webpackJsonp([2],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1107);


/***/ }),
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _jimpickSpectacleSrcSpectacle = __webpack_require__(978);
	
	var _jimpickSpectacleSrcUtilsPreloader = __webpack_require__(981);
	
	var _jimpickSpectacleSrcUtilsPreloader2 = _interopRequireDefault(_jimpickSpectacleSrcUtilsPreloader);
	
	// Customized
	
	var _deck = __webpack_require__(1180);
	
	var _deck2 = _interopRequireDefault(_deck);
	
	var _slide = __webpack_require__(1183);
	
	var _slide2 = _interopRequireDefault(_slide);
	
	// New additions
	
	var _fullscreen = __webpack_require__(1181);
	
	var _fullscreen2 = _interopRequireDefault(_fullscreen);
	
	var _section = __webpack_require__(1182);
	
	var _section2 = _interopRequireDefault(_section);
	
	var spectacle = {
	  Appear: _jimpickSpectacleSrcSpectacle.Appear,
	  BlockQuote: _jimpickSpectacleSrcSpectacle.BlockQuote,
	  Cite: _jimpickSpectacleSrcSpectacle.Cite,
	  Code: _jimpickSpectacleSrcSpectacle.Code,
	  Deck: _deck2['default'],
	  Fill: _jimpickSpectacleSrcSpectacle.Fill,
	  Fit: _jimpickSpectacleSrcSpectacle.Fit,
	  Heading: _jimpickSpectacleSrcSpectacle.Heading,
	  Image: _jimpickSpectacleSrcSpectacle.Image,
	  Layout: _jimpickSpectacleSrcSpectacle.Layout,
	  Link: _jimpickSpectacleSrcSpectacle.Link,
	  List: _jimpickSpectacleSrcSpectacle.List,
	  ListItem: _jimpickSpectacleSrcSpectacle.ListItem,
	  Quote: _jimpickSpectacleSrcSpectacle.Quote,
	  S: _jimpickSpectacleSrcSpectacle.S,
	  Slide: _slide2['default'],
	  Text: _jimpickSpectacleSrcSpectacle.Text,
	  Fullscreen: _fullscreen2['default'],
	  Section: _section2['default'],
	  preloader: _jimpickSpectacleSrcUtilsPreloader2['default']
	};
	
	exports['default'] = spectacle;
	module.exports = exports['default'];

/***/ }),
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _Object$getOwnPropertyDescriptor = __webpack_require__(1199)["default"];
	
	exports["default"] = function get(_x, _x2, _x3) {
	  var _again = true;
	
	  _function: while (_again) {
	    var object = _x,
	        property = _x2,
	        receiver = _x3;
	    _again = false;
	    if (object === null) object = Function.prototype;
	
	    var desc = _Object$getOwnPropertyDescriptor(object, property);
	
	    if (desc === undefined) {
	      var parent = Object.getPrototypeOf(object);
	
	      if (parent === null) {
	        return undefined;
	      } else {
	        _x = parent;
	        _x2 = property;
	        _x3 = receiver;
	        _again = true;
	        desc = parent = undefined;
	        continue _function;
	      }
	    } else if ("value" in desc) {
	      return desc.value;
	    } else {
	      var getter = desc.get;
	
	      if (getter === undefined) {
	        return undefined;
	      }
	
	      return getter.call(receiver);
	    }
	  }
	};
	
	exports.__esModule = true;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	/* eslint no-console: 0, no-cond-assign: 0 */
	
	'use strict';
	
	var _createClass = __webpack_require__(6)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _extends = __webpack_require__(7)['default'];
	
	var _objectWithoutProperties = __webpack_require__(16)['default'];
	
	var _getIterator = __webpack_require__(62)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _mdast = __webpack_require__(1482);
	
	var _mdast2 = _interopRequireDefault(_mdast);
	
	var _mdastHtml = __webpack_require__(1478);
	
	var _mdastHtml2 = _interopRequireDefault(_mdastHtml);
	
	var _lodash = __webpack_require__(65);
	
	var htmlProcessor = (0, _mdast2['default'])().use(_mdastHtml2['default']);
	
	var regionFilterRegex = /\{r\/([^\/:}]*)\/?([^\/:}]+)?\/?([^:}]+)?:?([^}]+)?}/g;
	
	var _default = (function () {
	  function _default(markdownData) {
	    _classCallCheck(this, _default);
	
	    this.doc = (0, _mdast2['default'])().parse(markdownData);
	    this.filteredDoc = null;
	    this.regionData = null;
	  }
	
	  _createClass(_default, [{
	    key: 'getSectionNames',
	    value: function getSectionNames() {
	      var names = [];
	      var children = this.doc.children;
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = _getIterator(children), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var child = _step.value;
	
	          if (child.type === 'heading' && child.depth === 1 && child.children && child.children.length > 0 && child.children[0] && typeof child.children[0].value === 'string') {
	            names.push(child.children[0].value);
	          }
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator['return']) {
	            _iterator['return']();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      return names;
	    }
	  }, {
	    key: 'getSectionAsHtml',
	    value: function getSectionAsHtml(sectionName, includeHeader, regionData) {
	      var section = this._getSection(sectionName, includeHeader, regionData);
	      return this._asHtml(section);
	    }
	  }, {
	    key: 'getSectionAsHtmlWithPrefixedUrls',
	    value: function getSectionAsHtmlWithPrefixedUrls(sectionName, includeHeader, prefix, regionData) {
	      var section = this._getSection(sectionName, includeHeader, regionData);
	      return this._asHtmlWithPrefixedUrls(section, prefix);
	    }
	  }, {
	    key: '_getSubSection',
	    value: function _getSubSection(sectionName, subSectionName, includeHeader, regionData) {
	      var _getSection2 = this._getSection(sectionName, false, regionData);
	
	      var type = _getSection2.type;
	      var children = _getSection2.children;
	      var position = _getSection2.position;
	
	      var regex = new RegExp('^' + subSectionName + '$', 'i');
	      var newNodes = {
	        type: type,
	        position: position,
	        children: []
	      };
	      var inSection = false;
	      var _iteratorNormalCompletion2 = true;
	      var _didIteratorError2 = false;
	      var _iteratorError2 = undefined;
	
	      try {
	        for (var _iterator2 = _getIterator(children), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	          var child = _step2.value;
	
	          if (child.type === 'heading' && child.depth === 2 && child.children && child.children.length > 0 && child.children[0] && typeof child.children[0].value === 'string') {
	            if (inSection) {
	              break;
	            } else if (child.children[0].value.match(regex)) {
	              inSection = true;
	              if (includeHeader) {
	                newNodes.children.push(child);
	              }
	              continue;
	            }
	          }
	          if (inSection) {
	            newNodes.children.push(child);
	          }
	        }
	      } catch (err) {
	        _didIteratorError2 = true;
	        _iteratorError2 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion2 && _iterator2['return']) {
	            _iterator2['return']();
	          }
	        } finally {
	          if (_didIteratorError2) {
	            throw _iteratorError2;
	          }
	        }
	      }
	
	      if (newNodes.children && newNodes.children.length === 0) {
	        console.log('No markdown section/subsection found for', sectionName, subSectionName);
	        throw new Error('No markdown section/subsection found for' + (' ' + sectionName + ' ' + subSectionName));
	      }
	
	      return newNodes;
	    }
	  }, {
	    key: 'getSectionAsString',
	    value: function getSectionAsString(sectionName, includeHeader, regionData) {
	      return _mdast2['default'].stringify(this._getSection(sectionName, includeHeader, regionData)).trim();
	    }
	  }, {
	    key: 'getSubSectionAsString',
	    value: function getSubSectionAsString(sectionName, subSectionName, includeHeader, regionData) {
	      var subSection = this._getSubSection(sectionName, subSectionName, includeHeader, regionData);
	      var result = _mdast2['default'].stringify(subSection).trim();
	      return result;
	    }
	  }, {
	    key: 'getSubSectionAsHtml',
	    value: function getSubSectionAsHtml(sectionName, subSectionName, includeHeader, regionData) {
	      var subSection = this.getSubSectionAsString(sectionName, subSectionName, includeHeader, regionData);
	      var result = htmlProcessor.process(subSection);
	      return result;
	    }
	  }, {
	    key: 'getAllAsHtml',
	    value: function getAllAsHtml(regionData) {
	      var doc = this._getFilteredDocForRegion(regionData);
	      return htmlProcessor.process(_mdast2['default'].stringify(doc));
	    }
	  }, {
	    key: 'getAllAsHtmlWithPrefixedUrls',
	    value: function getAllAsHtmlWithPrefixedUrls(prefix, regionData) {
	      var doc = this._getFilteredDocForRegion(regionData);
	      return this._asHtmlWithPrefixedUrls(doc, prefix);
	    }
	  }, {
	    key: 'getQuestions',
	    value: function getQuestions(sectionName, subSectionName, regionData) {
	      // FIXME: Not very forgiving parsing
	      var subSection = this._getSubSection(sectionName, subSectionName, false, regionData);
	      var questions = [];
	      var questionNodes = subSection.children[0].children;
	      questionNodes.forEach(function (node, index) {
	        var value = node.children[0].children[0].value;
	        var text = value,
	            exception = false,
	            cumulative = false;
	        switch (value[0]) {
	          case '*':
	            text = value.substr(1);
	            exception = true;
	            break;
	          case '+':
	            text = value.substr(1);
	            cumulative = true;
	            break;
	          default:
	            break;
	        }
	        questions.push({ number: index + 1, exception: exception, cumulative: cumulative, text: text });
	      });
	      return questions;
	    }
	  }, {
	    key: 'getSubSectionImage',
	    value: function getSubSectionImage(sectionName, subSectionName) {
	      var subSection = this._getSubSection(sectionName, subSectionName);
	      var imageUrl = undefined;
	      try {
	        var paragraph = subSection.children[0];
	        if (paragraph.type !== 'paragraph') {
	          throw new Error('Not a paragraph');
	        }
	        var image = paragraph.children[0];
	        if (image.type !== 'image') {
	          throw new Error('Not an image');
	        }
	        imageUrl = image.src;
	      } catch (err) {
	        console.error('Unexpected input', err);
	      }
	      if (!imageUrl) {
	        console.error('Image not found for ' + sectionName + ' ' + subSectionName);
	        throw new Error('Image not found for' + (' ' + sectionName + ' ' + subSectionName));
	      }
	      return imageUrl;
	    }
	  }, {
	    key: 'getSectionMetadata',
	    value: function getSectionMetadata(sectionName, key, regionData) {
	      var metadata = this._getSection(sectionName, false, regionData);
	      var keyValues = _mdast2['default'].stringify(metadata).split('\n');
	      var regex = new RegExp('^(' + key + ')\s*:\s*(.*)\s*$', 'i');
	      var _iteratorNormalCompletion3 = true;
	      var _didIteratorError3 = false;
	      var _iteratorError3 = undefined;
	
	      try {
	        for (var _iterator3 = _getIterator(keyValues), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	          var keyValue = _step3.value;
	
	          var match = keyValue.match(regex);
	          if (match && match.length > 1) {
	            return match[2].trim();
	          }
	        }
	      } catch (err) {
	        _didIteratorError3 = true;
	        _iteratorError3 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion3 && _iterator3['return']) {
	            _iterator3['return']();
	          }
	        } finally {
	          if (_didIteratorError3) {
	            throw _iteratorError3;
	          }
	        }
	      }
	    }
	  }, {
	    key: 'getMetadata',
	    value: function getMetadata(key) {
	      return this.getSectionMetadata('metadata', key);
	    }
	  }, {
	    key: '_getSection',
	    value: function _getSection(sectionName, includeHeader, regionData) {
	      var doc = this._getFilteredDocForRegion(regionData);
	      var type = doc.type;
	      var children = doc.children;
	      var position = doc.position;
	
	      var regex = new RegExp('^' + sectionName + '$', 'i');
	      var newNodes = {
	        type: type,
	        position: position,
	        children: []
	      };
	      var inSection = false;
	      var _iteratorNormalCompletion4 = true;
	      var _didIteratorError4 = false;
	      var _iteratorError4 = undefined;
	
	      try {
	        for (var _iterator4 = _getIterator(children), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
	          var child = _step4.value;
	
	          if (child.type === 'heading' && child.depth === 1 && child.children && child.children.length > 0 && child.children[0] && typeof child.children[0].value === 'string') {
	            if (inSection) {
	              break;
	            } else if (child.children[0].value.match(regex)) {
	              inSection = true;
	              if (includeHeader) {
	                newNodes.children.push(child);
	              }
	              continue;
	            }
	          }
	          if (inSection) {
	            newNodes.children.push(child);
	          }
	        }
	      } catch (err) {
	        _didIteratorError4 = true;
	        _iteratorError4 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion4 && _iterator4['return']) {
	            _iterator4['return']();
	          }
	        } finally {
	          if (_didIteratorError4) {
	            throw _iteratorError4;
	          }
	        }
	      }
	
	      if (newNodes.children && newNodes.children.length === 0) {
	        console.log('No markdown section found for', sectionName);
	        throw new Error('No markdown section found for ' + sectionName);
	      }
	
	      return newNodes;
	    }
	  }, {
	    key: '_asHtml',
	    value: function _asHtml(src) {
	      var srcAsString = _mdast2['default'].stringify(src);
	      return htmlProcessor.process(srcAsString);
	    }
	  }, {
	    key: '_asHtmlWithPrefixedUrls',
	    value: function _asHtmlWithPrefixedUrls(src, prefix) {
	      function prefixHref(doc, hrefPrefix) {
	        var node = _extends({}, doc);
	        if (node.href && node.href.indexOf('http') !== 0) {
	          node.href = hrefPrefix + node.href;
	        }
	        if (node.children) {
	          node.children = node.children.map(function (childDoc) {
	            return prefixHref(childDoc, hrefPrefix);
	          });
	        }
	        return node;
	      }
	      var newDoc = prefixHref(src, prefix);
	
	      var prefixedHtml = htmlProcessor.process(_mdast2['default'].stringify(newDoc));
	      var result = prefixedHtml.replace(new RegExp('<a href', 'g'), '<a target="_blank" href');
	      return result;
	    }
	  }, {
	    key: '_matchRegionFilters',
	    value: function _matchRegionFilters(text) {
	      var inlineFilters = [];
	      var filter = undefined;
	      var match = undefined;
	      while (match = regionFilterRegex.exec(text)) {
	        if (match.index === 0 && !match[4]) {
	          filter = match;
	          continue;
	        }
	        inlineFilters.push(match);
	      }
	      if (!filter && inlineFilters.length === 0) {
	        return null;
	      }
	      return {
	        inlineFilters: inlineFilters,
	        filter: filter
	      };
	    }
	  }, {
	    key: '_matchRegion',
	    value: function _matchRegion(filterMatch, regionData) {
	      var country = regionData.country;
	      var stateOrProvince = regionData.stateOrProvince;
	      var cityOrMunicipality = regionData.cityOrMunicipality;
	      var contractId = regionData.contractId;
	
	      if (filterMatch[1] && filterMatch[1] === contractId) return true;
	      if (filterMatch[1] && filterMatch[1] !== country) return false;
	      if (filterMatch[2] && filterMatch[2] !== stateOrProvince) return false;
	      if (filterMatch[3] && filterMatch[3] !== cityOrMunicipality) return false;
	      return true;
	    }
	  }, {
	    key: '_applyRegionFilters',
	    value: function _applyRegionFilters(textNode, regionData, nodeGroup) {
	      var _this = this;
	
	      var value = textNode.value;
	
	      var restOfTextNode = _objectWithoutProperties(textNode, ['value']);
	
	      var regionFilters = this._matchRegionFilters(value);
	      if (!regionFilters) {
	        return textNode;
	      }
	      var filteredText = value;
	      if (regionFilters.filter) {
	        if (nodeGroup && !nodeGroup.hasMatch && regionFilters.filter[1] === '') {
	          nodeGroup.hasMatch = false;
	          filteredText = filteredText.substr(regionFilters.filter.index + regionFilters.filter[0].length);
	        } else if (!nodeGroup && regionFilters.filter[1] === '') {
	          filteredText = filteredText.substr(regionFilters.filter.index + regionFilters.filter[0].length);
	        } else if (regionFilters.filter[1] !== '' && this._matchRegion(regionFilters.filter, regionData)) {
	          if (nodeGroup) nodeGroup.hasMatch = true;
	          filteredText = filteredText.substr(regionFilters.filter.index + regionFilters.filter[0].length);
	        } else {
	          return null;
	        }
	      }
	      var hasMatch = false;
	      filteredText = regionFilters.inlineFilters.reduce(function (text, filter) {
	        var replaceWith = '';
	        var hasEmptyFilter = filter[1] === '';
	        if (hasEmptyFilter && !hasMatch || !hasEmptyFilter && _this._matchRegion(filter, regionData)) {
	          hasMatch = !hasEmptyFilter;
	          replaceWith = filter[4];
	        }
	        if (replaceWith) {
	          replaceWith = replaceWith.replace('$cityOrMunicipality', regionData.cityOrMunicipality).replace('$stateOrProvince', regionData.stateOrProvince).replace('$country', regionData.country).replace('$contractId', regionData.contractId);
	        }
	        return text.replace(filter[0], replaceWith);
	      }, filteredText);
	      return _extends({
	        value: filteredText
	      }, restOfTextNode);
	    }
	  }, {
	    key: '_getFilteredNodeForRegion',
	    value: function _getFilteredNodeForRegion(node, regionData) {
	      if (!regionData) return node;
	      var children = node.children;
	
	      var restOfNode = _objectWithoutProperties(node, ['children']);
	
	      if (!children) return node;
	      var newNode = _extends({}, restOfNode, {
	        children: []
	      });
	      function appendIfNotEmpty(item) {
	        if (item.children && item.children.length > 0) {
	          newNode.children.push(item);
	        }
	      }
	      var headingGroup = { hasMatch: false };
	      var paragraphGroup = { hasMatch: false };
	      var listItemGroup = { hasMatch: false };
	      var _iteratorNormalCompletion5 = true;
	      var _didIteratorError5 = false;
	      var _iteratorError5 = undefined;
	
	      try {
	        for (var _iterator5 = _getIterator(children), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
	          var child = _step5.value;
	
	          switch (child.type) {
	            case 'text':
	              var filteredTextNode = this._applyRegionFilters(child, regionData);
	              if (filteredTextNode) {
	                newNode.children.push(filteredTextNode);
	              }
	              break;
	            case 'heading':
	              if (!child.children) {
	                newNode.children.push(child);
	                break;
	              }
	              if (child.children[0].type !== 'text') {
	                appendIfNotEmpty(this._getFilteredNodeForRegion(child, regionData));
	                break;
	              }
	              var headingTextNode = this._applyRegionFilters(child.children[0], regionData, headingGroup);
	              if (headingTextNode) {
	                appendIfNotEmpty(this._getFilteredNodeForRegion(child, regionData));
	              }
	              break;
	            case 'paragraph':
	              if (!child.children) {
	                newNode.children.push(child);
	                break;
	              }
	              if (child.children[0].type !== 'text') {
	                appendIfNotEmpty(this._getFilteredNodeForRegion(child, regionData));
	                break;
	              }
	              var paragraphTextNode = this._applyRegionFilters(child.children[0], regionData, paragraphGroup);
	              if (paragraphTextNode) {
	                appendIfNotEmpty(this._getFilteredNodeForRegion(child, regionData));
	              }
	              break;
	            case 'list':
	              appendIfNotEmpty(this._getFilteredNodeForRegion(child, regionData));
	              break;
	            case 'listItem':
	              if (!child.children) {
	                newNode.children.push(child);
	                break;
	              }
	              if (child.children[0].type !== 'paragraph') {
	                appendIfNotEmpty(this._getFilteredNodeForRegion(child, regionData));
	                break;
	              }
	              var listItemTextNode = this._applyRegionFilters(child.children[0].children[0], regionData, listItemGroup);
	              if (listItemTextNode) {
	                appendIfNotEmpty(this._getFilteredNodeForRegion(child, regionData));
	              }
	              break;
	            default:
	              appendIfNotEmpty(this._getFilteredNodeForRegion(child, regionData));
	          }
	        }
	      } catch (err) {
	        _didIteratorError5 = true;
	        _iteratorError5 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion5 && _iterator5['return']) {
	            _iterator5['return']();
	          }
	        } finally {
	          if (_didIteratorError5) {
	            throw _iteratorError5;
	          }
	        }
	      }
	
	      return newNode;
	    }
	  }, {
	    key: '_getFilteredDocForRegion',
	    value: function _getFilteredDocForRegion(regionData) {
	      if (!regionData) {
	        return this.doc;
	      }
	      if ((0, _lodash.isEqual)(regionData, this.regionData) && this.filteredDoc) {
	        return this.filteredDoc;
	      }
	      this.regionData = regionData;
	      this.filteredDoc = this._getFilteredNodeForRegion(this.doc, regionData);
	      return this.filteredDoc;
	    }
	  }]);

	  return _default;
	})();

	exports['default'] = _default;
	module.exports = exports['default'];

/***/ }),
/* 10 */,
/* 11 */,
/* 12 */
/***/ (function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function() {
		var list = [];
	
		// return the list of modules as css string
		list.toString = function toString() {
			var result = [];
			for(var i = 0; i < this.length; i++) {
				var item = this[i];
				if(item[2]) {
					result.push("@media " + item[2] + "{" + item[1] + "}");
				} else {
					result.push(item[1]);
				}
			}
			return result.join("");
		};
	
		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isOldIE = memoize(function() {
			return /msie [6-9]\b/.test(window.navigator.userAgent.toLowerCase());
		}),
		getHeadElement = memoize(function () {
			return document.head || document.getElementsByTagName("head")[0];
		}),
		singletonElement = null,
		singletonCounter = 0;
	
	module.exports = function(list, options) {
		if(false) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}
	
		options = options || {};
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isOldIE();
	
		var styles = listToStyles(list);
		addStylesToDom(styles, options);
	
		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	}
	
	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}
	
	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}
	
	function createStyleElement() {
		var styleElement = document.createElement("style");
		var head = getHeadElement();
		styleElement.type = "text/css";
		head.appendChild(styleElement);
		return styleElement;
	}
	
	function createLinkElement() {
		var linkElement = document.createElement("link");
		var head = getHeadElement();
		linkElement.rel = "stylesheet";
		head.appendChild(linkElement);
		return linkElement;
	}
	
	function addStyle(obj, options) {
		var styleElement, update, remove;
	
		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement());
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else if(obj.sourceMap &&
			typeof URL === "function" &&
			typeof URL.createObjectURL === "function" &&
			typeof URL.revokeObjectURL === "function" &&
			typeof Blob === "function" &&
			typeof btoa === "function") {
			styleElement = createLinkElement();
			update = updateLink.bind(null, styleElement);
			remove = function() {
				styleElement.parentNode.removeChild(styleElement);
				if(styleElement.href)
					URL.revokeObjectURL(styleElement.href);
			};
		} else {
			styleElement = createStyleElement();
			update = applyToTag.bind(null, styleElement);
			remove = function() {
				styleElement.parentNode.removeChild(styleElement);
			};
		}
	
		update(obj);
	
		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}
	
	var replaceText = (function () {
		var textStore = [];
	
		return function (index, replacement) {
			textStore[index] = replacement;
			return textStore.filter(Boolean).join('\n');
		};
	})();
	
	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}
	
	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;
		var sourceMap = obj.sourceMap;
	
		if(media) {
			styleElement.setAttribute("media", media)
		}
	
		if(styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}
	
	function updateLink(linkElement, obj) {
		var css = obj.css;
		var media = obj.media;
		var sourceMap = obj.sourceMap;
	
		if(sourceMap) {
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}
	
		var blob = new Blob([css], { type: "text/css" });
	
		var oldSrc = linkElement.href;
	
		linkElement.href = URL.createObjectURL(blob);
	
		if(oldSrc)
			URL.revokeObjectURL(oldSrc);
	}


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = __webpack_require__(7)['default'];
	
	var _Object$assign = __webpack_require__(487)['default'];
	
	var _getIterator = __webpack_require__(62)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.withDefaultLanguageIfNotPresent = withDefaultLanguageIfNotPresent;
	exports.i18nData = i18nData;
	exports.i18nProvider = i18nProvider;
	exports.i18nExtend = i18nExtend;
	exports.i18n = i18n;
	
	var _translationsFr_CAJson = __webpack_require__(1415);
	
	var _translationsFr_CAJson2 = _interopRequireDefault(_translationsFr_CAJson);
	
	var defaultLanguage = 'en';
	
	exports.defaultLanguage = defaultLanguage;
	var languages = {
	  'en': 'English',
	  'fr_CA': 'Français canadien'
	};
	
	exports.languages = languages;
	var g_translations = {
	  fr_CA: _translationsFr_CAJson2['default']
	};
	
	function withDefaultLanguageIfNotPresent(session) {
	  if (!session) return session;
	  return _extends({ language: 'en' }, session);
	}
	
	function i18nData(data) {
	  if (typeof data !== 'object') throw new TypeError('wrong data type');
	  data.$tag = 'i18n';
	  return data;
	}
	
	function i18nProvider(provider) {
	  if (typeof provider !== 'function') throw new TypeError('wrong provider type');
	  provider.$tag = 'i18n';
	  return provider;
	}
	
	function i18nExtend(lang, translations) {
	  _Object$assign(g_translations[lang], translations);
	}
	
	function i18n() {
	  var lang = arguments.length <= 0 || arguments[0] === undefined ? defaultLanguage : arguments[0];
	
	  if (typeof lang !== 'string') throw new TypeError('lang must be a string');
	
	  var data = g_translations[lang] || {};
	  var fn = function fn(arg1) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    switch (typeof arg1) {
	      case 'string':
	        {
	          return data[arg1] || arg1;
	        }
	      case 'function':
	        {
	          if ('i18n' !== arg1.$tag) return arg1;
	          return arg1(lang);
	        }
	      case 'object':
	        {
	          if (arg1.$tag === 'i18n') return arg1[lang] || arg1[defaultLanguage];
	          if (!Array.isArray(arg1)) return arg1;
	          if (arg1.length === 1) return data[arg1[0]] || arg1[0];
	          var key = arg1.join('${}');
	          var value = data[key];
	          if (value) {
	            return value.replace(/\$(\d)/g, function (match, index) {
	              return args[index] || '';
	            });
	          }
	          var a = [];
	          var i = 0;
	          var _iteratorNormalCompletion = true;
	          var _didIteratorError = false;
	          var _iteratorError = undefined;
	
	          try {
	            for (var _iterator = _getIterator(arg1), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	              var c = _step.value;
	
	              a.push(data[c] || c);
	              a.push(args[i++] || '');
	            }
	          } catch (err) {
	            _didIteratorError = true;
	            _iteratorError = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion && _iterator['return']) {
	                _iterator['return']();
	              }
	            } finally {
	              if (_didIteratorError) {
	                throw _iteratorError;
	              }
	            }
	          }
	
	          return a.join('');
	        }
	      default:
	        return arg1;
	    }
	  };
	  fn.lang = lang;
	  return fn;
	}

/***/ }),
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var Enhancer = __webpack_require__(935);
	
	module.exports = function (ComposedComponent /*: constructor*/) {
	  return Enhancer(ComposedComponent);
	};
	module.exports.Plugins = __webpack_require__(459);
	module.exports.PrintStyleSheet = __webpack_require__(934);
	module.exports.Style = __webpack_require__(455);
	module.exports.getState = __webpack_require__(458);
	module.exports.keyframes = __webpack_require__(936);

/***/ }),
/* 26 */,
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	/*eslint max-statements:0,complexity:0,no-invalid-this:0*/
	"use strict";
	
	var _get = __webpack_require__(8)["default"];
	
	var _inherits = __webpack_require__(5)["default"];
	
	var _createClass = __webpack_require__(6)["default"];
	
	var _classCallCheck = __webpack_require__(3)["default"];
	
	var _interopRequireDefault = __webpack_require__(2)["default"];
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var getStyles = function getStyles() {
	  var styles = {};
	  if (this.props.italic) {
	    styles.fontStyle = "italic";
	  }
	  if (this.props.bold) {
	    styles.fontWeight = "bold";
	  }
	  if (this.props.caps) {
	    styles.textTransform = "uppercase";
	  }
	  if (this.props.margin) {
	    styles.margin = this.props.margin;
	  }
	  if (this.props.padding) {
	    styles.padding = this.props.padding;
	  }
	  if (this.props.textColor) {
	    var color = "";
	    if (!this.context.styles.colors.hasOwnProperty(this.props.textColor)) {
	      color = this.props.textColor;
	    } else {
	      color = this.context.styles.colors[this.props.textColor];
	    }
	    styles.color = color;
	  }
	  if (this.props.textFont) {
	    var font = "";
	    if (!this.context.styles.fonts.hasOwnProperty(this.props.textFont)) {
	      font = this.props.textFont;
	    } else {
	      font = this.context.styles.fonts[this.props.textFont];
	    }
	    styles.fontFamily = font;
	  }
	  if (this.props.textSize) {
	    styles.fontSize = this.props.textSize;
	  }
	  if (this.props.textAlign) {
	    styles.textAlign = this.props.textAlign;
	  }
	  if (this.props.bgColor) {
	    var color = "";
	    if (!this.context.styles.colors.hasOwnProperty(this.props.bgColor)) {
	      color = this.props.bgColor;
	    } else {
	      color = this.context.styles.colors[this.props.bgColor];
	    }
	    styles.backgroundColor = color;
	  }
	  if (this.props.bgImage) {
	    if (this.props.bgDarken) {
	      styles.backgroundImage = "linear-gradient( rgba(0, 0, 0, " + this.props.bgDarken + "), rgba(0, 0, 0, " + this.props.bgDarken + ") ), url(" + this.props.bgImage + ")";
	    } else {
	      styles.backgroundImage = "url(" + this.props.bgImage + ")";
	    }
	    styles.backgroundSize = "cover";
	    styles.backgroundPosition = "center center";
	  }
	  return styles;
	};
	
	var Base = (function (_React$Component) {
	  _inherits(Base, _React$Component);
	
	  function Base(props) {
	    _classCallCheck(this, Base);
	
	    _get(Object.getPrototypeOf(Base.prototype), "constructor", this).call(this, props);
	    this.getStyles = getStyles;
	  }
	
	  _createClass(Base, [{
	    key: "render",
	    value: function render() {
	      return null;
	    }
	  }]);
	
	  return Base;
	})(_react2["default"].Component);
	
	Base.propTypes = {
	  textColor: _react2["default"].PropTypes.string,
	  textFont: _react2["default"].PropTypes.string,
	  bgColor: _react2["default"].PropTypes.string,
	  bgImage: _react2["default"].PropTypes.string,
	  bgDarken: _react2["default"].PropTypes.number
	};
	
	Base.defaultProps = {
	  bgDarken: 0
	};
	
	Base.Mixin = {
	  getStyles: getStyles
	};
	
	exports["default"] = Base;
	module.exports = exports["default"];

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _Object$freeze = __webpack_require__(308)["default"];
	
	var _Object$defineProperties = __webpack_require__(1198)["default"];
	
	exports["default"] = function (strings, raw) {
	  return _Object$freeze(_Object$defineProperties(strings, {
	    raw: {
	      value: _Object$freeze(raw)
	    }
	  }));
	};
	
	exports.__esModule = true;

/***/ }),
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1231), __esModule: true };

/***/ }),
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = __webpack_require__(7)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.setTempPassword = setTempPassword;
	exports.clearTempPassword = clearTempPassword;
	exports.loginSucceeded = loginSucceeded;
	exports.loginWithAuthData = loginWithAuthData;
	exports.login = login;
	exports.resetLoginForm = resetLoginForm;
	exports.logout = logout;
	exports.registerSucceeded = registerSucceeded;
	exports.register = register;
	exports.completeRegistration = completeRegistration;
	exports.resetRegisterEditProfileForm = resetRegisterEditProfileForm;
	exports.resetForgotPasswordForm = resetForgotPasswordForm;
	exports.sendPasswordReset = sendPasswordReset;
	exports.emailChanged = emailChanged;
	exports.changeEmail = changeEmail;
	exports.resetChangeEmailForm = resetChangeEmailForm;
	exports.passwordChanged = passwordChanged;
	exports.changePassword = changePassword;
	exports.resetChangePasswordForm = resetChangePasswordForm;
	
	var _reduxForm = __webpack_require__(36);
	
	var _routerHistory = __webpack_require__(229);
	
	var _routerHistory2 = _interopRequireDefault(_routerHistory);
	
	var _profileActions = __webpack_require__(103);
	
	var _servicesFirebaseRefJs = __webpack_require__(74);
	
	var _firebase = __webpack_require__(331);
	
	var _firebase2 = _interopRequireDefault(_firebase);
	
	var _servicesEvents = __webpack_require__(73);
	
	var SET_TEMP_PASSWORD = 'SET_TEMP_PASSWORD';
	exports.SET_TEMP_PASSWORD = SET_TEMP_PASSWORD;
	var CLEAR_TEMP_PASSWORD = 'CLEAR_TEMP_PASSWORD';
	
	exports.CLEAR_TEMP_PASSWORD = CLEAR_TEMP_PASSWORD;
	var LOGIN = 'LOGIN';
	exports.LOGIN = LOGIN;
	var LOGIN_ERROR = 'LOGIN_ERROR';
	
	exports.LOGIN_ERROR = LOGIN_ERROR;
	var LOGOUT = 'LOGOUT';
	
	exports.LOGOUT = LOGOUT;
	var REGISTER = 'REGISTER';
	exports.REGISTER = REGISTER;
	var REGISTER_ERROR = 'REGISTER_ERROR';
	
	exports.REGISTER_ERROR = REGISTER_ERROR;
	var PASSWORD_RESET_INIT = 'PASSWORD_RESET_INIT';
	exports.PASSWORD_RESET_INIT = PASSWORD_RESET_INIT;
	var PASSWORD_RESET_SENT = 'PASSWORD_RESET_SENT';
	exports.PASSWORD_RESET_SENT = PASSWORD_RESET_SENT;
	var PASSWORD_RESET_ERROR = 'PASSWORD_RESET_ERROR';
	
	exports.PASSWORD_RESET_ERROR = PASSWORD_RESET_ERROR;
	var CHANGE_EMAIL = 'CHANGE_EMAIL';
	exports.CHANGE_EMAIL = CHANGE_EMAIL;
	var CHANGE_EMAIL_ERROR = 'CHANGE_EMAIL_ERROR';
	
	exports.CHANGE_EMAIL_ERROR = CHANGE_EMAIL_ERROR;
	var CHANGE_PASSWORD = 'CHANGE_PASSWORD';
	exports.CHANGE_PASSWORD = CHANGE_PASSWORD;
	var CHANGE_PASSWORD_ERROR = 'CHANGE_PASSWORD_ERROR';
	
	exports.CHANGE_PASSWORD_ERROR = CHANGE_PASSWORD_ERROR;
	
	function setTempPassword(tempPassword) {
	  return {
	    type: SET_TEMP_PASSWORD,
	    tempPassword: tempPassword
	  };
	}
	
	function clearTempPassword() {
	  return {
	    type: CLEAR_TEMP_PASSWORD
	  };
	}
	
	function loginSucceeded(authData) {
	  return {
	    type: LOGIN,
	    authData: authData
	  };
	}
	
	function loginFailed(error) {
	  return {
	    type: LOGIN_ERROR,
	    error: error
	  };
	}
	
	var AUTHENTICATED = "Authenticated";
	
	function loginWithAuthData(_ref) {
	  var authData = _ref.authData;
	  var password = _ref.password;
	
	  var userId = authData.uid;
	  return function (dispatch) {
	    return dispatch((0, _profileActions.loadProfile)(userId)).then(function (profileData) {
	      dataLayer.push({
	        event: 'setUserId',
	        userId: userId
	      });
	      if (!profileData) {
	        var error = new Error('profile is missing');
	        error.code = 'profile/missing';
	        throw error;
	      }
	      var eventData = _extends({
	        userId: userId,
	        email: authData.email }, profileData);
	      (0, _servicesEvents.publishEvent)(AUTHENTICATED, eventData);
	      return dispatch(loginSucceeded(authData));
	    }).then(function () {
	      if (authData && authData.password && authData.password.isTemporaryPassword && password) {
	        return dispatch(setTempPassword(password));
	      }
	    }).then(function () {
	      return authData;
	    });
	  };
	}
	
	function login(data) {
	  var email = data.email;
	  var password = data.password;
	
	  return function (dispatch) {
	    return _servicesFirebaseRefJs.authRef.signInWithEmailAndPassword(email, password).then(function (authData) {
	      return dispatch(loginWithAuthData({ authData: authData, password: password }));
	    }).then(function (authData) {
	      var userId = authData.uid;
	
	      (0, _servicesEvents.publishEvent)('Signed In', { userId: userId });
	      return authData;
	    })['catch'](function (error) {
	      dispatch(loginFailed(error));
	      var errors = {};
	      if (error) {
	        switch (error.code) {
	          case 'auth/invalid-email':
	            errors.email = error.toString();
	            break;
	          case 'auth/user-disabled':
	            errors.email = 'Sorry, your account has been disabled. Please contact\n            our support team on <a href="javascript:Intercom(\'showNewMessage\')" target="_blank">support@planetprotectoracademy.com</a> and we\'ll do\n            our best to help you get back on track!';
	            break;
	          case 'auth/user-not-found':
	            errors.email = 'Sorry, we don\'t have that email address in our system.\n            Please double check and try again! If you\'re having trouble logging\n            in, please email us on <a href="javascript:Intercom(\'showNewMessage\')" target="_blank">support@planetprotectoracademy.com</a> and we\'d be\n            happy to help!';
	            break;
	          case 'auth/wrong-password':
	            errors.password = 'Oops, that doesn\'t seem to be the right password.\n            Please try again or <a href="/forgotPassword">\n            reset your password.</a>';
	            break;
	          case 'profile/missing':
	            errors.alert = 'This user registration is incomplete, please use the registration form with the same email/password to complete the registration for this user.';
	            break;
	          case 'profile/deleted':
	            errors.alert = 'Your account has been disabled. Please <a href="javascript:Intercom(\'showNewMessage\')" target="_blank">contact us</a> for further support.';
	            break;
	          default:
	            errors.alert = 'There seems to be a problem getting you logged in.\n            Please try again or contact our support team on\n            <a href="javascript:Intercom(\'showNewMessage\')" target="_blank">support@planetprotectoracademy.com</a> and we\'ll do our best to help you get\n            back on track!';
	        }
	      }
	      throw errors;
	    });
	  };
	}
	
	function resetLoginForm() {
	  var _ref2 = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	  var _ref2$email = _ref2.email;
	  var email = _ref2$email === undefined ? '' : _ref2$email;
	
	  return function (dispatch) {
	    dispatch((0, _reduxForm.initialize)('login', { email: email }));
	  };
	}
	
	function logout(_ref3) {
	  var userId = _ref3.userId;
	
	  (0, _servicesEvents.publishEvent)('Signed Out', { userId: userId });
	  _servicesFirebaseRefJs.authRef.signOut();
	  setCookie('featuredLanguage', '', -1);
	  setCookie('featuredPrograms', '', -1);
	  setCookie('contractId', '', -1);
	  setTimeout(function () {
	    return _routerHistory2['default'].replaceState(null, '/');
	  }, 0);
	  return {
	    type: LOGOUT
	  };
	}
	
	function registerSucceeded(userId) {
	  return {
	    type: REGISTER,
	    userId: userId
	  };
	}
	
	function registerFailed(error) {
	  return {
	    type: REGISTER_ERROR,
	    error: error
	  };
	}
	
	function register(data) {
	  var email = data.email;
	  var password = data.password;
	
	  var authData = undefined;
	  return function (dispatch) {
	    return _servicesFirebaseRefJs.authRef.createUserWithEmailAndPassword(email, password).then(function (userData) {
	      authData = userData;
	      return dispatch(registerSucceeded(userData.uid));
	    }, function (error) {
	      if (error.code !== 'auth/email-already-in-use') {
	        throw error;
	      }
	      return _servicesFirebaseRefJs.authRef.signInWithEmailAndPassword(email, password).then(function (userData) {
	        authData = userData;
	        return _servicesFirebaseRefJs.ref.child('users/' + userData.uid + '/profile').once('value');
	      }).then(function (profileRef) {
	        var profile = profileRef && profileRef.val();
	        if (profile) {
	          var _error = new Error('profile existing');
	          _error.code = 'profile/existing';
	          throw _error;
	        }
	      });
	    }).then(function () {
	      return dispatch((0, _profileActions.saveProfile)(authData.uid, data));
	    }).then(function () {
	      return dispatch(loginWithAuthData({ authData: authData }));
	    }).then(function () {
	      //const userId = authData.uid;
	      (0, _servicesEvents.publishEvent)("Registered", {
	        userId: userId,
	        firstName: data.firstName,
	        lastName: data.lastName,
	        email: data.email,
	        phone: data.phone,
	        marketingOptIn: data.marketingOptIn,
	        directPromotionOptIn: data.directPromotionOptIn,
	        termsAccepted: data.termsAccepted,
	        referrerUserId: data.referrerUserId
	      });
	      if (data.referrerUserId) {
	        (0, _servicesEvents.publishEvent)('User Referral Completed', {
	          userId: data.referrerUserId,
	          refereeUserId: userId
	        });
	      }
	      if (data.marketingOptIn) {
	        var payload = {
	          userId: userId,
	          email: data.email,
	          listId: "marketing",
	          consent: "explicit",
	          location: "registration"
	        };
	        (0, _servicesEvents.publishEvent)('Subscribed', payload);
	      }
	      if (data.directPromotionOptIn) {
	        var payload = {
	          userId: userId,
	          email: data.email,
	          listId: "directPromotion",
	          consent: "explicit",
	          location: "registration"
	        };
	        (0, _servicesEvents.publishEvent)('Subscribed', payload);
	      }
	      return userId;
	    })['catch'](function (error) {
	      dispatch(registerFailed(error));
	      var errors = {};
	      if (error) {
	        switch (error.code) {
	          case 'auth/invalid-email':
	            errors.email = error.toString();
	            break;
	          case 'auth/wrong-password':
	          case 'profile/existing':
	            errors.email = 'Oops, someone has already registered with that email\n          address. If it\'s yours and you\'re having trouble logging in, try\n          resetting your password!';
	            break;
	          case 'auth/weak-password':
	            errors.alert = 'Oops, it looks like your password is not strong enough.\n          Please try again with a more secure password, thanks!';
	            break;
	          default:
	            errors.alert = 'There seems to be a problem getting you registered on\n          our system. Please try again or contact our support team on\n          <a href="javascript:Intercom(\'showNewMessage\')" target="_blank">support@planetprotectoracademy.com</a> and we\'ll do our best to get you\n          started!';
	        }
	      }
	      throw errors;
	    });
	  };
	}
	
	function completeRegistration(userId, profile, data) {
	  return function (dispatch) {
	    var newProfile = _extends({}, profile, data);
	    return dispatch((0, _profileActions.updateProfile)(userId, newProfile)).then(function () {
	      (0, _servicesEvents.publishEvent)('Profile Completed', {
	        userId: userId,
	        cityOrMunicipality: data.cityOrMunicipality,
	        country: data.country,
	        stateOrProvince: data.stateOrProvince,
	        school: data.school
	      });
	    });
	  };
	}
	
	function resetRegisterEditProfileForm() {
	  var values = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	  return function (dispatch) {
	    dispatch((0, _reduxForm.initialize)('registerEditProfile', values));
	  };
	}
	
	function resetForgotPasswordForm() {
	  return function (dispatch) {
	    dispatch({ type: PASSWORD_RESET_INIT });
	    dispatch((0, _reduxForm.initialize)('forgotPassword', {}));
	  };
	}
	
	function sendPasswordReset(data) {
	  return function (dispatch) {
	    var email = data.email;
	    var url = data.url;
	
	    return _servicesFirebaseRefJs.authRef.sendPasswordResetEmail(email, { url: url }).then(function () {
	      dispatch({ type: PASSWORD_RESET_SENT });
	    })['catch'](function (error) {
	      var errors = {};
	      dispatch({
	        type: PASSWORD_RESET_ERROR,
	        error: error
	      });
	      if (error) {
	        switch (error.code) {
	          case 'auth/invalid-email':
	          case 'auth/user-not-found':
	            errors.email = error.toString();
	            break;
	          default:
	            errors.alert = 'Oops, we weren\'t able to send you the email to reset\n          your password. Please try again or contact our support team on\n          <a href="javascript:Intercom(\'showNewMessage\')" target="_blank">support@planetprotectoracademy.com</a> and we\'ll get you back on track!';
	        }
	      }
	      throw errors;
	    });
	  };
	}
	
	function emailChanged(_ref4) {
	  var oldEmail = _ref4.oldEmail;
	  var newEmail = _ref4.newEmail;
	
	  return {
	    type: CHANGE_EMAIL,
	    oldEmail: oldEmail,
	    newEmail: newEmail
	  };
	}
	
	function changeEmail(_ref5) {
	  var userId = _ref5.userId;
	  var oldEmail = _ref5.oldEmail;
	  var newEmail = _ref5.newEmail;
	  var password = _ref5.password;
	
	  return function (dispatch) {
	    var credential = _firebase2['default'].auth.EmailAuthProvider.credential(oldEmail, password);
	    return _servicesFirebaseRefJs.authRef.currentUser.reauthenticateWithCredential(credential).then(function () {
	      return _servicesFirebaseRefJs.authRef.currentUser.updateEmail(newEmail);
	    }).then(function () {
	      return dispatch((0, _profileActions.updateProfile)(userId, {
	        email: newEmail
	      }, false));
	    }).then(function () {
	      (0, _servicesEvents.publishEvent)('Email Changed', {
	        userId: userId, oldEmail: oldEmail, newEmail: newEmail
	      });
	      return dispatch(emailChanged({ oldEmail: oldEmail, newEmail: newEmail }));
	    })['catch'](function (error) {
	      var errors = {};
	      dispatch({
	        type: CHANGE_EMAIL_ERROR,
	        error: error
	      });
	      if (error) {
	        switch (error.code) {
	          case 'auth/invalid-email':
	            errors.email = error.toString();
	            break;
	          case 'auth/wrong-password':
	            errors.password = error.toString();
	            break;
	          case 'auth/email-already-in-use':
	            errors.email = error.toString();
	            break;
	          default:
	            errors.alert = 'Oops, there was a problem changing your email.\n          Please try again later or contact our support team at\n          <a href="javascript:Intercom(\'showNewMessage\')" target="_blank">support@planetprotectoracademy.com</a> and we\'ll do our best to help you get\n          back on track!';
	        }
	      }
	      throw errors;
	    });
	  };
	}
	
	function resetChangeEmailForm() {
	  return function (dispatch) {
	    dispatch((0, _reduxForm.initialize)('changeEmail', {}));
	  };
	}
	
	function passwordChanged(_ref6) {
	  var email = _ref6.email;
	
	  return {
	    type: CHANGE_PASSWORD,
	    email: email
	  };
	}
	
	function changePassword(_ref7) {
	  var email = _ref7.email;
	  var oldPassword = _ref7.oldPassword;
	  var newPassword = _ref7.newPassword;
	
	  return function (dispatch) {
	    var credential = _firebase2['default'].auth.EmailAuthProvider.credential(email, oldPassword);
	    return _servicesFirebaseRefJs.authRef.currentUser.reauthenticate(credential).then(function () {
	      return _servicesFirebaseRefJs.authRef.currentUser.updatePassword(newPassword);
	    }).then(function () {
	      var userId = _servicesFirebaseRefJs.authRef.currentUser.uid;
	      (0, _servicesEvents.publishEvent)('Password Changed', { userId: userId });
	      return dispatch(passwordChanged({ email: email }));
	    }).then(function () {
	      return dispatch(clearTempPassword());
	    }).then(function () {
	      return dispatch(login({ email: email, password: newPassword }));
	    })['catch'](function (error) {
	      var errors = {};
	      dispatch({
	        type: CHANGE_PASSWORD_ERROR,
	        error: error
	      });
	      if (error) {
	        switch (error.code) {
	          case 'auth/user-mismatch':
	          case 'auth/user-not-found':
	            errors.alert = 'Oops, you are not authenticated properly.\n          Please logout, login and try again.';
	            break;
	          case 'auth/wrong-password':
	            errors.oldPassword = error.toString();
	            break;
	          case 'auth/weak-password':
	            errors.password = error.toString();
	            break;
	          default:
	            errors.alert = 'Oops, there was a problem changing your password.\n          Please try again later or contact our support team at\n          <a href="javascript:Intercom(\'showNewMessage\')" target="_blank">support@planetprotectoracademy.com</a> and we\'ll do our best to help you get\n          back on track!';
	        }
	      }
	      throw errors;
	    });
	  };
	}
	
	function resetChangePasswordForm(tempPassword) {
	  return function (dispatch) {
	    dispatch((0, _reduxForm.initialize)('changePassword', {
	      oldPassword: tempPassword
	    }));
	  };
	}
	
	// GTM note: required for Intercom

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = __webpack_require__(6)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var countries = ['Afghanistan', 'Albania', 'Algeria', 'American Samoa', 'Andorra', 'Angola', 'Anguilla', 'Antarctica', 'Antigua And Barbuda', 'Argentina', 'Armenia', 'Aruba', 'Australia', 'Austria', 'Azerbaijan', 'Bahamas', 'Bahrain', 'Bangladesh', 'Barbados', 'Belarus', 'Belgium', 'Belize', 'Benin', 'Bermuda', 'Bhutan', 'Bolivia', 'Bosnia And Herzegovina', 'Botswana', 'Bouvet Island', 'Brazil', 'British Indian Ocean Territory', 'Brunei Darussalam', 'Bulgaria', 'Burkina Faso', 'Burundi', 'Cambodia', 'Cameroon', 'Canada', 'Cape Verde', 'Cayman Islands', 'Central African Republic', 'Chad', 'Chile', 'China', 'Christmas Island', 'Cocos (keeling) Islands', 'Colombia', 'Comoros', 'Congo', 'Congo, The Democratic Republic Of The', 'Cook Islands', 'Costa Rica', 'Cote D\'ivoire', 'Croatia', 'Cuba', 'Cyprus', 'Czech Republic', 'Denmark', 'Djibouti', 'Dominica', 'Dominican Republic', 'East Timor', 'Ecuador', 'Egypt', 'El Salvador', 'Equatorial Guinea', 'Eritrea', 'Estonia', 'Ethiopia', 'Falkland Islands (malvinas)', 'Faroe Islands', 'Fiji', 'Finland', 'France', 'French Guiana', 'French Polynesia', 'French Southern Territories', 'Gabon', 'Gambia', 'Georgia', 'Germany', 'Ghana', 'Gibraltar', 'Greece', 'Greenland', 'Grenada', 'Guadeloupe', 'Guam', 'Guatemala', 'Guinea', 'Guinea-bissau', 'Guyana', 'Haiti', 'Heard Island And Mcdonald Islands', 'Holy See (vatican City State)', 'Honduras', 'Hong Kong', 'Hungary', 'Iceland', 'India', 'Indonesia', 'Iran, Islamic Republic Of', 'Iraq', 'Ireland', 'Israel', 'Italy', 'Jamaica', 'Japan', 'Jordan', 'Kazakstan', 'Kenya', 'Kiribati', 'Korea, Democratic People\'s Republic Of', 'Korea, Republic Of', 'Kosovo', 'Kuwait', 'Kyrgyzstan', 'Lao People\'s Democratic Republic', 'Latvia', 'Lebanon', 'Lesotho', 'Liberia', 'Libyan Arab Jamahiriya', 'Liechtenstein', 'Lithuania', 'Luxembourg', 'Macau', 'Macedonia, The Former Yugoslav Republic Of', 'Madagascar', 'Malawi', 'Malaysia', 'Maldives', 'Mali', 'Malta', 'Marshall Islands', 'Martinique', 'Mauritania', 'Mauritius', 'Mayotte', 'Mexico', 'Micronesia, Federated States Of', 'Moldova, Republic Of', 'Monaco', 'Mongolia', 'Montserrat', 'Montenegro', 'Morocco', 'Mozambique', 'Myanmar', 'Namibia', 'Nauru', 'Nepal', 'Netherlands', 'Netherlands Antilles', 'New Caledonia', 'New Zealand', 'Nicaragua', 'Niger', 'Nigeria', 'Niue', 'Norfolk Island', 'Northern Mariana Islands', 'Norway', 'Oman', 'Pakistan', 'Palau', 'Palestinian Territory, Occupied', 'Panama', 'Papua New Guinea', 'Paraguay', 'Peru', 'Philippines', 'Pitcairn', 'Poland', 'Portugal', 'Puerto Rico', 'Qatar', 'Reunion', 'Romania', 'Russian Federation', 'Rwanda', 'Saint Helena', 'Saint Kitts And Nevis', 'Saint Lucia', 'Saint Pierre And Miquelon', 'Saint Vincent And The Grenadines', 'Samoa', 'San Marino', 'Sao Tome And Principe', 'Saudi Arabia', 'Senegal', 'Serbia', 'Seychelles', 'Sierra Leone', 'Singapore', 'Slovakia', 'Slovenia', 'Solomon Islands', 'Somalia', 'South Africa', 'South Georgia And The South Sandwich Islands', 'Spain', 'Sri Lanka', 'Sudan', 'Suriname', 'Svalbard And Jan Mayen', 'Swaziland', 'Sweden', 'Switzerland', 'Syrian Arab Republic', 'Taiwan, Province Of China', 'Tajikistan', 'Tanzania, United Republic Of', 'Thailand', 'Togo', 'Tokelau', 'Tonga', 'Trinidad And Tobago', 'Tunisia', 'Turkey', 'Turkmenistan', 'Turks And Caicos Islands', 'Tuvalu', 'Uganda', 'Ukraine', 'United Arab Emirates', 'United Kingdom', 'United States', 'United States Minor Outlying Islands', 'Uruguay', 'Uzbekistan', 'Vanuatu', 'Venezuela', 'Viet Nam', 'Virgin Islands, British', 'Virgin Islands, U.s.', 'Wallis And Futuna', 'Western Sahara', 'Yemen', 'Zambia', 'Zimbabwe'];
	var canadianProvinces = [{ code: 'AB', name: 'Alberta' }, { code: 'BC', name: 'British Columbia' }, { code: 'MB', name: 'Manitoba' }, { code: 'NB', name: 'New Brunswick' }, { code: 'NL', name: 'Newfoundland and Labrador' }, { code: 'NS', name: 'Nova Scotia' }, { code: 'NT', name: 'Northwest Territories' }, { code: 'NU', name: 'Nunavut' }, { code: 'ON', name: 'Ontario' }, { code: 'PE', name: 'Prince Edward Island' }, { code: 'QC', name: 'Quebec' }, { code: 'SK', name: 'Saskatchewan' }, { code: 'YT', name: 'Yukon' }];
	var americanStates = [{ code: 'AL', name: 'Alabama' }, { code: 'AK', name: 'Alaska' }, { code: 'AZ', name: 'Arizona' }, { code: 'AR', name: 'Arkansas' }, { code: 'CA', name: 'California' }, { code: 'CO', name: 'Colorado' }, { code: 'CT', name: 'Connecticut' }, { code: 'DE', name: 'Delaware' }, { code: 'DC', name: 'District Of Columbia' }, { code: 'FL', name: 'Florida' }, { code: 'GA', name: 'Georgia' }, { code: 'HI', name: 'Hawaii' }, { code: 'ID', name: 'Idaho' }, { code: 'IL', name: 'Illinois' }, { code: 'IN', name: 'Indiana' }, { code: 'IA', name: 'Iowa' }, { code: 'KS', name: 'Kansas' }, { code: 'KY', name: 'Kentucky' }, { code: 'LA', name: 'Louisiana' }, { code: 'ME', name: 'Maine' }, { code: 'MD', name: 'Maryland' }, { code: 'MA', name: 'Massachusetts' }, { code: 'MI', name: 'Michigan' }, { code: 'MN', name: 'Minnesota' }, { code: 'MS', name: 'Mississippi' }, { code: 'MO', name: 'Missouri' }, { code: 'MT', name: 'Montana' }, { code: 'NE', name: 'Nebraska' }, { code: 'NV', name: 'Nevada' }, { code: 'NH', name: 'New Hampshire' }, { code: 'NJ', name: 'New Jersey' }, { code: 'NM', name: 'New Mexico' }, { code: 'NY', name: 'New York' }, { code: 'NC', name: 'North Carolina' }, { code: 'ND', name: 'North Dakota' }, { code: 'OH', name: 'Ohio' }, { code: 'OK', name: 'Oklahoma' }, { code: 'OR', name: 'Oregon' }, { code: 'PA', name: 'Pennsylvania' }, { code: 'RI', name: 'Rhode Island' }, { code: 'SC', name: 'South Carolina' }, { code: 'SD', name: 'South Dakota' }, { code: 'TN', name: 'Tennessee' }, { code: 'TX', name: 'Texas' }, { code: 'UT', name: 'Utah' }, { code: 'VT', name: 'Vermont' }, { code: 'VA', name: 'Virginia' }, { code: 'WA', name: 'Washington' }, { code: 'WV', name: 'West Virginia' }, { code: 'WI', name: 'Wisconsin' }, { code: 'WY', name: 'Wyoming' }];
	var indianStates = [{ code: 'AN', name: 'Andaman and Nicobar Islands' }, { code: 'AP', name: 'Andhra Pradesh' }, { code: 'AR', name: 'Arunachal Pradesh' }, { code: 'AS', name: 'Assam' }, { code: 'BR', name: 'Bihar' }, { code: 'CH', name: 'Chandigarh' }, { code: 'CT', name: 'Chhattisgarhr' }, { code: 'DN', name: 'Dadra and Nagar Haveli' }, { code: 'DD', name: 'Daman and Diu' }, { code: 'DL', name: 'Dehli' }, { code: 'GA', name: 'Goa' }, { code: 'GJ', name: 'Gujarat' }, { code: 'HR', name: 'Haryana' }, { code: 'HP', name: 'Himachal Pradesh' }, { code: 'JK', name: 'Jammu and Kashmir' }, { code: 'JH', name: 'Jharkhand' }, { code: 'KA', name: 'Karnataka' }, { code: 'KL', name: 'Kerala' }, { code: 'LD', name: 'Lakshadweep' }, { code: 'MP', name: 'Madhya Pradesh' }, { code: 'MH', name: 'Maharashtra' }, { code: 'MN', name: 'Manipur' }, { code: 'ML', name: 'Meghalaya' }, { code: 'MZ', name: 'Mizoram' }, { code: 'NL', name: 'Nagaland' }, { code: 'OD', name: 'Odisha' }, { code: 'PY', name: 'Puducherry' }, { code: 'PB', name: 'Punjab' }, { code: 'RJ', name: 'Rajasthan' }, { code: 'SK', name: 'Sikkim' }, { code: 'TN', name: 'Tamil Nadu' }, { code: 'TS', name: 'Telangana' }, { code: 'TR', name: 'Tripura' }, { code: 'UP', name: 'Uttar Pradesh' }, { code: 'UK', name: 'Uttarakhand' }, { code: 'WB', name: 'West Bengal' }];
	var mexicanStates = [{ code: 'AGU', name: 'Aguascalientes' }, { code: 'BCN', name: 'Baja California' }, { code: 'BCS', name: 'Baja California Sur' }, { code: 'CAM', name: 'Campeche' }, { code: 'CHP', name: 'Chiapas' }, { code: 'CHH', name: 'Chihuahua' }, { code: 'COA', name: 'Coahuila' }, { code: 'COL', name: 'Colima' }, { code: 'CMX', name: 'Ciudad de Mexico' }, { code: 'DUR', name: 'Durango' }, { code: 'GUA', name: 'Guanajuato' }, { code: 'GRO', name: 'Guerrero' }, { code: 'HID', name: 'Hidalgo' }, { code: 'JAL', name: 'Jalisco' }, { code: 'MEX', name: 'Mexico' }, { code: 'MIC', name: 'Michoacan' }, { code: 'MOR', name: 'Morelos' }, { code: 'NAY', name: 'Nayarit' }, { code: 'NLE', name: 'Nuevo Leon' }, { code: 'OAX', name: 'Oaxaca' }, { code: 'PUE', name: 'Puebla' }, { code: 'QUE', name: 'Queretaro' }, { code: 'ROO', name: 'Quintana Roo' }, { code: 'SLP', name: 'San Luis Potosi' }, { code: 'SIN', name: 'Sinaloa' }, { code: 'SON', name: 'Sonora' }, { code: 'TAB', name: 'Tabasco' }, { code: 'TAM', name: 'Tamaulipas' }, { code: 'TLA', name: 'Tlaxcala' }, { code: 'VER', name: 'Veracruz' }, { code: 'YUC', name: 'Yucatan' }, { code: 'ZAC', name: 'Zacatecas' }];
	
	var Regionalization = (function () {
	  function Regionalization() {
	    _classCallCheck(this, Regionalization);
	  }
	
	  _createClass(Regionalization, null, [{
	    key: 'getCountries',
	    value: function getCountries() {
	      return countries;
	    }
	  }, {
	    key: 'getStatesOrProvinces',
	    value: function getStatesOrProvinces(country) {
	      if (country === 'Canada') {
	        return canadianProvinces;
	      }
	      if (country === 'India') {
	        return indianStates;
	      }
	      if (country === 'Mexico') {
	        return mexicanStates;
	      }
	      if (country === 'United States') {
	        return americanStates;
	      }
	      return [{
	        code: 'Other',
	        name: 'Other'
	      }];
	    }
	  }, {
	    key: 'isValidStateOrProvinces',
	    value: function isValidStateOrProvinces(country, stateOrProvince) {
	      if (country === 'Canada') {
	        return canadianProvinces.find(function (x) {
	          return x.code === stateOrProvince;
	        }) !== null;
	      }
	      if (country === 'India') {
	        return indianStates.find(function (x) {
	          return x.code === stateOrProvince;
	        }) !== null;
	      }
	      if (country === 'Mexico') {
	        return mexicanStates.find(function (x) {
	          return x.code === stateOrProvince;
	        }) !== null;
	      }
	      if (country === 'United States') {
	        return americanStates.find(function (x) {
	          return x.code === stateOrProvince;
	        }) !== null;
	      }
	      return stateOrProvince === 'Other';
	    }
	  }, {
	    key: 'hasStatesOrProvinces',
	    value: function hasStatesOrProvinces(country) {
	      return country === 'Canada' || country === 'India' || country === 'Mexico' || country === 'United States';
	    }
	  }, {
	    key: 'getRegionDataFromProfile',
	    value: function getRegionDataFromProfile(profile) {
	      var contractId = profile.contractId;
	      var country = profile.country;
	      var stateOrProvince = profile.stateOrProvince;
	      var cityOrMunicipality = profile.cityOrMunicipality;
	
	      return { contractId: contractId, country: country, stateOrProvince: stateOrProvince, cityOrMunicipality: cityOrMunicipality };
	    }
	  }, {
	    key: 'match',
	    value: function match(regionData, filter) {
	      if (regionData.contractId && regionData.contractId === filter) return true;
	      return (regionData.country + '/' + regionData.stateOrProvince + '/' + regionData.cityOrMunicipality).indexOf(filter) === 0;
	    }
	  }]);
	
	  return Regionalization;
	})();
	
	exports['default'] = Regionalization;
	module.exports = exports['default'];

/***/ }),
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */
/***/ (function(module, exports) {

	var core = module.exports = { version: '2.6.12' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _componentsYouTube = __webpack_require__(61);
	
	var _componentsYouTube2 = _interopRequireDefault(_componentsYouTube);
	
	function videoSlide(_ref) {
	  var id = _ref.id;
	  var notes = _ref.notes;
	  var heading = _ref.heading;
	  var youTubeId = _ref.youTubeId;
	  var lowRes = _ref.lowRes;
	  var bgColor = _ref.bgColor;
	  var slideClass = _ref.slideClass;
	
	  var slideContentClass = slideClass ? ' slide-' + slideClass : '';
	  var booleanLowRes = lowRes === 'true';
	  return _react2['default'].createElement(
	    _spectaclePpa.Slide,
	    {
	      id: id,
	      key: id,
	      bgColor: bgColor ? bgColor : 'black',
	      notes: notes },
	    _react2['default'].createElement(
	      'div',
	      { className: 'slide-content' + slideContentClass },
	      _react2['default'].createElement(
	        'div',
	        { className: 'video-slide' },
	        heading ? _react2['default'].createElement(
	          _spectaclePpa.Heading,
	          { size: 3, textColor: 'primary', textFont: 'primary' },
	          heading
	        ) : null,
	        _react2['default'].createElement(_componentsYouTube2['default'], {
	          youTubeId: youTubeId,
	          lowRes: booleanLowRes,
	          presentation: true })
	      )
	    )
	  );
	}
	
	exports['default'] = videoSlide;
	module.exports = exports['default'];

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _get = __webpack_require__(8)['default'];
	
	var _inherits = __webpack_require__(5)['default'];
	
	var _createClass = __webpack_require__(6)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _completeLevelModal = __webpack_require__(1174);
	
	var _completeLevelModal2 = _interopRequireDefault(_completeLevelModal);
	
	var _programs = __webpack_require__(69);
	
	var _programs2 = _interopRequireDefault(_programs);
	
	var CompleteLevelButton = (function (_Component) {
	  _inherits(CompleteLevelButton, _Component);
	
	  _createClass(CompleteLevelButton, null, [{
	    key: 'contextTypes',
	    value: {
	      sessionId: _react.PropTypes.string.isRequired,
	      session: _react.PropTypes.object.isRequired,
	      completeLevelAndExit: _react.PropTypes.func.isRequired,
	      completeLevelPreview: _react.PropTypes.func.isRequired,
	      i18n: _react.PropTypes.func.isRequired
	    },
	    enumerable: true
	  }]);
	
	  function CompleteLevelButton(props) {
	    _classCallCheck(this, CompleteLevelButton);
	
	    _get(Object.getPrototypeOf(CompleteLevelButton.prototype), 'constructor', this).call(this, props);
	    this.state = {
	      showModal: false
	    };
	  }
	
	  _createClass(CompleteLevelButton, [{
	    key: 'openModal',
	    value: function openModal() {
	      var _context$session = this.context.session;
	      var currentLevel = _context$session.currentLevel;
	      var completedLevel = _context$session.completedLevel;
	
	      if (Number(currentLevel) < completedLevel) {
	        this.exitNoComplete();
	        return;
	      }
	      this.setState({ showModal: true });
	    }
	  }, {
	    key: 'closeModal',
	    value: function closeModal() {
	      this.setState({ showModal: false });
	    }
	  }, {
	    key: 'complete',
	    value: function complete() {
	      var _context = this.context;
	      var completeLevelAndExit = _context.completeLevelAndExit;
	      var sessionId = _context.sessionId;
	      var _context$session2 = _context.session;
	      var programId = _context$session2.programId;
	      var currentLevel = _context$session2.currentLevel;
	      var contractId = _context$session2.contractId;
	      var funding = _context$session2.funding;
	      var completedLevel = _context$session2.completedLevel;
	
	      var program = _programs2['default'].programLookup[programId];
	      var levels = program.levels;
	
	      var finished = false;
	      var nextLevel = String(Number(currentLevel) + 1);
	      if (!levels[nextLevel]) {
	        finished = true;
	      }
	
	      completeLevelAndExit({
	        sessionId: sessionId,
	        completedLevel: currentLevel,
	        programId: programId,
	        finished: finished,
	        contractId: contractId,
	        funding: funding,
	        previousCompletedLevel: completedLevel
	      });
	    }
	  }, {
	    key: 'exitNoComplete',
	    value: function exitNoComplete() {
	      var _context2 = this.context;
	      var completeLevelPreview = _context2.completeLevelPreview;
	      var sessionId = _context2.sessionId;
	      var _context2$session = _context2.session;
	      var programId = _context2$session.programId;
	      var currentLevel = _context2$session.currentLevel;
	      var contractId = _context2$session.contractId;
	      var funding = _context2$session.funding;
	
	      completeLevelPreview({
	        sessionId: sessionId,
	        completedLevel: currentLevel,
	        programId: programId,
	        contractId: contractId,
	        funding: funding
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _context3 = this.context;
	      var session = _context3.session;
	      var _ = _context3.i18n;
	      var showModal = this.state.showModal;
	
	      return _react2['default'].createElement(
	        'div',
	        null,
	        _react2['default'].createElement(
	          'button',
	          {
	            className: 'btn btn-lg btn-primary clickToEndLevel',
	            onClick: this.openModal.bind(this) },
	          _('Click to Complete Level')
	        ),
	        _react2['default'].createElement(_completeLevelModal2['default'], {
	          session: session,
	          showModal: showModal,
	          closeModal: this.closeModal.bind(this),
	          complete: this.complete.bind(this),
	          exitNoComplete: this.exitNoComplete.bind(this) })
	      );
	    }
	  }]);
	
	  return CompleteLevelButton;
	})(_react.Component);
	
	exports['default'] = CompleteLevelButton;
	module.exports = exports['default'];

/***/ }),
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = function (data) {
	  return {
	    "200.html": data.defaultTemplate(),
	    "index.html": ["<!doctype html>", "<html>", "<head>", "<meta charset=\"utf-8\"/>", "<meta name=\"viewport\" content=\"width=device-width, initial-scale=1, user-scalable=no\"/>", "<link href=\"http://fonts.googleapis.com/css?family=Lobster+Two:400,700\" rel=\"stylesheet\" type=\"text/css\">", "<link href=\"http://fonts.googleapis.com/css?family=Open+Sans+Condensed:300,700\" rel=\"stylesheet\" type=\"text/css\">", "<link href=\"" + data.css + "\" rel=\"stylesheet\" type=\"text/css\" />", "</head>", "<body>", "<div id=\"root\"></div>", "<script src=\"" + data.main + "\"></script>", "</body>", "</html>"].join("")
	  };
	};

/***/ }),
/* 53 */
/***/ (function(module, exports) {

	/*eslint-disable object-shorthand*/
	"use strict";
	
	var colors = {
	  primary: "black",
	  secondary: "black",
	  tertiary: "black"
	};
	
	var fonts = {
	  primary: "Open Sans Condensed",
	  secondary: "Lobster Two",
	  tertiary: "monospace"
	};
	
	module.exports = {
	  colors: colors,
	  fonts: fonts,
	  global: {
	    body: {
	      background: "white",
	      fontFamily: fonts.primary,
	      fontWeight: "normal",
	      fontSize: "2em",
	      color: "black",
	      overflow: "hidden"
	    },
	    ".hljs": {
	      background: "white",
	      color: "black"
	    },
	    ".hljs span": {
	      color: "black !important"
	    }
	  },
	  components: {
	    blockquote: {
	      textAlign: "left",
	      position: "relative",
	      display: "inline-block"
	    },
	    quote: {
	      borderLeft: "1px solid " + colors.primary,
	      paddingLeft: 40,
	      display: "block",
	      color: "black",
	      fontSize: "4.9em",
	      lineHeight: 1,
	      fontWeight: "bold"
	    },
	    cite: {
	      color: "black",
	      display: "block",
	      clear: "left",
	      fontSize: "2em",
	      marginTop: "1em"
	    },
	    content: {
	      margin: "auto",
	      textAlign: "center"
	    },
	    codePane: {
	      pre: {
	        maxWidth: 800,
	        margin: "auto",
	        fontSize: "1em",
	        fontWeight: "normal",
	        fontFamily: fonts.tertiary
	      },
	      code: {
	        textAlign: "left",
	        padding: 20,
	        fontWeight: "normal"
	      }
	    },
	    code: {
	      color: "black",
	      fontSize: "2.66em",
	      fontFamily: fonts.tertiary,
	      margin: "0.25em auto",
	      backgroundColor: "rgba(0,0,0,0.15)",
	      padding: "0 10px",
	      borderRadius: 3
	    },
	    heading: {
	      h1: {
	        color: "black",
	        fontSize: "7.05em",
	        fontFamily: fonts.primary,
	        lineHeight: 1,
	        fontWeight: "bold",
	        margin: 0
	      },
	      h2: {
	        color: "black",
	        fontSize: "5.88em",
	        fontFamily: fonts.primary,
	        lineHeight: 1,
	        fontWeight: "bold",
	        margin: 0
	      },
	      h3: {
	        color: "black",
	        fontSize: "4.9em",
	        fontFamily: fonts.secondary,
	        lineHeight: 1,
	        fontWeight: "bold",
	        margin: "0.5em auto"
	      },
	      h4: {
	        color: "black",
	        fontSize: "3.82em",
	        fontFamily: fonts.primary,
	        lineHeight: 1,
	        fontWeight: "bold",
	        margin: "0.5em auto"
	      },
	      h5: {
	        color: "black",
	        fontSize: "3.19em",
	        fontFamily: fonts.primary,
	        lineHeight: 1,
	        fontWeight: "bold",
	        margin: "0.5em auto"
	      },
	      h6: {
	        color: "black",
	        fontSize: "2.66em",
	        fontFamily: fonts.primary,
	        lineHeight: 1,
	        fontWeight: "bold",
	        margin: "0.5em auto"
	      }
	    },
	    image: {
	      display: "block",
	      margin: "0.5em auto"
	    },
	    link: {
	      textDecoration: "none"
	    },
	    listItem: {
	      fontSize: "2.66em"
	    },
	    list: {
	      textAlign: "left",
	      listStylePosition: "inside",
	      padding: 0
	    },
	    s: {
	      strikethrough: {}
	    },
	    text: {
	      color: "black",
	      fontSize: "2.66em",
	      fontFamily: fonts.primary,
	      margin: "0.25em auto"
	    }
	  }
	};

/***/ }),
/* 54 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = {
	  'firebase': 'ppa-development',
	  'firebaseKey': 'AIzaSyC-E5nzag5XeQbxzmAgKNLt9eFVed34Dx4',
	  'intercom': 'zdty3foh',
	  'intercomToken': 'dG9rOjg0YWE1NTgzXzA2ZDhfNGNlNV85NDM4X2EyZWQzMGNkMGRkNzoxOjA=',
	  'stripe': 'pk_test_mnubjLTPoYtw0RQHGwU0i3oy',
	  'apiUrl': 'https://api.planetprotectoracademy.com:8080/'
	};

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _componentsYouTube = __webpack_require__(61);
	
	var _componentsYouTube2 = _interopRequireDefault(_componentsYouTube);
	
	function videoSlide(_ref) {
	  var id = _ref.id;
	  var notes = _ref.notes;
	  var heading = _ref.heading;
	  var youTubeId = _ref.youTubeId;
	  var lowRes = _ref.lowRes;
	  var bgColor = _ref.bgColor;
	  var slideClass = _ref.slideClass;
	
	  var slideContentClass = slideClass ? ' slide-' + slideClass : '';
	  var booleanLowRes = lowRes === 'true';
	  return _react2['default'].createElement(
	    _spectaclePpa.Slide,
	    {
	      id: id,
	      key: id,
	      bgColor: bgColor ? bgColor : 'black',
	      notes: notes },
	    _react2['default'].createElement(
	      'div',
	      { className: 'slide-content' + slideContentClass },
	      _react2['default'].createElement(
	        'div',
	        { className: 'video-slide' },
	        heading ? _react2['default'].createElement(
	          _spectaclePpa.Heading,
	          { size: 3, textColor: 'primary', textFont: 'primary' },
	          heading
	        ) : null,
	        _react2['default'].createElement(_componentsYouTube2['default'], {
	          youTubeId: youTubeId,
	          lowRes: booleanLowRes,
	          presentation: true })
	      )
	    )
	  );
	}
	
	exports['default'] = videoSlide;
	module.exports = exports['default'];

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _componentsYouTube = __webpack_require__(61);
	
	var _componentsYouTube2 = _interopRequireDefault(_componentsYouTube);
	
	function videoSlide(_ref) {
	  var id = _ref.id;
	  var notes = _ref.notes;
	  var heading = _ref.heading;
	  var youTubeId = _ref.youTubeId;
	  var lowRes = _ref.lowRes;
	  var bgColor = _ref.bgColor;
	  var slideClass = _ref.slideClass;
	
	  var slideContentClass = slideClass ? ' slide-' + slideClass : '';
	  var booleanLowRes = lowRes === 'true';
	  return _react2['default'].createElement(
	    _spectaclePpa.Slide,
	    {
	      id: id,
	      key: id,
	      bgColor: bgColor ? bgColor : 'black',
	      notes: notes },
	    _react2['default'].createElement(
	      'div',
	      { className: 'slide-content' + slideContentClass },
	      _react2['default'].createElement(
	        'div',
	        { className: 'video-slide' },
	        heading ? _react2['default'].createElement(
	          _spectaclePpa.Heading,
	          { size: 3, textColor: 'primary', textFont: 'primary' },
	          heading
	        ) : null,
	        _react2['default'].createElement(_componentsYouTube2['default'], {
	          youTubeId: youTubeId,
	          lowRes: booleanLowRes,
	          presentation: true })
	      )
	    )
	  );
	}
	
	exports['default'] = videoSlide;
	module.exports = exports['default'];

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _componentsYouTube = __webpack_require__(61);
	
	var _componentsYouTube2 = _interopRequireDefault(_componentsYouTube);
	
	function videoSlide(_ref) {
	  var id = _ref.id;
	  var notes = _ref.notes;
	  var heading = _ref.heading;
	  var youTubeId = _ref.youTubeId;
	  var lowRes = _ref.lowRes;
	  var bgColor = _ref.bgColor;
	  var slideClass = _ref.slideClass;
	
	  var slideContentClass = slideClass ? ' slide-' + slideClass : '';
	  var booleanLowRes = lowRes === 'true';
	  return _react2['default'].createElement(
	    _spectaclePpa.Slide,
	    {
	      id: id,
	      key: id,
	      bgColor: bgColor ? bgColor : 'black',
	      notes: notes },
	    _react2['default'].createElement(
	      'div',
	      { className: 'slide-content' + slideContentClass },
	      _react2['default'].createElement(
	        'div',
	        { className: 'video-slide' },
	        heading ? _react2['default'].createElement(
	          _spectaclePpa.Heading,
	          { size: 3, textColor: 'primary', textFont: 'primary' },
	          heading
	        ) : null,
	        _react2['default'].createElement(_componentsYouTube2['default'], {
	          youTubeId: youTubeId,
	          lowRes: booleanLowRes,
	          presentation: true })
	      )
	    )
	  );
	}
	
	exports['default'] = videoSlide;
	module.exports = exports['default'];

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _componentsYouTube = __webpack_require__(61);
	
	var _componentsYouTube2 = _interopRequireDefault(_componentsYouTube);
	
	function videoSlide(_ref) {
	  var id = _ref.id;
	  var notes = _ref.notes;
	  var heading = _ref.heading;
	  var youTubeId = _ref.youTubeId;
	  var lowRes = _ref.lowRes;
	  var bgColor = _ref.bgColor;
	  var slideClass = _ref.slideClass;
	
	  var slideContentClass = slideClass ? ' slide-' + slideClass : '';
	  var booleanLowRes = lowRes === 'true';
	  return _react2['default'].createElement(
	    _spectaclePpa.Slide,
	    {
	      id: id,
	      key: id,
	      bgColor: bgColor ? bgColor : 'black',
	      notes: notes },
	    _react2['default'].createElement(
	      'div',
	      { className: 'slide-content' + slideContentClass },
	      _react2['default'].createElement(
	        'div',
	        { className: 'video-slide' },
	        heading ? _react2['default'].createElement(
	          _spectaclePpa.Heading,
	          { size: 3, textColor: 'primary', textFont: 'primary' },
	          heading
	        ) : null,
	        _react2['default'].createElement(_componentsYouTube2['default'], {
	          youTubeId: youTubeId,
	          lowRes: booleanLowRes,
	          presentation: true })
	      )
	    )
	  );
	}
	
	exports['default'] = videoSlide;
	module.exports = exports['default'];

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _componentsYouTube = __webpack_require__(61);
	
	var _componentsYouTube2 = _interopRequireDefault(_componentsYouTube);
	
	function videoSlide(_ref) {
	  var id = _ref.id;
	  var notes = _ref.notes;
	  var heading = _ref.heading;
	  var youTubeId = _ref.youTubeId;
	  var lowRes = _ref.lowRes;
	  var bgColor = _ref.bgColor;
	  var slideClass = _ref.slideClass;
	
	  var slideContentClass = slideClass ? ' slide-' + slideClass : '';
	  var booleanLowRes = lowRes === 'true';
	  return _react2['default'].createElement(
	    _spectaclePpa.Slide,
	    {
	      id: id,
	      key: id,
	      bgColor: bgColor ? bgColor : 'black',
	      notes: notes },
	    _react2['default'].createElement(
	      'div',
	      { className: 'slide-content' + slideContentClass },
	      _react2['default'].createElement(
	        'div',
	        { className: 'video-slide' },
	        heading ? _react2['default'].createElement(
	          _spectaclePpa.Heading,
	          { size: 3, textColor: 'primary', textFont: 'primary' },
	          heading
	        ) : null,
	        _react2['default'].createElement(_componentsYouTube2['default'], {
	          youTubeId: youTubeId,
	          lowRes: booleanLowRes,
	          presentation: true })
	      )
	    )
	  );
	}
	
	exports['default'] = videoSlide;
	module.exports = exports['default'];

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _get = __webpack_require__(8)['default'];
	
	var _inherits = __webpack_require__(5)['default'];
	
	var _createClass = __webpack_require__(6)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(65);
	
	__webpack_require__(2220);
	
	var TeamNames = (function (_Component) {
	  _inherits(TeamNames, _Component);
	
	  _createClass(TeamNames, null, [{
	    key: 'contextTypes',
	    value: {
	      session: _react.PropTypes.object.isRequired,
	      setTeamName: _react.PropTypes.func.isRequired,
	      hideHUD: _react.PropTypes.func.isRequired,
	      presenter: _react.PropTypes.bool,
	      i18n: _react.PropTypes.func.isRequired
	    },
	    enumerable: true
	  }]);
	
	  function TeamNames(props) {
	    var _this = this;
	
	    _classCallCheck(this, TeamNames);
	
	    _get(Object.getPrototypeOf(TeamNames.prototype), 'constructor', this).call(this, props);
	    this.throttledSetTeamName = {};
	    [1, 2, 3, 4].forEach(function (teamNumber) {
	      _this.throttledSetTeamName[teamNumber] = (0, _lodash.throttle)(_this.setTeamName.bind(_this, teamNumber), 3000);
	    });
	    this.state = {
	      optimisticUpdates: {
	        '1': null,
	        '2': null,
	        '3': null,
	        '4': null
	      }
	    };
	  }
	
	  _createClass(TeamNames, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.refs.team1.focus();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps, nextContext) {
	      var _this2 = this;
	
	      var session = this.context.session;
	      var teamNames = session.teamNames;
	      var nextSession = nextContext.session;
	      var nextTeamNames = nextSession.teamNames;
	      var optimisticUpdates = this.state.optimisticUpdates;
	
	      [1, 2, 3, 4].forEach(function (teamNumber) {
	        if (teamNames && nextTeamNames[teamNumber] !== teamNames[teamNumber]) {
	          optimisticUpdates[teamNumber] = null;
	          _this2.setState({ optimisticUpdates: optimisticUpdates });
	        }
	      });
	    }
	  }, {
	    key: 'setTeamName',
	    value: function setTeamName(teamNumber, value) {
	      var _context = this.context;
	      var setTeamName = _context.setTeamName;
	      var hideHUD = _context.hideHUD;
	
	      setTeamName(teamNumber, value);
	      hideHUD();
	    }
	  }, {
	    key: 'clickHandler',
	    value: function clickHandler(evt) {
	      if (evt) {
	        evt.preventDefault();
	        evt.stopPropagation();
	        evt.nativeEvent.stopPropagation();
	      }
	    }
	  }, {
	    key: 'changeHandler',
	    value: function changeHandler(evt) {
	      var match = evt.target.name.match(/team(\d+)$/);
	      if (match && match[1]) {
	        var teamNumber = Number(match[1]);
	        var optimisticUpdates = this.state.optimisticUpdates;
	
	        optimisticUpdates[teamNumber] = evt.target.value;
	        this.setState({ optimisticUpdates: optimisticUpdates });
	        this.throttledSetTeamName[teamNumber](evt.target.value);
	      }
	      if (evt) {
	        evt.preventDefault();
	        evt.stopPropagation();
	        evt.nativeEvent.stopPropagation();
	      }
	    }
	  }, {
	    key: 'keyDown',
	    value: function keyDown(evt) {
	      var presenter = this.context.presenter;
	
	      if (evt) {
	        if (presenter) {
	          // Stop arrow key navigation on teacher remote
	          if (evt.keyCode === 37 || evt.keyCode === 39) {
	            // left, right
	            evt.stopPropagation();
	            evt.nativeEvent.stopPropagation();
	          }
	        } else {
	          // Don't use arrows for input fields in presentation mode
	          if (evt.keyCode === 37 || evt.keyCode === 39) {
	            // left, right
	            evt.preventDefault();
	          }
	        }
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _context2 = this.context;
	      var session = _context2.session;
	      var _ = _context2.i18n;
	      var teamNames = session.teamNames;
	      var optimisticUpdates = this.state.optimisticUpdates;
	
	      var optimisticTeamNames = {};
	      [1, 2, 3, 4].forEach(function (teamNumber) {
	        var teamName = null;
	        if (optimisticUpdates[teamNumber] !== null) {
	          teamName = optimisticUpdates[teamNumber];
	        } else {
	          teamName = teamNames && teamNames[teamNumber];
	        }
	        optimisticTeamNames[teamNumber] = teamName;
	      });
	
	      return _react2['default'].createElement(
	        'div',
	        { className: 'team-names' },
	        _react2['default'].createElement(
	          'div',
	          { className: 'form-group team-1' },
	          _react2['default'].createElement(
	            'label',
	            { className: 'control-label' },
	            _('Earth'),
	            _react2['default'].createElement('i', { className: 'ppa-icon ppa-icon-team-1' })
	          ),
	          _react2['default'].createElement('input', {
	            className: 'form-control',
	            placeholder: _('(Pick an Earth-related team name)'),
	            name: 'team1',
	            ref: 'team1',
	            value: optimisticTeamNames[1],
	            onClick: this.clickHandler.bind(this),
	            onChange: this.changeHandler.bind(this),
	            onKeyDown: this.keyDown.bind(this) })
	        ),
	        _react2['default'].createElement(
	          'div',
	          { className: 'form-group team-2' },
	          _react2['default'].createElement(
	            'label',
	            { className: 'control-label' },
	            _('Fire'),
	            _react2['default'].createElement('i', { className: 'ppa-icon ppa-icon-team-2' })
	          ),
	          _react2['default'].createElement('input', {
	            className: 'form-control',
	            placeholder: _('(Pick a Fire-related team name)'),
	            name: 'team2',
	            value: optimisticTeamNames[2],
	            onClick: this.clickHandler.bind(this),
	            onChange: this.changeHandler.bind(this),
	            onKeyDown: this.keyDown.bind(this) })
	        ),
	        _react2['default'].createElement(
	          'div',
	          { className: 'form-group team-3' },
	          _react2['default'].createElement(
	            'label',
	            { className: 'control-label' },
	            _('Water'),
	            _react2['default'].createElement('i', { className: 'ppa-icon ppa-icon-team-3' })
	          ),
	          _react2['default'].createElement('input', {
	            className: 'form-control',
	            placeholder: _('(Pick a Water-related team name)'),
	            name: 'team3',
	            value: optimisticTeamNames[3],
	            onClick: this.clickHandler.bind(this),
	            onChange: this.changeHandler.bind(this),
	            onKeyDown: this.keyDown.bind(this) })
	        ),
	        _react2['default'].createElement(
	          'div',
	          { className: 'form-group team-4' },
	          _react2['default'].createElement(
	            'label',
	            { className: 'control-label' },
	            _('Air'),
	            _react2['default'].createElement('i', { className: 'ppa-icon ppa-icon-team-4' })
	          ),
	          _react2['default'].createElement('input', {
	            className: 'form-control',
	            placeholder: _('(Pick an Air-related team name)'),
	            name: 'team4',
	            value: optimisticTeamNames[4],
	            onClick: this.clickHandler.bind(this),
	            onChange: this.changeHandler.bind(this),
	            onKeyDown: this.keyDown.bind(this) })
	        )
	      );
	    }
	  }]);
	
	  return TeamNames;
	})(_react.Component);
	
	exports['default'] = TeamNames;
	module.exports = exports['default'];

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _get = __webpack_require__(8)['default'];
	
	var _inherits = __webpack_require__(5)['default'];
	
	var _createClass = __webpack_require__(6)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _Object$keys = __webpack_require__(32)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(20);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _radium = __webpack_require__(144);
	
	var _radium2 = _interopRequireDefault(_radium);
	
	var _reactAddonsShallowCompare = __webpack_require__(1873);
	
	var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
	var _lodash = __webpack_require__(65);
	
	var _ismobilejs = __webpack_require__(241);
	
	var _ismobilejs2 = _interopRequireDefault(_ismobilejs);
	
	var _reactYoutubePlayer = __webpack_require__(2025);
	
	var _reactYoutubePlayer2 = _interopRequireDefault(_reactYoutubePlayer);
	
	var _videoRemoteControlButton = __webpack_require__(307);
	
	var _videoRemoteControlButton2 = _interopRequireDefault(_videoRemoteControlButton);
	
	var phone = _ismobilejs2['default'].phone;
	var tablet = _ismobilejs2['default'].tablet;
	
	var mobile = phone || tablet;
	
	var styles = {
	  videoContainer: {
	    overflow: 'hidden',
	    flex: '1 1 100%',
	    display: 'flex',
	    justifyContent: 'center',
	    alignItems: 'center',
	    height: '100%'
	  }
	};
	
	var YouTube = (function (_Component) {
	  _inherits(YouTube, _Component);
	
	  _createClass(YouTube, null, [{
	    key: 'propTypes',
	    value: {
	      youTubeId: _react.PropTypes.string.isRequired,
	      lowRes: _react.PropTypes.bool,
	      presentation: _react.PropTypes.bool
	    },
	    enumerable: true
	  }, {
	    key: 'contextTypes',
	    value: {
	      presenter: _react.PropTypes.bool.isRequired,
	      setVideoState: _react.PropTypes.func.isRequired,
	      session: _react.PropTypes.object.isRequired,
	      hideHUD: _react.PropTypes.func.isRequired,
	      deckState: _react.PropTypes.object.isRequired,
	      i18n: _react.PropTypes.func.isRequired
	    },
	    enumerable: true
	  }]);
	
	  function YouTube(props) {
	    _classCallCheck(this, _YouTube);
	
	    _get(Object.getPrototypeOf(_YouTube.prototype), 'constructor', this).call(this, props);
	    this.boundHandleKeyPress = this._handleKeyPress.bind(this);
	    this.boundSetVideoSize = this.setVideoSize.bind(this);
	    this.state = {
	      videoWidth: null,
	      videoHeight: null,
	      startingUp: true,
	      videoState: {}
	    };
	  }
	
	  _createClass(YouTube, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this = this;
	
	      var _context = this.context;
	      var session = _context.session;
	      var presenter = _context.presenter;
	
	      if (session && !presenter && (!session.videoState || _Object$keys(session.videoState).length === 0)) {
	        this.setVideoState({
	          playing: false,
	          started: false,
	          finished: false
	        });
	      }
	      setTimeout(function () {
	        _this.setVideoSize();
	      }, 0);
	      setTimeout(function () {
	        _this.setState({ startingUp: false });
	      }, 500);
	      this._attachEvents();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps, nextContext) {
	      if (this.context.session && this.context.session.videoState && nextContext.session && nextContext.session.videoState && nextContext.session.videoState.playing !== this.context.session.videoState.playing) {
	        this.context.hideHUD();
	      }
	      var session = nextContext.session;
	
	      this.setState({
	        videoState: session && session.videoState ? session.videoState : {}
	      });
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      var shouldUpdate = (0, _reactAddonsShallowCompare2['default'])(this, nextProps, nextState);
	      if (!shouldUpdate) {
	        shouldUpdate = !(0, _lodash.isEqual)(nextState, this.state);
	      }
	      return shouldUpdate;
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      var videoState = this.state.videoState;
	      var youtubePlayer = this.refs.youtubePlayer;
	
	      if (videoState.seek && youtubePlayer) {
	        youtubePlayer.player.getCurrentTime().then(function (currentTime) {
	          var newTime = currentTime + videoState.seek;
	          youtubePlayer.player.seekTo(newTime, true);
	        });
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this._detachEvents();
	    }
	  }, {
	    key: 'onPause',
	    value: function onPause() {
	      var session = this.context.session;
	
	      var videoState = session && session.videoState ? session.videoState : {};
	
	      if (videoState.playing) {
	        this.setVideoState({
	          playing: false,
	          started: videoState.started,
	          finished: videoState.finished
	        });
	      }
	    }
	  }, {
	    key: 'onPlay',
	    value: function onPlay() {
	      var session = this.context.session;
	
	      var videoState = session && session.videoState ? session.videoState : {};
	
	      if (!videoState.playing) {
	        this.setVideoState({
	          playing: true,
	          started: videoState.started,
	          finished: videoState.finished
	        });
	      }
	    }
	  }, {
	    key: 'setVideoSize',
	    value: function setVideoSize() {
	      var aspectRatio = 16.0 / 9.0;
	      var videoContainer = _reactDom2['default'].findDOMNode(this.refs.videoContainer);
	
	      if (!videoContainer) {
	        return;
	      }
	
	      if (mobile && this.resizeCount > 0) {
	        return;
	      }
	      this.setState({ videoWidth: 0, videoHeight: 0 });
	
	      var videoWidth = videoContainer.offsetWidth;
	      var videoHeight = videoContainer.offsetHeight;
	      if (videoHeight * aspectRatio < videoContainer.offsetWidth) {
	        videoWidth = videoHeight * aspectRatio;
	      }
	      if (videoWidth / aspectRatio < videoContainer.offsetHeight) {
	        videoHeight = videoWidth / aspectRatio;
	      }
	      this.setState({ videoWidth: videoWidth, videoHeight: videoHeight });
	      this.resizeCount = (this.resizeCount || 0) + 1;
	    }
	  }, {
	    key: 'setVideoState',
	    value: function setVideoState(videoState) {
	      this.context.setVideoState(videoState);
	    }
	  }, {
	    key: '_attachEvents',
	    value: function _attachEvents() {
	      if (!this.context.presenter) {
	        window.addEventListener('keydown', this.boundHandleKeyPress);
	      }
	      window.addEventListener('load', this.boundSetVideoSize);
	      window.addEventListener('resize', this.boundSetVideoSize);
	    }
	  }, {
	    key: '_detachEvents',
	    value: function _detachEvents() {
	      if (!this.context.presenter) {
	        window.removeEventListener('keydown', this.boundHandleKeyPress);
	      }
	      window.removeEventListener('load', this.boundSetVideoSize);
	      window.removeEventListener('resize', this.boundSetVideoSize);
	    }
	  }, {
	    key: '_handleKeyPress',
	    value: function _handleKeyPress(evt) {
	      var event = window.event ? window.event : evt;
	      // space
	      if (event.keyCode === 32) {
	        this.playPause.call(this, evt);
	      }
	    }
	  }, {
	    key: 'playPause',
	    value: function playPause(evt) {
	      var _this2 = this;
	
	      var _context2 = this.context;
	      var session = _context2.session;
	      var _ = _context2.i18n;
	
	      var videoState = session && session.videoState ? session.videoState : {};
	
	      evt.preventDefault();
	      evt.stopPropagation();
	      if (evt.nativeEvent) {
	        evt.nativeEvent.stopPropagation();
	      }
	
	      if (videoState.finished) {
	        this.setVideoState({
	          playing: false,
	          started: false,
	          finished: false
	        });
	        this.buttonLabel = _('Replay');
	        setTimeout(function () {
	          _this2.setVideoState({
	            playing: true,
	            started: true,
	            finished: false
	          });
	          setTimeout(function () {
	            _this2.buttonLabel = null;
	          }, 500);
	        }, 1000);
	        return;
	      }
	      this.setVideoState({
	        playing: !videoState.playing,
	        started: true,
	        finished: false
	      });
	    }
	  }, {
	    key: 'videoEnd',
	    value: function videoEnd() {
	      this.setVideoState({
	        playing: false,
	        finished: true
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var youTubeId = _props.youTubeId;
	      var lowRes = _props.lowRes;
	      var presentation = _props.presentation;
	      var _context3 = this.context;
	      var presenter = _context3.presenter;
	      var session = _context3.session;
	      var deviceRole = _context3.deckState.deviceRole;
	      var _ = _context3.i18n;
	      var configuration = session.configuration;
	      var mode = session.mode;
	
	      var videoState = session && session.videoState ? session.videoState : {};
	      var thumbnailUrl = lowRes ? '//img.youtube.com/vi/' + youTubeId + '/hqdefault.jpg' : '//i.ytimg.com/vi/' + youTubeId + '/maxresdefault.jpg';
	
	      if (presentation && mode) {
	        // Don't show video when in a mode in the HUD
	        return _react2['default'].createElement('div', null);
	      }
	
	      if (presenter) {
	        return _react2['default'].createElement('img', { src: thumbnailUrl });
	      }
	
	      var isDualScreen = configuration === 'dualScreen';
	      if (isDualScreen && deviceRole === 'remoteControl') {
	        return _react2['default'].createElement(
	          'div',
	          {
	            style: {
	              display: 'flex',
	              width: '100%',
	              justifyContent: 'center'
	            } },
	          _react2['default'].createElement(_videoRemoteControlButton2['default'], null)
	        );
	      }
	
	      var playbackState = 'unstarted';
	      if (!this.state.startingUp) {
	        if (videoState.playing) {
	          playbackState = 'playing';
	        }
	        if (!videoState.playing && videoState.started) {
	          playbackState = 'paused';
	        }
	      }
	
	      var buttonLabel = videoState.finished ? _('Replay') : _('Play');
	      if (this.buttonLabel) {
	        // We need to override the button label for when Replay
	        // is clicked
	        buttonLabel = this.buttonLabel;
	      }
	
	      var youTubePlayer = _react2['default'].createElement('div', null);
	      if (this.state.videoWidth && this.state.videoHeight) {
	        youTubePlayer = _react2['default'].createElement(
	          'div',
	          {
	            className: 'youtube-sized-container',
	            style: {
	              width: this.state.videoWidth + 'px',
	              height: this.state.videoHeight + 'px',
	              position: 'relative'
	            } },
	          _react2['default'].createElement('div', {
	            className: 'youtube-iframe-wrapper',
	            style: {
	              position: 'absolute',
	              opacity: videoState.started && !videoState.finished ? 0 : 1,
	              transition: 'opacity 1s ease-in',
	              width: this.state.videoWidth + 'px',
	              height: this.state.videoHeight + 'px',
	              background: 'url(' + thumbnailUrl + ') no-repeat center/cover',
	              display: mobile || videoState.playing ? 'none' : 'block'
	            } }),
	          _react2['default'].createElement(
	            'div',
	            {
	              className: 'youtube-glass-overlay',
	              style: {
	                width: this.state.videoWidth + 'px',
	                height: this.state.videoHeight + 'px',
	                position: 'absolute',
	                display: mobile || videoState.playing ? 'none' : 'flex',
	                justifyContent: 'center',
	                alignItems: 'center'
	              },
	              onClick: this.playPause.bind(this) },
	            _react2['default'].createElement(
	              'div',
	              { className: 'youtube-button' },
	              _react2['default'].createElement(
	                'button',
	                {
	                  className: 'btn btn-lg ppa-icon-play',
	                  style: {
	                    opacity: videoState.playing ? 0 : 1,
	                    cursor: videoState.playing ? 'none' : 'pointer',
	                    transition: 'opacity 0.3s ease-in'
	                  } },
	                _react2['default'].createElement(
	                  'span',
	                  { className: 'text-hide' },
	                  buttonLabel
	                )
	              )
	            )
	          ),
	          !videoState.finished || mobile ? _react2['default'].createElement(_reactYoutubePlayer2['default'], {
	            width: this.state.videoWidth + 'px',
	            height: this.state.videoHeight + 'px',
	            videoId: youTubeId,
	            playbackState: playbackState,
	            onPlay: this.onPlay.bind(this),
	            onPause: this.onPause.bind(this),
	            onEnd: this.videoEnd.bind(this),
	            ref: 'youtubePlayer',
	            configuration: {
	              showinfo: 0,
	              controls: 1,
	              rel: 0,
	              disablekb: 1,
	              modestbranding: 1,
	              iv_load_policy: 3
	            } }) : _react2['default'].createElement('div', {
	            className: 'youtube-placeholder',
	            style: {
	              width: this.state.videoWidth + 'px',
	              height: this.state.videoHeight + 'px'
	            } })
	        );
	      }
	
	      return _react2['default'].createElement(
	        'div',
	        {
	          className: 'youtube-fullscreen-container',
	          style: {
	            display: 'flex',
	            flexDirection: 'column',
	            width: '100%',
	            height: '100vh'
	          } },
	        _react2['default'].createElement(
	          'div',
	          {
	            className: 'youtube-video-container',
	            style: styles.videoContainer,
	            ref: 'videoContainer' },
	          this.state.videoWidth && this.state.videoHeight ? youTubePlayer : ''
	        )
	      );
	    }
	  }]);
	
	  var _YouTube = YouTube;
	  YouTube = (0, _radium2['default'])(YouTube) || YouTube;
	  return YouTube;
	})(_react.Component);
	
	exports['default'] = YouTube;
	module.exports = exports['default'];
	/*
	<div style={{marginBottom: '20px'}}>State: {playbackState}</div>
	*/

/***/ }),
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = __webpack_require__(7)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	function balloonSlide(_ref) {
	  var id = _ref.id;
	  var balloonType = _ref.balloonType;
	  var questionNumber = _ref.questionNumber;
	  var numQuestions = _ref.numQuestions;
	  var notes = _ref.notes;
	  var heading = _ref.heading;
	  var characterImage = _ref.characterImage;
	  var characterSide = _ref.characterSide;
	  var bgColor = _ref.bgColor;
	  var html = _ref.html;
	  var slideClass = _ref.slideClass;
	
	  var charPos = characterSide !== '' ? characterSide : '';
	  var slideContentClass = slideClass ? ' slide-' + slideClass : '';
	  var balloonClass = !balloonType && !bgColor ? ' balloon-regular' : '';
	  var bgColorOpts = {};
	  if (bgColor) {
	    bgColorOpts.bgColor = bgColor;
	  } else {
	    if (balloonType) {
	      bgColorOpts.bgColor = balloonType === 'question' ? '#45B3EC' : '#6FC36E'; // set to 45B3EC for questions, 6FC36E for other non-empty values
	    } else {
	        bgColorOpts.bgColor = 'transparent';
	      }
	  }
	  return _react2['default'].createElement(
	    _spectaclePpa.Slide,
	    _extends({
	      id: id,
	      key: id
	    }, bgColorOpts, {
	      notes: notes }),
	    _react2['default'].createElement(
	      'div',
	      { className: 'slide-content' + slideContentClass },
	      _react2['default'].createElement(
	        'div',
	        {
	          className: 'text-balloon ' + charPos + ' text-formatted' + balloonClass },
	        balloonType === 'question' ? _react2['default'].createElement(
	          _spectaclePpa.Heading,
	          { size: 2 },
	          'Question ',
	          questionNumber,
	          ' of ',
	          numQuestions,
	          ':'
	        ) : null,
	        !!heading && _react2['default'].createElement(
	          _spectaclePpa.Heading,
	          { size: 3 },
	          heading
	        ),
	        _react2['default'].createElement('div', {
	          className: 'text-balloon-body',
	          dangerouslySetInnerHTML: { __html: html } })
	      ),
	      characterImage ? _react2['default'].createElement(
	        'div',
	        {
	          className: 'text-balloon-character ' + charPos },
	        _react2['default'].createElement('img', { src: characterImage })
	      ) : null
	    )
	  );
	}
	
	exports['default'] = balloonSlide;
	module.exports = exports['default'];

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = __webpack_require__(7)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	function balloonSlide(_ref) {
	  var id = _ref.id;
	  var balloonType = _ref.balloonType;
	  var questionNumber = _ref.questionNumber;
	  var numQuestions = _ref.numQuestions;
	  var notes = _ref.notes;
	  var heading = _ref.heading;
	  var characterImage = _ref.characterImage;
	  var characterSide = _ref.characterSide;
	  var bgColor = _ref.bgColor;
	  var html = _ref.html;
	  var slideClass = _ref.slideClass;
	
	  var charPos = characterSide !== '' ? characterSide : '';
	  var slideContentClass = slideClass ? ' slide-' + slideClass : '';
	  var balloonClass = !balloonType && !bgColor ? ' balloon-regular' : '';
	  var bgColorOpts = {};
	  if (bgColor) {
	    bgColorOpts.bgColor = bgColor;
	  } else {
	    if (balloonType) {
	      bgColorOpts.bgColor = balloonType === 'question' ? '#45B3EC' : '#6FC36E'; // set to 45B3EC for questions, 6FC36E for other non-empty values
	    } else {
	        bgColorOpts.bgColor = 'transparent';
	      }
	  }
	  return _react2['default'].createElement(
	    _spectaclePpa.Slide,
	    _extends({
	      id: id,
	      key: id
	    }, bgColorOpts, {
	      notes: notes }),
	    _react2['default'].createElement(
	      'div',
	      { className: 'slide-content' + slideContentClass },
	      _react2['default'].createElement(
	        'div',
	        {
	          className: 'text-balloon ' + charPos + ' text-formatted' + balloonClass },
	        balloonType === 'question' ? _react2['default'].createElement(
	          _spectaclePpa.Heading,
	          { size: 2 },
	          'Question ',
	          questionNumber,
	          ' of ',
	          numQuestions,
	          ':'
	        ) : null,
	        !!heading && _react2['default'].createElement(
	          _spectaclePpa.Heading,
	          { size: 3 },
	          heading
	        ),
	        _react2['default'].createElement('div', {
	          className: 'text-balloon-body',
	          dangerouslySetInnerHTML: { __html: html } })
	      ),
	      characterImage ? _react2['default'].createElement(
	        'div',
	        {
	          className: 'text-balloon-character ' + charPos },
	        _react2['default'].createElement('img', { src: characterImage })
	      ) : null
	    )
	  );
	}
	
	exports['default'] = balloonSlide;
	module.exports = exports['default'];

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = __webpack_require__(7)['default'];
	
	var _defineProperty = __webpack_require__(105)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _zeroHeroes = __webpack_require__(1091);
	
	var _zeroHeroes2 = _interopRequireDefault(_zeroHeroes);
	
	var _keepCool = __webpack_require__(1076);
	
	var _keepCool2 = _interopRequireDefault(_keepCool);
	
	var _epsPrimaries = __webpack_require__(1039);
	
	var _epsPrimaries2 = _interopRequireDefault(_epsPrimaries);
	
	var _epsIntermediates = __webpack_require__(1026);
	
	var _epsIntermediates2 = _interopRequireDefault(_epsIntermediates);
	
	var _epsHybridAssembly = __webpack_require__(985);
	
	var _epsHybridAssembly2 = _interopRequireDefault(_epsHybridAssembly);
	
	var _epsHybridPrimaries = __webpack_require__(1014);
	
	var _epsHybridPrimaries2 = _interopRequireDefault(_epsHybridPrimaries);
	
	var _epsHybridIntermediates = __webpack_require__(1002);
	
	var _epsHybridIntermediates2 = _interopRequireDefault(_epsHybridIntermediates);
	
	var _h2whoa = __webpack_require__(1052);
	
	var _h2whoa2 = _interopRequireDefault(_h2whoa);
	
	var _h2whoaHybrid = __webpack_require__(1065);
	
	var _h2whoaHybrid2 = _interopRequireDefault(_h2whoaHybrid);
	
	var programList = [_zeroHeroes2['default'], _keepCool2['default'], _h2whoa2['default'], _epsPrimaries2['default'], _epsIntermediates2['default'], _epsHybridAssembly2['default'], _epsHybridPrimaries2['default'], _epsHybridIntermediates2['default'], _h2whoaHybrid2['default']];
	
	// Generate a lookup table by program id
	var programLookup = programList.reduce(function (previous, program) {
	  return _extends(_defineProperty({}, program.id, program), previous);
	}, {});
	
	var programs = {
	  programList: programList,
	  programLookup: programLookup
	};
	
	exports['default'] = programs;
	module.exports = exports['default'];

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = __webpack_require__(7)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	function balloonSlide(_ref) {
	  var id = _ref.id;
	  var balloonType = _ref.balloonType;
	  var questionNumber = _ref.questionNumber;
	  var numQuestions = _ref.numQuestions;
	  var notes = _ref.notes;
	  var heading = _ref.heading;
	  var characterImage = _ref.characterImage;
	  var characterSide = _ref.characterSide;
	  var bgColor = _ref.bgColor;
	  var html = _ref.html;
	  var slideClass = _ref.slideClass;
	
	  var charPos = characterSide !== '' ? characterSide : '';
	  var slideContentClass = slideClass ? ' slide-' + slideClass : '';
	  var balloonClass = !balloonType && !bgColor ? ' balloon-regular' : '';
	  var bgColorOpts = {};
	  if (bgColor) {
	    bgColorOpts.bgColor = bgColor;
	  } else {
	    if (balloonType) {
	      bgColorOpts.bgColor = balloonType === 'question' ? '#45B3EC' : '#6FC36E'; // set to 45B3EC for questions, 6FC36E for other non-empty values
	    } else {
	        bgColorOpts.bgColor = 'transparent';
	      }
	  }
	  return _react2['default'].createElement(
	    _spectaclePpa.Slide,
	    _extends({
	      id: id,
	      key: id
	    }, bgColorOpts, {
	      notes: notes }),
	    _react2['default'].createElement(
	      'div',
	      { className: 'slide-content' + slideContentClass },
	      _react2['default'].createElement(
	        'div',
	        {
	          className: 'text-balloon ' + charPos + ' text-formatted' + balloonClass },
	        balloonType === 'question' ? _react2['default'].createElement(
	          _spectaclePpa.Heading,
	          { size: 2 },
	          'Question ',
	          questionNumber,
	          ' of ',
	          numQuestions,
	          ':'
	        ) : null,
	        !!heading && _react2['default'].createElement(
	          _spectaclePpa.Heading,
	          { size: 3 },
	          heading
	        ),
	        _react2['default'].createElement('div', {
	          className: 'text-balloon-body',
	          dangerouslySetInnerHTML: { __html: html } })
	      ),
	      characterImage ? _react2['default'].createElement(
	        'div',
	        {
	          className: 'text-balloon-character ' + charPos },
	        _react2['default'].createElement('img', { src: characterImage })
	      ) : null
	    )
	  );
	}
	
	exports['default'] = balloonSlide;
	module.exports = exports['default'];

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = __webpack_require__(7)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	function balloonSlide(_ref) {
	  var id = _ref.id;
	  var balloonType = _ref.balloonType;
	  var questionNumber = _ref.questionNumber;
	  var numQuestions = _ref.numQuestions;
	  var notes = _ref.notes;
	  var heading = _ref.heading;
	  var characterImage = _ref.characterImage;
	  var characterSide = _ref.characterSide;
	  var bgColor = _ref.bgColor;
	  var html = _ref.html;
	  var slideClass = _ref.slideClass;
	
	  var charPos = characterSide !== '' ? characterSide : '';
	  var slideContentClass = slideClass ? ' slide-' + slideClass : '';
	  var balloonClass = !balloonType && !bgColor ? ' balloon-regular' : '';
	  var bgColorOpts = {};
	  if (bgColor) {
	    bgColorOpts.bgColor = bgColor;
	  } else {
	    if (balloonType) {
	      bgColorOpts.bgColor = balloonType === 'question' ? '#45B3EC' : '#6FC36E'; // set to 45B3EC for questions, 6FC36E for other non-empty values
	    } else {
	        bgColorOpts.bgColor = 'transparent';
	      }
	  }
	  return _react2['default'].createElement(
	    _spectaclePpa.Slide,
	    _extends({
	      id: id,
	      key: id
	    }, bgColorOpts, {
	      notes: notes }),
	    _react2['default'].createElement(
	      'div',
	      { className: 'slide-content' + slideContentClass },
	      _react2['default'].createElement(
	        'div',
	        {
	          className: 'text-balloon ' + charPos + ' text-formatted' + balloonClass },
	        balloonType === 'question' ? _react2['default'].createElement(
	          _spectaclePpa.Heading,
	          { size: 2 },
	          'Question ',
	          questionNumber,
	          ' of ',
	          numQuestions,
	          ':'
	        ) : null,
	        !!heading && _react2['default'].createElement(
	          _spectaclePpa.Heading,
	          { size: 3 },
	          heading
	        ),
	        _react2['default'].createElement('div', {
	          className: 'text-balloon-body',
	          dangerouslySetInnerHTML: { __html: html } })
	      ),
	      characterImage ? _react2['default'].createElement(
	        'div',
	        {
	          className: 'text-balloon-character ' + charPos },
	        _react2['default'].createElement('img', { src: characterImage })
	      ) : null
	    )
	  );
	}
	
	exports['default'] = balloonSlide;
	module.exports = exports['default'];

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = __webpack_require__(7)['default'];
	
	var _defineProperty = __webpack_require__(105)['default'];
	
	var _objectWithoutProperties = __webpack_require__(16)['default'];
	
	var _Promise = __webpack_require__(33)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.createSession = createSession;
	exports.updateSession = updateSession;
	exports.buySession = buySession;
	exports.bindSessions = bindSessions;
	exports.bindSingleSession = bindSingleSession;
	exports.unbind = unbind;
	exports.setLastSlide = setLastSlide;
	exports.setCurrentSlide = setCurrentSlide;
	exports.setVideoState = setVideoState;
	exports.setTeamName = setTeamName;
	exports.setScore = setScore;
	exports.setMissionReportAnswer = setMissionReportAnswer;
	exports.setMode = setMode;
	exports.setCurrentLevel = setCurrentLevel;
	exports.completeLevel = completeLevel;
	exports.advanceLevel = advanceLevel;
	exports.completeLevelAndAdvance = completeLevelAndAdvance;
	exports.resetAddEditClassForm = resetAddEditClassForm;
	exports.setConfiguration = setConfiguration;
	exports.archiveSession = archiveSession;
	exports.setHackedAnswer = setHackedAnswer;
	
	var _reduxForm = __webpack_require__(36);
	
	var _nodeUuid = __webpack_require__(347);
	
	var _nodeUuid2 = _interopRequireDefault(_nodeUuid);
	
	var _servicesFirebaseRef = __webpack_require__(74);
	
	var _servicesFirebaseRef2 = _interopRequireDefault(_servicesFirebaseRef);
	
	var _servicesPayment = __webpack_require__(302);
	
	var _servicesEvents = __webpack_require__(73);
	
	var _programsIndex = __webpack_require__(69);
	
	var _programsIndex2 = _interopRequireDefault(_programsIndex);
	
	var _helpersI18n = __webpack_require__(14);
	
	var SESSION_CREATE = 'SESSION_CREATE';
	exports.SESSION_CREATE = SESSION_CREATE;
	var SESSION_UPDATE = 'SESSION_UPDATE';
	exports.SESSION_UPDATE = SESSION_UPDATE;
	var SESSION_BUY = 'SESSION_BUY';
	exports.SESSION_BUY = SESSION_BUY;
	var SESSION_SET_CURRENT_SLIDE = 'SESSION_SET_CURRENT_SLIDE';
	exports.SESSION_SET_CURRENT_SLIDE = SESSION_SET_CURRENT_SLIDE;
	var SESSION_SET_LAST_SLIDE = 'SESSION_SET_LAST_SLIDE';
	exports.SESSION_SET_LAST_SLIDE = SESSION_SET_LAST_SLIDE;
	var SESSION_SET_VIDEO_STATE = 'SESSION_SET_VIDEO_STATE';
	exports.SESSION_SET_VIDEO_STATE = SESSION_SET_VIDEO_STATE;
	var SESSION_SET_TEAM_NAME = 'SESSION_SET_TEAM_NAME';
	exports.SESSION_SET_TEAM_NAME = SESSION_SET_TEAM_NAME;
	var SESSION_SET_SCORE = 'SESSION_SET_SCORE';
	exports.SESSION_SET_SCORE = SESSION_SET_SCORE;
	var SESSION_SET_MISSION_REPORT_ANSWER = 'SESSION_SET_MISSION_REPORT_ANSWER';
	exports.SESSION_SET_MISSION_REPORT_ANSWER = SESSION_SET_MISSION_REPORT_ANSWER;
	var SESSION_SET_HACKED_ANSWER = 'SESSION_SET_HACKED_ANSWER';
	exports.SESSION_SET_HACKED_ANSWER = SESSION_SET_HACKED_ANSWER;
	var SESSION_SET_MODE = 'SESSION_SET_MODE';
	exports.SESSION_SET_MODE = SESSION_SET_MODE;
	var SESSION_SET_CURRENT_LEVEL = 'SESSION_SET_CURRENT_LEVEL';
	exports.SESSION_SET_CURRENT_LEVEL = SESSION_SET_CURRENT_LEVEL;
	var SESSION_COMPLETE_LEVEL = 'SESSION_COMPLETE_LEVEL';
	exports.SESSION_COMPLETE_LEVEL = SESSION_COMPLETE_LEVEL;
	var SESSION_SET_CONFIGURATION = 'SESSION_SET_CONFIGURATION';
	exports.SESSION_SET_CONFIGURATION = SESSION_SET_CONFIGURATION;
	var SESSION_UNARCHIVE = 'SESSION_UNARCHIVE';
	exports.SESSION_UNARCHIVE = SESSION_UNARCHIVE;
	var SESSION_ARCHIVE = 'SESSION_ARCHIVE';
	exports.SESSION_ARCHIVE = SESSION_ARCHIVE;
	var NO_SESSIONS = 'NO_SESSIONS';
	
	exports.NO_SESSIONS = NO_SESSIONS;
	function getSessionById(sessionId) {
	  return _servicesFirebaseRef2['default'].child('sessions').child(sessionId).once('value').then(function (sessionRef) {
	    return (0, _helpersI18n.withDefaultLanguageIfNotPresent)(sessionRef.val());
	  });
	}
	
	function sessionCreate(sessionId, data) {
	  return {
	    type: SESSION_CREATE,
	    sessionId: sessionId,
	    data: (0, _helpersI18n.withDefaultLanguageIfNotPresent)(data)
	  };
	}
	
	function createSession(userId, programId, params) {
	  return function () {
	    var contractId = params.contractId;
	    var pendingApproval = params.pendingApproval;
	    var referrerUserId = params.referrerUserId;
	
	    var isApproved = !pendingApproval && contractId;
	    var validUntil = (0, _servicesPayment.getValidUntilTime)();
	    return new _Promise(function (resolve, reject) {
	      var id = _nodeUuid2['default'].v4();
	      var createdAt = _servicesFirebaseRef.TIMESTAMP;
	      var updatedAt = _servicesFirebaseRef.TIMESTAMP;
	      var language = params.language;
	      var grade = params.grade;
	      var divisionName = params.divisionName;
	      var numberOfStudents = params.numberOfStudents;
	      var auto = params.auto;
	
	      var configuration = 'dualScreen';
	      var data = {
	        userId: userId,
	        programId: programId,
	        createdAt: createdAt,
	        updatedAt: updatedAt,
	        language: language,
	        grade: grade,
	        divisionName: divisionName,
	        numberOfStudents: numberOfStudents,
	        configuration: configuration,
	        pendingApproval: pendingApproval,
	        auto: !!auto
	      };
	      if (isApproved) {
	        data.funding = 'CONTRACT';
	        data.staffUserId = 'auto';
	        data.contractId = contractId;
	        data.approvedAt = createdAt;
	        data.validUntil = validUntil;
	      }
	      if (referrerUserId) {
	        data.referrerUserId = referrerUserId;
	      }
	      _servicesFirebaseRef2['default'].child('sessions').child(id).set(data, function (error) {
	        if (error) {
	          reject(error);
	        } else {
	          resolve(id);
	        }
	      });
	    }).then(function (id) {
	      return new _Promise(function (resolve, reject) {
	        _servicesFirebaseRef2['default'].child('users').child(userId).child('sessions').push(id, function (error) {
	          if (error) {
	            reject(error);
	          } else {
	            resolve(id);
	          }
	        });
	      });
	    }).then(function (sessionId) {
	      var language = params.language;
	      var grade = params.grade;
	      var divisionName = params.divisionName;
	      var numberOfStudents = params.numberOfStudents;
	      var firstClass = params.firstClass;
	
	      if (firstClass) {
	        var eventData = {
	          userId: userId,
	          sessionId: sessionId,
	          programId: programId,
	          language: language,
	          grade: grade,
	          divisionName: divisionName,
	          numberOfStudents: numberOfStudents,
	          referrerUserId: referrerUserId
	        };
	        (0, _servicesEvents.publishEvent)('First Class Created', eventData);
	      }
	      return sessionId;
	    }).then(function (sessionId) {
	      var language = params.language;
	      var grade = params.grade;
	      var divisionName = params.divisionName;
	      var numberOfStudents = params.numberOfStudents;
	
	      var eventData = {
	        userId: userId,
	        sessionId: sessionId,
	        programId: programId,
	        language: language,
	        grade: grade,
	        divisionName: divisionName,
	        numberOfStudents: numberOfStudents,
	        referrerUserId: referrerUserId,
	        pendingApproval: pendingApproval // GTM note: required for intercom
	      };
	      (0, _servicesEvents.publishEvent)('Class Created', eventData);
	      if (isApproved) {
	        (0, _servicesEvents.sendClassApprovedEvents)({
	          userId: userId,
	          sessionId: sessionId,
	          programId: programId,
	          contractId: contractId,
	          staffUserId: 'auto',
	          validUntil: validUntil,
	          noEmail: false,
	          language: language
	        });
	      }
	      if (referrerUserId) {
	        (0, _servicesEvents.publishEvent)('Class Referral Completed', {
	          userId: referrerUserId,
	          refereeUserId: userId,
	          sessionId: sessionId,
	          programId: programId,
	          language: language
	        });
	      }
	    })['catch'](function (error) {
	      throw error;
	    });
	  };
	}
	
	function sessionUpdate(sessionId, data) {
	  return {
	    type: SESSION_UPDATE,
	    sessionId: sessionId,
	    data: data
	  };
	}
	
	function updateSession(sessionId, programId, data, userId) {
	  return function (dispatch) {
	    var updatedAt = _servicesFirebaseRef.TIMESTAMP;
	    var updateData = _extends({}, data, {
	      updatedAt: updatedAt
	    });
	    return new _Promise(function (resolve, reject) {
	      _servicesFirebaseRef2['default'].child('sessions').child(sessionId).update(updateData, function (error) {
	        if (error) {
	          reject(error);
	        } else {
	          resolve(sessionId);
	        }
	      });
	    }).then(function () {
	      return dispatch(sessionUpdate(sessionId, data));
	    }).then(function () {
	      var language = data.language;
	
	      var rest = _objectWithoutProperties(data, ['language']);
	
	      (0, _servicesEvents.publishEvent)('Class Updated', _extends({
	        userId: userId,
	        sessionId: sessionId,
	        programId: programId,
	        language: language
	      }, rest));
	    })['catch'](function (error) {
	      throw error;
	    });
	  };
	}
	
	function sessionBuy(sessionId, data) {
	  return {
	    type: SESSION_BUY,
	    sessionId: sessionId,
	    data: data
	  };
	}
	
	function buySession(sessionId, programId, data, userId) {
	  return function (dispatch) {
	    var updatedAt = _servicesFirebaseRef.TIMESTAMP;
	    var buyData = _extends({}, data, {
	      funding: 'STRIPE',
	      validUntil: (0, _servicesPayment.getValidUntilTime)()
	    });
	
	    return _servicesFirebaseRef2['default'].child('sessions').child(sessionId).update(_extends({}, buyData, {
	      updatedAt: updatedAt
	    })).then(function () {
	      dispatch(sessionBuy(sessionId, buyData));
	      return getSessionById(sessionId);
	    }).then(function (_ref) {
	      var language = _ref.language;
	
	      (0, _servicesEvents.publishEvent)('Class Purchased', {
	        userId: userId,
	        sessionId: sessionId,
	        programId: programId,
	        funding: 'STRIPE',
	        stripeChargeId: buyData.stripeChargeId,
	        promoCode: buyData.promoCode,
	        paidAmount: buyData.paidAmount,
	        paidCurrency: buyData.paidCurrency,
	        validUntil: buyData.validUntil,
	        language: language
	      }, ['validUntil']);
	    });
	  };
	}
	
	function fetchSession(dispatch, refs, sessionId) {
	  var sessionRef = _servicesFirebaseRef2['default'].child('sessions').child(sessionId);
	  sessionRef.on('value', function (snapshot) {
	    var value = snapshot.val();
	    if (value) {
	      dispatch(sessionCreate(sessionId, value));
	    }
	  });
	  refs.push(sessionRef);
	}
	
	function noSessions(userId) {
	  return {
	    type: NO_SESSIONS,
	    userId: userId
	  };
	}
	
	function bindSessions(userId, refs) {
	  return function (dispatch) {
	    var userSessionRef = _servicesFirebaseRef2['default'].child('users').child(userId).child('sessions');
	    userSessionRef.once('value', function (snapshot) {
	      if (snapshot && snapshot.val() === null) {
	        dispatch(noSessions(userId));
	      }
	    });
	    userSessionRef.on('child_added', function (snapshot) {
	      var sessionId = snapshot.val();
	      fetchSession(dispatch, refs, sessionId);
	    });
	    refs.push(userSessionRef);
	  };
	}
	
	function bindSingleSession(sessionId, refs) {
	  return function (dispatch) {
	    fetchSession(dispatch, refs, sessionId);
	  };
	}
	
	function unbind(refs) {
	  return function () {
	    refs.forEach(function (savedRef) {
	      savedRef.off();
	    });
	  };
	}
	
	function sessionSetLastSlide(sessionId, lastSlide) {
	  return {
	    type: SESSION_SET_LAST_SLIDE,
	    sessionId: sessionId,
	    lastSlide: lastSlide
	  };
	}
	
	function setLastSlide(_ref2) {
	  var sessionId = _ref2.sessionId;
	  var _ref2$lastSlide = _ref2.lastSlide;
	  var lastSlide = _ref2$lastSlide === undefined ? null : _ref2$lastSlide;
	
	  return function (dispatch) {
	    return new _Promise(function (resolve, reject) {
	      _servicesFirebaseRef2['default'].child('sessions').child(sessionId).update({
	        lastSlide: lastSlide
	      }, function (error) {
	        if (error) {
	          reject(error);
	        } else {
	          resolve();
	        }
	      });
	    }).then(function () {
	      return dispatch(sessionSetLastSlide(sessionId, lastSlide));
	    });
	  };
	}
	
	function sessionSetCurrentSlide(sessionId, currentSlide) {
	  return {
	    type: SESSION_SET_CURRENT_SLIDE,
	    sessionId: sessionId,
	    currentSlide: currentSlide
	  };
	}
	
	function setCurrentSlide(_ref3) {
	  var sessionId = _ref3.sessionId;
	  var _ref3$currentSlide = _ref3.currentSlide;
	  var currentSlide = _ref3$currentSlide === undefined ? null : _ref3$currentSlide;
	
	  return function (dispatch) {
	    return new _Promise(function (resolve, reject) {
	      _servicesFirebaseRef2['default'].child('sessions').child(sessionId).update({
	        currentSlide: currentSlide,
	        videoState: {}
	      }, function (error) {
	        if (error) {
	          reject(error);
	        } else {
	          resolve();
	        }
	      });
	    }).then(function () {
	      return dispatch(sessionSetCurrentSlide(sessionId, currentSlide));
	    });
	  };
	}
	
	function sessionSetVideoState(sessionId, videoState) {
	  return {
	    type: SESSION_SET_VIDEO_STATE,
	    sessionId: sessionId,
	    videoState: videoState
	  };
	}
	
	function setVideoState(_ref4) {
	  var sessionId = _ref4.sessionId;
	  var videoState = _ref4.videoState;
	
	  return function (dispatch) {
	    return new _Promise(function (resolve, reject) {
	      _servicesFirebaseRef2['default'].child('sessions').child(sessionId).update({
	        videoState: videoState
	      }, function (error) {
	        if (error) {
	          reject(error);
	        } else {
	          resolve();
	        }
	      });
	    }).then(function () {
	      return dispatch(sessionSetVideoState(sessionId, videoState));
	    });
	  };
	}
	
	function sessionSetTeamName(sessionId, team, teamName) {
	  return {
	    type: SESSION_SET_TEAM_NAME,
	    sessionId: sessionId,
	    team: team,
	    teamName: teamName
	  };
	}
	
	function setTeamName(_ref5) {
	  var sessionId = _ref5.sessionId;
	  var team = _ref5.team;
	  var teamName = _ref5.teamName;
	
	  return function (dispatch) {
	    return new _Promise(function (resolve, reject) {
	      _servicesFirebaseRef2['default'].child('sessions').child(sessionId).child('teamNames').update(_defineProperty({}, team, teamName), function (error) {
	        if (error) {
	          reject(error);
	        } else {
	          resolve();
	        }
	      });
	    }).then(function (data) {
	      return new _Promise(function (resolve, reject) {
	        _servicesFirebaseRef2['default'].child('sessions').child(sessionId).update({
	          updatedAt: _servicesFirebaseRef.TIMESTAMP
	        }, function (error) {
	          if (error) {
	            reject(error);
	          } else {
	            resolve(data);
	          }
	        });
	      });
	    }).then(function () {
	      return dispatch(sessionSetTeamName(sessionId, team, teamName));
	    });
	  };
	}
	
	function sessionSetScore(sessionId, team, score) {
	  return {
	    type: SESSION_SET_SCORE,
	    sessionId: sessionId,
	    team: team,
	    score: score
	  };
	}
	
	function setScore(_ref6) {
	  var sessionId = _ref6.sessionId;
	  var team = _ref6.team;
	  var score = _ref6.score;
	
	  return function (dispatch) {
	    return new _Promise(function (resolve, reject) {
	      _servicesFirebaseRef2['default'].child('sessions').child(sessionId).child('scores').update(_defineProperty({}, team, score), function (error) {
	        if (error) {
	          reject(error);
	        } else {
	          resolve();
	        }
	      });
	    }).then(function (data) {
	      return new _Promise(function (resolve, reject) {
	        _servicesFirebaseRef2['default'].child('sessions').child(sessionId).update({
	          updatedAt: _servicesFirebaseRef.TIMESTAMP
	        }, function (error) {
	          if (error) {
	            reject(error);
	          } else {
	            resolve(data);
	          }
	        });
	      });
	    }).then(function () {
	      return dispatch(sessionSetScore(sessionId, team, score));
	    });
	  };
	}
	
	function sessionSetMissionReportAnswer(_ref7) {
	  var sessionId = _ref7.sessionId;
	  var level = _ref7.level;
	  var questionNumber = _ref7.questionNumber;
	  var question = _ref7.question;
	  var answer = _ref7.answer;
	  var isValid = _ref7.isValid;
	
	  return {
	    type: SESSION_SET_MISSION_REPORT_ANSWER,
	    sessionId: sessionId,
	    level: level,
	    questionNumber: questionNumber,
	    question: question,
	    answer: answer,
	    isValid: isValid
	  };
	}
	
	function setMissionReportAnswer(_ref8) {
	  var sessionId = _ref8.sessionId;
	  var level = _ref8.level;
	  var questionNumber = _ref8.questionNumber;
	  var question = _ref8.question;
	  var answer = _ref8.answer;
	  var invalid = _ref8.invalid;
	
	  var questionId = questionNumber ? 'Q' + questionNumber : 'hacked';
	  return function (dispatch) {
	    return new _Promise(function (resolve, reject) {
	      _servicesFirebaseRef2['default'].child('sessions').child(sessionId).child('missionReports').child('L' + level).child(questionId).update({
	        question: question,
	        answer: answer,
	        invalid: invalid
	      }, function (error) {
	        if (error) {
	          reject(error);
	        } else {
	          resolve();
	        }
	      });
	    }).then(function (data) {
	      return new _Promise(function (resolve, reject) {
	        _servicesFirebaseRef2['default'].child('sessions').child(sessionId).update({
	          updatedAt: _servicesFirebaseRef.TIMESTAMP
	        }, function (error) {
	          if (error) {
	            reject(error);
	          } else {
	            resolve(data);
	          }
	        });
	      });
	    }).then(function () {
	      return dispatch(sessionSetMissionReportAnswer({
	        sessionId: sessionId,
	        level: level,
	        questionNumber: questionNumber,
	        question: question,
	        answer: answer,
	        invalid: invalid
	      }));
	    });
	  };
	}
	
	function sessionSetMode(sessionId, mode) {
	  return {
	    type: SESSION_SET_MODE,
	    sessionId: sessionId,
	    mode: mode
	  };
	}
	
	function setMode(_ref9) {
	  var sessionId = _ref9.sessionId;
	  var _ref9$mode = _ref9.mode;
	  var mode = _ref9$mode === undefined ? null : _ref9$mode;
	
	  return function (dispatch) {
	    return new _Promise(function (resolve, reject) {
	      _servicesFirebaseRef2['default'].child('sessions').child(sessionId).update({
	        mode: mode
	      }, function (error) {
	        if (error) {
	          reject(error);
	        } else {
	          resolve();
	        }
	      });
	    }).then(function () {
	      return dispatch(sessionSetMode(sessionId, mode));
	    });
	  };
	}
	
	function sessionSetCurrentLevel(sessionId, currentLevel) {
	  return {
	    type: SESSION_SET_CURRENT_LEVEL,
	    sessionId: sessionId,
	    currentLevel: currentLevel
	  };
	}
	
	function setCurrentLevel(_ref10) {
	  var sessionId = _ref10.sessionId;
	  var currentLevel = _ref10.currentLevel;
	
	  return function (dispatch) {
	    return new _Promise(function (resolve, reject) {
	      _servicesFirebaseRef2['default'].child('sessions').child(sessionId).update({
	        currentLevel: String(currentLevel)
	      }, function (error) {
	        if (error) {
	          reject(error);
	        } else {
	          resolve();
	        }
	      });
	    }).then(function () {
	      return dispatch(sessionSetCurrentLevel(sessionId, String(currentLevel)));
	    }).then(function () {
	      return setCurrentSlide({ sessionId: sessionId })(dispatch);
	    }).then(function () {
	      return setMode({ sessionId: sessionId })(dispatch);
	    });
	  };
	}
	
	function sessionCompleteLevel(_ref11) {
	  var sessionId = _ref11.sessionId;
	  var programId = _ref11.programId;
	  var completedLevel = _ref11.completedLevel;
	  var finished = _ref11.finished;
	
	  return {
	    type: SESSION_COMPLETE_LEVEL,
	    sessionId: sessionId,
	    programId: programId,
	    completedLevel: completedLevel,
	    finished: finished
	  };
	}
	
	function completeLevel(_ref12) {
	  var sessionId = _ref12.sessionId;
	  var completedLevel = _ref12.completedLevel;
	  var programId = _ref12.programId;
	  var finished = _ref12.finished;
	  var contractId = _ref12.contractId;
	  var userId = _ref12.userId;
	  var funding = _ref12.funding;
	
	  return function (dispatch) {
	    var attributes = {
	      completedLevel: Number(completedLevel),
	      updatedAt: _servicesFirebaseRef.TIMESTAMP
	    };
	    if (finished) {
	      attributes.completedAt = _servicesFirebaseRef.TIMESTAMP;
	    }
	    if (completedLevel === '1') {
	      attributes.completedLevel1At = _servicesFirebaseRef.TIMESTAMP;
	    }
	    return _servicesFirebaseRef2['default'].child('sessions').child(sessionId).update(attributes).then(function () {
	      return getSessionById(sessionId);
	    }).then(function (_ref13) {
	      var language = _ref13.language;
	
	      var levelName = _programsIndex2['default'].programList.filter(function (p) {
	        return p.id === programId;
	      })[0]["levels"][completedLevel]["levelName"];
	      (0, _servicesEvents.publishEvent)('Level Completed', {
	        userId: userId,
	        sessionId: sessionId,
	        programId: programId,
	        level: completedLevel,
	        levelName: levelName,
	        funding: funding,
	        contractId: contractId,
	        language: language
	      });
	      if (finished) {
	        (0, _servicesEvents.publishEvent)('Class Completed', {
	          userId: userId,
	          sessionId: sessionId,
	          programId: programId,
	          funding: funding,
	          contractId: contractId,
	          language: language
	        });
	      }
	    }).then(function () {
	      return dispatch(sessionCompleteLevel({
	        sessionId: sessionId,
	        programId: programId,
	        completedLevel: Number(completedLevel),
	        finished: finished
	      }));
	    });
	  };
	}
	
	function advanceLevel(_ref14) {
	  var sessionId = _ref14.sessionId;
	  var completedLevel = _ref14.completedLevel;
	
	  return function (dispatch) {
	    return _Promise.resolve().then(function () {
	      return setCurrentLevel({
	        sessionId: sessionId,
	        currentLevel: Number(completedLevel) + 1
	      })(dispatch);
	    }).then(function () {
	      return setLastSlide({ sessionId: sessionId })(dispatch);
	    });
	  };
	}
	
	function completeLevelAndAdvance(_ref15) {
	  var sessionId = _ref15.sessionId;
	  var completedLevel = _ref15.completedLevel;
	  var programId = _ref15.programId;
	  var finished = _ref15.finished;
	  var contractId = _ref15.contractId;
	  var userId = _ref15.userId;
	  var funding = _ref15.funding;
	
	  return function (dispatch) {
	    return _Promise.resolve().then(function () {
	      return completeLevel({ sessionId: sessionId, completedLevel: completedLevel, programId: programId, finished: finished, contractId: contractId, userId: userId, funding: funding })(dispatch);
	    }).then(function () {
	      return advanceLevel({ sessionId: sessionId, completedLevel: completedLevel })(dispatch);
	    });
	  };
	}
	
	function resetAddEditClassForm() {
	  var data = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	  return function (dispatch) {
	    dispatch((0, _reduxForm.initialize)('addEditClass', data));
	  };
	}
	
	function sessionSetConfiguration(sessionId, configuration) {
	  return {
	    type: SESSION_SET_CONFIGURATION,
	    sessionId: sessionId,
	    configuration: configuration
	  };
	}
	
	function setConfiguration(_ref16) {
	  var sessionId = _ref16.sessionId;
	  var _ref16$configuration = _ref16.configuration;
	  var configuration = _ref16$configuration === undefined ? null : _ref16$configuration;
	
	  return function (dispatch) {
	    return new _Promise(function (resolve, reject) {
	      _servicesFirebaseRef2['default'].child('sessions').child(sessionId).update({
	        configuration: configuration
	      }, function (error) {
	        if (error) {
	          reject(error);
	        } else {
	          resolve();
	        }
	      });
	    }).then(function () {
	      return dispatch(sessionSetConfiguration(sessionId, configuration));
	    });
	  };
	}
	
	function sessionArchive(sessionId) {
	  return {
	    type: SESSION_ARCHIVE,
	    sessionId: sessionId
	  };
	}
	
	function archiveSession(sessionId, programId, userId) {
	  return function (dispatch) {
	    return new _Promise(function (resolve, reject) {
	      _servicesFirebaseRef2['default'].child('sessions').child(sessionId).update({
	        archived: true,
	        pendingApproval: null,
	        updatedAt: _servicesFirebaseRef.TIMESTAMP,
	        archivedAt: _servicesFirebaseRef.TIMESTAMP
	      }, function (error) {
	        if (error) {
	          reject(error);
	        } else {
	          resolve();
	        }
	      });
	    }).then(function () {
	      return getSessionById(sessionId);
	    }).then(function (_ref17) {
	      var language = _ref17.language;
	
	      (0, _servicesEvents.publishEvent)('Class Archived', {
	        userId: userId,
	        sessionId: sessionId,
	        programId: programId,
	        language: language
	      });
	      return dispatch(sessionArchive(sessionId));
	    });
	  };
	}
	
	function sessionSetHackedAnswer(sessionId, level, answer) {
	  return {
	    type: SESSION_SET_HACKED_ANSWER,
	    sessionId: sessionId,
	    level: level,
	    answer: answer
	  };
	}
	
	function setHackedAnswer(_ref18) {
	  var sessionId = _ref18.sessionId;
	  var level = _ref18.level;
	  var answer = _ref18.answer;
	
	  return function (dispatch) {
	    return new _Promise(function (resolve, reject) {
	      _servicesFirebaseRef2['default'].child('sessions').child(sessionId).update(_defineProperty({}, 'zh-hacked-answer-' + level, answer), function (error) {
	        if (error) {
	          reject(error);
	        } else {
	          resolve();
	        }
	      });
	    }).then(function () {
	      return dispatch(sessionSetHackedAnswer(sessionId, answer));
	    });
	  };
	}

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = __webpack_require__(7)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.publishEvent = publishEvent;
	exports.sendClassApprovedEvents = sendClassApprovedEvents;
	
	var _utilsTimestamp = __webpack_require__(1128);
	
	/**
	 * Dispatch event to data layer
	 */
	
	function publishEvent(type, payload) {
	  var timeFields = arguments.length <= 2 || arguments[2] === undefined ? [] : arguments[2];
	
	  var timestamp = (0, _utilsTimestamp.createTS)();
	  // GTM note: intercom requires timestamps in format "dddd, MMMM Do YYYY, H:mm:ss"
	  var intercomTimestamp = (0, _utilsTimestamp.convertToRTS)(timestamp);
	  var intercomTimeFields = timeFields.reduce(function (props, propName) {
	    var newPropName = 'intercom' + propName[0].toUpperCase() + propName.substr(1);
	    props[newPropName] = (0, _utilsTimestamp.convertToRTS)(payload[propName]);
	    return props;
	  }, {});
	  dataLayer.push({
	    event: 'logEvent',
	    eventType: type,
	    eventProperties: _extends({}, payload, intercomTimeFields, {
	      timestamp: timestamp,
	      intercomTimestamp: intercomTimestamp
	    })
	  });
	  console.log("Published", type, JSON.stringify(payload));
	}
	
	function sendClassApprovedEvents(_ref) {
	  var userId = _ref.userId;
	  var sessionId = _ref.sessionId;
	  var programId = _ref.programId;
	  var contractId = _ref.contractId;
	  var staffUserId = _ref.staffUserId;
	  var validUntil = _ref.validUntil;
	  var noEmail = _ref.noEmail;
	  var language = _ref.language;
	
	  var payload = {
	    userId: userId,
	    sessionId: sessionId,
	    programId: programId,
	    funding: "CONTRACT",
	    contractId: contractId,
	    staffUserId: staffUserId,
	    validUntil: validUntil,
	    language: language
	  };
	  if (!noEmail) {
	    publishEvent('Class Approved Nurture Campaign Started', payload, ['validUntil']);
	  }
	  publishEvent('Class Approved', payload, ['validUntil']);
	}

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _firebase = __webpack_require__(331);
	
	var _firebase2 = _interopRequireDefault(_firebase);
	
	var _appConfig = __webpack_require__(54);
	
	var _appConfig2 = _interopRequireDefault(_appConfig);
	
	var firebase = _appConfig2['default'].firebase;
	var firebaseKey = _appConfig2['default'].firebaseKey;
	
	// Initialize Firebase
	var config = {
	  apiKey: firebaseKey,
	  authDomain: firebase + '.firebaseapp.com',
	  databaseURL: 'https://' + firebase + '.firebaseio.com',
	  storageBucket: firebase + '.appspot.com'
	};
	_firebase2['default'].initializeApp(config);
	
	var authRef = _firebase2['default'].auth();
	exports.authRef = authRef;
	var ref = _firebase2['default'].database().ref();
	exports.ref = ref;
	var TIMESTAMP = _firebase2['default'].database.ServerValue.TIMESTAMP;
	exports.TIMESTAMP = TIMESTAMP;
	exports['default'] = ref;

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.validateLogin = validateLogin;
	exports.validateChangeEmail = validateChangeEmail;
	exports.validateChangePassword = validateChangePassword;
	exports.validateRegistration = validateRegistration;
	exports.validateCompleteRegistration = validateCompleteRegistration;
	exports.validateEditProfile = validateEditProfile;
	exports.validateForgotPassword = validateForgotPassword;
	
	var _validator = __webpack_require__(917);
	
	var _validator2 = _interopRequireDefault(_validator);
	
	var _lodash = __webpack_require__(65);
	
	var _servicesRegionalization = __webpack_require__(38);
	
	var _servicesRegionalization2 = _interopRequireDefault(_servicesRegionalization);
	
	function validateEmail(data, errors) {
	  var email = data.email;
	
	  if (!email) {
	    errors.email = 'Required';
	  } else if (!_validator2['default'].isEmail(email)) {
	    errors.email = 'Email format does not appear to be valid';
	  }
	}
	
	function validatePassword(data, errors) {
	  var key = arguments.length <= 2 || arguments[2] === undefined ? 'password' : arguments[2];
	
	  var password = data[key];
	
	  if (!password) {
	    errors[key] = 'Required';
	  } else if (password.length < 6) {
	    errors[key] = 'Password must be minimum 6 characters in length';
	  }
	}
	
	function validateLogin(data) {
	  var errors = {};
	
	  validateEmail(data, errors);
	  validatePassword(data, errors);
	
	  return errors;
	}
	
	function validateChangeEmail(data) {
	  var errors = {};
	
	  validateEmail(data, errors);
	  validatePassword(data, errors);
	
	  return errors;
	}
	
	function validateChangePassword(data) {
	  var errors = {};
	
	  validatePassword(data, errors, 'oldPassword');
	  validatePassword(data, errors, 'newPassword');
	
	  return errors;
	}
	
	function validateProfileRegistration(data, errors) {
	  var firstName = data.firstName;
	  var lastName = data.lastName;
	
	  if (!firstName) {
	    errors.firstName = 'Required';
	  } else if (firstName.length > 80) {
	    errors.firstName = 'Please use a shorter name';
	  }
	
	  if (!lastName) {
	    errors.lastName = 'Required';
	  } else if (lastName.length > 80) {
	    errors.lastName = 'Please use a shorter name';
	  }
	}
	
	function validateSchool(data, errors) {
	  var country = data.country;
	  var cityOrMunicipality = data.cityOrMunicipality;
	  var stateOrProvince = data.stateOrProvince;
	  var school = data.school;
	
	  if (!cityOrMunicipality) {
	    errors.cityOrMunicipality = 'Required';
	  } else if (cityOrMunicipality.length > 80) {
	    errors.cityOrMunicipality = 'Please use a shorter name';
	  }
	
	  if (!country) {
	    errors.country = 'Required';
	  }
	
	  if (!stateOrProvince || !_servicesRegionalization2['default'].isValidStateOrProvinces(country, stateOrProvince)) {
	    errors.stateOrProvince = 'Required';
	  }
	
	  if (!school) {
	    errors.school = 'Required';
	  } else if (school.length > 80) {
	    errors.school = 'Please use a shorter name';
	  }
	}
	
	function validateRegistration(data) {
	  var errors = {};
	  var termsAccepted = data.termsAccepted;
	
	  validateProfileRegistration(data, errors);
	  validateEmail(data, errors);
	  validatePassword(data, errors);
	
	  if (!termsAccepted) {
	    errors.termsAccepted = 'Required';
	  }
	
	  return errors;
	}
	
	function validateCompleteRegistration(data) {
	  var errors = {};
	
	  validateSchool(data, errors);
	
	  return errors;
	}
	
	function validateEditProfile(data) {
	  var errors = {};
	
	  validateProfileRegistration(data, errors);
	  validateSchool(data, errors);
	
	  return errors;
	}
	
	function validateForgotPassword(data) {
	  var errors = {};
	
	  validateEmail(data, errors);
	
	  return errors;
	}
	
	var normalizeRegisterForm = {
	  firstName: function firstName(value) {
	    return value && (0, _lodash.trimLeft)(value);
	  },
	  lastName: function lastName(value) {
	    return value && (0, _lodash.trimLeft)(value);
	  },
	  phone: function phone(value) {
	    return value && (0, _lodash.trimLeft)(value);
	  },
	  cityOrMunicipality: function cityOrMunicipality(value) {
	    return value && (0, _lodash.trimLeft)(value);
	  },
	  school: function school(value) {
	    return value && (0, _lodash.trimLeft)(value);
	  },
	  marketingOptIn: function marketingOptIn(value) {
	    return !!value;
	  }
	};
	exports.normalizeRegisterForm = normalizeRegisterForm;

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _taggedTemplateLiteral = __webpack_require__(28)['default'];
	
	var _get = __webpack_require__(8)['default'];
	
	var _inherits = __webpack_require__(5)['default'];
	
	var _createClass = __webpack_require__(6)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _getIterator = __webpack_require__(62)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['Sum of questions ', ' must be the same or less than the number of Apprentices in Q1'], ['Sum of questions ', ' must be the same or less than the number of Apprentices in Q1']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(2216);
	
	function validationErrorMessage(question, cumulativeQuestionNumbers, _) {
	  if (question.exception) return _("You must report a number");
	  if (question.cumulative) return _(_templateObject, cumulativeQuestionNumbers);
	  if (question.number > 1) return _("Numbers reported must be the same or less than the total number of Apprentices in Q1");
	  return _("Please tell us the total number of Apprentices reporting in Q1");
	}
	
	function parseIntOrNull(n) {
	  var int = parseInt(n, 10);
	  if (isNaN(int)) return null;
	  return int;
	}
	
	var MissionReport = (function (_Component) {
	  _inherits(MissionReport, _Component);
	
	  _createClass(MissionReport, null, [{
	    key: 'propTypes',
	    value: {
	      missionReportQuestions: _react.PropTypes.array.isRequired
	    },
	    enumerable: true
	  }, {
	    key: 'contextTypes',
	    value: {
	      session: _react.PropTypes.object.isRequired,
	      setMissionReportAnswer: _react.PropTypes.func.isRequired,
	      hideHUD: _react.PropTypes.func.isRequired,
	      presenter: _react.PropTypes.bool,
	      i18n: _react.PropTypes.func.isRequired
	    },
	    enumerable: true
	  }]);
	
	  function MissionReport() {
	    _classCallCheck(this, MissionReport);
	
	    _get(Object.getPrototypeOf(MissionReport.prototype), 'constructor', this).call(this);
	    this.state = {
	      showValidationErrorModal: false,
	      validationErrors: []
	    };
	  }
	
	  _createClass(MissionReport, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.cumulativeQuestionNumbers = (nextProps.missionReportQuestions || []).filter(function (q) {
	        return q.cumulative;
	      }).map(function (q) {
	        return q.number;
	      });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.refs.question1.focus();
	    }
	  }, {
	    key: '_getAnswer',
	    value: function _getAnswer(questionNumber) {
	      var _context$session = this.context.session;
	      var missionReports = _context$session.missionReports;
	      var currentLevel = _context$session.currentLevel;
	
	      if (!missionReports) return null;
	      var levelReport = missionReports['L' + currentLevel];
	      if (!levelReport) return null;
	      var questionAsnwer = levelReport['Q' + questionNumber];
	      if (!questionAsnwer) return null;
	      return parseIntOrNull(questionAsnwer.answer);
	    }
	  }, {
	    key: '_getCumulativeValue',
	    value: function _getCumulativeValue(q1, v1, q2, v2) {
	      var missionReportQuestions = this.props.missionReportQuestions;
	
	      var cumulativeValue = 0;
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = _getIterator(missionReportQuestions), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var missionReportQuestion = _step.value;
	
	          if (!missionReportQuestion.cumulative) continue;
	          if (q1 && missionReportQuestion.number === q1.number) {
	            cumulativeValue += v1 || 0;
	          } else if (q2 && missionReportQuestion.number === q2.number) {
	            cumulativeValue += v2 || 0;
	          } else {
	            cumulativeValue += this._getAnswer(missionReportQuestion.number);
	          }
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator['return']) {
	            _iterator['return']();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      return cumulativeValue;
	    }
	  }, {
	    key: '_hasValidAnswer',
	    value: function _hasValidAnswer(question, answer, nbApprentices, cumulativeValue) {
	      if (question.exception || question.number === 1) return answer !== null;
	      if (nbApprentices === null || answer === null) return true;
	      if (question.cumulative) {
	        return cumulativeValue <= nbApprentices;
	      }
	      return answer <= nbApprentices;
	    }
	  }, {
	    key: '_setMissionReportQuestion',
	    value: function _setMissionReportQuestion(question, answer, nbApprentices, cumulativeValue) {
	      var _context = this.context;
	      var session = _context.session;
	      var setMissionReportAnswer = _context.setMissionReportAnswer;
	      var hideHUD = _context.hideHUD;
	      var level = session.currentLevel;
	
	      var isValid = this._hasValidAnswer(question, answer, nbApprentices, cumulativeValue);
	      setMissionReportAnswer({
	        level: level,
	        questionNumber: question.number,
	        question: question.text,
	        answer: answer,
	        invalid: !isValid
	      });
	      hideHUD();
	    }
	  }, {
	    key: 'clickHandler',
	    value: function clickHandler(evt) {
	      if (evt) {
	        evt.preventDefault();
	        evt.stopPropagation();
	        evt.nativeEvent.stopPropagation();
	      }
	    }
	  }, {
	    key: '_revalidateOtherQuestions',
	    value: function _revalidateOtherQuestions(question1Value, cumulativeValue) {
	      var _this = this;
	
	      var missionReportQuestions = this.props.missionReportQuestions;
	
	      missionReportQuestions.forEach(function (question) {
	        if (question.number === 1) return;
	        _this._setMissionReportQuestion(question, _this._getAnswer(question.number), question1Value, cumulativeValue);
	      });
	    }
	  }, {
	    key: '_revalidateCumulativeQuestions',
	    value: function _revalidateCumulativeQuestions(exceptQ, exceptV, nbApprentices) {
	      var _this2 = this;
	
	      var missionReportQuestions = this.props.missionReportQuestions;
	
	      missionReportQuestions.filter(function (q) {
	        return q.cumulative;
	      }).forEach(function (question) {
	        if (question.number === exceptQ.number) return;
	        var answer = _this2._getAnswer(question.number);
	        var cumulativeValue = _this2._getCumulativeValue(exceptQ, exceptV, question, answer);
	        _this2._setMissionReportQuestion(question, answer, nbApprentices, cumulativeValue);
	      });
	    }
	  }, {
	    key: 'changeHandler',
	    value: function changeHandler(evt) {
	      var match = evt.target.name.match(/question(\d+)$/);
	      if (match && match[1]) {
	        var questionNumber = Number(match[1]);
	        var missionReportQuestions = this.props.missionReportQuestions;
	
	        var question = missionReportQuestions[questionNumber - 1];
	        var value = parseIntOrNull(evt.target.value);
	        var nbApprentices = parseIntOrNull(this._getAnswer(1));
	        var cumulativeValue = this._getCumulativeValue(question, value);
	        if (value >= 0 && value <= 999 || value === null) {
	          this._setMissionReportQuestion(question, value, nbApprentices, cumulativeValue);
	        }
	        if (questionNumber > 1 && nbApprentices === null) {
	          this._setMissionReportQuestion(missionReportQuestions[0], nbApprentices, cumulativeValue);
	        }
	        if (questionNumber === 1) {
	          this._revalidateOtherQuestions(value, cumulativeValue);
	        }
	        if (question.cumulative) {
	          this._revalidateCumulativeQuestions(question, value, nbApprentices);
	        }
	      }
	      if (evt) {
	        evt.preventDefault();
	        evt.stopPropagation();
	        evt.nativeEvent.stopPropagation();
	      }
	    }
	  }, {
	    key: 'keyDown',
	    value: function keyDown(evt) {
	      var presenter = this.context.presenter;
	
	      if (evt) {
	        if (presenter) {
	          // Stop arrow key navigation on teacher remote
	          if (evt.keyCode === 37 || evt.keyCode === 39) {
	            // left, right
	            evt.stopPropagation();
	            evt.nativeEvent.stopPropagation();
	          }
	        } else {
	          // Don't use arrows for input fields in presentation mode
	          if (evt.keyCode === 37 || evt.keyCode === 39) {
	            // left, right
	            evt.preventDefault();
	          }
	        }
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var missionReportQuestions = this.props.missionReportQuestions;
	      var _context$session2 = this.context.session;
	      var missionReports = _context$session2.missionReports;
	      var currentLevel = _context$session2.currentLevel;
	
	      var answers = missionReports ? missionReports['L' + currentLevel] : null;
	
	      return _react2['default'].createElement(
	        'div',
	        { className: 'mission-report' },
	        _react2['default'].createElement(
	          'div',
	          { className: 'form-horizontal' },
	          _react2['default'].createElement(
	            'div',
	            { className: 'form-fields' },
	            missionReportQuestions.map(function (question, index) {
	              return _react2['default'].createElement(
	                'div',
	                { key: index, className: 'question-group-wrapper' },
	                _react2['default'].createElement(
	                  'div',
	                  { className: 'question-group team-' + (index + 1) },
	                  _react2['default'].createElement(
	                    'label',
	                    { className: 'control-label' },
	                    question.text
	                  ),
	                  _react2['default'].createElement('input', {
	                    className: 'form-control',
	                    placeholder: '',
	                    name: 'question' + (index + 1),
	                    ref: 'question' + (index + 1),
	                    type: 'number',
	                    value: answers && answers['Q' + (index + 1)] && answers['Q' + (index + 1)].answer,
	                    min: 0,
	                    max: 999,
	                    onClick: _this3.clickHandler.bind(_this3),
	                    onChange: _this3.changeHandler.bind(_this3),
	                    onKeyDown: _this3.keyDown.bind(_this3)
	                  })
	                ),
	                _react2['default'].createElement(
	                  'div',
	                  { className: 'question-group-error' },
	                  answers && answers['Q' + (index + 1)] && answers['Q' + (index + 1)].invalid && validationErrorMessage(question, _this3.cumulativeQuestionNumbers, _this3.context.i18n)
	                )
	              );
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return MissionReport;
	})(_react.Component);
	
	exports['default'] = MissionReport;
	module.exports = exports['default'];

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _get = __webpack_require__(8)['default'];
	
	var _inherits = __webpack_require__(5)['default'];
	
	var _createClass = __webpack_require__(6)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(838);
	
	// SVG files from https://github.com/encharm/Font-Awesome-SVG-PNG
	
	var _desktopSvg = __webpack_require__(2538);
	
	var _desktopSvg2 = _interopRequireDefault(_desktopSvg);
	
	var _mobileSvg = __webpack_require__(2539);
	
	var _mobileSvg2 = _interopRequireDefault(_mobileSvg);
	
	var SelectConfiguration = (function (_Component) {
	  _inherits(SelectConfiguration, _Component);
	
	  function SelectConfiguration() {
	    _classCallCheck(this, SelectConfiguration);
	
	    _get(Object.getPrototypeOf(SelectConfiguration.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(SelectConfiguration, [{
	    key: 'setConfiguration',
	    value: function setConfiguration(role, evt) {
	      var setConfiguration = this.context.setConfiguration;
	
	      setConfiguration(role);
	      if (evt) {
	        evt.preventDefault();
	        evt.stopPropagation();
	        evt.nativeEvent.stopPropagation();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _context = this.context;
	      var configuration = _context.session.configuration;
	      var _ = _context.i18n;
	
	      return _react2['default'].createElement(
	        'div',
	        { className: 'select-configuration' },
	        _react2['default'].createElement(
	          'h1',
	          null,
	          _('Select Configuration')
	        ),
	        _react2['default'].createElement(
	          'div',
	          { className: 'select-btn-container' },
	          _react2['default'].createElement(
	            'button',
	            {
	              className: 'btn btn-lg button dualScreenBtn ' + (configuration === 'dualScreen' && 'active'),
	              onClick: this.setConfiguration.bind(this, 'dualScreen') },
	            _react2['default'].createElement(
	              'figure',
	              { className: 'icons' },
	              _react2['default'].createElement('img', { src: _desktopSvg2['default'], className: 'desktopSvg' }),
	              '+',
	              _react2['default'].createElement('img', { src: _mobileSvg2['default'], className: 'mobileSvg' })
	            ),
	            _react2['default'].createElement(
	              'div',
	              { className: 'description' },
	              _react2['default'].createElement(
	                'h3',
	                null,
	                _('Dual Screen')
	              ),
	              _('Classroom Display + Remote')
	            ),
	            _react2['default'].createElement(
	              'div',
	              { className: 'checkmark' },
	              configuration === 'dualScreen' && _react2['default'].createElement('i', { className: 'glyphicon glyphicon-ok' })
	            )
	          ),
	          _react2['default'].createElement(
	            'button',
	            {
	              className: 'btn btn-lg button singleScreenBtn ' + (configuration === 'singleScreen' && 'active'),
	              onClick: this.setConfiguration.bind(this, 'singleScreen') },
	            _react2['default'].createElement(
	              'figure',
	              { className: 'icons' },
	              _react2['default'].createElement('img', { src: _desktopSvg2['default'], className: 'desktopSvg' })
	            ),
	            _react2['default'].createElement(
	              'div',
	              { className: 'description' },
	              _react2['default'].createElement(
	                'h3',
	                null,
	                _('Single Screen')
	              ),
	              _('Classroom Display Only')
	            ),
	            _react2['default'].createElement(
	              'div',
	              { className: 'checkmark' },
	              configuration === 'singleScreen' && _react2['default'].createElement('i', { className: 'glyphicon glyphicon-ok' })
	            )
	          )
	        )
	      );
	    }
	  }], [{
	    key: 'contextTypes',
	    value: {
	      session: _react.PropTypes.object.isRequired,
	      setConfiguration: _react.PropTypes.func.isRequired,
	      i18n: _react.PropTypes.func.isRequired
	    },
	    enumerable: true
	  }]);
	
	  return SelectConfiguration;
	})(_react.Component);
	
	exports['default'] = SelectConfiguration;
	module.exports = exports['default'];

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _get = __webpack_require__(8)['default'];
	
	var _inherits = __webpack_require__(5)['default'];
	
	var _createClass = __webpack_require__(6)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(838);
	
	// SVG files from https://github.com/encharm/Font-Awesome-SVG-PNG
	
	var _screenSvg = __webpack_require__(2541);
	
	var _screenSvg2 = _interopRequireDefault(_screenSvg);
	
	var _remoteSvg = __webpack_require__(2540);
	
	var _remoteSvg2 = _interopRequireDefault(_remoteSvg);
	
	var SelectDeviceRole = (function (_Component) {
	  _inherits(SelectDeviceRole, _Component);
	
	  function SelectDeviceRole() {
	    _classCallCheck(this, SelectDeviceRole);
	
	    _get(Object.getPrototypeOf(SelectDeviceRole.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(SelectDeviceRole, [{
	    key: 'setDeviceRole',
	    value: function setDeviceRole(role, evt) {
	      var setDeviceRole = this.context.setDeviceRole;
	
	      setDeviceRole(role);
	      if (evt) {
	        evt.preventDefault();
	        evt.stopPropagation();
	        evt.nativeEvent.stopPropagation();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _context = this.context;
	      var deviceRole = _context.deckState.deviceRole;
	      var _ = _context.i18n;
	
	      return _react2['default'].createElement(
	        'div',
	        { className: 'select-configuration' },
	        _react2['default'].createElement(
	          'h1',
	          null,
	          _('Select Role of This Device')
	        ),
	        _react2['default'].createElement(
	          'div',
	          { className: 'select-btn-container' },
	          _react2['default'].createElement(
	            'button',
	            {
	              className: 'btn btn-lg classroomDisplayBtn ' + (deviceRole === 'classroomDisplay' && 'active'),
	              onClick: this.setDeviceRole.bind(this, 'classroomDisplay') },
	            _react2['default'].createElement(
	              'figure',
	              { className: 'icons' },
	              _react2['default'].createElement('img', { src: _screenSvg2['default'], className: 'screenSvg' })
	            ),
	            _react2['default'].createElement(
	              'div',
	              { className: 'description' },
	              _react2['default'].createElement(
	                'h3',
	                null,
	                _('Classroom Display')
	              )
	            ),
	            _react2['default'].createElement(
	              'div',
	              { className: 'checkmark' },
	              deviceRole === 'classroomDisplay' && _react2['default'].createElement('i', { className: 'glyphicon glyphicon-ok' })
	            )
	          ),
	          _react2['default'].createElement(
	            'button',
	            {
	              className: 'btn btn-lg remoteControlBtn ' + (deviceRole === 'remoteControl' && 'active'),
	              onClick: this.setDeviceRole.bind(this, 'remoteControl') },
	            _react2['default'].createElement(
	              'figure',
	              { className: 'icons' },
	              _react2['default'].createElement('img', { src: _remoteSvg2['default'], className: 'remoteSvg' })
	            ),
	            _react2['default'].createElement(
	              'div',
	              { className: 'description' },
	              _react2['default'].createElement(
	                'h3',
	                null,
	                _('Remote Control')
	              )
	            ),
	            _react2['default'].createElement(
	              'div',
	              { className: 'checkmark' },
	              deviceRole === 'remoteControl' && _react2['default'].createElement('i', { className: 'glyphicon glyphicon-ok' })
	            )
	          )
	        )
	      );
	    }
	  }], [{
	    key: 'contextTypes',
	    value: {
	      deckState: _react.PropTypes.object.isRequired,
	      setDeviceRole: _react.PropTypes.func.isRequired,
	      i18n: _react.PropTypes.func.isRequired
	    },
	    enumerable: true
	  }]);
	
	  return SelectDeviceRole;
	})(_react.Component);
	
	exports['default'] = SelectDeviceRole;
	module.exports = exports['default'];

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _taggedTemplateLiteral = __webpack_require__(28)['default'];
	
	var _get = __webpack_require__(8)['default'];
	
	var _inherits = __webpack_require__(5)['default'];
	
	var _createClass = __webpack_require__(6)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['Start Level ', ''], ['Start Level ', '']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _startFromLastSlideModal = __webpack_require__(1177);
	
	var _startFromLastSlideModal2 = _interopRequireDefault(_startFromLastSlideModal);
	
	__webpack_require__(2219);
	
	var StartLevel = (function (_Component) {
	  _inherits(StartLevel, _Component);
	
	  _createClass(StartLevel, null, [{
	    key: 'contextTypes',
	    value: {
	      session: _react.PropTypes.object.isRequired,
	      program: _react.PropTypes.object.isRequired,
	      nextLevel: _react.PropTypes.string.isRequired,
	      setCurrentLevel: _react.PropTypes.func.isRequired,
	      setLastSlide: _react.PropTypes.func.isRequired,
	      setActiveSession: _react.PropTypes.func.isRequired,
	      i18n: _react.PropTypes.func.isRequired
	    },
	    enumerable: true
	  }]);
	
	  function StartLevel(props) {
	    _classCallCheck(this, StartLevel);
	
	    _get(Object.getPrototypeOf(StartLevel.prototype), 'constructor', this).call(this, props);
	    this.state = {
	      showStartFromLastSlideModal: false
	    };
	  }
	
	  _createClass(StartLevel, [{
	    key: 'displayStartFromLastSlideModal',
	    value: function displayStartFromLastSlideModal() {
	      this.setState({ showStartFromLastSlideModal: true });
	    }
	  }, {
	    key: 'hideStartFromLastSlideModal',
	    value: function hideStartFromLastSlideModal() {
	      this.setState({ showStartFromLastSlideModal: false });
	    }
	  }, {
	    key: 'startLevel',
	    value: function startLevel(evt) {
	      var _context = this.context;
	      var session = _context.session;
	      var setCurrentLevel = _context.setCurrentLevel;
	      var nextLevel = _context.nextLevel;
	      var lastSlide = session.lastSlide;
	
	      if (lastSlide) {
	        this.displayStartFromLastSlideModal();
	      } else {
	        setCurrentLevel(nextLevel);
	      }
	      if (evt) {
	        evt.preventDefault();
	        evt.stopPropagation();
	        evt.nativeEvent.stopPropagation();
	      }
	    }
	  }, {
	    key: 'startLevelFromBeginning',
	    value: function startLevelFromBeginning() {
	      var _context2 = this.context;
	      var nextLevel = _context2.nextLevel;
	      var setCurrentLevel = _context2.setCurrentLevel;
	      var setLastSlide = _context2.setLastSlide;
	
	      setLastSlide().then(function () {
	        return setCurrentLevel(nextLevel);
	      });
	    }
	  }, {
	    key: 'startLevelFromLastSlide',
	    value: function startLevelFromLastSlide() {
	      var _context3 = this.context;
	      var nextLevel = _context3.nextLevel;
	      var setCurrentLevel = _context3.setCurrentLevel;
	
	      setCurrentLevel(nextLevel);
	    }
	  }, {
	    key: 'dashboard',
	    value: function dashboard() {
	      var setActiveSession = this.context.setActiveSession;
	
	      setActiveSession('none');
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _context4 = this.context;
	      var nextLevel = _context4.nextLevel;
	      var _ = _context4.i18n;
	      var showStartFromLastSlideModal = this.state.showStartFromLastSlideModal;
	
	      return _react2['default'].createElement(
	        'div',
	        { className: 'start-level-container' },
	        _react2['default'].createElement(
	          'h1',
	          null,
	          _('Ready!')
	        ),
	        _react2['default'].createElement(
	          'p',
	          null,
	          _('You are cleared for takeoff, everything is ready to go!')
	        ),
	        _react2['default'].createElement(
	          'p',
	          null,
	          ' '
	        ),
	        _react2['default'].createElement(
	          'div',
	          null,
	          _react2['default'].createElement(
	            'button',
	            { className: 'btn btn-lg', onClick: this.dashboard.bind(this) },
	            _('Back to Dashboard')
	          ),
	          _react2['default'].createElement(
	            'button',
	            { className: 'btn btn-lg btn-primary', onClick: this.startLevel.bind(this) },
	            nextLevel !== 'completed' ? _react2['default'].createElement(
	              'span',
	              null,
	              _(_templateObject, nextLevel)
	            ) : _react2['default'].createElement(
	              'span',
	              null,
	              _('Re-Enter')
	            )
	          )
	        ),
	        _react2['default'].createElement(_startFromLastSlideModal2['default'], {
	          showModal: showStartFromLastSlideModal,
	          closeModal: this.hideStartFromLastSlideModal.bind(this),
	          startFromBeginning: this.startLevelFromBeginning.bind(this),
	          startFromLastSlide: this.startLevelFromLastSlide.bind(this) })
	      );
	    }
	  }]);
	
	  return StartLevel;
	})(_react.Component);
	
	exports['default'] = StartLevel;
	module.exports = exports['default'];

/***/ }),
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = __webpack_require__(7)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	function balloonSlide(_ref) {
	  var id = _ref.id;
	  var balloonType = _ref.balloonType;
	  var questionNumber = _ref.questionNumber;
	  var numQuestions = _ref.numQuestions;
	  var notes = _ref.notes;
	  var heading = _ref.heading;
	  var characterImage = _ref.characterImage;
	  var characterSide = _ref.characterSide;
	  var bgColor = _ref.bgColor;
	  var html = _ref.html;
	  var slideClass = _ref.slideClass;
	
	  var charPos = characterSide !== '' ? characterSide : '';
	  var slideContentClass = slideClass ? ' slide-' + slideClass : '';
	  var balloonClass = !balloonType && !bgColor ? ' balloon-regular' : '';
	  var bgColorOpts = {};
	  if (bgColor) {
	    bgColorOpts.bgColor = bgColor;
	  } else {
	    if (balloonType) {
	      bgColorOpts.bgColor = balloonType === 'question' ? '#45B3EC' : '#6FC36E'; // set to 45B3EC for questions, 6FC36E for other non-empty values
	    } else {
	        bgColorOpts.bgColor = 'transparent';
	      }
	  }
	  return _react2['default'].createElement(
	    _spectaclePpa.Slide,
	    _extends({
	      id: id,
	      key: id
	    }, bgColorOpts, {
	      notes: notes }),
	    _react2['default'].createElement(
	      'div',
	      { className: 'slide-content' + slideContentClass },
	      _react2['default'].createElement(
	        'div',
	        {
	          className: 'text-balloon ' + charPos + ' text-formatted' + balloonClass },
	        balloonType === 'question' ? _react2['default'].createElement(
	          _spectaclePpa.Heading,
	          { size: 2 },
	          'Question ',
	          questionNumber,
	          ' of ',
	          numQuestions,
	          ':'
	        ) : null,
	        !!heading && _react2['default'].createElement(
	          _spectaclePpa.Heading,
	          { size: 3 },
	          heading
	        ),
	        _react2['default'].createElement('div', {
	          className: 'text-balloon-body',
	          dangerouslySetInnerHTML: { __html: html } })
	      ),
	      characterImage ? _react2['default'].createElement(
	        'div',
	        {
	          className: 'text-balloon-character ' + charPos },
	        _react2['default'].createElement('img', { src: characterImage })
	      ) : null
	    )
	  );
	}
	
	exports['default'] = balloonSlide;
	module.exports = exports['default'];

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = __webpack_require__(7)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	function balloonSlide(_ref) {
	  var id = _ref.id;
	  var balloonType = _ref.balloonType;
	  var questionNumber = _ref.questionNumber;
	  var numQuestions = _ref.numQuestions;
	  var notes = _ref.notes;
	  var heading = _ref.heading;
	  var characterImage = _ref.characterImage;
	  var characterSide = _ref.characterSide;
	  var bgColor = _ref.bgColor;
	  var html = _ref.html;
	  var slideClass = _ref.slideClass;
	
	  var charPos = characterSide !== '' ? characterSide : '';
	  var slideContentClass = slideClass ? ' slide-' + slideClass : '';
	  var balloonClass = !balloonType && !bgColor ? ' balloon-regular' : '';
	  var bgColorOpts = {};
	  if (bgColor) {
	    bgColorOpts.bgColor = bgColor;
	  } else {
	    if (balloonType) {
	      bgColorOpts.bgColor = balloonType === 'question' ? '#45B3EC' : '#6FC36E'; // set to 45B3EC for questions, 6FC36E for other non-empty values
	    } else {
	        bgColorOpts.bgColor = 'transparent';
	      }
	  }
	  return _react2['default'].createElement(
	    _spectaclePpa.Slide,
	    _extends({
	      id: id,
	      key: id
	    }, bgColorOpts, {
	      notes: notes }),
	    _react2['default'].createElement(
	      'div',
	      { className: 'slide-content' + slideContentClass },
	      _react2['default'].createElement(
	        'div',
	        {
	          className: 'text-balloon ' + charPos + ' text-formatted' + balloonClass },
	        balloonType === 'question' ? _react2['default'].createElement(
	          _spectaclePpa.Heading,
	          { size: 2 },
	          'Question ',
	          questionNumber,
	          ' of ',
	          numQuestions,
	          ':'
	        ) : null,
	        !!heading && _react2['default'].createElement(
	          _spectaclePpa.Heading,
	          { size: 3 },
	          heading
	        ),
	        _react2['default'].createElement('div', {
	          className: 'text-balloon-body',
	          dangerouslySetInnerHTML: { __html: html } })
	      ),
	      characterImage ? _react2['default'].createElement(
	        'div',
	        {
	          className: 'text-balloon-character ' + charPos },
	        _react2['default'].createElement('img', { src: characterImage })
	      ) : null
	    )
	  );
	}
	
	exports['default'] = balloonSlide;
	module.exports = exports['default'];

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = __webpack_require__(7)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	function balloonSlide(_ref) {
	  var id = _ref.id;
	  var balloonType = _ref.balloonType;
	  var questionNumber = _ref.questionNumber;
	  var numQuestions = _ref.numQuestions;
	  var notes = _ref.notes;
	  var heading = _ref.heading;
	  var characterImage = _ref.characterImage;
	  var characterSide = _ref.characterSide;
	  var bgColor = _ref.bgColor;
	  var html = _ref.html;
	  var slideClass = _ref.slideClass;
	
	  var charPos = characterSide !== '' ? characterSide : '';
	  var slideContentClass = slideClass ? ' slide-' + slideClass : '';
	  var balloonClass = !balloonType && !bgColor ? ' balloon-regular' : '';
	  var bgColorOpts = {};
	  if (bgColor) {
	    bgColorOpts.bgColor = bgColor;
	  } else {
	    if (balloonType) {
	      bgColorOpts.bgColor = balloonType === 'question' ? '#45B3EC' : '#6FC36E'; // set to 45B3EC for questions, 6FC36E for other non-empty values
	    } else {
	        bgColorOpts.bgColor = 'transparent';
	      }
	  }
	  return _react2['default'].createElement(
	    _spectaclePpa.Slide,
	    _extends({
	      id: id,
	      key: id
	    }, bgColorOpts, {
	      notes: notes }),
	    _react2['default'].createElement(
	      'div',
	      { className: 'slide-content' + slideContentClass },
	      _react2['default'].createElement(
	        'div',
	        {
	          className: 'text-balloon ' + charPos + ' text-formatted' + balloonClass },
	        balloonType === 'question' ? _react2['default'].createElement(
	          _spectaclePpa.Heading,
	          { size: 2 },
	          'Question ',
	          questionNumber,
	          ' of ',
	          numQuestions,
	          ':'
	        ) : null,
	        !!heading && _react2['default'].createElement(
	          _spectaclePpa.Heading,
	          { size: 3 },
	          heading
	        ),
	        _react2['default'].createElement('div', {
	          className: 'text-balloon-body',
	          dangerouslySetInnerHTML: { __html: html } })
	      ),
	      characterImage ? _react2['default'].createElement(
	        'div',
	        {
	          className: 'text-balloon-character ' + charPos },
	        _react2['default'].createElement('img', { src: characterImage })
	      ) : null
	    )
	  );
	}
	
	exports['default'] = balloonSlide;
	module.exports = exports['default'];

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = __webpack_require__(7)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	function balloonSlide(_ref) {
	  var id = _ref.id;
	  var balloonType = _ref.balloonType;
	  var questionNumber = _ref.questionNumber;
	  var numQuestions = _ref.numQuestions;
	  var notes = _ref.notes;
	  var heading = _ref.heading;
	  var characterImage = _ref.characterImage;
	  var characterSide = _ref.characterSide;
	  var bgColor = _ref.bgColor;
	  var html = _ref.html;
	  var slideClass = _ref.slideClass;
	
	  var charPos = characterSide !== '' ? characterSide : '';
	  var slideContentClass = slideClass ? ' slide-' + slideClass : '';
	  var balloonClass = !balloonType && !bgColor ? ' balloon-regular' : '';
	  var bgColorOpts = {};
	  if (bgColor) {
	    bgColorOpts.bgColor = bgColor;
	  } else {
	    if (balloonType) {
	      bgColorOpts.bgColor = balloonType === 'question' ? '#45B3EC' : '#6FC36E'; // set to 45B3EC for questions, 6FC36E for other non-empty values
	    } else {
	        bgColorOpts.bgColor = 'transparent';
	      }
	  }
	  return _react2['default'].createElement(
	    _spectaclePpa.Slide,
	    _extends({
	      id: id,
	      key: id
	    }, bgColorOpts, {
	      notes: notes }),
	    _react2['default'].createElement(
	      'div',
	      { className: 'slide-content' + slideContentClass },
	      _react2['default'].createElement(
	        'div',
	        {
	          className: 'text-balloon ' + charPos + ' text-formatted' + balloonClass },
	        balloonType === 'question' ? _react2['default'].createElement(
	          _spectaclePpa.Heading,
	          { size: 2 },
	          'Question ',
	          questionNumber,
	          ' of ',
	          numQuestions,
	          ':'
	        ) : null,
	        !!heading && _react2['default'].createElement(
	          _spectaclePpa.Heading,
	          { size: 3 },
	          heading
	        ),
	        _react2['default'].createElement('div', {
	          className: 'text-balloon-body',
	          dangerouslySetInnerHTML: { __html: html } })
	      ),
	      characterImage ? _react2['default'].createElement(
	        'div',
	        {
	          className: 'text-balloon-character ' + charPos },
	        _react2['default'].createElement('img', { src: characterImage })
	      ) : null
	    )
	  );
	}
	
	exports['default'] = balloonSlide;
	module.exports = exports['default'];

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = __webpack_require__(7)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	function balloonSlide(_ref) {
	  var id = _ref.id;
	  var balloonType = _ref.balloonType;
	  var questionNumber = _ref.questionNumber;
	  var numQuestions = _ref.numQuestions;
	  var notes = _ref.notes;
	  var heading = _ref.heading;
	  var characterImage = _ref.characterImage;
	  var characterSide = _ref.characterSide;
	  var bgColor = _ref.bgColor;
	  var html = _ref.html;
	  var slideClass = _ref.slideClass;
	
	  var charPos = characterSide !== '' ? characterSide : '';
	  var slideContentClass = slideClass ? ' slide-' + slideClass : '';
	  var balloonClass = !balloonType && !bgColor ? ' balloon-regular' : '';
	  var bgColorOpts = {};
	  if (bgColor) {
	    bgColorOpts.bgColor = bgColor;
	  } else {
	    if (balloonType) {
	      bgColorOpts.bgColor = balloonType === 'question' ? '#45B3EC' : '#6FC36E'; // set to 45B3EC for questions, 6FC36E for other non-empty values
	    } else {
	        bgColorOpts.bgColor = 'transparent';
	      }
	  }
	  return _react2['default'].createElement(
	    _spectaclePpa.Slide,
	    _extends({
	      id: id,
	      key: id
	    }, bgColorOpts, {
	      notes: notes }),
	    _react2['default'].createElement(
	      'div',
	      { className: 'slide-content' + slideContentClass },
	      _react2['default'].createElement(
	        'div',
	        {
	          className: 'text-balloon ' + charPos + ' text-formatted' + balloonClass },
	        balloonType === 'question' ? _react2['default'].createElement(
	          _spectaclePpa.Heading,
	          { size: 2 },
	          'Question ',
	          questionNumber,
	          ' of ',
	          numQuestions,
	          ':'
	        ) : null,
	        !!heading && _react2['default'].createElement(
	          _spectaclePpa.Heading,
	          { size: 3 },
	          heading
	        ),
	        _react2['default'].createElement('div', {
	          className: 'text-balloon-body',
	          dangerouslySetInnerHTML: { __html: html } })
	      ),
	      characterImage ? _react2['default'].createElement(
	        'div',
	        {
	          className: 'text-balloon-character ' + charPos },
	        _react2['default'].createElement('img', { src: characterImage })
	      ) : null
	    )
	  );
	}
	
	exports['default'] = balloonSlide;
	module.exports = exports['default'];

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _componentsYouTube = __webpack_require__(61);
	
	var _componentsYouTube2 = _interopRequireDefault(_componentsYouTube);
	
	function videoSlide(_ref) {
	  var id = _ref.id;
	  var notes = _ref.notes;
	  var heading = _ref.heading;
	  var youTubeId = _ref.youTubeId;
	  var lowRes = _ref.lowRes;
	  var bgColor = _ref.bgColor;
	  var slideClass = _ref.slideClass;
	
	  var slideContentClass = slideClass ? ' slide-' + slideClass : '';
	  var booleanLowRes = lowRes === 'true';
	  return _react2['default'].createElement(
	    _spectaclePpa.Slide,
	    {
	      id: id,
	      key: id,
	      bgColor: bgColor ? bgColor : 'black',
	      notes: notes },
	    _react2['default'].createElement(
	      'div',
	      { className: 'slide-content' + slideContentClass },
	      _react2['default'].createElement(
	        'div',
	        { className: 'video-slide' },
	        heading ? _react2['default'].createElement(
	          _spectaclePpa.Heading,
	          { size: 3, textColor: 'primary', textFont: 'primary' },
	          heading
	        ) : null,
	        _react2['default'].createElement(_componentsYouTube2['default'], {
	          youTubeId: youTubeId,
	          lowRes: booleanLowRes,
	          presentation: true })
	      )
	    )
	  );
	}
	
	exports['default'] = videoSlide;
	module.exports = exports['default'];

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _componentsYouTube = __webpack_require__(61);
	
	var _componentsYouTube2 = _interopRequireDefault(_componentsYouTube);
	
	function videoSlide(_ref) {
	  var id = _ref.id;
	  var notes = _ref.notes;
	  var heading = _ref.heading;
	  var youTubeId = _ref.youTubeId;
	  var lowRes = _ref.lowRes;
	  var bgColor = _ref.bgColor;
	  var slideClass = _ref.slideClass;
	
	  var slideContentClass = slideClass ? ' slide-' + slideClass : '';
	  var booleanLowRes = lowRes === 'true';
	  return _react2['default'].createElement(
	    _spectaclePpa.Slide,
	    {
	      id: id,
	      key: id,
	      bgColor: bgColor ? bgColor : 'black',
	      notes: notes },
	    _react2['default'].createElement(
	      'div',
	      { className: 'slide-content' + slideContentClass },
	      _react2['default'].createElement(
	        'div',
	        { className: 'video-slide' },
	        heading ? _react2['default'].createElement(
	          _spectaclePpa.Heading,
	          { size: 3, textColor: 'primary', textFont: 'primary' },
	          heading
	        ) : null,
	        _react2['default'].createElement(_componentsYouTube2['default'], {
	          youTubeId: youTubeId,
	          lowRes: booleanLowRes,
	          presentation: true })
	      )
	    )
	  );
	}
	
	exports['default'] = videoSlide;
	module.exports = exports['default'];

/***/ }),
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(145)(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 97 */
/***/ (function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _helpersI18n = __webpack_require__(14);
	
	var _helpersMarkdownScript = __webpack_require__(9);
	
	var _helpersMarkdownScript2 = _interopRequireDefault(_helpersMarkdownScript);
	
	var _indexMd = __webpack_require__(1740);
	
	var _indexMd2 = _interopRequireDefault(_indexMd);
	
	var _indexFr_CAMd = __webpack_require__(1739);
	
	var _indexFr_CAMd2 = _interopRequireDefault(_indexFr_CAMd);
	
	exports['default'] = (0, _helpersI18n.i18nData)({
	  en: new _helpersMarkdownScript2['default'](_indexMd2['default']),
	  fr_CA: new _helpersMarkdownScript2['default'](_indexFr_CAMd2['default'])
	});
	module.exports = exports['default'];

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

	/* eslint react/no-multi-comp: 0, no-unused-vars: 0 */
	
	'use strict';
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.preloadGameShow = preloadGameShow;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _srcServicesRegionalization = __webpack_require__(38);
	
	var _srcServicesRegionalization2 = _interopRequireDefault(_srcServicesRegionalization);
	
	var _baseSlidesBalloonSlide = __webpack_require__(71);
	
	var _baseSlidesBalloonSlide2 = _interopRequireDefault(_baseSlidesBalloonSlide);
	
	var _baseSlidesHeadingSlide = __webpack_require__(171);
	
	var _baseSlidesHeadingSlide2 = _interopRequireDefault(_baseSlidesHeadingSlide);
	
	var _baseSlidesVideoSlide = __webpack_require__(43);
	
	var _baseSlidesVideoSlide2 = _interopRequireDefault(_baseSlidesVideoSlide);
	
	var _title_gameshowPng = __webpack_require__(2513);
	
	var _title_gameshowPng2 = _interopRequireDefault(_title_gameshowPng);
	
	var _title_gameshowBrainstormPng = __webpack_require__(2512);
	
	var _title_gameshowBrainstormPng2 = _interopRequireDefault(_title_gameshowBrainstormPng);
	
	var _title_gameshow_playersPng = __webpack_require__(2514);
	
	var _title_gameshow_playersPng2 = _interopRequireDefault(_title_gameshow_playersPng);
	
	var _imagesCharactersApprenticesPairArmsFoldedPng = __webpack_require__(2484);
	
	var _imagesCharactersApprenticesPairArmsFoldedPng2 = _interopRequireDefault(_imagesCharactersApprenticesPairArmsFoldedPng);
	
	var _imagesCharactersApprenticePointingUp2Png = __webpack_require__(2481);
	
	var _imagesCharactersApprenticePointingUp2Png2 = _interopRequireDefault(_imagesCharactersApprenticePointingUp2Png);
	
	var _imagesCharactersApprenticePointingUp3Png = __webpack_require__(2482);
	
	var _imagesCharactersApprenticePointingUp3Png2 = _interopRequireDefault(_imagesCharactersApprenticePointingUp3Png);
	
	var _imagesCharactersApprenticesFlexArmsPng = __webpack_require__(907);
	
	var _imagesCharactersApprenticesFlexArmsPng2 = _interopRequireDefault(_imagesCharactersApprenticesFlexArmsPng);
	
	var _imagesCharactersApprenticeFistUpPng = __webpack_require__(2477);
	
	var _imagesCharactersApprenticeFistUpPng2 = _interopRequireDefault(_imagesCharactersApprenticeFistUpPng);
	
	var _imagesCharactersApprenticeHandsHips2Png = __webpack_require__(2479);
	
	var _imagesCharactersApprenticeHandsHips2Png2 = _interopRequireDefault(_imagesCharactersApprenticeHandsHips2Png);
	
	var _imagesCharactersApprenticeCuriousPng = __webpack_require__(2476);
	
	var _imagesCharactersApprenticeCuriousPng2 = _interopRequireDefault(_imagesCharactersApprenticeCuriousPng);
	
	var _imagesCharactersApprenticePointingDiagonalPng = __webpack_require__(906);
	
	var _imagesCharactersApprenticePointingDiagonalPng2 = _interopRequireDefault(_imagesCharactersApprenticePointingDiagonalPng);
	
	var _imagesCharactersSara_surprisedPng = __webpack_require__(910);
	
	var _imagesCharactersSara_surprisedPng2 = _interopRequireDefault(_imagesCharactersSara_surprisedPng);
	
	var _imagesCharactersIan_shrug_laughPng = __webpack_require__(2495);
	
	var _imagesCharactersIan_shrug_laughPng2 = _interopRequireDefault(_imagesCharactersIan_shrug_laughPng);
	
	var _helpersMarkdownScript = __webpack_require__(9);
	
	var _helpersMarkdownScript2 = _interopRequireDefault(_helpersMarkdownScript);
	
	var _level1_garbageMd = __webpack_require__(1842);
	
	var _level1_garbageMd2 = _interopRequireDefault(_level1_garbageMd);
	
	var _level2_foodWasteMd = __webpack_require__(1843);
	
	var _level2_foodWasteMd2 = _interopRequireDefault(_level2_foodWasteMd);
	
	var _level3_foodScrapsMd = __webpack_require__(1844);
	
	var _level3_foodScrapsMd2 = _interopRequireDefault(_level3_foodScrapsMd);
	
	var _level4_wasteFreeLunchMd = __webpack_require__(1845);
	
	var _level4_wasteFreeLunchMd2 = _interopRequireDefault(_level4_wasteFreeLunchMd);
	
	var _level5_buySmartMd = __webpack_require__(1846);
	
	var _level5_buySmartMd2 = _interopRequireDefault(_level5_buySmartMd);
	
	var _level6_greenCycleMd = __webpack_require__(1847);
	
	var _level6_greenCycleMd2 = _interopRequireDefault(_level6_greenCycleMd);
	
	var levels = {
	  '1': { md: new _helpersMarkdownScript2['default'](_level1_garbageMd2['default']) },
	  '2': { md: new _helpersMarkdownScript2['default'](_level2_foodWasteMd2['default']) },
	  '3': { md: new _helpersMarkdownScript2['default'](_level3_foodScrapsMd2['default']) },
	  '4': { md: new _helpersMarkdownScript2['default'](_level4_wasteFreeLunchMd2['default']) },
	  '5': { md: new _helpersMarkdownScript2['default'](_level5_buySmartMd2['default']) },
	  '6': { md: new _helpersMarkdownScript2['default'](_level6_greenCycleMd2['default']) }
	};
	
	function preloadGameShow() {
	  (0, _spectaclePpa.preloader)([_title_gameshowPng2['default'], _title_gameshowBrainstormPng2['default'], _title_gameshow_playersPng2['default'], _imagesCharactersApprenticesPairArmsFoldedPng2['default'], _imagesCharactersApprenticePointingUp2Png2['default'], _imagesCharactersApprenticesFlexArmsPng2['default'], _imagesCharactersApprenticePointingUp3Png2['default'], _imagesCharactersApprenticeFistUpPng2['default'], _imagesCharactersApprenticeHandsHips2Png2['default'], _imagesCharactersApprenticeCuriousPng2['default'], _imagesCharactersSara_surprisedPng2['default'], _imagesCharactersIan_shrug_laughPng2['default']]);
	}
	
	function intro(level, regionData) {
	  var md = levels[level].md;
	  return (0, _baseSlidesVideoSlide2['default'])({
	    id: 'intro',
	    notes: md.getSubSectionAsHtml('Intro Video', 'Notes', false, regionData),
	    youTubeId: md.getSectionMetadata('Intro Video', 'YouTube', regionData)
	  });
	}
	
	function sizzle(level, regionData) {
	  var md = levels[level].md;
	  if (level === 5) {
	    return (0, _baseSlidesHeadingSlide2['default'])({
	      id: 'sizzle-brainstorm',
	      bgColor: '#742CBF',
	      afterImage: _title_gameshowBrainstormPng2['default'],
	      notes: md.getSubSectionAsHtml('Sizzle', 'Notes', false, regionData)
	    });
	  } else {
	    return (0, _baseSlidesHeadingSlide2['default'])({
	      id: 'sizzle',
	      bgColor: '#742CBF',
	      afterImage: _title_gameshowPng2['default'],
	      notes: md.getSubSectionAsHtml('Sizzle', 'Notes', false, regionData)
	    });
	  }
	}
	
	function scoring(level, regionData) {
	  var md = levels[level].md;
	  return (0, _baseSlidesBalloonSlide2['default'])({
	    id: 'scoring',
	    characterSide: 'right',
	    characterImage: _imagesCharactersApprenticeHandsHips2Png2['default'],
	    notes: md.getSubSectionAsHtml('Scoring', 'Notes', false, regionData),
	    html: md.getSubSectionAsHtml('Scoring', 'Content', false, regionData),
	    bgColor: '#742CBF'
	  });
	}
	
	function questionSlide(_ref) {
	  var level = _ref.level;
	  var questionNumber = _ref.questionNumber;
	  var numQuestions = _ref.numQuestions;
	  var md = _ref.md;
	  var questionCharacterImage = _ref.questionCharacterImage;
	  var answerCharacterImage = _ref.answerCharacterImage;
	  var regionData = _ref.regionData;
	
	  var questionSection = 'Question ' + questionNumber;
	  var defaultRegion = md.getSectionMetadata(questionSection, 'Default Region', regionData);
	  var questionCharacter = !questionCharacterImage ? _imagesCharactersApprenticeCuriousPng2['default'] : questionCharacterImage;
	  var answerCharacter = !answerCharacterImage ? _imagesCharactersApprenticePointingUp3Png2['default'] : answerCharacterImage;
	  var answer = undefined;
	  if (defaultRegion) {
	    answer = md.getSubSectionAsHtml(questionSection, 'Answer - ' + defaultRegion, false, regionData);
	  } else {
	    answer = md.getSubSectionAsHtml(questionSection, 'Answer', false, regionData);
	  }
	  var answerNotes = md.getSubSectionAsHtml(questionSection, 'Answer Notes', false, regionData);
	
	  return [
	
	  // if level 5, don't show 4 players please, and show instructions for
	  // Brainstorm Edition on Q1 only
	  level === 5 && questionNumber === 1 ? (0, _baseSlidesBalloonSlide2['default'])({
	    id: 'brainstorm-rules',
	    characterSide: 'right',
	    characterImage: _imagesCharactersSara_surprisedPng2['default'],
	    notes: md.getSubSectionAsHtml('Brainstorm Edition', 'Notes', false, regionData),
	    html: md.getSubSectionAsHtml('Brainstorm Edition', 'Content', false, regionData),
	    bgColor: '#742CBF'
	  }) : null,
	
	  // for all other levels show:
	  level !== 5 ? (0, _baseSlidesHeadingSlide2['default'])({
	    id: questionNumber + '-four-players',
	    afterImage: _title_gameshow_playersPng2['default'],
	    bgColor: 'black',
	    notes: '<h2>Question ' + questionNumber + ' of ' + numQuestions + ': </h2>' + md.getSubSectionAsHtml('Four Players Announcement', 'Notes', false, regionData)
	  }) : null,
	
	  // additional slide for level 1, question 6
	  level === 1 && questionNumber === 4 ? (0, _baseSlidesBalloonSlide2['default'])({
	    balloonType: 'question',
	    characterSide: 'left',
	    characterImage: _imagesCharactersApprenticeCuriousPng2['default'],
	    questionNumber: questionNumber,
	    numQuestions: numQuestions,
	    id: questionNumber + '-multiple-choice',
	    html: md.getSubSectionAsHtml(questionSection, 'Question Intro', false, regionData),
	    notes: '<h2>Question ' + questionNumber + ' of ' + numQuestions + ': </h2>' + '<br />' + '<p style="font color: white">Multiple choice, see next slide</h4>',
	    bgColor: '#45B3EC'
	  }) : null, (0, _baseSlidesBalloonSlide2['default'])({
	    balloonType: 'question',
	    characterSide: 'left',
	    characterImage: questionCharacter,
	    questionNumber: questionNumber,
	    numQuestions: numQuestions,
	    id: questionNumber + '-question',
	    html: md.getSubSectionAsHtml(questionSection, 'Question', false, regionData),
	    notes: '<h2>Question ' + questionNumber + ' of ' + numQuestions + ': </h2>' + '<br />' + '<p style="font color: white">Preview of next slide/answer</h4>' + answer
	  }), (0, _baseSlidesBalloonSlide2['default'])({
	    balloonType: 'answer',
	    characterSide: 'right',
	    characterImage: answerCharacter,
	    questionNumber: questionNumber,
	    id: questionNumber + '-answer',
	    html: answer,
	    notes: '<h2>Answer ' + questionNumber + ' of ' + numQuestions + '</h2>' + '<br />' + (!answerNotes.match(/SKIP/) ? md.getSubSectionAsHtml(questionSection, 'Answer Notes', false, regionData) : '')
	  })];
	}
	
	function endOfGameShow(level) {
	  return (0, _baseSlidesBalloonSlide2['default'])({
	    id: 'end',
	    characterSide: 'left',
	    characterImage: _imagesCharactersApprenticeFistUpPng2['default'],
	    bgColor: '#742CBF',
	    html: '<h3>Level ' + level + ' Game Show Completed!</h3>',
	    notes: 'Game show completed.'
	  });
	}
	
	function level1(regionData) {
	  var level = 1;
	  var md = levels[level].md;
	
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'game-show' },
	    intro(level, regionData),
	    sizzle(level, regionData),
	    scoring(level, regionData),
	    questionSlide({ level: level, questionNumber: 1, numQuestions: 6, md: md, regionData: regionData }),
	    (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'scoring-reminder',
	      characterSide: 'left',
	      characterImage: _imagesCharactersApprenticePointingDiagonalPng2['default'],
	      notes: md.getSubSectionAsHtml('Scoring Reminder', 'Notes', false, regionData),
	      html: md.getSubSectionAsHtml('Scoring Reminder', 'Content', false, regionData),
	      bgColor: '#742CBF'
	    }),
	    questionSlide({ level: level, questionNumber: 2, numQuestions: 6, md: md, regionData: regionData }),
	    questionSlide({ level: level, questionNumber: 3, numQuestions: 6, md: md, regionData: regionData }),
	    questionSlide({ level: level, questionNumber: 4, numQuestions: 6, md: md, regionData: regionData }),
	    questionSlide({ level: level, questionNumber: 5, numQuestions: 6, md: md, regionData: regionData }),
	    questionSlide({ level: level, questionNumber: 6, numQuestions: 6, md: md, regionData: regionData }),
	    (0, _baseSlidesVideoSlide2['default'])({
	      id: 'repair-song',
	      notes: md.getSubSectionAsHtml('The Repair Song Video', 'Notes', false, regionData),
	      youTubeId: md.getSectionMetadata('The Repair Song Video', 'YouTube', regionData)
	    }),
	    endOfGameShow(level)
	  );
	}
	
	function level2(regionData) {
	  var level = 2;
	  var md = levels[level].md;
	
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'game-show' },
	    intro(level, regionData),
	    sizzle(level, regionData),
	    scoring(level, regionData),
	    questionSlide({ level: level, questionNumber: 1, numQuestions: 5, md: md, regionData: regionData }),
	    (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'scoring-reminder',
	      characterSide: 'left',
	      characterImage: _imagesCharactersApprenticePointingDiagonalPng2['default'],
	      notes: md.getSubSectionAsHtml('Scoring Reminder', 'Notes', false, regionData),
	      html: md.getSubSectionAsHtml('Scoring Reminder', 'Content', false, regionData),
	      bgColor: '#742CBF'
	    }),
	    questionSlide({ level: level, questionNumber: 2, numQuestions: 5, md: md, regionData: regionData }),
	    questionSlide({ level: level, questionNumber: 3, numQuestions: 5, md: md, regionData: regionData }),
	    questionSlide({ level: level, questionNumber: 4, numQuestions: 5, md: md, regionData: regionData }),
	    questionSlide({ level: level, questionNumber: 5, numQuestions: 5, md: md, regionData: regionData }),
	    endOfGameShow(level)
	  );
	}
	
	function level3(regionData) {
	  var level = 3;
	  var md = levels[level].md;
	
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'game-show' },
	    intro(level, regionData),
	    sizzle(level, regionData),
	    questionSlide({ level: level, questionNumber: 1, numQuestions: 5, md: md, regionData: regionData }),
	    questionSlide({ level: level, questionNumber: 2, numQuestions: 5, md: md, regionData: regionData }),
	    questionSlide({ level: level, questionNumber: 3, numQuestions: 5, md: md, regionData: regionData }),
	    questionSlide({ level: level, questionNumber: 4, numQuestions: 5, md: md, regionData: regionData }),
	    questionSlide({ level: level, questionNumber: 5, numQuestions: 5, md: md, regionData: regionData }),
	    endOfGameShow(level)
	  );
	}
	
	function level4(regionData) {
	  var level = 4;
	  var md = levels[level].md;
	
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'game-show' },
	    intro(level, regionData),
	    sizzle(level, regionData),
	    questionSlide({ level: level, questionNumber: 1, numQuestions: 8, md: md, regionData: regionData }),
	    questionSlide({ level: level, questionNumber: 2, numQuestions: 8, md: md, regionData: regionData }),
	    questionSlide({ level: level, questionNumber: 3, numQuestions: 8, md: md, regionData: regionData }),
	    questionSlide({ level: level, questionNumber: 4, numQuestions: 8, md: md, regionData: regionData }),
	    questionSlide({ level: level, questionNumber: 5, numQuestions: 8, md: md, regionData: regionData }),
	    questionSlide({ level: level, questionNumber: 6, numQuestions: 8, md: md, regionData: regionData }),
	    questionSlide({ level: level, questionNumber: 7, numQuestions: 8, md: md, regionData: regionData }),
	    questionSlide({ level: level, questionNumber: 8, numQuestions: 8, md: md, regionData: regionData }),
	    endOfGameShow(level)
	  );
	}
	
	function level5(regionData) {
	  var level = 5;
	  var md = levels[level].md;
	
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'game-show' },
	    intro(level, regionData),
	    sizzle(level, regionData),
	    questionSlide({ level: level, questionNumber: 1, numQuestions: 4, md: md, regionData: regionData }),
	    questionSlide({ level: level, questionNumber: 2, numQuestions: 4, md: md, regionData: regionData }),
	    questionSlide({ level: level, questionNumber: 3, numQuestions: 4, md: md, regionData: regionData }),
	    questionSlide({ level: level, questionNumber: 4, numQuestions: 4, md: md, regionData: regionData }),
	    endOfGameShow(level)
	  );
	}
	
	function level6(regionData) {
	  var level = 6;
	  var md = levels[level].md;
	
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'game-show' },
	    intro(level, regionData),
	    sizzle(level, regionData),
	    (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'product-lifecycle',
	      characterSide: 'right',
	      characterImage: _imagesCharactersApprenticesFlexArmsPng2['default'],
	      notes: md.getSubSectionAsHtml('Product LifeCycle', 'Notes', false, regionData),
	      html: md.getSubSectionAsHtml('Product LifeCycle', 'Content', false, regionData),
	      bgColor: '#742CBF'
	    }),
	    questionSlide({ level: level, questionNumber: 1, numQuestions: 5, md: md, questionCharacterImage: _imagesCharactersIan_shrug_laughPng2['default'], answerCharacterImage: _imagesCharactersSara_surprisedPng2['default'], regionData: regionData }),
	    questionSlide({ level: level, questionNumber: 2, numQuestions: 5, md: md, regionData: regionData }),
	    questionSlide({ level: level, questionNumber: 3, numQuestions: 5, md: md, regionData: regionData }),
	    questionSlide({ level: level, questionNumber: 4, numQuestions: 5, md: md, regionData: regionData }),
	    questionSlide({ level: level, questionNumber: 5, numQuestions: 5, md: md, regionData: regionData }),
	    endOfGameShow(level, regionData),
	    (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'solutions',
	      characterSide: 'right',
	      characterImage: _imagesCharactersApprenticesPairArmsFoldedPng2['default'],
	      notes: md.getSubSectionAsHtml('Solutions', 'Notes', false, regionData),
	      html: md.getSubSectionAsHtml('Solutions', 'Content', false, regionData),
	      bgColor: '#742CBF'
	    })
	  );
	}
	
	function gameShowSection(_ref2) {
	  var level = _ref2.level;
	  var regionData = _ref2.regionData;
	
	  switch (level) {
	    case 1:
	      return level1(regionData);
	    case 2:
	      return level2(regionData);
	    case 3:
	      return level3(regionData);
	    case 4:
	      return level4(regionData);
	    case 5:
	      return level5(regionData);
	    case 6:
	      return level6(regionData);
	    default:
	      return (0, _baseSlidesHeadingSlide2['default'])({ heading: 'Unknown' });
	  }
	}
	
	exports['default'] = gameShowSection;
	/* Sara and Ian introduce the Game Show */ /* Sizzle */ /* Scoring intro */ /* Game show questions */ /* Scoring reminder */ /* The Repair Song */ /* End of Game Show */ /* Sara and Ian introduce the Game Show */ /* Sizzle */ /* Scoring intro */ /* Game show questions */ /* Scoring reminder */ /* End of Game Show */ /* Sara and Ian introduce the Game Show */ /* Sizzle */ /* Game show questions */ /* End of Game Show */ /* Sara and Ian introduce the Game Show */ /* Sizzle */ /* Game show questions */ /* End of Game Show */ /* Sara and Ian introduce the Game Show */ /* Sizzle */ /* Game show questions */ /* End of Game Show */ /* Sara and Ian introduce the Game Show */ /* Sizzle */ /* Product Life-Cycle */ /* Game show questions */ /* End of Game Show */ /* Now for some solutions! */

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = __webpack_require__(7)['default'];
	
	var _objectWithoutProperties = __webpack_require__(16)['default'];
	
	var _slicedToArray = __webpack_require__(1205)['default'];
	
	var _getIterator = __webpack_require__(62)['default'];
	
	var _Object$keys = __webpack_require__(32)['default'];
	
	var _Promise = __webpack_require__(33)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.saveProfile = saveProfile;
	exports.updateProfile = updateProfile;
	exports.updateOnboardingState = updateOnboardingState;
	exports.loadProfile = loadProfile;
	exports.bindProfile = bindProfile;
	exports.unbindProfile = unbindProfile;
	
	var _servicesFirebaseRef = __webpack_require__(74);
	
	var _servicesFirebaseRef2 = _interopRequireDefault(_servicesFirebaseRef);
	
	var _servicesEvents = __webpack_require__(73);
	
	var PROFILE_SAVING = 'PROFILE_SAVING';
	exports.PROFILE_SAVING = PROFILE_SAVING;
	var PROFILE_SAVED = 'PROFILE_SAVED';
	exports.PROFILE_SAVED = PROFILE_SAVED;
	var PROFILE_SAVE_ERROR = 'PROFILE_SAVE_ERROR';
	
	exports.PROFILE_SAVE_ERROR = PROFILE_SAVE_ERROR;
	var PROFILE_LOADING = 'PROFILE_LOADING';
	exports.PROFILE_LOADING = PROFILE_LOADING;
	var PROFILE_LOADED = 'PROFILE_LOADED';
	exports.PROFILE_LOADED = PROFILE_LOADED;
	var PROFILE_LOAD_ERROR = 'PROFILE_LOAD_ERROR';
	
	exports.PROFILE_LOAD_ERROR = PROFILE_LOAD_ERROR;
	var PROFILE_ONBOARDINGSTATE_UPDATED = 'PROFILE_ONBOARDINGSTATE_UPDATED';
	
	exports.PROFILE_ONBOARDINGSTATE_UPDATED = PROFILE_ONBOARDINGSTATE_UPDATED;
	function profileSaving(userId, data) {
	  return {
	    type: PROFILE_SAVING,
	    userId: userId,
	    payload: data
	  };
	}
	
	function profileSaved(userId, data) {
	  return {
	    type: PROFILE_SAVED,
	    userId: userId,
	    payload: data
	  };
	}
	
	function profileSaveError(error) {
	  return {
	    type: PROFILE_SAVE_ERROR,
	    error: error
	  };
	}
	
	function normalizeFormData(data) {
	  var _iteratorNormalCompletion = true;
	  var _didIteratorError = false;
	  var _iteratorError = undefined;
	
	  try {
	    for (var _iterator = _getIterator(_Object$keys(data)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	      var key = _step.value;
	
	      if (typeof data[key] === 'string') {
	        data[key] = data[key].trim();
	      }
	      if (typeof data[key] === 'undefined') {
	        data[key] = false;
	      }
	    }
	  } catch (err) {
	    _didIteratorError = true;
	    _iteratorError = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion && _iterator['return']) {
	        _iterator['return']();
	      }
	    } finally {
	      if (_didIteratorError) {
	        throw _iteratorError;
	      }
	    }
	  }
	}
	
	function saveProfile(userId, registerFormData) {
	  return function (dispatch) {
	    var password = registerFormData.password;
	    var alert = registerFormData.alert;
	    var termsAccepted = registerFormData.termsAccepted;
	    var referrerFirstName = registerFormData.referrerFirstName;
	    var referrerLastName = registerFormData.referrerLastName;
	    var referrerUniqueUrl = registerFormData.referrerUniqueUrl;
	    var referredProgramId = registerFormData.referredProgramId;
	
	    var filteredData = _objectWithoutProperties(registerFormData, ['password', 'alert', 'termsAccepted', 'referrerFirstName', 'referrerLastName', 'referrerUniqueUrl', 'referredProgramId']);
	
	    return new _Promise(function (resolve, reject) {
	      normalizeFormData(filteredData); // Trim strings
	      dispatch(profileSaving(userId, filteredData));
	      _servicesFirebaseRef2['default'].child('users').child(userId).child('profile').set(filteredData, function (error) {
	        if (error) {
	          reject(error);
	        } else {
	          resolve();
	        }
	      });
	    }).then(function () {
	      return new _Promise(function (resolve, reject) {
	        _servicesFirebaseRef2['default'].child('users').child(userId).update({
	          createdAt: _servicesFirebaseRef.TIMESTAMP,
	          updatedAt: _servicesFirebaseRef.TIMESTAMP
	        }, function (error) {
	          if (error) {
	            reject(error);
	          } else {
	            resolve();
	          }
	        });
	      });
	    }).then(function () {
	      (0, _servicesEvents.publishEvent)('Profile Created', _extends({}, filteredData, {
	        // GTM note: required for intercom
	        referrerFirstName: referrerFirstName, referrerLastName: referrerLastName, referrerUniqueUrl: referrerUniqueUrl, referredProgramId: referredProgramId
	      }));
	      dispatch(profileSaved(userId, filteredData));
	      return filteredData;
	    })['catch'](function (error) {
	      dispatch(profileSaveError(error));
	      throw new Error('Profile save error.');
	    });
	  };
	}
	
	function getCurrentProfile(profileRef) {
	  return new _Promise(function (resolve, reject) {
	    var timeout = setTimeout(function () {
	      return reject(new Error("Retrieving profile timed out."));
	    }, 10000);
	    profileRef.once('value', function (dataSnapshot) {
	      clearTimeout(timeout);
	      resolve(dataSnapshot.val());
	    });
	  });
	}
	
	function publishOptInEvent(listId, userId, consent, oldProfile, newProfile) {
	  if (!oldProfile) return;
	  var oldOptIn = oldProfile[listId + 'OptIn'];
	  var newOptIn = newProfile[listId + 'OptIn'];
	  if (oldOptIn === newOptIn) return;
	
	  var payload = {
	    userId: userId,
	    email: newProfile.email,
	    listId: listId,
	    consent: consent,
	    location: "profile"
	  };
	  (0, _servicesEvents.publishEvent)(newOptIn ? 'Subscribed' : 'Unsubscribed', payload);
	}
	
	function updateProfile(userId, formData) {
	  var sendEvents = arguments.length <= 2 || arguments[2] === undefined ? true : arguments[2];
	
	  return function (dispatch) {
	    var alert = formData.alert;
	    var consent = formData.consent;
	
	    var filteredData = _objectWithoutProperties(formData, ['alert', 'consent']);
	
	    normalizeFormData(filteredData); // Trim strings
	    dispatch(profileSaving(userId, filteredData));
	    var profileRef = _servicesFirebaseRef2['default'].child('users').child(userId).child('profile');
	    return _Promise.all([getCurrentProfile(profileRef), profileRef.update(filteredData).then(function () {
	      return filteredData;
	    })]).then(function (results) {
	      return _servicesFirebaseRef2['default'].child('users').child(userId).update({
	        updatedAt: _servicesFirebaseRef.TIMESTAMP
	      }).then(function () {
	        return results;
	      });
	    }).then(function (_ref) {
	      var _ref2 = _slicedToArray(_ref, 2);
	
	      var oldProfile = _ref2[0];
	      var data = _ref2[1];
	
	      if (sendEvents) {
	        (0, _servicesEvents.publishEvent)('Profile Updated', {
	          userId: userId,
	          email: data.email,
	          firstName: data.firstName,
	          lastName: data.lastName,
	          phone: data.phone,
	          country: data.country,
	          stateOrProvince: data.stateOrProvince,
	          cityOrMunicipality: data.cityOrMunicipality,
	          school: data.school,
	          marketingOptIn: data.marketingOptIn,
	          gettingStartedOptIn: data.gettingStartedOptIn,
	          directPromotionOptIn: data.directPromotionOptIn
	        });
	        publishOptInEvent("marketing", userId, "explicit", oldProfile, data);
	        publishOptInEvent("directPromotion", userId, "explicit", oldProfile, data);
	        publishOptInEvent("gettingStarted", userId, consent || "explicit", oldProfile, data);
	      }
	      dispatch(profileSaved(userId, data));
	      return data;
	    })['catch'](function (error) {
	      dispatch(profileSaveError(error));
	      throw new Error('Profile save error.');
	    });
	  };
	}
	
	function onboardingStateUpdate(userId, onboardingState) {
	  return {
	    type: PROFILE_ONBOARDINGSTATE_UPDATED,
	    userId: userId,
	    onboardingState: onboardingState
	  };
	}
	
	function updateOnboardingState(userId, onboardingState) {
	  return function (dispatch) {
	    return _servicesFirebaseRef2['default'].child('users').child(userId).child('profile').update({ onboarding: onboardingState }).then(function () {
	      (0, _servicesEvents.publishEvent)('Onboarding ' + onboardingState, {
	        userId: userId,
	        onboardingState: onboardingState
	      });
	    }).then(function () {
	      dispatch(onboardingStateUpdate(userId, onboardingState));
	    });
	  };
	}
	
	function profileLoading() {
	  return {
	    type: PROFILE_LOADING
	  };
	}
	
	function profileLoaded(profileData) {
	  return {
	    type: PROFILE_LOADED,
	    profileData: profileData
	  };
	}
	
	function profileLoadError(error) {
	  return {
	    type: PROFILE_LOAD_ERROR,
	    error: error
	  };
	}
	
	function loadProfile(userId) {
	  return function (dispatch) {
	    return new _Promise(function (resolve, reject) {
	      dispatch(profileLoading());
	      _servicesFirebaseRef2['default'].child('users').child(userId).once('value', function (data) {
	        resolve(data.val());
	      }, function (error) {
	        reject(error);
	      });
	    }).then(function (userData) {
	      if (userData && userData.isDeleted) {
	        var error = new Error('Profile is deleted.');
	        error.code = 'profile/deleted';
	        throw error;
	      }
	      var profileData = userData && userData.profile;
	      dispatch(profileLoaded(profileData));
	      return profileData;
	    }, function (error) {
	      dispatch(profileLoadError(error));
	      throw new Error('Profile load error.');
	    });
	  };
	}
	
	function bindProfile(userId, refs) {
	  return function (dispatch) {
	    var profileRef = _servicesFirebaseRef2['default'].child('users').child(userId).child('profile');
	    profileRef.on('value', function (snapshot) {
	      var profileData = snapshot.val();
	      dispatch(profileLoaded(profileData));
	    });
	    refs.push(profileRef);
	  };
	}
	
	function unbindProfile(refs) {
	  return function () {
	    refs.forEach(function (savedRef) {
	      savedRef.off();
	    });
	  };
	}

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = __webpack_require__(6)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.getAvailableProgramsForProfile = getAvailableProgramsForProfile;
	exports.getFeaturedProgramsForProfile = getFeaturedProgramsForProfile;
	exports.getProgramsLookup = getProgramsLookup;
	exports.hasFeaturedPrograms = hasFeaturedPrograms;
	exports.getFeaturedProgramIds = getFeaturedProgramIds;
	exports.getFeaturedProgramHelper = getFeaturedProgramHelper;
	
	var _programsIndex = __webpack_require__(69);
	
	var _programsIndex2 = _interopRequireDefault(_programsIndex);
	
	function betaFilter(program, profile) {
	  if (!program.beta) {
	    return true;
	  }
	  return !!profile.tester;
	}
	
	function regionFilter(program, profile) {
	  if (!Array.isArray(program.limitToRegions)) {
	    return true;
	  }
	  var profileRegion = [profile.country, profile.stateOrProvince, profile.cityOrMunicipality].join('/');
	  return program.limitToRegions.some(function (regionFilter) {
	    return profileRegion.indexOf(regionFilter) === 0;
	  });
	}
	
	function featuredOnlyFilter(program /*, profile*/) {
	  return !program.featuredOnly;
	}
	
	function featuredFilter(program, featuredPrograms) {
	  return featuredPrograms.indexOf(program.id) >= 0;
	}
	
	function getAvailableProgramsForProfile(profile) {
	  if (profile.staff) {
	    return _programsIndex2['default'].programList;
	  }
	  return _programsIndex2['default'].programList.filter(function (x) {
	    return betaFilter(x, profile);
	  }).filter(function (x) {
	    return regionFilter(x, profile);
	  }).filter(function (x) {
	    return featuredOnlyFilter(x, profile);
	  });
	}
	
	function getFeaturedProgramsForProfile(profile) {
	  var featuredProgramIds = getFeaturedProgramIds();
	  return _programsIndex2['default'].programList.filter(function (x) {
	    return betaFilter(x, profile);
	  }).filter(function (x) {
	    return regionFilter(x, profile);
	  }).filter(function (x) {
	    return featuredFilter(x, featuredProgramIds);
	  });
	}
	
	function getProgramsLookup() {
	  return _programsIndex2['default'].programLookup;
	}
	
	function hasFeaturedPrograms() {
	  return !!tryGetCookieValue("featuredPrograms");
	}
	
	function getFeaturedProgramIds() {
	  var value = tryGetCookieValue("featuredPrograms");
	  return typeof value === 'string' ? value.split(',') : [];
	}
	
	var ProgramHelper = (function () {
	  function ProgramHelper(program, featuredLanguage) {
	    _classCallCheck(this, ProgramHelper);
	
	    this._program = program;
	    this._featuredLanguage = featuredLanguage;
	  }
	
	  _createClass(ProgramHelper, [{
	    key: 'found',
	    get: function get() {
	      return !!this._program;
	    }
	  }, {
	    key: 'programId',
	    get: function get() {
	      return this._program && this._program.id || '';
	    }
	  }, {
	    key: 'featuredLanguage',
	    get: function get() {
	      if (this._program && this._program.languages && this._program.languages.includes(this._featuredLanguage)) {
	        return this._featuredLanguage;
	      } else {
	        return 'en';
	      }
	    }
	  }]);
	
	  return ProgramHelper;
	})();
	
	function getFeaturedProgramHelper(programId) {
	  var featuredProgramId = programId || getFeaturedProgramIds()[0];
	  var featuredLanguage = tryGetCookieValue("featuredLanguage");
	  return new ProgramHelper(_programsIndex2['default'].programLookup[featuredProgramId], featuredLanguage);
	}

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _Object$defineProperty = __webpack_require__(489)["default"];
	
	exports["default"] = function (obj, key, value) {
	  if (key in obj) {
	    _Object$defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	};
	
	exports.__esModule = true;

/***/ }),
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */
/***/ (function(module, exports) {

	module.exports = "# Title - Short\n\nZERO HEROES\n\n# Title - Long\n\nZERO HEROES\n\n# Description - Short\n\nZERO HEROES  inspires kids as zero waste superheroes to explore our garbage predicament and change their family's waste habits!\n\n# Description - Long\n\nZERO HEROES  inspires kids as zero waste superheroes to explore our garbage predicament and change their family's waste habits!\n\n# Description - Levels\n\n**Modules include:**\n\n* Operation Garbage Watch\n* Operation Love Food, Hate Waste\n* Operation Food Scraps\n* Operation Waste-Free Lunch\n* Operation Buy Smart\n* Operation Green Cycle\n\n# Level 1\nTitle: Operation Garbage Watch\nDescription: *The adventure begins! Why is garbage a problem?* What brings us joy that isn’t about stuff? First mission assignment!\n\n# Level 2\nTitle: Operation Love Food, Hate Waste\nDescription: *Why and how do we waste perfectly good food?* Calculate the relative value of the food families waste. Mission 2: Reduce food waste at home.\n\n# Level 3\nTitle: Operation Food Scraps\nDescription: *Composting and food scraps: why bother?* Play a Sorting Game, write a rap, and get Mission 3: use your food scraps bin!\n\n# Level 4\nTitle: Operation Waste-Free Lunch\nDescription: *What is packaging and what problems does it cause?* {r/Canada:Analyze}{r/:Analyse} today’s lunch. Use math to learn about collective impact. Make a poster and get Mission 4: have a waste-free lunch.\n\n# Level 5\nTitle: Operation Buy Smart\nDescription: *Now that we know all this, how can we buy smarter?* Brainstorm solutions, create buy-smart guidelines, create skits about impulse shopping, and get Mission 5: teach your families to buy smart!\n\n# Level 6\nTitle: Operation Green Cycle\nDescription: *Designing following nature’s design.* Learning about biomimicry: how can we design like nature does? Invent a product that uses biomimicry. Through the art of your choice, share your product with the class.\n"

/***/ }),
/* 112 */,
/* 113 */,
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(97);
	var core = __webpack_require__(42);
	var ctx = __webpack_require__(770);
	var hide = __webpack_require__(146);
	var has = __webpack_require__(115);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var IS_WRAP = type & $export.W;
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE];
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
	  var key, own, out;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    if (own && has(exports, key)) continue;
	    // export native or passed
	    out = own ? target[key] : source[key];
	    // prevent global pollution for namespaces
	    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
	    // bind timers to global for call from export context
	    : IS_BIND && own ? ctx(out, global)
	    // wrap global constructors for prevent change them in library
	    : IS_WRAP && target[key] == out ? (function (C) {
	      var F = function (a, b, c) {
	        if (this instanceof C) {
	          switch (arguments.length) {
	            case 0: return new C();
	            case 1: return new C(a);
	            case 2: return new C(a, b);
	          } return new C(a, b, c);
	        } return C.apply(this, arguments);
	      };
	      F[PROTOTYPE] = C[PROTOTYPE];
	      return F;
	    // make static versions for prototype methods
	    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
	    if (IS_PROTO) {
	      (exports.virtual || (exports.virtual = {}))[key] = out;
	      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
	      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
	    }
	  }
	};
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ }),
/* 115 */
/***/ (function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(191);
	var IE8_DOM_DEFINE = __webpack_require__(772);
	var toPrimitive = __webpack_require__(373);
	var dP = Object.defineProperty;
	
	exports.f = __webpack_require__(96) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};


/***/ }),
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1277);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(13)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../css-loader/index.js!./react-spinner.css", function() {
				var newContent = require("!!../../css-loader/index.js!./react-spinner.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _esSymbol = __webpack_require__(238);
	
	var _esSymbol2 = _interopRequireDefault(_esSymbol);
	
	// action creator handler
	var ACTION_HANDLER = (0, _esSymbol2['default'])();
	
	exports.ACTION_HANDLER = ACTION_HANDLER;
	// the action's uid symbol for listening
	var ACTION_KEY = (0, _esSymbol2['default'])();
	
	exports.ACTION_KEY = ACTION_KEY;
	// per instance registry of actions
	var ACTIONS_REGISTRY = (0, _esSymbol2['default'])();
	
	exports.ACTIONS_REGISTRY = ACTIONS_REGISTRY;
	// the action's name
	var ACTION_UID = (0, _esSymbol2['default'])();
	
	exports.ACTION_UID = ACTION_UID;
	// store all of a store's listeners
	var ALL_LISTENERS = (0, _esSymbol2['default'])();
	
	exports.ALL_LISTENERS = ALL_LISTENERS;
	// are we handling our own errors
	var HANDLING_ERRORS = (0, _esSymbol2['default'])();
	
	exports.HANDLING_ERRORS = HANDLING_ERRORS;
	// initial snapshot
	var INIT_SNAPSHOT = (0, _esSymbol2['default'])();
	
	exports.INIT_SNAPSHOT = INIT_SNAPSHOT;
	// last snapshot
	var LAST_SNAPSHOT = (0, _esSymbol2['default'])();
	
	exports.LAST_SNAPSHOT = LAST_SNAPSHOT;
	// all lifecycle listeners
	var LIFECYCLE = (0, _esSymbol2['default'])();
	
	exports.LIFECYCLE = LIFECYCLE;
	// store action listeners
	var LISTENERS = (0, _esSymbol2['default'])();
	
	exports.LISTENERS = LISTENERS;
	// public methods
	var PUBLIC_METHODS = (0, _esSymbol2['default'])();
	
	exports.PUBLIC_METHODS = PUBLIC_METHODS;
	// contains all state
	var STATE_CONTAINER = (0, _esSymbol2['default'])();
	exports.STATE_CONTAINER = STATE_CONTAINER;

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = __webpack_require__(7)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	function headingSlide(_ref) {
	  var id = _ref.id;
	  var bgColor = _ref.bgColor;
	  var notes = _ref.notes;
	  var heading = _ref.heading;
	  var subHeading = _ref.subHeading;
	  var beforeImage = _ref.beforeImage;
	  var afterImage = _ref.afterImage;
	  var slideClass = _ref.slideClass;
	
	  var slideContentClass = slideClass ? ' slide-' + slideClass : '';
	  var bgColorOpts = {};
	  if (bgColor) {
	    bgColorOpts.bgColor = bgColor;
	  }
	  return _react2['default'].createElement(
	    _spectaclePpa.Slide,
	    _extends({
	      id: id,
	      key: id
	    }, bgColorOpts, {
	      notes: notes }),
	    _react2['default'].createElement(
	      'div',
	      { className: 'slide-content' + slideContentClass },
	      !!beforeImage && _react2['default'].createElement(
	        'div',
	        { className: 'flex-image' },
	        _react2['default'].createElement('img', {
	          className: 'heading-image heading-image-before',
	          src: beforeImage })
	      ),
	      _react2['default'].createElement(
	        'div',
	        { className: 'text-heading' },
	        _react2['default'].createElement(
	          _spectaclePpa.Heading,
	          { size: 2 },
	          _react2['default'].createElement('div', { dangerouslySetInnerHTML: { __html: heading } })
	        ),
	        !!subHeading && _react2['default'].createElement(
	          _spectaclePpa.Heading,
	          { size: 3 },
	          _react2['default'].createElement('div', { dangerouslySetInnerHTML: { __html: subHeading } })
	        )
	      ),
	      !!afterImage && _react2['default'].createElement('img', {
	        className: 'heading-image heading-image-after',
	        src: afterImage })
	    )
	  );
	}
	
	exports['default'] = headingSlide;
	module.exports = exports['default'];

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _taggedTemplateLiteral = __webpack_require__(28)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.preloadStart = preloadStart;
	
	var _templateObject = _taggedTemplateLiteral(['Level ', ''], ['Level ', '']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _helpersMarkdownScript = __webpack_require__(9);
	
	var _helpersMarkdownScript2 = _interopRequireDefault(_helpersMarkdownScript);
	
	var _helpersI18n = __webpack_require__(14);
	
	var _imagesPpa_presentsPng = __webpack_require__(2463);
	
	var _imagesPpa_presentsPng2 = _interopRequireDefault(_imagesPpa_presentsPng);
	
	var _imagesPpa_presentsFr_CAPng = __webpack_require__(2462);
	
	var _imagesPpa_presentsFr_CAPng2 = _interopRequireDefault(_imagesPpa_presentsFr_CAPng);
	
	var _imagesKeepCoolNoPPAPresentsPng = __webpack_require__(2453);
	
	var _imagesKeepCoolNoPPAPresentsPng2 = _interopRequireDefault(_imagesKeepCoolNoPPAPresentsPng);
	
	var _imagesKeepCoolNoPPAPresentsFr_CAPng = __webpack_require__(2452);
	
	var _imagesKeepCoolNoPPAPresentsFr_CAPng2 = _interopRequireDefault(_imagesKeepCoolNoPPAPresentsFr_CAPng);
	
	var _startMd = __webpack_require__(1759);
	
	var _startMd2 = _interopRequireDefault(_startMd);
	
	var _startFr_CAMd = __webpack_require__(1758);
	
	var _startFr_CAMd2 = _interopRequireDefault(_startFr_CAMd);
	
	var _imagesLevel1_startPng = __webpack_require__(903);
	
	var _imagesLevel1_startPng2 = _interopRequireDefault(_imagesLevel1_startPng);
	
	var _imagesLevel2_startPng = __webpack_require__(441);
	
	var _imagesLevel2_startPng2 = _interopRequireDefault(_imagesLevel2_startPng);
	
	var _imagesLevel3_startPng = __webpack_require__(442);
	
	var _imagesLevel3_startPng2 = _interopRequireDefault(_imagesLevel3_startPng);
	
	var _imagesLevel4_startPng = __webpack_require__(443);
	
	var _imagesLevel4_startPng2 = _interopRequireDefault(_imagesLevel4_startPng);
	
	var _imagesLevel5_startPng = __webpack_require__(444);
	
	var _imagesLevel5_startPng2 = _interopRequireDefault(_imagesLevel5_startPng);
	
	var _imagesLevel6_startPng = __webpack_require__(904);
	
	var _imagesLevel6_startPng2 = _interopRequireDefault(_imagesLevel6_startPng);
	
	var imagePPALogo = (0, _helpersI18n.i18nData)({
	  en: _imagesPpa_presentsPng2['default'],
	  fr_CA: _imagesPpa_presentsFr_CAPng2['default']
	});
	
	var imageKCLogo = (0, _helpersI18n.i18nData)({
	  en: _imagesKeepCoolNoPPAPresentsPng2['default'],
	  fr_CA: _imagesKeepCoolNoPPAPresentsFr_CAPng2['default']
	});
	
	var levels = {
	  '1': { img: _imagesLevel1_startPng2['default'] },
	  '2': { img: _imagesLevel2_startPng2['default'] },
	  '3': { img: _imagesLevel3_startPng2['default'] },
	  '4': { img: _imagesLevel4_startPng2['default'] },
	  '5': { img: _imagesLevel5_startPng2['default'] },
	  '6': { img: _imagesLevel6_startPng2['default'] }
	};
	
	var md = (0, _helpersI18n.i18nData)({
	  en: new _helpersMarkdownScript2['default'](_startMd2['default']),
	  fr_CA: new _helpersMarkdownScript2['default'](_startFr_CAMd2['default'])
	});
	
	function preloadStart() {
	  (0, _spectaclePpa.preloader)([_imagesPpa_presentsPng2['default'], _imagesPpa_presentsFr_CAPng2['default'], _imagesKeepCoolNoPPAPresentsPng2['default'], _imagesKeepCoolNoPPAPresentsFr_CAPng2['default'], _imagesLevel1_startPng2['default'], _imagesLevel2_startPng2['default'], _imagesLevel3_startPng2['default'], _imagesLevel4_startPng2['default'], _imagesLevel5_startPng2['default'], _imagesLevel6_startPng2['default']]);
	}
	
	function startSection(_ref) {
	  var level = _ref.level;
	  var title = _ref.title;
	  var regionData = _ref.regionData;
	  var _ = _ref.i18n;
	
	  var md_i18n = _(md);
	  /* Level intro graphic */
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'start' },
	    _react2['default'].createElement(
	      _spectaclePpa.Slide,
	      {
	        id: 'ppa-presents',
	        key: 'ppa-presents',
	        bgColor: 'black',
	        notes: md_i18n.getSubSectionAsHtml('Level ' + level + ' Start', 'Notes', false, regionData) },
	      _react2['default'].createElement(
	        'div',
	        {
	          className: 'ui-slide' },
	        _react2['default'].createElement(
	          'div',
	          { className: 'flex-image' },
	          _react2['default'].createElement('img', {
	            className: 'heading-image heading-image-before',
	            src: _(imagePPALogo) })
	        )
	      )
	    ),
	    _react2['default'].createElement(
	      _spectaclePpa.Slide,
	      {
	        id: 'ppa-kc',
	        key: 'ppa-kc',
	        bgColor: 'black',
	        notes: md_i18n.getSubSectionAsHtml('Level ' + level + ' Start', 'Notes', false, regionData) },
	      _react2['default'].createElement(
	        'div',
	        {
	          className: 'ui-slide' },
	        _react2['default'].createElement(
	          'div',
	          { className: 'flex-image' },
	          _react2['default'].createElement('img', { className: 'kc-logo heading-image',
	            src: _(imageKCLogo) })
	        )
	      )
	    ),
	    _react2['default'].createElement(
	      _spectaclePpa.Slide,
	      {
	        id: 'level',
	        key: 'level',
	        bgColor: 'black',
	        notes: md_i18n.getSubSectionAsHtml('Level ' + level + ' Icon', 'Notes', false, regionData) },
	      _react2['default'].createElement(
	        'div',
	        {
	          className: 'ui-slide' },
	        _react2['default'].createElement(
	          'div',
	          { className: 'title-image' },
	          _react2['default'].createElement('img', {
	            className: 'heading-image heading-image-before',
	            src: levels[level].img }),
	          _react2['default'].createElement(
	            _spectaclePpa.Heading,
	            { size: 1 },
	            _react2['default'].createElement(
	              'strong',
	              null,
	              _(title)
	            )
	          ),
	          _react2['default'].createElement(
	            _spectaclePpa.Heading,
	            { size: 2 },
	            _react2['default'].createElement(
	              'strong',
	              null,
	              _(_templateObject, level)
	            )
	          )
	        )
	      )
	    )
	  );
	}
	
	exports['default'] = startSection;
	/* Sanksrit for Vanessa */ /* lokah samastah sukhino bhavantu */ /* may all beings everywhere be at peace */

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.preloadSong = preloadSong;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _helpersI18n = __webpack_require__(14);
	
	var _baseSlidesVideoSlide = __webpack_require__(59);
	
	var _baseSlidesVideoSlide2 = _interopRequireDefault(_baseSlidesVideoSlide);
	
	var _baseSlidesBalloonSlide = __webpack_require__(70);
	
	var _baseSlidesBalloonSlide2 = _interopRequireDefault(_baseSlidesBalloonSlide);
	
	var _imagesCharactersApprenticesPosingPng = __webpack_require__(2439);
	
	var _imagesCharactersApprenticesPosingPng2 = _interopRequireDefault(_imagesCharactersApprenticesPosingPng);
	
	var _imagesCharactersApprenticesFlexArmsPng = __webpack_require__(901);
	
	var _imagesCharactersApprenticesFlexArmsPng2 = _interopRequireDefault(_imagesCharactersApprenticesFlexArmsPng);
	
	var _helpersMarkdownScript = __webpack_require__(9);
	
	var _helpersMarkdownScript2 = _interopRequireDefault(_helpersMarkdownScript);
	
	var _songMd = __webpack_require__(1761);
	
	var _songMd2 = _interopRequireDefault(_songMd);
	
	var _songFr_CAMd = __webpack_require__(1760);
	
	var _songFr_CAMd2 = _interopRequireDefault(_songFr_CAMd);
	
	var md = (0, _helpersI18n.i18nData)({
	  en: new _helpersMarkdownScript2['default'](_songMd2['default']),
	  fr_CA: new _helpersMarkdownScript2['default'](_songFr_CAMd2['default'])
	});
	
	function preloadSong() {
	  (0, _spectaclePpa.preloader)([_imagesCharactersApprenticesPosingPng2['default'], _imagesCharactersApprenticesFlexArmsPng2['default']]);
	}
	
	function songSection(_ref) {
	  var level = _ref.level;
	  var regionData = _ref.regionData;
	  var i18n = _ref.i18n;
	
	  var md_i18n = i18n(md);
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'song' },
	    (level === 2 || level === 4 || level === 6) && (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'song-intro',
	      characterSide: 'right',
	      characterImage: _imagesCharactersApprenticesPosingPng2['default'],
	      html: md_i18n.getSubSectionAsHtml('Level ' + level + ' Intro', 'Content', false, regionData),
	      notes: md_i18n.getSubSectionAsHtml('Level ' + level + ' Intro', 'Notes', false, regionData)
	    }),
	    (level === 1 || level === 3 || level === 5) && (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'intro',
	      characterSide: 'right',
	      characterImage: _imagesCharactersApprenticesFlexArmsPng2['default'],
	      html: md_i18n.getSubSectionAsHtml('Level ' + level + ' Intro', 'Content', false, regionData),
	      notes: md_i18n.getSubSectionAsHtml('Level ' + level + ' Intro', 'Notes', false, regionData)
	    }),
	    (0, _baseSlidesVideoSlide2['default'])({
	      id: 'video',
	      notes: md_i18n.getSubSectionAsHtml('Song', 'Notes', false, regionData),
	      youTubeId: md_i18n.getSectionMetadata('Song', 'YouTube', regionData)
	    })
	  );
	}
	
	exports['default'] = songSection;
	/* Speech bubble in levels 2,4,6 */ /* Speech bubble in levels 1,3,5 */ /* Song */

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

	/* eslint react/no-multi-comp: 0, no-unused-vars: 0 */
	
	'use strict';
	
	var _taggedTemplateLiteral = __webpack_require__(28)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.preloadGameShow = preloadGameShow;
	
	var _templateObject = _taggedTemplateLiteral(['Question ', ' of ', ''], ['Question ', ' of ', '']),
	    _templateObject2 = _taggedTemplateLiteral(['Answer ', ' of ', ''], ['Answer ', ' of ', '']),
	    _templateObject3 = _taggedTemplateLiteral(['Level ', ' game show completed'], ['Level ', ' game show completed']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _helpersI18n = __webpack_require__(14);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _srcServicesRegionalization = __webpack_require__(38);
	
	var _srcServicesRegionalization2 = _interopRequireDefault(_srcServicesRegionalization);
	
	var _baseSlidesBalloonSlide = __webpack_require__(70);
	
	var _baseSlidesBalloonSlide2 = _interopRequireDefault(_baseSlidesBalloonSlide);
	
	var _baseSlidesHeadingSlide = __webpack_require__(170);
	
	var _baseSlidesHeadingSlide2 = _interopRequireDefault(_baseSlidesHeadingSlide);
	
	var _baseSlidesVideoSlide = __webpack_require__(59);
	
	var _baseSlidesVideoSlide2 = _interopRequireDefault(_baseSlidesVideoSlide);
	
	var _title_gameshowPng = __webpack_require__(2465);
	
	var _title_gameshowPng2 = _interopRequireDefault(_title_gameshowPng);
	
	var _title_gameshowFr_CAPng = __webpack_require__(2464);
	
	var _title_gameshowFr_CAPng2 = _interopRequireDefault(_title_gameshowFr_CAPng);
	
	var _title_gameshow_playersPng = __webpack_require__(2467);
	
	var _title_gameshow_playersPng2 = _interopRequireDefault(_title_gameshow_playersPng);
	
	var _title_gameshow_playersFr_CAPng = __webpack_require__(2466);
	
	var _title_gameshow_playersFr_CAPng2 = _interopRequireDefault(_title_gameshow_playersFr_CAPng);
	
	var _imagesCharactersApprenticesPairArmsFoldedPng = __webpack_require__(2438);
	
	var _imagesCharactersApprenticesPairArmsFoldedPng2 = _interopRequireDefault(_imagesCharactersApprenticesPairArmsFoldedPng);
	
	var _imagesCharactersApprenticePointingUp2Png = __webpack_require__(2435);
	
	var _imagesCharactersApprenticePointingUp2Png2 = _interopRequireDefault(_imagesCharactersApprenticePointingUp2Png);
	
	var _imagesCharactersApprenticePointingUp3Png = __webpack_require__(2436);
	
	var _imagesCharactersApprenticePointingUp3Png2 = _interopRequireDefault(_imagesCharactersApprenticePointingUp3Png);
	
	var _imagesCharactersApprenticesFlexArmsPng = __webpack_require__(901);
	
	var _imagesCharactersApprenticesFlexArmsPng2 = _interopRequireDefault(_imagesCharactersApprenticesFlexArmsPng);
	
	var _imagesCharactersApprenticeFistUpPng = __webpack_require__(2431);
	
	var _imagesCharactersApprenticeFistUpPng2 = _interopRequireDefault(_imagesCharactersApprenticeFistUpPng);
	
	var _imagesCharactersApprenticeHandsHips2Png = __webpack_require__(2433);
	
	var _imagesCharactersApprenticeHandsHips2Png2 = _interopRequireDefault(_imagesCharactersApprenticeHandsHips2Png);
	
	var _imagesCharactersApprenticeCuriousPng = __webpack_require__(2430);
	
	var _imagesCharactersApprenticeCuriousPng2 = _interopRequireDefault(_imagesCharactersApprenticeCuriousPng);
	
	var _imagesCharactersApprenticePointingDiagonalPng = __webpack_require__(900);
	
	var _imagesCharactersApprenticePointingDiagonalPng2 = _interopRequireDefault(_imagesCharactersApprenticePointingDiagonalPng);
	
	var _helpersMarkdownScript = __webpack_require__(9);
	
	var _helpersMarkdownScript2 = _interopRequireDefault(_helpersMarkdownScript);
	
	var _level1_climateMd = __webpack_require__(1773);
	
	var _level1_climateMd2 = _interopRequireDefault(_level1_climateMd);
	
	var _level1_climateFr_CAMd = __webpack_require__(1772);
	
	var _level1_climateFr_CAMd2 = _interopRequireDefault(_level1_climateFr_CAMd);
	
	var _level2_darkroomMd = __webpack_require__(1775);
	
	var _level2_darkroomMd2 = _interopRequireDefault(_level2_darkroomMd);
	
	var _level2_darkroomFr_CAMd = __webpack_require__(1774);
	
	var _level2_darkroomFr_CAMd2 = _interopRequireDefault(_level2_darkroomFr_CAMd);
	
	var _level3_showerPowerMd = __webpack_require__(1777);
	
	var _level3_showerPowerMd2 = _interopRequireDefault(_level3_showerPowerMd);
	
	var _level3_showerPowerFr_CAMd = __webpack_require__(1776);
	
	var _level3_showerPowerFr_CAMd2 = _interopRequireDefault(_level3_showerPowerFr_CAMd);
	
	var _level4_keepCarCoolMd = __webpack_require__(1779);
	
	var _level4_keepCarCoolMd2 = _interopRequireDefault(_level4_keepCarCoolMd);
	
	var _level4_keepCarCoolFr_CAMd = __webpack_require__(1778);
	
	var _level4_keepCarCoolFr_CAMd2 = _interopRequireDefault(_level4_keepCarCoolFr_CAMd);
	
	var _level5_goCarFreeMd = __webpack_require__(1781);
	
	var _level5_goCarFreeMd2 = _interopRequireDefault(_level5_goCarFreeMd);
	
	var _level5_goCarFreeFr_CAMd = __webpack_require__(1780);
	
	var _level5_goCarFreeFr_CAMd2 = _interopRequireDefault(_level5_goCarFreeFr_CAMd);
	
	var imageGameshowTitle = (0, _helpersI18n.i18nData)({
	  en: _title_gameshowPng2['default'],
	  fr_CA: _title_gameshowFr_CAPng2['default']
	});
	
	var imageGameshowPlayers = (0, _helpersI18n.i18nData)({
	  en: _title_gameshow_playersPng2['default'],
	  fr_CA: _title_gameshow_playersFr_CAPng2['default']
	});
	
	var markdownFileLevel1 = (0, _helpersI18n.i18nData)({
	  en: new _helpersMarkdownScript2['default'](_level1_climateMd2['default']),
	  fr_CA: new _helpersMarkdownScript2['default'](_level1_climateFr_CAMd2['default'])
	});
	var markdownFileLevel2 = (0, _helpersI18n.i18nData)({
	  en: new _helpersMarkdownScript2['default'](_level2_darkroomMd2['default']),
	  fr_CA: new _helpersMarkdownScript2['default'](_level2_darkroomFr_CAMd2['default'])
	});
	var markdownFileLevel3 = (0, _helpersI18n.i18nData)({
	  en: new _helpersMarkdownScript2['default'](_level3_showerPowerMd2['default']),
	  fr_CA: new _helpersMarkdownScript2['default'](_level3_showerPowerFr_CAMd2['default'])
	});
	var markdownFileLevel4 = (0, _helpersI18n.i18nData)({
	  en: new _helpersMarkdownScript2['default'](_level4_keepCarCoolMd2['default']),
	  fr_CA: new _helpersMarkdownScript2['default'](_level4_keepCarCoolFr_CAMd2['default'])
	});
	var markdownFileLevel5 = (0, _helpersI18n.i18nData)({
	  en: new _helpersMarkdownScript2['default'](_level5_goCarFreeMd2['default']),
	  fr_CA: new _helpersMarkdownScript2['default'](_level5_goCarFreeFr_CAMd2['default'])
	});
	
	var levels = {
	  '1': { md: markdownFileLevel1 },
	  '2': { md: markdownFileLevel2 },
	  '3': { md: markdownFileLevel3 },
	  '4': { md: markdownFileLevel4 },
	  '5': { md: markdownFileLevel5 }
	};
	
	function preloadGameShow() {
	  (0, _spectaclePpa.preloader)([_title_gameshowPng2['default'], _title_gameshowFr_CAPng2['default'], _title_gameshow_playersPng2['default'], _title_gameshow_playersFr_CAPng2['default'], _imagesCharactersApprenticesPairArmsFoldedPng2['default'], _imagesCharactersApprenticePointingUp2Png2['default'], _imagesCharactersApprenticesFlexArmsPng2['default'], _imagesCharactersApprenticePointingUp3Png2['default'], _imagesCharactersApprenticeFistUpPng2['default'], _imagesCharactersApprenticeCuriousPng2['default'], _imagesCharactersApprenticeHandsHips2Png2['default']]);
	}
	
	function intro(level, regionData, md) {
	  return (0, _baseSlidesVideoSlide2['default'])({
	    id: 'intro',
	    notes: md.getSubSectionAsHtml('Intro Video', 'Notes', false, regionData),
	    youTubeId: md.getSectionMetadata('Intro Video', 'YouTube', regionData)
	  });
	}
	
	function sizzle(level, regionData, md, i18n) {
	  return (0, _baseSlidesHeadingSlide2['default'])({
	    id: 'sizzle',
	    bgColor: '#742CBF',
	    afterImage: i18n(imageGameshowTitle),
	    notes: md.getSubSectionAsHtml('Sizzle', 'Notes', false, regionData)
	  });
	}
	
	function scoring(level, regionData, md) {
	  return (0, _baseSlidesBalloonSlide2['default'])({
	    id: 'scoring',
	    characterSide: 'right',
	    characterImage: _imagesCharactersApprenticeHandsHips2Png2['default'],
	    notes: md.getSubSectionAsHtml('Scoring', 'Notes', false, regionData),
	    html: md.getSubSectionAsHtml('Scoring', 'Content', false, regionData),
	    bgColor: '#742CBF'
	  });
	}
	
	function bonusAction(level, regionData, md) {
	  return (0, _baseSlidesBalloonSlide2['default'])({
	    id: 'bonus-action',
	    characterSide: 'right',
	    characterImage: _imagesCharactersApprenticesFlexArmsPng2['default'],
	    notes: md.getSubSectionAsHtml('Bonus Action', 'Notes', false, regionData),
	    html: md.getSubSectionAsHtml('Bonus Action', 'Content', false, regionData),
	    bgColor: '#742CBF'
	  });
	}
	
	function questionSlide(_ref) {
	  var level = _ref.level;
	  var questionNumber = _ref.questionNumber;
	  var numQuestions = _ref.numQuestions;
	  var md = _ref.md;
	  var questionCharacterImage = _ref.questionCharacterImage;
	  var answerCharacterImage = _ref.answerCharacterImage;
	  var regionData = _ref.regionData;
	  var i18n = _ref.i18n;
	
	  var _ = i18n;
	  var questionSection = 'Question ' + questionNumber;
	  var defaultRegion = md.getSectionMetadata(questionSection, 'Default Region', regionData);
	  var questionCharacter = !questionCharacterImage ? _imagesCharactersApprenticeCuriousPng2['default'] : questionCharacterImage;
	  var answerCharacter = !answerCharacterImage ? _imagesCharactersApprenticePointingUp3Png2['default'] : answerCharacterImage;
	  var answer = undefined;
	  if (defaultRegion) {
	    answer = md.getSubSectionAsHtml(questionSection, 'Answer - ' + defaultRegion, false, regionData);
	  } else {
	    answer = md.getSubSectionAsHtml(questionSection, 'Answer', false, regionData);
	  }
	  var answerNotes = md.getSubSectionAsHtml(questionSection, 'Answer Notes', false, regionData);
	
	  return [
	
	  // four players announcement
	  (0, _baseSlidesHeadingSlide2['default'])({
	    id: questionNumber + '-four-players',
	    afterImage: i18n(imageGameshowPlayers),
	    bgColor: 'black',
	    notes: '<h2>' + _(_templateObject, questionNumber, numQuestions) + ':</h2>' + md.getSubSectionAsHtml('Four Players Announcement', 'Notes', false, regionData)
	  }),
	
	  // video explanation of question
	  (0, _baseSlidesVideoSlide2['default'])({
	    id: questionNumber + '-video',
	    notes: md.getSubSectionAsHtml('Question ' + questionNumber, 'Video Notes', false, regionData),
	    youTubeId: md.getSectionMetadata('Question ' + questionNumber, 'YouTube', regionData)
	  }),
	
	  // answer slide
	  (0, _baseSlidesBalloonSlide2['default'])({
	    balloonType: 'answer',
	    characterSide: 'right',
	    characterImage: answerCharacter,
	    questionNumber: questionNumber,
	    id: questionNumber + '-answer',
	    html: answer,
	    notes: '<h2>' + _(_templateObject2, questionNumber, numQuestions) + '</h2>' + '<br />' + (!answerNotes.match(/SKIP/) ? md.getSubSectionAsHtml(questionSection, 'Answer Notes', false, regionData) : ''),
	    i18n: i18n
	  })];
	}
	
	function endOfGameShow(level, /*i18n*/_) {
	  return (0, _baseSlidesBalloonSlide2['default'])({
	    id: 'end',
	    characterSide: 'left',
	    characterImage: _imagesCharactersApprenticeFistUpPng2['default'],
	    bgColor: '#742CBF',
	    html: '<h3>' + _(_templateObject3, level) + '!</h3>',
	    notes: _('Game show completed') + '.'
	  });
	}
	
	function level1(regionData, i18n) {
	  var level = 1;
	  var md = i18n(levels[level].md);
	
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'game-show' },
	    intro(level, regionData, md),
	    (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'keep-cool-song-intro',
	      characterSide: 'right',
	      characterImage: _imagesCharactersApprenticesPairArmsFoldedPng2['default'],
	      notes: md.getSubSectionAsHtml('Keep Cool Song Intro', 'Notes', false, regionData),
	      html: md.getSubSectionAsHtml('Keep Cool Song Intro', 'Content', false, regionData),
	      bgColor: '#742CBF'
	    }),
	    (0, _baseSlidesVideoSlide2['default'])({
	      id: 'keep-cool-song-video',
	      notes: md.getSubSectionAsHtml('Keep Cool Song Video', 'Notes', false, regionData),
	      youTubeId: md.getSectionMetadata('Keep Cool Song Video', 'YouTube', regionData),
	      lowRes: md.getSectionMetadata('Keep Cool Song Video', 'LowRes', regionData)
	    }),
	    sizzle(level, regionData, md, i18n),
	    scoring(level, regionData, md),
	    bonusAction(level, regionData, md),
	    questionSlide({ level: level, questionNumber: 1, numQuestions: 4, md: md, regionData: regionData, i18n: i18n }),
	    (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'scoring-reminder',
	      characterSide: 'right',
	      characterImage: _imagesCharactersApprenticePointingDiagonalPng2['default'],
	      notes: md.getSubSectionAsHtml('Scoring Reminder', 'Notes', false, regionData),
	      html: md.getSubSectionAsHtml('Scoring Reminder', 'Content', false, regionData),
	      bgColor: '#742CBF'
	    }),
	    questionSlide({ level: level, questionNumber: 2, numQuestions: 4, md: md, regionData: regionData, i18n: i18n }),
	    questionSlide({ level: level, questionNumber: 3, numQuestions: 4, md: md, regionData: regionData, i18n: i18n }),
	    questionSlide({ level: level, questionNumber: 4, numQuestions: 4, md: md, regionData: regionData, i18n: i18n }),
	    endOfGameShow(level, i18n)
	  );
	}
	
	function level2(regionData, i18n) {
	  var level = 2;
	  var md = i18n(levels[level].md);
	
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'game-show' },
	    intro(level, regionData, md),
	    sizzle(level, regionData, md, i18n),
	    scoring(level, regionData, md),
	    bonusAction(level, regionData, md),
	    questionSlide({ level: level, questionNumber: 1, numQuestions: 3, md: md, regionData: regionData, i18n: i18n }),
	    (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'scoring-reminder',
	      characterSide: 'left',
	      characterImage: _imagesCharactersApprenticePointingDiagonalPng2['default'],
	      notes: md.getSubSectionAsHtml('Scoring Reminder', 'Notes', false, regionData),
	      html: md.getSubSectionAsHtml('Scoring Reminder', 'Content', false, regionData),
	      bgColor: '#742CBF'
	    }),
	    questionSlide({ level: level, questionNumber: 2, numQuestions: 3, md: md, regionData: regionData, i18n: i18n }),
	    questionSlide({ level: level, questionNumber: 3, numQuestions: 3, md: md, regionData: regionData, i18n: i18n }),
	    endOfGameShow(level, i18n)
	  );
	}
	
	function level3(regionData, i18n) {
	  var level = 3;
	  var md = i18n(levels[level].md);
	
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'game-show' },
	    intro(level, regionData, md),
	    sizzle(level, regionData, md, i18n),
	    bonusAction(level, regionData, md),
	    questionSlide({ level: level, questionNumber: 1, numQuestions: 3, md: md, regionData: regionData, i18n: i18n }),
	    questionSlide({ level: level, questionNumber: 2, numQuestions: 3, md: md, regionData: regionData, i18n: i18n }),
	    questionSlide({ level: level, questionNumber: 3, numQuestions: 3, md: md, regionData: regionData, i18n: i18n }),
	    endOfGameShow(level, i18n)
	  );
	}
	
	function level4(regionData, i18n) {
	  var level = 4;
	  var md = i18n(levels[level].md);
	
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'game-show' },
	    intro(level, regionData, md),
	    sizzle(level, regionData, md, i18n),
	    bonusAction(level, regionData, md),
	    questionSlide({ level: level, questionNumber: 1, numQuestions: 5, md: md, regionData: regionData, i18n: i18n }),
	    questionSlide({ level: level, questionNumber: 2, numQuestions: 5, md: md, regionData: regionData, i18n: i18n }),
	    questionSlide({ level: level, questionNumber: 3, numQuestions: 5, md: md, regionData: regionData, i18n: i18n }),
	    questionSlide({ level: level, questionNumber: 4, numQuestions: 5, md: md, regionData: regionData, i18n: i18n }),
	    questionSlide({ level: level, questionNumber: 5, numQuestions: 5, md: md, regionData: regionData, i18n: i18n }),
	    endOfGameShow(level, i18n)
	  );
	}
	
	function level5(regionData, i18n) {
	  var level = 5;
	  var md = i18n(levels[level].md);
	
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'game-show' },
	    (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'webisode-intro',
	      characterSide: 'right',
	      characterImage: _imagesCharactersApprenticesPairArmsFoldedPng2['default'],
	      notes: md.getSubSectionAsHtml('EPP Webisode Intro', 'Notes', false, regionData),
	      html: md.getSubSectionAsHtml('EPP Webisode Intro', 'Content', false, regionData),
	      bgColor: '#742CBF'
	    }),
	    (0, _baseSlidesVideoSlide2['default'])({
	      id: 'webisode-video',
	      notes: md.getSubSectionAsHtml('EPP Webisode Video', 'Notes', false, regionData),
	      youTubeId: md.getSectionMetadata('EPP Webisode Video', 'YouTube', regionData),
	      lowRes: md.getSectionMetadata('EPP Webisode Video', 'LowRes', regionData)
	    }),
	    intro(level, regionData, md),
	    sizzle(level, regionData, md, i18n),
	    bonusAction(level, regionData, md),
	    questionSlide({ level: level, questionNumber: 1, numQuestions: 4, md: md, regionData: regionData, i18n: i18n }),
	    questionSlide({ level: level, questionNumber: 2, numQuestions: 4, md: md, regionData: regionData, i18n: i18n }),
	    questionSlide({ level: level, questionNumber: 3, numQuestions: 4, md: md, regionData: regionData, i18n: i18n }),
	    questionSlide({ level: level, questionNumber: 4, numQuestions: 4, md: md, regionData: regionData, i18n: i18n }),
	    endOfGameShow(level, i18n)
	  );
	}
	
	function gameShowSection(_ref2) {
	  var level = _ref2.level;
	  var regionData = _ref2.regionData;
	  var i18n = _ref2.i18n;
	
	  switch (level) {
	    case 1:
	      return level1(regionData, i18n);
	    case 2:
	      return level2(regionData, i18n);
	    case 3:
	      return level3(regionData, i18n);
	    case 4:
	      return level4(regionData, i18n);
	    case 5:
	      return level5(regionData, i18n);
	    default:
	      return (0, _baseSlidesHeadingSlide2['default'])({ heading: 'Unknown' });
	  }
	}
	
	exports['default'] = gameShowSection;
	/* Sara and Ian introduce the Game Show */ /* Keep Cool Song Intro */ /* Keep Cool Song Video */ /* Sizzle */ /* Scoring intro */ /* Bonus action */ /* Game show questions */ /* Scoring reminder */ /* End of Game Show */ /* Sara and Ian introduce the Game Show */ /* Sizzle */ /* Scoring intro */ /* Bonus action */ /* Game show questions */ /* Scoring reminder */ /* End of Game Show */ /* Sara and Ian introduce the Game Show */ /* Sizzle */ /* Bonus action */ /* Game show questions */ /* End of Game Show */ /* Sara and Ian introduce the Game Show */ /* Sizzle */ /* Bonus action */ /* Game show questions */ /* End of Game Show */ /* EPP Webisode Intro */ /* EPP Webisode Video */ /* Sara and Ian introduce the Game Show */ /* Sizzle */ /* Bonus action */ /* Game show questions */ /* End of Game Show */

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _helpersI18n = __webpack_require__(14);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _baseSlidesVideoSlide = __webpack_require__(59);
	
	var _baseSlidesVideoSlide2 = _interopRequireDefault(_baseSlidesVideoSlide);
	
	var _helpersMarkdownScript = __webpack_require__(9);
	
	var _helpersMarkdownScript2 = _interopRequireDefault(_helpersMarkdownScript);
	
	var _mmeMd = __webpack_require__(1783);
	
	var _mmeMd2 = _interopRequireDefault(_mmeMd);
	
	var _mmeFr_CAMd = __webpack_require__(1782);
	
	var _mmeFr_CAMd2 = _interopRequireDefault(_mmeFr_CAMd);
	
	var md = (0, _helpersI18n.i18nData)({
	  en: new _helpersMarkdownScript2['default'](_mmeMd2['default']),
	  fr_CA: new _helpersMarkdownScript2['default'](_mmeFr_CAMd2['default'])
	});
	
	function mmeSection(_ref) {
	  var level = _ref.level;
	  var regionData = _ref.regionData;
	  var i18n = _ref.i18n;
	
	  var md_i18n = i18n(md);
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'mme' },
	    (0, _baseSlidesVideoSlide2['default'])({
	      id: 'video',
	      notes: md_i18n.getSubSectionAsHtml('MME Level ' + level, 'Notes', false, regionData),
	      youTubeId: md_i18n.getSectionMetadata('MME Level ' + level, 'YouTube', regionData)
	    })
	  );
	}
	
	exports['default'] = mmeSection;
	module.exports = exports['default'];
	/* MME segment */

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

	/* eslint react/no-multi-comp: 0 */
	
	'use strict';
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.preloadClassActivity = preloadClassActivity;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _helpersI18n = __webpack_require__(14);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _baseSlidesHeadingSlide = __webpack_require__(170);
	
	var _baseSlidesHeadingSlide2 = _interopRequireDefault(_baseSlidesHeadingSlide);
	
	var _baseSlidesVideoSlide = __webpack_require__(59);
	
	var _baseSlidesVideoSlide2 = _interopRequireDefault(_baseSlidesVideoSlide);
	
	var _baseSlidesBalloonSlide = __webpack_require__(70);
	
	var _baseSlidesBalloonSlide2 = _interopRequireDefault(_baseSlidesBalloonSlide);
	
	var _imagesCharactersApprenticeHandsHips3Png = __webpack_require__(2434);
	
	var _imagesCharactersApprenticeHandsHips3Png2 = _interopRequireDefault(_imagesCharactersApprenticeHandsHips3Png);
	
	var _imagesCharactersApprenticeArmsFolded2Png = __webpack_require__(2429);
	
	var _imagesCharactersApprenticeArmsFolded2Png2 = _interopRequireDefault(_imagesCharactersApprenticeArmsFolded2Png);
	
	var _imagesCharactersEsmeralda_hands_out_weheyPng = __webpack_require__(440);
	
	var _imagesCharactersEsmeralda_hands_out_weheyPng2 = _interopRequireDefault(_imagesCharactersEsmeralda_hands_out_weheyPng);
	
	var _imagesCharactersApprenticesBackToBackPng = __webpack_require__(2437);
	
	var _imagesCharactersApprenticesBackToBackPng2 = _interopRequireDefault(_imagesCharactersApprenticesBackToBackPng);
	
	var _imagesCharactersIan_sara_lean_questioningPng = __webpack_require__(902);
	
	var _imagesCharactersIan_sara_lean_questioningPng2 = _interopRequireDefault(_imagesCharactersIan_sara_lean_questioningPng);
	
	var _helpersMarkdownScript = __webpack_require__(9);
	
	var _helpersMarkdownScript2 = _interopRequireDefault(_helpersMarkdownScript);
	
	var _level1_drawSeasonsMd = __webpack_require__(1785);
	
	var _level1_drawSeasonsMd2 = _interopRequireDefault(_level1_drawSeasonsMd);
	
	var _level1_drawSeasonsFr_CAMd = __webpack_require__(1784);
	
	var _level1_drawSeasonsFr_CAMd2 = _interopRequireDefault(_level1_drawSeasonsFr_CAMd);
	
	var _level2a_drawEnergyMd = __webpack_require__(1787);
	
	var _level2a_drawEnergyMd2 = _interopRequireDefault(_level2a_drawEnergyMd);
	
	var _level2a_drawEnergyFr_CAMd = __webpack_require__(1786);
	
	var _level2a_drawEnergyFr_CAMd2 = _interopRequireDefault(_level2a_drawEnergyFr_CAMd);
	
	var _level2b_energySavingRapMd = __webpack_require__(1789);
	
	var _level2b_energySavingRapMd2 = _interopRequireDefault(_level2b_energySavingRapMd);
	
	var _level2b_energySavingRapFr_CAMd = __webpack_require__(1788);
	
	var _level2b_energySavingRapFr_CAMd2 = _interopRequireDefault(_level2b_energySavingRapFr_CAMd);
	
	var _level3a_modelHotWaterTankMd = __webpack_require__(1791);
	
	var _level3a_modelHotWaterTankMd2 = _interopRequireDefault(_level3a_modelHotWaterTankMd);
	
	var _level3a_modelHotWaterTankFr_CAMd = __webpack_require__(1790);
	
	var _level3a_modelHotWaterTankFr_CAMd2 = _interopRequireDefault(_level3a_modelHotWaterTankFr_CAMd);
	
	var _level3b_showerPosterMd = __webpack_require__(1793);
	
	var _level3b_showerPosterMd2 = _interopRequireDefault(_level3b_showerPosterMd);
	
	var _level3b_showerPosterFr_CAMd = __webpack_require__(1792);
	
	var _level3b_showerPosterFr_CAMd2 = _interopRequireDefault(_level3b_showerPosterFr_CAMd);
	
	var _level4a_drawTransportationMd = __webpack_require__(1795);
	
	var _level4a_drawTransportationMd2 = _interopRequireDefault(_level4a_drawTransportationMd);
	
	var _level4a_drawTransportationFr_CAMd = __webpack_require__(1794);
	
	var _level4a_drawTransportationFr_CAMd2 = _interopRequireDefault(_level4a_drawTransportationFr_CAMd);
	
	var _level4b_rateTransportationMd = __webpack_require__(1797);
	
	var _level4b_rateTransportationMd2 = _interopRequireDefault(_level4b_rateTransportationMd);
	
	var _level4b_rateTransportationFr_CAMd = __webpack_require__(1796);
	
	var _level4b_rateTransportationFr_CAMd2 = _interopRequireDefault(_level4b_rateTransportationFr_CAMd);
	
	var _level5a_teamBrainstormMd = __webpack_require__(1799);
	
	var _level5a_teamBrainstormMd2 = _interopRequireDefault(_level5a_teamBrainstormMd);
	
	var _level5a_teamBrainstormFr_CAMd = __webpack_require__(1798);
	
	var _level5a_teamBrainstormFr_CAMd2 = _interopRequireDefault(_level5a_teamBrainstormFr_CAMd);
	
	var _level5b_rolePlayMd = __webpack_require__(1801);
	
	var _level5b_rolePlayMd2 = _interopRequireDefault(_level5b_rolePlayMd);
	
	var _level5b_rolePlayFr_CAMd = __webpack_require__(1800);
	
	var _level5b_rolePlayFr_CAMd2 = _interopRequireDefault(_level5b_rolePlayFr_CAMd);
	
	var _level6_papercraftsMd = __webpack_require__(1803);
	
	var _level6_papercraftsMd2 = _interopRequireDefault(_level6_papercraftsMd);
	
	var _level6_papercraftsFr_CAMd = __webpack_require__(1802);
	
	var _level6_papercraftsFr_CAMd2 = _interopRequireDefault(_level6_papercraftsFr_CAMd);
	
	var markdownFileLevel1 = (0, _helpersI18n.i18nData)({
	  en: new _helpersMarkdownScript2['default'](_level1_drawSeasonsMd2['default']),
	  fr_CA: new _helpersMarkdownScript2['default'](_level1_drawSeasonsFr_CAMd2['default'])
	});
	var markdownFileLevel2a = (0, _helpersI18n.i18nData)({
	  en: new _helpersMarkdownScript2['default'](_level2a_drawEnergyMd2['default']),
	  fr_CA: new _helpersMarkdownScript2['default'](_level2a_drawEnergyFr_CAMd2['default'])
	});
	var markdownFileLevel2b = (0, _helpersI18n.i18nData)({
	  en: new _helpersMarkdownScript2['default'](_level2b_energySavingRapMd2['default']),
	  fr_CA: new _helpersMarkdownScript2['default'](_level2b_energySavingRapFr_CAMd2['default'])
	});
	var markdownFileLevel3a = (0, _helpersI18n.i18nData)({
	  en: new _helpersMarkdownScript2['default'](_level3a_modelHotWaterTankMd2['default']),
	  fr_CA: new _helpersMarkdownScript2['default'](_level3a_modelHotWaterTankFr_CAMd2['default'])
	});
	var markdownFileLevel3b = (0, _helpersI18n.i18nData)({
	  en: new _helpersMarkdownScript2['default'](_level3b_showerPosterMd2['default']),
	  fr_CA: new _helpersMarkdownScript2['default'](_level3b_showerPosterFr_CAMd2['default'])
	});
	var markdownFileLevel4a = (0, _helpersI18n.i18nData)({
	  en: new _helpersMarkdownScript2['default'](_level4a_drawTransportationMd2['default']),
	  fr_CA: new _helpersMarkdownScript2['default'](_level4a_drawTransportationFr_CAMd2['default'])
	});
	var markdownFileLevel4b = (0, _helpersI18n.i18nData)({
	  en: new _helpersMarkdownScript2['default'](_level4b_rateTransportationMd2['default']),
	  fr_CA: new _helpersMarkdownScript2['default'](_level4b_rateTransportationFr_CAMd2['default'])
	});
	var markdownFileLevel5a = (0, _helpersI18n.i18nData)({
	  en: new _helpersMarkdownScript2['default'](_level5a_teamBrainstormMd2['default']),
	  fr_CA: new _helpersMarkdownScript2['default'](_level5a_teamBrainstormFr_CAMd2['default'])
	});
	var markdownFileLevel5b = (0, _helpersI18n.i18nData)({
	  en: new _helpersMarkdownScript2['default'](_level5b_rolePlayMd2['default']),
	  fr_CA: new _helpersMarkdownScript2['default'](_level5b_rolePlayFr_CAMd2['default'])
	});
	var markdownFileLevel6 = (0, _helpersI18n.i18nData)({
	  en: new _helpersMarkdownScript2['default'](_level6_papercraftsMd2['default']),
	  fr_CA: new _helpersMarkdownScript2['default'](_level6_papercraftsFr_CAMd2['default'])
	});
	
	var levels = {
	  '1': { md: markdownFileLevel1 },
	  '2a': { md: markdownFileLevel2a },
	  '2b': { md: markdownFileLevel2b },
	  '3a': { md: markdownFileLevel3a },
	  '3b': { md: markdownFileLevel3b },
	  '4a': { md: markdownFileLevel4a },
	  '4b': { md: markdownFileLevel4b },
	  '5a': { md: markdownFileLevel5a },
	  '5b': { md: markdownFileLevel5b },
	  '6': { md: markdownFileLevel6 }
	};
	
	function preloadClassActivity() {
	  (0, _spectaclePpa.preloader)([_imagesCharactersEsmeralda_hands_out_weheyPng2['default'], _imagesCharactersApprenticeHandsHips3Png2['default'], _imagesCharactersApprenticeArmsFolded2Png2['default'], _imagesCharactersApprenticesBackToBackPng2['default'], _imagesCharactersIan_sara_lean_questioningPng2['default'], _imagesCharactersEsmeralda_hands_out_weheyPng2['default']]);
	}
	
	function sizzle(level, regionData, md) {
	  return (0, _baseSlidesBalloonSlide2['default'])({
	    id: 'sizzle',
	    characterSide: 'left',
	    characterImage: _imagesCharactersApprenticeHandsHips3Png2['default'],
	    notes: md.getSubSectionAsHtml('Sizzle', 'Notes', false, regionData),
	    html: md.getSubSectionAsHtml('Sizzle', 'Content', false, regionData)
	  });
	}
	
	function introVideo(level, regionData, md) {
	  return (0, _baseSlidesVideoSlide2['default'])({
	    id: 'intro-video',
	    notes: md.getSubSectionAsHtml('Intro Video', 'Notes', false, regionData),
	    youTubeId: md.getSectionMetadata('Intro Video', 'YouTube', regionData)
	  });
	}
	
	function instructions(level, regionData, md) {
	  return (0, _baseSlidesBalloonSlide2['default'])({
	    id: 'instructions',
	    characterSide: 'right',
	    characterImage: _imagesCharactersApprenticeArmsFolded2Png2['default'],
	    notes: md.getSubSectionAsHtml('Instructions', 'Notes', false, regionData),
	    html: md.getSubSectionAsHtml('Instructions', 'Content', false, regionData)
	  });
	}
	
	function scoring(level, regionData, md) {
	  return (0, _baseSlidesBalloonSlide2['default'])({
	    id: 'scoring',
	    characterSide: 'right',
	    characterImage: _imagesCharactersApprenticesBackToBackPng2['default'],
	    notes: md.getSubSectionAsHtml('Scoring', 'Notes', false, regionData),
	    html: md.getSubSectionAsHtml('Scoring', 'Content', false, regionData)
	  });
	}
	
	function level1(regionData, i18n) {
	  // Group drawing
	  var level = '1';
	  var md = i18n(levels[level].md);
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'class-activity-' + level },
	    sizzle(level, regionData, md),
	    introVideo(level, regionData, md),
	    instructions(level, regionData, md)
	  );
	}
	
	function level2a(regionData, i18n) {
	  // Draw Energy
	  var level = '2a';
	  var md = i18n(levels[level].md);
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'class-activity-' + level },
	    sizzle(level, regionData, md),
	    introVideo(level, regionData, md),
	    instructions(level, regionData, md)
	  );
	}
	
	function level2b(regionData, i18n) {
	  // Energy saving rap
	  var level = '2b';
	  var md = i18n(levels[level].md);
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'class-activity-' + level },
	    sizzle(level, regionData, md),
	    introVideo(level, regionData, md),
	    instructions(level, regionData, md),
	    scoring(level, regionData, md),
	    (0, _baseSlidesVideoSlide2['default'])({
	      id: 'rap-backtrack-practice',
	      notes: md.getSubSectionAsHtml('Rap Backtrack Practice', 'Notes', false, regionData),
	      youTubeId: md.getSectionMetadata('Rap Backtrack Practice', 'YouTube', regionData)
	    }),
	    (0, _baseSlidesVideoSlide2['default'])({
	      id: 'performing-intro-video',
	      notes: md.getSubSectionAsHtml('Performing Intro Video', 'Notes', false, regionData),
	      youTubeId: md.getSectionMetadata('Performing Intro Video', 'YouTube', regionData)
	    }),
	    (0, _baseSlidesVideoSlide2['default'])({
	      id: 'rap-backtrack-perform',
	      notes: md.getSubSectionAsHtml('Rap Backtrack Perform', 'Notes', false, regionData),
	      youTubeId: md.getSectionMetadata('Rap Backtrack Perform', 'YouTube', regionData)
	    })
	  );
	}
	
	function level3a(regionData, i18n) {
	  // Model hot water tank
	  var level = '3a';
	  var md = i18n(levels[level].md);
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'class-activity-' + level },
	    sizzle(level, regionData, md),
	    introVideo(level, regionData, md),
	    instructions(level, regionData, md)
	  );
	}
	
	function level3b(regionData, i18n) {
	  // Draw shower power poster
	  var level = '3b';
	  var md = i18n(levels[level].md);
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'class-activity-' + level },
	    sizzle(level, regionData, md),
	    introVideo(level, regionData, md),
	    instructions(level, regionData, md)
	  );
	}
	
	function level4a(regionData, i18n) {
	  // Draw different types of transportation
	  var level = '4a';
	  var md = i18n(levels[level].md);
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'class-activity-' + level },
	    (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'energy-demo-intro',
	      characterSide: 'left',
	      characterImage: _imagesCharactersEsmeralda_hands_out_weheyPng2['default'],
	      notes: md.getSubSectionAsHtml('Energy Demonstration Intro', 'Notes', false, regionData),
	      html: md.getSubSectionAsHtml('Energy Demonstration Intro', 'Content', false, regionData)
	    }),
	    (0, _baseSlidesVideoSlide2['default'])({
	      id: 'energy-demo-video',
	      notes: md.getSubSectionAsHtml('Energy Demonstration Video', 'Notes', false, regionData),
	      youTubeId: md.getSectionMetadata('Energy Demonstration Video', 'YouTube', regionData)
	    }),
	    sizzle(level, regionData, md),
	    instructions(level, regionData, md)
	  );
	}
	
	function level4b(regionData, i18n) {
	  // Rate transportation options
	  var level = '4b';
	  var md = i18n(levels[level].md);
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'class-activity-' + level },
	    sizzle(level, regionData, md),
	    introVideo(level, regionData, md),
	    instructions(level, regionData, md)
	  );
	}
	
	function level5a(regionData, i18n) {
	  // Team brainstorm
	  var level = '5a';
	  var md = i18n(levels[level].md);
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'class-activity-' + level },
	    sizzle(level, regionData, md),
	    introVideo(level, regionData, md),
	    instructions(level, regionData, md),
	    (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'class-discussion',
	      characterSide: 'right',
	      characterImage: _imagesCharactersIan_sara_lean_questioningPng2['default'],
	      notes: md.getSubSectionAsHtml('Class Discussion', 'Notes', false, regionData),
	      html: md.getSubSectionAsHtml('Class Discussion', 'Content', false, regionData)
	    })
	  );
	}
	
	function level5b(regionData, i18n) {
	  // Role play
	  var level = '5b';
	  var md = i18n(levels[level].md);
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'class-activity-' + level },
	    sizzle(level, regionData, md),
	    introVideo(level, regionData, md),
	    instructions(level, regionData, md)
	  );
	}
	
	function level6(regionData, i18n) {
	  // Papercrafts
	  var level = '6';
	  var md = i18n(levels[level].md);
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'class-activity-' + level },
	    sizzle(level, regionData, md),
	    introVideo(level, regionData, md)
	  );
	}
	
	function classActivitySection(_ref) {
	  var level = _ref.level;
	  var subActivity = _ref.subActivity;
	  var regionData = _ref.regionData;
	  var i18n = _ref.i18n;
	
	  switch ('' + level + (subActivity ? subActivity : '')) {
	    case '1':
	      return level1(regionData, i18n);
	    case '2a':
	      return level2a(regionData, i18n);
	    case '2b':
	      return level2b(regionData, i18n);
	    case '3a':
	      return level3a(regionData, i18n);
	    case '3b':
	      return level3b(regionData, i18n);
	    case '4a':
	      return level4a(regionData, i18n);
	    case '4b':
	      return level4b(regionData, i18n);
	    case '5a':
	      return level5a(regionData, i18n);
	    case '5b':
	      return level5b(regionData, i18n);
	    case '6':
	      return level6(regionData, i18n);
	    default:
	      return (0, _baseSlidesHeadingSlide2['default'])({ heading: 'Unknown' });
	  }
	}
	
	exports['default'] = classActivitySection;
	/* Sizzle */ /* Intro Video */ /* Instructions */ /* Sizzle */ /* Intro Video */ /* Instructions */ /* Sizzle */ /* Intro Video */ /* Instructions */ /* Scoring */ /* Rap Backtrack Practice */ /* Performing Intro Video */ /* Rap Backtrack Perform */ /* Sizzle */ /* Intro Video */ /* Instructions */ /* Sizzle */ /* Intro Video */ /* Instructions */ /* Energy Demonstration Intro */ /* Energy Demonstration Video */ /* Sizzle */ /* Instructions */ /* Sizzle */ /* Intro Video */ /* Instructions */ /* Sizzle */ /* Intro Video */ /* Instructions */ /* Class Discussion */ /* Sizzle */ /* Intro Video */ /* Instructions */ /* Sizzle */ /* Intro Video */

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _taggedTemplateLiteral = __webpack_require__(28)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.preloadFinish = preloadFinish;
	
	var _templateObject = _taggedTemplateLiteral(['Level ', ' Finished'], ['Level ', ' Finished']),
	    _templateObject2 = _taggedTemplateLiteral(['level ', ' of 6'], ['level ', ' of 6']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _helpersI18n = __webpack_require__(14);
	
	var _componentsCompleteLevelButton = __webpack_require__(44);
	
	var _componentsCompleteLevelButton2 = _interopRequireDefault(_componentsCompleteLevelButton);
	
	var _baseSlidesBalloonSlide = __webpack_require__(70);
	
	var _baseSlidesBalloonSlide2 = _interopRequireDefault(_baseSlidesBalloonSlide);
	
	var _baseSlidesVideoSlide = __webpack_require__(59);
	
	var _baseSlidesVideoSlide2 = _interopRequireDefault(_baseSlidesVideoSlide);
	
	var _imagesCharactersEsmeralda_goober_goofy_smilePng = __webpack_require__(438);
	
	var _imagesCharactersEsmeralda_goober_goofy_smilePng2 = _interopRequireDefault(_imagesCharactersEsmeralda_goober_goofy_smilePng);
	
	var _imagesCharactersEsmeralda_goober_proudPng = __webpack_require__(439);
	
	var _imagesCharactersEsmeralda_goober_proudPng2 = _interopRequireDefault(_imagesCharactersEsmeralda_goober_proudPng);
	
	var _imagesCharactersEsmeralda_goober_wavePng = __webpack_require__(2442);
	
	var _imagesCharactersEsmeralda_goober_wavePng2 = _interopRequireDefault(_imagesCharactersEsmeralda_goober_wavePng);
	
	var _imagesCharactersIan_sara_sidePng = __webpack_require__(2445);
	
	var _imagesCharactersIan_sara_sidePng2 = _interopRequireDefault(_imagesCharactersIan_sara_sidePng);
	
	var _imagesCharactersIan_sara_lean_questioningPng = __webpack_require__(902);
	
	var _imagesCharactersIan_sara_lean_questioningPng2 = _interopRequireDefault(_imagesCharactersIan_sara_lean_questioningPng);
	
	var _helpersMarkdownScript = __webpack_require__(9);
	
	var _helpersMarkdownScript2 = _interopRequireDefault(_helpersMarkdownScript);
	
	var _finishMd = __webpack_require__(1813);
	
	var _finishMd2 = _interopRequireDefault(_finishMd);
	
	var _finishFr_CAMd = __webpack_require__(1812);
	
	var _finishFr_CAMd2 = _interopRequireDefault(_finishFr_CAMd);
	
	var _level1_completeSvg = __webpack_require__(2468);
	
	var _level1_completeSvg2 = _interopRequireDefault(_level1_completeSvg);
	
	var _level2_completeSvg = __webpack_require__(2469);
	
	var _level2_completeSvg2 = _interopRequireDefault(_level2_completeSvg);
	
	var _level3_completeSvg = __webpack_require__(2470);
	
	var _level3_completeSvg2 = _interopRequireDefault(_level3_completeSvg);
	
	var _level4_completeSvg = __webpack_require__(2471);
	
	var _level4_completeSvg2 = _interopRequireDefault(_level4_completeSvg);
	
	var _level5_completeSvg = __webpack_require__(2472);
	
	var _level5_completeSvg2 = _interopRequireDefault(_level5_completeSvg);
	
	var _level6_completeSvg = __webpack_require__(2473);
	
	var _level6_completeSvg2 = _interopRequireDefault(_level6_completeSvg);
	
	var md = (0, _helpersI18n.i18nData)({
	  en: new _helpersMarkdownScript2['default'](_finishMd2['default']),
	  fr_CA: new _helpersMarkdownScript2['default'](_finishFr_CAMd2['default'])
	});
	
	var levels = {
	  '1': { img: _level1_completeSvg2['default'] },
	  '2': { img: _level2_completeSvg2['default'] },
	  '3': { img: _level3_completeSvg2['default'] },
	  '4': { img: _level4_completeSvg2['default'] },
	  '5': { img: _level5_completeSvg2['default'] },
	  '6': { img: _level6_completeSvg2['default'] }
	};
	
	function preloadFinish() {
	  (0, _spectaclePpa.preloader)([_imagesCharactersEsmeralda_goober_goofy_smilePng2['default'], _imagesCharactersEsmeralda_goober_proudPng2['default'], _imagesCharactersEsmeralda_goober_wavePng2['default'], _imagesCharactersIan_sara_sidePng2['default'], _imagesCharactersIan_sara_lean_questioningPng2['default'], _level1_completeSvg2['default'], _level2_completeSvg2['default'], _level3_completeSvg2['default'], _level4_completeSvg2['default'], _level5_completeSvg2['default'], _level6_completeSvg2['default']]);
	}
	
	function finishSection(_ref) {
	  var level = _ref.level;
	  var regionData = _ref.regionData;
	  var _ = _ref.i18n;
	
	  var md_i18n = _(md);
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'finish' },
	    level !== 6 && (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'scoreboard-recap',
	      characterSide: 'left',
	      characterImage: _imagesCharactersIan_sara_sidePng2['default'],
	      html: md_i18n.getSubSectionAsHtml('Scoreboard Recap', 'Content', false, regionData),
	      notes: md_i18n.getSubSectionAsHtml('Scoreboard Recap', 'Notes', false, regionData)
	    }),
	    (level === 2 || level === 3 || level === 4 || level === 5) && (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'earn-more-points',
	      characterSide: 'right',
	      characterImage: _imagesCharactersIan_sara_lean_questioningPng2['default'],
	      html: md_i18n.getSubSectionAsHtml('Earn More Points', 'Content', false, regionData),
	      notes: md_i18n.getSubSectionAsHtml('Earn More Points', 'Notes', false, regionData)
	    }),
	    level === 1 && (0, _baseSlidesVideoSlide2['default'])({
	      id: 'farewell-video',
	      notes: md_i18n.getSubSectionAsHtml('Level 1 Farewell Video', 'Notes', false, regionData),
	      youTubeId: md_i18n.getSectionMetadata('Level 1 Farewell Video', 'YouTube', regionData)
	    }),
	    (level === 1 || level === 4) && (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'farewell',
	      characterSide: 'right',
	      characterImage: _imagesCharactersEsmeralda_goober_goofy_smilePng2['default'],
	      html: md_i18n.getSubSectionAsHtml('Farewell', 'Content', false, regionData),
	      notes: md_i18n.getSubSectionAsHtml('Farewell', 'Notes', false, regionData)
	    }),
	    (level === 2 || level === 5) && (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'farewell',
	      characterSide: 'left',
	      characterImage: _imagesCharactersEsmeralda_goober_proudPng2['default'],
	      html: md_i18n.getSubSectionAsHtml('Farewell', 'Content', false, regionData),
	      notes: md_i18n.getSubSectionAsHtml('Farewell', 'Notes', false, regionData)
	    }),
	    level === 3 && (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'farewell',
	      characterSide: 'left',
	      characterImage: _imagesCharactersEsmeralda_goober_wavePng2['default'],
	      html: md_i18n.getSubSectionAsHtml('Farewell', 'Content', false, regionData),
	      notes: md_i18n.getSubSectionAsHtml('Farewell', 'Notes', false, regionData)
	    }),
	    _react2['default'].createElement(
	      _spectaclePpa.Slide,
	      {
	        id: 'level-completed',
	        notes: '<h2>' + _(_templateObject, level) + '</h2>',
	        bgColor: 'transparent',
	        finish: true },
	      _react2['default'].createElement(
	        'div',
	        { className: 'level-complete' },
	        _react2['default'].createElement(
	          'div',
	          { className: 'level-complete-content' },
	          _react2['default'].createElement(
	            'figure',
	            { className: 'level-complete-graphic' },
	            _react2['default'].createElement('img', { src: levels[level].img })
	          ),
	          _react2['default'].createElement(
	            _spectaclePpa.Heading,
	            { size: 2 },
	            _("You've finished")
	          ),
	          _react2['default'].createElement(
	            _spectaclePpa.Heading,
	            { size: 2 },
	            _(_templateObject2, level)
	          ),
	          _react2['default'].createElement(_componentsCompleteLevelButton2['default'], null)
	        )
	      )
	    )
	  );
	}
	
	exports['default'] = finishSection;
	/* Scoreboard Recap */ /* Earn More Points */ /* Video farewell level 1 */ /* Farewell levels 1 & 4 */ /* Farewell levels 2 & 5 */ /* Farewell levels 3 */ /* Level complete */

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.preloadStart = preloadStart;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _imagesPpa_presentsSvg = __webpack_require__(2507);
	
	var _imagesPpa_presentsSvg2 = _interopRequireDefault(_imagesPpa_presentsSvg);
	
	var _imagesZeroHeroesNoPPAPresentsPng = __webpack_require__(2510);
	
	var _imagesZeroHeroesNoPPAPresentsPng2 = _interopRequireDefault(_imagesZeroHeroesNoPPAPresentsPng);
	
	var _helpersMarkdownScript = __webpack_require__(9);
	
	var _helpersMarkdownScript2 = _interopRequireDefault(_helpersMarkdownScript);
	
	var _startMd = __webpack_require__(1827);
	
	var _startMd2 = _interopRequireDefault(_startMd);
	
	var _imagesLevel1_startPng = __webpack_require__(448);
	
	var _imagesLevel1_startPng2 = _interopRequireDefault(_imagesLevel1_startPng);
	
	var _imagesLevel2_startPng = __webpack_require__(449);
	
	var _imagesLevel2_startPng2 = _interopRequireDefault(_imagesLevel2_startPng);
	
	var _imagesLevel3_startPng = __webpack_require__(450);
	
	var _imagesLevel3_startPng2 = _interopRequireDefault(_imagesLevel3_startPng);
	
	var _imagesLevel4_startPng = __webpack_require__(451);
	
	var _imagesLevel4_startPng2 = _interopRequireDefault(_imagesLevel4_startPng);
	
	var _imagesLevel5_startPng = __webpack_require__(452);
	
	var _imagesLevel5_startPng2 = _interopRequireDefault(_imagesLevel5_startPng);
	
	var _imagesLevel6_startPng = __webpack_require__(911);
	
	var _imagesLevel6_startPng2 = _interopRequireDefault(_imagesLevel6_startPng);
	
	var levels = {
	  '1': { img: _imagesLevel1_startPng2['default'] },
	  '2': { img: _imagesLevel2_startPng2['default'] },
	  '3': { img: _imagesLevel3_startPng2['default'] },
	  '4': { img: _imagesLevel4_startPng2['default'] },
	  '5': { img: _imagesLevel5_startPng2['default'] },
	  '6': { img: _imagesLevel6_startPng2['default'] }
	};
	
	var md = new _helpersMarkdownScript2['default'](_startMd2['default']);
	
	function preloadStart() {
	  (0, _spectaclePpa.preloader)([_imagesPpa_presentsSvg2['default'], _imagesZeroHeroesNoPPAPresentsPng2['default'], _imagesLevel1_startPng2['default'], _imagesLevel2_startPng2['default'], _imagesLevel3_startPng2['default'], _imagesLevel4_startPng2['default'], _imagesLevel5_startPng2['default'], _imagesLevel6_startPng2['default']]);
	}
	
	function startSection(_ref) {
	  var level = _ref.level;
	  var title = _ref.title;
	  var regionData = _ref.regionData;
	
	  /* Level intro graphic */
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'start' },
	    _react2['default'].createElement(
	      _spectaclePpa.Slide,
	      {
	        id: 'ppa-presents',
	        key: 'ppa-presents',
	        bgColor: 'black',
	        notes: md.getSubSectionAsHtml('Level ' + level + ' Start', 'Notes', false, regionData) },
	      _react2['default'].createElement(
	        'div',
	        {
	          className: 'ui-slide' },
	        _react2['default'].createElement(
	          'div',
	          { className: 'flex-image' },
	          _react2['default'].createElement('img', {
	            className: 'heading-image heading-image-before',
	            src: _imagesPpa_presentsSvg2['default'] })
	        )
	      )
	    ),
	    _react2['default'].createElement(
	      _spectaclePpa.Slide,
	      {
	        id: 'ppa-zh',
	        key: 'ppa-zh',
	        bgColor: 'black',
	        notes: md.getSubSectionAsHtml('Level ' + level + ' Start', 'Notes', false, regionData) },
	      _react2['default'].createElement(
	        'div',
	        {
	          className: 'ui-slide' },
	        _react2['default'].createElement(
	          'div',
	          { className: 'flex-image' },
	          _react2['default'].createElement('img', { className: 'zh-logo heading-image',
	            src: _imagesZeroHeroesNoPPAPresentsPng2['default'] })
	        )
	      )
	    ),
	    _react2['default'].createElement(
	      _spectaclePpa.Slide,
	      {
	        id: 'level',
	        key: 'level',
	        bgColor: 'black',
	        notes: md.getSubSectionAsHtml('Level ' + level + ' Icon', 'Notes', false, regionData) },
	      _react2['default'].createElement(
	        'div',
	        {
	          className: 'ui-slide' },
	        _react2['default'].createElement(
	          'div',
	          { className: 'title-image' },
	          _react2['default'].createElement('img', {
	            className: 'heading-image heading-image-before',
	            src: levels[level].img }),
	          _react2['default'].createElement(
	            _spectaclePpa.Heading,
	            { size: 1 },
	            _react2['default'].createElement(
	              'strong',
	              null,
	              title
	            )
	          ),
	          _react2['default'].createElement(
	            _spectaclePpa.Heading,
	            { size: 2 },
	            _react2['default'].createElement(
	              'strong',
	              null,
	              'Level ',
	              level
	            )
	          )
	        )
	      )
	    )
	  );
	}
	
	exports['default'] = startSection;
	/* Sanksrit for Vanessa */ /* lokah samastah sukhino bhavantu */ /* may all beings everywhere be at peace */

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.preloadSong = preloadSong;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _baseSlidesVideoSlide = __webpack_require__(43);
	
	var _baseSlidesVideoSlide2 = _interopRequireDefault(_baseSlidesVideoSlide);
	
	var _baseSlidesBalloonSlide = __webpack_require__(71);
	
	var _baseSlidesBalloonSlide2 = _interopRequireDefault(_baseSlidesBalloonSlide);
	
	var _imagesCharactersApprenticesPosingPng = __webpack_require__(2485);
	
	var _imagesCharactersApprenticesPosingPng2 = _interopRequireDefault(_imagesCharactersApprenticesPosingPng);
	
	var _imagesCharactersApprenticesFlexArmsPng = __webpack_require__(907);
	
	var _imagesCharactersApprenticesFlexArmsPng2 = _interopRequireDefault(_imagesCharactersApprenticesFlexArmsPng);
	
	var _helpersMarkdownScript = __webpack_require__(9);
	
	var _helpersMarkdownScript2 = _interopRequireDefault(_helpersMarkdownScript);
	
	var _songMd = __webpack_require__(1828);
	
	var _songMd2 = _interopRequireDefault(_songMd);
	
	var md = new _helpersMarkdownScript2['default'](_songMd2['default']);
	
	function preloadSong() {
	  (0, _spectaclePpa.preloader)([_imagesCharactersApprenticesPosingPng2['default'], _imagesCharactersApprenticesFlexArmsPng2['default']]);
	}
	
	function songSection(_ref) {
	  var level = _ref.level;
	  var regionData = _ref.regionData;
	
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'song' },
	    level === 1 && (0, _baseSlidesVideoSlide2['default'])({
	      id: 'intro-video',
	      notes: md.getSubSectionAsHtml('Level ' + level + ' Intro', 'Notes', false, regionData),
	      youTubeId: md.getSectionMetadata('Level ' + level + ' Intro', 'YouTube', regionData)
	    }),
	    (level === 2 || level === 4 || level === 6) && (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'welcome-back',
	      characterSide: 'right',
	      characterImage: _imagesCharactersApprenticesPosingPng2['default'],
	      html: md.getSubSectionAsHtml('Level ' + level + ' Intro', 'Content', false, regionData),
	      notes: md.getSubSectionAsHtml('Level ' + level + ' Intro', 'Notes', false, regionData)
	    }),
	    level === 3 && (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'welcome-back',
	      characterSide: 'right',
	      characterImage: _imagesCharactersApprenticesFlexArmsPng2['default'],
	      html: md.getSubSectionAsHtml('Level ' + level + ' Intro', 'Content', false, regionData),
	      notes: md.getSubSectionAsHtml('Level ' + level + ' Intro', 'Notes', false, regionData)
	    }),
	    (0, _baseSlidesVideoSlide2['default'])({
	      id: 'video',
	      notes: md.getSubSectionAsHtml('Song', 'Notes', false, regionData),
	      youTubeId: md.getSectionMetadata('Song', 'YouTube', regionData)
	    })
	  );
	}
	
	exports['default'] = songSection;
	/* Intro to song in Level 1 */ /* Welcome back by Ian in levels 2,4,6 */ /* Welcome back by Sara in levels 3 */ /* Song */

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

	/* eslint react/no-multi-comp: 0 */
	
	'use strict';
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _baseSlidesVideoSlide = __webpack_require__(43);
	
	var _baseSlidesVideoSlide2 = _interopRequireDefault(_baseSlidesVideoSlide);
	
	var _helpersMarkdownScript = __webpack_require__(9);
	
	var _helpersMarkdownScript2 = _interopRequireDefault(_helpersMarkdownScript);
	
	var _level1_openingMd = __webpack_require__(1835);
	
	var _level1_openingMd2 = _interopRequireDefault(_level1_openingMd);
	
	var _level2_openingMd = __webpack_require__(1836);
	
	var _level2_openingMd2 = _interopRequireDefault(_level2_openingMd);
	
	var _level3_openingMd = __webpack_require__(1837);
	
	var _level3_openingMd2 = _interopRequireDefault(_level3_openingMd);
	
	var _level4_openingMd = __webpack_require__(1838);
	
	var _level4_openingMd2 = _interopRequireDefault(_level4_openingMd);
	
	var _level5_openingMd = __webpack_require__(1839);
	
	var _level5_openingMd2 = _interopRequireDefault(_level5_openingMd);
	
	var _level6_openingMd = __webpack_require__(1840);
	
	var _level6_openingMd2 = _interopRequireDefault(_level6_openingMd);
	
	var levels = {
	  '1': { md: new _helpersMarkdownScript2['default'](_level1_openingMd2['default']) },
	  '2': { md: new _helpersMarkdownScript2['default'](_level2_openingMd2['default']) },
	  '3': { md: new _helpersMarkdownScript2['default'](_level3_openingMd2['default']) },
	  '4': { md: new _helpersMarkdownScript2['default'](_level4_openingMd2['default']) },
	  '5': { md: new _helpersMarkdownScript2['default'](_level5_openingMd2['default']) },
	  '6': { md: new _helpersMarkdownScript2['default'](_level6_openingMd2['default']) }
	};
	
	function esOpeningStory(_ref) {
	  var level = _ref.level;
	  var regionData = _ref.regionData;
	
	  var md = levels[level].md;
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: "opening" },
	    (level === 1 || level === 2 || level === 4) && (0, _baseSlidesVideoSlide2['default'])({
	      id: 'intro-video',
	      notes: md.getSubSectionAsHtml('Ian and Sara Intro', 'Notes', false, regionData),
	      youTubeId: md.getSectionMetadata('Ian and Sara Intro', 'YouTube', regionData)
	    }),
	    (0, _baseSlidesVideoSlide2['default'])({
	      id: 'story',
	      notes: md.getSubSectionAsHtml('Esmeralda and Goober Opening Story', 'Notes', false, regionData),
	      youTubeId: md.getSectionMetadata('Esmeralda and Goober Opening Story', 'YouTube', regionData)
	    }),
	    level === 4 && (0, _baseSlidesVideoSlide2['default'])({
	      id: 'disposable-rap-intro',
	      notes: md.getSubSectionAsHtml('Disposable Rap Intro', 'Notes', false, regionData),
	      youTubeId: md.getSectionMetadata('Disposable Rap Intro', 'YouTube', regionData)
	    }),
	    level === 4 && (0, _baseSlidesVideoSlide2['default'])({
	      id: 'disposable-rap',
	      notes: md.getSubSectionAsHtml('Disposable Rap', 'Notes', false, regionData),
	      youTubeId: md.getSectionMetadata('Disposable Rap', 'YouTube', regionData)
	    }),
	    level === 6 && (0, _baseSlidesVideoSlide2['default'])({
	      id: 'song-of-stuff-intro',
	      notes: md.getSubSectionAsHtml('Intro to Song of Stuff', 'Notes', false, regionData),
	      youTubeId: md.getSectionMetadata('Intro to Song of Stuff', 'YouTube', regionData) }),
	    level === 6 && (0, _baseSlidesVideoSlide2['default'])({
	      id: 'e-waste',
	      notes: md.getSubSectionAsHtml('Song of Stuff', 'Notes', false, regionData),
	      youTubeId: md.getSectionMetadata('Song of Stuff', 'YouTube', regionData) })
	  );
	}
	
	exports['default'] = esOpeningStory;
	module.exports = exports['default'];
	/* Intro to Es Opening in Levels 1, 2 + 4 */ /* Framing Story Opening */ /* Disposable Rap Intro in Level 4 */ /* Disposable Rap in Level 4 */ /* Intro to Song of Stuff in Level 6 */ /* Song of Stuff in Level 6 */

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

	/* eslint react/no-multi-comp: 0 */
	
	'use strict';
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.preloadClassActivity = preloadClassActivity;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _baseSlidesHeadingSlide = __webpack_require__(171);
	
	var _baseSlidesHeadingSlide2 = _interopRequireDefault(_baseSlidesHeadingSlide);
	
	var _baseSlidesVideoSlide = __webpack_require__(43);
	
	var _baseSlidesVideoSlide2 = _interopRequireDefault(_baseSlidesVideoSlide);
	
	var _baseSlidesBalloonSlide = __webpack_require__(71);
	
	var _baseSlidesBalloonSlide2 = _interopRequireDefault(_baseSlidesBalloonSlide);
	
	var _imagesCharactersApprenticeHandsHips3Png = __webpack_require__(2480);
	
	var _imagesCharactersApprenticeHandsHips3Png2 = _interopRequireDefault(_imagesCharactersApprenticeHandsHips3Png);
	
	var _imagesCharactersApprenticeArmsFolded2Png = __webpack_require__(2475);
	
	var _imagesCharactersApprenticeArmsFolded2Png2 = _interopRequireDefault(_imagesCharactersApprenticeArmsFolded2Png);
	
	var _imagesCharactersApprenticesBackToBackPng = __webpack_require__(2483);
	
	var _imagesCharactersApprenticesBackToBackPng2 = _interopRequireDefault(_imagesCharactersApprenticesBackToBackPng);
	
	var _imagesCharactersEsmeralda_hands_out_weheyPng = __webpack_require__(447);
	
	var _imagesCharactersEsmeralda_hands_out_weheyPng2 = _interopRequireDefault(_imagesCharactersEsmeralda_hands_out_weheyPng);
	
	var _imagesCharactersIan_headshot_smilePng = __webpack_require__(908);
	
	var _imagesCharactersIan_headshot_smilePng2 = _interopRequireDefault(_imagesCharactersIan_headshot_smilePng);
	
	var _imagesCharactersSara_surprisedPng = __webpack_require__(910);
	
	var _imagesCharactersSara_surprisedPng2 = _interopRequireDefault(_imagesCharactersSara_surprisedPng);
	
	var _imagesCharactersSara_twist_hands_out_heyheyPng = __webpack_require__(2500);
	
	var _imagesCharactersSara_twist_hands_out_heyheyPng2 = _interopRequireDefault(_imagesCharactersSara_twist_hands_out_heyheyPng);
	
	var _imagesCharactersIan_pointing_upPng = __webpack_require__(2492);
	
	var _imagesCharactersIan_pointing_upPng2 = _interopRequireDefault(_imagesCharactersIan_pointing_upPng);
	
	var _imagesCharactersIan_pointing_leftPng = __webpack_require__(2491);
	
	var _imagesCharactersIan_pointing_leftPng2 = _interopRequireDefault(_imagesCharactersIan_pointing_leftPng);
	
	var _imagesCharactersIan_pointing_downPng = __webpack_require__(2490);
	
	var _imagesCharactersIan_pointing_downPng2 = _interopRequireDefault(_imagesCharactersIan_pointing_downPng);
	
	var _imagesCharactersSara_smilePng = __webpack_require__(2499);
	
	var _imagesCharactersSara_smilePng2 = _interopRequireDefault(_imagesCharactersSara_smilePng);
	
	var _imagesCharactersSara_humphPng = __webpack_require__(2498);
	
	var _imagesCharactersSara_humphPng2 = _interopRequireDefault(_imagesCharactersSara_humphPng);
	
	var _imagesCharactersIan_sara_lean_questioningPng = __webpack_require__(909);
	
	var _imagesCharactersIan_sara_lean_questioningPng2 = _interopRequireDefault(_imagesCharactersIan_sara_lean_questioningPng);
	
	var _imagesCharactersIan_sidePng = __webpack_require__(2496);
	
	var _imagesCharactersIan_sidePng2 = _interopRequireDefault(_imagesCharactersIan_sidePng);
	
	var _helpersMarkdownScript = __webpack_require__(9);
	
	var _helpersMarkdownScript2 = _interopRequireDefault(_helpersMarkdownScript);
	
	var _level1_groupDrawingMd = __webpack_require__(1848);
	
	var _level1_groupDrawingMd2 = _interopRequireDefault(_level1_groupDrawingMd);
	
	var _level2a_popcornJoysMd = __webpack_require__(1849);
	
	var _level2a_popcornJoysMd2 = _interopRequireDefault(_level2a_popcornJoysMd);
	
	var _level2b_wasteMathMd = __webpack_require__(1850);
	
	var _level2b_wasteMathMd2 = _interopRequireDefault(_level2b_wasteMathMd);
	
	var _level2c_eatMeFirstSignMd = __webpack_require__(1851);
	
	var _level2c_eatMeFirstSignMd2 = _interopRequireDefault(_level2c_eatMeFirstSignMd);
	
	var _level3a_sortingGameMd = __webpack_require__(1852);
	
	var _level3a_sortingGameMd2 = _interopRequireDefault(_level3a_sortingGameMd);
	
	var _level3b_foodScrapsRapMd = __webpack_require__(1853);
	
	var _level3b_foodScrapsRapMd2 = _interopRequireDefault(_level3b_foodScrapsRapMd);
	
	var _level4a_lunchAnalysisMd = __webpack_require__(1854);
	
	var _level4a_lunchAnalysisMd2 = _interopRequireDefault(_level4a_lunchAnalysisMd);
	
	var _level4b_collectiveImpactMathMd = __webpack_require__(1855);
	
	var _level4b_collectiveImpactMathMd2 = _interopRequireDefault(_level4b_collectiveImpactMathMd);
	
	var _level4c_wasteFreeLunchPosterMd = __webpack_require__(1856);
	
	var _level4c_wasteFreeLunchPosterMd2 = _interopRequireDefault(_level4c_wasteFreeLunchPosterMd);
	
	var _level5a_buySmartCodeMd = __webpack_require__(1857);
	
	var _level5a_buySmartCodeMd2 = _interopRequireDefault(_level5a_buySmartCodeMd);
	
	var _level5b_skitMd = __webpack_require__(1858);
	
	var _level5b_skitMd2 = _interopRequireDefault(_level5b_skitMd);
	
	var _level6_biomimicryMd = __webpack_require__(1859);
	
	var _level6_biomimicryMd2 = _interopRequireDefault(_level6_biomimicryMd);
	
	var levels = {
	  '1': { md: new _helpersMarkdownScript2['default'](_level1_groupDrawingMd2['default']) },
	  '2a': { md: new _helpersMarkdownScript2['default'](_level2a_popcornJoysMd2['default']) },
	  '2b': { md: new _helpersMarkdownScript2['default'](_level2b_wasteMathMd2['default']) },
	  '2c': { md: new _helpersMarkdownScript2['default'](_level2c_eatMeFirstSignMd2['default']) },
	  '3a': { md: new _helpersMarkdownScript2['default'](_level3a_sortingGameMd2['default']) },
	  '3b': { md: new _helpersMarkdownScript2['default'](_level3b_foodScrapsRapMd2['default']) },
	  '4a': { md: new _helpersMarkdownScript2['default'](_level4a_lunchAnalysisMd2['default']) },
	  '4b': { md: new _helpersMarkdownScript2['default'](_level4b_collectiveImpactMathMd2['default']) },
	  '4c': { md: new _helpersMarkdownScript2['default'](_level4c_wasteFreeLunchPosterMd2['default']) },
	  '5a': { md: new _helpersMarkdownScript2['default'](_level5a_buySmartCodeMd2['default']) },
	  '5b': { md: new _helpersMarkdownScript2['default'](_level5b_skitMd2['default']) },
	  '6': { md: new _helpersMarkdownScript2['default'](_level6_biomimicryMd2['default']) }
	};
	
	function preloadClassActivity() {
	  (0, _spectaclePpa.preloader)([_imagesCharactersEsmeralda_hands_out_weheyPng2['default'], _imagesCharactersIan_headshot_smilePng2['default'], _imagesCharactersApprenticeHandsHips3Png2['default'], _imagesCharactersApprenticeArmsFolded2Png2['default'], _imagesCharactersApprenticesBackToBackPng2['default'], _imagesCharactersSara_surprisedPng2['default'], _imagesCharactersSara_twist_hands_out_heyheyPng2['default'], _imagesCharactersIan_pointing_upPng2['default'], _imagesCharactersIan_pointing_leftPng2['default'], _imagesCharactersIan_pointing_downPng2['default'], _imagesCharactersSara_smilePng2['default'], _imagesCharactersSara_humphPng2['default'], _imagesCharactersIan_sara_lean_questioningPng2['default'], _imagesCharactersIan_sidePng2['default']]);
	}
	
	function sizzle(level, regionData) {
	  var md = levels[level].md;
	  return (0, _baseSlidesBalloonSlide2['default'])({
	    id: 'sizzle',
	    characterSide: 'left',
	    characterImage: _imagesCharactersApprenticeHandsHips3Png2['default'],
	    notes: md.getSubSectionAsHtml('Sizzle', 'Notes', false, regionData),
	    html: md.getSubSectionAsHtml('Sizzle', 'Content', false, regionData)
	  });
	}
	
	function introVideo(level, regionData) {
	  var md = levels[level].md;
	  return (0, _baseSlidesVideoSlide2['default'])({
	    id: 'intro-video',
	    notes: md.getSubSectionAsHtml('Intro Video', 'Notes', false, regionData),
	    youTubeId: md.getSectionMetadata('Intro Video', 'YouTube', regionData)
	  });
	}
	
	function instructions(level, regionData) {
	  var md = levels[level].md;
	  return (0, _baseSlidesBalloonSlide2['default'])({
	    id: 'instructions',
	    characterSide: 'right',
	    characterImage: _imagesCharactersApprenticeArmsFolded2Png2['default'],
	    notes: md.getSubSectionAsHtml('Instructions', 'Notes', false, regionData),
	    html: md.getSubSectionAsHtml('Instructions', 'Content', false, regionData)
	  });
	}
	
	function scoring(level, regionData) {
	  var md = levels[level].md;
	  return (0, _baseSlidesBalloonSlide2['default'])({
	    id: 'scoring',
	    characterSide: 'right',
	    characterImage: _imagesCharactersApprenticesBackToBackPng2['default'],
	    notes: md.getSubSectionAsHtml('Scoring', 'Notes', false, regionData),
	    html: md.getSubSectionAsHtml('Scoring', 'Content', false, regionData)
	  });
	}
	
	function level1(regionData) {
	  // Group drawing
	  var level = '1';
	  var md = levels[level].md;
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'class-activity-' + level },
	    introVideo(level, regionData),
	    sizzle(level, regionData),
	    instructions(level, regionData),
	    scoring(level, regionData),
	    (0, _baseSlidesVideoSlide2['default'])({
	      id: 'wrap-up',
	      notes: md.getSubSectionAsHtml('Ian and Sara Outro', 'Notes', false, regionData),
	      youTubeId: md.getSectionMetadata('Ian and Sara Outro', 'YouTube', regionData)
	    })
	  );
	}
	
	function level2a(regionData) {
	  // Popcorn Joys
	  var level = '2a';
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'class-activity-' + level },
	    introVideo(level, regionData),
	    instructions(level, regionData)
	  );
	}
	
	function level2b(regionData) {
	  // Waste math
	  var level = '2b';
	  var md = levels[level].md;
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'class-activity-' + level },
	    (0, _baseSlidesVideoSlide2['default'])({
	      id: 'intro-video',
	      notes: md.getSubSectionAsHtml('Intro Video', 'Notes', false, regionData),
	      youTubeId: md.getSectionMetadata('Intro Video', 'YouTube', regionData)
	    }),
	    sizzle(level, regionData),
	    instructions(level, regionData),
	    (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'question',
	      characterSide: 'left',
	      characterImage: _imagesCharactersIan_headshot_smilePng2['default'],
	      notes: md.getSubSectionAsHtml('Question', 'Notes', false, regionData),
	      html: md.getSubSectionAsHtml('Question', 'Content', false, regionData)
	    }),
	    (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'answer',
	      characterSide: 'right',
	      characterImage: _imagesCharactersSara_surprisedPng2['default'],
	      notes: md.getSubSectionAsHtml('Answer', 'Notes', false, regionData),
	      html: md.getSubSectionAsHtml('Answer', 'Content', false, regionData)
	    })
	  );
	}
	
	function level2c(regionData) {
	  // Eat me first box
	  var level = '2c';
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'class-activity-' + level },
	    sizzle(level, regionData),
	    instructions(level, regionData)
	  );
	}
	
	function level3a(regionData) {
	  // Sorting Game
	  var level = '3a';
	  var md = levels[level].md;
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'class-activity-' + level },
	    introVideo(level, regionData),
	    sizzle(level, regionData),
	    instructions(level, regionData),
	    scoring(level, regionData),
	    (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'start',
	      characterSide: 'right',
	      characterImage: _imagesCharactersSara_twist_hands_out_heyheyPng2['default'],
	      notes: md.getSubSectionAsHtml('Start Sorting Game', 'Notes', false, regionData),
	      html: md.getSubSectionAsHtml('Start Sorting Game', 'Content', false, regionData)
	    }),
	    (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'results',
	      characterSide: 'left',
	      characterImage: _imagesCharactersIan_sara_lean_questioningPng2['default'],
	      notes: md.getSubSectionAsHtml('Results', 'Notes', false, regionData),
	      html: md.getSubSectionAsHtml('Results', 'Content', false, regionData)
	    })
	  );
	}
	
	function level3b(regionData) {
	  // Food scraps rap
	  var level = '3b';
	  var md = levels[level].md;
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'class-activity-' + level },
	    introVideo(level, regionData),
	    sizzle(level, regionData),
	    instructions(level, regionData),
	    (0, _baseSlidesVideoSlide2['default'])({
	      id: 'rap-backtrack-practice',
	      notes: md.getSubSectionAsHtml('Rap Backtrack Practice', 'Notes', false, regionData),
	      youTubeId: md.getSectionMetadata('Rap Backtrack Practice', 'YouTube', regionData)
	    }),
	    scoring(level, regionData),
	    (0, _baseSlidesVideoSlide2['default'])({
	      id: 'rap-backtrack-perform',
	      notes: md.getSubSectionAsHtml('Rap Backtrack Perform', 'Notes', false, regionData),
	      youTubeId: md.getSectionMetadata('Rap Backtrack Perform', 'YouTube', regionData)
	    })
	  );
	}
	
	function level4a(regionData) {
	  // Lunch analysis
	  var level = '4a';
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'class-activity-' + level },
	    introVideo(level, regionData),
	    sizzle(level, regionData),
	    instructions(level, regionData)
	  );
	}
	
	function level4b(regionData) {
	  // Collective impact math
	  var level = '4b';
	  var md = levels[level].md;
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'class-activity-' + level },
	    introVideo(level, regionData),
	    sizzle(level, regionData),
	    (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'question-1',
	      characterSide: 'left',
	      characterImage: _imagesCharactersIan_pointing_upPng2['default'],
	      notes: md.getSubSectionAsHtml('Question 1', 'Notes', false, regionData),
	      html: md.getSubSectionAsHtml('Question 1', 'Content', false, regionData)
	    }),
	    (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'answer-1',
	      characterSide: 'right',
	      characterImage: _imagesCharactersSara_smilePng2['default'],
	      notes: md.getSubSectionAsHtml('Answer 1', 'Notes', false, regionData),
	      html: md.getSubSectionAsHtml('Answer 1', 'Content', false, regionData)
	    }),
	    (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'question-2',
	      characterSide: 'right',
	      characterImage: _imagesCharactersIan_pointing_leftPng2['default'],
	      notes: md.getSubSectionAsHtml('Question 2', 'Notes', false, regionData),
	      html: md.getSubSectionAsHtml('Question 2', 'Content', false, regionData)
	    }),
	    (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'answer-2',
	      characterSide: 'left',
	      characterImage: _imagesCharactersSara_humphPng2['default'],
	      notes: md.getSubSectionAsHtml('Answer 2', 'Notes', false, regionData),
	      html: md.getSubSectionAsHtml('Answer 2', 'Content', false, regionData)
	    }),
	    (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'question-3',
	      characterSide: 'left',
	      characterImage: _imagesCharactersIan_pointing_downPng2['default'],
	      notes: md.getSubSectionAsHtml('Question 3', 'Notes', false, regionData),
	      html: md.getSubSectionAsHtml('Question 3', 'Content', false, regionData)
	    }),
	    (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'answer-3',
	      characterSide: 'right',
	      characterImage: _imagesCharactersSara_surprisedPng2['default'],
	      notes: md.getSubSectionAsHtml('Answer 3', 'Notes', false, regionData),
	      html: md.getSubSectionAsHtml('Answer 3', 'Content', false, regionData)
	    }),
	    (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'collective-impact',
	      characterSide: 'right',
	      characterImage: _imagesCharactersSara_twist_hands_out_heyheyPng2['default'],
	      notes: md.getSubSectionAsHtml('Collective Impact', 'Notes', false, regionData),
	      html: md.getSubSectionAsHtml('Collective Impact', 'Content', false, regionData)
	    })
	  );
	}
	
	function level4c(regionData) {
	  // Waste-free lunch poster
	  var level = '4c';
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'class-activity-' + level },
	    sizzle(level, regionData),
	    instructions(level, regionData),
	    scoring(level, regionData)
	  );
	}
	
	function level5a(regionData) {
	  // Buy Smart Code
	  var level = '5a';
	  var md = levels[level].md;
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'class-activity-' + level },
	    introVideo(level, regionData),
	    sizzle(level, regionData),
	    instructions(level, regionData),
	    (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'es-buy-smart-code',
	      characterSide: 'left',
	      characterImage: _imagesCharactersEsmeralda_hands_out_weheyPng2['default'],
	      notes: md.getSubSectionAsHtml('Es Buy Smart Code', 'Notes', false, regionData),
	      html: md.getSubSectionAsHtml('Es Buy Smart Code', 'Content', false, regionData)
	    }),
	    (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'write-in-mission-file',
	      characterSide: 'right',
	      characterImage: _imagesCharactersSara_smilePng2['default'],
	      notes: md.getSubSectionAsHtml('Write Class Buy Smart Code', 'Notes', false, regionData),
	      html: md.getSubSectionAsHtml('Write Class Buy Smart Code', 'Content', false, regionData)
	    })
	  );
	}
	
	function level5b(regionData) {
	  // Skit
	  var level = '5b';
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'class-activity-' + level },
	    introVideo(level, regionData),
	    sizzle(level, regionData),
	    instructions(level, regionData)
	  );
	}
	
	function level6(regionData) {
	  // Biomimicry
	  var level = '6';
	  var md = levels[level].md;
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'class-activity-' + level },
	    sizzle(level, regionData),
	    (0, _baseSlidesVideoSlide2['default'])({
	      id: 'biomimicry-intro',
	      notes: md.getSubSectionAsHtml('Intro to Biomimicry', 'Notes', false, regionData),
	      youTubeId: md.getSectionMetadata('Intro to Biomimicry', 'YouTube', regionData)
	    }),
	    (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'biomimicry-info',
	      characterSide: 'right',
	      characterImage: _imagesCharactersSara_humphPng2['default'],
	      notes: md.getSubSectionAsHtml('Biomimicry Info', 'Notes', false, regionData),
	      html: md.getSubSectionAsHtml('Biomimicry Info', 'Content', false, regionData)
	    }),
	    (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'class-brainstorm',
	      characterSide: 'right',
	      characterImage: _imagesCharactersIan_sidePng2['default'],
	      notes: md.getSubSectionAsHtml('Class Brainstorm', 'Notes', false, regionData),
	      html: md.getSubSectionAsHtml('Class Brainstorm', 'Content', false, regionData)
	    }),
	    (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'nature-principals',
	      characterSide: 'right',
	      characterImage: _imagesCharactersSara_surprisedPng2['default'],
	      notes: md.getSubSectionAsHtml('Nature Principles', 'Notes', false, regionData),
	      html: md.getSubSectionAsHtml('Nature Principles', 'Content', false, regionData)
	    }),
	    (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'design-a-product',
	      characterSide: 'right',
	      characterImage: _imagesCharactersIan_pointing_upPng2['default'],
	      notes: md.getSubSectionAsHtml('Design a Product', 'Notes', false, regionData),
	      html: md.getSubSectionAsHtml('Design a Product', 'Content', false, regionData)
	    })
	  );
	}
	
	function classActivitySection(_ref) {
	  var level = _ref.level;
	  var subActivity = _ref.subActivity;
	  var regionData = _ref.regionData;
	
	  switch ('' + level + (subActivity ? subActivity : '')) {
	    case '1':
	      return level1(regionData);
	    case '2a':
	      return level2a(regionData);
	    case '2b':
	      return level2b(regionData);
	    case '2c':
	      return level2c(regionData);
	    case '3a':
	      return level3a(regionData);
	    case '3b':
	      return level3b(regionData);
	    case '4a':
	      return level4a(regionData);
	    case '4b':
	      return level4b(regionData);
	    case '4c':
	      return level4c(regionData);
	    case '5a':
	      return level5a(regionData);
	    case '5b':
	      return level5b(regionData);
	    case '6':
	      return level6(regionData);
	    default:
	      return (0, _baseSlidesHeadingSlide2['default'])({ heading: 'Unknown' });
	  }
	}
	
	exports['default'] = classActivitySection;
	/* Intro Video */ /* Sizzle */ /* Instructions */ /* Scoring */ /* Ian and Sara Outro */ /* Intro Video */ /* Instructions */ /* Intro to Math Challenge */ /* Sizzle */ /* Instructions */ /* Question */ /* Answer */ /* Sizzle */ /* Instructions */ /* Intro Video */ /* Sizzle */ /* Instructions */ /* Scoring */ /* Start the Sorting Game */ /* Results */ /* Intro Video */ /* Sizzle */ /* Instructions */ /* Rap Backtrack Practice */ /* Scoring */ /* Rap Backtrack Perform */ /* Intro Video */ /* Sizzle */ /* Instructions */ /* Intro Video */ /* Sizzle */ /* Question 1 */ /* Answer 1 */ /* Question 2 */ /* Answer 2 */ /* Question 3 */ /* Answer 3 */ /* Collective Impact */ /* Sizzle */ /* Instructions */ /* Scoring */ /* Intro Video */ /* Sizzle */ /* Instructions */ /* Es Buy Smart Code */ /* Write your class Buy Smart Code in Mission File */ /* Intro Video */ /* Sizzle */ /* Instructions */ /* Sizzle */ /* Intro to Biomimicry */ /* Biomimicry Info */ /* Class Brainstorm */ /* Nature Principles */ /* Design a Product */

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

	/* eslint react/no-multi-comp: 0 */
	
	'use strict';
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _baseSlidesVideoSlide = __webpack_require__(43);
	
	var _baseSlidesVideoSlide2 = _interopRequireDefault(_baseSlidesVideoSlide);
	
	var _helpersMarkdownScript = __webpack_require__(9);
	
	var _helpersMarkdownScript2 = _interopRequireDefault(_helpersMarkdownScript);
	
	var _level1_closingMd = __webpack_require__(1860);
	
	var _level1_closingMd2 = _interopRequireDefault(_level1_closingMd);
	
	var _level2_closingMd = __webpack_require__(1861);
	
	var _level2_closingMd2 = _interopRequireDefault(_level2_closingMd);
	
	var _level3_closingMd = __webpack_require__(1862);
	
	var _level3_closingMd2 = _interopRequireDefault(_level3_closingMd);
	
	var _level4_closingMd = __webpack_require__(1863);
	
	var _level4_closingMd2 = _interopRequireDefault(_level4_closingMd);
	
	var _level5_closingMd = __webpack_require__(1864);
	
	var _level5_closingMd2 = _interopRequireDefault(_level5_closingMd);
	
	var _level6_closingMd = __webpack_require__(1865);
	
	var _level6_closingMd2 = _interopRequireDefault(_level6_closingMd);
	
	var levels = {
	  '1': { md: new _helpersMarkdownScript2['default'](_level1_closingMd2['default']) },
	  '2': { md: new _helpersMarkdownScript2['default'](_level2_closingMd2['default']) },
	  '3': { md: new _helpersMarkdownScript2['default'](_level3_closingMd2['default']) },
	  '4': { md: new _helpersMarkdownScript2['default'](_level4_closingMd2['default']) },
	  '5': { md: new _helpersMarkdownScript2['default'](_level5_closingMd2['default']) },
	  '6': { md: new _helpersMarkdownScript2['default'](_level6_closingMd2['default']) }
	};
	
	function esClosingStory(_ref) {
	  var level = _ref.level;
	  var regionData = _ref.regionData;
	
	  var md = levels[level].md;
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'closing' },
	    (level === 2 || level === 6) && (0, _baseSlidesVideoSlide2['default'])({
	      id: 'intro-video',
	      notes: md.getSubSectionAsHtml('Ian and Sara Intro', 'Notes', false, regionData),
	      youTubeId: md.getSectionMetadata('Ian and Sara Intro', 'YouTube', regionData)
	    }),
	    (0, _baseSlidesVideoSlide2['default'])({
	      id: 'story',
	      notes: md.getSubSectionAsHtml('Esmeralda and Goober Closing Story', 'Notes', false, regionData),
	      youTubeId: md.getSectionMetadata('Esmeralda and Goober Closing Story', 'YouTube', regionData)
	    })
	  );
	}
	
	exports['default'] = esClosingStory;
	module.exports = exports['default'];
	/* Intro to Es Closing in Levels 1 + 2 */ /* Framing Story Closing */

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

	/* eslint no-unused-vars: 0 */
	'use strict';
	
	var _extends = __webpack_require__(7)['default'];
	
	var _objectWithoutProperties = __webpack_require__(16)['default'];
	
	var _Object$keys = __webpack_require__(32)['default'];
	
	var _Promise = __webpack_require__(33)['default'];
	
	var _regeneratorRuntime = __webpack_require__(492)['default'];
	
	var _Object$values = __webpack_require__(1201)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.bindUnapprovedSessions = bindUnapprovedSessions;
	exports.unbindUnapprovedSessions = unbindUnapprovedSessions;
	exports.approveSession = approveSession;
	exports.hideSession = hideSession;
	exports.findSession = findSession;
	exports.findUser = findUser;
	exports.reassignSession = reassignSession;
	exports.cancelFundedSpot = cancelFundedSpot;
	exports.refundSession = refundSession;
	exports.changeSessionContractId = changeSessionContractId;
	exports.changeSessionValidUntil = changeSessionValidUntil;
	exports.unarchiveSession = unarchiveSession;
	exports.userDeleted = userDeleted;
	exports.deleteUser = deleteUser;
	exports.toggleTester = toggleTester;
	exports.bindOnHoldSessions = bindOnHoldSessions;
	exports.unbindOnHoldSessions = unbindOnHoldSessions;
	exports.putOnHold = putOnHold;
	exports.changeProgram = changeProgram;
	exports.resetEditUserForm = resetEditUserForm;
	exports.editUser = editUser;
	
	var _servicesFirebaseRef = __webpack_require__(74);
	
	var _servicesFirebaseRef2 = _interopRequireDefault(_servicesFirebaseRef);
	
	var _servicesPayment = __webpack_require__(302);
	
	var _servicesEvents = __webpack_require__(73);
	
	var _helpersI18n = __webpack_require__(14);
	
	var _reduxForm = __webpack_require__(36);
	
	var _appConfig = __webpack_require__(54);
	
	var _servicesAjax = __webpack_require__(230);
	
	var SESSION_UNARCHIVE = 'SESSION_UNARCHIVE';
	exports.SESSION_UNARCHIVE = SESSION_UNARCHIVE;
	var UNAPPROVED_SESSIONS = 'UNAPPROVED_SESSIONS';
	exports.UNAPPROVED_SESSIONS = UNAPPROVED_SESSIONS;
	var PAYWALL_PROFILE_LOADED = 'PAYWALL_PROFILE_LOADED';
	exports.PAYWALL_PROFILE_LOADED = PAYWALL_PROFILE_LOADED;
	var PAYWALL_SESSION_APPROVE = 'PAYWALL_SESSION_APPROVE';
	exports.PAYWALL_SESSION_APPROVE = PAYWALL_SESSION_APPROVE;
	var PAYWALL_SESSION_HIDE = 'PAYWALL_SESSION_HIDE';
	exports.PAYWALL_SESSION_HIDE = PAYWALL_SESSION_HIDE;
	var PAYWALL_SESSION_FOUND = 'PAYWALL_SESSION_FOUND';
	exports.PAYWALL_SESSION_FOUND = PAYWALL_SESSION_FOUND;
	var PAYWALL_USER_FOUND = 'PAYWALL_USER_FOUND';
	exports.PAYWALL_USER_FOUND = PAYWALL_USER_FOUND;
	var PAYWALL_SESSION_REASSIGN = 'PAYWALL_SESSION_REASSIGN';
	exports.PAYWALL_SESSION_REASSIGN = PAYWALL_SESSION_REASSIGN;
	var PAYWALL_FUNDEDSPOT_CANCEL = 'PAYWALL_FUNDEDSPOT_CANCEL';
	exports.PAYWALL_FUNDEDSPOT_CANCEL = PAYWALL_FUNDEDSPOT_CANCEL;
	var PAYWALL_SESSION_REFUND = 'PAYWALL_SESSION_REFUND';
	exports.PAYWALL_SESSION_REFUND = PAYWALL_SESSION_REFUND;
	var PAYWALL_SESSION_CONTRACTID_CHANGE = 'PAYWALL_SESSION_CONTRACTID_CHANGE';
	exports.PAYWALL_SESSION_CONTRACTID_CHANGE = PAYWALL_SESSION_CONTRACTID_CHANGE;
	var PAYWALL_SESSION_VALIDUNTIL_CHANGE = 'PAYWALL_SESSION_VALIDUNTIL_CHANGE';
	exports.PAYWALL_SESSION_VALIDUNTIL_CHANGE = PAYWALL_SESSION_VALIDUNTIL_CHANGE;
	var PAYWALL_USER_DELETED = 'PAYWALL_USER_DELETED';
	exports.PAYWALL_USER_DELETED = PAYWALL_USER_DELETED;
	var PAYWALL_USER_TOGGLE_TESTER = 'PAYWALL_USER_TESTER_TOGGLED';
	exports.PAYWALL_USER_TOGGLE_TESTER = PAYWALL_USER_TOGGLE_TESTER;
	var PAYWALL_ONHOLD_SESSIONS = 'PAYWALL_ONHOLD_SESSIONS';
	exports.PAYWALL_ONHOLD_SESSIONS = PAYWALL_ONHOLD_SESSIONS;
	var PAYWALL_SESSION_ON_HOLD = 'PAYWALL_SESSION_ON_HOLD';
	exports.PAYWALL_SESSION_ON_HOLD = PAYWALL_SESSION_ON_HOLD;
	var PAYWALL_SESSION_PROGRAM_CHANGE = 'PAYWALL_SESSION_PROGRAM_CHANGE';
	exports.PAYWALL_SESSION_PROGRAM_CHANGE = PAYWALL_SESSION_PROGRAM_CHANGE;
	var PAYWALL_ERROR = 'PAYWALL_ERROR';
	
	exports.PAYWALL_ERROR = PAYWALL_ERROR;
	function getSessionById(sessionId) {
	  return _servicesFirebaseRef2['default'].child('sessions').child(sessionId).once('value').then(function (sessionRef) {
	    return (0, _helpersI18n.withDefaultLanguageIfNotPresent)(sessionRef.val());
	  });
	}
	
	function withDefaultLanguage(sessions) {
	  return _Object$keys(sessions).reduce(function (a, c) {
	    a[c] = (0, _helpersI18n.withDefaultLanguageIfNotPresent)(sessions[c]);
	    return a;
	  }, {});
	}
	
	function paywallProfileLoaded(_ref) {
	  var userId = _ref.userId;
	  var profileData = _ref.profileData;
	
	  return {
	    type: PAYWALL_PROFILE_LOADED,
	    userId: userId,
	    profileData: profileData
	  };
	}
	
	function bindSingleProfile(userId, refs) {
	  return function (dispatch) {
	    var profileRef = _servicesFirebaseRef2['default'].child('users').child(userId);
	    profileRef.on('value', function (snapshot) {
	      var value = snapshot.val();
	      if (!value) {
	        return;
	      }
	      var profile = value.profile;
	      var createdAt = value.createdAt;
	
	      var profileData = _extends({
	        createdAt: createdAt
	      }, profile);
	      dispatch(paywallProfileLoaded({ userId: userId, profileData: profileData }));
	    });
	    refs.profiles[userId] = profileRef;
	  };
	}
	
	function unapprovedSessions(sessions) {
	  return {
	    type: UNAPPROVED_SESSIONS,
	    sessions: withDefaultLanguage(sessions)
	  };
	}
	
	function removeOnHold(sessions) {
	  if (!sessions) return sessions;
	  var filtered = {};
	  _Object$keys(sessions).forEach(function (sessionId) {
	    if (sessions[sessionId].onHold) return;
	    filtered[sessionId] = sessions[sessionId];
	  });
	  return filtered;
	}
	
	function bindUnapprovedSessions(refs) {
	  return function (dispatch) {
	    var sessionsRef = _servicesFirebaseRef2['default'].child('sessions').orderByChild('pendingApproval').equalTo(true);
	    refs.sessions = sessionsRef;
	    refs.profiles = {};
	    sessionsRef.on('value', function (snapshot) {
	      var sessions = removeOnHold(snapshot.val());
	      dispatch(unapprovedSessions(sessions));
	      if (!sessions) {
	        return;
	      }
	      _Object$keys(sessions).forEach(function (sessionId) {
	        var userId = sessions[sessionId].userId;
	
	        if (!refs.profiles[userId]) {
	          dispatch(bindSingleProfile(userId, refs));
	        }
	      });
	    });
	  };
	}
	
	function unbindUnapprovedSessions(refs) {
	  return function () {
	    refs.sessions.off();
	    _Object$keys(refs.profiles).forEach(function (userId) {
	      refs.profiles[userId].off();
	    });
	  };
	}
	
	function sessionApprove(_ref2) {
	  var sessionId = _ref2.sessionId;
	  var contractId = _ref2.contractId;
	
	  return {
	    type: PAYWALL_SESSION_APPROVE,
	    sessionId: sessionId,
	    contractId: contractId
	  };
	}
	
	function approveSession(_ref3) {
	  var sessionId = _ref3.sessionId;
	  var contractId = _ref3.contractId;
	  var staffUserId = _ref3.staffUserId;
	  var userId = _ref3.userId;
	  var email = _ref3.email;
	  var programId = _ref3.programId;
	  var grade = _ref3.grade;
	  var divisionName = _ref3.divisionName;
	  var numberOfStudents = _ref3.numberOfStudents;
	  var noEmail = _ref3.noEmail;
	  var language = _ref3.language;
	
	  var validUntil = (0, _servicesPayment.getValidUntilTime)();
	  return function (dispatch) {
	    var approvedAt = _servicesFirebaseRef.TIMESTAMP;
	    var updatedAt = _servicesFirebaseRef.TIMESTAMP;
	    return _servicesFirebaseRef2['default'].child('sessions').child(sessionId).update({
	      pendingApproval: false,
	      onHold: false,
	      funding: 'CONTRACT',
	      staffUserId: staffUserId,
	      contractId: contractId,
	      approvedAt: approvedAt,
	      updatedAt: updatedAt,
	      validUntil: validUntil
	    }).then(function () {
	      (0, _servicesEvents.sendClassApprovedEvents)({
	        userId: userId, sessionId: sessionId, programId: programId, contractId: contractId, staffUserId: staffUserId, validUntil: validUntil, noEmail: noEmail, language: language
	      });
	    }).then(function () {
	      return dispatch(sessionApprove({ sessionId: sessionId, contractId: contractId }));
	    });
	  };
	}
	
	function sessionHide(_ref4) {
	  var sessionId = _ref4.sessionId;
	
	  return {
	    type: PAYWALL_SESSION_HIDE,
	    sessionId: sessionId
	  };
	}
	
	function hideSession(_ref5) {
	  var sessionId = _ref5.sessionId;
	  var staffUserId = _ref5.staffUserId;
	  var userId = _ref5.userId;
	  var email = _ref5.email;
	  var programId = _ref5.programId;
	  var grade = _ref5.grade;
	  var divisionName = _ref5.divisionName;
	  var numberOfStudents = _ref5.numberOfStudents;
	  var noEmail = _ref5.noEmail;
	
	  return function (dispatch) {
	    var hiddenAt = _servicesFirebaseRef.TIMESTAMP;
	    var updatedAt = _servicesFirebaseRef.TIMESTAMP;
	    return _servicesFirebaseRef2['default'].child('sessions').child(sessionId).update({
	      pendingApproval: false,
	      onHold: false,
	      staffUserId: staffUserId,
	      hiddenAt: hiddenAt,
	      updatedAt: updatedAt
	    }).then(function () {
	      return getSessionById(sessionId);
	    }).then(function (_ref6) {
	      var language = _ref6.language;
	
	      var payload = {
	        userId: userId,
	        sessionId: sessionId,
	        programId: programId,
	        staffUserId: staffUserId,
	        language: language
	      };
	      if (!noEmail) {
	        (0, _servicesEvents.publishEvent)('Class Rejected Nurture Campaign Started', payload);
	      }
	      (0, _servicesEvents.publishEvent)('Class Rejected', payload);
	    }).then(function () {
	      return dispatch(sessionHide({ sessionId: sessionId }));
	    });
	  };
	}
	
	function sessionFound(session, user) {
	  return {
	    type: PAYWALL_SESSION_FOUND,
	    session: (0, _helpersI18n.withDefaultLanguageIfNotPresent)(session),
	    user: user
	  };
	}
	
	function findSession(sessionId) {
	  return function (dispatch) {
	    console.log('findSession', sessionId);
	    if (!sessionId) {
	      return dispatch(sessionFound());
	    }
	    return new _Promise(function (resolve, reject) {
	      _servicesFirebaseRef2['default'].child('sessions').orderByKey().startAt(sessionId).limitToFirst(1).once('child_added', function (snapshot) {
	        if (snapshot && snapshot.key === sessionId) {
	          return resolve(snapshot.val());
	        }
	        resolve();
	      }, reject);
	    }).then(function (session) {
	      if (!session) {
	        return dispatch(sessionFound());
	      }
	
	      var sessionValues = _objectWithoutProperties(session, []);
	
	      var sessionWithId = _extends({}, sessionValues, {
	        sessionId: sessionId
	      });
	      return new _Promise(function (resolve, reject) {
	        _servicesFirebaseRef2['default'].child('users').child(sessionWithId.userId).once('value', function (snapshot) {
	          if (snapshot) {
	            return resolve(snapshot.val());
	          }
	          reject();
	        });
	      }).then(function (user) {
	        var userValues = _objectWithoutProperties(user, []);
	
	        var userWithId = _extends({}, userValues, {
	          userId: sessionWithId.userId
	        });
	        return dispatch(sessionFound(sessionWithId, userWithId));
	      });
	    });
	  };
	}
	
	function userFound(user) {
	  return {
	    type: PAYWALL_USER_FOUND,
	    user: user
	  };
	}
	
	function getSession(sessionId) {
	  return new _Promise(function (resolve, reject) {
	    _servicesFirebaseRef2['default'].child('sessions').child(sessionId).once('value', function (snapshot) {
	      if (snapshot && snapshot.key === sessionId) {
	        var value = snapshot.val();
	        return resolve(_extends({}, value, { sessionId: sessionId }));
	      }
	      resolve();
	    }, reject);
	  });
	}
	
	function findUser(userId) {
	  var _this = this;
	
	  return function (dispatch) {
	    return new _Promise(function (resolve, reject) {
	      _servicesFirebaseRef2['default'].child('users').child(userId).once('value', function (snapshot) {
	        if (snapshot && snapshot.key === userId) {
	          return resolve(snapshot.val());
	        }
	        resolve();
	      }, reject);
	    }).then(function callee$2$0(user) {
	      var promises;
	      return _regeneratorRuntime.async(function callee$2$0$(context$3$0) {
	        while (1) switch (context$3$0.prev = context$3$0.next) {
	          case 0:
	            if (user) {
	              context$3$0.next = 2;
	              break;
	            }
	
	            return context$3$0.abrupt('return', user);
	
	          case 2:
	            promises = _Object$values(user.sessions).map(getSession);
	            context$3$0.next = 5;
	            return _regeneratorRuntime.awrap(_Promise.all(promises));
	
	          case 5:
	            user.sessions = context$3$0.sent;
	            return context$3$0.abrupt('return', user);
	
	          case 7:
	          case 'end':
	            return context$3$0.stop();
	        }
	      }, null, _this);
	    }).then(function (user) {
	      if (!user) {
	        return dispatch(userFound());
	      }
	      return dispatch(userFound(_extends({}, user, { userId: userId })));
	    });
	  };
	}
	
	function sessionReAssign(sessionId, programId, oldUserId, newUserId) {
	  return {
	    type: PAYWALL_SESSION_REASSIGN,
	    sessionId: sessionId,
	    programId: programId,
	    oldUserId: oldUserId,
	    newUserId: newUserId
	  };
	}
	
	function reassignSession(_ref7) {
	  var sessionId = _ref7.sessionId;
	  var programId = _ref7.programId;
	  var oldUserId = _ref7.oldUserId;
	  var newUserId = _ref7.newUserId;
	  var staffUserId = _ref7.staffUserId;
	  var funding = _ref7.funding;
	  var contractId = _ref7.contractId;
	  var language = _ref7.language;
	
	  return function (dispatch) {
	    return _servicesFirebaseRef2['default'].child('sessions').child(sessionId).update({
	      userId: newUserId,
	      staffUserId: staffUserId,
	      updatedAt: _servicesFirebaseRef.TIMESTAMP
	    }).then(function () {
	      return _servicesFirebaseRef2['default'].child('users').child(newUserId).child('sessions').push(sessionId);
	    }).then(function () {
	      (0, _servicesEvents.publishEvent)('Class Assigned', {
	        userId: newUserId,
	        sessionId: sessionId,
	        programId: programId,
	        oldUserId: oldUserId,
	        staffUserId: staffUserId,
	        language: language
	      });
	    }).then(function () {
	      return new _Promise(function (resolve, reject) {
	        _servicesFirebaseRef2['default'].child('users').child(oldUserId).child('sessions').orderByValue().startAt(sessionId).limitToFirst(1).once('child_added', function (snapshot) {
	          snapshot.ref.remove(function (err) {
	            if (err) return reject(err);
	            resolve();
	          });
	        }, reject);
	      });
	    }).then(function () {
	      (0, _servicesEvents.publishEvent)('Class Re-Assigned', {
	        userId: oldUserId,
	        sessionId: sessionId,
	        programId: programId,
	        newUserId: newUserId,
	        staffUserId: staffUserId,
	        language: language
	      });
	    }).then(function () {
	      dispatch(sessionReAssign(sessionId, programId, oldUserId, newUserId));
	    });
	  };
	}
	
	function fundedSpotCancel(sessionId, programId) {
	  return {
	    type: PAYWALL_FUNDEDSPOT_CANCEL,
	    sessionId: sessionId,
	    programId: programId
	  };
	}
	
	function cancelFundedSpot(sessionId, programId, userId, staffUserId) {
	  return function (dispatch) {
	    return _servicesFirebaseRef2['default'].child('sessions').child(sessionId).update({
	      contractId: '',
	      funding: 'CANCELLED',
	      updatedAt: _servicesFirebaseRef.TIMESTAMP,
	      staffUserId: staffUserId,
	      validUntil: null
	    }).then(function () {
	      return getSessionById(sessionId);
	    }).then(function (_ref8) {
	      var language = _ref8.language;
	
	      (0, _servicesEvents.publishEvent)('Funded Spot Cancelled', {
	        userId: userId,
	        sessionId: sessionId,
	        programId: programId,
	        staffUserId: staffUserId,
	        language: language
	      });
	      return dispatch(fundedSpotCancel(sessionId, programId));
	    });
	  };
	}
	
	function sessionRefund(sessionId, programId) {
	  return {
	    type: PAYWALL_SESSION_REFUND,
	    sessionId: sessionId,
	    programId: programId
	  };
	}
	
	function refundSession(sessionId, sessionFunding, programId, userId, staffUserId) {
	  return function (dispatch) {
	    if (sessionFunding.toUpperCase() !== 'STRIPE') {
	      return _Promise.reject(new Error('You can\'t refund a class with a funding of ' + sessionFunding + '.'));
	    }
	    return _servicesFirebaseRef2['default'].child('sessions').child(sessionId).update({
	      funding: 'REFUNDED',
	      updatedAt: _servicesFirebaseRef.TIMESTAMP,
	      validUntil: null,
	      staffUserId: staffUserId
	    }).then(function () {
	      return getSessionById(sessionId);
	    }).then(function (_ref9) {
	      var language = _ref9.language;
	
	      (0, _servicesEvents.publishEvent)('Class Refunded', {
	        userId: userId,
	        sessionId: sessionId,
	        programId: programId,
	        staffUserId: staffUserId,
	        language: language
	      });
	      return dispatch(sessionRefund(sessionId, programId));
	    });
	  };
	}
	
	function sessionContractIdChange(sessionId, programId, newContractId) {
	  return {
	    type: PAYWALL_SESSION_CONTRACTID_CHANGE,
	    sessionId: sessionId,
	    programId: programId,
	    newContractId: newContractId
	  };
	}
	
	function changeSessionContractId(sessionId, programId, userId, staffUserId, oldContractId, newContractId) {
	  return function (dispatch) {
	    return _servicesFirebaseRef2['default'].child('sessions').child(sessionId).update({
	      contractId: newContractId,
	      updatedAt: _servicesFirebaseRef.TIMESTAMP,
	      staffUserId: staffUserId
	    }).then(function () {
	      (0, _servicesEvents.publishEvent)('Class Contract ID Changed', {
	        userId: userId,
	        sessionId: sessionId,
	        programId: programId,
	        oldContractId: oldContractId,
	        newContractId: newContractId,
	        staffUserId: staffUserId
	      });
	      dispatch(sessionContractIdChange(sessionId, programId, newContractId));
	    });
	  };
	}
	
	function sessionValidUntilChange(sessionId, programId, newValidUntil) {
	  return {
	    type: PAYWALL_SESSION_VALIDUNTIL_CHANGE,
	    sessionId: sessionId,
	    programId: programId,
	    newValidUntil: newValidUntil
	  };
	}
	
	function changeSessionValidUntil(sessionId, programId, userId, staffUserId, oldValidUntil, newValidUntil) {
	  return function (dispatch) {
	    return _servicesFirebaseRef2['default'].child('sessions').child(sessionId).update({
	      validUntil: newValidUntil,
	      staffUserId: staffUserId
	    }).then(function () {
	      (0, _servicesEvents.publishEvent)('Class Valid Until Changed', {
	        eventType: 'Class Valid Until Changed',
	        userId: userId,
	        sessionId: sessionId,
	        programId: programId,
	        oldValidUntil: oldValidUntil,
	        newValidUntil: newValidUntil,
	        staffUserId: staffUserId
	      }, ['oldValidUntil', 'newValidUntil']);
	      dispatch(sessionValidUntilChange(sessionId, programId, newValidUntil));
	    });
	  };
	}
	
	function sessionUnarchive(sessionId) {
	  return {
	    type: SESSION_UNARCHIVE,
	    sessionId: sessionId
	  };
	}
	
	function unarchiveSession(_ref10) {
	  var sessionId = _ref10.sessionId;
	  var programId = _ref10.programId;
	  var userId = _ref10.userId;
	  var staffUserId = _ref10.staffUserId;
	
	  return function (dispatch) {
	    return new _Promise(function (resolve, reject) {
	      _servicesFirebaseRef2['default'].child('sessions').child(sessionId).update({
	        archived: null,
	        pendingApproval: false,
	        updatedAt: _servicesFirebaseRef.TIMESTAMP,
	        archivedAt: null,
	        staffUserId: staffUserId
	      }, function (error) {
	        if (error) {
	          reject(error);
	        } else {
	          resolve();
	        }
	      });
	    }).then(function () {
	      return getSessionById(sessionId);
	    }).then(function (_ref11) {
	      var language = _ref11.language;
	
	      (0, _servicesEvents.publishEvent)('Class Unarchived', {
	        userId: userId,
	        sessionId: sessionId,
	        programId: programId,
	        staffUserId: staffUserId,
	        language: language
	      });
	      return dispatch(sessionUnarchive(sessionId));
	    });
	  };
	}
	
	function userDeleted(userId) {
	  return {
	    type: PAYWALL_USER_DELETED,
	    userId: userId
	  };
	}
	
	function deleteUser(_ref12) {
	  var userId = _ref12.userId;
	  var staffUserId = _ref12.staffUserId;
	
	  return function (dispatch) {
	    var userRef = _servicesFirebaseRef2['default'].child('users').child(userId);
	    var updatedFields = {
	      firstName: 'Deleted',
	      lastName: 'Deleted',
	      phone: 'Deleted',
	      email: 'Deleted',
	      school: 'Deleted',
	      cityOrMunicipality: 'Deleted',
	      stateOrProvince: 'Deleted',
	      country: 'Deleted'
	    };
	    return userRef.child('profile').update(updatedFields).then(function () {
	      return userRef.update({
	        updatedAt: _servicesFirebaseRef.TIMESTAMP,
	        isDeleted: true
	      });
	    }).then(function () {
	      (0, _servicesEvents.publishEvent)('User Deleted', _extends({ userId: userId, staffUserId: staffUserId }, updatedFields));
	      return dispatch(userDeleted(userId));
	    });
	  };
	}
	
	function testerToggled(userId, staffUserId, tester) {
	  return {
	    type: PAYWALL_USER_TOGGLE_TESTER,
	    userId: userId,
	    staffUserId: staffUserId,
	    tester: tester
	  };
	}
	
	function toggleTester(_ref13) {
	  var userId = _ref13.userId;
	  var staffUserId = _ref13.staffUserId;
	  var tester = _ref13.tester;
	
	  return function (dispatch) {
	    return _servicesFirebaseRef2['default'].child('users/' + userId + '/profile').update({ tester: tester }).then(function () {
	      if (tester) {
	        (0, _servicesEvents.publishEvent)('Beta Testing Enabled', { userId: userId, staffUserId: staffUserId });
	      } else {
	        (0, _servicesEvents.publishEvent)('Beta Testing Disabled', { userId: userId, staffUserId: staffUserId });
	      }
	      return dispatch(testerToggled(userId, staffUserId, tester));
	    });
	  };
	}
	
	function onHoldSessions(sessions) {
	  return {
	    type: PAYWALL_ONHOLD_SESSIONS,
	    sessions: withDefaultLanguage(sessions)
	  };
	}
	
	function bindOnHoldSessions(refs) {
	  return function (dispatch) {
	    var sessionsRef = _servicesFirebaseRef2['default'].child('sessions').orderByChild('onHold').equalTo(true);
	    refs.sessions = sessionsRef;
	    refs.profiles = {};
	    sessionsRef.on('value', function (snapshot) {
	      var sessions = snapshot.val();
	      dispatch(onHoldSessions(sessions));
	      if (!sessions) {
	        return;
	      }
	      _Object$keys(sessions).forEach(function (sessionId) {
	        var userId = sessions[sessionId].userId;
	
	        if (!refs.profiles[userId]) {
	          dispatch(bindSingleProfile(userId, refs));
	        }
	      });
	    });
	  };
	}
	
	function unbindOnHoldSessions(refs) {
	  return function () {
	    refs.sessions.off();
	    _Object$keys(refs.profiles).forEach(function (userId) {
	      refs.profiles[userId].off();
	    });
	  };
	}
	
	function sessionOnHold(sessionId) {
	  return { type: PAYWALL_SESSION_ON_HOLD, sessionId: sessionId };
	}
	
	function putOnHold(_ref14) {
	  var sessionId = _ref14.sessionId;
	
	  return function (dispatch) {
	    return _servicesFirebaseRef2['default'].child('sessions/' + sessionId).update({ onHold: true }).then(function () {
	      return dispatch(sessionOnHold(sessionId));
	    });
	  };
	}
	
	function sessionProgramChange(sessionId, oldProgramId, newProgramId, userId) {
	  return { type: PAYWALL_SESSION_PROGRAM_CHANGE, sessionId: sessionId, oldProgramId: oldProgramId, newProgramId: newProgramId, userId: userId };
	}
	
	function changeProgram(_ref15) {
	  var sessionId = _ref15.sessionId;
	  var oldProgramId = _ref15.oldProgramId;
	  var newProgramId = _ref15.newProgramId;
	  var userId = _ref15.userId;
	
	  return function (dispatch) {
	    return _servicesFirebaseRef2['default'].child('sessions/' + sessionId).update({ programId: newProgramId }).then(function () {
	      (0, _servicesEvents.publishEvent)('Program Changed', { userId: userId, sessionId: sessionId, oldProgramId: oldProgramId, newProgramId: newProgramId });
	    }).then(function () {
	      return dispatch(sessionProgramChange(sessionId, oldProgramId, newProgramId, userId));
	    });
	  };
	}
	
	function resetEditUserForm() {
	  var values = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	  return function (dispatch) {
	    dispatch((0, _reduxForm.initialize)('editUser', values));
	    dispatch(paywallError(''));
	  };
	}
	
	function paywallError(message) {
	  return {
	    type: PAYWALL_ERROR,
	    message: message
	  };
	}
	
	function editUser(userId, values, _ref16) {
	  var staffUserId = _ref16.staffUserId;
	
	  return function (dispatch) {
	    var profileRef = _servicesFirebaseRef2['default'].child('users/' + userId + '/profile');
	    var previousProfile = null;
	    return profileRef.once('value').then(function (snapshot) {
	      previousProfile = snapshot.val();
	      return profileRef.update(values);
	    }).then(function () {
	      // if email has changed we need to ask the API to update the authentication
	      if (previousProfile.email !== values.email) {
	        return (0, _servicesAjax.asyncAjax)(_appConfig.apiUrl + 'updateEmail', JSON.stringify({ userId: userId })).then(function (arg) {
	          /** @type {XMLHttpRequest} */
	          var xhr = arg;
	          if (xhr.status !== 200) {
	            throw new Error(['Error talking with API:', xhr.status, xhr.statusText].join(' '));
	          }
	          var result = JSON.parse(xhr.responseText);
	          var error = result.error;
	
	          if (error) {
	            throw new Error(['Could not update email:', error].join(' '));
	          }
	        })['catch'](function (error) {
	          dispatch(paywallError(error.message));
	          // rollback email change
	          return profileRef.update({ email: previousProfile.email });
	        });
	      }
	    }).then(function () {
	      return _servicesFirebaseRef2['default'].child('users/' + userId).update({ updatedAt: _servicesFirebaseRef.TIMESTAMP });
	    }).then(function () {
	      (0, _servicesEvents.publishEvent)('Profile Updated', {
	        userId: userId,
	        staffUserId: staffUserId,
	        email: values.email,
	        firstName: previousProfile.firstName,
	        lastName: previousProfile.lastName,
	        phone: previousProfile.phone,
	        country: values.country,
	        stateOrProvince: values.stateOrProvince,
	        cityOrMunicipality: values.cityOrMunicipality,
	        school: previousProfile.school,
	        marketingOptIn: previousProfile.marketingOptIn,
	        gettingStartedOptIn: previousProfile.gettingStartedOptIn,
	        directPromotionOptIn: previousProfile.directPromotionOptIn
	      });
	      if (previousProfile.tester !== values.tester) {
	        if (values.tester) {
	          (0, _servicesEvents.publishEvent)('Beta Testing Enabled', { userId: userId, staffUserId: staffUserId });
	        } else {
	          (0, _servicesEvents.publishEvent)('Beta Testing Disabled', { userId: userId, staffUserId: staffUserId });
	        }
	        return dispatch(testerToggled(userId, staffUserId, values.tester));
	      }
	    });
	  };
	}

/***/ }),
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(116);
	var createDesc = __webpack_require__(260);
	module.exports = __webpack_require__(96) ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};


/***/ }),
/* 147 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(773);
	var defined = __webpack_require__(364);
	module.exports = function (it) {
	  return IObject(defined(it));
	};


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

	var store = __webpack_require__(371)('wks');
	var uid = __webpack_require__(261);
	var Symbol = __webpack_require__(97).Symbol;
	var USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function (name) {
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;


/***/ }),
/* 150 */,
/* 151 */,
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/epsHybridIntermediates/images/characters/ian_sara_side-465d53e88668c40822120ecc48022186.png";

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/epsHybridPrimaries/images/characters/ian_sara_side-465d53e88668c40822120ecc48022186.png";

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/epsIntermediates/images/characters/ian_sara_side-465d53e88668c40822120ecc48022186.png";

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/epsPrimaries/images/characters/ian_sara_side-465d53e88668c40822120ecc48022186.png";

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/h2whoaHybrid/images/characters/ian_sara_side-465d53e88668c40822120ecc48022186.png";

/***/ }),
/* 157 */,
/* 158 */,
/* 159 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.eachObject = eachObject;
	exports.assign = assign;
	var isFunction = function isFunction(x) {
	  return typeof x === 'function';
	};
	
	exports.isFunction = isFunction;
	
	function eachObject(f, o) {
	  o.forEach(function (from) {
	    Object.keys(Object(from)).forEach(function (key) {
	      f(key, from[key]);
	    });
	  });
	}
	
	function assign(target) {
	  for (var _len = arguments.length, source = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    source[_key - 1] = arguments[_key];
	  }
	
	  eachObject(function (key, value) {
	    return target[key] = value;
	  }, source);
	  return target;
	}

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _componentsYouTube = __webpack_require__(61);
	
	var _componentsYouTube2 = _interopRequireDefault(_componentsYouTube);
	
	function videoSlide(_ref) {
	  var id = _ref.id;
	  var notes = _ref.notes;
	  var heading = _ref.heading;
	  var youTubeId = _ref.youTubeId;
	  var lowRes = _ref.lowRes;
	  var bgColor = _ref.bgColor;
	  var slideClass = _ref.slideClass;
	
	  var slideContentClass = slideClass ? ' slide-' + slideClass : '';
	  var booleanLowRes = lowRes === 'true';
	  return _react2['default'].createElement(
	    _spectaclePpa.Slide,
	    {
	      id: id,
	      key: id,
	      bgColor: bgColor ? bgColor : 'black',
	      notes: notes },
	    _react2['default'].createElement(
	      'div',
	      { className: 'slide-content' + slideContentClass },
	      _react2['default'].createElement(
	        'div',
	        { className: 'video-slide' },
	        heading ? _react2['default'].createElement(
	          _spectaclePpa.Heading,
	          { size: 3, textColor: 'primary', textFont: 'primary' },
	          heading
	        ) : null,
	        _react2['default'].createElement(_componentsYouTube2['default'], {
	          youTubeId: youTubeId,
	          lowRes: booleanLowRes,
	          presentation: true })
	      )
	    )
	  );
	}
	
	exports['default'] = videoSlide;
	module.exports = exports['default'];

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = __webpack_require__(7)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	function headingSlide(_ref) {
	  var id = _ref.id;
	  var bgColor = _ref.bgColor;
	  var notes = _ref.notes;
	  var heading = _ref.heading;
	  var subHeading = _ref.subHeading;
	  var beforeImage = _ref.beforeImage;
	  var afterImage = _ref.afterImage;
	  var slideClass = _ref.slideClass;
	
	  var slideContentClass = slideClass ? ' slide-' + slideClass : '';
	  var bgColorOpts = {};
	  if (bgColor) {
	    bgColorOpts.bgColor = bgColor;
	  }
	  return _react2['default'].createElement(
	    _spectaclePpa.Slide,
	    _extends({
	      id: id,
	      key: id
	    }, bgColorOpts, {
	      notes: notes }),
	    _react2['default'].createElement(
	      'div',
	      { className: 'slide-content' + slideContentClass },
	      !!beforeImage && _react2['default'].createElement(
	        'div',
	        { className: 'flex-image' },
	        _react2['default'].createElement('img', {
	          className: 'heading-image heading-image-before',
	          src: beforeImage })
	      ),
	      _react2['default'].createElement(
	        'div',
	        { className: 'text-heading' },
	        _react2['default'].createElement(
	          _spectaclePpa.Heading,
	          { size: 2 },
	          _react2['default'].createElement('div', { dangerouslySetInnerHTML: { __html: heading } })
	        ),
	        !!subHeading && _react2['default'].createElement(
	          _spectaclePpa.Heading,
	          { size: 3 },
	          _react2['default'].createElement('div', { dangerouslySetInnerHTML: { __html: subHeading } })
	        )
	      ),
	      !!afterImage && _react2['default'].createElement('img', {
	        className: 'heading-image heading-image-after',
	        src: afterImage })
	    )
	  );
	}
	
	exports['default'] = headingSlide;
	module.exports = exports['default'];

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = __webpack_require__(7)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	function headingSlide(_ref) {
	  var id = _ref.id;
	  var bgColor = _ref.bgColor;
	  var notes = _ref.notes;
	  var heading = _ref.heading;
	  var subHeading = _ref.subHeading;
	  var beforeImage = _ref.beforeImage;
	  var afterImage = _ref.afterImage;
	  var slideClass = _ref.slideClass;
	
	  var slideContentClass = slideClass ? ' slide-' + slideClass : '';
	  var bgColorOpts = {};
	  if (bgColor) {
	    bgColorOpts.bgColor = bgColor;
	  }
	  return _react2['default'].createElement(
	    _spectaclePpa.Slide,
	    _extends({
	      id: id,
	      key: id
	    }, bgColorOpts, {
	      notes: notes }),
	    _react2['default'].createElement(
	      'div',
	      { className: 'slide-content' + slideContentClass },
	      !!beforeImage && _react2['default'].createElement(
	        'div',
	        { className: 'flex-image' },
	        _react2['default'].createElement('img', {
	          className: 'heading-image heading-image-before',
	          src: beforeImage })
	      ),
	      _react2['default'].createElement(
	        'div',
	        { className: 'text-heading' },
	        _react2['default'].createElement(
	          _spectaclePpa.Heading,
	          { size: 2 },
	          _react2['default'].createElement('div', { dangerouslySetInnerHTML: { __html: heading } })
	        ),
	        !!subHeading && _react2['default'].createElement(
	          _spectaclePpa.Heading,
	          { size: 3 },
	          _react2['default'].createElement('div', { dangerouslySetInnerHTML: { __html: subHeading } })
	        )
	      ),
	      !!afterImage && _react2['default'].createElement('img', {
	        className: 'heading-image heading-image-after',
	        src: afterImage })
	    )
	  );
	}
	
	exports['default'] = headingSlide;
	module.exports = exports['default'];

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = __webpack_require__(7)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	function headingSlide(_ref) {
	  var id = _ref.id;
	  var bgColor = _ref.bgColor;
	  var notes = _ref.notes;
	  var heading = _ref.heading;
	  var subHeading = _ref.subHeading;
	  var beforeImage = _ref.beforeImage;
	  var afterImage = _ref.afterImage;
	  var slideClass = _ref.slideClass;
	
	  var slideContentClass = slideClass ? ' slide-' + slideClass : '';
	  var bgColorOpts = {};
	  if (bgColor) {
	    bgColorOpts.bgColor = bgColor;
	  }
	  return _react2['default'].createElement(
	    _spectaclePpa.Slide,
	    _extends({
	      id: id,
	      key: id
	    }, bgColorOpts, {
	      notes: notes }),
	    _react2['default'].createElement(
	      'div',
	      { className: 'slide-content' + slideContentClass },
	      !!beforeImage && _react2['default'].createElement(
	        'div',
	        { className: 'flex-image' },
	        _react2['default'].createElement('img', {
	          className: 'heading-image heading-image-before',
	          src: beforeImage })
	      ),
	      _react2['default'].createElement(
	        'div',
	        { className: 'text-heading' },
	        _react2['default'].createElement(
	          _spectaclePpa.Heading,
	          { size: 2 },
	          _react2['default'].createElement('div', { dangerouslySetInnerHTML: { __html: heading } })
	        ),
	        !!subHeading && _react2['default'].createElement(
	          _spectaclePpa.Heading,
	          { size: 3 },
	          _react2['default'].createElement('div', { dangerouslySetInnerHTML: { __html: subHeading } })
	        )
	      ),
	      !!afterImage && _react2['default'].createElement('img', {
	        className: 'heading-image heading-image-after',
	        src: afterImage })
	    )
	  );
	}
	
	exports['default'] = headingSlide;
	module.exports = exports['default'];

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

	/* eslint react/no-multi-comp: 0, no-unused-vars: 0 */
	
	'use strict';
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.preloadGameShow = preloadGameShow;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _srcServicesRegionalization = __webpack_require__(38);
	
	var _srcServicesRegionalization2 = _interopRequireDefault(_srcServicesRegionalization);
	
	var _baseSlidesBalloonSlide = __webpack_require__(87);
	
	var _baseSlidesBalloonSlide2 = _interopRequireDefault(_baseSlidesBalloonSlide);
	
	var _baseSlidesHeadingSlide = __webpack_require__(163);
	
	var _baseSlidesHeadingSlide2 = _interopRequireDefault(_baseSlidesHeadingSlide);
	
	var _baseSlidesVideoSlide = __webpack_require__(57);
	
	var _baseSlidesVideoSlide2 = _interopRequireDefault(_baseSlidesVideoSlide);
	
	var _title_gameshowPng = __webpack_require__(2331);
	
	var _title_gameshowPng2 = _interopRequireDefault(_title_gameshowPng);
	
	var _title_gameshow_playersPng = __webpack_require__(2332);
	
	var _title_gameshow_playersPng2 = _interopRequireDefault(_title_gameshow_playersPng);
	
	var _imagesCharactersIan_sara_lean_smilePng = __webpack_require__(417);
	
	var _imagesCharactersIan_sara_lean_smilePng2 = _interopRequireDefault(_imagesCharactersIan_sara_lean_smilePng);
	
	var _imagesCharactersIan_sidePng = __webpack_require__(872);
	
	var _imagesCharactersIan_sidePng2 = _interopRequireDefault(_imagesCharactersIan_sidePng);
	
	var _imagesCharactersSara_smilePng = __webpack_require__(418);
	
	var _imagesCharactersSara_smilePng2 = _interopRequireDefault(_imagesCharactersSara_smilePng);
	
	var _imagesCharactersIan_shrug_laughPng = __webpack_require__(2320);
	
	var _imagesCharactersIan_shrug_laughPng2 = _interopRequireDefault(_imagesCharactersIan_shrug_laughPng);
	
	var _imagesCharactersIan_pointing_upPng = __webpack_require__(416);
	
	var _imagesCharactersIan_pointing_upPng2 = _interopRequireDefault(_imagesCharactersIan_pointing_upPng);
	
	var _imagesCharactersIan_sara_lean_questioningPng = __webpack_require__(201);
	
	var _imagesCharactersIan_sara_lean_questioningPng2 = _interopRequireDefault(_imagesCharactersIan_sara_lean_questioningPng);
	
	var _imagesCharactersSara_surprisedPng = __webpack_require__(874);
	
	var _imagesCharactersSara_surprisedPng2 = _interopRequireDefault(_imagesCharactersSara_surprisedPng);
	
	var _imagesCharactersIan_sara_sidePng = __webpack_require__(154);
	
	var _imagesCharactersIan_sara_sidePng2 = _interopRequireDefault(_imagesCharactersIan_sara_sidePng);
	
	var _helpersMarkdownScript = __webpack_require__(9);
	
	var _helpersMarkdownScript2 = _interopRequireDefault(_helpersMarkdownScript);
	
	var _level1_knowTheRisksMd = __webpack_require__(1605);
	
	var _level1_knowTheRisksMd2 = _interopRequireDefault(_level1_knowTheRisksMd);
	
	var _level2_makeAPlanMd = __webpack_require__(1606);
	
	var _level2_makeAPlanMd2 = _interopRequireDefault(_level2_makeAPlanMd);
	
	var _level3_getAKitMd = __webpack_require__(1607);
	
	var _level3_getAKitMd2 = _interopRequireDefault(_level3_getAKitMd);
	
	var _level4_wereInThisTogetherMd = __webpack_require__(1608);
	
	var _level4_wereInThisTogetherMd2 = _interopRequireDefault(_level4_wereInThisTogetherMd);
	
	var levels = {
	  '1': { md: new _helpersMarkdownScript2['default'](_level1_knowTheRisksMd2['default']) },
	  '2': { md: new _helpersMarkdownScript2['default'](_level2_makeAPlanMd2['default']) },
	  '3': { md: new _helpersMarkdownScript2['default'](_level3_getAKitMd2['default']) },
	  '4': { md: new _helpersMarkdownScript2['default'](_level4_wereInThisTogetherMd2['default']) }
	};
	
	function preloadGameShow() {
	  (0, _spectaclePpa.preloader)([_title_gameshowPng2['default'], _title_gameshow_playersPng2['default'], _imagesCharactersIan_sara_lean_smilePng2['default'], _imagesCharactersIan_sidePng2['default'], _imagesCharactersSara_smilePng2['default'], _imagesCharactersIan_shrug_laughPng2['default'], _imagesCharactersIan_sara_lean_questioningPng2['default'], _imagesCharactersSara_surprisedPng2['default'], _imagesCharactersIan_sara_sidePng2['default']]);
	}
	
	function intro(level, regionData) {
	  var md = levels[level].md;
	  return (0, _baseSlidesVideoSlide2['default'])({
	    id: 'intro',
	    notes: md.getSubSectionAsHtml('Intro Video', 'Notes', false, regionData),
	    youTubeId: md.getSectionMetadata('Intro Video', 'YouTube', regionData)
	  });
	}
	
	function sizzle(level, regionData) {
	  var md = levels[level].md;
	  return (0, _baseSlidesHeadingSlide2['default'])({
	    id: 'sizzle',
	    bgColor: '#742CBF',
	    afterImage: _title_gameshowPng2['default'],
	    notes: md.getSubSectionAsHtml('Sizzle', 'Notes', false, regionData)
	  });
	}
	
	function scoring(level, regionData) {
	  var md = levels[level].md;
	  return (0, _baseSlidesBalloonSlide2['default'])({
	    id: 'scoring',
	    characterSide: 'left',
	    characterImage: _imagesCharactersIan_sara_lean_smilePng2['default'],
	    notes: md.getSubSectionAsHtml('Scoring', 'Notes', false, regionData),
	    html: md.getSubSectionAsHtml('Scoring', 'Content', false, regionData),
	    bgColor: '#742CBF'
	  });
	}
	
	function questionSlide(_ref) {
	  var level = _ref.level;
	  var questionNumber = _ref.questionNumber;
	  var numQuestions = _ref.numQuestions;
	  var md = _ref.md;
	  var questionCharacterImage = _ref.questionCharacterImage;
	  var answerCharacterImage = _ref.answerCharacterImage;
	  var regionData = _ref.regionData;
	
	  var questionSection = 'Question ' + questionNumber;
	  var defaultRegion = md.getSectionMetadata(questionSection, 'Default Region', regionData);
	  var questionCharacter = !questionCharacterImage ? _imagesCharactersIan_sidePng2['default'] : questionCharacterImage;
	  var answerCharacter = !answerCharacterImage ? _imagesCharactersSara_smilePng2['default'] : answerCharacterImage;
	  var answer = undefined;
	  if (defaultRegion) {
	    answer = md.getSubSectionAsHtml(questionSection, 'Answer - ' + defaultRegion, false, regionData);
	  } else {
	    answer = md.getSubSectionAsHtml(questionSection, 'Answer', false, regionData);
	  }
	  var answerNotes = md.getSubSectionAsHtml(questionSection, 'Answer Notes', false, regionData);
	
	  return [
	
	  // four players announcement
	  (0, _baseSlidesHeadingSlide2['default'])({
	    id: questionNumber + '-four-players',
	    afterImage: _title_gameshow_playersPng2['default'],
	    bgColor: 'black',
	    notes: '<h2>Question ' + questionNumber + ' of ' + numQuestions + ': </h2>' + md.getSubSectionAsHtml('Four Players Announcement', 'Notes', false, regionData)
	  }),
	
	  // additional slide for level 4, question 3
	  level === 4 && questionNumber === 3 ? (0, _baseSlidesBalloonSlide2['default'])({
	    balloonType: 'question',
	    characterSide: 'left',
	    characterImage: _imagesCharactersIan_sidePng2['default'],
	    questionNumber: questionNumber,
	    numQuestions: numQuestions,
	    id: questionNumber + '-multiple-choice',
	    html: md.getSubSectionAsHtml(questionSection, 'Question Intro', false, regionData),
	    notes: '<h2>Question ' + questionNumber + ' of ' + numQuestions + ': </h2>' + '<br />' + '<p style="font color: white">Multiple choice, see next slide</h4>',
	    bgColor: '#45B3EC'
	  }) : null,
	
	  // question text
	  (0, _baseSlidesBalloonSlide2['default'])({
	    balloonType: 'question',
	    characterSide: 'left',
	    characterImage: questionCharacter,
	    questionNumber: questionNumber,
	    numQuestions: numQuestions,
	    id: questionNumber + '-question',
	    html: md.getSubSectionAsHtml(questionSection, 'Question', false, regionData),
	    notes: '<h2>Question ' + questionNumber + ' of ' + numQuestions + ': </h2>' + '<br />' + '<p style="font color: white">Preview of next slide/answer</h4>' + answer
	  }),
	
	  // answer slide
	  (0, _baseSlidesBalloonSlide2['default'])({
	    balloonType: 'answer',
	    characterSide: 'right',
	    characterImage: answerCharacter,
	    questionNumber: questionNumber,
	    id: questionNumber + '-answer',
	    html: answer,
	    notes: '<h2>Answer ' + questionNumber + ' of ' + numQuestions + '</h2>' + '<br />' + (!answerNotes.match(/SKIP/) ? md.getSubSectionAsHtml(questionSection, 'Answer Notes', false, regionData) : '')
	  })];
	}
	
	function endOfGameShow(level) {
	  return (0, _baseSlidesBalloonSlide2['default'])({
	    id: 'end',
	    characterSide: 'left',
	    characterImage: _imagesCharactersIan_shrug_laughPng2['default'],
	    bgColor: '#742CBF',
	    html: '<h3>Level ' + level + ' Game Show Completed!</h3>',
	    notes: 'Game show completed.'
	  });
	}
	
	function level1(regionData) {
	  var level = 1;
	  var md = levels[level].md;
	
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'game-show' },
	    intro(level, regionData),
	    sizzle(level, regionData),
	    scoring(level, regionData),
	    questionSlide({ level: level, questionNumber: 1, numQuestions: 3, md: md, regionData: regionData }),
	    (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'scoring-reminder',
	      characterSide: 'left',
	      characterImage: _imagesCharactersIan_pointing_upPng2['default'],
	      notes: md.getSubSectionAsHtml('Scoring Reminder', 'Notes', false, regionData),
	      html: md.getSubSectionAsHtml('Scoring Reminder', 'Content', false, regionData),
	      bgColor: '#742CBF'
	    }),
	    questionSlide({ level: level, questionNumber: 2, numQuestions: 3, md: md, regionData: regionData }),
	    questionSlide({ level: level, questionNumber: 3, numQuestions: 3, md: md, regionData: regionData }),
	    endOfGameShow(level)
	  );
	}
	
	function level2(regionData) {
	  var level = 2;
	  var md = levels[level].md;
	
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'game-show' },
	    intro(level, regionData),
	    sizzle(level, regionData),
	    scoring(level, regionData),
	    questionSlide({ level: level, questionNumber: 1, numQuestions: 3, md: md, regionData: regionData }),
	    (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'scoring-reminder',
	      characterSide: 'left',
	      characterImage: _imagesCharactersIan_pointing_upPng2['default'],
	      notes: md.getSubSectionAsHtml('Scoring Reminder', 'Notes', false, regionData),
	      html: md.getSubSectionAsHtml('Scoring Reminder', 'Content', false, regionData),
	      bgColor: '#742CBF'
	    }),
	    questionSlide({ level: level, questionNumber: 2, numQuestions: 3, md: md, regionData: regionData }),
	    questionSlide({ level: level, questionNumber: 3, numQuestions: 3, md: md, regionData: regionData }),
	    endOfGameShow(level)
	  );
	}
	
	function level3(regionData) {
	  var level = 3;
	  var md = levels[level].md;
	
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'game-show' },
	    intro(level, regionData),
	    sizzle(level, regionData),
	    scoring(level, regionData),
	    questionSlide({ level: level, questionNumber: 1, numQuestions: 3, md: md, regionData: regionData }),
	    questionSlide({ level: level, questionNumber: 2, numQuestions: 3, md: md, regionData: regionData }),
	    questionSlide({ level: level, questionNumber: 3, numQuestions: 3, md: md, regionData: regionData }),
	    endOfGameShow(level)
	  );
	}
	
	function level4(regionData) {
	  var level = 4;
	  var md = levels[level].md;
	
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'game-show' },
	    intro(level, regionData),
	    sizzle(level, regionData),
	    questionSlide({ level: level, questionNumber: 1, numQuestions: 3, md: md, regionData: regionData }),
	    questionSlide({ level: level, questionNumber: 2, numQuestions: 3, md: md, regionData: regionData }),
	    questionSlide({ level: level, questionNumber: 3, numQuestions: 3, md: md, regionData: regionData }),
	    endOfGameShow(level)
	  );
	}
	
	function gameShowSection(_ref2) {
	  var level = _ref2.level;
	  var regionData = _ref2.regionData;
	
	  switch (level) {
	    case 1:
	      return level1(regionData);
	    case 2:
	      return level2(regionData);
	    case 3:
	      return level3(regionData);
	    case 4:
	      return level4(regionData);
	    default:
	      return (0, _baseSlidesHeadingSlide2['default'])({ heading: 'Unknown' });
	  }
	}
	
	exports['default'] = gameShowSection;
	/* Sara and Ian introduce the Game Show */ /* Sizzle */ /* Scoring intro */ /* Game show questions */ /* Scoring reminder */ /* End of Game Show */ /* Sara and Ian introduce the Game Show */ /* Sizzle */ /* Scoring intro */ /* Game show questions */ /* Scoring reminder */ /* End of Game Show */ /* Sara and Ian introduce the Game Show */ /* Sizzle */ /* Scoring intro */ /* Game show questions */ /* End of Game Show */ /* Sara and Ian introduce the Game Show */ /* Sizzle */ /* Game show questions */ /* End of Game Show */

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = __webpack_require__(7)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	function headingSlide(_ref) {
	  var id = _ref.id;
	  var bgColor = _ref.bgColor;
	  var notes = _ref.notes;
	  var heading = _ref.heading;
	  var subHeading = _ref.subHeading;
	  var beforeImage = _ref.beforeImage;
	  var afterImage = _ref.afterImage;
	  var slideClass = _ref.slideClass;
	
	  var slideContentClass = slideClass ? ' slide-' + slideClass : '';
	  var bgColorOpts = {};
	  if (bgColor) {
	    bgColorOpts.bgColor = bgColor;
	  }
	  return _react2['default'].createElement(
	    _spectaclePpa.Slide,
	    _extends({
	      id: id,
	      key: id
	    }, bgColorOpts, {
	      notes: notes }),
	    _react2['default'].createElement(
	      'div',
	      { className: 'slide-content' + slideContentClass },
	      !!beforeImage && _react2['default'].createElement(
	        'div',
	        { className: 'flex-image' },
	        _react2['default'].createElement('img', {
	          className: 'heading-image heading-image-before',
	          src: beforeImage })
	      ),
	      _react2['default'].createElement(
	        'div',
	        { className: 'text-heading' },
	        _react2['default'].createElement(
	          _spectaclePpa.Heading,
	          { size: 2 },
	          _react2['default'].createElement('div', { dangerouslySetInnerHTML: { __html: heading } })
	        ),
	        !!subHeading && _react2['default'].createElement(
	          _spectaclePpa.Heading,
	          { size: 3 },
	          _react2['default'].createElement('div', { dangerouslySetInnerHTML: { __html: subHeading } })
	        )
	      ),
	      !!afterImage && _react2['default'].createElement('img', {
	        className: 'heading-image heading-image-after',
	        src: afterImage })
	    )
	  );
	}
	
	exports['default'] = headingSlide;
	module.exports = exports['default'];

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

	/* eslint react/no-multi-comp: 0, no-unused-vars: 0 */
	
	'use strict';
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.preloadGameShow = preloadGameShow;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _srcServicesRegionalization = __webpack_require__(38);
	
	var _srcServicesRegionalization2 = _interopRequireDefault(_srcServicesRegionalization);
	
	var _baseSlidesBalloonSlide = __webpack_require__(88);
	
	var _baseSlidesBalloonSlide2 = _interopRequireDefault(_baseSlidesBalloonSlide);
	
	var _baseSlidesHeadingSlide = __webpack_require__(165);
	
	var _baseSlidesHeadingSlide2 = _interopRequireDefault(_baseSlidesHeadingSlide);
	
	var _baseSlidesVideoSlide = __webpack_require__(58);
	
	var _baseSlidesVideoSlide2 = _interopRequireDefault(_baseSlidesVideoSlide);
	
	var _title_gameshowPng = __webpack_require__(2353);
	
	var _title_gameshowPng2 = _interopRequireDefault(_title_gameshowPng);
	
	var _title_gameshow_playersPng = __webpack_require__(2354);
	
	var _title_gameshow_playersPng2 = _interopRequireDefault(_title_gameshow_playersPng);
	
	var _imagesCharactersIan_sara_lean_smilePng = __webpack_require__(424);
	
	var _imagesCharactersIan_sara_lean_smilePng2 = _interopRequireDefault(_imagesCharactersIan_sara_lean_smilePng);
	
	var _imagesCharactersIan_sidePng = __webpack_require__(879);
	
	var _imagesCharactersIan_sidePng2 = _interopRequireDefault(_imagesCharactersIan_sidePng);
	
	var _imagesCharactersSara_smilePng = __webpack_require__(425);
	
	var _imagesCharactersSara_smilePng2 = _interopRequireDefault(_imagesCharactersSara_smilePng);
	
	var _imagesCharactersIan_shrug_laughPng = __webpack_require__(2342);
	
	var _imagesCharactersIan_shrug_laughPng2 = _interopRequireDefault(_imagesCharactersIan_shrug_laughPng);
	
	var _imagesCharactersIan_pointing_upPng = __webpack_require__(423);
	
	var _imagesCharactersIan_pointing_upPng2 = _interopRequireDefault(_imagesCharactersIan_pointing_upPng);
	
	var _imagesCharactersIan_sara_lean_questioningPng = __webpack_require__(202);
	
	var _imagesCharactersIan_sara_lean_questioningPng2 = _interopRequireDefault(_imagesCharactersIan_sara_lean_questioningPng);
	
	var _imagesCharactersSara_surprisedPng = __webpack_require__(881);
	
	var _imagesCharactersSara_surprisedPng2 = _interopRequireDefault(_imagesCharactersSara_surprisedPng);
	
	var _imagesCharactersIan_sara_sidePng = __webpack_require__(155);
	
	var _imagesCharactersIan_sara_sidePng2 = _interopRequireDefault(_imagesCharactersIan_sara_sidePng);
	
	var _helpersMarkdownScript = __webpack_require__(9);
	
	var _helpersMarkdownScript2 = _interopRequireDefault(_helpersMarkdownScript);
	
	var _level1_knowTheRisksMd = __webpack_require__(1638);
	
	var _level1_knowTheRisksMd2 = _interopRequireDefault(_level1_knowTheRisksMd);
	
	var _level2_makeAPlanMd = __webpack_require__(1639);
	
	var _level2_makeAPlanMd2 = _interopRequireDefault(_level2_makeAPlanMd);
	
	var _level3_getAKitMd = __webpack_require__(1640);
	
	var _level3_getAKitMd2 = _interopRequireDefault(_level3_getAKitMd);
	
	var _level4_wereInThisTogetherMd = __webpack_require__(1641);
	
	var _level4_wereInThisTogetherMd2 = _interopRequireDefault(_level4_wereInThisTogetherMd);
	
	var levels = {
	  '1': { md: new _helpersMarkdownScript2['default'](_level1_knowTheRisksMd2['default']) },
	  '2': { md: new _helpersMarkdownScript2['default'](_level2_makeAPlanMd2['default']) },
	  '3': { md: new _helpersMarkdownScript2['default'](_level3_getAKitMd2['default']) },
	  '4': { md: new _helpersMarkdownScript2['default'](_level4_wereInThisTogetherMd2['default']) }
	};
	
	function preloadGameShow() {
	  (0, _spectaclePpa.preloader)([_title_gameshowPng2['default'], _title_gameshow_playersPng2['default'], _imagesCharactersIan_sara_lean_smilePng2['default'], _imagesCharactersIan_sidePng2['default'], _imagesCharactersSara_smilePng2['default'], _imagesCharactersIan_shrug_laughPng2['default'], _imagesCharactersIan_sara_lean_questioningPng2['default'], _imagesCharactersSara_surprisedPng2['default'], _imagesCharactersIan_sara_sidePng2['default']]);
	}
	
	function intro(level, regionData) {
	  var md = levels[level].md;
	  return (0, _baseSlidesVideoSlide2['default'])({
	    id: 'intro',
	    notes: md.getSubSectionAsHtml('Intro Video', 'Notes', false, regionData),
	    youTubeId: md.getSectionMetadata('Intro Video', 'YouTube', regionData)
	  });
	}
	
	function sizzle(level, regionData) {
	  var md = levels[level].md;
	  return (0, _baseSlidesHeadingSlide2['default'])({
	    id: 'sizzle',
	    bgColor: '#742CBF',
	    afterImage: _title_gameshowPng2['default'],
	    notes: md.getSubSectionAsHtml('Sizzle', 'Notes', false, regionData)
	  });
	}
	
	function scoring(level, regionData) {
	  var md = levels[level].md;
	  return (0, _baseSlidesBalloonSlide2['default'])({
	    id: 'scoring',
	    characterSide: 'left',
	    characterImage: _imagesCharactersIan_sara_lean_smilePng2['default'],
	    notes: md.getSubSectionAsHtml('Scoring', 'Notes', false, regionData),
	    html: md.getSubSectionAsHtml('Scoring', 'Content', false, regionData),
	    bgColor: '#742CBF'
	  });
	}
	
	function questionSlide(_ref) {
	  var level = _ref.level;
	  var questionNumber = _ref.questionNumber;
	  var numQuestions = _ref.numQuestions;
	  var md = _ref.md;
	  var questionCharacterImage = _ref.questionCharacterImage;
	  var answerCharacterImage = _ref.answerCharacterImage;
	  var regionData = _ref.regionData;
	
	  var questionSection = 'Question ' + questionNumber;
	  var defaultRegion = md.getSectionMetadata(questionSection, 'Default Region', regionData);
	  var questionCharacter = !questionCharacterImage ? _imagesCharactersIan_sidePng2['default'] : questionCharacterImage;
	  var answerCharacter = !answerCharacterImage ? _imagesCharactersSara_smilePng2['default'] : answerCharacterImage;
	  var answer = undefined;
	  if (defaultRegion) {
	    answer = md.getSubSectionAsHtml(questionSection, 'Answer - ' + defaultRegion, false, regionData);
	  } else {
	    answer = md.getSubSectionAsHtml(questionSection, 'Answer', false, regionData);
	  }
	  var answerNotes = md.getSubSectionAsHtml(questionSection, 'Answer Notes', false, regionData);
	
	  return [
	
	  // four players announcement
	  (0, _baseSlidesHeadingSlide2['default'])({
	    id: questionNumber + '-four-players',
	    afterImage: _title_gameshow_playersPng2['default'],
	    bgColor: 'black',
	    notes: '<h2>Question ' + questionNumber + ' of ' + numQuestions + ': </h2>' + md.getSubSectionAsHtml('Four Players Announcement', 'Notes', false, regionData)
	  }),
	
	  // additional slide for level 4, question 3
	  level === 4 && questionNumber === 3 ? (0, _baseSlidesBalloonSlide2['default'])({
	    balloonType: 'question',
	    characterSide: 'left',
	    characterImage: _imagesCharactersIan_sidePng2['default'],
	    questionNumber: questionNumber,
	    numQuestions: numQuestions,
	    id: questionNumber + '-multiple-choice',
	    html: md.getSubSectionAsHtml(questionSection, 'Question Intro', false, regionData),
	    notes: '<h2>Question ' + questionNumber + ' of ' + numQuestions + ': </h2>' + '<br />' + '<p style="font color: white">Multiple choice, see next slide</h4>',
	    bgColor: '#45B3EC'
	  }) : null,
	
	  // question text
	  (0, _baseSlidesBalloonSlide2['default'])({
	    balloonType: 'question',
	    characterSide: 'left',
	    characterImage: questionCharacter,
	    questionNumber: questionNumber,
	    numQuestions: numQuestions,
	    id: questionNumber + '-question',
	    html: md.getSubSectionAsHtml(questionSection, 'Question', false, regionData),
	    notes: '<h2>Question ' + questionNumber + ' of ' + numQuestions + ': </h2>' + '<br />' + '<p style="font color: white">Preview of next slide/answer</h4>' + answer
	  }),
	
	  // answer slide
	  (0, _baseSlidesBalloonSlide2['default'])({
	    balloonType: 'answer',
	    characterSide: 'right',
	    characterImage: answerCharacter,
	    questionNumber: questionNumber,
	    id: questionNumber + '-answer',
	    html: answer,
	    notes: '<h2>Answer ' + questionNumber + ' of ' + numQuestions + '</h2>' + '<br />' + (!answerNotes.match(/SKIP/) ? md.getSubSectionAsHtml(questionSection, 'Answer Notes', false, regionData) : '')
	  })];
	}
	
	function endOfGameShow(level) {
	  return (0, _baseSlidesBalloonSlide2['default'])({
	    id: 'end',
	    characterSide: 'left',
	    characterImage: _imagesCharactersIan_shrug_laughPng2['default'],
	    bgColor: '#742CBF',
	    html: '<h3>Level ' + level + ' Game Show Completed!</h3>',
	    notes: 'Game show completed.'
	  });
	}
	
	function level1(regionData) {
	  var level = 1;
	  var md = levels[level].md;
	
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'game-show' },
	    intro(level, regionData),
	    sizzle(level, regionData),
	    scoring(level, regionData),
	    questionSlide({ level: level, questionNumber: 1, numQuestions: 3, md: md, regionData: regionData }),
	    (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'scoring-reminder',
	      characterSide: 'left',
	      characterImage: _imagesCharactersIan_pointing_upPng2['default'],
	      notes: md.getSubSectionAsHtml('Scoring Reminder', 'Notes', false, regionData),
	      html: md.getSubSectionAsHtml('Scoring Reminder', 'Content', false, regionData),
	      bgColor: '#742CBF'
	    }),
	    questionSlide({ level: level, questionNumber: 2, numQuestions: 3, md: md, regionData: regionData }),
	    questionSlide({ level: level, questionNumber: 3, numQuestions: 3, md: md, regionData: regionData }),
	    endOfGameShow(level)
	  );
	}
	
	function level2(regionData) {
	  var level = 2;
	  var md = levels[level].md;
	
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'game-show' },
	    intro(level, regionData),
	    sizzle(level, regionData),
	    scoring(level, regionData),
	    questionSlide({ level: level, questionNumber: 1, numQuestions: 3, md: md, regionData: regionData }),
	    (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'scoring-reminder',
	      characterSide: 'left',
	      characterImage: _imagesCharactersIan_pointing_upPng2['default'],
	      notes: md.getSubSectionAsHtml('Scoring Reminder', 'Notes', false, regionData),
	      html: md.getSubSectionAsHtml('Scoring Reminder', 'Content', false, regionData),
	      bgColor: '#742CBF'
	    }),
	    questionSlide({ level: level, questionNumber: 2, numQuestions: 3, md: md, regionData: regionData }),
	    questionSlide({ level: level, questionNumber: 3, numQuestions: 3, md: md, regionData: regionData }),
	    endOfGameShow(level)
	  );
	}
	
	function level3(regionData) {
	  var level = 3;
	  var md = levels[level].md;
	
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'game-show' },
	    intro(level, regionData),
	    sizzle(level, regionData),
	    scoring(level, regionData),
	    questionSlide({ level: level, questionNumber: 1, numQuestions: 3, md: md, regionData: regionData }),
	    questionSlide({ level: level, questionNumber: 2, numQuestions: 3, md: md, regionData: regionData }),
	    questionSlide({ level: level, questionNumber: 3, numQuestions: 3, md: md, regionData: regionData }),
	    endOfGameShow(level)
	  );
	}
	
	function level4(regionData) {
	  var level = 4;
	  var md = levels[level].md;
	
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'game-show' },
	    intro(level, regionData),
	    sizzle(level, regionData),
	    questionSlide({ level: level, questionNumber: 1, numQuestions: 3, md: md, regionData: regionData }),
	    questionSlide({ level: level, questionNumber: 2, numQuestions: 3, md: md, regionData: regionData }),
	    questionSlide({ level: level, questionNumber: 3, numQuestions: 3, md: md, regionData: regionData }),
	    endOfGameShow(level)
	  );
	}
	
	function gameShowSection(_ref2) {
	  var level = _ref2.level;
	  var regionData = _ref2.regionData;
	
	  switch (level) {
	    case 1:
	      return level1(regionData);
	    case 2:
	      return level2(regionData);
	    case 3:
	      return level3(regionData);
	    case 4:
	      return level4(regionData);
	    default:
	      return (0, _baseSlidesHeadingSlide2['default'])({ heading: 'Unknown' });
	  }
	}
	
	exports['default'] = gameShowSection;
	/* Sara and Ian introduce the Game Show */ /* Sizzle */ /* Scoring intro */ /* Game show questions */ /* Scoring reminder */ /* End of Game Show */ /* Sara and Ian introduce the Game Show */ /* Sizzle */ /* Scoring intro */ /* Game show questions */ /* Scoring reminder */ /* End of Game Show */ /* Sara and Ian introduce the Game Show */ /* Sizzle */ /* Scoring intro */ /* Game show questions */ /* End of Game Show */ /* Sara and Ian introduce the Game Show */ /* Sizzle */ /* Game show questions */ /* End of Game Show */

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _helpersI18n = __webpack_require__(14);
	
	var _helpersMarkdownScript = __webpack_require__(9);
	
	var _helpersMarkdownScript2 = _interopRequireDefault(_helpersMarkdownScript);
	
	var _indexMd = __webpack_require__(1657);
	
	var _indexMd2 = _interopRequireDefault(_indexMd);
	
	var _indexFr_CAMd = __webpack_require__(1656);
	
	var _indexFr_CAMd2 = _interopRequireDefault(_indexFr_CAMd);
	
	exports['default'] = (0, _helpersI18n.i18nData)({
	  en: new _helpersMarkdownScript2['default'](_indexMd2['default']),
	  fr_CA: new _helpersMarkdownScript2['default'](_indexFr_CAMd2['default'])
	});
	module.exports = exports['default'];

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

	/* eslint react/no-multi-comp: 0, no-unused-vars: 0 */
	
	'use strict';
	
	var _taggedTemplateLiteral = __webpack_require__(28)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.preloadGameShow = preloadGameShow;
	
	var _templateObject = _taggedTemplateLiteral(['Question ', ' of ', ''], ['Question ', ' of ', '']),
	    _templateObject2 = _taggedTemplateLiteral(['Answer ', ' of ', ''], ['Answer ', ' of ', '']),
	    _templateObject3 = _taggedTemplateLiteral(['Level ', ' game show completed'], ['Level ', ' game show completed']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _helpersI18n = __webpack_require__(14);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _baseSlidesBalloonSlide = __webpack_require__(67);
	
	var _baseSlidesBalloonSlide2 = _interopRequireDefault(_baseSlidesBalloonSlide);
	
	var _baseSlidesHeadingSlide = __webpack_require__(122);
	
	var _baseSlidesHeadingSlide2 = _interopRequireDefault(_baseSlidesHeadingSlide);
	
	var _baseSlidesVideoSlide = __webpack_require__(89);
	
	var _baseSlidesVideoSlide2 = _interopRequireDefault(_baseSlidesVideoSlide);
	
	var _title_gameshowPng = __webpack_require__(2400);
	
	var _title_gameshowPng2 = _interopRequireDefault(_title_gameshowPng);
	
	var _title_gameshowFr_CAPng = __webpack_require__(2399);
	
	var _title_gameshowFr_CAPng2 = _interopRequireDefault(_title_gameshowFr_CAPng);
	
	var _title_gameshow_playersPng = __webpack_require__(2402);
	
	var _title_gameshow_playersPng2 = _interopRequireDefault(_title_gameshow_playersPng);
	
	var _title_gameshow_playersFr_CAPng = __webpack_require__(2401);
	
	var _title_gameshow_playersFr_CAPng2 = _interopRequireDefault(_title_gameshow_playersFr_CAPng);
	
	var _imagesCharactersApprenticesPairArmsFoldedPng = __webpack_require__(2368);
	
	var _imagesCharactersApprenticesPairArmsFoldedPng2 = _interopRequireDefault(_imagesCharactersApprenticesPairArmsFoldedPng);
	
	var _imagesCharactersApprenticePointingUp2Png = __webpack_require__(2365);
	
	var _imagesCharactersApprenticePointingUp2Png2 = _interopRequireDefault(_imagesCharactersApprenticePointingUp2Png);
	
	var _imagesCharactersApprenticePointingUp3Png = __webpack_require__(2366);
	
	var _imagesCharactersApprenticePointingUp3Png2 = _interopRequireDefault(_imagesCharactersApprenticePointingUp3Png);
	
	var _imagesCharactersApprenticesFlexArmsPng = __webpack_require__(430);
	
	var _imagesCharactersApprenticesFlexArmsPng2 = _interopRequireDefault(_imagesCharactersApprenticesFlexArmsPng);
	
	var _imagesCharactersApprenticeFistUpPng = __webpack_require__(2361);
	
	var _imagesCharactersApprenticeFistUpPng2 = _interopRequireDefault(_imagesCharactersApprenticeFistUpPng);
	
	var _imagesCharactersApprenticeHandsHips2Png = __webpack_require__(2363);
	
	var _imagesCharactersApprenticeHandsHips2Png2 = _interopRequireDefault(_imagesCharactersApprenticeHandsHips2Png);
	
	var _imagesCharactersApprenticeCuriousPng = __webpack_require__(2360);
	
	var _imagesCharactersApprenticeCuriousPng2 = _interopRequireDefault(_imagesCharactersApprenticeCuriousPng);
	
	var _imagesCharactersApprenticePointingDiagonalPng = __webpack_require__(884);
	
	var _imagesCharactersApprenticePointingDiagonalPng2 = _interopRequireDefault(_imagesCharactersApprenticePointingDiagonalPng);
	
	var _imagesCharactersSara_surprisedPng = __webpack_require__(889);
	
	var _imagesCharactersSara_surprisedPng2 = _interopRequireDefault(_imagesCharactersSara_surprisedPng);
	
	var _imagesCharactersIan_shrug_laughPng = __webpack_require__(2379);
	
	var _imagesCharactersIan_shrug_laughPng2 = _interopRequireDefault(_imagesCharactersIan_shrug_laughPng);
	
	var _helpersMarkdownScript = __webpack_require__(9);
	
	var _helpersMarkdownScript2 = _interopRequireDefault(_helpersMarkdownScript);
	
	var _level1_oneWaterMd = __webpack_require__(1688);
	
	var _level1_oneWaterMd2 = _interopRequireDefault(_level1_oneWaterMd);
	
	var _level1_oneWaterFr_CAMd = __webpack_require__(1687);
	
	var _level1_oneWaterFr_CAMd2 = _interopRequireDefault(_level1_oneWaterFr_CAMd);
	
	var _level2_saveWaterMd = __webpack_require__(1690);
	
	var _level2_saveWaterMd2 = _interopRequireDefault(_level2_saveWaterMd);
	
	var _level2_saveWaterFr_CAMd = __webpack_require__(1689);
	
	var _level2_saveWaterFr_CAMd2 = _interopRequireDefault(_level2_saveWaterFr_CAMd);
	
	var _level3_protectWaterMd = __webpack_require__(1692);
	
	var _level3_protectWaterMd2 = _interopRequireDefault(_level3_protectWaterMd);
	
	var _level3_protectWaterFr_CAMd = __webpack_require__(1691);
	
	var _level3_protectWaterFr_CAMd2 = _interopRequireDefault(_level3_protectWaterFr_CAMd);
	
	var _level4_connectInPlaceMd = __webpack_require__(1694);
	
	var _level4_connectInPlaceMd2 = _interopRequireDefault(_level4_connectInPlaceMd);
	
	var _level4_connectInPlaceFr_CAMd = __webpack_require__(1693);
	
	var _level4_connectInPlaceFr_CAMd2 = _interopRequireDefault(_level4_connectInPlaceFr_CAMd);
	
	var imageGameshowTitle = (0, _helpersI18n.i18nData)({
	  en: _title_gameshowPng2['default'],
	  fr_CA: _title_gameshowFr_CAPng2['default']
	});
	
	var imageGameshowPlayers = (0, _helpersI18n.i18nData)({
	  en: _title_gameshow_playersPng2['default'],
	  fr_CA: _title_gameshow_playersFr_CAPng2['default']
	});
	
	var markdownFileLevel1 = (0, _helpersI18n.i18nData)({
	  en: new _helpersMarkdownScript2['default'](_level1_oneWaterMd2['default']),
	  fr_CA: new _helpersMarkdownScript2['default'](_level1_oneWaterFr_CAMd2['default'])
	});
	var markdownFileLevel2 = (0, _helpersI18n.i18nData)({
	  en: new _helpersMarkdownScript2['default'](_level2_saveWaterMd2['default']),
	  fr_CA: new _helpersMarkdownScript2['default'](_level2_saveWaterFr_CAMd2['default'])
	});
	var markdownFileLevel3 = (0, _helpersI18n.i18nData)({
	  en: new _helpersMarkdownScript2['default'](_level3_protectWaterMd2['default']),
	  fr_CA: new _helpersMarkdownScript2['default'](_level3_protectWaterFr_CAMd2['default'])
	});
	var markdownFileLevel4 = (0, _helpersI18n.i18nData)({
	  en: new _helpersMarkdownScript2['default'](_level4_connectInPlaceMd2['default']),
	  fr_CA: new _helpersMarkdownScript2['default'](_level4_connectInPlaceFr_CAMd2['default'])
	});
	
	var levels = {
	  '1': { md: markdownFileLevel1 },
	  '2': { md: markdownFileLevel2 },
	  '3': { md: markdownFileLevel3 },
	  '4': { md: markdownFileLevel4 }
	};
	
	function preloadGameShow() {
	  (0, _spectaclePpa.preloader)([_title_gameshowPng2['default'], _title_gameshowFr_CAPng2['default'], _title_gameshow_playersPng2['default'], _title_gameshow_playersFr_CAPng2['default'], _imagesCharactersApprenticesPairArmsFoldedPng2['default'], _imagesCharactersApprenticePointingUp2Png2['default'], _imagesCharactersApprenticesFlexArmsPng2['default'], _imagesCharactersApprenticePointingUp3Png2['default'], _imagesCharactersApprenticeFistUpPng2['default'], _imagesCharactersApprenticeHandsHips2Png2['default'], _imagesCharactersApprenticeCuriousPng2['default'], _imagesCharactersSara_surprisedPng2['default'], _imagesCharactersIan_shrug_laughPng2['default']]);
	}
	
	function intro(level, regionData, md) {
	  return (0, _baseSlidesVideoSlide2['default'])({
	    id: 'intro',
	    notes: md.getSubSectionAsHtml('Intro Video', 'Notes', false, regionData),
	    youTubeId: md.getSectionMetadata('Intro Video', 'YouTube', regionData)
	  });
	}
	
	function sizzle(level, regionData, md, i18n) {
	  return (0, _baseSlidesHeadingSlide2['default'])({
	    id: 'sizzle',
	    bgColor: '#742CBF',
	    afterImage: i18n(imageGameshowTitle),
	    notes: md.getSubSectionAsHtml('Sizzle', 'Notes', false, regionData)
	  });
	}
	
	function scoring(level, regionData, md) {
	  return (0, _baseSlidesBalloonSlide2['default'])({
	    id: 'scoring',
	    characterSide: 'right',
	    characterImage: _imagesCharactersApprenticeHandsHips2Png2['default'],
	    notes: md.getSubSectionAsHtml('Scoring', 'Notes', false, regionData),
	    html: md.getSubSectionAsHtml('Scoring', 'Content', false, regionData),
	    bgColor: '#742CBF'
	  });
	}
	
	function questionSlide(_ref) {
	  var level = _ref.level;
	  var questionNumber = _ref.questionNumber;
	  var numQuestions = _ref.numQuestions;
	  var md = _ref.md;
	  var questionCharacterImage = _ref.questionCharacterImage;
	  var answerCharacterImage = _ref.answerCharacterImage;
	  var regionData = _ref.regionData;
	  var i18n = _ref.i18n;
	
	  var _ = i18n;
	  var questionSection = 'Question ' + questionNumber;
	  var defaultRegion = md.getSectionMetadata(questionSection, 'Default Region', regionData);
	  var questionCharacter = !questionCharacterImage ? _imagesCharactersApprenticeCuriousPng2['default'] : questionCharacterImage;
	  var answerCharacter = !answerCharacterImage ? _imagesCharactersApprenticePointingUp3Png2['default'] : answerCharacterImage;
	  var answer = undefined;
	  if (defaultRegion) {
	    answer = md.getSubSectionAsHtml(questionSection, 'Answer - ' + defaultRegion, false, regionData);
	  } else {
	    answer = md.getSubSectionAsHtml(questionSection, 'Answer', false, regionData);
	  }
	  var answerNotes = md.getSubSectionAsHtml(questionSection, 'Answer Notes', false, regionData);
	
	  return [
	
	  // four players announcement
	  (0, _baseSlidesHeadingSlide2['default'])({
	    id: questionNumber + '-four-players',
	    afterImage: i18n(imageGameshowPlayers),
	    bgColor: 'black',
	    notes: '<h2>' + _(_templateObject, questionNumber, numQuestions) + ':</h2>' + md.getSubSectionAsHtml('Four Players Announcement', 'Notes', false, regionData)
	  }),
	
	  // additional slide for level 1, question 2
	  level === 1 && questionNumber === 2 || level === 3 && questionNumber === 4 ? (0, _baseSlidesBalloonSlide2['default'])({
	    balloonType: 'question',
	    characterSide: 'left',
	    characterImage: _imagesCharactersApprenticeCuriousPng2['default'],
	    questionNumber: questionNumber,
	    numQuestions: numQuestions,
	    id: questionNumber + '-multiple-choice',
	    html: md.getSubSectionAsHtml(questionSection, 'Question Intro', false, regionData),
	    notes: '<h2>' + _(_templateObject, questionNumber, numQuestions) + ':</h2>' + '<br />' + ('<p style="font color: white">' + _('Multiple choice, see next slide') + '</h4>'),
	    bgColor: '#45B3EC',
	    i18n: i18n
	  }) : null,
	
	  // question text
	  (0, _baseSlidesBalloonSlide2['default'])({
	    balloonType: 'question',
	    characterSide: 'left',
	    characterImage: questionCharacter,
	    questionNumber: questionNumber,
	    numQuestions: numQuestions,
	    id: questionNumber + '-question',
	    html: md.getSubSectionAsHtml(questionSection, 'Question', false, regionData),
	    notes: '<h2>' + _(_templateObject, questionNumber, numQuestions) + ':</h2>' + '<br />' + ('<p style="font color: white">' + _('Preview of next slide/answer') + '</h4>') + answer,
	    i18n: i18n
	  }),
	
	  // answer text
	  (0, _baseSlidesBalloonSlide2['default'])({
	    balloonType: 'answer',
	    characterSide: 'right',
	    characterImage: answerCharacter,
	    questionNumber: questionNumber,
	    id: questionNumber + '-answer',
	    html: answer,
	    notes: '<h2>' + _(_templateObject2, questionNumber, numQuestions) + '</h2>' + '<br />' + (!answerNotes.match(/SKIP/) ? md.getSubSectionAsHtml(questionSection, 'Answer Notes', false, regionData) : ''),
	    i18n: i18n
	  })];
	}
	
	function endOfGameShow(level, /*i18n*/_) {
	  return (0, _baseSlidesBalloonSlide2['default'])({
	    id: 'end',
	    characterSide: 'left',
	    characterImage: _imagesCharactersApprenticeFistUpPng2['default'],
	    bgColor: '#742CBF',
	    html: '<h3>' + _(_templateObject3, level) + '!</h3>',
	    notes: _('Game show completed') + '.'
	  });
	}
	
	function level1(regionData, i18n) {
	  var level = 1;
	  var md = i18n(levels[level].md);
	
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'game-show' },
	    sizzle(level, regionData, md, i18n),
	    intro(level, regionData, md),
	    scoring(level, regionData, md),
	    questionSlide({ level: level, questionNumber: 1, numQuestions: 3, md: md, regionData: regionData, i18n: i18n }),
	    (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'scoring-reminder',
	      characterSide: 'right',
	      characterImage: _imagesCharactersApprenticePointingDiagonalPng2['default'],
	      notes: md.getSubSectionAsHtml('Scoring Reminder', 'Notes', false, regionData),
	      html: md.getSubSectionAsHtml('Scoring Reminder', 'Content', false, regionData),
	      bgColor: '#742CBF'
	    }),
	    questionSlide({ level: level, questionNumber: 2, numQuestions: 3, md: md, regionData: regionData, i18n: i18n }),
	    questionSlide({ level: level, questionNumber: 3, numQuestions: 3, md: md, regionData: regionData, i18n: i18n }),
	    endOfGameShow(level, i18n)
	  );
	}
	
	function level2(regionData, i18n) {
	  var level = 2;
	  var md = i18n(levels[level].md);
	
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'game-show' },
	    sizzle(level, regionData, md, i18n),
	    intro(level, regionData, md),
	    scoring(level, regionData, md),
	    questionSlide({ level: level, questionNumber: 1, numQuestions: 3, md: md, regionData: regionData, i18n: i18n }),
	    (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'scoring-reminder',
	      characterSide: 'right',
	      characterImage: _imagesCharactersApprenticePointingDiagonalPng2['default'],
	      notes: md.getSubSectionAsHtml('Scoring Reminder', 'Notes', false, regionData),
	      html: md.getSubSectionAsHtml('Scoring Reminder', 'Content', false, regionData),
	      bgColor: '#742CBF'
	    }),
	    questionSlide({ level: level, questionNumber: 2, numQuestions: 3, md: md, regionData: regionData, i18n: i18n }),
	    questionSlide({ level: level, questionNumber: 3, numQuestions: 3, md: md, regionData: regionData, i18n: i18n }),
	    endOfGameShow(level, i18n)
	  );
	}
	
	function level3(regionData, i18n) {
	  var level = 3;
	  var md = i18n(levels[level].md);
	
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'game-show' },
	    sizzle(level, regionData, md, i18n),
	    intro(level, regionData, md),
	    questionSlide({ level: level, questionNumber: 1, numQuestions: 5, md: md, regionData: regionData, i18n: i18n }),
	    questionSlide({ level: level, questionNumber: 2, numQuestions: 5, md: md, regionData: regionData, i18n: i18n }),
	    questionSlide({ level: level, questionNumber: 3, numQuestions: 5, md: md, regionData: regionData, i18n: i18n }),
	    questionSlide({ level: level, questionNumber: 4, numQuestions: 5, md: md, regionData: regionData, i18n: i18n }),
	    questionSlide({ level: level, questionNumber: 5, numQuestions: 5, md: md, regionData: regionData, i18n: i18n }),
	    endOfGameShow(level, i18n)
	  );
	}
	
	function level4(regionData, i18n) {
	  var level = 4;
	  var md = i18n(levels[level].md);
	
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'game-show' },
	    sizzle(level, regionData, md, i18n),
	    intro(level, regionData, md),
	    questionSlide({ level: level, questionNumber: 1, numQuestions: 3, md: md, regionData: regionData, i18n: i18n }),
	    questionSlide({ level: level, questionNumber: 2, numQuestions: 3, md: md, regionData: regionData, i18n: i18n }),
	    questionSlide({ level: level, questionNumber: 3, numQuestions: 3, md: md, regionData: regionData, i18n: i18n }),
	    endOfGameShow(level, i18n)
	  );
	}
	
	function gameShowSection(_ref2) {
	  var level = _ref2.level;
	  var regionData = _ref2.regionData;
	  var i18n = _ref2.i18n;
	
	  switch (level) {
	    case 1:
	      return level1(regionData, i18n);
	    case 2:
	      return level2(regionData, i18n);
	    case 3:
	      return level3(regionData, i18n);
	    case 4:
	      return level4(regionData, i18n);
	    default:
	      return (0, _baseSlidesHeadingSlide2['default'])({ heading: 'Unknown' });
	  }
	}
	
	exports['default'] = gameShowSection;
	/* Sizzle */ /* Sara and Ian introduce the Game Show */ /* Scoring intro */ /* Game show questions */ /* Scoring reminder */ /* End of Game Show */ /* Sizzle */ /* Sara and Ian introduce the Game Show */ /* Scoring intro */ /* Game show questions */ /* Scoring reminder */ /* End of Game Show */ /* Sizzle */ /* Sara and Ian introduce the Game Show */ /* Game show questions */ /* End of Game Show */ /* Sizzle */ /* Sara and Ian introduce the Game Show */ /* Game show questions */ /* End of Game Show */

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = __webpack_require__(7)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	function headingSlide(_ref) {
	  var id = _ref.id;
	  var bgColor = _ref.bgColor;
	  var notes = _ref.notes;
	  var heading = _ref.heading;
	  var subHeading = _ref.subHeading;
	  var beforeImage = _ref.beforeImage;
	  var afterImage = _ref.afterImage;
	  var slideClass = _ref.slideClass;
	
	  var slideContentClass = slideClass ? ' slide-' + slideClass : '';
	  var bgColorOpts = {};
	  if (bgColor) {
	    bgColorOpts.bgColor = bgColor;
	  }
	  return _react2['default'].createElement(
	    _spectaclePpa.Slide,
	    _extends({
	      id: id,
	      key: id
	    }, bgColorOpts, {
	      notes: notes }),
	    _react2['default'].createElement(
	      'div',
	      { className: 'slide-content' + slideContentClass },
	      !!beforeImage && _react2['default'].createElement(
	        'div',
	        { className: 'flex-image' },
	        _react2['default'].createElement('img', {
	          className: 'heading-image heading-image-before',
	          src: beforeImage })
	      ),
	      _react2['default'].createElement(
	        'div',
	        { className: 'text-heading' },
	        _react2['default'].createElement(
	          _spectaclePpa.Heading,
	          { size: 2 },
	          _react2['default'].createElement('div', { dangerouslySetInnerHTML: { __html: heading } })
	        ),
	        !!subHeading && _react2['default'].createElement(
	          _spectaclePpa.Heading,
	          { size: 3 },
	          _react2['default'].createElement('div', { dangerouslySetInnerHTML: { __html: subHeading } })
	        )
	      ),
	      !!afterImage && _react2['default'].createElement('img', {
	        className: 'heading-image heading-image-after',
	        src: afterImage })
	    )
	  );
	}
	
	exports['default'] = headingSlide;
	module.exports = exports['default'];

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = __webpack_require__(7)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	function headingSlide(_ref) {
	  var id = _ref.id;
	  var bgColor = _ref.bgColor;
	  var notes = _ref.notes;
	  var heading = _ref.heading;
	  var subHeading = _ref.subHeading;
	  var beforeImage = _ref.beforeImage;
	  var afterImage = _ref.afterImage;
	  var slideClass = _ref.slideClass;
	
	  var slideContentClass = slideClass ? ' slide-' + slideClass : '';
	  var bgColorOpts = {};
	  if (bgColor) {
	    bgColorOpts.bgColor = bgColor;
	  }
	  return _react2['default'].createElement(
	    _spectaclePpa.Slide,
	    _extends({
	      id: id,
	      key: id
	    }, bgColorOpts, {
	      notes: notes }),
	    _react2['default'].createElement(
	      'div',
	      { className: 'slide-content' + slideContentClass },
	      !!beforeImage && _react2['default'].createElement(
	        'div',
	        { className: 'flex-image' },
	        _react2['default'].createElement('img', {
	          className: 'heading-image heading-image-before',
	          src: beforeImage })
	      ),
	      _react2['default'].createElement(
	        'div',
	        { className: 'text-heading' },
	        _react2['default'].createElement(
	          _spectaclePpa.Heading,
	          { size: 2 },
	          _react2['default'].createElement('div', { dangerouslySetInnerHTML: { __html: heading } })
	        ),
	        !!subHeading && _react2['default'].createElement(
	          _spectaclePpa.Heading,
	          { size: 3 },
	          _react2['default'].createElement('div', { dangerouslySetInnerHTML: { __html: subHeading } })
	        )
	      ),
	      !!afterImage && _react2['default'].createElement('img', {
	        className: 'heading-image heading-image-after',
	        src: afterImage })
	    )
	  );
	}
	
	exports['default'] = headingSlide;
	module.exports = exports['default'];

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = __webpack_require__(7)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	function headingSlide(_ref) {
	  var id = _ref.id;
	  var bgColor = _ref.bgColor;
	  var notes = _ref.notes;
	  var heading = _ref.heading;
	  var subHeading = _ref.subHeading;
	  var beforeImage = _ref.beforeImage;
	  var afterImage = _ref.afterImage;
	  var slideClass = _ref.slideClass;
	
	  var slideContentClass = slideClass ? ' slide-' + slideClass : '';
	  var bgColorOpts = {};
	  if (bgColor) {
	    bgColorOpts.bgColor = bgColor;
	  }
	  return _react2['default'].createElement(
	    _spectaclePpa.Slide,
	    _extends({
	      id: id,
	      key: id
	    }, bgColorOpts, {
	      notes: notes }),
	    _react2['default'].createElement(
	      'div',
	      { className: 'slide-content' + slideContentClass },
	      !!beforeImage && _react2['default'].createElement(
	        'div',
	        { className: 'flex-image' },
	        _react2['default'].createElement('img', {
	          className: 'heading-image heading-image-before',
	          src: beforeImage })
	      ),
	      _react2['default'].createElement(
	        'div',
	        { className: 'text-heading' },
	        _react2['default'].createElement(
	          _spectaclePpa.Heading,
	          { size: 2 },
	          _react2['default'].createElement('div', { dangerouslySetInnerHTML: { __html: heading } })
	        ),
	        !!subHeading && _react2['default'].createElement(
	          _spectaclePpa.Heading,
	          { size: 3 },
	          _react2['default'].createElement('div', { dangerouslySetInnerHTML: { __html: subHeading } })
	        )
	      ),
	      !!afterImage && _react2['default'].createElement('img', {
	        className: 'heading-image heading-image-after',
	        src: afterImage })
	    )
	  );
	}
	
	exports['default'] = headingSlide;
	module.exports = exports['default'];

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.preloadMissionReport = preloadMissionReport;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _componentsMissionReport = __webpack_require__(76);
	
	var _componentsMissionReport2 = _interopRequireDefault(_componentsMissionReport);
	
	var _baseSlidesVideoSlide = __webpack_require__(43);
	
	var _baseSlidesVideoSlide2 = _interopRequireDefault(_baseSlidesVideoSlide);
	
	var _baseSlidesBalloonSlide = __webpack_require__(71);
	
	var _baseSlidesBalloonSlide2 = _interopRequireDefault(_baseSlidesBalloonSlide);
	
	var _imagesCharactersEsmeralda_hands_out_weheyPng = __webpack_require__(447);
	
	var _imagesCharactersEsmeralda_hands_out_weheyPng2 = _interopRequireDefault(_imagesCharactersEsmeralda_hands_out_weheyPng);
	
	var _imagesCharactersEsmeralda_hands_out_up_closePng = __webpack_require__(2489);
	
	var _imagesCharactersEsmeralda_hands_out_up_closePng2 = _interopRequireDefault(_imagesCharactersEsmeralda_hands_out_up_closePng);
	
	var _imagesCharactersEsmeralda_goober_goofy_smilePng = __webpack_require__(445);
	
	var _imagesCharactersEsmeralda_goober_goofy_smilePng2 = _interopRequireDefault(_imagesCharactersEsmeralda_goober_goofy_smilePng);
	
	var _imagesCharactersIan_headshot_smilePng = __webpack_require__(908);
	
	var _imagesCharactersIan_headshot_smilePng2 = _interopRequireDefault(_imagesCharactersIan_headshot_smilePng);
	
	var _imagesCharactersEsmeralda_goober_proudPng = __webpack_require__(446);
	
	var _imagesCharactersEsmeralda_goober_proudPng2 = _interopRequireDefault(_imagesCharactersEsmeralda_goober_proudPng);
	
	var _helpersMarkdownScript = __webpack_require__(9);
	
	var _helpersMarkdownScript2 = _interopRequireDefault(_helpersMarkdownScript);
	
	var _level2_operationGarbageWatchMd = __webpack_require__(1830);
	
	var _level2_operationGarbageWatchMd2 = _interopRequireDefault(_level2_operationGarbageWatchMd);
	
	var _level3_operationLoveFoodHateWasteMd = __webpack_require__(1831);
	
	var _level3_operationLoveFoodHateWasteMd2 = _interopRequireDefault(_level3_operationLoveFoodHateWasteMd);
	
	var _level4_operationFoodScrapsMd = __webpack_require__(1832);
	
	var _level4_operationFoodScrapsMd2 = _interopRequireDefault(_level4_operationFoodScrapsMd);
	
	var _level5_operationWasteFreeLunchMd = __webpack_require__(1833);
	
	var _level5_operationWasteFreeLunchMd2 = _interopRequireDefault(_level5_operationWasteFreeLunchMd);
	
	var _level6_operationBuySmartMd = __webpack_require__(1834);
	
	var _level6_operationBuySmartMd2 = _interopRequireDefault(_level6_operationBuySmartMd);
	
	var _imagesLevel1_startPng = __webpack_require__(448);
	
	var _imagesLevel1_startPng2 = _interopRequireDefault(_imagesLevel1_startPng);
	
	var _imagesLevel2_startPng = __webpack_require__(449);
	
	var _imagesLevel2_startPng2 = _interopRequireDefault(_imagesLevel2_startPng);
	
	var _imagesLevel3_startPng = __webpack_require__(450);
	
	var _imagesLevel3_startPng2 = _interopRequireDefault(_imagesLevel3_startPng);
	
	var _imagesLevel4_startPng = __webpack_require__(451);
	
	var _imagesLevel4_startPng2 = _interopRequireDefault(_imagesLevel4_startPng);
	
	var _imagesLevel5_startPng = __webpack_require__(452);
	
	var _imagesLevel5_startPng2 = _interopRequireDefault(_imagesLevel5_startPng);
	
	var levels = {
	  '1': { img: _imagesLevel1_startPng2['default'] },
	  '2': { md: new _helpersMarkdownScript2['default'](_level2_operationGarbageWatchMd2['default']), img: _imagesLevel2_startPng2['default'] },
	  '3': { md: new _helpersMarkdownScript2['default'](_level3_operationLoveFoodHateWasteMd2['default']), img: _imagesLevel3_startPng2['default'] },
	  '4': { md: new _helpersMarkdownScript2['default'](_level4_operationFoodScrapsMd2['default']), img: _imagesLevel4_startPng2['default'] },
	  '5': { md: new _helpersMarkdownScript2['default'](_level5_operationWasteFreeLunchMd2['default']), img: _imagesLevel5_startPng2['default'] },
	  '6': { md: new _helpersMarkdownScript2['default'](_level6_operationBuySmartMd2['default']) }
	};
	
	function preloadMissionReport() {
	  (0, _spectaclePpa.preloader)([_imagesCharactersEsmeralda_hands_out_weheyPng2['default'], _imagesCharactersEsmeralda_hands_out_up_closePng2['default'], _imagesCharactersEsmeralda_goober_goofy_smilePng2['default'], _imagesCharactersIan_headshot_smilePng2['default'], _imagesCharactersEsmeralda_goober_proudPng2['default'], _imagesLevel1_startPng2['default'], _imagesLevel2_startPng2['default'], _imagesLevel3_startPng2['default'], _imagesLevel4_startPng2['default'], _imagesLevel5_startPng2['default']]);
	}
	
	function missionReportSection(_ref) {
	  var level = _ref.level;
	  var regionData = _ref.regionData;
	
	  var md = levels[level].md;
	  var missionReportQuestions = md.getQuestions('Questions', 'Content', regionData);
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'mission-report' },
	    (0, _baseSlidesVideoSlide2['default'])({
	      id: 'video',
	      youTubeId: md.getSectionMetadata('Intro Video', 'YouTube', regionData),
	      notes: md.getSubSectionAsHtml('Intro Video', 'Notes', false, regionData)
	    }),
	    (level === 2 || level === 4 || level === 6) && (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'scoring',
	      characterSide: 'left',
	      characterImage: _imagesCharactersEsmeralda_hands_out_weheyPng2['default'],
	      html: md.getSubSectionAsHtml('Scoring', 'Content', false, regionData),
	      notes: md.getSubSectionAsHtml('Scoring', 'Notes', false, regionData)
	    }),
	    (level === 3 || level === 5) && (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'scoring',
	      characterSide: 'right',
	      characterImage: _imagesCharactersEsmeralda_hands_out_up_closePng2['default'],
	      html: md.getSubSectionAsHtml('Scoring', 'Content', false, regionData),
	      notes: md.getSubSectionAsHtml('Scoring', 'Notes', false, regionData)
	    }),
	    (level === 2 || level === 4 || level === 6) && (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'instructions',
	      characterSide: 'right',
	      characterImage: _imagesCharactersEsmeralda_hands_out_up_closePng2['default'],
	      html: md.getSubSectionAsHtml('Instructions', 'Content', false, regionData),
	      notes: md.getSubSectionAsHtml('Instructions', 'Notes', false, regionData)
	    }),
	    (level === 3 || level === 5) && (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'instructions',
	      characterSide: 'left',
	      characterImage: _imagesCharactersEsmeralda_hands_out_weheyPng2['default'],
	      html: md.getSubSectionAsHtml('Instructions', 'Content', false, regionData),
	      notes: md.getSubSectionAsHtml('Instructions', 'Notes', false, regionData)
	    }),
	    _react2['default'].createElement(
	      _spectaclePpa.Slide,
	      {
	        id: 'report',
	        bgColor: 'black',
	        missionReportQuestions: missionReportQuestions },
	      _react2['default'].createElement(
	        'div',
	        {
	          className: 'ui-slide mission-report-level-' + (level - 1) },
	        _react2['default'].createElement(
	          'header',
	          {
	            className: 'level-header' },
	          _react2['default'].createElement(
	            'figure',
	            { className: 'level-header-thumb' },
	            _react2['default'].createElement('img', { src: levels[level - 1].img })
	          ),
	          _react2['default'].createElement(
	            _spectaclePpa.Heading,
	            { size: 2 },
	            'Mission Report:',
	            _react2['default'].createElement('br', null),
	            md.getSectionMetadata('Mission Report', 'Title', regionData)
	          )
	        ),
	        _react2['default'].createElement(
	          'section',
	          {
	            className: 'mission-report-form' },
	          _react2['default'].createElement(_componentsMissionReport2['default'], { missionReportQuestions: missionReportQuestions })
	        )
	      )
	    ),
	    (level === 2 || level === 4 || level === 6) && (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'impact',
	      characterSide: 'right',
	      characterImage: _imagesCharactersEsmeralda_goober_proudPng2['default'],
	      html: md.getSubSectionAsHtml('Impact', 'Content', false, regionData),
	      notes: md.getSubSectionAsHtml('Impact', 'Notes', false, regionData)
	    }),
	    (level === 3 || level === 5) && (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'impact',
	      characterSide: 'right',
	      characterImage: _imagesCharactersEsmeralda_goober_goofy_smilePng2['default'],
	      html: md.getSubSectionAsHtml('Impact', 'Content', false, regionData),
	      notes: md.getSubSectionAsHtml('Impact', 'Notes', false, regionData)
	    }),
	    level !== 2 ? (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'class-discussion',
	      characterSide: 'left',
	      characterImage: _imagesCharactersIan_headshot_smilePng2['default'],
	      html: md.getSubSectionAsHtml('Class Discussion', 'Content', false, regionData),
	      notes: md.getSubSectionAsHtml('Class Discussion', 'Notes', false, regionData)
	    }) : null
	  );
	}
	
	exports['default'] = missionReportSection;
	/* Sara and Ian introduce mission report */ /* Scoring levels 2, 4 & 6 */ /* Scoring levels 3 & 5 */ /* Instructions levels 2, 4 & 6 */ /* Instructions 3 & 5 */ /* Mission Reporting Screen */ /* Impact screen for levels 2,4 & 6 */ /* Impact screen for levels 3 & 5 */ /* Class Discussion */

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.preloadMissionAssignment = preloadMissionAssignment;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _baseSlidesHeadingSlide = __webpack_require__(171);
	
	var _baseSlidesHeadingSlide2 = _interopRequireDefault(_baseSlidesHeadingSlide);
	
	var _baseSlidesBalloonSlide = __webpack_require__(71);
	
	var _baseSlidesBalloonSlide2 = _interopRequireDefault(_baseSlidesBalloonSlide);
	
	var _baseSlidesVideoSlide = __webpack_require__(43);
	
	var _baseSlidesVideoSlide2 = _interopRequireDefault(_baseSlidesVideoSlide);
	
	var _imagesLogo_ppaPng = __webpack_require__(912);
	
	var _imagesLogo_ppaPng2 = _interopRequireDefault(_imagesLogo_ppaPng);
	
	var _imagesCharactersEsPowerStancePng = __webpack_require__(2487);
	
	var _imagesCharactersEsPowerStancePng2 = _interopRequireDefault(_imagesCharactersEsPowerStancePng);
	
	var _imagesCharactersEsmeralda_hands_out_weheyPng = __webpack_require__(447);
	
	var _imagesCharactersEsmeralda_hands_out_weheyPng2 = _interopRequireDefault(_imagesCharactersEsmeralda_hands_out_weheyPng);
	
	var _helpersMarkdownScript = __webpack_require__(9);
	
	var _helpersMarkdownScript2 = _interopRequireDefault(_helpersMarkdownScript);
	
	var _level1_operationGarbageWatchMd = __webpack_require__(1866);
	
	var _level1_operationGarbageWatchMd2 = _interopRequireDefault(_level1_operationGarbageWatchMd);
	
	var _level2_operationLoveFoodHateWasteMd = __webpack_require__(1867);
	
	var _level2_operationLoveFoodHateWasteMd2 = _interopRequireDefault(_level2_operationLoveFoodHateWasteMd);
	
	var _level3_operationFoodScrapsMd = __webpack_require__(1868);
	
	var _level3_operationFoodScrapsMd2 = _interopRequireDefault(_level3_operationFoodScrapsMd);
	
	var _level4_operationWasteFreeLunchMd = __webpack_require__(1869);
	
	var _level4_operationWasteFreeLunchMd2 = _interopRequireDefault(_level4_operationWasteFreeLunchMd);
	
	var _level5_operationBuySmartMd = __webpack_require__(1870);
	
	var _level5_operationBuySmartMd2 = _interopRequireDefault(_level5_operationBuySmartMd);
	
	var levels = {
	  '1': { md: new _helpersMarkdownScript2['default'](_level1_operationGarbageWatchMd2['default']) },
	  '2': { md: new _helpersMarkdownScript2['default'](_level2_operationLoveFoodHateWasteMd2['default']) },
	  '3': { md: new _helpersMarkdownScript2['default'](_level3_operationFoodScrapsMd2['default']) },
	  '4': { md: new _helpersMarkdownScript2['default'](_level4_operationWasteFreeLunchMd2['default']) },
	  '5': { md: new _helpersMarkdownScript2['default'](_level5_operationBuySmartMd2['default']) }
	};
	
	function preloadMissionAssignment() {
	  (0, _spectaclePpa.preloader)([_imagesLogo_ppaPng2['default'], _imagesCharactersEsPowerStancePng2['default'], _imagesCharactersEsmeralda_hands_out_weheyPng2['default']]);
	}
	
	function missionAssignmentSection(_ref) {
	  var level = _ref.level;
	  var title = _ref.title;
	  var regionData = _ref.regionData;
	
	  var md = levels[level].md;
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'mission-assignment' },
	    (level === 3 || level === 5) && (0, _baseSlidesVideoSlide2['default'])({
	      id: 'intro-video',
	      notes: md.getSubSectionAsHtml('Intro Video', 'Notes', false, regionData),
	      youTubeId: md.getSectionMetadata('Intro Video', 'YouTube', regionData)
	    }),
	    (0, _baseSlidesHeadingSlide2['default'])({
	      id: 'sizzle',
	      beforeImage: _imagesLogo_ppaPng2['default'],
	      subHeading: 'Mission ' + level + ':<br/> ' + title,
	      notes: md.getSubSectionAsHtml('Mission Assignment', 'Notes', false, regionData),
	      bgColor: 'black'
	    }),
	    (level === 1 || level === 3 || level === 5) && (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'instructions',
	      characterSide: 'right',
	      characterImage: _imagesCharactersEsPowerStancePng2['default'],
	      notes: md.getSubSectionAsHtml('Instructions', 'Notes', false, regionData),
	      html: md.getSubSectionAsHtml('Instructions', 'Content', false, regionData)
	    }),
	    level === 1 && (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'bonus-mission',
	      characterSide: 'right',
	      characterImage: _imagesCharactersEsmeralda_hands_out_weheyPng2['default'],
	      notes: md.getSubSectionAsHtml('Bonus Mission', 'Notes', false, regionData),
	      html: md.getSubSectionAsHtml('Bonus Mission', 'Content', false, regionData)
	    }),
	    (level === 2 || level === 4) && (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'instructions',
	      characterSide: 'right',
	      characterImage: _imagesCharactersEsmeralda_hands_out_weheyPng2['default'],
	      notes: md.getSubSectionAsHtml('Instructions', 'Notes', false, regionData),
	      html: md.getSubSectionAsHtml('Instructions', 'Content', false, regionData)
	    }),
	    level === 1 && (0, _baseSlidesVideoSlide2['default'])({
	      id: 'outro',
	      notes: md.getSubSectionAsHtml('Outro Video', 'Notes', false, regionData),
	      youTubeId: md.getSectionMetadata('Outro Video', 'YouTube', regionData)
	    })
	  );
	}
	
	exports['default'] = missionAssignmentSection;
	/* Mission assignment intro only in levels 3 & 5 */ /* Sizzle */ /* Mission Instructions levels 1,3 & 5 */ /* Bonus mission in level 1 */ /* Mission Instructions levels 2 & 4 */ /* Mission assignment outro only in level 1 */

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.preloadFinish = preloadFinish;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _componentsCompleteLevelButton = __webpack_require__(44);
	
	var _componentsCompleteLevelButton2 = _interopRequireDefault(_componentsCompleteLevelButton);
	
	var _baseSlidesBalloonSlide = __webpack_require__(71);
	
	var _baseSlidesBalloonSlide2 = _interopRequireDefault(_baseSlidesBalloonSlide);
	
	var _imagesCharactersEsmeralda_goober_goofy_smilePng = __webpack_require__(445);
	
	var _imagesCharactersEsmeralda_goober_goofy_smilePng2 = _interopRequireDefault(_imagesCharactersEsmeralda_goober_goofy_smilePng);
	
	var _imagesCharactersEsmeralda_goober_proudPng = __webpack_require__(446);
	
	var _imagesCharactersEsmeralda_goober_proudPng2 = _interopRequireDefault(_imagesCharactersEsmeralda_goober_proudPng);
	
	var _imagesCharactersEsmeralda_goober_wavePng = __webpack_require__(2488);
	
	var _imagesCharactersEsmeralda_goober_wavePng2 = _interopRequireDefault(_imagesCharactersEsmeralda_goober_wavePng);
	
	var _imagesCharactersIan_sara_sidePng = __webpack_require__(2493);
	
	var _imagesCharactersIan_sara_sidePng2 = _interopRequireDefault(_imagesCharactersIan_sara_sidePng);
	
	var _imagesCharactersIan_sara_lean_questioningPng = __webpack_require__(909);
	
	var _imagesCharactersIan_sara_lean_questioningPng2 = _interopRequireDefault(_imagesCharactersIan_sara_lean_questioningPng);
	
	var _helpersMarkdownScript = __webpack_require__(9);
	
	var _helpersMarkdownScript2 = _interopRequireDefault(_helpersMarkdownScript);
	
	var _finishMd = __webpack_require__(1871);
	
	var _finishMd2 = _interopRequireDefault(_finishMd);
	
	var _level1_completeSvg = __webpack_require__(2515);
	
	var _level1_completeSvg2 = _interopRequireDefault(_level1_completeSvg);
	
	var _level2_completeSvg = __webpack_require__(2516);
	
	var _level2_completeSvg2 = _interopRequireDefault(_level2_completeSvg);
	
	var _level3_completeSvg = __webpack_require__(2517);
	
	var _level3_completeSvg2 = _interopRequireDefault(_level3_completeSvg);
	
	var _level4_completeSvg = __webpack_require__(2518);
	
	var _level4_completeSvg2 = _interopRequireDefault(_level4_completeSvg);
	
	var _level5_completeSvg = __webpack_require__(2519);
	
	var _level5_completeSvg2 = _interopRequireDefault(_level5_completeSvg);
	
	var _level6_completeSvg = __webpack_require__(2520);
	
	var _level6_completeSvg2 = _interopRequireDefault(_level6_completeSvg);
	
	var md = new _helpersMarkdownScript2['default'](_finishMd2['default']);
	
	var levels = {
	  '1': { img: _level1_completeSvg2['default'] },
	  '2': { img: _level2_completeSvg2['default'] },
	  '3': { img: _level3_completeSvg2['default'] },
	  '4': { img: _level4_completeSvg2['default'] },
	  '5': { img: _level5_completeSvg2['default'] },
	  '6': { img: _level6_completeSvg2['default'] }
	};
	
	function preloadFinish() {
	  (0, _spectaclePpa.preloader)([_imagesCharactersEsmeralda_goober_goofy_smilePng2['default'], _imagesCharactersEsmeralda_goober_proudPng2['default'], _imagesCharactersEsmeralda_goober_wavePng2['default'], _imagesCharactersIan_sara_sidePng2['default'], _imagesCharactersIan_sara_lean_questioningPng2['default'], _level1_completeSvg2['default'], _level2_completeSvg2['default'], _level3_completeSvg2['default'], _level4_completeSvg2['default'], _level5_completeSvg2['default'], _level6_completeSvg2['default']]);
	}
	
	function finishSection(_ref) {
	  var level = _ref.level;
	  var regionData = _ref.regionData;
	
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'finish' },
	    level !== 6 && (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'scoreboard-recap',
	      characterSide: 'left',
	      characterImage: _imagesCharactersIan_sara_sidePng2['default'],
	      html: md.getSubSectionAsHtml('Scoreboard Recap', 'Content', false, regionData),
	      notes: md.getSubSectionAsHtml('Scoreboard Recap', 'Notes', false, regionData)
	    }),
	    level !== 6 && (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'earn-more-points',
	      characterSide: 'right',
	      characterImage: _imagesCharactersIan_sara_lean_questioningPng2['default'],
	      html: md.getSubSectionAsHtml('Earn More Points', 'Content', false, regionData),
	      notes: md.getSubSectionAsHtml('Earn More Points', 'Notes', false, regionData)
	    }),
	    (level === 1 || level === 4) && (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'farewell',
	      characterSide: 'right',
	      characterImage: _imagesCharactersEsmeralda_goober_goofy_smilePng2['default'],
	      html: md.getSubSectionAsHtml('Farewell', 'Content', false, regionData),
	      notes: md.getSubSectionAsHtml('Farewell', 'Notes', false, regionData)
	    }),
	    (level === 2 || level === 5) && (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'farewell',
	      characterSide: 'left',
	      characterImage: _imagesCharactersEsmeralda_goober_proudPng2['default'],
	      html: md.getSubSectionAsHtml('Farewell', 'Content', false, regionData),
	      notes: md.getSubSectionAsHtml('Farewell', 'Notes', false, regionData)
	    }),
	    level === 3 && (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'farewell',
	      characterSide: 'left',
	      characterImage: _imagesCharactersEsmeralda_goober_wavePng2['default'],
	      html: md.getSubSectionAsHtml('Farewell', 'Content', false, regionData),
	      notes: md.getSubSectionAsHtml('Farewell', 'Notes', false, regionData)
	    }),
	    _react2['default'].createElement(
	      _spectaclePpa.Slide,
	      {
	        id: 'level-completed',
	        notes: '<h2>Level ' + level + ' Finished</h2>',
	        bgColor: 'transparent',
	        finish: true },
	      _react2['default'].createElement(
	        'div',
	        { className: 'level-complete' },
	        _react2['default'].createElement(
	          'div',
	          { className: 'level-complete-content' },
	          _react2['default'].createElement(
	            'figure',
	            { className: 'level-complete-graphic' },
	            _react2['default'].createElement('img', { src: levels[level].img })
	          ),
	          _react2['default'].createElement(
	            _spectaclePpa.Heading,
	            { size: 2 },
	            'You\'ve finished'
	          ),
	          _react2['default'].createElement(
	            _spectaclePpa.Heading,
	            { size: 2 },
	            'level ',
	            level,
	            ' of 6'
	          ),
	          _react2['default'].createElement(_componentsCompleteLevelButton2['default'], null)
	        )
	      )
	    )
	  );
	}
	
	exports['default'] = finishSection;
	/* Scoreboard Recap */ /* Earn More Points */ /* Farewell levels 1 & 4 */ /* Farewell levels 2 & 5 */ /* Farewell levels 3 */ /* Level complete */

/***/ }),
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */
/***/ (function(module, exports) {

	/**
	 * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
	 * of an array-like value.
	 */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This function is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 */
	function isLength(value) {
	  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	module.exports = isLength;


/***/ }),
/* 185 */
/***/ (function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ }),
/* 186 */
/***/ (function(module, exports) {

	module.exports = "# Title - Short\n\nEP SQUAD\n\n# Title - Long\n\nEMERGENCY PREPAREDNESS SQUAD\n\n# Description - Short\n\nEmergency Preparedness Squad trains kids as emergency preparedness superheroes to make sure families are ready when disaster strikes!\n\n# Description - Long\n\nEmergency Preparedness Squad trains kids as emergency preparedness superheroes to make sure families are ready when disaster strikes!\n\n# Description - Levels\n\n**Modules include:**\n&nbsp;\n* Know the Risks\n* Make a Plan\n* Get a Kit\n* We're In This Together\n&nbsp;\n\n# Level 1\nTitle: Know the Risks\nDescription: Planning 101: Why plan? How making plans before an emergency can help you stay calm.\n\n# Level 2\nTitle: Make a Plan\nDescription: Planning 101: Why plan? How making plans before an emergency can help you stay calm.\n\n# Level 3\nTitle: Get a Kit\nDescription: Prepare a 'grab-and-go' bag to make sure you stay safe during the first 72hrs of an emergency.\n\n# Level 4\nTitle: We're In This Together\nDescription: Emergencies can bring out the best in communities. Celebrate how you've helped helped your family be better prepared!\n"

/***/ }),
/* 187 */
/***/ (function(module, exports) {

	module.exports = "# Title - Short\n\nEP SQUAD (Gr. K-2)\n\n# Title - Long\n\nEMERGENCY PREPAREDNESS SQUAD (Gr. K-2)\n\n# Description - Short\n\nEmergency Preparedness Squad (for Grades K-3) trains kids as emergency preparedness superheroes to make sure families are ready when disaster strikes!\n\n# Description - Long\n\nEmergency Preparedness Squad trains kids as emergency preparedness superheroes to make sure families are ready when disaster strikes!\n\n# Description - Levels\n\n**Modules include:**\n&nbsp;\n* Know the Risks\n* Make a Plan\n* Get a Kit\n* We're In This Together\n&nbsp;\n\n# Level 1\nTitle: Know the Risks\nDescription: Planning 101: Why plan? How making plans before an emergency can help you stay calm.\n\n# Level 2\nTitle: Make a Plan\nDescription: Planning 101: Why plan? How making plans before an emergency can help you stay calm.\n\n# Level 3\nTitle: Get a Kit\nDescription: Prepare a 'grab-and-go' bag to make sure you stay safe during the first 72hrs of an emergency.\n\n# Level 4\nTitle: We're In This Together\nDescription: Emergencies can bring out the best in communities. Celebrate how you've helped helped your family be better prepared!\n"

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(2038);

/***/ }),
/* 189 */,
/* 190 */,
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(147);
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys = __webpack_require__(778);
	var enumBugKeys = __webpack_require__(365);
	
	module.exports = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(364);
	module.exports = function (it) {
	  return Object(defined(it));
	};


/***/ }),
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1291);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(13)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/autoprefixer-loader/index.js?browsers=last 2 version!../../../node_modules/sass-loader/index.js?sourceMap&includePaths[]=/tmp/ppa-firebase/src/styles!./spinnerButton.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/autoprefixer-loader/index.js?browsers=last 2 version!../../../node_modules/sass-loader/index.js?sourceMap&includePaths[]=/tmp/ppa-firebase/src/styles!./spinnerButton.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/epsHybridIntermediates/images/characters/ian_sara_lean_questioning-24f9edc84f6866578dbd17d6d194a844.png";

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/epsHybridPrimaries/images/characters/ian_sara_lean_questioning-24f9edc84f6866578dbd17d6d194a844.png";

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/epsIntermediates/images/characters/ian_sara_lean_questioning-24f9edc84f6866578dbd17d6d194a844.png";

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/epsPrimaries/images/characters/ian_sara_lean_questioning-24f9edc84f6866578dbd17d6d194a844.png";

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/h2whoaHybrid/images/characters/ian_sara_lean_questioning-24f9edc84f6866578dbd17d6d194a844.png";

/***/ }),
/* 204 */
/***/ (function(module, exports) {

	'use strict';
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function ToObject(val) {
		if (val == null) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function ownEnumerableKeys(obj) {
		var keys = Object.getOwnPropertyNames(obj);
	
		if (Object.getOwnPropertySymbols) {
			keys = keys.concat(Object.getOwnPropertySymbols(obj));
		}
	
		return keys.filter(function (key) {
			return propIsEnumerable.call(obj, key);
		});
	}
	
	module.exports = Object.assign || function (target, source) {
		var from;
		var keys;
		var to = ToObject(target);
	
		for (var s = 1; s < arguments.length; s++) {
			from = arguments[s];
			keys = ownEnumerableKeys(Object(from));
	
			for (var i = 0; i < keys.length; i++) {
				to[keys[i]] = from[keys[i]];
			}
		}
	
		return to;
	};


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = __webpack_require__(7)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	function headingSlide(_ref) {
	  var id = _ref.id;
	  var bgColor = _ref.bgColor;
	  var notes = _ref.notes;
	  var heading = _ref.heading;
	  var subHeading = _ref.subHeading;
	  var beforeImage = _ref.beforeImage;
	  var afterImage = _ref.afterImage;
	  var slideClass = _ref.slideClass;
	
	  var slideContentClass = slideClass ? ' slide-' + slideClass : '';
	  var bgColorOpts = {};
	  if (bgColor) {
	    bgColorOpts.bgColor = bgColor;
	  }
	  return _react2['default'].createElement(
	    _spectaclePpa.Slide,
	    _extends({
	      id: id,
	      key: id
	    }, bgColorOpts, {
	      notes: notes }),
	    _react2['default'].createElement(
	      'div',
	      { className: 'slide-content' + slideContentClass },
	      !!beforeImage && _react2['default'].createElement(
	        'div',
	        { className: 'flex-image' },
	        _react2['default'].createElement('img', {
	          className: 'heading-image heading-image-before',
	          src: beforeImage })
	      ),
	      _react2['default'].createElement(
	        'div',
	        { className: 'text-heading' },
	        _react2['default'].createElement(
	          _spectaclePpa.Heading,
	          { size: 2 },
	          _react2['default'].createElement('div', { dangerouslySetInnerHTML: { __html: heading } })
	        ),
	        !!subHeading && _react2['default'].createElement(
	          _spectaclePpa.Heading,
	          { size: 3 },
	          _react2['default'].createElement('div', { dangerouslySetInnerHTML: { __html: subHeading } })
	        )
	      ),
	      !!afterImage && _react2['default'].createElement('img', {
	        className: 'heading-image heading-image-after',
	        src: afterImage })
	    )
	  );
	}
	
	exports['default'] = headingSlide;
	module.exports = exports['default'];

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

	/* eslint react/no-multi-comp: 0, no-unused-vars: 0 */
	
	'use strict';
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.preloadGameShow = preloadGameShow;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _srcServicesRegionalization = __webpack_require__(38);
	
	var _srcServicesRegionalization2 = _interopRequireDefault(_srcServicesRegionalization);
	
	var _baseSlidesBalloonSlide = __webpack_require__(85);
	
	var _baseSlidesBalloonSlide2 = _interopRequireDefault(_baseSlidesBalloonSlide);
	
	var _baseSlidesHeadingSlide = __webpack_require__(161);
	
	var _baseSlidesHeadingSlide2 = _interopRequireDefault(_baseSlidesHeadingSlide);
	
	var _baseSlidesVideoSlide = __webpack_require__(55);
	
	var _baseSlidesVideoSlide2 = _interopRequireDefault(_baseSlidesVideoSlide);
	
	var _title_gameshowPng = __webpack_require__(2290);
	
	var _title_gameshowPng2 = _interopRequireDefault(_title_gameshowPng);
	
	var _title_gameshow_playersPng = __webpack_require__(2291);
	
	var _title_gameshow_playersPng2 = _interopRequireDefault(_title_gameshow_playersPng);
	
	var _imagesCharactersIan_sara_lean_smilePng = __webpack_require__(405);
	
	var _imagesCharactersIan_sara_lean_smilePng2 = _interopRequireDefault(_imagesCharactersIan_sara_lean_smilePng);
	
	var _imagesCharactersIan_sidePng = __webpack_require__(857);
	
	var _imagesCharactersIan_sidePng2 = _interopRequireDefault(_imagesCharactersIan_sidePng);
	
	var _imagesCharactersSara_smilePng = __webpack_require__(406);
	
	var _imagesCharactersSara_smilePng2 = _interopRequireDefault(_imagesCharactersSara_smilePng);
	
	var _imagesCharactersIan_shrug_laughPng = __webpack_require__(2279);
	
	var _imagesCharactersIan_shrug_laughPng2 = _interopRequireDefault(_imagesCharactersIan_shrug_laughPng);
	
	var _imagesCharactersIan_pointing_upPng = __webpack_require__(404);
	
	var _imagesCharactersIan_pointing_upPng2 = _interopRequireDefault(_imagesCharactersIan_pointing_upPng);
	
	var _imagesCharactersIan_sara_lean_questioningPng = __webpack_require__(199);
	
	var _imagesCharactersIan_sara_lean_questioningPng2 = _interopRequireDefault(_imagesCharactersIan_sara_lean_questioningPng);
	
	var _imagesCharactersSara_surprisedPng = __webpack_require__(859);
	
	var _imagesCharactersSara_surprisedPng2 = _interopRequireDefault(_imagesCharactersSara_surprisedPng);
	
	var _imagesCharactersIan_sara_sidePng = __webpack_require__(152);
	
	var _imagesCharactersIan_sara_sidePng2 = _interopRequireDefault(_imagesCharactersIan_sara_sidePng);
	
	var _helpersMarkdownScript = __webpack_require__(9);
	
	var _helpersMarkdownScript2 = _interopRequireDefault(_helpersMarkdownScript);
	
	var _level1_makeAPlanMd = __webpack_require__(1547);
	
	var _level1_makeAPlanMd2 = _interopRequireDefault(_level1_makeAPlanMd);
	
	var _level2_getAKitMd = __webpack_require__(1548);
	
	var _level2_getAKitMd2 = _interopRequireDefault(_level2_getAKitMd);
	
	var _level3_wereInThisTogetherMd = __webpack_require__(1549);
	
	var _level3_wereInThisTogetherMd2 = _interopRequireDefault(_level3_wereInThisTogetherMd);
	
	var levels = {
	  '1': { md: new _helpersMarkdownScript2['default'](_level1_makeAPlanMd2['default']) },
	  '2': { md: new _helpersMarkdownScript2['default'](_level2_getAKitMd2['default']) },
	  '3': { md: new _helpersMarkdownScript2['default'](_level3_wereInThisTogetherMd2['default']) }
	};
	
	function preloadGameShow() {
	  (0, _spectaclePpa.preloader)([_title_gameshowPng2['default'], _title_gameshow_playersPng2['default'], _imagesCharactersIan_sara_lean_smilePng2['default'], _imagesCharactersIan_sidePng2['default'], _imagesCharactersSara_smilePng2['default'], _imagesCharactersIan_shrug_laughPng2['default'], _imagesCharactersIan_sara_lean_questioningPng2['default'], _imagesCharactersSara_surprisedPng2['default'], _imagesCharactersIan_sara_sidePng2['default']]);
	}
	
	function intro(level, regionData) {
	  var md = levels[level].md;
	  return (0, _baseSlidesVideoSlide2['default'])({
	    id: 'intro',
	    notes: md.getSubSectionAsHtml('Intro Video', 'Notes', false, regionData),
	    youTubeId: md.getSectionMetadata('Intro Video', 'YouTube', regionData)
	  });
	}
	
	function sizzle(level, regionData) {
	  var md = levels[level].md;
	  return (0, _baseSlidesHeadingSlide2['default'])({
	    id: 'sizzle',
	    bgColor: '#742CBF',
	    afterImage: _title_gameshowPng2['default'],
	    notes: md.getSubSectionAsHtml('Sizzle', 'Notes', false, regionData)
	  });
	}
	
	function scoring(level, regionData) {
	  var md = levels[level].md;
	  return (0, _baseSlidesBalloonSlide2['default'])({
	    id: 'scoring',
	    characterSide: 'left',
	    characterImage: _imagesCharactersIan_sara_lean_smilePng2['default'],
	    notes: md.getSubSectionAsHtml('Scoring', 'Notes', false, regionData),
	    html: md.getSubSectionAsHtml('Scoring', 'Content', false, regionData),
	    bgColor: '#742CBF'
	  });
	}
	
	function questionSlide(_ref) {
	  var level = _ref.level;
	  var questionNumber = _ref.questionNumber;
	  var numQuestions = _ref.numQuestions;
	  var md = _ref.md;
	  var questionCharacterImage = _ref.questionCharacterImage;
	  var answerCharacterImage = _ref.answerCharacterImage;
	  var regionData = _ref.regionData;
	
	  var questionSection = 'Question ' + questionNumber;
	  var defaultRegion = md.getSectionMetadata(questionSection, 'Default Region', regionData);
	  var questionCharacter = !questionCharacterImage ? _imagesCharactersIan_sidePng2['default'] : questionCharacterImage;
	  var answerCharacter = !answerCharacterImage ? _imagesCharactersSara_smilePng2['default'] : answerCharacterImage;
	  var answer = undefined;
	  if (defaultRegion) {
	    answer = md.getSubSectionAsHtml(questionSection, 'Answer - ' + defaultRegion, false, regionData);
	  } else {
	    answer = md.getSubSectionAsHtml(questionSection, 'Answer', false, regionData);
	  }
	  var answerNotes = md.getSubSectionAsHtml(questionSection, 'Answer Notes', false, regionData);
	
	  return [
	
	  // four players announcement
	  (0, _baseSlidesHeadingSlide2['default'])({
	    id: questionNumber + '-four-players',
	    afterImage: _title_gameshow_playersPng2['default'],
	    bgColor: 'black',
	    notes: '<h2>Question ' + questionNumber + ' of ' + numQuestions + ': </h2>' + md.getSubSectionAsHtml('Four Players Announcement', 'Notes', false, regionData)
	  }),
	
	  // additional slide for level 3, question 3
	  level === 3 && questionNumber === 3 ? (0, _baseSlidesBalloonSlide2['default'])({
	    balloonType: 'question',
	    characterSide: 'left',
	    characterImage: _imagesCharactersIan_sidePng2['default'],
	    questionNumber: questionNumber,
	    numQuestions: numQuestions,
	    id: questionNumber + '-multiple-choice',
	    html: md.getSubSectionAsHtml(questionSection, 'Question Intro', false, regionData),
	    notes: '<h2>Question ' + questionNumber + ' of ' + numQuestions + ': </h2>' + '<br />' + '<p style="font color: white">Multiple choice, see next slide</h4>',
	    bgColor: '#45B3EC'
	  }) : null,
	
	  // question text
	  (0, _baseSlidesBalloonSlide2['default'])({
	    balloonType: 'question',
	    characterSide: 'left',
	    characterImage: questionCharacter,
	    questionNumber: questionNumber,
	    numQuestions: numQuestions,
	    id: questionNumber + '-question',
	    html: md.getSubSectionAsHtml(questionSection, 'Question', false, regionData),
	    notes: '<h2>Question ' + questionNumber + ' of ' + numQuestions + ': </h2>' + '<br />' + '<p style="font color: white">Preview of next slide/answer</h4>' + answer
	  }),
	
	  // answer slide
	  (0, _baseSlidesBalloonSlide2['default'])({
	    balloonType: 'answer',
	    characterSide: 'right',
	    characterImage: answerCharacter,
	    questionNumber: questionNumber,
	    id: questionNumber + '-answer',
	    html: answer,
	    notes: '<h2>Answer ' + questionNumber + ' of ' + numQuestions + '</h2>' + '<br />' + (!answerNotes.match(/SKIP/) ? md.getSubSectionAsHtml(questionSection, 'Answer Notes', false, regionData) : '')
	  })];
	}
	
	function endOfGameShow(level) {
	  return (0, _baseSlidesBalloonSlide2['default'])({
	    id: 'end',
	    characterSide: 'left',
	    characterImage: _imagesCharactersIan_shrug_laughPng2['default'],
	    bgColor: '#742CBF',
	    html: '<h3>Level ' + level + ' Game Show Completed!</h3>',
	    notes: 'Game show completed.'
	  });
	}
	
	function level1(regionData) {
	  var level = 1;
	  var md = levels[level].md;
	
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'game-show' },
	    intro(level, regionData),
	    sizzle(level, regionData),
	    scoring(level, regionData),
	    questionSlide({ level: level, questionNumber: 1, numQuestions: 3, md: md, regionData: regionData }),
	    (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'scoring-reminder',
	      characterSide: 'left',
	      characterImage: _imagesCharactersIan_pointing_upPng2['default'],
	      notes: md.getSubSectionAsHtml('Scoring Reminder', 'Notes', false, regionData),
	      html: md.getSubSectionAsHtml('Scoring Reminder', 'Content', false, regionData),
	      bgColor: '#742CBF'
	    }),
	    questionSlide({ level: level, questionNumber: 2, numQuestions: 3, md: md, regionData: regionData }),
	    questionSlide({ level: level, questionNumber: 3, numQuestions: 3, md: md, regionData: regionData }),
	    endOfGameShow(level)
	  );
	}
	
	function level2(regionData) {
	  var level = 2;
	  var md = levels[level].md;
	
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'game-show' },
	    intro(level, regionData),
	    sizzle(level, regionData),
	    scoring(level, regionData),
	    questionSlide({ level: level, questionNumber: 1, numQuestions: 3, md: md, regionData: regionData }),
	    questionSlide({ level: level, questionNumber: 2, numQuestions: 3, md: md, regionData: regionData }),
	    questionSlide({ level: level, questionNumber: 3, numQuestions: 3, md: md, regionData: regionData }),
	    endOfGameShow(level)
	  );
	}
	
	function level3(regionData) {
	  var level = 3;
	  var md = levels[level].md;
	
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'game-show' },
	    intro(level, regionData),
	    sizzle(level, regionData),
	    questionSlide({ level: level, questionNumber: 1, numQuestions: 3, md: md, regionData: regionData }),
	    questionSlide({ level: level, questionNumber: 2, numQuestions: 3, md: md, regionData: regionData }),
	    questionSlide({ level: level, questionNumber: 3, numQuestions: 3, md: md, regionData: regionData }),
	    endOfGameShow(level)
	  );
	}
	
	function gameShowSection(_ref2) {
	  var level = _ref2.level;
	  var regionData = _ref2.regionData;
	
	  switch (level) {
	    case 1:
	      return level1(regionData);
	    case 2:
	      return level2(regionData);
	    case 3:
	      return level3(regionData);
	    default:
	      return (0, _baseSlidesHeadingSlide2['default'])({ heading: 'Unknown' });
	  }
	}
	
	exports['default'] = gameShowSection;
	/* Sara and Ian introduce the Game Show */ /* Sizzle */ /* Scoring intro */ /* Game show questions */ /* Scoring reminder */ /* End of Game Show */ /* Sara and Ian introduce the Game Show */ /* Sizzle */ /* Scoring intro */ /* Game show questions */ /* End of Game Show */ /* Sara and Ian introduce the Game Show */ /* Sizzle */ /* Game show questions */ /* End of Game Show */

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

	/* eslint react/no-multi-comp: 0, no-unused-vars: 0 */
	
	'use strict';
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.preloadGameShow = preloadGameShow;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _srcServicesRegionalization = __webpack_require__(38);
	
	var _srcServicesRegionalization2 = _interopRequireDefault(_srcServicesRegionalization);
	
	var _baseSlidesBalloonSlide = __webpack_require__(86);
	
	var _baseSlidesBalloonSlide2 = _interopRequireDefault(_baseSlidesBalloonSlide);
	
	var _baseSlidesHeadingSlide = __webpack_require__(162);
	
	var _baseSlidesHeadingSlide2 = _interopRequireDefault(_baseSlidesHeadingSlide);
	
	var _baseSlidesVideoSlide = __webpack_require__(56);
	
	var _baseSlidesVideoSlide2 = _interopRequireDefault(_baseSlidesVideoSlide);
	
	var _title_gameshowPng = __webpack_require__(2310);
	
	var _title_gameshowPng2 = _interopRequireDefault(_title_gameshowPng);
	
	var _title_gameshow_playersPng = __webpack_require__(2311);
	
	var _title_gameshow_playersPng2 = _interopRequireDefault(_title_gameshow_playersPng);
	
	var _imagesCharactersIan_sara_lean_smilePng = __webpack_require__(411);
	
	var _imagesCharactersIan_sara_lean_smilePng2 = _interopRequireDefault(_imagesCharactersIan_sara_lean_smilePng);
	
	var _imagesCharactersIan_sidePng = __webpack_require__(865);
	
	var _imagesCharactersIan_sidePng2 = _interopRequireDefault(_imagesCharactersIan_sidePng);
	
	var _imagesCharactersSara_smilePng = __webpack_require__(412);
	
	var _imagesCharactersSara_smilePng2 = _interopRequireDefault(_imagesCharactersSara_smilePng);
	
	var _imagesCharactersIan_shrug_laughPng = __webpack_require__(2299);
	
	var _imagesCharactersIan_shrug_laughPng2 = _interopRequireDefault(_imagesCharactersIan_shrug_laughPng);
	
	var _imagesCharactersIan_pointing_upPng = __webpack_require__(410);
	
	var _imagesCharactersIan_pointing_upPng2 = _interopRequireDefault(_imagesCharactersIan_pointing_upPng);
	
	var _imagesCharactersIan_sara_lean_questioningPng = __webpack_require__(200);
	
	var _imagesCharactersIan_sara_lean_questioningPng2 = _interopRequireDefault(_imagesCharactersIan_sara_lean_questioningPng);
	
	var _imagesCharactersSara_surprisedPng = __webpack_require__(867);
	
	var _imagesCharactersSara_surprisedPng2 = _interopRequireDefault(_imagesCharactersSara_surprisedPng);
	
	var _imagesCharactersIan_sara_sidePng = __webpack_require__(153);
	
	var _imagesCharactersIan_sara_sidePng2 = _interopRequireDefault(_imagesCharactersIan_sara_sidePng);
	
	var _helpersMarkdownScript = __webpack_require__(9);
	
	var _helpersMarkdownScript2 = _interopRequireDefault(_helpersMarkdownScript);
	
	var _level1_makeAPlanMd = __webpack_require__(1575);
	
	var _level1_makeAPlanMd2 = _interopRequireDefault(_level1_makeAPlanMd);
	
	var _level2_getAKitMd = __webpack_require__(1576);
	
	var _level2_getAKitMd2 = _interopRequireDefault(_level2_getAKitMd);
	
	var _level3_wereInThisTogetherMd = __webpack_require__(1577);
	
	var _level3_wereInThisTogetherMd2 = _interopRequireDefault(_level3_wereInThisTogetherMd);
	
	var levels = {
	  '1': { md: new _helpersMarkdownScript2['default'](_level1_makeAPlanMd2['default']) },
	  '2': { md: new _helpersMarkdownScript2['default'](_level2_getAKitMd2['default']) },
	  '3': { md: new _helpersMarkdownScript2['default'](_level3_wereInThisTogetherMd2['default']) }
	};
	
	function preloadGameShow() {
	  (0, _spectaclePpa.preloader)([_title_gameshowPng2['default'], _title_gameshow_playersPng2['default'], _imagesCharactersIan_sara_lean_smilePng2['default'], _imagesCharactersIan_sidePng2['default'], _imagesCharactersSara_smilePng2['default'], _imagesCharactersIan_shrug_laughPng2['default'], _imagesCharactersIan_sara_lean_questioningPng2['default'], _imagesCharactersSara_surprisedPng2['default'], _imagesCharactersIan_sara_sidePng2['default']]);
	}
	
	function intro(level, regionData) {
	  var md = levels[level].md;
	  return (0, _baseSlidesVideoSlide2['default'])({
	    id: 'intro',
	    notes: md.getSubSectionAsHtml('Intro Video', 'Notes', false, regionData),
	    youTubeId: md.getSectionMetadata('Intro Video', 'YouTube', regionData)
	  });
	}
	
	function sizzle(level, regionData) {
	  var md = levels[level].md;
	  return (0, _baseSlidesHeadingSlide2['default'])({
	    id: 'sizzle',
	    bgColor: '#742CBF',
	    afterImage: _title_gameshowPng2['default'],
	    notes: md.getSubSectionAsHtml('Sizzle', 'Notes', false, regionData)
	  });
	}
	
	function scoring(level, regionData) {
	  var md = levels[level].md;
	  return (0, _baseSlidesBalloonSlide2['default'])({
	    id: 'scoring',
	    characterSide: 'left',
	    characterImage: _imagesCharactersIan_sara_lean_smilePng2['default'],
	    notes: md.getSubSectionAsHtml('Scoring', 'Notes', false, regionData),
	    html: md.getSubSectionAsHtml('Scoring', 'Content', false, regionData),
	    bgColor: '#742CBF'
	  });
	}
	
	function questionSlide(_ref) {
	  var level = _ref.level;
	  var questionNumber = _ref.questionNumber;
	  var numQuestions = _ref.numQuestions;
	  var md = _ref.md;
	  var questionCharacterImage = _ref.questionCharacterImage;
	  var answerCharacterImage = _ref.answerCharacterImage;
	  var regionData = _ref.regionData;
	
	  var questionSection = 'Question ' + questionNumber;
	  var defaultRegion = md.getSectionMetadata(questionSection, 'Default Region', regionData);
	  var questionCharacter = !questionCharacterImage ? _imagesCharactersIan_sidePng2['default'] : questionCharacterImage;
	  var answerCharacter = !answerCharacterImage ? _imagesCharactersSara_smilePng2['default'] : answerCharacterImage;
	  var answer = undefined;
	  if (defaultRegion) {
	    answer = md.getSubSectionAsHtml(questionSection, 'Answer - ' + defaultRegion, false, regionData);
	  } else {
	    answer = md.getSubSectionAsHtml(questionSection, 'Answer', false, regionData);
	  }
	  var answerNotes = md.getSubSectionAsHtml(questionSection, 'Answer Notes', false, regionData);
	
	  return [
	
	  // four players announcement
	  (0, _baseSlidesHeadingSlide2['default'])({
	    id: questionNumber + '-four-players',
	    afterImage: _title_gameshow_playersPng2['default'],
	    bgColor: 'black',
	    notes: '<h2>Question ' + questionNumber + ' of ' + numQuestions + ': </h2>' + md.getSubSectionAsHtml('Four Players Announcement', 'Notes', false, regionData)
	  }),
	
	  // additional slide for level 3, question 3
	  level === 3 && questionNumber === 3 ? (0, _baseSlidesBalloonSlide2['default'])({
	    balloonType: 'question',
	    characterSide: 'left',
	    characterImage: _imagesCharactersIan_sidePng2['default'],
	    questionNumber: questionNumber,
	    numQuestions: numQuestions,
	    id: questionNumber + '-multiple-choice',
	    html: md.getSubSectionAsHtml(questionSection, 'Question Intro', false, regionData),
	    notes: '<h2>Question ' + questionNumber + ' of ' + numQuestions + ': </h2>' + '<br />' + '<p style="font color: white">Multiple choice, see next slide</h4>',
	    bgColor: '#45B3EC'
	  }) : null,
	
	  // question text
	  (0, _baseSlidesBalloonSlide2['default'])({
	    balloonType: 'question',
	    characterSide: 'left',
	    characterImage: questionCharacter,
	    questionNumber: questionNumber,
	    numQuestions: numQuestions,
	    id: questionNumber + '-question',
	    html: md.getSubSectionAsHtml(questionSection, 'Question', false, regionData),
	    notes: '<h2>Question ' + questionNumber + ' of ' + numQuestions + ': </h2>' + '<br />' + '<p style="font color: white">Preview of next slide/answer</h4>' + answer
	  }),
	
	  // answer slide
	  (0, _baseSlidesBalloonSlide2['default'])({
	    balloonType: 'answer',
	    characterSide: 'right',
	    characterImage: answerCharacter,
	    questionNumber: questionNumber,
	    id: questionNumber + '-answer',
	    html: answer,
	    notes: '<h2>Answer ' + questionNumber + ' of ' + numQuestions + '</h2>' + '<br />' + (!answerNotes.match(/SKIP/) ? md.getSubSectionAsHtml(questionSection, 'Answer Notes', false, regionData) : '')
	  })];
	}
	
	function endOfGameShow(level) {
	  return (0, _baseSlidesBalloonSlide2['default'])({
	    id: 'end',
	    characterSide: 'left',
	    characterImage: _imagesCharactersIan_shrug_laughPng2['default'],
	    bgColor: '#742CBF',
	    html: '<h3>Level ' + level + ' Game Show Completed!</h3>',
	    notes: 'Game show completed.'
	  });
	}
	
	function level1(regionData) {
	  var level = 1;
	  var md = levels[level].md;
	
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'game-show' },
	    intro(level, regionData),
	    sizzle(level, regionData),
	    scoring(level, regionData),
	    questionSlide({ level: level, questionNumber: 1, numQuestions: 3, md: md, regionData: regionData }),
	    (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'scoring-reminder',
	      characterSide: 'left',
	      characterImage: _imagesCharactersIan_pointing_upPng2['default'],
	      notes: md.getSubSectionAsHtml('Scoring Reminder', 'Notes', false, regionData),
	      html: md.getSubSectionAsHtml('Scoring Reminder', 'Content', false, regionData),
	      bgColor: '#742CBF'
	    }),
	    questionSlide({ level: level, questionNumber: 2, numQuestions: 3, md: md, regionData: regionData }),
	    questionSlide({ level: level, questionNumber: 3, numQuestions: 3, md: md, regionData: regionData }),
	    endOfGameShow(level)
	  );
	}
	
	function level2(regionData) {
	  var level = 2;
	  var md = levels[level].md;
	
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'game-show' },
	    intro(level, regionData),
	    sizzle(level, regionData),
	    scoring(level, regionData),
	    questionSlide({ level: level, questionNumber: 1, numQuestions: 3, md: md, regionData: regionData }),
	    questionSlide({ level: level, questionNumber: 2, numQuestions: 3, md: md, regionData: regionData }),
	    questionSlide({ level: level, questionNumber: 3, numQuestions: 3, md: md, regionData: regionData }),
	    endOfGameShow(level)
	  );
	}
	
	function level3(regionData) {
	  var level = 3;
	  var md = levels[level].md;
	
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'game-show' },
	    intro(level, regionData),
	    sizzle(level, regionData),
	    questionSlide({ level: level, questionNumber: 1, numQuestions: 3, md: md, regionData: regionData }),
	    questionSlide({ level: level, questionNumber: 2, numQuestions: 3, md: md, regionData: regionData }),
	    questionSlide({ level: level, questionNumber: 3, numQuestions: 3, md: md, regionData: regionData }),
	    endOfGameShow(level)
	  );
	}
	
	function gameShowSection(_ref2) {
	  var level = _ref2.level;
	  var regionData = _ref2.regionData;
	
	  switch (level) {
	    case 1:
	      return level1(regionData);
	    case 2:
	      return level2(regionData);
	    case 3:
	      return level3(regionData);
	    default:
	      return (0, _baseSlidesHeadingSlide2['default'])({ heading: 'Unknown' });
	  }
	}
	
	exports['default'] = gameShowSection;
	/* Sara and Ian introduce the Game Show */ /* Sizzle */ /* Scoring intro */ /* Game show questions */ /* Scoring reminder */ /* End of Game Show */ /* Sara and Ian introduce the Game Show */ /* Sizzle */ /* Scoring intro */ /* Game show questions */ /* End of Game Show */ /* Sara and Ian introduce the Game Show */ /* Sizzle */ /* Game show questions */ /* End of Game Show */

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.preloadStart = preloadStart;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _baseSlidesVideoSlide = __webpack_require__(57);
	
	var _baseSlidesVideoSlide2 = _interopRequireDefault(_baseSlidesVideoSlide);
	
	var _imagesPpa_presentsSvg = __webpack_require__(2330);
	
	var _imagesPpa_presentsSvg2 = _interopRequireDefault(_imagesPpa_presentsSvg);
	
	var _imagesEmergencyPreparednessSquadGlowPng = __webpack_require__(419);
	
	var _imagesEmergencyPreparednessSquadGlowPng2 = _interopRequireDefault(_imagesEmergencyPreparednessSquadGlowPng);
	
	var _helpersMarkdownScript = __webpack_require__(9);
	
	var _helpersMarkdownScript2 = _interopRequireDefault(_helpersMarkdownScript);
	
	var _startMd = __webpack_require__(1595);
	
	var _startMd2 = _interopRequireDefault(_startMd);
	
	var _imagesLevel1_startPng = __webpack_require__(420);
	
	var _imagesLevel1_startPng2 = _interopRequireDefault(_imagesLevel1_startPng);
	
	var _imagesLevel2_startPng = __webpack_require__(421);
	
	var _imagesLevel2_startPng2 = _interopRequireDefault(_imagesLevel2_startPng);
	
	var _imagesLevel3_startPng = __webpack_require__(422);
	
	var _imagesLevel3_startPng2 = _interopRequireDefault(_imagesLevel3_startPng);
	
	var _imagesLevel4_startPng = __webpack_require__(876);
	
	var _imagesLevel4_startPng2 = _interopRequireDefault(_imagesLevel4_startPng);
	
	var levels = {
	  '1': { img: _imagesLevel1_startPng2['default'] },
	  '2': { img: _imagesLevel2_startPng2['default'] },
	  '3': { img: _imagesLevel3_startPng2['default'] },
	  '4': { img: _imagesLevel4_startPng2['default'] }
	};
	
	var md = new _helpersMarkdownScript2['default'](_startMd2['default']);
	
	function preloadStart() {
	  (0, _spectaclePpa.preloader)([_imagesPpa_presentsSvg2['default'], _imagesLevel1_startPng2['default'], _imagesLevel2_startPng2['default'], _imagesLevel3_startPng2['default'], _imagesLevel4_startPng2['default']]);
	}
	
	function startSection(_ref) {
	  var level = _ref.level;
	  var title = _ref.title;
	  var regionData = _ref.regionData;
	
	  /* Level intro graphic */
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'start' },
	    _react2['default'].createElement(
	      _spectaclePpa.Slide,
	      {
	        id: 'ppa-presents',
	        key: 'ppa-presents',
	        bgColor: 'black',
	        notes: md.getSubSectionAsHtml('Level ' + level + ' Start', 'Notes', false, regionData) },
	      _react2['default'].createElement(
	        'div',
	        {
	          className: 'ui-slide' },
	        _react2['default'].createElement(
	          'div',
	          { className: 'flex-image' },
	          _react2['default'].createElement('img', {
	            className: 'heading-image heading-image-before',
	            src: _imagesPpa_presentsSvg2['default'] })
	        )
	      )
	    ),
	    _react2['default'].createElement(
	      _spectaclePpa.Slide,
	      {
	        id: 'ppa-eps',
	        key: 'ppa-eps',
	        bgColor: 'black',
	        notes: md.getSubSectionAsHtml('Level ' + level + ' Start', 'Notes', false, regionData) },
	      _react2['default'].createElement(
	        'div',
	        {
	          className: 'ui-slide' },
	        _react2['default'].createElement(
	          'div',
	          { className: 'flex-image' },
	          _react2['default'].createElement('img', { className: 'eps-logo heading-image',
	            src: _imagesEmergencyPreparednessSquadGlowPng2['default'] })
	        )
	      )
	    ),
	    _react2['default'].createElement(
	      _spectaclePpa.Slide,
	      {
	        id: 'level',
	        key: 'level',
	        bgColor: 'black',
	        notes: md.getSubSectionAsHtml('Level ' + level + ' Icon', 'Notes', false, regionData) },
	      _react2['default'].createElement(
	        'div',
	        {
	          className: 'ui-slide' },
	        _react2['default'].createElement(
	          'div',
	          { className: 'title-image' },
	          _react2['default'].createElement('img', {
	            className: 'heading-image heading-image-before',
	            src: levels[level].img }),
	          _react2['default'].createElement(
	            _spectaclePpa.Heading,
	            { size: 1 },
	            _react2['default'].createElement(
	              'strong',
	              null,
	              title
	            )
	          ),
	          _react2['default'].createElement(
	            _spectaclePpa.Heading,
	            { size: 2 },
	            _react2['default'].createElement(
	              'strong',
	              null,
	              'Level ',
	              level
	            )
	          )
	        )
	      )
	    ),
	    (level === 1 || level === 2 || level === 3) && (0, _baseSlidesVideoSlide2['default'])({
	      id: 'level-intro',
	      notes: md.getSubSectionAsHtml('Level ' + level + ' Intro', 'Notes', false, regionData),
	      youTubeId: md.getSectionMetadata('Level ' + level + ' Intro', 'YouTube', regionData)
	    })
	  );
	}
	
	exports['default'] = startSection;
	/* Sanksrit for Vanessa */ /* lokah samastah sukhino bhavantu */ /* may all beings everywhere be at peace */ /* Sara and Ian Level Intro */

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.preloadSong = preloadSong;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _baseSlidesVideoSlide = __webpack_require__(57);
	
	var _baseSlidesVideoSlide2 = _interopRequireDefault(_baseSlidesVideoSlide);
	
	var _imagesCharactersIan_sara_sillyPng = __webpack_require__(2318);
	
	var _imagesCharactersIan_sara_sillyPng2 = _interopRequireDefault(_imagesCharactersIan_sara_sillyPng);
	
	var _imagesCharactersIan_sara_two_fingersPng = __webpack_require__(2319);
	
	var _imagesCharactersIan_sara_two_fingersPng2 = _interopRequireDefault(_imagesCharactersIan_sara_two_fingersPng);
	
	var _helpersMarkdownScript = __webpack_require__(9);
	
	var _helpersMarkdownScript2 = _interopRequireDefault(_helpersMarkdownScript);
	
	var _songMd = __webpack_require__(1596);
	
	var _songMd2 = _interopRequireDefault(_songMd);
	
	var md = new _helpersMarkdownScript2['default'](_songMd2['default']);
	
	function preloadSong() {
	  (0, _spectaclePpa.preloader)([_imagesCharactersIan_sara_sillyPng2['default'], _imagesCharactersIan_sara_two_fingersPng2['default']]);
	}
	
	function songSection(_ref) {
	  var regionData = _ref.regionData;
	
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'song' },
	    (0, _baseSlidesVideoSlide2['default'])({
	      id: 'video',
	      notes: md.getSubSectionAsHtml('Song', 'Notes', false, regionData),
	      youTubeId: md.getSectionMetadata('Song', 'YouTube', regionData)
	    })
	  );
	}
	
	exports['default'] = songSection;
	/* Song */

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

	/* eslint react/no-multi-comp: 0 */
	
	'use strict';
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _baseSlidesVideoSlide = __webpack_require__(57);
	
	var _baseSlidesVideoSlide2 = _interopRequireDefault(_baseSlidesVideoSlide);
	
	var _helpersMarkdownScript = __webpack_require__(9);
	
	var _helpersMarkdownScript2 = _interopRequireDefault(_helpersMarkdownScript);
	
	var _level1_egstoryMd = __webpack_require__(1598);
	
	var _level1_egstoryMd2 = _interopRequireDefault(_level1_egstoryMd);
	
	var _level2_egstoryMd = __webpack_require__(1599);
	
	var _level2_egstoryMd2 = _interopRequireDefault(_level2_egstoryMd);
	
	var _level3_egstoryMd = __webpack_require__(1600);
	
	var _level3_egstoryMd2 = _interopRequireDefault(_level3_egstoryMd);
	
	var _level4_egstoryMd = __webpack_require__(1601);
	
	var _level4_egstoryMd2 = _interopRequireDefault(_level4_egstoryMd);
	
	var levels = {
	  '1': { md: new _helpersMarkdownScript2['default'](_level1_egstoryMd2['default']) },
	  '2': { md: new _helpersMarkdownScript2['default'](_level2_egstoryMd2['default']) },
	  '3': { md: new _helpersMarkdownScript2['default'](_level3_egstoryMd2['default']) },
	  '4': { md: new _helpersMarkdownScript2['default'](_level4_egstoryMd2['default']) }
	};
	
	function esOpeningStory(_ref) {
	  var level = _ref.level;
	  var regionData = _ref.regionData;
	
	  var md = levels[level].md;
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: "esGooberStory" },
	    level === 1 && (0, _baseSlidesVideoSlide2['default'])({
	      id: 'es-goober-intro',
	      notes: md.getSubSectionAsHtml('Esmeralda and Goober Intro', 'Notes', false, regionData),
	      youTubeId: md.getSectionMetadata('Esmeralda and Goober Intro', 'YouTube', regionData)
	    }),
	    level === 3 && (0, _baseSlidesVideoSlide2['default'])({
	      id: 'sharknado',
	      notes: md.getSubSectionAsHtml('Sharknado', 'Notes', false, regionData),
	      youTubeId: md.getSectionMetadata('Sharknado', 'YouTube', regionData)
	    }),
	    level === 3 && (0, _baseSlidesVideoSlide2['default'])({
	      id: 'calming-breath-recap',
	      notes: md.getSubSectionAsHtml('Calming Breath Recap', 'Notes', false, regionData),
	      youTubeId: md.getSectionMetadata('Calming Breath Recap', 'YouTube', regionData)
	    }),
	    (0, _baseSlidesVideoSlide2['default'])({
	      id: 'story',
	      notes: md.getSubSectionAsHtml('Esmeralda and Goober Story', 'Notes', false, regionData),
	      youTubeId: md.getSectionMetadata('Esmeralda and Goober Story', 'YouTube', regionData)
	    }),
	    level === 2 && (0, _baseSlidesVideoSlide2['default'])({
	      id: 'calming-breath',
	      notes: md.getSubSectionAsHtml('Calming Breath Intro', 'Notes', false, regionData),
	      youTubeId: md.getSectionMetadata('Calming Breath Intro', 'YouTube', regionData)
	    })
	  );
	}
	
	exports['default'] = esOpeningStory;
	module.exports = exports['default'];
	/* Esmerelada and Goober Story Intro */ /* Sharknado in Level 3 */ /* Calming breath recap in Level 3 */ /* Esmerelda and Goober Story  */ /* Calming breath intro in Level 2 */

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

	/* eslint react/no-multi-comp: 0 */
	
	'use strict';
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.preloadClassActivity = preloadClassActivity;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _baseSlidesHeadingSlide = __webpack_require__(163);
	
	var _baseSlidesHeadingSlide2 = _interopRequireDefault(_baseSlidesHeadingSlide);
	
	var _baseSlidesVideoSlide = __webpack_require__(57);
	
	var _baseSlidesVideoSlide2 = _interopRequireDefault(_baseSlidesVideoSlide);
	
	var _baseSlidesBalloonSlide = __webpack_require__(87);
	
	var _baseSlidesBalloonSlide2 = _interopRequireDefault(_baseSlidesBalloonSlide);
	
	var _imagesCharactersIan_headshot_smilePng = __webpack_require__(871);
	
	var _imagesCharactersIan_headshot_smilePng2 = _interopRequireDefault(_imagesCharactersIan_headshot_smilePng);
	
	var _imagesCharactersIan_sara_sidePng = __webpack_require__(154);
	
	var _imagesCharactersIan_sara_sidePng2 = _interopRequireDefault(_imagesCharactersIan_sara_sidePng);
	
	var _imagesCharactersIan_sara_lean_smilePng = __webpack_require__(417);
	
	var _imagesCharactersIan_sara_lean_smilePng2 = _interopRequireDefault(_imagesCharactersIan_sara_lean_smilePng);
	
	var _imagesCharactersIan_sidePng = __webpack_require__(872);
	
	var _imagesCharactersIan_sidePng2 = _interopRequireDefault(_imagesCharactersIan_sidePng);
	
	var _imagesCharactersSara_surprisedPng = __webpack_require__(874);
	
	var _imagesCharactersSara_surprisedPng2 = _interopRequireDefault(_imagesCharactersSara_surprisedPng);
	
	var _imagesCharactersSara_twist_hands_out_heyheyPng = __webpack_require__(875);
	
	var _imagesCharactersSara_twist_hands_out_heyheyPng2 = _interopRequireDefault(_imagesCharactersSara_twist_hands_out_heyheyPng);
	
	var _imagesCharactersIan_pointing_upPng = __webpack_require__(416);
	
	var _imagesCharactersIan_pointing_upPng2 = _interopRequireDefault(_imagesCharactersIan_pointing_upPng);
	
	var _imagesCharactersIan_pointing_leftPng = __webpack_require__(2317);
	
	var _imagesCharactersIan_pointing_leftPng2 = _interopRequireDefault(_imagesCharactersIan_pointing_leftPng);
	
	var _imagesCharactersIan_pointing_downPng = __webpack_require__(2316);
	
	var _imagesCharactersIan_pointing_downPng2 = _interopRequireDefault(_imagesCharactersIan_pointing_downPng);
	
	var _imagesCharactersSara_smilePng = __webpack_require__(418);
	
	var _imagesCharactersSara_smilePng2 = _interopRequireDefault(_imagesCharactersSara_smilePng);
	
	var _imagesCharactersSara_humphPng = __webpack_require__(2321);
	
	var _imagesCharactersSara_humphPng2 = _interopRequireDefault(_imagesCharactersSara_humphPng);
	
	var _imagesCharactersIan_sara_lean_questioningPng = __webpack_require__(201);
	
	var _imagesCharactersIan_sara_lean_questioningPng2 = _interopRequireDefault(_imagesCharactersIan_sara_lean_questioningPng);
	
	var _helpersMarkdownScript = __webpack_require__(9);
	
	var _helpersMarkdownScript2 = _interopRequireDefault(_helpersMarkdownScript);
	
	var _level1_listEmergenciesMd = __webpack_require__(1609);
	
	var _level1_listEmergenciesMd2 = _interopRequireDefault(_level1_listEmergenciesMd);
	
	var _level2_floorplanMd = __webpack_require__(1610);
	
	var _level2_floorplanMd2 = _interopRequireDefault(_level2_floorplanMd);
	
	var _level3_kitRapMd = __webpack_require__(1611);
	
	var _level3_kitRapMd2 = _interopRequireDefault(_level3_kitRapMd);
	
	var _level4_drawingMd = __webpack_require__(1612);
	
	var _level4_drawingMd2 = _interopRequireDefault(_level4_drawingMd);
	
	var levels = {
	  '1': { md: new _helpersMarkdownScript2['default'](_level1_listEmergenciesMd2['default']) },
	  '2': { md: new _helpersMarkdownScript2['default'](_level2_floorplanMd2['default']) },
	  '3': { md: new _helpersMarkdownScript2['default'](_level3_kitRapMd2['default']) },
	  '4': { md: new _helpersMarkdownScript2['default'](_level4_drawingMd2['default']) }
	};
	
	function preloadClassActivity() {
	  (0, _spectaclePpa.preloader)([_imagesCharactersIan_headshot_smilePng2['default'], _imagesCharactersIan_sara_sidePng2['default'], _imagesCharactersIan_sara_lean_smilePng2['default'], _imagesCharactersIan_sidePng2['default'], _imagesCharactersSara_surprisedPng2['default'], _imagesCharactersSara_twist_hands_out_heyheyPng2['default'], _imagesCharactersIan_pointing_upPng2['default'], _imagesCharactersIan_pointing_leftPng2['default'], _imagesCharactersIan_pointing_downPng2['default'], _imagesCharactersSara_smilePng2['default'], _imagesCharactersSara_humphPng2['default'], _imagesCharactersIan_sara_lean_questioningPng2['default']]);
	}
	
	function introVideo(level, regionData) {
	  var md = levels[level].md;
	  return (0, _baseSlidesVideoSlide2['default'])({
	    id: 'intro-video',
	    notes: md.getSubSectionAsHtml('Intro Video', 'Notes', false, regionData),
	    youTubeId: md.getSectionMetadata('Intro Video', 'YouTube', regionData)
	  });
	}
	
	function sizzle(level, regionData) {
	  var md = levels[level].md;
	  return (0, _baseSlidesBalloonSlide2['default'])({
	    id: 'sizzle',
	    characterSide: 'right',
	    characterImage: _imagesCharactersIan_sara_sidePng2['default'],
	    notes: md.getSubSectionAsHtml('Sizzle', 'Notes', false, regionData),
	    html: md.getSubSectionAsHtml('Sizzle', 'Content', false, regionData)
	  });
	}
	
	function instructions(level, regionData) {
	  var md = levels[level].md;
	  return (0, _baseSlidesBalloonSlide2['default'])({
	    id: 'instructions',
	    characterSide: 'right',
	    characterImage: _imagesCharactersIan_sara_lean_smilePng2['default'],
	    notes: md.getSubSectionAsHtml('Instructions', 'Notes', false, regionData),
	    html: md.getSubSectionAsHtml('Instructions', 'Content', false, regionData)
	  });
	}
	
	function scoring(level, regionData) {
	  var md = levels[level].md;
	  return (0, _baseSlidesBalloonSlide2['default'])({
	    id: 'scoring',
	    characterSide: 'left',
	    characterImage: _imagesCharactersIan_sidePng2['default'],
	    notes: md.getSubSectionAsHtml('Scoring', 'Notes', false, regionData),
	    html: md.getSubSectionAsHtml('Scoring', 'Content', false, regionData)
	  });
	}
	
	function level1(regionData) {
	  // Top Ten Emergencies
	  var level = '1';
	  var md = levels[level].md;
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'class-activity-' + level },
	    introVideo(level, regionData),
	    sizzle(level, regionData),
	    instructions(level, regionData),
	    (0, _baseSlidesVideoSlide2['default'])({
	      id: 'time-up',
	      notes: md.getSubSectionAsHtml('Time Up', 'Notes', false, regionData),
	      youTubeId: md.getSectionMetadata('Time Up', 'YouTube', regionData)
	    }),
	    (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'how-to-get-points',
	      characterSide: 'left',
	      characterImage: _imagesCharactersSara_smilePng2['default'],
	      notes: md.getSubSectionAsHtml('How To Get Points', 'Notes', false, regionData),
	      html: md.getSubSectionAsHtml('How To Get Points', 'Content', false, regionData)
	    }),
	    (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'share-answers',
	      characterSide: 'right',
	      characterImage: _imagesCharactersIan_sidePng2['default'],
	      notes: md.getSubSectionAsHtml('Share Answers', 'Notes', false, regionData),
	      html: md.getSubSectionAsHtml('Share Answers', 'Content', false, regionData)
	    }),
	    (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'top-ten-emergencies',
	      characterSide: 'right',
	      characterImage: _imagesCharactersSara_twist_hands_out_heyheyPng2['default'],
	      notes: md.getSubSectionAsHtml('Top Ten Emergencies', 'Notes', false, regionData),
	      html: md.getSubSectionAsHtml('Top Ten Emergencies', 'Content', false, regionData)
	    }),
	    (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'points-reminder',
	      characterSide: 'right',
	      characterImage: _imagesCharactersIan_pointing_upPng2['default'],
	      notes: md.getSubSectionAsHtml('Points Reminder', 'Notes', false, regionData),
	      html: md.getSubSectionAsHtml('Points Reminder', 'Content', false, regionData)
	    }),
	    (0, _baseSlidesVideoSlide2['default'])({
	      id: 'act-out-emergencies',
	      notes: md.getSubSectionAsHtml('Act Out Emergencies', 'Notes', false, regionData),
	      youTubeId: md.getSectionMetadata('Act Out Emergencies', 'YouTube', regionData)
	    })
	  );
	}
	
	function level2(regionData) {
	  // floorplan
	  var level = '2';
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'class-activity-' + level },
	    introVideo(level, regionData),
	    sizzle(level, regionData),
	    instructions(level, regionData)
	  );
	}
	
	function level3(regionData) {
	  // Draw Energy
	  var level = '3';
	  var md = levels[level].md;
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'class-activity-' + level },
	    introVideo(level, regionData),
	    sizzle(level, regionData),
	    instructions(level, regionData),
	    (0, _baseSlidesVideoSlide2['default'])({
	      id: 'rap-backtrack-practice',
	      notes: md.getSubSectionAsHtml('Rap Backtrack Practice', 'Notes', false, regionData),
	      youTubeId: md.getSectionMetadata('Rap Backtrack Practice', 'YouTube', regionData)
	    }),
	    scoring(level, regionData),
	    (0, _baseSlidesVideoSlide2['default'])({
	      id: 'rap-backtrack-perform',
	      notes: md.getSubSectionAsHtml('Rap Backtrack Perform', 'Notes', false, regionData),
	      youTubeId: md.getSectionMetadata('Rap Backtrack Perform', 'YouTube', regionData)
	    })
	  );
	}
	
	function level4(regionData) {
	  // Energy saving rap
	  var level = '4';
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'class-activity-' + level },
	    introVideo(level, regionData),
	    sizzle(level, regionData),
	    instructions(level, regionData)
	  );
	}
	
	function classActivitySection(_ref) {
	  var level = _ref.level;
	  var subActivity = _ref.subActivity;
	  var regionData = _ref.regionData;
	
	  switch ('' + level + (subActivity ? subActivity : '')) {
	    case '1':
	      return level1(regionData);
	    case '2':
	      return level2(regionData);
	    case '3':
	      return level3(regionData);
	    case '4':
	      return level4(regionData);
	    default:
	      return (0, _baseSlidesHeadingSlide2['default'])({ heading: 'Unknown' });
	  }
	}
	
	exports['default'] = classActivitySection;
	/* Intro Video */ /* Sizzle */ /* Instructions */ /* Time's up */ /* How to get points */ /* Share answers */ /* Top ten emergencies */ /* Don't forget to add points */ /* Act out emergencies */ /* Intro Video */ /* Sizzle */ /* Instructions */ /* Intro Video */ /* Sizzle */ /* Instructions */ /* Rap Backtrack Practice */ /* Scoring */ /* Rap Backtrack Perform */ /* Intro Video */ /* Sizzle */ /* Instructions */

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.preloadMissionAssignment = preloadMissionAssignment;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _baseSlidesHeadingSlide = __webpack_require__(163);
	
	var _baseSlidesHeadingSlide2 = _interopRequireDefault(_baseSlidesHeadingSlide);
	
	var _baseSlidesBalloonSlide = __webpack_require__(87);
	
	var _baseSlidesBalloonSlide2 = _interopRequireDefault(_baseSlidesBalloonSlide);
	
	var _baseSlidesVideoSlide = __webpack_require__(57);
	
	var _baseSlidesVideoSlide2 = _interopRequireDefault(_baseSlidesVideoSlide);
	
	var _imagesEmergencyPreparednessSquadGlowPng = __webpack_require__(419);
	
	var _imagesEmergencyPreparednessSquadGlowPng2 = _interopRequireDefault(_imagesEmergencyPreparednessSquadGlowPng);
	
	var _imagesCharactersIan_sara_sidePng = __webpack_require__(154);
	
	var _imagesCharactersIan_sara_sidePng2 = _interopRequireDefault(_imagesCharactersIan_sara_sidePng);
	
	var _imagesCharactersIan_sara_lean_questioningPng = __webpack_require__(201);
	
	var _imagesCharactersIan_sara_lean_questioningPng2 = _interopRequireDefault(_imagesCharactersIan_sara_lean_questioningPng);
	
	var _helpersMarkdownScript = __webpack_require__(9);
	
	var _helpersMarkdownScript2 = _interopRequireDefault(_helpersMarkdownScript);
	
	var _level1_knowTheRisksMd = __webpack_require__(1613);
	
	var _level1_knowTheRisksMd2 = _interopRequireDefault(_level1_knowTheRisksMd);
	
	var _level2_makeAPlanMd = __webpack_require__(1614);
	
	var _level2_makeAPlanMd2 = _interopRequireDefault(_level2_makeAPlanMd);
	
	var _level3_getAKitMd = __webpack_require__(1615);
	
	var _level3_getAKitMd2 = _interopRequireDefault(_level3_getAKitMd);
	
	var _level4_keepBuildingKitMd = __webpack_require__(1616);
	
	var _level4_keepBuildingKitMd2 = _interopRequireDefault(_level4_keepBuildingKitMd);
	
	var levels = {
	  '1': { md: new _helpersMarkdownScript2['default'](_level1_knowTheRisksMd2['default']) },
	  '2': { md: new _helpersMarkdownScript2['default'](_level2_makeAPlanMd2['default']) },
	  '3': { md: new _helpersMarkdownScript2['default'](_level3_getAKitMd2['default']) },
	  '4': { md: new _helpersMarkdownScript2['default'](_level4_keepBuildingKitMd2['default']) }
	};
	
	function preloadMissionAssignment() {
	  (0, _spectaclePpa.preloader)([_imagesEmergencyPreparednessSquadGlowPng2['default'], _imagesCharactersIan_sara_sidePng2['default'], _imagesCharactersIan_sara_lean_questioningPng2['default']]);
	}
	
	function missionAssignmentSection(_ref) {
	  var level = _ref.level;
	  var title = _ref.title;
	  var regionData = _ref.regionData;
	
	  var md = levels[level].md;
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'mission-assignment' },
	    (0, _baseSlidesVideoSlide2['default'])({
	      id: 'mission-intro-video',
	      notes: md.getSubSectionAsHtml('Mission Intro Video', 'Notes', false, regionData),
	      youTubeId: md.getSectionMetadata('Mission Intro Video', 'YouTube', regionData)
	    }),
	    (0, _baseSlidesHeadingSlide2['default'])({
	      id: 'sizzle',
	      beforeImage: _imagesEmergencyPreparednessSquadGlowPng2['default'],
	      subHeading: 'Mission ' + level + ':<br/> ' + title,
	      notes: md.getSubSectionAsHtml('Mission Assignment', 'Notes', false, regionData),
	      bgColor: 'black'
	    }),
	    (level === 1 || level === 3) && (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'instructions',
	      characterSide: 'right',
	      characterImage: _imagesCharactersIan_sara_sidePng2['default'],
	      notes: md.getSubSectionAsHtml('Instructions', 'Notes', false, regionData),
	      html: md.getSubSectionAsHtml('Instructions', 'Content', false, regionData)
	    }),
	    (level === 2 || level === 4) && (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'instructions',
	      characterSide: 'right',
	      characterImage: _imagesCharactersIan_sara_lean_questioningPng2['default'],
	      notes: md.getSubSectionAsHtml('Instructions', 'Notes', false, regionData),
	      html: md.getSubSectionAsHtml('Instructions', 'Content', false, regionData)
	    })
	  );
	}
	
	exports['default'] = missionAssignmentSection;
	/* Mission Intro Video*/ /* Sizzle */ /* Mission Instructions levels 1 & 3 */ /* Mission Instructions levels 2 & 4 */

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.preloadFinish = preloadFinish;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _componentsCompleteLevelButton = __webpack_require__(44);
	
	var _componentsCompleteLevelButton2 = _interopRequireDefault(_componentsCompleteLevelButton);
	
	var _baseSlidesBalloonSlide = __webpack_require__(87);
	
	var _baseSlidesBalloonSlide2 = _interopRequireDefault(_baseSlidesBalloonSlide);
	
	var _baseSlidesVideoSlide = __webpack_require__(57);
	
	var _baseSlidesVideoSlide2 = _interopRequireDefault(_baseSlidesVideoSlide);
	
	var _imagesCharactersIan_sara_lean_smilePng = __webpack_require__(417);
	
	var _imagesCharactersIan_sara_lean_smilePng2 = _interopRequireDefault(_imagesCharactersIan_sara_lean_smilePng);
	
	var _imagesCharactersIan_sara_sidePng = __webpack_require__(154);
	
	var _imagesCharactersIan_sara_sidePng2 = _interopRequireDefault(_imagesCharactersIan_sara_sidePng);
	
	var _imagesCharactersIan_sara_lean_questioningPng = __webpack_require__(201);
	
	var _imagesCharactersIan_sara_lean_questioningPng2 = _interopRequireDefault(_imagesCharactersIan_sara_lean_questioningPng);
	
	var _helpersMarkdownScript = __webpack_require__(9);
	
	var _helpersMarkdownScript2 = _interopRequireDefault(_helpersMarkdownScript);
	
	var _finishMd = __webpack_require__(1617);
	
	var _finishMd2 = _interopRequireDefault(_finishMd);
	
	var _level1_completeSvg = __webpack_require__(2333);
	
	var _level1_completeSvg2 = _interopRequireDefault(_level1_completeSvg);
	
	var _level2_completeSvg = __webpack_require__(2334);
	
	var _level2_completeSvg2 = _interopRequireDefault(_level2_completeSvg);
	
	var _level3_completeSvg = __webpack_require__(2335);
	
	var _level3_completeSvg2 = _interopRequireDefault(_level3_completeSvg);
	
	var _level4_completeSvg = __webpack_require__(2336);
	
	var _level4_completeSvg2 = _interopRequireDefault(_level4_completeSvg);
	
	var md = new _helpersMarkdownScript2['default'](_finishMd2['default']);
	
	var levels = {
	  '1': { img: _level1_completeSvg2['default'] },
	  '2': { img: _level2_completeSvg2['default'] },
	  '3': { img: _level3_completeSvg2['default'] },
	  '4': { img: _level4_completeSvg2['default'] }
	};
	
	function preloadFinish() {
	  (0, _spectaclePpa.preloader)([_imagesCharactersIan_sara_lean_smilePng2['default'], _imagesCharactersIan_sara_sidePng2['default'], _imagesCharactersIan_sara_lean_questioningPng2['default'], _level1_completeSvg2['default'], _level2_completeSvg2['default'], _level3_completeSvg2['default'], _level4_completeSvg2['default']]);
	}
	
	function finishSection(_ref) {
	  var level = _ref.level;
	  var regionData = _ref.regionData;
	
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'finish' },
	    level === 1 && (0, _baseSlidesVideoSlide2['default'])({
	      id: 'outtakes',
	      notes: md.getSubSectionAsHtml('Outtakes 1', 'Notes', false, regionData),
	      youTubeId: md.getSectionMetadata('Outtakes 1', 'YouTube', regionData)
	    }),
	    level === 3 && (0, _baseSlidesVideoSlide2['default'])({
	      id: 'outtakes',
	      notes: md.getSubSectionAsHtml('Outtakes 2', 'Notes', false, regionData),
	      youTubeId: md.getSectionMetadata('Outtakes 2', 'YouTube', regionData)
	    }),
	    level !== 4 && (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'scoreboard-recap',
	      characterSide: 'left',
	      characterImage: _imagesCharactersIan_sara_sidePng2['default'],
	      html: md.getSubSectionAsHtml('Scoreboard Recap', 'Content', false, regionData),
	      notes: md.getSubSectionAsHtml('Scoreboard Recap', 'Notes', false, regionData)
	    }),
	    level !== 4 && (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'earn-more-points',
	      characterSide: 'right',
	      characterImage: _imagesCharactersIan_sara_lean_questioningPng2['default'],
	      html: md.getSubSectionAsHtml('Earn More Points', 'Content', false, regionData),
	      notes: md.getSubSectionAsHtml('Earn More Points', 'Notes', false, regionData)
	    }),
	    (level === 1 || level === 3) && (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'farewell',
	      characterSide: 'left',
	      characterImage: _imagesCharactersIan_sara_lean_smilePng2['default'],
	      html: md.getSubSectionAsHtml('Farewell', 'Content', false, regionData),
	      notes: md.getSubSectionAsHtml('Farewell', 'Notes', false, regionData)
	    }),
	    (level === 2 || level === 4) && (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'farewell',
	      characterSide: 'left',
	      characterImage: _imagesCharactersIan_sara_sidePng2['default'],
	      html: md.getSubSectionAsHtml('Farewell', 'Content', false, regionData),
	      notes: md.getSubSectionAsHtml('Farewell', 'Notes', false, regionData)
	    }),
	    _react2['default'].createElement(
	      _spectaclePpa.Slide,
	      {
	        id: 'level-completed',
	        notes: '<h2>Level ' + level + ' Finished</h2>',
	        bgColor: 'transparent',
	        finish: true },
	      _react2['default'].createElement(
	        'div',
	        { className: 'level-complete' },
	        _react2['default'].createElement(
	          'div',
	          { className: 'level-complete-content' },
	          _react2['default'].createElement(
	            'figure',
	            { className: 'level-complete-graphic' },
	            _react2['default'].createElement('img', { src: levels[level].img })
	          ),
	          _react2['default'].createElement(
	            _spectaclePpa.Heading,
	            { size: 2 },
	            'You\'ve finished'
	          ),
	          _react2['default'].createElement(
	            _spectaclePpa.Heading,
	            { size: 2 },
	            'level ',
	            level,
	            ' of 4'
	          ),
	          _react2['default'].createElement(_componentsCompleteLevelButton2['default'], null)
	        )
	      )
	    )
	  );
	}
	
	exports['default'] = finishSection;
	/* Outtakes 1 */ /* Outtakes 2 */ /* Scoreboard Recap */ /* Earn More Points */ /* Farewell level 1 & 3 */ /* Farewell level 2 & 4 */ /* Level complete */

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.preloadStart = preloadStart;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _baseSlidesVideoSlide = __webpack_require__(58);
	
	var _baseSlidesVideoSlide2 = _interopRequireDefault(_baseSlidesVideoSlide);
	
	var _imagesPpa_presentsSvg = __webpack_require__(2352);
	
	var _imagesPpa_presentsSvg2 = _interopRequireDefault(_imagesPpa_presentsSvg);
	
	var _imagesEmergencyPreparednessSquadGlowPng = __webpack_require__(426);
	
	var _imagesEmergencyPreparednessSquadGlowPng2 = _interopRequireDefault(_imagesEmergencyPreparednessSquadGlowPng);
	
	var _helpersMarkdownScript = __webpack_require__(9);
	
	var _helpersMarkdownScript2 = _interopRequireDefault(_helpersMarkdownScript);
	
	var _startMd = __webpack_require__(1628);
	
	var _startMd2 = _interopRequireDefault(_startMd);
	
	var _imagesLevel1_startPng = __webpack_require__(427);
	
	var _imagesLevel1_startPng2 = _interopRequireDefault(_imagesLevel1_startPng);
	
	var _imagesLevel2_startPng = __webpack_require__(428);
	
	var _imagesLevel2_startPng2 = _interopRequireDefault(_imagesLevel2_startPng);
	
	var _imagesLevel3_startPng = __webpack_require__(429);
	
	var _imagesLevel3_startPng2 = _interopRequireDefault(_imagesLevel3_startPng);
	
	var _imagesLevel4_startPng = __webpack_require__(883);
	
	var _imagesLevel4_startPng2 = _interopRequireDefault(_imagesLevel4_startPng);
	
	var levels = {
	  '1': { img: _imagesLevel1_startPng2['default'] },
	  '2': { img: _imagesLevel2_startPng2['default'] },
	  '3': { img: _imagesLevel3_startPng2['default'] },
	  '4': { img: _imagesLevel4_startPng2['default'] }
	};
	
	var md = new _helpersMarkdownScript2['default'](_startMd2['default']);
	
	function preloadStart() {
	  (0, _spectaclePpa.preloader)([_imagesPpa_presentsSvg2['default'], _imagesLevel1_startPng2['default'], _imagesLevel2_startPng2['default'], _imagesLevel3_startPng2['default'], _imagesLevel4_startPng2['default']]);
	}
	
	function startSection(_ref) {
	  var level = _ref.level;
	  var title = _ref.title;
	  var regionData = _ref.regionData;
	
	  /* Level intro graphic */
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'start' },
	    _react2['default'].createElement(
	      _spectaclePpa.Slide,
	      {
	        id: 'ppa-presents',
	        key: 'ppa-presents',
	        bgColor: 'black',
	        notes: md.getSubSectionAsHtml('Level ' + level + ' Start', 'Notes', false, regionData) },
	      _react2['default'].createElement(
	        'div',
	        {
	          className: 'ui-slide' },
	        _react2['default'].createElement(
	          'div',
	          { className: 'flex-image' },
	          _react2['default'].createElement('img', {
	            className: 'heading-image heading-image-before',
	            src: _imagesPpa_presentsSvg2['default'] })
	        )
	      )
	    ),
	    _react2['default'].createElement(
	      _spectaclePpa.Slide,
	      {
	        id: 'ppa-eps',
	        key: 'ppa-eps',
	        bgColor: 'black',
	        notes: md.getSubSectionAsHtml('Level ' + level + ' Start', 'Notes', false, regionData) },
	      _react2['default'].createElement(
	        'div',
	        {
	          className: 'ui-slide' },
	        _react2['default'].createElement(
	          'div',
	          { className: 'flex-image' },
	          _react2['default'].createElement('img', { className: 'eps-logo heading-image',
	            src: _imagesEmergencyPreparednessSquadGlowPng2['default'] })
	        )
	      )
	    ),
	    _react2['default'].createElement(
	      _spectaclePpa.Slide,
	      {
	        id: 'level',
	        key: 'level',
	        bgColor: 'black',
	        notes: md.getSubSectionAsHtml('Level ' + level + ' Icon', 'Notes', false, regionData) },
	      _react2['default'].createElement(
	        'div',
	        {
	          className: 'ui-slide' },
	        _react2['default'].createElement(
	          'div',
	          { className: 'title-image' },
	          _react2['default'].createElement('img', {
	            className: 'heading-image heading-image-before',
	            src: levels[level].img }),
	          _react2['default'].createElement(
	            _spectaclePpa.Heading,
	            { size: 1 },
	            _react2['default'].createElement(
	              'strong',
	              null,
	              title
	            )
	          ),
	          _react2['default'].createElement(
	            _spectaclePpa.Heading,
	            { size: 2 },
	            _react2['default'].createElement(
	              'strong',
	              null,
	              'Level ',
	              level
	            )
	          )
	        )
	      )
	    ),
	    (level === 1 || level === 2 || level === 3) && (0, _baseSlidesVideoSlide2['default'])({
	      id: 'level-intro',
	      notes: md.getSubSectionAsHtml('Level ' + level + ' Intro', 'Notes', false, regionData),
	      youTubeId: md.getSectionMetadata('Level ' + level + ' Intro', 'YouTube', regionData)
	    })
	  );
	}
	
	exports['default'] = startSection;
	/* Sanksrit for Vanessa */ /* lokah samastah sukhino bhavantu */ /* may all beings everywhere be at peace */ /* Sara and Ian Level Intro */

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.preloadSong = preloadSong;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _baseSlidesVideoSlide = __webpack_require__(58);
	
	var _baseSlidesVideoSlide2 = _interopRequireDefault(_baseSlidesVideoSlide);
	
	var _imagesCharactersIan_sara_sillyPng = __webpack_require__(2340);
	
	var _imagesCharactersIan_sara_sillyPng2 = _interopRequireDefault(_imagesCharactersIan_sara_sillyPng);
	
	var _imagesCharactersIan_sara_two_fingersPng = __webpack_require__(2341);
	
	var _imagesCharactersIan_sara_two_fingersPng2 = _interopRequireDefault(_imagesCharactersIan_sara_two_fingersPng);
	
	var _helpersMarkdownScript = __webpack_require__(9);
	
	var _helpersMarkdownScript2 = _interopRequireDefault(_helpersMarkdownScript);
	
	var _songMd = __webpack_require__(1629);
	
	var _songMd2 = _interopRequireDefault(_songMd);
	
	var md = new _helpersMarkdownScript2['default'](_songMd2['default']);
	
	function preloadSong() {
	  (0, _spectaclePpa.preloader)([_imagesCharactersIan_sara_sillyPng2['default'], _imagesCharactersIan_sara_two_fingersPng2['default']]);
	}
	
	function songSection(_ref) {
	  var regionData = _ref.regionData;
	
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'song' },
	    (0, _baseSlidesVideoSlide2['default'])({
	      id: 'video',
	      notes: md.getSubSectionAsHtml('Song', 'Notes', false, regionData),
	      youTubeId: md.getSectionMetadata('Song', 'YouTube', regionData)
	    })
	  );
	}
	
	exports['default'] = songSection;
	/* Song */

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

	/* eslint react/no-multi-comp: 0 */
	
	'use strict';
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _baseSlidesVideoSlide = __webpack_require__(58);
	
	var _baseSlidesVideoSlide2 = _interopRequireDefault(_baseSlidesVideoSlide);
	
	var _helpersMarkdownScript = __webpack_require__(9);
	
	var _helpersMarkdownScript2 = _interopRequireDefault(_helpersMarkdownScript);
	
	var _level1_egstoryMd = __webpack_require__(1631);
	
	var _level1_egstoryMd2 = _interopRequireDefault(_level1_egstoryMd);
	
	var _level2_egstoryMd = __webpack_require__(1632);
	
	var _level2_egstoryMd2 = _interopRequireDefault(_level2_egstoryMd);
	
	var _level3_egstoryMd = __webpack_require__(1633);
	
	var _level3_egstoryMd2 = _interopRequireDefault(_level3_egstoryMd);
	
	var _level4_egstoryMd = __webpack_require__(1634);
	
	var _level4_egstoryMd2 = _interopRequireDefault(_level4_egstoryMd);
	
	var levels = {
	  '1': { md: new _helpersMarkdownScript2['default'](_level1_egstoryMd2['default']) },
	  '2': { md: new _helpersMarkdownScript2['default'](_level2_egstoryMd2['default']) },
	  '3': { md: new _helpersMarkdownScript2['default'](_level3_egstoryMd2['default']) },
	  '4': { md: new _helpersMarkdownScript2['default'](_level4_egstoryMd2['default']) }
	};
	
	function esOpeningStory(_ref) {
	  var level = _ref.level;
	  var regionData = _ref.regionData;
	
	  var md = levels[level].md;
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: "esGooberStory" },
	    level === 1 && (0, _baseSlidesVideoSlide2['default'])({
	      id: 'es-goober-intro',
	      notes: md.getSubSectionAsHtml('Esmeralda and Goober Intro', 'Notes', false, regionData),
	      youTubeId: md.getSectionMetadata('Esmeralda and Goober Intro', 'YouTube', regionData)
	    }),
	    level === 3 && (0, _baseSlidesVideoSlide2['default'])({
	      id: 'sharknado',
	      notes: md.getSubSectionAsHtml('Sharknado', 'Notes', false, regionData),
	      youTubeId: md.getSectionMetadata('Sharknado', 'YouTube', regionData)
	    }),
	    level === 3 && (0, _baseSlidesVideoSlide2['default'])({
	      id: 'calming-breath-recap',
	      notes: md.getSubSectionAsHtml('Calming Breath Recap', 'Notes', false, regionData),
	      youTubeId: md.getSectionMetadata('Calming Breath Recap', 'YouTube', regionData)
	    }),
	    (0, _baseSlidesVideoSlide2['default'])({
	      id: 'story',
	      notes: md.getSubSectionAsHtml('Esmeralda and Goober Story', 'Notes', false, regionData),
	      youTubeId: md.getSectionMetadata('Esmeralda and Goober Story', 'YouTube', regionData)
	    }),
	    level === 2 && (0, _baseSlidesVideoSlide2['default'])({
	      id: 'calming-breath',
	      notes: md.getSubSectionAsHtml('Calming Breath Intro', 'Notes', false, regionData),
	      youTubeId: md.getSectionMetadata('Calming Breath Intro', 'YouTube', regionData)
	    })
	  );
	}
	
	exports['default'] = esOpeningStory;
	module.exports = exports['default'];
	/* Esmerelada and Goober Story Intro */ /* Sharknado in Level 3 */ /* Calming breath recap in Level 3 */ /* Esmerelda and Goober Story  */ /* Calming breath intro in Level 2 */

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

	/* eslint react/no-multi-comp: 0 */
	
	'use strict';
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.preloadClassActivity = preloadClassActivity;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _baseSlidesHeadingSlide = __webpack_require__(165);
	
	var _baseSlidesHeadingSlide2 = _interopRequireDefault(_baseSlidesHeadingSlide);
	
	var _baseSlidesVideoSlide = __webpack_require__(58);
	
	var _baseSlidesVideoSlide2 = _interopRequireDefault(_baseSlidesVideoSlide);
	
	var _baseSlidesBalloonSlide = __webpack_require__(88);
	
	var _baseSlidesBalloonSlide2 = _interopRequireDefault(_baseSlidesBalloonSlide);
	
	var _imagesCharactersIan_headshot_smilePng = __webpack_require__(878);
	
	var _imagesCharactersIan_headshot_smilePng2 = _interopRequireDefault(_imagesCharactersIan_headshot_smilePng);
	
	var _imagesCharactersIan_sara_sidePng = __webpack_require__(155);
	
	var _imagesCharactersIan_sara_sidePng2 = _interopRequireDefault(_imagesCharactersIan_sara_sidePng);
	
	var _imagesCharactersIan_sara_lean_smilePng = __webpack_require__(424);
	
	var _imagesCharactersIan_sara_lean_smilePng2 = _interopRequireDefault(_imagesCharactersIan_sara_lean_smilePng);
	
	var _imagesCharactersIan_sidePng = __webpack_require__(879);
	
	var _imagesCharactersIan_sidePng2 = _interopRequireDefault(_imagesCharactersIan_sidePng);
	
	var _imagesCharactersSara_surprisedPng = __webpack_require__(881);
	
	var _imagesCharactersSara_surprisedPng2 = _interopRequireDefault(_imagesCharactersSara_surprisedPng);
	
	var _imagesCharactersSara_twist_hands_out_heyheyPng = __webpack_require__(882);
	
	var _imagesCharactersSara_twist_hands_out_heyheyPng2 = _interopRequireDefault(_imagesCharactersSara_twist_hands_out_heyheyPng);
	
	var _imagesCharactersIan_pointing_upPng = __webpack_require__(423);
	
	var _imagesCharactersIan_pointing_upPng2 = _interopRequireDefault(_imagesCharactersIan_pointing_upPng);
	
	var _imagesCharactersIan_pointing_leftPng = __webpack_require__(2339);
	
	var _imagesCharactersIan_pointing_leftPng2 = _interopRequireDefault(_imagesCharactersIan_pointing_leftPng);
	
	var _imagesCharactersIan_pointing_downPng = __webpack_require__(2338);
	
	var _imagesCharactersIan_pointing_downPng2 = _interopRequireDefault(_imagesCharactersIan_pointing_downPng);
	
	var _imagesCharactersSara_smilePng = __webpack_require__(425);
	
	var _imagesCharactersSara_smilePng2 = _interopRequireDefault(_imagesCharactersSara_smilePng);
	
	var _imagesCharactersSara_humphPng = __webpack_require__(2343);
	
	var _imagesCharactersSara_humphPng2 = _interopRequireDefault(_imagesCharactersSara_humphPng);
	
	var _imagesCharactersIan_sara_lean_questioningPng = __webpack_require__(202);
	
	var _imagesCharactersIan_sara_lean_questioningPng2 = _interopRequireDefault(_imagesCharactersIan_sara_lean_questioningPng);
	
	var _helpersMarkdownScript = __webpack_require__(9);
	
	var _helpersMarkdownScript2 = _interopRequireDefault(_helpersMarkdownScript);
	
	var _level1_listEmergenciesMd = __webpack_require__(1642);
	
	var _level1_listEmergenciesMd2 = _interopRequireDefault(_level1_listEmergenciesMd);
	
	var _level2_floorplanMd = __webpack_require__(1643);
	
	var _level2_floorplanMd2 = _interopRequireDefault(_level2_floorplanMd);
	
	var _level3_kitRapMd = __webpack_require__(1644);
	
	var _level3_kitRapMd2 = _interopRequireDefault(_level3_kitRapMd);
	
	var _level4_drawingMd = __webpack_require__(1645);
	
	var _level4_drawingMd2 = _interopRequireDefault(_level4_drawingMd);
	
	var levels = {
	  '1': { md: new _helpersMarkdownScript2['default'](_level1_listEmergenciesMd2['default']) },
	  '2': { md: new _helpersMarkdownScript2['default'](_level2_floorplanMd2['default']) },
	  '3': { md: new _helpersMarkdownScript2['default'](_level3_kitRapMd2['default']) },
	  '4': { md: new _helpersMarkdownScript2['default'](_level4_drawingMd2['default']) }
	};
	
	function preloadClassActivity() {
	  (0, _spectaclePpa.preloader)([_imagesCharactersIan_headshot_smilePng2['default'], _imagesCharactersIan_sara_sidePng2['default'], _imagesCharactersIan_sara_lean_smilePng2['default'], _imagesCharactersIan_sidePng2['default'], _imagesCharactersSara_surprisedPng2['default'], _imagesCharactersSara_twist_hands_out_heyheyPng2['default'], _imagesCharactersIan_pointing_upPng2['default'], _imagesCharactersIan_pointing_leftPng2['default'], _imagesCharactersIan_pointing_downPng2['default'], _imagesCharactersSara_smilePng2['default'], _imagesCharactersSara_humphPng2['default'], _imagesCharactersIan_sara_lean_questioningPng2['default']]);
	}
	
	function introVideo(level, regionData) {
	  var md = levels[level].md;
	  return (0, _baseSlidesVideoSlide2['default'])({
	    id: 'intro-video',
	    notes: md.getSubSectionAsHtml('Intro Video', 'Notes', false, regionData),
	    youTubeId: md.getSectionMetadata('Intro Video', 'YouTube', regionData)
	  });
	}
	
	function sizzle(level, regionData) {
	  var md = levels[level].md;
	  return (0, _baseSlidesBalloonSlide2['default'])({
	    id: 'sizzle',
	    characterSide: 'right',
	    characterImage: _imagesCharactersIan_sara_sidePng2['default'],
	    notes: md.getSubSectionAsHtml('Sizzle', 'Notes', false, regionData),
	    html: md.getSubSectionAsHtml('Sizzle', 'Content', false, regionData)
	  });
	}
	
	function instructions(level, regionData) {
	  var md = levels[level].md;
	  return (0, _baseSlidesBalloonSlide2['default'])({
	    id: 'instructions',
	    characterSide: 'right',
	    characterImage: _imagesCharactersIan_sara_lean_smilePng2['default'],
	    notes: md.getSubSectionAsHtml('Instructions', 'Notes', false, regionData),
	    html: md.getSubSectionAsHtml('Instructions', 'Content', false, regionData)
	  });
	}
	
	function scoring(level, regionData) {
	  var md = levels[level].md;
	  return (0, _baseSlidesBalloonSlide2['default'])({
	    id: 'scoring',
	    characterSide: 'left',
	    characterImage: _imagesCharactersIan_sidePng2['default'],
	    notes: md.getSubSectionAsHtml('Scoring', 'Notes', false, regionData),
	    html: md.getSubSectionAsHtml('Scoring', 'Content', false, regionData)
	  });
	}
	
	function level1(regionData) {
	  // Top Ten Emergencies
	  var level = '1';
	  var md = levels[level].md;
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'class-activity-' + level },
	    introVideo(level, regionData),
	    sizzle(level, regionData),
	    instructions(level, regionData),
	    (0, _baseSlidesVideoSlide2['default'])({
	      id: 'time-up',
	      notes: md.getSubSectionAsHtml('Time Up', 'Notes', false, regionData),
	      youTubeId: md.getSectionMetadata('Time Up', 'YouTube', regionData)
	    }),
	    (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'how-to-get-points',
	      characterSide: 'left',
	      characterImage: _imagesCharactersSara_smilePng2['default'],
	      notes: md.getSubSectionAsHtml('How To Get Points', 'Notes', false, regionData),
	      html: md.getSubSectionAsHtml('How To Get Points', 'Content', false, regionData)
	    }),
	    (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'share-answers',
	      characterSide: 'right',
	      characterImage: _imagesCharactersIan_sidePng2['default'],
	      notes: md.getSubSectionAsHtml('Share Answers', 'Notes', false, regionData),
	      html: md.getSubSectionAsHtml('Share Answers', 'Content', false, regionData)
	    }),
	    (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'top-ten-emergencies',
	      characterSide: 'right',
	      characterImage: _imagesCharactersSara_twist_hands_out_heyheyPng2['default'],
	      notes: md.getSubSectionAsHtml('Top Ten Emergencies', 'Notes', false, regionData),
	      html: md.getSubSectionAsHtml('Top Ten Emergencies', 'Content', false, regionData)
	    }),
	    (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'points-reminder',
	      characterSide: 'right',
	      characterImage: _imagesCharactersIan_pointing_upPng2['default'],
	      notes: md.getSubSectionAsHtml('Points Reminder', 'Notes', false, regionData),
	      html: md.getSubSectionAsHtml('Points Reminder', 'Content', false, regionData)
	    }),
	    (0, _baseSlidesVideoSlide2['default'])({
	      id: 'act-out-emergencies',
	      notes: md.getSubSectionAsHtml('Act Out Emergencies', 'Notes', false, regionData),
	      youTubeId: md.getSectionMetadata('Act Out Emergencies', 'YouTube', regionData)
	    })
	  );
	}
	
	function level2(regionData) {
	  // floorplan
	  var level = '2';
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'class-activity-' + level },
	    introVideo(level, regionData),
	    sizzle(level, regionData),
	    instructions(level, regionData)
	  );
	}
	
	function level3(regionData) {
	  // Draw Energy
	  var level = '3';
	  var md = levels[level].md;
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'class-activity-' + level },
	    introVideo(level, regionData),
	    sizzle(level, regionData),
	    instructions(level, regionData),
	    (0, _baseSlidesVideoSlide2['default'])({
	      id: 'rap-backtrack-practice',
	      notes: md.getSubSectionAsHtml('Rap Backtrack Practice', 'Notes', false, regionData),
	      youTubeId: md.getSectionMetadata('Rap Backtrack Practice', 'YouTube', regionData)
	    }),
	    scoring(level, regionData),
	    (0, _baseSlidesVideoSlide2['default'])({
	      id: 'rap-backtrack-perform',
	      notes: md.getSubSectionAsHtml('Rap Backtrack Perform', 'Notes', false, regionData),
	      youTubeId: md.getSectionMetadata('Rap Backtrack Perform', 'YouTube', regionData)
	    })
	  );
	}
	
	function level4(regionData) {
	  // Energy saving rap
	  var level = '4';
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'class-activity-' + level },
	    introVideo(level, regionData),
	    sizzle(level, regionData),
	    instructions(level, regionData)
	  );
	}
	
	function classActivitySection(_ref) {
	  var level = _ref.level;
	  var subActivity = _ref.subActivity;
	  var regionData = _ref.regionData;
	
	  switch ('' + level + (subActivity ? subActivity : '')) {
	    case '1':
	      return level1(regionData);
	    case '2':
	      return level2(regionData);
	    case '3':
	      return level3(regionData);
	    case '4':
	      return level4(regionData);
	    default:
	      return (0, _baseSlidesHeadingSlide2['default'])({ heading: 'Unknown' });
	  }
	}
	
	exports['default'] = classActivitySection;
	/* Intro Video */ /* Sizzle */ /* Instructions */ /* Time's up */ /* How to get points */ /* Share answers */ /* Top ten emergencies */ /* Don't forget to add points */ /* Act out emergencies */ /* Intro Video */ /* Sizzle */ /* Instructions */ /* Intro Video */ /* Sizzle */ /* Instructions */ /* Rap Backtrack Practice */ /* Scoring */ /* Rap Backtrack Perform */ /* Intro Video */ /* Sizzle */ /* Instructions */

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.preloadMissionAssignment = preloadMissionAssignment;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _baseSlidesHeadingSlide = __webpack_require__(165);
	
	var _baseSlidesHeadingSlide2 = _interopRequireDefault(_baseSlidesHeadingSlide);
	
	var _baseSlidesBalloonSlide = __webpack_require__(88);
	
	var _baseSlidesBalloonSlide2 = _interopRequireDefault(_baseSlidesBalloonSlide);
	
	var _baseSlidesVideoSlide = __webpack_require__(58);
	
	var _baseSlidesVideoSlide2 = _interopRequireDefault(_baseSlidesVideoSlide);
	
	var _imagesEmergencyPreparednessSquadGlowPng = __webpack_require__(426);
	
	var _imagesEmergencyPreparednessSquadGlowPng2 = _interopRequireDefault(_imagesEmergencyPreparednessSquadGlowPng);
	
	var _imagesCharactersIan_sara_sidePng = __webpack_require__(155);
	
	var _imagesCharactersIan_sara_sidePng2 = _interopRequireDefault(_imagesCharactersIan_sara_sidePng);
	
	var _imagesCharactersIan_sara_lean_questioningPng = __webpack_require__(202);
	
	var _imagesCharactersIan_sara_lean_questioningPng2 = _interopRequireDefault(_imagesCharactersIan_sara_lean_questioningPng);
	
	var _helpersMarkdownScript = __webpack_require__(9);
	
	var _helpersMarkdownScript2 = _interopRequireDefault(_helpersMarkdownScript);
	
	var _level1_knowTheRisksMd = __webpack_require__(1646);
	
	var _level1_knowTheRisksMd2 = _interopRequireDefault(_level1_knowTheRisksMd);
	
	var _level2_makeAPlanMd = __webpack_require__(1647);
	
	var _level2_makeAPlanMd2 = _interopRequireDefault(_level2_makeAPlanMd);
	
	var _level3_getAKitMd = __webpack_require__(1648);
	
	var _level3_getAKitMd2 = _interopRequireDefault(_level3_getAKitMd);
	
	var _level4_keepBuildingKitMd = __webpack_require__(1649);
	
	var _level4_keepBuildingKitMd2 = _interopRequireDefault(_level4_keepBuildingKitMd);
	
	var levels = {
	  '1': { md: new _helpersMarkdownScript2['default'](_level1_knowTheRisksMd2['default']) },
	  '2': { md: new _helpersMarkdownScript2['default'](_level2_makeAPlanMd2['default']) },
	  '3': { md: new _helpersMarkdownScript2['default'](_level3_getAKitMd2['default']) },
	  '4': { md: new _helpersMarkdownScript2['default'](_level4_keepBuildingKitMd2['default']) }
	};
	
	function preloadMissionAssignment() {
	  (0, _spectaclePpa.preloader)([_imagesEmergencyPreparednessSquadGlowPng2['default'], _imagesCharactersIan_sara_sidePng2['default'], _imagesCharactersIan_sara_lean_questioningPng2['default']]);
	}
	
	function missionAssignmentSection(_ref) {
	  var level = _ref.level;
	  var title = _ref.title;
	  var regionData = _ref.regionData;
	
	  var md = levels[level].md;
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'mission-assignment' },
	    (0, _baseSlidesVideoSlide2['default'])({
	      id: 'mission-intro-video',
	      notes: md.getSubSectionAsHtml('Mission Intro Video', 'Notes', false, regionData),
	      youTubeId: md.getSectionMetadata('Mission Intro Video', 'YouTube', regionData)
	    }),
	    (0, _baseSlidesHeadingSlide2['default'])({
	      id: 'sizzle',
	      beforeImage: _imagesEmergencyPreparednessSquadGlowPng2['default'],
	      subHeading: 'Mission ' + level + ':<br/> ' + title,
	      notes: md.getSubSectionAsHtml('Mission Assignment', 'Notes', false, regionData),
	      bgColor: 'black'
	    }),
	    (level === 1 || level === 3) && (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'instructions',
	      characterSide: 'right',
	      characterImage: _imagesCharactersIan_sara_sidePng2['default'],
	      notes: md.getSubSectionAsHtml('Instructions', 'Notes', false, regionData),
	      html: md.getSubSectionAsHtml('Instructions', 'Content', false, regionData)
	    }),
	    (level === 2 || level === 4) && (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'instructions',
	      characterSide: 'right',
	      characterImage: _imagesCharactersIan_sara_lean_questioningPng2['default'],
	      notes: md.getSubSectionAsHtml('Instructions', 'Notes', false, regionData),
	      html: md.getSubSectionAsHtml('Instructions', 'Content', false, regionData)
	    })
	  );
	}
	
	exports['default'] = missionAssignmentSection;
	/* Mission Intro Video*/ /* Sizzle */ /* Mission Instructions levels 1 & 3 */ /* Mission Instructions levels 2 & 4 */

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.preloadFinish = preloadFinish;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _componentsCompleteLevelButton = __webpack_require__(44);
	
	var _componentsCompleteLevelButton2 = _interopRequireDefault(_componentsCompleteLevelButton);
	
	var _baseSlidesBalloonSlide = __webpack_require__(88);
	
	var _baseSlidesBalloonSlide2 = _interopRequireDefault(_baseSlidesBalloonSlide);
	
	var _baseSlidesVideoSlide = __webpack_require__(58);
	
	var _baseSlidesVideoSlide2 = _interopRequireDefault(_baseSlidesVideoSlide);
	
	var _imagesCharactersIan_sara_lean_smilePng = __webpack_require__(424);
	
	var _imagesCharactersIan_sara_lean_smilePng2 = _interopRequireDefault(_imagesCharactersIan_sara_lean_smilePng);
	
	var _imagesCharactersIan_sara_sidePng = __webpack_require__(155);
	
	var _imagesCharactersIan_sara_sidePng2 = _interopRequireDefault(_imagesCharactersIan_sara_sidePng);
	
	var _imagesCharactersIan_sara_lean_questioningPng = __webpack_require__(202);
	
	var _imagesCharactersIan_sara_lean_questioningPng2 = _interopRequireDefault(_imagesCharactersIan_sara_lean_questioningPng);
	
	var _helpersMarkdownScript = __webpack_require__(9);
	
	var _helpersMarkdownScript2 = _interopRequireDefault(_helpersMarkdownScript);
	
	var _finishMd = __webpack_require__(1650);
	
	var _finishMd2 = _interopRequireDefault(_finishMd);
	
	var _level1_completeSvg = __webpack_require__(2355);
	
	var _level1_completeSvg2 = _interopRequireDefault(_level1_completeSvg);
	
	var _level2_completeSvg = __webpack_require__(2356);
	
	var _level2_completeSvg2 = _interopRequireDefault(_level2_completeSvg);
	
	var _level3_completeSvg = __webpack_require__(2357);
	
	var _level3_completeSvg2 = _interopRequireDefault(_level3_completeSvg);
	
	var _level4_completeSvg = __webpack_require__(2358);
	
	var _level4_completeSvg2 = _interopRequireDefault(_level4_completeSvg);
	
	var md = new _helpersMarkdownScript2['default'](_finishMd2['default']);
	
	var levels = {
	  '1': { img: _level1_completeSvg2['default'] },
	  '2': { img: _level2_completeSvg2['default'] },
	  '3': { img: _level3_completeSvg2['default'] },
	  '4': { img: _level4_completeSvg2['default'] }
	};
	
	function preloadFinish() {
	  (0, _spectaclePpa.preloader)([_imagesCharactersIan_sara_lean_smilePng2['default'], _imagesCharactersIan_sara_sidePng2['default'], _imagesCharactersIan_sara_lean_questioningPng2['default'], _level1_completeSvg2['default'], _level2_completeSvg2['default'], _level3_completeSvg2['default'], _level4_completeSvg2['default']]);
	}
	
	function finishSection(_ref) {
	  var level = _ref.level;
	  var regionData = _ref.regionData;
	
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'finish' },
	    level === 1 && (0, _baseSlidesVideoSlide2['default'])({
	      id: 'outtakes',
	      notes: md.getSubSectionAsHtml('Outtakes 1', 'Notes', false, regionData),
	      youTubeId: md.getSectionMetadata('Outtakes 1', 'YouTube', regionData)
	    }),
	    level === 3 && (0, _baseSlidesVideoSlide2['default'])({
	      id: 'outtakes',
	      notes: md.getSubSectionAsHtml('Outtakes 2', 'Notes', false, regionData),
	      youTubeId: md.getSectionMetadata('Outtakes 2', 'YouTube', regionData)
	    }),
	    level !== 4 && (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'scoreboard-recap',
	      characterSide: 'left',
	      characterImage: _imagesCharactersIan_sara_sidePng2['default'],
	      html: md.getSubSectionAsHtml('Scoreboard Recap', 'Content', false, regionData),
	      notes: md.getSubSectionAsHtml('Scoreboard Recap', 'Notes', false, regionData)
	    }),
	    level !== 4 && (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'earn-more-points',
	      characterSide: 'right',
	      characterImage: _imagesCharactersIan_sara_lean_questioningPng2['default'],
	      html: md.getSubSectionAsHtml('Earn More Points', 'Content', false, regionData),
	      notes: md.getSubSectionAsHtml('Earn More Points', 'Notes', false, regionData)
	    }),
	    (level === 1 || level === 3) && (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'farewell',
	      characterSide: 'left',
	      characterImage: _imagesCharactersIan_sara_lean_smilePng2['default'],
	      html: md.getSubSectionAsHtml('Farewell', 'Content', false, regionData),
	      notes: md.getSubSectionAsHtml('Farewell', 'Notes', false, regionData)
	    }),
	    (level === 2 || level === 4) && (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'farewell',
	      characterSide: 'left',
	      characterImage: _imagesCharactersIan_sara_sidePng2['default'],
	      html: md.getSubSectionAsHtml('Farewell', 'Content', false, regionData),
	      notes: md.getSubSectionAsHtml('Farewell', 'Notes', false, regionData)
	    }),
	    _react2['default'].createElement(
	      _spectaclePpa.Slide,
	      {
	        id: 'level-completed',
	        notes: '<h2>Level ' + level + ' Finished</h2>',
	        bgColor: 'transparent',
	        finish: true },
	      _react2['default'].createElement(
	        'div',
	        { className: 'level-complete' },
	        _react2['default'].createElement(
	          'div',
	          { className: 'level-complete-content' },
	          _react2['default'].createElement(
	            'figure',
	            { className: 'level-complete-graphic' },
	            _react2['default'].createElement('img', { src: levels[level].img })
	          ),
	          _react2['default'].createElement(
	            _spectaclePpa.Heading,
	            { size: 2 },
	            'You\'ve finished'
	          ),
	          _react2['default'].createElement(
	            _spectaclePpa.Heading,
	            { size: 2 },
	            'level ',
	            level,
	            ' of 4'
	          ),
	          _react2['default'].createElement(_componentsCompleteLevelButton2['default'], null)
	        )
	      )
	    )
	  );
	}
	
	exports['default'] = finishSection;
	/* Outtakes 1 */ /* Outtakes 2 */ /* Scoreboard Recap */ /* Earn More Points */ /* Farewell level 1 & 3 */ /* Farewell level 2 & 4 */ /* Level complete */

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _taggedTemplateLiteral = __webpack_require__(28)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.preloadStart = preloadStart;
	
	var _templateObject = _taggedTemplateLiteral(['Level ', ''], ['Level ', '']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _helpersMarkdownScript = __webpack_require__(9);
	
	var _helpersMarkdownScript2 = _interopRequireDefault(_helpersMarkdownScript);
	
	var _helpersI18n = __webpack_require__(14);
	
	var _imagesPpa_presentsPng = __webpack_require__(2398);
	
	var _imagesPpa_presentsPng2 = _interopRequireDefault(_imagesPpa_presentsPng);
	
	var _imagesPpa_presentsFr_CAPng = __webpack_require__(2397);
	
	var _imagesPpa_presentsFr_CAPng2 = _interopRequireDefault(_imagesPpa_presentsFr_CAPng);
	
	var _imagesH2whoaNoPPAPresentsPng = __webpack_require__(2390);
	
	var _imagesH2whoaNoPPAPresentsPng2 = _interopRequireDefault(_imagesH2whoaNoPPAPresentsPng);
	
	var _imagesH2whoaNoPPAPresentsFr_CAPng = __webpack_require__(2389);
	
	var _imagesH2whoaNoPPAPresentsFr_CAPng2 = _interopRequireDefault(_imagesH2whoaNoPPAPresentsFr_CAPng);
	
	var _startMd = __webpack_require__(1672);
	
	var _startMd2 = _interopRequireDefault(_startMd);
	
	var _startFr_CAMd = __webpack_require__(1671);
	
	var _startFr_CAMd2 = _interopRequireDefault(_startFr_CAMd);
	
	var _imagesLevel1_startPng = __webpack_require__(432);
	
	var _imagesLevel1_startPng2 = _interopRequireDefault(_imagesLevel1_startPng);
	
	var _imagesLevel2_startPng = __webpack_require__(433);
	
	var _imagesLevel2_startPng2 = _interopRequireDefault(_imagesLevel2_startPng);
	
	var _imagesLevel3_startPng = __webpack_require__(434);
	
	var _imagesLevel3_startPng2 = _interopRequireDefault(_imagesLevel3_startPng);
	
	var _imagesLevel4_startPng = __webpack_require__(890);
	
	var _imagesLevel4_startPng2 = _interopRequireDefault(_imagesLevel4_startPng);
	
	var imagePPALogo = (0, _helpersI18n.i18nData)({
	  en: _imagesPpa_presentsPng2['default'],
	  fr_CA: _imagesPpa_presentsFr_CAPng2['default']
	});
	
	var imageH2WLogo = (0, _helpersI18n.i18nData)({
	  en: _imagesH2whoaNoPPAPresentsPng2['default'],
	  fr_CA: _imagesH2whoaNoPPAPresentsFr_CAPng2['default']
	});
	
	var levels = {
	  '1': { img: _imagesLevel1_startPng2['default'] },
	  '2': { img: _imagesLevel2_startPng2['default'] },
	  '3': { img: _imagesLevel3_startPng2['default'] },
	  '4': { img: _imagesLevel4_startPng2['default'] }
	};
	
	var md = (0, _helpersI18n.i18nData)({
	  en: new _helpersMarkdownScript2['default'](_startMd2['default']),
	  fr_CA: new _helpersMarkdownScript2['default'](_startFr_CAMd2['default'])
	});
	
	function preloadStart() {
	  (0, _spectaclePpa.preloader)([_imagesPpa_presentsPng2['default'], _imagesPpa_presentsFr_CAPng2['default'], _imagesH2whoaNoPPAPresentsPng2['default'], _imagesH2whoaNoPPAPresentsFr_CAPng2['default'], _imagesLevel1_startPng2['default'], _imagesLevel2_startPng2['default'], _imagesLevel3_startPng2['default'], _imagesLevel4_startPng2['default']]);
	}
	
	function startSection(_ref) {
	  var level = _ref.level;
	  var title = _ref.title;
	  var regionData = _ref.regionData;
	  var _ = _ref.i18n;
	
	  var md_i18n = _(md);
	  /* Level intro graphic */
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'start' },
	    _react2['default'].createElement(
	      _spectaclePpa.Slide,
	      {
	        id: 'ppa-presents',
	        key: 'ppa-presents',
	        bgColor: 'black',
	        notes: md_i18n.getSubSectionAsHtml('Level ' + level + ' Start', 'Notes', false, regionData) },
	      _react2['default'].createElement(
	        'div',
	        {
	          className: 'ui-slide' },
	        _react2['default'].createElement(
	          'div',
	          { className: 'flex-image' },
	          _react2['default'].createElement('img', {
	            className: 'heading-image heading-image-before',
	            src: _(imagePPALogo) })
	        )
	      )
	    ),
	    _react2['default'].createElement(
	      _spectaclePpa.Slide,
	      {
	        id: 'ppa-h2w',
	        key: 'ppa-h2w',
	        bgColor: 'black',
	        notes: md_i18n.getSubSectionAsHtml('Level ' + level + ' Start', 'Notes', false, regionData) },
	      _react2['default'].createElement(
	        'div',
	        {
	          className: 'ui-slide' },
	        _react2['default'].createElement(
	          'div',
	          { className: 'flex-image' },
	          _react2['default'].createElement('img', { className: 'h2w-logo heading-image',
	            src: _(imageH2WLogo) })
	        )
	      )
	    ),
	    _react2['default'].createElement(
	      _spectaclePpa.Slide,
	      {
	        id: 'level',
	        key: 'level',
	        bgColor: 'black',
	        notes: md_i18n.getSubSectionAsHtml('Level ' + level + ' Icon', 'Notes', false, regionData) },
	      _react2['default'].createElement(
	        'div',
	        {
	          className: 'ui-slide' },
	        _react2['default'].createElement(
	          'div',
	          { className: 'title-image' },
	          _react2['default'].createElement('img', {
	            className: 'heading-image heading-image-before',
	            src: levels[level].img }),
	          _react2['default'].createElement(
	            _spectaclePpa.Heading,
	            { size: 1 },
	            _react2['default'].createElement(
	              'strong',
	              null,
	              _(title)
	            )
	          ),
	          _react2['default'].createElement(
	            _spectaclePpa.Heading,
	            { size: 2 },
	            _react2['default'].createElement(
	              'strong',
	              null,
	              _(_templateObject, level)
	            )
	          )
	        )
	      )
	    )
	  );
	}
	
	exports['default'] = startSection;
	/* Sanksrit for Vanessa */ /* lokah samastah sukhino bhavantu */ /* may all beings everywhere be at peace */

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.preloadSong = preloadSong;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _helpersI18n = __webpack_require__(14);
	
	var _baseSlidesVideoSlide = __webpack_require__(89);
	
	var _baseSlidesVideoSlide2 = _interopRequireDefault(_baseSlidesVideoSlide);
	
	var _baseSlidesBalloonSlide = __webpack_require__(67);
	
	var _baseSlidesBalloonSlide2 = _interopRequireDefault(_baseSlidesBalloonSlide);
	
	var _imagesCharactersApprenticesPosingPng = __webpack_require__(2369);
	
	var _imagesCharactersApprenticesPosingPng2 = _interopRequireDefault(_imagesCharactersApprenticesPosingPng);
	
	var _imagesCharactersApprenticesFlexArmsPng = __webpack_require__(430);
	
	var _imagesCharactersApprenticesFlexArmsPng2 = _interopRequireDefault(_imagesCharactersApprenticesFlexArmsPng);
	
	var _helpersMarkdownScript = __webpack_require__(9);
	
	var _helpersMarkdownScript2 = _interopRequireDefault(_helpersMarkdownScript);
	
	var _songMd = __webpack_require__(1674);
	
	var _songMd2 = _interopRequireDefault(_songMd);
	
	var _songFr_CAMd = __webpack_require__(1673);
	
	var _songFr_CAMd2 = _interopRequireDefault(_songFr_CAMd);
	
	var md = (0, _helpersI18n.i18nData)({
	  en: new _helpersMarkdownScript2['default'](_songMd2['default']),
	  fr_CA: new _helpersMarkdownScript2['default'](_songFr_CAMd2['default'])
	});
	
	function preloadSong() {
	  (0, _spectaclePpa.preloader)([_imagesCharactersApprenticesPosingPng2['default'], _imagesCharactersApprenticesFlexArmsPng2['default']]);
	}
	
	function songSection(_ref) {
	  var level = _ref.level;
	  var regionData = _ref.regionData;
	  var i18n = _ref.i18n;
	
	  var md_i18n = i18n(md);
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'song' },
	    i18n.lang === 'en' && (level === 1 || level === 2) && (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'get-ready',
	      characterSide: 'right',
	      characterImage: _imagesCharactersApprenticesFlexArmsPng2['default'],
	      html: md_i18n.getSubSectionAsHtml('Get Ready to Sing', 'Content', false, regionData),
	      notes: md_i18n.getSubSectionAsHtml('Get Ready to Sing', 'Notes', false, regionData)
	    }),
	    i18n.lang === 'en' && (level === 1 || level === 2) && (0, _baseSlidesVideoSlide2['default'])({
	      id: 'song',
	      notes: md_i18n.getSubSectionAsHtml('Standalone Song', 'Notes', false, regionData),
	      youTubeId: md_i18n.getSectionMetadata('Standalone Song', 'YouTube', regionData)
	    }),
	    (level === 3 || level === 4) && (0, _baseSlidesVideoSlide2['default'])({
	      id: 'song',
	      notes: md_i18n.getSubSectionAsHtml('Combo Intro Song Level ' + level, 'Notes', false, regionData),
	      youTubeId: md_i18n.getSectionMetadata('Combo Intro Song Level ' + level, 'YouTube', regionData)
	    })
	  );
	}
	
	exports['default'] = songSection;
	/* Get ready to sing level 1 & 2 */ /* Standalone song in level 1 & 2 */ /* Combined Intro and Chorus in levels 3 & 4 */

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

	/* eslint react/no-multi-comp: 0 */
	
	'use strict';
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _helpersI18n = __webpack_require__(14);
	
	var _baseSlidesHeadingSlide = __webpack_require__(122);
	
	var _baseSlidesHeadingSlide2 = _interopRequireDefault(_baseSlidesHeadingSlide);
	
	var _baseSlidesVideoSlide = __webpack_require__(89);
	
	var _baseSlidesVideoSlide2 = _interopRequireDefault(_baseSlidesVideoSlide);
	
	var _helpersMarkdownScript = __webpack_require__(9);
	
	var _helpersMarkdownScript2 = _interopRequireDefault(_helpersMarkdownScript);
	
	var _esStoryMd = __webpack_require__(1684);
	
	var _esStoryMd2 = _interopRequireDefault(_esStoryMd);
	
	var _esStoryFr_CAMd = __webpack_require__(1683);
	
	var _esStoryFr_CAMd2 = _interopRequireDefault(_esStoryFr_CAMd);
	
	var md = (0, _helpersI18n.i18nData)({
	  en: new _helpersMarkdownScript2['default'](_esStoryMd2['default']),
	  fr_CA: new _helpersMarkdownScript2['default'](_esStoryFr_CAMd2['default'])
	});
	
	function video(_ref) {
	  var level = _ref.level;
	  var regionData = _ref.regionData;
	  var i18n = _ref.i18n;
	
	  var md_i18n = i18n(md);
	  return (0, _baseSlidesVideoSlide2['default'])({
	    id: 'video-' + level,
	    notes: md_i18n.getSubSectionAsHtml('Es Story ' + level, 'Notes', false, regionData),
	    youTubeId: md_i18n.getSectionMetadata('Es Story ' + level, 'YouTube', regionData)
	  });
	}
	
	function esStorySection(_ref2) {
	  var level = _ref2.level;
	  var subStory = _ref2.subStory;
	  var regionData = _ref2.regionData;
	  var i18n = _ref2.i18n;
	
	  var validLevels = ['1a', '1b', '1c', '2a', '3a', '3b', '4a', '4b'];
	  var theLevel = '' + level + (subStory || '');
	
	  if (validLevels.indexOf(theLevel) < 0) {
	    return (0, _baseSlidesHeadingSlide2['default'])({ heading: 'Unknown' });
	  }
	
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'es-story-' + theLevel },
	    video({ level: theLevel, regionData: regionData, i18n: i18n })
	  );
	}
	
	exports['default'] = esStorySection;
	module.exports = exports['default'];
	/* Video */

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _helpersI18n = __webpack_require__(14);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _baseSlidesVideoSlide = __webpack_require__(89);
	
	var _baseSlidesVideoSlide2 = _interopRequireDefault(_baseSlidesVideoSlide);
	
	var _helpersMarkdownScript = __webpack_require__(9);
	
	var _helpersMarkdownScript2 = _interopRequireDefault(_helpersMarkdownScript);
	
	var _mmeMd = __webpack_require__(1686);
	
	var _mmeMd2 = _interopRequireDefault(_mmeMd);
	
	var _mmeFr_CAMd = __webpack_require__(1685);
	
	var _mmeFr_CAMd2 = _interopRequireDefault(_mmeFr_CAMd);
	
	var md = (0, _helpersI18n.i18nData)({
	  en: new _helpersMarkdownScript2['default'](_mmeMd2['default']),
	  fr_CA: new _helpersMarkdownScript2['default'](_mmeFr_CAMd2['default'])
	});
	
	function mmeSection(_ref) {
	  var level = _ref.level;
	  var regionData = _ref.regionData;
	  var i18n = _ref.i18n;
	
	  var md_i18n = i18n(md);
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'mme' },
	    (0, _baseSlidesVideoSlide2['default'])({
	      id: 'video',
	      notes: md_i18n.getSubSectionAsHtml('MME Level ' + level, 'Notes', false, regionData),
	      youTubeId: md_i18n.getSectionMetadata('MME Level ' + level, 'YouTube', regionData)
	    })
	  );
	}
	
	exports['default'] = mmeSection;
	module.exports = exports['default'];
	/* MME segment */

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

	/* eslint react/no-multi-comp: 0 */
	
	'use strict';
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.preloadClassActivity = preloadClassActivity;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _helpersI18n = __webpack_require__(14);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _baseSlidesHeadingSlide = __webpack_require__(122);
	
	var _baseSlidesHeadingSlide2 = _interopRequireDefault(_baseSlidesHeadingSlide);
	
	var _baseSlidesBalloonSlide = __webpack_require__(67);
	
	var _baseSlidesBalloonSlide2 = _interopRequireDefault(_baseSlidesBalloonSlide);
	
	var _imagesCharactersApprenticeHandsHips3Png = __webpack_require__(2364);
	
	var _imagesCharactersApprenticeHandsHips3Png2 = _interopRequireDefault(_imagesCharactersApprenticeHandsHips3Png);
	
	var _imagesCharactersApprenticeArmsFolded2Png = __webpack_require__(2359);
	
	var _imagesCharactersApprenticeArmsFolded2Png2 = _interopRequireDefault(_imagesCharactersApprenticeArmsFolded2Png);
	
	var _imagesCharactersApprenticesBackToBackPng = __webpack_require__(2367);
	
	var _imagesCharactersApprenticesBackToBackPng2 = _interopRequireDefault(_imagesCharactersApprenticesBackToBackPng);
	
	var _imagesCharactersEsmeralda_hands_out_weheyPng = __webpack_require__(431);
	
	var _imagesCharactersEsmeralda_hands_out_weheyPng2 = _interopRequireDefault(_imagesCharactersEsmeralda_hands_out_weheyPng);
	
	var _imagesCharactersIan_headshot_smilePng = __webpack_require__(887);
	
	var _imagesCharactersIan_headshot_smilePng2 = _interopRequireDefault(_imagesCharactersIan_headshot_smilePng);
	
	var _imagesCharactersSara_surprisedPng = __webpack_require__(889);
	
	var _imagesCharactersSara_surprisedPng2 = _interopRequireDefault(_imagesCharactersSara_surprisedPng);
	
	var _imagesCharactersSara_twist_hands_out_heyheyPng = __webpack_require__(2384);
	
	var _imagesCharactersSara_twist_hands_out_heyheyPng2 = _interopRequireDefault(_imagesCharactersSara_twist_hands_out_heyheyPng);
	
	var _imagesCharactersIan_pointing_upPng = __webpack_require__(2375);
	
	var _imagesCharactersIan_pointing_upPng2 = _interopRequireDefault(_imagesCharactersIan_pointing_upPng);
	
	var _imagesCharactersIan_pointing_leftPng = __webpack_require__(2374);
	
	var _imagesCharactersIan_pointing_leftPng2 = _interopRequireDefault(_imagesCharactersIan_pointing_leftPng);
	
	var _imagesCharactersIan_pointing_downPng = __webpack_require__(2373);
	
	var _imagesCharactersIan_pointing_downPng2 = _interopRequireDefault(_imagesCharactersIan_pointing_downPng);
	
	var _imagesCharactersSara_smilePng = __webpack_require__(2383);
	
	var _imagesCharactersSara_smilePng2 = _interopRequireDefault(_imagesCharactersSara_smilePng);
	
	var _imagesCharactersSara_humphPng = __webpack_require__(2382);
	
	var _imagesCharactersSara_humphPng2 = _interopRequireDefault(_imagesCharactersSara_humphPng);
	
	var _imagesCharactersIan_sara_lean_questioningPng = __webpack_require__(888);
	
	var _imagesCharactersIan_sara_lean_questioningPng2 = _interopRequireDefault(_imagesCharactersIan_sara_lean_questioningPng);
	
	var _imagesCharactersIan_sidePng = __webpack_require__(2380);
	
	var _imagesCharactersIan_sidePng2 = _interopRequireDefault(_imagesCharactersIan_sidePng);
	
	var _helpersMarkdownScript = __webpack_require__(9);
	
	var _helpersMarkdownScript2 = _interopRequireDefault(_helpersMarkdownScript);
	
	var _level1a_teamBrainstormMd = __webpack_require__(1696);
	
	var _level1a_teamBrainstormMd2 = _interopRequireDefault(_level1a_teamBrainstormMd);
	
	var _level1a_teamBrainstormFr_CAMd = __webpack_require__(1695);
	
	var _level1a_teamBrainstormFr_CAMd2 = _interopRequireDefault(_level1a_teamBrainstormFr_CAMd);
	
	var _level1b_writePoemRapMd = __webpack_require__(1698);
	
	var _level1b_writePoemRapMd2 = _interopRequireDefault(_level1b_writePoemRapMd);
	
	var _level1b_writePoemRapFr_CAMd = __webpack_require__(1697);
	
	var _level1b_writePoemRapFr_CAMd2 = _interopRequireDefault(_level1b_writePoemRapFr_CAMd);
	
	var _level2_groupDrawingMd = __webpack_require__(1700);
	
	var _level2_groupDrawingMd2 = _interopRequireDefault(_level2_groupDrawingMd);
	
	var _level2_groupDrawingFr_CAMd = __webpack_require__(1699);
	
	var _level2_groupDrawingFr_CAMd2 = _interopRequireDefault(_level2_groupDrawingFr_CAMd);
	
	var _level3_posterMd = __webpack_require__(1702);
	
	var _level3_posterMd2 = _interopRequireDefault(_level3_posterMd);
	
	var _level3_posterFr_CAMd = __webpack_require__(1701);
	
	var _level3_posterFr_CAMd2 = _interopRequireDefault(_level3_posterFr_CAMd);
	
	var _level4_skitMd = __webpack_require__(1704);
	
	var _level4_skitMd2 = _interopRequireDefault(_level4_skitMd);
	
	var _level4_skitFr_CAMd = __webpack_require__(1703);
	
	var _level4_skitFr_CAMd2 = _interopRequireDefault(_level4_skitFr_CAMd);
	
	var markdownFileLevel1a = (0, _helpersI18n.i18nData)({
	  en: new _helpersMarkdownScript2['default'](_level1a_teamBrainstormMd2['default']),
	  fr_CA: new _helpersMarkdownScript2['default'](_level1a_teamBrainstormFr_CAMd2['default'])
	});
	var markdownFileLevel1b = (0, _helpersI18n.i18nData)({
	  en: new _helpersMarkdownScript2['default'](_level1b_writePoemRapMd2['default']),
	  fr_CA: new _helpersMarkdownScript2['default'](_level1b_writePoemRapFr_CAMd2['default'])
	});
	var markdownFileLevel2 = (0, _helpersI18n.i18nData)({
	  en: new _helpersMarkdownScript2['default'](_level2_groupDrawingMd2['default']),
	  fr_CA: new _helpersMarkdownScript2['default'](_level2_groupDrawingFr_CAMd2['default'])
	});
	var markdownFileLevel3 = (0, _helpersI18n.i18nData)({
	  en: new _helpersMarkdownScript2['default'](_level3_posterMd2['default']),
	  fr_CA: new _helpersMarkdownScript2['default'](_level3_posterFr_CAMd2['default'])
	});
	var markdownFileLevel4 = (0, _helpersI18n.i18nData)({
	  en: new _helpersMarkdownScript2['default'](_level4_skitMd2['default']),
	  fr_CA: new _helpersMarkdownScript2['default'](_level4_skitFr_CAMd2['default'])
	});
	
	var levels = {
	  '1a': { md: markdownFileLevel1a },
	  '1b': { md: markdownFileLevel1b },
	  '2': { md: markdownFileLevel2 },
	  '3': { md: markdownFileLevel3 },
	  '4': { md: markdownFileLevel4 }
	};
	
	function preloadClassActivity() {
	  (0, _spectaclePpa.preloader)([_imagesCharactersEsmeralda_hands_out_weheyPng2['default'], _imagesCharactersIan_headshot_smilePng2['default'], _imagesCharactersApprenticeHandsHips3Png2['default'], _imagesCharactersApprenticeArmsFolded2Png2['default'], _imagesCharactersApprenticesBackToBackPng2['default'], _imagesCharactersSara_surprisedPng2['default'], _imagesCharactersSara_twist_hands_out_heyheyPng2['default'], _imagesCharactersIan_pointing_upPng2['default'], _imagesCharactersIan_pointing_leftPng2['default'], _imagesCharactersIan_pointing_downPng2['default'], _imagesCharactersSara_smilePng2['default'], _imagesCharactersSara_humphPng2['default'], _imagesCharactersIan_sara_lean_questioningPng2['default'], _imagesCharactersIan_sidePng2['default']]);
	}
	
	function sizzle(level, regionData, md) {
	  return (0, _baseSlidesBalloonSlide2['default'])({
	    id: 'sizzle',
	    characterSide: 'left',
	    characterImage: _imagesCharactersApprenticeHandsHips3Png2['default'],
	    notes: md.getSubSectionAsHtml('Sizzle', 'Notes', false, regionData),
	    html: md.getSubSectionAsHtml('Sizzle', 'Content', false, regionData)
	  });
	}
	
	function instructions(level, regionData, md) {
	  return (0, _baseSlidesBalloonSlide2['default'])({
	    id: 'instructions',
	    characterSide: 'right',
	    characterImage: _imagesCharactersApprenticeArmsFolded2Png2['default'],
	    notes: md.getSubSectionAsHtml('Instructions', 'Notes', false, regionData),
	    html: md.getSubSectionAsHtml('Instructions', 'Content', false, regionData)
	  });
	}
	
	function scoring(level, regionData, md) {
	  return (0, _baseSlidesBalloonSlide2['default'])({
	    id: 'scoring',
	    characterSide: 'right',
	    characterImage: _imagesCharactersApprenticesBackToBackPng2['default'],
	    notes: md.getSubSectionAsHtml('Scoring', 'Notes', false, regionData),
	    html: md.getSubSectionAsHtml('Scoring', 'Content', false, regionData)
	  });
	}
	
	function level1a(regionData, i18n) {
	  // Group drawing
	  var level = '1a';
	  var md = i18n(levels[level].md);
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'class-activity-' + level },
	    sizzle(level, regionData, md),
	    instructions(level, regionData, md)
	  );
	}
	
	function level1b(regionData, i18n) {
	  // Group drawing
	  var level = '1b';
	  var md = i18n(levels[level].md);
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'class-activity-' + level },
	    sizzle(level, regionData, md),
	    instructions(level, regionData, md),
	    scoring(level, regionData, md)
	  );
	}
	
	function level2(regionData, i18n) {
	  // Popcorn Joys
	  var level = '2';
	  var md = i18n(levels[level].md);
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'class-activity-' + level },
	    sizzle(level, regionData, md),
	    instructions(level, regionData, md),
	    scoring(level, regionData, md)
	  );
	}
	
	function level3(regionData, i18n) {
	  // Waste math
	  var level = '3';
	  var md = i18n(levels[level].md);
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'class-activity-' + level },
	    sizzle(level, regionData, md),
	    instructions(level, regionData, md)
	  );
	}
	
	function level4(regionData, i18n) {
	  // Eat me first box
	  var level = '4';
	  var md = i18n(levels[level].md);
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'class-activity-' + level },
	    sizzle(level, regionData, md),
	    instructions(level, regionData, md)
	  );
	}
	
	function classActivitySection(_ref) {
	  var level = _ref.level;
	  var subActivity = _ref.subActivity;
	  var regionData = _ref.regionData;
	  var i18n = _ref.i18n;
	
	  switch ('' + level + (subActivity ? subActivity : '')) {
	    case '1a':
	      return level1a(regionData, i18n);
	    case '1b':
	      return level1b(regionData, i18n);
	    case '2':
	      return level2(regionData, i18n);
	    case '3':
	      return level3(regionData, i18n);
	    case '4':
	      return level4(regionData, i18n);
	    default:
	      return (0, _baseSlidesHeadingSlide2['default'])({ heading: 'Unknown' });
	  }
	}
	
	exports['default'] = classActivitySection;
	/* Sizzle */ /* Instructions */ /* Sizzle */ /* Instructions */ /* Scoring */ /* Sizzle */ /* Instructions */ /* Scoring */ /* Sizzle */ /* Instructions */ /* Sizzle */ /* Instructions */

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _taggedTemplateLiteral = __webpack_require__(28)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.preloadFinish = preloadFinish;
	
	var _templateObject = _taggedTemplateLiteral(['Level ', ' Finished'], ['Level ', ' Finished']),
	    _templateObject2 = _taggedTemplateLiteral(['level ', ' of 4'], ['level ', ' of 4']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _helpersI18n = __webpack_require__(14);
	
	var _componentsCompleteLevelButton = __webpack_require__(44);
	
	var _componentsCompleteLevelButton2 = _interopRequireDefault(_componentsCompleteLevelButton);
	
	var _baseSlidesBalloonSlide = __webpack_require__(67);
	
	var _baseSlidesBalloonSlide2 = _interopRequireDefault(_baseSlidesBalloonSlide);
	
	var _imagesCharactersIan_sara_lean_smilePng = __webpack_require__(2376);
	
	var _imagesCharactersIan_sara_lean_smilePng2 = _interopRequireDefault(_imagesCharactersIan_sara_lean_smilePng);
	
	var _imagesCharactersIan_sara_lean_questioningPng = __webpack_require__(888);
	
	var _imagesCharactersIan_sara_lean_questioningPng2 = _interopRequireDefault(_imagesCharactersIan_sara_lean_questioningPng);
	
	var _imagesCharactersIan_sara_sidePng = __webpack_require__(2377);
	
	var _imagesCharactersIan_sara_sidePng2 = _interopRequireDefault(_imagesCharactersIan_sara_sidePng);
	
	var _helpersMarkdownScript = __webpack_require__(9);
	
	var _helpersMarkdownScript2 = _interopRequireDefault(_helpersMarkdownScript);
	
	var _finishMd = __webpack_require__(1712);
	
	var _finishMd2 = _interopRequireDefault(_finishMd);
	
	var _finishFr_CAMd = __webpack_require__(1711);
	
	var _finishFr_CAMd2 = _interopRequireDefault(_finishFr_CAMd);
	
	var _level1_completeSvg = __webpack_require__(2403);
	
	var _level1_completeSvg2 = _interopRequireDefault(_level1_completeSvg);
	
	var _level2_completeSvg = __webpack_require__(2404);
	
	var _level2_completeSvg2 = _interopRequireDefault(_level2_completeSvg);
	
	var _level3_completeSvg = __webpack_require__(2405);
	
	var _level3_completeSvg2 = _interopRequireDefault(_level3_completeSvg);
	
	var _level4_completeSvg = __webpack_require__(2406);
	
	var _level4_completeSvg2 = _interopRequireDefault(_level4_completeSvg);
	
	var md = (0, _helpersI18n.i18nData)({
	  en: new _helpersMarkdownScript2['default'](_finishMd2['default']),
	  fr_CA: new _helpersMarkdownScript2['default'](_finishFr_CAMd2['default'])
	});
	
	var levels = {
	  '1': { img: _level1_completeSvg2['default'] },
	  '2': { img: _level2_completeSvg2['default'] },
	  '3': { img: _level3_completeSvg2['default'] },
	  '4': { img: _level4_completeSvg2['default'] }
	};
	
	function preloadFinish() {
	  (0, _spectaclePpa.preloader)([_imagesCharactersIan_sara_lean_smilePng2['default'], _imagesCharactersIan_sara_sidePng2['default'], _level1_completeSvg2['default'], _level2_completeSvg2['default'], _level3_completeSvg2['default'], _level4_completeSvg2['default']]);
	}
	
	function finishSection(_ref) {
	  var level = _ref.level;
	  var regionData = _ref.regionData;
	  var _ = _ref.i18n;
	
	  var md_i18n = _(md);
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'finish' },
	    level !== 4 && (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'scoreboard-recap',
	      characterSide: 'left',
	      characterImage: _imagesCharactersIan_sara_sidePng2['default'],
	      html: md_i18n.getSubSectionAsHtml('Scoreboard Recap', 'Content', false, regionData),
	      notes: md_i18n.getSubSectionAsHtml('Scoreboard Recap', 'Notes', false, regionData)
	    }),
	    level !== 4 && (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'earn-more-points',
	      characterSide: 'right',
	      characterImage: _imagesCharactersIan_sara_lean_questioningPng2['default'],
	      html: md_i18n.getSubSectionAsHtml('Earn More Points', 'Content', false, regionData),
	      notes: md_i18n.getSubSectionAsHtml('Earn More Points', 'Notes', false, regionData)
	    }),
	    level !== 4 && (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'farewell',
	      characterSide: 'left',
	      characterImage: _imagesCharactersIan_sara_lean_smilePng2['default'],
	      html: md_i18n.getSubSectionAsHtml('Farewell', 'Content', false, regionData),
	      notes: md_i18n.getSubSectionAsHtml('Farewell', 'Notes', false, regionData)
	    }),
	    level === 4 && (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'farewell',
	      characterSide: 'left',
	      characterImage: _imagesCharactersIan_sara_lean_smilePng2['default'],
	      html: md_i18n.getSubSectionAsHtml('Farewell Last', 'Content', false, regionData),
	      notes: md_i18n.getSubSectionAsHtml('Farewell Last', 'Notes', false, regionData)
	    }),
	    _react2['default'].createElement(
	      _spectaclePpa.Slide,
	      {
	        id: 'level-completed',
	        notes: '<h2>' + _(_templateObject, level) + '</h2>',
	        bgColor: 'transparent',
	        finish: true },
	      _react2['default'].createElement(
	        'div',
	        { className: 'level-complete' },
	        _react2['default'].createElement(
	          'div',
	          { className: 'level-complete-content' },
	          _react2['default'].createElement(
	            'figure',
	            { className: 'level-complete-graphic' },
	            _react2['default'].createElement('img', { src: levels[level].img })
	          ),
	          _react2['default'].createElement(
	            _spectaclePpa.Heading,
	            { size: 2 },
	            _("You've finished")
	          ),
	          _react2['default'].createElement(
	            _spectaclePpa.Heading,
	            { size: 2 },
	            _(_templateObject2, level)
	          ),
	          _react2['default'].createElement(_componentsCompleteLevelButton2['default'], null)
	        )
	      )
	    )
	  );
	}
	
	exports['default'] = finishSection;
	/* Scoreboard Recap */ /* Earn More Points */ /* Farewell */ /* Farewell */ /* Level complete */

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.preloadMissionReport = preloadMissionReport;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _helpersI18n = __webpack_require__(14);
	
	var _componentsMissionReport = __webpack_require__(76);
	
	var _componentsMissionReport2 = _interopRequireDefault(_componentsMissionReport);
	
	var _baseSlidesVideoSlide = __webpack_require__(59);
	
	var _baseSlidesVideoSlide2 = _interopRequireDefault(_baseSlidesVideoSlide);
	
	var _baseSlidesBalloonSlide = __webpack_require__(70);
	
	var _baseSlidesBalloonSlide2 = _interopRequireDefault(_baseSlidesBalloonSlide);
	
	var _imagesCharactersEsmeralda_hands_out_weheyPng = __webpack_require__(440);
	
	var _imagesCharactersEsmeralda_hands_out_weheyPng2 = _interopRequireDefault(_imagesCharactersEsmeralda_hands_out_weheyPng);
	
	var _imagesCharactersEsmeralda_hands_out_up_closePng = __webpack_require__(2443);
	
	var _imagesCharactersEsmeralda_hands_out_up_closePng2 = _interopRequireDefault(_imagesCharactersEsmeralda_hands_out_up_closePng);
	
	var _imagesCharactersEsmeralda_goober_goofy_smilePng = __webpack_require__(438);
	
	var _imagesCharactersEsmeralda_goober_goofy_smilePng2 = _interopRequireDefault(_imagesCharactersEsmeralda_goober_goofy_smilePng);
	
	var _imagesCharactersIan_headshot_smilePng = __webpack_require__(2444);
	
	var _imagesCharactersIan_headshot_smilePng2 = _interopRequireDefault(_imagesCharactersIan_headshot_smilePng);
	
	var _imagesCharactersEsmeralda_goober_proudPng = __webpack_require__(439);
	
	var _imagesCharactersEsmeralda_goober_proudPng2 = _interopRequireDefault(_imagesCharactersEsmeralda_goober_proudPng);
	
	var _helpersMarkdownScript = __webpack_require__(9);
	
	var _helpersMarkdownScript2 = _interopRequireDefault(_helpersMarkdownScript);
	
	var _level3_operationDarkroomMd = __webpack_require__(1765);
	
	var _level3_operationDarkroomMd2 = _interopRequireDefault(_level3_operationDarkroomMd);
	
	var _level3_operationDarkroomFr_CAMd = __webpack_require__(1764);
	
	var _level3_operationDarkroomFr_CAMd2 = _interopRequireDefault(_level3_operationDarkroomFr_CAMd);
	
	var _level4_operationShowerPowerMd = __webpack_require__(1767);
	
	var _level4_operationShowerPowerMd2 = _interopRequireDefault(_level4_operationShowerPowerMd);
	
	var _level4_operationShowerPowerFr_CAMd = __webpack_require__(1766);
	
	var _level4_operationShowerPowerFr_CAMd2 = _interopRequireDefault(_level4_operationShowerPowerFr_CAMd);
	
	var _level5_operationKeepCarCoolMd = __webpack_require__(1769);
	
	var _level5_operationKeepCarCoolMd2 = _interopRequireDefault(_level5_operationKeepCarCoolMd);
	
	var _level5_operationKeepCarCoolFr_CAMd = __webpack_require__(1768);
	
	var _level5_operationKeepCarCoolFr_CAMd2 = _interopRequireDefault(_level5_operationKeepCarCoolFr_CAMd);
	
	var _level6_operationGoCarFreeMd = __webpack_require__(1771);
	
	var _level6_operationGoCarFreeMd2 = _interopRequireDefault(_level6_operationGoCarFreeMd);
	
	var _level6_operationGoCarFreeFr_CAMd = __webpack_require__(1770);
	
	var _level6_operationGoCarFreeFr_CAMd2 = _interopRequireDefault(_level6_operationGoCarFreeFr_CAMd);
	
	var _imagesLevel2_startPng = __webpack_require__(441);
	
	var _imagesLevel2_startPng2 = _interopRequireDefault(_imagesLevel2_startPng);
	
	var _imagesLevel3_startPng = __webpack_require__(442);
	
	var _imagesLevel3_startPng2 = _interopRequireDefault(_imagesLevel3_startPng);
	
	var _imagesLevel4_startPng = __webpack_require__(443);
	
	var _imagesLevel4_startPng2 = _interopRequireDefault(_imagesLevel4_startPng);
	
	var _imagesLevel5_startPng = __webpack_require__(444);
	
	var _imagesLevel5_startPng2 = _interopRequireDefault(_imagesLevel5_startPng);
	
	var markdownFileLevel3 = (0, _helpersI18n.i18nData)({
	  en: new _helpersMarkdownScript2['default'](_level3_operationDarkroomMd2['default']),
	  fr_CA: new _helpersMarkdownScript2['default'](_level3_operationDarkroomFr_CAMd2['default'])
	});
	var markdownFileLevel4 = (0, _helpersI18n.i18nData)({
	  en: new _helpersMarkdownScript2['default'](_level4_operationShowerPowerMd2['default']),
	  fr_CA: new _helpersMarkdownScript2['default'](_level4_operationShowerPowerFr_CAMd2['default'])
	});
	var markdownFileLevel5 = (0, _helpersI18n.i18nData)({
	  en: new _helpersMarkdownScript2['default'](_level5_operationKeepCarCoolMd2['default']),
	  fr_CA: new _helpersMarkdownScript2['default'](_level5_operationKeepCarCoolFr_CAMd2['default'])
	});
	var markdownFileLevel6 = (0, _helpersI18n.i18nData)({
	  en: new _helpersMarkdownScript2['default'](_level6_operationGoCarFreeMd2['default']),
	  fr_CA: new _helpersMarkdownScript2['default'](_level6_operationGoCarFreeFr_CAMd2['default'])
	});
	
	var levels = {
	  '2': { img: _imagesLevel2_startPng2['default'] },
	  '3': { md: markdownFileLevel3, img: _imagesLevel3_startPng2['default'] },
	  '4': { md: markdownFileLevel4, img: _imagesLevel4_startPng2['default'] },
	  '5': { md: markdownFileLevel5, img: _imagesLevel5_startPng2['default'] },
	  '6': { md: markdownFileLevel6 }
	};
	
	function preloadMissionReport() {
	  (0, _spectaclePpa.preloader)([_imagesCharactersEsmeralda_hands_out_weheyPng2['default'], _imagesCharactersEsmeralda_hands_out_up_closePng2['default'], _imagesCharactersEsmeralda_goober_goofy_smilePng2['default'], _imagesCharactersIan_headshot_smilePng2['default'], _imagesCharactersEsmeralda_goober_proudPng2['default'], _imagesLevel2_startPng2['default'], _imagesLevel3_startPng2['default'], _imagesLevel4_startPng2['default'], _imagesLevel5_startPng2['default']]);
	}
	
	function missionReportSection(_ref) {
	  var level = _ref.level;
	  var regionData = _ref.regionData;
	  var _ = _ref.i18n;
	
	  var md = _(levels[level].md);
	  var missionReportQuestions = md.getQuestions('Questions', 'Content', regionData);
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'mission-report' },
	    (0, _baseSlidesVideoSlide2['default'])({
	      id: 'video',
	      youTubeId: md.getSectionMetadata('Intro Video', 'YouTube', regionData),
	      notes: md.getSubSectionAsHtml('Intro Video', 'Notes', false, regionData)
	    }),
	    (level === 2 || level === 4 || level === 6) && (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'scoring',
	      characterSide: 'left',
	      characterImage: _imagesCharactersEsmeralda_hands_out_weheyPng2['default'],
	      html: md.getSubSectionAsHtml('Scoring', 'Content', false, regionData),
	      notes: md.getSubSectionAsHtml('Scoring', 'Notes', false, regionData)
	    }),
	    (level === 3 || level === 5) && (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'scoring',
	      characterSide: 'right',
	      characterImage: _imagesCharactersEsmeralda_hands_out_up_closePng2['default'],
	      html: md.getSubSectionAsHtml('Scoring', 'Content', false, regionData),
	      notes: md.getSubSectionAsHtml('Scoring', 'Notes', false, regionData)
	    }),
	    (level === 2 || level === 4 || level === 6) && (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'instructions',
	      characterSide: 'right',
	      characterImage: _imagesCharactersEsmeralda_hands_out_up_closePng2['default'],
	      html: md.getSubSectionAsHtml('Instructions', 'Content', false, regionData),
	      notes: md.getSubSectionAsHtml('Instructions', 'Notes', false, regionData)
	    }),
	    (level === 3 || level === 5) && (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'instructions',
	      characterSide: 'left',
	      characterImage: _imagesCharactersEsmeralda_hands_out_weheyPng2['default'],
	      html: md.getSubSectionAsHtml('Instructions', 'Content', false, regionData),
	      notes: md.getSubSectionAsHtml('Instructions', 'Notes', false, regionData)
	    }),
	    _react2['default'].createElement(
	      _spectaclePpa.Slide,
	      {
	        id: 'report',
	        bgColor: 'black',
	        missionReportQuestions: missionReportQuestions },
	      _react2['default'].createElement(
	        'div',
	        {
	          className: 'ui-slide mission-report-level-' + (level - 1) },
	        _react2['default'].createElement(
	          'header',
	          {
	            className: 'level-header' },
	          _react2['default'].createElement(
	            'figure',
	            { className: 'level-header-thumb' },
	            _react2['default'].createElement('img', { src: levels[level - 1].img })
	          ),
	          _react2['default'].createElement(
	            _spectaclePpa.Heading,
	            { size: 2 },
	            _('Mission Report:'),
	            _react2['default'].createElement('br', null),
	            md.getSectionMetadata('Mission Report', 'Title', regionData)
	          )
	        ),
	        _react2['default'].createElement(
	          'section',
	          {
	            className: 'mission-report-form' },
	          _react2['default'].createElement(_componentsMissionReport2['default'], { missionReportQuestions: missionReportQuestions })
	        )
	      )
	    ),
	    (level === 2 || level === 4 || level === 6) && (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'impact',
	      characterSide: 'right',
	      characterImage: _imagesCharactersEsmeralda_goober_proudPng2['default'],
	      html: md.getSubSectionAsHtml('Impact', 'Content', false, regionData),
	      notes: md.getSubSectionAsHtml('Impact', 'Notes', false, regionData)
	    }),
	    (level === 3 || level === 5) && (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'impact',
	      characterSide: 'right',
	      characterImage: _imagesCharactersEsmeralda_goober_goofy_smilePng2['default'],
	      html: md.getSubSectionAsHtml('Impact', 'Content', false, regionData),
	      notes: md.getSubSectionAsHtml('Impact', 'Notes', false, regionData)
	    }),
	    (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'class-discussion',
	      characterSide: 'left',
	      characterImage: _imagesCharactersIan_headshot_smilePng2['default'],
	      html: md.getSubSectionAsHtml('Class Discussion', 'Content', false, regionData),
	      notes: md.getSubSectionAsHtml('Class Discussion', 'Notes', false, regionData)
	    })
	  );
	}
	
	exports['default'] = missionReportSection;
	/* Sara and Ian introduce mission report */ /* Scoring levels 2, 4 & 6 */ /* Scoring levels 3 & 5 */ /* Instructions levels 2, 4 & 6 */ /* Instructions 3 & 5 */ /* Mission Reporting Screen */ /* Impact screen for levels 2,4 & 6 */ /* Impact screen for levels 3 & 5 */ /* Class Discussion */

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _taggedTemplateLiteral = __webpack_require__(28)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.preloadMissionAssignment = preloadMissionAssignment;
	
	var _templateObject = _taggedTemplateLiteral(['Mission ', ':<br/> ', ''], ['Mission ', ':<br/> ', '']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _helpersI18n = __webpack_require__(14);
	
	var _baseSlidesHeadingSlide = __webpack_require__(170);
	
	var _baseSlidesHeadingSlide2 = _interopRequireDefault(_baseSlidesHeadingSlide);
	
	var _baseSlidesBalloonSlide = __webpack_require__(70);
	
	var _baseSlidesBalloonSlide2 = _interopRequireDefault(_baseSlidesBalloonSlide);
	
	var _baseSlidesVideoSlide = __webpack_require__(59);
	
	var _baseSlidesVideoSlide2 = _interopRequireDefault(_baseSlidesVideoSlide);
	
	var _imagesLogo_ppaPng = __webpack_require__(905);
	
	var _imagesLogo_ppaPng2 = _interopRequireDefault(_imagesLogo_ppaPng);
	
	var _imagesCharactersEsPowerStancePng = __webpack_require__(2441);
	
	var _imagesCharactersEsPowerStancePng2 = _interopRequireDefault(_imagesCharactersEsPowerStancePng);
	
	var _imagesCharactersEsmeralda_hands_out_weheyPng = __webpack_require__(440);
	
	var _imagesCharactersEsmeralda_hands_out_weheyPng2 = _interopRequireDefault(_imagesCharactersEsmeralda_hands_out_weheyPng);
	
	var _helpersMarkdownScript = __webpack_require__(9);
	
	var _helpersMarkdownScript2 = _interopRequireDefault(_helpersMarkdownScript);
	
	var _level2_operationDarkroomMd = __webpack_require__(1805);
	
	var _level2_operationDarkroomMd2 = _interopRequireDefault(_level2_operationDarkroomMd);
	
	var _level2_operationDarkroomFr_CAMd = __webpack_require__(1804);
	
	var _level2_operationDarkroomFr_CAMd2 = _interopRequireDefault(_level2_operationDarkroomFr_CAMd);
	
	var _level3_operationShowerPowerMd = __webpack_require__(1807);
	
	var _level3_operationShowerPowerMd2 = _interopRequireDefault(_level3_operationShowerPowerMd);
	
	var _level3_operationShowerPowerFr_CAMd = __webpack_require__(1806);
	
	var _level3_operationShowerPowerFr_CAMd2 = _interopRequireDefault(_level3_operationShowerPowerFr_CAMd);
	
	var _level4_operationKeepCarCoolMd = __webpack_require__(1809);
	
	var _level4_operationKeepCarCoolMd2 = _interopRequireDefault(_level4_operationKeepCarCoolMd);
	
	var _level4_operationKeepCarCoolFr_CAMd = __webpack_require__(1808);
	
	var _level4_operationKeepCarCoolFr_CAMd2 = _interopRequireDefault(_level4_operationKeepCarCoolFr_CAMd);
	
	var _level5_operationGoCarFreeMd = __webpack_require__(1811);
	
	var _level5_operationGoCarFreeMd2 = _interopRequireDefault(_level5_operationGoCarFreeMd);
	
	var _level5_operationGoCarFreeFr_CAMd = __webpack_require__(1810);
	
	var _level5_operationGoCarFreeFr_CAMd2 = _interopRequireDefault(_level5_operationGoCarFreeFr_CAMd);
	
	var markdownFileLevel2 = (0, _helpersI18n.i18nData)({
	  en: new _helpersMarkdownScript2['default'](_level2_operationDarkroomMd2['default']),
	  fr_CA: new _helpersMarkdownScript2['default'](_level2_operationDarkroomFr_CAMd2['default'])
	});
	var markdownFileLevel3 = (0, _helpersI18n.i18nData)({
	  en: new _helpersMarkdownScript2['default'](_level3_operationShowerPowerMd2['default']),
	  fr_CA: new _helpersMarkdownScript2['default'](_level3_operationShowerPowerFr_CAMd2['default'])
	});
	var markdownFileLevel4 = (0, _helpersI18n.i18nData)({
	  en: new _helpersMarkdownScript2['default'](_level4_operationKeepCarCoolMd2['default']),
	  fr_CA: new _helpersMarkdownScript2['default'](_level4_operationKeepCarCoolFr_CAMd2['default'])
	});
	var markdownFileLevel5 = (0, _helpersI18n.i18nData)({
	  en: new _helpersMarkdownScript2['default'](_level5_operationGoCarFreeMd2['default']),
	  fr_CA: new _helpersMarkdownScript2['default'](_level5_operationGoCarFreeFr_CAMd2['default'])
	});
	
	var levels = {
	  '2': { md: markdownFileLevel2 },
	  '3': { md: markdownFileLevel3 },
	  '4': { md: markdownFileLevel4 },
	  '5': { md: markdownFileLevel5 }
	};
	
	function preloadMissionAssignment() {
	  (0, _spectaclePpa.preloader)([_imagesLogo_ppaPng2['default'], _imagesCharactersEsPowerStancePng2['default'], _imagesCharactersEsmeralda_hands_out_weheyPng2['default']]);
	}
	
	function missionAssignmentSection(_ref) {
	  var level = _ref.level;
	  var regionData = _ref.regionData;
	  var i18n = _ref.i18n;
	
	  var md = i18n(levels[level].md);
	  var missionTitle = md.getSectionMetadata('Mission Assignment', 'Title', regionData);
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'mission-assignment' },
	    (0, _baseSlidesHeadingSlide2['default'])({
	      id: 'sizzle',
	      beforeImage: _imagesLogo_ppaPng2['default'],
	      subHeading: i18n(_templateObject, level - 1, missionTitle),
	      notes: md.getSubSectionAsHtml('Mission Assignment', 'Notes', false, regionData),
	      bgColor: 'black'
	    }),
	    (0, _baseSlidesVideoSlide2['default'])({
	      id: 'mission-intro-video',
	      notes: md.getSubSectionAsHtml('Mission Intro Video', 'Notes', false, regionData),
	      youTubeId: md.getSectionMetadata('Mission Intro Video', 'YouTube', regionData)
	    }),
	    (level === 2 || level === 4) && (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'instructions',
	      characterSide: 'right',
	      characterImage: _imagesCharactersEsPowerStancePng2['default'],
	      notes: md.getSubSectionAsHtml('Instructions', 'Notes', false, regionData),
	      html: md.getSubSectionAsHtml('Instructions', 'Content', false, regionData)
	    }),
	    (level === 3 || level === 5) && (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'instructions',
	      characterSide: 'right',
	      characterImage: _imagesCharactersEsmeralda_hands_out_weheyPng2['default'],
	      notes: md.getSubSectionAsHtml('Instructions', 'Notes', false, regionData),
	      html: md.getSubSectionAsHtml('Instructions', 'Content', false, regionData)
	    })
	  );
	}
	
	exports['default'] = missionAssignmentSection;
	/* Sizzle */ /* Mission Intro Video*/ /* Mission Instructions levels 2 & 4 */ /* Mission Instructions levels 3 & 5 */

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _baseSlidesVideoSlide = __webpack_require__(43);
	
	var _baseSlidesVideoSlide2 = _interopRequireDefault(_baseSlidesVideoSlide);
	
	var _helpersMarkdownScript = __webpack_require__(9);
	
	var _helpersMarkdownScript2 = _interopRequireDefault(_helpersMarkdownScript);
	
	var _mmeMd = __webpack_require__(1841);
	
	var _mmeMd2 = _interopRequireDefault(_mmeMd);
	
	var md = new _helpersMarkdownScript2['default'](_mmeMd2['default']);
	
	function mmeSection(_ref) {
	  var level = _ref.level;
	  var regionData = _ref.regionData;
	
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'mme' },
	    (0, _baseSlidesVideoSlide2['default'])({
	      id: 'video',
	      notes: md.getSubSectionAsHtml('MME Level ' + level, 'Notes', false, regionData),
	      youTubeId: md.getSectionMetadata('MME Level ' + level, 'YouTube', regionData)
	    })
	  );
	}
	
	exports['default'] = mmeSection;
	module.exports = exports['default'];
	/* MME segment */

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _historyLibCreateBrowserHistory = __webpack_require__(534);
	
	var _historyLibCreateBrowserHistory2 = _interopRequireDefault(_historyLibCreateBrowserHistory);
	
	var history = (0, _historyLibCreateBrowserHistory2['default'])();
	
	exports['default'] = history;
	module.exports = exports['default'];

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _Promise = __webpack_require__(33)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.asyncAjax = asyncAjax;
	
	exports['default'] = function (url, callback, data) {
	  try {
	    (function () {
	      var x = new (window.XMLHttpRequest || ActiveXObject)('MSXML2.XMLHTTP.3.0');
	      x.open(data ? 'POST' : 'GET', url, 1);
	      //Don't set custom headers to avoid CORS pre-flight request
	      x.onreadystatechange = function () {
	        return x.readyState > 3 && callback && callback(x.responseText, x);
	      };
	      x.send(data);
	    })();
	  } catch (e) {
	    window.console && console.log(e);
	  }
	};
	
	function asyncAjax(url, data) {
	  return new _Promise(function (resolve, reject) {
	    try {
	      (function () {
	        var x = new (window.XMLHttpRequest || ActiveXObject)('MSXML2.XMLHTTP.3.0');
	        x.open(data ? 'POST' : 'GET', url, 1);
	        //Don't set custom headers to avoid CORS pre-flight request
	        x.onreadystatechange = function () {
	          return x.readyState > 3 && resolve && resolve(x);
	        };
	        x.send(data);
	      })();
	    } catch (e) {
	      reject(e);
	    }
	  });
	}

/***/ }),
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */
/***/ (function(module, exports) {

	"use strict";
	
	var globalSymbolRegistryList = {};
	
	// Aliases & Helpers
	var make = Object.create;
	var defProps = Object.defineProperties;
	var defProp = Object.defineProperty;
	var defValue = function (value) {
	  var opts = arguments[1] === undefined ? {} : arguments[1];
	  return {
	    value: value,
	    configurable: !!opts.c,
	    writable: !!opts.w,
	    enumerable: !!opts.e
	  };
	};
	var isSymbol = function (symbol) {
	  return symbol && symbol[xSymbol.toStringTag] === "Symbol";
	};
	
	var supportsAccessors = undefined;
	try {
	  var x = defProp({}, "y", { get: function () {
	      return 1;
	    } });
	  supportsAccessors = x.y === 1;
	} catch (e) {
	  supportsAccessors = false;
	}
	
	var id = {};
	var uid = function (desc) {
	  desc = String(desc);
	  var x = "";
	  var i = 0;
	  while (id[desc + x]) {
	    x = i += 1;
	  }
	  id[desc + x] = 1;
	
	  var tag = "Symbol(" + desc + "" + x + ")";
	
	  /* istanbul ignore else */
	  if (supportsAccessors) {
	    // Make the symbols hidden to pre-es6 code
	    defProp(Object.prototype, tag, {
	      get: undefined,
	      set: function (value) {
	        defProp(this, tag, defValue(value, { c: true, w: true }));
	      },
	      configurable: true,
	      enumerable: false
	    });
	  }
	
	  return tag;
	};
	
	// The base symbol
	var SymbolProto = make(null);
	
	// 19.4.1.1
	function xSymbol(descString) {
	  if (this instanceof xSymbol) {
	    throw new TypeError("Symbol is not a constructor");
	  }
	
	  descString = descString === undefined ? "" : String(descString);
	
	  var tag = uid(descString);
	
	  /* istanbul ignore next */
	  if (!supportsAccessors) {
	    return tag;
	  }
	
	  return make(SymbolProto, {
	    __description__: defValue(descString),
	    __tag__: defValue(tag)
	  });
	}
	
	defProps(xSymbol, {
	  // 19.4.2.1
	  "for": defValue(function (key) {
	    var stringKey = String(key);
	
	    if (globalSymbolRegistryList[stringKey]) {
	      return globalSymbolRegistryList[stringKey];
	    }
	
	    var symbol = xSymbol(stringKey);
	    globalSymbolRegistryList[stringKey] = symbol;
	
	    return symbol;
	  }),
	
	  // 19.4.2.5
	  keyFor: defValue(function (sym) {
	    if (supportsAccessors && !isSymbol(sym)) {
	      throw new TypeError("" + sym + " is not a symbol");
	    }
	
	    for (var key in globalSymbolRegistryList) {
	      if (globalSymbolRegistryList[key] === sym) {
	        return supportsAccessors ? globalSymbolRegistryList[key].__description__ : globalSymbolRegistryList[key].substr(7, globalSymbolRegistryList[key].length - 8);
	      }
	    }
	  })
	});
	
	// 6.1.5.1
	defProps(xSymbol, {
	  hasInstance: defValue(xSymbol("hasInstance")),
	  isConcatSpreadable: defValue(xSymbol("isConcatSpreadable")),
	  iterator: defValue(xSymbol("iterator")),
	  match: defValue(xSymbol("match")),
	  replace: defValue(xSymbol("replace")),
	  search: defValue(xSymbol("search")),
	  species: defValue(xSymbol("species")),
	  split: defValue(xSymbol("split")),
	  toPrimitive: defValue(xSymbol("toPrimitive")),
	  toStringTag: defValue(xSymbol("toStringTag")),
	  unscopables: defValue(xSymbol("unscopables"))
	});
	
	// 19.4.3
	defProps(SymbolProto, {
	  constructor: defValue(xSymbol),
	
	  // 19.4.3.2
	  toString: defValue(function () {
	    return this.__tag__;
	  }),
	
	  // 19.4.3.3
	  valueOf: defValue(function () {
	    return "Symbol(" + this.__description__ + ")";
	  })
	});
	
	// 19.4.3.5
	/* istanbul ignore else */
	if (supportsAccessors) {
	  defProp(SymbolProto, xSymbol.toStringTag, defValue("Symbol", { c: true }));
	}
	
	module.exports = typeof Symbol === "function" ? Symbol : xSymbol;
	


/***/ }),
/* 239 */,
/* 240 */,
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
	 * isMobile.js v0.3.9
	 *
	 * A simple library to detect Apple phones and tablets,
	 * Android phones and tablets, other mobile devices (like blackberry, mini-opera and windows phone),
	 * and any kind of seven inch device, via user agent sniffing.
	 *
	 * @author: Kai Mallea (kmallea@gmail.com)
	 *
	 * @license: http://creativecommons.org/publicdomain/zero/1.0/
	 */
	(function (global) {
	
	    var apple_phone         = /iPhone/i,
	        apple_ipod          = /iPod/i,
	        apple_tablet        = /iPad/i,
	        android_phone       = /(?=.*\bAndroid\b)(?=.*\bMobile\b)/i, // Match 'Android' AND 'Mobile'
	        android_tablet      = /Android/i,
	        amazon_phone        = /(?=.*\bAndroid\b)(?=.*\bSD4930UR\b)/i,
	        amazon_tablet       = /(?=.*\bAndroid\b)(?=.*\b(?:KFOT|KFTT|KFJWI|KFJWA|KFSOWI|KFTHWI|KFTHWA|KFAPWI|KFAPWA|KFARWI|KFASWI|KFSAWI|KFSAWA)\b)/i,
	        windows_phone       = /IEMobile/i,
	        windows_tablet      = /(?=.*\bWindows\b)(?=.*\bARM\b)/i, // Match 'Windows' AND 'ARM'
	        other_blackberry    = /BlackBerry/i,
	        other_blackberry_10 = /BB10/i,
	        other_opera         = /Opera Mini/i,
	        other_chrome        = /(CriOS|Chrome)(?=.*\bMobile\b)/i,
	        other_firefox       = /(?=.*\bFirefox\b)(?=.*\bMobile\b)/i, // Match 'Firefox' AND 'Mobile'
	        seven_inch = new RegExp(
	            '(?:' +         // Non-capturing group
	
	            'Nexus 7' +     // Nexus 7
	
	            '|' +           // OR
	
	            'BNTV250' +     // B&N Nook Tablet 7 inch
	
	            '|' +           // OR
	
	            'Kindle Fire' + // Kindle Fire
	
	            '|' +           // OR
	
	            'Silk' +        // Kindle Fire, Silk Accelerated
	
	            '|' +           // OR
	
	            'GT-P1000' +    // Galaxy Tab 7 inch
	
	            ')',            // End non-capturing group
	
	            'i');           // Case-insensitive matching
	
	    var match = function(regex, userAgent) {
	        return regex.test(userAgent);
	    };
	
	    var IsMobileClass = function(userAgent) {
	        var ua = userAgent || navigator.userAgent;
	        // Facebook mobile app's integrated browser adds a bunch of strings that
	        // match everything. Strip it out if it exists.
	        var tmp = ua.split('[FBAN');
	        if (typeof tmp[1] !== 'undefined') {
	            ua = tmp[0];
	        }
	
	        this.apple = {
	            phone:  match(apple_phone, ua),
	            ipod:   match(apple_ipod, ua),
	            tablet: !match(apple_phone, ua) && match(apple_tablet, ua),
	            device: match(apple_phone, ua) || match(apple_ipod, ua) || match(apple_tablet, ua)
	        };
	        this.amazon = {
	            phone:  match(amazon_phone, ua),
	            tablet: !match(amazon_phone, ua) && match(amazon_tablet, ua),
	            device: match(amazon_phone, ua) || match(amazon_tablet, ua)
	        };
	        this.android = {
	            phone:  match(amazon_phone, ua) || match(android_phone, ua),
	            tablet: !match(amazon_phone, ua) && !match(android_phone, ua) && (match(amazon_tablet, ua) || match(android_tablet, ua)),
	            device: match(amazon_phone, ua) || match(amazon_tablet, ua) || match(android_phone, ua) || match(android_tablet, ua)
	        };
	        this.windows = {
	            phone:  match(windows_phone, ua),
	            tablet: match(windows_tablet, ua),
	            device: match(windows_phone, ua) || match(windows_tablet, ua)
	        };
	        this.other = {
	            blackberry:   match(other_blackberry, ua),
	            blackberry10: match(other_blackberry_10, ua),
	            opera:        match(other_opera, ua),
	            firefox:      match(other_firefox, ua),
	            chrome:       match(other_chrome, ua),
	            device:       match(other_blackberry, ua) || match(other_blackberry_10, ua) || match(other_opera, ua) || match(other_firefox, ua) || match(other_chrome, ua)
	        };
	        this.seven_inch = match(seven_inch, ua);
	        this.any = this.apple.device || this.android.device || this.windows.device || this.other.device || this.seven_inch;
	        // excludes 'other' devices and ipods, targeting touchscreen phones
	        this.phone = this.apple.phone || this.android.phone || this.windows.phone;
	        // excludes 7 inch devices, classifying as phone or tablet is left to the user
	        this.tablet = this.apple.tablet || this.android.tablet || this.windows.tablet;
	
	        if (typeof window === 'undefined') {
	            return this;
	        }
	    };
	
	    var instantiate = function() {
	        var IM = new IsMobileClass();
	        IM.Class = IsMobileClass;
	        return IM;
	    };
	
	    if (typeof module != 'undefined' && module.exports && typeof window === 'undefined') {
	        //node
	        module.exports = IsMobileClass;
	    } else if (typeof module != 'undefined' && module.exports && typeof window !== 'undefined') {
	        //browserify
	        module.exports = instantiate();
	    } else if (true) {
	        //AMD
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (global.isMobile = instantiate()), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else {
	        global.isMobile = instantiate();
	    }
	
	})(this);


/***/ }),
/* 242 */,
/* 243 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is object-like.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ }),
/* 244 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
	 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(1);
	 * // => false
	 */
	function isObject(value) {
	  // Avoid a V8 JIT bug in Chrome 19-20.
	  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	module.exports = isObject;


/***/ }),
/* 245 */,
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	if (false) {
	  var ReactIs = require('react-is');
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(1497)();
	}


/***/ }),
/* 247 */
/***/ (function(module, exports) {

	module.exports = "# Title - Short\n\nEPS Follow-up Modules (Gr. 3-7)\n\n# Title - Long\n\nEMERGENCY PREPAREDNESS SQUAD Follow-up Modules (Gr. 3-7)\n\n# Description - Short\n\nEmergency Preparedness Squad (for Grades 4-7) trains kids as emergency preparedness superheroes to make sure families are ready when disaster strikes!\n\n# Description - Long\n\nEmergency Preparedness Squad trains kids as emergency preparedness superheroes to make sure families are ready when disaster strikes!\n\n# Description - Levels\n\n**Modules include:**\n&nbsp;\n* Know the Risks (live presentation)\n* Make a Plan\n* Get a Kit\n* We're In This Together\n&nbsp;\n\n# Level 1\nTitle: Make a Plan\nDescription: Planning 101: Why plan? How making plans before an emergency can help you stay calm.\n\n# Level 2\nTitle: Get a Kit\nDescription: Prepare a 'grab-and-go' bag to make sure you stay safe during the first 72hrs of an emergency.\n\n# Level 3\nTitle: We're In This Together\nDescription: Emergencies can bring out the best in communities. Celebrate how you've helped helped your family be better prepared!\n"

/***/ }),
/* 248 */
/***/ (function(module, exports) {

	module.exports = "# Title - Short\n\nEPS Follow-up Modules (Gr. K-2)\n\n# Title - Long\n\nEMERGENCY PREPAREDNESS SQUAD Follow-up Modules (Gr. K-2)\n\n# Description - Short\n\nEmergency Preparedness Squad (for Grades K-3) trains kids as emergency preparedness superheroes to make sure families are ready when disaster strikes!\n\n# Description - Long\n\nEmergency Preparedness Squad trains kids as emergency preparedness superheroes to make sure families are ready when disaster strikes!\n\n# Description - Levels\n\n**Modules include:**\n&nbsp;\n* Know the Risks (live presentation)\n* Make a Plan\n* Get a Kit\n* We're In This Together\n&nbsp;\n\n# Level 1\nTitle: Make a Plan\nDescription: Planning 101: Why plan? How making plans before an emergency can help you stay calm.\n\n# Level 2\nTitle: Get a Kit\nDescription: Prepare a 'grab-and-go' bag to make sure you stay safe during the first 72hrs of an emergency.\n\n# Level 3\nTitle: We're In This Together\nDescription: Emergencies can bring out the best in communities. Celebrate how you've helped helped your family be better prepared!\n"

/***/ }),
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */
/***/ (function(module, exports) {

	module.exports = true;


/***/ }),
/* 259 */
/***/ (function(module, exports) {

	exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 260 */
/***/ (function(module, exports) {

	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};


/***/ }),
/* 261 */
/***/ (function(module, exports) {

	var id = 0;
	var px = Math.random();
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};


/***/ }),
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.getInternalMethods = getInternalMethods;
	exports.warn = warn;
	exports.uid = uid;
	exports.formatAsConstant = formatAsConstant;
	exports.dispatchIdentity = dispatchIdentity;
	/* istanbul ignore next */
	function NoopClass() {}
	
	var builtIns = Object.getOwnPropertyNames(NoopClass);
	var builtInProto = Object.getOwnPropertyNames(NoopClass.prototype);
	
	function getInternalMethods(Obj, isProto) {
	  var excluded = isProto ? builtInProto : builtIns;
	  var obj = isProto ? Obj.prototype : Obj;
	  return Object.getOwnPropertyNames(obj).reduce(function (value, m) {
	    if (excluded.indexOf(m) !== -1) {
	      return value;
	    }
	
	    value[m] = obj[m];
	    return value;
	  }, {});
	}
	
	function warn(msg) {
	  /* istanbul ignore else */
	  if (typeof console !== 'undefined') {
	    console.warn(new ReferenceError(msg));
	  }
	}
	
	function uid(container, name) {
	  var count = 0;
	  var key = name;
	  while (Object.hasOwnProperty.call(container, key)) {
	    key = name + String(++count);
	  }
	  return key;
	}
	
	function formatAsConstant(name) {
	  return name.replace(/[a-z]([A-Z])/g, function (i) {
	    return '' + i[0] + '_' + i[1].toLowerCase();
	  }).toUpperCase();
	}
	
	function dispatchIdentity(x) {
	  for (var _len = arguments.length, a = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    a[_key - 1] = arguments[_key];
	  }
	
	  this.dispatch(a.length ? [x].concat(a) : x);
	}

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Based on https://github.com/jsstyles/css-vendor, but without having to
	 * convert between different cases all the time.
	 *
	 * @flow
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(141);
	var arrayFind = __webpack_require__(462);
	
	var VENDOR_PREFIX_REGEX = /-(moz|webkit|ms|o)-/;
	
	var vendorPrefixes = ['Webkit', 'ms', 'Moz', 'O'];
	
	var infoByCssPrefix = {
	  '-moz-': {
	    cssPrefix: '-moz-',
	    jsPrefix: 'Moz',
	    alternativeProperties: {
	      // OLD - Firefox 19-
	      alignItems: [{ css: '-moz-box-align', js: 'MozBoxAlign' }],
	      flex: [{ css: '-moz-box-flex', js: 'MozBoxFlex' }],
	      flexDirection: [{ css: '-moz-box-orient', js: 'MozBoxOrient' }],
	      justifyContent: [{ css: '-moz-box-pack', js: 'MozBoxPack' }],
	      order: [{ css: '-moz-box-ordinal-group', js: 'MozBoxOrdinalGroup' }]
	    },
	    alternativeValues: {
	      // OLD - Firefox 19-
	      alignItems: {
	        'flex-start': ['start'],
	        'flex-end': ['end']
	      },
	      display: {
	        flex: ['-moz-box']
	      },
	      flexDirection: {
	        column: ['vertical'],
	        row: ['horizontal']
	      },
	      justifyContent: {
	        'flex-start': ['start'],
	        'flex-end': ['end'],
	        'space-between': ['justify']
	      }
	    }
	  },
	  '-ms-': {
	    cssPrefix: '-ms-',
	    jsPrefix: 'ms',
	    alternativeProperties: {
	      // TWEENER - IE 10
	      alignContent: [{ css: '-ms-flex-line-pack', js: 'msFlexLinePack' }],
	      alignItems: [{ css: '-ms-flex-align', js: 'msFlexAlign' }],
	      alignSelf: [{ css: '-ms-flex-align-item', js: 'msFlexAlignItem' }],
	      justifyContent: [{ css: '-ms-flex-pack', js: 'msFlexPack' }],
	      order: [{ css: '-ms-flex-order', js: 'msFlexOrder' }]
	    },
	    alternativeValues: {
	      // TWEENER - IE 10
	      alignContent: {
	        'flex-start': ['start'],
	        'flex-end': ['end'],
	        'space-between': ['justify'],
	        'space-around': ['distribute']
	      },
	      alignItems: {
	        'flex-start': ['start'],
	        'flex-end': ['end']
	      },
	      alignSelf: {
	        'flex-start': ['start'],
	        'flex-end': ['end']
	      },
	      display: {
	        flex: ['-ms-flexbox'],
	        'inline-flex': ['-ms-inline-flexbox']
	      },
	      justifyContent: {
	        'flex-start': ['start'],
	        'flex-end': ['end'],
	        'space-between': ['justify'],
	        'space-around': ['distribute']
	      }
	    }
	  },
	  '-o-': {
	    cssPrefix: '-o-',
	    jsPrefix: 'O'
	  },
	  '-webkit-': {
	    cssPrefix: '-webkit-',
	    jsPrefix: 'Webkit',
	    alternativeProperties: {
	      // OLD - iOS 6-, Safari 3.1-6
	      alignItems: [{ css: '-webkit-box-align', js: 'WebkitBoxAlign' }],
	      flex: [{ css: '-webkit-box-flex', js: 'MozBoxFlex' }],
	      flexDirection: [{ css: '-webkit-box-orient', js: 'WebkitBoxOrient' }],
	      justifyContent: [{ css: '-webkit-box-pack', js: 'WebkitBoxPack' }],
	      order: [{ css: '-webkit-box-ordinal-group', js: 'WebkitBoxOrdinalGroup' }]
	    },
	    alternativeValues: {
	      // OLD - iOS 6-, Safari 3.1-6
	      alignItems: {
	        'flex-start': ['start'],
	        'flex-end': ['end']
	      },
	      display: {
	        flex: ['-webkit-box']
	      },
	      flexDirection: {
	        row: ['horizontal'],
	        column: ['vertical']
	      },
	      justifyContent: {
	        'flex-start': ['start'],
	        'flex-end': ['end'],
	        'space-between': ['justify']
	      }
	    }
	  }
	};
	
	/**
	 * CSS properties which accept numbers but are not in units of "px".
	 * Copied from React core June 22, 2015.
	 * https://github.com/facebook/react/blob/
	 * ba81b60ad8e93b747be42a03b797065932c49c96/
	 * src/renderers/dom/shared/CSSProperty.js
	 */
	var isUnitlessNumber = {
	  boxFlex: true,
	  boxFlexGroup: true,
	  columnCount: true,
	  flex: true,
	  flexGrow: true,
	  flexPositive: true,
	  flexShrink: true,
	  flexNegative: true,
	  fontWeight: true,
	  lineClamp: true,
	  lineHeight: true,
	  opacity: true,
	  order: true,
	  orphans: true,
	  tabSize: true,
	  widows: true,
	  zIndex: true,
	  zoom: true,
	
	  // SVG-related properties
	  fillOpacity: true,
	  strokeDashoffset: true,
	  strokeOpacity: true,
	  strokeWidth: true
	};
	
	var domStyle = {};
	var prefixedPropertyCache = {};
	var prefixedValueCache = {};
	var prefixInfo = {
	  cssPrefix: '',
	  jsPrefix: ''
	};
	
	if (ExecutionEnvironment.canUseDOM) {
	  domStyle = (document /*: any*/).createElement('p').style;
	
	  // older Firefox versions may have no float property in style object
	  // so we need to add it manually
	  if (domStyle.float === undefined) {
	    domStyle.float = '';
	  }
	
	  // Based on http://davidwalsh.name/vendor-prefix
	  var prefixMatch;
	  var windowStyles = window.getComputedStyle(document.documentElement, '');
	
	  // Array.prototype.slice.call(windowStyles) fails with
	  // "Uncaught TypeError: undefined is not a function"
	  // in older versions Android (KitKat) web views
	  for (var i = 0; i < windowStyles.length; i++) {
	    prefixMatch = windowStyles[i].match(VENDOR_PREFIX_REGEX);
	
	    if (prefixMatch) {
	      break;
	    }
	  }
	
	  var cssVendorPrefix = prefixMatch && prefixMatch[0];
	
	  prefixInfo = cssVendorPrefix && infoByCssPrefix[cssVendorPrefix] ? infoByCssPrefix[cssVendorPrefix] : prefixInfo;
	}
	
	var _camelCaseRegex = /([a-z])?([A-Z])/g;
	var _camelCaseReplacer = function _camelCaseReplacer(match, p1, p2) {
	  return p1 + '-' + p2.toLowerCase();
	};
	var _camelCaseToDashCase = function _camelCaseToDashCase(s) {
	  return s.replace(_camelCaseRegex, _camelCaseReplacer);
	};
	
	var getPrefixedPropertyName = function getPrefixedPropertyName(property /*: string*/) /*: {css: string, js: string}*/ {
	  if (prefixedPropertyCache.hasOwnProperty(property)) {
	    return prefixedPropertyCache[property];
	  }
	
	  var unprefixed = {
	    css: _camelCaseToDashCase(property),
	    js: property,
	    isDefaultForServer: true
	  };
	
	  // Try the prefixed version first. Chrome in particular has the `filter` and
	  // `webkitFilter` properties availalbe on the style object, but only the
	  // prefixed version actually works.
	  var possiblePropertyNames = [
	  // Prefixed
	  {
	    css: prefixInfo.cssPrefix + _camelCaseToDashCase(property),
	    js: prefixInfo.jsPrefix + property[0].toUpperCase() + property.slice(1)
	  }, unprefixed];
	
	  // Alternative property names
	  if (prefixInfo.alternativeProperties && prefixInfo.alternativeProperties[property]) {
	    possiblePropertyNames = possiblePropertyNames.concat(prefixInfo.alternativeProperties[property]);
	  }
	
	  var workingProperty = arrayFind(possiblePropertyNames, function (possiblePropertyName) {
	    if (possiblePropertyName.js in domStyle) {
	      return possiblePropertyName;
	    }
	  }) || false;
	
	  return prefixedPropertyCache[property] = workingProperty;
	};
	
	// We are un-prefixing values before checking for isUnitlessNumber,
	// otherwise we are at risk of being in a situation where someone
	// explicitly passes something like `MozBoxFlex: 1` and that will
	// in turn get transformed into `MozBoxFlex: 1px`.
	var _getUnprefixedProperty = function _getUnprefixedProperty(property) {
	  var noPrefixProperty = property;
	
	  vendorPrefixes.some(function (prefix) {
	    // Let's check if the property starts with a vendor prefix
	    if (property.indexOf(prefix) === 0) {
	      noPrefixProperty = noPrefixProperty.replace(prefix, '');
	
	      // We have removed the vendor prefix, however the first
	      // character is going to be uppercase hence won't match
	      // any of the `isUnitlessNumber` keys as they all start
	      // with lower case. Let's ensure that the first char is
	      // lower case.
	      noPrefixProperty = noPrefixProperty.charAt(0).toLowerCase() + noPrefixProperty.slice(1);
	
	      return true;
	    }
	  });
	
	  return noPrefixProperty;
	};
	
	// React is planning to deprecate adding px automatically
	// (https://github.com/facebook/react/issues/1873), and if they do, this
	// should change to a warning or be removed in favor of React's warning.
	// Same goes for below.
	var _addPixelSuffixToValueIfNeeded = function _addPixelSuffixToValueIfNeeded(originalProperty, value) {
	  var unPrefixedProperty = _getUnprefixedProperty(originalProperty);
	
	  if (value !== 0 && !isNaN(value) && !isUnitlessNumber[unPrefixedProperty]) {
	    return value + 'px';
	  }
	  return value;
	};
	
	var _getPrefixedValue = function _getPrefixedValue(componentName, property, value, originalProperty) {
	  if (!Array.isArray(value)) {
	    // don't test numbers (pure or stringy), but do add 'px' prefix if needed
	    if (!isNaN(value) && value !== null) {
	      return _addPixelSuffixToValueIfNeeded(originalProperty, value);
	    }
	
	    if (typeof value !== 'string') {
	      if (value !== null && value !== undefined) {
	        value = value.toString();
	      } else {
	        return value;
	      }
	    }
	
	    // don't test numbers with units (e.g. 10em)
	    if (!isNaN(parseInt(value, 10))) {
	      return value;
	    }
	  }
	
	  var cacheKey = Array.isArray(value) ? value.join(' || ') : property + value;
	
	  if (prefixedValueCache.hasOwnProperty(cacheKey)) {
	    return prefixedValueCache[cacheKey];
	  }
	
	  var possibleValues;
	  if (Array.isArray(value)) {
	    // Add px for the same values React would, otherwise the testing below will
	    // fail and it will try to fallback.
	    possibleValues = value.map(function (v) {
	      return _addPixelSuffixToValueIfNeeded(originalProperty, v);
	    });
	
	    // Add prefixed versions
	    possibleValues = possibleValues.concat(value.filter(function (v) {
	      return !isNaN(v);
	    }) // Don't prefix numbers
	    .map(function (v) {
	      return prefixInfo.cssPrefix + v;
	    }));
	  } else {
	    possibleValues = [
	    // Unprefixed
	    value,
	    // Prefixed
	    prefixInfo.cssPrefix + value];
	  }
	
	  // Alternative values
	  if (prefixInfo.alternativeValues && prefixInfo.alternativeValues[originalProperty] && prefixInfo.alternativeValues[originalProperty][value]) {
	    possibleValues = possibleValues.concat(prefixInfo.alternativeValues[originalProperty][value]);
	  }
	
	  // Test possible value in order
	  var workingValue = arrayFind(possibleValues, function (possibleValue) {
	    domStyle[property] = '';
	    domStyle[property] = possibleValue;
	
	    // Note that we just make sure it is not an empty string. Browsers will
	    // sometimes rewrite values, but still accept them. They will set the value
	    // to an empty string if not supported.
	    // E.g. for border, "solid 1px black" becomes "1px solid black"
	    //      but "foobar" becomes "", since it is not supported.
	    return !!domStyle[property];
	  });
	
	  if (workingValue) {
	    prefixedValueCache[cacheKey] = workingValue;
	  } else {
	    // Unsupported, assume unprefixed works, but warn
	    prefixedValueCache[cacheKey] = value;
	
	    if (false) {
	      /* eslint-disable no-console */
	      if (console && console.warn) {
	        var componentContext = componentName ? ' in component "' + componentName + '"' : '';
	
	        console.warn('Unsupported CSS value "' + value + '" for property "' + property + '"' + componentContext);
	      }
	      /* eslint-enable no-console */
	    }
	  }
	
	  return prefixedValueCache[cacheKey];
	};
	
	// Returns a new style object with vendor prefixes added to property names
	// and values.
	var getPrefixedStyle = function getPrefixedStyle(componentName /*: any*/, // ReactComponent
	style /*: Object*/) /*: Object*/ {
	  var mode /*: 'css' | 'js'*/ = arguments.length <= 2 || arguments[2] === undefined ? 'js' : arguments[2];
	
	  if (!ExecutionEnvironment.canUseDOM) {
	    return Object.keys(style).reduce(function (newStyle, key) {
	      var value = style[key];
	      var newKey = mode === 'css' ? _camelCaseToDashCase(key) : key;
	      var newValue = Array.isArray(value) ? value[0] : value;
	      newStyle[newKey] = newValue;
	      return newStyle;
	    }, {});
	  }
	
	  var prefixedStyle = {};
	  Object.keys(style).forEach(function (property) {
	    var value = style[property];
	
	    var newProperty = getPrefixedPropertyName(property);
	    if (newProperty === false) {
	      // Ignore unsupported properties
	      if (false) {
	        /* eslint-disable no-console */
	        if (console && console.warn) {
	          var componentContext = componentName ? ' in component "' + componentName + '"' : '';
	
	          console.warn('Unsupported CSS property "' + property + '$"' + componentContext);
	        }
	        /* eslint-enable no-console */
	        return;
	      }
	    }
	
	    var newValue = _getPrefixedValue(componentName, newProperty.js, value, property);
	
	    prefixedStyle[newProperty[mode]] = newValue;
	  });
	  return prefixedStyle;
	};
	
	module.exports = {
	  getPrefixedPropertyName: getPrefixedPropertyName,
	  getPrefixedStyle: getPrefixedStyle,
	  cssPrefix: prefixInfo.cssPrefix,
	  jsPrefix: prefixInfo.jsPrefix
	};

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var easingTypes = __webpack_require__(2236);
	
	// additive is the new iOS 8 default. In most cases it simulates a physics-
	// looking overshoot behavior (especially with easeInOut. You can test that in
	// the example
	var DEFAULT_STACK_BEHAVIOR = 'ADDITIVE';
	var DEFAULT_EASING = easingTypes.easeInOutQuad;
	var DEFAULT_DURATION = 300;
	var DEFAULT_DELAY = 0;
	
	// see usage below
	function returnState(state) {
	  return state;
	}
	
	var tweenState = {
	  easingTypes: easingTypes,
	  stackBehavior: {
	    ADDITIVE: 'ADDITIVE',
	    DESTRUCTIVE: 'DESTRUCTIVE',
	  }
	};
	
	tweenState.Mixin = {
	  getInitialState: function() {
	    return {
	      tweenQueue: [],
	    };
	  },
	
	  tweenState: function(a, b, c) {
	    // tweenState(stateNameString, config)
	    // tweenState(stateRefFunc, stateNameString, config)
	
	    // passing a state name string and retrieving it later from this.state
	    // doesn't work for values in deeply nested collections (unless you design
	    // the API to be able to parse 'this.state.my.nested[1]', meh). Passing a
	    // direct, resolved reference wouldn't work either, since that reference
	    // points to the old state rather than the subsequent new ones.
	    if (typeof a === 'string') {
	      c = b;
	      b = a;
	      a = returnState;
	    }
	    this._tweenState(a, b, c);
	  },
	
	  _tweenState: function(stateRefFunc, stateName, config) {
	    // _pendingState doesn't exist in React 0.13 anymore. No harm leaving it
	    // here for backward compat
	    var state = this._pendingState || this.state;
	    var stateRef = stateRefFunc(state);
	
	    // see the reasoning for these defaults at the top
	    var newConfig = {
	      easing: config.easing || DEFAULT_EASING,
	      duration: config.duration == null ? DEFAULT_DURATION : config.duration,
	      delay: config.delay == null ? DEFAULT_DELAY : config.delay,
	      beginValue: config.beginValue == null ? stateRef[stateName] : config.beginValue,
	      endValue: config.endValue,
	      onEnd: config.onEnd,
	      stackBehavior: config.stackBehavior || DEFAULT_STACK_BEHAVIOR,
	    };
	
	    var newTweenQueue = state.tweenQueue;
	    if (newConfig.stackBehavior === tweenState.stackBehavior.DESTRUCTIVE) {
	      newTweenQueue = state.tweenQueue.filter(function(item) {
	        return item.stateName !== stateName || item.stateRefFunc(state) !== stateRef;
	      });
	    }
	
	    newTweenQueue.push({
	      stateRefFunc: stateRefFunc,
	      stateName: stateName,
	      config: newConfig,
	      initTime: Date.now() + newConfig.delay,
	    });
	
	    // tweenState calls setState
	    // sorry for mutating. No idea where in the state the value is
	    stateRef[stateName] = newConfig.endValue;
	    // this will also include the above update
	    this.setState({tweenQueue: newTweenQueue});
	
	    if (newTweenQueue.length === 1) {
	      this.startRaf();
	    }
	  },
	
	  getTweeningValue: function(a, b) {
	    // see tweenState API
	    if (typeof a === 'string') {
	      b = a;
	      a = returnState;
	    }
	    return this._getTweeningValue(a, b);
	  },
	
	  _getTweeningValue: function(stateRefFunc, stateName) {
	    var state = this.state;
	    var stateRef = stateRefFunc(state);
	    var tweeningValue = stateRef[stateName];
	    var now = Date.now();
	
	    for (var i = 0; i < state.tweenQueue.length; i++) {
	      var item = state.tweenQueue[i];
	      var itemStateRef = item.stateRefFunc(state);
	      if (item.stateName !== stateName || itemStateRef !== stateRef) {
	        continue;
	      }
	
	      var progressTime = now - item.initTime > item.config.duration ?
	        item.config.duration :
	        Math.max(0, now - item.initTime);
	      // `now - item.initTime` can be negative if initTime is scheduled in the
	      // future by a delay. In this case we take 0
	
	      var contrib = -item.config.endValue + item.config.easing(
	        progressTime,
	        item.config.beginValue,
	        item.config.endValue,
	        item.config.duration
	        // TODO: some funcs accept a 5th param
	      );
	      tweeningValue += contrib;
	    }
	
	    return tweeningValue;
	  },
	
	  _rafCb: function() {
	    var state = this.state;
	    if (state.tweenQueue.length === 0) {
	      return;
	    }
	
	    var now = Date.now();
	    var newTweenQueue = [];
	
	    for (var i = 0; i < state.tweenQueue.length; i++) {
	      var item = state.tweenQueue[i];
	      if (now - item.initTime < item.config.duration) {
	        newTweenQueue.push(item);
	      } else {
	        item.config.onEnd && item.config.onEnd();
	      }
	    }
	
	    // onEnd might trigger a parent callback that removes this component
	    if (!this.isMounted()) {
	      return;
	    }
	
	    this.setState({
	      tweenQueue: newTweenQueue,
	    });
	
	    requestAnimationFrame(this._rafCb);
	  },
	
	  startRaf: function() {
	    requestAnimationFrame(this._rafCb);
	  },
	
	};
	
	module.exports = tweenState;


/***/ }),
/* 278 */,
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016 Google Inc. All Rights Reserved.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	
	var assign = __webpack_require__(185);
	var getAttributes = __webpack_require__(1346);
	
	
	var utilities = {
	
	
	  /**
	   * Accepts default and user override fields and an optional tracker, hit
	   * filter, and target element and returns a single object that can be used in
	   * `ga('send', ...)` commands.
	   * @param {Object} defaultFields The default fields to return.
	   * @param {Object} userFields Fields set by the user to override the defaults.
	   * @param {Object} opt_tracker The tracker object to apply the hit filter to.
	   * @param {Function} opt_hitFilter A filter function that gets
	   *     called with the tracker model right before the `buildHitTask`. It can
	   *     be used to modify the model for the current hit only.
	   * @param {Element} opt_target If the hit originated from an interaction
	   *     with a DOM element, hitFilter is invoked with that element as the
	   *     second argument.
	   * @return {Object} The final fields object.
	   */
	  createFieldsObj: function(
	      defaultFields, userFields, opt_tracker, opt_hitFilter, opt_target) {
	
	    if (typeof opt_hitFilter == 'function') {
	      var originalBuildHitTask = opt_tracker.get('buildHitTask');
	      return {
	        buildHitTask: function(model) {
	          model.set(defaultFields, null, true);
	          model.set(userFields, null, true);
	          opt_hitFilter(model, opt_target);
	          originalBuildHitTask(model);
	        }
	      };
	    }
	    else {
	      return assign({}, defaultFields, userFields);
	    }
	  },
	
	
	  /**
	   * Retrieves the attributes from an DOM element and returns a fields object
	   * for all attributes matching the passed prefix string.
	   * @param {Element} element The DOM element to get attributes from.
	   * @param {string} prefix An attribute prefix. Only the attributes matching
	   *     the prefix will be returned on the fields object.
	   * @return {Object} An object of analytics.js fields and values
	   */
	  getAttributeFields: function(element, prefix) {
	    var attributes = getAttributes(element);
	    var attributeFields = {};
	
	    Object.keys(attributes).forEach(function(attribute) {
	
	      // The `on` prefix is used for event handling but isn't a field.
	      if (attribute.indexOf(prefix) === 0 && attribute != prefix + 'on') {
	
	        var value = attributes[attribute];
	
	        // Detects Boolean value strings.
	        if (value == 'true') value = true;
	        if (value == 'false') value = false;
	
	        var field = utilities.camelCase(attribute.slice(prefix.length));
	        attributeFields[field] = value;
	      }
	    });
	
	    return attributeFields;
	  },
	
	
	  domReady: function(callback) {
	    if (document.readyState == 'loading') {
	      document.addEventListener('DOMContentLoaded', function fn() {
	        document.removeEventListener('DOMContentLoaded', fn);
	        callback();
	      });
	    } else {
	      callback();
	    }
	  },
	
	
	  /**
	   * Accepts a function and returns a wrapped version of the function that is
	   * expected to be called elsewhere in the system. If it's not called
	   * elsewhere after the timeout period, it's called regardless. The wrapper
	   * function also prevents the callback from being called more than once.
	   * @param {Function} callback The function to call.
	   * @param {number} wait How many milliseconds to wait before invoking
	   *     the callback.
	   * @returns {Function} The wrapped version of the passed function.
	   */
	  withTimeout: function(callback, wait) {
	    var called = false;
	    var fn = function() {
	      if (!called) {
	        called = true;
	        callback();
	      }
	    };
	    setTimeout(fn, wait || 2000);
	    return fn;
	  },
	
	
	  /**
	   * Accepts a string containing hyphen or underscore word separators and
	   * converts it to camelCase.
	   * @param {string} str The string to camelCase.
	   * @return {string} The camelCased version of the string.
	   */
	  camelCase: function(str) {
	    return str.replace(/[\-\_]+(\w?)/g, function(match, p1) {
	      return p1.toUpperCase();
	    });
	  },
	
	
	  /**
	   * Capitalizes the first letter of a string.
	   * @param {string} str The input string.
	   * @return {string} The capitalized string
	   */
	  capitalize: function(str) {
	    return str.charAt(0).toUpperCase() + str.slice(1);
	  },
	
	
	  /**
	   * Indicates whether the passed variable is a JavaScript object.
	   * @param {*} value The input variable to test.
	   * @return {boolean} Whether or not the test is an object.
	   */
	  isObject: function(value) {
	    return typeof value == 'object' && value !== null;
	  },
	
	
	  /**
	   * Indicates whether the passed variable is a JavaScript array.
	   * @param {*} value The input variable to test.
	   * @return {boolean} Whether or not the value is an array.
	   */
	  isArray: Array.isArray || function(value) {
	    return Object.prototype.toString.call(value) === '[object Array]';
	  },
	
	
	  /**
	   * Accepts a value that may or may not be an array. If it is not an array,
	   * it is returned as the first item in a single-item array.
	   * @param {*} value The value to convert to an array if it is not.
	   * @return {Array} The array-ified value.
	   */
	  toArray: function(value) {
	    return utilities.isArray(value) ? value : [value];
	  }
	};
	
	module.exports = utilities;


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.preloadStart = preloadStart;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _baseSlidesVideoSlide = __webpack_require__(55);
	
	var _baseSlidesVideoSlide2 = _interopRequireDefault(_baseSlidesVideoSlide);
	
	var _imagesPpa_presentsSvg = __webpack_require__(2289);
	
	var _imagesPpa_presentsSvg2 = _interopRequireDefault(_imagesPpa_presentsSvg);
	
	var _imagesEmergencyPreparednessSquadGlowPng = __webpack_require__(407);
	
	var _imagesEmergencyPreparednessSquadGlowPng2 = _interopRequireDefault(_imagesEmergencyPreparednessSquadGlowPng);
	
	var _helpersMarkdownScript = __webpack_require__(9);
	
	var _helpersMarkdownScript2 = _interopRequireDefault(_helpersMarkdownScript);
	
	var _startMd = __webpack_require__(1538);
	
	var _startMd2 = _interopRequireDefault(_startMd);
	
	var _imagesLevel1_startPng = __webpack_require__(408);
	
	var _imagesLevel1_startPng2 = _interopRequireDefault(_imagesLevel1_startPng);
	
	var _imagesLevel2_startPng = __webpack_require__(409);
	
	var _imagesLevel2_startPng2 = _interopRequireDefault(_imagesLevel2_startPng);
	
	var _imagesLevel3_startPng = __webpack_require__(861);
	
	var _imagesLevel3_startPng2 = _interopRequireDefault(_imagesLevel3_startPng);
	
	var levels = {
	  '1': { img: _imagesLevel1_startPng2['default'] },
	  '2': { img: _imagesLevel2_startPng2['default'] },
	  '3': { img: _imagesLevel3_startPng2['default'] }
	};
	
	var md = new _helpersMarkdownScript2['default'](_startMd2['default']);
	
	function preloadStart() {
	  (0, _spectaclePpa.preloader)([_imagesPpa_presentsSvg2['default'], _imagesLevel1_startPng2['default'], _imagesLevel2_startPng2['default'], _imagesLevel3_startPng2['default']]);
	}
	
	function startSection(_ref) {
	  var level = _ref.level;
	  var title = _ref.title;
	  var regionData = _ref.regionData;
	
	  /* Level intro graphic */
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'start' },
	    _react2['default'].createElement(
	      _spectaclePpa.Slide,
	      {
	        id: 'ppa-presents',
	        key: 'ppa-presents',
	        bgColor: 'black',
	        notes: md.getSubSectionAsHtml('Level ' + level + ' Start', 'Notes', false, regionData) },
	      _react2['default'].createElement(
	        'div',
	        {
	          className: 'ui-slide' },
	        _react2['default'].createElement(
	          'div',
	          { className: 'flex-image' },
	          _react2['default'].createElement('img', {
	            className: 'heading-image heading-image-before',
	            src: _imagesPpa_presentsSvg2['default'] })
	        )
	      )
	    ),
	    _react2['default'].createElement(
	      _spectaclePpa.Slide,
	      {
	        id: 'ppa-eps',
	        key: 'ppa-eps',
	        bgColor: 'black',
	        notes: md.getSubSectionAsHtml('Level ' + level + ' Start', 'Notes', false, regionData) },
	      _react2['default'].createElement(
	        'div',
	        {
	          className: 'ui-slide' },
	        _react2['default'].createElement(
	          'div',
	          { className: 'flex-image' },
	          _react2['default'].createElement('img', { className: 'eps-logo heading-image',
	            src: _imagesEmergencyPreparednessSquadGlowPng2['default'] })
	        )
	      )
	    ),
	    _react2['default'].createElement(
	      _spectaclePpa.Slide,
	      {
	        id: 'level',
	        key: 'level',
	        bgColor: 'black',
	        notes: md.getSubSectionAsHtml('Level ' + level + ' Icon', 'Notes', false, regionData) },
	      _react2['default'].createElement(
	        'div',
	        {
	          className: 'ui-slide' },
	        _react2['default'].createElement(
	          'div',
	          { className: 'title-image' },
	          _react2['default'].createElement('img', {
	            className: 'heading-image heading-image-before',
	            src: levels[level].img }),
	          _react2['default'].createElement(
	            _spectaclePpa.Heading,
	            { size: 1 },
	            _react2['default'].createElement(
	              'strong',
	              null,
	              title
	            )
	          ),
	          _react2['default'].createElement(
	            _spectaclePpa.Heading,
	            { size: 2 },
	            _react2['default'].createElement(
	              'strong',
	              null,
	              'Level ',
	              level
	            )
	          )
	        )
	      )
	    ),
	    (level === 1 || level === 2) && (0, _baseSlidesVideoSlide2['default'])({
	      id: 'level-intro',
	      notes: md.getSubSectionAsHtml('Level ' + level + ' Intro', 'Notes', false, regionData),
	      youTubeId: md.getSectionMetadata('Level ' + level + ' Intro', 'YouTube', regionData)
	    })
	  );
	}
	
	exports['default'] = startSection;
	/* Sanksrit for Vanessa */ /* lokah samastah sukhino bhavantu */ /* may all beings everywhere be at peace */ /* Sara and Ian Level Intro */

/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.preloadSong = preloadSong;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _baseSlidesVideoSlide = __webpack_require__(55);
	
	var _baseSlidesVideoSlide2 = _interopRequireDefault(_baseSlidesVideoSlide);
	
	var _imagesCharactersIan_sara_sillyPng = __webpack_require__(856);
	
	var _imagesCharactersIan_sara_sillyPng2 = _interopRequireDefault(_imagesCharactersIan_sara_sillyPng);
	
	var _imagesCharactersIan_sara_two_fingersPng = __webpack_require__(2278);
	
	var _imagesCharactersIan_sara_two_fingersPng2 = _interopRequireDefault(_imagesCharactersIan_sara_two_fingersPng);
	
	var _helpersMarkdownScript = __webpack_require__(9);
	
	var _helpersMarkdownScript2 = _interopRequireDefault(_helpersMarkdownScript);
	
	var _songMd = __webpack_require__(1539);
	
	var _songMd2 = _interopRequireDefault(_songMd);
	
	var md = new _helpersMarkdownScript2['default'](_songMd2['default']);
	
	function preloadSong() {
	  (0, _spectaclePpa.preloader)([_imagesCharactersIan_sara_sillyPng2['default'], _imagesCharactersIan_sara_two_fingersPng2['default']]);
	}
	
	function songSection(_ref) {
	  var regionData = _ref.regionData;
	
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'song' },
	    (0, _baseSlidesVideoSlide2['default'])({
	      id: 'video',
	      notes: md.getSubSectionAsHtml('Song', 'Notes', false, regionData),
	      youTubeId: md.getSectionMetadata('Song', 'YouTube', regionData)
	    })
	  );
	}
	
	exports['default'] = songSection;
	/* Song */

/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

	/* eslint react/no-multi-comp: 0 */
	
	'use strict';
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _baseSlidesVideoSlide = __webpack_require__(55);
	
	var _baseSlidesVideoSlide2 = _interopRequireDefault(_baseSlidesVideoSlide);
	
	var _helpersMarkdownScript = __webpack_require__(9);
	
	var _helpersMarkdownScript2 = _interopRequireDefault(_helpersMarkdownScript);
	
	var _level1_egstoryMd = __webpack_require__(1541);
	
	var _level1_egstoryMd2 = _interopRequireDefault(_level1_egstoryMd);
	
	var _level2_egstoryMd = __webpack_require__(1542);
	
	var _level2_egstoryMd2 = _interopRequireDefault(_level2_egstoryMd);
	
	var _level3_egstoryMd = __webpack_require__(1543);
	
	var _level3_egstoryMd2 = _interopRequireDefault(_level3_egstoryMd);
	
	var levels = {
	  '1': { md: new _helpersMarkdownScript2['default'](_level1_egstoryMd2['default']) },
	  '2': { md: new _helpersMarkdownScript2['default'](_level2_egstoryMd2['default']) },
	  '3': { md: new _helpersMarkdownScript2['default'](_level3_egstoryMd2['default']) }
	};
	
	function esOpeningStory(_ref) {
	  var level = _ref.level;
	  var regionData = _ref.regionData;
	
	  var md = levels[level].md;
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: "esGooberStory" },
	    level === 2 && (0, _baseSlidesVideoSlide2['default'])({
	      id: 'sharknado',
	      notes: md.getSubSectionAsHtml('Sharknado', 'Notes', false, regionData),
	      youTubeId: md.getSectionMetadata('Sharknado', 'YouTube', regionData)
	    }),
	    level === 2 && (0, _baseSlidesVideoSlide2['default'])({
	      id: 'calming-breath-recap',
	      notes: md.getSubSectionAsHtml('Calming Breath Recap', 'Notes', false, regionData),
	      youTubeId: md.getSectionMetadata('Calming Breath Recap', 'YouTube', regionData)
	    }),
	    (0, _baseSlidesVideoSlide2['default'])({
	      id: 'story',
	      notes: md.getSubSectionAsHtml('Esmeralda and Goober Story', 'Notes', false, regionData),
	      youTubeId: md.getSectionMetadata('Esmeralda and Goober Story', 'YouTube', regionData)
	    }),
	    level === 1 && (0, _baseSlidesVideoSlide2['default'])({
	      id: 'calming-breath',
	      notes: md.getSubSectionAsHtml('Calming Breath Intro', 'Notes', false, regionData),
	      youTubeId: md.getSectionMetadata('Calming Breath Intro', 'YouTube', regionData)
	    })
	  );
	}
	
	exports['default'] = esOpeningStory;
	module.exports = exports['default'];
	/* Sharknado in Level 2 */ /* Calming breath recap in Level 2 */ /* Esmerelda and Goober Story  */ /* Calming breath intro in Level 1 */

/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.preloadMissionReport = preloadMissionReport;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _componentsMissionReport = __webpack_require__(76);
	
	var _componentsMissionReport2 = _interopRequireDefault(_componentsMissionReport);
	
	var _baseSlidesBalloonSlide = __webpack_require__(85);
	
	var _baseSlidesBalloonSlide2 = _interopRequireDefault(_baseSlidesBalloonSlide);
	
	var _baseSlidesVideoSlide = __webpack_require__(55);
	
	var _baseSlidesVideoSlide2 = _interopRequireDefault(_baseSlidesVideoSlide);
	
	var _imagesCharactersIan_arms_foldedPng = __webpack_require__(854);
	
	var _imagesCharactersIan_arms_foldedPng2 = _interopRequireDefault(_imagesCharactersIan_arms_foldedPng);
	
	var _imagesCharactersIan_headshot_smilePng = __webpack_require__(855);
	
	var _imagesCharactersIan_headshot_smilePng2 = _interopRequireDefault(_imagesCharactersIan_headshot_smilePng);
	
	var _imagesCharactersSara_twist_hands_out_yayPng = __webpack_require__(2281);
	
	var _imagesCharactersSara_twist_hands_out_yayPng2 = _interopRequireDefault(_imagesCharactersSara_twist_hands_out_yayPng);
	
	var _imagesCharactersSara_smilePng = __webpack_require__(406);
	
	var _imagesCharactersSara_smilePng2 = _interopRequireDefault(_imagesCharactersSara_smilePng);
	
	var _imagesCharactersIan_sara_sidePng = __webpack_require__(152);
	
	var _imagesCharactersIan_sara_sidePng2 = _interopRequireDefault(_imagesCharactersIan_sara_sidePng);
	
	var _imagesCharactersIan_sara_lean_questioningPng = __webpack_require__(199);
	
	var _imagesCharactersIan_sara_lean_questioningPng2 = _interopRequireDefault(_imagesCharactersIan_sara_lean_questioningPng);
	
	var _helpersMarkdownScript = __webpack_require__(9);
	
	var _helpersMarkdownScript2 = _interopRequireDefault(_helpersMarkdownScript);
	
	var _level1_knowTheRisksMd = __webpack_require__(1544);
	
	var _level1_knowTheRisksMd2 = _interopRequireDefault(_level1_knowTheRisksMd);
	
	var _level2_makeAPlanMd = __webpack_require__(1545);
	
	var _level2_makeAPlanMd2 = _interopRequireDefault(_level2_makeAPlanMd);
	
	var _level3_getAKitMd = __webpack_require__(1546);
	
	var _level3_getAKitMd2 = _interopRequireDefault(_level3_getAKitMd);
	
	var _imagesLevel0_startPng = __webpack_require__(2285);
	
	var _imagesLevel0_startPng2 = _interopRequireDefault(_imagesLevel0_startPng);
	
	var _imagesLevel1_startPng = __webpack_require__(408);
	
	var _imagesLevel1_startPng2 = _interopRequireDefault(_imagesLevel1_startPng);
	
	var _imagesLevel2_startPng = __webpack_require__(409);
	
	var _imagesLevel2_startPng2 = _interopRequireDefault(_imagesLevel2_startPng);
	
	var levels = {
	  '0': { img: _imagesLevel0_startPng2['default'] },
	  '1': { md: new _helpersMarkdownScript2['default'](_level1_knowTheRisksMd2['default']), img: _imagesLevel1_startPng2['default'] },
	  '2': { md: new _helpersMarkdownScript2['default'](_level2_makeAPlanMd2['default']), img: _imagesLevel2_startPng2['default'] },
	  '3': { md: new _helpersMarkdownScript2['default'](_level3_getAKitMd2['default']) }
	};
	
	function preloadMissionReport() {
	  (0, _spectaclePpa.preloader)([_imagesCharactersIan_arms_foldedPng2['default'], _imagesCharactersIan_headshot_smilePng2['default'], _imagesCharactersSara_twist_hands_out_yayPng2['default'], _imagesCharactersSara_smilePng2['default'], _imagesCharactersIan_sara_sidePng2['default'], _imagesCharactersIan_sara_lean_questioningPng2['default'], _imagesLevel0_startPng2['default'], _imagesLevel1_startPng2['default'], _imagesLevel2_startPng2['default']]);
	}
	
	function missionReportSection(_ref) {
	  var level = _ref.level;
	  var regionData = _ref.regionData;
	
	  var md = levels[level].md;
	  var missionReportQuestions = md.getQuestions('Questions', 'Content', regionData);
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'mission-report' },
	    level === 3 && (0, _baseSlidesVideoSlide2['default'])({
	      id: 'intro-video',
	      notes: md.getSubSectionAsHtml('Intro Video', 'Notes', false, regionData),
	      youTubeId: md.getSectionMetadata('Intro Video', 'YouTube', regionData)
	    }),
	    (level === 1 || level === 3) && (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'scoring',
	      characterSide: 'left',
	      characterImage: _imagesCharactersSara_twist_hands_out_yayPng2['default'],
	      html: md.getSubSectionAsHtml('Scoring', 'Content', false, regionData),
	      notes: md.getSubSectionAsHtml('Scoring', 'Notes', false, regionData)
	    }),
	    level === 2 && (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'scoring',
	      characterSide: 'right',
	      characterImage: _imagesCharactersSara_smilePng2['default'],
	      html: md.getSubSectionAsHtml('Scoring', 'Content', false, regionData),
	      notes: md.getSubSectionAsHtml('Scoring', 'Notes', false, regionData)
	    }),
	    (level === 1 || level === 3) && (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'instructions',
	      characterSide: 'right',
	      characterImage: _imagesCharactersIan_headshot_smilePng2['default'],
	      html: md.getSubSectionAsHtml('Instructions', 'Content', false, regionData),
	      notes: md.getSubSectionAsHtml('Instructions', 'Notes', false, regionData)
	    }),
	    level === 2 && (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'instructions',
	      characterSide: 'left',
	      characterImage: _imagesCharactersIan_arms_foldedPng2['default'],
	      html: md.getSubSectionAsHtml('Instructions', 'Content', false, regionData),
	      notes: md.getSubSectionAsHtml('Instructions', 'Notes', false, regionData)
	    }),
	    _react2['default'].createElement(
	      _spectaclePpa.Slide,
	      {
	        id: 'report',
	        bgColor: 'black',
	        missionReportQuestions: missionReportQuestions },
	      _react2['default'].createElement(
	        'div',
	        {
	          className: 'ui-slide mission-report-level-' + (level - 1) },
	        _react2['default'].createElement(
	          'header',
	          {
	            className: 'level-header' },
	          _react2['default'].createElement(
	            'figure',
	            { className: 'level-header-thumb' },
	            _react2['default'].createElement('img', { src: levels[level - 1].img })
	          ),
	          _react2['default'].createElement(
	            _spectaclePpa.Heading,
	            { size: 2 },
	            'Mission Report:',
	            _react2['default'].createElement('br', null),
	            md.getSectionMetadata('Mission Report', 'Title')
	          )
	        ),
	        _react2['default'].createElement(
	          'section',
	          {
	            className: 'mission-report-form' },
	          _react2['default'].createElement(_componentsMissionReport2['default'], { missionReportQuestions: missionReportQuestions })
	        )
	      )
	    ),
	    (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'impact',
	      characterSide: 'right',
	      characterImage: _imagesCharactersIan_sara_sidePng2['default'],
	      html: md.getSubSectionAsHtml('Impact', 'Content', false, regionData),
	      notes: md.getSubSectionAsHtml('Impact', 'Notes', false, regionData)
	    }),
	    (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'class-discussion',
	      characterSide: 'left',
	      characterImage: _imagesCharactersIan_sara_lean_questioningPng2['default'],
	      html: md.getSubSectionAsHtml('Class Discussion', 'Content', false, regionData),
	      notes: md.getSubSectionAsHtml('Class Discussion', 'Notes', false, regionData)
	    })
	  );
	}
	
	exports['default'] = missionReportSection;
	/* Intro video in level 3 */ /* Scoring level 1 & 3 */ /* Scoring level 2  */ /* Instructions levels 1 & 3 */ /* Instructions level 2 */ /* Mission Reporting Screen */ /* Impact screen */ /* Class Discussion */

/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

	/* eslint react/no-multi-comp: 0 */
	
	'use strict';
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.preloadClassActivity = preloadClassActivity;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _baseSlidesHeadingSlide = __webpack_require__(161);
	
	var _baseSlidesHeadingSlide2 = _interopRequireDefault(_baseSlidesHeadingSlide);
	
	var _baseSlidesVideoSlide = __webpack_require__(55);
	
	var _baseSlidesVideoSlide2 = _interopRequireDefault(_baseSlidesVideoSlide);
	
	var _baseSlidesBalloonSlide = __webpack_require__(85);
	
	var _baseSlidesBalloonSlide2 = _interopRequireDefault(_baseSlidesBalloonSlide);
	
	var _imagesCharactersIan_headshot_smilePng = __webpack_require__(855);
	
	var _imagesCharactersIan_headshot_smilePng2 = _interopRequireDefault(_imagesCharactersIan_headshot_smilePng);
	
	var _imagesCharactersIan_sara_sidePng = __webpack_require__(152);
	
	var _imagesCharactersIan_sara_sidePng2 = _interopRequireDefault(_imagesCharactersIan_sara_sidePng);
	
	var _imagesCharactersIan_sara_lean_smilePng = __webpack_require__(405);
	
	var _imagesCharactersIan_sara_lean_smilePng2 = _interopRequireDefault(_imagesCharactersIan_sara_lean_smilePng);
	
	var _imagesCharactersIan_sidePng = __webpack_require__(857);
	
	var _imagesCharactersIan_sidePng2 = _interopRequireDefault(_imagesCharactersIan_sidePng);
	
	var _imagesCharactersSara_surprisedPng = __webpack_require__(859);
	
	var _imagesCharactersSara_surprisedPng2 = _interopRequireDefault(_imagesCharactersSara_surprisedPng);
	
	var _imagesCharactersSara_twist_hands_out_heyheyPng = __webpack_require__(860);
	
	var _imagesCharactersSara_twist_hands_out_heyheyPng2 = _interopRequireDefault(_imagesCharactersSara_twist_hands_out_heyheyPng);
	
	var _imagesCharactersIan_pointing_upPng = __webpack_require__(404);
	
	var _imagesCharactersIan_pointing_upPng2 = _interopRequireDefault(_imagesCharactersIan_pointing_upPng);
	
	var _imagesCharactersIan_pointing_leftPng = __webpack_require__(2277);
	
	var _imagesCharactersIan_pointing_leftPng2 = _interopRequireDefault(_imagesCharactersIan_pointing_leftPng);
	
	var _imagesCharactersIan_pointing_downPng = __webpack_require__(2276);
	
	var _imagesCharactersIan_pointing_downPng2 = _interopRequireDefault(_imagesCharactersIan_pointing_downPng);
	
	var _imagesCharactersSara_smilePng = __webpack_require__(406);
	
	var _imagesCharactersSara_smilePng2 = _interopRequireDefault(_imagesCharactersSara_smilePng);
	
	var _imagesCharactersSara_humphPng = __webpack_require__(2280);
	
	var _imagesCharactersSara_humphPng2 = _interopRequireDefault(_imagesCharactersSara_humphPng);
	
	var _imagesCharactersIan_sara_lean_questioningPng = __webpack_require__(199);
	
	var _imagesCharactersIan_sara_lean_questioningPng2 = _interopRequireDefault(_imagesCharactersIan_sara_lean_questioningPng);
	
	var _helpersMarkdownScript = __webpack_require__(9);
	
	var _helpersMarkdownScript2 = _interopRequireDefault(_helpersMarkdownScript);
	
	var _level1_floorplanMd = __webpack_require__(1550);
	
	var _level1_floorplanMd2 = _interopRequireDefault(_level1_floorplanMd);
	
	var _level2_kitRapMd = __webpack_require__(1551);
	
	var _level2_kitRapMd2 = _interopRequireDefault(_level2_kitRapMd);
	
	var _level3_drawingMd = __webpack_require__(1552);
	
	var _level3_drawingMd2 = _interopRequireDefault(_level3_drawingMd);
	
	var levels = {
	  '1': { md: new _helpersMarkdownScript2['default'](_level1_floorplanMd2['default']) },
	  '2': { md: new _helpersMarkdownScript2['default'](_level2_kitRapMd2['default']) },
	  '3': { md: new _helpersMarkdownScript2['default'](_level3_drawingMd2['default']) }
	};
	
	function preloadClassActivity() {
	  (0, _spectaclePpa.preloader)([_imagesCharactersIan_headshot_smilePng2['default'], _imagesCharactersIan_sara_sidePng2['default'], _imagesCharactersIan_sara_lean_smilePng2['default'], _imagesCharactersIan_sidePng2['default'], _imagesCharactersSara_surprisedPng2['default'], _imagesCharactersSara_twist_hands_out_heyheyPng2['default'], _imagesCharactersIan_pointing_upPng2['default'], _imagesCharactersIan_pointing_leftPng2['default'], _imagesCharactersIan_pointing_downPng2['default'], _imagesCharactersSara_smilePng2['default'], _imagesCharactersSara_humphPng2['default'], _imagesCharactersIan_sara_lean_questioningPng2['default']]);
	}
	
	function introVideo(level, regionData) {
	  var md = levels[level].md;
	  return (0, _baseSlidesVideoSlide2['default'])({
	    id: 'intro-video',
	    notes: md.getSubSectionAsHtml('Intro Video', 'Notes', false, regionData),
	    youTubeId: md.getSectionMetadata('Intro Video', 'YouTube', regionData)
	  });
	}
	
	function sizzle(level, regionData) {
	  var md = levels[level].md;
	  return (0, _baseSlidesBalloonSlide2['default'])({
	    id: 'sizzle',
	    characterSide: 'right',
	    characterImage: _imagesCharactersIan_sara_sidePng2['default'],
	    notes: md.getSubSectionAsHtml('Sizzle', 'Notes', false, regionData),
	    html: md.getSubSectionAsHtml('Sizzle', 'Content', false, regionData)
	  });
	}
	
	function instructions(level, regionData) {
	  var md = levels[level].md;
	  return (0, _baseSlidesBalloonSlide2['default'])({
	    id: 'instructions',
	    characterSide: 'right',
	    characterImage: _imagesCharactersIan_sara_lean_smilePng2['default'],
	    notes: md.getSubSectionAsHtml('Instructions', 'Notes', false, regionData),
	    html: md.getSubSectionAsHtml('Instructions', 'Content', false, regionData)
	  });
	}
	
	function scoring(level, regionData) {
	  var md = levels[level].md;
	  return (0, _baseSlidesBalloonSlide2['default'])({
	    id: 'scoring',
	    characterSide: 'left',
	    characterImage: _imagesCharactersIan_sidePng2['default'],
	    notes: md.getSubSectionAsHtml('Scoring', 'Notes', false, regionData),
	    html: md.getSubSectionAsHtml('Scoring', 'Content', false, regionData)
	  });
	}
	
	function level1(regionData) {
	  // floorplan
	  var level = '1';
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'class-activity-' + level },
	    introVideo(level, regionData),
	    sizzle(level, regionData),
	    instructions(level, regionData)
	  );
	}
	
	function level2(regionData) {
	  // Draw Energy
	  var level = '2';
	  var md = levels[level].md;
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'class-activity-' + level },
	    introVideo(level, regionData),
	    sizzle(level, regionData),
	    instructions(level, regionData),
	    (0, _baseSlidesVideoSlide2['default'])({
	      id: 'rap-backtrack-practice',
	      notes: md.getSubSectionAsHtml('Rap Backtrack Practice', 'Notes', false, regionData),
	      youTubeId: md.getSectionMetadata('Rap Backtrack Practice', 'YouTube', regionData)
	    }),
	    scoring(level, regionData),
	    (0, _baseSlidesVideoSlide2['default'])({
	      id: 'rap-backtrack-perform',
	      notes: md.getSubSectionAsHtml('Rap Backtrack Perform', 'Notes', false, regionData),
	      youTubeId: md.getSectionMetadata('Rap Backtrack Perform', 'YouTube', regionData)
	    })
	  );
	}
	
	function level3(regionData) {
	  // Energy saving rap
	  var level = '3';
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'class-activity-' + level },
	    introVideo(level, regionData),
	    sizzle(level, regionData),
	    instructions(level, regionData)
	  );
	}
	
	function classActivitySection(_ref) {
	  var level = _ref.level;
	  var subActivity = _ref.subActivity;
	  var regionData = _ref.regionData;
	
	  switch ('' + level + (subActivity ? subActivity : '')) {
	    case '1':
	      return level1(regionData);
	    case '2':
	      return level2(regionData);
	    case '3':
	      return level3(regionData);
	    default:
	      return (0, _baseSlidesHeadingSlide2['default'])({ heading: 'Unknown' });
	  }
	}
	
	exports['default'] = classActivitySection;
	/* Intro Video */ /* Sizzle */ /* Instructions */ /* Intro Video */ /* Sizzle */ /* Instructions */ /* Rap Backtrack Practice */ /* Scoring */ /* Rap Backtrack Perform */ /* Intro Video */ /* Sizzle */ /* Instructions */

/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.preloadMissionAssignment = preloadMissionAssignment;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _baseSlidesHeadingSlide = __webpack_require__(161);
	
	var _baseSlidesHeadingSlide2 = _interopRequireDefault(_baseSlidesHeadingSlide);
	
	var _baseSlidesBalloonSlide = __webpack_require__(85);
	
	var _baseSlidesBalloonSlide2 = _interopRequireDefault(_baseSlidesBalloonSlide);
	
	var _baseSlidesVideoSlide = __webpack_require__(55);
	
	var _baseSlidesVideoSlide2 = _interopRequireDefault(_baseSlidesVideoSlide);
	
	var _imagesEmergencyPreparednessSquadGlowPng = __webpack_require__(407);
	
	var _imagesEmergencyPreparednessSquadGlowPng2 = _interopRequireDefault(_imagesEmergencyPreparednessSquadGlowPng);
	
	var _imagesCharactersIan_sara_sidePng = __webpack_require__(152);
	
	var _imagesCharactersIan_sara_sidePng2 = _interopRequireDefault(_imagesCharactersIan_sara_sidePng);
	
	var _imagesCharactersIan_sara_lean_questioningPng = __webpack_require__(199);
	
	var _imagesCharactersIan_sara_lean_questioningPng2 = _interopRequireDefault(_imagesCharactersIan_sara_lean_questioningPng);
	
	var _helpersMarkdownScript = __webpack_require__(9);
	
	var _helpersMarkdownScript2 = _interopRequireDefault(_helpersMarkdownScript);
	
	var _level1_makeAPlanMd = __webpack_require__(1553);
	
	var _level1_makeAPlanMd2 = _interopRequireDefault(_level1_makeAPlanMd);
	
	var _level2_getAKitMd = __webpack_require__(1554);
	
	var _level2_getAKitMd2 = _interopRequireDefault(_level2_getAKitMd);
	
	var _level3_keepBuildingKitMd = __webpack_require__(1555);
	
	var _level3_keepBuildingKitMd2 = _interopRequireDefault(_level3_keepBuildingKitMd);
	
	var levels = {
	  '1': { md: new _helpersMarkdownScript2['default'](_level1_makeAPlanMd2['default']) },
	  '2': { md: new _helpersMarkdownScript2['default'](_level2_getAKitMd2['default']) },
	  '3': { md: new _helpersMarkdownScript2['default'](_level3_keepBuildingKitMd2['default']) }
	};
	
	function preloadMissionAssignment() {
	  (0, _spectaclePpa.preloader)([_imagesEmergencyPreparednessSquadGlowPng2['default'], _imagesCharactersIan_sara_sidePng2['default'], _imagesCharactersIan_sara_lean_questioningPng2['default']]);
	}
	
	function missionAssignmentSection(_ref) {
	  var level = _ref.level;
	  var title = _ref.title;
	  var regionData = _ref.regionData;
	
	  var md = levels[level].md;
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'mission-assignment' },
	    (0, _baseSlidesVideoSlide2['default'])({
	      id: 'mission-intro-video',
	      notes: md.getSubSectionAsHtml('Mission Intro Video', 'Notes', false, regionData),
	      youTubeId: md.getSectionMetadata('Mission Intro Video', 'YouTube', regionData)
	    }),
	    (0, _baseSlidesHeadingSlide2['default'])({
	      id: 'sizzle',
	      beforeImage: _imagesEmergencyPreparednessSquadGlowPng2['default'],
	      subHeading: 'Mission ' + level + ':<br/> ' + title,
	      notes: md.getSubSectionAsHtml('Mission Assignment', 'Notes', false, regionData),
	      bgColor: 'black'
	    }),
	    (level === 1 || level === 3) && (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'instructions',
	      characterSide: 'right',
	      characterImage: _imagesCharactersIan_sara_sidePng2['default'],
	      notes: md.getSubSectionAsHtml('Instructions', 'Notes', false, regionData),
	      html: md.getSubSectionAsHtml('Instructions', 'Content', false, regionData)
	    }),
	    level === 2 && (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'instructions',
	      characterSide: 'right',
	      characterImage: _imagesCharactersIan_sara_lean_questioningPng2['default'],
	      notes: md.getSubSectionAsHtml('Instructions', 'Notes', false, regionData),
	      html: md.getSubSectionAsHtml('Instructions', 'Content', false, regionData)
	    })
	  );
	}
	
	exports['default'] = missionAssignmentSection;
	/* Mission Intro Video*/ /* Sizzle */ /* Mission Instructions levels 1 & 3 */ /* Mission Instructions levels 2 */

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.preloadFinish = preloadFinish;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _componentsCompleteLevelButton = __webpack_require__(44);
	
	var _componentsCompleteLevelButton2 = _interopRequireDefault(_componentsCompleteLevelButton);
	
	var _baseSlidesBalloonSlide = __webpack_require__(85);
	
	var _baseSlidesBalloonSlide2 = _interopRequireDefault(_baseSlidesBalloonSlide);
	
	var _baseSlidesVideoSlide = __webpack_require__(55);
	
	var _baseSlidesVideoSlide2 = _interopRequireDefault(_baseSlidesVideoSlide);
	
	var _imagesCharactersIan_sara_lean_smilePng = __webpack_require__(405);
	
	var _imagesCharactersIan_sara_lean_smilePng2 = _interopRequireDefault(_imagesCharactersIan_sara_lean_smilePng);
	
	var _imagesCharactersIan_sara_sidePng = __webpack_require__(152);
	
	var _imagesCharactersIan_sara_sidePng2 = _interopRequireDefault(_imagesCharactersIan_sara_sidePng);
	
	var _imagesCharactersIan_sara_lean_questioningPng = __webpack_require__(199);
	
	var _imagesCharactersIan_sara_lean_questioningPng2 = _interopRequireDefault(_imagesCharactersIan_sara_lean_questioningPng);
	
	var _imagesCharactersIan_sara_sillyPng = __webpack_require__(856);
	
	var _imagesCharactersIan_sara_sillyPng2 = _interopRequireDefault(_imagesCharactersIan_sara_sillyPng);
	
	var _helpersMarkdownScript = __webpack_require__(9);
	
	var _helpersMarkdownScript2 = _interopRequireDefault(_helpersMarkdownScript);
	
	var _finishMd = __webpack_require__(1556);
	
	var _finishMd2 = _interopRequireDefault(_finishMd);
	
	var _level1_completeSvg = __webpack_require__(2292);
	
	var _level1_completeSvg2 = _interopRequireDefault(_level1_completeSvg);
	
	var _level2_completeSvg = __webpack_require__(2293);
	
	var _level2_completeSvg2 = _interopRequireDefault(_level2_completeSvg);
	
	var _level3_completeSvg = __webpack_require__(2294);
	
	var _level3_completeSvg2 = _interopRequireDefault(_level3_completeSvg);
	
	var md = new _helpersMarkdownScript2['default'](_finishMd2['default']);
	
	var levels = {
	  '1': { img: _level1_completeSvg2['default'] },
	  '2': { img: _level2_completeSvg2['default'] },
	  '3': { img: _level3_completeSvg2['default'] }
	};
	
	function preloadFinish() {
	  (0, _spectaclePpa.preloader)([_imagesCharactersIan_sara_lean_smilePng2['default'], _imagesCharactersIan_sara_sidePng2['default'], _imagesCharactersIan_sara_lean_questioningPng2['default'], _imagesCharactersIan_sara_sillyPng2['default'], _level1_completeSvg2['default'], _level2_completeSvg2['default'], _level3_completeSvg2['default']]);
	}
	
	function finishSection(_ref) {
	  var level = _ref.level;
	  var regionData = _ref.regionData;
	
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'finish' },
	    level === 1 && (0, _baseSlidesVideoSlide2['default'])({
	      id: 'outtakes',
	      notes: md.getSubSectionAsHtml('Outtakes 1', 'Notes', false, regionData),
	      youTubeId: md.getSectionMetadata('Outtakes 1', 'YouTube', regionData)
	    }),
	    level === 2 && (0, _baseSlidesVideoSlide2['default'])({
	      id: 'outtakes',
	      notes: md.getSubSectionAsHtml('Outtakes 2', 'Notes', false, regionData),
	      youTubeId: md.getSectionMetadata('Outtakes 2', 'YouTube', regionData)
	    }),
	    level !== 3 && (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'scoreboard-recap',
	      characterSide: 'left',
	      characterImage: _imagesCharactersIan_sara_sidePng2['default'],
	      html: md.getSubSectionAsHtml('Scoreboard Recap', 'Content', false, regionData),
	      notes: md.getSubSectionAsHtml('Scoreboard Recap', 'Notes', false, regionData)
	    }),
	    level !== 3 && (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'earn-more-points',
	      characterSide: 'right',
	      characterImage: _imagesCharactersIan_sara_lean_questioningPng2['default'],
	      html: md.getSubSectionAsHtml('Earn More Points', 'Content', false, regionData),
	      notes: md.getSubSectionAsHtml('Earn More Points', 'Notes', false, regionData)
	    }),
	    level === 1 && (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'farewell',
	      characterSide: 'left',
	      characterImage: _imagesCharactersIan_sara_lean_smilePng2['default'],
	      html: md.getSubSectionAsHtml('Farewell', 'Content', false, regionData),
	      notes: md.getSubSectionAsHtml('Farewell', 'Notes', false, regionData)
	    }),
	    level === 2 && (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'farewell',
	      characterSide: 'left',
	      characterImage: _imagesCharactersIan_sara_sidePng2['default'],
	      html: md.getSubSectionAsHtml('Farewell', 'Content', false, regionData),
	      notes: md.getSubSectionAsHtml('Farewell', 'Notes', false, regionData)
	    }),
	    level === 3 && (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'farewell',
	      characterSide: 'left',
	      characterImage: _imagesCharactersIan_sara_sillyPng2['default'],
	      html: md.getSubSectionAsHtml('Farewell', 'Content', false, regionData),
	      notes: md.getSubSectionAsHtml('Farewell', 'Notes', false, regionData)
	    }),
	    _react2['default'].createElement(
	      _spectaclePpa.Slide,
	      {
	        id: 'level-completed',
	        notes: '<h2>Level ' + level + ' Finished</h2>',
	        bgColor: 'transparent',
	        finish: true },
	      _react2['default'].createElement(
	        'div',
	        { className: 'level-complete' },
	        _react2['default'].createElement(
	          'div',
	          { className: 'level-complete-content' },
	          _react2['default'].createElement(
	            'figure',
	            { className: 'level-complete-graphic' },
	            _react2['default'].createElement('img', { src: levels[level].img })
	          ),
	          _react2['default'].createElement(
	            _spectaclePpa.Heading,
	            { size: 2 },
	            'You\'ve finished'
	          ),
	          _react2['default'].createElement(
	            _spectaclePpa.Heading,
	            { size: 2 },
	            'level ',
	            level,
	            ' of 3'
	          ),
	          _react2['default'].createElement(_componentsCompleteLevelButton2['default'], null)
	        )
	      )
	    )
	  );
	}
	
	exports['default'] = finishSection;
	/* Outtakes 1 */ /* Outtakes 2 */ /* Scoreboard Recap */ /* Earn More Points */ /* Farewell levels 1 */ /* Farewell levels 2 */ /* Farewell levels 3 */ /* Level complete */

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.preloadStart = preloadStart;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _baseSlidesVideoSlide = __webpack_require__(56);
	
	var _baseSlidesVideoSlide2 = _interopRequireDefault(_baseSlidesVideoSlide);
	
	var _imagesPpa_presentsSvg = __webpack_require__(2309);
	
	var _imagesPpa_presentsSvg2 = _interopRequireDefault(_imagesPpa_presentsSvg);
	
	var _imagesEmergencyPreparednessSquadGlowPng = __webpack_require__(413);
	
	var _imagesEmergencyPreparednessSquadGlowPng2 = _interopRequireDefault(_imagesEmergencyPreparednessSquadGlowPng);
	
	var _helpersMarkdownScript = __webpack_require__(9);
	
	var _helpersMarkdownScript2 = _interopRequireDefault(_helpersMarkdownScript);
	
	var _startMd = __webpack_require__(1566);
	
	var _startMd2 = _interopRequireDefault(_startMd);
	
	var _imagesLevel1_startPng = __webpack_require__(414);
	
	var _imagesLevel1_startPng2 = _interopRequireDefault(_imagesLevel1_startPng);
	
	var _imagesLevel2_startPng = __webpack_require__(415);
	
	var _imagesLevel2_startPng2 = _interopRequireDefault(_imagesLevel2_startPng);
	
	var _imagesLevel3_startPng = __webpack_require__(869);
	
	var _imagesLevel3_startPng2 = _interopRequireDefault(_imagesLevel3_startPng);
	
	var levels = {
	  '1': { img: _imagesLevel1_startPng2['default'] },
	  '2': { img: _imagesLevel2_startPng2['default'] },
	  '3': { img: _imagesLevel3_startPng2['default'] }
	};
	
	var md = new _helpersMarkdownScript2['default'](_startMd2['default']);
	
	function preloadStart() {
	  (0, _spectaclePpa.preloader)([_imagesPpa_presentsSvg2['default'], _imagesLevel1_startPng2['default'], _imagesLevel2_startPng2['default'], _imagesLevel3_startPng2['default']]);
	}
	
	function startSection(_ref) {
	  var level = _ref.level;
	  var title = _ref.title;
	  var regionData = _ref.regionData;
	
	  /* Level intro graphic */
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'start' },
	    _react2['default'].createElement(
	      _spectaclePpa.Slide,
	      {
	        id: 'ppa-presents',
	        key: 'ppa-presents',
	        bgColor: 'black',
	        notes: md.getSubSectionAsHtml('Level ' + level + ' Start', 'Notes', false, regionData) },
	      _react2['default'].createElement(
	        'div',
	        {
	          className: 'ui-slide' },
	        _react2['default'].createElement(
	          'div',
	          { className: 'flex-image' },
	          _react2['default'].createElement('img', {
	            className: 'heading-image heading-image-before',
	            src: _imagesPpa_presentsSvg2['default'] })
	        )
	      )
	    ),
	    _react2['default'].createElement(
	      _spectaclePpa.Slide,
	      {
	        id: 'ppa-eps',
	        key: 'ppa-eps',
	        bgColor: 'black',
	        notes: md.getSubSectionAsHtml('Level ' + level + ' Start', 'Notes', false, regionData) },
	      _react2['default'].createElement(
	        'div',
	        {
	          className: 'ui-slide' },
	        _react2['default'].createElement(
	          'div',
	          { className: 'flex-image' },
	          _react2['default'].createElement('img', { className: 'eps-logo heading-image',
	            src: _imagesEmergencyPreparednessSquadGlowPng2['default'] })
	        )
	      )
	    ),
	    _react2['default'].createElement(
	      _spectaclePpa.Slide,
	      {
	        id: 'level',
	        key: 'level',
	        bgColor: 'black',
	        notes: md.getSubSectionAsHtml('Level ' + level + ' Icon', 'Notes', false, regionData) },
	      _react2['default'].createElement(
	        'div',
	        {
	          className: 'ui-slide' },
	        _react2['default'].createElement(
	          'div',
	          { className: 'title-image' },
	          _react2['default'].createElement('img', {
	            className: 'heading-image heading-image-before',
	            src: levels[level].img }),
	          _react2['default'].createElement(
	            _spectaclePpa.Heading,
	            { size: 1 },
	            _react2['default'].createElement(
	              'strong',
	              null,
	              title
	            )
	          ),
	          _react2['default'].createElement(
	            _spectaclePpa.Heading,
	            { size: 2 },
	            _react2['default'].createElement(
	              'strong',
	              null,
	              'Level ',
	              level
	            )
	          )
	        )
	      )
	    ),
	    (level === 1 || level === 2) && (0, _baseSlidesVideoSlide2['default'])({
	      id: 'level-intro',
	      notes: md.getSubSectionAsHtml('Level ' + level + ' Intro', 'Notes', false, regionData),
	      youTubeId: md.getSectionMetadata('Level ' + level + ' Intro', 'YouTube', regionData)
	    })
	  );
	}
	
	exports['default'] = startSection;
	/* Sanksrit for Vanessa */ /* lokah samastah sukhino bhavantu */ /* may all beings everywhere be at peace */ /* Sara and Ian Level Intro */

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.preloadSong = preloadSong;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _baseSlidesVideoSlide = __webpack_require__(56);
	
	var _baseSlidesVideoSlide2 = _interopRequireDefault(_baseSlidesVideoSlide);
	
	var _imagesCharactersIan_sara_sillyPng = __webpack_require__(864);
	
	var _imagesCharactersIan_sara_sillyPng2 = _interopRequireDefault(_imagesCharactersIan_sara_sillyPng);
	
	var _imagesCharactersIan_sara_two_fingersPng = __webpack_require__(2298);
	
	var _imagesCharactersIan_sara_two_fingersPng2 = _interopRequireDefault(_imagesCharactersIan_sara_two_fingersPng);
	
	var _helpersMarkdownScript = __webpack_require__(9);
	
	var _helpersMarkdownScript2 = _interopRequireDefault(_helpersMarkdownScript);
	
	var _songMd = __webpack_require__(1567);
	
	var _songMd2 = _interopRequireDefault(_songMd);
	
	var md = new _helpersMarkdownScript2['default'](_songMd2['default']);
	
	function preloadSong() {
	  (0, _spectaclePpa.preloader)([_imagesCharactersIan_sara_sillyPng2['default'], _imagesCharactersIan_sara_two_fingersPng2['default']]);
	}
	
	function songSection(_ref) {
	  var regionData = _ref.regionData;
	
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'song' },
	    (0, _baseSlidesVideoSlide2['default'])({
	      id: 'video',
	      notes: md.getSubSectionAsHtml('Song', 'Notes', false, regionData),
	      youTubeId: md.getSectionMetadata('Song', 'YouTube', regionData)
	    })
	  );
	}
	
	exports['default'] = songSection;
	/* Song */

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

	/* eslint react/no-multi-comp: 0 */
	
	'use strict';
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _baseSlidesVideoSlide = __webpack_require__(56);
	
	var _baseSlidesVideoSlide2 = _interopRequireDefault(_baseSlidesVideoSlide);
	
	var _helpersMarkdownScript = __webpack_require__(9);
	
	var _helpersMarkdownScript2 = _interopRequireDefault(_helpersMarkdownScript);
	
	var _level1_egstoryMd = __webpack_require__(1569);
	
	var _level1_egstoryMd2 = _interopRequireDefault(_level1_egstoryMd);
	
	var _level2_egstoryMd = __webpack_require__(1570);
	
	var _level2_egstoryMd2 = _interopRequireDefault(_level2_egstoryMd);
	
	var _level3_egstoryMd = __webpack_require__(1571);
	
	var _level3_egstoryMd2 = _interopRequireDefault(_level3_egstoryMd);
	
	var levels = {
	  '1': { md: new _helpersMarkdownScript2['default'](_level1_egstoryMd2['default']) },
	  '2': { md: new _helpersMarkdownScript2['default'](_level2_egstoryMd2['default']) },
	  '3': { md: new _helpersMarkdownScript2['default'](_level3_egstoryMd2['default']) }
	};
	
	function esOpeningStory(_ref) {
	  var level = _ref.level;
	  var regionData = _ref.regionData;
	
	  var md = levels[level].md;
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: "esGooberStory" },
	    level === 2 && (0, _baseSlidesVideoSlide2['default'])({
	      id: 'sharknado',
	      notes: md.getSubSectionAsHtml('Sharknado', 'Notes', false, regionData),
	      youTubeId: md.getSectionMetadata('Sharknado', 'YouTube', regionData)
	    }),
	    level === 2 && (0, _baseSlidesVideoSlide2['default'])({
	      id: 'calming-breath-recap',
	      notes: md.getSubSectionAsHtml('Calming Breath Recap', 'Notes', false, regionData),
	      youTubeId: md.getSectionMetadata('Calming Breath Recap', 'YouTube', regionData)
	    }),
	    (0, _baseSlidesVideoSlide2['default'])({
	      id: 'story',
	      notes: md.getSubSectionAsHtml('Esmeralda and Goober Story', 'Notes', false, regionData),
	      youTubeId: md.getSectionMetadata('Esmeralda and Goober Story', 'YouTube', regionData)
	    }),
	    level === 1 && (0, _baseSlidesVideoSlide2['default'])({
	      id: 'calming-breath',
	      notes: md.getSubSectionAsHtml('Calming Breath Intro', 'Notes', false, regionData),
	      youTubeId: md.getSectionMetadata('Calming Breath Intro', 'YouTube', regionData)
	    })
	  );
	}
	
	exports['default'] = esOpeningStory;
	module.exports = exports['default'];
	/* Sharknado in Level 2 */ /* Calming breath recap in Level 2 */ /* Esmerelda and Goober Story  */ /* Calming breath intro in Level 1 */

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.preloadMissionReport = preloadMissionReport;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _componentsMissionReport = __webpack_require__(76);
	
	var _componentsMissionReport2 = _interopRequireDefault(_componentsMissionReport);
	
	var _baseSlidesBalloonSlide = __webpack_require__(86);
	
	var _baseSlidesBalloonSlide2 = _interopRequireDefault(_baseSlidesBalloonSlide);
	
	var _baseSlidesVideoSlide = __webpack_require__(56);
	
	var _baseSlidesVideoSlide2 = _interopRequireDefault(_baseSlidesVideoSlide);
	
	var _imagesCharactersIan_arms_foldedPng = __webpack_require__(862);
	
	var _imagesCharactersIan_arms_foldedPng2 = _interopRequireDefault(_imagesCharactersIan_arms_foldedPng);
	
	var _imagesCharactersIan_headshot_smilePng = __webpack_require__(863);
	
	var _imagesCharactersIan_headshot_smilePng2 = _interopRequireDefault(_imagesCharactersIan_headshot_smilePng);
	
	var _imagesCharactersSara_twist_hands_out_yayPng = __webpack_require__(2301);
	
	var _imagesCharactersSara_twist_hands_out_yayPng2 = _interopRequireDefault(_imagesCharactersSara_twist_hands_out_yayPng);
	
	var _imagesCharactersSara_smilePng = __webpack_require__(412);
	
	var _imagesCharactersSara_smilePng2 = _interopRequireDefault(_imagesCharactersSara_smilePng);
	
	var _imagesCharactersIan_sara_sidePng = __webpack_require__(153);
	
	var _imagesCharactersIan_sara_sidePng2 = _interopRequireDefault(_imagesCharactersIan_sara_sidePng);
	
	var _imagesCharactersIan_sara_lean_questioningPng = __webpack_require__(200);
	
	var _imagesCharactersIan_sara_lean_questioningPng2 = _interopRequireDefault(_imagesCharactersIan_sara_lean_questioningPng);
	
	var _helpersMarkdownScript = __webpack_require__(9);
	
	var _helpersMarkdownScript2 = _interopRequireDefault(_helpersMarkdownScript);
	
	var _level1_knowTheRisksMd = __webpack_require__(1572);
	
	var _level1_knowTheRisksMd2 = _interopRequireDefault(_level1_knowTheRisksMd);
	
	var _level2_makeAPlanMd = __webpack_require__(1573);
	
	var _level2_makeAPlanMd2 = _interopRequireDefault(_level2_makeAPlanMd);
	
	var _level3_getAKitMd = __webpack_require__(1574);
	
	var _level3_getAKitMd2 = _interopRequireDefault(_level3_getAKitMd);
	
	var _imagesLevel0_startPng = __webpack_require__(2305);
	
	var _imagesLevel0_startPng2 = _interopRequireDefault(_imagesLevel0_startPng);
	
	var _imagesLevel1_startPng = __webpack_require__(414);
	
	var _imagesLevel1_startPng2 = _interopRequireDefault(_imagesLevel1_startPng);
	
	var _imagesLevel2_startPng = __webpack_require__(415);
	
	var _imagesLevel2_startPng2 = _interopRequireDefault(_imagesLevel2_startPng);
	
	var levels = {
	  '0': { img: _imagesLevel0_startPng2['default'] },
	  '1': { md: new _helpersMarkdownScript2['default'](_level1_knowTheRisksMd2['default']), img: _imagesLevel1_startPng2['default'] },
	  '2': { md: new _helpersMarkdownScript2['default'](_level2_makeAPlanMd2['default']), img: _imagesLevel2_startPng2['default'] },
	  '3': { md: new _helpersMarkdownScript2['default'](_level3_getAKitMd2['default']) }
	};
	
	function preloadMissionReport() {
	  (0, _spectaclePpa.preloader)([_imagesCharactersIan_arms_foldedPng2['default'], _imagesCharactersIan_headshot_smilePng2['default'], _imagesCharactersSara_twist_hands_out_yayPng2['default'], _imagesCharactersSara_smilePng2['default'], _imagesCharactersIan_sara_sidePng2['default'], _imagesCharactersIan_sara_lean_questioningPng2['default'], _imagesLevel0_startPng2['default'], _imagesLevel1_startPng2['default'], _imagesLevel2_startPng2['default']]);
	}
	
	function missionReportSection(_ref) {
	  var level = _ref.level;
	  var regionData = _ref.regionData;
	
	  var md = levels[level].md;
	  var missionReportQuestions = md.getQuestions('Questions', 'Content', regionData);
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'mission-report' },
	    level === 3 && (0, _baseSlidesVideoSlide2['default'])({
	      id: 'intro-video',
	      notes: md.getSubSectionAsHtml('Intro Video', 'Notes', false, regionData),
	      youTubeId: md.getSectionMetadata('Intro Video', 'YouTube', regionData)
	    }),
	    (level === 1 || level === 3) && (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'scoring',
	      characterSide: 'left',
	      characterImage: _imagesCharactersSara_twist_hands_out_yayPng2['default'],
	      html: md.getSubSectionAsHtml('Scoring', 'Content', false, regionData),
	      notes: md.getSubSectionAsHtml('Scoring', 'Notes', false, regionData)
	    }),
	    level === 2 && (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'scoring',
	      characterSide: 'right',
	      characterImage: _imagesCharactersSara_smilePng2['default'],
	      html: md.getSubSectionAsHtml('Scoring', 'Content', false, regionData),
	      notes: md.getSubSectionAsHtml('Scoring', 'Notes', false, regionData)
	    }),
	    (level === 1 || level === 3) && (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'instructions',
	      characterSide: 'right',
	      characterImage: _imagesCharactersIan_headshot_smilePng2['default'],
	      html: md.getSubSectionAsHtml('Instructions', 'Content', false, regionData),
	      notes: md.getSubSectionAsHtml('Instructions', 'Notes', false, regionData)
	    }),
	    level === 2 && (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'instructions',
	      characterSide: 'left',
	      characterImage: _imagesCharactersIan_arms_foldedPng2['default'],
	      html: md.getSubSectionAsHtml('Instructions', 'Content', false, regionData),
	      notes: md.getSubSectionAsHtml('Instructions', 'Notes', false, regionData)
	    }),
	    _react2['default'].createElement(
	      _spectaclePpa.Slide,
	      {
	        id: 'report',
	        bgColor: 'black',
	        missionReportQuestions: missionReportQuestions },
	      _react2['default'].createElement(
	        'div',
	        {
	          className: 'ui-slide mission-report-level-' + (level - 1) },
	        _react2['default'].createElement(
	          'header',
	          {
	            className: 'level-header' },
	          _react2['default'].createElement(
	            'figure',
	            { className: 'level-header-thumb' },
	            _react2['default'].createElement('img', { src: levels[level - 1].img })
	          ),
	          _react2['default'].createElement(
	            _spectaclePpa.Heading,
	            { size: 2 },
	            'Mission Report:',
	            _react2['default'].createElement('br', null),
	            md.getSectionMetadata('Mission Report', 'Title')
	          )
	        ),
	        _react2['default'].createElement(
	          'section',
	          {
	            className: 'mission-report-form' },
	          _react2['default'].createElement(_componentsMissionReport2['default'], { missionReportQuestions: missionReportQuestions })
	        )
	      )
	    ),
	    (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'impact',
	      characterSide: 'right',
	      characterImage: _imagesCharactersIan_sara_sidePng2['default'],
	      html: md.getSubSectionAsHtml('Impact', 'Content', false, regionData),
	      notes: md.getSubSectionAsHtml('Impact', 'Notes', false, regionData)
	    }),
	    (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'class-discussion',
	      characterSide: 'left',
	      characterImage: _imagesCharactersIan_sara_lean_questioningPng2['default'],
	      html: md.getSubSectionAsHtml('Class Discussion', 'Content', false, regionData),
	      notes: md.getSubSectionAsHtml('Class Discussion', 'Notes', false, regionData)
	    })
	  );
	}
	
	exports['default'] = missionReportSection;
	/* Intro video in level 3 */ /* Scoring level 1 & 3 */ /* Scoring level 2  */ /* Instructions levels 1 & 3 */ /* Instructions level 2 */ /* Mission Reporting Screen */ /* Impact screen */ /* Class Discussion */

/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

	/* eslint react/no-multi-comp: 0 */
	
	'use strict';
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.preloadClassActivity = preloadClassActivity;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _baseSlidesHeadingSlide = __webpack_require__(162);
	
	var _baseSlidesHeadingSlide2 = _interopRequireDefault(_baseSlidesHeadingSlide);
	
	var _baseSlidesVideoSlide = __webpack_require__(56);
	
	var _baseSlidesVideoSlide2 = _interopRequireDefault(_baseSlidesVideoSlide);
	
	var _baseSlidesBalloonSlide = __webpack_require__(86);
	
	var _baseSlidesBalloonSlide2 = _interopRequireDefault(_baseSlidesBalloonSlide);
	
	var _imagesCharactersIan_headshot_smilePng = __webpack_require__(863);
	
	var _imagesCharactersIan_headshot_smilePng2 = _interopRequireDefault(_imagesCharactersIan_headshot_smilePng);
	
	var _imagesCharactersIan_sara_sidePng = __webpack_require__(153);
	
	var _imagesCharactersIan_sara_sidePng2 = _interopRequireDefault(_imagesCharactersIan_sara_sidePng);
	
	var _imagesCharactersIan_sara_lean_smilePng = __webpack_require__(411);
	
	var _imagesCharactersIan_sara_lean_smilePng2 = _interopRequireDefault(_imagesCharactersIan_sara_lean_smilePng);
	
	var _imagesCharactersIan_sidePng = __webpack_require__(865);
	
	var _imagesCharactersIan_sidePng2 = _interopRequireDefault(_imagesCharactersIan_sidePng);
	
	var _imagesCharactersSara_surprisedPng = __webpack_require__(867);
	
	var _imagesCharactersSara_surprisedPng2 = _interopRequireDefault(_imagesCharactersSara_surprisedPng);
	
	var _imagesCharactersSara_twist_hands_out_heyheyPng = __webpack_require__(868);
	
	var _imagesCharactersSara_twist_hands_out_heyheyPng2 = _interopRequireDefault(_imagesCharactersSara_twist_hands_out_heyheyPng);
	
	var _imagesCharactersIan_pointing_upPng = __webpack_require__(410);
	
	var _imagesCharactersIan_pointing_upPng2 = _interopRequireDefault(_imagesCharactersIan_pointing_upPng);
	
	var _imagesCharactersIan_pointing_leftPng = __webpack_require__(2297);
	
	var _imagesCharactersIan_pointing_leftPng2 = _interopRequireDefault(_imagesCharactersIan_pointing_leftPng);
	
	var _imagesCharactersIan_pointing_downPng = __webpack_require__(2296);
	
	var _imagesCharactersIan_pointing_downPng2 = _interopRequireDefault(_imagesCharactersIan_pointing_downPng);
	
	var _imagesCharactersSara_smilePng = __webpack_require__(412);
	
	var _imagesCharactersSara_smilePng2 = _interopRequireDefault(_imagesCharactersSara_smilePng);
	
	var _imagesCharactersSara_humphPng = __webpack_require__(2300);
	
	var _imagesCharactersSara_humphPng2 = _interopRequireDefault(_imagesCharactersSara_humphPng);
	
	var _imagesCharactersIan_sara_lean_questioningPng = __webpack_require__(200);
	
	var _imagesCharactersIan_sara_lean_questioningPng2 = _interopRequireDefault(_imagesCharactersIan_sara_lean_questioningPng);
	
	var _helpersMarkdownScript = __webpack_require__(9);
	
	var _helpersMarkdownScript2 = _interopRequireDefault(_helpersMarkdownScript);
	
	var _level1_floorplanMd = __webpack_require__(1578);
	
	var _level1_floorplanMd2 = _interopRequireDefault(_level1_floorplanMd);
	
	var _level2_kitRapMd = __webpack_require__(1579);
	
	var _level2_kitRapMd2 = _interopRequireDefault(_level2_kitRapMd);
	
	var _level3_drawingMd = __webpack_require__(1580);
	
	var _level3_drawingMd2 = _interopRequireDefault(_level3_drawingMd);
	
	var levels = {
	  '1': { md: new _helpersMarkdownScript2['default'](_level1_floorplanMd2['default']) },
	  '2': { md: new _helpersMarkdownScript2['default'](_level2_kitRapMd2['default']) },
	  '3': { md: new _helpersMarkdownScript2['default'](_level3_drawingMd2['default']) }
	};
	
	function preloadClassActivity() {
	  (0, _spectaclePpa.preloader)([_imagesCharactersIan_headshot_smilePng2['default'], _imagesCharactersIan_sara_sidePng2['default'], _imagesCharactersIan_sara_lean_smilePng2['default'], _imagesCharactersIan_sidePng2['default'], _imagesCharactersSara_surprisedPng2['default'], _imagesCharactersSara_twist_hands_out_heyheyPng2['default'], _imagesCharactersIan_pointing_upPng2['default'], _imagesCharactersIan_pointing_leftPng2['default'], _imagesCharactersIan_pointing_downPng2['default'], _imagesCharactersSara_smilePng2['default'], _imagesCharactersSara_humphPng2['default'], _imagesCharactersIan_sara_lean_questioningPng2['default']]);
	}
	
	function introVideo(level, regionData) {
	  var md = levels[level].md;
	  return (0, _baseSlidesVideoSlide2['default'])({
	    id: 'intro-video',
	    notes: md.getSubSectionAsHtml('Intro Video', 'Notes', false, regionData),
	    youTubeId: md.getSectionMetadata('Intro Video', 'YouTube', regionData)
	  });
	}
	
	function sizzle(level, regionData) {
	  var md = levels[level].md;
	  return (0, _baseSlidesBalloonSlide2['default'])({
	    id: 'sizzle',
	    characterSide: 'right',
	    characterImage: _imagesCharactersIan_sara_sidePng2['default'],
	    notes: md.getSubSectionAsHtml('Sizzle', 'Notes', false, regionData),
	    html: md.getSubSectionAsHtml('Sizzle', 'Content', false, regionData)
	  });
	}
	
	function instructions(level, regionData) {
	  var md = levels[level].md;
	  return (0, _baseSlidesBalloonSlide2['default'])({
	    id: 'instructions',
	    characterSide: 'right',
	    characterImage: _imagesCharactersIan_sara_lean_smilePng2['default'],
	    notes: md.getSubSectionAsHtml('Instructions', 'Notes', false, regionData),
	    html: md.getSubSectionAsHtml('Instructions', 'Content', false, regionData)
	  });
	}
	
	function scoring(level, regionData) {
	  var md = levels[level].md;
	  return (0, _baseSlidesBalloonSlide2['default'])({
	    id: 'scoring',
	    characterSide: 'left',
	    characterImage: _imagesCharactersIan_sidePng2['default'],
	    notes: md.getSubSectionAsHtml('Scoring', 'Notes', false, regionData),
	    html: md.getSubSectionAsHtml('Scoring', 'Content', false, regionData)
	  });
	}
	
	function level1(regionData) {
	  // floorplan
	  var level = '1';
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'class-activity-' + level },
	    introVideo(level, regionData),
	    sizzle(level, regionData),
	    instructions(level, regionData)
	  );
	}
	
	function level2(regionData) {
	  // Draw Energy
	  var level = '2';
	  var md = levels[level].md;
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'class-activity-' + level },
	    introVideo(level, regionData),
	    sizzle(level, regionData),
	    instructions(level, regionData),
	    (0, _baseSlidesVideoSlide2['default'])({
	      id: 'rap-backtrack-practice',
	      notes: md.getSubSectionAsHtml('Rap Backtrack Practice', 'Notes', false, regionData),
	      youTubeId: md.getSectionMetadata('Rap Backtrack Practice', 'YouTube', regionData)
	    }),
	    scoring(level, regionData),
	    (0, _baseSlidesVideoSlide2['default'])({
	      id: 'rap-backtrack-perform',
	      notes: md.getSubSectionAsHtml('Rap Backtrack Perform', 'Notes', false, regionData),
	      youTubeId: md.getSectionMetadata('Rap Backtrack Perform', 'YouTube', regionData)
	    })
	  );
	}
	
	function level3(regionData) {
	  // Energy saving rap
	  var level = '3';
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'class-activity-' + level },
	    introVideo(level, regionData),
	    sizzle(level, regionData),
	    instructions(level, regionData)
	  );
	}
	
	function classActivitySection(_ref) {
	  var level = _ref.level;
	  var subActivity = _ref.subActivity;
	  var regionData = _ref.regionData;
	
	  switch ('' + level + (subActivity ? subActivity : '')) {
	    case '1':
	      return level1(regionData);
	    case '2':
	      return level2(regionData);
	    case '3':
	      return level3(regionData);
	    default:
	      return (0, _baseSlidesHeadingSlide2['default'])({ heading: 'Unknown' });
	  }
	}
	
	exports['default'] = classActivitySection;
	/* Intro Video */ /* Sizzle */ /* Instructions */ /* Intro Video */ /* Sizzle */ /* Instructions */ /* Rap Backtrack Practice */ /* Scoring */ /* Rap Backtrack Perform */ /* Intro Video */ /* Sizzle */ /* Instructions */

/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.preloadMissionAssignment = preloadMissionAssignment;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _baseSlidesHeadingSlide = __webpack_require__(162);
	
	var _baseSlidesHeadingSlide2 = _interopRequireDefault(_baseSlidesHeadingSlide);
	
	var _baseSlidesBalloonSlide = __webpack_require__(86);
	
	var _baseSlidesBalloonSlide2 = _interopRequireDefault(_baseSlidesBalloonSlide);
	
	var _baseSlidesVideoSlide = __webpack_require__(56);
	
	var _baseSlidesVideoSlide2 = _interopRequireDefault(_baseSlidesVideoSlide);
	
	var _imagesEmergencyPreparednessSquadGlowPng = __webpack_require__(413);
	
	var _imagesEmergencyPreparednessSquadGlowPng2 = _interopRequireDefault(_imagesEmergencyPreparednessSquadGlowPng);
	
	var _imagesCharactersIan_sara_sidePng = __webpack_require__(153);
	
	var _imagesCharactersIan_sara_sidePng2 = _interopRequireDefault(_imagesCharactersIan_sara_sidePng);
	
	var _imagesCharactersIan_sara_lean_questioningPng = __webpack_require__(200);
	
	var _imagesCharactersIan_sara_lean_questioningPng2 = _interopRequireDefault(_imagesCharactersIan_sara_lean_questioningPng);
	
	var _helpersMarkdownScript = __webpack_require__(9);
	
	var _helpersMarkdownScript2 = _interopRequireDefault(_helpersMarkdownScript);
	
	var _level1_makeAPlanMd = __webpack_require__(1581);
	
	var _level1_makeAPlanMd2 = _interopRequireDefault(_level1_makeAPlanMd);
	
	var _level2_getAKitMd = __webpack_require__(1582);
	
	var _level2_getAKitMd2 = _interopRequireDefault(_level2_getAKitMd);
	
	var _level3_keepBuildingKitMd = __webpack_require__(1583);
	
	var _level3_keepBuildingKitMd2 = _interopRequireDefault(_level3_keepBuildingKitMd);
	
	var levels = {
	  '1': { md: new _helpersMarkdownScript2['default'](_level1_makeAPlanMd2['default']) },
	  '2': { md: new _helpersMarkdownScript2['default'](_level2_getAKitMd2['default']) },
	  '3': { md: new _helpersMarkdownScript2['default'](_level3_keepBuildingKitMd2['default']) }
	};
	
	function preloadMissionAssignment() {
	  (0, _spectaclePpa.preloader)([_imagesEmergencyPreparednessSquadGlowPng2['default'], _imagesCharactersIan_sara_sidePng2['default'], _imagesCharactersIan_sara_lean_questioningPng2['default']]);
	}
	
	function missionAssignmentSection(_ref) {
	  var level = _ref.level;
	  var title = _ref.title;
	  var regionData = _ref.regionData;
	
	  var md = levels[level].md;
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'mission-assignment' },
	    (0, _baseSlidesVideoSlide2['default'])({
	      id: 'mission-intro-video',
	      notes: md.getSubSectionAsHtml('Mission Intro Video', 'Notes', false, regionData),
	      youTubeId: md.getSectionMetadata('Mission Intro Video', 'YouTube', regionData)
	    }),
	    (0, _baseSlidesHeadingSlide2['default'])({
	      id: 'sizzle',
	      beforeImage: _imagesEmergencyPreparednessSquadGlowPng2['default'],
	      subHeading: 'Mission ' + level + ':<br/> ' + title,
	      notes: md.getSubSectionAsHtml('Mission Assignment', 'Notes', false, regionData),
	      bgColor: 'black'
	    }),
	    (level === 1 || level === 3) && (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'instructions',
	      characterSide: 'right',
	      characterImage: _imagesCharactersIan_sara_sidePng2['default'],
	      notes: md.getSubSectionAsHtml('Instructions', 'Notes', false, regionData),
	      html: md.getSubSectionAsHtml('Instructions', 'Content', false, regionData)
	    }),
	    level === 2 && (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'instructions',
	      characterSide: 'right',
	      characterImage: _imagesCharactersIan_sara_lean_questioningPng2['default'],
	      notes: md.getSubSectionAsHtml('Instructions', 'Notes', false, regionData),
	      html: md.getSubSectionAsHtml('Instructions', 'Content', false, regionData)
	    })
	  );
	}
	
	exports['default'] = missionAssignmentSection;
	/* Mission Intro Video*/ /* Sizzle */ /* Mission Instructions levels 1 & 3 */ /* Mission Instructions levels 2 */

/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.preloadFinish = preloadFinish;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _componentsCompleteLevelButton = __webpack_require__(44);
	
	var _componentsCompleteLevelButton2 = _interopRequireDefault(_componentsCompleteLevelButton);
	
	var _baseSlidesBalloonSlide = __webpack_require__(86);
	
	var _baseSlidesBalloonSlide2 = _interopRequireDefault(_baseSlidesBalloonSlide);
	
	var _baseSlidesVideoSlide = __webpack_require__(56);
	
	var _baseSlidesVideoSlide2 = _interopRequireDefault(_baseSlidesVideoSlide);
	
	var _imagesCharactersIan_sara_lean_smilePng = __webpack_require__(411);
	
	var _imagesCharactersIan_sara_lean_smilePng2 = _interopRequireDefault(_imagesCharactersIan_sara_lean_smilePng);
	
	var _imagesCharactersIan_sara_sidePng = __webpack_require__(153);
	
	var _imagesCharactersIan_sara_sidePng2 = _interopRequireDefault(_imagesCharactersIan_sara_sidePng);
	
	var _imagesCharactersIan_sara_lean_questioningPng = __webpack_require__(200);
	
	var _imagesCharactersIan_sara_lean_questioningPng2 = _interopRequireDefault(_imagesCharactersIan_sara_lean_questioningPng);
	
	var _imagesCharactersIan_sara_sillyPng = __webpack_require__(864);
	
	var _imagesCharactersIan_sara_sillyPng2 = _interopRequireDefault(_imagesCharactersIan_sara_sillyPng);
	
	var _helpersMarkdownScript = __webpack_require__(9);
	
	var _helpersMarkdownScript2 = _interopRequireDefault(_helpersMarkdownScript);
	
	var _finishMd = __webpack_require__(1584);
	
	var _finishMd2 = _interopRequireDefault(_finishMd);
	
	var _level1_completeSvg = __webpack_require__(2312);
	
	var _level1_completeSvg2 = _interopRequireDefault(_level1_completeSvg);
	
	var _level2_completeSvg = __webpack_require__(2313);
	
	var _level2_completeSvg2 = _interopRequireDefault(_level2_completeSvg);
	
	var _level3_completeSvg = __webpack_require__(2314);
	
	var _level3_completeSvg2 = _interopRequireDefault(_level3_completeSvg);
	
	var md = new _helpersMarkdownScript2['default'](_finishMd2['default']);
	
	var levels = {
	  '1': { img: _level1_completeSvg2['default'] },
	  '2': { img: _level2_completeSvg2['default'] },
	  '3': { img: _level3_completeSvg2['default'] }
	};
	
	function preloadFinish() {
	  (0, _spectaclePpa.preloader)([_imagesCharactersIan_sara_lean_smilePng2['default'], _imagesCharactersIan_sara_sidePng2['default'], _imagesCharactersIan_sara_lean_questioningPng2['default'], _imagesCharactersIan_sara_sillyPng2['default'], _level1_completeSvg2['default'], _level2_completeSvg2['default'], _level3_completeSvg2['default']]);
	}
	
	function finishSection(_ref) {
	  var level = _ref.level;
	  var regionData = _ref.regionData;
	
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'finish' },
	    level === 1 && (0, _baseSlidesVideoSlide2['default'])({
	      id: 'outtakes',
	      notes: md.getSubSectionAsHtml('Outtakes 1', 'Notes', false, regionData),
	      youTubeId: md.getSectionMetadata('Outtakes 1', 'YouTube', regionData)
	    }),
	    level === 2 && (0, _baseSlidesVideoSlide2['default'])({
	      id: 'outtakes',
	      notes: md.getSubSectionAsHtml('Outtakes 2', 'Notes', false, regionData),
	      youTubeId: md.getSectionMetadata('Outtakes 2', 'YouTube', regionData)
	    }),
	    level !== 3 && (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'scoreboard-recap',
	      characterSide: 'left',
	      characterImage: _imagesCharactersIan_sara_sidePng2['default'],
	      html: md.getSubSectionAsHtml('Scoreboard Recap', 'Content', false, regionData),
	      notes: md.getSubSectionAsHtml('Scoreboard Recap', 'Notes', false, regionData)
	    }),
	    level !== 3 && (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'earn-more-points',
	      characterSide: 'right',
	      characterImage: _imagesCharactersIan_sara_lean_questioningPng2['default'],
	      html: md.getSubSectionAsHtml('Earn More Points', 'Content', false, regionData),
	      notes: md.getSubSectionAsHtml('Earn More Points', 'Notes', false, regionData)
	    }),
	    level === 1 && (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'farewell',
	      characterSide: 'left',
	      characterImage: _imagesCharactersIan_sara_lean_smilePng2['default'],
	      html: md.getSubSectionAsHtml('Farewell', 'Content', false, regionData),
	      notes: md.getSubSectionAsHtml('Farewell', 'Notes', false, regionData)
	    }),
	    level === 2 && (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'farewell',
	      characterSide: 'left',
	      characterImage: _imagesCharactersIan_sara_sidePng2['default'],
	      html: md.getSubSectionAsHtml('Farewell', 'Content', false, regionData),
	      notes: md.getSubSectionAsHtml('Farewell', 'Notes', false, regionData)
	    }),
	    level === 3 && (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'farewell',
	      characterSide: 'left',
	      characterImage: _imagesCharactersIan_sara_sillyPng2['default'],
	      html: md.getSubSectionAsHtml('Farewell', 'Content', false, regionData),
	      notes: md.getSubSectionAsHtml('Farewell', 'Notes', false, regionData)
	    }),
	    _react2['default'].createElement(
	      _spectaclePpa.Slide,
	      {
	        id: 'level-completed',
	        notes: '<h2>Level ' + level + ' Finished</h2>',
	        bgColor: 'transparent',
	        finish: true },
	      _react2['default'].createElement(
	        'div',
	        { className: 'level-complete' },
	        _react2['default'].createElement(
	          'div',
	          { className: 'level-complete-content' },
	          _react2['default'].createElement(
	            'figure',
	            { className: 'level-complete-graphic' },
	            _react2['default'].createElement('img', { src: levels[level].img })
	          ),
	          _react2['default'].createElement(
	            _spectaclePpa.Heading,
	            { size: 2 },
	            'You\'ve finished'
	          ),
	          _react2['default'].createElement(
	            _spectaclePpa.Heading,
	            { size: 2 },
	            'level ',
	            level,
	            ' of 3'
	          ),
	          _react2['default'].createElement(_componentsCompleteLevelButton2['default'], null)
	        )
	      )
	    )
	  );
	}
	
	exports['default'] = finishSection;
	/* Outtakes 1 */ /* Outtakes 2 */ /* Scoreboard Recap */ /* Earn More Points */ /* Farewell levels 1 */ /* Farewell levels 2 */ /* Farewell levels 3 */ /* Level complete */

/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.preloadMissionReport = preloadMissionReport;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _componentsMissionReport = __webpack_require__(76);
	
	var _componentsMissionReport2 = _interopRequireDefault(_componentsMissionReport);
	
	var _baseSlidesBalloonSlide = __webpack_require__(87);
	
	var _baseSlidesBalloonSlide2 = _interopRequireDefault(_baseSlidesBalloonSlide);
	
	var _baseSlidesVideoSlide = __webpack_require__(57);
	
	var _baseSlidesVideoSlide2 = _interopRequireDefault(_baseSlidesVideoSlide);
	
	var _imagesCharactersIan_arms_foldedPng = __webpack_require__(870);
	
	var _imagesCharactersIan_arms_foldedPng2 = _interopRequireDefault(_imagesCharactersIan_arms_foldedPng);
	
	var _imagesCharactersIan_headshot_smilePng = __webpack_require__(871);
	
	var _imagesCharactersIan_headshot_smilePng2 = _interopRequireDefault(_imagesCharactersIan_headshot_smilePng);
	
	var _imagesCharactersSara_twist_hands_out_yayPng = __webpack_require__(2322);
	
	var _imagesCharactersSara_twist_hands_out_yayPng2 = _interopRequireDefault(_imagesCharactersSara_twist_hands_out_yayPng);
	
	var _imagesCharactersSara_smilePng = __webpack_require__(418);
	
	var _imagesCharactersSara_smilePng2 = _interopRequireDefault(_imagesCharactersSara_smilePng);
	
	var _imagesCharactersIan_sara_sidePng = __webpack_require__(154);
	
	var _imagesCharactersIan_sara_sidePng2 = _interopRequireDefault(_imagesCharactersIan_sara_sidePng);
	
	var _imagesCharactersIan_sara_lean_questioningPng = __webpack_require__(201);
	
	var _imagesCharactersIan_sara_lean_questioningPng2 = _interopRequireDefault(_imagesCharactersIan_sara_lean_questioningPng);
	
	var _helpersMarkdownScript = __webpack_require__(9);
	
	var _helpersMarkdownScript2 = _interopRequireDefault(_helpersMarkdownScript);
	
	var _level2_knowTheRisksMd = __webpack_require__(1602);
	
	var _level2_knowTheRisksMd2 = _interopRequireDefault(_level2_knowTheRisksMd);
	
	var _level3_makeAPlanMd = __webpack_require__(1603);
	
	var _level3_makeAPlanMd2 = _interopRequireDefault(_level3_makeAPlanMd);
	
	var _level4_getAKitMd = __webpack_require__(1604);
	
	var _level4_getAKitMd2 = _interopRequireDefault(_level4_getAKitMd);
	
	var _imagesLevel1_startPng = __webpack_require__(420);
	
	var _imagesLevel1_startPng2 = _interopRequireDefault(_imagesLevel1_startPng);
	
	var _imagesLevel2_startPng = __webpack_require__(421);
	
	var _imagesLevel2_startPng2 = _interopRequireDefault(_imagesLevel2_startPng);
	
	var _imagesLevel3_startPng = __webpack_require__(422);
	
	var _imagesLevel3_startPng2 = _interopRequireDefault(_imagesLevel3_startPng);
	
	var levels = {
	  '1': { img: _imagesLevel1_startPng2['default'] },
	  '2': { md: new _helpersMarkdownScript2['default'](_level2_knowTheRisksMd2['default']), img: _imagesLevel2_startPng2['default'] },
	  '3': { md: new _helpersMarkdownScript2['default'](_level3_makeAPlanMd2['default']), img: _imagesLevel3_startPng2['default'] },
	  '4': { md: new _helpersMarkdownScript2['default'](_level4_getAKitMd2['default']) }
	};
	
	function preloadMissionReport() {
	  (0, _spectaclePpa.preloader)([_imagesCharactersIan_arms_foldedPng2['default'], _imagesCharactersIan_headshot_smilePng2['default'], _imagesCharactersSara_twist_hands_out_yayPng2['default'], _imagesCharactersSara_smilePng2['default'], _imagesCharactersIan_sara_sidePng2['default'], _imagesCharactersIan_sara_lean_questioningPng2['default'], _imagesLevel1_startPng2['default'], _imagesLevel2_startPng2['default'], _imagesLevel3_startPng2['default']]);
	}
	
	function missionReportSection(_ref) {
	  var level = _ref.level;
	  var regionData = _ref.regionData;
	
	  var md = levels[level].md;
	  var missionReportQuestions = md.getQuestions('Questions', 'Content', regionData);
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'mission-report' },
	    level === 4 && (0, _baseSlidesVideoSlide2['default'])({
	      id: 'intro-video',
	      notes: md.getSubSectionAsHtml('Intro Video', 'Notes', false, regionData),
	      youTubeId: md.getSectionMetadata('Intro Video', 'YouTube', regionData)
	    }),
	    (level === 2 || level === 4) && (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'scoring',
	      characterSide: 'left',
	      characterImage: _imagesCharactersSara_twist_hands_out_yayPng2['default'],
	      html: md.getSubSectionAsHtml('Scoring', 'Content', false, regionData),
	      notes: md.getSubSectionAsHtml('Scoring', 'Notes', false, regionData)
	    }),
	    level === 3 && (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'scoring',
	      characterSide: 'right',
	      characterImage: _imagesCharactersSara_smilePng2['default'],
	      html: md.getSubSectionAsHtml('Scoring', 'Content', false, regionData),
	      notes: md.getSubSectionAsHtml('Scoring', 'Notes', false, regionData)
	    }),
	    (level === 2 || level === 4) && (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'instructions',
	      characterSide: 'right',
	      characterImage: _imagesCharactersIan_headshot_smilePng2['default'],
	      html: md.getSubSectionAsHtml('Instructions', 'Content', false, regionData),
	      notes: md.getSubSectionAsHtml('Instructions', 'Notes', false, regionData)
	    }),
	    level === 3 && (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'instructions',
	      characterSide: 'left',
	      characterImage: _imagesCharactersIan_arms_foldedPng2['default'],
	      html: md.getSubSectionAsHtml('Instructions', 'Content', false, regionData),
	      notes: md.getSubSectionAsHtml('Instructions', 'Notes', false, regionData)
	    }),
	    _react2['default'].createElement(
	      _spectaclePpa.Slide,
	      {
	        id: 'report',
	        bgColor: 'black',
	        missionReportQuestions: missionReportQuestions },
	      _react2['default'].createElement(
	        'div',
	        {
	          className: 'ui-slide mission-report-level-' + (level - 1) },
	        _react2['default'].createElement(
	          'header',
	          {
	            className: 'level-header' },
	          _react2['default'].createElement(
	            'figure',
	            { className: 'level-header-thumb' },
	            _react2['default'].createElement('img', { src: levels[level - 1].img })
	          ),
	          _react2['default'].createElement(
	            _spectaclePpa.Heading,
	            { size: 2 },
	            'Mission Report:',
	            _react2['default'].createElement('br', null),
	            md.getSectionMetadata('Mission Report', 'Title')
	          )
	        ),
	        _react2['default'].createElement(
	          'section',
	          {
	            className: 'mission-report-form' },
	          _react2['default'].createElement(_componentsMissionReport2['default'], { missionReportQuestions: missionReportQuestions })
	        )
	      )
	    ),
	    (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'impact',
	      characterSide: 'right',
	      characterImage: _imagesCharactersIan_sara_sidePng2['default'],
	      html: md.getSubSectionAsHtml('Impact', 'Content', false, regionData),
	      notes: md.getSubSectionAsHtml('Impact', 'Notes', false, regionData)
	    }),
	    (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'class-discussion',
	      characterSide: 'left',
	      characterImage: _imagesCharactersIan_sara_lean_questioningPng2['default'],
	      html: md.getSubSectionAsHtml('Class Discussion', 'Content', false, regionData),
	      notes: md.getSubSectionAsHtml('Class Discussion', 'Notes', false, regionData)
	    })
	  );
	}
	
	exports['default'] = missionReportSection;
	/* Intro video in level 4 */ /* Scoring level 2 & 4 */ /* Scoring level 3 */ /* Instructions levels 2 & 4 */ /* Instructions level 3 */ /* Mission Reporting Screen */ /* Impact screen */ /* Class Discussion */

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.preloadMissionReport = preloadMissionReport;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _componentsMissionReport = __webpack_require__(76);
	
	var _componentsMissionReport2 = _interopRequireDefault(_componentsMissionReport);
	
	var _baseSlidesBalloonSlide = __webpack_require__(88);
	
	var _baseSlidesBalloonSlide2 = _interopRequireDefault(_baseSlidesBalloonSlide);
	
	var _baseSlidesVideoSlide = __webpack_require__(58);
	
	var _baseSlidesVideoSlide2 = _interopRequireDefault(_baseSlidesVideoSlide);
	
	var _imagesCharactersIan_arms_foldedPng = __webpack_require__(877);
	
	var _imagesCharactersIan_arms_foldedPng2 = _interopRequireDefault(_imagesCharactersIan_arms_foldedPng);
	
	var _imagesCharactersIan_headshot_smilePng = __webpack_require__(878);
	
	var _imagesCharactersIan_headshot_smilePng2 = _interopRequireDefault(_imagesCharactersIan_headshot_smilePng);
	
	var _imagesCharactersSara_twist_hands_out_yayPng = __webpack_require__(2344);
	
	var _imagesCharactersSara_twist_hands_out_yayPng2 = _interopRequireDefault(_imagesCharactersSara_twist_hands_out_yayPng);
	
	var _imagesCharactersSara_smilePng = __webpack_require__(425);
	
	var _imagesCharactersSara_smilePng2 = _interopRequireDefault(_imagesCharactersSara_smilePng);
	
	var _imagesCharactersIan_sara_sidePng = __webpack_require__(155);
	
	var _imagesCharactersIan_sara_sidePng2 = _interopRequireDefault(_imagesCharactersIan_sara_sidePng);
	
	var _imagesCharactersIan_sara_lean_questioningPng = __webpack_require__(202);
	
	var _imagesCharactersIan_sara_lean_questioningPng2 = _interopRequireDefault(_imagesCharactersIan_sara_lean_questioningPng);
	
	var _helpersMarkdownScript = __webpack_require__(9);
	
	var _helpersMarkdownScript2 = _interopRequireDefault(_helpersMarkdownScript);
	
	var _level2_knowTheRisksMd = __webpack_require__(1635);
	
	var _level2_knowTheRisksMd2 = _interopRequireDefault(_level2_knowTheRisksMd);
	
	var _level3_makeAPlanMd = __webpack_require__(1636);
	
	var _level3_makeAPlanMd2 = _interopRequireDefault(_level3_makeAPlanMd);
	
	var _level4_getAKitMd = __webpack_require__(1637);
	
	var _level4_getAKitMd2 = _interopRequireDefault(_level4_getAKitMd);
	
	var _imagesLevel1_startPng = __webpack_require__(427);
	
	var _imagesLevel1_startPng2 = _interopRequireDefault(_imagesLevel1_startPng);
	
	var _imagesLevel2_startPng = __webpack_require__(428);
	
	var _imagesLevel2_startPng2 = _interopRequireDefault(_imagesLevel2_startPng);
	
	var _imagesLevel3_startPng = __webpack_require__(429);
	
	var _imagesLevel3_startPng2 = _interopRequireDefault(_imagesLevel3_startPng);
	
	var levels = {
	  '1': { img: _imagesLevel1_startPng2['default'] },
	  '2': { md: new _helpersMarkdownScript2['default'](_level2_knowTheRisksMd2['default']), img: _imagesLevel2_startPng2['default'] },
	  '3': { md: new _helpersMarkdownScript2['default'](_level3_makeAPlanMd2['default']), img: _imagesLevel3_startPng2['default'] },
	  '4': { md: new _helpersMarkdownScript2['default'](_level4_getAKitMd2['default']) }
	};
	
	function preloadMissionReport() {
	  (0, _spectaclePpa.preloader)([_imagesCharactersIan_arms_foldedPng2['default'], _imagesCharactersIan_headshot_smilePng2['default'], _imagesCharactersSara_twist_hands_out_yayPng2['default'], _imagesCharactersSara_smilePng2['default'], _imagesCharactersIan_sara_sidePng2['default'], _imagesCharactersIan_sara_lean_questioningPng2['default'], _imagesLevel1_startPng2['default'], _imagesLevel2_startPng2['default'], _imagesLevel3_startPng2['default']]);
	}
	
	function missionReportSection(_ref) {
	  var level = _ref.level;
	  var regionData = _ref.regionData;
	
	  var md = levels[level].md;
	  var missionReportQuestions = md.getQuestions('Questions', 'Content', regionData);
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'mission-report' },
	    level === 4 && (0, _baseSlidesVideoSlide2['default'])({
	      id: 'intro-video',
	      notes: md.getSubSectionAsHtml('Intro Video', 'Notes', false, regionData),
	      youTubeId: md.getSectionMetadata('Intro Video', 'YouTube', regionData)
	    }),
	    (level === 2 || level === 4) && (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'scoring',
	      characterSide: 'left',
	      characterImage: _imagesCharactersSara_twist_hands_out_yayPng2['default'],
	      html: md.getSubSectionAsHtml('Scoring', 'Content', false, regionData),
	      notes: md.getSubSectionAsHtml('Scoring', 'Notes', false, regionData)
	    }),
	    level === 3 && (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'scoring',
	      characterSide: 'right',
	      characterImage: _imagesCharactersSara_smilePng2['default'],
	      html: md.getSubSectionAsHtml('Scoring', 'Content', false, regionData),
	      notes: md.getSubSectionAsHtml('Scoring', 'Notes', false, regionData)
	    }),
	    (level === 2 || level === 4) && (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'instructions',
	      characterSide: 'right',
	      characterImage: _imagesCharactersIan_headshot_smilePng2['default'],
	      html: md.getSubSectionAsHtml('Instructions', 'Content', false, regionData),
	      notes: md.getSubSectionAsHtml('Instructions', 'Notes', false, regionData)
	    }),
	    level === 3 && (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'instructions',
	      characterSide: 'left',
	      characterImage: _imagesCharactersIan_arms_foldedPng2['default'],
	      html: md.getSubSectionAsHtml('Instructions', 'Content', false, regionData),
	      notes: md.getSubSectionAsHtml('Instructions', 'Notes', false, regionData)
	    }),
	    _react2['default'].createElement(
	      _spectaclePpa.Slide,
	      {
	        id: 'report',
	        bgColor: 'black',
	        missionReportQuestions: missionReportQuestions },
	      _react2['default'].createElement(
	        'div',
	        {
	          className: 'ui-slide mission-report-level-' + (level - 1) },
	        _react2['default'].createElement(
	          'header',
	          {
	            className: 'level-header' },
	          _react2['default'].createElement(
	            'figure',
	            { className: 'level-header-thumb' },
	            _react2['default'].createElement('img', { src: levels[level - 1].img })
	          ),
	          _react2['default'].createElement(
	            _spectaclePpa.Heading,
	            { size: 2 },
	            'Mission Report:',
	            _react2['default'].createElement('br', null),
	            md.getSectionMetadata('Mission Report', 'Title')
	          )
	        ),
	        _react2['default'].createElement(
	          'section',
	          {
	            className: 'mission-report-form' },
	          _react2['default'].createElement(_componentsMissionReport2['default'], { missionReportQuestions: missionReportQuestions })
	        )
	      )
	    ),
	    (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'impact',
	      characterSide: 'right',
	      characterImage: _imagesCharactersIan_sara_sidePng2['default'],
	      html: md.getSubSectionAsHtml('Impact', 'Content', false, regionData),
	      notes: md.getSubSectionAsHtml('Impact', 'Notes', false, regionData)
	    }),
	    (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'class-discussion',
	      characterSide: 'left',
	      characterImage: _imagesCharactersIan_sara_lean_questioningPng2['default'],
	      html: md.getSubSectionAsHtml('Class Discussion', 'Content', false, regionData),
	      notes: md.getSubSectionAsHtml('Class Discussion', 'Notes', false, regionData)
	    })
	  );
	}
	
	exports['default'] = missionReportSection;
	/* Intro video in level 4 */ /* Scoring level 2 & 4 */ /* Scoring level 3 */ /* Instructions levels 2 & 4 */ /* Instructions level 3 */ /* Mission Reporting Screen */ /* Impact screen */ /* Class Discussion */

/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.preloadMissionReport = preloadMissionReport;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _helpersI18n = __webpack_require__(14);
	
	var _componentsMissionReport = __webpack_require__(76);
	
	var _componentsMissionReport2 = _interopRequireDefault(_componentsMissionReport);
	
	var _baseSlidesVideoSlide = __webpack_require__(89);
	
	var _baseSlidesVideoSlide2 = _interopRequireDefault(_baseSlidesVideoSlide);
	
	var _baseSlidesBalloonSlide = __webpack_require__(67);
	
	var _baseSlidesBalloonSlide2 = _interopRequireDefault(_baseSlidesBalloonSlide);
	
	var _imagesCharactersEsmeralda_hands_out_weheyPng = __webpack_require__(431);
	
	var _imagesCharactersEsmeralda_hands_out_weheyPng2 = _interopRequireDefault(_imagesCharactersEsmeralda_hands_out_weheyPng);
	
	var _imagesCharactersEsmeralda_hands_out_up_closePng = __webpack_require__(2372);
	
	var _imagesCharactersEsmeralda_hands_out_up_closePng2 = _interopRequireDefault(_imagesCharactersEsmeralda_hands_out_up_closePng);
	
	var _imagesCharactersEsmeralda_goober_goofy_smilePng = __webpack_require__(885);
	
	var _imagesCharactersEsmeralda_goober_goofy_smilePng2 = _interopRequireDefault(_imagesCharactersEsmeralda_goober_goofy_smilePng);
	
	var _imagesCharactersIan_headshot_smilePng = __webpack_require__(887);
	
	var _imagesCharactersIan_headshot_smilePng2 = _interopRequireDefault(_imagesCharactersIan_headshot_smilePng);
	
	var _imagesCharactersEsmeralda_goober_proudPng = __webpack_require__(886);
	
	var _imagesCharactersEsmeralda_goober_proudPng2 = _interopRequireDefault(_imagesCharactersEsmeralda_goober_proudPng);
	
	var _helpersMarkdownScript = __webpack_require__(9);
	
	var _helpersMarkdownScript2 = _interopRequireDefault(_helpersMarkdownScript);
	
	var _level2_operationTapsOffMd = __webpack_require__(1678);
	
	var _level2_operationTapsOffMd2 = _interopRequireDefault(_level2_operationTapsOffMd);
	
	var _level2_operationTapsOffFr_CAMd = __webpack_require__(1677);
	
	var _level2_operationTapsOffFr_CAMd2 = _interopRequireDefault(_level2_operationTapsOffFr_CAMd);
	
	var _level3_operationSaveWaterMd = __webpack_require__(1680);
	
	var _level3_operationSaveWaterMd2 = _interopRequireDefault(_level3_operationSaveWaterMd);
	
	var _level3_operationSaveWaterFr_CAMd = __webpack_require__(1679);
	
	var _level3_operationSaveWaterFr_CAMd2 = _interopRequireDefault(_level3_operationSaveWaterFr_CAMd);
	
	var _level4_operationProtectWaterMd = __webpack_require__(1682);
	
	var _level4_operationProtectWaterMd2 = _interopRequireDefault(_level4_operationProtectWaterMd);
	
	var _level4_operationProtectWaterFr_CAMd = __webpack_require__(1681);
	
	var _level4_operationProtectWaterFr_CAMd2 = _interopRequireDefault(_level4_operationProtectWaterFr_CAMd);
	
	var _imagesLevel1_startPng = __webpack_require__(432);
	
	var _imagesLevel1_startPng2 = _interopRequireDefault(_imagesLevel1_startPng);
	
	var _imagesLevel2_startPng = __webpack_require__(433);
	
	var _imagesLevel2_startPng2 = _interopRequireDefault(_imagesLevel2_startPng);
	
	var _imagesLevel3_startPng = __webpack_require__(434);
	
	var _imagesLevel3_startPng2 = _interopRequireDefault(_imagesLevel3_startPng);
	
	var markdownFileLevel2 = (0, _helpersI18n.i18nData)({
	  en: new _helpersMarkdownScript2['default'](_level2_operationTapsOffMd2['default']),
	  fr_CA: new _helpersMarkdownScript2['default'](_level2_operationTapsOffFr_CAMd2['default'])
	});
	var markdownFileLevel3 = (0, _helpersI18n.i18nData)({
	  en: new _helpersMarkdownScript2['default'](_level3_operationSaveWaterMd2['default']),
	  fr_CA: new _helpersMarkdownScript2['default'](_level3_operationSaveWaterFr_CAMd2['default'])
	});
	var markdownFileLevel4 = (0, _helpersI18n.i18nData)({
	  en: new _helpersMarkdownScript2['default'](_level4_operationProtectWaterMd2['default']),
	  fr_CA: new _helpersMarkdownScript2['default'](_level4_operationProtectWaterFr_CAMd2['default'])
	});
	
	var levels = {
	  '1': { img: _imagesLevel1_startPng2['default'] },
	  '2': { md: markdownFileLevel2, img: _imagesLevel2_startPng2['default'] },
	  '3': { md: markdownFileLevel3, img: _imagesLevel3_startPng2['default'] },
	  '4': { md: markdownFileLevel4 }
	};
	
	function preloadMissionReport() {
	  (0, _spectaclePpa.preloader)([_imagesCharactersEsmeralda_hands_out_weheyPng2['default'], _imagesCharactersEsmeralda_hands_out_up_closePng2['default'], _imagesCharactersEsmeralda_goober_goofy_smilePng2['default'], _imagesCharactersIan_headshot_smilePng2['default'], _imagesCharactersEsmeralda_goober_proudPng2['default'], _imagesLevel1_startPng2['default'], _imagesLevel2_startPng2['default'], _imagesLevel3_startPng2['default']]);
	}
	
	function missionReportSection(_ref) {
	  var level = _ref.level;
	  var regionData = _ref.regionData;
	  var _ = _ref.i18n;
	
	  var md = _(levels[level].md);
	  var missionReportQuestions = md.getQuestions('Questions', 'Content', regionData);
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'mission-report' },
	    (level === 1 || level === 2) && (0, _baseSlidesVideoSlide2['default'])({
	      id: 'video',
	      youTubeId: md.getSectionMetadata('Intro Video', 'YouTube', regionData),
	      notes: md.getSubSectionAsHtml('Intro Video', 'Notes', false, regionData)
	    }),
	    (level === 2 || level === 4) && (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'scoring',
	      characterSide: 'left',
	      characterImage: _imagesCharactersEsmeralda_hands_out_weheyPng2['default'],
	      html: md.getSubSectionAsHtml('Scoring', 'Content', false, regionData),
	      notes: md.getSubSectionAsHtml('Scoring', 'Notes', false, regionData)
	    }),
	    level === 3 && (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'scoring',
	      characterSide: 'right',
	      characterImage: _imagesCharactersEsmeralda_hands_out_up_closePng2['default'],
	      html: md.getSubSectionAsHtml('Scoring', 'Content', false, regionData),
	      notes: md.getSubSectionAsHtml('Scoring', 'Notes', false, regionData)
	    }),
	    (level === 2 || level === 4) && (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'instructions',
	      characterSide: 'right',
	      characterImage: _imagesCharactersEsmeralda_hands_out_up_closePng2['default'],
	      html: md.getSubSectionAsHtml('Instructions', 'Content', false, regionData),
	      notes: md.getSubSectionAsHtml('Instructions', 'Notes', false, regionData)
	    }),
	    level === 3 && (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'instructions',
	      characterSide: 'left',
	      characterImage: _imagesCharactersEsmeralda_hands_out_weheyPng2['default'],
	      html: md.getSubSectionAsHtml('Instructions', 'Content', false, regionData),
	      notes: md.getSubSectionAsHtml('Instructions', 'Notes', false, regionData)
	    }),
	    _react2['default'].createElement(
	      _spectaclePpa.Slide,
	      {
	        id: 'report',
	        bgColor: 'black',
	        missionReportQuestions: missionReportQuestions },
	      _react2['default'].createElement(
	        'div',
	        {
	          className: 'ui-slide mission-report-level-' + (level - 1) },
	        _react2['default'].createElement(
	          'header',
	          {
	            className: 'level-header' },
	          _react2['default'].createElement(
	            'figure',
	            { className: 'level-header-thumb' },
	            _react2['default'].createElement('img', { src: levels[level - 1].img })
	          ),
	          _react2['default'].createElement(
	            _spectaclePpa.Heading,
	            { size: 2 },
	            _('Mission Report:'),
	            _react2['default'].createElement('br', null),
	            md.getSectionMetadata('Mission Report', 'Title', regionData)
	          )
	        ),
	        _react2['default'].createElement(
	          'section',
	          {
	            className: 'mission-report-form' },
	          _react2['default'].createElement(_componentsMissionReport2['default'], { missionReportQuestions: missionReportQuestions })
	        )
	      )
	    ),
	    (level === 2 || level === 4) && (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'impact',
	      characterSide: 'right',
	      characterImage: _imagesCharactersEsmeralda_goober_proudPng2['default'],
	      html: md.getSubSectionAsHtml('Impact', 'Content', false, regionData),
	      notes: md.getSubSectionAsHtml('Impact', 'Notes', false, regionData)
	    }),
	    level === 3 && (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'impact',
	      characterSide: 'right',
	      characterImage: _imagesCharactersEsmeralda_goober_goofy_smilePng2['default'],
	      html: md.getSubSectionAsHtml('Impact', 'Content', false, regionData),
	      notes: md.getSubSectionAsHtml('Impact', 'Notes', false, regionData)
	    }),
	    (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'class-discussion',
	      characterSide: 'left',
	      characterImage: _imagesCharactersIan_headshot_smilePng2['default'],
	      html: md.getSubSectionAsHtml('Class Discussion', 'Content', false, regionData),
	      notes: md.getSubSectionAsHtml('Class Discussion', 'Notes', false, regionData)
	    })
	  );
	}
	
	exports['default'] = missionReportSection;
	/* Sara and Ian introduce mission report */ /* Scoring levels 2 & 4 */ /* Scoring level 3 */ /* Instructions levels 2 & 4 */ /* Instructions level 3 */ /* Mission Reporting Screen */ /* Impact screen for levels 2 & 4 */ /* Impact screen for level 3 */ /* Class Discussion */

/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _taggedTemplateLiteral = __webpack_require__(28)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.preloadMissionAssignment = preloadMissionAssignment;
	
	var _templateObject = _taggedTemplateLiteral(['Mission ', ':<br/> ', ''], ['Mission ', ':<br/> ', '']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _helpersI18n = __webpack_require__(14);
	
	var _baseSlidesHeadingSlide = __webpack_require__(122);
	
	var _baseSlidesHeadingSlide2 = _interopRequireDefault(_baseSlidesHeadingSlide);
	
	var _baseSlidesBalloonSlide = __webpack_require__(67);
	
	var _baseSlidesBalloonSlide2 = _interopRequireDefault(_baseSlidesBalloonSlide);
	
	var _baseSlidesVideoSlide = __webpack_require__(89);
	
	var _baseSlidesVideoSlide2 = _interopRequireDefault(_baseSlidesVideoSlide);
	
	var _imagesLogo_ppaPng = __webpack_require__(891);
	
	var _imagesLogo_ppaPng2 = _interopRequireDefault(_imagesLogo_ppaPng);
	
	var _imagesCharactersEsPowerStancePng = __webpack_require__(2371);
	
	var _imagesCharactersEsPowerStancePng2 = _interopRequireDefault(_imagesCharactersEsPowerStancePng);
	
	var _imagesCharactersEsmeralda_hands_out_weheyPng = __webpack_require__(431);
	
	var _imagesCharactersEsmeralda_hands_out_weheyPng2 = _interopRequireDefault(_imagesCharactersEsmeralda_hands_out_weheyPng);
	
	var _helpersMarkdownScript = __webpack_require__(9);
	
	var _helpersMarkdownScript2 = _interopRequireDefault(_helpersMarkdownScript);
	
	var _level1_operationTapsOffMd = __webpack_require__(1706);
	
	var _level1_operationTapsOffMd2 = _interopRequireDefault(_level1_operationTapsOffMd);
	
	var _level1_operationTapsOffFr_CAMd = __webpack_require__(1705);
	
	var _level1_operationTapsOffFr_CAMd2 = _interopRequireDefault(_level1_operationTapsOffFr_CAMd);
	
	var _level2_operationSaveWaterMd = __webpack_require__(1708);
	
	var _level2_operationSaveWaterMd2 = _interopRequireDefault(_level2_operationSaveWaterMd);
	
	var _level2_operationSaveWaterFr_CAMd = __webpack_require__(1707);
	
	var _level2_operationSaveWaterFr_CAMd2 = _interopRequireDefault(_level2_operationSaveWaterFr_CAMd);
	
	var _level3_operationProtectWaterMd = __webpack_require__(1710);
	
	var _level3_operationProtectWaterMd2 = _interopRequireDefault(_level3_operationProtectWaterMd);
	
	var _level3_operationProtectWaterFr_CAMd = __webpack_require__(1709);
	
	var _level3_operationProtectWaterFr_CAMd2 = _interopRequireDefault(_level3_operationProtectWaterFr_CAMd);
	
	var markdownFileLevel1 = (0, _helpersI18n.i18nData)({
	  en: new _helpersMarkdownScript2['default'](_level1_operationTapsOffMd2['default']),
	  fr_CA: new _helpersMarkdownScript2['default'](_level1_operationTapsOffFr_CAMd2['default'])
	});
	var markdownFileLevel2 = (0, _helpersI18n.i18nData)({
	  en: new _helpersMarkdownScript2['default'](_level2_operationSaveWaterMd2['default']),
	  fr_CA: new _helpersMarkdownScript2['default'](_level2_operationSaveWaterFr_CAMd2['default'])
	});
	var markdownFileLevel3 = (0, _helpersI18n.i18nData)({
	  en: new _helpersMarkdownScript2['default'](_level3_operationProtectWaterMd2['default']),
	  fr_CA: new _helpersMarkdownScript2['default'](_level3_operationProtectWaterFr_CAMd2['default'])
	});
	
	var levels = {
	  '1': { md: markdownFileLevel1 },
	  '2': { md: markdownFileLevel2 },
	  '3': { md: markdownFileLevel3 }
	};
	
	function preloadMissionAssignment() {
	  (0, _spectaclePpa.preloader)([_imagesLogo_ppaPng2['default'], _imagesCharactersEsPowerStancePng2['default'], _imagesCharactersEsmeralda_hands_out_weheyPng2['default']]);
	}
	
	function missionAssignmentSection(_ref) {
	  var level = _ref.level;
	  var regionData = _ref.regionData;
	  var i18n = _ref.i18n;
	
	  var md = i18n(levels[level].md);
	  var missionTitle = md.getSectionMetadata('Mission Assignment', 'Title', regionData);
	
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'mission-assignment' },
	    level === 2 && (0, _baseSlidesVideoSlide2['default'])({
	      id: 'intro-video',
	      notes: md.getSubSectionAsHtml('Intro Video', 'Notes', false, regionData),
	      youTubeId: md.getSectionMetadata('Intro Video', 'YouTube', regionData)
	    }),
	    level === 1 && (0, _baseSlidesHeadingSlide2['default'])({
	      id: 'sizzle',
	      beforeImage: _imagesLogo_ppaPng2['default'],
	      subHeading: i18n(_templateObject, level, missionTitle),
	      notes: md.getSubSectionAsHtml('Mission Assignment', 'Notes', false, regionData),
	      bgColor: 'black'
	    }),
	    level !== 1 && (0, _baseSlidesHeadingSlide2['default'])({
	      id: 'sizzle',
	      beforeImage: _imagesLogo_ppaPng2['default'],
	      subHeading: i18n(_templateObject, level, missionTitle),
	      notes: md.getSubSectionAsHtml('Mission Assignment', 'Notes', false, regionData),
	      bgColor: 'black'
	    }),
	    (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'instructions',
	      characterSide: 'right',
	      characterImage: _imagesCharactersEsmeralda_hands_out_weheyPng2['default'],
	      notes: md.getSubSectionAsHtml('Instructions', 'Notes', false, regionData),
	      html: md.getSubSectionAsHtml('Instructions', 'Content', false, regionData)
	    }),
	    (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'mission-files',
	      characterSide: 'right',
	      characterImage: _imagesCharactersEsPowerStancePng2['default'],
	      notes: md.getSubSectionAsHtml('Mission Files', 'Notes', false, regionData),
	      html: md.getSubSectionAsHtml('Mission Files', 'Content', false, regionData)
	    })
	  );
	}
	
	exports['default'] = missionAssignmentSection;
	/* Mission assignment*/ /* Sizzle level 1 */ /* Sizzle other levels */ /* Mission Instructions & Points */ /* Mission Files Instructions */

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

	/* eslint react/no-multi-comp: 0, no-unused-vars: 0 */
	
	'use strict';
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.preloadGameShow = preloadGameShow;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _srcServicesRegionalization = __webpack_require__(38);
	
	var _srcServicesRegionalization2 = _interopRequireDefault(_srcServicesRegionalization);
	
	var _baseSlidesBalloonSlide = __webpack_require__(68);
	
	var _baseSlidesBalloonSlide2 = _interopRequireDefault(_baseSlidesBalloonSlide);
	
	var _baseSlidesHeadingSlide = __webpack_require__(169);
	
	var _baseSlidesHeadingSlide2 = _interopRequireDefault(_baseSlidesHeadingSlide);
	
	var _baseSlidesVideoSlide = __webpack_require__(90);
	
	var _baseSlidesVideoSlide2 = _interopRequireDefault(_baseSlidesVideoSlide);
	
	var _title_gameshowPng = __webpack_require__(2424);
	
	var _title_gameshowPng2 = _interopRequireDefault(_title_gameshowPng);
	
	var _title_gameshow_playersPng = __webpack_require__(2425);
	
	var _title_gameshow_playersPng2 = _interopRequireDefault(_title_gameshow_playersPng);
	
	var _imagesCharactersIan_sara_lean_smilePng = __webpack_require__(436);
	
	var _imagesCharactersIan_sara_lean_smilePng2 = _interopRequireDefault(_imagesCharactersIan_sara_lean_smilePng);
	
	var _imagesCharactersIan_sidePng = __webpack_require__(895);
	
	var _imagesCharactersIan_sidePng2 = _interopRequireDefault(_imagesCharactersIan_sidePng);
	
	var _imagesCharactersSara_smilePng = __webpack_require__(437);
	
	var _imagesCharactersSara_smilePng2 = _interopRequireDefault(_imagesCharactersSara_smilePng);
	
	var _imagesCharactersIan_shrug_laughPng = __webpack_require__(2411);
	
	var _imagesCharactersIan_shrug_laughPng2 = _interopRequireDefault(_imagesCharactersIan_shrug_laughPng);
	
	var _imagesCharactersIan_pointing_upPng = __webpack_require__(435);
	
	var _imagesCharactersIan_pointing_upPng2 = _interopRequireDefault(_imagesCharactersIan_pointing_upPng);
	
	var _imagesCharactersIan_sara_lean_questioningPng = __webpack_require__(203);
	
	var _imagesCharactersIan_sara_lean_questioningPng2 = _interopRequireDefault(_imagesCharactersIan_sara_lean_questioningPng);
	
	var _imagesCharactersSara_surprisedPng = __webpack_require__(897);
	
	var _imagesCharactersSara_surprisedPng2 = _interopRequireDefault(_imagesCharactersSara_surprisedPng);
	
	var _imagesCharactersIan_sara_sidePng = __webpack_require__(156);
	
	var _imagesCharactersIan_sara_sidePng2 = _interopRequireDefault(_imagesCharactersIan_sara_sidePng);
	
	var _helpersMarkdownScript = __webpack_require__(9);
	
	var _helpersMarkdownScript2 = _interopRequireDefault(_helpersMarkdownScript);
	
	var _level1Md = __webpack_require__(1727);
	
	var _level1Md2 = _interopRequireDefault(_level1Md);
	
	var _level2Md = __webpack_require__(1728);
	
	var _level2Md2 = _interopRequireDefault(_level2Md);
	
	var levels = {
	  '1': { md: new _helpersMarkdownScript2['default'](_level1Md2['default']) },
	  '2': { md: new _helpersMarkdownScript2['default'](_level2Md2['default']) }
	};
	
	function preloadGameShow() {
	  (0, _spectaclePpa.preloader)([_title_gameshowPng2['default'], _title_gameshow_playersPng2['default'], _imagesCharactersIan_sara_lean_smilePng2['default'], _imagesCharactersIan_sidePng2['default'], _imagesCharactersSara_smilePng2['default'], _imagesCharactersIan_shrug_laughPng2['default'], _imagesCharactersIan_sara_lean_questioningPng2['default'], _imagesCharactersSara_surprisedPng2['default'], _imagesCharactersIan_sara_sidePng2['default']]);
	}
	
	function intro(level, regionData) {
	  var md = levels[level].md;
	  return (0, _baseSlidesVideoSlide2['default'])({
	    id: 'intro',
	    notes: md.getSubSectionAsHtml('Intro Video', 'Notes', false, regionData),
	    youTubeId: md.getSectionMetadata('Intro Video', 'YouTube', regionData)
	  });
	}
	
	function sizzle(level, regionData) {
	  var md = levels[level].md;
	  return (0, _baseSlidesHeadingSlide2['default'])({
	    id: 'sizzle',
	    bgColor: '#742CBF',
	    afterImage: _title_gameshowPng2['default'],
	    notes: md.getSubSectionAsHtml('Sizzle', 'Notes', false, regionData)
	  });
	}
	
	function scoring(level, regionData) {
	  var md = levels[level].md;
	  return (0, _baseSlidesBalloonSlide2['default'])({
	    id: 'scoring',
	    characterSide: 'left',
	    characterImage: _imagesCharactersIan_sara_lean_smilePng2['default'],
	    notes: md.getSubSectionAsHtml('Scoring', 'Notes', false, regionData),
	    html: md.getSubSectionAsHtml('Scoring', 'Content', false, regionData),
	    bgColor: '#742CBF'
	  });
	}
	
	function questionSlide(_ref) {
	  var level = _ref.level;
	  var questionNumber = _ref.questionNumber;
	  var numQuestions = _ref.numQuestions;
	  var md = _ref.md;
	  var questionCharacterImage = _ref.questionCharacterImage;
	  var answerCharacterImage = _ref.answerCharacterImage;
	  var regionData = _ref.regionData;
	
	  var questionSection = 'Question ' + questionNumber;
	  var defaultRegion = md.getSectionMetadata(questionSection, 'Default Region', regionData);
	  var questionCharacter = !questionCharacterImage ? _imagesCharactersIan_sidePng2['default'] : questionCharacterImage;
	  var answerCharacter = !answerCharacterImage ? _imagesCharactersSara_smilePng2['default'] : answerCharacterImage;
	  var answer = undefined;
	  if (defaultRegion) {
	    answer = md.getSubSectionAsHtml(questionSection, 'Answer - ' + defaultRegion, false, regionData);
	  } else {
	    answer = md.getSubSectionAsHtml(questionSection, 'Answer', false, regionData);
	  }
	  var answerNotes = md.getSubSectionAsHtml(questionSection, 'Answer Notes', false, regionData);
	
	  return [
	
	  // four players announcement
	  (0, _baseSlidesHeadingSlide2['default'])({
	    id: questionNumber + '-four-players',
	    afterImage: _title_gameshow_playersPng2['default'],
	    bgColor: 'black',
	    notes: '<h2>Question ' + questionNumber + ' of ' + numQuestions + ': </h2>' + md.getSubSectionAsHtml('Four Players Announcement', 'Notes', false, regionData)
	  }),
	
	  // question text
	  (0, _baseSlidesBalloonSlide2['default'])({
	    balloonType: 'question',
	    characterSide: 'left',
	    characterImage: questionCharacter,
	    questionNumber: questionNumber,
	    numQuestions: numQuestions,
	    id: questionNumber + '-question',
	    html: md.getSubSectionAsHtml(questionSection, 'Question', false, regionData),
	    notes: '<h2>Question ' + questionNumber + ' of ' + numQuestions + ': </h2>' + '<br />' + '<p style="font color: white">Preview of next slide/answer</h4>' + answer
	  }),
	
	  // answer slide
	  (0, _baseSlidesBalloonSlide2['default'])({
	    balloonType: 'answer',
	    characterSide: 'right',
	    characterImage: answerCharacter,
	    questionNumber: questionNumber,
	    id: questionNumber + '-answer',
	    html: answer,
	    notes: '<h2>Answer ' + questionNumber + ' of ' + numQuestions + '</h2>' + '<br />' + (!answerNotes.match(/SKIP/) ? md.getSubSectionAsHtml(questionSection, 'Answer Notes', false, regionData) : '')
	  })];
	}
	
	function endOfGameShow(level) {
	  return (0, _baseSlidesBalloonSlide2['default'])({
	    id: 'end',
	    characterSide: 'left',
	    characterImage: _imagesCharactersIan_shrug_laughPng2['default'],
	    bgColor: '#742CBF',
	    html: '<h3>Level ' + level + ' Game Show Completed!</h3>',
	    notes: 'Game show completed.'
	  });
	}
	
	function level1(regionData) {
	  var level = 1;
	  var md = levels[level].md;
	
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'game-show' },
	    intro(level, regionData),
	    sizzle(level, regionData),
	    scoring(level, regionData),
	    questionSlide({ level: level, questionNumber: 1, numQuestions: 4, md: md, regionData: regionData }),
	    (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'scoring-reminder',
	      characterSide: 'left',
	      characterImage: _imagesCharactersIan_pointing_upPng2['default'],
	      notes: md.getSubSectionAsHtml('Scoring Reminder', 'Notes', false, regionData),
	      html: md.getSubSectionAsHtml('Scoring Reminder', 'Content', false, regionData),
	      bgColor: '#742CBF'
	    }),
	    questionSlide({ level: level, questionNumber: 2, numQuestions: 4, md: md, regionData: regionData }),
	    questionSlide({ level: level, questionNumber: 3, numQuestions: 4, md: md, regionData: regionData }),
	    questionSlide({ level: level, questionNumber: 4, numQuestions: 4, md: md, regionData: regionData }),
	    endOfGameShow(level)
	  );
	}
	
	function level2(regionData) {
	  var level = 2;
	  var md = levels[level].md;
	
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'game-show' },
	    intro(level, regionData),
	    sizzle(level, regionData),
	    scoring(level, regionData),
	    questionSlide({ level: level, questionNumber: 1, numQuestions: 3, md: md, regionData: regionData }),
	    questionSlide({ level: level, questionNumber: 2, numQuestions: 3, md: md, regionData: regionData }),
	    questionSlide({ level: level, questionNumber: 3, numQuestions: 3, md: md, regionData: regionData }),
	    endOfGameShow(level)
	  );
	}
	
	function gameShowSection(_ref2) {
	  var level = _ref2.level;
	  var regionData = _ref2.regionData;
	
	  switch (level) {
	    case 1:
	      return level1(regionData);
	    case 2:
	      return level2(regionData);
	    default:
	      return (0, _baseSlidesHeadingSlide2['default'])({ heading: 'Unknown' });
	  }
	}
	
	exports['default'] = gameShowSection;
	/* Sara and Ian introduce the Game Show */ /* Sizzle */ /* Scoring intro */ /* Game show questions */ /* Scoring reminder */ /* End of Game Show */ /* Sara and Ian introduce the Game Show */ /* Sizzle */ /* Scoring intro */ /* Game show questions */ /* End of Game Show */

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = __webpack_require__(7)['default'];
	
	var _regeneratorRuntime = __webpack_require__(492)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.getOptIns = getOptIns;
	exports.setOptIns = setOptIns;
	exports.unsubscribe = unsubscribe;
	exports.subscribe = subscribe;
	
	var _appConfigJs = __webpack_require__(54);
	
	var _appConfigJs2 = _interopRequireDefault(_appConfigJs);
	
	var _servicesAjax = __webpack_require__(230);
	
	var _appConfig = __webpack_require__(54);
	
	var _appConfig2 = _interopRequireDefault(_appConfig);
	
	var _servicesEvents = __webpack_require__(73);
	
	var GET_OPTINS = 'GET_OPTINS';
	exports.GET_OPTINS = GET_OPTINS;
	var GET_OPTINS_COMPLETED = 'GET_OPTINS_COMPLETED';
	exports.GET_OPTINS_COMPLETED = GET_OPTINS_COMPLETED;
	var GET_OPTINS_FAILED = 'GET_OPTINS_FAILED';
	
	exports.GET_OPTINS_FAILED = GET_OPTINS_FAILED;
	
	function getOptIns(userId) {
	  var _this = this;
	
	  return function callee$1$0(dispatch) {
	    var xhr, res;
	    return _regeneratorRuntime.async(function callee$1$0$(context$2$0) {
	      while (1) switch (context$2$0.prev = context$2$0.next) {
	        case 0:
	          context$2$0.prev = 0;
	
	          dispatch({ type: GET_OPTINS, payload: { userId: userId } });
	          context$2$0.next = 4;
	          return _regeneratorRuntime.awrap((0, _servicesAjax.asyncAjax)(_appConfigJs2['default'].apiUrl + 'optIns?userId=' + userId));
	
	        case 4:
	          xhr = context$2$0.sent;
	          res = xhr.responseText;
	
	          if (xhr.status !== 200) {
	            dispatch({ type: GET_OPTINS_FAILED, payload: { message: 'Request failed with status code: ' + xhr.status } });
	          } else {
	            dispatch({ type: GET_OPTINS_COMPLETED, payload: JSON.parse(res) });
	          }
	          context$2$0.next = 12;
	          break;
	
	        case 9:
	          context$2$0.prev = 9;
	          context$2$0.t0 = context$2$0['catch'](0);
	
	          dispatch({ type: GET_OPTINS_FAILED, payload: context$2$0.t0 });
	
	        case 12:
	        case 'end':
	          return context$2$0.stop();
	      }
	    }, null, _this, [[0, 9]]);
	  };
	}
	
	var SET_OPTINS = 'SET_OPTINS';
	exports.SET_OPTINS = SET_OPTINS;
	var SET_OPTINS_COMPLETED = 'SET_OPTINS_COMPLETED';
	exports.SET_OPTINS_COMPLETED = SET_OPTINS_COMPLETED;
	var SET_OPTINS_FAILED = 'SET_OPTINS_FAILED';
	
	exports.SET_OPTINS_FAILED = SET_OPTINS_FAILED;
	
	function setOptIns(userId, optIns) {
	  var _this2 = this;
	
	  return function callee$1$0(dispatch) {
	    var xhr, res;
	    return _regeneratorRuntime.async(function callee$1$0$(context$2$0) {
	      while (1) switch (context$2$0.prev = context$2$0.next) {
	        case 0:
	          context$2$0.prev = 0;
	
	          dispatch({ type: SET_OPTINS, payload: { userId: userId } });
	          context$2$0.next = 4;
	          return _regeneratorRuntime.awrap((0, _servicesAjax.asyncAjax)(_appConfigJs2['default'].apiUrl + 'optIns', JSON.stringify(_extends({ userId: userId }, optIns))));
	
	        case 4:
	          xhr = context$2$0.sent;
	          res = xhr.responseText;
	
	          if (xhr.status !== 200) {
	            dispatch({ type: SET_OPTINS_FAILED, payload: { message: 'Request failed with status code: ' + xhr.status } });
	          } else {
	            dispatch({ type: SET_OPTINS_COMPLETED, payload: JSON.parse(res) });
	          }
	          context$2$0.next = 12;
	          break;
	
	        case 9:
	          context$2$0.prev = 9;
	          context$2$0.t0 = context$2$0['catch'](0);
	
	          dispatch({ type: SET_OPTINS_FAILED, payload: context$2$0.t0 });
	
	        case 12:
	        case 'end':
	          return context$2$0.stop();
	      }
	    }, null, _this2, [[0, 9]]);
	  };
	}
	
	var UNSUBSCRIBE = 'UNSUBSCRIBE';
	exports.UNSUBSCRIBE = UNSUBSCRIBE;
	var UNSUBSCRIBE_COMPLETED = 'UNSUBSCRIBE_COMPLETED';
	exports.UNSUBSCRIBE_COMPLETED = UNSUBSCRIBE_COMPLETED;
	var UNSUBSCRIBE_FAILED = 'UNSUBSCRIBE_FAILED';
	
	exports.UNSUBSCRIBE_FAILED = UNSUBSCRIBE_FAILED;
	
	function unsubscribe(userId, listId) {
	  var _this3 = this;
	
	  return function callee$1$0(dispatch) {
	    var response, xhr, res, payload;
	    return _regeneratorRuntime.async(function callee$1$0$(context$2$0) {
	      while (1) switch (context$2$0.prev = context$2$0.next) {
	        case 0:
	          dispatch({ type: UNSUBSCRIBE, payload: { userId: userId, listId: listId } });
	          response = undefined;
	          context$2$0.prev = 2;
	          context$2$0.next = 5;
	          return _regeneratorRuntime.awrap((0, _servicesAjax.asyncAjax)(_appConfig2['default'].apiUrl + 'unsubscribe', JSON.stringify({ userId: userId, listId: listId })));
	
	        case 5:
	          xhr = context$2$0.sent;
	          res = xhr.responseText;
	
	          if (!(xhr.status !== 200)) {
	            context$2$0.next = 11;
	            break;
	          }
	
	          console.log("Unsubscribe failed, status =", xhr.status, " responseText =", res);
	          dispatch({ type: UNSUBSCRIBE_FAILED, payload: { message: "Server returned an error." } });
	          return context$2$0.abrupt('return');
	
	        case 11:
	          response = JSON.parse(res);
	          dispatch({ type: UNSUBSCRIBE_COMPLETED, payload: response });
	          context$2$0.next = 19;
	          break;
	
	        case 15:
	          context$2$0.prev = 15;
	          context$2$0.t0 = context$2$0['catch'](2);
	
	          dispatch({ type: UNSUBSCRIBE_FAILED, payload: context$2$0.t0 });
	          return context$2$0.abrupt('return');
	
	        case 19:
	          if (!(!response || !response.unsubscribed || response.unsubscribed !== "OK")) {
	            context$2$0.next = 21;
	            break;
	          }
	
	          return context$2$0.abrupt('return');
	
	        case 21:
	          payload = {
	            userId: userId,
	            email: response.email,
	            listId: listId,
	            consent: "implicit",
	            location: "link"
	          };
	
	          (0, _servicesEvents.publishEvent)('Unsubscribed', payload);
	
	        case 23:
	        case 'end':
	          return context$2$0.stop();
	      }
	    }, null, _this3, [[2, 15]]);
	  };
	}
	
	var SUBSCRIBE = 'SUBSCRIBE';
	exports.SUBSCRIBE = SUBSCRIBE;
	var SUBSCRIBE_COMPLETED = 'SUBSCRIBE_COMPLETED';
	exports.SUBSCRIBE_COMPLETED = SUBSCRIBE_COMPLETED;
	var SUBSCRIBE_FAILED = 'SUBSCRIBE_FAILED';
	
	exports.SUBSCRIBE_FAILED = SUBSCRIBE_FAILED;
	
	function subscribe(userId, listId) {
	  var _this4 = this;
	
	  return function callee$1$0(dispatch) {
	    var response, xhr, res, payload;
	    return _regeneratorRuntime.async(function callee$1$0$(context$2$0) {
	      while (1) switch (context$2$0.prev = context$2$0.next) {
	        case 0:
	          dispatch({ type: SUBSCRIBE, payload: { userId: userId, listId: listId } });
	          response = undefined;
	          context$2$0.prev = 2;
	          context$2$0.next = 5;
	          return _regeneratorRuntime.awrap((0, _servicesAjax.asyncAjax)(_appConfig2['default'].apiUrl + 'subscribe', JSON.stringify({ userId: userId, listId: listId })));
	
	        case 5:
	          xhr = context$2$0.sent;
	          res = xhr.responseText;
	
	          if (!(xhr.status !== 200)) {
	            context$2$0.next = 11;
	            break;
	          }
	
	          console.log("Subscribe failed, status =", xhr.status, " responseText =", res);
	          dispatch({ type: SUBSCRIBE_FAILED, payload: { message: "Server returned an error." } });
	          return context$2$0.abrupt('return');
	
	        case 11:
	          response = JSON.parse(res);
	          dispatch({ type: SUBSCRIBE_COMPLETED, payload: response });
	          context$2$0.next = 19;
	          break;
	
	        case 15:
	          context$2$0.prev = 15;
	          context$2$0.t0 = context$2$0['catch'](2);
	
	          dispatch({ type: SUBSCRIBE_FAILED, payload: context$2$0.t0 });
	          return context$2$0.abrupt('return');
	
	        case 19:
	          if (!(!response || !response.subscribed || response.subscribed !== "OK")) {
	            context$2$0.next = 21;
	            break;
	          }
	
	          return context$2$0.abrupt('return');
	
	        case 21:
	          payload = {
	            userId: userId,
	            email: response.email,
	            listId: listId,
	            consent: "implicit",
	            location: "link"
	          };
	
	          (0, _servicesEvents.publishEvent)('Subscribed', payload);
	
	        case 23:
	        case 'end':
	          return context$2$0.stop();
	      }
	    }, null, _this4, [[2, 15]]);
	  };
	}

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _Object$freeze = __webpack_require__(308)["default"];
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var featureFlags = {
	  autoCreateClassWhenFeaturedProgramIsPresent: false, // 1
	  showVideoAfterAddingFirstClass: false,
	  allowAnyoneToSkipBetweenLevels: true
	};
	_Object$freeze(featureFlags);
	
	/*
	1) If we re-activate this feature we need to add updateProfile with gettingStartedOptIn=true after class auto-creation
	*/
	
	exports["default"] = featureFlags;
	module.exports = exports["default"];

/***/ }),
/* 301 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.parseCookie = parseCookie;
	
	function parseCookie(value) {
	    if (!value) return;
	    var json = window.atob(value);
	    return JSON.parse(json);
	}

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

	/* eslint no-undef:0 */
	
	'use strict';
	
	var _Promise = __webpack_require__(33)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.getPrice = getPrice;
	exports.createCCToken = createCCToken;
	exports.processCharge = processCharge;
	exports.getValidUntilTime = getValidUntilTime;
	
	var _appConfig = __webpack_require__(54);
	
	var _appConfig2 = _interopRequireDefault(_appConfig);
	
	Stripe.setPublishableKey(_appConfig2['default'].stripe);
	
	var CANADIAN_PROVINCES = ['AB', 'BC', 'MB', 'NB', 'NL', 'NS', 'NT', 'NU', 'ON', 'PE', 'QC', 'SK', 'YT'];
	function isCanada(state) {
	  return CANADIAN_PROVINCES.indexOf(state) >= 0;
	}
	
	var PRICES = {
	  'CAD': 250,
	  'USD': 250
	};
	
	function getPriceForCurrency(currency) {
	  return {
	    currency: currency,
	    amount: PRICES[currency]
	  };
	}
	
	function getPrice(profile) {
	  if (isCanada(profile.stateOrProvince)) {
	    return getPriceForCurrency('CAD');
	  }
	  return getPriceForCurrency('USD');
	}
	
	function createCCToken($form) {
	  return new _Promise(function (resolve, reject) {
	    Stripe.card.createToken($form, function (status, response) {
	      if (response.error) {
	        reject(response.error);
	      } else {
	        resolve(response.id);
	      }
	    });
	  });
	}
	
	function parseJsonResponse(xhrResponse) {
	  if (!xhrResponse) return null;
	  if (typeof xhrResponse !== 'string') return xhrResponse;
	  try {
	    return JSON.parse(xhrResponse);
	  } catch (err) {
	    return null;
	  }
	}
	
	function ajax(method, endpoint, data, cb) {
	  var xhr = new XMLHttpRequest();
	  xhr.open(method, _appConfig2['default'].apiUrl + endpoint, true);
	  xhr.setRequestHeader('Accept', 'application/json');
	  xhr.setRequestHeader('Content-Type', 'application/json');
	  xhr.addEventListener('readystatechange', function () {
	    if (xhr.readyState !== XMLHttpRequest.DONE) return;
	    if (xhr.status >= 400) {
	      var error = new Error(['Request failed:', method, endpoint, 'returned', xhr.status, xhr.statusText].join(' '));
	      error.response = xhr.response;
	      error.responseType = xhr.responseType;
	      cb(error, parseJsonResponse(xhr.response));
	      return;
	    }
	    cb(null, parseJsonResponse(xhr.response));
	  });
	  xhr.send(data ? JSON.stringify(data) : null);
	}
	
	function processCharge(data) {
	  return new _Promise(function (resolve, reject) {
	    ajax('POST', 'buySession', data, function (err, response) {
	      if (err) return reject(err);
	      resolve(response);
	    });
	  });
	}
	
	function getValidUntilTime() {
	  var now = new Date();
	  var validUntil = new Date(now.getFullYear(), 5, 30); // June 30th
	  if (validUntil < now) {
	    validUntil.setYear(now.getFullYear() + 1);
	  }
	  return validUntil.getTime();
	}

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _objectWithoutProperties = __webpack_require__(16)['default'];
	
	var _extends = __webpack_require__(7)['default'];
	
	var React = __webpack_require__(1),
	    RP = React.PropTypes,
	    config = __webpack_require__(1129),
	    debounce = __webpack_require__(65).debounce,
	    zxcvbn;
	
	var InputPassword = React.createClass({
	  displayName: 'InputPassword',
	
	  /*==========  VALIDATE  ==========*/
	
	  propTypes: {
	    infoBar: RP.bool,
	    statusColor: RP.string,
	    statusInactiveColor: RP.string,
	    minScore: RP.number,
	    changeCb: RP.func,
	    toggleMask: RP.bool,
	    unMaskTime: RP.number,
	    minLength: RP.number,
	    strengthLang: RP.array,
	    id: RP.string
	  },
	
	  /*==========  DEFAULTS  ==========*/
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      infoBar: true,
	      statusColor: config.statusColor,
	      statusInactiveColor: config.statusInactiveColor,
	      zxcvbn: config.zxcvbnSrc,
	      minScore: 0,
	      toggleMask: true,
	      unMaskTime: config.unMaskTime,
	      strengthLang: config.strengthLang,
	      id: 'input'
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      value: '',
	      score: 0,
	      entropy: 0,
	      isPassword: true,
	      isValid: false
	    };
	  },
	
	  /*==========  STYLES  ==========*/
	
	  getMeterStyle: function getMeterStyle(score) {
	    var width = this.state.value === '' ? 0 : 24 * score + 4;
	    return {
	      width: this.props.zxcvbn ? width + '%' : '100%',
	      maxWidth: '85%',
	      opacity: this.props.zxcvbn ? width * .01 + .5 : '1',
	      background: this.state.isValid ? this.props.statusColor : this.props.statusInactiveColor,
	      height: 5,
	      transition: 'all 400ms linear',
	      display: 'inline-block',
	      marginRight: '1%'
	    };
	  },
	
	  unMaskStyle: {
	    color: config.unMaskColor,
	    fontWeight: 200
	  },
	
	  infoStyle: {
	    // position: 'absolute',
	    bottom: -10,
	    width: '100%',
	    overflow: 'hidden',
	    height: 24
	  },
	
	  infoLabel: {
	    display: 'inline-block',
	    opacity: .5,
	    position: 'relative',
	    top: 2,
	    paddingRight: 5
	  },
	
	  strengthLangStyle: {
	    fontSize: 12,
	    position: 'relative',
	    top: 2
	  },
	
	  /*==========  METHODS  ==========*/
	
	  addPasswordType: function addPasswordType() {
	    this.setState({
	      isPassword: true
	    });
	  },
	
	  /*==========  HANDLERS  ==========*/
	
	  handleInputType: function handleInputType() {
	    this.setState({
	      isPassword: !this.state.isPassword
	    });
	  },
	
	  handleChange: function handleChange(e) {
	    e.preventDefault();
	
	    var native_target = e.nativeEvent.target;
	    var val = e.target.value;
	    var score;
	
	    this.setState({
	      value: val,
	      isValid: e.target.validity.valid,
	      selectionStart: native_target.selectionStart,
	      selectionEnd: native_target.selectionEnd
	    });
	
	    if (this.props.toggleMask) {
	      this.handleToggleMask();
	    }
	
	    if (this.props.zxcvbn) {
	      score = this.handleZxcvbn(val);
	    } else {
	      score = this.state.score;
	    }
	
	    // call onChange prop passed from parent
	    if (this.props.onChange) {
	      this.props.onChange(val, this.state.isValid, score);
	    }
	
	    if (this.props.minLength) {
	      this.handleMinLength(e.target.value.length);
	    }
	  },
	
	  handleToggleMask: function handleToggleMask() {
	
	    // display password, then
	    this.setState({
	      isPassword: false
	    });
	
	    // debounce remasking password
	    this.maskPassword();
	  },
	
	  handleZxcvbn: function handleZxcvbn(val) {
	
	    if (typeof zxcvbn === 'undefined' && typeof window.zxcvbn === 'undefined') {
	      return;
	    }
	
	    var stats = zxcvbn(val),
	        currentScore = stats.score;
	
	    this.setState({
	      score: currentScore,
	      entropy: stats.entropy
	    });
	
	    if (currentScore < this.props.minScore) {
	      this.setState({
	        isValid: false
	      });
	    }
	
	    // if score changed and callback provided
	    if (this.props.changeCb && this.state.score !== currentScore) {
	      this.props.changeCb(this.state.score, currentScore, val);
	    }
	
	    if (this.props.zxcvbn === 'debug') {
	      console.debug(stats);
	    }
	
	    return currentScore;
	  },
	
	  handleMinLength: function handleMinLength(len) {
	    if (len <= this.props.minLength) {
	      this.setState({
	        isValid: false
	      });
	    }
	  },
	
	  componentWillMount: function componentWillMount() {
	    var zxcvbnSrc;
	
	    // Load zxcvbn async if its enabled and doesn't already exist
	    if (this.props.zxcvbn && typeof zxcvbn === 'undefined') {
	
	      zxcvbnSrc = this.props.zxcvbn !== 'debug' ? this.props.zxcvbn : config.zxcvbnSrc;
	
	      // async load zxcvbn
	      __webpack_require__.e/* nsure */(1, function (require) {
	        zxcvbn = __webpack_require__(2554);
	      });
	    }
	
	    // set debouncer for password
	    if (this.props.toggleMask) {
	      this.maskPassword = debounce(this.addPasswordType, this.props.unMaskTime);
	    }
	  },
	
	  render: function render() {
	    var infoBar;
	
	    if (this.props.infoBar) {
	      infoBar = React.createElement(
	        'div',
	        { className: 'passwordField__info', style: this.infoStyle },
	        this.state.value.length > 0 && this.props.strengthLang.length > 0 && React.createElement(
	          'span',
	          { style: this.infoLabel },
	          'Strength'
	        ),
	        React.createElement('span', { style: this.getMeterStyle(this.state.score),
	          className: 'passwordField__meter' }),
	        React.createElement(
	          'span',
	          { style: this.strengthLangStyle, className: 'passwordField__strength' },
	          this.props.zxcvbn && this.state.value.length > 0 && this.props.strengthLang.length > 0 ? this.props.strengthLang[this.state.score] : null
	        )
	      );
	    }
	
	    // allow onChange to be passed from parent and not override default prop
	    var _props = this.props;
	    var onChange = _props.onChange;
	
	    var props = _objectWithoutProperties(_props, ['onChange']);
	
	    // overcome problem with firefox resetting the input selection point
	    var that = this;
	    setTimeout(function () {
	      if (!/Firefox/.test(navigator.userAgent)) return;
	      var elem = that.refs[that.props.id].getDOMNode();
	      elem.selectionStart = that.state.selectionStart;
	      elem.selectionEnd = that.state.selectionEnd;
	    }, 1);
	
	    return React.createElement(
	      'div',
	      {
	        style: { position: 'relative', display: 'block' },
	        className: 'passwordField',
	        'data-valid': this.state.isValid,
	        'data-score': this.state.score,
	        'data-entropy': this.state.entropy
	      },
	      React.createElement('input', _extends({
	        ref: this.props.id,
	        className: 'passwordField__input',
	        type: this.state.isPassword ? 'password' : 'text',
	        value: this.state.value,
	        style: this.state.isPassword ? null : this.unMaskStyle,
	        onChange: this.handleChange
	      }, props)),
	      infoBar
	    );
	  }
	});
	
	module.exports = InputPassword;

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _extends = __webpack_require__(7)["default"];
	
	var _interopRequireDefault = __webpack_require__(2)["default"];
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _vendorReactUxPasswordFieldSrc = __webpack_require__(303);
	
	var _vendorReactUxPasswordFieldSrc2 = _interopRequireDefault(_vendorReactUxPasswordFieldSrc);
	
	var _termsAndConditionsModal = __webpack_require__(1149);
	
	var _termsAndConditionsModal2 = _interopRequireDefault(_termsAndConditionsModal);
	
	var _dataUsageModal = __webpack_require__(1138);
	
	var _dataUsageModal2 = _interopRequireDefault(_dataUsageModal);
	
	var GetFirstName = function GetFirstName(props) {
	  return _react2["default"].createElement(
	    "div",
	    { className: "form-group" },
	    _react2["default"].createElement(
	      "label",
	      {
	        htmlFor: "txtFirstName",
	        className: "control-label"
	      },
	      "First Name *"
	    ),
	    _react2["default"].createElement("input", _extends({
	      id: "txtFirstname",
	      type: "text",
	      className: "form-control",
	      placeholder: "Jane",
	      spellCheck: "false",
	      maxLength: 80
	    }, props.firstName)),
	    props.firstName.error && props.firstName.touched ? _react2["default"].createElement(
	      "div",
	      { className: "text-danger" },
	      props.firstName.error
	    ) : _react2["default"].createElement("div", null)
	  );
	};
	
	exports.GetFirstName = GetFirstName;
	var GetLastName = function GetLastName(props) {
	  return _react2["default"].createElement(
	    "div",
	    { className: "form-group" },
	    _react2["default"].createElement(
	      "label",
	      {
	        htmlFor: "txtLastName",
	        className: "control-label"
	      },
	      "Last Name *"
	    ),
	    _react2["default"].createElement("input", _extends({
	      id: "txtLasttname",
	      type: "text",
	      className: "form-control",
	      placeholder: "Doe",
	      spellCheck: "false",
	      maxLength: 80
	    }, props.lastName)),
	    props.lastName.error && props.lastName.touched ? _react2["default"].createElement(
	      "div",
	      { className: "text-danger" },
	      props.lastName.error
	    ) : _react2["default"].createElement("div", null)
	  );
	};
	
	exports.GetLastName = GetLastName;
	var GetPhone = function GetPhone(props) {
	  return _react2["default"].createElement(
	    "div",
	    { className: "form-group" },
	    _react2["default"].createElement(
	      "label",
	      {
	        htmlFor: "txtPhone",
	        className: "control-label"
	      },
	      "Phone"
	    ),
	    _react2["default"].createElement("input", _extends({
	      id: "txtPhone",
	      type: "tel",
	      className: "form-control",
	      placeholder: "111-111-1111",
	      spellCheck: "false"
	    }, props.phone)),
	    props.phone.error && props.phone.touched ? _react2["default"].createElement(
	      "div",
	      { className: "text-danger" },
	      props.phone.error
	    ) : _react2["default"].createElement("div", null)
	  );
	};
	
	exports.GetPhone = GetPhone;
	var GetEmail = function GetEmail(props) {
	  return _react2["default"].createElement(
	    "div",
	    { className: "form-group" },
	    _react2["default"].createElement(
	      "label",
	      {
	        htmlFor: "txtEmail",
	        className: "control-label"
	      },
	      "Email * ",
	      _react2["default"].createElement(
	        "em",
	        null,
	        "(please use your school district email account if you have one)"
	      )
	    ),
	    _react2["default"].createElement("input", _extends({
	      id: "txtEmail",
	      type: "email",
	      className: "form-control",
	      placeholder: "jane@example.com",
	      spellCheck: "false"
	    }, props.email)),
	    props.email.error && props.email.touched ? _react2["default"].createElement("div", { className: "text-danger", dangerouslySetInnerHTML: { __html: props.email.error } }) : _react2["default"].createElement("div", null)
	  );
	};
	
	exports.GetEmail = GetEmail;
	var GetPasword = function GetPasword(props) {
	  return _react2["default"].createElement(
	    "div",
	    { className: "form-group" },
	    _react2["default"].createElement(
	      "label",
	      {
	        htmlFor: "txtPassword",
	        className: "control-label"
	      },
	      "Choose a password *"
	    ),
	    _react2["default"].createElement(_vendorReactUxPasswordFieldSrc2["default"], _extends({
	      id: "txtPassword",
	      className: "form-control",
	      placeholder: "thoo!mu3Da",
	      autoComplete: "off",
	      minLength: 8,
	      toggleMask: false
	    }, props.password)),
	    props.password.error && props.password.touched ? _react2["default"].createElement("div", { className: "text-danger", dangerouslySetInnerHTML: { __html: props.password.error } }) : _react2["default"].createElement("div", null)
	  );
	};
	
	exports.GetPasword = GetPasword;
	var GetOptIn = function GetOptIn(props) {
	  return _react2["default"].createElement(
	    "div",
	    {
	      className: props.optIn.error && props.optIn.touched ? "has-error" : ""
	    },
	    _react2["default"].createElement(
	      "div",
	      { className: "checkbox" },
	      _react2["default"].createElement(
	        "label",
	        null,
	        _react2["default"].createElement("input", _extends({
	          type: "checkbox"
	        }, props.optIn)),
	        props.label
	      )
	    ),
	    props.optIn.error && props.optIn.touched ? _react2["default"].createElement(
	      "div",
	      { className: "text-danger" },
	      props.optIn.error
	    ) : _react2["default"].createElement("div", null)
	  );
	};
	
	exports.GetOptIn = GetOptIn;
	var GetTermsAccepted = function GetTermsAccepted(props) {
	  return _react2["default"].createElement(
	    "div",
	    null,
	    _react2["default"].createElement(
	      "div",
	      { className: "checkbox" },
	      _react2["default"].createElement(
	        "label",
	        null,
	        _react2["default"].createElement("input", _extends({
	          type: "checkbox"
	        }, props.termsAccepted)),
	        "I accept the ",
	        _react2["default"].createElement(
	          "a",
	          { onClick: props.openTerms() },
	          "Terms & Conditions "
	        ),
	        "and ",
	        _react2["default"].createElement(
	          "a",
	          { onClick: props.openDataUsage() },
	          "Data Usage Policy"
	        ),
	        " ",
	        _react2["default"].createElement(
	          "em",
	          null,
	          "*"
	        )
	      ),
	      _react2["default"].createElement(_termsAndConditionsModal2["default"], {
	        showModal: props.showTermsAndConditionsModal,
	        closeModal: function () {
	          return props.closeTerms();
	        }
	      }),
	      _react2["default"].createElement(_dataUsageModal2["default"], {
	        showModal: props.showDataUsageModal,
	        closeModal: function () {
	          return props.closeDataUsage();
	        }
	      })
	    )
	  );
	};
	
	exports.GetTermsAccepted = GetTermsAccepted;
	var GetSchool = function GetSchool(props) {
	  return _react2["default"].createElement(
	    "div",
	    null,
	    _react2["default"].createElement(
	      "div",
	      { className: "form-group" },
	      _react2["default"].createElement(
	        "label",
	        {
	          htmlFor: "schoolTxt",
	          className: "control-label"
	        },
	        "School *"
	      ),
	      _react2["default"].createElement("input", _extends({
	        id: "schoolTxt",
	        type: "text",
	        className: "form-control",
	        placeholder: "Springfield Elementary",
	        spellCheck: "false",
	        maxLength: 80
	      }, props.school))
	    ),
	    props.school.error && props.school.touched ? _react2["default"].createElement(
	      "div",
	      { className: "text-danger" },
	      props.school.error
	    ) : _react2["default"].createElement("div", null)
	  );
	};
	
	exports.GetSchool = GetSchool;
	var GetCity = function GetCity(props) {
	  return _react2["default"].createElement(
	    "div",
	    null,
	    _react2["default"].createElement(
	      "div",
	      { className: "form-group" },
	      _react2["default"].createElement(
	        "label",
	        {
	          htmlFor: "cityTxt",
	          className: "control-label"
	        },
	        "City *"
	      ),
	      _react2["default"].createElement("input", _extends({
	        id: "cityTxt",
	        type: "text",
	        className: "form-control",
	        placeholder: "Springfield",
	        maxLength: 80
	      }, props.cityOrMunicipality))
	    ),
	    props.cityOrMunicipality.error && props.cityOrMunicipality.touched ? _react2["default"].createElement(
	      "div",
	      { className: "text-danger" },
	      props.cityOrMunicipality.error
	    ) : _react2["default"].createElement("div", null)
	  );
	};
	
	exports.GetCity = GetCity;
	var GetStatesOrProvince = function GetStatesOrProvince(props) {
	  return _react2["default"].createElement(
	    "div",
	    null,
	    _react2["default"].createElement(
	      "div",
	      { className: "form-group" },
	      _react2["default"].createElement(
	        "label",
	        {
	          htmlFor: "txtStateOrProvince",
	          className: "control-label"
	        },
	        "State or Province *"
	      ),
	      _react2["default"].createElement(
	        "select",
	        _extends({ id: "txtStateOrProvince",
	          className: "form-control"
	        }, props.stateOrProvince),
	        _react2["default"].createElement(
	          "option",
	          { value: "" },
	          " - Select State/Province - "
	        ),
	        props.statesOrProvinces.map(function (item) {
	          return _react2["default"].createElement(
	            "option",
	            { key: item.code, value: item.code },
	            item.name
	          );
	        })
	      )
	    ),
	    props.stateOrProvince.error && props.stateOrProvince.touched ? _react2["default"].createElement(
	      "div",
	      { className: "text-danger" },
	      props.stateOrProvince.error
	    ) : _react2["default"].createElement("div", null)
	  );
	};
	
	exports.GetStatesOrProvince = GetStatesOrProvince;
	var GetCountry = function GetCountry(props) {
	  return _react2["default"].createElement(
	    "div",
	    null,
	    _react2["default"].createElement(
	      "div",
	      { className: "form-group" },
	      _react2["default"].createElement(
	        "label",
	        {
	          htmlFor: "txtCountry",
	          className: "control-label"
	        },
	        "Country *"
	      ),
	      _react2["default"].createElement(
	        "select",
	        _extends({
	          id: "txtCountry",
	          className: "form-control"
	        }, props.country),
	        _react2["default"].createElement(
	          "option",
	          { value: "" },
	          " - Select Country -"
	        ),
	        _react2["default"].createElement(
	          "option",
	          { value: "Canada" },
	          "Canada"
	        ),
	        _react2["default"].createElement(
	          "option",
	          { value: "United States" },
	          "United States"
	        ),
	        _react2["default"].createElement(
	          "option",
	          { disabled: true },
	          " ────────── "
	        ),
	        props.countries.map(function (item) {
	          return _react2["default"].createElement(
	            "option",
	            { key: item, value: item },
	            item
	          );
	        })
	      )
	    ),
	    props.country.error && props.country.touched ? _react2["default"].createElement(
	      "div",
	      { className: "text-danger" },
	      props.country.error
	    ) : _react2["default"].createElement("div", null)
	  );
	};
	exports.GetCountry = GetCountry;

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _taggedTemplateLiteral = __webpack_require__(28)['default'];
	
	var _get = __webpack_require__(8)['default'];
	
	var _inherits = __webpack_require__(5)['default'];
	
	var _createClass = __webpack_require__(6)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _extends = __webpack_require__(7)['default'];
	
	var _Number$MAX_SAFE_INTEGER = __webpack_require__(486)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['Edit class details'], ['Edit class details']),
	    _templateObject2 = _taggedTemplateLiteral(['Add a class'], ['Add a class']),
	    _templateObject3 = _taggedTemplateLiteral(['Save'], ['Save']),
	    _templateObject4 = _taggedTemplateLiteral(['Add Class'], ['Add Class']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(24);
	
	var _reduxForm = __webpack_require__(36);
	
	var _validateClass = __webpack_require__(476);
	
	var _helpersI18n = __webpack_require__(14);
	
	var _lodash = __webpack_require__(65);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var AddEditClassModal = (function (_Component) {
	  _inherits(AddEditClassModal, _Component);
	
	  _createClass(AddEditClassModal, null, [{
	    key: 'propTypes',
	    value: {
	      programs: _react.PropTypes.array.isRequired,
	      showModal: _react.PropTypes.bool.isRequired,
	      closeModal: _react.PropTypes.func.isRequired,
	      fields: _react.PropTypes.shape({
	        alert: _react.PropTypes.object.isRequired,
	        program: _react.PropTypes.object.isRequired,
	        language: _react.PropTypes.object.isRequired,
	        grade: _react.PropTypes.object.isRequired,
	        divisionName: _react.PropTypes.object.isRequired,
	        numberOfStudents: _react.PropTypes.object.isRequired
	      }).isRequired,
	      handleSubmit: _react.PropTypes.func.isRequired,
	      edit: _react.PropTypes.bool,
	      text: _react.PropTypes.string,
	      title: _react.PropTypes.string
	    },
	    enumerable: true
	  }, {
	    key: 'contextTypes',
	    value: {
	      location: _react.PropTypes.object.isRequired
	    },
	    enumerable: true
	  }]);
	
	  function AddEditClassModal(props) {
	    _classCallCheck(this, _AddEditClassModal);
	
	    _get(Object.getPrototypeOf(_AddEditClassModal.prototype), 'constructor', this).call(this, props);
	    this.i18n = (0, _helpersI18n.i18n)(props.fields.language.value || _helpersI18n.defaultLanguage);
	  }
	
	  _createClass(AddEditClassModal, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.fields.language.value !== this.props.fields.language.value) {
	        this.i18n = (0, _helpersI18n.i18n)(nextProps.fields.language.value || _helpersI18n.defaultLanguage);
	      }
	    }
	  }, {
	    key: 'getSelectedProgramDescription',
	    value: function getSelectedProgramDescription() {
	      var selectedProgramId = this.props.fields.program.value;
	
	      var _ = this.i18n;
	      if (!selectedProgramId) {
	        return '';
	      }
	      var program = _lodash2['default'].find(this.props.programs, function (prog) {
	        return prog.id === selectedProgramId;
	      });
	      if (!program) {
	        return '';
	      }
	      return _(program.shortDescription);
	    }
	  }, {
	    key: 'getSelectedProgramTitle',
	    value: function getSelectedProgramTitle() {
	      var selectedProgramId = this.props.fields.program.value;
	
	      var _ = this.i18n;
	      if (!selectedProgramId) {
	        return '';
	      }
	      var program = _lodash2['default'].find(this.props.programs, function (prog) {
	        return prog.id === selectedProgramId;
	      });
	      if (!program) {
	        return '';
	      }
	      return _(program.title);
	    }
	  }, {
	    key: 'getSelectedProgramLanguages',
	    value: function getSelectedProgramLanguages() {
	      var selectedProgramId = this.props.fields.program.value;
	      if (!selectedProgramId) {
	        return [];
	      }
	      var program = _lodash2['default'].find(this.props.programs, function (prog) {
	        return prog.id === selectedProgramId;
	      });
	      if (!program) {
	        return [];
	      }
	      return program.languages || [_helpersI18n.defaultLanguage];
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var showModal = _props.showModal;
	      var closeModal = _props.closeModal;
	      var programs = _props.programs;
	      var _props$fields = _props.fields;
	      var alert = _props$fields.alert;
	      var program = _props$fields.program;
	      var language = _props$fields.language;
	      var grade = _props$fields.grade;
	      var divisionName = _props$fields.divisionName;
	      var numberOfStudents = _props$fields.numberOfStudents;
	      var handleSubmit = _props.handleSubmit;
	      var edit = _props.edit;
	      var title = _props.title;
	
	      var _ = this.i18n;
	
	      return _react2['default'].createElement(
	        _reactBootstrap.Modal,
	        { show: showModal, onHide: closeModal, dialogClassName: 'add-edit-class-modal' },
	        _react2['default'].createElement(
	          _reactBootstrap.Modal.Header,
	          { closeButton: true },
	          _react2['default'].createElement(
	            _reactBootstrap.Modal.Title,
	            null,
	            title ? title : edit ? _(_templateObject) : _(_templateObject2)
	          )
	        ),
	        _react2['default'].createElement(
	          'form',
	          { onSubmit: handleSubmit },
	          _react2['default'].createElement(
	            _reactBootstrap.Modal.Body,
	            null,
	            _react2['default'].createElement(
	              'div',
	              { className: 'row' },
	              _react2['default'].createElement(
	                'div',
	                { className: 'col-sm-8 col-md-12' },
	                _react2['default'].createElement(
	                  'h4',
	                  null,
	                  this.props.text
	                ),
	                alert.error && _react2['default'].createElement(
	                  'div',
	                  { className: 'form-group' },
	                  _react2['default'].createElement(
	                    'div',
	                    { className: 'alert alert-danger' },
	                    alert.error
	                  )
	                ),
	                edit ? _react2['default'].createElement(
	                  'div',
	                  { className: 'form-group' },
	                  _react2['default'].createElement(
	                    'label',
	                    { className: 'control-label' },
	                    _('Program')
	                  ),
	                  _react2['default'].createElement('input', _extends({ type: 'hidden' }, program)),
	                  _react2['default'].createElement(
	                    'div',
	                    null,
	                    this.getSelectedProgramTitle()
	                  )
	                ) : _react2['default'].createElement(
	                  'div',
	                  { className: 'form-group ' + (program.error && program.touched && 'has-error') },
	                  _react2['default'].createElement(
	                    'label',
	                    { htmlFor: 'selectProgram',
	                      className: 'control-label' },
	                    _('Pick a program'),
	                    ' (',
	                    _react2['default'].createElement(
	                      'a',
	                      { className: 'learnAboutPrograms', href: '/programs' },
	                      _('Learn about programs')
	                    ),
	                    ')'
	                  ),
	                  _react2['default'].createElement(
	                    'select',
	                    _extends({ id: 'selectProgram',
	                      className: 'form-control'
	                    }, program),
	                    _react2['default'].createElement(
	                      'option',
	                      { value: '' },
	                      '-- ',
	                      _('Choose a program'),
	                      ' --'
	                    ),
	                    programs.map(function (prog) {
	                      return _react2['default'].createElement(
	                        'option',
	                        { key: prog.id, value: prog.id },
	                        _(prog.title)
	                      );
	                    })
	                  ),
	                  program.error && program.touched && _react2['default'].createElement(
	                    'div',
	                    { className: 'text-danger' },
	                    _(program.error)
	                  ),
	                  _react2['default'].createElement(
	                    'h4',
	                    null,
	                    this.getSelectedProgramDescription()
	                  )
	                ),
	                _react2['default'].createElement(
	                  'div',
	                  { className: 'form-group ' + (language.error && language.touched && 'has-error') },
	                  _react2['default'].createElement(
	                    'label',
	                    { htmlFor: 'selectLanguage' },
	                    _('Language')
	                  ),
	                  _react2['default'].createElement(
	                    'select',
	                    _extends({ id: 'selectLanguage',
	                      className: 'form-control'
	                    }, language),
	                    this.getSelectedProgramLanguages().map(function (lng) {
	                      return _react2['default'].createElement(
	                        'option',
	                        { key: lng, value: lng },
	                        _helpersI18n.languages[lng]
	                      );
	                    })
	                  ),
	                  language.error && language.touched && _react2['default'].createElement(
	                    'div',
	                    { className: 'text-danger' },
	                    _(language.error)
	                  )
	                ),
	                _react2['default'].createElement(
	                  'div',
	                  { className: 'form-group ' + (grade.error && grade.touched && 'has-error') },
	                  _react2['default'].createElement(
	                    'label',
	                    { htmlFor: 'txtGrade',
	                      className: 'control-label' },
	                    _('Grade')
	                  ),
	                  _react2['default'].createElement('input', _extends({ id: 'txtGrade',
	                    type: 'text',
	                    className: 'form-control',
	                    placeholder: '',
	                    spellCheck: 'false',
	                    autoComplete: 'off',
	                    maxLength: 80
	                  }, grade)),
	                  grade.error && grade.touched && _react2['default'].createElement(
	                    'div',
	                    { className: 'text-danger' },
	                    _(grade.error)
	                  )
	                ),
	                _react2['default'].createElement(
	                  'div',
	                  { className: 'form-group ' + (divisionName.error && divisionName.touched && 'has-error') },
	                  _react2['default'].createElement(
	                    'label',
	                    { htmlFor: 'txtDivisionName',
	                      className: 'control-label' },
	                    _('Class/Division Name or #')
	                  ),
	                  _react2['default'].createElement('input', _extends({ id: 'txtDivisionName',
	                    type: 'text',
	                    className: 'form-control',
	                    placeholder: '',
	                    spellCheck: 'false',
	                    autoComplete: 'off',
	                    maxLength: 80
	                  }, divisionName)),
	                  divisionName.error && divisionName.touched && _react2['default'].createElement(
	                    'div',
	                    { className: 'text-danger' },
	                    _(divisionName.error)
	                  )
	                ),
	                _react2['default'].createElement(
	                  'div',
	                  { className: 'form-group ' + (numberOfStudents.error && numberOfStudents.touched && 'has-error') },
	                  _react2['default'].createElement(
	                    'label',
	                    { htmlFor: 'txtNumberOfStudents',
	                      className: 'control-label' },
	                    _('# of Students')
	                  ),
	                  _react2['default'].createElement('input', _extends({ id: 'txtNumberOfStudents',
	                    type: 'number',
	                    className: 'form-control',
	                    placeholder: '',
	                    min: '0',
	                    spellCheck: 'false',
	                    max: _Number$MAX_SAFE_INTEGER
	                  }, numberOfStudents)),
	                  numberOfStudents.error && numberOfStudents.touched && _react2['default'].createElement(
	                    'div',
	                    { className: 'text-danger' },
	                    _(numberOfStudents.error)
	                  ),
	                  numberOfStudents.valid && numberOfStudents.value > 40 && _react2['default'].createElement(
	                    'div',
	                    { style: { color: "#FF8300 !important" } },
	                    _react2['default'].createElement(
	                      'p',
	                      null,
	                      _react2['default'].createElement(
	                        'em',
	                        null,
	                        _('Top Tip!')
	                      ),
	                      ' ',
	                      _('The program is designed to be used with one classroom at a time.')
	                    ),
	                    _react2['default'].createElement(
	                      'p',
	                      null,
	                      _react2['default'].createElement(
	                        'em',
	                        null,
	                        _('Want to use it in multiple classrooms?')
	                      ),
	                      ' ',
	                      _('Add additional classes from the Programs page so that your progress and team points are saved separately for each class!')
	                    )
	                  )
	                )
	              )
	            )
	          ),
	          _react2['default'].createElement(
	            _reactBootstrap.Modal.Footer,
	            null,
	            _react2['default'].createElement(
	              _reactBootstrap.Row,
	              null,
	              _react2['default'].createElement(
	                _reactBootstrap.Col,
	                { xs: 12, sm: 6 },
	                _react2['default'].createElement(
	                  'div',
	                  { style: { textAlign: "left" } },
	                  !edit && _("By adding your class, you agree to receive occasional emails with tips from a real human to help you get started!")
	                )
	              ),
	              _react2['default'].createElement(
	                _reactBootstrap.Col,
	                { xs: 12, sm: 6 },
	                _react2['default'].createElement(
	                  'button',
	                  { type: 'submit', className: 'btn btn-lg btn-primary' },
	                  edit ? _(_templateObject3) : _(_templateObject4)
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  var _AddEditClassModal = AddEditClassModal;
	  AddEditClassModal = (0, _reduxForm.connectReduxForm)({
	    form: 'addEditClass',
	    fields: ['alert', 'program', 'language', 'grade', 'divisionName', 'numberOfStudents'],
	    validate: _validateClass.validateClass
	  })(AddEditClassModal) || AddEditClassModal;
	  return AddEditClassModal;
	})(_react.Component);
	
	exports['default'] = AddEditClassModal;
	module.exports = exports['default'];
	/* Alert */ /* Program */ /* Language */ /* Grade */ /* Division Name */ /* Number of Students */

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _taggedTemplateLiteral = __webpack_require__(28)['default'];
	
	var _get = __webpack_require__(8)['default'];
	
	var _inherits = __webpack_require__(5)['default'];
	
	var _createClass = __webpack_require__(6)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['This will be hacked in ', ' seconds.'], ['This will be hacked in ', ' seconds.']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _componentsCompleteLevelButton = __webpack_require__(44);
	
	var _componentsCompleteLevelButton2 = _interopRequireDefault(_componentsCompleteLevelButton);
	
	var _bkg_hackJpg = __webpack_require__(2537);
	
	var _bkg_hackJpg2 = _interopRequireDefault(_bkg_hackJpg);
	
	__webpack_require__(2215);
	
	var Hacked = (function (_Component) {
	  _inherits(Hacked, _Component);
	
	  _createClass(Hacked, null, [{
	    key: 'propTypes',
	    value: {
	      cliffHanger: _react.PropTypes.bool
	    },
	    enumerable: true
	  }, {
	    key: 'contextTypes',
	    value: {
	      session: _react.PropTypes.object.isRequired,
	      isHacked: _react.PropTypes.bool,
	      presenter: _react.PropTypes.bool,
	      setHackedAnswer: _react.PropTypes.func.isRequired,
	      hideHUD: _react.PropTypes.func.isRequired,
	      i18n: _react.PropTypes.func.isRequired
	    },
	    enumerable: true
	  }]);
	
	  function Hacked(props) {
	    _classCallCheck(this, Hacked);
	
	    _get(Object.getPrototypeOf(Hacked.prototype), 'constructor', this).call(this, props);
	    this.state = {
	      hacked: true,
	      countdown: 5
	    };
	  }
	
	  _createClass(Hacked, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.interval = setInterval(this.countdown.bind(this), 1000);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.interval) {
	        clearInterval(this.interval);
	      }
	    }
	  }, {
	    key: 'setHackedAnswer',
	    value: function setHackedAnswer(answer) {
	      var _context = this.context;
	      var session = _context.session;
	      var setHackedAnswer = _context.setHackedAnswer;
	      var hideHUD = _context.hideHUD;
	      var level = session.currentLevel;
	
	      setHackedAnswer({
	        level: level,
	        answer: answer
	      });
	      hideHUD();
	    }
	  }, {
	    key: 'clickHandler',
	    value: function clickHandler(evt) {
	      if (evt) {
	        evt.preventDefault();
	        evt.stopPropagation();
	        evt.nativeEvent.stopPropagation();
	      }
	    }
	  }, {
	    key: 'startHack',
	    value: function startHack() {
	      this.setState({
	        hacked: true
	      });
	    }
	  }, {
	    key: 'countdown',
	    value: function countdown() {
	      var countdown = this.state.countdown;
	
	      if (countdown === 1) {
	        this.startHack();
	        clearInterval(this.interval);
	        this.interval = null;
	        return;
	      }
	      this.setState({
	        countdown: countdown - 1
	      });
	    }
	  }, {
	    key: 'changeHandler',
	    value: function changeHandler(evt) {
	      this.setHackedAnswer(evt.target.value);
	      if (evt) {
	        evt.preventDefault();
	        evt.stopPropagation();
	        evt.nativeEvent.stopPropagation();
	      }
	    }
	  }, {
	    key: 'keyDown',
	    value: function keyDown(evt) {
	      var presenter = this.context.presenter;
	
	      if (evt) {
	        if (presenter) {
	          // Stop arrow key navigation on teacher remote
	          if (evt.keyCode === 37 || evt.keyCode === 39) {
	            // left, right
	            evt.stopPropagation();
	            evt.nativeEvent.stopPropagation();
	          }
	        } else {
	          // Don't use arrows for input fields in presentation mode
	          if (evt.keyCode === 37 || evt.keyCode === 39) {
	            // left, right
	            evt.preventDefault();
	          }
	        }
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var cliffHanger = this.props.cliffHanger;
	      var _state = this.state;
	      var countdown = _state.countdown;
	      var hacked = _state.hacked;
	      var _context2 = this.context;
	      var session = _context2.session;
	      var presenter = _context2.presenter;
	      var _ = _context2.i18n;
	
	      var hackedAnswer = session['zh-hacked-answer-' + session.currentLevel];
	      /*
	      const {
	        session: {
	          isHacked
	        }
	      } = this.context;
	      */
	
	      return _react2['default'].createElement(
	        'div',
	        null,
	        hacked && !presenter && _react2['default'].createElement(
	          'div',
	          { className: 'hacked', style: { backgroundImage: 'url(' + _bkg_hackJpg2['default'] + ')' } },
	          _react2['default'].createElement(
	            'div',
	            { className: 'hacked-form' },
	            !cliffHanger ? _react2['default'].createElement('input', {
	              type: 'text',
	              onClick: this.clickHandler.bind(this),
	              onChange: this.changeHandler.bind(this),
	              onKeyDown: this.keyDown.bind(this),
	              placeholder: _("(enter code here)"),
	              value: hackedAnswer }) : null,
	            cliffHanger ? _react2['default'].createElement(_componentsCompleteLevelButton2['default'], null) : null
	          )
	        ),
	        hacked && presenter && _react2['default'].createElement(
	          'div',
	          { className: 'hacked-remote' },
	          !cliffHanger ? _react2['default'].createElement('input', {
	            type: 'text',
	            onClick: this.clickHandler.bind(this),
	            onChange: this.changeHandler.bind(this),
	            onKeyDown: this.keyDown.bind(this),
	            placeholder: _("(enter code here)"),
	            value: hackedAnswer }) : null,
	          cliffHanger ? _react2['default'].createElement(_componentsCompleteLevelButton2['default'], null) : null
	        ),
	        !hacked && _react2['default'].createElement(
	          'div',
	          null,
	          _react2['default'].createElement(
	            'h1',
	            null,
	            _('Unhacked Screen')
	          ),
	          _(_templateObject, countdown)
	        )
	      );
	    }
	  }]);
	
	  return Hacked;
	})(_react.Component);
	
	exports['default'] = Hacked;
	module.exports = exports['default'];

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _get = __webpack_require__(8)['default'];
	
	var _inherits = __webpack_require__(5)['default'];
	
	var _createClass = __webpack_require__(6)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _Object$keys = __webpack_require__(32)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _imagesLogo_ppaSvg = __webpack_require__(453);
	
	var _imagesLogo_ppaSvg2 = _interopRequireDefault(_imagesLogo_ppaSvg);
	
	var VideoRemoteControlButton = (function (_Component) {
	  _inherits(VideoRemoteControlButton, _Component);
	
	  function VideoRemoteControlButton() {
	    _classCallCheck(this, VideoRemoteControlButton);
	
	    _get(Object.getPrototypeOf(VideoRemoteControlButton.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(VideoRemoteControlButton, [{
	    key: 'setVideoState',
	    value: function setVideoState(videoState) {
	      this.context.setVideoState(videoState);
	    }
	  }, {
	    key: 'playPause',
	    value: function playPause() {
	      var _this = this;
	
	      var _context = this.context;
	      var session = _context.session;
	      var _ = _context.i18n;
	
	      var videoState = session && session.videoState ? session.videoState : {};
	
	      if (videoState.finished) {
	        this.setVideoState({
	          playing: false,
	          started: false,
	          finished: false
	        });
	        this.buttonLabel = _('Replay');
	        setTimeout(function () {
	          _this.setVideoState({
	            playing: true,
	            started: true,
	            finished: false
	          });
	          setTimeout(function () {
	            _this.buttonLabel = null;
	          }, 500);
	        }, 1000);
	        return;
	      }
	      this.setVideoState({
	        playing: !videoState.playing,
	        started: true,
	        finished: false
	      });
	    }
	  }, {
	    key: 'seekVideo',
	    value: function seekVideo(seconds) {
	      var session = this.context.session;
	
	      var videoState = session && session.videoState ? session.videoState : {};
	
	      this.setVideoState({
	        playing: videoState.playing,
	        started: true,
	        finished: false,
	        seek: seconds,
	        seekTimestamp: Date.now()
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _context2 = this.context;
	      var session = _context2.session;
	      var _ = _context2.i18n;
	
	      var videoState = session && session.videoState ? session.videoState : {};
	      var videoSlide = false;
	      if (session && session.videoState && _Object$keys(session.videoState).length > 0) {
	        videoSlide = true;
	      }
	
	      if (videoSlide) {
	        var videoButton = undefined;
	        var playbackState = 'unstarted';
	        if (videoState.playing) {
	          playbackState = 'playing';
	        }
	        if (!videoState.playing && videoState.started) {
	          playbackState = 'paused';
	        }
	
	        if (playbackState === 'unstarted' || playbackState === 'paused') {
	          var buttonLabel = videoState.finished ? _('Replay') : _('Play');
	          if (this.buttonLabel) {
	            // We need to override the button label for when Replay
	            // is clicked
	            buttonLabel = this.buttonLabel;
	          }
	          videoButton = _react2['default'].createElement(
	            'button',
	            {
	              key: 'play',
	              className: 'btn teacher-remote-btn-video play',
	              onClick: this.playPause.bind(this) },
	            _react2['default'].createElement(
	              'span',
	              null,
	              _react2['default'].createElement('i', { className: 'glyphicon glyphicon-play' }),
	              buttonLabel
	            )
	          );
	        }
	
	        if (playbackState === 'playing') {
	          videoButton = _react2['default'].createElement(
	            'button',
	            {
	              key: 'pause',
	              className: 'btn teacher-remote-btn-video pause',
	              onClick: this.playPause.bind(this) },
	            _react2['default'].createElement(
	              'span',
	              null,
	              _react2['default'].createElement('i', { className: 'glyphicon glyphicon-pause' }),
	              _('Pause')
	            )
	          );
	        }
	
	        var videoButtons = [];
	        var disableSeek = !(playbackState === 'playing' || playbackState === 'paused');
	        videoButtons.push(_react2['default'].createElement(
	          'button',
	          {
	            key: 'fast-backward',
	            disabled: disableSeek,
	            className: 'btn teacher-remote-btn-video fast-backward',
	            onClick: this.seekVideo.bind(this, -15) },
	          _react2['default'].createElement(
	            'span',
	            null,
	            _react2['default'].createElement('i', { className: 'glyphicon glyphicon-fast-backward' }),
	            _('Rwd')
	          )
	        ));
	        videoButtons.push(videoButton);
	        videoButtons.push(_react2['default'].createElement(
	          'button',
	          {
	            key: 'fast-forward',
	            disabled: disableSeek,
	            className: 'btn teacher-remote-btn-video fast-forward',
	            onClick: this.seekVideo.bind(this, 15) },
	          _react2['default'].createElement(
	            'span',
	            null,
	            _react2['default'].createElement('i', { className: 'glyphicon glyphicon-fast-forward' }),
	            _('Fwd')
	          )
	        ));
	
	        return _react2['default'].createElement(
	          'div',
	          { className: 'btn-group' },
	          videoButtons
	        );
	      }
	
	      return _react2['default'].createElement(
	        'span',
	        { className: 'teacher-remote-btn-placeholder' },
	        _react2['default'].createElement('img', { src: _imagesLogo_ppaSvg2['default'] })
	      );
	    }
	  }], [{
	    key: 'contextTypes',
	    value: {
	      session: _react.PropTypes.object.isRequired,
	      setVideoState: _react.PropTypes.func.isRequired,
	      i18n: _react.PropTypes.func.isRequired
	    },
	    enumerable: true
	  }]);
	
	  return VideoRemoteControlButton;
	})(_react.Component);
	
	exports['default'] = VideoRemoteControlButton;
	module.exports = exports['default'];

/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1225), __esModule: true };

/***/ }),
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}
	
	module.exports = isObject;


/***/ }),
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(566),
	    isLength = __webpack_require__(184),
	    isObjectLike = __webpack_require__(243);
	
	/** `Object#toString` result references. */
	var arrayTag = '[object Array]';
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objToString = objectProto.toString;
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeIsArray = getNative(Array, 'isArray');
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(function() { return arguments; }());
	 * // => false
	 */
	var isArray = nativeIsArray || function(value) {
	  return isObjectLike(value) && isLength(value.length) && objToString.call(value) == arrayTag;
	};
	
	module.exports = isArray;


/***/ }),
/* 347 */,
/* 348 */,
/* 349 */
/***/ (function(module, exports) {

	module.exports = "# Title - Short\n\nH2WHOA! Follow-up Modules\n\n# Title - Long\n\nH2WHOA! Follow-up Modules\n\n# Description - Short\n\nKeep the fun going in the classroom with two pre-planned modules.\n\n# Description - Long\n\nKeep the fun going in the classroom with two pre-planned modules.\n\n# Description - Levels\n\n**Modules include:**\n&nbsp;\n* Water Wise\n* Celebrate!\n&nbsp;\n\n# Level 1\nTitle: Water Wise\nDescription: How we use water in our daily lives, and how we can save!\n\n# Level 2\nTitle: Celebrate!\nDescription: Report back on the at-home mission and celebrate successes!\n"

/***/ }),
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isPromise = undefined;
	
	var _typeof2 = __webpack_require__(363);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _keys = __webpack_require__(764);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	exports.isInternetExplorerBefore = isInternetExplorerBefore;
	exports.objectToGetParams = objectToGetParams;
	exports.windowOpen = windowOpen;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	 * This detection method identifies Internet Explorers up until version 11.
	 *
	 * Reference: https://msdn.microsoft.com/en-us/library/ms537503(v=vs.85).aspx
	 */
	function isInternetExplorerBefore(version) {
	  var iematch = /MSIE ([0-9]+)/g.exec(window.navigator.userAgent);
	
	  return iematch ? +iematch[1] < version : false;
	}
	
	/* eslint-disable prefer-template */
	function objectToGetParams(object) {
	  return '?' + (0, _keys2.default)(object).filter(function (key) {
	    return !!object[key];
	  }).map(function (key) {
	    return key + '=' + encodeURIComponent(object[key]);
	  }).join('&');
	}
	/* eslint-enable prefer-template */
	
	function windowOpen(url, _ref, onShareWindowClose) {
	  var name = _ref.name,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 400 : _ref$height,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 550 : _ref$width;
	
	  var left = window.outerWidth / 2 + (window.screenX || window.screenLeft || 0) - width / 2;
	  var top = window.outerHeight / 2 + (window.screenY || window.screenTop || 0) - height / 2;
	
	  var config = {
	    height: height,
	    width: width,
	    left: left,
	    top: top,
	    location: 'no',
	    toolbar: 'no',
	    status: 'no',
	    directories: 'no',
	    menubar: 'no',
	    scrollbars: 'yes',
	    resizable: 'no',
	    centerscreen: 'yes',
	    chrome: 'yes'
	  };
	
	  var shareDialog = window.open(url, isInternetExplorerBefore(10) ? '' : name, (0, _keys2.default)(config).map(function (key) {
	    return key + '=' + config[key];
	  }).join(', '));
	
	  if (onShareWindowClose) {
	    var interval = window.setInterval(function () {
	      try {
	        if (shareDialog === null || shareDialog.closed) {
	          window.clearInterval(interval);
	          onShareWindowClose(shareDialog);
	        }
	      } catch (e) {
	        /* eslint-disable no-console */
	        console.error(e);
	        /* eslint-enable no-console */
	      }
	    }, 1000);
	  }
	
	  return shareDialog;
	}
	
	var isPromise = exports.isPromise = function isPromise(obj) {
	  return !!obj && ((typeof obj === 'undefined' ? 'undefined' : (0, _typeof3.default)(obj)) === 'object' || typeof obj === 'function') && typeof obj.then === 'function';
	};

/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _assign = __webpack_require__(1979);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _assign2.default || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};

/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _iterator = __webpack_require__(1984);
	
	var _iterator2 = _interopRequireDefault(_iterator);
	
	var _symbol = __webpack_require__(1983);
	
	var _symbol2 = _interopRequireDefault(_symbol);
	
	var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
	  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
	} : function (obj) {
	  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
	};

/***/ }),
/* 364 */
/***/ (function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};


/***/ }),
/* 365 */
/***/ (function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');


/***/ }),
/* 366 */
/***/ (function(module, exports) {

	module.exports = {};


/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject = __webpack_require__(191);
	var dPs = __webpack_require__(2004);
	var enumBugKeys = __webpack_require__(365);
	var IE_PROTO = __webpack_require__(370)('IE_PROTO');
	var Empty = function () { /* empty */ };
	var PROTOTYPE = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(771)('iframe');
	  var i = enumBugKeys.length;
	  var lt = '<';
	  var gt = '>';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(1998).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty();
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ }),
/* 368 */
/***/ (function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

	var def = __webpack_require__(116).f;
	var has = __webpack_require__(115);
	var TAG = __webpack_require__(149)('toStringTag');
	
	module.exports = function (it, tag, stat) {
	  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
	};


/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(371)('keys');
	var uid = __webpack_require__(261);
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};


/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

	var core = __webpack_require__(42);
	var global = __webpack_require__(97);
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || (global[SHARED] = {});
	
	(module.exports = function (key, value) {
	  return store[key] || (store[key] = value !== undefined ? value : {});
	})('versions', []).push({
	  version: core.version,
	  mode: __webpack_require__(258) ? 'pure' : 'global',
	  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
	});


/***/ }),
/* 372 */
/***/ (function(module, exports) {

	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	module.exports = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};


/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(147);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};


/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(97);
	var core = __webpack_require__(42);
	var LIBRARY = __webpack_require__(258);
	var wksExt = __webpack_require__(375);
	var defineProperty = __webpack_require__(116).f;
	module.exports = function (name) {
	  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
	  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
	};


/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

	exports.f = __webpack_require__(149);


/***/ }),
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */
/***/ (function(module, exports) {

	/*!
	 * repeat-string <https://github.com/jonschlinkert/repeat-string>
	 *
	 * Copyright (c) 2014-2015, Jon Schlinkert.
	 * Licensed under the MIT License.
	 */
	
	'use strict';
	
	/**
	 * Results cache
	 */
	
	var res = '';
	var cache;
	
	/**
	 * Expose `repeat`
	 */
	
	module.exports = repeat;
	
	/**
	 * Repeat the given `string` the specified `number`
	 * of times.
	 *
	 * **Example:**
	 *
	 * ```js
	 * var repeat = require('repeat-string');
	 * repeat('A', 5);
	 * //=> AAAAA
	 * ```
	 *
	 * @param {String} `string` The string to repeat
	 * @param {Number} `number` The number of times to repeat the string
	 * @return {String} Repeated string
	 * @api public
	 */
	
	function repeat(str, num) {
	  if (typeof str !== 'string') {
	    throw new TypeError('expected a string');
	  }
	
	  // cover common, quick use cases
	  if (num === 1) return str;
	  if (num === 2) return str + str;
	
	  var max = str.length * num;
	  if (cache !== str || typeof cache === 'undefined') {
	    cache = str;
	    res = '';
	  } else if (res.length >= max) {
	    return res.substr(0, max);
	  }
	
	  while (max > res.length && num > 1) {
	    if (num & 1) {
	      res += str;
	    }
	
	    num >>= 1;
	    str += str;
	  }
	
	  res += str;
	  res = res.substr(0, max);
	  return res;
	}


/***/ }),
/* 402 */,
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/epsHybridAssembly/images/characters/apprenticePointingUp-83b8906d4e66a6dcab6abf0974076ceb.png";

/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/epsHybridIntermediates/images/characters/ian_pointing_up-bba09e13f5577e652503b9d51f9542fe.png";

/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/epsHybridIntermediates/images/characters/ian_sara_lean_smile-12d488cb6a6d1d48a6f2c910bc4b245d.png";

/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/epsHybridIntermediates/images/characters/sara_smile-235bfd423fca04d38d1338973d9baaa5.png";

/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/epsHybridIntermediates/images/emergencyPreparednessSquadGlow-0e342e40a280edf7ea3f35969fb58217.png";

/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/epsHybridIntermediates/images/level-1_start-6731b6cdde1dcce9be71edea3d6d592a.png";

/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/epsHybridIntermediates/images/level-2_start-442837f0b16c00f643a0e2c24ea2764b.png";

/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/epsHybridPrimaries/images/characters/ian_pointing_up-bba09e13f5577e652503b9d51f9542fe.png";

/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/epsHybridPrimaries/images/characters/ian_sara_lean_smile-12d488cb6a6d1d48a6f2c910bc4b245d.png";

/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/epsHybridPrimaries/images/characters/sara_smile-235bfd423fca04d38d1338973d9baaa5.png";

/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/epsHybridPrimaries/images/emergencyPreparednessSquadGlow-0e342e40a280edf7ea3f35969fb58217.png";

/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/epsHybridPrimaries/images/level-1_start-6731b6cdde1dcce9be71edea3d6d592a.png";

/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/epsHybridPrimaries/images/level-2_start-442837f0b16c00f643a0e2c24ea2764b.png";

/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/epsIntermediates/images/characters/ian_pointing_up-bba09e13f5577e652503b9d51f9542fe.png";

/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/epsIntermediates/images/characters/ian_sara_lean_smile-12d488cb6a6d1d48a6f2c910bc4b245d.png";

/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/epsIntermediates/images/characters/sara_smile-235bfd423fca04d38d1338973d9baaa5.png";

/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/epsIntermediates/images/emergencyPreparednessSquadGlow-0e342e40a280edf7ea3f35969fb58217.png";

/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/epsIntermediates/images/level-1_start-fa7258753d8cfafa05d92649458bde53.png";

/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/epsIntermediates/images/level-2_start-6731b6cdde1dcce9be71edea3d6d592a.png";

/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/epsIntermediates/images/level-3_start-442837f0b16c00f643a0e2c24ea2764b.png";

/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/epsPrimaries/images/characters/ian_pointing_up-bba09e13f5577e652503b9d51f9542fe.png";

/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/epsPrimaries/images/characters/ian_sara_lean_smile-12d488cb6a6d1d48a6f2c910bc4b245d.png";

/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/epsPrimaries/images/characters/sara_smile-235bfd423fca04d38d1338973d9baaa5.png";

/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/epsPrimaries/images/emergencyPreparednessSquadGlow-0e342e40a280edf7ea3f35969fb58217.png";

/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/epsPrimaries/images/level-1_start-fa7258753d8cfafa05d92649458bde53.png";

/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/epsPrimaries/images/level-2_start-6731b6cdde1dcce9be71edea3d6d592a.png";

/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/epsPrimaries/images/level-3_start-442837f0b16c00f643a0e2c24ea2764b.png";

/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/h2whoa/images/characters/apprenticesFlexArms-4aeefe98ba101c125fbc6e150654e893.png";

/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/h2whoa/images/characters/esmeralda_hands_out_wehey-7832e3f2ef50d264342ef65ea50c8936.png";

/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/h2whoa/images/level-1_start-cf4d72ef4103dc996fe27f0dbdd394bc.png";

/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/h2whoa/images/level-2_start-ef79035c09665140e421ec8371688e51.png";

/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/h2whoa/images/level-3_start-d100d721e5dca4ec9349644abd9ac11b.png";

/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/h2whoaHybrid/images/characters/ian_pointing_up-bba09e13f5577e652503b9d51f9542fe.png";

/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/h2whoaHybrid/images/characters/ian_sara_lean_smile-12d488cb6a6d1d48a6f2c910bc4b245d.png";

/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/h2whoaHybrid/images/characters/sara_smile-235bfd423fca04d38d1338973d9baaa5.png";

/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/keepCool/images/characters/esmeralda_goober_goofy_smile-ea36a1f2dea26b0654b664d4bb49cb2f.png";

/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/keepCool/images/characters/esmeralda_goober_proud-8cbef198ed6fd9fc4fa28a700b2d5f24.png";

/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/keepCool/images/characters/esmeralda_hands_out_wehey-7832e3f2ef50d264342ef65ea50c8936.png";

/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/keepCool/images/level-2_start-7d69e5f0039ee3aa45c51956ec7606cc.png";

/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/keepCool/images/level-3_start-c14b0872de7f6c7f1354e01c929c6f03.png";

/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/keepCool/images/level-4_start-c17cc4dc78e516c70bccdc9f31237926.png";

/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/keepCool/images/level-5_start-a29b7169ad26a58a9755c49ddbee2070.png";

/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/zeroHeroes/images/characters/esmeralda_goober_goofy_smile-ea36a1f2dea26b0654b664d4bb49cb2f.png";

/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/zeroHeroes/images/characters/esmeralda_goober_proud-8cbef198ed6fd9fc4fa28a700b2d5f24.png";

/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/zeroHeroes/images/characters/esmeralda_hands_out_wehey-7832e3f2ef50d264342ef65ea50c8936.png";

/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/zeroHeroes/images/level-1_start-bd002d52ad6b2540a0cf9701b39f3729.png";

/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/zeroHeroes/images/level-2_start-4d063116996736a0857946bae11d2af6.png";

/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/zeroHeroes/images/level-3_start-7a5b7e046a74e9928eef848eb843db9e.png";

/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/zeroHeroes/images/level-4_start-1eca31c035bdfd4aa4017d79a8328323.png";

/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/zeroHeroes/images/level-5_start-e1907bc5b43efa434ab461f9958e218a.png";

/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/images/logo_ppa-1c755af25916c3f9a746997ea8451e86.svg";

/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, global) {/**
	 * @license
	 * lodash 3.9.3 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern -d -o ./index.js`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	;(function() {
	
	  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
	  var undefined;
	
	  /** Used as the semantic version number. */
	  var VERSION = '3.9.3';
	
	  /** Used to compose bitmasks for wrapper metadata. */
	  var BIND_FLAG = 1,
	      BIND_KEY_FLAG = 2,
	      CURRY_BOUND_FLAG = 4,
	      CURRY_FLAG = 8,
	      CURRY_RIGHT_FLAG = 16,
	      PARTIAL_FLAG = 32,
	      PARTIAL_RIGHT_FLAG = 64,
	      ARY_FLAG = 128,
	      REARG_FLAG = 256;
	
	  /** Used as default options for `_.trunc`. */
	  var DEFAULT_TRUNC_LENGTH = 30,
	      DEFAULT_TRUNC_OMISSION = '...';
	
	  /** Used to detect when a function becomes hot. */
	  var HOT_COUNT = 150,
	      HOT_SPAN = 16;
	
	  /** Used to indicate the type of lazy iteratees. */
	  var LAZY_DROP_WHILE_FLAG = 0,
	      LAZY_FILTER_FLAG = 1,
	      LAZY_MAP_FLAG = 2;
	
	  /** Used as the `TypeError` message for "Functions" methods. */
	  var FUNC_ERROR_TEXT = 'Expected a function';
	
	  /** Used as the internal argument placeholder. */
	  var PLACEHOLDER = '__lodash_placeholder__';
	
	  /** `Object#toString` result references. */
	  var argsTag = '[object Arguments]',
	      arrayTag = '[object Array]',
	      boolTag = '[object Boolean]',
	      dateTag = '[object Date]',
	      errorTag = '[object Error]',
	      funcTag = '[object Function]',
	      mapTag = '[object Map]',
	      numberTag = '[object Number]',
	      objectTag = '[object Object]',
	      regexpTag = '[object RegExp]',
	      setTag = '[object Set]',
	      stringTag = '[object String]',
	      weakMapTag = '[object WeakMap]';
	
	  var arrayBufferTag = '[object ArrayBuffer]',
	      float32Tag = '[object Float32Array]',
	      float64Tag = '[object Float64Array]',
	      int8Tag = '[object Int8Array]',
	      int16Tag = '[object Int16Array]',
	      int32Tag = '[object Int32Array]',
	      uint8Tag = '[object Uint8Array]',
	      uint8ClampedTag = '[object Uint8ClampedArray]',
	      uint16Tag = '[object Uint16Array]',
	      uint32Tag = '[object Uint32Array]';
	
	  /** Used to match empty string literals in compiled template source. */
	  var reEmptyStringLeading = /\b__p \+= '';/g,
	      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
	      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
	
	  /** Used to match HTML entities and HTML characters. */
	  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39|#96);/g,
	      reUnescapedHtml = /[&<>"'`]/g,
	      reHasEscapedHtml = RegExp(reEscapedHtml.source),
	      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
	
	  /** Used to match template delimiters. */
	  var reEscape = /<%-([\s\S]+?)%>/g,
	      reEvaluate = /<%([\s\S]+?)%>/g,
	      reInterpolate = /<%=([\s\S]+?)%>/g;
	
	  /** Used to match property names within property paths. */
	  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\n\\]|\\.)*?\1)\]/,
	      reIsPlainProp = /^\w*$/,
	      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\n\\]|\\.)*?)\2)\]/g;
	
	  /**
	   * Used to match `RegExp` [special characters](http://www.regular-expressions.info/characters.html#special).
	   * In addition to special characters the forward slash is escaped to allow for
	   * easier `eval` use and `Function` compilation.
	   */
	  var reRegExpChars = /[.*+?^${}()|[\]\/\\]/g,
	      reHasRegExpChars = RegExp(reRegExpChars.source);
	
	  /** Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks). */
	  var reComboMark = /[\u0300-\u036f\ufe20-\ufe23]/g;
	
	  /** Used to match backslashes in property paths. */
	  var reEscapeChar = /\\(\\)?/g;
	
	  /** Used to match [ES template delimiters](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-template-literal-lexical-components). */
	  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
	
	  /** Used to match `RegExp` flags from their coerced string values. */
	  var reFlags = /\w*$/;
	
	  /** Used to detect hexadecimal string values. */
	  var reHasHexPrefix = /^0[xX]/;
	
	  /** Used to detect host constructors (Safari > 5). */
	  var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	  /** Used to detect unsigned integer values. */
	  var reIsUint = /^\d+$/;
	
	  /** Used to match latin-1 supplementary letters (excluding mathematical operators). */
	  var reLatin1 = /[\xc0-\xd6\xd8-\xde\xdf-\xf6\xf8-\xff]/g;
	
	  /** Used to ensure capturing order of template delimiters. */
	  var reNoMatch = /($^)/;
	
	  /** Used to match unescaped characters in compiled string literals. */
	  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
	
	  /** Used to match words to create compound words. */
	  var reWords = (function() {
	    var upper = '[A-Z\\xc0-\\xd6\\xd8-\\xde]',
	        lower = '[a-z\\xdf-\\xf6\\xf8-\\xff]+';
	
	    return RegExp(upper + '+(?=' + upper + lower + ')|' + upper + '?' + lower + '|' + upper + '+|[0-9]+', 'g');
	  }());
	
	  /** Used to detect and test for whitespace. */
	  var whitespace = (
	    // Basic whitespace characters.
	    ' \t\x0b\f\xa0\ufeff' +
	
	    // Line terminators.
	    '\n\r\u2028\u2029' +
	
	    // Unicode category "Zs" space separators.
	    '\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000'
	  );
	
	  /** Used to assign default `context` object properties. */
	  var contextProps = [
	    'Array', 'ArrayBuffer', 'Date', 'Error', 'Float32Array', 'Float64Array',
	    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Math', 'Number',
	    'Object', 'RegExp', 'Set', 'String', '_', 'clearTimeout', 'document',
	    'isFinite', 'parseFloat', 'parseInt', 'setTimeout', 'TypeError', 'Uint8Array',
	    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap', 'window'
	  ];
	
	  /** Used to make template sourceURLs easier to identify. */
	  var templateCounter = -1;
	
	  /** Used to identify `toStringTag` values of typed arrays. */
	  var typedArrayTags = {};
	  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	  typedArrayTags[uint32Tag] = true;
	  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	  typedArrayTags[dateTag] = typedArrayTags[errorTag] =
	  typedArrayTags[funcTag] = typedArrayTags[mapTag] =
	  typedArrayTags[numberTag] = typedArrayTags[objectTag] =
	  typedArrayTags[regexpTag] = typedArrayTags[setTag] =
	  typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
	
	  /** Used to identify `toStringTag` values supported by `_.clone`. */
	  var cloneableTags = {};
	  cloneableTags[argsTag] = cloneableTags[arrayTag] =
	  cloneableTags[arrayBufferTag] = cloneableTags[boolTag] =
	  cloneableTags[dateTag] = cloneableTags[float32Tag] =
	  cloneableTags[float64Tag] = cloneableTags[int8Tag] =
	  cloneableTags[int16Tag] = cloneableTags[int32Tag] =
	  cloneableTags[numberTag] = cloneableTags[objectTag] =
	  cloneableTags[regexpTag] = cloneableTags[stringTag] =
	  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	  cloneableTags[errorTag] = cloneableTags[funcTag] =
	  cloneableTags[mapTag] = cloneableTags[setTag] =
	  cloneableTags[weakMapTag] = false;
	
	  /** Used as an internal `_.debounce` options object by `_.throttle`. */
	  var debounceOptions = {
	    'leading': false,
	    'maxWait': 0,
	    'trailing': false
	  };
	
	  /** Used to map latin-1 supplementary letters to basic latin letters. */
	  var deburredLetters = {
	    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
	    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
	    '\xc7': 'C',  '\xe7': 'c',
	    '\xd0': 'D',  '\xf0': 'd',
	    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
	    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
	    '\xcC': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
	    '\xeC': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
	    '\xd1': 'N',  '\xf1': 'n',
	    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
	    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
	    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
	    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
	    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
	    '\xc6': 'Ae', '\xe6': 'ae',
	    '\xde': 'Th', '\xfe': 'th',
	    '\xdf': 'ss'
	  };
	
	  /** Used to map characters to HTML entities. */
	  var htmlEscapes = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#39;',
	    '`': '&#96;'
	  };
	
	  /** Used to map HTML entities to characters. */
	  var htmlUnescapes = {
	    '&amp;': '&',
	    '&lt;': '<',
	    '&gt;': '>',
	    '&quot;': '"',
	    '&#39;': "'",
	    '&#96;': '`'
	  };
	
	  /** Used to determine if values are of the language type `Object`. */
	  var objectTypes = {
	    'function': true,
	    'object': true
	  };
	
	  /** Used to escape characters for inclusion in compiled string literals. */
	  var stringEscapes = {
	    '\\': '\\',
	    "'": "'",
	    '\n': 'n',
	    '\r': 'r',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };
	
	  /** Detect free variable `exports`. */
	  var freeExports = objectTypes[typeof exports] && exports && !exports.nodeType && exports;
	
	  /** Detect free variable `module`. */
	  var freeModule = objectTypes[typeof module] && module && !module.nodeType && module;
	
	  /** Detect free variable `global` from Node.js. */
	  var freeGlobal = freeExports && freeModule && typeof global == 'object' && global && global.Object && global;
	
	  /** Detect free variable `self`. */
	  var freeSelf = objectTypes[typeof self] && self && self.Object && self;
	
	  /** Detect free variable `window`. */
	  var freeWindow = objectTypes[typeof window] && window && window.Object && window;
	
	  /** Detect the popular CommonJS extension `module.exports`. */
	  var moduleExports = freeModule && freeModule.exports === freeExports && freeExports;
	
	  /**
	   * Used as a reference to the global object.
	   *
	   * The `this` value is used if it's the global object to avoid Greasemonkey's
	   * restricted `window` object, otherwise the `window` object is used.
	   */
	  var root = freeGlobal || ((freeWindow !== (this && this.window)) && freeWindow) || freeSelf || this;
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * The base implementation of `compareAscending` which compares values and
	   * sorts them in ascending order without guaranteeing a stable sort.
	   *
	   * @private
	   * @param {*} value The value to compare.
	   * @param {*} other The other value to compare.
	   * @returns {number} Returns the sort order indicator for `value`.
	   */
	  function baseCompareAscending(value, other) {
	    if (value !== other) {
	      var valIsNull = value === null,
	          valIsUndef = value === undefined,
	          valIsReflexive = value === value;
	
	      var othIsNull = other === null,
	          othIsUndef = other === undefined,
	          othIsReflexive = other === other;
	
	      if ((value > other && !othIsNull) || !valIsReflexive ||
	          (valIsNull && !othIsUndef && othIsReflexive) ||
	          (valIsUndef && othIsReflexive)) {
	        return 1;
	      }
	      if ((value < other && !valIsNull) || !othIsReflexive ||
	          (othIsNull && !valIsUndef && valIsReflexive) ||
	          (othIsUndef && valIsReflexive)) {
	        return -1;
	      }
	    }
	    return 0;
	  }
	
	  /**
	   * The base implementation of `_.findIndex` and `_.findLastIndex` without
	   * support for callback shorthands and `this` binding.
	   *
	   * @private
	   * @param {Array} array The array to search.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {boolean} [fromRight] Specify iterating from right to left.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseFindIndex(array, predicate, fromRight) {
	    var length = array.length,
	        index = fromRight ? length : -1;
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (predicate(array[index], index, array)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.indexOf` without support for binary searches.
	   *
	   * @private
	   * @param {Array} array The array to search.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOf(array, value, fromIndex) {
	    if (value !== value) {
	      return indexOfNaN(array, fromIndex);
	    }
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.isFunction` without support for environments
	   * with incorrect `typeof` results.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	   */
	  function baseIsFunction(value) {
	    // Avoid a Chakra JIT bug in compatibility modes of IE 11.
	    // See https://github.com/jashkenas/underscore/issues/1621 for more details.
	    return typeof value == 'function' || false;
	  }
	
	  /**
	   * Converts `value` to a string if it's not one. An empty string is returned
	   * for `null` or `undefined` values.
	   *
	   * @private
	   * @param {*} value The value to process.
	   * @returns {string} Returns the string.
	   */
	  function baseToString(value) {
	    if (typeof value == 'string') {
	      return value;
	    }
	    return value == null ? '' : (value + '');
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimLeft` to get the index of the first character
	   * of `string` that is not found in `chars`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @param {string} chars The characters to find.
	   * @returns {number} Returns the index of the first character not found in `chars`.
	   */
	  function charsLeftIndex(string, chars) {
	    var index = -1,
	        length = string.length;
	
	    while (++index < length && chars.indexOf(string.charAt(index)) > -1) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimRight` to get the index of the last character
	   * of `string` that is not found in `chars`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @param {string} chars The characters to find.
	   * @returns {number} Returns the index of the last character not found in `chars`.
	   */
	  function charsRightIndex(string, chars) {
	    var index = string.length;
	
	    while (index-- && chars.indexOf(string.charAt(index)) > -1) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.sortBy` to compare transformed elements of a collection and stable
	   * sort them in ascending order.
	   *
	   * @private
	   * @param {Object} object The object to compare to `other`.
	   * @param {Object} other The object to compare to `object`.
	   * @returns {number} Returns the sort order indicator for `object`.
	   */
	  function compareAscending(object, other) {
	    return baseCompareAscending(object.criteria, other.criteria) || (object.index - other.index);
	  }
	
	  /**
	   * Used by `_.sortByOrder` to compare multiple properties of each element
	   * in a collection and stable sort them in the following order:
	   *
	   * If `orders` is unspecified, sort in ascending order for all properties.
	   * Otherwise, for each property, sort in ascending order if its corresponding value in
	   * orders is true, and descending order if false.
	   *
	   * @private
	   * @param {Object} object The object to compare to `other`.
	   * @param {Object} other The object to compare to `object`.
	   * @param {boolean[]} orders The order to sort by for each property.
	   * @returns {number} Returns the sort order indicator for `object`.
	   */
	  function compareMultiple(object, other, orders) {
	    var index = -1,
	        objCriteria = object.criteria,
	        othCriteria = other.criteria,
	        length = objCriteria.length,
	        ordersLength = orders.length;
	
	    while (++index < length) {
	      var result = baseCompareAscending(objCriteria[index], othCriteria[index]);
	      if (result) {
	        if (index >= ordersLength) {
	          return result;
	        }
	        return result * (orders[index] ? 1 : -1);
	      }
	    }
	    // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	    // that causes it, under certain circumstances, to provide the same value for
	    // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	    // for more details.
	    //
	    // This also ensures a stable sort in V8 and other engines.
	    // See https://code.google.com/p/v8/issues/detail?id=90 for more details.
	    return object.index - other.index;
	  }
	
	  /**
	   * Used by `_.deburr` to convert latin-1 supplementary letters to basic latin letters.
	   *
	   * @private
	   * @param {string} letter The matched letter to deburr.
	   * @returns {string} Returns the deburred letter.
	   */
	  function deburrLetter(letter) {
	    return deburredLetters[letter];
	  }
	
	  /**
	   * Used by `_.escape` to convert characters to HTML entities.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeHtmlChar(chr) {
	    return htmlEscapes[chr];
	  }
	
	  /**
	   * Used by `_.template` to escape characters for inclusion in compiled
	   * string literals.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeStringChar(chr) {
	    return '\\' + stringEscapes[chr];
	  }
	
	  /**
	   * Gets the index at which the first occurrence of `NaN` is found in `array`.
	   *
	   * @private
	   * @param {Array} array The array to search.
	   * @param {number} fromIndex The index to search from.
	   * @param {boolean} [fromRight] Specify iterating from right to left.
	   * @returns {number} Returns the index of the matched `NaN`, else `-1`.
	   */
	  function indexOfNaN(array, fromIndex, fromRight) {
	    var length = array.length,
	        index = fromIndex + (fromRight ? 0 : -1);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      var other = array[index];
	      if (other !== other) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * Checks if `value` is object-like.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	   */
	  function isObjectLike(value) {
	    return !!value && typeof value == 'object';
	  }
	
	  /**
	   * Used by `trimmedLeftIndex` and `trimmedRightIndex` to determine if a
	   * character code is whitespace.
	   *
	   * @private
	   * @param {number} charCode The character code to inspect.
	   * @returns {boolean} Returns `true` if `charCode` is whitespace, else `false`.
	   */
	  function isSpace(charCode) {
	    return ((charCode <= 160 && (charCode >= 9 && charCode <= 13) || charCode == 32 || charCode == 160) || charCode == 5760 || charCode == 6158 ||
	      (charCode >= 8192 && (charCode <= 8202 || charCode == 8232 || charCode == 8233 || charCode == 8239 || charCode == 8287 || charCode == 12288 || charCode == 65279)));
	  }
	
	  /**
	   * Replaces all `placeholder` elements in `array` with an internal placeholder
	   * and returns an array of their indexes.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {*} placeholder The placeholder to replace.
	   * @returns {Array} Returns the new array of placeholder indexes.
	   */
	  function replaceHolders(array, placeholder) {
	    var index = -1,
	        length = array.length,
	        resIndex = -1,
	        result = [];
	
	    while (++index < length) {
	      if (array[index] === placeholder) {
	        array[index] = PLACEHOLDER;
	        result[++resIndex] = index;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * An implementation of `_.uniq` optimized for sorted arrays without support
	   * for callback shorthands and `this` binding.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {Function} [iteratee] The function invoked per iteration.
	   * @returns {Array} Returns the new duplicate-value-free array.
	   */
	  function sortedUniq(array, iteratee) {
	    var seen,
	        index = -1,
	        length = array.length,
	        resIndex = -1,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index],
	          computed = iteratee ? iteratee(value, index, array) : value;
	
	      if (!index || seen !== computed) {
	        seen = computed;
	        result[++resIndex] = value;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimLeft` to get the index of the first non-whitespace
	   * character of `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the index of the first non-whitespace character.
	   */
	  function trimmedLeftIndex(string) {
	    var index = -1,
	        length = string.length;
	
	    while (++index < length && isSpace(string.charCodeAt(index))) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimRight` to get the index of the last non-whitespace
	   * character of `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the index of the last non-whitespace character.
	   */
	  function trimmedRightIndex(string) {
	    var index = string.length;
	
	    while (index-- && isSpace(string.charCodeAt(index))) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.unescape` to convert HTML entities to characters.
	   *
	   * @private
	   * @param {string} chr The matched character to unescape.
	   * @returns {string} Returns the unescaped character.
	   */
	  function unescapeHtmlChar(chr) {
	    return htmlUnescapes[chr];
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Create a new pristine `lodash` function using the given `context` object.
	   *
	   * @static
	   * @memberOf _
	   * @category Utility
	   * @param {Object} [context=root] The context object.
	   * @returns {Function} Returns a new `lodash` function.
	   * @example
	   *
	   * _.mixin({ 'foo': _.constant('foo') });
	   *
	   * var lodash = _.runInContext();
	   * lodash.mixin({ 'bar': lodash.constant('bar') });
	   *
	   * _.isFunction(_.foo);
	   * // => true
	   * _.isFunction(_.bar);
	   * // => false
	   *
	   * lodash.isFunction(lodash.foo);
	   * // => false
	   * lodash.isFunction(lodash.bar);
	   * // => true
	   *
	   * // using `context` to mock `Date#getTime` use in `_.now`
	   * var mock = _.runInContext({
	   *   'Date': function() {
	   *     return { 'getTime': getTimeMock };
	   *   }
	   * });
	   *
	   * // or creating a suped-up `defer` in Node.js
	   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
	   */
	  function runInContext(context) {
	    // Avoid issues with some ES3 environments that attempt to use values, named
	    // after built-in constructors like `Object`, for the creation of literals.
	    // ES5 clears this up by stating that literals must use built-in constructors.
	    // See https://es5.github.io/#x11.1.5 for more details.
	    context = context ? _.defaults(root.Object(), context, _.pick(root, contextProps)) : root;
	
	    /** Native constructor references. */
	    var Array = context.Array,
	        Date = context.Date,
	        Error = context.Error,
	        Function = context.Function,
	        Math = context.Math,
	        Number = context.Number,
	        Object = context.Object,
	        RegExp = context.RegExp,
	        String = context.String,
	        TypeError = context.TypeError;
	
	    /** Used for native method references. */
	    var arrayProto = Array.prototype,
	        objectProto = Object.prototype,
	        stringProto = String.prototype;
	
	    /** Used to detect DOM support. */
	    var document = (document = context.window) ? document.document : null;
	
	    /** Used to resolve the decompiled source of functions. */
	    var fnToString = Function.prototype.toString;
	
	    /** Used to check objects for own properties. */
	    var hasOwnProperty = objectProto.hasOwnProperty;
	
	    /** Used to generate unique IDs. */
	    var idCounter = 0;
	
	    /**
	     * Used to resolve the [`toStringTag`](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-object.prototype.tostring)
	     * of values.
	     */
	    var objToString = objectProto.toString;
	
	    /** Used to restore the original `_` reference in `_.noConflict`. */
	    var oldDash = context._;
	
	    /** Used to detect if a method is native. */
	    var reIsNative = RegExp('^' +
	      escapeRegExp(fnToString.call(hasOwnProperty))
	      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	    );
	
	    /** Native method references. */
	    var ArrayBuffer = getNative(context, 'ArrayBuffer'),
	        bufferSlice = getNative(ArrayBuffer && new ArrayBuffer(0), 'slice'),
	        ceil = Math.ceil,
	        clearTimeout = context.clearTimeout,
	        floor = Math.floor,
	        getPrototypeOf = getNative(Object, 'getPrototypeOf'),
	        parseFloat = context.parseFloat,
	        push = arrayProto.push,
	        Set = getNative(context, 'Set'),
	        setTimeout = context.setTimeout,
	        splice = arrayProto.splice,
	        Uint8Array = getNative(context, 'Uint8Array'),
	        WeakMap = getNative(context, 'WeakMap');
	
	    /** Used to clone array buffers. */
	    var Float64Array = (function() {
	      // Safari 5 errors when using an array buffer to initialize a typed array
	      // where the array buffer's `byteLength` is not a multiple of the typed
	      // array's `BYTES_PER_ELEMENT`.
	      try {
	        var func = getNative(context, 'Float64Array'),
	            result = new func(new ArrayBuffer(10), 0, 1) && func;
	      } catch(e) {}
	      return result || null;
	    }());
	
	    /* Native method references for those with the same name as other `lodash` methods. */
	    var nativeCreate = getNative(Object, 'create'),
	        nativeIsArray = getNative(Array, 'isArray'),
	        nativeIsFinite = context.isFinite,
	        nativeKeys = getNative(Object, 'keys'),
	        nativeMax = Math.max,
	        nativeMin = Math.min,
	        nativeNow = getNative(Date, 'now'),
	        nativeNumIsFinite = getNative(Number, 'isFinite'),
	        nativeParseInt = context.parseInt,
	        nativeRandom = Math.random;
	
	    /** Used as references for `-Infinity` and `Infinity`. */
	    var NEGATIVE_INFINITY = Number.NEGATIVE_INFINITY,
	        POSITIVE_INFINITY = Number.POSITIVE_INFINITY;
	
	    /** Used as references for the maximum length and index of an array. */
	    var MAX_ARRAY_LENGTH = 4294967295,
	        MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
	        HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
	
	    /** Used as the size, in bytes, of each `Float64Array` element. */
	    var FLOAT64_BYTES_PER_ELEMENT = Float64Array ? Float64Array.BYTES_PER_ELEMENT : 0;
	
	    /**
	     * Used as the [maximum length](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-number.max_safe_integer)
	     * of an array-like value.
	     */
	    var MAX_SAFE_INTEGER = 9007199254740991;
	
	    /** Used to store function metadata. */
	    var metaMap = WeakMap && new WeakMap;
	
	    /** Used to lookup unminified function names. */
	    var realNames = {};
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` object which wraps `value` to enable implicit chaining.
	     * Methods that operate on and return arrays, collections, and functions can
	     * be chained together. Methods that return a boolean or single value will
	     * automatically end the chain returning the unwrapped value. Explicit chaining
	     * may be enabled using `_.chain`. The execution of chained methods is lazy,
	     * that is, execution is deferred until `_#value` is implicitly or explicitly
	     * called.
	     *
	     * Lazy evaluation allows several methods to support shortcut fusion. Shortcut
	     * fusion is an optimization that merges iteratees to avoid creating intermediate
	     * arrays and reduce the number of iteratee executions.
	     *
	     * Chaining is supported in custom builds as long as the `_#value` method is
	     * directly or indirectly included in the build.
	     *
	     * In addition to lodash methods, wrappers have `Array` and `String` methods.
	     *
	     * The wrapper `Array` methods are:
	     * `concat`, `join`, `pop`, `push`, `reverse`, `shift`, `slice`, `sort`,
	     * `splice`, and `unshift`
	     *
	     * The wrapper `String` methods are:
	     * `replace` and `split`
	     *
	     * The wrapper methods that support shortcut fusion are:
	     * `compact`, `drop`, `dropRight`, `dropRightWhile`, `dropWhile`, `filter`,
	     * `first`, `initial`, `last`, `map`, `pluck`, `reject`, `rest`, `reverse`,
	     * `slice`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, `toArray`,
	     * and `where`
	     *
	     * The chainable wrapper methods are:
	     * `after`, `ary`, `assign`, `at`, `before`, `bind`, `bindAll`, `bindKey`,
	     * `callback`, `chain`, `chunk`, `commit`, `compact`, `concat`, `constant`,
	     * `countBy`, `create`, `curry`, `debounce`, `defaults`, `defer`, `delay`,
	     * `difference`, `drop`, `dropRight`, `dropRightWhile`, `dropWhile`, `fill`,
	     * `filter`, `flatten`, `flattenDeep`, `flow`, `flowRight`, `forEach`,
	     * `forEachRight`, `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `functions`,
	     * `groupBy`, `indexBy`, `initial`, `intersection`, `invert`, `invoke`, `keys`,
	     * `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
	     * `memoize`, `merge`, `method`, `methodOf`, `mixin`, `negate`, `omit`, `once`,
	     * `pairs`, `partial`, `partialRight`, `partition`, `pick`, `plant`, `pluck`,
	     * `property`, `propertyOf`, `pull`, `pullAt`, `push`, `range`, `rearg`,
	     * `reject`, `remove`, `rest`, `restParam`, `reverse`, `set`, `shuffle`,
	     * `slice`, `sort`, `sortBy`, `sortByAll`, `sortByOrder`, `splice`, `spread`,
	     * `take`, `takeRight`, `takeRightWhile`, `takeWhile`, `tap`, `throttle`,
	     * `thru`, `times`, `toArray`, `toPlainObject`, `transform`, `union`, `uniq`,
	     * `unshift`, `unzip`, `unzipWith`, `values`, `valuesIn`, `where`, `without`,
	     * `wrap`, `xor`, `zip`, `zipObject`, `zipWith`
	     *
	     * The wrapper methods that are **not** chainable by default are:
	     * `add`, `attempt`, `camelCase`, `capitalize`, `clone`, `cloneDeep`, `deburr`,
	     * `endsWith`, `escape`, `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`,
	     * `findLast`, `findLastIndex`, `findLastKey`, `findWhere`, `first`, `get`,
	     * `gt`, `gte`, `has`, `identity`, `includes`, `indexOf`, `inRange`, `isArguments`,
	     * `isArray`, `isBoolean`, `isDate`, `isElement`, `isEmpty`, `isEqual`, `isError`,
	     * `isFinite` `isFunction`, `isMatch`, `isNative`, `isNaN`, `isNull`, `isNumber`,
	     * `isObject`, `isPlainObject`, `isRegExp`, `isString`, `isUndefined`,
	     * `isTypedArray`, `join`, `kebabCase`, `last`, `lastIndexOf`, `lt`, `lte`,
	     * `max`, `min`, `noConflict`, `noop`, `now`, `pad`, `padLeft`, `padRight`,
	     * `parseInt`, `pop`, `random`, `reduce`, `reduceRight`, `repeat`, `result`,
	     * `runInContext`, `shift`, `size`, `snakeCase`, `some`, `sortedIndex`,
	     * `sortedLastIndex`, `startCase`, `startsWith`, `sum`, `template`, `trim`,
	     * `trimLeft`, `trimRight`, `trunc`, `unescape`, `uniqueId`, `value`, and `words`
	     *
	     * The wrapper method `sample` will return a wrapped value when `n` is provided,
	     * otherwise an unwrapped value is returned.
	     *
	     * @name _
	     * @constructor
	     * @category Chain
	     * @param {*} value The value to wrap in a `lodash` instance.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var wrapped = _([1, 2, 3]);
	     *
	     * // returns an unwrapped value
	     * wrapped.reduce(function(total, n) {
	     *   return total + n;
	     * });
	     * // => 6
	     *
	     * // returns a wrapped value
	     * var squares = wrapped.map(function(n) {
	     *   return n * n;
	     * });
	     *
	     * _.isArray(squares);
	     * // => false
	     *
	     * _.isArray(squares.value());
	     * // => true
	     */
	    function lodash(value) {
	      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
	        if (value instanceof LodashWrapper) {
	          return value;
	        }
	        if (hasOwnProperty.call(value, '__chain__') && hasOwnProperty.call(value, '__wrapped__')) {
	          return wrapperClone(value);
	        }
	      }
	      return new LodashWrapper(value);
	    }
	
	    /**
	     * The function whose prototype all chaining wrappers inherit from.
	     *
	     * @private
	     */
	    function baseLodash() {
	      // No operation performed.
	    }
	
	    /**
	     * The base constructor for creating `lodash` wrapper objects.
	     *
	     * @private
	     * @param {*} value The value to wrap.
	     * @param {boolean} [chainAll] Enable chaining for all wrapper methods.
	     * @param {Array} [actions=[]] Actions to peform to resolve the unwrapped value.
	     */
	    function LodashWrapper(value, chainAll, actions) {
	      this.__wrapped__ = value;
	      this.__actions__ = actions || [];
	      this.__chain__ = !!chainAll;
	    }
	
	    /**
	     * An object environment feature flags.
	     *
	     * @static
	     * @memberOf _
	     * @type Object
	     */
	    var support = lodash.support = {};
	
	    (function(x) {
	      var Ctor = function() { this.x = x; },
	          object = { '0': x, 'length': x },
	          props = [];
	
	      Ctor.prototype = { 'valueOf': x, 'y': x };
	      for (var key in new Ctor) { props.push(key); }
	
	      /**
	       * Detect if the DOM is supported.
	       *
	       * @memberOf _.support
	       * @type boolean
	       */
	      try {
	        support.dom = document.createDocumentFragment().nodeType === 11;
	      } catch(e) {
	        support.dom = false;
	      }
	    }(1, 0));
	
	    /**
	     * By default, the template delimiters used by lodash are like those in
	     * embedded Ruby (ERB). Change the following template settings to use
	     * alternative delimiters.
	     *
	     * @static
	     * @memberOf _
	     * @type Object
	     */
	    lodash.templateSettings = {
	
	      /**
	       * Used to detect `data` property values to be HTML-escaped.
	       *
	       * @memberOf _.templateSettings
	       * @type RegExp
	       */
	      'escape': reEscape,
	
	      /**
	       * Used to detect code to be evaluated.
	       *
	       * @memberOf _.templateSettings
	       * @type RegExp
	       */
	      'evaluate': reEvaluate,
	
	      /**
	       * Used to detect `data` property values to inject.
	       *
	       * @memberOf _.templateSettings
	       * @type RegExp
	       */
	      'interpolate': reInterpolate,
	
	      /**
	       * Used to reference the data object in the template text.
	       *
	       * @memberOf _.templateSettings
	       * @type string
	       */
	      'variable': '',
	
	      /**
	       * Used to import variables into the compiled template.
	       *
	       * @memberOf _.templateSettings
	       * @type Object
	       */
	      'imports': {
	
	        /**
	         * A reference to the `lodash` function.
	         *
	         * @memberOf _.templateSettings.imports
	         * @type Function
	         */
	        '_': lodash
	      }
	    };
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
	     *
	     * @private
	     * @param {*} value The value to wrap.
	     */
	    function LazyWrapper(value) {
	      this.__wrapped__ = value;
	      this.__actions__ = null;
	      this.__dir__ = 1;
	      this.__dropCount__ = 0;
	      this.__filtered__ = false;
	      this.__iteratees__ = null;
	      this.__takeCount__ = POSITIVE_INFINITY;
	      this.__views__ = null;
	    }
	
	    /**
	     * Creates a clone of the lazy wrapper object.
	     *
	     * @private
	     * @name clone
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the cloned `LazyWrapper` object.
	     */
	    function lazyClone() {
	      var actions = this.__actions__,
	          iteratees = this.__iteratees__,
	          views = this.__views__,
	          result = new LazyWrapper(this.__wrapped__);
	
	      result.__actions__ = actions ? arrayCopy(actions) : null;
	      result.__dir__ = this.__dir__;
	      result.__filtered__ = this.__filtered__;
	      result.__iteratees__ = iteratees ? arrayCopy(iteratees) : null;
	      result.__takeCount__ = this.__takeCount__;
	      result.__views__ = views ? arrayCopy(views) : null;
	      return result;
	    }
	
	    /**
	     * Reverses the direction of lazy iteration.
	     *
	     * @private
	     * @name reverse
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the new reversed `LazyWrapper` object.
	     */
	    function lazyReverse() {
	      if (this.__filtered__) {
	        var result = new LazyWrapper(this);
	        result.__dir__ = -1;
	        result.__filtered__ = true;
	      } else {
	        result = this.clone();
	        result.__dir__ *= -1;
	      }
	      return result;
	    }
	
	    /**
	     * Extracts the unwrapped value from its lazy wrapper.
	     *
	     * @private
	     * @name value
	     * @memberOf LazyWrapper
	     * @returns {*} Returns the unwrapped value.
	     */
	    function lazyValue() {
	      var array = this.__wrapped__.value();
	      if (!isArray(array)) {
	        return baseWrapperValue(array, this.__actions__);
	      }
	      var dir = this.__dir__,
	          isRight = dir < 0,
	          view = getView(0, array.length, this.__views__),
	          start = view.start,
	          end = view.end,
	          length = end - start,
	          index = isRight ? end : (start - 1),
	          takeCount = nativeMin(length, this.__takeCount__),
	          iteratees = this.__iteratees__,
	          iterLength = iteratees ? iteratees.length : 0,
	          resIndex = 0,
	          result = [];
	
	      outer:
	      while (length-- && resIndex < takeCount) {
	        index += dir;
	
	        var iterIndex = -1,
	            value = array[index];
	
	        while (++iterIndex < iterLength) {
	          var data = iteratees[iterIndex],
	              iteratee = data.iteratee,
	              type = data.type;
	
	          if (type == LAZY_DROP_WHILE_FLAG) {
	            if (data.done && (isRight ? (index > data.index) : (index < data.index))) {
	              data.count = 0;
	              data.done = false;
	            }
	            data.index = index;
	            if (!data.done) {
	              var limit = data.limit;
	              if (!(data.done = limit > -1 ? (data.count++ >= limit) : !iteratee(value))) {
	                continue outer;
	              }
	            }
	          } else {
	            var computed = iteratee(value);
	            if (type == LAZY_MAP_FLAG) {
	              value = computed;
	            } else if (!computed) {
	              if (type == LAZY_FILTER_FLAG) {
	                continue outer;
	              } else {
	                break outer;
	              }
	            }
	          }
	        }
	        result[resIndex++] = value;
	      }
	      return result;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a cache object to store key/value pairs.
	     *
	     * @private
	     * @static
	     * @name Cache
	     * @memberOf _.memoize
	     */
	    function MapCache() {
	      this.__data__ = {};
	    }
	
	    /**
	     * Removes `key` and its value from the cache.
	     *
	     * @private
	     * @name delete
	     * @memberOf _.memoize.Cache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed successfully, else `false`.
	     */
	    function mapDelete(key) {
	      return this.has(key) && delete this.__data__[key];
	    }
	
	    /**
	     * Gets the cached value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf _.memoize.Cache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the cached value.
	     */
	    function mapGet(key) {
	      return key == '__proto__' ? undefined : this.__data__[key];
	    }
	
	    /**
	     * Checks if a cached value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf _.memoize.Cache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function mapHas(key) {
	      return key != '__proto__' && hasOwnProperty.call(this.__data__, key);
	    }
	
	    /**
	     * Sets `value` to `key` of the cache.
	     *
	     * @private
	     * @name set
	     * @memberOf _.memoize.Cache
	     * @param {string} key The key of the value to cache.
	     * @param {*} value The value to cache.
	     * @returns {Object} Returns the cache object.
	     */
	    function mapSet(key, value) {
	      if (key != '__proto__') {
	        this.__data__[key] = value;
	      }
	      return this;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     *
	     * Creates a cache object to store unique values.
	     *
	     * @private
	     * @param {Array} [values] The values to cache.
	     */
	    function SetCache(values) {
	      var length = values ? values.length : 0;
	
	      this.data = { 'hash': nativeCreate(null), 'set': new Set };
	      while (length--) {
	        this.push(values[length]);
	      }
	    }
	
	    /**
	     * Checks if `value` is in `cache` mimicking the return signature of
	     * `_.indexOf` by returning `0` if the value is found, else `-1`.
	     *
	     * @private
	     * @param {Object} cache The cache to search.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns `0` if `value` is found, else `-1`.
	     */
	    function cacheIndexOf(cache, value) {
	      var data = cache.data,
	          result = (typeof value == 'string' || isObject(value)) ? data.set.has(value) : data.hash[value];
	
	      return result ? 0 : -1;
	    }
	
	    /**
	     * Adds `value` to the cache.
	     *
	     * @private
	     * @name push
	     * @memberOf SetCache
	     * @param {*} value The value to cache.
	     */
	    function cachePush(value) {
	      var data = this.data;
	      if (typeof value == 'string' || isObject(value)) {
	        data.set.add(value);
	      } else {
	        data.hash[value] = true;
	      }
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Copies the values of `source` to `array`.
	     *
	     * @private
	     * @param {Array} source The array to copy values from.
	     * @param {Array} [array=[]] The array to copy values to.
	     * @returns {Array} Returns `array`.
	     */
	    function arrayCopy(source, array) {
	      var index = -1,
	          length = source.length;
	
	      array || (array = Array(length));
	      while (++index < length) {
	        array[index] = source[index];
	      }
	      return array;
	    }
	
	    /**
	     * A specialized version of `_.forEach` for arrays without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns `array`.
	     */
	    function arrayEach(array, iteratee) {
	      var index = -1,
	          length = array.length;
	
	      while (++index < length) {
	        if (iteratee(array[index], index, array) === false) {
	          break;
	        }
	      }
	      return array;
	    }
	
	    /**
	     * A specialized version of `_.forEachRight` for arrays without support for
	     * callback shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns `array`.
	     */
	    function arrayEachRight(array, iteratee) {
	      var length = array.length;
	
	      while (length--) {
	        if (iteratee(array[length], length, array) === false) {
	          break;
	        }
	      }
	      return array;
	    }
	
	    /**
	     * A specialized version of `_.every` for arrays without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`.
	     */
	    function arrayEvery(array, predicate) {
	      var index = -1,
	          length = array.length;
	
	      while (++index < length) {
	        if (!predicate(array[index], index, array)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * A specialized version of `baseExtremum` for arrays which invokes `iteratee`
	     * with one argument: (value).
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} comparator The function used to compare values.
	     * @param {*} exValue The initial extremum value.
	     * @returns {*} Returns the extremum value.
	     */
	    function arrayExtremum(array, iteratee, comparator, exValue) {
	      var index = -1,
	          length = array.length,
	          computed = exValue,
	          result = computed;
	
	      while (++index < length) {
	        var value = array[index],
	            current = +iteratee(value);
	
	        if (comparator(current, computed)) {
	          computed = current;
	          result = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `_.filter` for arrays without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     */
	    function arrayFilter(array, predicate) {
	      var index = -1,
	          length = array.length,
	          resIndex = -1,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index];
	        if (predicate(value, index, array)) {
	          result[++resIndex] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `_.map` for arrays without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     */
	    function arrayMap(array, iteratee) {
	      var index = -1,
	          length = array.length,
	          result = Array(length);
	
	      while (++index < length) {
	        result[index] = iteratee(array[index], index, array);
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `_.reduce` for arrays without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @param {boolean} [initFromArray] Specify using the first element of `array`
	     *  as the initial value.
	     * @returns {*} Returns the accumulated value.
	     */
	    function arrayReduce(array, iteratee, accumulator, initFromArray) {
	      var index = -1,
	          length = array.length;
	
	      if (initFromArray && length) {
	        accumulator = array[++index];
	      }
	      while (++index < length) {
	        accumulator = iteratee(accumulator, array[index], index, array);
	      }
	      return accumulator;
	    }
	
	    /**
	     * A specialized version of `_.reduceRight` for arrays without support for
	     * callback shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @param {boolean} [initFromArray] Specify using the last element of `array`
	     *  as the initial value.
	     * @returns {*} Returns the accumulated value.
	     */
	    function arrayReduceRight(array, iteratee, accumulator, initFromArray) {
	      var length = array.length;
	      if (initFromArray && length) {
	        accumulator = array[--length];
	      }
	      while (length--) {
	        accumulator = iteratee(accumulator, array[length], length, array);
	      }
	      return accumulator;
	    }
	
	    /**
	     * A specialized version of `_.some` for arrays without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     */
	    function arraySome(array, predicate) {
	      var index = -1,
	          length = array.length;
	
	      while (++index < length) {
	        if (predicate(array[index], index, array)) {
	          return true;
	        }
	      }
	      return false;
	    }
	
	    /**
	     * A specialized version of `_.sum` for arrays without support for iteratees.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the sum.
	     */
	    function arraySum(array) {
	      var length = array.length,
	          result = 0;
	
	      while (length--) {
	        result += +array[length] || 0;
	      }
	      return result;
	    }
	
	    /**
	     * Used by `_.defaults` to customize its `_.assign` use.
	     *
	     * @private
	     * @param {*} objectValue The destination object property value.
	     * @param {*} sourceValue The source object property value.
	     * @returns {*} Returns the value to assign to the destination object.
	     */
	    function assignDefaults(objectValue, sourceValue) {
	      return objectValue === undefined ? sourceValue : objectValue;
	    }
	
	    /**
	     * Used by `_.template` to customize its `_.assign` use.
	     *
	     * **Note:** This function is like `assignDefaults` except that it ignores
	     * inherited property values when checking if a property is `undefined`.
	     *
	     * @private
	     * @param {*} objectValue The destination object property value.
	     * @param {*} sourceValue The source object property value.
	     * @param {string} key The key associated with the object and source values.
	     * @param {Object} object The destination object.
	     * @returns {*} Returns the value to assign to the destination object.
	     */
	    function assignOwnDefaults(objectValue, sourceValue, key, object) {
	      return (objectValue === undefined || !hasOwnProperty.call(object, key))
	        ? sourceValue
	        : objectValue;
	    }
	
	    /**
	     * A specialized version of `_.assign` for customizing assigned values without
	     * support for argument juggling, multiple sources, and `this` binding `customizer`
	     * functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {Function} customizer The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     */
	    function assignWith(object, source, customizer) {
	      var index = -1,
	          props = keys(source),
	          length = props.length;
	
	      while (++index < length) {
	        var key = props[index],
	            value = object[key],
	            result = customizer(value, source[key], key, object, source);
	
	        if ((result === result ? (result !== value) : (value === value)) ||
	            (value === undefined && !(key in object))) {
	          object[key] = result;
	        }
	      }
	      return object;
	    }
	
	    /**
	     * The base implementation of `_.assign` without support for argument juggling,
	     * multiple sources, and `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssign(object, source) {
	      return source == null
	        ? object
	        : baseCopy(source, keys(source), object);
	    }
	
	    /**
	     * The base implementation of `_.at` without support for string collections
	     * and individual key arguments.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {number[]|string[]} props The property names or indexes of elements to pick.
	     * @returns {Array} Returns the new array of picked elements.
	     */
	    function baseAt(collection, props) {
	      var index = -1,
	          isNil = collection == null,
	          isArr = !isNil && isArrayLike(collection),
	          length = isArr ? collection.length : 0,
	          propsLength = props.length,
	          result = Array(propsLength);
	
	      while(++index < propsLength) {
	        var key = props[index];
	        if (isArr) {
	          result[index] = isIndex(key, length) ? collection[key] : undefined;
	        } else {
	          result[index] = isNil ? undefined : collection[key];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Copies properties of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy properties from.
	     * @param {Array} props The property names to copy.
	     * @param {Object} [object={}] The object to copy properties to.
	     * @returns {Object} Returns `object`.
	     */
	    function baseCopy(source, props, object) {
	      object || (object = {});
	
	      var index = -1,
	          length = props.length;
	
	      while (++index < length) {
	        var key = props[index];
	        object[key] = source[key];
	      }
	      return object;
	    }
	
	    /**
	     * The base implementation of `_.callback` which supports specifying the
	     * number of arguments to provide to `func`.
	     *
	     * @private
	     * @param {*} [func=_.identity] The value to convert to a callback.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {number} [argCount] The number of arguments to provide to `func`.
	     * @returns {Function} Returns the callback.
	     */
	    function baseCallback(func, thisArg, argCount) {
	      var type = typeof func;
	      if (type == 'function') {
	        return thisArg === undefined
	          ? func
	          : bindCallback(func, thisArg, argCount);
	      }
	      if (func == null) {
	        return identity;
	      }
	      if (type == 'object') {
	        return baseMatches(func);
	      }
	      return thisArg === undefined
	        ? property(func)
	        : baseMatchesProperty(func, thisArg);
	    }
	
	    /**
	     * The base implementation of `_.clone` without support for argument juggling
	     * and `this` binding `customizer` functions.
	     *
	     * @private
	     * @param {*} value The value to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @param {Function} [customizer] The function to customize cloning values.
	     * @param {string} [key] The key of `value`.
	     * @param {Object} [object] The object `value` belongs to.
	     * @param {Array} [stackA=[]] Tracks traversed source objects.
	     * @param {Array} [stackB=[]] Associates clones with source counterparts.
	     * @returns {*} Returns the cloned value.
	     */
	    function baseClone(value, isDeep, customizer, key, object, stackA, stackB) {
	      var result;
	      if (customizer) {
	        result = object ? customizer(value, key, object) : customizer(value);
	      }
	      if (result !== undefined) {
	        return result;
	      }
	      if (!isObject(value)) {
	        return value;
	      }
	      var isArr = isArray(value);
	      if (isArr) {
	        result = initCloneArray(value);
	        if (!isDeep) {
	          return arrayCopy(value, result);
	        }
	      } else {
	        var tag = objToString.call(value),
	            isFunc = tag == funcTag;
	
	        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	          result = initCloneObject(isFunc ? {} : value);
	          if (!isDeep) {
	            return baseAssign(result, value);
	          }
	        } else {
	          return cloneableTags[tag]
	            ? initCloneByTag(value, tag, isDeep)
	            : (object ? value : {});
	        }
	      }
	      // Check for circular references and return corresponding clone.
	      stackA || (stackA = []);
	      stackB || (stackB = []);
	
	      var length = stackA.length;
	      while (length--) {
	        if (stackA[length] == value) {
	          return stackB[length];
	        }
	      }
	      // Add the source value to the stack of traversed objects and associate it with its clone.
	      stackA.push(value);
	      stackB.push(result);
	
	      // Recursively populate clone (susceptible to call stack limits).
	      (isArr ? arrayEach : baseForOwn)(value, function(subValue, key) {
	        result[key] = baseClone(subValue, isDeep, customizer, key, value, stackA, stackB);
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.create` without support for assigning
	     * properties to the created object.
	     *
	     * @private
	     * @param {Object} prototype The object to inherit from.
	     * @returns {Object} Returns the new object.
	     */
	    var baseCreate = (function() {
	      function object() {}
	      return function(prototype) {
	        if (isObject(prototype)) {
	          object.prototype = prototype;
	          var result = new object;
	          object.prototype = null;
	        }
	        return result || {};
	      };
	    }());
	
	    /**
	     * The base implementation of `_.delay` and `_.defer` which accepts an index
	     * of where to slice the arguments to provide to `func`.
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {Object} args The arguments provide to `func`.
	     * @returns {number} Returns the timer id.
	     */
	    function baseDelay(func, wait, args) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return setTimeout(function() { func.apply(undefined, args); }, wait);
	    }
	
	    /**
	     * The base implementation of `_.difference` which accepts a single array
	     * of values to exclude.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Array} values The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     */
	    function baseDifference(array, values) {
	      var length = array ? array.length : 0,
	          result = [];
	
	      if (!length) {
	        return result;
	      }
	      var index = -1,
	          indexOf = getIndexOf(),
	          isCommon = indexOf == baseIndexOf,
	          cache = (isCommon && values.length >= 200) ? createCache(values) : null,
	          valuesLength = values.length;
	
	      if (cache) {
	        indexOf = cacheIndexOf;
	        isCommon = false;
	        values = cache;
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index];
	
	        if (isCommon && value === value) {
	          var valuesIndex = valuesLength;
	          while (valuesIndex--) {
	            if (values[valuesIndex] === value) {
	              continue outer;
	            }
	          }
	          result.push(value);
	        }
	        else if (indexOf(values, value, 0) < 0) {
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.forEach` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object|string} Returns `collection`.
	     */
	    var baseEach = createBaseEach(baseForOwn);
	
	    /**
	     * The base implementation of `_.forEachRight` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object|string} Returns `collection`.
	     */
	    var baseEachRight = createBaseEach(baseForOwnRight, true);
	
	    /**
	     * The base implementation of `_.every` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`
	     */
	    function baseEvery(collection, predicate) {
	      var result = true;
	      baseEach(collection, function(value, index, collection) {
	        result = !!predicate(value, index, collection);
	        return result;
	      });
	      return result;
	    }
	
	    /**
	     * Gets the extremum value of `collection` invoking `iteratee` for each value
	     * in `collection` to generate the criterion by which the value is ranked.
	     * The `iteratee` is invoked with three arguments: (value, index|key, collection).
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} comparator The function used to compare values.
	     * @param {*} exValue The initial extremum value.
	     * @returns {*} Returns the extremum value.
	     */
	    function baseExtremum(collection, iteratee, comparator, exValue) {
	      var computed = exValue,
	          result = computed;
	
	      baseEach(collection, function(value, index, collection) {
	        var current = +iteratee(value, index, collection);
	        if (comparator(current, computed) || (current === exValue && current === result)) {
	          computed = current;
	          result = value;
	        }
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.fill` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     */
	    function baseFill(array, value, start, end) {
	      var length = array.length;
	
	      start = start == null ? 0 : (+start || 0);
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = (end === undefined || end > length) ? length : (+end || 0);
	      if (end < 0) {
	        end += length;
	      }
	      length = start > end ? 0 : (end >>> 0);
	      start >>>= 0;
	
	      while (start < length) {
	        array[start++] = value;
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.filter` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     */
	    function baseFilter(collection, predicate) {
	      var result = [];
	      baseEach(collection, function(value, index, collection) {
	        if (predicate(value, index, collection)) {
	          result.push(value);
	        }
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.find`, `_.findLast`, `_.findKey`, and `_.findLastKey`,
	     * without support for callback shorthands and `this` binding, which iterates
	     * over `collection` using the provided `eachFunc`.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to search.
	     * @param {Function} predicate The function invoked per iteration.
	     * @param {Function} eachFunc The function to iterate over `collection`.
	     * @param {boolean} [retKey] Specify returning the key of the found element
	     *  instead of the element itself.
	     * @returns {*} Returns the found element or its key, else `undefined`.
	     */
	    function baseFind(collection, predicate, eachFunc, retKey) {
	      var result;
	      eachFunc(collection, function(value, key, collection) {
	        if (predicate(value, key, collection)) {
	          result = retKey ? key : value;
	          return false;
	        }
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.flatten` with added support for restricting
	     * flattening and specifying the start index.
	     *
	     * @private
	     * @param {Array} array The array to flatten.
	     * @param {boolean} [isDeep] Specify a deep flatten.
	     * @param {boolean} [isStrict] Restrict flattening to arrays-like objects.
	     * @returns {Array} Returns the new flattened array.
	     */
	    function baseFlatten(array, isDeep, isStrict) {
	      var index = -1,
	          length = array.length,
	          resIndex = -1,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index];
	        if (isObjectLike(value) && isArrayLike(value) &&
	            (isStrict || isArray(value) || isArguments(value))) {
	          if (isDeep) {
	            // Recursively flatten arrays (susceptible to call stack limits).
	            value = baseFlatten(value, isDeep, isStrict);
	          }
	          var valIndex = -1,
	              valLength = value.length;
	
	          while (++valIndex < valLength) {
	            result[++resIndex] = value[valIndex];
	          }
	        } else if (!isStrict) {
	          result[++resIndex] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `baseForIn` and `baseForOwn` which iterates
	     * over `object` properties returned by `keysFunc` invoking `iteratee` for
	     * each property. Iteratee functions may exit iteration early by explicitly
	     * returning `false`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseFor = createBaseFor();
	
	    /**
	     * This function is like `baseFor` except that it iterates over properties
	     * in the opposite order.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseForRight = createBaseFor(true);
	
	    /**
	     * The base implementation of `_.forIn` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForIn(object, iteratee) {
	      return baseFor(object, iteratee, keysIn);
	    }
	
	    /**
	     * The base implementation of `_.forOwn` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwn(object, iteratee) {
	      return baseFor(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.forOwnRight` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwnRight(object, iteratee) {
	      return baseForRight(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.functions` which creates an array of
	     * `object` function property names filtered from those provided.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Array} props The property names to filter.
	     * @returns {Array} Returns the new array of filtered property names.
	     */
	    function baseFunctions(object, props) {
	      var index = -1,
	          length = props.length,
	          resIndex = -1,
	          result = [];
	
	      while (++index < length) {
	        var key = props[index];
	        if (isFunction(object[key])) {
	          result[++resIndex] = key;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `get` without support for string paths
	     * and default values.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array} path The path of the property to get.
	     * @param {string} [pathKey] The key representation of path.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseGet(object, path, pathKey) {
	      if (object == null) {
	        return;
	      }
	      if (pathKey !== undefined && pathKey in toObject(object)) {
	        path = [pathKey];
	      }
	      var index = 0,
	          length = path.length;
	
	      while (object != null && index < length) {
	        object = object[path[index++]];
	      }
	      return (index && index == length) ? object : undefined;
	    }
	
	    /**
	     * The base implementation of `_.isEqual` without support for `this` binding
	     * `customizer` functions.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {Function} [customizer] The function to customize comparing values.
	     * @param {boolean} [isLoose] Specify performing partial comparisons.
	     * @param {Array} [stackA] Tracks traversed `value` objects.
	     * @param {Array} [stackB] Tracks traversed `other` objects.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     */
	    function baseIsEqual(value, other, customizer, isLoose, stackA, stackB) {
	      if (value === other) {
	        return true;
	      }
	      if (value == null || other == null || (!isObject(value) && !isObjectLike(other))) {
	        return value !== value && other !== other;
	      }
	      return baseIsEqualDeep(value, other, baseIsEqual, customizer, isLoose, stackA, stackB);
	    }
	
	    /**
	     * A specialized version of `baseIsEqual` for arrays and objects which performs
	     * deep comparisons and tracks traversed objects enabling objects with circular
	     * references to be compared.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Function} [customizer] The function to customize comparing objects.
	     * @param {boolean} [isLoose] Specify performing partial comparisons.
	     * @param {Array} [stackA=[]] Tracks traversed `value` objects.
	     * @param {Array} [stackB=[]] Tracks traversed `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function baseIsEqualDeep(object, other, equalFunc, customizer, isLoose, stackA, stackB) {
	      var objIsArr = isArray(object),
	          othIsArr = isArray(other),
	          objTag = arrayTag,
	          othTag = arrayTag;
	
	      if (!objIsArr) {
	        objTag = objToString.call(object);
	        if (objTag == argsTag) {
	          objTag = objectTag;
	        } else if (objTag != objectTag) {
	          objIsArr = isTypedArray(object);
	        }
	      }
	      if (!othIsArr) {
	        othTag = objToString.call(other);
	        if (othTag == argsTag) {
	          othTag = objectTag;
	        } else if (othTag != objectTag) {
	          othIsArr = isTypedArray(other);
	        }
	      }
	      var objIsObj = objTag == objectTag,
	          othIsObj = othTag == objectTag,
	          isSameTag = objTag == othTag;
	
	      if (isSameTag && !(objIsArr || objIsObj)) {
	        return equalByTag(object, other, objTag);
	      }
	      if (!isLoose) {
	        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	        if (objIsWrapped || othIsWrapped) {
	          return equalFunc(objIsWrapped ? object.value() : object, othIsWrapped ? other.value() : other, customizer, isLoose, stackA, stackB);
	        }
	      }
	      if (!isSameTag) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      // For more information on detecting circular references see https://es5.github.io/#JO.
	      stackA || (stackA = []);
	      stackB || (stackB = []);
	
	      var length = stackA.length;
	      while (length--) {
	        if (stackA[length] == object) {
	          return stackB[length] == other;
	        }
	      }
	      // Add `object` and `other` to the stack of traversed objects.
	      stackA.push(object);
	      stackB.push(other);
	
	      var result = (objIsArr ? equalArrays : equalObjects)(object, other, equalFunc, customizer, isLoose, stackA, stackB);
	
	      stackA.pop();
	      stackB.pop();
	
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.isMatch` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Array} matchData The propery names, values, and compare flags to match.
	     * @param {Function} [customizer] The function to customize comparing objects.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     */
	    function baseIsMatch(object, matchData, customizer) {
	      var index = matchData.length,
	          length = index,
	          noCustomizer = !customizer;
	
	      if (object == null) {
	        return !length;
	      }
	      object = toObject(object);
	      while (index--) {
	        var data = matchData[index];
	        if ((noCustomizer && data[2])
	              ? data[1] !== object[data[0]]
	              : !(data[0] in object)
	            ) {
	          return false;
	        }
	      }
	      while (++index < length) {
	        data = matchData[index];
	        var key = data[0],
	            objValue = object[key],
	            srcValue = data[1];
	
	        if (noCustomizer && data[2]) {
	          if (objValue === undefined && !(key in object)) {
	            return false;
	          }
	        } else {
	          var result = customizer ? customizer(objValue, srcValue, key) : undefined;
	          if (!(result === undefined ? baseIsEqual(srcValue, objValue, customizer, true) : result)) {
	            return false;
	          }
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.map` without support for callback shorthands
	     * and `this` binding.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     */
	    function baseMap(collection, iteratee) {
	      var index = -1,
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value, key, collection) {
	        result[++index] = iteratee(value, key, collection);
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.matches` which does not clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new function.
	     */
	    function baseMatches(source) {
	      var matchData = getMatchData(source);
	      if (matchData.length == 1 && matchData[0][2]) {
	        var key = matchData[0][0],
	            value = matchData[0][1];
	
	        return function(object) {
	          if (object == null) {
	            return false;
	          }
	          return object[key] === value && (value !== undefined || (key in toObject(object)));
	        };
	      }
	      return function(object) {
	        return baseIsMatch(object, matchData);
	      };
	    }
	
	    /**
	     * The base implementation of `_.matchesProperty` which does not clone `srcValue`.
	     *
	     * @private
	     * @param {string} path The path of the property to get.
	     * @param {*} srcValue The value to compare.
	     * @returns {Function} Returns the new function.
	     */
	    function baseMatchesProperty(path, srcValue) {
	      var isArr = isArray(path),
	          isCommon = isKey(path) && isStrictComparable(srcValue),
	          pathKey = (path + '');
	
	      path = toPath(path);
	      return function(object) {
	        if (object == null) {
	          return false;
	        }
	        var key = pathKey;
	        object = toObject(object);
	        if ((isArr || !isCommon) && !(key in object)) {
	          object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
	          if (object == null) {
	            return false;
	          }
	          key = last(path);
	          object = toObject(object);
	        }
	        return object[key] === srcValue
	          ? (srcValue !== undefined || (key in object))
	          : baseIsEqual(srcValue, object[key], undefined, true);
	      };
	    }
	
	    /**
	     * The base implementation of `_.merge` without support for argument juggling,
	     * multiple sources, and `this` binding `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {Function} [customizer] The function to customize merging properties.
	     * @param {Array} [stackA=[]] Tracks traversed source objects.
	     * @param {Array} [stackB=[]] Associates values with source counterparts.
	     * @returns {Object} Returns `object`.
	     */
	    function baseMerge(object, source, customizer, stackA, stackB) {
	      if (!isObject(object)) {
	        return object;
	      }
	      var isSrcArr = isArrayLike(source) && (isArray(source) || isTypedArray(source)),
	          props = isSrcArr ? null : keys(source);
	
	      arrayEach(props || source, function(srcValue, key) {
	        if (props) {
	          key = srcValue;
	          srcValue = source[key];
	        }
	        if (isObjectLike(srcValue)) {
	          stackA || (stackA = []);
	          stackB || (stackB = []);
	          baseMergeDeep(object, source, key, baseMerge, customizer, stackA, stackB);
	        }
	        else {
	          var value = object[key],
	              result = customizer ? customizer(value, srcValue, key, object, source) : undefined,
	              isCommon = result === undefined;
	
	          if (isCommon) {
	            result = srcValue;
	          }
	          if ((result !== undefined || (isSrcArr && !(key in object))) &&
	              (isCommon || (result === result ? (result !== value) : (value === value)))) {
	            object[key] = result;
	          }
	        }
	      });
	      return object;
	    }
	
	    /**
	     * A specialized version of `baseMerge` for arrays and objects which performs
	     * deep merges and tracks traversed objects enabling objects with circular
	     * references to be merged.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {string} key The key of the value to merge.
	     * @param {Function} mergeFunc The function to merge values.
	     * @param {Function} [customizer] The function to customize merging properties.
	     * @param {Array} [stackA=[]] Tracks traversed source objects.
	     * @param {Array} [stackB=[]] Associates values with source counterparts.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function baseMergeDeep(object, source, key, mergeFunc, customizer, stackA, stackB) {
	      var length = stackA.length,
	          srcValue = source[key];
	
	      while (length--) {
	        if (stackA[length] == srcValue) {
	          object[key] = stackB[length];
	          return;
	        }
	      }
	      var value = object[key],
	          result = customizer ? customizer(value, srcValue, key, object, source) : undefined,
	          isCommon = result === undefined;
	
	      if (isCommon) {
	        result = srcValue;
	        if (isArrayLike(srcValue) && (isArray(srcValue) || isTypedArray(srcValue))) {
	          result = isArray(value)
	            ? value
	            : (isArrayLike(value) ? arrayCopy(value) : []);
	        }
	        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	          result = isArguments(value)
	            ? toPlainObject(value)
	            : (isPlainObject(value) ? value : {});
	        }
	        else {
	          isCommon = false;
	        }
	      }
	      // Add the source value to the stack of traversed objects and associate
	      // it with its merged value.
	      stackA.push(srcValue);
	      stackB.push(result);
	
	      if (isCommon) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        object[key] = mergeFunc(result, srcValue, customizer, stackA, stackB);
	      } else if (result === result ? (result !== value) : (value === value)) {
	        object[key] = result;
	      }
	    }
	
	    /**
	     * The base implementation of `_.property` without support for deep paths.
	     *
	     * @private
	     * @param {string} key The key of the property to get.
	     * @returns {Function} Returns the new function.
	     */
	    function baseProperty(key) {
	      return function(object) {
	        return object == null ? undefined : object[key];
	      };
	    }
	
	    /**
	     * A specialized version of `baseProperty` which supports deep paths.
	     *
	     * @private
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new function.
	     */
	    function basePropertyDeep(path) {
	      var pathKey = (path + '');
	      path = toPath(path);
	      return function(object) {
	        return baseGet(object, path, pathKey);
	      };
	    }
	
	    /**
	     * The base implementation of `_.pullAt` without support for individual
	     * index arguments and capturing the removed elements.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {number[]} indexes The indexes of elements to remove.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAt(array, indexes) {
	      var length = array ? indexes.length : 0;
	      while (length--) {
	        var index = indexes[length];
	        if (index != previous && isIndex(index)) {
	          var previous = index;
	          splice.call(array, index, 1);
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.random` without support for argument juggling
	     * and returning floating-point numbers.
	     *
	     * @private
	     * @param {number} min The minimum possible value.
	     * @param {number} max The maximum possible value.
	     * @returns {number} Returns the random number.
	     */
	    function baseRandom(min, max) {
	      return min + floor(nativeRandom() * (max - min + 1));
	    }
	
	    /**
	     * The base implementation of `_.reduce` and `_.reduceRight` without support
	     * for callback shorthands and `this` binding, which iterates over `collection`
	     * using the provided `eachFunc`.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {*} accumulator The initial value.
	     * @param {boolean} initFromCollection Specify using the first or last element
	     *  of `collection` as the initial value.
	     * @param {Function} eachFunc The function to iterate over `collection`.
	     * @returns {*} Returns the accumulated value.
	     */
	    function baseReduce(collection, iteratee, accumulator, initFromCollection, eachFunc) {
	      eachFunc(collection, function(value, index, collection) {
	        accumulator = initFromCollection
	          ? (initFromCollection = false, value)
	          : iteratee(accumulator, value, index, collection);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `setData` without support for hot loop detection.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetData = !metaMap ? identity : function(func, data) {
	      metaMap.set(func, data);
	      return func;
	    };
	
	    /**
	     * The base implementation of `_.slice` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseSlice(array, start, end) {
	      var index = -1,
	          length = array.length;
	
	      start = start == null ? 0 : (+start || 0);
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = (end === undefined || end > length) ? length : (+end || 0);
	      if (end < 0) {
	        end += length;
	      }
	      length = start > end ? 0 : ((end - start) >>> 0);
	      start >>>= 0;
	
	      var result = Array(length);
	      while (++index < length) {
	        result[index] = array[index + start];
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.some` without support for callback shorthands
	     * and `this` binding.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     */
	    function baseSome(collection, predicate) {
	      var result;
	
	      baseEach(collection, function(value, index, collection) {
	        result = predicate(value, index, collection);
	        return !result;
	      });
	      return !!result;
	    }
	
	    /**
	     * The base implementation of `_.sortBy` which uses `comparer` to define
	     * the sort order of `array` and replaces criteria objects with their
	     * corresponding values.
	     *
	     * @private
	     * @param {Array} array The array to sort.
	     * @param {Function} comparer The function to define sort order.
	     * @returns {Array} Returns `array`.
	     */
	    function baseSortBy(array, comparer) {
	      var length = array.length;
	
	      array.sort(comparer);
	      while (length--) {
	        array[length] = array[length].value;
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.sortByOrder` without param guards.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	     * @param {boolean[]} orders The sort orders of `iteratees`.
	     * @returns {Array} Returns the new sorted array.
	     */
	    function baseSortByOrder(collection, iteratees, orders) {
	      var callback = getCallback(),
	          index = -1;
	
	      iteratees = arrayMap(iteratees, function(iteratee) { return callback(iteratee); });
	
	      var result = baseMap(collection, function(value) {
	        var criteria = arrayMap(iteratees, function(iteratee) { return iteratee(value); });
	        return { 'criteria': criteria, 'index': ++index, 'value': value };
	      });
	
	      return baseSortBy(result, function(object, other) {
	        return compareMultiple(object, other, orders);
	      });
	    }
	
	    /**
	     * The base implementation of `_.sum` without support for callback shorthands
	     * and `this` binding.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {number} Returns the sum.
	     */
	    function baseSum(collection, iteratee) {
	      var result = 0;
	      baseEach(collection, function(value, index, collection) {
	        result += +iteratee(value, index, collection) || 0;
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.uniq` without support for callback shorthands
	     * and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The function invoked per iteration.
	     * @returns {Array} Returns the new duplicate-value-free array.
	     */
	    function baseUniq(array, iteratee) {
	      var index = -1,
	          indexOf = getIndexOf(),
	          length = array.length,
	          isCommon = indexOf == baseIndexOf,
	          isLarge = isCommon && length >= 200,
	          seen = isLarge ? createCache() : null,
	          result = [];
	
	      if (seen) {
	        indexOf = cacheIndexOf;
	        isCommon = false;
	      } else {
	        isLarge = false;
	        seen = iteratee ? [] : result;
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value, index, array) : value;
	
	        if (isCommon && value === value) {
	          var seenIndex = seen.length;
	          while (seenIndex--) {
	            if (seen[seenIndex] === computed) {
	              continue outer;
	            }
	          }
	          if (iteratee) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	        else if (indexOf(seen, computed, 0) < 0) {
	          if (iteratee || isLarge) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.values` and `_.valuesIn` which creates an
	     * array of `object` property values corresponding to the property names
	     * of `props`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array} props The property names to get values for.
	     * @returns {Object} Returns the array of property values.
	     */
	    function baseValues(object, props) {
	      var index = -1,
	          length = props.length,
	          result = Array(length);
	
	      while (++index < length) {
	        result[index] = object[props[index]];
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.dropRightWhile`, `_.dropWhile`, `_.takeRightWhile`,
	     * and `_.takeWhile` without support for callback shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {Function} predicate The function invoked per iteration.
	     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseWhile(array, predicate, isDrop, fromRight) {
	      var length = array.length,
	          index = fromRight ? length : -1;
	
	      while ((fromRight ? index-- : ++index < length) && predicate(array[index], index, array)) {}
	      return isDrop
	        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
	        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
	    }
	
	    /**
	     * The base implementation of `wrapperValue` which returns the result of
	     * performing a sequence of actions on the unwrapped `value`, where each
	     * successive action is supplied the return value of the previous.
	     *
	     * @private
	     * @param {*} value The unwrapped value.
	     * @param {Array} actions Actions to peform to resolve the unwrapped value.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseWrapperValue(value, actions) {
	      var result = value;
	      if (result instanceof LazyWrapper) {
	        result = result.value();
	      }
	      var index = -1,
	          length = actions.length;
	
	      while (++index < length) {
	        var args = [result],
	            action = actions[index];
	
	        push.apply(args, action.args);
	        result = action.func.apply(action.thisArg, args);
	      }
	      return result;
	    }
	
	    /**
	     * Performs a binary search of `array` to determine the index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function binaryIndex(array, value, retHighest) {
	      var low = 0,
	          high = array ? array.length : low;
	
	      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
	        while (low < high) {
	          var mid = (low + high) >>> 1,
	              computed = array[mid];
	
	          if ((retHighest ? (computed <= value) : (computed < value)) && computed !== null) {
	            low = mid + 1;
	          } else {
	            high = mid;
	          }
	        }
	        return high;
	      }
	      return binaryIndexBy(array, value, identity, retHighest);
	    }
	
	    /**
	     * This function is like `binaryIndex` except that it invokes `iteratee` for
	     * `value` and each element of `array` to compute their sort ranking. The
	     * iteratee is invoked with one argument; (value).
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function binaryIndexBy(array, value, iteratee, retHighest) {
	      value = iteratee(value);
	
	      var low = 0,
	          high = array ? array.length : 0,
	          valIsNaN = value !== value,
	          valIsNull = value === null,
	          valIsUndef = value === undefined;
	
	      while (low < high) {
	        var mid = floor((low + high) / 2),
	            computed = iteratee(array[mid]),
	            isDef = computed !== undefined,
	            isReflexive = computed === computed;
	
	        if (valIsNaN) {
	          var setLow = isReflexive || retHighest;
	        } else if (valIsNull) {
	          setLow = isReflexive && isDef && (retHighest || computed != null);
	        } else if (valIsUndef) {
	          setLow = isReflexive && (retHighest || isDef);
	        } else if (computed == null) {
	          setLow = false;
	        } else {
	          setLow = retHighest ? (computed <= value) : (computed < value);
	        }
	        if (setLow) {
	          low = mid + 1;
	        } else {
	          high = mid;
	        }
	      }
	      return nativeMin(high, MAX_ARRAY_INDEX);
	    }
	
	    /**
	     * A specialized version of `baseCallback` which only supports `this` binding
	     * and specifying the number of arguments to provide to `func`.
	     *
	     * @private
	     * @param {Function} func The function to bind.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {number} [argCount] The number of arguments to provide to `func`.
	     * @returns {Function} Returns the callback.
	     */
	    function bindCallback(func, thisArg, argCount) {
	      if (typeof func != 'function') {
	        return identity;
	      }
	      if (thisArg === undefined) {
	        return func;
	      }
	      switch (argCount) {
	        case 1: return function(value) {
	          return func.call(thisArg, value);
	        };
	        case 3: return function(value, index, collection) {
	          return func.call(thisArg, value, index, collection);
	        };
	        case 4: return function(accumulator, value, index, collection) {
	          return func.call(thisArg, accumulator, value, index, collection);
	        };
	        case 5: return function(value, other, key, object, source) {
	          return func.call(thisArg, value, other, key, object, source);
	        };
	      }
	      return function() {
	        return func.apply(thisArg, arguments);
	      };
	    }
	
	    /**
	     * Creates a clone of the given array buffer.
	     *
	     * @private
	     * @param {ArrayBuffer} buffer The array buffer to clone.
	     * @returns {ArrayBuffer} Returns the cloned array buffer.
	     */
	    function bufferClone(buffer) {
	      return bufferSlice.call(buffer, 0);
	    }
	    if (!bufferSlice) {
	      // PhantomJS has `ArrayBuffer` and `Uint8Array` but not `Float64Array`.
	      bufferClone = !(ArrayBuffer && Uint8Array) ? constant(null) : function(buffer) {
	        var byteLength = buffer.byteLength,
	            floatLength = Float64Array ? floor(byteLength / FLOAT64_BYTES_PER_ELEMENT) : 0,
	            offset = floatLength * FLOAT64_BYTES_PER_ELEMENT,
	            result = new ArrayBuffer(byteLength);
	
	        if (floatLength) {
	          var view = new Float64Array(result, 0, floatLength);
	          view.set(new Float64Array(buffer, 0, floatLength));
	        }
	        if (byteLength != offset) {
	          view = new Uint8Array(result, offset);
	          view.set(new Uint8Array(buffer, offset));
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates an array that is the composition of partially applied arguments,
	     * placeholders, and provided arguments into a single array of arguments.
	     *
	     * @private
	     * @param {Array|Object} args The provided arguments.
	     * @param {Array} partials The arguments to prepend to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgs(args, partials, holders) {
	      var holdersLength = holders.length,
	          argsIndex = -1,
	          argsLength = nativeMax(args.length - holdersLength, 0),
	          leftIndex = -1,
	          leftLength = partials.length,
	          result = Array(argsLength + leftLength);
	
	      while (++leftIndex < leftLength) {
	        result[leftIndex] = partials[leftIndex];
	      }
	      while (++argsIndex < holdersLength) {
	        result[holders[argsIndex]] = args[argsIndex];
	      }
	      while (argsLength--) {
	        result[leftIndex++] = args[argsIndex++];
	      }
	      return result;
	    }
	
	    /**
	     * This function is like `composeArgs` except that the arguments composition
	     * is tailored for `_.partialRight`.
	     *
	     * @private
	     * @param {Array|Object} args The provided arguments.
	     * @param {Array} partials The arguments to append to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgsRight(args, partials, holders) {
	      var holdersIndex = -1,
	          holdersLength = holders.length,
	          argsIndex = -1,
	          argsLength = nativeMax(args.length - holdersLength, 0),
	          rightIndex = -1,
	          rightLength = partials.length,
	          result = Array(argsLength + rightLength);
	
	      while (++argsIndex < argsLength) {
	        result[argsIndex] = args[argsIndex];
	      }
	      var offset = argsIndex;
	      while (++rightIndex < rightLength) {
	        result[offset + rightIndex] = partials[rightIndex];
	      }
	      while (++holdersIndex < holdersLength) {
	        result[offset + holders[holdersIndex]] = args[argsIndex++];
	      }
	      return result;
	    }
	
	    /**
	     * Creates a function that aggregates a collection, creating an accumulator
	     * object composed from the results of running each element in the collection
	     * through an iteratee.
	     *
	     * **Note:** This function is used to create `_.countBy`, `_.groupBy`, `_.indexBy`,
	     * and `_.partition`.
	     *
	     * @private
	     * @param {Function} setter The function to set keys and values of the accumulator object.
	     * @param {Function} [initializer] The function to initialize the accumulator object.
	     * @returns {Function} Returns the new aggregator function.
	     */
	    function createAggregator(setter, initializer) {
	      return function(collection, iteratee, thisArg) {
	        var result = initializer ? initializer() : {};
	        iteratee = getCallback(iteratee, thisArg, 3);
	
	        if (isArray(collection)) {
	          var index = -1,
	              length = collection.length;
	
	          while (++index < length) {
	            var value = collection[index];
	            setter(result, value, iteratee(value, index, collection), collection);
	          }
	        } else {
	          baseEach(collection, function(value, key, collection) {
	            setter(result, value, iteratee(value, key, collection), collection);
	          });
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function that assigns properties of source object(s) to a given
	     * destination object.
	     *
	     * **Note:** This function is used to create `_.assign`, `_.defaults`, and `_.merge`.
	     *
	     * @private
	     * @param {Function} assigner The function to assign values.
	     * @returns {Function} Returns the new assigner function.
	     */
	    function createAssigner(assigner) {
	      return restParam(function(object, sources) {
	        var index = -1,
	            length = object == null ? 0 : sources.length,
	            customizer = length > 2 ? sources[length - 2] : undefined,
	            guard = length > 2 ? sources[2] : undefined,
	            thisArg = length > 1 ? sources[length - 1] : undefined;
	
	        if (typeof customizer == 'function') {
	          customizer = bindCallback(customizer, thisArg, 5);
	          length -= 2;
	        } else {
	          customizer = typeof thisArg == 'function' ? thisArg : undefined;
	          length -= (customizer ? 1 : 0);
	        }
	        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	          customizer = length < 3 ? undefined : customizer;
	          length = 1;
	        }
	        while (++index < length) {
	          var source = sources[index];
	          if (source) {
	            assigner(object, source, customizer);
	          }
	        }
	        return object;
	      });
	    }
	
	    /**
	     * Creates a `baseEach` or `baseEachRight` function.
	     *
	     * @private
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseEach(eachFunc, fromRight) {
	      return function(collection, iteratee) {
	        var length = collection ? getLength(collection) : 0;
	        if (!isLength(length)) {
	          return eachFunc(collection, iteratee);
	        }
	        var index = fromRight ? length : -1,
	            iterable = toObject(collection);
	
	        while ((fromRight ? index-- : ++index < length)) {
	          if (iteratee(iterable[index], index, iterable) === false) {
	            break;
	          }
	        }
	        return collection;
	      };
	    }
	
	    /**
	     * Creates a base function for `_.forIn` or `_.forInRight`.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseFor(fromRight) {
	      return function(object, iteratee, keysFunc) {
	        var iterable = toObject(object),
	            props = keysFunc(object),
	            length = props.length,
	            index = fromRight ? length : -1;
	
	        while ((fromRight ? index-- : ++index < length)) {
	          var key = props[index];
	          if (iteratee(iterable[key], key, iterable) === false) {
	            break;
	          }
	        }
	        return object;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` and invokes it with the `this`
	     * binding of `thisArg`.
	     *
	     * @private
	     * @param {Function} func The function to bind.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @returns {Function} Returns the new bound function.
	     */
	    function createBindWrapper(func, thisArg) {
	      var Ctor = createCtorWrapper(func);
	
	      function wrapper() {
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return fn.apply(thisArg, arguments);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `Set` cache object to optimize linear searches of large arrays.
	     *
	     * @private
	     * @param {Array} [values] The values to cache.
	     * @returns {null|Object} Returns the new cache object if `Set` is supported, else `null`.
	     */
	    var createCache = !(nativeCreate && Set) ? constant(null) : function(values) {
	      return new SetCache(values);
	    };
	
	    /**
	     * Creates a function that produces compound words out of the words in a
	     * given string.
	     *
	     * @private
	     * @param {Function} callback The function to combine each word.
	     * @returns {Function} Returns the new compounder function.
	     */
	    function createCompounder(callback) {
	      return function(string) {
	        var index = -1,
	            array = words(deburr(string)),
	            length = array.length,
	            result = '';
	
	        while (++index < length) {
	          result = callback(result, array[index], index);
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function that produces an instance of `Ctor` regardless of
	     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
	     *
	     * @private
	     * @param {Function} Ctor The constructor to wrap.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCtorWrapper(Ctor) {
	      return function() {
	        // Use a `switch` statement to work with class constructors.
	        // See https://people.mozilla.org/~jorendorff/es6-draft.html#sec-ecmascript-function-objects-call-thisargument-argumentslist
	        // for more details.
	        var args = arguments;
	        switch (args.length) {
	          case 0: return new Ctor;
	          case 1: return new Ctor(args[0]);
	          case 2: return new Ctor(args[0], args[1]);
	          case 3: return new Ctor(args[0], args[1], args[2]);
	          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
	          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
	        }
	        var thisBinding = baseCreate(Ctor.prototype),
	            result = Ctor.apply(thisBinding, args);
	
	        // Mimic the constructor's `return` behavior.
	        // See https://es5.github.io/#x13.2.2 for more details.
	        return isObject(result) ? result : thisBinding;
	      };
	    }
	
	    /**
	     * Creates a `_.curry` or `_.curryRight` function.
	     *
	     * @private
	     * @param {boolean} flag The curry bit flag.
	     * @returns {Function} Returns the new curry function.
	     */
	    function createCurry(flag) {
	      function curryFunc(func, arity, guard) {
	        if (guard && isIterateeCall(func, arity, guard)) {
	          arity = null;
	        }
	        var result = createWrapper(func, flag, null, null, null, null, null, arity);
	        result.placeholder = curryFunc.placeholder;
	        return result;
	      }
	      return curryFunc;
	    }
	
	    /**
	     * Creates a `_.max` or `_.min` function.
	     *
	     * @private
	     * @param {Function} comparator The function used to compare values.
	     * @param {*} exValue The initial extremum value.
	     * @returns {Function} Returns the new extremum function.
	     */
	    function createExtremum(comparator, exValue) {
	      return function(collection, iteratee, thisArg) {
	        if (thisArg && isIterateeCall(collection, iteratee, thisArg)) {
	          iteratee = null;
	        }
	        iteratee = getCallback(iteratee, thisArg, 3);
	        if (iteratee.length == 1) {
	          collection = toIterable(collection);
	          var result = arrayExtremum(collection, iteratee, comparator, exValue);
	          if (!(collection.length && result === exValue)) {
	            return result;
	          }
	        }
	        return baseExtremum(collection, iteratee, comparator, exValue);
	      };
	    }
	
	    /**
	     * Creates a `_.find` or `_.findLast` function.
	     *
	     * @private
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new find function.
	     */
	    function createFind(eachFunc, fromRight) {
	      return function(collection, predicate, thisArg) {
	        predicate = getCallback(predicate, thisArg, 3);
	        if (isArray(collection)) {
	          var index = baseFindIndex(collection, predicate, fromRight);
	          return index > -1 ? collection[index] : undefined;
	        }
	        return baseFind(collection, predicate, eachFunc);
	      };
	    }
	
	    /**
	     * Creates a `_.findIndex` or `_.findLastIndex` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new find function.
	     */
	    function createFindIndex(fromRight) {
	      return function(array, predicate, thisArg) {
	        if (!(array && array.length)) {
	          return -1;
	        }
	        predicate = getCallback(predicate, thisArg, 3);
	        return baseFindIndex(array, predicate, fromRight);
	      };
	    }
	
	    /**
	     * Creates a `_.findKey` or `_.findLastKey` function.
	     *
	     * @private
	     * @param {Function} objectFunc The function to iterate over an object.
	     * @returns {Function} Returns the new find function.
	     */
	    function createFindKey(objectFunc) {
	      return function(object, predicate, thisArg) {
	        predicate = getCallback(predicate, thisArg, 3);
	        return baseFind(object, predicate, objectFunc, true);
	      };
	    }
	
	    /**
	     * Creates a `_.flow` or `_.flowRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new flow function.
	     */
	    function createFlow(fromRight) {
	      return function() {
	        var wrapper,
	            length = arguments.length,
	            index = fromRight ? length : -1,
	            leftIndex = 0,
	            funcs = Array(length);
	
	        while ((fromRight ? index-- : ++index < length)) {
	          var func = funcs[leftIndex++] = arguments[index];
	          if (typeof func != 'function') {
	            throw new TypeError(FUNC_ERROR_TEXT);
	          }
	          if (!wrapper && LodashWrapper.prototype.thru && getFuncName(func) == 'wrapper') {
	            wrapper = new LodashWrapper([]);
	          }
	        }
	        index = wrapper ? -1 : length;
	        while (++index < length) {
	          func = funcs[index];
	
	          var funcName = getFuncName(func),
	              data = funcName == 'wrapper' ? getData(func) : null;
	
	          if (data && isLaziable(data[0]) && data[1] == (ARY_FLAG | CURRY_FLAG | PARTIAL_FLAG | REARG_FLAG) && !data[4].length && data[9] == 1) {
	            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
	          } else {
	            wrapper = (func.length == 1 && isLaziable(func)) ? wrapper[funcName]() : wrapper.thru(func);
	          }
	        }
	        return function() {
	          var args = arguments;
	          if (wrapper && args.length == 1 && isArray(args[0])) {
	            return wrapper.plant(args[0]).value();
	          }
	          var index = 0,
	              result = length ? funcs[index].apply(this, args) : args[0];
	
	          while (++index < length) {
	            result = funcs[index].call(this, result);
	          }
	          return result;
	        };
	      };
	    }
	
	    /**
	     * Creates a function for `_.forEach` or `_.forEachRight`.
	     *
	     * @private
	     * @param {Function} arrayFunc The function to iterate over an array.
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @returns {Function} Returns the new each function.
	     */
	    function createForEach(arrayFunc, eachFunc) {
	      return function(collection, iteratee, thisArg) {
	        return (typeof iteratee == 'function' && thisArg === undefined && isArray(collection))
	          ? arrayFunc(collection, iteratee)
	          : eachFunc(collection, bindCallback(iteratee, thisArg, 3));
	      };
	    }
	
	    /**
	     * Creates a function for `_.forIn` or `_.forInRight`.
	     *
	     * @private
	     * @param {Function} objectFunc The function to iterate over an object.
	     * @returns {Function} Returns the new each function.
	     */
	    function createForIn(objectFunc) {
	      return function(object, iteratee, thisArg) {
	        if (typeof iteratee != 'function' || thisArg !== undefined) {
	          iteratee = bindCallback(iteratee, thisArg, 3);
	        }
	        return objectFunc(object, iteratee, keysIn);
	      };
	    }
	
	    /**
	     * Creates a function for `_.forOwn` or `_.forOwnRight`.
	     *
	     * @private
	     * @param {Function} objectFunc The function to iterate over an object.
	     * @returns {Function} Returns the new each function.
	     */
	    function createForOwn(objectFunc) {
	      return function(object, iteratee, thisArg) {
	        if (typeof iteratee != 'function' || thisArg !== undefined) {
	          iteratee = bindCallback(iteratee, thisArg, 3);
	        }
	        return objectFunc(object, iteratee);
	      };
	    }
	
	    /**
	     * Creates a function for `_.mapKeys` or `_.mapValues`.
	     *
	     * @private
	     * @param {boolean} [isMapKeys] Specify mapping keys instead of values.
	     * @returns {Function} Returns the new map function.
	     */
	    function createObjectMapper(isMapKeys) {
	      return function(object, iteratee, thisArg) {
	        var result = {};
	        iteratee = getCallback(iteratee, thisArg, 3);
	
	        baseForOwn(object, function(value, key, object) {
	          var mapped = iteratee(value, key, object);
	          key = isMapKeys ? mapped : key;
	          value = isMapKeys ? value : mapped;
	          result[key] = value;
	        });
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function for `_.padLeft` or `_.padRight`.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify padding from the right.
	     * @returns {Function} Returns the new pad function.
	     */
	    function createPadDir(fromRight) {
	      return function(string, length, chars) {
	        string = baseToString(string);
	        return (fromRight ? string : '') + createPadding(string, length, chars) + (fromRight ? '' : string);
	      };
	    }
	
	    /**
	     * Creates a `_.partial` or `_.partialRight` function.
	     *
	     * @private
	     * @param {boolean} flag The partial bit flag.
	     * @returns {Function} Returns the new partial function.
	     */
	    function createPartial(flag) {
	      var partialFunc = restParam(function(func, partials) {
	        var holders = replaceHolders(partials, partialFunc.placeholder);
	        return createWrapper(func, flag, null, partials, holders);
	      });
	      return partialFunc;
	    }
	
	    /**
	     * Creates a function for `_.reduce` or `_.reduceRight`.
	     *
	     * @private
	     * @param {Function} arrayFunc The function to iterate over an array.
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @returns {Function} Returns the new each function.
	     */
	    function createReduce(arrayFunc, eachFunc) {
	      return function(collection, iteratee, accumulator, thisArg) {
	        var initFromArray = arguments.length < 3;
	        return (typeof iteratee == 'function' && thisArg === undefined && isArray(collection))
	          ? arrayFunc(collection, iteratee, accumulator, initFromArray)
	          : baseReduce(collection, getCallback(iteratee, thisArg, 4), accumulator, initFromArray, eachFunc);
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` and invokes it with optional `this`
	     * binding of, partial application, and currying.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to reference.
	     * @param {number} bitmask The bitmask of flags. See `createWrapper` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [partialsRight] The arguments to append to those provided to the new function.
	     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createHybridWrapper(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
	      var isAry = bitmask & ARY_FLAG,
	          isBind = bitmask & BIND_FLAG,
	          isBindKey = bitmask & BIND_KEY_FLAG,
	          isCurry = bitmask & CURRY_FLAG,
	          isCurryBound = bitmask & CURRY_BOUND_FLAG,
	          isCurryRight = bitmask & CURRY_RIGHT_FLAG,
	          Ctor = isBindKey ? null : createCtorWrapper(func);
	
	      function wrapper() {
	        // Avoid `arguments` object use disqualifying optimizations by
	        // converting it to an array before providing it to other functions.
	        var length = arguments.length,
	            index = length,
	            args = Array(length);
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        if (partials) {
	          args = composeArgs(args, partials, holders);
	        }
	        if (partialsRight) {
	          args = composeArgsRight(args, partialsRight, holdersRight);
	        }
	        if (isCurry || isCurryRight) {
	          var placeholder = wrapper.placeholder,
	              argsHolders = replaceHolders(args, placeholder);
	
	          length -= argsHolders.length;
	          if (length < arity) {
	            var newArgPos = argPos ? arrayCopy(argPos) : null,
	                newArity = nativeMax(arity - length, 0),
	                newsHolders = isCurry ? argsHolders : null,
	                newHoldersRight = isCurry ? null : argsHolders,
	                newPartials = isCurry ? args : null,
	                newPartialsRight = isCurry ? null : args;
	
	            bitmask |= (isCurry ? PARTIAL_FLAG : PARTIAL_RIGHT_FLAG);
	            bitmask &= ~(isCurry ? PARTIAL_RIGHT_FLAG : PARTIAL_FLAG);
	
	            if (!isCurryBound) {
	              bitmask &= ~(BIND_FLAG | BIND_KEY_FLAG);
	            }
	            var newData = [func, bitmask, thisArg, newPartials, newsHolders, newPartialsRight, newHoldersRight, newArgPos, ary, newArity],
	                result = createHybridWrapper.apply(undefined, newData);
	
	            if (isLaziable(func)) {
	              setData(result, newData);
	            }
	            result.placeholder = placeholder;
	            return result;
	          }
	        }
	        var thisBinding = isBind ? thisArg : this,
	            fn = isBindKey ? thisBinding[func] : func;
	
	        if (argPos) {
	          args = reorder(args, argPos);
	        }
	        if (isAry && ary < args.length) {
	          args.length = ary;
	        }
	        if (this && this !== root && this instanceof wrapper) {
	          fn = Ctor || createCtorWrapper(func);
	        }
	        return fn.apply(thisBinding, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates the padding required for `string` based on the given `length`.
	     * The `chars` string is truncated if the number of characters exceeds `length`.
	     *
	     * @private
	     * @param {string} string The string to create padding for.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the pad for `string`.
	     */
	    function createPadding(string, length, chars) {
	      var strLength = string.length;
	      length = +length;
	
	      if (strLength >= length || !nativeIsFinite(length)) {
	        return '';
	      }
	      var padLength = length - strLength;
	      chars = chars == null ? ' ' : (chars + '');
	      return repeat(chars, ceil(padLength / chars.length)).slice(0, padLength);
	    }
	
	    /**
	     * Creates a function that wraps `func` and invokes it with the optional `this`
	     * binding of `thisArg` and the `partials` prepended to those provided to
	     * the wrapper.
	     *
	     * @private
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {number} bitmask The bitmask of flags. See `createWrapper` for more details.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {Array} partials The arguments to prepend to those provided to the new function.
	     * @returns {Function} Returns the new bound function.
	     */
	    function createPartialWrapper(func, bitmask, thisArg, partials) {
	      var isBind = bitmask & BIND_FLAG,
	          Ctor = createCtorWrapper(func);
	
	      function wrapper() {
	        // Avoid `arguments` object use disqualifying optimizations by
	        // converting it to an array before providing it `func`.
	        var argsIndex = -1,
	            argsLength = arguments.length,
	            leftIndex = -1,
	            leftLength = partials.length,
	            args = Array(argsLength + leftLength);
	
	        while (++leftIndex < leftLength) {
	          args[leftIndex] = partials[leftIndex];
	        }
	        while (argsLength--) {
	          args[leftIndex++] = arguments[++argsIndex];
	        }
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return fn.apply(isBind ? thisArg : this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.sortedIndex` or `_.sortedLastIndex` function.
	     *
	     * @private
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {Function} Returns the new index function.
	     */
	    function createSortedIndex(retHighest) {
	      return function(array, value, iteratee, thisArg) {
	        var callback = getCallback(iteratee);
	        return (iteratee == null && callback === baseCallback)
	          ? binaryIndex(array, value, retHighest)
	          : binaryIndexBy(array, value, callback(iteratee, thisArg, 1), retHighest);
	      };
	    }
	
	    /**
	     * Creates a function that either curries or invokes `func` with optional
	     * `this` binding and partially applied arguments.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to reference.
	     * @param {number} bitmask The bitmask of flags.
	     *  The bitmask may be composed of the following flags:
	     *     1 - `_.bind`
	     *     2 - `_.bindKey`
	     *     4 - `_.curry` or `_.curryRight` of a bound function
	     *     8 - `_.curry`
	     *    16 - `_.curryRight`
	     *    32 - `_.partial`
	     *    64 - `_.partialRight`
	     *   128 - `_.rearg`
	     *   256 - `_.ary`
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to be partially applied.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createWrapper(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
	      var isBindKey = bitmask & BIND_KEY_FLAG;
	      if (!isBindKey && typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var length = partials ? partials.length : 0;
	      if (!length) {
	        bitmask &= ~(PARTIAL_FLAG | PARTIAL_RIGHT_FLAG);
	        partials = holders = null;
	      }
	      length -= (holders ? holders.length : 0);
	      if (bitmask & PARTIAL_RIGHT_FLAG) {
	        var partialsRight = partials,
	            holdersRight = holders;
	
	        partials = holders = null;
	      }
	      var data = isBindKey ? null : getData(func),
	          newData = [func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity];
	
	      if (data) {
	        mergeData(newData, data);
	        bitmask = newData[1];
	        arity = newData[9];
	      }
	      newData[9] = arity == null
	        ? (isBindKey ? 0 : func.length)
	        : (nativeMax(arity - length, 0) || 0);
	
	      if (bitmask == BIND_FLAG) {
	        var result = createBindWrapper(newData[0], newData[2]);
	      } else if ((bitmask == PARTIAL_FLAG || bitmask == (BIND_FLAG | PARTIAL_FLAG)) && !newData[4].length) {
	        result = createPartialWrapper.apply(undefined, newData);
	      } else {
	        result = createHybridWrapper.apply(undefined, newData);
	      }
	      var setter = data ? baseSetData : setData;
	      return setter(result, newData);
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for arrays with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Array} array The array to compare.
	     * @param {Array} other The other array to compare.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Function} [customizer] The function to customize comparing arrays.
	     * @param {boolean} [isLoose] Specify performing partial comparisons.
	     * @param {Array} [stackA] Tracks traversed `value` objects.
	     * @param {Array} [stackB] Tracks traversed `other` objects.
	     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	     */
	    function equalArrays(array, other, equalFunc, customizer, isLoose, stackA, stackB) {
	      var index = -1,
	          arrLength = array.length,
	          othLength = other.length;
	
	      if (arrLength != othLength && !(isLoose && othLength > arrLength)) {
	        return false;
	      }
	      // Ignore non-index properties.
	      while (++index < arrLength) {
	        var arrValue = array[index],
	            othValue = other[index],
	            result = customizer ? customizer(isLoose ? othValue : arrValue, isLoose ? arrValue : othValue, index) : undefined;
	
	        if (result !== undefined) {
	          if (result) {
	            continue;
	          }
	          return false;
	        }
	        // Recursively compare arrays (susceptible to call stack limits).
	        if (isLoose) {
	          if (!arraySome(other, function(othValue) {
	                return arrValue === othValue || equalFunc(arrValue, othValue, customizer, isLoose, stackA, stackB);
	              })) {
	            return false;
	          }
	        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, customizer, isLoose, stackA, stackB))) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for comparing objects of
	     * the same `toStringTag`.
	     *
	     * **Note:** This function only supports comparing values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} value The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {string} tag The `toStringTag` of the objects to compare.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalByTag(object, other, tag) {
	      switch (tag) {
	        case boolTag:
	        case dateTag:
	          // Coerce dates and booleans to numbers, dates to milliseconds and booleans
	          // to `1` or `0` treating invalid dates coerced to `NaN` as not equal.
	          return +object == +other;
	
	        case errorTag:
	          return object.name == other.name && object.message == other.message;
	
	        case numberTag:
	          // Treat `NaN` vs. `NaN` as equal.
	          return (object != +object)
	            ? other != +other
	            : object == +other;
	
	        case regexpTag:
	        case stringTag:
	          // Coerce regexes to strings and treat strings primitives and string
	          // objects as equal. See https://es5.github.io/#x15.10.6.4 for more details.
	          return object == (other + '');
	      }
	      return false;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for objects with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Function} [customizer] The function to customize comparing values.
	     * @param {boolean} [isLoose] Specify performing partial comparisons.
	     * @param {Array} [stackA] Tracks traversed `value` objects.
	     * @param {Array} [stackB] Tracks traversed `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalObjects(object, other, equalFunc, customizer, isLoose, stackA, stackB) {
	      var objProps = keys(object),
	          objLength = objProps.length,
	          othProps = keys(other),
	          othLength = othProps.length;
	
	      if (objLength != othLength && !isLoose) {
	        return false;
	      }
	      var index = objLength;
	      while (index--) {
	        var key = objProps[index];
	        if (!(isLoose ? key in other : hasOwnProperty.call(other, key))) {
	          return false;
	        }
	      }
	      var skipCtor = isLoose;
	      while (++index < objLength) {
	        key = objProps[index];
	        var objValue = object[key],
	            othValue = other[key],
	            result = customizer ? customizer(isLoose ? othValue : objValue, isLoose? objValue : othValue, key) : undefined;
	
	        // Recursively compare objects (susceptible to call stack limits).
	        if (!(result === undefined ? equalFunc(objValue, othValue, customizer, isLoose, stackA, stackB) : result)) {
	          return false;
	        }
	        skipCtor || (skipCtor = key == 'constructor');
	      }
	      if (!skipCtor) {
	        var objCtor = object.constructor,
	            othCtor = other.constructor;
	
	        // Non `Object` object instances with different constructors are not equal.
	        if (objCtor != othCtor &&
	            ('constructor' in object && 'constructor' in other) &&
	            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * Gets the appropriate "callback" function. If the `_.callback` method is
	     * customized this function returns the custom method, otherwise it returns
	     * the `baseCallback` function. If arguments are provided the chosen function
	     * is invoked with them and its result is returned.
	     *
	     * @private
	     * @returns {Function} Returns the chosen function or its result.
	     */
	    function getCallback(func, thisArg, argCount) {
	      var result = lodash.callback || callback;
	      result = result === callback ? baseCallback : result;
	      return argCount ? result(func, thisArg, argCount) : result;
	    }
	
	    /**
	     * Gets metadata for `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {*} Returns the metadata for `func`.
	     */
	    var getData = !metaMap ? noop : function(func) {
	      return metaMap.get(func);
	    };
	
	    /**
	     * Gets the name of `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {string} Returns the function name.
	     */
	    function getFuncName(func) {
	      var result = func.name,
	          array = realNames[result],
	          length = array ? array.length : 0;
	
	      while (length--) {
	        var data = array[length],
	            otherFunc = data.func;
	        if (otherFunc == null || otherFunc == func) {
	          return data.name;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Gets the appropriate "indexOf" function. If the `_.indexOf` method is
	     * customized this function returns the custom method, otherwise it returns
	     * the `baseIndexOf` function. If arguments are provided the chosen function
	     * is invoked with them and its result is returned.
	     *
	     * @private
	     * @returns {Function|number} Returns the chosen function or its result.
	     */
	    function getIndexOf(collection, target, fromIndex) {
	      var result = lodash.indexOf || indexOf;
	      result = result === indexOf ? baseIndexOf : result;
	      return collection ? result(collection, target, fromIndex) : result;
	    }
	
	    /**
	     * Gets the "length" property value of `object`.
	     *
	     * **Note:** This function is used to avoid a [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792)
	     * that affects Safari on at least iOS 8.1-8.3 ARM64.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {*} Returns the "length" value.
	     */
	    var getLength = baseProperty('length');
	
	    /**
	     * Gets the propery names, values, and compare flags of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the match data of `object`.
	     */
	    function getMatchData(object) {
	      var result = pairs(object),
	          length = result.length;
	
	      while (length--) {
	        result[length][2] = isStrictComparable(result[length][1]);
	      }
	      return result;
	    }
	
	    /**
	     * Gets the native function at `key` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the method to get.
	     * @returns {*} Returns the function if it's native, else `undefined`.
	     */
	    function getNative(object, key) {
	      var value = object == null ? undefined : object[key];
	      return isNative(value) ? value : undefined;
	    }
	
	    /**
	     * Gets the view, applying any `transforms` to the `start` and `end` positions.
	     *
	     * @private
	     * @param {number} start The start of the view.
	     * @param {number} end The end of the view.
	     * @param {Array} [transforms] The transformations to apply to the view.
	     * @returns {Object} Returns an object containing the `start` and `end`
	     *  positions of the view.
	     */
	    function getView(start, end, transforms) {
	      var index = -1,
	          length = transforms ? transforms.length : 0;
	
	      while (++index < length) {
	        var data = transforms[index],
	            size = data.size;
	
	        switch (data.type) {
	          case 'drop':      start += size; break;
	          case 'dropRight': end -= size; break;
	          case 'take':      end = nativeMin(end, start + size); break;
	          case 'takeRight': start = nativeMax(start, end - size); break;
	        }
	      }
	      return { 'start': start, 'end': end };
	    }
	
	    /**
	     * Initializes an array clone.
	     *
	     * @private
	     * @param {Array} array The array to clone.
	     * @returns {Array} Returns the initialized clone.
	     */
	    function initCloneArray(array) {
	      var length = array.length,
	          result = new array.constructor(length);
	
	      // Add array properties assigned by `RegExp#exec`.
	      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	        result.index = array.index;
	        result.input = array.input;
	      }
	      return result;
	    }
	
	    /**
	     * Initializes an object clone.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneObject(object) {
	      var Ctor = object.constructor;
	      if (!(typeof Ctor == 'function' && Ctor instanceof Ctor)) {
	        Ctor = Object;
	      }
	      return new Ctor;
	    }
	
	    /**
	     * Initializes an object clone based on its `toStringTag`.
	     *
	     * **Note:** This function only supports cloning values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @param {string} tag The `toStringTag` of the object to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneByTag(object, tag, isDeep) {
	      var Ctor = object.constructor;
	      switch (tag) {
	        case arrayBufferTag:
	          return bufferClone(object);
	
	        case boolTag:
	        case dateTag:
	          return new Ctor(+object);
	
	        case float32Tag: case float64Tag:
	        case int8Tag: case int16Tag: case int32Tag:
	        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	          var buffer = object.buffer;
	          return new Ctor(isDeep ? bufferClone(buffer) : buffer, object.byteOffset, object.length);
	
	        case numberTag:
	        case stringTag:
	          return new Ctor(object);
	
	        case regexpTag:
	          var result = new Ctor(object.source, reFlags.exec(object));
	          result.lastIndex = object.lastIndex;
	      }
	      return result;
	    }
	
	    /**
	     * Invokes the method at `path` on `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {Array} args The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     */
	    function invokePath(object, path, args) {
	      if (object != null && !isKey(path, object)) {
	        path = toPath(path);
	        object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
	        path = last(path);
	      }
	      var func = object == null ? object : object[path];
	      return func == null ? undefined : func.apply(object, args);
	    }
	
	    /**
	     * Checks if `value` is array-like.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	     */
	    function isArrayLike(value) {
	      return value != null && isLength(getLength(value));
	    }
	
	    /**
	     * Checks if `value` is a valid array-like index.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	     */
	    function isIndex(value, length) {
	      value = (typeof value == 'number' || reIsUint.test(value)) ? +value : -1;
	      length = length == null ? MAX_SAFE_INTEGER : length;
	      return value > -1 && value % 1 == 0 && value < length;
	    }
	
	    /**
	     * Checks if the provided arguments are from an iteratee call.
	     *
	     * @private
	     * @param {*} value The potential iteratee value argument.
	     * @param {*} index The potential iteratee index or key argument.
	     * @param {*} object The potential iteratee object argument.
	     * @returns {boolean} Returns `true` if the arguments are from an iteratee call, else `false`.
	     */
	    function isIterateeCall(value, index, object) {
	      if (!isObject(object)) {
	        return false;
	      }
	      var type = typeof index;
	      if (type == 'number'
	          ? (isArrayLike(object) && isIndex(index, object.length))
	          : (type == 'string' && index in object)) {
	        var other = object[index];
	        return value === value ? (value === other) : (other !== other);
	      }
	      return false;
	    }
	
	    /**
	     * Checks if `value` is a property name and not a property path.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	     */
	    function isKey(value, object) {
	      var type = typeof value;
	      if ((type == 'string' && reIsPlainProp.test(value)) || type == 'number') {
	        return true;
	      }
	      if (isArray(value)) {
	        return false;
	      }
	      var result = !reIsDeepProp.test(value);
	      return result || (object != null && value in toObject(object));
	    }
	
	    /**
	     * Checks if `func` has a lazy counterpart.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` has a lazy counterpart, else `false`.
	     */
	    function isLaziable(func) {
	      var funcName = getFuncName(func);
	      if (!(funcName in LazyWrapper.prototype)) {
	        return false;
	      }
	      var other = lodash[funcName];
	      if (func === other) {
	        return true;
	      }
	      var data = getData(other);
	      return !!data && func === data[0];
	    }
	
	    /**
	     * Checks if `value` is a valid array-like length.
	     *
	     * **Note:** This function is based on [`ToLength`](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength).
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	     */
	    function isLength(value) {
	      return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` if suitable for strict
	     *  equality comparisons, else `false`.
	     */
	    function isStrictComparable(value) {
	      return value === value && !isObject(value);
	    }
	
	    /**
	     * Merges the function metadata of `source` into `data`.
	     *
	     * Merging metadata reduces the number of wrappers required to invoke a function.
	     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
	     * may be applied regardless of execution order. Methods like `_.ary` and `_.rearg`
	     * augment function arguments, making the order in which they are executed important,
	     * preventing the merging of metadata. However, we make an exception for a safe
	     * common case where curried functions have `_.ary` and or `_.rearg` applied.
	     *
	     * @private
	     * @param {Array} data The destination metadata.
	     * @param {Array} source The source metadata.
	     * @returns {Array} Returns `data`.
	     */
	    function mergeData(data, source) {
	      var bitmask = data[1],
	          srcBitmask = source[1],
	          newBitmask = bitmask | srcBitmask,
	          isCommon = newBitmask < ARY_FLAG;
	
	      var isCombo =
	        (srcBitmask == ARY_FLAG && bitmask == CURRY_FLAG) ||
	        (srcBitmask == ARY_FLAG && bitmask == REARG_FLAG && data[7].length <= source[8]) ||
	        (srcBitmask == (ARY_FLAG | REARG_FLAG) && bitmask == CURRY_FLAG);
	
	      // Exit early if metadata can't be merged.
	      if (!(isCommon || isCombo)) {
	        return data;
	      }
	      // Use source `thisArg` if available.
	      if (srcBitmask & BIND_FLAG) {
	        data[2] = source[2];
	        // Set when currying a bound function.
	        newBitmask |= (bitmask & BIND_FLAG) ? 0 : CURRY_BOUND_FLAG;
	      }
	      // Compose partial arguments.
	      var value = source[3];
	      if (value) {
	        var partials = data[3];
	        data[3] = partials ? composeArgs(partials, value, source[4]) : arrayCopy(value);
	        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : arrayCopy(source[4]);
	      }
	      // Compose partial right arguments.
	      value = source[5];
	      if (value) {
	        partials = data[5];
	        data[5] = partials ? composeArgsRight(partials, value, source[6]) : arrayCopy(value);
	        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : arrayCopy(source[6]);
	      }
	      // Use source `argPos` if available.
	      value = source[7];
	      if (value) {
	        data[7] = arrayCopy(value);
	      }
	      // Use source `ary` if it's smaller.
	      if (srcBitmask & ARY_FLAG) {
	        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
	      }
	      // Use source `arity` if one is not provided.
	      if (data[9] == null) {
	        data[9] = source[9];
	      }
	      // Use source `func` and merge bitmasks.
	      data[0] = source[0];
	      data[1] = newBitmask;
	
	      return data;
	    }
	
	    /**
	     * A specialized version of `_.pick` which picks `object` properties specified
	     * by `props`.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} props The property names to pick.
	     * @returns {Object} Returns the new object.
	     */
	    function pickByArray(object, props) {
	      object = toObject(object);
	
	      var index = -1,
	          length = props.length,
	          result = {};
	
	      while (++index < length) {
	        var key = props[index];
	        if (key in object) {
	          result[key] = object[key];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `_.pick` which picks `object` properties `predicate`
	     * returns truthy for.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Object} Returns the new object.
	     */
	    function pickByCallback(object, predicate) {
	      var result = {};
	      baseForIn(object, function(value, key, object) {
	        if (predicate(value, key, object)) {
	          result[key] = value;
	        }
	      });
	      return result;
	    }
	
	    /**
	     * Reorder `array` according to the specified indexes where the element at
	     * the first index is assigned as the first element, the element at
	     * the second index is assigned as the second element, and so on.
	     *
	     * @private
	     * @param {Array} array The array to reorder.
	     * @param {Array} indexes The arranged array indexes.
	     * @returns {Array} Returns `array`.
	     */
	    function reorder(array, indexes) {
	      var arrLength = array.length,
	          length = nativeMin(indexes.length, arrLength),
	          oldArray = arrayCopy(array);
	
	      while (length--) {
	        var index = indexes[length];
	        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
	      }
	      return array;
	    }
	
	    /**
	     * Sets metadata for `func`.
	     *
	     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
	     * period of time, it will trip its breaker and transition to an identity function
	     * to avoid garbage collection pauses in V8. See [V8 issue 2070](https://code.google.com/p/v8/issues/detail?id=2070)
	     * for more details.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var setData = (function() {
	      var count = 0,
	          lastCalled = 0;
	
	      return function(key, value) {
	        var stamp = now(),
	            remaining = HOT_SPAN - (stamp - lastCalled);
	
	        lastCalled = stamp;
	        if (remaining > 0) {
	          if (++count >= HOT_COUNT) {
	            return key;
	          }
	        } else {
	          count = 0;
	        }
	        return baseSetData(key, value);
	      };
	    }());
	
	    /**
	     * A fallback implementation of `_.isPlainObject` which checks if `value`
	     * is an object created by the `Object` constructor or has a `[[Prototype]]`
	     * of `null`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	     */
	    function shimIsPlainObject(value) {
	      var Ctor,
	          support = lodash.support;
	
	      // Exit early for non `Object` objects.
	      if (!(isObjectLike(value) && objToString.call(value) == objectTag) ||
	          (!hasOwnProperty.call(value, 'constructor') &&
	            (Ctor = value.constructor, typeof Ctor == 'function' && !(Ctor instanceof Ctor)))) {
	        return false;
	      }
	      // IE < 9 iterates inherited properties before own properties. If the first
	      // iterated property is an object's own property then there are no inherited
	      // enumerable properties.
	      var result;
	      // In most environments an object's own properties are iterated before
	      // its inherited properties. If the last iterated property is an object's
	      // own property then there are no inherited enumerable properties.
	      baseForIn(value, function(subValue, key) {
	        result = key;
	      });
	      return result === undefined || hasOwnProperty.call(value, result);
	    }
	
	    /**
	     * A fallback implementation of `Object.keys` which creates an array of the
	     * own enumerable property names of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function shimKeys(object) {
	      var props = keysIn(object),
	          propsLength = props.length,
	          length = propsLength && object.length;
	
	      var allowIndexes = !!length && isLength(length) &&
	        (isArray(object) || isArguments(object));
	
	      var index = -1,
	          result = [];
	
	      while (++index < propsLength) {
	        var key = props[index];
	        if ((allowIndexes && isIndex(key, length)) || hasOwnProperty.call(object, key)) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to an array-like object if it's not one.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {Array|Object} Returns the array-like object.
	     */
	    function toIterable(value) {
	      if (value == null) {
	        return [];
	      }
	      if (!isArrayLike(value)) {
	        return values(value);
	      }
	      return isObject(value) ? value : Object(value);
	    }
	
	    /**
	     * Converts `value` to an object if it's not one.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {Object} Returns the object.
	     */
	    function toObject(value) {
	      return isObject(value) ? value : Object(value);
	    }
	
	    /**
	     * Converts `value` to property path array if it's not one.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {Array} Returns the property path array.
	     */
	    function toPath(value) {
	      if (isArray(value)) {
	        return value;
	      }
	      var result = [];
	      baseToString(value).replace(rePropName, function(match, number, quote, string) {
	        result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
	      });
	      return result;
	    }
	
	    /**
	     * Creates a clone of `wrapper`.
	     *
	     * @private
	     * @param {Object} wrapper The wrapper to clone.
	     * @returns {Object} Returns the cloned wrapper.
	     */
	    function wrapperClone(wrapper) {
	      return wrapper instanceof LazyWrapper
	        ? wrapper.clone()
	        : new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__, arrayCopy(wrapper.__actions__));
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of elements split into groups the length of `size`.
	     * If `collection` can't be split evenly, the final chunk will be the remaining
	     * elements.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to process.
	     * @param {number} [size=1] The length of each chunk.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Array} Returns the new array containing chunks.
	     * @example
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 2);
	     * // => [['a', 'b'], ['c', 'd']]
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 3);
	     * // => [['a', 'b', 'c'], ['d']]
	     */
	    function chunk(array, size, guard) {
	      if (guard ? isIterateeCall(array, size, guard) : size == null) {
	        size = 1;
	      } else {
	        size = nativeMax(+size || 1, 1);
	      }
	      var index = 0,
	          length = array ? array.length : 0,
	          resIndex = -1,
	          result = Array(ceil(length / size));
	
	      while (index < length) {
	        result[++resIndex] = baseSlice(array, index, (index += size));
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array with all falsey values removed. The values `false`, `null`,
	     * `0`, `""`, `undefined`, and `NaN` are falsey.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to compact.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.compact([0, 1, false, 2, '', 3]);
	     * // => [1, 2, 3]
	     */
	    function compact(array) {
	      var index = -1,
	          length = array ? array.length : 0,
	          resIndex = -1,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index];
	        if (value) {
	          result[++resIndex] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array of unique `array` values not included in the other
	     * provided arrays using [`SameValueZero`](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The arrays of values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.difference([1, 2, 3], [4, 2]);
	     * // => [1, 3]
	     */
	    var difference = restParam(function(array, values) {
	      return isArrayLike(array)
	        ? baseDifference(array, baseFlatten(values, false, true))
	        : [];
	    });
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.drop([1, 2, 3]);
	     * // => [2, 3]
	     *
	     * _.drop([1, 2, 3], 2);
	     * // => [3]
	     *
	     * _.drop([1, 2, 3], 5);
	     * // => []
	     *
	     * _.drop([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function drop(array, n, guard) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (guard ? isIterateeCall(array, n, guard) : n == null) {
	        n = 1;
	      }
	      return baseSlice(array, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the end.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropRight([1, 2, 3]);
	     * // => [1, 2]
	     *
	     * _.dropRight([1, 2, 3], 2);
	     * // => [1]
	     *
	     * _.dropRight([1, 2, 3], 5);
	     * // => []
	     *
	     * _.dropRight([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function dropRight(array, n, guard) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (guard ? isIterateeCall(array, n, guard) : n == null) {
	        n = 1;
	      }
	      n = length - (+n || 0);
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the end.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * bound to `thisArg` and invoked with three arguments: (value, index, array).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that match the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropRightWhile([1, 2, 3], function(n) {
	     *   return n > 1;
	     * });
	     * // => [1]
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.pluck(_.dropRightWhile(users, { 'user': 'pebbles', 'active': false }), 'user');
	     * // => ['barney', 'fred']
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.pluck(_.dropRightWhile(users, 'active', false), 'user');
	     * // => ['barney']
	     *
	     * // using the `_.property` callback shorthand
	     * _.pluck(_.dropRightWhile(users, 'active'), 'user');
	     * // => ['barney', 'fred', 'pebbles']
	     */
	    function dropRightWhile(array, predicate, thisArg) {
	      return (array && array.length)
	        ? baseWhile(array, getCallback(predicate, thisArg, 3), true, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the beginning.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * bound to `thisArg` and invoked with three arguments: (value, index, array).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropWhile([1, 2, 3], function(n) {
	     *   return n < 3;
	     * });
	     * // => [3]
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.pluck(_.dropWhile(users, { 'user': 'barney', 'active': false }), 'user');
	     * // => ['fred', 'pebbles']
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.pluck(_.dropWhile(users, 'active', false), 'user');
	     * // => ['pebbles']
	     *
	     * // using the `_.property` callback shorthand
	     * _.pluck(_.dropWhile(users, 'active'), 'user');
	     * // => ['barney', 'fred', 'pebbles']
	     */
	    function dropWhile(array, predicate, thisArg) {
	      return (array && array.length)
	        ? baseWhile(array, getCallback(predicate, thisArg, 3), true)
	        : [];
	    }
	
	    /**
	     * Fills elements of `array` with `value` from `start` up to, but not
	     * including, `end`.
	     *
	     * **Note:** This method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.fill(array, 'a');
	     * console.log(array);
	     * // => ['a', 'a', 'a']
	     *
	     * _.fill(Array(3), 2);
	     * // => [2, 2, 2]
	     *
	     * _.fill([4, 6, 8], '*', 1, 2);
	     * // => [4, '*', 8]
	     */
	    function fill(array, value, start, end) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
	        start = 0;
	        end = length;
	      }
	      return baseFill(array, value, start, end);
	    }
	
	    /**
	     * This method is like `_.find` except that it returns the index of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to search.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.findIndex(users, function(chr) {
	     *   return chr.user == 'barney';
	     * });
	     * // => 0
	     *
	     * // using the `_.matches` callback shorthand
	     * _.findIndex(users, { 'user': 'fred', 'active': false });
	     * // => 1
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.findIndex(users, 'active', false);
	     * // => 0
	     *
	     * // using the `_.property` callback shorthand
	     * _.findIndex(users, 'active');
	     * // => 2
	     */
	    var findIndex = createFindIndex();
	
	    /**
	     * This method is like `_.findIndex` except that it iterates over elements
	     * of `collection` from right to left.
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to search.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.findLastIndex(users, function(chr) {
	     *   return chr.user == 'pebbles';
	     * });
	     * // => 2
	     *
	     * // using the `_.matches` callback shorthand
	     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
	     * // => 0
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.findLastIndex(users, 'active', false);
	     * // => 2
	     *
	     * // using the `_.property` callback shorthand
	     * _.findLastIndex(users, 'active');
	     * // => 0
	     */
	    var findLastIndex = createFindIndex(true);
	
	    /**
	     * Gets the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @alias head
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the first element of `array`.
	     * @example
	     *
	     * _.first([1, 2, 3]);
	     * // => 1
	     *
	     * _.first([]);
	     * // => undefined
	     */
	    function first(array) {
	      return array ? array[0] : undefined;
	    }
	
	    /**
	     * Flattens a nested array. If `isDeep` is `true` the array is recursively
	     * flattened, otherwise it is only flattened a single level.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @param {boolean} [isDeep] Specify a deep flatten.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flatten([1, [2, 3, [4]]]);
	     * // => [1, 2, 3, [4]]
	     *
	     * // using `isDeep`
	     * _.flatten([1, [2, 3, [4]]], true);
	     * // => [1, 2, 3, 4]
	     */
	    function flatten(array, isDeep, guard) {
	      var length = array ? array.length : 0;
	      if (guard && isIterateeCall(array, isDeep, guard)) {
	        isDeep = false;
	      }
	      return length ? baseFlatten(array, isDeep) : [];
	    }
	
	    /**
	     * Recursively flattens a nested array.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to recursively flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flattenDeep([1, [2, 3, [4]]]);
	     * // => [1, 2, 3, 4]
	     */
	    function flattenDeep(array) {
	      var length = array ? array.length : 0;
	      return length ? baseFlatten(array, true) : [];
	    }
	
	    /**
	     * Gets the index at which the first occurrence of `value` is found in `array`
	     * using [`SameValueZero`](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-samevaluezero)
	     * for equality comparisons. If `fromIndex` is negative, it is used as the offset
	     * from the end of `array`. If `array` is sorted providing `true` for `fromIndex`
	     * performs a faster binary search.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to search.
	     * @param {*} value The value to search for.
	     * @param {boolean|number} [fromIndex=0] The index to search from or `true`
	     *  to perform a binary search on a sorted array.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.indexOf([1, 2, 1, 2], 2);
	     * // => 1
	     *
	     * // using `fromIndex`
	     * _.indexOf([1, 2, 1, 2], 2, 2);
	     * // => 3
	     *
	     * // performing a binary search
	     * _.indexOf([1, 1, 2, 2], 2, true);
	     * // => 2
	     */
	    function indexOf(array, value, fromIndex) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return -1;
	      }
	      if (typeof fromIndex == 'number') {
	        fromIndex = fromIndex < 0 ? nativeMax(length + fromIndex, 0) : fromIndex;
	      } else if (fromIndex) {
	        var index = binaryIndex(array, value),
	            other = array[index];
	
	        if (value === value ? (value === other) : (other !== other)) {
	          return index;
	        }
	        return -1;
	      }
	      return baseIndexOf(array, value, fromIndex || 0);
	    }
	
	    /**
	     * Gets all but the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.initial([1, 2, 3]);
	     * // => [1, 2]
	     */
	    function initial(array) {
	      return dropRight(array, 1);
	    }
	
	    /**
	     * Creates an array of unique values that are included in all of the provided
	     * arrays using [`SameValueZero`](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of shared values.
	     * @example
	     * _.intersection([1, 2], [4, 2], [2, 1]);
	     * // => [2]
	     */
	    var intersection = restParam(function(arrays) {
	      var othLength = arrays.length,
	          othIndex = othLength,
	          caches = Array(length),
	          indexOf = getIndexOf(),
	          isCommon = indexOf == baseIndexOf,
	          result = [];
	
	      while (othIndex--) {
	        var value = arrays[othIndex] = isArrayLike(value = arrays[othIndex]) ? value : [];
	        caches[othIndex] = (isCommon && value.length >= 120) ? createCache(othIndex && value) : null;
	      }
	      var array = arrays[0],
	          index = -1,
	          length = array ? array.length : 0,
	          seen = caches[0];
	
	      outer:
	      while (++index < length) {
	        value = array[index];
	        if ((seen ? cacheIndexOf(seen, value) : indexOf(result, value, 0)) < 0) {
	          var othIndex = othLength;
	          while (--othIndex) {
	            var cache = caches[othIndex];
	            if ((cache ? cacheIndexOf(cache, value) : indexOf(arrays[othIndex], value, 0)) < 0) {
	              continue outer;
	            }
	          }
	          if (seen) {
	            seen.push(value);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    });
	
	    /**
	     * Gets the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the last element of `array`.
	     * @example
	     *
	     * _.last([1, 2, 3]);
	     * // => 3
	     */
	    function last(array) {
	      var length = array ? array.length : 0;
	      return length ? array[length - 1] : undefined;
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it iterates over elements of
	     * `array` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to search.
	     * @param {*} value The value to search for.
	     * @param {boolean|number} [fromIndex=array.length-1] The index to search from
	     *  or `true` to perform a binary search on a sorted array.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.lastIndexOf([1, 2, 1, 2], 2);
	     * // => 3
	     *
	     * // using `fromIndex`
	     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
	     * // => 1
	     *
	     * // performing a binary search
	     * _.lastIndexOf([1, 1, 2, 2], 2, true);
	     * // => 3
	     */
	    function lastIndexOf(array, value, fromIndex) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return -1;
	      }
	      var index = length;
	      if (typeof fromIndex == 'number') {
	        index = (fromIndex < 0 ? nativeMax(length + fromIndex, 0) : nativeMin(fromIndex || 0, length - 1)) + 1;
	      } else if (fromIndex) {
	        index = binaryIndex(array, value, true) - 1;
	        var other = array[index];
	        if (value === value ? (value === other) : (other !== other)) {
	          return index;
	        }
	        return -1;
	      }
	      if (value !== value) {
	        return indexOfNaN(array, index, true);
	      }
	      while (index--) {
	        if (array[index] === value) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * Removes all provided values from `array` using
	     * [`SameValueZero`](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.without`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...*} [values] The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3, 1, 2, 3];
	     *
	     * _.pull(array, 2, 3);
	     * console.log(array);
	     * // => [1, 1]
	     */
	    function pull() {
	      var args = arguments,
	          array = args[0];
	
	      if (!(array && array.length)) {
	        return array;
	      }
	      var index = 0,
	          indexOf = getIndexOf(),
	          length = args.length;
	
	      while (++index < length) {
	        var fromIndex = 0,
	            value = args[index];
	
	        while ((fromIndex = indexOf(array, value, fromIndex)) > -1) {
	          splice.call(array, fromIndex, 1);
	        }
	      }
	      return array;
	    }
	
	    /**
	     * Removes elements from `array` corresponding to the given indexes and returns
	     * an array of the removed elements. Indexes may be specified as an array of
	     * indexes or as individual arguments.
	     *
	     * **Note:** Unlike `_.at`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...(number|number[])} [indexes] The indexes of elements to remove,
	     *  specified as individual indexes or arrays of indexes.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = [5, 10, 15, 20];
	     * var evens = _.pullAt(array, 1, 3);
	     *
	     * console.log(array);
	     * // => [5, 15]
	     *
	     * console.log(evens);
	     * // => [10, 20]
	     */
	    var pullAt = restParam(function(array, indexes) {
	      indexes = baseFlatten(indexes);
	
	      var result = baseAt(array, indexes);
	      basePullAt(array, indexes.sort(baseCompareAscending));
	      return result;
	    });
	
	    /**
	     * Removes all elements from `array` that `predicate` returns truthy for
	     * and returns an array of the removed elements. The predicate is bound to
	     * `thisArg` and invoked with three arguments: (value, index, array).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * **Note:** Unlike `_.filter`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = [1, 2, 3, 4];
	     * var evens = _.remove(array, function(n) {
	     *   return n % 2 == 0;
	     * });
	     *
	     * console.log(array);
	     * // => [1, 3]
	     *
	     * console.log(evens);
	     * // => [2, 4]
	     */
	    function remove(array, predicate, thisArg) {
	      var result = [];
	      if (!(array && array.length)) {
	        return result;
	      }
	      var index = -1,
	          indexes = [],
	          length = array.length;
	
	      predicate = getCallback(predicate, thisArg, 3);
	      while (++index < length) {
	        var value = array[index];
	        if (predicate(value, index, array)) {
	          result.push(value);
	          indexes.push(index);
	        }
	      }
	      basePullAt(array, indexes);
	      return result;
	    }
	
	    /**
	     * Gets all but the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @alias tail
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.rest([1, 2, 3]);
	     * // => [2, 3]
	     */
	    function rest(array) {
	      return drop(array, 1);
	    }
	
	    /**
	     * Creates a slice of `array` from `start` up to, but not including, `end`.
	     *
	     * **Note:** This method is used instead of `Array#slice` to support node
	     * lists in IE < 9 and to ensure dense arrays are returned.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function slice(array, start, end) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
	        start = 0;
	        end = length;
	      }
	      return baseSlice(array, start, end);
	    }
	
	    /**
	     * Uses a binary search to determine the lowest index at which `value` should
	     * be inserted into `array` in order to maintain its sort order. If an iteratee
	     * function is provided it is invoked for `value` and each element of `array`
	     * to compute their sort ranking. The iteratee is bound to `thisArg` and
	     * invoked with one argument; (value).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedIndex([30, 50], 40);
	     * // => 1
	     *
	     * _.sortedIndex([4, 4, 5, 5], 5);
	     * // => 2
	     *
	     * var dict = { 'data': { 'thirty': 30, 'forty': 40, 'fifty': 50 } };
	     *
	     * // using an iteratee function
	     * _.sortedIndex(['thirty', 'fifty'], 'forty', function(word) {
	     *   return this.data[word];
	     * }, dict);
	     * // => 1
	     *
	     * // using the `_.property` callback shorthand
	     * _.sortedIndex([{ 'x': 30 }, { 'x': 50 }], { 'x': 40 }, 'x');
	     * // => 1
	     */
	    var sortedIndex = createSortedIndex();
	
	    /**
	     * This method is like `_.sortedIndex` except that it returns the highest
	     * index at which `value` should be inserted into `array` in order to
	     * maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedLastIndex([4, 4, 5, 5], 5);
	     * // => 4
	     */
	    var sortedLastIndex = createSortedIndex(true);
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.take([1, 2, 3]);
	     * // => [1]
	     *
	     * _.take([1, 2, 3], 2);
	     * // => [1, 2]
	     *
	     * _.take([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.take([1, 2, 3], 0);
	     * // => []
	     */
	    function take(array, n, guard) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (guard ? isIterateeCall(array, n, guard) : n == null) {
	        n = 1;
	      }
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the end.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeRight([1, 2, 3]);
	     * // => [3]
	     *
	     * _.takeRight([1, 2, 3], 2);
	     * // => [2, 3]
	     *
	     * _.takeRight([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.takeRight([1, 2, 3], 0);
	     * // => []
	     */
	    function takeRight(array, n, guard) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (guard ? isIterateeCall(array, n, guard) : n == null) {
	        n = 1;
	      }
	      n = length - (+n || 0);
	      return baseSlice(array, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the end. Elements are
	     * taken until `predicate` returns falsey. The predicate is bound to `thisArg`
	     * and invoked with three arguments: (value, index, array).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeRightWhile([1, 2, 3], function(n) {
	     *   return n > 1;
	     * });
	     * // => [2, 3]
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.pluck(_.takeRightWhile(users, { 'user': 'pebbles', 'active': false }), 'user');
	     * // => ['pebbles']
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.pluck(_.takeRightWhile(users, 'active', false), 'user');
	     * // => ['fred', 'pebbles']
	     *
	     * // using the `_.property` callback shorthand
	     * _.pluck(_.takeRightWhile(users, 'active'), 'user');
	     * // => []
	     */
	    function takeRightWhile(array, predicate, thisArg) {
	      return (array && array.length)
	        ? baseWhile(array, getCallback(predicate, thisArg, 3), false, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the beginning. Elements
	     * are taken until `predicate` returns falsey. The predicate is bound to
	     * `thisArg` and invoked with three arguments: (value, index, array).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeWhile([1, 2, 3], function(n) {
	     *   return n < 3;
	     * });
	     * // => [1, 2]
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false},
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.pluck(_.takeWhile(users, { 'user': 'barney', 'active': false }), 'user');
	     * // => ['barney']
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.pluck(_.takeWhile(users, 'active', false), 'user');
	     * // => ['barney', 'fred']
	     *
	     * // using the `_.property` callback shorthand
	     * _.pluck(_.takeWhile(users, 'active'), 'user');
	     * // => []
	     */
	    function takeWhile(array, predicate, thisArg) {
	      return (array && array.length)
	        ? baseWhile(array, getCallback(predicate, thisArg, 3))
	        : [];
	    }
	
	    /**
	     * Creates an array of unique values, in order, from all of the provided arrays
	     * using [`SameValueZero`](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.union([1, 2], [4, 2], [2, 1]);
	     * // => [1, 2, 4]
	     */
	    var union = restParam(function(arrays) {
	      return baseUniq(baseFlatten(arrays, false, true));
	    });
	
	    /**
	     * Creates a duplicate-free version of an array, using
	     * [`SameValueZero`](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-samevaluezero)
	     * for equality comparisons, in which only the first occurence of each element
	     * is kept. Providing `true` for `isSorted` performs a faster search algorithm
	     * for sorted arrays. If an iteratee function is provided it is invoked for
	     * each element in the array to generate the criterion by which uniqueness
	     * is computed. The `iteratee` is bound to `thisArg` and invoked with three
	     * arguments: (value, index, array).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @alias unique
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {boolean} [isSorted] Specify the array is sorted.
	     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array} Returns the new duplicate-value-free array.
	     * @example
	     *
	     * _.uniq([2, 1, 2]);
	     * // => [2, 1]
	     *
	     * // using `isSorted`
	     * _.uniq([1, 1, 2], true);
	     * // => [1, 2]
	     *
	     * // using an iteratee function
	     * _.uniq([1, 2.5, 1.5, 2], function(n) {
	     *   return this.floor(n);
	     * }, Math);
	     * // => [1, 2.5]
	     *
	     * // using the `_.property` callback shorthand
	     * _.uniq([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    function uniq(array, isSorted, iteratee, thisArg) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (isSorted != null && typeof isSorted != 'boolean') {
	        thisArg = iteratee;
	        iteratee = isIterateeCall(array, isSorted, thisArg) ? null : isSorted;
	        isSorted = false;
	      }
	      var callback = getCallback();
	      if (!(iteratee == null && callback === baseCallback)) {
	        iteratee = callback(iteratee, thisArg, 3);
	      }
	      return (isSorted && getIndexOf() == baseIndexOf)
	        ? sortedUniq(array, iteratee)
	        : baseUniq(array, iteratee);
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts an array of grouped
	     * elements and creates an array regrouping the elements to their pre-zip
	     * configuration.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip(['fred', 'barney'], [30, 40], [true, false]);
	     * // => [['fred', 30, true], ['barney', 40, false]]
	     *
	     * _.unzip(zipped);
	     * // => [['fred', 'barney'], [30, 40], [true, false]]
	     */
	    function unzip(array) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var index = -1,
	          length = 0;
	
	      array = arrayFilter(array, function(group) {
	        if (isArrayLike(group)) {
	          length = nativeMax(group.length, length);
	          return true;
	        }
	      });
	      var result = Array(length);
	      while (++index < length) {
	        result[index] = arrayMap(array, baseProperty(index));
	      }
	      return result;
	    }
	
	    /**
	     * This method is like `_.unzip` except that it accepts an iteratee to specify
	     * how regrouped values should be combined. The `iteratee` is bound to `thisArg`
	     * and invoked with four arguments: (accumulator, value, index, group).
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @param {Function} [iteratee] The function to combine regrouped values.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
	     * // => [[1, 10, 100], [2, 20, 200]]
	     *
	     * _.unzipWith(zipped, _.add);
	     * // => [3, 30, 300]
	     */
	    function unzipWith(array, iteratee, thisArg) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      var result = unzip(array);
	      if (iteratee == null) {
	        return result;
	      }
	      iteratee = bindCallback(iteratee, thisArg, 4);
	      return arrayMap(result, function(group) {
	        return arrayReduce(group, iteratee, undefined, true);
	      });
	    }
	
	    /**
	     * Creates an array excluding all provided values using
	     * [`SameValueZero`](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to filter.
	     * @param {...*} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.without([1, 2, 1, 3], 1, 2);
	     * // => [3]
	     */
	    var without = restParam(function(array, values) {
	      return isArrayLike(array)
	        ? baseDifference(array, values)
	        : [];
	    });
	
	    /**
	     * Creates an array of unique values that is the [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
	     * of the provided arrays.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of values.
	     * @example
	     *
	     * _.xor([1, 2], [4, 2]);
	     * // => [1, 4]
	     */
	    function xor() {
	      var index = -1,
	          length = arguments.length;
	
	      while (++index < length) {
	        var array = arguments[index];
	        if (isArrayLike(array)) {
	          var result = result
	            ? baseDifference(result, array).concat(baseDifference(array, result))
	            : array;
	        }
	      }
	      return result ? baseUniq(result) : [];
	    }
	
	    /**
	     * Creates an array of grouped elements, the first of which contains the first
	     * elements of the given arrays, the second of which contains the second elements
	     * of the given arrays, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zip(['fred', 'barney'], [30, 40], [true, false]);
	     * // => [['fred', 30, true], ['barney', 40, false]]
	     */
	    var zip = restParam(unzip);
	
	    /**
	     * The inverse of `_.pairs`; this method returns an object composed from arrays
	     * of property names and values. Provide either a single two dimensional array,
	     * e.g. `[[key1, value1], [key2, value2]]` or two arrays, one of property names
	     * and one of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @alias object
	     * @category Array
	     * @param {Array} props The property names.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObject([['fred', 30], ['barney', 40]]);
	     * // => { 'fred': 30, 'barney': 40 }
	     *
	     * _.zipObject(['fred', 'barney'], [30, 40]);
	     * // => { 'fred': 30, 'barney': 40 }
	     */
	    function zipObject(props, values) {
	      var index = -1,
	          length = props ? props.length : 0,
	          result = {};
	
	      if (length && !values && !isArray(props[0])) {
	        values = [];
	      }
	      while (++index < length) {
	        var key = props[index];
	        if (values) {
	          result[key] = values[index];
	        } else if (key) {
	          result[key[0]] = key[1];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts an iteratee to specify
	     * how grouped values should be combined. The `iteratee` is bound to `thisArg`
	     * and invoked with four arguments: (accumulator, value, index, group).
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @param {Function} [iteratee] The function to combine grouped values.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zipWith([1, 2], [10, 20], [100, 200], _.add);
	     * // => [111, 222]
	     */
	    var zipWith = restParam(function(arrays) {
	      var length = arrays.length,
	          iteratee = length > 2 ? arrays[length - 2] : undefined,
	          thisArg = length > 1 ? arrays[length - 1] : undefined;
	
	      if (length > 2 && typeof iteratee == 'function') {
	        length -= 2;
	      } else {
	        iteratee = (length > 1 && typeof thisArg == 'function') ? (--length, thisArg) : undefined;
	        thisArg = undefined;
	      }
	      arrays.length = length;
	      return unzipWith(arrays, iteratee, thisArg);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` object that wraps `value` with explicit method
	     * chaining enabled.
	     *
	     * @static
	     * @memberOf _
	     * @category Chain
	     * @param {*} value The value to wrap.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36 },
	     *   { 'user': 'fred',    'age': 40 },
	     *   { 'user': 'pebbles', 'age': 1 }
	     * ];
	     *
	     * var youngest = _.chain(users)
	     *   .sortBy('age')
	     *   .map(function(chr) {
	     *     return chr.user + ' is ' + chr.age;
	     *   })
	     *   .first()
	     *   .value();
	     * // => 'pebbles is 1'
	     */
	    function chain(value) {
	      var result = lodash(value);
	      result.__chain__ = true;
	      return result;
	    }
	
	    /**
	     * This method invokes `interceptor` and returns `value`. The interceptor is
	     * bound to `thisArg` and invoked with one argument; (value). The purpose of
	     * this method is to "tap into" a method chain in order to perform operations
	     * on intermediate results within the chain.
	     *
	     * @static
	     * @memberOf _
	     * @category Chain
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @param {*} [thisArg] The `this` binding of `interceptor`.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * _([1, 2, 3])
	     *  .tap(function(array) {
	     *    array.pop();
	     *  })
	     *  .reverse()
	     *  .value();
	     * // => [2, 1]
	     */
	    function tap(value, interceptor, thisArg) {
	      interceptor.call(thisArg, value);
	      return value;
	    }
	
	    /**
	     * This method is like `_.tap` except that it returns the result of `interceptor`.
	     *
	     * @static
	     * @memberOf _
	     * @category Chain
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @param {*} [thisArg] The `this` binding of `interceptor`.
	     * @returns {*} Returns the result of `interceptor`.
	     * @example
	     *
	     * _('  abc  ')
	     *  .chain()
	     *  .trim()
	     *  .thru(function(value) {
	     *    return [value];
	     *  })
	     *  .value();
	     * // => ['abc']
	     */
	    function thru(value, interceptor, thisArg) {
	      return interceptor.call(thisArg, value);
	    }
	
	    /**
	     * Enables explicit method chaining on the wrapper object.
	     *
	     * @name chain
	     * @memberOf _
	     * @category Chain
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * // without explicit chaining
	     * _(users).first();
	     * // => { 'user': 'barney', 'age': 36 }
	     *
	     * // with explicit chaining
	     * _(users).chain()
	     *   .first()
	     *   .pick('user')
	     *   .value();
	     * // => { 'user': 'barney' }
	     */
	    function wrapperChain() {
	      return chain(this);
	    }
	
	    /**
	     * Executes the chained sequence and returns the wrapped result.
	     *
	     * @name commit
	     * @memberOf _
	     * @category Chain
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2];
	     * var wrapper = _(array).push(3);
	     *
	     * console.log(array);
	     * // => [1, 2]
	     *
	     * wrapper = wrapper.commit();
	     * console.log(array);
	     * // => [1, 2, 3]
	     *
	     * wrapper.last();
	     * // => 3
	     *
	     * console.log(array);
	     * // => [1, 2, 3]
	     */
	    function wrapperCommit() {
	      return new LodashWrapper(this.value(), this.__chain__);
	    }
	
	    /**
	     * Creates a clone of the chained sequence planting `value` as the wrapped value.
	     *
	     * @name plant
	     * @memberOf _
	     * @category Chain
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2];
	     * var wrapper = _(array).map(function(value) {
	     *   return Math.pow(value, 2);
	     * });
	     *
	     * var other = [3, 4];
	     * var otherWrapper = wrapper.plant(other);
	     *
	     * otherWrapper.value();
	     * // => [9, 16]
	     *
	     * wrapper.value();
	     * // => [1, 4]
	     */
	    function wrapperPlant(value) {
	      var result,
	          parent = this;
	
	      while (parent instanceof baseLodash) {
	        var clone = wrapperClone(parent);
	        if (result) {
	          previous.__wrapped__ = clone;
	        } else {
	          result = clone;
	        }
	        var previous = clone;
	        parent = parent.__wrapped__;
	      }
	      previous.__wrapped__ = value;
	      return result;
	    }
	
	    /**
	     * Reverses the wrapped array so the first element becomes the last, the
	     * second element becomes the second to last, and so on.
	     *
	     * **Note:** This method mutates the wrapped array.
	     *
	     * @name reverse
	     * @memberOf _
	     * @category Chain
	     * @returns {Object} Returns the new reversed `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _(array).reverse().value()
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function wrapperReverse() {
	      var value = this.__wrapped__;
	      if (value instanceof LazyWrapper) {
	        if (this.__actions__.length) {
	          value = new LazyWrapper(this);
	        }
	        return new LodashWrapper(value.reverse(), this.__chain__);
	      }
	      return this.thru(function(value) {
	        return value.reverse();
	      });
	    }
	
	    /**
	     * Produces the result of coercing the unwrapped value to a string.
	     *
	     * @name toString
	     * @memberOf _
	     * @category Chain
	     * @returns {string} Returns the coerced string value.
	     * @example
	     *
	     * _([1, 2, 3]).toString();
	     * // => '1,2,3'
	     */
	    function wrapperToString() {
	      return (this.value() + '');
	    }
	
	    /**
	     * Executes the chained sequence to extract the unwrapped value.
	     *
	     * @name value
	     * @memberOf _
	     * @alias run, toJSON, valueOf
	     * @category Chain
	     * @returns {*} Returns the resolved unwrapped value.
	     * @example
	     *
	     * _([1, 2, 3]).value();
	     * // => [1, 2, 3]
	     */
	    function wrapperValue() {
	      return baseWrapperValue(this.__wrapped__, this.__actions__);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of elements corresponding to the given keys, or indexes,
	     * of `collection`. Keys may be specified as individual arguments or as arrays
	     * of keys.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {...(number|number[]|string|string[])} [props] The property names
	     *  or indexes of elements to pick, specified individually or in arrays.
	     * @returns {Array} Returns the new array of picked elements.
	     * @example
	     *
	     * _.at(['a', 'b', 'c'], [0, 2]);
	     * // => ['a', 'c']
	     *
	     * _.at(['barney', 'fred', 'pebbles'], 0, 2);
	     * // => ['barney', 'pebbles']
	     */
	    var at = restParam(function(collection, props) {
	      return baseAt(collection, baseFlatten(props));
	    });
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` through `iteratee`. The corresponding value
	     * of each key is the number of times the key was returned by `iteratee`.
	     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.countBy([4.3, 6.1, 6.4], function(n) {
	     *   return Math.floor(n);
	     * });
	     * // => { '4': 1, '6': 2 }
	     *
	     * _.countBy([4.3, 6.1, 6.4], function(n) {
	     *   return this.floor(n);
	     * }, Math);
	     * // => { '4': 1, '6': 2 }
	     *
	     * _.countBy(['one', 'two', 'three'], 'length');
	     * // => { '3': 2, '5': 1 }
	     */
	    var countBy = createAggregator(function(result, value, key) {
	      hasOwnProperty.call(result, key) ? ++result[key] : (result[key] = 1);
	    });
	
	    /**
	     * Checks if `predicate` returns truthy for **all** elements of `collection`.
	     * The predicate is bound to `thisArg` and invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @alias all
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.every([true, 1, null, 'yes'], Boolean);
	     * // => false
	     *
	     * var users = [
	     *   { 'user': 'barney', 'active': false },
	     *   { 'user': 'fred',   'active': false }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.every(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.every(users, 'active', false);
	     * // => true
	     *
	     * // using the `_.property` callback shorthand
	     * _.every(users, 'active');
	     * // => false
	     */
	    function every(collection, predicate, thisArg) {
	      var func = isArray(collection) ? arrayEvery : baseEvery;
	      if (thisArg && isIterateeCall(collection, predicate, thisArg)) {
	        predicate = null;
	      }
	      if (typeof predicate != 'function' || thisArg !== undefined) {
	        predicate = getCallback(predicate, thisArg, 3);
	      }
	      return func(collection, predicate);
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning an array of all elements
	     * `predicate` returns truthy for. The predicate is bound to `thisArg` and
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @alias select
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the new filtered array.
	     * @example
	     *
	     * _.filter([4, 5, 6], function(n) {
	     *   return n % 2 == 0;
	     * });
	     * // => [4, 6]
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.pluck(_.filter(users, { 'age': 36, 'active': true }), 'user');
	     * // => ['barney']
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.pluck(_.filter(users, 'active', false), 'user');
	     * // => ['fred']
	     *
	     * // using the `_.property` callback shorthand
	     * _.pluck(_.filter(users, 'active'), 'user');
	     * // => ['barney']
	     */
	    function filter(collection, predicate, thisArg) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      predicate = getCallback(predicate, thisArg, 3);
	      return func(collection, predicate);
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning the first element
	     * `predicate` returns truthy for. The predicate is bound to `thisArg` and
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @alias detect
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to search.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': true },
	     *   { 'user': 'fred',    'age': 40, 'active': false },
	     *   { 'user': 'pebbles', 'age': 1,  'active': true }
	     * ];
	     *
	     * _.result(_.find(users, function(chr) {
	     *   return chr.age < 40;
	     * }), 'user');
	     * // => 'barney'
	     *
	     * // using the `_.matches` callback shorthand
	     * _.result(_.find(users, { 'age': 1, 'active': true }), 'user');
	     * // => 'pebbles'
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.result(_.find(users, 'active', false), 'user');
	     * // => 'fred'
	     *
	     * // using the `_.property` callback shorthand
	     * _.result(_.find(users, 'active'), 'user');
	     * // => 'barney'
	     */
	    var find = createFind(baseEach);
	
	    /**
	     * This method is like `_.find` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to search.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * _.findLast([1, 2, 3, 4], function(n) {
	     *   return n % 2 == 1;
	     * });
	     * // => 3
	     */
	    var findLast = createFind(baseEachRight, true);
	
	    /**
	     * Performs a deep comparison between each element in `collection` and the
	     * source object, returning the first element that has equivalent property
	     * values.
	     *
	     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
	     * numbers, `Object` objects, regexes, and strings. Objects are compared by
	     * their own, not inherited, enumerable properties. For comparing a single
	     * own or inherited property value see `_.matchesProperty`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to search.
	     * @param {Object} source The object of property values to match.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * _.result(_.findWhere(users, { 'age': 36, 'active': true }), 'user');
	     * // => 'barney'
	     *
	     * _.result(_.findWhere(users, { 'age': 40, 'active': false }), 'user');
	     * // => 'fred'
	     */
	    function findWhere(collection, source) {
	      return find(collection, baseMatches(source));
	    }
	
	    /**
	     * Iterates over elements of `collection` invoking `iteratee` for each element.
	     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
	     * (value, index|key, collection). Iteratee functions may exit iteration early
	     * by explicitly returning `false`.
	     *
	     * **Note:** As with other "Collections" methods, objects with a "length" property
	     * are iterated like arrays. To avoid this behavior `_.forIn` or `_.forOwn`
	     * may be used for object iteration.
	     *
	     * @static
	     * @memberOf _
	     * @alias each
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array|Object|string} Returns `collection`.
	     * @example
	     *
	     * _([1, 2]).forEach(function(n) {
	     *   console.log(n);
	     * }).value();
	     * // => logs each value from left to right and returns the array
	     *
	     * _.forEach({ 'a': 1, 'b': 2 }, function(n, key) {
	     *   console.log(n, key);
	     * });
	     * // => logs each value-key pair and returns the object (iteration order is not guaranteed)
	     */
	    var forEach = createForEach(arrayEach, baseEach);
	
	    /**
	     * This method is like `_.forEach` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @alias eachRight
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array|Object|string} Returns `collection`.
	     * @example
	     *
	     * _([1, 2]).forEachRight(function(n) {
	     *   console.log(n);
	     * }).value();
	     * // => logs each value from right to left and returns the array
	     */
	    var forEachRight = createForEach(arrayEachRight, baseEachRight);
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` through `iteratee`. The corresponding value
	     * of each key is an array of the elements responsible for generating the key.
	     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.groupBy([4.2, 6.1, 6.4], function(n) {
	     *   return Math.floor(n);
	     * });
	     * // => { '4': [4.2], '6': [6.1, 6.4] }
	     *
	     * _.groupBy([4.2, 6.1, 6.4], function(n) {
	     *   return this.floor(n);
	     * }, Math);
	     * // => { '4': [4.2], '6': [6.1, 6.4] }
	     *
	     * // using the `_.property` callback shorthand
	     * _.groupBy(['one', 'two', 'three'], 'length');
	     * // => { '3': ['one', 'two'], '5': ['three'] }
	     */
	    var groupBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        result[key].push(value);
	      } else {
	        result[key] = [value];
	      }
	    });
	
	    /**
	     * Checks if `value` is in `collection` using
	     * [`SameValueZero`](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-samevaluezero)
	     * for equality comparisons. If `fromIndex` is negative, it is used as the offset
	     * from the end of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @alias contains, include
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to search.
	     * @param {*} target The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.reduce`.
	     * @returns {boolean} Returns `true` if a matching element is found, else `false`.
	     * @example
	     *
	     * _.includes([1, 2, 3], 1);
	     * // => true
	     *
	     * _.includes([1, 2, 3], 1, 2);
	     * // => false
	     *
	     * _.includes({ 'user': 'fred', 'age': 40 }, 'fred');
	     * // => true
	     *
	     * _.includes('pebbles', 'eb');
	     * // => true
	     */
	    function includes(collection, target, fromIndex, guard) {
	      var length = collection ? getLength(collection) : 0;
	      if (!isLength(length)) {
	        collection = values(collection);
	        length = collection.length;
	      }
	      if (!length) {
	        return false;
	      }
	      if (typeof fromIndex != 'number' || (guard && isIterateeCall(target, fromIndex, guard))) {
	        fromIndex = 0;
	      } else {
	        fromIndex = fromIndex < 0 ? nativeMax(length + fromIndex, 0) : (fromIndex || 0);
	      }
	      return (typeof collection == 'string' || !isArray(collection) && isString(collection))
	        ? (fromIndex < length && collection.indexOf(target, fromIndex) > -1)
	        : (getIndexOf(collection, target, fromIndex) > -1);
	    }
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` through `iteratee`. The corresponding value
	     * of each key is the last element responsible for generating the key. The
	     * iteratee function is bound to `thisArg` and invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * var keyData = [
	     *   { 'dir': 'left', 'code': 97 },
	     *   { 'dir': 'right', 'code': 100 }
	     * ];
	     *
	     * _.indexBy(keyData, 'dir');
	     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
	     *
	     * _.indexBy(keyData, function(object) {
	     *   return String.fromCharCode(object.code);
	     * });
	     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
	     *
	     * _.indexBy(keyData, function(object) {
	     *   return this.fromCharCode(object.code);
	     * }, String);
	     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
	     */
	    var indexBy = createAggregator(function(result, value, key) {
	      result[key] = value;
	    });
	
	    /**
	     * Invokes the method at `path` of each element in `collection`, returning
	     * an array of the results of each invoked method. Any additional arguments
	     * are provided to each invoked method. If `methodName` is a function it is
	     * invoked for, and `this` bound to, each element in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Array|Function|string} path The path of the method to invoke or
	     *  the function invoked per iteration.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.invoke([[5, 1, 7], [3, 2, 1]], 'sort');
	     * // => [[1, 5, 7], [1, 2, 3]]
	     *
	     * _.invoke([123, 456], String.prototype.split, '');
	     * // => [['1', '2', '3'], ['4', '5', '6']]
	     */
	    var invoke = restParam(function(collection, path, args) {
	      var index = -1,
	          isFunc = typeof path == 'function',
	          isProp = isKey(path),
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value) {
	        var func = isFunc ? path : ((isProp && value != null) ? value[path] : null);
	        result[++index] = func ? func.apply(value, args) : invokePath(value, path, args);
	      });
	      return result;
	    });
	
	    /**
	     * Creates an array of values by running each element in `collection` through
	     * `iteratee`. The `iteratee` is bound to `thisArg` and invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	     *
	     * The guarded methods are:
	     * `ary`, `callback`, `chunk`, `clone`, `create`, `curry`, `curryRight`,
	     * `drop`, `dropRight`, `every`, `fill`, `flatten`, `invert`, `max`, `min`,
	     * `parseInt`, `slice`, `sortBy`, `take`, `takeRight`, `template`, `trim`,
	     * `trimLeft`, `trimRight`, `trunc`, `random`, `range`, `sample`, `some`,
	     * `sum`, `uniq`, and `words`
	     *
	     * @static
	     * @memberOf _
	     * @alias collect
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array} Returns the new mapped array.
	     * @example
	     *
	     * function timesThree(n) {
	     *   return n * 3;
	     * }
	     *
	     * _.map([1, 2], timesThree);
	     * // => [3, 6]
	     *
	     * _.map({ 'a': 1, 'b': 2 }, timesThree);
	     * // => [3, 6] (iteration order is not guaranteed)
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * // using the `_.property` callback shorthand
	     * _.map(users, 'user');
	     * // => ['barney', 'fred']
	     */
	    function map(collection, iteratee, thisArg) {
	      var func = isArray(collection) ? arrayMap : baseMap;
	      iteratee = getCallback(iteratee, thisArg, 3);
	      return func(collection, iteratee);
	    }
	
	    /**
	     * Creates an array of elements split into two groups, the first of which
	     * contains elements `predicate` returns truthy for, while the second of which
	     * contains elements `predicate` returns falsey for. The predicate is bound
	     * to `thisArg` and invoked with three arguments: (value, index|key, collection).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the array of grouped elements.
	     * @example
	     *
	     * _.partition([1, 2, 3], function(n) {
	     *   return n % 2;
	     * });
	     * // => [[1, 3], [2]]
	     *
	     * _.partition([1.2, 2.3, 3.4], function(n) {
	     *   return this.floor(n) % 2;
	     * }, Math);
	     * // => [[1.2, 3.4], [2.3]]
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': false },
	     *   { 'user': 'fred',    'age': 40, 'active': true },
	     *   { 'user': 'pebbles', 'age': 1,  'active': false }
	     * ];
	     *
	     * var mapper = function(array) {
	     *   return _.pluck(array, 'user');
	     * };
	     *
	     * // using the `_.matches` callback shorthand
	     * _.map(_.partition(users, { 'age': 1, 'active': false }), mapper);
	     * // => [['pebbles'], ['barney', 'fred']]
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.map(_.partition(users, 'active', false), mapper);
	     * // => [['barney', 'pebbles'], ['fred']]
	     *
	     * // using the `_.property` callback shorthand
	     * _.map(_.partition(users, 'active'), mapper);
	     * // => [['fred'], ['barney', 'pebbles']]
	     */
	    var partition = createAggregator(function(result, value, key) {
	      result[key ? 0 : 1].push(value);
	    }, function() { return [[], []]; });
	
	    /**
	     * Gets the property value of `path` from all elements in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Array|string} path The path of the property to pluck.
	     * @returns {Array} Returns the property values.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * _.pluck(users, 'user');
	     * // => ['barney', 'fred']
	     *
	     * var userIndex = _.indexBy(users, 'user');
	     * _.pluck(userIndex, 'age');
	     * // => [36, 40] (iteration order is not guaranteed)
	     */
	    function pluck(collection, path) {
	      return map(collection, property(path));
	    }
	
	    /**
	     * Reduces `collection` to a value which is the accumulated result of running
	     * each element in `collection` through `iteratee`, where each successive
	     * invocation is supplied the return value of the previous. If `accumulator`
	     * is not provided the first element of `collection` is used as the initial
	     * value. The `iteratee` is bound to `thisArg` and invoked with four arguments:
	     * (accumulator, value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.reduce`, `_.reduceRight`, and `_.transform`.
	     *
	     * The guarded methods are:
	     * `assign`, `defaults`, `includes`, `merge`, `sortByAll`, and `sortByOrder`
	     *
	     * @static
	     * @memberOf _
	     * @alias foldl, inject
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * _.reduce([1, 2], function(total, n) {
	     *   return total + n;
	     * });
	     * // => 3
	     *
	     * _.reduce({ 'a': 1, 'b': 2 }, function(result, n, key) {
	     *   result[key] = n * 3;
	     *   return result;
	     * }, {});
	     * // => { 'a': 3, 'b': 6 } (iteration order is not guaranteed)
	     */
	    var reduce = createReduce(arrayReduce, baseEach);
	
	    /**
	     * This method is like `_.reduce` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @alias foldr
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * var array = [[0, 1], [2, 3], [4, 5]];
	     *
	     * _.reduceRight(array, function(flattened, other) {
	     *   return flattened.concat(other);
	     * }, []);
	     * // => [4, 5, 2, 3, 0, 1]
	     */
	    var reduceRight = createReduce(arrayReduceRight, baseEachRight);
	
	    /**
	     * The opposite of `_.filter`; this method returns the elements of `collection`
	     * that `predicate` does **not** return truthy for.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the new filtered array.
	     * @example
	     *
	     * _.reject([1, 2, 3, 4], function(n) {
	     *   return n % 2 == 0;
	     * });
	     * // => [1, 3]
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': true }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.pluck(_.reject(users, { 'age': 40, 'active': true }), 'user');
	     * // => ['barney']
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.pluck(_.reject(users, 'active', false), 'user');
	     * // => ['fred']
	     *
	     * // using the `_.property` callback shorthand
	     * _.pluck(_.reject(users, 'active'), 'user');
	     * // => ['barney']
	     */
	    function reject(collection, predicate, thisArg) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      predicate = getCallback(predicate, thisArg, 3);
	      return func(collection, function(value, index, collection) {
	        return !predicate(value, index, collection);
	      });
	    }
	
	    /**
	     * Gets a random element or `n` random elements from a collection.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to sample.
	     * @param {number} [n] The number of elements to sample.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {*} Returns the random sample(s).
	     * @example
	     *
	     * _.sample([1, 2, 3, 4]);
	     * // => 2
	     *
	     * _.sample([1, 2, 3, 4], 2);
	     * // => [3, 1]
	     */
	    function sample(collection, n, guard) {
	      if (guard ? isIterateeCall(collection, n, guard) : n == null) {
	        collection = toIterable(collection);
	        var length = collection.length;
	        return length > 0 ? collection[baseRandom(0, length - 1)] : undefined;
	      }
	      var index = -1,
	          result = toArray(collection),
	          length = result.length,
	          lastIndex = length - 1;
	
	      n = nativeMin(n < 0 ? 0 : (+n || 0), length);
	      while (++index < n) {
	        var rand = baseRandom(index, lastIndex),
	            value = result[rand];
	
	        result[rand] = result[index];
	        result[index] = value;
	      }
	      result.length = n;
	      return result;
	    }
	
	    /**
	     * Creates an array of shuffled values, using a version of the
	     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     * @example
	     *
	     * _.shuffle([1, 2, 3, 4]);
	     * // => [4, 1, 3, 2]
	     */
	    function shuffle(collection) {
	      return sample(collection, POSITIVE_INFINITY);
	    }
	
	    /**
	     * Gets the size of `collection` by returning its length for array-like
	     * values or the number of own enumerable properties for objects.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @returns {number} Returns the size of `collection`.
	     * @example
	     *
	     * _.size([1, 2, 3]);
	     * // => 3
	     *
	     * _.size({ 'a': 1, 'b': 2 });
	     * // => 2
	     *
	     * _.size('pebbles');
	     * // => 7
	     */
	    function size(collection) {
	      var length = collection ? getLength(collection) : 0;
	      return isLength(length) ? length : keys(collection).length;
	    }
	
	    /**
	     * Checks if `predicate` returns truthy for **any** element of `collection`.
	     * The function returns as soon as it finds a passing value and does not iterate
	     * over the entire collection. The predicate is bound to `thisArg` and invoked
	     * with three arguments: (value, index|key, collection).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @alias any
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.some([null, 0, 'yes', false], Boolean);
	     * // => true
	     *
	     * var users = [
	     *   { 'user': 'barney', 'active': true },
	     *   { 'user': 'fred',   'active': false }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.some(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.some(users, 'active', false);
	     * // => true
	     *
	     * // using the `_.property` callback shorthand
	     * _.some(users, 'active');
	     * // => true
	     */
	    function some(collection, predicate, thisArg) {
	      var func = isArray(collection) ? arraySome : baseSome;
	      if (thisArg && isIterateeCall(collection, predicate, thisArg)) {
	        predicate = null;
	      }
	      if (typeof predicate != 'function' || thisArg !== undefined) {
	        predicate = getCallback(predicate, thisArg, 3);
	      }
	      return func(collection, predicate);
	    }
	
	    /**
	     * Creates an array of elements, sorted in ascending order by the results of
	     * running each element in a collection through `iteratee`. This method performs
	     * a stable sort, that is, it preserves the original sort order of equal elements.
	     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * _.sortBy([1, 2, 3], function(n) {
	     *   return Math.sin(n);
	     * });
	     * // => [3, 1, 2]
	     *
	     * _.sortBy([1, 2, 3], function(n) {
	     *   return this.sin(n);
	     * }, Math);
	     * // => [3, 1, 2]
	     *
	     * var users = [
	     *   { 'user': 'fred' },
	     *   { 'user': 'pebbles' },
	     *   { 'user': 'barney' }
	     * ];
	     *
	     * // using the `_.property` callback shorthand
	     * _.pluck(_.sortBy(users, 'user'), 'user');
	     * // => ['barney', 'fred', 'pebbles']
	     */
	    function sortBy(collection, iteratee, thisArg) {
	      if (collection == null) {
	        return [];
	      }
	      if (thisArg && isIterateeCall(collection, iteratee, thisArg)) {
	        iteratee = null;
	      }
	      var index = -1;
	      iteratee = getCallback(iteratee, thisArg, 3);
	
	      var result = baseMap(collection, function(value, key, collection) {
	        return { 'criteria': iteratee(value, key, collection), 'index': ++index, 'value': value };
	      });
	      return baseSortBy(result, compareAscending);
	    }
	
	    /**
	     * This method is like `_.sortBy` except that it can sort by multiple iteratees
	     * or property names.
	     *
	     * If a property name is provided for an iteratee the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If an object is provided for an iteratee the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {...(Function|Function[]|Object|Object[]|string|string[])} iteratees
	     *  The iteratees to sort by, specified as individual values or arrays of values.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 42 },
	     *   { 'user': 'barney', 'age': 34 }
	     * ];
	     *
	     * _.map(_.sortByAll(users, ['user', 'age']), _.values);
	     * // => [['barney', 34], ['barney', 36], ['fred', 42], ['fred', 48]]
	     *
	     * _.map(_.sortByAll(users, 'user', function(chr) {
	     *   return Math.floor(chr.age / 10);
	     * }), _.values);
	     * // => [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 42]]
	     */
	    var sortByAll = restParam(function(collection, iteratees) {
	      if (collection == null) {
	        return [];
	      }
	      var guard = iteratees[2];
	      if (guard && isIterateeCall(iteratees[0], iteratees[1], guard)) {
	        iteratees.length = 1;
	      }
	      return baseSortByOrder(collection, baseFlatten(iteratees), []);
	    });
	
	    /**
	     * This method is like `_.sortByAll` except that it allows specifying the
	     * sort orders of the iteratees to sort by. A truthy value in `orders` will
	     * sort the corresponding property name in ascending order while a falsey
	     * value will sort it in descending order.
	     *
	     * If a property name is provided for an iteratee the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If an object is provided for an iteratee the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	     * @param {boolean[]} orders The sort orders of `iteratees`.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.reduce`.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 34 },
	     *   { 'user': 'fred',   'age': 42 },
	     *   { 'user': 'barney', 'age': 36 }
	     * ];
	     *
	     * // sort by `user` in ascending order and by `age` in descending order
	     * _.map(_.sortByOrder(users, ['user', 'age'], [true, false]), _.values);
	     * // => [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 42]]
	     */
	    function sortByOrder(collection, iteratees, orders, guard) {
	      if (collection == null) {
	        return [];
	      }
	      if (guard && isIterateeCall(iteratees, orders, guard)) {
	        orders = null;
	      }
	      if (!isArray(iteratees)) {
	        iteratees = iteratees == null ? [] : [iteratees];
	      }
	      if (!isArray(orders)) {
	        orders = orders == null ? [] : [orders];
	      }
	      return baseSortByOrder(collection, iteratees, orders);
	    }
	
	    /**
	     * Performs a deep comparison between each element in `collection` and the
	     * source object, returning an array of all elements that have equivalent
	     * property values.
	     *
	     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
	     * numbers, `Object` objects, regexes, and strings. Objects are compared by
	     * their own, not inherited, enumerable properties. For comparing a single
	     * own or inherited property value see `_.matchesProperty`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to search.
	     * @param {Object} source The object of property values to match.
	     * @returns {Array} Returns the new filtered array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false, 'pets': ['hoppy'] },
	     *   { 'user': 'fred',   'age': 40, 'active': true, 'pets': ['baby puss', 'dino'] }
	     * ];
	     *
	     * _.pluck(_.where(users, { 'age': 36, 'active': false }), 'user');
	     * // => ['barney']
	     *
	     * _.pluck(_.where(users, { 'pets': ['dino'] }), 'user');
	     * // => ['fred']
	     */
	    function where(collection, source) {
	      return filter(collection, baseMatches(source));
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Gets the number of milliseconds that have elapsed since the Unix epoch
	     * (1 January 1970 00:00:00 UTC).
	     *
	     * @static
	     * @memberOf _
	     * @category Date
	     * @example
	     *
	     * _.defer(function(stamp) {
	     *   console.log(_.now() - stamp);
	     * }, _.now());
	     * // => logs the number of milliseconds it took for the deferred function to be invoked
	     */
	    var now = nativeNow || function() {
	      return new Date().getTime();
	    };
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The opposite of `_.before`; this method creates a function that invokes
	     * `func` once it is called `n` or more times.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {number} n The number of calls before `func` is invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var saves = ['profile', 'settings'];
	     *
	     * var done = _.after(saves.length, function() {
	     *   console.log('done saving!');
	     * });
	     *
	     * _.forEach(saves, function(type) {
	     *   asyncSave({ 'type': type, 'complete': done });
	     * });
	     * // => logs 'done saving!' after the two async saves have completed
	     */
	    function after(n, func) {
	      if (typeof func != 'function') {
	        if (typeof n == 'function') {
	          var temp = n;
	          n = func;
	          func = temp;
	        } else {
	          throw new TypeError(FUNC_ERROR_TEXT);
	        }
	      }
	      n = nativeIsFinite(n = +n) ? n : 0;
	      return function() {
	        if (--n < 1) {
	          return func.apply(this, arguments);
	        }
	      };
	    }
	
	    /**
	     * Creates a function that accepts up to `n` arguments ignoring any
	     * additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @param {number} [n=func.length] The arity cap.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
	     * // => [6, 8, 10]
	     */
	    function ary(func, n, guard) {
	      if (guard && isIterateeCall(func, n, guard)) {
	        n = null;
	      }
	      n = (func && n == null) ? func.length : nativeMax(+n || 0, 0);
	      return createWrapper(func, ARY_FLAG, null, null, null, null, n);
	    }
	
	    /**
	     * Creates a function that invokes `func`, with the `this` binding and arguments
	     * of the created function, while it is called less than `n` times. Subsequent
	     * calls to the created function return the result of the last `func` invocation.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {number} n The number of calls at which `func` is no longer invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * jQuery('#add').on('click', _.before(5, addContactToList));
	     * // => allows adding up to 4 contacts to the list
	     */
	    function before(n, func) {
	      var result;
	      if (typeof func != 'function') {
	        if (typeof n == 'function') {
	          var temp = n;
	          n = func;
	          func = temp;
	        } else {
	          throw new TypeError(FUNC_ERROR_TEXT);
	        }
	      }
	      return function() {
	        if (--n > 0) {
	          result = func.apply(this, arguments);
	        }
	        if (n <= 1) {
	          func = null;
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of `thisArg`
	     * and prepends any additional `_.bind` arguments to those provided to the
	     * bound function.
	     *
	     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** Unlike native `Function#bind` this method does not set the "length"
	     * property of bound functions.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to bind.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * var greet = function(greeting, punctuation) {
	     *   return greeting + ' ' + this.user + punctuation;
	     * };
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * var bound = _.bind(greet, object, 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * // using placeholders
	     * var bound = _.bind(greet, object, _, '!');
	     * bound('hi');
	     * // => 'hi fred!'
	     */
	    var bind = restParam(function(func, thisArg, partials) {
	      var bitmask = BIND_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, bind.placeholder);
	        bitmask |= PARTIAL_FLAG;
	      }
	      return createWrapper(func, bitmask, thisArg, partials, holders);
	    });
	
	    /**
	     * Binds methods of an object to the object itself, overwriting the existing
	     * method. Method names may be specified as individual arguments or as arrays
	     * of method names. If no method names are provided all enumerable function
	     * properties, own and inherited, of `object` are bound.
	     *
	     * **Note:** This method does not set the "length" property of bound functions.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Object} object The object to bind and assign the bound methods to.
	     * @param {...(string|string[])} [methodNames] The object method names to bind,
	     *  specified as individual method names or arrays of method names.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var view = {
	     *   'label': 'docs',
	     *   'onClick': function() {
	     *     console.log('clicked ' + this.label);
	     *   }
	     * };
	     *
	     * _.bindAll(view);
	     * jQuery('#docs').on('click', view.onClick);
	     * // => logs 'clicked docs' when the element is clicked
	     */
	    var bindAll = restParam(function(object, methodNames) {
	      methodNames = methodNames.length ? baseFlatten(methodNames) : functions(object);
	
	      var index = -1,
	          length = methodNames.length;
	
	      while (++index < length) {
	        var key = methodNames[index];
	        object[key] = createWrapper(object[key], BIND_FLAG, object);
	      }
	      return object;
	    });
	
	    /**
	     * Creates a function that invokes the method at `object[key]` and prepends
	     * any additional `_.bindKey` arguments to those provided to the bound function.
	     *
	     * This method differs from `_.bind` by allowing bound functions to reference
	     * methods that may be redefined or don't yet exist.
	     * See [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
	     * for more details.
	     *
	     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Object} object The object the method belongs to.
	     * @param {string} key The key of the method.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * var object = {
	     *   'user': 'fred',
	     *   'greet': function(greeting, punctuation) {
	     *     return greeting + ' ' + this.user + punctuation;
	     *   }
	     * };
	     *
	     * var bound = _.bindKey(object, 'greet', 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * object.greet = function(greeting, punctuation) {
	     *   return greeting + 'ya ' + this.user + punctuation;
	     * };
	     *
	     * bound('!');
	     * // => 'hiya fred!'
	     *
	     * // using placeholders
	     * var bound = _.bindKey(object, 'greet', _, '!');
	     * bound('hi');
	     * // => 'hiya fred!'
	     */
	    var bindKey = restParam(function(object, key, partials) {
	      var bitmask = BIND_FLAG | BIND_KEY_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, bindKey.placeholder);
	        bitmask |= PARTIAL_FLAG;
	      }
	      return createWrapper(key, bitmask, object, partials, holders);
	    });
	
	    /**
	     * Creates a function that accepts one or more arguments of `func` that when
	     * called either invokes `func` returning its result, if all `func` arguments
	     * have been provided, or returns a function that accepts one or more of the
	     * remaining `func` arguments, and so on. The arity of `func` may be specified
	     * if `func.length` is not sufficient.
	     *
	     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method does not set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curry(abc);
	     *
	     * curried(1)(2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // using placeholders
	     * curried(1)(_, 3)(2);
	     * // => [1, 2, 3]
	     */
	    var curry = createCurry(CURRY_FLAG);
	
	    /**
	     * This method is like `_.curry` except that arguments are applied to `func`
	     * in the manner of `_.partialRight` instead of `_.partial`.
	     *
	     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method does not set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curryRight(abc);
	     *
	     * curried(3)(2)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(2, 3)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // using placeholders
	     * curried(3)(1, _)(2);
	     * // => [1, 2, 3]
	     */
	    var curryRight = createCurry(CURRY_RIGHT_FLAG);
	
	    /**
	     * Creates a debounced function that delays invoking `func` until after `wait`
	     * milliseconds have elapsed since the last time the debounced function was
	     * invoked. The debounced function comes with a `cancel` method to cancel
	     * delayed invocations. Provide an options object to indicate that `func`
	     * should be invoked on the leading and/or trailing edge of the `wait` timeout.
	     * Subsequent calls to the debounced function return the result of the last
	     * `func` invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is invoked
	     * on the trailing edge of the timeout only if the the debounced function is
	     * invoked more than once during the `wait` timeout.
	     *
	     * See [David Corbacho's article](http://drupalmotion.com/article/debounce-and-throttle-visual-explanation)
	     * for details over the differences between `_.debounce` and `_.throttle`.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to debounce.
	     * @param {number} [wait=0] The number of milliseconds to delay.
	     * @param {Object} [options] The options object.
	     * @param {boolean} [options.leading=false] Specify invoking on the leading
	     *  edge of the timeout.
	     * @param {number} [options.maxWait] The maximum time `func` is allowed to be
	     *  delayed before it is invoked.
	     * @param {boolean} [options.trailing=true] Specify invoking on the trailing
	     *  edge of the timeout.
	     * @returns {Function} Returns the new debounced function.
	     * @example
	     *
	     * // avoid costly calculations while the window size is in flux
	     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	     *
	     * // invoke `sendMail` when the click event is fired, debouncing subsequent calls
	     * jQuery('#postbox').on('click', _.debounce(sendMail, 300, {
	     *   'leading': true,
	     *   'trailing': false
	     * }));
	     *
	     * // ensure `batchLog` is invoked once after 1 second of debounced calls
	     * var source = new EventSource('/stream');
	     * jQuery(source).on('message', _.debounce(batchLog, 250, {
	     *   'maxWait': 1000
	     * }));
	     *
	     * // cancel a debounced call
	     * var todoChanges = _.debounce(batchLog, 1000);
	     * Object.observe(models.todo, todoChanges);
	     *
	     * Object.observe(models, function(changes) {
	     *   if (_.find(changes, { 'user': 'todo', 'type': 'delete'})) {
	     *     todoChanges.cancel();
	     *   }
	     * }, ['delete']);
	     *
	     * // ...at some point `models.todo` is changed
	     * models.todo.completed = true;
	     *
	     * // ...before 1 second has passed `models.todo` is deleted
	     * // which cancels the debounced `todoChanges` call
	     * delete models.todo;
	     */
	    function debounce(func, wait, options) {
	      var args,
	          maxTimeoutId,
	          result,
	          stamp,
	          thisArg,
	          timeoutId,
	          trailingCall,
	          lastCalled = 0,
	          maxWait = false,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      wait = wait < 0 ? 0 : (+wait || 0);
	      if (options === true) {
	        var leading = true;
	        trailing = false;
	      } else if (isObject(options)) {
	        leading = options.leading;
	        maxWait = 'maxWait' in options && nativeMax(+options.maxWait || 0, wait);
	        trailing = 'trailing' in options ? options.trailing : trailing;
	      }
	
	      function cancel() {
	        if (timeoutId) {
	          clearTimeout(timeoutId);
	        }
	        if (maxTimeoutId) {
	          clearTimeout(maxTimeoutId);
	        }
	        maxTimeoutId = timeoutId = trailingCall = undefined;
	      }
	
	      function delayed() {
	        var remaining = wait - (now() - stamp);
	        if (remaining <= 0 || remaining > wait) {
	          if (maxTimeoutId) {
	            clearTimeout(maxTimeoutId);
	          }
	          var isCalled = trailingCall;
	          maxTimeoutId = timeoutId = trailingCall = undefined;
	          if (isCalled) {
	            lastCalled = now();
	            result = func.apply(thisArg, args);
	            if (!timeoutId && !maxTimeoutId) {
	              args = thisArg = null;
	            }
	          }
	        } else {
	          timeoutId = setTimeout(delayed, remaining);
	        }
	      }
	
	      function maxDelayed() {
	        if (timeoutId) {
	          clearTimeout(timeoutId);
	        }
	        maxTimeoutId = timeoutId = trailingCall = undefined;
	        if (trailing || (maxWait !== wait)) {
	          lastCalled = now();
	          result = func.apply(thisArg, args);
	          if (!timeoutId && !maxTimeoutId) {
	            args = thisArg = null;
	          }
	        }
	      }
	
	      function debounced() {
	        args = arguments;
	        stamp = now();
	        thisArg = this;
	        trailingCall = trailing && (timeoutId || !leading);
	
	        if (maxWait === false) {
	          var leadingCall = leading && !timeoutId;
	        } else {
	          if (!maxTimeoutId && !leading) {
	            lastCalled = stamp;
	          }
	          var remaining = maxWait - (stamp - lastCalled),
	              isCalled = remaining <= 0 || remaining > maxWait;
	
	          if (isCalled) {
	            if (maxTimeoutId) {
	              maxTimeoutId = clearTimeout(maxTimeoutId);
	            }
	            lastCalled = stamp;
	            result = func.apply(thisArg, args);
	          }
	          else if (!maxTimeoutId) {
	            maxTimeoutId = setTimeout(maxDelayed, remaining);
	          }
	        }
	        if (isCalled && timeoutId) {
	          timeoutId = clearTimeout(timeoutId);
	        }
	        else if (!timeoutId && wait !== maxWait) {
	          timeoutId = setTimeout(delayed, wait);
	        }
	        if (leadingCall) {
	          isCalled = true;
	          result = func.apply(thisArg, args);
	        }
	        if (isCalled && !timeoutId && !maxTimeoutId) {
	          args = thisArg = null;
	        }
	        return result;
	      }
	      debounced.cancel = cancel;
	      return debounced;
	    }
	
	    /**
	     * Defers invoking the `func` until the current call stack has cleared. Any
	     * additional arguments are provided to `func` when it is invoked.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to defer.
	     * @param {...*} [args] The arguments to invoke the function with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.defer(function(text) {
	     *   console.log(text);
	     * }, 'deferred');
	     * // logs 'deferred' after one or more milliseconds
	     */
	    var defer = restParam(function(func, args) {
	      return baseDelay(func, 1, args);
	    });
	
	    /**
	     * Invokes `func` after `wait` milliseconds. Any additional arguments are
	     * provided to `func` when it is invoked.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {...*} [args] The arguments to invoke the function with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.delay(function(text) {
	     *   console.log(text);
	     * }, 1000, 'later');
	     * // => logs 'later' after one second
	     */
	    var delay = restParam(function(func, wait, args) {
	      return baseDelay(func, wait, args);
	    });
	
	    /**
	     * Creates a function that returns the result of invoking the provided
	     * functions with the `this` binding of the created function, where each
	     * successive invocation is supplied the return value of the previous.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {...Function} [funcs] Functions to invoke.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flow(_.add, square);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flow = createFlow();
	
	    /**
	     * This method is like `_.flow` except that it creates a function that
	     * invokes the provided functions from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @alias backflow, compose
	     * @category Function
	     * @param {...Function} [funcs] Functions to invoke.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flowRight(square, _.add);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flowRight = createFlow(true);
	
	    /**
	     * Creates a function that memoizes the result of `func`. If `resolver` is
	     * provided it determines the cache key for storing the result based on the
	     * arguments provided to the memoized function. By default, the first argument
	     * provided to the memoized function is coerced to a string and used as the
	     * cache key. The `func` is invoked with the `this` binding of the memoized
	     * function.
	     *
	     * **Note:** The cache is exposed as the `cache` property on the memoized
	     * function. Its creation may be customized by replacing the `_.memoize.Cache`
	     * constructor with one whose instances implement the [`Map`](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-properties-of-the-map-prototype-object)
	     * method interface of `get`, `has`, and `set`.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to have its output memoized.
	     * @param {Function} [resolver] The function to resolve the cache key.
	     * @returns {Function} Returns the new memoizing function.
	     * @example
	     *
	     * var upperCase = _.memoize(function(string) {
	     *   return string.toUpperCase();
	     * });
	     *
	     * upperCase('fred');
	     * // => 'FRED'
	     *
	     * // modifying the result cache
	     * upperCase.cache.set('fred', 'BARNEY');
	     * upperCase('fred');
	     * // => 'BARNEY'
	     *
	     * // replacing `_.memoize.Cache`
	     * var object = { 'user': 'fred' };
	     * var other = { 'user': 'barney' };
	     * var identity = _.memoize(_.identity);
	     *
	     * identity(object);
	     * // => { 'user': 'fred' }
	     * identity(other);
	     * // => { 'user': 'fred' }
	     *
	     * _.memoize.Cache = WeakMap;
	     * var identity = _.memoize(_.identity);
	     *
	     * identity(object);
	     * // => { 'user': 'fred' }
	     * identity(other);
	     * // => { 'user': 'barney' }
	     */
	    function memoize(func, resolver) {
	      if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var memoized = function() {
	        var args = arguments,
	            key = resolver ? resolver.apply(this, args) : args[0],
	            cache = memoized.cache;
	
	        if (cache.has(key)) {
	          return cache.get(key);
	        }
	        var result = func.apply(this, args);
	        memoized.cache = cache.set(key, result);
	        return result;
	      };
	      memoized.cache = new memoize.Cache;
	      return memoized;
	    }
	
	    /**
	     * Creates a function that negates the result of the predicate `func`. The
	     * `func` predicate is invoked with the `this` binding and arguments of the
	     * created function.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} predicate The predicate to negate.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function isEven(n) {
	     *   return n % 2 == 0;
	     * }
	     *
	     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
	     * // => [1, 3, 5]
	     */
	    function negate(predicate) {
	      if (typeof predicate != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return function() {
	        return !predicate.apply(this, arguments);
	      };
	    }
	
	    /**
	     * Creates a function that is restricted to invoking `func` once. Repeat calls
	     * to the function return the value of the first call. The `func` is invoked
	     * with the `this` binding and arguments of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var initialize = _.once(createApplication);
	     * initialize();
	     * initialize();
	     * // `initialize` invokes `createApplication` once
	     */
	    function once(func) {
	      return before(2, func);
	    }
	
	    /**
	     * Creates a function that invokes `func` with `partial` arguments prepended
	     * to those provided to the new function. This method is like `_.bind` except
	     * it does **not** alter the `this` binding.
	     *
	     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method does not set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * var greet = function(greeting, name) {
	     *   return greeting + ' ' + name;
	     * };
	     *
	     * var sayHelloTo = _.partial(greet, 'hello');
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     *
	     * // using placeholders
	     * var greetFred = _.partial(greet, _, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     */
	    var partial = createPartial(PARTIAL_FLAG);
	
	    /**
	     * This method is like `_.partial` except that partially applied arguments
	     * are appended to those provided to the new function.
	     *
	     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method does not set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * var greet = function(greeting, name) {
	     *   return greeting + ' ' + name;
	     * };
	     *
	     * var greetFred = _.partialRight(greet, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     *
	     * // using placeholders
	     * var sayHelloTo = _.partialRight(greet, 'hello', _);
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     */
	    var partialRight = createPartial(PARTIAL_RIGHT_FLAG);
	
	    /**
	     * Creates a function that invokes `func` with arguments arranged according
	     * to the specified indexes where the argument value at the first index is
	     * provided as the first argument, the argument value at the second index is
	     * provided as the second argument, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to rearrange arguments for.
	     * @param {...(number|number[])} indexes The arranged argument indexes,
	     *  specified as individual indexes or arrays of indexes.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var rearged = _.rearg(function(a, b, c) {
	     *   return [a, b, c];
	     * }, 2, 0, 1);
	     *
	     * rearged('b', 'c', 'a')
	     * // => ['a', 'b', 'c']
	     *
	     * var map = _.rearg(_.map, [1, 0]);
	     * map(function(n) {
	     *   return n * 3;
	     * }, [1, 2, 3]);
	     * // => [3, 6, 9]
	     */
	    var rearg = restParam(function(func, indexes) {
	      return createWrapper(func, REARG_FLAG, null, null, null, baseFlatten(indexes));
	    });
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * created function and arguments from `start` and beyond provided as an array.
	     *
	     * **Note:** This method is based on the [rest parameter](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Functions/rest_parameters).
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.restParam(function(what, names) {
	     *   return what + ' ' + _.initial(names).join(', ') +
	     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
	     * });
	     *
	     * say('hello', 'fred', 'barney', 'pebbles');
	     * // => 'hello fred, barney, & pebbles'
	     */
	    function restParam(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = nativeMax(start === undefined ? (func.length - 1) : (+start || 0), 0);
	      return function() {
	        var args = arguments,
	            index = -1,
	            length = nativeMax(args.length - start, 0),
	            rest = Array(length);
	
	        while (++index < length) {
	          rest[index] = args[start + index];
	        }
	        switch (start) {
	          case 0: return func.call(this, rest);
	          case 1: return func.call(this, args[0], rest);
	          case 2: return func.call(this, args[0], args[1], rest);
	        }
	        var otherArgs = Array(start + 1);
	        index = -1;
	        while (++index < start) {
	          otherArgs[index] = args[index];
	        }
	        otherArgs[start] = rest;
	        return func.apply(this, otherArgs);
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the created
	     * function and an array of arguments much like [`Function#apply`](https://es5.github.io/#x15.3.4.3).
	     *
	     * **Note:** This method is based on the [spread operator](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Spread_operator).
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to spread arguments over.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.spread(function(who, what) {
	     *   return who + ' says ' + what;
	     * });
	     *
	     * say(['fred', 'hello']);
	     * // => 'fred says hello'
	     *
	     * // with a Promise
	     * var numbers = Promise.all([
	     *   Promise.resolve(40),
	     *   Promise.resolve(36)
	     * ]);
	     *
	     * numbers.then(_.spread(function(x, y) {
	     *   return x + y;
	     * }));
	     * // => a Promise of 76
	     */
	    function spread(func) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return function(array) {
	        return func.apply(this, array);
	      };
	    }
	
	    /**
	     * Creates a throttled function that only invokes `func` at most once per
	     * every `wait` milliseconds. The throttled function comes with a `cancel`
	     * method to cancel delayed invocations. Provide an options object to indicate
	     * that `func` should be invoked on the leading and/or trailing edge of the
	     * `wait` timeout. Subsequent calls to the throttled function return the
	     * result of the last `func` call.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is invoked
	     * on the trailing edge of the timeout only if the the throttled function is
	     * invoked more than once during the `wait` timeout.
	     *
	     * See [David Corbacho's article](http://drupalmotion.com/article/debounce-and-throttle-visual-explanation)
	     * for details over the differences between `_.throttle` and `_.debounce`.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to throttle.
	     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	     * @param {Object} [options] The options object.
	     * @param {boolean} [options.leading=true] Specify invoking on the leading
	     *  edge of the timeout.
	     * @param {boolean} [options.trailing=true] Specify invoking on the trailing
	     *  edge of the timeout.
	     * @returns {Function} Returns the new throttled function.
	     * @example
	     *
	     * // avoid excessively updating the position while scrolling
	     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	     *
	     * // invoke `renewToken` when the click event is fired, but not more than once every 5 minutes
	     * jQuery('.interactive').on('click', _.throttle(renewToken, 300000, {
	     *   'trailing': false
	     * }));
	     *
	     * // cancel a trailing throttled call
	     * jQuery(window).on('popstate', throttled.cancel);
	     */
	    function throttle(func, wait, options) {
	      var leading = true,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      if (options === false) {
	        leading = false;
	      } else if (isObject(options)) {
	        leading = 'leading' in options ? !!options.leading : leading;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	      debounceOptions.leading = leading;
	      debounceOptions.maxWait = +wait;
	      debounceOptions.trailing = trailing;
	      return debounce(func, wait, debounceOptions);
	    }
	
	    /**
	     * Creates a function that provides `value` to the wrapper function as its
	     * first argument. Any additional arguments provided to the function are
	     * appended to those provided to the wrapper function. The wrapper is invoked
	     * with the `this` binding of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {*} value The value to wrap.
	     * @param {Function} wrapper The wrapper function.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var p = _.wrap(_.escape, function(func, text) {
	     *   return '<p>' + func(text) + '</p>';
	     * });
	     *
	     * p('fred, barney, & pebbles');
	     * // => '<p>fred, barney, &amp; pebbles</p>'
	     */
	    function wrap(value, wrapper) {
	      wrapper = wrapper == null ? identity : wrapper;
	      return createWrapper(wrapper, PARTIAL_FLAG, null, [value], []);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a clone of `value`. If `isDeep` is `true` nested objects are cloned,
	     * otherwise they are assigned by reference. If `customizer` is provided it is
	     * invoked to produce the cloned values. If `customizer` returns `undefined`
	     * cloning is handled by the method instead. The `customizer` is bound to
	     * `thisArg` and invoked with two argument; (value [, index|key, object]).
	     *
	     * **Note:** This method is loosely based on the
	     * [structured clone algorithm](http://www.w3.org/TR/html5/infrastructure.html#internal-structured-cloning-algorithm).
	     * The enumerable properties of `arguments` objects and objects created by
	     * constructors other than `Object` are cloned to plain `Object` objects. An
	     * empty object is returned for uncloneable values such as functions, DOM nodes,
	     * Maps, Sets, and WeakMaps.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @param {Function} [customizer] The function to customize cloning values.
	     * @param {*} [thisArg] The `this` binding of `customizer`.
	     * @returns {*} Returns the cloned value.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * var shallow = _.clone(users);
	     * shallow[0] === users[0];
	     * // => true
	     *
	     * var deep = _.clone(users, true);
	     * deep[0] === users[0];
	     * // => false
	     *
	     * // using a customizer callback
	     * var el = _.clone(document.body, function(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(false);
	     *   }
	     * });
	     *
	     * el === document.body
	     * // => false
	     * el.nodeName
	     * // => BODY
	     * el.childNodes.length;
	     * // => 0
	     */
	    function clone(value, isDeep, customizer, thisArg) {
	      if (isDeep && typeof isDeep != 'boolean' && isIterateeCall(value, isDeep, customizer)) {
	        isDeep = false;
	      }
	      else if (typeof isDeep == 'function') {
	        thisArg = customizer;
	        customizer = isDeep;
	        isDeep = false;
	      }
	      return typeof customizer == 'function'
	        ? baseClone(value, isDeep, bindCallback(customizer, thisArg, 1))
	        : baseClone(value, isDeep);
	    }
	
	    /**
	     * Creates a deep clone of `value`. If `customizer` is provided it is invoked
	     * to produce the cloned values. If `customizer` returns `undefined` cloning
	     * is handled by the method instead. The `customizer` is bound to `thisArg`
	     * and invoked with two argument; (value [, index|key, object]).
	     *
	     * **Note:** This method is loosely based on the
	     * [structured clone algorithm](http://www.w3.org/TR/html5/infrastructure.html#internal-structured-cloning-algorithm).
	     * The enumerable properties of `arguments` objects and objects created by
	     * constructors other than `Object` are cloned to plain `Object` objects. An
	     * empty object is returned for uncloneable values such as functions, DOM nodes,
	     * Maps, Sets, and WeakMaps.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to deep clone.
	     * @param {Function} [customizer] The function to customize cloning values.
	     * @param {*} [thisArg] The `this` binding of `customizer`.
	     * @returns {*} Returns the deep cloned value.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * var deep = _.cloneDeep(users);
	     * deep[0] === users[0];
	     * // => false
	     *
	     * // using a customizer callback
	     * var el = _.cloneDeep(document.body, function(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(true);
	     *   }
	     * });
	     *
	     * el === document.body
	     * // => false
	     * el.nodeName
	     * // => BODY
	     * el.childNodes.length;
	     * // => 20
	     */
	    function cloneDeep(value, customizer, thisArg) {
	      return typeof customizer == 'function'
	        ? baseClone(value, true, bindCallback(customizer, thisArg, 1))
	        : baseClone(value, true);
	    }
	
	    /**
	     * Checks if `value` is greater than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`, else `false`.
	     * @example
	     *
	     * _.gt(3, 1);
	     * // => true
	     *
	     * _.gt(3, 3);
	     * // => false
	     *
	     * _.gt(1, 3);
	     * // => false
	     */
	    function gt(value, other) {
	      return value > other;
	    }
	
	    /**
	     * Checks if `value` is greater than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than or equal to `other`, else `false`.
	     * @example
	     *
	     * _.gte(3, 1);
	     * // => true
	     *
	     * _.gte(3, 3);
	     * // => true
	     *
	     * _.gte(1, 3);
	     * // => false
	     */
	    function gte(value, other) {
	      return value >= other;
	    }
	
	    /**
	     * Checks if `value` is classified as an `arguments` object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isArguments(function() { return arguments; }());
	     * // => true
	     *
	     * _.isArguments([1, 2, 3]);
	     * // => false
	     */
	    function isArguments(value) {
	      return isObjectLike(value) && isArrayLike(value) && objToString.call(value) == argsTag;
	    }
	
	    /**
	     * Checks if `value` is classified as an `Array` object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isArray([1, 2, 3]);
	     * // => true
	     *
	     * _.isArray(function() { return arguments; }());
	     * // => false
	     */
	    var isArray = nativeIsArray || function(value) {
	      return isObjectLike(value) && isLength(value.length) && objToString.call(value) == arrayTag;
	    };
	
	    /**
	     * Checks if `value` is classified as a boolean primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isBoolean(false);
	     * // => true
	     *
	     * _.isBoolean(null);
	     * // => false
	     */
	    function isBoolean(value) {
	      return value === true || value === false || (isObjectLike(value) && objToString.call(value) == boolTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Date` object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isDate(new Date);
	     * // => true
	     *
	     * _.isDate('Mon April 23 2012');
	     * // => false
	     */
	    function isDate(value) {
	      return isObjectLike(value) && objToString.call(value) == dateTag;
	    }
	
	    /**
	     * Checks if `value` is a DOM element.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
	     * @example
	     *
	     * _.isElement(document.body);
	     * // => true
	     *
	     * _.isElement('<body>');
	     * // => false
	     */
	    function isElement(value) {
	      return !!value && value.nodeType === 1 && isObjectLike(value) &&
	        (objToString.call(value).indexOf('Element') > -1);
	    }
	    // Fallback for environments without DOM support.
	    if (!support.dom) {
	      isElement = function(value) {
	        return !!value && value.nodeType === 1 && isObjectLike(value) && !isPlainObject(value);
	      };
	    }
	
	    /**
	     * Checks if `value` is empty. A value is considered empty unless it is an
	     * `arguments` object, array, string, or jQuery-like collection with a length
	     * greater than `0` or an object with own enumerable properties.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {Array|Object|string} value The value to inspect.
	     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	     * @example
	     *
	     * _.isEmpty(null);
	     * // => true
	     *
	     * _.isEmpty(true);
	     * // => true
	     *
	     * _.isEmpty(1);
	     * // => true
	     *
	     * _.isEmpty([1, 2, 3]);
	     * // => false
	     *
	     * _.isEmpty({ 'a': 1 });
	     * // => false
	     */
	    function isEmpty(value) {
	      if (value == null) {
	        return true;
	      }
	      if (isArrayLike(value) && (isArray(value) || isString(value) || isArguments(value) ||
	          (isObjectLike(value) && isFunction(value.splice)))) {
	        return !value.length;
	      }
	      return !keys(value).length;
	    }
	
	    /**
	     * Performs a deep comparison between two values to determine if they are
	     * equivalent. If `customizer` is provided it is invoked to compare values.
	     * If `customizer` returns `undefined` comparisons are handled by the method
	     * instead. The `customizer` is bound to `thisArg` and invoked with three
	     * arguments: (value, other [, index|key]).
	     *
	     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
	     * numbers, `Object` objects, regexes, and strings. Objects are compared by
	     * their own, not inherited, enumerable properties. Functions and DOM nodes
	     * are **not** supported. Provide a customizer function to extend support
	     * for comparing other values.
	     *
	     * @static
	     * @memberOf _
	     * @alias eq
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {Function} [customizer] The function to customize value comparisons.
	     * @param {*} [thisArg] The `this` binding of `customizer`.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'user': 'fred' };
	     * var other = { 'user': 'fred' };
	     *
	     * object == other;
	     * // => false
	     *
	     * _.isEqual(object, other);
	     * // => true
	     *
	     * // using a customizer callback
	     * var array = ['hello', 'goodbye'];
	     * var other = ['hi', 'goodbye'];
	     *
	     * _.isEqual(array, other, function(value, other) {
	     *   if (_.every([value, other], RegExp.prototype.test, /^h(?:i|ello)$/)) {
	     *     return true;
	     *   }
	     * });
	     * // => true
	     */
	    function isEqual(value, other, customizer, thisArg) {
	      customizer = typeof customizer == 'function' ? bindCallback(customizer, thisArg, 3) : undefined;
	      var result = customizer ? customizer(value, other) : undefined;
	      return  result === undefined ? baseIsEqual(value, other, customizer) : !!result;
	    }
	
	    /**
	     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
	     * `SyntaxError`, `TypeError`, or `URIError` object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
	     * @example
	     *
	     * _.isError(new Error);
	     * // => true
	     *
	     * _.isError(Error);
	     * // => false
	     */
	    function isError(value) {
	      return isObjectLike(value) && typeof value.message == 'string' && objToString.call(value) == errorTag;
	    }
	
	    /**
	     * Checks if `value` is a finite primitive number.
	     *
	     * **Note:** This method is based on [`Number.isFinite`](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-number.isfinite).
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
	     * @example
	     *
	     * _.isFinite(10);
	     * // => true
	     *
	     * _.isFinite('10');
	     * // => false
	     *
	     * _.isFinite(true);
	     * // => false
	     *
	     * _.isFinite(Object(10));
	     * // => false
	     *
	     * _.isFinite(Infinity);
	     * // => false
	     */
	    var isFinite = nativeNumIsFinite || function(value) {
	      return typeof value == 'number' && nativeIsFinite(value);
	    };
	
	    /**
	     * Checks if `value` is classified as a `Function` object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isFunction(_);
	     * // => true
	     *
	     * _.isFunction(/abc/);
	     * // => false
	     */
	    var isFunction = !(baseIsFunction(/x/) || (Uint8Array && !baseIsFunction(Uint8Array))) ? baseIsFunction : function(value) {
	      // The use of `Object#toString` avoids issues with the `typeof` operator
	      // in older versions of Chrome and Safari which return 'function' for regexes
	      // and Safari 8 equivalents which return 'object' for typed array constructors.
	      return objToString.call(value) == funcTag;
	    };
	
	    /**
	     * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
	     * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	     * @example
	     *
	     * _.isObject({});
	     * // => true
	     *
	     * _.isObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isObject(1);
	     * // => false
	     */
	    function isObject(value) {
	      // Avoid a V8 JIT bug in Chrome 19-20.
	      // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
	      var type = typeof value;
	      return !!value && (type == 'object' || type == 'function');
	    }
	
	    /**
	     * Performs a deep comparison between `object` and `source` to determine if
	     * `object` contains equivalent property values. If `customizer` is provided
	     * it is invoked to compare values. If `customizer` returns `undefined`
	     * comparisons are handled by the method instead. The `customizer` is bound
	     * to `thisArg` and invoked with three arguments: (value, other, index|key).
	     *
	     * **Note:** This method supports comparing properties of arrays, booleans,
	     * `Date` objects, numbers, `Object` objects, regexes, and strings. Functions
	     * and DOM nodes are **not** supported. Provide a customizer function to extend
	     * support for comparing other values.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Function} [customizer] The function to customize value comparisons.
	     * @param {*} [thisArg] The `this` binding of `customizer`.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * var object = { 'user': 'fred', 'age': 40 };
	     *
	     * _.isMatch(object, { 'age': 40 });
	     * // => true
	     *
	     * _.isMatch(object, { 'age': 36 });
	     * // => false
	     *
	     * // using a customizer callback
	     * var object = { 'greeting': 'hello' };
	     * var source = { 'greeting': 'hi' };
	     *
	     * _.isMatch(object, source, function(value, other) {
	     *   return _.every([value, other], RegExp.prototype.test, /^h(?:i|ello)$/) || undefined;
	     * });
	     * // => true
	     */
	    function isMatch(object, source, customizer, thisArg) {
	      customizer = typeof customizer == 'function' ? bindCallback(customizer, thisArg, 3) : undefined;
	      return baseIsMatch(object, getMatchData(source), customizer);
	    }
	
	    /**
	     * Checks if `value` is `NaN`.
	     *
	     * **Note:** This method is not the same as [`isNaN`](https://es5.github.io/#x15.1.2.4)
	     * which returns `true` for `undefined` and other non-numeric values.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	     * @example
	     *
	     * _.isNaN(NaN);
	     * // => true
	     *
	     * _.isNaN(new Number(NaN));
	     * // => true
	     *
	     * isNaN(undefined);
	     * // => true
	     *
	     * _.isNaN(undefined);
	     * // => false
	     */
	    function isNaN(value) {
	      // An `NaN` primitive is the only value that is not equal to itself.
	      // Perform the `toStringTag` check first to avoid errors with some host objects in IE.
	      return isNumber(value) && value != +value;
	    }
	
	    /**
	     * Checks if `value` is a native function.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
	     * @example
	     *
	     * _.isNative(Array.prototype.push);
	     * // => true
	     *
	     * _.isNative(_);
	     * // => false
	     */
	    function isNative(value) {
	      if (value == null) {
	        return false;
	      }
	      if (objToString.call(value) == funcTag) {
	        return reIsNative.test(fnToString.call(value));
	      }
	      return isObjectLike(value) && reIsHostCtor.test(value);
	    }
	
	    /**
	     * Checks if `value` is `null`.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
	     * @example
	     *
	     * _.isNull(null);
	     * // => true
	     *
	     * _.isNull(void 0);
	     * // => false
	     */
	    function isNull(value) {
	      return value === null;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Number` primitive or object.
	     *
	     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are classified
	     * as numbers, use the `_.isFinite` method.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isNumber(8.4);
	     * // => true
	     *
	     * _.isNumber(NaN);
	     * // => true
	     *
	     * _.isNumber('8.4');
	     * // => false
	     */
	    function isNumber(value) {
	      return typeof value == 'number' || (isObjectLike(value) && objToString.call(value) == numberTag);
	    }
	
	    /**
	     * Checks if `value` is a plain object, that is, an object created by the
	     * `Object` constructor or one with a `[[Prototype]]` of `null`.
	     *
	     * **Note:** This method assumes objects created by the `Object` constructor
	     * have no inherited enumerable properties.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * _.isPlainObject(new Foo);
	     * // => false
	     *
	     * _.isPlainObject([1, 2, 3]);
	     * // => false
	     *
	     * _.isPlainObject({ 'x': 0, 'y': 0 });
	     * // => true
	     *
	     * _.isPlainObject(Object.create(null));
	     * // => true
	     */
	    var isPlainObject = !getPrototypeOf ? shimIsPlainObject : function(value) {
	      if (!(value && objToString.call(value) == objectTag)) {
	        return false;
	      }
	      var valueOf = getNative(value, 'valueOf'),
	          objProto = valueOf && (objProto = getPrototypeOf(valueOf)) && getPrototypeOf(objProto);
	
	      return objProto
	        ? (value == objProto || getPrototypeOf(value) == objProto)
	        : shimIsPlainObject(value);
	    };
	
	    /**
	     * Checks if `value` is classified as a `RegExp` object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isRegExp(/abc/);
	     * // => true
	     *
	     * _.isRegExp('/abc/');
	     * // => false
	     */
	    function isRegExp(value) {
	      return isObjectLike(value) && objToString.call(value) == regexpTag;
	    }
	
	    /**
	     * Checks if `value` is classified as a `String` primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isString('abc');
	     * // => true
	     *
	     * _.isString(1);
	     * // => false
	     */
	    function isString(value) {
	      return typeof value == 'string' || (isObjectLike(value) && objToString.call(value) == stringTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a typed array.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isTypedArray(new Uint8Array);
	     * // => true
	     *
	     * _.isTypedArray([]);
	     * // => false
	     */
	    function isTypedArray(value) {
	      return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[objToString.call(value)];
	    }
	
	    /**
	     * Checks if `value` is `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
	     * @example
	     *
	     * _.isUndefined(void 0);
	     * // => true
	     *
	     * _.isUndefined(null);
	     * // => false
	     */
	    function isUndefined(value) {
	      return value === undefined;
	    }
	
	    /**
	     * Checks if `value` is less than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`, else `false`.
	     * @example
	     *
	     * _.lt(1, 3);
	     * // => true
	     *
	     * _.lt(3, 3);
	     * // => false
	     *
	     * _.lt(3, 1);
	     * // => false
	     */
	    function lt(value, other) {
	      return value < other;
	    }
	
	    /**
	     * Checks if `value` is less than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than or equal to `other`, else `false`.
	     * @example
	     *
	     * _.lte(1, 3);
	     * // => true
	     *
	     * _.lte(3, 3);
	     * // => true
	     *
	     * _.lte(3, 1);
	     * // => false
	     */
	    function lte(value, other) {
	      return value <= other;
	    }
	
	    /**
	     * Converts `value` to an array.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the converted array.
	     * @example
	     *
	     * (function() {
	     *   return _.toArray(arguments).slice(1);
	     * }(1, 2, 3));
	     * // => [2, 3]
	     */
	    function toArray(value) {
	      var length = value ? getLength(value) : 0;
	      if (!isLength(length)) {
	        return values(value);
	      }
	      if (!length) {
	        return [];
	      }
	      return arrayCopy(value);
	    }
	
	    /**
	     * Converts `value` to a plain object flattening inherited enumerable
	     * properties of `value` to own properties of the plain object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Object} Returns the converted plain object.
	     * @example
	     *
	     * function Foo() {
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.assign({ 'a': 1 }, new Foo);
	     * // => { 'a': 1, 'b': 2 }
	     *
	     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	     * // => { 'a': 1, 'b': 2, 'c': 3 }
	     */
	    function toPlainObject(value) {
	      return baseCopy(value, keysIn(value));
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Assigns own enumerable properties of source object(s) to the destination
	     * object. Subsequent sources overwrite property assignments of previous sources.
	     * If `customizer` is provided it is invoked to produce the assigned values.
	     * The `customizer` is bound to `thisArg` and invoked with five arguments:
	     * (objectValue, sourceValue, key, object, source).
	     *
	     * **Note:** This method mutates `object` and is based on
	     * [`Object.assign`](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-object.assign).
	     *
	     * @static
	     * @memberOf _
	     * @alias extend
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @param {*} [thisArg] The `this` binding of `customizer`.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * _.assign({ 'user': 'barney' }, { 'age': 40 }, { 'user': 'fred' });
	     * // => { 'user': 'fred', 'age': 40 }
	     *
	     * // using a customizer callback
	     * var defaults = _.partialRight(_.assign, function(value, other) {
	     *   return _.isUndefined(value) ? other : value;
	     * });
	     *
	     * defaults({ 'user': 'barney' }, { 'age': 36 }, { 'user': 'fred' });
	     * // => { 'user': 'barney', 'age': 36 }
	     */
	    var assign = createAssigner(function(object, source, customizer) {
	      return customizer
	        ? assignWith(object, source, customizer)
	        : baseAssign(object, source);
	    });
	
	    /**
	     * Creates an object that inherits from the given `prototype` object. If a
	     * `properties` object is provided its own enumerable properties are assigned
	     * to the created object.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} prototype The object to inherit from.
	     * @param {Object} [properties] The properties to assign to the object.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * function Shape() {
	     *   this.x = 0;
	     *   this.y = 0;
	     * }
	     *
	     * function Circle() {
	     *   Shape.call(this);
	     * }
	     *
	     * Circle.prototype = _.create(Shape.prototype, {
	     *   'constructor': Circle
	     * });
	     *
	     * var circle = new Circle;
	     * circle instanceof Circle;
	     * // => true
	     *
	     * circle instanceof Shape;
	     * // => true
	     */
	    function create(prototype, properties, guard) {
	      var result = baseCreate(prototype);
	      if (guard && isIterateeCall(prototype, properties, guard)) {
	        properties = null;
	      }
	      return properties ? baseAssign(result, properties) : result;
	    }
	
	    /**
	     * Assigns own enumerable properties of source object(s) to the destination
	     * object for all destination properties that resolve to `undefined`. Once a
	     * property is set, additional values of the same property are ignored.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * _.defaults({ 'user': 'barney' }, { 'age': 36 }, { 'user': 'fred' });
	     * // => { 'user': 'barney', 'age': 36 }
	     */
	    var defaults = restParam(function(args) {
	      var object = args[0];
	      if (object == null) {
	        return object;
	      }
	      args.push(assignDefaults);
	      return assign.apply(undefined, args);
	    });
	
	    /**
	     * This method is like `_.find` except that it returns the key of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to search.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {string|undefined} Returns the key of the matched element, else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findKey(users, function(chr) {
	     *   return chr.age < 40;
	     * });
	     * // => 'barney' (iteration order is not guaranteed)
	     *
	     * // using the `_.matches` callback shorthand
	     * _.findKey(users, { 'age': 1, 'active': true });
	     * // => 'pebbles'
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.findKey(users, 'active', false);
	     * // => 'fred'
	     *
	     * // using the `_.property` callback shorthand
	     * _.findKey(users, 'active');
	     * // => 'barney'
	     */
	    var findKey = createFindKey(baseForOwn);
	
	    /**
	     * This method is like `_.findKey` except that it iterates over elements of
	     * a collection in the opposite order.
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to search.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {string|undefined} Returns the key of the matched element, else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findLastKey(users, function(chr) {
	     *   return chr.age < 40;
	     * });
	     * // => returns `pebbles` assuming `_.findKey` returns `barney`
	     *
	     * // using the `_.matches` callback shorthand
	     * _.findLastKey(users, { 'age': 36, 'active': true });
	     * // => 'barney'
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.findLastKey(users, 'active', false);
	     * // => 'fred'
	     *
	     * // using the `_.property` callback shorthand
	     * _.findLastKey(users, 'active');
	     * // => 'pebbles'
	     */
	    var findLastKey = createFindKey(baseForOwnRight);
	
	    /**
	     * Iterates over own and inherited enumerable properties of an object invoking
	     * `iteratee` for each property. The `iteratee` is bound to `thisArg` and invoked
	     * with three arguments: (value, key, object). Iteratee functions may exit
	     * iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forIn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => logs 'a', 'b', and 'c' (iteration order is not guaranteed)
	     */
	    var forIn = createForIn(baseFor);
	
	    /**
	     * This method is like `_.forIn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forInRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => logs 'c', 'b', and 'a' assuming `_.forIn ` logs 'a', 'b', and 'c'
	     */
	    var forInRight = createForIn(baseForRight);
	
	    /**
	     * Iterates over own enumerable properties of an object invoking `iteratee`
	     * for each property. The `iteratee` is bound to `thisArg` and invoked with
	     * three arguments: (value, key, object). Iteratee functions may exit iteration
	     * early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => logs 'a' and 'b' (iteration order is not guaranteed)
	     */
	    var forOwn = createForOwn(baseForOwn);
	
	    /**
	     * This method is like `_.forOwn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwnRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => logs 'b' and 'a' assuming `_.forOwn` logs 'a' and 'b'
	     */
	    var forOwnRight = createForOwn(baseForOwnRight);
	
	    /**
	     * Creates an array of function property names from all enumerable properties,
	     * own and inherited, of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @alias methods
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the new array of property names.
	     * @example
	     *
	     * _.functions(_);
	     * // => ['after', 'ary', 'assign', ...]
	     */
	    function functions(object) {
	      return baseFunctions(object, keysIn(object));
	    }
	
	    /**
	     * Gets the property value at `path` of `object`. If the resolved value is
	     * `undefined` the `defaultValue` is used in its place.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} [defaultValue] The value returned if the resolved value is `undefined`.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.get(object, 'a[0].b.c');
	     * // => 3
	     *
	     * _.get(object, ['a', '0', 'b', 'c']);
	     * // => 3
	     *
	     * _.get(object, 'a.b.c', 'default');
	     * // => 'default'
	     */
	    function get(object, path, defaultValue) {
	      var result = object == null ? undefined : baseGet(object, toPath(path), path + '');
	      return result === undefined ? defaultValue : result;
	    }
	
	    /**
	     * Checks if `path` is a direct property.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` is a direct property, else `false`.
	     * @example
	     *
	     * var object = { 'a': { 'b': { 'c': 3 } } };
	     *
	     * _.has(object, 'a');
	     * // => true
	     *
	     * _.has(object, 'a.b.c');
	     * // => true
	     *
	     * _.has(object, ['a', 'b', 'c']);
	     * // => true
	     */
	    function has(object, path) {
	      if (object == null) {
	        return false;
	      }
	      var result = hasOwnProperty.call(object, path);
	      if (!result && !isKey(path)) {
	        path = toPath(path);
	        object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
	        if (object == null) {
	          return false;
	        }
	        path = last(path);
	        result = hasOwnProperty.call(object, path);
	      }
	      return result || (isLength(object.length) && isIndex(path, object.length) &&
	        (isArray(object) || isArguments(object)));
	    }
	
	    /**
	     * Creates an object composed of the inverted keys and values of `object`.
	     * If `object` contains duplicate values, subsequent values overwrite property
	     * assignments of previous values unless `multiValue` is `true`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @param {boolean} [multiValue] Allow multiple values per key.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invert(object);
	     * // => { '1': 'c', '2': 'b' }
	     *
	     * // with `multiValue`
	     * _.invert(object, true);
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     */
	    function invert(object, multiValue, guard) {
	      if (guard && isIterateeCall(object, multiValue, guard)) {
	        multiValue = null;
	      }
	      var index = -1,
	          props = keys(object),
	          length = props.length,
	          result = {};
	
	      while (++index < length) {
	        var key = props[index],
	            value = object[key];
	
	        if (multiValue) {
	          if (hasOwnProperty.call(result, value)) {
	            result[value].push(key);
	          } else {
	            result[value] = [key];
	          }
	        }
	        else {
	          result[value] = key;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array of the own enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects. See the
	     * [ES spec](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-object.keys)
	     * for more details.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keys(new Foo);
	     * // => ['a', 'b'] (iteration order is not guaranteed)
	     *
	     * _.keys('hi');
	     * // => ['0', '1']
	     */
	    var keys = !nativeKeys ? shimKeys : function(object) {
	      var Ctor = object == null ? null : object.constructor;
	      if ((typeof Ctor == 'function' && Ctor.prototype === object) ||
	          (typeof object != 'function' && isArrayLike(object))) {
	        return shimKeys(object);
	      }
	      return isObject(object) ? nativeKeys(object) : [];
	    };
	
	    /**
	     * Creates an array of the own and inherited enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keysIn(new Foo);
	     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	     */
	    function keysIn(object) {
	      if (object == null) {
	        return [];
	      }
	      if (!isObject(object)) {
	        object = Object(object);
	      }
	      var length = object.length;
	      length = (length && isLength(length) &&
	        (isArray(object) || isArguments(object)) && length) || 0;
	
	      var Ctor = object.constructor,
	          index = -1,
	          isProto = typeof Ctor == 'function' && Ctor.prototype === object,
	          result = Array(length),
	          skipIndexes = length > 0;
	
	      while (++index < length) {
	        result[index] = (index + '');
	      }
	      for (var key in object) {
	        if (!(skipIndexes && isIndex(key, length)) &&
	            !(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The opposite of `_.mapValues`; this method creates an object with the
	     * same values as `object` and keys generated by running each own enumerable
	     * property of `object` through `iteratee`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns the new mapped object.
	     * @example
	     *
	     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   return key + value;
	     * });
	     * // => { 'a1': 1, 'b2': 2 }
	     */
	    var mapKeys = createObjectMapper(true);
	
	    /**
	     * Creates an object with the same keys as `object` and values generated by
	     * running each own enumerable property of `object` through `iteratee`. The
	     * iteratee function is bound to `thisArg` and invoked with three arguments:
	     * (value, key, object).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns the new mapped object.
	     * @example
	     *
	     * _.mapValues({ 'a': 1, 'b': 2 }, function(n) {
	     *   return n * 3;
	     * });
	     * // => { 'a': 3, 'b': 6 }
	     *
	     * var users = {
	     *   'fred':    { 'user': 'fred',    'age': 40 },
	     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	     * };
	     *
	     * // using the `_.property` callback shorthand
	     * _.mapValues(users, 'age');
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     */
	    var mapValues = createObjectMapper();
	
	    /**
	     * Recursively merges own enumerable properties of the source object(s), that
	     * don't resolve to `undefined` into the destination object. Subsequent sources
	     * overwrite property assignments of previous sources. If `customizer` is
	     * provided it is invoked to produce the merged values of the destination and
	     * source properties. If `customizer` returns `undefined` merging is handled
	     * by the method instead. The `customizer` is bound to `thisArg` and invoked
	     * with five arguments: (objectValue, sourceValue, key, object, source).
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @param {*} [thisArg] The `this` binding of `customizer`.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var users = {
	     *   'data': [{ 'user': 'barney' }, { 'user': 'fred' }]
	     * };
	     *
	     * var ages = {
	     *   'data': [{ 'age': 36 }, { 'age': 40 }]
	     * };
	     *
	     * _.merge(users, ages);
	     * // => { 'data': [{ 'user': 'barney', 'age': 36 }, { 'user': 'fred', 'age': 40 }] }
	     *
	     * // using a customizer callback
	     * var object = {
	     *   'fruits': ['apple'],
	     *   'vegetables': ['beet']
	     * };
	     *
	     * var other = {
	     *   'fruits': ['banana'],
	     *   'vegetables': ['carrot']
	     * };
	     *
	     * _.merge(object, other, function(a, b) {
	     *   if (_.isArray(a)) {
	     *     return a.concat(b);
	     *   }
	     * });
	     * // => { 'fruits': ['apple', 'banana'], 'vegetables': ['beet', 'carrot'] }
	     */
	    var merge = createAssigner(baseMerge);
	
	    /**
	     * The opposite of `_.pick`; this method creates an object composed of the
	     * own and inherited enumerable properties of `object` that are not omitted.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function|...(string|string[])} [predicate] The function invoked per
	     *  iteration or property names to omit, specified as individual property
	     *  names or arrays of property names.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'user': 'fred', 'age': 40 };
	     *
	     * _.omit(object, 'age');
	     * // => { 'user': 'fred' }
	     *
	     * _.omit(object, _.isNumber);
	     * // => { 'user': 'fred' }
	     */
	    var omit = restParam(function(object, props) {
	      if (object == null) {
	        return {};
	      }
	      if (typeof props[0] != 'function') {
	        var props = arrayMap(baseFlatten(props), String);
	        return pickByArray(object, baseDifference(keysIn(object), props));
	      }
	      var predicate = bindCallback(props[0], props[1], 3);
	      return pickByCallback(object, function(value, key, object) {
	        return !predicate(value, key, object);
	      });
	    });
	
	    /**
	     * Creates a two dimensional array of the key-value pairs for `object`,
	     * e.g. `[[key1, value1], [key2, value2]]`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the new array of key-value pairs.
	     * @example
	     *
	     * _.pairs({ 'barney': 36, 'fred': 40 });
	     * // => [['barney', 36], ['fred', 40]] (iteration order is not guaranteed)
	     */
	    function pairs(object) {
	      object = toObject(object);
	
	      var index = -1,
	          props = keys(object),
	          length = props.length,
	          result = Array(length);
	
	      while (++index < length) {
	        var key = props[index];
	        result[index] = [key, object[key]];
	      }
	      return result;
	    }
	
	    /**
	     * Creates an object composed of the picked `object` properties. Property
	     * names may be specified as individual arguments or as arrays of property
	     * names. If `predicate` is provided it is invoked for each property of `object`
	     * picking the properties `predicate` returns truthy for. The predicate is
	     * bound to `thisArg` and invoked with three arguments: (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function|...(string|string[])} [predicate] The function invoked per
	     *  iteration or property names to pick, specified as individual property
	     *  names or arrays of property names.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'user': 'fred', 'age': 40 };
	     *
	     * _.pick(object, 'user');
	     * // => { 'user': 'fred' }
	     *
	     * _.pick(object, _.isString);
	     * // => { 'user': 'fred' }
	     */
	    var pick = restParam(function(object, props) {
	      if (object == null) {
	        return {};
	      }
	      return typeof props[0] == 'function'
	        ? pickByCallback(object, bindCallback(props[0], props[1], 3))
	        : pickByArray(object, baseFlatten(props));
	    });
	
	    /**
	     * This method is like `_.get` except that if the resolved value is a function
	     * it is invoked with the `this` binding of its parent object and its result
	     * is returned.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to resolve.
	     * @param {*} [defaultValue] The value returned if the resolved value is `undefined`.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
	     *
	     * _.result(object, 'a[0].b.c1');
	     * // => 3
	     *
	     * _.result(object, 'a[0].b.c2');
	     * // => 4
	     *
	     * _.result(object, 'a.b.c', 'default');
	     * // => 'default'
	     *
	     * _.result(object, 'a.b.c', _.constant('default'));
	     * // => 'default'
	     */
	    function result(object, path, defaultValue) {
	      var result = object == null ? undefined : object[path];
	      if (result === undefined) {
	        if (object != null && !isKey(path, object)) {
	          path = toPath(path);
	          object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
	          result = object == null ? undefined : object[last(path)];
	        }
	        result = result === undefined ? defaultValue : result;
	      }
	      return isFunction(result) ? result.call(object) : result;
	    }
	
	    /**
	     * Sets the property value of `path` on `object`. If a portion of `path`
	     * does not exist it is created.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to augment.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.set(object, 'a[0].b.c', 4);
	     * console.log(object.a[0].b.c);
	     * // => 4
	     *
	     * _.set(object, 'x[0].y.z', 5);
	     * console.log(object.x[0].y.z);
	     * // => 5
	     */
	    function set(object, path, value) {
	      if (object == null) {
	        return object;
	      }
	      var pathKey = (path + '');
	      path = (object[pathKey] != null || isKey(path, object)) ? [pathKey] : toPath(path);
	
	      var index = -1,
	          length = path.length,
	          lastIndex = length - 1,
	          nested = object;
	
	      while (nested != null && ++index < length) {
	        var key = path[index];
	        if (isObject(nested)) {
	          if (index == lastIndex) {
	            nested[key] = value;
	          } else if (nested[key] == null) {
	            nested[key] = isIndex(path[index + 1]) ? [] : {};
	          }
	        }
	        nested = nested[key];
	      }
	      return object;
	    }
	
	    /**
	     * An alternative to `_.reduce`; this method transforms `object` to a new
	     * `accumulator` object which is the result of running each of its own enumerable
	     * properties through `iteratee`, with each invocation potentially mutating
	     * the `accumulator` object. The `iteratee` is bound to `thisArg` and invoked
	     * with four arguments: (accumulator, value, key, object). Iteratee functions
	     * may exit iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Array|Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The custom accumulator value.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * _.transform([2, 3, 4], function(result, n) {
	     *   result.push(n *= n);
	     *   return n % 2 == 0;
	     * });
	     * // => [4, 9]
	     *
	     * _.transform({ 'a': 1, 'b': 2 }, function(result, n, key) {
	     *   result[key] = n * 3;
	     * });
	     * // => { 'a': 3, 'b': 6 }
	     */
	    function transform(object, iteratee, accumulator, thisArg) {
	      var isArr = isArray(object) || isTypedArray(object);
	      iteratee = getCallback(iteratee, thisArg, 4);
	
	      if (accumulator == null) {
	        if (isArr || isObject(object)) {
	          var Ctor = object.constructor;
	          if (isArr) {
	            accumulator = isArray(object) ? new Ctor : [];
	          } else {
	            accumulator = baseCreate(isFunction(Ctor) ? Ctor.prototype : null);
	          }
	        } else {
	          accumulator = {};
	        }
	      }
	      (isArr ? arrayEach : baseForOwn)(object, function(value, index, object) {
	        return iteratee(accumulator, value, index, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * Creates an array of the own enumerable property values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.values(new Foo);
	     * // => [1, 2] (iteration order is not guaranteed)
	     *
	     * _.values('hi');
	     * // => ['h', 'i']
	     */
	    function values(object) {
	      return baseValues(object, keys(object));
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable property values
	     * of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.valuesIn(new Foo);
	     * // => [1, 2, 3] (iteration order is not guaranteed)
	     */
	    function valuesIn(object) {
	      return baseValues(object, keysIn(object));
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Checks if `n` is between `start` and up to but not including, `end`. If
	     * `end` is not specified it is set to `start` with `start` then set to `0`.
	     *
	     * @static
	     * @memberOf _
	     * @category Number
	     * @param {number} n The number to check.
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `n` is in the range, else `false`.
	     * @example
	     *
	     * _.inRange(3, 2, 4);
	     * // => true
	     *
	     * _.inRange(4, 8);
	     * // => true
	     *
	     * _.inRange(4, 2);
	     * // => false
	     *
	     * _.inRange(2, 2);
	     * // => false
	     *
	     * _.inRange(1.2, 2);
	     * // => true
	     *
	     * _.inRange(5.2, 4);
	     * // => false
	     */
	    function inRange(value, start, end) {
	      start = +start || 0;
	      if (typeof end === 'undefined') {
	        end = start;
	        start = 0;
	      } else {
	        end = +end || 0;
	      }
	      return value >= nativeMin(start, end) && value < nativeMax(start, end);
	    }
	
	    /**
	     * Produces a random number between `min` and `max` (inclusive). If only one
	     * argument is provided a number between `0` and the given number is returned.
	     * If `floating` is `true`, or either `min` or `max` are floats, a floating-point
	     * number is returned instead of an integer.
	     *
	     * @static
	     * @memberOf _
	     * @category Number
	     * @param {number} [min=0] The minimum possible value.
	     * @param {number} [max=1] The maximum possible value.
	     * @param {boolean} [floating] Specify returning a floating-point number.
	     * @returns {number} Returns the random number.
	     * @example
	     *
	     * _.random(0, 5);
	     * // => an integer between 0 and 5
	     *
	     * _.random(5);
	     * // => also an integer between 0 and 5
	     *
	     * _.random(5, true);
	     * // => a floating-point number between 0 and 5
	     *
	     * _.random(1.2, 5.2);
	     * // => a floating-point number between 1.2 and 5.2
	     */
	    function random(min, max, floating) {
	      if (floating && isIterateeCall(min, max, floating)) {
	        max = floating = null;
	      }
	      var noMin = min == null,
	          noMax = max == null;
	
	      if (floating == null) {
	        if (noMax && typeof min == 'boolean') {
	          floating = min;
	          min = 1;
	        }
	        else if (typeof max == 'boolean') {
	          floating = max;
	          noMax = true;
	        }
	      }
	      if (noMin && noMax) {
	        max = 1;
	        noMax = false;
	      }
	      min = +min || 0;
	      if (noMax) {
	        max = min;
	        min = 0;
	      } else {
	        max = +max || 0;
	      }
	      if (floating || min % 1 || max % 1) {
	        var rand = nativeRandom();
	        return nativeMin(min + (rand * (max - min + parseFloat('1e-' + ((rand + '').length - 1)))), max);
	      }
	      return baseRandom(min, max);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the camel cased string.
	     * @example
	     *
	     * _.camelCase('Foo Bar');
	     * // => 'fooBar'
	     *
	     * _.camelCase('--foo-bar');
	     * // => 'fooBar'
	     *
	     * _.camelCase('__foo_bar__');
	     * // => 'fooBar'
	     */
	    var camelCase = createCompounder(function(result, word, index) {
	      word = word.toLowerCase();
	      return result + (index ? (word.charAt(0).toUpperCase() + word.slice(1)) : word);
	    });
	
	    /**
	     * Capitalizes the first character of `string`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to capitalize.
	     * @returns {string} Returns the capitalized string.
	     * @example
	     *
	     * _.capitalize('fred');
	     * // => 'Fred'
	     */
	    function capitalize(string) {
	      string = baseToString(string);
	      return string && (string.charAt(0).toUpperCase() + string.slice(1));
	    }
	
	    /**
	     * Deburrs `string` by converting [latin-1 supplementary letters](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
	     * to basic latin letters and removing [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to deburr.
	     * @returns {string} Returns the deburred string.
	     * @example
	     *
	     * _.deburr('déjà vu');
	     * // => 'deja vu'
	     */
	    function deburr(string) {
	      string = baseToString(string);
	      return string && string.replace(reLatin1, deburrLetter).replace(reComboMark, '');
	    }
	
	    /**
	     * Checks if `string` ends with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to search.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=string.length] The position to search from.
	     * @returns {boolean} Returns `true` if `string` ends with `target`, else `false`.
	     * @example
	     *
	     * _.endsWith('abc', 'c');
	     * // => true
	     *
	     * _.endsWith('abc', 'b');
	     * // => false
	     *
	     * _.endsWith('abc', 'b', 2);
	     * // => true
	     */
	    function endsWith(string, target, position) {
	      string = baseToString(string);
	      target = (target + '');
	
	      var length = string.length;
	      position = position === undefined
	        ? length
	        : nativeMin(position < 0 ? 0 : (+position || 0), length);
	
	      position -= target.length;
	      return position >= 0 && string.indexOf(target, position) == position;
	    }
	
	    /**
	     * Converts the characters "&", "<", ">", '"', "'", and "\`", in `string` to
	     * their corresponding HTML entities.
	     *
	     * **Note:** No other characters are escaped. To escape additional characters
	     * use a third-party library like [_he_](https://mths.be/he).
	     *
	     * Though the ">" character is escaped for symmetry, characters like
	     * ">" and "/" don't need escaping in HTML and have no special meaning
	     * unless they're part of a tag or unquoted attribute value.
	     * See [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
	     * (under "semi-related fun fact") for more details.
	     *
	     * Backticks are escaped because in Internet Explorer < 9, they can break out
	     * of attribute values or HTML comments. See [#59](https://html5sec.org/#59),
	     * [#102](https://html5sec.org/#102), [#108](https://html5sec.org/#108), and
	     * [#133](https://html5sec.org/#133) of the [HTML5 Security Cheatsheet](https://html5sec.org/)
	     * for more details.
	     *
	     * When working with HTML you should always [quote attribute values](http://wonko.com/post/html-escaping)
	     * to reduce XSS vectors.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escape('fred, barney, & pebbles');
	     * // => 'fred, barney, &amp; pebbles'
	     */
	    function escape(string) {
	      // Reset `lastIndex` because in IE < 9 `String#replace` does not.
	      string = baseToString(string);
	      return (string && reHasUnescapedHtml.test(string))
	        ? string.replace(reUnescapedHtml, escapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Escapes the `RegExp` special characters "\", "/", "^", "$", ".", "|", "?",
	     * "*", "+", "(", ")", "[", "]", "{" and "}" in `string`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escapeRegExp('[lodash](https://lodash.com/)');
	     * // => '\[lodash\]\(https:\/\/lodash\.com\/\)'
	     */
	    function escapeRegExp(string) {
	      string = baseToString(string);
	      return (string && reHasRegExpChars.test(string))
	        ? string.replace(reRegExpChars, '\\$&')
	        : string;
	    }
	
	    /**
	     * Converts `string` to [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the kebab cased string.
	     * @example
	     *
	     * _.kebabCase('Foo Bar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('fooBar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('__foo_bar__');
	     * // => 'foo-bar'
	     */
	    var kebabCase = createCompounder(function(result, word, index) {
	      return result + (index ? '-' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Pads `string` on the left and right sides if it's shorter than `length`.
	     * Padding characters are truncated if they can't be evenly divided by `length`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.pad('abc', 8);
	     * // => '  abc   '
	     *
	     * _.pad('abc', 8, '_-');
	     * // => '_-abc_-_'
	     *
	     * _.pad('abc', 3);
	     * // => 'abc'
	     */
	    function pad(string, length, chars) {
	      string = baseToString(string);
	      length = +length;
	
	      var strLength = string.length;
	      if (strLength >= length || !nativeIsFinite(length)) {
	        return string;
	      }
	      var mid = (length - strLength) / 2,
	          leftLength = floor(mid),
	          rightLength = ceil(mid);
	
	      chars = createPadding('', rightLength, chars);
	      return chars.slice(0, leftLength) + string + chars;
	    }
	
	    /**
	     * Pads `string` on the left side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padLeft('abc', 6);
	     * // => '   abc'
	     *
	     * _.padLeft('abc', 6, '_-');
	     * // => '_-_abc'
	     *
	     * _.padLeft('abc', 3);
	     * // => 'abc'
	     */
	    var padLeft = createPadDir();
	
	    /**
	     * Pads `string` on the right side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padRight('abc', 6);
	     * // => 'abc   '
	     *
	     * _.padRight('abc', 6, '_-');
	     * // => 'abc_-_'
	     *
	     * _.padRight('abc', 3);
	     * // => 'abc'
	     */
	    var padRight = createPadDir(true);
	
	    /**
	     * Converts `string` to an integer of the specified radix. If `radix` is
	     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a hexadecimal,
	     * in which case a `radix` of `16` is used.
	     *
	     * **Note:** This method aligns with the [ES5 implementation](https://es5.github.io/#E)
	     * of `parseInt`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} string The string to convert.
	     * @param {number} [radix] The radix to interpret `value` by.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.parseInt('08');
	     * // => 8
	     *
	     * _.map(['6', '08', '10'], _.parseInt);
	     * // => [6, 8, 10]
	     */
	    function parseInt(string, radix, guard) {
	      if (guard && isIterateeCall(string, radix, guard)) {
	        radix = 0;
	      }
	      return nativeParseInt(string, radix);
	    }
	    // Fallback for environments with pre-ES5 implementations.
	    if (nativeParseInt(whitespace + '08') != 8) {
	      parseInt = function(string, radix, guard) {
	        // Firefox < 21 and Opera < 15 follow ES3 for `parseInt`.
	        // Chrome fails to trim leading <BOM> whitespace characters.
	        // See https://code.google.com/p/v8/issues/detail?id=3109 for more details.
	        if (guard ? isIterateeCall(string, radix, guard) : radix == null) {
	          radix = 0;
	        } else if (radix) {
	          radix = +radix;
	        }
	        string = trim(string);
	        return nativeParseInt(string, radix || (reHasHexPrefix.test(string) ? 16 : 10));
	      };
	    }
	
	    /**
	     * Repeats the given string `n` times.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to repeat.
	     * @param {number} [n=0] The number of times to repeat the string.
	     * @returns {string} Returns the repeated string.
	     * @example
	     *
	     * _.repeat('*', 3);
	     * // => '***'
	     *
	     * _.repeat('abc', 2);
	     * // => 'abcabc'
	     *
	     * _.repeat('abc', 0);
	     * // => ''
	     */
	    function repeat(string, n) {
	      var result = '';
	      string = baseToString(string);
	      n = +n;
	      if (n < 1 || !string || !nativeIsFinite(n)) {
	        return result;
	      }
	      // Leverage the exponentiation by squaring algorithm for a faster repeat.
	      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
	      do {
	        if (n % 2) {
	          result += string;
	        }
	        n = floor(n / 2);
	        string += string;
	      } while (n);
	
	      return result;
	    }
	
	    /**
	     * Converts `string` to [snake case](https://en.wikipedia.org/wiki/Snake_case).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the snake cased string.
	     * @example
	     *
	     * _.snakeCase('Foo Bar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('fooBar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('--foo-bar');
	     * // => 'foo_bar'
	     */
	    var snakeCase = createCompounder(function(result, word, index) {
	      return result + (index ? '_' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts `string` to [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the start cased string.
	     * @example
	     *
	     * _.startCase('--foo-bar');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('fooBar');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('__foo_bar__');
	     * // => 'Foo Bar'
	     */
	    var startCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + (word.charAt(0).toUpperCase() + word.slice(1));
	    });
	
	    /**
	     * Checks if `string` starts with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to search.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=0] The position to search from.
	     * @returns {boolean} Returns `true` if `string` starts with `target`, else `false`.
	     * @example
	     *
	     * _.startsWith('abc', 'a');
	     * // => true
	     *
	     * _.startsWith('abc', 'b');
	     * // => false
	     *
	     * _.startsWith('abc', 'b', 1);
	     * // => true
	     */
	    function startsWith(string, target, position) {
	      string = baseToString(string);
	      position = position == null
	        ? 0
	        : nativeMin(position < 0 ? 0 : (+position || 0), string.length);
	
	      return string.lastIndexOf(target, position) == position;
	    }
	
	    /**
	     * Creates a compiled template function that can interpolate data properties
	     * in "interpolate" delimiters, HTML-escape interpolated data properties in
	     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
	     * properties may be accessed as free variables in the template. If a setting
	     * object is provided it takes precedence over `_.templateSettings` values.
	     *
	     * **Note:** In the development build `_.template` utilizes
	     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
	     * for easier debugging.
	     *
	     * For more information on precompiling templates see
	     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
	     *
	     * For more information on Chrome extension sandboxes see
	     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The template string.
	     * @param {Object} [options] The options object.
	     * @param {RegExp} [options.escape] The HTML "escape" delimiter.
	     * @param {RegExp} [options.evaluate] The "evaluate" delimiter.
	     * @param {Object} [options.imports] An object to import into the template as free variables.
	     * @param {RegExp} [options.interpolate] The "interpolate" delimiter.
	     * @param {string} [options.sourceURL] The sourceURL of the template's compiled source.
	     * @param {string} [options.variable] The data object variable name.
	     * @param- {Object} [otherOptions] Enables the legacy `options` param signature.
	     * @returns {Function} Returns the compiled template function.
	     * @example
	     *
	     * // using the "interpolate" delimiter to create a compiled template
	     * var compiled = _.template('hello <%= user %>!');
	     * compiled({ 'user': 'fred' });
	     * // => 'hello fred!'
	     *
	     * // using the HTML "escape" delimiter to escape data property values
	     * var compiled = _.template('<b><%- value %></b>');
	     * compiled({ 'value': '<script>' });
	     * // => '<b>&lt;script&gt;</b>'
	     *
	     * // using the "evaluate" delimiter to execute JavaScript and generate HTML
	     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // using the internal `print` function in "evaluate" delimiters
	     * var compiled = _.template('<% print("hello " + user); %>!');
	     * compiled({ 'user': 'barney' });
	     * // => 'hello barney!'
	     *
	     * // using the ES delimiter as an alternative to the default "interpolate" delimiter
	     * var compiled = _.template('hello ${ user }!');
	     * compiled({ 'user': 'pebbles' });
	     * // => 'hello pebbles!'
	     *
	     * // using custom template delimiters
	     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
	     * var compiled = _.template('hello {{ user }}!');
	     * compiled({ 'user': 'mustache' });
	     * // => 'hello mustache!'
	     *
	     * // using backslashes to treat delimiters as plain text
	     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
	     * compiled({ 'value': 'ignored' });
	     * // => '<%- value %>'
	     *
	     * // using the `imports` option to import `jQuery` as `jq`
	     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
	     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // using the `sourceURL` option to specify a custom sourceURL for the template
	     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
	     * compiled(data);
	     * // => find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector
	     *
	     * // using the `variable` option to ensure a with-statement isn't used in the compiled template
	     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
	     * compiled.source;
	     * // => function(data) {
	     * //   var __t, __p = '';
	     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
	     * //   return __p;
	     * // }
	     *
	     * // using the `source` property to inline compiled templates for meaningful
	     * // line numbers in error messages and a stack trace
	     * fs.writeFileSync(path.join(cwd, 'jst.js'), '\
	     *   var JST = {\
	     *     "main": ' + _.template(mainText).source + '\
	     *   };\
	     * ');
	     */
	    function template(string, options, otherOptions) {
	      // Based on John Resig's `tmpl` implementation (http://ejohn.org/blog/javascript-micro-templating/)
	      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
	      var settings = lodash.templateSettings;
	
	      if (otherOptions && isIterateeCall(string, options, otherOptions)) {
	        options = otherOptions = null;
	      }
	      string = baseToString(string);
	      options = assignWith(baseAssign({}, otherOptions || options), settings, assignOwnDefaults);
	
	      var imports = assignWith(baseAssign({}, options.imports), settings.imports, assignOwnDefaults),
	          importsKeys = keys(imports),
	          importsValues = baseValues(imports, importsKeys);
	
	      var isEscaping,
	          isEvaluating,
	          index = 0,
	          interpolate = options.interpolate || reNoMatch,
	          source = "__p += '";
	
	      // Compile the regexp to match each delimiter.
	      var reDelimiters = RegExp(
	        (options.escape || reNoMatch).source + '|' +
	        interpolate.source + '|' +
	        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
	        (options.evaluate || reNoMatch).source + '|$'
	      , 'g');
	
	      // Use a sourceURL for easier debugging.
	      var sourceURL = '//# sourceURL=' +
	        ('sourceURL' in options
	          ? options.sourceURL
	          : ('lodash.templateSources[' + (++templateCounter) + ']')
	        ) + '\n';
	
	      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
	        interpolateValue || (interpolateValue = esTemplateValue);
	
	        // Escape characters that can't be included in string literals.
	        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
	
	        // Replace delimiters with snippets.
	        if (escapeValue) {
	          isEscaping = true;
	          source += "' +\n__e(" + escapeValue + ") +\n'";
	        }
	        if (evaluateValue) {
	          isEvaluating = true;
	          source += "';\n" + evaluateValue + ";\n__p += '";
	        }
	        if (interpolateValue) {
	          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
	        }
	        index = offset + match.length;
	
	        // The JS engine embedded in Adobe products requires returning the `match`
	        // string in order to produce the correct `offset` value.
	        return match;
	      });
	
	      source += "';\n";
	
	      // If `variable` is not specified wrap a with-statement around the generated
	      // code to add the data object to the top of the scope chain.
	      var variable = options.variable;
	      if (!variable) {
	        source = 'with (obj) {\n' + source + '\n}\n';
	      }
	      // Cleanup code by stripping empty strings.
	      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
	        .replace(reEmptyStringMiddle, '$1')
	        .replace(reEmptyStringTrailing, '$1;');
	
	      // Frame code as the function body.
	      source = 'function(' + (variable || 'obj') + ') {\n' +
	        (variable
	          ? ''
	          : 'obj || (obj = {});\n'
	        ) +
	        "var __t, __p = ''" +
	        (isEscaping
	           ? ', __e = _.escape'
	           : ''
	        ) +
	        (isEvaluating
	          ? ', __j = Array.prototype.join;\n' +
	            "function print() { __p += __j.call(arguments, '') }\n"
	          : ';\n'
	        ) +
	        source +
	        'return __p\n}';
	
	      var result = attempt(function() {
	        return Function(importsKeys, sourceURL + 'return ' + source).apply(undefined, importsValues);
	      });
	
	      // Provide the compiled function's source by its `toString` method or
	      // the `source` property as a convenience for inlining compiled templates.
	      result.source = source;
	      if (isError(result)) {
	        throw result;
	      }
	      return result;
	    }
	
	    /**
	     * Removes leading and trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trim('  abc  ');
	     * // => 'abc'
	     *
	     * _.trim('-_-abc-_-', '_-');
	     * // => 'abc'
	     *
	     * _.map(['  foo  ', '  bar  '], _.trim);
	     * // => ['foo', 'bar']
	     */
	    function trim(string, chars, guard) {
	      var value = string;
	      string = baseToString(string);
	      if (!string) {
	        return string;
	      }
	      if (guard ? isIterateeCall(value, chars, guard) : chars == null) {
	        return string.slice(trimmedLeftIndex(string), trimmedRightIndex(string) + 1);
	      }
	      chars = (chars + '');
	      return string.slice(charsLeftIndex(string, chars), charsRightIndex(string, chars) + 1);
	    }
	
	    /**
	     * Removes leading whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimLeft('  abc  ');
	     * // => 'abc  '
	     *
	     * _.trimLeft('-_-abc-_-', '_-');
	     * // => 'abc-_-'
	     */
	    function trimLeft(string, chars, guard) {
	      var value = string;
	      string = baseToString(string);
	      if (!string) {
	        return string;
	      }
	      if (guard ? isIterateeCall(value, chars, guard) : chars == null) {
	        return string.slice(trimmedLeftIndex(string));
	      }
	      return string.slice(charsLeftIndex(string, (chars + '')));
	    }
	
	    /**
	     * Removes trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimRight('  abc  ');
	     * // => '  abc'
	     *
	     * _.trimRight('-_-abc-_-', '_-');
	     * // => '-_-abc'
	     */
	    function trimRight(string, chars, guard) {
	      var value = string;
	      string = baseToString(string);
	      if (!string) {
	        return string;
	      }
	      if (guard ? isIterateeCall(value, chars, guard) : chars == null) {
	        return string.slice(0, trimmedRightIndex(string) + 1);
	      }
	      return string.slice(0, charsRightIndex(string, (chars + '')) + 1);
	    }
	
	    /**
	     * Truncates `string` if it's longer than the given maximum string length.
	     * The last characters of the truncated string are replaced with the omission
	     * string which defaults to "...".
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to truncate.
	     * @param {Object|number} [options] The options object or maximum string length.
	     * @param {number} [options.length=30] The maximum string length.
	     * @param {string} [options.omission='...'] The string to indicate text is omitted.
	     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {string} Returns the truncated string.
	     * @example
	     *
	     * _.trunc('hi-diddly-ho there, neighborino');
	     * // => 'hi-diddly-ho there, neighbo...'
	     *
	     * _.trunc('hi-diddly-ho there, neighborino', 24);
	     * // => 'hi-diddly-ho there, n...'
	     *
	     * _.trunc('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': ' '
	     * });
	     * // => 'hi-diddly-ho there,...'
	     *
	     * _.trunc('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': /,? +/
	     * });
	     * // => 'hi-diddly-ho there...'
	     *
	     * _.trunc('hi-diddly-ho there, neighborino', {
	     *   'omission': ' [...]'
	     * });
	     * // => 'hi-diddly-ho there, neig [...]'
	     */
	    function trunc(string, options, guard) {
	      if (guard && isIterateeCall(string, options, guard)) {
	        options = null;
	      }
	      var length = DEFAULT_TRUNC_LENGTH,
	          omission = DEFAULT_TRUNC_OMISSION;
	
	      if (options != null) {
	        if (isObject(options)) {
	          var separator = 'separator' in options ? options.separator : separator;
	          length = 'length' in options ? (+options.length || 0) : length;
	          omission = 'omission' in options ? baseToString(options.omission) : omission;
	        } else {
	          length = +options || 0;
	        }
	      }
	      string = baseToString(string);
	      if (length >= string.length) {
	        return string;
	      }
	      var end = length - omission.length;
	      if (end < 1) {
	        return omission;
	      }
	      var result = string.slice(0, end);
	      if (separator == null) {
	        return result + omission;
	      }
	      if (isRegExp(separator)) {
	        if (string.slice(end).search(separator)) {
	          var match,
	              newEnd,
	              substring = string.slice(0, end);
	
	          if (!separator.global) {
	            separator = RegExp(separator.source, (reFlags.exec(separator) || '') + 'g');
	          }
	          separator.lastIndex = 0;
	          while ((match = separator.exec(substring))) {
	            newEnd = match.index;
	          }
	          result = result.slice(0, newEnd == null ? end : newEnd);
	        }
	      } else if (string.indexOf(separator, end) != end) {
	        var index = result.lastIndexOf(separator);
	        if (index > -1) {
	          result = result.slice(0, index);
	        }
	      }
	      return result + omission;
	    }
	
	    /**
	     * The inverse of `_.escape`; this method converts the HTML entities
	     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, `&#39;`, and `&#96;` in `string` to their
	     * corresponding characters.
	     *
	     * **Note:** No other HTML entities are unescaped. To unescape additional HTML
	     * entities use a third-party library like [_he_](https://mths.be/he).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to unescape.
	     * @returns {string} Returns the unescaped string.
	     * @example
	     *
	     * _.unescape('fred, barney, &amp; pebbles');
	     * // => 'fred, barney, & pebbles'
	     */
	    function unescape(string) {
	      string = baseToString(string);
	      return (string && reHasEscapedHtml.test(string))
	        ? string.replace(reEscapedHtml, unescapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Splits `string` into an array of its words.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {RegExp|string} [pattern] The pattern to match words.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Array} Returns the words of `string`.
	     * @example
	     *
	     * _.words('fred, barney, & pebbles');
	     * // => ['fred', 'barney', 'pebbles']
	     *
	     * _.words('fred, barney, & pebbles', /[^, ]+/g);
	     * // => ['fred', 'barney', '&', 'pebbles']
	     */
	    function words(string, pattern, guard) {
	      if (guard && isIterateeCall(string, pattern, guard)) {
	        pattern = null;
	      }
	      string = baseToString(string);
	      return string.match(pattern || reWords) || [];
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Attempts to invoke `func`, returning either the result or the caught error
	     * object. Any additional arguments are provided to `func` when it is invoked.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Function} func The function to attempt.
	     * @returns {*} Returns the `func` result or error object.
	     * @example
	     *
	     * // avoid throwing errors for invalid selectors
	     * var elements = _.attempt(function(selector) {
	     *   return document.querySelectorAll(selector);
	     * }, '>_>');
	     *
	     * if (_.isError(elements)) {
	     *   elements = [];
	     * }
	     */
	    var attempt = restParam(function(func, args) {
	      try {
	        return func.apply(undefined, args);
	      } catch(e) {
	        return isError(e) ? e : new Error(e);
	      }
	    });
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of `thisArg`
	     * and arguments of the created function. If `func` is a property name the
	     * created callback returns the property value for a given element. If `func`
	     * is an object the created callback returns `true` for elements that contain
	     * the equivalent object properties, otherwise it returns `false`.
	     *
	     * @static
	     * @memberOf _
	     * @alias iteratee
	     * @category Utility
	     * @param {*} [func=_.identity] The value to convert to a callback.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Function} Returns the callback.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * // wrap to create custom callback shorthands
	     * _.callback = _.wrap(_.callback, function(callback, func, thisArg) {
	     *   var match = /^(.+?)__([gl]t)(.+)$/.exec(func);
	     *   if (!match) {
	     *     return callback(func, thisArg);
	     *   }
	     *   return function(object) {
	     *     return match[2] == 'gt'
	     *       ? object[match[1]] > match[3]
	     *       : object[match[1]] < match[3];
	     *   };
	     * });
	     *
	     * _.filter(users, 'age__gt36');
	     * // => [{ 'user': 'fred', 'age': 40 }]
	     */
	    function callback(func, thisArg, guard) {
	      if (guard && isIterateeCall(func, thisArg, guard)) {
	        thisArg = null;
	      }
	      return isObjectLike(func)
	        ? matches(func)
	        : baseCallback(func, thisArg);
	    }
	
	    /**
	     * Creates a function that returns `value`.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {*} value The value to return from the new function.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var object = { 'user': 'fred' };
	     * var getter = _.constant(object);
	     *
	     * getter() === object;
	     * // => true
	     */
	    function constant(value) {
	      return function() {
	        return value;
	      };
	    }
	
	    /**
	     * This method returns the first argument provided to it.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {*} value Any value.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * _.identity(object) === object;
	     * // => true
	     */
	    function identity(value) {
	      return value;
	    }
	
	    /**
	     * Creates a function that performs a deep comparison between a given object
	     * and `source`, returning `true` if the given object has equivalent property
	     * values, else `false`.
	     *
	     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
	     * numbers, `Object` objects, regexes, and strings. Objects are compared by
	     * their own, not inherited, enumerable properties. For comparing a single
	     * own or inherited property value see `_.matchesProperty`.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * _.filter(users, _.matches({ 'age': 40, 'active': false }));
	     * // => [{ 'user': 'fred', 'age': 40, 'active': false }]
	     */
	    function matches(source) {
	      return baseMatches(baseClone(source, true));
	    }
	
	    /**
	     * Creates a function that compares the property value of `path` on a given
	     * object to `value`.
	     *
	     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
	     * numbers, `Object` objects, regexes, and strings. Objects are compared by
	     * their own, not inherited, enumerable properties.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * _.find(users, _.matchesProperty('user', 'fred'));
	     * // => { 'user': 'fred' }
	     */
	    function matchesProperty(path, srcValue) {
	      return baseMatchesProperty(path, baseClone(srcValue, true));
	    }
	
	    /**
	     * Creates a function that invokes the method at `path` on a given object.
	     * Any additional arguments are provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': { 'c': _.constant(2) } } },
	     *   { 'a': { 'b': { 'c': _.constant(1) } } }
	     * ];
	     *
	     * _.map(objects, _.method('a.b.c'));
	     * // => [2, 1]
	     *
	     * _.invoke(_.sortBy(objects, _.method(['a', 'b', 'c'])), 'a.b.c');
	     * // => [1, 2]
	     */
	    var method = restParam(function(path, args) {
	      return function(object) {
	        return invokePath(object, path, args);
	      };
	    });
	
	    /**
	     * The opposite of `_.method`; this method creates a function that invokes
	     * the method at a given path on `object`. Any additional arguments are
	     * provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Object} object The object to query.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var array = _.times(3, _.constant),
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
	     * // => [2, 0]
	     */
	    var methodOf = restParam(function(object, args) {
	      return function(path) {
	        return invokePath(object, path, args);
	      };
	    });
	
	    /**
	     * Adds all own enumerable function properties of a source object to the
	     * destination object. If `object` is a function then methods are added to
	     * its prototype as well.
	     *
	     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
	     * avoid conflicts caused by modifying the original.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Function|Object} [object=lodash] The destination object.
	     * @param {Object} source The object of functions to add.
	     * @param {Object} [options] The options object.
	     * @param {boolean} [options.chain=true] Specify whether the functions added
	     *  are chainable.
	     * @returns {Function|Object} Returns `object`.
	     * @example
	     *
	     * function vowels(string) {
	     *   return _.filter(string, function(v) {
	     *     return /[aeiou]/i.test(v);
	     *   });
	     * }
	     *
	     * _.mixin({ 'vowels': vowels });
	     * _.vowels('fred');
	     * // => ['e']
	     *
	     * _('fred').vowels().value();
	     * // => ['e']
	     *
	     * _.mixin({ 'vowels': vowels }, { 'chain': false });
	     * _('fred').vowels();
	     * // => ['e']
	     */
	    function mixin(object, source, options) {
	      if (options == null) {
	        var isObj = isObject(source),
	            props = isObj ? keys(source) : null,
	            methodNames = (props && props.length) ? baseFunctions(source, props) : null;
	
	        if (!(methodNames ? methodNames.length : isObj)) {
	          methodNames = false;
	          options = source;
	          source = object;
	          object = this;
	        }
	      }
	      if (!methodNames) {
	        methodNames = baseFunctions(source, keys(source));
	      }
	      var chain = true,
	          index = -1,
	          isFunc = isFunction(object),
	          length = methodNames.length;
	
	      if (options === false) {
	        chain = false;
	      } else if (isObject(options) && 'chain' in options) {
	        chain = options.chain;
	      }
	      while (++index < length) {
	        var methodName = methodNames[index],
	            func = source[methodName];
	
	        object[methodName] = func;
	        if (isFunc) {
	          object.prototype[methodName] = (function(func) {
	            return function() {
	              var chainAll = this.__chain__;
	              if (chain || chainAll) {
	                var result = object(this.__wrapped__),
	                    actions = result.__actions__ = arrayCopy(this.__actions__);
	
	                actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
	                result.__chain__ = chainAll;
	                return result;
	              }
	              var args = [this.value()];
	              push.apply(args, arguments);
	              return func.apply(object, args);
	            };
	          }(func));
	        }
	      }
	      return object;
	    }
	
	    /**
	     * Reverts the `_` variable to its previous value and returns a reference to
	     * the `lodash` function.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @returns {Function} Returns the `lodash` function.
	     * @example
	     *
	     * var lodash = _.noConflict();
	     */
	    function noConflict() {
	      context._ = oldDash;
	      return this;
	    }
	
	    /**
	     * A no-operation function that returns `undefined` regardless of the
	     * arguments it receives.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @example
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * _.noop(object) === undefined;
	     * // => true
	     */
	    function noop() {
	      // No operation performed.
	    }
	
	    /**
	     * Creates a function that returns the property value at `path` on a
	     * given object.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': { 'c': 2 } } },
	     *   { 'a': { 'b': { 'c': 1 } } }
	     * ];
	     *
	     * _.map(objects, _.property('a.b.c'));
	     * // => [2, 1]
	     *
	     * _.pluck(_.sortBy(objects, _.property(['a', 'b', 'c'])), 'a.b.c');
	     * // => [1, 2]
	     */
	    function property(path) {
	      return isKey(path) ? baseProperty(path) : basePropertyDeep(path);
	    }
	
	    /**
	     * The opposite of `_.property`; this method creates a function that returns
	     * the property value at a given path on `object`.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Object} object The object to query.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var array = [0, 1, 2],
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
	     * // => [2, 0]
	     */
	    function propertyOf(object) {
	      return function(path) {
	        return baseGet(object, toPath(path), path + '');
	      };
	    }
	
	    /**
	     * Creates an array of numbers (positive and/or negative) progressing from
	     * `start` up to, but not including, `end`. If `end` is not specified it is
	     * set to `start` with `start` then set to `0`. If `end` is less than `start`
	     * a zero-length range is created unless a negative `step` is specified.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the new array of numbers.
	     * @example
	     *
	     * _.range(4);
	     * // => [0, 1, 2, 3]
	     *
	     * _.range(1, 5);
	     * // => [1, 2, 3, 4]
	     *
	     * _.range(0, 20, 5);
	     * // => [0, 5, 10, 15]
	     *
	     * _.range(0, -4, -1);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.range(0);
	     * // => []
	     */
	    function range(start, end, step) {
	      if (step && isIterateeCall(start, end, step)) {
	        end = step = null;
	      }
	      start = +start || 0;
	      step = step == null ? 1 : (+step || 0);
	
	      if (end == null) {
	        end = start;
	        start = 0;
	      } else {
	        end = +end || 0;
	      }
	      // Use `Array(length)` so engines like Chakra and V8 avoid slower modes.
	      // See https://youtu.be/XAqIpGU8ZZk#t=17m25s for more details.
	      var index = -1,
	          length = nativeMax(ceil((end - start) / (step || 1)), 0),
	          result = Array(length);
	
	      while (++index < length) {
	        result[index] = start;
	        start += step;
	      }
	      return result;
	    }
	
	    /**
	     * Invokes the iteratee function `n` times, returning an array of the results
	     * of each invocation. The `iteratee` is bound to `thisArg` and invoked with
	     * one argument; (index).
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {number} n The number of times to invoke `iteratee`.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * var diceRolls = _.times(3, _.partial(_.random, 1, 6, false));
	     * // => [3, 6, 4]
	     *
	     * _.times(3, function(n) {
	     *   mage.castSpell(n);
	     * });
	     * // => invokes `mage.castSpell(n)` three times with `n` of `0`, `1`, and `2`
	     *
	     * _.times(3, function(n) {
	     *   this.cast(n);
	     * }, mage);
	     * // => also invokes `mage.castSpell(n)` three times
	     */
	    function times(n, iteratee, thisArg) {
	      n = floor(n);
	
	      // Exit early to avoid a JSC JIT bug in Safari 8
	      // where `Array(0)` is treated as `Array(1)`.
	      if (n < 1 || !nativeIsFinite(n)) {
	        return [];
	      }
	      var index = -1,
	          result = Array(nativeMin(n, MAX_ARRAY_LENGTH));
	
	      iteratee = bindCallback(iteratee, thisArg, 1);
	      while (++index < n) {
	        if (index < MAX_ARRAY_LENGTH) {
	          result[index] = iteratee(index);
	        } else {
	          iteratee(index);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Generates a unique ID. If `prefix` is provided the ID is appended to it.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {string} [prefix] The value to prefix the ID with.
	     * @returns {string} Returns the unique ID.
	     * @example
	     *
	     * _.uniqueId('contact_');
	     * // => 'contact_104'
	     *
	     * _.uniqueId();
	     * // => '105'
	     */
	    function uniqueId(prefix) {
	      var id = ++idCounter;
	      return baseToString(prefix) + id;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Adds two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {number} augend The first number to add.
	     * @param {number} addend The second number to add.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * _.add(6, 4);
	     * // => 10
	     */
	    function add(augend, addend) {
	      return (+augend || 0) + (+addend || 0);
	    }
	
	    /**
	     * Gets the maximum value of `collection`. If `collection` is empty or falsey
	     * `-Infinity` is returned. If an iteratee function is provided it is invoked
	     * for each value in `collection` to generate the criterion by which the value
	     * is ranked. The `iteratee` is bound to `thisArg` and invoked with three
	     * arguments: (value, index, collection).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * _.max([4, 2, 8, 6]);
	     * // => 8
	     *
	     * _.max([]);
	     * // => -Infinity
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * _.max(users, function(chr) {
	     *   return chr.age;
	     * });
	     * // => { 'user': 'fred', 'age': 40 }
	     *
	     * // using the `_.property` callback shorthand
	     * _.max(users, 'age');
	     * // => { 'user': 'fred', 'age': 40 }
	     */
	    var max = createExtremum(gt, NEGATIVE_INFINITY);
	
	    /**
	     * Gets the minimum value of `collection`. If `collection` is empty or falsey
	     * `Infinity` is returned. If an iteratee function is provided it is invoked
	     * for each value in `collection` to generate the criterion by which the value
	     * is ranked. The `iteratee` is bound to `thisArg` and invoked with three
	     * arguments: (value, index, collection).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * _.min([4, 2, 8, 6]);
	     * // => 2
	     *
	     * _.min([]);
	     * // => Infinity
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * _.min(users, function(chr) {
	     *   return chr.age;
	     * });
	     * // => { 'user': 'barney', 'age': 36 }
	     *
	     * // using the `_.property` callback shorthand
	     * _.min(users, 'age');
	     * // => { 'user': 'barney', 'age': 36 }
	     */
	    var min = createExtremum(lt, POSITIVE_INFINITY);
	
	    /**
	     * Gets the sum of the values in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * _.sum([4, 6]);
	     * // => 10
	     *
	     * _.sum({ 'a': 4, 'b': 6 });
	     * // => 10
	     *
	     * var objects = [
	     *   { 'n': 4 },
	     *   { 'n': 6 }
	     * ];
	     *
	     * _.sum(objects, function(object) {
	     *   return object.n;
	     * });
	     * // => 10
	     *
	     * // using the `_.property` callback shorthand
	     * _.sum(objects, 'n');
	     * // => 10
	     */
	    function sum(collection, iteratee, thisArg) {
	      if (thisArg && isIterateeCall(collection, iteratee, thisArg)) {
	        iteratee = null;
	      }
	      var callback = getCallback(),
	          noIteratee = iteratee == null;
	
	      if (!(noIteratee && callback === baseCallback)) {
	        noIteratee = false;
	        iteratee = callback(iteratee, thisArg, 3);
	      }
	      return noIteratee
	        ? arraySum(isArray(collection) ? collection : toIterable(collection))
	        : baseSum(collection, iteratee);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    // Ensure wrappers are instances of `baseLodash`.
	    lodash.prototype = baseLodash.prototype;
	
	    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
	    LodashWrapper.prototype.constructor = LodashWrapper;
	
	    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
	    LazyWrapper.prototype.constructor = LazyWrapper;
	
	    // Add functions to the `Map` cache.
	    MapCache.prototype['delete'] = mapDelete;
	    MapCache.prototype.get = mapGet;
	    MapCache.prototype.has = mapHas;
	    MapCache.prototype.set = mapSet;
	
	    // Add functions to the `Set` cache.
	    SetCache.prototype.push = cachePush;
	
	    // Assign cache to `_.memoize`.
	    memoize.Cache = MapCache;
	
	    // Add functions that return wrapped values when chaining.
	    lodash.after = after;
	    lodash.ary = ary;
	    lodash.assign = assign;
	    lodash.at = at;
	    lodash.before = before;
	    lodash.bind = bind;
	    lodash.bindAll = bindAll;
	    lodash.bindKey = bindKey;
	    lodash.callback = callback;
	    lodash.chain = chain;
	    lodash.chunk = chunk;
	    lodash.compact = compact;
	    lodash.constant = constant;
	    lodash.countBy = countBy;
	    lodash.create = create;
	    lodash.curry = curry;
	    lodash.curryRight = curryRight;
	    lodash.debounce = debounce;
	    lodash.defaults = defaults;
	    lodash.defer = defer;
	    lodash.delay = delay;
	    lodash.difference = difference;
	    lodash.drop = drop;
	    lodash.dropRight = dropRight;
	    lodash.dropRightWhile = dropRightWhile;
	    lodash.dropWhile = dropWhile;
	    lodash.fill = fill;
	    lodash.filter = filter;
	    lodash.flatten = flatten;
	    lodash.flattenDeep = flattenDeep;
	    lodash.flow = flow;
	    lodash.flowRight = flowRight;
	    lodash.forEach = forEach;
	    lodash.forEachRight = forEachRight;
	    lodash.forIn = forIn;
	    lodash.forInRight = forInRight;
	    lodash.forOwn = forOwn;
	    lodash.forOwnRight = forOwnRight;
	    lodash.functions = functions;
	    lodash.groupBy = groupBy;
	    lodash.indexBy = indexBy;
	    lodash.initial = initial;
	    lodash.intersection = intersection;
	    lodash.invert = invert;
	    lodash.invoke = invoke;
	    lodash.keys = keys;
	    lodash.keysIn = keysIn;
	    lodash.map = map;
	    lodash.mapKeys = mapKeys;
	    lodash.mapValues = mapValues;
	    lodash.matches = matches;
	    lodash.matchesProperty = matchesProperty;
	    lodash.memoize = memoize;
	    lodash.merge = merge;
	    lodash.method = method;
	    lodash.methodOf = methodOf;
	    lodash.mixin = mixin;
	    lodash.negate = negate;
	    lodash.omit = omit;
	    lodash.once = once;
	    lodash.pairs = pairs;
	    lodash.partial = partial;
	    lodash.partialRight = partialRight;
	    lodash.partition = partition;
	    lodash.pick = pick;
	    lodash.pluck = pluck;
	    lodash.property = property;
	    lodash.propertyOf = propertyOf;
	    lodash.pull = pull;
	    lodash.pullAt = pullAt;
	    lodash.range = range;
	    lodash.rearg = rearg;
	    lodash.reject = reject;
	    lodash.remove = remove;
	    lodash.rest = rest;
	    lodash.restParam = restParam;
	    lodash.set = set;
	    lodash.shuffle = shuffle;
	    lodash.slice = slice;
	    lodash.sortBy = sortBy;
	    lodash.sortByAll = sortByAll;
	    lodash.sortByOrder = sortByOrder;
	    lodash.spread = spread;
	    lodash.take = take;
	    lodash.takeRight = takeRight;
	    lodash.takeRightWhile = takeRightWhile;
	    lodash.takeWhile = takeWhile;
	    lodash.tap = tap;
	    lodash.throttle = throttle;
	    lodash.thru = thru;
	    lodash.times = times;
	    lodash.toArray = toArray;
	    lodash.toPlainObject = toPlainObject;
	    lodash.transform = transform;
	    lodash.union = union;
	    lodash.uniq = uniq;
	    lodash.unzip = unzip;
	    lodash.unzipWith = unzipWith;
	    lodash.values = values;
	    lodash.valuesIn = valuesIn;
	    lodash.where = where;
	    lodash.without = without;
	    lodash.wrap = wrap;
	    lodash.xor = xor;
	    lodash.zip = zip;
	    lodash.zipObject = zipObject;
	    lodash.zipWith = zipWith;
	
	    // Add aliases.
	    lodash.backflow = flowRight;
	    lodash.collect = map;
	    lodash.compose = flowRight;
	    lodash.each = forEach;
	    lodash.eachRight = forEachRight;
	    lodash.extend = assign;
	    lodash.iteratee = callback;
	    lodash.methods = functions;
	    lodash.object = zipObject;
	    lodash.select = filter;
	    lodash.tail = rest;
	    lodash.unique = uniq;
	
	    // Add functions to `lodash.prototype`.
	    mixin(lodash, lodash);
	
	    /*------------------------------------------------------------------------*/
	
	    // Add functions that return unwrapped values when chaining.
	    lodash.add = add;
	    lodash.attempt = attempt;
	    lodash.camelCase = camelCase;
	    lodash.capitalize = capitalize;
	    lodash.clone = clone;
	    lodash.cloneDeep = cloneDeep;
	    lodash.deburr = deburr;
	    lodash.endsWith = endsWith;
	    lodash.escape = escape;
	    lodash.escapeRegExp = escapeRegExp;
	    lodash.every = every;
	    lodash.find = find;
	    lodash.findIndex = findIndex;
	    lodash.findKey = findKey;
	    lodash.findLast = findLast;
	    lodash.findLastIndex = findLastIndex;
	    lodash.findLastKey = findLastKey;
	    lodash.findWhere = findWhere;
	    lodash.first = first;
	    lodash.get = get;
	    lodash.gt = gt;
	    lodash.gte = gte;
	    lodash.has = has;
	    lodash.identity = identity;
	    lodash.includes = includes;
	    lodash.indexOf = indexOf;
	    lodash.inRange = inRange;
	    lodash.isArguments = isArguments;
	    lodash.isArray = isArray;
	    lodash.isBoolean = isBoolean;
	    lodash.isDate = isDate;
	    lodash.isElement = isElement;
	    lodash.isEmpty = isEmpty;
	    lodash.isEqual = isEqual;
	    lodash.isError = isError;
	    lodash.isFinite = isFinite;
	    lodash.isFunction = isFunction;
	    lodash.isMatch = isMatch;
	    lodash.isNaN = isNaN;
	    lodash.isNative = isNative;
	    lodash.isNull = isNull;
	    lodash.isNumber = isNumber;
	    lodash.isObject = isObject;
	    lodash.isPlainObject = isPlainObject;
	    lodash.isRegExp = isRegExp;
	    lodash.isString = isString;
	    lodash.isTypedArray = isTypedArray;
	    lodash.isUndefined = isUndefined;
	    lodash.kebabCase = kebabCase;
	    lodash.last = last;
	    lodash.lastIndexOf = lastIndexOf;
	    lodash.lt = lt;
	    lodash.lte = lte;
	    lodash.max = max;
	    lodash.min = min;
	    lodash.noConflict = noConflict;
	    lodash.noop = noop;
	    lodash.now = now;
	    lodash.pad = pad;
	    lodash.padLeft = padLeft;
	    lodash.padRight = padRight;
	    lodash.parseInt = parseInt;
	    lodash.random = random;
	    lodash.reduce = reduce;
	    lodash.reduceRight = reduceRight;
	    lodash.repeat = repeat;
	    lodash.result = result;
	    lodash.runInContext = runInContext;
	    lodash.size = size;
	    lodash.snakeCase = snakeCase;
	    lodash.some = some;
	    lodash.sortedIndex = sortedIndex;
	    lodash.sortedLastIndex = sortedLastIndex;
	    lodash.startCase = startCase;
	    lodash.startsWith = startsWith;
	    lodash.sum = sum;
	    lodash.template = template;
	    lodash.trim = trim;
	    lodash.trimLeft = trimLeft;
	    lodash.trimRight = trimRight;
	    lodash.trunc = trunc;
	    lodash.unescape = unescape;
	    lodash.uniqueId = uniqueId;
	    lodash.words = words;
	
	    // Add aliases.
	    lodash.all = every;
	    lodash.any = some;
	    lodash.contains = includes;
	    lodash.eq = isEqual;
	    lodash.detect = find;
	    lodash.foldl = reduce;
	    lodash.foldr = reduceRight;
	    lodash.head = first;
	    lodash.include = includes;
	    lodash.inject = reduce;
	
	    mixin(lodash, (function() {
	      var source = {};
	      baseForOwn(lodash, function(func, methodName) {
	        if (!lodash.prototype[methodName]) {
	          source[methodName] = func;
	        }
	      });
	      return source;
	    }()), false);
	
	    /*------------------------------------------------------------------------*/
	
	    // Add functions capable of returning wrapped and unwrapped values when chaining.
	    lodash.sample = sample;
	
	    lodash.prototype.sample = function(n) {
	      if (!this.__chain__ && n == null) {
	        return sample(this.value());
	      }
	      return this.thru(function(value) {
	        return sample(value, n);
	      });
	    };
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The semantic version number.
	     *
	     * @static
	     * @memberOf _
	     * @type string
	     */
	    lodash.VERSION = VERSION;
	
	    // Assign default placeholders.
	    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
	      lodash[methodName].placeholder = lodash;
	    });
	
	    // Add `LazyWrapper` methods that accept an `iteratee` value.
	    arrayEach(['dropWhile', 'filter', 'map', 'takeWhile'], function(methodName, type) {
	      var isFilter = type != LAZY_MAP_FLAG,
	          isDropWhile = type == LAZY_DROP_WHILE_FLAG;
	
	      LazyWrapper.prototype[methodName] = function(iteratee, thisArg) {
	        var filtered = this.__filtered__,
	            result = (filtered && isDropWhile) ? new LazyWrapper(this) : this.clone(),
	            iteratees = result.__iteratees__ || (result.__iteratees__ = []);
	
	        iteratees.push({
	          'done': false,
	          'count': 0,
	          'index': 0,
	          'iteratee': getCallback(iteratee, thisArg, 1),
	          'limit': -1,
	          'type': type
	        });
	
	        result.__filtered__ = filtered || isFilter;
	        return result;
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
	    arrayEach(['drop', 'take'], function(methodName, index) {
	      var whileName = methodName + 'While';
	
	      LazyWrapper.prototype[methodName] = function(n) {
	        var filtered = this.__filtered__,
	            result = (filtered && !index) ? this.dropWhile() : this.clone();
	
	        n = n == null ? 1 : nativeMax(floor(n) || 0, 0);
	        if (filtered) {
	          if (index) {
	            result.__takeCount__ = nativeMin(result.__takeCount__, n);
	          } else {
	            last(result.__iteratees__).limit = n;
	          }
	        } else {
	          var views = result.__views__ || (result.__views__ = []);
	          views.push({ 'size': n, 'type': methodName + (result.__dir__ < 0 ? 'Right' : '') });
	        }
	        return result;
	      };
	
	      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
	        return this.reverse()[methodName](n).reverse();
	      };
	
	      LazyWrapper.prototype[methodName + 'RightWhile'] = function(predicate, thisArg) {
	        return this.reverse()[whileName](predicate, thisArg).reverse();
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.first` and `_.last`.
	    arrayEach(['first', 'last'], function(methodName, index) {
	      var takeName = 'take' + (index ? 'Right' : '');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this[takeName](1).value()[0];
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.initial` and `_.rest`.
	    arrayEach(['initial', 'rest'], function(methodName, index) {
	      var dropName = 'drop' + (index ? '' : 'Right');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this[dropName](1);
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.pluck` and `_.where`.
	    arrayEach(['pluck', 'where'], function(methodName, index) {
	      var operationName = index ? 'filter' : 'map',
	          createCallback = index ? baseMatches : property;
	
	      LazyWrapper.prototype[methodName] = function(value) {
	        return this[operationName](createCallback(value));
	      };
	    });
	
	    LazyWrapper.prototype.compact = function() {
	      return this.filter(identity);
	    };
	
	    LazyWrapper.prototype.reject = function(predicate, thisArg) {
	      predicate = getCallback(predicate, thisArg, 1);
	      return this.filter(function(value) {
	        return !predicate(value);
	      });
	    };
	
	    LazyWrapper.prototype.slice = function(start, end) {
	      start = start == null ? 0 : (+start || 0);
	
	      var result = this;
	      if (start < 0) {
	        result = this.takeRight(-start);
	      } else if (start) {
	        result = this.drop(start);
	      }
	      if (end !== undefined) {
	        end = (+end || 0);
	        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
	      }
	      return result;
	    };
	
	    LazyWrapper.prototype.toArray = function() {
	      return this.drop(0);
	    };
	
	    // Add `LazyWrapper` methods to `lodash.prototype`.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var lodashFunc = lodash[methodName];
	      if (!lodashFunc) {
	        return;
	      }
	      var checkIteratee = /^(?:filter|map|reject)|While$/.test(methodName),
	          retUnwrapped = /^(?:first|last)$/.test(methodName);
	
	      lodash.prototype[methodName] = function() {
	        var args = arguments,
	            chainAll = this.__chain__,
	            value = this.__wrapped__,
	            isHybrid = !!this.__actions__.length,
	            isLazy = value instanceof LazyWrapper,
	            iteratee = args[0],
	            useLazy = isLazy || isArray(value);
	
	        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
	          // avoid lazy use if the iteratee has a "length" value other than `1`
	          isLazy = useLazy = false;
	        }
	        var onlyLazy = isLazy && !isHybrid;
	        if (retUnwrapped && !chainAll) {
	          return onlyLazy
	            ? func.call(value)
	            : lodashFunc.call(lodash, this.value());
	        }
	        var interceptor = function(value) {
	          var otherArgs = [value];
	          push.apply(otherArgs, args);
	          return lodashFunc.apply(lodash, otherArgs);
	        };
	        if (useLazy) {
	          var wrapper = onlyLazy ? value : new LazyWrapper(this),
	              result = func.apply(wrapper, args);
	
	          if (!retUnwrapped && (isHybrid || result.__actions__)) {
	            var actions = result.__actions__ || (result.__actions__ = []);
	            actions.push({ 'func': thru, 'args': [interceptor], 'thisArg': lodash });
	          }
	          return new LodashWrapper(result, chainAll);
	        }
	        return this.thru(interceptor);
	      };
	    });
	
	    // Add `Array` and `String` methods to `lodash.prototype`.
	    arrayEach(['concat', 'join', 'pop', 'push', 'replace', 'shift', 'sort', 'splice', 'split', 'unshift'], function(methodName) {
	      var func = (/^(?:replace|split)$/.test(methodName) ? stringProto : arrayProto)[methodName],
	          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
	          retUnwrapped = /^(?:join|pop|replace|shift)$/.test(methodName);
	
	      lodash.prototype[methodName] = function() {
	        var args = arguments;
	        if (retUnwrapped && !this.__chain__) {
	          return func.apply(this.value(), args);
	        }
	        return this[chainName](function(value) {
	          return func.apply(value, args);
	        });
	      };
	    });
	
	    // Map minified function names to their real names.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var lodashFunc = lodash[methodName];
	      if (lodashFunc) {
	        var key = lodashFunc.name,
	            names = realNames[key] || (realNames[key] = []);
	
	        names.push({ 'name': methodName, 'func': lodashFunc });
	      }
	    });
	
	    realNames[createHybridWrapper(null, BIND_KEY_FLAG).name] = [{ 'name': 'wrapper', 'func': null }];
	
	    // Add functions to the lazy wrapper.
	    LazyWrapper.prototype.clone = lazyClone;
	    LazyWrapper.prototype.reverse = lazyReverse;
	    LazyWrapper.prototype.value = lazyValue;
	
	    // Add chaining functions to the `lodash` wrapper.
	    lodash.prototype.chain = wrapperChain;
	    lodash.prototype.commit = wrapperCommit;
	    lodash.prototype.plant = wrapperPlant;
	    lodash.prototype.reverse = wrapperReverse;
	    lodash.prototype.toString = wrapperToString;
	    lodash.prototype.run = lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
	
	    // Add function aliases to the `lodash` wrapper.
	    lodash.prototype.collect = lodash.prototype.map;
	    lodash.prototype.head = lodash.prototype.first;
	    lodash.prototype.select = lodash.prototype.filter;
	    lodash.prototype.tail = lodash.prototype.rest;
	
	    return lodash;
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  // Export lodash.
	  var _ = runInContext();
	
	  // Some AMD build optimizers like r.js check for condition patterns like the following:
	  if (true) {
	    // Expose lodash to the global object when an AMD loader is present to avoid
	    // errors in cases where lodash is loaded by a script tag and not intended
	    // as an AMD module. See http://requirejs.org/docs/errors.html#mismatch for
	    // more details.
	    root._ = _;
	
	    // Define as an anonymous module so, through path mapping, it can be
	    // referenced as the "underscore" module.
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return _;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	  // Check for `exports` after `define` in case a build optimizer adds an `exports` object.
	  else if (freeExports && freeModule) {
	    // Export for Node.js or RingoJS.
	    if (moduleExports) {
	      (freeModule.exports = _)._ = _;
	    }
	    // Export for Rhino with CommonJS support.
	    else {
	      freeExports._ = _;
	    }
	  }
	  else {
	    // Export for a browser or Rhino.
	    root._ = _;
	  }
	}.call(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(157)(module), (function() { return this; }())))

/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var createMarkupForStyles = __webpack_require__(456);
	var Prefixer = __webpack_require__(276);
	
	var React = __webpack_require__(1);
	
	var buildCssString = function buildCssString(component, selector, rules) {
	  if (!selector || !rules) {
	    return;
	  }
	
	  var prefixedRules = Prefixer.getPrefixedStyle(component, rules, 'css');
	  var serializedRules = createMarkupForStyles(prefixedRules);
	
	  return selector + '{' + serializedRules + '}';
	};
	
	var Style = React.createClass({
	  displayName: 'Style',
	
	  propTypes: {
	    rules: React.PropTypes.object,
	    scopeSelector: React.PropTypes.string
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      scopeSelector: ''
	    };
	  },
	
	  _buildStyles: function _buildStyles(styles) {
	    var _this = this;
	
	    return Object.keys(styles).reduce(function (accumulator, selector) {
	      var rules = styles[selector];
	
	      if (selector === 'mediaQueries') {
	        accumulator += _this._buildMediaQueryString(rules);
	      } else {
	        var completeSelector = (_this.props.scopeSelector ? _this.props.scopeSelector + ' ' : '') + selector;
	        accumulator += buildCssString(_this, completeSelector, rules);
	      }
	
	      return accumulator;
	    }, '');
	  },
	
	  _buildMediaQueryString: function _buildMediaQueryString(mediaQueryObj) {
	    var _this2 = this;
	
	    var contextMediaQueries = this._getContextMediaQueries();
	    var mediaQueryString = '';
	
	    Object.keys(mediaQueryObj).forEach(function (query) {
	      var completeQuery = contextMediaQueries[query] ? contextMediaQueries[query] : query;
	      mediaQueryString += '@media ' + completeQuery + '{' + _this2._buildStyles(mediaQueryObj[query]) + '}';
	    });
	
	    return mediaQueryString;
	  },
	
	  _getContextMediaQueries: function _getContextMediaQueries() {
	    var contextMediaQueries = {};
	    if (this.context && this.context.mediaQueries) {
	      Object.keys(this.context.mediaQueries).forEach((function (query) {
	        contextMediaQueries[query] = this.context.mediaQueries[query].media;
	      }).bind(this));
	    }
	
	    return contextMediaQueries;
	  },
	
	  render: function render() {
	    if (!this.props.rules) {
	      return null;
	    }
	
	    var styles = this._buildStyles(this.props.rules);
	
	    return React.createElement('style', { dangerouslySetInnerHTML: { __html: styles } });
	  }
	});
	
	module.exports = Style;

/***/ }),
/* 456 */
/***/ (function(module, exports) {

	/* @flow */
	
	'use strict';
	
	var createMarkupForStyles = function createMarkupForStyles(style /*: Object*/, spaces /*: string*/) /*: string*/ {
	  spaces = spaces || '';
	  return Object.keys(style).map(function (property) {
	    return spaces + property + ': ' + style[property] + ';';
	  }).join('\n');
	};
	
	module.exports = createMarkupForStyles;

/***/ }),
/* 457 */
/***/ (function(module, exports) {

	/* @flow */
	
	'use strict';
	
	var getStateKey = function getStateKey(elementKey /*: ?string*/) /*: string*/ {
	  return elementKey === null || elementKey === undefined ? 'main' : elementKey.toString();
	};
	
	module.exports = getStateKey;

/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

	/* @flow */
	
	'use strict';
	
	var getStateKey = __webpack_require__(457);
	
	var VALID_KEYS = [':active', ':focus', ':hover'];
	
	var getState = function getState(state /*: {_radiumStyleState: {[key: string]: {[value: string]: boolean}}}*/, elementKey /*: string*/, value /*: string*/) /*: boolean*/ {
	  if (VALID_KEYS.indexOf(value) === -1) {
	    throw new Error('Radium.getState invalid value param: `' + value + '`');
	  }
	
	  var key = getStateKey(elementKey);
	
	  return !!(state && state._radiumStyleState && state._radiumStyleState[key] && state._radiumStyleState[key][value]);
	};
	
	module.exports = getState;

/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

	/** @flow */
	/* eslint-disable block-scoped-var */
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	/*:: import type {Config} from '../config';*/
	
	var checkPropsPlugin = __webpack_require__(938);
	var mergeStyleArrayPlugin = __webpack_require__(939);
	var prefixPlugin = __webpack_require__(941);
	var resolveInteractionStylesPlugin = __webpack_require__(942);
	var resolveMediaQueriesPlugin = __webpack_require__(943);
	
	/*:: export type PluginConfig = {
	  // May not be readable if code has been minified
	  componentName: string,
	
	  // The Radium configuration
	  config: Config,
	
	  // Retrieve the value of a field on the component
	  getComponentField: (key: string) => any,
	
	  // Retrieve the value of a field global to the Radium module
	  // Used so that tests can easily clear global state.
	  getGlobalState: (key: string) => any,
	
	  // Retrieve the value of some state specific to the rendered element.
	  // Requires the element to have a unique key or ref or for an element key
	  // to be passed in.
	  getState: (stateKey: string, elementKey?: string) => any,
	
	  // Access to the mergeStyles utility
	  mergeStyles: (styles: Array<Object>) => Object,
	
	  // The props of the rendered element. This can be changed by each plugin,
	  // and successive plugins will see the result of previous plugins.
	  props: Object,
	
	  // Calls setState on the component with the given key and value.
	  // By default this is specific to the rendered element, but you can override
	  // by passing in the `elementKey` parameter.
	  setState: (stateKey: string, value: any, elementKey?: string) => void,
	
	  // The style prop of the rendered element. This can be changed by each plugin,
	  // and successive plugins will see the result of previous plugins. Kept
	  // separate from `props` for ease of use.
	  style: Object,
	
	  // uses the exenv npm module
	  ExecutionEnvironment: {
	    canUseEventListeners: bool,
	    canUseDOM: bool,
	  }
	};*/
	/*:: export type PluginResult = ?{
	  // Merged into the component directly. Useful for storing things for which you
	  // don't need to re-render, event subscriptions, for instance.
	  componentFields?: Object,
	
	  // Merged into a Radium controlled global state object. Use this instead of
	  // module level state for ease of clearing state between tests.
	  globalState?: Object,
	
	  // Merged into the rendered element's props.
	  props?: Object,
	
	  // Replaces (not merged into) the rendered element's style property.
	  style?: Object,
	};*/
	
	module.exports = {
	  checkProps: checkPropsPlugin,
	  mergeStyleArray: mergeStyleArrayPlugin,
	  prefix: prefixPlugin,
	  resolveInteractionStyles: resolveInteractionStylesPlugin,
	  resolveMediaQueries: resolveMediaQueriesPlugin
	};
	
	// May not be readable if code has been minified
	
	// The Radium configuration
	
	// Retrieve the value of a field on the component
	
	// Retrieve the value of a field global to the Radium module
	// Used so that tests can easily clear global state.
	
	// Retrieve the value of some state specific to the rendered element.
	// Requires the element to have a unique key or ref or for an element key
	// to be passed in.
	
	// Access to the mergeStyles utility
	
	// The props of the rendered element. This can be changed by each plugin,
	// and successive plugins will see the result of previous plugins.
	
	// Calls setState on the component with the given key and value.
	// By default this is specific to the rendered element, but you can override
	// by passing in the `elementKey` parameter.
	
	// The style prop of the rendered element. This can be changed by each plugin,
	// and successive plugins will see the result of previous plugins. Kept
	// separate from `props` for ease of use.
	
	// uses the exenv npm module
	
	// Merged into the component directly. Useful for storing things for which you
	// don't need to re-render, event subscriptions, for instance.
	
	// Merged into a Radium controlled global state object. Use this instead of
	// module level state for ease of clearing state between tests.
	
	// Merged into the rendered element's props.
	
	// Replaces (not merged into) the rendered element's style property.

/***/ }),
/* 460 */
/***/ (function(module, exports) {

	/* @flow */
	
	"use strict";
	
	var allPrintStyles = {};
	var listeners = [];
	
	var subscribe = function subscribe(listener /*: () => void*/) /*: {remove: () => void}*/ {
	  if (listeners.indexOf(listener) === -1) {
	    listeners.push(listener);
	  }
	
	  return {
	    remove: function remove() {
	      var listenerIndex = listeners.indexOf(listener);
	
	      if (listenerIndex > -1) {
	        listeners.splice(listenerIndex, 1);
	      }
	    }
	  };
	};
	
	var _emitChange = function _emitChange() {
	  listeners.forEach(function (listener) {
	    return listener();
	  });
	};
	
	var _appendImportantToEachValue = function _appendImportantToEachValue(styleObj) {
	  var importantStyleObj = {};
	
	  Object.keys(styleObj).forEach(function (key) {
	    var value = styleObj[key];
	
	    // This breaks unitless values but they'll be deprecated soon anyway
	    // https://github.com/facebook/react/issues/1873
	    value = value + " !important";
	    importantStyleObj[key] = value;
	  });
	
	  return importantStyleObj;
	};
	
	var addPrintStyles = function addPrintStyles(Component /*: constructor*/) {
	  if (!Component.printStyles) {
	    return;
	  }
	
	  var printStyleClass = {};
	
	  Object.keys(Component.printStyles).forEach(function (key) {
	    var styles = Component.printStyles[key];
	    var className = "Radium-" + Component.displayName + "-" + key;
	    allPrintStyles["." + className] = _appendImportantToEachValue(styles);
	    printStyleClass[key] = className;
	  });
	
	  // Allows for lazy loading of JS that then calls Radium to update the
	  // print styles
	  _emitChange();
	  return printStyleClass;
	};
	
	var getPrintStyles = function getPrintStyles() /*: Object*/ {
	  return allPrintStyles;
	};
	
	module.exports = {
	  addPrintStyles: addPrintStyles,
	  getPrintStyles: getPrintStyles,
	  subscribe: subscribe
	};

/***/ }),
/* 461 */,
/* 462 */,
/* 463 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2016 Google Inc. All Rights Reserved.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	
	module.exports = {
	  VERSION: '1.0.0',
	  DEV_ID: 'i5iSjo',
	
	  VERSION_PARAM: '&_av',
	  USAGE_PARAM: '&_au',
	
	  NULL_DIMENSION: '(not set)'
	};


/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	module.exports = {
	  width: 1000,
	  height: 700,
	  margin: 40,
	  theme: __webpack_require__(982),
	  print: __webpack_require__(53),
	  html: __webpack_require__(52)
	};

/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

	/* eslint react/no-multi-comp: 0, no-unused-vars: 0 */
	
	'use strict';
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.preloadGameShow = preloadGameShow;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _srcServicesRegionalization = __webpack_require__(38);
	
	var _srcServicesRegionalization2 = _interopRequireDefault(_srcServicesRegionalization);
	
	var _baseSlidesBalloonSlide = __webpack_require__(84);
	
	var _baseSlidesBalloonSlide2 = _interopRequireDefault(_baseSlidesBalloonSlide);
	
	var _baseSlidesHeadingSlide = __webpack_require__(205);
	
	var _baseSlidesHeadingSlide2 = _interopRequireDefault(_baseSlidesHeadingSlide);
	
	var _baseSlidesVideoSlide = __webpack_require__(160);
	
	var _baseSlidesVideoSlide2 = _interopRequireDefault(_baseSlidesVideoSlide);
	
	var _title_gameshowPng = __webpack_require__(2273);
	
	var _title_gameshowPng2 = _interopRequireDefault(_title_gameshowPng);
	
	var _title_gameshow_playersPng = __webpack_require__(2274);
	
	var _title_gameshow_playersPng2 = _interopRequireDefault(_title_gameshow_playersPng);
	
	var _imagesCharactersApprenticeCuriousPng = __webpack_require__(2258);
	
	var _imagesCharactersApprenticeCuriousPng2 = _interopRequireDefault(_imagesCharactersApprenticeCuriousPng);
	
	var _imagesCharactersApprenticePointingUp3Png = __webpack_require__(2261);
	
	var _imagesCharactersApprenticePointingUp3Png2 = _interopRequireDefault(_imagesCharactersApprenticePointingUp3Png);
	
	var _imagesCharactersApprenticeHandsHips2Png = __webpack_require__(850);
	
	var _imagesCharactersApprenticeHandsHips2Png2 = _interopRequireDefault(_imagesCharactersApprenticeHandsHips2Png);
	
	var _imagesCharactersApprenticeFistUpPng = __webpack_require__(848);
	
	var _imagesCharactersApprenticeFistUpPng2 = _interopRequireDefault(_imagesCharactersApprenticeFistUpPng);
	
	var _helpersMarkdownScript = __webpack_require__(9);
	
	var _helpersMarkdownScript2 = _interopRequireDefault(_helpersMarkdownScript);
	
	var _level1_knowTheRisksMd = __webpack_require__(1525);
	
	var _level1_knowTheRisksMd2 = _interopRequireDefault(_level1_knowTheRisksMd);
	
	var levels = {
	  '1': { md: new _helpersMarkdownScript2['default'](_level1_knowTheRisksMd2['default']) }
	};
	
	function preloadGameShow() {
	  (0, _spectaclePpa.preloader)([_title_gameshowPng2['default'], _title_gameshow_playersPng2['default'], _imagesCharactersApprenticeCuriousPng2['default'], _imagesCharactersApprenticePointingUp3Png2['default'], _imagesCharactersApprenticeHandsHips2Png2['default'], _imagesCharactersApprenticeFistUpPng2['default']]);
	}
	
	function sizzle(level, regionData) {
	  var md = levels[level].md;
	  return (0, _baseSlidesHeadingSlide2['default'])({
	    id: 'sizzle',
	    bgColor: '#742CBF',
	    afterImage: _title_gameshowPng2['default'],
	    notes: md.getSubSectionAsHtml('Sizzle', 'Notes', false, regionData)
	  });
	}
	
	function scoring(level, regionData) {
	  var md = levels[level].md;
	  return (0, _baseSlidesBalloonSlide2['default'])({
	    id: 'scoring',
	    characterSide: 'right',
	    characterImage: _imagesCharactersApprenticeHandsHips2Png2['default'],
	    notes: md.getSubSectionAsHtml('Scoring', 'Notes', false, regionData),
	    html: md.getSubSectionAsHtml('Scoring', 'Content', false, regionData),
	    bgColor: '#742CBF'
	  });
	}
	
	function questionSlide(_ref) {
	  var questionNumber = _ref.questionNumber;
	  var numQuestions = _ref.numQuestions;
	  var md = _ref.md;
	  var questionCharacterImage = _ref.questionCharacterImage;
	  var answerCharacterImage = _ref.answerCharacterImage;
	  var regionData = _ref.regionData;
	
	  var questionSection = 'Question ' + questionNumber;
	  var defaultRegion = md.getSectionMetadata(questionSection, 'Default Region', regionData);
	  var questionCharacter = !questionCharacterImage ? _imagesCharactersApprenticeCuriousPng2['default'] : questionCharacterImage;
	  var answerCharacter = !answerCharacterImage ? _imagesCharactersApprenticePointingUp3Png2['default'] : answerCharacterImage;
	  var answer = undefined;
	  if (defaultRegion) {
	    answer = md.getSubSectionAsHtml(questionSection, 'Answer - ' + defaultRegion, false, regionData);
	  } else {
	    answer = md.getSubSectionAsHtml(questionSection, 'Answer', false, regionData);
	  }
	  var answerNotes = md.getSubSectionAsHtml(questionSection, 'Answer Notes', false, regionData);
	
	  return [
	
	  // four players announcement
	  (0, _baseSlidesHeadingSlide2['default'])({
	    id: questionNumber + '-four-players',
	    afterImage: _title_gameshow_playersPng2['default'],
	    bgColor: 'black',
	    notes: '<h2>Question ' + questionNumber + ' of ' + numQuestions + ': </h2>' + md.getSubSectionAsHtml('Four Players Announcement', 'Notes', false, regionData)
	  }),
	
	  // question text
	  (0, _baseSlidesBalloonSlide2['default'])({
	    balloonType: 'question',
	    characterSide: 'left',
	    characterImage: questionCharacter,
	    questionNumber: questionNumber,
	    numQuestions: numQuestions,
	    id: questionNumber + '-question',
	    html: md.getSubSectionAsHtml(questionSection, 'Question', false, regionData),
	    notes: '<h2>Question ' + questionNumber + ' of ' + numQuestions + ': </h2>' + '<br />' + '<p style="font color: white">Preview of next slide/answer</h4>' + answer
	  }),
	
	  // answer slide
	  (0, _baseSlidesBalloonSlide2['default'])({
	    balloonType: 'answer',
	    characterSide: 'right',
	    characterImage: answerCharacter,
	    questionNumber: questionNumber,
	    id: questionNumber + '-answer',
	    html: answer,
	    notes: '<h2>Answer ' + questionNumber + ' of ' + numQuestions + '</h2>' + '<br />' + (!answerNotes.match(/SKIP/) ? md.getSubSectionAsHtml(questionSection, 'Answer Notes', false, regionData) : '')
	  })];
	}
	
	function endOfGameShow(level) {
	  return (0, _baseSlidesBalloonSlide2['default'])({
	    id: 'end',
	    characterSide: 'left',
	    characterImage: _imagesCharactersApprenticeFistUpPng2['default'],
	    bgColor: '#742CBF',
	    html: '<h3>Game Show Completed!</h3>',
	    notes: 'Game show completed.'
	  });
	}
	
	function level1(regionData) {
	  var level = 1;
	  var md = levels[level].md;
	
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'game-show' },
	    sizzle(level, regionData),
	    scoring(level, regionData),
	    questionSlide({ level: level, questionNumber: 1, numQuestions: 4, md: md, regionData: regionData }),
	    questionSlide({ level: level, questionNumber: 2, numQuestions: 4, md: md, regionData: regionData }),
	    questionSlide({ level: level, questionNumber: 3, numQuestions: 4, md: md, regionData: regionData }),
	    questionSlide({ level: level, questionNumber: 4, numQuestions: 4, md: md, regionData: regionData }),
	    endOfGameShow(level)
	  );
	}
	
	function gameShowSection(_ref2) {
	  var level = _ref2.level;
	  var regionData = _ref2.regionData;
	
	  switch (level) {
	    case 1:
	      return level1(regionData);
	    default:
	      return (0, _baseSlidesHeadingSlide2['default'])({ heading: 'Unknown' });
	  }
	}
	
	exports['default'] = gameShowSection;
	/* Sizzle */ /* Scoring intro */ /* Game show questions */ /* End of Game Show */

/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.preloadStart = preloadStart;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _imagesPpa_presentsSvg = __webpack_require__(2423);
	
	var _imagesPpa_presentsSvg2 = _interopRequireDefault(_imagesPpa_presentsSvg);
	
	var _helpersMarkdownScript = __webpack_require__(9);
	
	var _helpersMarkdownScript2 = _interopRequireDefault(_helpersMarkdownScript);
	
	var _startMd = __webpack_require__(1722);
	
	var _startMd2 = _interopRequireDefault(_startMd);
	
	var _imagesH2whoaLevelStartPng = __webpack_require__(2417);
	
	var _imagesH2whoaLevelStartPng2 = _interopRequireDefault(_imagesH2whoaLevelStartPng);
	
	var levels = {
	  '1': { img: _imagesH2whoaLevelStartPng2['default'] },
	  '2': { img: _imagesH2whoaLevelStartPng2['default'] }
	};
	
	var md = new _helpersMarkdownScript2['default'](_startMd2['default']);
	
	function preloadStart() {
	  (0, _spectaclePpa.preloader)([_imagesPpa_presentsSvg2['default'], imgLevel1Start, imgLevel2Start]);
	}
	
	function startSection(_ref) {
	  var level = _ref.level;
	  var title = _ref.title;
	  var regionData = _ref.regionData;
	
	  /* Level intro graphic */
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'start' },
	    _react2['default'].createElement(
	      _spectaclePpa.Slide,
	      {
	        id: 'ppa-presents',
	        key: 'ppa-presents',
	        bgColor: 'black',
	        notes: md.getSubSectionAsHtml('Level ' + level + ' Start', 'Notes', false, regionData) },
	      _react2['default'].createElement(
	        'div',
	        {
	          className: 'ui-slide' },
	        _react2['default'].createElement(
	          'div',
	          { className: 'flex-image' },
	          _react2['default'].createElement('img', {
	            className: 'heading-image heading-image-before',
	            src: _imagesPpa_presentsSvg2['default'] })
	        )
	      )
	    ),
	    _react2['default'].createElement(
	      _spectaclePpa.Slide,
	      {
	        id: 'level',
	        key: 'level',
	        bgColor: 'black',
	        notes: md.getSubSectionAsHtml('Level ' + level + ' Icon', 'Notes', false, regionData) },
	      _react2['default'].createElement(
	        'div',
	        {
	          className: 'ui-slide' },
	        _react2['default'].createElement(
	          'div',
	          { className: 'title-image' },
	          _react2['default'].createElement('img', {
	            className: 'heading-image heading-image-before',
	            src: levels[level].img }),
	          _react2['default'].createElement(
	            _spectaclePpa.Heading,
	            { size: 1 },
	            _react2['default'].createElement(
	              'strong',
	              null,
	              title
	            )
	          ),
	          _react2['default'].createElement(
	            _spectaclePpa.Heading,
	            { size: 2 },
	            _react2['default'].createElement(
	              'strong',
	              null,
	              'Level ',
	              level
	            )
	          )
	        )
	      )
	    )
	  );
	}
	
	exports['default'] = startSection;
	/* Sanksrit for Vanessa */ /* lokah samastah sukhino bhavantu */ /* may all beings everywhere be at peace */

/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.preloadSong = preloadSong;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _baseSlidesBalloonSlide = __webpack_require__(68);
	
	var _baseSlidesBalloonSlide2 = _interopRequireDefault(_baseSlidesBalloonSlide);
	
	var _baseSlidesVideoSlide = __webpack_require__(90);
	
	var _baseSlidesVideoSlide2 = _interopRequireDefault(_baseSlidesVideoSlide);
	
	var _imagesCharactersIan_sara_sillyPng = __webpack_require__(894);
	
	var _imagesCharactersIan_sara_sillyPng2 = _interopRequireDefault(_imagesCharactersIan_sara_sillyPng);
	
	var _imagesCharactersIan_sara_two_fingersPng = __webpack_require__(2410);
	
	var _imagesCharactersIan_sara_two_fingersPng2 = _interopRequireDefault(_imagesCharactersIan_sara_two_fingersPng);
	
	var _helpersMarkdownScript = __webpack_require__(9);
	
	var _helpersMarkdownScript2 = _interopRequireDefault(_helpersMarkdownScript);
	
	var _songMd = __webpack_require__(1723);
	
	var _songMd2 = _interopRequireDefault(_songMd);
	
	var md = new _helpersMarkdownScript2['default'](_songMd2['default']);
	
	function preloadSong() {
	  (0, _spectaclePpa.preloader)([_imagesCharactersIan_sara_sillyPng2['default'], _imagesCharactersIan_sara_two_fingersPng2['default']]);
	}
	
	function songSection(_ref) {
	  var regionData = _ref.regionData;
	  var level = _ref.level;
	
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'song' },
	    level === 1 && (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'song-intro',
	      characterSide: 'right',
	      characterImage: _imagesCharactersIan_sara_sillyPng2['default'],
	      html: md.getSubSectionAsHtml('Level ' + level + ' Intro', 'Content', false, regionData),
	      notes: md.getSubSectionAsHtml('Level ' + level + ' Intro', 'Notes', false, regionData)
	    }),
	    level === 2 && (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'song-intro',
	      characterSide: 'right',
	      characterImage: _imagesCharactersIan_sara_sillyPng2['default'],
	      html: md.getSubSectionAsHtml('Level ' + level + ' Intro', 'Content', false, regionData),
	      notes: md.getSubSectionAsHtml('Level ' + level + ' Intro', 'Notes', false, regionData)
	    }),
	    (0, _baseSlidesVideoSlide2['default'])({
	      id: 'video',
	      notes: md.getSubSectionAsHtml('Song', 'Notes', false, regionData),
	      youTubeId: md.getSectionMetadata('Song', 'YouTube', regionData)
	    })
	  );
	}
	
	exports['default'] = songSection;
	/* Welcome */ /* Song */

/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.preloadMissionReport = preloadMissionReport;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _componentsMissionReport = __webpack_require__(76);
	
	var _componentsMissionReport2 = _interopRequireDefault(_componentsMissionReport);
	
	var _baseSlidesBalloonSlide = __webpack_require__(68);
	
	var _baseSlidesBalloonSlide2 = _interopRequireDefault(_baseSlidesBalloonSlide);
	
	var _baseSlidesVideoSlide = __webpack_require__(90);
	
	var _baseSlidesVideoSlide2 = _interopRequireDefault(_baseSlidesVideoSlide);
	
	var _imagesCharactersIan_arms_foldedPng = __webpack_require__(892);
	
	var _imagesCharactersIan_arms_foldedPng2 = _interopRequireDefault(_imagesCharactersIan_arms_foldedPng);
	
	var _imagesCharactersIan_headshot_smilePng = __webpack_require__(893);
	
	var _imagesCharactersIan_headshot_smilePng2 = _interopRequireDefault(_imagesCharactersIan_headshot_smilePng);
	
	var _imagesCharactersSara_twist_hands_out_yayPng = __webpack_require__(2414);
	
	var _imagesCharactersSara_twist_hands_out_yayPng2 = _interopRequireDefault(_imagesCharactersSara_twist_hands_out_yayPng);
	
	var _imagesCharactersSara_smilePng = __webpack_require__(437);
	
	var _imagesCharactersSara_smilePng2 = _interopRequireDefault(_imagesCharactersSara_smilePng);
	
	var _imagesCharactersIan_sara_sidePng = __webpack_require__(156);
	
	var _imagesCharactersIan_sara_sidePng2 = _interopRequireDefault(_imagesCharactersIan_sara_sidePng);
	
	var _imagesCharactersIan_sara_lean_questioningPng = __webpack_require__(203);
	
	var _imagesCharactersIan_sara_lean_questioningPng2 = _interopRequireDefault(_imagesCharactersIan_sara_lean_questioningPng);
	
	var _helpersMarkdownScript = __webpack_require__(9);
	
	var _helpersMarkdownScript2 = _interopRequireDefault(_helpersMarkdownScript);
	
	var _level1_reservoirsMd = __webpack_require__(1725);
	
	var _level1_reservoirsMd2 = _interopRequireDefault(_level1_reservoirsMd);
	
	var _level2_saveWaterMd = __webpack_require__(1726);
	
	var _level2_saveWaterMd2 = _interopRequireDefault(_level2_saveWaterMd);
	
	var _imagesLevel0_startPng = __webpack_require__(2419);
	
	var _imagesLevel0_startPng2 = _interopRequireDefault(_imagesLevel0_startPng);
	
	var _imagesLevel1_startPng = __webpack_require__(898);
	
	var _imagesLevel1_startPng2 = _interopRequireDefault(_imagesLevel1_startPng);
	
	var levels = {
	  '0': { img: _imagesLevel0_startPng2['default'] },
	  '1': { md: new _helpersMarkdownScript2['default'](_level1_reservoirsMd2['default']), img: _imagesLevel1_startPng2['default'] },
	  '2': { md: new _helpersMarkdownScript2['default'](_level2_saveWaterMd2['default']) }
	};
	
	function preloadMissionReport() {
	  (0, _spectaclePpa.preloader)([_imagesCharactersIan_arms_foldedPng2['default'], _imagesCharactersIan_headshot_smilePng2['default'], _imagesCharactersSara_twist_hands_out_yayPng2['default'], _imagesCharactersSara_smilePng2['default'], _imagesCharactersIan_sara_sidePng2['default'], _imagesCharactersIan_sara_lean_questioningPng2['default'], _imagesLevel0_startPng2['default'], _imagesLevel1_startPng2['default']]);
	}
	
	function missionReportSection(_ref) {
	  var level = _ref.level;
	  var regionData = _ref.regionData;
	
	  var md = levels[level].md;
	  var missionReportQuestions = md.getQuestions('Questions', 'Content', regionData);
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'mission-report' },
	    level === 2 && (0, _baseSlidesVideoSlide2['default'])({
	      id: 'intro-video',
	      notes: md.getSubSectionAsHtml('Intro Video', 'Notes', false, regionData),
	      youTubeId: md.getSectionMetadata('Intro Video', 'YouTube', regionData)
	    }),
	    level === 2 && (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'scoring',
	      characterSide: 'left',
	      characterImage: _imagesCharactersSara_twist_hands_out_yayPng2['default'],
	      html: md.getSubSectionAsHtml('Scoring', 'Content', false, regionData),
	      notes: md.getSubSectionAsHtml('Scoring', 'Notes', false, regionData)
	    }),
	    level === 2 && (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'instructions',
	      characterSide: 'right',
	      characterImage: _imagesCharactersIan_headshot_smilePng2['default'],
	      html: md.getSubSectionAsHtml('Instructions', 'Content', false, regionData),
	      notes: md.getSubSectionAsHtml('Instructions', 'Notes', false, regionData)
	    }),
	    _react2['default'].createElement(
	      _spectaclePpa.Slide,
	      {
	        id: 'report',
	        bgColor: 'black',
	        missionReportQuestions: missionReportQuestions },
	      _react2['default'].createElement(
	        'div',
	        {
	          className: 'ui-slide mission-report-level-' + (level - 1) },
	        _react2['default'].createElement(
	          'header',
	          {
	            className: 'level-header' },
	          _react2['default'].createElement(
	            'figure',
	            { className: 'level-header-thumb' },
	            _react2['default'].createElement('img', { src: levels[level - 1].img })
	          ),
	          _react2['default'].createElement(
	            _spectaclePpa.Heading,
	            { size: 2 },
	            'Mission Report:',
	            _react2['default'].createElement('br', null),
	            md.getSectionMetadata('Mission Report', 'Title')
	          )
	        ),
	        _react2['default'].createElement(
	          'section',
	          {
	            className: 'mission-report-form' },
	          _react2['default'].createElement(_componentsMissionReport2['default'], { missionReportQuestions: missionReportQuestions })
	        )
	      )
	    ),
	    level === 2 && (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'impact',
	      characterSide: 'right',
	      characterImage: _imagesCharactersIan_sara_sidePng2['default'],
	      html: md.getSubSectionAsHtml('Impact', 'Content', false, regionData),
	      notes: md.getSubSectionAsHtml('Impact', 'Notes', false, regionData)
	    }),
	    level === 2 && (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'class-discussion',
	      characterSide: 'left',
	      characterImage: _imagesCharactersIan_sara_lean_questioningPng2['default'],
	      html: md.getSubSectionAsHtml('Class Discussion', 'Content', false, regionData),
	      notes: md.getSubSectionAsHtml('Class Discussion', 'Notes', false, regionData)
	    })
	  );
	}
	
	exports['default'] = missionReportSection;
	/* Intro video level 2 only */ /* Scoring */ /* Instructions */ /* Mission Reporting Screen */ /* Impact screen */ /* Class Discussion */

/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

	/* eslint react/no-multi-comp: 0 */
	
	'use strict';
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.preloadClassActivity = preloadClassActivity;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _baseSlidesHeadingSlide = __webpack_require__(169);
	
	var _baseSlidesHeadingSlide2 = _interopRequireDefault(_baseSlidesHeadingSlide);
	
	var _baseSlidesVideoSlide = __webpack_require__(90);
	
	var _baseSlidesVideoSlide2 = _interopRequireDefault(_baseSlidesVideoSlide);
	
	var _baseSlidesBalloonSlide = __webpack_require__(68);
	
	var _baseSlidesBalloonSlide2 = _interopRequireDefault(_baseSlidesBalloonSlide);
	
	var _imagesCharactersIan_headshot_smilePng = __webpack_require__(893);
	
	var _imagesCharactersIan_headshot_smilePng2 = _interopRequireDefault(_imagesCharactersIan_headshot_smilePng);
	
	var _imagesCharactersIan_sara_sidePng = __webpack_require__(156);
	
	var _imagesCharactersIan_sara_sidePng2 = _interopRequireDefault(_imagesCharactersIan_sara_sidePng);
	
	var _imagesCharactersIan_sara_lean_smilePng = __webpack_require__(436);
	
	var _imagesCharactersIan_sara_lean_smilePng2 = _interopRequireDefault(_imagesCharactersIan_sara_lean_smilePng);
	
	var _imagesCharactersIan_sidePng = __webpack_require__(895);
	
	var _imagesCharactersIan_sidePng2 = _interopRequireDefault(_imagesCharactersIan_sidePng);
	
	var _imagesCharactersSara_surprisedPng = __webpack_require__(897);
	
	var _imagesCharactersSara_surprisedPng2 = _interopRequireDefault(_imagesCharactersSara_surprisedPng);
	
	var _imagesCharactersSara_twist_hands_out_heyheyPng = __webpack_require__(2413);
	
	var _imagesCharactersSara_twist_hands_out_heyheyPng2 = _interopRequireDefault(_imagesCharactersSara_twist_hands_out_heyheyPng);
	
	var _imagesCharactersIan_pointing_upPng = __webpack_require__(435);
	
	var _imagesCharactersIan_pointing_upPng2 = _interopRequireDefault(_imagesCharactersIan_pointing_upPng);
	
	var _imagesCharactersIan_pointing_leftPng = __webpack_require__(2409);
	
	var _imagesCharactersIan_pointing_leftPng2 = _interopRequireDefault(_imagesCharactersIan_pointing_leftPng);
	
	var _imagesCharactersIan_pointing_downPng = __webpack_require__(2408);
	
	var _imagesCharactersIan_pointing_downPng2 = _interopRequireDefault(_imagesCharactersIan_pointing_downPng);
	
	var _imagesCharactersSara_smilePng = __webpack_require__(437);
	
	var _imagesCharactersSara_smilePng2 = _interopRequireDefault(_imagesCharactersSara_smilePng);
	
	var _imagesCharactersSara_humphPng = __webpack_require__(2412);
	
	var _imagesCharactersSara_humphPng2 = _interopRequireDefault(_imagesCharactersSara_humphPng);
	
	var _imagesCharactersIan_sara_lean_questioningPng = __webpack_require__(203);
	
	var _imagesCharactersIan_sara_lean_questioningPng2 = _interopRequireDefault(_imagesCharactersIan_sara_lean_questioningPng);
	
	var _helpersMarkdownScript = __webpack_require__(9);
	
	var _helpersMarkdownScript2 = _interopRequireDefault(_helpersMarkdownScript);
	
	var _level1_drawingMd = __webpack_require__(1729);
	
	var _level1_drawingMd2 = _interopRequireDefault(_level1_drawingMd);
	
	var _level2_writingMd = __webpack_require__(1730);
	
	var _level2_writingMd2 = _interopRequireDefault(_level2_writingMd);
	
	var levels = {
	  '1': { md: new _helpersMarkdownScript2['default'](_level1_drawingMd2['default']) },
	  '2': { md: new _helpersMarkdownScript2['default'](_level2_writingMd2['default']) }
	};
	
	function preloadClassActivity() {
	  (0, _spectaclePpa.preloader)([_imagesCharactersIan_headshot_smilePng2['default'], _imagesCharactersIan_sara_sidePng2['default'], _imagesCharactersIan_sara_lean_smilePng2['default'], _imagesCharactersIan_sidePng2['default'], _imagesCharactersSara_surprisedPng2['default'], _imagesCharactersSara_twist_hands_out_heyheyPng2['default'], _imagesCharactersIan_pointing_upPng2['default'], _imagesCharactersIan_pointing_leftPng2['default'], _imagesCharactersIan_pointing_downPng2['default'], _imagesCharactersSara_smilePng2['default'], _imagesCharactersSara_humphPng2['default'], _imagesCharactersIan_sara_lean_questioningPng2['default']]);
	}
	
	function introVideo(level, regionData) {
	  var md = levels[level].md;
	  return (0, _baseSlidesVideoSlide2['default'])({
	    id: 'intro-video',
	    notes: md.getSubSectionAsHtml('Intro Video', 'Notes', false, regionData),
	    youTubeId: md.getSectionMetadata('Intro Video', 'YouTube', regionData)
	  });
	}
	
	function sizzle(level, regionData) {
	  var md = levels[level].md;
	  return (0, _baseSlidesBalloonSlide2['default'])({
	    id: 'sizzle',
	    characterSide: 'right',
	    characterImage: _imagesCharactersIan_sara_sidePng2['default'],
	    notes: md.getSubSectionAsHtml('Sizzle', 'Notes', false, regionData),
	    html: md.getSubSectionAsHtml('Sizzle', 'Content', false, regionData)
	  });
	}
	
	function instructions(level, regionData) {
	  var md = levels[level].md;
	  return (0, _baseSlidesBalloonSlide2['default'])({
	    id: 'instructions',
	    characterSide: 'right',
	    characterImage: _imagesCharactersIan_sara_lean_smilePng2['default'],
	    notes: md.getSubSectionAsHtml('Instructions', 'Notes', false, regionData),
	    html: md.getSubSectionAsHtml('Instructions', 'Content', false, regionData)
	  });
	}
	
	function level1(regionData) {
	  // floorplan
	  var level = '1';
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'class-activity-' + level },
	    sizzle(level, regionData),
	    introVideo(level, regionData),
	    instructions(level, regionData)
	  );
	}
	
	function level2(regionData) {
	  // Draw Energy
	  var level = '2';
	  var md = levels[level].md;
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'class-activity-' + level },
	    sizzle(level, regionData),
	    instructions(level, regionData),
	    (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'write-poem',
	      characterSide: 'left',
	      characterImage: _imagesCharactersSara_twist_hands_out_heyheyPng2['default'],
	      notes: md.getSubSectionAsHtml('Write Poem', 'Notes', false, regionData),
	      html: md.getSubSectionAsHtml('Write Poem', 'Content', false, regionData)
	    }),
	    (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'scoring-reminder',
	      characterSide: 'left',
	      characterImage: _imagesCharactersIan_pointing_upPng2['default'],
	      notes: md.getSubSectionAsHtml('Scoring Reminder', 'Notes', false, regionData),
	      html: md.getSubSectionAsHtml('Scoring Reminder', 'Content', false, regionData)
	    })
	  );
	}
	
	function classActivitySection(_ref) {
	  var level = _ref.level;
	  var subActivity = _ref.subActivity;
	  var regionData = _ref.regionData;
	
	  switch ('' + level + (subActivity ? subActivity : '')) {
	    case '1':
	      return level1(regionData);
	    case '2':
	      return level2(regionData);
	    default:
	      return (0, _baseSlidesHeadingSlide2['default'])({ heading: 'Unknown' });
	  }
	}
	
	exports['default'] = classActivitySection;
	/* Sizzle */ /* Intro Video */ /* Instructions */ /* Sizzle */ /* Instructions */ /* Write poem */ /* Scoring Reminder */

/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.preloadMissionAssignment = preloadMissionAssignment;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _baseSlidesHeadingSlide = __webpack_require__(169);
	
	var _baseSlidesHeadingSlide2 = _interopRequireDefault(_baseSlidesHeadingSlide);
	
	var _baseSlidesBalloonSlide = __webpack_require__(68);
	
	var _baseSlidesBalloonSlide2 = _interopRequireDefault(_baseSlidesBalloonSlide);
	
	var _baseSlidesVideoSlide = __webpack_require__(90);
	
	var _baseSlidesVideoSlide2 = _interopRequireDefault(_baseSlidesVideoSlide);
	
	var _imagesCharactersIan_sara_sidePng = __webpack_require__(156);
	
	var _imagesCharactersIan_sara_sidePng2 = _interopRequireDefault(_imagesCharactersIan_sara_sidePng);
	
	var _imagesCharactersIan_sara_lean_questioningPng = __webpack_require__(203);
	
	var _imagesCharactersIan_sara_lean_questioningPng2 = _interopRequireDefault(_imagesCharactersIan_sara_lean_questioningPng);
	
	var _imagesLogo_ppaPng = __webpack_require__(899);
	
	var _imagesLogo_ppaPng2 = _interopRequireDefault(_imagesLogo_ppaPng);
	
	var _helpersMarkdownScript = __webpack_require__(9);
	
	var _helpersMarkdownScript2 = _interopRequireDefault(_helpersMarkdownScript);
	
	var _level1_saveWaterMd = __webpack_require__(1731);
	
	var _level1_saveWaterMd2 = _interopRequireDefault(_level1_saveWaterMd);
	
	var _level2_keepSavingWaterMd = __webpack_require__(1732);
	
	var _level2_keepSavingWaterMd2 = _interopRequireDefault(_level2_keepSavingWaterMd);
	
	var levels = {
	  '1': { md: new _helpersMarkdownScript2['default'](_level1_saveWaterMd2['default']) },
	  '2': { md: new _helpersMarkdownScript2['default'](_level2_keepSavingWaterMd2['default']) }
	};
	
	function preloadMissionAssignment() {
	  (0, _spectaclePpa.preloader)([_imagesLogo_ppaPng2['default'], _imagesCharactersIan_sara_sidePng2['default'], _imagesCharactersIan_sara_lean_questioningPng2['default']]);
	}
	
	function missionAssignmentSection(_ref) {
	  var level = _ref.level;
	  var regionData = _ref.regionData;
	
	  var md = levels[level].md;
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'mission-assignment' },
	    level === 1 && (0, _baseSlidesHeadingSlide2['default'])({
	      id: 'sizzle',
	      beforeImage: _imagesLogo_ppaPng2['default'],
	      subHeading: 'Mission ' + level,
	      notes: md.getSubSectionAsHtml('Mission Assignment', 'Notes', false, regionData),
	      bgColor: 'black'
	    }),
	    level === 1 && (0, _baseSlidesVideoSlide2['default'])({
	      id: 'mission-intro-video',
	      notes: md.getSubSectionAsHtml('Mission Intro Video', 'Notes', false, regionData),
	      youTubeId: md.getSectionMetadata('Mission Intro Video', 'YouTube', regionData)
	    }),
	    level === 1 && (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'instructions',
	      characterSide: 'right',
	      characterImage: _imagesCharactersIan_sara_sidePng2['default'],
	      notes: md.getSubSectionAsHtml('Instructions', 'Notes', false, regionData),
	      html: md.getSubSectionAsHtml('Instructions', 'Content', false, regionData)
	    })
	  );
	}
	
	exports['default'] = missionAssignmentSection;
	/* Sizzle */ /* Mission Intro Video*/ /* Mission Instructions level 1 only */

/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.preloadFinish = preloadFinish;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _componentsCompleteLevelButton = __webpack_require__(44);
	
	var _componentsCompleteLevelButton2 = _interopRequireDefault(_componentsCompleteLevelButton);
	
	var _baseSlidesBalloonSlide = __webpack_require__(68);
	
	var _baseSlidesBalloonSlide2 = _interopRequireDefault(_baseSlidesBalloonSlide);
	
	var _baseSlidesVideoSlide = __webpack_require__(90);
	
	var _baseSlidesVideoSlide2 = _interopRequireDefault(_baseSlidesVideoSlide);
	
	var _imagesCharactersIan_sara_lean_smilePng = __webpack_require__(436);
	
	var _imagesCharactersIan_sara_lean_smilePng2 = _interopRequireDefault(_imagesCharactersIan_sara_lean_smilePng);
	
	var _imagesCharactersIan_sara_sidePng = __webpack_require__(156);
	
	var _imagesCharactersIan_sara_sidePng2 = _interopRequireDefault(_imagesCharactersIan_sara_sidePng);
	
	var _imagesCharactersIan_sara_lean_questioningPng = __webpack_require__(203);
	
	var _imagesCharactersIan_sara_lean_questioningPng2 = _interopRequireDefault(_imagesCharactersIan_sara_lean_questioningPng);
	
	var _imagesCharactersIan_sara_sillyPng = __webpack_require__(894);
	
	var _imagesCharactersIan_sara_sillyPng2 = _interopRequireDefault(_imagesCharactersIan_sara_sillyPng);
	
	var _helpersMarkdownScript = __webpack_require__(9);
	
	var _helpersMarkdownScript2 = _interopRequireDefault(_helpersMarkdownScript);
	
	var _finishMd = __webpack_require__(1733);
	
	var _finishMd2 = _interopRequireDefault(_finishMd);
	
	var _level1_completeSvg = __webpack_require__(2426);
	
	var _level1_completeSvg2 = _interopRequireDefault(_level1_completeSvg);
	
	var _level2_completeSvg = __webpack_require__(2427);
	
	var _level2_completeSvg2 = _interopRequireDefault(_level2_completeSvg);
	
	var md = new _helpersMarkdownScript2['default'](_finishMd2['default']);
	
	var levels = {
	  '1': { img: _level1_completeSvg2['default'] },
	  '2': { img: _level2_completeSvg2['default'] }
	};
	
	function preloadFinish() {
	  (0, _spectaclePpa.preloader)([_imagesCharactersIan_sara_lean_smilePng2['default'], _imagesCharactersIan_sara_sidePng2['default'], _imagesCharactersIan_sara_lean_questioningPng2['default'], _imagesCharactersIan_sara_sillyPng2['default'], _level1_completeSvg2['default'], _level2_completeSvg2['default']]);
	}
	
	function finishSection(_ref) {
	  var level = _ref.level;
	  var regionData = _ref.regionData;
	
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'finish' },
	    level !== 2 && (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'scoreboard-recap',
	      characterSide: 'left',
	      characterImage: _imagesCharactersIan_sara_sidePng2['default'],
	      html: md.getSubSectionAsHtml('Scoreboard Recap', 'Content', false, regionData),
	      notes: md.getSubSectionAsHtml('Scoreboard Recap', 'Notes', false, regionData)
	    }),
	    level !== 2 && (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'earn-more-points',
	      characterSide: 'right',
	      characterImage: _imagesCharactersIan_sara_lean_questioningPng2['default'],
	      html: md.getSubSectionAsHtml('Earn More Points', 'Content', false, regionData),
	      notes: md.getSubSectionAsHtml('Earn More Points', 'Notes', false, regionData)
	    }),
	    (0, _baseSlidesVideoSlide2['default'])({
	      id: 'farewell-video',
	      notes: md.getSubSectionAsHtml('Level ' + level + ' Farewell Video', 'Notes', false, regionData),
	      youTubeId: md.getSectionMetadata('Level ' + level + ' Farewell Video', 'YouTube', regionData)
	    }),
	    (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'farewell',
	      characterSide: 'left',
	      characterImage: _imagesCharactersIan_sara_sidePng2['default'],
	      html: md.getSubSectionAsHtml('Farewell', 'Content', false, regionData),
	      notes: md.getSubSectionAsHtml('Farewell', 'Notes', false, regionData)
	    }),
	    _react2['default'].createElement(
	      _spectaclePpa.Slide,
	      {
	        id: 'level-completed',
	        notes: '<h2>Level ' + level + ' Finished</h2>',
	        bgColor: 'transparent',
	        finish: true },
	      _react2['default'].createElement(
	        'div',
	        { className: 'level-complete' },
	        _react2['default'].createElement(
	          'div',
	          { className: 'level-complete-content' },
	          _react2['default'].createElement(
	            'figure',
	            { className: 'level-complete-graphic' },
	            _react2['default'].createElement('img', { src: levels[level].img })
	          ),
	          _react2['default'].createElement(
	            _spectaclePpa.Heading,
	            { size: 3 },
	            level,
	            '/2'
	          ),
	          _react2['default'].createElement(
	            _spectaclePpa.Heading,
	            { size: 2 },
	            'Levels Completed'
	          ),
	          _react2['default'].createElement(_componentsCompleteLevelButton2['default'], null)
	        )
	      )
	    )
	  );
	}
	
	exports['default'] = finishSection;
	/* Scoreboard Recap */ /* Earn More Points */ /* Video farewell level */ /* Farewell level */ /* Level complete */

/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _Promise = __webpack_require__(33)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.unbindActiveSession = unbindActiveSession;
	exports.setActiveSession = setActiveSession;
	exports.bindActiveSession = bindActiveSession;
	exports.completeLevelAndExit = completeLevelAndExit;
	exports.completeLevelPreview = completeLevelPreview;
	
	var _servicesFirebaseRef = __webpack_require__(74);
	
	var _servicesFirebaseRef2 = _interopRequireDefault(_servicesFirebaseRef);
	
	var _sessionActions = __webpack_require__(72);
	
	var _servicesEvents = __webpack_require__(73);
	
	var _programs = __webpack_require__(69);
	
	var _programs2 = _interopRequireDefault(_programs);
	
	var ACTIVE_SESSION_LOADED = 'ACTIVE_SESSION_LOADED';
	exports.ACTIVE_SESSION_LOADED = ACTIVE_SESSION_LOADED;
	var ACTIVE_SESSION_SET = 'ACTIVE_SESSION_SET';
	
	exports.ACTIVE_SESSION_SET = ACTIVE_SESSION_SET;
	function getValue(path) {
	  return new _Promise(function (resolve) {
	    _servicesFirebaseRef2['default'].child(path).once('value', function (snapshot) {
	      resolve(snapshot.val());
	    });
	  });
	}
	
	function activeSessionLoaded(activeSession) {
	  return {
	    type: ACTIVE_SESSION_LOADED,
	    activeSession: activeSession
	  };
	}
	
	function unbindActiveSession(refs) {
	  return function () {
	    refs.forEach(function (savedRef) {
	      savedRef.off();
	    });
	  };
	}
	
	function activeSessionSet(_ref) {
	  var userId = _ref.userId;
	  var sessionId = _ref.sessionId;
	
	  return {
	    type: ACTIVE_SESSION_SET,
	    userId: userId,
	    sessionId: sessionId
	  };
	}
	
	function setActiveSession(_ref2) {
	  var userId = _ref2.userId;
	  var sessionId = _ref2.sessionId;
	  var level = _ref2.level;
	  var deviceRole = _ref2.deviceRole;
	  var programId = _ref2.programId;
	
	  return function (dispatch) {
	    var promise = undefined;
	    if (sessionId === 'none') {
	      promise = _Promise.resolve(true);
	    } else {
	      promise = dispatch((0, _sessionActions.setCurrentLevel)({ sessionId: sessionId, currentLevel: level }));
	    }
	    return promise.then(function () {
	      return new _Promise(function (resolve, reject) {
	        _servicesFirebaseRef2['default'].child('users').child(userId).update({
	          activeSession: sessionId
	        }, function (error) {
	          if (error) {
	            reject(error);
	          } else {
	            resolve();
	          }
	        });
	      });
	    }).then(function () {
	      if (level !== "prep" && sessionId !== "none") {
	        (0, _servicesEvents.publishEvent)('Presentation Started', {
	          userId: userId,
	          sessionId: sessionId,
	          programId: programId,
	          currentLevel: level,
	          deviceRole: deviceRole
	        });
	      } else if (level === "prep") {
	        (0, _servicesEvents.publishEvent)('Set Up Presentation Started', {
	          userId: userId
	        });
	      }
	      return dispatch(activeSessionSet({ userId: userId, sessionId: sessionId }));
	    });
	  };
	}
	
	function bindActiveSession(userId, refs, pageLoad) {
	  return function (dispatch) {
	    var activeSessionRef = _servicesFirebaseRef2['default'].child('users').child(userId).child('activeSession');
	    var first = true;
	    activeSessionRef.on('value', function (snapshot) {
	      var activeSession = snapshot.val();
	      if (!first) {
	        dispatch(activeSessionLoaded(activeSession));
	        return;
	      }
	      first = false;
	      getValue(['sessions', activeSession, 'currentLevel'].join('/')).then(function (currentLevel) {
	        if (pageLoad && currentLevel !== 'prep') {
	          dispatch(setActiveSession({ userId: userId, sessionId: 'none' }));
	          return;
	        }
	        dispatch(activeSessionLoaded(activeSession));
	      });
	    });
	    refs.push(activeSessionRef);
	  };
	}
	
	function completeLevelAndExit(_ref3) {
	  var userId = _ref3.userId;
	  var sessionId = _ref3.sessionId;
	  var programId = _ref3.programId;
	  var completedLevel = _ref3.completedLevel;
	  var finished = _ref3.finished;
	  var contractId = _ref3.contractId;
	  var funding = _ref3.funding;
	  var previousCompletedLevel = _ref3.previousCompletedLevel;
	
	  var action = Number(previousCompletedLevel) === Number(completedLevel) ? _sessionActions.advanceLevel : _sessionActions.completeLevelAndAdvance;
	  return function (dispatch) {
	    return dispatch(setActiveSession({ userId: userId, sessionId: 'none' })).then(function () {
	      return dispatch(action({ sessionId: sessionId, completedLevel: completedLevel, programId: programId, finished: finished, contractId: contractId, userId: userId, funding: funding }));
	    }).then(function () {
	      return dispatch((0, _sessionActions.setCurrentLevel)({ sessionId: sessionId, currentLevel: 'prep' }));
	    });
	  };
	}
	
	function completeLevelPreview(_ref4) {
	  var userId = _ref4.userId;
	  var sessionId = _ref4.sessionId;
	  var programId = _ref4.programId;
	  var completedLevel = _ref4.completedLevel;
	  var contractId = _ref4.contractId;
	  var funding = _ref4.funding;
	
	  return function (dispatch) {
	    return dispatch(setActiveSession({ userId: userId, sessionId: 'none' })).then(function () {
	      var levelName = _programs2['default'].programList.filter(function (p) {
	        return p.id === programId;
	      })[0]["levels"][completedLevel]["levelName"];
	      (0, _servicesEvents.publishEvent)('Level Preview Completed', {
	        userId: userId,
	        sessionId: sessionId,
	        programId: programId,
	        level: completedLevel,
	        levelName: levelName,
	        funding: funding,
	        contractId: contractId
	      });
	    });
	  };
	}

/***/ }),
/* 473 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.showHUD = showHUD;
	exports.hideHUD = hideHUD;
	exports.registerHUDRef = registerHUDRef;
	exports.setDeviceRole = setDeviceRole;
	var SHOW_HUD = 'SHOW_HUD';
	exports.SHOW_HUD = SHOW_HUD;
	var HIDE_HUD = 'HIDE_HUD';
	exports.HIDE_HUD = HIDE_HUD;
	var DECK_SET_DEVICE_ROLE = 'DECK_SET_DEVICE_ROLE';
	exports.DECK_SET_DEVICE_ROLE = DECK_SET_DEVICE_ROLE;
	var REGISTER_HUD_REF = 'REGISTER_HUD_REF';
	
	exports.REGISTER_HUD_REF = REGISTER_HUD_REF;
	
	function showHUD() {
	  return {
	    type: SHOW_HUD
	  };
	}
	
	function hideHUD() {
	  return {
	    type: HIDE_HUD
	  };
	}
	
	function registerHUDRef(name, ref) {
	  return {
	    type: REGISTER_HUD_REF,
	    name: name,
	    ref: ref
	  };
	}
	
	function setDeviceRole(role) {
	  localStorage.setItem('deviceRole', role);
	  return {
	    type: DECK_SET_DEVICE_ROLE,
	    role: role
	  };
	}

/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _extends = __webpack_require__(7)["default"];
	
	var _Promise = __webpack_require__(33)["default"];
	
	var _interopRequireDefault = __webpack_require__(2)["default"];
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.loadUserReferral = loadUserReferral;
	exports.generateUserReferral = generateUserReferral;
	
	var _servicesFirebaseRefJs = __webpack_require__(74);
	
	var _servicesFirebaseRefJs2 = _interopRequireDefault(_servicesFirebaseRefJs);
	
	var USERREFERRAL_LOAD = "USERREFERRAL_LOAD";
	exports.USERREFERRAL_LOAD = USERREFERRAL_LOAD;
	var USERREFERRAL_LOADED = "USERREFERRAL_LOADED";
	exports.USERREFERRAL_LOADED = USERREFERRAL_LOADED;
	var USERREFERRAL_LOADERROR = "USERREFERRAL_LOADERROR";
	exports.USERREFERRAL_LOADERROR = USERREFERRAL_LOADERROR;
	var USERREFERRAL_GENERATE = "USERREFERRAL_GENERATE";
	exports.USERREFERRAL_GENERATE = USERREFERRAL_GENERATE;
	var USERREFERRAL_GENERATED = "USERREFERRAL_GENERATED";
	exports.USERREFERRAL_GENERATED = USERREFERRAL_GENERATED;
	var USERREFERRAL_GENERATEERROR = "USERREFERRAL_GENERATEERROR";
	
	exports.USERREFERRAL_GENERATEERROR = USERREFERRAL_GENERATEERROR;
	function userRefferalLoad(userId) {
	  return {
	    type: USERREFERRAL_LOAD,
	    userId: userId
	  };
	}
	
	function userReferralLoaded(userId, referralData) {
	  return _extends({
	    type: USERREFERRAL_LOADED,
	    userId: userId
	  }, referralData);
	}
	
	function userRefferalLoadError(userId, err) {
	  return {
	    type: USERREFERRAL_LOADERROR,
	    userId: userId,
	    message: err.message,
	    stack: err.stack
	  };
	}
	
	function loadUserReferral(userId) {
	  return function (dispatch) {
	    dispatch(userRefferalLoad(userId));
	    _servicesFirebaseRefJs2["default"].child('users').child(userId).child('referral').once('value', function (snapshot) {
	      dispatch(userReferralLoaded(userId, snapshot.val()));
	    }, function (err) {
	      dispatch(userRefferalLoadError(userId, err));
	    });
	  };
	}
	
	function userReferralGenerate(userId) {
	  return {
	    type: USERREFERRAL_GENERATE,
	    userId: userId
	  };
	}
	
	function userReferralGenerated(userId, referralData) {
	  return _extends({
	    type: USERREFERRAL_GENERATED,
	    userId: userId
	  }, referralData);
	}
	
	function userReferralGenerateError(userId, error) {
	  return {
	    type: USERREFERRAL_GENERATEERROR,
	    userId: userId,
	    message: error.message,
	    stack: error.stack
	  };
	}
	
	function normalizeName(name) {
	  return name.trim().toLowerCase().replace(/[^a-z]/ig, "");
	}
	
	function findReferrerId(userId, firstName, lastName) {
	  var index = arguments.length <= 3 || arguments[3] === undefined ? 0 : arguments[3];
	
	  return new _Promise(function (resolve, reject) {
	    var referrerId = "" + normalizeName(firstName) + normalizeName(lastName)[0] + (index > 0 ? index + 1 : '');
	    _servicesFirebaseRefJs2["default"].child('referrers').child(referrerId).once('value', function (snapshot) {
	      var value = snapshot.val();
	      if (!value) {
	        snapshot.ref.set({ userId: userId }, function (err) {
	          if (err) return reject(err);
	          resolve(referrerId);
	        });
	      } else {
	        resolve();
	      }
	    }, reject);
	  }).then(function (referrerId) {
	    if (referrerId) return referrerId;
	    return findReferrerId(userId, firstName, lastName, index + 1);
	  });
	}
	
	function generateUserReferral(userId, firstName, lastName) {
	  return function (dispatch) {
	    dispatch(userReferralGenerate(userId));
	    findReferrerId(userId, firstName, lastName).then(function (referrerId) {
	      return _servicesFirebaseRefJs2["default"].child('users').child(userId).child('referral').set({ referrerId: referrerId }).then(function () {
	        return dispatch(userReferralGenerated(userId, { referrerId: referrerId }));
	      });
	    })["catch"](function (err) {
	      return dispatch(userReferralGenerateError(userId, err));
	    });
	  };
	}

/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

	/* eslint no-console: 0 */
	'use strict';
	
	var _createClass = __webpack_require__(6)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _Promise = __webpack_require__(33)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.isValidFormat = isValidFormat;
	exports.fetch = fetch;
	exports.decreaseAvailable = decreaseAvailable;
	
	var _firebaseRef = __webpack_require__(74);
	
	var _firebaseRef2 = _interopRequireDefault(_firebaseRef);
	
	var PromoCode = (function () {
	  function PromoCode(code, promo) {
	    _classCallCheck(this, PromoCode);
	
	    this._code = code;
	    this._promo = promo;
	  }
	
	  _createClass(PromoCode, [{
	    key: 'isAvailable',
	    value: function isAvailable() {
	      return this._promo.available > 0;
	    }
	  }, {
	    key: 'isValidForProgram',
	    value: function isValidForProgram(programId) {
	      if (this._promo.programs === 'all') return true;
	      return this._promo.programs[programId];
	    }
	  }, {
	    key: 'code',
	    get: function get() {
	      return this._code;
	    }
	  }, {
	    key: 'value',
	    get: function get() {
	      return this._promo.value;
	    }
	  }]);
	
	  return PromoCode;
	})();
	
	var PROMOCODE_REGEX = /^[A-Z0-9\-]+$/;
	
	function isValidFormat(promoCode) {
	  return PROMOCODE_REGEX.test(promoCode);
	}
	
	function fetch(promoCode) {
	  return new _Promise(function (resolve, reject) {
	    if (!PROMOCODE_REGEX.test(promoCode)) return resolve();
	    _firebaseRef2['default'].child('promoCodes').child(promoCode).once('value', function (snapshot) {
	      var val = snapshot.val();
	      if (!val) return resolve(null);
	      resolve(new PromoCode(promoCode, val));
	    }, reject);
	  });
	}
	
	function decreaseAvailable(promoCode) {
	  return new _Promise(function (resolve, reject) {
	    if (!PROMOCODE_REGEX.test(promoCode)) return reject(new Error('Invalid format for promo-code.'));
	    _firebaseRef2['default'].child('promoCodes').child(promoCode).child('available').transaction(function (currentValue) {
	      return (currentValue || 0) - 1;
	    }, function (err) {
	      if (err) return reject(err);
	      resolve();
	    });
	  });
	}
	
	exports['default'] = {
	  fetch: fetch,
	  decreaseAvailable: decreaseAvailable,
	  isValidFormat: isValidFormat
	};

/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _Number$MAX_SAFE_INTEGER = __webpack_require__(486)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.validateClass = validateClass;
	
	var _lodash = __webpack_require__(65);
	
	function validateGrade(data, errors) {
	  var grade = data.grade;
	
	  if (!grade) {
	    errors.grade = 'Required';
	  } else if (grade.length > 80) {
	    errors.grade = 'Please use a shorter name';
	  }
	}
	
	function validateDivisionName(data, errors) {
	  var divisionName = data.divisionName;
	
	  if (!divisionName) {
	    errors.divisionName = 'Required';
	  } else if (divisionName.length > 80) {
	    errors.divisionName = 'Please use a shorter name';
	  }
	}
	
	function validateNumberOfStudents(data, errors) {
	  var numberOfStudents = data.numberOfStudents;
	
	  if (parseInt(numberOfStudents, 10) > 0) {
	    return;
	  }
	  if (parseInt(numberOfStudents, 10) > _Number$MAX_SAFE_INTEGER) {
	    errors.numberOfStudents = 'Too high';
	    return;
	  }
	  errors.numberOfStudents = 'Must be more than zero';
	}
	
	function validateProgram(data, errors) {
	  var program = data.program;
	
	  if (program) {
	    return;
	  }
	  errors.program = 'Required';
	}
	
	function validateLanguage(data, errors) {
	  var language = data.language;
	
	  if (language) {
	    return;
	  }
	  errors.language = 'Required';
	}
	
	function validateClass(data) {
	  var errors = {};
	
	  validateProgram(data, errors);
	  validateLanguage(data, errors);
	  validateGrade(data, errors);
	  validateDivisionName(data, errors);
	  validateNumberOfStudents(data, errors);
	
	  return errors;
	}
	
	var normalizeClass = {
	  grade: function grade(value) {
	    return value && (0, _lodash.trimLeft)(value);
	  },
	  divisionName: function divisionName(value) {
	    return value && (0, _lodash.trimLeft)(value);
	  }
	};
	exports.normalizeClass = normalizeClass;

/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

	/* eslint dot-notation: 0 */
	'use strict';
	
	var _get = __webpack_require__(8)['default'];
	
	var _inherits = __webpack_require__(5)['default'];
	
	var _createClass = __webpack_require__(6)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var ButtonBar = (function (_Component) {
	  _inherits(ButtonBar, _Component);
	
	  function ButtonBar() {
	    _classCallCheck(this, ButtonBar);
	
	    _get(Object.getPrototypeOf(ButtonBar.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(ButtonBar, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.context.registerHUDRef('Scores', this.refs['Scores']);
	      this.context.registerHUDRef('Extras', this.refs['Extras']);
	      this.context.registerHUDRef('Modules', this.refs['Modules']);
	      this.context.registerHUDRef('Exit', this.refs['Exit']);
	      this.context.registerHUDRef('Hide', this.refs['Hide']);
	    }
	  }, {
	    key: 'clickNavBar',
	    value: function clickNavBar(evt) {
	      var _context = this.context;
	      var setMode = _context.setMode;
	      var hideHUD = _context.hideHUD;
	
	      if (evt) {
	        evt.preventDefault();
	        evt.stopPropagation();
	        evt.nativeEvent.stopPropagation();
	        if (evt.target === this.refs.navBar) {
	          setMode(null);
	          hideHUD();
	        }
	      }
	    }
	  }, {
	    key: 'clickButton',
	    value: function clickButton(modeName) {
	      var _context2 = this.context;
	      var deckState = _context2.deckState;
	      var hideHUD = _context2.hideHUD;
	      var setMode = _context2.setMode;
	      var displayHUD = deckState.displayHUD;
	
	      var newMode = modeName === 'Hide' ? null : modeName.toLowerCase();
	      if (!newMode && displayHUD) {
	        hideHUD();
	      }
	      setMode(newMode);
	    }
	  }, {
	    key: 'navBarButton',
	    value: function navBarButton(modeName) {
	      var _context3 = this.context;
	      var presenter = _context3.presenter;
	      var session = _context3.session;
	      var _ = _context3.i18n;
	      var mode = session.mode;
	
	      var active = mode && modeName.toLowerCase() === mode.replace(/\/.*$/, '');
	      var name = modeName;
	      if (!mode && presenter && modeName === 'Hide') {
	        active = true;
	        name = 'Notes';
	      }
	
	      return _react2['default'].createElement(
	        'div',
	        {
	          key: 'btn-' + modeName,
	          className: 'navbar-btn ' + (active ? 'active' : ''),
	          onClick: this.clickButton.bind(this, modeName),
	          ref: modeName },
	        _react2['default'].createElement(
	          'button',
	          { className: 'btn btn-icon ' + (active ? 'active' : '') },
	          _react2['default'].createElement('div', { className: 'ppa-icon-' + name.toLowerCase() })
	        ),
	        _react2['default'].createElement(
	          'div',
	          null,
	          _(name)
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this = this;
	
	      return _react2['default'].createElement(
	        'div',
	        {
	          className: 'teacher-remote-navbar',
	          ref: 'navBar',
	          onClick: this.clickNavBar.bind(this) },
	        ['Scores', 'Extras', 'Modules', 'Exit', 'Hide'].map(function (modeName) {
	          return _this.navBarButton(modeName);
	        })
	      );
	    }
	  }], [{
	    key: 'contextTypes',
	    value: {
	      presenter: _react.PropTypes.bool.isRequired,
	      session: _react.PropTypes.object.isRequired,
	      deckState: _react.PropTypes.object.isRequired,
	      setMode: _react.PropTypes.func.isRequired,
	      hideHUD: _react.PropTypes.func.isRequired,
	      registerHUDRef: _react.PropTypes.func.isRequired,
	      i18n: _react.PropTypes.func.isRequired
	    },
	    enumerable: true
	  }]);
	
	  return ButtonBar;
	})(_react.Component);
	
	exports['default'] = ButtonBar;
	module.exports = exports['default'];

/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _get = __webpack_require__(8)['default'];
	
	var _inherits = __webpack_require__(5)['default'];
	
	var _createClass = __webpack_require__(6)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(2205);
	
	var Exit = (function (_Component) {
	  _inherits(Exit, _Component);
	
	  function Exit() {
	    _classCallCheck(this, Exit);
	
	    _get(Object.getPrototypeOf(Exit.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(Exit, [{
	    key: 'exitSession',
	    value: function exitSession() {
	      var setActiveSession = this.context.setActiveSession;
	
	      setActiveSession('none');
	    }
	  }, {
	    key: 'returnToPresentation',
	    value: function returnToPresentation() {
	      var _context = this.context;
	      var setMode = _context.setMode;
	      var hideHUD = _context.hideHUD;
	
	      setMode(null);
	      hideHUD();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _ = this.context.i18n;
	
	      return _react2['default'].createElement(
	        'div',
	        { className: 'exit' },
	        _react2['default'].createElement(
	          'h1',
	          null,
	          _('Exit Session?')
	        ),
	        _react2['default'].createElement(
	          'div',
	          { className: 'button-group' },
	          _react2['default'].createElement(
	            'button',
	            {
	              className: 'btn btn-lg btn-primary btn-wrap',
	              onClick: this.exitSession.bind(this) },
	            _('Yes, exit to DASHBOARD')
	          ),
	          _react2['default'].createElement(
	            'button',
	            {
	              className: 'btn btn-sm btn-default',
	              onClick: this.returnToPresentation.bind(this) },
	            _('No, back to presentation')
	          )
	        )
	      );
	    }
	  }], [{
	    key: 'contextTypes',
	    value: {
	      setActiveSession: _react.PropTypes.func.isRequired,
	      setMode: _react.PropTypes.func.isRequired,
	      hideHUD: _react.PropTypes.func.isRequired,
	      i18n: _react.PropTypes.func.isRequired
	    },
	    enumerable: true
	  }]);
	
	  return Exit;
	})(_react.Component);
	
	exports['default'] = Exit;
	module.exports = exports['default'];

/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _get = __webpack_require__(8)['default'];
	
	var _inherits = __webpack_require__(5)['default'];
	
	var _createClass = __webpack_require__(6)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _funVideoRemote = __webpack_require__(1164);
	
	var _funVideoRemote2 = _interopRequireDefault(_funVideoRemote);
	
	__webpack_require__(2206);
	
	var Fun = (function (_Component) {
	  _inherits(Fun, _Component);
	
	  function Fun() {
	    _classCallCheck(this, Fun);
	
	    _get(Object.getPrototypeOf(Fun.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(Fun, [{
	    key: 'clickVideo',
	    value: function clickVideo(index, evt) {
	      var _context = this.context;
	      var setMode = _context.setMode;
	      var setVideoState = _context.setVideoState;
	
	      setVideoState({
	        playing: false,
	        started: false,
	        finished: false
	      }).then(function () {
	        setMode('extras/' + index);
	      });
	      evt.preventDefault();
	      evt.stopPropagation();
	      evt.nativeEvent.stopPropagation();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this = this;
	
	      var _context2 = this.context;
	      var presenter = _context2.presenter;
	      var funMd = _context2.program.funMd;
	      var mode = _context2.session.mode;
	      var regionData = _context2.regionData;
	      var _ = _context2.i18n;
	
	      var funMd_i18n = _(funMd);
	      var funItemNames = funMd_i18n.getSectionNames();
	      if (presenter && mode !== 'extras') {
	        return _react2['default'].createElement(_funVideoRemote2['default'], null);
	      }
	      return _react2['default'].createElement(
	        'div',
	        { className: 'fun' },
	        _react2['default'].createElement(
	          'h1',
	          null,
	          _('Extras')
	        ),
	        _react2['default'].createElement(
	          'ul',
	          { className: 'fun-items scroller-panel' },
	          funItemNames.map(function (funItemName, index) {
	            var youTubeId = funMd_i18n.getSectionMetadata(funItemName, 'YouTube', regionData);
	            var description = funMd_i18n.getSubSectionAsString(funItemName, 'Description', false, regionData);
	            return _react2['default'].createElement(
	              'li',
	              {
	                className: 'fun-item',
	                key: funItemName },
	              _react2['default'].createElement(
	                'a',
	                { href: '#',
	                  onClick: _this.clickVideo.bind(_this, index + 1) },
	                _react2['default'].createElement(
	                  'figure',
	                  { className: 'fun-image' },
	                  _react2['default'].createElement('img', {
	                    src: '//img.youtube.com/vi/' + youTubeId + '/hqdefault.jpg' })
	                )
	              ),
	              _react2['default'].createElement(
	                'div',
	                { className: 'fun-item-info' },
	                _react2['default'].createElement(
	                  'h3',
	                  null,
	                  funItemName
	                ),
	                _react2['default'].createElement(
	                  'p',
	                  null,
	                  description
	                )
	              )
	            );
	          })
	        )
	      );
	    }
	  }], [{
	    key: 'contextTypes',
	    value: {
	      presenter: _react.PropTypes.bool,
	      program: _react.PropTypes.object.isRequired,
	      session: _react.PropTypes.object.isRequired,
	      setVideoState: _react.PropTypes.func.isRequired,
	      setMode: _react.PropTypes.func.isRequired,
	      regionData: _react.PropTypes.object.isRequired,
	      i18n: _react.PropTypes.func.isRequired
	    },
	    enumerable: true
	  }]);
	
	  return Fun;
	})(_react.Component);
	
	exports['default'] = Fun;
	module.exports = exports['default'];

/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _taggedTemplateLiteral = __webpack_require__(28)['default'];
	
	var _get = __webpack_require__(8)['default'];
	
	var _inherits = __webpack_require__(5)['default'];
	
	var _createClass = __webpack_require__(6)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _Object$keys = __webpack_require__(32)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['Level ', ':'], ['Level ', ':']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _featureFlags = __webpack_require__(300);
	
	var _featureFlags2 = _interopRequireDefault(_featureFlags);
	
	__webpack_require__(2208);
	
	function noOp() {}
	
	var Overview = (function (_Component) {
	  _inherits(Overview, _Component);
	
	  function Overview() {
	    _classCallCheck(this, Overview);
	
	    _get(Object.getPrototypeOf(Overview.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(Overview, [{
	    key: 'jumpToLevel',
	    value: function jumpToLevel(levelNumber) {
	      var _context = this.context;
	      var setCurrentLevel = _context.setCurrentLevel;
	      var hideHUD = _context.hideHUD;
	
	      setCurrentLevel(levelNumber);
	      hideHUD();
	    }
	  }, {
	    key: 'hideHUD',
	    value: function hideHUD(evt) {
	      evt.preventDefault();
	      this.context.setMode(null);
	      this.context.hideHUD();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this = this;
	
	      var _context2 = this.context;
	      var session = _context2.session;
	      var program = _context2.program;
	      var staff = _context2.staff;
	      var _ = _context2.i18n;
	      var currentLevel = session.currentLevel;
	      var sessionCompletedLevel = session.completedLevel;
	
	      var completedLevel = sessionCompletedLevel ? sessionCompletedLevel : 0;
	      var levels = program.levels;
	
	      var levelRows = _Object$keys(levels).map(function (levelKey) {
	        var levelNumber = Number(levelKey);
	        if (isNaN(levelNumber)) {
	          return null;
	        }
	        var level = levels[levelKey];
	        var thumbnail = level.thumbnail;
	        var levelName = level.levelName;
	
	        var isCurrentLevel = levelNumber === Number(currentLevel);
	        var canSkip = levelNumber <= completedLevel + 1 || staff || _featureFlags2['default'].allowAnyoneToSkipBetweenLevels;
	        return _react2['default'].createElement(
	          'li',
	          { key: 'level' + levelNumber,
	            className: levelNumber === Number(currentLevel) ? 'current overview-level level-' + levelNumber : 'overview-level level-' + levelNumber },
	          _react2['default'].createElement(
	            'div',
	            { className: 'overview-level-image' },
	            _react2['default'].createElement('img', { onClick: isCurrentLevel ? _this.hideHUD.bind(_this) : canSkip ? _this.jumpToLevel.bind(_this, levelNumber) : noOp, src: thumbnail })
	          ),
	          _react2['default'].createElement(
	            'div',
	            { className: 'overview-level-info' },
	            _react2['default'].createElement(
	              'h2',
	              null,
	              _(_templateObject, levelNumber),
	              ' ',
	              _react2['default'].createElement(
	                'span',
	                null,
	                _(levelName)
	              )
	            )
	          ),
	          _react2['default'].createElement(
	            'div',
	            { className: 'overview-level-status' },
	            isCurrentLevel && _react2['default'].createElement(
	              'button',
	              {
	                className: 'btn btn-sm btn-current',
	                onClick: _this.hideHUD.bind(_this) },
	              _('In Progress')
	            ),
	            levelNumber !== Number(currentLevel) && canSkip && _react2['default'].createElement(
	              'button',
	              {
	                className: 'btn btn-sm btn-default',
	                onClick: _this.jumpToLevel.bind(_this, levelNumber) },
	              levelNumber >= Number(currentLevel) ? _('Skip to Level') : _('Back to Level')
	            ),
	            levelNumber !== Number(currentLevel) && !canSkip && _react2['default'].createElement(
	              'button',
	              {
	                className: 'btn btn-sm btn-link', disabled: true },
	              _('Restricted')
	            )
	          )
	        );
	      });
	
	      return _react2['default'].createElement(
	        'div',
	        {
	          className: 'overview' },
	        _react2['default'].createElement(
	          'h1',
	          null,
	          _('Modules')
	        ),
	        _react2['default'].createElement(
	          'ul',
	          {
	            className: 'overview-levels scroller-panel' },
	          levelRows
	        )
	      );
	    }
	  }], [{
	    key: 'contextTypes',
	    value: {
	      session: _react.PropTypes.object.isRequired,
	      program: _react.PropTypes.object.isRequired,
	      setCurrentLevel: _react.PropTypes.func.isRequired,
	      setMode: _react.PropTypes.func.isRequired,
	      hideHUD: _react.PropTypes.func.isRequired,
	      staff: _react.PropTypes.bool,
	      i18n: _react.PropTypes.func.isRequired
	    },
	    enumerable: true
	  }]);
	
	  return Overview;
	})(_react.Component);
	
	exports['default'] = Overview;
	module.exports = exports['default'];

/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _get = __webpack_require__(8)['default'];
	
	var _inherits = __webpack_require__(5)['default'];
	
	var _createClass = __webpack_require__(6)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(2209);
	
	var Scores = (function (_Component) {
	  _inherits(Scores, _Component);
	
	  function Scores() {
	    _classCallCheck(this, Scores);
	
	    _get(Object.getPrototypeOf(Scores.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(Scores, [{
	    key: 'decrement',
	    value: function decrement(teamNumber, value) {
	      var _context = this.context;
	      var session = _context.session;
	      var setScore = _context.setScore;
	      var scores = session.scores;
	
	      var newScore = scores && scores[teamNumber] ? scores[teamNumber] - value : 0;
	      setScore(teamNumber, Math.max(newScore, 0));
	    }
	  }, {
	    key: 'increment',
	    value: function increment(teamNumber, value) {
	      var _context2 = this.context;
	      var session = _context2.session;
	      var setScore = _context2.setScore;
	      var scores = session.scores;
	
	      var newScore = scores && scores[teamNumber] ? scores[teamNumber] + value : value;
	      setScore(teamNumber, newScore);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this = this;
	
	      var _context3 = this.context;
	      var session = _context3.session;
	      var presenter = _context3.presenter;
	      var _ = _context3.i18n;
	      var scores = session.scores;
	      var teamNames = session.teamNames;
	
	      var styles = {
	        scores: {},
	        button: {}
	      };
	      if (presenter) {
	        styles.scores.height = '100%';
	      }
	
	      return _react2['default'].createElement(
	        'div',
	        {
	          className: 'deck-hud-scores' },
	        _react2['default'].createElement(
	          'h1',
	          null,
	          _('Team Scoreboard')
	        ),
	        _react2['default'].createElement(
	          'ul',
	          null,
	          [1, 2, 3, 4].map(function (teamNumber) {
	            return _react2['default'].createElement(
	              'li',
	              {
	                key: teamNumber,
	                className: 'deck-hud-scores-team team-' + teamNumber },
	              _react2['default'].createElement(
	                'div',
	                { className: 'deck-hud-scores-score' },
	                scores && scores[teamNumber] ? scores[teamNumber] : '0'
	              ),
	              _react2['default'].createElement(
	                'div',
	                { fit: true, className: 'deck-hud-scores-name ppa-icon-team-' + teamNumber },
	                _react2['default'].createElement(
	                  'span',
	                  { className: 'team-name' },
	                  teamNames && teamNames[teamNumber] ? teamNames[teamNumber] : _(['Earth', 'Fire', 'Water', 'Air'][teamNumber - 1])
	                )
	              ),
	              _react2['default'].createElement(
	                'div',
	                {
	                  className: 'btn btn-sm deck-hud-scores-btn',
	                  style: styles.button,
	                  onClick: _this.decrement.bind(_this, teamNumber, 10) },
	                '-10'
	              ),
	              _react2['default'].createElement(
	                'div',
	                {
	                  className: 'btn btn-lg deck-hud-scores-btn',
	                  style: styles.button,
	                  onClick: _this.decrement.bind(_this, teamNumber, 1) },
	                '-1'
	              ),
	              _react2['default'].createElement(
	                'div',
	                {
	                  className: 'btn btn-lg deck-hud-scores-btn',
	                  style: styles.button,
	                  onClick: _this.increment.bind(_this, teamNumber, 1) },
	                '+1'
	              ),
	              _react2['default'].createElement(
	                'div',
	                {
	                  className: 'btn btn-sm deck-hud-scores-btn',
	                  style: styles.button,
	                  onClick: _this.increment.bind(_this, teamNumber, 10) },
	                '+10'
	              )
	            );
	          })
	        )
	      );
	    }
	  }], [{
	    key: 'contextTypes',
	    value: {
	      session: _react.PropTypes.object.isRequired,
	      setScore: _react.PropTypes.func.isRequired,
	      presenter: _react.PropTypes.bool.isRequired,
	      i18n: _react.PropTypes.func.isRequired
	    },
	    enumerable: true
	  }]);
	
	  return Scores;
	})(_react.Component);
	
	exports['default'] = Scores;
	module.exports = exports['default'];

/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _get = __webpack_require__(8)['default'];
	
	var _inherits = __webpack_require__(5)['default'];
	
	var _createClass = __webpack_require__(6)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactAddonsCssTransitionGroup = __webpack_require__(188);
	
	var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);
	
	var _sessionPanel = __webpack_require__(483);
	
	var _sessionPanel2 = _interopRequireDefault(_sessionPanel);
	
	var SessionList = (function (_Component) {
	  _inherits(SessionList, _Component);
	
	  function SessionList() {
	    _classCallCheck(this, SessionList);
	
	    _get(Object.getPrototypeOf(SessionList.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(SessionList, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var title = _props.title;
	      var sessions = _props.sessions;
	      var userId = _props.userId;
	      var email = _props.email;
	      var approveSession = _props.approveSession;
	      var hideSession = _props.hideSession;
	      var putOnHold = _props.putOnHold;
	      var changeProgram = _props.changeProgram;
	      var changeUser = _props.changeUser;
	      var clearFound = _props.clearFound;
	
	      return _react2['default'].createElement(
	        'div',
	        null,
	        _react2['default'].createElement(
	          'h4',
	          null,
	          title
	        ),
	        _react2['default'].createElement(
	          _reactAddonsCssTransitionGroup2['default'],
	          {
	            transitionName: 'unapproved-session-list',
	            transitionEnterTimeout: 500,
	            transitionLeaveTimeout: 1000 },
	          sessions.length ? sessions.map(function (session) {
	            var sessionId = session.sessionId;
	
	            return _react2['default'].createElement(_sessionPanel2['default'], {
	              key: sessionId,
	              userId: userId,
	              email: email,
	              session: session,
	              approveSession: approveSession,
	              hideSession: hideSession,
	              putOnHold: putOnHold,
	              changeProgram: changeProgram,
	              changeUser: changeUser,
	              clearFound: clearFound
	            });
	          }) : _react2['default'].createElement(
	            'div',
	            null,
	            'None'
	          )
	        )
	      );
	    }
	  }], [{
	    key: 'propTypes',
	    value: {
	      title: _react.PropTypes.string.isRequired,
	      sessions: _react.PropTypes.array.isRequired,
	      userId: _react.PropTypes.string.isRequired,
	      email: _react.PropTypes.string.isRequired,
	      approveSession: _react.PropTypes.func,
	      hideSession: _react.PropTypes.func,
	      putOnHold: _react.PropTypes.func,
	      changeProgram: _react.PropTypes.func,
	      changeUser: _react.PropTypes.func,
	      clearFound: _react.PropTypes.func
	    },
	    enumerable: true
	  }]);
	
	  return SessionList;
	})(_react.Component);
	
	exports['default'] = SessionList;
	module.exports = exports['default'];

/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _get = __webpack_require__(8)['default'];
	
	var _inherits = __webpack_require__(5)['default'];
	
	var _createClass = __webpack_require__(6)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _inputMoment = __webpack_require__(1386);
	
	var _inputMoment2 = _interopRequireDefault(_inputMoment);
	
	var _moment = __webpack_require__(10);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _programs = __webpack_require__(69);
	
	var _programs2 = _interopRequireDefault(_programs);
	
	var _appConfig = __webpack_require__(54);
	
	__webpack_require__(2229);
	
	var _helpersI18n = __webpack_require__(14);
	
	__webpack_require__(2224);
	
	var validContractIdRegEx = /^800/;
	
	var SessionPanel = (function (_Component) {
	  _inherits(SessionPanel, _Component);
	
	  _createClass(SessionPanel, null, [{
	    key: 'propTypes',
	    value: {
	      session: _react.PropTypes.object.isRequired,
	      userId: _react.PropTypes.string.isRequired,
	      email: _react.PropTypes.string.isRequired,
	      approveSession: _react.PropTypes.func,
	      hideSession: _react.PropTypes.func,
	      clearFound: _react.PropTypes.func,
	      changeUser: _react.PropTypes.func,
	      cancelFundedSpot: _react.PropTypes.func,
	      refundSession: _react.PropTypes.func,
	      changeContractId: _react.PropTypes.func,
	      changeValidUntil: _react.PropTypes.func,
	      unarchiveSession: _react.PropTypes.func,
	      addToNurtureCampaign: _react.PropTypes.func,
	      putOnHold: _react.PropTypes.func,
	      changeProgram: _react.PropTypes.func
	    },
	    enumerable: true
	  }, {
	    key: 'contextTypes',
	    value: {
	      userId: _react.PropTypes.string.isRequired,
	      i18n: _react.PropTypes.func.isRequired
	    },
	    enumerable: true
	  }]);
	
	  function SessionPanel(props) {
	    _classCallCheck(this, SessionPanel);
	
	    _get(Object.getPrototypeOf(SessionPanel.prototype), 'constructor', this).call(this, props);
	    this.state = {
	      error: null,
	      validUntil: (0, _moment2['default'])(props.session.validUntil),
	      showValidUntilPicker: false,
	      programId: props.session.programId,
	      showProgramSelector: false
	    };
	  }
	
	  _createClass(SessionPanel, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(props) {
	      this.setState({ validUntil: (0, _moment2['default'])(props.session.validUntil) });
	    }
	  }, {
	    key: '_approve',
	    value: function _approve(evt, noEmail) {
	      var _props = this.props;
	      var userId = _props.userId;
	      var email = _props.email;
	      var _props$session = _props.session;
	      var sessionId = _props$session.sessionId;
	      var programId = _props$session.programId;
	      var divisionName = _props$session.divisionName;
	      var grade = _props$session.grade;
	      var numberOfStudents = _props$session.numberOfStudents;
	      var language = _props$session.language;
	      var approveSession = _props.approveSession;
	      var staffUserId = this.context.userId;
	
	      var contractId = this.refs.contractId.value;
	      evt.preventDefault();
	      evt.stopPropagation();
	      evt.nativeEvent.stopPropagation();
	      if (!contractId) {
	        this.setState({ error: 'Contract # is required!' });
	        return;
	      }
	      if (!validContractIdRegEx.test(contractId)) {
	        this.setState({ error: 'Contract # must start with 800!' });
	        return;
	      }
	      approveSession({
	        sessionId: sessionId,
	        contractId: contractId,
	        staffUserId: staffUserId,
	        userId: userId,
	        email: email,
	        programId: programId,
	        grade: grade,
	        divisionName: divisionName,
	        numberOfStudents: numberOfStudents,
	        noEmail: noEmail,
	        language: language
	      });
	    }
	  }, {
	    key: 'approve',
	    value: function approve(evt) {
	      this._approve(evt, false);
	    }
	  }, {
	    key: 'approveWithNoEmail',
	    value: function approveWithNoEmail(evt) {
	      this._approve(evt, true);
	    }
	  }, {
	    key: 'putOnHold',
	    value: function putOnHold(evt) {
	      evt.preventDefault();
	      evt.stopPropagation();
	      var sessionId = this.props.session.sessionId;
	
	      this.props.putOnHold({ sessionId: sessionId });
	    }
	  }, {
	    key: '_hide',
	    value: function _hide(evt, noEmail) {
	      var _props2 = this.props;
	      var userId = _props2.userId;
	      var email = _props2.email;
	      var _props2$session = _props2.session;
	      var sessionId = _props2$session.sessionId;
	      var programId = _props2$session.programId;
	      var grade = _props2$session.grade;
	      var divisionName = _props2$session.divisionName;
	      var numberOfStudents = _props2$session.numberOfStudents;
	      var hideSession = _props2.hideSession;
	      var staffUserId = this.context.userId;
	
	      evt.preventDefault();
	      evt.stopPropagation();
	      evt.nativeEvent.stopPropagation();
	      hideSession({
	        sessionId: sessionId,
	        staffUserId: staffUserId,
	        userId: userId,
	        email: email,
	        programId: programId,
	        grade: grade,
	        divisionName: divisionName,
	        numberOfStudents: numberOfStudents,
	        noEmail: noEmail
	      });
	    }
	  }, {
	    key: 'hide',
	    value: function hide(evt) {
	      this._hide(evt, false);
	    }
	  }, {
	    key: 'hideWithNoEmail',
	    value: function hideWithNoEmail(evt) {
	      this._hide(evt, true);
	    }
	  }, {
	    key: 'changeUser',
	    value: function changeUser(evt) {
	      var _this = this;
	
	      evt.preventDefault();
	      evt.stopPropagation();
	      var _props3 = this.props;
	      var oldUserId = _props3.userId;
	      var _props3$session = _props3.session;
	      var sessionId = _props3$session.sessionId;
	      var programId = _props3$session.programId;
	
	      var newUserId = this.refs.userId.value;
	      var staffUserId = this.context.userId;
	
	      this.props.changeUser({
	        sessionId: sessionId,
	        programId: programId,
	        oldUserId: oldUserId,
	        newUserId: newUserId,
	        staffUserId: staffUserId
	      })['catch'](function (err) {
	        _this.setState({ error: err.message });
	      });
	    }
	  }, {
	    key: 'backToSearch',
	    value: function backToSearch(evt) {
	      evt.preventDefault();
	      evt.stopPropagation();
	      this.props.clearFound();
	    }
	  }, {
	    key: 'cancelFundedSpot',
	    value: function cancelFundedSpot(evt) {
	      evt.preventDefault();
	      evt.stopPropagation();
	      var _props$session2 = this.props.session;
	      var sessionId = _props$session2.sessionId;
	      var programId = _props$session2.programId;
	      var userId = _props$session2.userId;
	      var staffUserId = this.context.userId;
	
	      this.props.cancelFundedSpot({ sessionId: sessionId, programId: programId, userId: userId, staffUserId: staffUserId });
	    }
	  }, {
	    key: 'refundSession',
	    value: function refundSession(evt) {
	      evt.preventDefault();
	      evt.stopPropagation();
	      var _props$session3 = this.props.session;
	      var sessionId = _props$session3.sessionId;
	      var programId = _props$session3.programId;
	      var sessionFunding = _props$session3.funding;
	      var userId = _props$session3.userId;
	      var staffUserId = this.context.userId;
	
	      this.props.refundSession({ sessionId: sessionId, sessionFunding: sessionFunding, programId: programId, userId: userId, staffUserId: staffUserId });
	    }
	  }, {
	    key: 'unarchiveSession',
	    value: function unarchiveSession(evt) {
	      evt.preventDefault();
	      evt.stopPropagation();
	      var _props$session4 = this.props.session;
	      var sessionId = _props$session4.sessionId;
	      var programId = _props$session4.programId;
	      var userId = _props$session4.userId;
	      var staffUserId = this.context.userId;
	
	      this.props.unarchiveSession({ sessionId: sessionId, programId: programId, userId: userId, staffUserId: staffUserId });
	    }
	  }, {
	    key: 'changeContractId',
	    value: function changeContractId(evt) {
	      evt.preventDefault();
	      evt.stopPropagation();
	      var _props$session5 = this.props.session;
	      var sessionId = _props$session5.sessionId;
	      var programId = _props$session5.programId;
	      var userId = _props$session5.userId;
	      var oldContractId = _props$session5.contractId;
	      var staffUserId = this.context.userId;
	
	      var newContractId = this.refs.contractId.value;
	      if (!newContractId) {
	        this.setState({ error: 'New contract # is required!' });
	        return;
	      }
	      if (!validContractIdRegEx.test(newContractId)) {
	        this.setState({ error: 'Contract # must start with 800!' });
	        return;
	      }
	      this.props.changeContractId({ sessionId: sessionId, programId: programId, userId: userId, staffUserId: staffUserId, oldContractId: oldContractId, newContractId: newContractId });
	    }
	  }, {
	    key: 'updateValidUntil',
	    value: function updateValidUntil() {
	      var _props$session6 = this.props.session;
	      var sessionId = _props$session6.sessionId;
	      var programId = _props$session6.programId;
	      var userId = _props$session6.userId;
	      var oldValidUntil = _props$session6.validUntil;
	      var staffUserId = this.context.userId;
	
	      var newValidUntil = this.state.validUntil.valueOf();
	      this.props.changeValidUntil({ sessionId: sessionId, programId: programId, userId: userId, staffUserId: staffUserId, oldValidUntil: oldValidUntil, newValidUntil: newValidUntil });
	    }
	  }, {
	    key: 'addToNurtureCampaign',
	    value: function addToNurtureCampaign(evt) {
	      evt.preventDefault();
	      evt.stopPropagation();
	      var _props$session7 = this.props.session;
	      var sessionId = _props$session7.sessionId;
	      var userId = _props$session7.userId;
	      var programId = _props$session7.programId;
	      var staffUserId = this.context.userId;
	
	      this.props.addToNurtureCampaign({ userId: userId, sessionId: sessionId, programId: programId, staffUserId: staffUserId });
	    }
	  }, {
	    key: 'handleValidUntilChange',
	    value: function handleValidUntilChange(validUntil) {
	      this.setState({ validUntil: validUntil });
	    }
	  }, {
	    key: 'toggleValidUntilPicker',
	    value: function toggleValidUntilPicker(evt) {
	      evt.preventDefault();
	      var validUntil = this.props.session.validUntil;
	
	      this.setState({ showValidUntilPicker: !this.state.showValidUntilPicker, validUntil: (0, _moment2['default'])(validUntil) });
	    }
	  }, {
	    key: 'showChangeProgram',
	    value: function showChangeProgram(evt) {
	      evt.preventDefault();
	      this.setState({ showProgramSelector: true });
	    }
	  }, {
	    key: 'changeProgram',
	    value: function changeProgram(evt) {
	      evt.preventDefault();
	      var _props$session8 = this.props.session;
	      var sessionId = _props$session8.sessionId;
	      var oldProgramId = _props$session8.programId;
	      var userId = _props$session8.userId;
	
	      this.props.changeProgram({ sessionId: sessionId, oldProgramId: oldProgramId, newProgramId: this.state.programId, userId: userId });
	      this.setState({ showProgramSelector: false });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props$session9 = this.props.session;
	      var sessionId = _props$session9.sessionId;
	      var createdAt = _props$session9.createdAt;
	      var funding = _props$session9.funding;
	      var programId = _props$session9.programId;
	      var divisionName = _props$session9.divisionName;
	      var grade = _props$session9.grade;
	      var numberOfStudents = _props$session9.numberOfStudents;
	      var contractId = _props$session9.contractId;
	      var validUntil = _props$session9.validUntil;
	      var archived = _props$session9.archived;
	      var archivedAt = _props$session9.archivedAt;
	      var onHold = _props$session9.onHold;
	      var language = _props$session9.language;
	      var _ = this.context.i18n;
	
	      var isApproval = this.props.approveSession && this.props.hideSession;
	      var isAdmin = this.props.changeUser && this.props.clearFound;
	      var program = _programs2['default'].programLookup[programId];
	      var title = program.title;
	      var error = this.state.error;
	
	      var firebaseBase = 'https://' + _appConfig.firebase + '.firebaseio.com';
	      var firebaseLink = firebaseBase + '/sessions/' + sessionId;
	      return _react2['default'].createElement(
	        'form',
	        { className: 'panel panel-default form-horizontal session-panel' },
	        _react2['default'].createElement(
	          'div',
	          { className: 'panel-heading' },
	          _react2['default'].createElement(
	            'h4',
	            { className: 'panel-title' },
	            'Date Started: ',
	            createdAt && (0, _moment2['default'])(createdAt).local().toString()
	          )
	        ),
	        _react2['default'].createElement(
	          'div',
	          { className: 'panel-body' },
	          _react2['default'].createElement(
	            'div',
	            { className: 'row' },
	            _react2['default'].createElement(
	              'dl',
	              { className: 'dl-horizontal col-xs-12 col-sm-6' },
	              _react2['default'].createElement(
	                'dt',
	                null,
	                'Program'
	              ),
	              this.state.showProgramSelector ? _react2['default'].createElement(
	                'dd',
	                null,
	                _react2['default'].createElement(
	                  'select',
	                  { defaultValue: programId, value: this.state.programId, onChange: function (evt) {
	                      return _this2.setState({ programId: evt.target.value });
	                    } },
	                  _programs2['default'].programList.map(function (p) {
	                    return _react2['default'].createElement(
	                      'option',
	                      { key: p.id, value: p.id },
	                      _(p.title)
	                    );
	                  })
	                ),
	                _react2['default'].createElement(
	                  'span',
	                  { onClick: this.changeProgram.bind(this) },
	                  '💾'
	                )
	              ) : _react2['default'].createElement(
	                'dd',
	                null,
	                _(title)
	              ),
	              _react2['default'].createElement(
	                'dt',
	                null,
	                'Language'
	              ),
	              _react2['default'].createElement(
	                'dd',
	                null,
	                _helpersI18n.languages[language]
	              ),
	              _react2['default'].createElement(
	                'dt',
	                null,
	                'Division'
	              ),
	              _react2['default'].createElement(
	                'dd',
	                null,
	                divisionName
	              ),
	              _react2['default'].createElement(
	                'dt',
	                null,
	                'Grade'
	              ),
	              _react2['default'].createElement(
	                'dd',
	                null,
	                grade
	              ),
	              _react2['default'].createElement(
	                'dt',
	                null,
	                'Students'
	              ),
	              _react2['default'].createElement(
	                'dd',
	                null,
	                numberOfStudents
	              ),
	              _react2['default'].createElement(
	                'dt',
	                null,
	                'Session ID'
	              ),
	              _react2['default'].createElement(
	                'dd',
	                null,
	                _react2['default'].createElement(
	                  'a',
	                  { href: firebaseLink, target: '_blank' },
	                  sessionId
	                )
	              ),
	              isAdmin && _react2['default'].createElement(
	                'dt',
	                null,
	                'Funding'
	              ),
	              isAdmin && _react2['default'].createElement(
	                'dd',
	                null,
	                funding
	              ),
	              isAdmin && _react2['default'].createElement(
	                'dt',
	                null,
	                'Contract ID'
	              ),
	              isAdmin && _react2['default'].createElement(
	                'dd',
	                null,
	                contractId
	              ),
	              isAdmin && _react2['default'].createElement(
	                'dt',
	                null,
	                'Archived'
	              ),
	              isAdmin && _react2['default'].createElement(
	                'dd',
	                null,
	                archived && archivedAt && (0, _moment2['default'])(archivedAt).local().toString()
	              ),
	              isAdmin && _react2['default'].createElement(
	                'dt',
	                null,
	                'Valid Until'
	              ),
	              isAdmin && _react2['default'].createElement(
	                'dd',
	                null,
	                validUntil && (0, _moment2['default'])(this.state.validUntil).local().toString(),
	                this.state.showValidUntilPicker && _react2['default'].createElement(_inputMoment2['default'], {
	                  moment: this.state.validUntil,
	                  onChange: this.handleValidUntilChange.bind(this),
	                  onSave: this.updateValidUntil.bind(this),
	                  prevMonthIcon: 'glyphicon glyphicon-chevron-left',
	                  nextMonthIcon: 'glyphicon glyphicon-chevron-right' })
	              ),
	              _react2['default'].createElement(
	                'dt',
	                null,
	                'Session created'
	              ),
	              _react2['default'].createElement(
	                'dd',
	                null,
	                (0, _moment2['default'])(createdAt).local().toString()
	              )
	            ),
	            isApproval && _react2['default'].createElement(
	              'div',
	              { className: 'col-xs-12 col-sm-6' },
	              _react2['default'].createElement(
	                'div',
	                { className: 'col-xs-12 col-md-6 form-group' },
	                _react2['default'].createElement(
	                  'label',
	                  { className: 'control-label' },
	                  'Contract #'
	                ),
	                _react2['default'].createElement('input', {
	                  className: 'form-control',
	                  ref: 'contractId' }),
	                error && _react2['default'].createElement(
	                  'div',
	                  { className: 'text-danger' },
	                  error
	                )
	              ),
	              _react2['default'].createElement(
	                'div',
	                { className: 'col-xs-12 col-md-6' },
	                _react2['default'].createElement(
	                  'button',
	                  {
	                    className: 'btn btn-xs btn-primary approval-buttons',
	                    onClick: this.approve.bind(this) },
	                  'Approve'
	                ),
	                _react2['default'].createElement(
	                  'button',
	                  {
	                    className: 'btn btn-xs btn-primary approval-buttons',
	                    onClick: this.approveWithNoEmail.bind(this) },
	                  'Approve No Emails'
	                ),
	                !onHold && _react2['default'].createElement(
	                  'button',
	                  {
	                    className: 'btn btn-xs btn-primary approval-buttons',
	                    onClick: this.putOnHold.bind(this) },
	                  'Put on hold'
	                ),
	                _react2['default'].createElement(
	                  'button',
	                  {
	                    className: 'btn btn-xs btn-primary approval-buttons',
	                    onClick: this.showChangeProgram.bind(this) },
	                  'Change program'
	                ),
	                _react2['default'].createElement(
	                  'button',
	                  {
	                    className: 'btn btn-xs btn-danger approval-buttons',
	                    onClick: this.hide.bind(this) },
	                  'Reject + Hide'
	                ),
	                _react2['default'].createElement(
	                  'button',
	                  {
	                    className: 'btn btn-xs btn-danger approval-buttons',
	                    onClick: this.hideWithNoEmail.bind(this) },
	                  'Reject + Hide No Emails'
	                )
	              )
	            ),
	            isAdmin && _react2['default'].createElement(
	              'div',
	              { className: 'col-xs-12 col-sm-6' },
	              _react2['default'].createElement(
	                'div',
	                { className: 'col-xs-12 col-md-6 form-group' },
	                _react2['default'].createElement(
	                  'label',
	                  { className: 'control-label' },
	                  'New User ID'
	                ),
	                _react2['default'].createElement('input', {
	                  className: 'form-control',
	                  ref: 'userId' }),
	                (!funding || contractId) && _react2['default'].createElement(
	                  'label',
	                  { className: 'control-label' },
	                  'New Contract ID'
	                ),
	                (!funding || contractId) && _react2['default'].createElement('input', {
	                  className: 'form-control',
	                  ref: 'contractId' }),
	                error && _react2['default'].createElement(
	                  'div',
	                  { className: 'text-danger' },
	                  error
	                )
	              ),
	              _react2['default'].createElement(
	                'div',
	                { className: 'col-xs-12 col-md-6 staff-actions-btn' },
	                _react2['default'].createElement(
	                  'button',
	                  {
	                    className: 'btn btn-xs btn-primary pull-right',
	                    onClick: this.changeUser.bind(this) },
	                  'Reassign to new User ID'
	                ),
	                _react2['default'].createElement(
	                  'button',
	                  {
	                    className: 'btn btn-xs btn-primary pull-right',
	                    onClick: this.showChangeProgram.bind(this) },
	                  'Change program'
	                ),
	                !funding && _react2['default'].createElement(
	                  'button',
	                  {
	                    className: 'btn btn-xs btn-primary pull-right',
	                    onClick: this.approve.bind(this) },
	                  'Approve'
	                ),
	                contractId && _react2['default'].createElement(
	                  'button',
	                  {
	                    className: 'btn btn-xs btn-primary pull-right',
	                    onClick: this.changeContractId.bind(this) },
	                  'Change to new Contract ID'
	                ),
	                validUntil && _react2['default'].createElement(
	                  'button',
	                  {
	                    className: 'btn btn-xs btn-primary pull-right',
	                    onClick: this.toggleValidUntilPicker.bind(this) },
	                  'Change Valid Until Date'
	                ),
	                contractId && _react2['default'].createElement(
	                  'button',
	                  {
	                    className: 'btn btn-xs btn-primary pull-right',
	                    onClick: this.cancelFundedSpot.bind(this) },
	                  'Cancel Funded Spot'
	                ),
	                contractId && _react2['default'].createElement(
	                  'button',
	                  {
	                    className: 'btn btn-xs btn-primary pull-right',
	                    onClick: this.addToNurtureCampaign.bind(this) },
	                  'Add to nurture campaign'
	                ),
	                funding && funding.toUpperCase() === 'STRIPE' && _react2['default'].createElement(
	                  'button',
	                  {
	                    className: 'btn btn-xs btn-primary pull-right',
	                    onClick: this.refundSession.bind(this) },
	                  'Mark as Refunded'
	                ),
	                archived && archivedAt && _react2['default'].createElement(
	                  'button',
	                  {
	                    className: 'btn btn-xs btn-primary pull-right',
	                    onClick: this.unarchiveSession.bind(this) },
	                  'Unarchive'
	                ),
	                _react2['default'].createElement(
	                  'button',
	                  {
	                    className: 'btn btn-xs btn-danger pull-right',
	                    onClick: this.backToSearch.bind(this) },
	                  'Back to search'
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return SessionPanel;
	})(_react.Component);
	
	exports['default'] = SessionPanel;
	module.exports = exports['default'];

/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _get = __webpack_require__(8)["default"];
	
	var _inherits = __webpack_require__(5)["default"];
	
	var _createClass = __webpack_require__(6)["default"];
	
	var _classCallCheck = __webpack_require__(3)["default"];
	
	var _extends = __webpack_require__(7)["default"];
	
	var _interopRequireDefault = __webpack_require__(2)["default"];
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__(10);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reduxForm = __webpack_require__(36);
	
	var _reactRedux = __webpack_require__(22);
	
	var _jimpickReactSpinner = __webpack_require__(51);
	
	var _jimpickReactSpinner2 = _interopRequireDefault(_jimpickReactSpinner);
	
	var _appConfig = __webpack_require__(54);
	
	var _actionsPaywallActions = __webpack_require__(134);
	
	var _servicesRegionalization = __webpack_require__(38);
	
	var _servicesRegionalization2 = _interopRequireDefault(_servicesRegionalization);
	
	function validateEditUser(data) {
	  var errors = {};
	  if (!data.email) {
	    errors.email = 'required';
	  }
	  if (!data.cityOrMunicipality) {
	    errors.cityOrMunicipality = 'required';
	  }
	  if (!data.stateOrProvince) {
	    errors.stateOrProvince = 'required';
	  }
	  if (!data.country) {
	    errors.country = 'required';
	  }
	  return errors;
	}
	
	var UserPanel = (function (_Component) {
	  _inherits(UserPanel, _Component);
	
	  _createClass(UserPanel, null, [{
	    key: "propTypes",
	    value: {
	      error: _react.PropTypes.string.isRequired,
	      profile: _react.PropTypes.object,
	      fields: _react.PropTypes.object.isRequired,
	      userId: _react.PropTypes.string.isRequired,
	      deleteUser: _react.PropTypes.func,
	      clearFound: _react.PropTypes.func,
	      toggleTester: _react.PropTypes.func,
	      resetEditUserForm: _react.PropTypes.func.isRequired,
	      editUser: _react.PropTypes.func.isRequired
	    },
	    enumerable: true
	  }, {
	    key: "contextTypes",
	    value: {
	      userId: _react.PropTypes.string.isRequired
	    },
	    enumerable: true
	  }]);
	
	  function UserPanel(props) {
	    _classCallCheck(this, _UserPanel);
	
	    _get(Object.getPrototypeOf(_UserPanel.prototype), "constructor", this).call(this, props);
	    this.state = {
	      editing: false,
	      saving: false
	    };
	    this.countries = _servicesRegionalization2["default"].getCountries();
	  }
	
	  _createClass(UserPanel, [{
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.fields.stateOrProvince.value === this.props.fields.stateOrProvince.value && nextProps.fields.country.value !== this.props.fields.country.value) {
	        var defaultValue = _servicesRegionalization2["default"].hasStatesOrProvinces(nextProps.fields.country.value) ? '' : 'Other';
	        this.props.fields.stateOrProvince.onChange(defaultValue);
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this = this;
	
	      var _props = this.props;
	      var error = _props.error;
	      var profile = _props.profile;
	      var userId = _props.userId;
	      var _props$fields = _props.fields;
	      var email = _props$fields.email;
	      var cityOrMunicipality = _props$fields.cityOrMunicipality;
	      var stateOrProvince = _props$fields.stateOrProvince;
	      var country = _props$fields.country;
	      var tester = _props$fields.tester;
	      var values = _props.values;
	      var _state = this.state;
	      var editing = _state.editing;
	      var saving = _state.saving;
	
	      if (!profile) {
	        return _react2["default"].createElement("div", null); // Can happen while loading
	      }
	
	      var statesOrProvinces = _servicesRegionalization2["default"].getStatesOrProvinces(country.value);
	      if (statesOrProvinces.length === 1) {
	        stateOrProvince.disabled = true;
	      }
	
	      var intercomBase = "https://app.intercom.com/apps/" + _appConfig.intercom;
	      var intercomLink = intercomBase + "/users/show?user_id=" + userId;
	      var firebaseBase = "https://" + _appConfig.firebase + ".firebaseio.com";
	      var firebaseLink = firebaseBase + "/users/" + userId;
	      var staffUserLink = "/staff/user/" + userId;
	      var isSearchResult = !!this.props.deleteUser;
	
	      if (!profile.school) {
	        return _react2["default"].createElement("div", null);
	      }
	
	      return _react2["default"].createElement(
	        "div",
	        { className: "well form-horizontal paywallUserForm" },
	        _react2["default"].createElement(
	          "div",
	          { className: "row" },
	          _react2["default"].createElement(
	            "div",
	            { className: "col-sm-6" },
	            _react2["default"].createElement(
	              "div",
	              { className: "form-group" },
	              _react2["default"].createElement(
	                "label",
	                { className: "col-xs-2 col-sm-4 control-label" },
	                "Email"
	              ),
	              _react2["default"].createElement(
	                "div",
	                { className: "col-xs-10 col-sm-8" },
	                editing ? _react2["default"].createElement(
	                  "div",
	                  null,
	                  _react2["default"].createElement("input", _extends({ id: "txtEmail",
	                    type: "email",
	                    className: "form-control",
	                    placeholder: "jane@example.com",
	                    spellCheck: "false",
	                    disabled: saving,
	                    value: values.email
	                  }, email)),
	                  email.error && email.touched && _react2["default"].createElement("div", { className: "text-danger", dangerouslySetInnerHTML: { __html: email.error } })
	                ) : _react2["default"].createElement(
	                  "a",
	                  { href: intercomLink, target: "_blank" },
	                  profile.email
	                )
	              )
	            ),
	            _react2["default"].createElement(
	              "div",
	              { className: "form-group" },
	              _react2["default"].createElement(
	                "label",
	                { className: "col-xs-2 col-sm-4 control-label" },
	                "First Name"
	              ),
	              _react2["default"].createElement(
	                "div",
	                { className: "col-xs-10 col-sm-8" },
	                profile.firstName
	              )
	            ),
	            _react2["default"].createElement(
	              "div",
	              { className: "form-group" },
	              _react2["default"].createElement(
	                "label",
	                { className: "col-xs-2 col-sm-4 control-label" },
	                "Last Name"
	              ),
	              _react2["default"].createElement(
	                "div",
	                { className: "col-xs-10 col-sm-8" },
	                profile.lastName
	              )
	            ),
	            _react2["default"].createElement(
	              "div",
	              { className: "form-group" },
	              _react2["default"].createElement(
	                "label",
	                { className: "col-xs-2 col-sm-4 control-label" },
	                "School"
	              ),
	              _react2["default"].createElement(
	                "div",
	                { className: "col-xs-10 col-sm-8" },
	                profile.school
	              )
	            ),
	            _react2["default"].createElement(
	              "div",
	              { className: "form-group" },
	              _react2["default"].createElement(
	                "div",
	                { className: "col-xs-12 error" },
	                error
	              )
	            ),
	            _react2["default"].createElement(
	              "div",
	              { className: "form-group" },
	              _react2["default"].createElement(
	                "div",
	                { className: "col-xs-12" },
	                isSearchResult && !editing && _react2["default"].createElement(
	                  "button",
	                  {
	                    className: "btn btn-primary btn-sm",
	                    onClick: this._editUser.bind(this) },
	                  "Edit user"
	                ),
	                isSearchResult && editing && _react2["default"].createElement(
	                  "button",
	                  {
	                    className: "btn btn-primary btn-sm",
	                    disabled: email.error || cityOrMunicipality.error || stateOrProvince.error || country.error,
	                    onClick: this._saveUser.bind(this) },
	                  "Save user ",
	                  saving && _react2["default"].createElement(_jimpickReactSpinner2["default"], null)
	                ),
	                " ",
	                isSearchResult && _react2["default"].createElement(
	                  "button",
	                  {
	                    className: "btn btn-primary btn-sm",
	                    onClick: function () {
	                      return _this.props.deleteUser({ userId: userId, staffUserId: _this.context.userId });
	                    } },
	                  "Delete user"
	                ),
	                " ",
	                isSearchResult && _react2["default"].createElement(
	                  "button",
	                  {
	                    className: "btn btn-sm",
	                    onClick: function () {
	                      return _this.props.clearFound();
	                    } },
	                  "Back to search"
	                )
	              )
	            )
	          ),
	          _react2["default"].createElement(
	            "div",
	            { className: "col-sm-6" },
	            _react2["default"].createElement(
	              "div",
	              { className: "form-group" },
	              _react2["default"].createElement(
	                "label",
	                { className: "col-xs-2 col-sm-4 control-label" },
	                "City"
	              ),
	              _react2["default"].createElement(
	                "div",
	                { className: "col-xs-10 col-sm-8" },
	                editing ? _react2["default"].createElement(
	                  "div",
	                  null,
	                  _react2["default"].createElement("input", _extends({ id: "txtCity",
	                    className: "form-control",
	                    placeholder: "Vancouver",
	                    spellCheck: "false",
	                    disabled: saving,
	                    value: values.cityOrMunicipality
	                  }, cityOrMunicipality)),
	                  cityOrMunicipality.error && cityOrMunicipality.touched && _react2["default"].createElement("div", { className: "text-danger", dangerouslySetInnerHTML: { __html: cityOrMunicipality.error } })
	                ) : profile.cityOrMunicipality
	              )
	            ),
	            _react2["default"].createElement(
	              "div",
	              { className: "form-group" },
	              _react2["default"].createElement(
	                "label",
	                { className: "col-xs-2 col-sm-4 control-label" },
	                "State or Province"
	              ),
	              _react2["default"].createElement(
	                "div",
	                { className: "col-xs-10 col-sm-8" },
	                editing ? _react2["default"].createElement(
	                  "div",
	                  null,
	                  _react2["default"].createElement(
	                    "select",
	                    _extends({ id: "selectState",
	                      className: "form-control",
	                      disabled: saving,
	                      value: values.stateOrProvince
	                    }, stateOrProvince),
	                    _react2["default"].createElement(
	                      "option",
	                      { value: "" },
	                      " - Select State or Province -"
	                    ),
	                    statesOrProvinces.map(function (item) {
	                      return _react2["default"].createElement(
	                        "option",
	                        { key: item.code, value: item.code },
	                        item.name
	                      );
	                    })
	                  ),
	                  stateOrProvince.error && stateOrProvince.touched && _react2["default"].createElement("div", { className: "text-danger", dangerouslySetInnerHTML: { __html: stateOrProvince.error } })
	                ) : profile.stateOrProvince
	              )
	            ),
	            _react2["default"].createElement(
	              "div",
	              { className: "form-group" },
	              _react2["default"].createElement(
	                "label",
	                { className: "col-xs-2 col-sm-4 control-label" },
	                "Country"
	              ),
	              _react2["default"].createElement(
	                "div",
	                { className: "col-xs-10 col-sm-8" },
	                editing ? _react2["default"].createElement(
	                  "div",
	                  null,
	                  _react2["default"].createElement(
	                    "select",
	                    _extends({ id: "selectState",
	                      className: "form-control",
	                      disabled: saving,
	                      value: values.country
	                    }, country),
	                    _react2["default"].createElement(
	                      "option",
	                      { value: "" },
	                      " - Select Country -"
	                    ),
	                    _react2["default"].createElement(
	                      "option",
	                      { value: "Canada" },
	                      "Canada"
	                    ),
	                    _react2["default"].createElement(
	                      "option",
	                      { value: "United States" },
	                      "United States"
	                    ),
	                    _react2["default"].createElement(
	                      "option",
	                      { disabled: true },
	                      " ────────── "
	                    ),
	                    this.countries.map(function (item) {
	                      return _react2["default"].createElement(
	                        "option",
	                        { key: item, value: item },
	                        item
	                      );
	                    })
	                  ),
	                  country.error && country.touched && _react2["default"].createElement("div", { className: "text-danger", dangerouslySetInnerHTML: { __html: country.error } })
	                ) : profile.country
	              )
	            ),
	            _react2["default"].createElement(
	              "div",
	              { className: "form-group" },
	              _react2["default"].createElement(
	                "label",
	                { className: "col-xs-2 col-sm-4 control-label" },
	                "Signup Date"
	              ),
	              _react2["default"].createElement(
	                "div",
	                { className: "col-xs-10 col-sm-8" },
	                profile.createdAt && (0, _moment2["default"])(profile.createdAt).local().toString()
	              )
	            ),
	            _react2["default"].createElement(
	              "div",
	              { className: "form-group" },
	              _react2["default"].createElement(
	                "label",
	                { className: "col-xs-2 col-sm-4 control-label" },
	                "User ID"
	              ),
	              _react2["default"].createElement(
	                "div",
	                { className: "col-xs-10 col-sm-8" },
	                isSearchResult ? _react2["default"].createElement(
	                  "a",
	                  { href: firebaseLink, target: "_blank" },
	                  userId
	                ) : _react2["default"].createElement(
	                  "a",
	                  { href: staffUserLink },
	                  userId
	                )
	              )
	            ),
	            _react2["default"].createElement(
	              "div",
	              { className: "form-group" },
	              _react2["default"].createElement(
	                "label",
	                { className: "col-xs-2 col-sm-4 control-label" },
	                "Beta Tester"
	              ),
	              _react2["default"].createElement(
	                "div",
	                { className: "col-xs-10 col-sm-8" },
	                editing ? _react2["default"].createElement("input", _extends({ type: "checkbox"
	                }, tester, {
	                  disabled: saving,
	                  checked: !!values.tester })) : _react2["default"].createElement("input", { type: "checkbox", disabled: true, checked: profile.tester })
	              )
	            )
	          )
	        ),
	        _react2["default"].createElement(
	          "div",
	          { className: "row" },
	          _react2["default"].createElement(
	            "div",
	            { className: "col-xs-12" },
	            this.props.children
	          )
	        )
	      );
	    }
	  }, {
	    key: "_editUser",
	    value: function _editUser() {
	      var _props$profile = this.props.profile;
	      var email = _props$profile.email;
	      var cityOrMunicipality = _props$profile.cityOrMunicipality;
	      var stateOrProvince = _props$profile.stateOrProvince;
	      var country = _props$profile.country;
	      var _props$profile$tester = _props$profile.tester;
	      var tester = _props$profile$tester === undefined ? false : _props$profile$tester;
	
	      this.props.resetEditUserForm({
	        email: email, cityOrMunicipality: cityOrMunicipality, stateOrProvince: stateOrProvince, country: country, tester: tester
	      });
	      this.setState({
	        editing: true
	      });
	    }
	  }, {
	    key: "_saveUser",
	    value: function _saveUser() {
	      var _this2 = this;
	
	      var staffUserId = this.context.userId;
	      var _props2 = this.props;
	      var userId = _props2.userId;
	      var values = _props2.values;
	
	      this.setState({ saving: true });
	      this.props.editUser(userId, values, { staffUserId: staffUserId })["catch"](function (error) {
	        console.error('Failed to save user.', error);
	        _this2.setState({ error: 'Oops something went wrong. Please try again.' });
	      }).then(function () {
	        return _this2.setState({ editing: false, saving: false });
	      });
	    }
	  }]);
	
	  var _UserPanel = UserPanel;
	  UserPanel = (0, _reduxForm.connectReduxForm)({
	    form: 'editUser',
	    fields: ['email', 'cityOrMunicipality', 'stateOrProvince', 'country', 'tester'],
	    validate: validateEditUser
	  })(UserPanel) || UserPanel;
	  UserPanel = (0, _reactRedux.connect)(function (state) {
	    return { error: state.paywall.error };
	  }, { resetEditUserForm: _actionsPaywallActions.resetEditUserForm, editUser: _actionsPaywallActions.editUser })(UserPanel) || UserPanel;
	  return UserPanel;
	})(_react.Component);
	
	exports["default"] = UserPanel;
	module.exports = exports["default"];

/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _extends = __webpack_require__(7)["default"];
	
	var _defineProperty = __webpack_require__(105)["default"];
	
	var _get = __webpack_require__(8)["default"];
	
	var _inherits = __webpack_require__(5)["default"];
	
	var _createClass = __webpack_require__(6)["default"];
	
	var _classCallCheck = __webpack_require__(3)["default"];
	
	var _Object$keys = __webpack_require__(32)["default"];
	
	var _getIterator = __webpack_require__(62)["default"];
	
	var _interopRequireDefault = __webpack_require__(2)["default"];
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(22);
	
	var _reactAddonsCssTransitionGroup = __webpack_require__(188);
	
	var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);
	
	var _lodash = __webpack_require__(65);
	
	var _userPanel = __webpack_require__(484);
	
	var _userPanel2 = _interopRequireDefault(_userPanel);
	
	var _actionsPaywallActions = __webpack_require__(134);
	
	var _viewsStaffSessionList = __webpack_require__(482);
	
	var _viewsStaffSessionList2 = _interopRequireDefault(_viewsStaffSessionList);
	
	function toList(hash, keyProp) {
	  return _Object$keys(hash).map(function (k) {
	    return _extends({}, hash[k], _defineProperty({}, keyProp, k));
	  });
	}
	
	function groupBy(list, key, action) {
	  var result = {};
	  var _iteratorNormalCompletion = true;
	  var _didIteratorError = false;
	  var _iteratorError = undefined;
	
	  try {
	    for (var _iterator = _getIterator(list), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	      var item = _step.value;
	
	      var groupValue = item[key];
	      var group = result[groupValue] = result[groupValue] || [];
	      group.push(item);
	    }
	  } catch (err) {
	    _didIteratorError = true;
	    _iteratorError = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion && _iterator["return"]) {
	        _iterator["return"]();
	      }
	    } finally {
	      if (_didIteratorError) {
	        throw _iteratorError;
	      }
	    }
	  }
	
	  if (action) {
	    var _iteratorNormalCompletion2 = true;
	    var _didIteratorError2 = false;
	    var _iteratorError2 = undefined;
	
	    try {
	      for (var _iterator2 = _getIterator(_Object$keys(result)), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	        var k = _step2.value;
	
	        result[k] = action(result[k]);
	      }
	    } catch (err) {
	      _didIteratorError2 = true;
	      _iteratorError2 = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion2 && _iterator2["return"]) {
	          _iterator2["return"]();
	        }
	      } finally {
	        if (_didIteratorError2) {
	          throw _iteratorError2;
	        }
	      }
	    }
	  }
	  return result;
	}
	
	function keepFirstOfEach(list, key) {
	  var hasOne = {};
	  return list.filter(function (x) {
	    var value = x[key];
	    if (hasOne[value]) return false;
	    hasOne[value] = true;
	    return true;
	  });
	}
	
	var UsersByDate = (function (_Component) {
	  _inherits(UsersByDate, _Component);
	
	  function UsersByDate() {
	    _classCallCheck(this, UsersByDate);
	
	    _get(Object.getPrototypeOf(UsersByDate.prototype), "constructor", this).apply(this, arguments);
	
	    this.state = {
	      unapprovedSessions: {},
	      onHoldSessions: {},
	      sortedUsers: []
	    };
	  }
	
	  _createClass(UsersByDate, [{
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      var _props = this.props;
	      var unapprovedSessions = _props.unapprovedSessions;
	      var onHoldSessions = _props.onHoldSessions;
	      var sessionType = _props.sessionType;
	
	      if ((unapprovedSessions !== prevProps.unapprovedSessions || sessionType !== prevProps.sessionType) && sessionType === 'unapproved') {
	        var sessionList = toList(unapprovedSessions, 'sessionId');
	        var sortedList = (0, _lodash.sortBy)(sessionList, 'createdAt');
	        var sortedUsers = keepFirstOfEach(sortedList, 'userId').map(function (_ref) {
	          var userId = _ref.userId;
	          return { userId: userId };
	        });
	        this.setState({
	          unapprovedSessions: groupBy(sortedList, 'userId'),
	          sortedUsers: sortedUsers
	        });
	      } else if ((onHoldSessions !== prevProps.onHoldSessions || sessionType !== prevProps.sessionType) && sessionType === 'on hold') {
	        var sessionList = toList(onHoldSessions, 'sessionId');
	        var sortedList = (0, _lodash.sortBy)(sessionList, 'createdAt');
	        var sortedUsers = keepFirstOfEach(sortedList, 'userId').map(function (_ref2) {
	          var userId = _ref2.userId;
	          return { userId: userId };
	        });
	        this.setState({
	          onHoldSessions: groupBy(sortedList, 'userId'),
	          sortedUsers: sortedUsers
	        });
	      }
	    }
	  }, {
	    key: "getChildren",
	    value: function getChildren(sessionType, userId) {
	      var _state = this.state;
	      var unapprovedSessions = _state.unapprovedSessions;
	      var onHoldSessions = _state.onHoldSessions;
	      var _props2 = this.props;
	      var approveSession = _props2.approveSession;
	      var hideSession = _props2.hideSession;
	      var putOnHold = _props2.putOnHold;
	      var changeProgram = _props2.changeProgram;
	      var profiles = _props2.profiles;
	
	      var _ref3 = profiles[userId] || {};
	
	      var email = _ref3.email;
	
	      if (sessionType === 'unapproved') {
	        return _react2["default"].createElement(_viewsStaffSessionList2["default"], {
	          title: "Unapproved Classroom Sessions",
	          userId: userId,
	          email: email,
	          sessions: unapprovedSessions[userId],
	          approveSession: approveSession,
	          hideSession: hideSession,
	          putOnHold: putOnHold,
	          changeProgram: changeProgram
	        });
	      }
	      if (sessionType === 'on hold') {
	        return _react2["default"].createElement(_viewsStaffSessionList2["default"], {
	          title: "On Hold Classroom Sessions",
	          userId: userId,
	          email: email,
	          sessions: onHoldSessions[userId],
	          approveSession: approveSession,
	          hideSession: hideSession,
	          putOnHold: putOnHold,
	          changeProgram: changeProgram
	        });
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this = this;
	
	      var _props3 = this.props;
	      var sessionType = _props3.sessionType;
	      var profiles = _props3.profiles;
	      var _state2 = this.state;
	      var unapprovedSessions = _state2.unapprovedSessions;
	      var onHoldSessions = _state2.onHoldSessions;
	      var sortedUsers = _state2.sortedUsers;
	
	      var sessions = 0;
	      if (sessionType === 'unapproved' && unapprovedSessions) {
	        sessions = _Object$keys(unapprovedSessions).length;
	      } else if (sessionType === 'on hold' && onHoldSessions) {
	        sessions = _Object$keys(onHoldSessions).length;
	      }
	
	      return _react2["default"].createElement(
	        "div",
	        null,
	        !sessions && _react2["default"].createElement(
	          "p",
	          null,
	          "No ",
	          sessionType,
	          " classroom sessions"
	        ),
	        _react2["default"].createElement(
	          _reactAddonsCssTransitionGroup2["default"],
	          {
	            transitionName: "unapproved-users-list",
	            transitionEnterTimeout: 500,
	            transitionLeaveTimeout: 1000 },
	          sortedUsers.map(function (user) {
	            var userId = user.userId;
	
	            return _react2["default"].createElement(
	              _userPanel2["default"],
	              {
	                key: userId,
	                userId: userId,
	                profile: profiles[userId]
	              },
	              _this.getChildren(sessionType, userId)
	            );
	          })
	        )
	      );
	    }
	  }], [{
	    key: "propTypes",
	    value: {
	      sessionType: _react.PropTypes.string.isRequired,
	      unapprovedSessions: _react.PropTypes.object.isRequired,
	      onHoldSessions: _react.PropTypes.object.isRequired,
	      profiles: _react.PropTypes.object.isRequired,
	      approveSession: _react.PropTypes.func.isRequired,
	      hideSession: _react.PropTypes.func.isRequired,
	      putOnHold: _react.PropTypes.func.isRequired,
	      changeProgram: _react.PropTypes.func.isRequired
	    },
	    enumerable: true
	  }]);
	
	  return UsersByDate;
	})(_react.Component);
	
	exports["default"] = (0, _reactRedux.connect)(function (_ref4) {
	  var paywall = _ref4.paywall;
	  return {
	    profiles: paywall.profiles,
	    unapprovedSessions: paywall.unapprovedSessions,
	    onHoldSessions: paywall.onHoldSessions
	  };
	}, {
	  approveSession: _actionsPaywallActions.approveSession,
	  hideSession: _actionsPaywallActions.hideSession,
	  putOnHold: _actionsPaywallActions.putOnHold,
	  changeProgram: _actionsPaywallActions.changeProgram
	})(UsersByDate);
	module.exports = exports["default"];

/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1220), __esModule: true };

/***/ }),
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _Array$from = __webpack_require__(1195)["default"];
	
	exports["default"] = function (arr) {
	  if (Array.isArray(arr)) {
	    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];
	
	    return arr2;
	  } else {
	    return _Array$from(arr);
	  }
	};
	
	exports.__esModule = true;

/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {// This method of obtaining a reference to the global object needs to be
	// kept identical to the way it is obtained in runtime.js
	var g =
	  typeof global === "object" ? global :
	  typeof window === "object" ? window :
	  typeof self === "object" ? self : this;
	
	// Use `getOwnPropertyNames` because not all browsers support calling
	// `hasOwnProperty` on the global `self` object in a worker. See #183.
	var hadRuntime = g.regeneratorRuntime &&
	  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;
	
	// Save the old regeneratorRuntime in case it needs to be restored later.
	var oldRuntime = hadRuntime && g.regeneratorRuntime;
	
	// Force reevalutation of runtime.js.
	g.regeneratorRuntime = undefined;
	
	module.exports = __webpack_require__(1206);
	
	if (hadRuntime) {
	  // Restore the original runtime.
	  g.regeneratorRuntime = oldRuntime;
	} else {
	  // Remove the global property added by runtime.js.
	  try {
	    delete g.regeneratorRuntime;
	  } catch(e) {
	    g.regeneratorRuntime = undefined;
	  }
	}
	
	module.exports = { "default": module.exports, __esModule: true };
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process, global, setImmediate) {/* @preserve
	 * The MIT License (MIT)
	 * 
	 * Copyright (c) 2013-2015 Petka Antonov
	 * 
	 * Permission is hereby granted, free of charge, to any person obtaining a copy
	 * of this software and associated documentation files (the "Software"), to deal
	 * in the Software without restriction, including without limitation the rights
	 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	 * copies of the Software, and to permit persons to whom the Software is
	 * furnished to do so, subject to the following conditions:
	 * 
	 * The above copyright notice and this permission notice shall be included in
	 * all copies or substantial portions of the Software.
	 * 
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.  IN NO EVENT SHALL THE
	 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	 * THE SOFTWARE.
	 * 
	 */
	/**
	 * bluebird build version 2.11.0
	 * Features enabled: core, race, call_get, generators, map, nodeify, promisify, props, reduce, settle, some, cancel, using, filter, any, each, timers
	*/
	!function(e){if(true)module.exports=e();else if("function"==typeof define&&define.amd)define([],e);else{var f;"undefined"!=typeof window?f=window:"undefined"!=typeof global?f=global:"undefined"!=typeof self&&(f=self),f.Promise=e()}}(function(){var define,module,exports;return (function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof _dereq_=="function"&&_dereq_;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof _dereq_=="function"&&_dereq_;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(_dereq_,module,exports){
	"use strict";
	module.exports = function(Promise) {
	var SomePromiseArray = Promise._SomePromiseArray;
	function any(promises) {
	    var ret = new SomePromiseArray(promises);
	    var promise = ret.promise();
	    ret.setHowMany(1);
	    ret.setUnwrap();
	    ret.init();
	    return promise;
	}
	
	Promise.any = function (promises) {
	    return any(promises);
	};
	
	Promise.prototype.any = function () {
	    return any(this);
	};
	
	};
	
	},{}],2:[function(_dereq_,module,exports){
	"use strict";
	var firstLineError;
	try {throw new Error(); } catch (e) {firstLineError = e;}
	var schedule = _dereq_("./schedule.js");
	var Queue = _dereq_("./queue.js");
	var util = _dereq_("./util.js");
	
	function Async() {
	    this._isTickUsed = false;
	    this._lateQueue = new Queue(16);
	    this._normalQueue = new Queue(16);
	    this._trampolineEnabled = true;
	    var self = this;
	    this.drainQueues = function () {
	        self._drainQueues();
	    };
	    this._schedule =
	        schedule.isStatic ? schedule(this.drainQueues) : schedule;
	}
	
	Async.prototype.disableTrampolineIfNecessary = function() {
	    if (util.hasDevTools) {
	        this._trampolineEnabled = false;
	    }
	};
	
	Async.prototype.enableTrampoline = function() {
	    if (!this._trampolineEnabled) {
	        this._trampolineEnabled = true;
	        this._schedule = function(fn) {
	            setTimeout(fn, 0);
	        };
	    }
	};
	
	Async.prototype.haveItemsQueued = function () {
	    return this._normalQueue.length() > 0;
	};
	
	Async.prototype.throwLater = function(fn, arg) {
	    if (arguments.length === 1) {
	        arg = fn;
	        fn = function () { throw arg; };
	    }
	    if (typeof setTimeout !== "undefined") {
	        setTimeout(function() {
	            fn(arg);
	        }, 0);
	    } else try {
	        this._schedule(function() {
	            fn(arg);
	        });
	    } catch (e) {
	        throw new Error("No async scheduler available\u000a\u000a    See http://goo.gl/m3OTXk\u000a");
	    }
	};
	
	function AsyncInvokeLater(fn, receiver, arg) {
	    this._lateQueue.push(fn, receiver, arg);
	    this._queueTick();
	}
	
	function AsyncInvoke(fn, receiver, arg) {
	    this._normalQueue.push(fn, receiver, arg);
	    this._queueTick();
	}
	
	function AsyncSettlePromises(promise) {
	    this._normalQueue._pushOne(promise);
	    this._queueTick();
	}
	
	if (!util.hasDevTools) {
	    Async.prototype.invokeLater = AsyncInvokeLater;
	    Async.prototype.invoke = AsyncInvoke;
	    Async.prototype.settlePromises = AsyncSettlePromises;
	} else {
	    if (schedule.isStatic) {
	        schedule = function(fn) { setTimeout(fn, 0); };
	    }
	    Async.prototype.invokeLater = function (fn, receiver, arg) {
	        if (this._trampolineEnabled) {
	            AsyncInvokeLater.call(this, fn, receiver, arg);
	        } else {
	            this._schedule(function() {
	                setTimeout(function() {
	                    fn.call(receiver, arg);
	                }, 100);
	            });
	        }
	    };
	
	    Async.prototype.invoke = function (fn, receiver, arg) {
	        if (this._trampolineEnabled) {
	            AsyncInvoke.call(this, fn, receiver, arg);
	        } else {
	            this._schedule(function() {
	                fn.call(receiver, arg);
	            });
	        }
	    };
	
	    Async.prototype.settlePromises = function(promise) {
	        if (this._trampolineEnabled) {
	            AsyncSettlePromises.call(this, promise);
	        } else {
	            this._schedule(function() {
	                promise._settlePromises();
	            });
	        }
	    };
	}
	
	Async.prototype.invokeFirst = function (fn, receiver, arg) {
	    this._normalQueue.unshift(fn, receiver, arg);
	    this._queueTick();
	};
	
	Async.prototype._drainQueue = function(queue) {
	    while (queue.length() > 0) {
	        var fn = queue.shift();
	        if (typeof fn !== "function") {
	            fn._settlePromises();
	            continue;
	        }
	        var receiver = queue.shift();
	        var arg = queue.shift();
	        fn.call(receiver, arg);
	    }
	};
	
	Async.prototype._drainQueues = function () {
	    this._drainQueue(this._normalQueue);
	    this._reset();
	    this._drainQueue(this._lateQueue);
	};
	
	Async.prototype._queueTick = function () {
	    if (!this._isTickUsed) {
	        this._isTickUsed = true;
	        this._schedule(this.drainQueues);
	    }
	};
	
	Async.prototype._reset = function () {
	    this._isTickUsed = false;
	};
	
	module.exports = new Async();
	module.exports.firstLineError = firstLineError;
	
	},{"./queue.js":28,"./schedule.js":31,"./util.js":38}],3:[function(_dereq_,module,exports){
	"use strict";
	module.exports = function(Promise, INTERNAL, tryConvertToPromise) {
	var rejectThis = function(_, e) {
	    this._reject(e);
	};
	
	var targetRejected = function(e, context) {
	    context.promiseRejectionQueued = true;
	    context.bindingPromise._then(rejectThis, rejectThis, null, this, e);
	};
	
	var bindingResolved = function(thisArg, context) {
	    if (this._isPending()) {
	        this._resolveCallback(context.target);
	    }
	};
	
	var bindingRejected = function(e, context) {
	    if (!context.promiseRejectionQueued) this._reject(e);
	};
	
	Promise.prototype.bind = function (thisArg) {
	    var maybePromise = tryConvertToPromise(thisArg);
	    var ret = new Promise(INTERNAL);
	    ret._propagateFrom(this, 1);
	    var target = this._target();
	
	    ret._setBoundTo(maybePromise);
	    if (maybePromise instanceof Promise) {
	        var context = {
	            promiseRejectionQueued: false,
	            promise: ret,
	            target: target,
	            bindingPromise: maybePromise
	        };
	        target._then(INTERNAL, targetRejected, ret._progress, ret, context);
	        maybePromise._then(
	            bindingResolved, bindingRejected, ret._progress, ret, context);
	    } else {
	        ret._resolveCallback(target);
	    }
	    return ret;
	};
	
	Promise.prototype._setBoundTo = function (obj) {
	    if (obj !== undefined) {
	        this._bitField = this._bitField | 131072;
	        this._boundTo = obj;
	    } else {
	        this._bitField = this._bitField & (~131072);
	    }
	};
	
	Promise.prototype._isBound = function () {
	    return (this._bitField & 131072) === 131072;
	};
	
	Promise.bind = function (thisArg, value) {
	    var maybePromise = tryConvertToPromise(thisArg);
	    var ret = new Promise(INTERNAL);
	
	    ret._setBoundTo(maybePromise);
	    if (maybePromise instanceof Promise) {
	        maybePromise._then(function() {
	            ret._resolveCallback(value);
	        }, ret._reject, ret._progress, ret, null);
	    } else {
	        ret._resolveCallback(value);
	    }
	    return ret;
	};
	};
	
	},{}],4:[function(_dereq_,module,exports){
	"use strict";
	var old;
	if (typeof Promise !== "undefined") old = Promise;
	function noConflict() {
	    try { if (Promise === bluebird) Promise = old; }
	    catch (e) {}
	    return bluebird;
	}
	var bluebird = _dereq_("./promise.js")();
	bluebird.noConflict = noConflict;
	module.exports = bluebird;
	
	},{"./promise.js":23}],5:[function(_dereq_,module,exports){
	"use strict";
	var cr = Object.create;
	if (cr) {
	    var callerCache = cr(null);
	    var getterCache = cr(null);
	    callerCache[" size"] = getterCache[" size"] = 0;
	}
	
	module.exports = function(Promise) {
	var util = _dereq_("./util.js");
	var canEvaluate = util.canEvaluate;
	var isIdentifier = util.isIdentifier;
	
	var getMethodCaller;
	var getGetter;
	if (false) {
	var makeMethodCaller = function (methodName) {
	    return new Function("ensureMethod", "                                    \n\
	        return function(obj) {                                               \n\
	            'use strict'                                                     \n\
	            var len = this.length;                                           \n\
	            ensureMethod(obj, 'methodName');                                 \n\
	            switch(len) {                                                    \n\
	                case 1: return obj.methodName(this[0]);                      \n\
	                case 2: return obj.methodName(this[0], this[1]);             \n\
	                case 3: return obj.methodName(this[0], this[1], this[2]);    \n\
	                case 0: return obj.methodName();                             \n\
	                default:                                                     \n\
	                    return obj.methodName.apply(obj, this);                  \n\
	            }                                                                \n\
	        };                                                                   \n\
	        ".replace(/methodName/g, methodName))(ensureMethod);
	};
	
	var makeGetter = function (propertyName) {
	    return new Function("obj", "                                             \n\
	        'use strict';                                                        \n\
	        return obj.propertyName;                                             \n\
	        ".replace("propertyName", propertyName));
	};
	
	var getCompiled = function(name, compiler, cache) {
	    var ret = cache[name];
	    if (typeof ret !== "function") {
	        if (!isIdentifier(name)) {
	            return null;
	        }
	        ret = compiler(name);
	        cache[name] = ret;
	        cache[" size"]++;
	        if (cache[" size"] > 512) {
	            var keys = Object.keys(cache);
	            for (var i = 0; i < 256; ++i) delete cache[keys[i]];
	            cache[" size"] = keys.length - 256;
	        }
	    }
	    return ret;
	};
	
	getMethodCaller = function(name) {
	    return getCompiled(name, makeMethodCaller, callerCache);
	};
	
	getGetter = function(name) {
	    return getCompiled(name, makeGetter, getterCache);
	};
	}
	
	function ensureMethod(obj, methodName) {
	    var fn;
	    if (obj != null) fn = obj[methodName];
	    if (typeof fn !== "function") {
	        var message = "Object " + util.classString(obj) + " has no method '" +
	            util.toString(methodName) + "'";
	        throw new Promise.TypeError(message);
	    }
	    return fn;
	}
	
	function caller(obj) {
	    var methodName = this.pop();
	    var fn = ensureMethod(obj, methodName);
	    return fn.apply(obj, this);
	}
	Promise.prototype.call = function (methodName) {
	    var $_len = arguments.length;var args = new Array($_len - 1); for(var $_i = 1; $_i < $_len; ++$_i) {args[$_i - 1] = arguments[$_i];}
	    if (false) {
	        if (canEvaluate) {
	            var maybeCaller = getMethodCaller(methodName);
	            if (maybeCaller !== null) {
	                return this._then(
	                    maybeCaller, undefined, undefined, args, undefined);
	            }
	        }
	    }
	    args.push(methodName);
	    return this._then(caller, undefined, undefined, args, undefined);
	};
	
	function namedGetter(obj) {
	    return obj[this];
	}
	function indexedGetter(obj) {
	    var index = +this;
	    if (index < 0) index = Math.max(0, index + obj.length);
	    return obj[index];
	}
	Promise.prototype.get = function (propertyName) {
	    var isIndex = (typeof propertyName === "number");
	    var getter;
	    if (!isIndex) {
	        if (canEvaluate) {
	            var maybeGetter = getGetter(propertyName);
	            getter = maybeGetter !== null ? maybeGetter : namedGetter;
	        } else {
	            getter = namedGetter;
	        }
	    } else {
	        getter = indexedGetter;
	    }
	    return this._then(getter, undefined, undefined, propertyName, undefined);
	};
	};
	
	},{"./util.js":38}],6:[function(_dereq_,module,exports){
	"use strict";
	module.exports = function(Promise) {
	var errors = _dereq_("./errors.js");
	var async = _dereq_("./async.js");
	var CancellationError = errors.CancellationError;
	
	Promise.prototype._cancel = function (reason) {
	    if (!this.isCancellable()) return this;
	    var parent;
	    var promiseToReject = this;
	    while ((parent = promiseToReject._cancellationParent) !== undefined &&
	        parent.isCancellable()) {
	        promiseToReject = parent;
	    }
	    this._unsetCancellable();
	    promiseToReject._target()._rejectCallback(reason, false, true);
	};
	
	Promise.prototype.cancel = function (reason) {
	    if (!this.isCancellable()) return this;
	    if (reason === undefined) reason = new CancellationError();
	    async.invokeLater(this._cancel, this, reason);
	    return this;
	};
	
	Promise.prototype.cancellable = function () {
	    if (this._cancellable()) return this;
	    async.enableTrampoline();
	    this._setCancellable();
	    this._cancellationParent = undefined;
	    return this;
	};
	
	Promise.prototype.uncancellable = function () {
	    var ret = this.then();
	    ret._unsetCancellable();
	    return ret;
	};
	
	Promise.prototype.fork = function (didFulfill, didReject, didProgress) {
	    var ret = this._then(didFulfill, didReject, didProgress,
	                         undefined, undefined);
	
	    ret._setCancellable();
	    ret._cancellationParent = undefined;
	    return ret;
	};
	};
	
	},{"./async.js":2,"./errors.js":13}],7:[function(_dereq_,module,exports){
	"use strict";
	module.exports = function() {
	var async = _dereq_("./async.js");
	var util = _dereq_("./util.js");
	var bluebirdFramePattern =
	    /[\\\/]bluebird[\\\/]js[\\\/](main|debug|zalgo|instrumented)/;
	var stackFramePattern = null;
	var formatStack = null;
	var indentStackFrames = false;
	var warn;
	
	function CapturedTrace(parent) {
	    this._parent = parent;
	    var length = this._length = 1 + (parent === undefined ? 0 : parent._length);
	    captureStackTrace(this, CapturedTrace);
	    if (length > 32) this.uncycle();
	}
	util.inherits(CapturedTrace, Error);
	
	CapturedTrace.prototype.uncycle = function() {
	    var length = this._length;
	    if (length < 2) return;
	    var nodes = [];
	    var stackToIndex = {};
	
	    for (var i = 0, node = this; node !== undefined; ++i) {
	        nodes.push(node);
	        node = node._parent;
	    }
	    length = this._length = i;
	    for (var i = length - 1; i >= 0; --i) {
	        var stack = nodes[i].stack;
	        if (stackToIndex[stack] === undefined) {
	            stackToIndex[stack] = i;
	        }
	    }
	    for (var i = 0; i < length; ++i) {
	        var currentStack = nodes[i].stack;
	        var index = stackToIndex[currentStack];
	        if (index !== undefined && index !== i) {
	            if (index > 0) {
	                nodes[index - 1]._parent = undefined;
	                nodes[index - 1]._length = 1;
	            }
	            nodes[i]._parent = undefined;
	            nodes[i]._length = 1;
	            var cycleEdgeNode = i > 0 ? nodes[i - 1] : this;
	
	            if (index < length - 1) {
	                cycleEdgeNode._parent = nodes[index + 1];
	                cycleEdgeNode._parent.uncycle();
	                cycleEdgeNode._length =
	                    cycleEdgeNode._parent._length + 1;
	            } else {
	                cycleEdgeNode._parent = undefined;
	                cycleEdgeNode._length = 1;
	            }
	            var currentChildLength = cycleEdgeNode._length + 1;
	            for (var j = i - 2; j >= 0; --j) {
	                nodes[j]._length = currentChildLength;
	                currentChildLength++;
	            }
	            return;
	        }
	    }
	};
	
	CapturedTrace.prototype.parent = function() {
	    return this._parent;
	};
	
	CapturedTrace.prototype.hasParent = function() {
	    return this._parent !== undefined;
	};
	
	CapturedTrace.prototype.attachExtraTrace = function(error) {
	    if (error.__stackCleaned__) return;
	    this.uncycle();
	    var parsed = CapturedTrace.parseStackAndMessage(error);
	    var message = parsed.message;
	    var stacks = [parsed.stack];
	
	    var trace = this;
	    while (trace !== undefined) {
	        stacks.push(cleanStack(trace.stack.split("\n")));
	        trace = trace._parent;
	    }
	    removeCommonRoots(stacks);
	    removeDuplicateOrEmptyJumps(stacks);
	    util.notEnumerableProp(error, "stack", reconstructStack(message, stacks));
	    util.notEnumerableProp(error, "__stackCleaned__", true);
	};
	
	function reconstructStack(message, stacks) {
	    for (var i = 0; i < stacks.length - 1; ++i) {
	        stacks[i].push("From previous event:");
	        stacks[i] = stacks[i].join("\n");
	    }
	    if (i < stacks.length) {
	        stacks[i] = stacks[i].join("\n");
	    }
	    return message + "\n" + stacks.join("\n");
	}
	
	function removeDuplicateOrEmptyJumps(stacks) {
	    for (var i = 0; i < stacks.length; ++i) {
	        if (stacks[i].length === 0 ||
	            ((i + 1 < stacks.length) && stacks[i][0] === stacks[i+1][0])) {
	            stacks.splice(i, 1);
	            i--;
	        }
	    }
	}
	
	function removeCommonRoots(stacks) {
	    var current = stacks[0];
	    for (var i = 1; i < stacks.length; ++i) {
	        var prev = stacks[i];
	        var currentLastIndex = current.length - 1;
	        var currentLastLine = current[currentLastIndex];
	        var commonRootMeetPoint = -1;
	
	        for (var j = prev.length - 1; j >= 0; --j) {
	            if (prev[j] === currentLastLine) {
	                commonRootMeetPoint = j;
	                break;
	            }
	        }
	
	        for (var j = commonRootMeetPoint; j >= 0; --j) {
	            var line = prev[j];
	            if (current[currentLastIndex] === line) {
	                current.pop();
	                currentLastIndex--;
	            } else {
	                break;
	            }
	        }
	        current = prev;
	    }
	}
	
	function cleanStack(stack) {
	    var ret = [];
	    for (var i = 0; i < stack.length; ++i) {
	        var line = stack[i];
	        var isTraceLine = stackFramePattern.test(line) ||
	            "    (No stack trace)" === line;
	        var isInternalFrame = isTraceLine && shouldIgnore(line);
	        if (isTraceLine && !isInternalFrame) {
	            if (indentStackFrames && line.charAt(0) !== " ") {
	                line = "    " + line;
	            }
	            ret.push(line);
	        }
	    }
	    return ret;
	}
	
	function stackFramesAsArray(error) {
	    var stack = error.stack.replace(/\s+$/g, "").split("\n");
	    for (var i = 0; i < stack.length; ++i) {
	        var line = stack[i];
	        if ("    (No stack trace)" === line || stackFramePattern.test(line)) {
	            break;
	        }
	    }
	    if (i > 0) {
	        stack = stack.slice(i);
	    }
	    return stack;
	}
	
	CapturedTrace.parseStackAndMessage = function(error) {
	    var stack = error.stack;
	    var message = error.toString();
	    stack = typeof stack === "string" && stack.length > 0
	                ? stackFramesAsArray(error) : ["    (No stack trace)"];
	    return {
	        message: message,
	        stack: cleanStack(stack)
	    };
	};
	
	CapturedTrace.formatAndLogError = function(error, title) {
	    if (typeof console !== "undefined") {
	        var message;
	        if (typeof error === "object" || typeof error === "function") {
	            var stack = error.stack;
	            message = title + formatStack(stack, error);
	        } else {
	            message = title + String(error);
	        }
	        if (typeof warn === "function") {
	            warn(message);
	        } else if (typeof console.log === "function" ||
	            typeof console.log === "object") {
	            console.log(message);
	        }
	    }
	};
	
	CapturedTrace.unhandledRejection = function (reason) {
	    CapturedTrace.formatAndLogError(reason, "^--- With additional stack trace: ");
	};
	
	CapturedTrace.isSupported = function () {
	    return typeof captureStackTrace === "function";
	};
	
	CapturedTrace.fireRejectionEvent =
	function(name, localHandler, reason, promise) {
	    var localEventFired = false;
	    try {
	        if (typeof localHandler === "function") {
	            localEventFired = true;
	            if (name === "rejectionHandled") {
	                localHandler(promise);
	            } else {
	                localHandler(reason, promise);
	            }
	        }
	    } catch (e) {
	        async.throwLater(e);
	    }
	
	    var globalEventFired = false;
	    try {
	        globalEventFired = fireGlobalEvent(name, reason, promise);
	    } catch (e) {
	        globalEventFired = true;
	        async.throwLater(e);
	    }
	
	    var domEventFired = false;
	    if (fireDomEvent) {
	        try {
	            domEventFired = fireDomEvent(name.toLowerCase(), {
	                reason: reason,
	                promise: promise
	            });
	        } catch (e) {
	            domEventFired = true;
	            async.throwLater(e);
	        }
	    }
	
	    if (!globalEventFired && !localEventFired && !domEventFired &&
	        name === "unhandledRejection") {
	        CapturedTrace.formatAndLogError(reason, "Unhandled rejection ");
	    }
	};
	
	function formatNonError(obj) {
	    var str;
	    if (typeof obj === "function") {
	        str = "[function " +
	            (obj.name || "anonymous") +
	            "]";
	    } else {
	        str = obj.toString();
	        var ruselessToString = /\[object [a-zA-Z0-9$_]+\]/;
	        if (ruselessToString.test(str)) {
	            try {
	                var newStr = JSON.stringify(obj);
	                str = newStr;
	            }
	            catch(e) {
	
	            }
	        }
	        if (str.length === 0) {
	            str = "(empty array)";
	        }
	    }
	    return ("(<" + snip(str) + ">, no stack trace)");
	}
	
	function snip(str) {
	    var maxChars = 41;
	    if (str.length < maxChars) {
	        return str;
	    }
	    return str.substr(0, maxChars - 3) + "...";
	}
	
	var shouldIgnore = function() { return false; };
	var parseLineInfoRegex = /[\/<\(]([^:\/]+):(\d+):(?:\d+)\)?\s*$/;
	function parseLineInfo(line) {
	    var matches = line.match(parseLineInfoRegex);
	    if (matches) {
	        return {
	            fileName: matches[1],
	            line: parseInt(matches[2], 10)
	        };
	    }
	}
	CapturedTrace.setBounds = function(firstLineError, lastLineError) {
	    if (!CapturedTrace.isSupported()) return;
	    var firstStackLines = firstLineError.stack.split("\n");
	    var lastStackLines = lastLineError.stack.split("\n");
	    var firstIndex = -1;
	    var lastIndex = -1;
	    var firstFileName;
	    var lastFileName;
	    for (var i = 0; i < firstStackLines.length; ++i) {
	        var result = parseLineInfo(firstStackLines[i]);
	        if (result) {
	            firstFileName = result.fileName;
	            firstIndex = result.line;
	            break;
	        }
	    }
	    for (var i = 0; i < lastStackLines.length; ++i) {
	        var result = parseLineInfo(lastStackLines[i]);
	        if (result) {
	            lastFileName = result.fileName;
	            lastIndex = result.line;
	            break;
	        }
	    }
	    if (firstIndex < 0 || lastIndex < 0 || !firstFileName || !lastFileName ||
	        firstFileName !== lastFileName || firstIndex >= lastIndex) {
	        return;
	    }
	
	    shouldIgnore = function(line) {
	        if (bluebirdFramePattern.test(line)) return true;
	        var info = parseLineInfo(line);
	        if (info) {
	            if (info.fileName === firstFileName &&
	                (firstIndex <= info.line && info.line <= lastIndex)) {
	                return true;
	            }
	        }
	        return false;
	    };
	};
	
	var captureStackTrace = (function stackDetection() {
	    var v8stackFramePattern = /^\s*at\s*/;
	    var v8stackFormatter = function(stack, error) {
	        if (typeof stack === "string") return stack;
	
	        if (error.name !== undefined &&
	            error.message !== undefined) {
	            return error.toString();
	        }
	        return formatNonError(error);
	    };
	
	    if (typeof Error.stackTraceLimit === "number" &&
	        typeof Error.captureStackTrace === "function") {
	        Error.stackTraceLimit = Error.stackTraceLimit + 6;
	        stackFramePattern = v8stackFramePattern;
	        formatStack = v8stackFormatter;
	        var captureStackTrace = Error.captureStackTrace;
	
	        shouldIgnore = function(line) {
	            return bluebirdFramePattern.test(line);
	        };
	        return function(receiver, ignoreUntil) {
	            Error.stackTraceLimit = Error.stackTraceLimit + 6;
	            captureStackTrace(receiver, ignoreUntil);
	            Error.stackTraceLimit = Error.stackTraceLimit - 6;
	        };
	    }
	    var err = new Error();
	
	    if (typeof err.stack === "string" &&
	        err.stack.split("\n")[0].indexOf("stackDetection@") >= 0) {
	        stackFramePattern = /@/;
	        formatStack = v8stackFormatter;
	        indentStackFrames = true;
	        return function captureStackTrace(o) {
	            o.stack = new Error().stack;
	        };
	    }
	
	    var hasStackAfterThrow;
	    try { throw new Error(); }
	    catch(e) {
	        hasStackAfterThrow = ("stack" in e);
	    }
	    if (!("stack" in err) && hasStackAfterThrow &&
	        typeof Error.stackTraceLimit === "number") {
	        stackFramePattern = v8stackFramePattern;
	        formatStack = v8stackFormatter;
	        return function captureStackTrace(o) {
	            Error.stackTraceLimit = Error.stackTraceLimit + 6;
	            try { throw new Error(); }
	            catch(e) { o.stack = e.stack; }
	            Error.stackTraceLimit = Error.stackTraceLimit - 6;
	        };
	    }
	
	    formatStack = function(stack, error) {
	        if (typeof stack === "string") return stack;
	
	        if ((typeof error === "object" ||
	            typeof error === "function") &&
	            error.name !== undefined &&
	            error.message !== undefined) {
	            return error.toString();
	        }
	        return formatNonError(error);
	    };
	
	    return null;
	
	})([]);
	
	var fireDomEvent;
	var fireGlobalEvent = (function() {
	    if (util.isNode) {
	        return function(name, reason, promise) {
	            if (name === "rejectionHandled") {
	                return process.emit(name, promise);
	            } else {
	                return process.emit(name, reason, promise);
	            }
	        };
	    } else {
	        var customEventWorks = false;
	        var anyEventWorks = true;
	        try {
	            var ev = new self.CustomEvent("test");
	            customEventWorks = ev instanceof CustomEvent;
	        } catch (e) {}
	        if (!customEventWorks) {
	            try {
	                var event = document.createEvent("CustomEvent");
	                event.initCustomEvent("testingtheevent", false, true, {});
	                self.dispatchEvent(event);
	            } catch (e) {
	                anyEventWorks = false;
	            }
	        }
	        if (anyEventWorks) {
	            fireDomEvent = function(type, detail) {
	                var event;
	                if (customEventWorks) {
	                    event = new self.CustomEvent(type, {
	                        detail: detail,
	                        bubbles: false,
	                        cancelable: true
	                    });
	                } else if (self.dispatchEvent) {
	                    event = document.createEvent("CustomEvent");
	                    event.initCustomEvent(type, false, true, detail);
	                }
	
	                return event ? !self.dispatchEvent(event) : false;
	            };
	        }
	
	        var toWindowMethodNameMap = {};
	        toWindowMethodNameMap["unhandledRejection"] = ("on" +
	            "unhandledRejection").toLowerCase();
	        toWindowMethodNameMap["rejectionHandled"] = ("on" +
	            "rejectionHandled").toLowerCase();
	
	        return function(name, reason, promise) {
	            var methodName = toWindowMethodNameMap[name];
	            var method = self[methodName];
	            if (!method) return false;
	            if (name === "rejectionHandled") {
	                method.call(self, promise);
	            } else {
	                method.call(self, reason, promise);
	            }
	            return true;
	        };
	    }
	})();
	
	if (typeof console !== "undefined" && typeof console.warn !== "undefined") {
	    warn = function (message) {
	        console.warn(message);
	    };
	    if (util.isNode && process.stderr.isTTY) {
	        warn = function(message) {
	            process.stderr.write("\u001b[31m" + message + "\u001b[39m\n");
	        };
	    } else if (!util.isNode && typeof (new Error().stack) === "string") {
	        warn = function(message) {
	            console.warn("%c" + message, "color: red");
	        };
	    }
	}
	
	return CapturedTrace;
	};
	
	},{"./async.js":2,"./util.js":38}],8:[function(_dereq_,module,exports){
	"use strict";
	module.exports = function(NEXT_FILTER) {
	var util = _dereq_("./util.js");
	var errors = _dereq_("./errors.js");
	var tryCatch = util.tryCatch;
	var errorObj = util.errorObj;
	var keys = _dereq_("./es5.js").keys;
	var TypeError = errors.TypeError;
	
	function CatchFilter(instances, callback, promise) {
	    this._instances = instances;
	    this._callback = callback;
	    this._promise = promise;
	}
	
	function safePredicate(predicate, e) {
	    var safeObject = {};
	    var retfilter = tryCatch(predicate).call(safeObject, e);
	
	    if (retfilter === errorObj) return retfilter;
	
	    var safeKeys = keys(safeObject);
	    if (safeKeys.length) {
	        errorObj.e = new TypeError("Catch filter must inherit from Error or be a simple predicate function\u000a\u000a    See http://goo.gl/o84o68\u000a");
	        return errorObj;
	    }
	    return retfilter;
	}
	
	CatchFilter.prototype.doFilter = function (e) {
	    var cb = this._callback;
	    var promise = this._promise;
	    var boundTo = promise._boundValue();
	    for (var i = 0, len = this._instances.length; i < len; ++i) {
	        var item = this._instances[i];
	        var itemIsErrorType = item === Error ||
	            (item != null && item.prototype instanceof Error);
	
	        if (itemIsErrorType && e instanceof item) {
	            var ret = tryCatch(cb).call(boundTo, e);
	            if (ret === errorObj) {
	                NEXT_FILTER.e = ret.e;
	                return NEXT_FILTER;
	            }
	            return ret;
	        } else if (typeof item === "function" && !itemIsErrorType) {
	            var shouldHandle = safePredicate(item, e);
	            if (shouldHandle === errorObj) {
	                e = errorObj.e;
	                break;
	            } else if (shouldHandle) {
	                var ret = tryCatch(cb).call(boundTo, e);
	                if (ret === errorObj) {
	                    NEXT_FILTER.e = ret.e;
	                    return NEXT_FILTER;
	                }
	                return ret;
	            }
	        }
	    }
	    NEXT_FILTER.e = e;
	    return NEXT_FILTER;
	};
	
	return CatchFilter;
	};
	
	},{"./errors.js":13,"./es5.js":14,"./util.js":38}],9:[function(_dereq_,module,exports){
	"use strict";
	module.exports = function(Promise, CapturedTrace, isDebugging) {
	var contextStack = [];
	function Context() {
	    this._trace = new CapturedTrace(peekContext());
	}
	Context.prototype._pushContext = function () {
	    if (!isDebugging()) return;
	    if (this._trace !== undefined) {
	        contextStack.push(this._trace);
	    }
	};
	
	Context.prototype._popContext = function () {
	    if (!isDebugging()) return;
	    if (this._trace !== undefined) {
	        contextStack.pop();
	    }
	};
	
	function createContext() {
	    if (isDebugging()) return new Context();
	}
	
	function peekContext() {
	    var lastIndex = contextStack.length - 1;
	    if (lastIndex >= 0) {
	        return contextStack[lastIndex];
	    }
	    return undefined;
	}
	
	Promise.prototype._peekContext = peekContext;
	Promise.prototype._pushContext = Context.prototype._pushContext;
	Promise.prototype._popContext = Context.prototype._popContext;
	
	return createContext;
	};
	
	},{}],10:[function(_dereq_,module,exports){
	"use strict";
	module.exports = function(Promise, CapturedTrace) {
	var getDomain = Promise._getDomain;
	var async = _dereq_("./async.js");
	var Warning = _dereq_("./errors.js").Warning;
	var util = _dereq_("./util.js");
	var canAttachTrace = util.canAttachTrace;
	var unhandledRejectionHandled;
	var possiblyUnhandledRejection;
	var debugging = false || (util.isNode &&
	                    (!!({"NODE_ENV":"production"})["BLUEBIRD_DEBUG"] ||
	                     ({"NODE_ENV":"production"})["NODE_ENV"] === "development"));
	
	if (util.isNode && ({"NODE_ENV":"production"})["BLUEBIRD_DEBUG"] == 0) debugging = false;
	
	if (debugging) {
	    async.disableTrampolineIfNecessary();
	}
	
	Promise.prototype._ignoreRejections = function() {
	    this._unsetRejectionIsUnhandled();
	    this._bitField = this._bitField | 16777216;
	};
	
	Promise.prototype._ensurePossibleRejectionHandled = function () {
	    if ((this._bitField & 16777216) !== 0) return;
	    this._setRejectionIsUnhandled();
	    async.invokeLater(this._notifyUnhandledRejection, this, undefined);
	};
	
	Promise.prototype._notifyUnhandledRejectionIsHandled = function () {
	    CapturedTrace.fireRejectionEvent("rejectionHandled",
	                                  unhandledRejectionHandled, undefined, this);
	};
	
	Promise.prototype._notifyUnhandledRejection = function () {
	    if (this._isRejectionUnhandled()) {
	        var reason = this._getCarriedStackTrace() || this._settledValue;
	        this._setUnhandledRejectionIsNotified();
	        CapturedTrace.fireRejectionEvent("unhandledRejection",
	                                      possiblyUnhandledRejection, reason, this);
	    }
	};
	
	Promise.prototype._setUnhandledRejectionIsNotified = function () {
	    this._bitField = this._bitField | 524288;
	};
	
	Promise.prototype._unsetUnhandledRejectionIsNotified = function () {
	    this._bitField = this._bitField & (~524288);
	};
	
	Promise.prototype._isUnhandledRejectionNotified = function () {
	    return (this._bitField & 524288) > 0;
	};
	
	Promise.prototype._setRejectionIsUnhandled = function () {
	    this._bitField = this._bitField | 2097152;
	};
	
	Promise.prototype._unsetRejectionIsUnhandled = function () {
	    this._bitField = this._bitField & (~2097152);
	    if (this._isUnhandledRejectionNotified()) {
	        this._unsetUnhandledRejectionIsNotified();
	        this._notifyUnhandledRejectionIsHandled();
	    }
	};
	
	Promise.prototype._isRejectionUnhandled = function () {
	    return (this._bitField & 2097152) > 0;
	};
	
	Promise.prototype._setCarriedStackTrace = function (capturedTrace) {
	    this._bitField = this._bitField | 1048576;
	    this._fulfillmentHandler0 = capturedTrace;
	};
	
	Promise.prototype._isCarryingStackTrace = function () {
	    return (this._bitField & 1048576) > 0;
	};
	
	Promise.prototype._getCarriedStackTrace = function () {
	    return this._isCarryingStackTrace()
	        ? this._fulfillmentHandler0
	        : undefined;
	};
	
	Promise.prototype._captureStackTrace = function () {
	    if (debugging) {
	        this._trace = new CapturedTrace(this._peekContext());
	    }
	    return this;
	};
	
	Promise.prototype._attachExtraTrace = function (error, ignoreSelf) {
	    if (debugging && canAttachTrace(error)) {
	        var trace = this._trace;
	        if (trace !== undefined) {
	            if (ignoreSelf) trace = trace._parent;
	        }
	        if (trace !== undefined) {
	            trace.attachExtraTrace(error);
	        } else if (!error.__stackCleaned__) {
	            var parsed = CapturedTrace.parseStackAndMessage(error);
	            util.notEnumerableProp(error, "stack",
	                parsed.message + "\n" + parsed.stack.join("\n"));
	            util.notEnumerableProp(error, "__stackCleaned__", true);
	        }
	    }
	};
	
	Promise.prototype._warn = function(message) {
	    var warning = new Warning(message);
	    var ctx = this._peekContext();
	    if (ctx) {
	        ctx.attachExtraTrace(warning);
	    } else {
	        var parsed = CapturedTrace.parseStackAndMessage(warning);
	        warning.stack = parsed.message + "\n" + parsed.stack.join("\n");
	    }
	    CapturedTrace.formatAndLogError(warning, "");
	};
	
	Promise.onPossiblyUnhandledRejection = function (fn) {
	    var domain = getDomain();
	    possiblyUnhandledRejection =
	        typeof fn === "function" ? (domain === null ? fn : domain.bind(fn))
	                                 : undefined;
	};
	
	Promise.onUnhandledRejectionHandled = function (fn) {
	    var domain = getDomain();
	    unhandledRejectionHandled =
	        typeof fn === "function" ? (domain === null ? fn : domain.bind(fn))
	                                 : undefined;
	};
	
	Promise.longStackTraces = function () {
	    if (async.haveItemsQueued() &&
	        debugging === false
	   ) {
	        throw new Error("cannot enable long stack traces after promises have been created\u000a\u000a    See http://goo.gl/DT1qyG\u000a");
	    }
	    debugging = CapturedTrace.isSupported();
	    if (debugging) {
	        async.disableTrampolineIfNecessary();
	    }
	};
	
	Promise.hasLongStackTraces = function () {
	    return debugging && CapturedTrace.isSupported();
	};
	
	if (!CapturedTrace.isSupported()) {
	    Promise.longStackTraces = function(){};
	    debugging = false;
	}
	
	return function() {
	    return debugging;
	};
	};
	
	},{"./async.js":2,"./errors.js":13,"./util.js":38}],11:[function(_dereq_,module,exports){
	"use strict";
	var util = _dereq_("./util.js");
	var isPrimitive = util.isPrimitive;
	
	module.exports = function(Promise) {
	var returner = function () {
	    return this;
	};
	var thrower = function () {
	    throw this;
	};
	var returnUndefined = function() {};
	var throwUndefined = function() {
	    throw undefined;
	};
	
	var wrapper = function (value, action) {
	    if (action === 1) {
	        return function () {
	            throw value;
	        };
	    } else if (action === 2) {
	        return function () {
	            return value;
	        };
	    }
	};
	
	
	Promise.prototype["return"] =
	Promise.prototype.thenReturn = function (value) {
	    if (value === undefined) return this.then(returnUndefined);
	
	    if (isPrimitive(value)) {
	        return this._then(
	            wrapper(value, 2),
	            undefined,
	            undefined,
	            undefined,
	            undefined
	       );
	    } else if (value instanceof Promise) {
	        value._ignoreRejections();
	    }
	    return this._then(returner, undefined, undefined, value, undefined);
	};
	
	Promise.prototype["throw"] =
	Promise.prototype.thenThrow = function (reason) {
	    if (reason === undefined) return this.then(throwUndefined);
	
	    if (isPrimitive(reason)) {
	        return this._then(
	            wrapper(reason, 1),
	            undefined,
	            undefined,
	            undefined,
	            undefined
	       );
	    }
	    return this._then(thrower, undefined, undefined, reason, undefined);
	};
	};
	
	},{"./util.js":38}],12:[function(_dereq_,module,exports){
	"use strict";
	module.exports = function(Promise, INTERNAL) {
	var PromiseReduce = Promise.reduce;
	
	Promise.prototype.each = function (fn) {
	    return PromiseReduce(this, fn, null, INTERNAL);
	};
	
	Promise.each = function (promises, fn) {
	    return PromiseReduce(promises, fn, null, INTERNAL);
	};
	};
	
	},{}],13:[function(_dereq_,module,exports){
	"use strict";
	var es5 = _dereq_("./es5.js");
	var Objectfreeze = es5.freeze;
	var util = _dereq_("./util.js");
	var inherits = util.inherits;
	var notEnumerableProp = util.notEnumerableProp;
	
	function subError(nameProperty, defaultMessage) {
	    function SubError(message) {
	        if (!(this instanceof SubError)) return new SubError(message);
	        notEnumerableProp(this, "message",
	            typeof message === "string" ? message : defaultMessage);
	        notEnumerableProp(this, "name", nameProperty);
	        if (Error.captureStackTrace) {
	            Error.captureStackTrace(this, this.constructor);
	        } else {
	            Error.call(this);
	        }
	    }
	    inherits(SubError, Error);
	    return SubError;
	}
	
	var _TypeError, _RangeError;
	var Warning = subError("Warning", "warning");
	var CancellationError = subError("CancellationError", "cancellation error");
	var TimeoutError = subError("TimeoutError", "timeout error");
	var AggregateError = subError("AggregateError", "aggregate error");
	try {
	    _TypeError = TypeError;
	    _RangeError = RangeError;
	} catch(e) {
	    _TypeError = subError("TypeError", "type error");
	    _RangeError = subError("RangeError", "range error");
	}
	
	var methods = ("join pop push shift unshift slice filter forEach some " +
	    "every map indexOf lastIndexOf reduce reduceRight sort reverse").split(" ");
	
	for (var i = 0; i < methods.length; ++i) {
	    if (typeof Array.prototype[methods[i]] === "function") {
	        AggregateError.prototype[methods[i]] = Array.prototype[methods[i]];
	    }
	}
	
	es5.defineProperty(AggregateError.prototype, "length", {
	    value: 0,
	    configurable: false,
	    writable: true,
	    enumerable: true
	});
	AggregateError.prototype["isOperational"] = true;
	var level = 0;
	AggregateError.prototype.toString = function() {
	    var indent = Array(level * 4 + 1).join(" ");
	    var ret = "\n" + indent + "AggregateError of:" + "\n";
	    level++;
	    indent = Array(level * 4 + 1).join(" ");
	    for (var i = 0; i < this.length; ++i) {
	        var str = this[i] === this ? "[Circular AggregateError]" : this[i] + "";
	        var lines = str.split("\n");
	        for (var j = 0; j < lines.length; ++j) {
	            lines[j] = indent + lines[j];
	        }
	        str = lines.join("\n");
	        ret += str + "\n";
	    }
	    level--;
	    return ret;
	};
	
	function OperationalError(message) {
	    if (!(this instanceof OperationalError))
	        return new OperationalError(message);
	    notEnumerableProp(this, "name", "OperationalError");
	    notEnumerableProp(this, "message", message);
	    this.cause = message;
	    this["isOperational"] = true;
	
	    if (message instanceof Error) {
	        notEnumerableProp(this, "message", message.message);
	        notEnumerableProp(this, "stack", message.stack);
	    } else if (Error.captureStackTrace) {
	        Error.captureStackTrace(this, this.constructor);
	    }
	
	}
	inherits(OperationalError, Error);
	
	var errorTypes = Error["__BluebirdErrorTypes__"];
	if (!errorTypes) {
	    errorTypes = Objectfreeze({
	        CancellationError: CancellationError,
	        TimeoutError: TimeoutError,
	        OperationalError: OperationalError,
	        RejectionError: OperationalError,
	        AggregateError: AggregateError
	    });
	    notEnumerableProp(Error, "__BluebirdErrorTypes__", errorTypes);
	}
	
	module.exports = {
	    Error: Error,
	    TypeError: _TypeError,
	    RangeError: _RangeError,
	    CancellationError: errorTypes.CancellationError,
	    OperationalError: errorTypes.OperationalError,
	    TimeoutError: errorTypes.TimeoutError,
	    AggregateError: errorTypes.AggregateError,
	    Warning: Warning
	};
	
	},{"./es5.js":14,"./util.js":38}],14:[function(_dereq_,module,exports){
	var isES5 = (function(){
	    "use strict";
	    return this === undefined;
	})();
	
	if (isES5) {
	    module.exports = {
	        freeze: Object.freeze,
	        defineProperty: Object.defineProperty,
	        getDescriptor: Object.getOwnPropertyDescriptor,
	        keys: Object.keys,
	        names: Object.getOwnPropertyNames,
	        getPrototypeOf: Object.getPrototypeOf,
	        isArray: Array.isArray,
	        isES5: isES5,
	        propertyIsWritable: function(obj, prop) {
	            var descriptor = Object.getOwnPropertyDescriptor(obj, prop);
	            return !!(!descriptor || descriptor.writable || descriptor.set);
	        }
	    };
	} else {
	    var has = {}.hasOwnProperty;
	    var str = {}.toString;
	    var proto = {}.constructor.prototype;
	
	    var ObjectKeys = function (o) {
	        var ret = [];
	        for (var key in o) {
	            if (has.call(o, key)) {
	                ret.push(key);
	            }
	        }
	        return ret;
	    };
	
	    var ObjectGetDescriptor = function(o, key) {
	        return {value: o[key]};
	    };
	
	    var ObjectDefineProperty = function (o, key, desc) {
	        o[key] = desc.value;
	        return o;
	    };
	
	    var ObjectFreeze = function (obj) {
	        return obj;
	    };
	
	    var ObjectGetPrototypeOf = function (obj) {
	        try {
	            return Object(obj).constructor.prototype;
	        }
	        catch (e) {
	            return proto;
	        }
	    };
	
	    var ArrayIsArray = function (obj) {
	        try {
	            return str.call(obj) === "[object Array]";
	        }
	        catch(e) {
	            return false;
	        }
	    };
	
	    module.exports = {
	        isArray: ArrayIsArray,
	        keys: ObjectKeys,
	        names: ObjectKeys,
	        defineProperty: ObjectDefineProperty,
	        getDescriptor: ObjectGetDescriptor,
	        freeze: ObjectFreeze,
	        getPrototypeOf: ObjectGetPrototypeOf,
	        isES5: isES5,
	        propertyIsWritable: function() {
	            return true;
	        }
	    };
	}
	
	},{}],15:[function(_dereq_,module,exports){
	"use strict";
	module.exports = function(Promise, INTERNAL) {
	var PromiseMap = Promise.map;
	
	Promise.prototype.filter = function (fn, options) {
	    return PromiseMap(this, fn, options, INTERNAL);
	};
	
	Promise.filter = function (promises, fn, options) {
	    return PromiseMap(promises, fn, options, INTERNAL);
	};
	};
	
	},{}],16:[function(_dereq_,module,exports){
	"use strict";
	module.exports = function(Promise, NEXT_FILTER, tryConvertToPromise) {
	var util = _dereq_("./util.js");
	var isPrimitive = util.isPrimitive;
	var thrower = util.thrower;
	
	function returnThis() {
	    return this;
	}
	function throwThis() {
	    throw this;
	}
	function return$(r) {
	    return function() {
	        return r;
	    };
	}
	function throw$(r) {
	    return function() {
	        throw r;
	    };
	}
	function promisedFinally(ret, reasonOrValue, isFulfilled) {
	    var then;
	    if (isPrimitive(reasonOrValue)) {
	        then = isFulfilled ? return$(reasonOrValue) : throw$(reasonOrValue);
	    } else {
	        then = isFulfilled ? returnThis : throwThis;
	    }
	    return ret._then(then, thrower, undefined, reasonOrValue, undefined);
	}
	
	function finallyHandler(reasonOrValue) {
	    var promise = this.promise;
	    var handler = this.handler;
	
	    var ret = promise._isBound()
	                    ? handler.call(promise._boundValue())
	                    : handler();
	
	    if (ret !== undefined) {
	        var maybePromise = tryConvertToPromise(ret, promise);
	        if (maybePromise instanceof Promise) {
	            maybePromise = maybePromise._target();
	            return promisedFinally(maybePromise, reasonOrValue,
	                                    promise.isFulfilled());
	        }
	    }
	
	    if (promise.isRejected()) {
	        NEXT_FILTER.e = reasonOrValue;
	        return NEXT_FILTER;
	    } else {
	        return reasonOrValue;
	    }
	}
	
	function tapHandler(value) {
	    var promise = this.promise;
	    var handler = this.handler;
	
	    var ret = promise._isBound()
	                    ? handler.call(promise._boundValue(), value)
	                    : handler(value);
	
	    if (ret !== undefined) {
	        var maybePromise = tryConvertToPromise(ret, promise);
	        if (maybePromise instanceof Promise) {
	            maybePromise = maybePromise._target();
	            return promisedFinally(maybePromise, value, true);
	        }
	    }
	    return value;
	}
	
	Promise.prototype._passThroughHandler = function (handler, isFinally) {
	    if (typeof handler !== "function") return this.then();
	
	    var promiseAndHandler = {
	        promise: this,
	        handler: handler
	    };
	
	    return this._then(
	            isFinally ? finallyHandler : tapHandler,
	            isFinally ? finallyHandler : undefined, undefined,
	            promiseAndHandler, undefined);
	};
	
	Promise.prototype.lastly =
	Promise.prototype["finally"] = function (handler) {
	    return this._passThroughHandler(handler, true);
	};
	
	Promise.prototype.tap = function (handler) {
	    return this._passThroughHandler(handler, false);
	};
	};
	
	},{"./util.js":38}],17:[function(_dereq_,module,exports){
	"use strict";
	module.exports = function(Promise,
	                          apiRejection,
	                          INTERNAL,
	                          tryConvertToPromise) {
	var errors = _dereq_("./errors.js");
	var TypeError = errors.TypeError;
	var util = _dereq_("./util.js");
	var errorObj = util.errorObj;
	var tryCatch = util.tryCatch;
	var yieldHandlers = [];
	
	function promiseFromYieldHandler(value, yieldHandlers, traceParent) {
	    for (var i = 0; i < yieldHandlers.length; ++i) {
	        traceParent._pushContext();
	        var result = tryCatch(yieldHandlers[i])(value);
	        traceParent._popContext();
	        if (result === errorObj) {
	            traceParent._pushContext();
	            var ret = Promise.reject(errorObj.e);
	            traceParent._popContext();
	            return ret;
	        }
	        var maybePromise = tryConvertToPromise(result, traceParent);
	        if (maybePromise instanceof Promise) return maybePromise;
	    }
	    return null;
	}
	
	function PromiseSpawn(generatorFunction, receiver, yieldHandler, stack) {
	    var promise = this._promise = new Promise(INTERNAL);
	    promise._captureStackTrace();
	    this._stack = stack;
	    this._generatorFunction = generatorFunction;
	    this._receiver = receiver;
	    this._generator = undefined;
	    this._yieldHandlers = typeof yieldHandler === "function"
	        ? [yieldHandler].concat(yieldHandlers)
	        : yieldHandlers;
	}
	
	PromiseSpawn.prototype.promise = function () {
	    return this._promise;
	};
	
	PromiseSpawn.prototype._run = function () {
	    this._generator = this._generatorFunction.call(this._receiver);
	    this._receiver =
	        this._generatorFunction = undefined;
	    this._next(undefined);
	};
	
	PromiseSpawn.prototype._continue = function (result) {
	    if (result === errorObj) {
	        return this._promise._rejectCallback(result.e, false, true);
	    }
	
	    var value = result.value;
	    if (result.done === true) {
	        this._promise._resolveCallback(value);
	    } else {
	        var maybePromise = tryConvertToPromise(value, this._promise);
	        if (!(maybePromise instanceof Promise)) {
	            maybePromise =
	                promiseFromYieldHandler(maybePromise,
	                                        this._yieldHandlers,
	                                        this._promise);
	            if (maybePromise === null) {
	                this._throw(
	                    new TypeError(
	                        "A value %s was yielded that could not be treated as a promise\u000a\u000a    See http://goo.gl/4Y4pDk\u000a\u000a".replace("%s", value) +
	                        "From coroutine:\u000a" +
	                        this._stack.split("\n").slice(1, -7).join("\n")
	                    )
	                );
	                return;
	            }
	        }
	        maybePromise._then(
	            this._next,
	            this._throw,
	            undefined,
	            this,
	            null
	       );
	    }
	};
	
	PromiseSpawn.prototype._throw = function (reason) {
	    this._promise._attachExtraTrace(reason);
	    this._promise._pushContext();
	    var result = tryCatch(this._generator["throw"])
	        .call(this._generator, reason);
	    this._promise._popContext();
	    this._continue(result);
	};
	
	PromiseSpawn.prototype._next = function (value) {
	    this._promise._pushContext();
	    var result = tryCatch(this._generator.next).call(this._generator, value);
	    this._promise._popContext();
	    this._continue(result);
	};
	
	Promise.coroutine = function (generatorFunction, options) {
	    if (typeof generatorFunction !== "function") {
	        throw new TypeError("generatorFunction must be a function\u000a\u000a    See http://goo.gl/6Vqhm0\u000a");
	    }
	    var yieldHandler = Object(options).yieldHandler;
	    var PromiseSpawn$ = PromiseSpawn;
	    var stack = new Error().stack;
	    return function () {
	        var generator = generatorFunction.apply(this, arguments);
	        var spawn = new PromiseSpawn$(undefined, undefined, yieldHandler,
	                                      stack);
	        spawn._generator = generator;
	        spawn._next(undefined);
	        return spawn.promise();
	    };
	};
	
	Promise.coroutine.addYieldHandler = function(fn) {
	    if (typeof fn !== "function") throw new TypeError("fn must be a function\u000a\u000a    See http://goo.gl/916lJJ\u000a");
	    yieldHandlers.push(fn);
	};
	
	Promise.spawn = function (generatorFunction) {
	    if (typeof generatorFunction !== "function") {
	        return apiRejection("generatorFunction must be a function\u000a\u000a    See http://goo.gl/6Vqhm0\u000a");
	    }
	    var spawn = new PromiseSpawn(generatorFunction, this);
	    var ret = spawn.promise();
	    spawn._run(Promise.spawn);
	    return ret;
	};
	};
	
	},{"./errors.js":13,"./util.js":38}],18:[function(_dereq_,module,exports){
	"use strict";
	module.exports =
	function(Promise, PromiseArray, tryConvertToPromise, INTERNAL) {
	var util = _dereq_("./util.js");
	var canEvaluate = util.canEvaluate;
	var tryCatch = util.tryCatch;
	var errorObj = util.errorObj;
	var reject;
	
	if (false) {
	if (canEvaluate) {
	    var thenCallback = function(i) {
	        return new Function("value", "holder", "                             \n\
	            'use strict';                                                    \n\
	            holder.pIndex = value;                                           \n\
	            holder.checkFulfillment(this);                                   \n\
	            ".replace(/Index/g, i));
	    };
	
	    var caller = function(count) {
	        var values = [];
	        for (var i = 1; i <= count; ++i) values.push("holder.p" + i);
	        return new Function("holder", "                                      \n\
	            'use strict';                                                    \n\
	            var callback = holder.fn;                                        \n\
	            return callback(values);                                         \n\
	            ".replace(/values/g, values.join(", ")));
	    };
	    var thenCallbacks = [];
	    var callers = [undefined];
	    for (var i = 1; i <= 5; ++i) {
	        thenCallbacks.push(thenCallback(i));
	        callers.push(caller(i));
	    }
	
	    var Holder = function(total, fn) {
	        this.p1 = this.p2 = this.p3 = this.p4 = this.p5 = null;
	        this.fn = fn;
	        this.total = total;
	        this.now = 0;
	    };
	
	    Holder.prototype.callers = callers;
	    Holder.prototype.checkFulfillment = function(promise) {
	        var now = this.now;
	        now++;
	        var total = this.total;
	        if (now >= total) {
	            var handler = this.callers[total];
	            promise._pushContext();
	            var ret = tryCatch(handler)(this);
	            promise._popContext();
	            if (ret === errorObj) {
	                promise._rejectCallback(ret.e, false, true);
	            } else {
	                promise._resolveCallback(ret);
	            }
	        } else {
	            this.now = now;
	        }
	    };
	
	    var reject = function (reason) {
	        this._reject(reason);
	    };
	}
	}
	
	Promise.join = function () {
	    var last = arguments.length - 1;
	    var fn;
	    if (last > 0 && typeof arguments[last] === "function") {
	        fn = arguments[last];
	        if (false) {
	            if (last < 6 && canEvaluate) {
	                var ret = new Promise(INTERNAL);
	                ret._captureStackTrace();
	                var holder = new Holder(last, fn);
	                var callbacks = thenCallbacks;
	                for (var i = 0; i < last; ++i) {
	                    var maybePromise = tryConvertToPromise(arguments[i], ret);
	                    if (maybePromise instanceof Promise) {
	                        maybePromise = maybePromise._target();
	                        if (maybePromise._isPending()) {
	                            maybePromise._then(callbacks[i], reject,
	                                               undefined, ret, holder);
	                        } else if (maybePromise._isFulfilled()) {
	                            callbacks[i].call(ret,
	                                              maybePromise._value(), holder);
	                        } else {
	                            ret._reject(maybePromise._reason());
	                        }
	                    } else {
	                        callbacks[i].call(ret, maybePromise, holder);
	                    }
	                }
	                return ret;
	            }
	        }
	    }
	    var $_len = arguments.length;var args = new Array($_len); for(var $_i = 0; $_i < $_len; ++$_i) {args[$_i] = arguments[$_i];}
	    if (fn) args.pop();
	    var ret = new PromiseArray(args).promise();
	    return fn !== undefined ? ret.spread(fn) : ret;
	};
	
	};
	
	},{"./util.js":38}],19:[function(_dereq_,module,exports){
	"use strict";
	module.exports = function(Promise,
	                          PromiseArray,
	                          apiRejection,
	                          tryConvertToPromise,
	                          INTERNAL) {
	var getDomain = Promise._getDomain;
	var async = _dereq_("./async.js");
	var util = _dereq_("./util.js");
	var tryCatch = util.tryCatch;
	var errorObj = util.errorObj;
	var PENDING = {};
	var EMPTY_ARRAY = [];
	
	function MappingPromiseArray(promises, fn, limit, _filter) {
	    this.constructor$(promises);
	    this._promise._captureStackTrace();
	    var domain = getDomain();
	    this._callback = domain === null ? fn : domain.bind(fn);
	    this._preservedValues = _filter === INTERNAL
	        ? new Array(this.length())
	        : null;
	    this._limit = limit;
	    this._inFlight = 0;
	    this._queue = limit >= 1 ? [] : EMPTY_ARRAY;
	    async.invoke(init, this, undefined);
	}
	util.inherits(MappingPromiseArray, PromiseArray);
	function init() {this._init$(undefined, -2);}
	
	MappingPromiseArray.prototype._init = function () {};
	
	MappingPromiseArray.prototype._promiseFulfilled = function (value, index) {
	    var values = this._values;
	    var length = this.length();
	    var preservedValues = this._preservedValues;
	    var limit = this._limit;
	    if (values[index] === PENDING) {
	        values[index] = value;
	        if (limit >= 1) {
	            this._inFlight--;
	            this._drainQueue();
	            if (this._isResolved()) return;
	        }
	    } else {
	        if (limit >= 1 && this._inFlight >= limit) {
	            values[index] = value;
	            this._queue.push(index);
	            return;
	        }
	        if (preservedValues !== null) preservedValues[index] = value;
	
	        var callback = this._callback;
	        var receiver = this._promise._boundValue();
	        this._promise._pushContext();
	        var ret = tryCatch(callback).call(receiver, value, index, length);
	        this._promise._popContext();
	        if (ret === errorObj) return this._reject(ret.e);
	
	        var maybePromise = tryConvertToPromise(ret, this._promise);
	        if (maybePromise instanceof Promise) {
	            maybePromise = maybePromise._target();
	            if (maybePromise._isPending()) {
	                if (limit >= 1) this._inFlight++;
	                values[index] = PENDING;
	                return maybePromise._proxyPromiseArray(this, index);
	            } else if (maybePromise._isFulfilled()) {
	                ret = maybePromise._value();
	            } else {
	                return this._reject(maybePromise._reason());
	            }
	        }
	        values[index] = ret;
	    }
	    var totalResolved = ++this._totalResolved;
	    if (totalResolved >= length) {
	        if (preservedValues !== null) {
	            this._filter(values, preservedValues);
	        } else {
	            this._resolve(values);
	        }
	
	    }
	};
	
	MappingPromiseArray.prototype._drainQueue = function () {
	    var queue = this._queue;
	    var limit = this._limit;
	    var values = this._values;
	    while (queue.length > 0 && this._inFlight < limit) {
	        if (this._isResolved()) return;
	        var index = queue.pop();
	        this._promiseFulfilled(values[index], index);
	    }
	};
	
	MappingPromiseArray.prototype._filter = function (booleans, values) {
	    var len = values.length;
	    var ret = new Array(len);
	    var j = 0;
	    for (var i = 0; i < len; ++i) {
	        if (booleans[i]) ret[j++] = values[i];
	    }
	    ret.length = j;
	    this._resolve(ret);
	};
	
	MappingPromiseArray.prototype.preservedValues = function () {
	    return this._preservedValues;
	};
	
	function map(promises, fn, options, _filter) {
	    var limit = typeof options === "object" && options !== null
	        ? options.concurrency
	        : 0;
	    limit = typeof limit === "number" &&
	        isFinite(limit) && limit >= 1 ? limit : 0;
	    return new MappingPromiseArray(promises, fn, limit, _filter);
	}
	
	Promise.prototype.map = function (fn, options) {
	    if (typeof fn !== "function") return apiRejection("fn must be a function\u000a\u000a    See http://goo.gl/916lJJ\u000a");
	
	    return map(this, fn, options, null).promise();
	};
	
	Promise.map = function (promises, fn, options, _filter) {
	    if (typeof fn !== "function") return apiRejection("fn must be a function\u000a\u000a    See http://goo.gl/916lJJ\u000a");
	    return map(promises, fn, options, _filter).promise();
	};
	
	
	};
	
	},{"./async.js":2,"./util.js":38}],20:[function(_dereq_,module,exports){
	"use strict";
	module.exports =
	function(Promise, INTERNAL, tryConvertToPromise, apiRejection) {
	var util = _dereq_("./util.js");
	var tryCatch = util.tryCatch;
	
	Promise.method = function (fn) {
	    if (typeof fn !== "function") {
	        throw new Promise.TypeError("fn must be a function\u000a\u000a    See http://goo.gl/916lJJ\u000a");
	    }
	    return function () {
	        var ret = new Promise(INTERNAL);
	        ret._captureStackTrace();
	        ret._pushContext();
	        var value = tryCatch(fn).apply(this, arguments);
	        ret._popContext();
	        ret._resolveFromSyncValue(value);
	        return ret;
	    };
	};
	
	Promise.attempt = Promise["try"] = function (fn, args, ctx) {
	    if (typeof fn !== "function") {
	        return apiRejection("fn must be a function\u000a\u000a    See http://goo.gl/916lJJ\u000a");
	    }
	    var ret = new Promise(INTERNAL);
	    ret._captureStackTrace();
	    ret._pushContext();
	    var value = util.isArray(args)
	        ? tryCatch(fn).apply(ctx, args)
	        : tryCatch(fn).call(ctx, args);
	    ret._popContext();
	    ret._resolveFromSyncValue(value);
	    return ret;
	};
	
	Promise.prototype._resolveFromSyncValue = function (value) {
	    if (value === util.errorObj) {
	        this._rejectCallback(value.e, false, true);
	    } else {
	        this._resolveCallback(value, true);
	    }
	};
	};
	
	},{"./util.js":38}],21:[function(_dereq_,module,exports){
	"use strict";
	module.exports = function(Promise) {
	var util = _dereq_("./util.js");
	var async = _dereq_("./async.js");
	var tryCatch = util.tryCatch;
	var errorObj = util.errorObj;
	
	function spreadAdapter(val, nodeback) {
	    var promise = this;
	    if (!util.isArray(val)) return successAdapter.call(promise, val, nodeback);
	    var ret =
	        tryCatch(nodeback).apply(promise._boundValue(), [null].concat(val));
	    if (ret === errorObj) {
	        async.throwLater(ret.e);
	    }
	}
	
	function successAdapter(val, nodeback) {
	    var promise = this;
	    var receiver = promise._boundValue();
	    var ret = val === undefined
	        ? tryCatch(nodeback).call(receiver, null)
	        : tryCatch(nodeback).call(receiver, null, val);
	    if (ret === errorObj) {
	        async.throwLater(ret.e);
	    }
	}
	function errorAdapter(reason, nodeback) {
	    var promise = this;
	    if (!reason) {
	        var target = promise._target();
	        var newReason = target._getCarriedStackTrace();
	        newReason.cause = reason;
	        reason = newReason;
	    }
	    var ret = tryCatch(nodeback).call(promise._boundValue(), reason);
	    if (ret === errorObj) {
	        async.throwLater(ret.e);
	    }
	}
	
	Promise.prototype.asCallback =
	Promise.prototype.nodeify = function (nodeback, options) {
	    if (typeof nodeback == "function") {
	        var adapter = successAdapter;
	        if (options !== undefined && Object(options).spread) {
	            adapter = spreadAdapter;
	        }
	        this._then(
	            adapter,
	            errorAdapter,
	            undefined,
	            this,
	            nodeback
	        );
	    }
	    return this;
	};
	};
	
	},{"./async.js":2,"./util.js":38}],22:[function(_dereq_,module,exports){
	"use strict";
	module.exports = function(Promise, PromiseArray) {
	var util = _dereq_("./util.js");
	var async = _dereq_("./async.js");
	var tryCatch = util.tryCatch;
	var errorObj = util.errorObj;
	
	Promise.prototype.progressed = function (handler) {
	    return this._then(undefined, undefined, handler, undefined, undefined);
	};
	
	Promise.prototype._progress = function (progressValue) {
	    if (this._isFollowingOrFulfilledOrRejected()) return;
	    this._target()._progressUnchecked(progressValue);
	
	};
	
	Promise.prototype._progressHandlerAt = function (index) {
	    return index === 0
	        ? this._progressHandler0
	        : this[(index << 2) + index - 5 + 2];
	};
	
	Promise.prototype._doProgressWith = function (progression) {
	    var progressValue = progression.value;
	    var handler = progression.handler;
	    var promise = progression.promise;
	    var receiver = progression.receiver;
	
	    var ret = tryCatch(handler).call(receiver, progressValue);
	    if (ret === errorObj) {
	        if (ret.e != null &&
	            ret.e.name !== "StopProgressPropagation") {
	            var trace = util.canAttachTrace(ret.e)
	                ? ret.e : new Error(util.toString(ret.e));
	            promise._attachExtraTrace(trace);
	            promise._progress(ret.e);
	        }
	    } else if (ret instanceof Promise) {
	        ret._then(promise._progress, null, null, promise, undefined);
	    } else {
	        promise._progress(ret);
	    }
	};
	
	
	Promise.prototype._progressUnchecked = function (progressValue) {
	    var len = this._length();
	    var progress = this._progress;
	    for (var i = 0; i < len; i++) {
	        var handler = this._progressHandlerAt(i);
	        var promise = this._promiseAt(i);
	        if (!(promise instanceof Promise)) {
	            var receiver = this._receiverAt(i);
	            if (typeof handler === "function") {
	                handler.call(receiver, progressValue, promise);
	            } else if (receiver instanceof PromiseArray &&
	                       !receiver._isResolved()) {
	                receiver._promiseProgressed(progressValue, promise);
	            }
	            continue;
	        }
	
	        if (typeof handler === "function") {
	            async.invoke(this._doProgressWith, this, {
	                handler: handler,
	                promise: promise,
	                receiver: this._receiverAt(i),
	                value: progressValue
	            });
	        } else {
	            async.invoke(progress, promise, progressValue);
	        }
	    }
	};
	};
	
	},{"./async.js":2,"./util.js":38}],23:[function(_dereq_,module,exports){
	"use strict";
	module.exports = function() {
	var makeSelfResolutionError = function () {
	    return new TypeError("circular promise resolution chain\u000a\u000a    See http://goo.gl/LhFpo0\u000a");
	};
	var reflect = function() {
	    return new Promise.PromiseInspection(this._target());
	};
	var apiRejection = function(msg) {
	    return Promise.reject(new TypeError(msg));
	};
	
	var util = _dereq_("./util.js");
	
	var getDomain;
	if (util.isNode) {
	    getDomain = function() {
	        var ret = process.domain;
	        if (ret === undefined) ret = null;
	        return ret;
	    };
	} else {
	    getDomain = function() {
	        return null;
	    };
	}
	util.notEnumerableProp(Promise, "_getDomain", getDomain);
	
	var UNDEFINED_BINDING = {};
	var async = _dereq_("./async.js");
	var errors = _dereq_("./errors.js");
	var TypeError = Promise.TypeError = errors.TypeError;
	Promise.RangeError = errors.RangeError;
	Promise.CancellationError = errors.CancellationError;
	Promise.TimeoutError = errors.TimeoutError;
	Promise.OperationalError = errors.OperationalError;
	Promise.RejectionError = errors.OperationalError;
	Promise.AggregateError = errors.AggregateError;
	var INTERNAL = function(){};
	var APPLY = {};
	var NEXT_FILTER = {e: null};
	var tryConvertToPromise = _dereq_("./thenables.js")(Promise, INTERNAL);
	var PromiseArray =
	    _dereq_("./promise_array.js")(Promise, INTERNAL,
	                                    tryConvertToPromise, apiRejection);
	var CapturedTrace = _dereq_("./captured_trace.js")();
	var isDebugging = _dereq_("./debuggability.js")(Promise, CapturedTrace);
	 /*jshint unused:false*/
	var createContext =
	    _dereq_("./context.js")(Promise, CapturedTrace, isDebugging);
	var CatchFilter = _dereq_("./catch_filter.js")(NEXT_FILTER);
	var PromiseResolver = _dereq_("./promise_resolver.js");
	var nodebackForPromise = PromiseResolver._nodebackForPromise;
	var errorObj = util.errorObj;
	var tryCatch = util.tryCatch;
	
	function Promise(resolver) {
	    if (typeof resolver !== "function") {
	        throw new TypeError("the promise constructor requires a resolver function\u000a\u000a    See http://goo.gl/EC22Yn\u000a");
	    }
	    if (this.constructor !== Promise) {
	        throw new TypeError("the promise constructor cannot be invoked directly\u000a\u000a    See http://goo.gl/KsIlge\u000a");
	    }
	    this._bitField = 0;
	    this._fulfillmentHandler0 = undefined;
	    this._rejectionHandler0 = undefined;
	    this._progressHandler0 = undefined;
	    this._promise0 = undefined;
	    this._receiver0 = undefined;
	    this._settledValue = undefined;
	    if (resolver !== INTERNAL) this._resolveFromResolver(resolver);
	}
	
	Promise.prototype.toString = function () {
	    return "[object Promise]";
	};
	
	Promise.prototype.caught = Promise.prototype["catch"] = function (fn) {
	    var len = arguments.length;
	    if (len > 1) {
	        var catchInstances = new Array(len - 1),
	            j = 0, i;
	        for (i = 0; i < len - 1; ++i) {
	            var item = arguments[i];
	            if (typeof item === "function") {
	                catchInstances[j++] = item;
	            } else {
	                return Promise.reject(
	                    new TypeError("Catch filter must inherit from Error or be a simple predicate function\u000a\u000a    See http://goo.gl/o84o68\u000a"));
	            }
	        }
	        catchInstances.length = j;
	        fn = arguments[i];
	        var catchFilter = new CatchFilter(catchInstances, fn, this);
	        return this._then(undefined, catchFilter.doFilter, undefined,
	            catchFilter, undefined);
	    }
	    return this._then(undefined, fn, undefined, undefined, undefined);
	};
	
	Promise.prototype.reflect = function () {
	    return this._then(reflect, reflect, undefined, this, undefined);
	};
	
	Promise.prototype.then = function (didFulfill, didReject, didProgress) {
	    if (isDebugging() && arguments.length > 0 &&
	        typeof didFulfill !== "function" &&
	        typeof didReject !== "function") {
	        var msg = ".then() only accepts functions but was passed: " +
	                util.classString(didFulfill);
	        if (arguments.length > 1) {
	            msg += ", " + util.classString(didReject);
	        }
	        this._warn(msg);
	    }
	    return this._then(didFulfill, didReject, didProgress,
	        undefined, undefined);
	};
	
	Promise.prototype.done = function (didFulfill, didReject, didProgress) {
	    var promise = this._then(didFulfill, didReject, didProgress,
	        undefined, undefined);
	    promise._setIsFinal();
	};
	
	Promise.prototype.spread = function (didFulfill, didReject) {
	    return this.all()._then(didFulfill, didReject, undefined, APPLY, undefined);
	};
	
	Promise.prototype.isCancellable = function () {
	    return !this.isResolved() &&
	        this._cancellable();
	};
	
	Promise.prototype.toJSON = function () {
	    var ret = {
	        isFulfilled: false,
	        isRejected: false,
	        fulfillmentValue: undefined,
	        rejectionReason: undefined
	    };
	    if (this.isFulfilled()) {
	        ret.fulfillmentValue = this.value();
	        ret.isFulfilled = true;
	    } else if (this.isRejected()) {
	        ret.rejectionReason = this.reason();
	        ret.isRejected = true;
	    }
	    return ret;
	};
	
	Promise.prototype.all = function () {
	    return new PromiseArray(this).promise();
	};
	
	Promise.prototype.error = function (fn) {
	    return this.caught(util.originatesFromRejection, fn);
	};
	
	Promise.getNewLibraryCopy = module.exports;
	
	Promise.is = function (val) {
	    return val instanceof Promise;
	};
	
	Promise.fromNode = function(fn) {
	    var ret = new Promise(INTERNAL);
	    var result = tryCatch(fn)(nodebackForPromise(ret));
	    if (result === errorObj) {
	        ret._rejectCallback(result.e, true, true);
	    }
	    return ret;
	};
	
	Promise.all = function (promises) {
	    return new PromiseArray(promises).promise();
	};
	
	Promise.defer = Promise.pending = function () {
	    var promise = new Promise(INTERNAL);
	    return new PromiseResolver(promise);
	};
	
	Promise.cast = function (obj) {
	    var ret = tryConvertToPromise(obj);
	    if (!(ret instanceof Promise)) {
	        var val = ret;
	        ret = new Promise(INTERNAL);
	        ret._fulfillUnchecked(val);
	    }
	    return ret;
	};
	
	Promise.resolve = Promise.fulfilled = Promise.cast;
	
	Promise.reject = Promise.rejected = function (reason) {
	    var ret = new Promise(INTERNAL);
	    ret._captureStackTrace();
	    ret._rejectCallback(reason, true);
	    return ret;
	};
	
	Promise.setScheduler = function(fn) {
	    if (typeof fn !== "function") throw new TypeError("fn must be a function\u000a\u000a    See http://goo.gl/916lJJ\u000a");
	    var prev = async._schedule;
	    async._schedule = fn;
	    return prev;
	};
	
	Promise.prototype._then = function (
	    didFulfill,
	    didReject,
	    didProgress,
	    receiver,
	    internalData
	) {
	    var haveInternalData = internalData !== undefined;
	    var ret = haveInternalData ? internalData : new Promise(INTERNAL);
	
	    if (!haveInternalData) {
	        ret._propagateFrom(this, 4 | 1);
	        ret._captureStackTrace();
	    }
	
	    var target = this._target();
	    if (target !== this) {
	        if (receiver === undefined) receiver = this._boundTo;
	        if (!haveInternalData) ret._setIsMigrated();
	    }
	
	    var callbackIndex = target._addCallbacks(didFulfill,
	                                             didReject,
	                                             didProgress,
	                                             ret,
	                                             receiver,
	                                             getDomain());
	
	    if (target._isResolved() && !target._isSettlePromisesQueued()) {
	        async.invoke(
	            target._settlePromiseAtPostResolution, target, callbackIndex);
	    }
	
	    return ret;
	};
	
	Promise.prototype._settlePromiseAtPostResolution = function (index) {
	    if (this._isRejectionUnhandled()) this._unsetRejectionIsUnhandled();
	    this._settlePromiseAt(index);
	};
	
	Promise.prototype._length = function () {
	    return this._bitField & 131071;
	};
	
	Promise.prototype._isFollowingOrFulfilledOrRejected = function () {
	    return (this._bitField & 939524096) > 0;
	};
	
	Promise.prototype._isFollowing = function () {
	    return (this._bitField & 536870912) === 536870912;
	};
	
	Promise.prototype._setLength = function (len) {
	    this._bitField = (this._bitField & -131072) |
	        (len & 131071);
	};
	
	Promise.prototype._setFulfilled = function () {
	    this._bitField = this._bitField | 268435456;
	};
	
	Promise.prototype._setRejected = function () {
	    this._bitField = this._bitField | 134217728;
	};
	
	Promise.prototype._setFollowing = function () {
	    this._bitField = this._bitField | 536870912;
	};
	
	Promise.prototype._setIsFinal = function () {
	    this._bitField = this._bitField | 33554432;
	};
	
	Promise.prototype._isFinal = function () {
	    return (this._bitField & 33554432) > 0;
	};
	
	Promise.prototype._cancellable = function () {
	    return (this._bitField & 67108864) > 0;
	};
	
	Promise.prototype._setCancellable = function () {
	    this._bitField = this._bitField | 67108864;
	};
	
	Promise.prototype._unsetCancellable = function () {
	    this._bitField = this._bitField & (~67108864);
	};
	
	Promise.prototype._setIsMigrated = function () {
	    this._bitField = this._bitField | 4194304;
	};
	
	Promise.prototype._unsetIsMigrated = function () {
	    this._bitField = this._bitField & (~4194304);
	};
	
	Promise.prototype._isMigrated = function () {
	    return (this._bitField & 4194304) > 0;
	};
	
	Promise.prototype._receiverAt = function (index) {
	    var ret = index === 0
	        ? this._receiver0
	        : this[
	            index * 5 - 5 + 4];
	    if (ret === UNDEFINED_BINDING) {
	        return undefined;
	    } else if (ret === undefined && this._isBound()) {
	        return this._boundValue();
	    }
	    return ret;
	};
	
	Promise.prototype._promiseAt = function (index) {
	    return index === 0
	        ? this._promise0
	        : this[index * 5 - 5 + 3];
	};
	
	Promise.prototype._fulfillmentHandlerAt = function (index) {
	    return index === 0
	        ? this._fulfillmentHandler0
	        : this[index * 5 - 5 + 0];
	};
	
	Promise.prototype._rejectionHandlerAt = function (index) {
	    return index === 0
	        ? this._rejectionHandler0
	        : this[index * 5 - 5 + 1];
	};
	
	Promise.prototype._boundValue = function() {
	    var ret = this._boundTo;
	    if (ret !== undefined) {
	        if (ret instanceof Promise) {
	            if (ret.isFulfilled()) {
	                return ret.value();
	            } else {
	                return undefined;
	            }
	        }
	    }
	    return ret;
	};
	
	Promise.prototype._migrateCallbacks = function (follower, index) {
	    var fulfill = follower._fulfillmentHandlerAt(index);
	    var reject = follower._rejectionHandlerAt(index);
	    var progress = follower._progressHandlerAt(index);
	    var promise = follower._promiseAt(index);
	    var receiver = follower._receiverAt(index);
	    if (promise instanceof Promise) promise._setIsMigrated();
	    if (receiver === undefined) receiver = UNDEFINED_BINDING;
	    this._addCallbacks(fulfill, reject, progress, promise, receiver, null);
	};
	
	Promise.prototype._addCallbacks = function (
	    fulfill,
	    reject,
	    progress,
	    promise,
	    receiver,
	    domain
	) {
	    var index = this._length();
	
	    if (index >= 131071 - 5) {
	        index = 0;
	        this._setLength(0);
	    }
	
	    if (index === 0) {
	        this._promise0 = promise;
	        if (receiver !== undefined) this._receiver0 = receiver;
	        if (typeof fulfill === "function" && !this._isCarryingStackTrace()) {
	            this._fulfillmentHandler0 =
	                domain === null ? fulfill : domain.bind(fulfill);
	        }
	        if (typeof reject === "function") {
	            this._rejectionHandler0 =
	                domain === null ? reject : domain.bind(reject);
	        }
	        if (typeof progress === "function") {
	            this._progressHandler0 =
	                domain === null ? progress : domain.bind(progress);
	        }
	    } else {
	        var base = index * 5 - 5;
	        this[base + 3] = promise;
	        this[base + 4] = receiver;
	        if (typeof fulfill === "function") {
	            this[base + 0] =
	                domain === null ? fulfill : domain.bind(fulfill);
	        }
	        if (typeof reject === "function") {
	            this[base + 1] =
	                domain === null ? reject : domain.bind(reject);
	        }
	        if (typeof progress === "function") {
	            this[base + 2] =
	                domain === null ? progress : domain.bind(progress);
	        }
	    }
	    this._setLength(index + 1);
	    return index;
	};
	
	Promise.prototype._setProxyHandlers = function (receiver, promiseSlotValue) {
	    var index = this._length();
	
	    if (index >= 131071 - 5) {
	        index = 0;
	        this._setLength(0);
	    }
	    if (index === 0) {
	        this._promise0 = promiseSlotValue;
	        this._receiver0 = receiver;
	    } else {
	        var base = index * 5 - 5;
	        this[base + 3] = promiseSlotValue;
	        this[base + 4] = receiver;
	    }
	    this._setLength(index + 1);
	};
	
	Promise.prototype._proxyPromiseArray = function (promiseArray, index) {
	    this._setProxyHandlers(promiseArray, index);
	};
	
	Promise.prototype._resolveCallback = function(value, shouldBind) {
	    if (this._isFollowingOrFulfilledOrRejected()) return;
	    if (value === this)
	        return this._rejectCallback(makeSelfResolutionError(), false, true);
	    var maybePromise = tryConvertToPromise(value, this);
	    if (!(maybePromise instanceof Promise)) return this._fulfill(value);
	
	    var propagationFlags = 1 | (shouldBind ? 4 : 0);
	    this._propagateFrom(maybePromise, propagationFlags);
	    var promise = maybePromise._target();
	    if (promise._isPending()) {
	        var len = this._length();
	        for (var i = 0; i < len; ++i) {
	            promise._migrateCallbacks(this, i);
	        }
	        this._setFollowing();
	        this._setLength(0);
	        this._setFollowee(promise);
	    } else if (promise._isFulfilled()) {
	        this._fulfillUnchecked(promise._value());
	    } else {
	        this._rejectUnchecked(promise._reason(),
	            promise._getCarriedStackTrace());
	    }
	};
	
	Promise.prototype._rejectCallback =
	function(reason, synchronous, shouldNotMarkOriginatingFromRejection) {
	    if (!shouldNotMarkOriginatingFromRejection) {
	        util.markAsOriginatingFromRejection(reason);
	    }
	    var trace = util.ensureErrorObject(reason);
	    var hasStack = trace === reason;
	    this._attachExtraTrace(trace, synchronous ? hasStack : false);
	    this._reject(reason, hasStack ? undefined : trace);
	};
	
	Promise.prototype._resolveFromResolver = function (resolver) {
	    var promise = this;
	    this._captureStackTrace();
	    this._pushContext();
	    var synchronous = true;
	    var r = tryCatch(resolver)(function(value) {
	        if (promise === null) return;
	        promise._resolveCallback(value);
	        promise = null;
	    }, function (reason) {
	        if (promise === null) return;
	        promise._rejectCallback(reason, synchronous);
	        promise = null;
	    });
	    synchronous = false;
	    this._popContext();
	
	    if (r !== undefined && r === errorObj && promise !== null) {
	        promise._rejectCallback(r.e, true, true);
	        promise = null;
	    }
	};
	
	Promise.prototype._settlePromiseFromHandler = function (
	    handler, receiver, value, promise
	) {
	    if (promise._isRejected()) return;
	    promise._pushContext();
	    var x;
	    if (receiver === APPLY && !this._isRejected()) {
	        x = tryCatch(handler).apply(this._boundValue(), value);
	    } else {
	        x = tryCatch(handler).call(receiver, value);
	    }
	    promise._popContext();
	
	    if (x === errorObj || x === promise || x === NEXT_FILTER) {
	        var err = x === promise ? makeSelfResolutionError() : x.e;
	        promise._rejectCallback(err, false, true);
	    } else {
	        promise._resolveCallback(x);
	    }
	};
	
	Promise.prototype._target = function() {
	    var ret = this;
	    while (ret._isFollowing()) ret = ret._followee();
	    return ret;
	};
	
	Promise.prototype._followee = function() {
	    return this._rejectionHandler0;
	};
	
	Promise.prototype._setFollowee = function(promise) {
	    this._rejectionHandler0 = promise;
	};
	
	Promise.prototype._cleanValues = function () {
	    if (this._cancellable()) {
	        this._cancellationParent = undefined;
	    }
	};
	
	Promise.prototype._propagateFrom = function (parent, flags) {
	    if ((flags & 1) > 0 && parent._cancellable()) {
	        this._setCancellable();
	        this._cancellationParent = parent;
	    }
	    if ((flags & 4) > 0 && parent._isBound()) {
	        this._setBoundTo(parent._boundTo);
	    }
	};
	
	Promise.prototype._fulfill = function (value) {
	    if (this._isFollowingOrFulfilledOrRejected()) return;
	    this._fulfillUnchecked(value);
	};
	
	Promise.prototype._reject = function (reason, carriedStackTrace) {
	    if (this._isFollowingOrFulfilledOrRejected()) return;
	    this._rejectUnchecked(reason, carriedStackTrace);
	};
	
	Promise.prototype._settlePromiseAt = function (index) {
	    var promise = this._promiseAt(index);
	    var isPromise = promise instanceof Promise;
	
	    if (isPromise && promise._isMigrated()) {
	        promise._unsetIsMigrated();
	        return async.invoke(this._settlePromiseAt, this, index);
	    }
	    var handler = this._isFulfilled()
	        ? this._fulfillmentHandlerAt(index)
	        : this._rejectionHandlerAt(index);
	
	    var carriedStackTrace =
	        this._isCarryingStackTrace() ? this._getCarriedStackTrace() : undefined;
	    var value = this._settledValue;
	    var receiver = this._receiverAt(index);
	    this._clearCallbackDataAtIndex(index);
	
	    if (typeof handler === "function") {
	        if (!isPromise) {
	            handler.call(receiver, value, promise);
	        } else {
	            this._settlePromiseFromHandler(handler, receiver, value, promise);
	        }
	    } else if (receiver instanceof PromiseArray) {
	        if (!receiver._isResolved()) {
	            if (this._isFulfilled()) {
	                receiver._promiseFulfilled(value, promise);
	            }
	            else {
	                receiver._promiseRejected(value, promise);
	            }
	        }
	    } else if (isPromise) {
	        if (this._isFulfilled()) {
	            promise._fulfill(value);
	        } else {
	            promise._reject(value, carriedStackTrace);
	        }
	    }
	
	    if (index >= 4 && (index & 31) === 4)
	        async.invokeLater(this._setLength, this, 0);
	};
	
	Promise.prototype._clearCallbackDataAtIndex = function(index) {
	    if (index === 0) {
	        if (!this._isCarryingStackTrace()) {
	            this._fulfillmentHandler0 = undefined;
	        }
	        this._rejectionHandler0 =
	        this._progressHandler0 =
	        this._receiver0 =
	        this._promise0 = undefined;
	    } else {
	        var base = index * 5 - 5;
	        this[base + 3] =
	        this[base + 4] =
	        this[base + 0] =
	        this[base + 1] =
	        this[base + 2] = undefined;
	    }
	};
	
	Promise.prototype._isSettlePromisesQueued = function () {
	    return (this._bitField &
	            -1073741824) === -1073741824;
	};
	
	Promise.prototype._setSettlePromisesQueued = function () {
	    this._bitField = this._bitField | -1073741824;
	};
	
	Promise.prototype._unsetSettlePromisesQueued = function () {
	    this._bitField = this._bitField & (~-1073741824);
	};
	
	Promise.prototype._queueSettlePromises = function() {
	    async.settlePromises(this);
	    this._setSettlePromisesQueued();
	};
	
	Promise.prototype._fulfillUnchecked = function (value) {
	    if (value === this) {
	        var err = makeSelfResolutionError();
	        this._attachExtraTrace(err);
	        return this._rejectUnchecked(err, undefined);
	    }
	    this._setFulfilled();
	    this._settledValue = value;
	    this._cleanValues();
	
	    if (this._length() > 0) {
	        this._queueSettlePromises();
	    }
	};
	
	Promise.prototype._rejectUncheckedCheckError = function (reason) {
	    var trace = util.ensureErrorObject(reason);
	    this._rejectUnchecked(reason, trace === reason ? undefined : trace);
	};
	
	Promise.prototype._rejectUnchecked = function (reason, trace) {
	    if (reason === this) {
	        var err = makeSelfResolutionError();
	        this._attachExtraTrace(err);
	        return this._rejectUnchecked(err);
	    }
	    this._setRejected();
	    this._settledValue = reason;
	    this._cleanValues();
	
	    if (this._isFinal()) {
	        async.throwLater(function(e) {
	            if ("stack" in e) {
	                async.invokeFirst(
	                    CapturedTrace.unhandledRejection, undefined, e);
	            }
	            throw e;
	        }, trace === undefined ? reason : trace);
	        return;
	    }
	
	    if (trace !== undefined && trace !== reason) {
	        this._setCarriedStackTrace(trace);
	    }
	
	    if (this._length() > 0) {
	        this._queueSettlePromises();
	    } else {
	        this._ensurePossibleRejectionHandled();
	    }
	};
	
	Promise.prototype._settlePromises = function () {
	    this._unsetSettlePromisesQueued();
	    var len = this._length();
	    for (var i = 0; i < len; i++) {
	        this._settlePromiseAt(i);
	    }
	};
	
	
	util.notEnumerableProp(Promise,
	                       "_makeSelfResolutionError",
	                       makeSelfResolutionError);
	
	_dereq_("./progress.js")(Promise, PromiseArray);
	_dereq_("./method.js")(Promise, INTERNAL, tryConvertToPromise, apiRejection);
	_dereq_("./bind.js")(Promise, INTERNAL, tryConvertToPromise);
	_dereq_("./finally.js")(Promise, NEXT_FILTER, tryConvertToPromise);
	_dereq_("./direct_resolve.js")(Promise);
	_dereq_("./synchronous_inspection.js")(Promise);
	_dereq_("./join.js")(Promise, PromiseArray, tryConvertToPromise, INTERNAL);
	Promise.version = "2.11.0";
	Promise.Promise = Promise;
	_dereq_('./map.js')(Promise, PromiseArray, apiRejection, tryConvertToPromise, INTERNAL);
	_dereq_('./cancel.js')(Promise);
	_dereq_('./using.js')(Promise, apiRejection, tryConvertToPromise, createContext);
	_dereq_('./generators.js')(Promise, apiRejection, INTERNAL, tryConvertToPromise);
	_dereq_('./nodeify.js')(Promise);
	_dereq_('./call_get.js')(Promise);
	_dereq_('./props.js')(Promise, PromiseArray, tryConvertToPromise, apiRejection);
	_dereq_('./race.js')(Promise, INTERNAL, tryConvertToPromise, apiRejection);
	_dereq_('./reduce.js')(Promise, PromiseArray, apiRejection, tryConvertToPromise, INTERNAL);
	_dereq_('./settle.js')(Promise, PromiseArray);
	_dereq_('./some.js')(Promise, PromiseArray, apiRejection);
	_dereq_('./promisify.js')(Promise, INTERNAL);
	_dereq_('./any.js')(Promise);
	_dereq_('./each.js')(Promise, INTERNAL);
	_dereq_('./timers.js')(Promise, INTERNAL);
	_dereq_('./filter.js')(Promise, INTERNAL);
	                                                         
	    util.toFastProperties(Promise);                                          
	    util.toFastProperties(Promise.prototype);                                
	    function fillTypes(value) {                                              
	        var p = new Promise(INTERNAL);                                       
	        p._fulfillmentHandler0 = value;                                      
	        p._rejectionHandler0 = value;                                        
	        p._progressHandler0 = value;                                         
	        p._promise0 = value;                                                 
	        p._receiver0 = value;                                                
	        p._settledValue = value;                                             
	    }                                                                        
	    // Complete slack tracking, opt out of field-type tracking and           
	    // stabilize map                                                         
	    fillTypes({a: 1});                                                       
	    fillTypes({b: 2});                                                       
	    fillTypes({c: 3});                                                       
	    fillTypes(1);                                                            
	    fillTypes(function(){});                                                 
	    fillTypes(undefined);                                                    
	    fillTypes(false);                                                        
	    fillTypes(new Promise(INTERNAL));                                        
	    CapturedTrace.setBounds(async.firstLineError, util.lastLineError);       
	    return Promise;                                                          
	
	};
	
	},{"./any.js":1,"./async.js":2,"./bind.js":3,"./call_get.js":5,"./cancel.js":6,"./captured_trace.js":7,"./catch_filter.js":8,"./context.js":9,"./debuggability.js":10,"./direct_resolve.js":11,"./each.js":12,"./errors.js":13,"./filter.js":15,"./finally.js":16,"./generators.js":17,"./join.js":18,"./map.js":19,"./method.js":20,"./nodeify.js":21,"./progress.js":22,"./promise_array.js":24,"./promise_resolver.js":25,"./promisify.js":26,"./props.js":27,"./race.js":29,"./reduce.js":30,"./settle.js":32,"./some.js":33,"./synchronous_inspection.js":34,"./thenables.js":35,"./timers.js":36,"./using.js":37,"./util.js":38}],24:[function(_dereq_,module,exports){
	"use strict";
	module.exports = function(Promise, INTERNAL, tryConvertToPromise,
	    apiRejection) {
	var util = _dereq_("./util.js");
	var isArray = util.isArray;
	
	function toResolutionValue(val) {
	    switch(val) {
	    case -2: return [];
	    case -3: return {};
	    }
	}
	
	function PromiseArray(values) {
	    var promise = this._promise = new Promise(INTERNAL);
	    var parent;
	    if (values instanceof Promise) {
	        parent = values;
	        promise._propagateFrom(parent, 1 | 4);
	    }
	    this._values = values;
	    this._length = 0;
	    this._totalResolved = 0;
	    this._init(undefined, -2);
	}
	PromiseArray.prototype.length = function () {
	    return this._length;
	};
	
	PromiseArray.prototype.promise = function () {
	    return this._promise;
	};
	
	PromiseArray.prototype._init = function init(_, resolveValueIfEmpty) {
	    var values = tryConvertToPromise(this._values, this._promise);
	    if (values instanceof Promise) {
	        values = values._target();
	        this._values = values;
	        if (values._isFulfilled()) {
	            values = values._value();
	            if (!isArray(values)) {
	                var err = new Promise.TypeError("expecting an array, a promise or a thenable\u000a\u000a    See http://goo.gl/s8MMhc\u000a");
	                this.__hardReject__(err);
	                return;
	            }
	        } else if (values._isPending()) {
	            values._then(
	                init,
	                this._reject,
	                undefined,
	                this,
	                resolveValueIfEmpty
	           );
	            return;
	        } else {
	            this._reject(values._reason());
	            return;
	        }
	    } else if (!isArray(values)) {
	        this._promise._reject(apiRejection("expecting an array, a promise or a thenable\u000a\u000a    See http://goo.gl/s8MMhc\u000a")._reason());
	        return;
	    }
	
	    if (values.length === 0) {
	        if (resolveValueIfEmpty === -5) {
	            this._resolveEmptyArray();
	        }
	        else {
	            this._resolve(toResolutionValue(resolveValueIfEmpty));
	        }
	        return;
	    }
	    var len = this.getActualLength(values.length);
	    this._length = len;
	    this._values = this.shouldCopyValues() ? new Array(len) : this._values;
	    var promise = this._promise;
	    for (var i = 0; i < len; ++i) {
	        var isResolved = this._isResolved();
	        var maybePromise = tryConvertToPromise(values[i], promise);
	        if (maybePromise instanceof Promise) {
	            maybePromise = maybePromise._target();
	            if (isResolved) {
	                maybePromise._ignoreRejections();
	            } else if (maybePromise._isPending()) {
	                maybePromise._proxyPromiseArray(this, i);
	            } else if (maybePromise._isFulfilled()) {
	                this._promiseFulfilled(maybePromise._value(), i);
	            } else {
	                this._promiseRejected(maybePromise._reason(), i);
	            }
	        } else if (!isResolved) {
	            this._promiseFulfilled(maybePromise, i);
	        }
	    }
	};
	
	PromiseArray.prototype._isResolved = function () {
	    return this._values === null;
	};
	
	PromiseArray.prototype._resolve = function (value) {
	    this._values = null;
	    this._promise._fulfill(value);
	};
	
	PromiseArray.prototype.__hardReject__ =
	PromiseArray.prototype._reject = function (reason) {
	    this._values = null;
	    this._promise._rejectCallback(reason, false, true);
	};
	
	PromiseArray.prototype._promiseProgressed = function (progressValue, index) {
	    this._promise._progress({
	        index: index,
	        value: progressValue
	    });
	};
	
	
	PromiseArray.prototype._promiseFulfilled = function (value, index) {
	    this._values[index] = value;
	    var totalResolved = ++this._totalResolved;
	    if (totalResolved >= this._length) {
	        this._resolve(this._values);
	    }
	};
	
	PromiseArray.prototype._promiseRejected = function (reason, index) {
	    this._totalResolved++;
	    this._reject(reason);
	};
	
	PromiseArray.prototype.shouldCopyValues = function () {
	    return true;
	};
	
	PromiseArray.prototype.getActualLength = function (len) {
	    return len;
	};
	
	return PromiseArray;
	};
	
	},{"./util.js":38}],25:[function(_dereq_,module,exports){
	"use strict";
	var util = _dereq_("./util.js");
	var maybeWrapAsError = util.maybeWrapAsError;
	var errors = _dereq_("./errors.js");
	var TimeoutError = errors.TimeoutError;
	var OperationalError = errors.OperationalError;
	var haveGetters = util.haveGetters;
	var es5 = _dereq_("./es5.js");
	
	function isUntypedError(obj) {
	    return obj instanceof Error &&
	        es5.getPrototypeOf(obj) === Error.prototype;
	}
	
	var rErrorKey = /^(?:name|message|stack|cause)$/;
	function wrapAsOperationalError(obj) {
	    var ret;
	    if (isUntypedError(obj)) {
	        ret = new OperationalError(obj);
	        ret.name = obj.name;
	        ret.message = obj.message;
	        ret.stack = obj.stack;
	        var keys = es5.keys(obj);
	        for (var i = 0; i < keys.length; ++i) {
	            var key = keys[i];
	            if (!rErrorKey.test(key)) {
	                ret[key] = obj[key];
	            }
	        }
	        return ret;
	    }
	    util.markAsOriginatingFromRejection(obj);
	    return obj;
	}
	
	function nodebackForPromise(promise) {
	    return function(err, value) {
	        if (promise === null) return;
	
	        if (err) {
	            var wrapped = wrapAsOperationalError(maybeWrapAsError(err));
	            promise._attachExtraTrace(wrapped);
	            promise._reject(wrapped);
	        } else if (arguments.length > 2) {
	            var $_len = arguments.length;var args = new Array($_len - 1); for(var $_i = 1; $_i < $_len; ++$_i) {args[$_i - 1] = arguments[$_i];}
	            promise._fulfill(args);
	        } else {
	            promise._fulfill(value);
	        }
	
	        promise = null;
	    };
	}
	
	
	var PromiseResolver;
	if (!haveGetters) {
	    PromiseResolver = function (promise) {
	        this.promise = promise;
	        this.asCallback = nodebackForPromise(promise);
	        this.callback = this.asCallback;
	    };
	}
	else {
	    PromiseResolver = function (promise) {
	        this.promise = promise;
	    };
	}
	if (haveGetters) {
	    var prop = {
	        get: function() {
	            return nodebackForPromise(this.promise);
	        }
	    };
	    es5.defineProperty(PromiseResolver.prototype, "asCallback", prop);
	    es5.defineProperty(PromiseResolver.prototype, "callback", prop);
	}
	
	PromiseResolver._nodebackForPromise = nodebackForPromise;
	
	PromiseResolver.prototype.toString = function () {
	    return "[object PromiseResolver]";
	};
	
	PromiseResolver.prototype.resolve =
	PromiseResolver.prototype.fulfill = function (value) {
	    if (!(this instanceof PromiseResolver)) {
	        throw new TypeError("Illegal invocation, resolver resolve/reject must be called within a resolver context. Consider using the promise constructor instead.\u000a\u000a    See http://goo.gl/sdkXL9\u000a");
	    }
	    this.promise._resolveCallback(value);
	};
	
	PromiseResolver.prototype.reject = function (reason) {
	    if (!(this instanceof PromiseResolver)) {
	        throw new TypeError("Illegal invocation, resolver resolve/reject must be called within a resolver context. Consider using the promise constructor instead.\u000a\u000a    See http://goo.gl/sdkXL9\u000a");
	    }
	    this.promise._rejectCallback(reason);
	};
	
	PromiseResolver.prototype.progress = function (value) {
	    if (!(this instanceof PromiseResolver)) {
	        throw new TypeError("Illegal invocation, resolver resolve/reject must be called within a resolver context. Consider using the promise constructor instead.\u000a\u000a    See http://goo.gl/sdkXL9\u000a");
	    }
	    this.promise._progress(value);
	};
	
	PromiseResolver.prototype.cancel = function (err) {
	    this.promise.cancel(err);
	};
	
	PromiseResolver.prototype.timeout = function () {
	    this.reject(new TimeoutError("timeout"));
	};
	
	PromiseResolver.prototype.isResolved = function () {
	    return this.promise.isResolved();
	};
	
	PromiseResolver.prototype.toJSON = function () {
	    return this.promise.toJSON();
	};
	
	module.exports = PromiseResolver;
	
	},{"./errors.js":13,"./es5.js":14,"./util.js":38}],26:[function(_dereq_,module,exports){
	"use strict";
	module.exports = function(Promise, INTERNAL) {
	var THIS = {};
	var util = _dereq_("./util.js");
	var nodebackForPromise = _dereq_("./promise_resolver.js")
	    ._nodebackForPromise;
	var withAppended = util.withAppended;
	var maybeWrapAsError = util.maybeWrapAsError;
	var canEvaluate = util.canEvaluate;
	var TypeError = _dereq_("./errors").TypeError;
	var defaultSuffix = "Async";
	var defaultPromisified = {__isPromisified__: true};
	var noCopyProps = [
	    "arity",    "length",
	    "name",
	    "arguments",
	    "caller",
	    "callee",
	    "prototype",
	    "__isPromisified__"
	];
	var noCopyPropsPattern = new RegExp("^(?:" + noCopyProps.join("|") + ")$");
	
	var defaultFilter = function(name) {
	    return util.isIdentifier(name) &&
	        name.charAt(0) !== "_" &&
	        name !== "constructor";
	};
	
	function propsFilter(key) {
	    return !noCopyPropsPattern.test(key);
	}
	
	function isPromisified(fn) {
	    try {
	        return fn.__isPromisified__ === true;
	    }
	    catch (e) {
	        return false;
	    }
	}
	
	function hasPromisified(obj, key, suffix) {
	    var val = util.getDataPropertyOrDefault(obj, key + suffix,
	                                            defaultPromisified);
	    return val ? isPromisified(val) : false;
	}
	function checkValid(ret, suffix, suffixRegexp) {
	    for (var i = 0; i < ret.length; i += 2) {
	        var key = ret[i];
	        if (suffixRegexp.test(key)) {
	            var keyWithoutAsyncSuffix = key.replace(suffixRegexp, "");
	            for (var j = 0; j < ret.length; j += 2) {
	                if (ret[j] === keyWithoutAsyncSuffix) {
	                    throw new TypeError("Cannot promisify an API that has normal methods with '%s'-suffix\u000a\u000a    See http://goo.gl/iWrZbw\u000a"
	                        .replace("%s", suffix));
	                }
	            }
	        }
	    }
	}
	
	function promisifiableMethods(obj, suffix, suffixRegexp, filter) {
	    var keys = util.inheritedDataKeys(obj);
	    var ret = [];
	    for (var i = 0; i < keys.length; ++i) {
	        var key = keys[i];
	        var value = obj[key];
	        var passesDefaultFilter = filter === defaultFilter
	            ? true : defaultFilter(key, value, obj);
	        if (typeof value === "function" &&
	            !isPromisified(value) &&
	            !hasPromisified(obj, key, suffix) &&
	            filter(key, value, obj, passesDefaultFilter)) {
	            ret.push(key, value);
	        }
	    }
	    checkValid(ret, suffix, suffixRegexp);
	    return ret;
	}
	
	var escapeIdentRegex = function(str) {
	    return str.replace(/([$])/, "\\$");
	};
	
	var makeNodePromisifiedEval;
	if (false) {
	var switchCaseArgumentOrder = function(likelyArgumentCount) {
	    var ret = [likelyArgumentCount];
	    var min = Math.max(0, likelyArgumentCount - 1 - 3);
	    for(var i = likelyArgumentCount - 1; i >= min; --i) {
	        ret.push(i);
	    }
	    for(var i = likelyArgumentCount + 1; i <= 3; ++i) {
	        ret.push(i);
	    }
	    return ret;
	};
	
	var argumentSequence = function(argumentCount) {
	    return util.filledRange(argumentCount, "_arg", "");
	};
	
	var parameterDeclaration = function(parameterCount) {
	    return util.filledRange(
	        Math.max(parameterCount, 3), "_arg", "");
	};
	
	var parameterCount = function(fn) {
	    if (typeof fn.length === "number") {
	        return Math.max(Math.min(fn.length, 1023 + 1), 0);
	    }
	    return 0;
	};
	
	makeNodePromisifiedEval =
	function(callback, receiver, originalName, fn) {
	    var newParameterCount = Math.max(0, parameterCount(fn) - 1);
	    var argumentOrder = switchCaseArgumentOrder(newParameterCount);
	    var shouldProxyThis = typeof callback === "string" || receiver === THIS;
	
	    function generateCallForArgumentCount(count) {
	        var args = argumentSequence(count).join(", ");
	        var comma = count > 0 ? ", " : "";
	        var ret;
	        if (shouldProxyThis) {
	            ret = "ret = callback.call(this, {{args}}, nodeback); break;\n";
	        } else {
	            ret = receiver === undefined
	                ? "ret = callback({{args}}, nodeback); break;\n"
	                : "ret = callback.call(receiver, {{args}}, nodeback); break;\n";
	        }
	        return ret.replace("{{args}}", args).replace(", ", comma);
	    }
	
	    function generateArgumentSwitchCase() {
	        var ret = "";
	        for (var i = 0; i < argumentOrder.length; ++i) {
	            ret += "case " + argumentOrder[i] +":" +
	                generateCallForArgumentCount(argumentOrder[i]);
	        }
	
	        ret += "                                                             \n\
	        default:                                                             \n\
	            var args = new Array(len + 1);                                   \n\
	            var i = 0;                                                       \n\
	            for (var i = 0; i < len; ++i) {                                  \n\
	               args[i] = arguments[i];                                       \n\
	            }                                                                \n\
	            args[i] = nodeback;                                              \n\
	            [CodeForCall]                                                    \n\
	            break;                                                           \n\
	        ".replace("[CodeForCall]", (shouldProxyThis
	                                ? "ret = callback.apply(this, args);\n"
	                                : "ret = callback.apply(receiver, args);\n"));
	        return ret;
	    }
	
	    var getFunctionCode = typeof callback === "string"
	                                ? ("this != null ? this['"+callback+"'] : fn")
	                                : "fn";
	
	    return new Function("Promise",
	                        "fn",
	                        "receiver",
	                        "withAppended",
	                        "maybeWrapAsError",
	                        "nodebackForPromise",
	                        "tryCatch",
	                        "errorObj",
	                        "notEnumerableProp",
	                        "INTERNAL","'use strict';                            \n\
	        var ret = function (Parameters) {                                    \n\
	            'use strict';                                                    \n\
	            var len = arguments.length;                                      \n\
	            var promise = new Promise(INTERNAL);                             \n\
	            promise._captureStackTrace();                                    \n\
	            var nodeback = nodebackForPromise(promise);                      \n\
	            var ret;                                                         \n\
	            var callback = tryCatch([GetFunctionCode]);                      \n\
	            switch(len) {                                                    \n\
	                [CodeForSwitchCase]                                          \n\
	            }                                                                \n\
	            if (ret === errorObj) {                                          \n\
	                promise._rejectCallback(maybeWrapAsError(ret.e), true, true);\n\
	            }                                                                \n\
	            return promise;                                                  \n\
	        };                                                                   \n\
	        notEnumerableProp(ret, '__isPromisified__', true);                   \n\
	        return ret;                                                          \n\
	        "
	        .replace("Parameters", parameterDeclaration(newParameterCount))
	        .replace("[CodeForSwitchCase]", generateArgumentSwitchCase())
	        .replace("[GetFunctionCode]", getFunctionCode))(
	            Promise,
	            fn,
	            receiver,
	            withAppended,
	            maybeWrapAsError,
	            nodebackForPromise,
	            util.tryCatch,
	            util.errorObj,
	            util.notEnumerableProp,
	            INTERNAL
	        );
	};
	}
	
	function makeNodePromisifiedClosure(callback, receiver, _, fn) {
	    var defaultThis = (function() {return this;})();
	    var method = callback;
	    if (typeof method === "string") {
	        callback = fn;
	    }
	    function promisified() {
	        var _receiver = receiver;
	        if (receiver === THIS) _receiver = this;
	        var promise = new Promise(INTERNAL);
	        promise._captureStackTrace();
	        var cb = typeof method === "string" && this !== defaultThis
	            ? this[method] : callback;
	        var fn = nodebackForPromise(promise);
	        try {
	            cb.apply(_receiver, withAppended(arguments, fn));
	        } catch(e) {
	            promise._rejectCallback(maybeWrapAsError(e), true, true);
	        }
	        return promise;
	    }
	    util.notEnumerableProp(promisified, "__isPromisified__", true);
	    return promisified;
	}
	
	var makeNodePromisified = canEvaluate
	    ? makeNodePromisifiedEval
	    : makeNodePromisifiedClosure;
	
	function promisifyAll(obj, suffix, filter, promisifier) {
	    var suffixRegexp = new RegExp(escapeIdentRegex(suffix) + "$");
	    var methods =
	        promisifiableMethods(obj, suffix, suffixRegexp, filter);
	
	    for (var i = 0, len = methods.length; i < len; i+= 2) {
	        var key = methods[i];
	        var fn = methods[i+1];
	        var promisifiedKey = key + suffix;
	        if (promisifier === makeNodePromisified) {
	            obj[promisifiedKey] =
	                makeNodePromisified(key, THIS, key, fn, suffix);
	        } else {
	            var promisified = promisifier(fn, function() {
	                return makeNodePromisified(key, THIS, key, fn, suffix);
	            });
	            util.notEnumerableProp(promisified, "__isPromisified__", true);
	            obj[promisifiedKey] = promisified;
	        }
	    }
	    util.toFastProperties(obj);
	    return obj;
	}
	
	function promisify(callback, receiver) {
	    return makeNodePromisified(callback, receiver, undefined, callback);
	}
	
	Promise.promisify = function (fn, receiver) {
	    if (typeof fn !== "function") {
	        throw new TypeError("fn must be a function\u000a\u000a    See http://goo.gl/916lJJ\u000a");
	    }
	    if (isPromisified(fn)) {
	        return fn;
	    }
	    var ret = promisify(fn, arguments.length < 2 ? THIS : receiver);
	    util.copyDescriptors(fn, ret, propsFilter);
	    return ret;
	};
	
	Promise.promisifyAll = function (target, options) {
	    if (typeof target !== "function" && typeof target !== "object") {
	        throw new TypeError("the target of promisifyAll must be an object or a function\u000a\u000a    See http://goo.gl/9ITlV0\u000a");
	    }
	    options = Object(options);
	    var suffix = options.suffix;
	    if (typeof suffix !== "string") suffix = defaultSuffix;
	    var filter = options.filter;
	    if (typeof filter !== "function") filter = defaultFilter;
	    var promisifier = options.promisifier;
	    if (typeof promisifier !== "function") promisifier = makeNodePromisified;
	
	    if (!util.isIdentifier(suffix)) {
	        throw new RangeError("suffix must be a valid identifier\u000a\u000a    See http://goo.gl/8FZo5V\u000a");
	    }
	
	    var keys = util.inheritedDataKeys(target);
	    for (var i = 0; i < keys.length; ++i) {
	        var value = target[keys[i]];
	        if (keys[i] !== "constructor" &&
	            util.isClass(value)) {
	            promisifyAll(value.prototype, suffix, filter, promisifier);
	            promisifyAll(value, suffix, filter, promisifier);
	        }
	    }
	
	    return promisifyAll(target, suffix, filter, promisifier);
	};
	};
	
	
	},{"./errors":13,"./promise_resolver.js":25,"./util.js":38}],27:[function(_dereq_,module,exports){
	"use strict";
	module.exports = function(
	    Promise, PromiseArray, tryConvertToPromise, apiRejection) {
	var util = _dereq_("./util.js");
	var isObject = util.isObject;
	var es5 = _dereq_("./es5.js");
	
	function PropertiesPromiseArray(obj) {
	    var keys = es5.keys(obj);
	    var len = keys.length;
	    var values = new Array(len * 2);
	    for (var i = 0; i < len; ++i) {
	        var key = keys[i];
	        values[i] = obj[key];
	        values[i + len] = key;
	    }
	    this.constructor$(values);
	}
	util.inherits(PropertiesPromiseArray, PromiseArray);
	
	PropertiesPromiseArray.prototype._init = function () {
	    this._init$(undefined, -3) ;
	};
	
	PropertiesPromiseArray.prototype._promiseFulfilled = function (value, index) {
	    this._values[index] = value;
	    var totalResolved = ++this._totalResolved;
	    if (totalResolved >= this._length) {
	        var val = {};
	        var keyOffset = this.length();
	        for (var i = 0, len = this.length(); i < len; ++i) {
	            val[this._values[i + keyOffset]] = this._values[i];
	        }
	        this._resolve(val);
	    }
	};
	
	PropertiesPromiseArray.prototype._promiseProgressed = function (value, index) {
	    this._promise._progress({
	        key: this._values[index + this.length()],
	        value: value
	    });
	};
	
	PropertiesPromiseArray.prototype.shouldCopyValues = function () {
	    return false;
	};
	
	PropertiesPromiseArray.prototype.getActualLength = function (len) {
	    return len >> 1;
	};
	
	function props(promises) {
	    var ret;
	    var castValue = tryConvertToPromise(promises);
	
	    if (!isObject(castValue)) {
	        return apiRejection("cannot await properties of a non-object\u000a\u000a    See http://goo.gl/OsFKC8\u000a");
	    } else if (castValue instanceof Promise) {
	        ret = castValue._then(
	            Promise.props, undefined, undefined, undefined, undefined);
	    } else {
	        ret = new PropertiesPromiseArray(castValue).promise();
	    }
	
	    if (castValue instanceof Promise) {
	        ret._propagateFrom(castValue, 4);
	    }
	    return ret;
	}
	
	Promise.prototype.props = function () {
	    return props(this);
	};
	
	Promise.props = function (promises) {
	    return props(promises);
	};
	};
	
	},{"./es5.js":14,"./util.js":38}],28:[function(_dereq_,module,exports){
	"use strict";
	function arrayMove(src, srcIndex, dst, dstIndex, len) {
	    for (var j = 0; j < len; ++j) {
	        dst[j + dstIndex] = src[j + srcIndex];
	        src[j + srcIndex] = void 0;
	    }
	}
	
	function Queue(capacity) {
	    this._capacity = capacity;
	    this._length = 0;
	    this._front = 0;
	}
	
	Queue.prototype._willBeOverCapacity = function (size) {
	    return this._capacity < size;
	};
	
	Queue.prototype._pushOne = function (arg) {
	    var length = this.length();
	    this._checkCapacity(length + 1);
	    var i = (this._front + length) & (this._capacity - 1);
	    this[i] = arg;
	    this._length = length + 1;
	};
	
	Queue.prototype._unshiftOne = function(value) {
	    var capacity = this._capacity;
	    this._checkCapacity(this.length() + 1);
	    var front = this._front;
	    var i = (((( front - 1 ) &
	                    ( capacity - 1) ) ^ capacity ) - capacity );
	    this[i] = value;
	    this._front = i;
	    this._length = this.length() + 1;
	};
	
	Queue.prototype.unshift = function(fn, receiver, arg) {
	    this._unshiftOne(arg);
	    this._unshiftOne(receiver);
	    this._unshiftOne(fn);
	};
	
	Queue.prototype.push = function (fn, receiver, arg) {
	    var length = this.length() + 3;
	    if (this._willBeOverCapacity(length)) {
	        this._pushOne(fn);
	        this._pushOne(receiver);
	        this._pushOne(arg);
	        return;
	    }
	    var j = this._front + length - 3;
	    this._checkCapacity(length);
	    var wrapMask = this._capacity - 1;
	    this[(j + 0) & wrapMask] = fn;
	    this[(j + 1) & wrapMask] = receiver;
	    this[(j + 2) & wrapMask] = arg;
	    this._length = length;
	};
	
	Queue.prototype.shift = function () {
	    var front = this._front,
	        ret = this[front];
	
	    this[front] = undefined;
	    this._front = (front + 1) & (this._capacity - 1);
	    this._length--;
	    return ret;
	};
	
	Queue.prototype.length = function () {
	    return this._length;
	};
	
	Queue.prototype._checkCapacity = function (size) {
	    if (this._capacity < size) {
	        this._resizeTo(this._capacity << 1);
	    }
	};
	
	Queue.prototype._resizeTo = function (capacity) {
	    var oldCapacity = this._capacity;
	    this._capacity = capacity;
	    var front = this._front;
	    var length = this._length;
	    var moveItemsCount = (front + length) & (oldCapacity - 1);
	    arrayMove(this, 0, this, oldCapacity, moveItemsCount);
	};
	
	module.exports = Queue;
	
	},{}],29:[function(_dereq_,module,exports){
	"use strict";
	module.exports = function(
	    Promise, INTERNAL, tryConvertToPromise, apiRejection) {
	var isArray = _dereq_("./util.js").isArray;
	
	var raceLater = function (promise) {
	    return promise.then(function(array) {
	        return race(array, promise);
	    });
	};
	
	function race(promises, parent) {
	    var maybePromise = tryConvertToPromise(promises);
	
	    if (maybePromise instanceof Promise) {
	        return raceLater(maybePromise);
	    } else if (!isArray(promises)) {
	        return apiRejection("expecting an array, a promise or a thenable\u000a\u000a    See http://goo.gl/s8MMhc\u000a");
	    }
	
	    var ret = new Promise(INTERNAL);
	    if (parent !== undefined) {
	        ret._propagateFrom(parent, 4 | 1);
	    }
	    var fulfill = ret._fulfill;
	    var reject = ret._reject;
	    for (var i = 0, len = promises.length; i < len; ++i) {
	        var val = promises[i];
	
	        if (val === undefined && !(i in promises)) {
	            continue;
	        }
	
	        Promise.cast(val)._then(fulfill, reject, undefined, ret, null);
	    }
	    return ret;
	}
	
	Promise.race = function (promises) {
	    return race(promises, undefined);
	};
	
	Promise.prototype.race = function () {
	    return race(this, undefined);
	};
	
	};
	
	},{"./util.js":38}],30:[function(_dereq_,module,exports){
	"use strict";
	module.exports = function(Promise,
	                          PromiseArray,
	                          apiRejection,
	                          tryConvertToPromise,
	                          INTERNAL) {
	var getDomain = Promise._getDomain;
	var async = _dereq_("./async.js");
	var util = _dereq_("./util.js");
	var tryCatch = util.tryCatch;
	var errorObj = util.errorObj;
	function ReductionPromiseArray(promises, fn, accum, _each) {
	    this.constructor$(promises);
	    this._promise._captureStackTrace();
	    this._preservedValues = _each === INTERNAL ? [] : null;
	    this._zerothIsAccum = (accum === undefined);
	    this._gotAccum = false;
	    this._reducingIndex = (this._zerothIsAccum ? 1 : 0);
	    this._valuesPhase = undefined;
	    var maybePromise = tryConvertToPromise(accum, this._promise);
	    var rejected = false;
	    var isPromise = maybePromise instanceof Promise;
	    if (isPromise) {
	        maybePromise = maybePromise._target();
	        if (maybePromise._isPending()) {
	            maybePromise._proxyPromiseArray(this, -1);
	        } else if (maybePromise._isFulfilled()) {
	            accum = maybePromise._value();
	            this._gotAccum = true;
	        } else {
	            this._reject(maybePromise._reason());
	            rejected = true;
	        }
	    }
	    if (!(isPromise || this._zerothIsAccum)) this._gotAccum = true;
	    var domain = getDomain();
	    this._callback = domain === null ? fn : domain.bind(fn);
	    this._accum = accum;
	    if (!rejected) async.invoke(init, this, undefined);
	}
	function init() {
	    this._init$(undefined, -5);
	}
	util.inherits(ReductionPromiseArray, PromiseArray);
	
	ReductionPromiseArray.prototype._init = function () {};
	
	ReductionPromiseArray.prototype._resolveEmptyArray = function () {
	    if (this._gotAccum || this._zerothIsAccum) {
	        this._resolve(this._preservedValues !== null
	                        ? [] : this._accum);
	    }
	};
	
	ReductionPromiseArray.prototype._promiseFulfilled = function (value, index) {
	    var values = this._values;
	    values[index] = value;
	    var length = this.length();
	    var preservedValues = this._preservedValues;
	    var isEach = preservedValues !== null;
	    var gotAccum = this._gotAccum;
	    var valuesPhase = this._valuesPhase;
	    var valuesPhaseIndex;
	    if (!valuesPhase) {
	        valuesPhase = this._valuesPhase = new Array(length);
	        for (valuesPhaseIndex=0; valuesPhaseIndex<length; ++valuesPhaseIndex) {
	            valuesPhase[valuesPhaseIndex] = 0;
	        }
	    }
	    valuesPhaseIndex = valuesPhase[index];
	
	    if (index === 0 && this._zerothIsAccum) {
	        this._accum = value;
	        this._gotAccum = gotAccum = true;
	        valuesPhase[index] = ((valuesPhaseIndex === 0)
	            ? 1 : 2);
	    } else if (index === -1) {
	        this._accum = value;
	        this._gotAccum = gotAccum = true;
	    } else {
	        if (valuesPhaseIndex === 0) {
	            valuesPhase[index] = 1;
	        } else {
	            valuesPhase[index] = 2;
	            this._accum = value;
	        }
	    }
	    if (!gotAccum) return;
	
	    var callback = this._callback;
	    var receiver = this._promise._boundValue();
	    var ret;
	
	    for (var i = this._reducingIndex; i < length; ++i) {
	        valuesPhaseIndex = valuesPhase[i];
	        if (valuesPhaseIndex === 2) {
	            this._reducingIndex = i + 1;
	            continue;
	        }
	        if (valuesPhaseIndex !== 1) return;
	        value = values[i];
	        this._promise._pushContext();
	        if (isEach) {
	            preservedValues.push(value);
	            ret = tryCatch(callback).call(receiver, value, i, length);
	        }
	        else {
	            ret = tryCatch(callback)
	                .call(receiver, this._accum, value, i, length);
	        }
	        this._promise._popContext();
	
	        if (ret === errorObj) return this._reject(ret.e);
	
	        var maybePromise = tryConvertToPromise(ret, this._promise);
	        if (maybePromise instanceof Promise) {
	            maybePromise = maybePromise._target();
	            if (maybePromise._isPending()) {
	                valuesPhase[i] = 4;
	                return maybePromise._proxyPromiseArray(this, i);
	            } else if (maybePromise._isFulfilled()) {
	                ret = maybePromise._value();
	            } else {
	                return this._reject(maybePromise._reason());
	            }
	        }
	
	        this._reducingIndex = i + 1;
	        this._accum = ret;
	    }
	
	    this._resolve(isEach ? preservedValues : this._accum);
	};
	
	function reduce(promises, fn, initialValue, _each) {
	    if (typeof fn !== "function") return apiRejection("fn must be a function\u000a\u000a    See http://goo.gl/916lJJ\u000a");
	    var array = new ReductionPromiseArray(promises, fn, initialValue, _each);
	    return array.promise();
	}
	
	Promise.prototype.reduce = function (fn, initialValue) {
	    return reduce(this, fn, initialValue, null);
	};
	
	Promise.reduce = function (promises, fn, initialValue, _each) {
	    return reduce(promises, fn, initialValue, _each);
	};
	};
	
	},{"./async.js":2,"./util.js":38}],31:[function(_dereq_,module,exports){
	"use strict";
	var schedule;
	var util = _dereq_("./util");
	var noAsyncScheduler = function() {
	    throw new Error("No async scheduler available\u000a\u000a    See http://goo.gl/m3OTXk\u000a");
	};
	if (util.isNode && typeof MutationObserver === "undefined") {
	    var GlobalSetImmediate = global.setImmediate;
	    var ProcessNextTick = process.nextTick;
	    schedule = util.isRecentNode
	                ? function(fn) { GlobalSetImmediate.call(global, fn); }
	                : function(fn) { ProcessNextTick.call(process, fn); };
	} else if ((typeof MutationObserver !== "undefined") &&
	          !(typeof window !== "undefined" &&
	            window.navigator &&
	            window.navigator.standalone)) {
	    schedule = function(fn) {
	        var div = document.createElement("div");
	        var observer = new MutationObserver(fn);
	        observer.observe(div, {attributes: true});
	        return function() { div.classList.toggle("foo"); };
	    };
	    schedule.isStatic = true;
	} else if (typeof setImmediate !== "undefined") {
	    schedule = function (fn) {
	        setImmediate(fn);
	    };
	} else if (typeof setTimeout !== "undefined") {
	    schedule = function (fn) {
	        setTimeout(fn, 0);
	    };
	} else {
	    schedule = noAsyncScheduler;
	}
	module.exports = schedule;
	
	},{"./util":38}],32:[function(_dereq_,module,exports){
	"use strict";
	module.exports =
	    function(Promise, PromiseArray) {
	var PromiseInspection = Promise.PromiseInspection;
	var util = _dereq_("./util.js");
	
	function SettledPromiseArray(values) {
	    this.constructor$(values);
	}
	util.inherits(SettledPromiseArray, PromiseArray);
	
	SettledPromiseArray.prototype._promiseResolved = function (index, inspection) {
	    this._values[index] = inspection;
	    var totalResolved = ++this._totalResolved;
	    if (totalResolved >= this._length) {
	        this._resolve(this._values);
	    }
	};
	
	SettledPromiseArray.prototype._promiseFulfilled = function (value, index) {
	    var ret = new PromiseInspection();
	    ret._bitField = 268435456;
	    ret._settledValue = value;
	    this._promiseResolved(index, ret);
	};
	SettledPromiseArray.prototype._promiseRejected = function (reason, index) {
	    var ret = new PromiseInspection();
	    ret._bitField = 134217728;
	    ret._settledValue = reason;
	    this._promiseResolved(index, ret);
	};
	
	Promise.settle = function (promises) {
	    return new SettledPromiseArray(promises).promise();
	};
	
	Promise.prototype.settle = function () {
	    return new SettledPromiseArray(this).promise();
	};
	};
	
	},{"./util.js":38}],33:[function(_dereq_,module,exports){
	"use strict";
	module.exports =
	function(Promise, PromiseArray, apiRejection) {
	var util = _dereq_("./util.js");
	var RangeError = _dereq_("./errors.js").RangeError;
	var AggregateError = _dereq_("./errors.js").AggregateError;
	var isArray = util.isArray;
	
	
	function SomePromiseArray(values) {
	    this.constructor$(values);
	    this._howMany = 0;
	    this._unwrap = false;
	    this._initialized = false;
	}
	util.inherits(SomePromiseArray, PromiseArray);
	
	SomePromiseArray.prototype._init = function () {
	    if (!this._initialized) {
	        return;
	    }
	    if (this._howMany === 0) {
	        this._resolve([]);
	        return;
	    }
	    this._init$(undefined, -5);
	    var isArrayResolved = isArray(this._values);
	    if (!this._isResolved() &&
	        isArrayResolved &&
	        this._howMany > this._canPossiblyFulfill()) {
	        this._reject(this._getRangeError(this.length()));
	    }
	};
	
	SomePromiseArray.prototype.init = function () {
	    this._initialized = true;
	    this._init();
	};
	
	SomePromiseArray.prototype.setUnwrap = function () {
	    this._unwrap = true;
	};
	
	SomePromiseArray.prototype.howMany = function () {
	    return this._howMany;
	};
	
	SomePromiseArray.prototype.setHowMany = function (count) {
	    this._howMany = count;
	};
	
	SomePromiseArray.prototype._promiseFulfilled = function (value) {
	    this._addFulfilled(value);
	    if (this._fulfilled() === this.howMany()) {
	        this._values.length = this.howMany();
	        if (this.howMany() === 1 && this._unwrap) {
	            this._resolve(this._values[0]);
	        } else {
	            this._resolve(this._values);
	        }
	    }
	
	};
	SomePromiseArray.prototype._promiseRejected = function (reason) {
	    this._addRejected(reason);
	    if (this.howMany() > this._canPossiblyFulfill()) {
	        var e = new AggregateError();
	        for (var i = this.length(); i < this._values.length; ++i) {
	            e.push(this._values[i]);
	        }
	        this._reject(e);
	    }
	};
	
	SomePromiseArray.prototype._fulfilled = function () {
	    return this._totalResolved;
	};
	
	SomePromiseArray.prototype._rejected = function () {
	    return this._values.length - this.length();
	};
	
	SomePromiseArray.prototype._addRejected = function (reason) {
	    this._values.push(reason);
	};
	
	SomePromiseArray.prototype._addFulfilled = function (value) {
	    this._values[this._totalResolved++] = value;
	};
	
	SomePromiseArray.prototype._canPossiblyFulfill = function () {
	    return this.length() - this._rejected();
	};
	
	SomePromiseArray.prototype._getRangeError = function (count) {
	    var message = "Input array must contain at least " +
	            this._howMany + " items but contains only " + count + " items";
	    return new RangeError(message);
	};
	
	SomePromiseArray.prototype._resolveEmptyArray = function () {
	    this._reject(this._getRangeError(0));
	};
	
	function some(promises, howMany) {
	    if ((howMany | 0) !== howMany || howMany < 0) {
	        return apiRejection("expecting a positive integer\u000a\u000a    See http://goo.gl/1wAmHx\u000a");
	    }
	    var ret = new SomePromiseArray(promises);
	    var promise = ret.promise();
	    ret.setHowMany(howMany);
	    ret.init();
	    return promise;
	}
	
	Promise.some = function (promises, howMany) {
	    return some(promises, howMany);
	};
	
	Promise.prototype.some = function (howMany) {
	    return some(this, howMany);
	};
	
	Promise._SomePromiseArray = SomePromiseArray;
	};
	
	},{"./errors.js":13,"./util.js":38}],34:[function(_dereq_,module,exports){
	"use strict";
	module.exports = function(Promise) {
	function PromiseInspection(promise) {
	    if (promise !== undefined) {
	        promise = promise._target();
	        this._bitField = promise._bitField;
	        this._settledValue = promise._settledValue;
	    }
	    else {
	        this._bitField = 0;
	        this._settledValue = undefined;
	    }
	}
	
	PromiseInspection.prototype.value = function () {
	    if (!this.isFulfilled()) {
	        throw new TypeError("cannot get fulfillment value of a non-fulfilled promise\u000a\u000a    See http://goo.gl/hc1DLj\u000a");
	    }
	    return this._settledValue;
	};
	
	PromiseInspection.prototype.error =
	PromiseInspection.prototype.reason = function () {
	    if (!this.isRejected()) {
	        throw new TypeError("cannot get rejection reason of a non-rejected promise\u000a\u000a    See http://goo.gl/hPuiwB\u000a");
	    }
	    return this._settledValue;
	};
	
	PromiseInspection.prototype.isFulfilled =
	Promise.prototype._isFulfilled = function () {
	    return (this._bitField & 268435456) > 0;
	};
	
	PromiseInspection.prototype.isRejected =
	Promise.prototype._isRejected = function () {
	    return (this._bitField & 134217728) > 0;
	};
	
	PromiseInspection.prototype.isPending =
	Promise.prototype._isPending = function () {
	    return (this._bitField & 402653184) === 0;
	};
	
	PromiseInspection.prototype.isResolved =
	Promise.prototype._isResolved = function () {
	    return (this._bitField & 402653184) > 0;
	};
	
	Promise.prototype.isPending = function() {
	    return this._target()._isPending();
	};
	
	Promise.prototype.isRejected = function() {
	    return this._target()._isRejected();
	};
	
	Promise.prototype.isFulfilled = function() {
	    return this._target()._isFulfilled();
	};
	
	Promise.prototype.isResolved = function() {
	    return this._target()._isResolved();
	};
	
	Promise.prototype._value = function() {
	    return this._settledValue;
	};
	
	Promise.prototype._reason = function() {
	    this._unsetRejectionIsUnhandled();
	    return this._settledValue;
	};
	
	Promise.prototype.value = function() {
	    var target = this._target();
	    if (!target.isFulfilled()) {
	        throw new TypeError("cannot get fulfillment value of a non-fulfilled promise\u000a\u000a    See http://goo.gl/hc1DLj\u000a");
	    }
	    return target._settledValue;
	};
	
	Promise.prototype.reason = function() {
	    var target = this._target();
	    if (!target.isRejected()) {
	        throw new TypeError("cannot get rejection reason of a non-rejected promise\u000a\u000a    See http://goo.gl/hPuiwB\u000a");
	    }
	    target._unsetRejectionIsUnhandled();
	    return target._settledValue;
	};
	
	
	Promise.PromiseInspection = PromiseInspection;
	};
	
	},{}],35:[function(_dereq_,module,exports){
	"use strict";
	module.exports = function(Promise, INTERNAL) {
	var util = _dereq_("./util.js");
	var errorObj = util.errorObj;
	var isObject = util.isObject;
	
	function tryConvertToPromise(obj, context) {
	    if (isObject(obj)) {
	        if (obj instanceof Promise) {
	            return obj;
	        }
	        else if (isAnyBluebirdPromise(obj)) {
	            var ret = new Promise(INTERNAL);
	            obj._then(
	                ret._fulfillUnchecked,
	                ret._rejectUncheckedCheckError,
	                ret._progressUnchecked,
	                ret,
	                null
	            );
	            return ret;
	        }
	        var then = util.tryCatch(getThen)(obj);
	        if (then === errorObj) {
	            if (context) context._pushContext();
	            var ret = Promise.reject(then.e);
	            if (context) context._popContext();
	            return ret;
	        } else if (typeof then === "function") {
	            return doThenable(obj, then, context);
	        }
	    }
	    return obj;
	}
	
	function getThen(obj) {
	    return obj.then;
	}
	
	var hasProp = {}.hasOwnProperty;
	function isAnyBluebirdPromise(obj) {
	    return hasProp.call(obj, "_promise0");
	}
	
	function doThenable(x, then, context) {
	    var promise = new Promise(INTERNAL);
	    var ret = promise;
	    if (context) context._pushContext();
	    promise._captureStackTrace();
	    if (context) context._popContext();
	    var synchronous = true;
	    var result = util.tryCatch(then).call(x,
	                                        resolveFromThenable,
	                                        rejectFromThenable,
	                                        progressFromThenable);
	    synchronous = false;
	    if (promise && result === errorObj) {
	        promise._rejectCallback(result.e, true, true);
	        promise = null;
	    }
	
	    function resolveFromThenable(value) {
	        if (!promise) return;
	        promise._resolveCallback(value);
	        promise = null;
	    }
	
	    function rejectFromThenable(reason) {
	        if (!promise) return;
	        promise._rejectCallback(reason, synchronous, true);
	        promise = null;
	    }
	
	    function progressFromThenable(value) {
	        if (!promise) return;
	        if (typeof promise._progress === "function") {
	            promise._progress(value);
	        }
	    }
	    return ret;
	}
	
	return tryConvertToPromise;
	};
	
	},{"./util.js":38}],36:[function(_dereq_,module,exports){
	"use strict";
	module.exports = function(Promise, INTERNAL) {
	var util = _dereq_("./util.js");
	var TimeoutError = Promise.TimeoutError;
	
	var afterTimeout = function (promise, message) {
	    if (!promise.isPending()) return;
	    
	    var err;
	    if(!util.isPrimitive(message) && (message instanceof Error)) {
	        err = message;
	    } else {
	        if (typeof message !== "string") {
	            message = "operation timed out";
	        }
	        err = new TimeoutError(message);
	    }
	    util.markAsOriginatingFromRejection(err);
	    promise._attachExtraTrace(err);
	    promise._cancel(err);
	};
	
	var afterValue = function(value) { return delay(+this).thenReturn(value); };
	var delay = Promise.delay = function (value, ms) {
	    if (ms === undefined) {
	        ms = value;
	        value = undefined;
	        var ret = new Promise(INTERNAL);
	        setTimeout(function() { ret._fulfill(); }, ms);
	        return ret;
	    }
	    ms = +ms;
	    return Promise.resolve(value)._then(afterValue, null, null, ms, undefined);
	};
	
	Promise.prototype.delay = function (ms) {
	    return delay(this, ms);
	};
	
	function successClear(value) {
	    var handle = this;
	    if (handle instanceof Number) handle = +handle;
	    clearTimeout(handle);
	    return value;
	}
	
	function failureClear(reason) {
	    var handle = this;
	    if (handle instanceof Number) handle = +handle;
	    clearTimeout(handle);
	    throw reason;
	}
	
	Promise.prototype.timeout = function (ms, message) {
	    ms = +ms;
	    var ret = this.then().cancellable();
	    ret._cancellationParent = this;
	    var handle = setTimeout(function timeoutTimeout() {
	        afterTimeout(ret, message);
	    }, ms);
	    return ret._then(successClear, failureClear, undefined, handle, undefined);
	};
	
	};
	
	},{"./util.js":38}],37:[function(_dereq_,module,exports){
	"use strict";
	module.exports = function (Promise, apiRejection, tryConvertToPromise,
	    createContext) {
	    var TypeError = _dereq_("./errors.js").TypeError;
	    var inherits = _dereq_("./util.js").inherits;
	    var PromiseInspection = Promise.PromiseInspection;
	
	    function inspectionMapper(inspections) {
	        var len = inspections.length;
	        for (var i = 0; i < len; ++i) {
	            var inspection = inspections[i];
	            if (inspection.isRejected()) {
	                return Promise.reject(inspection.error());
	            }
	            inspections[i] = inspection._settledValue;
	        }
	        return inspections;
	    }
	
	    function thrower(e) {
	        setTimeout(function(){throw e;}, 0);
	    }
	
	    function castPreservingDisposable(thenable) {
	        var maybePromise = tryConvertToPromise(thenable);
	        if (maybePromise !== thenable &&
	            typeof thenable._isDisposable === "function" &&
	            typeof thenable._getDisposer === "function" &&
	            thenable._isDisposable()) {
	            maybePromise._setDisposable(thenable._getDisposer());
	        }
	        return maybePromise;
	    }
	    function dispose(resources, inspection) {
	        var i = 0;
	        var len = resources.length;
	        var ret = Promise.defer();
	        function iterator() {
	            if (i >= len) return ret.resolve();
	            var maybePromise = castPreservingDisposable(resources[i++]);
	            if (maybePromise instanceof Promise &&
	                maybePromise._isDisposable()) {
	                try {
	                    maybePromise = tryConvertToPromise(
	                        maybePromise._getDisposer().tryDispose(inspection),
	                        resources.promise);
	                } catch (e) {
	                    return thrower(e);
	                }
	                if (maybePromise instanceof Promise) {
	                    return maybePromise._then(iterator, thrower,
	                                              null, null, null);
	                }
	            }
	            iterator();
	        }
	        iterator();
	        return ret.promise;
	    }
	
	    function disposerSuccess(value) {
	        var inspection = new PromiseInspection();
	        inspection._settledValue = value;
	        inspection._bitField = 268435456;
	        return dispose(this, inspection).thenReturn(value);
	    }
	
	    function disposerFail(reason) {
	        var inspection = new PromiseInspection();
	        inspection._settledValue = reason;
	        inspection._bitField = 134217728;
	        return dispose(this, inspection).thenThrow(reason);
	    }
	
	    function Disposer(data, promise, context) {
	        this._data = data;
	        this._promise = promise;
	        this._context = context;
	    }
	
	    Disposer.prototype.data = function () {
	        return this._data;
	    };
	
	    Disposer.prototype.promise = function () {
	        return this._promise;
	    };
	
	    Disposer.prototype.resource = function () {
	        if (this.promise().isFulfilled()) {
	            return this.promise().value();
	        }
	        return null;
	    };
	
	    Disposer.prototype.tryDispose = function(inspection) {
	        var resource = this.resource();
	        var context = this._context;
	        if (context !== undefined) context._pushContext();
	        var ret = resource !== null
	            ? this.doDispose(resource, inspection) : null;
	        if (context !== undefined) context._popContext();
	        this._promise._unsetDisposable();
	        this._data = null;
	        return ret;
	    };
	
	    Disposer.isDisposer = function (d) {
	        return (d != null &&
	                typeof d.resource === "function" &&
	                typeof d.tryDispose === "function");
	    };
	
	    function FunctionDisposer(fn, promise, context) {
	        this.constructor$(fn, promise, context);
	    }
	    inherits(FunctionDisposer, Disposer);
	
	    FunctionDisposer.prototype.doDispose = function (resource, inspection) {
	        var fn = this.data();
	        return fn.call(resource, resource, inspection);
	    };
	
	    function maybeUnwrapDisposer(value) {
	        if (Disposer.isDisposer(value)) {
	            this.resources[this.index]._setDisposable(value);
	            return value.promise();
	        }
	        return value;
	    }
	
	    Promise.using = function () {
	        var len = arguments.length;
	        if (len < 2) return apiRejection(
	                        "you must pass at least 2 arguments to Promise.using");
	        var fn = arguments[len - 1];
	        if (typeof fn !== "function") return apiRejection("fn must be a function\u000a\u000a    See http://goo.gl/916lJJ\u000a");
	
	        var input;
	        var spreadArgs = true;
	        if (len === 2 && Array.isArray(arguments[0])) {
	            input = arguments[0];
	            len = input.length;
	            spreadArgs = false;
	        } else {
	            input = arguments;
	            len--;
	        }
	        var resources = new Array(len);
	        for (var i = 0; i < len; ++i) {
	            var resource = input[i];
	            if (Disposer.isDisposer(resource)) {
	                var disposer = resource;
	                resource = resource.promise();
	                resource._setDisposable(disposer);
	            } else {
	                var maybePromise = tryConvertToPromise(resource);
	                if (maybePromise instanceof Promise) {
	                    resource =
	                        maybePromise._then(maybeUnwrapDisposer, null, null, {
	                            resources: resources,
	                            index: i
	                    }, undefined);
	                }
	            }
	            resources[i] = resource;
	        }
	
	        var promise = Promise.settle(resources)
	            .then(inspectionMapper)
	            .then(function(vals) {
	                promise._pushContext();
	                var ret;
	                try {
	                    ret = spreadArgs
	                        ? fn.apply(undefined, vals) : fn.call(undefined,  vals);
	                } finally {
	                    promise._popContext();
	                }
	                return ret;
	            })
	            ._then(
	                disposerSuccess, disposerFail, undefined, resources, undefined);
	        resources.promise = promise;
	        return promise;
	    };
	
	    Promise.prototype._setDisposable = function (disposer) {
	        this._bitField = this._bitField | 262144;
	        this._disposer = disposer;
	    };
	
	    Promise.prototype._isDisposable = function () {
	        return (this._bitField & 262144) > 0;
	    };
	
	    Promise.prototype._getDisposer = function () {
	        return this._disposer;
	    };
	
	    Promise.prototype._unsetDisposable = function () {
	        this._bitField = this._bitField & (~262144);
	        this._disposer = undefined;
	    };
	
	    Promise.prototype.disposer = function (fn) {
	        if (typeof fn === "function") {
	            return new FunctionDisposer(fn, this, createContext());
	        }
	        throw new TypeError();
	    };
	
	};
	
	},{"./errors.js":13,"./util.js":38}],38:[function(_dereq_,module,exports){
	"use strict";
	var es5 = _dereq_("./es5.js");
	var canEvaluate = typeof navigator == "undefined";
	var haveGetters = (function(){
	    try {
	        var o = {};
	        es5.defineProperty(o, "f", {
	            get: function () {
	                return 3;
	            }
	        });
	        return o.f === 3;
	    }
	    catch (e) {
	        return false;
	    }
	
	})();
	
	var errorObj = {e: {}};
	var tryCatchTarget;
	function tryCatcher() {
	    try {
	        var target = tryCatchTarget;
	        tryCatchTarget = null;
	        return target.apply(this, arguments);
	    } catch (e) {
	        errorObj.e = e;
	        return errorObj;
	    }
	}
	function tryCatch(fn) {
	    tryCatchTarget = fn;
	    return tryCatcher;
	}
	
	var inherits = function(Child, Parent) {
	    var hasProp = {}.hasOwnProperty;
	
	    function T() {
	        this.constructor = Child;
	        this.constructor$ = Parent;
	        for (var propertyName in Parent.prototype) {
	            if (hasProp.call(Parent.prototype, propertyName) &&
	                propertyName.charAt(propertyName.length-1) !== "$"
	           ) {
	                this[propertyName + "$"] = Parent.prototype[propertyName];
	            }
	        }
	    }
	    T.prototype = Parent.prototype;
	    Child.prototype = new T();
	    return Child.prototype;
	};
	
	
	function isPrimitive(val) {
	    return val == null || val === true || val === false ||
	        typeof val === "string" || typeof val === "number";
	
	}
	
	function isObject(value) {
	    return !isPrimitive(value);
	}
	
	function maybeWrapAsError(maybeError) {
	    if (!isPrimitive(maybeError)) return maybeError;
	
	    return new Error(safeToString(maybeError));
	}
	
	function withAppended(target, appendee) {
	    var len = target.length;
	    var ret = new Array(len + 1);
	    var i;
	    for (i = 0; i < len; ++i) {
	        ret[i] = target[i];
	    }
	    ret[i] = appendee;
	    return ret;
	}
	
	function getDataPropertyOrDefault(obj, key, defaultValue) {
	    if (es5.isES5) {
	        var desc = Object.getOwnPropertyDescriptor(obj, key);
	
	        if (desc != null) {
	            return desc.get == null && desc.set == null
	                    ? desc.value
	                    : defaultValue;
	        }
	    } else {
	        return {}.hasOwnProperty.call(obj, key) ? obj[key] : undefined;
	    }
	}
	
	function notEnumerableProp(obj, name, value) {
	    if (isPrimitive(obj)) return obj;
	    var descriptor = {
	        value: value,
	        configurable: true,
	        enumerable: false,
	        writable: true
	    };
	    es5.defineProperty(obj, name, descriptor);
	    return obj;
	}
	
	function thrower(r) {
	    throw r;
	}
	
	var inheritedDataKeys = (function() {
	    var excludedPrototypes = [
	        Array.prototype,
	        Object.prototype,
	        Function.prototype
	    ];
	
	    var isExcludedProto = function(val) {
	        for (var i = 0; i < excludedPrototypes.length; ++i) {
	            if (excludedPrototypes[i] === val) {
	                return true;
	            }
	        }
	        return false;
	    };
	
	    if (es5.isES5) {
	        var getKeys = Object.getOwnPropertyNames;
	        return function(obj) {
	            var ret = [];
	            var visitedKeys = Object.create(null);
	            while (obj != null && !isExcludedProto(obj)) {
	                var keys;
	                try {
	                    keys = getKeys(obj);
	                } catch (e) {
	                    return ret;
	                }
	                for (var i = 0; i < keys.length; ++i) {
	                    var key = keys[i];
	                    if (visitedKeys[key]) continue;
	                    visitedKeys[key] = true;
	                    var desc = Object.getOwnPropertyDescriptor(obj, key);
	                    if (desc != null && desc.get == null && desc.set == null) {
	                        ret.push(key);
	                    }
	                }
	                obj = es5.getPrototypeOf(obj);
	            }
	            return ret;
	        };
	    } else {
	        var hasProp = {}.hasOwnProperty;
	        return function(obj) {
	            if (isExcludedProto(obj)) return [];
	            var ret = [];
	
	            /*jshint forin:false */
	            enumeration: for (var key in obj) {
	                if (hasProp.call(obj, key)) {
	                    ret.push(key);
	                } else {
	                    for (var i = 0; i < excludedPrototypes.length; ++i) {
	                        if (hasProp.call(excludedPrototypes[i], key)) {
	                            continue enumeration;
	                        }
	                    }
	                    ret.push(key);
	                }
	            }
	            return ret;
	        };
	    }
	
	})();
	
	var thisAssignmentPattern = /this\s*\.\s*\S+\s*=/;
	function isClass(fn) {
	    try {
	        if (typeof fn === "function") {
	            var keys = es5.names(fn.prototype);
	
	            var hasMethods = es5.isES5 && keys.length > 1;
	            var hasMethodsOtherThanConstructor = keys.length > 0 &&
	                !(keys.length === 1 && keys[0] === "constructor");
	            var hasThisAssignmentAndStaticMethods =
	                thisAssignmentPattern.test(fn + "") && es5.names(fn).length > 0;
	
	            if (hasMethods || hasMethodsOtherThanConstructor ||
	                hasThisAssignmentAndStaticMethods) {
	                return true;
	            }
	        }
	        return false;
	    } catch (e) {
	        return false;
	    }
	}
	
	function toFastProperties(obj) {
	    /*jshint -W027,-W055,-W031*/
	    function f() {}
	    f.prototype = obj;
	    var l = 8;
	    while (l--) new f();
	    return obj;
	    eval(obj);
	}
	
	var rident = /^[a-z$_][a-z$_0-9]*$/i;
	function isIdentifier(str) {
	    return rident.test(str);
	}
	
	function filledRange(count, prefix, suffix) {
	    var ret = new Array(count);
	    for(var i = 0; i < count; ++i) {
	        ret[i] = prefix + i + suffix;
	    }
	    return ret;
	}
	
	function safeToString(obj) {
	    try {
	        return obj + "";
	    } catch (e) {
	        return "[no string representation]";
	    }
	}
	
	function markAsOriginatingFromRejection(e) {
	    try {
	        notEnumerableProp(e, "isOperational", true);
	    }
	    catch(ignore) {}
	}
	
	function originatesFromRejection(e) {
	    if (e == null) return false;
	    return ((e instanceof Error["__BluebirdErrorTypes__"].OperationalError) ||
	        e["isOperational"] === true);
	}
	
	function canAttachTrace(obj) {
	    return obj instanceof Error && es5.propertyIsWritable(obj, "stack");
	}
	
	var ensureErrorObject = (function() {
	    if (!("stack" in new Error())) {
	        return function(value) {
	            if (canAttachTrace(value)) return value;
	            try {throw new Error(safeToString(value));}
	            catch(err) {return err;}
	        };
	    } else {
	        return function(value) {
	            if (canAttachTrace(value)) return value;
	            return new Error(safeToString(value));
	        };
	    }
	})();
	
	function classString(obj) {
	    return {}.toString.call(obj);
	}
	
	function copyDescriptors(from, to, filter) {
	    var keys = es5.names(from);
	    for (var i = 0; i < keys.length; ++i) {
	        var key = keys[i];
	        if (filter(key)) {
	            try {
	                es5.defineProperty(to, key, es5.getDescriptor(from, key));
	            } catch (ignore) {}
	        }
	    }
	}
	
	var ret = {
	    isClass: isClass,
	    isIdentifier: isIdentifier,
	    inheritedDataKeys: inheritedDataKeys,
	    getDataPropertyOrDefault: getDataPropertyOrDefault,
	    thrower: thrower,
	    isArray: es5.isArray,
	    haveGetters: haveGetters,
	    notEnumerableProp: notEnumerableProp,
	    isPrimitive: isPrimitive,
	    isObject: isObject,
	    canEvaluate: canEvaluate,
	    errorObj: errorObj,
	    tryCatch: tryCatch,
	    inherits: inherits,
	    withAppended: withAppended,
	    maybeWrapAsError: maybeWrapAsError,
	    toFastProperties: toFastProperties,
	    filledRange: filledRange,
	    toString: safeToString,
	    canAttachTrace: canAttachTrace,
	    ensureErrorObject: ensureErrorObject,
	    originatesFromRejection: originatesFromRejection,
	    markAsOriginatingFromRejection: markAsOriginatingFromRejection,
	    classString: classString,
	    copyDescriptors: copyDescriptors,
	    hasDevTools: typeof chrome !== "undefined" && chrome &&
	                 typeof chrome.loadTimes === "function",
	    isNode: typeof process !== "undefined" &&
	        classString(process).toLowerCase() === "[object process]"
	};
	ret.isRecentNode = ret.isNode && (function() {
	    var version = process.versions.node.split(".").map(Number);
	    return (version[0] === 0 && version[1] > 10) || (version[0] > 0);
	})();
	
	if (ret.isNode) ret.toFastProperties(process);
	
	try {throw new Error(); } catch (e) {ret.lastLineError = e;}
	module.exports = ret;
	
	},{"./es5.js":14}]},{},[4])(4)
	});                    ;if (typeof window !== 'undefined' && window !== null) {                               window.P = window.Promise;                                                     } else if (typeof self !== 'undefined' && self !== null) {                             self.P = self.Promise;                                                         }
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(47), (function() { return this; }()), __webpack_require__(272).setImmediate))

/***/ }),
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */
/***/ (function(module, exports) {

	'use strict'
	
	module.exports = collapse
	
	// `collapse(' \t\nbar \nbaz\t') // ' bar baz '`
	function collapse(value) {
	  return String(value).replace(/\s+/g, ' ')
	}


/***/ }),
/* 502 */,
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

	// check on default Array iterator
	var Iterators  = __webpack_require__(136)
	  , ITERATOR   = __webpack_require__(40)('iterator')
	  , ArrayProto = Array.prototype;
	
	module.exports = function(it){
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};

/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(106);
	module.exports = function(iterator, fn, value, entries){
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch(e){
	    var ret = iterator['return'];
	    if(ret !== undefined)anObject(ret.call(iterator));
	    throw e;
	  }
	};

/***/ }),
/* 505 */,
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

	var ITERATOR     = __webpack_require__(40)('iterator')
	  , SAFE_CLOSING = false;
	
	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function(){ SAFE_CLOSING = true; };
	  Array.from(riter, function(){ throw 2; });
	} catch(e){ /* empty */ }
	
	module.exports = function(exec, skipClosing){
	  if(!skipClosing && !SAFE_CLOSING)return false;
	  var safe = false;
	  try {
	    var arr  = [7]
	      , iter = arr[ITERATOR]();
	    iter.next = function(){ return {done: safe = true}; };
	    arr[ITERATOR] = function(){ return iter; };
	    exec(arr);
	  } catch(e){ /* empty */ }
	  return safe;
	};

/***/ }),
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(509)
	  , min       = Math.min;
	module.exports = function(it){
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};

/***/ }),
/* 511 */,
/* 512 */
/***/ (function(module, exports) {



/***/ }),
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Representation of a single EventEmitter function.
	 *
	 * @param {Function} fn Event handler to be called.
	 * @param {Mixed} context Context for function execution.
	 * @param {Boolean} once Only emit once
	 * @api private
	 */
	function EE(fn, context, once) {
	  this.fn = fn;
	  this.context = context;
	  this.once = once || false;
	}
	
	/**
	 * Minimal EventEmitter interface that is molded against the Node.js
	 * EventEmitter interface.
	 *
	 * @constructor
	 * @api public
	 */
	function EventEmitter() { /* Nothing to set */ }
	
	/**
	 * Holds the assigned EventEmitters by name.
	 *
	 * @type {Object}
	 * @private
	 */
	EventEmitter.prototype._events = undefined;
	
	/**
	 * Return a list of assigned event listeners.
	 *
	 * @param {String} event The events that should be listed.
	 * @returns {Array}
	 * @api public
	 */
	EventEmitter.prototype.listeners = function listeners(event) {
	  if (!this._events || !this._events[event]) return [];
	  if (this._events[event].fn) return [this._events[event].fn];
	
	  for (var i = 0, l = this._events[event].length, ee = new Array(l); i < l; i++) {
	    ee[i] = this._events[event][i].fn;
	  }
	
	  return ee;
	};
	
	/**
	 * Emit an event to all registered event listeners.
	 *
	 * @param {String} event The name of the event.
	 * @returns {Boolean} Indication if we've emitted an event.
	 * @api public
	 */
	EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
	  if (!this._events || !this._events[event]) return false;
	
	  var listeners = this._events[event]
	    , len = arguments.length
	    , args
	    , i;
	
	  if ('function' === typeof listeners.fn) {
	    if (listeners.once) this.removeListener(event, listeners.fn, true);
	
	    switch (len) {
	      case 1: return listeners.fn.call(listeners.context), true;
	      case 2: return listeners.fn.call(listeners.context, a1), true;
	      case 3: return listeners.fn.call(listeners.context, a1, a2), true;
	      case 4: return listeners.fn.call(listeners.context, a1, a2, a3), true;
	      case 5: return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
	      case 6: return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
	    }
	
	    for (i = 1, args = new Array(len -1); i < len; i++) {
	      args[i - 1] = arguments[i];
	    }
	
	    listeners.fn.apply(listeners.context, args);
	  } else {
	    var length = listeners.length
	      , j;
	
	    for (i = 0; i < length; i++) {
	      if (listeners[i].once) this.removeListener(event, listeners[i].fn, true);
	
	      switch (len) {
	        case 1: listeners[i].fn.call(listeners[i].context); break;
	        case 2: listeners[i].fn.call(listeners[i].context, a1); break;
	        case 3: listeners[i].fn.call(listeners[i].context, a1, a2); break;
	        default:
	          if (!args) for (j = 1, args = new Array(len -1); j < len; j++) {
	            args[j - 1] = arguments[j];
	          }
	
	          listeners[i].fn.apply(listeners[i].context, args);
	      }
	    }
	  }
	
	  return true;
	};
	
	/**
	 * Register a new EventListener for the given event.
	 *
	 * @param {String} event Name of the event.
	 * @param {Functon} fn Callback function.
	 * @param {Mixed} context The context of the function.
	 * @api public
	 */
	EventEmitter.prototype.on = function on(event, fn, context) {
	  var listener = new EE(fn, context || this);
	
	  if (!this._events) this._events = {};
	  if (!this._events[event]) this._events[event] = listener;
	  else {
	    if (!this._events[event].fn) this._events[event].push(listener);
	    else this._events[event] = [
	      this._events[event], listener
	    ];
	  }
	
	  return this;
	};
	
	/**
	 * Add an EventListener that's only called once.
	 *
	 * @param {String} event Name of the event.
	 * @param {Function} fn Callback function.
	 * @param {Mixed} context The context of the function.
	 * @api public
	 */
	EventEmitter.prototype.once = function once(event, fn, context) {
	  var listener = new EE(fn, context || this, true);
	
	  if (!this._events) this._events = {};
	  if (!this._events[event]) this._events[event] = listener;
	  else {
	    if (!this._events[event].fn) this._events[event].push(listener);
	    else this._events[event] = [
	      this._events[event], listener
	    ];
	  }
	
	  return this;
	};
	
	/**
	 * Remove event listeners.
	 *
	 * @param {String} event The event we want to remove.
	 * @param {Function} fn The listener that we need to find.
	 * @param {Boolean} once Only remove once listeners.
	 * @api public
	 */
	EventEmitter.prototype.removeListener = function removeListener(event, fn, once) {
	  if (!this._events || !this._events[event]) return this;
	
	  var listeners = this._events[event]
	    , events = [];
	
	  if (fn) {
	    if (listeners.fn && (listeners.fn !== fn || (once && !listeners.once))) {
	      events.push(listeners);
	    }
	    if (!listeners.fn) for (var i = 0, length = listeners.length; i < length; i++) {
	      if (listeners[i].fn !== fn || (once && !listeners[i].once)) {
	        events.push(listeners[i]);
	      }
	    }
	  }
	
	  //
	  // Reset the array, or remove it completely if we have no more listeners.
	  //
	  if (events.length) {
	    this._events[event] = events.length === 1 ? events[0] : events;
	  } else {
	    delete this._events[event];
	  }
	
	  return this;
	};
	
	/**
	 * Remove all listeners or only the listeners for the specified event.
	 *
	 * @param {String} event The event want to remove all listeners for.
	 * @api public
	 */
	EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
	  if (!this._events) return this;
	
	  if (event) delete this._events[event];
	  else this._events = {};
	
	  return this;
	};
	
	//
	// Alias methods names because people roll like that.
	//
	EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
	EventEmitter.prototype.addListener = EventEmitter.prototype.on;
	
	//
	// This function doesn't apply anymore.
	//
	EventEmitter.prototype.setMaxListeners = function setMaxListeners() {
	  return this;
	};
	
	//
	// Expose the module.
	//
	EventEmitter.EventEmitter = EventEmitter;
	EventEmitter.EventEmitter2 = EventEmitter;
	EventEmitter.EventEmitter3 = EventEmitter;
	
	//
	// Expose the module.
	//
	module.exports = EventEmitter;


/***/ }),
/* 523 */
/***/ (function(module, exports) {

	/**
	 * Extend an object with another.
	 *
	 * @param {Object, ...} src, ...
	 * @return {Object} merged
	 * @api private
	 */
	
	module.exports = function(src) {
	  var objs = [].slice.call(arguments, 1), obj;
	
	  for (var i = 0, len = objs.length; i < len; i++) {
	    obj = objs[i];
	    for (var prop in obj) {
	      src[prop] = obj[prop];
	    }
	  }
	
	  return src;
	}


/***/ }),
/* 524 */
/***/ (function(module, exports) {

	'use strict';
	
	var hasOwn = Object.prototype.hasOwnProperty;
	var toStr = Object.prototype.toString;
	var defineProperty = Object.defineProperty;
	var gOPD = Object.getOwnPropertyDescriptor;
	
	var isArray = function isArray(arr) {
		if (typeof Array.isArray === 'function') {
			return Array.isArray(arr);
		}
	
		return toStr.call(arr) === '[object Array]';
	};
	
	var isPlainObject = function isPlainObject(obj) {
		if (!obj || toStr.call(obj) !== '[object Object]') {
			return false;
		}
	
		var hasOwnConstructor = hasOwn.call(obj, 'constructor');
		var hasIsPrototypeOf = obj.constructor && obj.constructor.prototype && hasOwn.call(obj.constructor.prototype, 'isPrototypeOf');
		// Not own constructor property must be Object
		if (obj.constructor && !hasOwnConstructor && !hasIsPrototypeOf) {
			return false;
		}
	
		// Own properties are enumerated firstly, so to speed up,
		// if last one is own, then all properties are own.
		var key;
		for (key in obj) { /**/ }
	
		return typeof key === 'undefined' || hasOwn.call(obj, key);
	};
	
	// If name is '__proto__', and Object.defineProperty is available, define __proto__ as an own property on target
	var setProperty = function setProperty(target, options) {
		if (defineProperty && options.name === '__proto__') {
			defineProperty(target, options.name, {
				enumerable: true,
				configurable: true,
				value: options.newValue,
				writable: true
			});
		} else {
			target[options.name] = options.newValue;
		}
	};
	
	// Return undefined instead of __proto__ if '__proto__' is not an own property
	var getProperty = function getProperty(obj, name) {
		if (name === '__proto__') {
			if (!hasOwn.call(obj, name)) {
				return void 0;
			} else if (gOPD) {
				// In early versions of node, obj['__proto__'] is buggy when obj has
				// __proto__ as an own property. Object.getOwnPropertyDescriptor() works.
				return gOPD(obj, name).value;
			}
		}
	
		return obj[name];
	};
	
	module.exports = function extend() {
		var options, name, src, copy, copyIsArray, clone;
		var target = arguments[0];
		var i = 1;
		var length = arguments.length;
		var deep = false;
	
		// Handle a deep copy situation
		if (typeof target === 'boolean') {
			deep = target;
			target = arguments[1] || {};
			// skip the boolean and the target
			i = 2;
		}
		if (target == null || (typeof target !== 'object' && typeof target !== 'function')) {
			target = {};
		}
	
		for (; i < length; ++i) {
			options = arguments[i];
			// Only deal with non-null/undefined values
			if (options != null) {
				// Extend the base object
				for (name in options) {
					src = getProperty(target, name);
					copy = getProperty(options, name);
	
					// Prevent never-ending loop
					if (target !== copy) {
						// Recurse if we're merging plain objects or arrays
						if (deep && copy && (isPlainObject(copy) || (copyIsArray = isArray(copy)))) {
							if (copyIsArray) {
								copyIsArray = false;
								clone = src && isArray(src) ? src : [];
							} else {
								clone = src && isPlainObject(src) ? src : {};
							}
	
							// Never move original objects, clone them
							setProperty(target, { name: name, newValue: extend(deep, clone, copy) });
	
						// Don't bring in undefined values
						} else if (typeof copy !== 'undefined') {
							setProperty(target, { name: name, newValue: copy });
						}
					}
				}
			}
		}
	
		// Return the modified object
		return target;
	};


/***/ }),
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, global) {/*! http://mths.be/he v0.5.0 by @mathias | MIT license */
	;(function(root) {
	
		// Detect free variables `exports`.
		var freeExports = typeof exports == 'object' && exports;
	
		// Detect free variable `module`.
		var freeModule = typeof module == 'object' && module &&
			module.exports == freeExports && module;
	
		// Detect free variable `global`, from Node.js or Browserified code,
		// and use it as `root`.
		var freeGlobal = typeof global == 'object' && global;
		if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal) {
			root = freeGlobal;
		}
	
		/*--------------------------------------------------------------------------*/
	
		// All astral symbols.
		var regexAstralSymbols = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g;
		// All ASCII symbols (not just printable ASCII) except those listed in the
		// first column of the overrides table.
		// http://whatwg.org/html/tokenization.html#table-charref-overrides
		var regexAsciiWhitelist = /[\x01-\x7F]/g;
		// All BMP symbols that are not ASCII newlines, printable ASCII symbols, or
		// code points listed in the first column of the overrides table on
		// http://whatwg.org/html/tokenization.html#table-charref-overrides.
		var regexBmpWhitelist = /[\x01-\t\x0B\f\x0E-\x1F\x7F\x81\x8D\x8F\x90\x9D\xA0-\uFFFF]/g;
	
		var regexEncodeNonAscii = /<\u20D2|=\u20E5|>\u20D2|\u205F\u200A|\u219D\u0338|\u2202\u0338|\u2220\u20D2|\u2229\uFE00|\u222A\uFE00|\u223C\u20D2|\u223D\u0331|\u223E\u0333|\u2242\u0338|\u224B\u0338|\u224D\u20D2|\u224E\u0338|\u224F\u0338|\u2250\u0338|\u2261\u20E5|\u2264\u20D2|\u2265\u20D2|\u2266\u0338|\u2267\u0338|\u2268\uFE00|\u2269\uFE00|\u226A\u0338|\u226A\u20D2|\u226B\u0338|\u226B\u20D2|\u227F\u0338|\u2282\u20D2|\u2283\u20D2|\u228A\uFE00|\u228B\uFE00|\u228F\u0338|\u2290\u0338|\u2293\uFE00|\u2294\uFE00|\u22B4\u20D2|\u22B5\u20D2|\u22D8\u0338|\u22D9\u0338|\u22DA\uFE00|\u22DB\uFE00|\u22F5\u0338|\u22F9\u0338|\u2933\u0338|\u29CF\u0338|\u29D0\u0338|\u2A6D\u0338|\u2A70\u0338|\u2A7D\u0338|\u2A7E\u0338|\u2AA1\u0338|\u2AA2\u0338|\u2AAC\uFE00|\u2AAD\uFE00|\u2AAF\u0338|\u2AB0\u0338|\u2AC5\u0338|\u2AC6\u0338|\u2ACB\uFE00|\u2ACC\uFE00|\u2AFD\u20E5|[\xA0-\u0113\u0116-\u0122\u0124-\u012B\u012E-\u014D\u0150-\u017E\u0192\u01B5\u01F5\u0237\u02C6\u02C7\u02D8-\u02DD\u0311\u0391-\u03A1\u03A3-\u03A9\u03B1-\u03C9\u03D1\u03D2\u03D5\u03D6\u03DC\u03DD\u03F0\u03F1\u03F5\u03F6\u0401-\u040C\u040E-\u044F\u0451-\u045C\u045E\u045F\u2002-\u2005\u2007-\u2010\u2013-\u2016\u2018-\u201A\u201C-\u201E\u2020-\u2022\u2025\u2026\u2030-\u2035\u2039\u203A\u203E\u2041\u2043\u2044\u204F\u2057\u205F-\u2063\u20AC\u20DB\u20DC\u2102\u2105\u210A-\u2113\u2115-\u211E\u2122\u2124\u2127-\u2129\u212C\u212D\u212F-\u2131\u2133-\u2138\u2145-\u2148\u2153-\u215E\u2190-\u219B\u219D-\u21A7\u21A9-\u21AE\u21B0-\u21B3\u21B5-\u21B7\u21BA-\u21DB\u21DD\u21E4\u21E5\u21F5\u21FD-\u2205\u2207-\u2209\u220B\u220C\u220F-\u2214\u2216-\u2218\u221A\u221D-\u2238\u223A-\u2257\u2259\u225A\u225C\u225F-\u2262\u2264-\u228B\u228D-\u229B\u229D-\u22A5\u22A7-\u22B0\u22B2-\u22BB\u22BD-\u22DB\u22DE-\u22E3\u22E6-\u22F7\u22F9-\u22FE\u2305\u2306\u2308-\u2310\u2312\u2313\u2315\u2316\u231C-\u231F\u2322\u2323\u232D\u232E\u2336\u233D\u233F\u237C\u23B0\u23B1\u23B4-\u23B6\u23DC-\u23DF\u23E2\u23E7\u2423\u24C8\u2500\u2502\u250C\u2510\u2514\u2518\u251C\u2524\u252C\u2534\u253C\u2550-\u256C\u2580\u2584\u2588\u2591-\u2593\u25A1\u25AA\u25AB\u25AD\u25AE\u25B1\u25B3-\u25B5\u25B8\u25B9\u25BD-\u25BF\u25C2\u25C3\u25CA\u25CB\u25EC\u25EF\u25F8-\u25FC\u2605\u2606\u260E\u2640\u2642\u2660\u2663\u2665\u2666\u266A\u266D-\u266F\u2713\u2717\u2720\u2736\u2758\u2772\u2773\u27C8\u27C9\u27E6-\u27ED\u27F5-\u27FA\u27FC\u27FF\u2902-\u2905\u290C-\u2913\u2916\u2919-\u2920\u2923-\u292A\u2933\u2935-\u2939\u293C\u293D\u2945\u2948-\u294B\u294E-\u2976\u2978\u2979\u297B-\u297F\u2985\u2986\u298B-\u2996\u299A\u299C\u299D\u29A4-\u29B7\u29B9\u29BB\u29BC\u29BE-\u29C5\u29C9\u29CD-\u29D0\u29DC-\u29DE\u29E3-\u29E5\u29EB\u29F4\u29F6\u2A00-\u2A02\u2A04\u2A06\u2A0C\u2A0D\u2A10-\u2A17\u2A22-\u2A27\u2A29\u2A2A\u2A2D-\u2A31\u2A33-\u2A3C\u2A3F\u2A40\u2A42-\u2A4D\u2A50\u2A53-\u2A58\u2A5A-\u2A5D\u2A5F\u2A66\u2A6A\u2A6D-\u2A75\u2A77-\u2A9A\u2A9D-\u2AA2\u2AA4-\u2AB0\u2AB3-\u2AC8\u2ACB\u2ACC\u2ACF-\u2ADB\u2AE4\u2AE6-\u2AE9\u2AEB-\u2AF3\u2AFD\uFB00-\uFB04]|\uD835[\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDCCF\uDD04\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDD6B]/g;
		var encodeMap = {'\xC1':'Aacute','\xE1':'aacute','\u0102':'Abreve','\u0103':'abreve','\u223E':'ac','\u223F':'acd','\u223E\u0333':'acE','\xC2':'Acirc','\xE2':'acirc','\xB4':'acute','\u0410':'Acy','\u0430':'acy','\xC6':'AElig','\xE6':'aelig','\u2061':'af','\uD835\uDD04':'Afr','\uD835\uDD1E':'afr','\xC0':'Agrave','\xE0':'agrave','\u2135':'aleph','\u0391':'Alpha','\u03B1':'alpha','\u0100':'Amacr','\u0101':'amacr','\u2A3F':'amalg','&':'amp','\u2A55':'andand','\u2A53':'And','\u2227':'and','\u2A5C':'andd','\u2A58':'andslope','\u2A5A':'andv','\u2220':'ang','\u29A4':'ange','\u29A8':'angmsdaa','\u29A9':'angmsdab','\u29AA':'angmsdac','\u29AB':'angmsdad','\u29AC':'angmsdae','\u29AD':'angmsdaf','\u29AE':'angmsdag','\u29AF':'angmsdah','\u2221':'angmsd','\u221F':'angrt','\u22BE':'angrtvb','\u299D':'angrtvbd','\u2222':'angsph','\xC5':'angst','\u237C':'angzarr','\u0104':'Aogon','\u0105':'aogon','\uD835\uDD38':'Aopf','\uD835\uDD52':'aopf','\u2A6F':'apacir','\u2248':'ap','\u2A70':'apE','\u224A':'ape','\u224B':'apid','\'':'apos','\xE5':'aring','\uD835\uDC9C':'Ascr','\uD835\uDCB6':'ascr','\u2254':'colone','*':'ast','\u224D':'CupCap','\xC3':'Atilde','\xE3':'atilde','\xC4':'Auml','\xE4':'auml','\u2233':'awconint','\u2A11':'awint','\u224C':'bcong','\u03F6':'bepsi','\u2035':'bprime','\u223D':'bsim','\u22CD':'bsime','\u2216':'setmn','\u2AE7':'Barv','\u22BD':'barvee','\u2305':'barwed','\u2306':'Barwed','\u23B5':'bbrk','\u23B6':'bbrktbrk','\u0411':'Bcy','\u0431':'bcy','\u201E':'bdquo','\u2235':'becaus','\u29B0':'bemptyv','\u212C':'Bscr','\u0392':'Beta','\u03B2':'beta','\u2136':'beth','\u226C':'twixt','\uD835\uDD05':'Bfr','\uD835\uDD1F':'bfr','\u22C2':'xcap','\u25EF':'xcirc','\u22C3':'xcup','\u2A00':'xodot','\u2A01':'xoplus','\u2A02':'xotime','\u2A06':'xsqcup','\u2605':'starf','\u25BD':'xdtri','\u25B3':'xutri','\u2A04':'xuplus','\u22C1':'Vee','\u22C0':'Wedge','\u290D':'rbarr','\u29EB':'lozf','\u25AA':'squf','\u25B4':'utrif','\u25BE':'dtrif','\u25C2':'ltrif','\u25B8':'rtrif','\u2423':'blank','\u2592':'blk12','\u2591':'blk14','\u2593':'blk34','\u2588':'block','=\u20E5':'bne','\u2261\u20E5':'bnequiv','\u2AED':'bNot','\u2310':'bnot','\uD835\uDD39':'Bopf','\uD835\uDD53':'bopf','\u22A5':'bot','\u22C8':'bowtie','\u29C9':'boxbox','\u2510':'boxdl','\u2555':'boxdL','\u2556':'boxDl','\u2557':'boxDL','\u250C':'boxdr','\u2552':'boxdR','\u2553':'boxDr','\u2554':'boxDR','\u2500':'boxh','\u2550':'boxH','\u252C':'boxhd','\u2564':'boxHd','\u2565':'boxhD','\u2566':'boxHD','\u2534':'boxhu','\u2567':'boxHu','\u2568':'boxhU','\u2569':'boxHU','\u229F':'minusb','\u229E':'plusb','\u22A0':'timesb','\u2518':'boxul','\u255B':'boxuL','\u255C':'boxUl','\u255D':'boxUL','\u2514':'boxur','\u2558':'boxuR','\u2559':'boxUr','\u255A':'boxUR','\u2502':'boxv','\u2551':'boxV','\u253C':'boxvh','\u256A':'boxvH','\u256B':'boxVh','\u256C':'boxVH','\u2524':'boxvl','\u2561':'boxvL','\u2562':'boxVl','\u2563':'boxVL','\u251C':'boxvr','\u255E':'boxvR','\u255F':'boxVr','\u2560':'boxVR','\u02D8':'breve','\xA6':'brvbar','\uD835\uDCB7':'bscr','\u204F':'bsemi','\u29C5':'bsolb','\\':'bsol','\u27C8':'bsolhsub','\u2022':'bull','\u224E':'bump','\u2AAE':'bumpE','\u224F':'bumpe','\u0106':'Cacute','\u0107':'cacute','\u2A44':'capand','\u2A49':'capbrcup','\u2A4B':'capcap','\u2229':'cap','\u22D2':'Cap','\u2A47':'capcup','\u2A40':'capdot','\u2145':'DD','\u2229\uFE00':'caps','\u2041':'caret','\u02C7':'caron','\u212D':'Cfr','\u2A4D':'ccaps','\u010C':'Ccaron','\u010D':'ccaron','\xC7':'Ccedil','\xE7':'ccedil','\u0108':'Ccirc','\u0109':'ccirc','\u2230':'Cconint','\u2A4C':'ccups','\u2A50':'ccupssm','\u010A':'Cdot','\u010B':'cdot','\xB8':'cedil','\u29B2':'cemptyv','\xA2':'cent','\xB7':'middot','\uD835\uDD20':'cfr','\u0427':'CHcy','\u0447':'chcy','\u2713':'check','\u03A7':'Chi','\u03C7':'chi','\u02C6':'circ','\u2257':'cire','\u21BA':'olarr','\u21BB':'orarr','\u229B':'oast','\u229A':'ocir','\u229D':'odash','\u2299':'odot','\xAE':'reg','\u24C8':'oS','\u2296':'ominus','\u2295':'oplus','\u2297':'otimes','\u25CB':'cir','\u29C3':'cirE','\u2A10':'cirfnint','\u2AEF':'cirmid','\u29C2':'cirscir','\u2232':'cwconint','\u201D':'rdquo','\u2019':'rsquo','\u2663':'clubs',':':'colon','\u2237':'Colon','\u2A74':'Colone',',':'comma','@':'commat','\u2201':'comp','\u2218':'compfn','\u2102':'Copf','\u2245':'cong','\u2A6D':'congdot','\u2261':'equiv','\u222E':'oint','\u222F':'Conint','\uD835\uDD54':'copf','\u2210':'coprod','\xA9':'copy','\u2117':'copysr','\u21B5':'crarr','\u2717':'cross','\u2A2F':'Cross','\uD835\uDC9E':'Cscr','\uD835\uDCB8':'cscr','\u2ACF':'csub','\u2AD1':'csube','\u2AD0':'csup','\u2AD2':'csupe','\u22EF':'ctdot','\u2938':'cudarrl','\u2935':'cudarrr','\u22DE':'cuepr','\u22DF':'cuesc','\u21B6':'cularr','\u293D':'cularrp','\u2A48':'cupbrcap','\u2A46':'cupcap','\u222A':'cup','\u22D3':'Cup','\u2A4A':'cupcup','\u228D':'cupdot','\u2A45':'cupor','\u222A\uFE00':'cups','\u21B7':'curarr','\u293C':'curarrm','\u22CE':'cuvee','\u22CF':'cuwed','\xA4':'curren','\u2231':'cwint','\u232D':'cylcty','\u2020':'dagger','\u2021':'Dagger','\u2138':'daleth','\u2193':'darr','\u21A1':'Darr','\u21D3':'dArr','\u2010':'dash','\u2AE4':'Dashv','\u22A3':'dashv','\u290F':'rBarr','\u02DD':'dblac','\u010E':'Dcaron','\u010F':'dcaron','\u0414':'Dcy','\u0434':'dcy','\u21CA':'ddarr','\u2146':'dd','\u2911':'DDotrahd','\u2A77':'eDDot','\xB0':'deg','\u2207':'Del','\u0394':'Delta','\u03B4':'delta','\u29B1':'demptyv','\u297F':'dfisht','\uD835\uDD07':'Dfr','\uD835\uDD21':'dfr','\u2965':'dHar','\u21C3':'dharl','\u21C2':'dharr','\u02D9':'dot','`':'grave','\u02DC':'tilde','\u22C4':'diam','\u2666':'diams','\xA8':'die','\u03DD':'gammad','\u22F2':'disin','\xF7':'div','\u22C7':'divonx','\u0402':'DJcy','\u0452':'djcy','\u231E':'dlcorn','\u230D':'dlcrop','$':'dollar','\uD835\uDD3B':'Dopf','\uD835\uDD55':'dopf','\u20DC':'DotDot','\u2250':'doteq','\u2251':'eDot','\u2238':'minusd','\u2214':'plusdo','\u22A1':'sdotb','\u21D0':'lArr','\u21D4':'iff','\u27F8':'xlArr','\u27FA':'xhArr','\u27F9':'xrArr','\u21D2':'rArr','\u22A8':'vDash','\u21D1':'uArr','\u21D5':'vArr','\u2225':'par','\u2913':'DownArrowBar','\u21F5':'duarr','\u0311':'DownBreve','\u2950':'DownLeftRightVector','\u295E':'DownLeftTeeVector','\u2956':'DownLeftVectorBar','\u21BD':'lhard','\u295F':'DownRightTeeVector','\u2957':'DownRightVectorBar','\u21C1':'rhard','\u21A7':'mapstodown','\u22A4':'top','\u2910':'RBarr','\u231F':'drcorn','\u230C':'drcrop','\uD835\uDC9F':'Dscr','\uD835\uDCB9':'dscr','\u0405':'DScy','\u0455':'dscy','\u29F6':'dsol','\u0110':'Dstrok','\u0111':'dstrok','\u22F1':'dtdot','\u25BF':'dtri','\u296F':'duhar','\u29A6':'dwangle','\u040F':'DZcy','\u045F':'dzcy','\u27FF':'dzigrarr','\xC9':'Eacute','\xE9':'eacute','\u2A6E':'easter','\u011A':'Ecaron','\u011B':'ecaron','\xCA':'Ecirc','\xEA':'ecirc','\u2256':'ecir','\u2255':'ecolon','\u042D':'Ecy','\u044D':'ecy','\u0116':'Edot','\u0117':'edot','\u2147':'ee','\u2252':'efDot','\uD835\uDD08':'Efr','\uD835\uDD22':'efr','\u2A9A':'eg','\xC8':'Egrave','\xE8':'egrave','\u2A96':'egs','\u2A98':'egsdot','\u2A99':'el','\u2208':'in','\u23E7':'elinters','\u2113':'ell','\u2A95':'els','\u2A97':'elsdot','\u0112':'Emacr','\u0113':'emacr','\u2205':'empty','\u25FB':'EmptySmallSquare','\u25AB':'EmptyVerySmallSquare','\u2004':'emsp13','\u2005':'emsp14','\u2003':'emsp','\u014A':'ENG','\u014B':'eng','\u2002':'ensp','\u0118':'Eogon','\u0119':'eogon','\uD835\uDD3C':'Eopf','\uD835\uDD56':'eopf','\u22D5':'epar','\u29E3':'eparsl','\u2A71':'eplus','\u03B5':'epsi','\u0395':'Epsilon','\u03F5':'epsiv','\u2242':'esim','\u2A75':'Equal','=':'equals','\u225F':'equest','\u21CC':'rlhar','\u2A78':'equivDD','\u29E5':'eqvparsl','\u2971':'erarr','\u2253':'erDot','\u212F':'escr','\u2130':'Escr','\u2A73':'Esim','\u0397':'Eta','\u03B7':'eta','\xD0':'ETH','\xF0':'eth','\xCB':'Euml','\xEB':'euml','\u20AC':'euro','!':'excl','\u2203':'exist','\u0424':'Fcy','\u0444':'fcy','\u2640':'female','\uFB03':'ffilig','\uFB00':'fflig','\uFB04':'ffllig','\uD835\uDD09':'Ffr','\uD835\uDD23':'ffr','\uFB01':'filig','\u25FC':'FilledSmallSquare','fj':'fjlig','\u266D':'flat','\uFB02':'fllig','\u25B1':'fltns','\u0192':'fnof','\uD835\uDD3D':'Fopf','\uD835\uDD57':'fopf','\u2200':'forall','\u22D4':'fork','\u2AD9':'forkv','\u2131':'Fscr','\u2A0D':'fpartint','\xBD':'half','\u2153':'frac13','\xBC':'frac14','\u2155':'frac15','\u2159':'frac16','\u215B':'frac18','\u2154':'frac23','\u2156':'frac25','\xBE':'frac34','\u2157':'frac35','\u215C':'frac38','\u2158':'frac45','\u215A':'frac56','\u215D':'frac58','\u215E':'frac78','\u2044':'frasl','\u2322':'frown','\uD835\uDCBB':'fscr','\u01F5':'gacute','\u0393':'Gamma','\u03B3':'gamma','\u03DC':'Gammad','\u2A86':'gap','\u011E':'Gbreve','\u011F':'gbreve','\u0122':'Gcedil','\u011C':'Gcirc','\u011D':'gcirc','\u0413':'Gcy','\u0433':'gcy','\u0120':'Gdot','\u0121':'gdot','\u2265':'ge','\u2267':'gE','\u2A8C':'gEl','\u22DB':'gel','\u2A7E':'ges','\u2AA9':'gescc','\u2A80':'gesdot','\u2A82':'gesdoto','\u2A84':'gesdotol','\u22DB\uFE00':'gesl','\u2A94':'gesles','\uD835\uDD0A':'Gfr','\uD835\uDD24':'gfr','\u226B':'gg','\u22D9':'Gg','\u2137':'gimel','\u0403':'GJcy','\u0453':'gjcy','\u2AA5':'gla','\u2277':'gl','\u2A92':'glE','\u2AA4':'glj','\u2A8A':'gnap','\u2A88':'gne','\u2269':'gnE','\u22E7':'gnsim','\uD835\uDD3E':'Gopf','\uD835\uDD58':'gopf','\u2AA2':'GreaterGreater','\u2273':'gsim','\uD835\uDCA2':'Gscr','\u210A':'gscr','\u2A8E':'gsime','\u2A90':'gsiml','\u2AA7':'gtcc','\u2A7A':'gtcir','>':'gt','\u22D7':'gtdot','\u2995':'gtlPar','\u2A7C':'gtquest','\u2978':'gtrarr','\u2269\uFE00':'gvnE','\u200A':'hairsp','\u210B':'Hscr','\u042A':'HARDcy','\u044A':'hardcy','\u2948':'harrcir','\u2194':'harr','\u21AD':'harrw','^':'Hat','\u210F':'hbar','\u0124':'Hcirc','\u0125':'hcirc','\u2665':'hearts','\u2026':'mldr','\u22B9':'hercon','\uD835\uDD25':'hfr','\u210C':'Hfr','\u2925':'searhk','\u2926':'swarhk','\u21FF':'hoarr','\u223B':'homtht','\u21A9':'larrhk','\u21AA':'rarrhk','\uD835\uDD59':'hopf','\u210D':'Hopf','\u2015':'horbar','\uD835\uDCBD':'hscr','\u0126':'Hstrok','\u0127':'hstrok','\u2043':'hybull','\xCD':'Iacute','\xED':'iacute','\u2063':'ic','\xCE':'Icirc','\xEE':'icirc','\u0418':'Icy','\u0438':'icy','\u0130':'Idot','\u0415':'IEcy','\u0435':'iecy','\xA1':'iexcl','\uD835\uDD26':'ifr','\u2111':'Im','\xCC':'Igrave','\xEC':'igrave','\u2148':'ii','\u2A0C':'qint','\u222D':'tint','\u29DC':'iinfin','\u2129':'iiota','\u0132':'IJlig','\u0133':'ijlig','\u012A':'Imacr','\u012B':'imacr','\u2110':'Iscr','\u0131':'imath','\u22B7':'imof','\u01B5':'imped','\u2105':'incare','\u221E':'infin','\u29DD':'infintie','\u22BA':'intcal','\u222B':'int','\u222C':'Int','\u2124':'Zopf','\u2A17':'intlarhk','\u2A3C':'iprod','\u2062':'it','\u0401':'IOcy','\u0451':'iocy','\u012E':'Iogon','\u012F':'iogon','\uD835\uDD40':'Iopf','\uD835\uDD5A':'iopf','\u0399':'Iota','\u03B9':'iota','\xBF':'iquest','\uD835\uDCBE':'iscr','\u22F5':'isindot','\u22F9':'isinE','\u22F4':'isins','\u22F3':'isinsv','\u0128':'Itilde','\u0129':'itilde','\u0406':'Iukcy','\u0456':'iukcy','\xCF':'Iuml','\xEF':'iuml','\u0134':'Jcirc','\u0135':'jcirc','\u0419':'Jcy','\u0439':'jcy','\uD835\uDD0D':'Jfr','\uD835\uDD27':'jfr','\u0237':'jmath','\uD835\uDD41':'Jopf','\uD835\uDD5B':'jopf','\uD835\uDCA5':'Jscr','\uD835\uDCBF':'jscr','\u0408':'Jsercy','\u0458':'jsercy','\u0404':'Jukcy','\u0454':'jukcy','\u039A':'Kappa','\u03BA':'kappa','\u03F0':'kappav','\u0136':'Kcedil','\u0137':'kcedil','\u041A':'Kcy','\u043A':'kcy','\uD835\uDD0E':'Kfr','\uD835\uDD28':'kfr','\u0138':'kgreen','\u0425':'KHcy','\u0445':'khcy','\u040C':'KJcy','\u045C':'kjcy','\uD835\uDD42':'Kopf','\uD835\uDD5C':'kopf','\uD835\uDCA6':'Kscr','\uD835\uDCC0':'kscr','\u21DA':'lAarr','\u0139':'Lacute','\u013A':'lacute','\u29B4':'laemptyv','\u2112':'Lscr','\u039B':'Lambda','\u03BB':'lambda','\u27E8':'lang','\u27EA':'Lang','\u2991':'langd','\u2A85':'lap','\xAB':'laquo','\u21E4':'larrb','\u291F':'larrbfs','\u2190':'larr','\u219E':'Larr','\u291D':'larrfs','\u21AB':'larrlp','\u2939':'larrpl','\u2973':'larrsim','\u21A2':'larrtl','\u2919':'latail','\u291B':'lAtail','\u2AAB':'lat','\u2AAD':'late','\u2AAD\uFE00':'lates','\u290C':'lbarr','\u290E':'lBarr','\u2772':'lbbrk','{':'lcub','[':'lsqb','\u298B':'lbrke','\u298F':'lbrksld','\u298D':'lbrkslu','\u013D':'Lcaron','\u013E':'lcaron','\u013B':'Lcedil','\u013C':'lcedil','\u2308':'lceil','\u041B':'Lcy','\u043B':'lcy','\u2936':'ldca','\u201C':'ldquo','\u2967':'ldrdhar','\u294B':'ldrushar','\u21B2':'ldsh','\u2264':'le','\u2266':'lE','\u21C6':'lrarr','\u27E6':'lobrk','\u2961':'LeftDownTeeVector','\u2959':'LeftDownVectorBar','\u230A':'lfloor','\u21BC':'lharu','\u21C7':'llarr','\u21CB':'lrhar','\u294E':'LeftRightVector','\u21A4':'mapstoleft','\u295A':'LeftTeeVector','\u22CB':'lthree','\u29CF':'LeftTriangleBar','\u22B2':'vltri','\u22B4':'ltrie','\u2951':'LeftUpDownVector','\u2960':'LeftUpTeeVector','\u2958':'LeftUpVectorBar','\u21BF':'uharl','\u2952':'LeftVectorBar','\u2A8B':'lEg','\u22DA':'leg','\u2A7D':'les','\u2AA8':'lescc','\u2A7F':'lesdot','\u2A81':'lesdoto','\u2A83':'lesdotor','\u22DA\uFE00':'lesg','\u2A93':'lesges','\u22D6':'ltdot','\u2276':'lg','\u2AA1':'LessLess','\u2272':'lsim','\u297C':'lfisht','\uD835\uDD0F':'Lfr','\uD835\uDD29':'lfr','\u2A91':'lgE','\u2962':'lHar','\u296A':'lharul','\u2584':'lhblk','\u0409':'LJcy','\u0459':'ljcy','\u226A':'ll','\u22D8':'Ll','\u296B':'llhard','\u25FA':'lltri','\u013F':'Lmidot','\u0140':'lmidot','\u23B0':'lmoust','\u2A89':'lnap','\u2A87':'lne','\u2268':'lnE','\u22E6':'lnsim','\u27EC':'loang','\u21FD':'loarr','\u27F5':'xlarr','\u27F7':'xharr','\u27FC':'xmap','\u27F6':'xrarr','\u21AC':'rarrlp','\u2985':'lopar','\uD835\uDD43':'Lopf','\uD835\uDD5D':'lopf','\u2A2D':'loplus','\u2A34':'lotimes','\u2217':'lowast','_':'lowbar','\u2199':'swarr','\u2198':'searr','\u25CA':'loz','(':'lpar','\u2993':'lparlt','\u296D':'lrhard','\u200E':'lrm','\u22BF':'lrtri','\u2039':'lsaquo','\uD835\uDCC1':'lscr','\u21B0':'lsh','\u2A8D':'lsime','\u2A8F':'lsimg','\u2018':'lsquo','\u201A':'sbquo','\u0141':'Lstrok','\u0142':'lstrok','\u2AA6':'ltcc','\u2A79':'ltcir','<':'lt','\u22C9':'ltimes','\u2976':'ltlarr','\u2A7B':'ltquest','\u25C3':'ltri','\u2996':'ltrPar','\u294A':'lurdshar','\u2966':'luruhar','\u2268\uFE00':'lvnE','\xAF':'macr','\u2642':'male','\u2720':'malt','\u2905':'Map','\u21A6':'map','\u21A5':'mapstoup','\u25AE':'marker','\u2A29':'mcomma','\u041C':'Mcy','\u043C':'mcy','\u2014':'mdash','\u223A':'mDDot','\u205F':'MediumSpace','\u2133':'Mscr','\uD835\uDD10':'Mfr','\uD835\uDD2A':'mfr','\u2127':'mho','\xB5':'micro','\u2AF0':'midcir','\u2223':'mid','\u2212':'minus','\u2A2A':'minusdu','\u2213':'mp','\u2ADB':'mlcp','\u22A7':'models','\uD835\uDD44':'Mopf','\uD835\uDD5E':'mopf','\uD835\uDCC2':'mscr','\u039C':'Mu','\u03BC':'mu','\u22B8':'mumap','\u0143':'Nacute','\u0144':'nacute','\u2220\u20D2':'nang','\u2249':'nap','\u2A70\u0338':'napE','\u224B\u0338':'napid','\u0149':'napos','\u266E':'natur','\u2115':'Nopf','\xA0':'nbsp','\u224E\u0338':'nbump','\u224F\u0338':'nbumpe','\u2A43':'ncap','\u0147':'Ncaron','\u0148':'ncaron','\u0145':'Ncedil','\u0146':'ncedil','\u2247':'ncong','\u2A6D\u0338':'ncongdot','\u2A42':'ncup','\u041D':'Ncy','\u043D':'ncy','\u2013':'ndash','\u2924':'nearhk','\u2197':'nearr','\u21D7':'neArr','\u2260':'ne','\u2250\u0338':'nedot','\u200B':'ZeroWidthSpace','\u2262':'nequiv','\u2928':'toea','\u2242\u0338':'nesim','\n':'NewLine','\u2204':'nexist','\uD835\uDD11':'Nfr','\uD835\uDD2B':'nfr','\u2267\u0338':'ngE','\u2271':'nge','\u2A7E\u0338':'nges','\u22D9\u0338':'nGg','\u2275':'ngsim','\u226B\u20D2':'nGt','\u226F':'ngt','\u226B\u0338':'nGtv','\u21AE':'nharr','\u21CE':'nhArr','\u2AF2':'nhpar','\u220B':'ni','\u22FC':'nis','\u22FA':'nisd','\u040A':'NJcy','\u045A':'njcy','\u219A':'nlarr','\u21CD':'nlArr','\u2025':'nldr','\u2266\u0338':'nlE','\u2270':'nle','\u2A7D\u0338':'nles','\u226E':'nlt','\u22D8\u0338':'nLl','\u2274':'nlsim','\u226A\u20D2':'nLt','\u22EA':'nltri','\u22EC':'nltrie','\u226A\u0338':'nLtv','\u2224':'nmid','\u2060':'NoBreak','\uD835\uDD5F':'nopf','\u2AEC':'Not','\xAC':'not','\u226D':'NotCupCap','\u2226':'npar','\u2209':'notin','\u2279':'ntgl','\u22F5\u0338':'notindot','\u22F9\u0338':'notinE','\u22F7':'notinvb','\u22F6':'notinvc','\u29CF\u0338':'NotLeftTriangleBar','\u2278':'ntlg','\u2AA2\u0338':'NotNestedGreaterGreater','\u2AA1\u0338':'NotNestedLessLess','\u220C':'notni','\u22FE':'notnivb','\u22FD':'notnivc','\u2280':'npr','\u2AAF\u0338':'npre','\u22E0':'nprcue','\u29D0\u0338':'NotRightTriangleBar','\u22EB':'nrtri','\u22ED':'nrtrie','\u228F\u0338':'NotSquareSubset','\u22E2':'nsqsube','\u2290\u0338':'NotSquareSuperset','\u22E3':'nsqsupe','\u2282\u20D2':'vnsub','\u2288':'nsube','\u2281':'nsc','\u2AB0\u0338':'nsce','\u22E1':'nsccue','\u227F\u0338':'NotSucceedsTilde','\u2283\u20D2':'vnsup','\u2289':'nsupe','\u2241':'nsim','\u2244':'nsime','\u2AFD\u20E5':'nparsl','\u2202\u0338':'npart','\u2A14':'npolint','\u2933\u0338':'nrarrc','\u219B':'nrarr','\u21CF':'nrArr','\u219D\u0338':'nrarrw','\uD835\uDCA9':'Nscr','\uD835\uDCC3':'nscr','\u2284':'nsub','\u2AC5\u0338':'nsubE','\u2285':'nsup','\u2AC6\u0338':'nsupE','\xD1':'Ntilde','\xF1':'ntilde','\u039D':'Nu','\u03BD':'nu','#':'num','\u2116':'numero','\u2007':'numsp','\u224D\u20D2':'nvap','\u22AC':'nvdash','\u22AD':'nvDash','\u22AE':'nVdash','\u22AF':'nVDash','\u2265\u20D2':'nvge','>\u20D2':'nvgt','\u2904':'nvHarr','\u29DE':'nvinfin','\u2902':'nvlArr','\u2264\u20D2':'nvle','<\u20D2':'nvlt','\u22B4\u20D2':'nvltrie','\u2903':'nvrArr','\u22B5\u20D2':'nvrtrie','\u223C\u20D2':'nvsim','\u2923':'nwarhk','\u2196':'nwarr','\u21D6':'nwArr','\u2927':'nwnear','\xD3':'Oacute','\xF3':'oacute','\xD4':'Ocirc','\xF4':'ocirc','\u041E':'Ocy','\u043E':'ocy','\u0150':'Odblac','\u0151':'odblac','\u2A38':'odiv','\u29BC':'odsold','\u0152':'OElig','\u0153':'oelig','\u29BF':'ofcir','\uD835\uDD12':'Ofr','\uD835\uDD2C':'ofr','\u02DB':'ogon','\xD2':'Ograve','\xF2':'ograve','\u29C1':'ogt','\u29B5':'ohbar','\u03A9':'ohm','\u29BE':'olcir','\u29BB':'olcross','\u203E':'oline','\u29C0':'olt','\u014C':'Omacr','\u014D':'omacr','\u03C9':'omega','\u039F':'Omicron','\u03BF':'omicron','\u29B6':'omid','\uD835\uDD46':'Oopf','\uD835\uDD60':'oopf','\u29B7':'opar','\u29B9':'operp','\u2A54':'Or','\u2228':'or','\u2A5D':'ord','\u2134':'oscr','\xAA':'ordf','\xBA':'ordm','\u22B6':'origof','\u2A56':'oror','\u2A57':'orslope','\u2A5B':'orv','\uD835\uDCAA':'Oscr','\xD8':'Oslash','\xF8':'oslash','\u2298':'osol','\xD5':'Otilde','\xF5':'otilde','\u2A36':'otimesas','\u2A37':'Otimes','\xD6':'Ouml','\xF6':'ouml','\u233D':'ovbar','\u23DE':'OverBrace','\u23B4':'tbrk','\u23DC':'OverParenthesis','\xB6':'para','\u2AF3':'parsim','\u2AFD':'parsl','\u2202':'part','\u041F':'Pcy','\u043F':'pcy','%':'percnt','.':'period','\u2030':'permil','\u2031':'pertenk','\uD835\uDD13':'Pfr','\uD835\uDD2D':'pfr','\u03A6':'Phi','\u03C6':'phi','\u03D5':'phiv','\u260E':'phone','\u03A0':'Pi','\u03C0':'pi','\u03D6':'piv','\u210E':'planckh','\u2A23':'plusacir','\u2A22':'pluscir','+':'plus','\u2A25':'plusdu','\u2A72':'pluse','\xB1':'pm','\u2A26':'plussim','\u2A27':'plustwo','\u2A15':'pointint','\uD835\uDD61':'popf','\u2119':'Popf','\xA3':'pound','\u2AB7':'prap','\u2ABB':'Pr','\u227A':'pr','\u227C':'prcue','\u2AAF':'pre','\u227E':'prsim','\u2AB9':'prnap','\u2AB5':'prnE','\u22E8':'prnsim','\u2AB3':'prE','\u2032':'prime','\u2033':'Prime','\u220F':'prod','\u232E':'profalar','\u2312':'profline','\u2313':'profsurf','\u221D':'prop','\u22B0':'prurel','\uD835\uDCAB':'Pscr','\uD835\uDCC5':'pscr','\u03A8':'Psi','\u03C8':'psi','\u2008':'puncsp','\uD835\uDD14':'Qfr','\uD835\uDD2E':'qfr','\uD835\uDD62':'qopf','\u211A':'Qopf','\u2057':'qprime','\uD835\uDCAC':'Qscr','\uD835\uDCC6':'qscr','\u2A16':'quatint','?':'quest','"':'quot','\u21DB':'rAarr','\u223D\u0331':'race','\u0154':'Racute','\u0155':'racute','\u221A':'Sqrt','\u29B3':'raemptyv','\u27E9':'rang','\u27EB':'Rang','\u2992':'rangd','\u29A5':'range','\xBB':'raquo','\u2975':'rarrap','\u21E5':'rarrb','\u2920':'rarrbfs','\u2933':'rarrc','\u2192':'rarr','\u21A0':'Rarr','\u291E':'rarrfs','\u2945':'rarrpl','\u2974':'rarrsim','\u2916':'Rarrtl','\u21A3':'rarrtl','\u219D':'rarrw','\u291A':'ratail','\u291C':'rAtail','\u2236':'ratio','\u2773':'rbbrk','}':'rcub',']':'rsqb','\u298C':'rbrke','\u298E':'rbrksld','\u2990':'rbrkslu','\u0158':'Rcaron','\u0159':'rcaron','\u0156':'Rcedil','\u0157':'rcedil','\u2309':'rceil','\u0420':'Rcy','\u0440':'rcy','\u2937':'rdca','\u2969':'rdldhar','\u21B3':'rdsh','\u211C':'Re','\u211B':'Rscr','\u211D':'Ropf','\u25AD':'rect','\u297D':'rfisht','\u230B':'rfloor','\uD835\uDD2F':'rfr','\u2964':'rHar','\u21C0':'rharu','\u296C':'rharul','\u03A1':'Rho','\u03C1':'rho','\u03F1':'rhov','\u21C4':'rlarr','\u27E7':'robrk','\u295D':'RightDownTeeVector','\u2955':'RightDownVectorBar','\u21C9':'rrarr','\u22A2':'vdash','\u295B':'RightTeeVector','\u22CC':'rthree','\u29D0':'RightTriangleBar','\u22B3':'vrtri','\u22B5':'rtrie','\u294F':'RightUpDownVector','\u295C':'RightUpTeeVector','\u2954':'RightUpVectorBar','\u21BE':'uharr','\u2953':'RightVectorBar','\u02DA':'ring','\u200F':'rlm','\u23B1':'rmoust','\u2AEE':'rnmid','\u27ED':'roang','\u21FE':'roarr','\u2986':'ropar','\uD835\uDD63':'ropf','\u2A2E':'roplus','\u2A35':'rotimes','\u2970':'RoundImplies',')':'rpar','\u2994':'rpargt','\u2A12':'rppolint','\u203A':'rsaquo','\uD835\uDCC7':'rscr','\u21B1':'rsh','\u22CA':'rtimes','\u25B9':'rtri','\u29CE':'rtriltri','\u29F4':'RuleDelayed','\u2968':'ruluhar','\u211E':'rx','\u015A':'Sacute','\u015B':'sacute','\u2AB8':'scap','\u0160':'Scaron','\u0161':'scaron','\u2ABC':'Sc','\u227B':'sc','\u227D':'sccue','\u2AB0':'sce','\u2AB4':'scE','\u015E':'Scedil','\u015F':'scedil','\u015C':'Scirc','\u015D':'scirc','\u2ABA':'scnap','\u2AB6':'scnE','\u22E9':'scnsim','\u2A13':'scpolint','\u227F':'scsim','\u0421':'Scy','\u0441':'scy','\u22C5':'sdot','\u2A66':'sdote','\u21D8':'seArr','\xA7':'sect',';':'semi','\u2929':'tosa','\u2736':'sext','\uD835\uDD16':'Sfr','\uD835\uDD30':'sfr','\u266F':'sharp','\u0429':'SHCHcy','\u0449':'shchcy','\u0428':'SHcy','\u0448':'shcy','\u2191':'uarr','\xAD':'shy','\u03A3':'Sigma','\u03C3':'sigma','\u03C2':'sigmaf','\u223C':'sim','\u2A6A':'simdot','\u2243':'sime','\u2A9E':'simg','\u2AA0':'simgE','\u2A9D':'siml','\u2A9F':'simlE','\u2246':'simne','\u2A24':'simplus','\u2972':'simrarr','\u2A33':'smashp','\u29E4':'smeparsl','\u2323':'smile','\u2AAA':'smt','\u2AAC':'smte','\u2AAC\uFE00':'smtes','\u042C':'SOFTcy','\u044C':'softcy','\u233F':'solbar','\u29C4':'solb','/':'sol','\uD835\uDD4A':'Sopf','\uD835\uDD64':'sopf','\u2660':'spades','\u2293':'sqcap','\u2293\uFE00':'sqcaps','\u2294':'sqcup','\u2294\uFE00':'sqcups','\u228F':'sqsub','\u2291':'sqsube','\u2290':'sqsup','\u2292':'sqsupe','\u25A1':'squ','\uD835\uDCAE':'Sscr','\uD835\uDCC8':'sscr','\u22C6':'Star','\u2606':'star','\u2282':'sub','\u22D0':'Sub','\u2ABD':'subdot','\u2AC5':'subE','\u2286':'sube','\u2AC3':'subedot','\u2AC1':'submult','\u2ACB':'subnE','\u228A':'subne','\u2ABF':'subplus','\u2979':'subrarr','\u2AC7':'subsim','\u2AD5':'subsub','\u2AD3':'subsup','\u2211':'sum','\u266A':'sung','\xB9':'sup1','\xB2':'sup2','\xB3':'sup3','\u2283':'sup','\u22D1':'Sup','\u2ABE':'supdot','\u2AD8':'supdsub','\u2AC6':'supE','\u2287':'supe','\u2AC4':'supedot','\u27C9':'suphsol','\u2AD7':'suphsub','\u297B':'suplarr','\u2AC2':'supmult','\u2ACC':'supnE','\u228B':'supne','\u2AC0':'supplus','\u2AC8':'supsim','\u2AD4':'supsub','\u2AD6':'supsup','\u21D9':'swArr','\u292A':'swnwar','\xDF':'szlig','\t':'Tab','\u2316':'target','\u03A4':'Tau','\u03C4':'tau','\u0164':'Tcaron','\u0165':'tcaron','\u0162':'Tcedil','\u0163':'tcedil','\u0422':'Tcy','\u0442':'tcy','\u20DB':'tdot','\u2315':'telrec','\uD835\uDD17':'Tfr','\uD835\uDD31':'tfr','\u2234':'there4','\u0398':'Theta','\u03B8':'theta','\u03D1':'thetav','\u205F\u200A':'ThickSpace','\u2009':'thinsp','\xDE':'THORN','\xFE':'thorn','\u2A31':'timesbar','\xD7':'times','\u2A30':'timesd','\u2336':'topbot','\u2AF1':'topcir','\uD835\uDD4B':'Topf','\uD835\uDD65':'topf','\u2ADA':'topfork','\u2034':'tprime','\u2122':'trade','\u25B5':'utri','\u225C':'trie','\u25EC':'tridot','\u2A3A':'triminus','\u2A39':'triplus','\u29CD':'trisb','\u2A3B':'tritime','\u23E2':'trpezium','\uD835\uDCAF':'Tscr','\uD835\uDCC9':'tscr','\u0426':'TScy','\u0446':'tscy','\u040B':'TSHcy','\u045B':'tshcy','\u0166':'Tstrok','\u0167':'tstrok','\xDA':'Uacute','\xFA':'uacute','\u219F':'Uarr','\u2949':'Uarrocir','\u040E':'Ubrcy','\u045E':'ubrcy','\u016C':'Ubreve','\u016D':'ubreve','\xDB':'Ucirc','\xFB':'ucirc','\u0423':'Ucy','\u0443':'ucy','\u21C5':'udarr','\u0170':'Udblac','\u0171':'udblac','\u296E':'udhar','\u297E':'ufisht','\uD835\uDD18':'Ufr','\uD835\uDD32':'ufr','\xD9':'Ugrave','\xF9':'ugrave','\u2963':'uHar','\u2580':'uhblk','\u231C':'ulcorn','\u230F':'ulcrop','\u25F8':'ultri','\u016A':'Umacr','\u016B':'umacr','\u23DF':'UnderBrace','\u23DD':'UnderParenthesis','\u228E':'uplus','\u0172':'Uogon','\u0173':'uogon','\uD835\uDD4C':'Uopf','\uD835\uDD66':'uopf','\u2912':'UpArrowBar','\u2195':'varr','\u03C5':'upsi','\u03D2':'Upsi','\u03A5':'Upsilon','\u21C8':'uuarr','\u231D':'urcorn','\u230E':'urcrop','\u016E':'Uring','\u016F':'uring','\u25F9':'urtri','\uD835\uDCB0':'Uscr','\uD835\uDCCA':'uscr','\u22F0':'utdot','\u0168':'Utilde','\u0169':'utilde','\xDC':'Uuml','\xFC':'uuml','\u29A7':'uwangle','\u299C':'vangrt','\u228A\uFE00':'vsubne','\u2ACB\uFE00':'vsubnE','\u228B\uFE00':'vsupne','\u2ACC\uFE00':'vsupnE','\u2AE8':'vBar','\u2AEB':'Vbar','\u2AE9':'vBarv','\u0412':'Vcy','\u0432':'vcy','\u22A9':'Vdash','\u22AB':'VDash','\u2AE6':'Vdashl','\u22BB':'veebar','\u225A':'veeeq','\u22EE':'vellip','|':'vert','\u2016':'Vert','\u2758':'VerticalSeparator','\u2240':'wr','\uD835\uDD19':'Vfr','\uD835\uDD33':'vfr','\uD835\uDD4D':'Vopf','\uD835\uDD67':'vopf','\uD835\uDCB1':'Vscr','\uD835\uDCCB':'vscr','\u22AA':'Vvdash','\u299A':'vzigzag','\u0174':'Wcirc','\u0175':'wcirc','\u2A5F':'wedbar','\u2259':'wedgeq','\u2118':'wp','\uD835\uDD1A':'Wfr','\uD835\uDD34':'wfr','\uD835\uDD4E':'Wopf','\uD835\uDD68':'wopf','\uD835\uDCB2':'Wscr','\uD835\uDCCC':'wscr','\uD835\uDD1B':'Xfr','\uD835\uDD35':'xfr','\u039E':'Xi','\u03BE':'xi','\u22FB':'xnis','\uD835\uDD4F':'Xopf','\uD835\uDD69':'xopf','\uD835\uDCB3':'Xscr','\uD835\uDCCD':'xscr','\xDD':'Yacute','\xFD':'yacute','\u042F':'YAcy','\u044F':'yacy','\u0176':'Ycirc','\u0177':'ycirc','\u042B':'Ycy','\u044B':'ycy','\xA5':'yen','\uD835\uDD1C':'Yfr','\uD835\uDD36':'yfr','\u0407':'YIcy','\u0457':'yicy','\uD835\uDD50':'Yopf','\uD835\uDD6A':'yopf','\uD835\uDCB4':'Yscr','\uD835\uDCCE':'yscr','\u042E':'YUcy','\u044E':'yucy','\xFF':'yuml','\u0178':'Yuml','\u0179':'Zacute','\u017A':'zacute','\u017D':'Zcaron','\u017E':'zcaron','\u0417':'Zcy','\u0437':'zcy','\u017B':'Zdot','\u017C':'zdot','\u2128':'Zfr','\u0396':'Zeta','\u03B6':'zeta','\uD835\uDD37':'zfr','\u0416':'ZHcy','\u0436':'zhcy','\u21DD':'zigrarr','\uD835\uDD6B':'zopf','\uD835\uDCB5':'Zscr','\uD835\uDCCF':'zscr','\u200D':'zwj','\u200C':'zwnj'};
	
		var regexEscape = /["&'<>`]/g;
		var escapeMap = {
			'"': '&quot;',
			'&': '&amp;',
			'\'': '&#x27;',
			'<': '&lt;',
			// See https://mathiasbynens.be/notes/ambiguous-ampersands: in HTML, the
			// following is not strictly necessary unless it’s part of a tag or an
			// unquoted attribute value. We’re only escaping it to support those
			// situations, and for XML support.
			'>': '&gt;',
			// In Internet Explorer ≤ 8, the backtick character can be used
			// to break out of (un)quoted attribute values or HTML comments.
			// See http://html5sec.org/#102, http://html5sec.org/#108, and
			// http://html5sec.org/#133.
			'`': '&#x60;'
		};
	
		var regexInvalidEntity = /&#(?:[xX][^a-fA-F0-9]|[^0-9xX])/;
		var regexInvalidRawCodePoint = /[\0-\x08\x0B\x0E-\x1F\x7F-\x9F\uFDD0-\uFDEF\uFFFE\uFFFF]|[\uD83F\uD87F\uD8BF\uD8FF\uD93F\uD97F\uD9BF\uD9FF\uDA3F\uDA7F\uDABF\uDAFF\uDB3F\uDB7F\uDBBF\uDBFF][\uDFFE\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/;
		var regexDecode = /&#([0-9]+)(;?)|&#[xX]([a-fA-F0-9]+)(;?)|&([0-9a-zA-Z]+);|&(Aacute|iacute|Uacute|plusmn|otilde|Otilde|Agrave|agrave|yacute|Yacute|oslash|Oslash|Atilde|atilde|brvbar|Ccedil|ccedil|ograve|curren|divide|Eacute|eacute|Ograve|oacute|Egrave|egrave|ugrave|frac12|frac14|frac34|Ugrave|Oacute|Iacute|ntilde|Ntilde|uacute|middot|Igrave|igrave|iquest|aacute|laquo|THORN|micro|iexcl|icirc|Icirc|Acirc|ucirc|ecirc|Ocirc|ocirc|Ecirc|Ucirc|aring|Aring|aelig|AElig|acute|pound|raquo|acirc|times|thorn|szlig|cedil|COPY|Auml|ordf|ordm|uuml|macr|Uuml|auml|Ouml|ouml|para|nbsp|Euml|quot|QUOT|euml|yuml|cent|sect|copy|sup1|sup2|sup3|Iuml|iuml|shy|eth|reg|not|yen|amp|AMP|REG|uml|ETH|deg|gt|GT|LT|lt)([=a-zA-Z0-9])?/g;
		var decodeMap = {'Aacute':'\xC1','aacute':'\xE1','Abreve':'\u0102','abreve':'\u0103','ac':'\u223E','acd':'\u223F','acE':'\u223E\u0333','Acirc':'\xC2','acirc':'\xE2','acute':'\xB4','Acy':'\u0410','acy':'\u0430','AElig':'\xC6','aelig':'\xE6','af':'\u2061','Afr':'\uD835\uDD04','afr':'\uD835\uDD1E','Agrave':'\xC0','agrave':'\xE0','alefsym':'\u2135','aleph':'\u2135','Alpha':'\u0391','alpha':'\u03B1','Amacr':'\u0100','amacr':'\u0101','amalg':'\u2A3F','amp':'&','AMP':'&','andand':'\u2A55','And':'\u2A53','and':'\u2227','andd':'\u2A5C','andslope':'\u2A58','andv':'\u2A5A','ang':'\u2220','ange':'\u29A4','angle':'\u2220','angmsdaa':'\u29A8','angmsdab':'\u29A9','angmsdac':'\u29AA','angmsdad':'\u29AB','angmsdae':'\u29AC','angmsdaf':'\u29AD','angmsdag':'\u29AE','angmsdah':'\u29AF','angmsd':'\u2221','angrt':'\u221F','angrtvb':'\u22BE','angrtvbd':'\u299D','angsph':'\u2222','angst':'\xC5','angzarr':'\u237C','Aogon':'\u0104','aogon':'\u0105','Aopf':'\uD835\uDD38','aopf':'\uD835\uDD52','apacir':'\u2A6F','ap':'\u2248','apE':'\u2A70','ape':'\u224A','apid':'\u224B','apos':'\'','ApplyFunction':'\u2061','approx':'\u2248','approxeq':'\u224A','Aring':'\xC5','aring':'\xE5','Ascr':'\uD835\uDC9C','ascr':'\uD835\uDCB6','Assign':'\u2254','ast':'*','asymp':'\u2248','asympeq':'\u224D','Atilde':'\xC3','atilde':'\xE3','Auml':'\xC4','auml':'\xE4','awconint':'\u2233','awint':'\u2A11','backcong':'\u224C','backepsilon':'\u03F6','backprime':'\u2035','backsim':'\u223D','backsimeq':'\u22CD','Backslash':'\u2216','Barv':'\u2AE7','barvee':'\u22BD','barwed':'\u2305','Barwed':'\u2306','barwedge':'\u2305','bbrk':'\u23B5','bbrktbrk':'\u23B6','bcong':'\u224C','Bcy':'\u0411','bcy':'\u0431','bdquo':'\u201E','becaus':'\u2235','because':'\u2235','Because':'\u2235','bemptyv':'\u29B0','bepsi':'\u03F6','bernou':'\u212C','Bernoullis':'\u212C','Beta':'\u0392','beta':'\u03B2','beth':'\u2136','between':'\u226C','Bfr':'\uD835\uDD05','bfr':'\uD835\uDD1F','bigcap':'\u22C2','bigcirc':'\u25EF','bigcup':'\u22C3','bigodot':'\u2A00','bigoplus':'\u2A01','bigotimes':'\u2A02','bigsqcup':'\u2A06','bigstar':'\u2605','bigtriangledown':'\u25BD','bigtriangleup':'\u25B3','biguplus':'\u2A04','bigvee':'\u22C1','bigwedge':'\u22C0','bkarow':'\u290D','blacklozenge':'\u29EB','blacksquare':'\u25AA','blacktriangle':'\u25B4','blacktriangledown':'\u25BE','blacktriangleleft':'\u25C2','blacktriangleright':'\u25B8','blank':'\u2423','blk12':'\u2592','blk14':'\u2591','blk34':'\u2593','block':'\u2588','bne':'=\u20E5','bnequiv':'\u2261\u20E5','bNot':'\u2AED','bnot':'\u2310','Bopf':'\uD835\uDD39','bopf':'\uD835\uDD53','bot':'\u22A5','bottom':'\u22A5','bowtie':'\u22C8','boxbox':'\u29C9','boxdl':'\u2510','boxdL':'\u2555','boxDl':'\u2556','boxDL':'\u2557','boxdr':'\u250C','boxdR':'\u2552','boxDr':'\u2553','boxDR':'\u2554','boxh':'\u2500','boxH':'\u2550','boxhd':'\u252C','boxHd':'\u2564','boxhD':'\u2565','boxHD':'\u2566','boxhu':'\u2534','boxHu':'\u2567','boxhU':'\u2568','boxHU':'\u2569','boxminus':'\u229F','boxplus':'\u229E','boxtimes':'\u22A0','boxul':'\u2518','boxuL':'\u255B','boxUl':'\u255C','boxUL':'\u255D','boxur':'\u2514','boxuR':'\u2558','boxUr':'\u2559','boxUR':'\u255A','boxv':'\u2502','boxV':'\u2551','boxvh':'\u253C','boxvH':'\u256A','boxVh':'\u256B','boxVH':'\u256C','boxvl':'\u2524','boxvL':'\u2561','boxVl':'\u2562','boxVL':'\u2563','boxvr':'\u251C','boxvR':'\u255E','boxVr':'\u255F','boxVR':'\u2560','bprime':'\u2035','breve':'\u02D8','Breve':'\u02D8','brvbar':'\xA6','bscr':'\uD835\uDCB7','Bscr':'\u212C','bsemi':'\u204F','bsim':'\u223D','bsime':'\u22CD','bsolb':'\u29C5','bsol':'\\','bsolhsub':'\u27C8','bull':'\u2022','bullet':'\u2022','bump':'\u224E','bumpE':'\u2AAE','bumpe':'\u224F','Bumpeq':'\u224E','bumpeq':'\u224F','Cacute':'\u0106','cacute':'\u0107','capand':'\u2A44','capbrcup':'\u2A49','capcap':'\u2A4B','cap':'\u2229','Cap':'\u22D2','capcup':'\u2A47','capdot':'\u2A40','CapitalDifferentialD':'\u2145','caps':'\u2229\uFE00','caret':'\u2041','caron':'\u02C7','Cayleys':'\u212D','ccaps':'\u2A4D','Ccaron':'\u010C','ccaron':'\u010D','Ccedil':'\xC7','ccedil':'\xE7','Ccirc':'\u0108','ccirc':'\u0109','Cconint':'\u2230','ccups':'\u2A4C','ccupssm':'\u2A50','Cdot':'\u010A','cdot':'\u010B','cedil':'\xB8','Cedilla':'\xB8','cemptyv':'\u29B2','cent':'\xA2','centerdot':'\xB7','CenterDot':'\xB7','cfr':'\uD835\uDD20','Cfr':'\u212D','CHcy':'\u0427','chcy':'\u0447','check':'\u2713','checkmark':'\u2713','Chi':'\u03A7','chi':'\u03C7','circ':'\u02C6','circeq':'\u2257','circlearrowleft':'\u21BA','circlearrowright':'\u21BB','circledast':'\u229B','circledcirc':'\u229A','circleddash':'\u229D','CircleDot':'\u2299','circledR':'\xAE','circledS':'\u24C8','CircleMinus':'\u2296','CirclePlus':'\u2295','CircleTimes':'\u2297','cir':'\u25CB','cirE':'\u29C3','cire':'\u2257','cirfnint':'\u2A10','cirmid':'\u2AEF','cirscir':'\u29C2','ClockwiseContourIntegral':'\u2232','CloseCurlyDoubleQuote':'\u201D','CloseCurlyQuote':'\u2019','clubs':'\u2663','clubsuit':'\u2663','colon':':','Colon':'\u2237','Colone':'\u2A74','colone':'\u2254','coloneq':'\u2254','comma':',','commat':'@','comp':'\u2201','compfn':'\u2218','complement':'\u2201','complexes':'\u2102','cong':'\u2245','congdot':'\u2A6D','Congruent':'\u2261','conint':'\u222E','Conint':'\u222F','ContourIntegral':'\u222E','copf':'\uD835\uDD54','Copf':'\u2102','coprod':'\u2210','Coproduct':'\u2210','copy':'\xA9','COPY':'\xA9','copysr':'\u2117','CounterClockwiseContourIntegral':'\u2233','crarr':'\u21B5','cross':'\u2717','Cross':'\u2A2F','Cscr':'\uD835\uDC9E','cscr':'\uD835\uDCB8','csub':'\u2ACF','csube':'\u2AD1','csup':'\u2AD0','csupe':'\u2AD2','ctdot':'\u22EF','cudarrl':'\u2938','cudarrr':'\u2935','cuepr':'\u22DE','cuesc':'\u22DF','cularr':'\u21B6','cularrp':'\u293D','cupbrcap':'\u2A48','cupcap':'\u2A46','CupCap':'\u224D','cup':'\u222A','Cup':'\u22D3','cupcup':'\u2A4A','cupdot':'\u228D','cupor':'\u2A45','cups':'\u222A\uFE00','curarr':'\u21B7','curarrm':'\u293C','curlyeqprec':'\u22DE','curlyeqsucc':'\u22DF','curlyvee':'\u22CE','curlywedge':'\u22CF','curren':'\xA4','curvearrowleft':'\u21B6','curvearrowright':'\u21B7','cuvee':'\u22CE','cuwed':'\u22CF','cwconint':'\u2232','cwint':'\u2231','cylcty':'\u232D','dagger':'\u2020','Dagger':'\u2021','daleth':'\u2138','darr':'\u2193','Darr':'\u21A1','dArr':'\u21D3','dash':'\u2010','Dashv':'\u2AE4','dashv':'\u22A3','dbkarow':'\u290F','dblac':'\u02DD','Dcaron':'\u010E','dcaron':'\u010F','Dcy':'\u0414','dcy':'\u0434','ddagger':'\u2021','ddarr':'\u21CA','DD':'\u2145','dd':'\u2146','DDotrahd':'\u2911','ddotseq':'\u2A77','deg':'\xB0','Del':'\u2207','Delta':'\u0394','delta':'\u03B4','demptyv':'\u29B1','dfisht':'\u297F','Dfr':'\uD835\uDD07','dfr':'\uD835\uDD21','dHar':'\u2965','dharl':'\u21C3','dharr':'\u21C2','DiacriticalAcute':'\xB4','DiacriticalDot':'\u02D9','DiacriticalDoubleAcute':'\u02DD','DiacriticalGrave':'`','DiacriticalTilde':'\u02DC','diam':'\u22C4','diamond':'\u22C4','Diamond':'\u22C4','diamondsuit':'\u2666','diams':'\u2666','die':'\xA8','DifferentialD':'\u2146','digamma':'\u03DD','disin':'\u22F2','div':'\xF7','divide':'\xF7','divideontimes':'\u22C7','divonx':'\u22C7','DJcy':'\u0402','djcy':'\u0452','dlcorn':'\u231E','dlcrop':'\u230D','dollar':'$','Dopf':'\uD835\uDD3B','dopf':'\uD835\uDD55','Dot':'\xA8','dot':'\u02D9','DotDot':'\u20DC','doteq':'\u2250','doteqdot':'\u2251','DotEqual':'\u2250','dotminus':'\u2238','dotplus':'\u2214','dotsquare':'\u22A1','doublebarwedge':'\u2306','DoubleContourIntegral':'\u222F','DoubleDot':'\xA8','DoubleDownArrow':'\u21D3','DoubleLeftArrow':'\u21D0','DoubleLeftRightArrow':'\u21D4','DoubleLeftTee':'\u2AE4','DoubleLongLeftArrow':'\u27F8','DoubleLongLeftRightArrow':'\u27FA','DoubleLongRightArrow':'\u27F9','DoubleRightArrow':'\u21D2','DoubleRightTee':'\u22A8','DoubleUpArrow':'\u21D1','DoubleUpDownArrow':'\u21D5','DoubleVerticalBar':'\u2225','DownArrowBar':'\u2913','downarrow':'\u2193','DownArrow':'\u2193','Downarrow':'\u21D3','DownArrowUpArrow':'\u21F5','DownBreve':'\u0311','downdownarrows':'\u21CA','downharpoonleft':'\u21C3','downharpoonright':'\u21C2','DownLeftRightVector':'\u2950','DownLeftTeeVector':'\u295E','DownLeftVectorBar':'\u2956','DownLeftVector':'\u21BD','DownRightTeeVector':'\u295F','DownRightVectorBar':'\u2957','DownRightVector':'\u21C1','DownTeeArrow':'\u21A7','DownTee':'\u22A4','drbkarow':'\u2910','drcorn':'\u231F','drcrop':'\u230C','Dscr':'\uD835\uDC9F','dscr':'\uD835\uDCB9','DScy':'\u0405','dscy':'\u0455','dsol':'\u29F6','Dstrok':'\u0110','dstrok':'\u0111','dtdot':'\u22F1','dtri':'\u25BF','dtrif':'\u25BE','duarr':'\u21F5','duhar':'\u296F','dwangle':'\u29A6','DZcy':'\u040F','dzcy':'\u045F','dzigrarr':'\u27FF','Eacute':'\xC9','eacute':'\xE9','easter':'\u2A6E','Ecaron':'\u011A','ecaron':'\u011B','Ecirc':'\xCA','ecirc':'\xEA','ecir':'\u2256','ecolon':'\u2255','Ecy':'\u042D','ecy':'\u044D','eDDot':'\u2A77','Edot':'\u0116','edot':'\u0117','eDot':'\u2251','ee':'\u2147','efDot':'\u2252','Efr':'\uD835\uDD08','efr':'\uD835\uDD22','eg':'\u2A9A','Egrave':'\xC8','egrave':'\xE8','egs':'\u2A96','egsdot':'\u2A98','el':'\u2A99','Element':'\u2208','elinters':'\u23E7','ell':'\u2113','els':'\u2A95','elsdot':'\u2A97','Emacr':'\u0112','emacr':'\u0113','empty':'\u2205','emptyset':'\u2205','EmptySmallSquare':'\u25FB','emptyv':'\u2205','EmptyVerySmallSquare':'\u25AB','emsp13':'\u2004','emsp14':'\u2005','emsp':'\u2003','ENG':'\u014A','eng':'\u014B','ensp':'\u2002','Eogon':'\u0118','eogon':'\u0119','Eopf':'\uD835\uDD3C','eopf':'\uD835\uDD56','epar':'\u22D5','eparsl':'\u29E3','eplus':'\u2A71','epsi':'\u03B5','Epsilon':'\u0395','epsilon':'\u03B5','epsiv':'\u03F5','eqcirc':'\u2256','eqcolon':'\u2255','eqsim':'\u2242','eqslantgtr':'\u2A96','eqslantless':'\u2A95','Equal':'\u2A75','equals':'=','EqualTilde':'\u2242','equest':'\u225F','Equilibrium':'\u21CC','equiv':'\u2261','equivDD':'\u2A78','eqvparsl':'\u29E5','erarr':'\u2971','erDot':'\u2253','escr':'\u212F','Escr':'\u2130','esdot':'\u2250','Esim':'\u2A73','esim':'\u2242','Eta':'\u0397','eta':'\u03B7','ETH':'\xD0','eth':'\xF0','Euml':'\xCB','euml':'\xEB','euro':'\u20AC','excl':'!','exist':'\u2203','Exists':'\u2203','expectation':'\u2130','exponentiale':'\u2147','ExponentialE':'\u2147','fallingdotseq':'\u2252','Fcy':'\u0424','fcy':'\u0444','female':'\u2640','ffilig':'\uFB03','fflig':'\uFB00','ffllig':'\uFB04','Ffr':'\uD835\uDD09','ffr':'\uD835\uDD23','filig':'\uFB01','FilledSmallSquare':'\u25FC','FilledVerySmallSquare':'\u25AA','fjlig':'fj','flat':'\u266D','fllig':'\uFB02','fltns':'\u25B1','fnof':'\u0192','Fopf':'\uD835\uDD3D','fopf':'\uD835\uDD57','forall':'\u2200','ForAll':'\u2200','fork':'\u22D4','forkv':'\u2AD9','Fouriertrf':'\u2131','fpartint':'\u2A0D','frac12':'\xBD','frac13':'\u2153','frac14':'\xBC','frac15':'\u2155','frac16':'\u2159','frac18':'\u215B','frac23':'\u2154','frac25':'\u2156','frac34':'\xBE','frac35':'\u2157','frac38':'\u215C','frac45':'\u2158','frac56':'\u215A','frac58':'\u215D','frac78':'\u215E','frasl':'\u2044','frown':'\u2322','fscr':'\uD835\uDCBB','Fscr':'\u2131','gacute':'\u01F5','Gamma':'\u0393','gamma':'\u03B3','Gammad':'\u03DC','gammad':'\u03DD','gap':'\u2A86','Gbreve':'\u011E','gbreve':'\u011F','Gcedil':'\u0122','Gcirc':'\u011C','gcirc':'\u011D','Gcy':'\u0413','gcy':'\u0433','Gdot':'\u0120','gdot':'\u0121','ge':'\u2265','gE':'\u2267','gEl':'\u2A8C','gel':'\u22DB','geq':'\u2265','geqq':'\u2267','geqslant':'\u2A7E','gescc':'\u2AA9','ges':'\u2A7E','gesdot':'\u2A80','gesdoto':'\u2A82','gesdotol':'\u2A84','gesl':'\u22DB\uFE00','gesles':'\u2A94','Gfr':'\uD835\uDD0A','gfr':'\uD835\uDD24','gg':'\u226B','Gg':'\u22D9','ggg':'\u22D9','gimel':'\u2137','GJcy':'\u0403','gjcy':'\u0453','gla':'\u2AA5','gl':'\u2277','glE':'\u2A92','glj':'\u2AA4','gnap':'\u2A8A','gnapprox':'\u2A8A','gne':'\u2A88','gnE':'\u2269','gneq':'\u2A88','gneqq':'\u2269','gnsim':'\u22E7','Gopf':'\uD835\uDD3E','gopf':'\uD835\uDD58','grave':'`','GreaterEqual':'\u2265','GreaterEqualLess':'\u22DB','GreaterFullEqual':'\u2267','GreaterGreater':'\u2AA2','GreaterLess':'\u2277','GreaterSlantEqual':'\u2A7E','GreaterTilde':'\u2273','Gscr':'\uD835\uDCA2','gscr':'\u210A','gsim':'\u2273','gsime':'\u2A8E','gsiml':'\u2A90','gtcc':'\u2AA7','gtcir':'\u2A7A','gt':'>','GT':'>','Gt':'\u226B','gtdot':'\u22D7','gtlPar':'\u2995','gtquest':'\u2A7C','gtrapprox':'\u2A86','gtrarr':'\u2978','gtrdot':'\u22D7','gtreqless':'\u22DB','gtreqqless':'\u2A8C','gtrless':'\u2277','gtrsim':'\u2273','gvertneqq':'\u2269\uFE00','gvnE':'\u2269\uFE00','Hacek':'\u02C7','hairsp':'\u200A','half':'\xBD','hamilt':'\u210B','HARDcy':'\u042A','hardcy':'\u044A','harrcir':'\u2948','harr':'\u2194','hArr':'\u21D4','harrw':'\u21AD','Hat':'^','hbar':'\u210F','Hcirc':'\u0124','hcirc':'\u0125','hearts':'\u2665','heartsuit':'\u2665','hellip':'\u2026','hercon':'\u22B9','hfr':'\uD835\uDD25','Hfr':'\u210C','HilbertSpace':'\u210B','hksearow':'\u2925','hkswarow':'\u2926','hoarr':'\u21FF','homtht':'\u223B','hookleftarrow':'\u21A9','hookrightarrow':'\u21AA','hopf':'\uD835\uDD59','Hopf':'\u210D','horbar':'\u2015','HorizontalLine':'\u2500','hscr':'\uD835\uDCBD','Hscr':'\u210B','hslash':'\u210F','Hstrok':'\u0126','hstrok':'\u0127','HumpDownHump':'\u224E','HumpEqual':'\u224F','hybull':'\u2043','hyphen':'\u2010','Iacute':'\xCD','iacute':'\xED','ic':'\u2063','Icirc':'\xCE','icirc':'\xEE','Icy':'\u0418','icy':'\u0438','Idot':'\u0130','IEcy':'\u0415','iecy':'\u0435','iexcl':'\xA1','iff':'\u21D4','ifr':'\uD835\uDD26','Ifr':'\u2111','Igrave':'\xCC','igrave':'\xEC','ii':'\u2148','iiiint':'\u2A0C','iiint':'\u222D','iinfin':'\u29DC','iiota':'\u2129','IJlig':'\u0132','ijlig':'\u0133','Imacr':'\u012A','imacr':'\u012B','image':'\u2111','ImaginaryI':'\u2148','imagline':'\u2110','imagpart':'\u2111','imath':'\u0131','Im':'\u2111','imof':'\u22B7','imped':'\u01B5','Implies':'\u21D2','incare':'\u2105','in':'\u2208','infin':'\u221E','infintie':'\u29DD','inodot':'\u0131','intcal':'\u22BA','int':'\u222B','Int':'\u222C','integers':'\u2124','Integral':'\u222B','intercal':'\u22BA','Intersection':'\u22C2','intlarhk':'\u2A17','intprod':'\u2A3C','InvisibleComma':'\u2063','InvisibleTimes':'\u2062','IOcy':'\u0401','iocy':'\u0451','Iogon':'\u012E','iogon':'\u012F','Iopf':'\uD835\uDD40','iopf':'\uD835\uDD5A','Iota':'\u0399','iota':'\u03B9','iprod':'\u2A3C','iquest':'\xBF','iscr':'\uD835\uDCBE','Iscr':'\u2110','isin':'\u2208','isindot':'\u22F5','isinE':'\u22F9','isins':'\u22F4','isinsv':'\u22F3','isinv':'\u2208','it':'\u2062','Itilde':'\u0128','itilde':'\u0129','Iukcy':'\u0406','iukcy':'\u0456','Iuml':'\xCF','iuml':'\xEF','Jcirc':'\u0134','jcirc':'\u0135','Jcy':'\u0419','jcy':'\u0439','Jfr':'\uD835\uDD0D','jfr':'\uD835\uDD27','jmath':'\u0237','Jopf':'\uD835\uDD41','jopf':'\uD835\uDD5B','Jscr':'\uD835\uDCA5','jscr':'\uD835\uDCBF','Jsercy':'\u0408','jsercy':'\u0458','Jukcy':'\u0404','jukcy':'\u0454','Kappa':'\u039A','kappa':'\u03BA','kappav':'\u03F0','Kcedil':'\u0136','kcedil':'\u0137','Kcy':'\u041A','kcy':'\u043A','Kfr':'\uD835\uDD0E','kfr':'\uD835\uDD28','kgreen':'\u0138','KHcy':'\u0425','khcy':'\u0445','KJcy':'\u040C','kjcy':'\u045C','Kopf':'\uD835\uDD42','kopf':'\uD835\uDD5C','Kscr':'\uD835\uDCA6','kscr':'\uD835\uDCC0','lAarr':'\u21DA','Lacute':'\u0139','lacute':'\u013A','laemptyv':'\u29B4','lagran':'\u2112','Lambda':'\u039B','lambda':'\u03BB','lang':'\u27E8','Lang':'\u27EA','langd':'\u2991','langle':'\u27E8','lap':'\u2A85','Laplacetrf':'\u2112','laquo':'\xAB','larrb':'\u21E4','larrbfs':'\u291F','larr':'\u2190','Larr':'\u219E','lArr':'\u21D0','larrfs':'\u291D','larrhk':'\u21A9','larrlp':'\u21AB','larrpl':'\u2939','larrsim':'\u2973','larrtl':'\u21A2','latail':'\u2919','lAtail':'\u291B','lat':'\u2AAB','late':'\u2AAD','lates':'\u2AAD\uFE00','lbarr':'\u290C','lBarr':'\u290E','lbbrk':'\u2772','lbrace':'{','lbrack':'[','lbrke':'\u298B','lbrksld':'\u298F','lbrkslu':'\u298D','Lcaron':'\u013D','lcaron':'\u013E','Lcedil':'\u013B','lcedil':'\u013C','lceil':'\u2308','lcub':'{','Lcy':'\u041B','lcy':'\u043B','ldca':'\u2936','ldquo':'\u201C','ldquor':'\u201E','ldrdhar':'\u2967','ldrushar':'\u294B','ldsh':'\u21B2','le':'\u2264','lE':'\u2266','LeftAngleBracket':'\u27E8','LeftArrowBar':'\u21E4','leftarrow':'\u2190','LeftArrow':'\u2190','Leftarrow':'\u21D0','LeftArrowRightArrow':'\u21C6','leftarrowtail':'\u21A2','LeftCeiling':'\u2308','LeftDoubleBracket':'\u27E6','LeftDownTeeVector':'\u2961','LeftDownVectorBar':'\u2959','LeftDownVector':'\u21C3','LeftFloor':'\u230A','leftharpoondown':'\u21BD','leftharpoonup':'\u21BC','leftleftarrows':'\u21C7','leftrightarrow':'\u2194','LeftRightArrow':'\u2194','Leftrightarrow':'\u21D4','leftrightarrows':'\u21C6','leftrightharpoons':'\u21CB','leftrightsquigarrow':'\u21AD','LeftRightVector':'\u294E','LeftTeeArrow':'\u21A4','LeftTee':'\u22A3','LeftTeeVector':'\u295A','leftthreetimes':'\u22CB','LeftTriangleBar':'\u29CF','LeftTriangle':'\u22B2','LeftTriangleEqual':'\u22B4','LeftUpDownVector':'\u2951','LeftUpTeeVector':'\u2960','LeftUpVectorBar':'\u2958','LeftUpVector':'\u21BF','LeftVectorBar':'\u2952','LeftVector':'\u21BC','lEg':'\u2A8B','leg':'\u22DA','leq':'\u2264','leqq':'\u2266','leqslant':'\u2A7D','lescc':'\u2AA8','les':'\u2A7D','lesdot':'\u2A7F','lesdoto':'\u2A81','lesdotor':'\u2A83','lesg':'\u22DA\uFE00','lesges':'\u2A93','lessapprox':'\u2A85','lessdot':'\u22D6','lesseqgtr':'\u22DA','lesseqqgtr':'\u2A8B','LessEqualGreater':'\u22DA','LessFullEqual':'\u2266','LessGreater':'\u2276','lessgtr':'\u2276','LessLess':'\u2AA1','lesssim':'\u2272','LessSlantEqual':'\u2A7D','LessTilde':'\u2272','lfisht':'\u297C','lfloor':'\u230A','Lfr':'\uD835\uDD0F','lfr':'\uD835\uDD29','lg':'\u2276','lgE':'\u2A91','lHar':'\u2962','lhard':'\u21BD','lharu':'\u21BC','lharul':'\u296A','lhblk':'\u2584','LJcy':'\u0409','ljcy':'\u0459','llarr':'\u21C7','ll':'\u226A','Ll':'\u22D8','llcorner':'\u231E','Lleftarrow':'\u21DA','llhard':'\u296B','lltri':'\u25FA','Lmidot':'\u013F','lmidot':'\u0140','lmoustache':'\u23B0','lmoust':'\u23B0','lnap':'\u2A89','lnapprox':'\u2A89','lne':'\u2A87','lnE':'\u2268','lneq':'\u2A87','lneqq':'\u2268','lnsim':'\u22E6','loang':'\u27EC','loarr':'\u21FD','lobrk':'\u27E6','longleftarrow':'\u27F5','LongLeftArrow':'\u27F5','Longleftarrow':'\u27F8','longleftrightarrow':'\u27F7','LongLeftRightArrow':'\u27F7','Longleftrightarrow':'\u27FA','longmapsto':'\u27FC','longrightarrow':'\u27F6','LongRightArrow':'\u27F6','Longrightarrow':'\u27F9','looparrowleft':'\u21AB','looparrowright':'\u21AC','lopar':'\u2985','Lopf':'\uD835\uDD43','lopf':'\uD835\uDD5D','loplus':'\u2A2D','lotimes':'\u2A34','lowast':'\u2217','lowbar':'_','LowerLeftArrow':'\u2199','LowerRightArrow':'\u2198','loz':'\u25CA','lozenge':'\u25CA','lozf':'\u29EB','lpar':'(','lparlt':'\u2993','lrarr':'\u21C6','lrcorner':'\u231F','lrhar':'\u21CB','lrhard':'\u296D','lrm':'\u200E','lrtri':'\u22BF','lsaquo':'\u2039','lscr':'\uD835\uDCC1','Lscr':'\u2112','lsh':'\u21B0','Lsh':'\u21B0','lsim':'\u2272','lsime':'\u2A8D','lsimg':'\u2A8F','lsqb':'[','lsquo':'\u2018','lsquor':'\u201A','Lstrok':'\u0141','lstrok':'\u0142','ltcc':'\u2AA6','ltcir':'\u2A79','lt':'<','LT':'<','Lt':'\u226A','ltdot':'\u22D6','lthree':'\u22CB','ltimes':'\u22C9','ltlarr':'\u2976','ltquest':'\u2A7B','ltri':'\u25C3','ltrie':'\u22B4','ltrif':'\u25C2','ltrPar':'\u2996','lurdshar':'\u294A','luruhar':'\u2966','lvertneqq':'\u2268\uFE00','lvnE':'\u2268\uFE00','macr':'\xAF','male':'\u2642','malt':'\u2720','maltese':'\u2720','Map':'\u2905','map':'\u21A6','mapsto':'\u21A6','mapstodown':'\u21A7','mapstoleft':'\u21A4','mapstoup':'\u21A5','marker':'\u25AE','mcomma':'\u2A29','Mcy':'\u041C','mcy':'\u043C','mdash':'\u2014','mDDot':'\u223A','measuredangle':'\u2221','MediumSpace':'\u205F','Mellintrf':'\u2133','Mfr':'\uD835\uDD10','mfr':'\uD835\uDD2A','mho':'\u2127','micro':'\xB5','midast':'*','midcir':'\u2AF0','mid':'\u2223','middot':'\xB7','minusb':'\u229F','minus':'\u2212','minusd':'\u2238','minusdu':'\u2A2A','MinusPlus':'\u2213','mlcp':'\u2ADB','mldr':'\u2026','mnplus':'\u2213','models':'\u22A7','Mopf':'\uD835\uDD44','mopf':'\uD835\uDD5E','mp':'\u2213','mscr':'\uD835\uDCC2','Mscr':'\u2133','mstpos':'\u223E','Mu':'\u039C','mu':'\u03BC','multimap':'\u22B8','mumap':'\u22B8','nabla':'\u2207','Nacute':'\u0143','nacute':'\u0144','nang':'\u2220\u20D2','nap':'\u2249','napE':'\u2A70\u0338','napid':'\u224B\u0338','napos':'\u0149','napprox':'\u2249','natural':'\u266E','naturals':'\u2115','natur':'\u266E','nbsp':'\xA0','nbump':'\u224E\u0338','nbumpe':'\u224F\u0338','ncap':'\u2A43','Ncaron':'\u0147','ncaron':'\u0148','Ncedil':'\u0145','ncedil':'\u0146','ncong':'\u2247','ncongdot':'\u2A6D\u0338','ncup':'\u2A42','Ncy':'\u041D','ncy':'\u043D','ndash':'\u2013','nearhk':'\u2924','nearr':'\u2197','neArr':'\u21D7','nearrow':'\u2197','ne':'\u2260','nedot':'\u2250\u0338','NegativeMediumSpace':'\u200B','NegativeThickSpace':'\u200B','NegativeThinSpace':'\u200B','NegativeVeryThinSpace':'\u200B','nequiv':'\u2262','nesear':'\u2928','nesim':'\u2242\u0338','NestedGreaterGreater':'\u226B','NestedLessLess':'\u226A','NewLine':'\n','nexist':'\u2204','nexists':'\u2204','Nfr':'\uD835\uDD11','nfr':'\uD835\uDD2B','ngE':'\u2267\u0338','nge':'\u2271','ngeq':'\u2271','ngeqq':'\u2267\u0338','ngeqslant':'\u2A7E\u0338','nges':'\u2A7E\u0338','nGg':'\u22D9\u0338','ngsim':'\u2275','nGt':'\u226B\u20D2','ngt':'\u226F','ngtr':'\u226F','nGtv':'\u226B\u0338','nharr':'\u21AE','nhArr':'\u21CE','nhpar':'\u2AF2','ni':'\u220B','nis':'\u22FC','nisd':'\u22FA','niv':'\u220B','NJcy':'\u040A','njcy':'\u045A','nlarr':'\u219A','nlArr':'\u21CD','nldr':'\u2025','nlE':'\u2266\u0338','nle':'\u2270','nleftarrow':'\u219A','nLeftarrow':'\u21CD','nleftrightarrow':'\u21AE','nLeftrightarrow':'\u21CE','nleq':'\u2270','nleqq':'\u2266\u0338','nleqslant':'\u2A7D\u0338','nles':'\u2A7D\u0338','nless':'\u226E','nLl':'\u22D8\u0338','nlsim':'\u2274','nLt':'\u226A\u20D2','nlt':'\u226E','nltri':'\u22EA','nltrie':'\u22EC','nLtv':'\u226A\u0338','nmid':'\u2224','NoBreak':'\u2060','NonBreakingSpace':'\xA0','nopf':'\uD835\uDD5F','Nopf':'\u2115','Not':'\u2AEC','not':'\xAC','NotCongruent':'\u2262','NotCupCap':'\u226D','NotDoubleVerticalBar':'\u2226','NotElement':'\u2209','NotEqual':'\u2260','NotEqualTilde':'\u2242\u0338','NotExists':'\u2204','NotGreater':'\u226F','NotGreaterEqual':'\u2271','NotGreaterFullEqual':'\u2267\u0338','NotGreaterGreater':'\u226B\u0338','NotGreaterLess':'\u2279','NotGreaterSlantEqual':'\u2A7E\u0338','NotGreaterTilde':'\u2275','NotHumpDownHump':'\u224E\u0338','NotHumpEqual':'\u224F\u0338','notin':'\u2209','notindot':'\u22F5\u0338','notinE':'\u22F9\u0338','notinva':'\u2209','notinvb':'\u22F7','notinvc':'\u22F6','NotLeftTriangleBar':'\u29CF\u0338','NotLeftTriangle':'\u22EA','NotLeftTriangleEqual':'\u22EC','NotLess':'\u226E','NotLessEqual':'\u2270','NotLessGreater':'\u2278','NotLessLess':'\u226A\u0338','NotLessSlantEqual':'\u2A7D\u0338','NotLessTilde':'\u2274','NotNestedGreaterGreater':'\u2AA2\u0338','NotNestedLessLess':'\u2AA1\u0338','notni':'\u220C','notniva':'\u220C','notnivb':'\u22FE','notnivc':'\u22FD','NotPrecedes':'\u2280','NotPrecedesEqual':'\u2AAF\u0338','NotPrecedesSlantEqual':'\u22E0','NotReverseElement':'\u220C','NotRightTriangleBar':'\u29D0\u0338','NotRightTriangle':'\u22EB','NotRightTriangleEqual':'\u22ED','NotSquareSubset':'\u228F\u0338','NotSquareSubsetEqual':'\u22E2','NotSquareSuperset':'\u2290\u0338','NotSquareSupersetEqual':'\u22E3','NotSubset':'\u2282\u20D2','NotSubsetEqual':'\u2288','NotSucceeds':'\u2281','NotSucceedsEqual':'\u2AB0\u0338','NotSucceedsSlantEqual':'\u22E1','NotSucceedsTilde':'\u227F\u0338','NotSuperset':'\u2283\u20D2','NotSupersetEqual':'\u2289','NotTilde':'\u2241','NotTildeEqual':'\u2244','NotTildeFullEqual':'\u2247','NotTildeTilde':'\u2249','NotVerticalBar':'\u2224','nparallel':'\u2226','npar':'\u2226','nparsl':'\u2AFD\u20E5','npart':'\u2202\u0338','npolint':'\u2A14','npr':'\u2280','nprcue':'\u22E0','nprec':'\u2280','npreceq':'\u2AAF\u0338','npre':'\u2AAF\u0338','nrarrc':'\u2933\u0338','nrarr':'\u219B','nrArr':'\u21CF','nrarrw':'\u219D\u0338','nrightarrow':'\u219B','nRightarrow':'\u21CF','nrtri':'\u22EB','nrtrie':'\u22ED','nsc':'\u2281','nsccue':'\u22E1','nsce':'\u2AB0\u0338','Nscr':'\uD835\uDCA9','nscr':'\uD835\uDCC3','nshortmid':'\u2224','nshortparallel':'\u2226','nsim':'\u2241','nsime':'\u2244','nsimeq':'\u2244','nsmid':'\u2224','nspar':'\u2226','nsqsube':'\u22E2','nsqsupe':'\u22E3','nsub':'\u2284','nsubE':'\u2AC5\u0338','nsube':'\u2288','nsubset':'\u2282\u20D2','nsubseteq':'\u2288','nsubseteqq':'\u2AC5\u0338','nsucc':'\u2281','nsucceq':'\u2AB0\u0338','nsup':'\u2285','nsupE':'\u2AC6\u0338','nsupe':'\u2289','nsupset':'\u2283\u20D2','nsupseteq':'\u2289','nsupseteqq':'\u2AC6\u0338','ntgl':'\u2279','Ntilde':'\xD1','ntilde':'\xF1','ntlg':'\u2278','ntriangleleft':'\u22EA','ntrianglelefteq':'\u22EC','ntriangleright':'\u22EB','ntrianglerighteq':'\u22ED','Nu':'\u039D','nu':'\u03BD','num':'#','numero':'\u2116','numsp':'\u2007','nvap':'\u224D\u20D2','nvdash':'\u22AC','nvDash':'\u22AD','nVdash':'\u22AE','nVDash':'\u22AF','nvge':'\u2265\u20D2','nvgt':'>\u20D2','nvHarr':'\u2904','nvinfin':'\u29DE','nvlArr':'\u2902','nvle':'\u2264\u20D2','nvlt':'<\u20D2','nvltrie':'\u22B4\u20D2','nvrArr':'\u2903','nvrtrie':'\u22B5\u20D2','nvsim':'\u223C\u20D2','nwarhk':'\u2923','nwarr':'\u2196','nwArr':'\u21D6','nwarrow':'\u2196','nwnear':'\u2927','Oacute':'\xD3','oacute':'\xF3','oast':'\u229B','Ocirc':'\xD4','ocirc':'\xF4','ocir':'\u229A','Ocy':'\u041E','ocy':'\u043E','odash':'\u229D','Odblac':'\u0150','odblac':'\u0151','odiv':'\u2A38','odot':'\u2299','odsold':'\u29BC','OElig':'\u0152','oelig':'\u0153','ofcir':'\u29BF','Ofr':'\uD835\uDD12','ofr':'\uD835\uDD2C','ogon':'\u02DB','Ograve':'\xD2','ograve':'\xF2','ogt':'\u29C1','ohbar':'\u29B5','ohm':'\u03A9','oint':'\u222E','olarr':'\u21BA','olcir':'\u29BE','olcross':'\u29BB','oline':'\u203E','olt':'\u29C0','Omacr':'\u014C','omacr':'\u014D','Omega':'\u03A9','omega':'\u03C9','Omicron':'\u039F','omicron':'\u03BF','omid':'\u29B6','ominus':'\u2296','Oopf':'\uD835\uDD46','oopf':'\uD835\uDD60','opar':'\u29B7','OpenCurlyDoubleQuote':'\u201C','OpenCurlyQuote':'\u2018','operp':'\u29B9','oplus':'\u2295','orarr':'\u21BB','Or':'\u2A54','or':'\u2228','ord':'\u2A5D','order':'\u2134','orderof':'\u2134','ordf':'\xAA','ordm':'\xBA','origof':'\u22B6','oror':'\u2A56','orslope':'\u2A57','orv':'\u2A5B','oS':'\u24C8','Oscr':'\uD835\uDCAA','oscr':'\u2134','Oslash':'\xD8','oslash':'\xF8','osol':'\u2298','Otilde':'\xD5','otilde':'\xF5','otimesas':'\u2A36','Otimes':'\u2A37','otimes':'\u2297','Ouml':'\xD6','ouml':'\xF6','ovbar':'\u233D','OverBar':'\u203E','OverBrace':'\u23DE','OverBracket':'\u23B4','OverParenthesis':'\u23DC','para':'\xB6','parallel':'\u2225','par':'\u2225','parsim':'\u2AF3','parsl':'\u2AFD','part':'\u2202','PartialD':'\u2202','Pcy':'\u041F','pcy':'\u043F','percnt':'%','period':'.','permil':'\u2030','perp':'\u22A5','pertenk':'\u2031','Pfr':'\uD835\uDD13','pfr':'\uD835\uDD2D','Phi':'\u03A6','phi':'\u03C6','phiv':'\u03D5','phmmat':'\u2133','phone':'\u260E','Pi':'\u03A0','pi':'\u03C0','pitchfork':'\u22D4','piv':'\u03D6','planck':'\u210F','planckh':'\u210E','plankv':'\u210F','plusacir':'\u2A23','plusb':'\u229E','pluscir':'\u2A22','plus':'+','plusdo':'\u2214','plusdu':'\u2A25','pluse':'\u2A72','PlusMinus':'\xB1','plusmn':'\xB1','plussim':'\u2A26','plustwo':'\u2A27','pm':'\xB1','Poincareplane':'\u210C','pointint':'\u2A15','popf':'\uD835\uDD61','Popf':'\u2119','pound':'\xA3','prap':'\u2AB7','Pr':'\u2ABB','pr':'\u227A','prcue':'\u227C','precapprox':'\u2AB7','prec':'\u227A','preccurlyeq':'\u227C','Precedes':'\u227A','PrecedesEqual':'\u2AAF','PrecedesSlantEqual':'\u227C','PrecedesTilde':'\u227E','preceq':'\u2AAF','precnapprox':'\u2AB9','precneqq':'\u2AB5','precnsim':'\u22E8','pre':'\u2AAF','prE':'\u2AB3','precsim':'\u227E','prime':'\u2032','Prime':'\u2033','primes':'\u2119','prnap':'\u2AB9','prnE':'\u2AB5','prnsim':'\u22E8','prod':'\u220F','Product':'\u220F','profalar':'\u232E','profline':'\u2312','profsurf':'\u2313','prop':'\u221D','Proportional':'\u221D','Proportion':'\u2237','propto':'\u221D','prsim':'\u227E','prurel':'\u22B0','Pscr':'\uD835\uDCAB','pscr':'\uD835\uDCC5','Psi':'\u03A8','psi':'\u03C8','puncsp':'\u2008','Qfr':'\uD835\uDD14','qfr':'\uD835\uDD2E','qint':'\u2A0C','qopf':'\uD835\uDD62','Qopf':'\u211A','qprime':'\u2057','Qscr':'\uD835\uDCAC','qscr':'\uD835\uDCC6','quaternions':'\u210D','quatint':'\u2A16','quest':'?','questeq':'\u225F','quot':'"','QUOT':'"','rAarr':'\u21DB','race':'\u223D\u0331','Racute':'\u0154','racute':'\u0155','radic':'\u221A','raemptyv':'\u29B3','rang':'\u27E9','Rang':'\u27EB','rangd':'\u2992','range':'\u29A5','rangle':'\u27E9','raquo':'\xBB','rarrap':'\u2975','rarrb':'\u21E5','rarrbfs':'\u2920','rarrc':'\u2933','rarr':'\u2192','Rarr':'\u21A0','rArr':'\u21D2','rarrfs':'\u291E','rarrhk':'\u21AA','rarrlp':'\u21AC','rarrpl':'\u2945','rarrsim':'\u2974','Rarrtl':'\u2916','rarrtl':'\u21A3','rarrw':'\u219D','ratail':'\u291A','rAtail':'\u291C','ratio':'\u2236','rationals':'\u211A','rbarr':'\u290D','rBarr':'\u290F','RBarr':'\u2910','rbbrk':'\u2773','rbrace':'}','rbrack':']','rbrke':'\u298C','rbrksld':'\u298E','rbrkslu':'\u2990','Rcaron':'\u0158','rcaron':'\u0159','Rcedil':'\u0156','rcedil':'\u0157','rceil':'\u2309','rcub':'}','Rcy':'\u0420','rcy':'\u0440','rdca':'\u2937','rdldhar':'\u2969','rdquo':'\u201D','rdquor':'\u201D','rdsh':'\u21B3','real':'\u211C','realine':'\u211B','realpart':'\u211C','reals':'\u211D','Re':'\u211C','rect':'\u25AD','reg':'\xAE','REG':'\xAE','ReverseElement':'\u220B','ReverseEquilibrium':'\u21CB','ReverseUpEquilibrium':'\u296F','rfisht':'\u297D','rfloor':'\u230B','rfr':'\uD835\uDD2F','Rfr':'\u211C','rHar':'\u2964','rhard':'\u21C1','rharu':'\u21C0','rharul':'\u296C','Rho':'\u03A1','rho':'\u03C1','rhov':'\u03F1','RightAngleBracket':'\u27E9','RightArrowBar':'\u21E5','rightarrow':'\u2192','RightArrow':'\u2192','Rightarrow':'\u21D2','RightArrowLeftArrow':'\u21C4','rightarrowtail':'\u21A3','RightCeiling':'\u2309','RightDoubleBracket':'\u27E7','RightDownTeeVector':'\u295D','RightDownVectorBar':'\u2955','RightDownVector':'\u21C2','RightFloor':'\u230B','rightharpoondown':'\u21C1','rightharpoonup':'\u21C0','rightleftarrows':'\u21C4','rightleftharpoons':'\u21CC','rightrightarrows':'\u21C9','rightsquigarrow':'\u219D','RightTeeArrow':'\u21A6','RightTee':'\u22A2','RightTeeVector':'\u295B','rightthreetimes':'\u22CC','RightTriangleBar':'\u29D0','RightTriangle':'\u22B3','RightTriangleEqual':'\u22B5','RightUpDownVector':'\u294F','RightUpTeeVector':'\u295C','RightUpVectorBar':'\u2954','RightUpVector':'\u21BE','RightVectorBar':'\u2953','RightVector':'\u21C0','ring':'\u02DA','risingdotseq':'\u2253','rlarr':'\u21C4','rlhar':'\u21CC','rlm':'\u200F','rmoustache':'\u23B1','rmoust':'\u23B1','rnmid':'\u2AEE','roang':'\u27ED','roarr':'\u21FE','robrk':'\u27E7','ropar':'\u2986','ropf':'\uD835\uDD63','Ropf':'\u211D','roplus':'\u2A2E','rotimes':'\u2A35','RoundImplies':'\u2970','rpar':')','rpargt':'\u2994','rppolint':'\u2A12','rrarr':'\u21C9','Rrightarrow':'\u21DB','rsaquo':'\u203A','rscr':'\uD835\uDCC7','Rscr':'\u211B','rsh':'\u21B1','Rsh':'\u21B1','rsqb':']','rsquo':'\u2019','rsquor':'\u2019','rthree':'\u22CC','rtimes':'\u22CA','rtri':'\u25B9','rtrie':'\u22B5','rtrif':'\u25B8','rtriltri':'\u29CE','RuleDelayed':'\u29F4','ruluhar':'\u2968','rx':'\u211E','Sacute':'\u015A','sacute':'\u015B','sbquo':'\u201A','scap':'\u2AB8','Scaron':'\u0160','scaron':'\u0161','Sc':'\u2ABC','sc':'\u227B','sccue':'\u227D','sce':'\u2AB0','scE':'\u2AB4','Scedil':'\u015E','scedil':'\u015F','Scirc':'\u015C','scirc':'\u015D','scnap':'\u2ABA','scnE':'\u2AB6','scnsim':'\u22E9','scpolint':'\u2A13','scsim':'\u227F','Scy':'\u0421','scy':'\u0441','sdotb':'\u22A1','sdot':'\u22C5','sdote':'\u2A66','searhk':'\u2925','searr':'\u2198','seArr':'\u21D8','searrow':'\u2198','sect':'\xA7','semi':';','seswar':'\u2929','setminus':'\u2216','setmn':'\u2216','sext':'\u2736','Sfr':'\uD835\uDD16','sfr':'\uD835\uDD30','sfrown':'\u2322','sharp':'\u266F','SHCHcy':'\u0429','shchcy':'\u0449','SHcy':'\u0428','shcy':'\u0448','ShortDownArrow':'\u2193','ShortLeftArrow':'\u2190','shortmid':'\u2223','shortparallel':'\u2225','ShortRightArrow':'\u2192','ShortUpArrow':'\u2191','shy':'\xAD','Sigma':'\u03A3','sigma':'\u03C3','sigmaf':'\u03C2','sigmav':'\u03C2','sim':'\u223C','simdot':'\u2A6A','sime':'\u2243','simeq':'\u2243','simg':'\u2A9E','simgE':'\u2AA0','siml':'\u2A9D','simlE':'\u2A9F','simne':'\u2246','simplus':'\u2A24','simrarr':'\u2972','slarr':'\u2190','SmallCircle':'\u2218','smallsetminus':'\u2216','smashp':'\u2A33','smeparsl':'\u29E4','smid':'\u2223','smile':'\u2323','smt':'\u2AAA','smte':'\u2AAC','smtes':'\u2AAC\uFE00','SOFTcy':'\u042C','softcy':'\u044C','solbar':'\u233F','solb':'\u29C4','sol':'/','Sopf':'\uD835\uDD4A','sopf':'\uD835\uDD64','spades':'\u2660','spadesuit':'\u2660','spar':'\u2225','sqcap':'\u2293','sqcaps':'\u2293\uFE00','sqcup':'\u2294','sqcups':'\u2294\uFE00','Sqrt':'\u221A','sqsub':'\u228F','sqsube':'\u2291','sqsubset':'\u228F','sqsubseteq':'\u2291','sqsup':'\u2290','sqsupe':'\u2292','sqsupset':'\u2290','sqsupseteq':'\u2292','square':'\u25A1','Square':'\u25A1','SquareIntersection':'\u2293','SquareSubset':'\u228F','SquareSubsetEqual':'\u2291','SquareSuperset':'\u2290','SquareSupersetEqual':'\u2292','SquareUnion':'\u2294','squarf':'\u25AA','squ':'\u25A1','squf':'\u25AA','srarr':'\u2192','Sscr':'\uD835\uDCAE','sscr':'\uD835\uDCC8','ssetmn':'\u2216','ssmile':'\u2323','sstarf':'\u22C6','Star':'\u22C6','star':'\u2606','starf':'\u2605','straightepsilon':'\u03F5','straightphi':'\u03D5','strns':'\xAF','sub':'\u2282','Sub':'\u22D0','subdot':'\u2ABD','subE':'\u2AC5','sube':'\u2286','subedot':'\u2AC3','submult':'\u2AC1','subnE':'\u2ACB','subne':'\u228A','subplus':'\u2ABF','subrarr':'\u2979','subset':'\u2282','Subset':'\u22D0','subseteq':'\u2286','subseteqq':'\u2AC5','SubsetEqual':'\u2286','subsetneq':'\u228A','subsetneqq':'\u2ACB','subsim':'\u2AC7','subsub':'\u2AD5','subsup':'\u2AD3','succapprox':'\u2AB8','succ':'\u227B','succcurlyeq':'\u227D','Succeeds':'\u227B','SucceedsEqual':'\u2AB0','SucceedsSlantEqual':'\u227D','SucceedsTilde':'\u227F','succeq':'\u2AB0','succnapprox':'\u2ABA','succneqq':'\u2AB6','succnsim':'\u22E9','succsim':'\u227F','SuchThat':'\u220B','sum':'\u2211','Sum':'\u2211','sung':'\u266A','sup1':'\xB9','sup2':'\xB2','sup3':'\xB3','sup':'\u2283','Sup':'\u22D1','supdot':'\u2ABE','supdsub':'\u2AD8','supE':'\u2AC6','supe':'\u2287','supedot':'\u2AC4','Superset':'\u2283','SupersetEqual':'\u2287','suphsol':'\u27C9','suphsub':'\u2AD7','suplarr':'\u297B','supmult':'\u2AC2','supnE':'\u2ACC','supne':'\u228B','supplus':'\u2AC0','supset':'\u2283','Supset':'\u22D1','supseteq':'\u2287','supseteqq':'\u2AC6','supsetneq':'\u228B','supsetneqq':'\u2ACC','supsim':'\u2AC8','supsub':'\u2AD4','supsup':'\u2AD6','swarhk':'\u2926','swarr':'\u2199','swArr':'\u21D9','swarrow':'\u2199','swnwar':'\u292A','szlig':'\xDF','Tab':'\t','target':'\u2316','Tau':'\u03A4','tau':'\u03C4','tbrk':'\u23B4','Tcaron':'\u0164','tcaron':'\u0165','Tcedil':'\u0162','tcedil':'\u0163','Tcy':'\u0422','tcy':'\u0442','tdot':'\u20DB','telrec':'\u2315','Tfr':'\uD835\uDD17','tfr':'\uD835\uDD31','there4':'\u2234','therefore':'\u2234','Therefore':'\u2234','Theta':'\u0398','theta':'\u03B8','thetasym':'\u03D1','thetav':'\u03D1','thickapprox':'\u2248','thicksim':'\u223C','ThickSpace':'\u205F\u200A','ThinSpace':'\u2009','thinsp':'\u2009','thkap':'\u2248','thksim':'\u223C','THORN':'\xDE','thorn':'\xFE','tilde':'\u02DC','Tilde':'\u223C','TildeEqual':'\u2243','TildeFullEqual':'\u2245','TildeTilde':'\u2248','timesbar':'\u2A31','timesb':'\u22A0','times':'\xD7','timesd':'\u2A30','tint':'\u222D','toea':'\u2928','topbot':'\u2336','topcir':'\u2AF1','top':'\u22A4','Topf':'\uD835\uDD4B','topf':'\uD835\uDD65','topfork':'\u2ADA','tosa':'\u2929','tprime':'\u2034','trade':'\u2122','TRADE':'\u2122','triangle':'\u25B5','triangledown':'\u25BF','triangleleft':'\u25C3','trianglelefteq':'\u22B4','triangleq':'\u225C','triangleright':'\u25B9','trianglerighteq':'\u22B5','tridot':'\u25EC','trie':'\u225C','triminus':'\u2A3A','TripleDot':'\u20DB','triplus':'\u2A39','trisb':'\u29CD','tritime':'\u2A3B','trpezium':'\u23E2','Tscr':'\uD835\uDCAF','tscr':'\uD835\uDCC9','TScy':'\u0426','tscy':'\u0446','TSHcy':'\u040B','tshcy':'\u045B','Tstrok':'\u0166','tstrok':'\u0167','twixt':'\u226C','twoheadleftarrow':'\u219E','twoheadrightarrow':'\u21A0','Uacute':'\xDA','uacute':'\xFA','uarr':'\u2191','Uarr':'\u219F','uArr':'\u21D1','Uarrocir':'\u2949','Ubrcy':'\u040E','ubrcy':'\u045E','Ubreve':'\u016C','ubreve':'\u016D','Ucirc':'\xDB','ucirc':'\xFB','Ucy':'\u0423','ucy':'\u0443','udarr':'\u21C5','Udblac':'\u0170','udblac':'\u0171','udhar':'\u296E','ufisht':'\u297E','Ufr':'\uD835\uDD18','ufr':'\uD835\uDD32','Ugrave':'\xD9','ugrave':'\xF9','uHar':'\u2963','uharl':'\u21BF','uharr':'\u21BE','uhblk':'\u2580','ulcorn':'\u231C','ulcorner':'\u231C','ulcrop':'\u230F','ultri':'\u25F8','Umacr':'\u016A','umacr':'\u016B','uml':'\xA8','UnderBar':'_','UnderBrace':'\u23DF','UnderBracket':'\u23B5','UnderParenthesis':'\u23DD','Union':'\u22C3','UnionPlus':'\u228E','Uogon':'\u0172','uogon':'\u0173','Uopf':'\uD835\uDD4C','uopf':'\uD835\uDD66','UpArrowBar':'\u2912','uparrow':'\u2191','UpArrow':'\u2191','Uparrow':'\u21D1','UpArrowDownArrow':'\u21C5','updownarrow':'\u2195','UpDownArrow':'\u2195','Updownarrow':'\u21D5','UpEquilibrium':'\u296E','upharpoonleft':'\u21BF','upharpoonright':'\u21BE','uplus':'\u228E','UpperLeftArrow':'\u2196','UpperRightArrow':'\u2197','upsi':'\u03C5','Upsi':'\u03D2','upsih':'\u03D2','Upsilon':'\u03A5','upsilon':'\u03C5','UpTeeArrow':'\u21A5','UpTee':'\u22A5','upuparrows':'\u21C8','urcorn':'\u231D','urcorner':'\u231D','urcrop':'\u230E','Uring':'\u016E','uring':'\u016F','urtri':'\u25F9','Uscr':'\uD835\uDCB0','uscr':'\uD835\uDCCA','utdot':'\u22F0','Utilde':'\u0168','utilde':'\u0169','utri':'\u25B5','utrif':'\u25B4','uuarr':'\u21C8','Uuml':'\xDC','uuml':'\xFC','uwangle':'\u29A7','vangrt':'\u299C','varepsilon':'\u03F5','varkappa':'\u03F0','varnothing':'\u2205','varphi':'\u03D5','varpi':'\u03D6','varpropto':'\u221D','varr':'\u2195','vArr':'\u21D5','varrho':'\u03F1','varsigma':'\u03C2','varsubsetneq':'\u228A\uFE00','varsubsetneqq':'\u2ACB\uFE00','varsupsetneq':'\u228B\uFE00','varsupsetneqq':'\u2ACC\uFE00','vartheta':'\u03D1','vartriangleleft':'\u22B2','vartriangleright':'\u22B3','vBar':'\u2AE8','Vbar':'\u2AEB','vBarv':'\u2AE9','Vcy':'\u0412','vcy':'\u0432','vdash':'\u22A2','vDash':'\u22A8','Vdash':'\u22A9','VDash':'\u22AB','Vdashl':'\u2AE6','veebar':'\u22BB','vee':'\u2228','Vee':'\u22C1','veeeq':'\u225A','vellip':'\u22EE','verbar':'|','Verbar':'\u2016','vert':'|','Vert':'\u2016','VerticalBar':'\u2223','VerticalLine':'|','VerticalSeparator':'\u2758','VerticalTilde':'\u2240','VeryThinSpace':'\u200A','Vfr':'\uD835\uDD19','vfr':'\uD835\uDD33','vltri':'\u22B2','vnsub':'\u2282\u20D2','vnsup':'\u2283\u20D2','Vopf':'\uD835\uDD4D','vopf':'\uD835\uDD67','vprop':'\u221D','vrtri':'\u22B3','Vscr':'\uD835\uDCB1','vscr':'\uD835\uDCCB','vsubnE':'\u2ACB\uFE00','vsubne':'\u228A\uFE00','vsupnE':'\u2ACC\uFE00','vsupne':'\u228B\uFE00','Vvdash':'\u22AA','vzigzag':'\u299A','Wcirc':'\u0174','wcirc':'\u0175','wedbar':'\u2A5F','wedge':'\u2227','Wedge':'\u22C0','wedgeq':'\u2259','weierp':'\u2118','Wfr':'\uD835\uDD1A','wfr':'\uD835\uDD34','Wopf':'\uD835\uDD4E','wopf':'\uD835\uDD68','wp':'\u2118','wr':'\u2240','wreath':'\u2240','Wscr':'\uD835\uDCB2','wscr':'\uD835\uDCCC','xcap':'\u22C2','xcirc':'\u25EF','xcup':'\u22C3','xdtri':'\u25BD','Xfr':'\uD835\uDD1B','xfr':'\uD835\uDD35','xharr':'\u27F7','xhArr':'\u27FA','Xi':'\u039E','xi':'\u03BE','xlarr':'\u27F5','xlArr':'\u27F8','xmap':'\u27FC','xnis':'\u22FB','xodot':'\u2A00','Xopf':'\uD835\uDD4F','xopf':'\uD835\uDD69','xoplus':'\u2A01','xotime':'\u2A02','xrarr':'\u27F6','xrArr':'\u27F9','Xscr':'\uD835\uDCB3','xscr':'\uD835\uDCCD','xsqcup':'\u2A06','xuplus':'\u2A04','xutri':'\u25B3','xvee':'\u22C1','xwedge':'\u22C0','Yacute':'\xDD','yacute':'\xFD','YAcy':'\u042F','yacy':'\u044F','Ycirc':'\u0176','ycirc':'\u0177','Ycy':'\u042B','ycy':'\u044B','yen':'\xA5','Yfr':'\uD835\uDD1C','yfr':'\uD835\uDD36','YIcy':'\u0407','yicy':'\u0457','Yopf':'\uD835\uDD50','yopf':'\uD835\uDD6A','Yscr':'\uD835\uDCB4','yscr':'\uD835\uDCCE','YUcy':'\u042E','yucy':'\u044E','yuml':'\xFF','Yuml':'\u0178','Zacute':'\u0179','zacute':'\u017A','Zcaron':'\u017D','zcaron':'\u017E','Zcy':'\u0417','zcy':'\u0437','Zdot':'\u017B','zdot':'\u017C','zeetrf':'\u2128','ZeroWidthSpace':'\u200B','Zeta':'\u0396','zeta':'\u03B6','zfr':'\uD835\uDD37','Zfr':'\u2128','ZHcy':'\u0416','zhcy':'\u0436','zigrarr':'\u21DD','zopf':'\uD835\uDD6B','Zopf':'\u2124','Zscr':'\uD835\uDCB5','zscr':'\uD835\uDCCF','zwj':'\u200D','zwnj':'\u200C'};
		var decodeMapLegacy = {'Aacute':'\xC1','aacute':'\xE1','Acirc':'\xC2','acirc':'\xE2','acute':'\xB4','AElig':'\xC6','aelig':'\xE6','Agrave':'\xC0','agrave':'\xE0','amp':'&','AMP':'&','Aring':'\xC5','aring':'\xE5','Atilde':'\xC3','atilde':'\xE3','Auml':'\xC4','auml':'\xE4','brvbar':'\xA6','Ccedil':'\xC7','ccedil':'\xE7','cedil':'\xB8','cent':'\xA2','copy':'\xA9','COPY':'\xA9','curren':'\xA4','deg':'\xB0','divide':'\xF7','Eacute':'\xC9','eacute':'\xE9','Ecirc':'\xCA','ecirc':'\xEA','Egrave':'\xC8','egrave':'\xE8','ETH':'\xD0','eth':'\xF0','Euml':'\xCB','euml':'\xEB','frac12':'\xBD','frac14':'\xBC','frac34':'\xBE','gt':'>','GT':'>','Iacute':'\xCD','iacute':'\xED','Icirc':'\xCE','icirc':'\xEE','iexcl':'\xA1','Igrave':'\xCC','igrave':'\xEC','iquest':'\xBF','Iuml':'\xCF','iuml':'\xEF','laquo':'\xAB','lt':'<','LT':'<','macr':'\xAF','micro':'\xB5','middot':'\xB7','nbsp':'\xA0','not':'\xAC','Ntilde':'\xD1','ntilde':'\xF1','Oacute':'\xD3','oacute':'\xF3','Ocirc':'\xD4','ocirc':'\xF4','Ograve':'\xD2','ograve':'\xF2','ordf':'\xAA','ordm':'\xBA','Oslash':'\xD8','oslash':'\xF8','Otilde':'\xD5','otilde':'\xF5','Ouml':'\xD6','ouml':'\xF6','para':'\xB6','plusmn':'\xB1','pound':'\xA3','quot':'"','QUOT':'"','raquo':'\xBB','reg':'\xAE','REG':'\xAE','sect':'\xA7','shy':'\xAD','sup1':'\xB9','sup2':'\xB2','sup3':'\xB3','szlig':'\xDF','THORN':'\xDE','thorn':'\xFE','times':'\xD7','Uacute':'\xDA','uacute':'\xFA','Ucirc':'\xDB','ucirc':'\xFB','Ugrave':'\xD9','ugrave':'\xF9','uml':'\xA8','Uuml':'\xDC','uuml':'\xFC','Yacute':'\xDD','yacute':'\xFD','yen':'\xA5','yuml':'\xFF'};
		var decodeMapNumeric = {'0':'\uFFFD','128':'\u20AC','130':'\u201A','131':'\u0192','132':'\u201E','133':'\u2026','134':'\u2020','135':'\u2021','136':'\u02C6','137':'\u2030','138':'\u0160','139':'\u2039','140':'\u0152','142':'\u017D','145':'\u2018','146':'\u2019','147':'\u201C','148':'\u201D','149':'\u2022','150':'\u2013','151':'\u2014','152':'\u02DC','153':'\u2122','154':'\u0161','155':'\u203A','156':'\u0153','158':'\u017E','159':'\u0178'};
		var invalidReferenceCodePoints = [1,2,3,4,5,6,7,8,11,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,127,128,129,130,131,132,133,134,135,136,137,138,139,140,141,142,143,144,145,146,147,148,149,150,151,152,153,154,155,156,157,158,159,64976,64977,64978,64979,64980,64981,64982,64983,64984,64985,64986,64987,64988,64989,64990,64991,64992,64993,64994,64995,64996,64997,64998,64999,65000,65001,65002,65003,65004,65005,65006,65007,65534,65535,131070,131071,196606,196607,262142,262143,327678,327679,393214,393215,458750,458751,524286,524287,589822,589823,655358,655359,720894,720895,786430,786431,851966,851967,917502,917503,983038,983039,1048574,1048575,1114110,1114111];
	
		/*--------------------------------------------------------------------------*/
	
		var stringFromCharCode = String.fromCharCode;
	
		var object = {};
		var hasOwnProperty = object.hasOwnProperty;
		var has = function(object, propertyName) {
			return hasOwnProperty.call(object, propertyName);
		};
	
		var contains = function(array, value) {
			var index = -1;
			var length = array.length;
			while (++index < length) {
				if (array[index] == value) {
					return true;
				}
			}
			return false;
		};
	
		var merge = function(options, defaults) {
			if (!options) {
				return defaults;
			}
			var result = {};
			var key;
			for (key in defaults) {
				// A `hasOwnProperty` check is not needed here, since only recognized
				// option names are used anyway. Any others are ignored.
				result[key] = has(options, key) ? options[key] : defaults[key];
			}
			return result;
		};
	
		// Modified version of `ucs2encode`; see http://mths.be/punycode.
		var codePointToSymbol = function(codePoint, strict) {
			var output = '';
			if ((codePoint >= 0xD800 && codePoint <= 0xDFFF) || codePoint > 0x10FFFF) {
				// See issue #4:
				// “Otherwise, if the number is in the range 0xD800 to 0xDFFF or is
				// greater than 0x10FFFF, then this is a parse error. Return a U+FFFD
				// REPLACEMENT CHARACTER.”
				if (strict) {
					parseError('character reference outside the permissible Unicode range');
				}
				return '\uFFFD';
			}
			if (has(decodeMapNumeric, codePoint)) {
				if (strict) {
					parseError('disallowed character reference');
				}
				return decodeMapNumeric[codePoint];
			}
			if (strict && contains(invalidReferenceCodePoints, codePoint)) {
				parseError('disallowed character reference');
			}
			if (codePoint > 0xFFFF) {
				codePoint -= 0x10000;
				output += stringFromCharCode(codePoint >>> 10 & 0x3FF | 0xD800);
				codePoint = 0xDC00 | codePoint & 0x3FF;
			}
			output += stringFromCharCode(codePoint);
			return output;
		};
	
		var hexEscape = function(symbol) {
			return '&#x' + symbol.charCodeAt(0).toString(16).toUpperCase() + ';';
		};
	
		var parseError = function(message) {
			throw Error('Parse error: ' + message);
		};
	
		/*--------------------------------------------------------------------------*/
	
		var encode = function(string, options) {
			options = merge(options, encode.options);
			var strict = options.strict;
			if (strict && regexInvalidRawCodePoint.test(string)) {
				parseError('forbidden code point');
			}
			var encodeEverything = options.encodeEverything;
			var useNamedReferences = options.useNamedReferences;
			var allowUnsafeSymbols = options.allowUnsafeSymbols;
			if (encodeEverything) {
				// Encode ASCII symbols.
				string = string.replace(regexAsciiWhitelist, function(symbol) {
					// Use named references if requested & possible.
					if (useNamedReferences && has(encodeMap, symbol)) {
						return '&' + encodeMap[symbol] + ';';
					}
					return hexEscape(symbol);
				});
				// Shorten a few escapes that represent two symbols, of which at least one
				// is within the ASCII range.
				if (useNamedReferences) {
					string = string
						.replace(/&gt;\u20D2/g, '&nvgt;')
						.replace(/&lt;\u20D2/g, '&nvlt;')
						.replace(/&#x66;&#x6A;/g, '&fjlig;');
				}
				// Encode non-ASCII symbols.
				if (useNamedReferences) {
					// Encode non-ASCII symbols that can be replaced with a named reference.
					string = string.replace(regexEncodeNonAscii, function(string) {
						// Note: there is no need to check `has(encodeMap, string)` here.
						return '&' + encodeMap[string] + ';';
					});
				}
				// Note: any remaining non-ASCII symbols are handled outside of the `if`.
			} else if (useNamedReferences) {
				// Apply named character references.
				// Encode `<>"'&` using named character references.
				if (!allowUnsafeSymbols) {
					string = string.replace(regexEscape, function(string) {
						return '&' + encodeMap[string] + ';'; // no need to check `has()` here
					});
				}
				// Shorten escapes that represent two symbols, of which at least one is
				// `<>"'&`.
				string = string
					.replace(/&gt;\u20D2/g, '&nvgt;')
					.replace(/&lt;\u20D2/g, '&nvlt;');
				// Encode non-ASCII symbols that can be replaced with a named reference.
				string = string.replace(regexEncodeNonAscii, function(string) {
					// Note: there is no need to check `has(encodeMap, string)` here.
					return '&' + encodeMap[string] + ';';
				});
			} else if (!allowUnsafeSymbols) {
				// Encode `<>"'&` using hexadecimal escapes, now that they’re not handled
				// using named character references.
				string = string.replace(regexEscape, hexEscape);
			}
			return string
				// Encode astral symbols.
				.replace(regexAstralSymbols, function($0) {
					// https://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
					var high = $0.charCodeAt(0);
					var low = $0.charCodeAt(1);
					var codePoint = (high - 0xD800) * 0x400 + low - 0xDC00 + 0x10000;
					return '&#x' + codePoint.toString(16).toUpperCase() + ';';
				})
				// Encode any remaining BMP symbols that are not printable ASCII symbols
				// using a hexadecimal escape.
				.replace(regexBmpWhitelist, hexEscape);
		};
		// Expose default options (so they can be overridden globally).
		encode.options = {
			'allowUnsafeSymbols': false,
			'encodeEverything': false,
			'strict': false,
			'useNamedReferences': false
		};
	
		var decode = function(html, options) {
			options = merge(options, decode.options);
			var strict = options.strict;
			if (strict && regexInvalidEntity.test(html)) {
				parseError('malformed character reference');
			}
			return html.replace(regexDecode, function($0, $1, $2, $3, $4, $5, $6, $7) {
				var codePoint;
				var semicolon;
				var hexDigits;
				var reference;
				var next;
				if ($1) {
					// Decode decimal escapes, e.g. `&#119558;`.
					codePoint = $1;
					semicolon = $2;
					if (strict && !semicolon) {
						parseError('character reference was not terminated by a semicolon');
					}
					return codePointToSymbol(codePoint, strict);
				}
				if ($3) {
					// Decode hexadecimal escapes, e.g. `&#x1D306;`.
					hexDigits = $3;
					semicolon = $4;
					if (strict && !semicolon) {
						parseError('character reference was not terminated by a semicolon');
					}
					codePoint = parseInt(hexDigits, 16);
					return codePointToSymbol(codePoint, strict);
				}
				if ($5) {
					// Decode named character references with trailing `;`, e.g. `&copy;`.
					reference = $5;
					if (has(decodeMap, reference)) {
						return decodeMap[reference];
					} else {
						// Ambiguous ampersand; see http://mths.be/notes/ambiguous-ampersands.
						if (strict) {
							parseError(
								'named character reference was not terminated by a semicolon'
							);
						}
						return $0;
					}
				}
				// If we’re still here, it’s a legacy reference for sure. No need for an
				// extra `if` check.
				// Decode named character references without trailing `;`, e.g. `&amp`
				// This is only a parse error if it gets converted to `&`, or if it is
				// followed by `=` in an attribute context.
				reference = $6;
				next = $7;
				if (next && options.isAttributeValue) {
					if (strict && next == '=') {
						parseError('`&` did not start a character reference');
					}
					return $0;
				} else {
					if (strict) {
						parseError(
							'named character reference was not terminated by a semicolon'
						);
					}
					// Note: there is no need to check `has(decodeMapLegacy, reference)`.
					return decodeMapLegacy[reference] + (next || '');
				}
			});
		};
		// Expose default options (so they can be overridden globally).
		decode.options = {
			'isAttributeValue': false,
			'strict': false
		};
	
		var escape = function(string) {
			return string.replace(regexEscape, function($0) {
				// Note: there is no need to check `has(escapeMap, $0)` here.
				return escapeMap[$0];
			});
		};
	
		/*--------------------------------------------------------------------------*/
	
		var he = {
			'version': '0.5.0',
			'encode': encode,
			'decode': decode,
			'escape': escape,
			'unescape': decode
		};
	
		// Some AMD build optimizers, like r.js, check for specific condition patterns
		// like the following:
		if (
			true
		) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
				return he;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		}	else if (freeExports && !freeExports.nodeType) {
			if (freeModule) { // in Node.js or RingoJS v0.8.0+
				freeModule.exports = he;
			} else { // in Narwhal or RingoJS v0.7.0-
				for (var key in he) {
					has(he, key) && (freeExports[key] = he[key]);
				}
			}
		} else { // in Rhino or a web browser
			root.he = he;
		}
	
	}(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(157)(module), (function() { return this; }())))

/***/ }),
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(1398);
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	module.exports = Symbol;


/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(542),
	    getRawTag = __webpack_require__(1395),
	    objectToString = __webpack_require__(1397);
	
	/** `Object#toString` result references. */
	var nullTag = '[object Null]',
	    undefinedTag = '[object Undefined]';
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	module.exports = baseGetTag;


/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(1401),
	    isArrayLike = __webpack_require__(1402),
	    isIndex = __webpack_require__(1396),
	    isObject = __webpack_require__(337);
	
	/**
	 * Checks if the given arguments are from an iteratee call.
	 *
	 * @private
	 * @param {*} value The potential iteratee value argument.
	 * @param {*} index The potential iteratee index or key argument.
	 * @param {*} object The potential iteratee object argument.
	 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	 *  else `false`.
	 */
	function isIterateeCall(value, index, object) {
	  if (!isObject(object)) {
	    return false;
	  }
	  var type = typeof index;
	  if (type == 'number'
	        ? (isArrayLike(object) && isIndex(index, object.length))
	        : (type == 'string' && index in object)
	      ) {
	    return eq(object[index], value);
	  }
	  return false;
	}
	
	module.exports = isIterateeCall;


/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

	var toNumber = __webpack_require__(1409);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0,
	    MAX_INTEGER = 1.7976931348623157e+308;
	
	/**
	 * Converts `value` to a finite number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.12.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted number.
	 * @example
	 *
	 * _.toFinite(3.2);
	 * // => 3.2
	 *
	 * _.toFinite(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toFinite(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toFinite('3.2');
	 * // => 3.2
	 */
	function toFinite(value) {
	  if (!value) {
	    return value === 0 ? value : 0;
	  }
	  value = toNumber(value);
	  if (value === INFINITY || value === -INFINITY) {
	    var sign = (value < 0 ? -1 : 1);
	    return sign * MAX_INTEGER;
	  }
	  return value === value ? value : 0;
	}
	
	module.exports = toFinite;


/***/ }),
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

	var baseProperty = __webpack_require__(1462);
	
	/**
	 * Gets the "length" property value of `object`.
	 *
	 * **Note:** This function is used to avoid a [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792)
	 * that affects Safari on at least iOS 8.1-8.3 ARM64.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {*} Returns the "length" value.
	 */
	var getLength = baseProperty('length');
	
	module.exports = getLength;


/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

	var isNative = __webpack_require__(1470);
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = object == null ? undefined : object[key];
	  return isNative(value) ? value : undefined;
	}
	
	module.exports = getNative;


/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

	var getLength = __webpack_require__(565),
	    isLength = __webpack_require__(184);
	
	/**
	 * Checks if `value` is array-like.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 */
	function isArrayLike(value) {
	  return value != null && isLength(getLength(value));
	}
	
	module.exports = isArrayLike;


/***/ }),
/* 568 */
/***/ (function(module, exports) {

	/** Used to detect unsigned integer values. */
	var reIsUint = /^\d+$/;
	
	/**
	 * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
	 * of an array-like value.
	 */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  value = (typeof value == 'number' || reIsUint.test(value)) ? +value : -1;
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return value > -1 && value % 1 == 0 && value < length;
	}
	
	module.exports = isIndex;


/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(244);
	
	/**
	 * Converts `value` to an object if it's not one.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {Object} Returns the object.
	 */
	function toObject(value) {
	  return isObject(value) ? value : Object(value);
	}
	
	module.exports = toObject;


/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(567),
	    isObjectLike = __webpack_require__(243);
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Native method references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * Checks if `value` is classified as an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	function isArguments(value) {
	  return isObjectLike(value) && isArrayLike(value) &&
	    hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
	}
	
	module.exports = isArguments;


/***/ }),
/* 571 */
/***/ (function(module, exports) {

	/**
	 * @author Titus Wormer
	 * @copyright 2015 Titus Wormer
	 * @license MIT
	 * @module mdast:defaults
	 * @version 2.3.2
	 * @fileoverview Default values for parse and
	 *  stringification settings.
	 */
	
	'use strict';
	
	/* eslint-env commonjs */
	
	/*
	 * Note that `stringify.entities` is a string.
	 */
	
	module.exports = {
	    'parse': {
	        'position': true,
	        'gfm': true,
	        'yaml': true,
	        'commonmark': false,
	        'footnotes': false,
	        'pedantic': false,
	        'breaks': false
	    },
	    'stringify': {
	        'entities': 'false',
	        'setext': false,
	        'closeAtx': false,
	        'looseTable': false,
	        'spacedTable': true,
	        'incrementListMarker': true,
	        'fences': false,
	        'fence': '`',
	        'bullet': '-',
	        'listItemIndent': 'tab',
	        'rule': '*',
	        'ruleSpaces': true,
	        'ruleRepetition': 3,
	        'strong': '*',
	        'emphasis': '_'
	    }
	};


/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author Titus Wormer
	 * @copyright 2015 Titus Wormer
	 * @license MIT
	 * @module mdast:utilities
	 * @version 2.3.2
	 * @fileoverview Collection of tiny helpers useful for
	 *   both parsing and compiling markdown.
	 */
	
	'use strict';
	
	/* eslint-env commonjs */
	
	/*
	 * Dependencies.
	 */
	
	var collapseWhiteSpace = __webpack_require__(501);
	
	/*
	 * Expressions.
	 */
	
	var EXPRESSION_LINE_BREAKS = /\r\n|\r/g;
	var EXPRESSION_SYMBOL_FOR_NEW_LINE = /\u2424/g;
	var EXPRESSION_BOM = /^\ufeff/;
	
	/**
	 * Throw an exception with in its `message` `value`
	 * and `name`.
	 *
	 * @param {*} value - Invalid value.
	 * @param {string} name - Setting name.
	 */
	function raise(value, name) {
	    throw new Error(
	        'Invalid value `' + value + '` ' +
	        'for setting `' + name + '`'
	    );
	}
	
	/**
	 * Validate a value to be boolean. Defaults to `def`.
	 * Raises an exception with `context[name]` when not
	 * a boolean.
	 *
	 * @example
	 *   validateBoolean({foo: null}, 'foo', true) // true
	 *   validateBoolean({foo: false}, 'foo', true) // false
	 *   validateBoolean({foo: 'bar'}, 'foo', true) // Throws
	 *
	 * @throws {Error} - When a setting is neither omitted nor
	 *   a boolean.
	 * @param {Object} context - Settings.
	 * @param {string} name - Setting name.
	 * @param {boolean} def - Default value.
	 */
	function validateBoolean(context, name, def) {
	    var value = context[name];
	
	    if (value === null || value === undefined) {
	        value = def;
	    }
	
	    if (typeof value !== 'boolean') {
	        raise(value, 'options.' + name);
	    }
	
	    context[name] = value;
	}
	
	/**
	 * Validate a value to be boolean. Defaults to `def`.
	 * Raises an exception with `context[name]` when not
	 * a boolean.
	 *
	 * @example
	 *   validateNumber({foo: null}, 'foo', 1) // 1
	 *   validateNumber({foo: 2}, 'foo', 1) // 2
	 *   validateNumber({foo: 'bar'}, 'foo', 1) // Throws
	 *
	 * @throws {Error} - When a setting is neither omitted nor
	 *   a number.
	 * @param {Object} context - Settings.
	 * @param {string} name - Setting name.
	 * @param {number} def - Default value.
	 */
	function validateNumber(context, name, def) {
	    var value = context[name];
	
	    if (value === null || value === undefined) {
	        value = def;
	    }
	
	    if (typeof value !== 'number' || value !== value) {
	        raise(value, 'options.' + name);
	    }
	
	    context[name] = value;
	}
	
	/**
	 * Validate a value to be in `map`. Defaults to `def`.
	 * Raises an exception with `context[name]` when not
	 * not in `map`.
	 *
	 * @example
	 *   var map = {bar: true, baz: true};
	 *   validateString({foo: null}, 'foo', 'bar', map) // 'bar'
	 *   validateString({foo: 'baz'}, 'foo', 'bar', map) // 'baz'
	 *   validateString({foo: true}, 'foo', 'bar', map) // Throws
	 *
	 * @throws {Error} - When a setting is neither omitted nor
	 *   in `map`.
	 * @param {Object} context - Settings.
	 * @param {string} name - Setting name.
	 * @param {string} def - Default value.
	 * @param {Object} map - Enum.
	 */
	function validateString(context, name, def, map) {
	    var value = context[name];
	
	    if (value === null || value === undefined) {
	        value = def;
	    }
	
	    if (!(value in map)) {
	        raise(value, 'options.' + name);
	    }
	
	    context[name] = value;
	}
	
	/**
	 * Clean a string in preperation of parsing.
	 *
	 * @example
	 *   clean('\ufefffoo'); // 'foo'
	 *   clean('foo\r\nbar'); // 'foo\nbar'
	 *   clean('foo\u2424bar'); // 'foo\nbar'
	 *
	 * @param {string} value - Content to clean.
	 * @return {string} - Cleaned content.
	 */
	function clean(value) {
	    return String(value)
	        .replace(EXPRESSION_BOM, '')
	        .replace(EXPRESSION_LINE_BREAKS, '\n')
	        .replace(EXPRESSION_SYMBOL_FOR_NEW_LINE, '\n');
	}
	
	/**
	 * Normalize an identifier.  Collapses multiple white space
	 * characters into a single space, and removes casing.
	 *
	 * @example
	 *   normalizeIdentifier('FOO\t bar'); // 'foo bar'
	 *
	 * @param {string} value - Content to normalize.
	 * @return {string} - Normalized content.
	 */
	function normalizeIdentifier(value) {
	    return collapseWhiteSpace(value).toLowerCase();
	}
	
	/*
	 * Expose `validate`.
	 */
	
	exports.validate = {
	    'boolean': validateBoolean,
	    'string': validateString,
	    'number': validateNumber
	};
	
	/*
	 * Expose.
	 */
	
	exports.normalizeIdentifier = normalizeIdentifier;
	exports.clean = clean;
	exports.raise = raise;


/***/ }),
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */
/***/ (function(module, exports) {

	'use strict';
	
	var toStr = Object.prototype.toString;
	
	module.exports = function isArguments(value) {
		var str = toStr.call(value);
		var isArgs = str === '[object Arguments]';
		if (!isArgs) {
			isArgs = str !== '[object Array]' &&
				value !== null &&
				typeof value === 'object' &&
				typeof value.length === 'number' &&
				value.length >= 0 &&
				toStr.call(value.callee) === '[object Function]';
		}
		return isArgs;
	};


/***/ }),
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */
/***/ (function(module, exports) {

	module.exports = "# Title - Short\n\nEPS Assembly Module (K-7)\n\n# Title - Long\n\nEmergency Preparedness Squad (Know the Risks)\n\n# Description - Short\n\nLive presentation module 'Know the Risks' for Emergency Preparedness Squad trains kids as emergency preparedness superheroes to make sure families are ready when disaster strikes!\n\n# Description - Long\n\nEmergency Preparedness Squad trains kids as emergency preparedness superheroes to make sure families are ready when disaster strikes!\n\n# Description - Levels\n&nbsp;\n&nbsp;\nKnow the Risks live presentation module only\n&nbsp;\n&nbsp;\n\n# Level 1\nTitle: Know the Risks\nDescription: Gives an A-Z overview of different disasters, introduces ways we can be better prepared, and teaches the Superhero Calming Breath!\n"

/***/ }),
/* 723 */
/***/ (function(module, exports) {

	module.exports = "### Data Usage Policy\n\n#### (last updated on April 28, 2021 to distinguish between Institutional Users and Household Users)\n\n&nbsp;\n\n##### 1. Introduction\n\nThis document outlines how DreamRider Productions (“DreamRider”, “we”, “us”) collects, uses, discloses, transfers and stores information about users (the \"User”, \"you\") of the Planet Protector Academy (the “Academy”) suite of environmental education programs (the “Programs”) and similar services (collectively, the \"Services\").\n\nUsers of our Services are comprised of teachers, educators, principals, school district staff,  other similar administrators, foundations, non-profit organizations, and other institutional users (collectively, \"Institutional User\"), and parents and their children (collectively, \"Household User\"). In certain instances, the type of information collected as part of the provision and administration of our Services may vary depending on the type of User.\n\n##### 2. Statement of Intent\n\nAs a registered charity using digital-based programs to fulfill our mission of inspiring, educating and empowering the next generation of environmental superheroes, we take our responsibility to safeguard your information very seriously and use your information in service of this mission, and as otherwise permitted or required pursuant to applicable law.\n\n##### 3. Collection and Use of Personal Information\n\n*What personal information do we collect?*\n\n* When you use our websites we may automatically collected certain information, including Internet Protocol (IP) addresses, browser type and language, internet service provider (ISP), referral or exit websites, operating system type and date/time.\n*\tWhen Institutional Users sign up for the Academy and/or our Programs, participate in an online survey or contact us with an enquiry, we may collect a variety of information, including name, email address, phone number, city, school name, and contact preferences.\n*\tIn the rare case where external funding for our Programs is not available in your area, Institutional Users will have the option of purchasing a program online using a credit card through a secure payment portal. In such instances we will need to collect payment information from Institutional Users to complete this transaction successfully.\n*\tWe may also collect information with respect to how our Institutional Users interact with the Academy and our Programs, including, but not limited to information about the effectiveness of our Programs, pages visited, links clicked, non-sensitive text entered, and mouse movements.\n*\tWe do not knowingly collect personal information about minors throughout the Academy, the related Programs, or our websites, If you are a parent and believe that the personal information of your child was unintentionally collected by us, please contact us pursuant to the instructions below to make a request for deletion of this information.\n\n*How do we use your personal information?*\n\n*\tWe may use personal information as permitted or required pursuant to applicable privacy laws. We may also use personal information to help us create, develop, promote, administer, deliver and improve our websites, the Academy and related Programs and Services.\n*\tWe also use User personal information to answer any User enquiries and provide User support with respect to our Services.\n*\tFrom time to time, we may use your personal information to send you important notices, such as changes in our terms, conditions and policies. Because this information is important to your interaction with DreamRider, you may not opt out of receiving these communications.\n*\tWe may, with your explicit permission ONLY, use your personal information to keep you posted on announcements and news related to the Academy and our Programs. You can choose whether to receive these messages when you register for our Programs and Services, and can update your communications preferences in your Academy website account and/or email newsletter profile at any time. You may also unsubscribe from such communications by clicking on the unsubscribe link within the applicable e-mails, replying to let us know you wish to be unsubscribed or e-mailing us at privacy@dreamriderproductions.com.\n*\tIn cases where funding for access to our Program(s) and Services is provided by a government agency, school district and/or philanthropic grantor, we may need to share the following information about Institutional Users: name, school name and information about any Programs used, including information on progress and completion of these Programs. This type of information is shared ONLY for the purpose of demonstrating to funders that their funding is in use by actual Institutional Users.  We will not provide personal contact information such as Institutional User email address, phone number or postal address without Institutional User explicit consent.\n*\tTo help us better understand Institutional User behaviour and improve the Institutional User experience, we may collect information about Institutional User interactions with various parts of the Academy and related digital services used to deliver our Programs and Services. For example, finding out the percentage of Institutional Users who take our onboarding tutorial and then go on to complete the program successfully with their students.\n\n##### 4. Collection and Use of Non-Personal Information\n\nWe also collect information in an anonymized or aggregated form that does not, on its own, allow a direct association with a specific individual. We may collect, use, transfer, share and disclose non-personal information to help us provide and administer the Academy and our Programs, for example:\n\n*\tTo measure the impact of the Academy and our Programs, we collect information about change in Household Users' environmental behaviours and their feedback on the program. Students report this numerical data with a show of hands in the classroom and through multiple choice polls in our live broadcast programs. This aggregated information may be shared with funding partners and external stakeholders to show the impact of the Academy’s Programs, or as part of our efforts to promote the Academy to potential educators and parents. Specific impact statistics collected from an Institutional User or Household User will not be shared publicly, but may be shared in aggregate form. For example: 73% of students in Oshawa say they feel like real-life planet protectors.\n* To improve our programs, services and communications, we may collect information such as language settings, zip/postal code, area code and the time zone where the Academy is being used. This is done, and such information is used so that we can provide regionalized student-facing content e.g. about how electricity is generated in your region.\n\nIf we combine personal information with non-personal information, we will treat the combined information as personal information.\n\n##### 5. Cookies and other Technologies\n\nOur websites, including the Academy website, may use “cookies”, pixel tags and other web technologies to help us:\n\n* Understand User behaviour and activity.\n*\tSave your preferences, which enables us to provide you with a more personalized experience. For example, when you return to the site, you don’t have to re-enter your classroom information.\n*\tTrack and measure the effectiveness of our communications, so that we can reach more Users and increase our charitable impact. For example, to understand how new Users first hear about us e.g. email, newsletters, other websites\n*\tCompile aggregate data about website traffic and interactions so that we can keep improving the Academy experience. For example, we may learn that Users don’t know where to find the scoreboard and so we can make this feature more obvious.\n\nLike many other web-based services and programs, we gather some types of information automatically, including Internet Protocol (IP) addresses, browser type and language, internet service provider (ISP), referral or exit websites, operating system and date/time. For example, we collect your browser name and version to troubleshoot technical issues should they arise.\n\n##### 6. How we protect your information\n\nWe take the security of your personal information very seriously and take all reasonable steps to ensure your personal information is stored securely and complies with data protection best practices. However, no security system is 100% secure, which means we cannot guarantee the absolute security of your personal information.\n\n##### 7. Use of Trusted Third Parties and Sharing of Personal Information\n\nWe may share your personal information with affiliated organizations, and third party service providers that assist us in administering and providing the Academy, our Programs, Services, and websites. We enter into agreements with all of our third-party tools and service providers to ensure that use of your personal information is strictly controlled for the purposes outlined herein, including providing and administering the Academy and our Programs. The agreements ensure that our service providers do not have the right to use or access your information for any other purposes.\n\nDreamRider works with a range of reputable third-party tools and services to provide and administer our Programs, such as hosting online webcasts through video communication tools, managing and enhancing User data, providing support services, assessing your interest in our Programs, and conducting satisfaction surveys. For example, we use [Intercom](https://www.intercom.com/) to support and stay in touch with Users, and use [GetFeedback](https://www.getfeedback.com/) to administer participant evaluation surveys.\n\nWe want to make sure that every user has a great experience using the Academy website. We use a service called FullStory that gives us insights, which we use to improve the Academy website's usability and help solve technical issues you might be experiencing. Information that we collect for this purpose includes, but is not limited to, pages visited, links clicked, non-sensitive text entered and mouse movements. We use the service to record interactions on our website only and do not share this information with any other third parties. For more information about how this information is collected and how to opt out, please visit the [FullStory Privacy Policy](https://www.fullstory.com/legal/privacy).\n\nAs noted previously, in cases where funding for access to our Program(s) is provided by a government agency, school district and/or philanthropic grantor, we may need to share the following information about Institutional Users with funders: name, school name, and information about any Programs used, including information on progress and completion of these Programs. This is shared ONLY for the purpose of demonstrating to funders that their funding is in use by actual Institutional Users.\n\nWe may also share your information as required or permitted pursuant to applicable law.\n\nSome of our service providers and trusted third parties may be located outside of your jurisdiction, and the information collected by us may be shared with entities located in the United States, Canada, and other jurisdictions. While your information is in another jurisdiction, it may be accessed by the courts, law enforcement, and national security authorities of that jurisdiction.\n\n##### 8. Children\n\nWe understand the sensitivities around collecting, storing, using, and sharing personal information related to children. For this reason, **we do not ask for or intentionally collect any personal information from minors**. Every account registration is first checked by one of our staff and if the registrant is suspected to be a minor, their account information will be deleted as soon as possible. If you believe we might have any information from or about a minor, please e-mail us at privacy@dreamriderproductions.com.\n\n##### 9. Links to Other Sites\n\nWe may provide links to third-party websites outside of our control or ownership and you are advised to read the Data Usage/Privacy Policy of each website you visit.\n\n##### 10. Your Rights with Respect to Personal Information\n\nYou have certain rights with respect to your Personal Information pursuant to applicable privacy laws, including (i) the right to access any Personal Information that we hold about you; (ii) correct, update, and amend any Personal Information that we hold about you, and (iii) withdraw your consent, so that we no longer process Personal Information in ways that you previously consented to.  \n\n##### 11. Changes\n\nOur Privacy Notice changes from time to time. When we amend this Privacy Notice, we will update the date at the beginning of the notice.  We will also provide you with notice of changes and obtain your consent to any such changes where and as required by applicable law. We encourage you to review this Privacy Notice periodically for the latest information on our practices.\n\n##### 12. Questions\n\nIf you have any questions about our Privacy Notice, the collection of your information, or if you wish to exercise your rights, or withdraw your consent, please contact our Privacy Officer via e-mail at privacy@dreamriderproductions.com. In certain instances, we may require that you provide additional information in order to verify your identity before we process your requests.\n"

/***/ }),
/* 724 */
/***/ (function(module, exports) {

	module.exports = "### Terms & Conditions\r\r#### (last updated on June 14, 2017)\r\r&nbsp;\r\r##### 1. Introduction\r\rPlease read these Terms & Conditions (\"Terms\", \"Terms & Conditions\") carefully before using the Planet Protector Academy website (the \"Academy\") operated by DreamRider Productions Society (“DreamRider”, \"us\", \"we\" or \"our\").\r\rBy accessing or using the Academy, you (“User”) agree to be bound by these Terms. If you disagree with any part of the Terms then you may not access the Service.\r\r##### 2. Copyright\r\rThe User acknowledges that all right, title, and interest in the Academy, including all intellectual property rights associated therewith, and any enhancements or modifications made to the Academy by any person shall at all times remain solely and exclusively the property of DreamRider.\r\rDreamRider’s intellectual property rights associated with the Academy include, without limitation, all (a) Planet Protector Academy trademarks, services marks, logos, trade dress (collectively “Marks”); (b) software, designs, websites, content and videos; and (c) copyrightable content, text, dialogue, story, characters, plots, ideas and other literary elements of the Academy and related materials.\r\r##### 3. Modification to the Service\r\rWe reserve the right at any time to modify or discontinue the Service (or any part or content thereof) without notice at any time. We shall not be liable to you or to any third-party for any modification, suspension or discontinuance of the Service.\r\r##### 4. Personal Information\r\rYour submission of personal information as part of the Academy is governed by our [Data Usage Policy](/dataUsage).\r\r##### 5. Disclaimer of warranties; limitation of liability\r\rThe User accepts the Academy materials “as-is” and acknowledges that DreamRider makes no representations or warranties about the suitability or fitness of the Academy materials for a particular purpose by the User. The User acknowledges and agrees that DreamRider is under no obligation to provide modifications, enhancements, training and or/support for the use and functionality of the Academy materials. The User acknowledges and agrees that Dreamrider shall not be liable for any loss, damage, costs or loss of revenue suffered by the User or any other person, employee, agent or servant arising from the use of or inability to use the Academy.\r\r##### 6. Indemnification\r\rYou agree to indemnify, defend and hold harmless DreamRider and our parent, subsidiaries, affiliates, partners, officers, directors, agents, contractors, licensors, service providers, subcontractors, suppliers, interns and employees, harmless from any claim or demand, including reasonable attorneys’ fees, made by any third-party due to or arising out of your breach of these Terms and Conditions or the documents they incorporate by reference, or your violation of any law or the rights of a third-party.\r\r##### 7. Governing Law\r\rThese Terms shall be governed and construed in accordance with the laws of British Columbia, Canada, without regard to its conflict of law provisions. Our failure to enforce any right or provision of these Terms will not be considered a waiver of those rights. If any provision of these Terms is held to be invalid or unenforceable by a court, the remaining provisions of these Terms will remain in effect. These Terms constitute the entire agreement between us regarding the Academy, and supersede and replace any prior agreements we might have between us regarding the Academy.\r\r##### 8. Changes to Terms & Conditions\r\rYou can review the most current version of the Terms & Conditions at any time at this page. We reserve the right, at our sole discretion, to update, change or replace any part of these Terms & Conditions by posting updates and changes to our website. It is your responsibility to check our website periodically for changes. Your continued use of or access to the Academy following the posting of any changes to these Terms & Conditions constitutes acceptance of those changes.\r\r##### 9. Contact\rIf you have any questions about these Terms & Conditions, please contact us.\r"

/***/ }),
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getVKShareCount = undefined;
	
	var _stringify = __webpack_require__(1978);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	exports.getFacebookShareCount = getFacebookShareCount;
	exports.getGooglePlusShareCount = getGooglePlusShareCount;
	exports.getLinkedinShareCount = getLinkedinShareCount;
	exports.getPinterestShareCount = getPinterestShareCount;
	exports.getOKShareCount = getOKShareCount;
	exports.getRedditShareCount = getRedditShareCount;
	exports.getTumblrShareCount = getTumblrShareCount;
	
	var _jsonp = __webpack_require__(1416);
	
	var _jsonp2 = _interopRequireDefault(_jsonp);
	
	var _utils = __webpack_require__(361);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getFacebookShareCount(shareUrl, callback) {
	  var endpoint = 'https://graph.facebook.com/?id=' + shareUrl;
	
	  (0, _jsonp2.default)(endpoint, function (err, data) {
	    callback(!err && data && data.share && data.share.share_count ? data.share.share_count : undefined);
	  });
	}
	
	function getGooglePlusShareCount(shareUrl, callback) {
	  if ((0, _utils.isInternetExplorerBefore)(11)) {
	    /* eslint-disable no-console */
	    console.error('Google plus share count is not supported in <=IE10!');
	    /* eslint-enable no-console */
	    return;
	  }
	
	  var xhr = new XMLHttpRequest();
	
	  xhr.open('POST', 'https://clients6.google.com/rpc');
	  xhr.setRequestHeader('Accept', 'application/json');
	  xhr.setRequestHeader('Content-type', 'application/json;charset=UTF-8');
	
	  xhr.send((0, _stringify2.default)({
	    method: 'pos.plusones.get',
	    id: 'p',
	    params: {
	      nolog: true,
	      id: shareUrl,
	      source: 'widget',
	      userId: '@viewer',
	      groupId: '@self'
	    },
	    jsonrpc: '2.0',
	    key: 'p',
	    apiVersion: 'v1'
	  }));
	
	  xhr.onload = function onSuccessdata() {
	    var data = JSON.parse(this.responseText);
	    callback(!!data ? data.result.metadata.globalCounts.count : undefined);
	  };
	
	  xhr.onerror = function onErrordata() {};
	}
	
	function getLinkedinShareCount(shareUrl, callback) {
	  var url = 'https://www.linkedin.com/countserv/count/share';
	
	  return (0, _jsonp2.default)(url + (0, _utils.objectToGetParams)({
	    url: shareUrl,
	    format: 'jsonp'
	  }), function (err, data) {
	    callback(!!data ? data.count : undefined);
	  });
	}
	
	function getPinterestShareCount(shareUrl, callback) {
	  var url = 'https://api.pinterest.com/v1/urls/count.json';
	
	  return (0, _jsonp2.default)(url + (0, _utils.objectToGetParams)({
	    url: shareUrl
	  }), function (err, data) {
	    callback(!!data ? data.count : undefined);
	  });
	}
	
	function getVKShareCount(shareUrl, callback) {
	  if (!window.VK) {
	    window.VK = {
	      Share: {
	        count: function count(index, _count2) {
	          return window.VK.callbacks[index](_count2);
	        }
	      },
	      callbacks: []
	    };
	  }
	
	  var url = 'https://vk.com/share.php';
	  var index = window.VK.callbacks.length;
	
	  window.VK.callbacks.push(callback);
	
	  return (0, _jsonp2.default)(url + (0, _utils.objectToGetParams)({
	    act: 'count',
	    index: index,
	    url: shareUrl
	  }));
	}
	
	exports.getVKShareCount = getVKShareCount;
	function getOKShareCount(shareUrl, callback) {
	  if (!window.OK) {
	    window.OK = {
	      Share: {
	        count: function count(index, _count) {
	          return window.OK.callbacks[index](_count);
	        }
	      },
	      callbacks: []
	    };
	  }
	
	  var url = 'https://connect.ok.ru/dk';
	  var index = window.OK.callbacks.length;
	
	  window.ODKL = {
	    updateCount: function updateCount(a, b) {
	      window.OK.callbacks[index](b);
	    }
	  };
	  window.OK.callbacks.push(callback);
	
	  return (0, _jsonp2.default)(url + (0, _utils.objectToGetParams)({
	    'st.cmd': 'extLike',
	    uid: 'odklcnt0',
	    ref: shareUrl
	  }));
	}
	
	function getRedditShareCount(shareUrl, callback) {
	  var endpoint = 'https://www.reddit.com/api/info.json?limit=1&url=' + shareUrl;
	
	  (0, _jsonp2.default)(endpoint, { param: 'jsonp' }, function (err, response) {
	    callback(!err && response && response.data && response.data.children.length > 0 && response.data.children[0].data.score ? response.data.children[0].data.score : undefined);
	  });
	}
	
	function getTumblrShareCount(shareUrl, callback) {
	  var endpoint = 'http://api.tumblr.com/v2/share/stats';
	
	  return (0, _jsonp2.default)(endpoint + (0, _utils.objectToGetParams)({
	    url: shareUrl
	  }), function (err, data) {
	    callback(!!data ? data.note_count : undefined);
	  });
	}

/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.email = email;
	exports.twitter = twitter;
	exports.telegram = telegram;
	exports.whatsapp = whatsapp;
	exports.facebook = facebook;
	exports.googlePlus = googlePlus;
	exports.linkedin = linkedin;
	exports.pinterest = pinterest;
	exports.vk = vk;
	exports.ok = ok;
	exports.reddit = reddit;
	exports.tumblr = tumblr;
	exports.livejournal = livejournal;
	exports.mailru = mailru;
	
	var _assert = __webpack_require__(950);
	
	var _assert2 = _interopRequireDefault(_assert);
	
	var _utils = __webpack_require__(361);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable prefer-template */
	function email(url, _ref) {
	  var subject = _ref.subject,
	      body = _ref.body;
	
	  return 'mailto:' + (0, _utils.objectToGetParams)({ subject: subject, body: body || subject });
	}
	
	function twitter(url, _ref2) {
	  var title = _ref2.title,
	      via = _ref2.via,
	      _ref2$hashtags = _ref2.hashtags,
	      hashtags = _ref2$hashtags === undefined ? [] : _ref2$hashtags;
	
	  (0, _assert2.default)(url, 'twitter.url');
	  (0, _assert2.default)(Array.isArray(hashtags), 'twitter.hashtags is not an array');
	
	  return 'https://twitter.com/share' + (0, _utils.objectToGetParams)({
	    url: url,
	    text: title,
	    via: via,
	    hashtags: hashtags.join(',')
	  });
	}
	
	function telegram(url, _ref3) {
	  var title = _ref3.title;
	
	  (0, _assert2.default)(url, 'telegram.url');
	  return 'https://telegram.me/share/' + (0, _utils.objectToGetParams)({
	    url: url,
	    text: title
	  });
	}
	
	function whatsapp(url, _ref4) {
	  var title = _ref4.title,
	      separator = _ref4.separator;
	
	  (0, _assert2.default)(url, 'whatsapp.url');
	  return 'https://api.whatsapp.com/send' + (0, _utils.objectToGetParams)({
	    text: title ? title + separator + url : url
	  });
	}
	
	function facebook(url, _ref5) {
	  var quote = _ref5.quote,
	      hashtag = _ref5.hashtag;
	
	  (0, _assert2.default)(url, 'facebook.url');
	
	  return 'https://www.facebook.com/sharer/sharer.php' + (0, _utils.objectToGetParams)({
	    u: url,
	    quote: quote,
	    hashtag: hashtag
	  });
	}
	
	function googlePlus(url) {
	  (0, _assert2.default)(url, 'googlePlus.url');
	
	  return 'https://plus.google.com/share' + (0, _utils.objectToGetParams)({ url: url });
	}
	
	function linkedin(url, _ref6) {
	  var title = _ref6.title,
	      description = _ref6.description;
	
	  (0, _assert2.default)(url, 'linkedin.url');
	
	  return 'https://linkedin.com/shareArticle' + (0, _utils.objectToGetParams)({
	    url: url,
	    title: title,
	    summary: description
	  });
	}
	
	function pinterest(url, _ref7) {
	  var media = _ref7.media,
	      description = _ref7.description;
	
	  (0, _assert2.default)(url, 'pinterest.url');
	  (0, _assert2.default)(media, 'pinterest.media');
	
	  return 'https://pinterest.com/pin/create/button/' + (0, _utils.objectToGetParams)({
	    url: url,
	    media: media,
	    description: description
	  });
	}
	
	function vk(url, _ref8) {
	  var title = _ref8.title,
	      description = _ref8.description,
	      image = _ref8.image;
	
	  (0, _assert2.default)(url, 'vk.url');
	
	  return 'https://vk.com/share.php' + (0, _utils.objectToGetParams)({
	    url: url,
	    title: title,
	    description: description,
	    image: image
	  });
	}
	
	function ok(url, _ref9) {
	  var title = _ref9.title,
	      description = _ref9.description,
	      image = _ref9.image;
	
	  (0, _assert2.default)(url, 'ok.url');
	
	  return 'https://connect.ok.ru/offer' + (0, _utils.objectToGetParams)({
	    url: url,
	    title: title,
	    description: description,
	    imageUrl: image
	  });
	}
	
	function reddit(url, _ref10) {
	  var title = _ref10.title;
	
	  (0, _assert2.default)(url, 'reddit.url');
	
	  return 'https://www.reddit.com/submit' + (0, _utils.objectToGetParams)({
	    url: url,
	    title: title
	  });
	}
	
	function tumblr(url, _ref11) {
	  var title = _ref11.title,
	      caption = _ref11.caption,
	      tags = _ref11.tags,
	      posttype = _ref11.posttype;
	
	  (0, _assert2.default)(url, 'tumblr.url');
	
	  return 'https://www.tumblr.com/widgets/share/tool' + (0, _utils.objectToGetParams)({
	    canonicalUrl: url,
	    title: title,
	    caption: caption,
	    tags: tags,
	    posttype: posttype
	  });
	}
	
	function livejournal(url, _ref12) {
	  var title = _ref12.title,
	      description = _ref12.description;
	
	  (0, _assert2.default)(url, 'livejournal.url');
	
	  return 'https://www.livejournal.com/update.bml' + (0, _utils.objectToGetParams)({
	    subject: title,
	    event: description
	  });
	}
	
	function mailru(url, _ref13) {
	  var title = _ref13.title,
	      description = _ref13.description,
	      image = _ref13.image;
	
	  (0, _assert2.default)(url, 'mailru.url');
	
	  return 'https://connect.mail.ru/share' + (0, _utils.objectToGetParams)({
	    url: url,
	    title: title,
	    description: description,
	    imageurl: image
	  });
	}

/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1989), __esModule: true };

/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1990), __esModule: true };

/***/ }),
/* 765 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};

/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _defineProperty = __webpack_require__(1981);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();

/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _setPrototypeOf = __webpack_require__(1982);
	
	var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);
	
	var _create = __webpack_require__(1980);
	
	var _create2 = _interopRequireDefault(_create);
	
	var _typeof2 = __webpack_require__(363);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
	  }
	
	  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
	};

/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _typeof2 = __webpack_require__(363);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
	};

/***/ }),
/* 769 */
/***/ (function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};


/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(1994);
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};


/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(147);
	var document = __webpack_require__(97).document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};


/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(96) && !__webpack_require__(145)(function () {
	  return Object.defineProperty(__webpack_require__(771)('div'), 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(769);
	// eslint-disable-next-line no-prototype-builtins
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};


/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(258);
	var $export = __webpack_require__(114);
	var redefine = __webpack_require__(780);
	var hide = __webpack_require__(146);
	var Iterators = __webpack_require__(366);
	var $iterCreate = __webpack_require__(2000);
	var setToStringTag = __webpack_require__(369);
	var getPrototypeOf = __webpack_require__(777);
	var ITERATOR = __webpack_require__(149)('iterator');
	var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
	var FF_ITERATOR = '@@iterator';
	var KEYS = 'keys';
	var VALUES = 'values';
	
	var returnThis = function () { return this; };
	
	module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function (kind) {
	    if (!BUGGY && kind in proto) return proto[kind];
	    switch (kind) {
	      case KEYS: return function keys() { return new Constructor(this, kind); };
	      case VALUES: return function values() { return new Constructor(this, kind); };
	    } return function entries() { return new Constructor(this, kind); };
	  };
	  var TAG = NAME + ' Iterator';
	  var DEF_VALUES = DEFAULT == VALUES;
	  var VALUES_BUG = false;
	  var proto = Base.prototype;
	  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
	  var $default = $native || getMethod(DEFAULT);
	  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
	  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
	  var methods, key, IteratorPrototype;
	  // Fix native
	  if ($anyNative) {
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
	    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if (DEF_VALUES && $native && $native.name !== VALUES) {
	    VALUES_BUG = true;
	    $default = function values() { return $native.call(this); };
	  }
	  // Define iterator
	  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG] = returnThis;
	  if (DEFAULT) {
	    methods = {
	      values: DEF_VALUES ? $default : getMethod(VALUES),
	      keys: IS_SET ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if (FORCED) for (key in methods) {
	      if (!(key in proto)) redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};


/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

	var pIE = __webpack_require__(259);
	var createDesc = __webpack_require__(260);
	var toIObject = __webpack_require__(148);
	var toPrimitive = __webpack_require__(373);
	var has = __webpack_require__(115);
	var IE8_DOM_DEFINE = __webpack_require__(772);
	var gOPD = Object.getOwnPropertyDescriptor;
	
	exports.f = __webpack_require__(96) ? gOPD : function getOwnPropertyDescriptor(O, P) {
	  O = toIObject(O);
	  P = toPrimitive(P, true);
	  if (IE8_DOM_DEFINE) try {
	    return gOPD(O, P);
	  } catch (e) { /* empty */ }
	  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
	};


/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	var $keys = __webpack_require__(778);
	var hiddenKeys = __webpack_require__(365).concat('length', 'prototype');
	
	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
	  return $keys(O, hiddenKeys);
	};


/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has = __webpack_require__(115);
	var toObject = __webpack_require__(193);
	var IE_PROTO = __webpack_require__(370)('IE_PROTO');
	var ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function (O) {
	  O = toObject(O);
	  if (has(O, IE_PROTO)) return O[IE_PROTO];
	  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};


/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

	var has = __webpack_require__(115);
	var toIObject = __webpack_require__(148);
	var arrayIndexOf = __webpack_require__(1996)(false);
	var IE_PROTO = __webpack_require__(370)('IE_PROTO');
	
	module.exports = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};


/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(114);
	var core = __webpack_require__(42);
	var fails = __webpack_require__(145);
	module.exports = function (KEY, exec) {
	  var fn = (core.Object || {})[KEY] || Object[KEY];
	  var exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
	};


/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(146);


/***/ }),
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */,
/* 805 */,
/* 806 */,
/* 807 */,
/* 808 */,
/* 809 */,
/* 810 */,
/* 811 */,
/* 812 */,
/* 813 */,
/* 814 */,
/* 815 */,
/* 816 */,
/* 817 */,
/* 818 */,
/* 819 */,
/* 820 */,
/* 821 */,
/* 822 */,
/* 823 */,
/* 824 */,
/* 825 */,
/* 826 */,
/* 827 */,
/* 828 */,
/* 829 */,
/* 830 */,
/* 831 */,
/* 832 */,
/* 833 */,
/* 834 */,
/* 835 */,
/* 836 */,
/* 837 */,
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1312);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(13)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/autoprefixer-loader/index.js?browsers=last 2 version!../../../../../node_modules/sass-loader/index.js?sourceMap&includePaths[]=/tmp/ppa-firebase/src/styles!./selectConfiguration.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/autoprefixer-loader/index.js?browsers=last 2 version!../../../../../node_modules/sass-loader/index.js?sourceMap&includePaths[]=/tmp/ppa-firebase/src/styles!./selectConfiguration.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 839 */,
/* 840 */
/***/ (function(module, exports) {

	
	exports = module.exports = trim;
	
	function trim(str){
	  return str.replace(/^\s*|\s*$/g, '');
	}
	
	exports.left = function(str){
	  return str.replace(/^\s*/, '');
	};
	
	exports.right = function(str){
	  return str.replace(/\s*$/, '');
	};


/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	var xtend = __webpack_require__(2240)
	var inherits = __webpack_require__(46)
	
	module.exports = unherit
	
	// Create a custom constructor which can be modified without affecting the
	// original class.
	function unherit(Super) {
	  var result
	  var key
	  var value
	
	  inherits(Of, Super)
	  inherits(From, Of)
	
	  // Clone values.
	  result = Of.prototype
	
	  for (key in result) {
	    value = result[key]
	
	    if (value && typeof value === 'object') {
	      result[key] = 'concat' in value ? value.concat() : xtend(value)
	    }
	  }
	
	  return Of
	
	  // Constructor accepting a single argument, which itself is an `arguments`
	  // object.
	  function From(parameters) {
	    return Super.apply(this, parameters)
	  }
	
	  // Constructor accepting variadic arguments.
	  function Of() {
	    if (!(this instanceof Of)) {
	      return new From(arguments)
	    }
	
	    return Super.apply(this, arguments)
	  }
	}


/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	module.exports = visit
	
	var visitParents = __webpack_require__(2243)
	
	var CONTINUE = visitParents.CONTINUE
	var SKIP = visitParents.SKIP
	var EXIT = visitParents.EXIT
	
	visit.CONTINUE = CONTINUE
	visit.SKIP = SKIP
	visit.EXIT = EXIT
	
	function visit(tree, test, visitor, reverse) {
	  if (typeof test === 'function' && typeof visitor !== 'function') {
	    reverse = visitor
	    visitor = test
	    test = null
	  }
	
	  visitParents(tree, test, overload, reverse)
	
	  function overload(node, parents) {
	    var parent = parents[parents.length - 1]
	    var index = parent ? parent.children.indexOf(node) : null
	    return visitor(node, index, parent)
	  }
	}


/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "7a522e6f972aed56cdf3ea276755118b.eot";

/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "1f0436695e1002d4af247c8b10280c04.eot";

/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "cbd0d886c34948d4751deca53983d367.eot";

/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "f5a6bf59381c45d65caeaa576d2a16c1.eot";

/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "bf31ff6c6c823fd96da0d95bb35ccf72.eot";

/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/epsHybridAssembly/images/characters/apprenticeFistUp-5390131095151e6e55b467351470b1b0.png";

/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/epsHybridAssembly/images/characters/apprenticeHandsHips-b4f26c1a9e0dd97ed5eb777b8471d8dc.png";

/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/epsHybridAssembly/images/characters/apprenticeHandsHips2-13a429b2c8f7b2f101a13dd077b67c2c.png";

/***/ }),
/* 851 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/epsHybridAssembly/images/characters/apprenticePointingDiagonal-01628f9248ed94db92bf66a6d3f2ca75.png";

/***/ }),
/* 852 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/epsHybridAssembly/images/characters/apprenticesPairHandsHips-09319d39a07573b6fb25a390a622e359.png";

/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/epsHybridAssembly/images/emergencyPreparednessSquadGlow-0e342e40a280edf7ea3f35969fb58217.png";

/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/epsHybridIntermediates/images/characters/ian_arms_folded-45361bb36249f0897318690f5b4521d2.png";

/***/ }),
/* 855 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/epsHybridIntermediates/images/characters/ian_headshot_smile-b903fb205b52f0700ed096f73d3e7ab2.png";

/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/epsHybridIntermediates/images/characters/ian_sara_silly-8139b5d7a02986b6a0cea289575bc98a.png";

/***/ }),
/* 857 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/epsHybridIntermediates/images/characters/ian_side-73146e2c2ff78c910e4856232244643f.png";

/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/epsHybridIntermediates/images/characters/sara_giggle-f59c43c85e15482d7fe0fc5dcac1de28.png";

/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/epsHybridIntermediates/images/characters/sara_surprised-61e177ce1eeefefed54cdf3a77a4bf34.png";

/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/epsHybridIntermediates/images/characters/sara_twist_hands_out_heyhey-88fc7fcb491ac0a78f3ce4e8d416ce57.png";

/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/epsHybridIntermediates/images/level-3_start-b1890c89289e1900058901dc3e751b00.png";

/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/epsHybridPrimaries/images/characters/ian_arms_folded-45361bb36249f0897318690f5b4521d2.png";

/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/epsHybridPrimaries/images/characters/ian_headshot_smile-b903fb205b52f0700ed096f73d3e7ab2.png";

/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/epsHybridPrimaries/images/characters/ian_sara_silly-8139b5d7a02986b6a0cea289575bc98a.png";

/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/epsHybridPrimaries/images/characters/ian_side-73146e2c2ff78c910e4856232244643f.png";

/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/epsHybridPrimaries/images/characters/sara_giggle-f59c43c85e15482d7fe0fc5dcac1de28.png";

/***/ }),
/* 867 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/epsHybridPrimaries/images/characters/sara_surprised-61e177ce1eeefefed54cdf3a77a4bf34.png";

/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/epsHybridPrimaries/images/characters/sara_twist_hands_out_heyhey-88fc7fcb491ac0a78f3ce4e8d416ce57.png";

/***/ }),
/* 869 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/epsHybridPrimaries/images/level-3_start-b1890c89289e1900058901dc3e751b00.png";

/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/epsIntermediates/images/characters/ian_arms_folded-45361bb36249f0897318690f5b4521d2.png";

/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/epsIntermediates/images/characters/ian_headshot_smile-b903fb205b52f0700ed096f73d3e7ab2.png";

/***/ }),
/* 872 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/epsIntermediates/images/characters/ian_side-73146e2c2ff78c910e4856232244643f.png";

/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/epsIntermediates/images/characters/sara_giggle-f59c43c85e15482d7fe0fc5dcac1de28.png";

/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/epsIntermediates/images/characters/sara_surprised-61e177ce1eeefefed54cdf3a77a4bf34.png";

/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/epsIntermediates/images/characters/sara_twist_hands_out_heyhey-88fc7fcb491ac0a78f3ce4e8d416ce57.png";

/***/ }),
/* 876 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/epsIntermediates/images/level-4_start-b1890c89289e1900058901dc3e751b00.png";

/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/epsPrimaries/images/characters/ian_arms_folded-45361bb36249f0897318690f5b4521d2.png";

/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/epsPrimaries/images/characters/ian_headshot_smile-b903fb205b52f0700ed096f73d3e7ab2.png";

/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/epsPrimaries/images/characters/ian_side-73146e2c2ff78c910e4856232244643f.png";

/***/ }),
/* 880 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/epsPrimaries/images/characters/sara_giggle-f59c43c85e15482d7fe0fc5dcac1de28.png";

/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/epsPrimaries/images/characters/sara_surprised-61e177ce1eeefefed54cdf3a77a4bf34.png";

/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/epsPrimaries/images/characters/sara_twist_hands_out_heyhey-88fc7fcb491ac0a78f3ce4e8d416ce57.png";

/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/epsPrimaries/images/level-4_start-b1890c89289e1900058901dc3e751b00.png";

/***/ }),
/* 884 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/h2whoa/images/characters/apprenticePointingDiagonal-01628f9248ed94db92bf66a6d3f2ca75.png";

/***/ }),
/* 885 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/h2whoa/images/characters/esmeralda_goober_goofy_smile-ea36a1f2dea26b0654b664d4bb49cb2f.png";

/***/ }),
/* 886 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/h2whoa/images/characters/esmeralda_goober_proud-8cbef198ed6fd9fc4fa28a700b2d5f24.png";

/***/ }),
/* 887 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/h2whoa/images/characters/ian_headshot_smile-b903fb205b52f0700ed096f73d3e7ab2.png";

/***/ }),
/* 888 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/h2whoa/images/characters/ian_sara_lean_questioning-24f9edc84f6866578dbd17d6d194a844.png";

/***/ }),
/* 889 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/h2whoa/images/characters/sara_surprised-61e177ce1eeefefed54cdf3a77a4bf34.png";

/***/ }),
/* 890 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/h2whoa/images/level-4_start-914fc9cfa583d9a53c28a201ba100f16.png";

/***/ }),
/* 891 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/h2whoa/images/logo_ppa-ecb5fec98ab9deca3fb59d6d00473ce6.png";

/***/ }),
/* 892 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/h2whoaHybrid/images/characters/ian_arms_folded-45361bb36249f0897318690f5b4521d2.png";

/***/ }),
/* 893 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/h2whoaHybrid/images/characters/ian_headshot_smile-b903fb205b52f0700ed096f73d3e7ab2.png";

/***/ }),
/* 894 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/h2whoaHybrid/images/characters/ian_sara_silly-8139b5d7a02986b6a0cea289575bc98a.png";

/***/ }),
/* 895 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/h2whoaHybrid/images/characters/ian_side-73146e2c2ff78c910e4856232244643f.png";

/***/ }),
/* 896 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/h2whoaHybrid/images/characters/sara_giggle-f59c43c85e15482d7fe0fc5dcac1de28.png";

/***/ }),
/* 897 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/h2whoaHybrid/images/characters/sara_surprised-61e177ce1eeefefed54cdf3a77a4bf34.png";

/***/ }),
/* 898 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/h2whoaHybrid/images/level-1_start-e43962d310155302845da8ef5f15e7d0.png";

/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/h2whoaHybrid/images/logo_ppa-ecb5fec98ab9deca3fb59d6d00473ce6.png";

/***/ }),
/* 900 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/keepCool/images/characters/apprenticePointingDiagonal-01628f9248ed94db92bf66a6d3f2ca75.png";

/***/ }),
/* 901 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/keepCool/images/characters/apprenticesFlexArms-4aeefe98ba101c125fbc6e150654e893.png";

/***/ }),
/* 902 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/keepCool/images/characters/ian_sara_lean_questioning-24f9edc84f6866578dbd17d6d194a844.png";

/***/ }),
/* 903 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/keepCool/images/level-1_start-3c34962ee162659b4f9c9846412458d4.png";

/***/ }),
/* 904 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/keepCool/images/level-6_start-0108fdb185105031dae57708118e2b3d.png";

/***/ }),
/* 905 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/keepCool/images/logo_ppa-ecb5fec98ab9deca3fb59d6d00473ce6.png";

/***/ }),
/* 906 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/zeroHeroes/images/characters/apprenticePointingDiagonal-01628f9248ed94db92bf66a6d3f2ca75.png";

/***/ }),
/* 907 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/zeroHeroes/images/characters/apprenticesFlexArms-4aeefe98ba101c125fbc6e150654e893.png";

/***/ }),
/* 908 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/zeroHeroes/images/characters/ian_headshot_smile-b903fb205b52f0700ed096f73d3e7ab2.png";

/***/ }),
/* 909 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/zeroHeroes/images/characters/ian_sara_lean_questioning-24f9edc84f6866578dbd17d6d194a844.png";

/***/ }),
/* 910 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/zeroHeroes/images/characters/sara_surprised-61e177ce1eeefefed54cdf3a77a4bf34.png";

/***/ }),
/* 911 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/zeroHeroes/images/level-6_start-8857fd7956f4a93c8ecdb7030558b053.png";

/***/ }),
/* 912 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/zeroHeroes/images/logo_ppa-ecb5fec98ab9deca3fb59d6d00473ce6.png";

/***/ }),
/* 913 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDE5LjIuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8IURPQ1RZUEUgc3ZnIFBVQkxJQyAiLS8vVzNDLy9EVEQgU1ZHIDEuMS8vRU4iICJodHRwOi8vd3d3LnczLm9yZy9HcmFwaGljcy9TVkcvMS4xL0RURC9zdmcxMS5kdGQiPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCAyOCAyOCIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgMjggMjg7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPHN0eWxlIHR5cGU9InRleHQvY3NzIj4KCS5zdDB7ZmlsbDojNjVEN0VDO30KPC9zdHlsZT4KPHBhdGggY2xhc3M9InN0MCIgZD0iTTIxLjYsMTIuMkwxNCw0LjVjLTEtMS0yLjYtMS0zLjYsMGwwLDBDOS45LDUsOS43LDUuNiw5LjcsNi4zczAuMywxLjMsMC43LDEuOGw1LjksNS45bC01LjksNS45CgljLTAuNSwwLjUtMC43LDEuMS0wLjcsMS44YzAsMC43LDAuMywxLjMsMC43LDEuOGMwLjUsMC41LDEuMSwwLjcsMS44LDAuN2MwLjYsMCwxLjMtMC4yLDEuOC0wLjdsNy42LTcuNgoJQzIyLjYsMTQuNywyMi42LDEzLjEsMjEuNiwxMi4yeiBNMjAuNywxNC44bC03LjYsNy42Yy0wLjUsMC41LTEuMywwLjUtMS44LDBjLTAuMi0wLjItMC40LTAuNi0wLjQtMC45czAuMS0wLjcsMC40LTAuOWw2LjMtNi4zCgljMC4yLTAuMiwwLjItMC42LDAtMC45bC02LjMtNi4zYy0wLjItMC4yLTAuNC0wLjYtMC40LTAuOXMwLjEtMC43LDAuNC0wLjlsMCwwQzExLjUsNS4yLDExLjgsNSwxMi4yLDVjMC4zLDAsMC43LDAuMSwwLjksMC40CglsNy42LDcuNkMyMS4yLDEzLjUsMjEuMiwxNC4zLDIwLjcsMTQuOHoiLz4KPC9zdmc+Cg=="

/***/ }),
/* 914 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDE5LjIuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8IURPQ1RZUEUgc3ZnIFBVQkxJQyAiLS8vVzNDLy9EVEQgU1ZHIDEuMS8vRU4iICJodHRwOi8vd3d3LnczLm9yZy9HcmFwaGljcy9TVkcvMS4xL0RURC9zdmcxMS5kdGQiPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCAyOCAyOCIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgMjggMjg7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPHN0eWxlIHR5cGU9InRleHQvY3NzIj4KCS5zdDB7ZmlsbDojNjVEN0VDO30KPC9zdHlsZT4KPHBhdGggY2xhc3M9InN0MCIgZD0iTTguNCwxNS43bDcuNiw3LjZjMSwxLDIuNiwxLDMuNiwwdjBjMC41LTAuNSwwLjctMS4xLDAuNy0xLjhzLTAuMy0xLjMtMC43LTEuOEwxMy43LDE0bDUuOS01LjkKCWMwLjUtMC41LDAuNy0xLjEsMC43LTEuOGMwLTAuNy0wLjMtMS4zLTAuNy0xLjhjLTAuNS0wLjUtMS4xLTAuNy0xLjgtMC43Yy0wLjYsMC0xLjMsMC4yLTEuOCwwLjdsLTcuNiw3LjYKCUM3LjQsMTMuMiw3LjQsMTQuOCw4LjQsMTUuN3ogTTkuMywxMy4xbDcuNi03LjZjMC41LTAuNSwxLjMtMC41LDEuOCwwYzAuMiwwLjIsMC40LDAuNiwwLjQsMC45YzAsMC4zLTAuMSwwLjctMC40LDAuOWwtNi4zLDYuMwoJYy0wLjIsMC4yLTAuMiwwLjYsMCwwLjlsNi4zLDYuM2MwLjIsMC4yLDAuNCwwLjYsMC40LDAuOWMwLDAuMy0wLjEsMC43LTAuNCwwLjljMCwwLDAsMCwwLDBjLTAuMiwwLjItMC42LDAuNC0wLjksMC40CgljLTAuMywwLTAuNy0wLjEtMC45LTAuNGwtNy42LTcuNkM4LjgsMTQuNCw4LjgsMTMuNiw5LjMsMTMuMXoiLz4KPC9zdmc+Cg=="

/***/ }),
/* 915 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/images/esmeralda_goober_half_wave-79a6eb685a9f1cb94f29f8bff109da2f.png";

/***/ }),
/* 916 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDE5LjIuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8IURPQ1RZUEUgc3ZnIFBVQkxJQyAiLS8vVzNDLy9EVEQgU1ZHIDEuMS8vRU4iICJodHRwOi8vd3d3LnczLm9yZy9HcmFwaGljcy9TVkcvMS4xL0RURC9zdmcxMS5kdGQiPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCAyOCAyOCIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgMjggMjg7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPHN0eWxlIHR5cGU9InRleHQvY3NzIj4KCS5zdDB7ZmlsbDojNjVEN0VDO30KPC9zdHlsZT4KPHBhdGggY2xhc3M9InN0MCIgZD0iTTkuNSwyNGMtMC4xLDAtMC4zLDAtMC40LTAuMWMtMC40LTAuMi0wLjYtMC41LTAuNi0wLjlWNWMwLTAuNCwwLjItMC44LDAuNi0wLjlDOS41LDMuOSw5LjksNCwxMC4yLDQuM2w5LDkKCWMwLjQsMC40LDAuNCwxLDAsMS40bC05LDlDMTAsMjMuOSw5LjgsMjQsOS41LDI0eiBNMTAuMSw2LjV2MTUuMWw3LjUtNy41TDEwLjEsNi41eiIvPgo8L3N2Zz4K"

/***/ }),
/* 917 */,
/* 918 */,
/* 919 */,
/* 920 */,
/* 921 */,
/* 922 */,
/* 923 */,
/* 924 */,
/* 925 */,
/* 926 */,
/* 927 */
/***/ (function(module, exports, __webpack_require__) {

	var screenfull = __webpack_require__(2172);
	
	var FullscreenMixin = {
	
	  getInitialState: function() {
	    return {
	      hasFullscreen: false
	    };
	  },
	
	  componentDidMount: function () {
	    var enabled = screenfull.enabled;
	
	    if (enabled) {
	      document.addEventListener(screenfull.raw.fullscreenchange, this.onChangeFullscreen);
	
	      this.setState({
	        hasFullscreen: enabled,
	        isFullscreen: screenfull.isFullscreen,
	        fullScreenElement: screenfull.element
	      });
	    }
	  },
	
	  requestFullscreen: function (ref) {
	    if (ref) {
	      screenfull.request(ref);
	    } else {
	      screenfull.request();
	    }
	  },
	
	  exitFullscreen: function () {
	    screenfull.exit();
	  },
	
	  onChangeFullscreen: function (e) {
	    var isFullscreen = screenfull.isFullscreen;
	    this.setState({
	      isFullscreen: isFullscreen,
	      fullScreenElement: screenfull.element
	    });
	
	    if (isFullscreen) {
	      typeof this.onEnterFullscreen === 'function' && this.onEnterFullscreen(e);
	    } else {
	      typeof this.onExitFullscreen === 'function' && this.onExitFullscreen(e);
	    }
	  }
	};
	
	module.exports = FullscreenMixin;


/***/ }),
/* 928 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	exports['default'] = makeAction;
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _esSymbol = __webpack_require__(238);
	
	var _esSymbol2 = _interopRequireDefault(_esSymbol);
	
	var _symbolsSymbols = __webpack_require__(121);
	
	var Sym = _interopRequireWildcard(_symbolsSymbols);
	
	var _utilsAltUtils = __webpack_require__(275);
	
	var utils = _interopRequireWildcard(_utilsAltUtils);
	
	var AltAction = (function () {
	  function AltAction(alt, name, action, actions, actionDetails) {
	    _classCallCheck(this, AltAction);
	
	    this[Sym.ACTION_UID] = name;
	    this[Sym.ACTION_HANDLER] = action.bind(this);
	    this.actions = actions;
	    this.actionDetails = actionDetails;
	    this.alt = alt;
	  }
	
	  _createClass(AltAction, [{
	    key: 'dispatch',
	    value: function dispatch(data) {
	      this.alt.dispatch(this[Sym.ACTION_UID], data, this.actionDetails);
	    }
	  }]);
	
	  return AltAction;
	})();
	
	function makeAction(alt, namespace, name, implementation, obj) {
	  // make sure each Symbol is unique
	  var actionId = utils.uid(alt[Sym.ACTIONS_REGISTRY], '' + namespace + '.' + name);
	  alt[Sym.ACTIONS_REGISTRY][actionId] = 1;
	  var actionSymbol = _esSymbol2['default']['for']('alt/' + actionId);
	
	  var data = {
	    namespace: namespace,
	    name: name,
	    id: actionId,
	    symbol: actionSymbol
	  };
	
	  // Wrap the action so we can provide a dispatch method
	  var newAction = new AltAction(alt, actionSymbol, implementation, obj, data);
	
	  // the action itself
	  var action = newAction[Sym.ACTION_HANDLER];
	  action.defer = function () {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    setTimeout(function () {
	      newAction[Sym.ACTION_HANDLER].apply(null, args);
	    });
	  };
	  action[Sym.ACTION_KEY] = actionSymbol;
	  action.data = data;
	
	  // ensure each reference is unique in the namespace
	  var container = alt.actions[namespace];
	  var id = utils.uid(container, name);
	  container[id] = action;
	
	  return action;
	}
	
	module.exports = exports['default'];

/***/ }),
/* 929 */
/***/ (function(module, exports, __webpack_require__) {

	/*global window*/
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var _bind = Function.prototype.bind;
	
	var _get = function get(_x3, _x4, _x5) { var _again = true; _function: while (_again) { var object = _x3, property = _x4, receiver = _x5; desc = parent = getter = undefined; _again = false; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x3 = parent; _x4 = property; _x5 = receiver; _again = true; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) subClass.__proto__ = superClass; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _flux = __webpack_require__(530);
	
	var _utilsStateFunctions = __webpack_require__(933);
	
	var StateFunctions = _interopRequireWildcard(_utilsStateFunctions);
	
	var _symbolsSymbols = __webpack_require__(121);
	
	var Sym = _interopRequireWildcard(_symbolsSymbols);
	
	var _utilsFunctions = __webpack_require__(159);
	
	var fn = _interopRequireWildcard(_utilsFunctions);
	
	var _store = __webpack_require__(932);
	
	var store = _interopRequireWildcard(_store);
	
	var _utilsAltUtils = __webpack_require__(275);
	
	var utils = _interopRequireWildcard(_utilsAltUtils);
	
	var _actions = __webpack_require__(928);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	var Alt = (function () {
	  function Alt() {
	    var config = arguments[0] === undefined ? {} : arguments[0];
	
	    _classCallCheck(this, Alt);
	
	    this.config = config;
	    this.serialize = config.serialize || JSON.stringify;
	    this.deserialize = config.deserialize || JSON.parse;
	    this.dispatcher = config.dispatcher || new _flux.Dispatcher();
	    this.batchingFunction = config.batchingFunction || function (callback) {
	      return callback();
	    };
	    this.actions = { global: {} };
	    this.stores = {};
	    this.storeTransforms = config.storeTransforms || [];
	    this[Sym.ACTIONS_REGISTRY] = {};
	    this[Sym.INIT_SNAPSHOT] = {};
	    this[Sym.LAST_SNAPSHOT] = {};
	  }
	
	  _createClass(Alt, [{
	    key: 'dispatch',
	    value: function dispatch(action, data, details) {
	      var _this = this;
	
	      this.batchingFunction(function () {
	        return _this.dispatcher.dispatch({ action: action, data: data, details: details });
	      });
	    }
	  }, {
	    key: 'createUnsavedStore',
	    value: function createUnsavedStore(StoreModel) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      var key = StoreModel.displayName || '';
	      store.createStoreConfig(this.config, StoreModel);
	      var Store = store.transformStore(this.storeTransforms, StoreModel);
	
	      return fn.isFunction(Store) ? store.createStoreFromClass.apply(store, [this, Store, key].concat(args)) : store.createStoreFromObject(this, Store, key);
	    }
	  }, {
	    key: 'createStore',
	    value: function createStore(StoreModel, iden) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      var key = iden || StoreModel.displayName || StoreModel.name || '';
	      store.createStoreConfig(this.config, StoreModel);
	      var Store = store.transformStore(this.storeTransforms, StoreModel);
	
	      if (this.stores[key] || !key) {
	        if (this.stores[key]) {
	          utils.warn('A store named ' + key + ' already exists, double check your store ' + 'names or pass in your own custom identifier for each store');
	        } else {
	          utils.warn('Store name was not specified');
	        }
	
	        key = utils.uid(this.stores, key);
	      }
	
	      var storeInstance = fn.isFunction(Store) ? store.createStoreFromClass.apply(store, [this, Store, key].concat(args)) : store.createStoreFromObject(this, Store, key);
	
	      this.stores[key] = storeInstance;
	      StateFunctions.saveInitialSnapshot(this, key);
	
	      return storeInstance;
	    }
	  }, {
	    key: 'generateActions',
	    value: function generateActions() {
	      for (var _len3 = arguments.length, actionNames = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	        actionNames[_key3] = arguments[_key3];
	      }
	
	      var actions = { name: 'global' };
	      return this.createActions(actionNames.reduce(function (obj, action) {
	        obj[action] = utils.dispatchIdentity;
	        return obj;
	      }, actions));
	    }
	  }, {
	    key: 'createAction',
	    value: function createAction(name, implementation, obj) {
	      return (0, _actions2['default'])(this, 'global', name, implementation, obj);
	    }
	  }, {
	    key: 'createActions',
	    value: function createActions(ActionsClass) {
	      for (var _len4 = arguments.length, argsForConstructor = Array(_len4 > 2 ? _len4 - 2 : 0), _key4 = 2; _key4 < _len4; _key4++) {
	        argsForConstructor[_key4 - 2] = arguments[_key4];
	      }
	
	      var _this2 = this;
	
	      var exportObj = arguments[1] === undefined ? {} : arguments[1];
	
	      var actions = {};
	      var key = utils.uid(this[Sym.ACTIONS_REGISTRY], ActionsClass.displayName || ActionsClass.name || 'Unknown');
	
	      if (fn.isFunction(ActionsClass)) {
	        (function () {
	          fn.assign(actions, utils.getInternalMethods(ActionsClass, true));
	
	          var ActionsGenerator = (function (_ActionsClass) {
	            function ActionsGenerator() {
	              for (var _len5 = arguments.length, args = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
	                args[_key5] = arguments[_key5];
	              }
	
	              _classCallCheck(this, ActionsGenerator);
	
	              _get(Object.getPrototypeOf(ActionsGenerator.prototype), 'constructor', this).apply(this, args);
	            }
	
	            _inherits(ActionsGenerator, _ActionsClass);
	
	            _createClass(ActionsGenerator, [{
	              key: 'generateActions',
	              value: function generateActions() {
	                for (var _len6 = arguments.length, actionNames = Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
	                  actionNames[_key6] = arguments[_key6];
	                }
	
	                actionNames.forEach(function (actionName) {
	                  actions[actionName] = utils.dispatchIdentity;
	                });
	              }
	            }]);
	
	            return ActionsGenerator;
	          })(ActionsClass);
	
	          fn.assign(actions, new (_bind.apply(ActionsGenerator, [null].concat(argsForConstructor)))());
	        })();
	      } else {
	        fn.assign(actions, ActionsClass);
	      }
	
	      this.actions[key] = this.actions[key] || {};
	
	      fn.eachObject(function (actionName, action) {
	        if (!fn.isFunction(action)) {
	          return;
	        }
	
	        // create the action
	        exportObj[actionName] = (0, _actions2['default'])(_this2, key, actionName, action, exportObj);
	
	        // generate a constant
	        var constant = utils.formatAsConstant(actionName);
	        exportObj[constant] = exportObj[actionName][Sym.ACTION_KEY];
	      }, [actions]);
	      return exportObj;
	    }
	  }, {
	    key: 'takeSnapshot',
	    value: function takeSnapshot() {
	      for (var _len7 = arguments.length, storeNames = Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
	        storeNames[_key7] = arguments[_key7];
	      }
	
	      var state = StateFunctions.snapshot(this, storeNames);
	      fn.assign(this[Sym.LAST_SNAPSHOT], state);
	      return this.serialize(state);
	    }
	  }, {
	    key: 'rollback',
	    value: function rollback() {
	      StateFunctions.setAppState(this, this.serialize(this[Sym.LAST_SNAPSHOT]), function (storeInst) {
	        storeInst[Sym.LIFECYCLE].emit('rollback');
	        storeInst.emitChange();
	      });
	    }
	  }, {
	    key: 'recycle',
	    value: function recycle() {
	      for (var _len8 = arguments.length, storeNames = Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
	        storeNames[_key8] = arguments[_key8];
	      }
	
	      var initialSnapshot = storeNames.length ? StateFunctions.filterSnapshots(this, this[Sym.INIT_SNAPSHOT], storeNames) : this[Sym.INIT_SNAPSHOT];
	
	      StateFunctions.setAppState(this, this.serialize(initialSnapshot), function (storeInst) {
	        storeInst[Sym.LIFECYCLE].emit('init');
	        storeInst.emitChange();
	      });
	    }
	  }, {
	    key: 'flush',
	    value: function flush() {
	      var state = this.serialize(StateFunctions.snapshot(this));
	      this.recycle();
	      return state;
	    }
	  }, {
	    key: 'bootstrap',
	    value: function bootstrap(data) {
	      StateFunctions.setAppState(this, data, function (storeInst) {
	        storeInst[Sym.LIFECYCLE].emit('bootstrap');
	        storeInst.emitChange();
	      });
	    }
	  }, {
	    key: 'prepare',
	    value: function prepare(storeInst, payload) {
	      var data = {};
	      if (!storeInst.displayName) {
	        throw new ReferenceError('Store provided does not have a name');
	      }
	      data[storeInst.displayName] = payload;
	      return this.serialize(data);
	    }
	  }, {
	    key: 'addActions',
	
	    // Instance type methods for injecting alt into your application as context
	
	    value: function addActions(name, ActionsClass) {
	      for (var _len9 = arguments.length, args = Array(_len9 > 2 ? _len9 - 2 : 0), _key9 = 2; _key9 < _len9; _key9++) {
	        args[_key9 - 2] = arguments[_key9];
	      }
	
	      this.actions[name] = Array.isArray(ActionsClass) ? this.generateActions.apply(this, ActionsClass) : this.createActions.apply(this, [ActionsClass].concat(args));
	    }
	  }, {
	    key: 'addStore',
	    value: function addStore(name, StoreModel) {
	      for (var _len10 = arguments.length, args = Array(_len10 > 2 ? _len10 - 2 : 0), _key10 = 2; _key10 < _len10; _key10++) {
	        args[_key10 - 2] = arguments[_key10];
	      }
	
	      this.createStore.apply(this, [StoreModel, name].concat(args));
	    }
	  }, {
	    key: 'getActions',
	    value: function getActions(name) {
	      return this.actions[name];
	    }
	  }, {
	    key: 'getStore',
	    value: function getStore(name) {
	      return this.stores[name];
	    }
	  }], [{
	    key: 'debug',
	    value: function debug(name, alt) {
	      var key = 'alt.js.org';
	      if (typeof window !== 'undefined') {
	        window[key] = window[key] || [];
	        window[key].push({ name: name, alt: alt });
	      }
	      return alt;
	    }
	  }]);
	
	  return Alt;
	})();
	
	exports['default'] = Alt;
	module.exports = exports['default'];

/***/ }),
/* 930 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _eventemitter3 = __webpack_require__(522);
	
	var _eventemitter32 = _interopRequireDefault(_eventemitter3);
	
	var _esSymbol = __webpack_require__(238);
	
	var _esSymbol2 = _interopRequireDefault(_esSymbol);
	
	var _symbolsSymbols = __webpack_require__(121);
	
	var Sym = _interopRequireWildcard(_symbolsSymbols);
	
	var _utilsFunctions = __webpack_require__(159);
	
	var fn = _interopRequireWildcard(_utilsFunctions);
	
	// event emitter instance
	var EE = (0, _esSymbol2['default'])();
	
	var AltStore = (function () {
	  function AltStore(alt, model, state, StoreModel) {
	    var _this = this;
	
	    _classCallCheck(this, AltStore);
	
	    this[EE] = new _eventemitter32['default']();
	    this[Sym.LIFECYCLE] = model[Sym.LIFECYCLE];
	    this[Sym.STATE_CONTAINER] = state || model;
	
	    this.preventDefault = false;
	    this._storeName = model._storeName;
	    this.boundListeners = model[Sym.ALL_LISTENERS];
	    this.StoreModel = StoreModel;
	
	    var output = model.output || function (x) {
	      return x;
	    };
	
	    this.emitChange = function () {
	      _this[EE].emit('change', output.call(model, _this[Sym.STATE_CONTAINER]));
	    };
	
	    var handleDispatch = function handleDispatch(f, payload) {
	      try {
	        return f();
	      } catch (e) {
	        if (model[Sym.HANDLING_ERRORS]) {
	          _this[Sym.LIFECYCLE].emit('error', e, payload, _this[Sym.STATE_CONTAINER]);
	          return false;
	        } else {
	          throw e;
	        }
	      }
	    };
	
	    fn.assign(this, model[Sym.PUBLIC_METHODS]);
	
	    // Register dispatcher
	    this.dispatchToken = alt.dispatcher.register(function (payload) {
	      _this.preventDefault = false;
	      _this[Sym.LIFECYCLE].emit('beforeEach', payload, _this[Sym.STATE_CONTAINER]);
	
	      var actionHandler = model[Sym.LISTENERS][payload.action] || model.otherwise;
	
	      if (actionHandler) {
	        var result = handleDispatch(function () {
	          return actionHandler.call(model, payload.data, payload.action);
	        }, payload);
	
	        if (result !== false && !_this.preventDefault) _this.emitChange();
	      }
	
	      if (model.reduce) {
	        handleDispatch(function () {
	          model.setState(model.reduce(_this[Sym.STATE_CONTAINER], payload));
	        }, payload);
	
	        if (!_this.preventDefault) _this.emitChange();
	      }
	
	      _this[Sym.LIFECYCLE].emit('afterEach', payload, _this[Sym.STATE_CONTAINER]);
	    });
	
	    this[Sym.LIFECYCLE].emit('init');
	  }
	
	  _createClass(AltStore, [{
	    key: 'getEventEmitter',
	    value: function getEventEmitter() {
	      return this[EE];
	    }
	  }, {
	    key: 'listen',
	    value: function listen(cb) {
	      var _this2 = this;
	
	      this[EE].on('change', cb);
	      return function () {
	        return _this2.unlisten(cb);
	      };
	    }
	  }, {
	    key: 'unlisten',
	    value: function unlisten(cb) {
	      if (!cb) throw new TypeError('Unlisten must receive a function');
	      this[Sym.LIFECYCLE].emit('unlisten');
	      this[EE].removeListener('change', cb);
	    }
	  }, {
	    key: 'getState',
	    value: function getState() {
	      return this.StoreModel.config.getState.call(this, this[Sym.STATE_CONTAINER]);
	    }
	  }]);
	
	  return AltStore;
	})();
	
	exports['default'] = AltStore;
	module.exports = exports['default'];

/***/ }),
/* 931 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _esSymbol = __webpack_require__(238);
	
	var _esSymbol2 = _interopRequireDefault(_esSymbol);
	
	var _symbolsSymbols = __webpack_require__(121);
	
	var Sym = _interopRequireWildcard(_symbolsSymbols);
	
	var _utilsFunctions = __webpack_require__(159);
	
	var fn = _interopRequireWildcard(_utilsFunctions);
	
	var StoreMixin = {
	  waitFor: function waitFor() {
	    for (var _len = arguments.length, sources = Array(_len), _key = 0; _key < _len; _key++) {
	      sources[_key] = arguments[_key];
	    }
	
	    if (!sources.length) {
	      throw new ReferenceError('Dispatch tokens not provided');
	    }
	
	    var sourcesArray = sources;
	    if (sources.length === 1) {
	      sourcesArray = Array.isArray(sources[0]) ? sources[0] : sources;
	    }
	
	    var tokens = sourcesArray.map(function (source) {
	      return source.dispatchToken || source;
	    });
	
	    this.dispatcher.waitFor(tokens);
	  },
	
	  exportAsync: function exportAsync(asyncMethods) {
	    this.registerAsync(asyncMethods);
	  },
	
	  registerAsync: function registerAsync(asyncDef) {
	    var _this = this;
	
	    var loadCounter = 0;
	
	    var asyncMethods = fn.isFunction(asyncDef) ? asyncDef(this.alt) : asyncDef;
	
	    var toExport = Object.keys(asyncMethods).reduce(function (publicMethods, methodName) {
	      var desc = asyncMethods[methodName];
	      var spec = fn.isFunction(desc) ? desc(_this) : desc;
	
	      var validHandlers = ['success', 'error', 'loading'];
	      validHandlers.forEach(function (handler) {
	        if (spec[handler] && !spec[handler][Sym.ACTION_KEY]) {
	          throw new Error('' + handler + ' handler must be an action function');
	        }
	      });
	
	      publicMethods[methodName] = function () {
	        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	          args[_key2] = arguments[_key2];
	        }
	
	        var state = _this.getInstance().getState();
	        var value = spec.local && spec.local.apply(spec, [state].concat(args));
	        var shouldFetch = spec.shouldFetch ? spec.shouldFetch.apply(spec, [state].concat(args)) : value == null;
	        var intercept = spec.interceptResponse || function (x) {
	          return x;
	        };
	
	        var makeActionHandler = function makeActionHandler(action, isError) {
	          return function (x) {
	            var fire = function fire() {
	              loadCounter -= 1;
	              action(intercept(x, action, args));
	              if (isError) throw x;
	            };
	            return typeof window === 'undefined' ? function () {
	              return fire();
	            } : fire();
	          };
	        };
	
	        // if we don't have it in cache then fetch it
	        if (shouldFetch) {
	          loadCounter += 1;
	          /* istanbul ignore else */
	          if (spec.loading) spec.loading(intercept(null, spec.loading, args));
	          return spec.remote.apply(spec, [state].concat(args))['catch'](makeActionHandler(spec.error, 1)).then(makeActionHandler(spec.success));
	        } else {
	          // otherwise emit the change now
	          _this.emitChange();
	        }
	      };
	
	      return publicMethods;
	    }, {});
	
	    this.exportPublicMethods(toExport);
	    this.exportPublicMethods({
	      isLoading: function isLoading() {
	        return loadCounter > 0;
	      }
	    });
	  },
	
	  exportPublicMethods: function exportPublicMethods(methods) {
	    var _this2 = this;
	
	    fn.eachObject(function (methodName, value) {
	      if (!fn.isFunction(value)) {
	        throw new TypeError('exportPublicMethods expects a function');
	      }
	
	      _this2[Sym.PUBLIC_METHODS][methodName] = value;
	    }, [methods]);
	  },
	
	  emitChange: function emitChange() {
	    this.getInstance().emitChange();
	  },
	
	  on: function on(lifecycleEvent, handler) {
	    if (lifecycleEvent === 'error') {
	      this[Sym.HANDLING_ERRORS] = true;
	    }
	    this[Sym.LIFECYCLE].on(lifecycleEvent, handler.bind(this));
	  },
	
	  bindAction: function bindAction(symbol, handler) {
	    if (!symbol) {
	      throw new ReferenceError('Invalid action reference passed in');
	    }
	    if (!fn.isFunction(handler)) {
	      throw new TypeError('bindAction expects a function');
	    }
	
	    if (handler.length > 1) {
	      throw new TypeError('Action handler in store ' + this._storeName + ' for ' + ('' + (symbol[Sym.ACTION_KEY] || symbol).toString() + ' was defined with ') + 'two parameters. Only a single parameter is passed through the ' + 'dispatcher, did you mean to pass in an Object instead?');
	    }
	
	    // You can pass in the constant or the function itself
	    var key = symbol[Sym.ACTION_KEY] ? symbol[Sym.ACTION_KEY] : symbol;
	    this[Sym.LISTENERS][key] = handler.bind(this);
	    this[Sym.ALL_LISTENERS].push(_esSymbol2['default'].keyFor(key));
	  },
	
	  bindActions: function bindActions(actions) {
	    var _this3 = this;
	
	    fn.eachObject(function (action, symbol) {
	      var matchFirstCharacter = /./;
	      var assumedEventHandler = action.replace(matchFirstCharacter, function (x) {
	        return 'on' + x[0].toUpperCase();
	      });
	      var handler = null;
	
	      if (_this3[action] && _this3[assumedEventHandler]) {
	        // If you have both action and onAction
	        throw new ReferenceError('You have multiple action handlers bound to an action: ' + ('' + action + ' and ' + assumedEventHandler));
	      } else if (_this3[action]) {
	        // action
	        handler = _this3[action];
	      } else if (_this3[assumedEventHandler]) {
	        // onAction
	        handler = _this3[assumedEventHandler];
	      }
	
	      if (handler) {
	        _this3.bindAction(symbol, handler);
	      }
	    }, [actions]);
	  },
	
	  bindListeners: function bindListeners(obj) {
	    var _this4 = this;
	
	    fn.eachObject(function (methodName, symbol) {
	      var listener = _this4[methodName];
	
	      if (!listener) {
	        throw new ReferenceError('' + methodName + ' defined but does not exist in ' + _this4._storeName);
	      }
	
	      if (Array.isArray(symbol)) {
	        symbol.forEach(function (action) {
	          _this4.bindAction(action, listener);
	        });
	      } else {
	        _this4.bindAction(symbol, listener);
	      }
	    }, [obj]);
	  }
	};
	
	exports['default'] = StoreMixin;
	module.exports = exports['default'];

/***/ }),
/* 932 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var _bind = Function.prototype.bind;
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; desc = parent = getter = undefined; _again = false; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	exports.createStoreConfig = createStoreConfig;
	exports.transformStore = transformStore;
	exports.createStoreFromObject = createStoreFromObject;
	exports.createStoreFromClass = createStoreFromClass;
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) subClass.__proto__ = superClass; }
	
	var _eventemitter3 = __webpack_require__(522);
	
	var _eventemitter32 = _interopRequireDefault(_eventemitter3);
	
	var _symbolsSymbols = __webpack_require__(121);
	
	var Sym = _interopRequireWildcard(_symbolsSymbols);
	
	var _utilsAltUtils = __webpack_require__(275);
	
	var utils = _interopRequireWildcard(_utilsAltUtils);
	
	var _utilsFunctions = __webpack_require__(159);
	
	var fn = _interopRequireWildcard(_utilsFunctions);
	
	var _AltStore = __webpack_require__(930);
	
	var _AltStore2 = _interopRequireDefault(_AltStore);
	
	var _StoreMixin = __webpack_require__(931);
	
	var _StoreMixin2 = _interopRequireDefault(_StoreMixin);
	
	function doSetState(store, storeInstance, state) {
	  if (!state) {
	    return;
	  }
	
	  var config = storeInstance.StoreModel.config;
	
	  var nextState = fn.isFunction(state) ? state(storeInstance[Sym.STATE_CONTAINER]) : state;
	
	  storeInstance[Sym.STATE_CONTAINER] = config.setState.call(store, storeInstance[Sym.STATE_CONTAINER], nextState);
	
	  if (!store.alt.dispatcher.isDispatching()) {
	    store.emitChange();
	  }
	}
	
	function createPrototype(proto, alt, key, extras) {
	  proto[Sym.ALL_LISTENERS] = [];
	  proto[Sym.LIFECYCLE] = new _eventemitter32['default']();
	  proto[Sym.LISTENERS] = {};
	  proto[Sym.PUBLIC_METHODS] = {};
	
	  return fn.assign(proto, _StoreMixin2['default'], {
	    _storeName: key,
	    alt: alt,
	    dispatcher: alt.dispatcher,
	    preventDefault: function preventDefault() {
	      this.getInstance().preventDefault = true;
	    }
	  }, extras);
	}
	
	function createStoreConfig(globalConfig, StoreModel) {
	  StoreModel.config = fn.assign({
	    getState: function getState(state) {
	      return fn.assign({}, state);
	    },
	    setState: fn.assign
	  }, globalConfig, StoreModel.config);
	}
	
	function transformStore(transforms, StoreModel) {
	  return transforms.reduce(function (Store, transform) {
	    return transform(Store);
	  }, StoreModel);
	}
	
	function createStoreFromObject(alt, StoreModel, key) {
	  var storeInstance = undefined;
	
	  var StoreProto = createPrototype({}, alt, key, fn.assign({
	    getInstance: function getInstance() {
	      return storeInstance;
	    },
	    setState: function setState(nextState) {
	      doSetState(this, storeInstance, nextState);
	    }
	  }, StoreModel));
	
	  // bind the store listeners
	  /* istanbul ignore else */
	  if (StoreProto.bindListeners) {
	    _StoreMixin2['default'].bindListeners.call(StoreProto, StoreProto.bindListeners);
	  }
	  /* istanbul ignore else */
	  if (StoreProto.observe) {
	    _StoreMixin2['default'].bindListeners.call(StoreProto, StoreProto.observe(alt));
	  }
	
	  // bind the lifecycle events
	  /* istanbul ignore else */
	  if (StoreProto.lifecycle) {
	    fn.eachObject(function (eventName, event) {
	      _StoreMixin2['default'].on.call(StoreProto, eventName, event);
	    }, [StoreProto.lifecycle]);
	  }
	
	  // create the instance and fn.assign the public methods to the instance
	  storeInstance = fn.assign(new _AltStore2['default'](alt, StoreProto, StoreProto.state || {}, StoreModel), StoreProto.publicMethods, { displayName: key });
	
	  return storeInstance;
	}
	
	function createStoreFromClass(alt, StoreModel, key) {
	  for (var _len = arguments.length, argsForClass = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
	    argsForClass[_key - 3] = arguments[_key];
	  }
	
	  var storeInstance = undefined;
	  var config = StoreModel.config;
	
	  // Creating a class here so we don't overload the provided store's
	  // prototype with the mixin behaviour and I'm extending from StoreModel
	  // so we can inherit any extensions from the provided store.
	
	  var Store = (function (_StoreModel) {
	    function Store() {
	      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        args[_key2] = arguments[_key2];
	      }
	
	      _classCallCheck(this, Store);
	
	      _get(Object.getPrototypeOf(Store.prototype), 'constructor', this).apply(this, args);
	    }
	
	    _inherits(Store, _StoreModel);
	
	    return Store;
	  })(StoreModel);
	
	  createPrototype(Store.prototype, alt, key, {
	    getInstance: function getInstance() {
	      return storeInstance;
	    },
	    setState: function setState(nextState) {
	      doSetState(this, storeInstance, nextState);
	    }
	  });
	
	  var store = new (_bind.apply(Store, [null].concat(argsForClass)))();
	
	  if (config.bindListeners) store.bindListeners(config.bindListeners);
	  if (config.datasource) store.registerAsync(config.datasource);
	
	  storeInstance = fn.assign(new _AltStore2['default'](alt, store, store[alt.config.stateKey] || store[config.stateKey] || null, StoreModel), utils.getInternalMethods(StoreModel), config.publicMethods, { displayName: key });
	
	  return storeInstance;
	}

/***/ }),
/* 933 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.setAppState = setAppState;
	exports.snapshot = snapshot;
	exports.saveInitialSnapshot = saveInitialSnapshot;
	exports.filterSnapshots = filterSnapshots;
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	var _symbolsSymbols = __webpack_require__(121);
	
	var Sym = _interopRequireWildcard(_symbolsSymbols);
	
	var _utilsFunctions = __webpack_require__(159);
	
	var fn = _interopRequireWildcard(_utilsFunctions);
	
	function setAppState(instance, data, onStore) {
	  var obj = instance.deserialize(data);
	  fn.eachObject(function (key, value) {
	    var store = instance.stores[key];
	    if (store) {
	      var config = store.StoreModel.config;
	
	      if (config.onDeserialize) {
	        obj[key] = config.onDeserialize(value) || value;
	      }
	      fn.assign(store[Sym.STATE_CONTAINER], obj[key]);
	      onStore(store);
	    }
	  }, [obj]);
	}
	
	function snapshot(instance) {
	  var storeNames = arguments[1] === undefined ? [] : arguments[1];
	
	  var stores = storeNames.length ? storeNames : Object.keys(instance.stores);
	  return stores.reduce(function (obj, storeHandle) {
	    var storeName = storeHandle.displayName || storeHandle;
	    var store = instance.stores[storeName];
	    var config = store.StoreModel.config;
	
	    store[Sym.LIFECYCLE].emit('snapshot');
	    var customSnapshot = config.onSerialize && config.onSerialize(store[Sym.STATE_CONTAINER]);
	    obj[storeName] = customSnapshot ? customSnapshot : store.getState();
	    return obj;
	  }, {});
	}
	
	function saveInitialSnapshot(instance, key) {
	  var state = instance.deserialize(instance.serialize(instance.stores[key][Sym.STATE_CONTAINER]));
	  instance[Sym.INIT_SNAPSHOT][key] = state;
	  instance[Sym.LAST_SNAPSHOT][key] = state;
	}
	
	function filterSnapshots(instance, state, stores) {
	  return stores.reduce(function (obj, store) {
	    var storeName = store.displayName || store;
	    if (!state[storeName]) {
	      throw new ReferenceError('' + storeName + ' is not a valid store');
	    }
	    obj[storeName] = state[storeName];
	    return obj;
	  }, {});
	}

/***/ }),
/* 934 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(1);
	
	var Style = __webpack_require__(455);
	var printStyles = __webpack_require__(460);
	
	var PrintStyle = React.createClass({
	  displayName: 'PrintStyle',
	
	  getInitialState: function getInitialState() {
	    return this._getStylesState();
	  },
	
	  componentDidMount: function componentDidMount() {
	    this.subscription = printStyles.subscribe(this._onChange);
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    this.subscription.remove();
	  },
	
	  _onChange: function _onChange() {
	    this.setState(this._getStylesState());
	  },
	
	  _getStylesState: function _getStylesState() {
	    return {
	      styles: printStyles.getPrintStyles()
	    };
	  },
	
	  render: function render() {
	    return React.createElement(Style, { rules: {
	        mediaQueries: {
	          print: this.state.styles
	        }
	      } });
	  }
	});
	
	module.exports = PrintStyle;

/***/ }),
/* 935 */
/***/ (function(module, exports, __webpack_require__) {

	/* @flow */
	
	'use strict';
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x2, _x3, _x4) { var _again = true; _function: while (_again) { var object = _x2, property = _x3, receiver = _x4; desc = parent = getter = undefined; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x2 = parent; _x3 = property; _x4 = receiver; _again = true; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var resolveStyles = __webpack_require__(944);
	var printStyles = __webpack_require__(460);
	
	var KEYS_TO_IGNORE_WHEN_COPYING_PROPERTIES = ['arguments', 'callee', 'caller', 'length', 'name', 'prototype', 'type'];
	
	var copyProperties = function copyProperties(source, target) {
	  Object.getOwnPropertyNames(source).forEach(function (key) {
	    if (KEYS_TO_IGNORE_WHEN_COPYING_PROPERTIES.indexOf(key) < 0 && !target.hasOwnProperty(key)) {
	      var descriptor = Object.getOwnPropertyDescriptor(source, key);
	      Object.defineProperty(target, key, descriptor);
	    }
	  });
	};
	
	var enhanceWithRadium = function enhanceWithRadium(configOrComposedComponent /*: constructor | Object*/) /*: constructor*/ {
	  var config /*:: ?: Object*/ = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	  if (typeof configOrComposedComponent !== 'function') {
	    var newConfig = _extends({}, config, configOrComposedComponent);
	    return function (configOrComponent) {
	      return enhanceWithRadium(configOrComponent, newConfig);
	    };
	  }
	
	  var ComposedComponent = configOrComposedComponent;
	
	  var RadiumEnhancer = (function (_ComposedComponent) {
	    _inherits(RadiumEnhancer, _ComposedComponent);
	
	    function RadiumEnhancer() {
	      _classCallCheck(this, RadiumEnhancer);
	
	      _get(Object.getPrototypeOf(RadiumEnhancer.prototype), 'constructor', this).apply(this, arguments);
	
	      this.state = this.state || {};
	      this.state._radiumStyleState = {};
	
	      if (RadiumEnhancer.printStyleClass) {
	        this.printStyleClass = RadiumEnhancer.printStyleClass;
	      }
	    }
	
	    // Class inheritance uses Object.create and because of __proto__ issues
	    // with IE <10 any static properties of the superclass aren't inherited and
	    // so need to be manually populated.
	    // See http://babeljs.io/docs/advanced/caveats/#classes-10-and-below-
	
	    _createClass(RadiumEnhancer, [{
	      key: 'render',
	      value: function render() {
	        var renderedElement = _get(Object.getPrototypeOf(RadiumEnhancer.prototype), 'render', this).call(this);
	        return resolveStyles(this, renderedElement, config);
	      }
	    }, {
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        if (_get(Object.getPrototypeOf(RadiumEnhancer.prototype), 'componentWillUnmount', this)) {
	          _get(Object.getPrototypeOf(RadiumEnhancer.prototype), 'componentWillUnmount', this).call(this);
	        }
	
	        if (this._radiumMouseUpListener) {
	          this._radiumMouseUpListener.remove();
	        }
	
	        if (this._radiumMediaQueryListenersByQuery) {
	          Object.keys(this._radiumMediaQueryListenersByQuery).forEach(function (query) {
	            this._radiumMediaQueryListenersByQuery[query].remove();
	          }, this);
	        }
	      }
	    }]);
	
	    return RadiumEnhancer;
	  })(ComposedComponent);
	
	  copyProperties(ComposedComponent, RadiumEnhancer);
	
	  if (false) {
	    // This also fixes React Hot Loader by exposing the original components top
	    // level prototype methods on the Radium enhanced prototype as discussed in
	    // https://github.com/FormidableLabs/radium/issues/219.
	    copyProperties(ComposedComponent.prototype, RadiumEnhancer.prototype);
	  }
	
	  RadiumEnhancer.displayName = ComposedComponent.displayName || ComposedComponent.name || 'Component';
	
	  RadiumEnhancer.printStyleClass = printStyles.addPrintStyles(RadiumEnhancer);
	
	  return RadiumEnhancer;
	};
	
	module.exports = enhanceWithRadium;

/***/ }),
/* 936 */
/***/ (function(module, exports, __webpack_require__) {

	/* @flow */
	
	'use strict';
	
	var createMarkupForStyles = __webpack_require__(456);
	var Prefixer = __webpack_require__(276);
	
	var ExecutionEnvironment = __webpack_require__(141);
	
	var isAnimationSupported = ExecutionEnvironment.canUseDOM && Prefixer.getPrefixedPropertyName('animation') !== false;
	
	var animationIndex = 1;
	var animationStyleSheet = null;
	var keyframesPrefixed = 'keyframes';
	
	if (isAnimationSupported) {
	  animationStyleSheet = (document.createElement('style') /*: any*/);
	  document.head.appendChild(animationStyleSheet);
	
	  // Test if prefix needed for keyframes (copied from PrefixFree)
	  animationStyleSheet.textContent = '@keyframes {}';
	  if (!animationStyleSheet.sheet.cssRules.length) {
	    keyframesPrefixed = Prefixer.cssPrefix + 'keyframes';
	  }
	}
	
	// Simple animation helper that injects CSS into a style object containing the
	// keyframes, and returns a string with the generated animation name.
	var keyframes = function keyframes(keyframeRules /*: {[percentage: string]: {[key: string]: string|number}}*/, componentName /*:: ?: string*/) /*: string*/ {
	  var name = 'Animation' + animationIndex;
	  animationIndex += 1;
	
	  if (!isAnimationSupported) {
	    return name;
	  }
	
	  var rule = '@' + keyframesPrefixed + ' ' + name + ' {\n' + Object.keys(keyframeRules).map(function (percentage) {
	    var props = keyframeRules[percentage];
	    var prefixedProps = Prefixer.getPrefixedStyle(componentName, props, 'css');
	    var serializedProps = createMarkupForStyles(prefixedProps, '  ');
	    return '  ' + percentage + ' {\n  ' + serializedProps + '\n  }';
	  }).join('\n') + '\n}\n';
	
	  // for flow
	  /* istanbul ignore next */
	  if (!animationStyleSheet) {
	    throw new Error('keyframes not initialized properly');
	  }
	
	  animationStyleSheet.sheet.insertRule(rule, animationStyleSheet.sheet.cssRules.length);
	  return name;
	};
	
	module.exports = keyframes;

/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var isPlainObject = __webpack_require__(546);
	
	var shouldMerge = function shouldMerge(value) {
	  // Don't merge objects overriding toString, since they should be converted
	  // to string values.
	  return isPlainObject(value) && value.toString === Object.prototype.toString;
	};
	
	// Merge style objects. Deep merge plain object values.
	var mergeStyles = function mergeStyles(styles) {
	  var result = {};
	
	  styles.forEach(function (style) {
	    if (!style || typeof style !== 'object') {
	      return;
	    }
	
	    if (Array.isArray(style)) {
	      style = mergeStyles(style);
	    }
	
	    Object.keys(style).forEach(function (key) {
	      if (shouldMerge(style[key]) && shouldMerge(result[key])) {
	        result[key] = mergeStyles([result[key], style[key]]);
	      } else {
	        result[key] = style[key];
	      }
	    });
	  });
	
	  return result;
	};
	
	module.exports = mergeStyles;

/***/ }),
/* 938 */
/***/ (function(module, exports, __webpack_require__) {

	/* @flow */
	
	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	/*:: import type {PluginConfig, PluginResult} from '.';*/
	
	var checkProps = (function () {} /*: any*/);
	
	if (false) {
	  // Warn if you use longhand and shorthand properties in the same style
	  // object.
	  // https://developer.mozilla.org/en-US/docs/Web/CSS/Shorthand_properties
	
	  var shorthandPropertyExpansions = {
	    'background': ['backgroundAttachment', 'backgroundBlendMode', 'backgroundClip', 'backgroundColor', 'backgroundImage', 'backgroundOrigin', 'backgroundPosition', 'backgroundPositionX', 'backgroundPositionY', 'backgroundRepeat', 'backgroundRepeatX', 'backgroundRepeatY', 'backgroundSize'],
	    'border': ['borderBottom', 'borderBottomColor', 'borderBottomStyle', 'borderBottomWidth', 'borderColor', 'borderLeft', 'borderLeftColor', 'borderLeftStyle', 'borderLeftWidth', 'borderRight', 'borderRightColor', 'borderRightStyle', 'borderRightWidth', 'borderStyle', 'borderTop', 'borderTopColor', 'borderTopStyle', 'borderTopWidth', 'borderWidth'],
	    'borderImage': ['borderImageOutset', 'borderImageRepeat', 'borderImageSlice', 'borderImageSource', 'borderImageWidth'],
	    'borderRadius': ['borderBottomLeftRadius', 'borderBottomRightRadius', 'borderTopLeftRadius', 'borderTopRightRadius'],
	    'font': ['fontFamily', 'fontKerning', 'fontSize', 'fontStretch', 'fontStyle', 'fontVariant', 'fontVariantLigatures', 'fontWeight', 'lineHeight'],
	    'listStyle': ['listStyleImage', 'listStylePosition', 'listStyleType'],
	    'margin': ['marginBottom', 'marginLeft', 'marginRight', 'marginTop'],
	    'padding': ['paddingBottom', 'paddingLeft', 'paddingRight', 'paddingTop'],
	    'transition': ['transitionDelay', 'transitionDuration', 'transitionProperty', 'transitionTimingFunction']
	  };
	
	  checkProps = function (config /*: PluginConfig*/) /*: PluginResult*/ {
	    var componentName = config.componentName;
	    var style = config.style;
	
	    if (typeof style !== 'object' || !style) {
	      return;
	    }
	
	    var styleKeys = Object.keys(style);
	    styleKeys.forEach(function (styleKey) {
	      if (shorthandPropertyExpansions[styleKey] && shorthandPropertyExpansions[styleKey].some(function (sp) {
	        return styleKeys.indexOf(sp) !== -1;
	      })) {
	        if (process.env.NODE_ENV !== 'production') {
	          /* eslint-disable no-console */
	          console.warn('Radium: property "' + styleKey + '" in style object', style, ': do not mix longhand and ' + 'shorthand properties in the same style object. Check the render ' + 'method of ' + componentName + '.', 'See https://github.com/FormidableLabs/radium/issues/95 for more ' + 'information.');
	          /* eslint-enable no-console */
	        }
	      }
	    });
	
	    styleKeys.forEach(function (k) {
	      return checkProps(_extends({}, config, { style: style[k] }));
	    });
	    return;
	  };
	}
	
	module.exports = checkProps;

/***/ }),
/* 939 */
/***/ (function(module, exports) {

	/* @flow */
	
	'use strict';
	
	// Convenient syntax for multiple styles: `style={[style1, style2, etc]}`
	// Ignores non-objects, so you can do `this.state.isCool && styles.cool`.
	/*:: import type {PluginConfig, PluginResult} from '.';*/var mergeStyleArrayPlugin = function mergeStyleArrayPlugin(_ref /*: PluginConfig*/) /*: PluginResult*/ {
	  var style = _ref.style;
	  var mergeStyles = _ref.mergeStyles;
	
	  var newStyle = Array.isArray(style) ? mergeStyles(style) : style;
	  return { style: newStyle };
	};
	
	module.exports = mergeStyleArrayPlugin;

/***/ }),
/* 940 */
/***/ (function(module, exports) {

	/* @flow */
	
	'use strict';
	
	var _callbacks = [];
	var _mouseUpListenerIsActive = false;
	
	var _handleMouseUp = function _handleMouseUp(ev) {
	  _callbacks.forEach(function (callback) {
	    callback(ev);
	  });
	};
	
	var subscribe = function subscribe(callback /*: () => void*/) /*: {remove: () => void}*/ {
	  if (_callbacks.indexOf(callback) === -1) {
	    _callbacks.push(callback);
	  }
	
	  if (!_mouseUpListenerIsActive) {
	    window.addEventListener('mouseup', _handleMouseUp);
	    _mouseUpListenerIsActive = true;
	  }
	
	  return {
	    remove: function remove() {
	      var index = _callbacks.indexOf(callback);
	      _callbacks.splice(index, 1);
	
	      if (_callbacks.length === 0 && _mouseUpListenerIsActive) {
	        window.removeEventListener('mouseup', _handleMouseUp);
	        _mouseUpListenerIsActive = false;
	      }
	    }
	  };
	};
	
	module.exports = {
	  subscribe: subscribe
	};

/***/ }),
/* 941 */
/***/ (function(module, exports, __webpack_require__) {

	/* @flow */
	
	'use strict';
	
	/*:: import type {PluginConfig, PluginResult} from '.';*/
	
	var Prefixer = __webpack_require__(276);
	
	var prefixPlugin = function prefixPlugin(_ref /*: PluginConfig*/) /*: PluginResult*/ {
	  var componentName = _ref.componentName;
	  var style = _ref.style;
	
	  var newStyle = Prefixer.getPrefixedStyle(componentName, style);
	  return { style: newStyle };
	};
	
	module.exports = prefixPlugin;

/***/ }),
/* 942 */
/***/ (function(module, exports, __webpack_require__) {

	/** @flow */
	
	'use strict';
	
	/*:: import type {PluginConfig, PluginResult} from '.';*/
	
	var MouseUpListener = __webpack_require__(940);
	
	var _isInteractiveStyleField = function _isInteractiveStyleField(styleFieldName) {
	  return styleFieldName === ':hover' || styleFieldName === ':active' || styleFieldName === ':focus';
	};
	
	var resolveInteractionStyles = function resolveInteractionStyles(config /*: PluginConfig*/) /*: PluginResult*/ {
	  var ExecutionEnvironment = config.ExecutionEnvironment;
	  var getComponentField = config.getComponentField;
	  var getState = config.getState;
	  var mergeStyles = config.mergeStyles;
	  var props = config.props;
	  var setState = config.setState;
	  var style = config.style;
	
	  var newComponentFields = {};
	  var newProps = {};
	
	  // Only add handlers if necessary
	  if (style[':hover'] || style[':active']) {
	    // Always call the existing handler if one is already defined.
	    // This code, and the very similar ones below, could be abstracted a bit
	    // more, but it hurts readability IMO.
	    var existingOnMouseEnter = props.onMouseEnter;
	    newProps.onMouseEnter = function (e) {
	      existingOnMouseEnter && existingOnMouseEnter(e);
	      setState(':hover', true);
	    };
	
	    var existingOnMouseLeave = props.onMouseLeave;
	    newProps.onMouseLeave = function (e) {
	      existingOnMouseLeave && existingOnMouseLeave(e);
	      setState(':hover', false);
	    };
	  }
	
	  if (style[':active']) {
	    var existingOnMouseDown = props.onMouseDown;
	    newProps.onMouseDown = function (e) {
	      existingOnMouseDown && existingOnMouseDown(e);
	      newComponentFields._lastMouseDown = Date.now();
	      setState(':active', true);
	    };
	  }
	
	  if (style[':focus']) {
	    var existingOnFocus = props.onFocus;
	    newProps.onFocus = function (e) {
	      existingOnFocus && existingOnFocus(e);
	      setState(':focus', true);
	    };
	
	    var existingOnBlur = props.onBlur;
	    newProps.onBlur = function (e) {
	      existingOnBlur && existingOnBlur(e);
	      setState(':focus', false);
	    };
	  }
	
	  if (style[':active'] && !getComponentField('_radiumMouseUpListener') && ExecutionEnvironment.canUseEventListeners) {
	    newComponentFields._radiumMouseUpListener = MouseUpListener.subscribe(function () {
	      Object.keys(getComponentField('state')._radiumStyleState).forEach(function (key) {
	        if (getState(':active')) {
	          setState(':active', false, key);
	        }
	      });
	    });
	  }
	
	  // Merge the styles in the order they were defined
	  var interactionStyles = Object.keys(style).filter(function (name) {
	    return _isInteractiveStyleField(name) && getState(name);
	  }).map(function (name) {
	    return style[name];
	  });
	
	  var newStyle = mergeStyles([style].concat(interactionStyles));
	
	  // Remove interactive styles
	  newStyle = Object.keys(newStyle).reduce(function (styleWithoutInteractions, name) {
	    if (!_isInteractiveStyleField(name)) {
	      styleWithoutInteractions[name] = newStyle[name];
	    }
	    return styleWithoutInteractions;
	  }, {});
	
	  return {
	    componentFields: newComponentFields,
	    props: newProps,
	    style: newStyle
	  };
	};
	
	module.exports = resolveInteractionStyles;

/***/ }),
/* 943 */
/***/ (function(module, exports) {

	/** @flow */
	
	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	/*:: import type {MatchMediaType} from '../config';*/
	/*:: import type {PluginConfig, PluginResult} from '.';*/
	
	var _windowMatchMedia;
	var _getWindowMatchMedia = function _getWindowMatchMedia(ExecutionEnvironment) {
	  if (_windowMatchMedia === undefined) {
	    _windowMatchMedia = !!ExecutionEnvironment.canUseDOM && !!window && !!window.matchMedia && function (mediaQueryString) {
	      return window.matchMedia(mediaQueryString);
	    } || null;
	  }
	  return _windowMatchMedia;
	};
	
	var resolveMediaQueries = function resolveMediaQueries(_ref /*: PluginConfig*/) /*: PluginResult*/ {
	  var ExecutionEnvironment = _ref.ExecutionEnvironment;
	  var getComponentField = _ref.getComponentField;
	  var getGlobalState = _ref.getGlobalState;
	  var config = _ref.config;
	  var mergeStyles = _ref.mergeStyles;
	  var setState = _ref.setState;
	  var style = _ref.style;
	
	  var newComponentFields = {};
	  var newStyle = style;
	  var matchMedia /*: ?MatchMediaType*/ = config.matchMedia || _getWindowMatchMedia(ExecutionEnvironment);
	  if (!matchMedia) {
	    return newStyle;
	  }
	
	  var mediaQueryListByQueryString = getGlobalState('mediaQueryListByQueryString') || {};
	
	  Object.keys(style).filter(function (name) {
	    return name.indexOf('@media') === 0;
	  }).map(function (query) {
	    var mediaQueryStyles = style[query];
	    query = query.replace('@media ', '');
	
	    // Create a global MediaQueryList if one doesn't already exist
	    var mql = mediaQueryListByQueryString[query];
	    if (!mql && matchMedia) {
	      mediaQueryListByQueryString[query] = mql = matchMedia(query);
	    }
	
	    var listenersByQuery = getComponentField('_radiumMediaQueryListenersByQuery');
	
	    if (!listenersByQuery || !listenersByQuery[query]) {
	      var listener = function listener() {
	        return setState(query, mql.matches, '_all');
	      };
	      mql.addListener(listener);
	      newComponentFields._radiumMediaQueryListenersByQuery = _extends({}, listenersByQuery);
	      newComponentFields._radiumMediaQueryListenersByQuery[query] = {
	        remove: function remove() {
	          mql.removeListener(listener);
	        }
	      };
	    }
	
	    // Apply media query states
	    if (mql.matches) {
	      newStyle = mergeStyles([newStyle, mediaQueryStyles]);
	    }
	  });
	
	  // Remove media queries
	  newStyle = Object.keys(newStyle).reduce(function (styleWithoutMedia, key) {
	    if (key.indexOf('@media') !== 0) {
	      styleWithoutMedia[key] = newStyle[key];
	    }
	    return styleWithoutMedia;
	  }, {});
	
	  return {
	    componentFields: newComponentFields,
	    globalState: { mediaQueryListByQueryString: mediaQueryListByQueryString },
	    style: newStyle
	  };
	};
	
	module.exports = resolveMediaQueries;

/***/ }),
/* 944 */
/***/ (function(module, exports, __webpack_require__) {

	/* @flow */
	
	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	/*:: import type {Config} from './config';*/
	
	var _getState = __webpack_require__(458);
	var getStateKey = __webpack_require__(457);
	var mergeStyles = __webpack_require__(937);
	var Plugins = __webpack_require__(459);
	
	var ExecutionEnvironment = __webpack_require__(141);
	var React = __webpack_require__(1);
	
	var DEFAULT_CONFIG = {
	  plugins: [Plugins.mergeStyleArray, Plugins.checkProps, Plugins.resolveMediaQueries, Plugins.resolveInteractionStyles, Plugins.prefix, Plugins.checkProps]
	};
	
	// Gross
	var globalState = {};
	
	// Declare early for recursive helpers.
	var resolveStyles = ((null /*: any*/) /*: (
	                                        component: any, // ReactComponent, flow+eslint complaining
	                                        renderedElement: any,
	                                        config: Config,
	                                        existingKeyMap?: {[key: string]: bool}
	                                      ) => any*/);
	
	var _resolveChildren = function _resolveChildren(_ref) {
	  var children = _ref.children;
	  var component = _ref.component;
	  var config = _ref.config;
	  var existingKeyMap = _ref.existingKeyMap;
	
	  if (!children) {
	    return children;
	  }
	
	  var childrenType = typeof children;
	
	  if (childrenType === 'string' || childrenType === 'number') {
	    // Don't do anything with a single primitive child
	    return children;
	  }
	
	  if (childrenType === 'function') {
	    // Wrap the function, resolving styles on the result
	    return function () {
	      var result = children.apply(this, arguments);
	      if (React.isValidElement(result)) {
	        return resolveStyles(component, result, config, existingKeyMap);
	      }
	      return result;
	    };
	  }
	
	  if (React.Children.count(children) === 1 && children.type) {
	    // If a React Element is an only child, don't wrap it in an array for
	    // React.Children.map() for React.Children.only() compatibility.
	    var onlyChild = React.Children.only(children);
	    return resolveStyles(component, onlyChild, config, existingKeyMap);
	  }
	
	  return React.Children.map(children, function (child) {
	    if (React.isValidElement(child)) {
	      return resolveStyles(component, child, config, existingKeyMap);
	    }
	
	    return child;
	  });
	};
	
	// Recurse over props, just like children
	var _resolveProps = function _resolveProps(_ref2) {
	  var component = _ref2.component;
	  var config = _ref2.config;
	  var existingKeyMap = _ref2.existingKeyMap;
	  var props = _ref2.props;
	
	  var newProps = props;
	
	  Object.keys(props).forEach(function (prop) {
	    // We already recurse over children above
	    if (prop === 'children') {
	      return;
	    }
	
	    var propValue = props[prop];
	    if (React.isValidElement(propValue)) {
	      newProps = _extends({}, newProps);
	      newProps[prop] = resolveStyles(component, propValue, config, existingKeyMap);
	    }
	  });
	
	  return newProps;
	};
	
	var _buildGetKey = function _buildGetKey(renderedElement, existingKeyMap) {
	  // We need a unique key to correlate state changes due to user interaction
	  // with the rendered element, so we know to apply the proper interactive
	  // styles.
	  var originalKey = renderedElement.ref || renderedElement.key;
	  var key = getStateKey(originalKey);
	
	  var alreadyGotKey = false;
	  var getKey = function getKey() {
	    if (alreadyGotKey) {
	      return key;
	    }
	
	    alreadyGotKey = true;
	
	    if (existingKeyMap[key]) {
	      throw new Error('Radium requires each element with interactive styles to have a unique ' + 'key, set using either the ref or key prop. ' + (originalKey ? 'Key "' + originalKey + '" is a duplicate.' : 'Multiple elements have no key specified.'));
	    }
	
	    existingKeyMap[key] = true;
	
	    return key;
	  };
	
	  return getKey;
	};
	
	var _setStyleState = function _setStyleState(component, key, stateKey, value) {
	  var existing = component._lastRadiumState || component.state && component.state._radiumStyleState || {};
	
	  var state = { _radiumStyleState: _extends({}, existing) };
	  state._radiumStyleState[key] = _extends({}, state._radiumStyleState[key]);
	  state._radiumStyleState[key][stateKey] = value;
	
	  component._lastRadiumState = state._radiumStyleState;
	  component.setState(state);
	};
	
	var _runPlugins = function _runPlugins(_ref3) {
	  var component = _ref3.component;
	  var config = _ref3.config;
	  var existingKeyMap = _ref3.existingKeyMap;
	  var props = _ref3.props;
	  var renderedElement = _ref3.renderedElement;
	
	  // Don't run plugins if renderedElement is not a simple ReactDOMElement or has
	  // no style.
	  if (!React.isValidElement(renderedElement) || typeof renderedElement.type !== 'string' || !props.style) {
	    return props;
	  }
	
	  var newProps = props;
	
	  var plugins = config.plugins || DEFAULT_CONFIG.plugins;
	
	  var getKey = _buildGetKey(renderedElement, existingKeyMap);
	
	  var newStyle = props.style;
	  plugins.forEach(function (plugin) {
	    var result = plugin({
	      ExecutionEnvironment: ExecutionEnvironment,
	      componentName: component.constructor.displayName || component.constructor.name,
	      getComponentField: function getComponentField(key) {
	        return component[key];
	      },
	      getGlobalState: function getGlobalState(key) {
	        return globalState[key];
	      },
	      config: config,
	      getState: function getState(stateKey, elementKey) {
	        return _getState(component.state, elementKey || getKey(), stateKey);
	      },
	      mergeStyles: mergeStyles,
	      props: newProps,
	      setState: function setState(stateKey, value, elementKey) {
	        return _setStyleState(component, elementKey || getKey(), stateKey, value);
	      },
	      style: newStyle
	    }) || {};
	
	    newStyle = result.style || newStyle;
	
	    newProps = result.props && Object.keys(result.props).length ? _extends({}, newProps, result.props) : newProps;
	
	    var newComponentFields = result.componentFields || {};
	    Object.keys(newComponentFields).forEach(function (fieldName) {
	      component[fieldName] = newComponentFields[fieldName];
	    });
	
	    var newGlobalState = result.globalState || {};
	    Object.keys(newGlobalState).forEach(function (key) {
	      globalState[key] = newGlobalState[key];
	    });
	  });
	
	  if (newStyle !== props.style) {
	    newProps = _extends({}, newProps, { style: newStyle });
	  }
	
	  return newProps;
	};
	
	// Wrapper around React.cloneElement. To avoid processing the same element
	// twice, whenever we clone an element add a special prop to make sure we don't
	// process this element again.
	var _cloneElement = function _cloneElement(renderedElement, newProps, newChildren) {
	  // Only add flag if this is a normal DOM element
	  if (typeof renderedElement.type === 'string') {
	    newProps = _extends({}, newProps, { _radiumDidResolveStyles: true });
	  }
	
	  return React.cloneElement(renderedElement, newProps, newChildren);
	};
	
	//
	// The nucleus of Radium. resolveStyles is called on the rendered elements
	// before they are returned in render. It iterates over the elements and
	// children, rewriting props to add event handlers required to capture user
	// interactions (e.g. mouse over). It also replaces the style prop because it
	// adds in the various interaction styles (e.g. :hover).
	//
	resolveStyles = function (component /*: any*/, // ReactComponent, flow+eslint complaining
	renderedElement /*: any*/, // ReactElement
	config /*: Config*/, existingKeyMap /*:: ?: {[key: string]: boolean}*/) /*: any*/ {
	  if (config === undefined) config = DEFAULT_CONFIG;
	  // ReactElement
	  existingKeyMap = existingKeyMap || {};
	
	  if (!renderedElement ||
	  // Bail if we've already processed this element. This ensures that only the
	  // owner of an element processes that element, since the owner's render
	  // function will be called first (which will always be the case, since you
	  // can't know what else to render until you render the parent component).
	  renderedElement.props && renderedElement.props._radiumDidResolveStyles) {
	    return renderedElement;
	  }
	
	  var newChildren = _resolveChildren({
	    children: renderedElement.props.children,
	    component: component,
	    config: config,
	    existingKeyMap: existingKeyMap
	  });
	
	  var newProps = _resolveProps({
	    component: component,
	    config: config,
	    existingKeyMap: existingKeyMap,
	    props: renderedElement.props
	  });
	
	  newProps = _runPlugins({
	    component: component,
	    config: config,
	    existingKeyMap: existingKeyMap,
	    props: newProps,
	    renderedElement: renderedElement
	  });
	
	  // If nothing changed, don't bother cloning the element. Might be a bit
	  // wasteful, as we add the sentinal to stop double-processing when we clone.
	  // Assume benign double-processing is better than unneeded cloning.
	  if (newChildren === renderedElement.props.children && newProps === renderedElement.props) {
	    return renderedElement;
	  }
	
	  return _cloneElement(renderedElement, newProps !== renderedElement.props ? newProps : {}, newChildren);
	};
	
	// Only for use by tests
	resolveStyles.__clearStateForTests = function () {
	  globalState = {};
	};
	
	module.exports = resolveStyles;
	// ReactComponent, flow+eslint complaining

/***/ }),
/* 945 */,
/* 946 */,
/* 947 */,
/* 948 */,
/* 949 */,
/* 950 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var objectAssign = __webpack_require__(1494)();
	
	// compare and isBuffer taken from https://github.com/feross/buffer/blob/680e9e5e488f22aac27599a57dc844a6315928dd/index.js
	// original notice:
	
	/*!
	 * The buffer module from node.js, for the browser.
	 *
	 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
	 * @license  MIT
	 */
	function compare(a, b) {
	  if (a === b) {
	    return 0;
	  }
	
	  var x = a.length;
	  var y = b.length;
	
	  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
	    if (a[i] !== b[i]) {
	      x = a[i];
	      y = b[i];
	      break;
	    }
	  }
	
	  if (x < y) {
	    return -1;
	  }
	  if (y < x) {
	    return 1;
	  }
	  return 0;
	}
	function isBuffer(b) {
	  if (global.Buffer && typeof global.Buffer.isBuffer === 'function') {
	    return global.Buffer.isBuffer(b);
	  }
	  return !!(b != null && b._isBuffer);
	}
	
	// based on node assert, original notice:
	// NB: The URL to the CommonJS spec is kept just for tradition.
	//     node-assert has evolved a lot since then, both in API and behavior.
	
	// http://wiki.commonjs.org/wiki/Unit_Testing/1.0
	//
	// THIS IS NOT TESTED NOR LIKELY TO WORK OUTSIDE V8!
	//
	// Originally from narwhal.js (http://narwhaljs.org)
	// Copyright (c) 2009 Thomas Robinson <280north.com>
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the 'Software'), to
	// deal in the Software without restriction, including without limitation the
	// rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
	// sell copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
	// ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
	// WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	var util = __webpack_require__(273);
	var hasOwn = Object.prototype.hasOwnProperty;
	var pSlice = Array.prototype.slice;
	var functionsHaveNames = (function () {
	  return function foo() {}.name === 'foo';
	}());
	function pToString (obj) {
	  return Object.prototype.toString.call(obj);
	}
	function isView(arrbuf) {
	  if (isBuffer(arrbuf)) {
	    return false;
	  }
	  if (typeof global.ArrayBuffer !== 'function') {
	    return false;
	  }
	  if (typeof ArrayBuffer.isView === 'function') {
	    return ArrayBuffer.isView(arrbuf);
	  }
	  if (!arrbuf) {
	    return false;
	  }
	  if (arrbuf instanceof DataView) {
	    return true;
	  }
	  if (arrbuf.buffer && arrbuf.buffer instanceof ArrayBuffer) {
	    return true;
	  }
	  return false;
	}
	// 1. The assert module provides functions that throw
	// AssertionError's when particular conditions are not met. The
	// assert module must conform to the following interface.
	
	var assert = module.exports = ok;
	
	// 2. The AssertionError is defined in assert.
	// new assert.AssertionError({ message: message,
	//                             actual: actual,
	//                             expected: expected })
	
	var regex = /\s*function\s+([^\(\s]*)\s*/;
	// based on https://github.com/ljharb/function.prototype.name/blob/adeeeec8bfcc6068b187d7d9fb3d5bb1d3a30899/implementation.js
	function getName(func) {
	  if (!util.isFunction(func)) {
	    return;
	  }
	  if (functionsHaveNames) {
	    return func.name;
	  }
	  var str = func.toString();
	  var match = str.match(regex);
	  return match && match[1];
	}
	assert.AssertionError = function AssertionError(options) {
	  this.name = 'AssertionError';
	  this.actual = options.actual;
	  this.expected = options.expected;
	  this.operator = options.operator;
	  if (options.message) {
	    this.message = options.message;
	    this.generatedMessage = false;
	  } else {
	    this.message = getMessage(this);
	    this.generatedMessage = true;
	  }
	  var stackStartFunction = options.stackStartFunction || fail;
	  if (Error.captureStackTrace) {
	    Error.captureStackTrace(this, stackStartFunction);
	  } else {
	    // non v8 browsers so we can have a stacktrace
	    var err = new Error();
	    if (err.stack) {
	      var out = err.stack;
	
	      // try to strip useless frames
	      var fn_name = getName(stackStartFunction);
	      var idx = out.indexOf('\n' + fn_name);
	      if (idx >= 0) {
	        // once we have located the function frame
	        // we need to strip out everything before it (and its line)
	        var next_line = out.indexOf('\n', idx + 1);
	        out = out.substring(next_line + 1);
	      }
	
	      this.stack = out;
	    }
	  }
	};
	
	// assert.AssertionError instanceof Error
	util.inherits(assert.AssertionError, Error);
	
	function truncate(s, n) {
	  if (typeof s === 'string') {
	    return s.length < n ? s : s.slice(0, n);
	  } else {
	    return s;
	  }
	}
	function inspect(something) {
	  if (functionsHaveNames || !util.isFunction(something)) {
	    return util.inspect(something);
	  }
	  var rawname = getName(something);
	  var name = rawname ? ': ' + rawname : '';
	  return '[Function' +  name + ']';
	}
	function getMessage(self) {
	  return truncate(inspect(self.actual), 128) + ' ' +
	         self.operator + ' ' +
	         truncate(inspect(self.expected), 128);
	}
	
	// At present only the three keys mentioned above are used and
	// understood by the spec. Implementations or sub modules can pass
	// other keys to the AssertionError's constructor - they will be
	// ignored.
	
	// 3. All of the following functions must throw an AssertionError
	// when a corresponding condition is not met, with a message that
	// may be undefined if not provided.  All assertion methods provide
	// both the actual and expected values to the assertion error for
	// display purposes.
	
	function fail(actual, expected, message, operator, stackStartFunction) {
	  throw new assert.AssertionError({
	    message: message,
	    actual: actual,
	    expected: expected,
	    operator: operator,
	    stackStartFunction: stackStartFunction
	  });
	}
	
	// EXTENSION! allows for well behaved errors defined elsewhere.
	assert.fail = fail;
	
	// 4. Pure assertion tests whether a value is truthy, as determined
	// by !!guard.
	// assert.ok(guard, message_opt);
	// This statement is equivalent to assert.equal(true, !!guard,
	// message_opt);. To test strictly for the value true, use
	// assert.strictEqual(true, guard, message_opt);.
	
	function ok(value, message) {
	  if (!value) fail(value, true, message, '==', assert.ok);
	}
	assert.ok = ok;
	
	// 5. The equality assertion tests shallow, coercive equality with
	// ==.
	// assert.equal(actual, expected, message_opt);
	
	assert.equal = function equal(actual, expected, message) {
	  if (actual != expected) fail(actual, expected, message, '==', assert.equal);
	};
	
	// 6. The non-equality assertion tests for whether two objects are not equal
	// with != assert.notEqual(actual, expected, message_opt);
	
	assert.notEqual = function notEqual(actual, expected, message) {
	  if (actual == expected) {
	    fail(actual, expected, message, '!=', assert.notEqual);
	  }
	};
	
	// 7. The equivalence assertion tests a deep equality relation.
	// assert.deepEqual(actual, expected, message_opt);
	
	assert.deepEqual = function deepEqual(actual, expected, message) {
	  if (!_deepEqual(actual, expected, false)) {
	    fail(actual, expected, message, 'deepEqual', assert.deepEqual);
	  }
	};
	
	assert.deepStrictEqual = function deepStrictEqual(actual, expected, message) {
	  if (!_deepEqual(actual, expected, true)) {
	    fail(actual, expected, message, 'deepStrictEqual', assert.deepStrictEqual);
	  }
	};
	
	function _deepEqual(actual, expected, strict, memos) {
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (actual === expected) {
	    return true;
	  } else if (isBuffer(actual) && isBuffer(expected)) {
	    return compare(actual, expected) === 0;
	
	  // 7.2. If the expected value is a Date object, the actual value is
	  // equivalent if it is also a Date object that refers to the same time.
	  } else if (util.isDate(actual) && util.isDate(expected)) {
	    return actual.getTime() === expected.getTime();
	
	  // 7.3 If the expected value is a RegExp object, the actual value is
	  // equivalent if it is also a RegExp object with the same source and
	  // properties (`global`, `multiline`, `lastIndex`, `ignoreCase`).
	  } else if (util.isRegExp(actual) && util.isRegExp(expected)) {
	    return actual.source === expected.source &&
	           actual.global === expected.global &&
	           actual.multiline === expected.multiline &&
	           actual.lastIndex === expected.lastIndex &&
	           actual.ignoreCase === expected.ignoreCase;
	
	  // 7.4. Other pairs that do not both pass typeof value == 'object',
	  // equivalence is determined by ==.
	  } else if ((actual === null || typeof actual !== 'object') &&
	             (expected === null || typeof expected !== 'object')) {
	    return strict ? actual === expected : actual == expected;
	
	  // If both values are instances of typed arrays, wrap their underlying
	  // ArrayBuffers in a Buffer each to increase performance
	  // This optimization requires the arrays to have the same type as checked by
	  // Object.prototype.toString (aka pToString). Never perform binary
	  // comparisons for Float*Arrays, though, since e.g. +0 === -0 but their
	  // bit patterns are not identical.
	  } else if (isView(actual) && isView(expected) &&
	             pToString(actual) === pToString(expected) &&
	             !(actual instanceof Float32Array ||
	               actual instanceof Float64Array)) {
	    return compare(new Uint8Array(actual.buffer),
	                   new Uint8Array(expected.buffer)) === 0;
	
	  // 7.5 For all other Object pairs, including Array objects, equivalence is
	  // determined by having the same number of owned properties (as verified
	  // with Object.prototype.hasOwnProperty.call), the same set of keys
	  // (although not necessarily the same order), equivalent values for every
	  // corresponding key, and an identical 'prototype' property. Note: this
	  // accounts for both named and indexed properties on Arrays.
	  } else if (isBuffer(actual) !== isBuffer(expected)) {
	    return false;
	  } else {
	    memos = memos || {actual: [], expected: []};
	
	    var actualIndex = memos.actual.indexOf(actual);
	    if (actualIndex !== -1) {
	      if (actualIndex === memos.expected.indexOf(expected)) {
	        return true;
	      }
	    }
	
	    memos.actual.push(actual);
	    memos.expected.push(expected);
	
	    return objEquiv(actual, expected, strict, memos);
	  }
	}
	
	function isArguments(object) {
	  return Object.prototype.toString.call(object) == '[object Arguments]';
	}
	
	function objEquiv(a, b, strict, actualVisitedObjects) {
	  if (a === null || a === undefined || b === null || b === undefined)
	    return false;
	  // if one is a primitive, the other must be same
	  if (util.isPrimitive(a) || util.isPrimitive(b))
	    return a === b;
	  if (strict && Object.getPrototypeOf(a) !== Object.getPrototypeOf(b))
	    return false;
	  var aIsArgs = isArguments(a);
	  var bIsArgs = isArguments(b);
	  if ((aIsArgs && !bIsArgs) || (!aIsArgs && bIsArgs))
	    return false;
	  if (aIsArgs) {
	    a = pSlice.call(a);
	    b = pSlice.call(b);
	    return _deepEqual(a, b, strict);
	  }
	  var ka = objectKeys(a);
	  var kb = objectKeys(b);
	  var key, i;
	  // having the same number of owned properties (keys incorporates
	  // hasOwnProperty)
	  if (ka.length !== kb.length)
	    return false;
	  //the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  //~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] !== kb[i])
	      return false;
	  }
	  //equivalent values for every corresponding key, and
	  //~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!_deepEqual(a[key], b[key], strict, actualVisitedObjects))
	      return false;
	  }
	  return true;
	}
	
	// 8. The non-equivalence assertion tests for any deep inequality.
	// assert.notDeepEqual(actual, expected, message_opt);
	
	assert.notDeepEqual = function notDeepEqual(actual, expected, message) {
	  if (_deepEqual(actual, expected, false)) {
	    fail(actual, expected, message, 'notDeepEqual', assert.notDeepEqual);
	  }
	};
	
	assert.notDeepStrictEqual = notDeepStrictEqual;
	function notDeepStrictEqual(actual, expected, message) {
	  if (_deepEqual(actual, expected, true)) {
	    fail(actual, expected, message, 'notDeepStrictEqual', notDeepStrictEqual);
	  }
	}
	
	
	// 9. The strict equality assertion tests strict equality, as determined by ===.
	// assert.strictEqual(actual, expected, message_opt);
	
	assert.strictEqual = function strictEqual(actual, expected, message) {
	  if (actual !== expected) {
	    fail(actual, expected, message, '===', assert.strictEqual);
	  }
	};
	
	// 10. The strict non-equality assertion tests for strict inequality, as
	// determined by !==.  assert.notStrictEqual(actual, expected, message_opt);
	
	assert.notStrictEqual = function notStrictEqual(actual, expected, message) {
	  if (actual === expected) {
	    fail(actual, expected, message, '!==', assert.notStrictEqual);
	  }
	};
	
	function expectedException(actual, expected) {
	  if (!actual || !expected) {
	    return false;
	  }
	
	  if (Object.prototype.toString.call(expected) == '[object RegExp]') {
	    return expected.test(actual);
	  }
	
	  try {
	    if (actual instanceof expected) {
	      return true;
	    }
	  } catch (e) {
	    // Ignore.  The instanceof check doesn't work for arrow functions.
	  }
	
	  if (Error.isPrototypeOf(expected)) {
	    return false;
	  }
	
	  return expected.call({}, actual) === true;
	}
	
	function _tryBlock(block) {
	  var error;
	  try {
	    block();
	  } catch (e) {
	    error = e;
	  }
	  return error;
	}
	
	function _throws(shouldThrow, block, expected, message) {
	  var actual;
	
	  if (typeof block !== 'function') {
	    throw new TypeError('"block" argument must be a function');
	  }
	
	  if (typeof expected === 'string') {
	    message = expected;
	    expected = null;
	  }
	
	  actual = _tryBlock(block);
	
	  message = (expected && expected.name ? ' (' + expected.name + ').' : '.') +
	            (message ? ' ' + message : '.');
	
	  if (shouldThrow && !actual) {
	    fail(actual, expected, 'Missing expected exception' + message);
	  }
	
	  var userProvidedMessage = typeof message === 'string';
	  var isUnwantedException = !shouldThrow && util.isError(actual);
	  var isUnexpectedException = !shouldThrow && actual && !expected;
	
	  if ((isUnwantedException &&
	      userProvidedMessage &&
	      expectedException(actual, expected)) ||
	      isUnexpectedException) {
	    fail(actual, expected, 'Got unwanted exception' + message);
	  }
	
	  if ((shouldThrow && actual && expected &&
	      !expectedException(actual, expected)) || (!shouldThrow && actual)) {
	    throw actual;
	  }
	}
	
	// 11. Expected to throw an error:
	// assert.throws(block, Error_opt, message_opt);
	
	assert.throws = function(block, /*optional*/error, /*optional*/message) {
	  _throws(true, block, error, message);
	};
	
	// EXTENSION! This is annoying to write outside this module.
	assert.doesNotThrow = function(block, /*optional*/error, /*optional*/message) {
	  _throws(false, block, error, message);
	};
	
	assert.ifError = function(err) { if (err) throw err; };
	
	// Expose a strict only variant of assert
	function strict(value, message) {
	  if (!value) fail(value, true, message, '==', strict);
	}
	assert.strict = objectAssign(strict, assert, {
	  equal: assert.strictEqual,
	  deepEqual: assert.deepStrictEqual,
	  notEqual: assert.notStrictEqual,
	  notDeepEqual: assert.notDeepStrictEqual
	});
	assert.strict.strict = assert.strict;
	
	var objectKeys = Object.keys || function (obj) {
	  var keys = [];
	  for (var key in obj) {
	    if (hasOwn.call(obj, key)) keys.push(key);
	  }
	  return keys;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 951 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author Titus Wormer
	 * @copyright 2015 Titus Wormer
	 * @license MIT
	 * @module attach-ware
	 * @fileoverview Middleware with configuration.
	 * @example
	 *   var ware = require('attach-ware')(require('ware'));
	 *
	 *   var middleware = ware()
	 *     .use(function (context, options) {
	 *         if (!options.condition) return;
	 *
	 *         return function (req, res, next) {
	 *           res.x = 'hello';
	 *           next();
	 *         };
	 *     }, {
	 *         'condition': true
	 *     })
	 *     .use(function (context, options) {
	 *         if (!options.condition) return;
	 *
	 *         return function (req, res, next) {
	 *           res.y = 'world';
	 *           next();
	 *         };
	 *     }, {
	 *         'condition': false
	 *     });
	 *
	 *   middleware.run({}, {}, function (err, req, res) {
	 *     res.x; // "hello"
	 *     res.y; // undefined
	 *   });
	 */
	
	'use strict';
	
	/* eslint-env commonjs */
	
	var slice = [].slice;
	var unherit = __webpack_require__(841);
	
	/**
	 * Clone `Ware` without affecting the super-class and
	 * turn it into configurable middleware.
	 *
	 * @param {Function} Ware - Ware-like constructor.
	 * @return {Function} AttachWare - Configurable middleware.
	 */
	function patch(Ware) {
	    /*
	     * Methods.
	     */
	
	    var useFn = Ware.prototype.use;
	
	    /**
	     * @constructor
	     * @class {AttachWare}
	     */
	    var AttachWare = unherit(Ware);
	
	    AttachWare.prototype.foo = true;
	
	    /**
	     * Attach configurable middleware.
	     *
	     * @memberof {AttachWare}
	     * @this {AttachWare}
	     * @param {Function} attach - Attacher.
	     * @return {AttachWare} - `this`.
	     */
	    function use(attach) {
	        var self = this;
	        var params = slice.call(arguments, 1);
	        var index;
	        var length;
	        var fn;
	
	        /*
	         * Accept other `AttachWare`.
	         */
	
	        if (attach instanceof AttachWare) {
	            if (attach.attachers) {
	                return self.use(attach.attachers);
	            }
	
	            return self;
	        }
	
	        /*
	         * Accept normal ware.
	         */
	
	        if (attach instanceof Ware) {
	            self.fns = self.fns.concat(attach.fns);
	            return self;
	        }
	
	        /*
	         * Multiple attachers.
	         */
	
	        if ('length' in attach && typeof attach !== 'function') {
	            index = -1;
	            length = attach.length;
	
	            while (++index < length) {
	                self.use.apply(self, [attach[index]].concat(params));
	            }
	
	            return self;
	        }
	
	        /*
	         * Single attacher.
	         */
	
	        fn = attach.apply(null, [self.context || self].concat(params));
	
	        /*
	         * Store the attacher to not break `new Ware(otherWare)`
	         * functionality.
	         */
	
	        if (!self.attachers) {
	            self.attachers = [];
	        }
	
	        self.attachers.push(attach);
	
	        /*
	         * Pass `fn` to the original `Ware#use()`.
	         */
	
	        if (fn) {
	            useFn.call(self, fn);
	        }
	
	        return self;
	    }
	
	    AttachWare.prototype.use = use;
	
	    return function (fn) {
	        return new AttachWare(fn);
	    };
	}
	
	module.exports = patch;


/***/ }),
/* 952 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016 Google Inc. All Rights Reserved.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	
	var assign = __webpack_require__(185);
	var provide = __webpack_require__(953);
	var usage = __webpack_require__(954);
	var createFieldsObj = __webpack_require__(279).createFieldsObj;
	var isObject = __webpack_require__(279).isObject;
	
	
	/**
	 * Adds handler for the history API methods
	 * @constructor
	 * @param {Object} tracker Passed internally by analytics.js
	 * @param {?Object} opts Passed by the require command.
	 */
	function UrlChangeTracker(tracker, opts) {
	
	  usage.track(tracker, usage.plugins.URL_CHANGE_TRACKER);
	
	  // Feature detects to prevent errors in unsupporting browsers.
	  if (!history.pushState || !window.addEventListener) return;
	
	  this.opts = assign({
	    shouldTrackUrlChange: this.shouldTrackUrlChange,
	    fieldsObj: {},
	    hitFilter: null
	  }, opts);
	
	  this.tracker = tracker;
	
	  // Sets the initial page field.
	  // Don't set this on the tracker yet so campaign data can be retreived
	  // from the location field.
	  this.path = getPath();
	
	  this.updateTrackerData = this.updateTrackerData.bind(this);
	
	  // Overrides history.pushState.
	  this.originalPushState = history.pushState;
	  history.pushState = function(state, title) {
	    // Sets the document title for reference later.
	    // TODO(philipwalton): consider using WeakMap for this to not conflict
	    // with any user-defined property also called "title".
	    if (isObject(state) && title) state.title = title;
	
	    this.originalPushState.apply(history, arguments);
	    this.updateTrackerData();
	  }.bind(this);
	
	  // Overrides history.repaceState.
	  this.originalReplaceState = history.replaceState;
	  history.replaceState = function(state, title) {
	    // Sets the document title for reference later.
	    // TODO(philipwalton): consider using WeakMap for this to not conflict
	    // with any user-defined property also called "title".
	    if (isObject(state) && title) state.title = title;
	
	    this.originalReplaceState.apply(history, arguments);
	    this.updateTrackerData(false);
	  }.bind(this);
	
	  // Handles URL changes via user interaction.
	  window.addEventListener('popstate', this.updateTrackerData);
	}
	
	
	/**
	 * Updates the page and title fields on the tracker if necessary and
	 * optionally sends a pageview.
	 * @param {boolean} shouldSendPageview Indicates whether the tracker should
	 *     send a pageview after updating the URL.
	 */
	UrlChangeTracker.prototype.updateTrackerData = function(shouldSendPageview) {
	
	  // Sets the default.
	  shouldSendPageview = shouldSendPageview === false ? false : true;
	
	  // Calls the update logic asychronously to help ensure user callbacks
	  // happen first.
	  setTimeout(function() {
	
	    var oldPath = this.path;
	    var newPath = getPath();
	
	    if (oldPath != newPath &&
	        this.opts.shouldTrackUrlChange.call(this, newPath, oldPath)) {
	
	      this.path = newPath;
	      this.tracker.set({
	        page: newPath,
	        title: isObject(history.state) && history.state.title || document.title
	      });
	
	      if (shouldSendPageview) {
	        var defaultFields = {transport: 'beacon'};
	        this.tracker.send('pageview', createFieldsObj(defaultFields,
	            this.opts.fieldsObj, this.tracker, this.opts.hitFilter));
	      }
	    }
	  }.bind(this), 0);
	};
	
	
	/**
	 * Determines whether or not the tracker should send a hit with the new page
	 * data. This default implementation can be overrided in the config options.
	 * @param {string} newPath The path prior to the URL change.
	 * @param {string} oldPath The path after the URL change.
	 * @return {boolean} Whether or not the URL change should be tracked.
	 */
	UrlChangeTracker.prototype.shouldTrackUrlChange = function(newPath, oldPath) {
	  return newPath && oldPath;
	};
	
	
	/**
	 * Removes all event listeners and instance properties.
	 */
	UrlChangeTracker.prototype.remove = function() {
	  window.removeEventListener('popstate', this.updateTrackerData);
	  history.replaceState = this.originalReplaceState;
	  history.pushState = this.originalPushState;
	
	  this.tracker = null;
	  this.opts = null;
	  this.path = null;
	
	  this.updateTrackerData = null;
	  this.originalReplaceState = null;
	  this.originalPushState = null;
	};
	
	
	/**
	 * @return {string} The path value of the current URL.
	 */
	function getPath() {
	  return location.pathname + location.search;
	}
	
	
	provide('urlChangeTracker', UrlChangeTracker);


/***/ }),
/* 953 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016 Google Inc. All Rights Reserved.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	
	var constants = __webpack_require__(463);
	var utilities = __webpack_require__(279);
	
	
	// Adds the dev ID to the list of dev IDs if any plugin is used.
	(window.gaDevIds = window.gaDevIds || []).push(constants.DEV_ID);
	
	
	/**
	 * Provides a plugin for use with analytics.js, accounting for the possibility
	 * that the global command queue has been renamed or not yet defined.
	 * @param {string} pluginName The plugin name identifier.
	 * @param {Function} pluginConstructor The plugin constructor function.
	 */
	module.exports = function providePlugin(pluginName, pluginConstructor) {
	  var gaAlias = window['GoogleAnalyticsObject'] || 'ga';
	  window[gaAlias] = window[gaAlias] || function() {
	    (window[gaAlias]['q'] = window[gaAlias]['q'] || []).push(arguments);
	  };
	
	  // Formally provides the plugin for use with analytics.js.
	  window[gaAlias]('provide', pluginName, pluginConstructor);
	
	  // Registers the plugin on the global gaplugins object.
	  window.gaplugins = window.gaplugins || {};
	  window.gaplugins[utilities.capitalize(pluginName)] = pluginConstructor;
	};


/***/ }),
/* 954 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016 Google Inc. All Rights Reserved.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	
	var constants = __webpack_require__(463);
	
	
	var plugins = {
	  CLEAN_URL_TRACKER: 1,
	  EVENT_TRACKER: 2,
	  IMPRESSION_TRACKER: 3,
	  MEDIA_QUERY_TRACKER: 4,
	  OUTBOUND_FORM_TRACKER: 5,
	  OUTBOUND_LINK_TRACKER: 6,
	  PAGE_VISIBILITY_TRACKER: 7,
	  SOCIAL_WIDGET_TRACKER: 8,
	  URL_CHANGE_TRACKER: 9
	};
	var PLUGIN_COUNT = 9;
	
	
	/**
	 * Converts a hexadecimal string to a binary string.
	 * @param {string} hex A hexadecimal numeric string.
	 * @return {string} a binary numeric string.
	 */
	function convertHexToBin(hex) {
	  return parseInt(hex || '0', 16).toString(2);
	}
	
	
	/**
	 * Converts a binary string to a hexadecimal string.
	 * @param {string} bin A binary numeric string.
	 * @return {string} a hexadecimal numeric string.
	 */
	function convertBinToHex(bin) {
	  return parseInt(bin || '0', 2).toString(16);
	}
	
	
	/**
	 * Adds leading zeros to a string if it's less than a minimum length.
	 * @param {string} str A string to pad.
	 * @param {number} len The minimum length of the string
	 * @return {string} The padded string.
	 */
	function padZeros(str, len) {
	  if (str.length < len) {
	    var toAdd = len - str.length;
	    while (toAdd) {
	      str = '0' + str;
	      toAdd--;
	    }
	  }
	  return str;
	}
	
	
	/**
	 * Accepts a binary numeric string and flips the digit from 0 to 1 at the
	 * specified index.
	 * @param {string} str The binary numeric string.
	 * @param {number} index The index to flip the bit.
	 * @return {string} The new binary string with the bit flipped on
	 */
	function flipBitOn(str, index) {
	  return str.substr(0, index) + 1 + str.substr(index + 1);
	}
	
	
	/**
	 * Accepts a tracker and a plugin index and flips the bit at the specified
	 * index on the tracker's usage parameter.
	 * @param {Object} tracker An analytics.js tracker.
	 * @param {number} pluginIndex The index of the plugin in the global list.
	 */
	function trackPlugin(tracker, pluginIndex) {
	  var usageHex = tracker.get(constants.USAGE_PARAM);
	  var usageBin = padZeros(convertHexToBin(usageHex), PLUGIN_COUNT);
	
	  // Flip the bit of the plugin being tracked.
	  usageBin = flipBitOn(usageBin, PLUGIN_COUNT - pluginIndex);
	
	  // Stores the modified usage string back on the tracker.
	  tracker.set(constants.USAGE_PARAM, convertBinToHex(usageBin));
	}
	
	
	/**
	 * Accepts a tracker and adds the current version to the version param.
	 * @param {Object} tracker An analytics.js tracker.
	 */
	function trackVersion(tracker) {
	  tracker.set(constants.VERSION_PARAM, constants.VERSION);
	}
	
	
	module.exports = {
	  track: function(tracker, plugin) {
	    trackVersion(tracker);
	    trackPlugin(tracker, plugin);
	  },
	  plugins: plugins
	};


/***/ }),
/* 955 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2)["default"];
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(20);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactTweenState = __webpack_require__(277);
	
	var _reactTweenState2 = _interopRequireDefault(_reactTweenState);
	
	var _lodash = __webpack_require__(454);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _objectAssign = __webpack_require__(204);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var Appear = _react2["default"].createClass({
	  displayName: "Appear",
	
	  mixins: [_reactTweenState2["default"].Mixin],
	  propTypes: {
	    children: _react2["default"].PropTypes.node,
	    style: _react2["default"].PropTypes.object
	  },
	  contextTypes: {
	    flux: _react2["default"].PropTypes.object,
	    "export": _react2["default"].PropTypes.bool,
	    overview: _react2["default"].PropTypes.bool,
	    slide: _react2["default"].PropTypes.number
	  },
	  getInitialState: function getInitialState() {
	    return {
	      active: false,
	      opacity: this.context["export"] || this.context.overview ? 1 : 0
	    };
	  },
	  componentDidMount: function componentDidMount() {
	    this.context.flux.stores.SlideStore.listen(this._storeChange);
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    this.context.flux.stores.SlideStore.unlisten(this._storeChange);
	  },
	  _storeChange: function _storeChange(state) {
	    var _this = this;
	
	    var slide = this.context.slide;
	    var fragment = _reactDom2["default"].findDOMNode(this.refs.fragment);
	    var key = _lodash2["default"].findKey(state.fragments[slide], {
	      "id": parseInt(fragment.dataset.fid)
	    });
	    if (slide in state.fragments && state.fragments[slide].hasOwnProperty(key)) {
	      this.setState({
	        active: state.fragments[slide][key].visible
	      }, function () {
	        var endVal = _this.state.active ? 1 : 0;
	        if (_this.context["export"] || _this.context.overview) {
	          endVal = 1;
	        }
	        _this.tweenState("opacity", {
	          easing: _reactTweenState2["default"].easingTypes.easeInOutQuad,
	          duration: 300,
	          endValue: endVal
	        });
	      });
	    }
	  },
	  render: function render() {
	    var styles = {
	      opacity: this.getTweeningValue("opacity")
	    };
	    return _react2["default"].createElement(
	      "div",
	      { style: (0, _objectAssign2["default"])({}, this.props.style, styles), className: "fragment", ref: "fragment" },
	      this.props.children
	    );
	  }
	});
	
	exports["default"] = Appear;
	module.exports = exports["default"];

/***/ }),
/* 956 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _get = __webpack_require__(8)["default"];
	
	var _inherits = __webpack_require__(5)["default"];
	
	var _createClass = __webpack_require__(6)["default"];
	
	var _classCallCheck = __webpack_require__(3)["default"];
	
	var _interopRequireDefault = __webpack_require__(2)["default"];
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _base = __webpack_require__(27);
	
	var _base2 = _interopRequireDefault(_base);
	
	var _radium = __webpack_require__(25);
	
	var _radium2 = _interopRequireDefault(_radium);
	
	var BlockQuote = (function (_Base) {
	  _inherits(BlockQuote, _Base);
	
	  function BlockQuote() {
	    _classCallCheck(this, _BlockQuote);
	
	    _get(Object.getPrototypeOf(_BlockQuote.prototype), "constructor", this).apply(this, arguments);
	  }
	
	  _createClass(BlockQuote, [{
	    key: "render",
	    value: function render() {
	      return _react2["default"].createElement(
	        "blockquote",
	        { style: [this.context.styles.components.blockquote, this.getStyles(), this.props.style] },
	        this.props.children
	      );
	    }
	  }]);
	
	  var _BlockQuote = BlockQuote;
	  BlockQuote = (0, _radium2["default"])(BlockQuote) || BlockQuote;
	  return BlockQuote;
	})(_base2["default"]);
	
	BlockQuote.propTypes = {
	  children: _react2["default"].PropTypes.node,
	  style: _react2["default"].PropTypes.object
	};
	
	BlockQuote.contextTypes = {
	  styles: _react2["default"].PropTypes.object
	};
	
	exports["default"] = BlockQuote;
	module.exports = exports["default"];

/***/ }),
/* 957 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _get = __webpack_require__(8)["default"];
	
	var _inherits = __webpack_require__(5)["default"];
	
	var _createClass = __webpack_require__(6)["default"];
	
	var _classCallCheck = __webpack_require__(3)["default"];
	
	var _interopRequireDefault = __webpack_require__(2)["default"];
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _base = __webpack_require__(27);
	
	var _base2 = _interopRequireDefault(_base);
	
	var _radium = __webpack_require__(25);
	
	var _radium2 = _interopRequireDefault(_radium);
	
	var Cite = (function (_Base) {
	  _inherits(Cite, _Base);
	
	  function Cite() {
	    _classCallCheck(this, _Cite);
	
	    _get(Object.getPrototypeOf(_Cite.prototype), "constructor", this).apply(this, arguments);
	  }
	
	  _createClass(Cite, [{
	    key: "render",
	    value: function render() {
	      return _react2["default"].createElement(
	        "cite",
	        { style: [this.context.styles.components.cite, this.getStyles()] },
	        "- ",
	        this.props.children
	      );
	    }
	  }]);
	
	  var _Cite = Cite;
	  Cite = (0, _radium2["default"])(Cite) || Cite;
	  return Cite;
	})(_base2["default"]);
	
	Cite.propTypes = {
	  children: _react2["default"].PropTypes.node
	};
	
	Cite.contextTypes = {
	  styles: _react2["default"].PropTypes.object
	};
	
	exports["default"] = Cite;
	module.exports = exports["default"];

/***/ }),
/* 958 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _get = __webpack_require__(8)["default"];
	
	var _inherits = __webpack_require__(5)["default"];
	
	var _createClass = __webpack_require__(6)["default"];
	
	var _classCallCheck = __webpack_require__(3)["default"];
	
	var _interopRequireDefault = __webpack_require__(2)["default"];
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _base = __webpack_require__(27);
	
	var _base2 = _interopRequireDefault(_base);
	
	var _radium = __webpack_require__(25);
	
	var _radium2 = _interopRequireDefault(_radium);
	
	var Code = (function (_Base) {
	  _inherits(Code, _Base);
	
	  function Code() {
	    _classCallCheck(this, _Code);
	
	    _get(Object.getPrototypeOf(_Code.prototype), "constructor", this).apply(this, arguments);
	  }
	
	  _createClass(Code, [{
	    key: "render",
	    value: function render() {
	      return _react2["default"].createElement(
	        "code",
	        { style: [this.context.styles.components.code, this.getStyles(), this.props.style] },
	        this.props.children
	      );
	    }
	  }]);
	
	  var _Code = Code;
	  Code = (0, _radium2["default"])(Code) || Code;
	  return Code;
	})(_base2["default"]);
	
	Code.propTypes = {
	  children: _react2["default"].PropTypes.node,
	  style: _react2["default"].PropTypes.object
	};
	
	Code.contextTypes = {
	  styles: _react2["default"].PropTypes.object
	};
	
	exports["default"] = Code;
	module.exports = exports["default"];

/***/ }),
/* 959 */
/***/ (function(module, exports, __webpack_require__) {

	/*eslint new-cap:0, max-statements:0*/
	/*global window document localStorage*/
	
	"use strict";
	
	var _get = __webpack_require__(8)["default"];
	
	var _inherits = __webpack_require__(5)["default"];
	
	var _createClass = __webpack_require__(6)["default"];
	
	var _classCallCheck = __webpack_require__(3)["default"];
	
	var _extends = __webpack_require__(7)["default"];
	
	var _interopRequireDefault = __webpack_require__(2)["default"];
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactAddonsTransitionGroup = __webpack_require__(350);
	
	var _reactAddonsTransitionGroup2 = _interopRequireDefault(_reactAddonsTransitionGroup);
	
	var _objectAssign = __webpack_require__(204);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _radium = __webpack_require__(25);
	
	var _radium2 = _interopRequireDefault(_radium);
	
	var _lodash = __webpack_require__(454);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _presenter = __webpack_require__(973);
	
	var _presenter2 = _interopRequireDefault(_presenter);
	
	var _export = __webpack_require__(960);
	
	var _export2 = _interopRequireDefault(_export);
	
	var _overview = __webpack_require__(972);
	
	var _overview2 = _interopRequireDefault(_overview);
	
	var _progress = __webpack_require__(974);
	
	var _progress2 = _interopRequireDefault(_progress);
	
	var Style = _radium2["default"].Style;
	
	var TransitionGroup = (0, _radium2["default"])(_reactAddonsTransitionGroup2["default"]);
	
	var Deck = (function (_React$Component) {
	  _inherits(Deck, _React$Component);
	
	  function Deck(props) {
	    _classCallCheck(this, _Deck);
	
	    _get(Object.getPrototypeOf(_Deck.prototype), "constructor", this).call(this, props);
	    this._handleKeyPress = this._handleKeyPress.bind(this);
	    this._handleClick = this._handleClick.bind(this);
	    this._goToSlide = this._goToSlide.bind(this);
	    this.state = {
	      lastSlide: null
	    };
	  }
	
	  _createClass(Deck, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var slide = this._getSlideIndex();
	      this.setState({
	        lastSlide: slide
	      });
	      localStorage.setItem("spectacle-slide", JSON.stringify({ slide: this.context.slide, forward: false, time: Date.now() }));
	      this._attachEvents();
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this._detachEvents();
	    }
	  }, {
	    key: "_attachEvents",
	    value: function _attachEvents() {
	      window.addEventListener("storage", this._goToSlide);
	      window.addEventListener("keydown", this._handleKeyPress);
	    }
	  }, {
	    key: "_detachEvents",
	    value: function _detachEvents() {
	      window.removeEventListener("storage", this._goToSlide);
	      window.removeEventListener("keydown", this._handleKeyPress);
	    }
	  }, {
	    key: "_handleKeyPress",
	    value: function _handleKeyPress(e) {
	      var event = window.event ? window.event : e;
	      // left, page down
	      if (event.keyCode === 37 || event.keyCode === 33) {
	        this._prevSlide();
	      }
	      // right, page up
	      if (event.keyCode === 39 || event.keyCode === 34) {
	        this._nextSlide();
	      }
	      if (event.keyCode === 79 && !event.ctrlKey && !event.metaKey) {
	        // o
	        this._toggleOverviewMode();
	      }
	      if (event.keyCode === 80 && !event.ctrlKey && !event.metaKey) {
	        // o
	        this._togglePresenterMode();
	      }
	    }
	  }, {
	    key: "_toggleOverviewMode",
	    value: function _toggleOverviewMode() {
	      var suffix = this.context.overview ? "" : "?overview";
	      this.context.history.replaceState(null, "/" + this.context.slide + suffix);
	    }
	  }, {
	    key: "_togglePresenterMode",
	    value: function _togglePresenterMode() {
	      var suffix = this.context.presenter ? "" : "?presenter";
	      this.context.history.replaceState(null, "/" + this.context.slide + suffix);
	    }
	  }, {
	    key: "_getSuffix",
	    value: function _getSuffix() {
	      if (this.context.presenter) {
	        return "?presenter";
	      } else if (this.context.overview) {
	        return "?overview";
	      } else {
	        return "";
	      }
	    }
	  }, {
	    key: "_goToSlide",
	    value: function _goToSlide(e) {
	      if (e.key === "spectacle-slide") {
	        var data = JSON.parse(e.newValue);
	        var slide = this._getSlideIndex();
	        this.setState({
	          lastSlide: slide || 0
	        });
	        if (this._checkFragments(this.context.slide, data.forward)) {
	          this.context.history.replaceState(null, "/" + data.slide + this._getSuffix());
	        }
	      }
	    }
	  }, {
	    key: "_prevSlide",
	    value: function _prevSlide() {
	      var slide = this._getSlideIndex();
	      this.setState({
	        lastSlide: slide
	      });
	      if (this._checkFragments(this.context.slide, false) || this.context.overview) {
	        if (slide > 0) {
	          this.context.history.replaceState(null, "/" + this._getHash(slide - 1) + this._getSuffix());
	          localStorage.setItem("spectacle-slide", JSON.stringify({ slide: this._getHash(slide - 1), forward: false, time: Date.now() }));
	        }
	      } else if (slide > 0) {
	        localStorage.setItem("spectacle-slide", JSON.stringify({ slide: this._getHash(slide), forward: false, time: Date.now() }));
	      }
	    }
	  }, {
	    key: "_nextSlide",
	    value: function _nextSlide() {
	      var slide = this._getSlideIndex();
	      this.setState({
	        lastSlide: slide
	      });
	      if (this._checkFragments(this.context.slide, true) || this.context.overview) {
	        if (slide < this.props.children.length - 1) {
	          this.context.history.replaceState(null, "/" + this._getHash(slide + 1) + this._getSuffix());
	          localStorage.setItem("spectacle-slide", JSON.stringify({ slide: this._getHash(slide + 1), forward: true, time: Date.now() }));
	        }
	      } else if (slide < this.props.children.length - 1) {
	        localStorage.setItem("spectacle-slide", JSON.stringify({ slide: this._getHash(slide), forward: true, time: Date.now() }));
	      }
	    }
	  }, {
	    key: "_getHash",
	    value: function _getHash(slide) {
	      var hash = slide;
	      if ("id" in this.props.children[slide].props) {
	        hash = this.props.children[slide].props.id;
	      }
	      return hash;
	    }
	  }, {
	    key: "_checkFragments",
	    value: function _checkFragments(slide, forward) {
	      var store = this.context.flux.stores.SlideStore;
	      var fragments = store.getState().fragments;
	      // Not proud of this at all. 0.14 Parent based contexts will fix this.
	      if (this.context.presenter) {
	        var main = document.querySelector(".spectacle-presenter-main");
	        if (main) {
	          var frags = main.querySelectorAll(".fragment");
	          if (!frags.length) {
	            return true;
	          }
	        } else {
	          return true;
	        }
	      }
	      if (slide in fragments) {
	        var count = _lodash2["default"].size(fragments[slide]);
	        var visible = _lodash2["default"].filter(fragments[slide], function (s) {
	          return s.visible === true;
	        });
	        var hidden = _lodash2["default"].filter(fragments[slide], function (s) {
	          return s.visible !== true;
	        });
	        if (forward === true && visible.length !== count) {
	          this.context.flux.actions.SlideActions.updateFragment({
	            fragment: hidden[0],
	            visible: true
	          });
	          return false;
	        }
	        if (forward === false && hidden.length !== count) {
	          this.context.flux.actions.SlideActions.updateFragment({
	            fragment: visible[_lodash2["default"].size(visible) - 1],
	            visible: false
	          });
	          return false;
	        }
	        return true;
	      } else {
	        return true;
	      }
	    }
	  }, {
	    key: "_getTouchEvents",
	    value: function _getTouchEvents() {
	      var self = this;
	
	      return {
	        onTouchStart: function onTouchStart(e) {
	          self.touchObject = {
	            startX: e.touches[0].pageX,
	            startY: e.touches[0].pageY
	          };
	        },
	        onTouchMove: function onTouchMove(e) {
	          var direction = self._swipeDirection({
	            x1: self.touchObject.startX,
	            x2: e.touches[0].pageX,
	            y1: self.touchObject.startY,
	            y2: e.touches[0].pageY
	          });
	
	          self.touchObject = {
	            startX: self.touchObject.startX,
	            startY: self.touchObject.startY,
	            endX: e.clientX,
	            endY: e.clientY,
	            length: Math.round(Math.sqrt(Math.pow(e.touches[0].pageX - self.touchObject.startX, 2))),
	            direction: direction
	          };
	
	          if (direction !== 0) {
	            e.preventDefault();
	          }
	        },
	        onTouchEnd: function onTouchEnd(e) {
	          self._handleSwipe(e);
	        },
	        onTouchCancel: function onTouchCancel(e) {
	          self._handleSwipe(e);
	        }
	      };
	    }
	  }, {
	    key: "_handleClick",
	    value: function _handleClick(e) {
	      if (this.clickSafe === true) {
	        e.preventDefault();
	        e.stopPropagation();
	        e.nativeEvent.stopPropagation();
	      }
	    }
	  }, {
	    key: "_handleSwipe",
	    value: function _handleSwipe() {
	      if (typeof this.touchObject.length !== "undefined" && this.touchObject.length > 44) {
	        this.clickSafe = true;
	      } else {
	        this.clickSafe = false;
	      }
	
	      if (Math.abs(this.touchObject.length) > 20) {
	        if (this.touchObject.direction === 1) {
	          this._nextSlide();
	        } else if (this.touchObject.direction === -1) {
	          this._prevSlide();
	        }
	      }
	
	      this.touchObject = {};
	    }
	  }, {
	    key: "_swipeDirection",
	    value: function _swipeDirection(touch) {
	      var xDist = touch.x1 - touch.x2;
	      var yDist = touch.y1 - touch.y2;
	      var r = Math.atan2(yDist, xDist);
	      var swipeAngle = Math.round(r * 180 / Math.PI);
	
	      if (swipeAngle < 0) {
	        swipeAngle = 360 - Math.abs(swipeAngle);
	      }
	      if (swipeAngle <= 45 && swipeAngle >= 0) {
	        return 1;
	      }
	      if (swipeAngle <= 360 && swipeAngle >= 315) {
	        return 1;
	      }
	      if (swipeAngle >= 135 && swipeAngle <= 225) {
	        return -1;
	      }
	
	      return 0;
	    }
	  }, {
	    key: "_getSlideIndex",
	    value: function _getSlideIndex() {
	      var _this = this;
	
	      var index = 0;
	      if (!parseInt(this.context.slide)) {
	        this.props.children.forEach(function (slide, i) {
	          if (slide.props.id === _this.context.slide) {
	            index = i;
	          }
	        });
	      } else {
	        index = parseInt(this.context.slide);
	      }
	      return index;
	    }
	  }, {
	    key: "_renderSlide",
	    value: function _renderSlide() {
	      var slide = this._getSlideIndex();
	      var child = this.props.children[slide];
	      return _react2["default"].cloneElement(child, {
	        key: slide,
	        hash: this.context.slide,
	        currentSlide: this.context.slide,
	        slideIndex: slide,
	        lastSlide: this.state.lastSlide,
	        transition: child.props.transition.length ? child.props.transition : this.props.transition,
	        transitionDuration: child.props.transition.transitionDuration ? child.props.transitionDuration : this.props.transitionDuration
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var globals = this.context["export"] ? {
	        body: (0, _objectAssign2["default"])(this.context.styles.global.body, {
	          minWidth: 1100,
	          minHeight: 850,
	          overflow: "auto"
	        })
	      } : {};
	
	      var styles = {
	        deck: {
	          backgroundColor: this.context.presenter || this.context.overview ? "black" : "",
	          position: "absolute",
	          top: 0,
	          left: 0,
	          width: "100%",
	          height: "100%"
	        },
	        transition: {
	          height: "100%",
	          width: "100%",
	          perspective: 1000,
	          transformStyle: "flat"
	        }
	      };
	
	      var componentToRender = undefined;
	      if (this.context.presenter) {
	        componentToRender = _react2["default"].createElement(_presenter2["default"], { slides: this.props.children,
	          slide: this._getSlideIndex(), hash: this.context.slide, lastSlide: this.state.lastSlide });
	      } else if (this.context["export"]) {
	        componentToRender = _react2["default"].createElement(_export2["default"], { slides: this.props.children });
	      } else if (this.context.overview) {
	        componentToRender = _react2["default"].createElement(_overview2["default"], { slides: this.props.children, slide: this._getSlideIndex() });
	      } else {
	        componentToRender = _react2["default"].createElement(
	          TransitionGroup,
	          { component: "div", style: [styles.transition] },
	          this._renderSlide()
	        );
	      }
	
	      return _react2["default"].createElement(
	        "div",
	        _extends({
	          className: "spectacle-deck",
	          style: [styles.deck],
	          onClick: this._handleClick
	        }, this._getTouchEvents()),
	        componentToRender,
	        !this.context["export"] ? _react2["default"].createElement(_progress2["default"], {
	          items: this.props.children,
	          currentSlide: this._getSlideIndex(),
	          type: this.props.progress }) : "",
	        _react2["default"].createElement(Style, { rules: (0, _objectAssign2["default"])(this.context.styles.global, globals) })
	      );
	    }
	  }]);
	
	  var _Deck = Deck;
	  Deck = (0, _radium2["default"])(Deck) || Deck;
	  return Deck;
	})(_react2["default"].Component);
	
	Deck.displayName = "Deck";
	
	Deck.defaultProps = {
	  transitionDuration: 500,
	  progress: "pacman"
	};
	
	Deck.propTypes = {
	  children: _react2["default"].PropTypes.node,
	  transition: _react2["default"].PropTypes.array,
	  transitionDuration: _react2["default"].PropTypes.number,
	  progress: _react2["default"].PropTypes.oneOf(["pacman", "bar", "number", "none"])
	};
	
	Deck.contextTypes = {
	  styles: _react2["default"].PropTypes.object,
	  flux: _react2["default"].PropTypes.object,
	  history: _react2["default"].PropTypes.object,
	  presenter: _react2["default"].PropTypes.bool,
	  "export": _react2["default"].PropTypes.bool,
	  overview: _react2["default"].PropTypes.bool,
	  slide: _react2["default"].PropTypes.number
	};
	
	exports["default"] = Deck;
	module.exports = exports["default"];

/***/ }),
/* 960 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _get = __webpack_require__(8)["default"];
	
	var _inherits = __webpack_require__(5)["default"];
	
	var _createClass = __webpack_require__(6)["default"];
	
	var _classCallCheck = __webpack_require__(3)["default"];
	
	var _interopRequireDefault = __webpack_require__(2)["default"];
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _radium = __webpack_require__(25);
	
	var _radium2 = _interopRequireDefault(_radium);
	
	var Export = (function (_React$Component) {
	  _inherits(Export, _React$Component);
	
	  function Export(props) {
	    _classCallCheck(this, _Export);
	
	    _get(Object.getPrototypeOf(_Export.prototype), "constructor", this).call(this, props);
	  }
	
	  _createClass(Export, [{
	    key: "_renderSlides",
	    value: function _renderSlides() {
	      return this.props.slides.map(function (child, index) {
	        return _react2["default"].cloneElement(child, {
	          key: index,
	          slideIndex: index,
	          transition: [],
	          transitionDuration: 0
	        });
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var styles = {
	        "export": {
	          height: "100%",
	          width: "100%"
	        }
	      };
	      return _react2["default"].createElement(
	        "div",
	        { className: "spectacle-export", style: [styles["export"]] },
	        this._renderSlides()
	      );
	    }
	  }]);
	
	  var _Export = Export;
	  Export = (0, _radium2["default"])(Export) || Export;
	  return Export;
	})(_react2["default"].Component);
	
	Export.propTypes = {
	  slides: _react2["default"].PropTypes.array
	};
	
	Export.contextTypes = {
	  styles: _react2["default"].PropTypes.object
	};
	
	exports["default"] = Export;
	module.exports = exports["default"];

/***/ }),
/* 961 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _get = __webpack_require__(8)["default"];
	
	var _inherits = __webpack_require__(5)["default"];
	
	var _createClass = __webpack_require__(6)["default"];
	
	var _classCallCheck = __webpack_require__(3)["default"];
	
	var _interopRequireDefault = __webpack_require__(2)["default"];
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _radium = __webpack_require__(25);
	
	var _radium2 = _interopRequireDefault(_radium);
	
	var Fill = (function (_React$Component) {
	  _inherits(Fill, _React$Component);
	
	  function Fill() {
	    _classCallCheck(this, _Fill);
	
	    _get(Object.getPrototypeOf(_Fill.prototype), "constructor", this).apply(this, arguments);
	  }
	
	  _createClass(Fill, [{
	    key: "render",
	    value: function render() {
	      var styles = {
	        flex: 1
	      };
	      return _react2["default"].createElement(
	        "div",
	        { style: [styles, this.props.style] },
	        this.props.children
	      );
	    }
	  }]);
	
	  var _Fill = Fill;
	  Fill = (0, _radium2["default"])(Fill) || Fill;
	  return Fill;
	})(_react2["default"].Component);
	
	Fill.propTypes = {
	  children: _react2["default"].PropTypes.node,
	  style: _react2["default"].PropTypes.object
	};
	
	exports["default"] = Fill;
	module.exports = exports["default"];

/***/ }),
/* 962 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _get = __webpack_require__(8)["default"];
	
	var _inherits = __webpack_require__(5)["default"];
	
	var _createClass = __webpack_require__(6)["default"];
	
	var _classCallCheck = __webpack_require__(3)["default"];
	
	var _interopRequireDefault = __webpack_require__(2)["default"];
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _radium = __webpack_require__(25);
	
	var _radium2 = _interopRequireDefault(_radium);
	
	var Fit = (function (_React$Component) {
	  _inherits(Fit, _React$Component);
	
	  function Fit() {
	    _classCallCheck(this, _Fit);
	
	    _get(Object.getPrototypeOf(_Fit.prototype), "constructor", this).apply(this, arguments);
	  }
	
	  _createClass(Fit, [{
	    key: "render",
	    value: function render() {
	      var styles = {
	        flex: 0
	      };
	      return _react2["default"].createElement(
	        "div",
	        { style: [styles, this.props.style] },
	        this.props.children
	      );
	    }
	  }]);
	
	  var _Fit = Fit;
	  Fit = (0, _radium2["default"])(Fit) || Fit;
	  return Fit;
	})(_react2["default"].Component);
	
	Fit.propTypes = {
	  children: _react2["default"].PropTypes.node,
	  style: _react2["default"].PropTypes.object
	};
	
	exports["default"] = Fit;
	module.exports = exports["default"];

/***/ }),
/* 963 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Alt instance.
	 */
	"use strict";
	
	var _get = __webpack_require__(8)["default"];
	
	var _inherits = __webpack_require__(5)["default"];
	
	var _classCallCheck = __webpack_require__(3)["default"];
	
	var _interopRequireDefault = __webpack_require__(2)["default"];
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _alt = __webpack_require__(929);
	
	var _alt2 = _interopRequireDefault(_alt);
	
	var _slideActions = __webpack_require__(964);
	
	var _slideActions2 = _interopRequireDefault(_slideActions);
	
	var _slideStore = __webpack_require__(965);
	
	var _slideStore2 = _interopRequireDefault(_slideStore);
	
	var Flux = (function (_Alt) {
	  _inherits(Flux, _Alt);
	
	  function Flux() {
	    var config = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	    _classCallCheck(this, Flux);
	
	    _get(Object.getPrototypeOf(Flux.prototype), "constructor", this).call(this, config);
	
	    this.addActions("SlideActions", _slideActions2["default"]);
	    this.addStore("SlideStore", _slideStore2["default"]);
	  }
	
	  return Flux;
	})(_alt2["default"]);
	
	exports["default"] = Flux;
	module.exports = exports["default"];

/***/ }),
/* 964 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _classCallCheck = __webpack_require__(3)["default"];
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var SlideActions = function SlideActions() {
	  _classCallCheck(this, SlideActions);
	
	  this.generateActions("addFragment", "updateFragment");
	};
	
	exports["default"] = SlideActions;
	module.exports = exports["default"];

/***/ }),
/* 965 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = __webpack_require__(6)["default"];
	
	var _classCallCheck = __webpack_require__(3)["default"];
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var SlideStore = (function () {
	  function SlideStore() {
	    _classCallCheck(this, SlideStore);
	
	    this.bindActions(this.alt.getActions("SlideActions"));
	    this.fragments = {};
	  }
	
	  _createClass(SlideStore, [{
	    key: "onAddFragment",
	    value: function onAddFragment(payload) {
	      var fragments = this.fragments;
	      var fid = "f" + payload.id;
	      if (!fragments.hasOwnProperty(payload.slide)) {
	        fragments[payload.slide] = {};
	        fragments[payload.slide][fid] = payload;
	      } else {
	        var slide = fragments[payload.slide];
	        if (!slide.hasOwnProperty(fid)) {
	          slide[fid] = payload;
	        }
	      }
	      this.setState({
	        fragments: fragments
	      });
	    }
	  }, {
	    key: "onUpdateFragment",
	    value: function onUpdateFragment(payload) {
	      var fragments = this.fragments;
	      fragments[payload.fragment.slide]["f" + payload.fragment.id].visible = payload.visible;
	      this.setState({
	        fragments: fragments
	      });
	    }
	  }]);
	
	  return SlideStore;
	})();
	
	exports["default"] = SlideStore;
	module.exports = exports["default"];

/***/ }),
/* 966 */
/***/ (function(module, exports, __webpack_require__) {

	/*global window*/
	
	"use strict";
	
	var _get = __webpack_require__(8)["default"];
	
	var _inherits = __webpack_require__(5)["default"];
	
	var _createClass = __webpack_require__(6)["default"];
	
	var _classCallCheck = __webpack_require__(3)["default"];
	
	var _interopRequireDefault = __webpack_require__(2)["default"];
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(20);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _base = __webpack_require__(27);
	
	var _base2 = _interopRequireDefault(_base);
	
	var _radium = __webpack_require__(25);
	
	var _radium2 = _interopRequireDefault(_radium);
	
	var Heading = (function (_Base) {
	  _inherits(Heading, _Base);
	
	  function Heading(props) {
	    _classCallCheck(this, _Heading);
	
	    _get(Object.getPrototypeOf(_Heading.prototype), "constructor", this).call(this, props);
	    this.resize = this.resize.bind(this);
	    this.state = {
	      scale: 1,
	      height: 16
	    };
	  }
	
	  _createClass(Heading, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.resize();
	      window.addEventListener("load", this.resize);
	      window.addEventListener("resize", this.resize);
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      window.removeEventListener("load", this.resize);
	      window.removeEventListener("resize", this.resize);
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps() {
	      this.resize();
	    }
	  }, {
	    key: "resize",
	    value: function resize() {
	      if (this.props.fit) {
	        var text = _reactDom2["default"].findDOMNode(this.refs.text);
	        var container = _reactDom2["default"].findDOMNode(this.refs.container);
	        text.style.display = "inline-block";
	        var scale = container.offsetWidth / text.offsetWidth;
	        var height = text.offsetHeight * scale;
	        text.style.display = "block";
	        this.setState({
	          scale: scale,
	          height: height
	        });
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var Tag = "H" + this.props.size;
	      var styles = {
	        container: {
	          display: "block",
	          width: "100%",
	          height: this.state.height
	        },
	        text: {
	          fontSize: 16,
	          display: "block",
	          margin: "0",
	          padding: "0",
	          lineHeight: this.props.lineHeight,
	          transform: "scale(" + this.state.scale + ")",
	          transformOrigin: "center top"
	        }
	      };
	      return this.props.fit ? _react2["default"].createElement(
	        "div",
	        {
	          ref: "container",
	          style: [this.context.styles.components.heading["h" + this.props.size], this.getStyles(), styles.container] },
	        _react2["default"].createElement(
	          "span",
	          {
	            ref: "text",
	            style: [styles.text, this.props.style] },
	          this.props.children
	        )
	      ) : _react2["default"].createElement(Tag, {
	        style: [this.context.styles.components.heading["h" + this.props.size], this.getStyles(), this.props.style]
	      }, this.props.children);
	    }
	  }]);
	
	  var _Heading = Heading;
	  Heading = (0, _radium2["default"])(Heading) || Heading;
	  return Heading;
	})(_base2["default"]);
	
	Heading.defaultProps = {
	  size: 1,
	  lineHeight: 1
	};
	
	Heading.propTypes = {
	  children: _react2["default"].PropTypes.node,
	  size: _react2["default"].PropTypes.number,
	  lineHeight: _react2["default"].PropTypes.number
	};
	
	Heading.contextTypes = {
	  styles: _react2["default"].PropTypes.object
	};
	
	exports["default"] = Heading;
	module.exports = exports["default"];

/***/ }),
/* 967 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _get = __webpack_require__(8)["default"];
	
	var _inherits = __webpack_require__(5)["default"];
	
	var _createClass = __webpack_require__(6)["default"];
	
	var _classCallCheck = __webpack_require__(3)["default"];
	
	var _interopRequireDefault = __webpack_require__(2)["default"];
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _base = __webpack_require__(27);
	
	var _base2 = _interopRequireDefault(_base);
	
	var _radium = __webpack_require__(25);
	
	var _radium2 = _interopRequireDefault(_radium);
	
	var Image = (function (_Base) {
	  _inherits(Image, _Base);
	
	  function Image() {
	    _classCallCheck(this, _Image);
	
	    _get(Object.getPrototypeOf(_Image.prototype), "constructor", this).apply(this, arguments);
	  }
	
	  _createClass(Image, [{
	    key: "render",
	    value: function render() {
	      var styles = {
	        width: this.props.width || "",
	        height: this.props.height || "",
	        display: this.props.display || ""
	      };
	      return _react2["default"].createElement("img", {
	        src: this.props.src,
	        style: [this.context.styles.components.image, this.getStyles(), styles, this.props.style] });
	    }
	  }]);
	
	  var _Image = Image;
	  Image = (0, _radium2["default"])(Image) || Image;
	  return Image;
	})(_base2["default"]);
	
	Image.propTypes = {
	  width: _react2["default"].PropTypes.oneOfType([_react2["default"].PropTypes.string, _react2["default"].PropTypes.number]),
	  height: _react2["default"].PropTypes.oneOfType([_react2["default"].PropTypes.string, _react2["default"].PropTypes.number]),
	  display: _react2["default"].PropTypes.string,
	  src: _react2["default"].PropTypes.string,
	  style: _react2["default"].PropTypes.object
	};
	
	Image.contextTypes = {
	  styles: _react2["default"].PropTypes.object
	};
	
	exports["default"] = Image;
	module.exports = exports["default"];

/***/ }),
/* 968 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _get = __webpack_require__(8)["default"];
	
	var _inherits = __webpack_require__(5)["default"];
	
	var _createClass = __webpack_require__(6)["default"];
	
	var _classCallCheck = __webpack_require__(3)["default"];
	
	var _interopRequireDefault = __webpack_require__(2)["default"];
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _radium = __webpack_require__(25);
	
	var _radium2 = _interopRequireDefault(_radium);
	
	var Layout = (function (_React$Component) {
	  _inherits(Layout, _React$Component);
	
	  function Layout() {
	    _classCallCheck(this, _Layout);
	
	    _get(Object.getPrototypeOf(_Layout.prototype), "constructor", this).apply(this, arguments);
	  }
	
	  _createClass(Layout, [{
	    key: "render",
	    value: function render() {
	      var styles = {
	        display: "flex"
	      };
	      return _react2["default"].createElement(
	        "div",
	        { style: [styles, this.props.style] },
	        this.props.children
	      );
	    }
	  }]);
	
	  var _Layout = Layout;
	  Layout = (0, _radium2["default"])(Layout) || Layout;
	  return Layout;
	})(_react2["default"].Component);
	
	Layout.propTypes = {
	  children: _react2["default"].PropTypes.node,
	  style: _react2["default"].PropTypes.object
	};
	
	exports["default"] = Layout;
	module.exports = exports["default"];

/***/ }),
/* 969 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _get = __webpack_require__(8)["default"];
	
	var _inherits = __webpack_require__(5)["default"];
	
	var _createClass = __webpack_require__(6)["default"];
	
	var _classCallCheck = __webpack_require__(3)["default"];
	
	var _interopRequireDefault = __webpack_require__(2)["default"];
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _base = __webpack_require__(27);
	
	var _base2 = _interopRequireDefault(_base);
	
	var _radium = __webpack_require__(25);
	
	var _radium2 = _interopRequireDefault(_radium);
	
	var Link = (function (_Base) {
	  _inherits(Link, _Base);
	
	  function Link() {
	    _classCallCheck(this, _Link);
	
	    _get(Object.getPrototypeOf(_Link.prototype), "constructor", this).apply(this, arguments);
	  }
	
	  _createClass(Link, [{
	    key: "render",
	    value: function render() {
	      return _react2["default"].createElement(
	        "a",
	        { href: this.props.href, style: [this.context.styles.components.link, this.getStyles(), this.props.style] },
	        this.props.children
	      );
	    }
	  }]);
	
	  var _Link = Link;
	  Link = (0, _radium2["default"])(Link) || Link;
	  return Link;
	})(_base2["default"]);
	
	Link.propTypes = {
	  children: _react2["default"].PropTypes.node,
	  href: _react2["default"].PropTypes.string,
	  style: _react2["default"].PropTypes.object
	};
	
	Link.contextTypes = {
	  styles: _react2["default"].PropTypes.object
	};
	
	exports["default"] = Link;
	module.exports = exports["default"];

/***/ }),
/* 970 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _get = __webpack_require__(8)["default"];
	
	var _inherits = __webpack_require__(5)["default"];
	
	var _createClass = __webpack_require__(6)["default"];
	
	var _classCallCheck = __webpack_require__(3)["default"];
	
	var _interopRequireDefault = __webpack_require__(2)["default"];
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _base = __webpack_require__(27);
	
	var _base2 = _interopRequireDefault(_base);
	
	var _radium = __webpack_require__(25);
	
	var _radium2 = _interopRequireDefault(_radium);
	
	var ListItem = (function (_Base) {
	  _inherits(ListItem, _Base);
	
	  function ListItem() {
	    _classCallCheck(this, _ListItem);
	
	    _get(Object.getPrototypeOf(_ListItem.prototype), "constructor", this).apply(this, arguments);
	  }
	
	  _createClass(ListItem, [{
	    key: "render",
	    value: function render() {
	      return _react2["default"].createElement(
	        "li",
	        { style: [this.context.styles.components.listItem, this.getStyles(), this.props.style] },
	        this.props.children
	      );
	    }
	  }]);
	
	  var _ListItem = ListItem;
	  ListItem = (0, _radium2["default"])(ListItem) || ListItem;
	  return ListItem;
	})(_base2["default"]);
	
	ListItem.propTypes = {
	  children: _react2["default"].PropTypes.node,
	  style: _react2["default"].PropTypes.object
	};
	
	ListItem.contextTypes = {
	  styles: _react2["default"].PropTypes.object
	};
	
	exports["default"] = ListItem;
	module.exports = exports["default"];

/***/ }),
/* 971 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _get = __webpack_require__(8)["default"];
	
	var _inherits = __webpack_require__(5)["default"];
	
	var _createClass = __webpack_require__(6)["default"];
	
	var _classCallCheck = __webpack_require__(3)["default"];
	
	var _interopRequireDefault = __webpack_require__(2)["default"];
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _base = __webpack_require__(27);
	
	var _base2 = _interopRequireDefault(_base);
	
	var _radium = __webpack_require__(25);
	
	var _radium2 = _interopRequireDefault(_radium);
	
	var List = (function (_Base) {
	  _inherits(List, _Base);
	
	  function List() {
	    _classCallCheck(this, _List);
	
	    _get(Object.getPrototypeOf(_List.prototype), "constructor", this).apply(this, arguments);
	  }
	
	  _createClass(List, [{
	    key: "render",
	    value: function render() {
	      return _react2["default"].createElement(
	        "ul",
	        { style: [this.context.styles.components.list, this.getStyles(), this.props.style] },
	        this.props.children
	      );
	    }
	  }]);
	
	  var _List = List;
	  List = (0, _radium2["default"])(List) || List;
	  return List;
	})(_base2["default"]);
	
	List.propTypes = {
	  children: _react2["default"].PropTypes.node,
	  style: _react2["default"].PropTypes.object
	};
	
	List.contextTypes = {
	  styles: _react2["default"].PropTypes.object
	};
	
	exports["default"] = List;
	module.exports = exports["default"];

/***/ }),
/* 972 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _get = __webpack_require__(8)["default"];
	
	var _inherits = __webpack_require__(5)["default"];
	
	var _createClass = __webpack_require__(6)["default"];
	
	var _classCallCheck = __webpack_require__(3)["default"];
	
	var _interopRequireDefault = __webpack_require__(2)["default"];
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _base = __webpack_require__(27);
	
	var _base2 = _interopRequireDefault(_base);
	
	var _radium = __webpack_require__(25);
	
	var _radium2 = _interopRequireDefault(_radium);
	
	var Overview = (function (_Base) {
	  _inherits(Overview, _Base);
	
	  function Overview(props) {
	    _classCallCheck(this, _Overview);
	
	    _get(Object.getPrototypeOf(_Overview.prototype), "constructor", this).call(this, props);
	  }
	
	  _createClass(Overview, [{
	    key: "_renderSlides",
	    value: function _renderSlides() {
	      var slide = this.props.slide;
	      return this.props.slides.map(function (child, index) {
	        if (index < slide - 3 || slide + 3 < index) {
	          return false;
	        }
	        var left = 50 + 30.6667 * (index - slide) + "%";
	        var style = {
	          position: "absolute",
	          width: "25%",
	          height: "25%",
	          top: "50%",
	          left: left,
	          transform: " translate(-50%,-50%)",
	          border: "1px solid #FFF",
	          opacity: index === slide ? 1 : 0.5
	        };
	        var el = _react2["default"].cloneElement(child, {
	          key: index,
	          slideIndex: index,
	          transition: [],
	          transitionDuration: 0,
	          appearOff: true
	        });
	        return _react2["default"].createElement(
	          "div",
	          { style: [style] },
	          el
	        );
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var styles = {
	        overview: {
	          height: "100%",
	          width: "100%"
	        }
	      };
	      return _react2["default"].createElement(
	        "div",
	        { className: "spectacle-overview", style: [styles.overview] },
	        this._renderSlides()
	      );
	    }
	  }]);
	
	  var _Overview = Overview;
	  Overview = (0, _radium2["default"])(Overview) || Overview;
	  return Overview;
	})(_base2["default"]);
	
	Overview.propTypes = {
	  slides: _react2["default"].PropTypes.array,
	  slide: _react2["default"].PropTypes.number
	};
	
	Overview.contextTypes = {
	  styles: _react2["default"].PropTypes.object
	};
	
	exports["default"] = Overview;
	module.exports = exports["default"];

/***/ }),
/* 973 */
/***/ (function(module, exports, __webpack_require__) {

	/*global setInterval clearInterval*/
	
	"use strict";
	
	var _get = __webpack_require__(8)["default"];
	
	var _inherits = __webpack_require__(5)["default"];
	
	var _createClass = __webpack_require__(6)["default"];
	
	var _classCallCheck = __webpack_require__(3)["default"];
	
	var _interopRequireDefault = __webpack_require__(2)["default"];
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _base = __webpack_require__(27);
	
	var _base2 = _interopRequireDefault(_base);
	
	var _radium = __webpack_require__(25);
	
	var _radium2 = _interopRequireDefault(_radium);
	
	var startTime = function startTime(date) {
	  var hours = date.getHours();
	  var minutes = date.getMinutes();
	  var seconds = date.getSeconds();
	  var ampm = hours >= 12 ? "PM" : "AM";
	  hours %= 12;
	  hours = hours ? hours : 12;
	  minutes = minutes < 10 ? "0" + minutes : minutes;
	  seconds = seconds < 10 ? "0" + seconds : seconds;
	  var strTime = hours + ":" + minutes + ":" + seconds + " " + ampm;
	  return strTime;
	};
	
	var Presenter = (function (_Base) {
	  _inherits(Presenter, _Base);
	
	  function Presenter(props) {
	    _classCallCheck(this, _Presenter);
	
	    _get(Object.getPrototypeOf(_Presenter.prototype), "constructor", this).call(this, props);
	    this.state = {
	      time: startTime(new Date())
	    };
	  }
	
	  _createClass(Presenter, [{
	    key: "_renderMainSlide",
	    value: function _renderMainSlide() {
	      var child = this.props.slides[this.props.slide];
	      var presenterStyle = {
	        position: "relative"
	      };
	      return _react2["default"].cloneElement(child, {
	        key: this.props.slide,
	        hash: this.props.hash,
	        slideIndex: this.props.slide,
	        lastSlide: this.props.lastSlide,
	        transition: [],
	        transitionDuration: 0,
	        presenterStyle: presenterStyle
	      });
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _this = this;
	
	      this.time = setInterval(function () {
	        _this.setState({
	          time: startTime(new Date())
	        });
	      }, 1000);
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      clearInterval(this.time);
	    }
	  }, {
	    key: "_renderNextSlide",
	    value: function _renderNextSlide() {
	      var presenterStyle = {
	        position: "relative"
	      };
	      var endStyle = {
	        position: "absolute",
	        top: "50%",
	        left: "50%",
	        transform: "translate(-50%, -50%)",
	        margin: 0,
	        color: "white"
	      };
	      var child = this.props.slides[parseInt(this.props.slide) + 1];
	      return child ? _react2["default"].cloneElement(child, {
	        key: this.props.slide + 1,
	        hash: child.props.id || this.props.slide + 1,
	        slideIndex: this.props.slide + 1,
	        lastSlide: this.props.lastSlide,
	        transition: [],
	        transitionDuration: 0,
	        presenterStyle: presenterStyle,
	        appearOff: true
	      }) : _react2["default"].createElement(
	        "h1",
	        { style: [endStyle] },
	        "END"
	      );
	    }
	  }, {
	    key: "_renderNotes",
	    value: function _renderNotes() {
	      var child = this.props.slides[this.props.slide];
	      if (!child.props.notes) {
	        return false;
	      }
	      return _react2["default"].createElement("div", { dangerouslySetInnerHTML: { __html: child.props.notes } });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var styles = {
	        presenter: {
	          height: "100%",
	          width: "100%",
	          display: "flex",
	          flex: 1,
	          flexDirection: "column"
	        },
	        header: {
	          position: "absolute",
	          display: "block",
	          color: "white",
	          width: "100%",
	          height: "20%",
	          textAlign: "center",
	          padding: "20px 50px"
	        },
	        slideInfo: {
	          position: "relative",
	          top: "50%",
	          transform: "translateY(-50%)",
	          float: "left",
	          margin: 0,
	          lineHeight: 1,
	          display: "inline-block",
	          fontSize: 28
	        },
	        clock: {
	          position: "relative",
	          top: "50%",
	          transform: "translateY(-50%)",
	          float: "right",
	          margin: 0,
	          lineHeight: 1,
	          display: "inline-block",
	          fontSize: 28
	        },
	        preview: {
	          display: "flex",
	          width: "100%",
	          height: "100%",
	          alignItems: "center",
	          justifyContent: "center",
	          flex: 1
	        },
	        main: {
	          display: "inline-block",
	          width: "50%",
	          height: "60%",
	          border: "2px solid white",
	          padding: 20,
	          margin: 20,
	          position: "relative"
	        },
	        next: {
	          display: "inline-block",
	          width: "40%",
	          height: "50%",
	          border: "2px solid white",
	          padding: 20,
	          margin: 20,
	          position: "relative"
	        },
	        notes: {
	          position: "absolute",
	          display: "block",
	          color: "white",
	          width: "100%",
	          height: "20%",
	          bottom: "0px",
	          textAlign: "left",
	          padding: "20px 50px",
	          columnCount: "2",
	          fontSize: "0.8em"
	        }
	      };
	      return _react2["default"].createElement(
	        "div",
	        { className: "spectacle-presenter", style: [styles.presenter] },
	        _react2["default"].createElement(
	          "div",
	          { style: styles.header },
	          _react2["default"].createElement(
	            "h2",
	            { style: styles.slideInfo },
	            "Slide ",
	            this.props.slide + 1,
	            " of ",
	            this.props.slides.length
	          ),
	          _react2["default"].createElement(
	            "h2",
	            { style: styles.clock },
	            this.state.time
	          )
	        ),
	        _react2["default"].createElement(
	          "div",
	          { style: styles.preview },
	          _react2["default"].createElement(
	            "div",
	            { className: "spectacle-presenter-main", style: [styles.main] },
	            this._renderMainSlide()
	          ),
	          _react2["default"].createElement(
	            "div",
	            { className: "spectacle-presenter-next", style: [styles.next] },
	            this._renderNextSlide()
	          )
	        ),
	        _react2["default"].createElement(
	          "div",
	          { className: "spectacle-presenter-notes", style: [styles.notes] },
	          this._renderNotes()
	        )
	      );
	    }
	  }]);
	
	  var _Presenter = Presenter;
	  Presenter = (0, _radium2["default"])(Presenter) || Presenter;
	  return Presenter;
	})(_base2["default"]);
	
	Presenter.propTypes = {
	  lastSlide: _react2["default"].PropTypes.number,
	  hash: _react2["default"].PropTypes.number,
	  slides: _react2["default"].PropTypes.array,
	  slide: _react2["default"].PropTypes.number
	};
	
	Presenter.contextTypes = {
	  styles: _react2["default"].PropTypes.object
	};
	
	exports["default"] = Presenter;
	module.exports = exports["default"];

/***/ }),
/* 974 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _get = __webpack_require__(8)["default"];
	
	var _inherits = __webpack_require__(5)["default"];
	
	var _createClass = __webpack_require__(6)["default"];
	
	var _classCallCheck = __webpack_require__(3)["default"];
	
	var _interopRequireDefault = __webpack_require__(2)["default"];
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _base = __webpack_require__(27);
	
	var _base2 = _interopRequireDefault(_base);
	
	var _radium = __webpack_require__(25);
	
	var _radium2 = _interopRequireDefault(_radium);
	
	var animations = {
	  pacmanTopFrames: _radium2["default"].keyframes({
	    "0%": { transform: "rotateZ(0deg)" },
	    "100%": { transform: "rotateZ(-30deg)" }
	  }),
	  pacmanBottomFrames: _radium2["default"].keyframes({
	    "0%": { transform: "rotateZ(0deg)" },
	    "100%": { transform: "rotateZ(30deg)" }
	  }),
	  pacmanTopFramesBis: _radium2["default"].keyframes({
	    "0%": { transform: "rotateZ(0deg)" },
	    "100%": { transform: "rotateZ(-30deg)" }
	  }),
	  pacmanBottomFramesBis: _radium2["default"].keyframes({
	    "0%": { transform: "rotateZ(0deg)" },
	    "100%": { transform: "rotateZ(30deg)" }
	  })
	};
	
	var Progress = (function (_Base) {
	  _inherits(Progress, _Base);
	
	  function Progress() {
	    _classCallCheck(this, _Progress);
	
	    _get(Object.getPrototypeOf(_Progress.prototype), "constructor", this).apply(this, arguments);
	  }
	
	  _createClass(Progress, [{
	    key: "render",
	    value: function render() {
	      var _this = this;
	
	      var style = this.context.styles.progress;
	      var markup = undefined;
	      switch (this.props.type) {
	        case "none":
	          return false;
	        case "pacman":
	          style = style.pacman;
	          markup = _react2["default"].createElement(
	            "div",
	            null,
	            _react2["default"].createElement(
	              "div",
	              { style: [style.pacman, this.getPointPosition(this.props.currentSlide)] },
	              _react2["default"].createElement("div", { style: [style.pacmanTop, this.getPacmanStyle("Top")] }),
	              _react2["default"].createElement("div", { style: [style.pacmanBottom, this.getPacmanStyle("Bottom")] })
	            ),
	            this.props.items.map(function (item, i) {
	              return _react2["default"].createElement("div", { style: [style.point, _this.getPointStyle(i)],
	                key: "presentation-progress-" + i });
	            })
	          );
	          break;
	        case "number":
	          style = style.number;
	          markup = _react2["default"].createElement(
	            "div",
	            null,
	            this.props.currentSlide + 1,
	            " / ",
	            this.props.items.length
	          );
	          break;
	        case "bar":
	          style = style.bar;
	          markup = _react2["default"].createElement("div", { style: [style.bar, this.getWidth()] });
	          break;
	        default:
	          return false;
	      }
	      return _react2["default"].createElement(
	        "div",
	        { style: [this.getStyles()] },
	        _react2["default"].createElement(
	          "div",
	          { style: [style.container] },
	          markup
	        )
	      );
	    }
	  }, {
	    key: "getWidth",
	    value: function getWidth() {
	      return {
	        width: 100 * this.props.currentSlide / (this.props.items.length - 1) + "%"
	      };
	    }
	  }, {
	    key: "getPacmanStyle",
	    value: function getPacmanStyle(side) {
	      var animationName = "pacman" + side + "Frames" + (this.props.currentSlide % 2 ? "" : "Bis");
	      return {
	        animation: animations[animationName] + " 0.12s linear 10 alternate both"
	      };
	    }
	  }, {
	    key: "getPointPosition",
	    value: function getPointPosition(i) {
	      return {
	        top: "-20px",
	        left: 5 + 20 * (i - this.props.items.length / 2) + "px"
	      };
	    }
	  }, {
	    key: "getPointStyle",
	    value: function getPointStyle(i) {
	      var style = this.getPointPosition(i);
	      if (this.props.currentSlide >= i) {
	        style.opacity = 0;
	      }
	
	      return style;
	    }
	  }]);
	
	  var _Progress = Progress;
	  Progress = (0, _radium2["default"])(Progress) || Progress;
	  return Progress;
	})(_base2["default"]);
	
	Progress.propTypes = {
	  items: _react2["default"].PropTypes.array,
	  currentSlide: _react2["default"].PropTypes.number,
	  type: _react2["default"].PropTypes.oneOf(["pacman", "bar", "number", "none"])
	};
	
	Progress.contextTypes = {
	  styles: _react2["default"].PropTypes.object
	};
	
	exports["default"] = Progress;
	module.exports = exports["default"];

/***/ }),
/* 975 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _get = __webpack_require__(8)["default"];
	
	var _inherits = __webpack_require__(5)["default"];
	
	var _createClass = __webpack_require__(6)["default"];
	
	var _classCallCheck = __webpack_require__(3)["default"];
	
	var _interopRequireDefault = __webpack_require__(2)["default"];
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _base = __webpack_require__(27);
	
	var _base2 = _interopRequireDefault(_base);
	
	var _radium = __webpack_require__(25);
	
	var _radium2 = _interopRequireDefault(_radium);
	
	var Quote = (function (_Base) {
	  _inherits(Quote, _Base);
	
	  function Quote() {
	    _classCallCheck(this, _Quote);
	
	    _get(Object.getPrototypeOf(_Quote.prototype), "constructor", this).apply(this, arguments);
	  }
	
	  _createClass(Quote, [{
	    key: "render",
	    value: function render() {
	      return _react2["default"].createElement(
	        "span",
	        { style: [this.context.styles.components.quote, this.getStyles(), this.props.style] },
	        this.props.children
	      );
	    }
	  }]);
	
	  var _Quote = Quote;
	  Quote = (0, _radium2["default"])(Quote) || Quote;
	  return Quote;
	})(_base2["default"]);
	
	Quote.propTypes = {
	  children: _react2["default"].PropTypes.node,
	  style: _react2["default"].PropTypes.object
	};
	
	Quote.contextTypes = {
	  styles: _react2["default"].PropTypes.object
	};
	
	exports["default"] = Quote;
	module.exports = exports["default"];

/***/ }),
/* 976 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _get = __webpack_require__(8)["default"];
	
	var _inherits = __webpack_require__(5)["default"];
	
	var _createClass = __webpack_require__(6)["default"];
	
	var _classCallCheck = __webpack_require__(3)["default"];
	
	var _interopRequireDefault = __webpack_require__(2)["default"];
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _objectAssign = __webpack_require__(204);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _radium = __webpack_require__(25);
	
	var _radium2 = _interopRequireDefault(_radium);
	
	var S = (function (_React$Component) {
	  _inherits(S, _React$Component);
	
	  function S() {
	    _classCallCheck(this, _S);
	
	    _get(Object.getPrototypeOf(_S.prototype), "constructor", this).apply(this, arguments);
	  }
	
	  _createClass(S, [{
	    key: "render",
	    value: function render() {
	      var styles = {};
	      if (this.props.type.indexOf("strikethrough") !== -1) {
	        styles = (0, _objectAssign2["default"])(styles, { textDecoration: "line-through" });
	      }
	      if (this.props.type.indexOf("underline") !== -1) {
	        styles = (0, _objectAssign2["default"])(styles, { textDecoration: "underline" });
	      }
	      if (this.props.type.indexOf("bold") !== -1) {
	        styles = (0, _objectAssign2["default"])(styles, { fontWeight: "bold" });
	      }
	      if (this.props.type.indexOf("italic") !== -1) {
	        styles = (0, _objectAssign2["default"])(styles, { fontStyle: "italic" });
	      }
	      return _react2["default"].createElement(
	        "span",
	        { style: [styles, this.context.styles.components.s[this.props.type], this.props.style] },
	        this.props.children
	      );
	    }
	  }]);
	
	  var _S = S;
	  S = (0, _radium2["default"])(S) || S;
	  return S;
	})(_react2["default"].Component);
	
	S.propTypes = {
	  children: _react2["default"].PropTypes.node,
	  style: _react2["default"].PropTypes.object,
	  type: _react2["default"].PropTypes.array
	};
	
	S.contextTypes = {
	  styles: _react2["default"].PropTypes.object
	};
	
	exports["default"] = S;
	module.exports = exports["default"];

/***/ }),
/* 977 */
/***/ (function(module, exports, __webpack_require__) {

	/*global window*/
	
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2)["default"];
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(20);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactTweenState = __webpack_require__(277);
	
	var _reactTweenState2 = _interopRequireDefault(_reactTweenState);
	
	var _base = __webpack_require__(27);
	
	var _base2 = _interopRequireDefault(_base);
	
	var _transitions = __webpack_require__(980);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _presentationConfig = __webpack_require__(464);
	
	var _presentationConfig2 = _interopRequireDefault(_presentationConfig);
	
	var _radium = __webpack_require__(25);
	
	var _radium2 = _interopRequireDefault(_radium);
	
	var Slide = _react2["default"].createClass({
	  displayName: "Slide",
	  mixins: [_reactTweenState2["default"].Mixin, _base2["default"].Mixin, _transitions2["default"]],
	  getDefaultProps: function getDefaultProps() {
	    return {
	      align: "center center",
	      presenterStyle: {}
	    };
	  },
	  propTypes: {
	    align: _react2["default"].PropTypes.string,
	    hash: _react2["default"].PropTypes.number,
	    presenterStyle: _react2["default"].PropTypes.object,
	    children: _react2["default"].PropTypes.node,
	    notes: _react2["default"].PropTypes.string,
	    slideIndex: _react2["default"].PropTypes.number,
	    lastSlide: _react2["default"].PropTypes.number
	  },
	  contextTypes: {
	    styles: _react2["default"].PropTypes.object,
	    "export": _react2["default"].PropTypes.bool,
	    print: _react2["default"].PropTypes.bool,
	    overview: _react2["default"].PropTypes.bool,
	    flux: _react2["default"].PropTypes.object
	  },
	  getInitialState: function getInitialState() {
	    return {
	      zoom: 1,
	      contentScale: 1
	    };
	  },
	  setZoom: function setZoom() {
	    var mobile = window.matchMedia("(max-width: 628px)").matches;
	    var content = _reactDom2["default"].findDOMNode(this.refs.content);
	    var zoom = content.offsetWidth / _presentationConfig2["default"].width;
	    var contentScaleY = content.parentNode.offsetHeight / _presentationConfig2["default"].height;
	    var contentScaleX = content.parentNode.offsetWidth / _presentationConfig2["default"].width;
	    var contentScale = mobile ? 1 : Math.min(contentScaleY, contentScaleX);
	    this.setState({
	      zoom: zoom > 0.6 ? zoom : 0.6,
	      contentScale: contentScale < 1 ? contentScale : 1
	    });
	  },
	  componentDidMount: function componentDidMount() {
	    var _this = this;
	
	    this.setZoom();
	    var slide = _reactDom2["default"].findDOMNode(this.refs.slide);
	    var frags = slide.querySelectorAll(".fragment");
	    if (frags && frags.length) {
	      Array.prototype.slice.call(frags, 0).forEach(function (frag, i) {
	        frag.dataset.fid = i;
	        _this.context.flux.actions.SlideActions.addFragment({
	          slide: _this.props.hash,
	          id: i,
	          visible: _this.props.lastSlide > _this.props.slideIndex
	        });
	      });
	    }
	    window.addEventListener("load", this.setZoom);
	    window.addEventListener("resize", this.setZoom);
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    window.removeEventListener("resize", this.setZoom);
	  },
	  render: function render() {
	    var printStyles = this.context.print ? {
	      backgroundColor: "white",
	      backgroundImage: "none"
	    } : {};
	    var overViewStyles = {
	      inner: {
	        flexDirection: "column"
	      },
	      content: {
	        width: "100%"
	      }
	    };
	    var styles = {
	      outer: {
	        position: this.context["export"] ? "relative" : "absolute",
	        top: 0,
	        left: 0,
	        width: "100%",
	        height: "100%",
	        display: "flex",
	        backgroundColor: this.context.styles.global.body.background ? this.context.styles.global.body.background : ""
	      },
	      inner: {
	        display: "flex",
	        position: "relative",
	        flex: 1,
	        alignItems: this.props.align ? this.props.align.split(" ")[1] : "center",
	        justifyContent: this.props.align ? this.props.align.split(" ")[0] : "center"
	      },
	      content: {
	        flex: 1,
	        maxHeight: _presentationConfig2["default"].height,
	        maxWidth: _presentationConfig2["default"].width,
	        fontSize: 16 * this.state.zoom,
	        transform: "scale(" + this.state.contentScale + ")",
	        padding: this.state.zoom > 0.6 ? _presentationConfig2["default"].margin : 10
	      }
	    };
	    return _react2["default"].createElement(
	      "div",
	      { className: "spectacle-slide",
	        ref: "slide",
	        style: [styles.outer, this.getStyles(), this.getTransitionStyles(), printStyles, this.props.presenterStyle] },
	      _react2["default"].createElement(
	        "div",
	        { style: [styles.inner, this.context.overview && overViewStyles.inner] },
	        _react2["default"].createElement(
	          "div",
	          { ref: "content",
	            className: "spectacle-content",
	            style: [styles.content, this.context.styles.components.content, this.context.overview && overViewStyles.content] },
	          this.props.children
	        )
	      )
	    );
	  }
	});
	
	exports["default"] = (0, _radium2["default"])(Slide);
	module.exports = exports["default"];

/***/ }),
/* 978 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2)["default"];
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _appear = __webpack_require__(955);
	
	var _appear2 = _interopRequireDefault(_appear);
	
	var _blockQuote = __webpack_require__(956);
	
	var _blockQuote2 = _interopRequireDefault(_blockQuote);
	
	var _cite = __webpack_require__(957);
	
	var _cite2 = _interopRequireDefault(_cite);
	
	var _code = __webpack_require__(958);
	
	var _code2 = _interopRequireDefault(_code);
	
	var _deck = __webpack_require__(959);
	
	var _deck2 = _interopRequireDefault(_deck);
	
	var _fill = __webpack_require__(961);
	
	var _fill2 = _interopRequireDefault(_fill);
	
	var _fit = __webpack_require__(962);
	
	var _fit2 = _interopRequireDefault(_fit);
	
	var _heading = __webpack_require__(966);
	
	var _heading2 = _interopRequireDefault(_heading);
	
	var _image = __webpack_require__(967);
	
	var _image2 = _interopRequireDefault(_image);
	
	var _layout = __webpack_require__(968);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _link = __webpack_require__(969);
	
	var _link2 = _interopRequireDefault(_link);
	
	var _listItem = __webpack_require__(970);
	
	var _listItem2 = _interopRequireDefault(_listItem);
	
	var _list = __webpack_require__(971);
	
	var _list2 = _interopRequireDefault(_list);
	
	var _quote = __webpack_require__(975);
	
	var _quote2 = _interopRequireDefault(_quote);
	
	var _s = __webpack_require__(976);
	
	var _s2 = _interopRequireDefault(_s);
	
	var _slide = __webpack_require__(977);
	
	var _slide2 = _interopRequireDefault(_slide);
	
	var _text = __webpack_require__(979);
	
	var _text2 = _interopRequireDefault(_text);
	
	exports.Appear = _appear2["default"];
	exports.BlockQuote = _blockQuote2["default"];
	exports.Cite = _cite2["default"];
	exports.Code = _code2["default"];
	exports.Deck = _deck2["default"];
	exports.Fill = _fill2["default"];
	exports.Fit = _fit2["default"];
	exports.Heading = _heading2["default"];
	exports.Image = _image2["default"];
	exports.Layout = _layout2["default"];
	exports.Link = _link2["default"];
	exports.ListItem = _listItem2["default"];
	exports.List = _list2["default"];
	exports.Quote = _quote2["default"];
	exports.S = _s2["default"];
	exports.Slide = _slide2["default"];
	exports.Text = _text2["default"];

/***/ }),
/* 979 */
/***/ (function(module, exports, __webpack_require__) {

	/*global window*/
	
	"use strict";
	
	var _get = __webpack_require__(8)["default"];
	
	var _inherits = __webpack_require__(5)["default"];
	
	var _createClass = __webpack_require__(6)["default"];
	
	var _classCallCheck = __webpack_require__(3)["default"];
	
	var _interopRequireDefault = __webpack_require__(2)["default"];
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(20);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _base = __webpack_require__(27);
	
	var _base2 = _interopRequireDefault(_base);
	
	var _radium = __webpack_require__(25);
	
	var _radium2 = _interopRequireDefault(_radium);
	
	var Text = (function (_Base) {
	  _inherits(Text, _Base);
	
	  function Text(props) {
	    _classCallCheck(this, _Text);
	
	    _get(Object.getPrototypeOf(_Text.prototype), "constructor", this).call(this, props);
	    this.resize = this.resize.bind(this);
	    this.state = {
	      scale: 1,
	      height: 16
	    };
	  }
	
	  _createClass(Text, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.resize();
	      window.addEventListener("load", this.resize);
	      window.addEventListener("resize", this.resize);
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      window.removeEventListener("load", this.resize);
	      window.removeEventListener("resize", this.resize);
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps() {
	      this.resize();
	    }
	  }, {
	    key: "resize",
	    value: function resize() {
	      if (this.props.fit) {
	        var text = _react2["default"].findDOMNode(this.refs.text);
	        var container = _react2["default"].findDOMNode(this.refs.container);
	        text.style.display = "inline-block";
	        var scale = container.offsetWidth / text.offsetWidth;
	        var height = text.offsetHeight * scale;
	        text.style.display = "block";
	        this.setState({
	          scale: scale,
	          height: height
	        });
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var styles = {
	        container: {
	          display: "block",
	          width: "100%",
	          height: this.state.height
	        },
	        text: {
	          fontSize: 16,
	          display: "block",
	          margin: "0",
	          padding: "0",
	          lineHeight: this.props.lineHeight,
	          transform: "scale(" + this.state.scale + ")",
	          transformOrigin: "center top"
	        }
	      };
	      return this.props.fit ? _react2["default"].createElement(
	        "div",
	        {
	          ref: "container",
	          style: [this.context.styles.components.text, this.getStyles(), styles.container] },
	        _react2["default"].createElement(
	          "span",
	          {
	            ref: "text",
	            style: [styles.text, this.props.style] },
	          this.props.children
	        )
	      ) : _react2["default"].createElement(
	        "p",
	        { style: [this.context.styles.components.text, this.getStyles(), this.props.style] },
	        this.props.children
	      );
	    }
	  }]);
	
	  var _Text = Text;
	  Text = (0, _radium2["default"])(Text) || Text;
	  return Text;
	})(_base2["default"]);
	
	Text.defaultProps = {
	  lineHeight: 1
	};
	
	Text.propTypes = {
	  children: _react2["default"].PropTypes.node,
	  lineHeight: _react2["default"].PropTypes.number
	};
	
	Text.contextTypes = {
	  styles: _react2["default"].PropTypes.object
	};
	
	exports["default"] = Text;
	module.exports = exports["default"];

/***/ }),
/* 980 */
/***/ (function(module, exports, __webpack_require__) {

	/*global setTimeout*/
	
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2)["default"];
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _objectAssign = __webpack_require__(204);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _reactTweenState = __webpack_require__(277);
	
	var _reactTweenState2 = _interopRequireDefault(_reactTweenState);
	
	exports["default"] = {
	  propTypes: {
	    transition: _react2["default"].PropTypes.array,
	    transitionDuration: _react2["default"].PropTypes.number
	  },
	  contextTypes: {
	    location: _react2["default"].PropTypes.object
	  },
	  getDefaultProps: function getDefaultProps() {
	    return {
	      transition: []
	    };
	  },
	  getInitialState: function getInitialState() {
	    var state = {
	      z: 1
	    };
	
	    if (this.props.transition.indexOf("fade") !== -1) {
	      state.opacity = 1;
	    }
	
	    if (this.props.transition.indexOf("zoom") !== -1) {
	      state.scale = 1;
	    }
	
	    if (this.props.transition.indexOf("slide") !== -1) {
	      state.left = 0;
	    }
	
	    if (this.props.transition.indexOf("spin") !== -1) {
	      state.x = 0;
	    }
	
	    return state;
	  },
	  routerCallback: function routerCallback(cb, immediate) {
	    if (this.props.transition.length > 0 && immediate !== true) {
	      setTimeout(cb, this.props.transitionDuration);
	    } else {
	      cb();
	    }
	  },
	  componentWillEnter: function componentWillEnter(cb) {
	    var _this = this;
	
	    var direction = this.props.slideIndex > this.props.lastSlide;
	
	    this.setState({
	      z: 1
	    }, function () {
	
	      if (_this.props.transition.indexOf("fade") !== -1) {
	        _this.tweenState("opacity", {
	          easing: _reactTweenState2["default"].easingTypes.easeInOutQuad,
	          duration: _this.props.transitionDuration,
	          beginValue: 0,
	          endValue: 1
	        });
	      }
	
	      if (_this.props.transition.indexOf("zoom") !== -1) {
	        _this.tweenState("scale", {
	          easing: _reactTweenState2["default"].easingTypes.easeInOutQuad,
	          duration: _this.props.transitionDuration,
	          beginValue: 0.1,
	          endValue: 1
	        });
	      }
	
	      if (_this.props.transition.indexOf("slide") !== -1) {
	        _this.tweenState("left", {
	          easing: _reactTweenState2["default"].easingTypes.easeOutQuad,
	          duration: _this.props.transitionDuration,
	          beginValue: direction ? 100 : -100,
	          endValue: 0
	        });
	      }
	
	      if (_this.props.transition.indexOf("spin") !== -1) {
	        _this.tweenState("x", {
	          easing: _reactTweenState2["default"].easingTypes.easeOutQuad,
	          duration: _this.props.transitionDuration,
	          beginValue: direction ? 90 : -90,
	          endValue: 0
	        });
	      }
	    });
	
	    this.routerCallback(cb);
	  },
	  componentWillAppear: function componentWillAppear(cb) {
	    var state = {
	      z: 1
	    };
	
	    if (this.props.transition.indexOf("fade") !== -1) {
	      state.opacity = 1;
	    }
	
	    if (this.props.transition.indexOf("zoom") !== -1) {
	      state.scale = 1;
	    }
	
	    if (this.props.transition.indexOf("slide") !== -1) {
	      state.left = 0;
	    }
	
	    if (this.props.transition.indexOf("spin") !== -1) {
	      state.x = 0;
	    }
	
	    this.setState(state);
	
	    this.routerCallback(cb, true);
	  },
	  componentWillLeave: function componentWillLeave(cb) {
	    var _this2 = this;
	
	    var slide = parseInt(this.props.currentSlide) || 0;
	    var direction = this.props.slideIndex > slide;
	
	    this.setState({
	      z: ""
	    }, function () {
	
	      if (_this2.props.transition.indexOf("fade") !== -1) {
	        _this2.tweenState("opacity", {
	          easing: _reactTweenState2["default"].easingTypes.easeInOutQuad,
	          duration: _this2.props.transitionDuration,
	          endValue: 0
	        });
	      }
	
	      if (_this2.props.transition.indexOf("zoom") !== -1) {
	        _this2.tweenState("scale", {
	          easing: _reactTweenState2["default"].easingTypes.easeInOutQuad,
	          duration: _this2.props.transitionDuration,
	          endValue: 0.1
	        });
	      }
	
	      if (_this2.props.transition.indexOf("slide") !== -1) {
	        _this2.tweenState("left", {
	          easing: _reactTweenState2["default"].easingTypes.easeOutQuad,
	          duration: _this2.props.transitionDuration,
	          endValue: direction ? 100 : -100
	        });
	      }
	
	      if (_this2.props.transition.indexOf("spin") !== -1) {
	        _this2.tweenState("x", {
	          easing: _reactTweenState2["default"].easingTypes.easeOutQuad,
	          duration: _this2.props.transitionDuration,
	          endValue: direction ? 90 : -90
	        });
	      }
	    });
	
	    this.routerCallback(cb);
	  },
	  getTransitionStyles: function getTransitionStyles() {
	    var transformValue = "";
	    var styles = {
	      zIndex: this.state.z
	    };
	    if (this.props.transition.indexOf("fade") !== -1) {
	      styles = (0, _objectAssign2["default"])(styles, {
	        opacity: this.getTweeningValue("opacity")
	      });
	    }
	    if (this.props.transition.indexOf("zoom") !== -1) {
	      transformValue += " scale(" + this.getTweeningValue("scale") + ")";
	    }
	    if (this.props.transition.indexOf("slide") !== -1) {
	      transformValue += " translate3d(" + this.getTweeningValue("left") + "%, 0, 0)";
	    } else {
	      transformValue += " translate3d(0px, 0px, 0px)";
	    }
	    if (this.props.transition.indexOf("spin") !== -1) {
	      transformValue += " rotateY(" + this.getTweeningValue("x") + "deg)";
	    }
	    styles = (0, _objectAssign2["default"])(styles, {
	      transform: transformValue
	    });
	    return styles;
	  }
	};
	module.exports = exports["default"];

/***/ }),
/* 981 */
/***/ (function(module, exports) {

	/*global Image*/
	
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var preload = function preload(imageArray) {
	  var images = [];
	  for (var i = 0; i < imageArray.length; i++) {
	    images[i] = new Image();
	    images[i].src = imageArray[i];
	  }
	};
	
	exports["default"] = preload;
	module.exports = exports["default"];

/***/ }),
/* 982 */
/***/ (function(module, exports) {

	/*eslint-disable object-shorthand*/
	"use strict";
	
	var colors = {
	  primary: "#f9c300",
	  secondary: "black",
	  tertiary: "white"
	};
	
	var fonts = {
	  primary: "Open Sans Condensed",
	  secondary: "Lobster Two",
	  tertiary: "monospace"
	};
	
	module.exports = {
	  colors: colors,
	  fonts: fonts,
	  global: {
	    body: {
	      background: colors.primary,
	      fontFamily: fonts.primary,
	      fontWeight: "normal",
	      fontSize: "2em",
	      color: colors.secondary,
	      overflow: "hidden"
	    },
	    "html, body": {
	      height: "100%"
	    },
	    "*": {
	      boxSizing: "border-box"
	    }
	  },
	  progress: {
	    pacman: {
	      container: {
	        position: "absolute",
	        bottom: "5px",
	        left: "50%",
	        transition: "all 1s ease-in-out 0.2s",
	        zIndex: 1000
	      },
	      pacman: {
	        position: "absolute",
	        transition: "left 0.3s ease-in-out 0.2s",
	        width: "20px",
	        height: "20px",
	        transform: "translate(-5px, -5px)"
	      },
	      pacmanTop: {
	        position: "absolute",
	        content: " ",
	        width: "20px",
	        height: "10px",
	        borderTopLeftRadius: "10px",
	        borderTopRightRadius: "10px",
	        background: colors.tertiary
	      },
	      pacmanBottom: {
	        position: "absolute",
	        content: " ",
	        width: "20px",
	        height: "10px",
	        borderBottomLeftRadius: "10px",
	        borderBottomRightRadius: "10px",
	        background: colors.tertiary,
	        top: "10px"
	      },
	      point: {
	        position: "absolute",
	        float: "left",
	        background: "transparent",
	        width: "10px",
	        height: "10px",
	        borderWidth: 2,
	        borderStyle: "solid",
	        borderColor: colors.tertiary,
	        borderRadius: "50%",
	        transition: "all 0.01s ease-out 0.4s"
	      }
	    },
	    bar: {
	      container: {
	        position: "absolute",
	        height: "10px",
	        width: "100%",
	        bottom: 0,
	        left: 0,
	        transition: "all 1s ease-in-out 0.2s",
	        zIndex: 1000
	      },
	      bar: {
	        height: "100%",
	        background: colors.tertiary,
	        transition: "all 0.3s ease-out"
	      }
	    },
	    number: {
	      container: {
	        position: "absolute",
	        bottom: 10,
	        right: 10,
	        zIndex: 1000,
	        color: colors.tertiary
	      }
	    }
	  },
	  components: {
	    blockquote: {
	      textAlign: "left",
	      position: "relative",
	      display: "inline-block"
	    },
	    quote: {
	      borderLeft: "1px solid " + colors.primary,
	      paddingLeft: 40,
	      display: "block",
	      color: colors.primary,
	      fontSize: "4.9em",
	      lineHeight: 1,
	      fontWeight: "bold"
	    },
	    cite: {
	      color: colors.tertiary,
	      display: "block",
	      clear: "left",
	      fontSize: "2em",
	      marginTop: "1em"
	    },
	    content: {
	      margin: "0 auto",
	      textAlign: "center"
	    },
	    codePane: {
	      pre: {
	        margin: "auto",
	        fontSize: "1em",
	        fontWeight: "normal",
	        fontFamily: fonts.tertiary,
	        minWidth: "100%",
	        maxWidth: 800
	      },
	      code: {
	        textAlign: "left",
	        padding: 20,
	        fontWeight: "normal"
	      }
	    },
	    code: {
	      color: "black",
	      fontSize: "2.66em",
	      fontFamily: fonts.tertiary,
	      margin: "0.25em auto",
	      backgroundColor: "rgba(0,0,0,0.15)",
	      padding: "0 10px",
	      borderRadius: 3
	    },
	    heading: {
	      h1: {
	        color: colors.tertiary,
	        fontSize: "7.05em",
	        fontFamily: fonts.primary,
	        lineHeight: 1,
	        fontWeight: "bold",
	        margin: 0,
	        zoom: 1
	      },
	      h2: {
	        color: colors.secondary,
	        fontSize: "5.88em",
	        fontFamily: fonts.primary,
	        lineHeight: 1,
	        fontWeight: "bold",
	        margin: 0
	      },
	      h3: {
	        color: "black",
	        fontSize: "4.9em",
	        fontFamily: fonts.secondary,
	        lineHeight: 1,
	        fontWeight: "bold",
	        margin: "0.5em auto"
	      },
	      h4: {
	        color: "black",
	        fontSize: "3.82em",
	        fontFamily: fonts.primary,
	        lineHeight: 1,
	        fontWeight: "bold",
	        margin: "0.5em auto"
	      },
	      h5: {
	        color: "black",
	        fontSize: "3.19em",
	        fontFamily: fonts.primary,
	        lineHeight: 1,
	        fontWeight: "bold",
	        margin: "0.5em auto"
	      },
	      h6: {
	        color: "black",
	        fontSize: "2.66em",
	        fontFamily: fonts.primary,
	        lineHeight: 1,
	        fontWeight: "bold",
	        margin: "0.5em auto"
	      }
	    },
	    image: {
	      display: "block",
	      margin: "0.5em auto"
	    },
	    link: {
	      textDecoration: "none"
	    },
	    listItem: {
	      fontSize: "2.66em"
	    },
	    list: {
	      textAlign: "left",
	      listStylePosition: "inside",
	      padding: 0
	    },
	    s: {
	      strikethrough: {}
	    },
	    text: {
	      color: "black",
	      fontSize: "2.66em",
	      fontFamily: fonts.primary,
	      margin: "0.25em auto"
	    }
	  }
	};

/***/ }),
/* 983 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = __webpack_require__(7)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	function htmlSlide(_ref) {
	  var id = _ref.id;
	  var notes = _ref.notes;
	  var heading = _ref.heading;
	  var bgColor = _ref.bgColor;
	  var subHeading = _ref.subHeading;
	  var html = _ref.html;
	  var slideClass = _ref.slideClass;
	
	  var slideContentClass = slideClass ? ' slide-' + slideClass : '';
	  var bgColorOpts = {};
	  if (bgColor) {
	    bgColorOpts.bgColor = bgColor;
	  }
	  return _react2['default'].createElement(
	    _spectaclePpa.Slide,
	    _extends({
	      id: id,
	      key: id
	    }, bgColorOpts, {
	      notes: notes,
	      textColor: 'white' }),
	    _react2['default'].createElement(
	      'div',
	      { className: 'slide-content' + slideContentClass },
	      _react2['default'].createElement(
	        'div',
	        {
	          className: 'text-formatted' },
	        !!heading && _react2['default'].createElement(
	          _spectaclePpa.Heading,
	          { size: 3 },
	          heading
	        ),
	        !!subHeading && _react2['default'].createElement(
	          _spectaclePpa.Heading,
	          { size: 5 },
	          subHeading
	        ),
	        _react2['default'].createElement('div', {
	          dangerouslySetInnerHTML: { __html: html } })
	      )
	    )
	  );
	}
	
	exports['default'] = htmlSlide;
	module.exports = exports['default'];

/***/ }),
/* 984 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = {
	  width: 1000,
	  height: 700,
	  margin: 40,
	  theme: __webpack_require__(999),
	  print: __webpack_require__(53),
	  html: __webpack_require__(52)
	};

/***/ }),
/* 985 */
/***/ (function(module, exports, __webpack_require__) {

	/* eslint no-console: 0 */
	
	'use strict';
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _helpersMarkdownScript = __webpack_require__(9);
	
	var _helpersMarkdownScript2 = _interopRequireDefault(_helpersMarkdownScript);
	
	var _indexMd = __webpack_require__(722);
	
	var _indexMd2 = _interopRequireDefault(_indexMd);
	
	var _extensionActivitiesExtensionActivitiesMd = __webpack_require__(1514);
	
	var _extensionActivitiesExtensionActivitiesMd2 = _interopRequireDefault(_extensionActivitiesExtensionActivitiesMd);
	
	var _programPrepProgramPrepMd = __webpack_require__(1517);
	
	var _programPrepProgramPrepMd2 = _interopRequireDefault(_programPrepProgramPrepMd);
	
	var _sections00_prepLevel1_prepMd = __webpack_require__(1518);
	
	var _sections00_prepLevel1_prepMd2 = _interopRequireDefault(_sections00_prepLevel1_prepMd);
	
	var _funMd = __webpack_require__(1515);
	
	var _funMd2 = _interopRequireDefault(_funMd);
	
	var _imagesEmergencyPreparednessSquadPng = __webpack_require__(2267);
	
	var _imagesEmergencyPreparednessSquadPng2 = _interopRequireDefault(_imagesEmergencyPreparednessSquadPng);
	
	var _imagesEmergencyPreparednessSquadTrialPng = __webpack_require__(2269);
	
	var _imagesEmergencyPreparednessSquadTrialPng2 = _interopRequireDefault(_imagesEmergencyPreparednessSquadTrialPng);
	
	var _imagesEmergencyPreparednessSquadExpiredPng = __webpack_require__(2268);
	
	var _imagesEmergencyPreparednessSquadExpiredPng2 = _interopRequireDefault(_imagesEmergencyPreparednessSquadExpiredPng);
	
	var _config = __webpack_require__(984);
	
	var _config2 = _interopRequireDefault(_config);
	
	// Preload image functions
	
	var _sections30_gameShowGameShowSection = __webpack_require__(465);
	
	__webpack_require__(2185);
	
	var md = new _helpersMarkdownScript2['default'](_indexMd2['default']);
	
	var levels = {
	  prep: {
	    deck: __webpack_require__(988)
	  },
	  1: {
	    thumbnail: __webpack_require__(2270),
	    overviewThumbnail: __webpack_require__(2271),
	    deck: __webpack_require__(986),
	    prep: new _helpersMarkdownScript2['default'](_sections00_prepLevel1_prepMd2['default']),
	    levelName: 'Know the Risks'
	  },
	  completed: {
	    deck: __webpack_require__(987)
	  }
	};
	
	var program = {
	  id: 'epsHybridAssembly',
	  title: md.getSectionAsString('Title - Short'),
	  longTitle: md.getSectionAsString('Title - Long'),
	  thumbnailImage: _imagesEmergencyPreparednessSquadPng2['default'],
	  trialImageThumb: _imagesEmergencyPreparednessSquadTrialPng2['default'],
	  expiredImageThumb: _imagesEmergencyPreparednessSquadExpiredPng2['default'],
	  longDescription: md.getSectionAsString('Description - Long'),
	  shortDescription: md.getSectionAsString('Description - Short'),
	  levelsDescription: md.getSectionAsString('Description - Levels'),
	  levels: levels,
	  extensionActivitiesMd: new _helpersMarkdownScript2['default'](_extensionActivitiesExtensionActivitiesMd2['default']),
	  programPrepMd: new _helpersMarkdownScript2['default'](_programPrepProgramPrepMd2['default']),
	  funMd: new _helpersMarkdownScript2['default'](_funMd2['default']),
	  preload: function preload(_ref) {
	    var level = _ref.level;
	
	    console.log('Preloading assets for Level ' + level);
	
	    (0, _sections30_gameShowGameShowSection.preloadGameShow)();
	  },
	  config: _config2['default'],
	  limitToRegions: []
	};
	
	exports['default'] = program;
	module.exports = exports['default'];

/***/ }),
/* 986 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(__filename) {'use strict';
	
	var _get = __webpack_require__(8)['default'];
	
	var _inherits = __webpack_require__(5)['default'];
	
	var _createClass = __webpack_require__(6)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _helpersMarkdownScript = __webpack_require__(9);
	
	var _helpersMarkdownScript2 = _interopRequireDefault(_helpersMarkdownScript);
	
	var _indexMd = __webpack_require__(722);
	
	var _indexMd2 = _interopRequireDefault(_indexMd);
	
	var _sections01_teamCreationTeamCreationSection = __webpack_require__(990);
	
	var _sections01_teamCreationTeamCreationSection2 = _interopRequireDefault(_sections01_teamCreationTeamCreationSection);
	
	var _sections02_startStartSection = __webpack_require__(991);
	
	var _sections02_startStartSection2 = _interopRequireDefault(_sections02_startStartSection);
	
	var _sections03_songSongSection = __webpack_require__(992);
	
	var _sections03_songSongSection2 = _interopRequireDefault(_sections03_songSongSection);
	
	var _sections04_overviewOverviewSection = __webpack_require__(993);
	
	var _sections04_overviewOverviewSection2 = _interopRequireDefault(_sections04_overviewOverviewSection);
	
	var _sections05_teamIntroTeamIntroSection = __webpack_require__(994);
	
	var _sections05_teamIntroTeamIntroSection2 = _interopRequireDefault(_sections05_teamIntroTeamIntroSection);
	
	var _sections06_superheroCalmingBreathSuperheroCalmingBreathSection = __webpack_require__(995);
	
	var _sections06_superheroCalmingBreathSuperheroCalmingBreathSection2 = _interopRequireDefault(_sections06_superheroCalmingBreathSuperheroCalmingBreathSection);
	
	var _sections30_gameShowGameShowSection = __webpack_require__(465);
	
	var _sections30_gameShowGameShowSection2 = _interopRequireDefault(_sections30_gameShowGameShowSection);
	
	var _sections40_classActivityClassActivitySection = __webpack_require__(996);
	
	var _sections40_classActivityClassActivitySection2 = _interopRequireDefault(_sections40_classActivityClassActivitySection);
	
	var _sections70_missionAssignmentMissionAssignmentSection = __webpack_require__(997);
	
	var _sections70_missionAssignmentMissionAssignmentSection2 = _interopRequireDefault(_sections70_missionAssignmentMissionAssignmentSection);
	
	var _sections90_finishFinishSection = __webpack_require__(998);
	
	var _sections90_finishFinishSection2 = _interopRequireDefault(_sections90_finishFinishSection);
	
	var md = new _helpersMarkdownScript2['default'](_indexMd2['default']);
	var level = Number(__filename.replace(/^.*level/, '').replace('.jsx', ''));
	var title = md.getSectionMetadata('Level ' + level, 'Title');
	
	var _default = (function (_Component) {
	  _inherits(_default, _Component);
	
	  function _default() {
	    _classCallCheck(this, _default);
	
	    _get(Object.getPrototypeOf(_default.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(_default, [{
	    key: 'render',
	    value: function render() {
	      var regionData = this.context.regionData;
	
	      return _react2['default'].createElement(
	        _spectaclePpa.Deck,
	        { transition: ['slide'],
	          transitionDuration: 800,
	          progress: 'bar' },
	        (0, _sections01_teamCreationTeamCreationSection2['default'])({ regionData: regionData }),
	        (0, _sections02_startStartSection2['default'])({ regionData: regionData }),
	        (0, _sections03_songSongSection2['default'])({ level: level, regionData: regionData }),
	        (0, _sections04_overviewOverviewSection2['default'])({ regionData: regionData }),
	        (0, _sections05_teamIntroTeamIntroSection2['default'])({ regionData: regionData }),
	        (0, _sections06_superheroCalmingBreathSuperheroCalmingBreathSection2['default'])({ regionData: regionData }),
	        (0, _sections30_gameShowGameShowSection2['default'])({ level: level, regionData: regionData }),
	        (0, _sections40_classActivityClassActivitySection2['default'])({ level: level, subActivity: 'a', regionData: regionData }),
	        (0, _sections40_classActivityClassActivitySection2['default'])({ level: level, subActivity: 'b', regionData: regionData }),
	        (0, _sections70_missionAssignmentMissionAssignmentSection2['default'])({ level: level, title: title, regionData: regionData }),
	        (0, _sections90_finishFinishSection2['default'])({ level: level, regionData: regionData })
	      );
	    }
	  }], [{
	    key: 'contextTypes',
	    value: {
	      regionData: _react.PropTypes.object.isRequired
	    },
	    enumerable: true
	  }, {
	    key: 'metadata',
	    value: {
	      title: title
	    },
	    enumerable: true
	  }]);

	  return _default;
	})(_react.Component);

	exports['default'] = _default;
	module.exports = exports['default'];
	/* Team Creation */ /* Start */ /* Theme Song */ /* Overview */ /* Team Introduction */ /* Superhero calming breath */ /* Game Show */ /* Emergency kit brainstorm */ /* Make a plan popcorn */ /* Mission Assignment */ /* Finish */
	/* WEBPACK VAR INJECTION */}.call(exports, "programs/epsHybridAssembly/level1.jsx"))

/***/ }),
/* 987 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _get = __webpack_require__(8)['default'];
	
	var _inherits = __webpack_require__(5)['default'];
	
	var _createClass = __webpack_require__(6)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _baseSlidesBalloonSlide = __webpack_require__(84);
	
	var _baseSlidesBalloonSlide2 = _interopRequireDefault(_baseSlidesBalloonSlide);
	
	var _imagesCharactersSara_gigglePng = __webpack_require__(2266);
	
	var _imagesCharactersSara_gigglePng2 = _interopRequireDefault(_imagesCharactersSara_gigglePng);
	
	var _helpersMarkdownScript = __webpack_require__(9);
	
	var _helpersMarkdownScript2 = _interopRequireDefault(_helpersMarkdownScript);
	
	var _levelCompletedMd = __webpack_require__(1516);
	
	var _levelCompletedMd2 = _interopRequireDefault(_levelCompletedMd);
	
	var md = new _helpersMarkdownScript2['default'](_levelCompletedMd2['default']);
	
	var _default = (function (_Component) {
	  _inherits(_default, _Component);
	
	  function _default() {
	    _classCallCheck(this, _default);
	
	    _get(Object.getPrototypeOf(_default.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(_default, [{
	    key: 'render',
	    value: function render() {
	      var regionData = this.context.regionData;
	
	      return _react2['default'].createElement(
	        _spectaclePpa.Deck,
	        { transition: ['slide'],
	          transitionDuration: 800,
	          progress: 'bar' },
	        (0, _baseSlidesBalloonSlide2['default'])({
	          id: 'welcome-back',
	          characterSide: 'right',
	          characterImage: _imagesCharactersSara_gigglePng2['default'],
	          notes: md.getSubSectionAsHtml('Level Completed', 'Notes', false, regionData),
	          html: md.getSubSectionAsHtml('Level Completed', 'Content', false, regionData),
	          bgColor: '#8f288c'
	        })
	      );
	    }
	  }], [{
	    key: 'contextTypes',
	    value: {
	      regionData: _react.PropTypes.object.isRequired
	    },
	    enumerable: true
	  }]);

	  return _default;
	})(_react.Component);

	exports['default'] = _default;
	module.exports = exports['default'];

/***/ }),
/* 988 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _get = __webpack_require__(8)['default'];
	
	var _inherits = __webpack_require__(5)['default'];
	
	var _createClass = __webpack_require__(6)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _componentsStartLevel = __webpack_require__(79);
	
	var _componentsStartLevel2 = _interopRequireDefault(_componentsStartLevel);
	
	var _sections00_prepPrepSection = __webpack_require__(989);
	
	var _sections00_prepPrepSection2 = _interopRequireDefault(_sections00_prepPrepSection);
	
	var _default = (function (_Component) {
	  _inherits(_default, _Component);
	
	  function _default() {
	    _classCallCheck(this, _default);
	
	    _get(Object.getPrototypeOf(_default.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(_default, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var level = _props.nextLevel;
	      var configuration = _props.configuration;
	      var regionData = this.context.regionData;
	
	      return _react2['default'].createElement(
	        _spectaclePpa.Deck,
	        { transition: ['slide'],
	          transitionDuration: 800,
	          progress: 'bar' },
	        (0, _sections00_prepPrepSection2['default'])({ level: level, configuration: configuration, regionData: regionData }),
	        _react2['default'].createElement(
	          _spectaclePpa.Slide,
	          {
	            id: 'start',
	            textColor: 'white' },
	          _react2['default'].createElement(_componentsStartLevel2['default'], null)
	        )
	      );
	    }
	  }], [{
	    key: 'propTypes',
	    value: {
	      nextLevel: _react.PropTypes.string.isRequired,
	      configuration: _react.PropTypes.string
	    },
	    enumerable: true
	  }, {
	    key: 'contextTypes',
	    value: {
	      regionData: _react.PropTypes.object.isRequired
	    },
	    enumerable: true
	  }]);

	  return _default;
	})(_react.Component);

	exports['default'] = _default;
	module.exports = exports['default'];
	/* Prep */

/***/ }),
/* 989 */
/***/ (function(module, exports, __webpack_require__) {

	/* eslint react/no-multi-comp: 0 */
	
	'use strict';
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _componentsSelectConfiguration = __webpack_require__(77);
	
	var _componentsSelectConfiguration2 = _interopRequireDefault(_componentsSelectConfiguration);
	
	var _componentsSelectDeviceRole = __webpack_require__(78);
	
	var _componentsSelectDeviceRole2 = _interopRequireDefault(_componentsSelectDeviceRole);
	
	var _baseSlidesHtmlSlide = __webpack_require__(983);
	
	var _baseSlidesHtmlSlide2 = _interopRequireDefault(_baseSlidesHtmlSlide);
	
	var _baseSlidesHeadingSlide = __webpack_require__(205);
	
	var _baseSlidesHeadingSlide2 = _interopRequireDefault(_baseSlidesHeadingSlide);
	
	var _baseSlidesVideoSlide = __webpack_require__(160);
	
	var _baseSlidesVideoSlide2 = _interopRequireDefault(_baseSlidesVideoSlide);
	
	var _helpersMarkdownScript = __webpack_require__(9);
	
	var _helpersMarkdownScript2 = _interopRequireDefault(_helpersMarkdownScript);
	
	var _tech_prepMd = __webpack_require__(1519);
	
	var _tech_prepMd2 = _interopRequireDefault(_tech_prepMd);
	
	var techPrepMd = new _helpersMarkdownScript2['default'](_tech_prepMd2['default']);
	
	function selectConfiguration() {
	  return _react2['default'].createElement(
	    _spectaclePpa.Slide,
	    {
	      id: 'configuration',
	      textColor: 'white' },
	    _react2['default'].createElement(_componentsSelectConfiguration2['default'], null)
	  );
	}
	
	function connectingRemote(_ref) {
	  var configuration = _ref.configuration;
	  var regionData = _ref.regionData;
	
	  if (configuration === 'dualScreen') {
	    return (0, _baseSlidesHtmlSlide2['default'])({
	      id: 'connecting-remote',
	      html: techPrepMd.getSectionAsHtml('Connecting Remote', false, regionData)
	    });
	  } else {
	    return null;
	  }
	}
	
	function selectDeviceRole(configuration) {
	  if (configuration === 'dualScreen') {
	    return _react2['default'].createElement(
	      _spectaclePpa.Slide,
	      {
	        id: 'device-role',
	        textColor: 'white' },
	      _react2['default'].createElement(_componentsSelectDeviceRole2['default'], null)
	    );
	  } else {
	    return null;
	  }
	}
	
	function techCheckIntro(_ref2) {
	  var regionData = _ref2.regionData;
	
	  return (0, _baseSlidesHtmlSlide2['default'])({
	    id: 'tech-check-intro',
	    html: techPrepMd.getSectionAsHtml('Tech Check Intro', false, regionData)
	  });
	}
	
	function techCheckVideo(_ref3) {
	  var regionData = _ref3.regionData;
	
	  return (0, _baseSlidesVideoSlide2['default'])({
	    id: 'tech-check-video',
	    youTubeId: techPrepMd.getSectionMetadata('Tech Check Video', 'YouTube', regionData)
	  });
	}
	
	function levelPrep(_ref4) {
	  var configuration = _ref4.configuration;
	  var regionData = _ref4.regionData;
	
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'prep' },
	    selectConfiguration(),
	    connectingRemote({ configuration: configuration, regionData: regionData }),
	    selectDeviceRole(configuration),
	    techCheckIntro({ regionData: regionData }),
	    techCheckVideo({ regionData: regionData })
	  );
	}
	
	function levelCompletedPrep(_ref5) {
	  var configuration = _ref5.configuration;
	  var regionData = _ref5.regionData;
	
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'prep' },
	    selectConfiguration(),
	    connectingRemote({ configuration: configuration, regionData: regionData }),
	    selectDeviceRole(configuration)
	  );
	}
	
	function prepSection(_ref6) {
	  var level = _ref6.level;
	  var configuration = _ref6.configuration;
	  var regionData = _ref6.regionData;
	
	  switch (level) {
	    case '1':
	      return levelPrep({ configuration: configuration, regionData: regionData });
	    case 'completed':
	      return levelCompletedPrep({ configuration: configuration, regionData: regionData });
	    default:
	      return (0, _baseSlidesHeadingSlide2['default'])({ heading: 'Unknown' });
	  }
	}
	
	exports['default'] = prepSection;
	module.exports = exports['default'];
	/* Select Configuration */ /* Connecting Remote Instructions */ /* Select Device Role */ /* Tech Check Intro */ /* Tech Check Video */ /* Start Level */ /* Select Configuration */ /* Connecting Remote */ /* Select Device Role */

/***/ }),
/* 990 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _componentsTeamNames = __webpack_require__(60);
	
	var _componentsTeamNames2 = _interopRequireDefault(_componentsTeamNames);
	
	function teamCreationSection() {
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'team-creation' },
	    _react2['default'].createElement(
	      _spectaclePpa.Slide,
	      {
	        id: 'assign',
	        bgColor: 'black',
	        notes: '<h2>Assign Team Names</h2>',
	        teamNames: true },
	      _react2['default'].createElement(
	        'div',
	        { className: 'ui-slide' },
	        _react2['default'].createElement(
	          _spectaclePpa.Heading,
	          { size: 1 },
	          'Name your teams!'
	        ),
	        _react2['default'].createElement(_componentsTeamNames2['default'], null)
	      )
	    )
	  );
	}
	
	exports['default'] = teamCreationSection;
	module.exports = exports['default'];
	/* Enter team names */

/***/ }),
/* 991 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.preloadStart = preloadStart;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _imagesPpa_presentsSvg = __webpack_require__(2272);
	
	var _imagesPpa_presentsSvg2 = _interopRequireDefault(_imagesPpa_presentsSvg);
	
	var _imagesEmergencyPreparednessSquadGlowPng = __webpack_require__(853);
	
	var _imagesEmergencyPreparednessSquadGlowPng2 = _interopRequireDefault(_imagesEmergencyPreparednessSquadGlowPng);
	
	var _helpersMarkdownScript = __webpack_require__(9);
	
	var _helpersMarkdownScript2 = _interopRequireDefault(_helpersMarkdownScript);
	
	var _startMd = __webpack_require__(1520);
	
	var _startMd2 = _interopRequireDefault(_startMd);
	
	var md = new _helpersMarkdownScript2['default'](_startMd2['default']);
	
	function preloadStart() {
	  (0, _spectaclePpa.preloader)([_imagesEmergencyPreparednessSquadGlowPng2['default']]);
	}
	
	function startSection(_ref) {
	  var regionData = _ref.regionData;
	
	  /* Level intro graphic */
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'start' },
	    _react2['default'].createElement(
	      _spectaclePpa.Slide,
	      {
	        id: 'ppa-presents',
	        key: 'ppa-presents',
	        bgColor: 'black',
	        notes: md.getSubSectionAsHtml('Assembly Start', 'Notes', false, regionData) },
	      _react2['default'].createElement(
	        'div',
	        {
	          className: 'ui-slide' },
	        _react2['default'].createElement(
	          'div',
	          { className: 'flex-image' },
	          _react2['default'].createElement('img', {
	            className: 'heading-image heading-image-before',
	            src: _imagesPpa_presentsSvg2['default'] })
	        )
	      )
	    ),
	    _react2['default'].createElement(
	      _spectaclePpa.Slide,
	      {
	        id: 'ppa-eps',
	        bgColor: 'black',
	        notes: md.getSubSectionAsHtml('Assembly Start', 'Notes', false, regionData) },
	      _react2['default'].createElement(
	        'div',
	        {
	          className: 'ui-slide' },
	        _react2['default'].createElement(
	          'div',
	          { className: 'flex-image' },
	          _react2['default'].createElement('img', { className: 'eps-logo heading-image',
	            src: _imagesEmergencyPreparednessSquadGlowPng2['default'] })
	        )
	      )
	    )
	  );
	}
	
	exports['default'] = startSection;
	/* Sanksrit for Vanessa */ /* lokah samastah sukhino bhavantu */ /* may all beings everywhere be at peace */

/***/ }),
/* 992 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.preloadSong = preloadSong;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _baseSlidesVideoSlide = __webpack_require__(160);
	
	var _baseSlidesVideoSlide2 = _interopRequireDefault(_baseSlidesVideoSlide);
	
	var _baseSlidesBalloonSlide = __webpack_require__(84);
	
	var _baseSlidesBalloonSlide2 = _interopRequireDefault(_baseSlidesBalloonSlide);
	
	var _imagesCharactersApprenticePointingDiagonalPng = __webpack_require__(851);
	
	var _imagesCharactersApprenticePointingDiagonalPng2 = _interopRequireDefault(_imagesCharactersApprenticePointingDiagonalPng);
	
	var _imagesCharactersApprenticesFlexArmsPng = __webpack_require__(2263);
	
	var _imagesCharactersApprenticesFlexArmsPng2 = _interopRequireDefault(_imagesCharactersApprenticesFlexArmsPng);
	
	var _helpersMarkdownScript = __webpack_require__(9);
	
	var _helpersMarkdownScript2 = _interopRequireDefault(_helpersMarkdownScript);
	
	var _songMd = __webpack_require__(1521);
	
	var _songMd2 = _interopRequireDefault(_songMd);
	
	var md = new _helpersMarkdownScript2['default'](_songMd2['default']);
	
	function preloadSong() {
	  (0, _spectaclePpa.preloader)([_imagesCharactersApprenticePointingDiagonalPng2['default'], _imagesCharactersApprenticesFlexArmsPng2['default']]);
	}
	
	function songSection(_ref) {
	  var regionData = _ref.regionData;
	
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'song' },
	    (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'congratulations',
	      characterSide: 'right',
	      characterImage: _imagesCharactersApprenticesFlexArmsPng2['default'],
	      html: md.getSubSectionAsHtml('Congratulations', 'Content', false, regionData),
	      notes: md.getSubSectionAsHtml('Congratulations', 'Notes', false, regionData)
	    }),
	    (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'song-intro',
	      characterSide: 'right',
	      characterImage: _imagesCharactersApprenticePointingDiagonalPng2['default'],
	      html: md.getSubSectionAsHtml('Song Intro', 'Content', false, regionData),
	      notes: md.getSubSectionAsHtml('Song Intro', 'Notes', false, regionData)
	    }),
	    (0, _baseSlidesVideoSlide2['default'])({
	      id: 'song',
	      notes: md.getSubSectionAsHtml('Song', 'Notes', false, regionData),
	      youTubeId: md.getSectionMetadata('Song', 'YouTube', regionData)
	    })
	  );
	}
	
	exports['default'] = songSection;
	/* Congratulations */ /* Song intro */ /* Song */

/***/ }),
/* 993 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.preloadGameShow = preloadGameShow;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _baseSlidesBalloonSlide = __webpack_require__(84);
	
	var _baseSlidesBalloonSlide2 = _interopRequireDefault(_baseSlidesBalloonSlide);
	
	var _helpersMarkdownScript = __webpack_require__(9);
	
	var _helpersMarkdownScript2 = _interopRequireDefault(_helpersMarkdownScript);
	
	var _overviewMd = __webpack_require__(1522);
	
	var _overviewMd2 = _interopRequireDefault(_overviewMd);
	
	var _imagesCharactersApprenticePointingUpPng = __webpack_require__(403);
	
	var _imagesCharactersApprenticePointingUpPng2 = _interopRequireDefault(_imagesCharactersApprenticePointingUpPng);
	
	var md = new _helpersMarkdownScript2['default'](_overviewMd2['default']);
	
	function preloadGameShow() {
	  (0, _spectaclePpa.preloader)([_imagesCharactersApprenticePointingUpPng2['default']]);
	}
	
	function overviewSection(_ref) {
	  var regionData = _ref.regionData;
	
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'overview' },
	    (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'contents',
	      characterSide: 'right',
	      characterImage: _imagesCharactersApprenticePointingUpPng2['default'],
	      notes: md.getSubSectionAsHtml('Overview', 'Notes', false, regionData),
	      html: md.getSubSectionAsHtml('Overview', 'Content', false, regionData)
	    })
	  );
	}
	
	exports['default'] = overviewSection;

/***/ }),
/* 994 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.preloadGameShow = preloadGameShow;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _baseSlidesBalloonSlide = __webpack_require__(84);
	
	var _baseSlidesBalloonSlide2 = _interopRequireDefault(_baseSlidesBalloonSlide);
	
	var _helpersMarkdownScript = __webpack_require__(9);
	
	var _helpersMarkdownScript2 = _interopRequireDefault(_helpersMarkdownScript);
	
	var _teamIntroMd = __webpack_require__(1523);
	
	var _teamIntroMd2 = _interopRequireDefault(_teamIntroMd);
	
	var _imagesCharactersApprenticeHandsHipsPng = __webpack_require__(849);
	
	var _imagesCharactersApprenticeHandsHipsPng2 = _interopRequireDefault(_imagesCharactersApprenticeHandsHipsPng);
	
	var md = new _helpersMarkdownScript2['default'](_teamIntroMd2['default']);
	
	function preloadGameShow() {
	  (0, _spectaclePpa.preloader)([_imagesCharactersApprenticeHandsHipsPng2['default']]);
	}
	
	function teamIntroSection(_ref) {
	  var regionData = _ref.regionData;
	
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'team-intro' },
	    (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'get-into-teams',
	      characterSide: 'right',
	      characterImage: _imagesCharactersApprenticeHandsHipsPng2['default'],
	      notes: md.getSubSectionAsHtml('Get Into Your Teams', 'Notes', false, regionData),
	      html: md.getSubSectionAsHtml('Get Into Your Teams', 'Content', false, regionData)
	    })
	  );
	}
	
	exports['default'] = teamIntroSection;
	/* Get into teams  */

/***/ }),
/* 995 */
/***/ (function(module, exports, __webpack_require__) {

	/* eslint react/no-multi-comp: 0 */
	
	'use strict';
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.preloadClassActivity = preloadClassActivity;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _baseSlidesBalloonSlide = __webpack_require__(84);
	
	var _baseSlidesBalloonSlide2 = _interopRequireDefault(_baseSlidesBalloonSlide);
	
	var _baseSlidesVideoSlide = __webpack_require__(160);
	
	var _baseSlidesVideoSlide2 = _interopRequireDefault(_baseSlidesVideoSlide);
	
	var _imagesCharactersApprenticeHandsHips3Png = __webpack_require__(2259);
	
	var _imagesCharactersApprenticeHandsHips3Png2 = _interopRequireDefault(_imagesCharactersApprenticeHandsHips3Png);
	
	var _imagesCharactersApprenticeHandsHipsPng = __webpack_require__(849);
	
	var _imagesCharactersApprenticeHandsHipsPng2 = _interopRequireDefault(_imagesCharactersApprenticeHandsHipsPng);
	
	var _imagesCharactersApprenticePointingUp2Png = __webpack_require__(2260);
	
	var _imagesCharactersApprenticePointingUp2Png2 = _interopRequireDefault(_imagesCharactersApprenticePointingUp2Png);
	
	var _imagesCharactersApprenticesRowArmsFoldedPng = __webpack_require__(2265);
	
	var _imagesCharactersApprenticesRowArmsFoldedPng2 = _interopRequireDefault(_imagesCharactersApprenticesRowArmsFoldedPng);
	
	var _imagesCharactersApprenticeHandsHips2Png = __webpack_require__(850);
	
	var _imagesCharactersApprenticeHandsHips2Png2 = _interopRequireDefault(_imagesCharactersApprenticeHandsHips2Png);
	
	var _imagesCharactersApprenticePointingUpPng = __webpack_require__(403);
	
	var _imagesCharactersApprenticePointingUpPng2 = _interopRequireDefault(_imagesCharactersApprenticePointingUpPng);
	
	var _imagesCharactersApprenticesPairHandsHipsPng = __webpack_require__(852);
	
	var _imagesCharactersApprenticesPairHandsHipsPng2 = _interopRequireDefault(_imagesCharactersApprenticesPairHandsHipsPng);
	
	var _helpersMarkdownScript = __webpack_require__(9);
	
	var _helpersMarkdownScript2 = _interopRequireDefault(_helpersMarkdownScript);
	
	var _level1_superheroCalmingBreathMd = __webpack_require__(1524);
	
	var _level1_superheroCalmingBreathMd2 = _interopRequireDefault(_level1_superheroCalmingBreathMd);
	
	var md = new _helpersMarkdownScript2['default'](_level1_superheroCalmingBreathMd2['default']);
	
	function preloadClassActivity() {
	  (0, _spectaclePpa.preloader)([_imagesCharactersApprenticeHandsHips3Png2['default'], _imagesCharactersApprenticeHandsHipsPng2['default'], _imagesCharactersApprenticePointingUp2Png2['default'], _imagesCharactersApprenticesRowArmsFoldedPng2['default'], _imagesCharactersApprenticeHandsHips2Png2['default'], _imagesCharactersApprenticePointingUpPng2['default'], _imagesCharactersApprenticesPairHandsHipsPng2['default']]);
	}
	
	function superheroCalmingBreathSection(regionData) {
	  // Superhero Calming Breath
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'superhero-calming-breath' },
	    (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'part-1-intro',
	      characterSide: 'right',
	      characterImage: _imagesCharactersApprenticesPairHandsHipsPng2['default'],
	      notes: md.getSubSectionAsHtml('Part 1 Intro', 'Notes', false, regionData),
	      html: md.getSubSectionAsHtml('Part 1 Intro', 'Content', false, regionData)
	    }),
	    (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'climate-change-emergencies',
	      characterSide: 'right',
	      characterImage: _imagesCharactersApprenticePointingUp2Png2['default'],
	      notes: md.getSubSectionAsHtml('Climate Change Emergencies', 'Notes', false, regionData),
	      html: md.getSubSectionAsHtml('Climate Change Emergencies', 'Content', false, regionData)
	    }),
	    (0, _baseSlidesVideoSlide2['default'])({
	      id: 'song',
	      notes: md.getSubSectionAsHtml('Keep Cool Song', 'Notes', false, regionData),
	      youTubeId: md.getSectionMetadata('Keep Cool Song', 'YouTube', regionData),
	      lowRes: md.getSectionMetadata('Keep Cool Song', 'LowRes', regionData)
	    }),
	    (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'superhero-calming-breath-intro',
	      characterSide: 'left',
	      characterImage: _imagesCharactersApprenticeHandsHips3Png2['default'],
	      notes: md.getSubSectionAsHtml('Superhero Calming Breath', 'Notes', false, regionData),
	      html: md.getSubSectionAsHtml('Superhero Calming Breath', 'Content', false, regionData)
	    }),
	    (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'superhero-calming-breath-instructions',
	      characterSide: 'right',
	      characterImage: _imagesCharactersApprenticePointingUpPng2['default'],
	      notes: md.getSubSectionAsHtml('Superhero Calming Breath Instructions', 'Notes', false, regionData),
	      html: md.getSubSectionAsHtml('Superhero Calming Breath Instructions', 'Content', false, regionData)
	    }),
	    (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'surprise-test',
	      characterSide: 'right',
	      characterImage: _imagesCharactersApprenticeHandsHips2Png2['default'],
	      notes: md.getSubSectionAsHtml('Surprise Test', 'Notes', false, regionData),
	      html: md.getSubSectionAsHtml('Surprise Test', 'Content', false, regionData)
	    }),
	    (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'drop-cover-hold-on',
	      characterSide: 'left',
	      characterImage: _imagesCharactersApprenticesRowArmsFoldedPng2['default'],
	      notes: md.getSubSectionAsHtml('Drop Cover Hold On', 'Notes', false, regionData),
	      html: md.getSubSectionAsHtml('Drop Cover Hold On', 'Content', false, regionData)
	    })
	  );
	}
	
	exports['default'] = superheroCalmingBreathSection;
	/* Part 1 Intro */ /* Climate Change Emergencies */ /* Keep Cool Song */ /* Superhero Calming Breath */ /* Superhero Calming Breath Instructions */ /* Surprise Test */ /* Drop Cover Hold On */

/***/ }),
/* 996 */
/***/ (function(module, exports, __webpack_require__) {

	/* eslint react/no-multi-comp: 0 */
	
	'use strict';
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.preloadClassActivity = preloadClassActivity;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _baseSlidesBalloonSlide = __webpack_require__(84);
	
	var _baseSlidesBalloonSlide2 = _interopRequireDefault(_baseSlidesBalloonSlide);
	
	var _baseSlidesHeadingSlide = __webpack_require__(205);
	
	var _baseSlidesHeadingSlide2 = _interopRequireDefault(_baseSlidesHeadingSlide);
	
	var _imagesCharactersApprenticesPairArmsFoldedPng = __webpack_require__(2264);
	
	var _imagesCharactersApprenticesPairArmsFoldedPng2 = _interopRequireDefault(_imagesCharactersApprenticesPairArmsFoldedPng);
	
	var _imagesCharactersApprenticesPairHandsHipsPng = __webpack_require__(852);
	
	var _imagesCharactersApprenticesPairHandsHipsPng2 = _interopRequireDefault(_imagesCharactersApprenticesPairHandsHipsPng);
	
	var _imagesCharactersApprenticePointingDiagonalPng = __webpack_require__(851);
	
	var _imagesCharactersApprenticePointingDiagonalPng2 = _interopRequireDefault(_imagesCharactersApprenticePointingDiagonalPng);
	
	var _imagesCharactersApprenticePointingUpPng = __webpack_require__(403);
	
	var _imagesCharactersApprenticePointingUpPng2 = _interopRequireDefault(_imagesCharactersApprenticePointingUpPng);
	
	var _imagesCharactersApprenticesBackToBackPng = __webpack_require__(2262);
	
	var _imagesCharactersApprenticesBackToBackPng2 = _interopRequireDefault(_imagesCharactersApprenticesBackToBackPng);
	
	var _helpersMarkdownScript = __webpack_require__(9);
	
	var _helpersMarkdownScript2 = _interopRequireDefault(_helpersMarkdownScript);
	
	var _level1a_emergencyKitMd = __webpack_require__(1526);
	
	var _level1a_emergencyKitMd2 = _interopRequireDefault(_level1a_emergencyKitMd);
	
	var _level1b_makeAPlanMd = __webpack_require__(1527);
	
	var _level1b_makeAPlanMd2 = _interopRequireDefault(_level1b_makeAPlanMd);
	
	var levels = {
	  '1a': { md: new _helpersMarkdownScript2['default'](_level1a_emergencyKitMd2['default']) },
	  '1b': { md: new _helpersMarkdownScript2['default'](_level1b_makeAPlanMd2['default']) }
	};
	
	function preloadClassActivity() {
	  (0, _spectaclePpa.preloader)([_imagesCharactersApprenticesPairArmsFoldedPng2['default'], _imagesCharactersApprenticesPairHandsHipsPng2['default'], _imagesCharactersApprenticePointingDiagonalPng2['default'], _imagesCharactersApprenticePointingUpPng2['default'], _imagesCharactersApprenticesBackToBackPng2['default']]);
	}
	
	function sizzle(level, regionData) {
	  var md = levels[level].md;
	  return (0, _baseSlidesBalloonSlide2['default'])({
	    id: 'sizzle',
	    characterSide: 'right',
	    characterImage: _imagesCharactersApprenticePointingUpPng2['default'],
	    notes: md.getSubSectionAsHtml('Sizzle', 'Notes', false, regionData),
	    html: md.getSubSectionAsHtml('Sizzle', 'Content', false, regionData)
	  });
	}
	
	function instructions(level, regionData) {
	  var md = levels[level].md;
	  return (0, _baseSlidesBalloonSlide2['default'])({
	    id: 'instructions',
	    characterSide: 'left',
	    characterImage: _imagesCharactersApprenticesPairHandsHipsPng2['default'],
	    notes: md.getSubSectionAsHtml('Instructions', 'Notes', false, regionData),
	    html: md.getSubSectionAsHtml('Instructions', 'Content', false, regionData)
	  });
	}
	
	function answers(level, regionData) {
	  var md = levels[level].md;
	  return (0, _baseSlidesBalloonSlide2['default'])({
	    id: 'answers',
	    characterSide: 'right',
	    characterImage: _imagesCharactersApprenticesPairArmsFoldedPng2['default'],
	    notes: md.getSubSectionAsHtml('Answers', 'Notes', false, regionData),
	    html: md.getSubSectionAsHtml('Answers', 'Content', false, regionData)
	  });
	}
	
	function level1a(regionData) {
	  // Emergency Kit
	  var level = '1a';
	  var md = levels[level].md;
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'class-activity-' + level },
	    sizzle(level, regionData),
	    instructions(level, regionData),
	    (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'time-up',
	      characterSide: 'right',
	      characterImage: _imagesCharactersApprenticePointingDiagonalPng2['default'],
	      notes: md.getSubSectionAsHtml('Time Up', 'Notes', false, regionData),
	      html: md.getSubSectionAsHtml('Time Up', 'Content', false, regionData)
	    }),
	    (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'collate-lists',
	      characterSide: 'left',
	      characterImage: _imagesCharactersApprenticesBackToBackPng2['default'],
	      notes: md.getSubSectionAsHtml('Collate Lists', 'Notes', false, regionData),
	      html: md.getSubSectionAsHtml('Collate Lists', 'Content', false, regionData)
	    }),
	    answers(level, regionData)
	  );
	}
	
	function level1b(regionData) {
	  // Popcorn Joys
	  var level = '1b';
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'class-activity-' + level },
	    sizzle(level, regionData),
	    instructions(level, regionData),
	    answers(level, regionData)
	  );
	}
	
	function classActivitySection(_ref) {
	  var level = _ref.level;
	  var subActivity = _ref.subActivity;
	  var regionData = _ref.regionData;
	
	  switch ('' + level + (subActivity ? subActivity : '')) {
	    case '1a':
	      return level1a(regionData);
	    case '1b':
	      return level1b(regionData);
	    default:
	      return (0, _baseSlidesHeadingSlide2['default'])({ heading: 'Unknown' });
	  }
	}
	
	exports['default'] = classActivitySection;
	/* Sizzle */ /* Instructions */ /* Time's Up! */ /* Collate lists */ /* Answers */ /* Sizzle */ /* Instructions */ /* Answers */

/***/ }),
/* 997 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.preloadMissionAssignment = preloadMissionAssignment;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _baseSlidesHeadingSlide = __webpack_require__(205);
	
	var _baseSlidesHeadingSlide2 = _interopRequireDefault(_baseSlidesHeadingSlide);
	
	var _baseSlidesBalloonSlide = __webpack_require__(84);
	
	var _baseSlidesBalloonSlide2 = _interopRequireDefault(_baseSlidesBalloonSlide);
	
	var _imagesEmergencyPreparednessSquadGlowPng = __webpack_require__(853);
	
	var _imagesEmergencyPreparednessSquadGlowPng2 = _interopRequireDefault(_imagesEmergencyPreparednessSquadGlowPng);
	
	var _imagesCharactersApprenticeFistUpPng = __webpack_require__(848);
	
	var _imagesCharactersApprenticeFistUpPng2 = _interopRequireDefault(_imagesCharactersApprenticeFistUpPng);
	
	var _helpersMarkdownScript = __webpack_require__(9);
	
	var _helpersMarkdownScript2 = _interopRequireDefault(_helpersMarkdownScript);
	
	var _level1_assemblyMissionMd = __webpack_require__(1528);
	
	var _level1_assemblyMissionMd2 = _interopRequireDefault(_level1_assemblyMissionMd);
	
	var levels = {
	  '1': { md: new _helpersMarkdownScript2['default'](_level1_assemblyMissionMd2['default']) }
	};
	
	function preloadMissionAssignment() {
	  (0, _spectaclePpa.preloader)([_imagesEmergencyPreparednessSquadGlowPng2['default'], _imagesCharactersApprenticeFistUpPng2['default']]);
	}
	
	function missionAssignmentSection(_ref) {
	  var level = _ref.level;
	  var regionData = _ref.regionData;
	
	  var md = levels[level].md;
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'mission-assignment' },
	    (0, _baseSlidesHeadingSlide2['default'])({
	      id: 'sizzle',
	      beforeImage: _imagesEmergencyPreparednessSquadGlowPng2['default'],
	      subHeading: 'Your Mission',
	      notes: md.getSubSectionAsHtml('Mission Assignment', 'Notes', false, regionData),
	      bgColor: 'black'
	    }),
	    (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'instructions',
	      characterSide: 'right',
	      characterImage: _imagesCharactersApprenticeFistUpPng2['default'],
	      notes: md.getSubSectionAsHtml('Instructions', 'Notes', false, regionData),
	      html: md.getSubSectionAsHtml('Instructions', 'Content', false, regionData)
	    })
	  );
	}
	
	exports['default'] = missionAssignmentSection;
	/* Sizzle */ /* Mission Instructions */

/***/ }),
/* 998 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.preloadFinish = preloadFinish;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _componentsCompleteLevelButton = __webpack_require__(44);
	
	var _componentsCompleteLevelButton2 = _interopRequireDefault(_componentsCompleteLevelButton);
	
	var _baseSlidesVideoSlide = __webpack_require__(160);
	
	var _baseSlidesVideoSlide2 = _interopRequireDefault(_baseSlidesVideoSlide);
	
	var _helpersMarkdownScript = __webpack_require__(9);
	
	var _helpersMarkdownScript2 = _interopRequireDefault(_helpersMarkdownScript);
	
	var _finishMd = __webpack_require__(1529);
	
	var _finishMd2 = _interopRequireDefault(_finishMd);
	
	var md = new _helpersMarkdownScript2['default'](_finishMd2['default']);
	
	function preloadFinish() {
	  (0, _spectaclePpa.preloader)([imgLevel1Complete]);
	}
	
	function finishSection(_ref) {
	  var regionData = _ref.regionData;
	
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'finish' },
	    (0, _baseSlidesVideoSlide2['default'])({
	      id: 'song-repeat',
	      notes: md.getSubSectionAsHtml('Song', 'Notes', false, regionData),
	      youTubeId: md.getSectionMetadata('Song', 'YouTube', regionData),
	      lowRes: md.getSectionMetadata('Song', 'LowRes', regionData)
	    }),
	    _react2['default'].createElement(
	      _spectaclePpa.Slide,
	      {
	        id: 'level-completed',
	        notes: '<h2>Assembly Level Finished</h2>',
	        bgColor: 'transparent',
	        finish: true },
	      _react2['default'].createElement(
	        'div',
	        { className: 'level-complete' },
	        _react2['default'].createElement(
	          'div',
	          { className: 'level-complete-content' },
	          _react2['default'].createElement(
	            _spectaclePpa.Heading,
	            { size: 2 },
	            'Assembly Complete'
	          ),
	          _react2['default'].createElement(_componentsCompleteLevelButton2['default'], null)
	        )
	      )
	    )
	  );
	}
	
	exports['default'] = finishSection;
	/* Song */ /* Level complete */

/***/ }),
/* 999 */
/***/ (function(module, exports) {

	/* eslint-disable object-shorthand */
	'use strict';
	
	var colors = {
	  primary: '#37bad5',
	  secondary: 'black',
	  tertiary: 'white',
	  level1: '#ffbc00',
	  level2: '#8f288c',
	  level3: '#26a7df',
	  level4: '#e80a89',
	  level5: '#f59122',
	  level6: '#37b34a',
	  gameshow: '#742CBF',
	  question: '#45B3EC',
	  answer: '#6FC36E'
	};
	
	var fonts = {
	  primary: 'BrandonTextWeb',
	  secondary: 'Orbitron',
	  tertiary: 'Ubuntu'
	};
	
	module.exports = {
	  colors: colors,
	  fonts: fonts,
	  global: {
	    body: {
	      background: 'transparent',
	      fontFamily: fonts.primary,
	      fontWeight: 'normal',
	      fontSize: '2em',
	      color: colors.primary,
	      overflow: 'hidden'
	    },
	    'html, body': {
	      // height: '100%'
	    },
	    '*': {
	      boxSizing: 'border-box'
	    },
	    input: {
	      color: 'black',
	      fontWeight: 'bold',
	      backgroundColor: 'white',
	      fontSize: '2.66em',
	      fontFamily: fonts.primary,
	      padding: '0.25em 0.25em 0.2em',
	      margin: '1% 1% 3%',
	      width: '98%'
	    },
	    label: {
	      color: 'white',
	      fontWeight: 'bold',
	      fontSize: '1.8em',
	      margin: '0.1em 0 0'
	    }
	  },
	  progress: {
	    bar: {
	      container: {
	        position: 'absolute',
	        height: '22px',
	        width: '100%',
	        bottom: 0,
	        left: 0,
	        transition: 'all 1s ease-in-out 0.2s',
	        zIndex: 1000
	      },
	      bar: {
	        height: '100%',
	        background: colors.primary,
	        transition: 'all 0.3s ease-out',
	        fontSize: '12px',
	        letterSpacing: '0.1em',
	        textTransform: 'uppercase',
	        padding: '4px',
	        textAlign: 'right'
	      }
	    },
	    number: {
	      container: {
	        position: 'absolute',
	        bottom: 10,
	        right: 10,
	        zIndex: 1000,
	        color: colors.tertiary
	      }
	    }
	  },
	  components: {
	    codePane: {
	      pre: {
	        margin: 'auto',
	        fontSize: '1em',
	        fontWeight: 'normal',
	        fontFamily: fonts.tertiary,
	        minWidth: '100%',
	        maxWidth: 800
	      },
	      code: {
	        textAlign: 'left',
	        padding: 20,
	        fontWeight: 'normal'
	      }
	    },
	    code: {
	      color: 'black',
	      fontSize: '2.66em',
	      fontFamily: fonts.tertiary,
	      margin: '0.25em auto',
	      backgroundColor: 'rgba(0,0,0,0.15)',
	      padding: '0 10px',
	      borderRadius: 3
	    },
	    heading: {},
	    link: {
	      textDecoration: 'none'
	    },
	    listItem: {
	      fontSize: '2.66em',
	      padding: '0 0 0.5em'
	    },
	    list: {
	      textAlign: 'center',
	      listStyle: 'none',
	      padding: '0.5em 0'
	    },
	    s: {
	      strikethrough: {}
	    },
	    text: {
	      color: 'black',
	      fontSize: '2.66em',
	      fontFamily: fonts.primary,
	      margin: '0.25em auto',
	      textShadow: '0 0 10px rgba(0,0,0,0.2)'
	    }
	  }
	};

/***/ }),
/* 1000 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = __webpack_require__(7)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	function htmlSlide(_ref) {
	  var id = _ref.id;
	  var notes = _ref.notes;
	  var heading = _ref.heading;
	  var bgColor = _ref.bgColor;
	  var subHeading = _ref.subHeading;
	  var html = _ref.html;
	  var slideClass = _ref.slideClass;
	
	  var slideContentClass = slideClass ? ' slide-' + slideClass : '';
	  var bgColorOpts = {};
	  if (bgColor) {
	    bgColorOpts.bgColor = bgColor;
	  }
	  return _react2['default'].createElement(
	    _spectaclePpa.Slide,
	    _extends({
	      id: id,
	      key: id
	    }, bgColorOpts, {
	      notes: notes,
	      textColor: 'white' }),
	    _react2['default'].createElement(
	      'div',
	      { className: 'slide-content' + slideContentClass },
	      _react2['default'].createElement(
	        'div',
	        {
	          className: 'text-formatted' },
	        !!heading && _react2['default'].createElement(
	          _spectaclePpa.Heading,
	          { size: 3 },
	          heading
	        ),
	        !!subHeading && _react2['default'].createElement(
	          _spectaclePpa.Heading,
	          { size: 5 },
	          subHeading
	        ),
	        _react2['default'].createElement('div', {
	          dangerouslySetInnerHTML: { __html: html } })
	      )
	    )
	  );
	}
	
	exports['default'] = htmlSlide;
	module.exports = exports['default'];

/***/ }),
/* 1001 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = {
	  width: 1000,
	  height: 700,
	  margin: 40,
	  theme: __webpack_require__(1011),
	  print: __webpack_require__(53),
	  html: __webpack_require__(52)
	};

/***/ }),
/* 1002 */
/***/ (function(module, exports, __webpack_require__) {

	/* eslint no-console: 0 */
	
	'use strict';
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _helpersMarkdownScript = __webpack_require__(9);
	
	var _helpersMarkdownScript2 = _interopRequireDefault(_helpersMarkdownScript);
	
	var _indexMd = __webpack_require__(247);
	
	var _indexMd2 = _interopRequireDefault(_indexMd);
	
	var _extensionActivitiesExtensionActivitiesMd = __webpack_require__(1530);
	
	var _extensionActivitiesExtensionActivitiesMd2 = _interopRequireDefault(_extensionActivitiesExtensionActivitiesMd);
	
	var _programPrepProgramPrepMd = __webpack_require__(1533);
	
	var _programPrepProgramPrepMd2 = _interopRequireDefault(_programPrepProgramPrepMd);
	
	var _sections00_prepLevel1_prepMd = __webpack_require__(1534);
	
	var _sections00_prepLevel1_prepMd2 = _interopRequireDefault(_sections00_prepLevel1_prepMd);
	
	var _sections00_prepLevel2_prepMd = __webpack_require__(1535);
	
	var _sections00_prepLevel2_prepMd2 = _interopRequireDefault(_sections00_prepLevel2_prepMd);
	
	var _sections00_prepLevel3_prepMd = __webpack_require__(1536);
	
	var _sections00_prepLevel3_prepMd2 = _interopRequireDefault(_sections00_prepLevel3_prepMd);
	
	var _funMd = __webpack_require__(1531);
	
	var _funMd2 = _interopRequireDefault(_funMd);
	
	var _imagesEmergencyPreparednessSquadPng = __webpack_require__(2282);
	
	var _imagesEmergencyPreparednessSquadPng2 = _interopRequireDefault(_imagesEmergencyPreparednessSquadPng);
	
	var _imagesEmergencyPreparednessSquadTrialPng = __webpack_require__(2284);
	
	var _imagesEmergencyPreparednessSquadTrialPng2 = _interopRequireDefault(_imagesEmergencyPreparednessSquadTrialPng);
	
	var _imagesEmergencyPreparednessSquadExpiredPng = __webpack_require__(2283);
	
	var _imagesEmergencyPreparednessSquadExpiredPng2 = _interopRequireDefault(_imagesEmergencyPreparednessSquadExpiredPng);
	
	var _config = __webpack_require__(1001);
	
	var _config2 = _interopRequireDefault(_config);
	
	// Preload image functions
	
	var _sections20_gameShowGameShowSection = __webpack_require__(206);
	
	__webpack_require__(2186);
	
	var md = new _helpersMarkdownScript2['default'](_indexMd2['default']);
	
	var levels = {
	  prep: {
	    deck: __webpack_require__(1007)
	  },
	  1: {
	    thumbnail: __webpack_require__(408),
	    overviewThumbnail: __webpack_require__(2286),
	    deck: __webpack_require__(1003),
	    prep: new _helpersMarkdownScript2['default'](_sections00_prepLevel1_prepMd2['default']),
	    levelName: 'Make a Plan'
	  },
	  2: {
	    thumbnail: __webpack_require__(409),
	    overviewThumbnail: __webpack_require__(2287),
	    deck: __webpack_require__(1004),
	    prep: new _helpersMarkdownScript2['default'](_sections00_prepLevel2_prepMd2['default']),
	    levelName: 'Get a Kit'
	  },
	  3: {
	    thumbnail: __webpack_require__(861),
	    overviewThumbnail: __webpack_require__(2288),
	    deck: __webpack_require__(1005),
	    prep: new _helpersMarkdownScript2['default'](_sections00_prepLevel3_prepMd2['default']),
	    levelName: "We're In This Together"
	  },
	  completed: {
	    deck: __webpack_require__(1006)
	  }
	};
	
	var program = {
	  id: 'epsHybridIntermediates',
	  title: md.getSectionAsString('Title - Short'),
	  longTitle: md.getSectionAsString('Title - Long'),
	  thumbnailImage: _imagesEmergencyPreparednessSquadPng2['default'],
	  trialImageThumb: _imagesEmergencyPreparednessSquadTrialPng2['default'],
	  expiredImageThumb: _imagesEmergencyPreparednessSquadExpiredPng2['default'],
	  longDescription: md.getSectionAsString('Description - Long'),
	  shortDescription: md.getSectionAsString('Description - Short'),
	  levelsDescription: md.getSectionAsString('Description - Levels'),
	  levels: levels,
	  extensionActivitiesMd: new _helpersMarkdownScript2['default'](_extensionActivitiesExtensionActivitiesMd2['default']),
	  programPrepMd: new _helpersMarkdownScript2['default'](_programPrepProgramPrepMd2['default']),
	  funMd: new _helpersMarkdownScript2['default'](_funMd2['default']),
	  preload: function preload(_ref) {
	    var level = _ref.level;
	
	    console.log('Preloading assets for Level ' + level);
	
	    (0, _sections20_gameShowGameShowSection.preloadGameShow)();
	  },
	  config: _config2['default'],
	  featuredOnly: true
	};
	
	exports['default'] = program;
	module.exports = exports['default'];

/***/ }),
/* 1003 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(__filename) {'use strict';
	
	var _get = __webpack_require__(8)['default'];
	
	var _inherits = __webpack_require__(5)['default'];
	
	var _createClass = __webpack_require__(6)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _helpersMarkdownScript = __webpack_require__(9);
	
	var _helpersMarkdownScript2 = _interopRequireDefault(_helpersMarkdownScript);
	
	var _indexMd = __webpack_require__(247);
	
	var _indexMd2 = _interopRequireDefault(_indexMd);
	
	var _sections01_startStartSection = __webpack_require__(280);
	
	var _sections01_startStartSection2 = _interopRequireDefault(_sections01_startStartSection);
	
	var _sections03_songSongSection = __webpack_require__(281);
	
	var _sections03_songSongSection2 = _interopRequireDefault(_sections03_songSongSection);
	
	var _sections10_teamCreationTeamCreationSection = __webpack_require__(1009);
	
	var _sections10_teamCreationTeamCreationSection2 = _interopRequireDefault(_sections10_teamCreationTeamCreationSection);
	
	var _sections11_esGooberStoryEsGooberStorySection = __webpack_require__(282);
	
	var _sections11_esGooberStoryEsGooberStorySection2 = _interopRequireDefault(_sections11_esGooberStoryEsGooberStorySection);
	
	var _sections12_missionReportMissionReportSection = __webpack_require__(283);
	
	var _sections12_missionReportMissionReportSection2 = _interopRequireDefault(_sections12_missionReportMissionReportSection);
	
	var _sections20_gameShowGameShowSection = __webpack_require__(206);
	
	var _sections20_gameShowGameShowSection2 = _interopRequireDefault(_sections20_gameShowGameShowSection);
	
	var _sections30_classActivityClassActivitySection = __webpack_require__(284);
	
	var _sections30_classActivityClassActivitySection2 = _interopRequireDefault(_sections30_classActivityClassActivitySection);
	
	var _sections70_missionAssignmentMissionAssignmentSection = __webpack_require__(285);
	
	var _sections70_missionAssignmentMissionAssignmentSection2 = _interopRequireDefault(_sections70_missionAssignmentMissionAssignmentSection);
	
	var _sections90_finishFinishSection = __webpack_require__(286);
	
	var _sections90_finishFinishSection2 = _interopRequireDefault(_sections90_finishFinishSection);
	
	var md = new _helpersMarkdownScript2['default'](_indexMd2['default']);
	var level = Number(__filename.replace(/^.*level/, '').replace('.jsx', ''));
	var title = md.getSectionMetadata('Level ' + level, 'Title');
	
	var _default = (function (_Component) {
	  _inherits(_default, _Component);
	
	  function _default() {
	    _classCallCheck(this, _default);
	
	    _get(Object.getPrototypeOf(_default.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(_default, [{
	    key: 'render',
	    value: function render() {
	      var regionData = this.context.regionData;
	
	      return _react2['default'].createElement(
	        _spectaclePpa.Deck,
	        { transition: ['slide'],
	          transitionDuration: 800,
	          progress: 'bar' },
	        (0, _sections01_startStartSection2['default'])({ level: level, title: title, regionData: regionData }),
	        (0, _sections03_songSongSection2['default'])({ level: level, regionData: regionData }),
	        (0, _sections10_teamCreationTeamCreationSection2['default'])({ regionData: regionData }),
	        (0, _sections12_missionReportMissionReportSection2['default'])({ level: level, regionData: regionData }),
	        (0, _sections11_esGooberStoryEsGooberStorySection2['default'])({ level: level, regionData: regionData }),
	        (0, _sections20_gameShowGameShowSection2['default'])({ level: level, regionData: regionData }),
	        (0, _sections30_classActivityClassActivitySection2['default'])({ level: level, regionData: regionData }),
	        (0, _sections70_missionAssignmentMissionAssignmentSection2['default'])({ level: level, title: title, regionData: regionData }),
	        (0, _sections90_finishFinishSection2['default'])({ level: level, regionData: regionData })
	      );
	    }
	  }], [{
	    key: 'contextTypes',
	    value: {
	      regionData: _react.PropTypes.object.isRequired
	    },
	    enumerable: true
	  }, {
	    key: 'metadata',
	    value: {
	      title: title
	    },
	    enumerable: true
	  }]);

	  return _default;
	})(_react.Component);

	exports['default'] = _default;
	module.exports = exports['default'];
	/* Start */ /* Theme Song */ /* Team Creation and Introduction */ /* Mission Report */ /* Esmeralda & Goober Story */ /* Game Show */ /* Class Activity: Floorplan */ /* Mission Assignment */ /* Finish */
	/* WEBPACK VAR INJECTION */}.call(exports, "programs/epsHybridIntermediates/level1.jsx"))

/***/ }),
/* 1004 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(__filename) {'use strict';
	
	var _get = __webpack_require__(8)['default'];
	
	var _inherits = __webpack_require__(5)['default'];
	
	var _createClass = __webpack_require__(6)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _helpersMarkdownScript = __webpack_require__(9);
	
	var _helpersMarkdownScript2 = _interopRequireDefault(_helpersMarkdownScript);
	
	var _indexMd = __webpack_require__(247);
	
	var _indexMd2 = _interopRequireDefault(_indexMd);
	
	var _sections01_startStartSection = __webpack_require__(280);
	
	var _sections01_startStartSection2 = _interopRequireDefault(_sections01_startStartSection);
	
	var _sections03_songSongSection = __webpack_require__(281);
	
	var _sections03_songSongSection2 = _interopRequireDefault(_sections03_songSongSection);
	
	var _sections11_esGooberStoryEsGooberStorySection = __webpack_require__(282);
	
	var _sections11_esGooberStoryEsGooberStorySection2 = _interopRequireDefault(_sections11_esGooberStoryEsGooberStorySection);
	
	var _sections12_missionReportMissionReportSection = __webpack_require__(283);
	
	var _sections12_missionReportMissionReportSection2 = _interopRequireDefault(_sections12_missionReportMissionReportSection);
	
	var _sections20_gameShowGameShowSection = __webpack_require__(206);
	
	var _sections20_gameShowGameShowSection2 = _interopRequireDefault(_sections20_gameShowGameShowSection);
	
	var _sections30_classActivityClassActivitySection = __webpack_require__(284);
	
	var _sections30_classActivityClassActivitySection2 = _interopRequireDefault(_sections30_classActivityClassActivitySection);
	
	var _sections70_missionAssignmentMissionAssignmentSection = __webpack_require__(285);
	
	var _sections70_missionAssignmentMissionAssignmentSection2 = _interopRequireDefault(_sections70_missionAssignmentMissionAssignmentSection);
	
	var _sections90_finishFinishSection = __webpack_require__(286);
	
	var _sections90_finishFinishSection2 = _interopRequireDefault(_sections90_finishFinishSection);
	
	var md = new _helpersMarkdownScript2['default'](_indexMd2['default']);
	var level = Number(__filename.replace(/^.*level/, '').replace('.jsx', ''));
	var title = md.getSectionMetadata('Level ' + level, 'Title');
	
	var _default = (function (_Component) {
	  _inherits(_default, _Component);
	
	  function _default() {
	    _classCallCheck(this, _default);
	
	    _get(Object.getPrototypeOf(_default.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(_default, [{
	    key: 'render',
	    value: function render() {
	      var regionData = this.context.regionData;
	
	      return _react2['default'].createElement(
	        _spectaclePpa.Deck,
	        { transition: ['slide'],
	          transitionDuration: 800,
	          progress: 'bar' },
	        (0, _sections01_startStartSection2['default'])({ level: level, title: title, regionData: regionData }),
	        (0, _sections03_songSongSection2['default'])({ level: level, regionData: regionData }),
	        (0, _sections11_esGooberStoryEsGooberStorySection2['default'])({ level: level, regionData: regionData }),
	        (0, _sections12_missionReportMissionReportSection2['default'])({ level: level, regionData: regionData }),
	        (0, _sections20_gameShowGameShowSection2['default'])({ level: level, regionData: regionData }),
	        (0, _sections30_classActivityClassActivitySection2['default'])({ level: level, regionData: regionData }),
	        (0, _sections70_missionAssignmentMissionAssignmentSection2['default'])({ level: level, title: title, regionData: regionData }),
	        (0, _sections90_finishFinishSection2['default'])({ level: level, regionData: regionData })
	      );
	    }
	  }], [{
	    key: 'contextTypes',
	    value: {
	      regionData: _react.PropTypes.object.isRequired
	    },
	    enumerable: true
	  }, {
	    key: 'metadata',
	    value: {
	      title: title
	    },
	    enumerable: true
	  }]);

	  return _default;
	})(_react.Component);

	exports['default'] = _default;
	module.exports = exports['default'];
	/* Start */ /* Theme Song */ /* Esmeralda & Goober Story */ /* Mission Report */ /* Game Show */ /* Class Activity: Kit rap */ /* Mission Assignment */ /* Finish */
	/* WEBPACK VAR INJECTION */}.call(exports, "programs/epsHybridIntermediates/level2.jsx"))

/***/ }),
/* 1005 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(__filename) {'use strict';
	
	var _get = __webpack_require__(8)['default'];
	
	var _inherits = __webpack_require__(5)['default'];
	
	var _createClass = __webpack_require__(6)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _helpersMarkdownScript = __webpack_require__(9);
	
	var _helpersMarkdownScript2 = _interopRequireDefault(_helpersMarkdownScript);
	
	var _indexMd = __webpack_require__(247);
	
	var _indexMd2 = _interopRequireDefault(_indexMd);
	
	var _sections01_startStartSection = __webpack_require__(280);
	
	var _sections01_startStartSection2 = _interopRequireDefault(_sections01_startStartSection);
	
	var _sections03_songSongSection = __webpack_require__(281);
	
	var _sections03_songSongSection2 = _interopRequireDefault(_sections03_songSongSection);
	
	var _sections11_esGooberStoryEsGooberStorySection = __webpack_require__(282);
	
	var _sections11_esGooberStoryEsGooberStorySection2 = _interopRequireDefault(_sections11_esGooberStoryEsGooberStorySection);
	
	var _sections12_missionReportMissionReportSection = __webpack_require__(283);
	
	var _sections12_missionReportMissionReportSection2 = _interopRequireDefault(_sections12_missionReportMissionReportSection);
	
	var _sections20_gameShowGameShowSection = __webpack_require__(206);
	
	var _sections20_gameShowGameShowSection2 = _interopRequireDefault(_sections20_gameShowGameShowSection);
	
	var _sections30_classActivityClassActivitySection = __webpack_require__(284);
	
	var _sections30_classActivityClassActivitySection2 = _interopRequireDefault(_sections30_classActivityClassActivitySection);
	
	var _sections70_missionAssignmentMissionAssignmentSection = __webpack_require__(285);
	
	var _sections70_missionAssignmentMissionAssignmentSection2 = _interopRequireDefault(_sections70_missionAssignmentMissionAssignmentSection);
	
	var _sections95_endingEndingSection = __webpack_require__(1010);
	
	var _sections95_endingEndingSection2 = _interopRequireDefault(_sections95_endingEndingSection);
	
	var _sections90_finishFinishSection = __webpack_require__(286);
	
	var _sections90_finishFinishSection2 = _interopRequireDefault(_sections90_finishFinishSection);
	
	var md = new _helpersMarkdownScript2['default'](_indexMd2['default']);
	var level = Number(__filename.replace(/^.*level/, '').replace('.jsx', ''));
	var title = md.getSectionMetadata('Level ' + level, 'Title');
	
	var _default = (function (_Component) {
	  _inherits(_default, _Component);
	
	  function _default() {
	    _classCallCheck(this, _default);
	
	    _get(Object.getPrototypeOf(_default.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(_default, [{
	    key: 'render',
	    value: function render() {
	      var regionData = this.context.regionData;
	
	      return _react2['default'].createElement(
	        _spectaclePpa.Deck,
	        { transition: ['slide'],
	          transitionDuration: 800,
	          progress: 'bar' },
	        (0, _sections01_startStartSection2['default'])({ level: level, title: title, regionData: regionData }),
	        (0, _sections03_songSongSection2['default'])({ level: level, regionData: regionData }),
	        (0, _sections12_missionReportMissionReportSection2['default'])({ level: level, regionData: regionData }),
	        (0, _sections11_esGooberStoryEsGooberStorySection2['default'])({ level: level, regionData: regionData }),
	        (0, _sections20_gameShowGameShowSection2['default'])({ level: level, regionData: regionData }),
	        (0, _sections30_classActivityClassActivitySection2['default'])({ level: level, title: title, regionData: regionData }),
	        (0, _sections95_endingEndingSection2['default'])({ regionData: regionData }),
	        (0, _sections70_missionAssignmentMissionAssignmentSection2['default'])({ level: level, title: title, regionData: regionData }),
	        (0, _sections90_finishFinishSection2['default'])({ level: level, regionData: regionData })
	      );
	    }
	  }], [{
	    key: 'contextTypes',
	    value: {
	      regionData: _react.PropTypes.object.isRequired
	    },
	    enumerable: true
	  }, {
	    key: 'metadata',
	    value: {
	      title: title
	    },
	    enumerable: true
	  }]);

	  return _default;
	})(_react.Component);

	exports['default'] = _default;
	module.exports = exports['default'];
	/* Start */ /* Theme Song */ /* Mission Report */ /* Esmeralda & Goober Story */ /* Game Show */ /* Class Activity: Drawing */ /* Ending */ /* Mission Assignment */ /* Finish */
	/* WEBPACK VAR INJECTION */}.call(exports, "programs/epsHybridIntermediates/level3.jsx"))

/***/ }),
/* 1006 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _get = __webpack_require__(8)['default'];
	
	var _inherits = __webpack_require__(5)['default'];
	
	var _createClass = __webpack_require__(6)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _baseSlidesBalloonSlide = __webpack_require__(85);
	
	var _baseSlidesBalloonSlide2 = _interopRequireDefault(_baseSlidesBalloonSlide);
	
	var _imagesCharactersSara_gigglePng = __webpack_require__(858);
	
	var _imagesCharactersSara_gigglePng2 = _interopRequireDefault(_imagesCharactersSara_gigglePng);
	
	var _helpersMarkdownScript = __webpack_require__(9);
	
	var _helpersMarkdownScript2 = _interopRequireDefault(_helpersMarkdownScript);
	
	var _levelCompletedMd = __webpack_require__(1532);
	
	var _levelCompletedMd2 = _interopRequireDefault(_levelCompletedMd);
	
	var md = new _helpersMarkdownScript2['default'](_levelCompletedMd2['default']);
	
	var _default = (function (_Component) {
	  _inherits(_default, _Component);
	
	  function _default() {
	    _classCallCheck(this, _default);
	
	    _get(Object.getPrototypeOf(_default.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(_default, [{
	    key: 'render',
	    value: function render() {
	      var regionData = this.context.regionData;
	
	      return _react2['default'].createElement(
	        _spectaclePpa.Deck,
	        { transition: ['slide'],
	          transitionDuration: 800,
	          progress: 'bar' },
	        (0, _baseSlidesBalloonSlide2['default'])({
	          id: 'welcome-back',
	          characterSide: 'right',
	          characterImage: _imagesCharactersSara_gigglePng2['default'],
	          notes: md.getSubSectionAsHtml('Level Completed', 'Notes', false, regionData),
	          html: md.getSubSectionAsHtml('Level Completed', 'Content', false, regionData),
	          bgColor: '#37b34a'
	        })
	      );
	    }
	  }], [{
	    key: 'contextTypes',
	    value: {
	      regionData: _react.PropTypes.object.isRequired
	    },
	    enumerable: true
	  }]);

	  return _default;
	})(_react.Component);

	exports['default'] = _default;
	module.exports = exports['default'];

/***/ }),
/* 1007 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _get = __webpack_require__(8)['default'];
	
	var _inherits = __webpack_require__(5)['default'];
	
	var _createClass = __webpack_require__(6)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _componentsStartLevel = __webpack_require__(79);
	
	var _componentsStartLevel2 = _interopRequireDefault(_componentsStartLevel);
	
	var _sections00_prepPrepSection = __webpack_require__(1008);
	
	var _sections00_prepPrepSection2 = _interopRequireDefault(_sections00_prepPrepSection);
	
	var _default = (function (_Component) {
	  _inherits(_default, _Component);
	
	  function _default() {
	    _classCallCheck(this, _default);
	
	    _get(Object.getPrototypeOf(_default.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(_default, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var level = _props.nextLevel;
	      var configuration = _props.configuration;
	      var regionData = this.context.regionData;
	
	      return _react2['default'].createElement(
	        _spectaclePpa.Deck,
	        { transition: ['slide'],
	          transitionDuration: 800,
	          progress: 'bar' },
	        (0, _sections00_prepPrepSection2['default'])({ level: level, configuration: configuration, regionData: regionData }),
	        _react2['default'].createElement(
	          _spectaclePpa.Slide,
	          {
	            id: 'start',
	            textColor: 'white' },
	          _react2['default'].createElement(_componentsStartLevel2['default'], null)
	        )
	      );
	    }
	  }], [{
	    key: 'propTypes',
	    value: {
	      nextLevel: _react.PropTypes.string.isRequired,
	      configuration: _react.PropTypes.string
	    },
	    enumerable: true
	  }, {
	    key: 'contextTypes',
	    value: {
	      regionData: _react.PropTypes.object.isRequired
	    },
	    enumerable: true
	  }]);

	  return _default;
	})(_react.Component);

	exports['default'] = _default;
	module.exports = exports['default'];
	/* Prep */

/***/ }),
/* 1008 */
/***/ (function(module, exports, __webpack_require__) {

	/* eslint react/no-multi-comp: 0 */
	
	'use strict';
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _componentsSelectConfiguration = __webpack_require__(77);
	
	var _componentsSelectConfiguration2 = _interopRequireDefault(_componentsSelectConfiguration);
	
	var _componentsSelectDeviceRole = __webpack_require__(78);
	
	var _componentsSelectDeviceRole2 = _interopRequireDefault(_componentsSelectDeviceRole);
	
	var _baseSlidesHtmlSlide = __webpack_require__(1000);
	
	var _baseSlidesHtmlSlide2 = _interopRequireDefault(_baseSlidesHtmlSlide);
	
	var _baseSlidesHeadingSlide = __webpack_require__(161);
	
	var _baseSlidesHeadingSlide2 = _interopRequireDefault(_baseSlidesHeadingSlide);
	
	var _baseSlidesVideoSlide = __webpack_require__(55);
	
	var _baseSlidesVideoSlide2 = _interopRequireDefault(_baseSlidesVideoSlide);
	
	var _helpersMarkdownScript = __webpack_require__(9);
	
	var _helpersMarkdownScript2 = _interopRequireDefault(_helpersMarkdownScript);
	
	var _tech_prepMd = __webpack_require__(1537);
	
	var _tech_prepMd2 = _interopRequireDefault(_tech_prepMd);
	
	var techPrepMd = new _helpersMarkdownScript2['default'](_tech_prepMd2['default']);
	
	function techPrepWizard(_ref) {
	  var regionData = _ref.regionData;
	
	  return (0, _baseSlidesHtmlSlide2['default'])({
	    id: 'tech-prep-wizard',
	    html: techPrepMd.getSectionAsHtml('Tech Prep Wizard', false, regionData)
	  });
	}
	
	function twoDeviceIntro(_ref2) {
	  var regionData = _ref2.regionData;
	
	  return (0, _baseSlidesHtmlSlide2['default'])({
	    id: 'two-device-intro',
	    html: techPrepMd.getSectionAsHtml('Two Device Intro', false, regionData)
	  });
	}
	
	function selectConfiguration() {
	  return _react2['default'].createElement(
	    _spectaclePpa.Slide,
	    {
	      id: 'configuration',
	      textColor: 'white' },
	    _react2['default'].createElement(_componentsSelectConfiguration2['default'], null)
	  );
	}
	
	function connectingRemote(_ref3) {
	  var configuration = _ref3.configuration;
	  var regionData = _ref3.regionData;
	
	  if (configuration === 'dualScreen') {
	    return (0, _baseSlidesHtmlSlide2['default'])({
	      id: 'connecting-remote',
	      html: techPrepMd.getSectionAsHtml('Connecting Remote', false, regionData)
	    });
	  } else {
	    return null;
	  }
	}
	
	function selectDeviceRole(configuration) {
	  if (configuration === 'dualScreen') {
	    return _react2['default'].createElement(
	      _spectaclePpa.Slide,
	      {
	        id: 'device-role',
	        textColor: 'white' },
	      _react2['default'].createElement(_componentsSelectDeviceRole2['default'], null)
	    );
	  } else {
	    return null;
	  }
	}
	
	function techCheckIntro(_ref4) {
	  var regionData = _ref4.regionData;
	
	  return (0, _baseSlidesHtmlSlide2['default'])({
	    id: 'tech-check-intro',
	    html: techPrepMd.getSectionAsHtml('Tech Check Intro', false, regionData)
	  });
	}
	
	function techCheckVideo(_ref5) {
	  var regionData = _ref5.regionData;
	
	  return (0, _baseSlidesVideoSlide2['default'])({
	    id: 'tech-check-video',
	    youTubeId: techPrepMd.getSectionMetadata('Tech Check Video', 'YouTube', regionData)
	  });
	}
	
	function levelPrep(_ref6) {
	  var configuration = _ref6.configuration;
	  var regionData = _ref6.regionData;
	
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'prep' },
	    techPrepWizard({ regionData: regionData }),
	    twoDeviceIntro({ regionData: regionData }),
	    selectConfiguration(),
	    connectingRemote({ configuration: configuration, regionData: regionData }),
	    selectDeviceRole(configuration),
	    techCheckIntro({ regionData: regionData }),
	    techCheckVideo({ regionData: regionData })
	  );
	}
	
	function levelCompletedPrep(_ref7) {
	  var configuration = _ref7.configuration;
	  var regionData = _ref7.regionData;
	
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'prep' },
	    selectConfiguration(),
	    connectingRemote({ configuration: configuration, regionData: regionData }),
	    selectDeviceRole(configuration)
	  );
	}
	
	function prepSection(_ref8) {
	  var level = _ref8.level;
	  var configuration = _ref8.configuration;
	  var regionData = _ref8.regionData;
	
	  switch (level) {
	    case '1':
	      return levelPrep({ configuration: configuration, regionData: regionData });
	    case '2':
	      return levelPrep({ configuration: configuration, regionData: regionData });
	    case '3':
	      return levelPrep({ configuration: configuration, regionData: regionData });
	    case 'completed':
	      return levelCompletedPrep({ configuration: configuration, regionData: regionData });
	    default:
	      return (0, _baseSlidesHeadingSlide2['default'])({ heading: 'Unknown' });
	  }
	}
	
	exports['default'] = prepSection;
	module.exports = exports['default'];
	/* Tech Prep Wizard */ /* Two Device Intro */ /* Select Configuration */ /* Connecting Remote Instructions */ /* Select Device Role */ /* Tech Check Intro */ /* Tech Check Video */ /* Start Level */ /* Select Configuration */ /* Connecting Remote */ /* Select Device Role */

/***/ }),
/* 1009 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.preloadGameShow = preloadGameShow;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _componentsTeamNames = __webpack_require__(60);
	
	var _componentsTeamNames2 = _interopRequireDefault(_componentsTeamNames);
	
	var _baseSlidesVideoSlide = __webpack_require__(55);
	
	var _baseSlidesVideoSlide2 = _interopRequireDefault(_baseSlidesVideoSlide);
	
	var _baseSlidesBalloonSlide = __webpack_require__(85);
	
	var _baseSlidesBalloonSlide2 = _interopRequireDefault(_baseSlidesBalloonSlide);
	
	var _helpersMarkdownScript = __webpack_require__(9);
	
	var _helpersMarkdownScript2 = _interopRequireDefault(_helpersMarkdownScript);
	
	var _teamCreationMd = __webpack_require__(1540);
	
	var _teamCreationMd2 = _interopRequireDefault(_teamCreationMd);
	
	var _imagesCharactersSara_twist_hands_out_heyheyPng = __webpack_require__(860);
	
	var _imagesCharactersSara_twist_hands_out_heyheyPng2 = _interopRequireDefault(_imagesCharactersSara_twist_hands_out_heyheyPng);
	
	var _imagesCharactersIan_arms_foldedPng = __webpack_require__(854);
	
	var _imagesCharactersIan_arms_foldedPng2 = _interopRequireDefault(_imagesCharactersIan_arms_foldedPng);
	
	var _imagesCharactersSara_gigglePng = __webpack_require__(858);
	
	var _imagesCharactersSara_gigglePng2 = _interopRequireDefault(_imagesCharactersSara_gigglePng);
	
	var _imagesCharactersIan_pointing_upPng = __webpack_require__(404);
	
	var _imagesCharactersIan_pointing_upPng2 = _interopRequireDefault(_imagesCharactersIan_pointing_upPng);
	
	var md = new _helpersMarkdownScript2['default'](_teamCreationMd2['default']);
	
	function preloadGameShow() {
	  (0, _spectaclePpa.preloader)([_imagesCharactersSara_twist_hands_out_heyheyPng2['default'], _imagesCharactersIan_arms_foldedPng2['default'], _imagesCharactersSara_gigglePng2['default']]);
	}
	
	function teamCreationSection(_ref) {
	  var regionData = _ref.regionData;
	
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'team-creation' },
	    (0, _baseSlidesVideoSlide2['default'])({
	      id: 'intro-team-names',
	      notes: md.getSubSectionAsHtml('Intro Team Names', 'Notes', false, regionData),
	      youTubeId: md.getSectionMetadata('Intro Team Names', 'YouTube', regionData)
	    }),
	    (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'get-into-teams',
	      characterSide: 'right',
	      characterImage: _imagesCharactersSara_gigglePng2['default'],
	      notes: md.getSubSectionAsHtml('Get Into Teams', 'Notes', false, regionData),
	      html: md.getSubSectionAsHtml('Get Into Teams', 'Content', false, regionData)
	    }),
	    _react2['default'].createElement(
	      _spectaclePpa.Slide,
	      {
	        id: 'assign',
	        bgColor: 'black',
	        notes: '<h2>Assign Team Names</h2>',
	        teamNames: true },
	      _react2['default'].createElement(
	        'div',
	        { className: 'ui-slide' },
	        _react2['default'].createElement(
	          _spectaclePpa.Heading,
	          { size: 1 },
	          'Name your teams!'
	        ),
	        _react2['default'].createElement(_componentsTeamNames2['default'], null)
	      )
	    ),
	    (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'scoring-intro',
	      characterSide: 'right',
	      characterImage: _imagesCharactersIan_arms_foldedPng2['default'],
	      notes: md.getSubSectionAsHtml('Scoring Intro', 'Notes', false, regionData),
	      html: md.getSubSectionAsHtml('Scoring Intro', 'Content', false, regionData)
	    }),
	    (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'scoreboard-intro',
	      characterSide: 'left',
	      characterImage: _imagesCharactersIan_pointing_upPng2['default'],
	      notes: md.getSubSectionAsHtml('Scoreboard Intro', 'Notes', false, regionData),
	      html: md.getSubSectionAsHtml('Scoreboard Intro', 'Content', false, regionData)
	    }),
	    (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'congratulations',
	      characterSide: 'right',
	      characterImage: _imagesCharactersSara_twist_hands_out_heyheyPng2['default'],
	      notes: md.getSubSectionAsHtml('Congratulations', 'Notes', false, regionData),
	      html: md.getSubSectionAsHtml('Congratulations', 'Content', false, regionData)
	    })
	  );
	}
	
	exports['default'] = teamCreationSection;
	/* Sara and Ian welcome to Academy */ /* Get into teams and come up with a cool name */ /* Enter team names */ /* Scoring intro */ /* Introduce scoreboard */ /* Congratulations */

/***/ }),
/* 1010 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.preloadEnding = preloadEnding;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _baseSlidesBalloonSlide = __webpack_require__(85);
	
	var _baseSlidesBalloonSlide2 = _interopRequireDefault(_baseSlidesBalloonSlide);
	
	var _baseSlidesHeadingSlide = __webpack_require__(161);
	
	var _baseSlidesHeadingSlide2 = _interopRequireDefault(_baseSlidesHeadingSlide);
	
	var _imagesEmergencyPreparednessSquadGlowPng = __webpack_require__(407);
	
	var _imagesEmergencyPreparednessSquadGlowPng2 = _interopRequireDefault(_imagesEmergencyPreparednessSquadGlowPng);
	
	var _imagesCharactersIan_hand_raisedPng = __webpack_require__(2275);
	
	var _imagesCharactersIan_hand_raisedPng2 = _interopRequireDefault(_imagesCharactersIan_hand_raisedPng);
	
	var _imagesCharactersIan_sara_sidePng = __webpack_require__(152);
	
	var _imagesCharactersIan_sara_sidePng2 = _interopRequireDefault(_imagesCharactersIan_sara_sidePng);
	
	var _helpersMarkdownScript = __webpack_require__(9);
	
	var _helpersMarkdownScript2 = _interopRequireDefault(_helpersMarkdownScript);
	
	var _endingMd = __webpack_require__(1557);
	
	var _endingMd2 = _interopRequireDefault(_endingMd);
	
	var md = new _helpersMarkdownScript2['default'](_endingMd2['default']);
	
	function preloadEnding() {
	  (0, _spectaclePpa.preloader)([_imagesCharactersIan_hand_raisedPng2['default'], _imagesCharactersIan_sara_sidePng2['default'], _imagesEmergencyPreparednessSquadGlowPng2['default']]);
	}
	
	function endingSection(_ref) {
	  var regionData = _ref.regionData;
	
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'ending' },
	    (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'announce-winners',
	      characterSide: 'right',
	      characterImage: _imagesCharactersIan_hand_raisedPng2['default'],
	      html: md.getSubSectionAsHtml('Announce Winners', 'Content', false, regionData),
	      notes: md.getSubSectionAsHtml('Announce Winners', 'Notes', false, regionData)
	    }),
	    (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'members-of-eps',
	      characterSide: 'right',
	      characterImage: _imagesCharactersIan_sara_sidePng2['default'],
	      html: md.getSubSectionAsHtml('Members EPS', 'Content', false, regionData),
	      notes: md.getSubSectionAsHtml('Members EPS', 'Notes', false, regionData)
	    }),
	    (0, _baseSlidesHeadingSlide2['default'])({
	      id: 'completed',
	      beforeImage: _imagesEmergencyPreparednessSquadGlowPng2['default'],
	      subHeading: 'All levels completed!!!',
	      notes: md.getSubSectionAsHtml('All Levels Completed', 'Notes', false, regionData),
	      bgColor: 'black'
	    })
	  );
	}
	
	exports['default'] = endingSection;
	/* Time to see who won! */ /* You're now all members of the Emergency Preparedness Squad */ /* You've completed all the levels */

/***/ }),
/* 1011 */
/***/ (function(module, exports) {

	/* eslint-disable object-shorthand */
	'use strict';
	
	var colors = {
	  primary: '#37bad5',
	  secondary: 'black',
	  tertiary: 'white',
	  level1: '#ffbc00',
	  level2: '#8f288c',
	  level3: '#26a7df',
	  level4: '#e80a89',
	  level5: '#f59122',
	  level6: '#37b34a',
	  gameshow: '#742CBF',
	  question: '#45B3EC',
	  answer: '#6FC36E'
	};
	
	var fonts = {
	  primary: 'BrandonTextWeb',
	  secondary: 'Orbitron',
	  tertiary: 'Ubuntu'
	};
	
	module.exports = {
	  colors: colors,
	  fonts: fonts,
	  global: {
	    body: {
	      background: 'transparent',
	      fontFamily: fonts.primary,
	      fontWeight: 'normal',
	      fontSize: '2em',
	      color: colors.primary,
	      overflow: 'hidden'
	    },
	    'html, body': {
	      // height: '100%'
	    },
	    '*': {
	      boxSizing: 'border-box'
	    },
	    input: {
	      color: 'black',
	      fontWeight: 'bold',
	      backgroundColor: 'white',
	      fontSize: '2.66em',
	      fontFamily: fonts.primary,
	      padding: '0.25em 0.25em 0.2em',
	      margin: '1% 1% 3%',
	      width: '98%'
	    },
	    label: {
	      color: 'white',
	      fontWeight: 'bold',
	      fontSize: '1.8em',
	      margin: '0.1em 0 0'
	    }
	  },
	  progress: {
	    bar: {
	      container: {
	        position: 'absolute',
	        height: '22px',
	        width: '100%',
	        bottom: 0,
	        left: 0,
	        transition: 'all 1s ease-in-out 0.2s',
	        zIndex: 1000
	      },
	      bar: {
	        height: '100%',
	        background: colors.primary,
	        transition: 'all 0.3s ease-out',
	        fontSize: '12px',
	        letterSpacing: '0.1em',
	        textTransform: 'uppercase',
	        padding: '4px',
	        textAlign: 'right'
	      }
	    },
	    number: {
	      container: {
	        position: 'absolute',
	        bottom: 10,
	        right: 10,
	        zIndex: 1000,
	        color: colors.tertiary
	      }
	    }
	  },
	  components: {
	    codePane: {
	      pre: {
	        margin: 'auto',
	        fontSize: '1em',
	        fontWeight: 'normal',
	        fontFamily: fonts.tertiary,
	        minWidth: '100%',
	        maxWidth: 800
	      },
	      code: {
	        textAlign: 'left',
	        padding: 20,
	        fontWeight: 'normal'
	      }
	    },
	    code: {
	      color: 'black',
	      fontSize: '2.66em',
	      fontFamily: fonts.tertiary,
	      margin: '0.25em auto',
	      backgroundColor: 'rgba(0,0,0,0.15)',
	      padding: '0 10px',
	      borderRadius: 3
	    },
	    heading: {},
	    link: {
	      textDecoration: 'none'
	    },
	    listItem: {
	      fontSize: '2.66em',
	      padding: '0 0 0.5em'
	    },
	    list: {
	      textAlign: 'center',
	      listStyle: 'none',
	      padding: '0.5em 0'
	    },
	    s: {
	      strikethrough: {}
	    },
	    text: {
	      color: 'black',
	      fontSize: '2.66em',
	      fontFamily: fonts.primary,
	      margin: '0.25em auto',
	      textShadow: '0 0 10px rgba(0,0,0,0.2)'
	    }
	  }
	};

/***/ }),
/* 1012 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = __webpack_require__(7)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	function htmlSlide(_ref) {
	  var id = _ref.id;
	  var notes = _ref.notes;
	  var heading = _ref.heading;
	  var bgColor = _ref.bgColor;
	  var subHeading = _ref.subHeading;
	  var html = _ref.html;
	  var slideClass = _ref.slideClass;
	
	  var slideContentClass = slideClass ? ' slide-' + slideClass : '';
	  var bgColorOpts = {};
	  if (bgColor) {
	    bgColorOpts.bgColor = bgColor;
	  }
	  return _react2['default'].createElement(
	    _spectaclePpa.Slide,
	    _extends({
	      id: id,
	      key: id
	    }, bgColorOpts, {
	      notes: notes,
	      textColor: 'white' }),
	    _react2['default'].createElement(
	      'div',
	      { className: 'slide-content' + slideContentClass },
	      _react2['default'].createElement(
	        'div',
	        {
	          className: 'text-formatted' },
	        !!heading && _react2['default'].createElement(
	          _spectaclePpa.Heading,
	          { size: 3 },
	          heading
	        ),
	        !!subHeading && _react2['default'].createElement(
	          _spectaclePpa.Heading,
	          { size: 5 },
	          subHeading
	        ),
	        _react2['default'].createElement('div', {
	          dangerouslySetInnerHTML: { __html: html } })
	      )
	    )
	  );
	}
	
	exports['default'] = htmlSlide;
	module.exports = exports['default'];

/***/ }),
/* 1013 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = {
	  width: 1000,
	  height: 700,
	  margin: 40,
	  theme: __webpack_require__(1023),
	  print: __webpack_require__(53),
	  html: __webpack_require__(52)
	};

/***/ }),
/* 1014 */
/***/ (function(module, exports, __webpack_require__) {

	/* eslint no-console: 0 */
	
	'use strict';
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _helpersMarkdownScript = __webpack_require__(9);
	
	var _helpersMarkdownScript2 = _interopRequireDefault(_helpersMarkdownScript);
	
	var _indexMd = __webpack_require__(248);
	
	var _indexMd2 = _interopRequireDefault(_indexMd);
	
	var _extensionActivitiesExtensionActivitiesMd = __webpack_require__(1558);
	
	var _extensionActivitiesExtensionActivitiesMd2 = _interopRequireDefault(_extensionActivitiesExtensionActivitiesMd);
	
	var _programPrepProgramPrepMd = __webpack_require__(1561);
	
	var _programPrepProgramPrepMd2 = _interopRequireDefault(_programPrepProgramPrepMd);
	
	var _sections00_prepLevel1_prepMd = __webpack_require__(1562);
	
	var _sections00_prepLevel1_prepMd2 = _interopRequireDefault(_sections00_prepLevel1_prepMd);
	
	var _sections00_prepLevel2_prepMd = __webpack_require__(1563);
	
	var _sections00_prepLevel2_prepMd2 = _interopRequireDefault(_sections00_prepLevel2_prepMd);
	
	var _sections00_prepLevel3_prepMd = __webpack_require__(1564);
	
	var _sections00_prepLevel3_prepMd2 = _interopRequireDefault(_sections00_prepLevel3_prepMd);
	
	var _funMd = __webpack_require__(1559);
	
	var _funMd2 = _interopRequireDefault(_funMd);
	
	var _imagesEmergencyPreparednessSquadPng = __webpack_require__(2302);
	
	var _imagesEmergencyPreparednessSquadPng2 = _interopRequireDefault(_imagesEmergencyPreparednessSquadPng);
	
	var _imagesEmergencyPreparednessSquadTrialPng = __webpack_require__(2304);
	
	var _imagesEmergencyPreparednessSquadTrialPng2 = _interopRequireDefault(_imagesEmergencyPreparednessSquadTrialPng);
	
	var _imagesEmergencyPreparednessSquadExpiredPng = __webpack_require__(2303);
	
	var _imagesEmergencyPreparednessSquadExpiredPng2 = _interopRequireDefault(_imagesEmergencyPreparednessSquadExpiredPng);
	
	var _config = __webpack_require__(1013);
	
	var _config2 = _interopRequireDefault(_config);
	
	// Preload image functions
	
	var _sections20_gameShowGameShowSection = __webpack_require__(207);
	
	__webpack_require__(2187);
	
	var md = new _helpersMarkdownScript2['default'](_indexMd2['default']);
	
	var levels = {
	  prep: {
	    deck: __webpack_require__(1019)
	  },
	  1: {
	    thumbnail: __webpack_require__(414),
	    overviewThumbnail: __webpack_require__(2306),
	    deck: __webpack_require__(1015),
	    prep: new _helpersMarkdownScript2['default'](_sections00_prepLevel1_prepMd2['default']),
	    levelName: 'Make a Plan'
	  },
	  2: {
	    thumbnail: __webpack_require__(415),
	    overviewThumbnail: __webpack_require__(2307),
	    deck: __webpack_require__(1016),
	    prep: new _helpersMarkdownScript2['default'](_sections00_prepLevel2_prepMd2['default']),
	    levelName: 'Get a Kit'
	  },
	  3: {
	    thumbnail: __webpack_require__(869),
	    overviewThumbnail: __webpack_require__(2308),
	    deck: __webpack_require__(1017),
	    prep: new _helpersMarkdownScript2['default'](_sections00_prepLevel3_prepMd2['default']),
	    levelName: "We're In This Together"
	  },
	  completed: {
	    deck: __webpack_require__(1018)
	  }
	};
	
	var program = {
	  id: 'epsHybridPrimaries',
	  title: md.getSectionAsString('Title - Short'),
	  longTitle: md.getSectionAsString('Title - Long'),
	  thumbnailImage: _imagesEmergencyPreparednessSquadPng2['default'],
	  trialImageThumb: _imagesEmergencyPreparednessSquadTrialPng2['default'],
	  expiredImageThumb: _imagesEmergencyPreparednessSquadExpiredPng2['default'],
	  longDescription: md.getSectionAsString('Description - Long'),
	  shortDescription: md.getSectionAsString('Description - Short'),
	  levelsDescription: md.getSectionAsString('Description - Levels'),
	  levels: levels,
	  extensionActivitiesMd: new _helpersMarkdownScript2['default'](_extensionActivitiesExtensionActivitiesMd2['default']),
	  programPrepMd: new _helpersMarkdownScript2['default'](_programPrepProgramPrepMd2['default']),
	  funMd: new _helpersMarkdownScript2['default'](_funMd2['default']),
	  preload: function preload(_ref) {
	    var level = _ref.level;
	
	    console.log('Preloading assets for Level ' + level);
	
	    (0, _sections20_gameShowGameShowSection.preloadGameShow)();
	  },
	  config: _config2['default'],
	  featuredOnly: true
	};
	
	exports['default'] = program;
	module.exports = exports['default'];

/***/ }),
/* 1015 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(__filename) {'use strict';
	
	var _get = __webpack_require__(8)['default'];
	
	var _inherits = __webpack_require__(5)['default'];
	
	var _createClass = __webpack_require__(6)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _helpersMarkdownScript = __webpack_require__(9);
	
	var _helpersMarkdownScript2 = _interopRequireDefault(_helpersMarkdownScript);
	
	var _indexMd = __webpack_require__(248);
	
	var _indexMd2 = _interopRequireDefault(_indexMd);
	
	var _sections01_startStartSection = __webpack_require__(287);
	
	var _sections01_startStartSection2 = _interopRequireDefault(_sections01_startStartSection);
	
	var _sections03_songSongSection = __webpack_require__(288);
	
	var _sections03_songSongSection2 = _interopRequireDefault(_sections03_songSongSection);
	
	var _sections10_teamCreationTeamCreationSection = __webpack_require__(1021);
	
	var _sections10_teamCreationTeamCreationSection2 = _interopRequireDefault(_sections10_teamCreationTeamCreationSection);
	
	var _sections11_esGooberStoryEsGooberStorySection = __webpack_require__(289);
	
	var _sections11_esGooberStoryEsGooberStorySection2 = _interopRequireDefault(_sections11_esGooberStoryEsGooberStorySection);
	
	var _sections12_missionReportMissionReportSection = __webpack_require__(290);
	
	var _sections12_missionReportMissionReportSection2 = _interopRequireDefault(_sections12_missionReportMissionReportSection);
	
	var _sections20_gameShowGameShowSection = __webpack_require__(207);
	
	var _sections20_gameShowGameShowSection2 = _interopRequireDefault(_sections20_gameShowGameShowSection);
	
	var _sections30_classActivityClassActivitySection = __webpack_require__(291);
	
	var _sections30_classActivityClassActivitySection2 = _interopRequireDefault(_sections30_classActivityClassActivitySection);
	
	var _sections70_missionAssignmentMissionAssignmentSection = __webpack_require__(292);
	
	var _sections70_missionAssignmentMissionAssignmentSection2 = _interopRequireDefault(_sections70_missionAssignmentMissionAssignmentSection);
	
	var _sections90_finishFinishSection = __webpack_require__(293);
	
	var _sections90_finishFinishSection2 = _interopRequireDefault(_sections90_finishFinishSection);
	
	var md = new _helpersMarkdownScript2['default'](_indexMd2['default']);
	var level = Number(__filename.replace(/^.*level/, '').replace('.jsx', ''));
	var title = md.getSectionMetadata('Level ' + level, 'Title');
	
	var _default = (function (_Component) {
	  _inherits(_default, _Component);
	
	  function _default() {
	    _classCallCheck(this, _default);
	
	    _get(Object.getPrototypeOf(_default.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(_default, [{
	    key: 'render',
	    value: function render() {
	      var regionData = this.context.regionData;
	
	      return _react2['default'].createElement(
	        _spectaclePpa.Deck,
	        { transition: ['slide'],
	          transitionDuration: 800,
	          progress: 'bar' },
	        (0, _sections01_startStartSection2['default'])({ level: level, title: title, regionData: regionData }),
	        (0, _sections03_songSongSection2['default'])({ level: level, regionData: regionData }),
	        (0, _sections10_teamCreationTeamCreationSection2['default'])({ regionData: regionData }),
	        (0, _sections12_missionReportMissionReportSection2['default'])({ level: level, regionData: regionData }),
	        (0, _sections11_esGooberStoryEsGooberStorySection2['default'])({ level: level, regionData: regionData }),
	        (0, _sections20_gameShowGameShowSection2['default'])({ level: level, regionData: regionData }),
	        (0, _sections30_classActivityClassActivitySection2['default'])({ level: level, regionData: regionData }),
	        (0, _sections70_missionAssignmentMissionAssignmentSection2['default'])({ level: level, title: title, regionData: regionData }),
	        (0, _sections90_finishFinishSection2['default'])({ level: level, regionData: regionData })
	      );
	    }
	  }], [{
	    key: 'contextTypes',
	    value: {
	      regionData: _react.PropTypes.object.isRequired
	    },
	    enumerable: true
	  }, {
	    key: 'metadata',
	    value: {
	      title: title
	    },
	    enumerable: true
	  }]);

	  return _default;
	})(_react.Component);

	exports['default'] = _default;
	module.exports = exports['default'];
	/* Start */ /* Theme Song */ /* Team Creation and Introduction */ /* Mission Report */ /* Esmeralda & Goober Story */ /* Game Show */ /* Class Activity: Floorplan */ /* Mission Assignment */ /* Finish */
	/* WEBPACK VAR INJECTION */}.call(exports, "programs/epsHybridPrimaries/level1.jsx"))

/***/ }),
/* 1016 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(__filename) {'use strict';
	
	var _get = __webpack_require__(8)['default'];
	
	var _inherits = __webpack_require__(5)['default'];
	
	var _createClass = __webpack_require__(6)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _helpersMarkdownScript = __webpack_require__(9);
	
	var _helpersMarkdownScript2 = _interopRequireDefault(_helpersMarkdownScript);
	
	var _indexMd = __webpack_require__(248);
	
	var _indexMd2 = _interopRequireDefault(_indexMd);
	
	var _sections01_startStartSection = __webpack_require__(287);
	
	var _sections01_startStartSection2 = _interopRequireDefault(_sections01_startStartSection);
	
	var _sections03_songSongSection = __webpack_require__(288);
	
	var _sections03_songSongSection2 = _interopRequireDefault(_sections03_songSongSection);
	
	var _sections11_esGooberStoryEsGooberStorySection = __webpack_require__(289);
	
	var _sections11_esGooberStoryEsGooberStorySection2 = _interopRequireDefault(_sections11_esGooberStoryEsGooberStorySection);
	
	var _sections12_missionReportMissionReportSection = __webpack_require__(290);
	
	var _sections12_missionReportMissionReportSection2 = _interopRequireDefault(_sections12_missionReportMissionReportSection);
	
	var _sections20_gameShowGameShowSection = __webpack_require__(207);
	
	var _sections20_gameShowGameShowSection2 = _interopRequireDefault(_sections20_gameShowGameShowSection);
	
	var _sections30_classActivityClassActivitySection = __webpack_require__(291);
	
	var _sections30_classActivityClassActivitySection2 = _interopRequireDefault(_sections30_classActivityClassActivitySection);
	
	var _sections70_missionAssignmentMissionAssignmentSection = __webpack_require__(292);
	
	var _sections70_missionAssignmentMissionAssignmentSection2 = _interopRequireDefault(_sections70_missionAssignmentMissionAssignmentSection);
	
	var _sections90_finishFinishSection = __webpack_require__(293);
	
	var _sections90_finishFinishSection2 = _interopRequireDefault(_sections90_finishFinishSection);
	
	var md = new _helpersMarkdownScript2['default'](_indexMd2['default']);
	var level = Number(__filename.replace(/^.*level/, '').replace('.jsx', ''));
	var title = md.getSectionMetadata('Level ' + level, 'Title');
	
	var _default = (function (_Component) {
	  _inherits(_default, _Component);
	
	  function _default() {
	    _classCallCheck(this, _default);
	
	    _get(Object.getPrototypeOf(_default.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(_default, [{
	    key: 'render',
	    value: function render() {
	      var regionData = this.context.regionData;
	
	      return _react2['default'].createElement(
	        _spectaclePpa.Deck,
	        { transition: ['slide'],
	          transitionDuration: 800,
	          progress: 'bar' },
	        (0, _sections01_startStartSection2['default'])({ level: level, title: title, regionData: regionData }),
	        (0, _sections03_songSongSection2['default'])({ level: level, regionData: regionData }),
	        (0, _sections11_esGooberStoryEsGooberStorySection2['default'])({ level: level, regionData: regionData }),
	        (0, _sections12_missionReportMissionReportSection2['default'])({ level: level, regionData: regionData }),
	        (0, _sections20_gameShowGameShowSection2['default'])({ level: level, regionData: regionData }),
	        (0, _sections30_classActivityClassActivitySection2['default'])({ level: level, regionData: regionData }),
	        (0, _sections70_missionAssignmentMissionAssignmentSection2['default'])({ level: level, title: title, regionData: regionData }),
	        (0, _sections90_finishFinishSection2['default'])({ level: level, regionData: regionData })
	      );
	    }
	  }], [{
	    key: 'contextTypes',
	    value: {
	      regionData: _react.PropTypes.object.isRequired
	    },
	    enumerable: true
	  }, {
	    key: 'metadata',
	    value: {
	      title: title
	    },
	    enumerable: true
	  }]);

	  return _default;
	})(_react.Component);

	exports['default'] = _default;
	module.exports = exports['default'];
	/* Start */ /* Theme Song */ /* Esmeralda & Goober Story */ /* Mission Report */ /* Game Show */ /* Class Activity: Kit rap */ /* Mission Assignment */ /* Finish */
	/* WEBPACK VAR INJECTION */}.call(exports, "programs/epsHybridPrimaries/level2.jsx"))

/***/ }),
/* 1017 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(__filename) {'use strict';
	
	var _get = __webpack_require__(8)['default'];
	
	var _inherits = __webpack_require__(5)['default'];
	
	var _createClass = __webpack_require__(6)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _helpersMarkdownScript = __webpack_require__(9);
	
	var _helpersMarkdownScript2 = _interopRequireDefault(_helpersMarkdownScript);
	
	var _indexMd = __webpack_require__(248);
	
	var _indexMd2 = _interopRequireDefault(_indexMd);
	
	var _sections01_startStartSection = __webpack_require__(287);
	
	var _sections01_startStartSection2 = _interopRequireDefault(_sections01_startStartSection);
	
	var _sections03_songSongSection = __webpack_require__(288);
	
	var _sections03_songSongSection2 = _interopRequireDefault(_sections03_songSongSection);
	
	var _sections11_esGooberStoryEsGooberStorySection = __webpack_require__(289);
	
	var _sections11_esGooberStoryEsGooberStorySection2 = _interopRequireDefault(_sections11_esGooberStoryEsGooberStorySection);
	
	var _sections12_missionReportMissionReportSection = __webpack_require__(290);
	
	var _sections12_missionReportMissionReportSection2 = _interopRequireDefault(_sections12_missionReportMissionReportSection);
	
	var _sections20_gameShowGameShowSection = __webpack_require__(207);
	
	var _sections20_gameShowGameShowSection2 = _interopRequireDefault(_sections20_gameShowGameShowSection);
	
	var _sections30_classActivityClassActivitySection = __webpack_require__(291);
	
	var _sections30_classActivityClassActivitySection2 = _interopRequireDefault(_sections30_classActivityClassActivitySection);
	
	var _sections70_missionAssignmentMissionAssignmentSection = __webpack_require__(292);
	
	var _sections70_missionAssignmentMissionAssignmentSection2 = _interopRequireDefault(_sections70_missionAssignmentMissionAssignmentSection);
	
	var _sections95_endingEndingSection = __webpack_require__(1022);
	
	var _sections95_endingEndingSection2 = _interopRequireDefault(_sections95_endingEndingSection);
	
	var _sections90_finishFinishSection = __webpack_require__(293);
	
	var _sections90_finishFinishSection2 = _interopRequireDefault(_sections90_finishFinishSection);
	
	var md = new _helpersMarkdownScript2['default'](_indexMd2['default']);
	var level = Number(__filename.replace(/^.*level/, '').replace('.jsx', ''));
	var title = md.getSectionMetadata('Level ' + level, 'Title');
	
	var _default = (function (_Component) {
	  _inherits(_default, _Component);
	
	  function _default() {
	    _classCallCheck(this, _default);
	
	    _get(Object.getPrototypeOf(_default.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(_default, [{
	    key: 'render',
	    value: function render() {
	      var regionData = this.context.regionData;
	
	      return _react2['default'].createElement(
	        _spectaclePpa.Deck,
	        { transition: ['slide'],
	          transitionDuration: 800,
	          progress: 'bar' },
	        (0, _sections01_startStartSection2['default'])({ level: level, title: title, regionData: regionData }),
	        (0, _sections03_songSongSection2['default'])({ level: level, regionData: regionData }),
	        (0, _sections12_missionReportMissionReportSection2['default'])({ level: level, regionData: regionData }),
	        (0, _sections11_esGooberStoryEsGooberStorySection2['default'])({ level: level, regionData: regionData }),
	        (0, _sections20_gameShowGameShowSection2['default'])({ level: level, regionData: regionData }),
	        (0, _sections30_classActivityClassActivitySection2['default'])({ level: level, title: title, regionData: regionData }),
	        (0, _sections95_endingEndingSection2['default'])({ regionData: regionData }),
	        (0, _sections70_missionAssignmentMissionAssignmentSection2['default'])({ level: level, title: title, regionData: regionData }),
	        (0, _sections90_finishFinishSection2['default'])({ level: level, regionData: regionData })
	      );
	    }
	  }], [{
	    key: 'contextTypes',
	    value: {
	      regionData: _react.PropTypes.object.isRequired
	    },
	    enumerable: true
	  }, {
	    key: 'metadata',
	    value: {
	      title: title
	    },
	    enumerable: true
	  }]);

	  return _default;
	})(_react.Component);

	exports['default'] = _default;
	module.exports = exports['default'];
	/* Start */ /* Theme Song */ /* Mission Report */ /* Esmeralda & Goober Story */ /* Game Show */ /* Class Activity: Drawing */ /* Ending */ /* Mission Assignment */ /* Finish */
	/* WEBPACK VAR INJECTION */}.call(exports, "programs/epsHybridPrimaries/level3.jsx"))

/***/ }),
/* 1018 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _get = __webpack_require__(8)['default'];
	
	var _inherits = __webpack_require__(5)['default'];
	
	var _createClass = __webpack_require__(6)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _baseSlidesBalloonSlide = __webpack_require__(86);
	
	var _baseSlidesBalloonSlide2 = _interopRequireDefault(_baseSlidesBalloonSlide);
	
	var _imagesCharactersSara_gigglePng = __webpack_require__(866);
	
	var _imagesCharactersSara_gigglePng2 = _interopRequireDefault(_imagesCharactersSara_gigglePng);
	
	var _helpersMarkdownScript = __webpack_require__(9);
	
	var _helpersMarkdownScript2 = _interopRequireDefault(_helpersMarkdownScript);
	
	var _levelCompletedMd = __webpack_require__(1560);
	
	var _levelCompletedMd2 = _interopRequireDefault(_levelCompletedMd);
	
	var md = new _helpersMarkdownScript2['default'](_levelCompletedMd2['default']);
	
	var _default = (function (_Component) {
	  _inherits(_default, _Component);
	
	  function _default() {
	    _classCallCheck(this, _default);
	
	    _get(Object.getPrototypeOf(_default.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(_default, [{
	    key: 'render',
	    value: function render() {
	      var regionData = this.context.regionData;
	
	      return _react2['default'].createElement(
	        _spectaclePpa.Deck,
	        { transition: ['slide'],
	          transitionDuration: 800,
	          progress: 'bar' },
	        (0, _baseSlidesBalloonSlide2['default'])({
	          id: 'welcome-back',
	          characterSide: 'right',
	          characterImage: _imagesCharactersSara_gigglePng2['default'],
	          notes: md.getSubSectionAsHtml('Level Completed', 'Notes', false, regionData),
	          html: md.getSubSectionAsHtml('Level Completed', 'Content', false, regionData),
	          bgColor: '#37b34a'
	        })
	      );
	    }
	  }], [{
	    key: 'contextTypes',
	    value: {
	      regionData: _react.PropTypes.object.isRequired
	    },
	    enumerable: true
	  }]);

	  return _default;
	})(_react.Component);

	exports['default'] = _default;
	module.exports = exports['default'];

/***/ }),
/* 1019 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _get = __webpack_require__(8)['default'];
	
	var _inherits = __webpack_require__(5)['default'];
	
	var _createClass = __webpack_require__(6)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _componentsStartLevel = __webpack_require__(79);
	
	var _componentsStartLevel2 = _interopRequireDefault(_componentsStartLevel);
	
	var _sections00_prepPrepSection = __webpack_require__(1020);
	
	var _sections00_prepPrepSection2 = _interopRequireDefault(_sections00_prepPrepSection);
	
	var _default = (function (_Component) {
	  _inherits(_default, _Component);
	
	  function _default() {
	    _classCallCheck(this, _default);
	
	    _get(Object.getPrototypeOf(_default.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(_default, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var level = _props.nextLevel;
	      var configuration = _props.configuration;
	      var regionData = this.context.regionData;
	
	      return _react2['default'].createElement(
	        _spectaclePpa.Deck,
	        { transition: ['slide'],
	          transitionDuration: 800,
	          progress: 'bar' },
	        (0, _sections00_prepPrepSection2['default'])({ level: level, configuration: configuration, regionData: regionData }),
	        _react2['default'].createElement(
	          _spectaclePpa.Slide,
	          {
	            id: 'start',
	            textColor: 'white' },
	          _react2['default'].createElement(_componentsStartLevel2['default'], null)
	        )
	      );
	    }
	  }], [{
	    key: 'propTypes',
	    value: {
	      nextLevel: _react.PropTypes.string.isRequired,
	      configuration: _react.PropTypes.string
	    },
	    enumerable: true
	  }, {
	    key: 'contextTypes',
	    value: {
	      regionData: _react.PropTypes.object.isRequired
	    },
	    enumerable: true
	  }]);

	  return _default;
	})(_react.Component);

	exports['default'] = _default;
	module.exports = exports['default'];
	/* Prep */

/***/ }),
/* 1020 */
/***/ (function(module, exports, __webpack_require__) {

	/* eslint react/no-multi-comp: 0 */
	
	'use strict';
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _componentsSelectConfiguration = __webpack_require__(77);
	
	var _componentsSelectConfiguration2 = _interopRequireDefault(_componentsSelectConfiguration);
	
	var _componentsSelectDeviceRole = __webpack_require__(78);
	
	var _componentsSelectDeviceRole2 = _interopRequireDefault(_componentsSelectDeviceRole);
	
	var _baseSlidesHtmlSlide = __webpack_require__(1012);
	
	var _baseSlidesHtmlSlide2 = _interopRequireDefault(_baseSlidesHtmlSlide);
	
	var _baseSlidesHeadingSlide = __webpack_require__(162);
	
	var _baseSlidesHeadingSlide2 = _interopRequireDefault(_baseSlidesHeadingSlide);
	
	var _baseSlidesVideoSlide = __webpack_require__(56);
	
	var _baseSlidesVideoSlide2 = _interopRequireDefault(_baseSlidesVideoSlide);
	
	var _helpersMarkdownScript = __webpack_require__(9);
	
	var _helpersMarkdownScript2 = _interopRequireDefault(_helpersMarkdownScript);
	
	var _tech_prepMd = __webpack_require__(1565);
	
	var _tech_prepMd2 = _interopRequireDefault(_tech_prepMd);
	
	var techPrepMd = new _helpersMarkdownScript2['default'](_tech_prepMd2['default']);
	
	function techPrepWizard(_ref) {
	  var regionData = _ref.regionData;
	
	  return (0, _baseSlidesHtmlSlide2['default'])({
	    id: 'tech-prep-wizard',
	    html: techPrepMd.getSectionAsHtml('Tech Prep Wizard', false, regionData)
	  });
	}
	
	function twoDeviceIntro(_ref2) {
	  var regionData = _ref2.regionData;
	
	  return (0, _baseSlidesHtmlSlide2['default'])({
	    id: 'two-device-intro',
	    html: techPrepMd.getSectionAsHtml('Two Device Intro', false, regionData)
	  });
	}
	
	function selectConfiguration() {
	  return _react2['default'].createElement(
	    _spectaclePpa.Slide,
	    {
	      id: 'configuration',
	      textColor: 'white' },
	    _react2['default'].createElement(_componentsSelectConfiguration2['default'], null)
	  );
	}
	
	function connectingRemote(_ref3) {
	  var configuration = _ref3.configuration;
	  var regionData = _ref3.regionData;
	
	  if (configuration === 'dualScreen') {
	    return (0, _baseSlidesHtmlSlide2['default'])({
	      id: 'connecting-remote',
	      html: techPrepMd.getSectionAsHtml('Connecting Remote', false, regionData)
	    });
	  } else {
	    return null;
	  }
	}
	
	function selectDeviceRole(configuration) {
	  if (configuration === 'dualScreen') {
	    return _react2['default'].createElement(
	      _spectaclePpa.Slide,
	      {
	        id: 'device-role',
	        textColor: 'white' },
	      _react2['default'].createElement(_componentsSelectDeviceRole2['default'], null)
	    );
	  } else {
	    return null;
	  }
	}
	
	function techCheckIntro(_ref4) {
	  var regionData = _ref4.regionData;
	
	  return (0, _baseSlidesHtmlSlide2['default'])({
	    id: 'tech-check-intro',
	    html: techPrepMd.getSectionAsHtml('Tech Check Intro', false, regionData)
	  });
	}
	
	function techCheckVideo(_ref5) {
	  var regionData = _ref5.regionData;
	
	  return (0, _baseSlidesVideoSlide2['default'])({
	    id: 'tech-check-video',
	    youTubeId: techPrepMd.getSectionMetadata('Tech Check Video', 'YouTube', regionData)
	  });
	}
	
	function levelPrep(_ref6) {
	  var configuration = _ref6.configuration;
	  var regionData = _ref6.regionData;
	
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'prep' },
	    techPrepWizard({ regionData: regionData }),
	    twoDeviceIntro({ regionData: regionData }),
	    selectConfiguration(),
	    connectingRemote({ configuration: configuration, regionData: regionData }),
	    selectDeviceRole(configuration),
	    techCheckIntro({ regionData: regionData }),
	    techCheckVideo({ regionData: regionData })
	  );
	}
	
	function levelCompletedPrep(_ref7) {
	  var configuration = _ref7.configuration;
	  var regionData = _ref7.regionData;
	
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'prep' },
	    selectConfiguration(),
	    connectingRemote({ configuration: configuration, regionData: regionData }),
	    selectDeviceRole(configuration)
	  );
	}
	
	function prepSection(_ref8) {
	  var level = _ref8.level;
	  var configuration = _ref8.configuration;
	  var regionData = _ref8.regionData;
	
	  switch (level) {
	    case '1':
	      return levelPrep({ configuration: configuration, regionData: regionData });
	    case '2':
	      return levelPrep({ configuration: configuration, regionData: regionData });
	    case '3':
	      return levelPrep({ configuration: configuration, regionData: regionData });
	    case 'completed':
	      return levelCompletedPrep({ configuration: configuration, regionData: regionData });
	    default:
	      return (0, _baseSlidesHeadingSlide2['default'])({ heading: 'Unknown' });
	  }
	}
	
	exports['default'] = prepSection;
	module.exports = exports['default'];
	/* Tech Prep Wizard */ /* Two Device Intro */ /* Select Configuration */ /* Connecting Remote Instructions */ /* Select Device Role */ /* Tech Check Intro */ /* Tech Check Video */ /* Start Level */ /* Select Configuration */ /* Connecting Remote */ /* Select Device Role */

/***/ }),
/* 1021 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.preloadGameShow = preloadGameShow;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _componentsTeamNames = __webpack_require__(60);
	
	var _componentsTeamNames2 = _interopRequireDefault(_componentsTeamNames);
	
	var _baseSlidesVideoSlide = __webpack_require__(56);
	
	var _baseSlidesVideoSlide2 = _interopRequireDefault(_baseSlidesVideoSlide);
	
	var _baseSlidesBalloonSlide = __webpack_require__(86);
	
	var _baseSlidesBalloonSlide2 = _interopRequireDefault(_baseSlidesBalloonSlide);
	
	var _helpersMarkdownScript = __webpack_require__(9);
	
	var _helpersMarkdownScript2 = _interopRequireDefault(_helpersMarkdownScript);
	
	var _teamCreationMd = __webpack_require__(1568);
	
	var _teamCreationMd2 = _interopRequireDefault(_teamCreationMd);
	
	var _imagesCharactersSara_twist_hands_out_heyheyPng = __webpack_require__(868);
	
	var _imagesCharactersSara_twist_hands_out_heyheyPng2 = _interopRequireDefault(_imagesCharactersSara_twist_hands_out_heyheyPng);
	
	var _imagesCharactersIan_arms_foldedPng = __webpack_require__(862);
	
	var _imagesCharactersIan_arms_foldedPng2 = _interopRequireDefault(_imagesCharactersIan_arms_foldedPng);
	
	var _imagesCharactersSara_gigglePng = __webpack_require__(866);
	
	var _imagesCharactersSara_gigglePng2 = _interopRequireDefault(_imagesCharactersSara_gigglePng);
	
	var _imagesCharactersIan_pointing_upPng = __webpack_require__(410);
	
	var _imagesCharactersIan_pointing_upPng2 = _interopRequireDefault(_imagesCharactersIan_pointing_upPng);
	
	var md = new _helpersMarkdownScript2['default'](_teamCreationMd2['default']);
	
	function preloadGameShow() {
	  (0, _spectaclePpa.preloader)([_imagesCharactersSara_twist_hands_out_heyheyPng2['default'], _imagesCharactersIan_arms_foldedPng2['default'], _imagesCharactersSara_gigglePng2['default']]);
	}
	
	function teamCreationSection(_ref) {
	  var regionData = _ref.regionData;
	
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'team-creation' },
	    (0, _baseSlidesVideoSlide2['default'])({
	      id: 'intro-team-names',
	      notes: md.getSubSectionAsHtml('Intro Team Names', 'Notes', false, regionData),
	      youTubeId: md.getSectionMetadata('Intro Team Names', 'YouTube', regionData)
	    }),
	    (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'get-into-teams',
	      characterSide: 'right',
	      characterImage: _imagesCharactersSara_gigglePng2['default'],
	      notes: md.getSubSectionAsHtml('Get Into Teams', 'Notes', false, regionData),
	      html: md.getSubSectionAsHtml('Get Into Teams', 'Content', false, regionData)
	    }),
	    _react2['default'].createElement(
	      _spectaclePpa.Slide,
	      {
	        id: 'assign',
	        bgColor: 'black',
	        notes: '<h2>Assign Team Names</h2>',
	        teamNames: true },
	      _react2['default'].createElement(
	        'div',
	        { className: 'ui-slide' },
	        _react2['default'].createElement(
	          _spectaclePpa.Heading,
	          { size: 1 },
	          'Name your teams!'
	        ),
	        _react2['default'].createElement(_componentsTeamNames2['default'], null)
	      )
	    ),
	    (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'scoring-intro',
	      characterSide: 'right',
	      characterImage: _imagesCharactersIan_arms_foldedPng2['default'],
	      notes: md.getSubSectionAsHtml('Scoring Intro', 'Notes', false, regionData),
	      html: md.getSubSectionAsHtml('Scoring Intro', 'Content', false, regionData)
	    }),
	    (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'scoreboard-intro',
	      characterSide: 'left',
	      characterImage: _imagesCharactersIan_pointing_upPng2['default'],
	      notes: md.getSubSectionAsHtml('Scoreboard Intro', 'Notes', false, regionData),
	      html: md.getSubSectionAsHtml('Scoreboard Intro', 'Content', false, regionData)
	    }),
	    (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'congratulations',
	      characterSide: 'right',
	      characterImage: _imagesCharactersSara_twist_hands_out_heyheyPng2['default'],
	      notes: md.getSubSectionAsHtml('Congratulations', 'Notes', false, regionData),
	      html: md.getSubSectionAsHtml('Congratulations', 'Content', false, regionData)
	    })
	  );
	}
	
	exports['default'] = teamCreationSection;
	/* Sara and Ian welcome to Academy */ /* Get into teams and come up with a cool name */ /* Enter team names */ /* Scoring intro */ /* Introduce scoreboard */ /* Congratulations */

/***/ }),
/* 1022 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.preloadEnding = preloadEnding;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _baseSlidesBalloonSlide = __webpack_require__(86);
	
	var _baseSlidesBalloonSlide2 = _interopRequireDefault(_baseSlidesBalloonSlide);
	
	var _baseSlidesHeadingSlide = __webpack_require__(162);
	
	var _baseSlidesHeadingSlide2 = _interopRequireDefault(_baseSlidesHeadingSlide);
	
	var _imagesEmergencyPreparednessSquadGlowPng = __webpack_require__(413);
	
	var _imagesEmergencyPreparednessSquadGlowPng2 = _interopRequireDefault(_imagesEmergencyPreparednessSquadGlowPng);
	
	var _imagesCharactersIan_hand_raisedPng = __webpack_require__(2295);
	
	var _imagesCharactersIan_hand_raisedPng2 = _interopRequireDefault(_imagesCharactersIan_hand_raisedPng);
	
	var _imagesCharactersIan_sara_sidePng = __webpack_require__(153);
	
	var _imagesCharactersIan_sara_sidePng2 = _interopRequireDefault(_imagesCharactersIan_sara_sidePng);
	
	var _helpersMarkdownScript = __webpack_require__(9);
	
	var _helpersMarkdownScript2 = _interopRequireDefault(_helpersMarkdownScript);
	
	var _endingMd = __webpack_require__(1585);
	
	var _endingMd2 = _interopRequireDefault(_endingMd);
	
	var md = new _helpersMarkdownScript2['default'](_endingMd2['default']);
	
	function preloadEnding() {
	  (0, _spectaclePpa.preloader)([_imagesCharactersIan_hand_raisedPng2['default'], _imagesCharactersIan_sara_sidePng2['default'], _imagesEmergencyPreparednessSquadGlowPng2['default']]);
	}
	
	function endingSection(_ref) {
	  var regionData = _ref.regionData;
	
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'ending' },
	    (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'announce-winners',
	      characterSide: 'right',
	      characterImage: _imagesCharactersIan_hand_raisedPng2['default'],
	      html: md.getSubSectionAsHtml('Announce Winners', 'Content', false, regionData),
	      notes: md.getSubSectionAsHtml('Announce Winners', 'Notes', false, regionData)
	    }),
	    (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'members-of-eps',
	      characterSide: 'right',
	      characterImage: _imagesCharactersIan_sara_sidePng2['default'],
	      html: md.getSubSectionAsHtml('Members EPS', 'Content', false, regionData),
	      notes: md.getSubSectionAsHtml('Members EPS', 'Notes', false, regionData)
	    }),
	    (0, _baseSlidesHeadingSlide2['default'])({
	      id: 'completed',
	      beforeImage: _imagesEmergencyPreparednessSquadGlowPng2['default'],
	      subHeading: 'All levels completed!!!',
	      notes: md.getSubSectionAsHtml('All Levels Completed', 'Notes', false, regionData),
	      bgColor: 'black'
	    })
	  );
	}
	
	exports['default'] = endingSection;
	/* Time to see who won! */ /* You're now all members of the Emergency Preparedness Squad */ /* You've completed all the levels */

/***/ }),
/* 1023 */
/***/ (function(module, exports) {

	/* eslint-disable object-shorthand */
	'use strict';
	
	var colors = {
	  primary: '#37bad5',
	  secondary: 'black',
	  tertiary: 'white',
	  level1: '#ffbc00',
	  level2: '#8f288c',
	  level3: '#26a7df',
	  level4: '#e80a89',
	  level5: '#f59122',
	  level6: '#37b34a',
	  gameshow: '#742CBF',
	  question: '#45B3EC',
	  answer: '#6FC36E'
	};
	
	var fonts = {
	  primary: 'BrandonTextWeb',
	  secondary: 'Orbitron',
	  tertiary: 'Ubuntu'
	};
	
	module.exports = {
	  colors: colors,
	  fonts: fonts,
	  global: {
	    body: {
	      background: 'transparent',
	      fontFamily: fonts.primary,
	      fontWeight: 'normal',
	      fontSize: '2em',
	      color: colors.primary,
	      overflow: 'hidden'
	    },
	    'html, body': {
	      // height: '100%'
	    },
	    '*': {
	      boxSizing: 'border-box'
	    },
	    input: {
	      color: 'black',
	      fontWeight: 'bold',
	      backgroundColor: 'white',
	      fontSize: '2.66em',
	      fontFamily: fonts.primary,
	      padding: '0.25em 0.25em 0.2em',
	      margin: '1% 1% 3%',
	      width: '98%'
	    },
	    label: {
	      color: 'white',
	      fontWeight: 'bold',
	      fontSize: '1.8em',
	      margin: '0.1em 0 0'
	    }
	  },
	  progress: {
	    bar: {
	      container: {
	        position: 'absolute',
	        height: '22px',
	        width: '100%',
	        bottom: 0,
	        left: 0,
	        transition: 'all 1s ease-in-out 0.2s',
	        zIndex: 1000
	      },
	      bar: {
	        height: '100%',
	        background: colors.primary,
	        transition: 'all 0.3s ease-out',
	        fontSize: '12px',
	        letterSpacing: '0.1em',
	        textTransform: 'uppercase',
	        padding: '4px',
	        textAlign: 'right'
	      }
	    },
	    number: {
	      container: {
	        position: 'absolute',
	        bottom: 10,
	        right: 10,
	        zIndex: 1000,
	        color: colors.tertiary
	      }
	    }
	  },
	  components: {
	    codePane: {
	      pre: {
	        margin: 'auto',
	        fontSize: '1em',
	        fontWeight: 'normal',
	        fontFamily: fonts.tertiary,
	        minWidth: '100%',
	        maxWidth: 800
	      },
	      code: {
	        textAlign: 'left',
	        padding: 20,
	        fontWeight: 'normal'
	      }
	    },
	    code: {
	      color: 'black',
	      fontSize: '2.66em',
	      fontFamily: fonts.tertiary,
	      margin: '0.25em auto',
	      backgroundColor: 'rgba(0,0,0,0.15)',
	      padding: '0 10px',
	      borderRadius: 3
	    },
	    heading: {},
	    link: {
	      textDecoration: 'none'
	    },
	    listItem: {
	      fontSize: '2.66em',
	      padding: '0 0 0.5em'
	    },
	    list: {
	      textAlign: 'center',
	      listStyle: 'none',
	      padding: '0.5em 0'
	    },
	    s: {
	      strikethrough: {}
	    },
	    text: {
	      color: 'black',
	      fontSize: '2.66em',
	      fontFamily: fonts.primary,
	      margin: '0.25em auto',
	      textShadow: '0 0 10px rgba(0,0,0,0.2)'
	    }
	  }
	};

/***/ }),
/* 1024 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = __webpack_require__(7)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	function htmlSlide(_ref) {
	  var id = _ref.id;
	  var notes = _ref.notes;
	  var heading = _ref.heading;
	  var bgColor = _ref.bgColor;
	  var subHeading = _ref.subHeading;
	  var html = _ref.html;
	  var slideClass = _ref.slideClass;
	
	  var slideContentClass = slideClass ? ' slide-' + slideClass : '';
	  var bgColorOpts = {};
	  if (bgColor) {
	    bgColorOpts.bgColor = bgColor;
	  }
	  return _react2['default'].createElement(
	    _spectaclePpa.Slide,
	    _extends({
	      id: id,
	      key: id
	    }, bgColorOpts, {
	      notes: notes,
	      textColor: 'white' }),
	    _react2['default'].createElement(
	      'div',
	      { className: 'slide-content' + slideContentClass },
	      _react2['default'].createElement(
	        'div',
	        {
	          className: 'text-formatted' },
	        !!heading && _react2['default'].createElement(
	          _spectaclePpa.Heading,
	          { size: 3 },
	          heading
	        ),
	        !!subHeading && _react2['default'].createElement(
	          _spectaclePpa.Heading,
	          { size: 5 },
	          subHeading
	        ),
	        _react2['default'].createElement('div', {
	          dangerouslySetInnerHTML: { __html: html } })
	      )
	    )
	  );
	}
	
	exports['default'] = htmlSlide;
	module.exports = exports['default'];

/***/ }),
/* 1025 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = {
	  width: 1000,
	  height: 700,
	  margin: 40,
	  theme: __webpack_require__(1036),
	  print: __webpack_require__(53),
	  html: __webpack_require__(52)
	};

/***/ }),
/* 1026 */
/***/ (function(module, exports, __webpack_require__) {

	/* eslint no-console: 0 */
	
	'use strict';
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _helpersMarkdownScript = __webpack_require__(9);
	
	var _helpersMarkdownScript2 = _interopRequireDefault(_helpersMarkdownScript);
	
	var _indexMd = __webpack_require__(186);
	
	var _indexMd2 = _interopRequireDefault(_indexMd);
	
	var _extensionActivitiesExtensionActivitiesMd = __webpack_require__(1586);
	
	var _extensionActivitiesExtensionActivitiesMd2 = _interopRequireDefault(_extensionActivitiesExtensionActivitiesMd);
	
	var _programPrepProgramPrepMd = __webpack_require__(1589);
	
	var _programPrepProgramPrepMd2 = _interopRequireDefault(_programPrepProgramPrepMd);
	
	var _sections00_prepLevel1_prepMd = __webpack_require__(1590);
	
	var _sections00_prepLevel1_prepMd2 = _interopRequireDefault(_sections00_prepLevel1_prepMd);
	
	var _sections00_prepLevel2_prepMd = __webpack_require__(1591);
	
	var _sections00_prepLevel2_prepMd2 = _interopRequireDefault(_sections00_prepLevel2_prepMd);
	
	var _sections00_prepLevel3_prepMd = __webpack_require__(1592);
	
	var _sections00_prepLevel3_prepMd2 = _interopRequireDefault(_sections00_prepLevel3_prepMd);
	
	var _sections00_prepLevel4_prepMd = __webpack_require__(1593);
	
	var _sections00_prepLevel4_prepMd2 = _interopRequireDefault(_sections00_prepLevel4_prepMd);
	
	var _funMd = __webpack_require__(1587);
	
	var _funMd2 = _interopRequireDefault(_funMd);
	
	var _imagesEmergencyPreparednessSquadPng = __webpack_require__(2323);
	
	var _imagesEmergencyPreparednessSquadPng2 = _interopRequireDefault(_imagesEmergencyPreparednessSquadPng);
	
	var _imagesEmergencyPreparednessSquadTrialPng = __webpack_require__(2325);
	
	var _imagesEmergencyPreparednessSquadTrialPng2 = _interopRequireDefault(_imagesEmergencyPreparednessSquadTrialPng);
	
	var _imagesEmergencyPreparednessSquadExpiredPng = __webpack_require__(2324);
	
	var _imagesEmergencyPreparednessSquadExpiredPng2 = _interopRequireDefault(_imagesEmergencyPreparednessSquadExpiredPng);
	
	var _config = __webpack_require__(1025);
	
	var _config2 = _interopRequireDefault(_config);
	
	// Preload image functions
	
	var _sections20_gameShowGameShowSection = __webpack_require__(164);
	
	__webpack_require__(2188);
	
	var md = new _helpersMarkdownScript2['default'](_indexMd2['default']);
	
	var levels = {
	  prep: {
	    deck: __webpack_require__(1032)
	  },
	  1: {
	    thumbnail: __webpack_require__(420),
	    overviewThumbnail: __webpack_require__(2326),
	    deck: __webpack_require__(1027),
	    prep: new _helpersMarkdownScript2['default'](_sections00_prepLevel1_prepMd2['default']),
	    levelName: 'Know the Risks'
	  },
	  2: {
	    thumbnail: __webpack_require__(421),
	    overviewThumbnail: __webpack_require__(2327),
	    deck: __webpack_require__(1028),
	    prep: new _helpersMarkdownScript2['default'](_sections00_prepLevel2_prepMd2['default']),
	    levelName: 'Make a Plan'
	  },
	  3: {
	    thumbnail: __webpack_require__(422),
	    overviewThumbnail: __webpack_require__(2328),
	    deck: __webpack_require__(1029),
	    prep: new _helpersMarkdownScript2['default'](_sections00_prepLevel3_prepMd2['default']),
	    levelName: "Get a Kit"
	  },
	  4: {
	    thumbnail: __webpack_require__(876),
	    overviewThumbnail: __webpack_require__(2329),
	    deck: __webpack_require__(1030),
	    prep: new _helpersMarkdownScript2['default'](_sections00_prepLevel4_prepMd2['default']),
	    levelName: "We're In This Together"
	  },
	  completed: {
	    deck: __webpack_require__(1031)
	  }
	};
	
	var program = {
	  id: 'epsIntermediates',
	  title: md.getSectionAsString('Title - Short'),
	  longTitle: md.getSectionAsString('Title - Long'),
	  thumbnailImage: _imagesEmergencyPreparednessSquadPng2['default'],
	  trialImageThumb: _imagesEmergencyPreparednessSquadTrialPng2['default'],
	  expiredImageThumb: _imagesEmergencyPreparednessSquadExpiredPng2['default'],
	  longDescription: md.getSectionAsString('Description - Long'),
	  shortDescription: md.getSectionAsString('Description - Short'),
	  levelsDescription: md.getSectionAsString('Description - Levels'),
	  levels: levels,
	  extensionActivitiesMd: new _helpersMarkdownScript2['default'](_extensionActivitiesExtensionActivitiesMd2['default']),
	  programPrepMd: new _helpersMarkdownScript2['default'](_programPrepProgramPrepMd2['default']),
	  funMd: new _helpersMarkdownScript2['default'](_funMd2['default']),
	  preload: function preload(_ref) {
	    var level = _ref.level;
	
	    console.log('Preloading assets for Level ' + level);
	
	    (0, _sections20_gameShowGameShowSection.preloadGameShow)();
	  },
	  config: _config2['default']
	};
	
	exports['default'] = program;
	module.exports = exports['default'];

/***/ }),
/* 1027 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(__filename) {'use strict';
	
	var _get = __webpack_require__(8)['default'];
	
	var _inherits = __webpack_require__(5)['default'];
	
	var _createClass = __webpack_require__(6)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _helpersMarkdownScript = __webpack_require__(9);
	
	var _helpersMarkdownScript2 = _interopRequireDefault(_helpersMarkdownScript);
	
	var _indexMd = __webpack_require__(186);
	
	var _indexMd2 = _interopRequireDefault(_indexMd);
	
	var _sections01_startStartSection = __webpack_require__(208);
	
	var _sections01_startStartSection2 = _interopRequireDefault(_sections01_startStartSection);
	
	var _sections03_songSongSection = __webpack_require__(209);
	
	var _sections03_songSongSection2 = _interopRequireDefault(_sections03_songSongSection);
	
	var _sections10_teamCreationTeamCreationSection = __webpack_require__(1034);
	
	var _sections10_teamCreationTeamCreationSection2 = _interopRequireDefault(_sections10_teamCreationTeamCreationSection);
	
	var _sections11_esGooberStoryEsGooberStorySection = __webpack_require__(210);
	
	var _sections11_esGooberStoryEsGooberStorySection2 = _interopRequireDefault(_sections11_esGooberStoryEsGooberStorySection);
	
	var _sections20_gameShowGameShowSection = __webpack_require__(164);
	
	var _sections20_gameShowGameShowSection2 = _interopRequireDefault(_sections20_gameShowGameShowSection);
	
	var _sections30_classActivityClassActivitySection = __webpack_require__(211);
	
	var _sections30_classActivityClassActivitySection2 = _interopRequireDefault(_sections30_classActivityClassActivitySection);
	
	var _sections70_missionAssignmentMissionAssignmentSection = __webpack_require__(212);
	
	var _sections70_missionAssignmentMissionAssignmentSection2 = _interopRequireDefault(_sections70_missionAssignmentMissionAssignmentSection);
	
	var _sections90_finishFinishSection = __webpack_require__(213);
	
	var _sections90_finishFinishSection2 = _interopRequireDefault(_sections90_finishFinishSection);
	
	var md = new _helpersMarkdownScript2['default'](_indexMd2['default']);
	var level = Number(__filename.replace(/^.*level/, '').replace('.jsx', ''));
	var title = md.getSectionMetadata('Level ' + level, 'Title');
	
	var _default = (function (_Component) {
	  _inherits(_default, _Component);
	
	  function _default() {
	    _classCallCheck(this, _default);
	
	    _get(Object.getPrototypeOf(_default.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(_default, [{
	    key: 'render',
	    value: function render() {
	      var regionData = this.context.regionData;
	
	      return _react2['default'].createElement(
	        _spectaclePpa.Deck,
	        { transition: ['slide'],
	          transitionDuration: 800,
	          progress: 'bar' },
	        (0, _sections01_startStartSection2['default'])({ level: level, title: title, regionData: regionData }),
	        (0, _sections03_songSongSection2['default'])({ level: level, regionData: regionData }),
	        (0, _sections10_teamCreationTeamCreationSection2['default'])({ regionData: regionData }),
	        (0, _sections11_esGooberStoryEsGooberStorySection2['default'])({ level: level, regionData: regionData }),
	        (0, _sections30_classActivityClassActivitySection2['default'])({ level: level, regionData: regionData }),
	        (0, _sections20_gameShowGameShowSection2['default'])({ level: level, regionData: regionData }),
	        (0, _sections70_missionAssignmentMissionAssignmentSection2['default'])({ level: level, title: title, regionData: regionData }),
	        (0, _sections90_finishFinishSection2['default'])({ level: level, regionData: regionData })
	      );
	    }
	  }], [{
	    key: 'contextTypes',
	    value: {
	      regionData: _react.PropTypes.object.isRequired
	    },
	    enumerable: true
	  }, {
	    key: 'metadata',
	    value: {
	      title: title
	    },
	    enumerable: true
	  }]);

	  return _default;
	})(_react.Component);

	exports['default'] = _default;
	module.exports = exports['default'];
	/* Start */ /* Theme Song */ /* Team Creation */ /* Esmeralda & Goober Story */ /* Top ten emergencies */ /* Game Show */ /* Mission Assignment */ /* Finish */
	/* WEBPACK VAR INJECTION */}.call(exports, "programs/epsIntermediates/level1.jsx"))

/***/ }),
/* 1028 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(__filename) {'use strict';
	
	var _get = __webpack_require__(8)['default'];
	
	var _inherits = __webpack_require__(5)['default'];
	
	var _createClass = __webpack_require__(6)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _helpersMarkdownScript = __webpack_require__(9);
	
	var _helpersMarkdownScript2 = _interopRequireDefault(_helpersMarkdownScript);
	
	var _indexMd = __webpack_require__(186);
	
	var _indexMd2 = _interopRequireDefault(_indexMd);
	
	var _sections01_startStartSection = __webpack_require__(208);
	
	var _sections01_startStartSection2 = _interopRequireDefault(_sections01_startStartSection);
	
	var _sections03_songSongSection = __webpack_require__(209);
	
	var _sections03_songSongSection2 = _interopRequireDefault(_sections03_songSongSection);
	
	var _sections11_esGooberStoryEsGooberStorySection = __webpack_require__(210);
	
	var _sections11_esGooberStoryEsGooberStorySection2 = _interopRequireDefault(_sections11_esGooberStoryEsGooberStorySection);
	
	var _sections12_missionReportMissionReportSection = __webpack_require__(294);
	
	var _sections12_missionReportMissionReportSection2 = _interopRequireDefault(_sections12_missionReportMissionReportSection);
	
	var _sections20_gameShowGameShowSection = __webpack_require__(164);
	
	var _sections20_gameShowGameShowSection2 = _interopRequireDefault(_sections20_gameShowGameShowSection);
	
	var _sections30_classActivityClassActivitySection = __webpack_require__(211);
	
	var _sections30_classActivityClassActivitySection2 = _interopRequireDefault(_sections30_classActivityClassActivitySection);
	
	var _sections70_missionAssignmentMissionAssignmentSection = __webpack_require__(212);
	
	var _sections70_missionAssignmentMissionAssignmentSection2 = _interopRequireDefault(_sections70_missionAssignmentMissionAssignmentSection);
	
	var _sections90_finishFinishSection = __webpack_require__(213);
	
	var _sections90_finishFinishSection2 = _interopRequireDefault(_sections90_finishFinishSection);
	
	var md = new _helpersMarkdownScript2['default'](_indexMd2['default']);
	var level = Number(__filename.replace(/^.*level/, '').replace('.jsx', ''));
	var title = md.getSectionMetadata('Level ' + level, 'Title');
	
	var _default = (function (_Component) {
	  _inherits(_default, _Component);
	
	  function _default() {
	    _classCallCheck(this, _default);
	
	    _get(Object.getPrototypeOf(_default.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(_default, [{
	    key: 'render',
	    value: function render() {
	      var regionData = this.context.regionData;
	
	      return _react2['default'].createElement(
	        _spectaclePpa.Deck,
	        { transition: ['slide'],
	          transitionDuration: 800,
	          progress: 'bar' },
	        (0, _sections01_startStartSection2['default'])({ level: level, title: title, regionData: regionData }),
	        (0, _sections03_songSongSection2['default'])({ level: level, regionData: regionData }),
	        (0, _sections12_missionReportMissionReportSection2['default'])({ level: level, regionData: regionData }),
	        (0, _sections11_esGooberStoryEsGooberStorySection2['default'])({ level: level, regionData: regionData }),
	        (0, _sections20_gameShowGameShowSection2['default'])({ level: level, regionData: regionData }),
	        (0, _sections30_classActivityClassActivitySection2['default'])({ level: level, regionData: regionData }),
	        (0, _sections70_missionAssignmentMissionAssignmentSection2['default'])({ level: level, title: title, regionData: regionData }),
	        (0, _sections90_finishFinishSection2['default'])({ level: level, regionData: regionData })
	      );
	    }
	  }], [{
	    key: 'contextTypes',
	    value: {
	      regionData: _react.PropTypes.object.isRequired
	    },
	    enumerable: true
	  }, {
	    key: 'metadata',
	    value: {
	      title: title
	    },
	    enumerable: true
	  }]);

	  return _default;
	})(_react.Component);

	exports['default'] = _default;
	module.exports = exports['default'];
	/* Start */ /* Theme Song */ /* Mission Report */ /* Esmeralda & Goober Story */ /* Game Show */ /* Class Activity: Floorplan */ /* Mission Assignment */ /* Finish */
	/* WEBPACK VAR INJECTION */}.call(exports, "programs/epsIntermediates/level2.jsx"))

/***/ }),
/* 1029 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(__filename) {'use strict';
	
	var _get = __webpack_require__(8)['default'];
	
	var _inherits = __webpack_require__(5)['default'];
	
	var _createClass = __webpack_require__(6)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _helpersMarkdownScript = __webpack_require__(9);
	
	var _helpersMarkdownScript2 = _interopRequireDefault(_helpersMarkdownScript);
	
	var _indexMd = __webpack_require__(186);
	
	var _indexMd2 = _interopRequireDefault(_indexMd);
	
	var _sections01_startStartSection = __webpack_require__(208);
	
	var _sections01_startStartSection2 = _interopRequireDefault(_sections01_startStartSection);
	
	var _sections03_songSongSection = __webpack_require__(209);
	
	var _sections03_songSongSection2 = _interopRequireDefault(_sections03_songSongSection);
	
	var _sections11_esGooberStoryEsGooberStorySection = __webpack_require__(210);
	
	var _sections11_esGooberStoryEsGooberStorySection2 = _interopRequireDefault(_sections11_esGooberStoryEsGooberStorySection);
	
	var _sections12_missionReportMissionReportSection = __webpack_require__(294);
	
	var _sections12_missionReportMissionReportSection2 = _interopRequireDefault(_sections12_missionReportMissionReportSection);
	
	var _sections20_gameShowGameShowSection = __webpack_require__(164);
	
	var _sections20_gameShowGameShowSection2 = _interopRequireDefault(_sections20_gameShowGameShowSection);
	
	var _sections30_classActivityClassActivitySection = __webpack_require__(211);
	
	var _sections30_classActivityClassActivitySection2 = _interopRequireDefault(_sections30_classActivityClassActivitySection);
	
	var _sections70_missionAssignmentMissionAssignmentSection = __webpack_require__(212);
	
	var _sections70_missionAssignmentMissionAssignmentSection2 = _interopRequireDefault(_sections70_missionAssignmentMissionAssignmentSection);
	
	var _sections90_finishFinishSection = __webpack_require__(213);
	
	var _sections90_finishFinishSection2 = _interopRequireDefault(_sections90_finishFinishSection);
	
	var md = new _helpersMarkdownScript2['default'](_indexMd2['default']);
	var level = Number(__filename.replace(/^.*level/, '').replace('.jsx', ''));
	var title = md.getSectionMetadata('Level ' + level, 'Title');
	
	var _default = (function (_Component) {
	  _inherits(_default, _Component);
	
	  function _default() {
	    _classCallCheck(this, _default);
	
	    _get(Object.getPrototypeOf(_default.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(_default, [{
	    key: 'render',
	    value: function render() {
	      var regionData = this.context.regionData;
	
	      return _react2['default'].createElement(
	        _spectaclePpa.Deck,
	        { transition: ['slide'],
	          transitionDuration: 800,
	          progress: 'bar' },
	        (0, _sections01_startStartSection2['default'])({ level: level, title: title, regionData: regionData }),
	        (0, _sections03_songSongSection2['default'])({ level: level, regionData: regionData }),
	        (0, _sections11_esGooberStoryEsGooberStorySection2['default'])({ level: level, regionData: regionData }),
	        (0, _sections12_missionReportMissionReportSection2['default'])({ level: level, regionData: regionData }),
	        (0, _sections20_gameShowGameShowSection2['default'])({ level: level, regionData: regionData }),
	        (0, _sections30_classActivityClassActivitySection2['default'])({ level: level, regionData: regionData }),
	        (0, _sections70_missionAssignmentMissionAssignmentSection2['default'])({ level: level, title: title, regionData: regionData }),
	        (0, _sections90_finishFinishSection2['default'])({ level: level, regionData: regionData })
	      );
	    }
	  }], [{
	    key: 'contextTypes',
	    value: {
	      regionData: _react.PropTypes.object.isRequired
	    },
	    enumerable: true
	  }, {
	    key: 'metadata',
	    value: {
	      title: title
	    },
	    enumerable: true
	  }]);

	  return _default;
	})(_react.Component);

	exports['default'] = _default;
	module.exports = exports['default'];
	/* Start */ /* Theme Song */ /* Esmeralda & Goober Story */ /* Mission Report */ /* Game Show */ /* Class Activity: Kit rap */ /* Mission Assignment */ /* Finish */
	/* WEBPACK VAR INJECTION */}.call(exports, "programs/epsIntermediates/level3.jsx"))

/***/ }),
/* 1030 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(__filename) {'use strict';
	
	var _get = __webpack_require__(8)['default'];
	
	var _inherits = __webpack_require__(5)['default'];
	
	var _createClass = __webpack_require__(6)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _helpersMarkdownScript = __webpack_require__(9);
	
	var _helpersMarkdownScript2 = _interopRequireDefault(_helpersMarkdownScript);
	
	var _indexMd = __webpack_require__(186);
	
	var _indexMd2 = _interopRequireDefault(_indexMd);
	
	var _sections01_startStartSection = __webpack_require__(208);
	
	var _sections01_startStartSection2 = _interopRequireDefault(_sections01_startStartSection);
	
	var _sections03_songSongSection = __webpack_require__(209);
	
	var _sections03_songSongSection2 = _interopRequireDefault(_sections03_songSongSection);
	
	var _sections11_esGooberStoryEsGooberStorySection = __webpack_require__(210);
	
	var _sections11_esGooberStoryEsGooberStorySection2 = _interopRequireDefault(_sections11_esGooberStoryEsGooberStorySection);
	
	var _sections12_missionReportMissionReportSection = __webpack_require__(294);
	
	var _sections12_missionReportMissionReportSection2 = _interopRequireDefault(_sections12_missionReportMissionReportSection);
	
	var _sections20_gameShowGameShowSection = __webpack_require__(164);
	
	var _sections20_gameShowGameShowSection2 = _interopRequireDefault(_sections20_gameShowGameShowSection);
	
	var _sections30_classActivityClassActivitySection = __webpack_require__(211);
	
	var _sections30_classActivityClassActivitySection2 = _interopRequireDefault(_sections30_classActivityClassActivitySection);
	
	var _sections70_missionAssignmentMissionAssignmentSection = __webpack_require__(212);
	
	var _sections70_missionAssignmentMissionAssignmentSection2 = _interopRequireDefault(_sections70_missionAssignmentMissionAssignmentSection);
	
	var _sections95_endingEndingSection = __webpack_require__(1035);
	
	var _sections95_endingEndingSection2 = _interopRequireDefault(_sections95_endingEndingSection);
	
	var _sections90_finishFinishSection = __webpack_require__(213);
	
	var _sections90_finishFinishSection2 = _interopRequireDefault(_sections90_finishFinishSection);
	
	var md = new _helpersMarkdownScript2['default'](_indexMd2['default']);
	var level = Number(__filename.replace(/^.*level/, '').replace('.jsx', ''));
	var title = md.getSectionMetadata('Level ' + level, 'Title');
	
	var _default = (function (_Component) {
	  _inherits(_default, _Component);
	
	  function _default() {
	    _classCallCheck(this, _default);
	
	    _get(Object.getPrototypeOf(_default.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(_default, [{
	    key: 'render',
	    value: function render() {
	      var regionData = this.context.regionData;
	
	      return _react2['default'].createElement(
	        _spectaclePpa.Deck,
	        { transition: ['slide'],
	          transitionDuration: 800,
	          progress: 'bar' },
	        (0, _sections01_startStartSection2['default'])({ level: level, title: title, regionData: regionData }),
	        (0, _sections03_songSongSection2['default'])({ level: level, regionData: regionData }),
	        (0, _sections12_missionReportMissionReportSection2['default'])({ level: level, regionData: regionData }),
	        (0, _sections11_esGooberStoryEsGooberStorySection2['default'])({ level: level, regionData: regionData }),
	        (0, _sections20_gameShowGameShowSection2['default'])({ level: level, regionData: regionData }),
	        (0, _sections30_classActivityClassActivitySection2['default'])({ level: level, regionData: regionData }),
	        (0, _sections95_endingEndingSection2['default'])({ regionData: regionData }),
	        (0, _sections70_missionAssignmentMissionAssignmentSection2['default'])({ level: level, title: title, regionData: regionData }),
	        (0, _sections90_finishFinishSection2['default'])({ level: level, regionData: regionData })
	      );
	    }
	  }], [{
	    key: 'contextTypes',
	    value: {
	      regionData: _react.PropTypes.object.isRequired
	    },
	    enumerable: true
	  }, {
	    key: 'metadata',
	    value: {
	      title: title
	    },
	    enumerable: true
	  }]);

	  return _default;
	})(_react.Component);

	exports['default'] = _default;
	module.exports = exports['default'];
	/* Start */ /* Theme Song */ /* Mission Report */ /* Esmeralda & Goober Story */ /* Game Show */ /* Class Activity: Drawing */ /* Ending */ /* Mission Assignment */ /* Finish */
	/* WEBPACK VAR INJECTION */}.call(exports, "programs/epsIntermediates/level4.jsx"))

/***/ }),
/* 1031 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _get = __webpack_require__(8)['default'];
	
	var _inherits = __webpack_require__(5)['default'];
	
	var _createClass = __webpack_require__(6)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _baseSlidesBalloonSlide = __webpack_require__(87);
	
	var _baseSlidesBalloonSlide2 = _interopRequireDefault(_baseSlidesBalloonSlide);
	
	var _imagesCharactersSara_gigglePng = __webpack_require__(873);
	
	var _imagesCharactersSara_gigglePng2 = _interopRequireDefault(_imagesCharactersSara_gigglePng);
	
	var _helpersMarkdownScript = __webpack_require__(9);
	
	var _helpersMarkdownScript2 = _interopRequireDefault(_helpersMarkdownScript);
	
	var _levelCompletedMd = __webpack_require__(1588);
	
	var _levelCompletedMd2 = _interopRequireDefault(_levelCompletedMd);
	
	var md = new _helpersMarkdownScript2['default'](_levelCompletedMd2['default']);
	
	var _default = (function (_Component) {
	  _inherits(_default, _Component);
	
	  function _default() {
	    _classCallCheck(this, _default);
	
	    _get(Object.getPrototypeOf(_default.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(_default, [{
	    key: 'render',
	    value: function render() {
	      var regionData = this.context.regionData;
	
	      return _react2['default'].createElement(
	        _spectaclePpa.Deck,
	        { transition: ['slide'],
	          transitionDuration: 800,
	          progress: 'bar' },
	        (0, _baseSlidesBalloonSlide2['default'])({
	          id: 'welcome-back',
	          characterSide: 'right',
	          characterImage: _imagesCharactersSara_gigglePng2['default'],
	          notes: md.getSubSectionAsHtml('Level Completed', 'Notes', false, regionData),
	          html: md.getSubSectionAsHtml('Level Completed', 'Content', false, regionData),
	          bgColor: '#37b34a'
	        })
	      );
	    }
	  }], [{
	    key: 'contextTypes',
	    value: {
	      regionData: _react.PropTypes.object.isRequired
	    },
	    enumerable: true
	  }]);

	  return _default;
	})(_react.Component);

	exports['default'] = _default;
	module.exports = exports['default'];

/***/ }),
/* 1032 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _get = __webpack_require__(8)['default'];
	
	var _inherits = __webpack_require__(5)['default'];
	
	var _createClass = __webpack_require__(6)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _componentsStartLevel = __webpack_require__(79);
	
	var _componentsStartLevel2 = _interopRequireDefault(_componentsStartLevel);
	
	var _sections00_prepPrepSection = __webpack_require__(1033);
	
	var _sections00_prepPrepSection2 = _interopRequireDefault(_sections00_prepPrepSection);
	
	var _default = (function (_Component) {
	  _inherits(_default, _Component);
	
	  function _default() {
	    _classCallCheck(this, _default);
	
	    _get(Object.getPrototypeOf(_default.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(_default, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var level = _props.nextLevel;
	      var configuration = _props.configuration;
	      var regionData = this.context.regionData;
	
	      return _react2['default'].createElement(
	        _spectaclePpa.Deck,
	        { transition: ['slide'],
	          transitionDuration: 800,
	          progress: 'bar' },
	        (0, _sections00_prepPrepSection2['default'])({ level: level, configuration: configuration, regionData: regionData }),
	        _react2['default'].createElement(
	          _spectaclePpa.Slide,
	          {
	            id: 'start',
	            textColor: 'white' },
	          _react2['default'].createElement(_componentsStartLevel2['default'], null)
	        )
	      );
	    }
	  }], [{
	    key: 'propTypes',
	    value: {
	      nextLevel: _react.PropTypes.string.isRequired,
	      configuration: _react.PropTypes.string
	    },
	    enumerable: true
	  }, {
	    key: 'contextTypes',
	    value: {
	      regionData: _react.PropTypes.object.isRequired
	    },
	    enumerable: true
	  }]);

	  return _default;
	})(_react.Component);

	exports['default'] = _default;
	module.exports = exports['default'];
	/* Prep */

/***/ }),
/* 1033 */
/***/ (function(module, exports, __webpack_require__) {

	/* eslint react/no-multi-comp: 0 */
	
	'use strict';
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _componentsSelectConfiguration = __webpack_require__(77);
	
	var _componentsSelectConfiguration2 = _interopRequireDefault(_componentsSelectConfiguration);
	
	var _componentsSelectDeviceRole = __webpack_require__(78);
	
	var _componentsSelectDeviceRole2 = _interopRequireDefault(_componentsSelectDeviceRole);
	
	var _baseSlidesHtmlSlide = __webpack_require__(1024);
	
	var _baseSlidesHtmlSlide2 = _interopRequireDefault(_baseSlidesHtmlSlide);
	
	var _baseSlidesHeadingSlide = __webpack_require__(163);
	
	var _baseSlidesHeadingSlide2 = _interopRequireDefault(_baseSlidesHeadingSlide);
	
	var _baseSlidesVideoSlide = __webpack_require__(57);
	
	var _baseSlidesVideoSlide2 = _interopRequireDefault(_baseSlidesVideoSlide);
	
	var _helpersMarkdownScript = __webpack_require__(9);
	
	var _helpersMarkdownScript2 = _interopRequireDefault(_helpersMarkdownScript);
	
	var _tech_prepMd = __webpack_require__(1594);
	
	var _tech_prepMd2 = _interopRequireDefault(_tech_prepMd);
	
	var techPrepMd = new _helpersMarkdownScript2['default'](_tech_prepMd2['default']);
	
	function techPrepWizard(_ref) {
	  var regionData = _ref.regionData;
	
	  return (0, _baseSlidesHtmlSlide2['default'])({
	    id: 'tech-prep-wizard',
	    html: techPrepMd.getSectionAsHtml('Tech Prep Wizard', false, regionData)
	  });
	}
	
	function twoDeviceIntro(_ref2) {
	  var regionData = _ref2.regionData;
	
	  return (0, _baseSlidesHtmlSlide2['default'])({
	    id: 'two-device-intro',
	    html: techPrepMd.getSectionAsHtml('Two Device Intro', false, regionData)
	  });
	}
	
	function selectConfiguration() {
	  return _react2['default'].createElement(
	    _spectaclePpa.Slide,
	    {
	      id: 'configuration',
	      textColor: 'white' },
	    _react2['default'].createElement(_componentsSelectConfiguration2['default'], null)
	  );
	}
	
	function connectingRemote(_ref3) {
	  var configuration = _ref3.configuration;
	  var regionData = _ref3.regionData;
	
	  if (configuration === 'dualScreen') {
	    return (0, _baseSlidesHtmlSlide2['default'])({
	      id: 'connecting-remote',
	      html: techPrepMd.getSectionAsHtml('Connecting Remote', false, regionData)
	    });
	  } else {
	    return null;
	  }
	}
	
	function selectDeviceRole(configuration) {
	  if (configuration === 'dualScreen') {
	    return _react2['default'].createElement(
	      _spectaclePpa.Slide,
	      {
	        id: 'device-role',
	        textColor: 'white' },
	      _react2['default'].createElement(_componentsSelectDeviceRole2['default'], null)
	    );
	  } else {
	    return null;
	  }
	}
	
	function techCheckIntro(_ref4) {
	  var regionData = _ref4.regionData;
	
	  return (0, _baseSlidesHtmlSlide2['default'])({
	    id: 'tech-check-intro',
	    html: techPrepMd.getSectionAsHtml('Tech Check Intro', false, regionData)
	  });
	}
	
	function techCheckVideo(_ref5) {
	  var regionData = _ref5.regionData;
	
	  return (0, _baseSlidesVideoSlide2['default'])({
	    id: 'tech-check-video',
	    youTubeId: techPrepMd.getSectionMetadata('Tech Check Video', 'YouTube', regionData)
	  });
	}
	
	function levelPrep(_ref6) {
	  var configuration = _ref6.configuration;
	  var regionData = _ref6.regionData;
	
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'prep' },
	    techPrepWizard({ regionData: regionData }),
	    twoDeviceIntro({ regionData: regionData }),
	    selectConfiguration(),
	    connectingRemote({ configuration: configuration, regionData: regionData }),
	    selectDeviceRole(configuration),
	    techCheckIntro({ regionData: regionData }),
	    techCheckVideo({ regionData: regionData })
	  );
	}
	
	function levelCompletedPrep(_ref7) {
	  var configuration = _ref7.configuration;
	  var regionData = _ref7.regionData;
	
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'prep' },
	    selectConfiguration(),
	    connectingRemote({ configuration: configuration, regionData: regionData }),
	    selectDeviceRole(configuration)
	  );
	}
	
	function prepSection(_ref8) {
	  var level = _ref8.level;
	  var configuration = _ref8.configuration;
	  var regionData = _ref8.regionData;
	
	  switch (level) {
	    case '1':
	      return levelPrep({ configuration: configuration, regionData: regionData });
	    case '2':
	      return levelPrep({ configuration: configuration, regionData: regionData });
	    case '3':
	      return levelPrep({ configuration: configuration, regionData: regionData });
	    case '4':
	      return levelPrep({ configuration: configuration, regionData: regionData });
	    case 'completed':
	      return levelCompletedPrep({ configuration: configuration, regionData: regionData });
	    default:
	      return (0, _baseSlidesHeadingSlide2['default'])({ heading: 'Unknown' });
	  }
	}
	
	exports['default'] = prepSection;
	module.exports = exports['default'];
	/* Tech Prep Wizard */ /* Two Device Intro */ /* Select Configuration */ /* Connecting Remote Instructions */ /* Select Device Role */ /* Tech Check Intro */ /* Tech Check Video */ /* Start Level */ /* Select Configuration */ /* Connecting Remote */ /* Select Device Role */

/***/ }),
/* 1034 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.preloadGameShow = preloadGameShow;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _componentsTeamNames = __webpack_require__(60);
	
	var _componentsTeamNames2 = _interopRequireDefault(_componentsTeamNames);
	
	var _baseSlidesVideoSlide = __webpack_require__(57);
	
	var _baseSlidesVideoSlide2 = _interopRequireDefault(_baseSlidesVideoSlide);
	
	var _baseSlidesBalloonSlide = __webpack_require__(87);
	
	var _baseSlidesBalloonSlide2 = _interopRequireDefault(_baseSlidesBalloonSlide);
	
	var _helpersMarkdownScript = __webpack_require__(9);
	
	var _helpersMarkdownScript2 = _interopRequireDefault(_helpersMarkdownScript);
	
	var _teamCreationMd = __webpack_require__(1597);
	
	var _teamCreationMd2 = _interopRequireDefault(_teamCreationMd);
	
	var _imagesCharactersSara_twist_hands_out_heyheyPng = __webpack_require__(875);
	
	var _imagesCharactersSara_twist_hands_out_heyheyPng2 = _interopRequireDefault(_imagesCharactersSara_twist_hands_out_heyheyPng);
	
	var _imagesCharactersIan_arms_foldedPng = __webpack_require__(870);
	
	var _imagesCharactersIan_arms_foldedPng2 = _interopRequireDefault(_imagesCharactersIan_arms_foldedPng);
	
	var _imagesCharactersSara_gigglePng = __webpack_require__(873);
	
	var _imagesCharactersSara_gigglePng2 = _interopRequireDefault(_imagesCharactersSara_gigglePng);
	
	var _imagesCharactersIan_pointing_upPng = __webpack_require__(416);
	
	var _imagesCharactersIan_pointing_upPng2 = _interopRequireDefault(_imagesCharactersIan_pointing_upPng);
	
	var md = new _helpersMarkdownScript2['default'](_teamCreationMd2['default']);
	
	function preloadGameShow() {
	  (0, _spectaclePpa.preloader)([_imagesCharactersSara_twist_hands_out_heyheyPng2['default'], _imagesCharactersIan_arms_foldedPng2['default'], _imagesCharactersSara_gigglePng2['default']]);
	}
	
	function teamCreationSection(_ref) {
	  var regionData = _ref.regionData;
	
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'team-creation' },
	    (0, _baseSlidesVideoSlide2['default'])({
	      id: 'intro-team-names',
	      notes: md.getSubSectionAsHtml('Intro Team Names', 'Notes', false, regionData),
	      youTubeId: md.getSectionMetadata('Intro Team Names', 'YouTube', regionData)
	    }),
	    (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'get-into-teams',
	      characterSide: 'right',
	      characterImage: _imagesCharactersSara_gigglePng2['default'],
	      notes: md.getSubSectionAsHtml('Get Into Teams', 'Notes', false, regionData),
	      html: md.getSubSectionAsHtml('Get Into Teams', 'Content', false, regionData)
	    }),
	    _react2['default'].createElement(
	      _spectaclePpa.Slide,
	      {
	        id: 'assign',
	        bgColor: 'black',
	        notes: '<h2>Assign Team Names</h2>',
	        teamNames: true },
	      _react2['default'].createElement(
	        'div',
	        { className: 'ui-slide' },
	        _react2['default'].createElement(
	          _spectaclePpa.Heading,
	          { size: 1 },
	          'Name your teams!'
	        ),
	        _react2['default'].createElement(_componentsTeamNames2['default'], null)
	      )
	    ),
	    (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'scoring-intro',
	      characterSide: 'right',
	      characterImage: _imagesCharactersIan_arms_foldedPng2['default'],
	      notes: md.getSubSectionAsHtml('Scoring Intro', 'Notes', false, regionData),
	      html: md.getSubSectionAsHtml('Scoring Intro', 'Content', false, regionData)
	    }),
	    (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'scoreboard-intro',
	      characterSide: 'left',
	      characterImage: _imagesCharactersIan_pointing_upPng2['default'],
	      notes: md.getSubSectionAsHtml('Scoreboard Intro', 'Notes', false, regionData),
	      html: md.getSubSectionAsHtml('Scoreboard Intro', 'Content', false, regionData)
	    }),
	    (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'congratulations',
	      characterSide: 'right',
	      characterImage: _imagesCharactersSara_twist_hands_out_heyheyPng2['default'],
	      notes: md.getSubSectionAsHtml('Congratulations', 'Notes', false, regionData),
	      html: md.getSubSectionAsHtml('Congratulations', 'Content', false, regionData)
	    })
	  );
	}
	
	exports['default'] = teamCreationSection;
	/* Sara and Ian welcome to Academy */ /* Get into teams and come up with a cool name */ /* Enter team names */ /* Scoring intro */ /* Introduce scoreboard */ /* Congratulations */

/***/ }),
/* 1035 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.preloadEnding = preloadEnding;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _baseSlidesBalloonSlide = __webpack_require__(87);
	
	var _baseSlidesBalloonSlide2 = _interopRequireDefault(_baseSlidesBalloonSlide);
	
	var _baseSlidesHeadingSlide = __webpack_require__(163);
	
	var _baseSlidesHeadingSlide2 = _interopRequireDefault(_baseSlidesHeadingSlide);
	
	var _imagesEmergencyPreparednessSquadGlowPng = __webpack_require__(419);
	
	var _imagesEmergencyPreparednessSquadGlowPng2 = _interopRequireDefault(_imagesEmergencyPreparednessSquadGlowPng);
	
	var _imagesCharactersIan_hand_raisedPng = __webpack_require__(2315);
	
	var _imagesCharactersIan_hand_raisedPng2 = _interopRequireDefault(_imagesCharactersIan_hand_raisedPng);
	
	var _imagesCharactersIan_sara_sidePng = __webpack_require__(154);
	
	var _imagesCharactersIan_sara_sidePng2 = _interopRequireDefault(_imagesCharactersIan_sara_sidePng);
	
	var _helpersMarkdownScript = __webpack_require__(9);
	
	var _helpersMarkdownScript2 = _interopRequireDefault(_helpersMarkdownScript);
	
	var _endingMd = __webpack_require__(1618);
	
	var _endingMd2 = _interopRequireDefault(_endingMd);
	
	var md = new _helpersMarkdownScript2['default'](_endingMd2['default']);
	
	function preloadEnding() {
	  (0, _spectaclePpa.preloader)([_imagesCharactersIan_hand_raisedPng2['default'], _imagesCharactersIan_sara_sidePng2['default'], _imagesEmergencyPreparednessSquadGlowPng2['default']]);
	}
	
	function endingSection(_ref) {
	  var regionData = _ref.regionData;
	
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'ending' },
	    (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'announce-winners',
	      characterSide: 'right',
	      characterImage: _imagesCharactersIan_hand_raisedPng2['default'],
	      html: md.getSubSectionAsHtml('Announce Winners', 'Content', false, regionData),
	      notes: md.getSubSectionAsHtml('Announce Winners', 'Notes', false, regionData)
	    }),
	    (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'members-of-eps',
	      characterSide: 'right',
	      characterImage: _imagesCharactersIan_sara_sidePng2['default'],
	      html: md.getSubSectionAsHtml('Members EPS', 'Content', false, regionData),
	      notes: md.getSubSectionAsHtml('Members EPS', 'Notes', false, regionData)
	    }),
	    (0, _baseSlidesHeadingSlide2['default'])({
	      id: 'completed',
	      beforeImage: _imagesEmergencyPreparednessSquadGlowPng2['default'],
	      subHeading: 'All levels completed!!!',
	      notes: md.getSubSectionAsHtml('All Levels Completed', 'Notes', false, regionData),
	      bgColor: 'black'
	    })
	  );
	}
	
	exports['default'] = endingSection;
	/* Time to see who won! */ /* You're now all members of the Emergency Preparedness Squad */ /* You've completed all the levels */

/***/ }),
/* 1036 */
/***/ (function(module, exports) {

	/* eslint-disable object-shorthand */
	'use strict';
	
	var colors = {
	  primary: '#37bad5',
	  secondary: 'black',
	  tertiary: 'white',
	  level1: '#ffbc00',
	  level2: '#8f288c',
	  level3: '#26a7df',
	  level4: '#e80a89',
	  level5: '#f59122',
	  level6: '#37b34a',
	  gameshow: '#742CBF',
	  question: '#45B3EC',
	  answer: '#6FC36E'
	};
	
	var fonts = {
	  primary: 'BrandonTextWeb',
	  secondary: 'Orbitron',
	  tertiary: 'Ubuntu'
	};
	
	module.exports = {
	  colors: colors,
	  fonts: fonts,
	  global: {
	    body: {
	      background: 'transparent',
	      fontFamily: fonts.primary,
	      fontWeight: 'normal',
	      fontSize: '2em',
	      color: colors.primary,
	      overflow: 'hidden'
	    },
	    'html, body': {
	      // height: '100%'
	    },
	    '*': {
	      boxSizing: 'border-box'
	    },
	    input: {
	      color: 'black',
	      fontWeight: 'bold',
	      backgroundColor: 'white',
	      fontSize: '2.66em',
	      fontFamily: fonts.primary,
	      padding: '0.25em 0.25em 0.2em',
	      margin: '1% 1% 3%',
	      width: '98%'
	    },
	    label: {
	      color: 'white',
	      fontWeight: 'bold',
	      fontSize: '1.8em',
	      margin: '0.1em 0 0'
	    }
	  },
	  progress: {
	    bar: {
	      container: {
	        position: 'absolute',
	        height: '22px',
	        width: '100%',
	        bottom: 0,
	        left: 0,
	        transition: 'all 1s ease-in-out 0.2s',
	        zIndex: 1000
	      },
	      bar: {
	        height: '100%',
	        background: colors.primary,
	        transition: 'all 0.3s ease-out',
	        fontSize: '12px',
	        letterSpacing: '0.1em',
	        textTransform: 'uppercase',
	        padding: '2px 4px',
	        textAlign: 'right'
	      }
	    },
	    number: {
	      container: {
	        position: 'absolute',
	        bottom: 10,
	        right: 10,
	        zIndex: 1000,
	        color: colors.tertiary
	      }
	    }
	  },
	  components: {
	    codePane: {
	      pre: {
	        margin: 'auto',
	        fontSize: '1em',
	        fontWeight: 'normal',
	        fontFamily: fonts.tertiary,
	        minWidth: '100%',
	        maxWidth: 800
	      },
	      code: {
	        textAlign: 'left',
	        padding: 20,
	        fontWeight: 'normal'
	      }
	    },
	    code: {
	      color: 'black',
	      fontSize: '2.66em',
	      fontFamily: fonts.tertiary,
	      margin: '0.25em auto',
	      backgroundColor: 'rgba(0,0,0,0.15)',
	      padding: '0 10px',
	      borderRadius: 3
	    },
	    heading: {},
	    link: {
	      textDecoration: 'none'
	    },
	    listItem: {
	      fontSize: '2.66em',
	      padding: '0 0 0.5em'
	    },
	    list: {
	      textAlign: 'center',
	      listStyle: 'none',
	      padding: '0.5em 0'
	    },
	    s: {
	      strikethrough: {}
	    },
	    text: {
	      color: 'black',
	      fontSize: '2.66em',
	      fontFamily: fonts.primary,
	      margin: '0.25em auto',
	      textShadow: '0 0 10px rgba(0,0,0,0.2)'
	    }
	  }
	};

/***/ }),
/* 1037 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = __webpack_require__(7)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	function htmlSlide(_ref) {
	  var id = _ref.id;
	  var notes = _ref.notes;
	  var heading = _ref.heading;
	  var bgColor = _ref.bgColor;
	  var subHeading = _ref.subHeading;
	  var html = _ref.html;
	  var slideClass = _ref.slideClass;
	
	  var slideContentClass = slideClass ? ' slide-' + slideClass : '';
	  var bgColorOpts = {};
	  if (bgColor) {
	    bgColorOpts.bgColor = bgColor;
	  }
	  return _react2['default'].createElement(
	    _spectaclePpa.Slide,
	    _extends({
	      id: id,
	      key: id
	    }, bgColorOpts, {
	      notes: notes,
	      textColor: 'white' }),
	    _react2['default'].createElement(
	      'div',
	      { className: 'slide-content' + slideContentClass },
	      _react2['default'].createElement(
	        'div',
	        {
	          className: 'text-formatted' },
	        !!heading && _react2['default'].createElement(
	          _spectaclePpa.Heading,
	          { size: 3 },
	          heading
	        ),
	        !!subHeading && _react2['default'].createElement(
	          _spectaclePpa.Heading,
	          { size: 5 },
	          subHeading
	        ),
	        _react2['default'].createElement('div', {
	          dangerouslySetInnerHTML: { __html: html } })
	      )
	    )
	  );
	}
	
	exports['default'] = htmlSlide;
	module.exports = exports['default'];

/***/ }),
/* 1038 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = {
	  width: 1000,
	  height: 700,
	  margin: 40,
	  theme: __webpack_require__(1049),
	  print: __webpack_require__(53),
	  html: __webpack_require__(52)
	};

/***/ }),
/* 1039 */
/***/ (function(module, exports, __webpack_require__) {

	/* eslint no-console: 0 */
	
	'use strict';
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _helpersMarkdownScript = __webpack_require__(9);
	
	var _helpersMarkdownScript2 = _interopRequireDefault(_helpersMarkdownScript);
	
	var _indexMd = __webpack_require__(187);
	
	var _indexMd2 = _interopRequireDefault(_indexMd);
	
	var _extensionActivitiesExtensionActivitiesMd = __webpack_require__(1619);
	
	var _extensionActivitiesExtensionActivitiesMd2 = _interopRequireDefault(_extensionActivitiesExtensionActivitiesMd);
	
	var _programPrepProgramPrepMd = __webpack_require__(1622);
	
	var _programPrepProgramPrepMd2 = _interopRequireDefault(_programPrepProgramPrepMd);
	
	var _sections00_prepLevel1_prepMd = __webpack_require__(1623);
	
	var _sections00_prepLevel1_prepMd2 = _interopRequireDefault(_sections00_prepLevel1_prepMd);
	
	var _sections00_prepLevel2_prepMd = __webpack_require__(1624);
	
	var _sections00_prepLevel2_prepMd2 = _interopRequireDefault(_sections00_prepLevel2_prepMd);
	
	var _sections00_prepLevel3_prepMd = __webpack_require__(1625);
	
	var _sections00_prepLevel3_prepMd2 = _interopRequireDefault(_sections00_prepLevel3_prepMd);
	
	var _sections00_prepLevel4_prepMd = __webpack_require__(1626);
	
	var _sections00_prepLevel4_prepMd2 = _interopRequireDefault(_sections00_prepLevel4_prepMd);
	
	var _funMd = __webpack_require__(1620);
	
	var _funMd2 = _interopRequireDefault(_funMd);
	
	var _imagesEmergencyPreparednessSquadPng = __webpack_require__(2345);
	
	var _imagesEmergencyPreparednessSquadPng2 = _interopRequireDefault(_imagesEmergencyPreparednessSquadPng);
	
	var _imagesEmergencyPreparednessSquadTrialPng = __webpack_require__(2347);
	
	var _imagesEmergencyPreparednessSquadTrialPng2 = _interopRequireDefault(_imagesEmergencyPreparednessSquadTrialPng);
	
	var _imagesEmergencyPreparednessSquadExpiredPng = __webpack_require__(2346);
	
	var _imagesEmergencyPreparednessSquadExpiredPng2 = _interopRequireDefault(_imagesEmergencyPreparednessSquadExpiredPng);
	
	var _config = __webpack_require__(1038);
	
	var _config2 = _interopRequireDefault(_config);
	
	// Preload image functions
	
	var _sections20_gameShowGameShowSection = __webpack_require__(166);
	
	__webpack_require__(2189);
	
	var md = new _helpersMarkdownScript2['default'](_indexMd2['default']);
	
	var levels = {
	  prep: {
	    deck: __webpack_require__(1045)
	  },
	  1: {
	    thumbnail: __webpack_require__(427),
	    overviewThumbnail: __webpack_require__(2348),
	    deck: __webpack_require__(1040),
	    prep: new _helpersMarkdownScript2['default'](_sections00_prepLevel1_prepMd2['default']),
	    levelName: 'Know the Risks'
	  },
	  2: {
	    thumbnail: __webpack_require__(428),
	    overviewThumbnail: __webpack_require__(2349),
	    deck: __webpack_require__(1041),
	    prep: new _helpersMarkdownScript2['default'](_sections00_prepLevel2_prepMd2['default']),
	    levelName: 'Make a Plan'
	  },
	  3: {
	    thumbnail: __webpack_require__(429),
	    overviewThumbnail: __webpack_require__(2350),
	    deck: __webpack_require__(1042),
	    prep: new _helpersMarkdownScript2['default'](_sections00_prepLevel3_prepMd2['default']),
	    levelName: "Get a Kit"
	  },
	  4: {
	    thumbnail: __webpack_require__(883),
	    overviewThumbnail: __webpack_require__(2351),
	    deck: __webpack_require__(1043),
	    prep: new _helpersMarkdownScript2['default'](_sections00_prepLevel4_prepMd2['default']),
	    levelName: "We're In This Together"
	  },
	  completed: {
	    deck: __webpack_require__(1044)
	  }
	};
	
	var program = {
	  id: 'epsPrimaries',
	  title: md.getSectionAsString('Title - Short'),
	  longTitle: md.getSectionAsString('Title - Long'),
	  thumbnailImage: _imagesEmergencyPreparednessSquadPng2['default'],
	  trialImageThumb: _imagesEmergencyPreparednessSquadTrialPng2['default'],
	  expiredImageThumb: _imagesEmergencyPreparednessSquadExpiredPng2['default'],
	  longDescription: md.getSectionAsString('Description - Long'),
	  shortDescription: md.getSectionAsString('Description - Short'),
	  levelsDescription: md.getSectionAsString('Description - Levels'),
	  levels: levels,
	  extensionActivitiesMd: new _helpersMarkdownScript2['default'](_extensionActivitiesExtensionActivitiesMd2['default']),
	  programPrepMd: new _helpersMarkdownScript2['default'](_programPrepProgramPrepMd2['default']),
	  funMd: new _helpersMarkdownScript2['default'](_funMd2['default']),
	  preload: function preload(_ref) {
	    var level = _ref.level;
	
	    console.log('Preloading assets for Level ' + level);
	
	    (0, _sections20_gameShowGameShowSection.preloadGameShow)();
	  },
	  config: _config2['default']
	};
	
	exports['default'] = program;
	module.exports = exports['default'];

/***/ }),
/* 1040 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(__filename) {'use strict';
	
	var _get = __webpack_require__(8)['default'];
	
	var _inherits = __webpack_require__(5)['default'];
	
	var _createClass = __webpack_require__(6)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _helpersMarkdownScript = __webpack_require__(9);
	
	var _helpersMarkdownScript2 = _interopRequireDefault(_helpersMarkdownScript);
	
	var _indexMd = __webpack_require__(187);
	
	var _indexMd2 = _interopRequireDefault(_indexMd);
	
	var _sections01_startStartSection = __webpack_require__(214);
	
	var _sections01_startStartSection2 = _interopRequireDefault(_sections01_startStartSection);
	
	var _sections03_songSongSection = __webpack_require__(215);
	
	var _sections03_songSongSection2 = _interopRequireDefault(_sections03_songSongSection);
	
	var _sections10_teamCreationTeamCreationSection = __webpack_require__(1047);
	
	var _sections10_teamCreationTeamCreationSection2 = _interopRequireDefault(_sections10_teamCreationTeamCreationSection);
	
	var _sections11_esGooberStoryEsGooberStorySection = __webpack_require__(216);
	
	var _sections11_esGooberStoryEsGooberStorySection2 = _interopRequireDefault(_sections11_esGooberStoryEsGooberStorySection);
	
	var _sections20_gameShowGameShowSection = __webpack_require__(166);
	
	var _sections20_gameShowGameShowSection2 = _interopRequireDefault(_sections20_gameShowGameShowSection);
	
	var _sections30_classActivityClassActivitySection = __webpack_require__(217);
	
	var _sections30_classActivityClassActivitySection2 = _interopRequireDefault(_sections30_classActivityClassActivitySection);
	
	var _sections70_missionAssignmentMissionAssignmentSection = __webpack_require__(218);
	
	var _sections70_missionAssignmentMissionAssignmentSection2 = _interopRequireDefault(_sections70_missionAssignmentMissionAssignmentSection);
	
	var _sections90_finishFinishSection = __webpack_require__(219);
	
	var _sections90_finishFinishSection2 = _interopRequireDefault(_sections90_finishFinishSection);
	
	var md = new _helpersMarkdownScript2['default'](_indexMd2['default']);
	var level = Number(__filename.replace(/^.*level/, '').replace('.jsx', ''));
	var title = md.getSectionMetadata('Level ' + level, 'Title');
	
	var _default = (function (_Component) {
	  _inherits(_default, _Component);
	
	  function _default() {
	    _classCallCheck(this, _default);
	
	    _get(Object.getPrototypeOf(_default.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(_default, [{
	    key: 'render',
	    value: function render() {
	      var regionData = this.context.regionData;
	
	      return _react2['default'].createElement(
	        _spectaclePpa.Deck,
	        { transition: ['slide'],
	          transitionDuration: 800,
	          progress: 'bar' },
	        (0, _sections01_startStartSection2['default'])({ level: level, title: title, regionData: regionData }),
	        (0, _sections03_songSongSection2['default'])({ level: level, regionData: regionData }),
	        (0, _sections10_teamCreationTeamCreationSection2['default'])({ regionData: regionData }),
	        (0, _sections11_esGooberStoryEsGooberStorySection2['default'])({ level: level, regionData: regionData }),
	        (0, _sections30_classActivityClassActivitySection2['default'])({ level: level, regionData: regionData }),
	        (0, _sections20_gameShowGameShowSection2['default'])({ level: level, regionData: regionData }),
	        (0, _sections70_missionAssignmentMissionAssignmentSection2['default'])({ level: level, title: title, regionData: regionData }),
	        (0, _sections90_finishFinishSection2['default'])({ level: level, regionData: regionData })
	      );
	    }
	  }], [{
	    key: 'contextTypes',
	    value: {
	      regionData: _react.PropTypes.object.isRequired
	    },
	    enumerable: true
	  }, {
	    key: 'metadata',
	    value: {
	      title: title
	    },
	    enumerable: true
	  }]);

	  return _default;
	})(_react.Component);

	exports['default'] = _default;
	module.exports = exports['default'];
	/* Start */ /* Theme Song */ /* Team Creation */ /* Esmeralda & Goober Story */ /* Top ten emergencies */ /* Game Show */ /* Mission Assignment */ /* Finish */
	/* WEBPACK VAR INJECTION */}.call(exports, "programs/epsPrimaries/level1.jsx"))

/***/ }),
/* 1041 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(__filename) {'use strict';
	
	var _get = __webpack_require__(8)['default'];
	
	var _inherits = __webpack_require__(5)['default'];
	
	var _createClass = __webpack_require__(6)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _helpersMarkdownScript = __webpack_require__(9);
	
	var _helpersMarkdownScript2 = _interopRequireDefault(_helpersMarkdownScript);
	
	var _indexMd = __webpack_require__(187);
	
	var _indexMd2 = _interopRequireDefault(_indexMd);
	
	var _sections01_startStartSection = __webpack_require__(214);
	
	var _sections01_startStartSection2 = _interopRequireDefault(_sections01_startStartSection);
	
	var _sections03_songSongSection = __webpack_require__(215);
	
	var _sections03_songSongSection2 = _interopRequireDefault(_sections03_songSongSection);
	
	var _sections11_esGooberStoryEsGooberStorySection = __webpack_require__(216);
	
	var _sections11_esGooberStoryEsGooberStorySection2 = _interopRequireDefault(_sections11_esGooberStoryEsGooberStorySection);
	
	var _sections12_missionReportMissionReportSection = __webpack_require__(295);
	
	var _sections12_missionReportMissionReportSection2 = _interopRequireDefault(_sections12_missionReportMissionReportSection);
	
	var _sections20_gameShowGameShowSection = __webpack_require__(166);
	
	var _sections20_gameShowGameShowSection2 = _interopRequireDefault(_sections20_gameShowGameShowSection);
	
	var _sections30_classActivityClassActivitySection = __webpack_require__(217);
	
	var _sections30_classActivityClassActivitySection2 = _interopRequireDefault(_sections30_classActivityClassActivitySection);
	
	var _sections70_missionAssignmentMissionAssignmentSection = __webpack_require__(218);
	
	var _sections70_missionAssignmentMissionAssignmentSection2 = _interopRequireDefault(_sections70_missionAssignmentMissionAssignmentSection);
	
	var _sections90_finishFinishSection = __webpack_require__(219);
	
	var _sections90_finishFinishSection2 = _interopRequireDefault(_sections90_finishFinishSection);
	
	var md = new _helpersMarkdownScript2['default'](_indexMd2['default']);
	var level = Number(__filename.replace(/^.*level/, '').replace('.jsx', ''));
	var title = md.getSectionMetadata('Level ' + level, 'Title');
	
	var _default = (function (_Component) {
	  _inherits(_default, _Component);
	
	  function _default() {
	    _classCallCheck(this, _default);
	
	    _get(Object.getPrototypeOf(_default.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(_default, [{
	    key: 'render',
	    value: function render() {
	      var regionData = this.context.regionData;
	
	      return _react2['default'].createElement(
	        _spectaclePpa.Deck,
	        { transition: ['slide'],
	          transitionDuration: 800,
	          progress: 'bar' },
	        (0, _sections01_startStartSection2['default'])({ level: level, title: title, regionData: regionData }),
	        (0, _sections03_songSongSection2['default'])({ level: level, regionData: regionData }),
	        (0, _sections12_missionReportMissionReportSection2['default'])({ level: level, regionData: regionData }),
	        (0, _sections11_esGooberStoryEsGooberStorySection2['default'])({ level: level, regionData: regionData }),
	        (0, _sections20_gameShowGameShowSection2['default'])({ level: level, regionData: regionData }),
	        (0, _sections30_classActivityClassActivitySection2['default'])({ level: level, regionData: regionData }),
	        (0, _sections70_missionAssignmentMissionAssignmentSection2['default'])({ level: level, title: title, regionData: regionData }),
	        (0, _sections90_finishFinishSection2['default'])({ level: level, regionData: regionData })
	      );
	    }
	  }], [{
	    key: 'contextTypes',
	    value: {
	      regionData: _react.PropTypes.object.isRequired
	    },
	    enumerable: true
	  }, {
	    key: 'metadata',
	    value: {
	      title: title
	    },
	    enumerable: true
	  }]);

	  return _default;
	})(_react.Component);

	exports['default'] = _default;
	module.exports = exports['default'];
	/* Start */ /* Theme Song */ /* Mission Report */ /* Esmeralda & Goober Story */ /* Game Show */ /* Class Activity: Floorplan */ /* Mission Assignment */ /* Finish */
	/* WEBPACK VAR INJECTION */}.call(exports, "programs/epsPrimaries/level2.jsx"))

/***/ }),
/* 1042 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(__filename) {'use strict';
	
	var _get = __webpack_require__(8)['default'];
	
	var _inherits = __webpack_require__(5)['default'];
	
	var _createClass = __webpack_require__(6)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _helpersMarkdownScript = __webpack_require__(9);
	
	var _helpersMarkdownScript2 = _interopRequireDefault(_helpersMarkdownScript);
	
	var _indexMd = __webpack_require__(187);
	
	var _indexMd2 = _interopRequireDefault(_indexMd);
	
	var _sections01_startStartSection = __webpack_require__(214);
	
	var _sections01_startStartSection2 = _interopRequireDefault(_sections01_startStartSection);
	
	var _sections03_songSongSection = __webpack_require__(215);
	
	var _sections03_songSongSection2 = _interopRequireDefault(_sections03_songSongSection);
	
	var _sections11_esGooberStoryEsGooberStorySection = __webpack_require__(216);
	
	var _sections11_esGooberStoryEsGooberStorySection2 = _interopRequireDefault(_sections11_esGooberStoryEsGooberStorySection);
	
	var _sections12_missionReportMissionReportSection = __webpack_require__(295);
	
	var _sections12_missionReportMissionReportSection2 = _interopRequireDefault(_sections12_missionReportMissionReportSection);
	
	var _sections20_gameShowGameShowSection = __webpack_require__(166);
	
	var _sections20_gameShowGameShowSection2 = _interopRequireDefault(_sections20_gameShowGameShowSection);
	
	var _sections30_classActivityClassActivitySection = __webpack_require__(217);
	
	var _sections30_classActivityClassActivitySection2 = _interopRequireDefault(_sections30_classActivityClassActivitySection);
	
	var _sections70_missionAssignmentMissionAssignmentSection = __webpack_require__(218);
	
	var _sections70_missionAssignmentMissionAssignmentSection2 = _interopRequireDefault(_sections70_missionAssignmentMissionAssignmentSection);
	
	var _sections90_finishFinishSection = __webpack_require__(219);
	
	var _sections90_finishFinishSection2 = _interopRequireDefault(_sections90_finishFinishSection);
	
	var md = new _helpersMarkdownScript2['default'](_indexMd2['default']);
	var level = Number(__filename.replace(/^.*level/, '').replace('.jsx', ''));
	var title = md.getSectionMetadata('Level ' + level, 'Title');
	
	var _default = (function (_Component) {
	  _inherits(_default, _Component);
	
	  function _default() {
	    _classCallCheck(this, _default);
	
	    _get(Object.getPrototypeOf(_default.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(_default, [{
	    key: 'render',
	    value: function render() {
	      var regionData = this.context.regionData;
	
	      return _react2['default'].createElement(
	        _spectaclePpa.Deck,
	        { transition: ['slide'],
	          transitionDuration: 800,
	          progress: 'bar' },
	        (0, _sections01_startStartSection2['default'])({ level: level, title: title, regionData: regionData }),
	        (0, _sections03_songSongSection2['default'])({ level: level, regionData: regionData }),
	        (0, _sections11_esGooberStoryEsGooberStorySection2['default'])({ level: level, regionData: regionData }),
	        (0, _sections12_missionReportMissionReportSection2['default'])({ level: level, regionData: regionData }),
	        (0, _sections20_gameShowGameShowSection2['default'])({ level: level, regionData: regionData }),
	        (0, _sections30_classActivityClassActivitySection2['default'])({ level: level, regionData: regionData }),
	        (0, _sections70_missionAssignmentMissionAssignmentSection2['default'])({ level: level, title: title, regionData: regionData }),
	        (0, _sections90_finishFinishSection2['default'])({ level: level, regionData: regionData })
	      );
	    }
	  }], [{
	    key: 'contextTypes',
	    value: {
	      regionData: _react.PropTypes.object.isRequired
	    },
	    enumerable: true
	  }, {
	    key: 'metadata',
	    value: {
	      title: title
	    },
	    enumerable: true
	  }]);

	  return _default;
	})(_react.Component);

	exports['default'] = _default;
	module.exports = exports['default'];
	/* Start */ /* Theme Song */ /* Esmeralda & Goober Story */ /* Mission Report */ /* Game Show */ /* Class Activity: Kit rap */ /* Mission Assignment */ /* Finish */
	/* WEBPACK VAR INJECTION */}.call(exports, "programs/epsPrimaries/level3.jsx"))

/***/ }),
/* 1043 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(__filename) {'use strict';
	
	var _get = __webpack_require__(8)['default'];
	
	var _inherits = __webpack_require__(5)['default'];
	
	var _createClass = __webpack_require__(6)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _helpersMarkdownScript = __webpack_require__(9);
	
	var _helpersMarkdownScript2 = _interopRequireDefault(_helpersMarkdownScript);
	
	var _indexMd = __webpack_require__(187);
	
	var _indexMd2 = _interopRequireDefault(_indexMd);
	
	var _sections01_startStartSection = __webpack_require__(214);
	
	var _sections01_startStartSection2 = _interopRequireDefault(_sections01_startStartSection);
	
	var _sections03_songSongSection = __webpack_require__(215);
	
	var _sections03_songSongSection2 = _interopRequireDefault(_sections03_songSongSection);
	
	var _sections11_esGooberStoryEsGooberStorySection = __webpack_require__(216);
	
	var _sections11_esGooberStoryEsGooberStorySection2 = _interopRequireDefault(_sections11_esGooberStoryEsGooberStorySection);
	
	var _sections12_missionReportMissionReportSection = __webpack_require__(295);
	
	var _sections12_missionReportMissionReportSection2 = _interopRequireDefault(_sections12_missionReportMissionReportSection);
	
	var _sections20_gameShowGameShowSection = __webpack_require__(166);
	
	var _sections20_gameShowGameShowSection2 = _interopRequireDefault(_sections20_gameShowGameShowSection);
	
	var _sections30_classActivityClassActivitySection = __webpack_require__(217);
	
	var _sections30_classActivityClassActivitySection2 = _interopRequireDefault(_sections30_classActivityClassActivitySection);
	
	var _sections70_missionAssignmentMissionAssignmentSection = __webpack_require__(218);
	
	var _sections70_missionAssignmentMissionAssignmentSection2 = _interopRequireDefault(_sections70_missionAssignmentMissionAssignmentSection);
	
	var _sections95_endingEndingSection = __webpack_require__(1048);
	
	var _sections95_endingEndingSection2 = _interopRequireDefault(_sections95_endingEndingSection);
	
	var _sections90_finishFinishSection = __webpack_require__(219);
	
	var _sections90_finishFinishSection2 = _interopRequireDefault(_sections90_finishFinishSection);
	
	var md = new _helpersMarkdownScript2['default'](_indexMd2['default']);
	var level = Number(__filename.replace(/^.*level/, '').replace('.jsx', ''));
	var title = md.getSectionMetadata('Level ' + level, 'Title');
	
	var _default = (function (_Component) {
	  _inherits(_default, _Component);
	
	  function _default() {
	    _classCallCheck(this, _default);
	
	    _get(Object.getPrototypeOf(_default.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(_default, [{
	    key: 'render',
	    value: function render() {
	      var regionData = this.context.regionData;
	
	      return _react2['default'].createElement(
	        _spectaclePpa.Deck,
	        { transition: ['slide'],
	          transitionDuration: 800,
	          progress: 'bar' },
	        (0, _sections01_startStartSection2['default'])({ level: level, title: title, regionData: regionData }),
	        (0, _sections03_songSongSection2['default'])({ level: level, regionData: regionData }),
	        (0, _sections12_missionReportMissionReportSection2['default'])({ level: level, regionData: regionData }),
	        (0, _sections11_esGooberStoryEsGooberStorySection2['default'])({ level: level, regionData: regionData }),
	        (0, _sections20_gameShowGameShowSection2['default'])({ level: level, regionData: regionData }),
	        (0, _sections30_classActivityClassActivitySection2['default'])({ level: level, regionData: regionData }),
	        (0, _sections95_endingEndingSection2['default'])({ regionData: regionData }),
	        (0, _sections70_missionAssignmentMissionAssignmentSection2['default'])({ level: level, title: title, regionData: regionData }),
	        (0, _sections90_finishFinishSection2['default'])({ level: level, regionData: regionData })
	      );
	    }
	  }], [{
	    key: 'contextTypes',
	    value: {
	      regionData: _react.PropTypes.object.isRequired
	    },
	    enumerable: true
	  }, {
	    key: 'metadata',
	    value: {
	      title: title
	    },
	    enumerable: true
	  }]);

	  return _default;
	})(_react.Component);

	exports['default'] = _default;
	module.exports = exports['default'];
	/* Start */ /* Theme Song */ /* Mission Report */ /* Esmeralda & Goober Story */ /* Game Show */ /* Class Activity: Drawing */ /* Ending */ /* Mission Assignment */ /* Finish */
	/* WEBPACK VAR INJECTION */}.call(exports, "programs/epsPrimaries/level4.jsx"))

/***/ }),
/* 1044 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _get = __webpack_require__(8)['default'];
	
	var _inherits = __webpack_require__(5)['default'];
	
	var _createClass = __webpack_require__(6)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _baseSlidesBalloonSlide = __webpack_require__(88);
	
	var _baseSlidesBalloonSlide2 = _interopRequireDefault(_baseSlidesBalloonSlide);
	
	var _imagesCharactersSara_gigglePng = __webpack_require__(880);
	
	var _imagesCharactersSara_gigglePng2 = _interopRequireDefault(_imagesCharactersSara_gigglePng);
	
	var _helpersMarkdownScript = __webpack_require__(9);
	
	var _helpersMarkdownScript2 = _interopRequireDefault(_helpersMarkdownScript);
	
	var _levelCompletedMd = __webpack_require__(1621);
	
	var _levelCompletedMd2 = _interopRequireDefault(_levelCompletedMd);
	
	var md = new _helpersMarkdownScript2['default'](_levelCompletedMd2['default']);
	
	var _default = (function (_Component) {
	  _inherits(_default, _Component);
	
	  function _default() {
	    _classCallCheck(this, _default);
	
	    _get(Object.getPrototypeOf(_default.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(_default, [{
	    key: 'render',
	    value: function render() {
	      var regionData = this.context.regionData;
	
	      return _react2['default'].createElement(
	        _spectaclePpa.Deck,
	        { transition: ['slide'],
	          transitionDuration: 800,
	          progress: 'bar' },
	        (0, _baseSlidesBalloonSlide2['default'])({
	          id: 'welcome-back',
	          characterSide: 'right',
	          characterImage: _imagesCharactersSara_gigglePng2['default'],
	          notes: md.getSubSectionAsHtml('Level Completed', 'Notes', false, regionData),
	          html: md.getSubSectionAsHtml('Level Completed', 'Content', false, regionData),
	          bgColor: '#37b34a'
	        })
	      );
	    }
	  }], [{
	    key: 'contextTypes',
	    value: {
	      regionData: _react.PropTypes.object.isRequired
	    },
	    enumerable: true
	  }]);

	  return _default;
	})(_react.Component);

	exports['default'] = _default;
	module.exports = exports['default'];

/***/ }),
/* 1045 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _get = __webpack_require__(8)['default'];
	
	var _inherits = __webpack_require__(5)['default'];
	
	var _createClass = __webpack_require__(6)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _componentsStartLevel = __webpack_require__(79);
	
	var _componentsStartLevel2 = _interopRequireDefault(_componentsStartLevel);
	
	var _sections00_prepPrepSection = __webpack_require__(1046);
	
	var _sections00_prepPrepSection2 = _interopRequireDefault(_sections00_prepPrepSection);
	
	var _default = (function (_Component) {
	  _inherits(_default, _Component);
	
	  function _default() {
	    _classCallCheck(this, _default);
	
	    _get(Object.getPrototypeOf(_default.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(_default, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var level = _props.nextLevel;
	      var configuration = _props.configuration;
	      var regionData = this.context.regionData;
	
	      return _react2['default'].createElement(
	        _spectaclePpa.Deck,
	        { transition: ['slide'],
	          transitionDuration: 800,
	          progress: 'bar' },
	        (0, _sections00_prepPrepSection2['default'])({ level: level, configuration: configuration, regionData: regionData }),
	        _react2['default'].createElement(
	          _spectaclePpa.Slide,
	          {
	            id: 'start',
	            textColor: 'white' },
	          _react2['default'].createElement(_componentsStartLevel2['default'], null)
	        )
	      );
	    }
	  }], [{
	    key: 'propTypes',
	    value: {
	      nextLevel: _react.PropTypes.string.isRequired,
	      configuration: _react.PropTypes.string
	    },
	    enumerable: true
	  }, {
	    key: 'contextTypes',
	    value: {
	      regionData: _react.PropTypes.object.isRequired
	    },
	    enumerable: true
	  }]);

	  return _default;
	})(_react.Component);

	exports['default'] = _default;
	module.exports = exports['default'];
	/* Prep */

/***/ }),
/* 1046 */
/***/ (function(module, exports, __webpack_require__) {

	/* eslint react/no-multi-comp: 0 */
	
	'use strict';
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _componentsSelectConfiguration = __webpack_require__(77);
	
	var _componentsSelectConfiguration2 = _interopRequireDefault(_componentsSelectConfiguration);
	
	var _componentsSelectDeviceRole = __webpack_require__(78);
	
	var _componentsSelectDeviceRole2 = _interopRequireDefault(_componentsSelectDeviceRole);
	
	var _baseSlidesHtmlSlide = __webpack_require__(1037);
	
	var _baseSlidesHtmlSlide2 = _interopRequireDefault(_baseSlidesHtmlSlide);
	
	var _baseSlidesHeadingSlide = __webpack_require__(165);
	
	var _baseSlidesHeadingSlide2 = _interopRequireDefault(_baseSlidesHeadingSlide);
	
	var _baseSlidesVideoSlide = __webpack_require__(58);
	
	var _baseSlidesVideoSlide2 = _interopRequireDefault(_baseSlidesVideoSlide);
	
	var _helpersMarkdownScript = __webpack_require__(9);
	
	var _helpersMarkdownScript2 = _interopRequireDefault(_helpersMarkdownScript);
	
	var _tech_prepMd = __webpack_require__(1627);
	
	var _tech_prepMd2 = _interopRequireDefault(_tech_prepMd);
	
	var techPrepMd = new _helpersMarkdownScript2['default'](_tech_prepMd2['default']);
	
	function techPrepWizard(_ref) {
	  var regionData = _ref.regionData;
	
	  return (0, _baseSlidesHtmlSlide2['default'])({
	    id: 'tech-prep-wizard',
	    html: techPrepMd.getSectionAsHtml('Tech Prep Wizard', false, regionData)
	  });
	}
	
	function twoDeviceIntro(_ref2) {
	  var regionData = _ref2.regionData;
	
	  return (0, _baseSlidesHtmlSlide2['default'])({
	    id: 'two-device-intro',
	    html: techPrepMd.getSectionAsHtml('Two Device Intro', false, regionData)
	  });
	}
	
	function selectConfiguration() {
	  return _react2['default'].createElement(
	    _spectaclePpa.Slide,
	    {
	      id: 'configuration',
	      textColor: 'white' },
	    _react2['default'].createElement(_componentsSelectConfiguration2['default'], null)
	  );
	}
	
	function connectingRemote(_ref3) {
	  var configuration = _ref3.configuration;
	  var regionData = _ref3.regionData;
	
	  if (configuration === 'dualScreen') {
	    return (0, _baseSlidesHtmlSlide2['default'])({
	      id: 'connecting-remote',
	      html: techPrepMd.getSectionAsHtml('Connecting Remote', false, regionData)
	    });
	  } else {
	    return null;
	  }
	}
	
	function selectDeviceRole(configuration) {
	  if (configuration === 'dualScreen') {
	    return _react2['default'].createElement(
	      _spectaclePpa.Slide,
	      {
	        id: 'device-role',
	        textColor: 'white' },
	      _react2['default'].createElement(_componentsSelectDeviceRole2['default'], null)
	    );
	  } else {
	    return null;
	  }
	}
	
	function techCheckIntro(_ref4) {
	  var regionData = _ref4.regionData;
	
	  return (0, _baseSlidesHtmlSlide2['default'])({
	    id: 'tech-check-intro',
	    html: techPrepMd.getSectionAsHtml('Tech Check Intro', false, regionData)
	  });
	}
	
	function techCheckVideo(_ref5) {
	  var regionData = _ref5.regionData;
	
	  return (0, _baseSlidesVideoSlide2['default'])({
	    id: 'tech-check-video',
	    youTubeId: techPrepMd.getSectionMetadata('Tech Check Video', 'YouTube', regionData)
	  });
	}
	
	function levelPrep(_ref6) {
	  var configuration = _ref6.configuration;
	  var regionData = _ref6.regionData;
	
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'prep' },
	    techPrepWizard({ regionData: regionData }),
	    twoDeviceIntro({ regionData: regionData }),
	    selectConfiguration(),
	    connectingRemote({ configuration: configuration, regionData: regionData }),
	    selectDeviceRole(configuration),
	    techCheckIntro({ regionData: regionData }),
	    techCheckVideo({ regionData: regionData })
	  );
	}
	
	function levelCompletedPrep(_ref7) {
	  var configuration = _ref7.configuration;
	  var regionData = _ref7.regionData;
	
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'prep' },
	    selectConfiguration(),
	    connectingRemote({ configuration: configuration, regionData: regionData }),
	    selectDeviceRole(configuration)
	  );
	}
	
	function prepSection(_ref8) {
	  var level = _ref8.level;
	  var configuration = _ref8.configuration;
	  var regionData = _ref8.regionData;
	
	  switch (level) {
	    case '1':
	      return levelPrep({ configuration: configuration, regionData: regionData });
	    case '2':
	      return levelPrep({ configuration: configuration, regionData: regionData });
	    case '3':
	      return levelPrep({ configuration: configuration, regionData: regionData });
	    case '4':
	      return levelPrep({ configuration: configuration, regionData: regionData });
	    case 'completed':
	      return levelCompletedPrep({ configuration: configuration, regionData: regionData });
	    default:
	      return (0, _baseSlidesHeadingSlide2['default'])({ heading: 'Unknown' });
	  }
	}
	
	exports['default'] = prepSection;
	module.exports = exports['default'];
	/* Tech Prep Wizard */ /* Two Device Intro */ /* Select Configuration */ /* Connecting Remote Instructions */ /* Select Device Role */ /* Tech Check Intro */ /* Tech Check Video */ /* Start Level */ /* Select Configuration */ /* Connecting Remote */ /* Select Device Role */

/***/ }),
/* 1047 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.preloadGameShow = preloadGameShow;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _componentsTeamNames = __webpack_require__(60);
	
	var _componentsTeamNames2 = _interopRequireDefault(_componentsTeamNames);
	
	var _baseSlidesVideoSlide = __webpack_require__(58);
	
	var _baseSlidesVideoSlide2 = _interopRequireDefault(_baseSlidesVideoSlide);
	
	var _baseSlidesBalloonSlide = __webpack_require__(88);
	
	var _baseSlidesBalloonSlide2 = _interopRequireDefault(_baseSlidesBalloonSlide);
	
	var _helpersMarkdownScript = __webpack_require__(9);
	
	var _helpersMarkdownScript2 = _interopRequireDefault(_helpersMarkdownScript);
	
	var _teamCreationMd = __webpack_require__(1630);
	
	var _teamCreationMd2 = _interopRequireDefault(_teamCreationMd);
	
	var _imagesCharactersSara_twist_hands_out_heyheyPng = __webpack_require__(882);
	
	var _imagesCharactersSara_twist_hands_out_heyheyPng2 = _interopRequireDefault(_imagesCharactersSara_twist_hands_out_heyheyPng);
	
	var _imagesCharactersIan_arms_foldedPng = __webpack_require__(877);
	
	var _imagesCharactersIan_arms_foldedPng2 = _interopRequireDefault(_imagesCharactersIan_arms_foldedPng);
	
	var _imagesCharactersSara_gigglePng = __webpack_require__(880);
	
	var _imagesCharactersSara_gigglePng2 = _interopRequireDefault(_imagesCharactersSara_gigglePng);
	
	var _imagesCharactersIan_pointing_upPng = __webpack_require__(423);
	
	var _imagesCharactersIan_pointing_upPng2 = _interopRequireDefault(_imagesCharactersIan_pointing_upPng);
	
	var md = new _helpersMarkdownScript2['default'](_teamCreationMd2['default']);
	
	function preloadGameShow() {
	  (0, _spectaclePpa.preloader)([_imagesCharactersSara_twist_hands_out_heyheyPng2['default'], _imagesCharactersIan_arms_foldedPng2['default'], _imagesCharactersSara_gigglePng2['default']]);
	}
	
	function teamCreationSection(_ref) {
	  var regionData = _ref.regionData;
	
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'team-creation' },
	    (0, _baseSlidesVideoSlide2['default'])({
	      id: 'intro-team-names',
	      notes: md.getSubSectionAsHtml('Intro Team Names', 'Notes', false, regionData),
	      youTubeId: md.getSectionMetadata('Intro Team Names', 'YouTube', regionData)
	    }),
	    (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'get-into-teams',
	      characterSide: 'right',
	      characterImage: _imagesCharactersSara_gigglePng2['default'],
	      notes: md.getSubSectionAsHtml('Get Into Teams', 'Notes', false, regionData),
	      html: md.getSubSectionAsHtml('Get Into Teams', 'Content', false, regionData)
	    }),
	    _react2['default'].createElement(
	      _spectaclePpa.Slide,
	      {
	        id: 'assign',
	        bgColor: 'black',
	        notes: '<h2>Assign Team Names</h2>',
	        teamNames: true },
	      _react2['default'].createElement(
	        'div',
	        { className: 'ui-slide' },
	        _react2['default'].createElement(
	          _spectaclePpa.Heading,
	          { size: 1 },
	          'Name your teams!'
	        ),
	        _react2['default'].createElement(_componentsTeamNames2['default'], null)
	      )
	    ),
	    (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'scoring-intro',
	      characterSide: 'right',
	      characterImage: _imagesCharactersIan_arms_foldedPng2['default'],
	      notes: md.getSubSectionAsHtml('Scoring Intro', 'Notes', false, regionData),
	      html: md.getSubSectionAsHtml('Scoring Intro', 'Content', false, regionData)
	    }),
	    (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'scoreboard-intro',
	      characterSide: 'left',
	      characterImage: _imagesCharactersIan_pointing_upPng2['default'],
	      notes: md.getSubSectionAsHtml('Scoreboard Intro', 'Notes', false, regionData),
	      html: md.getSubSectionAsHtml('Scoreboard Intro', 'Content', false, regionData)
	    }),
	    (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'congratulations',
	      characterSide: 'right',
	      characterImage: _imagesCharactersSara_twist_hands_out_heyheyPng2['default'],
	      notes: md.getSubSectionAsHtml('Congratulations', 'Notes', false, regionData),
	      html: md.getSubSectionAsHtml('Congratulations', 'Content', false, regionData)
	    })
	  );
	}
	
	exports['default'] = teamCreationSection;
	/* Sara and Ian welcome to Academy */ /* Get into teams and come up with a cool name */ /* Enter team names */ /* Scoring intro */ /* Introduce scoreboard */ /* Congratulations */

/***/ }),
/* 1048 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.preloadEnding = preloadEnding;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _baseSlidesBalloonSlide = __webpack_require__(88);
	
	var _baseSlidesBalloonSlide2 = _interopRequireDefault(_baseSlidesBalloonSlide);
	
	var _baseSlidesHeadingSlide = __webpack_require__(165);
	
	var _baseSlidesHeadingSlide2 = _interopRequireDefault(_baseSlidesHeadingSlide);
	
	var _imagesEmergencyPreparednessSquadGlowPng = __webpack_require__(426);
	
	var _imagesEmergencyPreparednessSquadGlowPng2 = _interopRequireDefault(_imagesEmergencyPreparednessSquadGlowPng);
	
	var _imagesCharactersIan_hand_raisedPng = __webpack_require__(2337);
	
	var _imagesCharactersIan_hand_raisedPng2 = _interopRequireDefault(_imagesCharactersIan_hand_raisedPng);
	
	var _imagesCharactersIan_sara_sidePng = __webpack_require__(155);
	
	var _imagesCharactersIan_sara_sidePng2 = _interopRequireDefault(_imagesCharactersIan_sara_sidePng);
	
	var _helpersMarkdownScript = __webpack_require__(9);
	
	var _helpersMarkdownScript2 = _interopRequireDefault(_helpersMarkdownScript);
	
	var _endingMd = __webpack_require__(1651);
	
	var _endingMd2 = _interopRequireDefault(_endingMd);
	
	var md = new _helpersMarkdownScript2['default'](_endingMd2['default']);
	
	function preloadEnding() {
	  (0, _spectaclePpa.preloader)([_imagesCharactersIan_hand_raisedPng2['default'], _imagesCharactersIan_sara_sidePng2['default'], _imagesEmergencyPreparednessSquadGlowPng2['default']]);
	}
	
	function endingSection(_ref) {
	  var regionData = _ref.regionData;
	
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'ending' },
	    (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'announce-winners',
	      characterSide: 'right',
	      characterImage: _imagesCharactersIan_hand_raisedPng2['default'],
	      html: md.getSubSectionAsHtml('Announce Winners', 'Content', false, regionData),
	      notes: md.getSubSectionAsHtml('Announce Winners', 'Notes', false, regionData)
	    }),
	    (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'members-of-eps',
	      characterSide: 'right',
	      characterImage: _imagesCharactersIan_sara_sidePng2['default'],
	      html: md.getSubSectionAsHtml('Members EPS', 'Content', false, regionData),
	      notes: md.getSubSectionAsHtml('Members EPS', 'Notes', false, regionData)
	    }),
	    (0, _baseSlidesHeadingSlide2['default'])({
	      id: 'completed',
	      beforeImage: _imagesEmergencyPreparednessSquadGlowPng2['default'],
	      subHeading: 'All levels completed!!!',
	      notes: md.getSubSectionAsHtml('All Levels Completed', 'Notes', false, regionData),
	      bgColor: 'black'
	    })
	  );
	}
	
	exports['default'] = endingSection;
	/* Time to see who won! */ /* You're now all members of the Emergency Preparedness Squad */ /* You've completed all the levels */

/***/ }),
/* 1049 */
/***/ (function(module, exports) {

	/* eslint-disable object-shorthand */
	'use strict';
	
	var colors = {
	  primary: '#37bad5',
	  secondary: 'black',
	  tertiary: 'white',
	  level1: '#ffbc00',
	  level2: '#8f288c',
	  level3: '#26a7df',
	  level4: '#e80a89',
	  level5: '#f59122',
	  level6: '#37b34a',
	  gameshow: '#742CBF',
	  question: '#45B3EC',
	  answer: '#6FC36E'
	};
	
	var fonts = {
	  primary: 'BrandonTextWeb',
	  secondary: 'Orbitron',
	  tertiary: 'Ubuntu'
	};
	
	module.exports = {
	  colors: colors,
	  fonts: fonts,
	  global: {
	    body: {
	      background: 'transparent',
	      fontFamily: fonts.primary,
	      fontWeight: 'normal',
	      fontSize: '2em',
	      color: colors.primary,
	      overflow: 'hidden'
	    },
	    'html, body': {
	      // height: '100%'
	    },
	    '*': {
	      boxSizing: 'border-box'
	    },
	    input: {
	      color: 'black',
	      fontWeight: 'bold',
	      backgroundColor: 'white',
	      fontSize: '2.66em',
	      fontFamily: fonts.primary,
	      padding: '0.25em 0.25em 0.2em',
	      margin: '1% 1% 3%',
	      width: '98%'
	    },
	    label: {
	      color: 'white',
	      fontWeight: 'bold',
	      fontSize: '1.8em',
	      margin: '0.1em 0 0'
	    }
	  },
	  progress: {
	    bar: {
	      container: {
	        position: 'absolute',
	        height: '22px',
	        width: '100%',
	        bottom: 0,
	        left: 0,
	        transition: 'all 1s ease-in-out 0.2s',
	        zIndex: 1000
	      },
	      bar: {
	        height: '100%',
	        background: colors.primary,
	        transition: 'all 0.3s ease-out',
	        fontSize: '12px',
	        letterSpacing: '0.1em',
	        textTransform: 'uppercase',
	        padding: '4px',
	        textAlign: 'right'
	      }
	    },
	    number: {
	      container: {
	        position: 'absolute',
	        bottom: 10,
	        right: 10,
	        zIndex: 1000,
	        color: colors.tertiary
	      }
	    }
	  },
	  components: {
	    codePane: {
	      pre: {
	        margin: 'auto',
	        fontSize: '1em',
	        fontWeight: 'normal',
	        fontFamily: fonts.tertiary,
	        minWidth: '100%',
	        maxWidth: 800
	      },
	      code: {
	        textAlign: 'left',
	        padding: 20,
	        fontWeight: 'normal'
	      }
	    },
	    code: {
	      color: 'black',
	      fontSize: '2.66em',
	      fontFamily: fonts.tertiary,
	      margin: '0.25em auto',
	      backgroundColor: 'rgba(0,0,0,0.15)',
	      padding: '0 10px',
	      borderRadius: 3
	    },
	    heading: {},
	    link: {
	      textDecoration: 'none'
	    },
	    listItem: {
	      fontSize: '2.66em',
	      padding: '0 0 0.5em'
	    },
	    list: {
	      textAlign: 'center',
	      listStyle: 'none',
	      padding: '0.5em 0'
	    },
	    s: {
	      strikethrough: {}
	    },
	    text: {
	      color: 'black',
	      fontSize: '2.66em',
	      fontFamily: fonts.primary,
	      margin: '0.25em auto',
	      textShadow: '0 0 10px rgba(0,0,0,0.2)'
	    }
	  }
	};

/***/ }),
/* 1050 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = __webpack_require__(7)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	function htmlSlide(_ref) {
	  var id = _ref.id;
	  var notes = _ref.notes;
	  var heading = _ref.heading;
	  var bgColor = _ref.bgColor;
	  var subHeading = _ref.subHeading;
	  var html = _ref.html;
	  var slideClass = _ref.slideClass;
	
	  var slideContentClass = slideClass ? ' slide-' + slideClass : '';
	  var bgColorOpts = {};
	  if (bgColor) {
	    bgColorOpts.bgColor = bgColor;
	  }
	  return _react2['default'].createElement(
	    _spectaclePpa.Slide,
	    _extends({
	      id: id,
	      key: id
	    }, bgColorOpts, {
	      notes: notes,
	      textColor: 'white' }),
	    _react2['default'].createElement(
	      'div',
	      { className: 'slide-content' + slideContentClass },
	      _react2['default'].createElement(
	        'div',
	        {
	          className: 'text-formatted' },
	        !!heading && _react2['default'].createElement(
	          _spectaclePpa.Heading,
	          { size: 3 },
	          heading
	        ),
	        !!subHeading && _react2['default'].createElement(
	          _spectaclePpa.Heading,
	          { size: 5 },
	          subHeading
	        ),
	        _react2['default'].createElement('div', {
	          dangerouslySetInnerHTML: { __html: html } })
	      )
	    )
	  );
	}
	
	exports['default'] = htmlSlide;
	module.exports = exports['default'];

/***/ }),
/* 1051 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = {
	  width: 1000,
	  height: 700,
	  margin: 40,
	  theme: __webpack_require__(1062),
	  print: __webpack_require__(53),
	  html: __webpack_require__(52)
	};

/***/ }),
/* 1052 */
/***/ (function(module, exports, __webpack_require__) {

	/* eslint no-console: 0 */
	'use strict';
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _helpersMarkdownScript = __webpack_require__(9);
	
	var _helpersMarkdownScript2 = _interopRequireDefault(_helpersMarkdownScript);
	
	var _helpersI18n = __webpack_require__(14);
	
	var _extensionActivitiesExtensionActivitiesMd = __webpack_require__(1653);
	
	var _extensionActivitiesExtensionActivitiesMd2 = _interopRequireDefault(_extensionActivitiesExtensionActivitiesMd);
	
	var _extensionActivitiesExtensionActivitiesFr_CAMd = __webpack_require__(1652);
	
	var _extensionActivitiesExtensionActivitiesFr_CAMd2 = _interopRequireDefault(_extensionActivitiesExtensionActivitiesFr_CAMd);
	
	var _programPrepProgramPrepMd = __webpack_require__(1660);
	
	var _programPrepProgramPrepMd2 = _interopRequireDefault(_programPrepProgramPrepMd);
	
	var _programPrepProgramPrepFr_CAMd = __webpack_require__(1659);
	
	var _programPrepProgramPrepFr_CAMd2 = _interopRequireDefault(_programPrepProgramPrepFr_CAMd);
	
	var _sections00_prepLevel1_prepMd = __webpack_require__(1662);
	
	var _sections00_prepLevel1_prepMd2 = _interopRequireDefault(_sections00_prepLevel1_prepMd);
	
	var _sections00_prepLevel1_prepFr_CAMd = __webpack_require__(1661);
	
	var _sections00_prepLevel1_prepFr_CAMd2 = _interopRequireDefault(_sections00_prepLevel1_prepFr_CAMd);
	
	var _sections00_prepLevel2_prepMd = __webpack_require__(1664);
	
	var _sections00_prepLevel2_prepMd2 = _interopRequireDefault(_sections00_prepLevel2_prepMd);
	
	var _sections00_prepLevel2_prepFr_CAMd = __webpack_require__(1663);
	
	var _sections00_prepLevel2_prepFr_CAMd2 = _interopRequireDefault(_sections00_prepLevel2_prepFr_CAMd);
	
	var _sections00_prepLevel3_prepMd = __webpack_require__(1666);
	
	var _sections00_prepLevel3_prepMd2 = _interopRequireDefault(_sections00_prepLevel3_prepMd);
	
	var _sections00_prepLevel3_prepFr_CAMd = __webpack_require__(1665);
	
	var _sections00_prepLevel3_prepFr_CAMd2 = _interopRequireDefault(_sections00_prepLevel3_prepFr_CAMd);
	
	var _sections00_prepLevel4_prepMd = __webpack_require__(1668);
	
	var _sections00_prepLevel4_prepMd2 = _interopRequireDefault(_sections00_prepLevel4_prepMd);
	
	var _sections00_prepLevel4_prepFr_CAMd = __webpack_require__(1667);
	
	var _sections00_prepLevel4_prepFr_CAMd2 = _interopRequireDefault(_sections00_prepLevel4_prepFr_CAMd);
	
	var _funMd = __webpack_require__(1655);
	
	var _funMd2 = _interopRequireDefault(_funMd);
	
	var _funFr_CAMd = __webpack_require__(1654);
	
	var _funFr_CAMd2 = _interopRequireDefault(_funFr_CAMd);
	
	var _imagesH2whoaPng = __webpack_require__(2386);
	
	var _imagesH2whoaPng2 = _interopRequireDefault(_imagesH2whoaPng);
	
	var _imagesH2whoaFr_CAPng = __webpack_require__(2385);
	
	var _imagesH2whoaFr_CAPng2 = _interopRequireDefault(_imagesH2whoaFr_CAPng);
	
	var _imagesH2whoaTrialPng = __webpack_require__(2392);
	
	var _imagesH2whoaTrialPng2 = _interopRequireDefault(_imagesH2whoaTrialPng);
	
	var _imagesH2whoaTrialFr_CAPng = __webpack_require__(2391);
	
	var _imagesH2whoaTrialFr_CAPng2 = _interopRequireDefault(_imagesH2whoaTrialFr_CAPng);
	
	var _imagesH2whoaExpiredPng = __webpack_require__(2388);
	
	var _imagesH2whoaExpiredPng2 = _interopRequireDefault(_imagesH2whoaExpiredPng);
	
	var _imagesH2whoaExpiredFr_CAPng = __webpack_require__(2387);
	
	var _imagesH2whoaExpiredFr_CAPng2 = _interopRequireDefault(_imagesH2whoaExpiredFr_CAPng);
	
	var _config = __webpack_require__(1051);
	
	var _config2 = _interopRequireDefault(_config);
	
	// Preload image functions
	
	var _sections20_gameShowGameShowSection = __webpack_require__(168);
	
	__webpack_require__(2190);
	
	var _md = __webpack_require__(167);
	
	var _md2 = _interopRequireDefault(_md);
	
	var level1PrepMd = (0, _helpersI18n.i18nData)({
	  en: new _helpersMarkdownScript2['default'](_sections00_prepLevel1_prepMd2['default']),
	  fr_CA: new _helpersMarkdownScript2['default'](_sections00_prepLevel1_prepFr_CAMd2['default'])
	});
	var level2PrepMd = (0, _helpersI18n.i18nData)({
	  en: new _helpersMarkdownScript2['default'](_sections00_prepLevel2_prepMd2['default']),
	  fr_CA: new _helpersMarkdownScript2['default'](_sections00_prepLevel2_prepFr_CAMd2['default'])
	});
	var level3PrepMd = (0, _helpersI18n.i18nData)({
	  en: new _helpersMarkdownScript2['default'](_sections00_prepLevel3_prepMd2['default']),
	  fr_CA: new _helpersMarkdownScript2['default'](_sections00_prepLevel3_prepFr_CAMd2['default'])
	});
	var level4PrepMd = (0, _helpersI18n.i18nData)({
	  en: new _helpersMarkdownScript2['default'](_sections00_prepLevel4_prepMd2['default']),
	  fr_CA: new _helpersMarkdownScript2['default'](_sections00_prepLevel4_prepFr_CAMd2['default'])
	});
	var extensionActivitiesMd = (0, _helpersI18n.i18nData)({
	  en: new _helpersMarkdownScript2['default'](_extensionActivitiesExtensionActivitiesMd2['default']),
	  fr_CA: new _helpersMarkdownScript2['default'](_extensionActivitiesExtensionActivitiesFr_CAMd2['default'])
	});
	var programPrepMd = (0, _helpersI18n.i18nData)({
	  en: new _helpersMarkdownScript2['default'](_programPrepProgramPrepMd2['default']),
	  fr_CA: new _helpersMarkdownScript2['default'](_programPrepProgramPrepFr_CAMd2['default'])
	});
	var funMd = (0, _helpersI18n.i18nData)({
	  en: new _helpersMarkdownScript2['default'](_funMd2['default']),
	  fr_CA: new _helpersMarkdownScript2['default'](_funFr_CAMd2['default'])
	});
	var imageThumb = (0, _helpersI18n.i18nData)({
	  en: _imagesH2whoaPng2['default'],
	  fr_CA: _imagesH2whoaFr_CAPng2['default']
	});
	var trialImageThumb = (0, _helpersI18n.i18nData)({
	  en: _imagesH2whoaTrialPng2['default'],
	  fr_CA: _imagesH2whoaTrialFr_CAPng2['default']
	});
	var expiredImageThumb = (0, _helpersI18n.i18nData)({
	  en: _imagesH2whoaExpiredPng2['default'],
	  fr_CA: _imagesH2whoaExpiredFr_CAPng2['default']
	});
	
	(0, _helpersI18n.i18nExtend)('fr_CA', {
	  "H2Whoa": "H2Ohhh",
	  "One Water": "Une seule eau",
	  "Save Water": "Économiser l'eau",
	  "Protect Water": "Protéger l'eau",
	  "Connect in Place": "Se connecter à son milieu"
	});
	
	var levels = {
	  prep: {
	    deck: __webpack_require__(1058)
	  },
	  1: {
	    thumbnail: __webpack_require__(432),
	    overviewThumbnail: __webpack_require__(2393),
	    deck: __webpack_require__(1053),
	    prep: level1PrepMd,
	    levelName: 'One Water'
	  },
	  2: {
	    thumbnail: __webpack_require__(433),
	    overviewThumbnail: __webpack_require__(2394),
	    deck: __webpack_require__(1054),
	    prep: level2PrepMd,
	    levelName: 'Save Water'
	  },
	  3: {
	    thumbnail: __webpack_require__(434),
	    overviewThumbnail: __webpack_require__(2395),
	    deck: __webpack_require__(1055),
	    prep: level3PrepMd,
	    levelName: 'Protect Water'
	  },
	  4: {
	    thumbnail: __webpack_require__(890),
	    overviewThumbnail: __webpack_require__(2396),
	    deck: __webpack_require__(1056),
	    prep: level4PrepMd,
	    levelName: 'Connect in Place'
	  },
	  completed: {
	    deck: __webpack_require__(1057)
	  }
	};
	
	var program = {
	  id: 'h2whoa',
	  title: (0, _helpersI18n.i18nProvider)(function (lang) {
	    return _md2['default'][lang].getSectionAsString('Title - Short');
	  }),
	  longTitle: (0, _helpersI18n.i18nProvider)(function (lang) {
	    return _md2['default'][lang].getSectionAsString('Title - Long');
	  }),
	  thumbnailImage: imageThumb,
	  trialImageThumb: trialImageThumb,
	  expiredImageThumb: expiredImageThumb,
	  longDescription: (0, _helpersI18n.i18nProvider)(function (lang) {
	    return _md2['default'][lang].getSectionAsString('Description - Long');
	  }),
	  levelsDescription: (0, _helpersI18n.i18nProvider)(function (lang) {
	    return _md2['default'][lang].getSectionAsString('Description - Levels');
	  }),
	  shortDescription: (0, _helpersI18n.i18nProvider)(function (lang) {
	    return _md2['default'][lang].getSectionAsString('Description - Short');
	  }),
	  levels: levels,
	  extensionActivitiesMd: extensionActivitiesMd,
	  programPrepMd: programPrepMd,
	  funMd: funMd,
	  preload: function preload(_ref) {
	    var level = _ref.level;
	
	    console.log('Preloading assets for Level ' + level);
	
	    (0, _sections20_gameShowGameShowSection.preloadGameShow)();
	  },
	  config: _config2['default'],
	  languages: ['en', 'fr_CA']
	};
	
	exports['default'] = program;
	module.exports = exports['default'];

/***/ }),
/* 1053 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(__filename) {'use strict';
	
	var _get = __webpack_require__(8)['default'];
	
	var _inherits = __webpack_require__(5)['default'];
	
	var _createClass = __webpack_require__(6)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _helpersI18n = __webpack_require__(14);
	
	var _sections01_startStartSection = __webpack_require__(220);
	
	var _sections01_startStartSection2 = _interopRequireDefault(_sections01_startStartSection);
	
	var _sections03_songSongSection = __webpack_require__(221);
	
	var _sections03_songSongSection2 = _interopRequireDefault(_sections03_songSongSection);
	
	var _sections10_teamCreationTeamCreationSection = __webpack_require__(1060);
	
	var _sections10_teamCreationTeamCreationSection2 = _interopRequireDefault(_sections10_teamCreationTeamCreationSection);
	
	var _sections12_esStoryEsStorySection = __webpack_require__(222);
	
	var _sections12_esStoryEsStorySection2 = _interopRequireDefault(_sections12_esStoryEsStorySection);
	
	var _sections13_mmeMmeSection = __webpack_require__(223);
	
	var _sections13_mmeMmeSection2 = _interopRequireDefault(_sections13_mmeMmeSection);
	
	var _sections20_gameShowGameShowSection = __webpack_require__(168);
	
	var _sections20_gameShowGameShowSection2 = _interopRequireDefault(_sections20_gameShowGameShowSection);
	
	var _sections30_classActivityClassActivitySection = __webpack_require__(224);
	
	var _sections30_classActivityClassActivitySection2 = _interopRequireDefault(_sections30_classActivityClassActivitySection);
	
	var _sections70_missionAssignmentMissionAssignmentSection = __webpack_require__(297);
	
	var _sections70_missionAssignmentMissionAssignmentSection2 = _interopRequireDefault(_sections70_missionAssignmentMissionAssignmentSection);
	
	var _sections90_finishFinishSection = __webpack_require__(225);
	
	var _sections90_finishFinishSection2 = _interopRequireDefault(_sections90_finishFinishSection);
	
	var _md = __webpack_require__(167);
	
	var _md2 = _interopRequireDefault(_md);
	
	var level = Number(__filename.replace(/^.*level/, '').replace('.jsx', ''));
	var _title = (0, _helpersI18n.i18nProvider)(function (lang) {
	  return _md2['default'][lang].getSectionMetadata('Level ' + level, 'Title');
	});
	
	var _default = (function (_Component) {
	  _inherits(_default, _Component);
	
	  function _default() {
	    _classCallCheck(this, _default);
	
	    _get(Object.getPrototypeOf(_default.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(_default, [{
	    key: 'render',
	    value: function render() {
	      var _context = this.context;
	      var regionData = _context.regionData;
	      var i18n = _context.i18n;
	
	      var title = i18n(_title);
	      return _react2['default'].createElement(
	        _spectaclePpa.Deck,
	        { transition: ['slide'],
	          transitionDuration: 800,
	          progress: 'bar' },
	        (0, _sections01_startStartSection2['default'])({ level: level, title: title, regionData: regionData, i18n: i18n }),
	        (0, _sections03_songSongSection2['default'])({ level: level, regionData: regionData, i18n: i18n }),
	        (0, _sections10_teamCreationTeamCreationSection2['default'])({ regionData: regionData, i18n: i18n }),
	        (0, _sections12_esStoryEsStorySection2['default'])({ level: level, subStory: 'a', regionData: regionData, i18n: i18n }),
	        (0, _sections20_gameShowGameShowSection2['default'])({ level: level, regionData: regionData, i18n: i18n }),
	        (0, _sections13_mmeMmeSection2['default'])({ level: level, regionData: regionData, i18n: i18n }),
	        (0, _sections12_esStoryEsStorySection2['default'])({ level: level, subStory: 'b', regionData: regionData, i18n: i18n }),
	        (0, _sections30_classActivityClassActivitySection2['default'])({ level: level, subActivity: 'a', regionData: regionData, i18n: i18n }),
	        (0, _sections30_classActivityClassActivitySection2['default'])({ level: level, subActivity: 'b', regionData: regionData, i18n: i18n }),
	        (0, _sections12_esStoryEsStorySection2['default'])({ level: level, subStory: 'c', regionData: regionData, i18n: i18n }),
	        (0, _sections70_missionAssignmentMissionAssignmentSection2['default'])({ level: level, title: title, regionData: regionData, i18n: i18n }),
	        (0, _sections90_finishFinishSection2['default'])({ level: level, regionData: regionData, i18n: i18n })
	      );
	    }
	  }], [{
	    key: 'contextTypes',
	    value: {
	      regionData: _react.PropTypes.object.isRequired,
	      i18n: _react.PropTypes.func.isRequired
	    },
	    enumerable: true
	  }, {
	    key: 'metadata',
	    value: {
	      title: _title
	    },
	    enumerable: true
	  }]);

	  return _default;
	})(_react.Component);

	exports['default'] = _default;
	module.exports = exports['default'];
	/* Start */ /* Theme Song */ /* Team Creation and Introduction */ /* Es Story 1a */ /* Game Show */ /* Messages from Mother Earth */ /* Es Story 1b */ /* Class Activity: Team Brainstorm */ /* Class Activity: Write a Poem or Rap */ /* Es Story 1c */ /* Mission Assignment */ /* Finish */
	/* WEBPACK VAR INJECTION */}.call(exports, "programs/h2whoa/level1.jsx"))

/***/ }),
/* 1054 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(__filename) {'use strict';
	
	var _get = __webpack_require__(8)['default'];
	
	var _inherits = __webpack_require__(5)['default'];
	
	var _createClass = __webpack_require__(6)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _helpersI18n = __webpack_require__(14);
	
	var _sections01_startStartSection = __webpack_require__(220);
	
	var _sections01_startStartSection2 = _interopRequireDefault(_sections01_startStartSection);
	
	var _sections03_songSongSection = __webpack_require__(221);
	
	var _sections03_songSongSection2 = _interopRequireDefault(_sections03_songSongSection);
	
	var _sections11_missionReportMissionReportSection = __webpack_require__(296);
	
	var _sections11_missionReportMissionReportSection2 = _interopRequireDefault(_sections11_missionReportMissionReportSection);
	
	var _sections12_esStoryEsStorySection = __webpack_require__(222);
	
	var _sections12_esStoryEsStorySection2 = _interopRequireDefault(_sections12_esStoryEsStorySection);
	
	var _sections13_mmeMmeSection = __webpack_require__(223);
	
	var _sections13_mmeMmeSection2 = _interopRequireDefault(_sections13_mmeMmeSection);
	
	var _sections20_gameShowGameShowSection = __webpack_require__(168);
	
	var _sections20_gameShowGameShowSection2 = _interopRequireDefault(_sections20_gameShowGameShowSection);
	
	var _sections30_classActivityClassActivitySection = __webpack_require__(224);
	
	var _sections30_classActivityClassActivitySection2 = _interopRequireDefault(_sections30_classActivityClassActivitySection);
	
	var _sections70_missionAssignmentMissionAssignmentSection = __webpack_require__(297);
	
	var _sections70_missionAssignmentMissionAssignmentSection2 = _interopRequireDefault(_sections70_missionAssignmentMissionAssignmentSection);
	
	var _sections90_finishFinishSection = __webpack_require__(225);
	
	var _sections90_finishFinishSection2 = _interopRequireDefault(_sections90_finishFinishSection);
	
	var _md = __webpack_require__(167);
	
	var _md2 = _interopRequireDefault(_md);
	
	var level = Number(__filename.replace(/^.*level/, '').replace('.jsx', ''));
	var _title = (0, _helpersI18n.i18nProvider)(function (lang) {
	  return _md2['default'][lang].getSectionMetadata('Level ' + level, 'Title');
	});
	
	var _default = (function (_Component) {
	  _inherits(_default, _Component);
	
	  function _default() {
	    _classCallCheck(this, _default);
	
	    _get(Object.getPrototypeOf(_default.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(_default, [{
	    key: 'render',
	    value: function render() {
	      var _context = this.context;
	      var regionData = _context.regionData;
	      var i18n = _context.i18n;
	
	      var title = i18n(_title);
	      return _react2['default'].createElement(
	        _spectaclePpa.Deck,
	        { transition: ['slide'],
	          transitionDuration: 800,
	          progress: 'bar' },
	        (0, _sections01_startStartSection2['default'])({ level: level, title: title, regionData: regionData, i18n: i18n }),
	        (0, _sections03_songSongSection2['default'])({ level: level, regionData: regionData, i18n: i18n }),
	        (0, _sections11_missionReportMissionReportSection2['default'])({ level: level, regionData: regionData, i18n: i18n }),
	        (0, _sections12_esStoryEsStorySection2['default'])({ level: level, subStory: 'a', regionData: regionData, i18n: i18n }),
	        (0, _sections20_gameShowGameShowSection2['default'])({ level: level, regionData: regionData, i18n: i18n }),
	        (0, _sections13_mmeMmeSection2['default'])({ level: level, regionData: regionData, i18n: i18n }),
	        (0, _sections30_classActivityClassActivitySection2['default'])({ level: level, regionData: regionData, i18n: i18n }),
	        (0, _sections70_missionAssignmentMissionAssignmentSection2['default'])({ level: level, title: title, regionData: regionData, i18n: i18n }),
	        (0, _sections90_finishFinishSection2['default'])({ level: level, regionData: regionData, i18n: i18n })
	      );
	    }
	  }], [{
	    key: 'contextTypes',
	    value: {
	      regionData: _react.PropTypes.object.isRequired,
	      i18n: _react.PropTypes.func.isRequired
	    },
	    enumerable: true
	  }, {
	    key: 'metadata',
	    value: {
	      title: _title
	    },
	    enumerable: true
	  }]);

	  return _default;
	})(_react.Component);

	exports['default'] = _default;
	module.exports = exports['default'];
	/* Start */ /* Theme Song */ /* Mission Report */ /* Es Story 2a */ /* Game Show */ /* Messages from Mother Earth */ /* Class Activity: Group Drawing */ /* Mission Assignment */ /* Finish */
	/* WEBPACK VAR INJECTION */}.call(exports, "programs/h2whoa/level2.jsx"))

/***/ }),
/* 1055 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(__filename) {'use strict';
	
	var _get = __webpack_require__(8)['default'];
	
	var _inherits = __webpack_require__(5)['default'];
	
	var _createClass = __webpack_require__(6)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _helpersI18n = __webpack_require__(14);
	
	var _sections01_startStartSection = __webpack_require__(220);
	
	var _sections01_startStartSection2 = _interopRequireDefault(_sections01_startStartSection);
	
	var _sections03_songSongSection = __webpack_require__(221);
	
	var _sections03_songSongSection2 = _interopRequireDefault(_sections03_songSongSection);
	
	var _sections11_missionReportMissionReportSection = __webpack_require__(296);
	
	var _sections11_missionReportMissionReportSection2 = _interopRequireDefault(_sections11_missionReportMissionReportSection);
	
	var _sections12_esStoryEsStorySection = __webpack_require__(222);
	
	var _sections12_esStoryEsStorySection2 = _interopRequireDefault(_sections12_esStoryEsStorySection);
	
	var _sections13_mmeMmeSection = __webpack_require__(223);
	
	var _sections13_mmeMmeSection2 = _interopRequireDefault(_sections13_mmeMmeSection);
	
	var _sections20_gameShowGameShowSection = __webpack_require__(168);
	
	var _sections20_gameShowGameShowSection2 = _interopRequireDefault(_sections20_gameShowGameShowSection);
	
	var _sections30_classActivityClassActivitySection = __webpack_require__(224);
	
	var _sections30_classActivityClassActivitySection2 = _interopRequireDefault(_sections30_classActivityClassActivitySection);
	
	var _sections70_missionAssignmentMissionAssignmentSection = __webpack_require__(297);
	
	var _sections70_missionAssignmentMissionAssignmentSection2 = _interopRequireDefault(_sections70_missionAssignmentMissionAssignmentSection);
	
	var _sections90_finishFinishSection = __webpack_require__(225);
	
	var _sections90_finishFinishSection2 = _interopRequireDefault(_sections90_finishFinishSection);
	
	var _md = __webpack_require__(167);
	
	var _md2 = _interopRequireDefault(_md);
	
	var level = Number(__filename.replace(/^.*level/, '').replace('.jsx', ''));
	var _title = (0, _helpersI18n.i18nProvider)(function (lang) {
	  return _md2['default'][lang].getSectionMetadata('Level ' + level, 'Title');
	});
	
	var _default = (function (_Component) {
	  _inherits(_default, _Component);
	
	  function _default() {
	    _classCallCheck(this, _default);
	
	    _get(Object.getPrototypeOf(_default.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(_default, [{
	    key: 'render',
	    value: function render() {
	      var _context = this.context;
	      var regionData = _context.regionData;
	      var i18n = _context.i18n;
	
	      var title = i18n(_title);
	      return _react2['default'].createElement(
	        _spectaclePpa.Deck,
	        { transition: ['slide'],
	          transitionDuration: 800,
	          progress: 'bar' },
	        (0, _sections01_startStartSection2['default'])({ level: level, title: title, regionData: regionData, i18n: i18n }),
	        (0, _sections03_songSongSection2['default'])({ level: level, regionData: regionData, i18n: i18n }),
	        (0, _sections11_missionReportMissionReportSection2['default'])({ level: level, regionData: regionData, i18n: i18n }),
	        (0, _sections12_esStoryEsStorySection2['default'])({ level: level, subStory: 'a', regionData: regionData, i18n: i18n }),
	        (0, _sections20_gameShowGameShowSection2['default'])({ level: level, regionData: regionData, i18n: i18n }),
	        (0, _sections13_mmeMmeSection2['default'])({ level: level, regionData: regionData, i18n: i18n }),
	        (0, _sections30_classActivityClassActivitySection2['default'])({ level: level, regionData: regionData, i18n: i18n }),
	        (0, _sections12_esStoryEsStorySection2['default'])({ level: level, subStory: 'b', regionData: regionData, i18n: i18n }),
	        (0, _sections70_missionAssignmentMissionAssignmentSection2['default'])({ level: level, title: title, regionData: regionData, i18n: i18n }),
	        (0, _sections90_finishFinishSection2['default'])({ level: level, regionData: regionData, i18n: i18n })
	      );
	    }
	  }], [{
	    key: 'contextTypes',
	    value: {
	      regionData: _react.PropTypes.object.isRequired,
	      i18n: _react.PropTypes.func.isRequired
	    },
	    enumerable: true
	  }, {
	    key: 'metadata',
	    value: {
	      title: _title
	    },
	    enumerable: true
	  }]);

	  return _default;
	})(_react.Component);

	exports['default'] = _default;
	module.exports = exports['default'];
	/* Start */ /* Theme Song */ /* Mission Report */ /* Es Story 3a */ /* Game Show */ /* Messages from Mother Earth */ /* Class Activity: Poster */ /* Es Story 3b */ /* Mission Assignment */ /* Finish */
	/* WEBPACK VAR INJECTION */}.call(exports, "programs/h2whoa/level3.jsx"))

/***/ }),
/* 1056 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(__filename) {'use strict';
	
	var _get = __webpack_require__(8)['default'];
	
	var _inherits = __webpack_require__(5)['default'];
	
	var _createClass = __webpack_require__(6)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _helpersI18n = __webpack_require__(14);
	
	var _sections01_startStartSection = __webpack_require__(220);
	
	var _sections01_startStartSection2 = _interopRequireDefault(_sections01_startStartSection);
	
	var _sections03_songSongSection = __webpack_require__(221);
	
	var _sections03_songSongSection2 = _interopRequireDefault(_sections03_songSongSection);
	
	var _sections11_missionReportMissionReportSection = __webpack_require__(296);
	
	var _sections11_missionReportMissionReportSection2 = _interopRequireDefault(_sections11_missionReportMissionReportSection);
	
	var _sections12_esStoryEsStorySection = __webpack_require__(222);
	
	var _sections12_esStoryEsStorySection2 = _interopRequireDefault(_sections12_esStoryEsStorySection);
	
	var _sections13_mmeMmeSection = __webpack_require__(223);
	
	var _sections13_mmeMmeSection2 = _interopRequireDefault(_sections13_mmeMmeSection);
	
	var _sections20_gameShowGameShowSection = __webpack_require__(168);
	
	var _sections20_gameShowGameShowSection2 = _interopRequireDefault(_sections20_gameShowGameShowSection);
	
	var _sections30_classActivityClassActivitySection = __webpack_require__(224);
	
	var _sections30_classActivityClassActivitySection2 = _interopRequireDefault(_sections30_classActivityClassActivitySection);
	
	var _sections95_endingEndingSection = __webpack_require__(1061);
	
	var _sections95_endingEndingSection2 = _interopRequireDefault(_sections95_endingEndingSection);
	
	var _sections90_finishFinishSection = __webpack_require__(225);
	
	var _sections90_finishFinishSection2 = _interopRequireDefault(_sections90_finishFinishSection);
	
	var _md = __webpack_require__(167);
	
	var _md2 = _interopRequireDefault(_md);
	
	var level = Number(__filename.replace(/^.*level/, '').replace('.jsx', ''));
	var _title = (0, _helpersI18n.i18nProvider)(function (lang) {
	  return _md2['default'][lang].getSectionMetadata('Level ' + level, 'Title');
	});
	
	var _default = (function (_Component) {
	  _inherits(_default, _Component);
	
	  function _default() {
	    _classCallCheck(this, _default);
	
	    _get(Object.getPrototypeOf(_default.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(_default, [{
	    key: 'render',
	    value: function render() {
	      var _context = this.context;
	      var regionData = _context.regionData;
	      var i18n = _context.i18n;
	
	      var title = i18n(_title);
	      return _react2['default'].createElement(
	        _spectaclePpa.Deck,
	        { transition: ['slide'],
	          transitionDuration: 800,
	          progress: 'bar' },
	        (0, _sections01_startStartSection2['default'])({ level: level, title: title, regionData: regionData, i18n: i18n }),
	        (0, _sections03_songSongSection2['default'])({ level: level, regionData: regionData, i18n: i18n }),
	        (0, _sections11_missionReportMissionReportSection2['default'])({ level: level, regionData: regionData, i18n: i18n }),
	        (0, _sections12_esStoryEsStorySection2['default'])({ level: level, subStory: 'a', regionData: regionData, i18n: i18n }),
	        (0, _sections20_gameShowGameShowSection2['default'])({ level: level, regionData: regionData, i18n: i18n }),
	        (0, _sections13_mmeMmeSection2['default'])({ level: level, regionData: regionData, i18n: i18n }),
	        (0, _sections30_classActivityClassActivitySection2['default'])({ level: level, regionData: regionData, i18n: i18n }),
	        (0, _sections12_esStoryEsStorySection2['default'])({ level: level, subStory: 'b', regionData: regionData, i18n: i18n }),
	        (0, _sections95_endingEndingSection2['default'])({ regionData: regionData, i18n: i18n }),
	        (0, _sections90_finishFinishSection2['default'])({ level: level, regionData: regionData, i18n: i18n })
	      );
	    }
	  }], [{
	    key: 'contextTypes',
	    value: {
	      regionData: _react.PropTypes.object.isRequired,
	      i18n: _react.PropTypes.func.isRequired
	    },
	    enumerable: true
	  }, {
	    key: 'metadata',
	    value: {
	      title: _title
	    },
	    enumerable: true
	  }]);

	  return _default;
	})(_react.Component);

	exports['default'] = _default;
	module.exports = exports['default'];
	/* Start */ /* Theme Song */ /* Mission Report */ /* Es Story 4a Green Apprentice news report and Nandor & Urb */ /* Game Show */ /* Messages from Mother Earth */ /* Class Activity: Skit */ /* Es Story 4b */ /* Ending */ /* Finish */
	/* WEBPACK VAR INJECTION */}.call(exports, "programs/h2whoa/level4.jsx"))

/***/ }),
/* 1057 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _get = __webpack_require__(8)['default'];
	
	var _inherits = __webpack_require__(5)['default'];
	
	var _createClass = __webpack_require__(6)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _baseSlidesBalloonSlide = __webpack_require__(67);
	
	var _baseSlidesBalloonSlide2 = _interopRequireDefault(_baseSlidesBalloonSlide);
	
	var _imagesCharactersSara_gigglePng = __webpack_require__(2381);
	
	var _imagesCharactersSara_gigglePng2 = _interopRequireDefault(_imagesCharactersSara_gigglePng);
	
	var _helpersMarkdownScript = __webpack_require__(9);
	
	var _helpersMarkdownScript2 = _interopRequireDefault(_helpersMarkdownScript);
	
	var _levelCompletedMd = __webpack_require__(1658);
	
	var _levelCompletedMd2 = _interopRequireDefault(_levelCompletedMd);
	
	var md = new _helpersMarkdownScript2['default'](_levelCompletedMd2['default']);
	
	var _default = (function (_Component) {
	  _inherits(_default, _Component);
	
	  function _default() {
	    _classCallCheck(this, _default);
	
	    _get(Object.getPrototypeOf(_default.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(_default, [{
	    key: 'render',
	    value: function render() {
	      var regionData = this.context.regionData;
	
	      return _react2['default'].createElement(
	        _spectaclePpa.Deck,
	        { transition: ['slide'],
	          transitionDuration: 800,
	          progress: 'bar' },
	        (0, _baseSlidesBalloonSlide2['default'])({
	          id: 'welcome-back',
	          characterSide: 'right',
	          characterImage: _imagesCharactersSara_gigglePng2['default'],
	          notes: md.getSubSectionAsHtml('Level Completed', 'Notes', false, regionData),
	          html: md.getSubSectionAsHtml('Level Completed', 'Content', false, regionData),
	          bgColor: '#37b34a'
	        })
	      );
	    }
	  }], [{
	    key: 'contextTypes',
	    value: {
	      regionData: _react.PropTypes.object.isRequired
	    },
	    enumerable: true
	  }]);

	  return _default;
	})(_react.Component);

	exports['default'] = _default;
	module.exports = exports['default'];

/***/ }),
/* 1058 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _get = __webpack_require__(8)['default'];
	
	var _inherits = __webpack_require__(5)['default'];
	
	var _createClass = __webpack_require__(6)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _componentsStartLevel = __webpack_require__(79);
	
	var _componentsStartLevel2 = _interopRequireDefault(_componentsStartLevel);
	
	var _sections00_prepPrepSection = __webpack_require__(1059);
	
	var _sections00_prepPrepSection2 = _interopRequireDefault(_sections00_prepPrepSection);
	
	var _default = (function (_Component) {
	  _inherits(_default, _Component);
	
	  function _default() {
	    _classCallCheck(this, _default);
	
	    _get(Object.getPrototypeOf(_default.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(_default, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var level = _props.nextLevel;
	      var configuration = _props.configuration;
	      var _context = this.context;
	      var regionData = _context.regionData;
	      var i18n = _context.i18n;
	
	      return _react2['default'].createElement(
	        _spectaclePpa.Deck,
	        { transition: ['slide'],
	          transitionDuration: 800,
	          progress: 'bar' },
	        (0, _sections00_prepPrepSection2['default'])({ level: level, configuration: configuration, regionData: regionData, i18n: i18n }),
	        _react2['default'].createElement(
	          _spectaclePpa.Slide,
	          {
	            id: 'start',
	            textColor: 'white' },
	          _react2['default'].createElement(_componentsStartLevel2['default'], null)
	        )
	      );
	    }
	  }], [{
	    key: 'propTypes',
	    value: {
	      nextLevel: _react.PropTypes.string.isRequired,
	      configuration: _react.PropTypes.string
	    },
	    enumerable: true
	  }, {
	    key: 'contextTypes',
	    value: {
	      regionData: _react.PropTypes.object.isRequired,
	      i18n: _react.PropTypes.func.isRequired
	    },
	    enumerable: true
	  }]);

	  return _default;
	})(_react.Component);

	exports['default'] = _default;
	module.exports = exports['default'];
	/* Prep */

/***/ }),
/* 1059 */
/***/ (function(module, exports, __webpack_require__) {

	/* eslint react/no-multi-comp: 0 */
	
	'use strict';
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _helpersI18n = __webpack_require__(14);
	
	var _componentsSelectConfiguration = __webpack_require__(77);
	
	var _componentsSelectConfiguration2 = _interopRequireDefault(_componentsSelectConfiguration);
	
	var _componentsSelectDeviceRole = __webpack_require__(78);
	
	var _componentsSelectDeviceRole2 = _interopRequireDefault(_componentsSelectDeviceRole);
	
	var _baseSlidesHtmlSlide = __webpack_require__(1050);
	
	var _baseSlidesHtmlSlide2 = _interopRequireDefault(_baseSlidesHtmlSlide);
	
	var _baseSlidesHeadingSlide = __webpack_require__(122);
	
	var _baseSlidesHeadingSlide2 = _interopRequireDefault(_baseSlidesHeadingSlide);
	
	var _baseSlidesVideoSlide = __webpack_require__(89);
	
	var _baseSlidesVideoSlide2 = _interopRequireDefault(_baseSlidesVideoSlide);
	
	var _helpersMarkdownScript = __webpack_require__(9);
	
	var _helpersMarkdownScript2 = _interopRequireDefault(_helpersMarkdownScript);
	
	var _tech_prepMd = __webpack_require__(1670);
	
	var _tech_prepMd2 = _interopRequireDefault(_tech_prepMd);
	
	var _tech_prepFr_CAMd = __webpack_require__(1669);
	
	var _tech_prepFr_CAMd2 = _interopRequireDefault(_tech_prepFr_CAMd);
	
	var techPrepMd = (0, _helpersI18n.i18nData)({
	  en: new _helpersMarkdownScript2['default'](_tech_prepMd2['default']),
	  fr_CA: new _helpersMarkdownScript2['default'](_tech_prepFr_CAMd2['default'])
	});
	
	function techPrepWizard(_ref) {
	  var regionData = _ref.regionData;
	  var i18n = _ref.i18n;
	
	  return (0, _baseSlidesHtmlSlide2['default'])({
	    id: 'tech-prep-wizard',
	    html: i18n(techPrepMd).getSectionAsHtml('Tech Prep Wizard', false, regionData)
	  });
	}
	
	function twoDeviceIntro(_ref2) {
	  var regionData = _ref2.regionData;
	  var i18n = _ref2.i18n;
	
	  return (0, _baseSlidesHtmlSlide2['default'])({
	    id: 'two-device-intro',
	    html: i18n(techPrepMd).getSectionAsHtml('Two Device Intro', false, regionData)
	  });
	}
	
	function selectConfiguration() {
	  return _react2['default'].createElement(
	    _spectaclePpa.Slide,
	    {
	      id: 'configuration',
	      textColor: 'white' },
	    _react2['default'].createElement(_componentsSelectConfiguration2['default'], null)
	  );
	}
	
	function connectingRemote(_ref3) {
	  var configuration = _ref3.configuration;
	  var regionData = _ref3.regionData;
	  var i18n = _ref3.i18n;
	
	  if (configuration === 'dualScreen') {
	    return (0, _baseSlidesHtmlSlide2['default'])({
	      id: 'connecting-remote',
	      html: i18n(techPrepMd).getSectionAsHtml('Connecting Remote', false, regionData)
	    });
	  } else {
	    return null;
	  }
	}
	
	function selectDeviceRole(configuration) {
	  if (configuration === 'dualScreen') {
	    return _react2['default'].createElement(
	      _spectaclePpa.Slide,
	      {
	        id: 'device-role',
	        textColor: 'white' },
	      _react2['default'].createElement(_componentsSelectDeviceRole2['default'], null)
	    );
	  } else {
	    return null;
	  }
	}
	
	function techCheckIntro(_ref4) {
	  var regionData = _ref4.regionData;
	  var i18n = _ref4.i18n;
	
	  return (0, _baseSlidesHtmlSlide2['default'])({
	    id: 'tech-check-intro',
	    html: i18n(techPrepMd).getSectionAsHtml('Tech Check Intro', false, regionData)
	  });
	}
	
	function techCheckVideo(_ref5) {
	  var regionData = _ref5.regionData;
	  var i18n = _ref5.i18n;
	
	  return (0, _baseSlidesVideoSlide2['default'])({
	    id: 'tech-check-video',
	    youTubeId: i18n(techPrepMd).getSectionMetadata('Tech Check Video', 'YouTube', regionData)
	  });
	}
	
	function levelPrep(_ref6) {
	  var configuration = _ref6.configuration;
	  var regionData = _ref6.regionData;
	  var i18n = _ref6.i18n;
	
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'prep' },
	    techPrepWizard({ regionData: regionData, i18n: i18n }),
	    twoDeviceIntro({ regionData: regionData, i18n: i18n }),
	    selectConfiguration(),
	    connectingRemote({ configuration: configuration, regionData: regionData, i18n: i18n }),
	    selectDeviceRole(configuration),
	    techCheckIntro({ regionData: regionData, i18n: i18n }),
	    techCheckVideo({ regionData: regionData, i18n: i18n })
	  );
	}
	
	function levelCompletedPrep(_ref7) {
	  var configuration = _ref7.configuration;
	  var regionData = _ref7.regionData;
	  var i18n = _ref7.i18n;
	
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'prep' },
	    selectConfiguration(),
	    connectingRemote({ configuration: configuration, regionData: regionData, i18n: i18n }),
	    selectDeviceRole(configuration)
	  );
	}
	
	function prepSection(_ref8) {
	  var level = _ref8.level;
	  var configuration = _ref8.configuration;
	  var regionData = _ref8.regionData;
	  var i18n = _ref8.i18n;
	
	  switch (level) {
	    case '1':
	      return levelPrep({ configuration: configuration, regionData: regionData, i18n: i18n });
	    case '2':
	      return levelPrep({ configuration: configuration, regionData: regionData, i18n: i18n });
	    case '3':
	      return levelPrep({ configuration: configuration, regionData: regionData, i18n: i18n });
	    case '4':
	      return levelPrep({ configuration: configuration, regionData: regionData, i18n: i18n });
	    case 'completed':
	      return levelCompletedPrep({ configuration: configuration, regionData: regionData, i18n: i18n });
	    default:
	      return (0, _baseSlidesHeadingSlide2['default'])({ heading: 'Unknown' });
	  }
	}
	
	exports['default'] = prepSection;
	module.exports = exports['default'];
	/* Tech Prep Wizard */ /* Two Device Intro */ /* Select Configuration */ /* Connecting Remote Instructions */ /* Select Device Role */ /* Tech Check Intro */ /* Tech Check Video */ /* Start Level */ /* Select Configuration */ /* Connecting Remote */ /* Select Device Role */

/***/ }),
/* 1060 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.preloadGameShow = preloadGameShow;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _helpersI18n = __webpack_require__(14);
	
	var _componentsTeamNames = __webpack_require__(60);
	
	var _componentsTeamNames2 = _interopRequireDefault(_componentsTeamNames);
	
	var _baseSlidesVideoSlide = __webpack_require__(89);
	
	var _baseSlidesVideoSlide2 = _interopRequireDefault(_baseSlidesVideoSlide);
	
	var _baseSlidesBalloonSlide = __webpack_require__(67);
	
	var _baseSlidesBalloonSlide2 = _interopRequireDefault(_baseSlidesBalloonSlide);
	
	var _helpersMarkdownScript = __webpack_require__(9);
	
	var _helpersMarkdownScript2 = _interopRequireDefault(_helpersMarkdownScript);
	
	var _teamCreationMd = __webpack_require__(1676);
	
	var _teamCreationMd2 = _interopRequireDefault(_teamCreationMd);
	
	var _teamCreationFr_CAMd = __webpack_require__(1675);
	
	var _teamCreationFr_CAMd2 = _interopRequireDefault(_teamCreationFr_CAMd);
	
	var _imagesCharactersApprenticesRowArmsFoldedPng = __webpack_require__(2370);
	
	var _imagesCharactersApprenticesRowArmsFoldedPng2 = _interopRequireDefault(_imagesCharactersApprenticesRowArmsFoldedPng);
	
	var _imagesCharactersApprenticeHandsHipsPng = __webpack_require__(2362);
	
	var _imagesCharactersApprenticeHandsHipsPng2 = _interopRequireDefault(_imagesCharactersApprenticeHandsHipsPng);
	
	var _imagesCharactersApprenticesFlexArmsPng = __webpack_require__(430);
	
	var _imagesCharactersApprenticesFlexArmsPng2 = _interopRequireDefault(_imagesCharactersApprenticesFlexArmsPng);
	
	var _imagesCharactersApprenticePointingDiagonalPng = __webpack_require__(884);
	
	var _imagesCharactersApprenticePointingDiagonalPng2 = _interopRequireDefault(_imagesCharactersApprenticePointingDiagonalPng);
	
	var md = (0, _helpersI18n.i18nData)({
	  en: new _helpersMarkdownScript2['default'](_teamCreationMd2['default']),
	  fr_CA: new _helpersMarkdownScript2['default'](_teamCreationFr_CAMd2['default'])
	});
	
	function preloadGameShow() {
	  (0, _spectaclePpa.preloader)([_imagesCharactersApprenticesRowArmsFoldedPng2['default'], _imagesCharactersApprenticeHandsHipsPng2['default'], apprenticePointingUp, _imagesCharactersApprenticesFlexArmsPng2['default']]);
	}
	
	function teamCreationSection(_ref) {
	  var regionData = _ref.regionData;
	  var i18n = _ref.i18n;
	
	  var md_i18n = i18n(md);
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'team-creation' },
	    (0, _baseSlidesVideoSlide2['default'])({
	      id: 'intro-team-names',
	      notes: md_i18n.getSubSectionAsHtml('Intro Team Names', 'Notes', false, regionData),
	      youTubeId: md_i18n.getSectionMetadata('Intro Team Names', 'YouTube', regionData)
	    }),
	    (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'get-into-teams',
	      characterSide: 'right',
	      characterImage: _imagesCharactersApprenticesRowArmsFoldedPng2['default'],
	      notes: md_i18n.getSubSectionAsHtml('Get Into Teams', 'Notes', false, regionData),
	      html: md_i18n.getSubSectionAsHtml('Get Into Teams', 'Content', false, regionData)
	    }),
	    _react2['default'].createElement(
	      _spectaclePpa.Slide,
	      {
	        id: 'assign',
	        bgColor: 'black',
	        notes: '<h2>Assign Team Names</h2>',
	        teamNames: true },
	      _react2['default'].createElement(
	        'div',
	        { className: 'ui-slide' },
	        _react2['default'].createElement(
	          _spectaclePpa.Heading,
	          { size: 1 },
	          i18n('Name your teams!')
	        ),
	        _react2['default'].createElement(_componentsTeamNames2['default'], null)
	      )
	    ),
	    (0, _baseSlidesVideoSlide2['default'])({
	      id: 'scoring-intro-video',
	      notes: md_i18n.getSubSectionAsHtml('Scoring Intro Video', 'Notes', false, regionData),
	      youTubeId: md_i18n.getSectionMetadata('Scoring Intro Video', 'YouTube', regionData)
	    }),
	    (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'scoring-intro',
	      characterSide: 'right',
	      characterImage: _imagesCharactersApprenticeHandsHipsPng2['default'],
	      notes: md_i18n.getSubSectionAsHtml('Scoring Intro', 'Notes', false, regionData),
	      html: md_i18n.getSubSectionAsHtml('Scoring Intro', 'Content', false, regionData)
	    }),
	    (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'scoreboard-intro',
	      characterSide: 'right',
	      characterImage: _imagesCharactersApprenticePointingDiagonalPng2['default'],
	      notes: md_i18n.getSubSectionAsHtml('Scoreboard Intro', 'Notes', false, regionData),
	      html: md_i18n.getSubSectionAsHtml('Scoreboard Intro', 'Content', false, regionData)
	    }),
	    (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'id-cards',
	      characterSide: 'left',
	      characterImage: _imagesCharactersApprenticesFlexArmsPng2['default'],
	      notes: md_i18n.getSubSectionAsHtml('ID Cards', 'Notes', false, regionData),
	      html: md_i18n.getSubSectionAsHtml('ID Cards', 'Content', false, regionData)
	    })
	  );
	}
	
	exports['default'] = teamCreationSection;
	/* Sara and Ian welcome to Academy */ /* Get into teams and come up with a cool name */ /* Enter team names */ /* Sara and Ian talk about points */ /* Scoring intro */ /* Introduce scoreboard */ /* ID cards draw your avatar */

/***/ }),
/* 1061 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.preloadEnding = preloadEnding;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _helpersI18n = __webpack_require__(14);
	
	var _baseSlidesBalloonSlide = __webpack_require__(67);
	
	var _baseSlidesBalloonSlide2 = _interopRequireDefault(_baseSlidesBalloonSlide);
	
	var _baseSlidesHeadingSlide = __webpack_require__(122);
	
	var _baseSlidesHeadingSlide2 = _interopRequireDefault(_baseSlidesHeadingSlide);
	
	var _imagesLogo_ppaPng = __webpack_require__(891);
	
	var _imagesLogo_ppaPng2 = _interopRequireDefault(_imagesLogo_ppaPng);
	
	var _imagesCharactersEsmeralda_goober_goofy_smilePng = __webpack_require__(885);
	
	var _imagesCharactersEsmeralda_goober_goofy_smilePng2 = _interopRequireDefault(_imagesCharactersEsmeralda_goober_goofy_smilePng);
	
	var _imagesCharactersIan_sara_sillyPng = __webpack_require__(2378);
	
	var _imagesCharactersIan_sara_sillyPng2 = _interopRequireDefault(_imagesCharactersIan_sara_sillyPng);
	
	var _imagesCharactersEsmeralda_goober_proudPng = __webpack_require__(886);
	
	var _imagesCharactersEsmeralda_goober_proudPng2 = _interopRequireDefault(_imagesCharactersEsmeralda_goober_proudPng);
	
	var _helpersMarkdownScript = __webpack_require__(9);
	
	var _helpersMarkdownScript2 = _interopRequireDefault(_helpersMarkdownScript);
	
	var _endingMd = __webpack_require__(1714);
	
	var _endingMd2 = _interopRequireDefault(_endingMd);
	
	var _endingFr_CAMd = __webpack_require__(1713);
	
	var _endingFr_CAMd2 = _interopRequireDefault(_endingFr_CAMd);
	
	var md = (0, _helpersI18n.i18nData)({
	  en: new _helpersMarkdownScript2['default'](_endingMd2['default']),
	  fr_CA: new _helpersMarkdownScript2['default'](_endingFr_CAMd2['default'])
	});
	
	function preloadEnding() {
	  (0, _spectaclePpa.preloader)([_imagesCharactersEsmeralda_goober_goofy_smilePng2['default'], _imagesCharactersIan_sara_sillyPng2['default'], _imagesCharactersEsmeralda_goober_proudPng2['default'], _imagesLogo_ppaPng2['default']]);
	}
	
	function endingSection(_ref) {
	  var regionData = _ref.regionData;
	  var i18n = _ref.i18n;
	
	  var md_i18n = i18n(md);
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'ending' },
	    (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'announce-winners',
	      characterSide: 'right',
	      characterImage: _imagesCharactersIan_sara_sillyPng2['default'],
	      html: md_i18n.getSubSectionAsHtml('Announce Winners', 'Content', false, regionData),
	      notes: md_i18n.getSubSectionAsHtml('Announce Winners', 'Notes', false, regionData)
	    }),
	    (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'planet-protectors',
	      characterSide: 'left',
	      characterImage: _imagesCharactersEsmeralda_goober_proudPng2['default'],
	      html: md_i18n.getSubSectionAsHtml('Planet Protectors', 'Content', false, regionData),
	      notes: md_i18n.getSubSectionAsHtml('Planet Protectors', 'Notes', false, regionData)
	    }),
	    (0, _baseSlidesHeadingSlide2['default'])({
	      id: 'completed',
	      beforeImage: _imagesLogo_ppaPng2['default'],
	      heading: i18n('H2Whoa') + '!',
	      subHeading: i18n('All levels completed') + '!!!',
	      notes: md_i18n.getSubSectionAsHtml('All Levels Completed', 'Notes', false, regionData),
	      bgColor: 'black'
	    })
	  );
	}
	
	exports['default'] = endingSection;
	/* Time to see who won! */ /* You're now all Planet Protectors */ /* You've completed all the levels */

/***/ }),
/* 1062 */
/***/ (function(module, exports) {

	/* eslint-disable object-shorthand */
	'use strict';
	
	var colors = {
	  primary: '#37bad5',
	  secondary: 'black',
	  tertiary: 'white',
	  level1: '#ffbc00',
	  level2: '#8f288c',
	  level3: '#26a7df',
	  level4: '#e80a89',
	  level5: '#f59122',
	  level6: '#37b34a',
	  gameshow: '#742CBF',
	  question: '#45B3EC',
	  answer: '#6FC36E'
	};
	
	var fonts = {
	  primary: 'BrandonTextWeb',
	  secondary: 'Orbitron',
	  tertiary: 'Ubuntu'
	};
	
	module.exports = {
	  colors: colors,
	  fonts: fonts,
	  global: {
	    body: {
	      background: 'transparent',
	      fontFamily: fonts.primary,
	      fontWeight: 'normal',
	      fontSize: '2em',
	      color: colors.primary,
	      overflow: 'hidden'
	    },
	    'html, body': {
	      // height: '100%'
	    },
	    '*': {
	      boxSizing: 'border-box'
	    },
	    input: {
	      color: 'black',
	      fontWeight: 'bold',
	      backgroundColor: 'white',
	      fontSize: '2.66em',
	      fontFamily: fonts.primary,
	      padding: '0.25em 0.25em 0.2em',
	      margin: '1% 1% 3%',
	      width: '98%'
	    },
	    label: {
	      color: 'white',
	      fontWeight: 'bold',
	      fontSize: '1.8em',
	      margin: '0.1em 0 0'
	    }
	  },
	  progress: {
	    bar: {
	      container: {
	        position: 'absolute',
	        height: '22px',
	        width: '100%',
	        bottom: 0,
	        left: 0,
	        transition: 'all 1s ease-in-out 0.2s',
	        zIndex: 1000
	      },
	      bar: {
	        height: '100%',
	        background: colors.primary,
	        transition: 'all 0.3s ease-out',
	        fontSize: '12px',
	        letterSpacing: '0.1em',
	        textTransform: 'uppercase',
	        padding: '4px',
	        textAlign: 'right'
	      }
	    },
	    number: {
	      container: {
	        position: 'absolute',
	        bottom: 10,
	        right: 10,
	        zIndex: 1000,
	        color: colors.tertiary
	      }
	    }
	  },
	  components: {
	    codePane: {
	      pre: {
	        margin: 'auto',
	        fontSize: '1em',
	        fontWeight: 'normal',
	        fontFamily: fonts.tertiary,
	        minWidth: '100%',
	        maxWidth: 800
	      },
	      code: {
	        textAlign: 'left',
	        padding: 20,
	        fontWeight: 'normal'
	      }
	    },
	    code: {
	      color: 'black',
	      fontSize: '2.66em',
	      fontFamily: fonts.tertiary,
	      margin: '0.25em auto',
	      backgroundColor: 'rgba(0,0,0,0.15)',
	      padding: '0 10px',
	      borderRadius: 3
	    },
	    heading: {},
	    link: {
	      textDecoration: 'none'
	    },
	    listItem: {
	      fontSize: '2.66em',
	      padding: '0 0 0.5em'
	    },
	    list: {
	      textAlign: 'center',
	      listStyle: 'none',
	      padding: '0.5em 0'
	    },
	    s: {
	      strikethrough: {}
	    },
	    text: {
	      color: 'black',
	      fontSize: '2.66em',
	      fontFamily: fonts.primary,
	      margin: '0.25em auto',
	      textShadow: '0 0 10px rgba(0,0,0,0.2)'
	    }
	  }
	};

/***/ }),
/* 1063 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = __webpack_require__(7)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	function htmlSlide(_ref) {
	  var id = _ref.id;
	  var notes = _ref.notes;
	  var heading = _ref.heading;
	  var bgColor = _ref.bgColor;
	  var subHeading = _ref.subHeading;
	  var html = _ref.html;
	  var slideClass = _ref.slideClass;
	
	  var slideContentClass = slideClass ? ' slide-' + slideClass : '';
	  var bgColorOpts = {};
	  if (bgColor) {
	    bgColorOpts.bgColor = bgColor;
	  }
	  return _react2['default'].createElement(
	    _spectaclePpa.Slide,
	    _extends({
	      id: id,
	      key: id
	    }, bgColorOpts, {
	      notes: notes,
	      textColor: 'white' }),
	    _react2['default'].createElement(
	      'div',
	      { className: 'slide-content' + slideContentClass },
	      _react2['default'].createElement(
	        'div',
	        {
	          className: 'text-formatted' },
	        !!heading && _react2['default'].createElement(
	          _spectaclePpa.Heading,
	          { size: 3 },
	          heading
	        ),
	        !!subHeading && _react2['default'].createElement(
	          _spectaclePpa.Heading,
	          { size: 5 },
	          subHeading
	        ),
	        _react2['default'].createElement('div', {
	          dangerouslySetInnerHTML: { __html: html } })
	      )
	    )
	  );
	}
	
	exports['default'] = htmlSlide;
	module.exports = exports['default'];

/***/ }),
/* 1064 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = {
	  width: 1000,
	  height: 700,
	  margin: 40,
	  theme: __webpack_require__(1073),
	  print: __webpack_require__(53),
	  html: __webpack_require__(52)
	};

/***/ }),
/* 1065 */
/***/ (function(module, exports, __webpack_require__) {

	/* eslint no-console: 0 */
	
	'use strict';
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _helpersMarkdownScript = __webpack_require__(9);
	
	var _helpersMarkdownScript2 = _interopRequireDefault(_helpersMarkdownScript);
	
	var _indexMd = __webpack_require__(349);
	
	var _indexMd2 = _interopRequireDefault(_indexMd);
	
	var _extensionActivitiesExtensionActivitiesMd = __webpack_require__(1715);
	
	var _extensionActivitiesExtensionActivitiesMd2 = _interopRequireDefault(_extensionActivitiesExtensionActivitiesMd);
	
	var _programPrepProgramPrepMd = __webpack_require__(1718);
	
	var _programPrepProgramPrepMd2 = _interopRequireDefault(_programPrepProgramPrepMd);
	
	var _sections00_prepLevel1_prepMd = __webpack_require__(1719);
	
	var _sections00_prepLevel1_prepMd2 = _interopRequireDefault(_sections00_prepLevel1_prepMd);
	
	var _sections00_prepLevel2_prepMd = __webpack_require__(1720);
	
	var _sections00_prepLevel2_prepMd2 = _interopRequireDefault(_sections00_prepLevel2_prepMd);
	
	var _funMd = __webpack_require__(1716);
	
	var _funMd2 = _interopRequireDefault(_funMd);
	
	var _imagesH2whoaPng = __webpack_require__(2415);
	
	var _imagesH2whoaPng2 = _interopRequireDefault(_imagesH2whoaPng);
	
	var _imagesH2whoaTrialPng = __webpack_require__(2418);
	
	var _imagesH2whoaTrialPng2 = _interopRequireDefault(_imagesH2whoaTrialPng);
	
	var _imagesH2whoaExpiredPng = __webpack_require__(2416);
	
	var _imagesH2whoaExpiredPng2 = _interopRequireDefault(_imagesH2whoaExpiredPng);
	
	var _config = __webpack_require__(1064);
	
	var _config2 = _interopRequireDefault(_config);
	
	// Preload image functions
	
	var _sections20_gameShowGameShowSection = __webpack_require__(298);
	
	__webpack_require__(2191);
	
	var md = new _helpersMarkdownScript2['default'](_indexMd2['default']);
	
	var levels = {
	  prep: {
	    deck: __webpack_require__(1069)
	  },
	  1: {
	    thumbnail: __webpack_require__(898),
	    overviewThumbnail: __webpack_require__(2421),
	    deck: __webpack_require__(1066),
	    prep: new _helpersMarkdownScript2['default'](_sections00_prepLevel1_prepMd2['default']),
	    levelName: 'Water Wise'
	  },
	  2: {
	    thumbnail: __webpack_require__(2420),
	    overviewThumbnail: __webpack_require__(2422),
	    deck: __webpack_require__(1067),
	    prep: new _helpersMarkdownScript2['default'](_sections00_prepLevel2_prepMd2['default']),
	    levelName: 'Celebrate'
	  },
	  completed: {
	    deck: __webpack_require__(1068)
	  }
	};
	
	var program = {
	  id: 'h2whoaHybrid',
	  title: md.getSectionAsString('Title - Short'),
	  longTitle: md.getSectionAsString('Title - Long'),
	  thumbnailImage: _imagesH2whoaPng2['default'],
	  trialImageThumb: _imagesH2whoaTrialPng2['default'],
	  expiredImageThumb: _imagesH2whoaExpiredPng2['default'],
	  longDescription: md.getSectionAsString('Description - Long'),
	  shortDescription: md.getSectionAsString('Description - Short'),
	  levelsDescription: md.getSectionAsString('Description - Levels'),
	  levels: levels,
	  extensionActivitiesMd: new _helpersMarkdownScript2['default'](_extensionActivitiesExtensionActivitiesMd2['default']),
	  programPrepMd: new _helpersMarkdownScript2['default'](_programPrepProgramPrepMd2['default']),
	  funMd: new _helpersMarkdownScript2['default'](_funMd2['default']),
	  preload: function preload(_ref) {
	    var level = _ref.level;
	
	    console.log('Preloading assets for Level ' + level);
	
	    (0, _sections20_gameShowGameShowSection.preloadGameShow)();
	  },
	  config: _config2['default'],
	  featuredOnly: true
	};
	
	exports['default'] = program;
	module.exports = exports['default'];

/***/ }),
/* 1066 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(__filename) {'use strict';
	
	var _get = __webpack_require__(8)['default'];
	
	var _inherits = __webpack_require__(5)['default'];
	
	var _createClass = __webpack_require__(6)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _helpersMarkdownScript = __webpack_require__(9);
	
	var _helpersMarkdownScript2 = _interopRequireDefault(_helpersMarkdownScript);
	
	var _indexMd = __webpack_require__(349);
	
	var _indexMd2 = _interopRequireDefault(_indexMd);
	
	var _sections01_startStartSection = __webpack_require__(466);
	
	var _sections01_startStartSection2 = _interopRequireDefault(_sections01_startStartSection);
	
	var _sections03_songSongSection = __webpack_require__(467);
	
	var _sections03_songSongSection2 = _interopRequireDefault(_sections03_songSongSection);
	
	var _sections10_teamCreationTeamCreationSection = __webpack_require__(1071);
	
	var _sections10_teamCreationTeamCreationSection2 = _interopRequireDefault(_sections10_teamCreationTeamCreationSection);
	
	var _sections20_gameShowGameShowSection = __webpack_require__(298);
	
	var _sections20_gameShowGameShowSection2 = _interopRequireDefault(_sections20_gameShowGameShowSection);
	
	var _sections12_missionReportMissionReportSection = __webpack_require__(468);
	
	var _sections12_missionReportMissionReportSection2 = _interopRequireDefault(_sections12_missionReportMissionReportSection);
	
	var _sections30_classActivityClassActivitySection = __webpack_require__(469);
	
	var _sections30_classActivityClassActivitySection2 = _interopRequireDefault(_sections30_classActivityClassActivitySection);
	
	var _sections70_missionAssignmentMissionAssignmentSection = __webpack_require__(470);
	
	var _sections70_missionAssignmentMissionAssignmentSection2 = _interopRequireDefault(_sections70_missionAssignmentMissionAssignmentSection);
	
	var _sections90_finishFinishSection = __webpack_require__(471);
	
	var _sections90_finishFinishSection2 = _interopRequireDefault(_sections90_finishFinishSection);
	
	var md = new _helpersMarkdownScript2['default'](_indexMd2['default']);
	var level = Number(__filename.replace(/^.*level/, '').replace('.jsx', ''));
	var title = md.getSectionMetadata('Level ' + level, 'Title');
	
	var _default = (function (_Component) {
	  _inherits(_default, _Component);
	
	  function _default() {
	    _classCallCheck(this, _default);
	
	    _get(Object.getPrototypeOf(_default.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(_default, [{
	    key: 'render',
	    value: function render() {
	      var regionData = this.context.regionData;
	
	      return _react2['default'].createElement(
	        _spectaclePpa.Deck,
	        { transition: ['slide'],
	          transitionDuration: 800,
	          progress: 'bar' },
	        (0, _sections01_startStartSection2['default'])({ level: level, title: title, regionData: regionData }),
	        (0, _sections03_songSongSection2['default'])({ level: level, regionData: regionData }),
	        (0, _sections10_teamCreationTeamCreationSection2['default'])({ regionData: regionData }),
	        (0, _sections20_gameShowGameShowSection2['default'])({ level: level, regionData: regionData }),
	        (0, _sections12_missionReportMissionReportSection2['default'])({ level: level, regionData: regionData }),
	        (0, _sections30_classActivityClassActivitySection2['default'])({ level: level, regionData: regionData }),
	        (0, _sections70_missionAssignmentMissionAssignmentSection2['default'])({ level: level, title: title, regionData: regionData }),
	        (0, _sections90_finishFinishSection2['default'])({ level: level, regionData: regionData })
	      );
	    }
	  }], [{
	    key: 'contextTypes',
	    value: {
	      regionData: _react.PropTypes.object.isRequired
	    },
	    enumerable: true
	  }, {
	    key: 'metadata',
	    value: {
	      title: title
	    },
	    enumerable: true
	  }]);

	  return _default;
	})(_react.Component);

	exports['default'] = _default;
	module.exports = exports['default'];
	/* Start */ /* Theme Song */ /* Team Creation and Introduction */ /* Game Show */ /* Mission Report */ /* Class Activity: Drawing */ /* Mission Assignment */ /* Finish */
	/* WEBPACK VAR INJECTION */}.call(exports, "programs/h2whoaHybrid/level1.jsx"))

/***/ }),
/* 1067 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(__filename) {'use strict';
	
	var _get = __webpack_require__(8)['default'];
	
	var _inherits = __webpack_require__(5)['default'];
	
	var _createClass = __webpack_require__(6)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _helpersMarkdownScript = __webpack_require__(9);
	
	var _helpersMarkdownScript2 = _interopRequireDefault(_helpersMarkdownScript);
	
	var _indexMd = __webpack_require__(349);
	
	var _indexMd2 = _interopRequireDefault(_indexMd);
	
	var _sections01_startStartSection = __webpack_require__(466);
	
	var _sections01_startStartSection2 = _interopRequireDefault(_sections01_startStartSection);
	
	var _sections03_songSongSection = __webpack_require__(467);
	
	var _sections03_songSongSection2 = _interopRequireDefault(_sections03_songSongSection);
	
	var _sections12_missionReportMissionReportSection = __webpack_require__(468);
	
	var _sections12_missionReportMissionReportSection2 = _interopRequireDefault(_sections12_missionReportMissionReportSection);
	
	var _sections20_gameShowGameShowSection = __webpack_require__(298);
	
	var _sections20_gameShowGameShowSection2 = _interopRequireDefault(_sections20_gameShowGameShowSection);
	
	var _sections30_classActivityClassActivitySection = __webpack_require__(469);
	
	var _sections30_classActivityClassActivitySection2 = _interopRequireDefault(_sections30_classActivityClassActivitySection);
	
	var _sections70_missionAssignmentMissionAssignmentSection = __webpack_require__(470);
	
	var _sections70_missionAssignmentMissionAssignmentSection2 = _interopRequireDefault(_sections70_missionAssignmentMissionAssignmentSection);
	
	var _sections90_finishFinishSection = __webpack_require__(471);
	
	var _sections90_finishFinishSection2 = _interopRequireDefault(_sections90_finishFinishSection);
	
	var _sections95_endingEndingSection = __webpack_require__(1072);
	
	var _sections95_endingEndingSection2 = _interopRequireDefault(_sections95_endingEndingSection);
	
	var md = new _helpersMarkdownScript2['default'](_indexMd2['default']);
	var level = Number(__filename.replace(/^.*level/, '').replace('.jsx', ''));
	var title = md.getSectionMetadata('Level ' + level, 'Title');
	
	var _default = (function (_Component) {
	  _inherits(_default, _Component);
	
	  function _default() {
	    _classCallCheck(this, _default);
	
	    _get(Object.getPrototypeOf(_default.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(_default, [{
	    key: 'render',
	    value: function render() {
	      var regionData = this.context.regionData;
	
	      return _react2['default'].createElement(
	        _spectaclePpa.Deck,
	        { transition: ['slide'],
	          transitionDuration: 800,
	          progress: 'bar' },
	        (0, _sections01_startStartSection2['default'])({ level: level, title: title, regionData: regionData }),
	        (0, _sections03_songSongSection2['default'])({ level: level, regionData: regionData }),
	        (0, _sections12_missionReportMissionReportSection2['default'])({ level: level, regionData: regionData }),
	        (0, _sections20_gameShowGameShowSection2['default'])({ level: level, regionData: regionData }),
	        (0, _sections30_classActivityClassActivitySection2['default'])({ level: level, regionData: regionData }),
	        (0, _sections70_missionAssignmentMissionAssignmentSection2['default'])({ level: level, title: title, regionData: regionData }),
	        (0, _sections95_endingEndingSection2['default'])({ level: level, regionData: regionData }),
	        (0, _sections90_finishFinishSection2['default'])({ level: level, regionData: regionData })
	      );
	    }
	  }], [{
	    key: 'contextTypes',
	    value: {
	      regionData: _react.PropTypes.object.isRequired
	    },
	    enumerable: true
	  }, {
	    key: 'metadata',
	    value: {
	      title: title
	    },
	    enumerable: true
	  }]);

	  return _default;
	})(_react.Component);

	exports['default'] = _default;
	module.exports = exports['default'];
	/* Start */ /* Theme Song */ /* Mission Report */ /* Game Show */ /* Class Activity: Writing */ /* Mission Assignment */ /* Ending */ /* Finish */
	/* WEBPACK VAR INJECTION */}.call(exports, "programs/h2whoaHybrid/level2.jsx"))

/***/ }),
/* 1068 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _get = __webpack_require__(8)['default'];
	
	var _inherits = __webpack_require__(5)['default'];
	
	var _createClass = __webpack_require__(6)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _baseSlidesBalloonSlide = __webpack_require__(68);
	
	var _baseSlidesBalloonSlide2 = _interopRequireDefault(_baseSlidesBalloonSlide);
	
	var _imagesCharactersSara_gigglePng = __webpack_require__(896);
	
	var _imagesCharactersSara_gigglePng2 = _interopRequireDefault(_imagesCharactersSara_gigglePng);
	
	var _helpersMarkdownScript = __webpack_require__(9);
	
	var _helpersMarkdownScript2 = _interopRequireDefault(_helpersMarkdownScript);
	
	var _levelCompletedMd = __webpack_require__(1717);
	
	var _levelCompletedMd2 = _interopRequireDefault(_levelCompletedMd);
	
	var md = new _helpersMarkdownScript2['default'](_levelCompletedMd2['default']);
	
	var _default = (function (_Component) {
	  _inherits(_default, _Component);
	
	  function _default() {
	    _classCallCheck(this, _default);
	
	    _get(Object.getPrototypeOf(_default.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(_default, [{
	    key: 'render',
	    value: function render() {
	      var regionData = this.context.regionData;
	
	      return _react2['default'].createElement(
	        _spectaclePpa.Deck,
	        { transition: ['slide'],
	          transitionDuration: 800,
	          progress: 'bar' },
	        (0, _baseSlidesBalloonSlide2['default'])({
	          id: 'welcome-back',
	          characterSide: 'right',
	          characterImage: _imagesCharactersSara_gigglePng2['default'],
	          notes: md.getSubSectionAsHtml('Level Completed', 'Notes', false, regionData),
	          html: md.getSubSectionAsHtml('Level Completed', 'Content', false, regionData),
	          bgColor: '#37b34a'
	        })
	      );
	    }
	  }], [{
	    key: 'contextTypes',
	    value: {
	      regionData: _react.PropTypes.object.isRequired
	    },
	    enumerable: true
	  }]);

	  return _default;
	})(_react.Component);

	exports['default'] = _default;
	module.exports = exports['default'];

/***/ }),
/* 1069 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _get = __webpack_require__(8)['default'];
	
	var _inherits = __webpack_require__(5)['default'];
	
	var _createClass = __webpack_require__(6)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _componentsStartLevel = __webpack_require__(79);
	
	var _componentsStartLevel2 = _interopRequireDefault(_componentsStartLevel);
	
	var _sections00_prepPrepSection = __webpack_require__(1070);
	
	var _sections00_prepPrepSection2 = _interopRequireDefault(_sections00_prepPrepSection);
	
	var _default = (function (_Component) {
	  _inherits(_default, _Component);
	
	  function _default() {
	    _classCallCheck(this, _default);
	
	    _get(Object.getPrototypeOf(_default.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(_default, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var level = _props.nextLevel;
	      var configuration = _props.configuration;
	      var regionData = this.context.regionData;
	
	      return _react2['default'].createElement(
	        _spectaclePpa.Deck,
	        { transition: ['slide'],
	          transitionDuration: 800,
	          progress: 'bar' },
	        (0, _sections00_prepPrepSection2['default'])({ level: level, configuration: configuration, regionData: regionData }),
	        _react2['default'].createElement(
	          _spectaclePpa.Slide,
	          {
	            id: 'start',
	            textColor: 'white' },
	          _react2['default'].createElement(_componentsStartLevel2['default'], null)
	        )
	      );
	    }
	  }], [{
	    key: 'propTypes',
	    value: {
	      nextLevel: _react.PropTypes.string.isRequired,
	      configuration: _react.PropTypes.string
	    },
	    enumerable: true
	  }, {
	    key: 'contextTypes',
	    value: {
	      regionData: _react.PropTypes.object.isRequired
	    },
	    enumerable: true
	  }]);

	  return _default;
	})(_react.Component);

	exports['default'] = _default;
	module.exports = exports['default'];
	/* Prep */

/***/ }),
/* 1070 */
/***/ (function(module, exports, __webpack_require__) {

	/* eslint react/no-multi-comp: 0 */
	
	'use strict';
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _componentsSelectConfiguration = __webpack_require__(77);
	
	var _componentsSelectConfiguration2 = _interopRequireDefault(_componentsSelectConfiguration);
	
	var _componentsSelectDeviceRole = __webpack_require__(78);
	
	var _componentsSelectDeviceRole2 = _interopRequireDefault(_componentsSelectDeviceRole);
	
	var _baseSlidesHtmlSlide = __webpack_require__(1063);
	
	var _baseSlidesHtmlSlide2 = _interopRequireDefault(_baseSlidesHtmlSlide);
	
	var _baseSlidesHeadingSlide = __webpack_require__(169);
	
	var _baseSlidesHeadingSlide2 = _interopRequireDefault(_baseSlidesHeadingSlide);
	
	var _baseSlidesVideoSlide = __webpack_require__(90);
	
	var _baseSlidesVideoSlide2 = _interopRequireDefault(_baseSlidesVideoSlide);
	
	var _helpersMarkdownScript = __webpack_require__(9);
	
	var _helpersMarkdownScript2 = _interopRequireDefault(_helpersMarkdownScript);
	
	var _tech_prepMd = __webpack_require__(1721);
	
	var _tech_prepMd2 = _interopRequireDefault(_tech_prepMd);
	
	var techPrepMd = new _helpersMarkdownScript2['default'](_tech_prepMd2['default']);
	
	function techPrepWizard(_ref) {
	  var regionData = _ref.regionData;
	
	  return (0, _baseSlidesHtmlSlide2['default'])({
	    id: 'tech-prep-wizard',
	    html: techPrepMd.getSectionAsHtml('Tech Prep Wizard', false, regionData)
	  });
	}
	
	function twoDeviceIntro(_ref2) {
	  var regionData = _ref2.regionData;
	
	  return (0, _baseSlidesHtmlSlide2['default'])({
	    id: 'two-device-intro',
	    html: techPrepMd.getSectionAsHtml('Two Device Intro', false, regionData)
	  });
	}
	
	function selectConfiguration() {
	  return _react2['default'].createElement(
	    _spectaclePpa.Slide,
	    {
	      id: 'configuration',
	      textColor: 'white' },
	    _react2['default'].createElement(_componentsSelectConfiguration2['default'], null)
	  );
	}
	
	function connectingRemote(_ref3) {
	  var configuration = _ref3.configuration;
	  var regionData = _ref3.regionData;
	
	  if (configuration === 'dualScreen') {
	    return (0, _baseSlidesHtmlSlide2['default'])({
	      id: 'connecting-remote',
	      html: techPrepMd.getSectionAsHtml('Connecting Remote', false, regionData)
	    });
	  } else {
	    return null;
	  }
	}
	
	function selectDeviceRole(configuration) {
	  if (configuration === 'dualScreen') {
	    return _react2['default'].createElement(
	      _spectaclePpa.Slide,
	      {
	        id: 'device-role',
	        textColor: 'white' },
	      _react2['default'].createElement(_componentsSelectDeviceRole2['default'], null)
	    );
	  } else {
	    return null;
	  }
	}
	
	function techCheckIntro(_ref4) {
	  var regionData = _ref4.regionData;
	
	  return (0, _baseSlidesHtmlSlide2['default'])({
	    id: 'tech-check-intro',
	    html: techPrepMd.getSectionAsHtml('Tech Check Intro', false, regionData)
	  });
	}
	
	function techCheckVideo(_ref5) {
	  var regionData = _ref5.regionData;
	
	  return (0, _baseSlidesVideoSlide2['default'])({
	    id: 'tech-check-video',
	    youTubeId: techPrepMd.getSectionMetadata('Tech Check Video', 'YouTube', regionData)
	  });
	}
	
	function levelPrep(_ref6) {
	  var configuration = _ref6.configuration;
	  var regionData = _ref6.regionData;
	
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'prep' },
	    techPrepWizard({ regionData: regionData }),
	    twoDeviceIntro({ regionData: regionData }),
	    selectConfiguration(),
	    connectingRemote({ configuration: configuration, regionData: regionData }),
	    selectDeviceRole(configuration),
	    techCheckIntro({ regionData: regionData }),
	    techCheckVideo({ regionData: regionData })
	  );
	}
	
	function levelCompletedPrep(_ref7) {
	  var configuration = _ref7.configuration;
	  var regionData = _ref7.regionData;
	
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'prep' },
	    selectConfiguration(),
	    connectingRemote({ configuration: configuration, regionData: regionData }),
	    selectDeviceRole(configuration)
	  );
	}
	
	function prepSection(_ref8) {
	  var level = _ref8.level;
	  var configuration = _ref8.configuration;
	  var regionData = _ref8.regionData;
	
	  switch (level) {
	    case '1':
	      return levelPrep({ configuration: configuration, regionData: regionData });
	    case '2':
	      return levelPrep({ configuration: configuration, regionData: regionData });
	    case '3':
	      return levelPrep({ configuration: configuration, regionData: regionData });
	    case 'completed':
	      return levelCompletedPrep({ configuration: configuration, regionData: regionData });
	    default:
	      return (0, _baseSlidesHeadingSlide2['default'])({ heading: 'Unknown' });
	  }
	}
	
	exports['default'] = prepSection;
	module.exports = exports['default'];
	/* Tech Prep Wizard */ /* Two Device Intro */ /* Select Configuration */ /* Connecting Remote Instructions */ /* Select Device Role */ /* Tech Check Intro */ /* Tech Check Video */ /* Start Level */ /* Select Configuration */ /* Connecting Remote */ /* Select Device Role */

/***/ }),
/* 1071 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.preloadGameShow = preloadGameShow;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _componentsTeamNames = __webpack_require__(60);
	
	var _componentsTeamNames2 = _interopRequireDefault(_componentsTeamNames);
	
	var _baseSlidesVideoSlide = __webpack_require__(90);
	
	var _baseSlidesVideoSlide2 = _interopRequireDefault(_baseSlidesVideoSlide);
	
	var _baseSlidesBalloonSlide = __webpack_require__(68);
	
	var _baseSlidesBalloonSlide2 = _interopRequireDefault(_baseSlidesBalloonSlide);
	
	var _helpersMarkdownScript = __webpack_require__(9);
	
	var _helpersMarkdownScript2 = _interopRequireDefault(_helpersMarkdownScript);
	
	var _teamCreationMd = __webpack_require__(1724);
	
	var _teamCreationMd2 = _interopRequireDefault(_teamCreationMd);
	
	var _imagesCharactersIan_arms_foldedPng = __webpack_require__(892);
	
	var _imagesCharactersIan_arms_foldedPng2 = _interopRequireDefault(_imagesCharactersIan_arms_foldedPng);
	
	var _imagesCharactersSara_gigglePng = __webpack_require__(896);
	
	var _imagesCharactersSara_gigglePng2 = _interopRequireDefault(_imagesCharactersSara_gigglePng);
	
	var _imagesCharactersIan_pointing_upPng = __webpack_require__(435);
	
	var _imagesCharactersIan_pointing_upPng2 = _interopRequireDefault(_imagesCharactersIan_pointing_upPng);
	
	var md = new _helpersMarkdownScript2['default'](_teamCreationMd2['default']);
	
	function preloadGameShow() {
	  (0, _spectaclePpa.preloader)([_imagesCharactersIan_arms_foldedPng2['default'], _imagesCharactersSara_gigglePng2['default'], _imagesCharactersIan_pointing_upPng2['default']]);
	}
	
	function teamCreationSection(_ref) {
	  var regionData = _ref.regionData;
	
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'team-creation' },
	    (0, _baseSlidesVideoSlide2['default'])({
	      id: 'intro-team-names',
	      notes: md.getSubSectionAsHtml('Welcome Video', 'Notes', false, regionData),
	      youTubeId: md.getSectionMetadata('Welcome Video', 'YouTube', regionData)
	    }),
	    (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'get-into-teams',
	      characterSide: 'right',
	      characterImage: _imagesCharactersSara_gigglePng2['default'],
	      notes: md.getSubSectionAsHtml('Get Into Teams', 'Notes', false, regionData),
	      html: md.getSubSectionAsHtml('Get Into Teams', 'Content', false, regionData)
	    }),
	    _react2['default'].createElement(
	      _spectaclePpa.Slide,
	      {
	        id: 'assign',
	        bgColor: 'black',
	        notes: '<h2>Assign Team Names</h2>',
	        teamNames: true },
	      _react2['default'].createElement(
	        'div',
	        { className: 'ui-slide' },
	        _react2['default'].createElement(
	          _spectaclePpa.Heading,
	          { size: 1 },
	          'Name your teams!'
	        ),
	        _react2['default'].createElement(_componentsTeamNames2['default'], null)
	      )
	    ),
	    (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'scoring-intro',
	      characterSide: 'right',
	      characterImage: _imagesCharactersIan_arms_foldedPng2['default'],
	      notes: md.getSubSectionAsHtml('Scoring Intro', 'Notes', false, regionData),
	      html: md.getSubSectionAsHtml('Scoring Intro', 'Content', false, regionData)
	    }),
	    (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'scoreboard-intro',
	      characterSide: 'left',
	      characterImage: _imagesCharactersIan_pointing_upPng2['default'],
	      notes: md.getSubSectionAsHtml('Scoreboard Intro', 'Notes', false, regionData),
	      html: md.getSubSectionAsHtml('Scoreboard Intro', 'Content', false, regionData)
	    })
	  );
	}
	
	exports['default'] = teamCreationSection;
	/* Sara and Ian welcome to Academy */ /* Get into teams and come up with a cool name */ /* Enter team names */ /* Scoring intro */ /* Introduce scoreboard */

/***/ }),
/* 1072 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.preloadEnding = preloadEnding;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _baseSlidesBalloonSlide = __webpack_require__(68);
	
	var _baseSlidesBalloonSlide2 = _interopRequireDefault(_baseSlidesBalloonSlide);
	
	var _baseSlidesHeadingSlide = __webpack_require__(169);
	
	var _baseSlidesHeadingSlide2 = _interopRequireDefault(_baseSlidesHeadingSlide);
	
	var _imagesLogo_ppaPng = __webpack_require__(899);
	
	var _imagesLogo_ppaPng2 = _interopRequireDefault(_imagesLogo_ppaPng);
	
	var _imagesCharactersIan_hand_raisedPng = __webpack_require__(2407);
	
	var _imagesCharactersIan_hand_raisedPng2 = _interopRequireDefault(_imagesCharactersIan_hand_raisedPng);
	
	var _imagesCharactersIan_sara_sidePng = __webpack_require__(156);
	
	var _imagesCharactersIan_sara_sidePng2 = _interopRequireDefault(_imagesCharactersIan_sara_sidePng);
	
	var _helpersMarkdownScript = __webpack_require__(9);
	
	var _helpersMarkdownScript2 = _interopRequireDefault(_helpersMarkdownScript);
	
	var _endingMd = __webpack_require__(1734);
	
	var _endingMd2 = _interopRequireDefault(_endingMd);
	
	var md = new _helpersMarkdownScript2['default'](_endingMd2['default']);
	
	function preloadEnding() {
	  (0, _spectaclePpa.preloader)([_imagesCharactersIan_hand_raisedPng2['default'], _imagesCharactersIan_sara_sidePng2['default'], _imagesLogo_ppaPng2['default']]);
	}
	
	function endingSection(_ref) {
	  var regionData = _ref.regionData;
	
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'ending' },
	    (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'announce-winners',
	      characterSide: 'right',
	      characterImage: _imagesCharactersIan_hand_raisedPng2['default'],
	      html: md.getSubSectionAsHtml('Announce Winners', 'Content', false, regionData),
	      notes: md.getSubSectionAsHtml('Announce Winners', 'Notes', false, regionData)
	    }),
	    (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'members-of-eps',
	      characterSide: 'right',
	      characterImage: _imagesCharactersIan_sara_sidePng2['default'],
	      html: md.getSubSectionAsHtml('Superheroes', 'Content', false, regionData),
	      notes: md.getSubSectionAsHtml('Superheroes', 'Notes', false, regionData)
	    }),
	    (0, _baseSlidesHeadingSlide2['default'])({
	      id: 'completed',
	      beforeImage: _imagesLogo_ppaPng2['default'],
	      subHeading: 'All levels completed!!!',
	      notes: md.getSubSectionAsHtml('All Levels Completed', 'Notes', false, regionData),
	      bgColor: 'black'
	    })
	  );
	}
	
	exports['default'] = endingSection;
	/* Time to see who won! */ /* You're now all members of the Emergency Preparedness Squad */ /* You've completed all the levels */

/***/ }),
/* 1073 */
/***/ (function(module, exports) {

	/* eslint-disable object-shorthand */
	'use strict';
	
	var colors = {
	  primary: '#37bad5',
	  secondary: 'black',
	  tertiary: 'white',
	  level1: '#ffbc00',
	  level2: '#8f288c',
	  level3: '#26a7df',
	  level4: '#e80a89',
	  level5: '#f59122',
	  level6: '#37b34a',
	  gameshow: '#742CBF',
	  question: '#45B3EC',
	  answer: '#6FC36E'
	};
	
	var fonts = {
	  primary: 'BrandonTextWeb',
	  secondary: 'Orbitron',
	  tertiary: 'Ubuntu'
	};
	
	module.exports = {
	  colors: colors,
	  fonts: fonts,
	  global: {
	    body: {
	      background: 'transparent',
	      fontFamily: fonts.primary,
	      fontWeight: 'normal',
	      fontSize: '2em',
	      color: colors.primary,
	      overflow: 'hidden'
	    },
	    'html, body': {
	      // height: '100%'
	    },
	    '*': {
	      boxSizing: 'border-box'
	    },
	    input: {
	      color: 'black',
	      fontWeight: 'bold',
	      backgroundColor: 'white',
	      fontSize: '2.66em',
	      fontFamily: fonts.primary,
	      padding: '0.25em 0.25em 0.2em',
	      margin: '1% 1% 3%',
	      width: '98%'
	    },
	    label: {
	      color: 'white',
	      fontWeight: 'bold',
	      fontSize: '1.8em',
	      margin: '0.1em 0 0'
	    }
	  },
	  progress: {
	    bar: {
	      container: {
	        position: 'absolute',
	        height: '22px',
	        width: '100%',
	        bottom: 0,
	        left: 0,
	        transition: 'all 1s ease-in-out 0.2s',
	        zIndex: 1000
	      },
	      bar: {
	        height: '100%',
	        background: colors.primary,
	        transition: 'all 0.3s ease-out',
	        fontSize: '12px',
	        letterSpacing: '0.1em',
	        textTransform: 'uppercase',
	        padding: '4px',
	        textAlign: 'right'
	      }
	    },
	    number: {
	      container: {
	        position: 'absolute',
	        bottom: 10,
	        right: 10,
	        zIndex: 1000,
	        color: colors.tertiary
	      }
	    }
	  },
	  components: {
	    codePane: {
	      pre: {
	        margin: 'auto',
	        fontSize: '1em',
	        fontWeight: 'normal',
	        fontFamily: fonts.tertiary,
	        minWidth: '100%',
	        maxWidth: 800
	      },
	      code: {
	        textAlign: 'left',
	        padding: 20,
	        fontWeight: 'normal'
	      }
	    },
	    code: {
	      color: 'black',
	      fontSize: '2.66em',
	      fontFamily: fonts.tertiary,
	      margin: '0.25em auto',
	      backgroundColor: 'rgba(0,0,0,0.15)',
	      padding: '0 10px',
	      borderRadius: 3
	    },
	    heading: {},
	    link: {
	      textDecoration: 'none'
	    },
	    listItem: {
	      fontSize: '2.66em',
	      padding: '0 0 0.5em'
	    },
	    list: {
	      textAlign: 'center',
	      listStyle: 'none',
	      padding: '0.5em 0'
	    },
	    s: {
	      strikethrough: {}
	    },
	    text: {
	      color: 'black',
	      fontSize: '2.66em',
	      fontFamily: fonts.primary,
	      margin: '0.25em auto',
	      textShadow: '0 0 10px rgba(0,0,0,0.2)'
	    }
	  }
	};

/***/ }),
/* 1074 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = __webpack_require__(7)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	function htmlSlide(_ref) {
	  var id = _ref.id;
	  var notes = _ref.notes;
	  var heading = _ref.heading;
	  var bgColor = _ref.bgColor;
	  var subHeading = _ref.subHeading;
	  var html = _ref.html;
	  var slideClass = _ref.slideClass;
	
	  var slideContentClass = slideClass ? ' slide-' + slideClass : '';
	  var bgColorOpts = {};
	  if (bgColor) {
	    bgColorOpts.bgColor = bgColor;
	  }
	  return _react2['default'].createElement(
	    _spectaclePpa.Slide,
	    _extends({
	      id: id,
	      key: id
	    }, bgColorOpts, {
	      notes: notes,
	      textColor: 'white' }),
	    _react2['default'].createElement(
	      'div',
	      { className: 'slide-content' + slideContentClass },
	      _react2['default'].createElement(
	        'div',
	        {
	          className: 'text-formatted' },
	        !!heading && _react2['default'].createElement(
	          _spectaclePpa.Heading,
	          { size: 3 },
	          heading
	        ),
	        !!subHeading && _react2['default'].createElement(
	          _spectaclePpa.Heading,
	          { size: 5 },
	          subHeading
	        ),
	        _react2['default'].createElement('div', {
	          dangerouslySetInnerHTML: { __html: html } })
	      )
	    )
	  );
	}
	
	exports['default'] = htmlSlide;
	module.exports = exports['default'];

/***/ }),
/* 1075 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = {
	  width: 1000,
	  height: 700,
	  margin: 40,
	  theme: __webpack_require__(1088),
	  print: __webpack_require__(53),
	  html: __webpack_require__(52)
	};

/***/ }),
/* 1076 */
/***/ (function(module, exports, __webpack_require__) {

	/* eslint no-console: 0 */
	'use strict';
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _helpersMarkdownScript = __webpack_require__(9);
	
	var _helpersMarkdownScript2 = _interopRequireDefault(_helpersMarkdownScript);
	
	var _helpersI18n = __webpack_require__(14);
	
	var _extensionActivitiesExtensionActivitiesMd = __webpack_require__(1736);
	
	var _extensionActivitiesExtensionActivitiesMd2 = _interopRequireDefault(_extensionActivitiesExtensionActivitiesMd);
	
	var _extensionActivitiesExtensionActivitiesFr_CAMd = __webpack_require__(1735);
	
	var _extensionActivitiesExtensionActivitiesFr_CAMd2 = _interopRequireDefault(_extensionActivitiesExtensionActivitiesFr_CAMd);
	
	var _programPrepProgramPrepMd = __webpack_require__(1743);
	
	var _programPrepProgramPrepMd2 = _interopRequireDefault(_programPrepProgramPrepMd);
	
	var _programPrepProgramPrepFr_CAMd = __webpack_require__(1742);
	
	var _programPrepProgramPrepFr_CAMd2 = _interopRequireDefault(_programPrepProgramPrepFr_CAMd);
	
	var _sections00_prepLevel1_prepMd = __webpack_require__(1745);
	
	var _sections00_prepLevel1_prepMd2 = _interopRequireDefault(_sections00_prepLevel1_prepMd);
	
	var _sections00_prepLevel1_prepFr_CAMd = __webpack_require__(1744);
	
	var _sections00_prepLevel1_prepFr_CAMd2 = _interopRequireDefault(_sections00_prepLevel1_prepFr_CAMd);
	
	var _sections00_prepLevel2_prepMd = __webpack_require__(1747);
	
	var _sections00_prepLevel2_prepMd2 = _interopRequireDefault(_sections00_prepLevel2_prepMd);
	
	var _sections00_prepLevel2_prepFr_CAMd = __webpack_require__(1746);
	
	var _sections00_prepLevel2_prepFr_CAMd2 = _interopRequireDefault(_sections00_prepLevel2_prepFr_CAMd);
	
	var _sections00_prepLevel3_prepMd = __webpack_require__(1749);
	
	var _sections00_prepLevel3_prepMd2 = _interopRequireDefault(_sections00_prepLevel3_prepMd);
	
	var _sections00_prepLevel3_prepFr_CAMd = __webpack_require__(1748);
	
	var _sections00_prepLevel3_prepFr_CAMd2 = _interopRequireDefault(_sections00_prepLevel3_prepFr_CAMd);
	
	var _sections00_prepLevel4_prepMd = __webpack_require__(1751);
	
	var _sections00_prepLevel4_prepMd2 = _interopRequireDefault(_sections00_prepLevel4_prepMd);
	
	var _sections00_prepLevel4_prepFr_CAMd = __webpack_require__(1750);
	
	var _sections00_prepLevel4_prepFr_CAMd2 = _interopRequireDefault(_sections00_prepLevel4_prepFr_CAMd);
	
	var _sections00_prepLevel5_prepMd = __webpack_require__(1753);
	
	var _sections00_prepLevel5_prepMd2 = _interopRequireDefault(_sections00_prepLevel5_prepMd);
	
	var _sections00_prepLevel5_prepFr_CAMd = __webpack_require__(1752);
	
	var _sections00_prepLevel5_prepFr_CAMd2 = _interopRequireDefault(_sections00_prepLevel5_prepFr_CAMd);
	
	var _sections00_prepLevel6_prepMd = __webpack_require__(1755);
	
	var _sections00_prepLevel6_prepMd2 = _interopRequireDefault(_sections00_prepLevel6_prepMd);
	
	var _sections00_prepLevel6_prepFr_CAMd = __webpack_require__(1754);
	
	var _sections00_prepLevel6_prepFr_CAMd2 = _interopRequireDefault(_sections00_prepLevel6_prepFr_CAMd);
	
	var _funMd = __webpack_require__(1738);
	
	var _funMd2 = _interopRequireDefault(_funMd);
	
	var _funFr_CAMd = __webpack_require__(1737);
	
	var _funFr_CAMd2 = _interopRequireDefault(_funFr_CAMd);
	
	var _imagesKeepCoolPng = __webpack_require__(2449);
	
	var _imagesKeepCoolPng2 = _interopRequireDefault(_imagesKeepCoolPng);
	
	var _imagesKeepCoolFr_CAPng = __webpack_require__(2448);
	
	var _imagesKeepCoolFr_CAPng2 = _interopRequireDefault(_imagesKeepCoolFr_CAPng);
	
	var _imagesKeepCoolTrialPng = __webpack_require__(2455);
	
	var _imagesKeepCoolTrialPng2 = _interopRequireDefault(_imagesKeepCoolTrialPng);
	
	var _imagesKeepCoolTrialFr_CAPng = __webpack_require__(2454);
	
	var _imagesKeepCoolTrialFr_CAPng2 = _interopRequireDefault(_imagesKeepCoolTrialFr_CAPng);
	
	var _imagesKeepCoolExpiredPng = __webpack_require__(2451);
	
	var _imagesKeepCoolExpiredPng2 = _interopRequireDefault(_imagesKeepCoolExpiredPng);
	
	var _imagesKeepCoolExpiredFr_CAPng = __webpack_require__(2450);
	
	var _imagesKeepCoolExpiredFr_CAPng2 = _interopRequireDefault(_imagesKeepCoolExpiredFr_CAPng);
	
	var _config = __webpack_require__(1075);
	
	var _config2 = _interopRequireDefault(_config);
	
	// Preload image functions
	
	var _sections20_gameShowGameShowSection = __webpack_require__(125);
	
	__webpack_require__(2192);
	
	var _md = __webpack_require__(101);
	
	var _md2 = _interopRequireDefault(_md);
	
	var level1PrepMd = (0, _helpersI18n.i18nData)({
	  en: new _helpersMarkdownScript2['default'](_sections00_prepLevel1_prepMd2['default']),
	  fr_CA: new _helpersMarkdownScript2['default'](_sections00_prepLevel1_prepFr_CAMd2['default'])
	});
	var level2PrepMd = (0, _helpersI18n.i18nData)({
	  en: new _helpersMarkdownScript2['default'](_sections00_prepLevel2_prepMd2['default']),
	  fr_CA: new _helpersMarkdownScript2['default'](_sections00_prepLevel2_prepFr_CAMd2['default'])
	});
	var level3PrepMd = (0, _helpersI18n.i18nData)({
	  en: new _helpersMarkdownScript2['default'](_sections00_prepLevel3_prepMd2['default']),
	  fr_CA: new _helpersMarkdownScript2['default'](_sections00_prepLevel3_prepFr_CAMd2['default'])
	});
	var level4PrepMd = (0, _helpersI18n.i18nData)({
	  en: new _helpersMarkdownScript2['default'](_sections00_prepLevel4_prepMd2['default']),
	  fr_CA: new _helpersMarkdownScript2['default'](_sections00_prepLevel4_prepFr_CAMd2['default'])
	});
	var level5PrepMd = (0, _helpersI18n.i18nData)({
	  en: new _helpersMarkdownScript2['default'](_sections00_prepLevel5_prepMd2['default']),
	  fr_CA: new _helpersMarkdownScript2['default'](_sections00_prepLevel5_prepFr_CAMd2['default'])
	});
	var level6PrepMd = (0, _helpersI18n.i18nData)({
	  en: new _helpersMarkdownScript2['default'](_sections00_prepLevel6_prepMd2['default']),
	  fr_CA: new _helpersMarkdownScript2['default'](_sections00_prepLevel6_prepFr_CAMd2['default'])
	});
	var extensionActivitiesMd = (0, _helpersI18n.i18nData)({
	  en: new _helpersMarkdownScript2['default'](_extensionActivitiesExtensionActivitiesMd2['default']),
	  fr_CA: new _helpersMarkdownScript2['default'](_extensionActivitiesExtensionActivitiesFr_CAMd2['default'])
	});
	var programPrepMd = (0, _helpersI18n.i18nData)({
	  en: new _helpersMarkdownScript2['default'](_programPrepProgramPrepMd2['default']),
	  fr_CA: new _helpersMarkdownScript2['default'](_programPrepProgramPrepFr_CAMd2['default'])
	});
	var funMd = (0, _helpersI18n.i18nData)({
	  en: new _helpersMarkdownScript2['default'](_funMd2['default']),
	  fr_CA: new _helpersMarkdownScript2['default'](_funFr_CAMd2['default'])
	});
	var imageThumb = (0, _helpersI18n.i18nData)({
	  en: _imagesKeepCoolPng2['default'],
	  fr_CA: _imagesKeepCoolFr_CAPng2['default']
	});
	var trialImageThumb = (0, _helpersI18n.i18nData)({
	  en: _imagesKeepCoolTrialPng2['default'],
	  fr_CA: _imagesKeepCoolTrialFr_CAPng2['default']
	});
	var expiredImageThumb = (0, _helpersI18n.i18nData)({
	  en: _imagesKeepCoolExpiredPng2['default'],
	  fr_CA: _imagesKeepCoolExpiredFr_CAPng2['default']
	});
	
	(0, _helpersI18n.i18nExtend)('fr_CA', {
	  "Keep Cool": "Restez Cool",
	  "The Climate Conundrum": "L'énigme du climat",
	  "Operation Darkroom": "Opération Interrupteur",
	  "Operation Shower Power": "Opération Douche chrono",
	  "Operation Keep Car Cool": "Opération Conduite écolo",
	  "Operation Go Car Free": "Opération Coupez les moteurs",
	  "Keep Cool Celebration": "Célébration Restez cool"
	});
	
	var levels = {
	  prep: {
	    deck: __webpack_require__(1084)
	  },
	  1: {
	    thumbnail: __webpack_require__(903),
	    overviewThumbnail: __webpack_require__(2456),
	    deck: __webpack_require__(1077),
	    prep: level1PrepMd,
	    levelName: 'The Climate Conundrum'
	  },
	  2: {
	    thumbnail: __webpack_require__(441),
	    overviewThumbnail: __webpack_require__(2457),
	    deck: __webpack_require__(1078),
	    prep: level2PrepMd,
	    levelName: 'Operation Darkroom'
	  },
	  3: {
	    thumbnail: __webpack_require__(442),
	    overviewThumbnail: __webpack_require__(2458),
	    deck: __webpack_require__(1079),
	    prep: level3PrepMd,
	    levelName: 'Operation Shower Power'
	  },
	  4: {
	    thumbnail: __webpack_require__(443),
	    overviewThumbnail: __webpack_require__(2459),
	    deck: __webpack_require__(1080),
	    prep: level4PrepMd,
	    levelName: 'Operation Keep Car Cool'
	  },
	  5: {
	    thumbnail: __webpack_require__(444),
	    overviewThumbnail: __webpack_require__(2460),
	    deck: __webpack_require__(1081),
	    prep: level5PrepMd,
	    levelName: 'Operation Go Car Free'
	  },
	  6: {
	    thumbnail: __webpack_require__(904),
	    overviewThumbnail: __webpack_require__(2461),
	    deck: __webpack_require__(1082),
	    prep: level6PrepMd,
	    levelName: 'Keep Cool'
	  },
	  completed: {
	    deck: __webpack_require__(1083)
	  }
	};
	
	var program = {
	  id: 'keepCool',
	  title: (0, _helpersI18n.i18nProvider)(function (lang) {
	    return _md2['default'][lang].getSectionAsString('Title - Short');
	  }),
	  longTitle: (0, _helpersI18n.i18nProvider)(function (lang) {
	    return _md2['default'][lang].getSectionAsString('Title - Long');
	  }),
	  thumbnailImage: imageThumb,
	  trialImageThumb: trialImageThumb,
	  expiredImageThumb: expiredImageThumb,
	  longDescription: (0, _helpersI18n.i18nProvider)(function (lang) {
	    return _md2['default'][lang].getSectionAsString('Description - Long');
	  }),
	  levelsDescription: (0, _helpersI18n.i18nProvider)(function (lang) {
	    return _md2['default'][lang].getSectionAsString('Description - Levels');
	  }),
	  shortDescription: (0, _helpersI18n.i18nProvider)(function (lang) {
	    return _md2['default'][lang].getSectionAsString('Description - Short');
	  }),
	  levels: levels,
	  extensionActivitiesMd: extensionActivitiesMd,
	  programPrepMd: programPrepMd,
	  funMd: funMd,
	  preload: function preload(_ref) {
	    var level = _ref.level;
	
	    console.log('Preloading assets for Level ' + level);
	
	    (0, _sections20_gameShowGameShowSection.preloadGameShow)();
	  },
	  config: _config2['default'],
	  languages: ['en', 'fr_CA']
	};
	
	exports['default'] = program;
	module.exports = exports['default'];

/***/ }),
/* 1077 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(__filename) {'use strict';
	
	var _get = __webpack_require__(8)['default'];
	
	var _inherits = __webpack_require__(5)['default'];
	
	var _createClass = __webpack_require__(6)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _helpersI18n = __webpack_require__(14);
	
	var _sections01_startStartSection = __webpack_require__(123);
	
	var _sections01_startStartSection2 = _interopRequireDefault(_sections01_startStartSection);
	
	var _sections03_songSongSection = __webpack_require__(124);
	
	var _sections03_songSongSection2 = _interopRequireDefault(_sections03_songSongSection);
	
	var _sections10_teamCreationTeamCreationSection = __webpack_require__(1086);
	
	var _sections10_teamCreationTeamCreationSection2 = _interopRequireDefault(_sections10_teamCreationTeamCreationSection);
	
	var _sections20_gameShowGameShowSection = __webpack_require__(125);
	
	var _sections20_gameShowGameShowSection2 = _interopRequireDefault(_sections20_gameShowGameShowSection);
	
	var _sections25_mmeMmeSection = __webpack_require__(126);
	
	var _sections25_mmeMmeSection2 = _interopRequireDefault(_sections25_mmeMmeSection);
	
	var _sections30_classActivityClassActivitySection = __webpack_require__(127);
	
	var _sections30_classActivityClassActivitySection2 = _interopRequireDefault(_sections30_classActivityClassActivitySection);
	
	var _sections90_finishFinishSection = __webpack_require__(128);
	
	var _sections90_finishFinishSection2 = _interopRequireDefault(_sections90_finishFinishSection);
	
	var _md = __webpack_require__(101);
	
	var _md2 = _interopRequireDefault(_md);
	
	var level = Number(__filename.replace(/^.*level/, '').replace('.jsx', ''));
	var _title = (0, _helpersI18n.i18nProvider)(function (lang) {
	  return _md2['default'][lang].getSectionMetadata('Level ' + level, 'Title');
	});
	
	var _default = (function (_Component) {
	  _inherits(_default, _Component);
	
	  function _default() {
	    _classCallCheck(this, _default);
	
	    _get(Object.getPrototypeOf(_default.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(_default, [{
	    key: 'render',
	    value: function render() {
	      var _context = this.context;
	      var regionData = _context.regionData;
	      var i18n = _context.i18n;
	
	      var title = i18n(_title);
	      return _react2['default'].createElement(
	        _spectaclePpa.Deck,
	        { transition: ['slide'],
	          transitionDuration: 800,
	          progress: 'bar' },
	        (0, _sections01_startStartSection2['default'])({ level: level, title: title, regionData: regionData, i18n: i18n }),
	        (0, _sections03_songSongSection2['default'])({ level: level, regionData: regionData, i18n: i18n }),
	        (0, _sections10_teamCreationTeamCreationSection2['default'])({ regionData: regionData, i18n: i18n }),
	        (0, _sections20_gameShowGameShowSection2['default'])({ level: level, regionData: regionData, i18n: i18n }),
	        (0, _sections25_mmeMmeSection2['default'])({ level: level, regionData: regionData, i18n: i18n }),
	        (0, _sections30_classActivityClassActivitySection2['default'])({ level: level, regionData: regionData, i18n: i18n }),
	        (0, _sections90_finishFinishSection2['default'])({ level: level, regionData: regionData, i18n: i18n })
	      );
	    }
	  }], [{
	    key: 'contextTypes',
	    value: {
	      regionData: _react.PropTypes.object.isRequired,
	      i18n: _react.PropTypes.func.isRequired
	    },
	    enumerable: true
	  }, {
	    key: 'metadata',
	    value: {
	      title: _title
	    },
	    enumerable: true
	  }]);

	  return _default;
	})(_react.Component);

	exports['default'] = _default;
	module.exports = exports['default'];
	/* Start */ /* Theme Song */ /* Team Creation and Introduction */ /* Game Show */ /* Messages from Mother Earth */ /* Class Activity: Draw a Season */ /* Finish */
	/* WEBPACK VAR INJECTION */}.call(exports, "programs/keepCool/level1.jsx"))

/***/ }),
/* 1078 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(__filename) {'use strict';
	
	var _get = __webpack_require__(8)['default'];
	
	var _inherits = __webpack_require__(5)['default'];
	
	var _createClass = __webpack_require__(6)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _helpersI18n = __webpack_require__(14);
	
	var _sections01_startStartSection = __webpack_require__(123);
	
	var _sections01_startStartSection2 = _interopRequireDefault(_sections01_startStartSection);
	
	var _sections03_songSongSection = __webpack_require__(124);
	
	var _sections03_songSongSection2 = _interopRequireDefault(_sections03_songSongSection);
	
	var _sections20_gameShowGameShowSection = __webpack_require__(125);
	
	var _sections20_gameShowGameShowSection2 = _interopRequireDefault(_sections20_gameShowGameShowSection);
	
	var _sections25_mmeMmeSection = __webpack_require__(126);
	
	var _sections25_mmeMmeSection2 = _interopRequireDefault(_sections25_mmeMmeSection);
	
	var _sections30_classActivityClassActivitySection = __webpack_require__(127);
	
	var _sections30_classActivityClassActivitySection2 = _interopRequireDefault(_sections30_classActivityClassActivitySection);
	
	var _sections70_missionAssignmentMissionAssignmentSection = __webpack_require__(227);
	
	var _sections70_missionAssignmentMissionAssignmentSection2 = _interopRequireDefault(_sections70_missionAssignmentMissionAssignmentSection);
	
	var _sections90_finishFinishSection = __webpack_require__(128);
	
	var _sections90_finishFinishSection2 = _interopRequireDefault(_sections90_finishFinishSection);
	
	var _md = __webpack_require__(101);
	
	var _md2 = _interopRequireDefault(_md);
	
	var level = Number(__filename.replace(/^.*level/, '').replace('.jsx', ''));
	var _title = (0, _helpersI18n.i18nProvider)(function (lang) {
	  return _md2['default'][lang].getSectionMetadata('Level ' + level, 'Title');
	});
	
	var _default = (function (_Component) {
	  _inherits(_default, _Component);
	
	  function _default() {
	    _classCallCheck(this, _default);
	
	    _get(Object.getPrototypeOf(_default.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(_default, [{
	    key: 'render',
	    value: function render() {
	      var _context = this.context;
	      var regionData = _context.regionData;
	      var i18n = _context.i18n;
	
	      var title = i18n(_title);
	      return _react2['default'].createElement(
	        _spectaclePpa.Deck,
	        { transition: ['slide'],
	          transitionDuration: 800,
	          progress: 'bar' },
	        (0, _sections01_startStartSection2['default'])({ level: level, title: title, regionData: regionData, i18n: i18n }),
	        (0, _sections03_songSongSection2['default'])({ level: level, regionData: regionData, i18n: i18n }),
	        (0, _sections20_gameShowGameShowSection2['default'])({ level: level, regionData: regionData, i18n: i18n }),
	        (0, _sections25_mmeMmeSection2['default'])({ level: level, regionData: regionData, i18n: i18n }),
	        (0, _sections30_classActivityClassActivitySection2['default'])({ level: level, subActivity: 'a', regionData: regionData, i18n: i18n }),
	        (0, _sections30_classActivityClassActivitySection2['default'])({ level: level, subActivity: 'b', regionData: regionData, i18n: i18n }),
	        (0, _sections70_missionAssignmentMissionAssignmentSection2['default'])({ level: level, title: title, regionData: regionData, i18n: i18n }),
	        (0, _sections90_finishFinishSection2['default'])({ level: level, regionData: regionData, i18n: i18n })
	      );
	    }
	  }], [{
	    key: 'contextTypes',
	    value: {
	      regionData: _react.PropTypes.object.isRequired,
	      i18n: _react.PropTypes.func.isRequired
	    },
	    enumerable: true
	  }, {
	    key: 'metadata',
	    value: {
	      title: _title
	    },
	    enumerable: true
	  }]);

	  return _default;
	})(_react.Component);

	exports['default'] = _default;
	module.exports = exports['default'];
	/* Start */ /* Theme Song */ /* Game Show */ /* Messages from Mother Earth */ /* Class Activity: Draw how energy is produced */ /* Class Activity: Write Energy Saving Rap */ /* Mission Assignment */ /* Finish */
	/* WEBPACK VAR INJECTION */}.call(exports, "programs/keepCool/level2.jsx"))

/***/ }),
/* 1079 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(__filename) {'use strict';
	
	var _get = __webpack_require__(8)['default'];
	
	var _inherits = __webpack_require__(5)['default'];
	
	var _createClass = __webpack_require__(6)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _helpersI18n = __webpack_require__(14);
	
	var _sections01_startStartSection = __webpack_require__(123);
	
	var _sections01_startStartSection2 = _interopRequireDefault(_sections01_startStartSection);
	
	var _sections03_songSongSection = __webpack_require__(124);
	
	var _sections03_songSongSection2 = _interopRequireDefault(_sections03_songSongSection);
	
	var _sections11_missionReportMissionReportSection = __webpack_require__(226);
	
	var _sections11_missionReportMissionReportSection2 = _interopRequireDefault(_sections11_missionReportMissionReportSection);
	
	var _sections20_gameShowGameShowSection = __webpack_require__(125);
	
	var _sections20_gameShowGameShowSection2 = _interopRequireDefault(_sections20_gameShowGameShowSection);
	
	var _sections25_mmeMmeSection = __webpack_require__(126);
	
	var _sections25_mmeMmeSection2 = _interopRequireDefault(_sections25_mmeMmeSection);
	
	var _sections30_classActivityClassActivitySection = __webpack_require__(127);
	
	var _sections30_classActivityClassActivitySection2 = _interopRequireDefault(_sections30_classActivityClassActivitySection);
	
	var _sections70_missionAssignmentMissionAssignmentSection = __webpack_require__(227);
	
	var _sections70_missionAssignmentMissionAssignmentSection2 = _interopRequireDefault(_sections70_missionAssignmentMissionAssignmentSection);
	
	var _sections90_finishFinishSection = __webpack_require__(128);
	
	var _sections90_finishFinishSection2 = _interopRequireDefault(_sections90_finishFinishSection);
	
	var _md = __webpack_require__(101);
	
	var _md2 = _interopRequireDefault(_md);
	
	var level = Number(__filename.replace(/^.*level/, '').replace('.jsx', ''));
	var _title = (0, _helpersI18n.i18nProvider)(function (lang) {
	  return _md2['default'][lang].getSectionMetadata('Level ' + level, 'Title');
	});
	
	var _default = (function (_Component) {
	  _inherits(_default, _Component);
	
	  function _default() {
	    _classCallCheck(this, _default);
	
	    _get(Object.getPrototypeOf(_default.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(_default, [{
	    key: 'render',
	    value: function render() {
	      var _context = this.context;
	      var regionData = _context.regionData;
	      var i18n = _context.i18n;
	
	      var title = i18n(_title);
	      return _react2['default'].createElement(
	        _spectaclePpa.Deck,
	        { transition: ['slide'],
	          transitionDuration: 800,
	          progress: 'bar' },
	        (0, _sections01_startStartSection2['default'])({ level: level, title: title, regionData: regionData, i18n: i18n }),
	        (0, _sections03_songSongSection2['default'])({ level: level, regionData: regionData, i18n: i18n }),
	        (0, _sections11_missionReportMissionReportSection2['default'])({ level: level, regionData: regionData, i18n: i18n }),
	        (0, _sections20_gameShowGameShowSection2['default'])({ level: level, regionData: regionData, i18n: i18n }),
	        (0, _sections25_mmeMmeSection2['default'])({ level: level, regionData: regionData, i18n: i18n }),
	        (0, _sections30_classActivityClassActivitySection2['default'])({ level: level, subActivity: 'a', regionData: regionData, i18n: i18n }),
	        (0, _sections30_classActivityClassActivitySection2['default'])({ level: level, subActivity: 'b', regionData: regionData, i18n: i18n }),
	        (0, _sections70_missionAssignmentMissionAssignmentSection2['default'])({ level: level, title: title, regionData: regionData, i18n: i18n }),
	        (0, _sections90_finishFinishSection2['default'])({ level: level, regionData: regionData, i18n: i18n })
	      );
	    }
	  }], [{
	    key: 'contextTypes',
	    value: {
	      regionData: _react.PropTypes.object.isRequired,
	      i18n: _react.PropTypes.func.isRequired
	    },
	    enumerable: true
	  }, {
	    key: 'metadata',
	    value: {
	      title: _title
	    },
	    enumerable: true
	  }]);

	  return _default;
	})(_react.Component);

	exports['default'] = _default;
	module.exports = exports['default'];
	/* Start */ /* Theme Song */ /* Mission Report */ /* Game Show */ /* Messages from Mother Earth */ /* Class Activity: Model Hot Water Tank */ /* Class Activity: Shower Power Poster */ /* Mission Assignment */ /* Finish */
	/* WEBPACK VAR INJECTION */}.call(exports, "programs/keepCool/level3.jsx"))

/***/ }),
/* 1080 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(__filename) {'use strict';
	
	var _get = __webpack_require__(8)['default'];
	
	var _inherits = __webpack_require__(5)['default'];
	
	var _createClass = __webpack_require__(6)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _helpersI18n = __webpack_require__(14);
	
	var _sections01_startStartSection = __webpack_require__(123);
	
	var _sections01_startStartSection2 = _interopRequireDefault(_sections01_startStartSection);
	
	var _sections03_songSongSection = __webpack_require__(124);
	
	var _sections03_songSongSection2 = _interopRequireDefault(_sections03_songSongSection);
	
	var _sections11_missionReportMissionReportSection = __webpack_require__(226);
	
	var _sections11_missionReportMissionReportSection2 = _interopRequireDefault(_sections11_missionReportMissionReportSection);
	
	var _sections20_gameShowGameShowSection = __webpack_require__(125);
	
	var _sections20_gameShowGameShowSection2 = _interopRequireDefault(_sections20_gameShowGameShowSection);
	
	var _sections25_mmeMmeSection = __webpack_require__(126);
	
	var _sections25_mmeMmeSection2 = _interopRequireDefault(_sections25_mmeMmeSection);
	
	var _sections30_classActivityClassActivitySection = __webpack_require__(127);
	
	var _sections30_classActivityClassActivitySection2 = _interopRequireDefault(_sections30_classActivityClassActivitySection);
	
	var _sections70_missionAssignmentMissionAssignmentSection = __webpack_require__(227);
	
	var _sections70_missionAssignmentMissionAssignmentSection2 = _interopRequireDefault(_sections70_missionAssignmentMissionAssignmentSection);
	
	var _sections90_finishFinishSection = __webpack_require__(128);
	
	var _sections90_finishFinishSection2 = _interopRequireDefault(_sections90_finishFinishSection);
	
	var _md = __webpack_require__(101);
	
	var _md2 = _interopRequireDefault(_md);
	
	var level = Number(__filename.replace(/^.*level/, '').replace('.jsx', ''));
	var _title = (0, _helpersI18n.i18nProvider)(function (lang) {
	  return _md2['default'][lang].getSectionMetadata('Level ' + level, 'Title');
	});
	
	var _default = (function (_Component) {
	  _inherits(_default, _Component);
	
	  function _default() {
	    _classCallCheck(this, _default);
	
	    _get(Object.getPrototypeOf(_default.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(_default, [{
	    key: 'render',
	    value: function render() {
	      var _context = this.context;
	      var regionData = _context.regionData;
	      var i18n = _context.i18n;
	
	      var title = i18n(_title);
	      return _react2['default'].createElement(
	        _spectaclePpa.Deck,
	        { transition: ['slide'],
	          transitionDuration: 800,
	          progress: 'bar' },
	        (0, _sections01_startStartSection2['default'])({ level: level, title: title, regionData: regionData, i18n: i18n }),
	        (0, _sections03_songSongSection2['default'])({ level: level, regionData: regionData, i18n: i18n }),
	        (0, _sections11_missionReportMissionReportSection2['default'])({ level: level, regionData: regionData, i18n: i18n }),
	        (0, _sections20_gameShowGameShowSection2['default'])({ level: level, regionData: regionData, i18n: i18n }),
	        (0, _sections25_mmeMmeSection2['default'])({ level: level, regionData: regionData, i18n: i18n }),
	        (0, _sections30_classActivityClassActivitySection2['default'])({ level: level, subActivity: 'a', regionData: regionData, i18n: i18n }),
	        (0, _sections30_classActivityClassActivitySection2['default'])({ level: level, subActivity: 'b', regionData: regionData, i18n: i18n }),
	        (0, _sections70_missionAssignmentMissionAssignmentSection2['default'])({ level: level, title: title, regionData: regionData, i18n: i18n }),
	        (0, _sections90_finishFinishSection2['default'])({ level: level, regionData: regionData, i18n: i18n })
	      );
	    }
	  }], [{
	    key: 'contextTypes',
	    value: {
	      regionData: _react.PropTypes.object.isRequired,
	      i18n: _react.PropTypes.func.isRequired
	    },
	    enumerable: true
	  }, {
	    key: 'metadata',
	    value: {
	      title: _title
	    },
	    enumerable: true
	  }]);

	  return _default;
	})(_react.Component);

	exports['default'] = _default;
	module.exports = exports['default'];
	/* Start */ /* Theme Song */ /* Mission Report */ /* Game Show */ /* Messages from Mother Earth */ /* Class Activity: Draw Transportation Options */ /* Class Activity: Rate Transportation Options */ /* Mission Assignment */ /* Finish */
	/* WEBPACK VAR INJECTION */}.call(exports, "programs/keepCool/level4.jsx"))

/***/ }),
/* 1081 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(__filename) {'use strict';
	
	var _get = __webpack_require__(8)['default'];
	
	var _inherits = __webpack_require__(5)['default'];
	
	var _createClass = __webpack_require__(6)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _helpersI18n = __webpack_require__(14);
	
	var _sections01_startStartSection = __webpack_require__(123);
	
	var _sections01_startStartSection2 = _interopRequireDefault(_sections01_startStartSection);
	
	var _sections03_songSongSection = __webpack_require__(124);
	
	var _sections03_songSongSection2 = _interopRequireDefault(_sections03_songSongSection);
	
	var _sections11_missionReportMissionReportSection = __webpack_require__(226);
	
	var _sections11_missionReportMissionReportSection2 = _interopRequireDefault(_sections11_missionReportMissionReportSection);
	
	var _sections20_gameShowGameShowSection = __webpack_require__(125);
	
	var _sections20_gameShowGameShowSection2 = _interopRequireDefault(_sections20_gameShowGameShowSection);
	
	var _sections25_mmeMmeSection = __webpack_require__(126);
	
	var _sections25_mmeMmeSection2 = _interopRequireDefault(_sections25_mmeMmeSection);
	
	var _sections30_classActivityClassActivitySection = __webpack_require__(127);
	
	var _sections30_classActivityClassActivitySection2 = _interopRequireDefault(_sections30_classActivityClassActivitySection);
	
	var _sections70_missionAssignmentMissionAssignmentSection = __webpack_require__(227);
	
	var _sections70_missionAssignmentMissionAssignmentSection2 = _interopRequireDefault(_sections70_missionAssignmentMissionAssignmentSection);
	
	var _sections90_finishFinishSection = __webpack_require__(128);
	
	var _sections90_finishFinishSection2 = _interopRequireDefault(_sections90_finishFinishSection);
	
	var _md = __webpack_require__(101);
	
	var _md2 = _interopRequireDefault(_md);
	
	var level = Number(__filename.replace(/^.*level/, '').replace('.jsx', ''));
	var _title = (0, _helpersI18n.i18nProvider)(function (lang) {
	  return _md2['default'][lang].getSectionMetadata('Level ' + level, 'Title');
	});
	
	var _default = (function (_Component) {
	  _inherits(_default, _Component);
	
	  function _default() {
	    _classCallCheck(this, _default);
	
	    _get(Object.getPrototypeOf(_default.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(_default, [{
	    key: 'render',
	    value: function render() {
	      var _context = this.context;
	      var regionData = _context.regionData;
	      var i18n = _context.i18n;
	
	      var title = i18n(_title);
	      return _react2['default'].createElement(
	        _spectaclePpa.Deck,
	        { transition: ['slide'],
	          transitionDuration: 800,
	          progress: 'bar' },
	        (0, _sections01_startStartSection2['default'])({ level: level, title: title, regionData: regionData, i18n: i18n }),
	        (0, _sections03_songSongSection2['default'])({ level: level, regionData: regionData, i18n: i18n }),
	        (0, _sections11_missionReportMissionReportSection2['default'])({ level: level, regionData: regionData, i18n: i18n }),
	        (0, _sections20_gameShowGameShowSection2['default'])({ level: level, regionData: regionData, i18n: i18n }),
	        (0, _sections25_mmeMmeSection2['default'])({ level: level, regionData: regionData, i18n: i18n }),
	        (0, _sections30_classActivityClassActivitySection2['default'])({ level: level, subActivity: 'a', regionData: regionData, i18n: i18n }),
	        (0, _sections30_classActivityClassActivitySection2['default'])({ level: level, subActivity: 'b', regionData: regionData, i18n: i18n }),
	        (0, _sections70_missionAssignmentMissionAssignmentSection2['default'])({ level: level, title: title, regionData: regionData, i18n: i18n }),
	        (0, _sections90_finishFinishSection2['default'])({ level: level, regionData: regionData, i18n: i18n })
	      );
	    }
	  }], [{
	    key: 'contextTypes',
	    value: {
	      regionData: _react.PropTypes.object.isRequired,
	      i18n: _react.PropTypes.func.isRequired
	    },
	    enumerable: true
	  }, {
	    key: 'metadata',
	    value: {
	      title: _title
	    },
	    enumerable: true
	  }]);

	  return _default;
	})(_react.Component);

	exports['default'] = _default;
	module.exports = exports['default'];
	/* Start */ /* Theme Song */ /* Mission Report */ /* Game Show */ /* Messages from Mother Earth */ /* Class Activity: Team Brainstorm */ /* Class Activity: Role Play */ /* Mission Assignment */ /* Finish */
	/* WEBPACK VAR INJECTION */}.call(exports, "programs/keepCool/level5.jsx"))

/***/ }),
/* 1082 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(__filename) {'use strict';
	
	var _get = __webpack_require__(8)['default'];
	
	var _inherits = __webpack_require__(5)['default'];
	
	var _createClass = __webpack_require__(6)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _helpersI18n = __webpack_require__(14);
	
	var _sections01_startStartSection = __webpack_require__(123);
	
	var _sections01_startStartSection2 = _interopRequireDefault(_sections01_startStartSection);
	
	var _sections03_songSongSection = __webpack_require__(124);
	
	var _sections03_songSongSection2 = _interopRequireDefault(_sections03_songSongSection);
	
	var _sections11_missionReportMissionReportSection = __webpack_require__(226);
	
	var _sections11_missionReportMissionReportSection2 = _interopRequireDefault(_sections11_missionReportMissionReportSection);
	
	var _sections25_mmeMmeSection = __webpack_require__(126);
	
	var _sections25_mmeMmeSection2 = _interopRequireDefault(_sections25_mmeMmeSection);
	
	var _sections30_classActivityClassActivitySection = __webpack_require__(127);
	
	var _sections30_classActivityClassActivitySection2 = _interopRequireDefault(_sections30_classActivityClassActivitySection);
	
	var _sections95_endingEndingSection = __webpack_require__(1087);
	
	var _sections95_endingEndingSection2 = _interopRequireDefault(_sections95_endingEndingSection);
	
	var _sections90_finishFinishSection = __webpack_require__(128);
	
	var _sections90_finishFinishSection2 = _interopRequireDefault(_sections90_finishFinishSection);
	
	var _md = __webpack_require__(101);
	
	var _md2 = _interopRequireDefault(_md);
	
	var level = Number(__filename.replace(/^.*level/, '').replace('.jsx', ''));
	var _title = (0, _helpersI18n.i18nProvider)(function (lang) {
	  return _md2['default'][lang].getSectionMetadata('Level ' + level, 'Title');
	});
	
	var _default = (function (_Component) {
	  _inherits(_default, _Component);
	
	  function _default() {
	    _classCallCheck(this, _default);
	
	    _get(Object.getPrototypeOf(_default.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(_default, [{
	    key: 'render',
	    value: function render() {
	      var _context = this.context;
	      var regionData = _context.regionData;
	      var i18n = _context.i18n;
	
	      var title = i18n(_title);
	      return _react2['default'].createElement(
	        _spectaclePpa.Deck,
	        { transition: ['slide'],
	          transitionDuration: 800,
	          progress: 'bar' },
	        (0, _sections01_startStartSection2['default'])({ level: level, title: title, regionData: regionData, i18n: i18n }),
	        (0, _sections03_songSongSection2['default'])({ level: level, regionData: regionData, i18n: i18n }),
	        (0, _sections11_missionReportMissionReportSection2['default'])({ level: level, regionData: regionData, i18n: i18n }),
	        (0, _sections25_mmeMmeSection2['default'])({ level: level, regionData: regionData, i18n: i18n }),
	        (0, _sections30_classActivityClassActivitySection2['default'])({ level: level, regionData: regionData, i18n: i18n }),
	        (0, _sections95_endingEndingSection2['default'])({ regionData: regionData, i18n: i18n }),
	        (0, _sections90_finishFinishSection2['default'])({ level: level, regionData: regionData, i18n: i18n })
	      );
	    }
	  }], [{
	    key: 'contextTypes',
	    value: {
	      regionData: _react.PropTypes.object.isRequired,
	      i18n: _react.PropTypes.func.isRequired
	    },
	    enumerable: true
	  }, {
	    key: 'metadata',
	    value: {
	      title: _title
	    },
	    enumerable: true
	  }]);

	  return _default;
	})(_react.Component);

	exports['default'] = _default;
	module.exports = exports['default'];
	/* Start */ /* Theme Song */ /* Mission Report */ /* Messages from Mother Earth */ /* Class Activity: Papercrafts */ /* Ending */ /* Finish */
	/* WEBPACK VAR INJECTION */}.call(exports, "programs/keepCool/level6.jsx"))

/***/ }),
/* 1083 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _get = __webpack_require__(8)['default'];
	
	var _inherits = __webpack_require__(5)['default'];
	
	var _createClass = __webpack_require__(6)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _baseSlidesBalloonSlide = __webpack_require__(70);
	
	var _baseSlidesBalloonSlide2 = _interopRequireDefault(_baseSlidesBalloonSlide);
	
	var _imagesCharactersSara_gigglePng = __webpack_require__(2447);
	
	var _imagesCharactersSara_gigglePng2 = _interopRequireDefault(_imagesCharactersSara_gigglePng);
	
	var _helpersMarkdownScript = __webpack_require__(9);
	
	var _helpersMarkdownScript2 = _interopRequireDefault(_helpersMarkdownScript);
	
	var _levelCompletedMd = __webpack_require__(1741);
	
	var _levelCompletedMd2 = _interopRequireDefault(_levelCompletedMd);
	
	var md = new _helpersMarkdownScript2['default'](_levelCompletedMd2['default']);
	
	var _default = (function (_Component) {
	  _inherits(_default, _Component);
	
	  function _default() {
	    _classCallCheck(this, _default);
	
	    _get(Object.getPrototypeOf(_default.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(_default, [{
	    key: 'render',
	    value: function render() {
	      var regionData = this.context.regionData;
	
	      return _react2['default'].createElement(
	        _spectaclePpa.Deck,
	        { transition: ['slide'],
	          transitionDuration: 800,
	          progress: 'bar' },
	        (0, _baseSlidesBalloonSlide2['default'])({
	          id: 'welcome-back',
	          characterSide: 'right',
	          characterImage: _imagesCharactersSara_gigglePng2['default'],
	          notes: md.getSubSectionAsHtml('Level Completed', 'Notes', false, regionData),
	          html: md.getSubSectionAsHtml('Level Completed', 'Content', false, regionData),
	          bgColor: '#37b34a'
	        })
	      );
	    }
	  }], [{
	    key: 'contextTypes',
	    value: {
	      regionData: _react.PropTypes.object.isRequired
	    },
	    enumerable: true
	  }]);

	  return _default;
	})(_react.Component);

	exports['default'] = _default;
	module.exports = exports['default'];

/***/ }),
/* 1084 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _get = __webpack_require__(8)['default'];
	
	var _inherits = __webpack_require__(5)['default'];
	
	var _createClass = __webpack_require__(6)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _componentsStartLevel = __webpack_require__(79);
	
	var _componentsStartLevel2 = _interopRequireDefault(_componentsStartLevel);
	
	var _sections00_prepPrepSection = __webpack_require__(1085);
	
	var _sections00_prepPrepSection2 = _interopRequireDefault(_sections00_prepPrepSection);
	
	var _default = (function (_Component) {
	  _inherits(_default, _Component);
	
	  function _default() {
	    _classCallCheck(this, _default);
	
	    _get(Object.getPrototypeOf(_default.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(_default, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var level = _props.nextLevel;
	      var configuration = _props.configuration;
	      var _context = this.context;
	      var regionData = _context.regionData;
	      var i18n = _context.i18n;
	
	      return _react2['default'].createElement(
	        _spectaclePpa.Deck,
	        { transition: ['slide'],
	          transitionDuration: 800,
	          progress: 'bar' },
	        (0, _sections00_prepPrepSection2['default'])({ level: level, configuration: configuration, regionData: regionData, i18n: i18n }),
	        _react2['default'].createElement(
	          _spectaclePpa.Slide,
	          {
	            id: 'start',
	            textColor: 'white' },
	          _react2['default'].createElement(_componentsStartLevel2['default'], null)
	        )
	      );
	    }
	  }], [{
	    key: 'propTypes',
	    value: {
	      nextLevel: _react.PropTypes.string.isRequired,
	      configuration: _react.PropTypes.string
	    },
	    enumerable: true
	  }, {
	    key: 'contextTypes',
	    value: {
	      regionData: _react.PropTypes.object.isRequired,
	      i18n: _react.PropTypes.func.isRequired
	    },
	    enumerable: true
	  }]);

	  return _default;
	})(_react.Component);

	exports['default'] = _default;
	module.exports = exports['default'];
	/* Prep */

/***/ }),
/* 1085 */
/***/ (function(module, exports, __webpack_require__) {

	/* eslint react/no-multi-comp: 0 */
	
	'use strict';
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _helpersI18n = __webpack_require__(14);
	
	var _componentsSelectConfiguration = __webpack_require__(77);
	
	var _componentsSelectConfiguration2 = _interopRequireDefault(_componentsSelectConfiguration);
	
	var _componentsSelectDeviceRole = __webpack_require__(78);
	
	var _componentsSelectDeviceRole2 = _interopRequireDefault(_componentsSelectDeviceRole);
	
	var _baseSlidesHtmlSlide = __webpack_require__(1074);
	
	var _baseSlidesHtmlSlide2 = _interopRequireDefault(_baseSlidesHtmlSlide);
	
	var _baseSlidesHeadingSlide = __webpack_require__(170);
	
	var _baseSlidesHeadingSlide2 = _interopRequireDefault(_baseSlidesHeadingSlide);
	
	var _baseSlidesVideoSlide = __webpack_require__(59);
	
	var _baseSlidesVideoSlide2 = _interopRequireDefault(_baseSlidesVideoSlide);
	
	var _helpersMarkdownScript = __webpack_require__(9);
	
	var _helpersMarkdownScript2 = _interopRequireDefault(_helpersMarkdownScript);
	
	var _tech_prepMd = __webpack_require__(1757);
	
	var _tech_prepMd2 = _interopRequireDefault(_tech_prepMd);
	
	var _tech_prepFr_CAMd = __webpack_require__(1756);
	
	var _tech_prepFr_CAMd2 = _interopRequireDefault(_tech_prepFr_CAMd);
	
	var techPrepMd = (0, _helpersI18n.i18nData)({
	  en: new _helpersMarkdownScript2['default'](_tech_prepMd2['default']),
	  fr_CA: new _helpersMarkdownScript2['default'](_tech_prepFr_CAMd2['default'])
	});
	
	function techPrepWizard(_ref) {
	  var regionData = _ref.regionData;
	  var i18n = _ref.i18n;
	
	  return (0, _baseSlidesHtmlSlide2['default'])({
	    id: 'tech-prep-wizard',
	    html: i18n(techPrepMd).getSectionAsHtml('Tech Prep Wizard', false, regionData)
	  });
	}
	
	function twoDeviceIntro(_ref2) {
	  var regionData = _ref2.regionData;
	  var i18n = _ref2.i18n;
	
	  return (0, _baseSlidesHtmlSlide2['default'])({
	    id: 'two-device-intro',
	    html: i18n(techPrepMd).getSectionAsHtml('Two Device Intro', false, regionData)
	  });
	}
	
	function selectConfiguration() {
	  return _react2['default'].createElement(
	    _spectaclePpa.Slide,
	    {
	      id: 'configuration',
	      textColor: 'white' },
	    _react2['default'].createElement(_componentsSelectConfiguration2['default'], null)
	  );
	}
	
	function connectingRemote(_ref3) {
	  var configuration = _ref3.configuration;
	  var regionData = _ref3.regionData;
	  var i18n = _ref3.i18n;
	
	  if (configuration === 'dualScreen') {
	    return (0, _baseSlidesHtmlSlide2['default'])({
	      id: 'connecting-remote',
	      html: i18n(techPrepMd).getSectionAsHtml('Connecting Remote', false, regionData)
	    });
	  } else {
	    return null;
	  }
	}
	
	function selectDeviceRole(configuration) {
	  if (configuration === 'dualScreen') {
	    return _react2['default'].createElement(
	      _spectaclePpa.Slide,
	      {
	        id: 'device-role',
	        textColor: 'white' },
	      _react2['default'].createElement(_componentsSelectDeviceRole2['default'], null)
	    );
	  } else {
	    return null;
	  }
	}
	
	function techCheckIntro(_ref4) {
	  var regionData = _ref4.regionData;
	  var i18n = _ref4.i18n;
	
	  return (0, _baseSlidesHtmlSlide2['default'])({
	    id: 'tech-check-intro',
	    html: i18n(techPrepMd).getSectionAsHtml('Tech Check Intro', false, regionData)
	  });
	}
	
	function techCheckVideo(_ref5) {
	  var regionData = _ref5.regionData;
	  var i18n = _ref5.i18n;
	
	  return (0, _baseSlidesVideoSlide2['default'])({
	    id: 'tech-check-video',
	    youTubeId: i18n(techPrepMd).getSectionMetadata('Tech Check Video', 'YouTube', regionData)
	  });
	}
	
	function levelPrep(_ref6) {
	  var configuration = _ref6.configuration;
	  var regionData = _ref6.regionData;
	  var i18n = _ref6.i18n;
	
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'prep' },
	    techPrepWizard({ regionData: regionData, i18n: i18n }),
	    twoDeviceIntro({ regionData: regionData, i18n: i18n }),
	    selectConfiguration(),
	    connectingRemote({ configuration: configuration, regionData: regionData, i18n: i18n }),
	    selectDeviceRole(configuration),
	    techCheckIntro({ regionData: regionData, i18n: i18n }),
	    techCheckVideo({ regionData: regionData, i18n: i18n })
	  );
	}
	
	function levelCompletedPrep(_ref7) {
	  var configuration = _ref7.configuration;
	  var regionData = _ref7.regionData;
	  var i18n = _ref7.i18n;
	
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'prep' },
	    selectConfiguration(),
	    connectingRemote({ configuration: configuration, regionData: regionData, i18n: i18n }),
	    selectDeviceRole(configuration)
	  );
	}
	
	function prepSection(_ref8) {
	  var level = _ref8.level;
	  var configuration = _ref8.configuration;
	  var regionData = _ref8.regionData;
	  var i18n = _ref8.i18n;
	
	  switch (level) {
	    case '1':
	      return levelPrep({ configuration: configuration, regionData: regionData, i18n: i18n });
	    case '2':
	      return levelPrep({ configuration: configuration, regionData: regionData, i18n: i18n });
	    case '3':
	      return levelPrep({ configuration: configuration, regionData: regionData, i18n: i18n });
	    case '4':
	      return levelPrep({ configuration: configuration, regionData: regionData, i18n: i18n });
	    case '5':
	      return levelPrep({ configuration: configuration, regionData: regionData, i18n: i18n });
	    case '6':
	      return levelPrep({ configuration: configuration, regionData: regionData, i18n: i18n });
	    case 'completed':
	      return levelCompletedPrep({ configuration: configuration, regionData: regionData, i18n: i18n });
	    default:
	      return (0, _baseSlidesHeadingSlide2['default'])({ heading: 'Unknown' });
	  }
	}
	
	exports['default'] = prepSection;
	module.exports = exports['default'];
	/* Tech Prep Wizard */ /* Two Device Intro */ /* Select Configuration */ /* Connecting Remote Instructions */ /* Select Device Role */ /* Tech Check Intro */ /* Tech Check Video */ /* Start Level */ /* Select Configuration */ /* Connecting Remote */ /* Select Device Role */

/***/ }),
/* 1086 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.preloadGameShow = preloadGameShow;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _helpersI18n = __webpack_require__(14);
	
	var _componentsTeamNames = __webpack_require__(60);
	
	var _componentsTeamNames2 = _interopRequireDefault(_componentsTeamNames);
	
	var _baseSlidesVideoSlide = __webpack_require__(59);
	
	var _baseSlidesVideoSlide2 = _interopRequireDefault(_baseSlidesVideoSlide);
	
	var _baseSlidesBalloonSlide = __webpack_require__(70);
	
	var _baseSlidesBalloonSlide2 = _interopRequireDefault(_baseSlidesBalloonSlide);
	
	var _helpersMarkdownScript = __webpack_require__(9);
	
	var _helpersMarkdownScript2 = _interopRequireDefault(_helpersMarkdownScript);
	
	var _teamCreationMd = __webpack_require__(1763);
	
	var _teamCreationMd2 = _interopRequireDefault(_teamCreationMd);
	
	var _teamCreationFr_CAMd = __webpack_require__(1762);
	
	var _teamCreationFr_CAMd2 = _interopRequireDefault(_teamCreationFr_CAMd);
	
	var _imagesCharactersApprenticesRowArmsFoldedPng = __webpack_require__(2440);
	
	var _imagesCharactersApprenticesRowArmsFoldedPng2 = _interopRequireDefault(_imagesCharactersApprenticesRowArmsFoldedPng);
	
	var _imagesCharactersApprenticeHandsHipsPng = __webpack_require__(2432);
	
	var _imagesCharactersApprenticeHandsHipsPng2 = _interopRequireDefault(_imagesCharactersApprenticeHandsHipsPng);
	
	var _imagesCharactersApprenticeArmsFoldedPng = __webpack_require__(2428);
	
	var _imagesCharactersApprenticeArmsFoldedPng2 = _interopRequireDefault(_imagesCharactersApprenticeArmsFoldedPng);
	
	var _imagesCharactersApprenticePointingDiagonalPng = __webpack_require__(900);
	
	var _imagesCharactersApprenticePointingDiagonalPng2 = _interopRequireDefault(_imagesCharactersApprenticePointingDiagonalPng);
	
	var md = (0, _helpersI18n.i18nData)({
	  en: new _helpersMarkdownScript2['default'](_teamCreationMd2['default']),
	  fr_CA: new _helpersMarkdownScript2['default'](_teamCreationFr_CAMd2['default'])
	});
	
	function preloadGameShow() {
	  (0, _spectaclePpa.preloader)([_imagesCharactersApprenticesRowArmsFoldedPng2['default'], _imagesCharactersApprenticeHandsHipsPng2['default'], _imagesCharactersApprenticeArmsFoldedPng2['default'], apprenticePointingUp]);
	}
	
	function teamCreationSection(_ref) {
	  var regionData = _ref.regionData;
	  var i18n = _ref.i18n;
	
	  var md_i18n = i18n(md);
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'team-creation' },
	    (0, _baseSlidesVideoSlide2['default'])({
	      id: 'welcome',
	      notes: md_i18n.getSubSectionAsHtml('Welcome Video', 'Notes', false, regionData),
	      youTubeId: md_i18n.getSectionMetadata('Welcome Video', 'YouTube', regionData)
	    }),
	    (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'get-into-teams',
	      characterSide: 'right',
	      characterImage: _imagesCharactersApprenticeArmsFoldedPng2['default'],
	      notes: md_i18n.getSubSectionAsHtml('Get Into Teams', 'Notes', false, regionData),
	      html: md_i18n.getSubSectionAsHtml('Get Into Teams', 'Content', false, regionData)
	    }),
	    _react2['default'].createElement(
	      _spectaclePpa.Slide,
	      {
	        id: 'assign',
	        bgColor: 'black',
	        notes: '<h2>Assign Team Names</h2>',
	        teamNames: true },
	      _react2['default'].createElement(
	        'div',
	        { className: 'ui-slide' },
	        _react2['default'].createElement(
	          _spectaclePpa.Heading,
	          { size: 1 },
	          i18n('Name your teams!')
	        ),
	        _react2['default'].createElement(_componentsTeamNames2['default'], null)
	      )
	    ),
	    (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'scoring-intro',
	      characterSide: 'right',
	      characterImage: _imagesCharactersApprenticeHandsHipsPng2['default'],
	      notes: md_i18n.getSubSectionAsHtml('Scoring Intro', 'Notes', false, regionData),
	      html: md_i18n.getSubSectionAsHtml('Scoring Intro', 'Content', false, regionData)
	    }),
	    (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'scoreboard-intro',
	      characterSide: 'right',
	      characterImage: _imagesCharactersApprenticePointingDiagonalPng2['default'],
	      notes: md_i18n.getSubSectionAsHtml('Scoreboard Intro', 'Notes', false, regionData),
	      html: md_i18n.getSubSectionAsHtml('Scoreboard Intro', 'Content', false, regionData)
	    }),
	    (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'id-cards',
	      characterSide: 'left',
	      characterImage: _imagesCharactersApprenticesRowArmsFoldedPng2['default'],
	      notes: md_i18n.getSubSectionAsHtml('ID Cards', 'Notes', false, regionData),
	      html: md_i18n.getSubSectionAsHtml('ID Cards', 'Content', false, regionData)
	    })
	  );
	}
	
	exports['default'] = teamCreationSection;
	/* Sara and Ian welcome to Academy */ /* Get into teams and come up with a cool name */ /* Enter team names */ /* Scoring intro */ /* Introduce scoreboard */ /* ID cards draw your avatar */

/***/ }),
/* 1087 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.preloadEnding = preloadEnding;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _helpersI18n = __webpack_require__(14);
	
	var _baseSlidesVideoSlide = __webpack_require__(59);
	
	var _baseSlidesVideoSlide2 = _interopRequireDefault(_baseSlidesVideoSlide);
	
	var _baseSlidesBalloonSlide = __webpack_require__(70);
	
	var _baseSlidesBalloonSlide2 = _interopRequireDefault(_baseSlidesBalloonSlide);
	
	var _baseSlidesHeadingSlide = __webpack_require__(170);
	
	var _baseSlidesHeadingSlide2 = _interopRequireDefault(_baseSlidesHeadingSlide);
	
	var _imagesLogo_ppaPng = __webpack_require__(905);
	
	var _imagesLogo_ppaPng2 = _interopRequireDefault(_imagesLogo_ppaPng);
	
	var _imagesCharactersEsmeralda_goober_goofy_smilePng = __webpack_require__(438);
	
	var _imagesCharactersEsmeralda_goober_goofy_smilePng2 = _interopRequireDefault(_imagesCharactersEsmeralda_goober_goofy_smilePng);
	
	var _imagesCharactersIan_sara_sillyPng = __webpack_require__(2446);
	
	var _imagesCharactersIan_sara_sillyPng2 = _interopRequireDefault(_imagesCharactersIan_sara_sillyPng);
	
	var _imagesCharactersEsmeralda_goober_proudPng = __webpack_require__(439);
	
	var _imagesCharactersEsmeralda_goober_proudPng2 = _interopRequireDefault(_imagesCharactersEsmeralda_goober_proudPng);
	
	var _helpersMarkdownScript = __webpack_require__(9);
	
	var _helpersMarkdownScript2 = _interopRequireDefault(_helpersMarkdownScript);
	
	var _endingMd = __webpack_require__(1815);
	
	var _endingMd2 = _interopRequireDefault(_endingMd);
	
	var _endingFr_CAMd = __webpack_require__(1814);
	
	var _endingFr_CAMd2 = _interopRequireDefault(_endingFr_CAMd);
	
	var md = (0, _helpersI18n.i18nData)({
	  en: new _helpersMarkdownScript2['default'](_endingMd2['default']),
	  fr_CA: new _helpersMarkdownScript2['default'](_endingFr_CAMd2['default'])
	});
	
	function preloadEnding() {
	  (0, _spectaclePpa.preloader)([_imagesCharactersEsmeralda_goober_goofy_smilePng2['default'], _imagesCharactersIan_sara_sillyPng2['default'], _imagesCharactersEsmeralda_goober_proudPng2['default'], _imagesLogo_ppaPng2['default']]);
	}
	
	function endingSection(_ref) {
	  var regionData = _ref.regionData;
	  var i18n = _ref.i18n;
	
	  var md_i18n = i18n(md);
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'ending' },
	    (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'announce-winners',
	      characterSide: 'right',
	      characterImage: _imagesCharactersIan_sara_sillyPng2['default'],
	      html: md_i18n.getSubSectionAsHtml('Announce Winners', 'Content', false, regionData),
	      notes: md_i18n.getSubSectionAsHtml('Announce Winners', 'Notes', false, regionData)
	    }),
	    (0, _baseSlidesVideoSlide2['default'])({
	      id: 'ian-sara-pie',
	      notes: md_i18n.getSubSectionAsHtml('Ian and Sara Pie', 'Notes', false, regionData),
	      youTubeId: md_i18n.getSectionMetadata('Ian and Sara Pie', 'YouTube', regionData)
	    }),
	    (0, _baseSlidesVideoSlide2['default'])({
	      id: 'congrats-video',
	      notes: md_i18n.getSubSectionAsHtml('Esmeralda and Goober Congrats', 'Notes', false, regionData),
	      youTubeId: md_i18n.getSectionMetadata('Esmeralda and Goober Congrats', 'YouTube', regionData)
	    }),
	    (0, _baseSlidesHeadingSlide2['default'])({
	      id: 'completed',
	      beforeImage: _imagesLogo_ppaPng2['default'],
	      heading: i18n('Keep Cool') + '!',
	      subHeading: i18n('All levels completed') + '!!!',
	      notes: md_i18n.getSubSectionAsHtml('All Levels Completed', 'Notes', false, regionData),
	      bgColor: 'black'
	    })
	  );
	}
	
	exports['default'] = endingSection;
	/* Time to see who won! */ /* Ian & Sara pie */ /* Esmeralda and Goober Congrats */ /* You've completed all the levels */

/***/ }),
/* 1088 */
/***/ (function(module, exports) {

	/* eslint-disable object-shorthand */
	'use strict';
	
	var colors = {
	  primary: '#37bad5',
	  secondary: 'black',
	  tertiary: 'white',
	  level1: '#ffbc00',
	  level2: '#8f288c',
	  level3: '#26a7df',
	  level4: '#e80a89',
	  level5: '#f59122',
	  level6: '#37b34a',
	  gameshow: '#742CBF',
	  question: '#45B3EC',
	  answer: '#6FC36E'
	};
	
	var fonts = {
	  primary: 'BrandonTextWeb',
	  secondary: 'Orbitron',
	  tertiary: 'Ubuntu'
	};
	
	module.exports = {
	  colors: colors,
	  fonts: fonts,
	  global: {
	    body: {
	      background: 'transparent',
	      fontFamily: fonts.primary,
	      fontWeight: 'normal',
	      fontSize: '2em',
	      color: colors.primary,
	      overflow: 'hidden'
	    },
	    'html, body': {
	      // height: '100%'
	    },
	    '*': {
	      boxSizing: 'border-box'
	    },
	    input: {
	      color: 'black',
	      fontWeight: 'bold',
	      backgroundColor: 'white',
	      fontSize: '2.66em',
	      fontFamily: fonts.primary,
	      padding: '0.25em 0.25em 0.2em',
	      margin: '1% 1% 3%',
	      width: '98%'
	    },
	    label: {
	      color: 'white',
	      fontWeight: 'bold',
	      fontSize: '1.8em',
	      margin: '0.1em 0 0'
	    }
	  },
	  progress: {
	    bar: {
	      container: {
	        position: 'absolute',
	        height: '22px',
	        width: '100%',
	        bottom: 0,
	        left: 0,
	        transition: 'all 1s ease-in-out 0.2s',
	        zIndex: 1000
	      },
	      bar: {
	        height: '100%',
	        background: colors.primary,
	        transition: 'all 0.3s ease-out',
	        fontSize: '12px',
	        letterSpacing: '0.1em',
	        textTransform: 'uppercase',
	        padding: '4px',
	        textAlign: 'right'
	      }
	    },
	    number: {
	      container: {
	        position: 'absolute',
	        bottom: 10,
	        right: 10,
	        zIndex: 1000,
	        color: colors.tertiary
	      }
	    }
	  },
	  components: {
	    codePane: {
	      pre: {
	        margin: 'auto',
	        fontSize: '1em',
	        fontWeight: 'normal',
	        fontFamily: fonts.tertiary,
	        minWidth: '100%',
	        maxWidth: 800
	      },
	      code: {
	        textAlign: 'left',
	        padding: 20,
	        fontWeight: 'normal'
	      }
	    },
	    code: {
	      color: 'black',
	      fontSize: '2.66em',
	      fontFamily: fonts.tertiary,
	      margin: '0.25em auto',
	      backgroundColor: 'rgba(0,0,0,0.15)',
	      padding: '0 10px',
	      borderRadius: 3
	    },
	    heading: {},
	    link: {
	      textDecoration: 'none'
	    },
	    listItem: {
	      fontSize: '2.66em',
	      padding: '0 0 0.5em'
	    },
	    list: {
	      textAlign: 'center',
	      listStyle: 'none',
	      padding: '0.5em 0'
	    },
	    s: {
	      strikethrough: {}
	    },
	    text: {
	      color: 'black',
	      fontSize: '2.66em',
	      fontFamily: fonts.primary,
	      margin: '0.25em auto',
	      textShadow: '0 0 10px rgba(0,0,0,0.2)'
	    }
	  }
	};

/***/ }),
/* 1089 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = __webpack_require__(7)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	function htmlSlide(_ref) {
	  var id = _ref.id;
	  var notes = _ref.notes;
	  var heading = _ref.heading;
	  var bgColor = _ref.bgColor;
	  var subHeading = _ref.subHeading;
	  var html = _ref.html;
	  var slideClass = _ref.slideClass;
	
	  var slideContentClass = slideClass ? ' slide-' + slideClass : '';
	  var bgColorOpts = {};
	  if (bgColor) {
	    bgColorOpts.bgColor = bgColor;
	  }
	  return _react2['default'].createElement(
	    _spectaclePpa.Slide,
	    _extends({
	      id: id,
	      key: id
	    }, bgColorOpts, {
	      notes: notes,
	      textColor: 'white' }),
	    _react2['default'].createElement(
	      'div',
	      { className: 'slide-content' + slideContentClass },
	      _react2['default'].createElement(
	        'div',
	        {
	          className: 'text-formatted' },
	        !!heading && _react2['default'].createElement(
	          _spectaclePpa.Heading,
	          { size: 3 },
	          heading
	        ),
	        !!subHeading && _react2['default'].createElement(
	          _spectaclePpa.Heading,
	          { size: 5 },
	          subHeading
	        ),
	        _react2['default'].createElement('div', {
	          dangerouslySetInnerHTML: { __html: html } })
	      )
	    )
	  );
	}
	
	exports['default'] = htmlSlide;
	module.exports = exports['default'];

/***/ }),
/* 1090 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = {
	  width: 1000,
	  height: 700,
	  margin: 40,
	  theme: __webpack_require__(1104),
	  print: __webpack_require__(53),
	  html: __webpack_require__(52)
	};

/***/ }),
/* 1091 */
/***/ (function(module, exports, __webpack_require__) {

	/* eslint no-console: 0 */
	
	'use strict';
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _helpersMarkdownScript = __webpack_require__(9);
	
	var _helpersMarkdownScript2 = _interopRequireDefault(_helpersMarkdownScript);
	
	var _indexMd = __webpack_require__(111);
	
	var _indexMd2 = _interopRequireDefault(_indexMd);
	
	var _extensionActivitiesExtensionActivitiesMd = __webpack_require__(1816);
	
	var _extensionActivitiesExtensionActivitiesMd2 = _interopRequireDefault(_extensionActivitiesExtensionActivitiesMd);
	
	var _programPrepProgramPrepMd = __webpack_require__(1819);
	
	var _programPrepProgramPrepMd2 = _interopRequireDefault(_programPrepProgramPrepMd);
	
	var _sections00_prepLevel1_prepMd = __webpack_require__(1820);
	
	var _sections00_prepLevel1_prepMd2 = _interopRequireDefault(_sections00_prepLevel1_prepMd);
	
	var _sections00_prepLevel2_prepMd = __webpack_require__(1821);
	
	var _sections00_prepLevel2_prepMd2 = _interopRequireDefault(_sections00_prepLevel2_prepMd);
	
	var _sections00_prepLevel3_prepMd = __webpack_require__(1822);
	
	var _sections00_prepLevel3_prepMd2 = _interopRequireDefault(_sections00_prepLevel3_prepMd);
	
	var _sections00_prepLevel4_prepMd = __webpack_require__(1823);
	
	var _sections00_prepLevel4_prepMd2 = _interopRequireDefault(_sections00_prepLevel4_prepMd);
	
	var _sections00_prepLevel5_prepMd = __webpack_require__(1824);
	
	var _sections00_prepLevel5_prepMd2 = _interopRequireDefault(_sections00_prepLevel5_prepMd);
	
	var _sections00_prepLevel6_prepMd = __webpack_require__(1825);
	
	var _sections00_prepLevel6_prepMd2 = _interopRequireDefault(_sections00_prepLevel6_prepMd);
	
	var _funMd = __webpack_require__(1817);
	
	var _funMd2 = _interopRequireDefault(_funMd);
	
	var _imagesZeroHeroesPng = __webpack_require__(2508);
	
	var _imagesZeroHeroesPng2 = _interopRequireDefault(_imagesZeroHeroesPng);
	
	var _imagesZeroHeroesTrialPng = __webpack_require__(2511);
	
	var _imagesZeroHeroesTrialPng2 = _interopRequireDefault(_imagesZeroHeroesTrialPng);
	
	var _imagesZeroHeroesExpiredPng = __webpack_require__(2509);
	
	var _imagesZeroHeroesExpiredPng2 = _interopRequireDefault(_imagesZeroHeroesExpiredPng);
	
	var _config = __webpack_require__(1090);
	
	var _config2 = _interopRequireDefault(_config);
	
	// Preload image functions
	
	var _sections20_gameShowGameShowSection = __webpack_require__(102);
	
	__webpack_require__(2193);
	
	var md = new _helpersMarkdownScript2['default'](_indexMd2['default']);
	
	var levels = {
	  prep: {
	    deck: __webpack_require__(1099)
	  },
	  1: {
	    thumbnail: __webpack_require__(448),
	    overviewThumbnail: __webpack_require__(2501),
	    deck: __webpack_require__(1092),
	    prep: new _helpersMarkdownScript2['default'](_sections00_prepLevel1_prepMd2['default']),
	    levelName: 'Operation Garbage Watch'
	  },
	  2: {
	    thumbnail: __webpack_require__(449),
	    overviewThumbnail: __webpack_require__(2502),
	    deck: __webpack_require__(1093),
	    prep: new _helpersMarkdownScript2['default'](_sections00_prepLevel2_prepMd2['default']),
	    levelName: 'Operation Love Food, Hate Waste'
	  },
	  3: {
	    thumbnail: __webpack_require__(450),
	    overviewThumbnail: __webpack_require__(2503),
	    deck: __webpack_require__(1094),
	    prep: new _helpersMarkdownScript2['default'](_sections00_prepLevel3_prepMd2['default']),
	    levelName: 'Operation Food Scraps'
	  },
	  4: {
	    thumbnail: __webpack_require__(451),
	    overviewThumbnail: __webpack_require__(2504),
	    deck: __webpack_require__(1095),
	    prep: new _helpersMarkdownScript2['default'](_sections00_prepLevel4_prepMd2['default']),
	    levelName: 'Operation Waste-Free Lunch'
	  },
	  5: {
	    thumbnail: __webpack_require__(452),
	    overviewThumbnail: __webpack_require__(2505),
	    deck: __webpack_require__(1096),
	    prep: new _helpersMarkdownScript2['default'](_sections00_prepLevel5_prepMd2['default']),
	    levelName: 'Operation Buy Smart'
	  },
	  6: {
	    thumbnail: __webpack_require__(911),
	    overviewThumbnail: __webpack_require__(2506),
	    deck: __webpack_require__(1097),
	    prep: new _helpersMarkdownScript2['default'](_sections00_prepLevel6_prepMd2['default']),
	    levelName: 'Operation Green Cycle'
	  },
	  completed: {
	    deck: __webpack_require__(1098)
	  }
	};
	
	var program = {
	  id: 'zeroHeroes',
	  title: md.getSectionAsString('Title - Short'),
	  longTitle: md.getSectionAsString('Title - Long'),
	  thumbnailImage: _imagesZeroHeroesPng2['default'],
	  trialImageThumb: _imagesZeroHeroesTrialPng2['default'],
	  expiredImageThumb: _imagesZeroHeroesExpiredPng2['default'],
	  longDescription: md.getSectionAsString('Description - Long'),
	  levelsDescription: md.getSectionAsString('Description - Levels'),
	  shortDescription: md.getSectionAsString('Description - Short'),
	  levels: levels,
	  extensionActivitiesMd: new _helpersMarkdownScript2['default'](_extensionActivitiesExtensionActivitiesMd2['default']),
	  programPrepMd: new _helpersMarkdownScript2['default'](_programPrepProgramPrepMd2['default']),
	  funMd: new _helpersMarkdownScript2['default'](_funMd2['default']),
	  preload: function preload(_ref) {
	    var level = _ref.level;
	
	    console.log('Preloading assets for Level ' + level);
	
	    (0, _sections20_gameShowGameShowSection.preloadGameShow)();
	  },
	  config: _config2['default']
	};
	
	exports['default'] = program;
	module.exports = exports['default'];

/***/ }),
/* 1092 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(__filename) {'use strict';
	
	var _get = __webpack_require__(8)['default'];
	
	var _inherits = __webpack_require__(5)['default'];
	
	var _createClass = __webpack_require__(6)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _helpersMarkdownScript = __webpack_require__(9);
	
	var _helpersMarkdownScript2 = _interopRequireDefault(_helpersMarkdownScript);
	
	var _indexMd = __webpack_require__(111);
	
	var _indexMd2 = _interopRequireDefault(_indexMd);
	
	var _sections01_startStartSection = __webpack_require__(129);
	
	var _sections01_startStartSection2 = _interopRequireDefault(_sections01_startStartSection);
	
	var _sections03_songSongSection = __webpack_require__(130);
	
	var _sections03_songSongSection2 = _interopRequireDefault(_sections03_songSongSection);
	
	var _sections10_teamCreationTeamCreationSection = __webpack_require__(1101);
	
	var _sections10_teamCreationTeamCreationSection2 = _interopRequireDefault(_sections10_teamCreationTeamCreationSection);
	
	var _sections12_esOpeningStoryEsOpeningStorySection = __webpack_require__(131);
	
	var _sections12_esOpeningStoryEsOpeningStorySection2 = _interopRequireDefault(_sections12_esOpeningStoryEsOpeningStorySection);
	
	var _sections20_gameShowGameShowSection = __webpack_require__(102);
	
	var _sections20_gameShowGameShowSection2 = _interopRequireDefault(_sections20_gameShowGameShowSection);
	
	var _sections30_classActivityClassActivitySection = __webpack_require__(132);
	
	var _sections30_classActivityClassActivitySection2 = _interopRequireDefault(_sections30_classActivityClassActivitySection);
	
	var _sections60_esClosingStoryEsClosingStorySection = __webpack_require__(133);
	
	var _sections60_esClosingStoryEsClosingStorySection2 = _interopRequireDefault(_sections60_esClosingStoryEsClosingStorySection);
	
	var _sections70_missionAssignmentMissionAssignmentSection = __webpack_require__(173);
	
	var _sections70_missionAssignmentMissionAssignmentSection2 = _interopRequireDefault(_sections70_missionAssignmentMissionAssignmentSection);
	
	var _sections90_finishFinishSection = __webpack_require__(174);
	
	var _sections90_finishFinishSection2 = _interopRequireDefault(_sections90_finishFinishSection);
	
	var md = new _helpersMarkdownScript2['default'](_indexMd2['default']);
	var level = Number(__filename.replace(/^.*level/, '').replace('.jsx', ''));
	var title = md.getSectionMetadata('Level ' + level, 'Title');
	
	var _default = (function (_Component) {
	  _inherits(_default, _Component);
	
	  function _default() {
	    _classCallCheck(this, _default);
	
	    _get(Object.getPrototypeOf(_default.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(_default, [{
	    key: 'render',
	    value: function render() {
	      var regionData = this.context.regionData;
	
	      return _react2['default'].createElement(
	        _spectaclePpa.Deck,
	        { transition: ['slide'],
	          transitionDuration: 800,
	          progress: 'bar' },
	        (0, _sections01_startStartSection2['default'])({ level: level, title: title, regionData: regionData }),
	        (0, _sections12_esOpeningStoryEsOpeningStorySection2['default'])({ level: level, regionData: regionData }),
	        (0, _sections03_songSongSection2['default'])({ level: level, regionData: regionData }),
	        (0, _sections10_teamCreationTeamCreationSection2['default'])({ regionData: regionData }),
	        (0, _sections20_gameShowGameShowSection2['default'])({ level: level, regionData: regionData }),
	        (0, _sections30_classActivityClassActivitySection2['default'])({ level: level, regionData: regionData }),
	        (0, _sections60_esClosingStoryEsClosingStorySection2['default'])({ level: level, regionData: regionData }),
	        (0, _sections70_missionAssignmentMissionAssignmentSection2['default'])({ level: level, title: title, regionData: regionData }),
	        (0, _sections90_finishFinishSection2['default'])({ level: level, regionData: regionData })
	      );
	    }
	  }], [{
	    key: 'contextTypes',
	    value: {
	      regionData: _react.PropTypes.object.isRequired
	    },
	    enumerable: true
	  }, {
	    key: 'metadata',
	    value: {
	      title: title
	    },
	    enumerable: true
	  }]);

	  return _default;
	})(_react.Component);

	exports['default'] = _default;
	module.exports = exports['default'];
	/* Start */ /* Esmeralda Opening Story */ /* Theme Song */ /* Team Creation and Introduction */ /* Game Show */ /* Class Activity: Draw a Season */ /* Esmeralda Closing Story */ /* Mission Assignment */ /* Finish */
	/* WEBPACK VAR INJECTION */}.call(exports, "programs/zeroHeroes/level1.jsx"))

/***/ }),
/* 1093 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(__filename) {'use strict';
	
	var _get = __webpack_require__(8)['default'];
	
	var _inherits = __webpack_require__(5)['default'];
	
	var _createClass = __webpack_require__(6)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _helpersMarkdownScript = __webpack_require__(9);
	
	var _helpersMarkdownScript2 = _interopRequireDefault(_helpersMarkdownScript);
	
	var _indexMd = __webpack_require__(111);
	
	var _indexMd2 = _interopRequireDefault(_indexMd);
	
	var _sections01_startStartSection = __webpack_require__(129);
	
	var _sections01_startStartSection2 = _interopRequireDefault(_sections01_startStartSection);
	
	var _sections03_songSongSection = __webpack_require__(130);
	
	var _sections03_songSongSection2 = _interopRequireDefault(_sections03_songSongSection);
	
	var _sections11_missionReportMissionReportSection = __webpack_require__(172);
	
	var _sections11_missionReportMissionReportSection2 = _interopRequireDefault(_sections11_missionReportMissionReportSection);
	
	var _sections12_esOpeningStoryEsOpeningStorySection = __webpack_require__(131);
	
	var _sections12_esOpeningStoryEsOpeningStorySection2 = _interopRequireDefault(_sections12_esOpeningStoryEsOpeningStorySection);
	
	var _sections20_gameShowGameShowSection = __webpack_require__(102);
	
	var _sections20_gameShowGameShowSection2 = _interopRequireDefault(_sections20_gameShowGameShowSection);
	
	var _sections13_mmeMmeSection = __webpack_require__(228);
	
	var _sections13_mmeMmeSection2 = _interopRequireDefault(_sections13_mmeMmeSection);
	
	var _sections30_classActivityClassActivitySection = __webpack_require__(132);
	
	var _sections30_classActivityClassActivitySection2 = _interopRequireDefault(_sections30_classActivityClassActivitySection);
	
	var _sections60_esClosingStoryEsClosingStorySection = __webpack_require__(133);
	
	var _sections60_esClosingStoryEsClosingStorySection2 = _interopRequireDefault(_sections60_esClosingStoryEsClosingStorySection);
	
	var _sections70_missionAssignmentMissionAssignmentSection = __webpack_require__(173);
	
	var _sections70_missionAssignmentMissionAssignmentSection2 = _interopRequireDefault(_sections70_missionAssignmentMissionAssignmentSection);
	
	var _sections90_finishFinishSection = __webpack_require__(174);
	
	var _sections90_finishFinishSection2 = _interopRequireDefault(_sections90_finishFinishSection);
	
	var md = new _helpersMarkdownScript2['default'](_indexMd2['default']);
	var level = Number(__filename.replace(/^.*level/, '').replace('.jsx', ''));
	var title = md.getSectionMetadata('Level ' + level, 'Title');
	
	var _default = (function (_Component) {
	  _inherits(_default, _Component);
	
	  function _default() {
	    _classCallCheck(this, _default);
	
	    _get(Object.getPrototypeOf(_default.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(_default, [{
	    key: 'render',
	    value: function render() {
	      var regionData = this.context.regionData;
	
	      return _react2['default'].createElement(
	        _spectaclePpa.Deck,
	        { transition: ['slide'],
	          transitionDuration: 800,
	          progress: 'bar' },
	        (0, _sections01_startStartSection2['default'])({ level: level, title: title, regionData: regionData }),
	        (0, _sections03_songSongSection2['default'])({ level: level, regionData: regionData }),
	        (0, _sections11_missionReportMissionReportSection2['default'])({ level: level, regionData: regionData }),
	        (0, _sections30_classActivityClassActivitySection2['default'])({ level: level, subActivity: 'a', regionData: regionData }),
	        (0, _sections12_esOpeningStoryEsOpeningStorySection2['default'])({ level: level, regionData: regionData }),
	        (0, _sections20_gameShowGameShowSection2['default'])({ level: level, regionData: regionData }),
	        (0, _sections13_mmeMmeSection2['default'])({ level: level, regionData: regionData }),
	        (0, _sections30_classActivityClassActivitySection2['default'])({ level: level, subActivity: 'b', regionData: regionData }),
	        (0, _sections30_classActivityClassActivitySection2['default'])({ level: level, subActivity: 'c', regionData: regionData }),
	        (0, _sections60_esClosingStoryEsClosingStorySection2['default'])({ level: level, regionData: regionData }),
	        (0, _sections70_missionAssignmentMissionAssignmentSection2['default'])({ level: level, title: title, regionData: regionData }),
	        (0, _sections90_finishFinishSection2['default'])({ level: level, regionData: regionData })
	      );
	    }
	  }], [{
	    key: 'contextTypes',
	    value: {
	      regionData: _react.PropTypes.object.isRequired
	    },
	    enumerable: true
	  }, {
	    key: 'metadata',
	    value: {
	      title: title
	    },
	    enumerable: true
	  }]);

	  return _default;
	})(_react.Component);

	exports['default'] = _default;
	module.exports = exports['default'];
	/* Start */ /* Theme Song */ /* Mission Report */ /* One-off popcorn activity instructions */ /* Esmeralda Opening Story */ /* Game Show */ /* Messages from Mother Earth */ /* Class Activity: Waste Math */ /* Class Activity: Eat Me First Box */ /* Esmeralda Closing Story */ /* Mission Assignment */ /* Finish */
	/* WEBPACK VAR INJECTION */}.call(exports, "programs/zeroHeroes/level2.jsx"))

/***/ }),
/* 1094 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(__filename) {'use strict';
	
	var _get = __webpack_require__(8)['default'];
	
	var _inherits = __webpack_require__(5)['default'];
	
	var _createClass = __webpack_require__(6)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _helpersMarkdownScript = __webpack_require__(9);
	
	var _helpersMarkdownScript2 = _interopRequireDefault(_helpersMarkdownScript);
	
	var _indexMd = __webpack_require__(111);
	
	var _indexMd2 = _interopRequireDefault(_indexMd);
	
	var _sections01_startStartSection = __webpack_require__(129);
	
	var _sections01_startStartSection2 = _interopRequireDefault(_sections01_startStartSection);
	
	var _sections03_songSongSection = __webpack_require__(130);
	
	var _sections03_songSongSection2 = _interopRequireDefault(_sections03_songSongSection);
	
	var _sections11_missionReportMissionReportSection = __webpack_require__(172);
	
	var _sections11_missionReportMissionReportSection2 = _interopRequireDefault(_sections11_missionReportMissionReportSection);
	
	var _sections12_esOpeningStoryEsOpeningStorySection = __webpack_require__(131);
	
	var _sections12_esOpeningStoryEsOpeningStorySection2 = _interopRequireDefault(_sections12_esOpeningStoryEsOpeningStorySection);
	
	var _sections20_gameShowGameShowSection = __webpack_require__(102);
	
	var _sections20_gameShowGameShowSection2 = _interopRequireDefault(_sections20_gameShowGameShowSection);
	
	var _sections13_mmeMmeSection = __webpack_require__(228);
	
	var _sections13_mmeMmeSection2 = _interopRequireDefault(_sections13_mmeMmeSection);
	
	var _sections30_classActivityClassActivitySection = __webpack_require__(132);
	
	var _sections30_classActivityClassActivitySection2 = _interopRequireDefault(_sections30_classActivityClassActivitySection);
	
	var _sections60_esClosingStoryEsClosingStorySection = __webpack_require__(133);
	
	var _sections60_esClosingStoryEsClosingStorySection2 = _interopRequireDefault(_sections60_esClosingStoryEsClosingStorySection);
	
	var _sections70_missionAssignmentMissionAssignmentSection = __webpack_require__(173);
	
	var _sections70_missionAssignmentMissionAssignmentSection2 = _interopRequireDefault(_sections70_missionAssignmentMissionAssignmentSection);
	
	var _sections90_finishFinishSection = __webpack_require__(174);
	
	var _sections90_finishFinishSection2 = _interopRequireDefault(_sections90_finishFinishSection);
	
	var md = new _helpersMarkdownScript2['default'](_indexMd2['default']);
	var level = Number(__filename.replace(/^.*level/, '').replace('.jsx', ''));
	var title = md.getSectionMetadata('Level ' + level, 'Title');
	
	var _default = (function (_Component) {
	  _inherits(_default, _Component);
	
	  function _default() {
	    _classCallCheck(this, _default);
	
	    _get(Object.getPrototypeOf(_default.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(_default, [{
	    key: 'render',
	    value: function render() {
	      var regionData = this.context.regionData;
	
	      return _react2['default'].createElement(
	        _spectaclePpa.Deck,
	        { transition: ['slide'],
	          transitionDuration: 800,
	          progress: 'bar' },
	        (0, _sections01_startStartSection2['default'])({ level: level, title: title, regionData: regionData }),
	        (0, _sections03_songSongSection2['default'])({ level: level, regionData: regionData }),
	        (0, _sections11_missionReportMissionReportSection2['default'])({ level: level, regionData: regionData }),
	        (0, _sections12_esOpeningStoryEsOpeningStorySection2['default'])({ level: level, regionData: regionData }),
	        (0, _sections20_gameShowGameShowSection2['default'])({ level: level, regionData: regionData }),
	        (0, _sections13_mmeMmeSection2['default'])({ level: level, regionData: regionData }),
	        (0, _sections30_classActivityClassActivitySection2['default'])({ level: level, subActivity: 'a', regionData: regionData }),
	        (0, _sections30_classActivityClassActivitySection2['default'])({ level: level, subActivity: 'b', regionData: regionData }),
	        (0, _sections60_esClosingStoryEsClosingStorySection2['default'])({ level: level, regionData: regionData }),
	        (0, _sections70_missionAssignmentMissionAssignmentSection2['default'])({ level: level, title: title, regionData: regionData }),
	        (0, _sections90_finishFinishSection2['default'])({ level: level, regionData: regionData })
	      );
	    }
	  }], [{
	    key: 'contextTypes',
	    value: {
	      regionData: _react.PropTypes.object.isRequired
	    },
	    enumerable: true
	  }, {
	    key: 'metadata',
	    value: {
	      title: title
	    },
	    enumerable: true
	  }]);

	  return _default;
	})(_react.Component);

	exports['default'] = _default;
	module.exports = exports['default'];
	/* Start */ /* Theme Song */ /* Mission Report */ /* Esmeralda Opening Story */ /* Game Show */ /* Messages from Mother Earth */ /* Class Activity: Sorting Game */ /* Class Activity: Food Scraps Rap */ /* Esmeralda Closing Story */ /* Mission Assignment */ /* Finish */
	/* WEBPACK VAR INJECTION */}.call(exports, "programs/zeroHeroes/level3.jsx"))

/***/ }),
/* 1095 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(__filename) {'use strict';
	
	var _get = __webpack_require__(8)['default'];
	
	var _inherits = __webpack_require__(5)['default'];
	
	var _createClass = __webpack_require__(6)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _helpersMarkdownScript = __webpack_require__(9);
	
	var _helpersMarkdownScript2 = _interopRequireDefault(_helpersMarkdownScript);
	
	var _indexMd = __webpack_require__(111);
	
	var _indexMd2 = _interopRequireDefault(_indexMd);
	
	var _sections01_startStartSection = __webpack_require__(129);
	
	var _sections01_startStartSection2 = _interopRequireDefault(_sections01_startStartSection);
	
	var _sections03_songSongSection = __webpack_require__(130);
	
	var _sections03_songSongSection2 = _interopRequireDefault(_sections03_songSongSection);
	
	var _sections11_missionReportMissionReportSection = __webpack_require__(172);
	
	var _sections11_missionReportMissionReportSection2 = _interopRequireDefault(_sections11_missionReportMissionReportSection);
	
	var _sections12_esOpeningStoryEsOpeningStorySection = __webpack_require__(131);
	
	var _sections12_esOpeningStoryEsOpeningStorySection2 = _interopRequireDefault(_sections12_esOpeningStoryEsOpeningStorySection);
	
	var _sections20_gameShowGameShowSection = __webpack_require__(102);
	
	var _sections20_gameShowGameShowSection2 = _interopRequireDefault(_sections20_gameShowGameShowSection);
	
	var _sections13_mmeMmeSection = __webpack_require__(228);
	
	var _sections13_mmeMmeSection2 = _interopRequireDefault(_sections13_mmeMmeSection);
	
	var _sections30_classActivityClassActivitySection = __webpack_require__(132);
	
	var _sections30_classActivityClassActivitySection2 = _interopRequireDefault(_sections30_classActivityClassActivitySection);
	
	var _sections60_esClosingStoryEsClosingStorySection = __webpack_require__(133);
	
	var _sections60_esClosingStoryEsClosingStorySection2 = _interopRequireDefault(_sections60_esClosingStoryEsClosingStorySection);
	
	var _sections70_missionAssignmentMissionAssignmentSection = __webpack_require__(173);
	
	var _sections70_missionAssignmentMissionAssignmentSection2 = _interopRequireDefault(_sections70_missionAssignmentMissionAssignmentSection);
	
	var _sections91_finishHackedFinishHackedSection = __webpack_require__(1102);
	
	var _sections91_finishHackedFinishHackedSection2 = _interopRequireDefault(_sections91_finishHackedFinishHackedSection);
	
	var md = new _helpersMarkdownScript2['default'](_indexMd2['default']);
	var level = Number(__filename.replace(/^.*level/, '').replace('.jsx', ''));
	var title = md.getSectionMetadata('Level ' + level, 'Title');
	
	var _default = (function (_Component) {
	  _inherits(_default, _Component);
	
	  function _default() {
	    _classCallCheck(this, _default);
	
	    _get(Object.getPrototypeOf(_default.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(_default, [{
	    key: 'render',
	    value: function render() {
	      var regionData = this.context.regionData;
	
	      return _react2['default'].createElement(
	        _spectaclePpa.Deck,
	        { transition: ['slide'],
	          transitionDuration: 800,
	          progress: 'bar' },
	        (0, _sections01_startStartSection2['default'])({ level: level, title: title, regionData: regionData }),
	        (0, _sections03_songSongSection2['default'])({ level: level, regionData: regionData }),
	        (0, _sections11_missionReportMissionReportSection2['default'])({ level: level, regionData: regionData }),
	        (0, _sections12_esOpeningStoryEsOpeningStorySection2['default'])({ level: level, regionData: regionData }),
	        (0, _sections20_gameShowGameShowSection2['default'])({ level: level, regionData: regionData }),
	        (0, _sections13_mmeMmeSection2['default'])({ level: level, regionData: regionData }),
	        (0, _sections30_classActivityClassActivitySection2['default'])({ level: level, subActivity: 'a', regionData: regionData }),
	        (0, _sections30_classActivityClassActivitySection2['default'])({ level: level, subActivity: 'b', regionData: regionData }),
	        (0, _sections30_classActivityClassActivitySection2['default'])({ level: level, subActivity: 'c', regionData: regionData }),
	        (0, _sections70_missionAssignmentMissionAssignmentSection2['default'])({ level: level, title: title, regionData: regionData }),
	        (0, _sections60_esClosingStoryEsClosingStorySection2['default'])({ level: level, regionData: regionData }),
	        (0, _sections91_finishHackedFinishHackedSection2['default'])({ level: level, regionData: regionData })
	      );
	    }
	  }], [{
	    key: 'contextTypes',
	    value: {
	      regionData: _react.PropTypes.object.isRequired
	    },
	    enumerable: true
	  }, {
	    key: 'metadata',
	    value: {
	      title: title
	    },
	    enumerable: true
	  }]);

	  return _default;
	})(_react.Component);

	exports['default'] = _default;
	module.exports = exports['default'];
	/* Start */ /* Theme Song */ /* Mission Report */ /* Esmeralda Opening Story */ /* Game Show */ /* Messages from Mother Earth */ /* Class Activity: Lunch Analysis */ /* Class Activity: Collective Impact Math */ /* Class Activity: Waste-Free Lunch Poster */ /* Mission Assignment is before Es Closing Story because of hack */ /* Esmeralda Closing Story */ /* Finish section in level 4 involves a hack */
	/* WEBPACK VAR INJECTION */}.call(exports, "programs/zeroHeroes/level4.jsx"))

/***/ }),
/* 1096 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(__filename) {'use strict';
	
	var _get = __webpack_require__(8)['default'];
	
	var _inherits = __webpack_require__(5)['default'];
	
	var _createClass = __webpack_require__(6)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _helpersMarkdownScript = __webpack_require__(9);
	
	var _helpersMarkdownScript2 = _interopRequireDefault(_helpersMarkdownScript);
	
	var _indexMd = __webpack_require__(111);
	
	var _indexMd2 = _interopRequireDefault(_indexMd);
	
	var _sections01_startStartSection = __webpack_require__(129);
	
	var _sections01_startStartSection2 = _interopRequireDefault(_sections01_startStartSection);
	
	var _sections03_songSongSection = __webpack_require__(130);
	
	var _sections03_songSongSection2 = _interopRequireDefault(_sections03_songSongSection);
	
	var _sections11_missionReportMissionReportSection = __webpack_require__(172);
	
	var _sections11_missionReportMissionReportSection2 = _interopRequireDefault(_sections11_missionReportMissionReportSection);
	
	var _sections12_esOpeningStoryEsOpeningStorySection = __webpack_require__(131);
	
	var _sections12_esOpeningStoryEsOpeningStorySection2 = _interopRequireDefault(_sections12_esOpeningStoryEsOpeningStorySection);
	
	var _sections20_gameShowGameShowSection = __webpack_require__(102);
	
	var _sections20_gameShowGameShowSection2 = _interopRequireDefault(_sections20_gameShowGameShowSection);
	
	var _sections30_classActivityClassActivitySection = __webpack_require__(132);
	
	var _sections30_classActivityClassActivitySection2 = _interopRequireDefault(_sections30_classActivityClassActivitySection);
	
	var _sections60_esClosingStoryEsClosingStorySection = __webpack_require__(133);
	
	var _sections60_esClosingStoryEsClosingStorySection2 = _interopRequireDefault(_sections60_esClosingStoryEsClosingStorySection);
	
	var _sections70_missionAssignmentMissionAssignmentSection = __webpack_require__(173);
	
	var _sections70_missionAssignmentMissionAssignmentSection2 = _interopRequireDefault(_sections70_missionAssignmentMissionAssignmentSection);
	
	var _sections90_finishFinishSection = __webpack_require__(174);
	
	var _sections90_finishFinishSection2 = _interopRequireDefault(_sections90_finishFinishSection);
	
	var _componentsHacked = __webpack_require__(306);
	
	var _componentsHacked2 = _interopRequireDefault(_componentsHacked);
	
	var md = new _helpersMarkdownScript2['default'](_indexMd2['default']);
	var level = Number(__filename.replace(/^.*level/, '').replace('.jsx', ''));
	var title = md.getSectionMetadata('Level ' + level, 'Title');
	
	var _default = (function (_Component) {
	  _inherits(_default, _Component);
	
	  function _default() {
	    _classCallCheck(this, _default);
	
	    _get(Object.getPrototypeOf(_default.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(_default, [{
	    key: 'render',
	    value: function render() {
	      var regionData = this.context.regionData;
	
	      return _react2['default'].createElement(
	        _spectaclePpa.Deck,
	        { transition: ['slide'],
	          transitionDuration: 800,
	          progress: 'bar' },
	        _react2['default'].createElement(
	          _spectaclePpa.Slide,
	          {
	            id: 'hacked',
	            notes: '<h2>Level ' + level + ' Hacked</h2>',
	            bgColor: 'black',
	            key: 'start',
	            hacked: true },
	          _react2['default'].createElement(_componentsHacked2['default'], null)
	        ),
	        (0, _sections01_startStartSection2['default'])({ level: level, title: title, regionData: regionData }),
	        (0, _sections12_esOpeningStoryEsOpeningStorySection2['default'])({ level: level, regionData: regionData }),
	        (0, _sections11_missionReportMissionReportSection2['default'])({ level: level, regionData: regionData }),
	        (0, _sections03_songSongSection2['default'])({ level: level, regionData: regionData }),
	        (0, _sections20_gameShowGameShowSection2['default'])({ level: level, regionData: regionData }),
	        (0, _sections30_classActivityClassActivitySection2['default'])({ level: level, subActivity: 'a', regionData: regionData }),
	        (0, _sections30_classActivityClassActivitySection2['default'])({ level: level, subActivity: 'b', regionData: regionData }),
	        (0, _sections60_esClosingStoryEsClosingStorySection2['default'])({ level: level, regionData: regionData }),
	        (0, _sections70_missionAssignmentMissionAssignmentSection2['default'])({ level: level, title: title, regionData: regionData }),
	        (0, _sections90_finishFinishSection2['default'])({ level: level, regionData: regionData })
	      );
	    }
	  }], [{
	    key: 'contextTypes',
	    value: {
	      regionData: _react.PropTypes.object.isRequired
	    },
	    enumerable: true
	  }, {
	    key: 'metadata',
	    value: {
	      title: title
	    },
	    enumerable: true
	  }]);

	  return _default;
	})(_react.Component);

	exports['default'] = _default;
	module.exports = exports['default'];
	/* Hacked */ /* Start */ /* Esmeralda Opening Story */ /* Mission Report */ /* Theme Song */ /* Game Show */ /* Class Activity: Buy Smart Code */ /* Class Activity: Skit */ /* Esmeralda Closing Story */ /* Mission Assignment */ /* Finish */
	/* WEBPACK VAR INJECTION */}.call(exports, "programs/zeroHeroes/level5.jsx"))

/***/ }),
/* 1097 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(__filename) {'use strict';
	
	var _get = __webpack_require__(8)['default'];
	
	var _inherits = __webpack_require__(5)['default'];
	
	var _createClass = __webpack_require__(6)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _helpersMarkdownScript = __webpack_require__(9);
	
	var _helpersMarkdownScript2 = _interopRequireDefault(_helpersMarkdownScript);
	
	var _indexMd = __webpack_require__(111);
	
	var _indexMd2 = _interopRequireDefault(_indexMd);
	
	var _sections01_startStartSection = __webpack_require__(129);
	
	var _sections01_startStartSection2 = _interopRequireDefault(_sections01_startStartSection);
	
	var _sections03_songSongSection = __webpack_require__(130);
	
	var _sections03_songSongSection2 = _interopRequireDefault(_sections03_songSongSection);
	
	var _sections11_missionReportMissionReportSection = __webpack_require__(172);
	
	var _sections11_missionReportMissionReportSection2 = _interopRequireDefault(_sections11_missionReportMissionReportSection);
	
	var _sections12_esOpeningStoryEsOpeningStorySection = __webpack_require__(131);
	
	var _sections12_esOpeningStoryEsOpeningStorySection2 = _interopRequireDefault(_sections12_esOpeningStoryEsOpeningStorySection);
	
	var _sections20_gameShowGameShowSection = __webpack_require__(102);
	
	var _sections20_gameShowGameShowSection2 = _interopRequireDefault(_sections20_gameShowGameShowSection);
	
	var _sections13_mmeMmeSection = __webpack_require__(228);
	
	var _sections13_mmeMmeSection2 = _interopRequireDefault(_sections13_mmeMmeSection);
	
	var _sections30_classActivityClassActivitySection = __webpack_require__(132);
	
	var _sections30_classActivityClassActivitySection2 = _interopRequireDefault(_sections30_classActivityClassActivitySection);
	
	var _sections60_esClosingStoryEsClosingStorySection = __webpack_require__(133);
	
	var _sections60_esClosingStoryEsClosingStorySection2 = _interopRequireDefault(_sections60_esClosingStoryEsClosingStorySection);
	
	var _sections95_endingEndingSection = __webpack_require__(1103);
	
	var _sections95_endingEndingSection2 = _interopRequireDefault(_sections95_endingEndingSection);
	
	var _sections90_finishFinishSection = __webpack_require__(174);
	
	var _sections90_finishFinishSection2 = _interopRequireDefault(_sections90_finishFinishSection);
	
	var md = new _helpersMarkdownScript2['default'](_indexMd2['default']);
	var level = Number(__filename.replace(/^.*level/, '').replace('.jsx', ''));
	var title = md.getSectionMetadata('Level ' + level, 'Title');
	
	var _default = (function (_Component) {
	  _inherits(_default, _Component);
	
	  function _default() {
	    _classCallCheck(this, _default);
	
	    _get(Object.getPrototypeOf(_default.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(_default, [{
	    key: 'render',
	    value: function render() {
	      var regionData = this.context.regionData;
	
	      return _react2['default'].createElement(
	        _spectaclePpa.Deck,
	        { transition: ['slide'],
	          transitionDuration: 800,
	          progress: 'bar' },
	        (0, _sections01_startStartSection2['default'])({ level: level, title: title, regionData: regionData }),
	        (0, _sections03_songSongSection2['default'])({ level: level, regionData: regionData }),
	        (0, _sections11_missionReportMissionReportSection2['default'])({ level: level, regionData: regionData }),
	        (0, _sections12_esOpeningStoryEsOpeningStorySection2['default'])({ level: level, regionData: regionData }),
	        (0, _sections20_gameShowGameShowSection2['default'])({ level: level, regionData: regionData }),
	        (0, _sections13_mmeMmeSection2['default'])({ level: level, regionData: regionData }),
	        (0, _sections30_classActivityClassActivitySection2['default'])({ level: level, regionData: regionData }),
	        (0, _sections60_esClosingStoryEsClosingStorySection2['default'])({ level: level, regionData: regionData }),
	        (0, _sections95_endingEndingSection2['default'])({ regionData: regionData }),
	        (0, _sections90_finishFinishSection2['default'])({ level: level, regionData: regionData })
	      );
	    }
	  }], [{
	    key: 'contextTypes',
	    value: {
	      regionData: _react.PropTypes.object.isRequired
	    },
	    enumerable: true
	  }, {
	    key: 'metadata',
	    value: {
	      title: title
	    },
	    enumerable: true
	  }]);

	  return _default;
	})(_react.Component);

	exports['default'] = _default;
	module.exports = exports['default'];
	/* Start */ /* Theme Song */ /* Mission Report */ /* Esmeralda Opening Story */ /* Game Show */ /* Messages from Mother Earth */ /* Class Activity: Biomimicry */ /* Esmeralda Closing Story */ /* Ending */ /* Finish */
	/* WEBPACK VAR INJECTION */}.call(exports, "programs/zeroHeroes/level6.jsx"))

/***/ }),
/* 1098 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _get = __webpack_require__(8)['default'];
	
	var _inherits = __webpack_require__(5)['default'];
	
	var _createClass = __webpack_require__(6)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _baseSlidesBalloonSlide = __webpack_require__(71);
	
	var _baseSlidesBalloonSlide2 = _interopRequireDefault(_baseSlidesBalloonSlide);
	
	var _imagesCharactersSara_gigglePng = __webpack_require__(2497);
	
	var _imagesCharactersSara_gigglePng2 = _interopRequireDefault(_imagesCharactersSara_gigglePng);
	
	var _helpersMarkdownScript = __webpack_require__(9);
	
	var _helpersMarkdownScript2 = _interopRequireDefault(_helpersMarkdownScript);
	
	var _levelCompletedMd = __webpack_require__(1818);
	
	var _levelCompletedMd2 = _interopRequireDefault(_levelCompletedMd);
	
	var md = new _helpersMarkdownScript2['default'](_levelCompletedMd2['default']);
	
	var _default = (function (_Component) {
	  _inherits(_default, _Component);
	
	  function _default() {
	    _classCallCheck(this, _default);
	
	    _get(Object.getPrototypeOf(_default.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(_default, [{
	    key: 'render',
	    value: function render() {
	      var regionData = this.context.regionData;
	
	      return _react2['default'].createElement(
	        _spectaclePpa.Deck,
	        { transition: ['slide'],
	          transitionDuration: 800,
	          progress: 'bar' },
	        (0, _baseSlidesBalloonSlide2['default'])({
	          id: 'welcome-back',
	          characterSide: 'right',
	          characterImage: _imagesCharactersSara_gigglePng2['default'],
	          notes: md.getSubSectionAsHtml('Level Completed', 'Notes', false, regionData),
	          html: md.getSubSectionAsHtml('Level Completed', 'Content', false, regionData),
	          bgColor: '#37b34a'
	        })
	      );
	    }
	  }], [{
	    key: 'contextTypes',
	    value: {
	      regionData: _react.PropTypes.object.isRequired
	    },
	    enumerable: true
	  }]);

	  return _default;
	})(_react.Component);

	exports['default'] = _default;
	module.exports = exports['default'];

/***/ }),
/* 1099 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _get = __webpack_require__(8)['default'];
	
	var _inherits = __webpack_require__(5)['default'];
	
	var _createClass = __webpack_require__(6)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _componentsStartLevel = __webpack_require__(79);
	
	var _componentsStartLevel2 = _interopRequireDefault(_componentsStartLevel);
	
	var _sections00_prepPrepSection = __webpack_require__(1100);
	
	var _sections00_prepPrepSection2 = _interopRequireDefault(_sections00_prepPrepSection);
	
	var _default = (function (_Component) {
	  _inherits(_default, _Component);
	
	  function _default() {
	    _classCallCheck(this, _default);
	
	    _get(Object.getPrototypeOf(_default.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(_default, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var level = _props.nextLevel;
	      var configuration = _props.configuration;
	      var regionData = this.context.regionData;
	
	      return _react2['default'].createElement(
	        _spectaclePpa.Deck,
	        { transition: ['slide'],
	          transitionDuration: 800,
	          progress: 'bar' },
	        (0, _sections00_prepPrepSection2['default'])({ level: level, configuration: configuration, regionData: regionData }),
	        _react2['default'].createElement(
	          _spectaclePpa.Slide,
	          {
	            id: 'start',
	            textColor: 'white' },
	          _react2['default'].createElement(_componentsStartLevel2['default'], null)
	        )
	      );
	    }
	  }], [{
	    key: 'propTypes',
	    value: {
	      nextLevel: _react.PropTypes.string.isRequired,
	      configuration: _react.PropTypes.string
	    },
	    enumerable: true
	  }, {
	    key: 'contextTypes',
	    value: {
	      regionData: _react.PropTypes.object.isRequired
	    },
	    enumerable: true
	  }]);

	  return _default;
	})(_react.Component);

	exports['default'] = _default;
	module.exports = exports['default'];
	/* Prep */

/***/ }),
/* 1100 */
/***/ (function(module, exports, __webpack_require__) {

	/* eslint react/no-multi-comp: 0 */
	
	'use strict';
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _componentsSelectConfiguration = __webpack_require__(77);
	
	var _componentsSelectConfiguration2 = _interopRequireDefault(_componentsSelectConfiguration);
	
	var _componentsSelectDeviceRole = __webpack_require__(78);
	
	var _componentsSelectDeviceRole2 = _interopRequireDefault(_componentsSelectDeviceRole);
	
	var _baseSlidesHtmlSlide = __webpack_require__(1089);
	
	var _baseSlidesHtmlSlide2 = _interopRequireDefault(_baseSlidesHtmlSlide);
	
	var _baseSlidesHeadingSlide = __webpack_require__(171);
	
	var _baseSlidesHeadingSlide2 = _interopRequireDefault(_baseSlidesHeadingSlide);
	
	var _baseSlidesVideoSlide = __webpack_require__(43);
	
	var _baseSlidesVideoSlide2 = _interopRequireDefault(_baseSlidesVideoSlide);
	
	var _helpersMarkdownScript = __webpack_require__(9);
	
	var _helpersMarkdownScript2 = _interopRequireDefault(_helpersMarkdownScript);
	
	var _tech_prepMd = __webpack_require__(1826);
	
	var _tech_prepMd2 = _interopRequireDefault(_tech_prepMd);
	
	var techPrepMd = new _helpersMarkdownScript2['default'](_tech_prepMd2['default']);
	
	function techPrepWizard(_ref) {
	  var regionData = _ref.regionData;
	
	  return (0, _baseSlidesHtmlSlide2['default'])({
	    id: 'tech-prep-wizard',
	    html: techPrepMd.getSectionAsHtml('Tech Prep Wizard', false, regionData)
	  });
	}
	
	function twoDeviceIntro(_ref2) {
	  var regionData = _ref2.regionData;
	
	  return (0, _baseSlidesHtmlSlide2['default'])({
	    id: 'two-device-intro',
	    html: techPrepMd.getSectionAsHtml('Two Device Intro', false, regionData)
	  });
	}
	
	function selectConfiguration() {
	  return _react2['default'].createElement(
	    _spectaclePpa.Slide,
	    {
	      id: 'configuration',
	      textColor: 'white' },
	    _react2['default'].createElement(_componentsSelectConfiguration2['default'], null)
	  );
	}
	
	function connectingRemote(_ref3) {
	  var configuration = _ref3.configuration;
	  var regionData = _ref3.regionData;
	
	  if (configuration === 'dualScreen') {
	    return (0, _baseSlidesHtmlSlide2['default'])({
	      id: 'connecting-remote',
	      html: techPrepMd.getSectionAsHtml('Connecting Remote', false, regionData)
	    });
	  } else {
	    return null;
	  }
	}
	
	function selectDeviceRole(configuration) {
	  if (configuration === 'dualScreen') {
	    return _react2['default'].createElement(
	      _spectaclePpa.Slide,
	      {
	        id: 'device-role',
	        textColor: 'white' },
	      _react2['default'].createElement(_componentsSelectDeviceRole2['default'], null)
	    );
	  } else {
	    return null;
	  }
	}
	
	function techCheckIntro(_ref4) {
	  var regionData = _ref4.regionData;
	
	  return (0, _baseSlidesHtmlSlide2['default'])({
	    id: 'tech-check-intro',
	    html: techPrepMd.getSectionAsHtml('Tech Check Intro', false, regionData)
	  });
	}
	
	function techCheckVideo(_ref5) {
	  var regionData = _ref5.regionData;
	
	  return (0, _baseSlidesVideoSlide2['default'])({
	    id: 'tech-check-video',
	    youTubeId: techPrepMd.getSectionMetadata('Tech Check Video', 'YouTube', regionData)
	  });
	}
	
	function levelPrep(_ref6) {
	  var configuration = _ref6.configuration;
	  var regionData = _ref6.regionData;
	
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'prep' },
	    techPrepWizard({ regionData: regionData }),
	    twoDeviceIntro({ regionData: regionData }),
	    selectConfiguration(),
	    connectingRemote({ configuration: configuration, regionData: regionData }),
	    selectDeviceRole(configuration),
	    techCheckIntro({ regionData: regionData }),
	    techCheckVideo({ regionData: regionData })
	  );
	}
	
	function levelCompletedPrep(_ref7) {
	  var configuration = _ref7.configuration;
	  var regionData = _ref7.regionData;
	
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'prep' },
	    selectConfiguration(),
	    connectingRemote({ configuration: configuration, regionData: regionData }),
	    selectDeviceRole(configuration)
	  );
	}
	
	function prepSection(_ref8) {
	  var level = _ref8.level;
	  var configuration = _ref8.configuration;
	  var regionData = _ref8.regionData;
	
	  switch (level) {
	    case '1':
	      return levelPrep({ configuration: configuration, regionData: regionData });
	    case '2':
	      return levelPrep({ configuration: configuration, regionData: regionData });
	    case '3':
	      return levelPrep({ configuration: configuration, regionData: regionData });
	    case '4':
	      return levelPrep({ configuration: configuration, regionData: regionData });
	    case '5':
	      return levelPrep({ configuration: configuration, regionData: regionData });
	    case '6':
	      return levelPrep({ configuration: configuration, regionData: regionData });
	    case 'completed':
	      return levelCompletedPrep({ configuration: configuration, regionData: regionData });
	    default:
	      return (0, _baseSlidesHeadingSlide2['default'])({ heading: 'Unknown' });
	  }
	}
	
	exports['default'] = prepSection;
	module.exports = exports['default'];
	/* Tech Prep Wizard */ /* Two Device Intro */ /* Select Configuration */ /* Connecting Remote Instructions */ /* Select Device Role */ /* Tech Check Intro */ /* Tech Check Video */ /* Start Level */ /* Select Configuration */ /* Connecting Remote */ /* Select Device Role */

/***/ }),
/* 1101 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.preloadGameShow = preloadGameShow;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _componentsTeamNames = __webpack_require__(60);
	
	var _componentsTeamNames2 = _interopRequireDefault(_componentsTeamNames);
	
	var _baseSlidesVideoSlide = __webpack_require__(43);
	
	var _baseSlidesVideoSlide2 = _interopRequireDefault(_baseSlidesVideoSlide);
	
	var _baseSlidesBalloonSlide = __webpack_require__(71);
	
	var _baseSlidesBalloonSlide2 = _interopRequireDefault(_baseSlidesBalloonSlide);
	
	var _helpersMarkdownScript = __webpack_require__(9);
	
	var _helpersMarkdownScript2 = _interopRequireDefault(_helpersMarkdownScript);
	
	var _teamCreationMd = __webpack_require__(1829);
	
	var _teamCreationMd2 = _interopRequireDefault(_teamCreationMd);
	
	var _imagesCharactersApprenticesRowArmsFoldedPng = __webpack_require__(2486);
	
	var _imagesCharactersApprenticesRowArmsFoldedPng2 = _interopRequireDefault(_imagesCharactersApprenticesRowArmsFoldedPng);
	
	var _imagesCharactersApprenticeHandsHipsPng = __webpack_require__(2478);
	
	var _imagesCharactersApprenticeHandsHipsPng2 = _interopRequireDefault(_imagesCharactersApprenticeHandsHipsPng);
	
	var _imagesCharactersApprenticeArmsFoldedPng = __webpack_require__(2474);
	
	var _imagesCharactersApprenticeArmsFoldedPng2 = _interopRequireDefault(_imagesCharactersApprenticeArmsFoldedPng);
	
	var _imagesCharactersApprenticePointingDiagonalPng = __webpack_require__(906);
	
	var _imagesCharactersApprenticePointingDiagonalPng2 = _interopRequireDefault(_imagesCharactersApprenticePointingDiagonalPng);
	
	var md = new _helpersMarkdownScript2['default'](_teamCreationMd2['default']);
	
	function preloadGameShow() {
	  (0, _spectaclePpa.preloader)([_imagesCharactersApprenticesRowArmsFoldedPng2['default'], _imagesCharactersApprenticeHandsHipsPng2['default'], _imagesCharactersApprenticeArmsFoldedPng2['default'], apprenticePointingUp]);
	}
	
	function teamCreationSection(_ref) {
	  var regionData = _ref.regionData;
	
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'team-creation' },
	    (0, _baseSlidesVideoSlide2['default'])({
	      id: 'intro',
	      notes: md.getSubSectionAsHtml('Intro Video', 'Notes', false, regionData),
	      youTubeId: md.getSectionMetadata('Intro Video', 'YouTube', regionData)
	    }),
	    (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'get-into-teams',
	      characterSide: 'right',
	      characterImage: _imagesCharactersApprenticeArmsFoldedPng2['default'],
	      notes: md.getSubSectionAsHtml('Get Into Teams', 'Notes', false, regionData),
	      html: md.getSubSectionAsHtml('Get Into Teams', 'Content', false, regionData)
	    }),
	    _react2['default'].createElement(
	      _spectaclePpa.Slide,
	      {
	        id: 'assign',
	        bgColor: 'black',
	        notes: '<h2>Assign Team Names</h2>',
	        teamNames: true },
	      _react2['default'].createElement(
	        'div',
	        { className: 'ui-slide' },
	        _react2['default'].createElement(
	          _spectaclePpa.Heading,
	          { size: 1 },
	          'Name your teams!'
	        ),
	        _react2['default'].createElement(_componentsTeamNames2['default'], null)
	      )
	    ),
	    (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'scoring-intro',
	      characterSide: 'right',
	      characterImage: _imagesCharactersApprenticeHandsHipsPng2['default'],
	      notes: md.getSubSectionAsHtml('Scoring Intro', 'Notes', false, regionData),
	      html: md.getSubSectionAsHtml('Scoring Intro', 'Content', false, regionData)
	    }),
	    (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'scoreboard-intro',
	      characterSide: 'right',
	      characterImage: _imagesCharactersApprenticePointingDiagonalPng2['default'],
	      notes: md.getSubSectionAsHtml('Scoreboard Intro', 'Notes', false, regionData),
	      html: md.getSubSectionAsHtml('Scoreboard Intro', 'Content', false, regionData)
	    }),
	    (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'id-cards',
	      characterSide: 'left',
	      characterImage: _imagesCharactersApprenticesRowArmsFoldedPng2['default'],
	      notes: md.getSubSectionAsHtml('ID Cards', 'Notes', false, regionData),
	      html: md.getSubSectionAsHtml('ID Cards', 'Content', false, regionData)
	    })
	  );
	}
	
	exports['default'] = teamCreationSection;
	/* Sara and Ian talk about teams and team names */ /* Get into teams and come up with a cool name */ /* Enter team names */ /* Scoring intro */ /* Introduce scoreboard */ /* ID cards draw your avatar */

/***/ }),
/* 1102 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _componentsHacked = __webpack_require__(306);
	
	var _componentsHacked2 = _interopRequireDefault(_componentsHacked);
	
	function finishHackedSection(_ref) {
	  var level = _ref.level;
	
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'finish' },
	    _react2['default'].createElement(
	      _spectaclePpa.Slide,
	      {
	        id: 'hacked',
	        notes: '<h2>Level ' + level + ' Finished</h2>',
	        bgColor: 'black',
	        hacked: 'cliffHanger',
	        finish: true },
	      _react2['default'].createElement(_componentsHacked2['default'], { cliffHanger: true })
	    )
	  );
	}
	
	exports['default'] = finishHackedSection;
	module.exports = exports['default'];
	/* Level complete */

/***/ }),
/* 1103 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.preloadEnding = preloadEnding;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spectaclePpa = __webpack_require__(4);
	
	var _baseSlidesVideoSlide = __webpack_require__(43);
	
	var _baseSlidesVideoSlide2 = _interopRequireDefault(_baseSlidesVideoSlide);
	
	var _baseSlidesBalloonSlide = __webpack_require__(71);
	
	var _baseSlidesBalloonSlide2 = _interopRequireDefault(_baseSlidesBalloonSlide);
	
	var _baseSlidesHeadingSlide = __webpack_require__(171);
	
	var _baseSlidesHeadingSlide2 = _interopRequireDefault(_baseSlidesHeadingSlide);
	
	var _imagesLogo_ppaPng = __webpack_require__(912);
	
	var _imagesLogo_ppaPng2 = _interopRequireDefault(_imagesLogo_ppaPng);
	
	var _imagesCharactersEsmeralda_goober_goofy_smilePng = __webpack_require__(445);
	
	var _imagesCharactersEsmeralda_goober_goofy_smilePng2 = _interopRequireDefault(_imagesCharactersEsmeralda_goober_goofy_smilePng);
	
	var _imagesCharactersIan_sara_sillyPng = __webpack_require__(2494);
	
	var _imagesCharactersIan_sara_sillyPng2 = _interopRequireDefault(_imagesCharactersIan_sara_sillyPng);
	
	var _imagesCharactersEsmeralda_goober_proudPng = __webpack_require__(446);
	
	var _imagesCharactersEsmeralda_goober_proudPng2 = _interopRequireDefault(_imagesCharactersEsmeralda_goober_proudPng);
	
	var _helpersMarkdownScript = __webpack_require__(9);
	
	var _helpersMarkdownScript2 = _interopRequireDefault(_helpersMarkdownScript);
	
	var _endingMd = __webpack_require__(1872);
	
	var _endingMd2 = _interopRequireDefault(_endingMd);
	
	var md = new _helpersMarkdownScript2['default'](_endingMd2['default']);
	
	function preloadEnding() {
	  (0, _spectaclePpa.preloader)([_imagesCharactersEsmeralda_goober_goofy_smilePng2['default'], _imagesCharactersIan_sara_sillyPng2['default'], _imagesCharactersEsmeralda_goober_proudPng2['default'], _imagesLogo_ppaPng2['default']]);
	}
	
	function endingSection(_ref) {
	  var regionData = _ref.regionData;
	
	  return _react2['default'].createElement(
	    _spectaclePpa.Section,
	    { id: 'ending' },
	    (0, _baseSlidesVideoSlide2['default'])({
	      id: 'ian-sara-goodbye',
	      youTubeId: md.getSectionMetadata('Ian and Sara Goodbye', 'YouTube', regionData),
	      notes: md.getSubSectionAsHtml('Ian and Sara Goodbye', 'Notes', false, regionData)
	    }),
	    (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'announce-winners',
	      characterSide: 'right',
	      characterImage: _imagesCharactersIan_sara_sillyPng2['default'],
	      html: md.getSubSectionAsHtml('Announce Winners', 'Content', false, regionData),
	      notes: md.getSubSectionAsHtml('Announce Winners', 'Notes', false, regionData)
	    }),
	    (0, _baseSlidesBalloonSlide2['default'])({
	      id: 'planet-protectors',
	      characterSide: 'left',
	      characterImage: _imagesCharactersEsmeralda_goober_proudPng2['default'],
	      html: md.getSubSectionAsHtml('Planet Protectors', 'Content', false, regionData),
	      notes: md.getSubSectionAsHtml('Planet Protectors', 'Notes', false, regionData)
	    }),
	    (0, _baseSlidesHeadingSlide2['default'])({
	      id: 'completed',
	      beforeImage: _imagesLogo_ppaPng2['default'],
	      heading: 'Zero Heroes',
	      subHeading: 'All levels completed!!!',
	      notes: md.getSubSectionAsHtml('All Levels Completed', 'Notes', false, regionData),
	      bgColor: 'black'
	    })
	  );
	}
	
	exports['default'] = endingSection;
	/* Ian and Sara Goodbye */ /* Time to see who won! */ /* You're now all Planet Protectors */ /* You've completed all the levels */

/***/ }),
/* 1104 */
/***/ (function(module, exports) {

	/* eslint-disable object-shorthand */
	'use strict';
	
	var colors = {
	  primary: '#37bad5',
	  secondary: 'black',
	  tertiary: 'white',
	  level1: '#ffbc00',
	  level2: '#8f288c',
	  level3: '#26a7df',
	  level4: '#e80a89',
	  level5: '#f59122',
	  level6: '#37b34a',
	  gameshow: '#742CBF',
	  question: '#45B3EC',
	  answer: '#6FC36E'
	};
	
	var fonts = {
	  primary: 'BrandonTextWeb',
	  secondary: 'Orbitron',
	  tertiary: 'Ubuntu'
	};
	
	module.exports = {
	  colors: colors,
	  fonts: fonts,
	  global: {
	    body: {
	      background: 'transparent',
	      fontFamily: fonts.primary,
	      fontWeight: 'normal',
	      fontSize: '2em',
	      color: colors.primary,
	      overflow: 'hidden'
	    },
	    'html, body': {
	      // height: '100%'
	    },
	    '*': {
	      boxSizing: 'border-box'
	    },
	    input: {
	      color: 'black',
	      fontWeight: 'bold',
	      backgroundColor: 'white',
	      fontSize: '2.66em',
	      fontFamily: fonts.primary,
	      padding: '0.25em 0.25em 0.2em',
	      margin: '1% 1% 3%',
	      width: '98%'
	    },
	    label: {
	      color: 'white',
	      fontWeight: 'bold',
	      fontSize: '1.8em',
	      margin: '0.1em 0 0'
	    }
	  },
	  progress: {
	    bar: {
	      container: {
	        position: 'absolute',
	        height: '22px',
	        width: '100%',
	        bottom: 0,
	        left: 0,
	        transition: 'all 1s ease-in-out 0.2s',
	        zIndex: 1000
	      },
	      bar: {
	        height: '100%',
	        background: colors.primary,
	        transition: 'all 0.3s ease-out',
	        fontSize: '12px',
	        letterSpacing: '0.1em',
	        textTransform: 'uppercase',
	        padding: '4px',
	        textAlign: 'right'
	      }
	    },
	    number: {
	      container: {
	        position: 'absolute',
	        bottom: 10,
	        right: 10,
	        zIndex: 1000,
	        color: colors.tertiary
	      }
	    }
	  },
	  components: {
	    codePane: {
	      pre: {
	        margin: 'auto',
	        fontSize: '1em',
	        fontWeight: 'normal',
	        fontFamily: fonts.tertiary,
	        minWidth: '100%',
	        maxWidth: 800
	      },
	      code: {
	        textAlign: 'left',
	        padding: 20,
	        fontWeight: 'normal'
	      }
	    },
	    code: {
	      color: 'black',
	      fontSize: '2.66em',
	      fontFamily: fonts.tertiary,
	      margin: '0.25em auto',
	      backgroundColor: 'rgba(0,0,0,0.15)',
	      padding: '0 10px',
	      borderRadius: 3
	    },
	    heading: {},
	    link: {
	      textDecoration: 'none'
	    },
	    listItem: {
	      fontSize: '2.66em',
	      padding: '0 0 0.5em'
	    },
	    list: {
	      textAlign: 'center',
	      listStyle: 'none',
	      padding: '0.5em 0'
	    },
	    s: {
	      strikethrough: {}
	    },
	    text: {
	      color: 'black',
	      fontSize: '2.66em',
	      fontFamily: fonts.primary,
	      margin: '0.25em auto',
	      textShadow: '0 0 10px rgba(0,0,0,0.2)'
	    }
	  }
	};

/***/ }),
/* 1105 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.setVideoState = setVideoState;
	
	var _servicesEvents = __webpack_require__(73);
	
	var SET_ONBOARDING_VIDEO_STATE = 'SET_ONBOARDING_VIDEO_STATE';
	
	exports.SET_ONBOARDING_VIDEO_STATE = SET_ONBOARDING_VIDEO_STATE;
	
	function setVideoState(_ref) {
	  var state = _ref.state;
	  var prevState = _ref.prevState;
	  var userId = _ref.userId;
	
	  return function (dispatch) {
	    dispatch({ type: SET_ONBOARDING_VIDEO_STATE, payload: state });
	    if (state === "playing" && prevState === "unstarted") {
	      (0, _servicesEvents.publishEvent)('onboarding video played', { userId: userId });
	    }
	  };
	}

/***/ }),
/* 1106 */
/***/ (function(module, exports) {

	// Delay for Onboarding when there's transitions (i.e. opening/expanding/closing the hud) (in milliseconds)
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var OnboardingDelayWithTransitions = 1800;
	exports.OnboardingDelayWithTransitions = OnboardingDelayWithTransitions;
	// Delay for Onboarding when there's no transitions
	var OnboardingDelayWithoutTransitions = 500;
	exports.OnboardingDelayWithoutTransitions = OnboardingDelayWithoutTransitions;

/***/ }),
/* 1107 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _Promise = __webpack_require__(33)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(20);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _root = __webpack_require__(1118);
	
	var _root2 = _interopRequireDefault(_root);
	
	var _store = __webpack_require__(1124);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _routerHistory = __webpack_require__(229);
	
	var _routerHistory2 = _interopRequireDefault(_routerHistory);
	
	var _servicesFirebaseRef = __webpack_require__(74);
	
	var _actionsAuthActions = __webpack_require__(37);
	
	__webpack_require__(952);
	
	var target = document.getElementById('root');
	var store = (0, _store2['default'])(window.__INITIAL_STATE__);
	
	var unsubscribe = undefined;
	
	function loginAndRenderPage(authData) {
	  unsubscribe();
	  var promise = _Promise.resolve();
	  if (authData) {
	    promise = promise.then(function () {
	      return store.dispatch((0, _actionsAuthActions.loginWithAuthData)({ authData: authData }));
	    })['catch'](function (err) {
	      console.error('Error authenticating with existing user. Forcing signing out.', err);
	      _servicesFirebaseRef.authRef.signOut();
	    });
	  }
	  promise.then(function () {
	    return _reactDom2['default'].render(_react2['default'].createElement(_root2['default'], { routerHistory: _routerHistory2['default'], store: store }), target);
	  });
	}
	unsubscribe = _servicesFirebaseRef.authRef.onAuthStateChanged(loginAndRenderPage, function () {
	  return loginAndRenderPage();
	});

/***/ }),
/* 1108 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = auth;
	
	var _actionsActiveSessionActions = __webpack_require__(472);
	
	var _actionsAuthActions = __webpack_require__(37);
	
	var initialState = '';
	
	function auth(state, action) {
	  if (state === undefined) state = initialState;
	
	  switch (action.type) {
	    case _actionsActiveSessionActions.ACTIVE_SESSION_LOADED:
	      return action.activeSession;
	    case _actionsAuthActions.LOGOUT:
	      return initialState;
	    default:
	      return state;
	  }
	}
	
	module.exports = exports['default'];

/***/ }),
/* 1109 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = __webpack_require__(7)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = auth;
	
	var _actionsAuthActions = __webpack_require__(37);
	
	var initialState = {
	  loggedIn: false,
	  authData: null,
	  passwordResetSent: false,
	  tempPassword: null
	};
	
	function auth(state, action) {
	  if (state === undefined) state = initialState;
	  var authData = action.authData;
	  var tempPassword = action.tempPassword;
	
	  switch (action.type) {
	    case _actionsAuthActions.LOGIN:
	      return _extends({}, state, {
	        loggedIn: true,
	        authData: authData
	      });
	    case _actionsAuthActions.LOGOUT:
	      return _extends({}, initialState);
	    case _actionsAuthActions.SET_TEMP_PASSWORD:
	      return _extends({}, state, {
	        tempPassword: tempPassword
	      });
	    case _actionsAuthActions.CLEAR_TEMP_PASSWORD:
	      return _extends({}, state, {
	        tempPassword: null
	      });
	    case _actionsAuthActions.PASSWORD_RESET_INIT:
	      return _extends({}, state, {
	        passwordResetSent: false
	      });
	    case _actionsAuthActions.PASSWORD_RESET_SENT:
	      return _extends({}, state, {
	        passwordResetSent: true
	      });
	    default:
	      return state;
	  }
	}
	
	module.exports = exports['default'];

/***/ }),
/* 1110 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = __webpack_require__(7)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = deck;
	
	var _actionsDeckActions = __webpack_require__(473);
	
	var _actionsAuthActions = __webpack_require__(37);
	
	var initialState = {
	  displayHUD: false,
	  deviceRole: localStorage.getItem('deviceRole')
	};
	
	function deck(state, action) {
	  if (state === undefined) state = initialState;
	
	  switch (action.type) {
	    case _actionsDeckActions.SHOW_HUD:
	      return _extends({}, state, {
	        displayHUD: true
	      });
	    case _actionsDeckActions.HIDE_HUD:
	      return _extends({}, state, {
	        displayHUD: false
	      });
	    case _actionsDeckActions.REGISTER_HUD_REF:
	      var refs = state.refs || {};
	      refs[action.name] = action.ref;
	      return _extends({}, state, { refs: refs });
	    case _actionsDeckActions.DECK_SET_DEVICE_ROLE:
	      var role = action.role;
	
	      return _extends({}, state, {
	        deviceRole: role
	      });
	    case _actionsAuthActions.LOGOUT:
	      return _extends({}, initialState);
	    default:
	      return state;
	  }
	}
	
	module.exports = exports['default'];

/***/ }),
/* 1111 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _redux = __webpack_require__(99);
	
	var _reduxForm = __webpack_require__(36);
	
	var _reducersAuthReducer = __webpack_require__(1109);
	
	var _reducersAuthReducer2 = _interopRequireDefault(_reducersAuthReducer);
	
	var _reducersSessionsReducer = __webpack_require__(1115);
	
	var _reducersSessionsReducer2 = _interopRequireDefault(_reducersSessionsReducer);
	
	var _reducersProfileReducer = __webpack_require__(1114);
	
	var _reducersProfileReducer2 = _interopRequireDefault(_reducersProfileReducer);
	
	var _reducersDeckReducer = __webpack_require__(1110);
	
	var _reducersDeckReducer2 = _interopRequireDefault(_reducersDeckReducer);
	
	var _reducersActiveSessionReducer = __webpack_require__(1108);
	
	var _reducersActiveSessionReducer2 = _interopRequireDefault(_reducersActiveSessionReducer);
	
	var _reducersPaywallReducer = __webpack_require__(1113);
	
	var _reducersPaywallReducer2 = _interopRequireDefault(_reducersPaywallReducer);
	
	var _reducersUserReferralReducer = __webpack_require__(1117);
	
	var _reducersUserReferralReducer2 = _interopRequireDefault(_reducersUserReferralReducer);
	
	var _utilsValidateNormalize = __webpack_require__(75);
	
	var _viewsDashboardValidateClass = __webpack_require__(476);
	
	var _reducersOnboardingVideo = __webpack_require__(1112);
	
	var _reducersOnboardingVideo2 = _interopRequireDefault(_reducersOnboardingVideo);
	
	var _reducersUnsubscribe = __webpack_require__(1116);
	
	var _reducersUnsubscribe2 = _interopRequireDefault(_reducersUnsubscribe);
	
	exports['default'] = (0, _redux.combineReducers)({
	  form: _reduxForm.reducer.normalize({
	    register: _utilsValidateNormalize.normalizeRegisterForm,
	    addEditClass: _viewsDashboardValidateClass.normalizeClass
	  }),
	  auth: _reducersAuthReducer2['default'],
	  sessions: _reducersSessionsReducer2['default'],
	  profile: _reducersProfileReducer2['default'],
	  deck: _reducersDeckReducer2['default'],
	  activeSession: _reducersActiveSessionReducer2['default'],
	  paywall: _reducersPaywallReducer2['default'],
	  userReferral: _reducersUserReferralReducer2['default'],
	  onboardingVideo: _reducersOnboardingVideo2['default'],
	  unsubscribe: _reducersUnsubscribe2['default']
	});
	module.exports = exports['default'];

/***/ }),
/* 1112 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _extends = __webpack_require__(7)["default"];
	
	var _Object$freeze = __webpack_require__(308)["default"];
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = reducer;
	
	var _actionsOnboardingVideo = __webpack_require__(1105);
	
	var defaultState = _Object$freeze({
	  state: 'unstarted'
	});
	
	function reducer(state, action) {
	  if (state === undefined) state = defaultState;
	
	  switch (action.type) {
	    case _actionsOnboardingVideo.SET_ONBOARDING_VIDEO_STATE:
	      {
	        return _extends({}, state, { state: action.payload });
	      }
	    default:
	      return state;
	  }
	}
	
	module.exports = exports["default"];

/***/ }),
/* 1113 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = __webpack_require__(7)['default'];
	
	var _defineProperty = __webpack_require__(105)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = auth;
	
	var _actionsPaywallActions = __webpack_require__(134);
	
	var _actionsAuthActions = __webpack_require__(37);
	
	var initialState = {
	  onHoldSessions: {},
	  unapprovedSessions: {},
	  profiles: {},
	  userFound: null,
	  sessionFound: null,
	  error: ''
	};
	
	function auth(state, action) {
	  if (state === undefined) state = initialState;
	  var sessions = action.sessions;
	
	  switch (action.type) {
	    case _actionsPaywallActions.PAYWALL_USER_FOUND:
	      return _extends({}, state, {
	        userFound: action.user || null,
	        sessionFound: null,
	        error: ''
	      });
	    case _actionsPaywallActions.PAYWALL_SESSION_FOUND:
	      {
	        var session = action.session;
	        var user = action.user;
	
	        return _extends({}, state, {
	          sessionFound: session && user ? {
	            session: session,
	            user: user
	          } : null,
	          userFound: null,
	          error: ''
	        });
	      }
	    case _actionsPaywallActions.UNAPPROVED_SESSIONS:
	      return _extends({}, state, {
	        unapprovedSessions: sessions
	      });
	    case _actionsPaywallActions.PAYWALL_ONHOLD_SESSIONS:
	      return _extends({}, state, {
	        onHoldSessions: sessions
	      });
	    case _actionsPaywallActions.PAYWALL_PROFILE_LOADED:
	      {
	        var profiles = state.profiles;
	        var userId = action.userId;
	        var profileData = action.profileData;
	
	        var userFound = null;
	        if (state.userFound && state.userFound.userId === userId) {
	          userFound = _extends({}, state.userFound, {
	            profile: _extends({}, profileData)
	          });
	        }
	        return _extends({}, state, {
	          profiles: _extends({}, profiles, _defineProperty({}, userId, profileData))
	        }, userFound ? { userFound: userFound } : {});
	      }
	    /*
	    case PAYWALL_USER_DELETED: {
	      const {profiles} = state;
	      const {userId} = action;
	      const {[userId]: profileRemoved, restOfProfiles} = profiles;
	      return {
	        ...state,
	        profiles: restOfProfiles
	      };
	    }
	    */
	    case _actionsPaywallActions.PAYWALL_USER_TOGGLE_TESTER:
	      {
	        var userId = action.userId;
	        var tester = action.tester;
	        var profiles = state.profiles;
	        var userFound = state.userFound;
	
	        var profileData = profiles[userId];
	        return _extends({}, state, {
	          userFound: userFound ? _extends({}, userFound, { profile: _extends({}, userFound.profile, { tester: tester }) }) : null,
	          profiles: _extends({}, profiles, _defineProperty({}, userId, _extends({}, profileData, { tester: tester })))
	        });
	      }
	    case _actionsPaywallActions.PAYWALL_ERROR:
	      {
	        var message = action.message;
	
	        return _extends({}, state, {
	          error: message
	        });
	      }
	    case _actionsAuthActions.LOGOUT:
	      return _extends({}, initialState);
	    default:
	      return state;
	  }
	}
	
	module.exports = exports['default'];

/***/ }),
/* 1114 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = __webpack_require__(7)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = auth;
	
	var _actionsProfileActions = __webpack_require__(103);
	
	var _actionsAuthActions = __webpack_require__(37);
	
	var initialState = {};
	
	function auth(state, action) {
	  if (state === undefined) state = initialState;
	  var profileData = action.profileData;
	
	  switch (action.type) {
	    case _actionsProfileActions.PROFILE_LOADED:
	      return _extends({}, profileData);
	    case _actionsProfileActions.PROFILE_LOAD_ERROR:
	      return {};
	    case _actionsAuthActions.LOGOUT:
	      return _extends({}, initialState);
	    default:
	      return state;
	  }
	}
	
	module.exports = exports['default'];

/***/ }),
/* 1115 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = __webpack_require__(7)['default'];
	
	var _defineProperty = __webpack_require__(105)['default'];
	
	var _toConsumableArray = __webpack_require__(491)['default'];
	
	var _objectWithoutProperties = __webpack_require__(16)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = auth;
	
	var _actionsSessionActions = __webpack_require__(72);
	
	var _actionsAuthActions = __webpack_require__(37);
	
	var initialState = {
	  sessionList: [],
	  sessions: {}
	};
	
	function auth(state, action) {
	  if (state === undefined) state = initialState;
	
	  switch (action.type) {
	    case _actionsSessionActions.SESSION_CREATE:
	      var sessionId = action.sessionId;
	      var sessionList = [].concat(_toConsumableArray(state.sessionList));
	      if (sessionList.indexOf(sessionId) < 0) {
	        sessionList.push(sessionId);
	      }
	      return {
	        sessionList: sessionList,
	        sessions: _extends({}, state.sessions, _defineProperty({}, sessionId, action.data))
	      };
	    case _actionsSessionActions.NO_SESSIONS:
	      var stateValues = _objectWithoutProperties(state, []);
	
	      return _extends({}, stateValues, { empty: true });
	    case _actionsAuthActions.LOGOUT:
	      return _extends({}, initialState);
	    default:
	      return state;
	  }
	}
	
	module.exports = exports['default'];

/***/ }),
/* 1116 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = __webpack_require__(7)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = reducer;
	
	var _actionsUnsubscribeActions = __webpack_require__(299);
	
	var defaultState = {
	  action: '',
	  error: '',
	  // get optIns
	  fetchingOptIns: false,
	  userId: '',
	  optIns: null,
	  // set optIns
	  settingOptIns: false,
	  settingDone: false,
	  // unsubscribe
	  unsubscribing: false,
	  unsubscribed: false,
	  // subscribe
	  subscribing: false,
	  subscribed: false
	};
	
	function reducer(state, action) {
	  if (state === undefined) state = defaultState;
	
	  switch (action.type) {
	    case _actionsUnsubscribeActions.GET_OPTINS:
	      {
	        return _extends({}, state, { fetchingOptIns: true });
	      }
	    case _actionsUnsubscribeActions.GET_OPTINS_COMPLETED:
	      {
	        return _extends({}, state, { fetchingOptIns: false, optIns: _extends({}, action.payload) });
	      }
	    case _actionsUnsubscribeActions.GET_OPTINS_FAILED:
	      {
	        return _extends({}, state, { fetchingOptIns: false, error: action.payload.message });
	      }
	    case _actionsUnsubscribeActions.SET_OPTINS:
	      {
	        return _extends({}, state, { settingOptIns: true, settingDone: false });
	      }
	    case _actionsUnsubscribeActions.SET_OPTINS_COMPLETED:
	      {
	        return _extends({}, state, { settingOptIns: false, settingDone: true });
	      }
	    case _actionsUnsubscribeActions.SET_OPTINS_FAILED:
	      {
	        return _extends({}, state, { settingOptIns: false });
	      }
	    case _actionsUnsubscribeActions.UNSUBSCRIBE:
	      {
	        return _extends({}, state, { unsubscribing: true, unsubscribed: false });
	      }
	    case _actionsUnsubscribeActions.UNSUBSCRIBE_COMPLETED:
	      {
	        var unsubscribed = action.payload.unsubscribed;
	
	        return _extends({}, state, { unsubscribing: false, unsubscribed: unsubscribed === 'OK' });
	      }
	    case _actionsUnsubscribeActions.UNSUBSCRIBE_FAILED:
	      {
	        return _extends({}, state, { unsubscribing: false });
	      }
	    case _actionsUnsubscribeActions.SUBSCRIBE:
	      {
	        return _extends({}, state, { subscribing: true, subscribed: false });
	      }
	    case _actionsUnsubscribeActions.SUBSCRIBE_COMPLETED:
	      {
	        var subscribed = action.payload.subscribed;
	
	        return _extends({}, state, { subscribing: false, subscribed: subscribed === 'OK' });
	      }
	    case _actionsUnsubscribeActions.SUBSCRIBE_FAILED:
	      {
	        return _extends({}, state, { subscribing: false, error: action.payload.message });
	      }
	    default:
	      return state;
	  }
	}
	
	module.exports = exports['default'];

/***/ }),
/* 1117 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _extends = __webpack_require__(7)["default"];
	
	var _objectWithoutProperties = __webpack_require__(16)["default"];
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = userReferral;
	
	var _actionsReferralActionsJs = __webpack_require__(474);
	
	var initialState = {};
	
	function userReferral(state, action) {
	  if (state === undefined) state = initialState;
	  var type = action.type;
	
	  var referralInfo = _objectWithoutProperties(action, ["type"]);
	
	  switch (type) {
	    case _actionsReferralActionsJs.USERREFERRAL_LOAD:
	      return _extends({}, state, { loading: true });
	    case _actionsReferralActionsJs.USERREFERRAL_GENERATE:
	      return _extends({}, state, { generating: true });
	    case _actionsReferralActionsJs.USERREFERRAL_LOADERROR:
	    case _actionsReferralActionsJs.USERREFERRAL_GENERATEERROR:
	      return _extends({}, state, { error: action.message });
	    case _actionsReferralActionsJs.USERREFERRAL_LOADED:
	      return _extends({ loading: false, loaded: true }, referralInfo);
	    case _actionsReferralActionsJs.USERREFERRAL_GENERATED:
	      return _extends({ loading: false, loaded: true, generating: false }, referralInfo);
	    default:
	      return state;
	  }
	}
	
	module.exports = exports["default"];

/***/ }),
/* 1118 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _get = __webpack_require__(8)['default'];
	
	var _inherits = __webpack_require__(5)['default'];
	
	var _createClass = __webpack_require__(6)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(22);
	
	var _reactRouter = __webpack_require__(66);
	
	var _invariant = __webpack_require__(26);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _routerRoutes = __webpack_require__(1119);
	
	var _routerRoutes2 = _interopRequireDefault(_routerRoutes);
	
	var _utils = __webpack_require__(1126);
	
	var _reduxDevtoolsLibReact = __webpack_require__(399);
	
	__webpack_require__(1127);
	
	__webpack_require__(1125);
	
	var Root = (function (_React$Component) {
	  _inherits(Root, _React$Component);
	
	  _createClass(Root, null, [{
	    key: 'propTypes',
	
	    // routerHistory is provided by the client bundle to determine which
	    // history to use (memory, hash, browser). routingContext, on the other hand,
	    // is provided by the server and provides a full router state.
	    value: {
	      store: _react2['default'].PropTypes.object.isRequired,
	      routerHistory: _react2['default'].PropTypes.object,
	      routingContext: _react2['default'].PropTypes.object
	    },
	    enumerable: true
	  }]);
	
	  function Root() {
	    _classCallCheck(this, Root);
	
	    _get(Object.getPrototypeOf(Root.prototype), 'constructor', this).call(this);
	  }
	
	  _createClass(Root, [{
	    key: 'renderDevTools',
	    value: function renderDevTools() {
	      if (false) {
	        (0, _utils.createDevToolsWindow)(this.props.store);
	        return null;
	      } else {
	        return _react2['default'].createElement(
	          _reduxDevtoolsLibReact.DebugPanel,
	          { top: true, right: true, bottom: true, key: 'debugPanel' },
	          _react2['default'].createElement(_reduxDevtoolsLibReact.DevTools, { store: this.props.store, monitor: _reduxDevtoolsLibReact.LogMonitor })
	        );
	      }
	    }
	  }, {
	    key: 'renderRouter',
	    value: function renderRouter() {
	      (0, _invariant2['default'])(this.props.routingContext || this.props.routerHistory, '<Root /> needs either a routingContext or routerHistory to render.');
	
	      if (this.props.routingContext) {
	        return _react2['default'].createElement(_reactRouter.RoutingContext, this.props.routingContext);
	      } else {
	        return _react2['default'].createElement(
	          _reactRouter.Router,
	          { onUpdate: function () {
	              return window.scrollTo(0, 0);
	            }, history: this.props.routerHistory },
	          (0, _routerRoutes2['default'])(this.props.store)
	        );
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var debugTools = null;
	
	      if (false) {
	        debugTools = this.renderDevTools();
	      }
	
	      return _react2['default'].createElement(
	        'div',
	        null,
	        debugTools,
	        _react2['default'].createElement(
	          _reactRedux.Provider,
	          { store: this.props.store },
	          this.renderRouter()
	        )
	      );
	    }
	  }]);
	
	  return Root;
	})(_react2['default'].Component);
	
	exports['default'] = Root;
	module.exports = exports['default'];

/***/ }),
/* 1119 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _reactRouter = __webpack_require__(66);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _viewsLayout = __webpack_require__(1170);
	
	var _viewsLayout2 = _interopRequireDefault(_viewsLayout);
	
	var _viewsApp = __webpack_require__(1132);
	
	var _viewsApp2 = _interopRequireDefault(_viewsApp);
	
	var _viewsDataUsage = __webpack_require__(1160);
	
	var _viewsDataUsage2 = _interopRequireDefault(_viewsDataUsage);
	
	var _viewsTermsAndConditions = __webpack_require__(1192);
	
	var _viewsTermsAndConditions2 = _interopRequireDefault(_viewsTermsAndConditions);
	
	var _viewsContact = __webpack_require__(1151);
	
	var _viewsContact2 = _interopRequireDefault(_viewsContact);
	
	var _viewsHome = __webpack_require__(1162);
	
	var _viewsHome2 = _interopRequireDefault(_viewsHome);
	
	var _viewsAuthSignin = __webpack_require__(1147);
	
	var _viewsAuthSignin2 = _interopRequireDefault(_viewsAuthSignin);
	
	var _viewsAuthLogout = __webpack_require__(1144);
	
	var _viewsAuthLogout2 = _interopRequireDefault(_viewsAuthLogout);
	
	var _viewsAuthRegister = __webpack_require__(1145);
	
	var _viewsAuthRegister2 = _interopRequireDefault(_viewsAuthRegister);
	
	var _viewsUnsubscribe = __webpack_require__(1193);
	
	var _viewsUnsubscribe2 = _interopRequireDefault(_viewsUnsubscribe);
	
	var _viewsUnsubscribed = __webpack_require__(1194);
	
	var _viewsUnsubscribed2 = _interopRequireDefault(_viewsUnsubscribed);
	
	var _viewsSubscribe = __webpack_require__(1190);
	
	var _viewsSubscribe2 = _interopRequireDefault(_viewsSubscribe);
	
	var _viewsSubscribed = __webpack_require__(1191);
	
	var _viewsSubscribed2 = _interopRequireDefault(_viewsSubscribed);
	
	var _viewsAuthForgotPassword = __webpack_require__(1142);
	
	var _viewsAuthForgotPassword2 = _interopRequireDefault(_viewsAuthForgotPassword);
	
	var _viewsAuthEditProfile = __webpack_require__(1139);
	
	var _viewsAuthEditProfile2 = _interopRequireDefault(_viewsAuthEditProfile);
	
	var _viewsAuthChangeTempPassword = __webpack_require__(1135);
	
	var _viewsAuthChangeTempPassword2 = _interopRequireDefault(_viewsAuthChangeTempPassword);
	
	var _viewsSessionPresentation = __webpack_require__(1178);
	
	var _viewsSessionPresentation2 = _interopRequireDefault(_viewsSessionPresentation);
	
	var _viewsStaffAssignContracts = __webpack_require__(1186);
	
	var _viewsStaffAssignContracts2 = _interopRequireDefault(_viewsStaffAssignContracts);
	
	var _viewsPrograms = __webpack_require__(1172);
	
	var _viewsPrograms2 = _interopRequireDefault(_viewsPrograms);
	
	var _viewsInviteInvite = __webpack_require__(1168);
	
	var _viewsInviteInvite2 = _interopRequireDefault(_viewsInviteInvite);
	
	var _servicesPrograms = __webpack_require__(104);
	
	exports['default'] = function (store) {
	  function requireAuth(nextState, transition) {
	    var state = store.getState();
	    if (!state.auth || !state.auth.loggedIn) {
	      transition({ next: nextState.location.pathname }, '/signin');
	    }
	  }
	
	  function requireStaff(nextState, transition) {
	    requireAuth(nextState, transition);
	    var state = store.getState();
	    if (!state.profile || !state.profile.staff) {
	      transition({ next: null }, '/');
	    }
	  }
	
	  function requireNoAuth(nextState, transition) {
	    if (nextState && nextState.location && nextState.location.query) {
	      var query = nextState.location.query;
	
	      if (query && query.fp) {
	        setCookie("featuredPrograms", query.fp);
	        setCookie("featuredLanguage", query.fl);
	        setCookie("contractId", query.contractId);
	      }
	    }
	    if (store.getState().auth.loggedIn) {
	      if ((0, _servicesPrograms.hasFeaturedPrograms)()) {
	        transition({ next: null }, '/programs');
	      } else {
	        transition({ next: null }, '/');
	      }
	    }
	  }
	
	  return _react2['default'].createElement(
	    _reactRouter.Route,
	    { component: _viewsLayout2['default'] },
	    _react2['default'].createElement(
	      _reactRouter.Route,
	      { path: '/', component: _viewsApp2['default'] },
	      _react2['default'].createElement(_reactRouter.IndexRoute, { component: _viewsHome2['default'] }),
	      _react2['default'].createElement(_reactRouter.Route, { path: 'signin', component: _viewsAuthSignin2['default'], onEnter: requireNoAuth }),
	      _react2['default'].createElement(_reactRouter.Route, { path: 'logout', component: _viewsAuthLogout2['default'] }),
	      _react2['default'].createElement(_reactRouter.Route, { path: 'register', component: _viewsAuthRegister2['default'], onEnter: requireNoAuth }),
	      _react2['default'].createElement(_reactRouter.Route, { path: 'unsubscribe', component: _viewsUnsubscribe2['default'] }),
	      _react2['default'].createElement(_reactRouter.Route, { path: 'unsubscribed', component: _viewsUnsubscribed2['default'] }),
	      _react2['default'].createElement(_reactRouter.Route, { path: 'subscribe', component: _viewsSubscribe2['default'] }),
	      _react2['default'].createElement(_reactRouter.Route, { path: 'subscribed', component: _viewsSubscribed2['default'] }),
	      _react2['default'].createElement(_reactRouter.Route, { path: 'forgotPassword', component: _viewsAuthForgotPassword2['default'] }),
	      _react2['default'].createElement(_reactRouter.Route, { path: 'profile', component: _viewsAuthEditProfile2['default'], onEnter: requireAuth }),
	      _react2['default'].createElement(_reactRouter.Route, {
	        path: 'changeTempPassword',
	        component: _viewsAuthChangeTempPassword2['default'],
	        onEnter: requireAuth }),
	      _react2['default'].createElement(_reactRouter.Route, { path: 'DataUsage', component: _viewsDataUsage2['default'] }),
	      _react2['default'].createElement(_reactRouter.Route, { path: 'termsAndConditions', component: _viewsTermsAndConditions2['default'] }),
	      _react2['default'].createElement(_reactRouter.Route, { path: 'contact', component: _viewsContact2['default'] }),
	      _react2['default'].createElement(
	        _reactRouter.Route,
	        { path: 'class/:id', onEnter: requireAuth },
	        _react2['default'].createElement(_reactRouter.IndexRoute, { component: _viewsSessionPresentation2['default'] }),
	        _react2['default'].createElement(_reactRouter.Route, { path: 'content/:levelId', component: _viewsSessionPresentation2['default'] }),
	        _react2['default'].createElement(_reactRouter.Route, { path: 'content/:levelId/:slide', component: _viewsSessionPresentation2['default'] })
	      ),
	      _react2['default'].createElement(
	        _reactRouter.Route,
	        { path: 'staff', onEnter: requireStaff },
	        _react2['default'].createElement(_reactRouter.IndexRoute, { component: _viewsStaffAssignContracts2['default'] }),
	        _react2['default'].createElement(_reactRouter.Route, { path: 'user/:userId', component: _viewsStaffAssignContracts2['default'] }),
	        _react2['default'].createElement(_reactRouter.Route, { path: 'session/:sessionId', component: _viewsStaffAssignContracts2['default'] }),
	        _react2['default'].createElement(_reactRouter.Route, { path: 'onHold', component: _viewsStaffAssignContracts2['default'] })
	      ),
	      _react2['default'].createElement(_reactRouter.Route, { path: '/programs', component: _viewsPrograms2['default'], onEnter: requireAuth }),
	      _react2['default'].createElement(_reactRouter.Route, { path: '/invite', component: _viewsInviteInvite2['default'], onEnter: requireAuth })
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ }),
/* 1120 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.identify = identify;
	exports.clearUserCookie = clearUserCookie;
	
	function identify(userId, profileData) {
	  if (typeof window.FS === 'undefined') return;
	  var firstName = profileData.firstName;
	  var lastName = profileData.lastName;
	  var email = profileData.email;
	  var country = profileData.country;
	  var cityOrMunicipality = profileData.cityOrMunicipality;
	
	  window.FS.identify(userId, {
	    displayName: firstName + ' ' + lastName,
	    email: email,
	    country_str: country,
	    city_str: cityOrMunicipality
	  });
	}
	
	function clearUserCookie(identifiedOnly) {
	  if (typeof window.FS === 'undefined') return;
	  window.FS.clearUserCookie(identifiedOnly);
	}
	
	exports['default'] = {
	  identify: identify,
	  clearUserCookie: clearUserCookie
	};

/***/ }),
/* 1121 */
/***/ (function(module, exports, __webpack_require__) {

	/* eslint new-cap: 0 */
	
	'use strict';
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.intercomHide = intercomHide;
	exports.intercomShow = intercomShow;
	exports.intercomShowNewMessage = intercomShowNewMessage;
	exports.intercomCreateLead = intercomCreateLead;
	
	var _intercomRestClient = __webpack_require__(1123);
	
	var _intercomRestClient2 = _interopRequireDefault(_intercomRestClient);
	
	var _intercomJsClient = __webpack_require__(1122);
	
	var _intercomJsClient2 = _interopRequireDefault(_intercomJsClient);
	
	var _appConfig = __webpack_require__(54);
	
	var _appConfig2 = _interopRequireDefault(_appConfig);
	
	__webpack_require__(2194);
	
	var intercomRestClient = new _intercomRestClient2['default']({ appId: _appConfig2['default'].intercom, apiToken: _appConfig2['default'].intercomToken, apiUrl: _appConfig2['default'].apiUrl + 'intercom/' });
	var intercomClient = new _intercomJsClient2['default'](intercomRestClient, { appId: _appConfig2['default'].intercom });
	
	// Expose the intercomClient so it can be used by GTM
	window.intercomClient = intercomClient;
	
	function switchToRestClient() {
	  window.intercomClient = intercomClient = intercomRestClient;
	  intercomClient.processQueue(window.Intercom.q);
	}
	
	window.addEventListener('load', function () {
	  var scripts = document.getElementsByTagName('script');
	  var intercomScript = Array.prototype.filter.call(scripts, function (script) {
	    return script.src.indexOf('widget.intercom.io') >= 0;
	  })[0];
	  if (intercomScript) {
	    intercomScript.addEventListener('error', function () {
	      return switchToRestClient();
	    });
	  } else {
	    setTimeout(function () {
	      if (!window.Intercom.booted) {
	        switchToRestClient();
	      }
	    }, 5000);
	  }
	  intercomClient.boot({});
	});
	
	function intercomHide() {
	  intercomClient.hide();
	  document.body.classList.add('hide-intercom');
	}
	
	function intercomShow() {
	  // intercomClient.show();
	  document.body.classList.remove('hide-intercom');
	}
	
	function intercomShowNewMessage(message) {
	  return intercomClient.showNewMessage(message);
	}
	
	function intercomCreateLead(data) {
	  return intercomRestClient.createLead(data);
	}

/***/ }),
/* 1122 */
/***/ (function(module, exports, __webpack_require__) {

	/* eslint new-cap: 0 */
	'use strict';
	
	var _createClass = __webpack_require__(6)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _extends = __webpack_require__(7)['default'];
	
	var _objectWithoutProperties = __webpack_require__(16)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _ismobilejs = __webpack_require__(241);
	
	var _ismobilejs2 = _interopRequireDefault(_ismobilejs);
	
	var IntercomJsClient = (function () {
	  function IntercomJsClient(restClient, _ref) {
	    var appId = _ref.appId;
	
	    _classCallCheck(this, IntercomJsClient);
	
	    this._restClient = restClient;
	    this._currentUserId = '';
	    this._appId = appId;
	  }
	
	  _createClass(IntercomJsClient, [{
	    key: 'boot',
	    value: function boot(data) {
	      console.debug('intercomClient.boot', data);
	      this._currentUserId = data.user_id;
	      window.Intercom('boot', _extends({}, data, { app_id: this._appId }));
	      return true;
	    }
	  }, {
	    key: 'update',
	    value: function update(data) {
	      var userId = data.userId;
	
	      var restOfData = _objectWithoutProperties(data, ['userId']);
	
	      if (userId && userId !== this._currentUserId) {
	        return this._restClient.update(data);
	      }
	      window.Intercom('update', restOfData);
	      return true;
	    }
	  }, {
	    key: 'trackEvent',
	    value: function trackEvent(eventName, metadata) {
	      var phone = _ismobilejs2['default'].phone;
	      var tablet = _ismobilejs2['default'].tablet;
	
	      var deviceInfo = {};
	      if (phone) {
	        deviceInfo.phone = true;
	      } else if (tablet) {
	        deviceInfo.tablet = true;
	      } else {
	        deviceInfo.desktop = true;
	      }
	      var userId = metadata.userId;
	      var id = metadata.id;
	
	      if (!userId && id) {
	        return this._restClient.trackEvent(eventName, metadata);
	      }
	      if (userId && userId !== this._currentUserId) {
	        return this._restClient.trackEvent(eventName, metadata);
	      }
	      window.Intercom('trackEvent', eventName, _extends({}, metadata, { deviceInfo: deviceInfo }));
	      return true;
	    }
	  }, {
	    key: 'shutdown',
	    value: function shutdown() {
	      window.Intercom('shutdown');
	      return true;
	    }
	  }, {
	    key: 'hide',
	    value: function hide() {
	      window.Intercom('hide');
	      return true;
	    }
	  }, {
	    key: 'show',
	    value: function show() {
	      window.Intercom('show');
	      return true;
	    }
	  }, {
	    key: 'showNewMessage',
	    value: function showNewMessage(message) {
	      window.Intercom('showNewMessage', message);
	      return true;
	    }
	  }]);
	
	  return IntercomJsClient;
	})();
	
	exports['default'] = IntercomJsClient;
	module.exports = exports['default'];

/***/ }),
/* 1123 */
/***/ (function(module, exports, __webpack_require__) {

	/* eslint no-console: 0, camelcase: 0 */
	'use strict';
	
	var _createClass = __webpack_require__(6)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _extends = __webpack_require__(7)['default'];
	
	var _objectWithoutProperties = __webpack_require__(16)['default'];
	
	var _Promise = __webpack_require__(33)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _ismobilejs = __webpack_require__(241);
	
	var _ismobilejs2 = _interopRequireDefault(_ismobilejs);
	
	function timeStamp() {
	  return parseInt(Date.now() / 1000, 10);
	}
	
	var IntercomRestClient = (function () {
	  function IntercomRestClient(_ref) {
	    var appId = _ref.appId;
	    var apiToken = _ref.apiToken;
	    var apiUrl = _ref.apiUrl;
	
	    _classCallCheck(this, IntercomRestClient);
	
	    this._appId = appId;
	    this._apiToken = apiToken;
	    this._apiUrl = apiUrl;
	    this._userId = null;
	    this._ajaxQueue = [];
	    this._processing = false;
	  }
	
	  _createClass(IntercomRestClient, [{
	    key: 'processQueue',
	    value: function processQueue(queue) {
	      console.log('Processing Intercom queue backlog.', queue);
	      var self = this;
	      queue.forEach(function (item) {
	        var action = item[0];
	        var args = Array.prototype.slice.call(item, 1);
	        var fn = self[action];
	        if (fn) {
	          fn.apply(self, args);
	        }
	      });
	    }
	  }, {
	    key: 'boot',
	    value: function boot(data) {
	      var app_id = data.app_id;
	      var name = data.name;
	      var email = data.email;
	      var user_id = data.user_id;
	
	      var restOfData = _objectWithoutProperties(data, ['app_id', 'name', 'email', 'user_id']);
	
	      this._userId = data.user_id;
	      if (!this._userId) return false;
	      var intercomData = {
	        name: name,
	        email: email,
	        user_id: user_id,
	        update_last_request_at: true,
	        custom_attributes: restOfData
	      };
	      this._enqueueAjax('POST', 'users', intercomData);
	      return true;
	    }
	  }, {
	    key: 'update',
	    value: function update(data) {
	      var name = data.name;
	      var email = data.email;
	      var userId = data.userId;
	
	      var restOfData = _objectWithoutProperties(data, ['name', 'email', 'userId']);
	
	      if (!this._userId && !userId) return false;
	      var intercomData = {
	        name: name,
	        email: email,
	        user_id: userId || this._userId,
	        update_last_request_at: true,
	        custom_attributes: restOfData
	      };
	      this._enqueueAjax('POST', 'users', intercomData);
	      return true;
	    }
	  }, {
	    key: 'trackEvent',
	    value: function trackEvent(eventName, metadata) {
	      var phone = _ismobilejs2['default'].phone;
	      var tablet = _ismobilejs2['default'].tablet;
	
	      var deviceInfo = {};
	      if (phone) {
	        deviceInfo.phone = true;
	      } else if (tablet) {
	        deviceInfo.tablet = true;
	      } else {
	        deviceInfo.desktop = true;
	      }
	      var userId = metadata.userId;
	      var id = metadata.id;
	
	      if (!userId && id) {
	        var _intercomData = {
	          event_name: eventName,
	          created_at: timeStamp(),
	          id: id,
	          metadata: _extends({}, metadata, { deviceInfo: deviceInfo })
	        };
	        this._enqueueAjax('POST', 'events', _intercomData);
	        return true;
	      }
	      if (!this._userId && !userId) return false;
	      var intercomData = {
	        event_name: eventName,
	        created_at: timeStamp(),
	        user_id: userId || this._userId,
	        metadata: _extends({}, metadata, { deviceInfo: deviceInfo })
	      };
	      this._enqueueAjax('POST', 'events', intercomData);
	      return true;
	    }
	  }, {
	    key: 'shutdown',
	    value: function shutdown() {
	      return false;
	    }
	  }, {
	    key: 'hide',
	    value: function hide() {
	      return false;
	    }
	  }, {
	    key: 'show',
	    value: function show() {
	      return false;
	    }
	  }, {
	    key: 'showNewMessage',
	    value: function showNewMessage() {
	      return false;
	    }
	  }, {
	    key: '_logErrorIfAny',
	    value: function _logErrorIfAny(err) {
	      if (err) {
	        console.log(err.message, err.stack);
	      }
	    }
	  }, {
	    key: '_ajax',
	    value: function _ajax(method, intercomEndpoint, data, cb) {
	      var _this = this;
	
	      this._processing = true;
	      var xhr = new XMLHttpRequest();
	      xhr.open(method, this._apiUrl + intercomEndpoint, true);
	      xhr.setRequestHeader('Accept', 'application/json');
	      xhr.setRequestHeader('Content-Type', 'application/json');
	      xhr.setRequestHeader('Authorization', 'Bearer ' + this._apiToken);
	      xhr.addEventListener('readystatechange', function () {
	        if (xhr.readyState !== XMLHttpRequest.DONE) return;
	        _this._processing = false;
	        if (xhr.status >= 400) {
	          var error = new Error(['Request failed:', method, intercomEndpoint, 'returned', xhr.status, xhr.statusText].join(' '));
	          error.response = xhr.response;
	          error.responseType = xhr.responseType;
	          cb(error);
	          return;
	        }
	        cb(null, xhr.response);
	      });
	      xhr.send(data ? JSON.stringify(data) : null);
	    }
	  }, {
	    key: '_enqueueAjax',
	    value: function _enqueueAjax(method, intercomEndpoint, data, cb) {
	      this._ajaxQueue.push([method, intercomEndpoint, data, cb]);
	      this._tryProcessQueue();
	    }
	  }, {
	    key: '_tryProcessQueue',
	    value: function _tryProcessQueue() {
	      var _this2 = this;
	
	      if (this._processing) return;
	
	      var args = this._ajaxQueue.shift();
	      if (!args) return;
	      var cb = args[3];
	
	      this._ajax(args[0], args[1], args[2], function (err, res) {
	        _this2._logErrorIfAny(err);
	        setTimeout(_this2._tryProcessQueue.bind(_this2), 0);
	        if (cb) cb(err, res);
	      });
	    }
	  }, {
	    key: 'createLead',
	    value: function createLead(data) {
	      var _this3 = this;
	
	      return new _Promise(function (resolve, reject) {
	        _this3._enqueueAjax('POST', 'contacts', data, function (err, res) {
	          if (err) return reject(err);
	          if (typeof res === 'string') {
	            try {
	              res = JSON.parse(res);
	            } catch (e) {
	              reject(err);
	            }
	          }
	          resolve(res.id);
	        });
	      });
	    }
	  }]);
	
	  return IntercomRestClient;
	})();
	
	exports['default'] = IntercomRestClient;
	module.exports = exports['default'];

/***/ }),
/* 1124 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = configureStore;
	
	var _redux = __webpack_require__(99);
	
	var _reduxDevtools = __webpack_require__(816);
	
	var _reduxThunk = __webpack_require__(829);
	
	var _reduxThunk2 = _interopRequireDefault(_reduxThunk);
	
	var _reduxLogger = __webpack_require__(828);
	
	var _reduxLogger2 = _interopRequireDefault(_reduxLogger);
	
	var _reducers = __webpack_require__(1111);
	
	var _reducers2 = _interopRequireDefault(_reducers);
	
	var createStoreWithMiddleware = undefined;
	
	var logger = (0, _reduxLogger2['default'])({
	  level: 'info',
	  collapsed: true
	  // predicate: (getState, action) => action.type !== AUTH_REMOVE_TOKEN
	});
	
	var middleware = [_reduxThunk2['default'], logger];
	
	if (false) {
	  createStoreWithMiddleware = (0, _redux.compose)(_redux.applyMiddleware.apply(undefined, middleware), (0, _reduxDevtools.devTools)())(_redux.createStore);
	} else {
	  createStoreWithMiddleware = _redux.applyMiddleware.apply(undefined, middleware)(_redux.createStore);
	}
	
	function configureStore(initialState) {
	  var store = createStoreWithMiddleware(_reducers2['default'], initialState);
	
	  if (false) {
	    module.hot.accept('./reducers', function () {
	      var nextRootReducer = require('./reducers/index');
	
	      store.replaceReducer(nextRootReducer);
	    });
	  }
	  return store;
	}
	
	module.exports = exports['default'];

/***/ }),
/* 1125 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2)["default"];
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _appConfig = __webpack_require__(54);
	
	var _appConfig2 = _interopRequireDefault(_appConfig);
	
	var _servicesAjax = __webpack_require__(230);
	
	var _servicesAjax2 = _interopRequireDefault(_servicesAjax);
	
	var PPABridge = function PPABridge(action, target, data) {
	  return (0, _servicesAjax2["default"])(_appConfig2["default"].apiUrl + "bridge", null, JSON.stringify({
	    action: action,
	    target: target,
	    data: data
	  }));
	};
	
	exports.PPABridge = PPABridge;
	window.PPABridge = PPABridge;

/***/ }),
/* 1126 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.createConstants = createConstants;
	exports.createReducer = createReducer;
	exports['default'] = createDevToolsWindow;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reduxDevtoolsLibReact = __webpack_require__(399);
	
	function createConstants() {
	  for (var _len = arguments.length, constants = Array(_len), _key = 0; _key < _len; _key++) {
	    constants[_key] = arguments[_key];
	  }
	
	  return constants.reduce(function (acc, constant) {
	    acc[constant] = constant;
	    return acc;
	  }, {});
	}
	
	function createReducer(initialState, reducerMap) {
	  return function (state, action) {
	    if (state === undefined) state = initialState;
	
	    var reducer = reducerMap[action.type];
	
	    return reducer ? reducer(state, action.payload) : state;
	  };
	}
	
	function createDevToolsWindow(store) {
	  var win = window.open(null, 'redux-devtools', // give it a name so it reuses the same window
	  'menubar=no,location=no,resizable=yes,scrollbars=no,status=no');
	
	  // reload in case it's reusing the same window with the old content
	  win.location.reload();
	
	  // wait a little bit for it to reload, then render
	  setTimeout(function () {
	    _react2['default'].render(_react2['default'].createElement(
	      _reduxDevtoolsLibReact.DebugPanel,
	      { top: true, right: true, bottom: true, left: true },
	      _react2['default'].createElement(_reduxDevtoolsLibReact.DevTools, { store: store, monitor: _reduxDevtoolsLibReact.LogMonitor })
	    ), win.document.body);
	  }, 10);
	}

/***/ }),
/* 1127 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2)["default"];
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _appConfig = __webpack_require__(54);
	
	var _appConfig2 = _interopRequireDefault(_appConfig);
	
	var _servicesAjax = __webpack_require__(230);
	
	var _servicesAjax2 = _interopRequireDefault(_servicesAjax);
	
	var sendToES = function sendToES(data, callback) {
	  return (0, _servicesAjax2["default"])(_appConfig2["default"].apiUrl + "events", callback, JSON.stringify(data));
	};
	
	exports.sendToES = sendToES;
	window.ES = {
	  sendToES: sendToES
	};

/***/ }),
/* 1128 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var moment = __webpack_require__(10);
	
	var createRTS = function createRTS() {
	  return moment().format("dddd, MMMM Do YYYY, H:mm:ss");
	};
	
	exports.createRTS = createRTS;
	var convertToRTS = function convertToRTS(timestamp) {
	  return moment(timestamp).format("dddd, MMMM Do YYYY, H:mm:ss");
	};
	
	exports.convertToRTS = convertToRTS;
	var createTS = function createTS() {
	  return Math.round(new Date() / 1000);
	};
	exports.createTS = createTS;

/***/ }),
/* 1129 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = {
	  statusColor: '#5CE592',
	  statusInactiveColor: '#FC6F6F',
	  unMaskColor: '#000000',
	  unMaskTime: 1400,
	  zxcvbnSrc: 'https://cdnjs.cloudflare.com/ajax/libs/zxcvbn/1.0/zxcvbn.min.js',
	  strengthLang: ['Weak', 'Okay', 'Good', 'Strong', 'Great']
	};

/***/ }),
/* 1130 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = __webpack_require__(7)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var PropTypes = _react2['default'].PropTypes;
	var createClass = _react2['default'].createClass;
	
	var Wufoo = createClass({
	
		propTypes: {
			async: PropTypes.bool,
			autoResize: PropTypes.bool,
			embedJs: PropTypes.string,
			formHash: PropTypes.string.isRequired,
			header: PropTypes.oneOf(['show', 'hide']),
			height: PropTypes.string,
			host: PropTypes.string,
			ssl: PropTypes.bool,
			userName: PropTypes.string.isRequired
		},
	
		getDefaultProps: function getDefaultProps() {
			return {
				async: true,
				autoResize: true,
				embedJs: '/scripts/embed/form.js',
				formHash: '',
				header: 'show',
				height: '0',
				host: 'wufoo.com',
				ssl: true,
				userName: ''
			};
		},
	
		/**
	  * Get the full url of the embed src
	  * @return {string} URL of embed
	  */
		getSrc: function getSrc() {
			return 'https://www.' + this.props.host + this.props.embedJs;
		},
	
		/**
	  * Run the Embed Code
	  */
		embedForm: function embedForm() {
			var self = this;
			var form = undefined;
			var rs = this.readyState;if (rs) if (rs !== 'complete') if (rs !== 'loaded') return;
			try {
				form = new window.WufooForm();
				form.initialize(self.props);
				form.display();
			} catch (e) {}
		},
	
		runScript: function runScript() {
			return typeof window.WufooForm !== 'function' ? this.createScript() : this.embedForm();
		},
	
		/**
	  * Load the Wufoo Embed JS file
	  * @return {Object} script object created
	  */
		createScript: function createScript() {
			var self = this;
			var s = document.createElement('script');
			s.src = this.getSrc();
			s.onload = s.onreadystatechange = function () {
				return self.embedForm();
			};
			var scr = document.getElementsByTagName('script')[0],
			    par = scr.parentNode;
			par.insertBefore(s, scr);
			return scr;
		},
	
		componentDidUpdate: function componentDidUpdate() {
			this.runScript();
		},
	
		componentWillMount: function componentWillMount() {
			this.runScript();
		},
	
		render: function render() {
			return _react2['default'].createElement('div', _extends({}, this.props, { id: 'wufoo-' + this.props.formHash }));
		}
	
	});
	
	exports['default'] = Wufoo;
	module.exports = exports['default'];

/***/ }),
/* 1131 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _get = __webpack_require__(8)["default"];
	
	var _inherits = __webpack_require__(5)["default"];
	
	var _createClass = __webpack_require__(6)["default"];
	
	var _classCallCheck = __webpack_require__(3)["default"];
	
	var _interopRequireDefault = __webpack_require__(2)["default"];
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jimpickSpectacleSrcBase = __webpack_require__(27);
	
	var _jimpickSpectacleSrcBase2 = _interopRequireDefault(_jimpickSpectacleSrcBase);
	
	var _radium = __webpack_require__(144);
	
	var _radium2 = _interopRequireDefault(_radium);
	
	var animations = {
	  pacmanTopFrames: _radium2["default"].keyframes({
	    "0%": { transform: "rotateZ(0deg)" },
	    "100%": { transform: "rotateZ(-30deg)" }
	  }),
	  pacmanBottomFrames: _radium2["default"].keyframes({
	    "0%": { transform: "rotateZ(0deg)" },
	    "100%": { transform: "rotateZ(30deg)" }
	  }),
	  pacmanTopFramesBis: _radium2["default"].keyframes({
	    "0%": { transform: "rotateZ(0deg)" },
	    "100%": { transform: "rotateZ(-30deg)" }
	  }),
	  pacmanBottomFramesBis: _radium2["default"].keyframes({
	    "0%": { transform: "rotateZ(0deg)" },
	    "100%": { transform: "rotateZ(30deg)" }
	  })
	};
	
	var Progress = (function (_Base) {
	  _inherits(Progress, _Base);
	
	  function Progress() {
	    _classCallCheck(this, _Progress);
	
	    _get(Object.getPrototypeOf(_Progress.prototype), "constructor", this).apply(this, arguments);
	  }
	
	  _createClass(Progress, [{
	    key: "render",
	    value: function render() {
	      var _this = this;
	
	      var _ = this.context.i18n;
	
	      var style = this.context.styles.progress;
	      var markup = undefined;
	      switch (this.props.type) {
	        case "none":
	          return false;
	        case "pacman":
	          style = style.pacman;
	          markup = _react2["default"].createElement(
	            "div",
	            null,
	            _react2["default"].createElement(
	              "div",
	              { style: [style.pacman, this.getPointPosition(this.props.currentSlide)] },
	              _react2["default"].createElement("div", { style: [style.pacmanTop, this.getPacmanStyle("Top")] }),
	              _react2["default"].createElement("div", { style: [style.pacmanBottom, this.getPacmanStyle("Bottom")] })
	            ),
	            this.props.items.map(function (item, i) {
	              return _react2["default"].createElement("div", { style: [style.point, _this.getPointStyle(i)],
	                key: "presentation-progress-" + i });
	            })
	          );
	          break;
	        case "number":
	          style = style.number;
	          markup = _react2["default"].createElement(
	            "div",
	            null,
	            this.props.currentSlide + 1,
	            " / ",
	            this.props.items.length
	          );
	          break;
	        case "bar":
	          style = style.bar;
	          markup = _react2["default"].createElement(
	            "div",
	            { style: [style.bar, this.getWidth()] },
	            _('Progress')
	          );
	          break;
	        default:
	          return false;
	      }
	      return _react2["default"].createElement(
	        "div",
	        { style: [this.getStyles()] },
	        _react2["default"].createElement(
	          "div",
	          { style: [style.container] },
	          markup
	        )
	      );
	    }
	  }, {
	    key: "getWidth",
	    value: function getWidth() {
	      return {
	        width: 100 * this.props.currentSlide / (this.props.items.length - 1) + "%"
	      };
	    }
	  }, {
	    key: "getPacmanStyle",
	    value: function getPacmanStyle(side) {
	      var animationName = "pacman" + side + "Frames" + (this.props.currentSlide % 2 ? "" : "Bis");
	      return {
	        animation: animations[animationName] + " 0.12s linear 10 alternate both"
	      };
	    }
	  }, {
	    key: "getPointPosition",
	    value: function getPointPosition(i) {
	      return {
	        top: "-20px",
	        left: 5 + 20 * (i - this.props.items.length / 2) + "px"
	      };
	    }
	  }, {
	    key: "getPointStyle",
	    value: function getPointStyle(i) {
	      var style = this.getPointPosition(i);
	      if (this.props.currentSlide >= i) {
	        style.opacity = 0;
	      }
	
	      return style;
	    }
	  }]);
	
	  var _Progress = Progress;
	  Progress = (0, _radium2["default"])(Progress) || Progress;
	  return Progress;
	})(_jimpickSpectacleSrcBase2["default"]);
	
	Progress.propTypes = {
	  items: _react2["default"].PropTypes.array,
	  currentSlide: _react2["default"].PropTypes.number,
	  type: _react2["default"].PropTypes.oneOf(["pacman", "bar", "number", "none"])
	};
	
	Progress.contextTypes = {
	  styles: _react2["default"].PropTypes.object,
	  i18n: _react2["default"].PropTypes.func.isRequired
	};
	
	exports["default"] = Progress;
	module.exports = exports["default"];

/***/ }),
/* 1132 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _get = __webpack_require__(8)['default'];
	
	var _inherits = __webpack_require__(5)['default'];
	
	var _createClass = __webpack_require__(6)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _extends = __webpack_require__(7)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(22);
	
	var _redux = __webpack_require__(99);
	
	var _servicesRegionalization = __webpack_require__(38);
	
	var _servicesRegionalization2 = _interopRequireDefault(_servicesRegionalization);
	
	var _actionsProfileActions = __webpack_require__(103);
	
	var _actionsActiveSessionActions = __webpack_require__(472);
	
	var _actionsSessionActions = __webpack_require__(72);
	
	var _viewsNavBar = __webpack_require__(1171);
	
	var _viewsNavBar2 = _interopRequireDefault(_viewsNavBar);
	
	var _viewsFooter = __webpack_require__(1161);
	
	var _viewsFooter2 = _interopRequireDefault(_viewsFooter);
	
	var _helpersI18n = __webpack_require__(14);
	
	var changeTempPasswordUrl = '/changeTempPassword';
	
	var isIE = false || !!document.documentMode;
	
	var App = (function (_Component) {
	  _inherits(App, _Component);
	
	  _createClass(App, null, [{
	    key: 'propTypes',
	    value: {
	      children: _react.PropTypes.element.isRequired,
	      location: _react.PropTypes.shape({
	        pathname: _react.PropTypes.string.isRequired
	      }).isRequired,
	      auth: _react.PropTypes.shape({
	        loggedIn: _react.PropTypes.bool.isRequired,
	        authData: _react.PropTypes.shape({
	          uid: _react.PropTypes.string
	        })
	      }).isRequired,
	      profile: _react.PropTypes.object.isRequired,
	      activeSession: _react.PropTypes.string,
	      bindProfile: _react.PropTypes.func.isRequired,
	      unbindProfile: _react.PropTypes.func.isRequired,
	      bindActiveSession: _react.PropTypes.func.isRequired,
	      unbindActiveSession: _react.PropTypes.func.isRequired,
	      archiveSession: _react.PropTypes.func.isRequired,
	      dispatch: _react.PropTypes.func.isRequired
	    },
	    enumerable: true
	  }, {
	    key: 'contextTypes',
	    value: {
	      history: _react.PropTypes.object.isRequired,
	      location: _react.PropTypes.object.isRequired
	    },
	    enumerable: true
	  }, {
	    key: 'childContextTypes',
	    value: {
	      setActiveSession: _react.PropTypes.func,
	      completeLevelAndExit: _react.PropTypes.func,
	      completeLevelPreview: _react.PropTypes.func,
	      auth: _react.PropTypes.object,
	      userId: _react.PropTypes.string,
	      profile: _react.PropTypes.object,
	      staff: _react.PropTypes.bool,
	      archiveSession: _react.PropTypes.func,
	      regionData: _react.PropTypes.object,
	      i18n: _react.PropTypes.func
	    },
	    enumerable: true
	  }]);
	
	  function App(props) {
	    _classCallCheck(this, App);
	
	    _get(Object.getPrototypeOf(App.prototype), 'constructor', this).call(this, props);
	    this.boundProfileRefs = [];
	    this.boundActiveSessionRefs = [];
	  }
	
	  _createClass(App, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      var _props = this.props;
	      var profile = _props.profile;
	      var auth = _props.auth;
	      var archive = _props.archiveSession;
	      var staff = profile.staff;
	
	      var userId = null;
	      if (auth && auth.authData && auth.authData.uid) {
	        userId = auth.authData.uid;
	      }
	      var regionData = _servicesRegionalization2['default'].getRegionDataFromProfile(profile);
	      return {
	        setActiveSession: this.dispatchSetActiveSession.bind(this),
	        completeLevelAndExit: this.dispatchCompleteLevelAndExit.bind(this),
	        completeLevelPreview: this.dispatchCompleteLevelPreview.bind(this),
	        auth: auth,
	        userId: userId,
	        profile: profile,
	        regionData: regionData,
	        staff: staff,
	        archiveSession: archive,
	        i18n: (0, _helpersI18n.i18n)('en')
	      };
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.bindProfile(this.props, true);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var history = this.context.history;
	      var query = this.context.location.query;
	      var currentAuth = this.props.auth;
	      var nextAuth = nextProps.auth;
	      var nextLocation = nextProps.location;
	      var nextActiveSession = nextProps.activeSession;
	
	      if (currentAuth && currentAuth.loggedIn && (!nextAuth || !nextAuth.loggedIn)) {
	        this.unbindProfile();
	      }
	      if ((!currentAuth || !currentAuth.loggedIn) && nextAuth && nextAuth.loggedIn) {
	        this.bindProfile(nextProps, true);
	      }
	
	      var authData = nextAuth.authData;
	
	      if (authData && authData.password && authData.password.isTemporaryPassword && nextLocation && nextLocation.pathname !== changeTempPasswordUrl) {
	        history.replaceState(null, changeTempPasswordUrl, query);
	        return;
	      }
	
	      if (nextActiveSession && nextActiveSession !== 'none' && nextLocation) {
	        var pathname = nextLocation.pathname;
	
	        var classUrl = '/class/' + nextActiveSession + '/';
	        if (!pathname.match(new RegExp('^' + classUrl))) {
	          history.replaceState(null, classUrl);
	        }
	      } else if ((nextActiveSession === 'none' || nextActiveSession === '') && nextLocation) {
	        var pathname = nextLocation.pathname;
	
	        var classUrl = '/class/';
	        if (pathname.match(new RegExp('^' + classUrl))) {
	          history.replaceState(null, '/');
	        }
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.unbindProfile();
	    }
	  }, {
	    key: 'bindProfile',
	    value: function bindProfile(props, pageLoad) {
	      var auth = props.auth;
	
	      if (auth && auth.authData && auth.authData.uid) {
	        var userId = auth.authData.uid;
	        this.props.bindProfile(userId, this.boundProfileRefs);
	        this.props.bindActiveSession(userId, this.boundActiveSessionRefs, pageLoad);
	      }
	    }
	  }, {
	    key: 'unbindProfile',
	    value: function unbindProfile() {
	      this.props.unbindProfile(this.boundProfileRefs);
	      this.props.unbindActiveSession(this.boundActiveSessionRefs);
	    }
	  }, {
	    key: 'dispatchSetActiveSession',
	    value: function dispatchSetActiveSession(sessionId, level, programId) {
	      var _props2 = this.props;
	      var auth = _props2.auth;
	      var dispatch = _props2.dispatch;
	
	      if (auth && auth.authData && auth.authData.uid) {
	        var userId = auth.authData.uid;
	        var deviceRole = localStorage.getItem('deviceRole') || 'classroomDisplay';
	        return dispatch((0, _actionsActiveSessionActions.setActiveSession)({ userId: userId, sessionId: sessionId, level: level, deviceRole: deviceRole, programId: programId }));
	      }
	    }
	  }, {
	    key: 'dispatchCompleteLevelAndExit',
	    value: function dispatchCompleteLevelAndExit(_ref) {
	      var sessionId = _ref.sessionId;
	      var programId = _ref.programId;
	      var completedLevel = _ref.completedLevel;
	      var finished = _ref.finished;
	      var contractId = _ref.contractId;
	      var funding = _ref.funding;
	      var previousCompletedLevel = _ref.previousCompletedLevel;
	      var _props3 = this.props;
	      var auth = _props3.auth;
	      var dispatch = _props3.dispatch;
	
	      if (auth && auth.authData && auth.authData.uid) {
	        var userId = auth.authData.uid;
	        return dispatch((0, _actionsActiveSessionActions.completeLevelAndExit)({
	          userId: userId,
	          sessionId: sessionId,
	          programId: programId,
	          completedLevel: completedLevel,
	          finished: finished,
	          contractId: contractId,
	          funding: funding,
	          previousCompletedLevel: previousCompletedLevel
	        }));
	      }
	    }
	  }, {
	    key: 'dispatchCompleteLevelPreview',
	    value: function dispatchCompleteLevelPreview(_ref2) {
	      var sessionId = _ref2.sessionId;
	      var programId = _ref2.programId;
	      var completedLevel = _ref2.completedLevel;
	      var contractId = _ref2.contractId;
	      var funding = _ref2.funding;
	      var _props4 = this.props;
	      var auth = _props4.auth;
	      var dispatch = _props4.dispatch;
	
	      if (auth && auth.authData && auth.authData.uid) {
	        var userId = auth.authData.uid;
	        return dispatch((0, _actionsActiveSessionActions.completeLevelPreview)({
	          userId: userId,
	          sessionId: sessionId,
	          programId: programId,
	          completedLevel: completedLevel,
	          contractId: contractId,
	          funding: funding
	        }));
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props5 = this.props;
	      var auth = _props5.auth;
	      var profile = _props5.profile;
	      var location = _props5.location;
	      var pathname = location.pathname;
	
	      var isHome = pathname === '/';
	      var logoutOnly = pathname === changeTempPasswordUrl;
	
	      return _react2['default'].createElement(
	        'div',
	        null,
	        !!isIE && _react2['default'].createElement(
	          'div',
	          { className: 'browser-warning' },
	          'Internet Explorer is not fully supported yet. Please use Edge, Chrome, or Firefox for the best experience!'
	        ),
	        !pathname.match(/\/content/) && _react2['default'].createElement(_viewsNavBar2['default'], {
	          auth: auth,
	          profile: profile,
	          isHome: isHome,
	          logoutOnly: logoutOnly }),
	        _react2['default'].createElement(
	          'div',
	          { className: 'container' },
	          this.props.children
	        ),
	        !pathname.match(/\/content/) && _react2['default'].createElement(_viewsFooter2['default'], null)
	      );
	    }
	  }]);
	
	  return App;
	})(_react.Component);
	
	exports['default'] = (0, _reactRedux.connect)(function (state) {
	  var auth = state.auth;
	  var profile = state.profile;
	  var activeSession = state.activeSession;
	
	  return { auth: _extends({}, auth), profile: profile, activeSession: activeSession };
	}, function (dispatch) {
	  return {
	    bindProfile: (0, _redux.bindActionCreators)(_actionsProfileActions.bindProfile, dispatch),
	    unbindProfile: (0, _redux.bindActionCreators)(_actionsProfileActions.unbindProfile, dispatch),
	    bindActiveSession: (0, _redux.bindActionCreators)(_actionsActiveSessionActions.bindActiveSession, dispatch),
	    unbindActiveSession: (0, _redux.bindActionCreators)(_actionsActiveSessionActions.unbindActiveSession, dispatch),
	    archiveSession: (0, _redux.bindActionCreators)(_actionsSessionActions.archiveSession, dispatch),
	    dispatch: dispatch
	  };
	})(App);
	module.exports = exports['default'];

/***/ }),
/* 1133 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _get = __webpack_require__(8)['default'];
	
	var _inherits = __webpack_require__(5)['default'];
	
	var _createClass = __webpack_require__(6)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _extends = __webpack_require__(7)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(24);
	
	var _reduxForm = __webpack_require__(36);
	
	var _utilsValidateNormalize = __webpack_require__(75);
	
	var _reactSpinner = __webpack_require__(51);
	
	var _reactSpinner2 = _interopRequireDefault(_reactSpinner);
	
	__webpack_require__(120);
	
	__webpack_require__(198);
	
	__webpack_require__(2196);
	
	var ChangeEmailModal = (function (_Component) {
	  _inherits(ChangeEmailModal, _Component);
	
	  function ChangeEmailModal() {
	    _classCallCheck(this, _ChangeEmailModal);
	
	    _get(Object.getPrototypeOf(_ChangeEmailModal.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(ChangeEmailModal, [{
	    key: 'handleSubmit',
	    value: function handleSubmit(evt) {
	      var _props = this.props;
	      var alert = _props.fields.alert;
	      var handleSubmit = _props.handleSubmit;
	
	      alert.submitError = false;
	      handleSubmit(evt);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props;
	      var showModal = _props2.showModal;
	      var closeModal = _props2.closeModal;
	      var _props2$fields = _props2.fields;
	      var alert = _props2$fields.alert;
	      var email = _props2$fields.email;
	      var password = _props2$fields.password;
	      var submitting = _props2.submitting;
	
	      return _react2['default'].createElement(
	        _reactBootstrap.Modal,
	        { show: showModal, onHide: closeModal },
	        _react2['default'].createElement(
	          _reactBootstrap.Modal.Header,
	          { closeButton: true },
	          _react2['default'].createElement(
	            _reactBootstrap.Modal.Title,
	            null,
	            'Change Email'
	          )
	        ),
	        _react2['default'].createElement(
	          'form',
	          { onSubmit: this.handleSubmit.bind(this) },
	          _react2['default'].createElement(
	            _reactBootstrap.Modal.Body,
	            { className: 'col-sm-8 col-md-12' },
	            alert.error && _react2['default'].createElement(
	              'div',
	              { className: 'form-group' },
	              _react2['default'].createElement('div', { className: 'alert alert-danger', dangerouslySetInnerHTML: { __html: alert.error } })
	            ),
	            _react2['default'].createElement(
	              'div',
	              { className: 'col-sm-12 col-md-12' },
	              _react2['default'].createElement(
	                'div',
	                { className: 'row' },
	                _react2['default'].createElement(
	                  'div',
	                  { className: 'form-group ' + (email.error && email.touched && 'has-error') },
	                  _react2['default'].createElement(
	                    'label',
	                    { htmlFor: 'txtEmail',
	                      className: 'newEmailLabel col-sm-3 control-label' },
	                    'New Email'
	                  ),
	                  _react2['default'].createElement(
	                    'div',
	                    { className: 'col-sm-9 newEmailInputDiv' },
	                    _react2['default'].createElement('input', _extends({ id: 'txtEmail',
	                      type: 'email',
	                      className: 'form-control',
	                      placeholder: 'jane@example.com',
	                      spellCheck: 'false'
	                    }, email)),
	                    email.error && email.touched && _react2['default'].createElement('div', { className: 'text-danger', dangerouslySetInnerHTML: { __html: email.error } })
	                  )
	                )
	              ),
	              _react2['default'].createElement(
	                'div',
	                { className: 'row' },
	                _react2['default'].createElement(
	                  'div',
	                  { className: 'form-group ' + (password.error && password.touched ? 'has-error' : '') },
	                  _react2['default'].createElement(
	                    'label',
	                    { htmlFor: 'txtPassword',
	                      className: 'passwordLabel col-sm-3 control-label' },
	                    'Password'
	                  ),
	                  _react2['default'].createElement(
	                    'div',
	                    { className: 'col-sm-9 passwordInputDiv' },
	                    _react2['default'].createElement('input', _extends({ id: 'txtPass',
	                      type: 'password',
	                      className: 'form-control',
	                      placeholder: 'thoo!mu3Da'
	                    }, password)),
	                    password.error && password.touched && _react2['default'].createElement('div', { className: 'text-danger', dangerouslySetInnerHTML: { __html: password.error } })
	                  )
	                )
	              )
	            )
	          ),
	          _react2['default'].createElement(
	            _reactBootstrap.Modal.Footer,
	            null,
	            _react2['default'].createElement(
	              'button',
	              { type: 'submit',
	                className: 'btn btn-primary spinnerButton ' + (submitting ? 'disabled' : '') },
	              _react2['default'].createElement(
	                'div',
	                { className: 'buttonContent' },
	                _react2['default'].createElement(
	                  'div',
	                  { className: 'buttonText' },
	                  submitting ? 'Submitting' : 'Submit'
	                ),
	                submitting && _react2['default'].createElement(
	                  'div',
	                  { className: 'spinnerWrapper' },
	                  _react2['default'].createElement(_reactSpinner2['default'], null)
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }], [{
	    key: 'propTypes',
	    value: {
	      showModal: _react.PropTypes.bool.isRequired,
	      closeModal: _react.PropTypes.func.isRequired,
	      fields: _react.PropTypes.object.isRequired,
	      handleSubmit: _react.PropTypes.func.isRequired,
	      submitting: _react.PropTypes.bool.isRequired
	    },
	    enumerable: true
	  }]);
	
	  var _ChangeEmailModal = ChangeEmailModal;
	  ChangeEmailModal = (0, _reduxForm.connectReduxForm)({
	    form: 'changeEmail',
	    fields: ['email', 'password', 'alert'],
	    validate: _utilsValidateNormalize.validateChangeEmail
	  })(ChangeEmailModal) || ChangeEmailModal;
	  return ChangeEmailModal;
	})(_react.Component);
	
	exports['default'] = ChangeEmailModal;
	module.exports = exports['default'];

/***/ }),
/* 1134 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _get = __webpack_require__(8)['default'];
	
	var _inherits = __webpack_require__(5)['default'];
	
	var _createClass = __webpack_require__(6)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _extends = __webpack_require__(7)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _vendorReactUxPasswordFieldSrc = __webpack_require__(303);
	
	var _vendorReactUxPasswordFieldSrc2 = _interopRequireDefault(_vendorReactUxPasswordFieldSrc);
	
	var _reactBootstrap = __webpack_require__(24);
	
	var _reduxForm = __webpack_require__(36);
	
	var _utilsValidateNormalize = __webpack_require__(75);
	
	var _reactSpinner = __webpack_require__(51);
	
	var _reactSpinner2 = _interopRequireDefault(_reactSpinner);
	
	__webpack_require__(120);
	
	__webpack_require__(198);
	
	var ChangePasswordModal = (function (_Component) {
	  _inherits(ChangePasswordModal, _Component);
	
	  function ChangePasswordModal() {
	    _classCallCheck(this, _ChangePasswordModal);
	
	    _get(Object.getPrototypeOf(_ChangePasswordModal.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(ChangePasswordModal, [{
	    key: 'handleSubmit',
	    value: function handleSubmit(evt) {
	      var _props = this.props;
	      var alert = _props.fields.alert;
	      var handleSubmit = _props.handleSubmit;
	
	      alert.submitError = false;
	      handleSubmit(evt);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props;
	      var showModal = _props2.showModal;
	      var closeModal = _props2.closeModal;
	      var _props2$fields = _props2.fields;
	      var alert = _props2$fields.alert;
	      var oldPassword = _props2$fields.oldPassword;
	      var newPassword = _props2$fields.newPassword;
	      var submitting = _props2.submitting;
	
	      return _react2['default'].createElement(
	        _reactBootstrap.Modal,
	        { show: showModal, onHide: closeModal },
	        _react2['default'].createElement(
	          _reactBootstrap.Modal.Header,
	          { closeButton: true },
	          _react2['default'].createElement(
	            _reactBootstrap.Modal.Title,
	            null,
	            'Change Password'
	          )
	        ),
	        _react2['default'].createElement(
	          'form',
	          { onSubmit: this.handleSubmit.bind(this) },
	          _react2['default'].createElement(
	            _reactBootstrap.Modal.Body,
	            null,
	            alert.error && _react2['default'].createElement(
	              'div',
	              { className: 'form-group' },
	              _react2['default'].createElement('div', { className: 'alert alert-danger', dangerouslySetInnerHTML: { __html: alert.error } })
	            ),
	            _react2['default'].createElement(
	              'div',
	              { className: 'row form-horizontal' },
	              _react2['default'].createElement(
	                'div',
	                { className: 'col-sm-10' },
	                _react2['default'].createElement(
	                  'div',
	                  {
	                    className: 'form-group ' + (oldPassword.error && oldPassword.touched ? 'has-error' : '') },
	                  _react2['default'].createElement(
	                    'label',
	                    {
	                      htmlFor: 'txtOldPassword',
	                      className: 'col-sm-4 control-label' },
	                    'Old Password'
	                  ),
	                  _react2['default'].createElement(
	                    'div',
	                    { className: 'col-sm-7' },
	                    _react2['default'].createElement('input', _extends({
	                      id: 'txtOldPassword',
	                      type: 'password',
	                      className: 'form-control',
	                      placeholder: 'thoo!mu3Da'
	                    }, oldPassword)),
	                    oldPassword.error && oldPassword.touched && _react2['default'].createElement('div', { className: 'text-danger', dangerouslySetInnerHTML: { __html: oldPassword.error } })
	                  )
	                ),
	                _react2['default'].createElement(
	                  'div',
	                  {
	                    className: 'form-group ' + (newPassword.error && newPassword.touched ? 'has-error' : '') },
	                  _react2['default'].createElement(
	                    'label',
	                    {
	                      htmlFor: 'txtNewPassword',
	                      className: 'col-sm-4 control-label' },
	                    'New Password'
	                  ),
	                  _react2['default'].createElement(
	                    'div',
	                    { className: 'col-sm-7' },
	                    _react2['default'].createElement(_vendorReactUxPasswordFieldSrc2['default'], _extends({
	                      id: 'txtNewPassword',
	                      className: 'form-control',
	                      placeholder: 'thoo!mu3Da',
	                      autoComplete: 'off',
	                      minLength: 8,
	                      toggleMask: false
	                    }, newPassword)),
	                    newPassword.error && newPassword.touched && _react2['default'].createElement('div', { className: 'text-danger', dangerouslySetInnerHTML: { __html: newPassword.error } })
	                  )
	                )
	              )
	            )
	          ),
	          _react2['default'].createElement(
	            _reactBootstrap.Modal.Footer,
	            null,
	            _react2['default'].createElement(
	              'button',
	              { type: 'submit',
	                className: 'btn btn-primary spinnerButton ' + (submitting ? 'disabled' : '') },
	              _react2['default'].createElement(
	                'div',
	                { className: 'buttonContent' },
	                _react2['default'].createElement(
	                  'div',
	                  { className: 'buttonText' },
	                  submitting ? 'Changing' : 'Change'
	                ),
	                submitting && _react2['default'].createElement(
	                  'div',
	                  { className: 'spinnerWrapper' },
	                  _react2['default'].createElement(_reactSpinner2['default'], null)
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }], [{
	    key: 'propTypes',
	    value: {
	      showModal: _react.PropTypes.bool.isRequired,
	      closeModal: _react.PropTypes.func.isRequired,
	      fields: _react.PropTypes.object.isRequired,
	      handleSubmit: _react.PropTypes.func.isRequired,
	      submitting: _react.PropTypes.bool.isRequired
	    },
	    enumerable: true
	  }]);
	
	  var _ChangePasswordModal = ChangePasswordModal;
	  ChangePasswordModal = (0, _reduxForm.connectReduxForm)({
	    form: 'changePassword',
	    fields: ['oldPassword', 'newPassword', 'alert'],
	    validate: _utilsValidateNormalize.validateChangePassword
	  })(ChangePasswordModal) || ChangePasswordModal;
	  return ChangePasswordModal;
	})(_react.Component);
	
	exports['default'] = ChangePasswordModal;
	module.exports = exports['default'];

/***/ }),
/* 1135 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _get = __webpack_require__(8)['default'];
	
	var _inherits = __webpack_require__(5)['default'];
	
	var _createClass = __webpack_require__(6)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(22);
	
	var _actionsAuthActions = __webpack_require__(37);
	
	var _changeTempPasswordForm = __webpack_require__(1136);
	
	var _changeTempPasswordForm2 = _interopRequireDefault(_changeTempPasswordForm);
	
	var _changeTempPasswordSuccess = __webpack_require__(1137);
	
	var _changeTempPasswordSuccess2 = _interopRequireDefault(_changeTempPasswordSuccess);
	
	var ChangeTempPassword = (function (_Component) {
	  _inherits(ChangeTempPassword, _Component);
	
	  _createClass(ChangeTempPassword, null, [{
	    key: 'propTypes',
	    value: {
	      auth: _react.PropTypes.object,
	      resetChangePasswordForm: _react.PropTypes.func.isRequired,
	      changePassword: _react.PropTypes.func.isRequired
	    },
	    enumerable: true
	  }]);
	
	  function ChangeTempPassword(props) {
	    _classCallCheck(this, _ChangeTempPassword);
	
	    _get(Object.getPrototypeOf(_ChangeTempPassword.prototype), 'constructor', this).call(this, props);
	    this.state = {
	      accepted: false
	    };
	  }
	
	  _createClass(ChangeTempPassword, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _props = this.props;
	      var auth = _props.auth;
	      var resetForm = _props.resetChangePasswordForm;
	
	      if (auth) {
	        resetForm(auth.tempPassword);
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var oldTempPassword = this.props.auth.tempPassword;
	      var newTempPassword = nextProps.auth.tempPassword;
	      var resetForm = nextProps.resetChangePasswordForm;
	
	      if (newTempPassword !== oldTempPassword) {
	        resetForm(newTempPassword);
	      }
	    }
	  }, {
	    key: 'handleSubmit',
	    value: function handleSubmit(data) {
	      var _this = this;
	
	      var email = this.props.auth.authData.password.email;
	      var oldPassword = data.oldPassword;
	      var newPassword = data.newPassword;
	
	      return this.props.changePassword({
	        email: email,
	        oldPassword: oldPassword,
	        newPassword: newPassword
	      }).then(function () {
	        _this.setState({
	          accepted: true
	        });
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var tempPassword = this.props.auth.tempPassword;
	      var accepted = this.state.accepted;
	
	      if (!accepted) {
	        return _react2['default'].createElement(
	          'div',
	          null,
	          _react2['default'].createElement(
	            'h1',
	            null,
	            'Choose a New Password'
	          ),
	          _react2['default'].createElement(
	            'p',
	            null,
	            'Please create a new password to replace your temporary password.'
	          ),
	          _react2['default'].createElement(_changeTempPasswordForm2['default'], {
	            tempPassword: tempPassword,
	            onSubmit: this.handleSubmit.bind(this) })
	        );
	      } else {
	        return _react2['default'].createElement(_changeTempPasswordSuccess2['default'], null);
	      }
	    }
	  }]);
	
	  var _ChangeTempPassword = ChangeTempPassword;
	  ChangeTempPassword = (0, _reactRedux.connect)(function (state) {
	    return {
	      auth: state.auth
	    };
	  }, {
	    resetChangePasswordForm: _actionsAuthActions.resetChangePasswordForm,
	    changePassword: _actionsAuthActions.changePassword
	  })(ChangeTempPassword) || ChangeTempPassword;
	  return ChangeTempPassword;
	})(_react.Component);
	
	exports['default'] = ChangeTempPassword;
	module.exports = exports['default'];

/***/ }),
/* 1136 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _get = __webpack_require__(8)['default'];
	
	var _inherits = __webpack_require__(5)['default'];
	
	var _createClass = __webpack_require__(6)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _extends = __webpack_require__(7)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _vendorReactUxPasswordFieldSrc = __webpack_require__(303);
	
	var _vendorReactUxPasswordFieldSrc2 = _interopRequireDefault(_vendorReactUxPasswordFieldSrc);
	
	var _reduxForm = __webpack_require__(36);
	
	var _utilsValidateNormalize = __webpack_require__(75);
	
	var _reactSpinner = __webpack_require__(51);
	
	var _reactSpinner2 = _interopRequireDefault(_reactSpinner);
	
	__webpack_require__(120);
	
	__webpack_require__(198);
	
	var ChangeTempPasswordForm = (function (_Component) {
	  _inherits(ChangeTempPasswordForm, _Component);
	
	  function ChangeTempPasswordForm() {
	    _classCallCheck(this, _ChangeTempPasswordForm);
	
	    _get(Object.getPrototypeOf(_ChangeTempPasswordForm.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(ChangeTempPasswordForm, [{
	    key: 'handleSubmit',
	    value: function handleSubmit(evt) {
	      var _props = this.props;
	      var alert = _props.fields.alert;
	      var handleSubmit = _props.handleSubmit;
	
	      alert.submitError = false;
	      handleSubmit(evt);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props;
	      var tempPassword = _props2.tempPassword;
	      var _props2$fields = _props2.fields;
	      var alert = _props2$fields.alert;
	      var oldPassword = _props2$fields.oldPassword;
	      var newPassword = _props2$fields.newPassword;
	      var submitting = _props2.submitting;
	
	      return _react2['default'].createElement(
	        'form',
	        {
	          className: 'form-horizontal',
	          onSubmit: this.handleSubmit.bind(this) },
	        alert.error && _react2['default'].createElement(
	          'div',
	          { className: 'form-group' },
	          _react2['default'].createElement('div', { className: 'alert alert-danger', dangerouslySetInnerHTML: { __html: alert.error } })
	        ),
	        _react2['default'].createElement(
	          'div',
	          { className: 'row' },
	          _react2['default'].createElement(
	            'div',
	            { className: 'col-sm-8 col-md-6' },
	            (!tempPassword || !oldPassword.value || oldPassword.error) && _react2['default'].createElement(
	              'div',
	              {
	                className: 'form-group ' + (oldPassword.error && oldPassword.touched ? 'has-error' : '') },
	              _react2['default'].createElement(
	                'label',
	                {
	                  htmlFor: 'txtOldPassword',
	                  className: 'col-sm-2 control-label' },
	                'Temporary Password'
	              ),
	              _react2['default'].createElement(
	                'div',
	                { className: 'col-sm-9' },
	                _react2['default'].createElement('input', _extends({
	                  id: 'txtOldPassword',
	                  type: 'password',
	                  className: 'form-control',
	                  placeholder: 'thoo!mu3Da'
	                }, oldPassword)),
	                oldPassword.error && oldPassword.touched && _react2['default'].createElement('div', { className: 'text-danger', dangerouslySetInnerHTML: { __html: oldPassword.error } })
	              )
	            ),
	            _react2['default'].createElement(
	              'div',
	              {
	                className: 'form-group ' + (newPassword.error && newPassword.touched ? 'has-error' : '') },
	              _react2['default'].createElement(
	                'label',
	                {
	                  htmlFor: 'txtNewPassword',
	                  className: 'col-sm-2 control-label' },
	                'New Password'
	              ),
	              _react2['default'].createElement(
	                'div',
	                { className: 'col-sm-9' },
	                _react2['default'].createElement(_vendorReactUxPasswordFieldSrc2['default'], _extends({
	                  id: 'txtNewPassword',
	                  className: 'form-control',
	                  placeholder: 'thoo!mu3Da',
	                  autoComplete: 'off',
	                  minLength: 8,
	                  toggleMask: false
	                }, newPassword)),
	                newPassword.error && newPassword.touched && _react2['default'].createElement('div', { className: 'text-danger', dangerouslySetInnerHTML: { __html: newPassword.error } })
	              )
	            )
	          )
	        ),
	        _react2['default'].createElement(
	          'button',
	          { type: 'submit',
	            className: 'btn btn-primary spinnerButton ' + (submitting ? 'disabled' : '') },
	          _react2['default'].createElement(
	            'div',
	            { className: 'buttonContent' },
	            _react2['default'].createElement(
	              'div',
	              { className: 'buttonText' },
	              submitting ? 'Changing' : 'Change'
	            ),
	            submitting && _react2['default'].createElement(
	              'div',
	              { className: 'spinnerWrapper' },
	              _react2['default'].createElement(_reactSpinner2['default'], null)
	            )
	          )
	        )
	      );
	    }
	  }], [{
	    key: 'propTypes',
	    value: {
	      tempPassword: _react.PropTypes.string,
	      fields: _react.PropTypes.object.isRequired,
	      handleSubmit: _react.PropTypes.func.isRequired,
	      submitting: _react.PropTypes.bool.isRequired
	    },
	    enumerable: true
	  }]);
	
	  var _ChangeTempPasswordForm = ChangeTempPasswordForm;
	  ChangeTempPasswordForm = (0, _reduxForm.connectReduxForm)({
	    form: 'changePassword',
	    fields: ['oldPassword', 'newPassword', 'alert'],
	    validate: _utilsValidateNormalize.validateChangePassword
	  })(ChangeTempPasswordForm) || ChangeTempPasswordForm;
	  return ChangeTempPasswordForm;
	})(_react.Component);
	
	exports['default'] = ChangeTempPasswordForm;
	module.exports = exports['default'];

/***/ }),
/* 1137 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _get = __webpack_require__(8)['default'];
	
	var _inherits = __webpack_require__(5)['default'];
	
	var _createClass = __webpack_require__(6)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(66);
	
	var ChangeTempPasswordSuccess = (function (_Component) {
	  _inherits(ChangeTempPasswordSuccess, _Component);
	
	  function ChangeTempPasswordSuccess() {
	    _classCallCheck(this, ChangeTempPasswordSuccess);
	
	    _get(Object.getPrototypeOf(ChangeTempPasswordSuccess.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(ChangeTempPasswordSuccess, [{
	    key: 'render',
	    value: function render() {
	      return _react2['default'].createElement(
	        'div',
	        null,
	        _react2['default'].createElement(
	          'h1',
	          null,
	          'Password Changed!'
	        ),
	        _react2['default'].createElement(
	          _reactRouter.Link,
	          { to: '/', className: 'btn btn-lg btn-primary' },
	          'Return to Dashboard'
	        )
	      );
	    }
	  }]);
	
	  return ChangeTempPasswordSuccess;
	})(_react.Component);
	
	exports['default'] = ChangeTempPasswordSuccess;
	module.exports = exports['default'];

/***/ }),
/* 1138 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _get = __webpack_require__(8)['default'];
	
	var _inherits = __webpack_require__(5)['default'];
	
	var _createClass = __webpack_require__(6)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(24);
	
	var _helpersMarkdownScript = __webpack_require__(9);
	
	var _helpersMarkdownScript2 = _interopRequireDefault(_helpersMarkdownScript);
	
	var _dataUsageMd = __webpack_require__(723);
	
	var _dataUsageMd2 = _interopRequireDefault(_dataUsageMd);
	
	var md = new _helpersMarkdownScript2['default'](_dataUsageMd2['default']);
	
	var dataUsageModal = (function (_Component) {
	  _inherits(dataUsageModal, _Component);
	
	  function dataUsageModal() {
	    _classCallCheck(this, dataUsageModal);
	
	    _get(Object.getPrototypeOf(dataUsageModal.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(dataUsageModal, [{
	    key: 'render',
	    value: function render() {
	      return _react2['default'].createElement(
	        _reactBootstrap.Modal,
	        {
	          show: this.props.showModal,
	          onHide: this.props.closeModal
	        },
	        _react2['default'].createElement(
	          _reactBootstrap.Modal.Body,
	          null,
	          _react2['default'].createElement('div', { dangerouslySetInnerHTML: { __html: md.getAllAsHtml() } })
	        ),
	        _react2['default'].createElement(
	          _reactBootstrap.Modal.Footer,
	          null,
	          _react2['default'].createElement(
	            _reactBootstrap.Button,
	            { onClick: this.props.closeModal() },
	            'Close'
	          )
	        )
	      );
	    }
	  }], [{
	    key: 'propTypes',
	    value: {
	      showModal: _react.PropTypes.bool.isRequired,
	      closeModal: _react.PropTypes.func.isRequired
	    },
	    enumerable: true
	  }]);
	
	  return dataUsageModal;
	})(_react.Component);
	
	exports['default'] = dataUsageModal;
	module.exports = exports['default'];

/***/ }),
/* 1139 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _get = __webpack_require__(8)['default'];
	
	var _inherits = __webpack_require__(5)['default'];
	
	var _createClass = __webpack_require__(6)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _extends = __webpack_require__(7)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(22);
	
	var _actionsAuthActions = __webpack_require__(37);
	
	var _actionsProfileActions = __webpack_require__(103);
	
	var _editProfileForm = __webpack_require__(1140);
	
	var _editProfileForm2 = _interopRequireDefault(_editProfileForm);
	
	var _editProfileSuccess = __webpack_require__(1141);
	
	var _editProfileSuccess2 = _interopRequireDefault(_editProfileSuccess);
	
	var EditProfile = (function (_Component) {
	  _inherits(EditProfile, _Component);
	
	  _createClass(EditProfile, null, [{
	    key: 'propTypes',
	    value: {
	      auth: _react.PropTypes.object.isRequired,
	      updateProfile: _react.PropTypes.func.isRequired,
	      resetRegisterEditProfileForm: _react.PropTypes.func.isRequired,
	      resetChangeEmailForm: _react.PropTypes.func.isRequired,
	      resetChangePasswordForm: _react.PropTypes.func.isRequired,
	      changeEmail: _react.PropTypes.func.isRequired,
	      changePassword: _react.PropTypes.func.isRequired,
	      profile: _react.PropTypes.object.isRequired
	    },
	    enumerable: true
	  }, {
	    key: 'contextTypes',
	    value: {
	      userId: _react.PropTypes.string.isRequired,
	      location: _react.PropTypes.object.isRequired
	    },
	    enumerable: true
	  }]);
	
	  function EditProfile(props) {
	    _classCallCheck(this, _EditProfile);
	
	    _get(Object.getPrototypeOf(_EditProfile.prototype), 'constructor', this).call(this, props);
	    this.state = {
	      accepted: false
	    };
	  }
	
	  _createClass(EditProfile, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _props$profile = this.props.profile;
	      var firstName = _props$profile.firstName;
	      var lastName = _props$profile.lastName;
	      var phone = _props$profile.phone;
	      var country = _props$profile.country;
	      var cityOrMunicipality = _props$profile.cityOrMunicipality;
	      var stateOrProvince = _props$profile.stateOrProvince;
	      var school = _props$profile.school;
	      var marketingOptIn = _props$profile.marketingOptIn;
	      var gettingStartedOptIn = _props$profile.gettingStartedOptIn;
	      var directPromotionOptIn = _props$profile.directPromotionOptIn;
	
	      this.props.resetRegisterEditProfileForm({
	        firstName: firstName,
	        lastName: lastName,
	        phone: phone,
	        country: country,
	        cityOrMunicipality: cityOrMunicipality,
	        stateOrProvince: stateOrProvince,
	        school: school,
	        marketingOptIn: marketingOptIn,
	        gettingStartedOptIn: gettingStartedOptIn,
	        directPromotionOptIn: directPromotionOptIn
	      });
	    }
	  }, {
	    key: 'handleSubmit',
	    value: function handleSubmit(data) {
	      var _this = this;
	
	      var userId = this.context.userId;
	      var _props = this.props;
	      var emailFromProfile = _props.profile.email;
	      var emailFromAuth = _props.auth.authData.email;
	
	      return this.props.updateProfile(userId, _extends({}, data, {
	        email: emailFromProfile || emailFromAuth
	      })).then(function () {
	        _this.setState({
	          accepted: true
	        });
	      })['catch'](function () {
	        var errors = {
	          alert: 'Oops, there was a problem updating your profile. Please try again!'
	        };
	        throw errors;
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var userId = this.context.userId;
	      var _props2 = this.props;
	      var emailFromProfile = _props2.profile.email;
	      var emailFromAuth = _props2.auth.authData.email;
	
	      var email = emailFromProfile || emailFromAuth;
	      var accepted = this.state.accepted;
	
	      if (!accepted) {
	        return _react2['default'].createElement(_editProfileForm2['default'], {
	          userId: userId,
	          email: email,
	          resetChangeEmailForm: this.props.resetChangeEmailForm,
	          resetChangePasswordForm: this.props.resetChangePasswordForm,
	          changeEmail: this.props.changeEmail,
	          changePassword: this.props.changePassword,
	          onSubmit: this.handleSubmit.bind(this) });
	      } else {
	        return _react2['default'].createElement(_editProfileSuccess2['default'], null);
	      }
	    }
	  }]);
	
	  var _EditProfile = EditProfile;
	  EditProfile = (0, _reactRedux.connect)(function (state) {
	    return {
	      auth: state.auth,
	      profile: state.profile
	    };
	  }, {
	    updateProfile: _actionsProfileActions.updateProfile,
	    resetRegisterEditProfileForm: _actionsAuthActions.resetRegisterEditProfileForm,
	    resetChangeEmailForm: _actionsAuthActions.resetChangeEmailForm,
	    resetChangePasswordForm: _actionsAuthActions.resetChangePasswordForm,
	    changeEmail: _actionsAuthActions.changeEmail,
	    changePassword: _actionsAuthActions.changePassword
	  })(EditProfile) || EditProfile;
	  return EditProfile;
	})(_react.Component);
	
	exports['default'] = EditProfile;
	module.exports = exports['default'];

/***/ }),
/* 1140 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _get = __webpack_require__(8)['default'];
	
	var _inherits = __webpack_require__(5)['default'];
	
	var _createClass = __webpack_require__(6)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reduxForm = __webpack_require__(36);
	
	var _utilsValidateNormalize = __webpack_require__(75);
	
	var _registrationComponents = __webpack_require__(304);
	
	var _servicesRegionalization = __webpack_require__(38);
	
	var _servicesRegionalization2 = _interopRequireDefault(_servicesRegionalization);
	
	var _changeEmailModal = __webpack_require__(1133);
	
	var _changeEmailModal2 = _interopRequireDefault(_changeEmailModal);
	
	var _changePasswordModal = __webpack_require__(1134);
	
	var _changePasswordModal2 = _interopRequireDefault(_changePasswordModal);
	
	__webpack_require__(2197);
	
	var EditProfileForm = (function (_Component) {
	  _inherits(EditProfileForm, _Component);
	
	  _createClass(EditProfileForm, null, [{
	    key: 'propTypes',
	    value: {
	      fields: _react.PropTypes.shape({
	        alert: _react.PropTypes.object.isRequired,
	        firstName: _react.PropTypes.object.isRequired,
	        lastName: _react.PropTypes.object.isRequired,
	        phone: _react.PropTypes.object,
	        cityOrMunicipality: _react.PropTypes.object.isRequired,
	        stateOrProvince: _react.PropTypes.object.isRequired,
	        country: _react.PropTypes.object.isRequired,
	        school: _react.PropTypes.object.isRequired,
	        gettingStartedOptIn: _react.PropTypes.object.isRequired,
	        directPromotionOptIn: _react.PropTypes.object.isRequired,
	        marketingOptIn: _react.PropTypes.object.isRequired
	      }).isRequired,
	      submitting: _react.PropTypes.bool.isRequired,
	      userId: _react.PropTypes.string,
	      email: _react.PropTypes.string,
	      resetChangeEmailForm: _react.PropTypes.func,
	      resetChangePasswordForm: _react.PropTypes.func,
	      changeEmail: _react.PropTypes.func,
	      changePassword: _react.PropTypes.func,
	      completeRegistration: _react.PropTypes.bool
	    },
	    enumerable: true
	  }]);
	
	  function EditProfileForm(props) {
	    _classCallCheck(this, _EditProfileForm);
	
	    _get(Object.getPrototypeOf(_EditProfileForm.prototype), 'constructor', this).call(this, props);
	    this.state = {
	      showChangeEmailModal: false,
	      showChangePasswordModal: false,
	      personRegistrationFormData: [],
	      personalRegistrationFormMode: true,
	      schoolRegistrationFormData: [],
	      isFirstPage: !props.completeRegistration,
	      isSubmitting: false
	    };
	    this.countries = _servicesRegionalization2['default'].getCountries();
	  }
	
	  _createClass(EditProfileForm, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.fields.country.value !== this.props.fields.country.value) {
	        var defaultValue = _servicesRegionalization2['default'].hasStatesOrProvinces(nextProps.fields.country.value) ? '' : 'Other';
	        this.props.fields.stateOrProvince.onChange(defaultValue);
	      }
	    }
	  }, {
	    key: 'openChangeEmail',
	    value: function openChangeEmail(evt) {
	      var resetChangeEmailForm = this.props.resetChangeEmailForm;
	
	      resetChangeEmailForm();
	      this.setState({ showChangeEmailModal: true });
	      evt.preventDefault();
	      evt.stopPropagation();
	      evt.nativeEvent.stopPropagation();
	    }
	  }, {
	    key: 'closeChangeEmail',
	    value: function closeChangeEmail() {
	      this.setState({ showChangeEmailModal: false });
	    }
	  }, {
	    key: 'handleChangeEmailSubmit',
	    value: function handleChangeEmailSubmit(data) {
	      var _this = this;
	
	      var newEmail = data.email;
	      var password = data.password;
	      var _props = this.props;
	      var changeEmail = _props.changeEmail;
	      var userId = _props.userId;
	      var oldEmail = _props.email;
	
	      return changeEmail({
	        userId: userId,
	        oldEmail: oldEmail,
	        newEmail: newEmail,
	        password: password
	      }).then(function () {
	        _this.closeChangeEmail();
	      });
	    }
	  }, {
	    key: 'openChangePassword',
	    value: function openChangePassword(evt) {
	      var resetChangePasswordForm = this.props.resetChangePasswordForm;
	
	      resetChangePasswordForm();
	      this.setState({ showChangePasswordModal: true });
	      evt.preventDefault();
	      evt.stopPropagation();
	      evt.nativeEvent.stopPropagation();
	    }
	  }, {
	    key: 'closeChangePassword',
	    value: function closeChangePassword() {
	      this.setState({ showChangePasswordModal: false });
	    }
	  }, {
	    key: 'handleChangePasswordSubmit',
	    value: function handleChangePasswordSubmit(data) {
	      var _this2 = this;
	
	      var _props2 = this.props;
	      var changePassword = _props2.changePassword;
	      var email = _props2.email;
	      var oldPassword = data.oldPassword;
	      var newPassword = data.newPassword;
	
	      return changePassword({
	        email: email,
	        oldPassword: oldPassword,
	        newPassword: newPassword
	      }).then(function () {
	        _this2.closeChangePassword();
	      });
	    }
	  }, {
	    key: 'handleSubmit',
	    value: function handleSubmit(evt) {
	      this.setState(function (prevState) {
	        return {
	          isSubmitting: !prevState.isSubmitting
	        };
	      });
	      this.props.handleSubmit(evt);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props;
	      var _props3$fields = _props3.fields;
	      var alert = _props3$fields.alert;
	      var firstName = _props3$fields.firstName;
	      var lastName = _props3$fields.lastName;
	      var phone = _props3$fields.phone;
	      var cityOrMunicipality = _props3$fields.cityOrMunicipality;
	      var stateOrProvince = _props3$fields.stateOrProvince;
	      var country = _props3$fields.country;
	      var school = _props3$fields.school;
	      var directPromotionOptIn = _props3$fields.directPromotionOptIn;
	      var gettingStartedOptIn = _props3$fields.gettingStartedOptIn;
	      var marketingOptIn = _props3$fields.marketingOptIn;
	      var email = _props3.email;
	      var invalid = _props3.invalid;
	
	      var statesOrProvinces = _servicesRegionalization2['default'].getStatesOrProvinces(country.value);
	      if (statesOrProvinces.length === 1) {
	        stateOrProvince.disabled = true;
	      }
	
	      return _react2['default'].createElement(
	        'div',
	        { className: 'col-lg-8 col-md-8 col-sm-6' },
	        _react2['default'].createElement(
	          'div',
	          null,
	          _react2['default'].createElement(
	            'h4',
	            { className: 'adminPageTitle' },
	            'Edit Profile'
	          ),
	          alert.error && _react2['default'].createElement(
	            'div',
	            { className: 'form-group' },
	            _react2['default'].createElement('div', { className: 'alert alert-danger', dangerouslySetInnerHTML: { __html: alert.error } })
	          ),
	          _react2['default'].createElement(
	            'h3',
	            null,
	            'Personal'
	          ),
	          _react2['default'].createElement('hr', null),
	          _react2['default'].createElement(_registrationComponents.GetFirstName, { firstName: firstName }),
	          _react2['default'].createElement(_registrationComponents.GetLastName, { lastName: lastName }),
	          _react2['default'].createElement(_registrationComponents.GetPhone, { phone: phone }),
	          _react2['default'].createElement(
	            'h3',
	            null,
	            'Account'
	          ),
	          _react2['default'].createElement('hr', null),
	          _react2['default'].createElement(
	            'div',
	            { className: 'form-group' },
	            _react2['default'].createElement(
	              'label',
	              { htmlFor: 'txtEmail', className: 'control-label' },
	              'Email'
	            ),
	            _react2['default'].createElement(
	              'div',
	              null,
	              email,
	              ' ',
	              _react2['default'].createElement(
	                'button',
	                { className: 'btn btn-default btn-sm', onClick: this.openChangeEmail.bind(this) },
	                'Change email'
	              )
	            ),
	            _react2['default'].createElement(_changeEmailModal2['default'], { showModal: this.state.showChangeEmailModal,
	              closeModal: this.closeChangeEmail.bind(this),
	              onSubmit: this.handleChangeEmailSubmit.bind(this) })
	          ),
	          _react2['default'].createElement(
	            'div',
	            { className: 'form-group' },
	            _react2['default'].createElement(
	              'label',
	              { htmlFor: 'txtPassword', className: 'control-label' },
	              'Password'
	            ),
	            _react2['default'].createElement(
	              'div',
	              null,
	              _react2['default'].createElement(
	                'button',
	                { className: 'btn btn-default btn-sm', onClick: this.openChangePassword.bind(this) },
	                'Change password'
	              )
	            ),
	            _react2['default'].createElement(_changePasswordModal2['default'], { showModal: this.state.showChangePasswordModal,
	              closeModal: this.closeChangePassword.bind(this),
	              onSubmit: this.handleChangePasswordSubmit.bind(this) })
	          ),
	          _react2['default'].createElement(
	            'h3',
	            null,
	            'School'
	          ),
	          _react2['default'].createElement('hr', null),
	          _react2['default'].createElement(_registrationComponents.GetCountry, { country: country, countries: this.countries }),
	          _react2['default'].createElement(_registrationComponents.GetStatesOrProvince, { stateOrProvince: stateOrProvince, statesOrProvinces: statesOrProvinces }),
	          _react2['default'].createElement(_registrationComponents.GetCity, { cityOrMunicipality: cityOrMunicipality }),
	          _react2['default'].createElement(_registrationComponents.GetSchool, { school: school }),
	          _react2['default'].createElement(
	            'h3',
	            null,
	            'Communications'
	          ),
	          _react2['default'].createElement('hr', null),
	          _react2['default'].createElement(_registrationComponents.GetOptIn, { label: 'Help to get started from a real human (1-4 messages per month)', optIn: gettingStartedOptIn }),
	          _react2['default'].createElement(_registrationComponents.GetOptIn, { label: 'Information about free programs in my area (2-4 messages per year)', optIn: directPromotionOptIn }),
	          _react2['default'].createElement(_registrationComponents.GetOptIn, { label: 'Newsletter with exclusive content and product news (4-6 messages per year)', optIn: marketingOptIn }),
	          _react2['default'].createElement(
	            'button',
	            {
	              onClick: this.handleSubmit.bind(this),
	              disabled: invalid,
	              className: 'btn btn-lg btn-primary spinnerButton'
	            },
	            'Submit'
	          )
	        )
	      );
	    }
	  }]);
	
	  var _EditProfileForm = EditProfileForm;
	  EditProfileForm = (0, _reduxForm.connectReduxForm)({
	    form: 'registerEditProfile',
	    fields: ['alert', 'firstName', 'lastName', 'phone', 'cityOrMunicipality', 'stateOrProvince', 'country', 'school', 'directPromotionOptIn', 'gettingStartedOptIn', 'marketingOptIn'],
	    validate: _utilsValidateNormalize.validateEditProfile
	  })(EditProfileForm) || EditProfileForm;
	  return EditProfileForm;
	})(_react.Component);
	
	exports['default'] = EditProfileForm;
	module.exports = exports['default'];

/***/ }),
/* 1141 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _get = __webpack_require__(8)['default'];
	
	var _inherits = __webpack_require__(5)['default'];
	
	var _createClass = __webpack_require__(6)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(66);
	
	var EditProfileSuccess = (function (_Component) {
	  _inherits(EditProfileSuccess, _Component);
	
	  function EditProfileSuccess() {
	    _classCallCheck(this, EditProfileSuccess);
	
	    _get(Object.getPrototypeOf(EditProfileSuccess.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(EditProfileSuccess, [{
	    key: 'render',
	    value: function render() {
	      var query = this.context.location.query;
	
	      return _react2['default'].createElement(
	        'div',
	        null,
	        _react2['default'].createElement(
	          'h1',
	          null,
	          'Profile Updated!'
	        ),
	        _react2['default'].createElement(
	          _reactRouter.Link,
	          { to: '/', query: query, className: 'btn btn-sm btn-primary' },
	          'Return to Dashboard'
	        )
	      );
	    }
	  }], [{
	    key: 'contextTypes',
	    value: {
	      location: _react.PropTypes.object.isRequired
	    },
	    enumerable: true
	  }]);
	
	  return EditProfileSuccess;
	})(_react.Component);
	
	exports['default'] = EditProfileSuccess;
	module.exports = exports['default'];

/***/ }),
/* 1142 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _get = __webpack_require__(8)['default'];
	
	var _inherits = __webpack_require__(5)['default'];
	
	var _createClass = __webpack_require__(6)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(22);
	
	var _actionsAuthActions = __webpack_require__(37);
	
	var _forgotPasswordForm = __webpack_require__(1143);
	
	var _forgotPasswordForm2 = _interopRequireDefault(_forgotPasswordForm);
	
	var ForgotPassword = (function (_Component) {
	  _inherits(ForgotPassword, _Component);
	
	  function ForgotPassword() {
	    _classCallCheck(this, _ForgotPassword);
	
	    _get(Object.getPrototypeOf(_ForgotPassword.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(ForgotPassword, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.props.resetForgotPasswordForm();
	    }
	  }, {
	    key: 'handleSubmit',
	    value: function handleSubmit(data) {
	      data.url = window.location.origin + '/signin?email=' + encodeURIComponent(data.email);
	      return this.props.sendPasswordReset(data);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var passwordResetSent = this.props.auth.passwordResetSent;
	
	      if (!passwordResetSent) {
	        return _react2['default'].createElement(_forgotPasswordForm2['default'], { onSubmit: this.handleSubmit.bind(this) });
	      } else {
	        return _react2['default'].createElement(
	          'div',
	          null,
	          _react2['default'].createElement(
	            'h2',
	            null,
	            'Password Reset Email Sent'
	          ),
	          _react2['default'].createElement(
	            'p',
	            null,
	            '"Please check your email inbox, and if you don\'t see an email from us shortly, be sure to check your junk/spam folder.'
	          )
	        );
	      }
	    }
	  }], [{
	    key: 'propTypes',
	    value: {
	      auth: _react.PropTypes.shape({
	        passwordResetSent: _react.PropTypes.bool.isRequired
	      }).isRequired,
	      sendPasswordReset: _react.PropTypes.func.isRequired,
	      resetForgotPasswordForm: _react.PropTypes.func.isRequired
	    },
	    enumerable: true
	  }]);
	
	  var _ForgotPassword = ForgotPassword;
	  ForgotPassword = (0, _reactRedux.connect)(function (state) {
	    return { auth: state.auth };
	  }, { sendPasswordReset: _actionsAuthActions.sendPasswordReset, resetForgotPasswordForm: _actionsAuthActions.resetForgotPasswordForm })(ForgotPassword) || ForgotPassword;
	  return ForgotPassword;
	})(_react.Component);
	
	exports['default'] = ForgotPassword;
	module.exports = exports['default'];

/***/ }),
/* 1143 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _get = __webpack_require__(8)['default'];
	
	var _inherits = __webpack_require__(5)['default'];
	
	var _createClass = __webpack_require__(6)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _extends = __webpack_require__(7)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reduxForm = __webpack_require__(36);
	
	var _utilsValidateNormalize = __webpack_require__(75);
	
	var _reactSpinner = __webpack_require__(51);
	
	var _reactSpinner2 = _interopRequireDefault(_reactSpinner);
	
	__webpack_require__(120);
	
	__webpack_require__(198);
	
	var ForgotPasswordForm = (function (_Component) {
	  _inherits(ForgotPasswordForm, _Component);
	
	  function ForgotPasswordForm() {
	    _classCallCheck(this, _ForgotPasswordForm);
	
	    _get(Object.getPrototypeOf(_ForgotPasswordForm.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(ForgotPasswordForm, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var _props$fields = _props.fields;
	      var alert = _props$fields.alert;
	      var email = _props$fields.email;
	      var handleSubmit = _props.handleSubmit;
	      var submitting = _props.submitting;
	
	      return _react2['default'].createElement(
	        'form',
	        { onSubmit: handleSubmit },
	        _react2['default'].createElement(
	          'h2',
	          null,
	          'Forgot password?'
	        ),
	        alert.error && _react2['default'].createElement(
	          'div',
	          { className: 'form-group' },
	          _react2['default'].createElement('div', { className: 'alert alert-danger', dangerouslySetInnerHTML: { __html: alert.error } })
	        ),
	        _react2['default'].createElement(
	          'div',
	          { className: 'row' },
	          _react2['default'].createElement(
	            'div',
	            { className: 'col-sm-8 col-md-6' },
	            _react2['default'].createElement(
	              'div',
	              { className: 'form-group ' + (email.error && email.touched && 'has-error') },
	              _react2['default'].createElement(
	                'label',
	                { htmlFor: 'txtEmail',
	                  className: 'control-label' },
	                'Enter email to request a password reset'
	              ),
	              _react2['default'].createElement('input', _extends({ id: 'txtEmail',
	                type: 'email',
	                className: 'form-control',
	                placeholder: 'jane@example.com',
	                spellCheck: 'false'
	              }, email)),
	              email.error && email.touched && _react2['default'].createElement('div', { className: 'text-danger', dangerouslySetInnerHTML: { __html: email.error } })
	            ),
	            _react2['default'].createElement(
	              'div',
	              { className: 'form-group' },
	              _react2['default'].createElement(
	                'button',
	                { type: 'submit',
	                  className: 'btn btn-primary spinnerButton ' + (submitting ? 'disabled' : '') },
	                _react2['default'].createElement(
	                  'div',
	                  { className: 'buttonContent' },
	                  _react2['default'].createElement(
	                    'div',
	                    { className: 'buttonText' },
	                    submitting ? 'Sending password reset email' : 'Send password reset email'
	                  ),
	                  submitting && _react2['default'].createElement(
	                    'div',
	                    { className: 'spinnerWrapper' },
	                    _react2['default'].createElement(_reactSpinner2['default'], null)
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }], [{
	    key: 'propTypes',
	    value: {
	      fields: _react.PropTypes.object.isRequired,
	      handleSubmit: _react.PropTypes.func.isRequired,
	      submitting: _react.PropTypes.bool.isRequired
	    },
	    enumerable: true
	  }]);
	
	  var _ForgotPasswordForm = ForgotPasswordForm;
	  ForgotPasswordForm = (0, _reduxForm.connectReduxForm)({
	    form: 'forgotPassword',
	    fields: ['email', 'alert', 'accepted'],
	    validate: _utilsValidateNormalize.validateForgotPassword
	  })(ForgotPasswordForm) || ForgotPasswordForm;
	  return ForgotPasswordForm;
	})(_react.Component);
	
	exports['default'] = ForgotPasswordForm;
	module.exports = exports['default'];

/***/ }),
/* 1144 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(22);
	
	var _reactRouter = __webpack_require__(66);
	
	var _actionsAuthActions = __webpack_require__(37);
	
	var Logout = _react2['default'].createClass({
	  displayName: 'Logout',
	
	  propTypes: {
	    logout: _react.PropTypes.func.isRequired
	  },
	  contextTypes: {
	    userId: _react.PropTypes.string.isRequired
	  },
	
	  mixins: [_reactRouter.Navigation],
	
	  componentDidMount: function componentDidMount() {
	    var userId = this.context.userId;
	
	    this.props.logout({ userId: userId });
	  },
	
	  render: function render() {
	    return _react2['default'].createElement(
	      'p',
	      null,
	      'You are now logged out'
	    );
	  }
	
	});
	
	exports['default'] = (0, _reactRedux.connect)(null, { logout: _actionsAuthActions.logout })(Logout);
	module.exports = exports['default'];

/***/ }),
/* 1145 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _get = __webpack_require__(8)['default'];
	
	var _inherits = __webpack_require__(5)['default'];
	
	var _createClass = __webpack_require__(6)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _extends = __webpack_require__(7)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(22);
	
	var _actionsAuthActions = __webpack_require__(37);
	
	var _actionsSessionActions = __webpack_require__(72);
	
	var _routerHistory = __webpack_require__(229);
	
	var _routerHistory2 = _interopRequireDefault(_routerHistory);
	
	var _registerForm = __webpack_require__(1146);
	
	var _registerForm2 = _interopRequireDefault(_registerForm);
	
	var _featureFlags = __webpack_require__(300);
	
	var _featureFlags2 = _interopRequireDefault(_featureFlags);
	
	var _servicesCookie = __webpack_require__(301);
	
	var _servicesPrograms = __webpack_require__(104);
	
	var Register = (function (_Component) {
	  _inherits(Register, _Component);
	
	  function Register() {
	    _classCallCheck(this, _Register);
	
	    _get(Object.getPrototypeOf(_Register.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(Register, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.props.resetRegisterEditProfileForm();
	    }
	  }, {
	    key: 'handleSubmit',
	    value: function handleSubmit(data) {
	      var _this = this;
	
	      var query = this.context.location.query;
	
	      var referral = (0, _servicesCookie.parseCookie)(tryGetCookieValue('ppa_referral')) || {};
	      var referrerUserId = referral.referrerUserId;
	      var referrerFirstName = referral.referrerFirstName;
	      var referrerLastName = referral.referrerLastName;
	      var referrerUniqueUrl = referral.referrerUniqueUrl;
	      var referredProgramId = referral.referredProgramId;
	
	      return this.props.register(_extends({}, data, {
	        referrerUserId: referrerUserId,
	        referrerFirstName: referrerFirstName,
	        referrerLastName: referrerLastName,
	        referrerUniqueUrl: referrerUniqueUrl,
	        referredProgramId: referredProgramId
	      })).then(function (userId) {
	        var featuredProgram = (0, _servicesPrograms.getFeaturedProgramHelper)();
	        if (_featureFlags2['default'].autoCreateClassWhenFeaturedProgramIsPresent && featuredProgram.found) {
	          var fpHelper = (0, _servicesPrograms.getFeaturedProgramHelper)();
	          return _this.props.createSession(userId, fpHelper.programId, {
	            language: fpHelper.featuredLanguage,
	            grade: '4',
	            divisionName: 'My Class',
	            numberOfStudents: 25,
	            pendingApproval: !query.contractId,
	            auto: true,
	            firstClass: true,
	            contractId: query.contractId,
	            referrerUserId: referrerUserId
	          });
	        }
	      }).then(function () {
	        _routerHistory2['default'].replaceState({ next: null }, '/');
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2['default'].createElement(_registerForm2['default'], { onSubmit: this.handleSubmit.bind(this) });
	    }
	  }], [{
	    key: 'propTypes',
	    value: {
	      auth: _react.PropTypes.object.isRequired,
	      register: _react.PropTypes.func.isRequired,
	      resetRegisterEditProfileForm: _react.PropTypes.func.isRequired,
	      createSession: _react.PropTypes.func.isRequired
	    },
	    enumerable: true
	  }, {
	    key: 'contextTypes',
	    value: {
	      location: _react.PropTypes.object.isRequired
	    },
	    enumerable: true
	  }]);
	
	  var _Register = Register;
	  Register = (0, _reactRedux.connect)(function (state) {
	    return { auth: state.auth };
	  }, { register: _actionsAuthActions.register, resetRegisterEditProfileForm: _actionsAuthActions.resetRegisterEditProfileForm, createSession: _actionsSessionActions.createSession })(Register) || Register;
	  return Register;
	})(_react.Component);
	
	exports['default'] = Register;
	module.exports = exports['default'];

/***/ }),
/* 1146 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _get = __webpack_require__(8)['default'];
	
	var _inherits = __webpack_require__(5)['default'];
	
	var _createClass = __webpack_require__(6)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _extends = __webpack_require__(7)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reduxForm = __webpack_require__(36);
	
	var _utilsValidateNormalize = __webpack_require__(75);
	
	var _reactSpinner = __webpack_require__(51);
	
	var _reactSpinner2 = _interopRequireDefault(_reactSpinner);
	
	var _registrationComponents = __webpack_require__(304);
	
	var RegisterForm = (function (_Component) {
	  _inherits(RegisterForm, _Component);
	
	  _createClass(RegisterForm, null, [{
	    key: 'propTypes',
	    value: {
	      fields: _react.PropTypes.shape({
	        alert: _react.PropTypes.object.isRequired,
	        email: _react.PropTypes.object.isRequired,
	        password: _react.PropTypes.object.isRequired,
	        firstName: _react.PropTypes.object.isRequired,
	        lastName: _react.PropTypes.object.isRequired,
	        phone: _react.PropTypes.object.isRequired,
	        termsAccepted: _react.PropTypes.object.isRequired,
	        directPromotionOptIn: _react.PropTypes.object.isRequired,
	        marketingOptIn: _react.PropTypes.object.isRequired
	      }).isRequired,
	      submitting: _react.PropTypes.bool.isRequired,
	      handleSubmit: _react.PropTypes.func.isRequired
	    },
	    enumerable: true
	  }]);
	
	  function RegisterForm(props) {
	    _classCallCheck(this, _RegisterForm);
	
	    _get(Object.getPrototypeOf(_RegisterForm.prototype), 'constructor', this).call(this, props);
	    this.state = {
	      showTermsAndConditionsModal: false,
	      showDataUsageModal: false
	    };
	  }
	
	  _createClass(RegisterForm, [{
	    key: 'closeDataUsage',
	    value: function closeDataUsage() {
	      this.setState(_extends({}, this.state, {
	        showDataUsageModal: false
	      }));
	    }
	  }, {
	    key: 'openTerms',
	    value: function openTerms() {
	      this.setState(_extends({}, this.state, {
	        showTermsAndConditionsModal: true
	      }));
	    }
	  }, {
	    key: 'closeTerms',
	    value: function closeTerms() {
	      this.setState(_extends({}, this.state, {
	        showTermsAndConditionsModal: false
	      }));
	    }
	  }, {
	    key: 'openDataUsage',
	    value: function openDataUsage() {
	      this.setState(_extends({}, this.state, {
	        showDataUsageModal: true
	      }));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _context,
	          _this = this;
	
	      var _props = this.props;
	      var _props$fields = _props.fields;
	      var alert = _props$fields.alert;
	      var email = _props$fields.email;
	      var password = _props$fields.password;
	      var firstName = _props$fields.firstName;
	      var lastName = _props$fields.lastName;
	      var phone = _props$fields.phone;
	      var termsAccepted = _props$fields.termsAccepted;
	      var directPromotionOptIn = _props$fields.directPromotionOptIn;
	      var marketingOptIn = _props$fields.marketingOptIn;
	      var invalid = _props.invalid;
	
	      return _react2['default'].createElement(
	        'div',
	        { className: 'col-lg-8 col-md-8 col-sm-6' },
	        _react2['default'].createElement(
	          'div',
	          null,
	          _react2['default'].createElement(
	            'h2',
	            null,
	            'Register to get access'
	          ),
	          alert.error && _react2['default'].createElement(
	            'div',
	            { className: 'form-group' },
	            _react2['default'].createElement('div', { className: 'alert alert-danger', dangerouslySetInnerHTML: { __html: alert.error } })
	          ),
	          _react2['default'].createElement(
	            'label',
	            { className: 'control-label', style: { float: "right" } },
	            '* Required Fields'
	          ),
	          _react2['default'].createElement(
	            'h3',
	            null,
	            'Personal'
	          ),
	          _react2['default'].createElement('hr', null),
	          _react2['default'].createElement(_registrationComponents.GetFirstName, { firstName: firstName }),
	          _react2['default'].createElement(_registrationComponents.GetLastName, { lastName: lastName }),
	          _react2['default'].createElement(_registrationComponents.GetPhone, { phone: phone }),
	          _react2['default'].createElement(
	            'h3',
	            null,
	            'Account'
	          ),
	          _react2['default'].createElement('hr', null),
	          _react2['default'].createElement(_registrationComponents.GetEmail, { email: email }),
	          _react2['default'].createElement(_registrationComponents.GetPasword, { password: password }),
	          _react2['default'].createElement(
	            'h3',
	            null,
	            'Communications'
	          ),
	          _react2['default'].createElement('hr', null),
	          _react2['default'].createElement(_registrationComponents.GetOptIn, { label: 'Information about free programs in my area (2-4 messages per year)', optIn: directPromotionOptIn }),
	          _react2['default'].createElement(_registrationComponents.GetOptIn, { label: 'Newsletter with exclusive content and product news (4-6 messages per year)', optIn: marketingOptIn }),
	          _react2['default'].createElement('br', null),
	          _react2['default'].createElement(_registrationComponents.GetTermsAccepted, {
	            termsAccepted: termsAccepted,
	            showTermsAndConditionsModal: this.state.showTermsAndConditionsModal,
	            showDataUsageModal: this.state.showDataUsageModal,
	            openTerms: function () {
	              return _this.openTerms.bind(_this);
	            },
	            closeTerms: function () {
	              return _this.closeTerms.bind(_this);
	            },
	            openDataUsage: function () {
	              return _this.openDataUsage.bind(_this);
	            },
	            closeDataUsage: function () {
	              return _this.closeDataUsage.bind(_this);
	            }
	          }),
	          _react2['default'].createElement(
	            'button',
	            {
	              onClick: (_context = this.props).handleSubmit.bind(_context),
	              disabled: invalid,
	              className: this.props.submitting ? "btn btn-lg btn-primary spinnerButton disabled" : 'btn btn-lg btn-primary spinnerButton'
	            },
	            _react2['default'].createElement(
	              'div',
	              { className: 'buttonText' },
	              this.props.submitting ? 'Registering' : 'Register'
	            ),
	            this.props.submitting ? _react2['default'].createElement(
	              'div',
	              { className: 'spinnerWrapper' },
	              _react2['default'].createElement(_reactSpinner2['default'], null)
	            ) : _react2['default'].createElement('div', null)
	          )
	        )
	      );
	    }
	  }]);
	
	  var _RegisterForm = RegisterForm;
	  RegisterForm = (0, _reduxForm.connectReduxForm)({
	    form: 'register',
	    fields: ['alert', 'email', 'password', 'firstName', 'lastName', 'phone', 'termsAccepted', 'directPromotionOptIn', 'marketingOptIn'],
	    validate: _utilsValidateNormalize.validateRegistration
	  })(RegisterForm) || RegisterForm;
	  return RegisterForm;
	})(_react.Component);
	
	exports['default'] = RegisterForm;
	module.exports = exports['default'];

/***/ }),
/* 1147 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _get = __webpack_require__(8)['default'];
	
	var _inherits = __webpack_require__(5)['default'];
	
	var _createClass = __webpack_require__(6)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(22);
	
	var _actionsAuthActions = __webpack_require__(37);
	
	var _signinForm = __webpack_require__(1148);
	
	var _signinForm2 = _interopRequireDefault(_signinForm);
	
	var _servicesPrograms = __webpack_require__(104);
	
	var Signin = (function (_Component) {
	  _inherits(Signin, _Component);
	
	  function Signin() {
	    _classCallCheck(this, _Signin);
	
	    _get(Object.getPrototypeOf(_Signin.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(Signin, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.props.resetLoginForm({
	        email: this.props.location.query.email
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.auth.loggedIn) {
	        if (nextProps.location.state && nextProps.location.state.next) {
	          nextProps.history.replaceState({ next: null }, nextProps.location.state.next);
	        } else if ((0, _servicesPrograms.hasFeaturedPrograms)()) {
	          nextProps.history.replaceState({ next: null }, '/programs');
	        } else {
	          nextProps.history.replaceState({ next: null }, '/');
	        }
	      }
	    }
	  }, {
	    key: 'handleSubmit',
	    value: function handleSubmit(data) {
	      return this.props.login(data);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2['default'].createElement(_signinForm2['default'], { onSubmit: this.handleSubmit.bind(this) });
	    }
	  }], [{
	    key: 'propTypes',
	    value: {
	      auth: _react.PropTypes.object.isRequired,
	      login: _react.PropTypes.func.isRequired,
	      resetLoginForm: _react.PropTypes.func.isRequired,
	      location: _react.PropTypes.object.isRequired
	    },
	    enumerable: true
	  }, {
	    key: 'contextTypes',
	    value: {
	      location: _react.PropTypes.object.isRequired
	    },
	    enumerable: true
	  }]);
	
	  var _Signin = Signin;
	  Signin = (0, _reactRedux.connect)(function (state) {
	    return { auth: state.auth };
	  }, { login: _actionsAuthActions.login, resetLoginForm: _actionsAuthActions.resetLoginForm })(Signin) || Signin;
	  return Signin;
	})(_react.Component);
	
	exports['default'] = Signin;
	module.exports = exports['default'];

/***/ }),
/* 1148 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _get = __webpack_require__(8)['default'];
	
	var _inherits = __webpack_require__(5)['default'];
	
	var _createClass = __webpack_require__(6)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _extends = __webpack_require__(7)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reduxForm = __webpack_require__(36);
	
	var _reactRouter = __webpack_require__(66);
	
	var _utilsValidateNormalize = __webpack_require__(75);
	
	var _reactSpinner = __webpack_require__(51);
	
	var _reactSpinner2 = _interopRequireDefault(_reactSpinner);
	
	__webpack_require__(120);
	
	__webpack_require__(198);
	
	var SigninForm = (function (_Component) {
	  _inherits(SigninForm, _Component);
	
	  function SigninForm() {
	    _classCallCheck(this, _SigninForm);
	
	    _get(Object.getPrototypeOf(_SigninForm.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(SigninForm, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var _props$fields = _props.fields;
	      var alert = _props$fields.alert;
	      var email = _props$fields.email;
	      var password = _props$fields.password;
	      var handleSubmit = _props.handleSubmit;
	      var submitting = _props.submitting;
	
	      return _react2['default'].createElement(
	        'form',
	        { onSubmit: handleSubmit,
	          className: 'form-horizontal' },
	        _react2['default'].createElement(
	          'h2',
	          null,
	          'Sign in'
	        ),
	        alert.error && _react2['default'].createElement(
	          'div',
	          { className: 'form-group' },
	          _react2['default'].createElement('div', { className: 'alert alert-danger', dangerouslySetInnerHTML: { __html: alert.error } })
	        ),
	        _react2['default'].createElement(
	          'div',
	          { className: 'row' },
	          _react2['default'].createElement(
	            'div',
	            { className: 'col-sm-8 col-md-8' },
	            _react2['default'].createElement(
	              'div',
	              { className: 'form-group ' + (email.error && email.touched && 'has-error') },
	              _react2['default'].createElement(
	                'label',
	                { htmlFor: 'txtEmail',
	                  className: 'col-sm-2 control-label' },
	                'Email'
	              ),
	              _react2['default'].createElement(
	                'div',
	                { className: 'col-sm-9' },
	                _react2['default'].createElement('input', _extends({ id: 'txtEmail',
	                  type: 'email',
	                  className: 'form-control',
	                  placeholder: 'jane@example.com',
	                  spellCheck: 'false'
	                }, email)),
	                email.error && email.touched && _react2['default'].createElement('div', { className: 'text-danger', dangerouslySetInnerHTML: { __html: email.error } })
	              )
	            ),
	            _react2['default'].createElement(
	              'div',
	              { className: 'form-group ' + (password.error && password.touched ? 'has-error' : '') },
	              _react2['default'].createElement(
	                'label',
	                { htmlFor: 'txtPassword',
	                  className: 'col-sm-2 control-label' },
	                'Password'
	              ),
	              _react2['default'].createElement(
	                'div',
	                { className: 'col-sm-9' },
	                _react2['default'].createElement('input', _extends({ id: 'txtPass',
	                  type: 'password',
	                  className: 'form-control',
	                  placeholder: 'thoo!mu3Da'
	                }, password)),
	                password.error && password.touched && _react2['default'].createElement('div', { className: 'text-danger', dangerouslySetInnerHTML: { __html: password.error } })
	              )
	            ),
	            _react2['default'].createElement(
	              'div',
	              { className: 'form-group' },
	              _react2['default'].createElement(
	                'div',
	                { className: 'col-sm-offset-2 col-sm-9' },
	                _react2['default'].createElement(
	                  'button',
	                  { type: 'submit',
	                    className: 'btn btn-lg btn-primary spinnerButton ' + (submitting ? 'disabled' : '') },
	                  _react2['default'].createElement(
	                    'div',
	                    { className: 'buttonContent' },
	                    _react2['default'].createElement(
	                      'div',
	                      { className: 'buttonText' },
	                      submitting ? 'Signing in' : 'Sign in'
	                    ),
	                    submitting && _react2['default'].createElement(
	                      'div',
	                      { className: 'spinnerWrapper' },
	                      _react2['default'].createElement(_reactSpinner2['default'], null)
	                    )
	                  )
	                ),
	                _react2['default'].createElement(
	                  'span',
	                  { style: { marginLeft: '1em' } },
	                  _react2['default'].createElement(
	                    _reactRouter.Link,
	                    { to: '/forgotPassword' },
	                    'Forgot password?'
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }], [{
	    key: 'propTypes',
	    value: {
	      fields: _react.PropTypes.object.isRequired,
	      handleSubmit: _react.PropTypes.func.isRequired,
	      submitting: _react.PropTypes.bool.isRequired
	    },
	    enumerable: true
	  }]);
	
	  var _SigninForm = SigninForm;
	  SigninForm = (0, _reduxForm.connectReduxForm)({
	    form: 'login',
	    fields: ['email', 'password', 'alert'],
	    validate: _utilsValidateNormalize.validateLogin
	  })(SigninForm) || SigninForm;
	  return SigninForm;
	})(_react.Component);
	
	exports['default'] = SigninForm;
	module.exports = exports['default'];

/***/ }),
/* 1149 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _get = __webpack_require__(8)['default'];
	
	var _inherits = __webpack_require__(5)['default'];
	
	var _createClass = __webpack_require__(6)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(24);
	
	var _helpersMarkdownScript = __webpack_require__(9);
	
	var _helpersMarkdownScript2 = _interopRequireDefault(_helpersMarkdownScript);
	
	var _termsAndConditionsMd = __webpack_require__(724);
	
	var _termsAndConditionsMd2 = _interopRequireDefault(_termsAndConditionsMd);
	
	var md = new _helpersMarkdownScript2['default'](_termsAndConditionsMd2['default']);
	
	var TermsAndConditionsModal = (function (_Component) {
	  _inherits(TermsAndConditionsModal, _Component);
	
	  function TermsAndConditionsModal() {
	    _classCallCheck(this, TermsAndConditionsModal);
	
	    _get(Object.getPrototypeOf(TermsAndConditionsModal.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(TermsAndConditionsModal, [{
	    key: 'render',
	    value: function render() {
	      return _react2['default'].createElement(
	        _reactBootstrap.Modal,
	        {
	          show: this.props.showModal,
	          onHide: this.props.closeModal
	        },
	        _react2['default'].createElement(
	          _reactBootstrap.Modal.Body,
	          null,
	          _react2['default'].createElement('div', { dangerouslySetInnerHTML: { __html: md.getAllAsHtml() } })
	        ),
	        _react2['default'].createElement(
	          _reactBootstrap.Modal.Footer,
	          null,
	          _react2['default'].createElement(
	            _reactBootstrap.Button,
	            { onClick: this.props.closeModal() },
	            'Close'
	          )
	        )
	      );
	    }
	  }], [{
	    key: 'propTypes',
	    value: {
	      showModal: _react.PropTypes.bool.isRequired,
	      closeModal: _react.PropTypes.func.isRequired
	    },
	    enumerable: true
	  }]);
	
	  return TermsAndConditionsModal;
	})(_react.Component);
	
	exports['default'] = TermsAndConditionsModal;
	module.exports = exports['default'];

/***/ }),
/* 1150 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _get = __webpack_require__(8)['default'];
	
	var _inherits = __webpack_require__(5)['default'];
	
	var _createClass = __webpack_require__(6)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var BodyTheme = (function (_React$Component) {
	  _inherits(BodyTheme, _React$Component);
	
	  function BodyTheme() {
	    _classCallCheck(this, BodyTheme);
	
	    _get(Object.getPrototypeOf(BodyTheme.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(BodyTheme, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      document.body.classList.add(this.props.themeClass);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      document.body.classList.remove(this.props.themeClass);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return this.props.children;
	    }
	  }], [{
	    key: 'propTypes',
	    value: {
	      themeClass: _react2['default'].PropTypes.string.isRequired,
	      children: _react2['default'].PropTypes.object
	    },
	    enumerable: true
	  }]);
	
	  return BodyTheme;
	})(_react2['default'].Component);
	
	exports['default'] = BodyTheme;
	module.exports = exports['default'];

/***/ }),
/* 1151 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _get = __webpack_require__(8)['default'];
	
	var _inherits = __webpack_require__(5)['default'];
	
	var _createClass = __webpack_require__(6)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _vendorReactWufooEmbedReactWufooEmbed = __webpack_require__(1130);
	
	var _vendorReactWufooEmbedReactWufooEmbed2 = _interopRequireDefault(_vendorReactWufooEmbedReactWufooEmbed);
	
	var Contact = (function (_Component) {
	  _inherits(Contact, _Component);
	
	  function Contact() {
	    _classCallCheck(this, Contact);
	
	    _get(Object.getPrototypeOf(Contact.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(Contact, [{
	    key: 'render',
	    value: function render() {
	      return _react2['default'].createElement(
	        'div',
	        null,
	        _react2['default'].createElement(
	          'h3',
	          null,
	          'Contact Us'
	        ),
	        _react2['default'].createElement(_vendorReactWufooEmbedReactWufooEmbed2['default'], { userName: 'dreamrider', formHash: 'we7cb321dfoh2j' })
	      );
	    }
	  }]);
	
	  return Contact;
	})(_react.Component);
	
	exports['default'] = Contact;
	module.exports = exports['default'];

/***/ }),
/* 1152 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _get = __webpack_require__(8)['default'];
	
	var _inherits = __webpack_require__(5)['default'];
	
	var _createClass = __webpack_require__(6)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(24);
	
	var ArchiveClassModal = (function (_Component) {
	  _inherits(ArchiveClassModal, _Component);
	
	  function ArchiveClassModal() {
	    _classCallCheck(this, ArchiveClassModal);
	
	    _get(Object.getPrototypeOf(ArchiveClassModal.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(ArchiveClassModal, [{
	    key: 'cancel',
	    value: function cancel(evt) {
	      var closeModal = this.props.closeModal;
	
	      closeModal();
	      evt.preventDefault();
	      evt.stopPropagation();
	      evt.nativeEvent.stopPropagation();
	    }
	  }, {
	    key: 'handleSubmit',
	    value: function handleSubmit(evt) {
	      var _props = this.props;
	      var onSubmit = _props.onSubmit;
	      var sessionId = _props.sessionId;
	      var closeModal = _props.closeModal;
	
	      onSubmit({ sessionId: sessionId });
	      closeModal();
	      evt.preventDefault();
	      evt.stopPropagation();
	      evt.nativeEvent.stopPropagation();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props;
	      var showModal = _props2.showModal;
	      var closeModal = _props2.closeModal;
	      var divisionName = _props2.divisionName;
	      var _ = _props2.i18n;
	
	      return _react2['default'].createElement(
	        _reactBootstrap.Modal,
	        { show: showModal, onHide: closeModal },
	        _react2['default'].createElement(
	          _reactBootstrap.Modal.Header,
	          { closeButton: true },
	          _react2['default'].createElement(
	            _reactBootstrap.Modal.Title,
	            null,
	            _('Archive class?')
	          )
	        ),
	        _react2['default'].createElement(
	          'form',
	          { onSubmit: this.handleSubmit.bind(this) },
	          _react2['default'].createElement(
	            _reactBootstrap.Modal.Body,
	            null,
	            _react2['default'].createElement(
	              'div',
	              { className: 'form-group' },
	              _react2['default'].createElement(
	                'h4',
	                null,
	                _('Division:'),
	                ' ',
	                divisionName
	              )
	            ),
	            _react2['default'].createElement(
	              'div',
	              { className: 'row' },
	              _react2['default'].createElement(
	                'div',
	                { className: 'col-sm-8 col-md-8' },
	                _react2['default'].createElement(
	                  'p',
	                  null,
	                  _react2['default'].createElement(
	                    'strong',
	                    null,
	                    _('Warning!')
	                  ),
	                  ' ',
	                  _('You can\'t undo this action.')
	                )
	              )
	            )
	          ),
	          _react2['default'].createElement(
	            _reactBootstrap.Modal.Footer,
	            null,
	            _react2['default'].createElement(
	              'button',
	              {
	                className: 'btn btn-lg',
	                onClick: this.cancel.bind(this) },
	              _('Cancel')
	            ),
	            ' ',
	            _react2['default'].createElement(
	              'button',
	              {
	                className: 'btn btn-lg btn-danger',
	                type: 'submit' },
	              _('Archive')
	            )
	          )
	        )
	      );
	    }
	  }], [{
	    key: 'propTypes',
	    value: {
	      divisionName: _react.PropTypes.string.isRequired,
	      sessionId: _react.PropTypes.string.isRequired,
	      showModal: _react.PropTypes.bool.isRequired,
	      closeModal: _react.PropTypes.func.isRequired,
	      onSubmit: _react.PropTypes.func.isRequired,
	      i18n: _react.PropTypes.func.isRequired
	    },
	    enumerable: true
	  }]);
	
	  return ArchiveClassModal;
	})(_react.Component);
	
	exports['default'] = ArchiveClassModal;
	module.exports = exports['default'];
	/* Title */

/***/ }),
/* 1153 */
/***/ (function(module, exports, __webpack_require__) {

	/* eslint no-console: 0 */
	'use strict';
	
	var _get = __webpack_require__(8)['default'];
	
	var _inherits = __webpack_require__(5)['default'];
	
	var _createClass = __webpack_require__(6)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(24);
	
	var _imagesEsmeralda_goober_half_wavePng = __webpack_require__(915);
	
	var _imagesEsmeralda_goober_half_wavePng2 = _interopRequireDefault(_imagesEsmeralda_goober_half_wavePng);
	
	var _imagesGoober_leapsJpg = __webpack_require__(2523);
	
	var _imagesGoober_leapsJpg2 = _interopRequireDefault(_imagesGoober_leapsJpg);
	
	__webpack_require__(2198);
	
	var _servicesPayment = __webpack_require__(302);
	
	var _servicesPromoCode = __webpack_require__(475);
	
	var _servicesPromoCode2 = _interopRequireDefault(_servicesPromoCode);
	
	var STEPS = {
	  SPLASH: 0,
	  PRICE: 1,
	  PAYMENTINFO: 2,
	  CONFIRM: 3
	};
	var INITIAL_STATE = {
	  step: STEPS.SPLASH,
	  promoCode: null,
	  confirmedDuration: false,
	  error: null,
	  disableContinue: false
	};
	
	var BuyNowModal = (function (_Component) {
	  _inherits(BuyNowModal, _Component);
	
	  _createClass(BuyNowModal, null, [{
	    key: 'propTypes',
	    value: {
	      showModal: _react.PropTypes.bool.isRequired,
	      closeModal: _react.PropTypes.func.isRequired,
	      onChargeProcessed: _react.PropTypes.func.isRequired,
	      programName: _react.PropTypes.string.isRequired,
	      programId: _react.PropTypes.string.isRequired,
	      sessionId: _react.PropTypes.string.isRequired
	    },
	    enumerable: true
	  }, {
	    key: 'contextTypes',
	    value: {
	      profile: _react.PropTypes.object.isRequired,
	      userId: _react.PropTypes.string.isRequired
	    },
	    enumerable: true
	  }]);
	
	  function BuyNowModal(props, context) {
	    _classCallCheck(this, BuyNowModal);
	
	    _get(Object.getPrototypeOf(BuyNowModal.prototype), 'constructor', this).call(this, props, context);
	    this.state = INITIAL_STATE;
	  }
	
	  _createClass(BuyNowModal, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.showModal !== nextProps.showModal) {
	        this.setState(INITIAL_STATE);
	      }
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel(evt) {
	      var closeModal = this.props.closeModal;
	
	      closeModal();
	      evt.preventDefault();
	      evt.stopPropagation();
	      evt.nativeEvent.stopPropagation();
	    }
	  }, {
	    key: 'captureFormRef',
	    value: function captureFormRef(form) {
	      this._form = form;
	    }
	  }, {
	    key: '_advanceToNextStep',
	    value: function _advanceToNextStep() {
	      this.setState({ step: this.state.step + 1 });
	    }
	  }, {
	    key: '_chargeCreditCard',
	    value: function _chargeCreditCard() {
	      var self = this;
	      var _props = this.props;
	      var onChargeProcessed = _props.onChargeProcessed;
	      var sessionId = _props.sessionId;
	      var programName = _props.programName;
	      var programId = _props.programId;
	      var promoCode = this.state.promoCode;
	      var _context = this.context;
	      var profile = _context.profile;
	      var userId = _context.userId;
	      var email = profile.email;
	
	      return (0, _servicesPayment.createCCToken)(this._form).then(function (token) {
	        var price = (0, _servicesPayment.getPrice)(profile);
	        var amount = price.amount;
	        var currency = price.currency;
	
	        var validUntil = new Date((0, _servicesPayment.getValidUntilTime)());
	        var validUntilYear = validUntil.getFullYear();
	        var chargeData = {
	          stripeToken: token,
	          promoCode: promoCode ? promoCode.code : '',
	          email: email,
	          amount: amount,
	          currency: currency,
	          description: programName + ' classroom licence til June 30, ' + validUntilYear,
	          metadata: {
	            sessionId: sessionId,
	            email: email,
	            userId: userId
	          }
	        };
	        return (0, _servicesPayment.processCharge)(chargeData);
	      }).then(function (charge) {
	        var sessionPaidForData = {
	          charge: charge,
	          promoCode: promoCode,
	          sessionId: sessionId,
	          programId: programId
	        };
	        return onChargeProcessed(sessionPaidForData);
	      }).then(function () {
	        self._advanceToNextStep();
	      })['catch'](function (error) {
	        console.log(error);
	        self.setState({ error: error.message });
	      });
	    }
	  }, {
	    key: 'nextStep',
	    value: function nextStep(evt) {
	      var self = this;
	      var closeModal = this.props.closeModal;
	      var currentStep = this.state.step;
	
	      evt.target.disabled = true;
	      evt.preventDefault();
	      evt.stopPropagation();
	      evt.nativeEvent.stopPropagation();
	      switch (currentStep) {
	        case STEPS.CONFIRM:
	          closeModal();
	          break;
	        case STEPS.PAYMENTINFO:
	          this._chargeCreditCard().then(function () {
	            return evt.target.disabled = false;
	          });
	          return;
	        default:
	          self._advanceToNextStep();
	      }
	      evt.target.disabled = false;
	    }
	  }, {
	    key: 'checkPromoCode',
	    value: function checkPromoCode(evt) {
	      var _this = this;
	
	      var self = this;
	      var value = evt.target.value;
	      if (!value) {
	        self.setState({ promoCode: null, error: null });
	        return;
	      }
	      if (!_servicesPromoCode2['default'].isValidFormat(value)) {
	        self.setState({ promoCode: null, error: 'Invalid format for promo-code.' });
	        return;
	      }
	      _servicesPromoCode2['default'].fetch(value).then(function (promoCode) {
	        if (!promoCode) {
	          self.setState({ promoCode: null, error: 'Sorry, this promo code is invalid.' });
	          return;
	        }
	        if (!promoCode.isAvailable()) {
	          self.setState({ promoCode: null, error: 'Sorry, this promo code is expired.' });
	          return;
	        }
	        if (!promoCode.isValidForProgram(_this.props.programId)) {
	          self.setState({ promoCode: null, error: 'Sorry, this promo code is not valid for this program.' });
	          return;
	        }
	        self.setState({ promoCode: promoCode, error: null });
	      })['catch'](function (error) {
	        console.log(error);
	        self.setState({ error: 'Problem while retrieving the promo-code. Please try again later.' });
	      });
	    }
	  }, {
	    key: 'handleConfirmDurationClick',
	    value: function handleConfirmDurationClick() {
	      this.setState({ confirmedDuration: !this.state.confirmedDuration });
	    }
	  }, {
	    key: 'handleSubmit',
	    value: function handleSubmit(evt) {
	      // Make sure the form doesn't get submitted
	      evt.preventDefault();
	      evt.stopPropagation();
	      evt.nativeEvent.stopPropagation();
	    }
	  }, {
	    key: 'validateField',
	    value: function validateField(evt) {
	      var element = evt.target;
	      var value = element.value;
	      var dataset = element.dataset;
	      var validationRegex = dataset.validationRegex;
	      var validationRequired = dataset.validationRequired;
	      var validationName = dataset.validationName;
	
	      if (validationRequired && !value) {
	        this.setState({ error: validationName + ' is required.' });
	        return;
	      }
	
	      if (validationRegex && !new RegExp(validationRegex).test(value)) {
	        this.setState({ error: 'Invalid ' + validationName + '.' });
	        return;
	      }
	
	      this.setState({ error: null });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props;
	      var showModal = _props2.showModal;
	      var closeModal = _props2.closeModal;
	      var programName = _props2.programName;
	      var sessionId = _props2.sessionId;
	      var _state = this.state;
	      var error = _state.error;
	      var step = _state.step;
	      var confirmedDuration = _state.confirmedDuration;
	      var promoCode = _state.promoCode;
	      var profile = this.context.profile;
	
	      var price = (0, _servicesPayment.getPrice)(profile);
	      var amount = price.amount;
	      var currency = price.currency;
	
	      var disableContinue = !!error;
	      if (step === STEPS.PRICE) {
	        disableContinue = disableContinue || !confirmedDuration;
	      }
	
	      var finalAmount = amount - (promoCode ? promoCode.value : 0);
	
	      return _react2['default'].createElement(
	        _reactBootstrap.Modal,
	        { show: showModal, onHide: closeModal, className: 'buy-now' },
	        _react2['default'].createElement(
	          _reactBootstrap.Modal.Header,
	          { closeButton: true },
	          _react2['default'].createElement(
	            _reactBootstrap.Modal.Title,
	            null,
	            'Buy ',
	            programName,
	            ' for your classroom!'
	          )
	        ),
	        _react2['default'].createElement(
	          'form',
	          { onSubmit: this.handleSubmit.bind(this), ref: this.captureFormRef.bind(this) },
	          _react2['default'].createElement(
	            _reactBootstrap.Modal.Body,
	            null,
	            _react2['default'].createElement('input', { type: 'hidden', name: 'sessionId', defaultValue: sessionId }),
	            _react2['default'].createElement('input', { type: 'hidden', name: 'funding', value: 'STRIPE' }),
	            _react2['default'].createElement('input', { type: 'hidden', name: 'promoCode', value: promoCode ? promoCode.code : '' }),
	            _react2['default'].createElement(
	              'div',
	              { className: 'row' },
	              step === STEPS.SPLASH && _react2['default'].createElement(
	                'div',
	                { className: 'col-sm-8 col-md-12' },
	                _react2['default'].createElement(
	                  'div',
	                  { className: 'col-md-6' },
	                  _react2['default'].createElement('img', { className: 'col-md-12 col-xs-6', src: _imagesEsmeralda_goober_half_wavePng2['default'] })
	                ),
	                _react2['default'].createElement(
	                  'div',
	                  { className: 'col-md-6' },
	                  _react2['default'].createElement(
	                    'h3',
	                    null,
	                    'Hurray!'
	                  ),
	                  _react2['default'].createElement(
	                    'h4',
	                    null,
	                    'You\'re bringing the Academy to your classroom!'
	                  )
	                )
	              ),
	              step === STEPS.PRICE && _react2['default'].createElement(
	                'div',
	                { className: 'col-sm-8 col-md-12' },
	                _react2['default'].createElement(
	                  'div',
	                  { className: 'col-md-6' },
	                  _react2['default'].createElement('img', { className: 'col-md-12 col-xs-6', src: _imagesEsmeralda_goober_half_wavePng2['default'] })
	                ),
	                _react2['default'].createElement(
	                  'div',
	                  { className: 'col-md-6' },
	                  error && _react2['default'].createElement(
	                    'div',
	                    { className: 'form-group' },
	                    _react2['default'].createElement(
	                      'div',
	                      { className: 'alert alert-danger' },
	                      error
	                    )
	                  ),
	                  _react2['default'].createElement(
	                    'div',
	                    { className: 'form-group' },
	                    _react2['default'].createElement(
	                      'label',
	                      { className: 'control-label' },
	                      _react2['default'].createElement(
	                        'h4',
	                        null,
	                        'Get full access for the year for only ',
	                        amount,
	                        ' ',
	                        currency
	                      )
	                    )
	                  ),
	                  _react2['default'].createElement(
	                    'div',
	                    { className: 'form-group' },
	                    _react2['default'].createElement(
	                      'label',
	                      { className: 'control-label' },
	                      'Have a promo code? Use it here!'
	                    ),
	                    _react2['default'].createElement('input', {
	                      className: 'form-control promoCode',
	                      name: 'promoCode',
	                      type: 'text',
	                      size: '10',
	                      maxLength: '10',
	                      autoFocus: true,
	                      onBlur: this.checkPromoCode.bind(this) })
	                  ),
	                  _react2['default'].createElement(
	                    'div',
	                    { className: 'promoCodeValue' },
	                    promoCode && 'Promo code VALID! You get the discounted price of ' + finalAmount + ' ' + currency
	                  ),
	                  _react2['default'].createElement(
	                    'div',
	                    { className: 'form-group confirmDuration' },
	                    _react2['default'].createElement('input', {
	                      type: 'checkbox',
	                      name: 'confirmDuration',
	                      onClick: this.handleConfirmDurationClick.bind(this) }),
	                    _react2['default'].createElement(
	                      'span',
	                      null,
	                      ' I understand that I\'m buying access to the program for this school year only (expires June 30th)'
	                    )
	                  )
	                )
	              ),
	              step === STEPS.PAYMENTINFO && _react2['default'].createElement(
	                'div',
	                { className: 'col-sm-8 col-md-12' },
	                error && _react2['default'].createElement(
	                  'div',
	                  { className: 'form-group' },
	                  _react2['default'].createElement(
	                    'div',
	                    { className: 'alert alert-danger' },
	                    error
	                  )
	                ),
	                _react2['default'].createElement(
	                  'div',
	                  null,
	                  _react2['default'].createElement(
	                    'h4',
	                    null,
	                    'We accept all major credit and debit cards including Visa, Mastercard and AmEx.'
	                  )
	                ),
	                _react2['default'].createElement(
	                  'div',
	                  { className: 'form-group' },
	                  _react2['default'].createElement(
	                    'label',
	                    null,
	                    'Card Number:'
	                  ),
	                  _react2['default'].createElement('input', { type: 'text',
	                    className: 'form-control input-sm cc-input',
	                    size: '24',
	                    maxLength: '16',
	                    'data-validation-regex': '^[0-9]{16}$',
	                    'data-validation-required': true,
	                    'data-validation-name': 'Card Number',
	                    onBlur: this.validateField.bind(this),
	                    autoFocus: true,
	                    'data-stripe': 'number' })
	                ),
	                _react2['default'].createElement(
	                  'div',
	                  { className: 'form-group' },
	                  _react2['default'].createElement(
	                    'label',
	                    null,
	                    'Expiration (MM/YY):'
	                  ),
	                  _react2['default'].createElement(
	                    'div',
	                    { className: 'expCvcRow' },
	                    _react2['default'].createElement('input', { type: 'text',
	                      className: 'form-control input-sm exp-input',
	                      'data-validation-regex': '^0[0-9]|1[0-2]$',
	                      'data-validation-required': true,
	                      'data-validation-name': 'Expiration Month',
	                      onBlur: this.validateField.bind(this),
	                      size: '2',
	                      maxLength: '2',
	                      'data-stripe': 'exp_month' }),
	                    '/',
	                    _react2['default'].createElement('input', { type: 'text',
	                      className: 'form-control input-sm exp-input',
	                      'data-validation-regex': '^[0-9]{2}$',
	                      'data-validation-required': true,
	                      'data-validation-name': 'Expiration Year',
	                      onBlur: this.validateField.bind(this),
	                      size: '2',
	                      maxLength: '2',
	                      'data-stripe': 'exp_year' }),
	                    _react2['default'].createElement(
	                      'label',
	                      { className: '' },
	                      'CVC:'
	                    ),
	                    _react2['default'].createElement('input', { type: 'text',
	                      className: 'form-control input-sm cvc-input',
	                      'data-validation-regex': '^[0-9]{3,4}$',
	                      'data-validation-required': true,
	                      'data-validation-name': 'CVC',
	                      onBlur: this.validateField.bind(this),
	                      size: '4',
	                      maxLength: '4',
	                      'data-stripe': 'cvc' })
	                  )
	                )
	              ),
	              step === STEPS.CONFIRM && _react2['default'].createElement(
	                'div',
	                { className: 'col-sm-8 col-md-12' },
	                _react2['default'].createElement(
	                  'div',
	                  { className: 'col-md-6' },
	                  _react2['default'].createElement('img', { className: 'col-md-12 col-xs-6 gooberLeaps', src: _imagesGoober_leapsJpg2['default'] })
	                ),
	                _react2['default'].createElement(
	                  'div',
	                  { className: 'col-md-6' },
	                  _react2['default'].createElement(
	                    'h3',
	                    null,
	                    'SUCCESS!'
	                  ),
	                  _react2['default'].createElement(
	                    'h4',
	                    null,
	                    'You now have full access to ',
	                    programName,
	                    ' for your classroom!'
	                  ),
	                  _react2['default'].createElement(
	                    'h4',
	                    null,
	                    'A confirmation email will be sent to you.'
	                  ),
	                  _react2['default'].createElement(
	                    'h4',
	                    null,
	                    'Happy planet protecting!'
	                  )
	                )
	              )
	            )
	          ),
	          _react2['default'].createElement(
	            _reactBootstrap.Modal.Footer,
	            null,
	            step < STEPS.CONFIRM && _react2['default'].createElement(
	              'button',
	              {
	                className: 'btn btn-secondary',
	                onClick: this.cancel.bind(this) },
	              'Cancel'
	            ),
	            ' ',
	            _react2['default'].createElement(
	              'button',
	              {
	                className: 'btn btn-primary',
	                onClick: this.nextStep.bind(this),
	                disabled: disableContinue ? 'disabled' : '' },
	              step < STEPS.CONFIRM ? 'Continue' : 'Let\'s Go!'
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return BuyNowModal;
	})(_react.Component);
	
	exports['default'] = BuyNowModal;
	module.exports = exports['default'];

/***/ }),
/* 1154 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _get = __webpack_require__(8)['default'];
	
	var _inherits = __webpack_require__(5)['default'];
	
	var _createClass = __webpack_require__(6)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _extends = __webpack_require__(7)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(24);
	
	var _reduxForm = __webpack_require__(36);
	
	var _utilsValidateNormalize = __webpack_require__(75);
	
	var _servicesRegionalization = __webpack_require__(38);
	
	var _servicesRegionalization2 = _interopRequireDefault(_servicesRegionalization);
	
	var _authRegistrationComponents = __webpack_require__(304);
	
	var CompleteRegistrationModal = (function (_Component) {
	  _inherits(CompleteRegistrationModal, _Component);
	
	  _createClass(CompleteRegistrationModal, null, [{
	    key: 'propTypes',
	    value: {
	      showModal: _react.PropTypes.bool.isRequired,
	      closeModal: _react.PropTypes.func.isRequired,
	      fields: _react.PropTypes.shape({
	        alert: _react.PropTypes.object.isRequired,
	        country: _react.PropTypes.object.isRequired,
	        cityOrMunicipality: _react.PropTypes.object.isRequired,
	        stateOrProvince: _react.PropTypes.object.isRequired,
	        school: _react.PropTypes.object.isRequired
	      }).isRequired,
	      handleSubmit: _react.PropTypes.func.isRequired
	    },
	    enumerable: true
	  }]);
	
	  function CompleteRegistrationModal(props) {
	    _classCallCheck(this, _CompleteRegistrationModal);
	
	    _get(Object.getPrototypeOf(_CompleteRegistrationModal.prototype), 'constructor', this).call(this, props);
	    this.countries = _servicesRegionalization2['default'].getCountries();
	  }
	
	  _createClass(CompleteRegistrationModal, [{
	    key: 'handleSubmit',
	    value: function handleSubmit(evt) {
	      this.props.handleSubmit(evt);
	    }
	  }, {
	    key: 'handleCountryChange',
	    value: function handleCountryChange(evt) {
	      var _props$fields = this.props.fields;
	      var country = _props$fields.country;
	      var stateOrProvince = _props$fields.stateOrProvince;
	
	      country.onChange(evt);
	      var statesOrProvinces = _servicesRegionalization2['default'].getStatesOrProvinces(evt.target.value);
	      if (statesOrProvinces.length === 1) {
	        stateOrProvince.onChange(statesOrProvinces[0].code);
	      } else {
	        stateOrProvince.onChange('');
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var showModal = _props.showModal;
	      var closeModal = _props.closeModal;
	      var fields = _props.fields;
	      var invalid = _props.invalid;
	      var country = fields.country;
	      var stateOrProvince = fields.stateOrProvince;
	      var cityOrMunicipality = fields.cityOrMunicipality;
	      var school = fields.school;
	
	      var statesOrProvinces = _servicesRegionalization2['default'].getStatesOrProvinces(country.value);
	      if (statesOrProvinces.length === 1) {
	        stateOrProvince.disabled = true;
	      }
	
	      return _react2['default'].createElement(
	        _reactBootstrap.Modal,
	        { backdrop: 'static', show: showModal, onHide: closeModal, keyboard: false, dialogClassName: 'complete-registration-modal' },
	        _react2['default'].createElement(
	          _reactBootstrap.Modal.Header,
	          null,
	          _react2['default'].createElement(
	            _reactBootstrap.Modal.Title,
	            null,
	            'About your school'
	          )
	        ),
	        _react2['default'].createElement(
	          _reactBootstrap.Modal.Body,
	          null,
	          _react2['default'].createElement(
	            'h4',
	            null,
	            'Tell us about your school so we can tailor to your region!'
	          ),
	          _react2['default'].createElement('hr', null),
	          _react2['default'].createElement(
	            'label',
	            { className: 'control-label', style: { float: "right" } },
	            '* Required Fields'
	          ),
	          _react2['default'].createElement(_authRegistrationComponents.GetCountry, { country: _extends({}, country, { onChange: this.handleCountryChange.bind(this) }), countries: this.countries }),
	          _react2['default'].createElement(_authRegistrationComponents.GetStatesOrProvince, { stateOrProvince: stateOrProvince, statesOrProvinces: statesOrProvinces }),
	          _react2['default'].createElement(_authRegistrationComponents.GetCity, { cityOrMunicipality: cityOrMunicipality }),
	          _react2['default'].createElement(_authRegistrationComponents.GetSchool, { school: school })
	        ),
	        _react2['default'].createElement(
	          _reactBootstrap.Modal.Footer,
	          null,
	          _react2['default'].createElement(
	            'button',
	            { disabled: invalid ? 'disabled' : '',
	              onClick: this.handleSubmit.bind(this),
	              className: 'btn btn-lg btn-primary' },
	            'Next'
	          )
	        )
	      );
	    }
	  }]);
	
	  var _CompleteRegistrationModal = CompleteRegistrationModal;
	  CompleteRegistrationModal = (0, _reduxForm.connectReduxForm)({
	    form: 'completeRegistration',
	    fields: ['alert', 'country', 'cityOrMunicipality', 'stateOrProvince', 'school'],
	    validate: _utilsValidateNormalize.validateCompleteRegistration
	  })(CompleteRegistrationModal) || CompleteRegistrationModal;
	  return CompleteRegistrationModal;
	})(_react.Component);
	
	exports['default'] = CompleteRegistrationModal;
	module.exports = exports['default'];

/***/ }),
/* 1155 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _get = __webpack_require__(8)['default'];
	
	var _inherits = __webpack_require__(5)['default'];
	
	var _createClass = __webpack_require__(6)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(24);
	
	__webpack_require__(2199);
	
	var ConfirmAddClassModal = (function (_Component) {
	  _inherits(ConfirmAddClassModal, _Component);
	
	  function ConfirmAddClassModal() {
	    _classCallCheck(this, ConfirmAddClassModal);
	
	    _get(Object.getPrototypeOf(ConfirmAddClassModal.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(ConfirmAddClassModal, [{
	    key: 'handleCancel',
	    value: function handleCancel(evt) {
	      evt.preventDefault();
	      evt.stopPropagation();
	      evt.nativeEvent.stopPropagation();
	      var onCancel = this.props.onCancel;
	
	      onCancel();
	    }
	  }, {
	    key: 'handleConfirm',
	    value: function handleConfirm(evt) {
	      evt.preventDefault();
	      evt.stopPropagation();
	      evt.nativeEvent.stopPropagation();
	      var onConfirm = this.props.onConfirm;
	
	      onConfirm();
	    }
	  }, {
	    key: 'onHide',
	    value: function onHide() {
	      // Do nothing
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var showModal = this.props.showModal;
	
	      return _react2['default'].createElement(
	        _reactBootstrap.Modal,
	        { show: showModal, onHide: this.onHide.bind(this), className: 'confirm-add-class' },
	        _react2['default'].createElement(
	          _reactBootstrap.Modal.Header,
	          null,
	          _react2['default'].createElement(
	            _reactBootstrap.Modal.Title,
	            null,
	            'Are you sure?'
	          )
	        ),
	        _react2['default'].createElement(
	          _reactBootstrap.Modal.Body,
	          null,
	          _react2['default'].createElement(
	            'h4',
	            null,
	            'It looks like you\'ve already added your class for this program.',
	            _react2['default'].createElement('br', null),
	            'Are you doing the program with multiple classes during this school year?'
	          ),
	          _react2['default'].createElement(
	            'button',
	            {
	              className: 'btn btn-primary',
	              onClick: this.handleCancel.bind(this) },
	            'No, I don\'t need to add an extra class'
	          ),
	          _react2['default'].createElement(
	            'button',
	            {
	              className: 'btn btn-default',
	              onClick: this.handleConfirm.bind(this) },
	            'Yes, I want to add an extra class'
	          )
	        )
	      );
	    }
	  }], [{
	    key: 'propTypes',
	    value: {
	      showModal: _react.PropTypes.bool.isRequired,
	      onCancel: _react.PropTypes.func.isRequired,
	      onConfirm: _react.PropTypes.func.isRequired
	    },
	    enumerable: true
	  }]);
	
	  return ConfirmAddClassModal;
	})(_react.Component);
	
	exports['default'] = ConfirmAddClassModal;
	module.exports = exports['default'];

/***/ }),
/* 1156 */
/***/ (function(module, exports, __webpack_require__) {

	/* global HelpCrunch */
	'use strict';
	
	var _get = __webpack_require__(8)['default'];
	
	var _inherits = __webpack_require__(5)['default'];
	
	var _createClass = __webpack_require__(6)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _extends = __webpack_require__(7)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	var _interopRequireWildcard = __webpack_require__(175)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(22);
	
	var _actionsSessionActions = __webpack_require__(72);
	
	var _actionsAuthActions = __webpack_require__(37);
	
	var _actionsProfileActions = __webpack_require__(103);
	
	var _sessionList = __webpack_require__(1157);
	
	var _sessionList2 = _interopRequireDefault(_sessionList);
	
	var _addEditClassModal = __webpack_require__(305);
	
	var _addEditClassModal2 = _interopRequireDefault(_addEditClassModal);
	
	var _completeRegistrationModal = __webpack_require__(1154);
	
	var _completeRegistrationModal2 = _interopRequireDefault(_completeRegistrationModal);
	
	var _imagesEsmeralda_goober_half_wavePng = __webpack_require__(915);
	
	var _imagesEsmeralda_goober_half_wavePng2 = _interopRequireDefault(_imagesEsmeralda_goober_half_wavePng);
	
	__webpack_require__(2200);
	
	var _featureFlags = __webpack_require__(300);
	
	var _featureFlags2 = _interopRequireDefault(_featureFlags);
	
	var _servicesCookie = __webpack_require__(301);
	
	var _servicesPrograms = __webpack_require__(104);
	
	var programs = _interopRequireWildcard(_servicesPrograms);
	
	var HomeDashboard = (function (_Component) {
	  _inherits(HomeDashboard, _Component);
	
	  _createClass(HomeDashboard, null, [{
	    key: 'propTypes',
	    value: {
	      auth: _react.PropTypes.shape({
	        authData: _react.PropTypes.shape({
	          uid: _react.PropTypes.string.isRequired
	        }).isRequired
	      }).isRequired,
	      sessions: _react.PropTypes.object.isRequired,
	      bindSessions: _react.PropTypes.func.isRequired,
	      unbind: _react.PropTypes.func.isRequired,
	      createSession: _react.PropTypes.func.isRequired,
	      updateSession: _react.PropTypes.func.isRequired,
	      buySession: _react.PropTypes.func.isRequired,
	      resetAddEditClassForm: _react.PropTypes.func.isRequired,
	      completeRegistration: _react.PropTypes.func.isRequired,
	      profile: _react.PropTypes.object.isRequired,
	      updateProfile: _react.PropTypes.func.isRequired
	    },
	    enumerable: true
	  }, {
	    key: 'contextTypes',
	    value: {
	      staff: _react.PropTypes.bool,
	      location: _react.PropTypes.object.isRequired,
	      userId: _react.PropTypes.string
	    },
	    enumerable: true
	  }]);
	
	  function HomeDashboard(props, context) {
	    _classCallCheck(this, HomeDashboard);
	
	    _get(Object.getPrototypeOf(HomeDashboard.prototype), 'constructor', this).call(this, props, context);
	    this.state = {
	      showAddEditClassModal: false,
	      showCompleteRegistrationModal: false,
	      loading: true,
	      availablePrograms: [],
	      editSession: null
	    };
	  }
	
	  _createClass(HomeDashboard, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this = this;
	
	      var userId = this.props.auth.authData.uid;
	      this.boundRefs = [];
	      this.props.bindSessions(userId, this.boundRefs);
	      this.count = 0;
	      this.interval = setInterval(function () {
	        if (_this.count === _this.props.sessions.sessionList.length) {
	          clearInterval(_this.interval);
	          _this.setState({ loading: false });
	        }
	        _this.count = _this.props.sessions.sessionList.length;
	      }, 250);
	      dataLayer.push({ event: 'showChatWidget' });
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.props.unbind(this.boundRefs);
	      clearInterval(this.interval);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var hasCompletedRegistration = !!nextProps.profile.school;
	      var nbSessions = nextProps.sessions.sessionList.length;
	      var featuredProgram = programs.getFeaturedProgramHelper();
	      this.setState({
	        showCompleteRegistrationModal: !hasCompletedRegistration
	      });
	      if (_featureFlags2['default'].autoCreateClassWhenFeaturedProgramIsPresent) {
	        if (hasCompletedRegistration && !featuredProgram.found && nextProps.sessions.empty) {
	          this.openAddEditClassModal(nextProps.profile);
	        }
	        var firstSessionId = nextProps.sessions.sessionList[0];
	        var firstSession = firstSessionId ? nextProps.sessions.sessions[firstSessionId] : {};
	        if (hasCompletedRegistration && featuredProgram.found && nbSessions === 1 && firstSession.auto) {
	          this.openAddEditClassModal(nextProps.profile, "Class details", "Almost there! We just need the last few details about your class.", firstSessionId);
	        }
	      }
	    }
	  }, {
	    key: 'openAddEditClassModal',
	    value: function openAddEditClassModal(useProfile, title, text, editSession) {
	      var profile = useProfile || this.props.profile;
	      var featuredPrograms = programs.getFeaturedProgramsForProfile(profile);
	      if (featuredPrograms.length > 0) {
	        var featuredProgram = programs.getFeaturedProgramHelper(featuredPrograms[0].id);
	        this.props.resetAddEditClassForm({
	          program: featuredProgram.programId,
	          language: featuredProgram.featuredLanguage
	        });
	      } else {
	        this.props.resetAddEditClassForm();
	      }
	      var availablePrograms = featuredPrograms.length > 0 ? featuredPrograms : programs.getAvailableProgramsForProfile(profile);
	      this.setState({ showAddEditClassModal: true, addEditClassTitle: title, addEditClassText: text, editSession: editSession, availablePrograms: availablePrograms });
	    }
	  }, {
	    key: 'closeAddEditClassModal',
	    value: function closeAddEditClassModal() {
	      this.setState({ showAddEditClassModal: false });
	    }
	  }, {
	    key: 'updateSession',
	    value: function updateSession(data) {
	      var programId = data.program;
	      var language = data.language;
	      var grade = data.grade;
	      var divisionName = data.divisionName;
	      var numberOfStudents = data.numberOfStudents;
	
	      var userId = this.context.userId;
	      this.props.updateSession(this.state.editSession, programId, {
	        language: language,
	        grade: grade,
	        divisionName: divisionName,
	        numberOfStudents: parseInt(numberOfStudents, 10),
	        auto: false
	      }, userId);
	      this.closeAddEditClassModal();
	    }
	  }, {
	    key: 'createSession',
	    value: function createSession(data) {
	      var _this2 = this;
	
	      var userId = this.props.auth.authData.uid;
	      var sessions = this.props.sessions;
	      var staff = this.context.staff;
	
	      var contractId = tryGetCookieValue("contractId");
	      var programId = data.program;
	      var language = data.language;
	      var grade = data.grade;
	      var divisionName = data.divisionName;
	      var numberOfStudents = data.numberOfStudents;
	
	      var _ref = (0, _servicesCookie.parseCookie)(tryGetCookieValue('ppa_referral')) || this.props.profile;
	
	      var referrerUserId = _ref.referrerUserId;
	
	      var hasFeaturedPrograms = programs.hasFeaturedPrograms();
	      return this.props.createSession(userId, programId, {
	        language: language,
	        grade: grade,
	        divisionName: divisionName,
	        numberOfStudents: parseInt(numberOfStudents, 10),
	        pendingApproval: !(staff || hasFeaturedPrograms && contractId),
	        firstClass: sessions.sessionList && sessions.sessionList.length === 0,
	        contractId: hasFeaturedPrograms && contractId,
	        referrerUserId: referrerUserId
	      }).then(function () {
	        if (_this2.props.profile.gettingStartedOptIn) return;
	        return _this2.props.updateProfile(userId, _extends({}, _this2.props.profile, { gettingStartedOptIn: true, consent: 'implicit' }));
	      }).then(function () {
	        _this2.closeAddEditClassModal();
	      });
	    }
	  }, {
	    key: '_sessionClassIndexList',
	    value: function _sessionClassIndexList() {
	      var _this3 = this;
	
	      var fundedIndexList = [];
	      var notFundedIndexList = [];
	      var sessions = this.props.sessions;
	      var sessionIdList = sessions.sessionList;
	
	      var activeSessionList = sessionIdList.map(function (id) {
	        return _extends({ id: id }, sessions.sessions[id]);
	      }).filter(function (session) {
	        return !session.archived;
	      });
	      activeSessionList.sort(function (left, right) {
	        return right.updatedAt - left.updatedAt;
	      });
	      activeSessionList.map(function (session, index) {
	        var staff = _this3.context.staff;
	
	        if (staff) fundedIndexList.push(index);
	        if (session.funding === 'STRIPE' || session.funding === 'CONTRACT') {
	          var validUntilDate = new Date(session.validUntil);
	          if (Date.now() < validUntilDate) fundedIndexList.push(index);
	        } else if (!session.pendingApproval && !session.hiddenAt) {
	          fundedIndexList.push(index);
	        } else {
	          notFundedIndexList.push(index);
	        }
	      });
	      return { fundedIndexList: fundedIndexList, notFundedIndexList: notFundedIndexList };
	    }
	  }, {
	    key: 'closeCompleteRegistrationModal',
	    value: function closeCompleteRegistrationModal() {
	      this.setState({ showCompleteRegistrationModal: false });
	    }
	  }, {
	    key: 'submitCompleteRegistration',
	    value: function submitCompleteRegistration(data) {
	      var _this4 = this;
	
	      var userId = this.props.auth.authData.uid;
	      this.props.completeRegistration(userId, this.props.profile, data).then(function () {
	        return _this4.setState({ showCompleteRegistrationModal: false });
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      var _state = this.state;
	      var showAddEditClassModal = _state.showAddEditClassModal;
	      var showCompleteRegistrationModal = _state.showCompleteRegistrationModal;
	      var addEditClassText = _state.addEditClassText;
	      var addEditClassTitle = _state.addEditClassTitle;
	      var sessions = this.props.sessions;
	      var sessionList = sessions.sessionList;
	      var empty = sessions.empty;
	      var _state2 = this.state;
	      var loading = _state2.loading;
	      var availablePrograms = _state2.availablePrograms;
	      var editSession = _state2.editSession;
	
	      var noSessions = sessionList.filter(function (sessionId) {
	        var session = sessions.sessions[sessionId];
	        return !session.archived;
	      }).length === 0;
	      var programLookup = programs.getProgramsLookup();
	      if (empty) {
	        return _react2['default'].createElement(
	          'div',
	          { className: 'register-success' },
	          _react2['default'].createElement(_completeRegistrationModal2['default'], { showModal: showCompleteRegistrationModal,
	            closeModal: this.closeCompleteRegistrationModal.bind(this),
	            onSubmit: this.submitCompleteRegistration.bind(this) }),
	          _react2['default'].createElement(
	            'div',
	            { className: 'row' },
	            _react2['default'].createElement(
	              'div',
	              { className: 'col-md-5' },
	              _react2['default'].createElement('img', { className: 'character-image', src: _imagesEsmeralda_goober_half_wavePng2['default'] })
	            ),
	            _react2['default'].createElement(
	              'div',
	              { className: 'welcomeHeaderContainer col-md-7' },
	              _react2['default'].createElement(
	                'h4',
	                { className: 'welcomeHeader', id: 'welcomeHeader1' },
	                'Welcome to the Planet Protector Academy!'
	              ),
	              _react2['default'].createElement(
	                'h4',
	                { className: 'welcomeHeader', id: 'welcomeHeader2' },
	                'Almost there! Just add your class to begin! to?'
	              ),
	              _react2['default'].createElement(
	                'button',
	                {
	                  className: 'welcomeHeaderBtn btn btn-primary btn-sm glyphicon glyphicon-plus',
	                  onClick: function () {
	                    return _this5.openAddEditClassModal();
	                  } },
	                'Add my first class'
	              ),
	              _react2['default'].createElement(_addEditClassModal2['default'], {
	                programs: availablePrograms,
	                showModal: showAddEditClassModal,
	                text: addEditClassText,
	                title: addEditClassTitle,
	                edit: false,
	                onSubmit: this.createSession.bind(this),
	                closeModal: this.closeAddEditClassModal.bind(this) })
	            )
	          )
	        );
	      }
	
	      return _react2['default'].createElement(
	        'div',
	        null,
	        _react2['default'].createElement(_completeRegistrationModal2['default'], { showModal: showCompleteRegistrationModal,
	          closeModal: this.closeCompleteRegistrationModal.bind(this),
	          onSubmit: this.submitCompleteRegistration.bind(this) }),
	        loading && _react2['default'].createElement(
	          'div',
	          null,
	          _react2['default'].createElement(
	            'h3',
	            null,
	            'Loading...'
	          )
	        ),
	        _react2['default'].createElement(_sessionList2['default'], {
	          sessions: sessions,
	          programLookup: programLookup,
	          resetAddEditClassForm: this.props.resetAddEditClassForm,
	          updateSession: this.props.updateSession,
	          buySession: this.props.buySession,
	          filterIfFunded: true }),
	        !loading && noSessions && _react2['default'].createElement(
	          'div',
	          null,
	          _react2['default'].createElement(
	            'h3',
	            null,
	            'All your classes are archived, please add a new one.'
	          )
	        ),
	        _react2['default'].createElement(_addEditClassModal2['default'], {
	          programs: availablePrograms,
	          showModal: showAddEditClassModal,
	          text: addEditClassText,
	          title: addEditClassTitle,
	          edit: !!editSession,
	          onSubmit: editSession ? this.updateSession.bind(this) : this.createSession.bind(this),
	          closeModal: this.closeAddEditClassModal.bind(this) })
	      );
	    }
	  }]);
	
	  return HomeDashboard;
	})(_react.Component);
	
	exports['default'] = (0, _reactRedux.connect)(function (state) {
	  return {
	    auth: state.auth,
	    profile: state.profile,
	    sessions: state.sessions
	  };
	}, {
	  bindSessions: _actionsSessionActions.bindSessions,
	  unbind: _actionsSessionActions.unbind,
	  createSession: _actionsSessionActions.createSession,
	  updateSession: _actionsSessionActions.updateSession,
	  buySession: _actionsSessionActions.buySession,
	  resetAddEditClassForm: _actionsSessionActions.resetAddEditClassForm,
	  completeRegistration: _actionsAuthActions.completeRegistration,
	  updateProfile: _actionsProfileActions.updateProfile
	})(HomeDashboard);
	module.exports = exports['default'];

/***/ }),
/* 1157 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _get = __webpack_require__(8)['default'];
	
	var _inherits = __webpack_require__(5)['default'];
	
	var _createClass = __webpack_require__(6)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _extends = __webpack_require__(7)['default'];
	
	var _getIterator = __webpack_require__(62)['default'];
	
	var _Promise = __webpack_require__(33)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactAddonsCssTransitionGroup = __webpack_require__(188);
	
	var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);
	
	var _sessionPanel = __webpack_require__(1158);
	
	var _sessionPanel2 = _interopRequireDefault(_sessionPanel);
	
	var _buyNowModal = __webpack_require__(1153);
	
	var _buyNowModal2 = _interopRequireDefault(_buyNowModal);
	
	var _servicesPromoCode = __webpack_require__(475);
	
	var _servicesPromoCode2 = _interopRequireDefault(_servicesPromoCode);
	
	__webpack_require__(2201);
	
	var buyNowDefault = function buyNowDefault() {
	  return {
	    showModal: false,
	    programName: '',
	    programId: '',
	    sessionId: ''
	  };
	};
	
	var SessionList = (function (_Component) {
	  _inherits(SessionList, _Component);
	
	  _createClass(SessionList, null, [{
	    key: 'propTypes',
	    value: {
	      sessions: _react.PropTypes.object.isRequired,
	      programLookup: _react.PropTypes.object.isRequired,
	      resetAddEditClassForm: _react.PropTypes.func.isRequired,
	      updateSession: _react.PropTypes.func.isRequired,
	      buySession: _react.PropTypes.func.isRequired
	    },
	    enumerable: true
	  }, {
	    key: 'contextTypes',
	    value: {
	      staff: _react.PropTypes.bool,
	      userId: _react.PropTypes.string,
	      archiveSession: _react.PropTypes.func
	    },
	    enumerable: true
	  }]);
	
	  function SessionList(props, context) {
	    _classCallCheck(this, SessionList);
	
	    _get(Object.getPrototypeOf(SessionList.prototype), 'constructor', this).call(this, props, context);
	    this.state = {
	      buyNow: buyNowDefault(),
	      activeSessionList: [],
	      boughtBucket: [],
	      trialBucket: [],
	      expiredBucket: []
	    };
	    this.archiveLocks = {};
	  }
	
	  _createClass(SessionList, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var buckets = this.calculateBuckets(this.props);
	      this.setState(buckets);
	      this.autoArchive(buckets.expiredBucket);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps /*, nextContext*/) {
	      var buckets = this.calculateBuckets(nextProps);
	      this.setState(buckets);
	      this.autoArchive(buckets.expiredBucket);
	    }
	  }, {
	    key: 'autoArchive',
	    value: function autoArchive(list) {
	      var _context = this.context;
	      var userId = _context.userId;
	      var archiveSession = _context.archiveSession;
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = _getIterator(list), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var session = _step.value;
	
	          if (this.archiveLocks[session.id]) continue;
	          this.archiveLocks[session.id] = true;
	          archiveSession(session.id, session.programId, userId);
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator['return']) {
	            _iterator['return']();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	    }
	  }, {
	    key: 'calculateBuckets',
	    value: function calculateBuckets(props) {
	      var _this = this;
	
	      var sessions = props.sessions;
	      var sessionIdList = sessions.sessionList;
	
	      var activeSessionList = sessionIdList.map(function (id) {
	        return _extends({ id: id }, sessions.sessions[id]);
	      }).filter(function (session) {
	        return !session.archived;
	      });
	
	      var sortBucket = function sortBucket(left, right) {
	        return new Date(left.createdAt) > new Date(right.createdAt) ? -1 : 1;
	      };
	
	      var boughtBucket = activeSessionList.filter(function (session) {
	        return (session.funding === "STRIPE" || session.funding === "CONTRACT") && new Date(session.validUntil) > new Date() || _this.context.staff;
	      }).sort(sortBucket);
	
	      var trialBucket = activeSessionList.filter(function (session) {
	        return typeof session.funding === 'undefined' || typeof session.funding === 'object' || session.funding === 'CANCELLED';
	      }).sort(sortBucket);
	
	      var expiredBucket = activeSessionList.filter(function (session) {
	        return (session.funding === "STRIPE" || session.funding === "CONTRACT") && new Date(session.validUntil) < new Date();
	      }).sort(sortBucket);
	
	      return {
	        activeSessionList: activeSessionList,
	        boughtBucket: boughtBucket,
	        trialBucket: trialBucket,
	        expiredBucket: expiredBucket
	      };
	    }
	  }, {
	    key: 'handleChargeProcessed',
	    value: function handleChargeProcessed(data) {
	      var buySession = this.props.buySession;
	      var userId = this.context.userId;
	      var sessionId = data.sessionId;
	      var programId = data.programId;
	      var promoCode = data.promoCode;
	      var charge = data.charge;
	
	      var buyData = {
	        stripeChargeId: charge.id,
	        promoCode: promoCode ? promoCode.code : null,
	        paidAmount: charge.amount / 100,
	        paidCurrency: charge.currency
	      };
	      var promise = _Promise.resolve();
	      if (buyData.promoCode) {
	        promise.then(function () {
	          return _servicesPromoCode2['default'].decreaseAvailable(buyData.promoCode);
	        });
	      }
	      promise.then(function () {
	        return buySession(sessionId, programId, buyData, userId);
	      });
	      return promise;
	    }
	  }, {
	    key: 'displayBuyNowModal',
	    value: function displayBuyNowModal(sessionId, programId, programName) {
	      this.setState({
	        buyNow: {
	          sessionId: sessionId,
	          programId: programId,
	          programName: programName,
	          showModal: true
	        }
	      });
	    }
	  }, {
	    key: 'closeBuyNowModal',
	    value: function closeBuyNowModal() {
	      this.setState({ buyNow: buyNowDefault() });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props;
	      var programLookup = _props.programLookup;
	      var resetAddEditClassForm = _props.resetAddEditClassForm;
	      var updateSession = _props.updateSession;
	      var _state = this.state;
	      var buyNow = _state.buyNow;
	      var activeSessionList = _state.activeSessionList;
	      var boughtBucket = _state.boughtBucket;
	      var trialBucket = _state.trialBucket;
	      var expiredBucket = _state.expiredBucket;
	
	      var mapBucket = function mapBucket(bucket, expand, predicate) {
	        return bucket.map(function (session) {
	          return _react2['default'].createElement(_sessionPanel2['default'], _extends({
	            expanded: expand === "all" || predicate && session === bucket[0] ? true : expand === "none" ? false : session === bucket[0],
	            key: session.id,
	            id: session.id,
	            program: programLookup[session.programId],
	            resetEditClassForm: resetAddEditClassForm,
	            updateSession: updateSession,
	            displayBuyNowModal: _this2.displayBuyNowModal.bind(_this2),
	            highlightProgramOverview: false
	          }, session));
	        });
	      };
	
	      return _react2['default'].createElement(
	        'div',
	        { className: 'panel-group session-panel-group' },
	        _react2['default'].createElement(_buyNowModal2['default'], {
	          key: buyNow.sessionId,
	          showModal: buyNow.showModal,
	          onChargeProcessed: this.handleChargeProcessed.bind(this),
	          closeModal: this.closeBuyNowModal.bind(this),
	          programName: buyNow.programName,
	          programId: buyNow.programId,
	          sessionId: buyNow.sessionId }),
	        _react2['default'].createElement(
	          _reactAddonsCssTransitionGroup2['default'],
	          {
	            transitionName: 'session-list',
	            transitionEnterTimeout: 500,
	            transitionLeaveTimeout: 1000 },
	          (activeSessionList.length === 1 && boughtBucket.length > 0 || boughtBucket.length > 0) && mapBucket(boughtBucket, "all", true),
	          activeSessionList.length === 1 && trialBucket.length > 0 && !this.context.staff ? mapBucket(trialBucket, "all", true) : trialBucket.length > 0 && !this.context.staff ? mapBucket(trialBucket, "none", boughtBucket.length === 0) : _react2['default'].createElement('div', null),
	          activeSessionList.length === 1 && expiredBucket.length > 0 && !this.context.staff ? mapBucket(expiredBucket, "all", true) : expiredBucket.length > 0 && !this.context.staff ? mapBucket(expiredBucket, "none", boughtBucket.length === 0 && trialBucket.length === 0) : _react2['default'].createElement('div', null)
	        )
	      );
	    }
	  }]);
	
	  return SessionList;
	})(_react.Component);
	
	exports['default'] = SessionList;
	module.exports = exports['default'];

/***/ }),
/* 1158 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _taggedTemplateLiteral = __webpack_require__(28)['default'];
	
	var _get = __webpack_require__(8)['default'];
	
	var _inherits = __webpack_require__(5)['default'];
	
	var _createClass = __webpack_require__(6)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _extends = __webpack_require__(7)['default'];
	
	var _Object$keys = __webpack_require__(32)['default'];
	
	var _Promise = __webpack_require__(33)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['#', ':'], ['#', ':']),
	    _templateObject2 = _taggedTemplateLiteral(['Start Module ', ''], ['Start Module ', '']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(22);
	
	var _addEditClassModal = __webpack_require__(305);
	
	var _addEditClassModal2 = _interopRequireDefault(_addEditClassModal);
	
	var _archiveClassModal = __webpack_require__(1152);
	
	var _archiveClassModal2 = _interopRequireDefault(_archiveClassModal);
	
	var _startFromLastSlideModal = __webpack_require__(1159);
	
	var _startFromLastSlideModal2 = _interopRequireDefault(_startFromLastSlideModal);
	
	var _actionsSessionActions = __webpack_require__(72);
	
	var _reactBootstrap = __webpack_require__(24);
	
	__webpack_require__(2202);
	
	var _imagesProjectorIconPng = __webpack_require__(2533);
	
	var _imagesProjectorIconPng2 = _interopRequireDefault(_imagesProjectorIconPng);
	
	var _imagesBuyIconPng = __webpack_require__(2524);
	
	var _imagesBuyIconPng2 = _interopRequireDefault(_imagesBuyIconPng);
	
	var _imagesStartLevelPng = __webpack_require__(2534);
	
	var _imagesStartLevelPng2 = _interopRequireDefault(_imagesStartLevelPng);
	
	var _servicesRegionalization = __webpack_require__(38);
	
	var _servicesRegionalization2 = _interopRequireDefault(_servicesRegionalization);
	
	var _helpersI18n = __webpack_require__(14);
	
	var ActivePanel1 = (function (_Component) {
	  _inherits(ActivePanel1, _Component);
	
	  _createClass(ActivePanel1, null, [{
	    key: 'propTypes',
	    value: {
	      program: _react.PropTypes.object.isRequired,
	      currentLevel: _react.PropTypes.number.isRequired,
	      mobile: _react.PropTypes.bool,
	      profile: _react.PropTypes.object.isRequired,
	      i18n: _react.PropTypes.func.isRequired
	    },
	    enumerable: true
	  }]);
	
	  function ActivePanel1(props) {
	    _classCallCheck(this, ActivePanel1);
	
	    _get(Object.getPrototypeOf(ActivePanel1.prototype), 'constructor', this).call(this, props);
	    this.state = {
	      activePanel: '' + (props.currentLevel >= _Object$keys(props.program.levels).filter(function (k) {
	        return parseInt(k, 10);
	      }).length ? '1' : props.currentLevel)
	    };
	  }
	
	  _createClass(ActivePanel1, [{
	    key: 'render',
	    value: function render() {
	      var _this = this;
	
	      var levelKeys = _Object$keys(this.props.program.levels).filter(function (k) {
	        return parseInt(k, 10);
	      });
	      var _ = this.props.i18n;
	
	      return _react2['default'].createElement(
	        'div',
	        { className: 'activePanel1 ' + (this.props.mobile ? 'mobileActivePanel' : '') },
	        _react2['default'].createElement(
	          'div',
	          { className: 'col-md-12 col-sm-12 col-xs-12 program-title-panel' },
	          _(this.props.program.title),
	          ' ',
	          _('Overview')
	        ),
	        _react2['default'].createElement(
	          'div',
	          { className: 'col-md-12 col-sm-12 col-xs-12', style: { padding: '0' } },
	          _react2['default'].createElement(
	            'div',
	            {
	              className: 'program-description-btn-panel col-md-12 col-sm-12 col-xs-12',
	              style: { marginTop: '10px' }
	            },
	            _react2['default'].createElement(
	              'div',
	              { className: 'col-md-5 col-sm-12 col-xs-12 program-description-level-list' },
	              levelKeys.map(function (l) {
	                var lvl = _this.props.program.levels[l];
	                return _react2['default'].createElement(
	                  'div',
	                  { key: l },
	                  _react2['default'].createElement(
	                    'div',
	                    {
	                      className: 'row program-description-panel program-desc-level-btn btn btn-sm col-md-12 col-sm-12 col-xs-12 ' + (_this.state.activePanel === l ? 'activeDescPanelBtn' : 'inactiveDescPanelBtn'),
	                      onClick: function () {
	                        return _this.setState({ activePanel: l });
	                      }
	                    },
	                    _react2['default'].createElement(
	                      'div',
	                      {
	                        className: 'col-md-2 col-xs-2',
	                        style: {
	                          paddingLeft: '5px',
	                          paddingRight: '5px'
	                        }
	                      },
	                      _react2['default'].createElement('img', {
	                        src: lvl.overviewThumbnail,
	                        style: {
	                          height: '52px !important',
	                          paddingLeft: '5px',
	                          paddingRight: '5px',
	                          float: 'left'
	                        }
	                      })
	                    ),
	                    _react2['default'].createElement(
	                      'div',
	                      {
	                        style: {
	                          float: 'left',
	                          paddingTop: '10px',
	                          paddingLeft: '25px',
	                          paddingRight: '10px',
	                          textTransform: 'none',
	                          fontSize: '15px',
	                          textAlign: 'left'
	                        },
	                        className: 'col-md-8 col-xs-8'
	                      },
	                      _(_templateObject, l),
	                      ' ',
	                      _(lvl.levelName)
	                    ),
	                    _react2['default'].createElement('span', {
	                      className: 'glyphicon col-md-1 col-xs-1 session-panel-arrow-icon panel-heading-btn-lh  ' + (_this.state.activePanel === l ? '' : 'glyphicon-chevron-right'),
	                      style: _this.state.activePanel === l ? { display: 'none !important' } : {
	                        fontSize: '32px',
	                        paddingRight: '0',
	                        float: 'left'
	                      },
	                      ariaHidden: 'true'
	                    })
	                  ),
	                  _this.state.activePanel === l && _react2['default'].createElement(
	                    'div',
	                    { className: 'col-md-7 col-sm-12 col-xs-12 program-description-active-panel mobile-program-description-active-panel' },
	                    _react2['default'].createElement('div', { dangerouslySetInnerHTML: {
	                        __html: _(_this.props.program.levels[_this.state.activePanel].prep).getAllAsHtmlWithPrefixedUrls('programPrep/' + _this.props.program.id + '/', _servicesRegionalization2['default'].getRegionDataFromProfile(_this.props.profile))
	                      } })
	                  )
	                );
	              })
	            ),
	            _react2['default'].createElement(
	              'div',
	              { className: 'col-md-7 col-sm-12 col-xs-12 program-description-active-panel desktop-program-description-active-panel' },
	              _react2['default'].createElement('div', { dangerouslySetInnerHTML: {
	                  __html: _(this.props.program.levels[this.state.activePanel].prep).getAllAsHtmlWithPrefixedUrls('programPrep/' + this.props.program.id + '/', _servicesRegionalization2['default'].getRegionDataFromProfile(this.props.profile))
	                } })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return ActivePanel1;
	})(_react.Component);
	
	var ActivePanel2 = (function (_Component2) {
	  _inherits(ActivePanel2, _Component2);
	
	  function ActivePanel2() {
	    _classCallCheck(this, ActivePanel2);
	
	    _get(Object.getPrototypeOf(ActivePanel2.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(ActivePanel2, [{
	    key: 'render',
	    value: function render() {
	      var _ = this.props.i18n;
	
	      return _react2['default'].createElement(
	        'div',
	        { className: 'activePanel2 ' + (this.props.mobile ? 'mobileActivePanel' : '') },
	        _react2['default'].createElement(
	          'div',
	          { className: 'col-md-12 col-sm-12 col-xs-12 program-title-panel' },
	          _('Teacher Resources')
	        ),
	        _react2['default'].createElement(
	          'div',
	          { className: 'col-md-12 col-sm-12 col-xs-12', style: { padding: '0', marginBottom: '5px' } },
	          _react2['default'].createElement(
	            'div',
	            { className: 'program-description-panel' },
	            _react2['default'].createElement('div', { dangerouslySetInnerHTML: {
	                __html: _(this.props.program.programPrepMd).getSectionAsHtmlWithPrefixedUrls('Teacher Resources', false, 'programPrep/' + this.props.program.id + '/', _servicesRegionalization2['default'].getRegionDataFromProfile(this.props.profile))
	              } })
	          )
	        )
	      );
	    }
	  }], [{
	    key: 'propTypes',
	    value: {
	      program: _react.PropTypes.object.isRequired,
	      mobile: _react.PropTypes.bool,
	      profile: _react.PropTypes.object.isRequired,
	      i18n: _react.PropTypes.func.isRequired
	    },
	    enumerable: true
	  }]);
	
	  return ActivePanel2;
	})(_react.Component);
	
	var ActivePanel3 = (function (_Component3) {
	  _inherits(ActivePanel3, _Component3);
	
	  function ActivePanel3() {
	    _classCallCheck(this, ActivePanel3);
	
	    _get(Object.getPrototypeOf(ActivePanel3.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(ActivePanel3, [{
	    key: 'render',
	    value: function render() {
	      var _ = this.props.i18n;
	
	      return _react2['default'].createElement(
	        'div',
	        { className: 'activePanel3 ' + (this.props.mobile ? 'mobileActivePanel' : '') },
	        _react2['default'].createElement(
	          'div',
	          { className: 'col-md-12 col-sm-12 col-xs-12 program-title-panel' },
	          _('Printables')
	        ),
	        _react2['default'].createElement(
	          'div',
	          { className: 'col-md-12 col-sm-12 col-xs-12', style: { padding: '0' } },
	          _react2['default'].createElement(
	            'div',
	            { className: 'program-description-panel' },
	            _react2['default'].createElement('div', { dangerouslySetInnerHTML: {
	                __html: _(this.props.program.programPrepMd).getSectionAsHtmlWithPrefixedUrls('Printables', false, 'programPrep/' + this.props.program.id + '/', _servicesRegionalization2['default'].getRegionDataFromProfile(this.props.profile))
	              } })
	          )
	        )
	      );
	    }
	  }], [{
	    key: 'propTypes',
	    value: {
	      program: _react.PropTypes.object.isRequired,
	      mobile: _react.PropTypes.bool,
	      profile: _react.PropTypes.object.isRequired,
	      i18n: _react.PropTypes.func.isRequired
	    },
	    enumerable: true
	  }]);
	
	  return ActivePanel3;
	})(_react.Component);
	
	var SessionPanel = (function (_Component4) {
	  _inherits(SessionPanel, _Component4);
	
	  _createClass(SessionPanel, null, [{
	    key: 'propTypes',
	    value: {
	      id: _react.PropTypes.string.isRequired,
	      program: _react.PropTypes.object.isRequired,
	      lastSlide: _react.PropTypes.string,
	      completedLevel: _react.PropTypes.number,
	      grade: _react.PropTypes.string,
	      divisionName: _react.PropTypes.string,
	      numberOfStudents: _react.PropTypes.number,
	      resetEditClassForm: _react.PropTypes.func.isRequired,
	      updateSession: _react.PropTypes.func.isRequired,
	      pendingApproval: _react.PropTypes.bool,
	      hiddenAt: _react.PropTypes.number,
	      expanded: _react.PropTypes.bool,
	      validUntil: _react.PropTypes.number,
	      funding: _react.PropTypes.string,
	      displayBuyNowModal: _react.PropTypes.func.isRequired,
	      setLastSlide: _react.PropTypes.func.isRequired,
	      profile: _react.PropTypes.object.isRequired,
	      highlightProgramOverview: _react.PropTypes.bool.isRequired,
	      language: _react.PropTypes.string
	    },
	    enumerable: true
	  }, {
	    key: 'contextTypes',
	    value: {
	      setActiveSession: _react.PropTypes.func.isRequired,
	      archiveSession: _react.PropTypes.func.isRequired,
	      staff: _react.PropTypes.bool,
	      userId: _react.PropTypes.string
	    },
	    enumerable: true
	  }]);
	
	  function SessionPanel(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, _SessionPanel);
	
	    _get(Object.getPrototypeOf(_SessionPanel.prototype), 'constructor', this).call(this, props);
	    this.state = {
	      expanded: props.expanded,
	      showEditClassModal: false,
	      showArchiveClassModal: false,
	      showStartFromLastSlideModal: false,
	      activePanel: 0,
	      language: props.language
	    };
	    this.i18n = (0, _helpersI18n.i18n)(props.language);
	    var program = props.program;
	
	    _Object$keys(program.levels).forEach(function (level) {
	      _this2.state['showPrepareLevel' + level + 'Modal'] = false;
	    });
	  }
	
	  _createClass(SessionPanel, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.i18n = (0, _helpersI18n.i18n)(nextProps.language);
	      this.setState({
	        expanded: nextProps.expanded,
	        language: nextProps.language
	      });
	    }
	  }, {
	    key: 'setupAV',
	    value: function setupAV() {
	      this.context.setActiveSession(this.props.id, 'prep', this.props.program.id);
	    }
	  }, {
	    key: 'openEditClassModal',
	    value: function openEditClassModal() {
	      var _props = this.props;
	      var resetEditClassForm = _props.resetEditClassForm;
	      var language = _props.language;
	      var grade = _props.grade;
	      var divisionName = _props.divisionName;
	      var numberOfStudents = _props.numberOfStudents;
	      var program = _props.program;
	
	      resetEditClassForm({
	        program: program.id,
	        language: language,
	        grade: grade,
	        divisionName: divisionName,
	        numberOfStudents: numberOfStudents
	      });
	      this.setState({ showEditClassModal: true });
	    }
	  }, {
	    key: 'closeEditClassModal',
	    value: function closeEditClassModal() {
	      this.setState({ showEditClassModal: false });
	    }
	  }, {
	    key: 'openArchiveClassModal',
	    value: function openArchiveClassModal() {
	      this.setState({ showArchiveClassModal: true });
	    }
	  }, {
	    key: 'closeArchiveClassModal',
	    value: function closeArchiveClassModal() {
	      this.setState({ showArchiveClassModal: false });
	    }
	  }, {
	    key: 'archiveClass',
	    value: function archiveClass(data) {
	      var _context = this.context;
	      var archiveSession = _context.archiveSession;
	      var userId = _context.userId;
	      var sessionId = data.sessionId;
	      var program = this.props.program;
	      var programId = program.id;
	
	      archiveSession(sessionId, programId, userId);
	    }
	  }, {
	    key: 'editSession',
	    value: function editSession(data) {
	      var _props2 = this.props;
	      var id = _props2.id;
	      var updateSession = _props2.updateSession;
	      var program = _props2.program;
	      var programId = program.id;
	      var language = data.language;
	      var grade = data.grade;
	      var divisionName = data.divisionName;
	      var numberOfStudents = data.numberOfStudents;
	
	      var userId = this.context.userId;
	      updateSession(id, programId, {
	        language: language,
	        grade: grade,
	        divisionName: divisionName,
	        numberOfStudents: parseInt(numberOfStudents, 10)
	      }, userId);
	      this.closeEditClassModal();
	    }
	  }, {
	    key: 'toggleExpanded',
	    value: function toggleExpanded() {
	      this.setState({ expanded: !this.state.expanded });
	    }
	  }, {
	    key: 'displayStartFromLastSlideModal',
	    value: function displayStartFromLastSlideModal(level) {
	      this.setState({ showStartFromLastSlideModal: true, level: level });
	    }
	  }, {
	    key: 'hideStartFromLastSlideModal',
	    value: function hideStartFromLastSlideModal() {
	      this.setState({ showStartFromLastSlideModal: false, level: null });
	    }
	  }, {
	    key: 'launchLevel',
	    value: function launchLevel(level) {
	      var lastSlide = this.props.lastSlide;
	
	      if (!lastSlide) {
	        this._launchLevel(level);
	      } else {
	        this.displayStartFromLastSlideModal(level);
	      }
	    }
	  }, {
	    key: '_launchLevel',
	    value: function _launchLevel(level, fromBeginning) {
	      var _this3 = this;
	
	      var setActiveSession = this.context.setActiveSession;
	
	      (fromBeginning ? this.props.setLastSlide({ sessionId: this.props.id }) : _Promise.resolve()).then(function () {
	        return setActiveSession(_this3.props.id, level, _this3.props.program.id);
	      });
	    }
	  }, {
	    key: 'displayBuyNowModal',
	    value: function displayBuyNowModal() {
	      var _props3 = this.props;
	      var sessionId = _props3.id;
	      var program = _props3.program;
	      var programId = program.id;
	      var programName = program.title;
	
	      var _ = this.i18n;
	      this.props.displayBuyNowModal(sessionId, programId, _(programName));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var _state = this.state;
	      var showEditClassModal = _state.showEditClassModal;
	      var showArchiveClassModal = _state.showArchiveClassModal;
	      var _props4 = this.props;
	      var id = _props4.id;
	      var program = _props4.program;
	      var divisionName = _props4.divisionName;
	      var completedLevel = _props4.completedLevel;
	
	      var _ = this.i18n;
	
	      var panelTitle = _react2['default'].createElement(
	        'div',
	        { className: 'panel-title clearfix', style: { cursor: "pointer !important" } },
	        _react2['default'].createElement(
	          'div',
	          { className: 'col-md-4 col-sm-6 col-xs-6 program-class-name-container', onClick: this.toggleExpanded.bind(this) },
	          _react2['default'].createElement(
	            'span',
	            { className: 'panel-title-text panel-heading-lh program-title-row row' },
	            _('Program:'),
	            ' ',
	            _react2['default'].createElement(
	              'span',
	              { className: 'programTitleSpan' },
	              _(program.title)
	            )
	          ),
	          _react2['default'].createElement(
	            'span',
	            { className: 'panel-title-text panel-heading-lh program-title-row row' },
	            _('Class/Division:'),
	            ' ',
	            _react2['default'].createElement(
	              'span',
	              { className: 'programTitleSpan' },
	              divisionName
	            )
	          )
	        ),
	        _react2['default'].createElement(
	          'div',
	          { className: 'col-md-4 level-bar-container', onClick: this.toggleExpanded.bind(this) },
	          _react2['default'].createElement(
	            'div',
	            { className: 'level-progress-bar-container' },
	            _react2['default'].createElement('div', {
	              className: 'level-progress-bar-bar',
	              style: {
	                width: typeof completedLevel === "number" ? Math.floor(completedLevel / _Object$keys(program.levels).filter(function (k) {
	                  return parseInt(k, 10);
	                }).length * 100) + '%' : "0%"
	              }
	            })
	          )
	        ),
	        _react2['default'].createElement(
	          'span',
	          { className: 'btn-group col-md-2 col-sm-6 col-xs-6 panel-buttons' },
	          _react2['default'].createElement('span', {
	            className: 'glyphicon glyphicon-pencil col-md-4 panel-heading-btn-lh',
	            ariaHidden: 'true',
	            style: { cursor: 'pointer' },
	            title: 'Edit Class',
	            onClick: this.openEditClassModal.bind(this)
	          }),
	          _react2['default'].createElement(_addEditClassModal2['default'], {
	            programs: [program],
	            showModal: showEditClassModal,
	            onSubmit: this.editSession.bind(this),
	            closeModal: this.closeEditClassModal.bind(this),
	            edit: true
	          }),
	          _react2['default'].createElement('span', {
	            className: 'glyphicon glyphicon-remove col-md-4 panel-heading-btn-lh',
	            ariaHidden: 'true',
	            title: 'Archive Class',
	            style: { cursor: 'pointer' },
	            onClick: this.openArchiveClassModal.bind(this)
	          }),
	          _react2['default'].createElement(_archiveClassModal2['default'], {
	            sessionId: id,
	            divisionName: divisionName,
	            showModal: showArchiveClassModal,
	            onSubmit: this.archiveClass.bind(this),
	            closeModal: this.closeArchiveClassModal.bind(this),
	            i18n: this.i18n
	          }),
	          _react2['default'].createElement('span', {
	            className: 'glyphicon col-md-4 panel-heading-btn-lh ' + (this.state.expanded ? 'glyphicon-chevron-up' : 'glyphicon-chevron-down'),
	            ariaHidden: 'true',
	            title: this.state.expanded ? 'Collapse' : 'Expand',
	            style: { cursor: 'pointer' },
	            onClick: this.toggleExpanded.bind(this)
	          })
	        )
	      );
	
	      var isPendingApproval = this.props.pendingApproval && !this.props.referrerUserId;
	      var isRejected = !this.props.pendingApproval && (typeof this.props.funding === "undefined" || typeof this.props.funding === "object" || this.props.funding === 'CANCELLED') && !this.context.staff;
	      var isExpired = !this.props.pendingApproval && (this.props.funding === "STRIPE" || this.props.funding === "CONTRACT") && new Date(this.props.validUntil) < new Date() && !this.context.staff;
	
	      var currentLevel = typeof completedLevel === 'number' ? completedLevel + 1 : 1;
	      return _react2['default'].createElement(
	        _reactBootstrap.Panel,
	        {
	          header: panelTitle,
	          collapsible: true,
	          expanded: this.state.expanded,
	          className: 'col-xs-12 col-sm-12',
	          style: {
	            paddingLeft: '0',
	            paddingRight: '0'
	          }
	        },
	        _react2['default'].createElement(
	          'div',
	          { className: 'col-md-4 program-thumb program-thumb-my-classes' },
	          _react2['default'].createElement('img', { src: isPendingApproval || isRejected ? _(program.trialImageThumb) : isExpired ? _(program.expiredImageThumb) : _(program.thumbnailImage) }),
	          _react2['default'].createElement(_startFromLastSlideModal2['default'], {
	            showModal: this.state.showStartFromLastSlideModal,
	            closeModal: this.hideStartFromLastSlideModal.bind(this),
	            startFromBeginning: function () {
	              return _this4._launchLevel(_this4.state.level, true);
	            },
	            startFromLastSlide: function () {
	              return _this4._launchLevel(_this4.state.level, false);
	            },
	            level: this.state.level,
	            i18n: this.i18n })
	        ),
	        _react2['default'].createElement(
	          'div',
	          { className: 'col-md-4 program-step-container' },
	          _react2['default'].createElement(
	            'div',
	            {
	              className: 'program-step col-md-12 col-sm-12 col-xs-12 btn btn-default session-panel-numb-btn' + (this.state.activePanel === 1 ? ' activePanelBtn' : '') + (this.props.highlightProgramOverview ? ' blink-border' : ''),
	              style: { marginTop: '0' },
	              onClick: function () {
	                _this4.state.activePanel === 1 ? _this4.setState(_extends({}, _this4.state, { activePanel: 0 })) : _this4.setState(_extends({}, _this4.state, { activePanel: 1 }));
	              }
	            },
	            _react2['default'].createElement(
	              'div',
	              { className: 'number-circle' },
	              '1'
	            ),
	            _react2['default'].createElement(
	              'div',
	              { className: 'session-panel-btn-text' },
	              _('Program Overview')
	            ),
	            _react2['default'].createElement(
	              'div',
	              { className: 'session-panel-arrow-icon-container' },
	              _react2['default'].createElement('span', {
	                className: 'glyphicon session-panel-arrow-icon ' + (this.state.activePanel === 1 ? 'glyphicon-chevron-down' : 'glyphicon-chevron-right')
	              })
	            )
	          ),
	          this.state.activePanel === 1 && _react2['default'].createElement(ActivePanel1, { profile: this.props.profile, program: program, currentLevel: currentLevel, mobile: true, i18n: this.i18n }),
	          _react2['default'].createElement(
	            'div',
	            {
	              className: 'program-step row col-md-12 col-sm-12 col-xs-12 btn btn-default session-panel-numb-btn ' + (this.state.activePanel === 2 ? 'activePanelBtn' : ''),
	              onClick: function () {
	                _this4.state.activePanel === 2 ? _this4.setState(_extends({}, _this4.state, { activePanel: 0 })) : _this4.setState(_extends({}, _this4.state, { activePanel: 2 }));
	              }
	            },
	            _react2['default'].createElement(
	              'div',
	              { className: 'number-circle' },
	              '2'
	            ),
	            _react2['default'].createElement(
	              'div',
	              { className: 'session-panel-btn-text' },
	              _('Teacher Resources')
	            ),
	            _react2['default'].createElement(
	              'div',
	              { className: 'session-panel-arrow-icon-container' },
	              _react2['default'].createElement('span', {
	                className: 'glyphicon session-panel-arrow-icon ' + (this.state.activePanel === 2 ? 'glyphicon-chevron-down' : 'glyphicon-chevron-right')
	              })
	            )
	          ),
	          this.state.activePanel === 2 && _react2['default'].createElement(ActivePanel2, { profile: this.props.profile, program: program, mobile: true, i18n: this.i18n }),
	          _react2['default'].createElement(
	            'div',
	            {
	              className: 'program-step row col-md-12 col-sm-12 col-xs-12 btn btn-default session-panel-numb-btn ' + (this.state.activePanel === 3 ? 'activePanelBtn' : ''),
	              style: { marginBottom: '5px' },
	              onClick: function () {
	                _this4.state.activePanel === 3 ? _this4.setState(_extends({}, _this4.state, { activePanel: 0 })) : _this4.setState(_extends({}, _this4.state, { activePanel: 3 }));
	              }
	            },
	            _react2['default'].createElement(
	              'div',
	              { className: 'number-circle' },
	              '3'
	            ),
	            _react2['default'].createElement(
	              'div',
	              { className: 'session-panel-btn-text' },
	              _('Printables')
	            ),
	            _react2['default'].createElement(
	              'div',
	              { className: 'session-panel-arrow-icon-container' },
	              _react2['default'].createElement('span', {
	                className: 'glyphicon session-panel-arrow-icon ' + (this.state.activePanel === 3 ? 'glyphicon-chevron-down' : 'glyphicon-chevron-right')
	              })
	            )
	          ),
	          this.state.activePanel === 3 && _react2['default'].createElement(ActivePanel3, { profile: this.props.profile, program: program, mobile: true, i18n: this.i18n })
	        ),
	        _react2['default'].createElement(
	          'div',
	          { className: 'col-md-4 col-sm-12 col-xs-12 program-launch-container' },
	          isRejected ? _react2['default'].createElement(
	            'div',
	            null,
	            _react2['default'].createElement(
	              'div',
	              {
	                className: 'program-launch btn btn-default session-panel-btn col-sm-12 col-xs-12 col-md-5 fundedProjectorIcon',
	                onClick: function () {
	                  if (!completedLevel) {
	                    _this4.setupAV.call(_this4);
	                  }
	                },
	                style: { float: 'left' }
	              },
	              _react2['default'].createElement('img', {
	                src: _imagesProjectorIconPng2['default'],
	                style: {
	                  marginTop: '5px',
	                  marginBottom: '5px'
	                }
	              }),
	              _react2['default'].createElement(
	                'span',
	                null,
	                _('Set Up Presentation')
	              )
	            ),
	            _react2['default'].createElement(
	              'div',
	              {
	                className: 'program-launch col-md-7 col-sm-12 col-xs-12 btn btn-default session-panel-btn sessionPanelImgIcon',
	                onClick: this.displayBuyNowModal.bind(this),
	                style: { float: 'right' }
	              },
	              _react2['default'].createElement('img', {
	                src: _imagesBuyIconPng2['default'],
	                style: {
	                  marginTop: '15px',
	                  marginBottom: '15px'
	                }
	              })
	            )
	          ) : _react2['default'].createElement(
	            'div',
	            {
	              className: 'program-launch btn btn-default session-panel-btn col-sm-12 col-xs-12 col-md-12 fundedProjectorIcon',
	              onClick: function () {
	                if (isExpired || isPendingApproval && completedLevel >= 1) {
	                  // Do nothing
	                } else {
	                    _this4.setupAV.call(_this4);
	                  }
	              }
	            },
	            _react2['default'].createElement('img', { src: _imagesProjectorIconPng2['default'] }),
	            _react2['default'].createElement(
	              'span',
	              null,
	              _('Set Up Presentation')
	            )
	          ),
	          _react2['default'].createElement(
	            'div',
	            {
	              className: 'program-launch col-md-12 col-sm-12 col-xs-12 btn btn-primary btn-wrap session-panel-launch-btn sessionPanelLaunchImgIcon ' + (isPendingApproval && completedLevel >= 1 || isRejected && completedLevel >= 1 || isExpired ? "rejectedLaunchBtn" : ""),
	              onClick: function () {
	                if (isExpired || isPendingApproval && completedLevel >= 1 || isRejected && completedLevel >= 1) {
	                  // Do nothing
	                } else if (completedLevel >= _Object$keys(program.levels).filter(function (k) {
	                    return parseInt(k, 10);
	                  }).length) {
	                    _this4.launchLevel.call(_this4, 'completed');
	                  } else {
	                    _this4.launchLevel.call(_this4, currentLevel);
	                  }
	              },
	              style: {
	                marginBottom: '0',
	                height: '69.6%'
	              }
	            },
	            _react2['default'].createElement('img', { src: _imagesStartLevelPng2['default'] }),
	            _react2['default'].createElement(
	              'div',
	              { className: 'row' },
	              isExpired ? _('Access Expired') : isPendingApproval && completedLevel >= 1 ? _('Access Pending') : isRejected && completedLevel >= 1 ? _('Buy To Unlock') : completedLevel >= _Object$keys(program.levels).filter(function (k) {
	                return parseInt(k, 10);
	              }).length ? _('Re-Enter') : _(_templateObject2, currentLevel)
	            )
	          )
	        ),
	        this.state.activePanel === 1 ? _react2['default'].createElement(ActivePanel1, { profile: this.props.profile, program: program, currentLevel: currentLevel, i18n: this.i18n }) : this.state.activePanel === 2 ? _react2['default'].createElement(ActivePanel2, { profile: this.props.profile, program: program, i18n: this.i18n }) : this.state.activePanel === 3 ? _react2['default'].createElement(ActivePanel3, { profile: this.props.profile, program: program, i18n: this.i18n }) : _react2['default'].createElement('div', null)
	      );
	    }
	  }]);
	
	  var _SessionPanel = SessionPanel;
	  SessionPanel = (0, _reactRedux.connect)(function (state) {
	    return { profile: state.profile };
	  }, { setLastSlide: _actionsSessionActions.setLastSlide })(SessionPanel) || SessionPanel;
	  return SessionPanel;
	})(_react.Component);
	
	exports['default'] = SessionPanel;
	module.exports = exports['default'];

/***/ }),
/* 1159 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _taggedTemplateLiteral = __webpack_require__(28)['default'];
	
	var _get = __webpack_require__(8)['default'];
	
	var _inherits = __webpack_require__(5)['default'];
	
	var _createClass = __webpack_require__(6)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['Start Level ', ''], ['Start Level ', '']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(24);
	
	__webpack_require__(2203);
	
	var StartFromLastSlideModal = (function (_Component) {
	  _inherits(StartFromLastSlideModal, _Component);
	
	  function StartFromLastSlideModal() {
	    _classCallCheck(this, StartFromLastSlideModal);
	
	    _get(Object.getPrototypeOf(StartFromLastSlideModal.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(StartFromLastSlideModal, [{
	    key: 'cancel',
	    value: function cancel(evt) {
	      var closeModal = this.props.closeModal;
	
	      closeModal();
	      evt.preventDefault();
	      evt.stopPropagation();
	      evt.nativeEvent.stopPropagation();
	    }
	  }, {
	    key: 'handleFromBeginning',
	    value: function handleFromBeginning(evt) {
	      var startFromBeginning = this.props.startFromBeginning;
	
	      startFromBeginning();
	      evt.preventDefault();
	      evt.stopPropagation();
	      evt.nativeEvent.stopPropagation();
	    }
	  }, {
	    key: 'handleFromLastSlide',
	    value: function handleFromLastSlide(evt) {
	      var startFromLastSlide = this.props.startFromLastSlide;
	
	      startFromLastSlide();
	      evt.preventDefault();
	      evt.stopPropagation();
	      evt.nativeEvent.stopPropagation();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var showModal = _props.showModal;
	      var closeModal = _props.closeModal;
	      var level = _props.level;
	      var _ = _props.i18n;
	
	      return _react2['default'].createElement(
	        _reactBootstrap.Modal,
	        { show: showModal, onHide: closeModal, className: 'start-from-last-slide' },
	        _react2['default'].createElement(
	          _reactBootstrap.Modal.Header,
	          { closeButton: true },
	          _react2['default'].createElement(
	            _reactBootstrap.Modal.Title,
	            null,
	            _(_templateObject, level)
	          )
	        ),
	        _react2['default'].createElement(
	          _reactBootstrap.Modal.Body,
	          null,
	          _react2['default'].createElement(
	            'h3',
	            null,
	            _('Resume from where you left off?')
	          ),
	          _react2['default'].createElement(
	            'button',
	            {
	              className: 'btn btn-default',
	              onClick: this.handleFromLastSlide.bind(this) },
	            _('Yes, take me to the last slide I was on')
	          ),
	          _react2['default'].createElement(
	            'button',
	            {
	              className: 'btn btn-default',
	              onClick: this.handleFromBeginning.bind(this) },
	            _('No, I want to start from the beginning of the level')
	          )
	        )
	      );
	    }
	  }], [{
	    key: 'propTypes',
	    value: {
	      showModal: _react.PropTypes.bool.isRequired,
	      closeModal: _react.PropTypes.func.isRequired,
	      startFromBeginning: _react.PropTypes.func.isRequired,
	      startFromLastSlide: _react.PropTypes.func.isRequired,
	      level: _react.PropTypes.number,
	      i18n: _react.PropTypes.func.isRequired
	    },
	    enumerable: true
	  }]);
	
	  return StartFromLastSlideModal;
	})(_react.Component);
	
	exports['default'] = StartFromLastSlideModal;
	module.exports = exports['default'];

/***/ }),
/* 1160 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _get = __webpack_require__(8)['default'];
	
	var _inherits = __webpack_require__(5)['default'];
	
	var _createClass = __webpack_require__(6)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _helpersMarkdownScript = __webpack_require__(9);
	
	var _helpersMarkdownScript2 = _interopRequireDefault(_helpersMarkdownScript);
	
	var _authDataUsageMd = __webpack_require__(723);
	
	var _authDataUsageMd2 = _interopRequireDefault(_authDataUsageMd);
	
	var md = new _helpersMarkdownScript2['default'](_authDataUsageMd2['default']);
	
	var DataUsage = (function (_Component) {
	  _inherits(DataUsage, _Component);
	
	  function DataUsage() {
	    _classCallCheck(this, DataUsage);
	
	    _get(Object.getPrototypeOf(DataUsage.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(DataUsage, [{
	    key: 'render',
	    value: function render() {
	      return _react2['default'].createElement(
	        'div',
	        null,
	        _react2['default'].createElement('div', { dangerouslySetInnerHTML: { __html: md.getAllAsHtml() } })
	      );
	    }
	  }]);
	
	  return DataUsage;
	})(_react.Component);
	
	exports['default'] = DataUsage;
	module.exports = exports['default'];

/***/ }),
/* 1161 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _get = __webpack_require__(8)['default'];
	
	var _inherits = __webpack_require__(5)['default'];
	
	var _createClass = __webpack_require__(6)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(66);
	
	__webpack_require__(2204);
	
	var Footer = (function (_Component) {
	  _inherits(Footer, _Component);
	
	  function Footer() {
	    _classCallCheck(this, Footer);
	
	    _get(Object.getPrototypeOf(Footer.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(Footer, [{
	    key: 'contactUs',
	    value: function contactUs(evt) {
	      evt.preventDefault();
	      evt.stopPropagation();
	      dataLayer.push({
	        event: 'contactUs'
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2['default'].createElement(
	        'footer',
	        { className: 'footer' },
	        _react2['default'].createElement(
	          'div',
	          { className: 'container' },
	          _react2['default'].createElement(
	            'div',
	            null,
	            '© ',
	            new Date().getFullYear(),
	            ' ',
	            _react2['default'].createElement(
	              _reactRouter.Link,
	              { to: '/termsAndConditions' },
	              'Terms & Conditions'
	            ),
	            ' | ',
	            ' ',
	            _react2['default'].createElement(
	              _reactRouter.Link,
	              { to: '/dataUsage' },
	              'Data Usage Policy'
	            ),
	            ' | ',
	            ' ',
	            _react2['default'].createElement(
	              'a',
	              { href: 'http://help.planetprotectoracademy.com', target: '_blank' },
	              'Help & Support'
	            ),
	            ' | ',
	            ' ',
	            _react2['default'].createElement(
	              'a',
	              { onClick: this.contactUs.bind(this) },
	              'Contact Us'
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Footer;
	})(_react.Component);
	
	exports['default'] = Footer;
	module.exports = exports['default'];

/***/ }),
/* 1162 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _get = __webpack_require__(8)['default'];
	
	var _inherits = __webpack_require__(5)['default'];
	
	var _createClass = __webpack_require__(6)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(22);
	
	var _landingPageHomeLanding = __webpack_require__(1169);
	
	var _landingPageHomeLanding2 = _interopRequireDefault(_landingPageHomeLanding);
	
	var _dashboardHomeDashboard = __webpack_require__(1156);
	
	var _dashboardHomeDashboard2 = _interopRequireDefault(_dashboardHomeDashboard);
	
	var Home = (function (_Component) {
	  _inherits(Home, _Component);
	
	  function Home() {
	    _classCallCheck(this, Home);
	
	    _get(Object.getPrototypeOf(Home.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(Home, [{
	    key: 'render',
	    value: function render() {
	      var loggedIn = this.props.auth.loggedIn;
	
	      if (!loggedIn) {
	        return _react2['default'].createElement(_landingPageHomeLanding2['default'], null);
	      } else {
	        return _react2['default'].createElement(_dashboardHomeDashboard2['default'], null);
	      }
	    }
	  }], [{
	    key: 'propTypes',
	    value: {
	      auth: _react2['default'].PropTypes.shape({
	        loggedIn: _react.PropTypes.bool.isRequired
	      }).isRequired
	    },
	    enumerable: true
	  }]);
	
	  return Home;
	})(_react.Component);
	
	exports['default'] = (0, _reactRedux.connect)(function (state) {
	  return { auth: state.auth };
	})(Home);
	module.exports = exports['default'];

/***/ }),
/* 1163 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _get = __webpack_require__(8)['default'];
	
	var _inherits = __webpack_require__(5)['default'];
	
	var _createClass = __webpack_require__(6)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _componentsYouTube = __webpack_require__(61);
	
	var _componentsYouTube2 = _interopRequireDefault(_componentsYouTube);
	
	var FunVideoOverlay = (function (_Component) {
	  _inherits(FunVideoOverlay, _Component);
	
	  function FunVideoOverlay() {
	    _classCallCheck(this, FunVideoOverlay);
	
	    _get(Object.getPrototypeOf(FunVideoOverlay.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(FunVideoOverlay, [{
	    key: 'click',
	    value: function click(evt) {
	      evt.preventDefault();
	      evt.stopPropagation();
	      evt.nativeEvent.stopPropagation();
	    }
	  }, {
	    key: 'close',
	    value: function close(evt) {
	      var _context = this.context;
	      var setMode = _context.setMode;
	      var setVideoState = _context.setVideoState;
	
	      setMode('extras').then(function () {
	        setVideoState({
	          playing: false,
	          started: false,
	          finished: false
	        });
	      });
	      evt.preventDefault();
	      evt.stopPropagation();
	      evt.nativeEvent.stopPropagation();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var videoNumber = this.props.videoNumber;
	      var _context2 = this.context;
	      var funMd = _context2.program.funMd;
	      var regionData = _context2.regionData;
	      var _ = _context2.i18n;
	
	      var funMd_i18n = _(funMd);
	      var funItemNames = funMd_i18n.getSectionNames();
	      var funItemName = funItemNames[videoNumber - 1];
	      var youTubeId = funMd_i18n.getSectionMetadata(funItemName, 'YouTube', regionData);
	      var lowRes = funMd_i18n.getSectionMetadata(funItemName, 'LowRes', regionData);
	      var booleanLowRes = lowRes === 'true';
	
	      return _react2['default'].createElement(
	        'div',
	        {
	          className: 'fun-video',
	          onClick: this.click.bind(this) },
	        _react2['default'].createElement(
	          'button',
	          {
	            className: 'pull-right btn-link go-back',
	            onClick: this.close.bind(this) },
	          _react2['default'].createElement('i', { className: 'glyphicon glyphicon-remove' })
	        ),
	        _react2['default'].createElement(_componentsYouTube2['default'], { youTubeId: youTubeId, lowRes: booleanLowRes })
	      );
	    }
	  }], [{
	    key: 'propTypes',
	    value: {
	      videoNumber: _react.PropTypes.number.isRequired
	    },
	    enumerable: true
	  }, {
	    key: 'contextTypes',
	    value: {
	      program: _react.PropTypes.object.isRequired,
	      setMode: _react.PropTypes.func.isRequired,
	      setVideoState: _react.PropTypes.func.isRequired,
	      regionData: _react.PropTypes.object.isRequired,
	      i18n: _react.PropTypes.func.isRequired
	    },
	    enumerable: true
	  }]);
	
	  return FunVideoOverlay;
	})(_react.Component);
	
	exports['default'] = FunVideoOverlay;
	module.exports = exports['default'];

/***/ }),
/* 1164 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _get = __webpack_require__(8)['default'];
	
	var _inherits = __webpack_require__(5)['default'];
	
	var _createClass = __webpack_require__(6)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _componentsVideoRemoteControlButton = __webpack_require__(307);
	
	var _componentsVideoRemoteControlButton2 = _interopRequireDefault(_componentsVideoRemoteControlButton);
	
	var FunVideoRemote = (function (_Component) {
	  _inherits(FunVideoRemote, _Component);
	
	  function FunVideoRemote() {
	    _classCallCheck(this, FunVideoRemote);
	
	    _get(Object.getPrototypeOf(FunVideoRemote.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(FunVideoRemote, [{
	    key: 'close',
	    value: function close(evt) {
	      var _context = this.context;
	      var setMode = _context.setMode;
	      var setVideoState = _context.setVideoState;
	
	      setMode('extras').then(function () {
	        setVideoState({
	          playing: false,
	          started: false,
	          finished: false
	        });
	      });
	      evt.preventDefault();
	      evt.stopPropagation();
	      evt.nativeEvent.stopPropagation();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _context2 = this.context;
	      var funMd = _context2.program.funMd;
	      var mode = _context2.session.mode;
	      var regionData = _context2.regionData;
	      var _ = _context2.i18n;
	
	      var videoNumber = null;
	      var match = mode ? mode.match(/^extras\/(.*)$/) : null;
	      if (match) {
	        videoNumber = Number(match[1]);
	      } else {
	        return _react2['default'].createElement('div', null);
	      }
	      var funMd_i18n = _(funMd);
	      var funItemNames = funMd_i18n.getSectionNames();
	      var funItemName = funItemNames[videoNumber - 1];
	      var description = funMd_i18n.getSubSectionAsString(funItemName, 'Description', false, regionData);
	
	      return _react2['default'].createElement(
	        'div',
	        { className: 'fun-video-remote' },
	        _react2['default'].createElement(
	          'button',
	          {
	            className: 'btn btn-sm go-back',
	            onClick: this.close.bind(this) },
	          _('Go Back')
	        ),
	        _react2['default'].createElement(
	          'h4',
	          { className: 'fun-title' },
	          funItemName
	        ),
	        _react2['default'].createElement(
	          'div',
	          { className: 'video-button-container' },
	          _react2['default'].createElement(_componentsVideoRemoteControlButton2['default'], null)
	        ),
	        _react2['default'].createElement(
	          'div',
	          { className: 'fun-description' },
	          _react2['default'].createElement(
	            'p',
	            null,
	            description
	          )
	        )
	      );
	    }
	  }], [{
	    key: 'contextTypes',
	    value: {
	      program: _react.PropTypes.object.isRequired,
	      session: _react.PropTypes.object.isRequired,
	      setMode: _react.PropTypes.func.isRequired,
	      setVideoState: _react.PropTypes.func.isRequired,
	      regionData: _react.PropTypes.object.isRequired,
	      i18n: _react.PropTypes.func.isRequired
	    },
	    enumerable: true
	  }]);
	
	  return FunVideoRemote;
	})(_react.Component);
	
	exports['default'] = FunVideoRemote;
	module.exports = exports['default'];

/***/ }),
/* 1165 */
/***/ (function(module, exports, __webpack_require__) {

	/* eslint dot-notation: 0 */
	'use strict';
	
	var _taggedTemplateLiteral = __webpack_require__(28)['default'];
	
	var _get = __webpack_require__(8)['default'];
	
	var _inherits = __webpack_require__(5)['default'];
	
	var _createClass = __webpack_require__(6)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['Level ', ''], ['Level ', '']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactAddonsCssTransitionGroup = __webpack_require__(188);
	
	var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);
	
	var _vendorSpectacleProgress = __webpack_require__(1131);
	
	var _vendorSpectacleProgress2 = _interopRequireDefault(_vendorSpectacleProgress);
	
	var _buttonBar = __webpack_require__(477);
	
	var _buttonBar2 = _interopRequireDefault(_buttonBar);
	
	var _scores = __webpack_require__(481);
	
	var _scores2 = _interopRequireDefault(_scores);
	
	var _fun = __webpack_require__(479);
	
	var _fun2 = _interopRequireDefault(_fun);
	
	var _funFunVideoOverlay = __webpack_require__(1163);
	
	var _funFunVideoOverlay2 = _interopRequireDefault(_funFunVideoOverlay);
	
	var _overview = __webpack_require__(480);
	
	var _overview2 = _interopRequireDefault(_overview);
	
	var _exit = __webpack_require__(478);
	
	var _exit2 = _interopRequireDefault(_exit);
	
	var _imagesLogo_ppaSvg = __webpack_require__(453);
	
	var _imagesLogo_ppaSvg2 = _interopRequireDefault(_imagesLogo_ppaSvg);
	
	var _imagesDrawerLogoFullLogo_ppaPng = __webpack_require__(2526);
	
	var _imagesDrawerLogoFullLogo_ppaPng2 = _interopRequireDefault(_imagesDrawerLogoFullLogo_ppaPng);
	
	var _imagesDrawerLogoFullLogo_ppaFr_CAPng = __webpack_require__(2525);
	
	var _imagesDrawerLogoFullLogo_ppaFr_CAPng2 = _interopRequireDefault(_imagesDrawerLogoFullLogo_ppaFr_CAPng);
	
	__webpack_require__(2207);
	
	var _helpersI18n = __webpack_require__(14);
	
	var DrawerLogo = (0, _helpersI18n.i18nData)({
	  en: _imagesDrawerLogoFullLogo_ppaPng2['default'],
	  fr_CA: _imagesDrawerLogoFullLogo_ppaFr_CAPng2['default']
	});
	
	var HeadsUpDisplay = (function (_Component) {
	  _inherits(HeadsUpDisplay, _Component);
	
	  function HeadsUpDisplay() {
	    _classCallCheck(this, HeadsUpDisplay);
	
	    _get(Object.getPrototypeOf(HeadsUpDisplay.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(HeadsUpDisplay, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.hudTimerCount = 0;
	      this.interval = setInterval(this.hudTimerCheck.bind(this), 1000);
	      this.context.registerHUDRef('Menu', this.refs['deck-hud-toggle']);
	      this.context.registerHUDRef('Next Arrow', this.refs['nextArrow']);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearInterval(this.interval);
	    }
	  }, {
	    key: 'hudTimerCheck',
	    value: function hudTimerCheck() {
	      // If the HUD is open for 10 seconds without being in a 'mode',
	      // then close it
	
	      var _props = this.props;
	      var displayHUD = _props.displayHUD;
	      var mode = _props.mode;
	      var _context = this.context;
	      var hideHUD = _context.hideHUD;
	      var profile = _context.profile;
	
	      if (displayHUD && !mode && profile.onboarding) {
	        this.hudTimerCount++;
	        if (this.hudTimerCount > 10) {
	          hideHUD();
	          this.hudTimerCount = 0;
	        }
	      } else {
	        this.hudTimerCount = 0;
	      }
	    }
	  }, {
	    key: 'clickHUDDrawer',
	    value: function clickHUDDrawer(evt) {
	      if (evt) {
	        evt.preventDefault();
	        evt.stopPropagation();
	        evt.nativeEvent.stopPropagation();
	      }
	    }
	  }, {
	    key: 'jumpTo',
	    value: function jumpTo() {
	      var _context2 = this.context;
	      var setCurrentSlide = _context2.setCurrentSlide;
	      var setLastSlide = _context2.setLastSlide;
	
	      var slide = this.refs.jumpTo.value;
	      setLastSlide(slide);
	      setCurrentSlide(slide);
	    }
	  }, {
	    key: 'exitSession',
	    value: function exitSession() {
	      var setActiveSession = this.context.setActiveSession;
	
	      setActiveSession('none');
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _context3 = this.context;
	      var currentLevel = _context3.session.currentLevel;
	      var staff = _context3.staff;
	      var _ = _context3.i18n;
	      var _props2 = this.props;
	      var slide = _props2.slide;
	      var displayHUD = _props2.displayHUD;
	      var displayHUDToggle = _props2.displayHUDToggle;
	      var displayExit = _props2.displayExit;
	      var TOC = _props2.TOC;
	      var currentSlide = _props2.currentSlide;
	      var progressType = _props2.progressType;
	      var prevSlide = _props2.prevSlide;
	      var nextSlide = _props2.nextSlide;
	      var mode = _props2.mode;
	      var deckHeight = _props2.deckHeight;
	
	      var currentSlideId = TOC[slide].id;
	      var yOffset = 122;
	      if (window.screen.width >= 1600) {
	        yOffset = 142;
	      }
	      var deckHeightWithoutProgressBar = deckHeight - 22;
	      var yPosition = -deckHeightWithoutProgressBar + 'px';
	      if (displayHUD && deckHeight) {
	        yPosition = mode ? 0 : yOffset - deckHeight + 'px';
	      }
	      var funVideoNumber = null;
	      var match = mode ? mode.match(/^extras\/(.*)$/) : null;
	      if (match) {
	        funVideoNumber = Number(match[1]);
	      }
	
	      var styles = {
	        hudDrawer: {
	          transform: 'translateY(' + yPosition + ')',
	          WebkitTransform: 'translateY(' + yPosition + ')',
	          transition: 'transform 0.5s cubic-bezier(0, 0, .58, 1)',
	          WebkitTransition: '-webkit-transform 0.5s cubic-bezier(0, 0, .58, 1)',
	          height: deckHeight
	        },
	        hudPrevButton: {
	          opacity: slide > 0 ? 1 : 0
	        },
	        hudNextButton: {
	          opacity: slide < TOC.length - 1 ? 1 : 0
	        }
	      };
	
	      return _react2['default'].createElement(
	        'div',
	        {
	          className: 'deck-control-glass' },
	        _react2['default'].createElement(
	          'a',
	          {
	            className: 'deck-hud-toggle ' + (displayHUD && mode ? 'on' : ''),
	            href: '#',
	            style: { display: displayHUDToggle ? 'flex' : 'none' },
	            ref: 'deck-hud-toggle' },
	          _react2['default'].createElement(
	            'svg',
	            { version: '1.2', baseProfile: 'tiny', xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 60 56.6' },
	            _react2['default'].createElement('path', { className: 'logo-center', d: 'M48.2 27.5c0-1.7-.8-3.2-2.2-4.3.6-1.6.6-3.3-.3-4.8-.8-1.5-2.3-2.4-4-2.6-.3-1.7-1.2-3.2-2.6-4-1.5-.8-3.2-.9-4.8-.3-1.1-1.3-2.6-2.2-4.3-2.2s-3.2.8-4.3 2.2c-1.6-.6-3.3-.6-4.8.3-1.5.8-2.4 2.3-2.6 4-1.7.3-3.2 1.2-4 2.6-.8 1.5-.9 3.2-.3 4.8-1.3 1.1-2.2 2.6-2.2 4.3s.8 3.2 2.2 4.3c-.6 1.6-.6 3.3.3 4.8.8 1.4 2.3 2.4 4 2.6.3 1.7 1.2 3.2 2.6 4 1.5.8 3.2.9 4.8.3 1.1 1.3 2.6 2.2 4.3 2.2s3.2-.8 4.3-2.2c1.6.6 3.3.6 4.8-.3 1.5-.8 2.4-2.3 2.6-4 1.7-.3 3.2-1.2 4-2.6.8-1.5.9-3.2.3-4.8 1.3-1.1 2.2-2.6 2.2-4.3zm-8 10.2c-1.3 0-2.9-.4-4.4-1.2-.3-2.2-1.1-4-2.2-5.4 1.3 1.1 3.1 1.9 5.4 2.2.8 1.5 1.2 3.1 1.2 4.4zm-9.6.4c.8-2.1 1.1-4.1.8-5.7.6 1.6 1.8 3.2 3.6 4.6 0 1.8-.5 3.3-1.1 4.4-1.3-.6-2.4-1.8-3.3-3.3zm-4.3 3.3c-.7-1.2-1.1-2.7-1.1-4.4 1.8-1.4 3-3 3.6-4.6-.3 1.7 0 3.7.8 5.7-1 1.5-2.1 2.7-3.3 3.3zm-6.5-3.7c0-1.3.4-2.9 1.2-4.4 2.2-.3 4-1.1 5.4-2.2-1.1 1.3-1.9 3.1-2.2 5.4-1.5.8-3 1.2-4.4 1.2zm0-20.4c1.3 0 2.9.4 4.4 1.2.3 2.2 1.1 4 2.2 5.4-1.3-1.1-3.1-1.9-5.4-2.2-.8-1.5-1.2-3-1.2-4.4zm9.7-.4c-.8 2.1-1.1 4.1-.8 5.7-.6-1.6-1.8-3.2-3.6-4.6 0-1.8.5-3.3 1.1-4.4 1.3.7 2.4 1.8 3.3 3.3zm-4.4 9.3c-1.7-.3-3.7 0-5.7.8-1.5-.9-2.6-2-3.3-3.2 1.2-.7 2.7-1.1 4.4-1.1 1.4 1.7 3 2.9 4.6 3.5zm0 2.6c-1.6.6-3.2 1.8-4.6 3.6-1.8 0-3.3-.5-4.4-1.1.7-1.2 1.8-2.3 3.3-3.2 2.1.8 4 1 5.7.7zm3.8 2.9c-.6 1.5-2 3-3.7 4.2.1-2.1.8-4 1.8-5.3-1.3 1-3.2 1.7-5.3 1.8 1.2-1.7 2.7-3.1 4.2-3.7-1.6.2-3.6-.2-5.5-1.1 1.9-.9 3.9-1.3 5.5-1.1-1.5-.6-3-2-4.2-3.7 2.1.1 4 .8 5.3 1.8-1-1.3-1.7-3.2-1.8-5.3 1.7 1.2 3.1 2.7 3.7 4.2-.2-1.6.2-3.6 1.1-5.5.9 1.9 1.3 3.9 1.1 5.5.6-1.5 2-3 3.7-4.2-.1 2.1-.8 4-1.8 5.3 1.3-1 3.2-1.7 5.3-1.8-1.2 1.7-2.7 3.1-4.2 3.7 1.6-.2 3.6.2 5.5 1.1-1.9.9-3.9 1.3-5.5 1.1 1.5.6 3 2 4.2 3.7-2.1-.1-4-.8-5.3-1.8 1 1.3 1.7 3.2 1.8 5.3-1.7-1.2-3.1-2.7-3.7-4.2.2 1.6-.2 3.6-1.1 5.5-.9-1.9-1.3-3.9-1.1-5.5zm4.9-18.1c.7 1.2 1.1 2.7 1.1 4.4-1.8 1.4-3 3-3.6 4.6.3-1.7 0-3.7-.8-5.7 1-1.5 2.1-2.6 3.3-3.3zm6.4 3.7c0 1.3-.4 2.9-1.2 4.4-2.2.3-4 1.1-5.4 2.2 1.1-1.3 1.9-3.1 2.2-5.4 1.5-.8 3.1-1.2 4.4-1.2zm-5.3 11.5c1.7.3 3.7 0 5.7-.8 1.5.9 2.6 2 3.3 3.2-1.2.7-2.7 1.1-4.4 1.1-1.4-1.7-3-2.9-4.6-3.5zm0-2.6c1.6-.6 3.2-1.8 4.6-3.6 1.8 0 3.3.5 4.4 1.1-.7 1.2-1.8 2.3-3.3 3.2-2-.8-4-1-5.7-.7zm9.3-6.9c.5.9.6 1.9.4 3-1-.5-2.1-.7-3.4-.7h-.9c.2-.3.3-.5.5-.8.6-1.1.9-2.2 1-3.3 1 .3 1.9.9 2.4 1.8zm-6-6c.9.5 1.5 1.3 1.8 2.4-1.1.1-2.2.4-3.3 1-.3.2-.5.3-.8.5v-.9c0-1.2-.3-2.4-.7-3.4 1.1-.2 2.1-.1 3 .4zM30 11.2c1 0 2 .4 2.8 1.2-.9.6-1.7 1.5-2.3 2.5-.2.3-.3.6-.4.8-.1-.3-.3-.6-.4-.8-.6-1.1-1.4-1.9-2.3-2.5.7-.8 1.6-1.2 2.6-1.2zm-8.2 2.1c.9-.5 1.9-.6 3-.4-.5 1-.7 2.1-.7 3.4v.9c-.3-.2-.5-.3-.8-.5-1.1-.6-2.2-.9-3.3-1 .4-1 1-1.9 1.8-2.4zm-5.9 6c.5-.9 1.3-1.5 2.4-1.8.1 1.1.4 2.2 1 3.3.2.3.3.5.5.8h-.9c-1.2 0-2.4.3-3.4.7-.3-1-.1-2.1.4-3zm-2.2 8.2c0-1 .4-2 1.2-2.8.6.9 1.5 1.7 2.5 2.3.3.2.6.3.8.4-.3.1-.6.3-.8.4-1.1.6-1.9 1.4-2.5 2.3-.8-.6-1.2-1.6-1.2-2.6zm2.2 8.2c-.5-.9-.6-1.9-.4-3 1 .5 2.1.7 3.4.7h.9c-.2.3-.3.5-.5.8-.6 1.1-.9 2.2-1 3.3-1.1-.3-1.9-.9-2.4-1.8zm5.9 6c-.9-.5-1.5-1.3-1.8-2.4 1.1-.1 2.2-.4 3.3-1 .3-.2.5-.3.8-.5v.9c0 1.2.3 2.4.7 3.4-1 .2-2.1.1-3-.4zm8.2 2.2c-1 0-2-.4-2.8-1.2.9-.6 1.7-1.5 2.3-2.5.2-.3.3-.6.4-.8.1.3.3.6.4.8.6 1.1 1.4 1.9 2.3 2.5-.6.7-1.5 1.2-2.6 1.2zm8.2-2.2c-.9.5-1.9.6-3 .4.5-1 .7-2.1.7-3.4v-.9c.3.2.5.3.8.5 1.1.6 2.2.9 3.3 1-.3 1-.9 1.9-1.8 2.4zm6-6c-.5.9-1.3 1.5-2.4 1.8-.1-1.1-.4-2.2-1-3.3-.2-.3-.3-.5-.5-.8h.9c1.2 0 2.4-.3 3.4-.7.2 1.1.1 2.1-.4 3zm1-5.4c-.6-.9-1.5-1.7-2.5-2.3-.3-.2-.6-.3-.8-.4.3-.1.6-.3.8-.4 1.1-.6 1.9-1.4 2.5-2.3.8.8 1.2 1.7 1.2 2.8 0 .8-.4 1.8-1.2 2.6z' }),
	            _react2['default'].createElement('path', { className: 'logo-surround', d: 'M58.2 34.2c1.4-.7 1.8-2.6 1.8-2.6s-2.1-.2-3.4.8c-.4.3-.8.9-1.1 1.4.2-1.1.4-2.1.4-3.2.5-.1 1.6-.4 2.8-1.3 1.2-1 1.3-2.9 1.3-2.9s-2.1.1-3.2 1.3c-.3.4-.6 1-.8 1.6 0-1.2 0-2.3-.1-3.4.5-.2 1.5-.6 2.4-1.7 1-1.1.8-3 .8-3s-2 .5-2.8 1.8c-.3.4-.4 1.1-.5 1.7-.2-1.2-.4-2.3-.7-3.4.4-.2 1.4-.9 2.1-2.1.8-1.3.2-3 .2-3s-1.8.8-2.4 2.2c-.2.5-.2 1.3-.2 1.9-.4-1.2-.9-2.3-1.4-3.4.3-.3 1.2-1 1.7-2.4.5-1.3-.3-2.9-.3-2.9s-1.6 1.1-1.9 2.6c-.1.6 0 1.4.2 2-.6-1.2-1.3-2.3-2-3.3.3-.3 1-1.2 1.2-2.6s-.8-2.8-.8-2.8S50 9 50 10.5c0 .6.2 1.3.5 1.9-.8-1-1.7-2-2.5-2.8.2-.4.7-1.3.8-2.7 0-1.4-1.2-2.5-1.2-2.5s-1.1 1.5-.9 3c.1.6.5 1.3.8 1.8-.3-.3-.6-.5-.9-.8-.7-.6-1.4-1.1-2.1-1.5.1-.3.5-1.4.3-2.8-.2-1.3-1.6-2.3-1.6-2.3s-.8 1.7-.4 3c.2.6.9 1.4 1.3 1.8-1.3-.8-2.5-1.4-3.5-1.9.1-.3.3-1.4-.2-2.8C39.8.6 38.3 0 38.3 0s-.5 1.8.1 3c.3.6 1.2 1.2 1.6 1.6-.7-.3-1.3-.5-1.9-.7-.2-.2-.9-1.1-1.9-1.3-.8-.1-2.1.4-2.1.4s.6.8 1.9 1.3c.8.3 1.8-.1 2-.2.6.2 1.5.5 2.4 1-.5-.1-1.6-.2-2.3 0C36.9 5.4 36 7 36 7s1.5.6 2.7 0c1.3-.6 1.9-1.6 2.1-1.9 1 .5 2.2 1.1 3.4 2-.6-.2-1.5-.5-2.1-.4-1.4.2-2.5 1.7-2.5 1.7s1.4.9 2.7.5c1.3-.4 2.1-1.2 2.4-1.5.5.4 1.1.8 1.7 1.3.5.4 1 .8 1.5 1.3-.5-.3-1.4-.7-2.1-.7-1.4 0-2.9 1.2-2.9 1.2s1.3 1.1 2.7.9c1.4-.2 2.4-.8 2.6-1.1.9.9 1.7 1.9 2.5 3-.5-.4-1.2-.9-1.8-1-1.4-.3-3.1.7-3.1.7s1.1 1.3 2.5 1.4c1.4.1 2.4-.4 2.8-.6.7 1 1.3 2.1 1.9 3.2-.4-.5-1-1-1.6-1.2-1.4-.6-3.2.2-3.2.2s.9 1.6 2.3 1.9c1.3.3 2.4.1 2.9-.1.5 1.1.9 2.3 1.3 3.5-.3-.5-.8-1.2-1.3-1.5-1.3-.8-3.3-.4-3.3-.4s.6 1.7 1.9 2.3c1.3.5 2.4.5 2.9.4.3 1.2.5 2.4.7 3.7-.3-.6-.6-1.4-1.1-1.8-1.2-1-3.2-1-3.2-1s.3 1.8 1.6 2.6c1.2.8 2.4.9 2.8 1 .1 1.2.1 2.4 0 3.6-.1-.6-.4-1.4-.8-1.8-1-1.2-3.1-1.6-3.1-1.6s0 1.9 1.1 2.9 2.1 1.3 2.6 1.4c-.1 1.2-.3 2.3-.6 3.4 0-.6-.1-1.4-.4-2-.8-1.4-2.8-2.1-2.8-2.1s-.4 1.9.6 3.1c.9 1.1 1.9 1.7 2.4 1.9-.3 1.1-.7 2.1-1.2 3.1.1-.6.1-1.4-.1-1.9-.7-1.6-2.6-2.6-2.6-2.6s-.7 1.8 0 3.3c.6 1.3 1.6 2 2 2.3-.5 1-1 1.9-1.6 2.8.2-.6.3-1.3.2-1.9-.2-1.7-2-3-2-3s-1 1.7-.6 3.3c.4 1.4 1.2 2.3 1.6 2.7-.7.9-1.4 1.8-2.1 2.5.3-.6.6-1.3.6-1.9 0-1.7-1.5-3.4-1.5-3.4s-1.3 1.5-1.1 3.2c.2 1.5.8 2.5 1.2 3-.8.8-1.7 1.5-2.6 2.1.4-.6.8-1.3 1-1.9.4-1.7-.9-3.7-.9-3.7s-1.6 1.3-1.7 3c-.1 1.5.4 2.7.6 3.2-.3.2-.7.4-1 .6-.6.4-1.2.7-1.8.9.5-.5 1-1.1 1.2-1.6.7-1.7-.2-3.9-.2-3.9s-1.9 1-2.2 2.7c-.3 1.5-.1 2.7 0 3.3-1.1.5-2 .8-2.9 1.1.6-.4 1.2-.9 1.5-1.4 1-1.6.5-3.9.5-3.9s-2.1.7-2.7 2.4c-.6 1.4-.6 2.6-.6 3.3-1.8.4-3.8.6-5.8.6-1.9 0-3.8-.2-5.6-.6 0-.6 0-1.9-.6-3.3-.7-1.6-2.7-2.4-2.7-2.4s-.5 2.4.5 3.9c.3.5.9 1 1.5 1.4-.9-.3-1.9-.6-2.9-1.1.2-.6.4-1.8 0-3.3-.4-1.7-2.2-2.7-2.2-2.7s-.9 2.2-.2 3.9c.2.6.7 1.1 1.2 1.6l-1.8-.9-1-.6c.3-.6.7-1.7.6-3.2-.1-1.7-1.7-3-1.7-3s-1.2 2-.9 3.7c.1.6.6 1.3 1 1.9-.9-.6-1.7-1.3-2.6-2.1.3-.5 1-1.5 1.2-3 .2-1.7-1.1-3.2-1.1-3.2S11 42.3 11 44c0 .6.3 1.3.6 1.9-.7-.8-1.4-1.6-2.1-2.5.4-.4 1.2-1.3 1.6-2.7.5-1.6-.6-3.3-.6-3.3s-1.8 1.4-2 3c-.1.6 0 1.2.2 1.9-.6-.9-1.1-1.8-1.6-2.8.5-.3 1.4-1.1 2-2.3.7-1.4 0-3.3 0-3.3s-1.9 1-2.4 2.6c-.2.6-.2 1.3-.1 1.9-.5-1-.8-2-1.2-3.1.5-.2 1.5-.8 2.4-1.9 1-1.2.6-3.1.6-3.1s-2 .7-2.8 2.1c-.3.5-.4 1.3-.4 2-.3-1.1-.5-2.2-.6-3.4.5-.1 1.6-.5 2.6-1.4 1.1-1 1.1-2.9 1.1-2.9s-2 .3-3 1.6c-.4.5-.6 1.2-.8 1.8-.1-1.2-.1-2.4 0-3.6.5 0 1.6-.2 2.8-1 1.3-.7 1.6-2.5 1.6-2.5s-2.1-.1-3.2 1c-.5.4-.9 1.2-1.1 1.8.1-1.3.4-2.5.7-3.7.5 0 1.6.1 2.9-.4 1.4-.6 1.9-2.3 1.9-2.3s-2-.4-3.3.4c-.5.3-1 1-1.3 1.5.4-1.2.8-2.4 1.3-3.5.5.1 1.5.4 2.9.1C11.1 17.6 12 16 12 16s-1.8-.7-3.2-.2c-.7.2-1.2.7-1.7 1.2.6-1.2 1.2-2.2 1.9-3.2.4.2 1.4.6 2.8.6 1.4-.1 2.5-1.4 2.5-1.4s-1.7-1-3.1-.7c-.6.1-1.4.6-1.8 1 .8-1.1 1.6-2.1 2.5-3 .3.2 1.2.9 2.6 1.1 1.4.2 2.7-.9 2.7-.9s-1.4-1.3-2.9-1.2c-.7 0-1.6.4-2.1.7.5-.5 1-.9 1.5-1.3.6-.5 1.1-.9 1.7-1.3.3.3 1.1 1.1 2.4 1.5 1.3.4 2.7-.5 2.7-.5S19.3 6.9 18 6.7c-.6-.1-1.6.2-2.1.4 1.2-.8 2.4-1.5 3.4-2 .2.3.8 1.2 2.1 1.9 1.2.6 2.7 0 2.7 0s-.9-1.6-2.2-2c-.7-.2-1.8-.1-2.3 0 .9-.4 1.7-.7 2.4-1 .3.1 1.2.5 2 .2 1.2-.4 1.9-1.3 1.9-1.3s-1.3-.5-2.1-.4c-1 .2-1.8 1.1-1.9 1.3-.5.2-1.2.4-1.9.7.5-.3 1.3-1 1.6-1.6.6-1.2.2-3 .2-3s-1.5.6-1.9 1.9c-.5 1.4-.2 2.5-.2 2.8-1.1.5-2.2 1.1-3.5 1.9.4-.4 1.1-1.2 1.3-1.8.4-1.3-.4-3-.4-3s-1.6.9-1.8 2.3c-.2 1.4.2 2.5.3 2.8l-2.1 1.5c-.3.2-.6.5-.9.8.3-.5.7-1.2.8-1.8.2-1.4-.9-3-.9-3s-1.2 1.2-1.2 2.5c0 1.4.6 2.4.8 2.7-.9.8-1.7 1.8-2.5 2.8.2-.5.4-1.3.4-1.9C10 9 8.6 7.6 8.6 7.6S7.5 9 7.8 10.4c.3 1.4 1 2.3 1.2 2.6-.7 1-1.4 2.1-2 3.3.1-.6.3-1.4.2-2-.3-1.5-1.9-2.6-1.9-2.6s-.8 1.6-.3 2.9 1.4 2.1 1.7 2.4c-.5 1.1-1 2.2-1.4 3.4 0-.6 0-1.4-.2-1.9-.6-1.4-2.4-2.2-2.4-2.2s-.5 1.7.2 3c.7 1.2 1.7 1.8 2.1 2.1-.3 1.1-.6 2.3-.7 3.4-.2-.7-.3-1.3-.6-1.8-.8-1.3-2.8-1.8-2.8-1.8s-.2 1.8.8 3c.9 1.1 1.9 1.5 2.4 1.7-.2 1.1-.2 2.2-.1 3.4-.2-.6-.5-1.2-.8-1.6C2.1 26.6 0 26.4 0 26.4s.1 1.9 1.3 2.8c1.1.9 2.3 1.2 2.8 1.3.1 1.1.2 2.2.4 3.2-.3-.5-.7-1.1-1.1-1.4-1.3-1-3.4-.8-3.4-.8s.4 1.9 1.8 2.6c1.3.7 2.4.8 3 .8.3 1.1.6 2.1 1 3.1-.4-.5-.9-1-1.3-1.2C3 36 .9 36.6.9 36.6s.8 1.8 2.3 2.3c1.4.5 2.6.4 3.1.3.5 1 1 2 1.6 2.9-.5-.4-1.1-.8-1.6-1-1.6-.5-3.6.5-3.6.5s1.1 1.7 2.7 1.9c1.5.2 2.7-.1 3.2-.3.6.9 1.2 1.7 1.9 2.5-.5-.3-1.1-.6-1.6-.6-1.7-.2-3.6 1.1-3.6 1.1s1.4 1.5 3.1 1.5c1.5 0 2.6-.5 3.1-.8.7.7 1.5 1.4 2.2 2-.5-.2-1.1-.3-1.6-.3-1.8.1-3.4 1.7-3.4 1.7s1.7 1.2 3.3.9c1.5-.3 2.5-1 3-1.4.5.4 1.1.7 1.6 1l1 .6c-.6-.1-1.2-.1-1.7 0-1.8.4-3.1 2.3-3.1 2.3s1.9 1 3.5.3c1.4-.6 2.3-1.4 2.7-1.9 1 .5 1.9.8 2.8 1.1-.6 0-1.2.1-1.7.3-1.7.7-2.7 2.9-2.7 2.9s2.1.6 3.6-.3c1.3-.8 2.1-1.8 2.4-2.4 2.1.5 4.3.8 6.6.8s4.6-.3 6.6-.8c.3.6 1.1 1.6 2.4 2.4 1.5.9 3.6.3 3.6.3s-1-2.2-2.7-2.9c-.5-.2-1.1-.3-1.7-.3.9-.3 1.8-.6 2.8-1.1.4.5 1.3 1.3 2.7 1.9 1.6.6 3.5-.3 3.5-.3s-1.3-2-3.1-2.3c-.5-.1-1.1 0-1.7 0 .3-.2.7-.4 1-.6.5-.3 1.1-.6 1.6-1 .5.4 1.5 1.1 3 1.4 1.7.3 3.3-.9 3.3-.9s-1.6-1.7-3.4-1.7c-.5 0-1.1.1-1.6.3.7-.6 1.5-1.3 2.2-2 .5.3 1.6.8 3.1.8 1.7 0 3.1-1.5 3.1-1.5s-1.8-1.3-3.6-1.1c-.5.1-1.1.3-1.6.6.7-.8 1.3-1.6 1.9-2.5.5.2 1.7.5 3.2.3 1.6-.2 2.7-1.9 2.7-1.9s-2-1-3.6-.5c-.5.2-1.1.6-1.6 1 .6-.9 1.1-1.9 1.6-2.9.5.1 1.7.2 3.1-.3 1.5-.5 2.3-2.3 2.3-2.3s-2.1-.6-3.6.2c-.5.2-.9.7-1.3 1.2.4-1 .7-2 1-3.1.6.1 1.7 0 3-.7z' })
	          ),
	          _react2['default'].createElement(
	            'span',
	            { className: 'deck-hud-toggle-label' },
	            _('Menu')
	          )
	        ),
	        !!displayExit && _react2['default'].createElement(
	          'button',
	          { className: 'btn btn-sm btn-default deck-hud-exit', onClick: this.exitSession.bind(this) },
	          _react2['default'].createElement('span', { className: 'ppa-icon-exit' }),
	          ' ',
	          _('Exit')
	        ),
	        _react2['default'].createElement(
	          'div',
	          {
	            className: 'deck-hud-drawer ' + (displayHUD && mode ? 'on' : ''),
	            ref: 'hudDrawer',
	            style: styles.hudDrawer,
	            onClick: this.clickHUDDrawer.bind(this) },
	          _react2['default'].createElement(
	            'div',
	            { className: 'deck-hud-drawer-logo' },
	            _react2['default'].createElement('img', { src: _(DrawerLogo) })
	          ),
	          _react2['default'].createElement(
	            'div',
	            {
	              className: 'deck-hud-panel' },
	            _react2['default'].createElement(
	              'div',
	              { className: 'deck-hud-logo' },
	              _react2['default'].createElement('img', { src: _imagesLogo_ppaSvg2['default'] })
	            ),
	            _react2['default'].createElement(
	              'div',
	              {
	                className: 'deck-hud-content' },
	              _react2['default'].createElement(
	                _reactAddonsCssTransitionGroup2['default'],
	                {
	                  className: 'deck-hud-content-transition-group',
	                  transitionName: 'hud-mode-switch',
	                  transitionEnterTimeout: 500,
	                  transitionLeaveTimeout: 300 },
	                mode === 'scores' ? _react2['default'].createElement(_scores2['default'], { key: 'scores' }) : null,
	                mode && mode.replace(/\/.*$/, '') === 'extras' ? _react2['default'].createElement(_fun2['default'], { key: 'extras' }) : null,
	                mode === 'modules' ? _react2['default'].createElement(_overview2['default'], { key: 'modules' }) : null,
	                mode === 'exit' ? _react2['default'].createElement(_exit2['default'], { key: 'exit' }) : null
	              )
	            ),
	            _react2['default'].createElement(_buttonBar2['default'], null),
	            staff && _react2['default'].createElement(
	              'div',
	              { className: 'deck-hud-jump-to' },
	              _react2['default'].createElement(
	                'div',
	                { className: 'deck-hud-jump-to-container' },
	                _react2['default'].createElement(
	                  'div',
	                  null,
	                  _(_templateObject, currentLevel)
	                ),
	                _react2['default'].createElement(
	                  'select',
	                  {
	                    ref: 'jumpTo',
	                    defaultValue: currentSlideId,
	                    onChange: this.jumpTo.bind(this) },
	                  TOC.map(function (toc) {
	                    var tocId = toc.id;
	
	                    return _react2['default'].createElement(
	                      'option',
	                      { key: tocId, value: tocId },
	                      tocId
	                    );
	                  })
	                )
	              )
	            )
	          ),
	          _react2['default'].createElement(_vendorSpectacleProgress2['default'], {
	            className: 'deck-progress',
	            items: TOC,
	            currentSlide: currentSlide,
	            type: progressType })
	        ),
	        _react2['default'].createElement(
	          'div',
	          {
	            className: 'deck-hud-button deck-hud-previous ppa-icon-arrow-prev',
	            onClick: prevSlide,
	            style: styles.hudPrevButton },
	          _react2['default'].createElement(
	            'span',
	            { className: 'text-hide' },
	            _('Previous')
	          )
	        ),
	        _react2['default'].createElement(
	          'div',
	          {
	            className: 'deck-hud-button deck-hud-next ppa-icon-arrow-next',
	            onClick: nextSlide,
	            style: styles.hudNextButton,
	            ref: 'nextArrow' },
	          _react2['default'].createElement(
	            'span',
	            { className: 'text-hide' },
	            _('Next')
	          )
	        ),
	        funVideoNumber && _react2['default'].createElement(_funFunVideoOverlay2['default'], { videoNumber: funVideoNumber })
	      );
	    }
	  }], [{
	    key: 'propTypes',
	    value: {
	      slide: _react.PropTypes.number.isRequired,
	      displayHUD: _react.PropTypes.bool.isRequired,
	      displayHUDToggle: _react.PropTypes.bool.isRequired,
	      displayArrows: _react.PropTypes.bool.isRequired,
	      displayExit: _react.PropTypes.bool.isRequired,
	      TOC: _react.PropTypes.array.isRequired,
	      currentSlide: _react.PropTypes.number.isRequired,
	      progressType: _react.PropTypes.string.isRequired,
	      prevSlide: _react.PropTypes.func.isRequired,
	      nextSlide: _react.PropTypes.func.isRequired,
	      mode: _react.PropTypes.string,
	      deckHeight: _react.PropTypes.number
	    },
	    enumerable: true
	  }, {
	    key: 'contextTypes',
	    value: {
	      session: _react.PropTypes.object.isRequired,
	      setCurrentSlide: _react.PropTypes.func.isRequired,
	      setLastSlide: _react.PropTypes.func.isRequired,
	      setActiveSession: _react.PropTypes.func.isRequired,
	      hideHUD: _react.PropTypes.func.isRequired,
	      staff: _react.PropTypes.bool,
	      profile: _react.PropTypes.object.isRequired,
	      registerHUDRef: _react.PropTypes.func.isRequired,
	      i18n: _react.PropTypes.func.isRequired
	    },
	    enumerable: true
	  }]);
	
	  return HeadsUpDisplay;
	})(_react.Component);
	
	exports['default'] = HeadsUpDisplay;
	module.exports = exports['default'];

/***/ }),
/* 1166 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _get = __webpack_require__(8)['default'];
	
	var _inherits = __webpack_require__(5)['default'];
	
	var _createClass = __webpack_require__(6)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _componentsVideoRemoteControlButton = __webpack_require__(307);
	
	var _componentsVideoRemoteControlButton2 = _interopRequireDefault(_componentsVideoRemoteControlButton);
	
	var _componentsCompleteLevelButton = __webpack_require__(44);
	
	var _componentsCompleteLevelButton2 = _interopRequireDefault(_componentsCompleteLevelButton);
	
	var _componentsTeamNames = __webpack_require__(60);
	
	var _componentsTeamNames2 = _interopRequireDefault(_componentsTeamNames);
	
	var _componentsMissionReport = __webpack_require__(76);
	
	var _componentsMissionReport2 = _interopRequireDefault(_componentsMissionReport);
	
	var _componentsHacked = __webpack_require__(306);
	
	var _componentsHacked2 = _interopRequireDefault(_componentsHacked);
	
	var PresentNotes = (function (_Component) {
	  _inherits(PresentNotes, _Component);
	
	  function PresentNotes() {
	    _classCallCheck(this, PresentNotes);
	
	    _get(Object.getPrototypeOf(PresentNotes.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(PresentNotes, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var oldSlide = this.props.slide;
	      var newSlide = nextProps.slide;
	      var notes = this.refs.notes;
	
	      if (oldSlide !== newSlide) {
	        if (notes) {
	          notes.scrollTop = 0;
	        }
	      }
	    }
	  }, {
	    key: '_renderMainSlide',
	    value: function _renderMainSlide() {
	      return _react2['default'].createElement('div', null);
	    }
	  }, {
	    key: '_renderNextSlide',
	    value: function _renderNextSlide() {
	      var endStyle = {
	        position: 'absolute',
	        top: '50%',
	        left: '50%',
	        transform: 'translate(-50%, -50%)',
	        margin: 0,
	        color: 'white'
	      };
	      var child = this.props.slide + 1 < this.props.TOC.length ? this.props.TOC[this.props.slide + 1].slide : null;
	      return child ? _react2['default'].createElement('div', null) : _react2['default'].createElement(
	        'h1',
	        { style: [endStyle] },
	        'END'
	      );
	    }
	  }, {
	    key: '_renderNotes',
	    value: function _renderNotes() {
	      var child = this.props.TOC[this.props.slide].slide;
	      var _child$props = child.props;
	      var notes = _child$props.notes;
	      var finish = _child$props.finish;
	      var teamNames = _child$props.teamNames;
	      var missionReportQuestions = _child$props.missionReportQuestions;
	      var hacked = _child$props.hacked;
	
	      return _react2['default'].createElement(
	        'div',
	        null,
	        !!notes && _react2['default'].createElement('div', { dangerouslySetInnerHTML: { __html: notes } }),
	        !!finish && _react2['default'].createElement(_componentsCompleteLevelButton2['default'], null),
	        !!teamNames && _react2['default'].createElement(_componentsTeamNames2['default'], null),
	        missionReportQuestions && _react2['default'].createElement(_componentsMissionReport2['default'], { missionReportQuestions: missionReportQuestions }),
	        hacked && _react2['default'].createElement(_componentsHacked2['default'], null)
	      );
	    }
	  }, {
	    key: '_renderPreviousSlide',
	    value: function _renderPreviousSlide() {
	      var startStyle = {
	        position: 'absolute',
	        top: '50%',
	        left: '50%',
	        transform: 'translate(-50%, -50%)',
	        margin: 0,
	        color: 'white'
	      };
	      var child = this.props.slide > 0 ? this.props.TOC[this.props.slide - 1].slide : null;
	      return child ? _react2['default'].createElement('div', null) : _react2['default'].createElement(
	        'h1',
	        { style: [startStyle] },
	        'START'
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2['default'].createElement(
	        'div',
	        { className: 'present-notes' },
	        _react2['default'].createElement(
	          'header',
	          { className: 'teacher-remote-header' },
	          _react2['default'].createElement(
	            'h2',
	            { className: 'teacher-remote-heading' },
	            'Slide ',
	            this.props.slide + 1,
	            ' of ',
	            this.props.TOC.length
	          )
	        ),
	        _react2['default'].createElement(
	          'div',
	          { className: 'teacher-remote-buttons' },
	          _react2['default'].createElement(
	            'button',
	            {
	              className: 'btn-arrow ' + (this.props.slide > 0 && 'ppa-icon-arrow-prev'),
	              onClick: this.props.prevSlide },
	            _react2['default'].createElement(
	              'span',
	              { className: 'text-hide' },
	              'Prev'
	            )
	          ),
	          _react2['default'].createElement(_componentsVideoRemoteControlButton2['default'], null),
	          _react2['default'].createElement(
	            'button',
	            {
	              className: 'btn-arrow ' + (this.props.slide + 1 < this.props.TOC.length ? 'ppa-icon-arrow-next' : ''),
	              onClick: this.props.nextSlide },
	            _react2['default'].createElement(
	              'span',
	              { className: 'text-hide' },
	              'Next'
	            )
	          )
	        ),
	        _react2['default'].createElement(
	          'div',
	          {
	            ref: 'notes',
	            className: 'teacher-remote-notes-wrapper' },
	          _react2['default'].createElement(
	            'div',
	            { className: 'teacher-remote-notes' },
	            this._renderNotes()
	          )
	        )
	      );
	    }
	  }], [{
	    key: 'propTypes',
	    value: {
	      lastSlide: _react.PropTypes.number,
	      slides: _react.PropTypes.array.isRequired,
	      slide: _react.PropTypes.number.isRequired,
	      TOC: _react.PropTypes.array.isRequired,
	      prevSlide: _react.PropTypes.func.isRequired,
	      nextSlide: _react.PropTypes.func.isRequired,
	      getHash: _react.PropTypes.func.isRequired
	    },
	    enumerable: true
	  }]);
	
	  return PresentNotes;
	})(_react.Component);
	
	exports['default'] = PresentNotes;
	module.exports = exports['default'];

/***/ }),
/* 1167 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _get = __webpack_require__(8)['default'];
	
	var _inherits = __webpack_require__(5)['default'];
	
	var _createClass = __webpack_require__(6)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _extends = __webpack_require__(7)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactAddonsCssTransitionGroup = __webpack_require__(188);
	
	var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);
	
	var _jimpickSpectacleSrcBase = __webpack_require__(27);
	
	var _jimpickSpectacleSrcBase2 = _interopRequireDefault(_jimpickSpectacleSrcBase);
	
	var _radium = __webpack_require__(144);
	
	var _radium2 = _interopRequireDefault(_radium);
	
	var _buttonBar = __webpack_require__(477);
	
	var _buttonBar2 = _interopRequireDefault(_buttonBar);
	
	var _present = __webpack_require__(1166);
	
	var _present2 = _interopRequireDefault(_present);
	
	var _scores = __webpack_require__(481);
	
	var _scores2 = _interopRequireDefault(_scores);
	
	var _fun = __webpack_require__(479);
	
	var _fun2 = _interopRequireDefault(_fun);
	
	var _overview = __webpack_require__(480);
	
	var _overview2 = _interopRequireDefault(_overview);
	
	var _exit = __webpack_require__(478);
	
	var _exit2 = _interopRequireDefault(_exit);
	
	__webpack_require__(2210);
	
	var Presenter = (function (_Base) {
	  _inherits(Presenter, _Base);
	
	  function Presenter() {
	    _classCallCheck(this, _Presenter);
	
	    _get(Object.getPrototypeOf(_Presenter.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(Presenter, [{
	    key: 'render',
	    value: function render() {
	      var session = this.context.session;
	      var mode = session.mode;
	
	      return _react2['default'].createElement(
	        'div',
	        { className: 'teacher-remote' },
	        _react2['default'].createElement(
	          'div',
	          { className: 'teacher-remote-panel panel panel-primary' },
	          _react2['default'].createElement(
	            _reactAddonsCssTransitionGroup2['default'],
	            {
	              className: 'teacher-remote-content-transition-group',
	              transitionName: 'teacher-remote-switch',
	              transitionEnterTimeout: 500,
	              transitionLeaveTimeout: 300 },
	            !mode ? _react2['default'].createElement(_present2['default'], _extends({ key: 'present' }, this.props)) : null,
	            mode === 'scores' ? _react2['default'].createElement(_scores2['default'], { key: 'scores' }) : null,
	            mode && mode.replace(/\/.*$/, '') === 'extras' ? _react2['default'].createElement(_fun2['default'], { key: 'extras' }) : null,
	            mode === 'modules' ? _react2['default'].createElement(_overview2['default'], { key: 'modules' }) : null,
	            mode === 'exit' ? _react2['default'].createElement(_exit2['default'], { key: 'exit' }) : null
	          ),
	          _react2['default'].createElement(_buttonBar2['default'], null)
	        )
	      );
	    }
	  }], [{
	    key: 'propTypes',
	    value: {
	      lastSlide: _react.PropTypes.number,
	      slides: _react.PropTypes.array.isRequired,
	      slide: _react.PropTypes.number.isRequired,
	      TOC: _react.PropTypes.array.isRequired,
	      prevSlide: _react.PropTypes.func.isRequired,
	      nextSlide: _react.PropTypes.func.isRequired,
	      getHash: _react.PropTypes.func.isRequired
	    },
	    enumerable: true
	  }, {
	    key: 'contextTypes',
	    value: {
	      session: _react.PropTypes.object.isRequired
	    },
	    enumerable: true
	  }]);
	
	  var _Presenter = Presenter;
	  Presenter = (0, _radium2['default'])(Presenter) || Presenter;
	  return Presenter;
	})(_jimpickSpectacleSrcBase2['default']);
	
	exports['default'] = Presenter;
	module.exports = exports['default'];

/***/ }),
/* 1168 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _get = __webpack_require__(8)['default'];
	
	var _inherits = __webpack_require__(5)['default'];
	
	var _createClass = __webpack_require__(6)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _extends = __webpack_require__(7)['default'];
	
	var _toConsumableArray = __webpack_require__(491)['default'];
	
	var _getIterator = __webpack_require__(62)['default'];
	
	var _Promise = __webpack_require__(33)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _nodeUuid = __webpack_require__(347);
	
	var _nodeUuid2 = _interopRequireDefault(_nodeUuid);
	
	var _reactBootstrap = __webpack_require__(24);
	
	var _reactShare = __webpack_require__(1975);
	
	var _reactRedux = __webpack_require__(22);
	
	var _actionsSessionActions = __webpack_require__(72);
	
	var _actionsReferralActions = __webpack_require__(474);
	
	var _servicesPrograms = __webpack_require__(104);
	
	var _ismobilejs = __webpack_require__(241);
	
	var _ismobilejs2 = _interopRequireDefault(_ismobilejs);
	
	var _copyToClipboard = __webpack_require__(1215);
	
	var _copyToClipboard2 = _interopRequireDefault(_copyToClipboard);
	
	var _servicesIntercom = __webpack_require__(1121);
	
	var _servicesEvents = __webpack_require__(73);
	
	var _programs = __webpack_require__(69);
	
	var _imagesFacebookMessengerWhiteSvg = __webpack_require__(2527);
	
	var _imagesFacebookMessengerWhiteSvg2 = _interopRequireDefault(_imagesFacebookMessengerWhiteSvg);
	
	var _imagesFacebookSvg = __webpack_require__(2528);
	
	var _imagesFacebookSvg2 = _interopRequireDefault(_imagesFacebookSvg);
	
	var _imagesTwitterSvg = __webpack_require__(2535);
	
	var _imagesTwitterSvg2 = _interopRequireDefault(_imagesTwitterSvg);
	
	var _imagesGooberOpenJumpCutoutPng = __webpack_require__(2522);
	
	var _imagesGooberOpenJumpCutoutPng2 = _interopRequireDefault(_imagesGooberOpenJumpCutoutPng);
	
	var _imagesIconmonstrShare3240Png = __webpack_require__(2532);
	
	var _imagesIconmonstrShare3240Png2 = _interopRequireDefault(_imagesIconmonstrShare3240Png);
	
	var _imagesIconmonstrCursor7240Png = __webpack_require__(2531);
	
	var _imagesIconmonstrCursor7240Png2 = _interopRequireDefault(_imagesIconmonstrCursor7240Png);
	
	var _imagesIconmonstrCheckbox2240Png = __webpack_require__(2530);
	
	var _imagesIconmonstrCheckbox2240Png2 = _interopRequireDefault(_imagesIconmonstrCheckbox2240Png);
	
	__webpack_require__(2211);
	
	var TwitterShareButton = _reactShare.ShareButtons.TwitterShareButton;
	
	var FACEBOOK_APPID = 1670987266293612;
	
	var emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	
	var BlurbMap = {
	  //"" = No program
	  "": "The Planet Protector Academy by @enviroheroes is a fun and engaging teaching resource that inspired my students to become environmental superheroes! Use my referral link for access (worth $250)!",
	  "keepCool": "The Planet Protector Academy: Keep Cool by @enviroheroes is a fun and engaging climate change teaching resource that inspired my students to become climate action superheroes! Use my referral link for access (worth $250)!",
	  "zeroHeroes": "The Planet Protector Academy: Zero Heroes by @enviroheroes is a fun and engaging waste reduction teaching resource that inspired my students to become zero waste superheroes! Use my referral link for access (worth $250)!",
	  "h2whoa": "The Planet Protector Academy: H2Whoa! by @enviroheroes is a fun and engaging water teaching resource that inspired my students to become water saving and protecting superheroes! Use my referral link for access (worth $250)!",
	  "espPrimaries": "The Emergency Preparedness Squad by @enviroheroes is a fun and engaging teaching resource that inspired my students to become emergency preparedness superheroes! Use my referral link for access (worth $250)!",
	  "espIntermediates": "The Emergency Preparedness Squad by @enviroheroes is a fun and engaging teaching resource that inspired my students to become emergency preparedness superheroes! Use my referral link for access (worth $250)!"
	};
	
	function buildReferralUrl(source, featuredProgram, referrerId) {
	  var fp = featuredProgram ? '&fp=' + featuredProgram : "";
	  return 'https://' + window.location.host + '/r?refId=' + referrerId + fp;
	}
	
	function buildMessengerUrl(isMobile, featuredProgram, referrerId) {
	  var referralUrl = buildReferralUrl("messenger", featuredProgram, referrerId);
	  var redirectUrl = window.location.href + '?messenger=done';
	  if (isMobile) {
	    return 'fb-messenger://share?link=' + encodeURIComponent(referralUrl) + '&app_id=' + FACEBOOK_APPID;
	  }
	  return 'https://www.facebook.com/dialog/send?app_id=' + FACEBOOK_APPID + '&link=' + encodeURIComponent(referralUrl) + '&redirect_uri=' + encodeURIComponent(redirectUrl);
	}
	
	function findFeaturedProgram(sessions) {
	  var sessionList = sessions.sessionList.map(function (sessionId) {
	    return sessions.sessions[sessionId];
	  });
	  sessionList.sort(function (a, b) {
	    return a.updatedAt - b.updatedAt;
	  });
	  var lastSessionWithContract = sessionList.filter(function (session) {
	    return session.funding === 'CONTRACT' && !_programs.programLookup[session.programId].featuredOnly;
	  })[0];
	  if (lastSessionWithContract) {
	    return lastSessionWithContract.programId;
	  }
	  return '';
	}
	
	function _shareOnMessenger(link) {
	  FB.ui({
	    method: "send",
	    link: link
	  });
	}
	
	function _shareOnFacebook(link, quote) {
	  FB.ui({
	    method: "share",
	    href: link,
	    quote: quote
	  });
	}
	
	var Invite = (function (_Component) {
	  _inherits(Invite, _Component);
	
	  _createClass(Invite, null, [{
	    key: 'propTypes',
	    value: {
	      auth: _react.PropTypes.shape({
	        authData: _react.PropTypes.shape({
	          uid: _react.PropTypes.string.isRequired
	        }).isRequired
	      }).isRequired,
	      sessions: _react.PropTypes.object.isRequired,
	      bindSessions: _react.PropTypes.func.isRequired,
	      unbind: _react.PropTypes.func.isRequired,
	      userReferral: _react.PropTypes.object.isRequired,
	      loadUserReferral: _react.PropTypes.func.isRequired,
	      generateUserReferral: _react.PropTypes.func.isRequired
	    },
	    enumerable: true
	  }, {
	    key: 'contextTypes',
	    value: {
	      profile: _react.PropTypes.object.isRequired,
	      i18n: _react.PropTypes.func.isRequired
	    },
	    enumerable: true
	  }]);
	
	  function Invite(props, context) {
	    _classCallCheck(this, Invite);
	
	    _get(Object.getPrototypeOf(Invite.prototype), 'constructor', this).call(this, props, context);
	    this.state = {
	      error: '',
	      featuredProgram: '',
	      emails: '',
	      emailInviteSent: false
	    };
	  }
	
	  _createClass(Invite, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var userId = this.props.auth.authData.uid;
	      this.boundRefs = [];
	      this.props.bindSessions(userId, this.boundRefs);
	      this.props.loadUserReferral(userId);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.props.unbind(this.boundRefs);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(props, ctx) {
	      this.setState({ featuredProgram: findFeaturedProgram(props.sessions) });
	      if (props.userReferral.loaded && !props.userReferral.referrerId && !props.userReferral.generating) {
	        var _ctx$profile = ctx.profile;
	        var firstName = _ctx$profile.firstName;
	        var lastName = _ctx$profile.lastName;
	
	        var userId = this.props.auth.authData.uid;
	        this.props.generateUserReferral(userId, firstName, lastName);
	      }
	    }
	  }, {
	    key: 'shareOnMessenger',
	    value: function shareOnMessenger() {
	      _shareOnMessenger(buildReferralUrl("messenger", this.state.featuredProgram, this.props.userReferral.referrerId));
	    }
	  }, {
	    key: 'shareOnFacebook',
	    value: function shareOnFacebook(quote) {
	      _shareOnFacebook(buildReferralUrl("facebook", this.state.featuredProgram, this.props.userReferral.referrerId), quote);
	    }
	  }, {
	    key: 'inviteByIntercom',
	    value: function inviteByIntercom(email, url, programId) {
	      var referrerUserId = this.props.auth.authData.uid;
	      var _context$profile = this.context.profile;
	      var referrerFirstName = _context$profile.firstName;
	      var referrerLastName = _context$profile.lastName;
	
	      var inviteData = {
	        referralId: _nodeUuid2['default'].v4(),
	        referralSource: "email",
	        referrerUserId: referrerUserId,
	        referrerFirstName: referrerFirstName,
	        referrerLastName: referrerLastName,
	        referrerUniqueUrl: url,
	        referredProgramId: programId
	      };
	      return (0, _servicesIntercom.intercomCreateLead)({ email: email, custom_attributes: inviteData }).then(function (leadId) {
	        (0, _servicesEvents.publishEvent)('Referral Lead Created', _extends({}, inviteData, { referreeEmail: email, leadId: leadId }));
	      }, function (err) {
	        console.log('inviteByIntercom failed for ' + email, err);
	        throw new Error('There was an issue sending an invite to ' + email + '. Please try again later.');
	      });
	    }
	  }, {
	    key: 'handleSendInvites',
	    value: function handleSendInvites(evt, referralUrl) {
	      var _this = this;
	
	      evt.preventDefault();
	      var emails = this.state.emails.split('\n').map(function (x) {
	        return x.trim();
	      }).filter(function (x) {
	        return !!x;
	      }).reduce(function (acc, cur) {
	        var lineEmails = cur.split(',').map(function (x) {
	          return x.trim();
	        }).filter(function (x) {
	          return !!x;
	        });
	        acc.push.apply(acc, _toConsumableArray(lineEmails));
	        return acc;
	      }, []);
	      if (!emails.length) {
	        this.setState({ emailInviteSent: false, error: "You need to provide at least one email address." });
	        return;
	      }
	      if (emails.length > 5) {
	        this.setState({ emailInviteSent: false, error: "Sorry, you can only send 5 invites at a time." });
	        return;
	      }
	      var errors = emails.map(function (email) {
	        var m = email.match(emailRegex);
	        if (!m) {
	          return email + ' is not a valid email.';
	        }
	      }).filter(function (x) {
	        return !!x;
	      });
	      if (errors.length) {
	        this.setState({ emailInviteSent: false, error: errors.join(" ") });
	        return;
	      }
	      var featuredProgram = this.state.featuredProgram;
	
	      var promises = [];
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = _getIterator(emails), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var email = _step.value;
	
	          promises.push(this.inviteByIntercom(email, referralUrl, featuredProgram));
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator['return']) {
	            _iterator['return']();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      _Promise.all(promises).then(function () {
	        _this.setState({ emailInviteSent: true, error: "", emails: "" });
	      }, function (err) {
	        _this.setState({ emailInviteSent: false, error: err.message });
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _context = this.context;
	      var profile = _context.profile;
	      var _ = _context.i18n;
	      var featuredProgram = this.state.featuredProgram;
	
	      var programs = (0, _servicesPrograms.getAvailableProgramsForProfile)(profile).filter(function (x) {
	        return !x.featuredOnly;
	      });
	      var mobileLink = _ismobilejs2['default'].phone || _ismobilejs2['default'].tablet;
	      var quote = BlurbMap[featuredProgram] || BlurbMap[""];
	      var userReferral = this.props.userReferral;
	
	      var ready = userReferral.loaded && userReferral.referrerId;
	      var referralUrl = ready ? buildReferralUrl("", featuredProgram, userReferral.referrerId) : "";
	
	      if (!ready) {
	        return _react2['default'].createElement(
	          _reactBootstrap.Row,
	          { className: 'invite not-ready' },
	          _react2['default'].createElement(
	            _reactBootstrap.Col,
	            { xs: 12 },
	            !userReferral.loaded && _react2['default'].createElement(
	              _reactBootstrap.Row,
	              null,
	              'Loading...'
	            ),
	            !userReferral.referrerId && _react2['default'].createElement(
	              _reactBootstrap.Row,
	              null,
	              'Generating unique referrer Id...'
	            ),
	            userReferral.error && _react2['default'].createElement(
	              _reactBootstrap.Row,
	              null,
	              userReferral.error
	            )
	          )
	        );
	      }
	
	      return _react2['default'].createElement(
	        _reactBootstrap.Row,
	        { className: 'invite' },
	        _react2['default'].createElement(
	          _reactBootstrap.Col,
	          { xs: 12 },
	          _react2['default'].createElement(
	            _reactBootstrap.Col,
	            { xs: 12, sm: 12, className: 'invite-header' },
	            _react2['default'].createElement(
	              _reactBootstrap.Col,
	              { xs: 12, sm: 6 },
	              'Invite a friend and share the fun!'
	            ),
	            _react2['default'].createElement(
	              _reactBootstrap.Col,
	              { xs: 12, sm: 6 },
	              _react2['default'].createElement('img', { src: _imagesGooberOpenJumpCutoutPng2['default'] })
	            )
	          ),
	          _react2['default'].createElement(
	            _reactBootstrap.Col,
	            { xs: 12, sm: 12, className: 'invite-howto' },
	            _react2['default'].createElement(
	              _reactBootstrap.Col,
	              { xs: 12, sm: 4 },
	              _react2['default'].createElement(
	                _reactBootstrap.Col,
	                { xs: 1, sm: 2 },
	                _react2['default'].createElement('img', { src: _imagesIconmonstrShare3240Png2['default'] })
	              ),
	              _react2['default'].createElement(
	                _reactBootstrap.Col,
	                { xs: 11, sm: 9 },
	                'You share your link with friends'
	              )
	            ),
	            _react2['default'].createElement(
	              _reactBootstrap.Col,
	              { xs: 12, sm: 4 },
	              _react2['default'].createElement(
	                _reactBootstrap.Col,
	                { xs: 1, sm: 2 },
	                _react2['default'].createElement('img', { src: _imagesIconmonstrCursor7240Png2['default'] })
	              ),
	              _react2['default'].createElement(
	                _reactBootstrap.Col,
	                { xs: 11, sm: 9 },
	                'Your friend signs up their class'
	              )
	            ),
	            _react2['default'].createElement(
	              _reactBootstrap.Col,
	              { xs: 12, sm: 4 },
	              _react2['default'].createElement(
	                _reactBootstrap.Col,
	                { xs: 1, sm: 2 },
	                _react2['default'].createElement('img', { src: _imagesIconmonstrCheckbox2240Png2['default'] })
	              ),
	              _react2['default'].createElement(
	                _reactBootstrap.Col,
	                { xs: 11, sm: 10 },
	                'You help increase our impact!'
	              )
	            )
	          )
	        ),
	        _react2['default'].createElement(
	          _reactBootstrap.Col,
	          { xs: 12, className: 'invite-mixed' },
	          _react2['default'].createElement(
	            _reactBootstrap.Row,
	            { className: 'invite-featuredProgram' },
	            _react2['default'].createElement(
	              _reactBootstrap.Col,
	              { xs: 12, sm: 5 },
	              'Featured program',
	              _react2['default'].createElement('br', null)
	            ),
	            _react2['default'].createElement(
	              _reactBootstrap.Col,
	              { xs: 12, sm: 7 },
	              _react2['default'].createElement(
	                'select',
	                { className: 'form-control', value: featuredProgram,
	                  onChange: function (evt) {
	                    return _this2.setState({ featuredProgram: evt.target.value });
	                  } },
	                _react2['default'].createElement('option', { key: 'none', value: '' }),
	                programs.map(function (x) {
	                  return _react2['default'].createElement(
	                    'option',
	                    { key: x.id, value: x.id },
	                    _(x.longTitle)
	                  );
	                })
	              )
	            )
	          ),
	          _react2['default'].createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2['default'].createElement('hr', null)
	          ),
	          _react2['default'].createElement(
	            _reactBootstrap.Row,
	            { className: 'invite-email' },
	            _react2['default'].createElement(
	              _reactBootstrap.Col,
	              { xs: 12 },
	              'Share by email'
	            ),
	            _react2['default'].createElement(
	              'div',
	              { className: 'error' },
	              this.state.error
	            ),
	            this.state.emailInviteSent && _react2['default'].createElement(
	              'div',
	              { className: 'sent' },
	              _react2['default'].createElement(
	                'p',
	                null,
	                'Your invite(s) have been sent.'
	              ),
	              _react2['default'].createElement(
	                'p',
	                null,
	                'Don\'t forget to remind your colleagues next time you see them!'
	              )
	            ),
	            _react2['default'].createElement(
	              _reactBootstrap.Col,
	              { xs: 12, sm: 8 },
	              _react2['default'].createElement('textarea', { id: 'emails',
	                className: 'form-control',
	                placeholder: 'Enter up to 5 email addresses here. One per line...',
	                spellCheck: 'false',
	                rows: 5,
	                onChange: function (evt) {
	                  return _this2.setState({ emails: evt.target.value });
	                },
	                value: this.state.emails })
	            ),
	            _react2['default'].createElement(
	              _reactBootstrap.Col,
	              { xs: 12, sm: 4, className: 'invite-email-btn-container' },
	              _react2['default'].createElement(
	                'button',
	                { type: 'submit', className: 'btn btn-lg btn-primary',
	                  onClick: function (evt) {
	                    return _this2.handleSendInvites(evt, referralUrl);
	                  } },
	                'Send invites'
	              )
	            )
	          ),
	          _react2['default'].createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2['default'].createElement('hr', null)
	          ),
	          _react2['default'].createElement(
	            _reactBootstrap.Row,
	            { className: 'invite-social' },
	            _react2['default'].createElement(
	              _reactBootstrap.Col,
	              { xs: 12 },
	              'Share on social media'
	            ),
	            _react2['default'].createElement(
	              _reactBootstrap.Col,
	              { xs: 12, sm: 4 },
	              mobileLink && _react2['default'].createElement(
	                'a',
	                { className: 'btn btn-sm messenger-share-btn',
	                  href: buildMessengerUrl(mobileLink, featuredProgram, userReferral.referrerId) },
	                _react2['default'].createElement('img', { src: _imagesFacebookMessengerWhiteSvg2['default'] }),
	                'Messenger'
	              ),
	              !mobileLink && _react2['default'].createElement(
	                'a',
	                { className: 'btn btn-sm messenger-share-btn',
	                  onClick: function () {
	                    return _this2.shareOnMessenger();
	                  } },
	                _react2['default'].createElement('img', { src: _imagesFacebookMessengerWhiteSvg2['default'] }),
	                'Messenger'
	              )
	            ),
	            _react2['default'].createElement(
	              _reactBootstrap.Col,
	              { xs: 12, sm: 4 },
	              _react2['default'].createElement(
	                'a',
	                { className: 'btn btn-sm facebook-share-btn',
	                  onClick: function () {
	                    return _this2.shareOnFacebook(quote);
	                  } },
	                _react2['default'].createElement('img', { src: _imagesFacebookSvg2['default'] }),
	                'Facebook'
	              )
	            ),
	            _react2['default'].createElement(
	              _reactBootstrap.Col,
	              { xs: 12, sm: 4 },
	              _react2['default'].createElement(
	                TwitterShareButton,
	                { className: 'btn btn-sm twitter-share-btn',
	                  url: buildReferralUrl("twitter", featuredProgram, userReferral.referrerId),
	                  title: quote },
	                _react2['default'].createElement('img', { src: _imagesTwitterSvg2['default'] }),
	                'Twitter'
	              )
	            )
	          ),
	          _react2['default'].createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2['default'].createElement('hr', null)
	          ),
	          _react2['default'].createElement(
	            _reactBootstrap.Row,
	            { className: 'invite-diy' },
	            _react2['default'].createElement(
	              _reactBootstrap.Col,
	              { xs: 12 },
	              'Share your link'
	            ),
	            _react2['default'].createElement(
	              'div',
	              { className: 'col-xs-12' },
	              _react2['default'].createElement(
	                'div',
	                { className: 'input-group input-group-sm' },
	                _react2['default'].createElement(_reactBootstrap.Input, { type: 'text', readOnly: 'readOnly',
	                  value: referralUrl }),
	                _react2['default'].createElement(
	                  'div',
	                  { className: 'input-group-btn' },
	                  _react2['default'].createElement(
	                    _reactBootstrap.Button,
	                    { bsSize: 'small', title: 'Copy to clipboard', onClick: function () {
	                        return (0, _copyToClipboard2['default'])(referralUrl);
	                      } },
	                    'Copy'
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Invite;
	})(_react.Component);
	
	exports.Invite = Invite;
	exports['default'] = (0, _reactRedux.connect)(function (state) {
	  return {
	    auth: state.auth,
	    sessions: state.sessions,
	    userReferral: state.userReferral
	  };
	}, {
	  bindSessions: _actionsSessionActions.bindSessions,
	  unbind: _actionsSessionActions.unbind,
	  loadUserReferral: _actionsReferralActions.loadUserReferral,
	  generateUserReferral: _actionsReferralActions.generateUserReferral
	})(Invite);

/***/ }),
/* 1169 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _get = __webpack_require__(8)['default'];
	
	var _inherits = __webpack_require__(5)['default'];
	
	var _createClass = __webpack_require__(6)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(66);
	
	var _tallLogo_ppaSvg = __webpack_require__(2536);
	
	var _tallLogo_ppaSvg2 = _interopRequireDefault(_tallLogo_ppaSvg);
	
	var _bodyTheme = __webpack_require__(1150);
	
	var _bodyTheme2 = _interopRequireDefault(_bodyTheme);
	
	var _servicesFullstoryJs = __webpack_require__(1120);
	
	var _servicesFullstoryJs2 = _interopRequireDefault(_servicesFullstoryJs);
	
	__webpack_require__(2212);
	
	var HomeLanding = (function (_Component) {
	  _inherits(HomeLanding, _Component);
	
	  function HomeLanding() {
	    _classCallCheck(this, HomeLanding);
	
	    _get(Object.getPrototypeOf(HomeLanding.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(HomeLanding, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      _servicesFullstoryJs2['default'].clearUserCookie();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var query = this.context.location.query;
	
	      return _react2['default'].createElement(
	        _bodyTheme2['default'],
	        { themeClass: 'dark' },
	        _react2['default'].createElement(
	          'div',
	          { className: 'container home-landing' },
	          _react2['default'].createElement(
	            'div',
	            { className: 'text-balloon' },
	            _react2['default'].createElement(
	              'h1',
	              null,
	              'Calling all super heroes!'
	            ),
	            _react2['default'].createElement(
	              'p',
	              null,
	              'Part hysterical entertainment, part fun-filled game, and entirely focused on ',
	              _react2['default'].createElement(
	                'strong',
	                null,
	                'behavior change'
	              ),
	              ' and ',
	              _react2['default'].createElement(
	                'strong',
	                null,
	                'educational outcomes'
	              ),
	              ', the Academy puts kids at the center of the story and inspires them to act on real world issues.  ',
	              _react2['default'].createElement(
	                'strong',
	                null,
	                _react2['default'].createElement(
	                  'a',
	                  { href: 'http://www.planetprotectoracademy.com', target: '_blank' },
	                  'Find out more!'
	                )
	              )
	            )
	          ),
	          _react2['default'].createElement(
	            'h1',
	            null,
	            _react2['default'].createElement('img', { src: _tallLogo_ppaSvg2['default'], alt: 'Planet Protector Academy' })
	          ),
	          _react2['default'].createElement(
	            'div',
	            { className: 'buttons' },
	            _react2['default'].createElement(
	              _reactRouter.Link,
	              { to: '/register', query: query, className: 'btn btn-lg btn-primary btn-wrap register-btn' },
	              'Register'
	            ),
	            _react2['default'].createElement(
	              _reactRouter.Link,
	              { to: '/signin', query: query, activeClassName: 'active', className: 'btn btn-lg btn-success btn-wrap' },
	              'Sign in'
	            )
	          )
	        )
	      );
	    }
	  }], [{
	    key: 'contextTypes',
	    value: {
	      location: _react.PropTypes.object.isRequired
	    },
	    enumerable: true
	  }]);
	
	  return HomeLanding;
	})(_react.Component);
	
	exports['default'] = HomeLanding;
	module.exports = exports['default'];

/***/ }),
/* 1170 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _get = __webpack_require__(8)['default'];
	
	var _inherits = __webpack_require__(5)['default'];
	
	var _createClass = __webpack_require__(6)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(2195);
	
	var Layout = (function (_Component) {
	  _inherits(Layout, _Component);
	
	  _createClass(Layout, null, [{
	    key: 'propTypes',
	    value: {
	      children: _react2['default'].PropTypes.element
	    },
	    enumerable: true
	  }]);
	
	  function Layout() {
	    _classCallCheck(this, Layout);
	
	    _get(Object.getPrototypeOf(Layout.prototype), 'constructor', this).call(this);
	  }
	
	  _createClass(Layout, [{
	    key: 'render',
	    value: function render() {
	      return _react2['default'].createElement(
	        'div',
	        { className: 'page-container' },
	        _react2['default'].createElement(
	          'div',
	          { className: 'view-container' },
	          this.props.children
	        )
	      );
	    }
	  }]);
	
	  return Layout;
	})(_react.Component);
	
	exports['default'] = Layout;
	module.exports = exports['default'];

/***/ }),
/* 1171 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _get = __webpack_require__(8)['default'];
	
	var _inherits = __webpack_require__(5)['default'];
	
	var _createClass = __webpack_require__(6)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(66);
	
	var _reactBootstrap = __webpack_require__(24);
	
	__webpack_require__(2213);
	
	var _imagesFullLogo_ppaSvg = __webpack_require__(2529);
	
	var _imagesFullLogo_ppaSvg2 = _interopRequireDefault(_imagesFullLogo_ppaSvg);
	
	var NavBar = (function (_Component) {
	  _inherits(NavBar, _Component);
	
	  function NavBar() {
	    _classCallCheck(this, NavBar);
	
	    _get(Object.getPrototypeOf(NavBar.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(NavBar, [{
	    key: '_openHelp',
	    value: function _openHelp() {
	      /* For some reasons an "a href" doesn't work from inside the hamburger menu, so we use this */
	      window.open("https://help.planetprotectoracademy.com", "_blank");
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var loggedIn = _props.auth.loggedIn;
	      var staff = _props.profile.staff;
	      var isHome = _props.isHome;
	      var logoutOnly = _props.logoutOnly;
	      var query = this.context.location.query;
	
	      var isLanding = isHome && !loggedIn;
	      var navheaderdisplay = this.context.location.pathname === '/' && loggedIn ? 'MY PROGRAMS' : this.context.location.pathname === '/programs' ? 'OTHER PROGRAMS' : this.context.location.pathname === '/profile' ? 'EDIT PROFILE' : this.context.location.pathname.startsWith('/staff') ? 'STAFF AREA' : this.context.location.pathname === '/unsubscribe' ? 'UNSUBSCRIBE' : this.context.location.pathname === '/unsubscribed' ? 'UNSUBSCRIBED' : this.context.location.pathname == '/invite' ? 'INVITE A FRIEND' : '';
	      var canInvite = true;
	
	      if (isLanding) {
	        return _react2['default'].createElement(
	          'nav',
	          { className: 'navbar navbar-landing' },
	          _react2['default'].createElement(
	            'ul',
	            { className: 'nav navbar-nav navbar-right' },
	            _react2['default'].createElement('li', null)
	          )
	        );
	      }
	
	      if (screen.width < 400 && loggedIn) {
	        return _react2['default'].createElement(
	          'nav',
	          {
	            className: 'navbar navbar-default mobileNav ' + (navheaderdisplay ? 'logged-in' : 'logged-out'),
	            role: 'navbar'
	          },
	          _react2['default'].createElement(
	            'div',
	            { className: 'container-fluid mobileNav' },
	            _react2['default'].createElement(
	              'div',
	              { className: 'branding navbar-left col-xs-6 mobileNavLogo' },
	              _react2['default'].createElement(
	                _reactRouter.Link,
	                { to: '/', activeClassName: 'active' },
	                _react2['default'].createElement('img', { src: _imagesFullLogo_ppaSvg2['default'] })
	              )
	            ),
	            _react2['default'].createElement(
	              'ul',
	              { className: 'nav navbar-nav navbar-right col-xs-1 ' + (screen.width <= 768 ? 'mobileXs' : '') },
	              _react2['default'].createElement(
	                _reactBootstrap.NavDropdown,
	                {
	                  className: 'hamburger-menu',
	                  eventKey: '4',
	                  title: _react2['default'].createElement('span', { className: 'glyphicon glyphicon-menu-hamburger' }),
	                  id: 'nav-dropdown'
	                },
	                loggedIn && !logoutOnly && _react2['default'].createElement(
	                  _reactBootstrap.MenuItem,
	                  { eventKey: '4.1' },
	                  _react2['default'].createElement(
	                    _reactRouter.Link,
	                    {
	                      className: isHome ? 'active' : '',
	                      to: '/',
	                      query: query },
	                    'My Programs'
	                  )
	                ),
	                loggedIn && !logoutOnly && _react2['default'].createElement(
	                  _reactBootstrap.MenuItem,
	                  { eventKey: '4.2' },
	                  _react2['default'].createElement(
	                    _reactRouter.Link,
	                    { to: '/programs', query: query, activeClassName: 'active' },
	                    'Other Programs'
	                  )
	                ),
	                loggedIn && staff && !logoutOnly && _react2['default'].createElement(
	                  _reactBootstrap.MenuItem,
	                  { eventKey: '4.3' },
	                  _react2['default'].createElement(
	                    _reactRouter.Link,
	                    { to: '/staff', activeClassName: 'active' },
	                    'Staff'
	                  )
	                ),
	                loggedIn && !logoutOnly && _react2['default'].createElement(
	                  _reactBootstrap.MenuItem,
	                  { eventKey: '4.4' },
	                  _react2['default'].createElement(
	                    _reactRouter.Link,
	                    { to: '/profile', query: query, activeClassName: 'active' },
	                    'Profile'
	                  )
	                ),
	                loggedIn && !logoutOnly && _react2['default'].createElement(
	                  _reactBootstrap.MenuItem,
	                  { eventKey: '4.5' },
	                  _react2['default'].createElement(
	                    'a',
	                    { onClick: this._openHelp.bind(this) },
	                    'Help'
	                  )
	                ),
	                !loggedIn && _react2['default'].createElement(
	                  _reactBootstrap.MenuItem,
	                  { eventKey: '4.6' },
	                  _react2['default'].createElement(
	                    _reactRouter.Link,
	                    { to: '/register', query: query, activeClassName: 'active', className: 'btn btn-lg btn-success' },
	                    'Register'
	                  )
	                ),
	                loggedIn ? _react2['default'].createElement(
	                  _reactBootstrap.MenuItem,
	                  { eventKey: '4.7' },
	                  _react2['default'].createElement(
	                    _reactRouter.Link,
	                    { to: '/logout', activeClassName: 'active' },
	                    'Sign out'
	                  )
	                ) : _react2['default'].createElement(
	                  _reactBootstrap.MenuItem,
	                  { eventKey: '4.7' },
	                  _react2['default'].createElement(
	                    _reactRouter.Link,
	                    { to: '/signin', query: query, activeClassName: 'active', className: 'btn btn-lg btn-success' },
	                    'Sign in'
	                  )
	                ),
	                loggedIn && canInvite && !logoutOnly && _react2['default'].createElement(
	                  _reactBootstrap.MenuItem,
	                  { eventKey: '4.8' },
	                  _react2['default'].createElement(
	                    _reactRouter.Link,
	                    { to: '/invite', activeClassName: 'active' },
	                    'Invite'
	                  )
	                )
	              )
	            )
	          )
	        );
	      } else if (screen.width < 992 && loggedIn) {
	        return _react2['default'].createElement(
	          'div',
	          { className: 'navbar-container' },
	          _react2['default'].createElement(
	            'nav',
	            {
	              className: 'navbar navbar-default mobileNav ' + (navheaderdisplay ? 'logged-in' : 'logged-out'),
	              role: 'navbar'
	            },
	            _react2['default'].createElement(
	              'div',
	              { className: 'container-fluid' },
	              _react2['default'].createElement(
	                'div',
	                { className: 'branding navbar-left col-xs-6' },
	                _react2['default'].createElement(
	                  _reactRouter.Link,
	                  { to: '/', activeClassName: 'active' },
	                  _react2['default'].createElement('img', { src: _imagesFullLogo_ppaSvg2['default'] })
	                )
	              ),
	              _react2['default'].createElement(
	                'ul',
	                { className: 'nav navbar-nav navbar-right col-xs-2 ' + (screen.width <= 768 ? 'mobileXs' : '') },
	                _react2['default'].createElement(
	                  _reactBootstrap.NavDropdown,
	                  {
	                    className: 'hamburger-menu',
	                    eventKey: '4',
	                    title: _react2['default'].createElement('span', { className: 'glyphicon glyphicon-menu-hamburger' }),
	                    id: 'nav-dropdown'
	                  },
	                  loggedIn && !logoutOnly && _react2['default'].createElement(
	                    _reactBootstrap.MenuItem,
	                    { eventKey: '4.1' },
	                    _react2['default'].createElement(
	                      _reactRouter.Link,
	                      {
	                        className: isHome ? 'active' : '',
	                        to: '/',
	                        query: query },
	                      'My Programs'
	                    )
	                  ),
	                  loggedIn && !logoutOnly && _react2['default'].createElement(
	                    _reactBootstrap.MenuItem,
	                    { eventKey: '4.2' },
	                    _react2['default'].createElement(
	                      _reactRouter.Link,
	                      { to: '/programs', query: query, activeClassName: 'active' },
	                      'Other Programs'
	                    )
	                  ),
	                  loggedIn && staff && !logoutOnly && _react2['default'].createElement(
	                    _reactBootstrap.MenuItem,
	                    { eventKey: '4.4' },
	                    _react2['default'].createElement(
	                      _reactRouter.Link,
	                      { to: '/staff', activeClassName: 'active' },
	                      'Staff'
	                    )
	                  ),
	                  loggedIn && !logoutOnly && _react2['default'].createElement(
	                    _reactBootstrap.MenuItem,
	                    { eventKey: '4.5' },
	                    _react2['default'].createElement(
	                      _reactRouter.Link,
	                      { to: '/profile', query: query, activeClassName: 'active' },
	                      'Profile'
	                    )
	                  ),
	                  loggedIn && !logoutOnly && _react2['default'].createElement(
	                    _reactBootstrap.MenuItem,
	                    { eventKey: '4.6' },
	                    _react2['default'].createElement(
	                      'a',
	                      { onClick: this._openHelp.bind(this) },
	                      'Help'
	                    )
	                  ),
	                  !loggedIn && _react2['default'].createElement(
	                    _reactBootstrap.MenuItem,
	                    { eventKey: '4.7' },
	                    _react2['default'].createElement(
	                      _reactRouter.Link,
	                      { to: '/register', query: query, activeClassName: 'active', className: 'btn btn-lg btn-success' },
	                      'Register'
	                    )
	                  ),
	                  loggedIn ? _react2['default'].createElement(
	                    _reactBootstrap.MenuItem,
	                    { eventKey: '4.8' },
	                    _react2['default'].createElement(
	                      _reactRouter.Link,
	                      { to: '/logout', activeClassName: 'active' },
	                      'Sign out'
	                    )
	                  ) : _react2['default'].createElement(
	                    _reactBootstrap.MenuItem,
	                    { eventKey: '4.8' },
	                    _react2['default'].createElement(
	                      _reactRouter.Link,
	                      { to: '/signin', query: query, activeClassName: 'active', className: 'btn btn-lg btn-success' },
	                      'Sign in'
	                    )
	                  ),
	                  loggedIn && canInvite && !logoutOnly && _react2['default'].createElement(
	                    _reactBootstrap.MenuItem,
	                    { eventKey: '4.9' },
	                    _react2['default'].createElement(
	                      _reactRouter.Link,
	                      { to: '/invite', activeClassName: 'active' },
	                      'Invite'
	                    )
	                  )
	                )
	              )
	            )
	          ),
	          navheaderdisplay && _react2['default'].createElement(
	            'div',
	            { className: 'navbar-page-header' },
	            navheaderdisplay
	          )
	        );
	      } else {
	        return _react2['default'].createElement(
	          'div',
	          { className: 'navbar-container' },
	          _react2['default'].createElement(
	            'nav',
	            { className: 'navbar navbar-default ' + (navheaderdisplay ? 'logged-in' : 'logged-out') },
	            _react2['default'].createElement(
	              'div',
	              { className: 'container-fluid' },
	              _react2['default'].createElement(
	                'div',
	                { className: 'branding navbar-left' },
	                _react2['default'].createElement(
	                  _reactRouter.Link,
	                  { to: '/', activeClassName: 'active' },
	                  _react2['default'].createElement('img', { src: _imagesFullLogo_ppaSvg2['default'] })
	                )
	              ),
	              _react2['default'].createElement(
	                'ul',
	                { className: 'nav navbar-nav navbar-right' },
	                loggedIn && !logoutOnly && _react2['default'].createElement(
	                  'li',
	                  null,
	                  _react2['default'].createElement(
	                    _reactRouter.Link,
	                    {
	                      className: isHome ? 'active' : '',
	                      to: '/',
	                      query: query },
	                    'My Programs'
	                  )
	                ),
	                loggedIn && !logoutOnly && _react2['default'].createElement(
	                  'li',
	                  null,
	                  _react2['default'].createElement(
	                    _reactRouter.Link,
	                    { to: '/programs', query: query, activeClassName: 'active' },
	                    'Other Programs'
	                  )
	                ),
	                loggedIn && staff && !logoutOnly && _react2['default'].createElement(
	                  'li',
	                  null,
	                  _react2['default'].createElement(
	                    _reactRouter.Link,
	                    { to: '/staff', activeClassName: 'active' },
	                    'Staff'
	                  )
	                ),
	                loggedIn && !logoutOnly && _react2['default'].createElement(
	                  'li',
	                  null,
	                  _react2['default'].createElement(
	                    _reactRouter.Link,
	                    { to: '/profile', query: query, activeClassName: 'active' },
	                    'Profile'
	                  )
	                ),
	                loggedIn && !logoutOnly && _react2['default'].createElement(
	                  'li',
	                  null,
	                  _react2['default'].createElement(
	                    'a',
	                    { onClick: this._openHelp.bind(this) },
	                    'Help'
	                  )
	                ),
	                !loggedIn && _react2['default'].createElement(
	                  'li',
	                  null,
	                  _react2['default'].createElement(
	                    _reactRouter.Link,
	                    { to: '/register', query: query, activeClassName: 'active', className: 'btn btn-lg btn-success' },
	                    'Register'
	                  )
	                ),
	                loggedIn ? _react2['default'].createElement(
	                  'li',
	                  null,
	                  _react2['default'].createElement(
	                    _reactRouter.Link,
	                    { to: '/logout', activeClassName: 'active' },
	                    'Sign out'
	                  )
	                ) : _react2['default'].createElement(
	                  'li',
	                  null,
	                  _react2['default'].createElement(
	                    _reactRouter.Link,
	                    { to: '/signin', query: query, activeClassName: 'active', className: 'btn btn-lg btn-success' },
	                    'Sign in'
	                  )
	                ),
	                loggedIn && canInvite && !logoutOnly && _react2['default'].createElement(
	                  'li',
	                  null,
	                  _react2['default'].createElement(
	                    _reactRouter.Link,
	                    { to: '/invite', className: 'btn btn-lg btn-success' },
	                    'Invite'
	                  )
	                )
	              )
	            )
	          ),
	          navheaderdisplay && _react2['default'].createElement(
	            'div',
	            { className: 'navbar-page-header' },
	            navheaderdisplay
	          )
	        );
	      }
	    }
	  }], [{
	    key: 'propTypes',
	    value: {
	      auth: _react.PropTypes.shape({
	        loggedIn: _react.PropTypes.bool.isRequired
	      }).isRequired,
	      profile: _react.PropTypes.shape({
	        staff: _react.PropTypes.bool,
	        beta: _react.PropTypes.bool
	      }),
	      isHome: _react.PropTypes.bool.isRequired,
	      logoutOnly: _react.PropTypes.bool.isRequired
	    },
	    enumerable: true
	  }, {
	    key: 'contextTypes',
	    value: {
	      location: _react.PropTypes.object.isRequired
	    },
	    enumerable: true
	  }]);
	
	  return NavBar;
	})(_react.Component);
	
	exports['default'] = NavBar;
	module.exports = exports['default'];

/***/ }),
/* 1172 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _get = __webpack_require__(8)['default'];
	
	var _inherits = __webpack_require__(5)['default'];
	
	var _createClass = __webpack_require__(6)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	var _interopRequireWildcard = __webpack_require__(175)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(22);
	
	var _programPanel = __webpack_require__(1173);
	
	var _programPanel2 = _interopRequireDefault(_programPanel);
	
	var _actionsSessionActions = __webpack_require__(72);
	
	var _actionsProfileActions = __webpack_require__(103);
	
	var _servicesPrograms = __webpack_require__(104);
	
	var programs = _interopRequireWildcard(_servicesPrograms);
	
	var ProgramsIndex = (function (_Component) {
	  _inherits(ProgramsIndex, _Component);
	
	  function ProgramsIndex() {
	    _classCallCheck(this, ProgramsIndex);
	
	    _get(Object.getPrototypeOf(ProgramsIndex.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(ProgramsIndex, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var userId = this.props.auth.authData.uid;
	      this.boundRefs = [];
	      this.props.bindSessions(userId, this.boundRefs);
	      dataLayer.push({ event: 'showChatWidget' });
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.props.unbind(this.boundRefs);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this = this;
	
	      var _props = this.props;
	      var auth = _props.auth;
	      var sessions = _props.sessions;
	      var authData = auth.authData;
	      var userId = authData.uid;
	      var profile = this.context.profile;
	
	      var featuredPrograms = programs.getFeaturedProgramsForProfile(profile);
	      var programList = programs.getAvailableProgramsForProfile(profile);
	      var otherPrograms = programList.filter(function (program) {
	        return featuredPrograms.indexOf(program) < 0;
	      });
	
	      return _react2['default'].createElement(
	        'div',
	        null,
	        featuredPrograms.length > 0 && _react2['default'].createElement(
	          'div',
	          { className: 'clearfix' },
	          featuredPrograms.map(function (program) {
	            var id = program.id;
	
	            return _react2['default'].createElement(_programPanel2['default'], {
	              key: id,
	              programs: featuredPrograms,
	              program: program,
	              userId: userId,
	              sessions: sessions,
	              createSession: _this.props.createSession,
	              updateSession: _this.props.updateSession,
	              resetAddEditClassForm: _this.props.resetAddEditClassForm,
	              updateProfile: _this.props.updateProfile });
	          })
	        ),
	        featuredPrograms.length === 0 && otherPrograms.length > 0 && _react2['default'].createElement(
	          'div',
	          { className: 'clearfix' },
	          otherPrograms.map(function (program) {
	            var id = program.id;
	
	            return _react2['default'].createElement(_programPanel2['default'], {
	              key: id,
	              programs: programList,
	              program: program,
	              userId: userId,
	              sessions: sessions,
	              createSession: _this.props.createSession,
	              updateSession: _this.props.updateSession,
	              resetAddEditClassForm: _this.props.resetAddEditClassForm,
	              updateProfile: _this.props.updateProfile });
	          })
	        )
	      );
	    }
	  }], [{
	    key: 'propTypes',
	    value: {
	      auth: _react.PropTypes.shape({
	        authData: _react.PropTypes.shape({
	          uid: _react.PropTypes.string.isRequired
	        }).isRequired
	      }).isRequired,
	      sessions: _react.PropTypes.object.isRequired,
	      bindSessions: _react.PropTypes.func.isRequired,
	      unbind: _react.PropTypes.func.isRequired,
	      createSession: _react.PropTypes.func.isRequired,
	      updateSession: _react.PropTypes.func.isRequired,
	      resetAddEditClassForm: _react.PropTypes.func.isRequired,
	      updateProfile: _react.PropTypes.func.isRequired
	    },
	    enumerable: true
	  }, {
	    key: 'contextTypes',
	    value: {
	      location: _react.PropTypes.object.isRequired,
	      profile: _react.PropTypes.object.isRequired
	    },
	    enumerable: true
	  }]);
	
	  return ProgramsIndex;
	})(_react.Component);
	
	exports['default'] = (0, _reactRedux.connect)(function (state) {
	  return {
	    auth: state.auth,
	    sessions: state.sessions
	  };
	}, {
	  bindSessions: _actionsSessionActions.bindSessions,
	  unbind: _actionsSessionActions.unbind,
	  createSession: _actionsSessionActions.createSession,
	  updateSession: _actionsSessionActions.updateSession,
	  resetAddEditClassForm: _actionsSessionActions.resetAddEditClassForm,
	  updateProfile: _actionsProfileActions.updateProfile
	})(ProgramsIndex);
	module.exports = exports['default'];

/***/ }),
/* 1173 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _get = __webpack_require__(8)['default'];
	
	var _inherits = __webpack_require__(5)['default'];
	
	var _createClass = __webpack_require__(6)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _extends = __webpack_require__(7)['default'];
	
	var _Promise = __webpack_require__(33)['default'];
	
	var _getIterator = __webpack_require__(62)['default'];
	
	var _Object$keys = __webpack_require__(32)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	var _interopRequireWildcard = __webpack_require__(175)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _helpersMarkdownScript = __webpack_require__(9);
	
	var _helpersMarkdownScript2 = _interopRequireDefault(_helpersMarkdownScript);
	
	var _dashboardAddEditClassModal = __webpack_require__(305);
	
	var _dashboardAddEditClassModal2 = _interopRequireDefault(_dashboardAddEditClassModal);
	
	var _routerHistory = __webpack_require__(229);
	
	var _routerHistory2 = _interopRequireDefault(_routerHistory);
	
	var _viewsDashboardConfirmAddClassModal = __webpack_require__(1155);
	
	var _viewsDashboardConfirmAddClassModal2 = _interopRequireDefault(_viewsDashboardConfirmAddClassModal);
	
	var _servicesCookie = __webpack_require__(301);
	
	var _servicesPrograms = __webpack_require__(104);
	
	var programs = _interopRequireWildcard(_servicesPrograms);
	
	var ProgramPanel = (function (_Component) {
	  _inherits(ProgramPanel, _Component);
	
	  _createClass(ProgramPanel, null, [{
	    key: 'propTypes',
	    value: {
	      userId: _react.PropTypes.string.isRequired,
	      sessions: _react.PropTypes.object.isRequired,
	      program: _react.PropTypes.object.isRequired,
	      programs: _react.PropTypes.array.isRequired,
	      createSession: _react.PropTypes.func.isRequired,
	      updateSession: _react.PropTypes.func.isRequired,
	      resetAddEditClassForm: _react.PropTypes.func.isRequired,
	      updateProfile: _react.PropTypes.func.isRequired
	    },
	    enumerable: true
	  }, {
	    key: 'contextTypes',
	    value: {
	      staff: _react.PropTypes.bool,
	      regionData: _react.PropTypes.object.isRequired,
	      location: _react.PropTypes.object.isRequired,
	      profile: _react.PropTypes.object.isRequired,
	      i18n: _react.PropTypes.func.isRequired
	    },
	    enumerable: true
	  }]);
	
	  function ProgramPanel(props) {
	    _classCallCheck(this, ProgramPanel);
	
	    _get(Object.getPrototypeOf(ProgramPanel.prototype), 'constructor', this).call(this, props);
	    this.state = {
	      showPrepareModal: false,
	      showAddEditClassModal: false,
	      showConfirmAddClassModal: false,
	      addClassData: null
	    };
	  }
	
	  _createClass(ProgramPanel, [{
	    key: 'closeAddEditClassModal',
	    value: function closeAddEditClassModal() {
	      var _this = this;
	
	      return new _Promise(function (resolve) {
	        _this.setState({ showAddEditClassModal: false }, resolve);
	      });
	    }
	  }, {
	    key: 'handleCancelAddClass',
	    value: function handleCancelAddClass() {
	      this.setState({ showConfirmAddClassModal: false, showAddEditClassModal: false, addClassData: null });
	    }
	  }, {
	    key: 'hasActiveSessionForProgram',
	    value: function hasActiveSessionForProgram() {
	      var _props = this.props;
	      var sessions = _props.sessions.sessions;
	      var program = _props.program;
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = _getIterator(_Object$keys(sessions)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var k = _step.value;
	
	          var session = sessions[k];
	          if (session.programId !== program.id) continue;
	          if (session.archivedAt) continue;
	          if (!session.funding) continue;
	          if (session.validUntil < Date.now()) continue;
	          return true;
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator['return']) {
	            _iterator['return']();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      return false;
	    }
	  }, {
	    key: 'handleAddClass',
	    value: function handleAddClass(data) {
	      if (this.hasActiveSessionForProgram()) {
	        this.setState({ showConfirmAddClassModal: true, addClassData: data });
	        return;
	      }
	      this.createSession(data);
	    }
	  }, {
	    key: 'handleConfirmAddClass',
	    value: function handleConfirmAddClass() {
	      var _this2 = this;
	
	      var addClassData = this.state.addClassData;
	
	      this.setState({ showConfirmAddClassModal: false, addClassData: null }, function () {
	        _this2.createSession(addClassData);
	      });
	    }
	  }, {
	    key: 'createSession',
	    value: function createSession(data) {
	      var _this3 = this;
	
	      var _props2 = this.props;
	      var userId = _props2.userId;
	      var program = _props2.program;
	      var createSession = _props2.createSession;
	      var updateProfile = _props2.updateProfile;
	      var sessions = _props2.sessions;
	      var staff = this.context.staff;
	
	      var contractId = tryGetCookieValue("contractId");
	      var programId = program.id;
	      var language = data.language;
	      var grade = data.grade;
	      var divisionName = data.divisionName;
	      var numberOfStudents = data.numberOfStudents;
	
	      var _ref = (0, _servicesCookie.parseCookie)(tryGetCookieValue('ppa_referral')) || this.context.profile;
	
	      var referrerUserId = _ref.referrerUserId;
	
	      var hasFeaturedPrograms = programs.hasFeaturedPrograms();
	      createSession(userId, programId, {
	        language: language,
	        grade: grade,
	        divisionName: divisionName,
	        numberOfStudents: parseInt(numberOfStudents, 10),
	        pendingApproval: !(staff || hasFeaturedPrograms && contractId),
	        firstClass: sessions.sessionList && sessions.sessionList.length === 0,
	        contractId: hasFeaturedPrograms && contractId,
	        referrerUserId: referrerUserId
	      }).then(function () {
	        if (_this3.context.profile.gettingStartedOptIn) return;
	        return updateProfile(userId, _extends({}, _this3.context.profile, { gettingStartedOptIn: true, consent: 'implicit' }));
	      }).then(function () {
	        return _this3.closeAddEditClassModal();
	      }).then(function () {
	        //Using a timeout is the only possible option
	        setTimeout(function () {
	          return _this3.redirectToDashboard();
	        }, 500);
	      });
	    }
	  }, {
	    key: 'redirectToDashboard',
	    value: function redirectToDashboard() {
	      var query = this.context.location.query;
	
	      _routerHistory2['default'].pushState(null, '/', query);
	    }
	  }, {
	    key: 'openAddEditClassModal',
	    value: function openAddEditClassModal() {
	      var resetAddEditClassForm = this.props.resetAddEditClassForm;
	
	      var fp = programs.getFeaturedProgramHelper(this.props.program.id);
	      resetAddEditClassForm({
	        program: fp.programId,
	        language: fp.featuredLanguage
	      });
	      this.setState({ showAddEditClassModal: true });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state;
	      var showAddEditClassModal = _state.showAddEditClassModal;
	      var showConfirmAddClassModal = _state.showConfirmAddClassModal;
	      var _props3 = this.props;
	      var program = _props3.program;
	      var programs = _props3.programs;
	      var _context = this.context;
	      var regionData = _context.regionData;
	      var _ = _context.i18n;
	      var programId = program.id;
	      var longDescription = program.longDescription;
	      var levelsDescription = program.levelsDescription;
	      var thumbnailImage = program.thumbnailImage;
	
	      var availablePrograms = programs.filter(function (prog) {
	        return prog.id === programId;
	      });
	      var mdDescription = new _helpersMarkdownScript2['default'](_(longDescription));
	      var mdLevels = new _helpersMarkdownScript2['default'](_(levelsDescription));
	      return _react2['default'].createElement(
	        'div',
	        { key: programId, className: 'well programWell row' },
	        _react2['default'].createElement(
	          'div',
	          { className: 'col-md-3 col-sm-2 program-thumb' },
	          _react2['default'].createElement('img', { src: _(thumbnailImage) })
	        ),
	        _react2['default'].createElement(
	          'div',
	          { className: 'col-md-8 col-sm-10 programPanelProgramTitleContainer' },
	          _react2['default'].createElement(
	            'h4',
	            { className: 'programPanelProgramTitle' },
	            _(program.title)
	          )
	        ),
	        _react2['default'].createElement(
	          'div',
	          { className: 'col-md-4 col-sm-4 programDescriptionDiv' },
	          _react2['default'].createElement('div', { dangerouslySetInnerHTML: { __html: mdDescription.getAllAsHtml(regionData) } }),
	          _react2['default'].createElement(
	            'div',
	            { className: 'col-md-2 programTitleDiv' },
	            _react2['default'].createElement(
	              'div',
	              null,
	              _react2['default'].createElement(
	                'button',
	                {
	                  className: 'btn btn-default btn-sm glyphicon glyphicon-plus',
	                  onClick: this.openAddEditClassModal.bind(this) },
	                'Add class'
	              )
	            ),
	            _react2['default'].createElement(_dashboardAddEditClassModal2['default'], {
	              programs: availablePrograms,
	              showModal: showAddEditClassModal,
	              onSubmit: this.handleAddClass.bind(this),
	              closeModal: this.closeAddEditClassModal.bind(this) }),
	            _react2['default'].createElement(_viewsDashboardConfirmAddClassModal2['default'], {
	              showModal: showConfirmAddClassModal,
	              onCancel: this.handleCancelAddClass.bind(this),
	              onConfirm: this.handleConfirmAddClass.bind(this) })
	          )
	        ),
	        _react2['default'].createElement(
	          'div',
	          { className: 'col-md-4 col-sm-6 programLevelsInclude' },
	          _react2['default'].createElement('div', { dangerouslySetInnerHTML: { __html: mdLevels.getAllAsHtml(regionData) } })
	        )
	      );
	    }
	  }]);
	
	  return ProgramPanel;
	})(_react.Component);
	
	exports['default'] = ProgramPanel;
	module.exports = exports['default'];

/***/ }),
/* 1174 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _taggedTemplateLiteral = __webpack_require__(28)['default'];
	
	var _get = __webpack_require__(8)['default'];
	
	var _inherits = __webpack_require__(5)['default'];
	
	var _createClass = __webpack_require__(6)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['Completed Level ', ''], ['Completed Level ', '']),
	    _templateObject2 = _taggedTemplateLiteral(['Yes, I just finished this Level with my class! Continue on to Level ', ''], ['Yes, I just finished this Level with my class! Continue on to Level ', '']),
	    _templateObject3 = _taggedTemplateLiteral(['No, I was just previewing the content. Exit and stay on Level ', ''], ['No, I was just previewing the content. Exit and stay on Level ', '']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(24);
	
	var _programs = __webpack_require__(69);
	
	var _programs2 = _interopRequireDefault(_programs);
	
	__webpack_require__(2214);
	
	var CompleteLevelModal = (function (_Component) {
	  _inherits(CompleteLevelModal, _Component);
	
	  function CompleteLevelModal() {
	    _classCallCheck(this, CompleteLevelModal);
	
	    _get(Object.getPrototypeOf(CompleteLevelModal.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(CompleteLevelModal, [{
	    key: 'cancel',
	    value: function cancel(evt) {
	      var closeModal = this.props.closeModal;
	
	      closeModal();
	      evt.preventDefault();
	      evt.stopPropagation();
	      evt.nativeEvent.stopPropagation();
	    }
	  }, {
	    key: 'handleComplete',
	    value: function handleComplete(evt) {
	      var complete = this.props.complete;
	
	      complete();
	      evt.preventDefault();
	      evt.stopPropagation();
	      evt.nativeEvent.stopPropagation();
	    }
	  }, {
	    key: 'handleExitNoComplete',
	    value: function handleExitNoComplete(evt) {
	      var exitNoComplete = this.props.exitNoComplete;
	
	      exitNoComplete();
	      evt.preventDefault();
	      evt.stopPropagation();
	      evt.nativeEvent.stopPropagation();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var showModal = _props.showModal;
	      var closeModal = _props.closeModal;
	      var _props$session = _props.session;
	      var programId = _props$session.programId;
	      var currentLevel = _props$session.currentLevel;
	      var _ = this.context.i18n;
	
	      var program = _programs2['default'].programLookup[programId];
	      var levels = program.levels;
	
	      var nextLevel = String(Number(currentLevel) + 1);
	      if (!levels[nextLevel]) {
	        nextLevel = 'completed';
	      }
	
	      return _react2['default'].createElement(
	        _reactBootstrap.Modal,
	        { show: showModal, onHide: closeModal, className: 'spectacle-deck complete-level' },
	        _react2['default'].createElement(
	          _reactBootstrap.Modal.Header,
	          { closeButton: true },
	          _react2['default'].createElement(
	            _reactBootstrap.Modal.Title,
	            null,
	            _(_templateObject, currentLevel),
	            '!'
	          )
	        ),
	        _react2['default'].createElement(
	          _reactBootstrap.Modal.Body,
	          null,
	          _react2['default'].createElement(
	            'h3',
	            null,
	            nextLevel !== 'completed' ? _('Proceed to the next level?') : _('All levels completed! Mark as done?')
	          ),
	          nextLevel !== 'completed' && _react2['default'].createElement(
	            'p',
	            null,
	            '(',
	            _('takes effect on the next launch')
	          ),
	          _react2['default'].createElement(
	            'button',
	            {
	              className: 'btn btn-default',
	              onClick: this.handleComplete.bind(this) },
	            nextLevel !== 'completed' ? _(_templateObject2, nextLevel) : _('Yes, all done!')
	          ),
	          _react2['default'].createElement(
	            'button',
	            {
	              className: 'btn btn-default',
	              onClick: this.handleExitNoComplete.bind(this) },
	            _(_templateObject3, currentLevel)
	          )
	        )
	      );
	    }
	  }], [{
	    key: 'propTypes',
	    value: {
	      session: _react.PropTypes.object.isRequired,
	      showModal: _react.PropTypes.bool.isRequired,
	      closeModal: _react.PropTypes.func.isRequired,
	      complete: _react.PropTypes.func.isRequired,
	      exitNoComplete: _react.PropTypes.func.isRequired
	    },
	    enumerable: true
	  }, {
	    key: 'contextTypes',
	    value: {
	      i18n: _react.PropTypes.func.isRequired
	    },
	    enumerable: true
	  }]);
	
	  return CompleteLevelModal;
	})(_react.Component);
	
	exports['default'] = CompleteLevelModal;
	module.exports = exports['default'];

/***/ }),
/* 1175 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _get = __webpack_require__(8)['default'];
	
	var _inherits = __webpack_require__(5)['default'];
	
	var _createClass = __webpack_require__(6)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(24);
	
	var NextSlideConfirmationModal = (function (_Component) {
	  _inherits(NextSlideConfirmationModal, _Component);
	
	  _createClass(NextSlideConfirmationModal, null, [{
	    key: 'propTypes',
	    value: {
	      showModal: _react.PropTypes.bool.isRequired,
	      closeModal: _react.PropTypes.func.isRequired,
	      title: _react.PropTypes.string.isRequired,
	      message: _react.PropTypes.string.isRequired,
	      cancelBtnMessage: _react.PropTypes.string.isRequired,
	      continueBtnMessage: _react.PropTypes.string.isRequired
	    },
	    enumerable: true
	  }]);
	
	  function NextSlideConfirmationModal() {
	    _classCallCheck(this, NextSlideConfirmationModal);
	
	    _get(Object.getPrototypeOf(NextSlideConfirmationModal.prototype), 'constructor', this).call(this);
	    this.state = {};
	  }
	
	  _createClass(NextSlideConfirmationModal, [{
	    key: 'handleCancel',
	    value: function handleCancel() {
	      this.props.closeModal(false);
	    }
	  }, {
	    key: 'handleContinue',
	    value: function handleContinue() {
	      this.props.closeModal(true);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var showModal = _props.showModal;
	      var message = _props.message;
	
	      return _react2['default'].createElement(
	        _reactBootstrap.Modal,
	        { show: showModal, onHide: this.handleCancel.bind(this), className: 'spectacle-deck complete-level' },
	        _react2['default'].createElement(
	          _reactBootstrap.Modal.Header,
	          { closeButton: true },
	          _react2['default'].createElement(
	            _reactBootstrap.Modal.Title,
	            null,
	            this.props.title
	          )
	        ),
	        _react2['default'].createElement(
	          _reactBootstrap.Modal.Body,
	          null,
	          _react2['default'].createElement(
	            'p',
	            null,
	            message
	          ),
	          _react2['default'].createElement(
	            'button',
	            {
	              className: 'btn btn-default',
	              onClick: this.handleCancel.bind(this) },
	            this.props.cancelBtnMessage
	          ),
	          _react2['default'].createElement(
	            'button',
	            {
	              className: 'btn btn-default',
	              onClick: this.handleContinue.bind(this) },
	            this.props.continueBtnMessage
	          )
	        )
	      );
	    }
	  }]);
	
	  return NextSlideConfirmationModal;
	})(_react.Component);
	
	exports['default'] = NextSlideConfirmationModal;
	module.exports = exports['default'];

/***/ }),
/* 1176 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _get = __webpack_require__(8)['default'];
	
	var _inherits = __webpack_require__(5)['default'];
	
	var _createClass = __webpack_require__(6)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _constantsApp = __webpack_require__(1106);
	
	__webpack_require__(2217);
	
	var Onboarding = (function (_Component) {
	  _inherits(Onboarding, _Component);
	
	  _createClass(Onboarding, null, [{
	    key: 'propTypes',
	    value: {
	      children: _react.PropTypes.node
	    },
	    enumerable: true
	  }, {
	    key: 'contextTypes',
	    value: {
	      profile: _react.PropTypes.object.isRequired,
	      updateOnboardingState: _react.PropTypes.func.isRequired,
	      userId: _react.PropTypes.string.isRequired,
	      showHUD: _react.PropTypes.func.isRequired,
	      hideHUD: _react.PropTypes.func.isRequired,
	      setMode: _react.PropTypes.func.isRequired,
	      deckState: _react.PropTypes.object.isRequired,
	      i18n: _react.PropTypes.func.isRequired
	    },
	    enumerable: true
	  }]);
	
	  function Onboarding(props, context) {
	    _classCallCheck(this, Onboarding);
	
	    _get(Object.getPrototypeOf(Onboarding.prototype), 'constructor', this).call(this, props, context);
	    this.state = { step: 0, wait: false };
	    var _ = this.context.i18n;
	
	    this.steps = [{
	      title: _('Welcome Training Agent!'),
	      text: _('Let\'s spend 30 seconds orienting you to the platform!'),
	      delayAfter: _constantsApp.OnboardingDelayWithoutTransitions
	    }, {
	      highlight: 'Menu',
	      attachmentPoint: [1, 0.5],
	      text: _('Click on MENU to open up the Heads Up Display menu.'),
	      action: context.showHUD,
	      delayAfter: _constantsApp.OnboardingDelayWithTransitions
	    }, {
	      highlight: 'Scores',
	      attachmentPoint: [0.5, 1],
	      text: _('Click on SCORES to check out the Scoreboard. Your class will be divided into four teams and will compete for points!'),
	      action: function action() {
	        return context.setMode('scores');
	      },
	      delayAfter: _constantsApp.OnboardingDelayWithTransitions
	    }, {
	      highlight: 'Extras',
	      attachmentPoint: [0.5, 0],
	      text: _('Click on EXTRAS for bonus resources for more learning and laughter!'),
	      action: function action() {
	        return context.setMode('extras');
	      },
	      delayAfter: _constantsApp.OnboardingDelayWithoutTransitions
	    }, {
	      highlight: 'Modules',
	      attachmentPoint: [0.5, 0],
	      text: _('Click on MODULES for an overview of all the levels in the program. You\'ll unlock levels as you progress!'),
	      action: function action() {
	        return context.setMode('modules');
	      },
	      delayAfter: _constantsApp.OnboardingDelayWithoutTransitions
	    }, {
	      highlight: 'Exit',
	      attachmentPoint: [0.5, 0],
	      text: _('Click on EXIT to leave the presentation and go back to the DASHBOARD page any time.'),
	      action: function action() {
	        return context.setMode('exit');
	      },
	      delayAfter: _constantsApp.OnboardingDelayWithoutTransitions
	    }, {
	      highlight: 'Hide',
	      attachmentPoint: [0.5, 0],
	      text: _('Click HIDE to close the Heads Up Display and get back to the action!'),
	      action: function action() {
	        context.setMode('').then(function () {
	          return context.showHUD();
	        });
	      },
	      delayAfter: _constantsApp.OnboardingDelayWithTransitions
	    }, {
	      title: _('Almost there!'),
	      highlight: 'Next Arrow',
	      attachmentPoint: [0, 0.5],
	      text: _react2['default'].createElement(
	        'p',
	        null,
	        _('You can progress through the slides in 3 ways:'),
	        _react2['default'].createElement(
	          'ol',
	          null,
	          _react2['default'].createElement(
	            'li',
	            null,
	            _('Use the arrow(s) as highlighted')
	          ),
	          _react2['default'].createElement(
	            'li',
	            null,
	            _('Use the left/right keys on your keyboard')
	          ),
	          _react2['default'].createElement(
	            'li',
	            null,
	            _('Use your Remote Control if you have it set up!')
	          )
	        )
	      )
	    }];
	  }
	
	  _createClass(Onboarding, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var step = this.state.step;
	      var hideHUD = this.context.hideHUD;
	
	      if (step === 0) {
	        hideHUD();
	      }
	    }
	  }, {
	    key: 'nextStep',
	    value: function nextStep(evt) {
	      evt.stopPropagation();
	      evt.preventDefault();
	      var step = this.state.step;
	
	      if (step === this.steps.length - 1) {
	        return this.done(evt);
	      }
	      if (this.steps[step].action) {
	        this.steps[step].action();
	      }
	      this.setState({ step: step + 1, wait: true });
	      var self = this;
	      setTimeout(function () {
	        self.setState({ wait: false });
	      }, this.steps[step].delayAfter || 0);
	    }
	  }, {
	    key: 'skipOnboarding',
	    value: function skipOnboarding(evt) {
	      evt.stopPropagation();
	      evt.preventDefault();
	      var _context = this.context;
	      var userId = _context.userId;
	      var updateOnboardingState = _context.updateOnboardingState;
	      var sessionId = _context.sessionId;
	
	      updateOnboardingState(userId, 'dismissed', sessionId);
	    }
	  }, {
	    key: 'done',
	    value: function done(evt) {
	      evt.stopPropagation();
	      evt.preventDefault();
	      var _context2 = this.context;
	      var userId = _context2.userId;
	      var updateOnboardingState = _context2.updateOnboardingState;
	      var sessionId = _context2.sessionId;
	
	      updateOnboardingState(userId, 'completed', sessionId);
	    }
	  }, {
	    key: '_generateStep',
	    value: function _generateStep() {
	      var _state = this.state;
	      var wait = _state.wait;
	      var step = _state.step;
	
	      if (wait) return null;
	      var _context3 = this.context;
	      var deckRefs = _context3.deckState.refs;
	      var _ = _context3.i18n;
	
	      var stepData = this.steps[step];
	      var highlight = stepData.highlight;
	      var attachmentPoint = stepData.attachmentPoint;
	
	      var hlTop = 0;
	      var hlLeft = 0;
	      var hlXRadius = 0;
	      var hlYRadius = 0;
	      if (highlight && deckRefs && deckRefs[highlight]) {
	        var highlightRef = deckRefs[highlight];
	        var boundingClientRect = highlightRef.getBoundingClientRect();
	        hlTop = boundingClientRect.top - 5;
	        hlLeft = boundingClientRect.left - 5;
	        hlXRadius = boundingClientRect.width / 2 + 5;
	        hlYRadius = boundingClientRect.height / 2 + 5;
	      }
	      var text = typeof stepData.text === 'string' ? stepData.text.split('\n').map(function (paragraph, index) {
	        return _react2['default'].createElement(
	          'p',
	          { key: index },
	          paragraph
	        );
	      }) : stepData.text;
	      var emptyTitle = stepData.title ? '' : ' empty-title';
	      return _react2['default'].createElement(
	        'div',
	        { className: 'spectacle-deck' },
	        highlight && _react2['default'].createElement(
	          'svg',
	          { className: 'pointer step-' + step, width: '100%', height: '100%' },
	          _react2['default'].createElement('line', { x1: '50%', y1: '50%', x2: hlLeft + hlXRadius * 2 * attachmentPoint[0],
	            y2: hlTop + hlYRadius * 2 * attachmentPoint[1], strokeWidth: 2 }),
	          _react2['default'].createElement('ellipse', { cx: hlLeft + hlXRadius, cy: hlTop + hlYRadius, rx: hlXRadius, ry: hlYRadius, strokeWidth: 2,
	            fillOpacity: 0.25, onClick: this.nextStep.bind(this) })
	        ),
	        _react2['default'].createElement(
	          'div',
	          { className: 'modal-dialog onboarding-modal', ref: 'box' },
	          _react2['default'].createElement(
	            'div',
	            { className: 'modal-content' },
	            _react2['default'].createElement(
	              'div',
	              { className: 'modal-header' + emptyTitle },
	              _react2['default'].createElement(
	                'h4',
	                { className: 'modal-title' },
	                stepData.title
	              )
	            ),
	            _react2['default'].createElement(
	              'div',
	              { className: 'modal-body' },
	              text,
	              step === 0 && _react2['default'].createElement(
	                'p',
	                null,
	                _react2['default'].createElement(
	                  'button',
	                  { className: 'btn btn-primary', onClick: this.nextStep.bind(this) },
	                  _('Let\'s Go!')
	                ),
	                ' ',
	                _react2['default'].createElement(
	                  'button',
	                  { className: 'btn btn-default', onClick: this.skipOnboarding.bind(this) },
	                  _('No Thanks')
	                )
	              ),
	              step === this.steps.length - 1 && _react2['default'].createElement(
	                'p',
	                null,
	                _react2['default'].createElement(
	                  'a',
	                  { href: '#', onClick: this.nextStep.bind(this) },
	                  _('Great, I\'m all trained up!')
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2['default'].createElement(
	        'div',
	        null,
	        _react2['default'].createElement(
	          'div',
	          { className: 'onboarding' },
	          this._generateStep()
	        ),
	        this.props.children
	      );
	    }
	  }]);
	
	  return Onboarding;
	})(_react.Component);
	
	exports['default'] = Onboarding;
	module.exports = exports['default'];

/***/ }),
/* 1177 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _get = __webpack_require__(8)['default'];
	
	var _inherits = __webpack_require__(5)['default'];
	
	var _createClass = __webpack_require__(6)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(24);
	
	__webpack_require__(2218);
	
	var StartFromLastSlideModal = (function (_Component) {
	  _inherits(StartFromLastSlideModal, _Component);
	
	  function StartFromLastSlideModal() {
	    _classCallCheck(this, StartFromLastSlideModal);
	
	    _get(Object.getPrototypeOf(StartFromLastSlideModal.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(StartFromLastSlideModal, [{
	    key: 'cancel',
	    value: function cancel(evt) {
	      var closeModal = this.props.closeModal;
	
	      closeModal();
	      evt.preventDefault();
	      evt.stopPropagation();
	      evt.nativeEvent.stopPropagation();
	    }
	  }, {
	    key: 'handleFromBeginning',
	    value: function handleFromBeginning(evt) {
	      var startFromBeginning = this.props.startFromBeginning;
	
	      startFromBeginning();
	      evt.preventDefault();
	      evt.stopPropagation();
	      evt.nativeEvent.stopPropagation();
	    }
	  }, {
	    key: 'handleFromLastSlide',
	    value: function handleFromLastSlide(evt) {
	      var startFromLastSlide = this.props.startFromLastSlide;
	
	      startFromLastSlide();
	      evt.preventDefault();
	      evt.stopPropagation();
	      evt.nativeEvent.stopPropagation();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var showModal = _props.showModal;
	      var closeModal = _props.closeModal;
	      var _ = this.context.i18n;
	
	      return _react2['default'].createElement(
	        _reactBootstrap.Modal,
	        { show: showModal, onHide: closeModal, className: 'spectacle-deck start-from-last-slide' },
	        _react2['default'].createElement(_reactBootstrap.Modal.Header, { closeButton: true }),
	        _react2['default'].createElement(
	          _reactBootstrap.Modal.Body,
	          null,
	          _react2['default'].createElement(
	            'h3',
	            null,
	            _('Resume from where you left off?')
	          ),
	          _react2['default'].createElement(
	            'button',
	            {
	              className: 'btn btn-default',
	              onClick: this.handleFromLastSlide.bind(this) },
	            _('Yes, take me to the last slide I was on')
	          ),
	          _react2['default'].createElement(
	            'button',
	            {
	              className: 'btn btn-default',
	              onClick: this.handleFromBeginning.bind(this) },
	            _('No, I want to start from the beginning of the module')
	          )
	        )
	      );
	    }
	  }], [{
	    key: 'propTypes',
	    value: {
	      showModal: _react.PropTypes.bool.isRequired,
	      closeModal: _react.PropTypes.func.isRequired,
	      startFromBeginning: _react.PropTypes.func.isRequired,
	      startFromLastSlide: _react.PropTypes.func.isRequired
	    },
	    enumerable: true
	  }, {
	    key: 'contextTypes',
	    value: {
	      i18n: _react.PropTypes.func.isRequired
	    },
	    enumerable: true
	  }]);
	
	  return StartFromLastSlideModal;
	})(_react.Component);
	
	exports['default'] = StartFromLastSlideModal;
	module.exports = exports['default'];

/***/ }),
/* 1178 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _get = __webpack_require__(8)['default'];
	
	var _inherits = __webpack_require__(5)['default'];
	
	var _createClass = __webpack_require__(6)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _extends = __webpack_require__(7)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(22);
	
	var _redux = __webpack_require__(99);
	
	var _actionsSessionActions = __webpack_require__(72);
	
	var _actionsDeckActions = __webpack_require__(473);
	
	var _actionsProfileActions = __webpack_require__(103);
	
	var _programs = __webpack_require__(69);
	
	var _programs2 = _interopRequireDefault(_programs);
	
	var _spectaclePpa = __webpack_require__(1179);
	
	var _spectaclePpa2 = _interopRequireDefault(_spectaclePpa);
	
	var Presentation = (function (_Component) {
	  _inherits(Presentation, _Component);
	
	  _createClass(Presentation, null, [{
	    key: 'propTypes',
	    value: {
	      params: _react.PropTypes.shape({
	        id: _react.PropTypes.string.isRequired
	      }).isRequired,
	      session: _react.PropTypes.object.isRequired,
	      deckState: _react.PropTypes.object.isRequired,
	      bindSingleSession: _react.PropTypes.func.isRequired,
	      unbind: _react.PropTypes.func.isRequired,
	      showHUD: _react.PropTypes.func.isRequired,
	      hideHUD: _react.PropTypes.func.isRequired,
	      registerHUDRef: _react.PropTypes.func.isRequired,
	      setDeviceRole: _react.PropTypes.func.isRequired,
	      updateOnboardingState: _react.PropTypes.func.isRequired,
	      dispatch: _react.PropTypes.func.isRequired,
	      auth: _react.PropTypes.object.isRequired
	    },
	    enumerable: true
	  }, {
	    key: 'contextTypes',
	    value: {
	      setActiveSession: _react.PropTypes.func.isRequired,
	      i18n: _react.PropTypes.func.isRequired
	    },
	    enumerable: true
	  }]);
	
	  function Presentation(props) {
	    _classCallCheck(this, Presentation);
	
	    _get(Object.getPrototypeOf(Presentation.prototype), 'constructor', this).call(this, props);
	    this.state = {
	      displayLoading: false,
	      displayTimeoutError: false
	    };
	  }
	
	  _createClass(Presentation, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this = this;
	
	      var sessionId = this.props.params.id;
	      this.boundRefs = [];
	      this.props.bindSingleSession(sessionId, this.boundRefs);
	      dataLayer.push({ event: 'hideChatWidget' });
	      setTimeout(function () {
	        if (!_this.isUnmounted) {
	          _this.setState({ displayLoading: true });
	        }
	      }, 2000);
	      setTimeout(function () {
	        if (!_this.isUnmounted) {
	          _this.setState({ displayTimeoutError: true });
	        }
	      }, 10000);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.props.unbind(this.boundRefs);
	      this.isUnmounted = true;
	    }
	  }, {
	    key: 'exitSession',
	    value: function exitSession() {
	      var setActiveSession = this.context.setActiveSession;
	
	      setActiveSession('none');
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var session = _props.session;
	      var params = _props.params;
	      var dispatch = _props.dispatch;
	      var deckState = _props.deckState;
	      var auth = _props.auth;
	      var deviceRole = deckState.deviceRole;
	      var _state = this.state;
	      var displayTimeoutError = _state.displayTimeoutError;
	      var displayLoading = _state.displayLoading;
	      var sessionId = params.id;
	      var _ = this.context.i18n;
	
	      if (!session || !session.programId) {
	        // Could be loading or it might not exist
	        return _react2['default'].createElement(
	          'div',
	          null,
	          displayLoading && !displayTimeoutError && _react2['default'].createElement(
	            'h2',
	            null,
	            _('Loading...')
	          ),
	          displayTimeoutError && _react2['default'].createElement(
	            'div',
	            null,
	            _react2['default'].createElement(
	              'h2',
	              null,
	              _('Unable to load class data')
	            ),
	            _react2['default'].createElement(
	              'button',
	              {
	                className: 'btn btn-sm btn-default',
	                onClick: this.exitSession.bind(this) },
	              _('Exit to Programs')
	            )
	          )
	        );
	      }
	
	      var programId = session.programId;
	      var sessionCurrentLevel = session.currentLevel;
	      var sessionCurrentSlide = session.currentSlide;
	      var sessionCompletedLevel = session.completedLevel;
	      var sessionConfiguration = session.configuration;
	      var contractId = session.contractId;
	      var funding = session.funding;
	
	      var program = _programs2['default'].programLookup[programId];
	      var levels = program.levels;
	      var preload = program.preload;
	      var userId = auth.authData.uid;
	
	      var boundSetVideoState = (0, _redux.bindActionCreators)(function (videoState) {
	        return (0, _actionsSessionActions.setVideoState)({ sessionId: sessionId, videoState: videoState });
	      }, dispatch);
	
	      var boundSetTeamName = (0, _redux.bindActionCreators)(function (team, teamName) {
	        return (0, _actionsSessionActions.setTeamName)({ sessionId: sessionId, team: team, teamName: teamName });
	      }, dispatch);
	
	      var boundSetScore = (0, _redux.bindActionCreators)(function (team, score) {
	        return (0, _actionsSessionActions.setScore)({ sessionId: sessionId, team: team, score: score });
	      }, dispatch);
	
	      var boundSetHackedAnswer = (0, _redux.bindActionCreators)(function (_ref) {
	        var level = _ref.level;
	        var answer = _ref.answer;
	        return (0, _actionsSessionActions.setHackedAnswer)({
	          sessionId: sessionId,
	          level: level,
	          answer: answer
	        });
	      }, dispatch);
	
	      var boundSetMissionReportAnswer = (0, _redux.bindActionCreators)(function (_ref2) {
	        var level = _ref2.level;
	        var questionNumber = _ref2.questionNumber;
	        var question = _ref2.question;
	        var answer = _ref2.answer;
	        var invalid = _ref2.invalid;
	        return (0, _actionsSessionActions.setMissionReportAnswer)({
	          sessionId: sessionId,
	          level: level,
	          questionNumber: questionNumber,
	          question: question,
	          answer: answer,
	          invalid: invalid
	        });
	      }, dispatch);
	
	      var boundSetMode = (0, _redux.bindActionCreators)(function (mode) {
	        return (0, _actionsSessionActions.setMode)({ sessionId: sessionId, mode: mode });
	      }, dispatch);
	
	      var boundSetCurrentLevel = (0, _redux.bindActionCreators)(function (currentLevel) {
	        return (0, _actionsSessionActions.setCurrentLevel)({ sessionId: sessionId, currentLevel: currentLevel });
	      }, dispatch);
	
	      var boundSetCurrentSlide = (0, _redux.bindActionCreators)(function (currentSlide) {
	        return (0, _actionsSessionActions.setCurrentSlide)({ sessionId: sessionId, currentSlide: currentSlide });
	      }, dispatch);
	
	      var noOp = function noOp() {};
	      var isPrepStartSlide = sessionCurrentLevel === 'prep' && sessionCurrentSlide === 'start';
	      var isCurrentLevel = parseInt(sessionCurrentLevel, 10) === (sessionCompletedLevel || 0) + 1;
	      var boundSetLastSlide = isPrepStartSlide || isCurrentLevel ? (0, _redux.bindActionCreators)(function (lastSlide) {
	        return (0, _actionsSessionActions.setLastSlide)({ sessionId: sessionId, lastSlide: lastSlide });
	      }, dispatch) : noOp;
	
	      var boundCompleteLevel = (0, _redux.bindActionCreators)(function (completedLevel, finished) {
	        return (0, _actionsSessionActions.completeLevel)({ sessionId: sessionId, completedLevel: completedLevel, programId: programId, finished: finished, contractId: contractId, userId: userId, funding: funding });
	      }, dispatch);
	
	      var boundSetConfiguration = (0, _redux.bindActionCreators)(function (configuration) {
	        return (0, _actionsSessionActions.setConfiguration)({ sessionId: sessionId, configuration: configuration });
	      }, dispatch);
	
	      var nextLevel = sessionCompletedLevel ? String(Number(sessionCompletedLevel) + 1) : '1';
	      if (!levels[nextLevel]) {
	        nextLevel = 'completed';
	      }
	
	      var deckInterface = null;
	      if (sessionCurrentLevel === 'prep') {
	        deckInterface = 'classroomDisplay';
	      } else {
	        if (sessionConfiguration === 'singleScreen') {
	          deckInterface = 'classroomDisplay';
	        } else if (sessionConfiguration === 'dualScreen') {
	          deckInterface = deviceRole;
	        }
	      }
	
	      if (!deckInterface) {
	        deckInterface = 'classroomDisplay';
	      }
	
	      return _react2['default'].createElement(_spectaclePpa2['default'], _extends({}, this.props, {
	        program: program,
	        session: session,
	        sessionId: sessionId,
	        nextLevel: nextLevel,
	        setVideoState: boundSetVideoState,
	        setTeamName: boundSetTeamName,
	        setScore: boundSetScore,
	        setMissionReportAnswer: boundSetMissionReportAnswer,
	        setHackedAnswer: boundSetHackedAnswer,
	        setMode: boundSetMode,
	        setCurrentLevel: boundSetCurrentLevel,
	        setCurrentSlide: boundSetCurrentSlide,
	        setLastSlide: boundSetLastSlide,
	        completeLevel: boundCompleteLevel,
	        setConfiguration: boundSetConfiguration,
	        deckInterface: deckInterface,
	        preload: preload }));
	    }
	  }]);
	
	  return Presentation;
	})(_react.Component);
	
	exports['default'] = (0, _reactRedux.connect)(function (state, ownProps) {
	  var deck = state.deck;
	  var auth = state.auth;
	  var id = ownProps.params.id;
	
	  var session = state.sessions.sessions[id];
	  return {
	    session: _extends({}, session),
	    deckState: _extends({}, deck),
	    auth: _extends({}, auth)
	  };
	}, function (dispatch) {
	  return {
	    bindSingleSession: (0, _redux.bindActionCreators)(_actionsSessionActions.bindSingleSession, dispatch),
	    unbind: (0, _redux.bindActionCreators)(_actionsSessionActions.unbind, dispatch),
	    showHUD: (0, _redux.bindActionCreators)(_actionsDeckActions.showHUD, dispatch),
	    hideHUD: (0, _redux.bindActionCreators)(_actionsDeckActions.hideHUD, dispatch),
	    setDeviceRole: (0, _redux.bindActionCreators)(_actionsDeckActions.setDeviceRole, dispatch),
	    updateOnboardingState: (0, _redux.bindActionCreators)(_actionsProfileActions.updateOnboardingState, dispatch),
	    registerHUDRef: (0, _redux.bindActionCreators)(_actionsDeckActions.registerHUDRef, dispatch),
	    dispatch: dispatch
	  };
	})(Presentation);
	module.exports = exports['default'];

/***/ }),
/* 1179 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _get = __webpack_require__(8)['default'];
	
	var _inherits = __webpack_require__(5)['default'];
	
	var _createClass = __webpack_require__(6)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _srcUtilsContext = __webpack_require__(1185);
	
	var _srcUtilsContext2 = _interopRequireDefault(_srcUtilsContext);
	
	var _alt = __webpack_require__(461);
	
	var _alt2 = _interopRequireDefault(_alt);
	
	var _jimpickSpectacleSrcFluxAlt = __webpack_require__(963);
	
	var _jimpickSpectacleSrcFluxAlt2 = _interopRequireDefault(_jimpickSpectacleSrcFluxAlt);
	
	__webpack_require__(2230);
	
	var flux = new _jimpickSpectacleSrcFluxAlt2['default']();
	_alt2['default'].debug('flux', flux);
	
	var Spectacle = (function (_Component) {
	  _inherits(Spectacle, _Component);
	
	  function Spectacle() {
	    _classCallCheck(this, Spectacle);
	
	    _get(Object.getPrototypeOf(Spectacle.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(Spectacle, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      var params = this.props.params;
	      var _context = this.context;
	      var levels = _context.program.levels;
	      var currentLevel = _context.session.currentLevel;
	
	      var levelId = params.levelId || currentLevel || '1';
	      var level = levels[levelId];
	      return {
	        levelId: levelId,
	        level: level,
	        params: params
	      };
	    }
	  }, {
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _props = this.props;
	      var deckInterface = _props.deckInterface;
	      var preload = _props.preload;
	      var currentLevel = this.context.session.currentLevel;
	
	      if (deckInterface === 'classroomDisplay') {
	        preload({ level: currentLevel });
	      }
	    }
	  }, {
	    key: 'exitSession',
	    value: function exitSession() {
	      var setActiveSession = this.context.setActiveSession;
	
	      setActiveSession('none');
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props;
	      var params = _props2.params;
	      var nextLevel = _props2.nextLevel;
	      var _context2 = this.context;
	      var levels = _context2.program.levels;
	      var _context2$session = _context2.session;
	      var configuration = _context2$session.configuration;
	      var currentLevel = _context2$session.currentLevel;
	
	      var levelId = params.levelId || currentLevel || '1';
	      var level = levels[levelId];
	      if (!level) {
	        return _react2['default'].createElement(
	          'div',
	          null,
	          _react2['default'].createElement(
	            'h2',
	            null,
	            'Unable to load data'
	          ),
	          _react2['default'].createElement(
	            'button',
	            {
	              className: 'btn btn-sm btn-default',
	              onClick: this.exitSession.bind(this) },
	            'Exit to Programs'
	          )
	        );
	      }
	      var Deck = level.deck;
	
	      return _react2['default'].createElement(Deck, { nextLevel: nextLevel, configuration: configuration });
	    }
	  }], [{
	    key: 'propTypes',
	    value: {
	      params: _react.PropTypes.object.isRequired,
	      nextLevel: _react.PropTypes.string,
	      deckInterface: _react.PropTypes.string.isRequired,
	      preload: _react.PropTypes.func.isRequired
	    },
	    enumerable: true
	  }, {
	    key: 'contextTypes',
	    value: {
	      location: _react.PropTypes.object,
	      program: _react.PropTypes.object,
	      presenter: _react.PropTypes.bool,
	      setActiveSession: _react.PropTypes.func.isRequired,
	      session: _react.PropTypes.object
	    },
	    enumerable: true
	  }, {
	    key: 'childContextTypes',
	    value: {
	      levelId: _react.PropTypes.string,
	      level: _react.PropTypes.object,
	      params: _react.PropTypes.object
	    },
	    enumerable: true
	  }]);
	
	  return Spectacle;
	})(_react.Component);
	
	var SpectacleContext = (0, _srcUtilsContext2['default'])(Spectacle, {
	  flux: flux
	});
	
	exports['default'] = SpectacleContext;
	module.exports = exports['default'];

/***/ }),
/* 1180 */
/***/ (function(module, exports, __webpack_require__) {

	/* eslint new-cap:0 */
	
	'use strict';
	
	var _get = __webpack_require__(8)['default'];
	
	var _inherits = __webpack_require__(5)['default'];
	
	var _createClass = __webpack_require__(6)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _extends = __webpack_require__(7)['default'];
	
	var _Object$keys = __webpack_require__(32)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactAddonsTransitionGroup = __webpack_require__(350);
	
	var _reactAddonsTransitionGroup2 = _interopRequireDefault(_reactAddonsTransitionGroup);
	
	var _objectAssign = __webpack_require__(185);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _radium = __webpack_require__(144);
	
	var _radium2 = _interopRequireDefault(_radium);
	
	var _viewsHudTeacherRemoteTeacherRemote = __webpack_require__(1167);
	
	var _viewsHudTeacherRemoteTeacherRemote2 = _interopRequireDefault(_viewsHudTeacherRemoteTeacherRemote);
	
	var _viewsHudTeacherRemoteHud = __webpack_require__(1165);
	
	var _viewsHudTeacherRemoteHud2 = _interopRequireDefault(_viewsHudTeacherRemoteHud);
	
	var _componentsOnboarding = __webpack_require__(1176);
	
	var _componentsOnboarding2 = _interopRequireDefault(_componentsOnboarding);
	
	var _componentsNextSlideConfirmationModal = __webpack_require__(1175);
	
	var _componentsNextSlideConfirmationModal2 = _interopRequireDefault(_componentsNextSlideConfirmationModal);
	
	var _lodash = __webpack_require__(65);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	__webpack_require__(2221);
	
	var Style = _radium2['default'].Style;
	var TransitionGroup = (0, _radium2['default'])(_reactAddonsTransitionGroup2['default']);
	var enableOnboarding = true;
	
	var Deck = (function (_Component) {
	  _inherits(Deck, _Component);
	
	  function Deck(props) {
	    _classCallCheck(this, _Deck);
	
	    _get(Object.getPrototypeOf(_Deck.prototype), 'constructor', this).call(this, props);
	    this._handleKeyPress = this._handleKeyPress.bind(this);
	    this._toggleHUD = this._toggleHUD.bind(this);
	    this._getDeckHeight = this._getDeckHeight.bind(this);
	    this._togglePresenterMode = this._togglePresenterMode.bind(this);
	    this.state = {
	      lastSlide: null,
	      hideCursor: false
	    };
	    this.oldPath = null;
	  }
	
	  _createClass(Deck, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      return {
	        togglePresenterMode: this._togglePresenterMode
	      };
	    }
	  }, {
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this._createTOC(this.props);
	      var _context = this.context;
	      var mode = _context.mode;
	      var displayHUD = _context.deckState.displayHUD;
	      var showHUD = _context.showHUD;
	
	      if (mode && !displayHUD) {
	        showHUD();
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this = this;
	
	      setTimeout(function () {
	        _this._getDeckHeight();
	      }, 0);
	      this._attachEvents();
	      this.cursorTimerCount = 0;
	      this.cursorInterval = setInterval(this.cursorTimerCheck.bind(this), 1000);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps, nextContext) {
	      var _this2 = this;
	
	      this._createTOC(nextProps);
	      var params = nextContext.params;
	      var session = nextContext.session;
	      var deckState = nextContext.deckState;
	      var showHUD = nextContext.showHUD;
	      var hideHUD = nextContext.hideHUD;
	      var history = nextContext.history;
	      var levelId = nextContext.levelId;
	      var paramsSlide = params.slide;
	      var mode = session.mode;
	      var displayHUD = deckState.displayHUD;
	
	      if (mode && !displayHUD) {
	        showHUD();
	      }
	
	      if (session) {
	        var lastSlide = session.lastSlide;
	        var currentSlide = session.currentSlide;
	        var currentLevel = session.currentLevel;
	        var completedLevel = session.completedLevel;
	
	        var slide = this._getSlideIndex();
	        this.setState({
	          lastSlide: slide
	        });
	        if (!currentSlide) {
	          if (lastSlide && currentLevel !== 'prep' && parseInt(currentLevel, 10) === (completedLevel || 0) + 1) {
	            nextContext.setCurrentSlide(lastSlide);
	          } else if (levelId === currentLevel) {
	            this._firstSlide();
	          }
	        } else if (!currentLevel) {
	          this._setLevel(levelId);
	        } else if (currentSlide && this.context.session.currentLevel && this.context.slide && (String(currentSlide) !== String(this.context.slide) || String(paramsSlide) !== String(currentSlide) || mode !== this.context.session.mode || currentLevel !== this.context.session.currentLevel || levelId !== String(currentLevel))) {
	          (function () {
	            var suffix = mode ? '?mode=' + mode : '';
	            var newPath = _this2._getMountPoint() + currentSlide + suffix;
	            if (newPath !== _this2.oldPath) {
	              setTimeout(function () {
	                history.replaceState(null, newPath);
	              }, 0);
	            }
	            if (!mode && _this2.context.session.mode) {
	              hideHUD();
	            }
	            _this2.oldPath = newPath;
	          })();
	        }
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this._detachEvents();
	      clearInterval(this.cursorInterval);
	    }
	  }, {
	    key: 'cursorTimerCheck',
	    value: function cursorTimerCheck() {
	      var hideCursor = this.state.hideCursor;
	
	      // If mouse hasn't been moved for 10 seconds, then hide it
	
	      this.cursorTimerCount++;
	      if (this.cursorTimerCount > 10 && !hideCursor) {
	        this.setState({
	          hideCursor: true
	        });
	      }
	    }
	  }, {
	    key: 'mouseMove',
	    value: function mouseMove() {
	      this.cursorTimerCount = 0;
	      this.setState({
	        hideCursor: false
	      });
	    }
	  }, {
	    key: '_mapChildren',
	    value: function _mapChildren(prefix, children) {
	      var _this3 = this;
	
	      var numericId = 0;
	      var childrenArray = _react.Children.toArray(children);
	      var entries = childrenArray.map(function (child) {
	        numericId++;
	        var id = prefix + (child.props.id ? child.props.id : numericId);
	        if (child.type.displayName === 'Slide') {
	          return {
	            id: id,
	            slide: child
	          };
	        } else if (child.type.displayName === 'Section') {
	          return _this3._mapChildren(id + ':', child.props.children);
	        } else {
	          throw new Error('Unexpected child component');
	        }
	      });
	      return entries;
	    }
	  }, {
	    key: '_createTOC',
	    value: function _createTOC(props) {
	      // Table of Contents
	      var nestedEntries = this._mapChildren('', props.children);
	      var entries = _lodash2['default'].flatten(nestedEntries);
	      this.TOC = entries;
	    }
	  }, {
	    key: '_attachEvents',
	    value: function _attachEvents() {
	      window.addEventListener('keydown', this._handleKeyPress);
	      window.addEventListener('load', this._getDeckHeight);
	      window.addEventListener('resize', this._getDeckHeight);
	    }
	  }, {
	    key: '_detachEvents',
	    value: function _detachEvents() {
	      window.removeEventListener('keydown', this._handleKeyPress);
	      window.removeEventListener('load', this._getDeckHeight);
	      window.removeEventListener('resize', this._getDeckHeight);
	    }
	  }, {
	    key: '_getDeckHeight',
	    value: function _getDeckHeight() {
	      this.setState({
	        deckHeight: window.innerHeight
	      });
	    }
	  }, {
	    key: '_handleKeyPress',
	    value: function _handleKeyPress(evt) {
	      var event = window.event ? window.event : evt;
	      // left, page down
	      if (event.keyCode === 37 || event.keyCode === 33) {
	        this._prevSlide();
	      }
	      // right, page up
	      if (event.keyCode === 39 || event.keyCode === 34) {
	        this._nextSlide();
	      }
	      // return/enter
	      if (event.keyCode === 13) {
	        this._toggleHUD();
	      }
	      /*
	      if (event.keyCode === 80 && !event.ctrlKey && !event.metaKey) { // o
	        this._togglePresenterMode();
	      }
	      */
	    }
	  }, {
	    key: '_getTouchEvents',
	    value: function _getTouchEvents() {
	      var self = this;
	
	      return {
	        onTouchStart: function onTouchStart(evt) {
	          self.touchObject = {
	            startX: evt.touches[0].pageX,
	            startY: evt.touches[0].pageY
	          };
	        },
	        onTouchMove: function onTouchMove(evt) {
	          var direction = self._swipeDirection({
	            x1: self.touchObject.startX,
	            x2: evt.touches[0].pageX,
	            y1: self.touchObject.startY,
	            y2: evt.touches[0].pageY
	          });
	
	          self.touchObject = {
	            startX: self.touchObject.startX,
	            startY: self.touchObject.startY,
	            endX: evt.clientX,
	            endY: evt.clientY,
	            length: Math.round(Math.sqrt(Math.pow(evt.touches[0].pageX - self.touchObject.startX, 2))),
	            direction: direction
	          };
	
	          if (direction !== 0) {
	            evt.preventDefault();
	          }
	        },
	        onTouchEnd: function onTouchEnd(evt) {
	          self._handleSwipe(evt);
	        },
	        onTouchCancel: function onTouchCancel(evt) {
	          self._handleSwipe(evt);
	        }
	      };
	    }
	  }, {
	    key: '_handleSwipe',
	    value: function _handleSwipe() {
	      if (typeof this.touchObject.length !== 'undefined' && this.touchObject.length > 44) {
	        this.clickSafe = true;
	      } else {
	        this.clickSafe = false;
	      }
	
	      if (Math.abs(this.touchObject.length) > 20) {
	        if (this.touchObject.direction === 1) {
	          this._nextSlide();
	        } else if (this.touchObject.direction === -1) {
	          this._prevSlide();
	        }
	      }
	
	      this.touchObject = {};
	    }
	  }, {
	    key: '_swipeDirection',
	    value: function _swipeDirection(touch) {
	      var xDist = touch.x1 - touch.x2;
	      var yDist = touch.y1 - touch.y2;
	      var radians = Math.atan2(yDist, xDist);
	      var swipeAngle = Math.round(radians * 180 / Math.PI);
	
	      if (swipeAngle < 0) {
	        swipeAngle = 360 - Math.abs(swipeAngle);
	      }
	      if (swipeAngle <= 45 && swipeAngle >= 0) {
	        return 1;
	      }
	      if (swipeAngle <= 360 && swipeAngle >= 315) {
	        return 1;
	      }
	      if (swipeAngle >= 135 && swipeAngle <= 225) {
	        return -1;
	      }
	
	      return 0;
	    }
	  }, {
	    key: '_togglePresenterMode',
	    value: function _togglePresenterMode() {
	      var _context2 = this.context;
	      var presenter = _context2.presenter;
	      var history = _context2.history;
	      var slide = _context2.slide;
	
	      var suffix = presenter ? '' : '?presenter';
	      var mountPoint = this._getMountPoint();
	      history.replaceState(null, mountPoint + slide + suffix);
	    }
	  }, {
	    key: '_getMountPoint',
	    value: function _getMountPoint() {
	      var _context3 = this.context;
	      var sessionId = _context3.sessionId;
	      var currentLevel = _context3.session.currentLevel;
	
	      return '/class/' + sessionId + '/content/' + currentLevel + '/';
	    }
	  }, {
	    key: '_firstSlide',
	    value: function _firstSlide() {
	      if (this.TOC.length === 0) return;
	      var _context4 = this.context;
	      var setCurrentSlide = _context4.setCurrentSlide;
	      var setLastSlide = _context4.setLastSlide;
	
	      var slideId = this._getHash(0);
	      setLastSlide(slideId);
	      setCurrentSlide(slideId);
	    }
	  }, {
	    key: '_setLevel',
	    value: function _setLevel(levelId) {
	      var setCurrentLevel = this.context.setCurrentLevel;
	
	      setCurrentLevel(levelId);
	    }
	  }, {
	    key: '_stopPropagation',
	    value: function _stopPropagation(evt) {
	      if (evt) {
	        evt.preventDefault();
	        evt.stopPropagation();
	        evt.nativeEvent.stopPropagation();
	      }
	    }
	  }, {
	    key: '_prevSlide',
	    value: function _prevSlide(evt) {
	      var _context5 = this.context;
	      var setCurrentSlide = _context5.setCurrentSlide;
	      var setLastSlide = _context5.setLastSlide;
	
	      var slide = this._getSlideIndex();
	      this._stopPropagation(evt);
	      this.setState({
	        lastSlide: slide
	      });
	      if (slide > 0) {
	        var slideId = this._getHash(slide - 1);
	        setLastSlide(slideId);
	        setCurrentSlide(slideId);
	      }
	    }
	  }, {
	    key: '_nextSlide',
	    value: function _nextSlide(evt) {
	      this._stopPropagation(evt);
	      return this.__nextSlide();
	    }
	  }, {
	    key: '__nextSlide',
	    value: function __nextSlide(force) {
	      var _context6 = this.context;
	      var setCurrentSlide = _context6.setCurrentSlide;
	      var setLastSlide = _context6.setLastSlide;
	      var _ = _context6.i18n;
	
	      var slide = this._getSlideIndex();
	      this.setState({
	        lastSlide: slide
	      });
	      if (!force && this.TOC[slide].id === 'mission-report:report') {
	        var _context$session = this.context.session;
	        var missionReports = _context$session.missionReports;
	        var completedLevel = _context$session.completedLevel;
	        var currentLevel = _context$session.currentLevel;
	
	        var missionReport = missionReports && missionReports['L' + currentLevel];
	        if (!missionReport || this._hasEmptyOrInvalidAnswer(missionReport)) {
	          this.setState({ nextSlideConfirmationModal: {
	              title: _('Mission Report'),
	              message: _('Please fill out the Mission Report, as it helps us share the impact of the program with our funders!'),
	              cancelBtnMessage: _('OK'),
	              continueBtnMessage: _('I\'m just previewing')
	            } });
	          return;
	        }
	        var _currentLevel = parseInt(currentLevel, 10);
	        var isNotCompleted = completedLevel < _currentLevel;
	        var isLastLevel = this.context.program.levels[_currentLevel + 1] === undefined;
	        console.log(isNotCompleted, isLastLevel);
	        if (isNotCompleted && isLastLevel) {
	          this.context.completeLevel(currentLevel, true);
	        }
	      }
	      if (slide < this.TOC.length - 1) {
	        var slideId = this._getHash(slide + 1);
	        setLastSlide(slideId);
	        setCurrentSlide(slideId);
	      }
	    }
	  }, {
	    key: '_hasEmptyOrInvalidAnswer',
	    value: function _hasEmptyOrInvalidAnswer(missionReport) {
	      return _Object$keys(missionReport).some(function (k) {
	        return missionReport[k].invalid || typeof missionReport[k].answer !== 'number';
	      });
	    }
	  }, {
	    key: '_getHash',
	    value: function _getHash(slide) {
	      return this.TOC[slide].id;
	    }
	  }, {
	    key: '_toggleHUD',
	    value: function _toggleHUD(evt) {
	      this._stopPropagation(evt);
	      var _context7 = this.context;
	      var deckState = _context7.deckState;
	      var showHUD = _context7.showHUD;
	      var hideHUD = _context7.hideHUD;
	      var displayHUD = deckState.displayHUD;
	
	      if (displayHUD) {
	        hideHUD();
	      } else {
	        showHUD();
	      }
	    }
	  }, {
	    key: '_getSlideIndexForSlideId',
	    value: function _getSlideIndexForSlideId(slideId) {
	      var index = _lodash2['default'].findIndex(this.TOC, function (entry) {
	        return String(entry.id) === String(slideId);
	      });
	      return index >= 0 ? index : 0;
	    }
	  }, {
	    key: '_getSlideIndex',
	    value: function _getSlideIndex() {
	      return this._getSlideIndexForSlideId(this.context.slide);
	    }
	  }, {
	    key: '_renderSlide',
	    value: function _renderSlide() {
	      var slide = this._getSlideIndex();
	      var child = this.TOC[slide].slide;
	      return _react2['default'].cloneElement(child, {
	        key: 'slide ' + slide,
	        hash: this.context.slide,
	        currentSlide: this.context.slide,
	        slideIndex: slide,
	        lastSlide: this.state.lastSlide,
	        transition: child.props.transition.length ? child.props.transition : this.props.transition,
	        transitionDuration: child.props.transition.transitionDuration ? child.props.transitionDuration : this.props.transitionDuration,
	        getSlideIndexForSlideId: this._getSlideIndexForSlideId.bind(this)
	      });
	    }
	  }, {
	    key: 'handleNextSlideConfirmation',
	    value: function handleNextSlideConfirmation(_continue) {
	      this.setState({ nextSlideConfirmationModal: null });
	      if (_continue) this.__nextSlide(true);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _context8 = this.context;
	      var session = _context8.session;
	      var location = _context8.location;
	      var deckState = _context8.deckState;
	      var setMode = _context8.setMode;
	      var program = _context8.program;
	      var mode = session.mode;
	      var currentLevel = session.currentLevel;
	      var displayHUDDeckState = deckState.displayHUD;
	
	      var displayHUD = currentLevel === 'prep' ? false : displayHUDDeckState;
	      var displayHUDToggle = currentLevel !== 'prep';
	      var displayArrows = currentLevel === 'prep' ? true : displayHUD;
	      var displayExit = currentLevel === 'prep';
	      var _state = this.state;
	      var deckHeight = _state.deckHeight;
	      var hideCursor = _state.hideCursor;
	
	      var slide = this._getSlideIndex();
	      var styles = {
	        showControls: {
	          position: 'absolute',
	          color: 'white',
	          fontSize: '14px',
	          padding: '5px',
	          opacity: displayHUD ? 0 : 1,
	          transition: 'opacity 0.4s ease-in'
	        },
	        deck: {
	          backgroundColor: this.context.presenter ? 'black' : this.props.bgColor,
	          color: 'white',
	          position: 'absolute',
	          top: 0,
	          left: 0,
	          width: '100%',
	          height: '100vh',
	          cursor: hideCursor ? 'none' : 'default',
	          overflow: 'hidden'
	        },
	        transition: {
	          height: '100vh',
	          width: '100%',
	          perspective: 1000,
	          transformStyle: 'flat'
	        }
	      };
	
	      var componentToRender = undefined;
	      if (this.context.presenter) {
	        componentToRender = _react2['default'].createElement(_viewsHudTeacherRemoteTeacherRemote2['default'], { slides: this.props.children,
	          slide: this._getSlideIndex(),
	          TOC: this.TOC,
	          prevSlide: this._prevSlide.bind(this),
	          nextSlide: this._nextSlide.bind(this),
	          getHash: this._getHash.bind(this) });
	        /*
	        <Progress
	          items={this.TOC}
	          currentSlide={this._getSlideIndex()}
	          type={this.props.progress} />
	        */
	      } else {
	          componentToRender = _react2['default'].createElement(
	            'div',
	            {
	              className: 'deck-fullscreen',
	              style: styles.deck },
	            _react2['default'].createElement(_viewsHudTeacherRemoteHud2['default'], {
	              slide: slide,
	              displayHUD: displayHUD,
	              displayHUDToggle: displayHUDToggle,
	              displayArrows: displayArrows,
	              displayExit: displayExit,
	              pathname: location.pathname,
	              TOC: this.TOC,
	              currentSlide: this._getSlideIndex(),
	              progressType: this.props.progress,
	              prevSlide: this._prevSlide.bind(this),
	              nextSlide: this._nextSlide.bind(this),
	              mode: mode,
	              deckHeight: deckHeight,
	              setMode: setMode }),
	            _react2['default'].createElement(
	              TransitionGroup,
	              {
	                className: 'deck-slide-transition-group',
	                component: 'div',
	                style: [styles.transition] },
	              this._renderSlide()
	            )
	          );
	        }
	
	      var programId = program.id;
	
	      var wrappedComponent = _react2['default'].createElement(
	        'div',
	        _extends({
	          className: programId + ' deck-level-' + currentLevel + ' spectacle-deck',
	          style: [styles.deck],
	          onClick: this._toggleHUD,
	          onMouseMove: this.mouseMove.bind(this)
	        }, this._getTouchEvents()),
	        componentToRender,
	        this.state.nextSlideConfirmationModal && _react2['default'].createElement(_componentsNextSlideConfirmationModal2['default'], {
	          showModal: true,
	          closeModal: this.handleNextSlideConfirmation.bind(this),
	          title: this.state.nextSlideConfirmationModal.title,
	          message: this.state.nextSlideConfirmationModal.message,
	          cancelBtnMessage: this.state.nextSlideConfirmationModal.cancelBtnMessage,
	          continueBtnMessage: this.state.nextSlideConfirmationModal.continueBtnMessage }),
	        _react2['default'].createElement(Style, { rules: (0, _objectAssign2['default'])(this.context.styles.global, {}) })
	      );
	
	      var _context9 = this.context;
	      var onboarding = _context9.profile.onboarding;
	      var presenter = _context9.presenter;
	
	      if (enableOnboarding && currentLevel !== 'prep' && !onboarding && !presenter) {
	        return _react2['default'].createElement(
	          _componentsOnboarding2['default'],
	          null,
	          wrappedComponent
	        );
	      }
	      return wrappedComponent;
	    }
	  }]);
	
	  var _Deck = Deck;
	  Deck = (0, _radium2['default'])(Deck) || Deck;
	  return Deck;
	})(_react.Component);
	
	Deck.displayName = 'Deck';
	
	Deck.defaultProps = {
	  transitionDuration: 500,
	  progress: 'pacman'
	};
	
	Deck.propTypes = {
	  children: _react.PropTypes.node,
	  transition: _react.PropTypes.array,
	  transitionDuration: _react.PropTypes.number,
	  progress: _react.PropTypes.oneOf(['pacman', 'bar', 'number', 'none']),
	  bgColor: _react.PropTypes.string
	};
	
	Deck.contextTypes = {
	  styles: _react.PropTypes.object,
	  flux: _react.PropTypes.object,
	  history: _react.PropTypes.object,
	  location: _react.PropTypes.object,
	  presenter: _react.PropTypes.bool,
	  slide: _react.PropTypes.string,
	  session: _react.PropTypes.object,
	  sessionId: _react.PropTypes.string,
	  deckState: _react.PropTypes.object,
	  showHUD: _react.PropTypes.func,
	  hideHUD: _react.PropTypes.func,
	  setMode: _react.PropTypes.func,
	  setCurrentLevel: _react.PropTypes.func,
	  setCurrentSlide: _react.PropTypes.func,
	  setLastSlide: _react.PropTypes.func,
	  levelId: _react.PropTypes.string,
	  level: _react.PropTypes.object,
	  params: _react.PropTypes.object,
	  program: _react.PropTypes.object,
	  profile: _react.PropTypes.object,
	  completeLevel: _react.PropTypes.func,
	  i18n: _react.PropTypes.func
	};
	
	Deck.childContextTypes = {
	  togglePresenterMode: _react.PropTypes.func
	};
	
	exports['default'] = Deck;
	module.exports = exports['default'];

/***/ }),
/* 1181 */
/***/ (function(module, exports, __webpack_require__) {

	/* eslint func-names: 0 */
	
	'use strict';
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jimpickReactFullscreenComponent = __webpack_require__(927);
	
	var _jimpickReactFullscreenComponent2 = _interopRequireDefault(_jimpickReactFullscreenComponent);
	
	var FullScreen = _react2['default'].createClass({
	  displayName: 'FullScreen',
	
	  propTypes: {
	    children: _react2['default'].PropTypes.node,
	    style: _react2['default'].PropTypes.object
	  },
	  mixins: [_jimpickReactFullscreenComponent2['default']],
	  componentDidMount: function componentDidMount() {
	    try {
	      this.requestFullscreen(document.body);
	    } catch (error) {
	      // console.log('RequestFullscreen', error);
	    }
	  },
	  render: function render() {
	    return _react2['default'].createElement(
	      'div',
	      { style: this.props.style, ref: 'container' },
	      this.props.children
	    );
	  }
	});
	
	exports['default'] = FullScreen;
	module.exports = exports['default'];

/***/ }),
/* 1182 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var Section = _react2['default'].createClass({
	  displayName: 'Section',
	  render: function render() {
	    return null;
	  }
	});
	
	exports['default'] = Section;
	module.exports = exports['default'];

/***/ }),
/* 1183 */
/***/ (function(module, exports, __webpack_require__) {

	/* global window */
	
	'use strict';
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(20);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactTweenState = __webpack_require__(376);
	
	var _reactTweenState2 = _interopRequireDefault(_reactTweenState);
	
	var _jimpickSpectacleSrcBase = __webpack_require__(27);
	
	var _jimpickSpectacleSrcBase2 = _interopRequireDefault(_jimpickSpectacleSrcBase);
	
	var _transitions = __webpack_require__(1184);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _jimpickSpectaclePresentationConfig = __webpack_require__(464);
	
	var _jimpickSpectaclePresentationConfig2 = _interopRequireDefault(_jimpickSpectaclePresentationConfig);
	
	var _radium = __webpack_require__(144);
	
	var _radium2 = _interopRequireDefault(_radium);
	
	var Slide = _react2['default'].createClass({
	  displayName: 'Slide',
	  propTypes: {
	    align: _react.PropTypes.string,
	    hash: _react.PropTypes.string,
	    presenterStyle: _react.PropTypes.object,
	    children: _react.PropTypes.node,
	    notes: _react.PropTypes.string,
	    slideIndex: _react.PropTypes.number,
	    lastSlide: _react.PropTypes.number,
	    finish: _react.PropTypes.bool,
	    teamNames: _react.PropTypes.bool,
	    missionReportQuestions: _react.PropTypes.array
	  },
	  contextTypes: {
	    styles: _react.PropTypes.object,
	    'export': _react.PropTypes.bool,
	    print: _react.PropTypes.bool,
	    overview: _react.PropTypes.bool,
	    flux: _react.PropTypes.object,
	    slide: _react.PropTypes.string,
	    presenter: _react.PropTypes.bool
	  },
	  mixins: [_reactTweenState2['default'].Mixin, _jimpickSpectacleSrcBase2['default'].Mixin, _transitions2['default']],
	  getDefaultProps: function getDefaultProps() {
	    return {
	      align: 'center center',
	      presenterStyle: {}
	    };
	  },
	  getInitialState: function getInitialState() {
	    return {
	      zoom: 1,
	      contentScale: 1
	    };
	  },
	  componentDidMount: function componentDidMount() {
	    var _this = this;
	
	    this.setZoom();
	    var slide = _reactDom2['default'].findDOMNode(this.refs.slide);
	    var frags = slide.querySelectorAll('.fragment');
	    if (frags && frags.length) {
	      Array.prototype.slice.call(frags, 0).forEach(function (frag, index) {
	        frag.dataset.fid = index;
	        _this.context.flux.actions.SlideActions.addFragment({
	          slide: _this.props.hash,
	          id: index,
	          visible: _this.props.lastSlide > _this.props.slideIndex
	        });
	      });
	    }
	    window.addEventListener('load', this.setZoom);
	    window.addEventListener('resize', this.setZoom);
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    window.removeEventListener('resize', this.setZoom);
	  },
	  setZoom: function setZoom() {
	    // const mobile = window.matchMedia('(max-width: 628px)').matches;
	    var content = _reactDom2['default'].findDOMNode(this.refs.content);
	    var zoom = content.offsetWidth / _jimpickSpectaclePresentationConfig2['default'].width;
	    var contentScaleY = content.parentNode.offsetHeight / _jimpickSpectaclePresentationConfig2['default'].height;
	    var contentScaleX = content.parentNode.offsetWidth / _jimpickSpectaclePresentationConfig2['default'].width;
	    var contentScale = Math.min(contentScaleY, contentScaleX);
	    this.setState({
	      zoom: zoom > 0.6 ? zoom : 0.6,
	      contentScale: contentScale < 1 ? contentScale : 1
	    });
	  },
	  render: function render() {
	    var printStyles = this.context.print ? {
	      backgroundColor: 'white',
	      backgroundImage: 'none'
	    } : {};
	    var overViewStyles = {
	      inner: {
	        flexDirection: 'column'
	      },
	      content: {
	        width: '100%'
	      }
	    };
	    var styles = {
	      outer: {
	        position: this.context['export'] ? 'relative' : 'absolute',
	        top: 0,
	        left: 0,
	        width: '100%',
	        height: '100%',
	        display: 'flex',
	        backgroundColor: this.context.styles.global.body.background ? this.context.styles.global.body.background : ''
	      },
	      inner: {
	        display: 'flex',
	        position: 'relative',
	        height: '100%',
	        flex: 1,
	        alignItems: this.props.align ? this.props.align.split(' ')[1] : 'center',
	        justifyContent: this.props.align ? this.props.align.split(' ')[0] : 'center'
	      },
	      content: {
	        flex: 1,
	        display: 'flex',
	        flexDirection: 'column',
	        justifyContent: 'center',
	        height: '100%',
	        // maxHeight: config.height,
	        // maxWidth: config.width,
	        fontSize: 16 * this.state.zoom
	        // transform: 'scale(' + this.state.contentScale + ')',
	        // padding: this.state.zoom > 0.6 ? config.margin : 10
	        // padding: '60px 40px 40px'
	      }
	    };
	    if (this.context.presenter) {
	      styles.content.transform = 'scale(' + this.state.contentScale + ')';
	    }
	    return _react2['default'].createElement(
	      'div',
	      { className: 'spectacle-slide',
	        ref: 'slide',
	        style: [styles.outer, this.getStyles(), this.getTransitionStyles(), printStyles, this.props.presenterStyle] },
	      _react2['default'].createElement(
	        'div',
	        { style: [styles.inner, this.context.overview && overViewStyles.inner] },
	        _react2['default'].createElement(
	          'div',
	          { ref: 'content',
	            className: 'spectacle-content',
	            style: [styles.content, this.context.styles.components.content, this.context.overview && overViewStyles.content] },
	          this.props.children
	        )
	      )
	    );
	  }
	});
	
	exports['default'] = (0, _radium2['default'])(Slide);
	module.exports = exports['default'];

/***/ }),
/* 1184 */
/***/ (function(module, exports, __webpack_require__) {

	/* global setTimeout */
	
	'use strict';
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _objectAssign = __webpack_require__(185);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _reactTweenState = __webpack_require__(376);
	
	var _reactTweenState2 = _interopRequireDefault(_reactTweenState);
	
	exports['default'] = {
	  propTypes: {
	    transition: _react2['default'].PropTypes.array,
	    transitionDuration: _react2['default'].PropTypes.number
	  },
	  contextTypes: {
	    location: _react2['default'].PropTypes.object
	  },
	  getDefaultProps: function getDefaultProps() {
	    return {
	      transition: []
	    };
	  },
	  getInitialState: function getInitialState() {
	    var state = {
	      z: 1
	    };
	
	    if (this.props.transition.indexOf('fade') !== -1) {
	      state.opacity = 1;
	    }
	
	    if (this.props.transition.indexOf('zoom') !== -1) {
	      state.scale = 1;
	    }
	
	    if (this.props.transition.indexOf('slide') !== -1) {
	      state.left = 0;
	    }
	
	    if (this.props.transition.indexOf('spin') !== -1) {
	      state.x = 0;
	    }
	
	    return state;
	  },
	  routerCallback: function routerCallback(cb, immediate) {
	    if (this.props.transition.length > 0 && immediate !== true) {
	      setTimeout(cb, this.props.transitionDuration + 200);
	    } else {
	      cb();
	    }
	  },
	  componentWillEnter: function componentWillEnter(cb) {
	    var _this = this;
	
	    var direction = this.props.slideIndex > this.props.lastSlide;
	
	    this.setState({
	      z: 1
	    }, function () {
	      if (_this.props.transition.indexOf('fade') !== -1) {
	        _this.tweenState('opacity', {
	          easing: _reactTweenState2['default'].easingTypes.easeInOutQuad,
	          duration: _this.props.transitionDuration,
	          beginValue: 0,
	          endValue: 1
	        });
	      }
	
	      if (_this.props.transition.indexOf('zoom') !== -1) {
	        _this.tweenState('scale', {
	          easing: _reactTweenState2['default'].easingTypes.easeInOutQuad,
	          duration: _this.props.transitionDuration,
	          beginValue: 0.1,
	          endValue: 1
	        });
	      }
	
	      if (_this.props.transition.indexOf('slide') !== -1) {
	        _this.tweenState('left', {
	          easing: _reactTweenState2['default'].easingTypes.easeOutQuad,
	          duration: _this.props.transitionDuration,
	          beginValue: direction ? 100 : -100,
	          endValue: 0
	        });
	      }
	
	      if (_this.props.transition.indexOf('spin') !== -1) {
	        _this.tweenState('x', {
	          easing: _reactTweenState2['default'].easingTypes.easeOutQuad,
	          duration: _this.props.transitionDuration,
	          beginValue: direction ? 90 : -90,
	          endValue: 0
	        });
	      }
	    });
	
	    this.routerCallback(cb);
	  },
	  componentWillAppear: function componentWillAppear(cb) {
	    var state = {
	      z: 1
	    };
	
	    if (this.props.transition.indexOf('fade') !== -1) {
	      state.opacity = 1;
	    }
	
	    if (this.props.transition.indexOf('zoom') !== -1) {
	      state.scale = 1;
	    }
	
	    if (this.props.transition.indexOf('slide') !== -1) {
	      state.left = 0;
	    }
	
	    if (this.props.transition.indexOf('spin') !== -1) {
	      state.x = 0;
	    }
	
	    this.setState(state);
	
	    this.routerCallback(cb, true);
	  },
	  componentWillLeave: function componentWillLeave(cb) {
	    var _this2 = this;
	
	    var slide = this.context.slide || 0;
	    var slideIndex = this.props.getSlideIndexForSlideId(slide);
	    var direction = this.props.slideIndex > slideIndex;
	
	    this.setState({
	      z: ''
	    }, function () {
	      if (_this2.props.transition.indexOf('fade') !== -1) {
	        _this2.tweenState('opacity', {
	          easing: _reactTweenState2['default'].easingTypes.easeInOutQuad,
	          duration: _this2.props.transitionDuration,
	          endValue: 0
	        });
	      }
	
	      if (_this2.props.transition.indexOf('zoom') !== -1) {
	        _this2.tweenState('scale', {
	          easing: _reactTweenState2['default'].easingTypes.easeInOutQuad,
	          duration: _this2.props.transitionDuration,
	          endValue: 0.1
	        });
	      }
	
	      if (_this2.props.transition.indexOf('slide') !== -1) {
	        _this2.tweenState('left', {
	          easing: _reactTweenState2['default'].easingTypes.easeOutQuad,
	          duration: _this2.props.transitionDuration,
	          endValue: direction ? 100 : -100
	        });
	      }
	
	      if (_this2.props.transition.indexOf('spin') !== -1) {
	        _this2.tweenState('x', {
	          easing: _reactTweenState2['default'].easingTypes.easeOutQuad,
	          duration: _this2.props.transitionDuration,
	          endValue: direction ? 90 : -90
	        });
	      }
	    });
	
	    this.routerCallback(cb);
	  },
	  getTransitionStyles: function getTransitionStyles() {
	    var transformValue = '';
	    var styles = {
	      zIndex: this.state.z
	    };
	    if (this.props.transition.indexOf('fade') !== -1) {
	      styles = (0, _objectAssign2['default'])(styles, {
	        opacity: this.getTweeningValue('opacity')
	      });
	    }
	    if (this.props.transition.indexOf('zoom') !== -1) {
	      transformValue += ' scale(' + this.getTweeningValue('scale') + ')';
	    }
	    if (this.props.transition.indexOf('slide') !== -1) {
	      transformValue += ' translate3d(' + this.getTweeningValue('left') + '%, 0, 0)';
	    } else {
	      transformValue += ' translate3d(0px, 0px, 0px)';
	    }
	    if (this.props.transition.indexOf('spin') !== -1) {
	      transformValue += ' rotateY(' + this.getTweeningValue('x') + 'deg)';
	    }
	    styles = (0, _objectAssign2['default'])(styles, {
	      transform: transformValue
	    });
	    return styles;
	  }
	};
	module.exports = exports['default'];

/***/ }),
/* 1185 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = __webpack_require__(7)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _helpersI18n = __webpack_require__(14);
	
	var context = function context(Component, params) {
	  var wrapper = _react2['default'].createClass({
	    displayName: 'ContextWrapper',
	    propTypes: {
	      location: _react.PropTypes.object,
	      params: _react.PropTypes.object,
	      history: _react.PropTypes.object,
	      session: _react.PropTypes.object,
	      sessionId: _react.PropTypes.string,
	      program: _react.PropTypes.object,
	      nextLevel: _react.PropTypes.string,
	      setVideoState: _react.PropTypes.func,
	      deckState: _react.PropTypes.object,
	      showHUD: _react.PropTypes.func,
	      hideHUD: _react.PropTypes.func,
	      setDeviceRole: _react.PropTypes.func,
	      setTeamName: _react.PropTypes.func,
	      setScore: _react.PropTypes.func,
	      setMissionReportAnswer: _react.PropTypes.func,
	      setHackedAnswer: _react.PropTypes.func,
	      setMode: _react.PropTypes.func,
	      setCurrentLevel: _react.PropTypes.func,
	      setCurrentSlide: _react.PropTypes.func,
	      setLastSlide: _react.PropTypes.func,
	      completeLevel: _react.PropTypes.func,
	      setConfiguration: _react.PropTypes.func,
	      deckInterface: _react.PropTypes.string,
	      updateOnboardingState: _react.PropTypes.func,
	      registerHUDRef: _react.PropTypes.func
	    },
	    contextTypes: {
	      regionData: _react.PropTypes.object
	    },
	    childContextTypes: {
	      styles: _react.PropTypes.object,
	      flux: _react.PropTypes.object,
	      history: _react.PropTypes.object,
	      location: _react.PropTypes.object,
	      presenter: _react.PropTypes.bool,
	      overview: _react.PropTypes.bool,
	      'export': _react.PropTypes.bool,
	      print: _react.PropTypes.bool,
	      slide: _react.PropTypes.string,
	      session: _react.PropTypes.object,
	      sessionId: _react.PropTypes.string,
	      program: _react.PropTypes.object,
	      nextLevel: _react.PropTypes.string,
	      setVideoState: _react.PropTypes.func,
	      mode: _react.PropTypes.string,
	      deckState: _react.PropTypes.object,
	      showHUD: _react.PropTypes.func,
	      hideHUD: _react.PropTypes.func,
	      setDeviceRole: _react.PropTypes.func,
	      setTeamName: _react.PropTypes.func,
	      setScore: _react.PropTypes.func,
	      setMissionReportAnswer: _react.PropTypes.func,
	      setHackedAnswer: _react.PropTypes.func,
	      setMode: _react.PropTypes.func,
	      setCurrentLevel: _react.PropTypes.func,
	      setCurrentSlide: _react.PropTypes.func,
	      setLastSlide: _react.PropTypes.func,
	      completeLevel: _react.PropTypes.func,
	      setConfiguration: _react.PropTypes.func,
	      deckInterface: _react.PropTypes.string,
	      updateOnboardingState: _react.PropTypes.func,
	      registerHUDRef: _react.PropTypes.func,
	      regionData: _react.PropTypes.object,
	      i18n: _react.PropTypes.func
	    },
	    getChildContext: function getChildContext() {
	      var styles = {};
	      var _props = this.props;
	      var location = _props.location;
	      var session = _props.session;
	      var sessionId = _props.sessionId;
	      var program = _props.program;
	      var nextLevel = _props.nextLevel;
	      var setVideoState = _props.setVideoState;
	      var deckState = _props.deckState;
	      var showHUD = _props.showHUD;
	      var hideHUD = _props.hideHUD;
	      var setDeviceRole = _props.setDeviceRole;
	      var history = _props.history;
	      var setTeamName = _props.setTeamName;
	      var setScore = _props.setScore;
	      var setMissionReportAnswer = _props.setMissionReportAnswer;
	      var setHackedAnswer = _props.setHackedAnswer;
	      var setMode = _props.setMode;
	      var setCurrentLevel = _props.setCurrentLevel;
	      var setCurrentSlide = _props.setCurrentSlide;
	      var setLastSlide = _props.setLastSlide;
	      var completeLevel = _props.completeLevel;
	      var setConfiguration = _props.setConfiguration;
	      var deckInterface = _props.deckInterface;
	      var updateOnboardingState = _props.updateOnboardingState;
	      var registerHUDRef = _props.registerHUDRef;
	      var regionData = this.context.regionData;
	      var config = program.config;
	
	      if (location.query && 'print' in location.query) {
	        styles = config.print;
	      } else {
	        styles = config.theme;
	      }
	      var slide = '1';
	      if (this.props.params && 'slide' in this.props.params) {
	        slide = this.props.params.slide;
	      }
	      return {
	        styles: styles,
	        flux: params.flux,
	        history: history,
	        location: location,
	        presenter: deckInterface === 'remoteControl',
	        overview: location.query && 'overview' in location.query,
	        'export': location.query && 'export' in location.query,
	        print: location.query && 'print' in location.query,
	        slide: slide,
	        session: session,
	        sessionId: sessionId,
	        program: program,
	        nextLevel: nextLevel,
	        setVideoState: setVideoState,
	        deckState: deckState,
	        showHUD: showHUD,
	        hideHUD: hideHUD,
	        setDeviceRole: setDeviceRole,
	        setTeamName: setTeamName,
	        setScore: setScore,
	        setMissionReportAnswer: setMissionReportAnswer,
	        setHackedAnswer: setHackedAnswer,
	        setMode: setMode,
	        setCurrentLevel: setCurrentLevel,
	        setCurrentSlide: setCurrentSlide,
	        setLastSlide: setLastSlide,
	        completeLevel: completeLevel,
	        setConfiguration: setConfiguration,
	        deckInterface: deckInterface,
	        updateOnboardingState: updateOnboardingState,
	        registerHUDRef: registerHUDRef,
	        regionData: _extends({}, regionData, { contractId: session && session.contractId }),
	        i18n: (0, _helpersI18n.i18n)(session.language || _helpersI18n.defaultLanguage)
	      };
	    },
	
	    render: function render() {
	      return _react2['default'].createElement(Component, this.props);
	    }
	  });
	  return wrapper;
	};
	
	exports['default'] = context;
	module.exports = exports['default'];

/***/ }),
/* 1186 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _get = __webpack_require__(8)['default'];
	
	var _inherits = __webpack_require__(5)['default'];
	
	var _createClass = __webpack_require__(6)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _unapprovedSessions = __webpack_require__(1189);
	
	var _unapprovedSessions2 = _interopRequireDefault(_unapprovedSessions);
	
	var _onHoldSessions = __webpack_require__(1187);
	
	var _onHoldSessions2 = _interopRequireDefault(_onHoldSessions);
	
	var _search = __webpack_require__(1188);
	
	var _search2 = _interopRequireDefault(_search);
	
	__webpack_require__(2222);
	
	var styles = {
	  floatLeft: {
	    float: 'left'
	  },
	  sessionsContainer: {
	    clear: 'both'
	  }
	};
	
	var AssignContracts = (function (_Component) {
	  _inherits(AssignContracts, _Component);
	
	  _createClass(AssignContracts, null, [{
	    key: 'propTypes',
	    value: {
	      route: _react.PropTypes.object.isRequired,
	      routeParams: _react.PropTypes.object.isRequired,
	      history: _react.PropTypes.object.isRequired
	    },
	    enumerable: true
	  }]);
	
	  function AssignContracts(props) {
	    _classCallCheck(this, AssignContracts);
	
	    _get(Object.getPrototypeOf(AssignContracts.prototype), 'constructor', this).call(this, props);
	    this.state = {
	      showOnHold: props.route.path === 'onHold'
	    };
	  }
	
	  _createClass(AssignContracts, [{
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      var path = this.props.route.path;
	
	      if (prevProps.route.path !== path && path === 'onHold') {
	        this.setState({ showOnHold: true });
	      }
	      if (prevProps.route.path !== path && !path) {
	        this.setState({ showOnHold: false });
	      }
	    }
	  }, {
	    key: 'showOnHold',
	    value: function showOnHold() {
	      this.props.history.replace('/staff/onHold');
	    }
	  }, {
	    key: 'showNotOnHold',
	    value: function showNotOnHold() {
	      this.props.history.replace('/staff');
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var showOnHold = this.state.showOnHold;
	
	      return _react2['default'].createElement(
	        'div',
	        { className: 'staff assign-contracts' },
	        _react2['default'].createElement(
	          'div',
	          null,
	          _react2['default'].createElement(
	            'h4',
	            { className: 'adminPageTitle' },
	            'Search'
	          ),
	          _react2['default'].createElement(_search2['default'], { history: this.props.history, route: this.props.route, routeParams: this.props.routeParams })
	        ),
	        _react2['default'].createElement(
	          'div',
	          null,
	          _react2['default'].createElement(
	            'a',
	            { onClick: this.showNotOnHold.bind(this) },
	            _react2['default'].createElement(
	              'h4',
	              { className: 'adminPageTitle' + (showOnHold ? '' : ' selected'), style: styles.floatLeft },
	              'Assign Contracts'
	            )
	          ),
	          _react2['default'].createElement(
	            'h4',
	            { className: 'adminPageTitle', style: styles.floatLeft },
	            ' | '
	          ),
	          _react2['default'].createElement(
	            'a',
	            { onClick: this.showOnHold.bind(this) },
	            _react2['default'].createElement(
	              'h4',
	              { className: 'adminPageTitle' + (showOnHold ? ' selected' : ''), style: styles.floatLeft },
	              'On Hold'
	            )
	          ),
	          _react2['default'].createElement(
	            'div',
	            { style: styles.sessionsContainer },
	            showOnHold ? _react2['default'].createElement(_onHoldSessions2['default'], null) : _react2['default'].createElement(_unapprovedSessions2['default'], null)
	          )
	        )
	      );
	    }
	  }]);
	
	  return AssignContracts;
	})(_react.Component);
	
	exports['default'] = AssignContracts;
	module.exports = exports['default'];

/***/ }),
/* 1187 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _get = __webpack_require__(8)["default"];
	
	var _inherits = __webpack_require__(5)["default"];
	
	var _createClass = __webpack_require__(6)["default"];
	
	var _classCallCheck = __webpack_require__(3)["default"];
	
	var _interopRequireDefault = __webpack_require__(2)["default"];
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(22);
	
	var _actionsPaywallActions = __webpack_require__(134);
	
	var _usersByDate = __webpack_require__(485);
	
	var _usersByDate2 = _interopRequireDefault(_usersByDate);
	
	var OnHoldSessions = (function (_Component) {
	  _inherits(OnHoldSessions, _Component);
	
	  _createClass(OnHoldSessions, null, [{
	    key: "propTypes",
	    value: {
	      bindOnHoldSessions: _react.PropTypes.func.isRequired,
	      unbindOnHoldSessions: _react.PropTypes.func.isRequired
	    },
	    enumerable: true
	  }]);
	
	  function OnHoldSessions(props) {
	    _classCallCheck(this, OnHoldSessions);
	
	    _get(Object.getPrototypeOf(OnHoldSessions.prototype), "constructor", this).call(this, props);
	    this.boundOnHoldSessionsRefs = {};
	  }
	
	  _createClass(OnHoldSessions, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.bindOnHoldSessions(this.props);
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.unbindOnHoldSessions();
	    }
	  }, {
	    key: "bindOnHoldSessions",
	    value: function bindOnHoldSessions(props) {
	      var bind = props.bindOnHoldSessions;
	
	      bind(this.boundOnHoldSessionsRefs);
	    }
	  }, {
	    key: "unbindOnHoldSessions",
	    value: function unbindOnHoldSessions() {
	      var unbind = this.props.unbindOnHoldSessions;
	
	      unbind(this.boundOnHoldSessionsRefs);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return _react2["default"].createElement(_usersByDate2["default"], { sessionType: "on hold" });
	    }
	  }]);
	
	  return OnHoldSessions;
	})(_react.Component);
	
	exports["default"] = (0, _reactRedux.connect)(function () {
	  return (/*state*/{}
	  );
	}, {
	  bindOnHoldSessions: _actionsPaywallActions.bindOnHoldSessions,
	  unbindOnHoldSessions: _actionsPaywallActions.unbindOnHoldSessions
	})(OnHoldSessions);
	module.exports = exports["default"];

/***/ }),
/* 1188 */
/***/ (function(module, exports, __webpack_require__) {

	/* eslint no-console: 0 */
	'use strict';
	
	var _extends = __webpack_require__(7)['default'];
	
	var _get = __webpack_require__(8)['default'];
	
	var _inherits = __webpack_require__(5)['default'];
	
	var _createClass = __webpack_require__(6)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _objectWithoutProperties = __webpack_require__(16)['default'];
	
	var _Promise = __webpack_require__(33)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(22);
	
	var _moment = __webpack_require__(10);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _actionsPaywallActions = __webpack_require__(134);
	
	var _userPanel = __webpack_require__(484);
	
	var _userPanel2 = _interopRequireDefault(_userPanel);
	
	__webpack_require__(2223);
	
	var _servicesFirebaseRef = __webpack_require__(74);
	
	var _servicesFirebaseRef2 = _interopRequireDefault(_servicesFirebaseRef);
	
	var _servicesEvents = __webpack_require__(73);
	
	var _programs = __webpack_require__(69);
	
	var _programs2 = _interopRequireDefault(_programs);
	
	var _viewsStaffSessionList = __webpack_require__(482);
	
	var _viewsStaffSessionList2 = _interopRequireDefault(_viewsStaffSessionList);
	
	var _viewsStaffSessionPanel = __webpack_require__(483);
	
	var _viewsStaffSessionPanel2 = _interopRequireDefault(_viewsStaffSessionPanel);
	
	function getProfile(user) {
	  var profile = user.profile;
	
	  var rest = _objectWithoutProperties(user, ['profile']);
	
	  return _extends({}, rest, profile);
	}
	
	var Search = (function (_Component) {
	  _inherits(Search, _Component);
	
	  _createClass(Search, null, [{
	    key: 'propTypes',
	    value: {
	      history: _react.PropTypes.object.isRequired,
	      route: _react.PropTypes.object.isRequired,
	      routeParams: _react.PropTypes.object.isRequired,
	      paywall: _react.PropTypes.object.isRequired,
	      findSession: _react.PropTypes.func.isRequired,
	      findUser: _react.PropTypes.func.isRequired,
	      approveSession: _react.PropTypes.func.isRequired,
	      reassignSession: _react.PropTypes.func.isRequired,
	      cancelFundedSpot: _react.PropTypes.func.isRequired,
	      refundSession: _react.PropTypes.func.isRequired,
	      changeSessionContractId: _react.PropTypes.func.isRequired,
	      changeSessionValidUntil: _react.PropTypes.func.isRequired,
	      unarchiveSession: _react.PropTypes.func.isRequired,
	      deleteUser: _react.PropTypes.func.isRequired,
	      toggleTester: _react.PropTypes.func.isRequired,
	      changeProgram: _react.PropTypes.func.isRequired
	    },
	    enumerable: true
	  }]);
	
	  function Search(props) {
	    _classCallCheck(this, Search);
	
	    _get(Object.getPrototypeOf(Search.prototype), 'constructor', this).call(this, props);
	    this.state = {};
	  }
	
	  _createClass(Search, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this._loadFromRoute();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      var route = this.props.route;
	
	      if (prevProps.route.path !== route.path) {
	        this._loadFromRoute();
	      }
	    }
	  }, {
	    key: '_loadFromRoute',
	    value: function _loadFromRoute() {
	      var _props = this.props;
	      var route = _props.route;
	      var routeParams = _props.routeParams;
	
	      var path = route.path || '';
	      if (path.startsWith('session/')) {
	        this.props.findSession(routeParams.sessionId);
	      } else if (path.startsWith('user/')) {
	        this.props.findUser(routeParams.userId);
	      } else {
	        this.props.findSession('');
	      }
	    }
	  }, {
	    key: 'handleSessionIdChange',
	    value: function handleSessionIdChange(evt) {
	      this.setState({ sessionId: evt.target.value, message: '' });
	    }
	  }, {
	    key: 'findSession',
	    value: function findSession(evt) {
	      evt.stopPropagation();
	      evt.preventDefault();
	      if (!this.state.sessionId) {
	        return;
	      }
	      this.props.history.push('/staff/session/' + this.state.sessionId);
	    }
	  }, {
	    key: 'handleUserIdChange',
	    value: function handleUserIdChange(evt) {
	      this.setState({ userId: evt.target.value, message: '' });
	    }
	  }, {
	    key: 'findUser',
	    value: function findUser(evt) {
	      evt.stopPropagation();
	      evt.preventDefault();
	      if (!this.state.userId) {
	        return;
	      }
	      this.props.history.push('/staff/user/' + this.state.userId);
	    }
	  }, {
	    key: '_checkUserExists',
	    value: function _checkUserExists(userId) {
	      return new _Promise(function (resolve, reject) {
	        _servicesFirebaseRef2['default'].child('users').child(userId).on('value', function (snapshot) {
	          if (!snapshot || !snapshot.val()) {
	            return reject(new Error('User ID doesn\'t exist.'));
	          }
	          resolve();
	        }, reject);
	      });
	    }
	  }, {
	    key: 'handleChangeUser',
	    value: function handleChangeUser(_ref) {
	      var _this = this;
	
	      var sessionId = _ref.sessionId;
	      var programId = _ref.programId;
	      var oldUserId = _ref.oldUserId;
	      var newUserId = _ref.newUserId;
	      var staffUserId = _ref.staffUserId;
	      var _props$paywall$sessionFound$session = this.props.paywall.sessionFound.session;
	      var funding = _props$paywall$sessionFound$session.funding;
	      var contractId = _props$paywall$sessionFound$session.contractId;
	      var language = _props$paywall$sessionFound$session.language;
	
	      var reassignSessionArgs = {
	        sessionId: sessionId,
	        programId: programId,
	        oldUserId: oldUserId,
	        newUserId: newUserId,
	        staffUserId: staffUserId,
	        funding: funding,
	        contractId: contractId,
	        language: language
	      };
	      return this._checkUserExists(newUserId).then(function () {
	        return _this.props.reassignSession(reassignSessionArgs);
	      }).then(function () {
	        return _this.props.findSession('');
	      }).then(function () {
	        return _this.setState({ message: 'User changed for session  ' + sessionId });
	      });
	    }
	  }, {
	    key: 'handleCancelFundedSpot',
	    value: function handleCancelFundedSpot(_ref2) {
	      var _this2 = this;
	
	      var sessionId = _ref2.sessionId;
	      var programId = _ref2.programId;
	      var userId = _ref2.userId;
	      var staffUserId = _ref2.staffUserId;
	
	      this.props.cancelFundedSpot(sessionId, programId, userId, staffUserId).then(function () {
	        return _this2.props.findSession('');
	      }).then(function () {
	        return _this2.setState({ message: 'Funded spot cancelled for session ' + sessionId });
	      });
	    }
	  }, {
	    key: 'handleRefundSession',
	    value: function handleRefundSession(_ref3) {
	      var _this3 = this;
	
	      var sessionId = _ref3.sessionId;
	      var sessionFunding = _ref3.sessionFunding;
	      var programId = _ref3.programId;
	      var userId = _ref3.userId;
	      var staffUserId = _ref3.staffUserId;
	
	      this.props.refundSession(sessionId, sessionFunding, programId, userId, staffUserId).then(function () {
	        return _this3.props.findSession('');
	      }).then(function () {
	        return _this3.setState({ message: 'Session marked as refunded ' + sessionId });
	      });
	    }
	  }, {
	    key: 'handleChangeContractId',
	    value: function handleChangeContractId(_ref4) {
	      var _this4 = this;
	
	      var sessionId = _ref4.sessionId;
	      var programId = _ref4.programId;
	      var userId = _ref4.userId;
	      var staffUserId = _ref4.staffUserId;
	      var oldContractId = _ref4.oldContractId;
	      var newContractId = _ref4.newContractId;
	
	      this.props.changeSessionContractId(sessionId, programId, userId, staffUserId, oldContractId, newContractId).then(function () {
	        return _this4.props.findSession('');
	      }).then(function () {
	        return _this4.setState({ message: 'Session ' + sessionId + ' contract id changed to ' + newContractId });
	      });
	    }
	  }, {
	    key: 'handleChangeValidUntil',
	    value: function handleChangeValidUntil(_ref5) {
	      var _this5 = this;
	
	      var sessionId = _ref5.sessionId;
	      var programId = _ref5.programId;
	      var userId = _ref5.userId;
	      var staffUserId = _ref5.staffUserId;
	      var oldValidUntil = _ref5.oldValidUntil;
	      var newValidUntil = _ref5.newValidUntil;
	
	      this.props.changeSessionValidUntil(sessionId, programId, userId, staffUserId, oldValidUntil, newValidUntil).then(function () {
	        return _this5.props.findSession('');
	      }).then(function () {
	        return _this5.setState({ message: 'Session ' + sessionId + ' valid Until changed to ' + (0, _moment2['default'])(newValidUntil).local().toString() });
	      });
	    }
	  }, {
	    key: 'handleApproveSession',
	    value: function handleApproveSession(args) {
	      var _this6 = this;
	
	      var sessionId = args.sessionId;
	
	      this.props.approveSession(args).then(function () {
	        return _this6.props.findSession('');
	      }).then(function () {
	        return _this6.setState({ message: 'Session ' + sessionId + ' is approved.' });
	      });
	    }
	  }, {
	    key: 'handleUnarchiveSession',
	    value: function handleUnarchiveSession(_ref6) {
	      var _this7 = this;
	
	      var sessionId = _ref6.sessionId;
	      var programId = _ref6.programId;
	      var userId = _ref6.userId;
	      var staffUserId = _ref6.staffUserId;
	
	      this.props.unarchiveSession({ sessionId: sessionId, programId: programId, userId: userId, staffUserId: staffUserId }).then(function () {
	        return _this7.props.findSession('');
	      }).then(function () {
	        return _this7.setState({ message: 'Session ' + sessionId + ' is unarchived.' });
	      });
	    }
	  }, {
	    key: 'handleHideSession',
	    value: function handleHideSession(args) {
	      var _this8 = this;
	
	      this.props.hideSession(args).then(function () {
	        return _this8.props.findSession('');
	      }).then(function () {
	        return _this8.setState({ message: 'Session ' + args.sessionId + ' is hidden.' });
	      });
	    }
	  }, {
	    key: 'handleDeleteUser',
	    value: function handleDeleteUser(_ref7) {
	      var _this9 = this;
	
	      var userId = _ref7.userId;
	      var staffUserId = _ref7.staffUserId;
	
	      this.props.deleteUser({ userId: userId, staffUserId: staffUserId }).then(function () {
	        return _this9.props.findSession('');
	      }).then(function () {
	        return _this9.setState({ message: 'User ' + userId + ' is deleted.' });
	      });
	    }
	  }, {
	    key: 'handleToggleTester',
	    value: function handleToggleTester(_ref8) {
	      var _this10 = this;
	
	      var userId = _ref8.userId;
	      var staffUserId = _ref8.staffUserId;
	      var tester = _ref8.tester;
	
	      this.props.toggleTester({ userId: userId, staffUserId: staffUserId, tester: tester }).then(function () {
	        return _this10.setState({ message: 'User ' + userId + ' is ' + (tester ? 'now' : 'no longer') + ' a beta tester.' });
	      });
	    }
	  }, {
	    key: 'handleAddToNurtureCampaign',
	    value: function handleAddToNurtureCampaign(args) {
	      var _this11 = this;
	
	      (0, _servicesEvents.publishEvent)('Class Approved Nurture Campaign Started', args);
	      this.props.findSession('').then(function () {
	        return _this11.setState({ message: 'Session ' + args.sessionId + ' nurture campaign started event sent.' });
	      });
	    }
	  }, {
	    key: 'handleChangeProgram',
	    value: function handleChangeProgram(args) {
	      var _this12 = this;
	
	      var newProgramTitle = _programs2['default'].programLookup[args.newProgramId].title;
	      this.props.changeProgram(args).then(function () {
	        return _this12.props.findSession('');
	      }).then(function () {
	        return _this12.setState({ message: 'Session ' + args.sessionId + ' program changed to ' + newProgramTitle + '.' });
	      });
	    }
	  }, {
	    key: 'handlePutOnHold',
	    value: function handlePutOnHold() {}
	  }, {
	    key: 'clearFound',
	    value: function clearFound() {
	      this.props.history.replace('/staff');
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var paywall = this.props.paywall;
	
	      return _react2['default'].createElement(
	        'div',
	        null,
	        _react2['default'].createElement(
	          'div',
	          { className: 'row' },
	          _react2['default'].createElement(
	            'div',
	            { className: 'col-sm-12' },
	            _react2['default'].createElement(
	              'span',
	              null,
	              this.state.message
	            )
	          )
	        ),
	        paywall.sessionFound && _react2['default'].createElement(
	          _userPanel2['default'],
	          {
	            profile: getProfile(paywall.sessionFound.user),
	            userId: paywall.sessionFound.user.userId,
	            clearFound: this.clearFound.bind(this)
	          },
	          _react2['default'].createElement(
	            'div',
	            null,
	            _react2['default'].createElement(
	              'h4',
	              null,
	              'Session'
	            ),
	            _react2['default'].createElement(_viewsStaffSessionPanel2['default'], {
	              session: paywall.sessionFound.session,
	              userId: paywall.sessionFound.user.userId,
	              email: paywall.sessionFound.user.profile.email,
	              approveSession: this.handleApproveSession.bind(this),
	              cancelFundedSpot: this.handleCancelFundedSpot.bind(this),
	              changeUser: this.handleChangeUser.bind(this),
	              clearFound: this.clearFound.bind(this),
	              refundSession: this.handleRefundSession.bind(this),
	              changeContractId: this.handleChangeContractId.bind(this),
	              changeValidUntil: this.handleChangeValidUntil.bind(this),
	              unarchiveSession: this.handleUnarchiveSession.bind(this),
	              addToNurtureCampaign: this.handleAddToNurtureCampaign.bind(this),
	              putOnHold: this.handlePutOnHold.bind(this),
	              changeProgram: this.handleChangeProgram.bind(this)
	            })
	          )
	        ),
	        paywall.userFound && _react2['default'].createElement(
	          _userPanel2['default'],
	          {
	            profile: getProfile(paywall.userFound),
	            userId: paywall.userFound.userId,
	            deleteUser: this.handleDeleteUser.bind(this),
	            toggleTester: this.handleToggleTester.bind(this),
	            clearFound: this.clearFound.bind(this)
	          },
	          _react2['default'].createElement(_viewsStaffSessionList2['default'], {
	            title: "Sessions",
	            userId: paywall.userFound.userId,
	            email: paywall.userFound.profile.email,
	            sessions: paywall.userFound.sessions,
	            approveSession: this.handleApproveSession.bind(this),
	            putOnHold: this.handlePutOnHold.bind(this),
	            changeProgram: this.handleChangeProgram.bind(this),
	            changeUser: this.handleChangeUser.bind(this),
	            cancelFundedSpot: this.handleCancelFundedSpot.bind(this),
	            clearFound: this.clearFound.bind(this),
	            refundSession: this.handleRefundSession.bind(this),
	            changeContractId: this.handleChangeContractId.bind(this),
	            changeValidUntil: this.handleChangeValidUntil.bind(this),
	            unarchiveSession: this.handleUnarchiveSession.bind(this),
	            addToNurtureCampaign: this.handleAddToNurtureCampaign.bind(this)
	          })
	        ),
	        !paywall.sessionFound && !paywall.userFound && _react2['default'].createElement(
	          'form',
	          { action: '#', className: 'sessionFinder' },
	          _react2['default'].createElement(
	            'div',
	            { className: 'well form-horizontal clearfix' },
	            _react2['default'].createElement(
	              'div',
	              { className: 'col-sm-6' },
	              _react2['default'].createElement(
	                'div',
	                { className: 'form-group' },
	                _react2['default'].createElement(
	                  'label',
	                  { className: 'col-xs-2 col-sm-4 control-label' },
	                  'Session Id'
	                ),
	                _react2['default'].createElement(
	                  'div',
	                  { className: 'col-xs-10 col-sm-8' },
	                  _react2['default'].createElement('input', { className: 'form-control',
	                    type: 'text',
	                    placeholder: 'sessionId',
	                    onBlur: this.handleSessionIdChange.bind(this) })
	                )
	              )
	            ),
	            _react2['default'].createElement(
	              'div',
	              { className: 'col-sm-6' },
	              _react2['default'].createElement(
	                'button',
	                {
	                  className: 'btn btn-primary btn-sm',
	                  onClick: this.findSession.bind(this) },
	                'Search'
	              )
	            )
	          )
	        ),
	        !paywall.sessionFound && !paywall.userFound && _react2['default'].createElement(
	          'form',
	          { action: '#', className: 'userFinder' },
	          _react2['default'].createElement(
	            'div',
	            { className: 'well form-horizontal clearfix' },
	            _react2['default'].createElement(
	              'div',
	              { className: 'col-sm-6' },
	              _react2['default'].createElement(
	                'div',
	                { className: 'form-group' },
	                _react2['default'].createElement(
	                  'label',
	                  { className: 'col-xs-2 col-sm-4 control-label' },
	                  'User Id'
	                ),
	                _react2['default'].createElement(
	                  'div',
	                  { className: 'col-xs-10 col-sm-8' },
	                  _react2['default'].createElement('input', { className: 'form-control',
	                    type: 'text',
	                    placeholder: 'userId',
	                    onBlur: this.handleUserIdChange.bind(this) })
	                )
	              )
	            ),
	            _react2['default'].createElement(
	              'div',
	              { className: 'col-sm-6' },
	              _react2['default'].createElement(
	                'button',
	                {
	                  className: 'btn btn-primary btn-sm',
	                  onClick: this.findUser.bind(this) },
	                'Search'
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Search;
	})(_react.Component);
	
	exports['default'] = (0, _reactRedux.connect)(function (state) {
	  var paywall = state.paywall;
	
	  return { paywall: paywall };
	}, {
	  findSession: _actionsPaywallActions.findSession,
	  findUser: _actionsPaywallActions.findUser,
	  approveSession: _actionsPaywallActions.approveSession,
	  reassignSession: _actionsPaywallActions.reassignSession,
	  cancelFundedSpot: _actionsPaywallActions.cancelFundedSpot,
	  refundSession: _actionsPaywallActions.refundSession,
	  changeSessionContractId: _actionsPaywallActions.changeSessionContractId,
	  changeSessionValidUntil: _actionsPaywallActions.changeSessionValidUntil,
	  unarchiveSession: _actionsPaywallActions.unarchiveSession,
	  deleteUser: _actionsPaywallActions.deleteUser,
	  toggleTester: _actionsPaywallActions.toggleTester,
	  changeProgram: _actionsPaywallActions.changeProgram
	})(Search);
	module.exports = exports['default'];

/***/ }),
/* 1189 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _get = __webpack_require__(8)["default"];
	
	var _inherits = __webpack_require__(5)["default"];
	
	var _createClass = __webpack_require__(6)["default"];
	
	var _classCallCheck = __webpack_require__(3)["default"];
	
	var _interopRequireDefault = __webpack_require__(2)["default"];
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(22);
	
	var _actionsPaywallActions = __webpack_require__(134);
	
	var _usersByDate = __webpack_require__(485);
	
	var _usersByDate2 = _interopRequireDefault(_usersByDate);
	
	var UnapprovedSessions = (function (_Component) {
	  _inherits(UnapprovedSessions, _Component);
	
	  _createClass(UnapprovedSessions, null, [{
	    key: "propTypes",
	    value: {
	      bindUnapprovedSessions: _react.PropTypes.func.isRequired,
	      unbindUnapprovedSessions: _react.PropTypes.func.isRequired
	    },
	    enumerable: true
	  }]);
	
	  function UnapprovedSessions(props) {
	    _classCallCheck(this, UnapprovedSessions);
	
	    _get(Object.getPrototypeOf(UnapprovedSessions.prototype), "constructor", this).call(this, props);
	    this.boundUnapprovedSessionsRefs = {};
	  }
	
	  _createClass(UnapprovedSessions, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.bindUnapprovedSessions(this.props);
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.unbindUnapprovedSessions();
	    }
	  }, {
	    key: "bindUnapprovedSessions",
	    value: function bindUnapprovedSessions(props) {
	      var bind = props.bindUnapprovedSessions;
	
	      bind(this.boundUnapprovedSessionsRefs);
	    }
	  }, {
	    key: "unbindUnapprovedSessions",
	    value: function unbindUnapprovedSessions() {
	      var unbind = this.props.unbindUnapprovedSessions;
	
	      unbind(this.boundUnapprovedSessionsRefs);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return _react2["default"].createElement(_usersByDate2["default"], { sessionType: "unapproved" });
	    }
	  }]);
	
	  return UnapprovedSessions;
	})(_react.Component);
	
	exports["default"] = (0, _reactRedux.connect)(function () {
	  return (/*state*/{}
	  );
	}, {
	  bindUnapprovedSessions: _actionsPaywallActions.bindUnapprovedSessions,
	  unbindUnapprovedSessions: _actionsPaywallActions.unbindUnapprovedSessions
	})(UnapprovedSessions);
	module.exports = exports["default"];

/***/ }),
/* 1190 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _get = __webpack_require__(8)['default'];
	
	var _inherits = __webpack_require__(5)['default'];
	
	var _createClass = __webpack_require__(6)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _extends = __webpack_require__(7)['default'];
	
	var _defineProperty = __webpack_require__(105)['default'];
	
	var _Object$keys = __webpack_require__(32)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(24);
	
	var _reactSpinner = __webpack_require__(51);
	
	var _reactSpinner2 = _interopRequireDefault(_reactSpinner);
	
	__webpack_require__(120);
	
	__webpack_require__(2225);
	
	var _reactRedux = __webpack_require__(22);
	
	var _redux = __webpack_require__(99);
	
	var _actionsUnsubscribeActions = __webpack_require__(299);
	
	var listNames = {
	  gettingStarted: "Help to get started from a real human (1-4 messages per month)",
	  directPromotion: "Information about free programs in my area (2-4 messages per year)",
	  marketing: "Newsletter with exclusive content and product news (4-6 messages per year)"
	};
	
	var Subscribe = (function (_Component) {
	  _inherits(Subscribe, _Component);
	
	  _createClass(Subscribe, null, [{
	    key: 'contextTypes',
	    value: {
	      location: _react.PropTypes.object.isRequired,
	      history: _react.PropTypes.object.isRequired
	    },
	    enumerable: true
	  }]);
	
	  function Subscribe(props) {
	    _classCallCheck(this, Subscribe);
	
	    _get(Object.getPrototypeOf(Subscribe.prototype), 'constructor', this).call(this, props);
	    this.state = {
	      error: '',
	      optIns: null
	    };
	  }
	
	  _createClass(Subscribe, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _context$location$query = this.context.location.query;
	      var userId = _context$location$query.userId;
	      var listId = _context$location$query.listId;
	
	      if (!userId) {
	        this.setState({ error: "Oups! It seems like this link is incomplete. Please try again by clicking the link in the email." });
	        return;
	      }
	      if (listId) {
	        this.props.subscribe(userId, listId);
	      } else {
	        this.props.getOptIns(userId);
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      var _context$location$query2 = this.context.location.query;
	      var userId = _context$location$query2.userId;
	      var listId = _context$location$query2.listId;
	      var _props = this.props;
	      var subscribed = _props.subscribed;
	      var optIns = _props.optIns;
	
	      if (prevProps.subscribed !== subscribed && subscribed) {
	        this.context.history.replaceState(null, '/subscribed?userId=' + userId + '&listId=' + listId);
	      }
	      if (prevProps.optIns !== optIns) {
	        this.setState({ optIns: optIns });
	      }
	    }
	  }, {
	    key: 'optInChange',
	    value: function optInChange(evt, optIn) {
	      this.setState(function (prevState) {
	        return {
	          optIns: _extends({}, prevState.optIns, _defineProperty({}, optIn, evt.target.checked))
	        };
	      });
	    }
	  }, {
	    key: 'submit',
	    value: function submit() {
	      var userId = this.context.location.query.userId;
	
	      this.props.setOptIns(userId, this.state.optIns);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this = this;
	
	      var listId = this.context.location.query.listId;
	      var _state = this.state;
	      var stateError = _state.error;
	      var optIns = _state.optIns;
	      var _props2 = this.props;
	      var propsError = _props2.error;
	      var subscribing = _props2.subscribing;
	      var fetchingOptIns = _props2.fetchingOptIns;
	      var settingDone = _props2.settingDone;
	
	      var error = stateError || propsError;
	      var working = !error && (subscribing || fetchingOptIns);
	      return _react2['default'].createElement(
	        _reactBootstrap.Row,
	        { className: 'subscribe' },
	        _react2['default'].createElement(
	          _reactBootstrap.Col,
	          { xs: 12 },
	          error && _react2['default'].createElement(
	            'div',
	            { className: 'error' },
	            'There was a problem subscribing you in the list. Please try again later.',
	            _react2['default'].createElement('br', null),
	            'Details: ',
	            error
	          ),
	          working && _react2['default'].createElement(
	            'div',
	            { className: 'waiting' },
	            _react2['default'].createElement(
	              'div',
	              { className: 'spinnerWrapper' },
	              _react2['default'].createElement(_reactSpinner2['default'], { className: 'blackSpinner' })
	            ),
	            subscribing ? 'Subscribing your from ' + listNames[listId] : 'Fetching your lists'
	          ),
	          optIns && _react2['default'].createElement(
	            'div',
	            { className: 'optIns' },
	            _Object$keys(optIns).map(function (optIn) {
	              return _react2['default'].createElement(
	                'div',
	                { key: optIn },
	                _react2['default'].createElement('input', { type: 'checkbox', readOnly: settingDone, checked: optIns[optIn], onChange: function (evt) {
	                    return _this.optInChange(evt, optIn);
	                  } }),
	                ' ',
	                listNames[optIn]
	              );
	            }),
	            _react2['default'].createElement(
	              'div',
	              { className: 'btn-container' },
	              settingDone ? _react2['default'].createElement(
	                'span',
	                { className: 'saved' },
	                'Preferences saved ',
	                '✅'
	              ) : _react2['default'].createElement(
	                'a',
	                { onClick: this.submit.bind(this), className: 'btn btn-lg btn-success' },
	                'Submit'
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Subscribe;
	})(_react.Component);
	
	exports['default'] = (0, _reactRedux.connect)(function (state) {
	  return _extends({}, state.unsubscribe);
	}, function (dispatch) {
	  return (0, _redux.bindActionCreators)({
	    getOptIns: _actionsUnsubscribeActions.getOptIns,
	    setOptIns: _actionsUnsubscribeActions.setOptIns,
	    subscribe: _actionsUnsubscribeActions.subscribe
	  }, dispatch);
	})(Subscribe);
	module.exports = exports['default'];

/***/ }),
/* 1191 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _get = __webpack_require__(8)['default'];
	
	var _inherits = __webpack_require__(5)['default'];
	
	var _createClass = __webpack_require__(6)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(24);
	
	__webpack_require__(2226);
	
	var Subscribed = (function (_Component) {
	  _inherits(Subscribed, _Component);
	
	  function Subscribed() {
	    _classCallCheck(this, Subscribed);
	
	    _get(Object.getPrototypeOf(Subscribed.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(Subscribed, [{
	    key: 'render',
	    value: function render() {
	      return _react2['default'].createElement(
	        _reactBootstrap.Row,
	        { className: 'subscribed' },
	        _react2['default'].createElement(
	          _reactBootstrap.Col,
	          { xs: 12 },
	          _react2['default'].createElement(
	            'div',
	            null,
	            'You have been subscribed to this list. You can unsubscribe at anytime through your Profile settings.'
	          )
	        )
	      );
	    }
	  }], [{
	    key: 'contextTypes',
	    value: {
	      location: _react.PropTypes.object.isRequired
	    },
	    enumerable: true
	  }]);
	
	  return Subscribed;
	})(_react.Component);
	
	exports['default'] = Subscribed;
	module.exports = exports['default'];

/***/ }),
/* 1192 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _get = __webpack_require__(8)['default'];
	
	var _inherits = __webpack_require__(5)['default'];
	
	var _createClass = __webpack_require__(6)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _helpersMarkdownScript = __webpack_require__(9);
	
	var _helpersMarkdownScript2 = _interopRequireDefault(_helpersMarkdownScript);
	
	var _authTermsAndConditionsMd = __webpack_require__(724);
	
	var _authTermsAndConditionsMd2 = _interopRequireDefault(_authTermsAndConditionsMd);
	
	var md = new _helpersMarkdownScript2['default'](_authTermsAndConditionsMd2['default']);
	
	var DataUsage = (function (_Component) {
	  _inherits(DataUsage, _Component);
	
	  function DataUsage() {
	    _classCallCheck(this, DataUsage);
	
	    _get(Object.getPrototypeOf(DataUsage.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(DataUsage, [{
	    key: 'render',
	    value: function render() {
	      return _react2['default'].createElement(
	        'div',
	        null,
	        _react2['default'].createElement('div', { dangerouslySetInnerHTML: { __html: md.getAllAsHtml() } })
	      );
	    }
	  }]);
	
	  return DataUsage;
	})(_react.Component);
	
	exports['default'] = DataUsage;
	module.exports = exports['default'];

/***/ }),
/* 1193 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _get = __webpack_require__(8)['default'];
	
	var _inherits = __webpack_require__(5)['default'];
	
	var _createClass = __webpack_require__(6)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _extends = __webpack_require__(7)['default'];
	
	var _defineProperty = __webpack_require__(105)['default'];
	
	var _Object$keys = __webpack_require__(32)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(24);
	
	var _reactSpinner = __webpack_require__(51);
	
	var _reactSpinner2 = _interopRequireDefault(_reactSpinner);
	
	__webpack_require__(120);
	
	__webpack_require__(2227);
	
	var _reactRedux = __webpack_require__(22);
	
	var _redux = __webpack_require__(99);
	
	var _actionsUnsubscribeActions = __webpack_require__(299);
	
	var listNames = {
	  gettingStarted: "Help to get started from a real human (1-4 messages per month)",
	  directPromotion: "Information about free programs in my area (2-4 messages per year)",
	  marketing: "Newsletter with exclusive content and product news (4-6 messages per year)"
	};
	
	var Unsubscribe = (function (_Component) {
	  _inherits(Unsubscribe, _Component);
	
	  _createClass(Unsubscribe, null, [{
	    key: 'contextTypes',
	    value: {
	      location: _react.PropTypes.object.isRequired,
	      history: _react.PropTypes.object.isRequired
	    },
	    enumerable: true
	  }]);
	
	  function Unsubscribe(props) {
	    _classCallCheck(this, Unsubscribe);
	
	    _get(Object.getPrototypeOf(Unsubscribe.prototype), 'constructor', this).call(this, props);
	    this.state = {
	      error: '',
	      optIns: null
	    };
	  }
	
	  _createClass(Unsubscribe, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _context$location$query = this.context.location.query;
	      var userId = _context$location$query.userId;
	      var listId = _context$location$query.listId;
	
	      if (!userId) {
	        this.setState({ error: "Oups! It seems like this link is incomplete. Please try again by clicking the link in the email." });
	        return;
	      }
	      if (listId) {
	        this.props.unsubscribe(userId, listId);
	      } else {
	        this.props.getOptIns(userId);
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      var _context$location$query2 = this.context.location.query;
	      var userId = _context$location$query2.userId;
	      var listId = _context$location$query2.listId;
	      var _props = this.props;
	      var unsubscribed = _props.unsubscribed;
	      var optIns = _props.optIns;
	
	      if (prevProps.unsubscribed !== unsubscribed && unsubscribed) {
	        this.context.history.replaceState(null, '/unsubscribed?userId=' + userId + '&listId=' + listId);
	      }
	      if (prevProps.optIns !== optIns) {
	        this.setState({ optIns: optIns });
	      }
	    }
	  }, {
	    key: 'optInChange',
	    value: function optInChange(evt, optIn) {
	      this.setState(function (prevState) {
	        return {
	          optIns: _extends({}, prevState.optIns, _defineProperty({}, optIn, evt.target.checked))
	        };
	      });
	    }
	  }, {
	    key: 'submit',
	    value: function submit() {
	      var userId = this.context.location.query.userId;
	
	      this.props.setOptIns(userId, this.state.optIns);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this = this;
	
	      var listId = this.context.location.query.listId;
	      var _state = this.state;
	      var stateError = _state.error;
	      var optIns = _state.optIns;
	      var _props2 = this.props;
	      var propsError = _props2.error;
	      var unsubscribing = _props2.unsubscribing;
	      var fetchingOptIns = _props2.fetchingOptIns;
	      var settingDone = _props2.settingDone;
	
	      var error = stateError || propsError;
	      var working = !error && (unsubscribing || fetchingOptIns);
	      return _react2['default'].createElement(
	        _reactBootstrap.Row,
	        { className: 'unsubscribe' },
	        _react2['default'].createElement(
	          _reactBootstrap.Col,
	          { xs: 12 },
	          error && _react2['default'].createElement(
	            'div',
	            { className: 'error' },
	            'There was a problem unsubscribing you from the list. Please try again later.',
	            _react2['default'].createElement('br', null),
	            'Details: ',
	            error
	          ),
	          working && _react2['default'].createElement(
	            'div',
	            { className: 'waiting' },
	            _react2['default'].createElement(
	              'div',
	              { className: 'spinnerWrapper' },
	              _react2['default'].createElement(_reactSpinner2['default'], { className: 'blackSpinner' })
	            ),
	            unsubscribing ? 'Unsubscribing your from ' + listNames[listId] : 'Fetching your lists'
	          ),
	          optIns && _react2['default'].createElement(
	            'div',
	            { className: 'optIns' },
	            _Object$keys(optIns).map(function (optIn) {
	              return _react2['default'].createElement(
	                'div',
	                { key: optIn },
	                _react2['default'].createElement('input', { type: 'checkbox', readOnly: settingDone, checked: optIns[optIn], onChange: function (evt) {
	                    return _this.optInChange(evt, optIn);
	                  } }),
	                ' ',
	                listNames[optIn]
	              );
	            }),
	            _react2['default'].createElement(
	              'div',
	              { className: 'btn-container' },
	              settingDone ? _react2['default'].createElement(
	                'span',
	                { className: 'saved' },
	                'Preferences saved ',
	                '✅'
	              ) : _react2['default'].createElement(
	                'a',
	                { onClick: this.submit.bind(this), className: 'btn btn-lg btn-success' },
	                'Submit'
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Unsubscribe;
	})(_react.Component);
	
	exports['default'] = (0, _reactRedux.connect)(function (state) {
	  return _extends({}, state.unsubscribe);
	}, function (dispatch) {
	  return (0, _redux.bindActionCreators)({
	    getOptIns: _actionsUnsubscribeActions.getOptIns,
	    setOptIns: _actionsUnsubscribeActions.setOptIns,
	    unsubscribe: _actionsUnsubscribeActions.unsubscribe
	  }, dispatch);
	})(Unsubscribe);
	module.exports = exports['default'];

/***/ }),
/* 1194 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _get = __webpack_require__(8)['default'];
	
	var _inherits = __webpack_require__(5)['default'];
	
	var _createClass = __webpack_require__(6)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(24);
	
	__webpack_require__(2228);
	
	var Unsubscribed = (function (_Component) {
	  _inherits(Unsubscribed, _Component);
	
	  function Unsubscribed() {
	    _classCallCheck(this, Unsubscribed);
	
	    _get(Object.getPrototypeOf(Unsubscribed.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(Unsubscribed, [{
	    key: 'render',
	    value: function render() {
	      return _react2['default'].createElement(
	        _reactBootstrap.Row,
	        { className: 'unsubscribed' },
	        _react2['default'].createElement(
	          _reactBootstrap.Col,
	          { xs: 12 },
	          _react2['default'].createElement(
	            'div',
	            null,
	            'You have been unsubscribed from this list. You can re-subscribe at anytime through your Profile settings.'
	          )
	        )
	      );
	    }
	  }], [{
	    key: 'contextTypes',
	    value: {
	      location: _react.PropTypes.object.isRequired
	    },
	    enumerable: true
	  }]);
	
	  return Unsubscribed;
	})(_react.Component);
	
	exports['default'] = Unsubscribed;
	module.exports = exports['default'];

/***/ }),
/* 1195 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1216), __esModule: true };

/***/ }),
/* 1196 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1218), __esModule: true };

/***/ }),
/* 1197 */,
/* 1198 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1223), __esModule: true };

/***/ }),
/* 1199 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1226), __esModule: true };

/***/ }),
/* 1200 */,
/* 1201 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1230), __esModule: true };

/***/ }),
/* 1202 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1232), __esModule: true };

/***/ }),
/* 1203 */,
/* 1204 */,
/* 1205 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getIterator = __webpack_require__(62)["default"];
	
	var _isIterable = __webpack_require__(1196)["default"];
	
	exports["default"] = (function () {
	  function sliceIterator(arr, i) {
	    var _arr = [];
	    var _n = true;
	    var _d = false;
	    var _e = undefined;
	
	    try {
	      for (var _i = _getIterator(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
	        _arr.push(_s.value);
	
	        if (i && _arr.length === i) break;
	      }
	    } catch (err) {
	      _d = true;
	      _e = err;
	    } finally {
	      try {
	        if (!_n && _i["return"]) _i["return"]();
	      } finally {
	        if (_d) throw _e;
	      }
	    }
	
	    return _arr;
	  }
	
	  return function (arr, i) {
	    if (Array.isArray(arr)) {
	      return arr;
	    } else if (_isIterable(Object(arr))) {
	      return sliceIterator(arr, i);
	    } else {
	      throw new TypeError("Invalid attempt to destructure non-iterable instance");
	    }
	  };
	})();
	
	exports.__esModule = true;

/***/ }),
/* 1206 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {/**
	 * Copyright (c) 2014, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
	 * additional grant of patent rights can be found in the PATENTS file in
	 * the same directory.
	 */
	
	"use strict";
	
	var _Symbol = __webpack_require__(1202)["default"];
	
	var _Object$create = __webpack_require__(488)["default"];
	
	var _Object$setPrototypeOf = __webpack_require__(490)["default"];
	
	var _Promise = __webpack_require__(33)["default"];
	
	!(function (global) {
	  "use strict";
	
	  var hasOwn = Object.prototype.hasOwnProperty;
	  var undefined; // More compressible than void 0.
	  var $Symbol = typeof _Symbol === "function" ? _Symbol : {};
	  var iteratorSymbol = $Symbol.iterator || "@@iterator";
	  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
	
	  var inModule = typeof module === "object";
	  var runtime = global.regeneratorRuntime;
	  if (runtime) {
	    if (inModule) {
	      // If regeneratorRuntime is defined globally and we're in a module,
	      // make the exports object identical to regeneratorRuntime.
	      module.exports = runtime;
	    }
	    // Don't bother evaluating the rest of this file if the runtime was
	    // already defined globally.
	    return;
	  }
	
	  // Define the runtime globally (as expected by generated code) as either
	  // module.exports (if we're in a module) or a new, empty object.
	  runtime = global.regeneratorRuntime = inModule ? module.exports : {};
	
	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    // If outerFn provided, then outerFn.prototype instanceof Generator.
	    var generator = _Object$create((outerFn || Generator).prototype);
	    var context = new Context(tryLocsList || []);
	
	    // The ._invoke method unifies the implementations of the .next,
	    // .throw, and .return methods.
	    generator._invoke = makeInvokeMethod(innerFn, self, context);
	
	    return generator;
	  }
	  runtime.wrap = wrap;
	
	  // Try/catch helper to minimize deoptimizations. Returns a completion
	  // record like context.tryEntries[i].completion. This interface could
	  // have been (and was previously) designed to take a closure to be
	  // invoked without arguments, but in all the cases we care about we
	  // already have an existing method we want to call, so there's no need
	  // to create a new function object. We can even get away with assuming
	  // the method takes exactly one argument, since that happens to be true
	  // in every case, so we don't have to touch the arguments object. The
	  // only additional allocation required is the completion record, which
	  // has a stable shape and so hopefully should be cheap to allocate.
	  function tryCatch(fn, obj, arg) {
	    try {
	      return { type: "normal", arg: fn.call(obj, arg) };
	    } catch (err) {
	      return { type: "throw", arg: err };
	    }
	  }
	
	  var GenStateSuspendedStart = "suspendedStart";
	  var GenStateSuspendedYield = "suspendedYield";
	  var GenStateExecuting = "executing";
	  var GenStateCompleted = "completed";
	
	  // Returning this object from the innerFn has the same effect as
	  // breaking out of the dispatch switch statement.
	  var ContinueSentinel = {};
	
	  // Dummy constructor functions that we use as the .constructor and
	  // .constructor.prototype properties for functions that return Generator
	  // objects. For full spec compliance, you may wish to configure your
	  // minifier not to mangle the names of these two functions.
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}
	
	  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype;
	  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
	  GeneratorFunctionPrototype.constructor = GeneratorFunction;
	  GeneratorFunctionPrototype[toStringTagSymbol] = GeneratorFunction.displayName = "GeneratorFunction";
	
	  // Helper for defining the .next, .throw, and .return methods of the
	  // Iterator interface in terms of a single ._invoke method.
	  function defineIteratorMethods(prototype) {
	    ["next", "throw", "return"].forEach(function (method) {
	      prototype[method] = function (arg) {
	        return this._invoke(method, arg);
	      };
	    });
	  }
	
	  runtime.isGeneratorFunction = function (genFun) {
	    var ctor = typeof genFun === "function" && genFun.constructor;
	    return ctor ? ctor === GeneratorFunction ||
	    // For the native GeneratorFunction constructor, the best we can
	    // do is to check its .name property.
	    (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
	  };
	
	  runtime.mark = function (genFun) {
	    if (_Object$setPrototypeOf) {
	      _Object$setPrototypeOf(genFun, GeneratorFunctionPrototype);
	    } else {
	      genFun.__proto__ = GeneratorFunctionPrototype;
	      if (!(toStringTagSymbol in genFun)) {
	        genFun[toStringTagSymbol] = "GeneratorFunction";
	      }
	    }
	    genFun.prototype = _Object$create(Gp);
	    return genFun;
	  };
	
	  // Within the body of any async function, `await x` is transformed to
	  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
	  // `value instanceof AwaitArgument` to determine if the yielded value is
	  // meant to be awaited. Some may consider the name of this method too
	  // cutesy, but they are curmudgeons.
	  runtime.awrap = function (arg) {
	    return new AwaitArgument(arg);
	  };
	
	  function AwaitArgument(arg) {
	    this.arg = arg;
	  }
	
	  function AsyncIterator(generator) {
	    function invoke(method, arg, resolve, reject) {
	      var record = tryCatch(generator[method], generator, arg);
	      if (record.type === "throw") {
	        reject(record.arg);
	      } else {
	        var result = record.arg;
	        var value = result.value;
	        if (value instanceof AwaitArgument) {
	          return _Promise.resolve(value.arg).then(function (value) {
	            invoke("next", value, resolve, reject);
	          }, function (err) {
	            invoke("throw", err, resolve, reject);
	          });
	        }
	
	        return _Promise.resolve(value).then(function (unwrapped) {
	          // When a yielded Promise is resolved, its final value becomes
	          // the .value of the Promise<{value,done}> result for the
	          // current iteration. If the Promise is rejected, however, the
	          // result for this iteration will be rejected with the same
	          // reason. Note that rejections of yielded Promises are not
	          // thrown back into the generator function, as is the case
	          // when an awaited Promise is rejected. This difference in
	          // behavior between yield and await is important, because it
	          // allows the consumer to decide what to do with the yielded
	          // rejection (swallow it and continue, manually .throw it back
	          // into the generator, abandon iteration, whatever). With
	          // await, by contrast, there is no opportunity to examine the
	          // rejection reason outside the generator function, so the
	          // only option is to throw it from the await expression, and
	          // let the generator function handle the exception.
	          result.value = unwrapped;
	          resolve(result);
	        }, reject);
	      }
	    }
	
	    if (typeof process === "object" && process.domain) {
	      invoke = process.domain.bind(invoke);
	    }
	
	    var previousPromise;
	
	    function enqueue(method, arg) {
	      function callInvokeWithMethodAndArg() {
	        return new _Promise(function (resolve, reject) {
	          invoke(method, arg, resolve, reject);
	        });
	      }
	
	      return previousPromise =
	      // If enqueue has been called before, then we want to wait until
	      // all previous Promises have been resolved before calling invoke,
	      // so that results are always delivered in the correct order. If
	      // enqueue has not been called before, then it is important to
	      // call invoke immediately, without waiting on a callback to fire,
	      // so that the async generator function has the opportunity to do
	      // any necessary setup in a predictable way. This predictability
	      // is why the Promise constructor synchronously invokes its
	      // executor callback, and why async functions synchronously
	      // execute code before the first await. Since we implement simple
	      // async functions in terms of async generators, it is especially
	      // important to get this right, even though it requires care.
	      previousPromise ? previousPromise.then(callInvokeWithMethodAndArg,
	      // Avoid propagating failures to Promises returned by later
	      // invocations of the iterator.
	      callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
	    }
	
	    // Define the unified helper method that is used to implement .next,
	    // .throw, and .return (see defineIteratorMethods).
	    this._invoke = enqueue;
	  }
	
	  defineIteratorMethods(AsyncIterator.prototype);
	
	  // Note that simple async functions are implemented on top of
	  // AsyncIterator objects; they just return a Promise for the value of
	  // the final result produced by the iterator.
	  runtime.async = function (innerFn, outerFn, self, tryLocsList) {
	    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList));
	
	    return runtime.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
	    : iter.next().then(function (result) {
	      return result.done ? result.value : iter.next();
	    });
	  };
	
	  function makeInvokeMethod(innerFn, self, context) {
	    var state = GenStateSuspendedStart;
	
	    return function invoke(method, arg) {
	      if (state === GenStateExecuting) {
	        throw new Error("Generator is already running");
	      }
	
	      if (state === GenStateCompleted) {
	        if (method === "throw") {
	          throw arg;
	        }
	
	        // Be forgiving, per 25.3.3.3.3 of the spec:
	        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
	        return doneResult();
	      }
	
	      while (true) {
	        var delegate = context.delegate;
	        if (delegate) {
	          if (method === "return" || method === "throw" && delegate.iterator[method] === undefined) {
	            // A return or throw (when the delegate iterator has no throw
	            // method) always terminates the yield* loop.
	            context.delegate = null;
	
	            // If the delegate iterator has a return method, give it a
	            // chance to clean up.
	            var returnMethod = delegate.iterator["return"];
	            if (returnMethod) {
	              var record = tryCatch(returnMethod, delegate.iterator, arg);
	              if (record.type === "throw") {
	                // If the return method threw an exception, let that
	                // exception prevail over the original return or throw.
	                method = "throw";
	                arg = record.arg;
	                continue;
	              }
	            }
	
	            if (method === "return") {
	              // Continue with the outer return, now that the delegate
	              // iterator has been terminated.
	              continue;
	            }
	          }
	
	          var record = tryCatch(delegate.iterator[method], delegate.iterator, arg);
	
	          if (record.type === "throw") {
	            context.delegate = null;
	
	            // Like returning generator.throw(uncaught), but without the
	            // overhead of an extra function call.
	            method = "throw";
	            arg = record.arg;
	            continue;
	          }
	
	          // Delegate generator ran and handled its own exceptions so
	          // regardless of what the method was, we continue as if it is
	          // "next" with an undefined arg.
	          method = "next";
	          arg = undefined;
	
	          var info = record.arg;
	          if (info.done) {
	            context[delegate.resultName] = info.value;
	            context.next = delegate.nextLoc;
	          } else {
	            state = GenStateSuspendedYield;
	            return info;
	          }
	
	          context.delegate = null;
	        }
	
	        if (method === "next") {
	          if (state === GenStateSuspendedYield) {
	            context.sent = arg;
	          } else {
	            context.sent = undefined;
	          }
	        } else if (method === "throw") {
	          if (state === GenStateSuspendedStart) {
	            state = GenStateCompleted;
	            throw arg;
	          }
	
	          if (context.dispatchException(arg)) {
	            // If the dispatched exception was caught by a catch block,
	            // then let that catch block handle the exception normally.
	            method = "next";
	            arg = undefined;
	          }
	        } else if (method === "return") {
	          context.abrupt("return", arg);
	        }
	
	        state = GenStateExecuting;
	
	        var record = tryCatch(innerFn, self, context);
	        if (record.type === "normal") {
	          // If an exception is thrown from innerFn, we leave state ===
	          // GenStateExecuting and loop back for another invocation.
	          state = context.done ? GenStateCompleted : GenStateSuspendedYield;
	
	          var info = {
	            value: record.arg,
	            done: context.done
	          };
	
	          if (record.arg === ContinueSentinel) {
	            if (context.delegate && method === "next") {
	              // Deliberately forget the last sent value so that we don't
	              // accidentally pass it on to the delegate.
	              arg = undefined;
	            }
	          } else {
	            return info;
	          }
	        } else if (record.type === "throw") {
	          state = GenStateCompleted;
	          // Dispatch the exception by looping back around to the
	          // context.dispatchException(arg) call above.
	          method = "throw";
	          arg = record.arg;
	        }
	      }
	    };
	  }
	
	  // Define Generator.prototype.{next,throw,return} in terms of the
	  // unified ._invoke helper method.
	  defineIteratorMethods(Gp);
	
	  Gp[iteratorSymbol] = function () {
	    return this;
	  };
	
	  Gp[toStringTagSymbol] = "Generator";
	
	  Gp.toString = function () {
	    return "[object Generator]";
	  };
	
	  function pushTryEntry(locs) {
	    var entry = { tryLoc: locs[0] };
	
	    if (1 in locs) {
	      entry.catchLoc = locs[1];
	    }
	
	    if (2 in locs) {
	      entry.finallyLoc = locs[2];
	      entry.afterLoc = locs[3];
	    }
	
	    this.tryEntries.push(entry);
	  }
	
	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal";
	    delete record.arg;
	    entry.completion = record;
	  }
	
	  function Context(tryLocsList) {
	    // The root entry object (effectively a try statement without a catch
	    // or a finally block) gives us a place to store values thrown from
	    // locations where there is no enclosing try statement.
	    this.tryEntries = [{ tryLoc: "root" }];
	    tryLocsList.forEach(pushTryEntry, this);
	    this.reset(true);
	  }
	
	  runtime.keys = function (object) {
	    var keys = [];
	    for (var key in object) {
	      keys.push(key);
	    }
	    keys.reverse();
	
	    // Rather than returning an object with a next method, we keep
	    // things simple and return the next function itself.
	    return function next() {
	      while (keys.length) {
	        var key = keys.pop();
	        if (key in object) {
	          next.value = key;
	          next.done = false;
	          return next;
	        }
	      }
	
	      // To avoid creating an additional object, we just hang the .value
	      // and .done properties off the next function object itself. This
	      // also ensures that the minifier will not anonymize the function.
	      next.done = true;
	      return next;
	    };
	  };
	
	  function values(iterable) {
	    if (iterable) {
	      var iteratorMethod = iterable[iteratorSymbol];
	      if (iteratorMethod) {
	        return iteratorMethod.call(iterable);
	      }
	
	      if (typeof iterable.next === "function") {
	        return iterable;
	      }
	
	      if (!isNaN(iterable.length)) {
	        var i = -1,
	            next = function next() {
	          while (++i < iterable.length) {
	            if (hasOwn.call(iterable, i)) {
	              next.value = iterable[i];
	              next.done = false;
	              return next;
	            }
	          }
	
	          next.value = undefined;
	          next.done = true;
	
	          return next;
	        };
	
	        return next.next = next;
	      }
	    }
	
	    // Return an iterator with no values.
	    return { next: doneResult };
	  }
	  runtime.values = values;
	
	  function doneResult() {
	    return { value: undefined, done: true };
	  }
	
	  Context.prototype = {
	    constructor: Context,
	
	    reset: function reset(skipTempReset) {
	      this.prev = 0;
	      this.next = 0;
	      this.sent = undefined;
	      this.done = false;
	      this.delegate = null;
	
	      this.tryEntries.forEach(resetTryEntry);
	
	      if (!skipTempReset) {
	        for (var name in this) {
	          // Not sure about the optimal order of these conditions:
	          if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) {
	            this[name] = undefined;
	          }
	        }
	      }
	    },
	
	    stop: function stop() {
	      this.done = true;
	
	      var rootEntry = this.tryEntries[0];
	      var rootRecord = rootEntry.completion;
	      if (rootRecord.type === "throw") {
	        throw rootRecord.arg;
	      }
	
	      return this.rval;
	    },
	
	    dispatchException: function dispatchException(exception) {
	      if (this.done) {
	        throw exception;
	      }
	
	      var context = this;
	      function handle(loc, caught) {
	        record.type = "throw";
	        record.arg = exception;
	        context.next = loc;
	        return !!caught;
	      }
	
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        var record = entry.completion;
	
	        if (entry.tryLoc === "root") {
	          // Exception thrown outside of any try block that could handle
	          // it, so set the completion value of the entire function to
	          // throw the exception.
	          return handle("end");
	        }
	
	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc");
	          var hasFinally = hasOwn.call(entry, "finallyLoc");
	
	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            } else if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            }
	          } else if (hasFinally) {
	            if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	          } else {
	            throw new Error("try statement without catch or finally");
	          }
	        }
	      }
	    },
	
	    abrupt: function abrupt(type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }
	
	      if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) {
	        // Ignore the finally entry if control is not jumping to a
	        // location outside the try/catch block.
	        finallyEntry = null;
	      }
	
	      var record = finallyEntry ? finallyEntry.completion : {};
	      record.type = type;
	      record.arg = arg;
	
	      if (finallyEntry) {
	        this.next = finallyEntry.finallyLoc;
	      } else {
	        this.complete(record);
	      }
	
	      return ContinueSentinel;
	    },
	
	    complete: function complete(record, afterLoc) {
	      if (record.type === "throw") {
	        throw record.arg;
	      }
	
	      if (record.type === "break" || record.type === "continue") {
	        this.next = record.arg;
	      } else if (record.type === "return") {
	        this.rval = record.arg;
	        this.next = "end";
	      } else if (record.type === "normal" && afterLoc) {
	        this.next = afterLoc;
	      }
	    },
	
	    finish: function finish(finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.finallyLoc === finallyLoc) {
	          this.complete(entry.completion, entry.afterLoc);
	          resetTryEntry(entry);
	          return ContinueSentinel;
	        }
	      }
	    },
	
	    "catch": function _catch(tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;
	          if (record.type === "throw") {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }
	          return thrown;
	        }
	      }
	
	      // The context.catch method must only be called with a location
	      // argument that corresponds to a known catch block.
	      throw new Error("illegal catch attempt");
	    },
	
	    delegateYield: function delegateYield(iterable, resultName, nextLoc) {
	      this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      };
	
	      return ContinueSentinel;
	    }
	  };
	})(
	// Among the various tricks for obtaining a reference to the global
	// object, this seems to be the most reliable technique that does not
	// use indirect eval (which violates Content Security Policy).
	typeof global === "object" ? global : typeof window === "object" ? window : typeof self === "object" ? self : undefined);
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(47)))

/***/ }),
/* 1207 */
/***/ (function(module, exports) {

	'use strict'
	
	module.exports = bail
	
	function bail(err) {
	  if (err) {
	    throw err
	  }
	}


/***/ }),
/* 1208 */,
/* 1209 */
/***/ (function(module, exports) {

	module.exports = function blacklist (src) {
	  var copy = {}
	  var filter = arguments[1]
	
	  if (typeof filter === 'string') {
	    filter = {}
	    for (var i = 1; i < arguments.length; i++) {
	      filter[arguments[i]] = true
	    }
	  }
	
	  for (var key in src) {
	    // blacklist?
	    if (filter[key]) continue
	
	    copy[key] = src[key]
	  }
	
	  return copy
	}


/***/ }),
/* 1210 */,
/* 1211 */,
/* 1212 */,
/* 1213 */
/***/ (function(module, exports) {

	'use strict'
	
	module.exports = ccount
	
	function ccount(source, character) {
	  var value = String(source)
	  var count = 0
	  var index
	
	  if (typeof character !== 'string') {
	    throw new Error('Expected character')
	  }
	
	  index = value.indexOf(character)
	
	  while (index !== -1) {
	    count++
	    index = value.indexOf(character, index + character.length)
	  }
	
	  return count
	}


/***/ }),
/* 1214 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(setImmediate) {
	/**
	 * slice() reference.
	 */
	
	var slice = Array.prototype.slice;
	
	/**
	 * Expose `co`.
	 */
	
	module.exports = co;
	
	/**
	 * Wrap the given generator `fn` and
	 * return a thunk.
	 *
	 * @param {Function} fn
	 * @return {Function}
	 * @api public
	 */
	
	function co(fn) {
	  var isGenFun = isGeneratorFunction(fn);
	
	  return function (done) {
	    var ctx = this;
	
	    // in toThunk() below we invoke co()
	    // with a generator, so optimize for
	    // this case
	    var gen = fn;
	
	    // we only need to parse the arguments
	    // if gen is a generator function.
	    if (isGenFun) {
	      var args = slice.call(arguments), len = args.length;
	      var hasCallback = len && 'function' == typeof args[len - 1];
	      done = hasCallback ? args.pop() : error;
	      gen = fn.apply(this, args);
	    } else {
	      done = done || error;
	    }
	
	    next();
	
	    // #92
	    // wrap the callback in a setImmediate
	    // so that any of its errors aren't caught by `co`
	    function exit(err, res) {
	      setImmediate(function(){
	        done.call(ctx, err, res);
	      });
	    }
	
	    function next(err, res) {
	      var ret;
	
	      // multiple args
	      if (arguments.length > 2) res = slice.call(arguments, 1);
	
	      // error
	      if (err) {
	        try {
	          ret = gen.throw(err);
	        } catch (e) {
	          return exit(e);
	        }
	      }
	
	      // ok
	      if (!err) {
	        try {
	          ret = gen.next(res);
	        } catch (e) {
	          return exit(e);
	        }
	      }
	
	      // done
	      if (ret.done) return exit(null, ret.value);
	
	      // normalize
	      ret.value = toThunk(ret.value, ctx);
	
	      // run
	      if ('function' == typeof ret.value) {
	        var called = false;
	        try {
	          ret.value.call(ctx, function(){
	            if (called) return;
	            called = true;
	            next.apply(ctx, arguments);
	          });
	        } catch (e) {
	          setImmediate(function(){
	            if (called) return;
	            called = true;
	            next(e);
	          });
	        }
	        return;
	      }
	
	      // invalid
	      next(new TypeError('You may only yield a function, promise, generator, array, or object, '
	        + 'but the following was passed: "' + String(ret.value) + '"'));
	    }
	  }
	}
	
	/**
	 * Convert `obj` into a normalized thunk.
	 *
	 * @param {Mixed} obj
	 * @param {Mixed} ctx
	 * @return {Function}
	 * @api private
	 */
	
	function toThunk(obj, ctx) {
	
	  if (isGeneratorFunction(obj)) {
	    return co(obj.call(ctx));
	  }
	
	  if (isGenerator(obj)) {
	    return co(obj);
	  }
	
	  if (isPromise(obj)) {
	    return promiseToThunk(obj);
	  }
	
	  if ('function' == typeof obj) {
	    return obj;
	  }
	
	  if (isObject(obj) || Array.isArray(obj)) {
	    return objectToThunk.call(ctx, obj);
	  }
	
	  return obj;
	}
	
	/**
	 * Convert an object of yieldables to a thunk.
	 *
	 * @param {Object} obj
	 * @return {Function}
	 * @api private
	 */
	
	function objectToThunk(obj){
	  var ctx = this;
	  var isArray = Array.isArray(obj);
	
	  return function(done){
	    var keys = Object.keys(obj);
	    var pending = keys.length;
	    var results = isArray
	      ? new Array(pending) // predefine the array length
	      : new obj.constructor();
	    var finished;
	
	    if (!pending) {
	      setImmediate(function(){
	        done(null, results)
	      });
	      return;
	    }
	
	    // prepopulate object keys to preserve key ordering
	    if (!isArray) {
	      for (var i = 0; i < pending; i++) {
	        results[keys[i]] = undefined;
	      }
	    }
	
	    for (var i = 0; i < keys.length; i++) {
	      run(obj[keys[i]], keys[i]);
	    }
	
	    function run(fn, key) {
	      if (finished) return;
	      try {
	        fn = toThunk(fn, ctx);
	
	        if ('function' != typeof fn) {
	          results[key] = fn;
	          return --pending || done(null, results);
	        }
	
	        fn.call(ctx, function(err, res){
	          if (finished) return;
	
	          if (err) {
	            finished = true;
	            return done(err);
	          }
	
	          results[key] = res;
	          --pending || done(null, results);
	        });
	      } catch (err) {
	        finished = true;
	        done(err);
	      }
	    }
	  }
	}
	
	/**
	 * Convert `promise` to a thunk.
	 *
	 * @param {Object} promise
	 * @return {Function}
	 * @api private
	 */
	
	function promiseToThunk(promise) {
	  return function(fn){
	    promise.then(function(res) {
	      fn(null, res);
	    }, fn);
	  }
	}
	
	/**
	 * Check if `obj` is a promise.
	 *
	 * @param {Object} obj
	 * @return {Boolean}
	 * @api private
	 */
	
	function isPromise(obj) {
	  return obj && 'function' == typeof obj.then;
	}
	
	/**
	 * Check if `obj` is a generator.
	 *
	 * @param {Mixed} obj
	 * @return {Boolean}
	 * @api private
	 */
	
	function isGenerator(obj) {
	  return obj && 'function' == typeof obj.next && 'function' == typeof obj.throw;
	}
	
	/**
	 * Check if `obj` is a generator function.
	 *
	 * @param {Mixed} obj
	 * @return {Boolean}
	 * @api private
	 */
	
	function isGeneratorFunction(obj) {
	  return obj && obj.constructor && 'GeneratorFunction' == obj.constructor.name;
	}
	
	/**
	 * Check for plain object.
	 *
	 * @param {Mixed} val
	 * @return {Boolean}
	 * @api private
	 */
	
	function isObject(val) {
	  return val && Object == val.constructor;
	}
	
	/**
	 * Throw `err` in a new stack.
	 *
	 * This is used when co() is invoked
	 * without supplying a callback, which
	 * should only be for demonstrational
	 * purposes.
	 *
	 * @param {Error} err
	 * @api private
	 */
	
	function error(err) {
	  if (!err) return;
	  setImmediate(function(){
	    throw err;
	  });
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(272).setImmediate))

/***/ }),
/* 1215 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var deselectCurrent = __webpack_require__(2233);
	
	var clipboardToIE11Formatting = {
	  "text/plain": "Text",
	  "text/html": "Url",
	  "default": "Text"
	}
	
	var defaultMessage = "Copy to clipboard: #{key}, Enter";
	
	function format(message) {
	  var copyKey = (/mac os x/i.test(navigator.userAgent) ? "⌘" : "Ctrl") + "+C";
	  return message.replace(/#{\s*key\s*}/g, copyKey);
	}
	
	function copy(text, options) {
	  var debug,
	    message,
	    reselectPrevious,
	    range,
	    selection,
	    mark,
	    success = false;
	  if (!options) {
	    options = {};
	  }
	  debug = options.debug || false;
	  try {
	    reselectPrevious = deselectCurrent();
	
	    range = document.createRange();
	    selection = document.getSelection();
	
	    mark = document.createElement("span");
	    mark.textContent = text;
	    // avoid screen readers from reading out loud the text
	    mark.ariaHidden = "true"
	    // reset user styles for span element
	    mark.style.all = "unset";
	    // prevents scrolling to the end of the page
	    mark.style.position = "fixed";
	    mark.style.top = 0;
	    mark.style.clip = "rect(0, 0, 0, 0)";
	    // used to preserve spaces and line breaks
	    mark.style.whiteSpace = "pre";
	    // do not inherit user-select (it may be `none`)
	    mark.style.webkitUserSelect = "text";
	    mark.style.MozUserSelect = "text";
	    mark.style.msUserSelect = "text";
	    mark.style.userSelect = "text";
	    mark.addEventListener("copy", function(e) {
	      e.stopPropagation();
	      if (options.format) {
	        e.preventDefault();
	        if (typeof e.clipboardData === "undefined") { // IE 11
	          debug && console.warn("unable to use e.clipboardData");
	          debug && console.warn("trying IE specific stuff");
	          window.clipboardData.clearData();
	          var format = clipboardToIE11Formatting[options.format] || clipboardToIE11Formatting["default"]
	          window.clipboardData.setData(format, text);
	        } else { // all other browsers
	          e.clipboardData.clearData();
	          e.clipboardData.setData(options.format, text);
	        }
	      }
	      if (options.onCopy) {
	        e.preventDefault();
	        options.onCopy(e.clipboardData);
	      }
	    });
	
	    document.body.appendChild(mark);
	
	    range.selectNodeContents(mark);
	    selection.addRange(range);
	
	    var successful = document.execCommand("copy");
	    if (!successful) {
	      throw new Error("copy command was unsuccessful");
	    }
	    success = true;
	  } catch (err) {
	    debug && console.error("unable to copy using execCommand: ", err);
	    debug && console.warn("trying IE specific stuff");
	    try {
	      window.clipboardData.setData(options.format || "text", text);
	      options.onCopy && options.onCopy(window.clipboardData);
	      success = true;
	    } catch (err) {
	      debug && console.error("unable to copy using clipboardData: ", err);
	      debug && console.error("falling back to prompt");
	      message = format("message" in options ? options.message : defaultMessage);
	      window.prompt(message, text);
	    }
	  } finally {
	    if (selection) {
	      if (typeof selection.removeRange == "function") {
	        selection.removeRange(range);
	      } else {
	        selection.removeAllRanges();
	      }
	    }
	
	    if (mark) {
	      document.body.removeChild(mark);
	    }
	    reselectPrevious();
	  }
	
	  return success;
	}
	
	module.exports = copy;


/***/ }),
/* 1216 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(177);
	__webpack_require__(1258);
	module.exports = __webpack_require__(29).Array.from;

/***/ }),
/* 1217 */,
/* 1218 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(236);
	__webpack_require__(177);
	module.exports = __webpack_require__(1257);

/***/ }),
/* 1219 */,
/* 1220 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1261);
	module.exports = 0x1fffffffffffff;

/***/ }),
/* 1221 */,
/* 1222 */,
/* 1223 */
/***/ (function(module, exports, __webpack_require__) {

	var $ = __webpack_require__(30);
	module.exports = function defineProperties(T, D){
	  return $.setDescs(T, D);
	};

/***/ }),
/* 1224 */,
/* 1225 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1263);
	module.exports = __webpack_require__(29).Object.freeze;

/***/ }),
/* 1226 */
/***/ (function(module, exports, __webpack_require__) {

	var $ = __webpack_require__(30);
	__webpack_require__(1264);
	module.exports = function getOwnPropertyDescriptor(it, key){
	  return $.getDesc(it, key);
	};

/***/ }),
/* 1227 */,
/* 1228 */,
/* 1229 */,
/* 1230 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1270);
	module.exports = __webpack_require__(29).Object.values;

/***/ }),
/* 1231 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(512);
	__webpack_require__(177);
	__webpack_require__(236);
	__webpack_require__(1268);
	module.exports = __webpack_require__(29).Promise;

/***/ }),
/* 1232 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1269);
	__webpack_require__(512);
	module.exports = __webpack_require__(29).Symbol;

/***/ }),
/* 1233 */,
/* 1234 */,
/* 1235 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(107)
	  , document = __webpack_require__(80).document
	  // in old IE typeof document.createElement is 'object'
	  , is = isObject(document) && isObject(document.createElement);
	module.exports = function(it){
	  return is ? document.createElement(it) : {};
	};

/***/ }),
/* 1236 */
/***/ (function(module, exports, __webpack_require__) {

	// all enumerable object keys, includes symbols
	var $ = __webpack_require__(30);
	module.exports = function(it){
	  var keys       = $.getKeys(it)
	    , getSymbols = $.getSymbols;
	  if(getSymbols){
	    var symbols = getSymbols(it)
	      , isEnum  = $.isEnum
	      , i       = 0
	      , key;
	    while(symbols.length > i)if(isEnum.call(it, key = symbols[i++]))keys.push(key);
	  }
	  return keys;
	};

/***/ }),
/* 1237 */
/***/ (function(module, exports, __webpack_require__) {

	var ctx         = __webpack_require__(135)
	  , call        = __webpack_require__(504)
	  , isArrayIter = __webpack_require__(503)
	  , anObject    = __webpack_require__(106)
	  , toLength    = __webpack_require__(510)
	  , getIterFn   = __webpack_require__(323);
	module.exports = function(iterable, entries, fn, that){
	  var iterFn = getIterFn(iterable)
	    , f      = ctx(fn, that, entries ? 2 : 1)
	    , index  = 0
	    , length, step, iterator;
	  if(typeof iterFn != 'function')throw TypeError(iterable + ' is not iterable!');
	  // fast case for arrays with default iterator
	  if(isArrayIter(iterFn))for(length = toLength(iterable.length); length > index; index++){
	    entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
	  } else for(iterator = iterFn.call(iterable); !(step = iterator.next()).done; ){
	    call(iterator, f, step.value, entries);
	  }
	};

/***/ }),
/* 1238 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(137)
	  , getNames  = __webpack_require__(30).getNames
	  , toString  = {}.toString;
	
	var windowNames = typeof window == 'object' && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function(it){
	  try {
	    return getNames(it);
	  } catch(e){
	    return windowNames.slice();
	  }
	};
	
	module.exports.get = function getOwnPropertyNames(it){
	  if(windowNames && toString.call(it) == '[object Window]')return getWindowNames(it);
	  return getNames(toIObject(it));
	};

/***/ }),
/* 1239 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(80).document && document.documentElement;

/***/ }),
/* 1240 */
/***/ (function(module, exports) {

	// fast apply, http://jsperf.lnkit.com/fast-apply/5
	module.exports = function(fn, args, that){
	  var un = that === undefined;
	  switch(args.length){
	    case 0: return un ? fn()
	                      : fn.call(that);
	    case 1: return un ? fn(args[0])
	                      : fn.call(that, args[0]);
	    case 2: return un ? fn(args[0], args[1])
	                      : fn.call(that, args[0], args[1]);
	    case 3: return un ? fn(args[0], args[1], args[2])
	                      : fn.call(that, args[0], args[1], args[2]);
	    case 4: return un ? fn(args[0], args[1], args[2], args[3])
	                      : fn.call(that, args[0], args[1], args[2], args[3]);
	  } return              fn.apply(that, args);
	};

/***/ }),
/* 1241 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(176);
	module.exports = Array.isArray || function(arg){
	  return cof(arg) == 'Array';
	};

/***/ }),
/* 1242 */,
/* 1243 */,
/* 1244 */,
/* 1245 */
/***/ (function(module, exports, __webpack_require__) {

	var $         = __webpack_require__(30)
	  , toIObject = __webpack_require__(137);
	module.exports = function(object, el){
	  var O      = toIObject(object)
	    , keys   = $.getKeys(O)
	    , length = keys.length
	    , index  = 0
	    , key;
	  while(length > index)if(O[key = keys[index++]] === el)return key;
	};

/***/ }),
/* 1246 */
/***/ (function(module, exports, __webpack_require__) {

	var global    = __webpack_require__(80)
	  , macrotask = __webpack_require__(1255).set
	  , Observer  = global.MutationObserver || global.WebKitMutationObserver
	  , process   = global.process
	  , Promise   = global.Promise
	  , isNode    = __webpack_require__(176)(process) == 'process'
	  , head, last, notify;
	
	var flush = function(){
	  var parent, domain, fn;
	  if(isNode && (parent = process.domain)){
	    process.domain = null;
	    parent.exit();
	  }
	  while(head){
	    domain = head.domain;
	    fn     = head.fn;
	    if(domain)domain.enter();
	    fn(); // <- currently we use it only for Promise - try / catch not required
	    if(domain)domain.exit();
	    head = head.next;
	  } last = undefined;
	  if(parent)parent.enter();
	};
	
	// Node.js
	if(isNode){
	  notify = function(){
	    process.nextTick(flush);
	  };
	// browsers with MutationObserver
	} else if(Observer){
	  var toggle = 1
	    , node   = document.createTextNode('');
	  new Observer(flush).observe(node, {characterData: true}); // eslint-disable-line no-new
	  notify = function(){
	    node.data = toggle = -toggle;
	  };
	// environments with maybe non-completely correct, but existent Promise
	} else if(Promise && Promise.resolve){
	  notify = function(){
	    Promise.resolve().then(flush);
	  };
	// for other environments - macrotask based on:
	// - setImmediate
	// - MessageChannel
	// - window.postMessag
	// - onreadystatechange
	// - setTimeout
	} else {
	  notify = function(){
	    // strange IE + webpack dev server bug - use .call(global)
	    macrotask.call(global, flush);
	  };
	}
	
	module.exports = function asap(fn){
	  var task = {fn: fn, next: undefined, domain: isNode && process.domain};
	  if(last)last.next = task;
	  if(!head){
	    head = task;
	    notify();
	  } last = task;
	};

/***/ }),
/* 1247 */,
/* 1248 */
/***/ (function(module, exports, __webpack_require__) {

	var $         = __webpack_require__(30)
	  , toIObject = __webpack_require__(137)
	  , isEnum    = $.isEnum;
	module.exports = function(isEntries){
	  return function(it){
	    var O      = toIObject(it)
	      , keys   = $.getKeys(O)
	      , length = keys.length
	      , i      = 0
	      , result = []
	      , key;
	    while(length > i)if(isEnum.call(O, key = keys[i++])){
	      result.push(isEntries ? [key, O[key]] : O[key]);
	    } return result;
	  };
	};

/***/ }),
/* 1249 */
/***/ (function(module, exports, __webpack_require__) {

	var redefine = __webpack_require__(321);
	module.exports = function(target, src){
	  for(var key in src)redefine(target, key, src[key]);
	  return target;
	};

/***/ }),
/* 1250 */
/***/ (function(module, exports) {

	// 7.2.9 SameValue(x, y)
	module.exports = Object.is || function is(x, y){
	  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
	};

/***/ }),
/* 1251 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var core        = __webpack_require__(29)
	  , $           = __webpack_require__(30)
	  , DESCRIPTORS = __webpack_require__(232)
	  , SPECIES     = __webpack_require__(40)('species');
	
	module.exports = function(KEY){
	  var C = core[KEY];
	  if(DESCRIPTORS && C && !C[SPECIES])$.setDesc(C, SPECIES, {
	    configurable: true,
	    get: function(){ return this; }
	  });
	};

/***/ }),
/* 1252 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.3.20 SpeciesConstructor(O, defaultConstructor)
	var anObject  = __webpack_require__(106)
	  , aFunction = __webpack_require__(314)
	  , SPECIES   = __webpack_require__(40)('species');
	module.exports = function(O, D){
	  var C = anObject(O).constructor, S;
	  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
	};

/***/ }),
/* 1253 */
/***/ (function(module, exports) {

	module.exports = function(it, Constructor, name){
	  if(!(it instanceof Constructor))throw TypeError(name + ": use the 'new' operator!");
	  return it;
	};

/***/ }),
/* 1254 */,
/* 1255 */
/***/ (function(module, exports, __webpack_require__) {

	var ctx                = __webpack_require__(135)
	  , invoke             = __webpack_require__(1240)
	  , html               = __webpack_require__(1239)
	  , cel                = __webpack_require__(1235)
	  , global             = __webpack_require__(80)
	  , process            = global.process
	  , setTask            = global.setImmediate
	  , clearTask          = global.clearImmediate
	  , MessageChannel     = global.MessageChannel
	  , counter            = 0
	  , queue              = {}
	  , ONREADYSTATECHANGE = 'onreadystatechange'
	  , defer, channel, port;
	var run = function(){
	  var id = +this;
	  if(queue.hasOwnProperty(id)){
	    var fn = queue[id];
	    delete queue[id];
	    fn();
	  }
	};
	var listner = function(event){
	  run.call(event.data);
	};
	// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
	if(!setTask || !clearTask){
	  setTask = function setImmediate(fn){
	    var args = [], i = 1;
	    while(arguments.length > i)args.push(arguments[i++]);
	    queue[++counter] = function(){
	      invoke(typeof fn == 'function' ? fn : Function(fn), args);
	    };
	    defer(counter);
	    return counter;
	  };
	  clearTask = function clearImmediate(id){
	    delete queue[id];
	  };
	  // Node.js 0.8-
	  if(__webpack_require__(176)(process) == 'process'){
	    defer = function(id){
	      process.nextTick(ctx(run, id, 1));
	    };
	  // Browsers with MessageChannel, includes WebWorkers
	  } else if(MessageChannel){
	    channel = new MessageChannel;
	    port    = channel.port2;
	    channel.port1.onmessage = listner;
	    defer = ctx(port.postMessage, port, 1);
	  // Browsers with postMessage, skip WebWorkers
	  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
	  } else if(global.addEventListener && typeof postMessage == 'function' && !global.importScripts){
	    defer = function(id){
	      global.postMessage(id + '', '*');
	    };
	    global.addEventListener('message', listner, false);
	  // IE8-
	  } else if(ONREADYSTATECHANGE in cel('script')){
	    defer = function(id){
	      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function(){
	        html.removeChild(this);
	        run.call(id);
	      };
	    };
	  // Rest old browsers
	  } else {
	    defer = function(id){
	      setTimeout(ctx(run, id, 1), 0);
	    };
	  }
	}
	module.exports = {
	  set:   setTask,
	  clear: clearTask
	};

/***/ }),
/* 1256 */,
/* 1257 */
/***/ (function(module, exports, __webpack_require__) {

	var classof   = __webpack_require__(315)
	  , ITERATOR  = __webpack_require__(40)('iterator')
	  , Iterators = __webpack_require__(136);
	module.exports = __webpack_require__(29).isIterable = function(it){
	  var O = Object(it);
	  return O[ITERATOR] !== undefined
	    || '@@iterator' in O
	    || Iterators.hasOwnProperty(classof(O));
	};

/***/ }),
/* 1258 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var ctx         = __webpack_require__(135)
	  , $export     = __webpack_require__(63)
	  , toObject    = __webpack_require__(322)
	  , call        = __webpack_require__(504)
	  , isArrayIter = __webpack_require__(503)
	  , toLength    = __webpack_require__(510)
	  , getIterFn   = __webpack_require__(323);
	$export($export.S + $export.F * !__webpack_require__(506)(function(iter){ Array.from(iter); }), 'Array', {
	  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
	  from: function from(arrayLike/*, mapfn = undefined, thisArg = undefined*/){
	    var O       = toObject(arrayLike)
	      , C       = typeof this == 'function' ? this : Array
	      , $$      = arguments
	      , $$len   = $$.length
	      , mapfn   = $$len > 1 ? $$[1] : undefined
	      , mapping = mapfn !== undefined
	      , index   = 0
	      , iterFn  = getIterFn(O)
	      , length, result, step, iterator;
	    if(mapping)mapfn = ctx(mapfn, $$len > 2 ? $$[2] : undefined, 2);
	    // if object isn't iterable or it's array with default iterator - use simple case
	    if(iterFn != undefined && !(C == Array && isArrayIter(iterFn))){
	      for(iterator = iterFn.call(O), result = new C; !(step = iterator.next()).done; index++){
	        result[index] = mapping ? call(iterator, mapfn, [step.value, index], true) : step.value;
	      }
	    } else {
	      length = toLength(O.length);
	      for(result = new C(length); length > index; index++){
	        result[index] = mapping ? mapfn(O[index], index) : O[index];
	      }
	    }
	    result.length = index;
	    return result;
	  }
	});


/***/ }),
/* 1259 */,
/* 1260 */,
/* 1261 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.6 Number.MAX_SAFE_INTEGER
	var $export = __webpack_require__(63);
	
	$export($export.S, 'Number', {MAX_SAFE_INTEGER: 0x1fffffffffffff});

/***/ }),
/* 1262 */,
/* 1263 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.5 Object.freeze(O)
	var isObject = __webpack_require__(107);
	
	__webpack_require__(234)('freeze', function($freeze){
	  return function freeze(it){
	    return $freeze && isObject(it) ? $freeze(it) : it;
	  };
	});

/***/ }),
/* 1264 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	var toIObject = __webpack_require__(137);
	
	__webpack_require__(234)('getOwnPropertyDescriptor', function($getOwnPropertyDescriptor){
	  return function getOwnPropertyDescriptor(it, key){
	    return $getOwnPropertyDescriptor(toIObject(it), key);
	  };
	});

/***/ }),
/* 1265 */,
/* 1266 */,
/* 1267 */,
/* 1268 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $          = __webpack_require__(30)
	  , LIBRARY    = __webpack_require__(319)
	  , global     = __webpack_require__(80)
	  , ctx        = __webpack_require__(135)
	  , classof    = __webpack_require__(315)
	  , $export    = __webpack_require__(63)
	  , isObject   = __webpack_require__(107)
	  , anObject   = __webpack_require__(106)
	  , aFunction  = __webpack_require__(314)
	  , strictNew  = __webpack_require__(1253)
	  , forOf      = __webpack_require__(1237)
	  , setProto   = __webpack_require__(507).set
	  , same       = __webpack_require__(1250)
	  , SPECIES    = __webpack_require__(40)('species')
	  , speciesConstructor = __webpack_require__(1252)
	  , asap       = __webpack_require__(1246)
	  , PROMISE    = 'Promise'
	  , process    = global.process
	  , isNode     = classof(process) == 'process'
	  , P          = global[PROMISE]
	  , empty      = function(){ /* empty */ }
	  , Wrapper;
	
	var testResolve = function(sub){
	  var test = new P(empty), promise;
	  if(sub)test.constructor = function(exec){
	    exec(empty, empty);
	  };
	  (promise = P.resolve(test))['catch'](empty);
	  return promise === test;
	};
	
	var USE_NATIVE = function(){
	  var works = false;
	  function P2(x){
	    var self = new P(x);
	    setProto(self, P2.prototype);
	    return self;
	  }
	  try {
	    works = P && P.resolve && testResolve();
	    setProto(P2, P);
	    P2.prototype = $.create(P.prototype, {constructor: {value: P2}});
	    // actual Firefox has broken subclass support, test that
	    if(!(P2.resolve(5).then(function(){}) instanceof P2)){
	      works = false;
	    }
	    // actual V8 bug, https://code.google.com/p/v8/issues/detail?id=4162
	    if(works && __webpack_require__(232)){
	      var thenableThenGotten = false;
	      P.resolve($.setDesc({}, 'then', {
	        get: function(){ thenableThenGotten = true; }
	      }));
	      works = thenableThenGotten;
	    }
	  } catch(e){ works = false; }
	  return works;
	}();
	
	// helpers
	var sameConstructor = function(a, b){
	  // library wrapper special case
	  if(LIBRARY && a === P && b === Wrapper)return true;
	  return same(a, b);
	};
	var getConstructor = function(C){
	  var S = anObject(C)[SPECIES];
	  return S != undefined ? S : C;
	};
	var isThenable = function(it){
	  var then;
	  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
	};
	var PromiseCapability = function(C){
	  var resolve, reject;
	  this.promise = new C(function($$resolve, $$reject){
	    if(resolve !== undefined || reject !== undefined)throw TypeError('Bad Promise constructor');
	    resolve = $$resolve;
	    reject  = $$reject;
	  });
	  this.resolve = aFunction(resolve),
	  this.reject  = aFunction(reject)
	};
	var perform = function(exec){
	  try {
	    exec();
	  } catch(e){
	    return {error: e};
	  }
	};
	var notify = function(record, isReject){
	  if(record.n)return;
	  record.n = true;
	  var chain = record.c;
	  asap(function(){
	    var value = record.v
	      , ok    = record.s == 1
	      , i     = 0;
	    var run = function(reaction){
	      var handler = ok ? reaction.ok : reaction.fail
	        , resolve = reaction.resolve
	        , reject  = reaction.reject
	        , result, then;
	      try {
	        if(handler){
	          if(!ok)record.h = true;
	          result = handler === true ? value : handler(value);
	          if(result === reaction.promise){
	            reject(TypeError('Promise-chain cycle'));
	          } else if(then = isThenable(result)){
	            then.call(result, resolve, reject);
	          } else resolve(result);
	        } else reject(value);
	      } catch(e){
	        reject(e);
	      }
	    };
	    while(chain.length > i)run(chain[i++]); // variable length - can't use forEach
	    chain.length = 0;
	    record.n = false;
	    if(isReject)setTimeout(function(){
	      var promise = record.p
	        , handler, console;
	      if(isUnhandled(promise)){
	        if(isNode){
	          process.emit('unhandledRejection', value, promise);
	        } else if(handler = global.onunhandledrejection){
	          handler({promise: promise, reason: value});
	        } else if((console = global.console) && console.error){
	          console.error('Unhandled promise rejection', value);
	        }
	      } record.a = undefined;
	    }, 1);
	  });
	};
	var isUnhandled = function(promise){
	  var record = promise._d
	    , chain  = record.a || record.c
	    , i      = 0
	    , reaction;
	  if(record.h)return false;
	  while(chain.length > i){
	    reaction = chain[i++];
	    if(reaction.fail || !isUnhandled(reaction.promise))return false;
	  } return true;
	};
	var $reject = function(value){
	  var record = this;
	  if(record.d)return;
	  record.d = true;
	  record = record.r || record; // unwrap
	  record.v = value;
	  record.s = 2;
	  record.a = record.c.slice();
	  notify(record, true);
	};
	var $resolve = function(value){
	  var record = this
	    , then;
	  if(record.d)return;
	  record.d = true;
	  record = record.r || record; // unwrap
	  try {
	    if(record.p === value)throw TypeError("Promise can't be resolved itself");
	    if(then = isThenable(value)){
	      asap(function(){
	        var wrapper = {r: record, d: false}; // wrap
	        try {
	          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
	        } catch(e){
	          $reject.call(wrapper, e);
	        }
	      });
	    } else {
	      record.v = value;
	      record.s = 1;
	      notify(record, false);
	    }
	  } catch(e){
	    $reject.call({r: record, d: false}, e); // wrap
	  }
	};
	
	// constructor polyfill
	if(!USE_NATIVE){
	  // 25.4.3.1 Promise(executor)
	  P = function Promise(executor){
	    aFunction(executor);
	    var record = this._d = {
	      p: strictNew(this, P, PROMISE),         // <- promise
	      c: [],                                  // <- awaiting reactions
	      a: undefined,                           // <- checked in isUnhandled reactions
	      s: 0,                                   // <- state
	      d: false,                               // <- done
	      v: undefined,                           // <- value
	      h: false,                               // <- handled rejection
	      n: false                                // <- notify
	    };
	    try {
	      executor(ctx($resolve, record, 1), ctx($reject, record, 1));
	    } catch(err){
	      $reject.call(record, err);
	    }
	  };
	  __webpack_require__(1249)(P.prototype, {
	    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
	    then: function then(onFulfilled, onRejected){
	      var reaction = new PromiseCapability(speciesConstructor(this, P))
	        , promise  = reaction.promise
	        , record   = this._d;
	      reaction.ok   = typeof onFulfilled == 'function' ? onFulfilled : true;
	      reaction.fail = typeof onRejected == 'function' && onRejected;
	      record.c.push(reaction);
	      if(record.a)record.a.push(reaction);
	      if(record.s)notify(record, false);
	      return promise;
	    },
	    // 25.4.5.1 Promise.prototype.catch(onRejected)
	    'catch': function(onRejected){
	      return this.then(undefined, onRejected);
	    }
	  });
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, {Promise: P});
	__webpack_require__(235)(P, PROMISE);
	__webpack_require__(1251)(PROMISE);
	Wrapper = __webpack_require__(29)[PROMISE];
	
	// statics
	$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
	  // 25.4.4.5 Promise.reject(r)
	  reject: function reject(r){
	    var capability = new PromiseCapability(this)
	      , $$reject   = capability.reject;
	    $$reject(r);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * (!USE_NATIVE || testResolve(true)), PROMISE, {
	  // 25.4.4.6 Promise.resolve(x)
	  resolve: function resolve(x){
	    // instanceof instead of internal slot check because we should fix it without replacement native Promise core
	    if(x instanceof P && sameConstructor(x.constructor, this))return x;
	    var capability = new PromiseCapability(this)
	      , $$resolve  = capability.resolve;
	    $$resolve(x);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(506)(function(iter){
	  P.all(iter)['catch'](function(){});
	})), PROMISE, {
	  // 25.4.4.1 Promise.all(iterable)
	  all: function all(iterable){
	    var C          = getConstructor(this)
	      , capability = new PromiseCapability(C)
	      , resolve    = capability.resolve
	      , reject     = capability.reject
	      , values     = [];
	    var abrupt = perform(function(){
	      forOf(iterable, false, values.push, values);
	      var remaining = values.length
	        , results   = Array(remaining);
	      if(remaining)$.each.call(values, function(promise, index){
	        var alreadyCalled = false;
	        C.resolve(promise).then(function(value){
	          if(alreadyCalled)return;
	          alreadyCalled = true;
	          results[index] = value;
	          --remaining || resolve(results);
	        }, reject);
	      });
	      else resolve(results);
	    });
	    if(abrupt)reject(abrupt.error);
	    return capability.promise;
	  },
	  // 25.4.4.4 Promise.race(iterable)
	  race: function race(iterable){
	    var C          = getConstructor(this)
	      , capability = new PromiseCapability(C)
	      , reject     = capability.reject;
	    var abrupt = perform(function(){
	      forOf(iterable, false, function(promise){
	        C.resolve(promise).then(capability.resolve, reject);
	      });
	    });
	    if(abrupt)reject(abrupt.error);
	    return capability.promise;
	  }
	});

/***/ }),
/* 1269 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// ECMAScript 6 symbols shim
	var $              = __webpack_require__(30)
	  , global         = __webpack_require__(80)
	  , has            = __webpack_require__(317)
	  , DESCRIPTORS    = __webpack_require__(232)
	  , $export        = __webpack_require__(63)
	  , redefine       = __webpack_require__(321)
	  , $fails         = __webpack_require__(233)
	  , shared         = __webpack_require__(508)
	  , setToStringTag = __webpack_require__(235)
	  , uid            = __webpack_require__(511)
	  , wks            = __webpack_require__(40)
	  , keyOf          = __webpack_require__(1245)
	  , $names         = __webpack_require__(1238)
	  , enumKeys       = __webpack_require__(1236)
	  , isArray        = __webpack_require__(1241)
	  , anObject       = __webpack_require__(106)
	  , toIObject      = __webpack_require__(137)
	  , createDesc     = __webpack_require__(320)
	  , getDesc        = $.getDesc
	  , setDesc        = $.setDesc
	  , _create        = $.create
	  , getNames       = $names.get
	  , $Symbol        = global.Symbol
	  , $JSON          = global.JSON
	  , _stringify     = $JSON && $JSON.stringify
	  , setter         = false
	  , HIDDEN         = wks('_hidden')
	  , isEnum         = $.isEnum
	  , SymbolRegistry = shared('symbol-registry')
	  , AllSymbols     = shared('symbols')
	  , useNative      = typeof $Symbol == 'function'
	  , ObjectProto    = Object.prototype;
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function(){
	  return _create(setDesc({}, 'a', {
	    get: function(){ return setDesc(this, 'a', {value: 7}).a; }
	  })).a != 7;
	}) ? function(it, key, D){
	  var protoDesc = getDesc(ObjectProto, key);
	  if(protoDesc)delete ObjectProto[key];
	  setDesc(it, key, D);
	  if(protoDesc && it !== ObjectProto)setDesc(ObjectProto, key, protoDesc);
	} : setDesc;
	
	var wrap = function(tag){
	  var sym = AllSymbols[tag] = _create($Symbol.prototype);
	  sym._k = tag;
	  DESCRIPTORS && setter && setSymbolDesc(ObjectProto, tag, {
	    configurable: true,
	    set: function(value){
	      if(has(this, HIDDEN) && has(this[HIDDEN], tag))this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    }
	  });
	  return sym;
	};
	
	var isSymbol = function(it){
	  return typeof it == 'symbol';
	};
	
	var $defineProperty = function defineProperty(it, key, D){
	  if(D && has(AllSymbols, key)){
	    if(!D.enumerable){
	      if(!has(it, HIDDEN))setDesc(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if(has(it, HIDDEN) && it[HIDDEN][key])it[HIDDEN][key] = false;
	      D = _create(D, {enumerable: createDesc(0, false)});
	    } return setSymbolDesc(it, key, D);
	  } return setDesc(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P){
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P))
	    , i    = 0
	    , l = keys.length
	    , key;
	  while(l > i)$defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P){
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key){
	  var E = isEnum.call(this, key);
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key]
	    ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key){
	  var D = getDesc(it = toIObject(it), key);
	  if(D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key]))D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it){
	  var names  = getNames(toIObject(it))
	    , result = []
	    , i      = 0
	    , key;
	  while(names.length > i)if(!has(AllSymbols, key = names[i++]) && key != HIDDEN)result.push(key);
	  return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it){
	  var names  = getNames(toIObject(it))
	    , result = []
	    , i      = 0
	    , key;
	  while(names.length > i)if(has(AllSymbols, key = names[i++]))result.push(AllSymbols[key]);
	  return result;
	};
	var $stringify = function stringify(it){
	  if(it === undefined || isSymbol(it))return; // IE8 returns string on undefined
	  var args = [it]
	    , i    = 1
	    , $$   = arguments
	    , replacer, $replacer;
	  while($$.length > i)args.push($$[i++]);
	  replacer = args[1];
	  if(typeof replacer == 'function')$replacer = replacer;
	  if($replacer || !isArray(replacer))replacer = function(key, value){
	    if($replacer)value = $replacer.call(this, key, value);
	    if(!isSymbol(value))return value;
	  };
	  args[1] = replacer;
	  return _stringify.apply($JSON, args);
	};
	var buggyJSON = $fails(function(){
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({a: S}) != '{}' || _stringify(Object(S)) != '{}';
	});
	
	// 19.4.1.1 Symbol([description])
	if(!useNative){
	  $Symbol = function Symbol(){
	    if(isSymbol(this))throw TypeError('Symbol is not a constructor');
	    return wrap(uid(arguments.length > 0 ? arguments[0] : undefined));
	  };
	  redefine($Symbol.prototype, 'toString', function toString(){
	    return this._k;
	  });
	
	  isSymbol = function(it){
	    return it instanceof $Symbol;
	  };
	
	  $.create     = $create;
	  $.isEnum     = $propertyIsEnumerable;
	  $.getDesc    = $getOwnPropertyDescriptor;
	  $.setDesc    = $defineProperty;
	  $.setDescs   = $defineProperties;
	  $.getNames   = $names.get = $getOwnPropertyNames;
	  $.getSymbols = $getOwnPropertySymbols;
	
	  if(DESCRIPTORS && !__webpack_require__(319)){
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }
	}
	
	var symbolStatics = {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function(key){
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(key){
	    return keyOf(SymbolRegistry, key);
	  },
	  useSetter: function(){ setter = true; },
	  useSimple: function(){ setter = false; }
	};
	// 19.4.2.2 Symbol.hasInstance
	// 19.4.2.3 Symbol.isConcatSpreadable
	// 19.4.2.4 Symbol.iterator
	// 19.4.2.6 Symbol.match
	// 19.4.2.8 Symbol.replace
	// 19.4.2.9 Symbol.search
	// 19.4.2.10 Symbol.species
	// 19.4.2.11 Symbol.split
	// 19.4.2.12 Symbol.toPrimitive
	// 19.4.2.13 Symbol.toStringTag
	// 19.4.2.14 Symbol.unscopables
	$.each.call((
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,' +
	  'species,split,toPrimitive,toStringTag,unscopables'
	).split(','), function(it){
	  var sym = wks(it);
	  symbolStatics[it] = useNative ? sym : wrap(sym);
	});
	
	setter = true;
	
	$export($export.G + $export.W, {Symbol: $Symbol});
	
	$export($export.S, 'Symbol', symbolStatics);
	
	$export($export.S + $export.F * !useNative, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});
	
	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!useNative || buggyJSON), 'JSON', {stringify: $stringify});
	
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);

/***/ }),
/* 1270 */
/***/ (function(module, exports, __webpack_require__) {

	// http://goo.gl/XkBrjD
	var $export = __webpack_require__(63)
	  , $values = __webpack_require__(1248)(false);
	
	$export($export.S, 'Object', {
	  values: function values(it){
	    return $values(it);
	  }
	});

/***/ }),
/* 1271 */,
/* 1272 */,
/* 1273 */,
/* 1274 */,
/* 1275 */,
/* 1276 */,
/* 1277 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(12)();
	// imports
	
	
	// module
	exports.push([module.id, ".react-spinner{position:relative;width:32px;height:32px;top:50%;left:50%}.react-spinner_bar{animation:react-spinner_spin 1.2s linear infinite;border-radius:5px;background-color:#fff;position:absolute;width:20%;height:7.8%;top:-3.9%;left:-10%}@keyframes react-spinner_spin{0%{opacity:1}to{opacity:.15}}", ""]);
	
	// exports


/***/ }),
/* 1278 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(12)();
	// imports
	
	
	// module
	exports.push([module.id, ".epsHybridAssembly .heading-image{width:80%;height:80%;object-fit:contain;display:block;margin:0 auto}.epsHybridAssembly .heading-image-before{width:75%;height:auto;object-fit:inherit}.epsHybridAssembly .flex-image{width:45%;display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;-ms-flex-item-align:center;align-self:center}.epsHybridAssembly .flex-image>img.eps-logo{-ms-flex:1 1 auto;flex:1 1 auto}.epsHybridAssembly .spectacle-content .ui-slide .title-image h1{background-color:#000;width:80%;padding:1% 3% 1.5%;margin:0 auto;position:relative;z-index:1;font-family:BrandonTextWeb,Helvetica,Arial,sans-serif;font-size:1.1em;text-shadow:none;font-weight:400}.epsHybridAssembly .spectacle-content .ui-slide .title-image h2{background-color:#b4e166;width:80%;padding:3%;margin:0 auto;position:relative;font-family:BrandonTextWeb,Helvetica,Arial,sans-serif;font-size:2.4em;text-shadow:0 0 20px rgba(0,0,0,.3);font-weight:800;color:#000;text-align:center}.epsHybridAssembly .spectacle-content .ui-slide .title-image h2:after,.epsHybridAssembly .spectacle-content .ui-slide .title-image h2:before{content:\"\";position:absolute;display:block;bottom:-.5em;border:.75em solid #9fd93b;z-index:-1}.epsHybridAssembly .spectacle-content .ui-slide .title-image h2:before{left:-1em;border-right-width:.75em;border-left-color:transparent}.epsHybridAssembly .spectacle-content .ui-slide .title-image h2:after{right:-1em;border-left-width:.75em;border-right-color:transparent}.epsHybridAssembly .spectacle-content .ui-slide .title-image h2 strong:after,.epsHybridAssembly .spectacle-content .ui-slide .title-image h2 strong:before{content:\"\";position:absolute;display:block;border-style:solid;border-color:#85bc25 transparent transparent;bottom:-.5em}.epsHybridAssembly .spectacle-content .ui-slide .title-image h2 strong:before{left:0;border-width:.5em 0 0 .5em}.epsHybridAssembly .spectacle-content .ui-slide .title-image h2 strong:after{right:0;border-width:.5em .5em 0 0}.epsHybridAssembly .title-image{width:22em;height:25em;position:relative;margin:0 auto;z-index:1}.epsHybridAssembly .title-image:after{display:block;content:\"\";position:absolute;top:7%;right:10%;bottom:7em;left:10%;border-top-left-radius:5%;border-top-right-radius:5%}.epsHybridAssembly .title-image img{position:relative;z-index:2;height:18em;width:auto}.epsHybridAssembly .spectacle-deck:before{content:\"\";display:block;position:absolute;top:0;right:0;bottom:0;left:0}.epsHybridAssembly.deck-level-prep{background-color:#000;background-position:50%;background-image:linear-gradient(rgba(12,44,60,.5) 1px,transparent 0),linear-gradient(#0c2c3c 1px,transparent 0),linear-gradient(90deg,rgba(12,44,60,.5) 1px,transparent 0),linear-gradient(90deg,rgba(12,44,60,.7) 1px,transparent 0),linear-gradient(transparent 3px,#000 0,#000 73px,transparent 0),linear-gradient(90deg,rgba(12,44,60,.7) 3px,transparent 0,transparent 73px,rgba(12,44,60,.7) 0);background-size:5px 5px,75px 75px,5px 5px,75px 75px,75px 75px,75px 75px}.epsHybridAssembly.deck-level-prep .spectacle-content h3{margin-bottom:0;color:#37bad5}.epsHybridAssembly.deck-level-prep .text-formatted{font-size:1.4em}.epsHybridAssembly.deck-level-1 .deck-slide-transition-group,.epsHybridAssembly.deck-level-1 .title-image:after{background-color:#247530}.epsHybridAssembly.deck-level-1 .level-1 .overview-level-image,.epsHybridAssembly.deck-level-1 .spectacle-content .ui-slide .title-image h1{color:#247530}.epsHybridAssembly.deck-level-2 .deck-slide-transition-group,.epsHybridAssembly.deck-level-2 .title-image:after{background-color:#000}.epsHybridAssembly.deck-level-2 .level-2 .overview-level-image,.epsHybridAssembly.deck-level-2 .spectacle-content .ui-slide .title-image h1{color:#000}.epsHybridAssembly.deck-level-3 .deck-slide-transition-group,.epsHybridAssembly.deck-level-3 .title-image:after{background-color:#000}.epsHybridAssembly.deck-level-3 .level-3 .overview-level-image,.epsHybridAssembly.deck-level-3 .spectacle-content .ui-slide .title-image h1{color:#000}.epsHybridAssembly.deck-level-4 .deck-slide-transition-group,.epsHybridAssembly.deck-level-4 .title-image:after{background-color:#000}.epsHybridAssembly.deck-level-4 .level-4 .overview-level-image,.epsHybridAssembly.deck-level-4 .spectacle-content .ui-slide .title-image h1{color:#000}.epsHybridAssembly.deck-level-5 .deck-slide-transition-group,.epsHybridAssembly.deck-level-5 .title-image:after{background-color:#000}.epsHybridAssembly.deck-level-5 .level-5 .overview-level-image,.epsHybridAssembly.deck-level-5 .spectacle-content .ui-slide .title-image h1{color:#000}.epsHybridAssembly.deck-level-6 .deck-slide-transition-group,.epsHybridAssembly.deck-level-6 .title-image:after{background-color:#000}.epsHybridAssembly.deck-level-6 .level-6 .overview-level-image,.epsHybridAssembly.deck-level-6 .spectacle-content .ui-slide .title-image h1{color:#000}.epsHybridAssembly .level-1 .overview-level-image{background-color:#247530}.epsHybridAssembly .level-2 .overview-level-image,.epsHybridAssembly .level-3 .overview-level-image,.epsHybridAssembly .level-4 .overview-level-image,.epsHybridAssembly .level-5 .overview-level-image,.epsHybridAssembly .level-6 .overview-level-image{background-color:#000}.epsHybridAssembly .slide-content{-ms-flex:1 1 0%;flex:1 1 0%;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-pack:center;justify-content:center;height:100%}.epsHybridAssembly .spectacle-content h1{margin:.25em auto;color:#fff;font-size:2.5em;font-family:BrandonTextWeb;line-height:1;font-weight:700}.epsHybridAssembly .spectacle-content h2{margin:.125em auto;font-weight:100}.epsHybridAssembly .spectacle-content h2,.epsHybridAssembly .spectacle-content h3{color:#fff;font-size:2em;font-family:BrandonTextWeb;line-height:1;letter-spacing:-.5px}.epsHybridAssembly .spectacle-content h3{margin:0 auto .125em;font-weight:700}.epsHybridAssembly .spectacle-content h4{font-size:1.6em;letter-spacing:0}.epsHybridAssembly .spectacle-content h4,.epsHybridAssembly .spectacle-content h6{margin:.5em auto;color:#fff;font-family:BrandonTextWeb;line-height:1;font-weight:400;text-transform:none}.epsHybridAssembly .spectacle-content h6{font-size:3.5em;letter-spacing:-.033em;text-align:center}.epsHybridAssembly .spectacle-content blockquote{text-align:left;position:relative;display:inline-block}.epsHybridAssembly .spectacle-content quote{border-left:1px solid #37bad5;padding-left:40;display:block;color:#37bad5;font-size:49px;line-height:1;font-weight:700}.epsHybridAssembly .spectacle-content cite{color:#fff;display:block;clear:left;font-size:20px;margin-top:1em}.epsHybridAssembly .spectacle-content content{margin:0 auto;text-align:center}.epsHybridAssembly .spectacle-content .ui-slide{background-color:#000;background-position:50%;background-image:linear-gradient(rgba(12,44,60,.5) 1px,transparent 0),linear-gradient(#0c2c3c 1px,transparent 0),linear-gradient(90deg,rgba(12,44,60,.5) 1px,transparent 0),linear-gradient(90deg,rgba(12,44,60,.7) 1px,transparent 0),linear-gradient(transparent 3px,#000 0,#000 73px,transparent 0),linear-gradient(90deg,rgba(12,44,60,.7) 3px,transparent 0,transparent 73px,rgba(12,44,60,.7) 0);background-size:5px 5px,75px 75px,5px 5px,75px 75px,75px 75px,75px 75px;-ms-flex:1;flex:1;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-pack:center;justify-content:center;padding:12.5%;font-family:Orbitron;color:#37bad5}.epsHybridAssembly .spectacle-content .ui-slide h1,.epsHybridAssembly .spectacle-content .ui-slide h2,.epsHybridAssembly .spectacle-content .ui-slide h3,.epsHybridAssembly .spectacle-content .ui-slide h4,.epsHybridAssembly .spectacle-content .ui-slide h5,.epsHybridAssembly .spectacle-content .ui-slide h6{color:#37bad5;font-family:Orbitron}.epsHybridAssembly .spectacle-content .ui-slide h1{margin:.25em 0 .75em;font-size:32px;font-size:3.6vw;text-align:center;text-shadow:0 0 5px #37bad5}@media (max-width:767px){.epsHybridAssembly .spectacle-content .ui-slide h1{font-size:18px;font-size:6vw}}.epsHybridAssembly .spectacle-content .ui-slide h2{color:#11abcd;font-size:1.8em;font-weight:700}.epsHybridAssembly .spectacle-content .ui-slide h3{color:#37bad5;text-shadow:0 0 5px #37bad5;font-size:1.6em;font-weight:400}.epsHybridAssembly .spectacle-content .ui-slide .flex-image+h3{margin-top:.5em;color:#b4e166;animation:glowing;text-align:center}.epsHybridAssembly .spectacle-content .ui-slide [class*=\" ppa-icon-\"]:before,.epsHybridAssembly .spectacle-content .ui-slide [class^=ppa-icon-]:before{margin:0}.epsHybridAssembly .spectacle-content .ui-slide .level-header{display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;-ms-flex-align:center;align-items:center;padding-bottom:2vw;min-height:8vw;min-height:8vmax}.epsHybridAssembly .spectacle-content .ui-slide .level-header .level-header-thumb{position:relative;display:block;margin:0 30px;height:6.5vw;width:6.5vw;border-radius:10px}.epsHybridAssembly .spectacle-content .ui-slide .level-header .level-header-thumb img{width:auto;height:7vw;margin:-.25vw}.epsHybridAssembly .spectacle-content .ui-slide .level-header .level-header-thumb:after,.epsHybridAssembly .spectacle-content .ui-slide .level-header .level-header-thumb:before{content:\"\";display:block;border:3px solid #11abcd;width:10px;position:absolute;top:0;bottom:0}.epsHybridAssembly .spectacle-content .ui-slide .level-header .level-header-thumb:before{border-top-left-radius:10px;border-bottom-left-radius:10px;left:-20px;border-right:none}.epsHybridAssembly .spectacle-content .ui-slide .level-header .level-header-thumb:after{border-top-right-radius:10px;border-bottom-right-radius:10px;right:-20px;border-left:none}.epsHybridAssembly .spectacle-content .ui-slide .level-header .level-header-thumb+h2{margin-left:.5vw}.epsHybridAssembly .spectacle-content .ui-slide .level-header h2{-ms-flex:1;flex:1}.epsHybridAssembly .spectacle-content .ui-slide.mission-report-level-1 .level-header-thumb{background-color:#247530;box-shadow:0 0 15px #247530}.epsHybridAssembly .spectacle-content .ui-slide.mission-report-level-2 .level-header-thumb,.epsHybridAssembly .spectacle-content .ui-slide.mission-report-level-3 .level-header-thumb,.epsHybridAssembly .spectacle-content .ui-slide.mission-report-level-4 .level-header-thumb,.epsHybridAssembly .spectacle-content .ui-slide.mission-report-level-5 .level-header-thumb{background-color:#000;box-shadow:0 0 15px #000}.epsHybridAssembly .spectacle-content .ui-slide .mission-report{border-top:2px solid #11abcd;border-bottom:2px solid #11abcd;padding:2.5vw 3vw;max-height:60vh;overflow-y:hidden;counter-reset:missioncounter}.epsHybridAssembly .spectacle-content .ui-slide .mission-report .form-fields{padding:0;width:100%}.epsHybridAssembly .spectacle-content .ui-slide .mission-report .form-horizontal{display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row}.epsHybridAssembly .spectacle-content .ui-slide .mission-report .form-horizontal .question-group-wrapper{margin:0 0 .5em}.epsHybridAssembly .spectacle-content .ui-slide .mission-report .form-horizontal .question-group-error{color:red;font-size:.8em;line-height:.8em}.epsHybridAssembly .spectacle-content .ui-slide .mission-report .form-horizontal .question-group{margin:0;display:-ms-flexbox;display:flex;-ms-flex-flow:wrap;flex-flow:wrap;-ms-flex-direction:row;flex-direction:row;-ms-flex-align:center;align-items:center}.epsHybridAssembly .spectacle-content .ui-slide .mission-report .form-horizontal .question-group:before{content:counter(missioncounter) \".\";counter-increment:missioncounter 1;display:block;width:1.5em;font-size:1.2em;line-height:1.2em;text-align:left;font-weight:700}.epsHybridAssembly .spectacle-content .ui-slide .mission-report .form-horizontal .button-group{margin-left:2.5vw;-ms-flex-preferred-size:240px;flex-basis:240px;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center}.epsHybridAssembly .spectacle-content .ui-slide .mission-report .form-horizontal input[type=number]::-webkit-inner-spin-button,.epsHybridAssembly .spectacle-content .ui-slide .mission-report .form-horizontal input[type=number]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}.epsHybridAssembly .spectacle-content .ui-slide .mission-report .form-horizontal input[type=number]{-moz-appearance:textfield}.epsHybridAssembly .spectacle-content .ui-slide .mission-report .form-horizontal .control-label{text-align:left}.epsHybridAssembly .spectacle-content .ui-slide .mission-report label{-ms-flex:2;flex:2;margin-top:0;padding-top:0;padding-right:.5em;font-size:1em;line-height:1em;display:table-cell;vertical-align:middle;font-weight:400;font-family:BrandonTextWeb;color:#11abcd}.epsHybridAssembly .spectacle-content .ui-slide .mission-report .form-control,.epsHybridAssembly .spectacle-content .ui-slide .mission-report input{border:.125em solid #11abcd;background:#000;width:3em;height:1.4em;padding:.25em .25em .1em;margin:0 0 1% 2%;border-radius:.25em;font-size:1.1em;text-align:right;line-height:.7em;font-family:Orbitron;color:#37bad5}.epsHybridAssembly .spectacle-content .ui-slide .mission-report .btn-fake{background-color:#000;box-sizing:border-box;width:150px;height:150px;padding:25px;border-radius:50%;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;border:4px solid #61d9f2;font-size:15px;text-transform:uppercase;box-shadow:inset 0 0 0 5px #000,inset 0 0 5px 15px #e0f000,0 0 0 0 #61d9f2;text-shadow:0 0 0 #fff;transition:all .5s ease-in-out;-webkit-tap-highlight-color:black;outline:none}.epsHybridAssembly .spectacle-content .ui-slide .mission-report .btn-fake:active{box-shadow:inset 0 0 0 3px #000,inset 0 0 15px 18px #f4ff58,0 0 10px 5px #61d9f2;text-shadow:0 0 15px #fff;transform:rotate(2turn)}.epsHybridAssembly .spectacle-content .team-names .form-group{margin:0 0 .5em;display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;-ms-flex-align:center;align-items:center}.epsHybridAssembly .spectacle-content .team-names label{-ms-flex-preferred-size:10em;flex-basis:10em;margin-top:0;padding-top:0;font-size:2em;line-height:1em;font-weight:400;font-family:Orbitron,sans-serif;text-transform:uppercase;text-align:right;color:#11abcd}.epsHybridAssembly .spectacle-content .team-names label i{margin:0 .125em 0 .25em;font-size:1.25em}.epsHybridAssembly .spectacle-content .team-names .team-1 label{color:#3cca3f}.epsHybridAssembly .spectacle-content .team-names .team-2 label{color:#c57b39}.epsHybridAssembly .spectacle-content .team-names .team-3 label{color:#187bc5}.epsHybridAssembly .spectacle-content .team-names .team-4 label{color:#f8f8f8}.epsHybridAssembly .spectacle-content .team-names .form-control{border-radius:.25em;height:2em;padding:.5em;margin-bottom:1%;font-size:1.2em}.epsHybridAssembly .spectacle-content .text-balloon{width:75vw;padding:5%;margin:15vh auto 0;border-radius:7.5vh;background-color:rgba(0,0,0,.3);-ms-flex-align:start;align-items:flex-start;text-align:left;color:#fff;font-size:1.4em}.epsHybridAssembly .spectacle-content .text-balloon:after{bottom:-30px;border-width:15px 30px;left:auto}.epsHybridAssembly .spectacle-content .text-balloon.left:after{border-color:rgba(0,0,0,.3) transparent transparent rgba(0,0,0,.3);left:35%;transform:skewX(-40deg)}.epsHybridAssembly .spectacle-content .text-balloon.right:after{border-color:rgba(0,0,0,.3) rgba(0,0,0,.3) transparent transparent;right:35%;transform:skewX(40deg)}.epsHybridAssembly .spectacle-content .text-balloon h2,.epsHybridAssembly .spectacle-content .text-balloon h3{margin-left:0;margin-right:0}.epsHybridAssembly .text-balloon-character{margin:-60px 15% 0;position:relative;text-align:center}.epsHybridAssembly .text-balloon-character.right{text-align:right}.epsHybridAssembly .text-balloon-character.left{text-align:left}.epsHybridAssembly .text-balloon-character img{height:30vh;width:auto}.epsHybridAssembly .text-heading{width:66.7%;font-size:1.6em;line-height:1.25em;text-align:center;margin:0 auto}.epsHybridAssembly .text-formatted{width:66.7%;font-size:1.6em;line-height:1.25em;text-align:left;margin:0 auto}.epsHybridAssembly .text-formatted ul{margin-top:.5em;padding-left:2em}.epsHybridAssembly .text-formatted li{margin-bottom:.5em}.epsHybridAssembly .text-formatted h2,.epsHybridAssembly .text-formatted h3{margin-left:0;margin-right:0}.epsHybridAssembly .text-balloon-body{width:auto;margin:0}.epsHybridAssembly .youtube-button .btn-lg{font-size:48px;line-height:40px;padding:8px 5px 8px 11px;height:100px;min-height:100px;width:100px;border-radius:50%;z-index:100}.epsHybridAssembly .level-complete{-ms-flex-direction:column;flex-direction:column;-ms-flex:1;flex:1}.epsHybridAssembly .level-complete,.epsHybridAssembly .spectacle-content .level-complete-content{display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center}.epsHybridAssembly .spectacle-content .level-complete-content{width:40vw;height:40vw;-ms-flex-direction:column;flex-direction:column}.epsHybridAssembly .spectacle-content .level-complete-content .level-complete-graphic{position:absolute;top:50%;left:50%;margin-left:-20vw;margin-top:-20vw;z-index:1}.epsHybridAssembly .spectacle-content .level-complete-content .level-complete-graphic img{width:40vw;height:40vw}.epsHybridAssembly .spectacle-content .level-complete-content h3{font-size:7em;line-height:.5em;font-weight:700;text-align:center}.epsHybridAssembly .spectacle-content .level-complete-content h2{text-align:center;font-weight:700}.epsHybridAssembly .spectacle-content .level-complete-content .btn{background:none;border-color:#fff;position:relative;z-index:2;height:2.5em;min-height:2.5em;padding:0 1.25em;border-radius:1.25em;font-family:BrandonTextWeb;font-size:1em;color:#fff;text-shadow:none}.epsHybridAssembly .hacked{background-color:#000;background-size:cover;animation:glitcher 2s;display:-ms-flexbox;display:flex;position:absolute;top:0;bottom:0;left:0;right:0;-ms-flex-align:end;align-items:flex-end}.epsHybridAssembly .hacked-form{width:40%;margin-left:50%;margin-bottom:6em}.epsHybridAssembly.deck-level-1 .spectacle-content .text-balloon.balloon-regular{background-color:rgba(150,50,0,.3)}.epsHybridAssembly.deck-level-1 .spectacle-content .text-balloon.balloon-regular.left:after{border-color:rgba(150,50,0,.3) transparent transparent rgba(150,50,0,.3)}.epsHybridAssembly.deck-level-1 .spectacle-content .text-balloon.balloon-regular.right:after{border-color:rgba(150,50,0,.3) rgba(150,50,0,.3) transparent transparent}.epsHybridAssembly.deck-level-5 .spectacle-content .text-balloon.balloon-regular{background-color:rgba(125,75,0,.3)}.epsHybridAssembly.deck-level-5 .spectacle-content .text-balloon.balloon-regular.left:after{border-color:rgba(125,75,0,.3) transparent transparent rgba(125,75,0,.3)}.epsHybridAssembly.deck-level-5 .spectacle-content .text-balloon.balloon-regular.right:after{border-color:rgba(125,75,0,.3) rgba(125,75,0,.3) transparent transparent}", ""]);
	
	// exports


/***/ }),
/* 1279 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(12)();
	// imports
	
	
	// module
	exports.push([module.id, ".epsHybridIntermediates .heading-image{width:80%;height:80%;object-fit:contain;display:block;margin:0 auto}.epsHybridIntermediates .heading-image-before{width:75%;height:auto;object-fit:inherit}.epsHybridIntermediates .flex-image{width:45%;display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;-ms-flex-item-align:center;align-self:center}.epsHybridIntermediates .flex-image>img.eps-logo{-ms-flex:1 1 auto;flex:1 1 auto}.epsHybridIntermediates .spectacle-content .ui-slide .title-image h1{background-color:#000;width:80%;padding:1% 3% 1.5%;margin:0 auto;position:relative;z-index:1;font-family:BrandonTextWeb,Helvetica,Arial,sans-serif;font-size:1.1em;text-shadow:none;font-weight:400}.epsHybridIntermediates .spectacle-content .ui-slide .title-image h2{background-color:#b4e166;width:80%;padding:3%;margin:0 auto;position:relative;font-family:BrandonTextWeb,Helvetica,Arial,sans-serif;font-size:2.4em;text-shadow:0 0 20px rgba(0,0,0,.3);font-weight:800;color:#000;text-align:center}.epsHybridIntermediates .spectacle-content .ui-slide .title-image h2:after,.epsHybridIntermediates .spectacle-content .ui-slide .title-image h2:before{content:\"\";position:absolute;display:block;bottom:-.5em;border:.75em solid #9fd93b;z-index:-1}.epsHybridIntermediates .spectacle-content .ui-slide .title-image h2:before{left:-1em;border-right-width:.75em;border-left-color:transparent}.epsHybridIntermediates .spectacle-content .ui-slide .title-image h2:after{right:-1em;border-left-width:.75em;border-right-color:transparent}.epsHybridIntermediates .spectacle-content .ui-slide .title-image h2 strong:after,.epsHybridIntermediates .spectacle-content .ui-slide .title-image h2 strong:before{content:\"\";position:absolute;display:block;border-style:solid;border-color:#85bc25 transparent transparent;bottom:-.5em}.epsHybridIntermediates .spectacle-content .ui-slide .title-image h2 strong:before{left:0;border-width:.5em 0 0 .5em}.epsHybridIntermediates .spectacle-content .ui-slide .title-image h2 strong:after{right:0;border-width:.5em .5em 0 0}.epsHybridIntermediates .title-image{width:22em;height:25em;position:relative;margin:0 auto;z-index:1}.epsHybridIntermediates .title-image:after{display:block;content:\"\";position:absolute;top:7%;right:10%;bottom:7em;left:10%;border-top-left-radius:5%;border-top-right-radius:5%}.epsHybridIntermediates .title-image img{position:relative;z-index:2;height:18em;width:auto}.epsHybridIntermediates .spectacle-deck:before{content:\"\";display:block;position:absolute;top:0;right:0;bottom:0;left:0}.epsHybridIntermediates.deck-level-prep{background-color:#000;background-position:50%;background-image:linear-gradient(rgba(12,44,60,.5) 1px,transparent 0),linear-gradient(#0c2c3c 1px,transparent 0),linear-gradient(90deg,rgba(12,44,60,.5) 1px,transparent 0),linear-gradient(90deg,rgba(12,44,60,.7) 1px,transparent 0),linear-gradient(transparent 3px,#000 0,#000 73px,transparent 0),linear-gradient(90deg,rgba(12,44,60,.7) 3px,transparent 0,transparent 73px,rgba(12,44,60,.7) 0);background-size:5px 5px,75px 75px,5px 5px,75px 75px,75px 75px,75px 75px}.epsHybridIntermediates.deck-level-prep .spectacle-content h3{margin-bottom:0;color:#37bad5}.epsHybridIntermediates.deck-level-prep .text-formatted{font-size:1.4em}.epsHybridIntermediates.deck-level-1 .deck-slide-transition-group,.epsHybridIntermediates.deck-level-1 .title-image:after{background-color:#fa981d}.epsHybridIntermediates.deck-level-1 .level-1 .overview-level-image,.epsHybridIntermediates.deck-level-1 .spectacle-content .ui-slide .title-image h1{color:#fa981d}.epsHybridIntermediates.deck-level-2 .deck-slide-transition-group,.epsHybridIntermediates.deck-level-2 .title-image:after{background-color:#0daf4c}.epsHybridIntermediates.deck-level-2 .level-2 .overview-level-image,.epsHybridIntermediates.deck-level-2 .spectacle-content .ui-slide .title-image h1{color:#0daf4c}.epsHybridIntermediates.deck-level-3 .deck-slide-transition-group,.epsHybridIntermediates.deck-level-3 .title-image:after{background-color:#ae244e}.epsHybridIntermediates.deck-level-3 .level-3 .overview-level-image,.epsHybridIntermediates.deck-level-3 .spectacle-content .ui-slide .title-image h1{color:#ae244e}.epsHybridIntermediates.deck-level-4 .deck-slide-transition-group,.epsHybridIntermediates.deck-level-4 .title-image:after{background-color:#000}.epsHybridIntermediates.deck-level-4 .level-4 .overview-level-image,.epsHybridIntermediates.deck-level-4 .spectacle-content .ui-slide .title-image h1{color:#000}.epsHybridIntermediates.deck-level-5 .deck-slide-transition-group,.epsHybridIntermediates.deck-level-5 .title-image:after{background-color:#000}.epsHybridIntermediates.deck-level-5 .level-5 .overview-level-image,.epsHybridIntermediates.deck-level-5 .spectacle-content .ui-slide .title-image h1{color:#000}.epsHybridIntermediates.deck-level-6 .deck-slide-transition-group,.epsHybridIntermediates.deck-level-6 .title-image:after{background-color:#000}.epsHybridIntermediates.deck-level-6 .level-6 .overview-level-image,.epsHybridIntermediates.deck-level-6 .spectacle-content .ui-slide .title-image h1{color:#000}.epsHybridIntermediates .level-1 .overview-level-image{background-color:#fa981d}.epsHybridIntermediates .level-2 .overview-level-image{background-color:#0daf4c}.epsHybridIntermediates .level-3 .overview-level-image{background-color:#ae244e}.epsHybridIntermediates .level-4 .overview-level-image,.epsHybridIntermediates .level-5 .overview-level-image,.epsHybridIntermediates .level-6 .overview-level-image{background-color:#000}.epsHybridIntermediates .slide-content{-ms-flex:1 1 0%;flex:1 1 0%;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-pack:center;justify-content:center;height:100%}.epsHybridIntermediates .spectacle-content h1{margin:.25em auto;color:#fff;font-size:2.5em;font-family:BrandonTextWeb;line-height:1;font-weight:700}.epsHybridIntermediates .spectacle-content h2{margin:.125em auto;color:#fff;font-size:2em;font-family:BrandonTextWeb;line-height:1;font-weight:100;letter-spacing:-.5px}.epsHybridIntermediates .spectacle-content h3{margin:0 auto .125em;color:#fff;font-size:2em;font-family:BrandonTextWeb;line-height:1;font-weight:700;letter-spacing:-.5px}.epsHybridIntermediates .spectacle-content h4{font-size:1.6em;letter-spacing:0}.epsHybridIntermediates .spectacle-content h4,.epsHybridIntermediates .spectacle-content h6{margin:.5em auto;color:#fff;font-family:BrandonTextWeb;line-height:1;font-weight:400;text-transform:none}.epsHybridIntermediates .spectacle-content h6{font-size:3.5em;letter-spacing:-.033em;text-align:center}.epsHybridIntermediates .spectacle-content blockquote{text-align:left;position:relative;display:inline-block}.epsHybridIntermediates .spectacle-content quote{border-left:1px solid #37bad5;padding-left:40;display:block;color:#37bad5;font-size:49px;line-height:1;font-weight:700}.epsHybridIntermediates .spectacle-content cite{color:#fff;display:block;clear:left;font-size:20px;margin-top:1em}.epsHybridIntermediates .spectacle-content content{margin:0 auto;text-align:center}.epsHybridIntermediates .spectacle-content .ui-slide{background-color:#000;background-position:50%;background-image:linear-gradient(rgba(12,44,60,.5) 1px,transparent 0),linear-gradient(#0c2c3c 1px,transparent 0),linear-gradient(90deg,rgba(12,44,60,.5) 1px,transparent 0),linear-gradient(90deg,rgba(12,44,60,.7) 1px,transparent 0),linear-gradient(transparent 3px,#000 0,#000 73px,transparent 0),linear-gradient(90deg,rgba(12,44,60,.7) 3px,transparent 0,transparent 73px,rgba(12,44,60,.7) 0);background-size:5px 5px,75px 75px,5px 5px,75px 75px,75px 75px,75px 75px;-ms-flex:1;flex:1;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-pack:center;justify-content:center;padding:12.5%;font-family:Orbitron;color:#37bad5}.epsHybridIntermediates .spectacle-content .ui-slide h1,.epsHybridIntermediates .spectacle-content .ui-slide h2,.epsHybridIntermediates .spectacle-content .ui-slide h3,.epsHybridIntermediates .spectacle-content .ui-slide h4,.epsHybridIntermediates .spectacle-content .ui-slide h5,.epsHybridIntermediates .spectacle-content .ui-slide h6{color:#37bad5;font-family:Orbitron}.epsHybridIntermediates .spectacle-content .ui-slide h1{margin:.25em 0 .75em;font-size:32px;font-size:3.6vw;text-align:center;text-shadow:0 0 5px #37bad5}@media (max-width:767px){.epsHybridIntermediates .spectacle-content .ui-slide h1{font-size:18px;font-size:6vw}}.epsHybridIntermediates .spectacle-content .ui-slide h2{color:#11abcd;font-size:1.8em;font-weight:700}.epsHybridIntermediates .spectacle-content .ui-slide h3{color:#37bad5;text-shadow:0 0 5px #37bad5;font-size:1.6em;font-weight:400}.epsHybridIntermediates .spectacle-content .ui-slide .flex-image+h3{margin-top:.5em;color:#b4e166;animation:glowing;text-align:center}.epsHybridIntermediates .spectacle-content .ui-slide [class*=\" ppa-icon-\"]:before,.epsHybridIntermediates .spectacle-content .ui-slide [class^=ppa-icon-]:before{margin:0}.epsHybridIntermediates .spectacle-content .ui-slide .level-header{display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;-ms-flex-align:center;align-items:center;padding-bottom:2vw;min-height:8vw;min-height:8vmax}.epsHybridIntermediates .spectacle-content .ui-slide .level-header .level-header-thumb{position:relative;display:block;margin:0 30px;height:6.5vw;width:6.5vw;border-radius:10px}.epsHybridIntermediates .spectacle-content .ui-slide .level-header .level-header-thumb img{width:auto;height:7vw;margin:-.25vw}.epsHybridIntermediates .spectacle-content .ui-slide .level-header .level-header-thumb:after,.epsHybridIntermediates .spectacle-content .ui-slide .level-header .level-header-thumb:before{content:\"\";display:block;border:3px solid #11abcd;width:10px;position:absolute;top:0;bottom:0}.epsHybridIntermediates .spectacle-content .ui-slide .level-header .level-header-thumb:before{border-top-left-radius:10px;border-bottom-left-radius:10px;left:-20px;border-right:none}.epsHybridIntermediates .spectacle-content .ui-slide .level-header .level-header-thumb:after{border-top-right-radius:10px;border-bottom-right-radius:10px;right:-20px;border-left:none}.epsHybridIntermediates .spectacle-content .ui-slide .level-header .level-header-thumb+h2{margin-left:.5vw}.epsHybridIntermediates .spectacle-content .ui-slide .level-header h2{-ms-flex:1;flex:1}.epsHybridIntermediates .spectacle-content .ui-slide.mission-report-level-1 .level-header-thumb{background-color:#fa981d;box-shadow:0 0 15px #fa981d}.epsHybridIntermediates .spectacle-content .ui-slide.mission-report-level-2 .level-header-thumb{background-color:#0daf4c;box-shadow:0 0 15px #0daf4c}.epsHybridIntermediates .spectacle-content .ui-slide.mission-report-level-3 .level-header-thumb{background-color:#ae244e;box-shadow:0 0 15px #ae244e}.epsHybridIntermediates .spectacle-content .ui-slide.mission-report-level-4 .level-header-thumb,.epsHybridIntermediates .spectacle-content .ui-slide.mission-report-level-5 .level-header-thumb{background-color:#000;box-shadow:0 0 15px #000}.epsHybridIntermediates .spectacle-content .ui-slide .mission-report{border-top:2px solid #11abcd;border-bottom:2px solid #11abcd;padding:2.5vw 3vw;max-height:60vh;overflow-y:hidden;counter-reset:missioncounter}.epsHybridIntermediates .spectacle-content .ui-slide .mission-report .form-fields{padding:0;width:100%}.epsHybridIntermediates .spectacle-content .ui-slide .mission-report .form-horizontal{display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row}.epsHybridIntermediates .spectacle-content .ui-slide .mission-report .form-horizontal .question-group-wrapper{margin:0 0 .5em}.epsHybridIntermediates .spectacle-content .ui-slide .mission-report .form-horizontal .question-group-error{color:red;font-size:.8em;line-height:.8em}.epsHybridIntermediates .spectacle-content .ui-slide .mission-report .form-horizontal .question-group{margin:0;display:-ms-flexbox;display:flex;-ms-flex-flow:wrap;flex-flow:wrap;-ms-flex-direction:row;flex-direction:row;-ms-flex-align:center;align-items:center}.epsHybridIntermediates .spectacle-content .ui-slide .mission-report .form-horizontal .question-group:before{content:counter(missioncounter) \".\";counter-increment:missioncounter 1;display:block;width:1.5em;font-size:1.2em;line-height:1.2em;text-align:left;font-weight:700}.epsHybridIntermediates .spectacle-content .ui-slide .mission-report .form-horizontal .button-group{margin-left:2.5vw;-ms-flex-preferred-size:240px;flex-basis:240px;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center}.epsHybridIntermediates .spectacle-content .ui-slide .mission-report .form-horizontal input[type=number]::-webkit-inner-spin-button,.epsHybridIntermediates .spectacle-content .ui-slide .mission-report .form-horizontal input[type=number]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}.epsHybridIntermediates .spectacle-content .ui-slide .mission-report .form-horizontal input[type=number]{-moz-appearance:textfield}.epsHybridIntermediates .spectacle-content .ui-slide .mission-report .form-horizontal .control-label{text-align:left}.epsHybridIntermediates .spectacle-content .ui-slide .mission-report label{-ms-flex:2;flex:2;margin-top:0;padding-top:0;padding-right:.5em;font-size:1em;line-height:1em;display:table-cell;vertical-align:middle;font-weight:400;font-family:BrandonTextWeb;color:#11abcd}.epsHybridIntermediates .spectacle-content .ui-slide .mission-report .form-control,.epsHybridIntermediates .spectacle-content .ui-slide .mission-report input{border:.125em solid #11abcd;background:#000;width:3em;height:1.4em;padding:.25em .25em .1em;margin:0 0 1% 2%;border-radius:.25em;font-size:1.1em;text-align:right;line-height:.7em;font-family:Orbitron;color:#37bad5}.epsHybridIntermediates .spectacle-content .ui-slide .mission-report .btn-fake{background-color:#000;box-sizing:border-box;width:150px;height:150px;padding:25px;border-radius:50%;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;border:4px solid #61d9f2;font-size:15px;text-transform:uppercase;box-shadow:inset 0 0 0 5px #000,inset 0 0 5px 15px #e0f000,0 0 0 0 #61d9f2;text-shadow:0 0 0 #fff;transition:all .5s ease-in-out;-webkit-tap-highlight-color:black;outline:none}.epsHybridIntermediates .spectacle-content .ui-slide .mission-report .btn-fake:active{box-shadow:inset 0 0 0 3px #000,inset 0 0 15px 18px #f4ff58,0 0 10px 5px #61d9f2;text-shadow:0 0 15px #fff;transform:rotate(2turn)}.epsHybridIntermediates .spectacle-content .team-names .form-group{margin:0 0 .5em;display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;-ms-flex-align:center;align-items:center}.epsHybridIntermediates .spectacle-content .team-names label{-ms-flex-preferred-size:10em;flex-basis:10em;margin-top:0;padding-top:0;font-size:2em;line-height:1em;font-weight:400;font-family:Orbitron,sans-serif;text-transform:uppercase;text-align:right;color:#11abcd}.epsHybridIntermediates .spectacle-content .team-names label i{margin:0 .125em 0 .25em;font-size:1.25em}.epsHybridIntermediates .spectacle-content .team-names .team-1 label{color:#3cca3f}.epsHybridIntermediates .spectacle-content .team-names .team-2 label{color:#c57b39}.epsHybridIntermediates .spectacle-content .team-names .team-3 label{color:#187bc5}.epsHybridIntermediates .spectacle-content .team-names .team-4 label{color:#f8f8f8}.epsHybridIntermediates .spectacle-content .team-names .form-control{border-radius:.25em;height:2em;padding:.5em;margin-bottom:1%;font-size:1.2em}.epsHybridIntermediates .spectacle-content .text-balloon{width:75vw;padding:5%;margin:15vh auto 0;border-radius:7.5vh;background-color:rgba(0,0,0,.3);-ms-flex-align:start;align-items:flex-start;text-align:left;color:#fff;font-size:1.2em}.epsHybridIntermediates .spectacle-content .text-balloon:after{bottom:-30px;border-width:15px 30px;left:auto}.epsHybridIntermediates .spectacle-content .text-balloon.left:after{border-color:rgba(0,0,0,.3) transparent transparent rgba(0,0,0,.3);left:35%;transform:skewX(-40deg)}.epsHybridIntermediates .spectacle-content .text-balloon.right:after{border-color:rgba(0,0,0,.3) rgba(0,0,0,.3) transparent transparent;right:35%;transform:skewX(40deg)}.epsHybridIntermediates .spectacle-content .text-balloon h2,.epsHybridIntermediates .spectacle-content .text-balloon h3{margin-left:0;margin-right:0}.epsHybridIntermediates .text-balloon-character{margin:-60px 15% 0;position:relative;text-align:center}.epsHybridIntermediates .text-balloon-character.right{text-align:right}.epsHybridIntermediates .text-balloon-character.left{text-align:left}.epsHybridIntermediates .text-balloon-character img{height:30vh;width:auto}.epsHybridIntermediates .text-heading{width:66.7%;font-size:1.6em;line-height:1.25em;text-align:center;margin:0 auto}.epsHybridIntermediates .text-formatted{width:66.7%;font-size:1.6em;line-height:1.25em;text-align:left;margin:0 auto}.epsHybridIntermediates .text-formatted ul{margin-top:.5em;padding-left:2em}.epsHybridIntermediates .text-formatted li{margin-bottom:.5em}.epsHybridIntermediates .text-formatted h2,.epsHybridIntermediates .text-formatted h3{margin-left:0;margin-right:0}.epsHybridIntermediates .text-balloon-body{width:auto;margin:0}.epsHybridIntermediates .youtube-button .btn-lg{font-size:48px;line-height:40px;padding:8px 5px 8px 11px;height:100px;min-height:100px;width:100px;border-radius:50%;z-index:100}.epsHybridIntermediates .level-complete{-ms-flex-direction:column;flex-direction:column;-ms-flex:1;flex:1}.epsHybridIntermediates .level-complete,.epsHybridIntermediates .spectacle-content .level-complete-content{display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center}.epsHybridIntermediates .spectacle-content .level-complete-content{width:40vw;height:40vw;-ms-flex-direction:column;flex-direction:column}.epsHybridIntermediates .spectacle-content .level-complete-content .level-complete-graphic{position:absolute;top:50%;left:50%;margin-left:-20vw;margin-top:-20vw;z-index:1}.epsHybridIntermediates .spectacle-content .level-complete-content .level-complete-graphic img{width:40vw;height:40vw}.epsHybridIntermediates .spectacle-content .level-complete-content h3{font-size:7em;line-height:.5em;font-weight:700;text-align:center}.epsHybridIntermediates .spectacle-content .level-complete-content h2{text-align:center;font-weight:700}.epsHybridIntermediates .spectacle-content .level-complete-content .btn{background:none;border-color:#fff;position:relative;z-index:2;height:2.5em;min-height:2.5em;padding:0 1.25em;border-radius:1.25em;font-family:BrandonTextWeb;font-size:1em;color:#fff;text-shadow:none}.epsHybridIntermediates .hacked{background-color:#000;background-size:cover;animation:glitcher 2s;display:-ms-flexbox;display:flex;position:absolute;top:0;bottom:0;left:0;right:0;-ms-flex-align:end;align-items:flex-end}.epsHybridIntermediates .hacked-form{width:40%;margin-left:50%;margin-bottom:6em}.epsHybridIntermediates.deck-level-1 .spectacle-content .text-balloon.balloon-regular{background-color:rgba(150,50,0,.3)}.epsHybridIntermediates.deck-level-1 .spectacle-content .text-balloon.balloon-regular.left:after{border-color:rgba(150,50,0,.3) transparent transparent rgba(150,50,0,.3)}.epsHybridIntermediates.deck-level-1 .spectacle-content .text-balloon.balloon-regular.right:after{border-color:rgba(150,50,0,.3) rgba(150,50,0,.3) transparent transparent}.epsHybridIntermediates.deck-level-5 .spectacle-content .text-balloon.balloon-regular{background-color:rgba(125,75,0,.3)}.epsHybridIntermediates.deck-level-5 .spectacle-content .text-balloon.balloon-regular.left:after{border-color:rgba(125,75,0,.3) transparent transparent rgba(125,75,0,.3)}.epsHybridIntermediates.deck-level-5 .spectacle-content .text-balloon.balloon-regular.right:after{border-color:rgba(125,75,0,.3) rgba(125,75,0,.3) transparent transparent}", ""]);
	
	// exports


/***/ }),
/* 1280 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(12)();
	// imports
	
	
	// module
	exports.push([module.id, ".epsHybridPrimaries .heading-image{width:80%;height:80%;object-fit:contain;display:block;margin:0 auto}.epsHybridPrimaries .heading-image-before{width:75%;height:auto;object-fit:inherit}.epsHybridPrimaries .flex-image{width:45%;display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;-ms-flex-item-align:center;align-self:center}.epsHybridPrimaries .flex-image>img.eps-logo{-ms-flex:1 1 auto;flex:1 1 auto}.epsHybridPrimaries .spectacle-content .ui-slide .title-image h1{background-color:#000;width:80%;padding:1% 3% 1.5%;margin:0 auto;position:relative;z-index:1;font-family:BrandonTextWeb,Helvetica,Arial,sans-serif;font-size:1.1em;text-shadow:none;font-weight:400}.epsHybridPrimaries .spectacle-content .ui-slide .title-image h2{background-color:#b4e166;width:80%;padding:3%;margin:0 auto;position:relative;font-family:BrandonTextWeb,Helvetica,Arial,sans-serif;font-size:2.4em;text-shadow:0 0 20px rgba(0,0,0,.3);font-weight:800;color:#000;text-align:center}.epsHybridPrimaries .spectacle-content .ui-slide .title-image h2:after,.epsHybridPrimaries .spectacle-content .ui-slide .title-image h2:before{content:\"\";position:absolute;display:block;bottom:-.5em;border:.75em solid #9fd93b;z-index:-1}.epsHybridPrimaries .spectacle-content .ui-slide .title-image h2:before{left:-1em;border-right-width:.75em;border-left-color:transparent}.epsHybridPrimaries .spectacle-content .ui-slide .title-image h2:after{right:-1em;border-left-width:.75em;border-right-color:transparent}.epsHybridPrimaries .spectacle-content .ui-slide .title-image h2 strong:after,.epsHybridPrimaries .spectacle-content .ui-slide .title-image h2 strong:before{content:\"\";position:absolute;display:block;border-style:solid;border-color:#85bc25 transparent transparent;bottom:-.5em}.epsHybridPrimaries .spectacle-content .ui-slide .title-image h2 strong:before{left:0;border-width:.5em 0 0 .5em}.epsHybridPrimaries .spectacle-content .ui-slide .title-image h2 strong:after{right:0;border-width:.5em .5em 0 0}.epsHybridPrimaries .title-image{width:22em;height:25em;position:relative;margin:0 auto;z-index:1}.epsHybridPrimaries .title-image:after{display:block;content:\"\";position:absolute;top:7%;right:10%;bottom:7em;left:10%;border-top-left-radius:5%;border-top-right-radius:5%}.epsHybridPrimaries .title-image img{position:relative;z-index:2;height:18em;width:auto}.epsHybridPrimaries .spectacle-deck:before{content:\"\";display:block;position:absolute;top:0;right:0;bottom:0;left:0}.epsHybridPrimaries.deck-level-prep{background-color:#000;background-position:50%;background-image:linear-gradient(rgba(12,44,60,.5) 1px,transparent 0),linear-gradient(#0c2c3c 1px,transparent 0),linear-gradient(90deg,rgba(12,44,60,.5) 1px,transparent 0),linear-gradient(90deg,rgba(12,44,60,.7) 1px,transparent 0),linear-gradient(transparent 3px,#000 0,#000 73px,transparent 0),linear-gradient(90deg,rgba(12,44,60,.7) 3px,transparent 0,transparent 73px,rgba(12,44,60,.7) 0);background-size:5px 5px,75px 75px,5px 5px,75px 75px,75px 75px,75px 75px}.epsHybridPrimaries.deck-level-prep .spectacle-content h3{margin-bottom:0;color:#37bad5}.epsHybridPrimaries.deck-level-prep .text-formatted{font-size:1.4em}.epsHybridPrimaries.deck-level-1 .deck-slide-transition-group,.epsHybridPrimaries.deck-level-1 .title-image:after{background-color:#fa981d}.epsHybridPrimaries.deck-level-1 .level-1 .overview-level-image,.epsHybridPrimaries.deck-level-1 .spectacle-content .ui-slide .title-image h1{color:#fa981d}.epsHybridPrimaries.deck-level-2 .deck-slide-transition-group,.epsHybridPrimaries.deck-level-2 .title-image:after{background-color:#0daf4c}.epsHybridPrimaries.deck-level-2 .level-2 .overview-level-image,.epsHybridPrimaries.deck-level-2 .spectacle-content .ui-slide .title-image h1{color:#0daf4c}.epsHybridPrimaries.deck-level-3 .deck-slide-transition-group,.epsHybridPrimaries.deck-level-3 .title-image:after{background-color:#ae244e}.epsHybridPrimaries.deck-level-3 .level-3 .overview-level-image,.epsHybridPrimaries.deck-level-3 .spectacle-content .ui-slide .title-image h1{color:#ae244e}.epsHybridPrimaries.deck-level-4 .deck-slide-transition-group,.epsHybridPrimaries.deck-level-4 .title-image:after{background-color:#000}.epsHybridPrimaries.deck-level-4 .level-4 .overview-level-image,.epsHybridPrimaries.deck-level-4 .spectacle-content .ui-slide .title-image h1{color:#000}.epsHybridPrimaries.deck-level-5 .deck-slide-transition-group,.epsHybridPrimaries.deck-level-5 .title-image:after{background-color:#000}.epsHybridPrimaries.deck-level-5 .level-5 .overview-level-image,.epsHybridPrimaries.deck-level-5 .spectacle-content .ui-slide .title-image h1{color:#000}.epsHybridPrimaries.deck-level-6 .deck-slide-transition-group,.epsHybridPrimaries.deck-level-6 .title-image:after{background-color:#000}.epsHybridPrimaries.deck-level-6 .level-6 .overview-level-image,.epsHybridPrimaries.deck-level-6 .spectacle-content .ui-slide .title-image h1{color:#000}.epsHybridPrimaries .level-1 .overview-level-image{background-color:#fa981d}.epsHybridPrimaries .level-2 .overview-level-image{background-color:#0daf4c}.epsHybridPrimaries .level-3 .overview-level-image{background-color:#ae244e}.epsHybridPrimaries .level-4 .overview-level-image,.epsHybridPrimaries .level-5 .overview-level-image,.epsHybridPrimaries .level-6 .overview-level-image{background-color:#000}.epsHybridPrimaries .slide-content{-ms-flex:1 1 0%;flex:1 1 0%;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-pack:center;justify-content:center;height:100%}.epsHybridPrimaries .spectacle-content h1{margin:.25em auto;color:#fff;font-size:2.5em;font-family:BrandonTextWeb;line-height:1;font-weight:700}.epsHybridPrimaries .spectacle-content h2{margin:.125em auto;font-weight:100}.epsHybridPrimaries .spectacle-content h2,.epsHybridPrimaries .spectacle-content h3{color:#fff;font-size:2em;font-family:BrandonTextWeb;line-height:1;letter-spacing:-.5px}.epsHybridPrimaries .spectacle-content h3{margin:0 auto .125em;font-weight:700}.epsHybridPrimaries .spectacle-content h4{font-size:1.6em;letter-spacing:0}.epsHybridPrimaries .spectacle-content h4,.epsHybridPrimaries .spectacle-content h6{margin:.5em auto;color:#fff;font-family:BrandonTextWeb;line-height:1;font-weight:400;text-transform:none}.epsHybridPrimaries .spectacle-content h6{font-size:3.5em;letter-spacing:-.033em;text-align:center}.epsHybridPrimaries .spectacle-content blockquote{text-align:left;position:relative;display:inline-block}.epsHybridPrimaries .spectacle-content quote{border-left:1px solid #37bad5;padding-left:40;display:block;color:#37bad5;font-size:49px;line-height:1;font-weight:700}.epsHybridPrimaries .spectacle-content cite{color:#fff;display:block;clear:left;font-size:20px;margin-top:1em}.epsHybridPrimaries .spectacle-content content{margin:0 auto;text-align:center}.epsHybridPrimaries .spectacle-content .ui-slide{background-color:#000;background-position:50%;background-image:linear-gradient(rgba(12,44,60,.5) 1px,transparent 0),linear-gradient(#0c2c3c 1px,transparent 0),linear-gradient(90deg,rgba(12,44,60,.5) 1px,transparent 0),linear-gradient(90deg,rgba(12,44,60,.7) 1px,transparent 0),linear-gradient(transparent 3px,#000 0,#000 73px,transparent 0),linear-gradient(90deg,rgba(12,44,60,.7) 3px,transparent 0,transparent 73px,rgba(12,44,60,.7) 0);background-size:5px 5px,75px 75px,5px 5px,75px 75px,75px 75px,75px 75px;-ms-flex:1;flex:1;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-pack:center;justify-content:center;padding:12.5%;font-family:Orbitron;color:#37bad5}.epsHybridPrimaries .spectacle-content .ui-slide h1,.epsHybridPrimaries .spectacle-content .ui-slide h2,.epsHybridPrimaries .spectacle-content .ui-slide h3,.epsHybridPrimaries .spectacle-content .ui-slide h4,.epsHybridPrimaries .spectacle-content .ui-slide h5,.epsHybridPrimaries .spectacle-content .ui-slide h6{color:#37bad5;font-family:Orbitron}.epsHybridPrimaries .spectacle-content .ui-slide h1{margin:.25em 0 .75em;font-size:32px;font-size:3.6vw;text-align:center;text-shadow:0 0 5px #37bad5}@media (max-width:767px){.epsHybridPrimaries .spectacle-content .ui-slide h1{font-size:18px;font-size:6vw}}.epsHybridPrimaries .spectacle-content .ui-slide h2{color:#11abcd;font-size:1.8em;font-weight:700}.epsHybridPrimaries .spectacle-content .ui-slide h3{color:#37bad5;text-shadow:0 0 5px #37bad5;font-size:1.6em;font-weight:400}.epsHybridPrimaries .spectacle-content .ui-slide .flex-image+h3{margin-top:.5em;color:#b4e166;animation:glowing;text-align:center}.epsHybridPrimaries .spectacle-content .ui-slide [class*=\" ppa-icon-\"]:before,.epsHybridPrimaries .spectacle-content .ui-slide [class^=ppa-icon-]:before{margin:0}.epsHybridPrimaries .spectacle-content .ui-slide .level-header{display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;-ms-flex-align:center;align-items:center;padding-bottom:2vw;min-height:8vw;min-height:8vmax}.epsHybridPrimaries .spectacle-content .ui-slide .level-header .level-header-thumb{position:relative;display:block;margin:0 30px;height:6.5vw;width:6.5vw;border-radius:10px}.epsHybridPrimaries .spectacle-content .ui-slide .level-header .level-header-thumb img{width:auto;height:7vw;margin:-.25vw}.epsHybridPrimaries .spectacle-content .ui-slide .level-header .level-header-thumb:after,.epsHybridPrimaries .spectacle-content .ui-slide .level-header .level-header-thumb:before{content:\"\";display:block;border:3px solid #11abcd;width:10px;position:absolute;top:0;bottom:0}.epsHybridPrimaries .spectacle-content .ui-slide .level-header .level-header-thumb:before{border-top-left-radius:10px;border-bottom-left-radius:10px;left:-20px;border-right:none}.epsHybridPrimaries .spectacle-content .ui-slide .level-header .level-header-thumb:after{border-top-right-radius:10px;border-bottom-right-radius:10px;right:-20px;border-left:none}.epsHybridPrimaries .spectacle-content .ui-slide .level-header .level-header-thumb+h2{margin-left:.5vw}.epsHybridPrimaries .spectacle-content .ui-slide .level-header h2{-ms-flex:1;flex:1}.epsHybridPrimaries .spectacle-content .ui-slide.mission-report-level-1 .level-header-thumb{background-color:#fa981d;box-shadow:0 0 15px #fa981d}.epsHybridPrimaries .spectacle-content .ui-slide.mission-report-level-2 .level-header-thumb{background-color:#0daf4c;box-shadow:0 0 15px #0daf4c}.epsHybridPrimaries .spectacle-content .ui-slide.mission-report-level-3 .level-header-thumb{background-color:#ae244e;box-shadow:0 0 15px #ae244e}.epsHybridPrimaries .spectacle-content .ui-slide.mission-report-level-4 .level-header-thumb,.epsHybridPrimaries .spectacle-content .ui-slide.mission-report-level-5 .level-header-thumb{background-color:#000;box-shadow:0 0 15px #000}.epsHybridPrimaries .spectacle-content .ui-slide .mission-report{border-top:2px solid #11abcd;border-bottom:2px solid #11abcd;padding:2.5vw 3vw;max-height:60vh;overflow-y:hidden;counter-reset:missioncounter}.epsHybridPrimaries .spectacle-content .ui-slide .mission-report .form-fields{padding:0;width:100%}.epsHybridPrimaries .spectacle-content .ui-slide .mission-report .form-horizontal{display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row}.epsHybridPrimaries .spectacle-content .ui-slide .mission-report .form-horizontal .question-group-wrapper{margin:0 0 .5em}.epsHybridPrimaries .spectacle-content .ui-slide .mission-report .form-horizontal .question-group-error{color:red;font-size:.8em;line-height:.8em}.epsHybridPrimaries .spectacle-content .ui-slide .mission-report .form-horizontal .question-group{margin:0;display:-ms-flexbox;display:flex;-ms-flex-flow:wrap;flex-flow:wrap;-ms-flex-direction:row;flex-direction:row;-ms-flex-align:center;align-items:center}.epsHybridPrimaries .spectacle-content .ui-slide .mission-report .form-horizontal .question-group:before{content:counter(missioncounter) \".\";counter-increment:missioncounter 1;display:block;width:1.5em;font-size:1.2em;line-height:1.2em;text-align:left;font-weight:700}.epsHybridPrimaries .spectacle-content .ui-slide .mission-report .form-horizontal .button-group{margin-left:2.5vw;-ms-flex-preferred-size:240px;flex-basis:240px;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center}.epsHybridPrimaries .spectacle-content .ui-slide .mission-report .form-horizontal input[type=number]::-webkit-inner-spin-button,.epsHybridPrimaries .spectacle-content .ui-slide .mission-report .form-horizontal input[type=number]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}.epsHybridPrimaries .spectacle-content .ui-slide .mission-report .form-horizontal input[type=number]{-moz-appearance:textfield}.epsHybridPrimaries .spectacle-content .ui-slide .mission-report .form-horizontal .control-label{text-align:left}.epsHybridPrimaries .spectacle-content .ui-slide .mission-report label{-ms-flex:2;flex:2;margin-top:0;padding-top:0;padding-right:.5em;font-size:1em;line-height:1em;display:table-cell;vertical-align:middle;font-weight:400;font-family:BrandonTextWeb;color:#11abcd}.epsHybridPrimaries .spectacle-content .ui-slide .mission-report .form-control,.epsHybridPrimaries .spectacle-content .ui-slide .mission-report input{border:.125em solid #11abcd;background:#000;width:3em;height:1.4em;padding:.25em .25em .1em;margin:0 0 1% 2%;border-radius:.25em;font-size:1.1em;text-align:right;line-height:.7em;font-family:Orbitron;color:#37bad5}.epsHybridPrimaries .spectacle-content .ui-slide .mission-report .btn-fake{background-color:#000;box-sizing:border-box;width:150px;height:150px;padding:25px;border-radius:50%;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;border:4px solid #61d9f2;font-size:15px;text-transform:uppercase;box-shadow:inset 0 0 0 5px #000,inset 0 0 5px 15px #e0f000,0 0 0 0 #61d9f2;text-shadow:0 0 0 #fff;transition:all .5s ease-in-out;-webkit-tap-highlight-color:black;outline:none}.epsHybridPrimaries .spectacle-content .ui-slide .mission-report .btn-fake:active{box-shadow:inset 0 0 0 3px #000,inset 0 0 15px 18px #f4ff58,0 0 10px 5px #61d9f2;text-shadow:0 0 15px #fff;transform:rotate(2turn)}.epsHybridPrimaries .spectacle-content .team-names .form-group{margin:0 0 .5em;display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;-ms-flex-align:center;align-items:center}.epsHybridPrimaries .spectacle-content .team-names label{-ms-flex-preferred-size:10em;flex-basis:10em;margin-top:0;padding-top:0;font-size:2em;line-height:1em;font-weight:400;font-family:Orbitron,sans-serif;text-transform:uppercase;text-align:right;color:#11abcd}.epsHybridPrimaries .spectacle-content .team-names label i{margin:0 .125em 0 .25em;font-size:1.25em}.epsHybridPrimaries .spectacle-content .team-names .team-1 label{color:#3cca3f}.epsHybridPrimaries .spectacle-content .team-names .team-2 label{color:#c57b39}.epsHybridPrimaries .spectacle-content .team-names .team-3 label{color:#187bc5}.epsHybridPrimaries .spectacle-content .team-names .team-4 label{color:#f8f8f8}.epsHybridPrimaries .spectacle-content .team-names .form-control{border-radius:.25em;height:2em;padding:.5em;margin-bottom:1%;font-size:1.2em}.epsHybridPrimaries .spectacle-content .text-balloon{width:75vw;padding:5%;margin:15vh auto 0;border-radius:7.5vh;background-color:rgba(0,0,0,.3);-ms-flex-align:start;align-items:flex-start;text-align:left;color:#fff;font-size:1.2em}.epsHybridPrimaries .spectacle-content .text-balloon:after{bottom:-30px;border-width:15px 30px;left:auto}.epsHybridPrimaries .spectacle-content .text-balloon.left:after{border-color:rgba(0,0,0,.3) transparent transparent rgba(0,0,0,.3);left:35%;transform:skewX(-40deg)}.epsHybridPrimaries .spectacle-content .text-balloon.right:after{border-color:rgba(0,0,0,.3) rgba(0,0,0,.3) transparent transparent;right:35%;transform:skewX(40deg)}.epsHybridPrimaries .spectacle-content .text-balloon h2,.epsHybridPrimaries .spectacle-content .text-balloon h3{margin-left:0;margin-right:0}.epsHybridPrimaries .text-balloon-character{margin:-60px 15% 0;position:relative;text-align:center}.epsHybridPrimaries .text-balloon-character.right{text-align:right}.epsHybridPrimaries .text-balloon-character.left{text-align:left}.epsHybridPrimaries .text-balloon-character img{height:30vh;width:auto}.epsHybridPrimaries .text-heading{width:66.7%;font-size:1.6em;line-height:1.25em;text-align:center;margin:0 auto}.epsHybridPrimaries .text-formatted{width:66.7%;font-size:1.6em;line-height:1.25em;text-align:left;margin:0 auto}.epsHybridPrimaries .text-formatted ul{margin-top:.5em;padding-left:2em}.epsHybridPrimaries .text-formatted li{margin-bottom:.5em}.epsHybridPrimaries .text-formatted h2,.epsHybridPrimaries .text-formatted h3{margin-left:0;margin-right:0}.epsHybridPrimaries .text-balloon-body{width:auto;margin:0}.epsHybridPrimaries .youtube-button .btn-lg{font-size:48px;line-height:40px;padding:8px 5px 8px 11px;height:100px;min-height:100px;width:100px;border-radius:50%;z-index:100}.epsHybridPrimaries .level-complete{-ms-flex-direction:column;flex-direction:column;-ms-flex:1;flex:1}.epsHybridPrimaries .level-complete,.epsHybridPrimaries .spectacle-content .level-complete-content{display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center}.epsHybridPrimaries .spectacle-content .level-complete-content{width:40vw;height:40vw;-ms-flex-direction:column;flex-direction:column}.epsHybridPrimaries .spectacle-content .level-complete-content .level-complete-graphic{position:absolute;top:50%;left:50%;margin-left:-20vw;margin-top:-20vw;z-index:1}.epsHybridPrimaries .spectacle-content .level-complete-content .level-complete-graphic img{width:40vw;height:40vw}.epsHybridPrimaries .spectacle-content .level-complete-content h3{font-size:7em;line-height:.5em;font-weight:700;text-align:center}.epsHybridPrimaries .spectacle-content .level-complete-content h2{text-align:center;font-weight:700}.epsHybridPrimaries .spectacle-content .level-complete-content .btn{background:none;border-color:#fff;position:relative;z-index:2;height:2.5em;min-height:2.5em;padding:0 1.25em;border-radius:1.25em;font-family:BrandonTextWeb;font-size:1em;color:#fff;text-shadow:none}.epsHybridPrimaries .hacked{background-color:#000;background-size:cover;animation:glitcher 2s;display:-ms-flexbox;display:flex;position:absolute;top:0;bottom:0;left:0;right:0;-ms-flex-align:end;align-items:flex-end}.epsHybridPrimaries .hacked-form{width:40%;margin-left:50%;margin-bottom:6em}.epsHybridPrimaries.deck-level-1 .spectacle-content .text-balloon.balloon-regular{background-color:rgba(150,50,0,.3)}.epsHybridPrimaries.deck-level-1 .spectacle-content .text-balloon.balloon-regular.left:after{border-color:rgba(150,50,0,.3) transparent transparent rgba(150,50,0,.3)}.epsHybridPrimaries.deck-level-1 .spectacle-content .text-balloon.balloon-regular.right:after{border-color:rgba(150,50,0,.3) rgba(150,50,0,.3) transparent transparent}.epsHybridPrimaries.deck-level-5 .spectacle-content .text-balloon.balloon-regular{background-color:rgba(125,75,0,.3)}.epsHybridPrimaries.deck-level-5 .spectacle-content .text-balloon.balloon-regular.left:after{border-color:rgba(125,75,0,.3) transparent transparent rgba(125,75,0,.3)}.epsHybridPrimaries.deck-level-5 .spectacle-content .text-balloon.balloon-regular.right:after{border-color:rgba(125,75,0,.3) rgba(125,75,0,.3) transparent transparent}", ""]);
	
	// exports


/***/ }),
/* 1281 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(12)();
	// imports
	
	
	// module
	exports.push([module.id, ".epsIntermediates .heading-image{width:80%;height:80%;object-fit:contain;display:block;margin:0 auto}.epsIntermediates .heading-image-before{width:75%;height:auto;object-fit:inherit}.epsIntermediates .flex-image{width:45%;display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;-ms-flex-item-align:center;align-self:center}.epsIntermediates .flex-image>img.eps-logo{-ms-flex:1 1 auto;flex:1 1 auto}.epsIntermediates .spectacle-content .ui-slide .title-image h1{background-color:#000;width:80%;padding:1% 3% 1.5%;margin:0 auto;position:relative;z-index:1;font-family:BrandonTextWeb,Helvetica,Arial,sans-serif;font-size:1.1em;text-shadow:none;font-weight:400}.epsIntermediates .spectacle-content .ui-slide .title-image h2{background-color:#b4e166;width:80%;padding:3%;margin:0 auto;position:relative;font-family:BrandonTextWeb,Helvetica,Arial,sans-serif;font-size:2.4em;text-shadow:0 0 20px rgba(0,0,0,.3);font-weight:800;color:#000;text-align:center}.epsIntermediates .spectacle-content .ui-slide .title-image h2:after,.epsIntermediates .spectacle-content .ui-slide .title-image h2:before{content:\"\";position:absolute;display:block;bottom:-.5em;border:.75em solid #9fd93b;z-index:-1}.epsIntermediates .spectacle-content .ui-slide .title-image h2:before{left:-1em;border-right-width:.75em;border-left-color:transparent}.epsIntermediates .spectacle-content .ui-slide .title-image h2:after{right:-1em;border-left-width:.75em;border-right-color:transparent}.epsIntermediates .spectacle-content .ui-slide .title-image h2 strong:after,.epsIntermediates .spectacle-content .ui-slide .title-image h2 strong:before{content:\"\";position:absolute;display:block;border-style:solid;border-color:#85bc25 transparent transparent;bottom:-.5em}.epsIntermediates .spectacle-content .ui-slide .title-image h2 strong:before{left:0;border-width:.5em 0 0 .5em}.epsIntermediates .spectacle-content .ui-slide .title-image h2 strong:after{right:0;border-width:.5em .5em 0 0}.epsIntermediates .title-image{width:22em;height:25em;position:relative;margin:0 auto;z-index:1}.epsIntermediates .title-image:after{display:block;content:\"\";position:absolute;top:7%;right:10%;bottom:7em;left:10%;border-top-left-radius:5%;border-top-right-radius:5%}.epsIntermediates .title-image img{position:relative;z-index:2;height:18em;width:auto}.epsIntermediates .spectacle-deck:before{content:\"\";display:block;position:absolute;top:0;right:0;bottom:0;left:0}.epsIntermediates.deck-level-prep{background-color:#000;background-position:50%;background-image:linear-gradient(rgba(12,44,60,.5) 1px,transparent 0),linear-gradient(#0c2c3c 1px,transparent 0),linear-gradient(90deg,rgba(12,44,60,.5) 1px,transparent 0),linear-gradient(90deg,rgba(12,44,60,.7) 1px,transparent 0),linear-gradient(transparent 3px,#000 0,#000 73px,transparent 0),linear-gradient(90deg,rgba(12,44,60,.7) 3px,transparent 0,transparent 73px,rgba(12,44,60,.7) 0);background-size:5px 5px,75px 75px,5px 5px,75px 75px,75px 75px,75px 75px}.epsIntermediates.deck-level-prep .spectacle-content h3{margin-bottom:0;color:#37bad5}.epsIntermediates.deck-level-prep .text-formatted{font-size:1.4em}.epsIntermediates.deck-level-1 .deck-slide-transition-group,.epsIntermediates.deck-level-1 .title-image:after{background-color:#37b34a}.epsIntermediates.deck-level-1 .level-1 .overview-level-image,.epsIntermediates.deck-level-1 .spectacle-content .ui-slide .title-image h1{color:#37b34a}.epsIntermediates.deck-level-2 .deck-slide-transition-group,.epsIntermediates.deck-level-2 .title-image:after{background-color:#fa981d}.epsIntermediates.deck-level-2 .level-2 .overview-level-image,.epsIntermediates.deck-level-2 .spectacle-content .ui-slide .title-image h1{color:#fa981d}.epsIntermediates.deck-level-3 .deck-slide-transition-group,.epsIntermediates.deck-level-3 .title-image:after{background-color:#0daf4c}.epsIntermediates.deck-level-3 .level-3 .overview-level-image,.epsIntermediates.deck-level-3 .spectacle-content .ui-slide .title-image h1{color:#0daf4c}.epsIntermediates.deck-level-4 .deck-slide-transition-group,.epsIntermediates.deck-level-4 .title-image:after{background-color:#ae244e}.epsIntermediates.deck-level-4 .level-4 .overview-level-image,.epsIntermediates.deck-level-4 .spectacle-content .ui-slide .title-image h1{color:#ae244e}.epsIntermediates.deck-level-5 .deck-slide-transition-group,.epsIntermediates.deck-level-5 .title-image:after{background-color:#000}.epsIntermediates.deck-level-5 .level-5 .overview-level-image,.epsIntermediates.deck-level-5 .spectacle-content .ui-slide .title-image h1{color:#000}.epsIntermediates.deck-level-6 .deck-slide-transition-group,.epsIntermediates.deck-level-6 .title-image:after{background-color:#000}.epsIntermediates.deck-level-6 .level-6 .overview-level-image,.epsIntermediates.deck-level-6 .spectacle-content .ui-slide .title-image h1{color:#000}.epsIntermediates .level-1 .overview-level-image{background-color:#37b34a}.epsIntermediates .level-2 .overview-level-image{background-color:#fa981d}.epsIntermediates .level-3 .overview-level-image{background-color:#0daf4c}.epsIntermediates .level-4 .overview-level-image{background-color:#ae244e}.epsIntermediates .level-5 .overview-level-image,.epsIntermediates .level-6 .overview-level-image{background-color:#000}.epsIntermediates .slide-content{-ms-flex:1 1 0%;flex:1 1 0%;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-pack:center;justify-content:center;height:100%}.epsIntermediates .spectacle-content h1{margin:.25em auto;color:#fff;font-size:2.5em;font-family:BrandonTextWeb;line-height:1;font-weight:700}.epsIntermediates .spectacle-content h2{margin:.125em auto;font-weight:100}.epsIntermediates .spectacle-content h2,.epsIntermediates .spectacle-content h3{color:#fff;font-size:2em;font-family:BrandonTextWeb;line-height:1;letter-spacing:-.5px}.epsIntermediates .spectacle-content h3{margin:0 auto .125em;font-weight:700}.epsIntermediates .spectacle-content h4{font-size:1.6em;letter-spacing:0}.epsIntermediates .spectacle-content h4,.epsIntermediates .spectacle-content h6{margin:.5em auto;color:#fff;font-family:BrandonTextWeb;line-height:1;font-weight:400;text-transform:none}.epsIntermediates .spectacle-content h6{font-size:3.5em;letter-spacing:-.033em;text-align:center}.epsIntermediates .spectacle-content blockquote{text-align:left;position:relative;display:inline-block}.epsIntermediates .spectacle-content quote{border-left:1px solid #37bad5;padding-left:40;display:block;color:#37bad5;font-size:49px;line-height:1;font-weight:700}.epsIntermediates .spectacle-content cite{color:#fff;display:block;clear:left;font-size:20px;margin-top:1em}.epsIntermediates .spectacle-content content{margin:0 auto;text-align:center}.epsIntermediates .spectacle-content .ui-slide{background-color:#000;background-position:50%;background-image:linear-gradient(rgba(12,44,60,.5) 1px,transparent 0),linear-gradient(#0c2c3c 1px,transparent 0),linear-gradient(90deg,rgba(12,44,60,.5) 1px,transparent 0),linear-gradient(90deg,rgba(12,44,60,.7) 1px,transparent 0),linear-gradient(transparent 3px,#000 0,#000 73px,transparent 0),linear-gradient(90deg,rgba(12,44,60,.7) 3px,transparent 0,transparent 73px,rgba(12,44,60,.7) 0);background-size:5px 5px,75px 75px,5px 5px,75px 75px,75px 75px,75px 75px;-ms-flex:1;flex:1;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-pack:center;justify-content:center;padding:12.5%;font-family:Orbitron;color:#37bad5}.epsIntermediates .spectacle-content .ui-slide h1,.epsIntermediates .spectacle-content .ui-slide h2,.epsIntermediates .spectacle-content .ui-slide h3,.epsIntermediates .spectacle-content .ui-slide h4,.epsIntermediates .spectacle-content .ui-slide h5,.epsIntermediates .spectacle-content .ui-slide h6{color:#37bad5;font-family:Orbitron}.epsIntermediates .spectacle-content .ui-slide h1{margin:.25em 0 .75em;font-size:32px;font-size:3.6vw;text-align:center;text-shadow:0 0 5px #37bad5}@media (max-width:767px){.epsIntermediates .spectacle-content .ui-slide h1{font-size:18px;font-size:6vw}}.epsIntermediates .spectacle-content .ui-slide h2{color:#11abcd;font-size:1.8em;font-weight:700}.epsIntermediates .spectacle-content .ui-slide h3{color:#37bad5;text-shadow:0 0 5px #37bad5;font-size:1.6em;font-weight:400}.epsIntermediates .spectacle-content .ui-slide .flex-image+h3{margin-top:.5em;color:#b4e166;animation:glowing;text-align:center}.epsIntermediates .spectacle-content .ui-slide [class*=\" ppa-icon-\"]:before,.epsIntermediates .spectacle-content .ui-slide [class^=ppa-icon-]:before{margin:0}.epsIntermediates .spectacle-content .ui-slide .level-header{display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;-ms-flex-align:center;align-items:center;padding-bottom:2vw;min-height:8vw;min-height:8vmax}.epsIntermediates .spectacle-content .ui-slide .level-header .level-header-thumb{position:relative;display:block;margin:0 30px;height:6.5vw;width:6.5vw;border-radius:10px}.epsIntermediates .spectacle-content .ui-slide .level-header .level-header-thumb img{width:auto;height:7vw;margin:-.25vw}.epsIntermediates .spectacle-content .ui-slide .level-header .level-header-thumb:after,.epsIntermediates .spectacle-content .ui-slide .level-header .level-header-thumb:before{content:\"\";display:block;border:3px solid #11abcd;width:10px;position:absolute;top:0;bottom:0}.epsIntermediates .spectacle-content .ui-slide .level-header .level-header-thumb:before{border-top-left-radius:10px;border-bottom-left-radius:10px;left:-20px;border-right:none}.epsIntermediates .spectacle-content .ui-slide .level-header .level-header-thumb:after{border-top-right-radius:10px;border-bottom-right-radius:10px;right:-20px;border-left:none}.epsIntermediates .spectacle-content .ui-slide .level-header .level-header-thumb+h2{margin-left:.5vw}.epsIntermediates .spectacle-content .ui-slide .level-header h2{-ms-flex:1;flex:1}.epsIntermediates .spectacle-content .ui-slide.mission-report-level-1 .level-header-thumb{background-color:#37b34a;box-shadow:0 0 15px #37b34a}.epsIntermediates .spectacle-content .ui-slide.mission-report-level-2 .level-header-thumb{background-color:#fa981d;box-shadow:0 0 15px #fa981d}.epsIntermediates .spectacle-content .ui-slide.mission-report-level-3 .level-header-thumb{background-color:#0daf4c;box-shadow:0 0 15px #0daf4c}.epsIntermediates .spectacle-content .ui-slide.mission-report-level-4 .level-header-thumb{background-color:#ae244e;box-shadow:0 0 15px #ae244e}.epsIntermediates .spectacle-content .ui-slide.mission-report-level-5 .level-header-thumb{background-color:#000;box-shadow:0 0 15px #000}.epsIntermediates .spectacle-content .ui-slide .mission-report{border-top:2px solid #11abcd;border-bottom:2px solid #11abcd;padding:2.5vw 3vw;max-height:60vh;overflow-y:hidden;counter-reset:missioncounter}.epsIntermediates .spectacle-content .ui-slide .mission-report .form-fields{padding:0;width:100%}.epsIntermediates .spectacle-content .ui-slide .mission-report .form-horizontal{display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row}.epsIntermediates .spectacle-content .ui-slide .mission-report .form-horizontal .question-group-wrapper{margin:0 0 .5em}.epsIntermediates .spectacle-content .ui-slide .mission-report .form-horizontal .question-group-error{color:red;font-size:.8em;line-height:.8em}.epsIntermediates .spectacle-content .ui-slide .mission-report .form-horizontal .question-group{margin:0;display:-ms-flexbox;display:flex;-ms-flex-flow:wrap;flex-flow:wrap;-ms-flex-direction:row;flex-direction:row;-ms-flex-align:center;align-items:center}.epsIntermediates .spectacle-content .ui-slide .mission-report .form-horizontal .question-group:before{content:counter(missioncounter) \".\";counter-increment:missioncounter 1;display:block;width:1.5em;font-size:1.2em;line-height:1.2em;text-align:left;font-weight:700}.epsIntermediates .spectacle-content .ui-slide .mission-report .form-horizontal .button-group{margin-left:2.5vw;-ms-flex-preferred-size:240px;flex-basis:240px;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center}.epsIntermediates .spectacle-content .ui-slide .mission-report .form-horizontal input[type=number]::-webkit-inner-spin-button,.epsIntermediates .spectacle-content .ui-slide .mission-report .form-horizontal input[type=number]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}.epsIntermediates .spectacle-content .ui-slide .mission-report .form-horizontal input[type=number]{-moz-appearance:textfield}.epsIntermediates .spectacle-content .ui-slide .mission-report .form-horizontal .control-label{text-align:left}.epsIntermediates .spectacle-content .ui-slide .mission-report label{-ms-flex:2;flex:2;margin-top:0;padding-top:0;padding-right:.5em;font-size:1em;line-height:1em;display:table-cell;vertical-align:middle;font-weight:400;font-family:BrandonTextWeb;color:#11abcd}.epsIntermediates .spectacle-content .ui-slide .mission-report .form-control,.epsIntermediates .spectacle-content .ui-slide .mission-report input{border:.125em solid #11abcd;background:#000;width:3em;height:1.4em;padding:.25em .25em .1em;margin:0 0 1% 2%;border-radius:.25em;font-size:1.1em;text-align:right;line-height:.7em;font-family:Orbitron;color:#37bad5}.epsIntermediates .spectacle-content .ui-slide .mission-report .btn-fake{background-color:#000;box-sizing:border-box;width:150px;height:150px;padding:25px;border-radius:50%;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;border:4px solid #61d9f2;font-size:15px;text-transform:uppercase;box-shadow:inset 0 0 0 5px #000,inset 0 0 5px 15px #e0f000,0 0 0 0 #61d9f2;text-shadow:0 0 0 #fff;transition:all .5s ease-in-out;-webkit-tap-highlight-color:black;outline:none}.epsIntermediates .spectacle-content .ui-slide .mission-report .btn-fake:active{box-shadow:inset 0 0 0 3px #000,inset 0 0 15px 18px #f4ff58,0 0 10px 5px #61d9f2;text-shadow:0 0 15px #fff;transform:rotate(2turn)}.epsIntermediates .spectacle-content .team-names .form-group{margin:0 0 .5em;display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;-ms-flex-align:center;align-items:center}.epsIntermediates .spectacle-content .team-names label{-ms-flex-preferred-size:10em;flex-basis:10em;margin-top:0;padding-top:0;font-size:2em;line-height:1em;font-weight:400;font-family:Orbitron,sans-serif;text-transform:uppercase;text-align:right;color:#11abcd}.epsIntermediates .spectacle-content .team-names label i{margin:0 .125em 0 .25em;font-size:1.25em}.epsIntermediates .spectacle-content .team-names .team-1 label{color:#3cca3f}.epsIntermediates .spectacle-content .team-names .team-2 label{color:#c57b39}.epsIntermediates .spectacle-content .team-names .team-3 label{color:#187bc5}.epsIntermediates .spectacle-content .team-names .team-4 label{color:#f8f8f8}.epsIntermediates .spectacle-content .team-names .form-control{border-radius:.25em;height:2em;padding:.5em;margin-bottom:1%;font-size:1.2em}.epsIntermediates .spectacle-content .text-balloon{width:75vw;padding:5%;margin:15vh auto 0;border-radius:7.5vh;background-color:rgba(0,0,0,.3);-ms-flex-align:start;align-items:flex-start;text-align:left;color:#fff;font-size:1.2em}.epsIntermediates .spectacle-content .text-balloon:after{bottom:-30px;border-width:15px 30px;left:auto}.epsIntermediates .spectacle-content .text-balloon.left:after{border-color:rgba(0,0,0,.3) transparent transparent rgba(0,0,0,.3);left:35%;transform:skewX(-40deg)}.epsIntermediates .spectacle-content .text-balloon.right:after{border-color:rgba(0,0,0,.3) rgba(0,0,0,.3) transparent transparent;right:35%;transform:skewX(40deg)}.epsIntermediates .spectacle-content .text-balloon h2,.epsIntermediates .spectacle-content .text-balloon h3{margin-left:0;margin-right:0}.epsIntermediates .text-balloon-character{margin:-60px 15% 0;position:relative;text-align:center}.epsIntermediates .text-balloon-character.right{text-align:right}.epsIntermediates .text-balloon-character.left{text-align:left}.epsIntermediates .text-balloon-character img{height:30vh;width:auto}.epsIntermediates .text-heading{width:66.7%;font-size:1.6em;line-height:1.25em;text-align:center;margin:0 auto}.epsIntermediates .text-formatted{width:66.7%;font-size:1.6em;line-height:1.25em;text-align:left;margin:0 auto}.epsIntermediates .text-formatted ul{margin-top:.5em;padding-left:2em}.epsIntermediates .text-formatted li{margin-bottom:.5em}.epsIntermediates .text-formatted h2,.epsIntermediates .text-formatted h3{margin-left:0;margin-right:0}.epsIntermediates .text-balloon-body{width:auto;margin:0}.epsIntermediates .youtube-button .btn-lg{font-size:48px;line-height:40px;padding:8px 5px 8px 11px;height:100px;min-height:100px;width:100px;border-radius:50%;z-index:100}.epsIntermediates .level-complete{-ms-flex-direction:column;flex-direction:column;-ms-flex:1;flex:1}.epsIntermediates .level-complete,.epsIntermediates .spectacle-content .level-complete-content{display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center}.epsIntermediates .spectacle-content .level-complete-content{width:40vw;height:40vw;-ms-flex-direction:column;flex-direction:column}.epsIntermediates .spectacle-content .level-complete-content .level-complete-graphic{position:absolute;top:50%;left:50%;margin-left:-20vw;margin-top:-20vw;z-index:1}.epsIntermediates .spectacle-content .level-complete-content .level-complete-graphic img{width:40vw;height:40vw}.epsIntermediates .spectacle-content .level-complete-content h3{font-size:7em;line-height:.5em;font-weight:700;text-align:center}.epsIntermediates .spectacle-content .level-complete-content h2{text-align:center;font-weight:700}.epsIntermediates .spectacle-content .level-complete-content .btn{background:none;border-color:#fff;position:relative;z-index:2;height:2.5em;min-height:2.5em;padding:0 1.25em;border-radius:1.25em;font-family:BrandonTextWeb;font-size:1em;color:#fff;text-shadow:none}.epsIntermediates .hacked{background-color:#000;background-size:cover;animation:glitcher 2s;display:-ms-flexbox;display:flex;position:absolute;top:0;bottom:0;left:0;right:0;-ms-flex-align:end;align-items:flex-end}.epsIntermediates .hacked-form{width:40%;margin-left:50%;margin-bottom:6em}.epsIntermediates.deck-level-1 .spectacle-content .text-balloon.balloon-regular{background-color:rgba(150,50,0,.3)}.epsIntermediates.deck-level-1 .spectacle-content .text-balloon.balloon-regular.left:after{border-color:rgba(150,50,0,.3) transparent transparent rgba(150,50,0,.3)}.epsIntermediates.deck-level-1 .spectacle-content .text-balloon.balloon-regular.right:after{border-color:rgba(150,50,0,.3) rgba(150,50,0,.3) transparent transparent}.epsIntermediates.deck-level-5 .spectacle-content .text-balloon.balloon-regular{background-color:rgba(125,75,0,.3)}.epsIntermediates.deck-level-5 .spectacle-content .text-balloon.balloon-regular.left:after{border-color:rgba(125,75,0,.3) transparent transparent rgba(125,75,0,.3)}.epsIntermediates.deck-level-5 .spectacle-content .text-balloon.balloon-regular.right:after{border-color:rgba(125,75,0,.3) rgba(125,75,0,.3) transparent transparent}", ""]);
	
	// exports


/***/ }),
/* 1282 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(12)();
	// imports
	
	
	// module
	exports.push([module.id, ".epsPrimaries .heading-image{width:80%;height:80%;object-fit:contain;display:block;margin:0 auto}.epsPrimaries .heading-image-before{width:75%;height:auto;object-fit:inherit}.epsPrimaries .flex-image{width:45%;display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;-ms-flex-item-align:center;align-self:center}.epsPrimaries .flex-image>img.eps-logo{-ms-flex:1 1 auto;flex:1 1 auto}.epsPrimaries .spectacle-content .ui-slide .title-image h1{background-color:#000;width:80%;padding:1% 3% 1.5%;margin:0 auto;position:relative;z-index:1;font-family:BrandonTextWeb,Helvetica,Arial,sans-serif;font-size:1.1em;text-shadow:none;font-weight:400}.epsPrimaries .spectacle-content .ui-slide .title-image h2{background-color:#b4e166;width:80%;padding:3%;margin:0 auto;position:relative;font-family:BrandonTextWeb,Helvetica,Arial,sans-serif;font-size:2.4em;text-shadow:0 0 20px rgba(0,0,0,.3);font-weight:800;color:#000;text-align:center}.epsPrimaries .spectacle-content .ui-slide .title-image h2:after,.epsPrimaries .spectacle-content .ui-slide .title-image h2:before{content:\"\";position:absolute;display:block;bottom:-.5em;border:.75em solid #9fd93b;z-index:-1}.epsPrimaries .spectacle-content .ui-slide .title-image h2:before{left:-1em;border-right-width:.75em;border-left-color:transparent}.epsPrimaries .spectacle-content .ui-slide .title-image h2:after{right:-1em;border-left-width:.75em;border-right-color:transparent}.epsPrimaries .spectacle-content .ui-slide .title-image h2 strong:after,.epsPrimaries .spectacle-content .ui-slide .title-image h2 strong:before{content:\"\";position:absolute;display:block;border-style:solid;border-color:#85bc25 transparent transparent;bottom:-.5em}.epsPrimaries .spectacle-content .ui-slide .title-image h2 strong:before{left:0;border-width:.5em 0 0 .5em}.epsPrimaries .spectacle-content .ui-slide .title-image h2 strong:after{right:0;border-width:.5em .5em 0 0}.epsPrimaries .title-image{width:22em;height:25em;position:relative;margin:0 auto;z-index:1}.epsPrimaries .title-image:after{display:block;content:\"\";position:absolute;top:7%;right:10%;bottom:7em;left:10%;border-top-left-radius:5%;border-top-right-radius:5%}.epsPrimaries .title-image img{position:relative;z-index:2;height:18em;width:auto}.epsPrimaries .spectacle-deck:before{content:\"\";display:block;position:absolute;top:0;right:0;bottom:0;left:0}.epsPrimaries.deck-level-prep{background-color:#000;background-position:50%;background-image:linear-gradient(rgba(12,44,60,.5) 1px,transparent 0),linear-gradient(#0c2c3c 1px,transparent 0),linear-gradient(90deg,rgba(12,44,60,.5) 1px,transparent 0),linear-gradient(90deg,rgba(12,44,60,.7) 1px,transparent 0),linear-gradient(transparent 3px,#000 0,#000 73px,transparent 0),linear-gradient(90deg,rgba(12,44,60,.7) 3px,transparent 0,transparent 73px,rgba(12,44,60,.7) 0);background-size:5px 5px,75px 75px,5px 5px,75px 75px,75px 75px,75px 75px}.epsPrimaries.deck-level-prep .spectacle-content h3{margin-bottom:0;color:#37bad5}.epsPrimaries.deck-level-prep .text-formatted{font-size:1.4em}.epsPrimaries.deck-level-1 .deck-slide-transition-group,.epsPrimaries.deck-level-1 .title-image:after{background-color:#37b34a}.epsPrimaries.deck-level-1 .level-1 .overview-level-image,.epsPrimaries.deck-level-1 .spectacle-content .ui-slide .title-image h1{color:#37b34a}.epsPrimaries.deck-level-2 .deck-slide-transition-group,.epsPrimaries.deck-level-2 .title-image:after{background-color:#fa981d}.epsPrimaries.deck-level-2 .level-2 .overview-level-image,.epsPrimaries.deck-level-2 .spectacle-content .ui-slide .title-image h1{color:#fa981d}.epsPrimaries.deck-level-3 .deck-slide-transition-group,.epsPrimaries.deck-level-3 .title-image:after{background-color:#0daf4c}.epsPrimaries.deck-level-3 .level-3 .overview-level-image,.epsPrimaries.deck-level-3 .spectacle-content .ui-slide .title-image h1{color:#0daf4c}.epsPrimaries.deck-level-4 .deck-slide-transition-group,.epsPrimaries.deck-level-4 .title-image:after{background-color:#ae244e}.epsPrimaries.deck-level-4 .level-4 .overview-level-image,.epsPrimaries.deck-level-4 .spectacle-content .ui-slide .title-image h1{color:#ae244e}.epsPrimaries.deck-level-5 .deck-slide-transition-group,.epsPrimaries.deck-level-5 .title-image:after{background-color:#000}.epsPrimaries.deck-level-5 .level-5 .overview-level-image,.epsPrimaries.deck-level-5 .spectacle-content .ui-slide .title-image h1{color:#000}.epsPrimaries.deck-level-6 .deck-slide-transition-group,.epsPrimaries.deck-level-6 .title-image:after{background-color:#000}.epsPrimaries.deck-level-6 .level-6 .overview-level-image,.epsPrimaries.deck-level-6 .spectacle-content .ui-slide .title-image h1{color:#000}.epsPrimaries .level-1 .overview-level-image{background-color:#37b34a}.epsPrimaries .level-2 .overview-level-image{background-color:#fa981d}.epsPrimaries .level-3 .overview-level-image{background-color:#0daf4c}.epsPrimaries .level-4 .overview-level-image{background-color:#ae244e}.epsPrimaries .level-5 .overview-level-image,.epsPrimaries .level-6 .overview-level-image{background-color:#000}.epsPrimaries .slide-content{-ms-flex:1 1 0%;flex:1 1 0%;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-pack:center;justify-content:center;height:100%}.epsPrimaries .spectacle-content h1{margin:.25em auto;color:#fff;font-size:2.5em;font-family:BrandonTextWeb;line-height:1;font-weight:700}.epsPrimaries .spectacle-content h2{margin:.125em auto;font-weight:100}.epsPrimaries .spectacle-content h2,.epsPrimaries .spectacle-content h3{color:#fff;font-size:2em;font-family:BrandonTextWeb;line-height:1;letter-spacing:-.5px}.epsPrimaries .spectacle-content h3{margin:0 auto .125em;font-weight:700}.epsPrimaries .spectacle-content h4{font-size:1.6em;letter-spacing:0}.epsPrimaries .spectacle-content h4,.epsPrimaries .spectacle-content h6{margin:.5em auto;color:#fff;font-family:BrandonTextWeb;line-height:1;font-weight:400;text-transform:none}.epsPrimaries .spectacle-content h6{font-size:3.5em;letter-spacing:-.033em;text-align:center}.epsPrimaries .spectacle-content blockquote{text-align:left;position:relative;display:inline-block}.epsPrimaries .spectacle-content quote{border-left:1px solid #37bad5;padding-left:40;display:block;color:#37bad5;font-size:49px;line-height:1;font-weight:700}.epsPrimaries .spectacle-content cite{color:#fff;display:block;clear:left;font-size:20px;margin-top:1em}.epsPrimaries .spectacle-content content{margin:0 auto;text-align:center}.epsPrimaries .spectacle-content .ui-slide{background-color:#000;background-position:50%;background-image:linear-gradient(rgba(12,44,60,.5) 1px,transparent 0),linear-gradient(#0c2c3c 1px,transparent 0),linear-gradient(90deg,rgba(12,44,60,.5) 1px,transparent 0),linear-gradient(90deg,rgba(12,44,60,.7) 1px,transparent 0),linear-gradient(transparent 3px,#000 0,#000 73px,transparent 0),linear-gradient(90deg,rgba(12,44,60,.7) 3px,transparent 0,transparent 73px,rgba(12,44,60,.7) 0);background-size:5px 5px,75px 75px,5px 5px,75px 75px,75px 75px,75px 75px;-ms-flex:1;flex:1;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-pack:center;justify-content:center;padding:12.5%;font-family:Orbitron;color:#37bad5}.epsPrimaries .spectacle-content .ui-slide h1,.epsPrimaries .spectacle-content .ui-slide h2,.epsPrimaries .spectacle-content .ui-slide h3,.epsPrimaries .spectacle-content .ui-slide h4,.epsPrimaries .spectacle-content .ui-slide h5,.epsPrimaries .spectacle-content .ui-slide h6{color:#37bad5;font-family:Orbitron}.epsPrimaries .spectacle-content .ui-slide h1{margin:.25em 0 .75em;font-size:32px;font-size:3.6vw;text-align:center;text-shadow:0 0 5px #37bad5}@media (max-width:767px){.epsPrimaries .spectacle-content .ui-slide h1{font-size:18px;font-size:6vw}}.epsPrimaries .spectacle-content .ui-slide h2{color:#11abcd;font-size:1.8em;font-weight:700}.epsPrimaries .spectacle-content .ui-slide h3{color:#37bad5;text-shadow:0 0 5px #37bad5;font-size:1.6em;font-weight:400}.epsPrimaries .spectacle-content .ui-slide .flex-image+h3{margin-top:.5em;color:#b4e166;animation:glowing;text-align:center}.epsPrimaries .spectacle-content .ui-slide [class*=\" ppa-icon-\"]:before,.epsPrimaries .spectacle-content .ui-slide [class^=ppa-icon-]:before{margin:0}.epsPrimaries .spectacle-content .ui-slide .level-header{display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;-ms-flex-align:center;align-items:center;padding-bottom:2vw;min-height:8vw;min-height:8vmax}.epsPrimaries .spectacle-content .ui-slide .level-header .level-header-thumb{position:relative;display:block;margin:0 30px;height:6.5vw;width:6.5vw;border-radius:10px}.epsPrimaries .spectacle-content .ui-slide .level-header .level-header-thumb img{width:auto;height:7vw;margin:-.25vw}.epsPrimaries .spectacle-content .ui-slide .level-header .level-header-thumb:after,.epsPrimaries .spectacle-content .ui-slide .level-header .level-header-thumb:before{content:\"\";display:block;border:3px solid #11abcd;width:10px;position:absolute;top:0;bottom:0}.epsPrimaries .spectacle-content .ui-slide .level-header .level-header-thumb:before{border-top-left-radius:10px;border-bottom-left-radius:10px;left:-20px;border-right:none}.epsPrimaries .spectacle-content .ui-slide .level-header .level-header-thumb:after{border-top-right-radius:10px;border-bottom-right-radius:10px;right:-20px;border-left:none}.epsPrimaries .spectacle-content .ui-slide .level-header .level-header-thumb+h2{margin-left:.5vw}.epsPrimaries .spectacle-content .ui-slide .level-header h2{-ms-flex:1;flex:1}.epsPrimaries .spectacle-content .ui-slide.mission-report-level-1 .level-header-thumb{background-color:#37b34a;box-shadow:0 0 15px #37b34a}.epsPrimaries .spectacle-content .ui-slide.mission-report-level-2 .level-header-thumb{background-color:#fa981d;box-shadow:0 0 15px #fa981d}.epsPrimaries .spectacle-content .ui-slide.mission-report-level-3 .level-header-thumb{background-color:#0daf4c;box-shadow:0 0 15px #0daf4c}.epsPrimaries .spectacle-content .ui-slide.mission-report-level-4 .level-header-thumb{background-color:#ae244e;box-shadow:0 0 15px #ae244e}.epsPrimaries .spectacle-content .ui-slide.mission-report-level-5 .level-header-thumb{background-color:#000;box-shadow:0 0 15px #000}.epsPrimaries .spectacle-content .ui-slide .mission-report{border-top:2px solid #11abcd;border-bottom:2px solid #11abcd;padding:2.5vw 3vw;max-height:60vh;overflow-y:hidden;counter-reset:missioncounter}.epsPrimaries .spectacle-content .ui-slide .mission-report .form-fields{padding:0;width:100%}.epsPrimaries .spectacle-content .ui-slide .mission-report .form-horizontal{display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row}.epsPrimaries .spectacle-content .ui-slide .mission-report .form-horizontal .question-group-wrapper{margin:0 0 .5em}.epsPrimaries .spectacle-content .ui-slide .mission-report .form-horizontal .question-group-error{color:red;font-size:.8em;line-height:.8em}.epsPrimaries .spectacle-content .ui-slide .mission-report .form-horizontal .question-group{margin:0;display:-ms-flexbox;display:flex;-ms-flex-flow:wrap;flex-flow:wrap;-ms-flex-direction:row;flex-direction:row;-ms-flex-align:center;align-items:center}.epsPrimaries .spectacle-content .ui-slide .mission-report .form-horizontal .question-group:before{content:counter(missioncounter) \".\";counter-increment:missioncounter 1;display:block;width:1.5em;font-size:1.2em;line-height:1.2em;text-align:left;font-weight:700}.epsPrimaries .spectacle-content .ui-slide .mission-report .form-horizontal .button-group{margin-left:2.5vw;-ms-flex-preferred-size:240px;flex-basis:240px;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center}.epsPrimaries .spectacle-content .ui-slide .mission-report .form-horizontal input[type=number]::-webkit-inner-spin-button,.epsPrimaries .spectacle-content .ui-slide .mission-report .form-horizontal input[type=number]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}.epsPrimaries .spectacle-content .ui-slide .mission-report .form-horizontal input[type=number]{-moz-appearance:textfield}.epsPrimaries .spectacle-content .ui-slide .mission-report .form-horizontal .control-label{text-align:left}.epsPrimaries .spectacle-content .ui-slide .mission-report label{-ms-flex:2;flex:2;margin-top:0;padding-top:0;padding-right:.5em;font-size:1em;line-height:1em;display:table-cell;vertical-align:middle;font-weight:400;font-family:BrandonTextWeb;color:#11abcd}.epsPrimaries .spectacle-content .ui-slide .mission-report .form-control,.epsPrimaries .spectacle-content .ui-slide .mission-report input{border:.125em solid #11abcd;background:#000;width:3em;height:1.4em;padding:.25em .25em .1em;margin:0 0 1% 2%;border-radius:.25em;font-size:1.1em;text-align:right;line-height:.7em;font-family:Orbitron;color:#37bad5}.epsPrimaries .spectacle-content .ui-slide .mission-report .btn-fake{background-color:#000;box-sizing:border-box;width:150px;height:150px;padding:25px;border-radius:50%;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;border:4px solid #61d9f2;font-size:15px;text-transform:uppercase;box-shadow:inset 0 0 0 5px #000,inset 0 0 5px 15px #e0f000,0 0 0 0 #61d9f2;text-shadow:0 0 0 #fff;transition:all .5s ease-in-out;-webkit-tap-highlight-color:black;outline:none}.epsPrimaries .spectacle-content .ui-slide .mission-report .btn-fake:active{box-shadow:inset 0 0 0 3px #000,inset 0 0 15px 18px #f4ff58,0 0 10px 5px #61d9f2;text-shadow:0 0 15px #fff;transform:rotate(2turn)}.epsPrimaries .spectacle-content .team-names .form-group{margin:0 0 .5em;display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;-ms-flex-align:center;align-items:center}.epsPrimaries .spectacle-content .team-names label{-ms-flex-preferred-size:10em;flex-basis:10em;margin-top:0;padding-top:0;font-size:2em;line-height:1em;font-weight:400;font-family:Orbitron,sans-serif;text-transform:uppercase;text-align:right;color:#11abcd}.epsPrimaries .spectacle-content .team-names label i{margin:0 .125em 0 .25em;font-size:1.25em}.epsPrimaries .spectacle-content .team-names .team-1 label{color:#3cca3f}.epsPrimaries .spectacle-content .team-names .team-2 label{color:#c57b39}.epsPrimaries .spectacle-content .team-names .team-3 label{color:#187bc5}.epsPrimaries .spectacle-content .team-names .team-4 label{color:#f8f8f8}.epsPrimaries .spectacle-content .team-names .form-control{border-radius:.25em;height:2em;padding:.5em;margin-bottom:1%;font-size:1.2em}.epsPrimaries .spectacle-content .text-balloon{width:75vw;padding:5%;margin:15vh auto 0;border-radius:7.5vh;background-color:rgba(0,0,0,.3);-ms-flex-align:start;align-items:flex-start;text-align:left;color:#fff;font-size:1.2em}.epsPrimaries .spectacle-content .text-balloon:after{bottom:-30px;border-width:15px 30px;left:auto}.epsPrimaries .spectacle-content .text-balloon.left:after{border-color:rgba(0,0,0,.3) transparent transparent rgba(0,0,0,.3);left:35%;transform:skewX(-40deg)}.epsPrimaries .spectacle-content .text-balloon.right:after{border-color:rgba(0,0,0,.3) rgba(0,0,0,.3) transparent transparent;right:35%;transform:skewX(40deg)}.epsPrimaries .spectacle-content .text-balloon h2,.epsPrimaries .spectacle-content .text-balloon h3{margin-left:0;margin-right:0}.epsPrimaries .text-balloon-character{margin:-60px 15% 0;position:relative;text-align:center}.epsPrimaries .text-balloon-character.right{text-align:right}.epsPrimaries .text-balloon-character.left{text-align:left}.epsPrimaries .text-balloon-character img{height:30vh;width:auto}.epsPrimaries .text-heading{text-align:center}.epsPrimaries .text-formatted,.epsPrimaries .text-heading{width:66.7%;font-size:1.6em;line-height:1.25em;margin:0 auto}.epsPrimaries .text-formatted{text-align:left}.epsPrimaries .text-formatted ul{margin-top:.5em;padding-left:2em}.epsPrimaries .text-formatted li{margin-bottom:.5em}.epsPrimaries .text-formatted h2,.epsPrimaries .text-formatted h3{margin-left:0;margin-right:0}.epsPrimaries .text-balloon-body{width:auto;margin:0}.epsPrimaries .youtube-button .btn-lg{font-size:48px;line-height:40px;padding:8px 5px 8px 11px;height:100px;min-height:100px;width:100px;border-radius:50%;z-index:100}.epsPrimaries .level-complete{-ms-flex-direction:column;flex-direction:column;-ms-flex:1;flex:1}.epsPrimaries .level-complete,.epsPrimaries .spectacle-content .level-complete-content{display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center}.epsPrimaries .spectacle-content .level-complete-content{width:40vw;height:40vw;-ms-flex-direction:column;flex-direction:column}.epsPrimaries .spectacle-content .level-complete-content .level-complete-graphic{position:absolute;top:50%;left:50%;margin-left:-20vw;margin-top:-20vw;z-index:1}.epsPrimaries .spectacle-content .level-complete-content .level-complete-graphic img{width:40vw;height:40vw}.epsPrimaries .spectacle-content .level-complete-content h3{font-size:7em;line-height:.5em;font-weight:700;text-align:center}.epsPrimaries .spectacle-content .level-complete-content h2{text-align:center;font-weight:700}.epsPrimaries .spectacle-content .level-complete-content .btn{background:none;border-color:#fff;position:relative;z-index:2;height:2.5em;min-height:2.5em;padding:0 1.25em;border-radius:1.25em;font-family:BrandonTextWeb;font-size:1em;color:#fff;text-shadow:none}.epsPrimaries .hacked{background-color:#000;background-size:cover;animation:glitcher 2s;display:-ms-flexbox;display:flex;position:absolute;top:0;bottom:0;left:0;right:0;-ms-flex-align:end;align-items:flex-end}.epsPrimaries .hacked-form{width:40%;margin-left:50%;margin-bottom:6em}.epsPrimaries.deck-level-1 .spectacle-content .text-balloon.balloon-regular{background-color:rgba(150,50,0,.3)}.epsPrimaries.deck-level-1 .spectacle-content .text-balloon.balloon-regular.left:after{border-color:rgba(150,50,0,.3) transparent transparent rgba(150,50,0,.3)}.epsPrimaries.deck-level-1 .spectacle-content .text-balloon.balloon-regular.right:after{border-color:rgba(150,50,0,.3) rgba(150,50,0,.3) transparent transparent}.epsPrimaries.deck-level-5 .spectacle-content .text-balloon.balloon-regular{background-color:rgba(125,75,0,.3)}.epsPrimaries.deck-level-5 .spectacle-content .text-balloon.balloon-regular.left:after{border-color:rgba(125,75,0,.3) transparent transparent rgba(125,75,0,.3)}.epsPrimaries.deck-level-5 .spectacle-content .text-balloon.balloon-regular.right:after{border-color:rgba(125,75,0,.3) rgba(125,75,0,.3) transparent transparent}", ""]);
	
	// exports


/***/ }),
/* 1283 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(12)();
	// imports
	
	
	// module
	exports.push([module.id, ".h2whoa .heading-image{width:80%;height:80%;object-fit:contain;display:block;margin:0 auto}.h2whoa .heading-image-before{width:75%;height:auto;object-fit:inherit}.h2whoa .flex-image{width:45%;display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;-ms-flex-item-align:center;align-self:center}.h2whoa .spectacle-content .ui-slide .title-image h1{background-color:#000;width:80%;padding:1% 3% 1.5%;margin:0 auto;position:relative;z-index:1;font-family:BrandonTextWeb,Helvetica,Arial,sans-serif;font-size:1.1em;text-shadow:none;font-weight:400}.h2whoa .spectacle-content .ui-slide .title-image h2{background-color:#b4e166;width:80%;padding:3%;margin:0 auto;position:relative;font-family:BrandonTextWeb,Helvetica,Arial,sans-serif;font-size:2.4em;text-shadow:0 0 20px rgba(0,0,0,.3);font-weight:800;color:#000;text-align:center}.h2whoa .spectacle-content .ui-slide .title-image h2:after,.h2whoa .spectacle-content .ui-slide .title-image h2:before{content:\"\";position:absolute;display:block;bottom:-.5em;border:.75em solid #9fd93b;z-index:-1}.h2whoa .spectacle-content .ui-slide .title-image h2:before{left:-1em;border-right-width:.75em;border-left-color:transparent}.h2whoa .spectacle-content .ui-slide .title-image h2:after{right:-1em;border-left-width:.75em;border-right-color:transparent}.h2whoa .spectacle-content .ui-slide .title-image h2 strong:after,.h2whoa .spectacle-content .ui-slide .title-image h2 strong:before{content:\"\";position:absolute;display:block;border-style:solid;border-color:#85bc25 transparent transparent;bottom:-.5em}.h2whoa .spectacle-content .ui-slide .title-image h2 strong:before{left:0;border-width:.5em 0 0 .5em}.h2whoa .spectacle-content .ui-slide .title-image h2 strong:after{right:0;border-width:.5em .5em 0 0}.h2whoa .title-image{width:22em;height:25em;position:relative;margin:0 auto;z-index:1}.h2whoa .title-image:after{display:block;content:\"\";position:absolute;top:7%;right:10%;bottom:7em;left:10%;border-top-left-radius:5%;border-top-right-radius:5%}.h2whoa .title-image img{position:relative;z-index:2;height:18em;width:auto}.h2whoa .spectacle-deck:before{content:\"\";display:block;position:absolute;top:0;right:0;bottom:0;left:0}.h2whoa.deck-level-prep{background-color:#000;background-position:50%;background-image:linear-gradient(rgba(12,44,60,.5) 1px,transparent 0),linear-gradient(#0c2c3c 1px,transparent 0),linear-gradient(90deg,rgba(12,44,60,.5) 1px,transparent 0),linear-gradient(90deg,rgba(12,44,60,.7) 1px,transparent 0),linear-gradient(transparent 3px,#000 0,#000 73px,transparent 0),linear-gradient(90deg,rgba(12,44,60,.7) 3px,transparent 0,transparent 73px,rgba(12,44,60,.7) 0);background-size:5px 5px,75px 75px,5px 5px,75px 75px,75px 75px,75px 75px}.h2whoa.deck-level-prep .spectacle-content h3{margin-bottom:0;color:#37bad5}.h2whoa.deck-level-prep .text-formatted{font-size:1.4em}.h2whoa.deck-level-1 .deck-slide-transition-group,.h2whoa.deck-level-1 .title-image:after{background-color:#3ad7ff}.h2whoa.deck-level-1 .level-1 .overview-level-image,.h2whoa.deck-level-1 .spectacle-content .ui-slide .title-image h1{color:#3ad7ff}.h2whoa.deck-level-2 .deck-slide-transition-group,.h2whoa.deck-level-2 .title-image:after{background-color:#39b44a}.h2whoa.deck-level-2 .level-2 .overview-level-image,.h2whoa.deck-level-2 .spectacle-content .ui-slide .title-image h1{color:#39b44a}.h2whoa.deck-level-3 .deck-slide-transition-group,.h2whoa.deck-level-3 .title-image:after{background-color:#fdbc11}.h2whoa.deck-level-3 .level-3 .overview-level-image,.h2whoa.deck-level-3 .spectacle-content .ui-slide .title-image h1{color:#fdbc11}.h2whoa.deck-level-4 .deck-slide-transition-group,.h2whoa.deck-level-4 .title-image:after{background-color:#e51088}.h2whoa.deck-level-4 .level-4 .overview-level-image,.h2whoa.deck-level-4 .spectacle-content .ui-slide .title-image h1{color:#e51088}.h2whoa .level-1 .overview-level-image{background-color:#3ad7ff}.h2whoa .level-2 .overview-level-image{background-color:#39b44a}.h2whoa .level-3 .overview-level-image{background-color:#fdbc11}.h2whoa .level-4 .overview-level-image{background-color:#e51088}.h2whoa .slide-content{-ms-flex:1 1 0%;flex:1 1 0%;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-pack:center;justify-content:center;height:100%}.h2whoa .spectacle-content h1{margin:.25em auto;color:#fff;font-size:2.5em;font-family:BrandonTextWeb,Helvetica,Arial,sans-serif;line-height:1;font-weight:700}.h2whoa .spectacle-content h2{margin:.125em auto;font-weight:100}.h2whoa .spectacle-content h2,.h2whoa .spectacle-content h3{color:#fff;font-size:2em;font-family:BrandonTextWeb,Helvetica,Arial,sans-serif;line-height:1;letter-spacing:-.5px}.h2whoa .spectacle-content h3{margin:0 auto .125em;font-weight:700}.h2whoa .spectacle-content h4{font-size:1.6em;letter-spacing:0}.h2whoa .spectacle-content h4,.h2whoa .spectacle-content h6{margin:.5em auto;color:#fff;font-family:BrandonTextWeb,Helvetica,Arial,sans-serif;line-height:1;font-weight:400;text-transform:none}.h2whoa .spectacle-content h6{font-size:3.5em;letter-spacing:-.033em;text-align:center}.h2whoa .spectacle-content blockquote{text-align:left;position:relative;display:inline-block}.h2whoa .spectacle-content quote{border-left:1px solid #37bad5;padding-left:40;display:block;color:#37bad5;font-size:49px;line-height:1;font-weight:700}.h2whoa .spectacle-content cite{color:#fff;display:block;clear:left;font-size:20px;margin-top:1em}.h2whoa .spectacle-content content{margin:0 auto;text-align:center}.h2whoa .spectacle-content .ui-slide{background-color:#000;background-position:50%;background-image:linear-gradient(rgba(12,44,60,.5) 1px,transparent 0),linear-gradient(#0c2c3c 1px,transparent 0),linear-gradient(90deg,rgba(12,44,60,.5) 1px,transparent 0),linear-gradient(90deg,rgba(12,44,60,.7) 1px,transparent 0),linear-gradient(transparent 3px,#000 0,#000 73px,transparent 0),linear-gradient(90deg,rgba(12,44,60,.7) 3px,transparent 0,transparent 73px,rgba(12,44,60,.7) 0);background-size:5px 5px,75px 75px,5px 5px,75px 75px,75px 75px,75px 75px;-ms-flex:1;flex:1;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-pack:center;justify-content:center;padding:12.5%;font-family:Orbitron;color:#37bad5}.h2whoa .spectacle-content .ui-slide h1,.h2whoa .spectacle-content .ui-slide h2,.h2whoa .spectacle-content .ui-slide h3,.h2whoa .spectacle-content .ui-slide h4,.h2whoa .spectacle-content .ui-slide h5,.h2whoa .spectacle-content .ui-slide h6{color:#37bad5;font-family:Orbitron}.h2whoa .spectacle-content .ui-slide h1{margin:.25em 0 .75em;font-size:32px;font-size:3.6vw;text-align:center;text-shadow:0 0 5px #37bad5}@media (max-width:767px){.h2whoa .spectacle-content .ui-slide h1{font-size:18px;font-size:6vw}}.h2whoa .spectacle-content .ui-slide h2{color:#11abcd;font-size:1.8em;font-weight:700}.h2whoa .spectacle-content .ui-slide h3{color:#37bad5;text-shadow:0 0 5px #37bad5;font-size:1.6em;font-weight:400}.h2whoa .spectacle-content .ui-slide .flex-image+h3{margin-top:.5em;color:#b4e166;animation:glowing;text-align:center}.h2whoa .spectacle-content .ui-slide [class*=\" ppa-icon-\"]:before,.h2whoa .spectacle-content .ui-slide [class^=ppa-icon-]:before{margin:0}.h2whoa .spectacle-content .ui-slide .level-header{display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;-ms-flex-align:center;align-items:center;padding-bottom:2vw;min-height:8vw;min-height:8vmax}.h2whoa .spectacle-content .ui-slide .level-header .level-header-thumb{position:relative;display:block;margin:0 30px;height:6.5vw;width:6.5vw;border-radius:10px}.h2whoa .spectacle-content .ui-slide .level-header .level-header-thumb img{width:auto;height:7vw;margin:-.25vw}.h2whoa .spectacle-content .ui-slide .level-header .level-header-thumb:after,.h2whoa .spectacle-content .ui-slide .level-header .level-header-thumb:before{content:\"\";display:block;border:3px solid #11abcd;width:10px;position:absolute;top:0;bottom:0}.h2whoa .spectacle-content .ui-slide .level-header .level-header-thumb:before{border-top-left-radius:10px;border-bottom-left-radius:10px;left:-20px;border-right:none}.h2whoa .spectacle-content .ui-slide .level-header .level-header-thumb:after{border-top-right-radius:10px;border-bottom-right-radius:10px;right:-20px;border-left:none}.h2whoa .spectacle-content .ui-slide .level-header .level-header-thumb+h2{margin-left:.5vw}.h2whoa .spectacle-content .ui-slide .level-header h2{-ms-flex:1;flex:1}.h2whoa .spectacle-content .ui-slide.mission-report-level-1 .level-header-thumb{background-color:#3ad7ff;box-shadow:0 0 15px #3ad7ff}.h2whoa .spectacle-content .ui-slide.mission-report-level-2 .level-header-thumb{background-color:#39b44a;box-shadow:0 0 15px #39b44a}.h2whoa .spectacle-content .ui-slide.mission-report-level-3 .level-header-thumb{background-color:#fdbc11;box-shadow:0 0 15px #fdbc11}.h2whoa .spectacle-content .ui-slide.mission-report-level-4 .level-header-thumb{background-color:#e51088;box-shadow:0 0 15px #e51088}.h2whoa .spectacle-content .ui-slide .mission-report{border-top:2px solid #11abcd;border-bottom:2px solid #11abcd;padding:2.5vw 3vw;max-height:60vh;overflow-y:hidden;counter-reset:missioncounter}.h2whoa .spectacle-content .ui-slide .mission-report .form-fields{padding:0;width:100%}.h2whoa .spectacle-content .ui-slide .mission-report .form-horizontal{display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row}.h2whoa .spectacle-content .ui-slide .mission-report .form-horizontal .question-group-wrapper{margin:0 0 .5em}.h2whoa .spectacle-content .ui-slide .mission-report .form-horizontal .question-group-error{color:red;font-size:.8em;line-height:.8em}.h2whoa .spectacle-content .ui-slide .mission-report .form-horizontal .question-group{margin:0;display:-ms-flexbox;display:flex;-ms-flex-flow:wrap;flex-flow:wrap;-ms-flex-direction:row;flex-direction:row;-ms-flex-align:center;align-items:center}.h2whoa .spectacle-content .ui-slide .mission-report .form-horizontal .question-group:before{content:counter(missioncounter) \".\";counter-increment:missioncounter 1;display:block;width:1.5em;font-size:1.2em;line-height:1.2em;text-align:left;font-weight:700}.h2whoa .spectacle-content .ui-slide .mission-report .form-horizontal .button-group{margin-left:2.5vw;-ms-flex-preferred-size:240px;flex-basis:240px;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center}.h2whoa .spectacle-content .ui-slide .mission-report .form-horizontal input[type=number]::-webkit-inner-spin-button,.h2whoa .spectacle-content .ui-slide .mission-report .form-horizontal input[type=number]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}.h2whoa .spectacle-content .ui-slide .mission-report .form-horizontal input[type=number]{-moz-appearance:textfield}.h2whoa .spectacle-content .ui-slide .mission-report .form-horizontal .control-label{text-align:left}.h2whoa .spectacle-content .ui-slide .mission-report label{-ms-flex:2;flex:2;margin-top:0;padding-top:0;padding-right:.5em;font-size:1em;line-height:1em;font-weight:400;font-family:BrandonTextWeb,Helvetica,Arial,sans-serif;color:#11abcd}.h2whoa .spectacle-content .ui-slide .mission-report .form-control,.h2whoa .spectacle-content .ui-slide .mission-report input{border:.125em solid #11abcd;background:#000;width:3em;height:1.4em;padding:.25em .25em .1em;margin:0 0 1% 2%;border-radius:.25em;font-size:1.1em;text-align:right;line-height:.7em;font-family:Orbitron;color:#37bad5}.h2whoa .spectacle-content .ui-slide .mission-report .btn-fake{background-color:#000;box-sizing:border-box;width:150px;height:150px;padding:25px;border-radius:50%;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;border:4px solid #61d9f2;font-size:15px;text-transform:uppercase;box-shadow:inset 0 0 0 5px #000,inset 0 0 5px 15px #e0f000,0 0 0 0 #61d9f2;text-shadow:0 0 0 #fff;transition:all .5s ease-in-out;-webkit-tap-highlight-color:black;outline:none}.h2whoa .spectacle-content .ui-slide .mission-report .btn-fake:active{box-shadow:inset 0 0 0 3px #000,inset 0 0 15px 18px #f4ff58,0 0 10px 5px #61d9f2;text-shadow:0 0 15px #fff;transform:rotate(2turn)}.h2whoa .spectacle-content .team-names .form-group{margin:0 0 .5em;display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;-ms-flex-align:center;align-items:center}.h2whoa .spectacle-content .team-names label{-ms-flex-preferred-size:10em;flex-basis:10em;margin-top:0;padding-top:0;font-size:2em;line-height:1em;font-weight:400;font-family:Orbitron,sans-serif;text-transform:uppercase;text-align:right;color:#11abcd}.h2whoa .spectacle-content .team-names label i{margin:0 .125em 0 .25em;font-size:1.25em}.h2whoa .spectacle-content .team-names .team-1 label{color:#3cca3f}.h2whoa .spectacle-content .team-names .team-2 label{color:#c57b39}.h2whoa .spectacle-content .team-names .team-3 label{color:#187bc5}.h2whoa .spectacle-content .team-names .team-4 label{color:#f8f8f8}.h2whoa .spectacle-content .team-names .form-control{border-radius:.25em;height:2em;padding:.5em;margin-bottom:1%;font-size:1.2em}.h2whoa .spectacle-content .text-balloon{width:75vw;padding:5%;margin:15vh auto 0;border-radius:7.5vh;background-color:rgba(0,0,0,.3);-ms-flex-align:start;align-items:flex-start;text-align:left;color:#fff;font-size:1.2em}.h2whoa .spectacle-content .text-balloon:after{bottom:-30px;border-width:15px 30px;left:auto}.h2whoa .spectacle-content .text-balloon.left:after{border-color:rgba(0,0,0,.3) transparent transparent rgba(0,0,0,.3);left:35%;transform:skewX(-40deg)}.h2whoa .spectacle-content .text-balloon.right:after{border-color:rgba(0,0,0,.3) rgba(0,0,0,.3) transparent transparent;right:35%;transform:skewX(40deg)}.h2whoa .spectacle-content .text-balloon h2,.h2whoa .spectacle-content .text-balloon h3{margin-left:0;margin-right:0}.h2whoa .text-balloon-character{margin:-60px 15% 0;position:relative;text-align:center}.h2whoa .text-balloon-character.right{text-align:right}.h2whoa .text-balloon-character.left{text-align:left}.h2whoa .text-balloon-character img{height:30vh;width:auto}.h2whoa .text-heading{text-align:center}.h2whoa .text-formatted,.h2whoa .text-heading{width:66.7%;font-size:1.6em;line-height:1.25em;margin:0 auto}.h2whoa .text-formatted{text-align:left}.h2whoa .text-formatted ul{margin-top:.5em;padding-left:2em}.h2whoa .text-formatted li{margin-bottom:.5em}.h2whoa .text-formatted h2,.h2whoa .text-formatted h3{margin-left:0;margin-right:0}.h2whoa .text-balloon-body{width:auto;margin:0}.h2whoa .youtube-button .btn-lg{font-size:48px;line-height:40px;padding:8px 5px 8px 11px;height:100px;min-height:100px;width:100px;border-radius:50%;z-index:100}.h2whoa .level-complete{-ms-flex-direction:column;flex-direction:column;-ms-flex:1;flex:1}.h2whoa .level-complete,.h2whoa .spectacle-content .level-complete-content{display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center}.h2whoa .spectacle-content .level-complete-content{width:44vw;height:44vw;-ms-flex-direction:column;flex-direction:column}.h2whoa .spectacle-content .level-complete-content .level-complete-graphic{position:absolute;top:50%;left:50%;margin-left:-22vw;margin-top:-22vw;z-index:1}.h2whoa .spectacle-content .level-complete-content .level-complete-graphic img{width:44vw;height:44vw}.h2whoa .spectacle-content .level-complete-content h3{font-size:7em;line-height:.5em;font-weight:700;text-align:center}.h2whoa .spectacle-content .level-complete-content h2{text-align:center;font-weight:700}.h2whoa .spectacle-content .level-complete-content .btn{background:none;border-color:#fff;position:relative;z-index:2;height:2.5em;min-height:2.5em;padding:0 1.25em;border-radius:1.25em;font-family:BrandonTextWeb,Helvetica,Arial,sans-serif;font-size:1em;color:#fff;text-shadow:none}.h2whoa .hacked{background-color:#000;background-size:cover;animation:glitcher 2s;display:-ms-flexbox;display:flex;position:absolute;top:0;bottom:0;left:0;right:0;-ms-flex-align:end;align-items:flex-end}.h2whoa .hacked-form{width:40%;margin-left:50%;margin-bottom:6em}.h2whoa.deck-level-1 .spectacle-content .text-balloon.balloon-regular{background-color:rgba(150,50,0,.3)}.h2whoa.deck-level-1 .spectacle-content .text-balloon.balloon-regular.left:after{border-color:rgba(150,50,0,.3) transparent transparent rgba(150,50,0,.3)}.h2whoa.deck-level-1 .spectacle-content .text-balloon.balloon-regular.right:after{border-color:rgba(150,50,0,.3) rgba(150,50,0,.3) transparent transparent}.h2whoa.deck-level-5 .spectacle-content .text-balloon.balloon-regular{background-color:rgba(125,75,0,.3)}.h2whoa.deck-level-5 .spectacle-content .text-balloon.balloon-regular.left:after{border-color:rgba(125,75,0,.3) transparent transparent rgba(125,75,0,.3)}.h2whoa.deck-level-5 .spectacle-content .text-balloon.balloon-regular.right:after{border-color:rgba(125,75,0,.3) rgba(125,75,0,.3) transparent transparent}", ""]);
	
	// exports


/***/ }),
/* 1284 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(12)();
	// imports
	
	
	// module
	exports.push([module.id, ".h2whoaHybrid .heading-image{width:80%;height:80%;object-fit:contain;display:block;margin:0 auto}.h2whoaHybrid .heading-image-before{width:75%;height:auto;object-fit:inherit}.h2whoaHybrid .flex-image{width:45%;display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;-ms-flex-item-align:center;align-self:center}.h2whoaHybrid .flex-image>img.eps-logo{-ms-flex:1 1 auto;flex:1 1 auto}.h2whoaHybrid .spectacle-content .ui-slide .title-image h1{background-color:#000;width:80%;padding:1% 3% 1.5%;margin:0 auto;position:relative;z-index:1;font-family:BrandonTextWeb,Helvetica,Arial,sans-serif;font-size:1.1em;text-shadow:none;font-weight:400}.h2whoaHybrid .spectacle-content .ui-slide .title-image h2{background-color:#b4e166;width:80%;padding:3%;margin:0 auto;position:relative;font-family:BrandonTextWeb,Helvetica,Arial,sans-serif;font-size:2.4em;text-shadow:0 0 20px rgba(0,0,0,.3);font-weight:800;color:#000;text-align:center}.h2whoaHybrid .spectacle-content .ui-slide .title-image h2:after,.h2whoaHybrid .spectacle-content .ui-slide .title-image h2:before{content:\"\";position:absolute;display:block;bottom:-.5em;border:.75em solid #9fd93b;z-index:-1}.h2whoaHybrid .spectacle-content .ui-slide .title-image h2:before{left:-1em;border-right-width:.75em;border-left-color:transparent}.h2whoaHybrid .spectacle-content .ui-slide .title-image h2:after{right:-1em;border-left-width:.75em;border-right-color:transparent}.h2whoaHybrid .spectacle-content .ui-slide .title-image h2 strong:after,.h2whoaHybrid .spectacle-content .ui-slide .title-image h2 strong:before{content:\"\";position:absolute;display:block;border-style:solid;border-color:#85bc25 transparent transparent;bottom:-.5em}.h2whoaHybrid .spectacle-content .ui-slide .title-image h2 strong:before{left:0;border-width:.5em 0 0 .5em}.h2whoaHybrid .spectacle-content .ui-slide .title-image h2 strong:after{right:0;border-width:.5em .5em 0 0}.h2whoaHybrid .title-image{width:22em;height:25em;position:relative;margin:0 auto;z-index:1}.h2whoaHybrid .title-image:after{display:block;content:\"\";position:absolute;top:7%;right:10%;bottom:7em;left:10%;border-top-left-radius:5%;border-top-right-radius:5%}.h2whoaHybrid .title-image img{position:relative;z-index:2;height:18em;width:auto}.h2whoaHybrid .spectacle-deck:before{content:\"\";display:block;position:absolute;top:0;right:0;bottom:0;left:0}.h2whoaHybrid.deck-level-prep{background-color:#000;background-position:50%;background-image:linear-gradient(rgba(12,44,60,.5) 1px,transparent 0),linear-gradient(#0c2c3c 1px,transparent 0),linear-gradient(90deg,rgba(12,44,60,.5) 1px,transparent 0),linear-gradient(90deg,rgba(12,44,60,.7) 1px,transparent 0),linear-gradient(transparent 3px,#000 0,#000 73px,transparent 0),linear-gradient(90deg,rgba(12,44,60,.7) 3px,transparent 0,transparent 73px,rgba(12,44,60,.7) 0);background-size:5px 5px,75px 75px,5px 5px,75px 75px,75px 75px,75px 75px}.h2whoaHybrid.deck-level-prep .spectacle-content h3{margin-bottom:0;color:#37bad5}.h2whoaHybrid.deck-level-prep .text-formatted{font-size:1.4em}.h2whoaHybrid.deck-level-1 .deck-slide-transition-group,.h2whoaHybrid.deck-level-1 .title-image:after{background-color:#26a7df}.h2whoaHybrid.deck-level-1 .level-1 .overview-level-image,.h2whoaHybrid.deck-level-1 .spectacle-content .ui-slide .title-image h1{color:#26a7df}.h2whoaHybrid.deck-level-2 .deck-slide-transition-group,.h2whoaHybrid.deck-level-2 .title-image:after{background-color:#0daf4c}.h2whoaHybrid.deck-level-2 .level-2 .overview-level-image,.h2whoaHybrid.deck-level-2 .spectacle-content .ui-slide .title-image h1{color:#0daf4c}.h2whoaHybrid .level-1 .overview-level-image{background-color:#26a7df}.h2whoaHybrid .level-2 .overview-level-image{background-color:#0daf4c}.h2whoaHybrid .slide-content{-ms-flex:1 1 0%;flex:1 1 0%;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-pack:center;justify-content:center;height:100%}.h2whoaHybrid .spectacle-content h1{margin:.25em auto;color:#fff;font-size:2.5em;font-family:BrandonTextWeb;line-height:1;font-weight:700}.h2whoaHybrid .spectacle-content h2{margin:.125em auto;font-weight:100}.h2whoaHybrid .spectacle-content h2,.h2whoaHybrid .spectacle-content h3{color:#fff;font-size:2em;font-family:BrandonTextWeb;line-height:1;letter-spacing:-.5px}.h2whoaHybrid .spectacle-content h3{margin:0 auto .125em;font-weight:700}.h2whoaHybrid .spectacle-content h4{font-size:1.6em;letter-spacing:0}.h2whoaHybrid .spectacle-content h4,.h2whoaHybrid .spectacle-content h6{margin:.5em auto;color:#fff;font-family:BrandonTextWeb;line-height:1;font-weight:400;text-transform:none}.h2whoaHybrid .spectacle-content h6{font-size:3.5em;letter-spacing:-.033em;text-align:center}.h2whoaHybrid .spectacle-content blockquote{text-align:left;position:relative;display:inline-block}.h2whoaHybrid .spectacle-content quote{border-left:1px solid #37bad5;padding-left:40;display:block;color:#37bad5;font-size:49px;line-height:1;font-weight:700}.h2whoaHybrid .spectacle-content cite{color:#fff;display:block;clear:left;font-size:20px;margin-top:1em}.h2whoaHybrid .spectacle-content content{margin:0 auto;text-align:center}.h2whoaHybrid .spectacle-content .ui-slide{background-color:#000;background-position:50%;background-image:linear-gradient(rgba(12,44,60,.5) 1px,transparent 0),linear-gradient(#0c2c3c 1px,transparent 0),linear-gradient(90deg,rgba(12,44,60,.5) 1px,transparent 0),linear-gradient(90deg,rgba(12,44,60,.7) 1px,transparent 0),linear-gradient(transparent 3px,#000 0,#000 73px,transparent 0),linear-gradient(90deg,rgba(12,44,60,.7) 3px,transparent 0,transparent 73px,rgba(12,44,60,.7) 0);background-size:5px 5px,75px 75px,5px 5px,75px 75px,75px 75px,75px 75px;-ms-flex:1;flex:1;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-pack:center;justify-content:center;padding:12.5%;font-family:Orbitron;color:#37bad5}.h2whoaHybrid .spectacle-content .ui-slide h1,.h2whoaHybrid .spectacle-content .ui-slide h2,.h2whoaHybrid .spectacle-content .ui-slide h3,.h2whoaHybrid .spectacle-content .ui-slide h4,.h2whoaHybrid .spectacle-content .ui-slide h5,.h2whoaHybrid .spectacle-content .ui-slide h6{color:#37bad5;font-family:Orbitron}.h2whoaHybrid .spectacle-content .ui-slide h1{margin:.25em 0 .75em;font-size:32px;font-size:3.6vw;text-align:center;text-shadow:0 0 5px #37bad5}@media (max-width:767px){.h2whoaHybrid .spectacle-content .ui-slide h1{font-size:18px;font-size:6vw}}.h2whoaHybrid .spectacle-content .ui-slide h2{color:#11abcd;font-size:1.8em;font-weight:700}.h2whoaHybrid .spectacle-content .ui-slide h3{color:#37bad5;text-shadow:0 0 5px #37bad5;font-size:1.6em;font-weight:400}.h2whoaHybrid .spectacle-content .ui-slide .flex-image+h3{margin-top:.5em;color:#b4e166;animation:glowing;text-align:center}.h2whoaHybrid .spectacle-content .ui-slide [class*=\" ppa-icon-\"]:before,.h2whoaHybrid .spectacle-content .ui-slide [class^=ppa-icon-]:before{margin:0}.h2whoaHybrid .spectacle-content .ui-slide .level-header{display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;-ms-flex-align:center;align-items:center;padding-bottom:2vw;min-height:8vw;min-height:8vmax}.h2whoaHybrid .spectacle-content .ui-slide .level-header .level-header-thumb{position:relative;display:block;margin:0 30px;height:6.5vw;width:6.5vw;border-radius:10px}.h2whoaHybrid .spectacle-content .ui-slide .level-header .level-header-thumb img{width:auto;height:7vw;margin:-.25vw}.h2whoaHybrid .spectacle-content .ui-slide .level-header .level-header-thumb:after,.h2whoaHybrid .spectacle-content .ui-slide .level-header .level-header-thumb:before{content:\"\";display:block;border:3px solid #11abcd;width:10px;position:absolute;top:0;bottom:0}.h2whoaHybrid .spectacle-content .ui-slide .level-header .level-header-thumb:before{border-top-left-radius:10px;border-bottom-left-radius:10px;left:-20px;border-right:none}.h2whoaHybrid .spectacle-content .ui-slide .level-header .level-header-thumb:after{border-top-right-radius:10px;border-bottom-right-radius:10px;right:-20px;border-left:none}.h2whoaHybrid .spectacle-content .ui-slide .level-header .level-header-thumb+h2{margin-left:.5vw}.h2whoaHybrid .spectacle-content .ui-slide .level-header h2{-ms-flex:1;flex:1}.h2whoaHybrid .spectacle-content .ui-slide.mission-report-level-1 .level-header-thumb{background-color:#26a7df;box-shadow:0 0 15px #26a7df}.h2whoaHybrid .spectacle-content .ui-slide.mission-report-level-2 .level-header-thumb{background-color:#0daf4c;box-shadow:0 0 15px #0daf4c}.h2whoaHybrid .spectacle-content .ui-slide .mission-report{border-top:2px solid #11abcd;border-bottom:2px solid #11abcd;padding:2.5vw 3vw;max-height:60vh;overflow-y:hidden;counter-reset:missioncounter}.h2whoaHybrid .spectacle-content .ui-slide .mission-report .form-fields{padding:0;width:100%}.h2whoaHybrid .spectacle-content .ui-slide .mission-report .form-horizontal{display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row}.h2whoaHybrid .spectacle-content .ui-slide .mission-report .form-horizontal .question-group-wrapper{margin:0 0 .5em}.h2whoaHybrid .spectacle-content .ui-slide .mission-report .form-horizontal .question-group-error{color:red;font-size:.8em;line-height:.8em}.h2whoaHybrid .spectacle-content .ui-slide .mission-report .form-horizontal .question-group{margin:0;display:-ms-flexbox;display:flex;-ms-flex-flow:wrap;flex-flow:wrap;-ms-flex-direction:row;flex-direction:row;-ms-flex-align:center;align-items:center}.h2whoaHybrid .spectacle-content .ui-slide .mission-report .form-horizontal .question-group:before{content:counter(missioncounter) \".\";counter-increment:missioncounter 1;display:block;width:1.5em;font-size:1.2em;line-height:1.2em;text-align:left;font-weight:700}.h2whoaHybrid .spectacle-content .ui-slide .mission-report .form-horizontal .button-group{margin-left:2.5vw;-ms-flex-preferred-size:240px;flex-basis:240px;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center}.h2whoaHybrid .spectacle-content .ui-slide .mission-report .form-horizontal input[type=number]::-webkit-inner-spin-button,.h2whoaHybrid .spectacle-content .ui-slide .mission-report .form-horizontal input[type=number]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}.h2whoaHybrid .spectacle-content .ui-slide .mission-report .form-horizontal input[type=number]{-moz-appearance:textfield}.h2whoaHybrid .spectacle-content .ui-slide .mission-report .form-horizontal .control-label{text-align:left}.h2whoaHybrid .spectacle-content .ui-slide .mission-report label{-ms-flex:2;flex:2;margin-top:0;padding-top:0;padding-right:.5em;font-size:1em;line-height:1em;display:table-cell;vertical-align:middle;font-weight:400;font-family:BrandonTextWeb;color:#11abcd}.h2whoaHybrid .spectacle-content .ui-slide .mission-report .form-control,.h2whoaHybrid .spectacle-content .ui-slide .mission-report input{border:.125em solid #11abcd;background:#000;width:3em;height:1.4em;padding:.25em .25em .1em;margin:0 0 1% 2%;border-radius:.25em;font-size:1.1em;text-align:right;line-height:.7em;font-family:Orbitron;color:#37bad5}.h2whoaHybrid .spectacle-content .ui-slide .mission-report .btn-fake{background-color:#000;box-sizing:border-box;width:150px;height:150px;padding:25px;border-radius:50%;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;border:4px solid #61d9f2;font-size:15px;text-transform:uppercase;box-shadow:inset 0 0 0 5px #000,inset 0 0 5px 15px #e0f000,0 0 0 0 #61d9f2;text-shadow:0 0 0 #fff;transition:all .5s ease-in-out;-webkit-tap-highlight-color:black;outline:none}.h2whoaHybrid .spectacle-content .ui-slide .mission-report .btn-fake:active{box-shadow:inset 0 0 0 3px #000,inset 0 0 15px 18px #f4ff58,0 0 10px 5px #61d9f2;text-shadow:0 0 15px #fff;transform:rotate(2turn)}.h2whoaHybrid .spectacle-content .team-names .form-group{margin:0 0 .5em;display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;-ms-flex-align:center;align-items:center}.h2whoaHybrid .spectacle-content .team-names label{-ms-flex-preferred-size:10em;flex-basis:10em;margin-top:0;padding-top:0;font-size:2em;line-height:1em;font-weight:400;font-family:Orbitron,sans-serif;text-transform:uppercase;text-align:right;color:#11abcd}.h2whoaHybrid .spectacle-content .team-names label i{margin:0 .125em 0 .25em;font-size:1.25em}.h2whoaHybrid .spectacle-content .team-names .team-1 label{color:#3cca3f}.h2whoaHybrid .spectacle-content .team-names .team-2 label{color:#c57b39}.h2whoaHybrid .spectacle-content .team-names .team-3 label{color:#187bc5}.h2whoaHybrid .spectacle-content .team-names .team-4 label{color:#f8f8f8}.h2whoaHybrid .spectacle-content .team-names .form-control{border-radius:.25em;height:2em;padding:.5em;margin-bottom:1%;font-size:1.2em}.h2whoaHybrid .spectacle-content .text-balloon{width:75vw;padding:5%;margin:15vh auto 0;border-radius:7.5vh;background-color:rgba(0,0,0,.3);-ms-flex-align:start;align-items:flex-start;text-align:left;color:#fff;font-size:1.2em}.h2whoaHybrid .spectacle-content .text-balloon:after{bottom:-30px;border-width:15px 30px;left:auto}.h2whoaHybrid .spectacle-content .text-balloon.left:after{border-color:rgba(0,0,0,.3) transparent transparent rgba(0,0,0,.3);left:35%;transform:skewX(-40deg)}.h2whoaHybrid .spectacle-content .text-balloon.right:after{border-color:rgba(0,0,0,.3) rgba(0,0,0,.3) transparent transparent;right:35%;transform:skewX(40deg)}.h2whoaHybrid .spectacle-content .text-balloon h2,.h2whoaHybrid .spectacle-content .text-balloon h3{margin-left:0;margin-right:0}.h2whoaHybrid .text-balloon-character{margin:-60px 15% 0;position:relative;text-align:center}.h2whoaHybrid .text-balloon-character.right{text-align:right}.h2whoaHybrid .text-balloon-character.left{text-align:left}.h2whoaHybrid .text-balloon-character img{height:30vh;width:auto}.h2whoaHybrid .text-heading{text-align:center}.h2whoaHybrid .text-formatted,.h2whoaHybrid .text-heading{width:66.7%;font-size:1.6em;line-height:1.25em;margin:0 auto}.h2whoaHybrid .text-formatted{text-align:left}.h2whoaHybrid .text-formatted ul{margin-top:.5em;padding-left:2em}.h2whoaHybrid .text-formatted li{margin-bottom:.5em}.h2whoaHybrid .text-formatted h2,.h2whoaHybrid .text-formatted h3{margin-left:0;margin-right:0}.h2whoaHybrid .text-balloon-body{width:auto;margin:0}.h2whoaHybrid .youtube-button .btn-lg{font-size:48px;line-height:40px;padding:8px 5px 8px 11px;height:100px;min-height:100px;width:100px;border-radius:50%;z-index:100}.h2whoaHybrid .level-complete{-ms-flex-direction:column;flex-direction:column;-ms-flex:1;flex:1}.h2whoaHybrid .level-complete,.h2whoaHybrid .spectacle-content .level-complete-content{display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center}.h2whoaHybrid .spectacle-content .level-complete-content{width:40vw;height:40vw;-ms-flex-direction:column;flex-direction:column}.h2whoaHybrid .spectacle-content .level-complete-content .level-complete-graphic{position:absolute;top:50%;left:50%;margin-left:-20vw;margin-top:-20vw;z-index:1}.h2whoaHybrid .spectacle-content .level-complete-content .level-complete-graphic img{width:40vw;height:40vw}.h2whoaHybrid .spectacle-content .level-complete-content h3{font-size:7em;line-height:.5em;font-weight:700;text-align:center}.h2whoaHybrid .spectacle-content .level-complete-content h2{text-align:center;font-weight:700}.h2whoaHybrid .spectacle-content .level-complete-content .btn{background:none;border-color:#fff;position:relative;z-index:2;height:2.5em;min-height:2.5em;padding:0 1.25em;border-radius:1.25em;font-family:BrandonTextWeb;font-size:1em;color:#fff;text-shadow:none}.h2whoaHybrid .hacked{background-color:#000;background-size:cover;animation:glitcher 2s;display:-ms-flexbox;display:flex;position:absolute;top:0;bottom:0;left:0;right:0;-ms-flex-align:end;align-items:flex-end}.h2whoaHybrid .hacked-form{width:40%;margin-left:50%;margin-bottom:6em}.h2whoaHybrid.deck-level-1 .spectacle-content .text-balloon.balloon-regular{background-color:rgba(150,50,0,.3)}.h2whoaHybrid.deck-level-1 .spectacle-content .text-balloon.balloon-regular.left:after{border-color:rgba(150,50,0,.3) transparent transparent rgba(150,50,0,.3)}.h2whoaHybrid.deck-level-1 .spectacle-content .text-balloon.balloon-regular.right:after{border-color:rgba(150,50,0,.3) rgba(150,50,0,.3) transparent transparent}.h2whoaHybrid.deck-level-5 .spectacle-content .text-balloon.balloon-regular{background-color:rgba(125,75,0,.3)}.h2whoaHybrid.deck-level-5 .spectacle-content .text-balloon.balloon-regular.left:after{border-color:rgba(125,75,0,.3) transparent transparent rgba(125,75,0,.3)}.h2whoaHybrid.deck-level-5 .spectacle-content .text-balloon.balloon-regular.right:after{border-color:rgba(125,75,0,.3) rgba(125,75,0,.3) transparent transparent}", ""]);
	
	// exports


/***/ }),
/* 1285 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(12)();
	// imports
	
	
	// module
	exports.push([module.id, ".keepCool .heading-image{width:80%;height:80%;object-fit:contain;display:block;margin:0 auto}.keepCool .heading-image-before{width:75%;height:auto;object-fit:inherit}.keepCool .flex-image{width:45%;display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;-ms-flex-item-align:center;align-self:center}.keepCool .spectacle-content .ui-slide .title-image h1{background-color:#000;width:80%;padding:1% 3% 1.5%;margin:0 auto;position:relative;z-index:1;font-family:BrandonTextWeb,Helvetica,Arial,sans-serif;font-size:1.1em;text-shadow:none;font-weight:400}.keepCool .spectacle-content .ui-slide .title-image h2{background-color:#b4e166;width:80%;padding:3%;margin:0 auto;position:relative;font-family:BrandonTextWeb,Helvetica,Arial,sans-serif;font-size:2.4em;text-shadow:0 0 20px rgba(0,0,0,.3);font-weight:800;color:#000;text-align:center}.keepCool .spectacle-content .ui-slide .title-image h2:after,.keepCool .spectacle-content .ui-slide .title-image h2:before{content:\"\";position:absolute;display:block;bottom:-.5em;border:.75em solid #9fd93b;z-index:-1}.keepCool .spectacle-content .ui-slide .title-image h2:before{left:-1em;border-right-width:.75em;border-left-color:transparent}.keepCool .spectacle-content .ui-slide .title-image h2:after{right:-1em;border-left-width:.75em;border-right-color:transparent}.keepCool .spectacle-content .ui-slide .title-image h2 strong:after,.keepCool .spectacle-content .ui-slide .title-image h2 strong:before{content:\"\";position:absolute;display:block;border-style:solid;border-color:#85bc25 transparent transparent;bottom:-.5em}.keepCool .spectacle-content .ui-slide .title-image h2 strong:before{left:0;border-width:.5em 0 0 .5em}.keepCool .spectacle-content .ui-slide .title-image h2 strong:after{right:0;border-width:.5em .5em 0 0}.keepCool .title-image{width:22em;height:25em;position:relative;margin:0 auto;z-index:1}.keepCool .title-image:after{display:block;content:\"\";position:absolute;top:7%;right:10%;bottom:7em;left:10%;border-top-left-radius:5%;border-top-right-radius:5%}.keepCool .title-image img{position:relative;z-index:2;height:18em;width:auto}.keepCool .spectacle-deck:before{content:\"\";display:block;position:absolute;top:0;right:0;bottom:0;left:0}.keepCool.deck-level-prep{background-color:#000;background-position:50%;background-image:linear-gradient(rgba(12,44,60,.5) 1px,transparent 0),linear-gradient(#0c2c3c 1px,transparent 0),linear-gradient(90deg,rgba(12,44,60,.5) 1px,transparent 0),linear-gradient(90deg,rgba(12,44,60,.7) 1px,transparent 0),linear-gradient(transparent 3px,#000 0,#000 73px,transparent 0),linear-gradient(90deg,rgba(12,44,60,.7) 3px,transparent 0,transparent 73px,rgba(12,44,60,.7) 0);background-size:5px 5px,75px 75px,5px 5px,75px 75px,75px 75px,75px 75px}.keepCool.deck-level-prep .spectacle-content h3{margin-bottom:0;color:#37bad5}.keepCool.deck-level-prep .text-formatted{font-size:1.4em}.keepCool.deck-level-1 .deck-slide-transition-group,.keepCool.deck-level-1 .title-image:after{background-color:#2ba7df}.keepCool.deck-level-1 .level-1 .overview-level-image,.keepCool.deck-level-1 .spectacle-content .ui-slide .title-image h1{color:#2ba7df}.keepCool.deck-level-2 .deck-slide-transition-group,.keepCool.deck-level-2 .title-image:after{background-color:#4450a2}.keepCool.deck-level-2 .level-2 .overview-level-image,.keepCool.deck-level-2 .spectacle-content .ui-slide .title-image h1{color:#4450a2}.keepCool.deck-level-3 .deck-slide-transition-group,.keepCool.deck-level-3 .title-image:after{background-color:#8f288c}.keepCool.deck-level-3 .level-3 .overview-level-image,.keepCool.deck-level-3 .spectacle-content .ui-slide .title-image h1{color:#8f288c}.keepCool.deck-level-4 .deck-slide-transition-group,.keepCool.deck-level-4 .title-image:after{background-color:#ffbc00}.keepCool.deck-level-4 .level-4 .overview-level-image,.keepCool.deck-level-4 .spectacle-content .ui-slide .title-image h1{color:#ffbc00}.keepCool.deck-level-5 .deck-slide-transition-group,.keepCool.deck-level-5 .title-image:after{background-color:#37b34a}.keepCool.deck-level-5 .level-5 .overview-level-image,.keepCool.deck-level-5 .spectacle-content .ui-slide .title-image h1{color:#37b34a}.keepCool.deck-level-6 .deck-slide-transition-group,.keepCool.deck-level-6 .title-image:after{background-color:#e80a89}.keepCool.deck-level-6 .level-6 .overview-level-image,.keepCool.deck-level-6 .spectacle-content .ui-slide .title-image h1{color:#e80a89}.keepCool .level-1 .overview-level-image{background-color:#2ba7df}.keepCool .level-2 .overview-level-image{background-color:#4450a2}.keepCool .level-3 .overview-level-image{background-color:#8f288c}.keepCool .level-4 .overview-level-image{background-color:#ffbc00}.keepCool .level-5 .overview-level-image{background-color:#37b34a}.keepCool .level-6 .overview-level-image{background-color:#e80a89}.keepCool .slide-content{-ms-flex:1 1 0%;flex:1 1 0%;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-pack:center;justify-content:center;height:100%}.keepCool .spectacle-content h1{margin:.25em auto;color:#fff;font-size:2.5em;font-family:BrandonTextWeb;line-height:1;font-weight:700}.keepCool .spectacle-content h2{margin:.125em auto;font-weight:100}.keepCool .spectacle-content h2,.keepCool .spectacle-content h3{color:#fff;font-size:2em;font-family:BrandonTextWeb;line-height:1;letter-spacing:-.5px}.keepCool .spectacle-content h3{margin:0 auto .125em;font-weight:700}.keepCool .spectacle-content h4{font-size:1.6em;letter-spacing:0}.keepCool .spectacle-content h4,.keepCool .spectacle-content h6{margin:.5em auto;color:#fff;font-family:BrandonTextWeb;line-height:1;font-weight:400;text-transform:none}.keepCool .spectacle-content h6{font-size:3.5em;letter-spacing:-.033em;text-align:center}.keepCool .spectacle-content blockquote{text-align:left;position:relative;display:inline-block}.keepCool .spectacle-content quote{border-left:1px solid #37bad5;padding-left:40;display:block;color:#37bad5;font-size:49px;line-height:1;font-weight:700}.keepCool .spectacle-content cite{color:#fff;display:block;clear:left;font-size:20px;margin-top:1em}.keepCool .spectacle-content content{margin:0 auto;text-align:center}.keepCool .spectacle-content .ui-slide{background-color:#000;background-position:50%;background-image:linear-gradient(rgba(12,44,60,.5) 1px,transparent 0),linear-gradient(#0c2c3c 1px,transparent 0),linear-gradient(90deg,rgba(12,44,60,.5) 1px,transparent 0),linear-gradient(90deg,rgba(12,44,60,.7) 1px,transparent 0),linear-gradient(transparent 3px,#000 0,#000 73px,transparent 0),linear-gradient(90deg,rgba(12,44,60,.7) 3px,transparent 0,transparent 73px,rgba(12,44,60,.7) 0);background-size:5px 5px,75px 75px,5px 5px,75px 75px,75px 75px,75px 75px;-ms-flex:1;flex:1;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-pack:center;justify-content:center;padding:12.5%;font-family:Orbitron;color:#37bad5}.keepCool .spectacle-content .ui-slide h1,.keepCool .spectacle-content .ui-slide h2,.keepCool .spectacle-content .ui-slide h3,.keepCool .spectacle-content .ui-slide h4,.keepCool .spectacle-content .ui-slide h5,.keepCool .spectacle-content .ui-slide h6{color:#37bad5;font-family:Orbitron}.keepCool .spectacle-content .ui-slide h1{margin:.25em 0 .75em;font-size:32px;font-size:3.6vw;text-align:center;text-shadow:0 0 5px #37bad5}@media (max-width:767px){.keepCool .spectacle-content .ui-slide h1{font-size:18px;font-size:6vw}}.keepCool .spectacle-content .ui-slide h2{color:#11abcd;font-size:1.8em;font-weight:700}.keepCool .spectacle-content .ui-slide h3{color:#37bad5;text-shadow:0 0 5px #37bad5;font-size:1.6em;font-weight:400}.keepCool .spectacle-content .ui-slide .flex-image+h3{margin-top:.5em;color:#b4e166;animation:glowing;text-align:center}.keepCool .spectacle-content .ui-slide [class*=\" ppa-icon-\"]:before,.keepCool .spectacle-content .ui-slide [class^=ppa-icon-]:before{margin:0}.keepCool .spectacle-content .ui-slide .level-header{display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;-ms-flex-align:center;align-items:center;padding-bottom:2vw;min-height:8vw;min-height:8vmax}.keepCool .spectacle-content .ui-slide .level-header .level-header-thumb{position:relative;display:block;margin:0 30px;height:6.5vw;width:6.5vw;border-radius:10px}.keepCool .spectacle-content .ui-slide .level-header .level-header-thumb img{width:auto;height:7vw;margin:-.25vw}.keepCool .spectacle-content .ui-slide .level-header .level-header-thumb:after,.keepCool .spectacle-content .ui-slide .level-header .level-header-thumb:before{content:\"\";display:block;border:3px solid #11abcd;width:10px;position:absolute;top:0;bottom:0}.keepCool .spectacle-content .ui-slide .level-header .level-header-thumb:before{border-top-left-radius:10px;border-bottom-left-radius:10px;left:-20px;border-right:none}.keepCool .spectacle-content .ui-slide .level-header .level-header-thumb:after{border-top-right-radius:10px;border-bottom-right-radius:10px;right:-20px;border-left:none}.keepCool .spectacle-content .ui-slide .level-header .level-header-thumb+h2{margin-left:.5vw}.keepCool .spectacle-content .ui-slide .level-header h2{-ms-flex:1;flex:1}.keepCool .spectacle-content .ui-slide.mission-report-level-1 .level-header-thumb{background-color:#2ba7df;box-shadow:0 0 15px #2ba7df}.keepCool .spectacle-content .ui-slide.mission-report-level-2 .level-header-thumb{background-color:#4450a2;box-shadow:0 0 15px #4450a2}.keepCool .spectacle-content .ui-slide.mission-report-level-3 .level-header-thumb{background-color:#8f288c;box-shadow:0 0 15px #8f288c}.keepCool .spectacle-content .ui-slide.mission-report-level-4 .level-header-thumb{background-color:#ffbc00;box-shadow:0 0 15px #ffbc00}.keepCool .spectacle-content .ui-slide.mission-report-level-5 .level-header-thumb{background-color:#37b34a;box-shadow:0 0 15px #37b34a}.keepCool .spectacle-content .ui-slide .mission-report{border-top:2px solid #11abcd;border-bottom:2px solid #11abcd;padding:2.5vw 3vw;max-height:60vh;overflow-y:hidden;counter-reset:missioncounter}.keepCool .spectacle-content .ui-slide .mission-report .form-fields{padding:0;width:100%}.keepCool .spectacle-content .ui-slide .mission-report .form-horizontal{display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row}.keepCool .spectacle-content .ui-slide .mission-report .form-horizontal .question-group-wrapper{margin:0 0 .5em}.keepCool .spectacle-content .ui-slide .mission-report .form-horizontal .question-group-error{color:red;font-size:.8em;line-height:.8em}.keepCool .spectacle-content .ui-slide .mission-report .form-horizontal .question-group{margin:0;display:-ms-flexbox;display:flex;-ms-flex-flow:wrap;flex-flow:wrap;-ms-flex-direction:row;flex-direction:row;-ms-flex-align:center;align-items:center}.keepCool .spectacle-content .ui-slide .mission-report .form-horizontal .question-group:before{content:counter(missioncounter) \".\";counter-increment:missioncounter 1;display:block;width:1.5em;font-size:1.2em;line-height:1.2em;text-align:left;font-weight:700}.keepCool .spectacle-content .ui-slide .mission-report .form-horizontal .button-group{margin-left:2.5vw;-ms-flex-preferred-size:240px;flex-basis:240px;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center}.keepCool .spectacle-content .ui-slide .mission-report .form-horizontal input[type=number]::-webkit-inner-spin-button,.keepCool .spectacle-content .ui-slide .mission-report .form-horizontal input[type=number]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}.keepCool .spectacle-content .ui-slide .mission-report .form-horizontal input[type=number]{-moz-appearance:textfield}.keepCool .spectacle-content .ui-slide .mission-report .form-horizontal .control-label{text-align:left}.keepCool .spectacle-content .ui-slide .mission-report label{-ms-flex:2;flex:2;margin-top:0;padding-top:0;padding-right:.5em;font-size:1em;line-height:1em;display:table-cell;vertical-align:middle;font-weight:400;font-family:BrandonTextWeb;color:#11abcd}.keepCool .spectacle-content .ui-slide .mission-report .form-control,.keepCool .spectacle-content .ui-slide .mission-report input{border:.125em solid #11abcd;background:#000;width:3em;height:1.4em;padding:.25em .25em .1em;margin:0 0 1% 2%;border-radius:.25em;font-size:1.1em;text-align:right;line-height:.7em;font-family:Orbitron;color:#37bad5}.keepCool .spectacle-content .ui-slide .mission-report .btn-fake{background-color:#000;box-sizing:border-box;width:150px;height:150px;padding:25px;border-radius:50%;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;border:4px solid #61d9f2;font-size:15px;text-transform:uppercase;box-shadow:inset 0 0 0 5px #000,inset 0 0 5px 15px #e0f000,0 0 0 0 #61d9f2;text-shadow:0 0 0 #fff;transition:all .5s ease-in-out;-webkit-tap-highlight-color:black;outline:none}.keepCool .spectacle-content .ui-slide .mission-report .btn-fake:active{box-shadow:inset 0 0 0 3px #000,inset 0 0 15px 18px #f4ff58,0 0 10px 5px #61d9f2;text-shadow:0 0 15px #fff;transform:rotate(2turn)}.keepCool .spectacle-content .team-names .form-group{margin:0 0 .5em;display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;-ms-flex-align:center;align-items:center}.keepCool .spectacle-content .team-names label{-ms-flex-preferred-size:10em;flex-basis:10em;margin-top:0;padding-top:0;font-size:2em;line-height:1em;font-weight:400;font-family:Orbitron,sans-serif;text-transform:uppercase;text-align:right;color:#11abcd}.keepCool .spectacle-content .team-names label i{margin:0 .125em 0 .25em;font-size:1.25em}.keepCool .spectacle-content .team-names .team-1 label{color:#3cca3f}.keepCool .spectacle-content .team-names .team-2 label{color:#c57b39}.keepCool .spectacle-content .team-names .team-3 label{color:#187bc5}.keepCool .spectacle-content .team-names .team-4 label{color:#f8f8f8}.keepCool .spectacle-content .team-names .form-control{border-radius:.25em;height:2em;padding:.5em;margin-bottom:1%;font-size:1.2em}.keepCool .spectacle-content .text-balloon{width:75vw;padding:5%;margin:15vh auto 0;border-radius:7.5vh;background-color:rgba(0,0,0,.3);-ms-flex-align:start;align-items:flex-start;text-align:left;color:#fff;font-size:1.2em}.keepCool .spectacle-content .text-balloon:after{bottom:-30px;border-width:15px 30px;left:auto}.keepCool .spectacle-content .text-balloon.left:after{border-color:rgba(0,0,0,.3) transparent transparent rgba(0,0,0,.3);left:35%;transform:skewX(-40deg)}.keepCool .spectacle-content .text-balloon.right:after{border-color:rgba(0,0,0,.3) rgba(0,0,0,.3) transparent transparent;right:35%;transform:skewX(40deg)}.keepCool .spectacle-content .text-balloon h2,.keepCool .spectacle-content .text-balloon h3{margin-left:0;margin-right:0}.keepCool .text-balloon-character{margin:-60px 15% 0;position:relative;text-align:center}.keepCool .text-balloon-character.right{text-align:right}.keepCool .text-balloon-character.left{text-align:left}.keepCool .text-balloon-character img{height:30vh;width:auto}.keepCool .text-heading{text-align:center}.keepCool .text-formatted,.keepCool .text-heading{width:66.7%;font-size:1.6em;line-height:1.25em;margin:0 auto}.keepCool .text-formatted{text-align:left}.keepCool .text-formatted ul{margin-top:.5em;padding-left:2em}.keepCool .text-formatted li{margin-bottom:.5em}.keepCool .text-formatted h2,.keepCool .text-formatted h3{margin-left:0;margin-right:0}.keepCool .text-balloon-body{width:auto;margin:0}.keepCool .youtube-button .btn-lg{font-size:48px;line-height:40px;padding:8px 5px 8px 11px;height:100px;min-height:100px;width:100px;border-radius:50%;z-index:100}.keepCool .level-complete{-ms-flex-direction:column;flex-direction:column;-ms-flex:1;flex:1}.keepCool .level-complete,.keepCool .spectacle-content .level-complete-content{display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center}.keepCool .spectacle-content .level-complete-content{width:40vw;height:40vw;-ms-flex-direction:column;flex-direction:column}.keepCool .spectacle-content .level-complete-content .level-complete-graphic{position:absolute;top:50%;left:50%;margin-left:-20vw;margin-top:-20vw;z-index:1}.keepCool .spectacle-content .level-complete-content .level-complete-graphic img{width:40vw;height:40vw}.keepCool .spectacle-content .level-complete-content h3{font-size:7em;line-height:.5em;font-weight:700;text-align:center}.keepCool .spectacle-content .level-complete-content h2{text-align:center;font-weight:700}.keepCool .spectacle-content .level-complete-content .btn{background:none;border-color:#fff;position:relative;z-index:2;height:2.5em;min-height:2.5em;padding:0 1.25em;border-radius:1.25em;font-family:BrandonTextWeb;font-size:1em;color:#fff;text-shadow:none}.keepCool .hacked{background-color:#000;background-size:cover;animation:glitcher 2s;display:-ms-flexbox;display:flex;position:absolute;top:0;bottom:0;left:0;right:0;-ms-flex-align:end;align-items:flex-end}.keepCool .hacked-form{width:40%;margin-left:50%;margin-bottom:6em}.keepCool.deck-level-1 .spectacle-content .text-balloon.balloon-regular{background-color:rgba(150,50,0,.3)}.keepCool.deck-level-1 .spectacle-content .text-balloon.balloon-regular.left:after{border-color:rgba(150,50,0,.3) transparent transparent rgba(150,50,0,.3)}.keepCool.deck-level-1 .spectacle-content .text-balloon.balloon-regular.right:after{border-color:rgba(150,50,0,.3) rgba(150,50,0,.3) transparent transparent}.keepCool.deck-level-5 .spectacle-content .text-balloon.balloon-regular{background-color:rgba(125,75,0,.3)}.keepCool.deck-level-5 .spectacle-content .text-balloon.balloon-regular.left:after{border-color:rgba(125,75,0,.3) transparent transparent rgba(125,75,0,.3)}.keepCool.deck-level-5 .spectacle-content .text-balloon.balloon-regular.right:after{border-color:rgba(125,75,0,.3) rgba(125,75,0,.3) transparent transparent}", ""]);
	
	// exports


/***/ }),
/* 1286 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(12)();
	// imports
	
	
	// module
	exports.push([module.id, ".zeroHeroes .heading-image{width:80%;height:80%;object-fit:contain;display:block;margin:0 auto}.zeroHeroes .heading-image-before{width:75%;height:auto;object-fit:inherit}.zeroHeroes .flex-image{width:45%;display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;-ms-flex-item-align:center;align-self:center}.zeroHeroes .spectacle-content .ui-slide .title-image h1{background-color:#000;width:80%;padding:1% 3% 1.5%;margin:0 auto;position:relative;z-index:1;font-family:BrandonTextWeb,Helvetica,Arial,sans-serif;font-size:1.1em;text-shadow:none;font-weight:400}.zeroHeroes .spectacle-content .ui-slide .title-image h2{background-color:#b4e166;width:80%;padding:3%;margin:0 auto;position:relative;font-family:BrandonTextWeb,Helvetica,Arial,sans-serif;font-size:2.4em;text-shadow:0 0 20px rgba(0,0,0,.3);font-weight:800;color:#000;text-align:center}.zeroHeroes .spectacle-content .ui-slide .title-image h2:after,.zeroHeroes .spectacle-content .ui-slide .title-image h2:before{content:\"\";position:absolute;display:block;bottom:-.5em;border:.75em solid #9fd93b;z-index:-1}.zeroHeroes .spectacle-content .ui-slide .title-image h2:before{left:-1em;border-right-width:.75em;border-left-color:transparent}.zeroHeroes .spectacle-content .ui-slide .title-image h2:after{right:-1em;border-left-width:.75em;border-right-color:transparent}.zeroHeroes .spectacle-content .ui-slide .title-image h2 strong:after,.zeroHeroes .spectacle-content .ui-slide .title-image h2 strong:before{content:\"\";position:absolute;display:block;border-style:solid;border-color:#85bc25 transparent transparent;bottom:-.5em}.zeroHeroes .spectacle-content .ui-slide .title-image h2 strong:before{left:0;border-width:.5em 0 0 .5em}.zeroHeroes .spectacle-content .ui-slide .title-image h2 strong:after{right:0;border-width:.5em .5em 0 0}.zeroHeroes .title-image{width:22em;height:25em;position:relative;margin:0 auto;z-index:1}.zeroHeroes .title-image:after{display:block;content:\"\";position:absolute;top:7%;right:10%;bottom:7em;left:10%;border-top-left-radius:5%;border-top-right-radius:5%}.zeroHeroes .title-image img{position:relative;z-index:2;height:18em;width:auto}.zeroHeroes .spectacle-deck:before{content:\"\";display:block;position:absolute;top:0;right:0;bottom:0;left:0}.zeroHeroes.deck-level-prep{background-color:#000;background-position:50%;background-image:linear-gradient(rgba(12,44,60,.5) 1px,transparent 0),linear-gradient(#0c2c3c 1px,transparent 0),linear-gradient(90deg,rgba(12,44,60,.5) 1px,transparent 0),linear-gradient(90deg,rgba(12,44,60,.7) 1px,transparent 0),linear-gradient(transparent 3px,#000 0,#000 73px,transparent 0),linear-gradient(90deg,rgba(12,44,60,.7) 3px,transparent 0,transparent 73px,rgba(12,44,60,.7) 0);background-size:5px 5px,75px 75px,5px 5px,75px 75px,75px 75px,75px 75px}.zeroHeroes.deck-level-prep .spectacle-content h3{margin-bottom:0;color:#37bad5}.zeroHeroes.deck-level-prep .text-formatted{font-size:1.4em}.zeroHeroes.deck-level-1 .deck-slide-transition-group,.zeroHeroes.deck-level-1 .title-image:after{background-color:#ffbc00}.zeroHeroes.deck-level-1 .level-1 .overview-level-image,.zeroHeroes.deck-level-1 .spectacle-content .ui-slide .title-image h1{color:#ffbc00}.zeroHeroes.deck-level-2 .deck-slide-transition-group,.zeroHeroes.deck-level-2 .title-image:after{background-color:#8f288c}.zeroHeroes.deck-level-2 .level-2 .overview-level-image,.zeroHeroes.deck-level-2 .spectacle-content .ui-slide .title-image h1{color:#8f288c}.zeroHeroes.deck-level-3 .deck-slide-transition-group,.zeroHeroes.deck-level-3 .title-image:after{background-color:#26a7df}.zeroHeroes.deck-level-3 .level-3 .overview-level-image,.zeroHeroes.deck-level-3 .spectacle-content .ui-slide .title-image h1{color:#26a7df}.zeroHeroes.deck-level-4 .deck-slide-transition-group,.zeroHeroes.deck-level-4 .title-image:after{background-color:#e80a89}.zeroHeroes.deck-level-4 .level-4 .overview-level-image,.zeroHeroes.deck-level-4 .spectacle-content .ui-slide .title-image h1{color:#e80a89}.zeroHeroes.deck-level-5 .deck-slide-transition-group,.zeroHeroes.deck-level-5 .title-image:after{background-color:#f59122}.zeroHeroes.deck-level-5 .level-5 .overview-level-image,.zeroHeroes.deck-level-5 .spectacle-content .ui-slide .title-image h1{color:#f59122}.zeroHeroes.deck-level-6 .deck-slide-transition-group,.zeroHeroes.deck-level-6 .title-image:after{background-color:#37b34a}.zeroHeroes.deck-level-6 .level-6 .overview-level-image,.zeroHeroes.deck-level-6 .spectacle-content .ui-slide .title-image h1{color:#37b34a}.zeroHeroes .level-1 .overview-level-image{background-color:#ffbc00}.zeroHeroes .level-2 .overview-level-image{background-color:#8f288c}.zeroHeroes .level-3 .overview-level-image{background-color:#26a7df}.zeroHeroes .level-4 .overview-level-image{background-color:#e80a89}.zeroHeroes .level-5 .overview-level-image{background-color:#f59122}.zeroHeroes .level-6 .overview-level-image{background-color:#37b34a}.zeroHeroes .slide-content{-ms-flex:1 1 0%;flex:1 1 0%;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-pack:center;justify-content:center;height:100%}.zeroHeroes .spectacle-content h1{margin:.25em auto;color:#fff;font-size:2.5em;font-family:BrandonTextWeb,Helvetica,Arial,sans-serif;line-height:1;font-weight:700}.zeroHeroes .spectacle-content h2{margin:.125em auto;font-weight:100}.zeroHeroes .spectacle-content h2,.zeroHeroes .spectacle-content h3{color:#fff;font-size:2em;font-family:BrandonTextWeb,Helvetica,Arial,sans-serif;line-height:1;letter-spacing:-.5px}.zeroHeroes .spectacle-content h3{margin:0 auto .125em;font-weight:700}.zeroHeroes .spectacle-content h4{font-size:1.6em;letter-spacing:0}.zeroHeroes .spectacle-content h4,.zeroHeroes .spectacle-content h6{margin:.5em auto;color:#fff;font-family:BrandonTextWeb,Helvetica,Arial,sans-serif;line-height:1;font-weight:400;text-transform:none}.zeroHeroes .spectacle-content h6{font-size:3.5em;letter-spacing:-.033em;text-align:center}.zeroHeroes .spectacle-content blockquote{text-align:left;position:relative;display:inline-block}.zeroHeroes .spectacle-content quote{border-left:1px solid #37bad5;padding-left:40;display:block;color:#37bad5;font-size:49px;line-height:1;font-weight:700}.zeroHeroes .spectacle-content cite{color:#fff;display:block;clear:left;font-size:20px;margin-top:1em}.zeroHeroes .spectacle-content content{margin:0 auto;text-align:center}.zeroHeroes .spectacle-content .ui-slide{background-color:#000;background-position:50%;background-image:linear-gradient(rgba(12,44,60,.5) 1px,transparent 0),linear-gradient(#0c2c3c 1px,transparent 0),linear-gradient(90deg,rgba(12,44,60,.5) 1px,transparent 0),linear-gradient(90deg,rgba(12,44,60,.7) 1px,transparent 0),linear-gradient(transparent 3px,#000 0,#000 73px,transparent 0),linear-gradient(90deg,rgba(12,44,60,.7) 3px,transparent 0,transparent 73px,rgba(12,44,60,.7) 0);background-size:5px 5px,75px 75px,5px 5px,75px 75px,75px 75px,75px 75px;-ms-flex:1;flex:1;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-pack:center;justify-content:center;padding:12.5%;font-family:Orbitron;color:#37bad5}.zeroHeroes .spectacle-content .ui-slide h1,.zeroHeroes .spectacle-content .ui-slide h2,.zeroHeroes .spectacle-content .ui-slide h3,.zeroHeroes .spectacle-content .ui-slide h4,.zeroHeroes .spectacle-content .ui-slide h5,.zeroHeroes .spectacle-content .ui-slide h6{color:#37bad5;font-family:Orbitron}.zeroHeroes .spectacle-content .ui-slide h1{margin:.25em 0 .75em;font-size:32px;font-size:3.6vw;text-align:center;text-shadow:0 0 5px #37bad5}@media (max-width:767px){.zeroHeroes .spectacle-content .ui-slide h1{font-size:18px;font-size:6vw}}.zeroHeroes .spectacle-content .ui-slide h2{color:#11abcd;font-size:1.8em;font-weight:700}.zeroHeroes .spectacle-content .ui-slide h3{color:#37bad5;text-shadow:0 0 5px #37bad5;font-size:1.6em;font-weight:400}.zeroHeroes .spectacle-content .ui-slide .flex-image+h3{margin-top:.5em;color:#b4e166;animation:glowing;text-align:center}.zeroHeroes .spectacle-content .ui-slide [class*=\" ppa-icon-\"]:before,.zeroHeroes .spectacle-content .ui-slide [class^=ppa-icon-]:before{margin:0}.zeroHeroes .spectacle-content .ui-slide .level-header{display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;-ms-flex-align:center;align-items:center;padding-bottom:2vw;min-height:8vw;min-height:8vmax}.zeroHeroes .spectacle-content .ui-slide .level-header .level-header-thumb{position:relative;display:block;margin:0 30px;height:6.5vw;width:6.5vw;border-radius:10px}.zeroHeroes .spectacle-content .ui-slide .level-header .level-header-thumb img{width:auto;height:7vw;margin:-.25vw}.zeroHeroes .spectacle-content .ui-slide .level-header .level-header-thumb:after,.zeroHeroes .spectacle-content .ui-slide .level-header .level-header-thumb:before{content:\"\";display:block;border:3px solid #11abcd;width:10px;position:absolute;top:0;bottom:0}.zeroHeroes .spectacle-content .ui-slide .level-header .level-header-thumb:before{border-top-left-radius:10px;border-bottom-left-radius:10px;left:-20px;border-right:none}.zeroHeroes .spectacle-content .ui-slide .level-header .level-header-thumb:after{border-top-right-radius:10px;border-bottom-right-radius:10px;right:-20px;border-left:none}.zeroHeroes .spectacle-content .ui-slide .level-header .level-header-thumb+h2{margin-left:.5vw}.zeroHeroes .spectacle-content .ui-slide .level-header h2{-ms-flex:1;flex:1}.zeroHeroes .spectacle-content .ui-slide.mission-report-level-1 .level-header-thumb{background-color:#ffbc00;box-shadow:0 0 15px #ffbc00}.zeroHeroes .spectacle-content .ui-slide.mission-report-level-2 .level-header-thumb{background-color:#8f288c;box-shadow:0 0 15px #8f288c}.zeroHeroes .spectacle-content .ui-slide.mission-report-level-3 .level-header-thumb{background-color:#26a7df;box-shadow:0 0 15px #26a7df}.zeroHeroes .spectacle-content .ui-slide.mission-report-level-4 .level-header-thumb{background-color:#e80a89;box-shadow:0 0 15px #e80a89}.zeroHeroes .spectacle-content .ui-slide.mission-report-level-5 .level-header-thumb{background-color:#f59122;box-shadow:0 0 15px #f59122}.zeroHeroes .spectacle-content .ui-slide .mission-report{border-top:2px solid #11abcd;border-bottom:2px solid #11abcd;padding:2.5vw 3vw;max-height:60vh;overflow-y:hidden;counter-reset:missioncounter}.zeroHeroes .spectacle-content .ui-slide .mission-report .form-fields{padding:0;width:100%}.zeroHeroes .spectacle-content .ui-slide .mission-report .form-horizontal{display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row}.zeroHeroes .spectacle-content .ui-slide .mission-report .form-horizontal .question-group-wrapper{margin:0 0 .5em}.zeroHeroes .spectacle-content .ui-slide .mission-report .form-horizontal .question-group-error{color:red;font-size:.8em;line-height:.8em}.zeroHeroes .spectacle-content .ui-slide .mission-report .form-horizontal .question-group{margin:0;display:-ms-flexbox;display:flex;-ms-flex-flow:wrap;flex-flow:wrap;-ms-flex-direction:row;flex-direction:row;-ms-flex-align:center;align-items:center}.zeroHeroes .spectacle-content .ui-slide .mission-report .form-horizontal .question-group:before{content:counter(missioncounter) \".\";counter-increment:missioncounter 1;display:block;width:1.5em;font-size:1.2em;line-height:1.2em;text-align:left;font-weight:700}.zeroHeroes .spectacle-content .ui-slide .mission-report .form-horizontal .button-group{margin-left:2.5vw;-ms-flex-preferred-size:240px;flex-basis:240px;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center}.zeroHeroes .spectacle-content .ui-slide .mission-report .form-horizontal input[type=number]::-webkit-inner-spin-button,.zeroHeroes .spectacle-content .ui-slide .mission-report .form-horizontal input[type=number]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}.zeroHeroes .spectacle-content .ui-slide .mission-report .form-horizontal input[type=number]{-moz-appearance:textfield}.zeroHeroes .spectacle-content .ui-slide .mission-report .form-horizontal .control-label{text-align:left}.zeroHeroes .spectacle-content .ui-slide .mission-report label{-ms-flex:2;flex:2;margin-top:0;padding-top:0;padding-right:.5em;font-size:1em;line-height:1em;font-weight:400;font-family:BrandonTextWeb,Helvetica,Arial,sans-serif;color:#11abcd}.zeroHeroes .spectacle-content .ui-slide .mission-report .form-control,.zeroHeroes .spectacle-content .ui-slide .mission-report input{border:.125em solid #11abcd;background:#000;width:3em;height:1.4em;padding:.25em .25em .1em;margin:0 0 1% 2%;border-radius:.25em;font-size:1.1em;text-align:right;line-height:.7em;font-family:Orbitron;color:#37bad5}.zeroHeroes .spectacle-content .ui-slide .mission-report .btn-fake{background-color:#000;box-sizing:border-box;width:150px;height:150px;padding:25px;border-radius:50%;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;border:4px solid #61d9f2;font-size:15px;text-transform:uppercase;box-shadow:inset 0 0 0 5px #000,inset 0 0 5px 15px #e0f000,0 0 0 0 #61d9f2;text-shadow:0 0 0 #fff;transition:all .5s ease-in-out;-webkit-tap-highlight-color:black;outline:none}.zeroHeroes .spectacle-content .ui-slide .mission-report .btn-fake:active{box-shadow:inset 0 0 0 3px #000,inset 0 0 15px 18px #f4ff58,0 0 10px 5px #61d9f2;text-shadow:0 0 15px #fff;transform:rotate(2turn)}.zeroHeroes .spectacle-content .team-names .form-group{margin:0 0 .5em;display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;-ms-flex-align:center;align-items:center}.zeroHeroes .spectacle-content .team-names label{-ms-flex-preferred-size:10em;flex-basis:10em;margin-top:0;padding-top:0;font-size:2em;line-height:1em;font-weight:400;font-family:Orbitron,sans-serif;text-transform:uppercase;text-align:right;color:#11abcd}.zeroHeroes .spectacle-content .team-names label i{margin:0 .125em 0 .25em;font-size:1.25em}.zeroHeroes .spectacle-content .team-names .team-1 label{color:#3cca3f}.zeroHeroes .spectacle-content .team-names .team-2 label{color:#c57b39}.zeroHeroes .spectacle-content .team-names .team-3 label{color:#187bc5}.zeroHeroes .spectacle-content .team-names .team-4 label{color:#f8f8f8}.zeroHeroes .spectacle-content .team-names .form-control{border-radius:.25em;height:2em;padding:.5em;margin-bottom:1%;font-size:1.2em}.zeroHeroes .spectacle-content .text-balloon{width:75vw;padding:5%;margin:15vh auto 0;border-radius:7.5vh;background-color:rgba(0,0,0,.3);-ms-flex-align:start;align-items:flex-start;text-align:left;color:#fff;font-size:1.2em}.zeroHeroes .spectacle-content .text-balloon:after{bottom:-30px;border-width:15px 30px;left:auto}.zeroHeroes .spectacle-content .text-balloon.left:after{border-color:rgba(0,0,0,.3) transparent transparent rgba(0,0,0,.3);left:35%;transform:skewX(-40deg)}.zeroHeroes .spectacle-content .text-balloon.right:after{border-color:rgba(0,0,0,.3) rgba(0,0,0,.3) transparent transparent;right:35%;transform:skewX(40deg)}.zeroHeroes .spectacle-content .text-balloon h2,.zeroHeroes .spectacle-content .text-balloon h3{margin-left:0;margin-right:0}.zeroHeroes .text-balloon-character{margin:-60px 15% 0;position:relative;text-align:center}.zeroHeroes .text-balloon-character.right{text-align:right}.zeroHeroes .text-balloon-character.left{text-align:left}.zeroHeroes .text-balloon-character img{height:30vh;width:auto}.zeroHeroes .text-heading{text-align:center}.zeroHeroes .text-formatted,.zeroHeroes .text-heading{width:66.7%;font-size:1.6em;line-height:1.25em;margin:0 auto}.zeroHeroes .text-formatted{text-align:left}.zeroHeroes .text-formatted ul{margin-top:.5em;padding-left:2em}.zeroHeroes .text-formatted li{margin-bottom:.5em}.zeroHeroes .text-formatted h2,.zeroHeroes .text-formatted h3{margin-left:0;margin-right:0}.zeroHeroes .text-balloon-body{width:auto;margin:0}.zeroHeroes .youtube-button .btn-lg{font-size:48px;line-height:40px;padding:8px 5px 8px 11px;height:100px;min-height:100px;width:100px;border-radius:50%;z-index:100}.zeroHeroes .level-complete{-ms-flex-direction:column;flex-direction:column;-ms-flex:1;flex:1}.zeroHeroes .level-complete,.zeroHeroes .spectacle-content .level-complete-content{display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center}.zeroHeroes .spectacle-content .level-complete-content{width:40vw;height:40vw;-ms-flex-direction:column;flex-direction:column}.zeroHeroes .spectacle-content .level-complete-content .level-complete-graphic{position:absolute;top:50%;left:50%;margin-left:-20vw;margin-top:-20vw;z-index:1}.zeroHeroes .spectacle-content .level-complete-content .level-complete-graphic img{width:40vw;height:40vw}.zeroHeroes .spectacle-content .level-complete-content h3{font-size:7em;line-height:.5em;font-weight:700;text-align:center}.zeroHeroes .spectacle-content .level-complete-content h2{text-align:center;font-weight:700}.zeroHeroes .spectacle-content .level-complete-content .btn{background:none;border-color:#fff;position:relative;z-index:2;height:2.5em;min-height:2.5em;padding:0 1.25em;border-radius:1.25em;font-family:BrandonTextWeb,Helvetica,Arial,sans-serif;font-size:1em;color:#fff;text-shadow:none}.zeroHeroes .hacked{background-color:#000;background-size:cover;animation:glitcher 2s;display:-ms-flexbox;display:flex;position:absolute;top:0;bottom:0;left:0;right:0;-ms-flex-align:end;align-items:flex-end}.zeroHeroes .hacked-form{width:40%;margin-left:50%;margin-bottom:6em}.zeroHeroes.deck-level-1 .spectacle-content .text-balloon.balloon-regular{background-color:rgba(150,50,0,.3)}.zeroHeroes.deck-level-1 .spectacle-content .text-balloon.balloon-regular.left:after{border-color:rgba(150,50,0,.3) transparent transparent rgba(150,50,0,.3)}.zeroHeroes.deck-level-1 .spectacle-content .text-balloon.balloon-regular.right:after{border-color:rgba(150,50,0,.3) rgba(150,50,0,.3) transparent transparent}.zeroHeroes.deck-level-5 .spectacle-content .text-balloon.balloon-regular{background-color:rgba(125,75,0,.3)}.zeroHeroes.deck-level-5 .spectacle-content .text-balloon.balloon-regular.left:after{border-color:rgba(125,75,0,.3) transparent transparent rgba(125,75,0,.3)}.zeroHeroes.deck-level-5 .spectacle-content .text-balloon.balloon-regular.right:after{border-color:rgba(125,75,0,.3) rgba(125,75,0,.3) transparent transparent}", ""]);
	
	// exports


/***/ }),
/* 1287 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(12)();
	// imports
	
	
	// module
	exports.push([module.id, "body.hide-intercom #intercom-container{display:none}", ""]);
	
	// exports


/***/ }),
/* 1288 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(12)();
	// imports
	exports.push([module.id, "@import url(//hello.myfonts.net/count/31e6d3);", ""]);
	
	// module
	exports.push([module.id, "@font-face{font-family:BrandonTextWeb;font-weight:700;font-style:italic;src:url(" + __webpack_require__(843) + ");src:url(" + __webpack_require__(843) + "?#iefix) format(\"embedded-opentype\"),url(" + __webpack_require__(2246) + ") format(\"woff2\"),url(" + __webpack_require__(2245) + ") format(\"woff\"),url(" + __webpack_require__(2244) + ") format(\"truetype\")}@font-face{font-family:BrandonTextWeb;font-weight:700;src:url(" + __webpack_require__(844) + ");src:url(" + __webpack_require__(844) + "?#iefix) format(\"embedded-opentype\"),url(" + __webpack_require__(2249) + ") format(\"woff2\"),url(" + __webpack_require__(2248) + ") format(\"woff\"),url(" + __webpack_require__(2247) + ") format(\"truetype\")}@font-face{font-family:BrandonTextWeb;font-style:italic;src:url(" + __webpack_require__(845) + ");src:url(" + __webpack_require__(845) + "?#iefix) format(\"embedded-opentype\"),url(" + __webpack_require__(2252) + ") format(\"woff2\"),url(" + __webpack_require__(2251) + ") format(\"woff\"),url(" + __webpack_require__(2250) + ") format(\"truetype\")}@font-face{font-family:BrandonTextWeb;src:url(" + __webpack_require__(846) + ");src:url(" + __webpack_require__(846) + "?#iefix) format(\"embedded-opentype\"),url(" + __webpack_require__(2255) + ") format(\"woff2\"),url(" + __webpack_require__(2254) + ") format(\"woff\"),url(" + __webpack_require__(2253) + ") format(\"truetype\")}body{background-color:#f0f0f0;background-position:50%;color:#000}body,h1,h2,h3,h4,h5,h6{font-family:BrandonTextWeb,Helvetica,Arial,sans-serif}h1,h2,h3,h4,h5,h6{color:#37bad5}h1,h2,h3{margin-top:1em;margin-bottom:1em;text-transform:uppercase;letter-spacing:.1em}h2{color:#abd561}.container{margin-left:5px;margin-right:5px}@media (min-width:768px){.container{margin-left:auto;margin-right:auto}}.navbar-default{background-color:#000;background-position:50%;background-image:linear-gradient(rgba(12,44,60,.5) 1px,transparent 0),linear-gradient(#0c2c3c 1px,transparent 0),linear-gradient(90deg,rgba(12,44,60,.5) 1px,transparent 0),linear-gradient(90deg,rgba(12,44,60,.7) 1px,transparent 0),linear-gradient(transparent 3px,#000 0,#000 73px,transparent 0),linear-gradient(90deg,rgba(12,44,60,.7) 3px,transparent 0,transparent 73px,rgba(12,44,60,.7) 0);background-size:5px 5px,75px 75px,5px 5px,75px 75px,75px 75px,75px 75px;border-radius:0;border-bottom:4px solid #37bad5;padding:15px 30px}.branding{width:250px}.deck-hud-panel,.panel-primary{background:none;border:4px solid #37bad5;border-radius:20px;padding:0;transition:all .75s ease-in}.deck-hud-panel:after,.deck-hud-panel:before,.panel-primary:after,.panel-primary:before{background:#000;content:\"\";display:block;position:absolute;top:30px;bottom:30px;width:4px}.deck-hud-panel:before,.panel-primary:before{left:-4px}.deck-hud-panel:after,.panel-primary:after{right:-4px}.deck-hud-panel>.panel-heading,.panel-primary>.panel-heading{background:none;border:none;font-family:Orbitron,sans-serif;font-size:32px;text-transform:uppercase;letter-spacing:.1em;color:#37bad5;text-align:center;text-shadow:0 0 5px rgba(55,172,236,.8)}.panel-default{background-color:#f0f0f0;border:none!important}.panel-default .panel-heading{border-top:none!important;border-left:none!important;border-right:none!important}.panel-default .panel-body{border:none!important}.well{background-color:rgba(0,0,0,.5);border-radius:20px;border-color:#37bad5;border-width:4px;padding-bottom:30px}.well h1,.well h2,.well h3,.well h4,.well h5,.well h6{margin-top:0}.well-header{padding-bottom:15px;margin-bottom:15px;border-bottom:1px solid #37bad5}.btn{background:transparent;border-color:#61d9f2;border-width:3px;border-radius:10px;margin:5px auto;min-height:3em;line-height:1em;font-family:BrandonTextWeb,Helvetica,Arial,sans-serif;font-size:18px;text-transform:uppercase;letter-spacing:.1em;color:#61d9f2;text-align:center;outline:none}@media (max-width:479px){.btn{margin:5px 0;font-size:15px;max-width:100%}}.btn.glyphicon:before{margin-right:.125em;font-size:2.5em;line-height:.5em;vertical-align:middle}.btn.btn-current[disabled],.btn.btn-link[disabled]{border-color:hsla(0,0%,87%,.5);border-style:dotted;color:#ddd;cursor:default;opacity:.8}.btn.btn-current[disabled]{border-color:#3cca3f;color:#3cca3f;cursor:default}.btn:hover{box-shadow:0 0 10px #61d9f2;background-color:#61d9f2;color:#fff}.btn-xs{border-radius:8px;font-size:11px}.btn-sm{font-size:13px;line-height:34px;padding:0 9px}.btn-group-lg>.btn,.btn-lg{padding:17px;font-size:20px}@media (max-width:479px){.btn-group-lg>.btn,.btn-lg{max-width:100%}}.btn-primary{border-color:#abd561;color:#fff;background-color:#abd561}.btn-primary.active,.btn-primary.active:focus,.btn-primary.active:hover,.btn-primary:active:focus,.btn-primary:active:hover,.btn-primary:focus,.btn-primary:hover{border-color:#abd561;background:transparent;color:#abd561;box-shadow:0 0 10px #abd561}.btn-success{border-color:#00b9f2;color:#00b9f2!important;background:#000}.btn-success.active,.btn-success.active:focus,.btn-success.active:hover,.btn-success:active:focus,.btn-success:active:hover,.btn-success:focus,.btn-success:hover{box-shadow:0 0 10px #00b9f2;border-color:#00b9f2;color:#fff!important;background-color:#00b9f2}.btn-default{border-color:#37bad5;color:#37bad5;background:transparent}.btn-default.active,.btn-default.active:focus,.btn-default.active:hover,.btn-default:active:focus,.btn-default:active:hover,.btn-default:focus,.btn-default:hover{border-color:#37bad5;color:#fff;background-color:#37bad5;box-shadow:0 0 10px #37bad5}.btn-link,.btn-link.active,.btn-link:active,.btn-link[disabled],fieldset[disabled] .btn-link{background-color:none}.list-group-item{border:none}.btn-wrap{white-space:normal}.program-thumb{margin-bottom:5px;padding-left:0}.program-thumb img{width:100%;height:auto}.programTitleDiv{text-transform:uppercase;padding-left:0!important;padding-right:0!important}@media (max-width:768px){.programTitleDiv{transform:translateY(-10%)!important}}@media (min-width:768px){.programTitleDiv{transform:translateY(10%)!important}}@media (min-width:992px){.programTitleDiv{transform:translateY(42%)!important}}@media (min-width:1200px){.programTitleDiv{transform:translateY(12%)!important}}.programDescriptionDiv{padding-left:5%!important;padding-right:0!important}@media (max-width:992px){.programDescriptionDiv{transform:translateY(0)!important}}@media (min-width:992px){.programDescriptionDiv{transform:translateY(14%)!important}}@media (min-width:1200px){.programDescriptionDiv{transform:translateY(30%)!important}}.programLevelsInclude{padding-left:5%!important;padding-right:0!important}@media (max-width:992px){.programLevelsInclude{transform:translateY(0)!important}}@media (min-width:992px){.programLevelsInclude{transform:translateY(12%)!important}}@media (min-width:1200px){.programLevelsInclude{transform:translateY(20%)!important}}.programPanelProgramTitleContainer{padding-left:5%!important;padding-right:0!important}@media (max-width:992px){.programPanelProgramTitleContainer{transform:translateY(0)!important}}@media (min-width:992px){.programPanelProgramTitleContainer{transform:translateY(50%)!important}}@media (min-width:1200px){.programPanelProgramTitleContainer{transform:translateY(100%)!important}}.programPanelProgramTitle{font-size:25px!important}.svg-icon{display:block;background-repeat:no-repeat;background-size:100%;height:56px;width:56px;margin:0 auto}.svg-icon.icon-prev{background-image:url(" + __webpack_require__(914) + ")}.svg-icon.icon-play{background-image:url(" + __webpack_require__(916) + ")}.svg-icon.icon-next{background-image:url(" + __webpack_require__(913) + ")}body,html{-webkit-touch-callout:none;-webkit-user-select:none;-webkit-tap-highlight-color:transparent}a::selection,div::selection,h1::selection,h2::selection,h3::selection,h4::selection,h5::selection,h6::selection,p::selection{background-color:red}a::moz-selection,a::webkit-selection,div::moz-selection,div::webkit-selection,h1::moz-selection,h1::webkit-selection,h2::moz-selection,h2::webkit-selection,h3::moz-selection,h3::webkit-selection,h4::moz-selection,h4::webkit-selection,h5::moz-selection,h5::webkit-selection,h6::moz-selection,h6::webkit-selection,p::moz-selection,p::webkit-selection{background-color:red}.home-landing{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;text-align:center}.home-landing img{max-width:80vw;height:auto}.text-balloon{background-color:#fff;padding:1vw 5vw 2vw;min-width:260px;width:60vw;border-radius:5vh;position:relative;-ms-flex-positive:2;flex-grow:2;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;color:#000}@media screen and (max-width:768px){.text-balloon{border-radius:25px;padding:1vw 5vw 2vw}}.text-balloon h1{margin:1vw 0 .25vw;font-weight:700;font-size:3em;font-size:3.6125vw;color:#000;font-family:BrandonTextWeb,Helvetica,Arial,sans-serif;letter-spacing:0;text-align:center}@media screen and (max-width:768px){.text-balloon h1{margin:2vw 0 1vw;font-size:2em}}.text-balloon *{max-width:100%}.text-balloon:after{content:\"\";display:block;border-style:solid;border-width:30px;border-color:#fff transparent transparent;width:0;position:absolute;bottom:-60px;left:50%;margin-left:-30px}.browser-warning{background-color:#9e260d;height:2.5em;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;width:100%}.modal-content{background-color:#fff}input.form-control,select.form-control{border:1px solid #e4e4e4!important}.modal-content{background-color:transparent}.modal-header{background-color:#000;background-position:50%;background-image:linear-gradient(rgba(12,44,60,.5) 1px,transparent 0),linear-gradient(#0c2c3c 1px,transparent 0),linear-gradient(90deg,rgba(12,44,60,.5) 1px,transparent 0),linear-gradient(90deg,rgba(12,44,60,.7) 1px,transparent 0),linear-gradient(transparent 3px,#000 0,#000 73px,transparent 0),linear-gradient(90deg,rgba(12,44,60,.7) 3px,transparent 0,transparent 73px,rgba(12,44,60,.7) 0);background-size:5px 5px,75px 75px,5px 5px,75px 75px,75px 75px,75px 75px;border-bottom:4px solid #37bad5;padding-left:30px;border-top-left-radius:6px;border-top-right-radius:6px;overflow:hidden}.modal-header>h4{display:inline-block;line-height:38px;padding-left:10px;font-family:BrandonTextWeb,Helvetica,Arial,sans-serif;text-transform:uppercase;font-weight:700;color:#abd561!important}.modal-header>h4>.subtitle{font-size:.75em;text-transform:capitalize}.modal-header>.close{font-size:38px;line-height:1em}.modal-header:before{background-image:url(" + __webpack_require__(453) + ");background-size:40px 38px;display:inline-block;width:40px;height:38px;vertical-align:bottom;content:\"\"}.modal-body,.modal-footer{background-color:#fff}.modal-body{padding:30px}.modal-body label{color:#37bad5;text-transform:uppercase}.modal-footer{border-top:1px solid #e4e4e4;border-bottom-left-radius:6px;border-bottom-right-radius:6px}.nav-tabs{border-bottom:1px solid #e4e4e4}.nav-tabs>li>a{color:#000!important;background-color:#fff!important;border:1px solid #e4e4e4!important}.nav-tabs>li.active>a,.nav-tabs>li>a:focus,.nav-tabs>li>a:hover{color:#fff!important;background-color:#b4e166!important;border:1px solid #e4e4e4}.programWell{background-color:#fff;border:0}.navbar-default .navbar-nav>li>a.btn-lg{margin-top:22px;padding:6px 15px 3px;font-size:18px;line-height:18px;min-height:0;border:3px solid;color:#fff}.navbar-default .navbar-nav>li>a{padding-top:30px}.navbar-default .navbar-nav>li>a[target=_blank]:focus{color:#fff}.container-fluid>.navbar-nav>li>a.btn:focus{color:#00b9f2!important;border-color:#00b9f2!important;background-color:transparent!important}.container-fluid>.navbar-nav>li>a.btn:hover{color:#fff!important;border-color:#00b9f2!important;background-color:#00b9f2}a.btn.btn-success,a.btn.btn-success:hover{color:#fff}button.btn.btn-lg.button.dualScreenBtn.active,button.btn.btn-lg.button.singleScreenBtn.active{background-color:#abd561!important;border-color:#abd561!important}button.btn.btn-lg.classroomDisplayBtn.active,button.btn.btn-lg.remoteControlBtn.active{border-color:#abd561!important;background-color:#abd561!important;color:#fff!important}@media (max-width:992px){.btn.btn-sm.glyphicon.glyphicon-plus{width:100%!important}}.text-danger>a{color:inherit;text-decoration:underline}.form-horizontal .control-label{text-align:left}.programTitle.program-keepCool{font-family:Orbitron,sans-serif!important}.paywallInfoModal>div>div>.modal-header>h4{line-height:1em}.paywallInfoModal>div>div>.modal-header:before{vertical-align:sub}.paywallUserForm .error{color:red}.navbar-nav{font-size:18px;text-transform:uppercase}.navbar-nav>li{float:left}@font-face{font-family:ppa-icon;src:url(" + __webpack_require__(847) + ");src:url(" + __webpack_require__(847) + "#iefix) format(\"embedded-opentype\"),url(" + __webpack_require__(2257) + ") format(\"woff\"),url(" + __webpack_require__(2256) + ") format(\"truetype\"),url(" + __webpack_require__(2521) + "#ppa-icon) format(\"svg\");font-weight:400;font-style:normal}[class*=\" ppa-icon-\"]:before,[class^=ppa-icon-]:before{font-family:ppa-icon;font-style:normal;font-weight:400;speak:none;display:inline-block;text-decoration:inherit;width:1em;margin-right:.2em;text-align:center;font-variant:normal;text-transform:none;line-height:1em;margin-left:.2em;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.ppa-icon-twitter:before{content:\"\\E800\"}.ppa-icon-facebook:before{content:\"\\E801\"}.ppa-icon-arrow-outline-next:before{content:\"\\E802\"}.ppa-icon-arrow-outline-prev:before{content:\"\\E803\"}.ppa-icon-extras:before{content:\"\\E804\"}.ppa-icon-mute:before{content:\"\\E805\"}.ppa-icon-notes:before{content:\"\\E806\"}.ppa-icon-modules:before{content:\"\\E807\"}.ppa-icon-scores:before{content:\"\\E808\"}.ppa-icon-settings:before{content:\"\\E809\"}.ppa-icon-unmute:before{content:\"\\E80A\"}.ppa-icon-play:before{content:\"\\E80B\"}.ppa-icon-minus:before{content:\"\\E80C\"}.ppa-icon-plus:before{content:\"\\E80D\"}.ppa-icon-team-1:before{content:\"\\E80E\"}.ppa-icon-team-2:before{content:\"\\E810\"}.ppa-icon-team-3:before{content:\"\\E811\"}.ppa-icon-team-4:before{content:\"\\E80F\"}.ppa-icon-logout:before{content:\"\\E812\"}.ppa-icon-exit:before{content:\"\\E813\"}.ppa-icon-arrow-next:before{content:\"\\E814\"}.ppa-icon-arrow-prev:before{content:\"\\E815\"}.ppa-icon-hide:before{content:\"\\E816\"}/*! normalize.css v3.0.2 | MIT License | git.io/normalize */html{font-family:sans-serif;-ms-text-size-adjust:100%;-webkit-text-size-adjust:100%}body{margin:0}article,aside,details,figcaption,figure,footer,header,hgroup,main,menu,nav,section,summary{display:block}audio,canvas,progress,video{display:inline-block;vertical-align:baseline}audio:not([controls]){display:none;height:0}[hidden],template{display:none}a{background-color:transparent}a:active,a:hover{outline:0}abbr[title]{border-bottom:1px dotted}b,strong{font-weight:700}dfn{font-style:italic}h1{font-size:2em;margin:.67em 0}mark{background:#ff0;color:#000}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sup{top:-.5em}sub{bottom:-.25em}img{border:0}svg:not(:root){overflow:hidden}figure{margin:1em 40px}hr{box-sizing:content-box;height:0}pre{overflow:auto}code,kbd,pre,samp{font-family:monospace,monospace;font-size:1em}button,input,optgroup,select,textarea{color:inherit;font:inherit;margin:0}button{overflow:visible}button,select{text-transform:none}button,html input[type=button],input[type=reset],input[type=submit]{-webkit-appearance:button;cursor:pointer}button[disabled],html input[disabled]{cursor:default}button::-moz-focus-inner,input::-moz-focus-inner{border:0;padding:0}input{line-height:normal}input[type=checkbox],input[type=radio]{box-sizing:border-box;padding:0}input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{height:auto}input[type=search]{-webkit-appearance:textfield;box-sizing:content-box}input[type=search]::-webkit-search-cancel-button,input[type=search]::-webkit-search-decoration{-webkit-appearance:none}fieldset{border:1px solid silver;margin:0 2px;padding:.35em .625em .75em}legend{border:0;padding:0}textarea{overflow:auto}optgroup{font-weight:700}table{border-collapse:collapse;border-spacing:0}td,th{padding:0}.spectacle-deck body{font-family:BrandonTextWeb,Helvetica,Arial,sans-serif;background-color:#000;background-position:50%;background-image:linear-gradient(rgba(12,44,60,.5) 1px,transparent 0),linear-gradient(#0c2c3c 1px,transparent 0),linear-gradient(90deg,rgba(12,44,60,.5) 1px,transparent 0),linear-gradient(90deg,rgba(12,44,60,.7) 1px,transparent 0),linear-gradient(transparent 3px,#000 0,#000 73px,transparent 0),linear-gradient(90deg,rgba(12,44,60,.7) 3px,transparent 0,transparent 73px,rgba(12,44,60,.7) 0);background-size:5px 5px,75px 75px,5px 5px,75px 75px,75px 75px,75px 75px}.spectacle-deck h1,.spectacle-deck h2,.spectacle-deck h3,.spectacle-deck h4,.spectacle-deck h5,.spectacle-deck h6{font-family:BrandonTextWeb,Helvetica,Arial,sans-serif;color:#37bad5}.spectacle-deck h1,.spectacle-deck h2,.spectacle-deck h3{margin-top:1em;margin-bottom:1em;font-family:Orbitron,sans-serif;color:#61d9f2;text-transform:uppercase;letter-spacing:.1em}.spectacle-deck .container{margin-left:5px;margin-right:5px}@media (min-width:768px){.spectacle-deck .container{margin-left:auto;margin-right:auto}}.spectacle-deck .navbar-default{background-color:rgba(13,18,24,.8);border-radius:0;border-bottom:4px solid #37bad5;padding:15px 30px}.spectacle-deck .branding{width:250px}.spectacle-deck .deck-hud-panel,.spectacle-deck .panel-primary{background:none;border:4px solid #37bad5;border-radius:20px;padding:0;transition:all .75s ease-in}.spectacle-deck .deck-hud-panel:after,.spectacle-deck .deck-hud-panel:before,.spectacle-deck .panel-primary:after,.spectacle-deck .panel-primary:before{background:#000;content:\"\";display:block;position:absolute;top:30px;bottom:30px;width:4px}.spectacle-deck .deck-hud-panel:before,.spectacle-deck .panel-primary:before{left:-4px}.spectacle-deck .deck-hud-panel:after,.spectacle-deck .panel-primary:after{right:-4px}.spectacle-deck .deck-hud-panel>.panel-heading,.spectacle-deck .panel-primary>.panel-heading{background:none;border:none;font-family:Orbitron,sans-serif;font-size:32px;text-transform:uppercase;letter-spacing:.1em;color:#37bad5;text-align:center;text-shadow:0 0 5px rgba(55,172,236,.8)}.spectacle-deck .panel-default{background-color:#202020;border:none!important}.spectacle-deck .panel-default .panel-heading{background-color:#3a3a3a;border:none!important}.spectacle-deck .panel-default .panel-body{border:none!important}.spectacle-deck .well{background-color:rgba(0,0,0,.5);border-radius:20px;border-color:#11abcd;border-width:4px;padding-bottom:30px}.spectacle-deck .well h1,.spectacle-deck .well h2,.spectacle-deck .well h3,.spectacle-deck .well h4,.spectacle-deck .well h5,.spectacle-deck .well h6{margin-top:0}.spectacle-deck .well-header{padding-bottom:15px;margin-bottom:15px;border-bottom:1px solid #11abcd}.spectacle-deck .btn{background:#000;border-color:#37bad5;border-width:3px;border-radius:10px;margin:5px auto;min-height:3em;font-family:BrandonTextWeb,Helvetica,Arial,sans-serif;font-size:18px;text-transform:uppercase;letter-spacing:.1em;text-align:center;text-shadow:0 0 5px rgba(55,172,236,.8);outline:none!important}@media (max-width:479px){.spectacle-deck .btn{margin:5px 0;font-size:15px;max-width:100%}}.spectacle-deck .btn.glyphicon:before{margin-right:.125em;font-size:2.5em;line-height:.5em;vertical-align:middle}.spectacle-deck .btn.btn-current[disabled],.spectacle-deck .btn.btn-link[disabled]{border-color:hsla(0,0%,87%,.5);border-style:dotted;color:#ddd;cursor:default;opacity:.8}.spectacle-deck .btn.btn-current[disabled]{border-color:#3cca3f;color:#3cca3f;cursor:default}.spectacle-deck .btn:hover{box-shadow:none}.spectacle-deck .btn-xs{border-radius:8px;font-size:11px}.spectacle-deck .btn-sm{font-size:13px}.spectacle-deck .btn-group-lg>.btn,.spectacle-deck .btn-lg{padding:17px;font-size:20px}@media (max-width:479px){.spectacle-deck .btn-group-lg>.btn,.spectacle-deck .btn-lg{max-width:100%}}.spectacle-deck .btn-primary{background:#b4e166;border-color:#b4e166;color:#fff;text-shadow:0 0 5px #b4e166}.spectacle-deck .btn-primary.active,.spectacle-deck .btn-primary.active:focus,.spectacle-deck .btn-primary.active:hover,.spectacle-deck .btn-primary:active:focus,.spectacle-deck .btn-primary:active:hover,.spectacle-deck .btn-primary:focus,.spectacle-deck .btn-primary:hover{color:#b4e166;text-shadow:0 0 5px #000;background-color:#000;border-color:#b4e166;box-shadow:0 0 10px #b4e166}.spectacle-deck .btn-success{background:#000;color:#00b9f2!important;border-color:#00b9f2}.spectacle-deck .btn-success.active,.spectacle-deck .btn-success.active:focus,.spectacle-deck .btn-success.active:hover,.spectacle-deck .btn-success:active:focus,.spectacle-deck .btn-success:active:hover,.spectacle-deck .btn-success:focus,.spectacle-deck .btn-success:hover{color:#fff!important;background-color:#00b9f2;border-color:#00b9f2;box-shadow:0 0 10px #00b9f2}.spectacle-deck .btn-default{border-color:#11abcd;color:#11abcd}.spectacle-deck .btn-default.active,.spectacle-deck .btn-default.active:focus,.spectacle-deck .btn-default.active:hover,.spectacle-deck .btn-default:active:focus,.spectacle-deck .btn-default:active:hover,.spectacle-deck .btn-default:focus,.spectacle-deck .btn-default:hover{color:#fff;background-color:#11abcd;border-color:#11abcd;box-shadow:0 0 10px #11abcd}.spectacle-deck .btn-link,.spectacle-deck .btn-link.active,.spectacle-deck .btn-link:active,.spectacle-deck .btn-link[disabled],.spectacle-deck fieldset[disabled] .btn-link{background-color:none}.spectacle-deck .list-group-item{border:none}.spectacle-deck .btn-wrap{white-space:normal}.spectacle-deck .program-thumb{margin-bottom:5px}.spectacle-deck .program-thumb img{width:100%;height:auto}.spectacle-deck .svg-icon{display:block;background-repeat:no-repeat;background-size:100%;height:56px;width:56px;margin:0 auto}.spectacle-deck .svg-icon.icon-prev{background-image:url(" + __webpack_require__(914) + ")}.spectacle-deck .svg-icon.icon-play{background-image:url(" + __webpack_require__(916) + ")}.spectacle-deck .svg-icon.icon-next{background-image:url(" + __webpack_require__(913) + ")}.spectacle-deck body,.spectacle-deck html{-webkit-touch-callout:none;-webkit-user-select:none;-webkit-tap-highlight-color:transparent}.spectacle-deck a::selection,.spectacle-deck div::selection,.spectacle-deck h1::selection,.spectacle-deck h2::selection,.spectacle-deck h3::selection,.spectacle-deck h4::selection,.spectacle-deck h5::selection,.spectacle-deck h6::selection,.spectacle-deck p::selection{background-color:red}.spectacle-deck a::moz-selection,.spectacle-deck a::webkit-selection,.spectacle-deck div::moz-selection,.spectacle-deck div::webkit-selection,.spectacle-deck h1::moz-selection,.spectacle-deck h1::webkit-selection,.spectacle-deck h2::moz-selection,.spectacle-deck h2::webkit-selection,.spectacle-deck h3::moz-selection,.spectacle-deck h3::webkit-selection,.spectacle-deck h4::moz-selection,.spectacle-deck h4::webkit-selection,.spectacle-deck h5::moz-selection,.spectacle-deck h5::webkit-selection,.spectacle-deck h6::moz-selection,.spectacle-deck h6::webkit-selection,.spectacle-deck p::moz-selection,.spectacle-deck p::webkit-selection{background-color:red}.spectacle-deck .home-landing{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;text-align:center}.spectacle-deck .home-landing img{max-width:80vw;height:auto}.spectacle-deck .text-balloon{background-color:#fff;padding:1vw 5vw 2vw;min-width:260px;width:60vw;border-radius:5vh;position:relative;-ms-flex-positive:2;flex-grow:2;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;color:#000}@media screen and (max-width:768px){.spectacle-deck .text-balloon{border-radius:25px;padding:1vw 5vw 2vw}}.spectacle-deck .text-balloon h1{margin:1vw 0 .25vw;font-weight:700;font-size:3em;font-size:3.6125vw;color:#000;font-family:BrandonTextWeb,Helvetica,Arial,sans-serif;letter-spacing:0;text-align:center}@media screen and (max-width:768px){.spectacle-deck .text-balloon h1{margin:2vw 0 1vw;font-size:2em}}.spectacle-deck .text-balloon *{max-width:100%}.spectacle-deck .text-balloon:after{content:\"\";display:block;border-style:solid;border-width:30px;border-color:#fff transparent transparent;width:0;position:absolute;bottom:-60px;left:50%;margin-left:-30px}.spectacle-deck .browser-warning{background-color:#9e260d;height:2.5em;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;width:100%}.spectacle-deck .modal-content{border-radius:6px;overflow:hidden}.spectacle-deck .modal-body,.spectacle-deck .modal-content,.spectacle-deck .modal-footer{background-color:#303030}.spectacle-deck .modal-header{background:#303030;border-bottom:4px solid #464545}.spectacle-deck .modal-footer{border-top:1px solid #464545}.spectacle-deck .clickToEndLevel{line-height:1em!important}", ""]);
	
	// exports


/***/ }),
/* 1289 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(12)();
	// imports
	
	
	// module
	exports.push([module.id, ".newEmailLabel{float:left;padding-left:0!important}.newEmailInputDiv{float:right;padding-right:0!important}.passwordLabel{float:left;padding-left:0!important}.passwordInputDiv{float:right;padding-right:0!important}", ""]);
	
	// exports


/***/ }),
/* 1290 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(12)();
	// imports
	
	
	// module
	exports.push([module.id, "h2{font-size:30px;line-height:30px}h3{font-size:25px;line-height:25px;margin-bottom:0!important}hr{margin-top:.91%!important;margin-bottom:2.35%!important;border-top:1px solid #61d9f2}", ""]);
	
	// exports


/***/ }),
/* 1291 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(12)();
	// imports
	
	
	// module
	exports.push([module.id, ".spinnerButton .buttonContent,.spinnerButton .buttonContent .buttonText{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center}.spinnerButton .buttonContent .buttonText{height:20px;padding:0 10px}.spinnerButton .buttonContent .spinnerWrapper{width:20px;height:20px;overflow:hidden;display:-ms-flexbox;display:flex}", ""]);
	
	// exports


/***/ }),
/* 1292 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(12)();
	// imports
	
	
	// module
	exports.push([module.id, ".ddMmSpacer{font-size:1em;line-height:1em}.confirmDuration{margin-top:10px}.promoCode{width:auto}.promoCodeValue{font-weight:700;color:#abd561}.expCvcRow>*{display:inline-block;vertical-align:middle}.expCvcRow span{font-size:2em}.expCvcRow label,.expCvcRow span{padding-left:15px;padding-right:15px}.cc-input,.cvc-input,.exp-input{width:auto}.gooberLeaps{margin:0;padding:0}", ""]);
	
	// exports


/***/ }),
/* 1293 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(12)();
	// imports
	
	
	// module
	exports.push([module.id, ".confirm-add-class .modal-body h4{font-family:brandon-grotesque,Helvetica,Arial,sans-serif;padding:0 0 1em;margin:0}.confirm-add-class .btn{width:100%;white-space:normal;min-height:4em;text-transform:none}", ""]);
	
	// exports


/***/ }),
/* 1294 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(12)();
	// imports
	
	
	// module
	exports.push([module.id, ".welcomeHeader{text-align:center!important;margin-bottom:21px}#welcomeHeader1{font-size:32px}#welcomeHeader2{font-size:24px}.welcomeHeaderContainer{text-align:center!important;margin-top:10%}.welcomeHeaderBtn{float:none}.character-image{width:80%;float:right}.adminPageTitle{color:#b4e166;font-size:30px;text-transform:uppercase}", ""]);
	
	// exports


/***/ }),
/* 1295 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(12)();
	// imports
	
	
	// module
	exports.push([module.id, ".session-panel-group{margin-bottom:0!important}", ""]);
	
	// exports


/***/ }),
/* 1296 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(12)();
	// imports
	
	
	// module
	exports.push([module.id, "@keyframes blink{50%{border-color:#abd561}}.session-list-enter{opacity:.01}.session-list-enter.session-list-enter-active{opacity:1;transition:opacity .5s ease-in}.session-list-leave{opacity:1;max-height:600px}.session-list-leave.session-list-leave-active{opacity:.01;max-height:0;transition:opacity 1s ease-in,max-height 1s ease-in}.panel-title .btn{line-height:12px!important;font-size:12px!important;margin:0!important;margin-left:5px!important}.panel-heading .level-bar{width:100%;display:-ms-flexbox;display:flex;-ms-flex-pack:justify;justify-content:space-between}.panel-heading .level-bar .level-bar-item{-ms-flex:1;flex:1;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;display:-ms-flexbox;display:flex}.panel-heading .level-bar .level-bar-item+.level-bar-item{margin-left:5px}.level-bar .level-prep{text-align:center;font-size:3em;text-shadow:2px 2px #000;padding:0!important}.panel-body .level-bar{margin:10px auto;padding:0}@media (min-width:992px){.panel-body .level-bar{margin:2px auto}}@media (min-width:1200px){.panel-body .level-bar{margin:24px auto}}.panel-body .level-bar .level-bar-item{font-size:24px;margin-bottom:5px}.level-bar .level-bar-item{padding:4px;text-align:center;background:#fff;border:1px solid #37bad5;font-size:.8em;font-family:BrandonTextWeb,Helvetica,Arial,sans-serif}.level-bar .level-bar-item .level-number{line-height:1.4em;color:#37bad5}.level-bar .level-bar-item.completed{background:#37bad5;color:#000}.level-bar .level-bar-item.completed .level-number{color:#000}.level-bar .level-bar-item.active{background-color:#abd561;border:1px solid #abd561;box-shadow:0 0 3px #abd561;font-weight:700}.level-bar .level-bar-item.active .level-number{color:#fff}.level-bar-label{margin-right:.5em;text-transform:uppercase;line-height:1.8em;color:#00b9f2}.panel-title .glyphicon{text-align:right}@media (max-width:767px){.session-panel .dl-horizontal dt{display:inline-block;width:30%;margin-right:5%;clear:left;vertical-align:top}.session-panel .dl-horizontal dd{display:inline-block;width:65%;vertical-align:top}}.panel-heading-lh{line-height:1.8em;color:#00b9f2}.panel-heading-btn-lh{line-height:1.6em;color:#00b9f2}.launchLevelBtn{white-space:normal}.inactiveLevelContainer,.levelBarContainer{padding-left:0!important;padding-right:0!important}.inactiveLevelContainer{margin-left:1.8%!important;margin-right:1.8%!important}.panel-body .level-bar .level-bar-item{padding-top:5.56%!important;padding-bottom:0!important;border-radius:15px}.nounImage{height:62.9px!important;width:58.5px!important;cursor:pointer}.nounImage:hover{box-shadow:0 0 5px #000}.programPrepBtn{margin-left:30%;margin-right:1%;margin-top:5%}.inactiveLevelContainer>.level-bar-item{padding-left:5%!important;padding-right:0!important}.level-bar-item>.level-number>.glyphicon-lock{font-size:24px}.level-bar>.level-bar-item.col-md-1>.level-number>.glyphicon-lock{font-size:14px!important}.col-md-1>.level-bar-item>.glyphicon-ok{padding-top:20%;padding-bottom:30%;font-size:24px}.col-md-4>.level-bar-item>.level-number{padding-bottom:4.5%;font-size:24px}.col-md-1>.level-bar-item>.level-number{padding-top:17.5%;padding-bottom:22.5%;font-size:24px}.panel-heading{cursor:default!important;border-radius:10px;background-color:#132430!important;margin-bottom:8px}.editClassBtn{margin-top:0!important;margin-bottom:21px!important}.close{color:#11abcd}.close:hover{color:#2fcef1}.learnAboutPrograms{color:#b4e166}@media (max-width:992px){.programPrepBtn{width:98.5%!important;margin-left:1.8%!important;margin-right:0!important;margin-top:3.5%!important}.level-number{padding-top:0!important;padding-bottom:0!important;padding-right:4.75%!important}.panel-body .level-bar .level-bar-item{padding-top:1%!important;margin-top:2%!important;margin-bottom:2%!important}.col-md-1>.level-bar-item>.glyphicon-ok{padding-bottom:0!important;padding-top:0!important}.level-bar-item.completed{padding-left:.5%!important}.launchLevelBtn{margin-top:2%!important;margin-bottom:2%!important}.editClassBtn{width:50%!important}.re-enter{margin-left:1.8%;width:98.5%!important;margin-right:0!important}}.panel.panel-default{border-radius:25px 25px 0 0}.programTitleSpan{padding-left:0!important;text-align:center;color:#abd561}.re-enter{width:24%}.buyNowBtn{padding-top:0!important;padding-bottom:0!important}.launchBtnContainer{padding-left:0!important;padding-right:0!important}.panel-buttons{text-align:center;float:right;padding-top:15px}.buttonBarContainer{text-align:center;padding-left:0}.buttonBarContainer .btn{margin:0;min-width:100%}@media (min-width:992px){.buttonBarContainer .btn{min-width:30%}}.program-title-row{margin-left:0!important;margin-right:0!important;text-transform:uppercase}.level-bar-container{padding-top:22.5px}@media (max-width:992px){.level-bar-container{visibility:hidden}}.level-progress-bar-container{width:100%;height:15px;border-radius:30px;background-color:#4b4b49}.level-progress-bar-bar{border-top-left-radius:30px;border-bottom-left-radius:30px;border-top-right-radius:30px;border-bottom-right-radius:30px;background-color:#22b1cb;height:100%}.program-step-container{height:343px;padding-left:5px;padding-right:5px}.program-launch-container{height:342px!important;padding-left:5px;padding-right:0!important}.program-step{height:33.3%}.panel-body{padding-left:0!important;padding-right:0!important;padding-top:0!important}.session-panel-numb-btn{display:table;padding-top:20px;padding-bottom:20px}.session-panel-btn,.session-panel-numb-btn{border:1px solid transparent;background-color:#fff}.session-panel-launch-btn{color:#6c8240!important}.number-circle{border-radius:50%;min-width:75px;width:75px;padding:8px 2px 2px 3px;background:#00b9f2;color:#fff;text-align:center;font-size:40px;display:table-cell;vertical-align:middle;font-family:BrandonTextWeb,Helvetica,Arial,sans-serif}.session-panel-numb-btn{box-shadow:0 0 10px #dedee0!important}.session-panel-numb-btn:hover>.number-circle{background:#fff!important;color:#00b9f2}.session-panel-btn-text{padding-left:20px;font-size:17px;text-transform:none;font-weight:700;text-align:left;white-space:normal}.session-panel-arrow-icon-container,.session-panel-btn-text{display:table-cell;vertical-align:middle}.session-panel-arrow-icon{font-size:42px}.program-description-active-panel,.program-description-btn-panel,.program-description-panel{border-radius:10px;padding:25px}.program-description-panel{background-color:#fff;font-size:18px}.program-description-btn-panel{background-color:#f0f0f0;padding:0!important;margin-top:5px!important}.program-description-active-panel{background-color:#dedee0;margin-top:5px;padding-top:20px!important;min-height:698px}.program-desc-level-btn{padding:10px 5px!important}.program-desc-level-btn,.program-desc-level-btn:hover{box-shadow:0 0 10px #dedee0!important}.program-title-panel{font-size:24px!important;text-align:center;color:#fff;background-color:#00b9f2;border-radius:5px;margin-top:2.5px;margin-bottom:10px;padding-top:5px;padding-bottom:0;text-transform:uppercase}.activePanelBtn{border-color:#00b9f2!important;background-color:#00b9f2!important;color:#fff!important;box-shadow:0!important}.activePanelBtn>.number-circle{background:#fff!important;color:#00b9f2}.activeDescPanelBtn{background-color:#dedee0!important;border-color:#dedee0!important;width:100%;font-weight:700}.program-description-panel.btn.btn-sm{border-color:#fff;background-color:#fff;color:#000!important}.program-description-panel.btn.btn-sm:hover{background-color:#dedee0!important;border-color:#dedee0!important;box-shadow:0 0 10px #dedee0!important}.sessionPanelImgIcon{margin-top:0;height:33%;display:table;box-shadow:0 0 10px #dedee0!important}.sessionPanelImgIcon:active,.sessionPanelImgIcon:focus,.sessionPanelImgIcon:hover{border:0!important;background-color:#fff!important;box-shadow:0 0 10px #00b9f2!important}.sessionPanelImgIcon>img{width:100%;display:table-cell;vertical-align:middle}.sessionPanelLaunchImgIcon:active,.sessionPanelLaunchImgIcon:focus,.sessionPanelLaunchImgIcon:hover{background-color:#abd561!important}.sessionPanelLaunchImgIcon>img{width:50%;padding-top:32.5px}.sessionPanelLaunchImgIcon>div{margin-top:12%}.program-description-level-list{padding-left:0;padding-right:10px}.navbar.navbar-default.logged-in{margin-bottom:0!important;border-bottom:0!important}.program-thumb-my-classes{padding-right:5px}.program-thumb-my-classes>img{max-height:363px}.view-container>div>.container{padding-left:80px;padding-right:80px}.sessionPanelLaunchImgIcon{font-size:25px}.session-panel-numb-btn:hover{background-color:#00b9f2!important}.program-description-active-panel>div>h1,.program-description-active-panel>div>h4,.program-description-panel>div>h1,.program-description-panel>div>h4{color:#00b9f2}.program-description-active-panel>div>h1,.program-description-panel>div>h1{font-size:2em}.program-description-active-panel>div>h4,.program-description-panel>div>h4{font-size:1.25em}.program-description-active-panel>div>p,.program-description-active-panel>div>ul>li,.program-description-panel>div>p,.program-description-panel>div>ul>li{font-size:1em}.program-description-active-panel>div>p>a,.program-description-active-panel>div>p>strong>a,.program-description-active-panel>div>ul>li>a,.program-description-panel>div>p>a,.program-description-panel>div>p>strong>a,.program-description-panel>div>ul>li>a,.program-description-panel>div>ul>li>ul>li>a{color:#d5199b}.program-description-btn-panel{margin-top:0!important}.session-panel-numb-btn>.session-panel-arrow-icon{color:#00b9f2!important}.session-panel-numb-btn:hover>.session-panel-arrow-icon{color:#fff!important}.rejectedLaunchBtn,.rejectedLaunchBtn:hover{background-color:orange!important;border-color:orange!important;cursor:not-allowed!important}@media (min-width:992px){.mobile-program-welcome-panel,.mobileActivePanel{display:none!important}.desktop-program-welcome-panel{display:inline!important}.mobile-program-description-active-panel{display:none!important}.desktop-program-description-active-panel{display:inline!important}}.col-xs-12.col-sm-12.panel.panel-default>.panel-collapse>.panel-body{margin-bottom:50px}.session-panel-arrow-icon-container>.glyphicon.session-panel-arrow-icon.glyphicon-chevron-down,.session-panel-arrow-icon-container>.glyphicon.session-panel-arrow-icon.glyphicon-chevron-right{float:right}@media (min-width:1200px){.program-step-container{height:300px}.program-launch-container{height:301px!important}.number-circle{min-width:60px;width:60px}.view-container>div>.container{padding-left:100px!important;padding-right:100px!important}.session-panel-numb-btn>.session-panel-btn-text{padding-left:10px!important}}@media (max-width:1200px){.program-step-container{height:291px}.program-launch-container{height:292px!important}.number-circle{min-width:58px;width:58px}.session-panel-numb-btn{padding-left:10px;padding-right:10px}.session-panel-numb-btn>.session-panel-btn-text{padding-left:10px}}@media (max-width:992px){.level-bar-container{display:none}.panel-buttons{text-align:right}.program-thumb.program-thumb-my-classes{margin-bottom:8px}.program-thumb.program-thumb-my-classes>img{padding-left:20%;padding-right:20%}.session-panel-btn-text{padding-left:7%!important}.program-launch-container{padding-left:5px!important;padding-right:5px!important;margin-top:10px;height:100%!important}.sessionPanelLaunchImgIcon{height:100%!important;width:100%!important}.activePanel1,.activePanel2,.activePanel3{padding-left:5px;padding-right:5px;display:none}.session-panel-arrow-icon.panel-heading-btn-lh.glyphicon-chevron-right{padding-right:15px;float:right!important}.program-description-active-panel{min-height:0;margin-bottom:5px}.sessionPanelLaunchImgIcon>img{width:50%!important}.session-panel-numb-btn{padding-left:25px;padding-right:0}.sessionPanelImgIcon>img{margin-left:auto!important;margin-right:auto!important}.mobileActivePanel{display:inline!important;padding-left:0!important;padding-right:0!important}.program-description-level-list{padding-left:10px;padding-right:10px}.program-title-panel{margin-top:5px}.desktop-program-welcome-panel{display:none!important}.mobile-program-welcome-panel{display:inline!important}.desktop-program-description-active-panel{display:none!important}.mobile-program-description-active-panel{display:inline!important}.session-panel-arrow-icon-container>.glyphicon.session-panel-arrow-icon.glyphicon-chevron-down,.session-panel-arrow-icon-container>.glyphicon.session-panel-arrow-icon.glyphicon-chevron-right{padding-right:35px}}@media (max-width:768px){.sessionPanelLaunchImgIcon{height:auto!important;width:100%!important}.sessionPanelLaunchImgIcon>img{padding-top:10px!important;float:left}.activePanel1,.activePanel2,.activePanel3{display:none}.session-panel-btn-text{padding-left:5%!important}.program-description-level-list{padding-left:0;padding-right:0}.mobileActivePanel{display:block!important}.program-launch-container{height:100%!important;margin-top:10px}.desktop-program-welcome-panel{display:none!important}.mobile-program-welcome-panel{display:inline!important}.desktop-program-description-active-panel{display:none!important}.mobile-program-description-active-panel{display:inline!important}}@media (max-width:600px){.panel-title>a>.panel-buttons,.program-class-name-container{width:100%!important;padding-top:0!important}}@media (min-width:500px){.activeDescPanelBtn>.col-md-8,.inactiveDescPanelBtn>.col-md-8{padding-left:10px!important}}@media (max-width:500px){.activeDescPanelBtn>.col-md-2,.inactiveDescPanelBtn>.col-md-2,.inactiveDescPanelBtn>.session-panel-arrow-icon{padding-left:0!important;padding-right:0!important}.activeDescPanelBtn>.col-md-8,.inactiveDescPanelBtn>.col-md-8{padding-right:0!important;font-size:12px!important}.session-panel-arrow-icon-container>.glyphicon.session-panel-arrow-icon.glyphicon-chevron-down,.session-panel-arrow-icon-container>.glyphicon.session-panel-arrow-icon.glyphicon-chevron-right{padding-right:15px}}@media (max-width:550px){.sessionPanelLaunchImgIcon>img{width:25%!important}.sessionPanelLaunchImgIcon>div{margin-top:5%}.sessionPanelLaunchImgIcon{padding-top:20px!important;padding-bottom:25px!important}.program-launch-container{margin-top:5px!important}}@media (max-width:400px){.sessionPanelLaunchImgIcon>div{font-size:19px!important}}.blink-border{border:2px solid transparent;animation:blink .5s step-end infinite alternate}.session-panel-launch-btn{text-transform:uppercase}.fundedProjectorIcon{margin-top:0;height:33%;display:-ms-flexbox;display:flex;-ms-flex-flow:row wrap;flex-flow:row wrap;-ms-flex-pack:space-evenly;justify-content:space-evenly;-ms-flex-align:center;align-items:center}.fundedProjectorIcon>img{height:45px;margin:5px;-ms-flex:0 1 auto;flex:0 1 auto}.fundedProjectorIcon>span{-ms-flex:1 1 auto;flex:1 1 auto;font-weight:700;font-size:.9em}.fundedProjectorIcon:hover{color:#37bad5!important;background-color:#fff!important}", ""]);
	
	// exports


/***/ }),
/* 1297 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(12)();
	// imports
	
	
	// module
	exports.push([module.id, ".start-from-last-slide .modal-content h3{font-family:brandon-grotesque,Helvetica,Arial,sans-serif;padding:1em 0;margin:0}.start-from-last-slide .btn{width:100%;white-space:normal;min-height:4em;text-transform:none}", ""]);
	
	// exports


/***/ }),
/* 1298 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(12)();
	// imports
	
	
	// module
	exports.push([module.id, "html{position:relative;min-height:100%}@media (min-width:768px){body{margin-bottom:80px!important}}.footer{width:100%;padding-right:80px;min-height:50px;background-color:#0c2c3c;color:#fff;line-height:50px}@media (min-width:768px){.footer{position:absolute;bottom:0}}body>.container{padding:60px 15px 0}.footer>.container{padding-right:15px;padding-left:15px}", ""]);
	
	// exports


/***/ }),
/* 1299 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(12)();
	// imports
	
	
	// module
	exports.push([module.id, ".spectacle-deck .exit{height:100%;flex-direction:column}.spectacle-deck .exit,.spectacle-deck .exit .button-group{display:-ms-flexbox;display:flex;-ms-flex-direction:column;-ms-flex-align:center;align-items:center}.spectacle-deck .exit .button-group{flex-direction:column;-ms-flex-pack:center;justify-content:center;-ms-flex:1;flex:1;padding:.5em .5em 2em;width:100%}.spectacle-deck .exit .button-group p{text-align:center}@media (min-width:1600px){.spectacle-deck .exit .button-group p{font-size:1.4em}}.spectacle-deck .exit .btn-lg{margin:1em;min-height:1em}@media (max-width:400px){.spectacle-deck .exit .btn-sm{white-space:normal;padding:10px;line-height:13px}}.spectacle-deck .teacher-remote .exit .btn-lg,.spectacle-deck .teacher-remote .exit .btn-sm{width:auto}", ""]);
	
	// exports


/***/ }),
/* 1300 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(12)();
	// imports
	
	
	// module
	exports.push([module.id, ".spectacle-deck .fun{height:100%;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column}.spectacle-deck .fun-items{list-style:none;padding:0;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap}.spectacle-deck .fun-item{padding:0 .5em .75em;width:100%}.spectacle-deck .fun-item .fun-image{width:100%;margin:0;border-radius:2.5vw;border:2px solid #11abcd;overflow:hidden}.spectacle-deck .fun-item .fun-image img{width:100%;height:auto;margin:-1.5em 0}@media (min-width:480px){.spectacle-deck .fun-item{width:50%}}@media (min-width:768px){.spectacle-deck .fun-item{width:33.33333%}}@media (min-width:992px){.spectacle-deck .fun-item{width:25%}}.spectacle-deck .fun-item-info{font-size:182px;font-size:.6125em;line-height:1em}.spectacle-deck .fun-item-info h3{margin:.5em 0 .25em;font-size:1em;line-height:1.2em}.spectacle-deck .fun-item-info p{font-family:BrandonTextWeb,Helvetica,Arial,sans-serif}.spectacle-deck .fun-video{position:absolute;z-index:6;width:100%;height:100vh;background:#000}.spectacle-deck .fun-video .go-back{position:absolute;top:.5em;right:.5em;font-size:1.5em;z-index:11}.spectacle-deck .fun-video-remote{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column}.spectacle-deck .fun-video-remote .fun-title{text-align:center;-ms-flex:0 0 auto;flex:0 0 auto}.spectacle-deck .fun-video-remote .video-button-container{display:-ms-flexbox;display:flex;width:100%;-ms-flex-pack:center;justify-content:center;padding:.5em;-ms-flex:0 0 auto;flex:0 0 auto}.spectacle-deck .fun-video-remote .fun-description{overflow-y:auto}", ""]);
	
	// exports


/***/ }),
/* 1301 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(12)();
	// imports
	
	
	// module
	exports.push([module.id, ".spectacle-deck .deck-control-glass{position:absolute;z-index:5;width:100%}.spectacle-deck .deck-hud-toggle{position:absolute;top:32px;left:20px;z-index:1;color:hsla(0,0%,100%,.5);transition:all .75s cubic-bezier(.75,-.04,.45,1.17);-ms-flex-direction:column;flex-direction:column;-ms-flex-align:center;align-items:center}.spectacle-deck .deck-hud-toggle .deck-hud-toggle-label{text-transform:uppercase;font-size:.6em}.spectacle-deck .deck-hud-toggle img{width:60px;position:relative;z-index:2}.spectacle-deck .deck-hud-toggle:hover{color:#b4e166;text-decoration:none}.spectacle-deck .deck-hud-toggle:focus{color:inherit;text-decoration:none}.spectacle-deck .deck-hud-toggle svg{width:60px;position:relative;z-index:2}.spectacle-deck .deck-hud-toggle svg path{transition:all .75s cubic-bezier(.75,-.04,.45,1.17)}.spectacle-deck .deck-hud-toggle svg .logo-center,.spectacle-deck .deck-hud-toggle svg .logo-surround{fill:hsla(0,0%,100%,.5)}.spectacle-deck .deck-hud-toggle:hover svg .logo-center{fill:#37bad5}.spectacle-deck .deck-hud-toggle:hover svg .logo-surround{fill:#b4e166}@media (min-width:1600px){.spectacle-deck .deck-hud-toggle{transform:scale(1.2);top:40px;left:22px}}.spectacle-deck .deck-hud-logo{position:absolute;top:-74px;left:50%;width:90px;margin-left:-45px}.spectacle-deck .deck-hud-logo img{width:90px;position:relative;z-index:2}.spectacle-deck .deck-hud-logo:after{background-color:#03080c;content:\"\";display:block;height:4px;position:absolute;z-index:1;right:6px;left:6px;top:70px}.spectacle-deck .deck-hud-drawer{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;position:absolute;top:0;z-Index:6;background-color:#000;background-position:50%;background-image:linear-gradient(rgba(12,44,60,.5) 1px,transparent 0),linear-gradient(#0c2c3c 1px,transparent 0),linear-gradient(90deg,rgba(12,44,60,.5) 1px,transparent 0),linear-gradient(90deg,rgba(12,44,60,.7) 1px,transparent 0),linear-gradient(transparent 3px,#000 0,#000 73px,transparent 0),linear-gradient(90deg,rgba(12,44,60,.7) 3px,transparent 0,transparent 73px,rgba(12,44,60,.7) 0);background-size:5px 5px,75px 75px,5px 5px,75px 75px,75px 75px,75px 75px;width:100%;padding:0 0 15px;transform:translateY(-100vh);font-family:Orbitron,sans-serif}.spectacle-deck .deck-hud-drawer.on{padding:15vh 10vw}@media (max-width:767px){.spectacle-deck .deck-hud-drawer.on{padding:80px 20px 50px}}.spectacle-deck .deck-hud-drawer:after{background-color:#000;background-position:50%;background-image:linear-gradient(rgba(12,44,60,.5) 1px,transparent 0),linear-gradient(#0c2c3c 1px,transparent 0),linear-gradient(90deg,rgba(12,44,60,.5) 1px,transparent 0),linear-gradient(90deg,rgba(12,44,60,.7) 1px,transparent 0),linear-gradient(transparent 3px,#000 0,#000 73px,transparent 0),linear-gradient(90deg,rgba(12,44,60,.7) 3px,transparent 0,transparent 73px,rgba(12,44,60,.7) 0);background-size:5px 5px,75px 75px,5px 5px,75px 75px,75px 75px,75px 75px;display:block;content:\"\";position:absolute;top:0;right:0;bottom:0;left:0;opacity:0;transition:opacity .5s ease-in-out}.spectacle-deck .deck-hud-drawer.on:after{opacity:1}.spectacle-deck .deck-hud-drawer-logo{position:absolute;left:10px;bottom:10px;height:84px;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;z-index:1;margin-bottom:22px}.spectacle-deck .deck-hud-drawer-logo img{width:210px;opacity:1;transition:all .5s ease-in-out}@media screen and (max-width:959px){.spectacle-deck .deck-hud-drawer-logo img{width:180px}}@media screen and (max-width:767px){.spectacle-deck .deck-hud-drawer-logo img{width:130px}}@media screen and (max-width:599px){.spectacle-deck .deck-hud-drawer-logo img{display:none}}@media screen and (min-width:1600px){.spectacle-deck .deck-hud-drawer-logo{bottom:20px}}.spectacle-deck .on .deck-hud-drawer-logo img{opacity:0;width:0}.spectacle-deck .deck-hud-content,.spectacle-deck .teacher-remote{-ms-flex:1;flex:1}.spectacle-deck .deck-hud-content h1,.spectacle-deck .teacher-remote h1{margin:.25em 0 .75em;font-size:32px;font-size:3vw;text-align:center;text-shadow:0 0 15px #61d9f2}@media (max-width:767px){.spectacle-deck .deck-hud-content h1,.spectacle-deck .teacher-remote h1{font-size:18px;font-size:6vw}}.spectacle-deck .teacher-remote{background:#000;position:relative}.spectacle-deck .deck-hud-button{position:absolute;top:35vh;height:30vh;width:.8em;overflow-x:hidden;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;cursor:pointer;color:#fff;font-size:4.5em;font-size:6vmax}.spectacle-deck .deck-hud-button:before{margin:0 -.1em}.spectacle-deck .deck-hud-previous{left:0;-ms-flex-pack:start;justify-content:flex-start}.spectacle-deck .deck-hud-previous:hover{transform:translateX(0)!important}.spectacle-deck .deck-hud-next{right:0;-ms-flex-pack:end;justify-content:flex-end}.spectacle-deck .deck-hud-next:hover{transform:translateX(0)!important}.spectacle-deck .hud-mode-switch-enter{opacity:.01}.spectacle-deck .hud-mode-switch-enter.hud-mode-switch-enter-active{opacity:1;transition:opacity .5s ease-in}.spectacle-deck .hud-mode-switch-exit{opacity:1}.spectacle-deck .hud-mode-switch-exit.hud-mode-switch-exit-active{opacity:.01;transition:opacity .3s ease-in}.spectacle-deck .deck-hud-panel{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;height:100%;border-color:rgba(46,160,188,0);padding:15px 5% 45px;position:relative;z-index:1;margin-bottom:22px}@media (max-height:480px){.spectacle-deck .deck-hud-panel{padding-bottom:10px}}.spectacle-deck .on .deck-hud-panel{border-color:#2ea0bc}.spectacle-deck .deck-hud-content{position:relative}.spectacle-deck .deck-hud-content-transition-group>div{position:absolute;width:100%;height:100%}.spectacle-deck .deck-hud-exit{position:absolute;top:32px;right:10px}.spectacle-deck .scroller-panel{overflow-y:auto;-ms-flex:1;flex:1}.spectacle-deck .deck-hud-jump-to{position:absolute;width:100%;left:0;font-size:10px;display:-ms-flexbox;display:flex;-ms-flex-pack:end;justify-content:flex-end}.spectacle-deck .deck-hud-jump-to .deck-hud-jump-to-container{z-index:11;text-align:right}.spectacle-deck .deck-hud-jump-to .deck-hud-jump-to-container select{display:none;font-size:16px;color:#000;font-family:BrandonTextWeb,Helvetica,Arial,sans-serif}.spectacle-deck .deck-hud-jump-to .deck-hud-jump-to-container:hover select{display:block}", ""]);
	
	// exports


/***/ }),
/* 1302 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(12)();
	// imports
	
	
	// module
	exports.push([module.id, ".spectacle-deck .overview{height:100%;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column}.spectacle-deck .teacher-remote .overview{padding:2em}@media (max-width:767px){.spectacle-deck .teacher-remote .overview{padding:.5em}}.spectacle-deck .overview-levels{list-style:none;padding:0;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap}.spectacle-deck .overview-level{padding:0 .75em 1em;line-height:1em;width:33%;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column}@media (max-width:767px){.spectacle-deck .overview-level{padding:0 .5em 2em;width:50%;-ms-flex-direction:column;flex-direction:column;-ms-flex-wrap:nowrap;flex-wrap:nowrap}}@media (max-width:479px){.spectacle-deck .overview-level{padding:0 .25em 2em;-ms-flex-direction:column;flex-direction:column}}.spectacle-deck .overview-level h2{margin:.5em 0;font-size:1.2vw;line-height:1.2em}@media (max-width:767px){.spectacle-deck .overview-level h2{margin:0 0 .25em;font-size:.75em}}@media (max-width:479px){.spectacle-deck .overview-level h2{font-size:.6125em}}.spectacle-deck .overview-level.current h2,.spectacle-deck .overview-level.current h3{color:#fff}.spectacle-deck .overview-level .btn{width:100%}@media (max-width:767px){.spectacle-deck .overview-level .btn{font-size:.5em;white-space:normal;padding:.125em;-ms-flex-item-align:end;align-self:flex-end}}.spectacle-deck .overview-level-image{width:10vh;height:10vh;border-radius:1.5vw;text-align:center;margin-right:1em;margin-bottom:.5em}@media (max-width:767px){.spectacle-deck .overview-level-image{width:10vw;height:10vw}}@media (max-width:479px){.spectacle-deck .overview-level-image{width:15vw;height:15vw}}.spectacle-deck .overview-level-image img{height:106%;margin:-4%}.spectacle-deck .current .overview-level-image{border-color:#fff}.spectacle-deck .overview-level-info{-ms-flex:1;flex:1;min-width:50%}.spectacle-deck .overview-level-status{width:100%;display:-ms-flexbox;display:flex;-ms-flex-align:end;align-items:flex-end}@media (max-width:991px){.spectacle-deck .overview-level-status{-ms-flex:1;flex:1}}", ""]);
	
	// exports


/***/ }),
/* 1303 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(12)();
	// imports
	
	
	// module
	exports.push([module.id, ".spectacle-deck .deck-hud-scores{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;min-height:1px}.spectacle-deck .deck-hud-scores h1{min-height:1px}.spectacle-deck .deck-hud-scores ul{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex:1;flex:1;min-height:1px;padding:0}.spectacle-deck .deck-hud-scores ul li{min-height:1px}.spectacle-deck .deck-hud-scores .teacher-remote .deck-hud-scores{padding:1em 0}.spectacle-deck .deck-hud-scores-team{display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;-ms-flex-align:center;align-items:center;-ms-flex:1;flex:1;border-bottom:2px solid #11abcd;padding:.5em .25em;font-size:1.8em;font-size:4vh;line-height:1em}.spectacle-deck .deck-hud-scores-team:first-child{border-top:2px solid #11abcd}.spectacle-deck .deck-hud-scores-team.team-1{color:#3cca3f}.spectacle-deck .deck-hud-scores-team.team-2{color:#c57b39}.spectacle-deck .deck-hud-scores-team.team-3{color:#187bc5}.spectacle-deck .deck-hud-scores-team.team-4{color:#f8f8f8}.spectacle-deck .deck-hud-scores-team .teacher-remote .deck-hud-scores-team{border:none;font-size:4.5vh}.spectacle-deck .deck-hud-scores-score{width:2.25em;padding-top:.2em;font-size:1.25em}@media (min-width:480px){.spectacle-deck .deck-hud-scores-score{font-size:1em}}@media (min-width:768px){.spectacle-deck .deck-hud-scores-score{width:2.5em;font-size:1.5em}}.spectacle-deck .deck-hud-scores-score .teacher-remote .deck-hud-scores-score{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;font-family:Orbitron,sans-serif}.spectacle-deck .deck-hud-scores-name{display:none;-ms-flex:1;flex:1;height:2em;text-transform:uppercase;overflow:hidden;text-overflow:ellipsis}.spectacle-deck .deck-hud-scores-name:before{margin-right:.25em;margin-left:0;font-size:1.2em;width:1em;line-height:1.125em;vertical-align:middle}@media (min-width:480px){.spectacle-deck .deck-hud-scores-name:before{font-size:1.5em;line-height:.66667em}}.spectacle-deck .deck-hud-scores-name .team-name{display:none;font-size:.625em;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}@media (min-aspect-ratio:31/50){.spectacle-deck .deck-hud-scores-name .team-name{display:block}}@media (min-aspect-ratio:3/5){.spectacle-deck .deck-hud-scores-name{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center}}.spectacle-deck .teacher-remote .deck-hud-scores-name{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center}.spectacle-deck .teacher-remote .deck-hud-scores-name .team-name{font-family:Orbitron,sans-serif;-ms-flex:1;flex:1}.spectacle-deck .deck-hud-scores-btn{border-radius:50%;border-width:.075em;text-align:center;margin-left:5px}.spectacle-deck .deck-hud-scores-btn.btn-lg{padding:0;font-size:1.25em;line-height:1.7em;min-height:1.75em;min-width:1.75em}.spectacle-deck .deck-hud-scores-btn.btn-sm{padding:0;font-size:.6em;line-height:1.95em;min-height:2em;min-width:2em}.spectacle-deck .deck-hud-scores-btn .ppa-icon{display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;height:1.6em;min-height:.94em}.spectacle-deck .deck-hud-scores-btn .ppa-icon:before{margin:0}.spectacle-deck .team-1 .deck-hud-scores-btn{color:#3cca3f;border-color:#3cca3f}.spectacle-deck .team-2 .deck-hud-scores-btn{color:#c57b39;border-color:#c57b39}.spectacle-deck .team-3 .deck-hud-scores-btn{color:#187bc5;border-color:#187bc5}.spectacle-deck .team-4 .deck-hud-scores-btn{color:#f8f8f8;border-color:#f8f8f8}", ""]);
	
	// exports


/***/ }),
/* 1304 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(12)();
	// imports
	
	
	// module
	exports.push([module.id, ".spectacle-deck .teacher-remote{box-sizing:border-box;padding:10px 10px 55px;height:100%;display:-ms-flexbox;display:flex;-ms-flex:1;flex:1;-ms-flex-direction:column;flex-direction:column}@media (max-width:767px){.spectacle-deck .teacher-remote{padding-bottom:49px}}@media (max-height:480px){.spectacle-deck .teacher-remote{padding:5px 5px 33px}}@media (max-height:400px){.spectacle-deck .teacher-remote{padding:5px 5px 28px}}.spectacle-deck .teacher-remote-panel{padding:10px;margin:0}.spectacle-deck .teacher-remote-header{display:block;color:#fff;text-align:center;padding:15px 15px 0}.spectacle-deck .teacher-remote-heading{border-bottom:2px solid #37bad5;margin:-1em -1.625em .75em;padding:0 1.625em .25em;color:#b4e166;font-size:.8em}@media (max-height:480px){.spectacle-deck .teacher-remote-heading{margin:-1.75em -2.25em .5em;padding:0 2.25em .06125em;font-size:.6em}}.spectacle-deck .slideInfo{position:relative;top:50%;float:left;margin:0;line-height:1;display:inline-block;font-size:16}.spectacle-deck .teacher-remote-preview{display:none;width:100%;height:27vw;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;-ms-flex:1;flex:1}.spectacle-deck .teacher-remote-preview .spectacle-slide{overflow:hidden}.spectacle-deck .teacher-remote-thumb{display:inline-block;width:28vw;height:21vw;border:2px solid #2ea0bc;position:relative;overflow:hidden}.spectacle-deck .teacher-remote-previous{margin-right:-2px}.spectacle-deck .teacher-remote-previous,.spectacle-deck .teacher-remote-previous .spectacle-slide{border-top-left-radius:20px;border-bottom-left-radius:20px}.spectacle-deck .teacher-remote-next{margin-left:-2px}.spectacle-deck .teacher-remote-next,.spectacle-deck .teacher-remote-next .spectacle-slide{border-top-right-radius:20px;border-bottom-right-radius:20px}.spectacle-deck .teacher-remote-buttons{display:-ms-flexbox;display:flex;margin:0 auto 5px}.spectacle-deck .teacher-remote-buttons .btn-arrow{background:none;width:auto;height:1.1em;min-height:1.1em;padding:5px;border:none;font-size:16vw;line-height:1.5em;-ms-flex:1;flex:1}@media (min-width:480px){.spectacle-deck .teacher-remote-buttons .btn-arrow{font-size:4.5em}}@media (max-height:480px){.spectacle-deck .teacher-remote-buttons .btn-arrow{padding:0;font-size:18vw}}@media (max-height:400px){.spectacle-deck .teacher-remote-buttons .btn-arrow{font-size:10vw}}.spectacle-deck .teacher-remote-buttons .btn-arrow:before{margin:0}.spectacle-deck .teacher-remote-buttons .btn-arrow:focus{outline:none}.spectacle-deck .teacher-remote-buttons .btn-arrow:active{background:none}.spectacle-deck .teacher-remote-buttons .btn-group{display:-ms-flexbox;display:flex;width:auto;-ms-flex:1 1 auto;flex:1 1 auto}.spectacle-deck .teacher-remote-buttons .btn-group .btn{-ms-flex:1 1 auto;flex:1 1 auto;width:auto}.spectacle-deck .teacher-remote-btn-placeholder{-ms-flex-preferred-size:24vw;flex-basis:24vw;height:24vw;min-height:24vw;display:block}@media (min-width:480px){.spectacle-deck .teacher-remote-btn-placeholder{-ms-flex-preferred-size:120px;flex-basis:120px;height:120px;min-height:120px}}@media (max-height:480px){.spectacle-deck .teacher-remote-btn-placeholder{-ms-flex-preferred-size:18vw;flex-basis:18vw;height:18vw;min-height:18vw}}@media (max-height:400px){.spectacle-deck .teacher-remote-btn-placeholder{-ms-flex-preferred-size:10vw;flex-basis:10vw;height:10vw;min-height:10vw}}.spectacle-deck .teacher-remote-btn-placeholder img{width:100%}.spectacle-deck .teacher-remote-btn-video{font-size:10px;padding:.25em;-ms-flex-preferred-size:24vw;flex-basis:24vw;height:24vw;min-height:24vw;margin-left:5px;width:20vw}@media (min-width:480px){.spectacle-deck .teacher-remote-btn-video{-ms-flex-preferred-size:120px;flex-basis:120px;height:120px;min-height:120px;font-size:18px}}@media (max-height:480px){.spectacle-deck .teacher-remote-btn-video{-ms-flex-preferred-size:18vw;flex-basis:18vw;height:18vw;min-height:18vw;font-size:.5em;border-radius:1em}}@media (max-height:400px){.spectacle-deck .teacher-remote-btn-video{-ms-flex-preferred-size:10vw;flex-basis:10vw;height:10vw;min-height:10vw;font-size:.3em;border-radius:.5em;border-width:2px}}.spectacle-deck .teacher-remote-btn-video .glyphicon{font-size:2em;display:block;margin-bottom:.25em}@media (min-width:480px){.spectacle-deck .teacher-remote-btn-video .glyphicon{font-size:2.5em}}.spectacle-deck .teacher-remote-btn-video:focus{color:#61d9f2}.spectacle-deck .present-notes{height:100%;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex:1;flex:1;position:relative}.spectacle-deck .present-notes:after{display:block;content:\"\";height:10px;box-shadow:0 -10px 10px 5px #000;position:absolute;bottom:-10px;left:5px;right:5px}@media (max-height:400px){.spectacle-deck .present-notes:after{box-shadow:0 -5px 7px 1px #000}}.spectacle-deck .teacher-remote-notes-wrapper{-ms-flex:1;flex:1;display:-ms-flexbox;display:flex;overflow:auto;-webkit-overflow-scrolling:touch}.spectacle-deck .teacher-remote-notes{color:#fff;width:100%;height:100%;bottom:0;text-align:left;padding:.75em;font-size:.8em;min-height:-webkit-min-content}@media (max-height:568px){.spectacle-deck .teacher-remote-notes{font-size:.66667em}}@media (max-height:480px){.spectacle-deck .teacher-remote-notes{font-size:.5625em}}@media (min-width:400px){.spectacle-deck .teacher-remote-notes input{width:50%}}.spectacle-deck .teacher-remote-notes h2{margin:0;font-size:1em}.spectacle-deck .teacher-remote-notes h3{margin:0;font-size:.8em}.spectacle-deck .teacher-remote-notes h4,.spectacle-deck .teacher-remote-notes ol,.spectacle-deck .teacher-remote-notes p,.spectacle-deck .teacher-remote-notes ul{margin:0 0 1em;font-size:1.2em}.spectacle-deck .teacher-remote-notes ol,.spectacle-deck .teacher-remote-notes ul{padding-left:1.5em}.spectacle-deck .teacher-remote-notes ol ol,.spectacle-deck .teacher-remote-notes ol p,.spectacle-deck .teacher-remote-notes ul p,.spectacle-deck .teacher-remote-notes ul ul{font-size:1em}.spectacle-deck .teacher-remote-notes .btn{border-radius:1.25em;font-size:.9em;padding:1em 2em;margin:.5em 0}.spectacle-deck .teacher-remote .teacher-remote-navbar{bottom:10px}@media (max-height:480px){.spectacle-deck .teacher-remote .teacher-remote-navbar{bottom:0}}.spectacle-deck .teacher-remote-navbar{display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;padding:10px 10px 0;text-align:center;position:absolute;bottom:-5px;left:5%;right:5%;z-index:10;-ms-flex:0 0 80px;flex:0 0 80px}@media screen and (min-width:1600px){.spectacle-deck .teacher-remote-navbar{bottom:10px}}.spectacle-deck .teacher-remote-navbar .navbar-btn{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-align:center;align-items:center;width:48px;position:relative;margin:0 3%}.spectacle-deck .teacher-remote-navbar .navbar-btn:after{background:#000;content:\"\";display:block;position:absolute;top:24px;left:-2px;right:-2px;height:8px;z-index:1}@media (max-width:767px){.spectacle-deck .teacher-remote-navbar .navbar-btn:after{top:14px}}@media (max-height:400px){.spectacle-deck .teacher-remote-navbar .navbar-btn:after{transform:scale(.8);transform-origin:center;top:18px}}.spectacle-deck .teacher-remote-navbar .navbar-btn .teacher-remote .teacher-remote-navbar{width:42px}@media (max-width:767px){.spectacle-deck .teacher-remote-navbar .navbar-btn{width:42px}}@media (min-width:1600px){.spectacle-deck .teacher-remote-navbar .navbar-btn{transform:scale(1.2)}}.spectacle-deck .teacher-remote-navbar .navbar-btn .btn{-ms-flex:1 0 45px;flex:1 0 45px;min-height:0;font-size:32px;line-height:28px;z-index:2}.spectacle-deck .teacher-remote-navbar .navbar-btn .btn:focus{outline:none}.spectacle-deck .teacher-remote-navbar .navbar-btn .btn:active{background:#2ea0bc}.spectacle-deck .teacher-remote-navbar .navbar-btn .btn .glyphicon{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center}.spectacle-deck .teacher-remote-navbar .navbar-btn .btn .teacher-remote .teacher-remote-navbar .navbar-btn .btn{-ms-flex-preferred-size:42px;flex-basis:42px}@media (max-width:767px){.spectacle-deck .teacher-remote-navbar .navbar-btn .btn{-ms-flex-preferred-size:42px;flex-basis:42px}}@media (max-height:480px){.spectacle-deck .teacher-remote-navbar .navbar-btn .btn{margin:-2px 0 0}}@media (max-height:400px){.spectacle-deck .teacher-remote-navbar .navbar-btn .btn{transform:scale(.8);transform-origin:center bottom}}.spectacle-deck .teacher-remote-navbar .navbar-btn>div{color:#65d7ec;-ms-flex:1 1;flex:1 1;padding-top:3px;font-size:10px;text-transform:uppercase;white-space:nowrap}@media (max-width:767px){.spectacle-deck .teacher-remote-navbar .navbar-btn>div{font-size:8px}}@media (max-height:480px){.spectacle-deck .teacher-remote-navbar .navbar-btn>div{padding-top:2px}}.spectacle-deck .teacher-remote-navbar .navbar-btn.active>div{color:#fff;text-shadow:0 0 15px #61d9f2}.spectacle-deck .on .teacher-remote-navbar{bottom:-48px}@media (max-width:767px){.spectacle-deck .on .teacher-remote-navbar{bottom:-42px}}.spectacle-deck .btn-icon{width:48px;height:48px;border-radius:50%;border-width:2px;padding:0;box-shadow:0 0 5px #37bad5;position:relative}.spectacle-deck .btn-icon .teacher-remote .btn-icon{width:42px;height:42px}@media (max-width:767px){.spectacle-deck .btn-icon{width:42px;height:42px}}.spectacle-deck .btn-icon:hover{color:#fff}.spectacle-deck .btn-icon.active{background-color:#37bad5;color:#000;box-shadow:0 0 15px #61d9f2,inset 0 0 25px #bff0fa}.spectacle-deck .btn-icon [class*=\" ppa-icon-\"]:before,.spectacle-deck .btn-icon [class^=ppa-icon-]:before{margin:0}.spectacle-deck .teacher-remote-switch-enter{opacity:.01}.spectacle-deck .teacher-remote-switch-enter.teacher-remote-switch-enter-active{opacity:1;transition:opacity .5s ease-in}.spectacle-deck .teacher-remote-switch-exit{opacity:1}.spectacle-deck .teacher-remote-switch-exit.teacher-remote-switch-exit-active{opacity:.01;transition:opacity .3s ease-in}.spectacle-deck .teacher-remote-panel{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;height:100%}.spectacle-deck .teacher-remote-content{position:relative}.spectacle-deck .teacher-remote-content-transition-group{position:relative;width:100%;height:100%}.spectacle-deck .teacher-remote-content-transition-group>div{position:absolute;width:100%;height:100%}", ""]);
	
	// exports


/***/ }),
/* 1305 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(12)();
	// imports
	
	
	// module
	exports.push([module.id, ".invite{text-align:center}@media (min-width:768px){.invite{text-align:left}}.invite>div{margin-bottom:2em}.invite .error{color:red}.invite .invite-header{font-size:2em}.invite .invite-header img{max-width:0}@media (min-width:768px){.invite .invite-header{padding-left:50px;padding-right:50px}.invite .invite-header>div{padding:0;text-align:right}.invite .invite-header>div:first-child{text-align:left}.invite .invite-header img{max-width:80%}}@media (min-width:992px){.invite .invite-header{font-size:2.7em;padding-left:100px;padding-right:100px}.invite .invite-header>div:first-child{padding:1.63em 0}}@media (min-width:768px){.invite .invite-howto{padding-left:50px;padding-right:50px}}@media (min-width:992px){.invite .invite-howto{padding-left:100px;padding-right:100px}}.invite .invite-howto>div{padding:0}.invite .invite-howto>div>div{padding:0 5px 0 0;font-size:1.5em;text-align:left}.invite .invite-howto>div>div>img{max-width:100%}.invite .invite-mixed{background-color:#fff;border:1px solid #61d9f2;border-radius:15px}.invite .invite-mixed>div:first-child{margin-top:50px}.invite .invite-mixed>div:last-child>div:last-child{margin-bottom:50px}.invite .invite-mixed>div>hr{margin:38px 200px!important}.invite .invite-mixed>div{padding:0 5px}@media (min-width:768px){.invite .invite-mixed>div{padding:0 50px}.invite .invite-mixed>div>div{padding:0 25px}}.invite .invite-mixed>div>div:first-child{margin-bottom:25px}.invite .invite-mixed>div>div.error{padding:0}.invite .invite-mixed .invite-featuredProgram{font-size:2em}@media (min-width:992px){.invite .invite-mixed .invite-featuredProgram{padding-left:100px;padding-right:100px}.invite .invite-mixed .invite-featuredProgram>div{padding-left:50px;padding-right:50px}}.invite .invite-mixed .invite-featuredProgram>div:first-child{line-height:45px;padding-right:0;margin:0}.invite .invite-mixed .invite-featuredProgram>div>small{font-size:.5em;display:block;margin-top:-20px;white-space:nowrap}.invite .invite-mixed .invite-email{font-size:2.5em;text-align:center}.invite .invite-mixed .invite-email .sent p:last-child{font-size:.65em}.invite .invite-mixed .invite-email #emails{border:1px solid #000}.invite .invite-mixed .invite-email .invite-email-btn-container>button{min-width:100%}@media (min-width:768px){.invite .invite-mixed .invite-email .invite-email-btn-container{padding-top:.75em}}.invite .invite-mixed .invite-social{font-size:2.5em;text-align:center}.invite .invite-mixed .invite-social .messenger-share-btn{display:block;width:100%;margin-right:10px;border-color:#0084ff;background-color:#0084ff;color:#fff;border-radius:4px;font-size:16px;min-height:1em;text-transform:none}.invite .invite-mixed .invite-social .messenger-share-btn:hover{border-color:#2495ff;background-color:#2495ff}.invite .invite-mixed .invite-social .messenger-share-btn>img{position:absolute;left:60px;top:13px;height:24px}@media (max-width:767px){.invite .invite-mixed .invite-social .messenger-share-btn>img{left:30px}}.invite .invite-mixed .invite-social .facebook-share-btn{display:block;width:100%;margin-right:10px;border-color:#3b5998;background-color:#3b5998;color:#fff;border-radius:4px;font-size:16px;min-height:1em;text-transform:none}.invite .invite-mixed .invite-social .facebook-share-btn:hover{border-color:#4568b2;background-color:#4568b2}.invite .invite-mixed .invite-social .facebook-share-btn>img{position:absolute;left:60px;top:13px;height:24px}@media (max-width:767px){.invite .invite-mixed .invite-social .facebook-share-btn>img{left:30px}}.invite .invite-mixed .invite-social .twitter-share-btn{display:block;width:100%;border-color:#1b95e0;background-color:#1b95e0;color:#fff;border-radius:4px;font-size:16px;min-height:1em;text-transform:none}.invite .invite-mixed .invite-social .twitter-share-btn:hover{border-color:#0c7abf;background-color:#0c7abf}.invite .invite-mixed .invite-social .twitter-share-btn>img{position:absolute;left:60px;top:13px;height:24px}@media (max-width:767px){.invite .invite-mixed .invite-social .twitter-share-btn>img{left:30px}}.invite .invite-mixed .invite-diy{text-align:center;font-size:2.5em}.invite .invite-mixed .invite-diy>div:nth-child(3){line-height:45px;margin-bottom:1em}@media (max-width:991px){.invite{padding:0 10px}.invite .invite-header>div:first-child{padding-top:1.4em}.invite .invite-featuredProgram{padding:0}.invite .invite-mixed>div>hr{margin:38px 15%!important}}@media (max-width:767px){.invite{padding:0 10px}.invite>div>div>div{padding-bottom:10px}.invite .invite-featuredProgram{padding:0}.invite .invite-mixed>div>hr{margin:38px 25%!important}.invite .invite-header>div:last-child{line-height:25px}}", ""]);
	
	// exports


/***/ }),
/* 1306 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(12)();
	// imports
	
	
	// module
	exports.push([module.id, ".dark{background-color:#000;background-position:50%;background-image:linear-gradient(rgba(12,44,60,.5) 1px,transparent 0),linear-gradient(#0c2c3c 1px,transparent 0),linear-gradient(90deg,rgba(12,44,60,.5) 1px,transparent 0),linear-gradient(90deg,rgba(12,44,60,.7) 1px,transparent 0),linear-gradient(transparent 3px,#000 0,#000 73px,transparent 0),linear-gradient(90deg,rgba(12,44,60,.7) 3px,transparent 0,transparent 73px,rgba(12,44,60,.7) 0);background-size:5px 5px,75px 75px,5px 5px,75px 75px,75px 75px,75px 75px;color:#fff}.dark .home-landing{padding:15px}.dark .buttons{width:100%}@media (min-width:400px){.dark .register-btn{margin-right:10px}}.dark a.btn.btn-primary.active,.dark a.btn.btn-primary.active:focus,.dark a.btn.btn-primary.active:hover,.dark a.btn.btn-primary:active:focus,.dark a.btn.btn-primary:active:hover,.dark a.btn.btn-primary:focus,.dark a.btn.btn-primary:hover,.dark a.btn.btn-success{background-color:#000}.dark a.btn.btn-success.active,.dark a.btn.btn-success.active:focus,.dark a.btn.btn-success.active:hover,.dark a.btn.btn-success:active:focus,.dark a.btn.btn-success:active:hover,.dark a.btn.btn-success:focus,.dark a.btn.btn-success:hover{color:#fff;background-color:#11abcd;border-color:#11abcd;box-shadow:0 0 10px #11abcd}.view-container>div>.container{padding-left:15px!important;padding-right:15px!important}@media (min-width:1200px){.container.home-landing{margin-left:-100px!important}}@media (max-width:768px){.container.home-landing{padding-bottom:75px!important}}", ""]);
	
	// exports


/***/ }),
/* 1307 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(12)();
	// imports
	
	
	// module
	exports.push([module.id, ".navbar.logged-out a.active.btn{display:none}.navbar .navbar-nav li a.active{color:#abd561!important}a#nav-dropdown>span>span.caret{display:none!important}.hamburger-menu.dropdown>a#nav-dropdown{padding-top:25px!important}.hamburger-menu.open.dropdown>a#nav-dropdown{background-color:transparent!important}.nav.navbar-nav.navbar-right.col-xs-2{float:right}.nav.navbar-nav.navbar-right.col-xs-2.mobileXs{padding-right:25%!important}.nav.navbar-nav.navbar-right.col-xs-1{float:right}.nav.navbar-nav.navbar-right.col-xs-1.mobileXs{padding-right:25%!important}.glyphicon.glyphicon-menu-hamburger{font-size:36px!important}@media (max-width:768px){.hamburger-menu.open>ul.dropdown-menu{transform:translateX(-22%)!important}}@media (max-width:400px){.hamburger-menu.open>ul.dropdown-menu{transform:translateX(-48%)!important}}@media (min-width:769px){.hamburger-menu.open>ul.dropdown-menu{transform:translateX(0)!important}}.mobileNav{padding-left:0!important;padding-right:0!important}.mobileNavLogo{padding-left:5%!important;padding-right:0!important}.navbar-page-header{background-color:#00b9f2;color:#fff;font-size:28px;text-align:center;margin-bottom:10px;padding-top:5px}.navbar-container{padding-left:0;padding-right:0}", ""]);
	
	// exports


/***/ }),
/* 1308 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(12)();
	// imports
	
	
	// module
	exports.push([module.id, ".complete-level{text-align:center}.complete-level .modal-content,.complete-level .modal-content h3{font-family:brandon-grotesque,Helvetica,Arial,sans-serif}.complete-level .btn{width:100%;white-space:normal;min-height:4em;text-transform:none}", ""]);
	
	// exports


/***/ }),
/* 1309 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(12)();
	// imports
	
	
	// module
	exports.push([module.id, ".hacked input:-ms-input-placeholder,.teacher-remote .hacked-remote input:-ms-input-placeholder{font-size:.45em}.hacked input::placeholder,.teacher-remote .hacked-remote input::placeholder{font-size:.45em}", ""]);
	
	// exports


/***/ }),
/* 1310 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(12)();
	// imports
	
	
	// module
	exports.push([module.id, ".teacher-remote .mission-report{padding-bottom:2em;overflow-y:auto;counter-reset:missioncounter}.teacher-remote .mission-report .question-group-wrapper{margin:0 0 .5em}.teacher-remote .mission-report .question-group-error{color:red;font-size:.8em;line-height:.8em}.teacher-remote .mission-report .question-group{margin:0;display:-ms-flexbox;display:flex;-ms-flex-flow:wrap;flex-flow:wrap;-ms-flex-direction:row;flex-direction:row;-ms-flex-align:center;align-items:center}.teacher-remote .mission-report .question-group label{-ms-flex:1;flex:1;font-size:1em;font-weight:400;text-align:left;padding:0}.teacher-remote .mission-report .question-group input{width:4em;font-size:1em}.teacher-remote .mission-report .question-group:before{content:counter(missioncounter) \".\";counter-increment:missioncounter 1;display:block;width:1.25em;font-size:1.5em;line-height:1.2em;text-align:left;font-weight:700}.teacher-remote .mission-report .fake-button-group{display:none}", ""]);
	
	// exports


/***/ }),
/* 1311 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(12)();
	// imports
	
	
	// module
	exports.push([module.id, ".onboarding{z-index:1000;position:absolute;left:0;top:0;width:100%;height:100vh;background-color:transparent;display:-ms-flexbox;display:flex}.modal-dialog.onboarding-modal .modal-header{text-transform:uppercase}.modal-dialog.onboarding-modal .modal-header.empty-title{text-align:center}.onboarding>div{-ms-flex-align:stretch;align-items:stretch;width:100%;height:100%}.onboarding>div>div.modal-dialog{position:relative;width:420px;padding:10px;margin-left:auto;margin-right:auto;top:50%;transform:translateY(-60%)}.onboarding>div>svg{position:absolute;top:0;left:0;width:100%;height:100vh;background-color:transparent;fill:#fff;stroke:#b4e166}", ""]);
	
	// exports


/***/ }),
/* 1312 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(12)();
	// imports
	
	
	// module
	exports.push([module.id, ".select-configuration{overflow-y:auto}.spectacle-content .select-configuration{margin:0 10vw}.select-configuration h1{text-align:center;margin-bottom:5vh}.select-configuration .select-btn-container{display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-ms-flex-direction:column;flex-direction:column}@media (min-width:480px){.select-configuration .select-btn-container{-ms-flex-direction:row;flex-direction:row;-ms-flex-wrap:nowrap;flex-wrap:nowrap}}.select-configuration .select-btn-container .btn{-ms-flex:1;flex:1;margin:.25em;padding:.5em .5em 1em;white-space:normal;transition:background-color .25s ease-in-out;font-size:1.125em;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-pack:start;justify-content:flex-start;-ms-flex-align:center;align-items:center}@media (min-width:480px){.select-configuration .select-btn-container .btn{height:50vh;padding:.5em;font-size:1.25em}}@media (min-width:992px){.select-configuration .select-btn-container .btn{height:60vh;padding:1em;font-size:1em}}.select-configuration .select-btn-container .btn h3{margin:.5em 0;font-size:1.25em}@media (min-width:480px){.select-configuration .select-btn-container .btn h3{margin:1em 0}}.select-configuration .select-btn-container .btn .icons{margin:1em 0}@media (min-width:992px){.select-configuration .select-btn-container .btn .icons{margin-bottom:1.5em}}.select-configuration .select-btn-container .btn .description{-ms-flex:1;flex:1;font-family:BrandonTextWeb,Helvetica,Arial,sans-serif;color:#fff;font-size:1em}.select-configuration .select-btn-container .btn .desktopSvg{width:25%;margin:0 2%}@media (min-width:480px){.select-configuration .select-btn-container .btn .desktopSvg{width:30%}}.select-configuration .select-btn-container .btn .mobileSvg{width:20%;margin:0 2%}@media (min-width:480px){.select-configuration .select-btn-container .btn .mobileSvg{width:24%}}.select-configuration .select-btn-container .btn .screenSvg{width:30%;margin:0 2%}@media (min-width:480px){.select-configuration .select-btn-container .btn .screenSvg{width:40%}}.select-configuration .select-btn-container .btn .remoteSvg{width:12.15%;margin:0 2%}@media (min-width:480px){.select-configuration .select-btn-container .btn .remoteSvg{width:16.2%}}.select-configuration .select-btn-container .btn .checkmark{font-size:3em;display:none}@media (min-width:480px){.select-configuration .select-btn-container .btn .checkmark{display:block}}.select-configuration .select-btn-container .btn:active,.select-configuration .select-btn-container .btn:hover{background-color:#37bad5}.select-configuration .select-btn-container .btn:active .description,.select-configuration .select-btn-container .btn:active .glyphicon:before,.select-configuration .select-btn-container .btn:active h3,.select-configuration .select-btn-container .btn:hover .description,.select-configuration .select-btn-container .btn:hover .glyphicon:before,.select-configuration .select-btn-container .btn:hover h3{color:#fff;text-shadow:0 0 5px rgba(0,0,0,.2)}.select-configuration .select-btn-container .btn.active{background-color:#9fd93b;border-color:#b4e166;color:#fff}.select-configuration .select-btn-container .btn.active .description,.select-configuration .select-btn-container .btn.active .glyphicon:before,.select-configuration .select-btn-container .btn.active h3{color:#fff;text-shadow:0 0 5px rgba(0,0,0,.2)}button.btn.btn-lg.button.dualScreenBtn,button.btn.btn-lg.button.singleScreenBtn{border-color:#37bad5!important}", ""]);
	
	// exports


/***/ }),
/* 1313 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(12)();
	// imports
	
	
	// module
	exports.push([module.id, ".spectacle-deck.start-from-last-slide{text-align:center}.spectacle-deck.start-from-last-slide .modal-content h3{font-family:brandon-grotesque,Helvetica,Arial,sans-serif;padding:1em 0;margin:0}.spectacle-deck.start-from-last-slide .btn{width:100%;white-space:normal;min-height:4em;text-transform:none}", ""]);
	
	// exports


/***/ }),
/* 1314 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(12)();
	// imports
	
	
	// module
	exports.push([module.id, ".spectacle-deck>div>div>div>div>div>.start-level-container{margin:5vw 15vw;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center}.spectacle-deck>div>div>div>div>div>.start-level-container h1{margin:0;color:#61d9f2;font-size:20vw;line-height:.8em;letter-spacing:normal;-ms-flex:1;flex:1}.spectacle-deck>div>div>div>div>div>.start-level-container p{font-size:2vw;text-transform:uppercase}.spectacle-deck>div>div>div>div>div>.start-level-container .btn{margin-right:10px}@media (max-width:400px){.spectacle-deck>div>div>div>div>div>.start-level-container .btn{white-space:normal;line-height:20px;padding:17px}}", ""]);
	
	// exports


/***/ }),
/* 1315 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(12)();
	// imports
	
	
	// module
	exports.push([module.id, ".teacher-remote .team-names{margin:0}@media (min-width:768px){.teacher-remote .team-names{margin:0 2em}}.teacher-remote .form-group{display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap}.teacher-remote .form-group label{padding-top:.25em;-ms-flex-preferred-size:100%;flex-basis:100%}.teacher-remote .form-group label i{float:right}@media (min-width:768px){.teacher-remote .form-group label{-ms-flex-preferred-size:5em;flex-basis:5em}}.teacher-remote .form-group .form-control{-ms-flex:4;flex:4;height:3em;padding:.25em 1em}@media (max-height:480px){.teacher-remote .form-group .form-control{height:2em;margin-bottom:0}}", ""]);
	
	// exports


/***/ }),
/* 1316 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(12)();
	// imports
	
	
	// module
	exports.push([module.id, ".deck-hud-button{transition-property:transform,color,opacity;transition-duration:.25s;transition-timing-function:ease-in}.deck-hud-button:hover{color:#fff}", ""]);
	
	// exports


/***/ }),
/* 1317 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(12)();
	// imports
	
	
	// module
	exports.push([module.id, ".assign-contracts{-webkit-user-select:initial}.assign-contracts .form-horizontal .control-label{padding-top:0}.assign-contracts .inline-btn{margin:0}a>h4.adminPageTitle{cursor:pointer}h4.adminPageTitle.selected{text-decoration:underline}.unapproved-users-list-enter{opacity:.01}.unapproved-users-list-enter.unapproved-users-list-enter-active{opacity:1;transition:opacity .5s ease-in}.unapproved-users-list-leave{opacity:1;max-height:auto}.unapproved-users-list-leave.unapproved-users-list-leave-active{opacity:.01;max-height:1000px;transition:opacity 1s ease-in,max-height 1s ease-in}.unapproved-session-list-enter{opacity:.01}.unapproved-session-list-enter.unapproved-session-list-enter-active{opacity:1;transition:opacity .5s ease-in}.unapproved-session-list-leave{opacity:1;max-height:600px}.unapproved-session-list-leave.unapproved-session-list-leave-active{opacity:.01;max-height:0;transition:opacity 1s ease-in,max-height 1s ease-in}.staff h3{color:#abd561}.staff-actions-btn>button{clear:both}", ""]);
	
	// exports


/***/ }),
/* 1318 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(12)();
	// imports
	
	
	// module
	exports.push([module.id, ".sessionFinder .well{padding:19px 0 0}.sessionFinder .col-sm-6{line-height:50px}.userFinder .well{padding:19px 0 0}.userFinder .col-sm-6{line-height:50px}", ""]);
	
	// exports


/***/ }),
/* 1319 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(12)();
	// imports
	
	
	// module
	exports.push([module.id, ".approval-buttons{width:100%}", ""]);
	
	// exports


/***/ }),
/* 1320 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(12)();
	// imports
	
	
	// module
	exports.push([module.id, ".subscribe{text-align:center;padding:10px 0}.subscribe .error{color:red}.subscribe .waiting .spinnerWrapper{left:50%;width:40px;height:40px;overflow:hidden;position:relative;margin-left:-20px}.subscribe .waiting .spinnerWrapper .blackSpinner>div{background-color:#000!important}.subscribe .optIns{max-width:400px;margin-left:auto;margin-right:auto;text-align:left}.subscribe .optIns .btn-container{margin:10px 0;text-align:center}.subscribe .optIns .btn-container .saved{font-size:20px;font-weight:700}", ""]);
	
	// exports


/***/ }),
/* 1321 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(12)();
	// imports
	
	
	// module
	exports.push([module.id, ".subscribed{text-align:center}.subscribed .error{color:red}", ""]);
	
	// exports


/***/ }),
/* 1322 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(12)();
	// imports
	
	
	// module
	exports.push([module.id, ".unsubscribe{text-align:center;padding:10px 0}.unsubscribe .error{color:red}.unsubscribe .waiting .spinnerWrapper{left:50%;width:40px;height:40px;overflow:hidden;position:relative;margin-left:-20px}.unsubscribe .waiting .spinnerWrapper .blackSpinner>div{background-color:#000!important}.unsubscribe .optIns{max-width:400px;margin-left:auto;margin-right:auto;text-align:left}.unsubscribe .optIns .btn-container{margin:10px 0;text-align:center}.unsubscribe .optIns .btn-container .saved{font-size:20px;font-weight:700}", ""]);
	
	// exports


/***/ }),
/* 1323 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(12)();
	// imports
	
	
	// module
	exports.push([module.id, ".unsubscribed{text-align:center}.unsubscribed .error{color:red}", ""]);
	
	// exports


/***/ }),
/* 1324 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(12)();
	// imports
	
	
	// module
	exports.push([module.id, ".m-calendar{display:inline-block}.m-calendar table{width:100%;border-collapse:collapse;border-spacing:0;table-layout:fixed}.m-calendar td{padding:8px 0;text-align:center;cursor:pointer;color:#dfe0e4;border:1px solid #dfe0e4}.m-calendar thead td{color:#1385e5;font-size:11px;font-weight:700;text-transform:uppercase;font-size:12px}.m-calendar tbody td{color:#666}.m-calendar tbody td:hover{background:#1385e5;border-color:#1385e5;color:#fff}.m-calendar .current-day{color:#1385e5;font-weight:700}.m-calendar .next-month,.m-calendar .prev-month{color:#999}.m-calendar .toolbar{line-height:30px;color:#1385e5;text-align:center;margin-bottom:13px}.m-calendar .toolbar button{position:relative;width:30px;height:30px;line-height:30px;color:#fff;border:1px solid #1385e5;border-radius:50%;background:#1385e5;font-size:20px;padding:0;text-align:center;outline:0;z-index:5;cursor:pointer}.m-calendar .toolbar .prev-month{float:left}.m-calendar .toolbar .next-month{float:right}.m-calendar .toolbar .current-date{color:#1385e5}.m-time{color:#fff;padding-top:50px}.m-time .showtime{text-align:center}.m-time .separater{display:inline-block;font-size:32px;font-weight:700;color:#1385e5;width:32px;height:65px;line-height:65px;text-align:center}.m-time .time-text{position:relative;left:-10px;font-size:15px;color:#1385e5;margin-top:7px;margin-bottom:10px}.m-time .sliders{padding:0 10px}.m-time .time{width:65px;height:65px;font-size:38px;line-height:65px;background-color:#1385e5;text-align:center}.m-time .time,.u-slider-time{display:inline-block;border-radius:3px}.u-slider-time{position:relative;background-color:#dfe0e4;height:4px;width:100%;cursor:pointer}.u-slider-time .value{position:absolute;background-color:#1385e5;border-radius:3px;top:0;height:100%}.u-slider-time .handle{position:absolute;width:4px;height:4px}.u-slider-time .handle:after{position:relative;display:block;content:\"\";top:-10px;left:-12px;width:24px;height:24px;background-color:#fff;border:3px solid #1385e5;border-radius:50%;cursor:pointer}.im-btn{display:inline-block;background-color:#fff;border:0;outline:0;cursor:pointer;line-height:1}.im-btn:before{margin-right:6px}.m-input-moment{display:inline-block;width:330px;padding:12px 15px;border-radius:3px;border:1px solid #dfe0e4}.m-input-moment .options{width:100%;display:inline-block;margin-bottom:4px}.m-input-moment .options button{float:left;width:50%;color:#1385e5;text-align:center;font-size:16px;padding:7px;border:1px solid #1385e5;border-radius:3px}.m-input-moment .options button:first-child{border-top-right-radius:0;border-bottom-right-radius:0}.m-input-moment .options button:last-child{border-top-left-radius:0;border-bottom-left-radius:0}.m-input-moment .options button.is-active{color:#fff;background-color:#1385e5}.m-input-moment .tab{display:none;height:310px}.m-input-moment .tab.is-active{display:block}.m-input-moment .tabs{margin-bottom:11px}.m-input-moment .btn-save{display:block;margin-top:10px;width:100%;background-color:#1385e5;padding:12px 0;text-align:center;color:#fff;font-size:16px;border-radius:3px}", ""]);
	
	// exports


/***/ }),
/* 1325 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(12)();
	// imports
	
	
	// module
	exports.push([module.id, "/*! normalize.css v3.0.3 | MIT License | github.com/necolas/normalize.css */html{font-family:sans-serif;-ms-text-size-adjust:100%;-webkit-text-size-adjust:100%}body{margin:0}article,aside,details,figcaption,figure,footer,header,hgroup,main,menu,nav,section,summary{display:block}audio,canvas,progress,video{display:inline-block;vertical-align:baseline}audio:not([controls]){display:none;height:0}[hidden],template{display:none}a{background-color:transparent}a:active,a:hover{outline:0}abbr[title]{border-bottom:1px dotted}b,strong{font-weight:700}dfn{font-style:italic}h1{font-size:2em;margin:.67em 0}mark{background:#ff0;color:#000}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sup{top:-.5em}sub{bottom:-.25em}img{border:0}svg:not(:root){overflow:hidden}figure{margin:1em 40px}hr{box-sizing:content-box;height:0}pre{overflow:auto}code,kbd,pre,samp{font-family:monospace,monospace;font-size:1em}button,input,optgroup,select,textarea{color:inherit;font:inherit;margin:0}button{overflow:visible}button,select{text-transform:none}button,html input[type=button],input[type=reset],input[type=submit]{-webkit-appearance:button;cursor:pointer}button[disabled],html input[disabled]{cursor:default}button::-moz-focus-inner,input::-moz-focus-inner{border:0;padding:0}input{line-height:normal}input[type=checkbox],input[type=radio]{box-sizing:border-box;padding:0}input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{height:auto}input[type=search]{-webkit-appearance:textfield;box-sizing:content-box}input[type=search]::-webkit-search-cancel-button,input[type=search]::-webkit-search-decoration{-webkit-appearance:none}fieldset{border:1px solid silver;margin:0 2px;padding:.35em .625em .75em}legend{border:0;padding:0}textarea{overflow:auto}optgroup{font-weight:700}table{border-collapse:collapse;border-spacing:0}td,th{padding:0}", ""]);
	
	// exports


/***/ }),
/* 1326 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * This is the web browser implementation of `debug()`.
	 *
	 * Expose `debug()` as the module.
	 */
	
	exports = module.exports = __webpack_require__(1327);
	exports.log = log;
	exports.formatArgs = formatArgs;
	exports.save = save;
	exports.load = load;
	exports.useColors = useColors;
	exports.storage = 'undefined' != typeof chrome
	               && 'undefined' != typeof chrome.storage
	                  ? chrome.storage.local
	                  : localstorage();
	
	/**
	 * Colors.
	 */
	
	exports.colors = [
	  'lightseagreen',
	  'forestgreen',
	  'goldenrod',
	  'dodgerblue',
	  'darkorchid',
	  'crimson'
	];
	
	/**
	 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
	 * and the Firebug extension (any Firefox version) are known
	 * to support "%c" CSS customizations.
	 *
	 * TODO: add a `localStorage` variable to explicitly enable/disable colors
	 */
	
	function useColors() {
	  // NB: In an Electron preload script, document will be defined but not fully
	  // initialized. Since we know we're in Chrome, we'll just detect this case
	  // explicitly
	  if (typeof window !== 'undefined' && window.process && window.process.type === 'renderer') {
	    return true;
	  }
	
	  // is webkit? http://stackoverflow.com/a/16459606/376773
	  // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
	  return (typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance) ||
	    // is firebug? http://stackoverflow.com/a/398120/376773
	    (typeof window !== 'undefined' && window.console && (window.console.firebug || (window.console.exception && window.console.table))) ||
	    // is firefox >= v31?
	    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
	    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31) ||
	    // double check webkit in userAgent just in case we are in a worker
	    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/));
	}
	
	/**
	 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
	 */
	
	exports.formatters.j = function(v) {
	  try {
	    return JSON.stringify(v);
	  } catch (err) {
	    return '[UnexpectedJSONParseError]: ' + err.message;
	  }
	};
	
	
	/**
	 * Colorize log arguments if enabled.
	 *
	 * @api public
	 */
	
	function formatArgs(args) {
	  var useColors = this.useColors;
	
	  args[0] = (useColors ? '%c' : '')
	    + this.namespace
	    + (useColors ? ' %c' : ' ')
	    + args[0]
	    + (useColors ? '%c ' : ' ')
	    + '+' + exports.humanize(this.diff);
	
	  if (!useColors) return;
	
	  var c = 'color: ' + this.color;
	  args.splice(1, 0, c, 'color: inherit')
	
	  // the final "%c" is somewhat tricky, because there could be other
	  // arguments passed either before or after the %c, so we need to
	  // figure out the correct index to insert the CSS into
	  var index = 0;
	  var lastC = 0;
	  args[0].replace(/%[a-zA-Z%]/g, function(match) {
	    if ('%%' === match) return;
	    index++;
	    if ('%c' === match) {
	      // we only are interested in the *last* %c
	      // (the user may have provided their own)
	      lastC = index;
	    }
	  });
	
	  args.splice(lastC, 0, c);
	}
	
	/**
	 * Invokes `console.log()` when available.
	 * No-op when `console.log` is not a "function".
	 *
	 * @api public
	 */
	
	function log() {
	  // this hackery is required for IE8/9, where
	  // the `console.log` function doesn't have 'apply'
	  return 'object' === typeof console
	    && console.log
	    && Function.prototype.apply.call(console.log, console, arguments);
	}
	
	/**
	 * Save `namespaces`.
	 *
	 * @param {String} namespaces
	 * @api private
	 */
	
	function save(namespaces) {
	  try {
	    if (null == namespaces) {
	      exports.storage.removeItem('debug');
	    } else {
	      exports.storage.debug = namespaces;
	    }
	  } catch(e) {}
	}
	
	/**
	 * Load `namespaces`.
	 *
	 * @return {String} returns the previously persisted debug modes
	 * @api private
	 */
	
	function load() {
	  var r;
	  try {
	    r = exports.storage.debug;
	  } catch(e) {}
	
	  // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
	  if (!r && typeof process !== 'undefined' && 'env' in process) {
	    r = ({"NODE_ENV":"production"}).DEBUG;
	  }
	
	  return r;
	}
	
	/**
	 * Enable namespaces listed in `localStorage.debug` initially.
	 */
	
	exports.enable(load());
	
	/**
	 * Localstorage attempts to return the localstorage.
	 *
	 * This is necessary because safari throws
	 * when a user disables cookies/localstorage
	 * and you attempt to access it.
	 *
	 * @return {LocalStorage}
	 * @api private
	 */
	
	function localstorage() {
	  try {
	    return window.localStorage;
	  } catch (e) {}
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(47)))

/***/ }),
/* 1327 */
/***/ (function(module, exports, __webpack_require__) {

	
	/**
	 * This is the common logic for both the Node.js and web browser
	 * implementations of `debug()`.
	 *
	 * Expose `debug()` as the module.
	 */
	
	exports = module.exports = createDebug.debug = createDebug['default'] = createDebug;
	exports.coerce = coerce;
	exports.disable = disable;
	exports.enable = enable;
	exports.enabled = enabled;
	exports.humanize = __webpack_require__(1487);
	
	/**
	 * The currently active debug mode names, and names to skip.
	 */
	
	exports.names = [];
	exports.skips = [];
	
	/**
	 * Map of special "%n" handling functions, for the debug "format" argument.
	 *
	 * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
	 */
	
	exports.formatters = {};
	
	/**
	 * Previous log timestamp.
	 */
	
	var prevTime;
	
	/**
	 * Select a color.
	 * @param {String} namespace
	 * @return {Number}
	 * @api private
	 */
	
	function selectColor(namespace) {
	  var hash = 0, i;
	
	  for (i in namespace) {
	    hash  = ((hash << 5) - hash) + namespace.charCodeAt(i);
	    hash |= 0; // Convert to 32bit integer
	  }
	
	  return exports.colors[Math.abs(hash) % exports.colors.length];
	}
	
	/**
	 * Create a debugger with the given `namespace`.
	 *
	 * @param {String} namespace
	 * @return {Function}
	 * @api public
	 */
	
	function createDebug(namespace) {
	
	  function debug() {
	    // disabled?
	    if (!debug.enabled) return;
	
	    var self = debug;
	
	    // set `diff` timestamp
	    var curr = +new Date();
	    var ms = curr - (prevTime || curr);
	    self.diff = ms;
	    self.prev = prevTime;
	    self.curr = curr;
	    prevTime = curr;
	
	    // turn the `arguments` into a proper Array
	    var args = new Array(arguments.length);
	    for (var i = 0; i < args.length; i++) {
	      args[i] = arguments[i];
	    }
	
	    args[0] = exports.coerce(args[0]);
	
	    if ('string' !== typeof args[0]) {
	      // anything else let's inspect with %O
	      args.unshift('%O');
	    }
	
	    // apply any `formatters` transformations
	    var index = 0;
	    args[0] = args[0].replace(/%([a-zA-Z%])/g, function(match, format) {
	      // if we encounter an escaped % then don't increase the array index
	      if (match === '%%') return match;
	      index++;
	      var formatter = exports.formatters[format];
	      if ('function' === typeof formatter) {
	        var val = args[index];
	        match = formatter.call(self, val);
	
	        // now we need to remove `args[index]` since it's inlined in the `format`
	        args.splice(index, 1);
	        index--;
	      }
	      return match;
	    });
	
	    // apply env-specific formatting (colors, etc.)
	    exports.formatArgs.call(self, args);
	
	    var logFn = debug.log || exports.log || console.log.bind(console);
	    logFn.apply(self, args);
	  }
	
	  debug.namespace = namespace;
	  debug.enabled = exports.enabled(namespace);
	  debug.useColors = exports.useColors();
	  debug.color = selectColor(namespace);
	
	  // env-specific initialization logic for debug instances
	  if ('function' === typeof exports.init) {
	    exports.init(debug);
	  }
	
	  return debug;
	}
	
	/**
	 * Enables a debug mode by namespaces. This can include modes
	 * separated by a colon and wildcards.
	 *
	 * @param {String} namespaces
	 * @api public
	 */
	
	function enable(namespaces) {
	  exports.save(namespaces);
	
	  exports.names = [];
	  exports.skips = [];
	
	  var split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
	  var len = split.length;
	
	  for (var i = 0; i < len; i++) {
	    if (!split[i]) continue; // ignore empty strings
	    namespaces = split[i].replace(/\*/g, '.*?');
	    if (namespaces[0] === '-') {
	      exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
	    } else {
	      exports.names.push(new RegExp('^' + namespaces + '$'));
	    }
	  }
	}
	
	/**
	 * Disable debug output.
	 *
	 * @api public
	 */
	
	function disable() {
	  exports.enable('');
	}
	
	/**
	 * Returns true if the given mode name is enabled, false otherwise.
	 *
	 * @param {String} name
	 * @return {Boolean}
	 * @api public
	 */
	
	function enabled(name) {
	  var i, len;
	  for (i = 0, len = exports.skips.length; i < len; i++) {
	    if (exports.skips[i].test(name)) {
	      return false;
	    }
	  }
	  for (i = 0, len = exports.names.length; i < len; i++) {
	    if (exports.names[i].test(name)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	/**
	 * Coerce `val`.
	 *
	 * @param {Mixed} val
	 * @return {Mixed}
	 * @api private
	 */
	
	function coerce(val) {
	  if (val instanceof Error) return val.stack || val.message;
	  return val;
	}


/***/ }),
/* 1328 */,
/* 1329 */,
/* 1330 */,
/* 1331 */,
/* 1332 */,
/* 1333 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * Dependencies.
	 */
	
	var repeat = __webpack_require__(401);
	
	/*
	 * Constants.
	 */
	
	var TAB = '\t';
	var NEWLINE = '\n';
	var SPACE = ' ';
	
	/**
	 * Replace tabs with spaces, being smart about which
	 * column the tab is at and which size should be used.
	 *
	 * @example
	 *   detab('\tfoo\nbar\tbaz'); // '    foo\nbar baz'
	 *   detab('\tfoo\nbar\tbaz', 2); // '  foo\nbar baz'
	 *   detab('\tfoo\nbar\tbaz', 8); // '        foo\nbar     baz'
	 *
	 * @param {string} value - Value with tabs.
	 * @param {number?} [size=4] - Tab-size.
	 * @return {string} - Value without tabs.
	 */
	function detab(value, size) {
	    var string = typeof value === 'string';
	    var length = string && value.length;
	    var index = -1;
	    var column = -1;
	    var tabSize = size || 4;
	    var result = '';
	    var character;
	    var add;
	
	    if (!string) {
	        throw new Error('detab expected string');
	    }
	
	    while (++index < length) {
	        character = value.charAt(index);
	
	        if (character === TAB) {
	            add = tabSize - ((column + 1) % tabSize);
	            result += repeat(SPACE, add);
	            column += add;
	            continue;
	        }
	
	        if (character === NEWLINE) {
	            column = -1;
	        } else {
	            column++;
	        }
	
	        result += character;
	    }
	
	    return result;
	}
	
	/*
	 * Expose.
	 */
	
	module.exports = detab;


/***/ }),
/* 1334 */,
/* 1335 */,
/* 1336 */,
/* 1337 */,
/* 1338 */,
/* 1339 */,
/* 1340 */,
/* 1341 */,
/* 1342 */,
/* 1343 */,
/* 1344 */,
/* 1345 */,
/* 1346 */
/***/ (function(module, exports) {

	/**
	 * Gets all attributes of an element as a plain JavaScriot object.
	 * @param {Element} element The element whose attributes to get.
	 * @return {Object} An object whose keys are the attribute keys and whose
	 *     values are the attribute values. If no attributes exist, an empty
	 *     object is returned.
	 */
	module.exports = function getAttributes(element) {
	  var attrs = {};
	
	  // Validate input.
	  if (!(element && element.nodeType == 1)) return attrs;
	
	  // Return an empty object if there are no attributes.
	  var map = element.attributes;
	  if (map.length === 0) return {};
	
	  for (var i = 0, attr; attr = map[i]; i++) {
	    attrs[attr.name] = attr.value;
	  }
	  return attrs;
	};


/***/ }),
/* 1347 */,
/* 1348 */,
/* 1349 */,
/* 1350 */,
/* 1351 */,
/* 1352 */,
/* 1353 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule CSSCore
	 * @typechecks
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(15);
	
	/**
	 * The CSSCore module specifies the API (and implements most of the methods)
	 * that should be used when dealing with the display of elements (via their
	 * CSS classes and visibility on screen. It is an API focused on mutating the
	 * display and not reading it as no logical state should be encoded in the
	 * display of elements.
	 */
	
	var CSSCore = {
	
	  /**
	   * Adds the class passed in to the element if it doesn't already have it.
	   *
	   * @param {DOMElement} element the element to set the class on
	   * @param {string} className the CSS className
	   * @return {DOMElement} the element passed in
	   */
	  addClass: function (element, className) {
	    !!/\s/.test(className) ?  false ? invariant(false, 'CSSCore.addClass takes only a single class name. "%s" contains ' + 'multiple classes.', className) : invariant(false) : undefined;
	
	    if (className) {
	      if (element.classList) {
	        element.classList.add(className);
	      } else if (!CSSCore.hasClass(element, className)) {
	        element.className = element.className + ' ' + className;
	      }
	    }
	    return element;
	  },
	
	  /**
	   * Removes the class passed in from the element
	   *
	   * @param {DOMElement} element the element to set the class on
	   * @param {string} className the CSS className
	   * @return {DOMElement} the element passed in
	   */
	  removeClass: function (element, className) {
	    !!/\s/.test(className) ?  false ? invariant(false, 'CSSCore.removeClass takes only a single class name. "%s" contains ' + 'multiple classes.', className) : invariant(false) : undefined;
	
	    if (className) {
	      if (element.classList) {
	        element.classList.remove(className);
	      } else if (CSSCore.hasClass(element, className)) {
	        element.className = element.className.replace(new RegExp('(^|\\s)' + className + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ') // multiple spaces to one
	        .replace(/^\s*|\s*$/g, ''); // trim the ends
	      }
	    }
	    return element;
	  },
	
	  /**
	   * Helper to add or remove a class from an element based on a condition.
	   *
	   * @param {DOMElement} element the element to set the class on
	   * @param {string} className the CSS className
	   * @param {*} bool condition to whether to add or remove the class
	   * @return {DOMElement} the element passed in
	   */
	  conditionClass: function (element, className, bool) {
	    return (bool ? CSSCore.addClass : CSSCore.removeClass)(element, className);
	  },
	
	  /**
	   * Tests whether the element has the class specified.
	   *
	   * @param {DOMNode|DOMWindow} element the element to set the class on
	   * @param {string} className the CSS className
	   * @return {boolean} true if the element has the class, false if not
	   */
	  hasClass: function (element, className) {
	    !!/\s/.test(className) ?  false ? invariant(false, 'CSS.hasClass takes only a single class name.') : invariant(false) : undefined;
	    if (element.classList) {
	      return !!className && element.classList.contains(className);
	    }
	    return (' ' + element.className + ' ').indexOf(' ' + className + ' ') > -1;
	  }
	
	};
	
	module.exports = CSSCore;

/***/ }),
/* 1354 */,
/* 1355 */,
/* 1356 */,
/* 1357 */,
/* 1358 */,
/* 1359 */,
/* 1360 */,
/* 1361 */,
/* 1362 */,
/* 1363 */,
/* 1364 */,
/* 1365 */,
/* 1366 */,
/* 1367 */,
/* 1368 */,
/* 1369 */,
/* 1370 */,
/* 1371 */,
/* 1372 */,
/* 1373 */,
/* 1374 */,
/* 1375 */,
/* 1376 */,
/* 1377 */,
/* 1378 */,
/* 1379 */,
/* 1380 */,
/* 1381 */,
/* 1382 */,
/* 1383 */,
/* 1384 */,
/* 1385 */,
/* 1386 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1388);


/***/ }),
/* 1387 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _moment = __webpack_require__(10);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(11);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _range = __webpack_require__(1407);
	
	var _range2 = _interopRequireDefault(_range);
	
	var _chunk = __webpack_require__(1400);
	
	var _chunk2 = _interopRequireDefault(_chunk);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Day = function Day(_ref) {
	  var i = _ref.i,
	      w = _ref.w,
	      d = _ref.d,
	      className = _ref.className,
	      props = _objectWithoutProperties(_ref, ['i', 'w', 'd', 'className']);
	
	  var prevMonth = w === 0 && i > 7;
	  var nextMonth = w >= 4 && i <= 14;
	  var cls = (0, _classnames2.default)({
	    'prev-month': prevMonth,
	    'next-month': nextMonth,
	    'current-day': !prevMonth && !nextMonth && i === d
	  });
	
	  return _react2.default.createElement(
	    'td',
	    _extends({ className: cls }, props),
	    i
	  );
	};
	
	var Calendar = function (_Component) {
	  _inherits(Calendar, _Component);
	
	  function Calendar() {
	    var _ref2;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Calendar);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = Calendar.__proto__ || Object.getPrototypeOf(Calendar)).call.apply(_ref2, [this].concat(args))), _this), _this.selectDate = function (i, w) {
	      var prevMonth = w === 0 && i > 7;
	      var nextMonth = w >= 4 && i <= 14;
	      var m = _this.props.moment;
	
	      if (prevMonth) m.subtract(1, 'month');
	      if (nextMonth) m.add(1, 'month');
	
	      m.date(i);
	
	      _this.props.onChange(m);
	    }, _this.prevMonth = function (e) {
	      e.preventDefault();
	      _this.props.onChange(_this.props.moment.subtract(1, 'month'));
	    }, _this.nextMonth = function (e) {
	      e.preventDefault();
	      _this.props.onChange(_this.props.moment.add(1, 'month'));
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Calendar, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var m = this.props.moment;
	      var d = m.date();
	      var d1 = m.clone().subtract(1, 'month').endOf('month').date();
	      var d2 = m.clone().date(1).day();
	      var d3 = m.clone().endOf('month').date();
	      var days = [].concat((0, _range2.default)(d1 - d2 + 1, d1 + 1), (0, _range2.default)(1, d3 + 1), (0, _range2.default)(1, 42 - d3 - d2 + 1));
	      var weeks = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('m-calendar', this.props.className) },
	        _react2.default.createElement(
	          'div',
	          { className: 'toolbar' },
	          _react2.default.createElement(
	            'button',
	            { type: 'button', className: 'prev-month', onClick: this.prevMonth },
	            _react2.default.createElement('i', { className: this.props.prevMonthIcon })
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'current-date' },
	            m.format('MMMM YYYY')
	          ),
	          _react2.default.createElement(
	            'button',
	            { type: 'button', className: 'next-month', onClick: this.nextMonth },
	            _react2.default.createElement('i', { className: this.props.nextMonthIcon })
	          )
	        ),
	        _react2.default.createElement(
	          'table',
	          null,
	          _react2.default.createElement(
	            'thead',
	            null,
	            _react2.default.createElement(
	              'tr',
	              null,
	              weeks.map(function (w, i) {
	                return _react2.default.createElement(
	                  'td',
	                  { key: i },
	                  w
	                );
	              })
	            )
	          ),
	          _react2.default.createElement(
	            'tbody',
	            null,
	            (0, _chunk2.default)(days, 7).map(function (row, w) {
	              return _react2.default.createElement(
	                'tr',
	                { key: w },
	                row.map(function (i) {
	                  return _react2.default.createElement(Day, {
	                    key: i,
	                    i: i,
	                    d: d,
	                    w: w,
	                    onClick: function onClick() {
	                      return _this2.selectDate(i, w);
	                    }
	                  });
	                })
	              );
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return Calendar;
	}(_react.Component);
	
	exports.default = Calendar;

/***/ }),
/* 1388 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__(11);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _moment = __webpack_require__(10);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _calendar = __webpack_require__(1387);
	
	var _calendar2 = _interopRequireDefault(_calendar);
	
	var _time = __webpack_require__(1389);
	
	var _time2 = _interopRequireDefault(_time);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var InputMoment = function (_Component) {
	  _inherits(InputMoment, _Component);
	
	  function InputMoment() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, InputMoment);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = InputMoment.__proto__ || Object.getPrototypeOf(InputMoment)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      tab: 0
	    }, _this.handleClickTab = function (e, tab) {
	      e.preventDefault();
	      _this.setState({ tab: tab });
	    }, _this.handleSave = function (e) {
	      e.preventDefault();
	      if (_this.props.onSave) _this.props.onSave();
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(InputMoment, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var tab = this.state.tab;
	
	      var _props = this.props,
	          m = _props.moment,
	          className = _props.className,
	          prevMonthIcon = _props.prevMonthIcon,
	          nextMonthIcon = _props.nextMonthIcon,
	          minStep = _props.minStep,
	          hourStep = _props.hourStep,
	          onSave = _props.onSave,
	          props = _objectWithoutProperties(_props, ['moment', 'className', 'prevMonthIcon', 'nextMonthIcon', 'minStep', 'hourStep', 'onSave']);
	
	      var cls = (0, _classnames2.default)('m-input-moment', className);
	
	      return _react2.default.createElement(
	        'div',
	        _extends({ className: cls }, props),
	        _react2.default.createElement(
	          'div',
	          { className: 'options' },
	          _react2.default.createElement(
	            'button',
	            {
	              type: 'button',
	              className: (0, _classnames2.default)('ion-calendar im-btn', { 'is-active': tab === 0 }),
	              onClick: function onClick(e) {
	                return _this2.handleClickTab(e, 0);
	              }
	            },
	            'Date'
	          ),
	          _react2.default.createElement(
	            'button',
	            {
	              type: 'button',
	              className: (0, _classnames2.default)('ion-clock im-btn', { 'is-active': tab === 1 }),
	              onClick: function onClick(e) {
	                return _this2.handleClickTab(e, 1);
	              }
	            },
	            'Time'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'tabs' },
	          _react2.default.createElement(_calendar2.default, {
	            className: (0, _classnames2.default)('tab', { 'is-active': tab === 0 }),
	            moment: m,
	            onChange: this.props.onChange,
	            prevMonthIcon: this.props.prevMonthIcon,
	            nextMonthIcon: this.props.nextMonthIcon
	          }),
	          _react2.default.createElement(_time2.default, {
	            className: (0, _classnames2.default)('tab', { 'is-active': tab === 1 }),
	            moment: m,
	            minStep: this.props.minStep,
	            hourStep: this.props.hourStep,
	            onChange: this.props.onChange
	          })
	        ),
	        this.props.onSave ? _react2.default.createElement(
	          'button',
	          {
	            type: 'button',
	            className: 'im-btn btn-save ion-checkmark',
	            onClick: this.handleSave
	          },
	          'Save'
	        ) : null
	      );
	    }
	  }]);
	
	  return InputMoment;
	}(_react.Component);
	
	InputMoment.defaultProps = {
	  prevMonthIcon: 'ion-ios-arrow-left',
	  nextMonthIcon: 'ion-ios-arrow-right',
	  minStep: 1,
	  hourStep: 1
	};
	exports.default = InputMoment;

/***/ }),
/* 1389 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__(11);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactInputSlider = __webpack_require__(1923);
	
	var _reactInputSlider2 = _interopRequireDefault(_reactInputSlider);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _class = function (_Component) {
	  _inherits(_class, _Component);
	
	  function _class() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, _class);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = _class.__proto__ || Object.getPrototypeOf(_class)).call.apply(_ref, [this].concat(args))), _this), _this.changeHours = function (pos) {
	      var m = _this.props.moment;
	      m.hours(pos.x);
	      _this.props.onChange(m);
	    }, _this.changeMinutes = function (pos) {
	      var m = _this.props.moment;
	      m.minutes(pos.x);
	      _this.props.onChange(m);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(_class, [{
	    key: 'render',
	    value: function render() {
	      var m = this.props.moment;
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('m-time', this.props.className) },
	        _react2.default.createElement(
	          'div',
	          { className: 'showtime' },
	          _react2.default.createElement(
	            'span',
	            { className: 'time' },
	            m.format('HH')
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'separater' },
	            ':'
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'time' },
	            m.format('mm')
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'sliders' },
	          _react2.default.createElement(
	            'div',
	            { className: 'time-text' },
	            'Hours:'
	          ),
	          _react2.default.createElement(_reactInputSlider2.default, {
	            className: 'u-slider-time',
	            xmin: 0,
	            xmax: 23,
	            xstep: this.props.hourStep,
	            x: m.hour(),
	            onChange: this.changeHours
	          }),
	          _react2.default.createElement(
	            'div',
	            { className: 'time-text' },
	            'Minutes:'
	          ),
	          _react2.default.createElement(_reactInputSlider2.default, {
	            className: 'u-slider-time',
	            xmin: 0,
	            xmax: 59,
	            xstep: this.props.minStep,
	            x: m.minute(),
	            onChange: this.changeMinutes
	          })
	        )
	      );
	    }
	  }]);
	
	  return _class;
	}(_react.Component);
	
	exports.default = _class;

/***/ }),
/* 1390 */
/***/ (function(module, exports) {

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeCeil = Math.ceil,
	    nativeMax = Math.max;
	
	/**
	 * The base implementation of `_.range` and `_.rangeRight` which doesn't
	 * coerce arguments.
	 *
	 * @private
	 * @param {number} start The start of the range.
	 * @param {number} end The end of the range.
	 * @param {number} step The value to increment or decrement by.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Array} Returns the range of numbers.
	 */
	function baseRange(start, end, step, fromRight) {
	  var index = -1,
	      length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
	      result = Array(length);
	
	  while (length--) {
	    result[fromRight ? length : ++index] = start;
	    start += step;
	  }
	  return result;
	}
	
	module.exports = baseRange;


/***/ }),
/* 1391 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.slice` without an iteratee call guard.
	 *
	 * @private
	 * @param {Array} array The array to slice.
	 * @param {number} [start=0] The start position.
	 * @param {number} [end=array.length] The end position.
	 * @returns {Array} Returns the slice of `array`.
	 */
	function baseSlice(array, start, end) {
	  var index = -1,
	      length = array.length;
	
	  if (start < 0) {
	    start = -start > length ? 0 : (length + start);
	  }
	  end = end > length ? length : end;
	  if (end < 0) {
	    end += length;
	  }
	  length = start > end ? 0 : ((end - start) >>> 0);
	  start >>>= 0;
	
	  var result = Array(length);
	  while (++index < length) {
	    result[index] = array[index + start];
	  }
	  return result;
	}
	
	module.exports = baseSlice;


/***/ }),
/* 1392 */
/***/ (function(module, exports, __webpack_require__) {

	var trimmedEndIndex = __webpack_require__(1399);
	
	/** Used to match leading whitespace. */
	var reTrimStart = /^\s+/;
	
	/**
	 * The base implementation of `_.trim`.
	 *
	 * @private
	 * @param {string} string The string to trim.
	 * @returns {string} Returns the trimmed string.
	 */
	function baseTrim(string) {
	  return string
	    ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
	    : string;
	}
	
	module.exports = baseTrim;


/***/ }),
/* 1393 */
/***/ (function(module, exports, __webpack_require__) {

	var baseRange = __webpack_require__(1390),
	    isIterateeCall = __webpack_require__(544),
	    toFinite = __webpack_require__(545);
	
	/**
	 * Creates a `_.range` or `_.rangeRight` function.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new range function.
	 */
	function createRange(fromRight) {
	  return function(start, end, step) {
	    if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
	      end = step = undefined;
	    }
	    // Ensure the sign of `-0` is preserved.
	    start = toFinite(start);
	    if (end === undefined) {
	      end = start;
	      start = 0;
	    } else {
	      end = toFinite(end);
	    }
	    step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
	    return baseRange(start, end, step, fromRight);
	  };
	}
	
	module.exports = createRange;


/***/ }),
/* 1394 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	module.exports = freeGlobal;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1395 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(542);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	module.exports = getRawTag;


/***/ }),
/* 1396 */
/***/ (function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  var type = typeof value;
	  length = length == null ? MAX_SAFE_INTEGER : length;
	
	  return !!length &&
	    (type == 'number' ||
	      (type != 'symbol' && reIsUint.test(value))) &&
	        (value > -1 && value % 1 == 0 && value < length);
	}
	
	module.exports = isIndex;


/***/ }),
/* 1397 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	module.exports = objectToString;


/***/ }),
/* 1398 */
/***/ (function(module, exports, __webpack_require__) {

	var freeGlobal = __webpack_require__(1394);
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	module.exports = root;


/***/ }),
/* 1399 */
/***/ (function(module, exports) {

	/** Used to match a single whitespace character. */
	var reWhitespace = /\s/;
	
	/**
	 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
	 * character of `string`.
	 *
	 * @private
	 * @param {string} string The string to inspect.
	 * @returns {number} Returns the index of the last non-whitespace character.
	 */
	function trimmedEndIndex(string) {
	  var index = string.length;
	
	  while (index-- && reWhitespace.test(string.charAt(index))) {}
	  return index;
	}
	
	module.exports = trimmedEndIndex;


/***/ }),
/* 1400 */
/***/ (function(module, exports, __webpack_require__) {

	var baseSlice = __webpack_require__(1391),
	    isIterateeCall = __webpack_require__(544),
	    toInteger = __webpack_require__(1408);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeCeil = Math.ceil,
	    nativeMax = Math.max;
	
	/**
	 * Creates an array of elements split into groups the length of `size`.
	 * If `array` can't be split evenly, the final chunk will be the remaining
	 * elements.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Array
	 * @param {Array} array The array to process.
	 * @param {number} [size=1] The length of each chunk
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	 * @returns {Array} Returns the new array of chunks.
	 * @example
	 *
	 * _.chunk(['a', 'b', 'c', 'd'], 2);
	 * // => [['a', 'b'], ['c', 'd']]
	 *
	 * _.chunk(['a', 'b', 'c', 'd'], 3);
	 * // => [['a', 'b', 'c'], ['d']]
	 */
	function chunk(array, size, guard) {
	  if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
	    size = 1;
	  } else {
	    size = nativeMax(toInteger(size), 0);
	  }
	  var length = array == null ? 0 : array.length;
	  if (!length || size < 1) {
	    return [];
	  }
	  var index = 0,
	      resIndex = 0,
	      result = Array(nativeCeil(length / size));
	
	  while (index < length) {
	    result[resIndex++] = baseSlice(array, index, (index += size));
	  }
	  return result;
	}
	
	module.exports = chunk;


/***/ }),
/* 1401 */
/***/ (function(module, exports) {

	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	module.exports = eq;


/***/ }),
/* 1402 */
/***/ (function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(1403),
	    isLength = __webpack_require__(1404);
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	module.exports = isArrayLike;


/***/ }),
/* 1403 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(543),
	    isObject = __webpack_require__(337);
	
	/** `Object#toString` result references. */
	var asyncTag = '[object AsyncFunction]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    proxyTag = '[object Proxy]';
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  if (!isObject(value)) {
	    return false;
	  }
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 9 which returns 'object' for typed arrays and other constructors.
	  var tag = baseGetTag(value);
	  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	}
	
	module.exports = isFunction;


/***/ }),
/* 1404 */
/***/ (function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	module.exports = isLength;


/***/ }),
/* 1405 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ }),
/* 1406 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(543),
	    isObjectLike = __webpack_require__(1405);
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && baseGetTag(value) == symbolTag);
	}
	
	module.exports = isSymbol;


/***/ }),
/* 1407 */
/***/ (function(module, exports, __webpack_require__) {

	var createRange = __webpack_require__(1393);
	
	/**
	 * Creates an array of numbers (positive and/or negative) progressing from
	 * `start` up to, but not including, `end`. A step of `-1` is used if a negative
	 * `start` is specified without an `end` or `step`. If `end` is not specified,
	 * it's set to `start` with `start` then set to `0`.
	 *
	 * **Note:** JavaScript follows the IEEE-754 standard for resolving
	 * floating-point values which can produce unexpected results.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {number} [start=0] The start of the range.
	 * @param {number} end The end of the range.
	 * @param {number} [step=1] The value to increment or decrement by.
	 * @returns {Array} Returns the range of numbers.
	 * @see _.inRange, _.rangeRight
	 * @example
	 *
	 * _.range(4);
	 * // => [0, 1, 2, 3]
	 *
	 * _.range(-4);
	 * // => [0, -1, -2, -3]
	 *
	 * _.range(1, 5);
	 * // => [1, 2, 3, 4]
	 *
	 * _.range(0, 20, 5);
	 * // => [0, 5, 10, 15]
	 *
	 * _.range(0, -4, -1);
	 * // => [0, -1, -2, -3]
	 *
	 * _.range(1, 4, 0);
	 * // => [1, 1, 1]
	 *
	 * _.range(0);
	 * // => []
	 */
	var range = createRange();
	
	module.exports = range;


/***/ }),
/* 1408 */
/***/ (function(module, exports, __webpack_require__) {

	var toFinite = __webpack_require__(545);
	
	/**
	 * Converts `value` to an integer.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted integer.
	 * @example
	 *
	 * _.toInteger(3.2);
	 * // => 3
	 *
	 * _.toInteger(Number.MIN_VALUE);
	 * // => 0
	 *
	 * _.toInteger(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toInteger('3.2');
	 * // => 3
	 */
	function toInteger(value) {
	  var result = toFinite(value),
	      remainder = result % 1;
	
	  return result === result ? (remainder ? result - remainder : result) : 0;
	}
	
	module.exports = toInteger;


/***/ }),
/* 1409 */
/***/ (function(module, exports, __webpack_require__) {

	var baseTrim = __webpack_require__(1392),
	    isObject = __webpack_require__(337),
	    isSymbol = __webpack_require__(1406);
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = baseTrim(value);
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = toNumber;


/***/ }),
/* 1410 */,
/* 1411 */,
/* 1412 */
/***/ (function(module, exports, __webpack_require__) {

	(function(root) {
	  'use strict';
	
	  function isNumeric(v) {
	    if (typeof v === 'number' && !isNaN(v)) return true;
	    v = (v||'').toString().trim();
	    if (!v) return false;
	    return !isNaN(v);
	  }
	
	  if (true) {
	    if (typeof module !== 'undefined' && module.exports) {
	      exports = module.exports = isNumeric;
	    }
	    exports.isNumeric = isNumeric;
	  } else if (typeof define === 'function' && define.amd) {
	    define([], function() {
	      return isNumeric;
	    });
	  } else {
	    root.isNumeric = isNumeric;
	  }
	
	})(this);


/***/ }),
/* 1413 */,
/* 1414 */,
/* 1415 */
/***/ (function(module, exports) {

	module.exports = {"Question ${} of ${}:":"Question $0 de $1 :","Level":"Niveau","Name your teams!":"Donnez un nom à votre équipe!","Mission Report:":"Rapport de mission :","Game show completed":"Jeu complété","Level ${} game show completed":"Le jeu-questionnaire du Niveau $0 est terminé!","Levels Completed":"Niveaux complétés","Progress":"Progression","Program":"Programme","Program:":"Programme :","Pick a program":"Choisir un programme","Learn about programs":"Découvrir les programmes","Choose a program":"Choisir un programme","Language":"Langue","Grade":"Année","Class/Division Name or #":"Classe/Division ou numéro","# of Students":"Nombre d'élèves","Top Tip!":"Top Conseil!","The program is designed to be used with one classroom at a time.":"Le programme est conçu pour être utilisé avec une classe à la fois.","Want to use it in multiple classrooms?":"Voulez-vous l'utiliser dans plusieurs classes?","Add additional classes from the Programs page so that your progress and team points are saved separately for each class!":"Ajoutez des classes supplémentaires à partir de la page Programmes afin que votre progression et vos points d'équipe soient enregistrés séparément pour chaque classe!","Edit class details":"Modifier les détails de la classe","Add a class":"Ajouter une classe","Save":"Enregister","Add Class":"Ajouter la classe","Archive class?":"Archiver la classe?","Division:":"Division","Warning!":"Attention!","You can't undo this action.":"Vous ne pouvez pas annuler cette action.","Cancel":"Annuler","Archive":"Archiver","Modules":"Modules","Teacher Resources":"Ressources pédagogiques","Printables":"Matériel à imprimer","Class/Division":"Classe/Division","Class/Division:":"Classe/Division :","Program Overview":"Vue d'ensemble du programme","Access Expired":"Accès expiré","Access Pending":"Accès en attente","Buy To Unlock":"Acheter pour débloquer","Re-Enter":"Recommencer","Start Module ${}":"Lancer le module $0","Resume from where you left off?":"Souhaitez-vous reprendre là où vous vous êtes arrêté?","Yes, take me to the last slide I was on":"Oui, je souhaite retourner à la dernière diapositive où j'étais","No, I want to start from the beginning of the level":"Non, je veux recommencer depuis le début du niveau","Start Level ${}":"Lancer le niveau $0","Exit Session?":"Quitter la session","Yes, exit to DASHBOARD":"Oui, retour au tableau de bord","No, back to presentation":"Non, retour à la présentation","Go Back":"Retourner","Scores":"Pointages","Extras":"Extras","Menu":"Menu","Exit":"Sortir","Notes":"Notes","Previous":"Précédent","Next":"Suivant","Level ${}":"Niveau $0","In Progress":"En Cours","Skip to Level":"Passer au niveau","Back to Level":"Retour au niveau","Restricted":"Limité","Team Scoreboard":"Tableau de bord de l'équipe","Click to Complete Level":"Cliquez pour terminer le niveau","Proceed to the next level?":"Passer au niveau suivant?","All levels completed! Mark as done?":"Tous les niveaux terminés! Marque comme Terminé?","takes effect on the next launch":"prend effet au prochain lancement","Yes, all done!":"Oui, tout est fait!","Completed Level ${}":"Niveau $0 terminé","Yes, I just finished this Level with my class! Continue on to Level ${}":"Oui, je viens de terminer ce niveau avec ma classe! Continuez jusqu'au niveau $0","No, I was just previewing the content. Exit and stay on Level ${}":"Non, je ne faisais que prévisualiser le contenu. Quitter et rester au niveau $0","Exit Session":"Sortir de la session","Unhacked Screen":"Écran non-hacké","This will be hacked in ${} seconds.":"Ce sera piraté dans $0 secondes.","Sum of questions ${} must be the same or less than the number of Apprentices in Q1":"La somme des questions $0 doit être plus petit ou égale au nombre d'apprenti(e)s rapporté à la Q1","Welcome Training Agent!":"Bienvenue agent en formation!","Let's spend 30 seconds orienting you to the platform!":"Passons 30 secondes à vous orienter sur la plateforme!","Click on MENU to open up the Heads Up Display menu.":"Cliquez sur MENU pour ouvrir le menu Affichage Heads Up.","Click on SCORES to check out the Scoreboard. Your class will be divided into four teams and will compete for points!":"Cliquez sur POINTAGE pour consulter le tableau de bord. Votre classe sera divisée en quatre équipes et se disputera des points!","Click on EXTRAS for bonus resources for more learning and laughter!":"Cliquez sur EXTRAS pour des ressources de bonus pour plus d'apprentissage et de rire!","Click on MODULES for an overview of all the levels in the program. You'll unlock levels as you progress!":"Cliquez sur MODULES pour avoir un aperçu de tous les niveaux du programme. Vous débloquerez des niveaux à mesure que vous progresserez!","Click on EXIT to leave the presentation and go back to the DASHBOARD page any time.":"Cliquez sur QUITTER pour quitter la présentation et revenir à la page Tableau de bord à tout moment.","Click HIDE to close the Heads Up Display and get back to the action!":"Cliquez sur Masquer pour fermer l'affichage Heads Up et revenir à l'action!","Almost there!":"Presque là!","You can progress through the slides in 3 ways:":"Vous pouvez progresser dans les diapositives de 3 manières:","Use the arrow(s) as highlighted":"Utilisez les flèches comme surligné","Use the left/right keys on your keyboard":"Utilisez les touches gauche / droite de votre clavier","Use your Remote Control if you have it set up!":"Utilisez votre télécommande si vous l'avez configurée!","Let's Go!":"Allons-y!","No Thanks":"Non Merci","Great, I'm all trained up!":"Génial, je suis tout entraîné!","Select Configuration":"Choisir la Configuration","Dual Screen":"Deux Écrans","Classroom Display + Remote":"Affichage en Classe + Télécommande","Single Screen":"Un seul Écran","Classroom Display Only":"Affiche en Classe seulement","Select Role of This Device":"Choisir le rôle de cet appareil","Classroom Display":"Affichage en Classe","Remote Control":"Télécommande","No, I want to start from the beginning of the module":"Non, je veux commencer depuis le début du module","Ready!":"Prêt!","You are cleared for takeoff, everything is ready to go!":"Vous êtes autorisé à commencer, tout est prêt!","Back to Dashboard":"Retour au tableau de bord","Earth":"Terre","(Pick an Earth-related team name)":"(Choisissez un nom d'équipe lié à la Terre)","Fire":"Feu","(Pick a Fire-related team name)":"(Choisissez un nom d'équipe lié au Feu)","Water":"Eau","(Pick a Water-related team name)":"(Choisissez un nom d'équipe lié à l'Eau)","Air":"Air","(Pick an Air-related team name)":"(Choisissez un nom d'équipe lié à l'Air)","Replay":"Rejouer","Play":"Jouer","Pause":"Pause","Rwd":"Rec","Fwd":"Ava","Loading...":"Chargement...","Unable to load class data":"Impossible de charger les données de classe","Exit to Programs":"Quitter vers les programmes","Please fill out the Mission Report, as it helps us share the impact of the program with our funders!":"Veuillez remplir le rapport de mission, car il nous aide à partager l'impact du programme avec nos bailleurs de fonds!","OK":"OK","I'm just previewing":"Je ne fais que prévisualiser","You've finished":"Vous avez terminé","level ${} of 1":"$0 des 1 niveaux","level ${} of 2":"$0 des 2 niveaux","level ${} of 3":"$0 des 3 niveaux","level ${} of 4":"$0 des 4 niveaux","level ${} of 5":"$0 des 5 niveaux","level ${} of 6":"$0 des 6 niveaux","Multiple choice, see next slide":"Multiple choix, voir prochaine diapo","Preview of next slide/answer":"Aperçu de la prochaine diapo/réponse","Answer ${} of ${}":"Réponse $0 de $1","All levels completed":"Tous les niveaux sont terminés","Level ${} Finished":"Niveau $0 Complété","Hide":"Cacher","Set Up Presentation":"Configurer la présentation","By adding your class, you agree to receive occasional emails with tips from a real human to help you get started!":"En ajoutant votre classe, vous acceptez de recevoir des courriels occasionnels provenant d’une vraie personne pour vous aider à vous lancer.","Welcome":"Bienvenue","#${}:":"#$0 :","Level ${}:":"Niveau $0 :","Mission ${}:<br/> ${}":"Mission $0 :<br/> $1","You must report a number":"Vous devez inscrire un nombre","Numbers reported must be the same or less than the total number of Apprentices in Q1":"Le nombre inscrit doit être plus petit ou égale au nombre d'apprenti(e)s rapporté à la Q1","Please tell us the total number of Apprentices reporting in Q1":"SVP faites-nous savoir le nombre d'apprenti(e)s qui font leur rapport à la Q1"}

/***/ }),
/* 1416 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Module dependencies
	 */
	
	var debug = __webpack_require__(1326)('jsonp');
	
	/**
	 * Module exports.
	 */
	
	module.exports = jsonp;
	
	/**
	 * Callback index.
	 */
	
	var count = 0;
	
	/**
	 * Noop function.
	 */
	
	function noop(){}
	
	/**
	 * JSONP handler
	 *
	 * Options:
	 *  - param {String} qs parameter (`callback`)
	 *  - prefix {String} qs parameter (`__jp`)
	 *  - name {String} qs parameter (`prefix` + incr)
	 *  - timeout {Number} how long after a timeout error is emitted (`60000`)
	 *
	 * @param {String} url
	 * @param {Object|Function} optional options / callback
	 * @param {Function} optional callback
	 */
	
	function jsonp(url, opts, fn){
	  if ('function' == typeof opts) {
	    fn = opts;
	    opts = {};
	  }
	  if (!opts) opts = {};
	
	  var prefix = opts.prefix || '__jp';
	
	  // use the callback name that was passed if one was provided.
	  // otherwise generate a unique name by incrementing our counter.
	  var id = opts.name || (prefix + (count++));
	
	  var param = opts.param || 'callback';
	  var timeout = null != opts.timeout ? opts.timeout : 60000;
	  var enc = encodeURIComponent;
	  var target = document.getElementsByTagName('script')[0] || document.head;
	  var script;
	  var timer;
	
	
	  if (timeout) {
	    timer = setTimeout(function(){
	      cleanup();
	      if (fn) fn(new Error('Timeout'));
	    }, timeout);
	  }
	
	  function cleanup(){
	    if (script.parentNode) script.parentNode.removeChild(script);
	    window[id] = noop;
	    if (timer) clearTimeout(timer);
	  }
	
	  function cancel(){
	    if (window[id]) {
	      cleanup();
	    }
	  }
	
	  window[id] = function(data){
	    debug('jsonp got', data);
	    cleanup();
	    if (fn) fn(null, data);
	  };
	
	  // add qs component
	  url += (~url.indexOf('?') ? '&' : '?') + param + '=' + enc(id);
	  url = url.replace('?&', '?');
	
	  debug('jsonp req "%s"', url);
	
	  // create script
	  script = document.createElement('script');
	  script.src = url;
	  target.parentNode.insertBefore(script, target);
	
	  return cancel;
	}


/***/ }),
/* 1417 */
/***/ (function(module, exports) {

	
	module.exports = function load (src, opts, cb) {
	  var head = document.head || document.getElementsByTagName('head')[0]
	  var script = document.createElement('script')
	
	  if (typeof opts === 'function') {
	    cb = opts
	    opts = {}
	  }
	
	  opts = opts || {}
	  cb = cb || function() {}
	
	  script.type = opts.type || 'text/javascript'
	  script.charset = opts.charset || 'utf8';
	  script.async = 'async' in opts ? !!opts.async : true
	  script.src = src
	
	  if (opts.attrs) {
	    setAttributes(script, opts.attrs)
	  }
	
	  if (opts.text) {
	    script.text = '' + opts.text
	  }
	
	  var onend = 'onload' in script ? stdOnEnd : ieOnEnd
	  onend(script, cb)
	
	  // some good legacy browsers (firefox) fail the 'in' detection above
	  // so as a fallback we always set onload
	  // old IE will ignore this and new IE will set onload
	  if (!script.onload) {
	    stdOnEnd(script, cb);
	  }
	
	  head.appendChild(script)
	}
	
	function setAttributes(script, attrs) {
	  for (var attr in attrs) {
	    script.setAttribute(attr, attrs[attr]);
	  }
	}
	
	function stdOnEnd (script, cb) {
	  script.onload = function () {
	    this.onerror = this.onload = null
	    cb(null, script)
	  }
	  script.onerror = function () {
	    // this.onload = null here is necessary
	    // because even IE9 works not like others
	    this.onerror = this.onload = null
	    cb(new Error('Failed to load ' + this.src), script)
	  }
	}
	
	function ieOnEnd (script, cb) {
	  script.onreadystatechange = function () {
	    if (this.readyState != 'complete' && this.readyState != 'loaded') return
	    this.onreadystatechange = null
	    cb(null, script) // there is no way to catch loading errors in IE8
	  }
	}


/***/ }),
/* 1418 */,
/* 1419 */,
/* 1420 */,
/* 1421 */,
/* 1422 */,
/* 1423 */,
/* 1424 */,
/* 1425 */,
/* 1426 */,
/* 1427 */,
/* 1428 */,
/* 1429 */,
/* 1430 */,
/* 1431 */,
/* 1432 */,
/* 1433 */,
/* 1434 */,
/* 1435 */,
/* 1436 */,
/* 1437 */,
/* 1438 */,
/* 1439 */,
/* 1440 */,
/* 1441 */,
/* 1442 */,
/* 1443 */,
/* 1444 */,
/* 1445 */,
/* 1446 */,
/* 1447 */,
/* 1448 */,
/* 1449 */,
/* 1450 */,
/* 1451 */,
/* 1452 */,
/* 1453 */,
/* 1454 */,
/* 1455 */,
/* 1456 */,
/* 1457 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayEach = __webpack_require__(1458),
	    baseEach = __webpack_require__(1459),
	    createForEach = __webpack_require__(1467);
	
	/**
	 * Iterates over elements of `collection` invoking `iteratee` for each element.
	 * The `iteratee` is bound to `thisArg` and invoked with three arguments:
	 * (value, index|key, collection). Iteratee functions may exit iteration early
	 * by explicitly returning `false`.
	 *
	 * **Note:** As with other "Collections" methods, objects with a "length" property
	 * are iterated like arrays. To avoid this behavior `_.forIn` or `_.forOwn`
	 * may be used for object iteration.
	 *
	 * @static
	 * @memberOf _
	 * @alias each
	 * @category Collection
	 * @param {Array|Object|string} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @param {*} [thisArg] The `this` binding of `iteratee`.
	 * @returns {Array|Object|string} Returns `collection`.
	 * @example
	 *
	 * _([1, 2]).forEach(function(n) {
	 *   console.log(n);
	 * }).value();
	 * // => logs each value from left to right and returns the array
	 *
	 * _.forEach({ 'a': 1, 'b': 2 }, function(n, key) {
	 *   console.log(n, key);
	 * });
	 * // => logs each value-key pair and returns the object (iteration order is not guaranteed)
	 */
	var forEach = createForEach(arrayEach, baseEach);
	
	module.exports = forEach;


/***/ }),
/* 1458 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.forEach` for arrays without support for callback
	 * shorthands and `this` binding.
	 *
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns `array`.
	 */
	function arrayEach(array, iteratee) {
	  var index = -1,
	      length = array.length;
	
	  while (++index < length) {
	    if (iteratee(array[index], index, array) === false) {
	      break;
	    }
	  }
	  return array;
	}
	
	module.exports = arrayEach;


/***/ }),
/* 1459 */
/***/ (function(module, exports, __webpack_require__) {

	var baseForOwn = __webpack_require__(1461),
	    createBaseEach = __webpack_require__(1465);
	
	/**
	 * The base implementation of `_.forEach` without support for callback
	 * shorthands and `this` binding.
	 *
	 * @private
	 * @param {Array|Object|string} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array|Object|string} Returns `collection`.
	 */
	var baseEach = createBaseEach(baseForOwn);
	
	module.exports = baseEach;


/***/ }),
/* 1460 */
/***/ (function(module, exports, __webpack_require__) {

	var createBaseFor = __webpack_require__(1466);
	
	/**
	 * The base implementation of `baseForIn` and `baseForOwn` which iterates
	 * over `object` properties returned by `keysFunc` invoking `iteratee` for
	 * each property. Iteratee functions may exit iteration early by explicitly
	 * returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor = createBaseFor();
	
	module.exports = baseFor;


/***/ }),
/* 1461 */
/***/ (function(module, exports, __webpack_require__) {

	var baseFor = __webpack_require__(1460),
	    keys = __webpack_require__(1472);
	
	/**
	 * The base implementation of `_.forOwn` without support for callback
	 * shorthands and `this` binding.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForOwn(object, iteratee) {
	  return baseFor(object, iteratee, keys);
	}
	
	module.exports = baseForOwn;


/***/ }),
/* 1462 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	module.exports = baseProperty;


/***/ }),
/* 1463 */
/***/ (function(module, exports) {

	/**
	 * Converts `value` to a string if it's not one. An empty string is returned
	 * for `null` or `undefined` values.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  return value == null ? '' : (value + '');
	}
	
	module.exports = baseToString;


/***/ }),
/* 1464 */
/***/ (function(module, exports, __webpack_require__) {

	var identity = __webpack_require__(1475);
	
	/**
	 * A specialized version of `baseCallback` which only supports `this` binding
	 * and specifying the number of arguments to provide to `func`.
	 *
	 * @private
	 * @param {Function} func The function to bind.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {number} [argCount] The number of arguments to provide to `func`.
	 * @returns {Function} Returns the callback.
	 */
	function bindCallback(func, thisArg, argCount) {
	  if (typeof func != 'function') {
	    return identity;
	  }
	  if (thisArg === undefined) {
	    return func;
	  }
	  switch (argCount) {
	    case 1: return function(value) {
	      return func.call(thisArg, value);
	    };
	    case 3: return function(value, index, collection) {
	      return func.call(thisArg, value, index, collection);
	    };
	    case 4: return function(accumulator, value, index, collection) {
	      return func.call(thisArg, accumulator, value, index, collection);
	    };
	    case 5: return function(value, other, key, object, source) {
	      return func.call(thisArg, value, other, key, object, source);
	    };
	  }
	  return function() {
	    return func.apply(thisArg, arguments);
	  };
	}
	
	module.exports = bindCallback;


/***/ }),
/* 1465 */
/***/ (function(module, exports, __webpack_require__) {

	var getLength = __webpack_require__(565),
	    isLength = __webpack_require__(184),
	    toObject = __webpack_require__(569);
	
	/**
	 * Creates a `baseEach` or `baseEachRight` function.
	 *
	 * @private
	 * @param {Function} eachFunc The function to iterate over a collection.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseEach(eachFunc, fromRight) {
	  return function(collection, iteratee) {
	    var length = collection ? getLength(collection) : 0;
	    if (!isLength(length)) {
	      return eachFunc(collection, iteratee);
	    }
	    var index = fromRight ? length : -1,
	        iterable = toObject(collection);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (iteratee(iterable[index], index, iterable) === false) {
	        break;
	      }
	    }
	    return collection;
	  };
	}
	
	module.exports = createBaseEach;


/***/ }),
/* 1466 */
/***/ (function(module, exports, __webpack_require__) {

	var toObject = __webpack_require__(569);
	
	/**
	 * Creates a base function for `_.forIn` or `_.forInRight`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseFor(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var iterable = toObject(object),
	        props = keysFunc(object),
	        length = props.length,
	        index = fromRight ? length : -1;
	
	    while ((fromRight ? index-- : ++index < length)) {
	      var key = props[index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}
	
	module.exports = createBaseFor;


/***/ }),
/* 1467 */
/***/ (function(module, exports, __webpack_require__) {

	var bindCallback = __webpack_require__(1464),
	    isArray = __webpack_require__(346);
	
	/**
	 * Creates a function for `_.forEach` or `_.forEachRight`.
	 *
	 * @private
	 * @param {Function} arrayFunc The function to iterate over an array.
	 * @param {Function} eachFunc The function to iterate over a collection.
	 * @returns {Function} Returns the new each function.
	 */
	function createForEach(arrayFunc, eachFunc) {
	  return function(collection, iteratee, thisArg) {
	    return (typeof iteratee == 'function' && thisArg === undefined && isArray(collection))
	      ? arrayFunc(collection, iteratee)
	      : eachFunc(collection, bindCallback(iteratee, thisArg, 3));
	  };
	}
	
	module.exports = createForEach;


/***/ }),
/* 1468 */
/***/ (function(module, exports, __webpack_require__) {

	var isArguments = __webpack_require__(570),
	    isArray = __webpack_require__(346),
	    isIndex = __webpack_require__(568),
	    isLength = __webpack_require__(184),
	    keysIn = __webpack_require__(1473);
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A fallback implementation of `Object.keys` which creates an array of the
	 * own enumerable property names of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function shimKeys(object) {
	  var props = keysIn(object),
	      propsLength = props.length,
	      length = propsLength && object.length;
	
	  var allowIndexes = !!length && isLength(length) &&
	    (isArray(object) || isArguments(object));
	
	  var index = -1,
	      result = [];
	
	  while (++index < propsLength) {
	    var key = props[index];
	    if ((allowIndexes && isIndex(key, length)) || hasOwnProperty.call(object, key)) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = shimKeys;


/***/ }),
/* 1469 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(244);
	
	/** `Object#toString` result references. */
	var funcTag = '[object Function]';
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objToString = objectProto.toString;
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in older versions of Chrome and Safari which return 'function' for regexes
	  // and Safari 8 which returns 'object' for typed array constructors.
	  return isObject(value) && objToString.call(value) == funcTag;
	}
	
	module.exports = isFunction;


/***/ }),
/* 1470 */
/***/ (function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(1469),
	    isObjectLike = __webpack_require__(243);
	
	/** Used to detect host constructors (Safari > 5). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var fnToString = Function.prototype.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  fnToString.call(hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/**
	 * Checks if `value` is a native function.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
	 * @example
	 *
	 * _.isNative(Array.prototype.push);
	 * // => true
	 *
	 * _.isNative(_);
	 * // => false
	 */
	function isNative(value) {
	  if (value == null) {
	    return false;
	  }
	  if (isFunction(value)) {
	    return reIsNative.test(fnToString.call(value));
	  }
	  return isObjectLike(value) && reIsHostCtor.test(value);
	}
	
	module.exports = isNative;


/***/ }),
/* 1471 */
/***/ (function(module, exports, __webpack_require__) {

	var isObjectLike = __webpack_require__(243);
	
	/** `Object#toString` result references. */
	var stringTag = '[object String]';
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objToString = objectProto.toString;
	
	/**
	 * Checks if `value` is classified as a `String` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isString('abc');
	 * // => true
	 *
	 * _.isString(1);
	 * // => false
	 */
	function isString(value) {
	  return typeof value == 'string' || (isObjectLike(value) && objToString.call(value) == stringTag);
	}
	
	module.exports = isString;


/***/ }),
/* 1472 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(566),
	    isArrayLike = __webpack_require__(567),
	    isObject = __webpack_require__(244),
	    shimKeys = __webpack_require__(1468);
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeKeys = getNative(Object, 'keys');
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/6.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	var keys = !nativeKeys ? shimKeys : function(object) {
	  var Ctor = object == null ? undefined : object.constructor;
	  if ((typeof Ctor == 'function' && Ctor.prototype === object) ||
	      (typeof object != 'function' && isArrayLike(object))) {
	    return shimKeys(object);
	  }
	  return isObject(object) ? nativeKeys(object) : [];
	};
	
	module.exports = keys;


/***/ }),
/* 1473 */
/***/ (function(module, exports, __webpack_require__) {

	var isArguments = __webpack_require__(570),
	    isArray = __webpack_require__(346),
	    isIndex = __webpack_require__(568),
	    isLength = __webpack_require__(184),
	    isObject = __webpack_require__(244);
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */
	function keysIn(object) {
	  if (object == null) {
	    return [];
	  }
	  if (!isObject(object)) {
	    object = Object(object);
	  }
	  var length = object.length;
	  length = (length && isLength(length) &&
	    (isArray(object) || isArguments(object)) && length) || 0;
	
	  var Ctor = object.constructor,
	      index = -1,
	      isProto = typeof Ctor == 'function' && Ctor.prototype === object,
	      result = Array(length),
	      skipIndexes = length > 0;
	
	  while (++index < length) {
	    result[index] = (index + '');
	  }
	  for (var key in object) {
	    if (!(skipIndexes && isIndex(key, length)) &&
	        !(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = keysIn;


/***/ }),
/* 1474 */
/***/ (function(module, exports, __webpack_require__) {

	var baseToString = __webpack_require__(1463);
	
	/**
	 * Capitalizes the first character of `string`.
	 *
	 * @static
	 * @memberOf _
	 * @category String
	 * @param {string} [string=''] The string to capitalize.
	 * @returns {string} Returns the capitalized string.
	 * @example
	 *
	 * _.capitalize('fred');
	 * // => 'Fred'
	 */
	function capitalize(string) {
	  string = baseToString(string);
	  return string && (string.charAt(0).toUpperCase() + string.slice(1));
	}
	
	module.exports = capitalize;


/***/ }),
/* 1475 */
/***/ (function(module, exports) {

	/**
	 * This method returns the first argument provided to it.
	 *
	 * @static
	 * @memberOf _
	 * @category Utility
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'user': 'fred' };
	 *
	 * _.identity(object) === object;
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	module.exports = identity;


/***/ }),
/* 1476 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Get the count of the longest repeating streak of
	 * `character` in `value`.
	 *
	 * @example
	 *   longestStreak('` foo `` bar `', '`') // 2
	 *
	 * @param {string} value - Content, coerced to string.
	 * @param {string} character - Single character to look
	 *   for.
	 * @return {number} - Number of characters at the place
	 *   where `character` occurs in its longest streak in
	 *   `value`.
	 * @throws {Error} - when `character` is not a single
	 *   character.
	 */
	function longestStreak(value, character) {
	    var count = 0;
	    var maximum = 0;
	    var index = -1;
	    var length;
	
	    value = String(value);
	    length = value.length;
	
	    if (typeof character !== 'string' || character.length !== 1) {
	        throw new Error('Expected character');
	    }
	
	    while (++index < length) {
	        if (value.charAt(index) === character) {
	            count++;
	
	            if (count > maximum) {
	                maximum = count;
	            }
	        } else {
	            count = 0;
	        }
	    }
	
	    return maximum;
	}
	
	/*
	 * Expose.
	 */
	
	module.exports = longestStreak;


/***/ }),
/* 1477 */
/***/ (function(module, exports) {

	'use strict';
	
	/*
	 * Useful expressions.
	 */
	
	var EXPRESSION_DOT = /\./;
	var EXPRESSION_LAST_DOT = /\.[^.]*$/;
	
	/*
	 * Allowed alignment values.
	 */
	
	var LEFT = 'l';
	var RIGHT = 'r';
	var CENTER = 'c';
	var DOT = '.';
	var NULL = '';
	
	var ALLIGNMENT = [LEFT, RIGHT, CENTER, DOT, NULL];
	
	/*
	 * Characters.
	 */
	
	var COLON = ':';
	var DASH = '-';
	var PIPE = '|';
	var SPACE = ' ';
	var NEW_LINE = '\n';
	
	/**
	 * Get the length of `value`.
	 *
	 * @param {string} value
	 * @return {number}
	 */
	function lengthNoop(value) {
	    return String(value).length;
	}
	
	/**
	 * Get a string consisting of `length` `character`s.
	 *
	 * @param {number} length
	 * @param {string} [character=' ']
	 * @return {string}
	 */
	function pad(length, character) {
	    return Array(length + 1).join(character || SPACE);
	}
	
	/**
	 * Get the position of the last dot in `value`.
	 *
	 * @param {string} value
	 * @return {number}
	 */
	function dotindex(value) {
	    var match = EXPRESSION_LAST_DOT.exec(value);
	
	    return match ? match.index + 1 : value.length;
	}
	
	/**
	 * Create a table from a matrix of strings.
	 *
	 * @param {Array.<Array.<string>>} table
	 * @param {Object?} options
	 * @param {boolean?} [options.rule=true]
	 * @param {string?} [options.delimiter=" | "]
	 * @param {string?} [options.start="| "]
	 * @param {string?} [options.end=" |"]
	 * @param {Array.<string>?} options.align
	 * @param {function(string)?} options.stringLength
	 * @return {string} Pretty table
	 */
	function markdownTable(table, options) {
	    var settings = options || {};
	    var delimiter = settings.delimiter;
	    var start = settings.start;
	    var end = settings.end;
	    var alignment = settings.align;
	    var calculateStringLength = settings.stringLength || lengthNoop;
	    var cellCount = 0;
	    var rowIndex = -1;
	    var rowLength = table.length;
	    var sizes = [];
	    var align;
	    var rule;
	    var rows;
	    var row;
	    var cells;
	    var index;
	    var position;
	    var size;
	    var value;
	    var spacing;
	    var before;
	    var after;
	
	    alignment = alignment ? alignment.concat() : [];
	
	    if (delimiter === null || delimiter === undefined) {
	        delimiter = SPACE + PIPE + SPACE;
	    }
	
	    if (start === null || start === undefined) {
	        start = PIPE + SPACE;
	    }
	
	    if (end === null || end === undefined) {
	        end = SPACE + PIPE;
	    }
	
	    while (++rowIndex < rowLength) {
	        row = table[rowIndex];
	
	        index = -1;
	
	        if (row.length > cellCount) {
	            cellCount = row.length;
	        }
	
	        while (++index < cellCount) {
	            position = row[index] ? dotindex(row[index]) : null;
	
	            if (!sizes[index]) {
	                sizes[index] = 3;
	            }
	
	            if (position > sizes[index]) {
	                sizes[index] = position;
	            }
	        }
	    }
	
	    if (typeof alignment === 'string') {
	        alignment = pad(cellCount, alignment).split('');
	    }
	
	    /*
	     * Make sure only valid alignments are used.
	     */
	
	    index = -1;
	
	    while (++index < cellCount) {
	        align = alignment[index];
	
	        if (typeof align === 'string') {
	            align = align.charAt(0).toLowerCase();
	        }
	
	        if (ALLIGNMENT.indexOf(align) === -1) {
	            align = NULL;
	        }
	
	        alignment[index] = align;
	    }
	
	    rowIndex = -1;
	    rows = [];
	
	    while (++rowIndex < rowLength) {
	        row = table[rowIndex];
	
	        index = -1;
	        cells = [];
	
	        while (++index < cellCount) {
	            value = row[index];
	
	            if (value === null || value === undefined) {
	                value = '';
	            } else {
	                value = String(value);
	            }
	
	            if (alignment[index] !== DOT) {
	                cells[index] = value;
	            } else {
	                position = dotindex(value);
	
	                size = sizes[index] +
	                    (EXPRESSION_DOT.test(value) ? 0 : 1) -
	                    (calculateStringLength(value) - position);
	
	                cells[index] = value + pad(size - 1);
	            }
	        }
	
	        rows[rowIndex] = cells;
	    }
	
	    sizes = [];
	    rowIndex = -1;
	
	    while (++rowIndex < rowLength) {
	        cells = rows[rowIndex];
	
	        index = -1;
	
	        while (++index < cellCount) {
	            value = cells[index];
	
	            if (!sizes[index]) {
	                sizes[index] = 3;
	            }
	
	            size = calculateStringLength(value);
	
	            if (size > sizes[index]) {
	                sizes[index] = size;
	            }
	        }
	    }
	
	    rowIndex = -1;
	
	    while (++rowIndex < rowLength) {
	        cells = rows[rowIndex];
	
	        index = -1;
	
	        while (++index < cellCount) {
	            value = cells[index];
	
	            position = sizes[index] - (calculateStringLength(value) || 0);
	            spacing = pad(position);
	
	            if (alignment[index] === RIGHT || alignment[index] === DOT) {
	                value = spacing + value;
	            } else if (alignment[index] !== CENTER) {
	                value = value + spacing;
	            } else {
	                position = position / 2;
	
	                if (position % 1 === 0) {
	                    before = position;
	                    after = position;
	                } else {
	                    before = position + 0.5;
	                    after = position - 0.5;
	                }
	
	                value = pad(before) + value + pad(after);
	            }
	
	            cells[index] = value;
	        }
	
	        rows[rowIndex] = cells.join(delimiter);
	    }
	
	    if (settings.rule !== false) {
	        index = -1;
	        rule = [];
	
	        while (++index < cellCount) {
	            align = alignment[index];
	
	            /*
	             * When `align` is left, don't add colons.
	             */
	
	            value = align === RIGHT || align === NULL ? DASH : COLON;
	            value += pad(sizes[index] - 2, DASH);
	            value += align !== LEFT && align !== NULL ? COLON : DASH;
	
	            rule[index] = value;
	        }
	
	        rows.splice(1, 0, rule.join(delimiter));
	    }
	
	    return start + rows.join(end + NEW_LINE + start) + end;
	}
	
	/*
	 * Expose `markdownTable`.
	 */
	
	module.exports = markdownTable;


/***/ }),
/* 1478 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author Titus Wormer
	 * @copyright 2015 Titus Wormer
	 * @license MIT
	 * @module mdast:html
	 * @fileoverview Compile Markdown to HTML with mdast.
	 */
	
	'use strict';
	
	/*
	 * Dependencies.
	 */
	
	var compilers = __webpack_require__(1479);
	var transformer = __webpack_require__(1481);
	
	/**
	 * Attach an HTML compiler.
	 *
	 * @param {MDAST} mdast - Instance.
	 * @param {Object?} [options] - Configuration.
	 */
	function plugin(mdast, options) {
	    var MarkdownCompiler = mdast.Compiler;
	    var ancestor = MarkdownCompiler.prototype;
	    var proto;
	    var key;
	
	    /**
	     * Extensible prototype.
	     */
	    function HTMLCompilerPrototype() {}
	
	    HTMLCompilerPrototype.prototype = ancestor;
	
	    proto = new HTMLCompilerPrototype();
	
	    proto.options.xhtml = false;
	    proto.options.sanitize = false;
	    proto.options.entities = 'true';
	
	    /**
	     * Extensible constructor.
	     */
	    function HTMLCompiler(file) {
	        if (file.extension) {
	            file.move({
	                'extension': 'html'
	            });
	        }
	
	        MarkdownCompiler.apply(this, [file, options]);
	    }
	
	    HTMLCompiler.prototype = proto;
	
	    /*
	     * Expose compilers.
	     */
	
	    for (key in compilers) {
	        proto[key] = compilers[key];
	    }
	
	    mdast.Compiler = HTMLCompiler;
	
	    return transformer;
	}
	
	/*
	 * Expose `plugin`.
	 */
	
	module.exports = plugin;


/***/ }),
/* 1479 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author Titus Wormer
	 * @copyright 2015 Titus Wormer
	 * @license MIT
	 * @module mdast:html:compilers
	 * @fileoverview Compilers to transform mdast nodes to HTML.
	 */
	
	'use strict';
	
	/*
	 * Dependencies.
	 */
	
	var trim = __webpack_require__(840);
	var detab = __webpack_require__(1333);
	var collapse = __webpack_require__(501);
	var normalizeURI = __webpack_require__(1488);
	var trimLines = __webpack_require__(2234);
	var visit = __webpack_require__(842);
	var h = __webpack_require__(1480);
	
	/*
	 * Compilers.
	 */
	
	var visitors = {};
	
	/**
	 * Return the content of a reference without definition
	 * as markdown.
	 *
	 * @example
	 *   failsafe({
	 *     identifier: 'foo',
	 *     referenceType: 'shortcut',
	 *     children: [
	 *       {
	 *         type: 'text',
	 *         value: 'foo'
	 *       }
	 *     ]
	 *   }, {}); // '[foo]'
	 *
	 * @param {Node} node - Node to compile.
	 * @param {Node?} definition - Definition node, when
	 *   existing.
	 * @param {HTMLCompiler} context - Instance.
	 * @return {string?} - If without definition, returns a
	 *   string, returns nothing otherwise.
	 */
	function failsafe(node, definition, context) {
	    var result;
	
	    if (node.referenceType === 'shortcut' && !definition.link) {
	        result = node.children ? context.all(node).join('') : node.alt;
	
	        return (node.type === 'imageReference' ? '!' : '') +
	            '[' + result + ']';
	    }
	
	    return '';
	}
	
	/**
	 * Stringify all footnote definitions, if any.
	 *
	 * @example
	 *   generateFootnotes(); // '<div class="footnotes">\n<hr>\n...'
	 *
	 * @return {string} - Compiled footnotes, if any.
	 * @this {HTMLCompiler}
	 */
	function generateFootnotes() {
	    var self = this;
	    var definitions = self.footnotes;
	    var length = definitions.length;
	    var index = -1;
	    var results = [];
	    var def;
	
	    if (!length) {
	        return '';
	    }
	
	    while (++index < length) {
	        def = definitions[index];
	
	        results[index] = self.listItem({
	            'type': 'listItem',
	            'data': {
	                'htmlAttributes': {
	                    'id': 'fn-' + def.identifier
	                }
	            },
	            'children': def.children.concat({
	                'type': 'link',
	                'href': '#fnref-' + def.identifier,
	                'data': {
	                    'htmlAttributes': {
	                        'class': 'footnote-backref'
	                    }
	                },
	                'children': [{
	                    'type': 'text',
	                    'value': '↩'
	                }]
	            }),
	            'position': def.position
	        }, {});
	    }
	
	    return h(self, null, {
	        'name': 'div',
	        'attributes': {
	            'class': 'footnotes'
	        },
	        'content': h(self, null, {
	                'name': 'hr'
	            }) +
	            '\n' +
	            h(self, null, {
	                'name': 'ol',
	                'content': results.join('\n')
	            }, null, true)
	    }, null, true) + '\n';
	}
	
	/**
	 * Stringify an unknown node.
	 *
	 * @example
	 *   unknown({
	 *     data: {
	 *       htmlName: 'section'
	 *     },
	 *     children: [
	 *       {
	 *         type: 'text',
	 *         value: 'foo'
	 *       }
	 *     ]
	 *   }); // '<section>foo</section>'
	 *
	 * @param {Node} node - Node to compile.
	 * @return {string} - Compiled node.
	 * @this {HTMLCompiler}
	 */
	function unknown(node) {
	    var content = 'children' in node ? this.all(node).join('') : node.value;
	
	    return h(this, node, {
	        'name': 'div',
	        'content': content || ''
	    }, node.data);
	}
	
	/**
	 * Visit a node.
	 *
	 * @example
	 *   var compiler = new Compiler();
	 *
	 *   compiler.visit({
	 *     type: 'strong',
	 *     children: [{
	 *       type: 'text',
	 *       value: 'Foo'
	 *     }]
	 *   });
	 *   // '**Foo**'
	 *
	 * @param {Object} node - Node.
	 * @param {Object?} [parent] - `node`s parent.
	 * @return {string} - Compiled `node`.
	 */
	function one(node, parent) {
	    var self = this;
	    var type = node && node.type;
	    var fn = typeof self[type] === 'function' ? type : 'unknown';
	
	    if (!type) {
	        self.file.fail('Expected node `' + node + '`');
	    }
	
	    return self[fn](node, parent);
	}
	
	/**
	 * Stringify the children of `node`.
	 *
	 * @example
	 *   all({
	 *     children: [
	 *       {
	 *         type: 'text',
	 *         value: 'foo'
	 *       }
	 *     ]
	 *   }); // 'foo'
	 *
	 * @param {Node} parent - Parent to visit.
	 * @return {Array.<string>}
	 * @this {HTMLCompiler}
	 */
	function all(parent) {
	    var self = this;
	    var nodes = parent.children;
	    var values = [];
	    var index = -1;
	    var length = nodes.length;
	    var value;
	    var prev;
	
	    while (++index < length) {
	        value = self.visit(nodes[index], parent);
	
	        if (value) {
	            if (
	                prev &&
	                (
	                    prev.type === 'break' ||
	                    (prev.type === 'escape' && prev.value === '\n')
	                )
	            ) {
	                value = trim.left(value);
	            }
	
	            values.push(value);
	        }
	
	        prev = nodes[index];
	    }
	
	    return values;
	}
	
	/**
	 * Stringify a root object.
	 *
	 * @example
	 *   // This will additionally include defined footnotes,
	 *   // when applicable.
	 *   root({
	 *     children: [
	 *       {
	 *         type: 'paragraph',
	 *         children: [
	 *           {
	 *             type: 'text',
	 *             value: 'foo'
	 *           }
	 *         ]
	 *       }
	 *     ]
	 *   }); // '<p>foo</p>\n'
	 *
	 * @param {Node} node - Node to compile.
	 * @return {string} - Compiled node.
	 * @this {HTMLCompiler}
	 */
	function root(node) {
	    var self = this;
	    var definitions = {};
	    var footnotes = [];
	    var result;
	
	    self.definitions = definitions;
	    self.footnotes = footnotes;
	
	    visit(node, 'definition', function (definition) {
	        definitions[definition.identifier.toUpperCase()] = definition;
	    });
	
	    visit(node, 'footnoteDefinition', function (definition) {
	        footnotes.push(definition);
	    });
	
	    result = self.all(node).join('\n');
	
	    return (result ? result + '\n' : '') + self.generateFootnotes();
	}
	
	/**
	 * Stringify a block quote.
	 *
	 * @example
	 *   blockquote({
	 *     children: [
	 *       {
	 *         type: 'paragraph',
	 *         children: [
	 *           {
	 *             type: 'text',
	 *             value: 'foo'
	 *           }
	 *         ]
	 *       }
	 *     ]
	 *   }); // '<blockquote>\n<p>foo</p>\n</blockquote>'
	 *
	 * @param {Node} node - Node to compile.
	 * @return {string} - Compiled node.
	 * @this {HTMLCompiler}
	 */
	function blockquote(node) {
	    return h(this, node, {
	        'name': 'blockquote',
	        'content': this.all(node).join('\n')
	    }, node.data, true);
	}
	
	/**
	 * Stringify an inline footnote.
	 *
	 * @example
	 *   // This additionally adds a definition at the bottem
	 *   // of the document.
	 *   footnote({
	 *     children: [
	 *       {
	 *         type: 'text',
	 *         value: 'foo'
	 *       }
	 *     ]
	 *   }); // '<sup id="fnref-1"><a href="#fn-1">1</a></sup>'
	 *
	 * @param {Node} node - Node to compile.
	 * @return {string} - Compiled node.
	 * @this {HTMLCompiler}
	 */
	function footnote(node) {
	    var self = this;
	    var definitions = self.footnotes;
	    var index = -1;
	    var length = definitions.length;
	    var identifiers = [];
	    var identifier;
	
	    while (++index < length) {
	        identifiers[index] = definitions[index].identifier;
	    }
	
	    index = -1;
	    identifier = 1;
	
	    while (identifiers.indexOf(String(identifier)) !== -1) {
	        identifier++;
	    }
	
	    identifier = String(identifier);
	
	    self.footnotes.push({
	        'type': 'footnoteDefinition',
	        'identifier': identifier,
	        'children': node.children,
	        'position': node.position
	    });
	
	    return self.footnoteReference({
	        'type': 'footnoteReference',
	        'identifier': identifier,
	        'position': node.position
	    });
	}
	
	/**
	 * Stringify a list.
	 *
	 * @example
	 *   list({
	 *     ordered: true
	 *     loose: false
	 *     children: [
	 *       {
	 *         type: 'listItem',
	 *         children: [
	 *           {
	 *             type: 'paragraph',
	 *             children: [
	 *               {
	 *                 type: 'text',
	 *                 value: 'foo'
	 *               }
	 *             ]
	 *           }
	 *         ]
	 *       }
	 *     ]
	 *   }); // '<ol>\n<li>foo</li>\n</ol>'
	 *
	 * @param {Node} node - Node to compile.
	 * @return {string} - Compiled node.
	 * @this {HTMLCompiler}
	 */
	function list(node) {
	    return h(this, node, {
	        'name': node.ordered ? 'ol' : 'ul',
	        'attributes': {
	            'start': node.start !== 1 ? node.start : null
	        },
	        'content': this.all(node).join('\n')
	    }, node.data, true);
	}
	
	/**
	 * Stringify a list-item.
	 *
	 * @example
	 *   listItem({
	 *     children: [
	 *       {
	 *         type: 'paragraph',
	 *         children: [
	 *           {
	 *             type: 'text',
	 *             value: 'foo'
	 *           }
	 *         ]
	 *       }
	 *     ]
	 *   }, {
	 *     loose: false
	 *   }); // '<li>foo</li>'
	 *
	 * @param {Node} node - Node to compile.
	 * @param {Node} parent - Parent of `node`.
	 * @return {string} - Compiled node.
	 * @this {HTMLCompiler}
	 */
	function listItem(node, parent) {
	    var single;
	    var result;
	
	    single = !parent.loose &&
	        node.children.length === 1 &&
	        node.children[0].children;
	
	    result = this.all(single ? node.children[0] : node)
	        .join(single ? '' : '\n');
	
	    return h(this, node, {
	        'name': 'li',
	        'content': result
	    }, node.data, !single);
	}
	
	/**
	 * Stringify a heading.
	 *
	 * @example
	 *   heading({
	 *     depth: 3,
	 *     children: [
	 *       {
	 *         type: 'text',
	 *         value: 'foo'
	 *       }
	 *     ]
	 *   }); // '<h3>foo</h3>'
	 *
	 * @param {Node} node - Node to compile.
	 * @return {string} - Compiled node.
	 * @this {HTMLCompiler}
	 */
	function heading(node) {
	    return h(this, node, {
	        'name': 'h' + node.depth,
	        'content': this.all(node).join('')
	    }, node.data);
	}
	
	/**
	 * Stringify a paragraph.
	 *
	 * @example
	 *   paragraph({
	 *     children: [
	 *       {
	 *         type: 'text',
	 *         value: 'foo'
	 *       }
	 *     ]
	 *   }); // 'foo'
	 *
	 * @param {Node} node - Node to compile.
	 * @return {string} - Compiled node.
	 * @this {HTMLCompiler}
	 */
	function paragraph(node) {
	    return h(this, node, {
	        'name': 'p',
	        'content': trim(detab(this.all(node).join('')))
	    }, node.data);
	}
	
	/**
	 * Stringify a code block.
	 *
	 * @example
	 *   code({
	 *     value: 'foo &amp; bar;'
	 *   }); // '<pre><code>foo &amp;amp; bar\n</code></pre>'
	 *
	 * @param {Node} node - Node to compile.
	 * @return {string} - Compiled node.
	 * @this {HTMLCompiler}
	 */
	function code(node) {
	    var self = this;
	    var value = node.value ? detab(node.value + '\n') : '';
	
	    return h(self, node, {
	        'name': 'pre',
	        'content': h(self, node, {
	            'name': 'code',
	            'content': self.encode(value)
	        }, node.data)
	    });
	}
	
	/**
	 * Stringify a table.
	 *
	 * @example
	 *   table({
	 *     children: [
	 *       {
	 *         type: 'tableRow',
	 *         ...
	 *       }
	 *     ]
	 *   }); // '<table><thead>...'
	 *
	 * @param {Node} node - Node to compile.
	 * @return {string} - Compiled node.
	 * @this {HTMLCompiler}
	 */
	function table(node) {
	    var self = this;
	    var rows = node.children;
	    var index = rows.length;
	    var align = node.align;
	    var alignLength = align.length;
	    var pos;
	    var result = [];
	    var row;
	    var out;
	    var name;
	    var cell;
	
	    while (index--) {
	        pos = alignLength;
	        row = rows[index].children;
	        out = [];
	        name = index === 0 ? 'th' : 'td';
	
	        while (pos--) {
	            cell = row[pos];
	            out[pos] = h(self, cell, {
	                'name': name,
	                'attributes': {
	                    'align': align[pos]
	                },
	                'content': cell ? self.all(cell).join('\n') : ''
	            }, cell && cell.data);
	        }
	
	        result[index] = h(self, rows[index], {
	            'name': 'tr',
	            'content': out.join('\n')
	        }, rows[index], true);
	    }
	
	    return h(self, node, {
	        'name': 'table',
	        'content': h(self, node, {
	                'name': 'thead',
	                'content': result[0]
	            }, null, true) +
	            '\n' +
	            h(self, node, {
	                'name': 'tbody',
	                'content': result.slice(1).join('\n')
	            }, null, true)
	    }, node.data, true);
	}
	
	/**
	 * Stringify a literal HTML.
	 *
	 * @example
	 *   html({
	 *     value: '<i>italic</i>'
	 *   }); // '<i>italic</i>'
	 *
	 * @param {Node} node - Node to compile.
	 * @return {string} - Compiled node.
	 * @this {HTMLCompiler}
	 */
	function html(node) {
	    return this.options.sanitize ? this.encode(node.value) : node.value;
	}
	
	/**
	 * Stringify a horizontal rule.
	 *
	 * @example
	 *   rule(); // '<hr>'
	 *
	 * @param {Node} node - Node to compile.
	 * @return {string} - Compiled node.
	 * @this {HTMLCompiler}
	 */
	function rule(node) {
	    return h(this, node, {
	        'name': 'hr'
	    }, node.data);
	}
	
	/**
	 * Stringify inline code.
	 *
	 * @example
	 *   inlineCode({
	 *     value: 'foo &amp; bar;'
	 *   }); // '<code>foo &amp;amp; bar;</code>'
	 *
	 * @param {Node} node - Node to compile.
	 * @return {string} - Compiled node.
	 * @this {HTMLCompiler}
	 */
	function inlineCode(node) {
	    return h(this, node, {
	        'name': 'code',
	        'content': collapse(this.encode(node.value))
	    }, node.data);
	}
	
	/**
	 * Stringify strongly emphasised content.
	 *
	 * @example
	 *   strong({
	 *     children: [
	 *       {
	 *         type: 'text',
	 *         value: 'foo'
	 *       }
	 *     ]
	 *   }); // '<strong>foo</strong>'
	 *
	 * @param {Node} node - Node to compile.
	 * @return {string} - Compiled node.
	 * @this {HTMLCompiler}
	 */
	function strong(node) {
	    return h(this, node, {
	        'name': 'strong',
	        'content': this.all(node).join('')
	    }, node.data);
	}
	
	/**
	 * Stringify emphasised content.
	 *
	 * @example
	 *   emphasis({
	 *     children: [
	 *       {
	 *         type: 'text',
	 *         value: 'foo'
	 *       }
	 *     ]
	 *   }); // '<em>foo</em>'
	 *
	 * @param {Node} node - Node to compile.
	 * @return {string} - Compiled node.
	 * @this {HTMLCompiler}
	 */
	function emphasis(node) {
	    return h(this, node, {
	        'name': 'em',
	        'content': this.all(node).join('')
	    }, node.data);
	}
	
	/**
	 * Stringify an inline break.
	 *
	 * @example
	 *   hardBreak(); // '<br>\n'
	 *
	 * @param {Node} node - Node to compile.
	 * @return {string} - Compiled node.
	 * @this {HTMLCompiler}
	 */
	function hardBreak(node) {
	    return h(this, node, {
	        'name': 'br'
	    }, node.data) + '\n';
	}
	
	/**
	 * Stringify a link.
	 *
	 * @example
	 *   link({
	 *     href: 'http://example.com',
	 *     children: [
	 *       {
	 *         type: 'text',
	 *         value: 'foo'
	 *       }
	 *     ]
	 *   }); // '<a href="http://example.com">foo</a>'
	 *
	 * @param {Node} node - Node to compile.
	 * @return {string} - Compiled node.
	 * @this {HTMLCompiler}
	 */
	function link(node) {
	    return h(this, node, {
	        'name': 'a',
	        'attributes': {
	            'href': normalizeURI(node.href),
	            'title': node.title
	        },
	        'content': this.all(node).join('')
	    }, node.data);
	}
	
	/**
	 * Stringify a reference to a footnote.
	 *
	 * @example
	 *   // If a definition was added previously:
	 *   footnoteReference({
	 *     identifier: 'foo'
	 *   });
	 *   // <sup id="fnref-foo">
	 *   //   <a class="footnote-ref" href="#fn-foo">foo</a>
	 *   // </sup>
	 *
	 * @param {Node} node - Node to compile.
	 * @return {string} - Compiled node.
	 * @this {HTMLCompiler}
	 */
	function footnoteReference(node) {
	    var identifier = node.identifier;
	
	    return h(this, node, {
	        'name': 'sup',
	        'attributes': {
	            'id': 'fnref-' + identifier
	        },
	        'content': h(this, node, {
	            'name': 'a',
	            'attributes': {
	                'href': '#fn-' + identifier,
	                'class': 'footnote-ref'
	            },
	            'content': identifier
	        })
	    }, node.data);
	}
	
	/**
	 * Stringify a reference to a link.
	 *
	 * @example
	 *   // If a definition was added previously:
	 *   linkReference({
	 *     identifier: 'foo'
	 *   }); // '<a href="http://example.com/fav.ico"></a>'
	 *
	 * @param {Node} node - Node to compile.
	 * @return {string} - Compiled node.
	 * @this {HTMLCompiler}
	 */
	function linkReference(node) {
	    var self = this;
	    var def = self.definitions[node.identifier.toUpperCase()] || {};
	
	    return failsafe(node, def, self) || h(self, node, {
	        'name': 'a',
	        'attributes': {
	            'href': normalizeURI(def.link || ''),
	            'title': def.title
	        },
	        'content': self.all(node).join('')
	    }, node.data);
	}
	
	/**
	 * Stringify a reference to an image.
	 *
	 * @example
	 *   // If a definition was added previously:
	 *   imageReference({
	 *     identifier: 'foo'
	 *   }); // '<img src="http://example.com/fav.ico" alt="">'
	 *
	 * @param {Node} node - Node to compile.
	 * @return {string} - Compiled node.
	 * @this {HTMLCompiler}
	 */
	function imageReference(node) {
	    var self = this;
	    var def = self.definitions[node.identifier.toUpperCase()] || {};
	
	    return failsafe(node, def, self) || h(self, node, {
	        'name': 'img',
	        'attributes': {
	            'src': normalizeURI(def.link || ''),
	            'alt': node.alt || '',
	            'title': def.title
	        }
	    }, node.data);
	}
	
	/**
	 * Stringify an image.
	 *
	 * @example
	 *   image({
	 *     src: 'http://example.com/fav.ico'
	 *   }); // '<img src="http://example.com/fav.ico" alt="">'
	 *
	 * @param {Node} node - Node to compile.
	 * @return {string} - Compiled node.
	 * @this {HTMLCompiler}
	 */
	function image(node) {
	    return h(this, node, {
	        'name': 'img',
	        'attributes': {
	            'src': normalizeURI(node.src),
	            'alt': node.alt || '',
	            'title': node.title
	        }
	    }, node.data);
	}
	
	/**
	 * Stringify a deletion.
	 *
	 * @example
	 *   strikethrough({
	 *     children: [
	 *       {
	 *         type: 'text',
	 *         value: 'foo'
	 *       }
	 *     ]
	 *   }); // '<del>foo</del>'
	 *
	 * @param {Node} node - Node to compile.
	 * @return {string} - Compiled node.
	 * @this {HTMLCompiler}
	 */
	function strikethrough(node) {
	    return h(this, node, {
	        'name': 'del',
	        'content': this.all(node).join('')
	    }, node.data);
	}
	
	/**
	 * Stringify text.
	 *
	 * @example
	 *   text({value: '&'}); // '&amp;'
	 *
	 *   text({value: 'foo'}); // 'foo'
	 *
	 * @param {Node} node - Node to compile.
	 * @return {string} - Compiled node.
	 * @this {HTMLCompiler}
	 */
	function text(node) {
	    return trimLines(this.encode(node.value));
	}
	
	/**
	 * Stringify escaped text.
	 *
	 * @example
	 *   escape({value: '\n'}); // '<br>\n'
	 *
	 *   escape({value: '|'}); // '\\|'
	 *
	 * @param {Node} node - Node to compile.
	 * @return {string} - Compiled node.
	 * @this {HTMLCompiler}
	 */
	function escape(node) {
	    return this[node.value === '\n' ? 'break' : 'text'](node);
	}
	
	/**
	 * Return an empty string for nodes which are ignored.
	 *
	 * @example
	 *   ignore(); // ''
	 *
	 * @return {string} - Empty string.
	 * @this {HTMLCompiler}
	 */
	function ignore() {
	    return '';
	}
	
	/*
	 * Helpers.
	 */
	
	visitors.visit = one;
	visitors.all = all;
	visitors.unknown = unknown;
	visitors.generateFootnotes = generateFootnotes;
	
	/*
	 * Ignored nodes.
	 */
	
	visitors.yaml = ignore;
	visitors.definition = ignore;
	visitors.footnoteDefinition = ignore;
	
	/*
	 * Compilers.
	 */
	
	visitors.footnote = footnote;
	visitors.root = root;
	visitors.blockquote = blockquote;
	visitors.list = list;
	visitors.listItem = listItem;
	visitors.paragraph = paragraph;
	visitors.heading = heading;
	visitors.table = table;
	visitors.code = code;
	visitors.html = html;
	visitors.horizontalRule = rule;
	visitors.inlineCode = inlineCode;
	visitors.strong = strong;
	visitors.emphasis = emphasis;
	visitors.break = hardBreak;
	visitors.link = link;
	visitors.image = image;
	visitors.footnoteReference = footnoteReference;
	visitors.linkReference = linkReference;
	visitors.imageReference = imageReference;
	visitors.delete = strikethrough;
	visitors.text = text;
	visitors.escape = escape;
	
	/*
	 * Expose.
	 */
	
	module.exports = visitors;


/***/ }),
/* 1480 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author Titus Wormer
	 * @copyright 2015 Titus Wormer
	 * @license MIT
	 * @module mdast:html:h
	 * @fileoverview
	 *   Create HTML nodes. Loosely inspired by
	 *   https://github.com/Matt-Esch/virtual-dom/blob/master/
	 *   virtual-hyperscript/index.js
	 */
	
	'use strict';
	
	/*
	 * Dependencies.
	 */
	
	var assign = __webpack_require__(185);
	
	/*
	 * Constants.
	 */
	
	var LINE = '\n';
	var EMPTY = '';
	var SPACE = ' ';
	var GT = '>';
	var LT = '<';
	var SLASH = '/';
	var QUOTE = '"';
	var EQUALS = '=';
	
	/*
	 * List of self-closing tags.
	 */
	
	var CLOSING = ['hr', 'img', 'br'];
	
	/**
	 * Compile attributes.
	 *
	 * @param {Object?} attributes - Map of attributes.
	 * @param {function(string): string} encode - Strategy
	 *   to use.
	 * @param {Node} node - mdast node currently being
	 *   compiled.
	 * @return {string} - HTML attributes.
	 */
	function toAttributes(attributes, encode, node) {
	    var parameters = [];
	    var key;
	    var value;
	
	    for (key in attributes) {
	        value = attributes[key];
	
	        if (value !== null && value !== undefined) {
	            value = encode(String(value || EMPTY), node);
	            parameters.push(key + EQUALS + QUOTE + value + QUOTE);
	        }
	    }
	
	    return parameters.length ? parameters.join(SPACE) : EMPTY;
	}
	
	/**
	 * Compile a `node`, in `context`, into HTML.
	 *
	 * @example
	 *   h(compiler, {
	 *     'type': 'break'
	 *     'attributes': {
	 *       'id': 'foo'
	 *     }
	 *   }, 'br') // '<br id="foo">'
	 *
	 *   h(compiler, {
	 *     'type': 'break'
	 *   }, 'br', {
	 *     'id': 'foo'
	 *   }) // '<br id="foo">'
	 *
	 * @param {HTMLCompiler} context - Context compiler.
	 * @param {Node} node - mdast node. Used for positions
	 *   on errors.
	 * @param {Object?} [defaults] - Default HTML configuration.
	 * @param {Object?} [defaults.attributes] - Default Attributes.
	 * @param {Object?} [defaults.content] - Default content.
	 * @param {Object?} [defaults.name] - Default tag-name.
	 * @param {Object?} [data] - Node configuration.
	 * @param {Object?} [data.htmlAttributes] - HTML Attributes.
	 * @param {Object?} [data.htmlContent] - Content of element.
	 * @param {Object?} [data.htmlName] - Tag-name.
	 * @param {boolean} [loose] - Whether to add an initial and
	 *   a trailing newline character inside the opening and
	 *   closing tags.
	 * @return {string} - HTML representation of `node`, based
	 *   on the given options.
	 */
	function h(context, node, defaults, data, loose) {
	    var name;
	    var value;
	    var parameters;
	    var content;
	
	    if (!data) {
	        data = {};
	    }
	
	    name = context.encode(data.htmlName || defaults.name);
	
	    if (data.htmlContent && !context.options.sanitize) {
	        content = data.htmlContent;
	    } else {
	        content = defaults.content || EMPTY;
	    }
	
	    parameters = toAttributes(
	        assign({}, defaults.attributes, data.htmlAttributes
	    ), context.encode, node);
	
	    value = LT + name + (parameters ? SPACE + parameters : EMPTY);
	
	    if (CLOSING.indexOf(name) !== -1) {
	        return value + (context.options.xhtml ? SPACE + SLASH : EMPTY) + GT;
	    }
	
	    return value + GT +
	        (loose ? LINE : EMPTY) +
	        content +
	        (loose && content ? LINE : EMPTY) +
	        LT + SLASH + name + GT;
	}
	
	/*
	 * Expose.
	 */
	
	module.exports = h;


/***/ }),
/* 1481 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author Titus Wormer
	 * @copyright 2015 Titus Wormer
	 * @license MIT
	 * @module mdast:html:compilers
	 * @fileoverview Compilers to transform mdast nodes to HTML.
	 */
	
	'use strict';
	
	/*
	 * Dependencies.
	 */
	
	var visit = __webpack_require__(842);
	
	/*
	 * Constants.
	 */
	
	var FIRST_WORD = /^[^\ \t]+(?=[\ \t]|$)/;
	
	/**
	 * Helper to get/set `htmlAttributes`.
	 *
	 * @param {Node} node - Node to get data from.
	 * @return {Object} - Attributes.
	 */
	function getAttributes(node) {
	    var data = node.data || (node.data = {});
	    return data.htmlAttributes || (data.htmlAttributes = {});
	}
	
	/**
	 * Augment a code node.
	 *
	 * @param {Node} node - Code node.
	 */
	function code(node) {
	    var lang = node.lang && node.lang.match(FIRST_WORD);
	    var attrs;
	
	    if (!lang) {
	        return;
	    }
	
	    attrs = getAttributes(node);
	    attrs.class = (attrs.class ? attrs.class + ' ' : '') + 'language-' + lang;
	}
	
	/*
	 * Map of node-type handlers.
	 */
	
	var handlers = {};
	
	handlers.code = code;
	
	/**
	 * Transform `ast`.
	 *
	 * @param {Node} ast - Tree.
	 */
	function transformer(ast) {
	    visit(ast, function (node) {
	        if (node.type in handlers) {
	            handlers[node.type](node);
	        }
	    });
	}
	
	/*
	 * Expose.
	 */
	
	module.exports = transformer;


/***/ }),
/* 1482 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author Titus Wormer
	 * @copyright 2015 Titus Wormer
	 * @license MIT
	 * @module mdast
	 * @version 2.3.2
	 * @fileoverview Markdown processor powered by plugins.
	 */
	
	'use strict';
	
	/* eslint-env commonjs */
	
	/*
	 * Dependencies.
	 */
	
	var unified = __webpack_require__(2241);
	var Parser = __webpack_require__(1484);
	var Compiler = __webpack_require__(1485);
	
	/*
	 * Exports.
	 */
	
	module.exports = unified({
	    'name': 'mdast',
	    'Parser': Parser,
	    'Compiler': Compiler
	});


/***/ }),
/* 1483 */
/***/ (function(module, exports) {

	/* This file is generated by `script/build-expressions.js` */
	/* eslint-env commonjs */
	module.exports = {
	  'rules': {
	    'newline': /^\n((?:[ \t]*\n)*)/,
	    'code': /^((?:(?: {4}|\t)[^\n]*\n?((?:[ \t]*\n)*))+)/,
	    'horizontalRule': /^[ \t]*([-*_])( *\1){2,} *(?=\n|$)/,
	    'heading': /^([ \t]*)(#{1,6})(?:([ \t]+)([^\n]+?))??(?:[ \t]+#+)?[ \t]*(?=\n|$)/,
	    'lineHeading': /^(\ {0,3})([^\n]+?)[ \t]*\n\ {0,3}(=|-){1,}[ \t]*(?=\n|$)/,
	    'definition': /^[ \t]*\[((?:[^\\](?:\\|\\(?:\\{2})+)\]|[^\]])+)\]:[ \t\n]*(<[^>\[\]]+>|[^\s\[\]]+)(?:[ \t\n]+['"(]((?:[^\n]|\n(?!\n))*?)['")])?[ \t]*(?=\n|$)/,
	    'bullet': /(?:[*+-]|\d+\.)/,
	    'indent': /^([ \t]*)((?:[*+-]|\d+\.))( {1,4}(?! )| |\t)/,
	    'item': /([ \t]*)((?:[*+-]|\d+\.))( {1,4}(?! )| |\t)[^\n]*(?:\n(?!\1(?:[*+-]|\d+\.)[ \t])[^\n]*)*/gm,
	    'list': /^([ \t]*)((?:[*+-]|\d+\.))[ \t][\s\S]+?(?:(?=\n+\1?(?:[-*_][ \t]*){3,}(?:\n|$))|(?=\n+[ \t]*\[((?:[^\\](?:\\|\\(?:\\{2})+)\]|[^\]])+)\]:[ \t\n]*(<[^>\[\]]+>|[^\s\[\]]+)(?:[ \t\n]+['"(]((?:[^\n]|\n(?!\n))*?)['")])?[ \t]*(?=\n|$))|\n{2,}(?![ \t])(?!\1(?:[*+-]|\d+\.)[ \t])|$)/,
	    'blockquote': /^(?=[ \t]*>)(?:(?:(?:[ \t]*>[^\n]*\n)*(?:[ \t]*>[^\n]+(?=\n|$))|(?![ \t]*>)(?![ \t]*\[((?:[^\\](?:\\|\\(?:\\{2})+)\]|[^\]])+)\]:[ \t\n]*(<[^>\[\]]+>|[^\s\[\]]+)(?:[ \t\n]+['"(]((?:[^\n]|\n(?!\n))*?)['")])?[ \t]*(?=\n|$))[^\n]+)(?:\n|$))*(?:[ \t]*>[ \t]*(?:\n[ \t]*>[ \t]*)*)?/,
	    'html': /^(?:[ \t]*(?:(?:(?:<(?:article|header|aside|hgroup|blockquote|hr|iframe|body|li|map|button|object|canvas|ol|caption|output|col|p|colgroup|pre|dd|progress|div|section|dl|table|td|dt|tbody|embed|textarea|fieldset|tfoot|figcaption|th|figure|thead|footer|tr|form|ul|h1|h2|h3|h4|h5|h6|video|script|style)(?:(?:\s+)(?:[a-zA-Z_:][a-zA-Z0-9_.:-]*)(?:(?:\s+)?=(?:\s+)?(?:[^"'=<>`]+|'[^']*'|"[^"]*"))?)*(?:\s+)?\/?>?)|(?:<\/(?:article|header|aside|hgroup|blockquote|hr|iframe|body|li|map|button|object|canvas|ol|caption|output|col|p|colgroup|pre|dd|progress|div|section|dl|table|td|dt|tbody|embed|textarea|fieldset|tfoot|figcaption|th|figure|thead|footer|tr|form|ul|h1|h2|h3|h4|h5|h6|video|script|style)(?:\s+)?>))|<!--[\s\S]*?-->|(?:<\?(?:[^\?]|\?(?!>))+\?>)|(?:<![a-zA-Z]+\s+[\s\S]+?>)|(?:<!\[CDATA\[[\s\S]+?\]\]>))[\s\S]*?[ \t]*?(?:\n{2,}|\s*$))/i,
	    'paragraph': /^(?:(?:[^\n]+\n?(?![ \t]*([-*_])( *\1){2,} *(?=\n|$)|([ \t]*)(#{1,6})(?:([ \t]+)([^\n]+?))??(?:[ \t]+#+)?[ \t]*(?=\n|$)|(\ {0,3})([^\n]+?)[ \t]*\n\ {0,3}(=|-){1,}[ \t]*(?=\n|$)|[ \t]*\[((?:[^\\](?:\\|\\(?:\\{2})+)\]|[^\]])+)\]:[ \t\n]*(<[^>\[\]]+>|[^\s\[\]]+)(?:[ \t\n]+['"(]((?:[^\n]|\n(?!\n))*?)['")])?[ \t]*(?=\n|$)|(?=[ \t]*>)(?:(?:(?:[ \t]*>[^\n]*\n)*(?:[ \t]*>[^\n]+(?=\n|$))|(?![ \t]*>)(?![ \t]*\[((?:[^\\](?:\\|\\(?:\\{2})+)\]|[^\]])+)\]:[ \t\n]*(<[^>\[\]]+>|[^\s\[\]]+)(?:[ \t\n]+['"(]((?:[^\n]|\n(?!\n))*?)['")])?[ \t]*(?=\n|$))[^\n]+)(?:\n|$))*(?:[ \t]*>[ \t]*(?:\n[ \t]*>[ \t]*)*)?|<(?!(?:a|em|strong|small|s|cite|q|dfn|abbr|data|time|code|var|samp|kbd|sub|sup|i|b|u|mark|ruby|rt|rp|bdi|bdo|span|br|wbr|ins|del|img)\b)(?!mailto:)\w+(?!:\/|[^\w\s@]*@)\b))+)/,
	    'escape': /^\\([\\`*{}\[\]()#+\-.!_>])/,
	    'autoLink': /^<([^ >]+(@|:\/)[^ >]+)>/,
	    'tag': /^(?:(?:<(?:[a-zA-Z][a-zA-Z0-9]*)(?:(?:\s+)(?:[a-zA-Z_:][a-zA-Z0-9_.:-]*)(?:(?:\s+)?=(?:\s+)?(?:[^"'=<>`]+|'[^']*'|"[^"]*"))?)*(?:\s+)?\/?>)|(?:<\/(?:[a-zA-Z][a-zA-Z0-9]*)(?:\s+)?>)|<!--[\s\S]*?-->|(?:<\?(?:[^\?]|\?(?!>))+\?>)|(?:<![a-zA-Z]+\s+[\s\S]+?>)|(?:<!\[CDATA\[[\s\S]+?\]\]>))/,
	    'strong': /^(_)_((?:\\[\s\S]|[^\\])+?)__(?!_)|^(\*)\*((?:\\[\s\S]|[^\\])+?)\*\*(?!\*)/,
	    'emphasis': /^\b(_)((?:__|\\[\s\S]|[^\\])+?)_\b|^(\*)((?:\*\*|\\[\s\S]|[^\\])+?)\*(?!\*)/,
	    'inlineCode': /^(`+)((?!`)[\s\S]*?(?:`\s+|[^`]))?(\1)(?!`)/,
	    'break': /^ {2,}\n(?!\s*$)/,
	    'inlineText': /^[\s\S]+?(?=[\\<!\[_*`]| {2,}\n|$)/,
	    'link': /^(!?\[)((?:\[[^\]]*\]|[^\[\]]|\](?=[^\[]*\]))*)\]\(\s*(?:(?!<)((?:\((?:\\[\s\S]|[^\)])*?\)|\\[\s\S]|[\s\S])*?)|<([\s\S]*?)>)(?:\s+['"]([\s\S]*?)['"])?\s*\)/,
	    'shortcutReference': /^(!?\[)((?:\\[\s\S]|[^\[\]])+?)\]/,
	    'reference': /^(!?\[)((?:\[[^\]]*\]|[^\[\]]|\](?=[^\[]*\]))*)\]\s*\[((?:\\[\s\S]|[^\[\]])*)\]/
	  },
	  'gfm': {
	    'fences': /^( *)(([`~])\3{2,})[ \t]*([^\n`~]+)?[ \t]*(?:\n([\s\S]*?))??(?:\n\ {0,3}\2\3*[ \t]*(?=\n|$)|$)/,
	    'paragraph': /^(?:(?:[^\n]+\n?(?![ \t]*([-*_])( *\1){2,} *(?=\n|$)|( *)(([`~])\5{2,})[ \t]*([^\n`~]+)?[ \t]*(?:\n([\s\S]*?))??(?:\n\ {0,3}\4\5*[ \t]*(?=\n|$)|$)|([ \t]*)((?:[*+-]|\d+\.))[ \t][\s\S]+?(?:(?=\n+\8?(?:[-*_][ \t]*){3,}(?:\n|$))|(?=\n+[ \t]*\[((?:[^\\](?:\\|\\(?:\\{2})+)\]|[^\]])+)\]:[ \t\n]*(<[^>\[\]]+>|[^\s\[\]]+)(?:[ \t\n]+['"(]((?:[^\n]|\n(?!\n))*?)['")])?[ \t]*(?=\n|$))|\n{2,}(?![ \t])(?!\8(?:[*+-]|\d+\.)[ \t])|$)|([ \t]*)(#{1,6})(?:([ \t]+)([^\n]+?))??(?:[ \t]+#+)?[ \t]*(?=\n|$)|(\ {0,3})([^\n]+?)[ \t]*\n\ {0,3}(=|-){1,}[ \t]*(?=\n|$)|[ \t]*\[((?:[^\\](?:\\|\\(?:\\{2})+)\]|[^\]])+)\]:[ \t\n]*(<[^>\[\]]+>|[^\s\[\]]+)(?:[ \t\n]+['"(]((?:[^\n]|\n(?!\n))*?)['")])?[ \t]*(?=\n|$)|(?=[ \t]*>)(?:(?:(?:[ \t]*>[^\n]*\n)*(?:[ \t]*>[^\n]+(?=\n|$))|(?![ \t]*>)(?![ \t]*\[((?:[^\\](?:\\|\\(?:\\{2})+)\]|[^\]])+)\]:[ \t\n]*(<[^>\[\]]+>|[^\s\[\]]+)(?:[ \t\n]+['"(]((?:[^\n]|\n(?!\n))*?)['")])?[ \t]*(?=\n|$))[^\n]+)(?:\n|$))*(?:[ \t]*>[ \t]*(?:\n[ \t]*>[ \t]*)*)?|<(?!(?:a|em|strong|small|s|cite|q|dfn|abbr|data|time|code|var|samp|kbd|sub|sup|i|b|u|mark|ruby|rt|rp|bdi|bdo|span|br|wbr|ins|del|img)\b)(?!mailto:)\w+(?!:\/|[^\w\s@]*@)\b))+)/,
	    'table': /^( *\|(.+))\n( *\|( *[-:]+[-| :]*)\n)((?: *\|.*(?:\n|$))*)/,
	    'looseTable': /^( *(\S.*\|.*))\n( *([-:]+ *\|[-| :]*)\n)((?:.*\|.*(?:\n|$))*)/,
	    'escape': /^\\([\\`*{}\[\]()#+\-.!_>~|])/,
	    'url': /^https?:\/\/[^\s<]+[^<.,:;"')\]\s]/,
	    'deletion': /^~~(?=\S)([\s\S]*?\S)~~/,
	    'inlineText': /^[\s\S]+?(?=[\\<!\[_*`~]|https?:\/\/| {2,}\n|$)/
	  },
	  'footnotes': {
	    'footnoteDefinition': /^( *\[\^([^\]]+)\]: *)([^\n]+((?:\n+ +[^\n]+)*))/
	  },
	  'yaml': {
	    'yamlFrontMatter': /^-{3}\n([\s\S]+?\n)?-{3}/
	  },
	  'pedantic': {
	    'heading': /^([ \t]*)(#{1,6})([ \t]*)([^\n]*?)[ \t]*#*[ \t]*(?=\n|$)/,
	    'strong': /^(_)_(?=\S)([\s\S]*?\S)__(?!_)|^(\*)\*(?=\S)([\s\S]*?\S)\*\*(?!\*)/,
	    'emphasis': /^(_)(?=\S)([\s\S]*?\S)_(?!_)|^(\*)(?=\S)([\s\S]*?\S)\*(?!\*)/
	  },
	  'commonmark': {
	    'list': /^([ \t]*)((?:[*+-]|\d+[\.\)]))[ \t][\s\S]+?(?:(?=\n+\1?(?:[-*_][ \t]*){3,}(?:\n|$))|(?=\n+[ \t]*\[((?:[^\\](?:\\|\\(?:\\{2})+)\]|[^\]])+)\]:[ \t\n]*(<[^>\[\]]+>|[^\s\[\]]+)(?:[ \t\n]+['"(]((?:[^\n]|\n(?!\n))*?)['")])?[ \t]*(?=\n|$))|\n{2,}(?![ \t])(?!\1(?:[*+-]|\d+[\.\)])[ \t])|$)/,
	    'item': /([ \t]*)((?:[*+-]|\d+[\.\)]))( {1,4}(?! )| |\t)[^\n]*(?:\n(?!\1(?:[*+-]|\d+[\.\)])[ \t])[^\n]*)*/gm,
	    'bullet': /(?:[*+-]|\d+[\.\)])/,
	    'indent': /^([ \t]*)((?:[*+-]|\d+[\.\)]))( {1,4}(?! )| |\t)/,
	    'html': /^(?:[ \t]*(?:(?:(?:<(?:article|header|aside|hgroup|blockquote|hr|iframe|body|li|map|button|object|canvas|ol|caption|output|col|p|colgroup|pre|dd|progress|div|section|dl|table|td|dt|tbody|embed|textarea|fieldset|tfoot|figcaption|th|figure|thead|footer|tr|form|ul|h1|h2|h3|h4|h5|h6|video|script|style)(?:(?:\s+)(?:[a-zA-Z_:][a-zA-Z0-9_.:-]*)(?:(?:\s+)?=(?:\s+)?(?:[^"'=<>`]+|'[^']*'|"[^"]*"))?)*(?:\s+)?\/?>?)|(?:<\/(?:article|header|aside|hgroup|blockquote|hr|iframe|body|li|map|button|object|canvas|ol|caption|output|col|p|colgroup|pre|dd|progress|div|section|dl|table|td|dt|tbody|embed|textarea|fieldset|tfoot|figcaption|th|figure|thead|footer|tr|form|ul|h1|h2|h3|h4|h5|h6|video|script|style)(?:\s+)?>))|(?:<!--(?!-?>)(?:[^-]|-(?!-))*-->)|(?:<\?(?:[^\?]|\?(?!>))+\?>)|(?:<![a-zA-Z]+\s+[\s\S]+?>)|(?:<!\[CDATA\[[\s\S]+?\]\]>))[\s\S]*?[ \t]*?(?:\n{2,}|\s*$))/i,
	    'tag': /^(?:(?:<(?:[a-zA-Z][a-zA-Z0-9]*)(?:(?:\s+)(?:[a-zA-Z_:][a-zA-Z0-9_.:-]*)(?:(?:\s+)?=(?:\s+)?(?:[^"'=<>`]+|'[^']*'|"[^"]*"))?)*(?:\s+)?\/?>)|(?:<\/(?:[a-zA-Z][a-zA-Z0-9]*)(?:\s+)?>)|(?:<!--(?!-?>)(?:[^-]|-(?!-))*-->)|(?:<\?(?:[^\?]|\?(?!>))+\?>)|(?:<![a-zA-Z]+\s+[\s\S]+?>)|(?:<!\[CDATA\[[\s\S]+?\]\]>))/,
	    'link': /^(!?\[)((?:(?:\[(?:\[(?:\\[\s\S]|[^\[\]])*?\]|\\[\s\S]|[^\[\]])*?\])|\\[\s\S]|[^\[\]])*?)\]\(\s*(?:(?!<)((?:(?:\((?:\\[\s\S]|[^\(\)\s])*?\)|\\[\s\S]|[^\(\)\s])*?))|<([^\n]*?)>)(?:\s+(?:\'((?:\\[\s\S]|[^\'])*?)\'|"((?:\\[\s\S]|[^"])*?)"|\(((?:\\[\s\S]|[^\)])*?)\)))?\s*\)/,
	    'reference': /^(!?\[)((?:(?:\[(?:\[(?:\\[\s\S]|[^\[\]])*?\]|\\[\s\S]|[^\[\]])*?\])|\\[\s\S]|[^\[\]])*?)\]\s*\[((?:\\[\s\S]|[^\[\]])*)\]/,
	    'paragraph': /^(?:(?:[^\n]+\n?(?!\ {0,3}([-*_])( *\1){2,} *(?=\n|$)|(\ {0,3})(#{1,6})(?:([ \t]+)([^\n]+?))??(?:[ \t]+#+)?\ {0,3}(?=\n|$)|(?=\ {0,3}>)(?:(?:(?:\ {0,3}>[^\n]*\n)*(?:\ {0,3}>[^\n]+(?=\n|$))|(?!\ {0,3}>)(?!\ {0,3}\[((?:[^\\](?:\\|\\(?:\\{2})+)\]|[^\]])+)\]:[ \t\n]*(<[^>\[\]]+>|[^\s\[\]]+)(?:[ \t\n]+['"(]((?:[^\n]|\n(?!\n))*?)['")])?\ {0,3}(?=\n|$))[^\n]+)(?:\n|$))*(?:\ {0,3}>\ {0,3}(?:\n\ {0,3}>\ {0,3})*)?|<(?!(?:a|em|strong|small|s|cite|q|dfn|abbr|data|time|code|var|samp|kbd|sub|sup|i|b|u|mark|ruby|rt|rp|bdi|bdo|span|br|wbr|ins|del|img)\b)(?!mailto:)\w+(?!:\/|[^\w\s@]*@)\b))+)/,
	    'blockquote': /^(?=[ \t]*>)(?:(?:(?:[ \t]*>[^\n]*\n)*(?:[ \t]*>[^\n]+(?=\n|$))|(?![ \t]*>)(?![ \t]*([-*_])( *\1){2,} *(?=\n|$)|([ \t]*)((?:[*+-]|\d+\.))[ \t][\s\S]+?(?:(?=\n+\3?(?:[-*_][ \t]*){3,}(?:\n|$))|(?=\n+[ \t]*\[((?:[^\\](?:\\|\\(?:\\{2})+)\]|[^\]])+)\]:[ \t\n]*(<[^>\[\]]+>|[^\s\[\]]+)(?:[ \t\n]+['"(]((?:[^\n]|\n(?!\n))*?)['")])?[ \t]*(?=\n|$))|\n{2,}(?![ \t])(?!\3(?:[*+-]|\d+\.)[ \t])|$)|( *)(([`~])\10{2,})[ \t]*([^\n`~]+)?[ \t]*(?:\n([\s\S]*?))??(?:\n\ {0,3}\9\10*[ \t]*(?=\n|$)|$)|((?:(?: {4}|\t)[^\n]*\n?((?:[ \t]*\n)*))+)|[ \t]*\[((?:[^\\](?:\\|\\(?:\\{2})+)\]|[^\]])+)\]:[ \t\n]*(<[^>\[\]]+>|[^\s\[\]]+)(?:[ \t\n]+['"(]((?:[^\n]|\n(?!\n))*?)['")])?[ \t]*(?=\n|$))[^\n]+)(?:\n|$))*(?:[ \t]*>[ \t]*(?:\n[ \t]*>[ \t]*)*)?/,
	    'escape': /^\\(\n|[\\`*{}\[\]()#+\-.!_>"$%&',\/:;<=?@^~|])/
	  },
	  'commonmarkGFM': {
	    'paragraph': /^(?:(?:[^\n]+\n?(?!\ {0,3}([-*_])( *\1){2,} *(?=\n|$)|( *)(([`~])\5{2,})\ {0,3}([^\n`~]+)?\ {0,3}(?:\n([\s\S]*?))??(?:\n\ {0,3}\4\5*\ {0,3}(?=\n|$)|$)|(\ {0,3})((?:[*+-]|\d+\.))[ \t][\s\S]+?(?:(?=\n+\8?(?:[-*_]\ {0,3}){3,}(?:\n|$))|(?=\n+\ {0,3}\[((?:[^\\](?:\\|\\(?:\\{2})+)\]|[^\]])+)\]:[ \t\n]*(<[^>\[\]]+>|[^\s\[\]]+)(?:[ \t\n]+['"(]((?:[^\n]|\n(?!\n))*?)['")])?\ {0,3}(?=\n|$))|\n{2,}(?![ \t])(?!\8(?:[*+-]|\d+\.)[ \t])|$)|(\ {0,3})(#{1,6})(?:([ \t]+)([^\n]+?))??(?:[ \t]+#+)?\ {0,3}(?=\n|$)|(?=\ {0,3}>)(?:(?:(?:\ {0,3}>[^\n]*\n)*(?:\ {0,3}>[^\n]+(?=\n|$))|(?!\ {0,3}>)(?!\ {0,3}\[((?:[^\\](?:\\|\\(?:\\{2})+)\]|[^\]])+)\]:[ \t\n]*(<[^>\[\]]+>|[^\s\[\]]+)(?:[ \t\n]+['"(]((?:[^\n]|\n(?!\n))*?)['")])?\ {0,3}(?=\n|$))[^\n]+)(?:\n|$))*(?:\ {0,3}>\ {0,3}(?:\n\ {0,3}>\ {0,3})*)?|<(?!(?:a|em|strong|small|s|cite|q|dfn|abbr|data|time|code|var|samp|kbd|sub|sup|i|b|u|mark|ruby|rt|rp|bdi|bdo|span|br|wbr|ins|del|img)\b)(?!mailto:)\w+(?!:\/|[^\w\s@]*@)\b))+)/
	  },
	  'breaks': {
	    'break': /^ *\n(?!\s*$)/,
	    'inlineText': /^[\s\S]+?(?=[\\<!\[_*`]| *\n|$)/
	  },
	  'breaksGFM': {
	    'inlineText': /^[\s\S]+?(?=[\\<!\[_*`~]|https?:\/\/| *\n|$)/
	  }
	};


/***/ }),
/* 1484 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author Titus Wormer
	 * @copyright 2015 Titus Wormer
	 * @license MIT
	 * @module mdast:parse
	 * @version 2.3.2
	 * @fileoverview Parse a markdown document into an
	 *   abstract syntax tree.
	 */
	
	'use strict';
	
	/* eslint-env commonjs */
	
	/*
	 * Dependencies.
	 */
	
	var he = __webpack_require__(532);
	var repeat = __webpack_require__(401);
	var trim = __webpack_require__(840);
	var trimTrailingLines = __webpack_require__(2235);
	var extend = __webpack_require__(523);
	var utilities = __webpack_require__(572);
	var defaultExpressions = __webpack_require__(1483);
	var defaultOptions = __webpack_require__(571).parse;
	
	/*
	 * Methods.
	 */
	
	var raise = utilities.raise;
	var clean = utilities.clean;
	var validate = utilities.validate;
	var normalize = utilities.normalizeIdentifier;
	var arrayPush = [].push;
	
	/*
	 * Characters.
	 */
	
	var AT_SIGN = '@';
	var CARET = '^';
	var EQUALS = '=';
	var EXCLAMATION_MARK = '!';
	var MAILTO_PROTOCOL = 'mailto:';
	var NEW_LINE = '\n';
	var SPACE = ' ';
	var TAB = '\t';
	var EMPTY = '';
	var LT = '<';
	var GT = '>';
	var BRACKET_OPEN = '[';
	
	/*
	 * Types.
	 */
	
	var BLOCK = 'block';
	var INLINE = 'inline';
	var HORIZONTAL_RULE = 'horizontalRule';
	var HTML = 'html';
	var YAML = 'yaml';
	var TABLE = 'table';
	var TABLE_CELL = 'tableCell';
	var TABLE_HEADER = 'tableHeader';
	var TABLE_ROW = 'tableRow';
	var PARAGRAPH = 'paragraph';
	var TEXT = 'text';
	var CODE = 'code';
	var LIST = 'list';
	var LIST_ITEM = 'listItem';
	var FOOTNOTE_DEFINITION = 'footnoteDefinition';
	var HEADING = 'heading';
	var BLOCKQUOTE = 'blockquote';
	var LINK = 'link';
	var IMAGE = 'image';
	var FOOTNOTE = 'footnote';
	var ESCAPE = 'escape';
	var STRONG = 'strong';
	var EMPHASIS = 'emphasis';
	var DELETE = 'delete';
	var INLINE_CODE = 'inlineCode';
	var BREAK = 'break';
	var ROOT = 'root';
	
	/**
	 * Wrapper around he's `decode` function.
	 *
	 * @example
	 *   decode('&amp;'); // '&'
	 *   decode('&amp'); // '&'
	 *
	 * @param {string} value
	 * @param {function(string)} eat
	 * @return {string}
	 * @throws {Error} - When `eat.file.quiet` is not `true`.
	 *   However, by default `he` does not throw on incorrect
	 *   encoded entities, but when
	 *   `he.decode.options.strict: true`, they occur on
	 *   entities with a missing closing semi-colon.
	 */
	function decode(value, eat) {
	    try {
	        return he.decode(value);
	    } catch (exception) {
	        eat.file.fail(exception, eat.now());
	    }
	}
	
	/**
	 * Factory to de-escape a value, based on an expression
	 * at `key` in `scope`.
	 *
	 * @example
	 *   var expressions = {escape: /\\(a)/}
	 *   var descape = descapeFactory(expressions, 'escape');
	 *
	 * @param {Object} scope - Map of expressions.
	 * @param {string} key - Key in `map` at which the
	 *   non-global expression exists.
	 * @return {function(string): string} - Function which
	 *   takes a value and returns its unescaped version.
	 */
	function descapeFactory(scope, key) {
	    var globalExpression;
	    var expression;
	
	    /**
	     * Private method to get a global expression
	     * from the expression at `key` in `scope`.
	     * This method is smart about not recreating
	     * the expressions every time.
	     *
	     * @private
	     * @return {RegExp}
	     */
	    function generate() {
	        if (scope[key] !== globalExpression) {
	            globalExpression = scope[key];
	            expression = new RegExp(
	                scope[key].source.replace(CARET, EMPTY), 'g'
	            );
	        }
	
	        return expression;
	    }
	
	    /**
	     * De-escape a string using the expression at `key`
	     * in `scope`.
	     *
	     * @example
	     *   var expressions = {escape: /\\(a)/}
	     *   var descape = descapeFactory(expressions, 'escape');
	     *   descape('\a'); // 'a'
	     *
	     * @param {string} value - Escaped string.
	     * @return {string} - Unescaped string.
	     */
	    function descape(value) {
	        return value.replace(generate(), '$1');
	    }
	
	    return descape;
	}
	
	/*
	 * Tab size.
	 */
	
	var TAB_SIZE = 4;
	
	/*
	 * Expressions.
	 */
	
	var EXPRESSION_RIGHT_ALIGNMENT = /^[ \t]*-+:[ \t]*$/;
	var EXPRESSION_CENTER_ALIGNMENT = /^[ \t]*:-+:[ \t]*$/;
	var EXPRESSION_LEFT_ALIGNMENT = /^[ \t]*:-+[ \t]*$/;
	var EXPRESSION_TABLE_FENCE = /^[ \t]*|\|[ \t]*$/g;
	var EXPRESSION_TABLE_BORDER = /[ \t]*\|[ \t]*/;
	var EXPRESSION_BLOCK_QUOTE = /^[ \t]*>[ \t]?/gm;
	var EXPRESSION_BULLET = /^([ \t]*)([*+-]|\d+[.)])( {1,4}(?! )| |\t)([^\n]*)/;
	var EXPRESSION_PEDANTIC_BULLET = /^([ \t]*)([*+-]|\d+[.)])([ \t]+)/;
	var EXPRESSION_INITIAL_INDENT = /^( {1,4}|\t)?/gm;
	var EXPRESSION_INITIAL_TAB = /^( {4}|\t)?/gm;
	var EXPRESSION_HTML_LINK_OPEN = /^<a /i;
	var EXPRESSION_HTML_LINK_CLOSE = /^<\/a>/i;
	var EXPRESSION_LOOSE_LIST_ITEM = /\n\n(?!\s*$)/;
	var EXPRESSION_TASK_ITEM = /^\[([\ \t]|x|X)\][\ \t]/;
	
	/*
	 * A map of characters, and their column length,
	 * which can be used as indentation.
	 */
	
	var INDENTATION_CHARACTERS = {};
	
	INDENTATION_CHARACTERS[SPACE] = SPACE.length;
	INDENTATION_CHARACTERS[TAB] = TAB_SIZE;
	
	/**
	 * Gets indentation information for a line.
	 *
	 * @example
	 *   getIndent('  foo');
	 *   // {indent: 2, stops: {1: 0, 2: 1}}
	 *
	 *   getIndent('\tfoo');
	 *   // {indent: 4, stops: {4: 0}}
	 *
	 *   getIndent('  \tfoo');
	 *   // {indent: 4, stops: {1: 0, 2: 1, 4: 2}}
	 *
	 *   getIndent('\t  foo')
	 *   // {indent: 6, stops: {4: 0, 5: 1, 6: 2}}
	 *
	 * @param {string} value - Indented line.
	 * @return {Object}
	 */
	function getIndent(value) {
	    var index = 0;
	    var indent = 0;
	    var character = value.charAt(index);
	    var stops = {};
	    var size;
	
	    while (character in INDENTATION_CHARACTERS) {
	        size = INDENTATION_CHARACTERS[character];
	
	        indent += size;
	
	        if (size > 1) {
	            indent = Math.floor(indent / size) * size;
	        }
	
	        stops[indent] = index;
	
	        character = value.charAt(++index);
	    }
	
	    return {
	        'indent': indent,
	        'stops': stops
	    };
	}
	
	/**
	 * Remove the minimum indent from every line in `value`.
	 * Supports both tab, spaced, and mixed indentation (as
	 * well as possible).
	 *
	 * @example
	 *   removeIndentation('  foo'); // 'foo'
	 *   removeIndentation('    foo', 2); // '  foo'
	 *   removeIndentation('\tfoo', 2); // '  foo'
	 *   removeIndentation('  foo\n bar'); // ' foo\n bar'
	 *
	 * @param {string} value
	 * @param {number?} [maximum] - Maximum indentation
	 *   to remove.
	 * @return {string} - Unindented `value`.
	 */
	function removeIndentation(value, maximum) {
	    var values = value.split(NEW_LINE);
	    var position = values.length + 1;
	    var minIndent = Infinity;
	    var matrix = [];
	    var index;
	    var indentation;
	    var stops;
	    var padding;
	
	    values.unshift(repeat(SPACE, maximum) + EXCLAMATION_MARK);
	
	    while (position--) {
	        indentation = getIndent(values[position]);
	
	        matrix[position] = indentation.stops;
	
	        if (trim(values[position]).length === 0) {
	            continue;
	        }
	
	        if (indentation.indent) {
	            if (indentation.indent > 0 && indentation.indent < minIndent) {
	                minIndent = indentation.indent;
	            }
	        } else {
	            minIndent = Infinity;
	
	            break;
	        }
	    }
	
	    if (minIndent !== Infinity) {
	        position = values.length;
	
	        while (position--) {
	            stops = matrix[position];
	            index = minIndent;
	
	            while (index && !(index in stops)) {
	                index--;
	            }
	
	            if (
	                trim(values[position]).length !== 0 &&
	                minIndent &&
	                index !== minIndent
	            ) {
	                padding = TAB;
	            } else {
	                padding = EMPTY;
	            }
	
	            values[position] = padding + values[position].slice(
	                index in stops ? stops[index] + 1 : 0
	            );
	        }
	    }
	
	    values.shift();
	
	    return values.join(NEW_LINE);
	}
	
	/**
	 * Ensure that `value` is at least indented with
	 * `indent` spaces.  Does not support tabs. Does support
	 * multiple lines.
	 *
	 * @example
	 *   ensureIndentation('foo', 2); // '  foo'
	 *   ensureIndentation('  foo', 4); // '    foo'
	 *
	 * @param {string} value
	 * @param {number} indent - The maximum amount of
	 *   spacing to insert.
	 * @return {string} - indented `value`.
	 */
	function ensureIndentation(value, indent) {
	    var values = value.split(NEW_LINE);
	    var length = values.length;
	    var index = -1;
	    var line;
	    var position;
	
	    while (++index < length) {
	        line = values[index];
	
	        position = -1;
	
	        while (++position < indent) {
	            if (line.charAt(position) !== SPACE) {
	                values[index] = repeat(SPACE, indent - position) + line;
	                break;
	            }
	        }
	    }
	
	    return values.join(NEW_LINE);
	}
	
	/**
	 * Get the alignment from a table rule.
	 *
	 * @example
	 *   getAlignment([':-', ':-:', '-:', '--']);
	 *   // ['left', 'center', 'right', null];
	 *
	 * @param {Array.<string>} cells
	 * @return {Array.<string?>}
	 */
	function getAlignment(cells) {
	    var results = [];
	    var index = -1;
	    var length = cells.length;
	    var alignment;
	
	    while (++index < length) {
	        alignment = cells[index];
	
	        if (EXPRESSION_RIGHT_ALIGNMENT.test(alignment)) {
	            results[index] = 'right';
	        } else if (EXPRESSION_CENTER_ALIGNMENT.test(alignment)) {
	            results[index] = 'center';
	        } else if (EXPRESSION_LEFT_ALIGNMENT.test(alignment)) {
	            results[index] = 'left';
	        } else {
	            results[index] = null;
	        }
	    }
	
	    return results;
	}
	
	/**
	 * Construct a state `toggler`: a function which inverses
	 * `property` in context based on its current value.
	 * The by `toggler` returned function restores that value.
	 *
	 * @example
	 *   var context = {};
	 *   var key = 'foo';
	 *   var val = true;
	 *   context[key] = val;
	 *   context.enter = stateToggler(key, val);
	 *   context[key]; // true
	 *   var exit = context.enter();
	 *   context[key]; // false
	 *   var nested = context.enter();
	 *   context[key]; // false
	 *   nested();
	 *   context[key]; // false
	 *   exit();
	 *   context[key]; // true
	 *
	 * @param {string} key - Property to toggle.
	 * @param {boolean} state - It's default state.
	 * @return {function(): function()} - Enter.
	 */
	function stateToggler(key, state) {
	    /**
	     * Construct a toggler for the bound `key`.
	     *
	     * @return {Function} - Exit state.
	     */
	    function enter() {
	        var self = this;
	        var current = self[key];
	
	        self[key] = !state;
	
	        /**
	         * State canceler, cancels the state, if allowed.
	         */
	        function exit() {
	            self[key] = current;
	        }
	
	        return exit;
	    }
	
	    return enter;
	}
	
	/**
	 * Construct a state toggler which doesn't toggle.
	 *
	 * @example
	 *   var context = {};
	 *   var key = 'foo';
	 *   var val = true;
	 *   context[key] = val;
	 *   context.enter = noopToggler();
	 *   context[key]; // true
	 *   var exit = context.enter();
	 *   context[key]; // true
	 *   exit();
	 *   context[key]; // true
	 *
	 * @return {function(): function()} - Enter.
	 */
	function noopToggler() {
	    /**
	     * No-operation.
	     */
	    function exit() {}
	
	    /**
	     * @return {Function}
	     */
	    function enter() {
	        return exit;
	    }
	
	    return enter;
	}
	
	/*
	 * Define nodes of a type which can be merged.
	 */
	
	var MERGEABLE_NODES = {};
	
	/**
	 * Merge two text nodes: `node` into `prev`.
	 *
	 * @param {Object} prev - Preceding sibling.
	 * @param {Object} node - Following sibling.
	 * @return {Object} - `prev`.
	 */
	MERGEABLE_NODES.text = function (prev, node) {
	    prev.value += node.value;
	
	    return prev;
	};
	
	/**
	 * Merge two blockquotes: `node` into `prev`, unless in
	 * CommonMark mode.
	 *
	 * @param {Object} prev - Preceding sibling.
	 * @param {Object} node - Following sibling.
	 * @return {Object} - `prev`, or `node` in CommonMark mode.
	 */
	MERGEABLE_NODES.blockquote = function (prev, node) {
	    if (this.options.commonmark) {
	        return node;
	    }
	
	    prev.children = prev.children.concat(node.children);
	
	    return prev;
	};
	
	/**
	 * Merge two lists: `node` into `prev`. Knows, about
	 * which bullets were used.
	 *
	 * @param {Object} prev - Preceding sibling.
	 * @param {Object} node - Following sibling.
	 * @return {Object} - `prev`, or `node` when the lists are
	 *   of different types (a different bullet is used).
	 */
	MERGEABLE_NODES.list = function (prev, node) {
	    if (
	        !this.currentBullet ||
	        this.currentBullet !== this.previousBullet ||
	        this.currentBullet.length !== 1
	    ) {
	        return node;
	    }
	
	    prev.children = prev.children.concat(node.children);
	
	    return prev;
	};
	
	/**
	 * Tokenise a line.  Unsets `currentBullet` and
	 * `previousBullet` if more than one lines are found, thus
	 * preventing lists from merging when they use different
	 * bullets.
	 *
	 * @example
	 *   tokenizeNewline(eat, '\n\n');
	 *
	 * @param {function(string)} eat
	 * @param {string} $0 - Lines.
	 */
	function tokenizeNewline(eat, $0) {
	    if ($0.length > 1) {
	        this.currentBullet = null;
	        this.previousBullet = null;
	    }
	
	    eat($0);
	}
	
	/**
	 * Tokenise an indented code block.
	 *
	 * @example
	 *   tokenizeCode(eat, '\tfoo');
	 *
	 * @param {function(string)} eat
	 * @param {string} $0 - Whole code.
	 * @return {Node} - `code` node.
	 */
	function tokenizeCode(eat, $0) {
	    $0 = trimTrailingLines($0);
	
	    return eat($0)(this.renderCodeBlock(
	        removeIndentation($0, TAB_SIZE), null, eat)
	    );
	}
	
	/**
	 * Tokenise a fenced code block.
	 *
	 * @example
	 *   var $0 = '```js\nfoo()\n```';
	 *   tokenizeFences(eat, $0, '', '```', '`', 'js', 'foo()\n');
	 *
	 * @param {function(string)} eat
	 * @param {string} $0 - Whole code.
	 * @param {string} $1 - Initial spacing.
	 * @param {string} $2 - Initial fence.
	 * @param {string} $3 - Fence marker.
	 * @param {string} $4 - Programming language flag.
	 * @param {string} $5 - Content.
	 * @return {Node} - `code` node.
	 */
	function tokenizeFences(eat, $0, $1, $2, $3, $4, $5) {
	    $0 = trimTrailingLines($0);
	
	    /*
	     * If the initial fence was preceded by spaces,
	     * exdent that amount of white space from the code
	     * block.  Because it's possible that the code block
	     * is exdented, we first have to ensure at least
	     * those spaces are available.
	     */
	
	    if ($1) {
	        $5 = removeIndentation(ensureIndentation($5, $1.length), $1.length);
	    }
	
	    return eat($0)(this.renderCodeBlock($5, $4, eat));
	}
	
	/**
	 * Tokenise an ATX-style heading.
	 *
	 * @example
	 *   tokenizeHeading(eat, ' # foo', ' ', '#', ' ', 'foo');
	 *
	 * @param {function(string)} eat
	 * @param {string} $0 - Whole heading.
	 * @param {string} $1 - Initial spacing.
	 * @param {string} $2 - Hashes.
	 * @param {string} $3 - Internal spacing.
	 * @param {string} $4 - Content.
	 * @return {Node} - `heading` node.
	 */
	function tokenizeHeading(eat, $0, $1, $2, $3, $4) {
	    var now = eat.now();
	
	    now.column += ($1 + $2 + ($3 || '')).length;
	
	    return eat($0)(this.renderHeading($4, $2.length, now));
	}
	
	/**
	 * Tokenise a Setext-style heading.
	 *
	 * @example
	 *   tokenizeLineHeading(eat, 'foo\n===', '', 'foo', '=');
	 *
	 * @param {function(string)} eat
	 * @param {string} $0 - Whole heading.
	 * @param {string} $1 - Initial spacing.
	 * @param {string} $2 - Content.
	 * @param {string} $3 - Underline marker.
	 * @return {Node} - `heading` node.
	 */
	function tokenizeLineHeading(eat, $0, $1, $2, $3) {
	    var now = eat.now();
	
	    now.column += $1.length;
	
	    return eat($0)(this.renderHeading($2, $3 === EQUALS ? 1 : 2, now));
	}
	
	/**
	 * Tokenise a horizontal rule.
	 *
	 * @example
	 *   tokenizeHorizontalRule(eat, '***');
	 *
	 * @param {function(string)} eat
	 * @param {string} $0 - Whole rule.
	 * @return {Node} - `horizontalRule` node.
	 */
	function tokenizeHorizontalRule(eat, $0) {
	    return eat($0)(this.renderVoid(HORIZONTAL_RULE));
	}
	
	/**
	 * Tokenise a blockquote.
	 *
	 * @example
	 *   tokenizeBlockquote(eat, '> Foo');
	 *
	 * @param {function(string)} eat
	 * @param {string} $0 - Whole blockquote.
	 * @return {Node} - `blockquote` node.
	 */
	function tokenizeBlockquote(eat, $0) {
	    var now = eat.now();
	    var indent = this.indent(now.line);
	    var value = trimTrailingLines($0);
	    var add = eat(value);
	
	    value = value.replace(EXPRESSION_BLOCK_QUOTE, function (prefix) {
	        indent(prefix.length);
	
	        return '';
	    });
	
	    return add(this.renderBlockquote(value, now));
	}
	
	/**
	 * Tokenise a list.
	 *
	 * @example
	 *   tokenizeList(eat, '- Foo', '', '-');
	 *
	 * @param {function(string)} eat
	 * @param {string} $0 - Whole list.
	 * @param {string} $1 - Indent.
	 * @param {string} $2 - Bullet.
	 * @return {Node} - `list` node.
	 */
	function tokenizeList(eat, $0, $1, $2) {
	    var self = this;
	    var firstBullet = $2;
	    var value = trimTrailingLines($0);
	    var matches = value.match(self.rules.item);
	    var length = matches.length;
	    var index = 0;
	    var isLoose = false;
	    var now;
	    var bullet;
	    var item;
	    var enterTop;
	    var exitBlockquote;
	    var node;
	    var indent;
	    var size;
	    var position;
	    var end;
	
	    /*
	     * Determine if all list-items belong to the
	     * same list.
	     */
	
	    if (!self.options.pedantic) {
	        while (++index < length) {
	            bullet = self.rules.bullet.exec(matches[index])[0];
	
	            if (
	                firstBullet !== bullet &&
	                (
	                    firstBullet.length === 1 && bullet.length === 1 ||
	                    bullet.charAt(bullet.length - 1) !==
	                    firstBullet.charAt(firstBullet.length - 1)
	                )
	            ) {
	                matches = matches.slice(0, index);
	                matches[index - 1] = trimTrailingLines(matches[index - 1]);
	
	                length = matches.length;
	
	                break;
	            }
	        }
	    }
	
	    if (self.options.commonmark) {
	        index = -1;
	
	        while (++index < length) {
	            item = matches[index];
	            indent = self.rules.indent.exec(item);
	            indent = indent[1] + repeat(SPACE, indent[2].length) + indent[3];
	            size = getIndent(indent).indent;
	            position = indent.length;
	            end = item.length;
	
	            while (++position < end) {
	                if (
	                    item.charAt(position) === NEW_LINE &&
	                    item.charAt(position - 1) === NEW_LINE &&
	                    getIndent(item.slice(position + 1)).indent < size
	                ) {
	                    matches[index] = item.slice(0, position - 1);
	
	                    matches = matches.slice(0, index + 1);
	                    length = matches.length;
	
	                    break;
	                }
	            }
	        }
	    }
	
	    self.previousBullet = self.currentBullet;
	    self.currentBullet = firstBullet;
	
	    index = -1;
	
	    node = eat(matches.join(NEW_LINE)).reset(
	        self.renderList([], firstBullet)
	    );
	
	    enterTop = self.exitTop();
	    exitBlockquote = self.enterBlockquote();
	
	    while (++index < length) {
	        item = matches[index];
	        now = eat.now();
	
	        item = eat(item)(self.renderListItem(item, now), node);
	
	        if (item.loose) {
	            isLoose = true;
	        }
	
	        if (index !== length - 1) {
	            eat(NEW_LINE);
	        }
	    }
	
	    node.loose = isLoose;
	
	    enterTop();
	    exitBlockquote();
	
	    return node;
	}
	
	/**
	 * Tokenise HTML.
	 *
	 * @example
	 *   tokenizeHtml(eat, '<span>foo</span>');
	 *
	 * @param {function(string)} eat
	 * @param {string} $0 - Whole HTML.
	 * @return {Node} - `html` node.
	 */
	function tokenizeHtml(eat, $0) {
	    $0 = trimTrailingLines($0);
	
	    return eat($0)(this.renderRaw(HTML, $0));
	}
	
	/**
	 * Tokenise a definition.
	 *
	 * @example
	 *   var $0 = '[foo]: http://example.com "Example Domain"';
	 *   var $1 = 'foo';
	 *   var $2 = 'http://example.com';
	 *   var $3 = 'Example Domain';
	 *   tokenizeDefinition(eat, $0, $1, $2, $3);
	 *
	 * @property {boolean} onlyAtTop
	 * @property {boolean} notInBlockquote
	 * @param {function(string)} eat
	 * @param {string} $0 - Whole definition.
	 * @param {string} $1 - Key.
	 * @param {string} $2 - URL.
	 * @param {string} $3 - Title.
	 * @return {Node} - `definition` node.
	 */
	function tokenizeDefinition(eat, $0, $1, $2, $3) {
	    var link = $2;
	
	    /*
	     * Remove angle-brackets from `link`.
	     */
	
	    if (link.charAt(0) === LT && link.charAt(link.length - 1) === GT) {
	        link = link.slice(1, -1);
	    }
	
	    return eat($0)({
	        'type': 'definition',
	        'identifier': normalize($1),
	        'title': $3 ? decode(this.descape($3), eat) : null,
	        'link': decode(this.descape(link), eat)
	    });
	}
	
	tokenizeDefinition.onlyAtTop = true;
	tokenizeDefinition.notInBlockquote = true;
	
	/**
	 * Tokenise YAML front matter.
	 *
	 * @example
	 *   var $0 = '---\nfoo: bar\n---';
	 *   var $1 = 'foo: bar';
	 *   tokenizeYAMLFrontMatter(eat, $0, $1);
	 *
	 * @property {boolean} onlyAtStart
	 * @param {function(string)} eat
	 * @param {string} $0 - Whole front matter.
	 * @param {string} $1 - Content.
	 * @return {Node} - `yaml` node.
	 */
	function tokenizeYAMLFrontMatter(eat, $0, $1) {
	    return eat($0)(this.renderRaw(YAML, $1 ? trimTrailingLines($1) : EMPTY));
	}
	
	tokenizeYAMLFrontMatter.onlyAtStart = true;
	
	/**
	 * Tokenise a footnote definition.
	 *
	 * @example
	 *   var $0 = '[foo]: Bar.';
	 *   var $1 = '[foo]';
	 *   var $2 = 'foo';
	 *   var $3 = 'Bar.';
	 *   tokenizeFootnoteDefinition(eat, $0, $1, $2, $3);
	 *
	 * @property {boolean} onlyAtTop
	 * @property {boolean} notInBlockquote
	 * @param {function(string)} eat
	 * @param {string} $0 - Whole definition.
	 * @param {string} $1 - Whole key.
	 * @param {string} $2 - Key.
	 * @param {string} $3 - Whole value.
	 * @return {Node} - `footnoteDefinition` node.
	 */
	function tokenizeFootnoteDefinition(eat, $0, $1, $2, $3) {
	    var self = this;
	    var now = eat.now();
	    var indent = self.indent(now.line);
	
	    $3 = $3.replace(EXPRESSION_INITIAL_TAB, function (value) {
	        indent(value.length);
	
	        return EMPTY;
	    });
	
	    now.column += $1.length;
	
	    return eat($0)(self.renderFootnoteDefinition(normalize($2), $3, now));
	}
	
	tokenizeFootnoteDefinition.onlyAtTop = true;
	tokenizeFootnoteDefinition.notInBlockquote = true;
	
	/**
	 * Tokenise a table.
	 *
	 * @example
	 *   var $0 = ' | foo |\n | --- |\n | bar |';
	 *   var $1 = ' | foo |';
	 *   var $2 = '| foo |';
	 *   var $3 = ' | --- |';
	 *   var $4 = '| --- |';
	 *   var $5 = ' | bar |';
	 *   tokenizeTable(eat, $0, $1, $2, $3, $4, $5);
	 *
	 * @property {boolean} onlyAtTop
	 * @param {function(string)} eat
	 * @param {string} $0 - Whole table.
	 * @param {string} $1 - Whole heading.
	 * @param {string} $2 - Trimmed heading.
	 * @param {string} $3 - Whole alignment.
	 * @param {string} $4 - Trimmed alignment.
	 * @param {string} $5 - Rows.
	 * @return {Node} - `table` node.
	 */
	function tokenizeTable(eat, $0, $1, $2, $3, $4, $5) {
	    var self = this;
	    var length;
	    var index;
	    var node;
	
	    $0 = trimTrailingLines($0);
	
	    node = eat($0).reset({
	        'type': TABLE,
	        'align': [],
	        'children': []
	    });
	
	    /**
	     * Eat a row of type `type`.
	     *
	     * @param {string} type - Type of the returned node,
	     *   such as `tableHeader` or `tableRow`.
	     * @param {string} value - Row, including initial and
	     *   final fences.
	     */
	    function renderRow(type, value) {
	        var row = eat(value).reset(self.renderParent(type, []), node);
	        var length = value.length + 1;
	        var index = -1;
	        var queue = '';
	        var cell = '';
	        var preamble = true;
	        var count;
	        var opening;
	        var character;
	        var subvalue;
	        var now;
	
	        while (++index < length) {
	            character = value.charAt(index);
	
	            if (character === '\t' || character === ' ') {
	                if (cell) {
	                    queue += character;
	                } else {
	                    eat(character);
	                }
	
	                continue;
	            }
	
	            if (character === '|' || character === '') {
	                if (preamble) {
	                    eat(character);
	                } else {
	                    if (character && opening) {
	                        // cell += queue + character;
	                        queue += character;
	                        continue;
	                    }
	
	                    if ((cell || character) && !preamble) {
	                        subvalue = cell;
	
	                        if (queue.length > 1) {
	                            if (character) {
	                                subvalue += queue.slice(0, queue.length - 1);
	                                queue = queue.charAt(queue.length - 1);
	                            } else {
	                                subvalue += queue;
	                                queue = '';
	                            }
	                        }
	
	                        now = eat.now();
	
	                        eat(subvalue)(
	                            self.renderInline(TABLE_CELL, cell, now), row
	                        );
	                    }
	
	                    eat(queue + character);
	
	                    queue = '';
	                    cell = '';
	                }
	            } else {
	                if (queue) {
	                    cell += queue;
	                    queue = '';
	                }
	
	                cell += character;
	
	                if (character === '\\' && index !== length - 2) {
	                    cell += value.charAt(index + 1);
	                    index++;
	                }
	
	                if (character === '`') {
	                    count = 1;
	
	                    while (value.charAt(index + 1) === character) {
	                        cell += character;
	                        index++;
	                        count++;
	                    }
	
	                    if (!opening) {
	                        opening = count;
	                    } else if (count >= opening) {
	                        opening = 0;
	                    }
	                }
	            }
	
	            preamble = false;
	        }
	    }
	
	    /*
	     * Add the table's header.
	     */
	
	    renderRow(TABLE_HEADER, $1);
	
	    eat(NEW_LINE);
	
	    /*
	     * Add the table's alignment.
	     */
	
	    eat($3);
	
	    $4 = $4
	        .replace(EXPRESSION_TABLE_FENCE, EMPTY)
	        .split(EXPRESSION_TABLE_BORDER);
	
	    node.align = getAlignment($4);
	
	    /*
	     * Add the table rows to table's children.
	     */
	
	    $5 = trimTrailingLines($5).split(NEW_LINE);
	
	    index = -1;
	    length = $5.length;
	
	    while (++index < length) {
	        renderRow(TABLE_ROW, $5[index]);
	
	        if (index !== length - 1) {
	            eat(NEW_LINE);
	        }
	    }
	
	    return node;
	}
	
	tokenizeTable.onlyAtTop = true;
	
	/**
	 * Tokenise a paragraph node.
	 *
	 * @example
	 *   tokenizeParagraph(eat, 'Foo.');
	 *
	 * @param {function(string)} eat
	 * @param {string} $0 - Whole paragraph.
	 * @return {Node?} - `paragraph` node, when the node does
	 *   not just contain white space.
	 */
	function tokenizeParagraph(eat, $0) {
	    var now = eat.now();
	
	    if (trim($0) === EMPTY) {
	        eat($0);
	
	        return null;
	    }
	
	    $0 = trimTrailingLines($0);
	
	    return eat($0)(this.renderInline(PARAGRAPH, $0, now));
	}
	
	/**
	 * Tokenise a text node.
	 *
	 * @example
	 *   tokenizeText(eat, 'foo');
	 *
	 * @param {function(string)} eat
	 * @param {string} $0 - Whole text.
	 * @return {Node} - `text` node.
	 */
	function tokenizeText(eat, $0) {
	    return eat($0)(this.renderRaw(TEXT, $0));
	}
	
	/**
	 * Create a code-block node.
	 *
	 * @example
	 *   renderCodeBlock('foo()', 'js', now());
	 *
	 * @param {string?} [value] - Code.
	 * @param {string?} [language] - Optional language flag.
	 * @param {Function} eat
	 * @return {Object} - `code` node.
	 */
	function renderCodeBlock(value, language, eat) {
	    return {
	        'type': CODE,
	        'lang': language ? decode(this.descape(language), eat) : null,
	        'value': trimTrailingLines(value || EMPTY)
	    };
	}
	
	/**
	 * Create a list node.
	 *
	 * @example
	 *   var children = [renderListItem('- foo')];
	 *   renderList(children, '-');
	 *
	 * @param {string} children - Children.
	 * @param {string} bullet - First bullet.
	 * @return {Object} - `list` node.
	 */
	function renderList(children, bullet) {
	    var start = parseInt(bullet, 10);
	
	    if (start !== start) {
	        start = null;
	    }
	
	    /*
	     * `loose` should be added later.
	     */
	
	    return {
	        'type': LIST,
	        'ordered': bullet.length > 1,
	        'start': start,
	        'loose': null,
	        'children': children
	    };
	}
	
	/**
	 * Create a list-item using overly simple mechanics.
	 *
	 * @example
	 *   renderPedanticListItem('- _foo_', now());
	 *
	 * @param {string} value - List-item.
	 * @param {Object} position - List-item location.
	 * @return {string} - Cleaned `value`.
	 */
	function renderPedanticListItem(value, position) {
	    var self = this;
	    var indent = self.indent(position.line);
	
	    /**
	     * A simple replacer which removed all matches,
	     * and adds their length to `offset`.
	     *
	     * @param {string} $0
	     * @return {string}
	     */
	    function replacer($0) {
	        indent($0.length);
	
	        return EMPTY;
	    }
	
	    /*
	     * Remove the list-item's bullet.
	     */
	
	    value = value.replace(EXPRESSION_PEDANTIC_BULLET, replacer);
	
	    /*
	     * The initial line was also matched by the below, so
	     * we reset the `line`.
	     */
	
	    indent = self.indent(position.line);
	
	    return value.replace(EXPRESSION_INITIAL_INDENT, replacer);
	}
	
	/**
	 * Create a list-item using sane mechanics.
	 *
	 * @example
	 *   renderNormalListItem('- _foo_', now());
	 *
	 * @param {string} value - List-item.
	 * @param {Object} position - List-item location.
	 * @return {string} - Cleaned `value`.
	 */
	function renderNormalListItem(value, position) {
	    var self = this;
	    var indent = self.indent(position.line);
	    var bullet;
	    var rest;
	    var lines;
	    var trimmedLines;
	    var index;
	    var length;
	    var max;
	
	    /*
	     * Remove the list-item's bullet.
	     */
	
	    value = value.replace(EXPRESSION_BULLET, function ($0, $1, $2, $3, $4) {
	        bullet = $1 + $2 + $3;
	        rest = $4;
	
	       /*
	        * Make sure that the first nine numbered list items
	        * can indent with an extra space.  That is, when
	        * the bullet did not receive an extra final space.
	        */
	
	        if (Number($2) < 10 && bullet.length % 2 === 1) {
	            $2 = SPACE + $2;
	        }
	
	        max = $1 + repeat(SPACE, $2.length) + $3;
	
	        return max + rest;
	    });
	
	    lines = value.split(NEW_LINE);
	
	    trimmedLines = removeIndentation(
	        value, getIndent(max).indent
	    ).split(NEW_LINE);
	
	    /*
	     * We replaced the initial bullet with something
	     * else above, which was used to trick
	     * `removeIndentation` into removing some more
	     * characters when possible. However, that could
	     * result in the initial line to be stripped more
	     * than it should be.
	     */
	
	    trimmedLines[0] = rest;
	
	    indent(bullet.length);
	
	    index = 0;
	    length = lines.length;
	
	    while (++index < length) {
	        indent(lines[index].length - trimmedLines[index].length);
	    }
	
	    return trimmedLines.join(NEW_LINE);
	}
	
	/*
	 * A map of two functions which can create list items.
	 */
	
	var LIST_ITEM_MAP = {};
	
	LIST_ITEM_MAP.true = renderPedanticListItem;
	LIST_ITEM_MAP.false = renderNormalListItem;
	
	/**
	 * Create a list-item node.
	 *
	 * @example
	 *   renderListItem('- _foo_', now());
	 *
	 * @param {Object} value - List-item.
	 * @param {Object} position - List-item location.
	 * @return {Object} - `listItem` node.
	 */
	function renderListItem(value, position) {
	    var self = this;
	    var checked = null;
	    var node;
	    var task;
	    var indent;
	
	    value = LIST_ITEM_MAP[self.options.pedantic].apply(self, arguments);
	
	    if (self.options.gfm) {
	        task = value.match(EXPRESSION_TASK_ITEM);
	
	        if (task) {
	            indent = task[0].length;
	            checked = task[1].toLowerCase() === 'x';
	
	            self.indent(position.line)(indent);
	            value = value.slice(indent);
	        }
	    }
	
	    node = {
	        'type': LIST_ITEM,
	        'loose': EXPRESSION_LOOSE_LIST_ITEM.test(value) ||
	            value.charAt(value.length - 1) === NEW_LINE
	    };
	
	    if (self.options.gfm) {
	        node.checked = checked;
	    }
	
	    node.children = self.tokenizeBlock(value, position);
	
	    return node;
	}
	
	/**
	 * Create a footnote-definition node.
	 *
	 * @example
	 *   renderFootnoteDefinition('1', '_foo_', now());
	 *
	 * @param {string} identifier - Unique reference.
	 * @param {string} value - Contents
	 * @param {Object} position - Definition location.
	 * @return {Object} - `footnoteDefinition` node.
	 */
	function renderFootnoteDefinition(identifier, value, position) {
	    var self = this;
	    var exitBlockquote = self.enterBlockquote();
	    var node;
	
	    node = {
	        'type': FOOTNOTE_DEFINITION,
	        'identifier': identifier,
	        'children': self.tokenizeBlock(value, position)
	    };
	
	    exitBlockquote();
	
	    return node;
	}
	
	/**
	 * Create a heading node.
	 *
	 * @example
	 *   renderHeading('_foo_', 1, now());
	 *
	 * @param {string} value - Content.
	 * @param {number} depth - Heading depth.
	 * @param {Object} position - Heading content location.
	 * @return {Object} - `heading` node
	 */
	function renderHeading(value, depth, position) {
	    return {
	        'type': HEADING,
	        'depth': depth,
	        'children': this.tokenizeInline(value, position)
	    };
	}
	
	/**
	 * Create a blockquote node.
	 *
	 * @example
	 *   renderBlockquote('_foo_', eat);
	 *
	 * @param {string} value - Content.
	 * @param {Object} now - Position.
	 * @return {Object} - `blockquote` node.
	 */
	function renderBlockquote(value, now) {
	    var self = this;
	    var exitBlockquote = self.enterBlockquote();
	    var node = {
	        'type': BLOCKQUOTE,
	        'children': this.tokenizeBlock(value, now)
	    };
	
	    exitBlockquote();
	
	    return node;
	}
	
	/**
	 * Create a void node.
	 *
	 * @example
	 *   renderVoid('horizontalRule');
	 *
	 * @param {string} type - Node type.
	 * @return {Object} - Node of type `type`.
	 */
	function renderVoid(type) {
	    return {
	        'type': type
	    };
	}
	
	/**
	 * Create a parent.
	 *
	 * @example
	 *   renderParent('paragraph', '_foo_');
	 *
	 * @param {string} type - Node type.
	 * @param {Array.<Object>} children - Child nodes.
	 * @return {Object} - Node of type `type`.
	 */
	function renderParent(type, children) {
	    return {
	        'type': type,
	        'children': children
	    };
	}
	
	/**
	 * Create a raw node.
	 *
	 * @example
	 *   renderRaw('inlineCode', 'foo()');
	 *
	 * @param {string} type - Node type.
	 * @param {string} value - Contents.
	 * @return {Object} - Node of type `type`.
	 */
	function renderRaw(type, value) {
	    return {
	        'type': type,
	        'value': value
	    };
	}
	
	/**
	 * Create a link node.
	 *
	 * @example
	 *   renderLink(true, 'example.com', 'example', 'Example Domain', now(), eat);
	 *   renderLink(false, 'fav.ico', 'example', 'Example Domain', now(), eat);
	 *
	 * @param {boolean} isLink - Whether linking to a document
	 *   or an image.
	 * @param {string} href - URI reference.
	 * @param {string} text - Content.
	 * @param {string?} title - Title.
	 * @param {Object} position - Location of link.
	 * @param {function(string)} eat
	 * @return {Object} - `link` or `image` node.
	 */
	function renderLink(isLink, href, text, title, position, eat) {
	    var self = this;
	    var exitLink = self.enterLink();
	    var node;
	
	    node = {
	        'type': isLink ? LINK : IMAGE,
	        'title': title ? decode(self.descape(title), eat) : null
	    };
	
	    href = decode(href, eat);
	
	    if (isLink) {
	        node.href = href;
	        node.children = self.tokenizeInline(text, position);
	    } else {
	        node.src = href;
	        node.alt = text ? decode(self.descape(text), eat) : null;
	    }
	
	    exitLink();
	
	    return node;
	}
	
	/**
	 * Create a footnote node.
	 *
	 * @example
	 *   renderFootnote('_foo_', now());
	 *
	 * @param {string} value - Contents.
	 * @param {Object} position - Location of footnote.
	 * @return {Object} - `footnote` node.
	 */
	function renderFootnote(value, position) {
	    return this.renderInline(FOOTNOTE, value, position);
	}
	
	/**
	 * Add a node with inline content.
	 *
	 * @example
	 *   renderInline('strong', '_foo_', now());
	 *
	 * @param {string} type - Node type.
	 * @param {string} value - Contents.
	 * @param {Object} position - Location of node.
	 * @return {Object} - Node of type `type`.
	 */
	function renderInline(type, value, position) {
	    return this.renderParent(type, this.tokenizeInline(value, position));
	}
	
	/**
	 * Add a node with block content.
	 *
	 * @example
	 *   renderBlock('blockquote', 'Foo.', now());
	 *
	 * @param {string} type - Node type.
	 * @param {string} value - Contents.
	 * @param {Object} position - Location of node.
	 * @return {Object} - Node of type `type`.
	 */
	function renderBlock(type, value, position) {
	    return this.renderParent(type, this.tokenizeBlock(value, position));
	}
	
	/**
	 * Tokenise an escape sequence.
	 *
	 * @example
	 *   tokenizeEscape(eat, '\\a', 'a');
	 *
	 * @param {function(string)} eat
	 * @param {string} $0 - Whole escape.
	 * @param {string} $1 - Escaped character.
	 * @return {Node} - `escape` node.
	 */
	function tokenizeEscape(eat, $0, $1) {
	    return eat($0)(this.renderRaw(ESCAPE, $1));
	}
	
	/**
	 * Tokenise a URL in carets.
	 *
	 * @example
	 *   tokenizeAutoLink(eat, '<http://foo.bar>', 'http://foo.bar', '');
	 *
	 * @property {boolean} notInLink
	 * @param {function(string)} eat
	 * @param {string} $0 - Whole link.
	 * @param {string} $1 - URL.
	 * @param {string?} [$2] - Protocol or at.
	 * @return {Node} - `link` node.
	 */
	function tokenizeAutoLink(eat, $0, $1, $2) {
	    var self = this;
	    var href = $1;
	    var text = $1;
	    var now = eat.now();
	    var offset = 1;
	    var tokenize;
	    var node;
	
	    if ($2 === AT_SIGN) {
	        if (
	            text.substr(0, MAILTO_PROTOCOL.length).toLowerCase() !==
	            MAILTO_PROTOCOL
	        ) {
	            href = MAILTO_PROTOCOL + text;
	        } else {
	            text = text.substr(MAILTO_PROTOCOL.length);
	            offset += MAILTO_PROTOCOL.length;
	        }
	    }
	
	    now.column += offset;
	
	    /*
	     * Temporarily remove support for escapes in autolinks.
	     */
	
	    tokenize = self.inlineTokenizers.escape;
	    self.inlineTokenizers.escape = null;
	
	    node = eat($0)(self.renderLink(true, href, text, null, now, eat));
	
	    self.inlineTokenizers.escape = tokenize;
	
	    return node;
	}
	
	tokenizeAutoLink.notInLink = true;
	
	/**
	 * Tokenise a URL in text.
	 *
	 * @example
	 *   tokenizeURL(eat, 'http://foo.bar');
	 *
	 * @property {boolean} notInLink
	 * @param {function(string)} eat
	 * @param {string} $0 - Whole link.
	 * @return {Node} - `link` node.
	 */
	function tokenizeURL(eat, $0) {
	    var now = eat.now();
	
	    return eat($0)(this.renderLink(true, $0, $0, null, now, eat));
	}
	
	tokenizeURL.notInLink = true;
	
	/**
	 * Tokenise an HTML tag.
	 *
	 * @example
	 *   tokenizeTag(eat, '<span foo="bar">');
	 *
	 * @param {function(string)} eat
	 * @param {string} $0 - Content.
	 * @return {Node} - `html` node.
	 */
	function tokenizeTag(eat, $0) {
	    var self = this;
	
	    if (!self.inLink && EXPRESSION_HTML_LINK_OPEN.test($0)) {
	        self.inLink = true;
	    } else if (self.inLink && EXPRESSION_HTML_LINK_CLOSE.test($0)) {
	        self.inLink = false;
	    }
	
	    return eat($0)(self.renderRaw(HTML, $0));
	}
	
	/**
	 * Tokenise a link.
	 *
	 * @example
	 *   tokenizeLink(
	 *     eat, '![foo](fav.ico "Favicon")', '![', 'foo', null,
	 *     'fav.ico', 'Foo Domain'
	 *   );
	 *
	 * @param {function(string)} eat
	 * @param {string} $0 - Whole link.
	 * @param {string} $1 - Prefix.
	 * @param {string} $2 - Text.
	 * @param {string?} $3 - URL wrapped in angle braces.
	 * @param {string?} $4 - Literal URL.
	 * @param {string?} $5 - Title wrapped in single or double
	 *   quotes.
	 * @param {string?} [$6] - Title wrapped in double quotes.
	 * @param {string?} [$7] - Title wrapped in parentheses.
	 * @return {Node?} - `link` node, `image` node, or `null`.
	 */
	function tokenizeLink(eat, $0, $1, $2, $3, $4, $5, $6, $7) {
	    var isLink = $1 === BRACKET_OPEN;
	    var href = $4 || $3 || '';
	    var title = $7 || $6 || $5;
	    var now;
	
	    if (!isLink || !this.inLink) {
	        now = eat.now();
	
	        now.column += $1.length;
	
	        return eat($0)(this.renderLink(
	            isLink, this.descape(href), $2, title, now, eat
	        ));
	    }
	
	    return null;
	}
	
	/**
	 * Tokenise a reference link, image, or footnote;
	 * shortcut reference link, or footnote.
	 *
	 * @example
	 *   tokenizeReference(eat, '[foo]', '[', 'foo');
	 *   tokenizeReference(eat, '[foo][]', '[', 'foo', '');
	 *   tokenizeReference(eat, '[foo][bar]', '[', 'foo', 'bar');
	 *
	 * @param {function(string)} eat
	 * @param {string} $0 - Whole link.
	 * @param {string} $1 - Prefix.
	 * @param {string} $2 - identifier.
	 * @param {string} $3 - Content.
	 * @return {Node?} - `linkReference`, `imageReference`, or
	 *   `footnoteReference`.  Returns null when this is a link
	 *   reference, but we're already in a link.
	 */
	function tokenizeReference(eat, $0, $1, $2, $3) {
	    var self = this;
	    var text = $2;
	    var identifier = $3 || $2;
	    var type = $1 === BRACKET_OPEN ? 'link' : 'image';
	    var isFootnote = self.options.footnotes && identifier.charAt(0) === CARET;
	    var now = eat.now();
	    var referenceType;
	    var node;
	    var exitLink;
	
	    if ($3 === undefined) {
	        referenceType = 'shortcut';
	    } else if ($3 === '') {
	        referenceType = 'collapsed';
	    } else {
	        referenceType = 'full';
	    }
	
	    if (referenceType !== 'shortcut') {
	        isFootnote = false;
	    }
	
	    if (isFootnote) {
	        identifier = identifier.substr(1);
	    }
	
	    if (isFootnote) {
	        if (identifier.indexOf(SPACE) !== -1) {
	            return eat($0)(self.renderFootnote(identifier, eat.now()));
	        } else {
	            type = 'footnote';
	        }
	    }
	
	    if (self.inLink && type === 'link') {
	        return null;
	    }
	
	    now.column += $1.length;
	
	    node = {
	        'type': type + 'Reference',
	        'identifier': normalize(identifier)
	    };
	
	    if (type === 'link' || type === 'image') {
	        node.referenceType = referenceType;
	    }
	
	    if (type === 'link') {
	        exitLink = self.enterLink();
	        node.children = self.tokenizeInline(text, now);
	        exitLink();
	    } else if (type === 'image') {
	        node.alt = decode(self.descape(text), eat);
	    }
	
	    return eat($0)(node);
	}
	
	/**
	 * Tokenise strong emphasis.
	 *
	 * @example
	 *   tokenizeStrong(eat, '**foo**', '**', 'foo');
	 *   tokenizeStrong(eat, '__foo__', null, null, '__', 'foo');
	 *
	 * @param {function(string)} eat
	 * @param {string} $0 - Whole emphasis.
	 * @param {string?} $1 - Marker.
	 * @param {string?} $2 - Content.
	 * @param {string?} [$3] - Marker.
	 * @param {string?} [$4] - Content.
	 * @return {Node?} - `strong` node, when not empty.
	 */
	function tokenizeStrong(eat, $0, $1, $2, $3, $4) {
	    var now = eat.now();
	    var value = $2 || $4;
	
	    if (trim(value) === EMPTY) {
	        return null;
	    }
	
	    now.column += 2;
	
	    return eat($0)(this.renderInline(STRONG, value, now));
	}
	
	/**
	 * Tokenise slight emphasis.
	 *
	 * @example
	 *   tokenizeEmphasis(eat, '*foo*', '*', 'foo');
	 *   tokenizeEmphasis(eat, '_foo_', null, null, '_', 'foo');
	 *
	 * @param {function(string)} eat
	 * @param {string} $0 - Whole emphasis.
	 * @param {string?} $1 - Marker.
	 * @param {string?} $2 - Content.
	 * @param {string?} [$3] - Marker.
	 * @param {string?} [$4] - Content.
	 * @return {Node?} - `emphasis` node, when not empty.
	 */
	function tokenizeEmphasis(eat, $0, $1, $2, $3, $4) {
	    var now = eat.now();
	    var marker = $1 || $3;
	    var value = $2 || $4;
	
	    if (
	        trim(value) === EMPTY ||
	        value.charAt(0) === marker ||
	        value.charAt(value.length - 1) === marker
	    ) {
	        return null;
	    }
	
	    now.column += 1;
	
	    return eat($0)(this.renderInline(EMPHASIS, value, now));
	}
	
	/**
	 * Tokenise a deletion.
	 *
	 * @example
	 *   tokenizeDeletion(eat, '~~foo~~', '~~', 'foo');
	 *
	 * @param {function(string)} eat
	 * @param {string} $0 - Whole deletion.
	 * @param {string} $1 - Content.
	 * @return {Node} - `delete` node.
	 */
	function tokenizeDeletion(eat, $0, $1) {
	    var now = eat.now();
	
	    now.column += 2;
	
	    return eat($0)(this.renderInline(DELETE, $1, now));
	}
	
	/**
	 * Tokenise inline code.
	 *
	 * @example
	 *   tokenizeInlineCode(eat, '`foo()`', '`', 'foo()');
	 *
	 * @param {function(string)} eat
	 * @param {string} $0 - Whole code.
	 * @param {string} $1 - Initial markers.
	 * @param {string} $2 - Content.
	 * @return {Node} - `inlineCode` node.
	 */
	function tokenizeInlineCode(eat, $0, $1, $2) {
	    return eat($0)(this.renderRaw(INLINE_CODE, trim($2 || '')));
	}
	
	/**
	 * Tokenise a break.
	 *
	 * @example
	 *   tokenizeBreak(eat, '  \n');
	 *
	 * @param {function(string)} eat
	 * @param {string} $0
	 * @return {Node} - `break` node.
	 */
	function tokenizeBreak(eat, $0) {
	    return eat($0)(this.renderVoid(BREAK));
	}
	
	/**
	 * Construct a new parser.
	 *
	 * @example
	 *   var parser = new Parser(new VFile('Foo'));
	 *
	 * @constructor
	 * @class {Parser}
	 * @param {VFile} file - File to parse.
	 * @param {Object?} [options] - Passed to
	 *   `Parser#setOptions()`.
	 */
	function Parser(file, options) {
	    var self = this;
	    var rules = extend({}, self.expressions.rules);
	
	    self.file = file;
	    self.inLink = false;
	    self.atTop = true;
	    self.atStart = true;
	    self.inBlockquote = false;
	
	    self.rules = rules;
	    self.descape = descapeFactory(rules, 'escape');
	
	    self.options = extend({}, self.options);
	
	    self.setOptions(options);
	}
	
	/**
	 * Set options.  Does not overwrite previously set
	 * options.
	 *
	 * @example
	 *   var parser = new Parser();
	 *   parser.setOptions({gfm: true});
	 *
	 * @this {Parser}
	 * @throws {Error} - When an option is invalid.
	 * @param {Object?} [options] - Parse settings.
	 * @return {Parser} - `self`.
	 */
	Parser.prototype.setOptions = function (options) {
	    var self = this;
	    var expressions = self.expressions;
	    var rules = self.rules;
	    var current = self.options;
	    var key;
	
	    if (options === null || options === undefined) {
	        options = {};
	    } else if (typeof options === 'object') {
	        options = extend({}, options);
	    } else {
	        raise(options, 'options');
	    }
	
	    self.options = options;
	
	    for (key in defaultOptions) {
	        validate.boolean(options, key, current[key]);
	
	        if (options[key]) {
	            extend(rules, expressions[key]);
	        }
	    }
	
	    if (options.gfm && options.breaks) {
	        extend(rules, expressions.breaksGFM);
	    }
	
	    if (options.gfm && options.commonmark) {
	        extend(rules, expressions.commonmarkGFM);
	    }
	
	    if (options.commonmark) {
	        self.enterBlockquote = noopToggler();
	    }
	
	    return self;
	};
	
	/*
	 * Expose `defaults`.
	 */
	
	Parser.prototype.options = defaultOptions;
	
	/*
	 * Expose `expressions`.
	 */
	
	Parser.prototype.expressions = defaultExpressions;
	
	/**
	 * Factory to track indentation for each line corresponding
	 * to the given `start` and the number of invocations.
	 *
	 * @param {number} start - Starting line.
	 * @return {function(offset)} - Indenter.
	 */
	Parser.prototype.indent = function (start) {
	    var self = this;
	    var line = start;
	
	    /**
	     * Intender which increments the global offset,
	     * starting at the bound line, and further incrementing
	     * each line for each invocation.
	     *
	     * @example
	     *   indenter(2)
	     *
	     * @param {number} offset - Number to increment the
	     *   offset.
	     */
	    function indenter(offset) {
	        self.offset[line] = (self.offset[line] || 0) + offset;
	
	        line++;
	    }
	
	    return indenter;
	};
	
	/**
	 * Parse the bound file.
	 *
	 * @example
	 *   new Parser(new File('_Foo_.')).parse();
	 *
	 * @this {Parser}
	 * @return {Object} - `root` node.
	 */
	Parser.prototype.parse = function () {
	    var self = this;
	    var value = clean(String(self.file));
	    var node;
	
	    /*
	     * Add an `offset` matrix, used to keep track of
	     * syntax and white space indentation per line.
	     */
	
	    self.offset = {};
	
	    node = self.renderBlock(ROOT, value);
	
	    if (self.options.position) {
	        node.position = {
	            'start': {
	                'line': 1,
	                'column': 1
	            }
	        };
	
	        node.position.end = self.eof || node.position.start;
	    }
	
	    return node;
	};
	
	/*
	 * Enter and exit helpers.
	 */
	
	Parser.prototype.enterLink = stateToggler('inLink', false);
	Parser.prototype.exitTop = stateToggler('atTop', true);
	Parser.prototype.exitStart = stateToggler('atStart', true);
	Parser.prototype.enterBlockquote = stateToggler('inBlockquote', false);
	
	/*
	 * Expose helpers
	 */
	
	Parser.prototype.renderRaw = renderRaw;
	Parser.prototype.renderVoid = renderVoid;
	Parser.prototype.renderParent = renderParent;
	Parser.prototype.renderInline = renderInline;
	Parser.prototype.renderBlock = renderBlock;
	
	Parser.prototype.renderLink = renderLink;
	Parser.prototype.renderCodeBlock = renderCodeBlock;
	Parser.prototype.renderBlockquote = renderBlockquote;
	Parser.prototype.renderList = renderList;
	Parser.prototype.renderListItem = renderListItem;
	Parser.prototype.renderFootnoteDefinition = renderFootnoteDefinition;
	Parser.prototype.renderHeading = renderHeading;
	Parser.prototype.renderFootnote = renderFootnote;
	
	/**
	 * Construct a tokenizer.  This creates both
	 * `tokenizeInline` and `tokenizeBlock`.
	 *
	 * @example
	 *   Parser.prototype.tokenizeInline = tokenizeFactory('inline');
	 *
	 * @param {string} type - Name of parser, used to find
	 *   its expressions (`%sMethods`) and tokenizers
	 *   (`%Tokenizers`).
	 * @return {function(string, Object?): Array.<Object>}
	 */
	function tokenizeFactory(type) {
	    /**
	     * Tokenizer for a bound `type`
	     *
	     * @example
	     *   parser = new Parser();
	     *   parser.tokenizeInline('_foo_');
	     *
	     * @param {string} value - Content.
	     * @param {Object?} [location] - Offset at which `value`
	     *   starts.
	     * @return {Array.<Object>} - Nodes.
	     */
	    function tokenize(value, location) {
	        var self = this;
	        var offset = self.offset;
	        var tokens = [];
	        var rules = self.rules;
	        var methods = self[type + 'Methods'];
	        var tokenizers = self[type + 'Tokenizers'];
	        var line = location ? location.line : 1;
	        var column = location ? location.column : 1;
	        var patchPosition = self.options.position;
	        var add;
	        var index;
	        var length;
	        var method;
	        var name;
	        var match;
	        var matched;
	        var valueLength;
	        var eater;
	
	        /*
	         * Trim white space only lines.
	         */
	
	        if (!value) {
	            return tokens;
	        }
	
	        /**
	         * Update line and column based on `value`.
	         *
	         * @example
	         *   updatePosition('foo');
	         *
	         * @param {string} subvalue
	         */
	        function updatePosition(subvalue) {
	            var character = -1;
	            var subvalueLength = subvalue.length;
	            var lastIndex = -1;
	
	            while (++character < subvalueLength) {
	                if (subvalue.charAt(character) === NEW_LINE) {
	                    lastIndex = character;
	                    line++;
	                }
	            }
	
	            if (lastIndex === -1) {
	                column = column + subvalue.length;
	            } else {
	                column = subvalue.length - lastIndex;
	            }
	
	            if (line in offset) {
	                if (lastIndex !== -1) {
	                    column += offset[line];
	                } else if (column <= offset[line]) {
	                    column = offset[line] + 1;
	                }
	            }
	        }
	
	        /**
	         * Get offset. Called before the fisrt character is
	         * eaten to retrieve the range's offsets.
	         *
	         * @return {Function} - `done`, to be called when
	         *   the last character is eaten.
	         */
	        function getOffset() {
	            var indentation = [];
	            var pos = line + 1;
	
	            /**
	             * Done. Called when the last character is
	             * eaten to retrieve the range's offsets.
	             *
	             * @return {Array.<number>} - Offset.
	             */
	            function done() {
	                var last = line + 1;
	
	                while (pos < last) {
	                    indentation.push((offset[pos] || 0) + 1);
	
	                    pos++;
	                }
	
	                return indentation;
	            }
	
	            return done;
	        }
	
	        /**
	         * Get the current position.
	         *
	         * @example
	         *   position = now(); // {line: 1, column: 1}
	         *
	         * @return {Object}
	         */
	        function now() {
	            return {
	                'line': line,
	                'column': column
	            };
	        }
	
	        /**
	         * Store position information for a node.
	         *
	         * @example
	         *   start = now();
	         *   updatePosition('foo');
	         *   location = new Position(start);
	         *   // {start: {line: 1, column: 1}, end: {line: 1, column: 3}}
	         *
	         * @param {Object} start
	         */
	        function Position(start) {
	            this.start = start;
	            this.end = now();
	        }
	
	        /**
	         * Throw when a value is incorrectly eaten.
	         * This shouldn’t happen but will throw on new,
	         * incorrect rules.
	         *
	         * @example
	         *   // When the current value is set to `foo bar`.
	         *   validateEat('foo');
	         *   eat('foo');
	         *
	         *   validateEat('bar');
	         *   // throws, because the space is not eaten.
	         *
	         * @param {string} subvalue - Value to be eaten.
	         * @throws {Error} - When `subvalue` cannot be eaten.
	         */
	        function validateEat(subvalue) {
	            /* istanbul ignore if */
	            if (value.substring(0, subvalue.length) !== subvalue) {
	                self.file.fail(
	                    'Incorrectly eaten value: please report this ' +
	                    'warning on http://git.io/vUYWz', now()
	                );
	            }
	        }
	
	        /**
	         * Mark position and patch `node.position`.
	         *
	         * @example
	         *   var update = position();
	         *   updatePosition('foo');
	         *   update({});
	         *   // {
	         *   //   position: {
	         *   //     start: {line: 1, column: 1}
	         *   //     end: {line: 1, column: 3}
	         *   //   }
	         *   // }
	         *
	         * @returns {function(Node): Node}
	         */
	        function position() {
	            var before = now();
	
	            /**
	             * Add the position to a node.
	             *
	             * @example
	             *   update({type: 'text', value: 'foo'});
	             *
	             * @param {Node} node - Node to attach position
	             *   on.
	             * @return {Node} - `node`.
	             */
	            function update(node, indent) {
	                var prev = node.position;
	                var start = prev ? prev.start : before;
	                var combined = [];
	                var n = prev && prev.end.line;
	                var l = before.line;
	
	                node.position = new Position(start);
	
	                /*
	                 * If there was already a `position`, this
	                 * node was merged.  Fixing `start` wasn't
	                 * hard, but the indent is different.
	                 * Especially because some information, the
	                 * indent between `n` and `l` wasn't
	                 * tracked.  Luckily, that space is
	                 * (should be?) empty, so we can safely
	                 * check for it now.
	                 */
	
	                if (prev) {
	                    combined = prev.indent;
	
	                    if (n < l) {
	                        while (++n < l) {
	                            combined.push((offset[n] || 0) + 1);
	                        }
	
	                        combined.push(before.column);
	                    }
	
	                    indent = combined.concat(indent);
	                }
	
	                node.position.indent = indent;
	
	                return node;
	            }
	
	            return update;
	        }
	
	        /**
	         * Add `node` to `parent`s children or to `tokens`.
	         * Performs merges where possible.
	         *
	         * @example
	         *   add({});
	         *
	         *   add({}, {children: []});
	         *
	         * @param {Object} node - Node to add.
	         * @param {Object} [parent] - Parent to insert into.
	         * @return {Object} - Added or merged into node.
	         */
	        add = function (node, parent) {
	            var isMultiple = 'length' in node;
	            var prev;
	            var children;
	
	            if (!parent) {
	                children = tokens;
	            } else {
	                children = parent.children;
	            }
	
	            if (isMultiple) {
	                arrayPush.apply(children, node);
	            } else {
	                if (type === INLINE && node.type === TEXT) {
	                    node.value = decode(node.value, eater);
	                }
	
	                prev = children[children.length - 1];
	
	                if (
	                    prev &&
	                    node.type === prev.type &&
	                    node.type in MERGEABLE_NODES
	                ) {
	                    node = MERGEABLE_NODES[node.type].call(
	                        self, prev, node
	                    );
	                }
	
	                if (node !== prev) {
	                    children.push(node);
	                }
	
	                if (self.atStart && tokens.length) {
	                    self.exitStart();
	                }
	            }
	
	            return node;
	        };
	
	        /**
	         * Remove `subvalue` from `value`.
	         * Expects `subvalue` to be at the start from
	         * `value`, and applies no validation.
	         *
	         * @example
	         *   eat('foo')({type: 'text', value: 'foo'});
	         *
	         * @param {string} subvalue - Removed from `value`,
	         *   and passed to `updatePosition`.
	         * @return {Function} - Wrapper around `add`, which
	         *   also adds `position` to node.
	         */
	        function eat(subvalue) {
	            var indent = getOffset();
	            var pos = position();
	            var current = now();
	
	            validateEat(subvalue);
	
	            /**
	             * Add the given arguments, add `position` to
	             * the returned node, and return the node.
	             *
	             * @return {Node}
	             */
	            function apply() {
	                return pos(add.apply(null, arguments), indent);
	            }
	
	            /**
	             * Functions just like apply, but resets the
	             * content:  the line and column are reversed,
	             * and the eaten value is re-added.
	             *
	             * This is useful for nodes with a single
	             * type of content, such as lists and tables.
	             *
	             * See `apply` above for what parameters are
	             * expected.
	             *
	             * @return {Node}
	             */
	            function reset() {
	                var node = apply.apply(null, arguments);
	
	                line = current.line;
	                column = current.column;
	                value = subvalue + value;
	
	                return node;
	            }
	
	            apply.reset = reset;
	
	            value = value.substring(subvalue.length);
	
	            updatePosition(subvalue);
	
	            indent = indent();
	
	            return apply;
	        }
	
	        /**
	         * Same as `eat` above, but will not add positional
	         * information to nodes.
	         *
	         * @example
	         *   noEat('foo')({type: 'text', value: 'foo'});
	         *
	         * @param {string} subvalue - Removed from `value`.
	         * @return {Function} - Wrapper around `add`.
	         */
	        function noEat(subvalue) {
	            validateEat(subvalue);
	
	            /**
	             * Add the given arguments, and return the
	             * node.
	             *
	             * @return {Node}
	             */
	            function apply() {
	                return add.apply(null, arguments);
	            }
	
	            /**
	             * Functions just like apply, but resets the
	             * content: the eaten value is re-added.
	             *
	             * @return {Node}
	             */
	            function reset() {
	                var node = apply.apply(null, arguments);
	
	                value = subvalue + value;
	
	                return node;
	            }
	
	            apply.reset = reset;
	
	            value = value.substring(subvalue.length);
	
	            return apply;
	        }
	
	        /*
	         * Expose the eater, depending on if `position`s
	         * should be patched on nodes.
	         */
	
	        eater = patchPosition ? eat : noEat;
	
	        /*
	         * Expose `now` on `eater`.
	         */
	
	        eater.now = now;
	
	        /*
	         * Expose `file` on `eater`.
	         */
	
	        eater.file = self.file;
	
	        /*
	         * Sync initial offset.
	         */
	
	        updatePosition(EMPTY);
	
	        /*
	         * Iterate over `value`, and iterate over all
	         * block-expressions.  When one matches, invoke
	         * its companion function.  If no expression
	         * matches, something failed (should not happen)
	         * and an exception is thrown.
	         */
	
	        while (value) {
	            index = -1;
	            length = methods.length;
	            matched = false;
	
	            while (++index < length) {
	                name = methods[index];
	                method = tokenizers[name];
	
	                if (
	                    method &&
	                    rules[name] &&
	                    (!method.onlyAtStart || self.atStart) &&
	                    (!method.onlyAtTop || self.atTop) &&
	                    (!method.notInBlockquote || !self.inBlockquote) &&
	                    (!method.notInLink || !self.inLink)
	                ) {
	                    match = rules[name].exec(value);
	
	                    if (match) {
	                        valueLength = value.length;
	
	                        method.apply(self, [eater].concat(match));
	
	                        matched = valueLength !== value.length;
	
	                        if (matched) {
	                            break;
	                        }
	                    }
	                }
	            }
	
	            /* istanbul ignore if */
	            if (!matched) {
	                self.file.fail('Infinite loop', eater.now());
	
	                /*
	                 * Errors are not thrown on `File#fail`
	                 * when `quiet: true`.
	                 */
	
	                break;
	            }
	        }
	
	        self.eof = now();
	
	        return tokens;
	    }
	
	    return tokenize;
	}
	
	/*
	 * Expose tokenizers for block-level nodes.
	 */
	
	Parser.prototype.blockTokenizers = {
	    'yamlFrontMatter': tokenizeYAMLFrontMatter,
	    'newline': tokenizeNewline,
	    'code': tokenizeCode,
	    'fences': tokenizeFences,
	    'heading': tokenizeHeading,
	    'lineHeading': tokenizeLineHeading,
	    'horizontalRule': tokenizeHorizontalRule,
	    'blockquote': tokenizeBlockquote,
	    'list': tokenizeList,
	    'html': tokenizeHtml,
	    'definition': tokenizeDefinition,
	    'footnoteDefinition': tokenizeFootnoteDefinition,
	    'looseTable': tokenizeTable,
	    'table': tokenizeTable,
	    'paragraph': tokenizeParagraph
	};
	
	/*
	 * Expose order in which to parse block-level nodes.
	 */
	
	Parser.prototype.blockMethods = [
	    'yamlFrontMatter',
	    'newline',
	    'code',
	    'fences',
	    'blockquote',
	    'heading',
	    'horizontalRule',
	    'list',
	    'lineHeading',
	    'html',
	    'definition',
	    'footnoteDefinition',
	    'looseTable',
	    'table',
	    'paragraph'
	];
	
	/**
	 * Block tokenizer.
	 *
	 * @example
	 *   var parser = new Parser();
	 *   parser.tokenizeBlock('> foo.');
	 *
	 * @param {string} value - Content.
	 * @return {Array.<Object>} - Nodes.
	 */
	
	Parser.prototype.tokenizeBlock = tokenizeFactory(BLOCK);
	
	/*
	 * Expose tokenizers for inline-level nodes.
	 */
	
	Parser.prototype.inlineTokenizers = {
	    'escape': tokenizeEscape,
	    'autoLink': tokenizeAutoLink,
	    'url': tokenizeURL,
	    'tag': tokenizeTag,
	    'link': tokenizeLink,
	    'reference': tokenizeReference,
	    'shortcutReference': tokenizeReference,
	    'strong': tokenizeStrong,
	    'emphasis': tokenizeEmphasis,
	    'deletion': tokenizeDeletion,
	    'inlineCode': tokenizeInlineCode,
	    'break': tokenizeBreak,
	    'inlineText': tokenizeText
	};
	
	/*
	 * Expose order in which to parse inline-level nodes.
	 */
	
	Parser.prototype.inlineMethods = [
	    'escape',
	    'autoLink',
	    'url',
	    'tag',
	    'link',
	    'reference',
	    'shortcutReference',
	    'strong',
	    'emphasis',
	    'deletion',
	    'inlineCode',
	    'break',
	    'inlineText'
	];
	
	/**
	 * Inline tokenizer.
	 *
	 * @example
	 *   var parser = new Parser();
	 *   parser.tokenizeInline('_foo_');
	 *
	 * @param {string} value - Content.
	 * @return {Array.<Object>} - Nodes.
	 */
	
	Parser.prototype.tokenizeInline = tokenizeFactory(INLINE);
	
	/*
	 * Expose `tokenizeFactory` so dependencies could create
	 * their own tokenizers.
	 */
	
	Parser.prototype.tokenizeFactory = tokenizeFactory;
	
	/*
	 * Expose `parse` on `module.exports`.
	 */
	
	module.exports = Parser;


/***/ }),
/* 1485 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author Titus Wormer
	 * @copyright 2015 Titus Wormer
	 * @license MIT
	 * @module mdast:stringify
	 * @version 2.3.2
	 * @fileoverview Compile an abstract syntax tree into
	 *   a markdown document.
	 */
	
	'use strict';
	
	/* eslint-env commonjs */
	
	/*
	 * Dependencies.
	 */
	
	var he = __webpack_require__(532);
	var table = __webpack_require__(1477);
	var repeat = __webpack_require__(401);
	var extend = __webpack_require__(523);
	var ccount = __webpack_require__(1213);
	var longestStreak = __webpack_require__(1476);
	var utilities = __webpack_require__(572);
	var defaultOptions = __webpack_require__(571).stringify;
	
	/*
	 * Methods.
	 */
	
	var raise = utilities.raise;
	var validate = utilities.validate;
	
	/*
	 * Constants.
	 */
	
	var INDENT = 4;
	var MINIMUM_CODE_FENCE_LENGTH = 3;
	var YAML_FENCE_LENGTH = 3;
	var MINIMUM_RULE_LENGTH = 3;
	var MAILTO = 'mailto:';
	var ERROR_LIST_ITEM_INDENT = 'Cannot indent code properly. See ' +
	    'http://git.io/mdast-lii';
	
	/*
	 * Expressions.
	 */
	
	var EXPRESSIONS_WHITE_SPACE = /\s/;
	
	/*
	 * Naive fence expression.
	 */
	
	var FENCE = /([`~])\1{2}/;
	
	/*
	 * Expression for a protocol.
	 *
	 * @see http://en.wikipedia.org/wiki/URI_scheme#Generic_syntax
	 */
	
	var PROTOCOL = /^[a-z][a-z+.-]+:\/?/i;
	
	/*
	 * Characters.
	 */
	
	var ANGLE_BRACKET_CLOSE = '>';
	var ANGLE_BRACKET_OPEN = '<';
	var ASTERISK = '*';
	var CARET = '^';
	var COLON = ':';
	var DASH = '-';
	var DOT = '.';
	var EMPTY = '';
	var EQUALS = '=';
	var EXCLAMATION_MARK = '!';
	var HASH = '#';
	var LINE = '\n';
	var PARENTHESIS_OPEN = '(';
	var PARENTHESIS_CLOSE = ')';
	var PIPE = '|';
	var PLUS = '+';
	var QUOTE_DOUBLE = '"';
	var QUOTE_SINGLE = '\'';
	var SPACE = ' ';
	var SQUARE_BRACKET_OPEN = '[';
	var SQUARE_BRACKET_CLOSE = ']';
	var TICK = '`';
	var TILDE = '~';
	var UNDERSCORE = '_';
	
	/*
	 * Character combinations.
	 */
	
	var BREAK = LINE + LINE;
	var GAP = BREAK + LINE;
	var DOUBLE_TILDE = TILDE + TILDE;
	
	/*
	 * Allowed entity options.
	 */
	
	var ENTITY_OPTIONS = {};
	
	ENTITY_OPTIONS.true = true;
	ENTITY_OPTIONS.false = true;
	ENTITY_OPTIONS.numbers = true;
	ENTITY_OPTIONS.escape = true;
	
	/*
	 * Allowed list-bullet characters.
	 */
	
	var LIST_BULLETS = {};
	
	LIST_BULLETS[ASTERISK] = true;
	LIST_BULLETS[DASH] = true;
	LIST_BULLETS[PLUS] = true;
	
	/*
	 * Allowed horizontal-rule bullet characters.
	 */
	
	var HORIZONTAL_RULE_BULLETS = {};
	
	HORIZONTAL_RULE_BULLETS[ASTERISK] = true;
	HORIZONTAL_RULE_BULLETS[DASH] = true;
	HORIZONTAL_RULE_BULLETS[UNDERSCORE] = true;
	
	/*
	 * Allowed emphasis characters.
	 */
	
	var EMPHASIS_MARKERS = {};
	
	EMPHASIS_MARKERS[UNDERSCORE] = true;
	EMPHASIS_MARKERS[ASTERISK] = true;
	
	/*
	 * Allowed fence markers.
	 */
	
	var FENCE_MARKERS = {};
	
	FENCE_MARKERS[TICK] = true;
	FENCE_MARKERS[TILDE] = true;
	
	/*
	 * Which method to use based on `list.ordered`.
	 */
	
	var ORDERED_MAP = {};
	
	ORDERED_MAP.true = 'visitOrderedItems';
	ORDERED_MAP.false = 'visitUnorderedItems';
	
	/*
	 * Allowed list-item-indent's.
	 */
	
	var LIST_ITEM_INDENTS = {};
	
	var LIST_ITEM_TAB = 'tab';
	var LIST_ITEM_ONE = '1';
	var LIST_ITEM_MIXED = 'mixed';
	
	LIST_ITEM_INDENTS[LIST_ITEM_ONE] = true;
	LIST_ITEM_INDENTS[LIST_ITEM_TAB] = true;
	LIST_ITEM_INDENTS[LIST_ITEM_MIXED] = true;
	
	/*
	 * Which checkbox to use.
	 */
	
	var CHECKBOX_MAP = {};
	
	CHECKBOX_MAP.null = EMPTY;
	CHECKBOX_MAP.undefined = EMPTY;
	CHECKBOX_MAP.true = SQUARE_BRACKET_OPEN + 'x' + SQUARE_BRACKET_CLOSE + SPACE;
	CHECKBOX_MAP.false = SQUARE_BRACKET_OPEN + SPACE + SQUARE_BRACKET_CLOSE +
	    SPACE;
	
	/**
	 * Encode noop.
	 * Simply returns the given value.
	 *
	 * @example
	 *   var encode = encodeNoop();
	 *   encode('AT&T') // 'AT&T'
	 *
	 * @param {string} value - Content.
	 * @return {string} - Content, without any modifications.
	 */
	function encodeNoop(value) {
	    return value;
	}
	
	/**
	 * Factory to encode HTML entities.
	 * Creates a no-operation function when `type` is
	 * `'false'`, a function which encodes using named
	 * references when `type` is `'true'`, and a function
	 * which encodes using numbered references when `type` is
	 * `'numbers'`.
	 *
	 * By default this should not throw errors, but he does
	 * throw an error when in `strict` mode:
	 *
	 *     he.encode.options.strict = true;
	 *     encodeFactory('true')('\x01') // throws
	 *
	 * These are thrown on the currently compiled `File`.
	 *
	 * @example
	 *   var file = new File();
	 *
	 *   var encode = encodeFactory('false', file);
	 *   encode('AT&T') // 'AT&T'
	 *
	 *   encode = encodeFactory('true', file);
	 *   encode('AT&T') // 'AT&amp;T'
	 *
	 *   encode = encodeFactory('numbers', file);
	 *   encode('AT&T') // 'ATT&#x26;T'
	 *
	 * @param {string} type - Either `'true'`, `'false'`, or
	 *   `numbers`.
	 * @param {File} file - Currently compiled virtual file.
	 * @return {function(string): string} - Function which
	 *   takes a value and returns its encoded version.
	 */
	function encodeFactory(type, file) {
	    var options = {};
	    var fn;
	
	    if (type === 'false') {
	        return encodeNoop;
	    }
	
	    if (type === 'true') {
	        options.useNamedReferences = true;
	    }
	
	    fn = type === 'escape' ? 'escape' : 'encode';
	
	    /**
	     * Encode HTML entities using `he` using bound options.
	     *
	     * @see https://github.com/mathiasbynens/he#strict
	     *
	     * @example
	     *   // When `type` is `'true'`.
	     *   encode('AT&T'); // 'AT&amp;T'
	     *
	     *   // When `type` is `'numbers'`.
	     *   encode('AT&T'); // 'ATT&#x26;T'
	     *
	     * @param {string} value - Content.
	     * @param {Object} [node] - Node which is compiled.
	     * @return {string} - Encoded content.
	     * @throws {Error} - When `file.quiet` is not `true`.
	     *   However, by default `he` does not throw on
	     *   parse errors, but when
	     *   `he.encode.options.strict: true`, they occur on
	     *   invalid HTML.
	     */
	    function encode(value, node) {
	        /* istanbul ignore next - useful for other stringifiers */
	        var position = node ? node.position : null;
	        try {
	            return he[fn](value, options);
	        } catch (exception) {
	            file.fail(exception, position);
	        }
	    }
	
	    return encode;
	}
	
	/**
	 * Wrap `url` in angle brackets when needed, or when
	 * forced.
	 *
	 * In links, images, and definitions, the URL part needs
	 * to be enclosed when it:
	 *
	 * - has a length of `0`;
	 * - contains white-space;
	 * - has more or less opening than closing parentheses.
	 *
	 * @example
	 *   encloseURI('foo bar') // '<foo bar>'
	 *   encloseURI('foo(bar(baz)') // '<foo(bar(baz)>'
	 *   encloseURI('') // '<>'
	 *   encloseURI('example.com') // 'example.com'
	 *   encloseURI('example.com', true) // '<example.com>'
	 *
	 * @param {string} uri
	 * @param {boolean?} [always] - Force enclosing.
	 * @return {boolean} - Properly enclosed `uri`.
	 */
	function encloseURI(uri, always) {
	    if (
	        always ||
	        !uri.length ||
	        EXPRESSIONS_WHITE_SPACE.test(uri) ||
	        ccount(uri, PARENTHESIS_OPEN) !== ccount(uri, PARENTHESIS_CLOSE)
	    ) {
	        return ANGLE_BRACKET_OPEN + uri + ANGLE_BRACKET_CLOSE;
	    }
	
	    return uri;
	}
	
	/**
	 * There is currently no way to support nested delimiters
	 * across Markdown.pl, CommonMark, and GitHub (RedCarpet).
	 * The following code supports Markdown.pl and GitHub.
	 * CommonMark is not supported when mixing double- and
	 * single quotes inside a title.
	 *
	 * @see https://github.com/vmg/redcarpet/issues/473
	 * @see https://github.com/jgm/CommonMark/issues/308
	 *
	 * @example
	 *   encloseTitle('foo') // '"foo"'
	 *   encloseTitle('foo \'bar\' baz') // '"foo \'bar\' baz"'
	 *   encloseTitle('foo "bar" baz') // '\'foo "bar" baz\''
	 *   encloseTitle('foo "bar" \'baz\'') // '"foo "bar" \'baz\'"'
	 *
	 * @param {string} title - Content.
	 * @return {string} - Properly enclosed title.
	 */
	function encloseTitle(title) {
	    var delimiter = QUOTE_DOUBLE;
	
	    if (title.indexOf(delimiter) !== -1) {
	        delimiter = QUOTE_SINGLE;
	    }
	
	    return delimiter + title + delimiter;
	}
	
	/**
	 * Pad `value` with `level * INDENT` spaces.  Respects
	 * lines. Ignores empty lines.
	 *
	 * @example
	 *   pad('foo', 1) // '    foo'
	 *
	 * @param {string} value - Content.
	 * @param {number} level - Indentation level.
	 * @return {string} - Padded `value`.
	 */
	function pad(value, level) {
	    var index;
	    var padding;
	
	    value = value.split(LINE);
	
	    index = value.length;
	    padding = repeat(SPACE, level * INDENT);
	
	    while (index--) {
	        if (value[index].length !== 0) {
	            value[index] = padding + value[index];
	        }
	    }
	
	    return value.join(LINE);
	}
	
	/**
	 * Construct a new compiler.
	 *
	 * @example
	 *   var compiler = new Compiler(new File('> foo.'));
	 *
	 * @constructor
	 * @class {Compiler}
	 * @param {File} file - Virtual file.
	 * @param {Object?} [options] - Passed to
	 *   `Compiler#setOptions()`.
	 */
	function Compiler(file, options) {
	    var self = this;
	
	    self.file = file;
	
	    self.options = extend({}, self.options);
	
	    self.setOptions(options);
	}
	
	/*
	 * Cache prototype.
	 */
	
	var compilerPrototype = Compiler.prototype;
	
	/*
	 * Expose defaults.
	 */
	
	compilerPrototype.options = defaultOptions;
	
	/*
	 * Map of applicable enum's.
	 */
	
	var maps = {
	    'entities': ENTITY_OPTIONS,
	    'bullet': LIST_BULLETS,
	    'rule': HORIZONTAL_RULE_BULLETS,
	    'listItemIndent': LIST_ITEM_INDENTS,
	    'emphasis': EMPHASIS_MARKERS,
	    'strong': EMPHASIS_MARKERS,
	    'fence': FENCE_MARKERS
	};
	
	/**
	 * Set options.  Does not overwrite previously set
	 * options.
	 *
	 * @example
	 *   var compiler = new Compiler();
	 *   compiler.setOptions({bullet: '*'});
	 *
	 * @this {Compiler}
	 * @throws {Error} - When an option is invalid.
	 * @param {Object?} [options] - Stringify settings.
	 * @return {Compiler} - `self`.
	 */
	compilerPrototype.setOptions = function (options) {
	    var self = this;
	    var current = self.options;
	    var ruleRepetition;
	    var key;
	
	    if (options === null || options === undefined) {
	        options = {};
	    } else if (typeof options === 'object') {
	        options = extend({}, options);
	    } else {
	        raise(options, 'options');
	    }
	
	    for (key in defaultOptions) {
	        validate[typeof current[key]](
	            options, key, current[key], maps[key]
	        );
	    }
	
	    ruleRepetition = options.ruleRepetition;
	
	    if (ruleRepetition && ruleRepetition < MINIMUM_RULE_LENGTH) {
	        raise(ruleRepetition, 'options.ruleRepetition');
	    }
	
	    self.encode = encodeFactory(String(options.entities), self.file);
	
	    self.options = options;
	
	    return self;
	};
	
	/**
	 * Visit a node.
	 *
	 * @example
	 *   var compiler = new Compiler();
	 *
	 *   compiler.visit({
	 *     type: 'strong',
	 *     children: [{
	 *       type: 'text',
	 *       value: 'Foo'
	 *     }]
	 *   });
	 *   // '**Foo**'
	 *
	 * @param {Object} node - Node.
	 * @param {Object?} [parent] - `node`s parent.
	 * @return {string} - Compiled `node`.
	 */
	compilerPrototype.visit = function (node, parent) {
	    var self = this;
	
	    /*
	     * Fail on unknown nodes.
	     */
	
	    if (typeof self[node.type] !== 'function') {
	        self.file.fail(
	            'Missing compiler for node of type `' +
	            node.type + '`: `' + node + '`',
	            node
	        );
	    }
	
	    return self[node.type](node, parent);
	};
	
	/**
	 * Visit all children of `parent`.
	 *
	 * @example
	 *   var compiler = new Compiler();
	 *
	 *   compiler.all({
	 *     type: 'strong',
	 *     children: [{
	 *       type: 'text',
	 *       value: 'Foo'
	 *     },
	 *     {
	 *       type: 'text',
	 *       value: 'Bar'
	 *     }]
	 *   });
	 *   // ['Foo', 'Bar']
	 *
	 * @param {Object} parent - Parent node of children.
	 * @return {Array.<string>} - List of compiled children.
	 */
	compilerPrototype.all = function (parent) {
	    var self = this;
	    var children = parent.children;
	    var values = [];
	    var index = -1;
	    var length = children.length;
	
	    while (++index < length) {
	        values[index] = self.visit(children[index], parent);
	    }
	
	    return values;
	};
	
	/**
	 * Visit ordered list items.
	 *
	 * Starts the list with
	 * `node.start` and increments each following list item
	 * bullet by one:
	 *
	 *     2. foo
	 *     3. bar
	 *
	 * In `incrementListMarker: false` mode, does not increment
	 * each marker and stays on `node.start`:
	 *
	 *     1. foo
	 *     1. bar
	 *
	 * Adds an extra line after an item if it has
	 * `loose: true`.
	 *
	 * @example
	 *   var compiler = new Compiler();
	 *
	 *   compiler.visitOrderedItems({
	 *     type: 'list',
	 *     ordered: true,
	 *     children: [{
	 *       type: 'listItem',
	 *       children: [{
	 *         type: 'text',
	 *         value: 'bar'
	 *       }]
	 *     }]
	 *   });
	 *   // '1.  bar'
	 *
	 * @param {Object} node - `list` node with
	 *   `ordered: true`.
	 * @return {string} - Markdown list.
	 */
	compilerPrototype.visitOrderedItems = function (node) {
	    var self = this;
	    var increment = self.options.incrementListMarker;
	    var values = [];
	    var start = node.start;
	    var children = node.children;
	    var length = children.length;
	    var index = -1;
	    var bullet;
	
	    while (++index < length) {
	        bullet = (increment ? start + index : start) + DOT;
	        values[index] = self.listItem(children[index], node, index, bullet);
	    }
	
	    return values.join(LINE);
	};
	
	/**
	 * Visit unordered list items.
	 *
	 * Uses `options.bullet` as each item's bullet.
	 *
	 * Adds an extra line after an item if it has
	 * `loose: true`.
	 *
	 * @example
	 *   var compiler = new Compiler();
	 *
	 *   compiler.visitUnorderedItems({
	 *     type: 'list',
	 *     ordered: false,
	 *     children: [{
	 *       type: 'listItem',
	 *       children: [{
	 *         type: 'text',
	 *         value: 'bar'
	 *       }]
	 *     }]
	 *   });
	 *   // '-   bar'
	 *
	 * @param {Object} node - `list` node with
	 *   `ordered: false`.
	 * @return {string} - Markdown list.
	 */
	compilerPrototype.visitUnorderedItems = function (node) {
	    var self = this;
	    var values = [];
	    var children = node.children;
	    var length = children.length;
	    var index = -1;
	    var bullet = self.options.bullet;
	
	    while (++index < length) {
	        values[index] = self.listItem(children[index], node, index, bullet);
	    }
	
	    return values.join(LINE);
	};
	
	/**
	 * Stringify a block node with block children (e.g., `root`
	 * or `blockquote`).
	 *
	 * Knows about code following a list, or adjacent lists
	 * with similar bullets, and places an extra newline
	 * between them.
	 *
	 * @example
	 *   var compiler = new Compiler();
	 *
	 *   compiler.block({
	 *     type: 'root',
	 *     children: [{
	 *       type: 'paragraph',
	 *       children: [{
	 *         type: 'text',
	 *         value: 'bar'
	 *       }]
	 *     }]
	 *   });
	 *   // 'bar'
	 *
	 * @param {Object} node - `root` node.
	 * @return {string} - Markdown block content.
	 */
	compilerPrototype.block = function (node) {
	    var self = this;
	    var values = [];
	    var children = node.children;
	    var length = children.length;
	    var index = -1;
	    var child;
	    var prev;
	
	    while (++index < length) {
	        child = children[index];
	
	        if (prev) {
	            /*
	             * Duplicate nodes, such as a list
	             * directly following another list,
	             * often need multiple new lines.
	             *
	             * Additionally, code blocks following a list
	             * might easily be mistaken for a paragraph
	             * in the list itself.
	             */
	
	            if (child.type === prev.type && prev.type === 'list') {
	                values.push(prev.ordered === child.ordered ? GAP : BREAK);
	            } else if (
	                prev.type === 'list' &&
	                child.type === 'code' &&
	                !child.lang
	            ) {
	                values.push(GAP);
	            } else {
	                values.push(BREAK);
	            }
	        }
	
	        values.push(self.visit(child, node));
	
	        prev = child;
	    }
	
	    return values.join(EMPTY);
	};
	
	/**
	 * Stringify a root.
	 *
	 * Adds a final newline to ensure valid POSIX files.
	 *
	 * @example
	 *   var compiler = new Compiler();
	 *
	 *   compiler.root({
	 *     type: 'root',
	 *     children: [{
	 *       type: 'paragraph',
	 *       children: [{
	 *         type: 'text',
	 *         value: 'bar'
	 *       }]
	 *     }]
	 *   });
	 *   // 'bar'
	 *
	 * @param {Object} node - `root` node.
	 * @return {string} - Markdown document.
	 */
	compilerPrototype.root = function (node) {
	    return this.block(node) + LINE;
	};
	
	/**
	 * Stringify a heading.
	 *
	 * In `setext: true` mode and when `depth` is smaller than
	 * three, creates a setext header:
	 *
	 *     Foo
	 *     ===
	 *
	 * Otherwise, an ATX header is generated:
	 *
	 *     ### Foo
	 *
	 * In `closeAtx: true` mode, the header is closed with
	 * hashes:
	 *
	 *     ### Foo ###
	 *
	 * @example
	 *   var compiler = new Compiler();
	 *
	 *   compiler.heading({
	 *     type: 'heading',
	 *     depth: 2,
	 *     children: [{
	 *       type: 'strong',
	 *       children: [{
	 *         type: 'text',
	 *         value: 'bar'
	 *       }]
	 *     }]
	 *   });
	 *   // '## **bar**'
	 *
	 * @param {Object} node - `heading` node.
	 * @return {string} - Markdown heading.
	 */
	compilerPrototype.heading = function (node) {
	    var self = this;
	    var setext = self.options.setext;
	    var closeAtx = self.options.closeAtx;
	    var depth = node.depth;
	    var content = self.all(node).join(EMPTY);
	    var prefix;
	
	    if (setext && depth < 3) {
	        return content + LINE +
	            repeat(depth === 1 ? EQUALS : DASH, content.length);
	    }
	
	    prefix = repeat(HASH, node.depth);
	    content = prefix + SPACE + content;
	
	    if (closeAtx) {
	        content += SPACE + prefix;
	    }
	
	    return content;
	};
	
	/**
	 * Stringify text.
	 *
	 * Supports named entities in `settings.encode: true` mode:
	 *
	 *     AT&amp;T
	 *
	 * Supports numbered entities in `settings.encode: numbers`
	 * mode:
	 *
	 *     AT&#x26;T
	 *
	 * @example
	 *   var compiler = new Compiler();
	 *
	 *   compiler.text({
	 *     type: 'text',
	 *     value: 'foo'
	 *   });
	 *   // 'foo'
	 *
	 * @param {Object} node - `text` node.
	 * @return {string} - Raw markdown text.
	 */
	compilerPrototype.text = function (node) {
	    return this.encode(node.value, node);
	};
	
	/**
	 * Stringify escaped text.
	 *
	 * @example
	 *   var compiler = new Compiler();
	 *
	 *   compiler.escape({
	 *     type: 'escape',
	 *     value: '\n'
	 *   });
	 *   // '\\\n'
	 *
	 * @param {Object} node - `escape` node.
	 * @return {string} - Markdown escape.
	 */
	compilerPrototype.escape = function (node) {
	    return '\\' + node.value;
	};
	
	/**
	 * Stringify a paragraph.
	 *
	 * @example
	 *   var compiler = new Compiler();
	 *
	 *   compiler.paragraph({
	 *     type: 'paragraph',
	 *     children: [{
	 *       type: 'strong',
	 *       children: [{
	 *         type: 'text',
	 *         value: 'bar'
	 *       }]
	 *     }]
	 *   });
	 *   // '**bar**'
	 *
	 * @param {Object} node - `paragraph` node.
	 * @return {string} - Markdown paragraph.
	 */
	compilerPrototype.paragraph = function (node) {
	    return this.all(node).join(EMPTY);
	};
	
	/**
	 * Stringify a block quote.
	 *
	 * @example
	 *   var compiler = new Compiler();
	 *
	 *   compiler.paragraph({
	 *     type: 'blockquote',
	 *     children: [{
	 *       type: 'paragraph',
	 *       children: [{
	 *         type: 'strong',
	 *         children: [{
	 *           type: 'text',
	 *           value: 'bar'
	 *         }]
	 *       }]
	 *     }]
	 *   });
	 *   // '> **bar**'
	 *
	 * @param {Object} node - `blockquote` node.
	 * @return {string} - Markdown block quote.
	 */
	compilerPrototype.blockquote = function (node) {
	    var indent = ANGLE_BRACKET_CLOSE + SPACE;
	
	    return indent + this.block(node).split(LINE).join(LINE + indent);
	};
	
	/**
	 * Stringify a list. See `Compiler#visitOrderedList()` and
	 * `Compiler#visitUnorderedList()` for internal working.
	 *
	 * @example
	 *   var compiler = new Compiler();
	 *
	 *   compiler.visitUnorderedItems({
	 *     type: 'list',
	 *     ordered: false,
	 *     children: [{
	 *       type: 'listItem',
	 *       children: [{
	 *         type: 'text',
	 *         value: 'bar'
	 *       }]
	 *     }]
	 *   });
	 *   // '-   bar'
	 *
	 * @param {Object} node - `list` node.
	 * @return {string} - Markdown list.
	 */
	compilerPrototype.list = function (node) {
	    return this[ORDERED_MAP[node.ordered]](node);
	};
	
	/**
	 * Stringify a list item.
	 *
	 * Prefixes the content with a checked checkbox when
	 * `checked: true`:
	 *
	 *     [x] foo
	 *
	 * Prefixes the content with an unchecked checkbox when
	 * `checked: false`:
	 *
	 *     [ ] foo
	 *
	 * @example
	 *   var compiler = new Compiler();
	 *
	 *   compiler.listItem({
	 *     type: 'listItem',
	 *     checked: true,
	 *     children: [{
	 *       type: 'text',
	 *       value: 'bar'
	 *     }]
	 *   }, {
	 *     type: 'list',
	 *     ordered: false,
	 *     children: [{
	 *       type: 'listItem',
	 *       checked: true,
	 *       children: [{
	 *         type: 'text',
	 *         value: 'bar'
	 *       }]
	 *     }]
	 *   }, 0, '*');
	 *   '-   [x] bar'
	 *
	 * @param {Object} node - `listItem` node.
	 * @param {Object} parent - `list` node.
	 * @param {number} position - Index of `node` in `parent`.
	 * @param {string} bullet - Bullet to use.  This, and the
	 *   `listItemIndent` setting define the used indent.
	 * @return {string} - Markdown list item.
	 */
	compilerPrototype.listItem = function (node, parent, position, bullet) {
	    var self = this;
	    var style = self.options.listItemIndent;
	    var children = node.children;
	    var values = [];
	    var index = -1;
	    var length = children.length;
	    var loose = node.loose;
	    var value;
	    var indent;
	    var spacing;
	
	    while (++index < length) {
	        values[index] = self.visit(children[index], node);
	    }
	
	    value = CHECKBOX_MAP[node.checked] + values.join(loose ? BREAK : LINE);
	
	    if (
	        style === LIST_ITEM_ONE ||
	        (style === LIST_ITEM_MIXED && value.indexOf(LINE) === -1)
	    ) {
	        indent = bullet.length + 1;
	        spacing = SPACE;
	    } else {
	        indent = Math.ceil((bullet.length + 1) / INDENT) * INDENT;
	        spacing = repeat(SPACE, indent - bullet.length);
	    }
	
	    value = bullet + spacing + pad(value, indent / INDENT).slice(indent);
	
	    if (loose && parent.children.length - 1 !== position) {
	        value += LINE;
	    }
	
	    return value;
	};
	
	/**
	 * Stringify inline code.
	 *
	 * Knows about internal ticks (`\``), and ensures one more
	 * tick is used to enclose the inline code:
	 *
	 *     ```foo ``bar`` baz```
	 *
	 * Even knows about inital and final ticks:
	 *
	 *     `` `foo ``
	 *     `` foo` ``
	 *
	 * @example
	 *   var compiler = new Compiler();
	 *
	 *   compiler.inlineCode({
	 *     type: 'inlineCode',
	 *     value: 'foo(); `bar`; baz()'
	 *   });
	 *   // '``foo(); `bar`; baz()``'
	 *
	 * @param {Object} node - `inlineCode` node.
	 * @return {string} - Markdown inline code.
	 */
	compilerPrototype.inlineCode = function (node) {
	    var value = node.value;
	    var ticks = repeat(TICK, longestStreak(value, TICK) + 1);
	    var start = ticks;
	    var end = ticks;
	
	    if (value.charAt(0) === TICK) {
	        start += SPACE;
	    }
	
	    if (value.charAt(value.length - 1) === TICK) {
	        end = SPACE + end;
	    }
	
	    return start + node.value + end;
	};
	
	/**
	 * Stringify YAML front matter.
	 *
	 * @example
	 *   var compiler = new Compiler();
	 *
	 *   compiler.yaml({
	 *     type: 'yaml',
	 *     value: 'foo: bar'
	 *   });
	 *   // '---\nfoo: bar\n---'
	 *
	 * @param {Object} node - `yaml` node.
	 * @return {string} - Markdown YAML document.
	 */
	compilerPrototype.yaml = function (node) {
	    var delimiter = repeat(DASH, YAML_FENCE_LENGTH);
	    var value = node.value ? LINE + node.value : EMPTY;
	
	    return delimiter + value + LINE + delimiter;
	};
	
	/**
	 * Stringify a code block.
	 *
	 * Creates indented code when:
	 *
	 * - No language tag exists;
	 * - Not in `fences: true` mode;
	 * - A non-empty value exists.
	 *
	 * Otherwise, GFM fenced code is created:
	 *
	 *     ```js
	 *     foo();
	 *     ```
	 *
	 * When in ``fence: `~` `` mode, uses tildes as fences:
	 *
	 *     ~~~js
	 *     foo();
	 *     ~~~
	 *
	 * Knows about internal fences (Note: GitHub/Kramdown does
	 * not support this):
	 *
	 *     ````javascript
	 *     ```markdown
	 *     foo
	 *     ```
	 *     ````
	 *
	 * Supports named entities in the language flag with
	 * `settings.encode` mode.
	 *
	 * @example
	 *   var compiler = new Compiler();
	 *
	 *   compiler.code({
	 *     type: 'code',
	 *     lang: 'js',
	 *     value: 'fooo();'
	 *   });
	 *   // '```js\nfooo();\n```'
	 *
	 * @param {Object} node - `code` node.
	 * @return {string} - Markdown code block.
	 */
	compilerPrototype.code = function (node, parent) {
	    var self = this;
	    var value = node.value;
	    var options = self.options;
	    var marker = options.fence;
	    var language = self.encode(node.lang || EMPTY, node);
	    var fence;
	
	    /*
	     * Without (needed) fences.
	     */
	
	    if (!language && !options.fences && value) {
	        /*
	         * Throw when pedantic, in a list item which
	         * isn’t compiled using a tab.
	         */
	
	        if (
	            parent &&
	            parent.type === 'listItem' &&
	            options.listItemIndent !== LIST_ITEM_TAB &&
	            options.pedantic
	        ) {
	            self.file.fail(ERROR_LIST_ITEM_INDENT, node.position);
	        }
	
	        return pad(value, 1);
	    }
	
	    fence = longestStreak(value, marker) + 1;
	
	    /*
	     * Fix GFM / RedCarpet bug, where fence-like characters
	     * inside fenced code can exit a code-block.
	     * Yes, even when the outer fence uses different
	     * characters, or is longer.
	     * Thus, we can only pad the code to make it work.
	     */
	
	    if (FENCE.test(value)) {
	        value = pad(value, 1);
	    }
	
	    fence = repeat(marker, Math.max(fence, MINIMUM_CODE_FENCE_LENGTH));
	
	    return fence + language + LINE + value + LINE + fence;
	};
	
	/**
	 * Stringify HTML.
	 *
	 * @example
	 *   var compiler = new Compiler();
	 *
	 *   compiler.html({
	 *     type: 'html',
	 *     value: '<div>bar</div>'
	 *   });
	 *   // '<div>bar</div>'
	 *
	 * @param {Object} node - `html` node.
	 * @return {string} - Markdown HTML.
	 */
	compilerPrototype.html = function (node) {
	    return node.value;
	};
	
	/**
	 * Stringify a horizontal rule.
	 *
	 * The character used is configurable by `rule`: (`'_'`)
	 *
	 *     ___
	 *
	 * The number of repititions is defined through
	 * `ruleRepetition`: (`6`)
	 *
	 *     ******
	 *
	 * Whether spaces delimit each character, is configured
	 * through `ruleSpaces`: (`true`)
	 *
	 *     * * *
	 *
	 * @example
	 *   var compiler = new Compiler();
	 *
	 *   compiler.horizontalRule({
	 *     type: 'horizontalRule'
	 *   });
	 *   // '***'
	 *
	 * @return {string} - Markdown rule.
	 */
	compilerPrototype.horizontalRule = function () {
	    var options = this.options;
	    var rule = repeat(options.rule, options.ruleRepetition);
	
	    if (options.ruleSpaces) {
	        rule = rule.split(EMPTY).join(SPACE);
	    }
	
	    return rule;
	};
	
	/**
	 * Stringify a strong.
	 *
	 * The marker used is configurable by `strong`, which
	 * defaults to an asterisk (`'*'`) but also accepts an
	 * underscore (`'_'`):
	 *
	 *     _foo_
	 *
	 * @example
	 *   var compiler = new Compiler();
	 *
	 *   compiler.strong({
	 *     type: 'strong',
	 *     children: [{
	 *       type: 'text',
	 *       value: 'Foo'
	 *     }]
	 *   });
	 *   // '**Foo**'
	 *
	 * @param {Object} node - `strong` node.
	 * @return {string} - Markdown strong-emphasised text.
	 */
	compilerPrototype.strong = function (node) {
	    var marker = this.options.strong;
	
	    marker = marker + marker;
	
	    return marker + this.all(node).join(EMPTY) + marker;
	};
	
	/**
	 * Stringify an emphasis.
	 *
	 * The marker used is configurable by `emphasis`, which
	 * defaults to an underscore (`'_'`) but also accepts an
	 * asterisk (`'*'`):
	 *
	 *     *foo*
	 *
	 * @example
	 *   var compiler = new Compiler();
	 *
	 *   compiler.emphasis({
	 *     type: 'emphasis',
	 *     children: [{
	 *       type: 'text',
	 *       value: 'Foo'
	 *     }]
	 *   });
	 *   // '_Foo_'
	 *
	 * @param {Object} node - `emphasis` node.
	 * @return {string} - Markdown emphasised text.
	 */
	compilerPrototype.emphasis = function (node) {
	    var marker = this.options.emphasis;
	
	    return marker + this.all(node).join(EMPTY) + marker;
	};
	
	/**
	 * Stringify a hard break.
	 *
	 * @example
	 *   var compiler = new Compiler();
	 *
	 *   compiler.break({
	 *     type: 'break'
	 *   });
	 *   // '  \n'
	 *
	 * @return {string} - Hard markdown break.
	 */
	compilerPrototype.break = function () {
	    return SPACE + SPACE + LINE;
	};
	
	/**
	 * Stringify a delete.
	 *
	 * @example
	 *   var compiler = new Compiler();
	 *
	 *   compiler.delete({
	 *     type: 'delete',
	 *     children: [{
	 *       type: 'text',
	 *       value: 'Foo'
	 *     }]
	 *   });
	 *   // '~~Foo~~'
	 *
	 * @param {Object} node - `delete` node.
	 * @return {string} - Markdown strike-through.
	 */
	compilerPrototype.delete = function (node) {
	    return DOUBLE_TILDE + this.all(node).join(EMPTY) + DOUBLE_TILDE;
	};
	
	/**
	 * Stringify a link.
	 *
	 * When no title exists, the compiled `children` equal
	 * `href`, and `href` starts with a protocol, an auto
	 * link is created:
	 *
	 *     <http://example.com>
	 *
	 * Otherwise, is smart about enclosing `href` (see
	 * `encloseURI()`) and `title` (see `encloseTitle()`).
	 *
	 *    [foo](<foo at bar dot com> 'An "example" e-mail')
	 *
	 * Supports named entities in the `href` and `title` when
	 * in `settings.encode` mode.
	 *
	 * @example
	 *   var compiler = new Compiler();
	 *
	 *   compiler.link({
	 *     type: 'link',
	 *     href: 'http://example.com',
	 *     title: 'Example Domain',
	 *     children: [{
	 *       type: 'text',
	 *       value: 'Foo'
	 *     }]
	 *   });
	 *   // '[Foo](http://example.com "Example Domain")'
	 *
	 * @param {Object} node - `link` node.
	 * @return {string} - Markdown link.
	 */
	compilerPrototype.link = function (node) {
	    var self = this;
	    var url = self.encode(node.href, node);
	    var value = self.all(node).join(EMPTY);
	
	    if (
	        node.title === null &&
	        PROTOCOL.test(url) &&
	        (url === value || url === MAILTO + value)
	    ) {
	        return encloseURI(url, true);
	    }
	
	    url = encloseURI(url);
	
	    if (node.title) {
	        url += SPACE + encloseTitle(self.encode(node.title, node));
	    }
	
	    value = SQUARE_BRACKET_OPEN + value + SQUARE_BRACKET_CLOSE;
	
	    value += PARENTHESIS_OPEN + url + PARENTHESIS_CLOSE;
	
	    return value;
	};
	
	/**
	 * Stringify a link label.
	 *
	 * Because link references are easily, mistakingly,
	 * created (for example, `[foo]`), reference nodes have
	 * an extra property depicting how it looked in the
	 * original document, so stringification can cause minimal
	 * changes.
	 *
	 * @example
	 *   label({
	 *     type: 'referenceImage',
	 *     referenceType: 'full',
	 *     identifier: 'foo'
	 *   });
	 *   // '[foo]'
	 *
	 *   label({
	 *     type: 'referenceImage',
	 *     referenceType: 'collapsed',
	 *     identifier: 'foo'
	 *   });
	 *   // '[]'
	 *
	 *   label({
	 *     type: 'referenceImage',
	 *     referenceType: 'shortcut',
	 *     identifier: 'foo'
	 *   });
	 *   // ''
	 *
	 * @param {Object} node - `linkReference` or
	 *   `imageReference` node.
	 * @return {string} - Markdown label reference.
	 */
	function label(node) {
	    var value = EMPTY;
	    var type = node.referenceType;
	
	    if (type === 'full') {
	        value = node.identifier;
	    }
	
	    if (type !== 'shortcut') {
	        value = SQUARE_BRACKET_OPEN + value + SQUARE_BRACKET_CLOSE;
	    }
	
	    return value;
	}
	
	/**
	 * Stringify a link reference.
	 *
	 * See `label()` on how reference labels are created.
	 *
	 * @example
	 *   var compiler = new Compiler();
	 *
	 *   compiler.linkReference({
	 *     type: 'linkReference',
	 *     referenceType: 'collapsed',
	 *     identifier: 'foo',
	 *     children: [{
	 *       type: 'text',
	 *       value: 'Foo'
	 *     }]
	 *   });
	 *   // '[Foo][]'
	 *
	 * @param {Object} node - `linkReference` node.
	 * @return {string} - Markdown link reference.
	 */
	compilerPrototype.linkReference = function (node) {
	    return SQUARE_BRACKET_OPEN +
	        this.all(node).join(EMPTY) + SQUARE_BRACKET_CLOSE +
	        label(node);
	};
	
	/**
	 * Stringify an image reference.
	 *
	 * See `label()` on how reference labels are created.
	 *
	 * Supports named entities in the `alt` when
	 * in `settings.encode` mode.
	 *
	 * @example
	 *   var compiler = new Compiler();
	 *
	 *   compiler.imageReference({
	 *     type: 'imageReference',
	 *     referenceType: 'full',
	 *     identifier: 'foo',
	 *     alt: 'Foo'
	 *   });
	 *   // '![Foo][foo]'
	 *
	 * @param {Object} node - `imageReference` node.
	 * @return {string} - Markdown image reference.
	 */
	compilerPrototype.imageReference = function (node) {
	    var alt = this.encode(node.alt, node);
	
	    return EXCLAMATION_MARK +
	        SQUARE_BRACKET_OPEN + alt + SQUARE_BRACKET_CLOSE +
	        label(node);
	};
	
	/**
	 * Stringify a footnote reference.
	 *
	 * @example
	 *   var compiler = new Compiler();
	 *
	 *   compiler.footnoteReference({
	 *     type: 'footnoteReference',
	 *     identifier: 'foo'
	 *   });
	 *   // '[^foo]'
	 *
	 * @param {Object} node - `footnoteReference` node.
	 * @return {string} - Markdown footnote reference.
	 */
	compilerPrototype.footnoteReference = function (node) {
	    return SQUARE_BRACKET_OPEN + CARET + node.identifier +
	        SQUARE_BRACKET_CLOSE;
	};
	
	/**
	 * Stringify an link- or image definition.
	 *
	 * Is smart about enclosing `href` (see `encloseURI()`) and
	 * `title` (see `encloseTitle()`).
	 *
	 *    [foo]: <foo at bar dot com> 'An "example" e-mail'
	 *
	 * @example
	 *   var compiler = new Compiler();
	 *
	 *   compiler.definition({
	 *     type: 'definition',
	 *     link: 'http://example.com',
	 *     title: 'Example Domain',
	 *     identifier: 'foo'
	 *   });
	 *   // '[foo]: http://example.com "Example Domain"'
	 *
	 * @param {Object} node - `definition` node.
	 * @return {string} - Markdown link- or image definition.
	 */
	compilerPrototype.definition = function (node) {
	    var value = SQUARE_BRACKET_OPEN + node.identifier + SQUARE_BRACKET_CLOSE;
	    var url = encloseURI(node.link);
	
	    if (node.title) {
	        url += SPACE + encloseTitle(node.title);
	    }
	
	    return value + COLON + SPACE + url;
	};
	
	/**
	 * Stringify an image.
	 *
	 * Is smart about enclosing `href` (see `encloseURI()`) and
	 * `title` (see `encloseTitle()`).
	 *
	 *    ![foo](</fav icon.png> 'My "favourite" icon')
	 *
	 * Supports named entities in `src`, `alt`, and `title`
	 * when in `settings.encode` mode.
	 *
	 * @example
	 *   var compiler = new Compiler();
	 *
	 *   compiler.image({
	 *     type: 'image',
	 *     href: 'http://example.png/favicon.png',
	 *     title: 'Example Icon',
	 *     alt: 'Foo'
	 *   });
	 *   // '![Foo](http://example.png/favicon.png "Example Icon")'
	 *
	 * @param {Object} node - `image` node.
	 * @return {string} - Markdown image.
	 */
	compilerPrototype.image = function (node) {
	    var encode = this.encode;
	    var url = encloseURI(encode(node.src, node));
	    var value;
	
	    if (node.title) {
	        url += SPACE + encloseTitle(encode(node.title, node));
	    }
	
	    value = EXCLAMATION_MARK +
	        SQUARE_BRACKET_OPEN + encode(node.alt || EMPTY, node) +
	        SQUARE_BRACKET_CLOSE;
	
	    value += PARENTHESIS_OPEN + url + PARENTHESIS_CLOSE;
	
	    return value;
	};
	
	/**
	 * Stringify a footnote.
	 *
	 * @example
	 *   var compiler = new Compiler();
	 *
	 *   compiler.footnote({
	 *     type: 'footnote',
	 *     children: [{
	 *       type: 'text',
	 *       value: 'Foo'
	 *     }]
	 *   });
	 *   // '[^Foo]'
	 *
	 * @param {Object} node - `footnote` node.
	 * @return {string} - Markdown footnote.
	 */
	compilerPrototype.footnote = function (node) {
	    return SQUARE_BRACKET_OPEN + CARET + this.all(node).join(EMPTY) +
	        SQUARE_BRACKET_CLOSE;
	};
	
	/**
	 * Stringify a footnote definition.
	 *
	 * @example
	 *   var compiler = new Compiler();
	 *
	 *   compiler.footnoteDefinition({
	 *     type: 'footnoteDefinition',
	 *     identifier: 'foo',
	 *     children: [{
	 *       type: 'paragraph',
	 *       children: [{
	 *         type: 'text',
	 *         value: 'bar'
	 *       }]
	 *     }]
	 *   });
	 *   // '[^foo]: bar'
	 *
	 * @param {Object} node - `footnoteDefinition` node.
	 * @return {string} - Markdown footnote definition.
	 */
	compilerPrototype.footnoteDefinition = function (node) {
	    var id = node.identifier.toLowerCase();
	
	    return SQUARE_BRACKET_OPEN + CARET + id +
	        SQUARE_BRACKET_CLOSE + COLON + SPACE +
	        this.all(node).join(BREAK + repeat(SPACE, INDENT));
	};
	
	/**
	 * Stringify table.
	 *
	 * Creates a fenced table by default, but not in
	 * `looseTable: true` mode:
	 *
	 *     Foo | Bar
	 *     :-: | ---
	 *     Baz | Qux
	 *
	 * NOTE: Be careful with `looseTable: true` mode, as a
	 * loose table inside an indented code block on GitHub
	 * renders as an actual table!
	 *
	 * Creates a spaces table by default, but not in
	 * `spacedTable: false`:
	 *
	 *     |Foo|Bar|
	 *     |:-:|---|
	 *     |Baz|Qux|
	 *
	 * @example
	 *   var compiler = new Compiler();
	 *
	 *   compiler.table({
	 *     type: 'table',
	 *     align: ['center', null],
	 *     children: [
	 *       {
	 *         type: 'tableHeader',
	 *         children: [
	 *           {
	 *             type: 'tableCell'
	 *             children: [{
	 *               type: 'text'
	 *               value: 'Foo'
	 *             }]
	 *           },
	 *           {
	 *             type: 'tableCell'
	 *             children: [{
	 *               type: 'text'
	 *               value: 'Bar'
	 *             }]
	 *           }
	 *         ]
	 *       },
	 *       {
	 *         type: 'tableRow',
	 *         children: [
	 *           {
	 *             type: 'tableCell'
	 *             children: [{
	 *               type: 'text'
	 *               value: 'Baz'
	 *             }]
	 *           },
	 *           {
	 *             type: 'tableCell'
	 *             children: [{
	 *               type: 'text'
	 *               value: 'Qux'
	 *             }]
	 *           }
	 *         ]
	 *       }
	 *     ]
	 *   });
	 *   // '| Foo | Bar |\n| :-: | --- |\n| Baz | Qux |'
	 *
	 * @param {Object} node - `table` node.
	 * @return {string} - Markdown table.
	 */
	compilerPrototype.table = function (node) {
	    var self = this;
	    var loose = self.options.looseTable;
	    var spaced = self.options.spacedTable;
	    var rows = node.children;
	    var index = rows.length;
	    var result = [];
	    var start;
	
	    while (index--) {
	        result[index] = self.all(rows[index]);
	    }
	
	    start = loose ? EMPTY : spaced ? PIPE + SPACE : PIPE;
	
	    return table(result, {
	        'align': node.align,
	        'start': start,
	        'end': start.split(EMPTY).reverse().join(EMPTY),
	        'delimiter': spaced ? SPACE + PIPE + SPACE : PIPE
	    });
	};
	
	/**
	 * Stringify a table cell.
	 *
	 * @example
	 *   var compiler = new Compiler();
	 *
	 *   compiler.tableCell({
	 *     type: 'tableCell',
	 *     children: [{
	 *       type: 'text'
	 *       value: 'Qux'
	 *     }]
	 *   });
	 *   // 'Qux'
	 *
	 * @param {Object} node - `tableCell` node.
	 * @return {string} - Markdown table cell.
	 */
	compilerPrototype.tableCell = function (node) {
	    return this.all(node).join(EMPTY);
	};
	
	/**
	 * Stringify the bound file.
	 *
	 * @example
	 *   var file = new VFile('__Foo__');
	 *
	 *   file.namespace('mdast').tree = {
	 *     type: 'strong',
	 *     children: [{
	 *       type: 'text',
	 *       value: 'Foo'
	 *     }]
	 *   });
	 *
	 *   new Compiler(file).compile();
	 *   // '**Foo**'
	 *
	 * @this {Compiler}
	 * @return {string} - Markdown document.
	 */
	compilerPrototype.compile = function () {
	    return this.visit(this.file.namespace('mdast').tree);
	};
	
	/*
	 * Expose `stringify` on `module.exports`.
	 */
	
	module.exports = Compiler;


/***/ }),
/* 1486 */,
/* 1487 */
/***/ (function(module, exports) {

	/**
	 * Helpers.
	 */
	
	var s = 1000;
	var m = s * 60;
	var h = m * 60;
	var d = h * 24;
	var y = d * 365.25;
	
	/**
	 * Parse or format the given `val`.
	 *
	 * Options:
	 *
	 *  - `long` verbose formatting [false]
	 *
	 * @param {String|Number} val
	 * @param {Object} [options]
	 * @throws {Error} throw an error if val is not a non-empty string or a number
	 * @return {String|Number}
	 * @api public
	 */
	
	module.exports = function(val, options) {
	  options = options || {};
	  var type = typeof val;
	  if (type === 'string' && val.length > 0) {
	    return parse(val);
	  } else if (type === 'number' && isNaN(val) === false) {
	    return options.long ? fmtLong(val) : fmtShort(val);
	  }
	  throw new Error(
	    'val is not a non-empty string or a valid number. val=' +
	      JSON.stringify(val)
	  );
	};
	
	/**
	 * Parse the given `str` and return milliseconds.
	 *
	 * @param {String} str
	 * @return {Number}
	 * @api private
	 */
	
	function parse(str) {
	  str = String(str);
	  if (str.length > 100) {
	    return;
	  }
	  var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(
	    str
	  );
	  if (!match) {
	    return;
	  }
	  var n = parseFloat(match[1]);
	  var type = (match[2] || 'ms').toLowerCase();
	  switch (type) {
	    case 'years':
	    case 'year':
	    case 'yrs':
	    case 'yr':
	    case 'y':
	      return n * y;
	    case 'days':
	    case 'day':
	    case 'd':
	      return n * d;
	    case 'hours':
	    case 'hour':
	    case 'hrs':
	    case 'hr':
	    case 'h':
	      return n * h;
	    case 'minutes':
	    case 'minute':
	    case 'mins':
	    case 'min':
	    case 'm':
	      return n * m;
	    case 'seconds':
	    case 'second':
	    case 'secs':
	    case 'sec':
	    case 's':
	      return n * s;
	    case 'milliseconds':
	    case 'millisecond':
	    case 'msecs':
	    case 'msec':
	    case 'ms':
	      return n;
	    default:
	      return undefined;
	  }
	}
	
	/**
	 * Short format for `ms`.
	 *
	 * @param {Number} ms
	 * @return {String}
	 * @api private
	 */
	
	function fmtShort(ms) {
	  if (ms >= d) {
	    return Math.round(ms / d) + 'd';
	  }
	  if (ms >= h) {
	    return Math.round(ms / h) + 'h';
	  }
	  if (ms >= m) {
	    return Math.round(ms / m) + 'm';
	  }
	  if (ms >= s) {
	    return Math.round(ms / s) + 's';
	  }
	  return ms + 'ms';
	}
	
	/**
	 * Long format for `ms`.
	 *
	 * @param {Number} ms
	 * @return {String}
	 * @api private
	 */
	
	function fmtLong(ms) {
	  return plural(ms, d, 'day') ||
	    plural(ms, h, 'hour') ||
	    plural(ms, m, 'minute') ||
	    plural(ms, s, 'second') ||
	    ms + ' ms';
	}
	
	/**
	 * Pluralization helper.
	 */
	
	function plural(ms, n, name) {
	  if (ms < n) {
	    return;
	  }
	  if (ms < n * 1.5) {
	    return Math.floor(ms / n) + ' ' + name;
	  }
	  return Math.ceil(ms / n) + ' ' + name + 's';
	}


/***/ }),
/* 1488 */
/***/ (function(module, exports) {

	'use strict'
	
	module.exports = identity
	
	try {
	  normalize('')
	  module.exports = normalize
	} catch (_) {}
	
	// Normalize `uri`.
	function normalize(uri) {
	  return encodeURI(decodeURI(uri))
	}
	
	/* istanbul ignore next - Fallback, return input. */
	function identity(uri) {
	  return uri
	}


/***/ }),
/* 1489 */,
/* 1490 */,
/* 1491 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// modified from https://github.com/es-shims/es6-shim
	var objectKeys = __webpack_require__(1493);
	var hasSymbols = __webpack_require__(334)();
	var callBound = __webpack_require__(312);
	var toObject = Object;
	var $push = callBound('Array.prototype.push');
	var $propIsEnumerable = callBound('Object.prototype.propertyIsEnumerable');
	var originalGetSymbols = hasSymbols ? Object.getOwnPropertySymbols : null;
	
	// eslint-disable-next-line no-unused-vars
	module.exports = function assign(target, source1) {
		if (target == null) { throw new TypeError('target must be an object'); }
		var to = toObject(target); // step 1
		if (arguments.length === 1) {
			return to; // step 2
		}
		for (var s = 1; s < arguments.length; ++s) {
			var from = toObject(arguments[s]); // step 3.a.i
	
			// step 3.a.ii:
			var keys = objectKeys(from);
			var getSymbols = hasSymbols && (Object.getOwnPropertySymbols || originalGetSymbols);
			if (getSymbols) {
				var syms = getSymbols(from);
				for (var j = 0; j < syms.length; ++j) {
					var key = syms[j];
					if ($propIsEnumerable(from, key)) {
						$push(keys, key);
					}
				}
			}
	
			// step 3.a.iii:
			for (var i = 0; i < keys.length; ++i) {
				var nextKey = keys[i];
				if ($propIsEnumerable(from, nextKey)) { // step 3.a.iii.2
					var propValue = from[nextKey]; // step 3.a.iii.2.a
					to[nextKey] = propValue; // step 3.a.iii.2.b
				}
			}
		}
	
		return to; // step 4
	};


/***/ }),
/* 1492 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var keysShim;
	if (!Object.keys) {
		// modified from https://github.com/es-shims/es5-shim
		var has = Object.prototype.hasOwnProperty;
		var toStr = Object.prototype.toString;
		var isArgs = __webpack_require__(712); // eslint-disable-line global-require
		var isEnumerable = Object.prototype.propertyIsEnumerable;
		var hasDontEnumBug = !isEnumerable.call({ toString: null }, 'toString');
		var hasProtoEnumBug = isEnumerable.call(function () {}, 'prototype');
		var dontEnums = [
			'toString',
			'toLocaleString',
			'valueOf',
			'hasOwnProperty',
			'isPrototypeOf',
			'propertyIsEnumerable',
			'constructor'
		];
		var equalsConstructorPrototype = function (o) {
			var ctor = o.constructor;
			return ctor && ctor.prototype === o;
		};
		var excludedKeys = {
			$applicationCache: true,
			$console: true,
			$external: true,
			$frame: true,
			$frameElement: true,
			$frames: true,
			$innerHeight: true,
			$innerWidth: true,
			$onmozfullscreenchange: true,
			$onmozfullscreenerror: true,
			$outerHeight: true,
			$outerWidth: true,
			$pageXOffset: true,
			$pageYOffset: true,
			$parent: true,
			$scrollLeft: true,
			$scrollTop: true,
			$scrollX: true,
			$scrollY: true,
			$self: true,
			$webkitIndexedDB: true,
			$webkitStorageInfo: true,
			$window: true
		};
		var hasAutomationEqualityBug = (function () {
			/* global window */
			if (typeof window === 'undefined') { return false; }
			for (var k in window) {
				try {
					if (!excludedKeys['$' + k] && has.call(window, k) && window[k] !== null && typeof window[k] === 'object') {
						try {
							equalsConstructorPrototype(window[k]);
						} catch (e) {
							return true;
						}
					}
				} catch (e) {
					return true;
				}
			}
			return false;
		}());
		var equalsConstructorPrototypeIfNotBuggy = function (o) {
			/* global window */
			if (typeof window === 'undefined' || !hasAutomationEqualityBug) {
				return equalsConstructorPrototype(o);
			}
			try {
				return equalsConstructorPrototype(o);
			} catch (e) {
				return false;
			}
		};
	
		keysShim = function keys(object) {
			var isObject = object !== null && typeof object === 'object';
			var isFunction = toStr.call(object) === '[object Function]';
			var isArguments = isArgs(object);
			var isString = isObject && toStr.call(object) === '[object String]';
			var theKeys = [];
	
			if (!isObject && !isFunction && !isArguments) {
				throw new TypeError('Object.keys called on a non-object');
			}
	
			var skipProto = hasProtoEnumBug && isFunction;
			if (isString && object.length > 0 && !has.call(object, 0)) {
				for (var i = 0; i < object.length; ++i) {
					theKeys.push(String(i));
				}
			}
	
			if (isArguments && object.length > 0) {
				for (var j = 0; j < object.length; ++j) {
					theKeys.push(String(j));
				}
			} else {
				for (var name in object) {
					if (!(skipProto && name === 'prototype') && has.call(object, name)) {
						theKeys.push(String(name));
					}
				}
			}
	
			if (hasDontEnumBug) {
				var skipConstructor = equalsConstructorPrototypeIfNotBuggy(object);
	
				for (var k = 0; k < dontEnums.length; ++k) {
					if (!(skipConstructor && dontEnums[k] === 'constructor') && has.call(object, dontEnums[k])) {
						theKeys.push(dontEnums[k]);
					}
				}
			}
			return theKeys;
		};
	}
	module.exports = keysShim;


/***/ }),
/* 1493 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var slice = Array.prototype.slice;
	var isArgs = __webpack_require__(712);
	
	var origKeys = Object.keys;
	var keysShim = origKeys ? function keys(o) { return origKeys(o); } : __webpack_require__(1492);
	
	var originalKeys = Object.keys;
	
	keysShim.shim = function shimObjectKeys() {
		if (Object.keys) {
			var keysWorksWithArguments = (function () {
				// Safari 5.0 bug
				var args = Object.keys(arguments);
				return args && args.length === arguments.length;
			}(1, 2));
			if (!keysWorksWithArguments) {
				Object.keys = function keys(object) { // eslint-disable-line func-name-matching
					if (isArgs(object)) {
						return originalKeys(slice.call(object));
					}
					return originalKeys(object);
				};
			}
		} else {
			Object.keys = keysShim;
		}
		return Object.keys || keysShim;
	};
	
	module.exports = keysShim;


/***/ }),
/* 1494 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var implementation = __webpack_require__(1491);
	
	var lacksProperEnumerationOrder = function () {
		if (!Object.assign) {
			return false;
		}
		/*
		 * v8, specifically in node 4.x, has a bug with incorrect property enumeration order
		 * note: this does not detect the bug unless there's 20 characters
		 */
		var str = 'abcdefghijklmnopqrst';
		var letters = str.split('');
		var map = {};
		for (var i = 0; i < letters.length; ++i) {
			map[letters[i]] = letters[i];
		}
		var obj = Object.assign({}, map);
		var actual = '';
		for (var k in obj) {
			actual += k;
		}
		return str !== actual;
	};
	
	var assignHasPendingExceptions = function () {
		if (!Object.assign || !Object.preventExtensions) {
			return false;
		}
		/*
		 * Firefox 37 still has "pending exception" logic in its Object.assign implementation,
		 * which is 72% slower than our shim, and Firefox 40's native implementation.
		 */
		var thrower = Object.preventExtensions({ 1: 2 });
		try {
			Object.assign(thrower, 'xy');
		} catch (e) {
			return thrower[1] === 'y';
		}
		return false;
	};
	
	module.exports = function getPolyfill() {
		if (!Object.assign) {
			return implementation;
		}
		if (lacksProperEnumerationOrder()) {
			return implementation;
		}
		if (assignHasPendingExceptions()) {
			return implementation;
		}
		return Object.assign;
	};


/***/ }),
/* 1495 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// resolves . and .. elements in a path array with directory names there
	// must be no slashes, empty elements, or device names (c:\) in the array
	// (so also no leading and trailing slashes - it does not distinguish
	// relative and absolute paths)
	function normalizeArray(parts, allowAboveRoot) {
	  // if the path tries to go above the root, `up` ends up > 0
	  var up = 0;
	  for (var i = parts.length - 1; i >= 0; i--) {
	    var last = parts[i];
	    if (last === '.') {
	      parts.splice(i, 1);
	    } else if (last === '..') {
	      parts.splice(i, 1);
	      up++;
	    } else if (up) {
	      parts.splice(i, 1);
	      up--;
	    }
	  }
	
	  // if the path is allowed to go above the root, restore leading ..s
	  if (allowAboveRoot) {
	    for (; up--; up) {
	      parts.unshift('..');
	    }
	  }
	
	  return parts;
	}
	
	// Split a filename into [root, dir, basename, ext], unix version
	// 'root' is just a slash, or nothing.
	var splitPathRe =
	    /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/;
	var splitPath = function(filename) {
	  return splitPathRe.exec(filename).slice(1);
	};
	
	// path.resolve([from ...], to)
	// posix version
	exports.resolve = function() {
	  var resolvedPath = '',
	      resolvedAbsolute = false;
	
	  for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
	    var path = (i >= 0) ? arguments[i] : process.cwd();
	
	    // Skip empty and invalid entries
	    if (typeof path !== 'string') {
	      throw new TypeError('Arguments to path.resolve must be strings');
	    } else if (!path) {
	      continue;
	    }
	
	    resolvedPath = path + '/' + resolvedPath;
	    resolvedAbsolute = path.charAt(0) === '/';
	  }
	
	  // At this point the path should be resolved to a full absolute path, but
	  // handle relative paths to be safe (might happen when process.cwd() fails)
	
	  // Normalize the path
	  resolvedPath = normalizeArray(filter(resolvedPath.split('/'), function(p) {
	    return !!p;
	  }), !resolvedAbsolute).join('/');
	
	  return ((resolvedAbsolute ? '/' : '') + resolvedPath) || '.';
	};
	
	// path.normalize(path)
	// posix version
	exports.normalize = function(path) {
	  var isAbsolute = exports.isAbsolute(path),
	      trailingSlash = substr(path, -1) === '/';
	
	  // Normalize the path
	  path = normalizeArray(filter(path.split('/'), function(p) {
	    return !!p;
	  }), !isAbsolute).join('/');
	
	  if (!path && !isAbsolute) {
	    path = '.';
	  }
	  if (path && trailingSlash) {
	    path += '/';
	  }
	
	  return (isAbsolute ? '/' : '') + path;
	};
	
	// posix version
	exports.isAbsolute = function(path) {
	  return path.charAt(0) === '/';
	};
	
	// posix version
	exports.join = function() {
	  var paths = Array.prototype.slice.call(arguments, 0);
	  return exports.normalize(filter(paths, function(p, index) {
	    if (typeof p !== 'string') {
	      throw new TypeError('Arguments to path.join must be strings');
	    }
	    return p;
	  }).join('/'));
	};
	
	
	// path.relative(from, to)
	// posix version
	exports.relative = function(from, to) {
	  from = exports.resolve(from).substr(1);
	  to = exports.resolve(to).substr(1);
	
	  function trim(arr) {
	    var start = 0;
	    for (; start < arr.length; start++) {
	      if (arr[start] !== '') break;
	    }
	
	    var end = arr.length - 1;
	    for (; end >= 0; end--) {
	      if (arr[end] !== '') break;
	    }
	
	    if (start > end) return [];
	    return arr.slice(start, end - start + 1);
	  }
	
	  var fromParts = trim(from.split('/'));
	  var toParts = trim(to.split('/'));
	
	  var length = Math.min(fromParts.length, toParts.length);
	  var samePartsLength = length;
	  for (var i = 0; i < length; i++) {
	    if (fromParts[i] !== toParts[i]) {
	      samePartsLength = i;
	      break;
	    }
	  }
	
	  var outputParts = [];
	  for (var i = samePartsLength; i < fromParts.length; i++) {
	    outputParts.push('..');
	  }
	
	  outputParts = outputParts.concat(toParts.slice(samePartsLength));
	
	  return outputParts.join('/');
	};
	
	exports.sep = '/';
	exports.delimiter = ':';
	
	exports.dirname = function(path) {
	  var result = splitPath(path),
	      root = result[0],
	      dir = result[1];
	
	  if (!root && !dir) {
	    // No dirname whatsoever
	    return '.';
	  }
	
	  if (dir) {
	    // It has a dirname, strip trailing slash
	    dir = dir.substr(0, dir.length - 1);
	  }
	
	  return root + dir;
	};
	
	
	exports.basename = function(path, ext) {
	  var f = splitPath(path)[2];
	  // TODO: make this comparison case-insensitive on windows?
	  if (ext && f.substr(-1 * ext.length) === ext) {
	    f = f.substr(0, f.length - ext.length);
	  }
	  return f;
	};
	
	
	exports.extname = function(path) {
	  return splitPath(path)[3];
	};
	
	function filter (xs, f) {
	    if (xs.filter) return xs.filter(f);
	    var res = [];
	    for (var i = 0; i < xs.length; i++) {
	        if (f(xs[i], i, xs)) res.push(xs[i]);
	    }
	    return res;
	}
	
	// String.prototype.substr - negative index don't work in IE8
	var substr = 'ab'.substr(-1) === 'b'
	    ? function (str, start, len) { return str.substr(start, len) }
	    : function (str, start, len) {
	        if (start < 0) start = str.length + start;
	        return str.substr(start, len);
	    }
	;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(47)))

/***/ }),
/* 1496 */,
/* 1497 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = __webpack_require__(1498);
	
	function emptyFunction() {}
	function emptyFunctionWithReset() {}
	emptyFunctionWithReset.resetWarningCache = emptyFunction;
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    var err = new Error(
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	    err.name = 'Invariant Violation';
	    throw err;
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bigint: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    elementType: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim,
	
	    checkPropTypes: emptyFunctionWithReset,
	    resetWarningCache: emptyFunction
	  };
	
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ }),
/* 1498 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ }),
/* 1499 */,
/* 1500 */,
/* 1501 */,
/* 1502 */,
/* 1503 */,
/* 1504 */,
/* 1505 */,
/* 1506 */,
/* 1507 */,
/* 1508 */,
/* 1509 */,
/* 1510 */,
/* 1511 */,
/* 1512 */,
/* 1513 */,
/* 1514 */
/***/ (function(module, exports) {

	module.exports = "# Extension Activities\n\n&nbsp;\n"

/***/ }),
/* 1515 */
/***/ (function(module, exports) {

	module.exports = "# Emergency Preparedness Squad Theme Song\n\nYouTube: _0TUIVDHqSE\n\n## Description\n\nSing and dance along to the Emergency Preparedness Squad's theme song anytime you like. Great for starting a lesson!\n\n\n# Esmeralda Planet Protector & The E-Waste Emergency\n\nYouTube: POzKQKxvuzQ\nLowRes: true\n\n## Description\n\nWatch Esmeralda and Goober fight the rise of electronic waste and the evil supervillain Blaster, with some help from our our Planet Protector friends!\n\n\n# Esmeralda Planet Protector & The Litterless Lunch\n\nYouTube: OeT53lGAYX4\nLowRes: true\n\n## Description\n\nEsmeralda and Goober take on Trashella to stop her from convincing kid to bring lunches that make litter!\n\n\n# Esmeralda Planet Protector & Walking To School\n\nYouTube: 1FmXmBOU-V8\nLowRes: true\n\n## Description\n\nCan Esmeralda Superspy Planet Protector and her sidekick Goober stop the Evil Dr. Carbon's dastardly plan to stop kids from walking to school?\n\n\n# Esmeralda Superspy: Backstage #1\n\nYouTube: BQyzd8Y7EaY\nLowRes: true\n\n## Description\n\nDo series stars Ian and Sara spend their time saving the environment and protecting the planet? No, because Ian keeps acting like a monkey! Even when the boss, Jacqueline, is around.\n\n\n# Esmeralda Superspy: Backstage #2\n\nYouTube: AEmVWqAie6s\nLowRes: true\n\n## Description\n\nTake a peak behind the scenes! Sara takes you on a tour of the set - or at least, she tries to. Ian keeps messing up her shots!\n\n\n# Esmeralda Superspy: Backstage #3\n\nYouTube: zZId4Rr2-Rw\nLowRes: true\n\n## Description\n\nIan thinks he's doing a safety speech for the funny environmental show \"Esmeralda Superspy\" but really, Sara is about to get her revenge on him for wrecking her scenes.\n\n\n# Good Green News: Vancouver Urban Gardens\n\nYouTube: dPD3BogYAKw\nLowRes: true\n\n## Description\n\nKid reporter Tia, 9, reports on the Good Green News in the city of Vancouver - Find out why Vancouver helped bring over 400 urban gardens to the city!\n"

/***/ }),
/* 1516 */
/***/ (function(module, exports) {

	module.exports = "# Level Completed\n\n## Content\n\n### Welcome back!\n* Click the MENU button (top left) and use MODULES to go back to any of the modules.\n* Or check out the videos in the EXTRAS section!\n\n\n## Notes\n\nWelcome back!\n"

/***/ }),
/* 1517 */
/***/ (function(module, exports) {

	module.exports = "# Teacher Resources\n## Welcome!\nWe're so happy to be training emergency preparedness superheroes from {r/:$cityOrMunicipality}!\n\n#### Know the Risks assembly presentation\nThese classroom-based learning modules for the Emergency Preparedness Squad program are designed to follow on from the assembly *Know the Risks* presentation by our actors. If you've yet to receive the presentation, feel free to familiarize yourself with the classroom modules!\n\n#### Teacher's Guide\nWhile the program is plug & play, the **Teachers_Guide.pdf** gives you a full overview of program's contents and how it works (Overview and Quick Start Guide sections).\n\n#### Web browser compatibility\nThe Academy has been designed to work with the latest modern browsers, including *Chrome*, *Firefox* and *Safari*. If you usually use Internet Explorer, please use a different browser for a bug-free experience!\n\n#### Support\nGet in touch if you have any questions through the Messenger in the bottom right-hand corner!\n\n# Printables\n\n#### Essential Print Materials\nBefore you start the program with your class, make sure you print the following resources:\n\n**No files for Assembly module.**\n"

/***/ }),
/* 1518 */
/***/ (function(module, exports) {

	module.exports = "# Assembly  Overview\r\n\r\n&nbsp;\r\n"

/***/ }),
/* 1519 */
/***/ (function(module, exports) {

	module.exports = "# Connecting Remote\n\n### Connect your remote!\nTo connect a second device as a Remote Control:\n1. Go to www.remote4ppa.com on your tablet/phone.\n2. Enter your username and password on your tablet/phone.\n3. Go to the next slide to Select Role For This Device.\n4. Choose the right Role for each device.\n5. Your selections will be saved for future use, but you can always change it later!\n\n# Tech Check Intro\n\n### Tech Check!\nNOW PLEASE hook up your main device to your projector and **test the audio/video** to make sure everything's working! There's a fun video in the next slide to help you do this (it's also in the Fun section if you want to share with your class).\n\n#### Full Screen Experience\nThe Planet Protector Academy is best enjoyed as a full screen experience. **Click 'View'** in your browser's menu bar, and select **'Full Screen'** (Chrome) or **'Enter Full Screen'** (Safari/Firefox).\n\n# Tech Check Video\nYouTube: ZVdMndkjaIo\n"

/***/ }),
/* 1520 */
/***/ (function(module, exports) {

	module.exports = "# Assembly Start\n\n## Notes\n\n### Start\n\n&nbsp;\n\n# Know The Risks Icon\n\n## Notes\n\n&nbsp;\n"

/***/ }),
/* 1521 */
/***/ (function(module, exports) {

	module.exports = "# Congratulations\n\n## Content\n\n### Congratulations!\n\n#### You're now Apprentices in the Emergency Preparedness Squad!\n\n## Notes\n\n&nbsp;\n\n\n# Song Intro\n\n## Content\n\n###### Get ready to sing!\n\n## Notes\n\n&nbsp;\n\n\n# Song\nYouTube: a_hq2Bcb6Ug\n\n## Notes\n\n&nbsp;\n"

/***/ }),
/* 1522 */
/***/ (function(module, exports) {

	module.exports = "# Overview\n\n## Content\n\n### There are four parts!\n1. Know the Risks\n2. Make a Plan\n3. Get a Kit\n4. We're In This Together\n\n## Notes\n\n&nbsp;\n"

/***/ }),
/* 1523 */
/***/ (function(module, exports) {

	module.exports = "# Get Into Your Teams\n\n## Content\n\n###### Get into your teams!\n\n## Notes\n\n&nbsp;\n"

/***/ }),
/* 1524 */
/***/ (function(module, exports) {

	module.exports = "Superhero Calming Breath\n\n# Part 1 Intro\n\n## Content\n\n### Part 1: Know the Risks\n\n#### What is an emergency?\n\n## Notes\n\n&nbsp;\n\n\n# Climate Change Emergencies\n\n## Content\n\n### Climate Change weather-related emergencies\n\n## Notes\n\n&nbsp;\n\n\n# Keep Cool Song\nYouTube: d2TDbYKERuM\nLowRes: true\n\n## Notes\n\n&nbsp;\n\n\n# Superhero Calming Breath\n\n## Content\n\n###### Superhero Calming Breath!\n\n## Notes\n\n&nbsp;\n\n\n# Superhero Calming Breath Instructions\n\n## Content\n\n### Instructions:\n* Breath in 1 - 2 - 3 - 4\n* Hold 1 - 2\n* Breath out 1 - 2 - 3 - 4\n* Hold 1 - 2\n\n## Notes\n\n&nbsp;\n\n\n# Surprise Test\n\n## Content\n\n###### Surprise Test!\n\n## Notes\n\n&nbsp;\n\n\n# Drop Cover Hold On\n\n## Content\n\n###### Drop, Cover\n###### & Hold On\n\n## Notes\n\n&nbsp;\n"

/***/ }),
/* 1525 */
/***/ (function(module, exports) {

	module.exports = "# Game Show\n\nLevel 1 - Know the Risks\n\n\n# Sizzle\n\n## Notes\n\n&nbsp;\n\n\n# Scoring\n\n## Content\n\n### How to score points\n* Do your Superhero pose.\n* Buzz in first.\n* Give a good answer. Try your best!\n* If you don’t know the answer, think about what a good answer might be. This is not a test!\n\n## Notes\n\n&nbsp;\n\n\n# Four Players Announcement\n\n## Notes\n\n* One Apprentice from each team comes to the front of the room.\n* Encourage a different Apprentice to come up for each question.\n\n\n# Question 1\n\n## Question\n\n#### What are potential emergencies in your region?\n\n## Answer\n\n### Top Ten Emergencies:\n#### Earthquakes, Avalanches\n#### Wildfires, Disease Outbreak\n#### Landslides, Tsunamis, Power Outages\n#### Hazardous Material Spills\n#### Severe Weather, Floods\n\n## Answer Notes\n\n&nbsp;\n\n\n# Question 2\n\n## Question\n\n#### What kind of things can happen in a storm?\n\n## Answer\n\n### Some risks from storms:\n* Trees/branches falling\n* Power outage\n* Property damage\n* Roads closed\n\n## Answer Notes\n\n&nbsp;\n\n\n# Question 3\n\n## Question\n\n#### What can happen in a power outage?\n\n## Answer\n\n### Some risks from power outages:\n* No electricity or lights\n* No heat if electric\n* No street lights or traffic lights\n* Internet probably won't work\n* Fresh food will go bad in the fridge\n\n## Answer Notes\n\n&nbsp;\n\n\n# Question 4\n\n## Question\n\n#### Who can help you in an emergency?\n\n## Answer\n\n### People who can help:\n* Your friends\n* Your family\n* Teachers\n* Neighbours\n\nThe people who are right with you are the ones who will help! In a big emergency the police/fire/ambulance service will be very busy helping those who need urgent assistance.\n\n## Answer Notes\n\n&nbsp;\n"

/***/ }),
/* 1526 */
/***/ (function(module, exports) {

	module.exports = "# Sizzle\n\n## Content\n\n### Activity: Brainstorm!\n#### Get a Kit\n\n## Notes\n&nbsp;\n\n\n# Instructions\n\n## Content\n\n### Instructions:\n* What are some things that should probably go in your kit?\n* Squad leaders: collect answers from your team and write them down\n* Points for good answers, number of answers, good {r/Canada:behaviour}{r/:behavior}\n* 3 minutes!\n\n## Notes\n\n&nbsp;\n\n\n# Time Up\n\n## Content\n\n###### Time's up!\n\n## Notes\n\n&nbsp;\n\n\n# Collate Lists\n\n## Content\n\n### Squad leaders:\n#### Put all your team's answers into one list\n\n## Notes\n\n&nbsp;\n\n\n# Answers\n\n## Content\n\n### Things to put in your kit:\n* Food, Water (nonperishable)\n* Flashlight, Candles\n* Medication, Glasses\n* Extra clothes, Blanket\n* Picture / letter from parents\n* Copy of plan, incl contact info and safe meeting place\n* First aid kit\n\n## Notes\n\n&nbsp;\n"

/***/ }),
/* 1527 */
/***/ (function(module, exports) {

	module.exports = "Emergency Kit\n\n# Sizzle\n\n## Content\n\n### Activity: Popcorn!\n#### Make a Plan\n\n## Notes\n&nbsp;\n\n# Instructions\n\n## Content\n\n### What needs to be included in your plan?\n\n## Notes\n\n&nbsp;\n\n\n# Answers\n\n## Content\n\n### Some possible answers:\n* Your meeting place\n* A plan for each family member\n* Written contact info\n* A plan for your pets\n\n## Notes\n\n&nbsp;\n"

/***/ }),
/* 1528 */
/***/ (function(module, exports) {

	module.exports = "# Mission Assignment\n\nTitle: Assembly Mission\n\n## Notes\n\n&nbsp;\n\n\n# Instructions\n\n## Content\n\n### Your mission:\n\n1. Practice your Superhero Calming Breath\n2. Talk to your family about Emergency Preparedness and tell them about the Alertable app\n3. Know your community - they are the ones with you in an emergency!\n\n## Notes\n\n&nbsp;\n"

/***/ }),
/* 1529 */
/***/ (function(module, exports) {

	module.exports = "Finish\n\n# Song\nYouTube: f5KyvOXPqN8\n\n## Notes\n\n&nbsp;\n"

/***/ }),
/* 1530 */
/***/ (function(module, exports) {

	module.exports = "# Extension Activities\n\n#### Emergency Preparedness Squad song\n* Perform during Emergency Preparedness Week or at another assembly for your school.\n* We’d love to hear about it or see a video!!\n* For even more fun, Apprentices can create their own choreography.\n\n#### PreparedBC's Master of Disaster teaching resource\n* The Province of BC has developed a curriculum-linked resource for Grade 6 classrooms. [Check it out](http://www2.gov.bc.ca/gov/content/safety/emergency-preparedness-response-recovery/preparedbc/master-of-disaster)!\n* Not a Grade 6 teacher? Check out their [extensive multimedia resource library](https://www2.gov.bc.ca/gov/content/safety/emergency-preparedness-response-recovery/preparedbc/master-of-disaster/master-of-disaster-multimedia-resources) for more educational resources on emergency preparedness!\n\n#### Other Emergency Preparedness resources\n* [Disaster Hero](http://www.disasterhero.com/) online video game where players compete to become the next Disaster Hero!\n* [Ready.gov](https://www.ready.gov/kids) is the US government's hub for emergency preparedness info includes a special kids section with PDF resources and online games.\n* [American Public Health Association](http://www.getreadyforflu.org/kids/)'s resources include puzzles and brain teasers with an emergency preparedness theme.\n"

/***/ }),
/* 1531 */
/***/ (function(module, exports) {

	module.exports = "# Emergency Preparedness Squad Theme Song\n\nYouTube: _0TUIVDHqSE\n\n## Description\n\nSing and dance along to the Emergency Preparedness Squad's theme song anytime you like. Great for starting a lesson!\n\n\n# Esmeralda Planet Protector & The E-Waste Emergency\n\nYouTube: POzKQKxvuzQ\nLowRes: true\n\n## Description\n\nWatch Esmeralda and Goober fight the rise of electronic waste and the evil supervillain Blaster, with some help from our our Planet Protector friends!\n\n\n# Esmeralda Planet Protector & The Litterless Lunch\n\nYouTube: OeT53lGAYX4\nLowRes: true\n\n## Description\n\nEsmeralda and Goober take on Trashella to stop her from convincing kid to bring lunches that make litter!\n\n\n# Esmeralda Planet Protector & Walking To School\n\nYouTube: 1FmXmBOU-V8\nLowRes: true\n\n## Description\n\nCan Esmeralda Superspy Planet Protector and her sidekick Goober stop the Evil Dr. Carbon's dastardly plan to stop kids from walking to school?\n\n\n# Esmeralda Superspy: Backstage #1\n\nYouTube: BQyzd8Y7EaY\nLowRes: true\n\n## Description\n\nDo series stars Ian and Sara spend their time saving the environment and protecting the planet? No, because Ian keeps acting like a monkey! Even when the boss, Jacqueline, is around.\n\n\n# Esmeralda Superspy: Backstage #2\n\nYouTube: AEmVWqAie6s\nLowRes: true\n\n## Description\n\nTake a peak behind the scenes! Sara takes you on a tour of the set - or at least, she tries to. Ian keeps messing up her shots!\n\n\n# Esmeralda Superspy: Backstage #3\n\nYouTube: zZId4Rr2-Rw\nLowRes: true\n\n## Description\n\nIan thinks he's doing a safety speech for the funny environmental show \"Esmeralda Superspy\" but really, Sara is about to get her revenge on him for wrecking her scenes.\n\n\n# Good Green News: Vancouver Urban Gardens\n\nYouTube: dPD3BogYAKw\nLowRes: true\n\n## Description\n\nKid reporter Tia, 9, reports on the Good Green News in the city of Vancouver - Find out why Vancouver helped bring over 400 urban gardens to the city!\n"

/***/ }),
/* 1532 */
/***/ (function(module, exports) {

	module.exports = "# Level Completed\n\n## Content\n\n### Welcome back!\n* Click the MENU button (top left) and use MODULES to go back to any of the three modules.\n* Or check out the videos in the EXTRAS section!\n\n## Notes\n\nWelcome back!\n"

/***/ }),
/* 1533 */
/***/ (function(module, exports) {

	module.exports = "# Teacher Resources\n## Welcome!\nWe're so happy to be training emergency preparedness superheroes from {r/:$cityOrMunicipality}!\n\n#### Know the Risks assembly presentation\nThese classroom-based learning modules for the Emergency Preparedness Squad program are designed to follow on from the assembly *Know the Risks* presentation by our actors. If you've yet to receive the presentation, feel free to familiarize yourself with the classroom modules!\n\n#### {r/Canada} Teacher's Guide\n{r/Canada} Download the [Teacher's Guide](Teachers_Guide.pdf) for a full overview of the program's contents and how it works.\n\n#### Curriculum Links\nThe Emergency Preparedness Squad supports curriculum standards in science, arts, language and social studies. The following connections are provided for your convenience:\n\n* {r/Canada/BC}[BC Grades 3-5](CL_PPA-EPS-Hybrid_Canada_BC_Grades_3-5.pdf)\n* {r/} We don't have curriculum links for your area yet. Do you want to help us develop them? Please contact us!\n\n#### Need help from a human?\nGet in touch through the Messenger in the bottom right-hand corner!\n\n# Printables\n\n#### Required Print Materials\n\n* Mission Files for each child in [{r/Canada:colour}{r/:color}](Printables_Mission_Files_Colour.pdf) or [black & white](Printables_Mission_Files_BW.pdf).\n* [Answers](Printables_Crossword_Answers.pdf) to Emergency Preparedness Crossword in Mission Files.\n* Completion certificates for each child in [{r/Canada:colour}{r/:color}](Printables_Completion_Certificates_Colour.pdf) or [black & white](Printables_Completion_Certificates_BW.pdf).\n\n#### Optional Print Materials\n* Winning team certificates in [{r/Canada:colour}{r/:color}](Printables_Winning_Certificates_Colour.pdf) or [black & white](Printables_Winning_Certificates_BW.pdf).\n"

/***/ }),
/* 1534 */
/***/ (function(module, exports) {

	module.exports = "# Module 1 Overview\r\n\r\n#### MAKE A PLAN at a glance\r\n##### Typical duration: 1 hour\r\n* Watch engaging videos.\r\n* Sing the Emergency Preparedness Squad Theme Song.\r\n* Report on their Know the Risks at-home mission.\r\n* Play a game show on the importance of making a family emergency preparedness plan.\r\n* Draw a floor plan of your home and identify emergency exits.\r\n* Be assigned their next mission, Mission 1: Make a Plan.\r\n\r\n#### Getting into teams\r\n* Before starting the program, divide your class into four teams - Earth, Air, Fire and Water (we recommend you set up the teams ahead of time and that they remain the same for the duration of the program).\r\n* Each team will work together during the various arts-based activities and score points for participating, collaborating, listening etc.\r\n* It's a flexible system for you to reward the {r/Canada:behaviour}{r/:behavior} you want to see in your class!\r\n\r\n#### Key Vocabulary\r\n* Planning\r\n* Emergency Plan\r\n* Safety and wellbeing\r\n* Emergency exits\r\n\r\n# Materials\r\n\r\n#### What you need for this level\r\n* Mission Files for each student in [{r/Canada:colour}{r/:color}](Printables_Mission_Files_Colour.pdf) or [black & white](Printables_Mission_Files_BW.pdf).\r\n"

/***/ }),
/* 1535 */
/***/ (function(module, exports) {

	module.exports = "# Module 2 Overview\n\n#### GET A KIT at a glance\n##### Typical duration: 1 hour\nIn this level, Apprentices will:\n* Sing the Emergency Preparedness Squad Theme Song.\n* Report on their Make a Plan at-home mission.\n* Play a game show which engages them on the importance of making an emergency preparedness kit.\n* Write and perform, in teams, a rap about making an emergency preparedness kit.\n* Be assigned their second mission, Mission 2: Get a Kit.\n\n\n#### Getting into teams\n* Your class should already be divided into teams from the previous session.  They will keep these teams through the program.\n* Each team will work together during the various arts-based activities and score points for participating, collaborating, listening etc.\n\n#### Key Vocabulary\n* Emergency Preparedness Kit\n\n# Materials\n\n#### What you need for this level\n* Mission Files (available from the Printables section on the Dashboard page)\n"

/***/ }),
/* 1536 */
/***/ (function(module, exports) {

	module.exports = "# Module 3 Overview\n\n#### WE'RE IN THIS TOGETHER at a glance\n##### Typical duration: 1 hour\nIn this level, Apprentices will:\n* Sing the Emergency Preparedness Squad Theme Song.\n* Report back on their Get a Kit at-home mission.\n* Play a game show which engages them on being good community members during an emergency.\n* Receive individual participation and winning team certificates.\n* Celebrate their achievements during the program!\n\n#### Key Vocabulary\n* Community\n\n# Materials\n\n#### What you need for this level\n* Mission Files\n* Completion certificates for each Apprentice in [{r/Canada:colour}{r/:color}](Printables_Completion_Certificates_Colour.pdf) or [black & white](Printables_Completion_Certificates_BW.pdf).\n* Once you know which team has earned the most points, you can print a Winning Team Certificate in [{r/Canada:colour}{r/:color}](Printables_Winning_Certificates_Colour.pdf) or [black & white](Printables_Winning_Certificates_BW.pdf) to post on your classroom wall after the lesson.\n"

/***/ }),
/* 1537 */
/***/ (function(module, exports) {

	module.exports = "# Tech Prep Wizard\n\n### Tech Prep Wizard\n\nThis short wizard will help you get set up to run the Academy in your classroom.\n\nDon't show your students the screen yet!\n\nClick the arrow or use your keyboard's right directional arrow to move through the wizard.\n\n# Two Device Intro\n\n### Two Device Experience\nThe Academy is best experienced using two devices:\n* Main device (COMPUTER or TABLET) projects the website at the front of the class.\n* Second device (TABLET or CELLPHONE) can be as a Remote Control (optional):\n  * gives you freedom to move around the classroom.\n  * contains prompts and facilitation notes at your finger tips.\n  * provides useful progress indicators, such as length of videos and number of slides remaining.\n\n# Connecting Remote\n\n### Connect your remote!\nTo connect a second device as a Remote Control:\n1. Go to www.remote4ppa.com on your tablet/phone.\n2. Enter your username and password on your tablet/phone.\n3. Go to the next slide to Select Role For This Device.\n4. Choose the right Role for each device.\n5. Your selections will be saved for future use, but you can always change it later!\n\n# Tech Check Intro\n\n### Tech Check!\nNOW PLEASE hook up your main device to your projector and **test the audio/video** to make sure everything's working! There's a fun video in the next slide to help you do this (it's also in the Fun section if you want to share with your class).\n\n#### Full Screen Experience\nThe Planet Protector Academy is best enjoyed as a full screen experience. **Click 'View'** in your browser's menu bar, and select **'Full Screen'** (Chrome) or **'Enter Full Screen'** (Safari/Firefox).\n\n# Tech Check Video\nYouTube: ZVdMndkjaIo\n"

/***/ }),
/* 1538 */
/***/ (function(module, exports) {

	module.exports = "# Program Start\n\n# Level 1 Start\n\n## Notes\n\n### Start\n\nShow this screen at the start of class. When the kids are ready, advance to the next screen.\n\nUse the directional arrows on your remote to go forwards/backwards through the level.\n\n# Level 1 Icon\n\n## Notes\n\nMake a Plan\n\n### Tracking your progress\n\nYou can see how far along you are by the slide number on the top of your Remote Control or by the blue progress bar running along the bottom of the Menu on the Classroom Display.\n\n# Level 1 Intro\n\nYouTube: NOpMBKA5T4Q\n\n## Notes\n\nSara and Ian welcome the students back to the Emergency Preparedness Squad program (0:36).\n\n### Problems with your video buffering?\nPause the video and wait a minute for it to pre-load, then it should play without a hitch!\n\n# Level 2 Start\n\n## Notes\n\n### Start\n\nShow this screen at the start of class. When the kids are ready, advance to the next screen.\n\n# Level 2 Icon\n\n## Notes\n\nGet a Kit\n\n# Level 2 Intro\n\nYouTube: O4Qx3wGyCWA\n\n## Notes\n\nSara and Ian welcome the students back to the program (0:15).\n\n# Level 3 Start\n\n## Notes\n\n### Start\n\nShow this screen at the start of class. When the kids are ready, advance to the next screen.\n\n# Level 3 Icon\n\n## Notes\n\nWe're In This Together\n"

/***/ }),
/* 1539 */
/***/ (function(module, exports) {

	module.exports = "# Song\nYouTube: fB3ZHt6aYJ8\n\n## Notes\n\n### Emergency Preparedness Squad Song\n\nEncourage your class to learn this song and sing along to the video (2:21).\n\n### Extension Activities\nApprentices can perform the song to the whole school and/or create their own choreography.\n"

/***/ }),
/* 1540 */
/***/ (function(module, exports) {

	module.exports = "Team Creation\n\n# Intro Team Names\n\nYouTube: 2Nspklyhmtg\n\n## Notes\nSara and Ian introduce the level and tell Apprentices to get into teams (1:51).\n\n# Get Into Teams\n\n## Content\n\n###### Get into four teams!\n\nName your teams in the next slide.\n\n## Notes\n\nName teams in the next slide. Once you enter the name in the text field, it automatically saves!\n\n# Scoring Intro\n\n## Content\n\n### Here's how your team can score points\n\n* Answer questions\n* Do activities\n* Complete missions\n* Work well together (teamwork points)\n* and more!\n\n## Notes\n\n### Scoring\n* Teams can earn points for most activities in the program. You can allocate points as you see fit. Maximum points total is 999.\n* Individuals can earn points for teams, or teams can earn points together.\n* Teamwork points are critical to ensure collaboration.\n* Points can also be a classroom \"currency\", e.g.to gain classroom privileges.\n* The team with the most points at the end of Level 3 is the winner.\n\n# Scoreboard Intro\n\n## Content\n\n### Check out the scoreboard!\n\nYour teams are now ready to start scoring points!\n\n## Notes\n\nClick on the 'Scoreboard' icon on your remote at any time to bring down the scoreboard and add points for teams.\n\n# Congratulations\n\n## Content\n\n### Congratulations!\n\n#### You're now Apprentices in the Emergency Preparedness Squad!\n\n## Notes\n\n&nbsp;\n"

/***/ }),
/* 1541 */
/***/ (function(module, exports) {

	module.exports = "# Esmeralda and Goober Story\n\nYouTube: i6c_oeWPDxg\n\n## Notes\nEsmeralda and Goober storyline - Make a Plan (1:47).\n\n# Calming Breath Intro\n\nYouTube: bDy55oVYj00\n\n## Notes\nSara and Ian help Apprentices practice the Superhero Calming Breath (0:49).\n"

/***/ }),
/* 1542 */
/***/ (function(module, exports) {

	module.exports = "# Sharknado\nYouTube: _JRlG-5_7ic\n\n## Notes\n\nSara and Ian share what should go in your Apprentices' emergency kits (4:16).\n\n# Calming Breath Recap\nYouTube: nUGO4-S_I5w\n\n## Notes\n\nPractice the Superhero Calming Breath! (0:36).\n\n# Esmeralda and Goober Story\n\nYouTube: 5FvPTip5iI4\n\n## Notes\nEsmeralda and Goober storyline - Get a Kit (2:37).\n"

/***/ }),
/* 1543 */
/***/ (function(module, exports) {

	module.exports = "# Esmeralda and Goober Story\n\nYouTube: Ka3bcyUj6TU\n\n## Notes\nEsmeralda and Goober storyline wrap-up (2:19).\n"

/***/ }),
/* 1544 */
/***/ (function(module, exports) {

	module.exports = "# Mission Report\nTitle: Know the Risks\n\n# Scoring\n\n## Content\n\n### Count your mission points!\n\n* Your mission at the end of the 'Know the Risks' assembly was to talk to your family about preparing for an emergency.\n* Teams get one point for each team member that talked with their families.\n* Make sure your points get added onto the Scoreboard!\n\n## Notes\n\n&nbsp;\n\n# Instructions\n\n## Content\n\n### Time to report to HQ!\n\n* Answer with a show of hands.\n* Teachers can report too!\n\n## Notes\n\n### Mission Reports\n* Mission reports help us communicate the impact of our program. Thanks for helping us to measure it!\n* Using a show of hands keeps the data anonymous.\n\n# Questions\n\n## Content\n\n1. Number of Apprentices and Teachers reporting in.\n2. I talked with my family about the Top Ten Emergencies.\n3. I've used the Superhero Calming Breath to help me feel calm.\n4. How many Apprentices are having fun with this program?\n\n# Impact\n\n## Content\n\n### Awesome work, Apprentices!\n\nYour Mission Report was received by Emergency Preparedness Squad HQ.\n\n## Notes\n\nGreat job!\n\n# Class Discussion\n\n## Content\n\n### Class Discussion\n* As a class, discuss what was easy or hard about this mission.\n* What worked, what didn’t work?\n* What would make it easier?\n\n## Notes\n\nEncourage Apprentices who did not succeed to keep trying, if appropriate.\n"

/***/ }),
/* 1545 */
/***/ (function(module, exports) {

	module.exports = "# Mission Report\nTitle: Make a Plan\n\n# Scoring\n\n## Content\n\n### Get points for your missions!\n\n* Turn to Level 1 - Make a Plan in your Mission Files.\n* In your teams, count the total number of points you scored.\n* Make sure your points get added onto the Scoreboard!\n\n## Notes\n\nThis slide only covers actions listed under 'Get a point for' for each mission.\nStudents report the Mission Report section next.\n\n# Instructions\n\n## Content\n\n### Time to report to HQ!\n\n* Answer with a show of hands.\n* Teachers can report too!\n\n## Notes\n\n### Mission Reports\n* Mission reports help us communicate the impact of our program. Thanks for helping us to measure it!\n* Using a show of hands keeps the data anonymous.\n\n# Questions\n\n## Content\n\n1. Number of Apprentices and Teachers reporting in.\n2. +My family filled out an emergency plan.\n3. +My family started filling out a plan but didn't finish.\n4. +My family hasn't made an emergency plan YET, but we pledge to soon.\n5. +My family didn't make an emergency plan and aren't likely to.\n6. How many Apprentices feel like real-life Emergency Preparedness Squad superheroes now?\n\n# Impact\n\n## Content\n\n### Awesome work, Apprentices!\n\nYour Mission Report was received by Emergency Preparedness Squad HQ.\n\n## Notes\n\nGreat job!\n\n# Class Discussion\n\n## Content\n\n### Class Discussion\n* As a class, discuss what was easy or hard about this mission.\n* What worked, what didn’t work?\n* What would make it easier?\n\n## Notes\n\nEncourage Apprentices who did not succeed to keep trying, if appropriate.\n"

/***/ }),
/* 1546 */
/***/ (function(module, exports) {

	module.exports = "# Mission Report\nTitle: Get a Kit\n\n# Intro Video\nYouTube: oQiZTpCPDM4\n\n## Notes\n\nSara and Ian introduce the mission report for Get a Kit (3:04).\n\n# Scoring\n\n## Content\n\n### Get points for your missions!\n\n* Turn to Level 2 - Get a Kit in your Mission Files.\n* In your teams, count the total number of points you scored.\n* Make sure your points get added onto the Scoreboard!\n\n## Notes\n\nThis slide only covers actions listed under 'Get a point for' for each mission.\nStudents report the Mission Report section next.\n\n# Instructions\n\n## Content\n\n### Time to report to HQ!\n\n* Answer with a show of hands.\n* Teachers can report too!\n\n## Notes\n\n### Mission Reports\n* Mission reports help us communicate the impact of our program. Thanks for helping us to measure it!\n* Using a show of hands keeps the data anonymous.\n\n# Questions\n\n## Content\n\n1. Number of Apprentices and Teachers reporting in.\n2. +My family started putting together our kit.\n3. +My family hasn't started our kit YET but we pledge to do it soon.\n4. +My family didn't make an emergency kit and aren't likely to.\n5. How many Apprentices pledge to be Emergency Preparedness Squad superheroes from now on?\n6. My family succeeded in at least one mission during the program.\n\n# Impact\n\n## Content\n\n### Awesome work, Apprentices!\n\nYour Mission Report was received by Emergency Preparedness Squad HQ.\n\n## Notes\n\nGreat job!\n\n# Class Discussion\n\n## Content\n\n### Class Discussion\n* As a class, discuss what was easy or hard about this mission.\n* What worked, what didn’t work?\n* What would make it easier?\n\n## Notes\n\nEncourage apprentices who did not succeed to keep trying, if appropriate.\n"

/***/ }),
/* 1547 */
/***/ (function(module, exports) {

	module.exports = "Level 1 - Make a Plan\n\n# Intro Video\n\nYouTube: 6a5nxfJ3UB8\n\n## Notes\n\nSara and Ian introduce the Game Show (2:38).\n\n# Sizzle\n\n## Notes\n\n### Game Show\nIn the Game Show we ask questions relating to the topic *before* giving the answers, in order to stimulate thinking, rather than to test knowledge.\n\nOne Apprentice from each team will come up to the front of the class and get a chance to answer the question in turn.\n\nFor more info, see \"Game Show Info\" in the Teachers Guide, which is available in the Teacher Resources section on the Dashboard page.\n\n# Scoring\n\n## Content\n\n### How to score points\n* Do your Superhero pose.\n* Buzz in first.\n* Give a good answer. Try your best!\n* If you don’t know the answer, think about what a good answer might be. This is not a test!\n\n## Notes\n\nDon't forget to score points on the Scoreboard!\n\n# Four Players Announcement\n\n## Notes\n\n* One Apprentice from each team comes to the front of the room.\n* Encourage a different Apprentice to come up for each question.\n\n# Question 1\n\n## Question\n\n#### Name some things you could plan e.g. a party\n\n## Answer\n\n### Some things you could plan:\n* Party\n* Trip\n* Class\n* Making a video\n* How you'll study for a test\n* A neighbourhood hockey game\n\n## Answer Notes\n\n&nbsp;\n\n# Scoring Reminder\n\n## Content\n\n### Don't forget to add scores!\n\n## Notes\n\nClick on the 'Scores' button below to open up the Scoreboard.\n\n# Question 2\n\n## Question\n\n#### What do you think is the goal of an emergency plan? Why do we need one?\n\n## Answer\n\n### Goal is safety and well-being:\n* So we think about what we’ll need to do ahead of time.\n* So we’ll feel more prepared and safe.\n* So we have all our information together.\n* So we know what to do.\n\n## Answer Notes\n\n&nbsp;\n\n# Question 3\n\n## Question\n\n#### Team brainstorm - What are some things that should be included in an emergency plan?\n\n## Answer\n\n### Some things that should be in an emergency plan:\n* Where to meet your family.\n* How to contact your family.\n* What to do if you're in different places (work/home/play).\n* Plan for your pets.\n* Special needs concerns.\n* Emergency contact info.\n\n## Answer Notes\n\n&nbsp;\n"

/***/ }),
/* 1548 */
/***/ (function(module, exports) {

	module.exports = "Level 2 - Get a Kit\n\n# Intro Video\n\nYouTube: OpmtyG62cn4\n\n## Notes\n\nSara and Ian introduce the Game Show (0:29).\n\n# Sizzle\n\n## Notes\n\nGame Show\n\n# Scoring\n\n## Content\n\n### Reminder:\n* Do your Superhero pose.\n* Buzz in first.\n* Give a good answer.\n\n## Notes\n\nDon't forget to score points on the Scoreboard!\n\n# Four Players Announcement\n\n## Notes\n\nFour players to the front.\n\n# Question 1\n\n## Question\n\n#### What do you think an emergency prep kit is for?\n\n## Answer\n\n### An emergency preparedness kit is so you can:\n* Have something to eat\n* Have water to drink\n* Stay safe and warm\n* Get important news\n\n## Answer Notes\n\n&nbsp;\n\n# Scoring Reminder\n\n## Content\n\n### Don't forget to add scores!\n\n## Notes\n\nClick on the 'Scores' button below to open up the Scoreboard.\n\n# Question 2\n\n## Question\n\n#### Name a good place to keep your emergency kit in your home.\n\n## Answer\n\n### Some places to keep your kit:\n* Near the door\n* In a bag you can grab and go\n* Make sure everyone in your family knows where it's stored!\n\n## Answer Notes\n\n&nbsp;\n\n# Question 3\n\n## Question\n\n#### Team brainstorm - write down as many things as you can that should probably go in your kit.\nScoring: If you got ten or items or more, get ten points. No peeking in your Mission Files!\n\n## Answer\n\n### Things you can put in your kit:\n* Food\n* Water (nonperishable)\n* Flashlight\n* Medication + glasses\n* Extra clothes\n* Picture / letter from parents\n* Copy of plan, incl contact info and safe meeting place\n\n## Answer Notes\n\n&nbsp;\n"

/***/ }),
/* 1549 */
/***/ (function(module, exports) {

	module.exports = "Level 3 - We're In This Together\n\n# Intro Video\n\nYouTube: mXdAKK3NAmE\n\n## Notes\n\nSara and Ian introduce the Game Show (0:47).\n\n# Sizzle\n\n## Notes\n\nGame Show\n\n# Four Players Announcement\n\n## Notes\n\nFour players to the front.\n\n# Question 1\n\n## Question\n\n#### Who are the people most likely to help you in an emergency?\n\n## Answer\n\n### Some people who are likely to help you:\n* Your friends\n* Your family\n* Teachers\n* Neighbours\n\n## Answer Notes\n\n&nbsp;\n\n# Question 2\n\n## Question\n\n#### Why aren't the police and fire fighters the ones likely to help?\n\n## Answer\n\n#### They will be busy saving lives, where they can do the most good.\n\n## Answer Notes\n\n&nbsp;\n\n# Question 3\n\n## Question Intro\n\n#### When should you call 911?\nMultiple choice - see next slide!\n\n## Question\n(a) to ask if an earthquake just happened\n\n(b) to tell them an earthquake just happened\n\n(c) if someone's life is in danger\n\n(d) if a gas main broke\n\n## Answer\n\n#### The answer is: (c) + (d)\nDon't call 911 unless someone's life is in danger.\n\n## Answer Notes\n\n&nbsp;\n"

/***/ }),
/* 1550 */
/***/ (function(module, exports) {

	module.exports = "Group Drawing\n\n# Intro Video\n\nYouTube: B779gOrzCuk\n\n## Notes\n\nSara and Ian introduce the importance of being prepared for the first 72hrs. They also introduce the first part of making an emergency plan (1:18).\n\n# Sizzle\n\n## Content\n\n### Activity 1: Drawing!\n\n## Notes\nActivity instructions on next slide.\n\n# Instructions\n\n## Content\n\n### Activity Instructions:\n* Draw a floorplan of one room in your home.\n* Plan emergency exits from one room of your home.\n  * Try to think of two possibilities.\n  * If you live in an apartment, do not plan to use the elevators.\n* Two points for the drawing.\n* One point for getting your parent/guardian to sign the natural gas safety info in your Mission Files!\n\n## Notes\n\n&nbsp;\n"

/***/ }),
/* 1551 */
/***/ (function(module, exports) {

	module.exports = "# Intro Video\n\nYouTube: anIbh_g5Tu4\n\n## Notes\nIntro to rap activity (1:20).\n\n# Sizzle\n\n## Content\n\n### Activity 1: Write a rap!\n\n(Younger grades can write a poem instead)\n\n## Notes\n\nActivity instructions on next slide.\n\n# Instructions\n\n## Content\n\n### Activity Instructions:\n* Write a rap about things you’ll need in your kit - at least two items.\n* Write two lines, where the last word in each line rhymes.\n* Your Mission Files has sample rhymes, but get bonus points for using words that aren't in the booklet.\n* If you're writing a rap, {r/Canada:practise}{r/:practice} in your teams with the backing track on the next slide.\n\n## Notes\n\nThere is a worksheet in the Mission File for this activity.\n\n# Rap Backtrack Practice\n\nYouTube: eEzxxHgcpzE\n\n## Notes\n\nTo get the backtrack (10:07) to repeat, just press play again.\n\n# Scoring\n\n## Content\n\n### Now perform for the class!\n\n#### Get points for:\n* Two lines that rhyme.\n* Good performance.\n* Beatboxing (if you're rapping).\n* Being a good audience.\n\n## Notes\n\n### Extension Activity\nVideo your raps and submit them to our website!\n\n# Rap Backtrack Perform\nYouTube: eEzxxHgcpzE\n\n## Notes\n\nTo get the backtrack to repeat, just press play again.\n"

/***/ }),
/* 1552 */
/***/ (function(module, exports) {

	module.exports = "# Intro Video  \n\nYouTube: 0MKIR2myq7U\n\n## Notes\nSara and Ian introduce the Drawing activity (1:21).\n\n# Sizzle\n\n## Content\n\n### Activity 1: Drawing!\n\n## Notes\n\n&nbsp;\n\n# Instructions\n\n## Content\n\n### Activity Instructions:\n* Draw a picture of the people you might be with in an emergency.\n* Points for trying your best!\n\n## Notes\n\n&nbsp;\n"

/***/ }),
/* 1553 */
/***/ (function(module, exports) {

	module.exports = "# Mission Assignment\n\nTitle: Make a Plan\n\n## Notes\n&nbsp;\n\n# Mission Intro Video\n\nYouTube: F8mHgZSKa1s\n\n## Notes\n\nIan and Sara introduce Mission 1 - Make a Plan (2:01).\n\n### Make a Plan\n* Apprentices turn to Mission 1 in their Mission Files.\n* Decide which day you will do the next Level.\n* Apprentices write that date on the cover of their Mission Files and on the Mission 1 page.\n* Points are awarded for signed and returned Mission 1 page.\n\n# Instructions\n\n## Content\n\n### Mission 1:\n\n#### Making a plan\n* Get your family to make a plan!\n* With the adults in your family, fill out the plan in your Mission Files.\n* Make copies of the plan and store it in safe places.\n* Get your Mission File signed by your parent/guardian.\n\n## Notes\n\n&nbsp;\n"

/***/ }),
/* 1554 */
/***/ (function(module, exports) {

	module.exports = "# Mission Assignment\n\nTitle: Get a Kit\n\n## Notes\n&nbsp;\n\n# Mission Intro Video\n\nYouTube: AsQU_9j_eyo\n\n## Notes\n\nIan and Sara introduce Mission 2 - Get a Kit (1:43).\n\n### Make a Plan\n* Apprentices turn to Mission 2 in their Mission Files.\n* Decide which day you will do the next Level.\n* Apprentices write that date on the cover of their Mission Files and on the Mission 2 page.\n* Points are awarded for signed and returned Mission 2 page.\n\n# Instructions\n\n## Content\n\n### Mission 2:\n\n#### Get a kit\n* Get your family to make a kit!\n* One point for each item in your kit.\n* Do the puzzle to get bonus points.\n* Get your Mission File signed by your parent/guardian.\n\n## Notes\n\n&nbsp;\n"

/***/ }),
/* 1555 */
/***/ (function(module, exports) {

	module.exports = "# Mission Assignment\n\nTitle: Keep Building Your Kit\n\n## Notes\n&nbsp;\n\n# Mission Intro Video\n\nYouTube: 86B6X8UUbkg\n\n## Notes\n\nIan and Sara introduce Mission 3 - We're In This Together (2:47).\n\n### Make a Plan\n* Apprentices turn to Mission 3 in their Mission Files.\n* Decide which day you will do the next Level.\n* Apprentices write that date on the cover of their Mission Files and on the Mission 3 page.\n* Points are awarded for signed and returned Mission 3 page.\n\n# Instructions\n\n## Content\n\n### Mission 3:\n\n#### Keep getting more prepared!\n* Keep building your kit!\n* Talk with friends and family about emergency preparedness.\n* Keep practising your Superhero Calming Breath!\n\n## Notes\n\n&nbsp;\n"

/***/ }),
/* 1556 */
/***/ (function(module, exports) {

	module.exports = "Finish\n\n# Outtakes 1\n\nYouTube: m0Zkh5kx3sQ\n\n## Notes\n\nOuttakes fun with Ian & Sara (1:16).\n\n# Outtakes 2\n\nYouTube: xj0mgAqAyqw\n\n## Notes\n\nMore outtakes fun with Ian & Sara (0:48).\n\n# Scoreboard Recap\n\n## Content\n\n### Check out the scoreboard to see who's in the lead!\n\n## Notes\n\n&nbsp;\n\n# Earn More Points\n\n## Content\n\n### Everyone has a chance to earn more points!\n* Take home your Mission Files.\n* Do your missions and record what you did.\n* Listen & participate in class!\n\n## Notes\n\n&nbsp;\n\n# Farewell\n\n## Content\n\n### Keep the fun going!\n\n#### Visit *AndGoober.com* for games and activities\n\nGo to the next slide to finish the level\n\n## Notes\nTo finish, go to the next slide and click 'Click to end level'.\n"

/***/ }),
/* 1557 */
/***/ (function(module, exports) {

	module.exports = "Ending\n\n# Announce Winners\n\n## Content\n\n### Time to announce the winners!\n\n#### Teachers please hand out certificates.\n\n## Notes\n\nPrint winning team certificates once you know who won; give all team members completion certificates now.\n\n# Members EPS\n\n## Content\n\n### You are all now members of the Emergency Preparedness Squad!\n\n#### Congratulations!\n\n## Notes\n\nThank you for training your Apprentices!\n\n# All Levels Completed\n\n## Notes\n\n&nbsp;\n\n### Getting your feedback\n\nWe love to hear from teachers about their experience with the Academy. We'll be in touch in the next few days with a feedback survey!\n\nHave ideas for extension activities? Please share them with us!\n"

/***/ }),
/* 1558 */
/***/ (function(module, exports) {

	module.exports = "# Extension Activities\n\n#### Emergency Preparedness Squad song\n* Perform during Emergency Preparedness Week or at another assembly for your school.\n* We’d love to hear about it or see a video!!\n* For even more fun, Apprentices can create their own choreography.\n\n#### PreparedBC's Master of Disaster teaching resource\n* The Province of BC has developed a curriculum-linked resource for Grade 6 classrooms. [Check it out](http://www2.gov.bc.ca/gov/content/safety/emergency-preparedness-response-recovery/preparedbc/master-of-disaster)!\n* Not a Grade 6 teacher? Check out their [extensive multimedia resource library](https://www2.gov.bc.ca/gov/content/safety/emergency-preparedness-response-recovery/preparedbc/master-of-disaster/master-of-disaster-multimedia-resources) for more educational resources on emergency preparedness!\n\n#### Other Emergency Preparedness resources\n* [Disaster Hero](http://www.disasterhero.com/) online video game where players compete to become the next Disaster Hero!\n* [Ready.gov](https://www.ready.gov/kids) is the US government's hub for emergency preparedness info includes a special kids section with PDF resources and online games.\n* [American Public Health Association](http://www.getreadyforflu.org/kids/)'s resources include puzzles and brain teasers with an emergency preparedness theme.\n"

/***/ }),
/* 1559 */
/***/ (function(module, exports) {

	module.exports = "# Emergency Preparedness Squad Theme Song\n\nYouTube: _0TUIVDHqSE\n\n## Description\n\nSing and dance along to the Emergency Preparedness Squad's theme song anytime you like. Great for starting a lesson!\n\n\n# Esmeralda Planet Protector & The E-Waste Emergency\n\nYouTube: POzKQKxvuzQ\nLowRes: true\n\n## Description\n\nWatch Esmeralda and Goober fight the rise of electronic waste and the evil supervillain Blaster, with some help from our our Planet Protector friends!\n\n\n# Esmeralda Planet Protector & The Litterless Lunch\n\nYouTube: OeT53lGAYX4\nLowRes: true\n\n## Description\n\nEsmeralda and Goober take on Trashella to stop her from convincing kid to bring lunches that make litter!\n\n\n# Esmeralda Planet Protector & Walking To School\n\nYouTube: 1FmXmBOU-V8\nLowRes: true\n\n## Description\n\nCan Esmeralda Superspy Planet Protector and her sidekick Goober stop the Evil Dr. Carbon's dastardly plan to stop kids from walking to school?\n\n\n# Esmeralda Superspy: Backstage #1\n\nYouTube: BQyzd8Y7EaY\nLowRes: true\n\n## Description\n\nDo series stars Ian and Sara spend their time saving the environment and protecting the planet? No, because Ian keeps acting like a monkey! Even when the boss, Jacqueline, is around.\n\n\n# Esmeralda Superspy: Backstage #2\n\nYouTube: AEmVWqAie6s\nLowRes: true\n\n## Description\n\nTake a peak behind the scenes! Sara takes you on a tour of the set - or at least, she tries to. Ian keeps messing up her shots!\n\n\n# Esmeralda Superspy: Backstage #3\n\nYouTube: zZId4Rr2-Rw\nLowRes: true\n\n## Description\n\nIan thinks he's doing a safety speech for the funny environmental show \"Esmeralda Superspy\" but really, Sara is about to get her revenge on him for wrecking her scenes.\n\n\n# Good Green News: Vancouver Urban Gardens\n\nYouTube: dPD3BogYAKw\nLowRes: true\n\n## Description\n\nKid reporter Tia, 9, reports on the Good Green News in the city of Vancouver - Find out why Vancouver helped bring over 400 urban gardens to the city!\n"

/***/ }),
/* 1560 */
/***/ (function(module, exports) {

	module.exports = "# Level Completed\n\n## Content\n\n### Welcome back!\n* Click the MENU button (top left) and use MODULES to go back to any of the three modules.\n* Or check out the videos in the EXTRAS section!\n\n## Notes\n\nWelcome back!\n"

/***/ }),
/* 1561 */
/***/ (function(module, exports) {

	module.exports = "# Teacher Resources\n## Welcome!\nWe're so happy to be training emergency preparedness superheroes from {r/:$cityOrMunicipality}!\n\n#### Know the Risks assembly presentation\nThese classroom-based learning modules for the Emergency Preparedness Squad program are designed to follow on from the assembly *Know the Risks* presentation by our actors. If you've yet to receive the presentation, feel free to familiarize yourself with the classroom modules!\n\n#### {r/Canada} Teacher's Guide\n{r/Canada} Download the [Teacher's Guide](Teachers_Guide.pdf) for a full overview of the program's contents and how it works.\n\n#### Curriculum Links\nThe Emergency Preparedness Squad supports curriculum standards in science, arts, language and social studies. The following connections are provided for your convenience:\n\n* {r/Canada/BC}[BC Grades K-2](CL_PPA-EPS-Hybrid_Canada_BC_Grades_K-2.pdf)\n* {r/} We don't have curriculum links for your area yet. Do you want to help us develop them? Please contact us!\n\n#### Need help from a human?\nGet in touch through the Messenger in the bottom right-hand corner!\n\n# Printables\n\n#### Required Print Materials\n\n* Mission Files for each child in [{r/Canada:colour}{r/:color}](Printables_Mission_Files_Colour.pdf) or [black & white](Printables_Mission_Files_BW.pdf).\n* Completion certificates for each child in [{r/Canada:colour}{r/:color}](Printables_Completion_Certificates_Colour.pdf) or [black & white](Printables_Completion_Certificates_BW.pdf).\n\n#### Optional Print Materials\n* Winning team certificates in [{r/Canada:colour}{r/:color}](Printables_Winning_Certificates_Colour.pdf) or [black & white](Printables_Winning_Certificates_BW.pdf).\n"

/***/ }),
/* 1562 */
/***/ (function(module, exports) {

	module.exports = "# Module 1 Overview\r\n\r\n#### MAKE A PLAN at a glance\r\n##### Typical duration: 1 hour\r\n* Watch engaging videos.\r\n* Sing the Emergency Preparedness Squad Theme Song.\r\n* Report on their Know the Risks at-home mission.\r\n* Play a game show on the importance of making a family emergency preparedness plan.\r\n* Draw a floor plan of your home and identify emergency exits.\r\n* Be assigned their first mission, Mission 1: Make a Plan.\r\n\r\n#### Getting into teams\r\n* Before starting the program, divide your class into four teams - Earth, Air, Fire and Water (we recommend you set up the teams ahead of time and that they remain the same for the duration of the program).\r\n* Each team will work together during the various arts-based activities and score points for participating, collaborating, listening etc.\r\n* It's a flexible system for you to reward the {r/Canada:behaviour}{r/:behavior} you want to see in your class!\r\n\r\n#### Key Vocabulary\r\n* Planning\r\n* Emergency Plan\r\n* Safety and wellbeing\r\n* Emergency exits\r\n\r\n# Materials\r\n\r\n#### What you need for this level\r\n* Mission Files for each student in [{r/Canada:colour}{r/:color}](Printables_Mission_Files_Colour.pdf) or [black & white](Printables_Mission_Files_BW.pdf).\r\n"

/***/ }),
/* 1563 */
/***/ (function(module, exports) {

	module.exports = "# Module 2 Overview\n\n#### GET A KIT at a glance\n##### Typical duration: 1 hour\nIn this level, Apprentices will:\n* Sing the Emergency Preparedness Squad Theme Song.\n* Report on their Make a Plan at-home mission.\n* Play a game show which engages them on the importance of making an emergency preparedness kit.\n* Write and perform, in teams, a rap about making an emergency preparedness kit.\n* Be assigned their next mission, Mission 2: Get a Kit.\n\n#### Key Vocabulary\n* Emergency Preparedness Kit\n\n# Materials\n\n#### What you need for this level\n* Each Apprentice also requires their Mission File 2 printed if you haven’t done so.\n"

/***/ }),
/* 1564 */
/***/ (function(module, exports) {

	module.exports = "# Module 3 Overview\n\n#### WE'RE IN THIS TOGETHER at a glance\n##### Typical duration: 1 hour\nIn this level, Apprentices will:\n* Sing the Emergency Preparedness Squad Theme Song.\n* Report back on their Get a Kit at-home mission.\n* Play a game show which engages them on being good community members during an emergency.\n* Receive individual participation and winning team certificates.\n* Celebrate their achievements during the program!\n\n#### Key Vocabulary\n* Community\n\n# Materials\n\n#### What you need for this level\n* Mission Files\n* Completion certificates for each Apprentice in [{r/Canada:colour}{r/:color}](Printables_Completion_Certificates_Colour.pdf) or [black & white](Printables_Completion_Certificates_BW.pdf).\n* Once you know which team has earned the most points, you can print a Winning Team Certificate in [{r/Canada:colour}{r/:color}](Printables_Winning_Certificates_Colour.pdf) or [black & white](Printables_Winning_Certificates_BW.pdf) to post on your classroom wall after the lesson.\n"

/***/ }),
/* 1565 */
/***/ (function(module, exports) {

	module.exports = "# Tech Prep Wizard\n\n### Tech Prep Wizard\n\nThis short wizard will help you get set up to run the Academy in your classroom.\n\nDon't show your students the screen yet!\n\nClick the arrow or use your keyboard's right directional arrow to move through the wizard.\n\n# Two Device Intro\n\n### Two Device Experience\nThe Academy is best experienced using two devices:\n* Main device (COMPUTER or TABLET) projects the website at the front of the class.\n* Second device (TABLET or CELLPHONE) can be as a remote control (optional):\n  * gives you freedom to move around the classroom.\n  * contains prompts and facilitation notes at your finger tips.\n  * provides useful progress indicators, such as length of videos and number of slides remaining.\n\n# Connecting Remote\n\n### Connect your remote!\nTo connect a second device as a Remote Control:\n1. Go to www.remote4ppa.com on your tablet/phone.\n2. Enter your username and password on your tablet/phone.\n3. Go to the next slide to Select Role For This Device.\n4. Choose the right Role for each device.\n5. Your selections will be saved for future use, but you can always change it later!\n\n# Tech Check Intro\n\n### Tech Check!\nNOW PLEASE hook up your main device to your projector and **test the audio/video** to make sure everything's working! There's a fun video in the next slide to help you do this (it's also in the Fun section if you want to share with your class).\n\n#### Full Screen Experience\nThe Planet Protector Academy is best enjoyed as a full screen experience. **Click 'View'** in your browser's menu bar, and select **'Full Screen'** (Chrome) or **'Enter Full Screen'** (Safari/Firefox).\n\n# Tech Check Video\nYouTube: ZVdMndkjaIo\n"

/***/ }),
/* 1566 */
/***/ (function(module, exports) {

	module.exports = "# Program Start\n\n# Level 1 Start\n\n## Notes\n\n### Start\n\nShow this screen at the start of class. When the kids are ready, advance to the next screen.\n\nUse the directional arrows on your remote to go forwards/backwards through the level.\n\n# Level 1 Icon\n\n## Notes\n\nMake a Plan\n\n### Tracking your progress\n\nYou can see how far along you are by the slide number on the top of your Remote Control or by the blue progress bar running along the bottom of the Menu on the Classroom Display.\n\n# Level 1 Intro\n\nYouTube: NOpMBKA5T4Q\n\n## Notes\n\nSara and Ian welcome the students back to the Emergency Preparedness Squad program (0:36).\n\n### Problems with your video buffering?\nPause the video and wait a minute for it to pre-load, then it should play without a hitch!\n\n# Level 2 Start\n\n## Notes\n\n### Start\n\nShow this screen at the start of class. When the kids are ready, advance to the next screen.\n\n# Level 2 Icon\n\n## Notes\n\nGet a Kit\n\n# Level 2 Intro\n\nYouTube: O4Qx3wGyCWA\n\n## Notes\n\nSara and Ian welcome the students back to the program (0:15).\n\n# Level 3 Start\n\n## Notes\n\n### Start\n\nShow this screen at the start of class. When the kids are ready, advance to the next screen.\n\n# Level 3 Icon\n\n## Notes\n\nWe're In This Together\n"

/***/ }),
/* 1567 */
/***/ (function(module, exports) {

	module.exports = "# Song\nYouTube: fB3ZHt6aYJ8\n\n## Notes\n\n### Emergency Preparedness Squad Song\n\nEncourage your class to learn this song and sing along to the video (2:21).\n\n### Extension Activities\nApprentices can perform the song to the whole school and/or create their own choreography.\n"

/***/ }),
/* 1568 */
/***/ (function(module, exports) {

	module.exports = "Team Creation\n\n# Intro Team Names\n\nYouTube: 2Nspklyhmtg\n\n## Notes\nSara and Ian introduce the level and tell Apprentices to get into teams (1:51).\n\n# Get Into Teams\n\n## Content\n\n###### Get into four teams!\n\nName your teams in the next slide.\n\n## Notes\n\nName teams in the next slide. Once you enter the name in the text field, it automatically saves!\n\n# Scoring Intro\n\n## Content\n\n### Here's how your team can score points\n\n* Answer questions\n* Do activities\n* Complete missions\n* Work well together (teamwork points)\n* and more!\n\n## Notes\n\n### Scoring\n* Teams can earn points for most activities in the program. You can allocate points as you see fit. Maximum points total is 999.\n* Individuals can earn points for teams, or teams can earn points together.\n* Teamwork points are critical to ensure collaboration.\n* Points can also be a classroom \"currency\", e.g.to gain classroom privileges.\n* The team with the most points at the end of Level 3 is the winner.\n\n# Scoreboard Intro\n\n## Content\n\n### Check out the scoreboard!\n\n(In the top left corner, click MENU and then SCORES)\n\nYour teams are now ready to start scoring points!\n\n## Notes\n\nClick on the 'Scoreboard' icon on your remote at any time to bring down the scoreboard and add points for teams.\n\n# Congratulations\n\n## Content\n\n### Congratulations!\n\n#### You're now Apprentices in the Emergency Preparedness Squad!\n\n## Notes\n\n&nbsp;\n"

/***/ }),
/* 1569 */
/***/ (function(module, exports) {

	module.exports = "# Esmeralda and Goober Story\n\nYouTube: i6c_oeWPDxg\n\n## Notes\nEsmeralda and Goober storyline - Make a Plan (1:47).\n\n# Calming Breath Intro\n\nYouTube: bDy55oVYj00\n\n## Notes\nSara and Ian help Apprentices practice the Superhero Calming Breath (0:49).\n"

/***/ }),
/* 1570 */
/***/ (function(module, exports) {

	module.exports = "# Sharknado\nYouTube: _JRlG-5_7ic\n\n## Notes\n\nSara and Ian share what should go in your Apprentices' emergency kits (4:16).\n\n# Calming Breath Recap\nYouTube: nUGO4-S_I5w\n\n## Notes\n\nPractice the Superhero Calming Breath! (0:36).\n\n# Esmeralda and Goober Story\n\nYouTube: 5FvPTip5iI4\n\n## Notes\nEsmeralda and Goober storyline - Get a Kit (2:37).\n"

/***/ }),
/* 1571 */
/***/ (function(module, exports) {

	module.exports = "# Esmeralda and Goober Story\n\nYouTube: Ka3bcyUj6TU\n\n## Notes\nEsmeralda and Goober storyline wrap-up (2:19).\n"

/***/ }),
/* 1572 */
/***/ (function(module, exports) {

	module.exports = "# Mission Report\nTitle: Know the Risks\n\n# Scoring\n\n## Content\n\n### Count your mission points!\n\n* Your mission at the end of the 'Know the Risks' assembly was to talk to your family about preparing for an emergency.\n* Teams get one point for each team member that talked with their families.\n* Make sure your points get added onto the Scoreboard!\n\n## Notes\n\n&nbsp;\n\n# Instructions\n\n## Content\n\n### Time to report to HQ!\n\n* Answer with a show of hands.\n* Teachers can report too!\n\n## Notes\n\n### Mission Reports\n* Mission reports help us communicate the impact of our program. Thanks for helping us to measure it!\n* Using a show of hands keeps the data anonymous.\n\n# Questions\n\n## Content\n\n1. Number of Apprentices and Teachers reporting in.\n2. I talked with my family about the Top Ten Emergencies.\n3. I've used the Superhero Calming Breath to help me feel calm.\n4. How many Apprentices are having fun with this program?\n\n# Impact\n\n## Content\n\n### Awesome work, Apprentices!\n\nYour Mission Report was received by Emergency Preparedness Squad HQ.\n\n## Notes\n\nGreat job!\n\n# Class Discussion\n\n## Content\n\n### Class Discussion\n* As a class, discuss what was easy or hard about this mission.\n* What worked, what didn’t work?\n* What would make it easier?\n\n## Notes\n\nEncourage Apprentices who did not succeed to keep trying, if appropriate.\n"

/***/ }),
/* 1573 */
/***/ (function(module, exports) {

	module.exports = "# Mission Report\nTitle: Make a Plan\n\n# Scoring\n\n## Content\n\n### Get points for your missions!\n\n* Turn to Level 1 - Make a Plan in your Mission Files.\n* In your teams, count the total number of points you scored.\n* Make sure your points get added onto the Scoreboard!\n\n## Notes\n\nThis slide only covers actions listed under 'Get a point for' for each mission.\nStudents report the Mission Report section next.\n\n# Instructions\n\n## Content\n\n### Time to report to HQ!\n\n* Answer with a show of hands.\n* Teachers can report too!\n\n## Notes\n\n### Mission Reports\n* Mission reports help us communicate the impact of our program. Thanks for helping us to measure it!\n* Using a show of hands keeps the data anonymous.\n\n# Questions\n\n## Content\n\n1. Number of Apprentices and Teachers reporting in.\n2. +My family filled out an emergency plan.\n3. +My family started filling out a plan but didn't finish.\n4. +My family hasn't made an emergency plan YET, but we pledge to soon.\n5. +My family didn't make an emergency plan and aren't likely to.\n6. How many Apprentices feel like real-life Emergency Preparedness Squad superheroes now?\n\n# Impact\n\n## Content\n\n### Awesome work, Apprentices!\n\nYour Mission Report was received by Emergency Preparedness Squad HQ.\n\n## Notes\n\nGreat job!\n\n# Class Discussion\n\n## Content\n\n### Class Discussion\n* As a class, discuss what was easy or hard about this mission.\n* What worked, what didn’t work?\n* What would make it easier?\n\n## Notes\n\nEncourage Apprentices who did not succeed to keep trying, if appropriate.\n"

/***/ }),
/* 1574 */
/***/ (function(module, exports) {

	module.exports = "# Mission Report\nTitle: Get a Kit\n\n# Intro Video\nYouTube: oQiZTpCPDM4\n\n## Notes\n\nSara and Ian introduce the mission report for Get a Kit (3:04).\n\n# Scoring\n\n## Content\n\n### Get points for your missions!\n\n* Turn to Level 2 - Get a Kit in your Mission Files.\n* In your teams, count the total number of points you scored.\n* Make sure your points get added onto the Scoreboard!\n\n## Notes\n\nThis slide only covers actions listed under 'Get a point for' for each mission.\nStudents report the Mission Report section next.\n\n# Instructions\n\n## Content\n\n### Time to report to HQ!\n\n* Answer with a show of hands.\n* Teachers can report too!\n\n## Notes\n\n### Mission Reports\n* Mission reports help us communicate the impact of our program. Thanks for helping us to measure it!\n* Using a show of hands keeps the data anonymous.\n\n# Questions\n\n## Content\n\n1. Number of Apprentices and Teachers reporting in.\n2. +My family started putting together our kit.\n3. +My family hasn't started our kit YET but we pledge to do it soon.\n4. +My family didn't make an emergency kit and aren't likely to.\n5. How many Apprentices pledge to be Emergency Preparedness Squad superheroes from now on?\n6. My family succeeded in at least one mission during the program.\n\n# Impact\n\n## Content\n\n### Awesome work, Apprentices!\n\nYour Mission Report was received by Emergency Preparedness Squad HQ.\n\n## Notes\n\nGreat job!\n\n# Class Discussion\n\n## Content\n\n### Class Discussion\n* As a class, discuss what was easy or hard about this mission.\n* What worked, what didn’t work?\n* What would make it easier?\n\n## Notes\n\nEncourage apprentices who did not succeed to keep trying, if appropriate.\n"

/***/ }),
/* 1575 */
/***/ (function(module, exports) {

	module.exports = "Level 1 - Make a Plan\n\n# Intro Video\n\nYouTube: 6a5nxfJ3UB8\n\n## Notes\n\nSara and Ian introduce the Game Show (2:38).\n\n# Sizzle\n\n## Notes\n\n### Game Show\nIn the Game Show we ask questions relating to the topic *before* giving the answers, in order to stimulate thinking, rather than to test knowledge.\n\nOne Apprentice from each team will come up to the front of the class and get a chance to answer the question in turn.\n\nFor more info, see \"Game Show Info\" in the Teachers Guide, which is available in the Teacher Resources section on the Dashboard page.\n\n# Scoring\n\n## Content\n\n### How to score points\n* Do your Superhero pose.\n* Buzz in first.\n* Give a good answer. Try your best!\n* If you don’t know the answer, think about what a good answer might be. This is not a test!\n\n## Notes\n\nDon't forget to score points on the Scoreboard!\n\n# Four Players Announcement\n\n## Notes\n\n* One Apprentice from each team comes to the front of the room.\n* Encourage a different Apprentice to come up for each question.\n\n# Question 1\n\n## Question\n\n#### Name some things you could plan e.g. a party\n\n## Answer\n\n### Some things you could plan:\n* Party\n* Trip\n* Class\n* Making a video\n* How you'll study for a test\n* A neighbourhood hockey game\n\n## Answer Notes\n\n&nbsp;\n\n# Scoring Reminder\n\n## Content\n\n### Don't forget to add scores!\n\n## Notes\n\nClick on the 'Scores' button below to open up the Scoreboard.\n\n# Question 2\n\n## Question\n\n#### What do you think is the goal of an emergency plan? Why do we need one?\n\n## Answer\n\n### Goal is safety and well-being:\n* So we think about what we’ll need to do ahead of time.\n* So we’ll feel more prepared and safe.\n* So we have all our information together.\n* So we know what to do.\n\n## Answer Notes\n\n&nbsp;\n\n# Question 3\n\n## Question\n\n#### Team brainstorm - What are some things that should be included in an emergency plan?\n\n## Answer\n\n### Some things that should be in an emergency plan:\n* Where to meet your family.\n* How to contact your family.\n* What to do if you're in different places (work/home/play).\n* Plan for your pets.\n* Special needs concerns.\n* Emergency contact info.\n\n## Answer Notes\n\n&nbsp;\n"

/***/ }),
/* 1576 */
/***/ (function(module, exports) {

	module.exports = "Level 2 - Get a Kit\n\n# Intro Video\n\nYouTube: OpmtyG62cn4\n\n## Notes\n\nSara and Ian introduce the Game Show (0:29).\n\n# Sizzle\n\n## Notes\n\nGame Show\n\n# Scoring\n\n## Content\n\n### Reminder:\n* Do your Superhero pose.\n* Buzz in first.\n* Give a good answer.\n\n## Notes\n\nDon't forget to score points on the Scoreboard!\n\n# Four Players Announcement\n\n## Notes\n\nFour players to the front.\n\n# Question 1\n\n## Question\n\n#### What do you think an emergency prep kit is for?\n\n## Answer\n\n### An emergency preparedness kit is so you can:\n* Have something to eat\n* Have water to drink\n* Stay safe and warm\n* Get important news\n\n## Answer Notes\n\n&nbsp;\n\n# Scoring Reminder\n\n## Content\n\n### Don't forget to add scores!\n\n## Notes\n\nClick on the 'Scores' button below to open up the Scoreboard.\n\n# Question 2\n\n## Question\n\n#### Name a good place to keep your emergency kit in your home.\n\n## Answer\n\n### Some places to keep your kit:\n* Near the door\n* In a bag you can grab and go\n* Make sure everyone in your family knows where it's stored!\n\n## Answer Notes\n\n&nbsp;\n\n# Question 3\n\n## Question\n\n#### Team brainstorm - write down as many things as you can that should probably go in your kit.\nScoring: If you got ten or items or more, get ten points. No peeking in your Mission Files!\n\n## Answer\n\n### Things you can put in your kit:\n* Food\n* Water (nonperishable)\n* Flashlight\n* Medication + glasses\n* Extra clothes\n* Picture / letter from parents\n* Copy of plan, incl contact info and safe meeting place\n\n## Answer Notes\n\n&nbsp;\n"

/***/ }),
/* 1577 */
/***/ (function(module, exports) {

	module.exports = "Level 3 - We're In This Together\n\n# Intro Video\n\nYouTube: mXdAKK3NAmE\n\n## Notes\n\nSara and Ian introduce the Game Show (0:47).\n\n# Sizzle\n\n## Notes\n\nGame Show\n\n# Four Players Announcement\n\n## Notes\n\nFour players to the front.\n\n# Question 1\n\n## Question\n\n#### Who are the people most likely to help you in an emergency?\n\n## Answer\n\n### Some people who are likely to help you:\n* Your friends\n* Your family\n* Teachers\n* Neighbours\n\n## Answer Notes\n\n&nbsp;\n\n# Question 2\n\n## Question\n\n#### Why aren't the police and fire fighters the ones likely to help?\n\n## Answer\n\n#### They will be busy saving lives, where they can do the most good.\n\n## Answer Notes\n\n&nbsp;\n\n# Question 3\n\n## Question Intro\n\n#### When should you call 911?\nMultiple choice - see next slide!\n\n## Question\n(a) to ask if an earthquake just happened\n\n(b) to tell them an earthquake just happened\n\n(c) if someone's life is in danger\n\n(d) if a gas main broke\n\n## Answer\n\n#### The answer is: (c) + (d)\nDon't call 911 unless someone's life is in danger.\n\n## Answer Notes\n\n&nbsp;\n"

/***/ }),
/* 1578 */
/***/ (function(module, exports) {

	module.exports = "Group Drawing\n\n# Intro Video\n\nYouTube: B779gOrzCuk\n\n## Notes\n\nSara and Ian introduce the importance of being prepared for the first 72hrs. They also introduce the first part of making an emergency plan (1:18).\n\n# Sizzle\n\n## Content\n\n### Activity 1: Drawing!\n\n## Notes\nActivity instructions on next slide.\n\n# Instructions\n\n## Content\n\n### Activity Instructions:\n* Draw a floorplan of one room in your home.\n* Plan emergency exits from one room of your home.\n  * Try to think of two possibilities.\n  * If you live in an apartment, do not plan to use the elevators.\n* Two points for the drawing.\n* One point for getting your parent/guardian to sign the natural gas safety info in your Mission Files!\n\n## Notes\n\n&nbsp;\n"

/***/ }),
/* 1579 */
/***/ (function(module, exports) {

	module.exports = "# Intro Video\n\nYouTube: anIbh_g5Tu4\n\n## Notes\nIntro to rap activity (1:20).\n\n# Sizzle\n\n## Content\n\n### Activity 1: Write a rap!\n\n(Younger grades can write a poem instead)\n\n## Notes\n\nActivity instructions on next slide.\n\n# Instructions\n\n## Content\n\n### Activity Instructions:\n* Write a rap about things you’ll need in your kit - at least two items.\n* Write two lines, where the last word in each line rhymes.\n* Your Mission Files has sample rhymes, but get bonus points for using words that aren't in the booklet.\n* If you're writing a rap, {r/Canada:practise}{r/:practice} in your teams with the backing track on the next slide.\n\n## Notes\n\nThere is a worksheet in the Mission File for this activity.\n\n# Rap Backtrack Practice\n\nYouTube: eEzxxHgcpzE\n\n## Notes\n\nTo get the backtrack (10:07) to repeat, just press play again.\n\n# Scoring\n\n## Content\n\n### Now perform for the class!\n\n#### Get points for:\n* Two lines that rhyme.\n* Good performance.\n* Beatboxing (if you're rapping).\n* Being a good audience.\n\n## Notes\n\n### Extension Activity\nVideo your raps and submit them to our website!\n\n# Rap Backtrack Perform\nYouTube: eEzxxHgcpzE\n\n## Notes\n\nTo get the backtrack to repeat, just press play again.\n"

/***/ }),
/* 1580 */
/***/ (function(module, exports) {

	module.exports = "# Intro Video  \n\nYouTube: 0MKIR2myq7U\n\n## Notes\nSara and Ian introduce the Drawing activity (1:21).\n\n# Sizzle\n\n## Content\n\n### Activity 1: Drawing!\n\n## Notes\n\n&nbsp;\n\n# Instructions\n\n## Content\n\n### Activity Instructions:\n* Draw a picture of the people you might be with in an emergency.\n* Points for trying your best!\n\n## Notes\n\n&nbsp;\n"

/***/ }),
/* 1581 */
/***/ (function(module, exports) {

	module.exports = "# Mission Assignment\n\nTitle: Make a Plan\n\n## Notes\n&nbsp;\n\n# Mission Intro Video\n\nYouTube: F8mHgZSKa1s\n\n## Notes\n\nIan and Sara introduce Mission 1 - Make a Plan (2:01).\n\n### Make a Plan\n* Apprentices turn to Mission 1 in their Mission Files.\n* Decide which day you will do the next Level.\n* Apprentices write that date on the cover of their Mission Files and on the Mission 1 page.\n* Points are awarded for signed and returned Mission 1 page.\n\n# Instructions\n\n## Content\n\n### Mission 1:\n\n#### Making a plan\n* Get your family to make a plan!\n* With the adults in your family, fill out the plan in your Mission Files.\n* Make copies of the plan and store it in safe places.\n* Get your Mission File signed by your parent/guardian.\n\n## Notes\n\n&nbsp;\n"

/***/ }),
/* 1582 */
/***/ (function(module, exports) {

	module.exports = "# Mission Assignment\n\nTitle: Get a Kit\n\n## Notes\n&nbsp;\n\n# Mission Intro Video\n\nYouTube: AsQU_9j_eyo\n\n## Notes\n\nIan and Sara introduce Mission 2 - Get a Kit (1:43).\n\n### Make a Plan\n* Apprentices turn to Mission 2 in their Mission Files.\n* Decide which day you will do the next Level.\n* Apprentices write that date on the cover of their Mission Files and on the Mission 2 page.\n* Points are awarded for signed and returned Mission 2 page.\n\n# Instructions\n\n## Content\n\n### Mission 2:\n\n#### Get a kit\n* Get your family to make a kit!\n* One point for each item in your kit.\n* Do the puzzle to get bonus points.\n* Get your Mission File signed by your parent/guardian.\n\n## Notes\n\n&nbsp;\n"

/***/ }),
/* 1583 */
/***/ (function(module, exports) {

	module.exports = "# Mission Assignment\n\nTitle: Keep Building Your Kit\n\n## Notes\n&nbsp;\n\n# Mission Intro Video\n\nYouTube: 86B6X8UUbkg\n\n## Notes\n\nIan and Sara introduce Mission 3 - We're In This Together (2:47).\n\n# Instructions\n\n## Content\n\n### Mission 3:\n\n#### Keep getting more prepared!\n* Keep building your kit!\n* Talk with friends and family about emergency preparedness.\n* Keep practising your Superhero Calming Breath!\n\n## Notes\n\n&nbsp;\n"

/***/ }),
/* 1584 */
/***/ (function(module, exports) {

	module.exports = "Finish\n\n# Outtakes 1\n\nYouTube: m0Zkh5kx3sQ\n\n## Notes\n\nOuttakes fun with Ian & Sara (1:16).\n\n# Outtakes 2\n\nYouTube: xj0mgAqAyqw\n\n## Notes\n\nMore outtakes fun with Ian & Sara (0:48).\n\n# Scoreboard Recap\n\n## Content\n\n### Check out the scoreboard to see who's in the lead!\n\n## Notes\n\n&nbsp;\n\n# Earn More Points\n\n## Content\n\n### Everyone has a chance to earn more points!\n* Take home your Mission Files.\n* Do your missions and record what you did.\n* Listen & participate in class!\n\n## Notes\n\n&nbsp;\n\n# Farewell\n\n## Content\n\n### Keep the fun going!\n\n#### Visit *AndGoober.com* for games and activities\n\nGo to the next slide to finish the level\n\n## Notes\nTo finish, go to the next slide and click 'Click to end level'.\n"

/***/ }),
/* 1585 */
/***/ (function(module, exports) {

	module.exports = "Ending\n\n# Announce Winners\n\n## Content\n\n### Time to announce the winners!\n\n#### Teachers please hand out certificates.\n\n## Notes\n\nPrint winning team certificates once you know who won; give all team members completion certificates now.\n\n# Members EPS\n\n## Content\n\n### You are all now members of the Emergency Preparedness Squad!\n\n#### Congratulations!\n\n## Notes\n\nThank you for training your Apprentices!\n\n# All Levels Completed\n\n## Notes\n\n&nbsp;\n\n### Getting your feedback\n\nWe love to hear from teachers about their experience with the Academy. We'll be in touch in the next few days with a feedback survey!\n\nHave ideas for extension activities? Please share them with us!\n"

/***/ }),
/* 1586 */
/***/ (function(module, exports) {

	module.exports = "# Extension Activities\n\n#### Emergency Preparedness Squad song\n* Perform during Emergency Preparedness Week or at another assembly for your school.\n* We’d love to hear about it or see a video!!\n* For even more fun, Apprentices can create their own choreography.\n\n#### PreparedBC's Master of Disaster teaching resource\n* The Province of BC has developed a curriculum-linked resource for Grade 6 classrooms. [Check it out](http://www2.gov.bc.ca/gov/content/safety/emergency-preparedness-response-recovery/preparedbc/master-of-disaster)!\n* Not a Grade 6 teacher? Check out their [extensive multimedia resource library](https://www2.gov.bc.ca/gov/content/safety/emergency-preparedness-response-recovery/preparedbc/master-of-disaster/master-of-disaster-multimedia-resources) for more educational resources on emergency preparedness!\n\n#### Other Emergency Preparedness resources\n* [Disaster Hero](http://www.disasterhero.com/) online video game where players compete to become the next Disaster Hero!\n* [Ready.gov](https://www.ready.gov/kids) is the US government's hub for emergency preparedness info includes a special kids section with PDF resources and online games.\n* [American Public Health Association](http://www.getreadyforflu.org/kids/)'s resources include puzzles and brain teasers with an emergency preparedness theme.\n"

/***/ }),
/* 1587 */
/***/ (function(module, exports) {

	module.exports = "# Emergency Preparedness Squad Theme Song\n\nYouTube: _0TUIVDHqSE\n\n## Description\n\nSing and dance along to the Emergency Preparedness Squad's theme song anytime you like. Great for starting a lesson!\n\n\n# Esmeralda Planet Protector & The E-Waste Emergency\n\nYouTube: POzKQKxvuzQ\nLowRes: true\n\n## Description\n\nWatch Esmeralda and Goober fight the rise of electronic waste and the evil supervillain Blaster, with some help from our our Planet Protector friends!\n\n\n# Esmeralda Planet Protector & The Litterless Lunch\n\nYouTube: OeT53lGAYX4\nLowRes: true\n\n## Description\n\nEsmeralda and Goober take on Trashella to stop her from convincing kid to bring lunches that make litter!\n\n\n# Esmeralda Planet Protector & Walking To School\n\nYouTube: 1FmXmBOU-V8\nLowRes: true\n\n## Description\n\nCan Esmeralda Superspy Planet Protector and her sidekick Goober stop the Evil Dr. Carbon's dastardly plan to stop kids from walking to school?\n\n\n# Esmeralda Superspy: Backstage #1\n\nYouTube: BQyzd8Y7EaY\nLowRes: true\n\n## Description\n\nDo series stars Ian and Sara spend their time saving the environment and protecting the planet? No, because Ian keeps acting like a monkey! Even when the boss, Jacqueline, is around.\n\n\n# Esmeralda Superspy: Backstage #2\n\nYouTube: AEmVWqAie6s\nLowRes: true\n\n## Description\n\nTake a peak behind the scenes! Sara takes you on a tour of the set - or at least, she tries to. Ian keeps messing up her shots!\n\n\n# Esmeralda Superspy: Backstage #3\n\nYouTube: zZId4Rr2-Rw\nLowRes: true\n\n## Description\n\nIan thinks he's doing a safety speech for the funny environmental show \"Esmeralda Superspy\" but really, Sara is about to get her revenge on him for wrecking her scenes.\n\n\n# Good Green News: Vancouver Urban Gardens\n\nYouTube: dPD3BogYAKw\nLowRes: true\n\n## Description\n\nKid reporter Tia, 9, reports on the Good Green News in the city of Vancouver - Find out why Vancouver helped bring over 400 urban gardens to the city!\n"

/***/ }),
/* 1588 */
/***/ (function(module, exports) {

	module.exports = "# Level Completed\n\n## Content\n\n### Welcome back!\n* Click the MENU button (top left) and use MODULES to go back to any of the four modules.\n* Or check out the videos in the EXTRAS section!\n\n## Notes\n\nWelcome back!\n"

/***/ }),
/* 1589 */
/***/ (function(module, exports) {

	module.exports = "# Teacher Resources\n## Welcome!\nWe're so happy to be training emergency preparedness superheroes from {r/:$cityOrMunicipality}!\n\n#### {r/Canada} Teacher's Guide\n{r/Canada} Download the [Teacher's Guide](Teachers_Guide.pdf) for a full overview of the program's contents and how it works.\n\nThe best way to orient yourself is to check out the student-facing content by clicking 'Start Module 1'.\n\n#### Curriculum Links\nThe Emergency Preparedness Squad supports curriculum standards in science, arts, language and social studies. The following connections are provided for your convenience:\n\n* {r/Canada/BC}[British Columbia Grades 3-5](CL_PPA-EPS_Canada_BC_Grades_3-5.pdf)\n* {r/Canada/ON}[Ontario Grades 3-6](CL_PPA-EPS_Canada_Ontario_Grades_3-6.pdf)\n* {r/United States}[Common Core State Standards Grades 3-5](CL_PPA-EPS_US_Common_Core_Grades_3-5.pdf)\n* {r/United States}[Next Generation Science Standards Grades 3-5](CL_PPA-EPS_US_Next_Generation_Science_Standards_Grades_3-5.pdf)\n* {r/}We don't have curriculum links for your area yet. Do you want to help us develop them? Please contact us!\n\n#### Teaching students remotely?\nCheck out our [Remote Teaching Cheat Sheet](Remote_Teaching_Cheat_Sheet.pdf) for tips on how to adapt the program for remote/at-home learning!\n\n#### Need help from a human?\nGet in touch through the Messenger in the bottom right-hand corner!\n\n# Printables\n\n#### Required Print Materials\n\n* Mission Files for each child in [{r/Canada:colour}{r/:color}](Printables_Mission_Files_Colour.pdf) or [black & white](Printables_Mission_Files_BW.pdf).\n* [Answers](Printables_Crossword_Answers.pdf) to Emergency Preparedness Crossword in Mission Files.\n* Completion certificates for each child in [{r/Canada:colour}{r/:color}](Printables_Completion_Certificates_Colour.pdf) or [black & white](Printables_Completion_Certificates_BW.pdf).\n\n#### Optional Print Materials\n* Winning team certificates in [{r/Canada:colour}{r/:color}](Printables_Winning_Certificates_Colour.pdf) or [black & white](Printables_Winning_Certificates_BW.pdf).\n"

/***/ }),
/* 1590 */
/***/ (function(module, exports) {

	module.exports = "# Module 1 Overview\r\n\r\n#### KNOW THE RISKS at a glance\r\n##### Typical duration: 1 hour\r\n* Watch engaging videos.\r\n* Sing the Emergency Preparedness Squad Theme Song.\r\n* Brainstorm the Top Ten Emergencies.\r\n* Play a game show on what can happen during a disaster.\r\n* Learn and practice the Superhero Calming Breath.\r\n* Be assigned their first mission, Mission 1: Know the Risks.\r\n\r\n#### Getting into teams\r\n* Before starting the program, divide your class into four teams - Earth, Air, Fire and Water (we recommend you set up the teams ahead of time and that they remain the same for the duration of the program).\r\n* Each team will work together during the various arts-based activities and score points for participating, collaborating, listening etc.\r\n* It's a flexible system for you to reward the {r/Canada:behaviour}{r/:behavior} you want to see in your class!\r\n\r\n#### Key Vocabulary\r\n* Emergencies\r\n* Risks\r\n* Emergency Preparedness\r\n\r\n# Materials\r\n\r\n#### What you need for this level\r\n* Mission Files for each student in [{r/Canada:colour}{r/:color}](Printables_Mission_Files_Colour.pdf) or [black & white](Printables_Mission_Files_BW.pdf).\r\n"

/***/ }),
/* 1591 */
/***/ (function(module, exports) {

	module.exports = "# Module 2 Overview\r\n\r\n#### MAKE A PLAN at a glance\r\n##### Typical duration: 1 hour\r\n* Watch engaging videos.\r\n* Sing the Emergency Preparedness Squad Theme Song.\r\n* Report on their Know the Risks at-home mission.\r\n* Play a game show on the importance of making a family emergency preparedness plan.\r\n* Draw a floor plan of your home and identify emergency exits.\r\n* Be assigned their second mission, Mission 2: Make a Plan.\r\n\r\n#### Key Vocabulary\r\n* Planning\r\n* Emergency Plan\r\n* Safety and wellbeing\r\n* Emergency exits\r\n\r\n# Materials\r\n\r\n#### What you need for this level\r\n* Mission Files for each student\r\n"

/***/ }),
/* 1592 */
/***/ (function(module, exports) {

	module.exports = "# Module 3 Overview\n\n#### GET A KIT at a glance\n##### Typical duration: 1 hour\nIn this level, Apprentices will:\n* Sing the Emergency Preparedness Squad Theme Song.\n* Report on their Make a Plan at-home mission.\n* Play a game show which engages them on the importance of making an emergency preparedness kit.\n* Write and perform, in teams, a rap about making an emergency preparedness kit.\n* Be assigned their next mission, Mission 3: Get a Kit.\n\n#### Key Vocabulary\n* Emergency Preparedness Kit\n\n# Materials\n\n#### What you need for this level\n* Each Apprentice also requires their Mission Files if you haven printed this yet.\n"

/***/ }),
/* 1593 */
/***/ (function(module, exports) {

	module.exports = "# Module 4 Overview\n\n#### WE'RE IN THIS TOGETHER at a glance\n##### Typical duration: 1 hour\nIn this level, Apprentices will:\n* Sing the Emergency Preparedness Squad Theme Song.\n* Report back on their Get a Kit at-home mission.\n* Play a game show which engages them on being good community members during an emergency.\n* Receive individual participation and winning team certificates.\n* Celebrate their achievements during the program!\n\n#### Key Vocabulary\n* Community\n\n# Materials\n\n#### What you need for this level\n* Mission Files\n* Completion certificates for each Apprentice in [{r/Canada:colour}{r/:color}](Printables_Completion_Certificates_Colour.pdf) or [black & white](Printables_Completion_Certificates_BW.pdf).\n* Once you know which team has earned the most points, you can print a Winning Team Certificate in [{r/Canada:colour}{r/:color}](Printables_Winning_Certificates_Colour.pdf) or [black & white](Printables_Winning_Certificates_BW.pdf) to post on your classroom wall after the lesson.\n"

/***/ }),
/* 1594 */
/***/ (function(module, exports) {

	module.exports = "# Tech Prep Wizard\n\n### Tech Prep Wizard\n\nThis short wizard will help you get set up to run the Academy in your classroom.\n\nDon't show your students the screen yet!\n\nClick the arrow or use your keyboard's right directional arrow to move through the wizard.\n\n# Two Device Intro\n\n### Two Device Experience\nThe Academy is best experienced using two devices:\n* Main device (COMPUTER or TABLET) projects the website at the front of the class.\n* Second device (TABLET or CELLPHONE) can be as a remote control (optional):\n  * gives you freedom to move around the classroom.\n  * contains prompts and facilitation notes at your finger tips.\n  * provides useful progress indicators, such as length of videos and number of slides remaining.\n\n# Connecting Remote\n\n### Connect your remote!\nTo connect a second device as a Remote Control:\n1. Go to www.remote4ppa.com on your tablet/phone.\n2. Enter your username and password on your tablet/phone.\n3. Go to the next slide to Select Role For This Device.\n4. Choose the right Role for each device.\n5. Your selections will be saved for future use, but you can always change it later!\n\n# Tech Check Intro\n\n### Tech Check!\nNOW PLEASE hook up your main device to your projector and **test the audio/video** to make sure everything's working! There's a fun video in the next slide to help you do this (it's also in the Fun section if you want to share with your class).\n\n#### Full Screen Experience\nThe Planet Protector Academy is best enjoyed as a full screen experience. **Click 'View'** in your browser's menu bar, and select **'Full Screen'** (Chrome) or **'Enter Full Screen'** (Safari/Firefox).\n\n# Tech Check Video\nYouTube: ZVdMndkjaIo\n"

/***/ }),
/* 1595 */
/***/ (function(module, exports) {

	module.exports = "# Program Start\n\n# Level 1 Start\n\n## Notes\n\n### Start\n\nShow this screen at the start of class. When the kids are ready, advance to the next screen.\n\nUse the directional arrows on your remote to go forwards/backwards through the level.\n\n# Level 1 Icon\n\n## Notes\n\nKnow the Risks\n\n### Tracking your progress\n\nYou can see how far along you are by the slide number on the top of your Remote Control or by the blue progress bar running along the bottom of the Menu on the Classroom Display.\n\n# Level 1 Intro\n\nYouTube: iUfUibFjjaU\n\n## Notes\n\nSara and Ian welcome the students to the Emergency Preparedness Squad program (2:38).\n\n# Level 2 Start\n\n## Notes\n\n### Start\n\nShow this screen at the start of class. When the kids are ready, advance to the next screen.\n\nUse the directional arrows on your remote to go forwards/backwards through the level.\n\n# Level 2 Icon\n\n## Notes\n\nMake a Plan\n\n# Level 2 Intro\n\nYouTube: Jqt2vQvCcD4\n\n## Notes\n\nSara and Ian welcome the students back to the program (0:39).\n\n### Problems with your video buffering?\nPause the video and wait a minute for it to pre-load, then it should play without a hitch!\n\n# Level 3 Start\n\n## Notes\n\n### Start\n\nShow this screen at the start of class. When the kids are ready, advance to the next screen.\n\n# Level 3 Icon\n\n## Notes\n\nGet a Kit\n\n# Level 3 Intro\n\nYouTube: O4Qx3wGyCWA\n\n## Notes\n\nSara and Ian welcome the students back to the program (0:15).\n\n# Level 4 Start\n\n## Notes\n\n### Start\n\nShow this screen at the start of class. When the kids are ready, advance to the next screen.\n\n# Level 4 Icon\n\n## Notes\n\nWe're In This Together\n"

/***/ }),
/* 1596 */
/***/ (function(module, exports) {

	module.exports = "# Song\nYouTube: fB3ZHt6aYJ8\n\n## Notes\n\n### Emergency Preparedness Squad Song\n\nEncourage your class to learn this song and sing along to the video (2:21).\n\n### Extension Activities\nApprentices can perform the song to the whole school and/or create their own choreography.\n"

/***/ }),
/* 1597 */
/***/ (function(module, exports) {

	module.exports = "Team Creation\n\n# Intro Team Names\n\nYouTube: fKpu_L5XHz8\n\n## Notes\nSara and Ian introduce themselves and tell Apprentices to get into teams (1:20).\n\n# Get Into Teams\n\n## Content\n\n###### Get into four teams!\n\nName your teams in the next slide.\n\n## Notes\n\nName teams in the next slide. Once you enter the name in the text field, it automatically saves!\n\n# Scoring Intro\n\n## Content\n\n### Here's how your team can score points\n\n* Answer questions\n* Do activities\n* Complete missions\n* Work well together (teamwork points)\n* and more!\n\n## Notes\n\n### Scoring\n* Teams can earn points for most activities in the program. You can allocate points as you see fit. Maximum points total is 999.\n* Individuals can earn points for teams, or teams can earn points together.\n* Teamwork points are critical to ensure collaboration.\n* Points can also be a classroom \"currency\", e.g.to gain classroom privileges.\n* The team with the most points at the end of Level 4 is the winner.\n\n# Scoreboard Intro\n\n## Content\n\n### Check out the scoreboard!\n\n(In the top left corner, click MENU and then SCORES)\n\nYour teams are now ready to start scoring points!\n\n## Notes\n\nClick on the 'Scoreboard' icon on your remote at any time to bring down the scoreboard and add points for teams.\n\n# Congratulations\n\n## Content\n\n### Congratulations!\n\n#### You're now Apprentices in the Emergency Preparedness Squad!\n\n## Notes\n\n&nbsp;\n"

/***/ }),
/* 1598 */
/***/ (function(module, exports) {

	module.exports = "# Esmeralda and Goober Intro\n\nYouTube: BSMdUUViT94\n\n## Notes\nIan and Sara introduce the Esmeralda and Goober storyline (0:42).\n\n# Esmeralda and Goober Story\n\nYouTube: vY9c9oatHDw\n\n## Notes\nEsmeralda and Goober storyline - Know the Risks (3:43).\n"

/***/ }),
/* 1599 */
/***/ (function(module, exports) {

	module.exports = "# Esmeralda and Goober Story\n\nYouTube: i6c_oeWPDxg\n\n## Notes\nEsmeralda and Goober storyline - Make a Plan (1:47).\n\n# Calming Breath Intro\n\nYouTube: bDy55oVYj00\n\n## Notes\nSara and Ian help Apprentices practice the Superhero Calming Breath (0:49).\n"

/***/ }),
/* 1600 */
/***/ (function(module, exports) {

	module.exports = "# Sharknado\n\nYouTube: _JRlG-5_7ic\n\n## Notes\n\nSara and Ian share what should go in your Apprentices' emergency kits (4:16).\n\n# Calming Breath Recap\n\nYouTube: nUGO4-S_I5w\n\n## Notes\n\nPractice the Superhero Calming Breath! (0:36).\n\n# Esmeralda and Goober Story\n\nYouTube: 5FvPTip5iI4\n\n## Notes\nEsmeralda and Goober storyline - Get a Kit (2:37).\n"

/***/ }),
/* 1601 */
/***/ (function(module, exports) {

	module.exports = "# Esmeralda and Goober Story\n\nYouTube: Ka3bcyUj6TU\n\n## Notes\nEsmeralda and Goober storyline wrap-up (2:19).\n"

/***/ }),
/* 1602 */
/***/ (function(module, exports) {

	module.exports = "# Mission Report\nTitle: Know the Risks\n\n# Scoring\n\n## Content\n\n### Count your mission points!\n\n* Turn to Level 1 - Know the Risks in your Mission Files.\n* Teams get one point for each team member that talked with their families.\n* Make sure your points get added onto the Scoreboard!\n\n## Notes\n\n&nbsp;\n\n# Instructions\n\n## Content\n\n### Time to report to HQ!\n\n* Answer with a show of hands.\n* Teachers can report too!\n\n## Notes\n\n### Mission Reports\n* Mission reports help us communicate the impact of our program. Thanks for helping us to measure it!\n* Using a show of hands keeps the data anonymous.\n\n# Questions\n\n## Content\n\n1. Number of Apprentices and Teachers reporting in.\n2. I talked with my family about the Top Ten Emergencies.\n3. I've used the Superhero Calming Breath to help me feel calm.\n4. How many Apprentices are having fun with this program?\n\n# Impact\n\n## Content\n\n### Awesome work, Apprentices!\n\nYour Mission Report was received by Emergency Preparedness Squad HQ.\n\n## Notes\n\nGreat job!\n\n# Class Discussion\n\n## Content\n\n### Class Discussion\n* As a class, discuss what was easy or hard about this mission.\n* What worked, what didn’t work?\n* What would make it easier?\n\n## Notes\n\nEncourage Apprentices who did not succeed to keep trying, if appropriate.\n"

/***/ }),
/* 1603 */
/***/ (function(module, exports) {

	module.exports = "# Mission Report\nTitle: Make a Plan\n\n# Scoring\n\n## Content\n\n### Get points for your missions!\n\n* Turn to Level 2 - Make a Plan in your Mission Files.\n* In your teams, count the total number of points you scored.\n* Make sure your points get added onto the Scoreboard!\n\n## Notes\n\nThis slide only covers actions listed under 'Get a point for' for each mission.\nStudents report the Mission Report section next.\n\n# Instructions\n\n## Content\n\n### Time to report to HQ!\n\n* Answer with a show of hands.\n* Teachers can report too!\n\n## Notes\n\n### Mission Reports\n* Mission reports help us communicate the impact of our program. Thanks for helping us to measure it!\n* Using a show of hands keeps the data anonymous.\n\n# Questions\n\n## Content\n\n1. Number of Apprentices and Teachers reporting in.\n2. +My family filled out an emergency plan.\n3. +My family started filling out a plan but didn't finish.\n4. +My family hasn't made an emergency plan YET, but we pledge to soon.\n5. +My family didn't make an emergency plan and aren't likely to.\n6. How many Apprentices feel like real-life Emergency Preparedness Squad superheroes now?\n\n# Impact\n\n## Content\n\n### Awesome work, Apprentices!\n\nYour Mission Report was received by Emergency Preparedness Squad HQ.\n\n## Notes\n\nGreat job!\n\n# Class Discussion\n\n## Content\n\n### Class Discussion\n* As a class, discuss what was easy or hard about this mission.\n* What worked, what didn’t work?\n* What would make it easier?\n\n## Notes\n\nEncourage Apprentices who did not succeed to keep trying, if appropriate.\n"

/***/ }),
/* 1604 */
/***/ (function(module, exports) {

	module.exports = "# Mission Report\nTitle: Get a Kit\n\n# Intro Video\nYouTube: oQiZTpCPDM4\n\n## Notes\n\nSara and Ian introduce the mission report for Get a Kit (3:04).\n\n# Scoring\n\n## Content\n\n### Get points for your missions!\n\n* Turn to Level 3 - Get a Kit in your Mission Files.\n* In your teams, count the total number of points you scored.\n* Make sure your points get added onto the Scoreboard!\n\n## Notes\n\nThis slide only covers actions listed under 'Get a point for' for each mission.\nStudents report the Mission Report section next.\n\n# Instructions\n\n## Content\n\n### Time to report to HQ!\n\n* Answer with a show of hands.\n* Teachers can report too!\n\n## Notes\n\n### Mission Reports\n* Mission reports help us communicate the impact of our program. Thanks for helping us to measure it!\n* Using a show of hands keeps the data anonymous.\n\n# Questions\n\n## Content\n\n1. Number of Apprentices and Teachers reporting in.\n2. +My family started putting together our kit.\n3. +My family hasn't started our kit YET but we pledge to do it soon.\n4. +My family didn't make an emergency kit and aren't likely to.\n5. How many Apprentices pledge to be Emergency Preparedness Squad superheroes from now on?\n6. My family succeeded in at least one mission during the program.\n\n# Impact\n\n## Content\n\n### Awesome work, Apprentices!\n\nYour Mission Report was received by Emergency Preparedness Squad HQ.\n\n## Notes\n\nGreat job!\n\n# Class Discussion\n\n## Content\n\n### Class Discussion\n* As a class, discuss what was easy or hard about this mission.\n* What worked, what didn’t work?\n* What would make it easier?\n\n## Notes\n\nEncourage apprentices who did not succeed to keep trying, if appropriate.\n"

/***/ }),
/* 1605 */
/***/ (function(module, exports) {

	module.exports = "# Game Show\n\nLevel 1 - Know the Risks\n\n# Intro Video\n\nYouTube: jZHHVq_xOvM\n\n## Notes\n\nSara and Ian introduce the Game Show (2:10).\n\n\n# Sizzle\n\n## Notes\n\n&nbsp;\n\n\n# Scoring\n\n## Content\n\n### How to score points\n* Do your Superhero pose.\n* Buzz in first.\n* Give a good answer. Try your best!\n* If you don’t know the answer, think about what a good answer might be. This is not a test!\n\n## Notes\n\n&nbsp;\n\n\n# Four Players Announcement\n\n## Notes\n\n&nbsp;\n\n\n# Question 1\n\n## Question\n\n#### What kind of things can happen in an earthquake?\n\n## Answer\n\n### Some risks from earthquakes:\n* Property damage\n* Roads closed\n* Natural gas leak\n* Shaking around\n* Falling objects in buildings\n* Broken windows\n* Power outage\n\n## Answer Notes\n\n&nbsp;\n\n# Scoring Reminder\n\n## Content\n\n### Don't forget to add scores!\n\n## Notes\n\nClick on the 'Scores' button below to open up the Scoreboard.\n\n\n# Question 2\n\n## Question\n\n#### What kind of things can happen in a windstorm?\n\n## Answer\n\n### Some risks from windstorms:\n* Trees/branches falling\n* Power outage\n* Property damage\n* Roads blocked\n\n## Answer Notes\n\n&nbsp;\n\n\n# Question 3\n\n## Question\n\n#### What kind of things can happen in a power outage?\n\n## Answer\n\n### Some risks from power outages:\n* No electricity or lights\n* No heat if electric\n* No street lights or traffic lights\n* Internet probably won't work\n* Fresh food will go bad in the fridge\n\n## Answer Notes\n\n&nbsp;\n"

/***/ }),
/* 1606 */
/***/ (function(module, exports) {

	module.exports = "Level 2 - Make a Plan\n\n# Intro Video\n\nYouTube: 6a5nxfJ3UB8\n\n## Notes\n\nSara and Ian introduce the Game Show (2:38).\n\n# Sizzle\n\n## Notes\n\n### Game Show\nIn the Game Show we ask questions relating to the topic *before* giving the answers, in order to stimulate thinking, rather than to test knowledge.\n\nOne Apprentice from each team will come up to the front of the class and get a chance to answer the question in turn.\n\nFor more info, see \"Game Show Info\" in the Teachers Guide, which is available in the Teacher Resources section on the Dashboard page.\n\n# Scoring\n\n## Content\n\n### How to score points\n* Do your Superhero pose.\n* Buzz in first.\n* Give a good answer. Try your best!\n* If you don’t know the answer, think about what a good answer might be. This is not a test!\n\n## Notes\n\nDon't forget to score points on the Scoreboard!\n\n# Four Players Announcement\n\n## Notes\n\n* One Apprentice from each team comes to the front of the room.\n* Encourage a different Apprentice to come up for each question.\n\n# Question 1\n\n## Question\n\n#### Name some things you could plan e.g. a party\n\n## Answer\n\n### Some things you could plan:\n* Party\n* Trip\n* Class\n* Making a video\n* How you'll study for a test\n* A neighbourhood hockey game\n\n## Answer Notes\n\n&nbsp;\n\n# Scoring Reminder\n\n## Content\n\n### Don't forget to add scores!\n\n## Notes\n\nClick on the 'Scores' button below to open up the Scoreboard.\n\n# Question 2\n\n## Question\n\n#### What do you think is the goal of an emergency plan? Why do we need one?\n\n## Answer\n\n### Goal is safety and well-being:\n* So we think about what we’ll need to do ahead of time.\n* So we’ll feel more prepared and safe.\n* So we have all our information together.\n* So we know what to do.\n\n## Answer Notes\n\n&nbsp;\n\n# Question 3\n\n## Question\n\n#### Team brainstorm - What are some things that should be included in an emergency plan?\n\n## Answer\n\n### Some things that should be in an emergency plan:\n* Where to meet your family.\n* How to contact your family.\n* What to do if you're in different places (work/home/play).\n* Plan for your pets.\n* Special needs concerns.\n* Emergency contact info.\n\n## Answer Notes\n\n&nbsp;\n"

/***/ }),
/* 1607 */
/***/ (function(module, exports) {

	module.exports = "Level 3 - Get a Kit\n\n# Intro Video\n\nYouTube: OpmtyG62cn4\n\n## Notes\n\nSara and Ian introduce the Game Show (0:29).\n\n# Sizzle\n\n## Notes\n\nGame Show\n\n# Scoring\n\n## Content\n\n### Reminder:\n* Do your Superhero pose.\n* Buzz in first.\n* Give a good answer.\n\n## Notes\n\nDon't forget to score points on the Scoreboard!\n\n# Four Players Announcement\n\n## Notes\n\nFour players to the front.\n\n# Question 1\n\n## Question\n\n#### What do you think an emergency prep kit is for?\n\n## Answer\n\n### An emergency preparedness kit is so you can:\n* Have something to eat\n* Have water to drink\n* Stay safe and warm\n* Get important news\n\n## Answer Notes\n\n&nbsp;\n\n# Scoring Reminder\n\n## Content\n\n### Don't forget to add scores!\n\n## Notes\n\nClick on the 'Scores' button below to open up the Scoreboard.\n\n# Question 2\n\n## Question\n\n#### Name a good place to keep your emergency kit in your home.\n\n## Answer\n\n### Some places to keep your kit:\n* Near the door\n* In a bag you can grab and go\n* Make sure everyone in your family knows where it's stored!\n\n## Answer Notes\n\n&nbsp;\n\n# Question 3\n\n## Question\n\n#### Team brainstorm - write down as many things as you can that should probably go in your kit.\nScoring: If you got ten or items or more, get ten points. No peeking in your Mission Files!\n\n## Answer\n\n### Things you can put in your kit:\n* Food\n* Water (nonperishable)\n* Flashlight\n* Medication + glasses\n* Extra clothes\n* Picture / letter from parents\n* Copy of plan, incl contact info and safe meeting place\n\n## Answer Notes\n\n&nbsp;\n"

/***/ }),
/* 1608 */
/***/ (function(module, exports) {

	module.exports = "Level 4 - We're In This Together\n\n# Intro Video\n\nYouTube: mXdAKK3NAmE\n\n## Notes\n\nSara and Ian introduce the Game Show (0:47).\n\n# Sizzle\n\n## Notes\n\nGame Show\n\n# Four Players Announcement\n\n## Notes\n\nFour players to the front.\n\n# Question 1\n\n## Question\n\n#### Who are the people most likely to help you in an emergency?\n\n## Answer\n\n### Some people who are likely to help you:\n* Your friends\n* Your family\n* Teachers\n* Neighbours\n\n## Answer Notes\n\n&nbsp;\n\n# Question 2\n\n## Question\n\n#### Why aren't the police and fire fighters the ones likely to help?\n\n## Answer\n\n#### They will be busy saving lives, where they can do the most good.\n\n## Answer Notes\n\n&nbsp;\n\n# Question 3\n\n## Question Intro\n\n#### When should you call 911?\nMultiple choice - see next slide!\n\n## Question\n(a) to ask if an earthquake just happened\n\n(b) to tell them an earthquake just happened\n\n(c) if someone's life is in danger\n\n(d) if a gas main broke\n\n## Answer\n\n#### The answer is: (c) + (d)\nDon't call 911 unless someone's life is in danger.\n\n## Answer Notes\n\n&nbsp;\n"

/***/ }),
/* 1609 */
/***/ (function(module, exports) {

	module.exports = "List Emergencies\n\n# Intro Video\n\nYouTube: _aGQS4IvHic\n\n## Notes\n\nSara and Ian practice the Superhero Calming Breath and introduce the Top Ten Emergencies brainstorming activity (1:44).\n\n# Sizzle\n\n## Content\n\n### Activity: Brainstorm!\n\n## Notes\n&nbsp;\n\n# Instructions\n\n## Content\n\n### Activity Instructions:\n* Make a list of possible emergencies in your region:\n  * As a team, make a list of as many emergencies as you can.\n  * Points for good answers, number of answers, good {r/Canada:behaviour}{r/:behavior}\n  * 3 minutes!\n\n## Notes\n\n&nbsp;\n\n# Time Up\n\nYouTube: GGsuC2gFtyk\n\n## Notes\n\nSara and Ian tell your class to share their answers (0:23).\n\n# How To Get Points\n\n## Content\n\n### How to get points\n  * 2 points if your item is on the list.\n  * 1 point if not on the list but teacher says it's a legit emergency.\n  * Minus 1 point for cheeky monkey answers.\n\n## Notes\n\n&nbsp;\n\n# Share Answers\n\n## Content\n\n### Share your answers\n1 person from each team read your list.\n\n## Notes\n\n&nbsp;\n\n# Top Ten Emergencies\n\n## Content\n\n### Top Ten Emergencies:\n#### Earthquakes, Avalanches, Wildfires\n#### Disease Outbreak, Landslides, Tsunamis\n#### Power Outages, Hazardous Material Spills\n#### Severe Weather, Floods\n\n## Notes\n\n&nbsp;\n\n# Points Reminder\n\n## Content\n\n### Don't forget to add scores!\n\n## Notes\n\n&nbsp;\n\n# Act Out Emergencies\n\nYouTube: Y4_2TaxVFjw\n\n## Notes\n\nSara and Ian act out the Top Ten Emergencies (1:24).\n"

/***/ }),
/* 1610 */
/***/ (function(module, exports) {

	module.exports = "Group Drawing\n\n# Intro Video\n\nYouTube: B779gOrzCuk\n\n## Notes\n\nSara and Ian introduce the importance of being prepared for the first 72hrs. They also introduce the first part of making an emergency plan (1:18).\n\n# Sizzle\n\n## Content\n\n### Activity 1: Drawing!\n\n## Notes\nActivity instructions on next slide.\n\n# Instructions\n\n## Content\n\n### Activity Instructions:\n* Draw a floorplan of one room in your home.\n* Plan emergency exits from one room of your home.\n  * Try to think of two possibilities.\n  * If you live in an apartment, do not plan to use the elevators.\n* Two points for the drawing.\n* One point for getting your parent/guardian to sign the natural gas safety info in your Mission Files!\n\n## Notes\n\n&nbsp;\n"

/***/ }),
/* 1611 */
/***/ (function(module, exports) {

	module.exports = "# Intro Video\n\nYouTube: anIbh_g5Tu4\n\n## Notes\nIntro to rap activity (1:20).\n\n# Sizzle\n\n## Content\n\n### Activity 1: Write a rap!\n\n(Younger grades can write a poem instead)\n\n## Notes\n\nActivity instructions on next slide.\n\n# Instructions\n\n## Content\n\n### Activity Instructions:\n* Write a rap about things you’ll need in your kit - at least two items.\n* Write two lines, where the last word in each line rhymes.\n* Your Mission Files has sample rhymes, but get bonus points for using words that aren't in the booklet.\n* If you're writing a rap, {r/Canada:practise}{r/:practice} in your teams with the backing track on the next slide.\n\n## Notes\n\nThere is a worksheet in the Mission File for this activity.\n\n# Rap Backtrack Practice\n\nYouTube: eEzxxHgcpzE\n\n## Notes\n\nTo get the backtrack (10:07) to repeat, just press play again.\n\n# Scoring\n\n## Content\n\n### Now perform for the class!\n\n#### Get points for:\n* Two lines that rhyme.\n* Good performance.\n* Beatboxing (if you're rapping).\n* Being a good audience.\n\n## Notes\n\n### Extension Activity\nVideo your raps and submit them to our website!\n\n# Rap Backtrack Perform\nYouTube: eEzxxHgcpzE\n\n## Notes\n\nTo get the backtrack to repeat, just press play again.\n"

/***/ }),
/* 1612 */
/***/ (function(module, exports) {

	module.exports = "# Intro Video  \n\nYouTube: 0MKIR2myq7U\n\n## Notes\nSara and Ian introduce the Drawing activity (1:21).\n\n# Sizzle\n\n## Content\n\n### Activity 1: Drawing!\n\n## Notes\n\n&nbsp;\n\n# Instructions\n\n## Content\n\n### Activity Instructions:\n* Draw a picture of the people you might be with in an emergency.\n* Points for trying your best!\n\n## Notes\n\n&nbsp;\n"

/***/ }),
/* 1613 */
/***/ (function(module, exports) {

	module.exports = "# Mission Assignment\n\nTitle: Know the Risks\n\n## Notes\n&nbsp;\n\n# Mission Intro Video\n\nYouTube: p_xHSeWJUOA\n\n## Notes\n\nIan and Sara introduce Mission 1 - Know the Risks (1:23).\n\n### Make a Plan\n* Apprentices turn to Mission 1 in their Mission Files.\n* Decide which day you will do the next Level.\n* Apprentices write that date on the cover of their Mission Files and on the Mission 1 page.\n* Points are awarded for signed and returned Mission 1 page.\n\n# Instructions\n\n## Content\n\n### Mission 1:\n\n#### Know the Risks\n* Tell your family about the Top Ten Emergencies\n* Practice the Superhero Calming Breath\n* Get your Mission File signed by your parent/guardian.\n\n## Notes\n\n&nbsp;\n"

/***/ }),
/* 1614 */
/***/ (function(module, exports) {

	module.exports = "# Mission Assignment\n\nTitle: Make a Plan\n\n## Notes\n&nbsp;\n\n# Mission Intro Video\n\nYouTube: F8mHgZSKa1s\n\n## Notes\n\nIan and Sara introduce Mission 2 - Make a Plan (2:01).\n\n### Make a Plan\n* Apprentices turn to Mission 2 in their Mission Files.\n* Decide which day you will do the next Level.\n* Apprentices write that date on the cover of their Mission Files and on the Mission 2 page.\n* Points are awarded for signed and returned Mission 2 page.\n\n# Instructions\n\n## Content\n\n### Mission 2:\n\n#### Making a plan\n* Get your family to make a plan!\n* With the adults in your family, fill out the plan in your Mission Files.\n* Make copies of the plan and store it in safe places.\n* Get your Mission File signed by your parent/guardian.\n\n## Notes\n\n&nbsp;\n"

/***/ }),
/* 1615 */
/***/ (function(module, exports) {

	module.exports = "# Mission Assignment\n\nTitle: Get a Kit\n\n## Notes\n&nbsp;\n\n# Mission Intro Video\n\nYouTube: AsQU_9j_eyo\n\n## Notes\n\nIan and Sara introduce Mission 3 - Get a Kit (1:43).\n\n### Make a Plan\n* Apprentices turn to Mission 3 in their Mission Files.\n* Decide which day you will do the next Level.\n* Apprentices write that date on the cover of their Mission Files and on the Mission 3 page.\n* Points are awarded for signed and returned Mission 3 page.\n\n# Instructions\n\n## Content\n\n### Mission 3:\n\n#### Get a kit\n* Get your family to make a kit!\n* One point for each item in your kit.\n* Do the puzzle to get bonus points.\n* Get your Mission File signed by your parent/guardian.\n\n## Notes\n\n&nbsp;\n"

/***/ }),
/* 1616 */
/***/ (function(module, exports) {

	module.exports = "# Mission Assignment\n\nTitle: Keep Building Your Kit\n\n## Notes\n&nbsp;\n\n# Mission Intro Video\n\nYouTube: 86B6X8UUbkg\n\n## Notes\n\nIan and Sara introduce Mission 4 - We're In This Together (2:47).\n\n# Instructions\n\n## Content\n\n### Mission 4:\n\n#### Keep getting more prepared!\n* Keep building your kit!\n* Talk with friends and family about emergency preparedness.\n* Keep practising your Superhero Calming Breath!\n\n## Notes\n\n&nbsp;\n"

/***/ }),
/* 1617 */
/***/ (function(module, exports) {

	module.exports = "Finish\n\n# Outtakes 1\n\nYouTube: m0Zkh5kx3sQ\n\n## Notes\n\nOuttakes fun with Ian & Sara (1:16).\n\n# Outtakes 2\n\nYouTube: xj0mgAqAyqw\n\n## Notes\n\nMore outtakes fun with Ian & Sara (0:48).\n\n# Scoreboard Recap\n\n## Content\n\n### Check out the scoreboard to see who's in the lead!\n\n## Notes\n\n&nbsp;\n\n# Earn More Points\n\n## Content\n\n### Everyone has a chance to earn more points!\n* Take home your Mission Files.\n* Do your missions and record what you did.\n* Listen & participate in class!\n\n## Notes\n\n&nbsp;\n\n# Farewell\n\n## Content\n\n### Keep the fun going!\n\n#### Visit *AndGoober.com* for games and activities\n\nGo to the next slide to finish the level\n\n## Notes\nTo finish, go to the next slide and click 'Click to end level'.\n"

/***/ }),
/* 1618 */
/***/ (function(module, exports) {

	module.exports = "Ending\n\n# Announce Winners\n\n## Content\n\n### Time to announce the winners!\n\n#### Teachers please hand out certificates.\n\n## Notes\n\nPrint winning team certificates once you know who won; give all team members completion certificates now.\n\n# Members EPS\n\n## Content\n\n### You are all now members of the Emergency Preparedness Squad!\n\n#### Congratulations!\n\n## Notes\n\nThank you for training your Apprentices!\n\n# All Levels Completed\n\n## Notes\n\n&nbsp;\n\n### Getting your feedback\n\nWe love to hear from teachers about their experience with the Academy. We'll be in touch in the next few days with a feedback survey!\n\nHave ideas for extension activities? Please share them with us!\n"

/***/ }),
/* 1619 */
/***/ (function(module, exports) {

	module.exports = "# Extension Activities\n\n#### Emergency Preparedness Squad song\n* Perform during Emergency Preparedness Week or at another assembly for your school.\n* We’d love to hear about it or see a video!!\n* For even more fun, Apprentices can create their own choreography.\n\n#### PreparedBC's Master of Disaster teaching resource\n* The Province of BC has developed a curriculum-linked resource for Grade 6 classrooms. [Check it out](http://www2.gov.bc.ca/gov/content/safety/emergency-preparedness-response-recovery/preparedbc/master-of-disaster)!\n* Not a Grade 6 teacher? Check out their [extensive multimedia resource library](https://www2.gov.bc.ca/gov/content/safety/emergency-preparedness-response-recovery/preparedbc/master-of-disaster/master-of-disaster-multimedia-resources) for more educational resources on emergency preparedness!\n\n#### Other Emergency Preparedness resources\n* [Disaster Hero](http://www.disasterhero.com/) online video game where players compete to become the next Disaster Hero!\n* [Ready.gov](https://www.ready.gov/kids) is the US government's hub for emergency preparedness info includes a special kids section with PDF resources and online games.\n* [American Public Health Association](http://www.getreadyforflu.org/kids/)'s resources include puzzles and brain teasers with an emergency preparedness theme.\n"

/***/ }),
/* 1620 */
/***/ (function(module, exports) {

	module.exports = "# Emergency Preparedness Squad Theme Song\n\nYouTube: _0TUIVDHqSE\n\n## Description\n\nSing and dance along to the Emergency Preparedness Squad's theme song anytime you like. Great for starting a lesson!\n\n\n# Esmeralda Planet Protector & The E-Waste Emergency\n\nYouTube: POzKQKxvuzQ\nLowRes: true\n\n## Description\n\nWatch Esmeralda and Goober fight the rise of electronic waste and the evil supervillain Blaster, with some help from our our Planet Protector friends!\n\n\n# Esmeralda Planet Protector & The Litterless Lunch\n\nYouTube: OeT53lGAYX4\nLowRes: true\n\n## Description\n\nEsmeralda and Goober take on Trashella to stop her from convincing kid to bring lunches that make litter!\n\n\n# Esmeralda Planet Protector & Walking To School\n\nYouTube: 1FmXmBOU-V8\nLowRes: true\n\n## Description\n\nCan Esmeralda Superspy Planet Protector and her sidekick Goober stop the Evil Dr. Carbon's dastardly plan to stop kids from walking to school?\n\n\n# Esmeralda Superspy: Backstage #1\n\nYouTube: BQyzd8Y7EaY\nLowRes: true\n\n## Description\n\nDo series stars Ian and Sara spend their time saving the environment and protecting the planet? No, because Ian keeps acting like a monkey! Even when the boss, Jacqueline, is around.\n\n\n# Esmeralda Superspy: Backstage #2\n\nYouTube: AEmVWqAie6s\nLowRes: true\n\n## Description\n\nTake a peak behind the scenes! Sara takes you on a tour of the set - or at least, she tries to. Ian keeps messing up her shots!\n\n\n# Esmeralda Superspy: Backstage #3\n\nYouTube: zZId4Rr2-Rw\nLowRes: true\n\n## Description\n\nIan thinks he's doing a safety speech for the funny environmental show \"Esmeralda Superspy\" but really, Sara is about to get her revenge on him for wrecking her scenes.\n\n\n# Good Green News: Vancouver Urban Gardens\n\nYouTube: dPD3BogYAKw\nLowRes: true\n\n## Description\n\nKid reporter Tia, 9, reports on the Good Green News in the city of Vancouver - Find out why Vancouver helped bring over 400 urban gardens to the city!\n"

/***/ }),
/* 1621 */
/***/ (function(module, exports) {

	module.exports = "# Level Completed\n\n## Content\n\n### Welcome back!\n* Click the MENU button (top left) and use MODULES to go back to any of the four modules.\n* Or check out the videos in the EXTRAS section!\n\n## Notes\n\nWelcome back!\n"

/***/ }),
/* 1622 */
/***/ (function(module, exports) {

	module.exports = "# Teacher Resources\n## Welcome!\nWe're so happy to be training emergency preparedness superheroes from {r/:$cityOrMunicipality}!\n\n#### {r/Canada} Teacher's Guide\n{r/Canada} Download the [Teacher's Guide](Teachers_Guide.pdf) for a full overview of the program's contents and how it works.\n\nThe best way to orient yourself is to check out the student-facing content by clicking 'Start Module 1'.\n\n#### Curriculum Links\nThe Emergency Preparedness Squad supports curriculum standards in science, arts, language and social studies. The following connections are provided for your convenience:\n\n* {r/Canada/BC}[British Columbia Grades K-2](CL_PPA-EPS_Canada_BC_Grades_K-2.pdf)\n* {r/}We don't have curriculum links for your area yet. Do you want to help us develop them? Please contact us!\n\n#### Teaching students remotely?\nCheck out our [Remote Teaching Cheat Sheet](Remote_Teaching_Cheat_Sheet.pdf) for tips on how to adapt the program for remote/at-home learning!\n\n#### Need help from a human?\nGet in touch through the Messenger in the bottom right-hand corner!\n\n# Printables\n\n#### Required Print Materials\n\n* Mission Files for each child in [{r/Canada:colour}{r/:color}](Printables_Mission_Files_Colour.pdf) or [black & white](Printables_Mission_Files_BW.pdf).\n* Completion certificates for each child in [{r/Canada:colour}{r/:color}](Printables_Completion_Certificates_Colour.pdf) or [black & white](Printables_Completion_Certificates_BW.pdf).\n\n#### Optional Print Materials\n* Winning team certificates in [{r/Canada:colour}{r/:color}](Printables_Winning_Certificates_Colour.pdf) or [black & white](Printables_Winning_Certificates_BW.pdf).\n"

/***/ }),
/* 1623 */
/***/ (function(module, exports) {

	module.exports = "# Module 1 Overview\r\n\r\n#### KNOW THE RISKS at a glance\r\n##### Typical duration: 1 hour\r\n* Watch engaging videos.\r\n* Sing the Emergency Preparedness Squad Theme Song.\r\n* Brainstorm the Top Ten Emergencies.\r\n* Play a game show on what can happen during a disaster.\r\n* Learn and practice the Superhero Calming Breath.\r\n* Be assigned their first mission, Mission 1: Know the Risks.\r\n\r\n#### Getting into teams\r\n* Before starting the program, divide your class into four teams - Earth, Air, Fire and Water (we recommend you set up the teams ahead of time and that they remain the same for the duration of the program).\r\n* Each team will work together during the various arts-based activities and score points for participating, collaborating, listening etc.\r\n* It's a flexible system for you to reward the {r/Canada:behaviour}{r/:behavior} you want to see in your class!\r\n\r\n#### Key Vocabulary\r\n* Emergencies\r\n* Risks\r\n* Emergency Preparedness\r\n\r\n# Materials\r\n\r\n#### What you need for this level\r\n* Mission Files for each student in [{r/Canada:colour}{r/:color}](Printables_Mission_Files_Colour.pdf) or [black & white](Printables_Mission_Files_BW.pdf).\r\n"

/***/ }),
/* 1624 */
/***/ (function(module, exports) {

	module.exports = "# Module 2 Overview\r\n\r\n#### MAKE A PLAN at a glance\r\n##### Typical duration: 1 hour\r\n* Watch engaging videos.\r\n* Sing the Emergency Preparedness Squad Theme Song.\r\n* Report on their Know the Risks at-home mission.\r\n* Play a game show on the importance of making a family emergency preparedness plan.\r\n* Draw a floor plan of your home and identify emergency exits.\r\n* Be assigned their second mission, Mission 2: Make a Plan.\r\n\r\n#### Key Vocabulary\r\n* Planning\r\n* Emergency Plan\r\n* Safety and wellbeing\r\n* Emergency exits\r\n\r\n# Materials\r\n\r\n#### What you need for this level\r\n* Mission Files for each student\r\n"

/***/ }),
/* 1625 */
/***/ (function(module, exports) {

	module.exports = "# Module 3 Overview\n\n#### GET A KIT at a glance\n##### Typical duration: 1 hour\nIn this level, Apprentices will:\n* Sing the Emergency Preparedness Squad Theme Song.\n* Report on their Make a Plan at-home mission.\n* Play a game show which engages them on the importance of making an emergency preparedness kit.\n* Write and perform, in teams, a rap about making an emergency preparedness kit.\n* Be assigned their next mission, Mission 3: Get a Kit.\n\n#### Key Vocabulary\n* Emergency Preparedness Kit\n\n# Materials\n\n#### What you need for this level\n* Each Apprentice also requires their Mission Files if you haven printed this yet.\n"

/***/ }),
/* 1626 */
/***/ (function(module, exports) {

	module.exports = "# Module 4 Overview\n\n#### WE'RE IN THIS TOGETHER at a glance\n##### Typical duration: 1 hour\nIn this level, Apprentices will:\n* Sing the Emergency Preparedness Squad Theme Song.\n* Report back on their Get a Kit at-home mission.\n* Play a game show which engages them on being good community members during an emergency.\n* Receive individual participation and winning team certificates.\n* Celebrate their achievements during the program!\n\n#### Key Vocabulary\n* Community\n\n# Materials\n\n#### What you need for this level\n* Mission Files\n* Completion certificates for each Apprentice in [{r/Canada:colour}{r/:color}](Printables_Completion_Certificates_Colour.pdf) or [black & white](Printables_Completion_Certificates_BW.pdf).\n* Once you know which team has earned the most points, you can print a Winning Team Certificate in [{r/Canada:colour}{r/:color}](Printables_Winning_Certificates_Colour.pdf) or [black & white](Printables_Winning_Certificates_BW.pdf) to post on your classroom wall after the lesson.\n"

/***/ }),
/* 1627 */
/***/ (function(module, exports) {

	module.exports = "# Tech Prep Wizard\n\n### Tech Prep Wizard\n\nThis short wizard will help you get set up to run the Academy in your classroom.\n\nDon't show your students the screen yet!\n\nClick the arrow or use your keyboard's right directional arrow to move through the wizard.\n\n# Two Device Intro\n\n### Two Device Experience\nThe Academy is best experienced using two devices:\n* Main device (COMPUTER or TABLET) projects the website at the front of the class.\n* Second device (TABLET or CELLPHONE) can be as a remote control (optional):\n  * gives you freedom to move around the classroom.\n  * contains prompts and facilitation notes at your finger tips.\n  * provides useful progress indicators, such as length of videos and number of slides remaining.\n\n# Connecting Remote\n\n### Connect your remote!\nTo connect a second device as a Remote Control:\n1. Go to www.remote4ppa.com on your tablet/phone.\n2. Enter your username and password on your tablet/phone.\n3. Go to the next slide to Select Role For This Device.\n4. Choose the right Role for each device.\n5. Your selections will be saved for future use, but you can always change it later!\n\n# Tech Check Intro\n\n### Tech Check!\nNOW PLEASE hook up your main device to your projector and **test the audio/video** to make sure everything's working! There's a fun video in the next slide to help you do this (it's also in the Fun section if you want to share with your class).\n\n#### Full Screen Experience\nThe Planet Protector Academy is best enjoyed as a full screen experience. **Click 'View'** in your browser's menu bar, and select **'Full Screen'** (Chrome) or **'Enter Full Screen'** (Safari/Firefox).\n\n# Tech Check Video\nYouTube: ZVdMndkjaIo\n"

/***/ }),
/* 1628 */
/***/ (function(module, exports) {

	module.exports = "# Program Start\n\n# Level 1 Start\n\n## Notes\n\n### Start\n\nShow this screen at the start of class. When the kids are ready, advance to the next screen.\n\nUse the directional arrows on your remote to go forwards/backwards through the level.\n\n# Level 1 Icon\n\n## Notes\n\nKnow the Risks\n\n### Tracking your progress\n\nYou can see how far along you are by the slide number on the top of your Remote Control or by the blue progress bar running along the bottom of the Menu on the Classroom Display.\n\n# Level 1 Intro\n\nYouTube: iUfUibFjjaU\n\n## Notes\n\nSara and Ian welcome the students to the Emergency Preparedness Squad program (2:38).\n\n# Level 2 Start\n\n## Notes\n\n### Start\n\nShow this screen at the start of class. When the kids are ready, advance to the next screen.\n\nUse the directional arrows on your remote to go forwards/backwards through the level.\n\n# Level 2 Icon\n\n## Notes\n\nMake a Plan\n\n# Level 2 Intro\n\nYouTube: Jqt2vQvCcD4\n\n## Notes\n\nSara and Ian welcome the students back to the program (0:39).\n\n### Problems with your video buffering?\nPause the video and wait a minute for it to pre-load, then it should play without a hitch!\n\n# Level 3 Start\n\n## Notes\n\n### Start\n\nShow this screen at the start of class. When the kids are ready, advance to the next screen.\n\n# Level 3 Icon\n\n## Notes\n\nGet a Kit\n\n# Level 3 Intro\n\nYouTube: O4Qx3wGyCWA\n\n## Notes\n\nSara and Ian welcome the students back to the program (0:15).\n\n# Level 4 Start\n\n## Notes\n\n### Start\n\nShow this screen at the start of class. When the kids are ready, advance to the next screen.\n\n# Level 4 Icon\n\n## Notes\n\nWe're In This Together\n"

/***/ }),
/* 1629 */
/***/ (function(module, exports) {

	module.exports = "# Song\nYouTube: fB3ZHt6aYJ8\n\n## Notes\n\n### Emergency Preparedness Squad Song\n\nEncourage your class to learn this song and sing along to the video (2:21).\n\n### Extension Activities\nApprentices can perform the song to the whole school and/or create their own choreography.\n"

/***/ }),
/* 1630 */
/***/ (function(module, exports) {

	module.exports = "Team Creation\n\n# Intro Team Names\n\nYouTube: fKpu_L5XHz8\n\n## Notes\nSara and Ian introduce themselves and tell Apprentices to get into teams (1:20).\n\n# Get Into Teams\n\n## Content\n\n###### Get into four teams!\n\nName your teams in the next slide.\n\n## Notes\n\nName teams in the next slide. Once you enter the name in the text field, it automatically saves!\n\n# Scoring Intro\n\n## Content\n\n### Here's how your team can score points\n\n* Answer questions\n* Do activities\n* Complete missions\n* Work well together (teamwork points)\n* and more!\n\n## Notes\n\n### Scoring\n* Teams can earn points for most activities in the program. You can allocate points as you see fit. Maximum points total is 999.\n* Individuals can earn points for teams, or teams can earn points together.\n* Teamwork points are critical to ensure collaboration.\n* Points can also be a classroom \"currency\", e.g.to gain classroom privileges.\n* The team with the most points at the end of Level 4 is the winner.\n\n# Scoreboard Intro\n\n## Content\n\n### Check out the scoreboard!\n\n(In the top left corner, click MENU and then SCORES)\n\nYour teams are now ready to start scoring points!\n\n## Notes\n\nClick on the 'Scoreboard' icon on your remote at any time to bring down the scoreboard and add points for teams.\n\n# Congratulations\n\n## Content\n\n### Congratulations!\n\n#### You're now Apprentices in the Emergency Preparedness Squad!\n\n## Notes\n\n&nbsp;\n"

/***/ }),
/* 1631 */
/***/ (function(module, exports) {

	module.exports = "# Esmeralda and Goober Intro\n\nYouTube: BSMdUUViT94\n\n## Notes\nIan and Sara introduce the Esmeralda and Goober storyline (0:42).\n\n# Esmeralda and Goober Story\n\nYouTube: vY9c9oatHDw\n\n## Notes\nEsmeralda and Goober storyline - Know the Risks (3:43).\n"

/***/ }),
/* 1632 */
/***/ (function(module, exports) {

	module.exports = "# Esmeralda and Goober Story\n\nYouTube: i6c_oeWPDxg\n\n## Notes\nEsmeralda and Goober storyline - Make a Plan (1:47).\n\n# Calming Breath Intro\n\nYouTube: bDy55oVYj00\n\n## Notes\nSara and Ian help Apprentices practice the Superhero Calming Breath (0:49).\n"

/***/ }),
/* 1633 */
/***/ (function(module, exports) {

	module.exports = "# Sharknado\n\nYouTube: _JRlG-5_7ic\n\n## Notes\n\nSara and Ian share what should go in your Apprentices' emergency kits (4:16).\n\n# Calming Breath Recap\n\nYouTube: nUGO4-S_I5w\n\n## Notes\n\nPractice the Superhero Calming Breath! (0:36).\n\n# Esmeralda and Goober Story\n\nYouTube: 5FvPTip5iI4\n\n## Notes\nEsmeralda and Goober storyline - Get a Kit (2:37).\n"

/***/ }),
/* 1634 */
/***/ (function(module, exports) {

	module.exports = "# Esmeralda and Goober Story\n\nYouTube: Ka3bcyUj6TU\n\n## Notes\nEsmeralda and Goober storyline wrap-up (2:19).\n"

/***/ }),
/* 1635 */
/***/ (function(module, exports) {

	module.exports = "# Mission Report\nTitle: Know the Risks\n\n# Scoring\n\n## Content\n\n### Count your mission points!\n\n* Turn to Level 1 - Know the Risks in your Mission Files.\n* Teams get one point for each team member that talked with their families.\n* Make sure your points get added onto the Scoreboard!\n\n## Notes\n\n&nbsp;\n\n# Instructions\n\n## Content\n\n### Time to report to HQ!\n\n* Answer with a show of hands.\n* Teachers can report too!\n\n## Notes\n\n### Mission Reports\n* Mission reports help us communicate the impact of our program. Thanks for helping us to measure it!\n* Using a show of hands keeps the data anonymous.\n\n# Questions\n\n## Content\n\n1. Number of Apprentices and Teachers reporting in.\n2. I talked with my family about the Top Ten Emergencies.\n3. I've used the Superhero Calming Breath to help me feel calm.\n4. How many Apprentices are having fun with this program?\n\n# Impact\n\n## Content\n\n### Awesome work, Apprentices!\n\nYour Mission Report was received by Emergency Preparedness Squad HQ.\n\n## Notes\n\nGreat job!\n\n# Class Discussion\n\n## Content\n\n### Class Discussion\n* As a class, discuss what was easy or hard about this mission.\n* What worked, what didn’t work?\n* What would make it easier?\n\n## Notes\n\nEncourage Apprentices who did not succeed to keep trying, if appropriate.\n"

/***/ }),
/* 1636 */
/***/ (function(module, exports) {

	module.exports = "# Mission Report\nTitle: Make a Plan\n\n# Scoring\n\n## Content\n\n### Get points for your missions!\n\n* Turn to Level 2 - Make a Plan in your Mission Files.\n* In your teams, count the total number of points you scored.\n* Make sure your points get added onto the Scoreboard!\n\n## Notes\n\nThis slide only covers actions listed under 'Get a point for' for each mission.\nStudents report the Mission Report section next.\n\n# Instructions\n\n## Content\n\n### Time to report to HQ!\n\n* Answer with a show of hands.\n* Teachers can report too!\n\n## Notes\n\n### Mission Reports\n* Mission reports help us communicate the impact of our program. Thanks for helping us to measure it!\n* Using a show of hands keeps the data anonymous.\n\n# Questions\n\n## Content\n\n1. Number of Apprentices and Teachers reporting in.\n2. +My family filled out an emergency plan.\n3. +My family started filling out a plan but didn't finish.\n4. +My family hasn't made an emergency plan YET, but we pledge to soon.\n5. +My family didn't make an emergency plan and aren't likely to.\n6. How many Apprentices feel like real-life Emergency Preparedness Squad superheroes now?\n\n# Impact\n\n## Content\n\n### Awesome work, Apprentices!\n\nYour Mission Report was received by Emergency Preparedness Squad HQ.\n\n## Notes\n\nGreat job!\n\n# Class Discussion\n\n## Content\n\n### Class Discussion\n* As a class, discuss what was easy or hard about this mission.\n* What worked, what didn’t work?\n* What would make it easier?\n\n## Notes\n\nEncourage Apprentices who did not succeed to keep trying, if appropriate.\n"

/***/ }),
/* 1637 */
/***/ (function(module, exports) {

	module.exports = "# Mission Report\nTitle: Get a Kit\n\n# Intro Video\nYouTube: oQiZTpCPDM4\n\n## Notes\n\nSara and Ian introduce the mission report for Get a Kit (3:04).\n\n# Scoring\n\n## Content\n\n### Get points for your missions!\n\n* Turn to Level 3 - Get a Kit in your Mission Files.\n* In your teams, count the total number of points you scored.\n* Make sure your points get added onto the Scoreboard!\n\n## Notes\n\nThis slide only covers actions listed under 'Get a point for' for each mission.\nStudents report the Mission Report section next.\n\n# Instructions\n\n## Content\n\n### Time to report to HQ!\n\n* Answer with a show of hands.\n* Teachers can report too!\n\n## Notes\n\n### Mission Reports\n* Mission reports help us communicate the impact of our program. Thanks for helping us to measure it!\n* Using a show of hands keeps the data anonymous.\n\n# Questions\n\n## Content\n\n1. Number of Apprentices and Teachers reporting in.\n2. +My family started putting together our kit.\n3. +My family hasn't started our kit YET but we pledge to do it soon.\n4. +My family didn't make an emergency kit and aren't likely to.\n5. How many Apprentices pledge to be Emergency Preparedness Squad superheroes from now on?\n6. My family succeeded in at least one mission during the program.\n\n# Impact\n\n## Content\n\n### Awesome work, Apprentices!\n\nYour Mission Report was received by Emergency Preparedness Squad HQ.\n\n## Notes\n\nGreat job!\n\n# Class Discussion\n\n## Content\n\n### Class Discussion\n* As a class, discuss what was easy or hard about this mission.\n* What worked, what didn’t work?\n* What would make it easier?\n\n## Notes\n\nEncourage apprentices who did not succeed to keep trying, if appropriate.\n"

/***/ }),
/* 1638 */
/***/ (function(module, exports) {

	module.exports = "# Game Show\n\nLevel 1 - Know the Risks\n\n# Intro Video\n\nYouTube: jZHHVq_xOvM\n\n## Notes\n\nSara and Ian introduce the Game Show (2:10).\n\n\n# Sizzle\n\n## Notes\n\n&nbsp;\n\n\n# Scoring\n\n## Content\n\n### How to score points\n* Do your Superhero pose.\n* Buzz in first.\n* Give a good answer. Try your best!\n* If you don’t know the answer, think about what a good answer might be. This is not a test!\n\n## Notes\n\n&nbsp;\n\n\n# Four Players Announcement\n\n## Notes\n\n&nbsp;\n\n\n# Question 1\n\n## Question\n\n#### What kind of things can happen in an earthquake?\n\n## Answer\n\n### Some risks from earthquakes:\n* Property damage\n* Roads closed\n* Natural gas leak\n* Shaking around\n* Falling objects in buildings\n* Broken windows\n* Power outage\n\n## Answer Notes\n\n&nbsp;\n\n# Scoring Reminder\n\n## Content\n\n### Don't forget to add scores!\n\n## Notes\n\nClick on the 'Scores' button below to open up the Scoreboard.\n\n\n# Question 2\n\n## Question\n\n#### What kind of things can happen in a windstorm?\n\n## Answer\n\n### Some risks from windstorms:\n* Trees/branches falling\n* Power outage\n* Property damage\n* Roads blocked\n\n## Answer Notes\n\n&nbsp;\n\n\n# Question 3\n\n## Question\n\n#### What kind of things can happen in a power outage?\n\n## Answer\n\n### Some risks from power outages:\n* No electricity or lights\n* No heat if electric\n* No street lights or traffic lights\n* Internet probably won't work\n* Fresh food will go bad in the fridge\n\n## Answer Notes\n\n&nbsp;\n"

/***/ }),
/* 1639 */
/***/ (function(module, exports) {

	module.exports = "Level 2 - Make a Plan\n\n# Intro Video\n\nYouTube: 6a5nxfJ3UB8\n\n## Notes\n\nSara and Ian introduce the Game Show (2:38).\n\n# Sizzle\n\n## Notes\n\n### Game Show\nIn the Game Show we ask questions relating to the topic *before* giving the answers, in order to stimulate thinking, rather than to test knowledge.\n\nOne Apprentice from each team will come up to the front of the class and get a chance to answer the question in turn.\n\nFor more info, see \"Game Show Info\" in the Teachers Guide, which is available in the Teacher Resources section on the Dashboard page.\n\n# Scoring\n\n## Content\n\n### How to score points\n* Do your Superhero pose.\n* Buzz in first.\n* Give a good answer. Try your best!\n* If you don’t know the answer, think about what a good answer might be. This is not a test!\n\n## Notes\n\nDon't forget to score points on the Scoreboard!\n\n# Four Players Announcement\n\n## Notes\n\n* One Apprentice from each team comes to the front of the room.\n* Encourage a different Apprentice to come up for each question.\n\n# Question 1\n\n## Question\n\n#### Name some things you could plan e.g. a party\n\n## Answer\n\n### Some things you could plan:\n* Party\n* Trip\n* Class\n* Making a video\n* How you'll study for a test\n* A neighbourhood hockey game\n\n## Answer Notes\n\n&nbsp;\n\n# Scoring Reminder\n\n## Content\n\n### Don't forget to add scores!\n\n## Notes\n\nClick on the 'Scores' button below to open up the Scoreboard.\n\n# Question 2\n\n## Question\n\n#### What do you think is the goal of an emergency plan? Why do we need one?\n\n## Answer\n\n### Goal is safety and well-being:\n* So we think about what we’ll need to do ahead of time.\n* So we’ll feel more prepared and safe.\n* So we have all our information together.\n* So we know what to do.\n\n## Answer Notes\n\n&nbsp;\n\n# Question 3\n\n## Question\n\n#### Team brainstorm - What are some things that should be included in an emergency plan?\n\n## Answer\n\n### Some things that should be in an emergency plan:\n* Where to meet your family.\n* How to contact your family.\n* What to do if you're in different places (work/home/play).\n* Plan for your pets.\n* Special needs concerns.\n* Emergency contact info.\n\n## Answer Notes\n\n&nbsp;\n"

/***/ }),
/* 1640 */
/***/ (function(module, exports) {

	module.exports = "Level 3 - Get a Kit\n\n# Intro Video\n\nYouTube: OpmtyG62cn4\n\n## Notes\n\nSara and Ian introduce the Game Show (0:29).\n\n# Sizzle\n\n## Notes\n\nGame Show\n\n# Scoring\n\n## Content\n\n### Reminder:\n* Do your Superhero pose.\n* Buzz in first.\n* Give a good answer.\n\n## Notes\n\nDon't forget to score points on the Scoreboard!\n\n# Four Players Announcement\n\n## Notes\n\nFour players to the front.\n\n# Question 1\n\n## Question\n\n#### What do you think an emergency prep kit is for?\n\n## Answer\n\n### An emergency preparedness kit is so you can:\n* Have something to eat\n* Have water to drink\n* Stay safe and warm\n* Get important news\n\n## Answer Notes\n\n&nbsp;\n\n# Scoring Reminder\n\n## Content\n\n### Don't forget to add scores!\n\n## Notes\n\nClick on the 'Scores' button below to open up the Scoreboard.\n\n# Question 2\n\n## Question\n\n#### Name a good place to keep your emergency kit in your home.\n\n## Answer\n\n### Some places to keep your kit:\n* Near the door\n* In a bag you can grab and go\n* Make sure everyone in your family knows where it's stored!\n\n## Answer Notes\n\n&nbsp;\n\n# Question 3\n\n## Question\n\n#### Team brainstorm - write down as many things as you can that should probably go in your kit.\nScoring: If you got ten or items or more, get ten points. No peeking in your Mission Files!\n\n## Answer\n\n### Things you can put in your kit:\n* Food\n* Water (nonperishable)\n* Flashlight\n* Medication + glasses\n* Extra clothes\n* Picture / letter from parents\n* Copy of plan, incl contact info and safe meeting place\n\n## Answer Notes\n\n&nbsp;\n"

/***/ }),
/* 1641 */
/***/ (function(module, exports) {

	module.exports = "Level 4 - We're In This Together\n\n# Intro Video\n\nYouTube: mXdAKK3NAmE\n\n## Notes\n\nSara and Ian introduce the Game Show (0:47).\n\n# Sizzle\n\n## Notes\n\nGame Show\n\n# Four Players Announcement\n\n## Notes\n\nFour players to the front.\n\n# Question 1\n\n## Question\n\n#### Who are the people most likely to help you in an emergency?\n\n## Answer\n\n### Some people who are likely to help you:\n* Your friends\n* Your family\n* Teachers\n* Neighbours\n\n## Answer Notes\n\n&nbsp;\n\n# Question 2\n\n## Question\n\n#### Why aren't the police and fire fighters the ones likely to help?\n\n## Answer\n\n#### They will be busy saving lives, where they can do the most good.\n\n## Answer Notes\n\n&nbsp;\n\n# Question 3\n\n## Question Intro\n\n#### When should you call 911?\nMultiple choice - see next slide!\n\n## Question\n(a) to ask if an earthquake just happened\n\n(b) to tell them an earthquake just happened\n\n(c) if someone's life is in danger\n\n(d) if a gas main broke\n\n## Answer\n\n#### The answer is: (c) + (d)\nDon't call 911 unless someone's life is in danger.\n\n## Answer Notes\n\n&nbsp;\n"

/***/ }),
/* 1642 */
/***/ (function(module, exports) {

	module.exports = "List Emergencies\n\n# Intro Video\n\nYouTube: _aGQS4IvHic\n\n## Notes\n\nSara and Ian practice the Superhero Calming Breath and introduce the Top Ten Emergencies brainstorming activity (1:44).\n\n# Sizzle\n\n## Content\n\n### Activity: Brainstorm!\n\n## Notes\n&nbsp;\n\n# Instructions\n\n## Content\n\n### Activity Instructions:\n* Make a list of possible emergencies in your region:\n  * As a team, make a list of as many emergencies as you can.\n  * Points for good answers, number of answers, good {r/Canada:behaviour}{r/:behavior}\n  * 3 minutes!\n\n## Notes\n\n&nbsp;\n\n# Time Up\n\nYouTube: GGsuC2gFtyk\n\n## Notes\n\nSara and Ian tell your class to share their answers (0:23).\n\n# How To Get Points\n\n## Content\n\n### How to get points\n  * 2 points if your item is on the list.\n  * 1 point if not on the list but teacher says it's a legit emergency.\n  * Minus 1 point for cheeky monkey answers.\n\n## Notes\n\n&nbsp;\n\n# Share Answers\n\n## Content\n\n### Share your answers\n1 person from each team read your list.\n\n## Notes\n\n&nbsp;\n\n# Top Ten Emergencies\n\n## Content\n\n### Top Ten Emergencies:\n#### Earthquakes, Avalanches, Wildfires\n#### Disease Outbreak, Landslides, Tsunamis\n#### Power Outages, Hazardous Material Spills\n#### Severe Weather, Floods\n\n## Notes\n\n&nbsp;\n\n# Points Reminder\n\n## Content\n\n### Don't forget to add scores!\n\n## Notes\n\n&nbsp;\n\n# Act Out Emergencies\n\nYouTube: Y4_2TaxVFjw\n\n## Notes\n\nSara and Ian act out the Top Ten Emergencies (1:24).\n"

/***/ }),
/* 1643 */
/***/ (function(module, exports) {

	module.exports = "Group Drawing\n\n# Intro Video\n\nYouTube: B779gOrzCuk\n\n## Notes\n\nSara and Ian introduce the importance of being prepared for the first 72hrs. They also introduce the first part of making an emergency plan (1:18).\n\n# Sizzle\n\n## Content\n\n### Activity 1: Drawing!\n\n## Notes\nActivity instructions on next slide.\n\n# Instructions\n\n## Content\n\n### Activity Instructions:\n* Draw a floorplan of one room in your home.\n* Plan emergency exits from one room of your home.\n  * Try to think of two possibilities.\n  * If you live in an apartment, do not plan to use the elevators.\n* Two points for the drawing.\n* One point for getting your parent/guardian to sign the natural gas safety info in your Mission Files!\n\n## Notes\n\n&nbsp;\n"

/***/ }),
/* 1644 */
/***/ (function(module, exports) {

	module.exports = "# Intro Video\n\nYouTube: anIbh_g5Tu4\n\n## Notes\nIntro to rap activity (1:20).\n\n# Sizzle\n\n## Content\n\n### Activity 1: Write a rap!\n\n(Younger grades can write a poem instead)\n\n## Notes\n\nActivity instructions on next slide.\n\n# Instructions\n\n## Content\n\n### Activity Instructions:\n* Write a rap about things you’ll need in your kit - at least two items.\n* Write two lines, where the last word in each line rhymes.\n* Your Mission Files has sample rhymes, but get bonus points for using words that aren't in the booklet.\n* If you're writing a rap, {r/Canada:practise}{r/:practice} in your teams with the backing track on the next slide.\n\n## Notes\n\nThere is a worksheet in the Mission File for this activity.\n\n# Rap Backtrack Practice\n\nYouTube: eEzxxHgcpzE\n\n## Notes\n\nTo get the backtrack (10:07) to repeat, just press play again.\n\n# Scoring\n\n## Content\n\n### Now perform for the class!\n\n#### Get points for:\n* Two lines that rhyme.\n* Good performance.\n* Beatboxing (if you're rapping).\n* Being a good audience.\n\n## Notes\n\n### Extension Activity\nVideo your raps and submit them to our website!\n\n# Rap Backtrack Perform\nYouTube: eEzxxHgcpzE\n\n## Notes\n\nTo get the backtrack to repeat, just press play again.\n"

/***/ }),
/* 1645 */
/***/ (function(module, exports) {

	module.exports = "# Intro Video  \n\nYouTube: 0MKIR2myq7U\n\n## Notes\nSara and Ian introduce the Drawing activity (1:21).\n\n# Sizzle\n\n## Content\n\n### Activity 1: Drawing!\n\n## Notes\n\n&nbsp;\n\n# Instructions\n\n## Content\n\n### Activity Instructions:\n* Draw a picture of the people you might be with in an emergency.\n* Points for trying your best!\n\n## Notes\n\n&nbsp;\n"

/***/ }),
/* 1646 */
/***/ (function(module, exports) {

	module.exports = "# Mission Assignment\n\nTitle: Know the Risks\n\n## Notes\n&nbsp;\n\n# Mission Intro Video\n\nYouTube: p_xHSeWJUOA\n\n## Notes\n\nIan and Sara introduce Mission 1 - Know the Risks (1:23).\n\n### Make a Plan\n* Apprentices turn to Mission 1 in their Mission Files.\n* Decide which day you will do the next Level.\n* Apprentices write that date on the cover of their Mission Files and on the Mission 1 page.\n* Points are awarded for signed and returned Mission 1 page.\n\n# Instructions\n\n## Content\n\n### Mission 1:\n\n#### Know the Risks\n* Tell your family about the Top Ten Emergencies\n* Practice the Superhero Calming Breath\n* Get your Mission File signed by your parent/guardian.\n\n## Notes\n\n&nbsp;\n"

/***/ }),
/* 1647 */
/***/ (function(module, exports) {

	module.exports = "# Mission Assignment\n\nTitle: Make a Plan\n\n## Notes\n&nbsp;\n\n# Mission Intro Video\n\nYouTube: F8mHgZSKa1s\n\n## Notes\n\nIan and Sara introduce Mission 2 - Make a Plan (2:01).\n\n### Make a Plan\n* Apprentices turn to Mission 2 in their Mission Files.\n* Decide which day you will do the next Level.\n* Apprentices write that date on the cover of their Mission Files and on the Mission 2 page.\n* Points are awarded for signed and returned Mission 2 page.\n\n# Instructions\n\n## Content\n\n### Mission 2:\n\n#### Making a plan\n* Get your family to make a plan!\n* With the adults in your family, fill out the plan in your Mission Files.\n* Make copies of the plan and store it in safe places.\n* Get your Mission File signed by your parent/guardian.\n\n## Notes\n\n&nbsp;\n"

/***/ }),
/* 1648 */
/***/ (function(module, exports) {

	module.exports = "# Mission Assignment\n\nTitle: Get a Kit\n\n## Notes\n&nbsp;\n\n# Mission Intro Video\n\nYouTube: AsQU_9j_eyo\n\n## Notes\n\nIan and Sara introduce Mission 3 - Get a Kit (1:43).\n\n### Make a Plan\n* Apprentices turn to Mission 3 in their Mission Files.\n* Decide which day you will do the next Level.\n* Apprentices write that date on the cover of their Mission Files and on the Mission 3 page.\n* Points are awarded for signed and returned Mission 3 page.\n\n# Instructions\n\n## Content\n\n### Mission 3:\n\n#### Get a kit\n* Get your family to make a kit!\n* One point for each item in your kit.\n* Do the puzzle to get bonus points.\n* Get your Mission File signed by your parent/guardian.\n\n## Notes\n\n&nbsp;\n"

/***/ }),
/* 1649 */
/***/ (function(module, exports) {

	module.exports = "# Mission Assignment\n\nTitle: Keep Building Your Kit\n\n## Notes\n&nbsp;\n\n# Mission Intro Video\n\nYouTube: 86B6X8UUbkg\n\n## Notes\n\nIan and Sara introduce Mission 4 - We're In This Together (2:47).\n\n# Instructions\n\n## Content\n\n### Mission 4:\n\n#### Keep getting more prepared!\n* Keep building your kit!\n* Talk with friends and family about emergency preparedness.\n* Keep practising your Superhero Calming Breath!\n\n## Notes\n\n&nbsp;\n"

/***/ }),
/* 1650 */
/***/ (function(module, exports) {

	module.exports = "Finish\n\n# Outtakes 1\n\nYouTube: m0Zkh5kx3sQ\n\n## Notes\n\nOuttakes fun with Ian & Sara (1:16).\n\n# Outtakes 2\n\nYouTube: xj0mgAqAyqw\n\n## Notes\n\nMore outtakes fun with Ian & Sara (0:48).\n\n# Scoreboard Recap\n\n## Content\n\n### Check out the scoreboard to see who's in the lead!\n\n## Notes\n\n&nbsp;\n\n# Earn More Points\n\n## Content\n\n### Everyone has a chance to earn more points!\n* Take home your Mission Files.\n* Do your missions and record what you did.\n* Listen & participate in class!\n\n## Notes\n\n&nbsp;\n\n# Farewell\n\n## Content\n\n### Keep the fun going!\n\n#### Visit *AndGoober.com* for games and activities\n\nGo to the next slide to finish the level\n\n## Notes\nTo finish, go to the next slide and click 'Click to end level'.\n"

/***/ }),
/* 1651 */
/***/ (function(module, exports) {

	module.exports = "Ending\n\n# Announce Winners\n\n## Content\n\n### Time to announce the winners!\n\n#### Teachers please hand out certificates.\n\n## Notes\n\nPrint winning team certificates once you know who won; give all team members completion certificates now.\n\n# Members EPS\n\n## Content\n\n### You are all now members of the Emergency Preparedness Squad!\n\n#### Congratulations!\n\n## Notes\n\nThank you for training your Apprentices!\n\n# All Levels Completed\n\n## Notes\n\n&nbsp;\n\n### Getting your feedback\n\nWe love to hear from teachers about their experience with the Academy. We'll be in touch in the next few days with a feedback survey!\n\nHave ideas for extension activities? Please share them with us!\n"

/***/ }),
/* 1652 */
/***/ (function(module, exports) {

	module.exports = "# Extension Activities\n\n#### All levels\n* Planet Protector Academy song\n  * Perform on Earth Day or at another assembly for your school with the karaoke version in the Fun section\n  * We’d love to hear about it or see a video!!\n  * For even more fun, Apprentices can create their own choreography.\n* Useful resources to extend learning:\n  * [Biomimicry Education Network](https://asknature.org/groups/biomimicry-education-network/#.WIy_B7YrI_U)\n  *\t[Center for a New American Dream](https://www.newdream.org/)\n  *\t[Resourceful PDX](http://www.resourcefulpdx.com/)\n\n#### Level 1 - Operation Garbage Watch\n* Mapping garbage\n  * Carry out some research to find out where  garbage goes.\n  * How many miles does it travel to get there?\n  * Draw a map showing the route.\n  * What does it look like? Draw a picture of it.  \n* Drawing joys\n  * Add more joys to your drawing every day for a week.\n  * Act out some of the joys and have other teams guess.\n  * Do an art project to express one particular joy, eg. Do a painting of playing soccer, or make up a song about being in nature.\n\n#### Level 2 - Operation Love Food, Hate Waste\n*\tUse food to explore systems by mapping production, transportation, consumption, disposal\n* Explore how consumer choice affects which product varieties grown and vice verca\n\n#### Level 3 - Operation Food Scraps\n* Setting up a Worm Bin in your classroom\n  * Research what it would take to set up a worm bin in your classroom.\n  * Also research what it would take to create an outdoor composting system for your school.\n  * Based on criteria and constraints, determine which would be best for your classroom/school.\n  * If possible, implement your solution!\n* Send postcards to lobby regional government or thank you to local businesses.\n\n#### Level 4 - Operation Waste-Free Lunch\n* Measure the impact of your Waste-Free Lunch\n  * Starting one week before you have a waste free lunch, keep track of all the stuff you throw away at lunch time (wrappers, cans, plastic food containers, food scraps, etc. measured either by mass or simply listing out what you throw away).\n  * Do the same for a week after you start going waste free.  How much waste did you save?  What would you total waste savings be if you continued going waste free for a whole school year?\n* Analyzing lunches with a systems thinking lense\n  * Think about the systems that are involved in the packaging of our lunches.\n  * Where do we buy these things? Where are they made?\n  * How far did these items have to travel to get to us?\n  * What’s a problem with that?\n* Visualizing collective impact\n  * For a great visualization of collective impact, view one or two of artist Chris Jordan’s \"Running the Numbers\":\n    * A T-Rex showing # of plastic bags used every 10 seconds. [Watch!](http://www.chrisjordan.com/gallery/rtn2/#t-rex)\n    * Plastic bottles used every minute [Watch!](http://www.chrisjordan.com/gallery/rtn/#caps-seurat)\n    * Plastic cups on airlines every hour [Watch!](http://www.chrisjordan.com/gallery/rtn/#plastic-cups)\n\n#### Level 5 - Operation Buy Smart\n* Poster activity\n  * Make a poster showing alternatives to buying things impulsively, and/or that compare and contrast impulse buying with Buy Smart Buying.\n  * Poster to include the pros and cons of each based on a set of criteria.\n"

/***/ }),
/* 1653 */
/***/ (function(module, exports) {

	module.exports = "# Extension Activities\n\n#### All levels\n* Planet Protector Academy song\n  * Perform on Earth Day or at another assembly for your school with the karaoke version in the Fun section\n  * We’d love to hear about it or see a video!!\n  * For even more fun, Apprentices can create their own choreography.\n* Useful resources to extend learning:\n  * [Biomimicry Education Network](https://asknature.org/groups/biomimicry-education-network/#.WIy_B7YrI_U)\n  *\t[Center for a New American Dream](https://www.newdream.org/)\n  *\t[Resourceful PDX](http://www.resourcefulpdx.com/)\n\n#### Level 1 - Operation Garbage Watch\n* Mapping garbage\n  * Carry out some research to find out where  garbage goes.\n  * How many miles does it travel to get there?\n  * Draw a map showing the route.\n  * What does it look like? Draw a picture of it.  \n* Drawing joys\n  * Add more joys to your drawing every day for a week.\n  * Act out some of the joys and have other teams guess.\n  * Do an art project to express one particular joy, eg. Do a painting of playing soccer, or make up a song about being in nature.\n\n#### Level 2 - Operation Love Food, Hate Waste\n*\tUse food to explore systems by mapping production, transportation, consumption, disposal\n* Explore how consumer choice affects which product varieties grown and vice verca\n\n#### Level 3 - Operation Food Scraps\n* Setting up a Worm Bin in your classroom\n  * Research what it would take to set up a worm bin in your classroom.\n  * Also research what it would take to create an outdoor composting system for your school.\n  * Based on criteria and constraints, determine which would be best for your classroom/school.\n  * If possible, implement your solution!\n* Send postcards to lobby regional government or thank you to local businesses.\n\n#### Level 4 - Operation Waste-Free Lunch\n* Measure the impact of your Waste-Free Lunch\n  * Starting one week before you have a waste free lunch, keep track of all the stuff you throw away at lunch time (wrappers, cans, plastic food containers, food scraps, etc. measured either by mass or simply listing out what you throw away).\n  * Do the same for a week after you start going waste free.  How much waste did you save?  What would you total waste savings be if you continued going waste free for a whole school year?\n* Analyzing lunches with a systems thinking lense\n  * Think about the systems that are involved in the packaging of our lunches.\n  * Where do we buy these things? Where are they made?\n  * How far did these items have to travel to get to us?\n  * What’s a problem with that?\n* Visualizing collective impact\n  * For a great visualization of collective impact, view one or two of artist Chris Jordan’s \"Running the Numbers\":\n    * A T-Rex showing # of plastic bags used every 10 seconds. [Watch!](http://www.chrisjordan.com/gallery/rtn2/#t-rex)\n    * Plastic bottles used every minute [Watch!](http://www.chrisjordan.com/gallery/rtn/#caps-seurat)\n    * Plastic cups on airlines every hour [Watch!](http://www.chrisjordan.com/gallery/rtn/#plastic-cups)\n\n#### Level 5 - Operation Buy Smart\n* Poster activity\n  * Make a poster showing alternatives to buying things impulsively, and/or that compare and contrast impulse buying with Buy Smart Buying.\n  * Poster to include the pros and cons of each based on a set of criteria.\n"

/***/ }),
/* 1654 */
/***/ (function(module, exports) {

	module.exports = "# Planet Protector Academy Theme Song\n\nYouTube: ulOo2VuQEWA\n\n## Description\n\nSing and dance along to the Academy's theme song anytime you like. Great for starting a lesson!\n\n\n# Esmeralda Planet Protector & The E-Waste Emergency\n\nYouTube: POzKQKxvuzQ\nLowRes: true\n\n## Description\n\nWatch Esmeralda and Goober fight the rise of electronic waste and the evil supervillain Blaster, with some help from our our Planet Protector friends!\n\n\n# Esmeralda Planet Protector & The Litterless Lunch\n\nYouTube: OeT53lGAYX4\nLowRes: true\n\n## Description\n\nEsmeralda and Goober take on Trashella to stop her from convincing kid to bring lunches that make litter!\n\n\n# Esmeralda Planet Protector & Walking To School\n\nYouTube: 1FmXmBOU-V8\nLowRes: true\n\n## Description\n\nCan Esmeralda Superspy Planet Protector and her sidekick Goober stop the Evil Dr. Carbon's dastardly plan to stop kids from walking to school?\n\n\n# Esmeralda Superspy: Backstage #1\n\nYouTube: BQyzd8Y7EaY\nLowRes: true\n\n## Description\n\nDo series stars Ian and Sara spend their time saving the environment and protecting the planet? No, because Ian keeps acting like a monkey! Even when the boss, Jacqueline, is around.\n\n\n# Esmeralda Superspy: Backstage #2\n\nYouTube: AEmVWqAie6s\nLowRes: true\n\n## Description\n\nTake a peak behind the scenes! Sara takes you on a tour of the set - or at least, she tries to. Ian keeps messing up her shots!\n\n\n# Esmeralda Superspy: Backstage #3\n\nYouTube: zZId4Rr2-Rw\nLowRes: true\n\n## Description\n\nIan thinks he's doing a safety speech for the funny environmental show \"Esmeralda Superspy\" but really, Sara is about to get her revenge on him for wrecking her scenes.\n\n\n# Good Green News: Vancouver Urban Gardens\n\nYouTube: dPD3BogYAKw\nLowRes: true\n\n## Description\n\nKid reporter Tia, 9, reports on the Good Green News in the city of Vancouver - Find out why Vancouver helped bring over 400 urban gardens to the city!\n"

/***/ }),
/* 1655 */
/***/ (function(module, exports) {

	module.exports = "# Planet Protector Academy Theme Song\n\nYouTube: ulOo2VuQEWA\n\n## Description\n\nSing and dance along to the Academy's theme song anytime you like. Great for starting a lesson!\n\n\n# Esmeralda Planet Protector & The E-Waste Emergency\n\nYouTube: POzKQKxvuzQ\nLowRes: true\n\n## Description\n\nWatch Esmeralda and Goober fight the rise of electronic waste and the evil supervillain Blaster, with some help from our our Planet Protector friends!\n\n\n# Esmeralda Planet Protector & The Litterless Lunch\n\nYouTube: OeT53lGAYX4\nLowRes: true\n\n## Description\n\nEsmeralda and Goober take on Trashella to stop her from convincing kid to bring lunches that make litter!\n\n\n# Esmeralda Planet Protector & Walking To School\n\nYouTube: 1FmXmBOU-V8\nLowRes: true\n\n## Description\n\nCan Esmeralda Superspy Planet Protector and her sidekick Goober stop the Evil Dr. Carbon's dastardly plan to stop kids from walking to school?\n\n\n# Esmeralda Superspy: Backstage #1\n\nYouTube: BQyzd8Y7EaY\nLowRes: true\n\n## Description\n\nDo series stars Ian and Sara spend their time saving the environment and protecting the planet? No, because Ian keeps acting like a monkey! Even when the boss, Jacqueline, is around.\n\n\n# Esmeralda Superspy: Backstage #2\n\nYouTube: AEmVWqAie6s\nLowRes: true\n\n## Description\n\nTake a peak behind the scenes! Sara takes you on a tour of the set - or at least, she tries to. Ian keeps messing up her shots!\n\n\n# Esmeralda Superspy: Backstage #3\n\nYouTube: zZId4Rr2-Rw\nLowRes: true\n\n## Description\n\nIan thinks he's doing a safety speech for the funny environmental show \"Esmeralda Superspy\" but really, Sara is about to get her revenge on him for wrecking her scenes.\n\n\n# Good Green News: Vancouver Urban Gardens\n\nYouTube: dPD3BogYAKw\nLowRes: true\n\n## Description\n\nKid reporter Tia, 9, reports on the Good Green News in the city of Vancouver - Find out why Vancouver helped bring over 400 urban gardens to the city!\n"

/***/ }),
/* 1656 */
/***/ (function(module, exports) {

	module.exports = "# Title - Short\n\nH2OHHH!\n\n# Title - Long\n\nH2OHHH!\n\n# Description - Short\n\nH2OHHH! motive les élèves à devenir des superhéros pour l'eau et aide leur famille à conserver et à protéger ces précieuses ressources!\n\n# Description - Long\n\nH2OHHH! motive les élèves à devenir des superhéros pour l'eau et aide leur famille à conserver et à protéger ces précieuses ressources!\n\n# Description - Levels\n\n**Modules include:**\n\n* Une seule eau\n* Économiser l'eau\n* Protéger l'eau\n* Se connecter à son milieu\n\n# Level 1\nTitle: Une Eau\nDescription: *L'aventure commence! Comment sommes-nous liés à l'eau?* On explore les multiples façons d'utiliser et de jouir de l'eau. Grâce à la communauté autochtone Tsleil Waututh, on comprend qu'en prenant soin de l'eau, on prend soin de tout ce qui y vit et en dépend, comme le saumon. On prend l'habitude d'être reconnaissant pour l'eau. Objectif de la première mission : fermer les robinets.\n\n# Level 2\nTitle: Économiser l'eau\nDescription: *Comment l'eau se rend-elle à nos robinets? Comment l'eau potable est-elle nettoyée?* On en apprend sur le cycle de l'eau et sur les moyens de conserver notre précieuse eau potable. On fait la rencontre de Josephine Mandamin, une aînée Anishinaabe, qui a fait le tour des Grands Lacs à pieds pour inspirer des millions à prendre soin de l'eau. Charge de la Mission 2 : économiser l'eau.\n\n# Level 3\nTitle: Protéger l'eau\nDescription: *Comment l'eau devient-elle polluée? Pourquoi la propreté de l'eau est-elle importante?* On en apprend sur les moyens de protéger l'eau, particulièrement sur les façons dont les fermiers autochtones dans le sud de Bélize assurent la propreté de leurs ruisseaux et rivières pour pouvoir utiliser l'eau pour leurs cultures. On met nos connaissances en pratique avec la Mission 3 : protéger l'eau.\n\n# Level 4\nTitle: Se connecter à son milieu\nDescription: *Comment l'eau fait-elle partie de notre milieu de vie?* On apprend quels types de sources d'eau naturelles se retrouvent près de notre école/maison. On découvre une communauté autochtone de l'Arizona qui a planté une forêt pour nettoyer une rivière polluée. On conclue et on célèbre!\n"

/***/ }),
/* 1657 */
/***/ (function(module, exports) {

	module.exports = "# Title - Short\n\nH2WHOA!\n\n# Title - Long\n\nH2WHOA!\n\n# Description - Short\n\nH2WHOA! inspires kids to become water superheroes and help their families conserve and protect our precious water resources!\n\n# Description - Long\n\nH2WHOA! inspires kids to become water superheroes and help their families conserve and protect our precious water resources!\n\n# Description - Levels\n\n**Modules include:**\n\n* One Water\n* Save Water\n* Protect Water\n* Connect in Place\n\n# Level 1\nTitle: One Water\nDescription: *The adventure begins! How are we connected to water?* Explore how we use and have fun with water. Learn from the Tsleil Waututh First Nation that when we look after water, we look after everything that lives in and depends on water, like salmon. Practicing gratitude for water. First mission assignment: turning off taps.\n\n# Level 2\nTitle: Save Water\nDescription: *How does water reach our taps? How is our drinking water cleaned?* How is our drinking water cleaned? Learn about the Water Cycle and how we can conserve our precious drinking water. Meet Anishinaabe Elder Josephine Mandamin, who walked around the Great Lakes, inspiring millions to care for water. Receive Mission 2: saving water.\n\n# Level 3\nTitle: Protect Water\nDescription: *How does water get polluted?* Why is it important to keep it clean? Learn ways to protect our water, including how Indigenous farmers in southern Belize have a natural way to keep their streams and rivers clean, so they can use the water to grow their crops. Putting learning into practice with Mission 3: protecting water.\n\n# Level 4\nTitle: Connect in Place\nDescription: *How is water part of where I live?* Learn what forms of natural water sources are close to my school/home. Hear about an Indigenous community in Arizona that planted a forest to help clean a polluted river. Program wrap-up and celebration!\n"

/***/ }),
/* 1658 */
/***/ (function(module, exports) {

	module.exports = "# Level Completed\n\n## Content\n\n### Welcome back!\n* Click the MENU button (top left) and use MODULES to go back to any of the four modules.\n* Or check out the videos in the EXTRAS section!\n\n## Notes\n\nWelcome back!\n"

/***/ }),
/* 1659 */
/***/ (function(module, exports) {

	module.exports = "# Teacher Resources\n## Bienvenue!\nNous sommes très heureux de former des Gardiens de la planète à {r/:$cityOrMunicipality}!\n\n#### Guide de l’enseignant(e)\n* {r/Canada}Téléchargez [le Guide de l’enseignant(e)](Teachers_Guide.fr_CA.pdf) pour un survol du contenu du programme et de son fonctionnement\n* La meilleure façon de vous orienter consiste à consulter le contenu destiné aux élèves en cliquant sur « Lancer le module 1 ».\n\n#### Liens vers les programmes d'études\nL’Académie des gardiens de la planète satisfait à toutes les exigences des programmes d'études en sciences, arts, langues et sciences humaines.\n\n* {r/Canada/BC}[Liens vers les programmes d'études de la 3ᵉ à la 6ᵉ année de la Colombie-Brittanique](CL_PPA-H2W_Canada_BC_Grades_3-6.fr_CA.pdf)\n* {r/Canada/AB}Liens vers les programmes d'études de la 2ᵉ à la 6ᵉ année de l'Alberta - à paraître bientôt! ([télécharger en anglais](CL_PPA-H2W_Canada_Alberta_Grades_2-6.pdf))\n* {r/Canada/SK}[Liens vers les programmes d'études de la 3ᵉ à la 6ᵉ année de la Saskatchewan](CL_PPA-H2W_Canada_Saskatchewan_Grades_3-6.fr_CA.pdf)\n* {r/Canada/MB}[Liens vers les programmes d'études de la 3ᵉ à la 6ᵉ année du Manitoba](CL_PPA-H2W_Canada_Manitoba_Grades_3-6.fr_CA.pdf)\n* {r/Canada/ON}Liens vers les programmes d'études de la 3ᵉ à la 6ᵉ année de l'Ontario - à paraître bientôt! ([télécharger en anglais](CL_PPA-H2W_Canada_Ontario_Grades_3-6.pdf))\n* {r/Canada/QC}[Liens vers les programmes d'études de la 3ᵉ à la 6ᵉ année du Québec](CL_PPA-H2W_Canada_Quebec_Grades_3-6.fr_CA.pdf)\n* {r/}Nous n’avons pas encore de liens vers les curriculums de votre région. Êtes-vous intéressé de nous aider à les développer? Contactez nous!\n\n#### Enseignez-vous à distance aux élèves?\nConsultez notre [aide-mémoire sur l’enseignement à distance](Remote_Teaching_Cheat_Sheet.fr_CA.pdf) pour obtenir des conseils sur la manière d’adapter le programme à l’apprentissage à distance/domicile!\n\n#### Vous voulez parlez à un être humain?\nCommuniquez avec nous en cliquant sur le bouton Messager dans le coin inférieur à droite! (en anglais)\n\n# Printables\n\n#### Matériel obligatoire à imprimer\n* Le dossier de missions pour chaque élève, en [couleur](Printables_Mission_Files_Colour.fr_CA.pdf) ou [noir et blanc](Printables_Mission_Files_BW.fr_CA.pdf).\n* Les cartes d’identité pour chaque élève, en [couleur](Printables_ID_Cards_Colour.fr_CA.pdf) ou [noir et blanc](Printables_ID_Cards_BW.fr_CA.pdf).\n*\tLes certificats de réalisation pour chaque élève, en [couleur](Printables_Completion_Certificates_Colour.fr_CA.pdf) ou [noir et blanc](Printables_Completion_Certificates_BW.fr_CA.pdf).\n\n#### Matériel facultatif à imprimer\n* Les certificats pour l’équipe gagnante, en [couleur](Printables_Winning_Certificates_Colour.fr_CA.pdf) ou [noir et blanc](Printables_Winning_Certificates_BW.fr_CA.pdf)\n* [Lettre aux parents](Printables_Parent_Guardian_Letter.pdf) (en anglais)\n*\tLes projets de bricolage :\n  *\tEsmeralda, en [couleur](Printables_Papercraft_Esmeralda_Colour.pdf) ou [noir et blanc](Printables_Papercraft_Esmeralda_BW.pdf).\n  *\tGoober, en [couleur](Printables_Papercraft_Goober_Colour.pdf) ou [noir et blanc](Printables_Papercraft_Goober_BW.pdf).\n"

/***/ }),
/* 1660 */
/***/ (function(module, exports) {

	module.exports = "# Teacher Resources\n## Welcome!\nWe're so happy to be training planet protectors from {r/:$cityOrMunicipality}!\n\n#### {r/Canada} Teacher's Guide\n{r/Canada} Download the [Teacher's Guide](Teachers_Guide.pdf) for a full overview of the program's contents and how it works.\n\nThe best way to orient yourself is to check out the student-facing content by clicking 'Start Module 1'.\n\n#### Curriculum Links\nThe Planet Protector Academy supports curriculum standards in science, arts, language and social studies. The following connections are provided for your convenience:\n\n* {r/Canada/BC}[British Columbia Grades 3-6](CL_PPA-H2W_Canada_BC_Grades_3-6.pdf)\n* {r/Canada/AB}[Alberta Grades 2-6](CL_PPA-H2W_Canada_Alberta_Grades_2-6.pdf)\n* {r/Canada/SK}[Saskatchewan Grades 3-6](CL_PPA-H2W_Canada_Saskatchewan_Grades_3-6.pdf)\n* {r/Canada/MB}[Manitoba Grades 3-6](CL_PPA-H2W_Canada_Manitoba_Grades_3-6.pdf)\n* {r/Canada/ON}[Ontario Grades 2-6](CL_PPA-H2W_Canada_Ontario_Grades_2-6.pdf)\n* {r/Canada/QC}[Quebec Grades 3-6](CL_PPA-H2W_Canada_Quebec_Grades_3-6.pdf)\n* {r/United States}Common Core curriculum links for Grades 3-5 are coming soon. In the meantime, check out the [curriculum links for the similar Keep Cool program](https://planetprotectoracademy.com/wp-content/uploads/2016/10/CL_PPA-KC_US_Common_Core_Grades_3-5.pdf) for an example of what to expect.\n* {r/United States}Next Generation Science Standards curriculum links for Grades 3-5 are coming soon. In the meantime, check out the [curriculum links for the similar Keep Cool program](https://planetprotectoracademy.com/wp-content/uploads/2016/10/CL_PPA-KC_US_Next_Generation_Science_Standards_Grades_3-5.pdf) for an example of what to expect.\n* {r/}We don't have curriculum links for your area yet. Do you want to help us develop them? Please contact us!\n\n#### Teaching students remotely?\nCheck out our [Remote Teaching Cheat Sheet](Remote_Teaching_Cheat_Sheet.pdf) for tips on how to adapt the program for remote/at-home learning!\n\n#### Need help from a human?\nGet in touch through the Messenger in the bottom right-hand corner!\n\n# Printables\n\n#### Required Print Materials\n* Mission Files for each child in [{r/Canada:colour}{r/:color}](Printables_Mission_Files_Colour.pdf) or [black & white](Printables_Mission_Files_BW.pdf).\n* ID Cards for each child in [{r/Canada:colour}{r/:color}](Printables_ID_Cards_Colour.pdf) or [black & white](Printables_ID_Cards_BW.pdf).\n* Completion certificates for each child in [{r/Canada:colour}{r/:color}](Printables_Completion_Certificates_Colour.pdf) or [black & white](Printables_Completion_Certificates_BW.pdf).\n\n#### Optional Print Materials\n* Winning team certificates in [{r/Canada:colour}{r/:color}](Printables_Winning_Certificates_Colour.pdf) or [black & white](Printables_Winning_Certificates_BW.pdf).\n* Papercrafts:\n  * Esmeralda [{r/Canada:colour}{r/:color}](Printables_Papercraft_Esmeralda_Colour.pdf) or [black & white](Printables_Papercraft_Esmeralda_BW.pdf)\n  * Goober [{r/Canada:colour}{r/:color}](Printables_Papercraft_Goober_Colour.pdf) or [black & white](Printables_Papercraft_Goober_BW.pdf)\n* Additional fun [Activity Pages](Printables_H2W_Activity_Book.pdf)\n"

/***/ }),
/* 1661 */
/***/ (function(module, exports) {

	module.exports = "# Module 1 Survol\n\n#### Aperçu de UNE SEULE EAU\n##### Durée habituelle : 60-90 minutes\nDans ce module, les élèves (« apprentis ») pourront :\n*\tregarder des vidéos captivantes.\n*\tchanter la chanson-thème des Gardiens de la planète.\n*\tjouer à un jeu basé sur les méthodes d’apprentissage par investigation qui incitent les élèves à réfléchir à notre relation à l’eau.\n*\tapprendre de la Première nation Tsleil Waututh qu’en s’occupant de l’eau, on s’occupe de tout ce qui y vit et en dépend, comme le saumon. Une pratique active de la gratitude pour l’eau.\n*\tfaire un remue-méninges de mots qui décrivent l’eau avec, en option, la possibilité de les utiliser pour créer un poème ou un rap.\n*\trecevoir une mission à réaliser à la maison dans leur dossier de missions.\n\n#### Former des équipes\n*\tAvant de commencer le programme, formez quatre équipes avec vos élèves.\n*\tChaque équipe travaillera ensemble au cours des différentes activités artistiques pour accumuler des points pour la participation, la collaboration, l’écoute, etc.\n*\tLe système est souple et s’adapte selon les comportements et aptitudes que vous souhaitez récompenser!\n\n#### Mots de vocabulaire à expliquer\n* arrière-grand-mère\n* perpétuellement\n* remue-méninges\n* mouillé\n* vers (d’un poème)\n* robinet\n\n\n# Matériel\n\n#### Ce dont vous aurez besoin pour ce module :\n* Le dossier de missions pour chaque élève, imprimé en [[couleur](Printables_Mission_Files_Colour.fr_CA.pdf) ou [noir et blanc](Printables_Mission_Files_BW.fr_CA.pdf).\n* Les cartes d’identité pour chaque élève, en [couleur](Printables_ID_Cards_Colour.fr_CA.pdf) ou [noir et blanc](Printables_ID_Cards_BW.fr_CA.pdf).\n"

/***/ }),
/* 1662 */
/***/ (function(module, exports) {

	module.exports = "# Module 1 Overview\r\n\r\n#### ONE WATER at a glance\r\n##### Typical duration: 60-90 minutes\r\nIn this module, students (\"Apprentices\") will:\r\n* Watch engaging videos.\r\n* Sing the Planet Protector Theme Song.\r\n* Play a game based on inquiry-based learning which engages them to think about our relationship to water.\r\n* Learn from the Tsleil Waututh First Nation that when we look after water, we look after everything that lives in and depends on water, like salmon. Practicing gratitude for water.\r\n* Brainstorm descriptive words for water, with the option of turning them into a poem or rap.\r\n* Be assigned their first at-home mission in their printed Mission Files: Turning Off Taps.\r\n\r\n#### Getting into teams\r\n* Before starting the program, divide your class into four teams.\r\n* Each team will work together during the various arts-based activities and score points for participating, collaborating, listening etc.\r\n* It's a flexible system for you to reward the {r/Canada:behaviour}{r/:behavior} you want to see in your class!\r\n\r\n# Materials\r\n\r\n#### What you need for this level\r\n* Mission Files for each student in [{r/Canada:colour}{r/:color}](Printables_Mission_Files_Colour.pdf) or [black & white](Printables_Mission_Files_BW.pdf).\r\n* ID Cards in [{r/Canada:colour}{r/:color}](Printables_ID_Cards_Colour.pdf) or [black & white](Printables_ID_Cards_BW.pdf) for each student.\r\n"

/***/ }),
/* 1663 */
/***/ (function(module, exports) {

	module.exports = "# Module 2 Survol\n\n#### Aperçu de ÉCONOMISER L’EAU\n##### Durée habituelle : 60-90 minutes\nDans ce module, les apprentis pourront :\n*\tfaire rapport de leur mission « Robinets fermés ».\n*\tchanter la chanson-thème des Gardiens de la planète.\n*\tparticiper à un jeu-questionnaire sur l’économie d’eau.\n*\trencontrer une aînée anishinaabe, Josephine Mandamin, qui a fait le tour des Grands Lacs à pied pour sensibiliser les gens au sujet de l’importance de prendre soin de l’eau.\n*\tdessiner, en groupe, le système d’eau local, de la source jusqu’au robinet.\n*\trecevoir la deuxième mission à réaliser – « Opération : Économiser l’eau ».\n\n#### Remarques sur les missions\n*\tModifier ses habitudes peut être difficile pour certaines familles.\n*\tLes familles de différents milieux socioéconomiques peuvent être plus ou moins capables de participer.\n*\tIl est important de valoriser les petits gestes à poser et de ne pas juger l’incapacité de certains à réaliser leurs missions.\n*\tLes échecs ne sont pas graves. L’important, c’est d’essayer et d’apprendre.\n\n#### Mots de vocabulaire à expliquer\n* QG (quartier général)\n* améliorations\n* saleté\n* microbes\n* gazon\n* bassin versant\n\n\n# Matériel\n\n#### Ce dont vous aurez besoin pour ce module :\n* Chaque apprenti(e) a aussi besoin de son dossier de mission 2.\n"

/***/ }),
/* 1664 */
/***/ (function(module, exports) {

	module.exports = "# Module 2 Overview\n\n#### SAVE WATER at a glance\n##### Typical duration: 60-90 minutes\nIn this module, Apprentices will:\n* Report on their Operation Taps Off mission.\n* Sing the Planet Protector Theme Song.\n* Play the Game Show about saving water.\n* Meet Anishinaabe Elder Josephine Mandamin, who walked around the Great Lakes, inspiring millions to care for water.\n* In groups, draw the local water system from source to tap.\n* Be assigned Mission 2: Operation Save Water.\n\n#### Note on Missions\n* Changing habits can be hard for families.\n* Families in different socio-economic situations, also, will have different abilities to participate.\n* It’s important to share the idea of small doable steps, and that there is no judgment around anyone’s ability to succeed at the missions.\n* Failure is ok. Trying and learning is what’s important.\n\n# Materials\n\n#### What you need for this level\n* Each Apprentice also requires their Mission File 2.\n"

/***/ }),
/* 1665 */
/***/ (function(module, exports) {

	module.exports = "# Module 3 Survol\n\n#### Aperçu de PROTÉGER L’EAU\n##### Durée habituelle : 60-90 minutes\nDans ce module, les apprentis pourront :\n*\tfaire rapport de leur mission « Opération : Économiser l’eau ».\n* chanter la chanson-thème des Gardiens de la planète.\n*\tparticiper au jeu-questionnaire sur les concepts de protection de l’eau.\n*\tapprendre comment des agriculteurs autochtones du sud du Bélize utilisent des méthodes naturelles pour assurer la propreté de leurs ruisseaux et rivières, afin d’utiliser l’eau pour leurs cultures.\n*\tcréer une affiche pour la famille sur les moyens de prévenir la pollution d’eau.\n*\trecevoir la Mission 3 – « Opération : Protéger l’eau ».\n\n#### Mots de vocabulaire à expliquer\n* pelouse\n* égout\n* eaux de ruissellement\n* noyau\n* étang\n* excréments\n\n\n# Matériel  \n\n#### Ce dont vous aurez besoin pour ce module :\n* Chaque apprenti(e) a aussi besoin de son dossier de mission 3.\n"

/***/ }),
/* 1666 */
/***/ (function(module, exports) {

	module.exports = "# Module 3 Overview\n\n#### PROTECT WATER at a glance\n##### Typical duration: 60-90 minutes\nIn this module, Apprentices will:\n* Report on their Operation Save Water mission.\n* Sing the Planet Protector Theme Song and H2Whoa! Theme Song.\n* Play the Game Show on water protection concepts.\n* Learn how Indigenous farmers in southern Belize have a natural way to keep their streams and rivers clean, so they can use the water to grow their crops.\n* Create a poster to remind their families about preventing water pollution.\n* Be assigned Mission 3: Operation Protect Water.\n\n# Materials  \n\n#### What you need for this level\n* Each Apprentice also requires their Mission File 3.\n"

/***/ }),
/* 1667 */
/***/ (function(module, exports) {

	module.exports = "# Module 4 Survol\n\n#### Aperçu de SE CONNECTER À SON MILIEU\n##### Durée habituelle : 60-90 minutes\nDans ce module, les apprentis pourront :\n*\tfaire rapport de leur mission « Opération : Protéger l’eau ».\n*\tchanter la chanson-thème des Gardiens de la planète.\n*\tparticiper au jeu-questionnaire sur les ressources d’eau naturelles de sa région.\n*\tapprendre comment une communauté autochtone de l’Arizona a planté une forêt pour aider à nettoyer une rivière polluée.\n*\tcréer un sketch sur comment convaincre ses amis d’arrêter de polluer l’eau.\n*\trecevoir des certificats de participation individuelle et pour l’équipe gagnante.\n*\tcélébrer leurs réalisations!\n\n#### Mots de vocabulaire à expliquer\n* calotte glacière\n* eaux souterraines\n\n\n# Matériel\n\n#### Ce dont vous aurez besoin pour ce module :\n* Les dossiers de missions\n* Les certificats de réalisation pour chaque apprenti, en [couleur](Printables_Completion_Certificates_Colour.fr_CA.pdf) ou [noir et blanc](Printables_Completion_Certificates_BW.fr_CA.pdf).\n* (facultatif) Les projets de bricolage pour chaque apprenti, avec des ciseaux et des accessoires pour le coloriage :\n  * Le dessin d’Esmeralda, en [couleur](Printables_Papercraft_Esmeralda_Colour.pdf) ou [noir et blanc](Printables_Papercraft_Esmeralda_BW.pdf).\n  * Le dessin de Goober, en [couleur](Printables_Papercraft_Goober_Colour.pdf) ou [noir et blanc](Printables_Papercraft_Goober_BW.pdf).\n* Le certificat de l’équipe gagnante, en [couleur](Printables_Winning_Certificates_Colour.fr_CA.pdf) ou [noir et blanc](Printables_Winning_Certificates_BW.fr_CA.pdf), que vous pourrez imprimer après avoir compilé le pointage des équipes et afficher dans la classe à la fin de la leçon\n"

/***/ }),
/* 1668 */
/***/ (function(module, exports) {

	module.exports = "# Module 4 Overview\n\n#### CONNECT IN PLACE at a glance\n##### Typical duration: 60-90 minutes\nIn this module, Apprentices will:\n* Report on their Operation Protect Water mission.\n* Sing the Planet Protector Theme Song.\n* Play the Game Show on connecting to natural water resources.\n* Learn about an Indigenous community in Arizona that planted a forest to help clean a polluted river.\n* Make a skit about how to talk to friends about protecting water.\n* Receive individual participation and winning team certificates.\n* Celebrate their achievements during the program!\n\n# Materials\n\n#### What you need for this level\n* Mission Files\n* Completion certificates for each Apprentice in [{r/Canada:colour}{r/:color}](Printables_Completion_Certificates_Colour.pdf) or [black & white](Printables_Completion_Certificates_BW.pdf).\n* Optional but fun: papercrafts for each Apprentice, plus scissors and something to {r/Canada:colour}{r/:color} with:\n  * Esmeralda papercraft in [{r/Canada:colour}{r/:color}](Printables_Papercraft_Esmeralda_Colour.pdf) or [black & white](Printables_Papercraft_Esmeralda_BW.pdf).\n  * Goober papercraft in [{r/Canada:colour}{r/:color}](Printables_Papercraft_Goober_Colour.pdf) or [black & white](Printables_Papercraft_Goober_BW.pdf).\n* Once you know which team has earned the most points, you can print a Winning Team Certificate in [{r/Canada:colour}{r/:color}](Printables_Winning_Certificates_Colour.pdf) or [black & white](Printables_Winning_Certificates_BW.pdf) to post on your classroom wall after the lesson.\n"

/***/ }),
/* 1669 */
/***/ (function(module, exports) {

	module.exports = "# Tech Prep Wizard\n\n### Tutoriel d’installation technique\n\nCe bref tutoriel vous guidera au cours de l’installation du programme de l’Académie pour votre salle de classe.\n\nNe montrez pas tout de suite l’écran à vos élèves!\n\nCliquez sur les flèches ou utilisez la flèche droite de votre clavier pour avancer dans le tutoriel.\n\n\n# Two Device Intro\n\n### Expérience à deux appareils\nL’expérience de l’Académie est plus agréable en utilisant deux appareils :\n*\tL’appareil principal (ORDINATEUR ou TABLETTE) fait la projection du site Web en classe.\n*\tLe deuxième appareil (TABLETTE ou CELLULAIRE) qui fonctionne comme télécommande (facultatif) :\n  *\tvous donne la liberté de vous déplacer dans la classe.\n  * contient des instructions et notes au bout des doigts.\n  *\tfournit des indicateurs utiles sur la progression, notamment sur la durée des vidéos et le nombre de diapos restantes.\n\n\n# Connecting Remote\n\n### Pour connecter votre télécommande!\nAfin de connecter le deuxième appareil comme télécommande :\n1. Allez à www.remote4ppa.com sur votre tablette/cellulaire.\n2. Inscrivez votre nom d’utilisateur et mot de passe sur votre tablette/cellulaire.\n3. Passez à la prochaine diapo pour sélectionner le rôle de l’appareil.\n4. Choisissez le bon rôle pour chaque appareil.\n5. Vos choix seront enregistrés pour une utilisation éventuelle, mais vous pouvez aussi apporter des changements plus tard!\n\n\n# Tech Check Intro\n\n### Vérification\nVEUILLEZ MAINTENANT connecter l’appareil principal à votre projecteur et **vérifier l’audio/la vidéo** pour vous assurer que tout fonctionne! Vous trouverez une vidéo amusante (en anglais) à la prochaine diapo qui vous aidera pour cette étape (elle se trouve aussi dans la section Pour s’amuser, si vous souhaitez la montrer à vos élèves).\n\n#### L’expérience plein écran\nL’expérience de l’Académie des gardiens de la planète est plus amusante en mode plein écran. Cliquez sur **Affichage (ou Présentation)** dans le menu de votre navigateur et sélectionnez ensuite **Plein écran** (Chrome) ou **Activer** le mode plein écran (Safari/ Firefox).\n\n# Tech Check Video\nYouTube: ZVdMndkjaIo\n"

/***/ }),
/* 1670 */
/***/ (function(module, exports) {

	module.exports = "# Tech Prep Wizard\n\n### Tech Prep Wizard\n\nThis short wizard will help you get set up to run the Academy in your classroom.\n\nDon't show your students the screen yet!\n\nClick the arrow or use your keyboard's right directional arrow to move through the wizard.\n\n# Two Device Intro\n\n### Two Device Experience\nThe Academy is best experienced using two devices:\n* Main device (COMPUTER or TABLET) projects the website at the front of the class.\n* Second device (TABLET or CELLPHONE) can be as a remote control (optional):\n  * gives you freedom to move around the classroom.\n  * contains prompts and facilitation notes at your finger tips.\n  * provides useful progress indicators, such as length of videos and number of slides remaining. \n\n# Connecting Remote\n\n### Connect your remote!\nTo connect a second device as a Remote Control:\n1. Go to www.remote4ppa.com on your tablet/phone.\n2. Enter your username and password on your tablet/phone.\n3. Go to the next slide to Select Role For This Device.\n4. Choose the right Role for each device.\n5. Your selections will be saved for future use, but you can always change it later!\n\n# Tech Check Intro\n\n### Tech Check!\nNOW PLEASE hook up your main device to your projector and **test the audio/video** to make sure everything's working! There's a fun video in the next slide to help you do this (it's also in the Fun section if you want to share with your class).\n\n#### Full Screen Experience\nThe Planet Protector Academy is best enjoyed as a full screen experience. **Click 'View'** in your browser's menu bar, and select **'Full Screen'** (Chrome) or **'Enter Full Screen'** (Safari/Firefox).\n\n# Tech Check Video\nYouTube: ZVdMndkjaIo\n"

/***/ }),
/* 1671 */
/***/ (function(module, exports) {

	module.exports = "# Program Start\n\n# Level 1 Start\n\n## Notes\n\n&nbsp;\n\n# Level 1 Icon\n\n## Notes\n\n&nbsp;\n\n&nbsp;\n\n# Level 2 Start\n\n## Notes\n\n&nbsp;\n\n# Level 2 Icon\n\n## Notes\n\n&nbsp;\n\n# Level 3 Start\n\n## Notes\n\n&nbsp;\n\n# Level 3 Icon\n\n## Notes\n\n&nbsp;\n\n# Level 4 Start\n\n## Notes\n\n&nbsp;\n\n# Level 4 Icon\n\n## Notes\n\n&nbsp;\n\n# Level 5 Start\n\n## Notes\n\n&nbsp;\n\n# Level 5 Icon\n\n## Notes\n\n&nbsp;\n\n# Level 6 Start\n\n## Notes\n\n&nbsp;\n\n# Level 6 Icon\n\n## Notes\n\n&nbsp;\n"

/***/ }),
/* 1672 */
/***/ (function(module, exports) {

	module.exports = "# Program Start\n\n# Level 1 Start\n\n## Notes\n\n### Start\n\nShow this screen at the start of class. When the kids are ready, advance to the next screen.\n\nUse the directional arrows on your remote to go forwards/backwards through the level.\n\n# Level 1 Icon\n\n## Notes\n\nOne Water\n\n### Tracking your progress\n\nYou can see how far along you are by the slide number on the top of your Remote Control or by the blue progress bar running along the bottom of the Menu on the Classroom Display.\n\n# Level 2 Start\n\n## Notes\n\n### Start\n\nShow this screen at the start of class. When the kids are ready, advance to the next screen.\n\n# Level 2 Icon\n\n## Notes\n\nSave Water\n\n# Level 3 Start\n\n## Notes\n\n### Start\n\nShow this screen at the start of class. When the kids are ready, advance to the next screen.\n\n# Level 3 Icon\n\n## Notes\n\nProtect Water\n\n# Level 4 Start\n\n## Notes\n\n### Start\n\nShow this screen at the start of class. When the kids are ready, advance to the next screen.\n\n# Level 4 Icon\n\n## Notes\n\nConnect In Place\n"

/***/ }),
/* 1673 */
/***/ (function(module, exports) {

	module.exports = "# Get Ready to Sing\n\n## Content\n\n### Prêts à chanter?!\n\n## Notes\n\nPrêts à chanter?!\n\n\n# Standalone Song\nYouTube: JPX85dIOjks\n\n## Notes\n&nbsp;\n\n\n# Combo Intro Song Level 3\nYouTube: zxYmw6Us3X8\n\n## Notes\n&nbsp;\n\n\n# Combo Intro Song Level 4\nYouTube: KnYFFVRQnVc\n\n## Notes\n&nbsp;\n"

/***/ }),
/* 1674 */
/***/ (function(module, exports) {

	module.exports = "# Get Ready to Sing\n\n## Content\n\n### Get ready to sing!\n\n## Notes\n\nGet ready to sing!\n\n\n# Standalone Song\nYouTube: ulOo2VuQEWA\n\n## Notes\n\n### Planet Protectors Song\nEncourage your class to learn this song and sing along to the video (1:52). The lyrics will be shown and are also on the last page of the Mission Files.\n\n### Extension Activities\nApprentices can perform the song to the whole school and/or create their own choreography.\n\n\n# Combo Intro Song Level 3\nYouTube: Lu9FhVVw0H4\n\n## Notes\n\n### Extension Activities\nApprentices can perform the song to the whole school and/or create their own choreography.\n\n\n# Combo Intro Song Level 4\nYouTube: 8WSy1X1Ax0c\n\n## Notes\n\n### Extension Activities\nApprentices can perform the song to the whole school and/or create their own choreography.\n"

/***/ }),
/* 1675 */
/***/ (function(module, exports) {

	module.exports = "Team Creation\n\n# Intro Team Names\n\nYouTube: NayGneuNNQU\n102\n\n## Notes\n(2:48)\n\n\n# Get Into Teams\n\n## Content\n\n###### Formez quatre équipes!\n\nÀ la prochaine diapo, donnez un nom à votre équipe.\n\n## Notes\n&nbsp;\n\n\n# Scoring Intro Video\n\nYouTube: nCQ4eDoxlLg\n103\n\n## Notes\n(0:39)\n\n\n# Scoring Intro\n\n## Content\n\n### Pour accumuler des points en équipe :\n* Répondez aux questions\n* Participez aux activités\n* Effectuez les missions\n* Travaillez ensemble (un bon travail d'équipe)\n* et plus!\n\n\n\n## Notes\n&nbsp;\n\n\n# Scoreboard Intro\n\n## Content\n\n### Consultez le tableau des points!\n\n(Dans le coin supérieur gauche, cliquez sur MENU, ensuite POINTAGE)\n\nLes équipes sont maintenant prêtes à accumuler des points!\n\n\n## Notes\n&nbsp;\n\n\n# ID Cards\n\n## Content\n\n### Félicitations!\n\n#### Vous êtes maintenant des apprentis-gardiens de la planète!\n\nC'est le temps de remplir vos cartes d'identité et de vous dessiner en gardien de la planète!\n\n## Notes\n&nbsp;\n"

/***/ }),
/* 1676 */
/***/ (function(module, exports) {

	module.exports = "Team Creation\n\n# Intro Team Names\n\nYouTube: rM_hqjFXfYQ\n102\n\n## Notes\nSara and Ian introduce welcome your students to the Academy (2:48).\n\n\n# Get Into Teams\n\n## Content\n\n###### Get into four teams!\n\nName your teams in the next slide.\n\n## Notes\nName teams in the next slide. Once you enter the name in the text field, it automatically saves!\n\n\n# Scoring Intro Video\n\nYouTube: V7DLyAqCnsc\n\n## Notes\nSara and Ian explain how they can score points (0:39).\n\n\n# Scoring Intro\n\n## Content\n\n### Here's how your team can score points\n\n* Answer questions\n* Do activities\n* Complete missions\n* Work well together (teamwork points)\n* and more!\n\n## Notes\n\n### Scoring\n* Teams can earn points for most activities in the program. You can allocate points as you see fit. Maximum points total is 999.\n* Individuals can earn points for teams, or teams can earn points together.\n* Teamwork points are critical to ensure collaboration.\n* Points can also be a classroom \"currency\", e.g.to gain classroom privileges.\n* The team with the most points at the end of Level 6 is the winner.\n\n\n# Scoreboard Intro\n\n## Content\n\n### Check out the scoreboard!\n\n(In the top left corner, click MENU and then SCORES)\n\nYour teams are now ready to start scoring points!\n\n## Notes\n\nClick on the 'Scoreboard' icon on your remote at any time to bring down the scoreboard and add points for teams.\n\n\n# ID Cards\n\n## Content\n\n### Congratulations!\n\n#### You're now Planet Protector Apprentices!\n\nTime to fill out your ID cards and draw yourself as the Planet Protector that you are!\n\n## Notes\n\nHave Apprentices write their names and team names on their ID cards, and draw their \"avatar\", ie. a picture of themselves as a superhero.\n"

/***/ }),
/* 1677 */
/***/ (function(module, exports) {

	module.exports = "# Mission Report\nTitle: Opération Robinets fermés\n\n# Intro Video\n\nYouTube: alurUaG9Izw\n\n## Notes\n\n(1:01)\n\n\n# Scoring\n\n## Content\n\n### Accumulez des points pour vos missions!\n* Allez à la Mission 1 de votre dossier de missions.\n* En équipe, calculez le total des points accumulés dans la section « Accumuler des points pour votre équipe ».\n* N'oubliez pas d'ajouter vos points au tableau des points!\n\n## Notes\n\n&nbsp;\n\n\n# Instructions\n\n## Content\n\n### C'est l'heure de faire votre rapport au QG!\n* Répondez en levant la main.\n* Si vous ou votre famille avez fait des améliorations, mêmes petites, dites oui!\n* Si rien n'a changé, ne levez pas la main. Reprenez-vous à la prochaine mission!\n* Les agents de formation peuvent aussi faire leur rapport!\n\n## Notes\n&nbsp;\n\n\n# Questions\n\n## Content\n\n1. Nombre d'apprenti(e)s et d'enseignant(e)s qui font leur rapport.\n2. Je ferme plus souvent les robinets.\n3. Ma famille ferme plus souvent les robinets.\n4. Je m'engage à continuer de fermer les robinets.\n5. Combien d'enfants s'amusent à participer au programme?\n\n\n# Impact\n\n## Content\n\n### Excellent travail, apprenti(e)s!\nVotre rapport de mission a été reçu au QG de l'Académie des gardiens de la planète.\n\n## Notes\n&nbsp;\n\n\n# Class Discussion\n\n## Content\n\n### Discussion en classe\n* Discutez ensemble de ce qui a été facile ou difficile pendant la mission.\n* Qu'est-ce qui a fonctionné et n'a pas fonctionné?\n* Qu'est-ce qui pourrait faciliter les choses?\n\n## Notes\n&nbsp;\n"

/***/ }),
/* 1678 */
/***/ (function(module, exports) {

	module.exports = "# Mission Report\nTitle: Operation Taps Off\n\n\n# Intro Video\nYouTube: NzBFMW9MQTY\n\n## Notes\nIntro to the Mission Report for Operation Taps Off (1:01).\n\n\n# Scoring\n\n## Content\n\n### Get points for your missions!\n* Turn to Mission 1 in your Mission Files.\n* In your teams, count the total number of points you scored in the 'Get points for' section.\n* Make sure your points get added onto the Scoreboard!\n\n## Notes\nThis slide only covers actions listed under 'Get a point for' for each mission.\nStudents report the Mission Report section next.\n\n\n# Instructions\n\n## Content\n\n### Time to report to HQ!\n* Answer with a show of hands.\n* If you or your family has improved even a little bit, say yes!\n* If you didn't change, don't put up your hand. Try again next mission!\n* Training Agents can report too!\n\n## Notes\n\n### Mission Reports\n* Mission reports help us communicate the impact of our program. Thanks for helping us to measure it!\n* Using a show of hands keeps the data anonymous.\n\n\n# Questions\n\n## Content\n1. Number of Apprentices and Teachers reporting in.\n2. I am turning off taps more now.\n3. My family is turning off taps more now.\n4. I pledge to keep turning off taps.\n5. How many kids are having fun doing this program?\n\n\n# Class Discussion\n\n## Content\n\n### Class Discussion\n* As a class, discuss what was easy or hard about this mission.\n* What worked, what didn’t work?\n* What would make it easier?\n\n## Notes\nEncourage apprentices who did not succeed to keep trying, if appropriate.\n\n\n# Impact\n\n## Content\n\n### Awesome work, Apprentices!\nYour Mission Report was received by Planet Protector Academy HQ.\n\n## Notes\nGreat job!\n"

/***/ }),
/* 1679 */
/***/ (function(module, exports) {

	module.exports = "# Mission Report\nTitle: Opération Économiser l'eau\n\n\n# Scoring\n\n## Content\n\n### Accumulez des points pour vos missions!\n* Allez à la Mission 2 de votre dossier de missions.\n* En équipe, calculez le total des points accumulés dans la section « Accumuler des points pour votre équipe ».\n* N'oubliez pas d'ajouter vos points au tableau des points!\n\n## Notes\n&nbsp;\n\n\n# Instructions\n\n## Content\n\n### C'est l'heure de faire votre rapport au QG!\n* Répondez en levant la main.\n* Si vous ou votre famille avez fait des améliorations, mêmes petites, dites oui!\n* Si rien n'a changé, ne levez pas la main. Reprenez-vous à la prochaine mission!\n* Les agents de formation peuvent aussi faire leur rapport!\n\n## Notes\n&nbsp;\n\n\n# Questions\n\n## Content\n\n1. Nombre d'apprenti(e)s et d'enseignant(e)s qui font leur rapport.\n2. Mes douches sont maintenant plus rapides.\n3. Les douches de ma famille sont maintenant plus rapides.\n4. La laveuse à linge ou le lave-vaisselle est maintenant bien plein(e) quand ma famille la (le) démarre.\n5. Je m'engage à continuer d'économiser l'eau.\n6. Mes parents/tuteurs s'engagent à laisser l'eau de pluie arroser la pelouse.\n7. Mes parents/tuteurs s'engagent à installer un baril pour l'eau de pluie.\n\n## Notes\n&nbsp;\n\n\n# Impact\n\n## Content\n\n### Excellent travail, apprentis!\nVotre rapport de mission a été reçu au QG de l'Académie des gardiens de la planète.\n\n## Notes\n&nbsp;\n\n\n# Class Discussion\n\n## Content\n\n### Discussion en classe\n* Discutez ensemble de ce qui a été facile ou difficile pendant la mission.\n* Qu'est-ce qui a fonctionné et n'a pas fonctionné?\n* Qu'est-ce qui pourrait faciliter les choses?\n\n## Notes\n&nbsp;\n"

/***/ }),
/* 1680 */
/***/ (function(module, exports) {

	module.exports = "# Mission Report\nTitle: Operation Save Water\n\n\n# Scoring\n\n## Content\n\n### Get points for your missions!\n* Turn to Mission 2 in your Mission Files.\n* In your teams, count the total number of points you scored in the 'Get points for' section.\n* Make sure your points get added onto the Scoreboard!\n\n## Notes\nThis slide only covers actions listed under 'Get a point for' for each mission.\nStudents report the Mission Report section next.\n\n\n# Instructions\n\n## Content\n\n### Time to report to HQ!\n* Answer with a show of hands.\n* If you or your family has improved even a little bit, say yes!\n* If you didn't change, don't put up your hand. Try again next mission!\n* Training Agents can report too!\n\n## Notes\nMission reports help us communicate the impact of our program. Thanks for helping us to measure it!\n\n\n# Questions\n\n## Content\n1. Number of Apprentices and Teachers reporting in.\n2. I am having shorter showers now.\n3. My family is having shorter showers now.\n4. My family is doing fuller loads of laundry/dishwasher now.\n5. I pledge to keep saving water.\n6. My parents/guardians pledge to let the rain water our lawn.\n7. My parents/guardians pledge to get a rain barrel.\n\n## Notes\n&nbsp;\n\n\n# Class Discussion\n\n## Content\n\n### Class Discussion\n* As a class, discuss what was easy or hard about this mission.\n* What worked, what didn’t work?\n* What would make it easier?\n\n## Notes\nEncourage apprentices who did not succeed to keep trying, if appropriate.\n\n\n# Impact\n\n## Content\n\n### Great job, Apprentices!\n\n#### Thanks for protecting the planet!\nYour Mission Report was received by Planet Protector Academy HQ.\n\n## Notes\nGreat job!\n"

/***/ }),
/* 1681 */
/***/ (function(module, exports) {

	module.exports = "# Mission Report\nTitle: Opération Protéger l'eau\n\n\n# Scoring\n\n## Content\n\n### Accumulez des points pour vos missions!\n* Allez à la Mission 3 de votre dossier de missions.\n* En équipe, calculez le total des points accumulés dans la section « Accumuler des points pour votre équipe ».\n* N'oubliez pas d'ajouter vos points au tableau des points!\n\n## Notes\n&nbsp;\n\n\n# Instructions\n\n## Content\n\n### C'est l'heure de faire votre rapport au QG!\n* Répondez en levant la main.\n* Si vous ou votre famille avez fait des améliorations, mêmes petites, dites oui!\n* Si rien n'a changé, ne levez pas la main. Reprenez-vous à la prochaine mission!\n* Les agents de formation peuvent aussi faire leur rapport!\n\n## Notes\n&nbsp;\n\n\n# Questions\n\n## Content\n\n1. Nombre d'apprenti(e)s et d'enseignant(e)s qui font leur rapport.\n2. J'ai enseigné le Code de protection de l'eau à ma famille.\n3. J'ai modifié mes habitudes grâce au Code.\n4. Ma famille a modifié ses habitudes grâce au Code.\n5. À partir d'aujourd'hui, je m'engage à protéger l'eau.\n6. Combien d'enfants se croient maintenant de véritables gardiens de la planète?\n7. À partir d'aujourd'hui, je m'engage à être un(e) gardien(ne) de la planète.\n\n## Notes\n&nbsp;\n\n\n# Impact\n\n## Content\n\n### Excellent travail, apprentis!\nVotre rapport de mission a été reçu au QG de l'Académie des gardiens de la planète.\n\n## Notes\n&nbsp;\n\n\n# Class Discussion\n\n## Content\n\n### Discussion en classe\n* Discutez ensemble de ce qui a été facile ou difficile pendant la mission.\n* Qu'est-ce qui a fonctionné et n'a pas fonctionné?\n* Qu'est-ce qui pourrait faciliter les choses?\n\n## Notes\n&nbsp;\n"

/***/ }),
/* 1682 */
/***/ (function(module, exports) {

	module.exports = "# Mission Report\nTitle: Operation Protect Water\n\n\n# Scoring\n\n## Content\n\n### Get points for your missions!\n\n* Turn to Mission 3 in your Mission Files.\n* In your teams, count the total number of points you scored in the 'Get points for' sections.\n* Make sure your points get added onto the Scoreboard!\n\n## Notes\nThis slide only covers actions listed under 'Get a point for' for each mission.\nStudents report the Mission Report section next.\n\n\n# Instructions\n\n## Content\n\n### Time to report to HQ!\n* Answer with a show of hands.\n* If you or your family has improved even a little bit, say yes!\n* If you didn't change, don't put up your hand.\n* Training Agents can report too!\n\n## Notes\nMission reports help us communicate the impact of our program. Thanks for helping us to measure it!\n\n\n# Questions\n\n## Content\n1. Number of Apprentices and Teachers reporting in.\n2. I taught my family about the Water Protector Code.\n3. I changed my habits because of the Code.\n4. My family changed our habits because of the Code.\n5. I pledge to be a water protector from now on.\n6. How many kids feel like real life Planet Protectors now?\n7. I pledge to be a Planet Protector from now on.\n\n## Notes\n&nbsp;\n\n\n# Class Discussion\n\n## Content\n\n### Class Discussion\n* As a class, discuss what was easy or hard about this mission.\n* What worked, what didn’t work?\n* What would make it easier?\n\n## Notes\nEncourage apprentices who did not succeed to keep trying, if appropriate.\n\n\n# Impact\n\n## Content\n\n### Awesome work, Apprentices!\n\n#### Thanks for protecting the planet!\nYour Mission Report was received by Planet Protector Academy HQ.\n\n## Notes\nGreat job!\n"

/***/ }),
/* 1683 */
/***/ (function(module, exports) {

	module.exports = "# Es Story 1a\nYouTube: TUXG9B0HkQw\n104/105/106/107\n\n## Notes\n(11:36)\n\n\n# Es Story 1b\nYouTube: G2MgAaUyKrQ\n110\n\n## Notes\n(1:01)\n\n\n# Es Story 1c\nYouTube: HVC9en5zDM8\n111-113\n\n## Notes\n(7:25)\n\n\n# Es Story 2a\nYouTube: u9-3PaJGbhM\n203/204/205/207\n\n## Notes\n(8:40)\n\n\n# Es Story 3a\nYouTube: PdYN9-HEuL4\n303/304/305\n\n## Notes\n(2:51)\n\n\n# Es Story 3b\nYouTube: Wfkbgqkr0kU\n310\n\n## Notes\n(2:11)\n\n\n# Es Story 4a\nYouTube: JOQ_XjPrEcA\n403/404/405\n\n## Notes\n(3:48)\n\n\n# Es Story 4b\nYouTube: L0gouiT2p7o\n410/412/413\n\n## Notes\n(6:55)\n"

/***/ }),
/* 1684 */
/***/ (function(module, exports) {

	module.exports = "# Es Story 1a\nYouTube: P_WoTQPF3i4\n104/105/106/107\n\n## Notes\nEsmeralda and Goober find a missing water reservoir. Green Apprentice news report and confronting the Evaporator. Nandor & Urb discover earth. (11:37)\n\n### Problems with your video buffering?\nPause the video and wait a minute for it to pre-load, then it should play without a hitch!\n\n\n# Es Story 1b\nYouTube: xWVMZyrFZIs\n110\n\n## Notes\nNandor & Urb plot to take some water from Earth (1:01)\n\n\n# Es Story 1c\nYouTube: TPz7FefA2ys\n111-113\n\n## Notes\nEsmeralda meets with Apprentices, gets shielding device. Esmeralda defeats the Evaporator. Esmeralda gives the first mission (7:25).\n\n\n# Es Story 2a\nYouTube: b0pIwK8_4tU\n203/204/205/207\n\n## Notes\nGreen Apprentice news report: taps running dry. Nandor & Urb plan to steal all of Earth's fresh water. Enviro Ian cleans up mess. Intro to Water Cycle song. (8:40)\n\n\n# Es Story 3a\nYouTube: Fux-n8ApNL8\n303/304/305\n\n## Notes\nGreen Apprentice news report. Nandor & Urb find toxins in Earth's water. (2:51)\n\n\n# Es Story 3b\nYouTube: CBHIAtdn42g\n310\n\n## Notes\nEsmeralda & Goober convince Dubious to save the world (2:11)\n\n\n# Es Story 4a\nYouTube: JOKXVw5JWG4\n403/404/405\n\n## Notes\nGreen Apprentice news report and Nandor & Urb (3:48)\n\n\n# Es Story 4b\nYouTube: 60LJfUSYg2A\n410/412/413\n\n## Notes\nEsmeralda foils the Evaporator's plan and saves Apprentices (6:56)\n"

/***/ }),
/* 1685 */
/***/ (function(module, exports) {

	module.exports = "# MME Level 1\nYouTube: 8ucjPVwH7Hw\n\n## Notes\n(3:19)\n\n\n# MME Level 2\nYouTube: VNd21qg2fPE\n\n## Notes\n(2:25)\n\n\n# MME Level 3\nYouTube: O-sEHAMM0hw\n\n## Notes\n(5:41)\n\n\n# MME Level 4\nYouTube: QX4SqqRm5AQ\n\n## Notes\n(10:49)\n"

/***/ }),
/* 1686 */
/***/ (function(module, exports) {

	module.exports = "# MME Level 1\nYouTube: H0pzw_aMCJc\n\n## Notes\nMessages From Mother Earth Episode 1 (3:19)\n\n\n# MME Level 2\nYouTube: cUEV1b5Hj3s\n\n## Notes\nMessages From Mother Earth Episode 2 (2:25)\n\n\n# MME Level 3\nYouTube: 74xcYfHEzts\n\n## Notes\nEsmeralda and Goober share how water gets polluted. Messages From Mother Earth Episode 3. Nandor & Urb observe how humans pollute (and clean up) water. (5:41)\n\n\n# MME Level 4\nYouTube: zRpdYCpX_2Y\n\n## Notes\nSara & Ian demonstrate rain barrel. Messages From Mother Earth Episode 4. Esmeralda & Goober battle the mind control beam; Nandor & Urb's plan is foiled. (10:49)\n"

/***/ }),
/* 1687 */
/***/ (function(module, exports) {

	module.exports = "# Game Show\nLevel 2 - One Water\n\n# Intro Video\nYouTube: rTdqUwGaBxg\n\n## Notes\n(2:01)\n\n\n# Sizzle\n\n## Notes\n&nbsp;\n\n\n# Scoring\n\n## Content\n\n### Pour accumuler des points :\n* Prenez la pose de gardien(ne) de la planète.\n* Soyez le premier ou la première à activer le signal sonore.\n* Donnez la bonne réponse. Faites de votre mieux!\n* Si vous ne connaissez pas la réponse, réfléchissez à ce que pourrait être une bonne réponse. Ce n'est pas un test!\n\n## Notes\n&nbsp;\n\n\n# Four Players Announcement\n\n## Notes\n&nbsp;\n\n\n# Question 1\n\n## Question\n\n### Identifiez une façon de s'amuser avec ou dans l'eau\n(sport, activité, etc.).\n\n## Answer\n\n### Il y a plusieurs façons de profiter de l'eau!\nOn peut :\n* boire de l'eau froide quand il fait chaud\n* participer à des sports aquatiques\n* sauter d'un quai\n* apprécier la sensation d'une douche chaude sur la peau\n* visiter des parc aquatiques, participer à des batailles d'eau\n* etc.\n\n\n## Answer Notes\n&nbsp;\n\n\n# Question 2\n\n## Question Intro\n\n### Quel âge a l'eau?\nChoix multiples - Passez à la prochaine diapo!\n\n## Question\n1. Plus vieille que les dinosaures\n2. Le même âge que l'arrière-grand-mère de votre enseignant(e)\n3. Elle renaît à chaque nouvelle pluie\n\n\n## Answer\n\n### La bonne réponse est:\n1. Plus vieille que les dinosaures\n\nL'eau suit un cycle selon lequel l'eau se recycle perpétuellement.\n\n## Answer Notes\n&nbsp;\n\n\n# Scoring Reminder\n\n## Content\n\n### N'oubliez pas de calculer vos points!\n\n## Notes\n\n&nbsp;\n\n\n# Question 3\n\n## Question\n\n#### Comment utilise-t-on l'eau à la maison?\n\n## Answer\n\n### Façons d'utiliser l'eau à la maison :\n* Laver le linge et la vaisselle\n* Utiliser la toilette\n* Se doucher, se laver les mains\n* Arroser les plantes\n* Se brosser les dents\n* Faire la cuisine, le ménage\n* Etc.\n\n\n## Answer Notes\n&nbsp;\n"

/***/ }),
/* 1688 */
/***/ (function(module, exports) {

	module.exports = "# Game Show\nLevel 1 - One Water\n\n# Intro Video\nYouTube: VyBu5Qr6qaM\n\n## Notes\nIntro to Game Show (2:01).\n\n\n# Sizzle\n\n## Notes\n\n### Game Show\nIn the Game Show we ask questions relating to the topic *before* giving the answers, in order to stimulate thinking, rather than to test knowledge.\n\nOne Apprentice from each team will come up to the front of the class and get a chance to answer the question in turn.\n\nFor more info, see \"Game Show Info\" in the Teachers Guide, which is available in the Teacher Resources section on the Dashboard page.\n\n\n# Scoring\n\n## Content\n\n### How to score points\n* Do your Planet Protector pose.\n* Buzz in first.\n* Give a good answer. Try your best!\n* If you don’t know the answer, think about what a good answer might be. This is not a test!\n\n## Notes\nDon't forget to score points on the Scoreboard!\n\n\n# Four Players Announcement\n\n## Notes\n* One Apprentice from each team comes to the front of the room.\n* Encourage a different Apprentice to come up for each question.\n\n\n# Question 1\n\n## Question\n\n### Name one way you like to have fun with or in water.\n(sport, activity etc.)\n\n## Answer\n\n### There are many ways!\nYou can enjoy:\n* Drinking cold water on a hot day\n* Water sports\n* Jumping off a dock\n* The feeling of a hot shower on your skin\n* Water parks, water fights\n* Etc.\n\n## Answer Notes\nIs the text going outside the speech bubble? You can resize your browser window to try and fix it, or even better - go full screen!\n\n\n# Question 2\n\n## Question Intro\n\n### How old is water?\nMultiple choice - see next slide!\n\n## Question\n1. Older than dinosaurs\n2. As old as your teacher's great grandmother\n3. New every time it rains\n\n## Answer\n\n### The answer is:\n1. Older than dinosaurs\n\nThe water cycle keeps recycling water again and again.\n\n## Answer Notes\n&nbsp;\n\n\n# Scoring Reminder\n\n## Content\n\n### Don't forget to add scores!\n\n## Notes\nClick on the 'Scores' button below to open up the Scoreboard.\n\n\n# Question 3\n\n## Question\n\n#### Name one way you use water in the home.\n\n## Answer\n\n### Ways you can use water in the home:\n* Washing clothes and dishes\n* Using the toilet\n* Showering, washing hands\n* Watering plants\n* Brushing teeth\n* Cooking, cleaning the house\n* Etc.\n\n## Answer Notes\n&nbsp;\n"

/***/ }),
/* 1689 */
/***/ (function(module, exports) {

	module.exports = "# Game Show\nLevel 2 - Save Water\n\n# Intro Video\nYouTube: vSHAOA0V94Y\n\n## Notes\n(0:12)\n\n\n# Sizzle\n\n## Notes\n&nbsp;\n\n\n# Scoring\n\n## Content\n\n### Pour accumuler des points :\n* Prenez la pose de gardien(ne) de la planète.\n* Soyez le premier ou la première à activer le signal sonore.\n* Donnez une bonne réponse.\n\n## Notes\n&nbsp;\n\n\n# Four Players Announcement\n\n## Notes\n&nbsp;\n\n\n# Question 1\n\n## Question\n\n### Comment nettoie-t-on l'eau potable?\n\n## Answer\n\n### Il existe différentes méthodes de nettoyer l'eau, qui dépendent de la géographie de la communauté.\nLes trois façons courantes sont :\n1. par filtration – on en extrait les saletés, etc.\n2. par rayonnement – on utilise des rayons ultraviolets pour éliminer les bactéries.\n3. par chloration – on ajoute du chlore pour éviter la formation éventuelle de microbes.\n\n## Answer Notes\n&nbsp;\n\n\n# Scoring Reminder\n\n## Content\n\n### N'oubliez pas de calculer vos points!\n\n## Notes\n\n&nbsp;\n\n\n# Question 2\n\n## Question\n\n### Comment peut-on économiser l'eau?\n\n## Answer\n\n### Quelques moyens d'économiser l'eau :\n* Fermer les robinets en se brossant les dents\n* Se doucher rapidement (5 min. max.!)\n* Laisser la pluie arroser le gazon\n* Installer un baril pour l'eau de pluie\n* Démarrer le lave-vaiselle ou la laveuse à linge seulement quand il ou elle est plein(e)\n* Respecter les restrictions de la Ville en matière de consommation d’eau\n* Etc.\n\n## Answer Notes\n&nbsp;\n\n\n# Question 3\n\n## Question\n\n### C'est quoi le cycle de l'eau?\n\n## Answer\n\n### C'est le cycle que parcourt l'eau sur la Terre.\n* Toute l'eau du monde est reliée et circule à travers les rivières, les lacs, les nuages, les forêts et même les êtres humains. Chaque être vivant fait partie du cycle de l'eau.\n* Le cycle de l'eau comprend :\n  * l'évaporation (p. ex., la vapeur)\n  * la condensation (p. ex., les nuages)\n  * les précipitations (p. ex., la pluie)\n  * la transpiration (p. ex., l'eau qui s'évapore d'une plante)\n  * la sublimation (p. ex.. la neige qui se transforme en vapeur)\n\n## Answer Notes\n&nbsp;\n"

/***/ }),
/* 1690 */
/***/ (function(module, exports) {

	module.exports = "# Game Show\nLevel 2 - Save Water\n\n# Intro Video\nYouTube: -VpWeDAQzN4\n\n## Notes\nIntro to Game Show (0:12).\n\n# Sizzle\n\n## Notes\nGame Show\n\n\n# Scoring\n\n## Content\n\n### How to get points:\n* Do your Planet Protector pose.\n* Buzz in first.\n* Give a good answer.\n\n## Notes\nDon't forget to score points on the Scoreboard!\n\n\n# Four Players Announcement\n\n## Notes\nFour players to the front.\n\n\n# Question 1\n\n## Question\n\n### How is our drinking water cleaned?\n\n## Answer\n\n### There are different ways that communities clean water, depending on the geography.\nThree common steps are:\n1. Filtration - Taking out dirt, etc.\n2. Radiation - Using ultra-violet light to kill bacteria.\n3. Chlorination - Adding the chemical chlorine so more germs don’t grow later.\n\n## Answer Notes\n&nbsp;\n\n\n# Scoring Reminder\n\n## Content\n\n### Don't forget to add scores!\n\n## Notes\nClick on the 'Scores' button below to open up the Scoreboard.\n\n\n# Question 2\n\n## Question\n\n### Name one way you can save water.\n\n## Answer\n\n### Some ways to save water:\n* Turn off taps when brushing teeth\n* Take shorter showers (5 min max!)\n* Let the rain water the lawn\n* Have a rain barrel\n* Only do full loads of laundry/dishes\n* Obey city water restrictions\n* Etc.\n\n## Answer Notes\n&nbsp;\n\n\n# Question 3\n\n## Question\n\n### What is the water cycle?\n\n## Answer\n\n### It's the cycle that water goes through on earth.\n* All the water in the world is connected and moves through rivers, lakes, clouds, forests, and even humans. Every living thing is part of the water cycle.\n* Parts of the water cycle include:\n  * evaporation (eg. steam)\n  * condensation (eg. clouds)\n  * precipitation (eg. rain)\n  * transpiration (eg. water evaporating from a plant)\n  * sublimation (eg. snow becoming vapour).\n\n## Answer Notes\n&nbsp;\n"

/***/ }),
/* 1691 */
/***/ (function(module, exports) {

	module.exports = "# Game Show\nLevel 3 - Protect Water\n\n# Intro Video\nYouTube: fbl31Nn6cM4\n\n## Notes\nIntro to Game Show (0:19).\n\n\n# Sizzle\n\n## Notes\n&nbsp;\n\n\n# Four Players Announcement\n\n## Notes\n&nbsp;\n\n\n# Question 1\n\n## Question\n\n### Qu'est-ce qui peut polluer l'eau?\n\n## Answer\n\n### Voici des choses qui peuvent polluer l'eau :\n* Les produits chimiques\n* La peinture\n* L'huile\n* Les eaux d'égout\n* Les déchets alimentaires\n* Les savons, shampoings, agents nettoyants qui ne sont pas biodégradables\n\n## Answer Notes\n&nbsp;\n\n\n# Question 2\n\n## Question\n\n### Pourquoi est-ce un problème quand l'eau est polluée?\n\n## Answer\n\n### L'eau polluée nuit aux plantes, aux animaux et aux êtres humains.\n* Il faut la nettoyer pour qu'elle soit potable, ce qui est coûteux.\n* Puisque toute l'eau est reliée, l'eau polluée d'un lieu entraîne de la pollution partout.\n\n## Answer Notes\n&nbsp;\n\n\n# Question 3\n\n## Question\n\n### Comment la nature nettoie-t-elle l'eau?\n\n## Answer\n\n### La nature nettoie l'eau grâce au cycle de l'eau.\nLes plantes et le sol filtrent et nettoient l'eau qui y circule.\n\n## Answer Notes\n&nbsp;\n\n\n# Question 4\n\n## Question Intro\n\n#### Les eaux de ruissellement sont de l'eau de pluie ou de la neige fondue qui se retrouve au sol et aboutit dans les égouts. Où les égouts acheminent-ils généralement l'eau?\n\nChoix multiples - Passez à la diapo suivante!\n\n## Question\n1. Au même endroit que l'eau domestique - l'usine de traitement des eaux - où elle est nettoyée.\n2. Directement dans la nature (rivières, océan, etc.) sans être nettoyée.\n3. Dans vos robinets.\n4. Dans le noyau en fusion de la terre.\n\n## Answer\n\n### La bonne réponse :\n2. Directement dans la nature (rivières, étangs, océan, etc.) sans être nettoyée.\n\nAutrement dit, la pollution qui aboutit dans les égouts pollue aussi l'habitat des poissons.\n\n## Answer Notes\n&nbsp;\n\n\n# Question 5\n\n## Question\n\n#### Remue-méninges d'équipe - En équipe, réfléchissez à tout ce qui peut polluer les eaux de ruissellement.\n\nUn point pour chaque réponse.\n\n## Answer\n\n### Ce qui pollue les eaux de ruissellement :\n* Des déchets dans les égouts\n* Les excréments d'animaux\n* Les fertilisants et pesticides (sur les pelouses et à la ferme)\n* Les produits chimiques, peintures\n* L'huile des voitures qui dégoutte sur les routes\n\n## Answer Notes\n&nbsp;\n"

/***/ }),
/* 1692 */
/***/ (function(module, exports) {

	module.exports = "# Game Show\nLevel 3 - Protect Water\n\n# Intro Video\nYouTube: UvRHnxpfYxI\n\n## Notes\nIntro to Game Show (0:19).\n\n\n# Sizzle\n\n## Notes\nGame Show\n\n\n# Four Players Announcement\n\n## Notes\n\nFour players to the front.\n\n\n# Question 1\n\n## Question\n\n### What are some things that pollute water?\n\n## Answer\n\n### Some things that pollute water\n* Chemicals\n* Paint\n* Oil\n* Sewage\n* Food waste\n* Soaps, shampoos, cleaning agents that aren't biodegradable\n\n## Answer Notes\n&nbsp;\n\n\n# Question 2\n\n## Question\n\n### What's the problem with pollution in water?\n\n## Answer\n\n### Pollution in water hurts plants, animals and us.\n* It has to be cleaned to be drinkable, which is expensive.\n* Since all water is connected, polluting some water pollutes all water.\n\n## Answer Notes\n&nbsp;\n\n\n# Question 3\n\n## Question\n\n### How does nature clean water?\n\n## Answer\n\n### Nature cleans water through the water cycle.\nPlants and soil filter and clean water that pass through them.\n\n## Answer Notes\n&nbsp;\n\n\n# Question 4\n\n## Question Intro\n\n#### Stormwater is rain water or melted snow that collects on the ground and ends up in storm drains. Where do these drains usually take the water?\n\nMultiple choice - see next slide!\n\n## Question\n\n1. To the same place as house water - the municipal water station - where it is cleaned.\n2. Straight into nature (rivers, ocean, etc.) without being cleaned\n3. Back into your taps\n4. To the earth's molten core.\n\n## Answer\n\n### The answer is:\n2. Straight into nature (rivers, ponds, the ocean, etc.) without being cleaned.\n\nThis means any pollution that goes down storm drains pollutes fish habitat.\n\n## Answer Notes\n&nbsp;\n\n\n# Question 5\n\n## Question\n\n#### Team Brainstorm - in your teams, think of as many things as you can that might pollute the stormwater.\n\nOne point for each answer.\n\n## Answer\n\n### Some things that pollute stormwater:\n* Garbage in storm drains\n* Pet waste\n* Fertilizers and pesticides (on lawns and farms)\n* Chemicals, paint\n* Oil from cars that has dripped on the roads\n\n## Answer Notes\n&nbsp;\n"

/***/ }),
/* 1693 */
/***/ (function(module, exports) {

	module.exports = "# Game Show\nLevel 4 - Connect in Place\n\n# Intro Video\nYouTube: s5hcJAkWsTw\n\n## Notes\n(0:28)\n\n\n# Sizzle\n\n## Notes\n&nbsp;\n\n\n# Four Players Announcement\n\n## Notes\n&nbsp;\n\n\n# Question 1\n\n## Question\n\n### Sous quelles formes peut-on trouver les sources d'eau naturelles?\n\n## Answer\n\n### Quelques sources d'eau naturelles :\n* Les océans\n* Les mers\n* Les lacs\n* Les calottes glacières\n* Les eaux souterraines\n* L'eau dans l'atmosphère\n\n## Answer Notes\n&nbsp;\n\n\n# Question 2\n\n## Question\n\n### Quels types de sources d'eau trouve-on près de votre domicile ou école?\n\n## Answer\n\n### Chaque classe de gardiens de la planète se trouve près de sources différentes.\nIl est possible que vous soyez près d'une crique, d'un ruisseau ou d'une rivière et peut-être même d'un lac, d'un océan ou d'un glacier!\n\n## Answer Notes\n&nbsp;\n\n\n# Question 3\n\n## Question\n\n### Connaissez-vous le nom d'une des sources d'eau naturelles près de votre domicile ou école?\nVous pouvez d'abord y réfléchir en équipe!\n\n## Answer\n\n### Chaque classe de gardiens de la planète se trouve près de sources différentes.\n* Vous pouvez situer votre école sur une carte pour trouver les réponses que vous ne connaissez pas.\n* Activité-boni : Trouvez la source d'eau la plus près de l'école et, si possible, allez-y! \n\n## Answer Notes\n&nbsp;\n"

/***/ }),
/* 1694 */
/***/ (function(module, exports) {

	module.exports = "# Game Show\nLevel 4 - Connect in Place\n\n# Intro Video\nYouTube: 5HoJkjJJ4PI\n\n## Notes\nIntro to Game Show (0:28).\n\n\n# Sizzle\n\n## Notes\nGame Show\n\n\n# Four Players Announcement\n\n## Notes\nFour players to the front.\n\n\n# Question 1\n\n## Question\n\n### What forms can natural sources of water take?\n\n## Answer\n\n### Some natural sources of water:\n* Oceans\n* Seas\n* Lakes\n* Ice caps\n* Groundwater\n* In the atmosphere\n\n## Answer Notes\n&nbsp;\n\n\n# Question 2\n\n## Question\n\n### What types of natural water are near your home or school?\n\n## Answer\n\n### Every Planet Protector classroom is near different water.\nYou likely have creeks, rivers, streams, and maybe also lakes, oceans, even glaciers!\n\n## Answer Notes\n&nbsp;\n\n\n# Question 3\n\n## Question\n\n### Do you know the name of a natural source of water near your home or school?\nOption to brainstorm in your teams first!\n\n## Answer\n\n### Every Planet Protector classroom is near different water.\n* You can look up your school on a map to find the answers if you don't know already.\n* Bonus activity: Find out where the closest water is to your school, and, if you can, visit it!\n\n## Answer Notes\n&nbsp;\n"

/***/ }),
/* 1695 */
/***/ (function(module, exports) {

	module.exports = "# Sizzle\n\n## Content\n\n### Activité 1 : Remue-méninges d'équipe!\n\n## Notes\n&nbsp;\n\n\n# Instructions\n\n## Content\n\n### Instructions\n* En équipe, dressez une liste de tous les mots qui décrivent l'eau. Trouvez-en le plus possible en 2 minutes.\n* Quel est l'aspect physique de l'eau? Son goût, son odeur, sa texture (p. ex., « mouillé »).\n* Un point pour chaque mot!\n\n## Notes\n&nbsp;\n"

/***/ }),
/* 1696 */
/***/ (function(module, exports) {

	module.exports = "# Sizzle\n\n## Content\n\n### Activity 1: Team Brainstorm!\n\n## Notes\nActivity: Team brainstorm\n\nActivity instructions on next slide.\n\n\n# Instructions\n\n## Content\n\n### Instructions\n* As a team, in two minutes, brainstorm a list of as many words as you can think of that describe water.\n* What does water look, taste, smell, touch, feel like? (eg. \"wet\").\n* One point for each water word!\n\n## Notes\n\n&nbsp;\n"

/***/ }),
/* 1697 */
/***/ (function(module, exports) {

	module.exports = "# Sizzle\n\n## Content\n\n### Activité 2 : Écrivez un poème\n(facultatif, si le temps le permet)\n\n## Notes\n&nbsp;\n\n\n# Instructions\n\n## Content\n\n### Instructions\nAvec les mots de votre liste :\n* écrivez un poème sur l'eau et présentez-le à votre classe.\n* faites-en un rap, si vous voulez!\n\n## Notes\n&nbsp;\n\n\n# Scoring\n\n## Content\n\n### Présentez-le maintenant à votre classe!\nObtenez des points :\n* pour deux vers qui riment.\n* pour une présentation dynamique.\n* pour du beatboxing (si vous faites un rap).\n* si vous êtes un bon public.\n\n## Notes\n&nbsp;\n"

/***/ }),
/* 1698 */
/***/ (function(module, exports) {

	module.exports = "# Sizzle\n\n## Content\n\n### Activity 2: Write a Poem\n(optional if you have time)\n\n## Notes\nActivity: Write a Poem\n\nActivity instructions on next slide.\n\n\n# Instructions\n\n## Content\n\n### Instructions\nUse your list of words about water to:\n* Write a poem about water and perform the poem for your class.\n* Option to perform it as a rap!\n\n## Notes\n\n&nbsp;\n\n\n# Scoring\n\n## Content\n\n### Now perform for the class!\nGet points for:\n* Two lines that rhyme.\n* Good performance.\n* Beatboxing (if you're rapping).\n* Being a good audience.\n\n## Notes\n\n&nbsp;\n"

/***/ }),
/* 1699 */
/***/ (function(module, exports) {

	module.exports = "# Sizzle\n\n## Content\n\n### Activité : Dessin de groupe\n\n## Notes\n&nbsp;\n\n\n# Instructions\n\n## Content\n\n### Instructions\nDessinez votre système local d'eau, de la source jusqu'au robinet :\n* D'où vient l'eau (puit, rivière, lac, bassin versant)?\n* Où l'entrepose-t-on (réservoir, bassin de stockage, etc.)?\n* Où est-elle traitée (usine de traitement des eaux)?\n* Comment se rend-elle de l'usine de traitement jusqu'à votre domicile (pompes à eau et canalisations vers le domicile)?\n* Comment circule-t-elle dans le domicile (tuyaux dans les murs)?\n* Par où sort-elle (robinet, toilette, douche)?\n\n## Notes\n&nbsp;\n\n\n# Scoring\n\n## Content\n\n### Pour accumuler des points\n* 1 point pour chaque lieu illustré (rivière, bassin, usine, tuyaux, domicile, robinet, etc.)\n* Des points-bonis pour un bon travail d'équipe et une présentation dynamique.\n\n## Notes\n&nbsp;\n"

/***/ }),
/* 1700 */
/***/ (function(module, exports) {

	module.exports = "# Sizzle\n\n## Content\n\n### Activity: Group Drawing\n\n## Notes\nActivity: Group Drawing\n\nActivity instructions on next slide.\n\n\n# Instructions\n\n## Content\n\n### Instructions:\nIn your teams or individually, draw your local water system from source to tap:\n* Where does it come from? (well, river, lake, watershed)\n* Where is it stored? (reservoir, storage tanks, etc.)\n* Where is it treated? (water treatment plant)\n* How does it move from the treatment plant to your home? (water pumps & pipes to your home)\n* How does it move in your house? (pipes in the wall)\n* Where does it come out? (taps, toilet, shower)\n\n## Notes\n&nbsp;\n\n\n# Scoring\n\n## Content\n\n### Scoring\n* 1 point for every location drawn (river, reservoir, treatment plant, pipes, house, taps, etc.)\n* Bonus points for everyone working together and a good presentation.\n\n## Notes\n&nbsp;\n"

/***/ }),
/* 1701 */
/***/ (function(module, exports) {

	module.exports = "# Sizzle\n\n## Content\n\n### Activité : Créer une affiche\n\n## Notes\n&nbsp;\n\n\n# Instructions\n\n## Content\n\n### Instructions\n* Chaque membre de l'équipe dessine une affiche pour son domicile qui indiquera à sa famille les meilleurs moyens de réduire la pollution d'eau.\n* Consultez votre livre de missions pour trouver des moyens de réduire la pollution d'eau et choisissez-en au moins deux pour votre affiche.\n* Les apprenti(e)s recoivent des points quand leur affiche est terminée.\n\n## Notes\n&nbsp;\n"

/***/ }),
/* 1702 */
/***/ (function(module, exports) {

	module.exports = "# Sizzle\n\n## Content\n\n### Activity: Create a Poster\n\n## Notes\nActivity: Create a Poster\n\nActivity instructions on next slide.\n\n\n# Instructions\n\n## Content\n\n### Instructions\n* Each team member draws a poster to take home to remind their family about specific ways to reduce water pollution.\n* See your mission book for ways to reduce water pollution, and choose at least two for your poster.\n* Apprentices get points for completing their poster.\n\n## Notes\n&nbsp;\n"

/***/ }),
/* 1703 */
/***/ (function(module, exports) {

	module.exports = "# Sizzle\n\n## Content\n\n### Activité: Créer un sketch!\n\n## Notes\n&nbsp;\n\n\n# Instructions\n\n## Content\n\n### Instructions\n* Dans votre sketch, vous et quelques amis jouissez d'une activité aquatique lorsque vous remarquez quelqu'un qui nuit à l'eau.\n* Vous réussissez à le convaincre poliment de devenir un gardien de la planète et de protéger l'eau.\n* Répétez votre sketch en équipe (10 min.) et présentez-le à la classe!\n\n## Notes\n&nbsp;\n"

/***/ }),
/* 1704 */
/***/ (function(module, exports) {

	module.exports = "# Sizzle\n\n## Content\n\n### Activity: Make a Skit!\n\n## Notes\nActivity: Make a Skit\n\nActivity instructions on next slide.\n\n\n# Instructions\n\n## Content\n\n### Instructions\n* In this skit, you and a few friends are enjoying a water activity, when you notice someone hurting water.\n* In a kind way, convince that person to be a Planet Protector and to protect water.\n* Practice the skit as a team (10 min) and then perform for your class!\n\n## Notes\n&nbsp;\n"

/***/ }),
/* 1705 */
/***/ (function(module, exports) {

	module.exports = "# Mission Assignment\nTitle: Opération Robinets fermés\n\n## Notes\n&nbsp;\n\n\n# Instructions\n\n## Content\n\n### Mission 1 :\n\n#### Fermez les robinets. Ne laissez pas couler l'eau!\nPour accumuler des points:\n* Fermez les robinets quand vous vous brossez les dents, vous vous lavez les mains, vous lavez la vaisselle, etc.\n* Rappelez-le à votre famille.\n* Ramenez votre dossier de missions signé.\n* Les agents de formation (autrement dit, les enseignant(e)s) peuvent aussi participer à la mission!\n\n## Notes\n&nbsp;\n\n\n# Mission Files\n\n## Content\n\n### Sortez votre dossier de missions!\n* Allez à la Mission 1 de votre dossier de missions.\n* Confirmez la date à laquelle vous allez effectuer le niveau en classe. Inscrivez-la sur la page couverture de votre dossier de missions et à la page de la Mission 1.\n* Consignez vos points dans votre dossier de missions.\n* Pour obtenir des points-bonis, faites signer un parent/tuteur dans la section Rapport de mission à la page de la Mission 1! \n\n## Notes\n&nbsp;\n"

/***/ }),
/* 1706 */
/***/ (function(module, exports) {

	module.exports = "# Mission Assignment\nTitle: Operation Taps Off\n\n## Notes\n&nbsp;\n\n\n# Instructions\n\n## Content\n\n### Mission 1:\n\n#### Turn off the taps. Don't let the water run!\nGet points every time you:\n* Turn off the taps when brushing teeth, washing hands, dishes etc.\n* Remind your family to do the same.\n* Bring back your signed Mission Files.\n* Training Agents (a.k.a teachers!) can do this mission too!\n\n## Notes\n&nbsp;\n\n\n# Mission Files\n\n## Content\n\n### Get Out Your Mission Files!\n* Turn to Mission 1 in your Mission Files.\n* Confirm which day you'll do the next level in class. Write that date on the cover of your Mission Files and on the Mission 1 page.\n* Record your points in your Mission Files.\n* Get your parents/guardians to sign the Mission Report section on the Mission 1 page for extra points!\n\n## Notes\n&nbsp;\n"

/***/ }),
/* 1707 */
/***/ (function(module, exports) {

	module.exports = "# Intro Video\nYouTube: qXwrKPCGHck\n\n## Notes\n(4:50)\n\n\n# Mission Assignment\nTitle: Opération Économiser l'eau\n\n## Notes\n&nbsp;\n\n\n# Instructions\n\n## Content\n\n### Mission 2 :\n\n#### Économisez le plus d'eau possible!\nAccumulez des points pour chaque geste suivant que vous posez ou rappelez à la famille :\n* Toujours fermer les robinets\n* Se doucher rapidement (5 min. max.!)\n* Démarrer le lave-vaiselle ou la laveuse à linge seulement quand il ou elle est plein(e)\n\n## Notes\n&nbsp;\n\n\n# Mission Files\n\n## Content\n\n### Sortez votre dossier de missions!\n* Allez à la Mission 2 de votre dossier de missions.\n* Confirmez la date à laquelle vous allez compléter le niveau en classe. Inscrivez-la sur la page couverture de votre dossier de missions et à la page de la Mission 2.\n* Enregistrez vos points dans votre dossier de missions.\n* Pour obtenir des points-bonis, faites signer un parent/tuteur dans la section Rapport de mission à la page de la Mission 2!\n\n## Notes\n&nbsp;\n"

/***/ }),
/* 1708 */
/***/ (function(module, exports) {

	module.exports = "# Intro Video\nYouTube: LME7lCGBbMM\n\n## Notes\nEsmeralda and Goober have their showdown with Dr Dubious, give second mission (4:50).\n\n\n# Mission Assignment\nTitle: Operation Save Water\n\n## Notes\n&nbsp;\n\n\n# Instructions\n\n## Content\n\n### Mission 2:\n\n#### Save as much water water as you can!\nGet points every time you do these actions, or remind your family members to:\n* Keep turning off taps\n* Take short showers (5 minutes max!)\n* Only run full loads in your washing machine and dishwasher\n\n## Notes\n&nbsp;\n\n\n# Mission Files\n\n## Content\n\n### Get Out Your Mission Files!\n* Turn to Mission 2 in your Mission Files.\n* Confirm which day you'll do the next level in class. Write that date on the cover of your Mission Files and on the Mission 2 page.\n* Get your parents/guardians to sign the Mission Report section on the Mission 2 page.\n\n## Notes\n&nbsp;\n"

/***/ }),
/* 1709 */
/***/ (function(module, exports) {

	module.exports = "# Mission Assignment\nTitle: Opération Protéger l'eau\n\n## Notes\n&nbsp;\n\n\n# Instructions\n\n## Content\n\n### Mission 3 :\n\n#### Respectez le Code de protection de l'eau!\nDans votre dossier de missions, vous trouverez le Code de protection de l'eau. Vous accumulez un point pour chaque geste suivant :\n* Respect du Code\n* Rappel/enseignement du Code à un membre de la famille\n* Explication à un membre de la famille de pourquoi il est important de protéger l'eau\n\n## Notes\n&nbsp;\n\n\n# Mission Files\n\n## Content\n\n### Sortez votre dossier de missions!\n* Allez à la Mission 3 de votre dossier de missions.\n* Confirmez la date à laquelle vous allez compléter le niveau en classe. Inscrivez-la sur la page couverture de votre dossier de missions et à la page de la Mission 3.\n* Enregistrez vos points dans votre dossier de missions.\n* Pour obtenir des points-bonis, faites signer un parent/tuteur dans la section Rapport de mission à la page de la Mission 3!\n\n## Notes\n&nbsp;\n"

/***/ }),
/* 1710 */
/***/ (function(module, exports) {

	module.exports = "# Mission Assignment\nTitle: Operation Protect Water\n\n## Notes\n&nbsp;\n\n\n# Instructions\n\n## Content\n\n### Mission 3:\n\n#### Follow the Water Protector Code!\nIn your Mission Files you will see the Water Protector Code. Get a point every time you:\n* Follow the Code  \n* Remind/teach a family member about the Code\n* Tell a family member why we need to protect water\n\n## Notes\n&nbsp;\n\n\n# Mission Files\n\n## Content\n\n### Get Out Your Mission Files!\n* Turn to Mission 3 in your Mission Files.\n* Confirm which day you'll do the next level in class. Write that date on the cover of your Mission Files and on the Mission 3 page.\n* Get your parents/guardians to sign the Mission Report section on the Mission 3 page.\n\n## Notes\n&nbsp;\n"

/***/ }),
/* 1711 */
/***/ (function(module, exports) {

	module.exports = "Finish\n\n# Scoreboard Recap\n\n## Content\n\n### Consultez le tableau des points pour voir qui est en tête!\n\n## Notes\n&nbsp;\n\n\n# Earn More Points\n\n## Content\n\n### Tous auront la chance d'accumuler plus de points!\n* Ramenez votre dossier de missions à la maison.\n* Effectuez les missions et inscrivez ce que vous avez fait.\n* Écoutez et participez en classe!\n\n## Notes\n&nbsp;\n\n\n# Farewell\n\n## Content\n\n### Continuez de vous amuser!\n\n#### Consultez AndGoober.com pour obtenir plus de jeux et d'activités.\n\nPassez à la prochaine diapo pour terminer le niveau.\n\n## Notes\n&nbsp;\n\n\n# Farewell Last\n\n## Content\n\n### À la prochaine, chers (chères) apprenti(e)s!\n\n#### Pour plus de plaisir, rendez-vous sur AndGoober.com.\n\nPassez à la prochaine diapo pour terminer le niveau.\n\n## Notes\n&nbsp;\n"

/***/ }),
/* 1712 */
/***/ (function(module, exports) {

	module.exports = "Finish\n\n# Scoreboard Recap\n\n## Content\n\n### Check out the scoreboard to see who's in the lead!\n\n## Notes\n\n&nbsp;\n\n\n# Earn More Points\n\n## Content\n\n### Everyone has a chance to earn more points!\n* Take home your Mission Files.\n* Do your missions and record what you did.\n* Listen & participate in class!\n\n## Notes\n\n&nbsp;\n\n\n# Farewell\n\n## Content\n\n### Keep the fun going!\n\n#### Visit *AndGoober.com* for games and activities\n\nGo to the next slide to finish the level\n\n## Notes\nTo finish, go to the next slide and click 'Click to end level'.\n\n\n# Farewell Last\n\n## Content\n\n### Til next time, Apprentices!\n\n#### For more fun, go to *AndGoober.com* for games and activities\n\nGo to the next slide to finish the level\n\n## Notes\nTo finish, go to the next slide and click 'Click to end level'.\n"

/***/ }),
/* 1713 */
/***/ (function(module, exports) {

	module.exports = "Ending\n\n# Announce Winners\n\n## Content\n\n### C'est l'heure d'annoncer les gagnants!\n\n#### Les agents de formation peuvent remettre les certificats.\n\n## Notes\n&nbsp;\n\n\n# Planet Protectors\n\n## Content\n\n### Vous êtes maintenant des superhéros pour la protection de la planète!\n\n#### Félicitations!\n\nContinuez de protéger la planète et de trouver des moyens d'économiser l'eau.\n\nÀ la prochaine! La gardienne Esmeralda et Goober vous saluent!\n\n## Notes\n&nbsp;\n\n\n# All Levels Completed\n\n## Notes\n&nbsp;\n"

/***/ }),
/* 1714 */
/***/ (function(module, exports) {

	module.exports = "Ending\n\n# Announce Winners\n\n## Content\n\n### Time to announce the winners!\n\n#### Training Agents please hand out certificates.\n\n## Notes\n\nPrint winning team certificates once you know who won; give all team members completion certificates now.\n\n### Extension Activity\nNow's a great time to do the papercraft activity!\n\n\n# Planet Protectors\n\n## Content\n\n### You are all now Planet Protecting superheroes!\n\n#### Congratulations!\n\nKeep protecting the planet, keep finding ways to save water!\n\nUntil next time, Esmeralda Planet Protector and Goober signing off!\n\n## Notes\n\nThank you for being a Training Agent and training your Apprentices!\n\n### Getting your feedback\n\nWe love to hear from teachers about their experience with the Academy. We'll be in touch in the next few days with a feedback survey!\n\n\n# All Levels Completed\n\n## Notes\n\nHave ideas for extension activities? Please share them with us!\n"

/***/ }),
/* 1715 */
/***/ (function(module, exports) {

	module.exports = "# Extension Activities\n\n&nbsp;\n"

/***/ }),
/* 1716 */
/***/ (function(module, exports) {

	module.exports = "# H2Whoa! Theme Song\n\nYouTube: ulOo2VuQEWA\n\n## Description\n\nSing and dance along to the *H2Whoa!* theme song anytime you like. Great for starting a lesson!\n\n\n# Esmeralda Planet Protector & The E-Waste Emergency\n\nYouTube: POzKQKxvuzQ\nLowRes: true\n\n## Description\n\nWatch Esmeralda and Goober fight the rise of electronic waste and the evil supervillain Blaster, with some help from our our Planet Protector friends!\n\n\n# Esmeralda Planet Protector & The Litterless Lunch\n\nYouTube: OeT53lGAYX4\nLowRes: true\n\n## Description\n\nEsmeralda and Goober take on Trashella to stop her from convincing kid to bring lunches that make litter!\n\n\n# Esmeralda Planet Protector & Walking To School\n\nYouTube: 1FmXmBOU-V8\nLowRes: true\n\n## Description\n\nCan Esmeralda Superspy Planet Protector and her sidekick Goober stop the Evil Dr. Carbon's dastardly plan to stop kids from walking to school?\n\n\n# Esmeralda Superspy: Backstage #1\n\nYouTube: BQyzd8Y7EaY\nLowRes: true\n\n## Description\n\nDo series stars Ian and Sara spend their time saving the environment and protecting the planet? No, because Ian keeps acting like a monkey! Even when the boss, Jacqueline, is around.\n\n\n# Esmeralda Superspy: Backstage #2\n\nYouTube: AEmVWqAie6s\nLowRes: true\n\n## Description\n\nTake a peak behind the scenes! Sara takes you on a tour of the set - or at least, she tries to. Ian keeps messing up her shots!\n\n\n# Esmeralda Superspy: Backstage #3\n\nYouTube: zZId4Rr2-Rw\nLowRes: true\n\n## Description\n\nIan thinks he's doing a safety speech for the funny environmental show \"Esmeralda Superspy\" but really, Sara is about to get her revenge on him for wrecking her scenes.\n\n\n# Good Green News: Vancouver Urban Gardens\n\nYouTube: dPD3BogYAKw\nLowRes: true\n\n## Description\n\nKid reporter Tia, 9, reports on the Good Green News in the city of Vancouver - Find out why Vancouver helped bring over 400 urban gardens to the city!\n"

/***/ }),
/* 1717 */
/***/ (function(module, exports) {

	module.exports = "# Level Completed\n\n## Content\n\n### Welcome back!\n* Use the **OVERVIEW** to go back to any Level and check out the videos in the\n**FUN** section!\n\n## Notes\n\nWelcome back!\n"

/***/ }),
/* 1718 */
/***/ (function(module, exports) {

	module.exports = "# Teacher Resources\n## Welcome!\nWe're so happy to be training environmental superheroes from {r/:$cityOrMunicipality}!\n\n#### *H2Whoa!* live show\nThese classroom-based modules are designed to follow on from the *H2Whoa!* live show you received at your school. If you've yet to receive the presentation, feel free to familiarize yourself with the classroom modules!\n\n#### Teacher's Guide\n* Download the [Teacher's Guide](Teachers_Guide.pdf) for a full overview of the program's contents and how it works.\n* The best way to orient yourself is to check out the student facing content by clicking 'Start Module 1'.\n\n#### Curriculum Links\nThe *H2Whoa!* follow-up modules supports curriculum standards in arts, science, language and social studies. The following connections are provided for your convenience:\n\n* {r/Canada/BC}[BC Grades K-7](CL_PPA-H2W-Hybrid_Canada_BC_Grades_K-7.pdf)\n* {r/} We don't have curriculum links for your area yet. Do you want to help us develop them? Please contact us!\n\n#### Need help from a human?\nGet in touch through the Messenger in the bottom right-hand corner!\n\n# Printables\n\n#### Required Print Materials\n\n* Mission Page for each child in [{r/Canada:colour}{r/:color}](Printables_Mission_Page_Colour.pdf) or [black & white](Printables_Mission_Page_BW.pdf).\n* ID Cards for each child in [{r/Canada:colour}{r/:color}](Printables_ID_Cards_Colour.pdf) or [black & white](Printables_ID_Cards_BW.pdf).\n* Completion certificates for each child in [{r/Canada:colour}{r/:color}](Printables_Completion_Certificates_Colour.pdf) or [black & white](Printables_Completion_Certificates_BW.pdf).\n\n#### Optional Print Materials\n* Winning team certificates in [{r/Canada:colour}{r/:color}](Printables_Winning_Certificates_Colour.pdf) or [black & white](Printables_Winning_Certificates_BW.pdf).\n"

/***/ }),
/* 1719 */
/***/ (function(module, exports) {

	module.exports = "# Module 1 Overview\r\n\r\n#### At a glance\r\n##### Duration: 20-60 minutes depending on activities used\r\n* Watch engaging videos.\r\n* Sing the *H2Whoa!* Theme Song.\r\n* Play a game show on how we value and use water, and how we can save it.\r\n* Draw a poster to encourage shorter showers.\r\n* Be assigned their mission.\r\n\r\n#### Getting into teams\r\n* Before starting the program, divide your class into four teams - Earth, Air, Fire and Water (we recommend you set up the teams ahead of time and that they remain the same for the duration of the program).\r\n* Each team will work together during the various arts-based activities and score points for participating, collaborating, listening etc.\r\n* It's a flexible system for you to reward the {r/Canada:behaviour}{r/:behavior} you want to see in your class!\r\n\r\n#### Key Vocabulary\r\n* Drinking Water\r\n* Reservoir\r\n\r\n# Materials\r\n\r\n#### What you need for this level\r\n* Mission Page for each student in [{r/Canada:colour}{r/:color}](Printables_Mission_Page_Colour.pdf) or [black & white](Printables_Mission_Page_BW.pdf).\r\n"

/***/ }),
/* 1720 */
/***/ (function(module, exports) {

	module.exports = "# Module 2 Overview\n\n#### At a glance\n##### Duration: 20-60 minutes depending on activities used\n* Watch engaging videos.\n* Sing the *H2Whoa!* Theme Song.\n* Play a game show about water sources and different things that pollute water.\n* Write a poem about water.\n* Be assigned their second mission.\n\n#### Key Vocabulary\n* Pollution\n* Water Sources\n\n# Materials\n\n#### What you need for this level\n* Each Apprentice requires their signed Mission Page\n"

/***/ }),
/* 1721 */
/***/ (function(module, exports) {

	module.exports = "# Tech Prep Wizard\n\n### Tech Prep Wizard\n\nThis short wizard will help you get set up to run the Academy in your classroom.\n\nDon't show your students the screen yet!\n\nClick the arrow or use your keyboard's right directional arrow to move through the wizard.\n\n# Two Device Intro\n\n### Two Device Experience\nThe Academy is best experienced using two devices:\n* Main device (COMPUTER or TABLET) projects the website at the front of the class.\n* Second device (TABLET or CELLPHONE) can be as a remote control (optional):\n  * gives you freedom to move around the classroom.\n  * contains prompts and facilitation notes at your finger tips.\n  * provides useful progress indicators, such as length of videos and number of slides remaining.\n\n# Connecting Remote\n\n### Connect your remote!\nTo connect a second device as a Remote Control:\n1. Go to www.remote4ppa.com on your tablet/phone.\n2. Enter your username and password on your tablet/phone.\n3. Go to the next slide to Select Role For This Device.\n4. Choose the right Role for each device.\n5. Your selections will be saved for future use, but you can always change it later!\n\n# Tech Check Intro\n\n### Tech Check!\nNOW PLEASE hook up your main device to your projector and **test the audio/video** to make sure everything's working! There's a fun video in the next slide to help you do this (it's also in the Fun section if you want to share with your class).\n\n#### Full Screen Experience\nThe Planet Protector Academy is best enjoyed as a full screen experience. **Click 'View'** in your browser's menu bar, and select **'Full Screen'** (Chrome) or **'Enter Full Screen'** (Safari/Firefox).\n\n# Tech Check Video\nYouTube: ZVdMndkjaIo\n"

/***/ }),
/* 1722 */
/***/ (function(module, exports) {

	module.exports = "# Program Start\n\n# Level 1 Start\n\n## Notes\n\n### Start\n\nShow this screen at the start of class. When the kids are ready, advance to the next screen.\n\nUse the directional arrows on your remote to go forwards/backwards through the level.\n\n# Level 1 Icon\n\n## Notes\n\nLevel 1\n\n### Tracking your progress\n\nYou can see how far along you are by the slide number on the top of your Remote Control or by the blue progress bar running along the bottom of the Menu on the Classroom Display.\n\n### Problems with your video buffering?\nPause the video and wait a minute for it to pre-load, then it should play without a hitch!\n\n# Level 2 Start\n\n## Notes\n\n### Start\n\nShow this screen at the start of class. When the kids are ready, advance to the next screen.\n\n# Level 2 Icon\n\n## Notes\n\nLevel 2\n"

/***/ }),
/* 1723 */
/***/ (function(module, exports) {

	module.exports = "# Level 1 Intro\n\n## Content\n\n### Welcome, Planet Protectors!\n\n#### Why not start with a song?\n\n## Notes\n\n&nbsp;\n\n# Level 2 Intro\n\n## Content\n\n### Welcome, Planet Protectors!\n\n#### Get ready to sing!\n\n## Notes\n\n&nbsp;\n\n# Song\nYouTube: ulOo2VuQEWA\n\n\n## Notes\n\n### H2Whoa! Song\n\nEncourage your class to learn this song and sing along to the video (3:02).\n\n### Extension Activities\nApprentices can perform the song to the whole school and/or create their own choreography.\n"

/***/ }),
/* 1724 */
/***/ (function(module, exports) {

	module.exports = "Team Creation\n\n# Welcome Video\n\nYouTube: 7tEwMXlO_HI\n\n## Notes\nThe Apprentices are welcomed to the Academy by Esmeralda and Goober (2:59).\n\n# Get Into Teams\n\n## Content\n\n###### Get into four teams!\n\nName your teams in the next slide.\n\n## Notes\n\nName teams in the next slide. Once you enter the name in the text field, it automatically saves!\n\n# Scoring Intro\n\n## Content\n\n### Here's how your team can score points\n\n* Answer questions\n* Do activities\n* Complete missions\n* Work well together (teamwork points)\n* and more!\n\n## Notes\n\n### Scoring\n* Teams can earn points for most activities in the program. You can allocate points as you see fit. Maximum points total is 999.\n* Individuals can earn points for teams, or teams can earn points together.\n* Teamwork points are critical to ensure collaboration.\n* Points can also be a classroom \"currency\", e.g.to gain classroom privileges.\n* The team with the most points at the end of Level 3 is the winner.\n\n# Scoreboard Intro\n\n## Content\n\n### Check out the scoreboard!\n\n(In the top left corner, click MENU and then SCORES)\n\nYour teams are now ready to start scoring points!\n\n## Notes\n\nClick on the 'Scoreboard' icon on your remote at any time to bring down the scoreboard and add points for teams.\n\n# Congratulations\n\n## Content\n\n### Congratulations!\n\n#### You're now Apprentices in the Emergency Preparedness Squad!\n\n## Notes\n\n&nbsp;\n"

/***/ }),
/* 1725 */
/***/ (function(module, exports) {

	module.exports = "# Mission Report\nTitle: Know Your Reservoirs\n\n# Questions\n\n## Content\n\n1. Number of Apprentices and Teachers reporting in.\n2. Number of teams that named at least one reservoir.\n3. Total number of Apprentices whose teams answered #2 correctly.\n"

/***/ }),
/* 1726 */
/***/ (function(module, exports) {

	module.exports = "# Mission Report\nTitle: Save Water\n\n# Intro Video\n\nYouTube: FMczloWrKp0\n\n## Notes\n\nSara and Ian introduce the mission report (0:16)\n\n# Scoring\n\n## Content\n\n### Get points for your missions!\n\n* Get out your completed mission page\n* Add up your team's total points\n* Add your points to the scoreboard! (click \"Menu\" top left!)\n\n## Notes\n\nThis slide only covers actions listed under 'Get a point for' for each mission.\nStudents report the Mission Report section next.\n\n# Instructions\n\n## Content\n\n### Time to report to HQ!\n\n* Answer with a show of hands.\n* If you or anyone in your family is saving more water now, say yes!\n* If you haven't really changed, don't put up your hand.\n\n## Notes\n\n### Mission Reports\n* Mission reports help us communicate the impact of our program. Thanks for helping us to measure it!\n* Using a show of hands keeps the data anonymous.\n\n# Questions\n\n## Content\n\n1. Number of Apprentices and Teachers reporting in.\n2. At least one person in my family is turning off taps more now.\n3. At least one person in my family is having shorter showers now.\n4. My family is now doing another water saving action that they didn’t do before (eg. full loads of laundry, etc.)\n5. My parents/guardians pledged to let the rain water our lawn.\n6. I pledge to be a water protector from now on!\n\n# Impact\n\n## Content\n\n### Awesome work, Apprentices!\n\nYour Mission Report was received by Planet Protector Academy HQ.\n\n## Notes\n\nGreat job!\n\n# Class Discussion\n\n## Content\n\n### Class Discussion\n* As a class, discuss what was easy or hard about this mission.\n* What worked, what didn’t work?\n* What would make it easier?\n\n## Notes\n\nEncourage Apprentices who did not succeed to keep trying, if appropriate.\n"

/***/ }),
/* 1727 */
/***/ (function(module, exports) {

	module.exports = "Level 1\n\n# Intro Video\n\nYouTube: xlESv9kND64\n\n## Notes\n\nShort message from Esmeralda and Goober. Sara and Ian introduce the Game Show (2:31)\n\n# Sizzle\n\n## Notes\n\n### Game Show\nIn the Game Show we ask questions relating to the topic *before* giving the answers, in order to stimulate thinking, rather than to test knowledge.\n\nOne Apprentice from each team will come up to the front of the class and get a chance to answer the question in turn.\n\nFor more info, see \"Game Show Info\" in the Teachers Guide, which is available in the Teacher Resources section on the Dashboard page.\n\n# Scoring\n\n## Content\n\n### How to score points\n* Do your Planet Protector pose.\n* Buzz in first.\n* Give a good answer. Try your best!\n* If you don’t know the answer, think about what a good answer might be. This is not a test!\n\n## Notes\n\nDon't forget to score points on the Scoreboard!\n\n# Four Players Announcement\n\n## Notes\n\n* One Apprentice from each team comes to the front of the room.\n* Encourage a different Apprentice to come up for each question.\n\n# Question 1\n\n## Question\n\n#### Name one way you enjoy water.\n\n## Answer\n\n### There are many ways!\nYou can enjoy:\n* Drinking cold water on a hot day\n* Water sports\n* Jumping off a dock\n* The feeling of a hot shower on your skin\n* Water parks, water fights\n* Etc.\n\n## Answer Notes\n\n&nbsp;\n\n# Scoring Reminder\n\n## Content\n\n### Don't forget to add scores!\n\n## Notes\n\nClick on the 'Scores' button below to open up the Scoreboard.\n\n# Question 2\n\n## Question\n\n#### Name one way you use water in the home.\n\n## Answer\n\n### Ways you can use water in the home:\n* Washing clothes and dishes\n* Using the toilet\n* Showering, washing hands\n* Watering plants\n* Brushing teeth\n* Cooking, cleaning the house\n* Etc.\n\n## Answer Notes\n\n&nbsp;\n\n# Question 3\n\n## Question\n\n#### Name one way you can save water.\n\n## Answer\n\n### Some ways to save:\n* Turn off taps when brushing teeth\n* Take shorter showers (5 min max!)\n* Let the rain water the lawn\n* Have a rain barrel\n* Only do full loads of laundry/dishes\n* Obey city water restrictions\n* Etc.\n\n## Answer Notes\n\n&nbsp;\n\n# Question 4\n\n## Question\n\n#### Team brainstorm - name the reservoirs our drinking water come from.\nScoring: One point per reservoir you guess right!\n\n## Answer\n\n#### Greater Vancouver has three water reservoirs, collecting and storing our water supply:\n* Capilano Reservoir\n* Seymour Reservoir\n* Coquitlam Reservoir\n\n## Answer Notes\n\n&nbsp;\n"

/***/ }),
/* 1728 */
/***/ (function(module, exports) {

	module.exports = "Level 2\n\n# Intro Video\n\nYouTube: qZLvEs-aIxM\n\n## Notes\n\nSara and Ian introduce the Game Show (0:47).\n\n# Sizzle\n\n## Notes\n\nGame Show\n\n# Scoring\n\n## Content\n\n### Reminder:\n* Do your Planet Protector pose.\n* Buzz in first.\n* Give a good answer.\n* If you don’t know the answer, think about what a good answer might be. This is not a test!\n\n## Notes\n\nDon't forget to score points on the Scoreboard!\n\n# Four Players Announcement\n\n## Notes\n\nFour players to the front.\n\n# Question 1\n\n## Question\n\n#### Name something that pollutes water.\n\n## Answer\n\n### Some things that pollute water include:\n* Chemicals, non-biodegradable soaps and household cleaners\n* Plastics\n* Garbage\n* Flushing wipes\n* Oil and gas spills\n* Etc.\n\n## Answer Notes\n\n&nbsp;\n\n# Scoring Reminder\n\n## Content\n\n### Don't forget to add scores!\n\n## Notes\n\nClick on the 'Scores' button below to open up the Scoreboard.\n\n# Question 2\n\n## Question\n\n#### Water is found in a lot of places in nature.\n#### Name one source of water.\n\n## Answer\n\n### Sources of water:\n* River, stream, creek\n* Lake, pond, ocean\n* Spring, well\n* Rainfall, snow\n* Glacial runoff\n\n## Answer Notes\n\n&nbsp;\n\n# Question 3\n\n## Question\n\n#### Name a sport played on or in water.\n\n* This question is optional\n\n## Answer\n\n### Sports on or in water:\n* Skiing\n* Snowboarding\n* Ice skating\n* Swimming\n* Water polo\n* Kayaking, canoeing\n* Water skiing\n* Etc.\n\n## Answer Notes\n\n&nbsp;\n"

/***/ }),
/* 1729 */
/***/ (function(module, exports) {

	module.exports = "# Sizzle\n\n## Content\n\n### Activity: Drawing!\n\n* This activity is optional\n\n## Notes\n\n&nbsp;\n\n# Intro Video  \n\nYouTube: AkLnS6hd8Q4\n\n## Notes\nMrs G introduces the Drawing activity (0:46).\n\n# Instructions\n\n## Content\n\n### Make a Shower Power Poster\n* Remind you and your family that you have the power to take a short shower - and save energy.\n* Experiment with different media if they’re available! e.g. collage, ink, {r/Canada:coloured}{r/:colored} pencils, crayons.\n* Showers should be 5 minutes max!\n* Put your poster in or near your bathroom at home.\n* Apprentices get points for completing their poster.\n\n## Notes\n\n&nbsp;\n"

/***/ }),
/* 1730 */
/***/ (function(module, exports) {

	module.exports = "# Sizzle\n\n## Content\n\n### Activity: Writing\n\n* This activity is optional\n\n## Notes\n\nActivity instructions on next slide.\n\n# Instructions\n\n## Content\n\n### Activity Instructions:\n* Get into your teams\n* Write down as many words you can think of about water (taste, touch, activities, weather, etc. etc.)\n* You have two minutes!\n\n## Notes\n\n&nbsp;\n\n# Write Poem\n\n## Content\n\n### Write a Poem!\n* As a team, use your words to write a poem.\n* 1 point for every line of poetry.\n* Bonus points for rhymes and rhythm!\n\n## Notes\n\n&nbsp;\n\n# Scoring Reminder\n\n## Content\n\n### Don't forget to add scores!\n\n## Notes\n\n&nbsp;\n"

/***/ }),
/* 1731 */
/***/ (function(module, exports) {

	module.exports = "# Mission Assignment\n\nTitle: Save Water!\n\n## Notes\n&nbsp;\n\n# Mission Intro Video\n\nYouTube: JZIqV3eQvIU\n\n## Notes\n\nIan and Sara introduce Mission 1 - Save Water (1:26).\n\n### Make a Plan\n* Apprentices turn to their Mission File.\n* Decide which day you will do the next Level.\n* Points are awarded for signed and returned Mission page.\n\n# Instructions\n\n## Content\n\n### Mission 1:\n\n#### Get points for your team for:\n* Turning off taps, taking shorter showers, etc.\n* Reminding your family to turn off taps, take shorter showers, etc.\n* Getting your parents/guardians to pledge to let the rain water their garden.\n\n## Notes\n\n&nbsp;\n"

/***/ }),
/* 1732 */
/***/ (function(module, exports) {

	module.exports = "# Mission Assignment\n\nTitle: Keep Saving Water!\n\n## Notes\n&nbsp;\n\n# Mission Intro Video\n\nYouTube: REPLACEME\n\n## Notes\n\nIan and Sara introduce Mission 2 - Keep Saving Water! (REPLACEME).\n"

/***/ }),
/* 1733 */
/***/ (function(module, exports) {

	module.exports = "Finish\n\n# Scoreboard Recap\n\n## Content\n\n### Check out the scoreboard to see who's in the lead!\n\n## Notes\n\n&nbsp;\n\n# Earn More Points\n\n## Content\n\n### Everyone has a chance to earn more points!\n* Take home your Mission Files.\n* Do your missions and record what you did.\n* Listen & participate in class!\n\n## Notes\n\n&nbsp;\n\n# Level 1 Farewell Video\n\nYouTube: s15KiwJG9hk\n\n## Notes\n\nIan and Sara say farewell for Level 1 (0:15).\n\n# Level 2 Farewell Video\n\nYouTube: 7OlHYpSFk7Y\n\n## Notes\n\nIan and Sara say farewell (1:14).\n\n# Farewell\n\n## Content\n\n### Keep the fun going!\n\n#### Visit *AndGoober.com* for games and activities\n\nGo to the next slide to finish the level\n\n## Notes\nTo finish, go to the next slide and click 'Click to end level'.\n"

/***/ }),
/* 1734 */
/***/ (function(module, exports) {

	module.exports = "Ending\n\n# Announce Winners\n\n## Content\n\n### Time to announce the winners!\n\n#### Teachers please hand out certificates.\n\n## Notes\n\nPrint winning team certificates once you know who won; give all team members completion certificates now.\n\n# Superheroes\n\n## Content\n\n### You are all now water saving superheroes!\n\n#### Congratulations!\n\n## Notes\n\nThank you for training your Apprentices!\n\n# All Levels Completed\n\n## Notes\n\n&nbsp;\n\n### Getting your feedback\n\nWe love to hear from teachers about their experience with the Academy. We'll be in touch in the next few days with a feedback survey!\n\nHave ideas for extension activities? Please share them with us!\n"

/***/ }),
/* 1735 */
/***/ (function(module, exports) {

	module.exports = "# Extension Activities\n\n#### All levels\n* Planet Protector Academy song\n  * Perform on Earth Day or at another assembly for your school with the karaoke version in the Fun section\n  * We’d love to hear about it or see a video!!\n  * For even more fun, Apprentices can create their own choreography.\n* Keep Cool video game\n  * Play the video game at home or in class!\n  * Access the game on the [DreamRider Productions website](http://www.dreamridertheatre.com/KeepCool/KeepCool.html)\n\n#### Level 1 - The Climate Conundrum\n* Climate  past and present\n  * Research recorded average temperatures, precipitation levels and any incidents of extreme weather that have occurred in the last 50-100 years in the season your team is focused on.\n  * Your illustrations should reflect your findings and the data must be featured in your work.\n  * Predict what the climate might be like in the next 50-100 years if the climate continues to change at its current rate.\n\n#### Level 2 - Operation Darkroom\n* Becoming a carbon neutral society\n  * Creative writing activity about ways we could get around in the future that are carbon neutral.\n  * Put them in role as inventors, that in 50 years from now, have invented a creative and carbon neutral way of {r/Canada:travelling}{r/:traveling}. What is it called? What is it built from/made of? What kind of energy does it need to run? What are the advantages? What are the drawbacks? How many people does it carry? How does it travel? Over land, water, air, all three?\n* Watch the live Keep Cool play\n  * DreamRider Productions’ Climate Change show, Keep Cool is a 40-minute, musical theatre show that teaches kids what they can do to reduce their energy consumption and minimize their “carbon footprint”.\n  * Kids will learn about positive actions they can take to offset climate change, specifically teaching them ways they can reduce carbon gas emissions.\n  * Watch free [on YouTube](http://bit.ly/1dO3oph)\n* Keep Cool play follow-up activity on reducing your carbon footprint\n  * Draw one way you learned to reduce their “carbon footprint” and write a pledge at the bottom of the page for how often you will make this change in you daily lives or of things you are already doing that make a difference. Examples:\n    * “I will ride my bike to Amy’s house every time I go to play.”\n    * “I ride the bus to school everyday.”\n    * “I will pack a litterless lunch for myself to bring to school each day.”\n\n#### Level 3 - Operation Shower Power\n\n* Art for change in a wider context\n  * Research or have the teacher show examples of artwork created with the intent of convincing the viewer to change their behavior or take action around an issue.\n  * Examples include painted murals with social justice messages, historical government propaganda artwork, advertisements and current public service announcements. \n  * Discuss what elements of written and visual messages make the artworks convincing (or not).\n  * Apply those same techniques to your own posters with the goal of convincing your household to take shorter showers (before you do the Level) or a local issue that's current for your community.\n* Picture Find: Wasting Water\n  * How is this family wasting water? Find 8 ways that water is being wasted in this picture.\n  * [Download the PDF for this activity](Extension_Activity_Wasting_Water.pdf).\n* Find The Path\n  * Goober has everything mixed up, help him remember where our tap water goes.\n  * [Download the PDF for this activity](Extension_Activity_Find_The_Path.pdf).\n\n#### Level 5 - Operation Go Car Free\n\n* Equity issues around transportation alternatives\n  * While a great idea to encourage kids to walk to school, options for transportation alternatives affect students very differently depending on where they live.\n  * With this in mind, discuss ways that transportation and urban planning at the level of local and state government shape what options are available for the general public to choose from.\n  * In particular, you might want to explore how families' access to public transit and living close to school, grocery stores etc. is related to racial/ethnic segregation of {r/Canada:neighbourhoods}{r/:neighborhoods} and families' income.\n  * Research your town or city's current urban planning goals. Transportation Plans are often available publicly on the municipality's website.\n  * You could also research local organizations that are working towards sustainable solutions for these goals on a larger scale. Each team could present about on organization to the rest of the class.\n  * If appropriate, write a letter to local city council members or state legislatures describing the importance of expanding public transportation, building safe bike routes for commuting, and sponsoring\n  carpooling programs.\n"

/***/ }),
/* 1736 */
/***/ (function(module, exports) {

	module.exports = "# Extension Activities\n\n#### All levels\n* Planet Protector Academy song\n  * Perform on Earth Day or at another assembly for your school with the karaoke version in the Fun section\n  * We’d love to hear about it or see a video!!\n  * For even more fun, Apprentices can create their own choreography.\n* Keep Cool video game\n  * Play the video game at home or in class!\n  * Access the game on the [DreamRider Productions website](http://www.dreamridertheatre.com/KeepCool/KeepCool.html)\n\n#### Level 1 - The Climate Conundrum\n* Climate  past and present\n  * Research recorded average temperatures, precipitation levels and any incidents of extreme weather that have occurred in the last 50-100 years in the season your team is focused on.\n  * Your illustrations should reflect your findings and the data must be featured in your work.\n  * Predict what the climate might be like in the next 50-100 years if the climate continues to change at its current rate.\n\n#### Level 2 - Operation Darkroom\n* Becoming a carbon neutral society\n  * Creative writing activity about ways we could get around in the future that are carbon neutral.\n  * Put them in role as inventors, that in 50 years from now, have invented a creative and carbon neutral way of {r/Canada:travelling}{r/:traveling}. What is it called? What is it built from/made of? What kind of energy does it need to run? What are the advantages? What are the drawbacks? How many people does it carry? How does it travel? Over land, water, air, all three?\n* Watch the live Keep Cool play\n  * DreamRider Productions’ Climate Change show, Keep Cool is a 40-minute, musical theatre show that teaches kids what they can do to reduce their energy consumption and minimize their “carbon footprint”.\n  * Kids will learn about positive actions they can take to offset climate change, specifically teaching them ways they can reduce carbon gas emissions.\n  * Watch free [on YouTube](http://bit.ly/1dO3oph)\n* Keep Cool play follow-up activity on reducing your carbon footprint\n  * Draw one way you learned to reduce their “carbon footprint” and write a pledge at the bottom of the page for how often you will make this change in you daily lives or of things you are already doing that make a difference. Examples:\n    * “I will ride my bike to Amy’s house every time I go to play.”\n    * “I ride the bus to school everyday.”\n    * “I will pack a litterless lunch for myself to bring to school each day.”\n\n#### Level 3 - Operation Shower Power\n\n* Art for change in a wider context\n  * Research or have the teacher show examples of artwork created with the intent of convincing the viewer to change their behavior or take action around an issue.\n  * Examples include painted murals with social justice messages, historical government propaganda artwork, advertisements and current public service announcements. \n  * Discuss what elements of written and visual messages make the artworks convincing (or not).\n  * Apply those same techniques to your own posters with the goal of convincing your household to take shorter showers (before you do the Level) or a local issue that's current for your community.\n* Picture Find: Wasting Water\n  * How is this family wasting water? Find 8 ways that water is being wasted in this picture.\n  * [Download the PDF for this activity](Extension_Activity_Wasting_Water.pdf).\n* Find The Path\n  * Goober has everything mixed up, help him remember where our tap water goes.\n  * [Download the PDF for this activity](Extension_Activity_Find_The_Path.pdf).\n\n#### Level 5 - Operation Go Car Free\n\n* Equity issues around transportation alternatives\n  * While a great idea to encourage kids to walk to school, options for transportation alternatives affect students very differently depending on where they live.\n  * With this in mind, discuss ways that transportation and urban planning at the level of local and state government shape what options are available for the general public to choose from.\n  * In particular, you might want to explore how families' access to public transit and living close to school, grocery stores etc. is related to racial/ethnic segregation of {r/Canada:neighbourhoods}{r/:neighborhoods} and families' income.\n  * Research your town or city's current urban planning goals. Transportation Plans are often available publicly on the municipality's website.\n  * You could also research local organizations that are working towards sustainable solutions for these goals on a larger scale. Each team could present about on organization to the rest of the class.\n  * If appropriate, write a letter to local city council members or state legislatures describing the importance of expanding public transportation, building safe bike routes for commuting, and sponsoring\n  carpooling programs.\n"

/***/ }),
/* 1737 */
/***/ (function(module, exports) {

	module.exports = "# Planet Protector Academy Theme Song\n\nYouTube: ulOo2VuQEWA\n\n## Description\n\nSing and dance along to the Academy's theme song anytime you like. Great for starting a lesson!\n\n\n# Esmeralda Planet Protector & The E-Waste Emergency\n\nYouTube: POzKQKxvuzQ\nLowRes: true\n\n## Description\n\nWatch Esmeralda and Goober fight the rise of electronic waste and the evil supervillain Blaster, with some help from our our Planet Protector friends!\n\n\n# Esmeralda Planet Protector & The Litterless Lunch\n\nYouTube: OeT53lGAYX4\nLowRes: true\n\n## Description\n\nEsmeralda and Goober take on Trashella to stop her from convincing kid to bring lunches that make litter!\n\n\n# Esmeralda Planet Protector & Walking To School\n\nYouTube: 1FmXmBOU-V8\nLowRes: true\n\n## Description\n\nCan Esmeralda Superspy Planet Protector and her sidekick Goober stop the Evil Dr. Carbon's dastardly plan to stop kids from walking to school?\n\n\n# Esmeralda Superspy: Backstage #1\n\nYouTube: BQyzd8Y7EaY\nLowRes: true\n\n## Description\n\nDo series stars Ian and Sara spend their time saving the environment and protecting the planet? No, because Ian keeps acting like a monkey! Even when the boss, Jacqueline, is around.\n\n\n# Esmeralda Superspy: Backstage #2\n\nYouTube: AEmVWqAie6s\nLowRes: true\n\n## Description\n\nTake a peak behind the scenes! Sara takes you on a tour of the set - or at least, she tries to. Ian keeps messing up her shots!\n\n\n# Esmeralda Superspy: Backstage #3\n\nYouTube: zZId4Rr2-Rw\nLowRes: true\n\n## Description\n\nIan thinks he's doing a safety speech for the funny environmental show \"Esmeralda Superspy\" but really, Sara is about to get her revenge on him for wrecking her scenes.\n\n\n# Good Green News: Vancouver Urban Gardens\n\nYouTube: dPD3BogYAKw\nLowRes: true\n\n## Description\n\nKid reporter Tia, 9, reports on the Good Green News in the city of Vancouver - Find out why Vancouver helped bring over 400 urban gardens to the city!\n"

/***/ }),
/* 1738 */
/***/ (function(module, exports) {

	module.exports = "# Planet Protector Academy Theme Song\n\nYouTube: ulOo2VuQEWA\n\n## Description\n\nSing and dance along to the Academy's theme song anytime you like. Great for starting a lesson!\n\n\n# Esmeralda Planet Protector & The E-Waste Emergency\n\nYouTube: POzKQKxvuzQ\nLowRes: true\n\n## Description\n\nWatch Esmeralda and Goober fight the rise of electronic waste and the evil supervillain Blaster, with some help from our our Planet Protector friends!\n\n\n# Esmeralda Planet Protector & The Litterless Lunch\n\nYouTube: OeT53lGAYX4\nLowRes: true\n\n## Description\n\nEsmeralda and Goober take on Trashella to stop her from convincing kid to bring lunches that make litter!\n\n\n# Esmeralda Planet Protector & Walking To School\n\nYouTube: 1FmXmBOU-V8\nLowRes: true\n\n## Description\n\nCan Esmeralda Superspy Planet Protector and her sidekick Goober stop the Evil Dr. Carbon's dastardly plan to stop kids from walking to school?\n\n\n# Esmeralda Superspy: Backstage #1\n\nYouTube: BQyzd8Y7EaY\nLowRes: true\n\n## Description\n\nDo series stars Ian and Sara spend their time saving the environment and protecting the planet? No, because Ian keeps acting like a monkey! Even when the boss, Jacqueline, is around.\n\n\n# Esmeralda Superspy: Backstage #2\n\nYouTube: AEmVWqAie6s\nLowRes: true\n\n## Description\n\nTake a peak behind the scenes! Sara takes you on a tour of the set - or at least, she tries to. Ian keeps messing up her shots!\n\n\n# Esmeralda Superspy: Backstage #3\n\nYouTube: zZId4Rr2-Rw\nLowRes: true\n\n## Description\n\nIan thinks he's doing a safety speech for the funny environmental show \"Esmeralda Superspy\" but really, Sara is about to get her revenge on him for wrecking her scenes.\n\n\n# Good Green News: Vancouver Urban Gardens\n\nYouTube: dPD3BogYAKw\nLowRes: true\n\n## Description\n\nKid reporter Tia, 9, reports on the Good Green News in the city of Vancouver - Find out why Vancouver helped bring over 400 urban gardens to the city!\n"

/***/ }),
/* 1739 */
/***/ (function(module, exports) {

	module.exports = "# Title - Short\n\nRESTEZ COOL\n\n# Title - Long\n\nRESTEZ COOL\n\n# Description - Short\n\nRESTEZ COOL inspire les élèves à devenir des super-héroïnes et des super-héros de l’action climatique et à changer les habitudes de leur famille en matière d’énergie et de transport!\n\n# Description - Long\n\nRESTEZ COOL inspire les élèves à devenir des super-héroïnes et des super-héros de l’action climatique et à changer les habitudes de leur famille en matière d’énergie et de transport!\n\n# Description - Levels\n\n**Modules include:**\n\n* L'énigme du climat\n* Opération Interrupteur\n* Opération Douche chrono\n* Opération Conduite écolo\n* Opération Coupez les moteurs\n* Célébration Restez cool\n\n# Level 1\nTitle: L'énigme du climat\n\n# Level 2\nTitle: Opération Interrupteur\n\n# Level 3\nTitle: Opération Douche chrono\n\n# Level 4\nTitle: Opération Conduite écolo\n\n# Level 5\nTitle: Opération Coupez les moteurs\n\n# Level 6\nTitle: Célébration Restez cool\n"

/***/ }),
/* 1740 */
/***/ (function(module, exports) {

	module.exports = "# Title - Short\n\nKEEP COOL\n\n# Title - Long\n\nKEEP COOL\n\n# Description - Short\n\nKEEP COOL inspires kids to become climate action superheroes and lead change in their families' energy and transportation habits!\n\n# Description - Long\n\nKEEP COOL inspires kids to become climate action superheroes and lead change in their families' energy and transportation habits!\n\n# Description - Levels\n\n**Modules include:**\n\n* The Climate Conundrum\n* Operation Darkroom\n* Operation Shower Power\n* Operation Keep Car Cool\n* Operation Go Car Free\n* Keep Cool\n\n# Level 1\nTitle: The Climate Conundrum\n\n# Level 2\nTitle: Operation Darkroom\n\n# Level 3\nTitle: Operation Shower Power\n\n# Level 4\nTitle: Operation Keep Car Cool\n\n# Level 5\nTitle: Operation Go Car Free\n\n# Level 6\nTitle: Keep Cool\n"

/***/ }),
/* 1741 */
/***/ (function(module, exports) {

	module.exports = "# Level Completed\n\n## Content\n\n### Welcome back!\n* Click the MENU button (top left) and use MODULES to go back to any of the six modules.\n* Or check out the videos in the EXTRAS section!\n\n## Notes\n\nWelcome back!\n"

/***/ }),
/* 1742 */
/***/ (function(module, exports) {

	module.exports = "# Teacher Resources\n## Bienvenue!\nNous sommes très heureux de former des Gardiens de la planète à {r/:$cityOrMunicipality}!\n\n#### Guide de l’enseignant(e)\n* {r/Canada}Téléchargez [le Guide de l’enseignant(e)](Teachers_Guide.fr_CA.pdf) pour un survol du contenu du programme et de son fonctionnement\n* La meilleure façon de vous orienter consiste à consulter le contenu destiné aux élèves en cliquant sur « Lancer le module 1 ».\n\n#### Liens vers les programmes d'études\nL’Académie des gardiens de la planète satisfait à toutes les exigences des programmes d'études en sciences, arts, langues et sciences humaines.\n\n* {r/Canada/BC}[Liens vers les programmes d'études de la 3ᵉ à la 6ᵉ année de la Colombie-Brittanique](CL_PPA-KC_Canada_BC_Grades_3-6.fr_CA.pdf)\n* {r/Canada/AB}Liens vers les programmes d'études de la 2ᵉ à la 6ᵉ année de l'Alberta - à paraître bientôt! ([télécharger en anglais](CL_PPA-KC_Canada_Alberta_Grades_2-6.pdf))\n* {r/Canada/SK}Liens vers les programmes d'études de la 3ᵉ à la 6ᵉ année de la Saskatchewan - à paraître bientôt! ([télécharger en anglais](CL_PPA-KC_Canada_Saskatchewan_Grades_3-6.pdf))\n* {r/Canada/MB}Liens vers les programmes d'études de la 3ᵉ à la 6ᵉ année du Manitoba - à paraître bientôt! ([télécharger en anglais](CL_PPA-KC_Canada_Manitoba_Grades_3-6.pdf))\n* {r/Canada/ON}Liens vers les programmes d'études de la 2ᵉ à la 6ᵉ année de l'Ontario - à paraître bientôt! ([télécharger en anglais](CL_PPA-KC_Canada_Ontario_Grades_3-6.pdf))\n* {r/Canada/QC}Liens vers les programmes d'études de la 3ᵉ à la 6ᵉ année du Québec - à paraître bientôt! ([télécharger en anglais](CL_PPA-KC_Canada_Quebec_Grades_3-6.pdf)_\n* {r/}Nous n’avons pas encore de liens vers les curriculums de votre région. Êtes-vous intéressé de nous aider à les développer? Contactez nous!\n\n#### Enseignez-vous à distance aux élèves?\nConsultez notre [aide-mémoire sur l’enseignement à distance](Remote_Teaching_Cheat_Sheet.fr_CA.pdf) pour obtenir des conseils sur la manière d’adapter le programme à l’apprentissage à distance/domicile!\n\n#### Vous voulez parlez à un être humain?\nCommuniquez avec nous en cliquant sur le bouton Messager dans le coin inférieur à droite! (en anglais)\n\n# Printables\n\n#### Matériel obligatoire à imprimer\n* Le dossier de missions pour chaque élève, en [couleur](Printables_Mission_Book_Colour.fr_CA.pdf) ou [noir et blanc](Printables_Mission_Book_BW.fr_CA.pdf).\n* Les cartes d’identité pour chaque élève, en [couleur](Printables_ID_Cards_Colour.fr_CA.pdf) ou [noir et blanc](Printables_ID_Cards_BW.fr_CA.pdf).\n*\tLes certificats de réalisation pour chaque élève, en [couleur](Printables_Completion_Certificates_Colour.fr_CA.pdf) ou [noir et blanc](Printables_Completion_Certificates_BW.fr_CA.pdf).\n\n#### Matériel facultatif à imprimer\n* Les certificats pour l’équipe gagnante, en [couleur](Printables_Winning_Certificates_Colour.fr_CA.pdf) ou [noir et blanc](Printables_Winning_Certificates_BW.fr_CA.pdf)\n* [Lettre aux parents](Printables_Parent_Guardian_Letter.pdf) (en anglais)\n*\tLes projets de bricolage :\n  *\tEsmeralda, en [couleur](Printables_Papercraft_Esmeralda_Colour.pdf) ou [noir et blanc](Printables_Papercraft_Esmeralda_BW.pdf).\n  *\tGoober, en [couleur](Printables_Papercraft_Goober_Colour.pdf) ou [noir et blanc](Printables_Papercraft_Goober_BW.pdf).\n"

/***/ }),
/* 1743 */
/***/ (function(module, exports) {

	module.exports = "# Teacher Resources\n## Welcome!\nWe're so happy to be training planet protectors from {r/:$cityOrMunicipality}!\n\n#### {r/Canada} Teacher's Guide\n{r/Canada} Download the [Teacher's Guide](Teachers_Guide.pdf) for a full overview of the program's contents and how it works.\n\nThe best way to orient yourself is to check out the student-facing content by clicking 'Start Module 1'.\n\n#### Curriculum Links\nThe Planet Protector Academy supports curriculum standards in science, arts, language and social studies. The following connections are provided for your convenience:\n\n* {r/Canada/BC}[British Columbia Grades 3-6](CL_PPA-KC_Canada_BC_Grades_3-6.pdf)\n* {r/Canada/AB}[Alberta Grades K-6](CL_PPA-KC_Canada_Alberta_Grades_K-6.pdf)\n* {r/Canada/SK}[Saskatchewan Grades 3-6](CL_PPA-KC_Canada_Saskatchewan_Grades_3-6.pdf)\n* {r/Canada/MB}[Manitoba Grades 3-6](CL_PPA-KC_Canada_Manitoba_Grades_3-6.pdf)\n* {r/Canada/ON}[Ontario Grades 2-6](CL_PPA-KC_Canada_Ontario_Grades_2-6.pdf)\n* {r/United States}[Common Core State Standards Grades 3-5](CL_PPA-KC_US_Common_Core_Grades_3-5.pdf)\n* {r/United States}[Next Generation Science Standards Grades 3-5](CL_PPA-KC_US_Next_Generation_Science_Standards_Grades_3-5.pdf)\n* {r/United States/WA}[WA State Standards Grades 3-5 (incl CCSS & NGSS)](CL_PPA-KC_US_WA_State_Standards_Grades_3-5.pdf)\n* {r/}We don't have curriculum links for your area yet. Do you want to help us develop them? Please contact us!\n\n#### Teaching students remotely?\nCheck out our [Remote Teaching Cheat Sheet](Remote_Teaching_Cheat_Sheet.pdf) for tips on how to adapt the program for remote/at-home learning!\n\n#### Need help from a human?\nGet in touch through the Messenger in the bottom right-hand corner!\n\n# Printables\n\n#### Required Print Materials\n\n* Mission Books for each child in [{r/Canada:colour}{r/:color}](Printables_Mission_Book_Colour.pdf) or [black & white](Printables_Mission_Book_BW.pdf).\n* ID Cards for each child in [{r/Canada:colour}{r/:color}](Printables_ID_Cards_Colour.pdf) or [black & white](Printables_ID_Cards_BW.pdf).\n* Completion certificates for each child in [{r/Canada:colour}{r/:color}](Printables_Completion_Certificates_Colour.pdf) or [black & white](Printables_Completion_Certificates_BW.pdf).\n\n#### Optional Print Materials\n* Winning team certificates in [{r/Canada:colour}{r/:color}](Printables_Winning_Certificates_Colour.pdf) or [black & white](Printables_Winning_Certificates_BW.pdf).\n* Papercrafts:\n  * Esmeralda [{r/Canada:colour}{r/:color}](Printables_Papercraft_Esmeralda_Colour.pdf) or [black & white](Printables_Papercraft_Esmeralda_BW.pdf)\n  * Goober [{r/Canada:colour}{r/:color}](Printables_Papercraft_Goober_Colour.pdf) or [black & white](Printables_Papercraft_Goober_BW.pdf)\n* Additional fun [Activity Pages](Printables_KC_Activity_Book.pdf)\n"

/***/ }),
/* 1744 */
/***/ (function(module, exports) {

	module.exports = "# Survol du module 1\r\n\r\n#### L’ÉNIGME DU CLIMAT en bref\r\n##### Durée normale : 1 heure\r\n* Visionnez des vidéos stimulantes.\r\n* chanter la chanson thème de l’Académie des gardiens de la planète.\r\n* Jouer à un jeu « télévisé » qui porte sur les principales distinctions entre la météo, le climat et les changements climatiques.\r\n* Dessiner, en équipe, une saison dans la région de résidence.\r\n\r\n#### Former des équipes\r\n* Avant de commencer le programme, divisez votre classe en quatre équipes – la terre, l’air, le feu et l’eau (nous vous recommandons de répartir les équipes à l’avance et de ne pas les modifier en cours de programme).\r\n* Chaque équipe travaillera ensemble pendant les différentes activités artistiques et obtiendra des points pour sa participation, sa collaboration, son écoute, etc.\r\n* La flexibilité de ce système vous permet de récompenser le comportement que vous voulez encourager dans votre classe!\r\n\r\n#### Vocabulaire essentiel\r\n* Météo\r\n* Saison\r\n* Changement climatique\r\n* Pollution\r\n* Gaz à effet de serre\r\n\r\n# Matériel\r\n\r\n#### Ce dont vous avez besoin pour ce niveau\r\n* Les livrets de mission pour chaque élève en [couleur](Printables_Mission_Book_Colour.fr_CA.pdf) ou [en noir et blanc](Printables_Mission_Book_BW.fr_CA.pdf).\r\n* Des cartes d’identité pour chaque élève en [couleur](Printables_ID_Cards_Colour.fr_CA.pdf) ou en [noir et blanc](Printables_ID_Cards_BW.pdf).\r\n"

/***/ }),
/* 1745 */
/***/ (function(module, exports) {

	module.exports = "# Module 1 Overview\r\n\r\n#### THE CLIMATE CONUNDRUM at a glance\r\n##### Typical duration: 1 hour\r\n* Watch engaging videos.\r\n* Sing the Planet Protector Academy Theme Song.\r\n* Play a \"Game Show\" which engages them on key distinctions between weather, climate and climate change.\r\n* Draw, in teams, one season in the region they live.\r\n\r\n#### Getting into teams\r\n* Before starting the program, divide your class into four teams - Earth, Air, Fire and Water (we recommend you set up the teams ahead of time and that they remain the same for the duration of the program).\r\n* Each team will work together during the various arts-based activities and score points for participating, collaborating, listening etc.\r\n* It's a flexible system for you to reward the {r/Canada:behaviour}{r/:behavior} you want to see in your class!\r\n\r\n#### Key Vocabulary\r\n* Weather\r\n* Season\r\n* Climate Change\r\n* Pollution\r\n* Greenhouse Gases\r\n\r\n# Materials\r\n\r\n#### What you need for this level\r\n* Mission Books for each student in [{r/Canada:colour}{r/:color}](Printables_Mission_Book_Colour.pdf) or [black & white](Printables_Mission_Book_BW.pdf).\r\n* ID Cards for each student in [{r/Canada:colour}{r/:color}](Printables_ID_Cards_Colour.pdf) or [black & white](Printables_ID_Cards_BW.pdf).\r\n"

/***/ }),
/* 1746 */
/***/ (function(module, exports) {

	module.exports = "# Survol du module 2\n\n#### OPÉRATIONN INTERRUPTEUR en bref\n##### Durée normale : 1 heure\nÀ ce niveau, les apprenti·e·s vont :\n* chanter la chanson thème de l’Académie des gardiens de la planète.\n* jouer à un jeu « télévisé » qui porte sur l’énergie, l’électricité, d’où vient notre électricité et pourquoi nous devons économiser l’énergie.\n* dessiner, en équipes, un système de production d’énergie électrique.\n* composer et présenter, en équipe, un rap sur les économies d’énergie.\n* se faire attribuer la première mission, Mission 1 : Opération Interrupteur.\n\n#### Former des équipes\n* La classe devrait déjà être divisée en équipes depuis l’activité précédente. Les équipes resteront les mêmes au cours du programme.\n* Chaque équipe travaillera ensemble pendant les différentes activités artistiques et obtiendra des points pour sa participation, sa collaboration, son écoute, etc.\n\n#### Vocabulaire essentiel\n* Électricité\n* Énergie\n* Génératrice\n* Lignes électriques à haute tension\n* Transformateur\n\n# Matériel\n\n#### Ce dont vous avez besoin pour ce niveau\n* 4 feuilles de papier graphique\n* Des crayons marqueurs\n* Les livrets de mission\n"

/***/ }),
/* 1747 */
/***/ (function(module, exports) {

	module.exports = "# Module 2 Overview\n\n#### OPERATION DARKROOM at a glance\n##### Typical duration: 1 hour\nIn this level, Apprentices will:\n* Sing the Planet Protector Academy Theme Song.\n* Play a \"Game Show\" which engages them on energy, electricity, where our electricity comes from, and why they should save energy.\n* Draw, in teams, a power generation system.\n* Write and perform, in teams, a rap about saving energy.\n* Be assigned their first mission, Mission 1: Operation Darkroom.\n\n#### Getting into teams\n* Your class should already be divided into teams from the previous session.  They will keep these teams through the program.\n* Each team will work together during the various arts-based activities and score points for participating, collaborating, listening etc.\n\n#### Key Vocabulary\n* Electricity\n* Energy\n* Generator\n* High Voltage Power Lines\n* Transformer\n\n# Materials\n\n#### What you need for this level\n* 4 pieces of Chart Paper\n* Markers\n* Mission Books\n"

/***/ }),
/* 1748 */
/***/ (function(module, exports) {

	module.exports = "# Survol du module 3\n\n#### OPÉRATION DOUCHE CHRONO en bref\n##### Durée normale : 1 heure\nÀ ce niveau, les apprenti·e·s vont :\n* chanter la chanson thème de l’Académie des gardiens de la planète.\n* faire le rapport de la mission Opération Interrupteur.\n* jouer à un jeu « télévisé » qui porte sur le chauffage, l’eau chaude et le système d’eau chaude.\n* jouer, en équipes, à un jeu de rôles concernant les systèmes d’eau chaude.\n* dessiner, individuellement, une affiche qui incite à « se doucher en 5 minutes ».\n* se faire attribuer la Mission 2 : Opération Douche chrono.\n* **Mission de rechange ou en prime** : Si un·e élève se dit incapable de réduire la durée de sa douche, le défi de sa mission pourrait être de porter un chandail supplémentaire au lieu d’augmenter le chauffage à la maison.\n\n#### Vocabulaire essentiel\n* Chaleur\n* Température\n* Molécules\n* Réservoir à eau chaude\n\n# Matériel\n\n#### Ce dont vous avez besoin pour ce niveau\n* Les livrets de mission\n* Une feuille de papier vierge pour chaque élève\n* Des marqueurs de couleur ou des crayons de couleur en bois\n"

/***/ }),
/* 1749 */
/***/ (function(module, exports) {

	module.exports = "# Module 3 Overview\n\n#### OPERATION SHOWER POWER at a glance\n##### Typical duration: 1 hour\nIn this level, Apprentices will:\n* Sing the Planet Protector Academy Theme Song.\n* Report back on their Operation Darkroom mission.\n* Play a \"Game Show\" which engages them on heat, hot water, and the hot water system.\n* Play, in teams, a {r/Canada:theatre}{r/:theater} game about hot water systems.\n* Draw, individually, a \"Take a 5-minute shower\" poster.\n* Be assigned Mission 2: Operation Shower Power.\n* **Alternative/Bonus Mission**: If a student says they are unable to take a shorter shower, their mission challenge could be to put on an extra sweater instead of turning up the heat in their home.\n\n#### Key Vocabulary\n* Heat\n* Temperature\n* Molecules\n* Hot Water Tank\n\n# Materials\n\n#### What you need for this level\n* Mission Books\n* Blank paper for each student\n* {r/Canada:Coloured}{r/:Colored} markers or pencil crayons\n"

/***/ }),
/* 1750 */
/***/ (function(module, exports) {

	module.exports = "# Survol du module 4\n\n#### OPÉRATION CONDUITE ÉCOLO en bref\n##### Durée normale : 1 heure\nÀ ce niveau, les apprenti·e·s vont :\n* chanter la chanson thème de l’Académie des gardiens de la planète.\n* faire le rapport de la mission Opération Douche chrono.\n* jouer à un « télévisé » qui porte sur les modes de transport, le carburant et les émissions de carburant.\n* dessiner, en équipes, une affiche avec différents modes de transport.\n* évaluer, en équipes, ces modes de transport en matière de santé et de protection de la planète.\n* se faire attribuer la Mission 3 : Opération Conduite écolo.\n\n#### Vocabulaire essentiel\n* Transport\n* Voyager intelligemment\n* Essence ou carburant\n* Marche au ralenti\n\n# Matériel\n\n#### Ce dont vous avez besoin pour ce niveau\n* Les livrets de mission\n* Une feuille de papier vierge pour chaque équipe\n* Des marqueurs de couleur ou des crayons de couleur en bois\n"

/***/ }),
/* 1751 */
/***/ (function(module, exports) {

	module.exports = "# Module 4 Overview\n\n#### OPERATION KEEP CAR COOL at a glance\n##### Typical duration: 1 hour\nIn this level, Apprentices will:\n* Sing the Planet Protector Academy Theme Song.\n* Report back on their Operation Shower Power mission.\n* Play a game show which engages them on modes of transportation, fuel, and fuel emissions.\n* Draw, in teams, a poster with different types of transportation.\n* In teams, rate those modes of transportation for health and kindness to the planet.\n* Be assigned Mission 3: Operation Keep Car Cool.\n\n#### Key Vocabulary\n* Transportation\n* Smart Travel\n* Gasoline/Fuel\n* Idling\n\n# Materials\n\n#### What you need for this level\n* Mission Books\n* Blank paper for each team\n* {r/Canada:Coloured}{r/:Colored} markers or pencil crayons\n"

/***/ }),
/* 1752 */
/***/ (function(module, exports) {

	module.exports = "# Survol du module 5\n\n#### OPÉRATION COUPEZ LES MOTEURS en bref\n##### Durée normale : 1 heure\nÀ ce niveau, les apprenti·e·s vont :\n* chanter la chanson thème de l’Académie des gardiens de la planète.\n* faire le rapport de la mission Opération Conduite écolo.\n* jouer à un jeu « télévisé » qui porte sur l’utilisation intelligente de la voiture et les déplacements actifs.\n* faire un remue-méninge pour trouver des solutions aux obstacles que rencontrent les enfants pour se rendre à l’école à pied.\n* interpréter des rôles, en équipes, pour aborder la question des moyens de transport de rechange avec leurs parents.\n* se faire attribuer la mission FINALE, Mission 4 : Opération Coupez les moteurs.\n\n#### Vocabulaire essentiel\n* Ressources\n\n# Matériel\n\n#### Ce dont vous avez besoin pour ce niveau\n* Les livrets de mission\n"

/***/ }),
/* 1753 */
/***/ (function(module, exports) {

	module.exports = "# Module 5 Overview\n\n#### OPERATION GO CAR FREE at a glance\n##### Typical duration: 1 hour\nIn this level, Apprentices will:\n* Sing the Planet Protector Academy Theme Song.\n* Report back on their Operation Keep Car Cool mission.\n* Play a game show which engages them on being car-smart and active transportation.\n*\tBrainstorm solutions to the obstacles kids have to walking to school.\n* Act out, in teams, how to tell your parents about alternate transportation.\n* Be assigned their FINAL mission, Mission 4: Operation Go Car Free.\n\n#### Key Vocabulary\n* Resources\n\n# Materials\n\n#### What you need for this level\n* Mission Books\n"

/***/ }),
/* 1754 */
/***/ (function(module, exports) {

	module.exports = "# Survol du module 6\n\n#### CÉLÉBRATION RESTEZ COOL en bref\n##### Durée normale : 1 heure\nÀ ce niveau, les apprenti·e·s vont :\n* chanter la chanson thème de l’Académie des gardiens de la planète.\n* faire le rapport de la mission Opération Coupez les moteurs.\n* créer leur propre modèle de bricolage en papier d’Esmeralda ou de Goober.\n* recevoir des certificats de participation individuels et pour l’équipe.\n* célébrer leurs réalisations.\n\n# Matériel\n\n#### Ce dont vous avez besoin pour ce niveau\n* Des certificats de fin de formation pour chaque apprenti·e, en [couleurs](Printables_Completion_Certificates_Colour.fr_CA.pdf) ou en [noir et blanc](Printables_Completion_Certificates_BW.fr_CA.pdf).\n* Activité facultative, mais amusante : des bricolages en papier pour chaque apprenti·e, avec des ciseaux et de quoi colorier :\n* Bricolage en papier d’Esmaralda en [couleurs](Printables_Papercraft_Esmeralda_Colour.pdf) ou en [noir et blanc](Printables_Papercraft_Esmeralda_BW.pdf).\n* Bricolage en papier de Goober en [couleurs](Printables_Papercraft_Goober_Colour.pdf) ou en [noir et blanc](Printables_Papercraft_Goober_BW.pdf).\n* Dès que vous saurez quelle équipe a accumulé le plus grand nombre de points, vous pouvez imprimer un certificat en [couleur](Printables_Winning_Certificates_Colour.fr_CA.pdf) ou en [noir et blanc](Printables_Winning_Certificates_BW.fr_CA.pdf) qui indique l’équipe gagnante et l’afficher au mur de votre classe après la leçon.\n"

/***/ }),
/* 1755 */
/***/ (function(module, exports) {

	module.exports = "# Module 6 Overview\n\n#### KEEP COOL CELEBRATION at a glance\n##### Typical duration: 1 hour\nIn this level, Apprentices will:\n* Sing the Planet Protector Academy Theme Song.\n* Report back on their Operation Go Car Free mission.\n* Make their own Esmeralda or Goober papercraft.\n* Receive individual and team certificates for their participation.\n* Celebrate their achievements.\n\n# Materials\n\n#### What you need for this level\n* Completion certificates for each Apprentice in [{r/Canada:colour}{r/:color}](Printables_Completion_Certificates_Colour.pdf) or [black & white](Printables_Completion_Certificates_BW.pdf).\n* Optional but fun: papercrafts for each Apprentice, plus scissors and something to {r/Canada:colour}{r/:color} with:\n  * Esmeralda papercraft in [{r/Canada:colour}{r/:color}](Printables_Papercraft_Esmeralda_Colour.pdf) or [black & white](Printables_Papercraft_Esmeralda_BW.pdf).\n  * Goober papercraft in [{r/Canada:colour}{r/:color}](Printables_Papercraft_Goober_Colour.pdf) or [black & white](Printables_Papercraft_Goober_BW.pdf).\n* Once you know which team has earned the most points, you can print a Winning Team Certificate in [{r/Canada:colour}{r/:color}](Printables_Winning_Certificates_Colour.pdf) or [black & white](Printables_Winning_Certificates_BW.pdf) to post on your classroom wall after the lesson.\n"

/***/ }),
/* 1756 */
/***/ (function(module, exports) {

	module.exports = "# Tech Prep Wizard\n\n### Tutoriel d’installation technique\n\nCe bref tutoriel vous guidera au cours de l’installation du programme de l’Académie pour votre salle de classe.\n\nNe montrez pas tout de suite l’écran à vos élèves!\n\nCliquez sur les flèches ou utilisez la flèche droite de votre clavier pour avancer dans le tutoriel.\n\n\n# Two Device Intro\n\n### Expérience à deux appareils\nL’expérience de l’Académie est plus agréable en utilisant deux appareils :\n*\tL’appareil principal (ORDINATEUR ou TABLETTE) fait la projection du site Web en classe.\n*\tLe deuxième appareil (TABLETTE ou CELLULAIRE) qui fonctionne comme télécommande (facultatif) :\n  *\tvous donne la liberté de vous déplacer dans la classe.\n  * contient des instructions et notes au bout des doigts.\n  *\tfournit des indicateurs utiles sur la progression, notamment sur la durée des vidéos et le nombre de diapos restantes.\n\n\n# Connecting Remote\n\n### Pour connecter votre télécommande!\nAfin de connecter le deuxième appareil comme télécommande :\n1. Allez à www.remote4ppa.com sur votre tablette/cellulaire.\n2. Inscrivez votre nom d’utilisateur et mot de passe sur votre tablette/cellulaire.\n3. Passez à la prochaine diapo pour sélectionner le rôle de l’appareil.\n4. Choisissez le bon rôle pour chaque appareil.\n5. Vos choix seront enregistrés pour une utilisation éventuelle, mais vous pouvez aussi apporter des changements plus tard!\n\n\n# Tech Check Intro\n\n### Vérification\nVEUILLEZ MAINTENANT connecter l’appareil principal à votre projecteur et **vérifier l’audio/la vidéo** pour vous assurer que tout fonctionne! Vous trouverez une vidéo amusante (en anglais) à la prochaine diapo qui vous aidera pour cette étape (elle se trouve aussi dans la section Pour s’amuser, si vous souhaitez la montrer à vos élèves).\n\n#### L’expérience plein écran\nL’expérience de l’Académie des gardiens de la planète est plus amusante en mode plein écran. Cliquez sur **Affichage (ou Présentation)** dans le menu de votre navigateur et sélectionnez ensuite **Plein écran** (Chrome) ou **Activer** le mode plein écran (Safari/ Firefox).\n\n# Tech Check Video\nYouTube: ZVdMndkjaIo\n"

/***/ }),
/* 1757 */
/***/ (function(module, exports) {

	module.exports = "# Tech Prep Wizard\n\n### Tech Prep Wizard\n\nThis short wizard will help you get set up to run the Academy in your classroom.\n\nDon't show your students the screen yet!\n\nClick the arrow or use your keyboard's right directional arrow to move through the wizard.\n\n# Two Device Intro\n\n### Two Device Experience\nThe Academy is best experienced using two devices:\n* Main device (COMPUTER or TABLET) projects the website at the front of the class.\n* Second device (TABLET or CELLPHONE) can be as a remote control (optional):\n  * gives you freedom to move around the classroom.\n  * contains prompts and facilitation notes at your finger tips.\n  * provides useful progress indicators, such as length of videos and number of slides remaining.\n\n# Connecting Remote\n\n### Connect your remote!\nTo connect a second device as a Remote Control:\n1. Go to www.remote4ppa.com on your tablet/phone.\n2. Enter your username and password on your tablet/phone.\n3. Go to the next slide to Select Role For This Device.\n4. Choose the right Role for each device.\n5. Your selections will be saved for future use, but you can always change it later!\n\n# Tech Check Intro\n\n### Tech Check!\nNOW PLEASE hook up your main device to your projector and **test the audio/video** to make sure everything's working! There's a fun video in the next slide to help you do this (it's also in the Fun section if you want to share with your class).\n\n#### Full Screen Experience\nThe Planet Protector Academy is best enjoyed as a full screen experience. **Click 'View'** in your browser's menu bar, and select **'Full Screen'** (Chrome) or **'Enter Full Screen'** (Safari/Firefox).\n\n# Tech Check Video\nYouTube: ZVdMndkjaIo\n"

/***/ }),
/* 1758 */
/***/ (function(module, exports) {

	module.exports = "# Level 1 Start\n\n## Notes\n\n### Début\n\nMontrez cet écran au début du cours. Quand les enfants sont prêt·e·s, passez à l’écran suivant.\n\nServez-vous des flèches directionnelles de votre télécommande pour avancer ou reculer.\n\n\n# Level 1 Icon\n\n## Notes\n\nOpération Énigme du climat\n\n### Suivi de vos progrès\n\nVous pouvez voir où vous en êtes grâce au numéro de la diapositive qui se trouve en haut de votre télécommande ou grâce à la barre de progression bleue qui se trouve en bas du menu de l’écran présenté à la classe.\n\n\n# Level 2 Start\n\n## Notes\n\n### Début\n\nMontrez cet écran au début du cours. Quand les enfants sont prêt·e·s, passez à l’écran suivant.\n\n\n# Level 2 Icon\n\n## Notes\n\nOpération Interrupteur\n\n\n# Level 3 Start\n\n## Notes\n\n### Début\n\nMontrez cet écran au début du cours. Quand les enfants sont prêt·e·s, passez à l’écran suivant.\n\n\n# Level 3 Icon\n\n## Notes\n\nOpération Douche chrono\n\n\n# Level 4 Start\n\n## Notes\n\n### Début\n\nMontrez cet écran au début du cours. Quand les enfants sont prêt·e·s, passez à l’écran suivant.\n\n\n# Level 4 Icon\n\n## Notes\n\nOpération Conduite écolo\n\n\n# Level 5 Start\n\n## Notes\n\n### Début\n\nMontrez cet écran au début du cours. Quand les enfants sont prêt·e·s, passez à l’écran suivant.\n\n\n# Level 5 Icon\n\n## Notes\n\nOpération Coupez les moteurs\n\n# Level 6 Start\n\n## Notes\n\n### Début\n\nMontrez cet écran au début du cours. Quand les enfants sont prêt·e·s, passez à l’écran suivant.\n\n\n# Level 6 Icon\n\n## Notes\n\nOpération Restez cool\n"

/***/ }),
/* 1759 */
/***/ (function(module, exports) {

	module.exports = "# Level 1 Start\n\n## Notes\n\n### Start\n\nShow this screen at the start of class. When the kids are ready, advance to the next screen.\n\nUse the directional arrows on your remote to go forwards/backwards through the level.\n\n\n# Level 1 Icon\n\n## Notes\n\nOperation Climate Conundrum\n\n### Tracking your progress\n\nYou can see how far along you are by the slide number on the top of your Remote Control or by the blue progress bar running along the bottom of the Menu on the Classroom Display.\n\n\n# Level 2 Start\n\n## Notes\n\n### Start\n\nShow this screen at the start of class. When the kids are ready, advance to the next screen.\n\n\n# Level 2 Icon\n\n## Notes\n\nOperation Darkroom\n\n\n# Level 3 Start\n\n## Notes\n\n### Start\n\nShow this screen at the start of class. When the kids are ready, advance to the next screen.\n\n\n# Level 3 Icon\n\n## Notes\n\nOperation Shower Power\n\n\n# Level 4 Start\n\n## Notes\n\n### Start\n\nShow this screen at the start of class. When the kids are ready, advance to the next screen.\n\n\n# Level 4 Icon\n\n## Notes\n\nOperation Keep Car Cool\n\n\n# Level 5 Start\n\n## Notes\n\n### Start\n\nShow this screen at the start of class. When the kids are ready, advance to the next screen.\n\n\n# Level 5 Icon\n\n## Notes\n\nOperation Go Car Free\n\n\n# Level 6 Start\n\n## Notes\n\n### Start\n\nShow this screen at the start of class. When the kids are ready, advance to the next screen.\n\n\n# Level 6 Icon\n\n## Notes\n\nOperation Keep Cool\n"

/***/ }),
/* 1760 */
/***/ (function(module, exports) {

	module.exports = "# Level 1 Intro\n\n## Content\n\n### Pourquoi ne pas commencer par une chanson?\n\n## Notes\n\nPrêts à chanter?!\n\n\n# Level 2 Intro\n\n## Content\n\n### Bienvenue de nouveau aux gardiennes et gardiens de la planète!\n\n#### Prêts à chanter?!\n\n## Notes\n\nPrêts à chanter?!\n\n\n# Level 3 Intro\n\n## Content\n\n### Bienvenue de nouveau aux gardiennes et gardiens de la planète!\n\n#### Prêts à chanter?!\n\n## Notes\n\nPrêts à chanter?!\n\n\n# Level 4 Intro\n\n## Content\n\n### Bienvenue de nouveau aux gardiennes et gardiens de la planète!\n\n#### Prêts à chanter?!\n\n## Notes\n\nPrêts à chanter?!\n\n\n# Level 5 Intro\n\n## Content\n\n### Bienvenue de nouveau aux gardiennes et gardiens de la planète!\n\n#### Prêts à chanter?!\n\n## Notes\n\nPrêts à chanter?!\n\n\n# Level 6 Intro\n\n## Content\n\n### Bienvenue de nouveau aux gardiennes et gardiens de la planète!\n\n#### Prêts à chanter?!\n\n## Notes\n\nPrêts à chanter?!\n\n\n# Song\n\nYouTube: JPX85dIOjks\n\n## Notes\n\n### Chanson des gardiennes et gardiens de la planète\n\nEncouragez votre classe à apprendre cette chanson et à chanter en même temps que la vidéo (1:52). Les paroles seront projetées et se trouvent aussi à la dernière page des livrets de mission.\n\n### Activités d’approfondissement\nLes apprenti·e·s peuvent interpréter la chanson devant toute l’école et/ou créer leur propre chorégraphie.\n"

/***/ }),
/* 1761 */
/***/ (function(module, exports) {

	module.exports = "# Level 1 Intro\n\n## Content\n\n### Why not start with a song?\n\n## Notes\n\nGet ready to sing!\n\n\n# Level 2 Intro\n\n## Content\n\n### Welcome back Planet Protectors!\n\n#### Get ready to sing!\n\n## Notes\n\nGet ready to sing!\n\n\n# Level 3 Intro\n\n## Content\n\n### Welcome back Planet Protectors!\n\n#### Get ready to sing!\n\n## Notes\n\nGet ready to sing!\n\n\n# Level 4 Intro\n\n## Content\n\n### Welcome back Planet Protectors!\n\n#### Get ready to sing!\n\n## Notes\n\nGet ready to sing!\n\n\n# Level 5 Intro\n\n## Content\n\n### Welcome back Planet Protectors!\n\n#### Get ready to sing!\n\n## Notes\n\nGet ready to sing!\n\n# Level 6 Intro\n\n## Content\n\n### Welcome back Planet Protectors!\n\n#### Get ready to sing!\n\n## Notes\n\nGet ready to sing!\n\n\n# Song\n\nYouTube: ulOo2VuQEWA\n\n## Notes\n\n### Planet Protectors Song\n\nEncourage your class to learn this song and sing along to the video (1:52). The lyrics will be shown and are also on the last page of the Mission Books.\n\n### Extension Activities\nApprentices can perform the song to the whole school and/or create their own choreography.\n"

/***/ }),
/* 1762 */
/***/ (function(module, exports) {

	module.exports = "# Welcome Video\n\nYouTube: UaMQ3LrUkhw\n\n## Notes\n\nEsmeralda et Goober accueillent les apprenti·e·à l’Académie (2:59).\n\n\n# Get Into Teams\n\n## Content\n\n###### Formez quatre équipes!\n\nÀ la prochaine diapo, donnez un nom à votre équipe.\n\n## Notes\n\nNommez les équipes à la prochaine diapositive. Après que vous avez saisi le nom dans le champ de texte, il s’enregistre automatiquement!\n\n\n# Scoring Intro\n\n## Content\n\n### Pour accumuler des points en équipe :\n* Répondez aux questions\n* Participez aux activités\n* Effectuez les missions\n* Travaillez ensemble (un bon travail d’équipe)\n* et plus!\n\n## Notes\n\n### Pointage\n* Les équipes peuvent gagner des points pour la plupart des activités du programme. Vous pouvez attribuer les points comme bon vous semble. Le nombre maximum de points est de 999.\n* Les personnes peuvent gagner des points pour les équipes, ou les équipes peuvent gagner des points ensemble.\n* Les points de travail en équipe sont essentiels pour assurer la collaboration.\n* Les points peuvent aussi servir de « monnaie » en classe, par exemple pour obtenir des privilèges en classe.\n* L’équipe qui a le plus de points à la fin du niveau 6 est l’équipe gagnante.\n\n# Scoreboard Intro\n\n## Content\n\n### Consultez le tableau des points!\n\n(Dans le coin supérieur gauche, cliquez sur MENU, ensuite POINTAGE)\n\nLes équipes sont maintenant prêtes à accumuler des points!\n\n## Notes\n\nCliquez à tout moment sur l’icône « Tableau d’affichage » de votre télécommande pour faire apparaître le tableau d’affichage et ajouter des points pour les équipes.\n\n\n# ID Cards\n\n## Content\n\n### Félicitations!\n\n#### Vous êtes maintenant des apprentis-gardiens de la planète!\n\nC’est le temps de remplir vos cartes d’identité et de vous dessiner en gardien de la planète!\n\n## Notes\n\nDemandez aux apprenti·e·s d’écrire leur nom et le nom de leur équipe sur leur carte d’identité, et de dessiner leur « avatar », c’est-à-dire une photo d’elle, d’eux ou d’elleux en super-héroïnes ou super-héros.\n"

/***/ }),
/* 1763 */
/***/ (function(module, exports) {

	module.exports = "# Welcome Video\n\nYouTube: 7tEwMXlO_HI\n\n## Notes\n\nThe Apprentices are welcomed to the Academy by Esmeralda and Goober (2:59).\n\n\n# Get Into Teams\n\n## Content\n\n###### Get into four teams!\n\nName your teams in the next slide.\n\n## Notes\n\nName teams in the next slide. Once you enter the name in the text field, it automatically saves!\n\n\n# Scoring Intro\n\n## Content\n\n### Here's how your team can score points\n\n* Answer questions\n* Do activities\n* Complete missions\n* Work well together (teamwork points)\n* and more!\n\n## Notes\n\n### Scoring\n* Teams can earn points for most activities in the program. You can allocate points as you see fit. Maximum points total is 999.\n* Individuals can earn points for teams, or teams can earn points together.\n* Teamwork points are critical to ensure collaboration.\n* Points can also be a classroom \"currency\", e.g.to gain classroom privileges.\n* The team with the most points at the end of Level 6 is the winner.\n\n\n# Scoreboard Intro\n\n## Content\n\n### Check out the scoreboard!\n\n(In the top left corner, click MENU and then SCORES)\n\nYour teams are now ready to start scoring points!\n\n## Notes\n\nClick on the 'Scoreboard' icon on your remote at any time to bring down the scoreboard and add points for teams.\n\n\n# ID Cards\n\n## Content\n\n### Congratulations!\n\n#### You're now Planet Protector Apprentices!\n\nTime to fill out your ID cards and draw yourself as the Planet Protector that you are!\n\n## Notes\n\nHave Apprentices write their names and team names on their ID cards, and draw their \"avatar\", ie. a picture of themselves as a superhero.\n"

/***/ }),
/* 1764 */
/***/ (function(module, exports) {

	module.exports = "# Mission Report\nTitle: Opération Interrupteur\n\n\n# Intro Video\n\nYouTube: EOZ54RaSX88\n\n## Notes\n\nIntroduction du rapport de mission pour l’opération Interrupteur (0:58).\n\n\n# Scoring\n\n## Content\n\n### Accumulez des points pour vos missions!\n* Allez à la Mission 1 de votre dossier de missions.\n* En équipe, calculez le total des points accumulés dans la section « Accumuler des points pour votre équipe ».\n* N’oubliez pas d’ajouter vos points au tableau des points!\n\n## Notes\n\nCette diapositive ne couvre que les actions énumérées à la rubrique « Obtenir un point pour » de chaque mission.\nLes élèves présentent ensuite la section Rapport de mission.\n\n\n# Instructions\n\n## Content\n\n### C’est l’heure de faire votre rapport au QG!\n* Répondez en levant la main.\n* Si vous ou votre famille avez fait des améliorations, mêmes petites, dites oui!\n* Si rien n’a changé, ne levez pas la main. Reprenez-vous à la prochaine mission!\n* Les agents de formation peuvent aussi faire leur rapport!\n\n## Notes\n\n### Rapports de mission\n* Les rapports de mission nous aident à communiquer l’impact de notre programme. Merci de nous aider à en faire l’évaluation!\n* Le vote à main levée permet de conserver l’anonymat des données.\n\n\n# Questions\n\n## Content\n\n1. Nombre d’apprenti·e·s et d’agent·e·s de formation qui font rapport.\n2. J’éteins maintenant plus souvent les lumières.\n3. Ma famille éteint maintenant plus souvent les lumières.\n4. Je m’engage à éteindre les lumières.\n\n\n# Impact\n\n## Content\n\n### Excellent travail, apprenti·e·s!\nVotre rapport de mission a été reçu au QG de l’Académie des gardiens de la planète.\n\n## Notes\n\nBeau travail!\n\n\n# Class Discussion\n\n## Content\n\n### Discussion en classe\n* Discutez ensemble de ce qui a été facile ou difficile pendant la mission.\n* Qu’est-ce qui a fonctionné et n’a pas fonctionné?\n* Qu’est-ce qui pourrait faciliter les choses?\n\n## Notes\n\nAu besoin, encouragez les apprenti·e·s à continuer d’essayer si elles, ils ou iels n’ont pas réussi.\n"

/***/ }),
/* 1765 */
/***/ (function(module, exports) {

	module.exports = "# Mission Report\nTitle: Operation Darkroom\n\n\n# Intro Video\n\nYouTube: j2VUCBeXCLg\n\n## Notes\n\nIntro to the Mission Report for Operation Darkroom (0:58).\n\n\n# Scoring\n\n## Content\n\n### Get points for your missions!\n* Turn to Mission 1 in your Mission Books.\n* In your teams, count the total number of points you scored in the 'Get points for' section.\n* Make sure your points get added onto the Scoreboard!\n\n## Notes\n\nThis slide only covers actions listed under 'Get a point for' for each mission.\nStudents report the Mission Report section next.\n\n# Instructions\n\n## Content\n\n### Time to report to HQ!\n* Answer with a show of hands\n* If you or anyone is turning off lights even just a little more now, say yes!\n* If you really havenʼt changed, donʼt put up your hand. Try again next mission!\n* Training Agent enters answers and can report too!\n\n## Notes\n\n### Mission Reports\n* Mission reports help us communicate the impact of our program. Thanks for helping us to measure it!\n* Using a show of hands keeps the data anonymous.\n\n\n# Questions\n\n## Content\n\n1. Number of Apprentices and Training Agents reporting in.\n2. I am turning off lights more now.\n3. My family is turning off lights more now.\n4. I pledge to turn off lights.\n\n\n# Impact\n\n## Content\n\n### Awesome work, Apprentices!\nYour Mission Report was received by Planet Protector Academy HQ.\n\n## Notes\n\nGreat job!\n\n\n# Class Discussion\n\n## Content\n\n### Class Discussion\n* As a class, discuss what was easy or hard about this mission.\n* What worked, what didn’t work?\n* What would make it easier?\n\n## Notes\n\nEncourage apprentices who did not succeed to keep trying, if appropriate.\n"

/***/ }),
/* 1766 */
/***/ (function(module, exports) {

	module.exports = "# Mission Report\nTitle: Opération Douche chrono\n\n\n# Intro Video\n\nYouTube: lwO5L_sO5sY\n\n## Notes\n\nIntroduction du rapport de mission pour l’opération Douche chrono (0:51).\n\n\n# Scoring\n\n## Content\n\n### Accumulez des points pour vos missions!\n* Allez à la Mission 2 de votre dossier de missions.\n* En équipe, calculez le total des points accumulés dans la section « Accumuler des points pour votre équipe ».\n* N’oubliez pas d’ajouter vos points au tableau des points!\n\n## Notes\n\nCette diapositive ne couvre que les actions énumérées à la rubrique « Obtenir un point pour » de chaque mission.\nLes élèves présentent ensuite la section Rapport de mission.\n\n\n# Instructions\n\n## Content\n\n### C’est l’heure de faire votre rapport au QG!\n* Répondez en levant la main.\n* Si vous ou votre famille avez fait des améliorations, mêmes petites, dites oui!\n* Si rien n’a changé, ne levez pas la main. Reprenez-vous à la prochaine mission!\n* Les agents de formation peuvent aussi faire leur rapport!\n\n## Notes\n\n### Rapports de mission\n* Les rapports de mission nous aident à communiquer l’impact de notre programme. Merci de nous aider à en faire l’évaluation!\n* Le vote à main levée permet de conserver l’anonymat des données.\n\n\n# Questions\n\n## Content\n\n1. Nombre d’apprenti·e·s et d’agent·e·s de formation qui font rapport.\n2. Je prends maintenant des douches plus rapides.\n3. Ma famille prend maintenant des douches plus rapides.\n4. Je m’engage à prendre des douches plus rapides.\n5. Combien d'enfants s'amusent à participer au programme?\n\n\n# Impact\n\n## Content\n\n### Excellent travail, apprenti·e·s!\nVotre rapport de mission a été reçu au QG de l’Académie des gardiens de la planète.\n\n## Notes\n\nBeau travail!\n\n\n# Class Discussion\n\n## Content\n\n### Discussion en classe\n* Discutez ensemble de ce qui a été facile ou difficile pendant la mission.\n* Qu’est-ce qui a fonctionné et n’a pas fonctionné?\n* Qu’est-ce qui pourrait faciliter les choses?\n\n## Notes\n\nAu besoin, encouragez les apprenti·e·s à continuer d’essayer si elles, ils ou iels n’ont pas réussi.\n"

/***/ }),
/* 1767 */
/***/ (function(module, exports) {

	module.exports = "# Mission Report\nTitle: Operation Shower Power\n\n\n# Intro Video\n\nYouTube: ePj6NQNtaiE\n\n## Notes\n\nIntro to the Mission Report for Operation Shower Power (0:51).\n\n\n# Scoring\n\n## Content\n\n### Get points for your missions!\n* Turn to Mission 2 in your Mission Books.\n* In your teams, count the total number of points you scored in the 'Get points for' section.\n* Make sure your points get added onto the Scoreboard!\n\n## Notes\n\nThis slide only covers actions listed under 'Get a point for' for each mission.\nStudents report the Mission Report section next.\n\n\n# Instructions\n\n## Content\n\n### Time to report to HQ!\n* Answer with a show of hands.\n* If you or anyone in your family is having a shorter shower now, say yes!\n* If you really haven't changed, don't put up your hand. Try again next mission!\n* Training Agents can report too!\n\n## Notes\n\n### Mission Reports\n* Mission reports help us communicate the impact of our program. Thanks for helping us to measure it!\n* Using a show of hands keeps the data anonymous.\n\n\n# Questions\n\n## Content\n\n1. Number of Apprentices and Training Agents reporting in.\n2. I am having shorter showers now.\n3. My family is having shorter showers now.\n4. I pledge to take shorter showers.\n5. How many kids are having fun doing this program?\n\n# Impact\n\n## Content\n\n### Awesome work, Apprentices!\nYour Mission Report was received by Planet Protector Academy HQ.\n\n## Notes\n\nGreat job!\n\n\n# Class Discussion\n\n## Content\n\n### Class Discussion\n* As a class, discuss what was easy or hard about this mission.\n* What worked, what didn’t work?\n* What would make it easier?\n\n## Notes\n\nEncourage apprentices who did not succeed to keep trying, if appropriate.\n"

/***/ }),
/* 1768 */
/***/ (function(module, exports) {

	module.exports = "# Mission Report\nTitle: Opération Conduite écolo\n\n\n# Intro Video\n\nYouTube: AEiuruLstQ0\n\n## Notes\n\nIntroduction du rapport de mission pour l’opération Conduite écolo (0:51).\n\n\n# Scoring\n\n## Content\n\n### Accumulez des points pour vos missions!\n* Allez à la Mission 3 de votre dossier de missions.\n* En équipe, calculez le total des points accumulés dans la section « Accumuler des points pour votre équipe ».\n* N’oubliez pas d’ajouter vos points au tableau des points!\n\n## Notes\n\nCette diapositive ne couvre que les actions énumérées à la rubrique « Obtenir un point pour » de chaque mission.\nLes élèves présentent ensuite la section Rapport de mission.\n\n\n# Instructions\n\n## Content\n\n### C’est l’heure de faire votre rapport au QG!\n* Répondez en levant la main.\n* Si vous ou votre famille avez fait des améliorations, mêmes petites, dites oui!\n* Si rien n’a changé, ne levez pas la main. Reprenez-vous à la prochaine mission!\n* Les agents de formation peuvent aussi faire leur rapport!\n\n## Notes\n\n### Rapports de mission\n* Les rapports de mission nous aident à communiquer l’impact de notre programme. Merci de nous aider à en faire l’évaluation!\n* Le vote à main levée permet de conserver l’anonymat des données.\n\n\n# Questions\n\n## Content\n\n1. Nombre d’apprenti·e·s et d’agent·e·s de formation qui font rapport.\n2. Ma famille laisse moins le moteur tourner au ralenti.\n3. Ma famille fait moins de vitesse en voiture.\n4. Ma famille s’engage à assurer un meilleur entretien de notre véhicule.\n5. Je m’engage à conduire de façon écologique quand je serai grande ou grand.\n6. Combien d'enfants se croient maintenant de véritables gardien·ne·s de la planète?\n7. Je m’engage à protéger la planète à partir de maintenant.\n\n\n# Impact\n\n## Content\n\n### Excellent travail, apprenti·e·s!\nVotre rapport de mission a été reçu au QG de l’Académie des gardiens de la planète.\n\n## Notes\n\nBeau travail!\n\n\n# Class Discussion\n\n## Content\n\n### Discussion en classe\n* Discutez ensemble de ce qui a été facile ou difficile pendant la mission.\n* Qu’est-ce qui a fonctionné et n’a pas fonctionné?\n* Qu’est-ce qui pourrait faciliter les choses?\n\n## Notes\n\nAu besoin, encouragez les apprenti·e·s à continuer d’essayer si elles, ils ou iels n’ont pas réussi.\n"

/***/ }),
/* 1769 */
/***/ (function(module, exports) {

	module.exports = "# Mission Report\nTitle: Operation Keep Car Cool\n\n\n# Intro Video\n\nYouTube: iJXFRZG3KCw\n\n## Notes\n\nIntro to the Mission Report for Operation Keep Car Cool (1:29).\n\n\n# Scoring\n\n## Content\n\n### Get points for your missions!\n* Turn to Mission 3 in your Mission Books.\n* In your teams, count the total number of points you scored in the 'Get points for' section.\n* Make sure your points get added onto the Scoreboard!\n\n## Notes\n\nThis slide only covers actions listed under 'Get a point for' for each mission.\nStudents report the Mission Report section next.\n\n\n# Instructions\n\n## Content\n\n### Time to report to HQ!\n* Answer with a show of hands.\n* If your family has improved even just a little bit, say yes!\n* If you really haven't changed, don't put up your hand. Try again next mission!\n* Training Agents can report too!\n\n## Notes\n\n### Mission Reports\n* Mission reports help us communicate the impact of our program. Thanks for helping us to measure it!\n* Using a show of hands keeps the data anonymous.\n\n# Questions\n\n## Content\n\n1. Number of Apprentices and Training Agents reporting in.\n2. My family is idling less now.\n3. My family is speeding less now.\n4. My family pledges to maintain our car better.\n5. I pledge to be a Green Driver when I grow up.\n6. How many kids feel like real life Planet Protectors now?\n7. I pledge to be a Planet Protector from now on.\n\n\n# Impact\n\n## Content\n\n### Awesome work, Apprentices!\nYour Mission Report was received by Planet Protector Academy HQ.\n\n## Notes\n\nGreat job!\n\n\n# Class Discussion\n\n## Content\n\n### Class Discussion\n* As a class, discuss what was easy or hard about this mission.\n* What worked, what didn’t work?\n* What would make it easier?\n\n## Notes\n\nEncourage apprentices who did not succeed to keep trying, if appropriate.\n"

/***/ }),
/* 1770 */
/***/ (function(module, exports) {

	module.exports = "# Mission Report\nTitle: Opération Coupez les moteurs\n\n\n# Intro Video\n\nYouTube: jXJ8aszbOg8\n\n## Notes\n\nIntroduction du rapport de mission pour l’opération Coupez les moteurs (0:41).\n\n\n# Scoring\n\n## Content\n\n### Accumulez des points pour vos missions!\n* Allez à la Mission 4 de votre dossier de missions.\n* En équipe, calculez le total des points accumulés dans la section « Accumuler des points pour votre équipe ».\n* N’oubliez pas d’ajouter vos points au tableau des points!\n\n## Notes\n\nCette diapositive ne couvre que les actions énumérées à la rubrique « Obtenir un point pour » de chaque mission.\nLes élèves présentent ensuite la section Rapport de mission.\n\n\n# Instructions\n\n## Content\n\n### C’est l’heure de faire votre rapport au QG!\n* Répondez en levant la main.\n* Si vous ou votre famille avez fait des améliorations, mêmes petites, dites oui!\n* Si rien n’a changé, ne levez pas la main. Reprenez-vous à la prochaine mission!\n* Les agents de formation peuvent aussi faire leur rapport!\n\n## Notes\n\nLes rapports de mission nous aident à communiquer l’impact de notre programme. Merci de nous aider à en faire l’évaluation!\n\n# Questions\n\n## Content\n\n1. Nombre d’apprenti·e·s et d’agent·e·s de formation qui font rapport.\n2. Ma famille conduit maintenant moins.\n3. Ma famille marche maintenant plus.\n4. Ma famille fait maintenant plus de vélo.\n5. Ma famille se déplace maintenant plus souvent en transport en commun.\n6. Ma famille fait maintenant plus de covoiturage.\n7. Ma famille a réussi au moins une mission pendant le programme.\n\n\n# Impact\n\n## Content\n\n### Excellent travail, apprenti·e·s!\n### Merci de protéger la planète!\nVotre rapport de mission a été reçu au QG de l’Académie des gardiens de la planète.\n\n## Notes\n\nBeau travail!\n\n\n# Class Discussion\n\n## Content\n\n### Discussion en classe\n* Discutez ensemble de ce qui a été facile ou difficile pendant la mission.\n* Qu’est-ce qui a fonctionné et n’a pas fonctionné?\n* Qu’est-ce qui pourrait faciliter les choses?\n\n## Notes\n\nAu besoin, encouragez les apprenti·e·s à continuer d’essayer si elles, ils ou iels n’ont pas réussi.\n"

/***/ }),
/* 1771 */
/***/ (function(module, exports) {

	module.exports = "# Mission Report\nTitle: Operation Go Car Free\n\n\n# Intro Video\n\nYouTube: PXevrtC98eA\n\n## Notes\n\nIntro to the Mission Report for Operation Go Car Free (0:41).\n\n\n# Scoring\n\n## Content\n\n### Get points for your missions!\n* Turn to Mission 4 in your Mission Books.\n* In your teams, count the total number of points you scored in the 'Get points for' section.\n* Make sure your points get added onto the Scoreboard!\n\n## Notes\nThis slide only covers actions listed under 'Get a point for' for each mission.\nStudents report the Mission Report section next.\n\n\n# Instructions\n\n## Content\n\n### Time to report to HQ!\n* Answer with a show of hands.\n* If your family has improved even just a little bit, say yes!\n* If you really haven't changed, don't put up your hand.\n* Training Agents can report too!\n\n## Notes\nMission reports help us communicate the impact of our program. Thanks for helping us to measure it!\n\n\n# Questions\n\n## Content\n\n1. Number of Apprentices and Training Agents reporting in.\n2. My family is driving less now.\n3. My family is walking more now.\n4. My family is cycling more now.\n5. My family is taking transit more now.\n6. My family is ridesharing more now.\n7. My family succeeded in at least one mission during the program.\n\n\n# Impact\n\n## Content\n\n### Great job, Apprentices!\n#### Thanks for protecting the planet!\nYour Mission Report was received by Planet Protector Academy HQ.\n\n## Notes\n\nGreat job!\n\n\n# Class Discussion\n\n## Content\n\n### Class Discussion\n* As a class, discuss what was easy or hard about this mission.\n* What worked, what didn’t work?\n* What would make it easier?\n\n## Notes\n\nEncourage apprentices who did not succeed to keep trying, if appropriate.\n"

/***/ }),
/* 1772 */
/***/ (function(module, exports) {

	module.exports = "# Game Show\n\nNiveau 1 – L’énigme du climat\n\n\n# Intro Video\n\nYouTube: 5WFeCps6V1A\n\n## Notes\n\nCourt message d’Esmeralda et de Goober. Sara et Ian présentent le jeu télévisé (2:10)\n\n\n# Keep Cool Song Intro\n\n## Content\n\n### Chanson Restez cool!\nVisionnez cette vidéo (en anglais). Les paroles de la chanson contiennent des réponses aux questions du jeu télévisé!\n\n## Notes\n\n&nbsp;\n\n\n# Keep Cool Song Video\n\nYouTube: c7XZuBYBsKU\n\n## Notes\n\nVidéo qui explique les changements climatiques (2:49). Les paroles de cette chanson se trouvent dans le livret de mission de chaque élève.\n\n\n# Sizzle\n\n## Notes\n\n### Jeu télévisé\nAu cours du jeu télévisé, nous posons des questions relatives au sujet *avant* de donner les réponses, et ce, afin de stimuler la réflexion, plutôt que de tester les connaissances.\n\nUn·e apprenti·e de chaque équipe se présentera devant la classe et aura l’occasion de répondre à la question à son tour.\n\nPour obtenir de plus amples renseignements, reportez-vous à la section « Info sur le jeu télévisé » du guide pédagogique qui se trouve dans la section Ressources pédagogiques de la page Tableau de contrôle.\n\n\n# Scoring\n\n## Content\n\n### Pour accumuler des points :\n* Prenez la pose de gardien·ne de la planète.\n* Soyez le premier ou la première à activer le signal sonore.\n* Donnez la bonne réponse. Faites de votre mieux!\n* Si vous ne savez pas la réponse, réfléchissez à ce que pourrait être une bonne réponse. Ce n’est pas un test!\n\n## Notes\n\nN’oubliez pas d’indiquer les points au tableau d’affichage!\n\n\n# Bonus Action\n\n## Content\n\n### Action prime\nObtenez un point quand vous faites une pose de super-héroïne ou de super-héros quand vous arrivez à l’avant de la classe!\n\n## Notes\n\n&nbsp;\n\n\n# Four Players Announcement\n\n## Notes\n\n* Un·e apprenti·e de chaque équipe se rend à l’avant de la pièce.\n* Encouragez un·e apprenti·e différent·e à se présenter pour chaque question.\n\n\n# Question 1\n\nYouTube: ReGZ39PcloI\n\n## Video Notes\n\nIan et Sara présentent la Q1 du jeu télévisé (1:26).\n\n## Question\n\n### Qu’est-ce que la météo?\n\n## Answer\n\n### La météo, c’est :\n* Une collection de changements observables dans l’atmosphère qui se produisent localement tous les jours.\n* La pluie qui se forme dans les nuages, la neige qui tombe des nuages, le vent qui souffle, le soleil qui brille, le brouillard qui se lève, la température qui augmente ou qui diminue, ce sont tous des types de météo.\n* En constante évolution – à la minute et au jour le jour.\n\n## Answer Notes\n\n&nbsp;\n\n\n# Scoring Reminder\n\n## Content\n\n### N’oubliez pas de calculer vos points!\n\n## Notes\n\nCliquez sur le bouton « Pointages » ci-dessous pour ouvrir le tableau d’affichage.\n\n\n# Question 2\n\nYouTube: dISMMwPQhio\n\n## Video Notes\n\nIan et Sara présentent la Q2 du jeu télévisé (1:09).\n\n## Question\n\n### Qu’est-ce que le climat?\n\n## Answer\n\n### Le climat, c’est :\n* L’éventail des conditions météorologiques typiques d’une région (par exemple, la chaleur et le froid habituels, la quantité de pluie habituelle pendant l’année).\n* Le climat décrit le comportement de notre atmosphère sur de longues périodes de temps, comme des décennies et des siècles!\n* Il existe trois régions climatiques sur la terre : polaire, tempérée et tropicale.\n* Le climat interagit avec les courants océaniques, les montagnes, les canyons et les grandes masses de neige pour créer des systèmes météorologiques à long terme.\n\n## Answer Notes\n\n&nbsp;\n\n\n# Question 3\n\nYouTube: ank-cUt61mM\n\n## Video Notes\n\nIan et Sara présentent la Q3 du jeu télévisé (1:21).\n\n## Question\n\n### Que se passe-t-il avec notre climat?\n\n## Answer\n\n### Notre climat change plus rapidement que d’habitude :\n* Il est donc difficile pour les oiseaux, les poissons et les mammifères de s’adapter et de survivre.\n* Nous observons des conditions météorologiques plus extrêmes et des tempêtes saisonnières plus fortes et destructrices.\n* Tandis que les températures de notre planète continuent d’augmenter, les éléments dont nous avons besoin pour survivre sont menacés : eau, nourriture et abri.\n* Quels autres indices avons-nous que le climat change plus rapidement que d’habitude?\n\n## Answer Notes\n\nLe texte sort-il de la bulle? Vous pouvez redimensionner la fenêtre de votre navigateur pour essayer de remédier à la situation, ou mieux encore, passez en plein écran!\n\n\n# Question 4\n\nYouTube: WenxlEtSVgY\n\n## Video Notes\n\nIan et Sara présentent la Q4 du jeu télévisé (1:30).\n\n## Question\n\n### Quels sont les facteurs à l’origine des changements climatiques?\n\n## Answer\n\n### Les changements climatiques sont causés par :\n* La combustion de combustibles fossiles, comme le pétrole et le gaz, libère dans l’atmosphère des gaz à effet de serre qui retiennent la chaleur du soleil et la maintiennent près de la Terre.\n* Nous brûlons des combustibles fossiles et créons des gaz à effet de serre quand :\n  * nous conduisons nos voitures pour nous déplacer ou transporter des aliments des fermes vers les magasins.\n  * nous mangeons de la viande – les gens mangent plus aujourd’hui que jamais auparavant. Les vaches et autres animaux d’élevage produisent beaucoup de gaz à effet de serre lorsqu’ils pètent!\n  * Les usines fabriquent des jouets, des téléviseurs et tout ce que vous aimez acheter.\n\n## Answer Notes\n\n&nbsp;\n"

/***/ }),
/* 1773 */
/***/ (function(module, exports) {

	module.exports = "# Game Show\n\nLevel 1 - The Climate Conundrum\n\n\n# Intro Video\n\nYouTube: DrEhZ_cxSYk\n\n## Notes\n\nShort message from Esmeralda and Goober. Sara and Ian introduce the Game Show (2:10)\n\n\n# Keep Cool Song Intro\n\n## Content\n\n### Keep Cool Song!\nWatch this video. The lyrics in the song have answers to the upcoming game show questions!\n\n## Notes\n\n&nbsp;\n\n\n# Keep Cool Song Video\n\nYouTube: 8huU_6QfvtQ\n\n## Notes\nVideo explaining climate change (2:49). Lyrics to this song can be found in each students' Mission Book.\n\n\n# Sizzle\n\n## Notes\n\n### Game Show\nIn the Game Show we ask questions relating to the topic *before* giving the answers, in order to stimulate thinking, rather than to test knowledge.\n\nOne Apprentice from each team will come up to the front of the class and get a chance to answer the question in turn.\n\nFor more info, see \"Game Show Info\" in the Teachers Guide, which is available in the Teacher Resources section on the Dashboard page.\n\n\n# Scoring\n\n## Content\n\n### How to score points\n* Do your Planet Protector pose.\n* Buzz in first.\n* Give a good answer. Try your best!\n* If you don’t know the answer, think about what a good answer might be. This is not a test!\n\n## Notes\n\nDon't forget to score points on the Scoreboard!\n\n\n# Bonus Action\n\n## Content\n\n### Bonus Action\nGet a point for doing a Superhero pose as you come up to the front of the class!\n\n## Notes\n\n&nbsp;\n\n\n# Four Players Announcement\n\n## Notes\n\n* One Apprentice from each team comes to the front of the room.\n* Encourage a different Apprentice to come up for each question.\n\n\n# Question 1\n\nYouTube: x-9K9Ikkpzs\n\n## Video Notes\n\nIan and Sara present Q1 of the gameshow (1:26).\n\n## Question\n\n### What is Weather?\n\n## Answer\n\n### Weather is:\n* A collection of observable changes in the atmosphere that happen locally everyday.\n* Rain forming in clouds, snow falling from clouds, the wind blowing, the sun shining, fog rolling, the temperature increasing or decreasing, these are all types of weather.\n* Constantly changing – minute-by-minute and day-by-day.\n\n## Answer Notes\n\n&nbsp;\n\n\n# Scoring Reminder\n\n## Content\n\n### Don't forget to add scores!\n\n## Notes\n\nClick on the 'Scores' button below to open up the Scoreboard.\n\n\n# Question 2\n\nYouTube: ltKKByS91Ns\n\n## Video Notes\n\nIan and Sara present Q2 of the gameshow (1:09).\n\n## Question\n\n### What is Climate?\n\n## Answer\n\n### Climate is:\n* The range of an area’s typical weather conditions (e.g. how hot and cold it usually gets, how much it usually rains over the year).\n* Climate describes how our atmosphere behaves over long periods of time, like decades and centuries!\n* There are three climate regions on earth: Polar, Temperate and Tropical.\n* Climate interacts with ocean currents, mountains, canyons and large masses of snow to create long-term weather systems.\n\n## Answer Notes\n\n&nbsp;\n\n\n# Question 3\n\nYouTube: VhMFMD0mWOA\n\n## Video Notes\n\nIan and Sara present Q3 of the gameshow (1:21).\n\n## Question\n\n### What is happening to our climate?\n\n## Answer\n\n### Our climate is changing faster than usual:\n* This makes it difficult for birds, fish and mammals to adapt and survive.\n* We are seeing more extreme weather and stronger, destructive seasonal storms.\n* As temperatures on our planet continue to rise, the very things we need to survive are at risk: water, food and shelter.\n* What other clues do we have that the climate is changing faster than usual?\n\n## Answer Notes\n\nIs the text going outside the speech bubble? You can resize your browser window to try and fix it, or even better - go full screen!\n\n\n# Question 4\n\nYouTube: -S9Nhpa98ok\n\n## Video Notes\n\nIan and Sara present Q4 of the gameshow (1:30).\n\n## Question\n\n### What are some things that are causing Climate Change?\n\n## Answer\n\n### Climate change is caused by:\n* Burning fossil fuels, like oil and gas, releases greenhouse gases in to the atmosphere that trap the heat of the sun and keep it close to the Earth.\n* We burn fossil fuels and create greenhouse gases when:\n  * Driving in our cars to go places or transporting food from farms to the store.\n  * Eating meat – people eat more today than they ever have. Cows and other livestock produce a lot of greenhouse gases when they toot!\n  * Factories make toys, TV’s and everything else you like to buy.\n\n## Answer Notes\n\n&nbsp;\n"

/***/ }),
/* 1774 */
/***/ (function(module, exports) {

	module.exports = "# Game Show\n\nNiveau 2 – Interrupteur\n\n\n# Intro Video\n\nYouTube: lsilI1leYiQ\n\n## Notes\n\nCourt message d’Esmeralda et de Goober. Sara et Ian présentent le jeu télévisé (1:41)\n\n\n# Sizzle\n\n## Notes\n\nLe jeu « télévisé »\n\n\n# Scoring\n\n## Content\n\n### Rappel :\n* Prenez la pose de gardien·ne de la planète.\n* Soyez le premier ou la première à activer le signal sonore.\n* Donnez une bonne réponse.\n\n## Notes\n\nN’oubliez pas d’indiquer les points au tableau d’affichage!\n\n\n# Bonus Action\n\n## Content\n\n### Action prime\nObtenez un point quand vous faites semblant d’éteindre les lumières quand vous arrivez à l’avant de la classe!\n\n## Notes\n\n&nbsp;\n\n# Four Players Announcement\n\n## Notes\n\nQuatre joueuses et joueurs se rendent à l’avant.\n\n\n# Question 1\n\nYouTube: UMCTr_iUxvU\n\n## Video Notes\n\nIan et Sara présentent la Q1 du jeu télévisé (1:12).\n\n## Question\n\n### D’où vient l’électricité?\n\n## Answer\n\n### {r/Canada/AB} En Alberta :\n### {r/Canada/BC} En Colombie-Britannique :\n### {r/Canada/MB} Au Manitoba :\n### {r/Canada/ON} En Ontario :\n### {r/United States/WA} Dans l’État de Washington :\n### {r/} L’électricité est une source d’énergie secondaire\n\n* {r/Canada/AB} On produit de l’électricité en brûlant du charbon (43 %) et du gaz naturel (40 %) et en ayant recours à des sources d’énergie renouvelables (17 %) comme l’énergie hydraulique et l’énergie éolienne.\n* {r/Canada/AB} Quand on brûle le charbon, l’énergie thermique est convertie en énergie électrique qui est acheminée par des câbles jusqu’à votre domicile.\n* {r/Canada/AB} Le charbon et le gaz naturel proviennent de plantes anciennes qui ont été enterrées il y a des millions d’années.\n\n* {r/Canada/BC} On produit la plupart de l’électricité en transformant de l’eau en mouvement en énergie électrique. C’est ce que l’on appelle l’hydroélectricité.\n* {r/Canada/BC} L’eau est très puissante et nous utilisons l’énergie de l’eau qui tombe pour faire tourner des turbines géantes reliées à des aimants.\n* {r/Canada/BC} Les aimants qui tournent créent une charge électrique que nous pouvons stocker et envoyer dans les foyers.\n\n* {r/Canada/MB} On produit 96 % de l’électricité en transformant de l’eau en mouvement en énergie électrique. C’est ce que l’on appelle l’hydroélectricité.\n* {r/Canada/MB} L’eau est très puissante et nous utilisons l’énergie de l’eau qui tombe pour faire tourner des turbines géantes reliées à des aimants.\n* {r/Canada/MB} Les aimants qui tournent créent une charge électrique que nous pouvons stocker et envoyer dans les foyers.\n\n* {r/Canada/ON} L’électricité provient du nucléaire (59 %), de l’eau (23 %) et du gaz naturel (11 %).\n* {r/Canada/ON} Avec l’énergie nucléaire, on sépare de minuscules particules appelées atomes pour libérer de l’énergie thermique.\n* {r/Canada/ON} La chaleur fait bouillir l’eau dans de grands réservoirs et crée de la vapeur qui alimente les turbines qui créent l’électricité.\n\n* {r/United States/WA} On produit un peu plus de 60 % de l’électricité en transformant de l’eau en mouvement en énergie électrique. On en produit environ 15 % en faisant brûler du charbon et 13 % au moyen de gaz naturel.\n* {r/United States/WA} On produit la plupart de l’électricité en transformant de l’eau en mouvement en énergie électrique. C’est ce que l’on appelle l’hydroélectricité.\n* {r/United States/WA} L’eau est très puissante et nous utilisons l’énergie de l’eau qui tombe pour faire tourner des turbines géantes reliées à des aimants.\n\n* {r/} Cela signifie qu’on la crée à partir d’autres sources d’énergie, comme :\n  * {r/} Les combustibles fossiles, y compris le charbon, le gaz naturel et le pétrole.\n  * {r/} L’énergie nucléaire.\n  * {r/} Les ressources renouvelables, y compris l’énergie éolienne, l’énergie hydraulique (énergie provenant du mouvement de l’eau), l’énergie solaire (énergie provenant du soleil) et l’énergie géothermique (énergie provenant de la chaleur interne de la terre).\n\n## Answer Notes\n\n&nbsp;\n\n\n# Scoring Reminder\n\n## Content\n\n### N’oubliez pas de calculer vos points!\n\n## Notes\n\nCliquez sur le bouton « Pointages » ci-dessous pour ouvrir le tableau d’affichage.\n\n\n# Question 2\n\nYouTube: 7VzWEtTH76M\n\n## Video Notes\n\nIan et Sara présentent la Q2 du jeu télévisé (1:06).\n\n## Question\n\n### Comment l’électricité parvient-elle à votre domicile?\n\n## Answer\n\n### L’électricité parvient à votre domicile de ces façons :\n\n* Lorsque l’énergie électrique est captée, elle est transformée par un transformateur afin que l’énergie puisse être utilisée à un niveau plus sûr dans nos domicile.\n* Elle est ensuite envoyée à une sous-station où elle circule dans les lignes électriques et finit par arriver dans nos domiciles.\n* Nous nous branchons sur l’électricité à la maison par le biais de petites prises qui se trouvent dans les murs. Nous nous en servons pour alimenter nos lampes, nos fours, nos téléviseurs, nos ordinateurs et nos sèche-cheveux ainsi que pour recharger nos téléphones.\n\n## Answer Notes\n\n&nbsp;\n\n\n# Question 3\n\nYouTube: tbJEYm85GIo\n\n## Video Notes\n\nIan et Sara présentent la Q3 du jeu télévisé (1:09).\n\n## Question\n\n### Pourquoi devrions-nous économiser l’énergie?\n\n## Answer\n\n### Nous devons économiser l’énergie parce que :\n\n* plus nous utilisons d’énergie, plus nous devons en produire.\n* la combustion de combustibles fossiles pour produire de l’électricité pollue l’air et produit des gaz à effet de serre, ce qui entraîne des changements climatiques.\n* la construction de barrages est coûteuse et endommage nos écosystèmes naturels.\n* moins d’électricité utilisée = plus d’argent économisé!\n\n## Answer Notes\n\n&nbsp;\n"

/***/ }),
/* 1775 */
/***/ (function(module, exports) {

	module.exports = "# Game Show\n\nLevel 2 - Darkroom\n\n\n# Intro Video\n\nYouTube: sFBHqN_PCTQ\n\n## Notes\n\nShort message from Esmeralda and Goober. Sara and Ian introduce the Game Show (1:41)\n\n\n# Sizzle\n\n## Notes\n\nGame Show\n\n\n# Scoring\n\n## Content\n\n### Reminder:\n* Do your Planet Protector pose.\n* Buzz in first.\n* Give a good answer.\n\n## Notes\n\nDon't forget to score points on the Scoreboard!\n\n\n# Bonus Action\n\n## Content\n\n### Bonus Action\nGet a point for pretending to turn off the lights as you come up to the front of the class!\n\n## Notes\n\n&nbsp;\n\n# Four Players Announcement\n\n## Notes\n\nFour players to the front.\n\n\n# Question 1\n\nYouTube: i-4gIdosesI\n\n## Video Notes\n\nIan and Sara present Q1 of the gameshow (1:12).\n\n## Question\n\n### Where does electricity come from?\n\n## Answer\n\n### {r/Canada/AB} In Alberta:\n### {r/Canada/BC} In British Columbia:\n### {r/Canada/MB} In Manitoba:\n### {r/Canada/ON} In Ontario:\n### {r/United States/WA} In Washington State:\n### {r/} Electricity is a secondary energy source\n\n* {r/Canada/AB} Electricity is made by burning Coal (43%), Natural Gas (40%), and renewable energy sources (17%) such as Hydro and Wind.\n* {r/Canada/AB} When burning coal, heat energy is converted to electrical energy which travels through wires to your home.\n* {r/Canada/AB} Coal and Natural Gas come from ancient plants that were buried undergound millions of years ago.\n\n* {r/Canada/BC} Most electricity is made from transforming moving water into electrical energy.  We call this Hydro electricity.\n* {r/Canada/BC} Water is very powerful and we use the energy of falling water to spin giant turbines that are connected to magnets.\n* {r/Canada/BC} Spinning magnets create an electric charge that we can store and send to homes.\n\n* {r/Canada/MB} 96% of electricity is made from transforming moving water into electrical energy.  This is called Hydro electricity.\n* {r/Canada/MB} Water is very powerful and we use the energy of falling water to spin giant turbines that are connected to magnets.\n* {r/Canada/MB} Spinning magnets create an electric charge that we can store and send to homes.\n\n* {r/Canada/ON} Electricity comes from Nuclear (59%), Hydro (23%), and Natural Gas (11%).\n* {r/Canada/ON} With nuclear power, tiny particles called Atoms are split apart to release heat energy.\n* {r/Canada/ON} The heat boils water in big tanks and creates steam which powers the turbines that create electricity.\n\n* {r/United States/WA} Just over 60% of electricity is made from transforming moving water into electrical energy. Around 15% is made burning coal and 13% using natural gas.\n* {r/United States/WA} Most electricity is made from transforming moving water into electrical energy.  We call this Hydro electricity.\n* {r/United States/WA} Water is very powerful and we use the energy of falling water to spin giant turbines that are connected to magnets.\n\n* {r/} This means it's created from other sources of energy, like:\n  * {r/} Fossil fuels, including coal, natural gas and oil.\n  * {r/} Nuclear power.\n  * {r/} Renewable resources, including wind, hydro (energy from moving water), solar (energy from the sun) and geothermal (energy from the internal heat of the earth).\n\n## Answer Notes\n\n&nbsp;\n\n\n# Scoring Reminder\n\n## Content\n\n### Don't forget to add scores!\n\n## Notes\n\nClick on the 'Scores' button below to open up the Scoreboard.\n\n\n# Question 2\n\nYouTube: PD3QSs77iKA\n\n## Video Notes\n\nIan and Sara present Q2 of the gameshow (1:06).\n\n## Question\n\n### How does electricity get to your home?\n\n## Answer\n\n### Electricity gets to your home in these ways:\n\n* When the electrical energy is captured, it gets changed by a transformer so the energy can be used at a safer level in our homes.\n* It’s then sent to a sub-station where it then travels though the power lines and eventually arrives in our homes.\n* We plug into the electricity at home through little outlets in our walls. We use it to power our lights, ovens, TV’s, computers, hair dryers and to re-charge our phones.\n\n## Answer Notes\n\n&nbsp;\n\n\n# Question 3\n\nYouTube: 7Ik4O2XId6I\n\n## Video Notes\n\nIan and Sara present Q3 of the gameshow (1:09).\n\n## Question\n\n### Why should we save energy?\n\n## Answer\n\n### We should save energy because:\n\n* The more energy you use, the more we have to produce.\n* Burning fossil fuels to make electricity pollutes the air and produces greenhouse gases, which leads to climate change.\n* Building dams are expensive and damage our natural ecosystems.\n* Less electricity used = more money saved!\n\n## Answer Notes\n\n&nbsp;\n"

/***/ }),
/* 1776 */
/***/ (function(module, exports) {

	module.exports = "# Game Show\n\nNiveau 3 – Douche chrono\n\n\n# Intro Video\n\nYouTube: Q5G2BYPlBb0\n\n## Notes\n\nCourt message d’Esmeralda et de Goober. Sara et Ian présentent le jeu télévisé (1:19)\n\n\n# Sizzle\n\n## Notes\n\nLe jeu « télévisé »\n\n\n# Bonus Action\n\n## Content\n\n### Action prime\nObtenez un point si vous faites semblant d’enfiler un chandail quand vous arrivez devant la classe!\n\n## Notes\n\n&nbsp;\n\n\n# Four Players Announcement\n\n## Notes\n\nQuatre joueuses et joueurs se rendent à l’avant.\n\n\n# Question 1\n\nYouTube: JRxF2sk-N6w\n\n## Video Notes\n\nIan et Sara présentent la Q1 du jeu télévisé (1:07).\n\n## Question\n\n### Qu’est-ce que la chaleur?\n\n## Answer\n\n### La chaleur, c’est :\n\n* Un type d’énergie.\n* Vous pouvez mesurer la quantité de chaleur d’un objet en mesurant sa température. L’unité de mesure de la température est le degré.\n* La chaleur peut être transférée d’une chose à une autre.\n* La chaleur est le résultat du mouvement des molécules.  Plus elles bougent vite, plus les choses se réchauffent!\n* Exemple : Quand les molécules d’eau se déplacent rapidement, l’eau liquide se transforme en vapeur.  Quand les molécules d’eau se déplacent à un rythme modéré, elles restent à l’état liquide et quand les molécules d’eau se déplacent très, très, lentement, elles se transforment en glace solide.\n\n## Answer Notes\n\n&nbsp;\n\n\n# Question 2\n\nYouTube: jzjP-kZp2ok\n\n## Video Notes\n\nIan et Sara présentent la Q2 du jeu télévisé (1:06).\n\n## Question\n\n### D’où vient l’eau chaude de votre domicile?\n\n## Answer\n\n### L’eau chaude :\n\n* s’obtient en ajoutant de l’énergie thermique à l’eau.\n* s’obtient, dans votre domicile, par un chauffe-eau alimenté par du gaz naturel ou de l’électricité.\n* Le chauffe-eau se trouve le plus souvent dans le sous-sols ou dans une pièce désignée des grands bâtiments.\n\n## Answer Notes\n\n&nbsp;\n\n\n# Question 3\n\nYouTube: -iDINP4cfcY\n\n## Video Notes\n\nIan et Sara présentent la Q3 du jeu télévisé (1:06).\n\n## Question\n\n### Comment le réservoir d’eau chaude chauffe-t-il l’eau?\n\n## Answer\n\n### Fonctionnement du réservoir d’eau chaude :\n\n* Le chauffe-eau brûle du gaz naturel ou utilise de l’électricité pour chauffer du métal.\n* La chaleur est ensuite transférée à l’eau où elle accélère le mouvement des molécules de l’eau pour que l’eau devienne plus chaude.\n* Faire brûler du gaz naturel ou avoir recours à de l’électricité pour produire de l’eau chaude signifie que vous devez faire preuve d’intelligence quant à la quantité que vous utilisez!\n* Prendre une douche plus courte permet d’économiser de l’eau et de l’énergie!\n\n## Answer Notes\n\n&nbsp;\n"

/***/ }),
/* 1777 */
/***/ (function(module, exports) {

	module.exports = "# Game Show\n\nLevel 3 - Shower Power\n\n\n# Intro Video\n\nYouTube: 54YdSq0Jt1U\n\n## Notes\n\nShort message from Esmeralda and Goober. Sara and Ian introduce the Game Show (1:19)\n\n\n# Sizzle\n\n## Notes\n\nGame Show\n\n\n# Bonus Action\n\n## Content\n\n### Bonus Action\nGet a point for pretending to put a sweater on as you come up to the front of the class!\n\n## Notes\n\n&nbsp;\n\n\n# Four Players Announcement\n\n## Notes\n\nFour players to the front.\n\n\n# Question 1\n\nYouTube: PJHFFyclkLA\n\n## Video Notes\n\nIan and Sara present Q1 of the gameshow (1:07).\n\n## Question\n\n### What is heat?\n\n## Answer\n\n### Heat is:\n\n* A type of energy.\n* You can measure the amount of heat something has by measuring its temperature. The unit of measure for temperature is degrees.\n* Heat can be transferred from one thing to another thing.\n* Heat is the result of molecules moving.  The faster they are moving the hotter things get!\n* Example: When water molecules move fast, liquid water turns to steam.  When water molecules move at a moderate pace, it stays as a liquid and when water molecules move very, very, slowly, they turn to solid ice.\n\n## Answer Notes\n\n&nbsp;\n\n\n# Question 2\n\nYouTube: QzodpZXWfp0\n\n## Video Notes\n\nIan and Sara present Q2 of the gameshow (1:06).\n\n## Question\n\n### Where does the hot water in your home come from?\n\n## Answer\n\n### Hot Water:\n\n* Is made by adding heat energy to water.\n* In your home, hot water is made in a hot water heater that is powered by burning natural gas or by electricity.\n* The hot water heater is most often found in basements or in the boiler rooms of larger buildings.\n\n## Answer Notes\n\n&nbsp;\n\n\n# Question 3\n\nYouTube: axnpn2jUeRE\n\n## Video Notes\n\nIan and Sara present Q3 of the gameshow (1:06).\n\n## Question\n\n### How does the hot water tank make the water hot?\n\n## Answer\n\n### How a hot water tank works:\n\n* The hot water heater burns natural gas or uses electricity to heat up metal.\n* The heat is then transferred to the water where it speeds up the molecules in water to make the water hotter.\n* Burning natural gas or using electricity to make hot water means you have to be smart about how much you use!\n* Taking a shorter shower saves water and energy!\n\n## Answer Notes\n\n&nbsp;\n"

/***/ }),
/* 1778 */
/***/ (function(module, exports) {

	module.exports = "# Game Show\n\nNiveau 4 – Conduite écolo\n\n\n# Intro Video\n\nYouTube: 2CrovSNvlew\n\n## Notes\n\nCourt message d’Esmeralda et de Goober. Sara et Ian présentent le jeu télévisé (1:31)\n\n\n# Sizzle\n\n## Notes\n\nLe jeu « télévisé »\n\n\n# Bonus Action\n\n## Content\n\n### Action prime\nFaites comme si vous conduisiez une voiture pour vous rendre à l’avant de la classe. Quand vous vous arrêtez, coupez le moteur pour obtenir un point prime!\n\n## Notes\n\n&nbsp;\n\n\n# Four Players Announcement\n\n## Notes\n\nQuatre joueuses et joueurs se rendent à l’avant.\n\n\n# Question 1\n\nYouTube: CQiEnTSzPY4\n\n## Video Notes\n\nIan et Sara présentent la Q1 du jeu télévisé (1:14).\n\n## Question\n\n### Qu’est-ce que le transport?\n\n## Answer\n\n### Le transport, c’est :\n\n* la façon dont vous choisissez de vous déplacer!\n* Les différentes méthodes de transport sont la marche, le vélo, l’autobus, le covoiturage, la planche à roulettes ou la trottinette pour se rendre aux endroits où l’on a besoin de se rendre pour nos activités quotidiennes.\n* On parle de « déplacements intelligents » parce qu’ils sont meilleurs pour votre corps et pour la planète.\n\n## Answer Notes\n\n&nbsp;\n\n\n# Question 2\n\nYouTube: Bf3xWg8ALPA\n\n## Video Notes\n\nIan et Sara présentent la Q2 du jeu télévisé (1:11).\n\n## Question\n\n### Quelle énergie les voitures consomment-elles?\n\n## Answer\n\n### Consommation d’énergie par les voitures :\n\n* Les moteurs de voitures peuvent utiliser différents types d’énergie ou de carburant pour se déplacer.\n* Aujourd’hui, la plupart des voitures fonctionnent à l’essence ou au diesel (qui proviennent à l’origine du pétrole, un combustible fossile).\n* Les voitures électriques commencent à gagner en popularité. D’où vient l’électricité qu’elles consomment?\n* Il existe également d’autres voitures qui fonctionnent à l’hydrogène, au gaz naturel, au biocarburant, à l’énergie solaire et à l’alcool!\n\n## Answer Notes\n\n&nbsp;\n\n\n# Question 3\n\nYouTube: No5o_FkbzuM\n\n## Video Notes\n\nIan et Sara présentent la Q3 du jeu télévisé (1:29).\n\n## Question\n\n### Qu’y a-t-il de mal à ce que les véhicules utilisent de l’essence?\n\n## Answer\n\n### Les véhicules qui consomment de l’essence posent un problème :\n\n* parce qu’il faut beaucoup d’énergie pour extraire le pétrole et l’essence du sol, et le processus d’extraction du pétrole et de l’essence pollue également l’air.\n* parce que la combustion de carburant dans nos voitures pollue également l’air.\n* parce que le pétrole et l’essence s’écoulent souvent de nos voitures et finissent dans les rivières, les lacs et les océans, ce qui pollue notre eau.\n* parce que les véhicules qui consomment de l’essence rejettent également des gaz à effet de serre dans l’atmosphère, ce qui accélère les changements climatiques.\n\n## Answer Notes\n\n&nbsp;\n\n\n# Question 4\n\nYouTube: 6kkwJL0-mME\n\n## Video Notes\n\nIan et Sara présentent la Q4 du jeu télévisé (1:18).\n\n## Question\n\n### Par quels moyens peut-on réduire la consommation d’essence des voitures?\n\n## Answer\n\n### Moyens de réduire la consommation d’essence des voitures :\n\n* Faites inspecter votre voiture! Un véhicule que l’on entretient bien consomme moins de carburant.\n* Assurez-vous que ses pneus sont bien gonflés.\n* N’appuyez pas trop sur l’accélérateur. Accélérez en douceur et lentement.\n* Respectez la limite de vitesse.\n* Ne laissez pas la voiture en marche au ralenti.\n* Marchez, pédalez, faites du covoiturage ou empruntez les transports en commun!\n\n## Answer Notes\n\n&nbsp;\n\n\n# Question 5\n\nYouTube: y_a1IJLcp18\n\n## Video Notes\n\nIan et Sara présentent la Q5 du jeu télévisé (1:30).\n\n## Question\n\n### Pourquoi la marche au ralenti pose-t-elle problème?\n\n## Answer\n\n### La marche au ralenti est à l’origine de nombreux problèmes :\n\n* C’est un gaspillage de carburant.\n* Elle pollue l’air.\n* Elle contribue aux changements climatiques.\n* Elle ne vous mène nulle part.\n\n## Answer Notes\n\n&nbsp;\n"

/***/ }),
/* 1779 */
/***/ (function(module, exports) {

	module.exports = "# Game Show\n\nLevel 4 - Keep Car Cool\n\n\n# Intro Video\n\nYouTube: qEA4m5t791Q\n\n## Notes\n\nShort message from Esmeralda and Goober. Sara and Ian introduce the Game Show (1:31)\n\n\n# Sizzle\n\n## Notes\n\nGame Show\n\n\n# Bonus Action\n\n## Content\n\n### Bonus Action\nPretend you're driving a car to the front of the class. When you stop, turn off the engine to get a bonus point!\n\n## Notes\n\n&nbsp;\n\n\n# Four Players Announcement\n\n## Notes\n\nFour players to the front.\n\n\n# Question 1\n\nYouTube: V8yPKsg5V6w\n\n## Video Notes\n\nIan and Sara present Q1 of the gameshow (1:14).\n\n## Question\n\n### What is transportation?\n\n## Answer\n\n### Transportation is:\n\n* The way you choose to get around!\n* Different methods of transportation are to walk, ride a bike, take a bus, carpool, skateboard or scooter to the places you need to go in your life.\n* We call these \"smart travel\" because they are better for your body and better for the planet.\n\n## Answer Notes\n\n&nbsp;\n\n\n# Question 2\n\nYouTube: 64vXgSA0tdQ\n\n## Video Notes\n\nIan and Sara present Q2 of the gameshow (1:11).\n\n## Question\n\n### What energy do cars use?\n\n## Answer\n\n### Energy use by cars:\n\n* Car engines can use many different kinds of energy or fuel to make them move.\n* Today, most cars run on gasoline or diesel (originally come from oil, a fossil fuel).\n* Electric cars are starting to become popular – where does the electricity they run on come from?\n* There are also other cars that run on hydrogen, natural gas, biofuel, solar power and alcohol!\n\n## Answer Notes\n\n&nbsp;\n\n\n# Question 3\n\nYouTube: jwPsbyrBzaU\n\n## Video Notes\n\nIan and Sara present Q3 of the gameshow (1:29).\n\n## Question\n\n### What is wrong with vehicles that use gas?\n\n## Answer\n\n### Vehicles that use gas are a problem because:\n\n* It takes a lot of energy to get oil and gas out of the ground, and the process of making oil and gas also pollutes the air.\n* Burning fuel in our cars also pollutes our air.\n* Oil and gas often drip from our cars and end up in the rivers, lakes and oceans, and this pollutes our water.\n* Vehicles that burn gas also release greenhouse gases into the atmosphere and this speeds up climate change.\n\n## Answer Notes\n\n&nbsp;\n\n\n# Question 4\n\nYouTube: NXjpbl91jnU\n\n## Video Notes\n\nIan and Sara present Q4 of the gameshow (1:18).\n\n## Question\n\n### What are some ways that you can use less gas in your car?\n\n## Answer\n\n### Ways you can use less gas in your car:\n\n* Take you car in for a check-up! A maintained vehicle burns less fuel.\n* Keep your tires pumped up.\n* Go easy on the accelerator. Speed up smoothly and slowly.\n* Drive the speed limit.\n* No idling.\n* Walk, cycle, rideshare or take transit!\n\n## Answer Notes\n\n&nbsp;\n\n\n# Question 5\n\nYouTube: mlmUtEvZHsE\n\n## Video Notes\n\nIan and Sara present Q5 of the gameshow (1:30).\n\n## Question\n\n### What is wrong with idling?\n\n## Answer\n\n### Idling causes lots of problems:\n\n* Idling is a waste of fuel.\n* It pollutes the air.\n* It contributes to climate change.\n* It gets you nowhere.\n\n## Answer Notes\n\n&nbsp;\n"

/***/ }),
/* 1780 */
/***/ (function(module, exports) {

	module.exports = "# Game Show\n\nNiveau 5 – Coupez les moteurs\n\n\n# EPP Webisode Intro\n\n## Content\n\n### Les plus récentes aventures d’Esmeralda et de Goober\nRegardez Esmeralda, gardienne de la planète, et Goober lutter contre le dernier plan du diabolique Dr Carbon pour empêcher les enfants de se rendre à l’école à pied.\n\nLa vidéo est en anglais - nous aurons bientôt une version française disponible !\n\n## Notes\n\n&nbsp;\n\n\n# EPP Webisode Video\n\nYouTube: 1FmXmBOU-V8\nLowRes: true\n\n## Notes\n\nWebisode d’Esmeralda, gardienne de la planète (8:24)\n\n\n# Intro Video\n\nYouTube: VQWqx6FRIkQ\n\n## Notes\n\nCourt message d’Esmeralda et de Goober. Sara et Ian présentent le jeu télévisé (1:08)\n\n\n# Sizzle\n\n## Notes\n\nLe jeu « télévisé »\n\n\n# Bonus Action\n\n## Content\n\n### Action prime\nObtenez un point si vous faites semblant de rouler à vélo quand vous arrivez devant la classe!\n\n## Notes\n\n&nbsp;\n\n# Four Players Announcement\n\n## Notes\n\nQuatre joueuses et joueurs se rendent à l’avant.\n\n\n# Question 1\n\nYouTube: lzGh7rUkoJg\n\n## Video Notes\n\nIan et Sara présentent la Q1 du jeu télévisé (1:05).\n\n## Question\n\n### Pourquoi les voitures posent-elles problème?\n\n## Answer\n\n### Les voitures sont à l’origine de problèmes parce :\n\n* qu’elles polluent l’air et provoquent des changements climatiques.\n* qu’elles nous font faire moins d’exercice. Au lieu de marcher jusqu’à l’arrêt d’autobus ou de nous rendre à vélo au magasin, nous prenons notre voiture parce que c’est plus rapide et plus pratique.\n* qu’elles polluent l’eau. Elles laissent souvent échapper de l’huile sur les routes, qui se déverse dans nos rivières, nos ruisseaux et nos océans.\n* qu’elles nécessitent beaucoup d’énergie et de matériaux au moment de leur fabrication.\n* que seule une petite quantité de matériau de leurs pneus est recyclée, le reste est envoyé aux sites d’enfouissement.\n\n## Answer Notes\n\n&nbsp;\n\n\n# Question 2\n\nYouTube: Y_RXHLFzKMY\n\n## Video Notes\n\nIan et Sara présentent la Q2 du jeu télévisé (1:55).\n\n## Question\n\n### Quelles ressources utilise-t-on pour fabriquer les voitures?\n\n## Answer\n\n### Ressources dont on se sert pour fabriquer les voitures :\n\n* Métaux : cuivre, fer, acier\n* Caoutchouc, verre, tissu ou cuir\n* Huile, plastiques, pétrole (pour le plastique)\n* Électricité\n* Temps\n* ... et beaucoup d’eau\n* Vous en trouverez peut-être d’autres!\n* De quelles ressources a-t-on besoin pour marcher, faire du vélo ou du patin à roulettes?\n\n## Answer Notes\n\n&nbsp;\n\n\n# Question 3\n\nYouTube: ZJEyuWZB_Ac\n\n## Video Notes\n\nIan et Sara présentent la Q3 du jeu télévisé (1:11).\n\n## Question\n\n### Quelles sont les alternatives à la conduite d’une voiture?\n\n## Answer\n\n### Alternatives à la conduite automobile :\n\n* Marcher ou faire du vélo.\n* Prendre l’autobus.\n* Faire du covoiturage (partage de la voiture avec la famille / les amis).\n* Faire de la planche à roulettes, du patins à roulettes ou de la trotinette.\n\n**SUPER CONSEIL** : Les déplacements actifs sont bons pour la santé et pour la planète! Tout le monde y gagne quand vous faites des choix de déplacements intelligents!\n\n## Answer Notes\n\n&nbsp;\n\n\n# Question 4\n\nYouTube: XPa9H7Cz7Zw\n\n## Video Notes\n\nIan et Sara présentent la Q4 du jeu télévisé (1:21).\n\n## Question\n\n### Quels obstacles empêchent les enfants de se rendre à pied à l’école?\n\n## Answer\n\n### Obstacles qui empêchent les enfants de se rendre à pied à l’école :\n\n* Je n’en ai pas le droit.\n* Ce n’est pas sans danger.\n* L’école est trop loin pour m’y rendre à pied.\n* Il fait trop froid, il pleut trop.\n* Mon père et ma mère m’y déposent en route pour le travail.\n* J’ai peur de me perdre.\n* Je me réveille à la dernière minute.\n\n## Answer Notes\n\n&nbsp;\n"

/***/ }),
/* 1781 */
/***/ (function(module, exports) {

	module.exports = "# Game Show\n\nLevel 5 - Go Car Free\n\n\n# EPP Webisode Intro\n\n## Content\n\n### Esmeralda and Goober's latest adventures\nWatch Esmeralda Planet Protector and Goober fight evil Dr Carbon's latest plan to stop kids from walking to school.\n\n## Notes\n\n&nbsp;\n\n\n# EPP Webisode Video\n\nYouTube: 1FmXmBOU-V8\nLowRes: true\n\n## Notes\n\nEsmeralda Planet Protector Webisode (8:24).\n\n\n# Intro Video\n\nYouTube: fzLGIECW7zw\n\n## Notes\n\nShort message from Esmeralda and Goober. Sara and Ian introduce the Game Show (1:08)\n\n\n# Sizzle\n\n## Notes\n\nGame Show\n\n\n# Bonus Action\n\n## Content\n\n### Bonus Action\nGet a point for pretending to ride your bike as you come up to the front of the class!\n\n## Notes\n\n&nbsp;\n\n# Four Players Announcement\n\n## Notes\n\nFour players to the front.\n\n\n# Question 1\n\nYouTube: m5PG1hVOPII\n\n## Video Notes\n\nIan and Sara present Q1 of the gameshow (1:05).\n\n## Question\n\n### Why are cars a problem?\n\n## Answer\n\n### Cars are a problem because:\n\n* Cars pollute the air and cause Climate Change.\n* Cars mean we get less exercise. Instead of walking to the bus stop or riding your bike to the store, we get in our cars because it's faster and more convenient.\n* Cars pollute our water. They often leak oil on the roads and it washes it into our rivers, streams, and oceans.\n* Cars take a lot of energy and materials to make.\n* Tires: only a small amount of tires are recycled, the rest go to the landfill.\n\n## Answer Notes\n\n&nbsp;\n\n\n# Question 2\n\nYouTube: 1-Fj9GCH0UI\n\n## Video Notes\n\nIan and Sara present Q2 of the gameshow (1:55).\n\n## Question\n\n### What resources are used to make cars?\n\n## Answer\n\n### Cars are made using:\n\n* Metals: copper, iron, steel\n* Rubber, Glass, Fabric or leather\n* Oil, Plastics, Petroleum (for plastic)\n* Electricity\n* Time\n* ...and lots of water\n* You may think of more!\n* What resources are needed to walk, bike, or skate?\n\n## Answer Notes\n\n&nbsp;\n\n\n# Question 3\n\nYouTube: IL1tULUGpMM\n\n## Video Notes\n\nIan and Sara present Q3 of the gameshow (1:11).\n\n## Question\n\n### What are some alternatives to driving a car?\n\n## Answer\n\n### Alternatives to driving:\n\n* Walking or Riding a bike.\n* Taking the bus.\n* Ridesharing (sharing the car with family/friends).\n* Skateboarding, Rollerblading or riding on your Scooter.\n\n**TOP TIP**: Active travel is good for your health and good for the planet! Everybody wins when you make smart travel choices!\n\n## Answer Notes\n\n&nbsp;\n\n\n# Question 4\n\nYouTube: 6fNbha54-dQ\n\n## Video Notes\n\nIan and Sara present Q4 of the gameshow (1:21).\n\n## Question\n\n### What are some things that get in the way of kids walking to school?\n\n## Answer\n\n### Things that get in the way of kids walking to school:\n\n* I’m not allowed to.\n* It's not safe.\n* It's too far to walk.\n* It's too cold, it's too rainy.\n* My Mom/Dad drops me off on their way to work.\n* I’m afraid of getting lost.\n* I always sleep in late.\n\n## Answer Notes\n\n&nbsp;\n"

/***/ }),
/* 1782 */
/***/ (function(module, exports) {

	module.exports = "# MME Level 1\nYouTube: _Rxn0y1tpvg\n\n## Notes\n\nMessages de la Mère Nature Saison 2, Épisode 1 (5:04) – Trouver votre super pouvoir\n\n\n# MME Level 2\nYouTube: mFltTOCbNi8\nLowRes: true\n\n## Notes\n\nMessages de la Mère Nature Saison 2, Épisode 2 (4:56) – Vous servir du pouvoir de votre énergie pour guérir Mère Nature\n\n\n# MME Level 3\nYouTube: kw4_QAlsFwY\n\n## Notes\n\nMessages de la Mère Nature Saison 2, Épisode 3 (4:53) – Incarner la danse de la nature\n\n\n# MME Level 4\nYouTube: _ZbAOQvSMZg\nLowRes: true\n\n## Notes\n\nMessages de la Mère Nature Saison 2, Épisode 4 (4:32) – Récits d’Aîné·e·s\n\n\n# MME Level 5\nYouTube: 90sPmUiNIMw\n\n## Notes\n\nMessages de la Mère Nature Saison 2, Épisode 5 (5:01) – La magie des graines\n\n\n# MME Level 6\nYouTube: iRw_bDcNtZI\n\n## Notes\n\nMessages de la Mère Nature Saison 2, Épisode 6 (5:05) – Apprendre le mouvement avec les animaux\n"

/***/ }),
/* 1783 */
/***/ (function(module, exports) {

	module.exports = "# MME Level 1\nYouTube: 4K62v044pi4\n\n## Notes\n\nMessages From Mother Earth Season 2, Episode 1 (5:04) - Finding Your Superpower\n\n\n# MME Level 2\nYouTube: mucwE7rKIpk\nLowRes: true\n\n## Notes\n\nMessages From Mother Earth Season 2, Episode 2 (4:56) - Using the power of your energy to heal Mother Earth\n\n\n# MME Level 3\nYouTube: fXG-dgR5J5g\n\n## Notes\n\nMessages From Mother Earth Season 2, Episode 3 (4:53) - Embodying Nature's Dance\n\n\n# MME Level 4\nYouTube: 78JVO-AAWo0\n\n## Notes\n\nMessages From Mother Earth Season 2, Episode 4 (4:32) - Elders Stories\n\n\n# MME Level 5\nYouTube: whmDCdBsNzg\n\n## Notes\n\nMessages From Mother Earth Season 2, Episode 5 (5:01) - The Magic of Seeds\n\n\n# MME Level 6\nYouTube: UuZKPncLCCk\n\n## Notes\n\nMessages From Mother Earth Season 2, Episode 6 (5:05) - Learning Movement from Animals\n"

/***/ }),
/* 1784 */
/***/ (function(module, exports) {

	module.exports = "# Intro Video\n\nYouTube: 4bOlxAwDU9Q\n\n## Notes\n\nIntroduction à l’activité de dessin enr équipe (1:08).\n\n\n# Sizzle\n\n## Content\n\n### Activité 1 : Dessin en équipe!\n\n## Notes\nLes instructions pour réaliser l’activité se trouvent à la diapositive suivante.\n\n\n# Instructions\n\n## Content\n\n### Instructions pour réaliser l’activité :\n* Chaque équipe tire au sort une saison dans la région où elle vit. L’équipe Terre dessine l’hiver. L’équipe Eau, le printemps; l’équipe Feu, l’été; l’équipe Air, l’automne.\n* Essayez différents médiums s’ils sont disponibles, comme le collage, l’encre, les crayons de couleur, les crayons de cire.\n* Une personne de chaque équipe montre les dessins à la classe.\n* Les points attribués aux équipes sont à la discrétion de l’enseignant·e – par exemple, 1 point pour chaque objet tiré au sort, 1 point pour une bonne présentation, 1 point pour le travail en commun.\n\n## Notes\n\n### Activités d’approfondissement :\n* Faites de la recherche pour trouver les températures moyennes enregistrées, les niveaux de précipitations et tout incident météorologique extrême survenu au cours des 50 à 100 dernières années pendant la saison sur laquelle votre équipe se concentre. Vos illustrations doivent refléter vos résultats et les données doivent figurer dans votre travail.\n* Imaginez ce que sera le climat dans les 50 à 100 prochaines années s’il continue à changer au rythme actuel. En équipe, dessinez votre vision.\n"

/***/ }),
/* 1785 */
/***/ (function(module, exports) {

	module.exports = "# Intro Video\n\nYouTube: E6um_9XZLdE\n\n## Notes\n\nIntro to Team Drawing activity (1:08).\n\n\n# Sizzle\n\n## Content\n\n### Activity 1: Team Drawing!\n\n## Notes\nActivity instructions on next slide.\n\n\n# Instructions\n\n## Content\n\n### Activity Instructions:\n* Each team draws one season in the region where they live. Earth team draws winter. Water team - spring, Fire team - summer, Air team - fall.\n* Share your drawings with the class.\n* Experiment with different media if they’re available! e.g. collage, ink, {r/Canada:coloured}{r/:colored} pencils, crayons.\n* One person from each team shows the class their drawing.\n* Award points to teams at teacher discretion - eg. 1 point for each item drawn, 1 point for a good presentation, 1 point for everyone working together.\n\n## Notes\n\n### Extension Activities:\n* Research recorded average temperatures, precipitation levels and any incidents of extreme weather that have occurred in the last 50-100 years in the season your team is focused on. Your illustrations should reflect your findings and the data must be featured in your work.\n* Imagine what the climate might be like in the next 50-100 years if the climate continues to change at its current rate. Draw your vision in your teams.\"\n"

/***/ }),
/* 1786 */
/***/ (function(module, exports) {

	module.exports = "# Sizzle\n\n## Content\n\n### Activité 1 : Dessin en équipe!\n\n## Notes\n\nLes instructions pour réaliser l’activité se trouvent à la diapositive suivante.\n\n\n# Intro Video\n\nYouTube: DcUmP88SkOA\n\n## Notes\n\nIntroduction à l’activité de dessin en équipe (1:25).\n\n\n# Instructions\n\n## Content\n\n### Instructions pour réaliser l’activité :\n* Dessinez une centrale électrique et montrez comment elle produit de l’énergie électrique.\n* Dessinez ensuite un transformateur, des lignes de transmission, etc.\n* Reliez le tout pour montrer comment l’électricité circule de la centrale aux domiciles.\n* Essayez différents médiums s’ils sont disponibles, comme le collage, l’encre.\n* Une personne de chaque équipe montre les dessins à la classe.\n* Les points attribués aux équipes sont à la discrétion de l’enseignant·e – par exemple, 1 point pour chaque objet tiré au sort, 1 point pour une bonne présentation, 1 point pour le travail en commun.\n\n## Notes\n\n&nbsp;\n"

/***/ }),
/* 1787 */
/***/ (function(module, exports) {

	module.exports = "# Sizzle\n\n## Content\n\n### Activity 1: Team Drawing!\n\n## Notes\n\nActivity instructions on next slide.\n\n\n# Intro Video\n\nYouTube: T6q43v8N1NU\n\n## Notes\n\nIntro to Team Drawing Activity (1:25).\n\n\n# Instructions\n\n## Content\n\n### Activity Instructions:\n* Draw a power generator and show how it produces electrical energy.\n* Then draw a transformer, transmission lines etc.\n* Link them together to show how electricity flows from the power station to your house.\n* Experiment with different media if they’re available! e.g. collage, ink.\n* One person from each team shows the class the drawing.\n* Award points to teams at teacher discretion - eg. 1 point for each item drawn, 1 point for a good presentation, 1 point for everyone working together.\n\n## Notes\n\n&nbsp;\n"

/***/ }),
/* 1788 */
/***/ (function(module, exports) {

	module.exports = "# Sizzle\n\n## Content\n\n### Activité 2 : Composez un rap!\n(Les plus jeunes pourraient plutôt composer un poème)\n\n## Notes\n\n&nbsp;\n\n\n# Intro Video  \n\nYouTube: aQ1nf9OXk_c\n\n## Notes\n\nIntroduction à l’activité de rap sur les économies d’énergie (1:06).\n\n\n# Instructions\n\n## Content\n\n### Instructions pour composer le rap\n* Écrivez au sujet des économies d’énergie ou de ce que vous avez appris aujourd’hui.\n* Écrivez deux phrases dont le dernier mot de chacune rime.\n* Votre dossier de mission contient des exemples de rimes, mais vous obtiendrez des points supplémentaires si vous utilisez des mots qui ne figurent pas dans le livret.\n* Si vous composez un rap, exercez-vous avec la piste d’accompagnement de la diapositive suivante.\n\n## Notes\n\nLe livret de mission contient une fiche de travail consacrée à cette activité.\n\n\n# Scoring\n\n## Content\n\n### Obtenez des points :\n* pour deux phrases qui riment.\n* pour une bonne prestation.\n* si vous avez fait du « beatboxing ».\n* si vous avez bien écouté les autres.\n\n## Notes\n\n&nbsp;\n\n\n# Rap Backtrack Practice\n\nYouTube: eEzxxHgcpzE\n\n## Notes\n\nPour faire rejouer la piste (10:08), il suffit d’appuyer de nouveau sur la touche « jouer ».\n\n\n# Performing Intro Video\n\nYouTube: oJ6MWntpQII\n\n## Notes\n\nIan et Sara présentent les prestations (0:34).\n\n\n# Rap Backtrack Perform\nYouTube: eEzxxHgcpzE\n\n## Notes\n\n### Activité d’approfondissement\nFilmez vos raps et soumettez-les sur notre site Web!\n"

/***/ }),
/* 1789 */
/***/ (function(module, exports) {

	module.exports = "# Sizzle\n\n## Content\n\n### Activity 2: Write a rap!\n(Younger grades can write a poem instead)\n\n## Notes\n\n&nbsp;\n\n\n# Intro Video  \n\nYouTube: FlTvuhTGQ3M\n\n## Notes\n\nIntro to Energy Saving Rap activity (1:06).\n\n\n# Instructions\n\n## Content\n\n### Rap Instructions\n* Write about saving energy, or something you learned today.\n* Write two lines, where the last word in each line rhymes.\n* Your Mission Files has sample rhymes, but get bonus points for using words that aren't in the booklet.\n* If you're writing a rap, {r/Canada:practise}{r/:practice} in your teams with the backing track on the next slide.\n\n## Notes\n\nThere is a worksheet in the Mission Book for this activity.\n\n\n# Scoring\n\n## Content\n\n### Get points for:\n* Two lines that rhyme.\n* Good performance.\n* Beatboxing.\n* Being a good audience.\n\n## Notes\n\n&nbsp;\n\n\n# Rap Backtrack Practice\n\nYouTube: eEzxxHgcpzE\n\n## Notes\n\nTo get the backtrack (10:08) to repeat, just press play again.\n\n\n# Performing Intro Video\n\nYouTube: hJjNU0SQmsY\n\n## Notes\n\nIan and Sara introduce the performances (0:34).\n\n\n# Rap Backtrack Perform\nYouTube: eEzxxHgcpzE\n\n## Notes\n\n### Extension Activity\nVideo your raps and submit them to our website!\n"

/***/ }),
/* 1790 */
/***/ (function(module, exports) {

	module.exports = "# Sizzle\n\n## Content\n\n### Activité 1 : Jeu de théâtre!\n\n## Notes\n\n&nbsp;\n\n\n# Intro Video\n\nYouTube: _cXARBCrhBE\n\n## Notes\n\nIntroduction au jeu de théâtre (1:04).\n\n\n# Instructions\n\n## Content\n\n### Instructions pour réaliser l’activité :\nDans vos groupes, faites semblant de faire partie du système d’alimentation en eau et créez le parcours de l’eau depuis le réservoir jusqu’à la baignoire. Composantes possibles d’un système d’eau chaude :\n* Réservoir à eau chaude\n* Brûleur à gaz dans le réservoir\n* Tuyaux\n* Pomme de douche et/ou baignoire avec robinet\n* Rideau de douche\n* Personne dans la douche\n\n## Notes\n\nLes équipes obtiennent des points pour la présentation de leur système\n"

/***/ }),
/* 1791 */
/***/ (function(module, exports) {

	module.exports = "# Sizzle\n\n## Content\n\n### Activity 1: Theatre Game!\n\n## Notes\n\n&nbsp;\n\n\n# Intro Video\n\nYouTube: 8OGBq4r1ZxQ\n\n## Notes\n\nIntro to Theatre Game (1:04).\n\n\n# Instructions\n\n## Content\n\n### Activity Instructions:\nIn your groups, pretend to be parts of the water system and create the path of water from the tank to the tub. Possible Parts in a Hot Water System:\n* Hot water tank\n* Gas burner in tank\n* Pipe(s)\n* Shower head and/or bathtub with tap\n* Shower curtain\n* Person in shower\n\n## Notes\n\nTeams get points for presenting their systems\n"

/***/ }),
/* 1792 */
/***/ (function(module, exports) {

	module.exports = "# Sizzle\n\n## Content\n\n### Activité 2 : Dessin!\n\n## Notes\n\nLes instructions pour réaliser l’activité se trouvent à la diapositive suivante.\n\n\n# Intro Video\n\nYouTube: NsfbDRB6CGA\n\n## Notes\n\nIntroduction à l’activité de dessin (0:46).\n\n\n# Instructions\n\n## Content\n\n### Créez une affiche Douche chrono\n* Rappelez-vous et rappelez à votre famille que vous avez le pouvoir de passer moins de temps dans la douche – et d’économiser ainsi de l’énergie.\n* Essayez différents médiums s’ils sont disponibles, par exemple le collage, l’encre, les crayons de couleur, les crayons de cire.\n* Les douches ne devraient pas durer plus de 5 minutes!\n* Placez votre affiche dans ou près de votre salle de bain à la maison.\n* Les apprenti·e·s obtiennent des points lorsqu’elles, ils ou iels terminent leur affiche.\n\n## Notes\n\n&nbsp;\n"

/***/ }),
/* 1793 */
/***/ (function(module, exports) {

	module.exports = "# Sizzle\n\n## Content\n\n### Activity 2: Team Drawing!\n\n## Notes\n\nActivity instructions on next slide.\n\n\n# Intro Video\n\nYouTube: AkLnS6hd8Q4\n\n## Notes\n\nIntro to Team Drawing activity (0:46).\n\n\n# Instructions\n\n## Content\n\n### Make a Shower Power Poster\n* Remind you and your family that you have the power to take a short shower - and save energy.\n* Experiment with different media if they’re available! e.g. collage, ink, {r/Canada:coloured}{r/:colored} pencils, crayons.\n* Showers should be 5 minutes max!\n* Put your poster in or near your bathroom at home.\n* Apprentices get points for completing their poster.\n\n## Notes\n\n&nbsp;\n"

/***/ }),
/* 1794 */
/***/ (function(module, exports) {

	module.exports = "# Energy Demonstration Intro\n\n## Content\n\n### Apprenez-en davantage sur l’énergie... et sur le gaspillage d’énergie!\n\n## Notes\n\n&nbsp;\n\n\n# Energy Demonstration Video\n\nYouTube: XuqWMEKG3Dg\n\n## Notes\n\n* Esmeralda et Goober démontrent que l’on consomme plus d’énergie en courant qu’en marchant et qu’il en va de même pour la voiture (1:33).\n* On encourage les apprenti·e·s à se lever et à marcher/courir sur place à côté de leur bureau.\n* Les voitures consomment moins de carburant lorsque vous respectez la limite de vitesse (comparativement à quand vous roulez plus vite).\n\n\n# Sizzle\n\n## Content\n\n### Activité 1 : Dessin en équipe!\n\n## Notes\n\n&nbsp;\n\n\n# Instructions\n\n## Content\n\n### Options de transport\n* Dessinez autant de moyens de transport différents que possible.\n* Pour obtenir le maximum de points, chaque membre de l’équipe doit dessiner au moins une chose.\n* Une personne de chaque équipe montre les dessins à la classe.\n\n## Notes\n\n&nbsp;\n"

/***/ }),
/* 1795 */
/***/ (function(module, exports) {

	module.exports = "# Energy Demonstration Intro\n\n## Content\n\n### Learn more about energy... and how it's wasted!\n\n## Notes\n\n&nbsp;\n\n\n# Energy Demonstration Video\n\nYouTube: lYmxMDg4z3E\n\n## Notes\n\n* Esmeralda and Goober demonstrate how you use more energy when you run than when you walk and it’s similar with your car (1:33).\n* Apprentices are encouraged to stand up and walk/run on the spot next to their desks.\n* Cars use less fuel when you go the speed limit (as opposed to speeding).\n\n\n# Sizzle\n\n## Content\n\n### Activity 1: Team Drawing!\n\n## Notes\n\n&nbsp;\n\n\n# Instructions\n\n## Content\n\n### Transportation options\n* Draw as many different kinds of transportation as you can.\n* For full points, every team member must draw at least one thing.\n* Each group presents to the class.\n\n## Notes\n\n&nbsp;\n"

/***/ }),
/* 1796 */
/***/ (function(module, exports) {

	module.exports = "# Sizzle\n\n## Content\n\n### Activité 2 : Évaluez vos options de transport!\n\n## Notes\n\n&nbsp;\n\n\n# Intro Video  \nYouTube: b79uasam7U8\n\n## Notes\nIntroduction à l’activité d’évaluation des options de transport (0:33).\n\n\n# Instructions\n\n## Content\n\n### Instructions pour réaliser l’activité :\n* Classez les options en fonction de la pollution qu’elles génèrent.\n* Ensuite, évaluez-les en fonction de la quantité d’exercice que vous faites.\n* Quelles sont les options les plus actives?\n* Faites part des évaluations de votre équipe à votre classe.\n* Les équipes obtiennent des points pour leur participation, leur ingéniosité, leur exactitude, leur travail d’équipe et leur présentation.\n\n## Notes\n\n&nbsp;\n"

/***/ }),
/* 1797 */
/***/ (function(module, exports) {

	module.exports = "# Sizzle\n\n## Content\n\n### Activity 2: Rate your transportation options!\n\n## Notes\n\n&nbsp;\n\n\n# Intro Video  \nYouTube: jJQZHSEZyfs\n\n## Notes\nIntro to rating transportation options activity (0:33).\n\n\n# Instructions\n\n## Content\n\n### Activity Instructions:\n* Rate the items by how much pollution they make.\n* Then rate them by how much exercise you get.\n* Which ones are the most active?\n* Share your team's ratings with your class.\n* Teams can score points for participation, ingenuity, correctness, teamwork and presentation.\n\n## Notes\n\n&nbsp;\n"

/***/ }),
/* 1798 */
/***/ (function(module, exports) {

	module.exports = "# Sizzle\n\n## Content\n\n### Activité 1 : Remue-méninges en l’équipe!\n\n## Notes\n\n&nbsp;\n\n\n# Intro Video  \n\nYouTube: gnt-y8oiCgw\n\n## Notes\n\nMme G présente l’activité Remue-méninges en équipe (0:36).\n\n\n# Instructions\n\n## Content\n\n### Résolution de problèmes!\n* En équipe, trouvez au moins deux solutions aux obstacles qui empêchent les enfants de se rendre à pied à l’école.\n* Obtenez 1 point pour chaque idée.\n\n## Notes\n\nAttribuez des points à chaque solution viable.\n\n\n# Class Discussion\n\n## Content\n\n### Discussion en classe\n* Quelle est la solution semblerait le mieux fonctionner dans la vraie vie?\n* Que pourrions-nous dire d’autre à nos parents pour les convaincre de moins conduire?\n\n## Notes\n\n&nbsp;\n"

/***/ }),
/* 1799 */
/***/ (function(module, exports) {

	module.exports = "# Sizzle\n\n## Content\n\n### Activity 1: Team Brainstorm!\n\n## Notes\n\n&nbsp;\n\n\n# Intro Video  \n\nYouTube: 5HqnvSzhvys\n\n## Notes\n\nMrs G introduces the Team Brainstorm activity (0:36).\n\n\n# Instructions\n\n## Content\n\n### Problem solving!\n* In your teams, come up with at least 2 solutions to the things that get in the way of kids walking to school.\n* Get 1 point for each idea.\n\n## Notes\n\nAssign points for each viable solution.\n\n\n# Class Discussion\n\n## Content\n\n### Class Discussion\n* What solution seemed like it would work best in real life?\n* What are some other things we could tell our parents to convince them to drive less?\n\n## Notes\n\n&nbsp;\n"

/***/ }),
/* 1800 */
/***/ (function(module, exports) {

	module.exports = "# Sizzle\n\n## Content\n\n### Activité 2 : Jeu de rôles!\n\n## Notes\n\n&nbsp;\n\n\n# Intro Video\n\nYouTube: WujtxWtt5_w\n\n## Notes\n\nMme G présente l’activité Jeu de rôles (0:38).\n\n\n# Instructions\n\n## Content\n\n### En équipe, faites un jeu de rôles :\n* Certain·e·s apprenti·e·s jouent leur propre rôle, d’autres jouent le rôle de parents qui veulent conduire.\n* Décidez où vous allez et comment vous pouvez vous y rendre sans voiture.\n* Trouvez de bonnes raisons de marcher, de faire du vélo ou d’emprunter les transports en commun.\n* Répétez votre jeu de rôles en équipe et soyez prêt·e·s à le présenter à la classe dans 10 minutes.\n\n## Notes\nCette activité aidera les apprenti·e·s à s’exercer en vue des conversations qu’elles, ils et iels auront avec leur famille.\n* Demandez à vos élèves de faire part des raisons les plus convaincantes données par les enfants dans le jeu de rôles.\n* Dans quelle mesure leurs raisons ont-elles permis de surmonter certains des obstacles provenant des parents que vous avez déterminés plus tôt?\n\n### Activité d’approfondissement\nCréez une affiche qui montre des alternatives aux achats impulsifs OU qui fait le contraste entre les achats impulsifs et les achats intelligents.\n"

/***/ }),
/* 1801 */
/***/ (function(module, exports) {

	module.exports = "# Sizzle\n\n## Content\n\n### Activity 2: Role Play!\n\n## Notes\n\n&nbsp;\n\n\n# Intro Video\n\nYouTube: fNc4Cn269kc\n\n## Notes\n\nMrs G introduces the Role Play activity (0:38).\n\n\n# Instructions\n\n## Content\n\n### In your teams, do a role play:\n* Some Apprentices play themselves, others play parents who want to drive.\n* Decide where you are going and how you could get there without taking the car.\n* Come up with good reasons to walk, bike, or take transit instead.\n* {r/Canada:Practise}{r/:Practice} your role play in your teams, be ready to perform them for the class in 10 mins.\n\n## Notes\nThis activity will help Apprentices practice for conversations they'll have with their families.\n* Ask your students to share the most convincing reasons given by the kids in the role play.\n* How well did their reasons overcome some of the parent barriers you brainstormed earlier?\n\n### Extension Activity\nMake a poster showing alternatives to buying things impulsively OR contract impulse buying with Buy Smart buying.\n"

/***/ }),
/* 1802 */
/***/ (function(module, exports) {

	module.exports = "# Sizzle\n\n## Content\n\n### Activité 1 : Bricolages d’Esmeralda et de Goober!\n\n## Notes\n\nLes prix de bricolage se trouvent dans la section du matériel à imprimer de la page du tableau de bord.\n\nImprimez les bricolages en couleur ou demandez aux enfants de colorier les leurs après que vous aurez imprimé les versions en noir et blanc!\n\n\n# Intro Video\n\nYouTube: 1Kx_8aYA2A0\n\n## Notes\nIntroduction à l’activité des bricolages (0:29).\n"

/***/ }),
/* 1803 */
/***/ (function(module, exports) {

	module.exports = "# Sizzle\n\n## Content\n\n### Activity 1: Esmeralda & Goober Papercrafts!\n\n## Notes\n\nThe Papercraft prizes can be found in the Printables section on the Dashboard page.\n\nPrint the {r/Canada:colour}{r/:color} papercrafts or have the kids {r/Canada:colour}{r/:color} their own by using the black & white versions!\n\n\n# Intro Video\n\nYouTube: 0j3_79qkTY0\n\n## Notes\nIntro to Papercrafts activity (0:29).\n"

/***/ }),
/* 1804 */
/***/ (function(module, exports) {

	module.exports = "# Mission Assignment\n\nTitle: Opération Interrupteur\n\n## Notes\n\n### Opération Interrupteur\n* Les apprenti·e·s ouvrent leur livret de mission à la mission 1.\n* Décidez du jour auquel vous effectuerez le niveau suivant.\n* Les apprenti·e·s inscrivent cette date sur la couverture de leur livre de mission et sur la page de la mission 1.\n* Des points sont attribués quand la page de la mission 1 est signée et remise.\n\n\n# Mission Intro Video\n\nYouTube: lR0Z0lYMNkA\n\n## Notes\n\nEsmeralda et Goober présentent la mission 1 (1:11)\n\n\n# Instructions\n\n## Content\n\n### Mission 1 :\n\n#### Éteindre les lumières\n* Éteignez les lumières quand vous quittez une pièce à la maison ou à l’école, et récoltez un point pour votre équipe.\n* Rappelez aux membres de votre famille d’éteindre les lumières lorsqu’elles, ils et iels quittent une pièce, et récoltez un point pour votre équipe.\n* Inscrivez vos points dans votre livret de mission, à la mission  1.\n* Encouragez les membres de votre équipe à remplir réaliser vos missions jusqu’à la prochaine journée de l’Académie des gardiens de la planète.\n\n## Notes\n\n&nbsp;\n"

/***/ }),
/* 1805 */
/***/ (function(module, exports) {

	module.exports = "# Mission Assignment\n\nTitle: Operation Darkroom\n\n## Notes\n\n### Operation Darkroom\n* Apprentices turn to Mission 1 in their Mission Books.\n* Decide which day you will do the next Level.\n* Apprentices write that date on the cover of their Mission Books and on the Mission 1 page.\n* Points are awarded for signed and returned Mission 1 page.\n\n\n# Mission Intro Video\n\nYouTube: K3KDPgOXn5w\n\n## Notes\n\nEsmeralda and Goober introduce Mission 1 (1:11)\n\n\n# Instructions\n\n## Content\n\n### Mission 1:\n\n#### Turning off lights\n* Turn off lights when you leave a room at home or school, and get a point for your team.\n* Remind your family to turn off lights when they leave a room, and get a point for your team.\n* Record your points in your Mission Book, under Mission 1.\n* Keep encouraging your team members to fulfill your missions until the next Planet Protector Academy day.\n\n## Notes\n\n&nbsp;\n"

/***/ }),
/* 1806 */
/***/ (function(module, exports) {

	module.exports = "# Mission Assignment\n\nTitle: Opération Douche chrono\n\n## Notes\n\n### Opération Douche chrono\n* Les apprenti·e·s ouvrent leur livret de mission à la mission 2.\n* Décidez du jour auquel vous effectuerez le niveau suivant.\n* Les apprenti·e·s inscrivent cette date sur la couverture de leur livre de mission et sur la page de la mission 2.\n* Des points sont attribués quand la page de la mission 2 est signée et remise.\n\n\n# Mission Intro Video\n\nYouTube: nw2xxgjT4Q4\n\n## Notes\n\nEsmeralda et Goober présentent la mission 2 (1:10)\n\n\n# Instructions\n\n## Content\n\n### Mission 2 :\n#### Prendre des douches plus rapides\n* Passez moins de temps sous la douche (5 minutes maximum!) et récoltez un point pour votre équipe.\n* Encouragez votre famille à passer moins de temps sous la douche et récoltez un point pour votre équipe.\n* Inscrivez vos points dans votre livret de mission, à la mission  2.\n* Encouragez les membres de votre équipe à remplir réaliser vos missions jusqu’à la prochaine journée de l’Académie des gardiens de la planète.\n\n## Notes\n\n&nbsp;\n"

/***/ }),
/* 1807 */
/***/ (function(module, exports) {

	module.exports = "# Mission Assignment\n\nTitle: Operation Shower Power\n\n## Notes\n\n### Operation Shower Power\n* Apprentices turn to Mission 2 in their Mission Books.\n* Decide which day you will do the next Level.\n* Apprentices write that date on the cover of their Mission Books and on the Mission 2 page.\n* Points are awarded for signed and returned Mission 2 page.\n\n\n# Mission Intro Video\n\nYouTube: 4fTlSCkGpnQ\n\n## Notes\n\nEsmeralda and Goober introduce Mission 2 (1:10)\n\n\n# Instructions\n\n## Content\n\n### Mission 2:\n#### Taking shorter showers\n* Take a shorter shower (5 minutes max!) and get a point for your team.\n* Encourage your family to take shorter showers, and get a point for your team.\n* Record your points in your Mission Book, under Mission 2.\n* Keep encouraging your team members to fulfill your missions until the next Planet Protector Academy day.\n\n## Notes\n\n&nbsp;\n"

/***/ }),
/* 1808 */
/***/ (function(module, exports) {

	module.exports = "# Mission Assignment\n\nTitle: Opération Conduite écolo\n\n## Notes\n\n### Opération Conduite écolo\n* Les apprenti·e·s ouvrent leur livret de mission à la mission 3.\n* Décidez du jour auquel vous effectuerez le niveau suivant.\n* Les apprenti·e·s inscrivent cette date sur la couverture de leur livre de mission et sur la page de la mission 3.\n* Des points sont attribués quand la page de la mission 3 est signée et remise.\n\n\n# Mission Intro Video\n\nYouTube: e0Gf0azxJ20\n\n## Notes\n\nEsmeralda et Goober présentent la mission 3 (0:47)\n\n\n# Instructions\n\n## Content\n\n### Mission 3 :\n#### Réduire la marche au ralenti et les excès de vitesse\n* Toutes les fois que vous rappelez à votre famille de ne pas faire tourner le moteur au ralenti ou de ne pas faire d’excès de vitesse, vous récoltez un point pour votre équipe.\n* Demandez à votre famille de faire faire l’entretien de votre (vos) véhicule(s) pour aussi récolter des points.\n* Si votre famille n’a pas de voiture, récoltez des points toutes les fois que vous marchez, faites du vélo, faites de la planche à roulettes ou empruntez l’autobus!\n* Inscrivez vos points dans votre livret de mission, à la mission  3.\n* Continuez à encourager les membres de votre équipe à réaliser leurs missions!\n\n## Notes\n\n&nbsp;\n"

/***/ }),
/* 1809 */
/***/ (function(module, exports) {

	module.exports = "# Mission Assignment\n\nTitle: Operation Keep Car Cool\n\n## Notes\n\n### Operation Keep Car Cool\n* Apprentices turn to Mission 3 in their Mission Books.\n* Decide which day you will do the next Level.\n* Apprentices write that date on the cover of their Mission Books and on the Mission 3 page.\n* Points are awarded for signed and returned Mission 3 page.\n\n\n# Mission Intro Video\n\nYouTube: scDDfkVr1Gk\n\n## Notes\n\nEsmeralda and Goober introduce Mission 3 (0:47)\n\n\n# Instructions\n\n## Content\n\n### Mission 3:\n#### Reduce idling and speeding\n* Each time you remind your family not to idle the car or speed, you get a point for team.\n* Ask your family to keep your vehicle(s) maintained to get points too.\n* If your family doesn't have a car, get points every time you walk, cycle, skate or take the bus!\n* Record your points in your Mission Book, under Mission 3.\n* Keep encouraging your team members to fulfill their missions!\n\n## Notes\n\n&nbsp;\n"

/***/ }),
/* 1810 */
/***/ (function(module, exports) {

	module.exports = "# Mission Assignment\n\nTitle: Opération Coupez les moteurs\n\n## Notes\n\n### Opération Conduite écolo\n* Les apprenti·e·s ouvrent leur livret de mission à la mission 4.\n* Décidez du jour auquel vous effectuerez le niveau suivant.\n* Les apprenti·e·s inscrivent cette date sur la couverture de leur livre de mission et sur la page de la mission 4.\n* Des points sont attribués quand la page de la mission 4 est signée et remise.\n\n\n# Mission Intro Video\n\nYouTube: 2OFGxj7j_QI\n\n## Notes\n\nEsmeralda et Goober présentent la mission 4 (1:09).\n\n\n# Instructions\n\n## Content\n\n### Mission 4 :\n#### Adopter un mode de transport plus actif :\n* Toutes les fois que vous marchez, faites du vélo, empruntez les transports en commun, faites du covoiturage, etc. au lieu de conduire, vous récoltez un point pour votre équipe.\n* Toutes les fois qu’un membre de votre famille fait du vélo, marche, emprunte les transports en commun, fait du covoiturage, etc. au lieu de conduire, vous récoltez un point pour votre équipe.\n* Inscrivez vos points dans votre livret de mission, à la mission  4.\n* Encouragez les membres de votre équipe à remplir réaliser vos missions jusqu’à la prochaine journée de l’Académie des gardiens de la planète.\n\n## Notes\n\n&nbsp;\n"

/***/ }),
/* 1811 */
/***/ (function(module, exports) {

	module.exports = "# Mission Assignment\n\nTitle: Operation Go Car Free\n\n## Notes\n\n### Operation Keep Car Cool\n* Apprentices turn to Mission 4 in their Mission Books.\n* Decide which day you will do the next Level.\n* Apprentices write that date on the cover of their Mission Books and on the Mission 4 page.\n* Points are awarded for signed and returned Mission 4 page.\n\n\n# Mission Intro Video\n\nYouTube: 0_sy2cxaT7Q\n\n## Notes\n\nEsmeralda and Goober introduce Mission 4 (1:09).\n\n\n# Instructions\n\n## Content\n\n### Mission 4:\n#### Taking more active transportation:\n* Each time you walk, bike, transit, carpool, etc., instead of driving, you get a point for team.\n* Each time someone in your family bikes, walks, transits, carpools, etc., instead of driving, you get a point for your team.\n* Record your points in your Mission Book, under Mission 4.\n* Keep encouraging your team members to fulfill your missions until the next Planet Protector Academy day.\n\n## Notes\n\n&nbsp;\n"

/***/ }),
/* 1812 */
/***/ (function(module, exports) {

	module.exports = "# Scoreboard Recap\n\n## Content\n\n### Consultez le tableau d’affichage pour voir qui est en tête!\n\n## Notes\n\n&nbsp;\n\n\n# Earn More Points\n\n## Content\n\n### Tout le monde a une chance de récolter plus de points!\n* Ramenez vos dossiers de mission à la maison.\n* Réalisez vos missions et consignez ce que vous avez fait.\n* Écoutez et participez en classe!\n\n## Notes\n\n&nbsp;\n\n\n# Level 1 Farewell Video\n\nYouTube: 41ORdwK8KRg\n\n## Notes\n\nEsmeralda et Goober font leurs adieux au niveau 1 (0:17).\n\n\n# Farewell\n\n## Content\n\n### Continuez de vous amuser!\n#### Consultez *AndGoober.com* pour trouver des jeux et des activités\nPassez à la diapositive suivante pour terminer le niveau\n\n## Notes\n\nPour terminer, passez à la diapositive suivante et cliquez sur « Cliquer pour terminer le niveau ».\n"

/***/ }),
/* 1813 */
/***/ (function(module, exports) {

	module.exports = "# Scoreboard Recap\n\n## Content\n\n### Check out the scoreboard to see who's in the lead!\n\n## Notes\n\n&nbsp;\n\n\n# Earn More Points\n\n## Content\n\n### Everyone has a chance to earn more points!\n* Take home your Mission Files.\n* Do your missions and record what you did.\n* Listen & participate in class!\n\n## Notes\n\n&nbsp;\n\n\n# Level 1 Farewell Video\n\nYouTube: 6eMI_c6Ll0Q\n\n## Notes\n\nEsmeralda and Goober say farewell for Level 1 (0:17).\n\n\n# Farewell\n\n## Content\n\n### Keep the fun going!\n#### Visit *AndGoober.com* for games and activities\nGo to the next slide to finish the level\n\n## Notes\n\nTo finish, go to the next slide and click 'Click to end level'.\n"

/***/ }),
/* 1814 */
/***/ (function(module, exports) {

	module.exports = "# Announce Winners\n\n## Content\n\n### Il est temps d’annoncer les personnes gagnantes!\n#### Agent·e·s de formation, remettez les certificats.\n\n## Notes\n\nImprimez les certificats de l’équipe gagnante après que vous savez qui a gagné; donnez dès maintenant à tou·te·s les membres de l’équipe des certificats d’achèvement.\n\n### Activité d’approfondissement\nC’est maintenant le moment idéal pour faire l’activité de bricolage!\n\n\n# Ian and Sara Pie\n\nYouTube: CInCeoRQ9_c\n\n## Notes\n\nIan parvient enfin à entartrer Sara au visage!\n\n\n# Esmeralda and Goober Congrats\n\nYouTube: jraHfuJHxhA\n\n## Notes\n\nEsmeralda et Goober félicitent les apprenti·e·s (0:21).\n\n\n# All Levels Completed\n\n## Notes\n\n&nbsp;\n\n### Vos commentaires\n\nNous aimons que les enseignant·e·s nous fassent part de leurs commentaires au sujet de leur expérience de l’Académie. Dans les prochains jours, nous vous transmettrons un sondage de rétroaction!\n\nAvez-vous des idées d’activités d’approfondissement? N’hésitez pas à nous en faire part!\n"

/***/ }),
/* 1815 */
/***/ (function(module, exports) {

	module.exports = "# Announce Winners\n\n## Content\n\n### Time to announce the winners!\n#### Training Agents please hand out certificates.\n\n## Notes\n\nPrint winning team certificates once you know who won; give all team members completion certificates now.\n\n### Extension Activity\nNow's a great time to do the papercraft activity!\n\n\n# Ian and Sara Pie\n\nYouTube: P6eq5yrIwow\n\n## Notes\n\nIan finally gets to put pie in Sara's face!\n\n\n# Esmeralda and Goober Congrats\n\nYouTube: lh7PUYyNyY0\n\n## Notes\n\nEsmeralda and Goober congratulate the Apprentices (0:21).\n\n\n# All Levels Completed\n\n## Notes\n\n&nbsp;\n\n### Getting your feedback\n\nWe love to hear from teachers about their experience with the Academy. We'll be in touch in the next few days with a feedback survey!\n\nHave ideas for extension activities? Please share them with us!\n"

/***/ }),
/* 1816 */
/***/ (function(module, exports) {

	module.exports = "# Extension Activities\n\n#### All levels\n* Planet Protector Academy song\n  * Perform on Earth Day or at another assembly for your school with the karaoke version in the Fun section\n  * We’d love to hear about it or see a video!!\n  * For even more fun, Apprentices can create their own choreography.\n* Useful resources to extend learning:\n  * [Biomimicry Education Network](https://asknature.org/groups/biomimicry-education-network/#.WIy_B7YrI_U)\n  *\t[Center for a New American Dream](https://www.newdream.org/)\n  *\t[Resourceful PDX](http://www.resourcefulpdx.com/)\n\n#### Level 1 - Operation Garbage Watch\n* Mapping garbage\n  * Carry out some research to find out where  garbage goes.\n  * How many miles does it travel to get there?\n  * Draw a map showing the route.\n  * What does it look like? Draw a picture of it.  \n* Drawing joys\n  * Add more joys to your drawing every day for a week.\n  * Act out some of the joys and have other teams guess.\n  * Do an art project to express one particular joy, eg. Do a painting of playing soccer, or make up a song about being in nature.\n\n#### Level 2 - Operation Love Food, Hate Waste\n*\tUse food to explore systems by mapping production, transportation, consumption, disposal\n* Explore how consumer choice affects which product varieties grown and vice verca\n\n#### Level 3 - Operation Food Scraps\n* Setting up a Worm Bin in your classroom\n  * Research what it would take to set up a worm bin in your classroom.\n  * Also research what it would take to create an outdoor composting system for your school.\n  * Based on criteria and constraints, determine which would be best for your classroom/school.\n  * If possible, implement your solution!\n* Send postcards to lobby regional government or thank you to local businesses.\n\n#### Level 4 - Operation Waste-Free Lunch\n* Measure the impact of your Waste-Free Lunch\n  * Starting one week before you have a waste free lunch, keep track of all the stuff you throw away at lunch time (wrappers, cans, plastic food containers, food scraps, etc. measured either by mass or simply listing out what you throw away).\n  * Do the same for a week after you start going waste free.  How much waste did you save?  What would you total waste savings be if you continued going waste free for a whole school year?\n* Analyzing lunches with a systems thinking lense\n  * Think about the systems that are involved in the packaging of our lunches.\n  * Where do we buy these things? Where are they made?\n  * How far did these items have to travel to get to us?\n  * What’s a problem with that?\n* Visualizing collective impact\n  * For a great visualization of collective impact, view one or two of artist Chris Jordan’s \"Running the Numbers\":\n    * A T-Rex showing # of plastic bags used every 10 seconds. [Watch!](http://www.chrisjordan.com/gallery/rtn2/#t-rex)\n    * Plastic bottles used every minute [Watch!](http://www.chrisjordan.com/gallery/rtn/#caps-seurat)\n    * Plastic cups on airlines every hour [Watch!](http://www.chrisjordan.com/gallery/rtn/#plastic-cups)\n\n#### Level 5 - Operation Buy Smart\n* Poster activity\n  * Make a poster showing alternatives to buying things impulsively, and/or that compare and contrast impulse buying with Buy Smart Buying.\n  * Poster to include the pros and cons of each based on a set of criteria.\n"

/***/ }),
/* 1817 */
/***/ (function(module, exports) {

	module.exports = "# Planet Protector Academy Theme Song\n\nYouTube: ulOo2VuQEWA\n\n## Description\n\nSing and dance along to the Academy's theme song anytime you like. Great for starting a lesson!\n\n\n# Esmeralda Planet Protector & The E-Waste Emergency\n\nYouTube: POzKQKxvuzQ\nLowRes: true\n\n## Description\n\nWatch Esmeralda and Goober fight the rise of electronic waste and the evil supervillain Blaster, with some help from our our Planet Protector friends!\n\n\n# Esmeralda Planet Protector & The Litterless Lunch\n\nYouTube: OeT53lGAYX4\nLowRes: true\n\n## Description\n\nEsmeralda and Goober take on Trashella to stop her from convincing kid to bring lunches that make litter!\n\n\n# Esmeralda Planet Protector & Walking To School\n\nYouTube: 1FmXmBOU-V8\nLowRes: true\n\n## Description\n\nCan Esmeralda Superspy Planet Protector and her sidekick Goober stop the Evil Dr. Carbon's dastardly plan to stop kids from walking to school?\n\n\n# Esmeralda Superspy: Backstage #1\n\nYouTube: BQyzd8Y7EaY\nLowRes: true\n\n## Description\n\nDo series stars Ian and Sara spend their time saving the environment and protecting the planet? No, because Ian keeps acting like a monkey! Even when the boss, Jacqueline, is around.\n\n\n# Esmeralda Superspy: Backstage #2\n\nYouTube: AEmVWqAie6s\nLowRes: true\n\n## Description\n\nTake a peak behind the scenes! Sara takes you on a tour of the set - or at least, she tries to. Ian keeps messing up her shots!\n\n\n# Esmeralda Superspy: Backstage #3\n\nYouTube: zZId4Rr2-Rw\nLowRes: true\n\n## Description\n\nIan thinks he's doing a safety speech for the funny environmental show \"Esmeralda Superspy\" but really, Sara is about to get her revenge on him for wrecking her scenes.\n\n\n# Good Green News: Vancouver Urban Gardens\n\nYouTube: dPD3BogYAKw\nLowRes: true\n\n## Description\n\nKid reporter Tia, 9, reports on the Good Green News in the city of Vancouver - Find out why Vancouver helped bring over 400 urban gardens to the city!\n"

/***/ }),
/* 1818 */
/***/ (function(module, exports) {

	module.exports = "# Level Completed\n\n## Content\n\n### Welcome back!\n* Click the MENU button (top left) and use MODULES to go back to any of the six modules.\n* Or check out the videos in the EXTRAS section!\n\n## Notes\n\nWelcome back!\n"

/***/ }),
/* 1819 */
/***/ (function(module, exports) {

	module.exports = "# Teacher Resources\n## Welcome!\nWe're so happy to be training planet protectors from {r/:$cityOrMunicipality}!\n\n#### {r/Canada} Teacher's Guide\n{r/Canada} Download the [Teacher's Guide](Teachers_Guide.pdf) for a full overview of the program's contents and how it works.\n\nThe best way to orient yourself is to check out the student-facing content by clicking 'Start Module 1'.\n\n#### Curriculum Links\nThe Planet Protector Academy supports curriculum standards in science, arts, language and social studies. The following connections are provided for your convenience:\n\n* {r/Canada/BC}[British Columbia Grades 3-6](CL_PPA-ZH_Canada_BC_Grades_3-6.pdf)\n* {r/Canada/AB}[Alberta Grades 3-6](CL_PPA-ZH_Canada_Alberta_Grades_3-6.pdf)\n* {r/Canada/SK}[Saskatchewan Grades 3-6](CL_PPA-ZH_Canada_Saskatchewan_Grades_3-6.pdf)\n* {r/Canada/MB}[Manitoba Grades 3-6](CL_PPA-ZH_Canada_Manitoba_Grades_3-6.pdf)\n* {r/Canada/ON}[Ontario Grades 3-6](CL_PPA-ZH_Canada_Ontario_Grades_3-6.pdf)\n* {r/India}[CBSE Grades 2-7](CL_PPA-ZH_India_CBSE_Grades_2-7.pdf)\n* {r/United States/FL}[Florida Grades 3-5](CL_PPA-ZH_US_Florida_Grades_3-5.pdf)\n* {r/United States}[Common Core State Standards Grades 3-5](CL_PPA-ZH_US_Common_Core_Grades_3-5.pdf)\n* {r/United States}[Next Generation Science Standards Grades 3-5](CL_PPA-ZH_US_Next_Generation_Science_Standards_Grades_3-5.pdf)\n* {r/}We don't have curriculum links for your area yet. Do you want to help us develop them? Please contact us!\n\n#### Teaching students remotely?\nCheck out our [Remote Teaching Cheat Sheet](Remote_Teaching_Cheat_Sheet.pdf) for tips on how to adapt the program for remote/at-home learning!\n\n#### Need help from a human?\nGet in touch through the Messenger in the bottom right-hand corner!\n\n# Printables\n\n#### Required Print Materials\n\n* Mission Files for each child in [{r/Canada:colour}{r/:color}](Printables_Mission_Files_Colour.pdf) or [black & white](Printables_Mission_Files_BW.pdf).\n* ID Cards for each child in [{r/Canada:colour}{r/:color}](Printables_ID_Cards_Colour.pdf) or [black & white](Printables_ID_Cards_BW.pdf).\n* Sorting Game cards (Module 3). Select your area:\n  * {r/Canada/BC}British Columbia\n    * [Abbotsford](Printables_Sorting_Game_Abbotsford.pdf)\n    * [Burnaby](Printables_Sorting_Game_Burnaby.pdf)\n    * [Chilliwack](Printables_Sorting_Game_Chilliwack.pdf)\n    * [Coquitlam](Printables_Sorting_Game_Coquitlam.pdf)\n    * [Langley, City](Printables_Sorting_Game_City_of_Langley.pdf)\n    * [Langley, Township](Printables_Sorting_Game_Township_of_Langley.pdf)\n    * [Mission](Printables_Sorting_Game_Mission.pdf)\n    * [North Vancouver, City](Printables_Sorting_Game_City_of_North_Vancouver.pdf)\n    * [Pemberton](Printables_Sorting_Game_Pemberton.pdf)    \n    * [Port Coquitlam](Printables_Sorting_Game_Port_Coquitlam.pdf)\n    * [Port Moody](Printables_Sorting_Game_Port_Moody.pdf)\n    * [Richmond](Printables_Sorting_Game_Richmond.pdf)\n    * [Squamish](Printables_Sorting_Game_Squamish.pdf)\n    * [Surrey](Printables_Sorting_Game_Surrey.pdf)\n    * [Vancouver](Printables_Sorting_Game_Vancouver.pdf)\n    * [West Vancouver](Printables_Sorting_Game_West_Vancouver.pdf)\n    * [Whistler](Printables_Sorting_Game_Whistler.pdf)    \n  * {r/Canada/AB}Alberta\n    * [Calgary](Printables_Sorting_Game_Calgary.pdf)\n    * [Edmonton](Printables_Sorting_Game_Edmonton.pdf)\n    * [Edson](Printables_Sorting_Game_Edson.pdf)\n  * {r/Canada/MB}Manitoba\n    * [Brandon](Printables_Sorting_Game_Brandon.pdf)\n  * {r/Canada/SK}[Saskatchewan](Printables_Sorting_Game_Saskatchewan.pdf)\n  * {r/Canada/ON}Ontario\n    * [Amherstburg](Printables_Sorting_Game_Amherstburg.pdf)\n    * [Barrie](Printables_Sorting_Game_Barrie.pdf)\n    * [Durham Region](Printables_Sorting_Game_Durham_Region.pdf)\n    * [Essex](Printables_Sorting_Game_Essex.pdf)\n    * [Guelph](Printables_Sorting_Game_Guelph.pdf)\n    * [Hamilton](Printables_Sorting_Game_Hamilton.pdf)\n    * [Huntsville](Printables_Sorting_Game_Huntsville.pdf)\n    * [Kingsville](Printables_Sorting_Game_Kingsville.pdf)\n    * [Lakeshore](Printables_Sorting_Game_Lakeshore.pdf)\n    * [LaSalle](Printables_Sorting_Game_LaSalle.pdf)\n    * [Leamington](Printables_Sorting_Game_Leamington.pdf)\n    * [Orillia](Printables_Sorting_Game_Orillia.pdf)\n    * [Peterborough](Printables_Sorting_Game_Peterborough.pdf)\n    * [Simcoe County](Printables_Sorting_Game_Simcoe_County.pdf)\n    * [Tecumseh](Printables_Sorting_Game_Tecumseh.pdf)\n    * [Vaughan](Printables_Sorting_Game_Vaughan.pdf)\n    * [Waterloo Region](Printables_Sorting_Game_Waterloo_Region.pdf)\n    * [Windsor](Printables_Sorting_Game_Windsor.pdf)\n  * {r/India}India\n    * [SSVM Institutions](Printables_Sorting_Game_SSVM_Institutions.pdf)\n  * {r/}[Universal Sorting Game cards](Printables_Sorting_Game_Universal.pdf)\n* [Email from the Professor](Printables_Professor_Email.pdf) for Module 5 (four copies) - *shh* the answer is \"Keep It In The Cycle\".\n* Completion certificates for each child in [{r/Canada:colour}{r/:color}](Printables_Completion_Certificates_Colour.pdf) or [black & white](Printables_Completion_Certificates_BW.pdf).\n\n#### Optional Print Materials\n* Winning team certificates in [{r/Canada:colour}{r/:color}](Printables_Winning_Certificates_Colour.pdf) or [black & white](Printables_Winning_Certificates_BW.pdf).\n* Papercrafts:\n  * Esmeralda [{r/Canada:colour}{r/:color}](Printables_Papercraft_Esmeralda_Colour.pdf) or [black & white](Printables_Papercraft_Esmeralda_BW.pdf)\n  * Goober [{r/Canada:colour}{r/:color}](Printables_Papercraft_Goober_Colour.pdf) or [black & white](Printables_Papercraft_Goober_BW.pdf)\n* [Disposable Rap song lyrics](Printables_Disposable_Rap_Lyrics.pdf)\n* Additional fun [Activity Pages](Printables_ZH_Activity_Book.pdf)\n"

/***/ }),
/* 1820 */
/***/ (function(module, exports) {

	module.exports = "# Module 1 Overview\r\n\r\n#### OPERATION GARBAGE WATCH at a glance\r\n##### Typical duration: 1 hour\r\nIn this level, students (\"Apprentices\") will:\r\n* Watch engaging videos.\r\n* Sing the Planet Protector Theme Song.\r\n* Play a \"Game Show\" based on inquiry-based learning which engages them to think about garbage and why it's a problem.\r\n* Draw, in teams, things that bring them joy that aren't about stuff, and share with the class.\r\n* Be assigned an at-home mission in their printed Mission Files.\r\n* For a more comprehensive overview, see the Teacher Guide in the Teacher Resources section on the Dashboard page.\r\n\r\n#### Getting into teams\r\n* Before starting the program, divide your class into four teams.\r\n* Each team will work together during the various arts-based activities and score points for participating, collaborating, listening etc.\r\n* It's a flexible system for you to reward the {r/Canada:behaviour}{r/:behavior} you want to see in your class!\r\n\r\n#### Key Vocabulary\r\n* Product\r\n* Natural Resource\r\n* Landfill\r\n* Waste\r\n* Conundrum\r\n\r\n# Materials\r\n\r\n#### What you need for this level\r\n* Mission Files in [{r/Canada:colour}{r/:color}](Printables_Mission_Files_Colour.pdf) or [black & white](Printables_Mission_Files_BW.pdf) for each student.\r\n* ID Cards in [{r/Canada:colour}{r/:color}](Printables_ID_Cards_Colour.pdf) or [black & white](Printables_ID_Cards_BW.pdf) for each student.\r\n* Four large pieces of paper, plus crayons and/or markers.\r\n"

/***/ }),
/* 1821 */
/***/ (function(module, exports) {

	module.exports = "# Module 2 Overview\n\n#### OPERATION LOVE FOOD, HATE WASTE at a glance\n##### Typical duration: 1 hour\nIn this level, Apprentices will:\n* Report on their Operation Garbage Watch mission.\n* Sing the Planet Protector Theme Song.\n* Play the \"Game Show\" about food waste.\n* Learn about an Indigenous community with a huge recycling centre in Arizona, and the principle of using every part of what is harvested.\n* Do a math problem in teams.\n* Draw an \"Eat Me First\" sign to take home.\n* Be assigned Mission 2: Operation Love Food Hate Waste.\n\n#### Key Vocabulary\n* Food Waste\n* Reusable\n* Shipping\n\n#### Note on Missions\n* Changing habits around stuff and garbage can be hard for families.\n* Families in different socio-economic situations, also, will have different abilities to participate.\n* It’s important to share the idea of small doable steps, and that there is no judgment around anyone’s ability to succeed at the missions.\n* Failure is ok. Trying and learning is what’s important.\n\n# Materials\n\n#### What you need for this level\n* Plain paper.\n* Pencils plus markers/crayons.\n* Each Apprentice also requires their Mission File 2.\n"

/***/ }),
/* 1822 */
/***/ (function(module, exports) {

	module.exports = "# Module 3 Overview\n\n#### OPERATION FOOD SCRAPS at a glance\n##### Typical duration: 1 hour\nIn this level, Apprentices will:\n* Report on their Operation Love Food, Hate Waste mission.\n* Sing the Planet Protector Theme Song.\n* Play the \"Game Show\" on organics recycling (composting).\n* Learn about the thousands-of-years-old practice of composting from an Indigenous community in Arizona.\n* Play the Sorting Game (what goes in what bin?).\n* Write and perform a 2-line rap about food scraps.\n* Be assigned Mission 3: Operation Food Scraps.\n\n#### Key Vocabulary\n* Food scraps\n* Methane\n* Landfill\n* Compost\n* Microorganisms\n\n# Materials  \n\n#### What you need for this level\n* A set of Sorting Game cards and bin sheets (compost, landfill, recycling) for each team (see the Printables for printable PDFs for your area).\n* Scissors so Apprentices can help cut out the cards and bin sheets.\n* Each Apprentice also requires their Mission File 3.\n"

/***/ }),
/* 1823 */
/***/ (function(module, exports) {

	module.exports = "# Module 4 Overview\n\n#### OPERATION WASTE-FREE LUNCH at a glance\n##### Typical duration: 1 hour\nIn this level, Apprentices will:\n* Report on their Operation Food Scraps mission.\n* Sing the Planet Protector Theme Song.\n* Play the Game Show on packaging.\n* Discover how the ancestral Pueblo used nature’s principals to farm in the desert.\n* {r/Canada:Analyze}{r/:Analyse} today's lunch for packaging and think about reducing waste.\n* •\tDo a math challenge on the collective impact of choosing package-free alternatives.\n* Make a Waste-Free Lunch poster.\n* Be assigned Mission 4: Operation Waste-Free Lunch.\n\n#### Key Vocabulary\n* Packaging\n* Litter\n* Marketing\n* Collective impact\n* Analysis\n\n#### Spoiler Alert!\nAt the end of this level, one of the characters appears to 'hack' the Academy. Don't worry though, your Apprentices will be solving a puzzle to unlock the Academy at the beginning of Level 5.\n\n# Materials\n\n#### What you need for this level\n* Paper and markers/crayons for drawing posters.\n* Paper and pencils for math challenge.\n* Apprentices will need to have not eaten their lunches yet! Note: the lunch analysis activity can be done on another day if necessary.\n* Each Apprentice also requires their Mission File 4.\n"

/***/ }),
/* 1824 */
/***/ (function(module, exports) {

	module.exports = "# Module 5 Overview\n\n#### OPERATION BUY SMART at a glance\n##### Typical duration: 1 hour\nIn this level, Apprentices will:\n* Report on their Operation Waste-Free Lunch mission.\n* Sing the Planet Protector Theme Song.\n* Play the Game Show - Brainstorm Edition. Teams brainstorm together about impulse purchasing.\n* Create Buy Smart guidelines together as a class.\n* Create and perform skits about impulse purchasing.\n* Be assigned Mission 5: Operation Buy Smart.\n\n#### Key Vocabulary\n* Brainstorm\n* Impulse purchase\n\n#### Unlocking the Academy\nApprentices will unlock the Academy by solving the puzzle in the Professor's email and entering it into the form field at the beginning of the level. Suspense encouraged - the answer is 'Keep It In The Cycle' if you need it!\n\n# Materials\n\n#### What you need for this level\n* Paper and writing implements.\n* [Professor's email](Printables_Professor_Email.pdf) with puzzle: print one for each team or Apprentice, as you prefer.\n* Each Apprentice also requires their Mission File 5.\n"

/***/ }),
/* 1825 */
/***/ (function(module, exports) {

	module.exports = "# Module 6 Overview\n\n#### OPERATION GREEN CYCLE at a glance\n##### Typical duration: 1 hour\nIn this level, Apprentices will:\n* Report on their Operation Buy Smart mission.\n* Sing the Planet Protector Theme Song.\n* Play the \"Game Show\" to engage them with the concept of the Product Life-cycle.\n* Learn how the Maori people of New Zealand build homes out of rammed earth & clay.\n* Brainstorm product ideas that are more in harmony with nature.\n* Make their own Esmeralda or Goober papercraft!\n* Receive individual and team certificates for their participation.\n* Celebrate their achievements!\n\n#### Key Vocabulary\n* Biomimicry\n* Product Life-cycle\n* Production\n* Distribution\n* Consumption\n* Disposal\n\n# Materials\n\n#### What you need for this level\n* Completion certificates for each Apprentice in [{r/Canada:colour}{r/:color}](Printables_Completion_Certificates_Colour.pdf) or [black & white](Printables_Completion_Certificates_BW.pdf).\n* Optional but fun: papercrafts for each Apprentice, plus scissors and something to {r/Canada:colour}{r/:color} with:\n  * Esmeralda papercraft in [{r/Canada:colour}{r/:color}](Printables_Papercraft_Esmeralda_Colour.pdf) or [black & white](Printables_Papercraft_Esmeralda_BW.pdf).\n  * Goober papercraft in [{r/Canada:colour}{r/:color}](Printables_Papercraft_Goober_Colour.pdf) or [black & white](Printables_Papercraft_Goober_BW.pdf).\n* Once you know which team has earned the most points, you can print a Winning Team Certificate in [{r/Canada:colour}{r/:color}](Printables_Winning_Certificates_Colour.pdf) or [black & white](Printables_Winning_Certificates_BW.pdf) to post on your classroom wall after the lesson.\n"

/***/ }),
/* 1826 */
/***/ (function(module, exports) {

	module.exports = "# Tech Prep Wizard\n\n### Tech Prep Wizard\n\nThis short wizard will help you get set up to run the Academy in your classroom.\n\nDon't show your students the screen yet!\n\nClick the arrow or use your keyboard's right directional arrow to move through the wizard.\n\n# Two Device Intro\n\n### Two Device Experience\nThe Academy is best experienced using two devices:\n* Main device (COMPUTER or TABLET) projects the website at the front of the class.\n* Second device (TABLET or CELLPHONE) can be as a remote control (optional):\n  * gives you freedom to move around the classroom.\n  * contains prompts and facilitation notes at your finger tips.\n  * provides useful progress indicators, such as length of videos and number of slides remaining. \n\n# Connecting Remote\n\n### Connect your remote!\nTo connect a second device as a Remote Control:\n1. Go to www.remote4ppa.com on your tablet/phone.\n2. Enter your username and password on your tablet/phone.\n3. Go to the next slide to Select Role For This Device.\n4. Choose the right Role for each device.\n5. Your selections will be saved for future use, but you can always change it later!\n\n# Tech Check Intro\n\n### Tech Check!\nNOW PLEASE hook up your main device to your projector and **test the audio/video** to make sure everything's working! There's a fun video in the next slide to help you do this (it's also in the Fun section if you want to share with your class).\n\n#### Full Screen Experience\nThe Planet Protector Academy is best enjoyed as a full screen experience. **Click 'View'** in your browser's menu bar, and select **'Full Screen'** (Chrome) or **'Enter Full Screen'** (Safari/Firefox).\n\n# Tech Check Video\nYouTube: ZVdMndkjaIo\n"

/***/ }),
/* 1827 */
/***/ (function(module, exports) {

	module.exports = "# Program Start\n\n# Level 1 Start\n\n## Notes\n\n### Start\n\nShow this screen at the start of class. When the kids are ready, advance to the next screen.\n\nUse the directional arrows on your remote to go forwards/backwards through the level.\n\n# Level 1 Icon\n\n## Notes\n\nOperation Garbage Watch\n\n### Tracking your progress\n\nYou can see how far along you are by the slide number on the top of your Remote Control or by the blue progress bar running along the bottom of the Menu on the Classroom Display.\n\n# Level 2 Start\n\n## Notes\n\n### Start\n\nShow this screen at the start of class. When the kids are ready, advance to the next screen.\n\n# Level 2 Icon\n\n## Notes\n\nOperation Love Food Hate Waste\n\n# Level 3 Start\n\n## Notes\n\n### Start\n\nShow this screen at the start of class. When the kids are ready, advance to the next screen.\n\n# Level 3 Icon\n\n## Notes\n\nOperation Food Scraps\n\n# Level 4 Start\n\n## Notes\n\n### Start\n\nShow this screen at the start of class. When the kids are ready, advance to the next screen.\n\n# Level 4 Icon\n\n## Notes\n\nOperation Waste-Free Lunch\n\n# Level 5 Start\n\n## Notes\n\n### Start\n\nShow this screen at the start of class. When the kids are ready, advance to the next screen.\n\n# Level 5 Icon\n\n## Notes\n\nOperation Buy Smart\n\n# Level 6 Start\n\n## Notes\n\n### Start\n\nShow this screen at the start of class. When the kids are ready, advance to the next screen.\n\n# Level 6 Icon\n\n## Notes\n\nOperation Green Cycle\n"

/***/ }),
/* 1828 */
/***/ (function(module, exports) {

	module.exports = "# Level 1 Intro\n\nYouTube: IOz_EHZd4gk\n\n## Notes\nIan and Sara introduce the Planet Protector Academy song (0:23).\n\n# Level 2 Intro\n\n## Content\n\n### Welcome back Planet Protectors!\n\n#### Get ready to sing!\n\n## Notes\n\nGet ready to sing!\n\n# Level 3 Intro\n\n## Content\n\n### Welcome back Planet Protectors!\n\n#### Get ready to sing!\n\n## Notes\n\nGet ready to sing!\n\n# Level 4 Intro\n\n## Content\n\n### Welcome back Planet Protectors!\n\n#### Get ready to sing!\n\n## Notes\n\nGet ready to sing!\n\n# Level 5 Intro\n\n## Content\n\n### Congratulations Apprentices!\n\n#### Welcome back. Time to sing!\n\n## Notes\n\nGet ready to sing!\n\n# Level 6 Intro\n\n## Content\n\n### Welcome back Planet Protectors!\n\n#### Get ready to sing!\n\n## Notes\n\nGet ready to sing!\n\n# Song\nYouTube: ulOo2VuQEWA\n\n## Notes\n\n### Planet Protectors Song\n\nEncourage your class to learn this song and sing along to the video (1:52). The lyrics will be shown and are also on the last page of the Mission Files.\n\n### Extension Activities\nApprentices can perform the song to the whole school and/or create their own choreography.\n"

/***/ }),
/* 1829 */
/***/ (function(module, exports) {

	module.exports = "Team Creation\n\n# Intro Video\n\nYouTube: cmoSujpN6Ao\n\n## Notes\nSara and Ian encourage Apprentices to get into teams and explain how they can score points (2:16).\n\n# Get Into Teams\n\n## Content\n\n###### Get into four teams!\n\nName your teams in the next slide.\n\n## Notes\n\nName teams in the next slide. Once you enter the name in the text field, it automatically saves!\n\n# Scoring Intro\n\n## Content\n\n### Here's how your team can score points\n\n* Answer questions\n* Do activities\n* Complete missions\n* Work well together (teamwork points)\n* and more!\n\n## Notes\n\n### Scoring\n* Teams can earn points for most activities in the program. You can allocate points as you see fit. Maximum points total is 999.\n* Individuals can earn points for teams, or teams can earn points together.\n* Teamwork points are critical to ensure collaboration.\n* Points can also be a classroom \"currency\", e.g.to gain classroom privileges.\n* The team with the most points at the end of Level 6 is the winner.\n\n# Scoreboard Intro\n\n## Content\n\n### Check out the scoreboard!\n\n(In the top left corner, click MENU and then SCORES)\n\nYour teams are now ready to start scoring points!\n\n## Notes\n\nClick on the 'Scoreboard' icon on your remote at any time to bring down the scoreboard and add points for teams.\n\n# ID Cards\n\n## Content\n\n### Congratulations!\n\n#### You're now Planet Protector Apprentices!\n\nTime to fill out your ID cards and draw yourself as the Planet Protector that you are!\n\n## Notes\n\nHave Apprentices write their names and team names on their ID cards, and draw their \"avatar\", ie. a picture of themselves as a superhero.\n"

/***/ }),
/* 1830 */
/***/ (function(module, exports) {

	module.exports = "# Mission Report\nTitle: Operation Garbage Watch\n\n# Intro Video\n\nYouTube: _U3Lyyu_pXI\n\n## Notes\nIntro to the Mission Report for Operation Garbage Watch (1:10).\n\n# Scoring\n\n## Content\n\n### Get points for your missions!\n\n* Turn to Mission 1 in your Mission Files.\n* In your teams, count the total number of points you scored in the 'Get points for' section.\n* Make sure your points get added onto the Scoreboard!\n\n## Notes\n\nThis slide only covers actions listed under 'Get a point for' for each mission.\nStudents report the Mission Report section next.\n\n# Instructions\n\n## Content\n\n### Time to report to HQ!\n\n* Answer with a show of hands\n* Training Agent enters answers and can report too!\n\n## Notes\n\n### Mission Reports\n* Mission reports help us communicate the impact of our program. Thanks for helping us to measure it!\n* Using a show of hands keeps the data anonymous.\n\n# Questions\n\n## Content\n\n1. Number of Apprentices and Training Agents reporting in.\n2. I gave my family the Mission Briefing page.\n3. I talked to my family about how we can make less garbage.\n4. I looked for clues about my family's waste habits.\n5. I found my nearest depot to recycle small appliances.\n6. I pledge to repair and reuse items before recycling.\n\n\n# Impact\n\n## Content\n\n### Awesome work, Apprentices!\n\nYour Mission Report was received by Planet Protector Academy HQ.\n\n## Notes\n\nGreat job!\n"

/***/ }),
/* 1831 */
/***/ (function(module, exports) {

	module.exports = "# Mission Report\n\nTitle: Operation Love Food Hate Waste\n\n# Intro Video\n\nYouTube: z7__F2MLa3E\n\n## Notes\nIntro to the Mission Report for Operation Love Food Hate Waste (0:22).\n\n# Scoring\n\n## Content\n\n### Get points for your missions!\n\n* Turn to Mission 2 in your Mission Files.\n* In your teams, count the total number of points you scored in the 'Get points for' section.\n* Make sure your points get added onto the Scoreboard!\n\n## Notes\n\nThis slide only covers actions listed under 'Get a point for' for each mission.\nStudents report the Mission Report section next.\n\n# Instructions\n\n## Content\n\n### Time to report to HQ!\n\n* Answer with a show of hands.\n* If you or your family has improved even a little bit, say yes!\n* If you didn't change, don't put up your hand. Try again next mission!\n* Training Agents can report too!\n\n## Notes\n\nMission reports help us communicate the impact of our program. Thanks for helping us to measure it!\n\n# Questions\n\n## Content\n\n1. Number of Apprentices and Training Agents reporting in.\n2. I put my Eat Me First sign in my fridge.\n3. I reminded my family to eat first from the Eat Me First box.\n4. I am now wasting less food.\n5. My family is now wasting less food.\n6. I pledge to waste less food!\n\n## Notes\n\nIf there's no food scraps service in your area, just ask your Apprentices to share if their families are now wasting less food.\n\n# Class Discussion\n\n## Content\n\n### Class Discussion\n* As a class, discuss what was easy or hard about this mission.\n* What worked, what didn’t work?\n* What would make it easier?\n\n## Notes\n\nEncourage apprentices who did not succeed to keep trying, if appropriate.\n\n# Impact\n\n## Content\n\n### Great job, Apprentices!\n\n#### Thanks for protecting the planet!\n\nYour Mission Report was received by Planet Protector Academy HQ.\n\n\n## Notes\n\nGreat job!\n"

/***/ }),
/* 1832 */
/***/ (function(module, exports) {

	module.exports = "# Mission Report\nTitle: Operation Food Scraps\n\n# Intro Video\n\nYouTube: _SdpqQYnzeM\n\n## Notes\nIntro to the Mission Report for Operation Food Scraps (1:08).\n\n# Scoring\n\n## Content\n\n### Get points for your missions!\n\n* Turn to Mission 3 in your Mission Files.\n* In your teams, count the total number of points you scored in the 'Get points for' sections.\n* Make sure your points get added onto the Scoreboard!\n\n## Notes\n\nThis slide only covers actions listed under 'Get a point for' for each mission.\nStudents report the Mission Report section next.\n\n# Instructions\n\n## Content\n\n### Time to report to HQ!\n\n* Answer with a show of hands.\n* If you or your family didn't change, don't put up your hand. Try again next mission!\n* Training Agents can report too!\n\n## Notes\n\nMission reports help us communicate the impact of our program. Thanks for helping us to measure it!\n\n# Questions\n\n## Content\n\n1. Number of Apprentices and Training Agents reporting in.\n2. I am recycling food scraps more now.\n3. +My family was not using the food scraps bin before, but has now started because of this mission.\n4. +My family was already using a food scraps bin, but we're using it better now.\n5. My family has done more to reduce food waste this week.\n6. Who votes for Ian to be team captain?\n7. +I tried my best on this mission but my family wasn’t able to change yet.\n\n# Class Discussion\n\n## Content\n\n### Class Discussion\n* As a class, discuss what was easy or hard about this mission.\n* What worked, what didn’t work?\n* What would make it easier?\n\n## Notes\n\nEncourage apprentices who did not succeed to keep trying, if appropriate.\n\n# Impact\n\n## Content\n\n### Awesome work, Apprentices!\n\n#### Thanks for protecting the planet!\n\nYour Mission Report was received by Planet Protector Academy HQ.\n\n## Notes\n\nGreat job!\n"

/***/ }),
/* 1833 */
/***/ (function(module, exports) {

	module.exports = "# Mission Report\nTitle: Operation Waste-Free Lunch\n\n# Intro Video\n\nYouTube: SbS69PykAN0\n\n## Notes\nIntro to the Mission Report for Operation Waste-Free Lunch (1:41).\n\n# Scoring\n\n## Content\n\n### Get points for your missions!\n\n* Turn to Mission 4 in your Mission Files.\n* In your teams, count the total number of points you scored in the 'Get points for' sections.\n* Make sure your points get added onto the Scoreboard!\n\n## Notes\n\nThis slide only covers actions listed under 'Get a point for' for each mission.\nStudents report the Mission Report section next.\n\n# Instructions\n\n## Content\n\n### Time to report to HQ!\n\n* Answer with a show of hands.\n* If you created less garbage in your lunch, say yes!\n* If your family wasn't able to change, don't put up your hand. Try again next mission!\n* If you are now littering less and putting waste in its place more, say yes!\n* Training Agents can report too!\n\n## Notes\n\nMission reports help us communicate the impact of our program. Thanks for helping us to measure it!\n\n# Questions\n\n## Content\n\n1. Number of Apprentices and Training Agents reporting in.\n2. I participated in our class Waste-Free Lunch.\n3. *We got other classrooms to also host a Waste Free Lunch. Here's how many classes:\n4. +My lunch now makes less garbage than it did before.\n5. I pledge to keep finding ways to reduce the garbage that my lunch makes.\n6. +I tried my best on this mission but my family wasn’t able to change yet.\n7. I'm now littering less and putting waste in its place more.\n\n# Class Discussion\n\n## Content\n\n### Class Discussion\n* As a class, discuss what was easy or hard about this mission.\n* What worked, what didn’t work?\n* What would make it easier?\n\n## Notes\n\nEncourage apprentices who did not succeed to keep trying, if appropriate.\n\n# Impact\n\n## Content\n\n### Great job, Apprentices!\n\n#### Thanks for protecting the planet!\n\nYour Mission Report  was received by Planet Protector Academy HQ.\n\n## Notes\n\nGreat job!\n"

/***/ }),
/* 1834 */
/***/ (function(module, exports) {

	module.exports = "# Mission Report\nTitle: Operation Buy Smart\n\n# Intro Video\nYouTube: f-prL9jvwhA\n\n## Notes\nSara and Ian introduce the Mission Report for Operation Buy Smart (1:55).\n\n# Scoring\n\n## Content\n\n### Get points for your missions!\n\n* Turn to Mission 5 in your Mission Files.\n* In your teams, count the total number of points you scored in the 'Get points for' section.\n* Make sure your points get added onto the Scoreboard!\n\n## Notes\n\nThis slide only covers actions listed under 'Get a point for' for each mission.\nStudents report the Mission Report section in next.\n\n# Instructions\n\n## Content\n\n### Time to report HQ!\n\n* Answer with a show of hands.\n* If your family used the Buy Smart Code, make sure you report!\n* If it wasn't possible this week, don't put up your hand. Try again!\n* Training Agents can report too!\n\n## Notes\n\nMission reports help us communicate the impact of our program. Thanks for helping us to measure it!\n\n# Questions\n\n## Content\n\n1. Number of Apprentices and Training Agents reporting in.\n2. I pledge to Buy Smart when I grow up, for the sake of the planet!\n3. How many Apprentices are having fun with this program?\n4. How many Apprentices feel like real-life Planet Protectors now?\n5. How many Apprentices pledge to be Planet Protectors from now on?\n6. My family succeeded in at least one mission during the program.\n\n# Class Discussion\n\n## Content\n\n### Class Discussion\n* As a class, discuss what was easy or hard about this mission.\n* What worked, what didn’t work?\n* What would make it easier?\n\n## Notes\n\nEncourage apprentices who did not succeed to keep trying, if appropriate.\n\n# Impact\n\n## Content\n\n### Great job, Apprentices!\n\n#### Thanks for protecting the planet!\n\nYour Mission Report was received by Planet Protector Academy HQ.\n\n## Notes\n\nGreat job!\n"

/***/ }),
/* 1835 */
/***/ (function(module, exports) {

	module.exports = "# Ian and Sara Intro\n\nYouTube: HkQdJ2N1NN4\n\n## Notes\nIntro to the first installment of Esmeralda and Goober's planet protecting adventures (1:38).\n\n### Problems with your video buffering?\nPause the video and wait a minute for it to pre-load, then it should play without a hitch!\n\n# Esmeralda and Goober Opening Story\n\nYouTube: FIrtO7bBqlo\n\n## Notes\nEsmeralda and Goober welcome the Apprentices to the Academy (3:22).\n"

/***/ }),
/* 1836 */
/***/ (function(module, exports) {

	module.exports = "# Ian and Sara Intro\n\nYouTube: ITAnQrAoiI4\n\n## Notes\nIntro to Esmeralda and Goober Opening Story (0:56).\n\n# Esmeralda and Goober Opening Story\n\nYouTube: j41AGvP85gI\n\n## Notes\nEsmeralda and Goober visit the landfill and come face to face with supervillain Trashella (4:07).\n"

/***/ }),
/* 1837 */
/***/ (function(module, exports) {

	module.exports = "# Esmeralda and Goober Opening Story\n\nYouTube: N0kawhcRfFc\n\n## Notes\nEsmeralda and Goober learn about methane and chase after another supervillain, the Blaster (2:11).\n"

/***/ }),
/* 1838 */
/***/ (function(module, exports) {

	module.exports = "# Ian and Sara Intro\n\nYouTube: 2QttQl5KktI\n\n## Notes\nIntro to Esmeralda and Goober Opening Story (0:49).\n\n# Esmeralda and Goober Opening Story\n\nYouTube: 0Asyn4VAp-s\n\n## Notes\nEsmeralda teaches Goober about packaging and why it's a problem (1:55).\n\n# Disposable Rap Intro\n\nYouTube: iYTqwolZ7X8\n\n## Notes\nIntro to Disposable Rap (1:28).\n\n# Disposable Rap\n\nYouTube: 7ZCAYQJ_NBA\n\n## Notes\n\nDisposable Rap: a fun rap video about single-use plastics (2:59).\n"

/***/ }),
/* 1839 */
/***/ (function(module, exports) {

	module.exports = "# Esmeralda and Goober Opening Story\n\nYouTube: QHbCMC_Czjs\n\n## Notes\nEsmeralda and Goober meet the Systems Manager (5:23).\n"

/***/ }),
/* 1840 */
/***/ (function(module, exports) {

	module.exports = "# Esmeralda and Goober Opening Story\n\nYouTube: zB36hR6ioxM\n\n## Notes\nEsmeralda snaps Goober out of his trance and they try to escape the shack (2:51).\n\n# Intro to Song of Stuff\n\nYouTube: 6Qrl2o8No9M\n\n## Notes\nIntro to Song of Stuff (0:06).\n\n# Song of Stuff\n\nYouTube: G45Uo4UKmxc\n\n## Notes\nSong of Stuff music video based on the Story of Stuff project (3:13).\n"

/***/ }),
/* 1841 */
/***/ (function(module, exports) {

	module.exports = "# MME Level 2\n\nYouTube: hgkIlzjLLdE\n\n## Notes\n\nMessages From Mother Earth Episode 5 (2:43)\n\n\n# MME Level 3\n\nYouTube: 89E4ARNKSak\n\n## Notes\n\nMessages From Mother Earth Episode 6 (3:50)\n\n\n# MME Level 4\n\nYouTube: gmMfIzfXeyk\n\n## Notes\n\nMessages From Mother Earth Episode 7 (2:29)\n\n\n# MME Level 6\n\nYouTube: l5QHvKngfVg\n\n## Notes\n\nMessages From Mother Earth Episode 8 (2:34)\n"

/***/ }),
/* 1842 */
/***/ (function(module, exports) {

	module.exports = "# Game Show\n\nLevel 1 - The Garbage Conundrum\n\n# Intro Video\n\nYouTube: UC-TwrQhZtI\n\n## Notes\nIntro to Game Show (1:39).\n\n\n# Sizzle\n\n## Notes\n\n### Game Show\nIn the Game Show we ask questions relating to the topic *before* giving the answers, in order to stimulate thinking, rather than to test knowledge.\n\nOne Apprentice from each team will come up to the front of the class and get a chance to answer the question in turn.\n\nFor more info, see \"Game Show Info\" in the Teachers Guide, which is available in the Teacher Resources section on the Dashboard page.\n\n\n# Scoring\n\n## Content\n\n### How to score points\n* Do your Planet Protector pose.\n* Buzz in first.\n* Give a good answer. Try your best!\n* If you don’t know the answer, think about what a good answer might be. This is not a test!\n\n## Notes\n\nDon't forget to score points on the Scoreboard!\n\n\n# Four Players Announcement\n\n## Notes\n\n* One Apprentice from each team comes to the front of the room.\n* Encourage a different Apprentice to come up for each question.\n\n\n# Question 1\n\n## Question\n\n### What is a product?\n\n## Answer\n\n### A product is:\n* Something that is made or grown to be sold and used.\n\n## Answer Notes\n\n&nbsp;\n\n# Scoring Reminder\n\n## Content\n\n### Don't forget to add scores!\n\n## Notes\n\nClick on the 'Scores' button below to open up the Scoreboard.\n\n\n# Question 2\n\n## Question\n\n### What is a natural resource?\n\n## Answer\n\n### A natural resource is:\n* The stuff that products are made of, that we take from nature.\n* Examples: trees, metals, oils, minerals, water.\n\n## Answer Notes\n\n&nbsp;\n\n\n# Question 3\n\n## Question\n\n### What happens to garbage once it's in the landfill?\n\n## Answer\n\n### What happens to garbage in a landfill:\n* It stays there forever.\n* Food rots and creates methane, a poison gas.\n* Plastic and other garbage just sit there.\n* Chemicals can leach into the soil and into waterways (ending up in our drinking water & food).\n* All of the resources that went into making the products are trapped forever.\n\n## Answer Notes\n\n&nbsp;\n\n\n# Question 4\n\n## Question Intro\n\n### How much garbage does the average person put in the landfill every year?\nMultiple choice - see next slide!\n\n## Question\n\n{r/Canada} a) 38 kg - as much as a child\n\n{r/United States} a) 84 lb - as much as a kid\n\n{r/India} a) 38 kg - as much as a kid\n\n{r/} a) 38 kg - as much as a kid\n\n\n{r/Canada} b) 475 kg - as much as four large men\n\n{r/United States} b) 1,047 lb - as much as four large men\n\n{r/India} b) 124 kg - as much as a small gorilla\n\n{r/} b) 475 kg - as much as four large men\n\n\n{r/Canada} c) 777 kg - as much as a small car\n\n{r/United States} c) 1,713 lb - as much as a small car\n\n{r/India} c) 475 kg - as much as four large men\n\n{r/} c) 777 kg - as much as a small car\n\n\n{r/Canada} d) 1,252 kg - as much as a small car with four large men in it\n\n{r/United States} d) 2,760 lb - as much as a small car with four large men in it\n\n{r/India} d) 1,252 kg - as much as a small car with four large men in it\n\n{r/} d) 1,252 kg - as much as a small car with four large men in it\n\n[comment]: # (Canada source: Stats Canada)\n[comment]: # (US source: EPA)\n[comment]: # (India source: What a Waste: A Global Review of Solid Waste Management, World Bank, 2012; https://openknowledge.worldbank.org/bitstream/handle/10986/17388/68135.pdf?sequence=8&isAllowed=y)\n\n## Answer\n\n### The answer is:\n\n{r/Canada} c) the average Canadian makes about 777 kg of garbage every year – more than any other country in the world!\n\n{r/United States} b) the average American makes about 1,047 lb of garbage every year.\n\n{r/India} b) the average Indian makes about 124 kg of garbage every year.\n\n{r/} It varies country to country. For example, the average in the United States is (b) 475 kg and in Canada is (c) 777 kg!\n\n{r/} What about your country?\n\n## Answer Notes\n\n&nbsp;\n\n\n# Question 5\n\n## Question\n\n### What problems does garbage cause?\n\n## Answer\n\n### Garbage causes lots of problems:\n* It pollutes the water, soil and air\n* It takes up valuable land - our landfills are running out of space!\n* The resources used to make everything in the garbage are lost forever. They've been taken out of the cycle of life.\n* We're using up our resources and trashing them for ever\n\n## Answer Notes\n\n&nbsp;\n\n\n# Question 6\n\n## Question\n\n### What can we do to prevent things from going to the landfill?\n\n#### Hint: it's the 4Rs\n\n## Answer\n\n### We can:\n1. **Reduce** - if you don’t need it don’t buy it! Do you really need the latest and greatest?\n2. **Reuse** - share, donate, or repurpose into something new!\n3. **Repair** - fix and maintain!\n4. **Recycle** - if you can’t do any of the above first, use your home’s recycling bin or bring it to a depot.\n\nDo things in this order to take care of the planet!\n\nLearn the 4Rs by singing and dancing to the Repair Song in the next slide!\n\n## Answer Notes\n\n&nbsp;\n\n\n# The Repair Song Video\n\nYouTube: av4knngXq24\n\n## Notes\nIntro to Game Show (2:33).\n"

/***/ }),
/* 1843 */
/***/ (function(module, exports) {

	module.exports = "# Game Show\n\nLevel 2 - Food Waste\n\n# Intro Video\n\nYouTube: 9SzO-3MMJcM\n\n## Notes\nIntro to Game Show (0:51).\n\n# Sizzle\n\n## Notes\n\nGame Show\n\n# Scoring\n\n## Content\n\n### Reminder:\n* Do your Planet Protector pose.\n* Buzz in first.\n* Give a good answer.\n\n## Notes\n\nDon't forget to score points on the Scoreboard!\n\n# Four Players Announcement\n\n## Notes\n\nFour players to the front.\n\n# Question 1\n\n## Question\n\n### What's the problem with throwing out food that was edible?\n\n## Answer\n\n### Throwing out edible food:\n* Wastes money (it's like buying four bags of groceries and leaving one behind in the parking lot!).\n* Somebody could have eaten that food!\n* Wastes all the resources and time spent growing, shipping and storing the food - all of which costs energy and creates garbage too.\n* Wasted food is wasted money!\n* Food that ends up in landfill creates methane, which causes climate change.\n\n## Answer Notes\n\n&nbsp;\n\n# Scoring Reminder\n\n## Content\n\n### Don't forget to add scores!\n\n## Notes\n\nClick on the 'Scores' button below to open up the Scoreboard.\n\n# Question 2\n\n## Question\n\n### Which types of food are wasted the most?\n\n## Answer\n\n### Foods wasted the most:\n  1. Fruits and vegetables are wasted the most.\n  2. Fish, seafood and grains.\n  3. Dairy and meat.\n\n## Answer Notes\n\n{r/Canada} Additional questions:\n\n{r/United States} Additional questions:\n\n* {r/Canada} Why do you think fruit & vegetables are wasted the most?\n* {r/United States} Why do you think fruit & vegetables are wasted the most?\n\n{r/} &nbsp;\n\n# Question 3\n\n## Question\n\n### {r/Canada} How much food does the average family waste?\n\n#### {r/Canada} (your answer can be in $ or % of food)\n\n### {r/United States} How much food does the average family waste?\n\n#### {r/United States} (your answer can be in $ or % of food)\n\n### {r/} Why does food end up being wasted in the home?\n\n\n## Answer\n\n### {r/Canada} Most families waste 25-30% of food they buy:\n\n### {r/United States} Most families waste 25-30% of food they buy:\n\n### {r/} Some reasons why food is wasted:\n\n* {r/Canada} About $700 worth of food every year in every family is wasted!\n* {r/Canada} Almost half of fruits and vegetables are wasted.\n* {r/Canada} One third of fish, seafood and grains.\n* {r/Canada} 20% of dairy and meat is wasted.\n* {r/Canada} On top of that, 1/3 of fruits and vegetables never even make it to the store - they get thrown out for being ugly!\n* {r/United States} About $700 worth of food every year in every family is wasted!\n* {r/United States} Almost half of fruits and vegetables are wasted.\n* {r/United States} One third of fish, seafood and grains.\n* {r/United States} 20% of dairy and meat is wasted.\n* {r/United States} On top of that, 1/3 of fruits and vegetables never even make it to the store - they get thrown out for being ugly!\n* {r/} Gets forgotten about at the back of the fridge\n* {r/} Buy too much (e.g. buy one get one free)\n* {r/} Can only buy in large amounts\n* {r/} Cook too much food that doesn't get eaten as leftover\n* {r/} Change of plans\n\n## Answer Notes\n\nAdditional questions:\n\n* Why does food end up being wasted in the home?\n* How and why is food wasted before it even gets to your supermarket/grower?\n\nReferences: Value Change Management Centre and National Resources Defense Council\n\n# Question 4\n\n## Question\n\n### What's the problem with wasting food?\n\n## Answer\n\n### Problems with wasting food:\n* Somebody could have eaten that food!\n* All the resources and water that went into the creation of the food get wasted too.\n\n## Answer Notes\n\nAdditional questions:\n\n* What's your {r/Canada:favourite}{r/:favorite} left-over meal?\n\n# Question 5\n\n## Question\n\n### What are some ways we could stop wasting food?\n\n## Answer\n\n### How to love food & hate waste:\n* Only buy what we will eat - make a shopping list!\n* Plan meals to use the food that needs to be eaten.\n* Don't buy large packages that we won't finish.\n* Eat leftovers instead of throwing them out.\n* Serve portion sizes we can actually eat.\n\n## Answer Notes\n\n&nbsp;\n"

/***/ }),
/* 1844 */
/***/ (function(module, exports) {

	module.exports = "# Game Show\n\nLevel 3 - Food Scraps\n\n# Intro Video\n\nYouTube: Jya7pHG-HuM\n\n## Notes\nThe Professor explains the importance of composting (2:44).\n\n# Sizzle\n\n## Notes\n\nGame Show\n\n# Four Players Announcement\n\n## Notes\n\nFour players to the front.\n\n# Question 1\n\n## Question\n\n### What are food scraps?\n\n## Answer\n\n### Food scraps are food we don't eat\n* Includes:\n  * Inedible food like banana peels.\n  * Edible food like bread that has gone mouldy.\n  * Leftovers that we throw away\n\n## Answer Notes\n\n&nbsp;\n\n# Question 2\n\n## Question\n\n### {r/Canada} How much of our household garbage is food?\n\n### {r/United States} How much of our household garbage is food?\n\n### {r/} How much of our household garbage is food scraps?\n\n## Answer\n\n### {r/Canada} In Canada, 40% of household waste is food!\n\n### {r/United States} In the US, 22% of household waste is food!\n\n### {r/} Around 30-40% of household waste is food!\n\n* {r/Canada} How much of your family's waste is food?\n* {r/United States} How much of your family's waste is food?\n* {r/} The actual amount is different depending on the country and region.\n* {r/} How much of your family's waste is food?\n\n[comment]: # (Canada source: Metro Vancouver)\n[comment]: # (United States source: US EPA)\n[comment]: # (Everywhere else source: estimate based on Canada and US figures)\n\n## Answer Notes\n\n&nbsp;\n\n# Question 3\n\n## Question\n\n### What are three good things about composting?\n\n## Answer\n\n### Good things about composting:\n1. Reduces landfill - doesn't make waste.\n2. Doesn't make methane.\n3. Makes soil to grow plants.\n\n## Answer Notes\n\n&nbsp;\n\n# Question 4\n\n## Question\n\n### What's the problem with putting food in the garbage?\n\n## Answer\n\n### Putting food in garbage:\n* Increases the landfill.\n* Makes methane.\n* Takes food out of the cycle of life / doesn't make new soil.\n* Leaves us with nothing!\n\n## Answer Notes\n\n&nbsp;\n\n# Question 5\n\n## Question\n\n### What are microorganisms?\n\n## Answer\n\n### Microorganisms:\n* Very small living creatures you can see in a microscope.\n* They turn food into soil!\n\n## Answer Notes\n\n&nbsp;\n"

/***/ }),
/* 1845 */
/***/ (function(module, exports) {

	module.exports = "# Game Show\n\nLevel 4 - Waste-Free Lunch\n\n# Intro Video\n\nYouTube: abpblxk1TVA\n\n## Notes\nIntro to Game Show (0:13).\n\n# Sizzle\n\n## Notes\n\nGame Show\n\n# Four Players Announcement\n\n## Notes\n\nFour players to the front.\n\n# Question 1\n\n## Question\n\n### What is packaging?\n\n## Answer\n\n### Packaging:\n* A disposable covering on a product.\n\n## Answer Notes\n\n&nbsp;\n\n# Question 2\n\n## Question\n\n### What is packaging made of?\n\n## Answer\n\n### Packaging can be made of:\n* Plastic\n* Metal\n* Paper\n* Cardboard\n* Glass\n* Styrofoam\n\n## Answer Notes\n\n&nbsp;\n\n# Question 3\n\n## Question\n\n### What problems does packaging create?\n\n## Answer\n\n### Packaging creates problems:\n* It makes a lot of garbage that lasts forever.\n* Lots of plastic doesn't get recycled.\n* Litter - lots of packaging ends up in the street and in nature.\n* Toxic chemicals in plastic can get into water, soil and food.\n* Even when they're recyclable, plastic and styrofoam end up putting a lot of chemicals into the air and use a lot of energy and water to make.\n* Some companies use packaging to trick us into buying something we don't need.\n\n## Answer Notes\n\n&nbsp;\n\n# Question 4\n\n## Question\n\n### What is a waste-free lunch?\n\n## Answer\n\n### Waste-Free Lunch:\n* A lunch that leaves no garbage when you're done.\n* Also called a litterless lunch.\n\n## Answer Notes\n\n&nbsp;\n\n# Question 5\n\n## Question\n\n### List some items you'll need for a waste-free lunch\n\nIf you don't bring your own lunch, think about a waste-free picnic instead.\n\n## Answer\n\n### You'll need:\n* Re-usable containers\n* Re-usable bottle\n* Cloth napkin\n* Re-usable fork, knife or spoon\n* Lunch bag or box\n\n## Answer Notes\n\n&nbsp;\n\n# Question 6\n\n## Question\n\n### What's a single-use item?\n\n## Answer\n\n### Single-use item:\n* Something you can only use once and then throw it, or part of it, away.\n\n## Answer Notes\n\n&nbsp;\n\n# Question 7\n\n## Question\n\n### Name 5 single-use items\n\n## Answer\n\n### Some single-use items:\n* Disposable cutlery\n* Coffee cup\n* Paper napkin\n* Paper plate\n* Plastic bags\n* Plastic water or juice bottle\n\n## Answer Notes\n\n&nbsp;\n\n# Question 8\n\n## Question\n\n### What problems do single-use items create?\n\n## Answer\n\n### Single-use items:\n* Fill up the landfill fast because we make garbage every time we use one.\n* Use a lot of resources when they're made, and create pollution and garbage while they're being made too.\n* Cost more - example: bottled water is mostly just tap water, you have to keep using single-use sandwich bags etc.\n\n## Answer Notes\n\n&nbsp;\n"

/***/ }),
/* 1846 */
/***/ (function(module, exports) {

	module.exports = "# Game Show\n\nLevel 5 - Buy Smart\n\n# Intro Video\n\nYouTube: xMy-VZfdouc\n\n## Notes\nIntro to Game Show (0:52).\n\n# Sizzle\n\n## Notes\n\nGame Show\n\n# Brainstorm Edition\n\n## Content\n\n### Game show rules for Brainstorm Edition:\n* No Buzzers this time! Stay seated with your groups!\n* When you see the question, try to come up with answers in your groups. Teamwork counts!\n* Then share your answers with the class.\n* It's a brainstorm, so you get a point for each idea shared!\n\n## Notes\n\nDifferent rules for Brainstorm Edition.\n\n# Question 1\n\n## Question\n\n### What is an \"impulse purchase\"?\n\n#### Give some examples.\n\n## Answer\n\n### An impulse purchase:\nSomething you buy without thinking, just because you see it and want it in that moment. Examples include:\n* Candy at the checkout counter.\n* A toy you see at the store.\n* Something on sale you don't really need.\n\n## Answer Notes\n\n&nbsp;\n\n# Question 2\n\n## Question\n\n### What feelings do you get when you make an impulse purchase?\n\n#### How long do they last?\n\n## Answer\n\n#### There is no right answer!\n\n## Answer Notes\n\n&nbsp;\n\n# Question 3\n\n## Question\n\n### What are some other ways to get that feeling?\n\n#### (without wasting money and resources)\n\n## Answer\n\n### There is no right answer!\n\n#### But here are some ideas:\n\n* Wait a day to see if you still want it.\n* Do something on your list of joys.\n* Just enjoy wanting it! People often get the same joy out of wanting something as they do from having it.\n\n## Answer Notes\n\n&nbsp;\n\n# Question 4\n\n## Question\n\n### How do some companies try to make you buy their stuff?\n\n## Answer\n\n### Ways companies try to make you buy stuff:\n\n* Make you think you need it and that your life will be better if you have it.\n* Make you think you'll look cool by having celebrities use the product.\n* Make you think people will like you if you have it.\n* Make you feel bad about yourself if you don't have it.\n* Make you act on impulse instead of thinking about it.\n* Put things in fancy packaging to look more exciting than they actually are.\n\n## Answer Notes\n\n&nbsp;\n"

/***/ }),
/* 1847 */
/***/ (function(module, exports) {

	module.exports = "# Game Show\n\nLevel 6 - Green Cycle\n\n# Intro Video\n\nYouTube: c-gdm37BskE\n\n## Notes\nIntro to Game Show (0:10).\n\n# Sizzle\n\n## Notes\n\nGame Show\n\n# Product LifeCycle\n\n## Content\n\n### The Life-Cycle of a Product\nWe take the earth's resources\n\nAnd we drive them to the factories\n\nAnd turn them into things we buy\n\n(which is mostly stuff that we don't need)\n\nWe're throwing the world out in the dump\n\n## Notes\n\nIntroduction to the life-cycle of a product.\n\n# Four Players Announcement\n\n## Notes\n\nFour players to the front.\n\n# Question 1\n\n## Question\n\n### Name one problem caused by the way we use our natural resources\n\n## Answer\n\n### We're using up the planet!\n* We use up our renewable resources (like trees) faster than they can be renewed (80% of the earth's forests are gone).\n* We've used up too many of our non-renewable resources (ones that we can't replace, like oil).\n* This is bad for our environment, polluting the water, the air, the food we eat, and even ourselves.\n* We're destroying animal and bird habitat.\n\n## Answer Notes\n\n&nbsp;\n\n# Question 2\n\n## Question\n\n### The way we make things in factories causes problems too.\n\n#### Name one or more of these problems.\n\n## Answer\n\n### Problems with how things are made:\n* To make, package and ship a product makes up to 70 times more garbage than the product itself.\n* Making products often uses chemicals that pollute the air, land, water etc.\n* People who work in factories that make things we buy are not always treated well.\n* Products are often designed to break or wear out after a short time.\n\n## Answer Notes\n\n&nbsp;\n\n# Question 3\n\n## Question\n\n### There are problems caused by shipping products, too.\n\n#### What do you think these problems might be?\n\n## Answer\n\n### Transportation Issues:\n* Transporting products takes up huge amounts of energy and causes pollution.\n* For example, a plastic toy will be made in China from resources shipped from a country in Africa, and then shipped to be sold in America.\n\n## Answer Notes\n\n&nbsp;\n\n# Question 4\n\n## Question\n\n### What are some problems with the way we buy stuff?\n\n## Answer\n\n### We buy:\n* Stuff we don't need.\n* Stuff that doesn't last or can't be fixed.\n* Stuff once that we use then throw away.\n* Stuff without thinking about it.\n* Stuff that can't be recycled, that just gets thrown out when we're done.\n\n## Answer Notes\n\n&nbsp;\n\n# Question 5\n\n## Question\n\n### What are some problems with the way we get rid of stuff?\n\n## Answer\n\n### Our garbage problem:\n* Only 1% of stuff we buy is still in use 6 months later.\n* Our dumps are filling up.\n* Everything we put in the dump goes out of the cycle of life and is lost forever.\n* Some places burn their garbage, which creates air pollution.\n* Recycling is good, but it's not enough. We have too much stuff!\n\n## Answer Notes\n\nReference: Story of Stuff\n\n# Solutions\n\n## Content\n\n### Now for some solutions!\n\n## Notes\n\nApprentices will learn how they can design solutions for these problems in the next activity.\n"

/***/ }),
/* 1848 */
/***/ (function(module, exports) {

	module.exports = "Group Drawing\n\n# Intro Video\n\nYouTube: NnDWihhjILA\n\n## Notes\nIntro to Group Drawing activity (1:20).\n\n# Sizzle\n\n## Content\n\n### Activity 1: Group Drawing\n\n## Notes\nActivity 1: Group Drawing\n\nActivity instructions on next slide.\n\n# Instructions\n\n## Content\n\n### Drawing our joys\n* In your teams, draw things that give you joy, that aren't about having stuff.\n  * For example, if you like playing soccer, the joy is about playing *with* your friends, not owning a ball. So soccer is a joy that's not about owning stuff.\n* Share your art with the class.\n\n## Notes\n\nSee next slide for points info.\n\n# Scoring\n\n## Content\n\n### How to score points\n\n* Teamwork!\n* Number of joys you draw that aren't about stuff.\n* Quality of drawings.\n\n## Notes\n\n### Extension Activity\nApprentices can add more joys to their drawing every day of the week.\n\n# Ian and Sara Outro\n\nYouTube: rZ93_QeRmFg\n\n## Notes\nGroup Drawing activity wrap-up (0:30).\n"

/***/ }),
/* 1849 */
/***/ (function(module, exports) {

	module.exports = "# Intro Video\n\nYouTube: BqXYz9nXWOM\n\n## Notes\nIntro to Popcorn Activity (1:47).\n\n# Instructions\n\n## Content\n\n### What brought you joy this week?\n* Think back to the experiences that brought you joy this week.\n* What were you doing?\n* Who were you with?\n* Get into partners, listen to their joys then share these with the class.\n\n## Notes\n\nPopcorn activity: Joys from the week.\n"

/***/ }),
/* 1850 */
/***/ (function(module, exports) {

	module.exports = "# Intro Video\n\nYouTube: qkwRjncdBe0\n\n## Notes\nIntro to Math Challenge activity (0:28).\n\n# Sizzle\n\n## Content\n\n### Activity 1: Math Challenge!\n\n## Notes\n\nActivity 1: Math Challenge\n\n# Instructions\n\n## Content\n\n### Math Challenge Instructions\n* Teams work together to get the answer.\n* Points for getting the correct answer.\n* Points for being the first team to get the correct answer.\n\n## Notes\n\nQuestion on next slide.\n\n# Question\n\n## Content\n\n### Math Challenge!\n* {r/India} Imagine one mango costs 10 rupees.\n* {r/India} Level 1 (challenging): How much money is wasted if you throw away 4 mangos?\n* {r/India} Level 2 (really challenging): How much money is wasted if you throw away 1 dozen mangoes?\n* {r/India} Level 3 (even more challenging): How much money is wasted if you throw away 5 dozen mangoes?\n* {r/India} Tip: 1 dozen mangoes is 12 mangoes!\n* {r/} The average family wastes $700 a year throwing out perfectly good food.\n* {r/} Level 1 (challenging): If a video game costs $50 including tax, how many games could you buy if your family didn't waste that food?\n* {r/} Level 2 (really challenging): If a video game costs $45 including tax, how many games could you buy then?\n\n## Notes\n\nAnswers on next screen.\n\n# Answer\n\n## Content\n\n### The answer is...!\n* {r/India} Level 1 (challenging): 40 rupees\n* {r/India} Level 2 (challenging): 120 rupees\n* {r/India} Level 3 (even more challenging) 600 rupees\n* {r/} Level 1 (challenging): 14 video games\n* {r/} Level 2 (really challenging): 15 video games, plus $25 leftover for pizza!\n\n## Notes\n\n### Optional Question\n* What fun experiences could they buy with the money they've just saved?\n"

/***/ }),
/* 1851 */
/***/ (function(module, exports) {

	module.exports = "Eat Me First Sign\n\n# Sizzle\n\n## Content\n\n### Activity 2: Eat Me First Sign!\n\n## Notes\n\nActivity 2: Eat Me First Sign\n\nGet your paper and writing/{r/Canada:colouring}{r/:coloring} materials together.\n\n# Instructions\n\n## Content\n\n### 'Eat Me First' sign!\n* Make a small sign to go in your fridge at home that says EAT ME FIRST.\n* You can draw pictures of food too, or decorate the sign as you like!\n* Points for an easy-to-read sign, and for good design.\n\n## Notes\n\nThe sign will help families identify food that needs to be eaten before it goes bad.\n"

/***/ }),
/* 1852 */
/***/ (function(module, exports) {

	module.exports = "Sorting Game\n\n# Intro Video\n\nYouTube: rNz2vijyTK8\n\n## Notes\nIntro to Sorting Game activity (1:42).\n\n# Sizzle\n\n## Content\n\n### Activity 1: Sorting Game!\n\n## Notes\n\n### Activity 1: Sorting Game\n* You'll need the Sorting Game cards and bin sheets.\n* Each team gets one deck of cards and three 'bins'.\n\n# Instructions\n\n## Content\n\n### Game Instructions\n* 1 person in each team is the dealer.\n* Dealer flips up one card in deck.\n* Team members point where dealer should place card: in compost, recycling or landfill.\n* Dealer places card.\n* Repeat!\n\n## Notes\n\nPoints allocation on next slide\n\n# Scoring\n\n## Content\n\n### How to score points\n* Number of correct answers for your team.\n* Good teamwork and listening to each other!\n\n## Notes\n\nFor extra fun: First team finished gets a point. Note this won’t work with some classes.\n\n# Start Sorting Game\n\n## Content\n\n### Start the Sorting Game!\n\n#### (if you haven't already)\n\n## Notes\n\nStart the Sorting Game!\n\n# Results\n\n## Content\n\n### See how many you got right!\n\n## Notes\n\n### Scoring\n* Compare the teams' answers with your answer sheet.\n* Award points for number of correct items and teamwork/listening.\n"

/***/ }),
/* 1853 */
/***/ (function(module, exports) {

	module.exports = "Food Scraps Rap\n\n# Intro Video  \n\nYouTube: 8NQs-NNdx5w\n\n## Notes\nIntro to Food Scraps Rap activity (0:52).\n\n# Sizzle\n\n## Content\n\n### Activity 2: Write a rap!\n\n(Younger grades can write a poem instead)\n\n## Notes\n\nActivity 2: Write a rap\n\n# Instructions\n\n## Content\n\n### Instructions\n* Write about food scraps, or something you learned today.\n* Write two lines, where the last word in each line rhymes.\n* Your Mission Files has sample rhymes, but get bonus points for using words that aren't in the booklet.\n* If you're writing a rap, {r/Canada:practise}{r/:practice} in your teams with the backing track on the next slide.\n\n\n## Notes\n\nThere is a worksheet in the Mission File for this activity.\n\n# Rap Backtrack Practice\nYouTube: eEzxxHgcpzE\n\n## Notes\n\nTo get the backtrack (10:08) to repeat, just press play again.\n\n# Scoring\n\n## Content\n\n### Now perform for the class!\n\n#### Get points for:\n* Two lines that rhyme.\n* Good performance.\n* Beatboxing.\n* Being a good audience.\n\n## Notes\n\n### Extension Activity\nVideo your raps and submit them to our website!\n\n# Rap Backtrack Perform\nYouTube: eEzxxHgcpzE\n\n## Notes\n\nTo get the backtrack to repeat, just press play again.\n"

/***/ }),
/* 1854 */
/***/ (function(module, exports) {

	module.exports = "Lunch Analysis\n\n# Intro Video\n\nYouTube: I7SZOyTNII0\n\n## Notes\nIntro to Lunch Analysis (1:15).\n\n# Sizzle\n\n## Content\n\n### Activity 1: Lunch Analysis!\n\n## Notes\n\nActivity 1: Lunch Analysis\n\n# Instructions\n\n## Content\n\n### How waste-free is your lunch right now?\n\n*\tIn teams or individually, look at your lunch or your snack and find at least one way to create less garbage.\n* If you already have a Waste-Free Lunch or don't bring your own lunch, think about the packaging you use at home.\n\n## Notes\n\nIf your students do not bring their lunches to school, you can discuss items usually found in school lunches or picnics.\n\n### Additional Questions\n* How does your family buy in bulk?\n* What kind of packaging does the item come in?\n* What other things do you buy that have packaging?\n* How big is the packaging compared to the product? Why could that be?\n"

/***/ }),
/* 1855 */
/***/ (function(module, exports) {

	module.exports = "Collective Impact Math\n\n# Intro Video  \nYouTube: z__73UcXMKY\n\n## Notes\nIntro to Collective Impact activity (1:04).\n\n# Sizzle\n\n## Content\n\n### Activity 2: Collective Impact\n\n#### Math Challenge\n\n## Notes\n\nThis activity will help apprentices use math to understand a social concept: collective impact.\n\n# Question 1\n\n## Content\n\n### Question 1\nIf you have a cereal bar every day for lunch, how many wrappers will end up in the garbage in a year?\n\n## Notes\n\nAnswer preview: 365 wrappers.\n\n# Answer 1\n\n## Content\n\n### Answer:\n#### 365 wrappers\n\n## Notes\n\n365 wrappers.\n\n# Question 2\n\n## Content\n\n### Question 2\nIf everyone in your class has a cereal bar for lunch, how many wrappers will end up in the garbage in a year?\n\n## Notes\n\nAnswer preview: 365 x # of Apprentices in your class.\n\n# Answer 2\n\n## Content\n\n### Answer:\n#### 365 x (# of Apprentices in class)\n\n## Notes\n\n365 x # of Apprentices in class.\n\n# Question 3\n\n## Content\n\n### Question 3\nIf a city has a {r/India:20,00,000}{r/:2,000,000} people in it, and everyone has a cereal bar for lunch, how many wrappers will end up in the garbage in a year?\n\n## Notes\n\nAnswer preview: {r/India:20,00,000}{r/:2,000,000} x 365 = {r/India:7 crore 30 lakh }{r/:730 million}.\n\n### Alternative question\nIf a school has 200 students, and everyone has a cereal bar for lunch, how many wrappers will end up in the garbage in a year. Answer preview: 200 x 365 = 7,300.\n\n# Answer 3\n\n## Content\n\n### Answer:\n#### {r/India:20,00,000}{r/:2,000,000}\n#### x 365 =\n<br>\n#### {r/India:7 crore 30 lakh }{r/:730 million} wrappers in one year!\n\n## Notes\n\n&nbsp;\n\n# Collective Impact\n\n## Content\n\n### That's called collective impact!\n\n#### That means, everyone together makes a big difference!\n\n## Notes\n\n### Optional Questions\n* What other waste habits would be interesting to measure the impact of?\n"

/***/ }),
/* 1856 */
/***/ (function(module, exports) {

	module.exports = "Waste-free lunch poster\n\n# Sizzle\n\n## Content\n\n### Activity 3: Waste-free lunch posters\n\n## Notes\n\nActivity 3: Waste-free lunch posters.\n\n# Instructions\n\n## Content\n\n### Design a poster about waste-free lunches\n* The poster should be about *at least ONE* way that people can reduce the waste in their lunches.\n* If you don't bring your own lunch to school, make a poster encouraging people to put waste in its place and not litter.\n* Put the poster up in a hallway in your school.\n\n## Notes\n\nDesign a poster.\n\n# Scoring\n\n## Content\n\n### Points for:\n* Good poster design.\n* Ideas expressed well.\n* Number of ideas expressed.\n\n## Notes\n\n### Extension Activity\n\nWeigh the garbage in your classroom for one week before/after your Waste-Free Lunch, and measure the difference!\n"

/***/ }),
/* 1857 */
/***/ (function(module, exports) {

	module.exports = "Buy Smart Code\n\n# Intro Video  \n\nYouTube: shFoXIqHqNE\n\n## Notes\nIntro to Buy Smart Code activity (1:59).\n\n# Sizzle\n\n## Content\n\n### Activity 1: Buy Smart Code\n\n## Notes\n\nActivity 1: Buy Smart Code.\n\n# Instructions\n\n## Content\n\n### Create your class Buy Smart Code\n\n#### As a class, discuss:\n* How do we buy smarter, in ways that are kinder to the planet?\n* What questions do we need to ask ourselves when we're buying things so that we make the kindest choice?\n* Collaborate as a class on guidelines to buying smart: create a Buy Smart Code!\n\n## Notes\n\n* Our Buy Smart Code is on the next slide\n* Don't reveal it until the class has come up with a good list themselves\n* Then see if the class missed anything on the next slide, and add it to their list\n\n# Es Buy Smart Code\n\n## Content\n\n### Here's my Buy Smart Code:\n1. **Buy things that last.** Is this durable? Or will it break soon?\n2. **Buy things that you can reuse and share.** How many times can I use it?\n3. **Buy things that can be repaired.** Could I fix it if it breaks?\n4. **Buy things with little packaging.** Can I buy in bulk?\n5. **Do I really need it?** Is this just a pleasure-flash or is it lasting fun?\n6. **Love makes us happier than stuff does.** Choose experiences - have a fun time together - instead of buying stuff.\n\n## Notes\n\nEsmeralda's Buy Smart Code.\n\n# Write Class Buy Smart Code\n\n## Content\n\n### Write your class' \"Buy Smart Code\" in Mission File 5\n\n## Notes\n\nThis will help Apprentices prepare for Mission 5.\n"

/***/ }),
/* 1858 */
/***/ (function(module, exports) {

	module.exports = "Practise your Buy Smart skills!\n\n# Intro Video  \nYouTube: 5RZKn3SRVW0\n\n## Notes\nIntro to Skit activity (1:14).\n\n# Sizzle\n\n## Content\n\n### Activity 2: Skit\n\n## Notes\n\nActivity 2: Skit\n\n# Instructions\n\n## Content\n\n### In your teams, make up a skit:\n* Your family or friends are at the mall.\n* One of you wants to buy something that is clearly just an impulse purchase.\n* The rest of you convince that person not to buy it. Give good reasons!\n* Perform the skit for your class.\n\n## Notes\n\nThis activity will help Apprentices practice for conversations they'll have with their families.\n\n### Extension Activity\nMake a poster showing alternatives to buying things impulsively OR contract impulse buying with Buy Smart buying.\n"

/***/ }),
/* 1859 */
/***/ (function(module, exports) {

	module.exports = "Biomimicry\n\n# Sizzle\n\n## Content\n\n### Activity 1: Biomimicry Brainstorm\n\n## Notes\n\nActivity 1: Biomimicry Brainstorm\n\n# Intro to Biomimicry\n\nYouTube: ChfXvXQdfVk\n\n## Notes\nIntro to Biomimicry (1:25).\n\n# Biomimicry Info\n\n## Content\n\n### Biomimicry - what is it?\n* It's when humans design and make stuff or systems inspired by things or processes found in nature.\n  * e.g. waste from animal is food for another animal.\n* We have to learn how to live in harmony with nature.\n* Nature has already solved all the problems we’re trying to figure out to be sustainable.\n* So when we design things we should follow how nature does it.\n* We listen to nature, nature is our boss!\n\n## Notes\n\nInformation on Biomimicry.\n\n# Class Brainstorm\n\n## Content\n\n### Class Brainstorm\n* What are some ways that nature keeps everything in a cycle of re-use? Think:\n  * What does nature use for energy?\n  * How does nature clean itself?\n  * What happens to one creature's waste?\n  * How do parts of nature work together and help each other?\n\n## Notes\n\n### Answer Preview: Nature's Principles\n* Life runs on clean energy (sunlight, wind, water)\n* Life uses water to dissolve stuff instead of chemicals\n* Life thrives on diversity and cooperation\n* Life wastes nothing, up-cycles everything, does not foul its nest.\n* Life takes care of the place it lives now, by making sure it’s healthy for the future.\n\n# Nature Principles\n\n## Content\n\n### Nature's Principles\n* Life runs on clean energy (sunlight, wind, water)\n* Life uses water to dissolve stuff instead of chemicals\n* Life thrives on diversity and cooperation\n* Life wastes nothing, up-cycles everything, does not foul its nest.\n* Life takes care of the place it lives now, by making sure it’s healthy for the future.\n\n## Notes\n\nInformation on Nature's Principles.\n\n# Design a Product\n\n## Content\n\n### Design a product\nIn teams or individually, dream up and invent a product that lives by these life principles! Then, share your product with the class, using art, movement, music, words or math.\n\nHere are questions you can ask:\n1. What kind of energy does it run on?\n2. What packaging does it need, what could it be made of?\n3. What materials is it made of? Can it be recycled?\n4. Can it be made without polluting anything?\n5. Can it be repaired if it breaks?\n6. Can it be turned into something else later?\n\n## Notes\n\nDesign a product.\n"

/***/ }),
/* 1860 */
/***/ (function(module, exports) {

	module.exports = "# Esmeralda and Goober Closing Story\n\nYouTube: -exh0NxeEio\n\n## Notes\nEsmeralda gives the Apprentices their first mission (1:28).\n"

/***/ }),
/* 1861 */
/***/ (function(module, exports) {

	module.exports = "# Ian and Sara Intro\n\nYouTube: 8drRLkLjcTw\n\n## Notes\nIntro to the Esmeralda and Goober Closing Story (0:42).\n\n# Esmeralda and Goober Closing Story\n\nYouTube: IjijiyJNzaM\n\n## Notes\nEsmeralda gives the Apprentices their second mission (1:04).\n"

/***/ }),
/* 1862 */
/***/ (function(module, exports) {

	module.exports = "# Esmeralda and Goober Closing Story\n\nYouTube: QXO9vRoYePU\n\n## Notes\nEsmeralda gives the Apprentices their third mission (3:09).\n"

/***/ }),
/* 1863 */
/***/ (function(module, exports) {

	module.exports = "# Esmeralda and Goober Closing Story\n\nYouTube: G3NNvrzdfmc\n\n## Notes\nEsmeralda gives the Apprentices their fourth mission (3:39).\n\n### Spoiler Alert\n\nThe System Manager character appears to 'hack' the Academy. Your Apprentices will be solving a puzzle to unlock the Academy at the beginning of Level 5.\n"

/***/ }),
/* 1864 */
/***/ (function(module, exports) {

	module.exports = "# Esmeralda and Goober Closing Story\n\nYouTube: tmfzNGOOsXM\n\n## Notes\nEsmeralda gives the Apprentices their fifth mission (1:12).\n"

/***/ }),
/* 1865 */
/***/ (function(module, exports) {

	module.exports = "# Ian and Sara Intro\n\nYouTube: 4087d2dmtQY\n\n## Notes\nIntro to the Esmeralda and Goober Closing Story (0:31).\n\n# Esmeralda and Goober Closing Story\n\nYouTube: Bp6ewyFzUT8\n\n## Notes\nThe last installment of Esmeralda and Goober's adventures (1:40).\n"

/***/ }),
/* 1866 */
/***/ (function(module, exports) {

	module.exports = "# Mission Assignment\n\nTitle: Operation Garbage Watch\n\n## Notes\n\n### Operation Garbage Watch\n\n* Apprentices turn to Mission 1 in their Mission Files.\n* Decide which day you will do the next Level.\n* Apprentices write that date on the cover of their Mission Files and on the Mission 1 page.\n* Points are awarded for signed and returned Mission 1 page.\n\n# Instructions\n\n## Content\n\n### Mission 1:\n\n#### Notice how much garbage your family makes\n* Give your parents/guardians their Mission Briefing.\n* Ask your family, \"What's one easy way our family can make less garbage?\"\n* Keep looking for clues about your family's waste habits until next time.\n* Training Agents (a.k.a teachers!) can do this mission too!\n\n## Notes\n\nOperation Garbage Watch instructions.\n\n\n# Bonus Mission\n\n## Content\n\n### Bonus mission!\n\n#### Find out where you could recycle a broken toaster\n* Google \"recycle toaster\" and your city/town\n* {r/Canada/BC} *Hint* in British Columbia an organization called ElectroRecycle helps make sure toasters and other small appliances are recycled.\n\n## Notes\n\n&nbsp;\n\n\n# Outro Video\nYouTube: vVCsfZZLpgk\n\n## Notes\nSara and Ian wrap up Level 1 (0:54).\n"

/***/ }),
/* 1867 */
/***/ (function(module, exports) {

	module.exports = "# Mission Assignment\n\nTitle: Operation Love Food Hate Waste\n\n## Notes\n\n### Operation Love Food Hate Waste\n\n* Apprentices turn to Mission 2 in their Mission Files.\n* Decide which day you will do the next Level.\n* Apprentices write that date on the cover of their Mission Files and on the Mission 2 page.\n* Points are awarded for signed and returned Mission 2 page.\n\n# Instructions\n\n## Content\n\n### Mission 2:\n\n#### Reducing food waste\n\n* Take your Eat Me First sign home.\n* Post it inside your fridge - on a box or on a shelf.\n* Remind your family to eat first from the Eat Me First box or shelf!\n* Training Agents can do this mission too!\n\n## Notes\n\nOperation Love Food Hate Waste instructions.\n"

/***/ }),
/* 1868 */
/***/ (function(module, exports) {

	module.exports = "# Mission Assignment\n\nTitle: Operation Food Scraps\n\n## Notes\n\n### Operation Food Scraps\n\n* Apprentices turn to Mission 3 in their Mission Files.\n* Confirm which missions you can do\n* Decide which day you will do the next Level.\n* Apprentices write that date on the cover of their Mission Files and on the Mission 3 page.\n* Points are awarded for signed and returned Mission 3 page.\n\n# Intro Video\n\nYouTube: 6KyXPZJf-GI\n\n## Notes\nIntro to Mission 3: Operation Food Scraps (0:41).\n\n# Instructions\n\n## Content\n\n### Mission 3:\n\n#### Keep food scraps in the cycle of life\n\n* Recycle more food scraps at school and/or at home! \n* Help your friends and family to remember what goes in the bin and what doesn't.\n* Can't recycle food scraps? Do more to reduce food waste this week e.g. meal planning, making a shopping list etc.\n* Training Agents can do this mission too!\n\n## Notes\n\nOperation Food Scraps instructions.\n"

/***/ }),
/* 1869 */
/***/ (function(module, exports) {

	module.exports = "# Mission Assignment\n\nTitle: Operation Waste-Free Lunch\n\n## Notes\n\n### Operation Waste-Free Lunch\n\n* Apprentices turn to Mission 4 in their Mission Files.\n* Decide which day you will do the next Level.\n* Apprentices write that date on the cover of their Mission Files and on the Mission 4 page.\n* Points are awarded for signed and returned Mission 4 page.\n\n# Instructions\n\n## Content\n\n### Mission 4:\n\n#### Make less waste when you have lunch!\n\n* Find at least one way to reduce the waste in your lunches.\n* Host a Waste-Free Lunch in your classroom.\n* Encourage other classrooms to also host one!\n* Put up your posters around your school.\n* Training Agents can do this mission too!\n\n## Notes\n\nOperation Waste-Free Lunch instructions.\n"

/***/ }),
/* 1870 */
/***/ (function(module, exports) {

	module.exports = "# Mission Assignment\n\nTitle: Operation Buy Smart\n\n## Notes\n\n### Operation Buy Smart\n\n* Apprentices turn to Mission 5 in their Mission Files.\n* Decide which day you will do the next Level.\n* Apprentices write that date on the cover of their Mission Files and on the Mission 5 page.\n* Points are awarded for signed and returned Mission 5 page.\n\n# Intro Video\n\nYouTube: zKhpee6arrY\n\n## Notes\nIntro to Mission 5: Operation Buy Smart (1:23).\n\n# Instructions\n\n## Content\n\n### Mission 5:\n\n#### Start following the Buy Smart Code\n\n* Help your family to pick at least one item in the code to follow this week!\n* Training Agents can do this mission too!\n\n## Notes\n\nOperation Buy Smart instructions.\n"

/***/ }),
/* 1871 */
/***/ (function(module, exports) {

	module.exports = "# Scoreboard Recap\n\n## Content\n\n### Check out the scoreboard to see who's in the lead!\n\n## Notes\n\n&nbsp;\n\n# Earn More Points\n\n## Content\n\n### Everyone has a chance to earn more points!\n* Take home your Mission Files.\n* Do your missions and record what you did.\n* Listen & participate in class!\n\n## Notes\n\n&nbsp;\n\n# Farewell\n\n## Content\n\n### Keep the fun going!\n\n#### Visit *AndGoober.com* for games and activities\n\nGo to the next slide to finish the level\n\n## Notes\nTo finish, go to the next slide and click 'Click to end level'.\n"

/***/ }),
/* 1872 */
/***/ (function(module, exports) {

	module.exports = "Ending\n\n# Ian and Sara Goodbye\n\nYouTube: 4oW3UfLCl4w\n\n## Notes\nIan and Sara say goodbye to the Apprentices (2:22).\n\n# Announce Winners\n\n## Content\n\n### Time to announce the winners!\n\n#### Training Agents please hand out certificates.\n\n## Notes\n\nPrint winning team certificates once you know who won; give all team members completion certificates now.\n\n### Extension Activity\nNow's a great time to do the papercraft activity!\n\n# Planet Protectors\n\n## Content\n\n### You are all now Planet Protecting Zero Heroes!\n\n#### Congratulations!\n\nKeep protecting the planet, keep finding ways to reduce waste!\n\nUntil next time, Esmeralda Planet Protector and Goober signing out!\n\n## Notes\n\nThank you for being a Training Agent and training your Apprentices!\n\n### Getting your feedback\n\nWe love to hear from teachers about their experience with the Academy. We'll be in touch in the next few days with a feedback survey!\n\n# All Levels Completed\n\n## Notes\n\nHave ideas for extension activities? Please share them with us!\n"

/***/ }),
/* 1873 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(2082);

/***/ }),
/* 1874 */,
/* 1875 */,
/* 1876 */,
/* 1877 */,
/* 1878 */,
/* 1879 */,
/* 1880 */,
/* 1881 */,
/* 1882 */,
/* 1883 */,
/* 1884 */,
/* 1885 */,
/* 1886 */,
/* 1887 */,
/* 1888 */,
/* 1889 */,
/* 1890 */,
/* 1891 */,
/* 1892 */,
/* 1893 */,
/* 1894 */,
/* 1895 */,
/* 1896 */,
/* 1897 */,
/* 1898 */,
/* 1899 */,
/* 1900 */,
/* 1901 */,
/* 1902 */,
/* 1903 */,
/* 1904 */,
/* 1905 */,
/* 1906 */,
/* 1907 */,
/* 1908 */,
/* 1909 */,
/* 1910 */,
/* 1911 */,
/* 1912 */,
/* 1913 */,
/* 1914 */,
/* 1915 */,
/* 1916 */,
/* 1917 */,
/* 1918 */,
/* 1919 */,
/* 1920 */,
/* 1921 */,
/* 1922 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__(11);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _blacklist = __webpack_require__(1209);
	
	var _blacklist2 = _interopRequireDefault(_blacklist);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(20);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _propTypes = __webpack_require__(246);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var InputSlider = function (_Component) {
	  _inherits(InputSlider, _Component);
	
	  function InputSlider() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, InputSlider);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = InputSlider.__proto__ || Object.getPrototypeOf(InputSlider)).call.apply(_ref, [this].concat(args))), _this), _this.getClientPosition = function (e) {
	      var touches = e.touches;
	
	      if (touches && touches.length) {
	        var finger = touches[0];
	        return {
	          x: finger.clientX,
	          y: finger.clientY
	        };
	      }
	
	      return {
	        x: e.clientX,
	        y: e.clientY
	      };
	    }, _this.getPosition = function () {
	      var top = (_this.props.y - _this.props.ymin) / (_this.props.ymax - _this.props.ymin) * 100;
	      var left = (_this.props.x - _this.props.xmin) / (_this.props.xmax - _this.props.xmin) * 100;
	
	      if (top > 100) top = 100;
	      if (top < 0) top = 0;
	      if (_this.props.axis === 'x') top = 0;
	      top += '%';
	
	      if (left > 100) left = 100;
	      if (left < 0) left = 0;
	      if (_this.props.axis === 'y') left = 0;
	      left += '%';
	
	      return { top: top, left: left };
	    }, _this.change = function (pos, dragEnd) {
	      if (!_this.props.onChange) return;
	
	      var rect = _reactDom2.default.findDOMNode(_this).getBoundingClientRect();
	      var width = rect.width,
	          height = rect.height;
	      var _this$props = _this.props,
	          axis = _this$props.axis,
	          xstep = _this$props.xstep,
	          ystep = _this$props.ystep,
	          xmax = _this$props.xmax,
	          xmin = _this$props.xmin,
	          ymax = _this$props.ymax,
	          ymin = _this$props.ymin;
	      var top = pos.top,
	          left = pos.left;
	
	      var dx = 0;
	      var dy = 0;
	
	      if (left < 0) left = 0;
	      if (left > width) left = width;
	      if (top < 0) top = 0;
	      if (top > height) top = height;
	
	      if (axis === 'x' || axis === 'xy') {
	        dx = left / width * (xmax - xmin);
	      }
	
	      if (axis === 'y' || axis === 'xy') {
	        dy = top / height * (ymax - ymin);
	      }
	
	      var x = (dx !== 0 ? parseInt(dx / xstep, 10) * xstep : 0) + xmin;
	      var y = (dy !== 0 ? parseInt(dy / ystep, 10) * ystep : 0) + ymin;
	
	      _this.props.onChange({ x: x, y: y });
	    }, _this.handleMouseDown = function (e) {
	      e.preventDefault();
	      var dom = _this.refs.handle;
	      var clientPos = _this.getClientPosition(e);
	
	      _this.start = {
	        x: dom.offsetLeft,
	        y: dom.offsetTop
	      };
	
	      _this.offset = {
	        x: clientPos.x,
	        y: clientPos.y
	      };
	
	      document.addEventListener('mousemove', _this.handleDrag);
	      document.addEventListener('mouseup', _this.handleDragEnd);
	
	      document.addEventListener('touchmove', _this.handleDrag, { passive: false });
	      document.addEventListener('touchend', _this.handleDragEnd);
	      document.addEventListener('touchcancel', _this.handleDragEnd);
	    }, _this.getPos = function (e) {
	      var clientPos = _this.getClientPosition(e);
	      var rect = _reactDom2.default.findDOMNode(_this).getBoundingClientRect();
	      var posX = clientPos.x + _this.start.x - _this.offset.x;
	      var posY = clientPos.y + _this.start.y - _this.offset.y;
	
	      return {
	        left: posX,
	        top: posY
	      };
	    }, _this.handleDrag = function (e) {
	      e.preventDefault();
	      _this.change(_this.getPos(e));
	    }, _this.handleDragEnd = function (e) {
	      e.preventDefault();
	      document.removeEventListener('mousemove', _this.handleDrag);
	      document.removeEventListener('mouseup', _this.handleDragEnd);
	
	      document.removeEventListener('touchmove', _this.handleDrag);
	      document.removeEventListener('touchend', _this.handleDragEnd);
	      document.removeEventListener('touchcancel', _this.handleDragEnd);
	
	      if (_this.props.onDragEnd) {
	        _this.props.onDragEnd();
	      }
	    }, _this.handleClick = function (e) {
	      var clientPos = _this.getClientPosition(e);
	      var rect = _reactDom2.default.findDOMNode(_this).getBoundingClientRect();
	
	      _this.change({
	        left: clientPos.x - rect.left,
	        top: clientPos.y - rect.top
	      }, true);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(InputSlider, [{
	    key: 'render',
	    value: function render() {
	      var axis = this.props.axis;
	
	      var props = (0, _blacklist2.default)(this.props, 'axis', 'x', 'y', 'xmin', 'xmax', 'ymin', 'ymax', 'xstep', 'ystep', 'onChange', 'onDragEnd', 'className', 'onClick');
	      var pos = this.getPosition();
	
	      var valueStyle = {};
	      if (axis === 'x') valueStyle.width = pos.left;
	      if (axis === 'y') valueStyle.height = pos.top;
	
	      props.className = (0, _classnames2.default)('u-slider', 'u-slider-' + axis, this.props.className);
	
	      return _react2.default.createElement(
	        'div',
	        _extends({}, props, { onClick: this.handleClick }),
	        _react2.default.createElement('div', { className: 'value', style: valueStyle }),
	        _react2.default.createElement('div', {
	          className: 'handle',
	          ref: 'handle',
	          onTouchStart: this.handleMouseDown,
	          onMouseDown: this.handleMouseDown,
	          onClick: function onClick(e) {
	            e.stopPropagation();
	            e.nativeEvent.stopImmediatePropagation();
	          },
	          style: pos
	        })
	      );
	    }
	  }]);
	
	  return InputSlider;
	}(_react.Component);
	
	InputSlider.propTypes = {
	  axis: _propTypes2.default.string,
	  x: _propTypes2.default.number,
	  xmax: _propTypes2.default.number,
	  xmin: _propTypes2.default.number,
	  y: _propTypes2.default.number,
	  ymax: _propTypes2.default.number,
	  ymin: _propTypes2.default.number,
	  xstep: _propTypes2.default.number,
	  ystep: _propTypes2.default.number
	};
	InputSlider.defaultProps = {
	  axis: 'x',
	  xmin: 0,
	  ymin: 0,
	  xstep: 1,
	  ystep: 1
	};
	
	
	module.exports = InputSlider;

/***/ }),
/* 1923 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1922);


/***/ }),
/* 1924 */,
/* 1925 */,
/* 1926 */,
/* 1927 */,
/* 1928 */,
/* 1929 */,
/* 1930 */,
/* 1931 */,
/* 1932 */,
/* 1933 */,
/* 1934 */,
/* 1935 */,
/* 1936 */,
/* 1937 */,
/* 1938 */,
/* 1939 */,
/* 1940 */,
/* 1941 */,
/* 1942 */,
/* 1943 */,
/* 1944 */,
/* 1945 */,
/* 1946 */,
/* 1947 */,
/* 1948 */,
/* 1949 */,
/* 1950 */,
/* 1951 */,
/* 1952 */,
/* 1953 */,
/* 1954 */,
/* 1955 */,
/* 1956 */,
/* 1957 */,
/* 1958 */,
/* 1959 */,
/* 1960 */,
/* 1961 */,
/* 1962 */,
/* 1963 */,
/* 1964 */,
/* 1965 */,
/* 1966 */,
/* 1967 */,
/* 1968 */,
/* 1969 */,
/* 1970 */,
/* 1971 */,
/* 1972 */,
/* 1973 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(362);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.generateIcon = generateIcon;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(246);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _icons = __webpack_require__(1974);
	
	var _icons2 = _interopRequireDefault(_icons);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function generateIcon(network) {
	  if (!_icons2.default[network.toLowerCase()]) {
	    throw new Error('invalid network name for a social icon');
	  }
	
	  var iconConfig = _icons2.default[network.toLowerCase()];
	
	  var Icon = function Icon(props) {
	    var className = props.className,
	        iconBgStyle = props.iconBgStyle,
	        logoFillColor = props.logoFillColor,
	        round = props.round,
	        size = props.size;
	
	
	    var baseStyle = {
	      width: size,
	      height: size
	    };
	
	    var classes = 'social-icon social-icon--' + network + ' ' + className;
	
	    var finalIconBgStyle = (0, _extends3.default)({}, iconBgStyle);
	
	    return _react2.default.createElement(
	      'div',
	      { style: baseStyle },
	      _react2.default.createElement(
	        'svg',
	        {
	          viewBox: '0 0 64 64',
	          width: size,
	          height: size,
	          className: classes },
	        _react2.default.createElement(
	          'g',
	          null,
	          !round ? _react2.default.createElement('rect', {
	            width: '64',
	            height: '64',
	            fill: iconConfig.color,
	            style: finalIconBgStyle }) : _react2.default.createElement('circle', {
	            cx: '32',
	            cy: '32',
	            r: '31',
	            fill: iconConfig.color,
	            style: finalIconBgStyle })
	        ),
	        _react2.default.createElement(
	          'g',
	          null,
	          _react2.default.createElement('path', { d: iconConfig.icon, fill: logoFillColor })
	        )
	      )
	    );
	  };
	
	  Icon.propTypes = {
	    className: _propTypes2.default.string,
	    iconBgStyle: _propTypes2.default.object,
	    logoFillColor: _propTypes2.default.string,
	    round: _propTypes2.default.bool,
	    size: _propTypes2.default.number
	  };
	
	  Icon.defaultProps = {
	    className: '',
	    logoFillColor: 'white',
	    size: 64
	  };
	
	  return Icon;
	}

/***/ }),
/* 1974 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/* eslint-disable max-len */
	exports.default = {
	  facebook: {
	    icon: 'M34.1,47V33.3h4.6l0.7-5.3h-5.3v-3.4c0-1.5,0.4-2.6,2.6-2.6l2.8,0v-4.8c-0.5-0.1-2.2-0.2-4.1-0.2 c-4.1,0-6.9,2.5-6.9,7V28H24v5.3h4.6V47H34.1z',
	    mask: 'M0,0v64h64V0H0z M39.6,22l-2.8,0c-2.2,0-2.6,1.1-2.6,2.6V28h5.3l-0.7,5.3h-4.6V47h-5.5V33.3H24V28h4.6V24 c0-4.6,2.8-7,6.9-7c2,0,3.6,0.1,4.1,0.2V22z',
	    color: '#3b5998'
	  },
	  google: {
	    icon: 'M25.3,30.1v3.8h6.3c-0.3,1.6-1.9,4.8-6.3,4.8c-3.8,0-6.9-3.1-6.9-7s3.1-7,6.9-7c2.2,0,3.6,0.9,4.4,1.7l3-2.9c-1.9-1.8-4.4-2.9-7.4-2.9c-6.1,0-11.1,5-11.1,11.1s5,11.1,11.1,11.1c6.4,0,10.7-4.5,10.7-10.9c0-0.7-0.1-1.3-0.2-1.8H25.3L25.3,30.1z M49.8,28.9h-3.2v-3.2h-3.2v3.2h-3.2v3.2h3.2v3.2h3.2v-3.2h3.2',
	    mask: 'M0,0v64h64V0H0z M31.3,19.1c0.3,0.3,0.6,0.7,0.9,1.2c0.3,0.4,0.5,0.9,0.7,1.5c0.2,0.6,0.3,1.3,0.3,2.1 c0,1.4-0.3,2.6-0.9,3.4c-0.3,0.4-0.6,0.8-0.9,1.2c-0.4,0.4-0.8,0.7-1.2,1.1c-0.2,0.2-0.5,0.5-0.7,0.8c-0.2,0.3-0.4,0.7-0.4,1.1 c0,0.4,0.1,0.8,0.4,1c0.2,0.3,0.4,0.5,0.6,0.7l1.4,1.1c0.8,0.7,1.6,1.5,2.2,2.3c0.6,0.8,0.9,2,0.9,3.3c0,1.9-0.9,3.7-2.6,5.2 c-1.8,1.6-4.3,2.4-7.7,2.4c-2.8,0-4.9-0.6-6.3-1.8c-1.4-1.1-2.1-2.4-2.1-3.9c0-0.7,0.2-1.6,0.7-2.5c0.4-0.9,1.2-1.7,2.4-2.4 c1.3-0.7,2.7-1.2,4.1-1.5c1.4-0.2,2.6-0.3,3.5-0.4c-0.3-0.4-0.5-0.8-0.8-1.2c-0.3-0.4-0.4-0.9-0.4-1.5c0-0.4,0-0.6,0.2-0.9 c0.1-0.2,0.2-0.5,0.2-0.7c-0.5,0.1-0.9,0.1-1.3,0.1c-2.1,0-3.8-0.7-4.9-2c-1.2-1.2-1.8-2.7-1.8-4.3c0-2,0.8-3.8,2.5-5.4 c1.1-0.9,2.3-1.6,3.5-1.8c1.2-0.2,2.3-0.4,3.4-0.4h8L33,18.4h-2.5C30.7,18.6,31,18.8,31.3,19.1z M48,32h-4.3v4.2h-2.5V32H37v-2.5 h4.2v-4.3h2.5v4.3H48V32z M27.1,19.1c-0.6-0.5-1.4-0.7-2.2-0.7c-1.1,0-2,0.5-2.7,1.3c-0.6,0.9-0.9,1.9-0.9,3c0,1.5,0.4,3,1.3,4.5 c0.4,0.7,0.9,1.4,1.6,1.9c0.6,0.5,1.4,0.8,2.2,0.8c1.1,0,1.9-0.4,2.6-1.1c0.3-0.5,0.6-1,0.7-1.6c0.1-0.5,0.1-1,0.1-1.4 c0-1.6-0.4-3.2-1.2-4.8C28.2,20.2,27.7,19.5,27.1,19.1z M26.9,36.2c-0.2,0-0.7,0-1.6,0.1c-0.8,0.1-1.7,0.3-2.5,0.6 c-0.2,0.1-0.5,0.2-0.9,0.4c-0.4,0.2-0.7,0.4-1.1,0.7c-0.4,0.3-0.7,0.7-0.9,1.2c-0.3,0.5-0.4,1.1-0.4,1.8c0,1.4,0.6,2.6,1.9,3.5 c1.2,0.9,2.9,1.4,5,1.4c1.9,0,3.3-0.4,4.3-1.3c1-0.8,1.5-1.8,1.5-3.1c0-1-0.3-1.9-1-2.7c-0.7-0.7-1.8-1.6-3.3-2.6 C27.5,36.2,27.2,36.2,26.9,36.2z',
	    color: '#dd4b39'
	  },
	  linkedin: {
	    icon: 'M20.4,44h5.4V26.6h-5.4V44z M23.1,18c-1.7,0-3.1,1.4-3.1,3.1c0,1.7,1.4,3.1,3.1,3.1 c1.7,0,3.1-1.4,3.1-3.1C26.2,19.4,24.8,18,23.1,18z M39.5,26.2c-2.6,0-4.4,1.4-5.1,2.8h-0.1v-2.4h-5.2V44h5.4v-8.6 c0-2.3,0.4-4.5,3.2-4.5c2.8,0,2.8,2.6,2.8,4.6V44H46v-9.5C46,29.8,45,26.2,39.5,26.2z',
	    mask: 'M0,0v64h64V0H0z M25.8,44h-5.4V26.6h5.4V44z M23.1,24.3c-1.7,0-3.1-1.4-3.1-3.1c0-1.7,1.4-3.1,3.1-3.1 c1.7,0,3.1,1.4,3.1,3.1C26.2,22.9,24.8,24.3,23.1,24.3z M46,44h-5.4v-8.4c0-2,0-4.6-2.8-4.6c-2.8,0-3.2,2.2-3.2,4.5V44h-5.4V26.6 h5.2V29h0.1c0.7-1.4,2.5-2.8,5.1-2.8c5.5,0,6.5,3.6,6.5,8.3V44z',
	    color: '#007fb1'
	  },
	  email: {
	    icon: 'M17,22v20h30V22H17z M41.1,25L32,32.1L22.9,25H41.1z M20,39V26.6l12,9.3l12-9.3V39H20z',
	    mask: 'M41.1,25H22.9l9.1,7.1L41.1,25z M44,26.6l-12,9.3l-12-9.3V39h24V26.6z M0,0v64h64V0H0z M47,42H17V22h30V42z',
	    color: '#7f7f7f'
	  },
	  twitter: {
	    icon: 'M48,22.1c-1.2,0.5-2.4,0.9-3.8,1c1.4-0.8,2.4-2.1,2.9-3.6c-1.3,0.8-2.7,1.3-4.2,1.6 C41.7,19.8,40,19,38.2,19c-3.6,0-6.6,2.9-6.6,6.6c0,0.5,0.1,1,0.2,1.5c-5.5-0.3-10.3-2.9-13.5-6.9c-0.6,1-0.9,2.1-0.9,3.3 c0,2.3,1.2,4.3,2.9,5.5c-1.1,0-2.1-0.3-3-0.8c0,0,0,0.1,0,0.1c0,3.2,2.3,5.8,5.3,6.4c-0.6,0.1-1.1,0.2-1.7,0.2c-0.4,0-0.8,0-1.2-0.1 c0.8,2.6,3.3,4.5,6.1,4.6c-2.2,1.8-5.1,2.8-8.2,2.8c-0.5,0-1.1,0-1.6-0.1c2.9,1.9,6.4,2.9,10.1,2.9c12.1,0,18.7-10,18.7-18.7 c0-0.3,0-0.6,0-0.8C46,24.5,47.1,23.4,48,22.1z',
	    mask: 'M0,0v64h64V0H0z M44.7,25.5c0,0.3,0,0.6,0,0.8C44.7,35,38.1,45,26.1,45c-3.7,0-7.2-1.1-10.1-2.9 c0.5,0.1,1,0.1,1.6,0.1c3.1,0,5.9-1,8.2-2.8c-2.9-0.1-5.3-2-6.1-4.6c0.4,0.1,0.8,0.1,1.2,0.1c0.6,0,1.2-0.1,1.7-0.2 c-3-0.6-5.3-3.3-5.3-6.4c0,0,0-0.1,0-0.1c0.9,0.5,1.9,0.8,3,0.8c-1.8-1.2-2.9-3.2-2.9-5.5c0-1.2,0.3-2.3,0.9-3.3 c3.2,4,8.1,6.6,13.5,6.9c-0.1-0.5-0.2-1-0.2-1.5c0-3.6,2.9-6.6,6.6-6.6c1.9,0,3.6,0.8,4.8,2.1c1.5-0.3,2.9-0.8,4.2-1.6 c-0.5,1.5-1.5,2.8-2.9,3.6c1.3-0.2,2.6-0.5,3.8-1C47.1,23.4,46,24.5,44.7,25.5z',
	    color: '#00aced'
	  },
	  pinterest: {
	    icon: 'M32,16c-8.8,0-16,7.2-16,16c0,6.6,3.9,12.2,9.6,14.7c0-1.1,0-2.5,0.3-3.7 c0.3-1.3,2.1-8.7,2.1-8.7s-0.5-1-0.5-2.5c0-2.4,1.4-4.1,3.1-4.1c1.5,0,2.2,1.1,2.2,2.4c0,1.5-0.9,3.7-1.4,5.7 c-0.4,1.7,0.9,3.1,2.5,3.1c3,0,5.1-3.9,5.1-8.5c0-3.5-2.4-6.1-6.7-6.1c-4.9,0-7.9,3.6-7.9,7.7c0,1.4,0.4,2.4,1.1,3.1 c0.3,0.3,0.3,0.5,0.2,0.9c-0.1,0.3-0.3,1-0.3,1.3c-0.1,0.4-0.4,0.6-0.8,0.4c-2.2-0.9-3.3-3.4-3.3-6.1c0-4.5,3.8-10,11.4-10 c6.1,0,10.1,4.4,10.1,9.2c0,6.3-3.5,11-8.6,11c-1.7,0-3.4-0.9-3.9-2c0,0-0.9,3.7-1.1,4.4c-0.3,1.2-1,2.5-1.6,3.4 c1.4,0.4,3,0.7,4.5,0.7c8.8,0,16-7.2,16-16C48,23.2,40.8,16,32,16z',
	    mask: 'M0,0v64h64V0H0z M32,48c-1.6,0-3.1-0.2-4.5-0.7c0.6-1,1.3-2.2,1.6-3.4c0.2-0.7,1.1-4.4,1.1-4.4 c0.6,1.1,2.2,2,3.9,2c5.1,0,8.6-4.7,8.6-11c0-4.7-4-9.2-10.1-9.2c-7.6,0-11.4,5.5-11.4,10c0,2.8,1,5.2,3.3,6.1 c0.4,0.1,0.7,0,0.8-0.4c0.1-0.3,0.2-1,0.3-1.3c0.1-0.4,0.1-0.5-0.2-0.9c-0.6-0.8-1.1-1.7-1.1-3.1c0-4,3-7.7,7.9-7.7 c4.3,0,6.7,2.6,6.7,6.1c0,4.6-2,8.5-5.1,8.5c-1.7,0-2.9-1.4-2.5-3.1c0.5-2,1.4-4.2,1.4-5.7c0-1.3-0.7-2.4-2.2-2.4 c-1.7,0-3.1,1.8-3.1,4.1c0,1.5,0.5,2.5,0.5,2.5s-1.8,7.4-2.1,8.7c-0.3,1.2-0.3,2.6-0.3,3.7C19.9,44.2,16,38.6,16,32 c0-8.8,7.2-16,16-16c8.8,0,16,7.2,16,16C48,40.8,40.8,48,32,48z',
	    color: '#cb2128'
	  },
	  vk: {
	    icon: 'M44.94,44.84h-0.2c-2.17-.36-3.66-1.92-4.92-3.37C39.1,40.66,38,38.81,36.7,39c-1.85.3-.93,3.52-1.71,4.9-0.62,1.11-3.29.91-5.12,0.71-5.79-.62-8.75-3.77-11.35-7.14A64.13,64.13,0,0,1,11.6,26a10.59,10.59,0,0,1-1.51-4.49C11,20.7,12.56,21,14.11,21c1.31,0,3.36-.29,4.32.2C19,21.46,19.57,23,20,24a37.18,37.18,0,0,0,3.31,5.82c0.56,0.81,1.41,2.35,2.41,2.14s1.06-2.63,1.1-4.18c0-1.77,0-4-.5-4.9S25,22,24.15,21.47c0.73-1.49,2.72-1.63,5.12-1.63,2,0,4.84-.23,5.62,1.12s0.25,3.85.2,5.71c-0.06,2.09-.41,4.25,1,5.21,1.09-.12,1.68-1.2,2.31-2A28,28,0,0,0,41.72,24c0.44-1,.91-2.65,1.71-3,1.21-.47,3.15-0.1,4.92-0.1,1.46,0,4.05-.41,4.52.61,0.39,0.85-.75,3-1.1,3.57a61.88,61.88,0,0,1-4.12,5.61c-0.58.78-1.78,2-1.71,3.27,0.05,0.94,1,1.67,1.71,2.35a33.12,33.12,0,0,1,3.92,4.18c0.47,0.62,1.5,2,1.4,2.76C52.66,45.81,46.88,44.24,44.94,44.84Z',
	    mask: 'M0,0v64h64V0H0z M44.94,44.84h-0.2c-2.17-.36-3.66-1.92-4.92-3.37C39.1,40.66,38,38.81,36.7,39c-1.85.3-.93,3.52-1.71,4.9-0.62,1.11-3.29.91-5.12,0.71-5.79-.62-8.75-3.77-11.35-7.14A64.13,64.13,0,0,1,11.6,26a10.59,10.59,0,0,1-1.51-4.49C11,20.7,12.56,21,14.11,21c1.31,0,3.36-.29,4.32.2C19,21.46,19.57,23,20,24a37.18,37.18,0,0,0,3.31,5.82c0.56,0.81,1.41,2.35,2.41,2.14s1.06-2.63,1.1-4.18c0-1.77,0-4-.5-4.9S25,22,24.15,21.47c0.73-1.49,2.72-1.63,5.12-1.63,2,0,4.84-.23,5.62,1.12s0.25,3.85.2,5.71c-0.06,2.09-.41,4.25,1,5.21,1.09-.12,1.68-1.2,2.31-2A28,28,0,0,0,41.72,24c0.44-1,.91-2.65,1.71-3,1.21-.47,3.15-0.1,4.92-0.1,1.46,0,4.05-.41,4.52.61,0.39,0.85-.75,3-1.1,3.57a61.88,61.88,0,0,1-4.12,5.61c-0.58.78-1.78,2-1.71,3.27,0.05,0.94,1,1.67,1.71,2.35a33.12,33.12,0,0,1,3.92,4.18c0.47,0.62,1.5,2,1.4,2.76C52.66,45.81,46.88,44.24,44.94,44.84Z',
	    color: '#45668e'
	  },
	  ok: {
	    icon: 'M39,30c-1,0-3,2-7,2s-6-2-7-2c-1.1,0-2,0.9-2,2c0,1,0.6,1.5,1,1.7c1.2,0.7,5,2.3,5,2.3l-4.3,5.4   c0,0-0.8,0.9-0.8,1.6c0,1.1,0.9,2,2,2c1,0,1.5-0.7,1.5-0.7S32,39,32,39c0,0,4.5,5.3,4.5,5.3S37,45,38,45c1.1,0,2-0.9,2-2   c0-0.6-0.8-1.6-0.8-1.6L35,36c0,0,3.8-1.6,5-2.3c0.4-0.3,1-0.7,1-1.7C41,30.9,40.1,30,39,30z M32,15c-3.9,0-7,3.1-7,7s3.1,7,7,7c3.9,0,7-3.1,7-7S35.9,15,32,15z M32,25.5   c-1.9,0-3.5-1.6-3.5-3.5c0-1.9,1.6-3.5,3.5-3.5c1.9,0,3.5,1.6,3.5,3.5C35.5,23.9,33.9,22.5,35,22.5z ',
	    mask: 'M45,1H5C2.8,1,1,2.8,1,5v40c0,2.2,1.8,4,4,4h40c2.2,0,4-1.8,4-4V5C49,2.8,47.2,1,45,1z',
	    color: '#f2720c'
	  },
	  telegram: {
	    icon: 'm45.90873,15.44335c-0.6901,-0.0281 -1.37668,0.14048 -1.96142,0.41265c-0.84989,0.32661 -8.63939,3.33986 -16.5237,6.39174c-3.9685,1.53296 -7.93349,3.06593 -10.98537,4.24067c-3.05012,1.1765 -5.34694,2.05098 -5.4681,2.09312c-0.80775,0.28096 -1.89996,0.63566 -2.82712,1.72788c-0.23354,0.27218 -0.46884,0.62161 -0.58825,1.10275c-0.11941,0.48114 -0.06673,1.09222 0.16682,1.5716c0.46533,0.96052 1.25376,1.35737 2.18443,1.71383c3.09051,0.99037 6.28638,1.93508 8.93263,2.8236c0.97632,3.44171 1.91401,6.89571 2.84116,10.34268c0.30554,0.69185 0.97105,0.94823 1.65764,0.95525l-0.00351,0.03512c0,0 0.53908,0.05268 1.06412,-0.07375c0.52679,-0.12292 1.18879,-0.42846 1.79109,-0.99212c0.662,-0.62161 2.45836,-2.38812 3.47683,-3.38552l7.6736,5.66477l0.06146,0.03512c0,0 0.84989,0.59703 2.09312,0.68132c0.62161,0.04214 1.4399,-0.07726 2.14229,-0.59176c0.70766,-0.51626 1.1765,-1.34683 1.396,-2.29506c0.65673,-2.86224 5.00979,-23.57745 5.75257,-27.00686l-0.02107,0.08077c0.51977,-1.93157 0.32837,-3.70159 -0.87096,-4.74991c-0.60054,-0.52152 -1.2924,-0.7498 -1.98425,-0.77965l0,0.00176zm-0.2072,3.29069c0.04741,0.0439 0.0439,0.0439 0.00351,0.04741c-0.01229,-0.00351 0.14048,0.2072 -0.15804,1.32576l-0.01229,0.04214l-0.00878,0.03863c-0.75858,3.50668 -5.15554,24.40802 -5.74203,26.96472c-0.08077,0.34417 -0.11414,0.31959 -0.09482,0.29852c-0.1756,-0.02634 -0.50045,-0.16506 -0.52679,-0.1756l-13.13468,-9.70175c4.4988,-4.33199 9.09945,-8.25307 13.744,-12.43229c0.8218,-0.41265 0.68483,-1.68573 -0.29852,-1.70681c-1.04305,0.24584 -1.92279,0.99564 -2.8798,1.47502c-5.49971,3.2626 -11.11882,6.13186 -16.55882,9.49279c-2.792,-0.97105 -5.57873,-1.77704 -8.15298,-2.57601c2.2336,-0.89555 4.00889,-1.55579 5.75608,-2.23009c3.05188,-1.1765 7.01687,-2.7042 10.98537,-4.24067c7.94051,-3.06944 15.92667,-6.16346 16.62028,-6.43037l0.05619,-0.02283l0.05268,-0.02283c0.19316,-0.0878 0.30378,-0.09658 0.35471,-0.10009c0,0 -0.01756,-0.05795 -0.00351,-0.04566l-0.00176,0zm-20.91715,22.0638l2.16687,1.60145c-0.93418,0.91311 -1.81743,1.77353 -2.45485,2.38812l0.28798,-3.98957',
	    mask: 'M0,0v64h64V0H0z M32,48c-1.6,0-3.1-0.2-4.5-0.7c0.6-1,1.3-2.2,1.6-3.4c0.2-0.7,1.1-4.4,1.1-4.4 c0.6,1.1,2.2,2,3.9,2c5.1,0,8.6-4.7,8.6-11c0-4.7-4-9.2-10.1-9.2c-7.6,0-11.4,5.5-11.4,10c0,2.8,1,5.2,3.3,6.1 c0.4,0.1,0.7,0,0.8-0.4c0.1-0.3,0.2-1,0.3-1.3c0.1-0.4,0.1-0.5-0.2-0.9c-0.6-0.8-1.1-1.7-1.1-3.1c0-4,3-7.7,7.9-7.7 c4.3,0,6.7,2.6,6.7,6.1c0,4.6-2,8.5-5.1,8.5c-1.7,0-2.9-1.4-2.5-3.1c0.5-2,1.4-4.2,1.4-5.7c0-1.3-0.7-2.4-2.2-2.4 c-1.7,0-3.1,1.8-3.1,4.1c0,1.5,0.5,2.5,0.5,2.5s-1.8,7.4-2.1,8.7c-0.3,1.2-0.3,2.6-0.3,3.7C19.9,44.2,16,38.6,16,32 c0-8.8,7.2-16,16-16c8.8,0,16,7.2,16,16C48,40.8,40.8,48,32,48z',
	    color: '#37aee2'
	  },
	  whatsapp: {
	    icon: 'm42.32286,33.93287c-0.5178,-0.2589 -3.04726,-1.49644 -3.52105,-1.66732c-0.4712,-0.17346 -0.81554,-0.2589 -1.15987,0.2589c-0.34175,0.51004 -1.33075,1.66474 -1.63108,2.00648c-0.30032,0.33658 -0.60064,0.36247 -1.11327,0.12945c-0.5178,-0.2589 -2.17994,-0.80259 -4.14759,-2.56312c-1.53269,-1.37217 -2.56312,-3.05503 -2.86603,-3.57283c-0.30033,-0.5178 -0.03366,-0.80259 0.22524,-1.06149c0.23301,-0.23301 0.5178,-0.59547 0.7767,-0.90616c0.25372,-0.31068 0.33657,-0.5178 0.51262,-0.85437c0.17088,-0.36246 0.08544,-0.64725 -0.04402,-0.90615c-0.12945,-0.2589 -1.15987,-2.79613 -1.58964,-3.80584c-0.41424,-1.00971 -0.84142,-0.88027 -1.15987,-0.88027c-0.29773,-0.02588 -0.64208,-0.02588 -0.98382,-0.02588c-0.34693,0 -0.90616,0.12945 -1.37736,0.62136c-0.4712,0.5178 -1.80194,1.76053 -1.80194,4.27186c0,2.51134 1.84596,4.945 2.10227,5.30747c0.2589,0.33657 3.63497,5.51458 8.80262,7.74113c1.23237,0.5178 2.1903,0.82848 2.94111,1.08738c1.23237,0.38836 2.35599,0.33657 3.24402,0.20712c0.99159,-0.15534 3.04985,-1.24272 3.47963,-2.45956c0.44013,-1.21683 0.44013,-2.22654 0.31068,-2.45955c-0.12945,-0.23301 -0.46601,-0.36247 -0.98382,-0.59548m-9.40068,12.84407l-0.02589,0c-3.05503,0 -6.08417,-0.82849 -8.72495,-2.38189l-0.62136,-0.37023l-6.47252,1.68286l1.73463,-6.29129l-0.41424,-0.64725c-1.70875,-2.71846 -2.6149,-5.85116 -2.6149,-9.07706c0,-9.39809 7.68934,-17.06155 17.15993,-17.06155c4.58253,0 8.88029,1.78642 12.11655,5.02268c3.23625,3.21036 5.02267,7.50812 5.02267,12.06476c-0.0078,9.3981 -7.69712,17.06155 -17.14699,17.06155m14.58906,-31.58846c-3.93529,-3.80584 -9.1133,-5.95471 -14.62789,-5.95471c-11.36055,0 -20.60848,9.2065 -20.61625,20.52564c0,3.61684 0.94757,7.14565 2.75211,10.26282l-2.92557,10.63564l10.93337,-2.85309c3.0136,1.63108 6.4052,2.4958 9.85634,2.49839l0.01037,0c11.36574,0 20.61884,-9.2091 20.62403,-20.53082c0,-5.48093 -2.14111,-10.64081 -6.03239,-14.51915',
	    mask: 'M0,0v64h64V0H0z M32,48c-1.6,0-3.1-0.2-4.5-0.7c0.6-1,1.3-2.2,1.6-3.4c0.2-0.7,1.1-4.4,1.1-4.4 c0.6,1.1,2.2,2,3.9,2c5.1,0,8.6-4.7,8.6-11c0-4.7-4-9.2-10.1-9.2c-7.6,0-11.4,5.5-11.4,10c0,2.8,1,5.2,3.3,6.1 c0.4,0.1,0.7,0,0.8-0.4c0.1-0.3,0.2-1,0.3-1.3c0.1-0.4,0.1-0.5-0.2-0.9c-0.6-0.8-1.1-1.7-1.1-3.1c0-4,3-7.7,7.9-7.7 c4.3,0,6.7,2.6,6.7,6.1c0,4.6-2,8.5-5.1,8.5c-1.7,0-2.9-1.4-2.5-3.1c0.5-2,1.4-4.2,1.4-5.7c0-1.3-0.7-2.4-2.2-2.4 c-1.7,0-3.1,1.8-3.1,4.1c0,1.5,0.5,2.5,0.5,2.5s-1.8,7.4-2.1,8.7c-0.3,1.2-0.3,2.6-0.3,3.7C19.9,44.2,16,38.6,16,32 c0-8.8,7.2-16,16-16c8.8,0,16,7.2,16,16C48,40.8,40.8,48,32,48z',
	    color: '#2cb742'
	  },
	  reddit: {
	    icon: 'm 52.8165,31.942362 c 0,-2.4803 -2.0264,-4.4965 -4.5169,-4.4965 -1.2155,0 -2.3171,0.4862 -3.128,1.2682 -3.077,-2.0247 -7.2403,-3.3133 -11.8507,-3.4782 l 2.5211,-7.9373 6.8272,1.5997 -0.0102,0.0986 c 0,2.0281 1.6575,3.6771 3.6958,3.6771 2.0366,0 3.6924,-1.649 3.6924,-3.6771 0,-2.0281 -1.6575,-3.6788 -3.6924,-3.6788 -1.564,0 -2.8968,0.9758 -3.4357,2.3443 l -7.3593,-1.7255 c -0.3213,-0.0782 -0.6477,0.1071 -0.748,0.4233 L 32,25.212062 c -4.8246,0.0578 -9.1953,1.3566 -12.41,3.4425 -0.8058,-0.7446 -1.8751,-1.2104 -3.0583,-1.2104 -2.4905,0 -4.5152,2.0179 -4.5152,4.4982 0,1.649 0.9061,3.0787 2.2389,3.8607 -0.0884,0.4794 -0.1462,0.9639 -0.1462,1.4569 0,6.6487 8.1736,12.0581 18.2223,12.0581 10.0487,0 18.224,-5.4094 18.224,-12.0581 0,-0.4658 -0.0493,-0.9248 -0.1275,-1.377 1.4144,-0.7599 2.3885,-2.2304 2.3885,-3.9406 z m -29.2808,3.0872 c 0,-1.4756 1.207,-2.6775 2.6894,-2.6775 1.4824,0 2.6877,1.2019 2.6877,2.6775 0,1.4756 -1.2053,2.6758 -2.6877,2.6758 -1.4824,0 -2.6894,-1.2002 -2.6894,-2.6758 z m 15.4037,7.9373 c -1.3549,1.3481 -3.4816,2.0043 -6.5008,2.0043 l -0.0221,-0.0051 -0.0221,0.0051 c -3.0209,0 -5.1476,-0.6562 -6.5008,-2.0043 -0.2465,-0.2448 -0.2465,-0.6443 0,-0.8891 0.2465,-0.2465 0.6477,-0.2465 0.8942,0 1.105,1.0999 2.9393,1.6337 5.6066,1.6337 l 0.0221,0.0051 0.0221,-0.0051 c 2.6673,0 4.5016,-0.5355 5.6066,-1.6354 0.2465,-0.2465 0.6477,-0.2448 0.8942,0 0.2465,0.2465 0.2465,0.6443 0,0.8908 z m -0.3213,-5.2615 c -1.4824,0 -2.6877,-1.2002 -2.6877,-2.6758 0,-1.4756 1.2053,-2.6775 2.6877,-2.6775 1.4824,0 2.6877,1.2019 2.6877,2.6775 0,1.4756 -1.2053,2.6758 -2.6877,2.6758 z',
	    color: '#5f99cf'
	  },
	  tumblr: {
	    icon: 'M39.2,41c-0.6,0.3-1.6,0.5-2.4,0.5c-2.4,0.1-2.9-1.7-2.9-3v-9.3h6v-4.5h-6V17c0,0-4.3,0-4.4,0 c-0.1,0-0.2,0.1-0.2,0.2c-0.3,2.3-1.4,6.4-5.9,8.1v3.9h3V39c0,3.4,2.5,8.1,9,8c2.2,0,4.7-1,5.2-1.8L39.2,41z',
	    mask: 'M0,0v64h64V0H0z M35.4,47c-6.5,0.1-9-4.7-9-8v-9.8h-3v-3.9c4.6-1.6,5.6-5.7,5.9-8.1c0-0.2,0.1-0.2,0.2-0.2 c0.1,0,4.4,0,4.4,0v7.6h6v4.5h-6v9.3c0,1.3,0.5,3,2.9,3c0.8,0,1.9-0.3,2.4-0.5l1.4,4.3C40.1,46,37.6,47,35.4,47z',
	    color: '#2c4762'
	  },
	  livejournal: {
	    icon: 'M18.3407821,28.1764706 L21.9441341,31.789916 L33.0055865,42.882353 C33.0055865,42.882353 33.0893855,42.9663866 33.0893855,42.9663866 L46.6648046,47 C46.6648046,47 46.6648046,47 46.7486034,47 C46.8324022,47 46.8324022,47 46.9162012,46.9159664 C47,46.8319327 47,46.8319327 47,46.7478991 L42.9776536,33.1344537 C42.9776536,33.1344537 42.9776536,33.1344537 42.8938548,33.0504202 L31.1620111,21.3697479 L31.1620111,21.3697479 L28.1452514,18.2605042 C27.3072626,17.4201681 26.5530726,17 25.7150838,17 C24.2905028,17 23.0335195,18.3445378 21.5251397,19.8571429 C21.273743,20.1092437 20.9385475,20.4453781 20.6871508,20.697479 C20.3519553,21.0336134 20.1005586,21.2857143 19.849162,21.5378151 C18.3407821,22.9663866 17.0837989,24.2268908 17,25.7394958 C17.0837989,26.4957983 17.5027933,27.3361345 18.3407821,28.1764706 Z M39.9012319,39.6134454 C39.7336341,39.4453781 39.4822374,37.6806724 40.2364275,36.8403362 C40.9906174,36.0840337 41.6610084,36 42.1638017,36 C42.3313995,36 42.4989973,36 42.5827961,36 L44.8453659,43.5630253 L43.5883828,44.8235295 L36.0464833,42.5546218 C35.9626843,42.2184874 35.8788855,41.2100841 36.8844722,40.2016807 C37.2196676,39.8655463 37.8900587,39.6134454 38.5604498,39.6134454 C39.147042,39.6134454 39.5660364,39.7815126 39.5660364,39.7815126 C39.6498353,39.8655463 39.8174331,39.8655463 39.8174331,39.7815126 C39.9850307,39.7815126 39.9850307,39.697479 39.9012319,39.6134454 Z',
	    mask: 'M0,0v64h64V0H0z M35.4,47c-6.5,0.1-9-4.7-9-8v-9.8h-3v-3.9c4.6-1.6,5.6-5.7,5.9-8.1c0-0.2,0.1-0.2,0.2-0.2 c0.1,0,4.4,0,4.4,0v7.6h6v4.5h-6v9.3c0,1.3,0.5,3,2.9,3c0.8,0,1.9-0.3,2.4-0.5l1.4,4.3C40.1,46,37.6,47,35.4,47z',
	    color: '#21A5D8'
	  },
	  mailru: {
	    icon: 'M39.7107745,17 C41.6619755,17 43.3204965,18.732852 43.3204965,21.0072202 C43.3204965,23.2815885 41.7595357,25.0144404 39.7107745,25.0144404 C37.7595732,25.0144404 36.1010522,23.2815885 36.1010522,21.0072202 C36.1010522,18.732852 37.7595732,17 39.7107745,17 Z M24.3938451,17 C26.3450463,17 28.0035672,18.732852 28.0035672,21.0072202 C28.0035672,23.2815885 26.4426063,25.0144404 24.3938451,25.0144404 C22.4426439,25.0144404 20.7841229,23.2815885 20.7841229,21.0072202 C20.7841229,18.732852 22.4426439,17 24.3938451,17 Z M51.9057817,43.4259928 C51.7106617,44.0758123 51.4179815,44.6173285 50.9301812,44.9422383 C50.637501,45.1588448 50.2472607,45.267148 49.8570205,45.267148 C49.07654,45.267148 48.3936197,44.833935 48.0033795,44.0758123 L46.2472985,40.7184115 L45.759498,41.2599278 C42.5400162,44.9422383 37.466893,47 32.0035297,47 C26.5401664,47 21.5646034,44.9422383 18.2475614,41.2599278 L17.7597611,40.7184115 L16.00368,44.0758123 C15.6134398,44.833935 14.9305194,45.267148 14.1500389,45.267148 C13.7597986,45.267148 13.3695584,45.1588448 13.0768782,44.9422383 C12.0037176,44.2924187 11.7110374,42.7761733 12.2963978,41.5848375 L16.7841605,33.0288807 C17.1744007,32.270758 17.8573211,31.8375453 18.6378016,31.8375453 C19.0280418,31.8375453 19.4182821,31.9458485 19.7109623,32.1624548 C20.7841229,32.8122743 21.0768031,34.3285197 20.4914427,35.5198555 L20.1012025,36.2779783 L20.2963226,36.602888 C22.4426439,39.9602888 27.0279667,42.234657 31.9059697,42.234657 C36.7839727,42.234657 41.3692955,40.068592 43.5156167,36.602888 L43.7107367,36.2779783 L43.3204965,35.6281587 C43.0278165,35.0866425 42.9302562,34.436823 43.1253765,33.7870035 C43.3204965,33.137184 43.6131767,32.5956678 44.100977,32.270758 C44.3936572,32.0541515 44.7838975,31.9458485 45.1741377,31.9458485 C45.9546182,31.9458485 46.6375385,32.3790613 47.0277787,33.137184 L51.5155415,41.6931408 C52.003342,42.234657 52.100902,42.8844765 51.9057817,43.4259928 Z',
	    mask: 'M0,0v64h64V0H0z M35.4,47c-6.5,0.1-9-4.7-9-8v-9.8h-3v-3.9c4.6-1.6,5.6-5.7,5.9-8.1c0-0.2,0.1-0.2,0.2-0.2 c0.1,0,4.4,0,4.4,0v7.6h6v4.5h-6v9.3c0,1.3,0.5,3,2.9,3c0.8,0,1.9-0.3,2.4-0.5l1.4,4.3C40.1,46,37.6,47,35.4,47z',
	    color: '#168DE2'
	  }
	};
	/* eslint-enable max-len */

/***/ }),
/* 1975 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.shareCountGetters = exports.shareLinks = exports.ShareCounts = exports.ShareButtons = exports.generateShareIcon = undefined;
	
	var _generateIcon = __webpack_require__(1973);
	
	var _shareButtons = __webpack_require__(1976);
	
	var ShareButtons = _interopRequireWildcard(_shareButtons);
	
	var _shareCounts = __webpack_require__(1977);
	
	var ShareCounts = _interopRequireWildcard(_shareCounts);
	
	var _socialMediaShareLinks = __webpack_require__(762);
	
	var shareLinks = _interopRequireWildcard(_socialMediaShareLinks);
	
	var _shareCountGetters = __webpack_require__(761);
	
	var shareCountGetters = _interopRequireWildcard(_shareCountGetters);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	exports.generateShareIcon = _generateIcon.generateIcon;
	exports.ShareButtons = ShareButtons;
	exports.ShareCounts = ShareCounts;
	exports.shareLinks = shareLinks;
	exports.shareCountGetters = shareCountGetters;

/***/ }),
/* 1976 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.MailruShareButton = exports.LivejournalShareButton = exports.TumblrShareButton = exports.RedditShareButton = exports.OKShareButton = exports.VKShareButton = exports.PinterestShareButton = exports.LinkedinShareButton = exports.GooglePlusShareButton = exports.EmailShareButton = exports.WhatsappShareButton = exports.TelegramShareButton = exports.TwitterShareButton = exports.FacebookShareButton = undefined;
	
	var _extends2 = __webpack_require__(362);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(763);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(765);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(766);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(768);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(767);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _keys = __webpack_require__(764);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(246);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(11);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _socialMediaShareLinks = __webpack_require__(762);
	
	var links = _interopRequireWildcard(_socialMediaShareLinks);
	
	var _utils = __webpack_require__(361);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var supportedNetworks = (0, _keys2.default)(links); /* eslint-disable react/no-multi-comp */
	
	var ShareButton = function (_Component) {
	  (0, _inherits3.default)(ShareButton, _Component);
	
	  function ShareButton() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, ShareButton);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ShareButton.__proto__ || (0, _getPrototypeOf2.default)(ShareButton)).call.apply(_ref, [this].concat(args))), _this), _this.onClick = function (e) {
	      var _this$props = _this.props,
	          disabled = _this$props.disabled,
	          onClick = _this$props.onClick,
	          openWindow = _this$props.openWindow;
	
	
	      if (disabled) {
	        return;
	      }
	
	      e.preventDefault();
	
	      var link = _this.link();
	
	      if (openWindow) {
	        _this.openWindow(link);
	      }
	
	      if (onClick) {
	        onClick(link);
	      }
	    }, _this.onKeyPress = function (e) {
	      if (e.key === 'Enter' || e.key === 13) {
	        _this.onClick(e);
	      }
	    }, _this.openWindow = function (link) {
	      var _this$props2 = _this.props,
	          beforeOnClick = _this$props2.beforeOnClick,
	          onShareWindowClose = _this$props2.onShareWindowClose,
	          windowWidth = _this$props2.windowWidth,
	          windowHeight = _this$props2.windowHeight;
	
	
	      var windowOptions = {
	        height: windowHeight,
	        width: windowWidth
	      };
	
	      var windowOpenBound = function windowOpenBound() {
	        return (0, _utils.windowOpen)(link, windowOptions, onShareWindowClose);
	      };
	
	      if (beforeOnClick) {
	        var returnVal = beforeOnClick();
	
	        if ((0, _utils.isPromise)(returnVal)) {
	          returnVal.then(windowOpenBound);
	        } else {
	          windowOpenBound();
	        }
	      } else {
	        windowOpenBound();
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(ShareButton, [{
	    key: 'link',
	    value: function link() {
	      var _props = this.props,
	          url = _props.url,
	          opts = _props.opts,
	          network = _props.network;
	
	      return links[network](url, opts);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          additionalProps = _props2.additionalProps,
	          children = _props2.children,
	          className = _props2.className,
	          disabled = _props2.disabled,
	          disabledStyle = _props2.disabledStyle,
	          network = _props2.network,
	          role = _props2.role,
	          style = _props2.style,
	          tabIndex = _props2.tabIndex;
	
	
	      var classes = (0, _classnames2.default)('SocialMediaShareButton', 'SocialMediaShareButton--' + network, {
	        'SocialMediaShareButton--disabled': !!disabled,
	        disabled: !!disabled
	      }, className);
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, additionalProps, {
	          role: role,
	          tabIndex: tabIndex,
	          onClick: this.onClick,
	          onKeyPress: this.onKeyPress,
	          className: classes,
	          style: (0, _extends3.default)({}, style, disabled ? disabledStyle : {}) }),
	        children
	      );
	    }
	  }]);
	  return ShareButton;
	}(_react.Component);
	
	/* HOC to ease migration from v1 to v2.
	 * To-be-removed in v2.
	 */
	
	
	ShareButton.propTypes = {
	  additionalProps: _propTypes2.default.object,
	  children: _propTypes2.default.node,
	  className: _propTypes2.default.string,
	  disabled: _propTypes2.default.bool,
	  disabledStyle: _propTypes2.default.object,
	  network: _propTypes2.default.oneOf(supportedNetworks),
	  onClick: _propTypes2.default.func,
	  opts: _propTypes2.default.object,
	  openWindow: _propTypes2.default.bool,
	  url: _propTypes2.default.string.isRequired,
	  role: _propTypes2.default.string,
	  style: _propTypes2.default.object,
	  windowWidth: _propTypes2.default.number,
	  windowHeight: _propTypes2.default.number,
	  beforeOnClick: _propTypes2.default.func,
	  onShareWindowClose: _propTypes2.default.func,
	  tabIndex: _propTypes2.default.string
	};
	ShareButton.defaultProps = {
	  disabledStyle: {
	    opacity: 0.6
	  },
	  openWindow: true,
	  role: 'button',
	  tabIndex: '0'
	};
	exports.default = ShareButton;
	function createShareButton(network) {
	  var optsMap = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {
	    return {};
	  };
	  var propTypes = arguments[2];
	  var defaultProps = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	
	  var CreatedButton = function CreatedButton(props) {
	    return _react2.default.createElement(ShareButton, (0, _extends3.default)({}, props, {
	      network: network,
	      opts: optsMap(props) }));
	  };
	
	  CreatedButton.propTypes = propTypes;
	  CreatedButton.defaultProps = defaultProps;
	
	  return CreatedButton;
	}
	
	var FacebookShareButton = exports.FacebookShareButton = createShareButton('facebook', function (props) {
	  /* eslint-disable no-console */
	  if (props.picture) {
	    console.warn('FacebookShareButton warning: picture is a deprecated prop.');
	  }
	
	  if (props.title) {
	    console.warn('FacebookShareButton warning: title is a deprecated prop. Use "quote" instead.');
	  }
	
	  if (props.description) {
	    console.warn('FacebookShareButton warning: description is a deprecated prop.\n      Use "quote" instead.');
	  }
	  /* eslint-enable no-console */
	
	  return {
	    quote: props.quote,
	    hashtag: props.hashtag
	  };
	}, {
	  quote: _propTypes2.default.string,
	  hashtag: _propTypes2.default.string
	}, {
	  windowWidth: 550,
	  windowHeight: 400
	});
	
	var TwitterShareButton = exports.TwitterShareButton = createShareButton('twitter', function (props) {
	  return {
	    hashtags: props.hashtags,
	    title: props.title,
	    via: props.via
	  };
	}, {
	  hashtags: _propTypes2.default.arrayOf(_propTypes2.default.string),
	  title: _propTypes2.default.string,
	  via: _propTypes2.default.string
	}, {
	  windowWidth: 550,
	  windowHeight: 400
	});
	
	var TelegramShareButton = exports.TelegramShareButton = createShareButton('telegram', function (props) {
	  return {
	    title: props.title,
	    via: props.via
	  };
	}, {
	  title: _propTypes2.default.string,
	  via: _propTypes2.default.string
	}, {
	  windowWidth: 550,
	  windowHeight: 400
	});
	
	var WhatsappShareButton = exports.WhatsappShareButton = createShareButton('whatsapp', function (props) {
	  return {
	    title: props.title,
	    separator: props.separator
	  };
	}, {
	  title: _propTypes2.default.string,
	  separator: _propTypes2.default.string
	}, {
	  separator: ' ',
	  windowWidth: 550,
	  windowHeight: 400
	});
	
	var EmailShareButton = exports.EmailShareButton = createShareButton('email', function (props) {
	  return {
	    subject: props.subject,
	    body: props.body
	  };
	}, {
	  subject: _propTypes2.default.string,
	  body: _propTypes2.default.string
	}, {
	  openWindow: false,
	  onClick: function onClick(link) {
	    window.location.href = link;
	  }
	});
	
	var GooglePlusShareButton = exports.GooglePlusShareButton = createShareButton('googlePlus', undefined, undefined, {
	  windowWidth: 550,
	  windowHeight: 400
	});
	
	var LinkedinShareButton = exports.LinkedinShareButton = createShareButton('linkedin', function (props) {
	  return {
	    title: props.title,
	    description: props.description
	  };
	}, {
	  title: _propTypes2.default.string,
	  description: _propTypes2.default.string
	}, {
	  windowWidth: 750,
	  windowHeight: 600
	});
	
	var PinterestShareButton = exports.PinterestShareButton = createShareButton('pinterest', function (props) {
	  return {
	    media: props.media,
	    description: props.description
	  };
	}, {
	  media: _propTypes2.default.string.isRequired,
	  description: _propTypes2.default.string
	}, {
	  windowWidth: 1000,
	  windowHeight: 730
	});
	
	var VKShareButton = exports.VKShareButton = createShareButton('vk', function (props) {
	  return {
	    title: props.title,
	    description: props.description,
	    image: props.image
	  };
	}, {
	  title: _propTypes2.default.string,
	  description: _propTypes2.default.string,
	  image: _propTypes2.default.string
	}, {
	  windowWidth: 660,
	  windowHeight: 460
	});
	
	var OKShareButton = exports.OKShareButton = createShareButton('ok', function (props) {
	  return {
	    title: props.title,
	    description: props.description,
	    image: props.image
	  };
	}, {
	  title: _propTypes2.default.string,
	  description: _propTypes2.default.string,
	  image: _propTypes2.default.string
	}, {
	  windowWidth: 660,
	  windowHeight: 460
	});
	
	var RedditShareButton = exports.RedditShareButton = createShareButton('reddit', function (props) {
	  return {
	    title: props.title
	  };
	}, {
	  title: _propTypes2.default.string
	}, {
	  windowWidth: 660,
	  windowHeight: 460
	});
	
	var TumblrShareButton = exports.TumblrShareButton = createShareButton('tumblr', function (props) {
	  return {
	    title: props.title,
	    tags: props.tags.join(','),
	    caption: props.caption,
	    posttype: props.posttype
	  };
	}, {
	  title: _propTypes2.default.string,
	  caption: _propTypes2.default.string,
	  posttype: _propTypes2.default.string,
	  tags: _propTypes2.default.arrayOf(_propTypes2.default.string)
	}, {
	  tags: [],
	  posttype: 'link',
	  windowWidth: 660,
	  windowHeight: 460
	});
	
	var LivejournalShareButton = exports.LivejournalShareButton = createShareButton('livejournal', function (props) {
	  return {
	    title: props.title,
	    description: props.description
	  };
	}, {
	  title: _propTypes2.default.string,
	  description: _propTypes2.default.string
	}, {
	  windowWidth: 660,
	  windowHeight: 460
	});
	
	var MailruShareButton = exports.MailruShareButton = createShareButton('mailru', function (props) {
	  return {
	    title: props.title,
	    description: props.description,
	    image: props.image
	  };
	}, {
	  title: _propTypes2.default.string,
	  description: _propTypes2.default.string,
	  image: _propTypes2.default.string
	}, {
	  windowWidth: 660,
	  windowHeight: 460
	});

/***/ }),
/* 1977 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TwitterShareCount = exports.TumblrShareCount = exports.RedditShareCount = exports.OKShareCount = exports.VKShareCount = exports.PinterestShareCount = exports.GooglePlusShareCount = exports.LinkedinShareCount = exports.FacebookShareCount = undefined;
	
	var _extends2 = __webpack_require__(362);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(763);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(765);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(766);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(768);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(767);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(246);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(11);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _shareCountGetters = __webpack_require__(761);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable react/no-multi-comp */
	var SocialMediaShareCount = function (_Component) {
	  (0, _inherits3.default)(SocialMediaShareCount, _Component);
	
	  function SocialMediaShareCount(props) {
	    (0, _classCallCheck3.default)(this, SocialMediaShareCount);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (SocialMediaShareCount.__proto__ || (0, _getPrototypeOf2.default)(SocialMediaShareCount)).call(this, props));
	
	    _this._isMounted = false;
	    _this.state = { count: 0 };
	    return _this;
	  }
	
	  (0, _createClass3.default)(SocialMediaShareCount, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this._isMounted = true;
	      this.updateCount(this.props.url);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.url !== this.props.url) {
	        this.updateCount(nextProps.url);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this._isMounted = false;
	    }
	  }, {
	    key: 'updateCount',
	    value: function updateCount(url) {
	      var _this2 = this;
	
	      if (this.props.getCount) {
	        this.setState({
	          isLoading: true
	        });
	
	        this.props.getCount(url, function (count) {
	          if (_this2._isMounted) {
	            _this2.setState({
	              count: count,
	              isLoading: false
	            });
	          }
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          count = _state.count,
	          isLoading = _state.isLoading;
	      var _props = this.props,
	          children = _props.children,
	          className = _props.className;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('SocialMediaShareCount', className) },
	        !isLoading && children(count || 0)
	      );
	    }
	  }]);
	  return SocialMediaShareCount;
	}(_react.Component);
	
	SocialMediaShareCount.propTypes = {
	  children: _propTypes2.default.func,
	  className: _propTypes2.default.string,
	  getCount: _propTypes2.default.func,
	  url: _propTypes2.default.string.isRequired
	};
	
	SocialMediaShareCount.defaultProps = {
	  children: function children(shareCount) {
	    return shareCount;
	  }
	};
	
	function shareCountFactory(getCount) {
	  return function (props) {
	    return _react2.default.createElement(SocialMediaShareCount, (0, _extends3.default)({ getCount: getCount }, props));
	  };
	}
	
	var FacebookShareCount = exports.FacebookShareCount = shareCountFactory(_shareCountGetters.getFacebookShareCount);
	var LinkedinShareCount = exports.LinkedinShareCount = shareCountFactory(_shareCountGetters.getLinkedinShareCount);
	var GooglePlusShareCount = exports.GooglePlusShareCount = shareCountFactory(_shareCountGetters.getGooglePlusShareCount);
	var PinterestShareCount = exports.PinterestShareCount = shareCountFactory(_shareCountGetters.getPinterestShareCount);
	var VKShareCount = exports.VKShareCount = shareCountFactory(_shareCountGetters.getVKShareCount);
	var OKShareCount = exports.OKShareCount = shareCountFactory(_shareCountGetters.getOKShareCount);
	var RedditShareCount = exports.RedditShareCount = shareCountFactory(_shareCountGetters.getRedditShareCount);
	var TumblrShareCount = exports.TumblrShareCount = shareCountFactory(_shareCountGetters.getTumblrShareCount);
	var TwitterShareCount = exports.TwitterShareCount = function TwitterShareCount() {
	  throw new Error('TwitterShareCount was removed in version 1.3.0 because' + 'the Twitter API was shut down and there is no replacement. Please ' + 'remove it from your code.');
	};

/***/ }),
/* 1978 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1985), __esModule: true };

/***/ }),
/* 1979 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1986), __esModule: true };

/***/ }),
/* 1980 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1987), __esModule: true };

/***/ }),
/* 1981 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1988), __esModule: true };

/***/ }),
/* 1982 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1991), __esModule: true };

/***/ }),
/* 1983 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1992), __esModule: true };

/***/ }),
/* 1984 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1993), __esModule: true };

/***/ }),
/* 1985 */
/***/ (function(module, exports, __webpack_require__) {

	var core = __webpack_require__(42);
	var $JSON = core.JSON || (core.JSON = { stringify: JSON.stringify });
	module.exports = function stringify(it) { // eslint-disable-line no-unused-vars
	  return $JSON.stringify.apply($JSON, arguments);
	};


/***/ }),
/* 1986 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2011);
	module.exports = __webpack_require__(42).Object.assign;


/***/ }),
/* 1987 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2012);
	var $Object = __webpack_require__(42).Object;
	module.exports = function create(P, D) {
	  return $Object.create(P, D);
	};


/***/ }),
/* 1988 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2013);
	var $Object = __webpack_require__(42).Object;
	module.exports = function defineProperty(it, key, desc) {
	  return $Object.defineProperty(it, key, desc);
	};


/***/ }),
/* 1989 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2014);
	module.exports = __webpack_require__(42).Object.getPrototypeOf;


/***/ }),
/* 1990 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2015);
	module.exports = __webpack_require__(42).Object.keys;


/***/ }),
/* 1991 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2016);
	module.exports = __webpack_require__(42).Object.setPrototypeOf;


/***/ }),
/* 1992 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2019);
	__webpack_require__(2017);
	__webpack_require__(2020);
	__webpack_require__(2021);
	module.exports = __webpack_require__(42).Symbol;


/***/ }),
/* 1993 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2018);
	__webpack_require__(2022);
	module.exports = __webpack_require__(375).f('iterator');


/***/ }),
/* 1994 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};


/***/ }),
/* 1995 */
/***/ (function(module, exports) {

	module.exports = function () { /* empty */ };


/***/ }),
/* 1996 */
/***/ (function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(148);
	var toLength = __webpack_require__(2009);
	var toAbsoluteIndex = __webpack_require__(2008);
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};


/***/ }),
/* 1997 */
/***/ (function(module, exports, __webpack_require__) {

	// all enumerable object keys, includes symbols
	var getKeys = __webpack_require__(192);
	var gOPS = __webpack_require__(368);
	var pIE = __webpack_require__(259);
	module.exports = function (it) {
	  var result = getKeys(it);
	  var getSymbols = gOPS.f;
	  if (getSymbols) {
	    var symbols = getSymbols(it);
	    var isEnum = pIE.f;
	    var i = 0;
	    var key;
	    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
	  } return result;
	};


/***/ }),
/* 1998 */
/***/ (function(module, exports, __webpack_require__) {

	var document = __webpack_require__(97).document;
	module.exports = document && document.documentElement;


/***/ }),
/* 1999 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(769);
	module.exports = Array.isArray || function isArray(arg) {
	  return cof(arg) == 'Array';
	};


/***/ }),
/* 2000 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var create = __webpack_require__(367);
	var descriptor = __webpack_require__(260);
	var setToStringTag = __webpack_require__(369);
	var IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(146)(IteratorPrototype, __webpack_require__(149)('iterator'), function () { return this; });
	
	module.exports = function (Constructor, NAME, next) {
	  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
	  setToStringTag(Constructor, NAME + ' Iterator');
	};


/***/ }),
/* 2001 */
/***/ (function(module, exports) {

	module.exports = function (done, value) {
	  return { value: value, done: !!done };
	};


/***/ }),
/* 2002 */
/***/ (function(module, exports, __webpack_require__) {

	var META = __webpack_require__(261)('meta');
	var isObject = __webpack_require__(147);
	var has = __webpack_require__(115);
	var setDesc = __webpack_require__(116).f;
	var id = 0;
	var isExtensible = Object.isExtensible || function () {
	  return true;
	};
	var FREEZE = !__webpack_require__(145)(function () {
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function (it) {
	  setDesc(it, META, { value: {
	    i: 'O' + ++id, // object ID
	    w: {}          // weak collections IDs
	  } });
	};
	var fastKey = function (it, create) {
	  // return primitive with prefix
	  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return 'F';
	    // not necessary to add metadata
	    if (!create) return 'E';
	    // add missing metadata
	    setMeta(it);
	  // return object ID
	  } return it[META].i;
	};
	var getWeak = function (it, create) {
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return true;
	    // not necessary to add metadata
	    if (!create) return false;
	    // add missing metadata
	    setMeta(it);
	  // return hash weak collections IDs
	  } return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function (it) {
	  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY: META,
	  NEED: false,
	  fastKey: fastKey,
	  getWeak: getWeak,
	  onFreeze: onFreeze
	};


/***/ }),
/* 2003 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var DESCRIPTORS = __webpack_require__(96);
	var getKeys = __webpack_require__(192);
	var gOPS = __webpack_require__(368);
	var pIE = __webpack_require__(259);
	var toObject = __webpack_require__(193);
	var IObject = __webpack_require__(773);
	var $assign = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(145)(function () {
	  var A = {};
	  var B = {};
	  // eslint-disable-next-line no-undef
	  var S = Symbol();
	  var K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function (k) { B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
	  var T = toObject(target);
	  var aLen = arguments.length;
	  var index = 1;
	  var getSymbols = gOPS.f;
	  var isEnum = pIE.f;
	  while (aLen > index) {
	    var S = IObject(arguments[index++]);
	    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
	    var length = keys.length;
	    var j = 0;
	    var key;
	    while (length > j) {
	      key = keys[j++];
	      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
	    }
	  } return T;
	} : $assign;


/***/ }),
/* 2004 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(116);
	var anObject = __webpack_require__(191);
	var getKeys = __webpack_require__(192);
	
	module.exports = __webpack_require__(96) ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var keys = getKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};


/***/ }),
/* 2005 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(148);
	var gOPN = __webpack_require__(776).f;
	var toString = {}.toString;
	
	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function (it) {
	  try {
	    return gOPN(it);
	  } catch (e) {
	    return windowNames.slice();
	  }
	};
	
	module.exports.f = function getOwnPropertyNames(it) {
	  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
	};


/***/ }),
/* 2006 */
/***/ (function(module, exports, __webpack_require__) {

	// Works with __proto__ only. Old v8 can't work with null proto objects.
	/* eslint-disable no-proto */
	var isObject = __webpack_require__(147);
	var anObject = __webpack_require__(191);
	var check = function (O, proto) {
	  anObject(O);
	  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
	};
	module.exports = {
	  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
	    function (test, buggy, set) {
	      try {
	        set = __webpack_require__(770)(Function.call, __webpack_require__(775).f(Object.prototype, '__proto__').set, 2);
	        set(test, []);
	        buggy = !(test instanceof Array);
	      } catch (e) { buggy = true; }
	      return function setPrototypeOf(O, proto) {
	        check(O, proto);
	        if (buggy) O.__proto__ = proto;
	        else set(O, proto);
	        return O;
	      };
	    }({}, false) : undefined),
	  check: check
	};


/***/ }),
/* 2007 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(372);
	var defined = __webpack_require__(364);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function (TO_STRING) {
	  return function (that, pos) {
	    var s = String(defined(that));
	    var i = toInteger(pos);
	    var l = s.length;
	    var a, b;
	    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};


/***/ }),
/* 2008 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(372);
	var max = Math.max;
	var min = Math.min;
	module.exports = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};


/***/ }),
/* 2009 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(372);
	var min = Math.min;
	module.exports = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};


/***/ }),
/* 2010 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(1995);
	var step = __webpack_require__(2001);
	var Iterators = __webpack_require__(366);
	var toIObject = __webpack_require__(148);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(774)(Array, 'Array', function (iterated, kind) {
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var kind = this._k;
	  var index = this._i++;
	  if (!O || index >= O.length) {
	    this._t = undefined;
	    return step(1);
	  }
	  if (kind == 'keys') return step(0, index);
	  if (kind == 'values') return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');


/***/ }),
/* 2011 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(114);
	
	$export($export.S + $export.F, 'Object', { assign: __webpack_require__(2003) });


/***/ }),
/* 2012 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(114);
	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	$export($export.S, 'Object', { create: __webpack_require__(367) });


/***/ }),
/* 2013 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(114);
	// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	$export($export.S + $export.F * !__webpack_require__(96), 'Object', { defineProperty: __webpack_require__(116).f });


/***/ }),
/* 2014 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.9 Object.getPrototypeOf(O)
	var toObject = __webpack_require__(193);
	var $getPrototypeOf = __webpack_require__(777);
	
	__webpack_require__(779)('getPrototypeOf', function () {
	  return function getPrototypeOf(it) {
	    return $getPrototypeOf(toObject(it));
	  };
	});


/***/ }),
/* 2015 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 Object.keys(O)
	var toObject = __webpack_require__(193);
	var $keys = __webpack_require__(192);
	
	__webpack_require__(779)('keys', function () {
	  return function keys(it) {
	    return $keys(toObject(it));
	  };
	});


/***/ }),
/* 2016 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.19 Object.setPrototypeOf(O, proto)
	var $export = __webpack_require__(114);
	$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(2006).set });


/***/ }),
/* 2017 */
/***/ (function(module, exports) {



/***/ }),
/* 2018 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $at = __webpack_require__(2007)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(774)(String, 'String', function (iterated) {
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var index = this._i;
	  var point;
	  if (index >= O.length) return { value: undefined, done: true };
	  point = $at(O, index);
	  this._i += point.length;
	  return { value: point, done: false };
	});


/***/ }),
/* 2019 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// ECMAScript 6 symbols shim
	var global = __webpack_require__(97);
	var has = __webpack_require__(115);
	var DESCRIPTORS = __webpack_require__(96);
	var $export = __webpack_require__(114);
	var redefine = __webpack_require__(780);
	var META = __webpack_require__(2002).KEY;
	var $fails = __webpack_require__(145);
	var shared = __webpack_require__(371);
	var setToStringTag = __webpack_require__(369);
	var uid = __webpack_require__(261);
	var wks = __webpack_require__(149);
	var wksExt = __webpack_require__(375);
	var wksDefine = __webpack_require__(374);
	var enumKeys = __webpack_require__(1997);
	var isArray = __webpack_require__(1999);
	var anObject = __webpack_require__(191);
	var isObject = __webpack_require__(147);
	var toObject = __webpack_require__(193);
	var toIObject = __webpack_require__(148);
	var toPrimitive = __webpack_require__(373);
	var createDesc = __webpack_require__(260);
	var _create = __webpack_require__(367);
	var gOPNExt = __webpack_require__(2005);
	var $GOPD = __webpack_require__(775);
	var $GOPS = __webpack_require__(368);
	var $DP = __webpack_require__(116);
	var $keys = __webpack_require__(192);
	var gOPD = $GOPD.f;
	var dP = $DP.f;
	var gOPN = gOPNExt.f;
	var $Symbol = global.Symbol;
	var $JSON = global.JSON;
	var _stringify = $JSON && $JSON.stringify;
	var PROTOTYPE = 'prototype';
	var HIDDEN = wks('_hidden');
	var TO_PRIMITIVE = wks('toPrimitive');
	var isEnum = {}.propertyIsEnumerable;
	var SymbolRegistry = shared('symbol-registry');
	var AllSymbols = shared('symbols');
	var OPSymbols = shared('op-symbols');
	var ObjectProto = Object[PROTOTYPE];
	var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
	var QObject = global.QObject;
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function () {
	  return _create(dP({}, 'a', {
	    get: function () { return dP(this, 'a', { value: 7 }).a; }
	  })).a != 7;
	}) ? function (it, key, D) {
	  var protoDesc = gOPD(ObjectProto, key);
	  if (protoDesc) delete ObjectProto[key];
	  dP(it, key, D);
	  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
	} : dP;
	
	var wrap = function (tag) {
	  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
	  sym._k = tag;
	  return sym;
	};
	
	var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
	  return typeof it == 'symbol';
	} : function (it) {
	  return it instanceof $Symbol;
	};
	
	var $defineProperty = function defineProperty(it, key, D) {
	  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
	  anObject(it);
	  key = toPrimitive(key, true);
	  anObject(D);
	  if (has(AllSymbols, key)) {
	    if (!D.enumerable) {
	      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
	      D = _create(D, { enumerable: createDesc(0, false) });
	    } return setSymbolDesc(it, key, D);
	  } return dP(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P) {
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P));
	  var i = 0;
	  var l = keys.length;
	  var key;
	  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P) {
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key) {
	  var E = isEnum.call(this, key = toPrimitive(key, true));
	  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
	  it = toIObject(it);
	  key = toPrimitive(key, true);
	  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
	  var D = gOPD(it, key);
	  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it) {
	  var names = gOPN(toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
	  } return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
	  var IS_OP = it === ObjectProto;
	  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
	  } return result;
	};
	
	// 19.4.1.1 Symbol([description])
	if (!USE_NATIVE) {
	  $Symbol = function Symbol() {
	    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
	    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
	    var $set = function (value) {
	      if (this === ObjectProto) $set.call(OPSymbols, value);
	      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    };
	    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
	    return wrap(tag);
	  };
	  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
	    return this._k;
	  });
	
	  $GOPD.f = $getOwnPropertyDescriptor;
	  $DP.f = $defineProperty;
	  __webpack_require__(776).f = gOPNExt.f = $getOwnPropertyNames;
	  __webpack_require__(259).f = $propertyIsEnumerable;
	  $GOPS.f = $getOwnPropertySymbols;
	
	  if (DESCRIPTORS && !__webpack_require__(258)) {
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }
	
	  wksExt.f = function (name) {
	    return wrap(wks(name));
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });
	
	for (var es6Symbols = (
	  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
	).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);
	
	for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);
	
	$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function (key) {
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(sym) {
	    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
	    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
	  },
	  useSetter: function () { setter = true; },
	  useSimple: function () { setter = false; }
	});
	
	$export($export.S + $export.F * !USE_NATIVE, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});
	
	// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
	// https://bugs.chromium.org/p/v8/issues/detail?id=3443
	var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });
	
	$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
	  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
	    return $GOPS.f(toObject(it));
	  }
	});
	
	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
	})), 'JSON', {
	  stringify: function stringify(it) {
	    var args = [it];
	    var i = 1;
	    var replacer, $replacer;
	    while (arguments.length > i) args.push(arguments[i++]);
	    $replacer = replacer = args[1];
	    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
	    if (!isArray(replacer)) replacer = function (key, value) {
	      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
	      if (!isSymbol(value)) return value;
	    };
	    args[1] = replacer;
	    return _stringify.apply($JSON, args);
	  }
	});
	
	// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
	$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(146)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 2020 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(374)('asyncIterator');


/***/ }),
/* 2021 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(374)('observable');


/***/ }),
/* 2022 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2010);
	var global = __webpack_require__(97);
	var hide = __webpack_require__(146);
	var Iterators = __webpack_require__(366);
	var TO_STRING_TAG = __webpack_require__(149)('toStringTag');
	
	var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
	  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
	  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
	  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
	  'TextTrackList,TouchList').split(',');
	
	for (var i = 0; i < DOMIterables.length; i++) {
	  var NAME = DOMIterables[i];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	  Iterators[NAME] = Iterators.Array;
	}


/***/ }),
/* 2023 */,
/* 2024 */,
/* 2025 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _lodashLangIsString2 = __webpack_require__(1471);
	
	var _lodashLangIsString3 = _interopRequireDefault(_lodashLangIsString2);
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _youtubePlayer = __webpack_require__(2551);
	
	var _youtubePlayer2 = _interopRequireDefault(_youtubePlayer);
	
	var _isNumeric = __webpack_require__(1412);
	
	var _isNumeric2 = _interopRequireDefault(_isNumeric);
	
	/**
	 * @typedef {string} YoutubePlayer~playbackState
	 * @value 'unstarted' Stops and cancels loading of the current video. [stopVideo]{@link https://developers.google.com/youtube/iframe_api_reference#stopVideo}
	 * @value 'playing' Plays the currently cued/loaded video. [playVideo]{@link https://developers.google.com/youtube/iframe_api_reference#playVideo}
	 * @value 'paused' Pauses the currently playing video. [pauseVideo]{@link https://developers.google.com/youtube/iframe_api_reference#pauseVideo}
	 */
	
	/**
	 * @property {string} videoId
	 * @property {string|number} width (default: '100%').
	 * @property {string|number} height (default: '100%').
	 * @property {YoutubePlayer~playbackState} playbackState
	 * @property {Object} configuration Configuration parameters to be passed to the YouTube Player (known as `playerVars` in the YouTube Player API for iframe Embeds, https://developers.google.com/youtube/player_parameters?playerVersion=HTML5#Parameters).
	 */
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var ReactYoutubePlayer = (function (_React$Component) {
	    _inherits(ReactYoutubePlayer, _React$Component);
	
	    function ReactYoutubePlayer() {
	        var _this = this;
	
	        _classCallCheck(this, ReactYoutubePlayer);
	
	        _get(Object.getPrototypeOf(ReactYoutubePlayer.prototype), 'constructor', this).apply(this, arguments);
	
	        this.setRealPlaybackState = function (stateName) {
	            _this.realPlaybackState = stateName;
	        };
	
	        this.getRealPlaybackState = function () {
	            return _this.realPlaybackState;
	        };
	
	        this.bindEvent = function () {
	            _this.player.on('stateChange', function (event) {
	                var realPlaybackState = undefined;
	
	                _this.setRealPlaybackState(ReactYoutubePlayer.stateNames[event.data]);
	
	                realPlaybackState = _this.getRealPlaybackState();
	
	                if (realPlaybackState === 'ended') {
	                    _this.props.onEnd(event);
	                } else if (realPlaybackState === 'playing') {
	                    _this.props.onPlay(event);
	                } else if (realPlaybackState === 'paused') {
	                    _this.props.onPause(event);
	                } else if (realPlaybackState === 'buffering') {
	                    _this.props.onBuffer(event);
	                }
	            });
	
	            _this.player.on('error', function (event) {
	                _this.props.onError(event);
	            });
	        };
	
	        this.diffState = function (prevProps, nextProps) {
	            // console.log('prevProps', prevProps, 'nextProps', nextProps);
	
	            if (_this.realPlaybackState !== nextProps.playbackState && nextProps.playbackState) {
	                _this.setPlaybackState(nextProps.playbackState);
	            }
	
	            if (prevProps.videoId !== nextProps.videoId && nextProps.videoId) {
	                _this.cueVideoId(nextProps.videoId);
	            }
	
	            // console.log('prevProps.width !== nextProps.width', prevProps.width !== nextProps.width);
	
	            if (prevProps.width !== nextProps.width) {
	                _this.setViewportWidth(nextProps.width);
	            }
	
	            if (prevProps.height !== nextProps.height) {
	                _this.setViewportHeight(nextProps.height);
	            }
	        };
	
	        this.setPlaybackState = function (stateName) {
	            if (stateName === 'playing') {
	                _this.player.playVideo();
	            } else if (stateName === 'paused') {
	                _this.player.pauseVideo();
	            } else if (stateName === 'unstarted') {
	                _this.player.stopVideo();
	            } else {
	                throw new Error('Invalid playback state ("' + stateName + '").');
	            }
	        };
	
	        this.cueVideoId = function (videoId) {
	            // console.log('videoId', videoId);
	
	            if (!(0, _lodashLangIsString3['default'])(videoId)) {
	                throw new Error('videoId parameter must be a string.');
	            }
	
	            _this.player.cueVideoById(videoId);
	        };
	
	        this.setViewportWidth = function (width) {
	            _this.setDimension('width', width);
	        };
	
	        this.setViewportHeight = function (height) {
	            _this.setDimension('height', height);
	        };
	
	        this.setDimension = function (name, size) {
	            var formattedSize = undefined;
	
	            if (!size) {
	                _this.refs.player.style.removeProperty(name);
	            } else {
	                formattedSize = size;
	
	                if ((0, _isNumeric2['default'])(formattedSize)) {
	                    formattedSize += 'px';
	                }
	
	                _this.refs.viewport.style[name] = formattedSize;
	            }
	        };
	    }
	
	    _createClass(ReactYoutubePlayer, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.player = (0, _youtubePlayer2['default'])(this.refs.player, {
	                playerVars: this.props.configuration
	            });
	
	            this.bindEvent();
	
	            this.diffState({}, this.props);
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            this.diffState(this.props, nextProps);
	        }
	    }, {
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate() {
	            // console.log('shouldComponentUpdate', 'this.props', this.props);
	
	            return false;
	        }
	
	        /**
	         * State set using 'state' property can change, e.g.
	         * 'playing' will change to 'ended' at the end of the video.
	         * Read playback state reflects the current player state
	         * and is used to compare against the video player properties.
	         *
	         * @param {string} stateName
	         * @returns {undefined}
	         */
	    }, {
	        key: 'render',
	
	        /**
	         * @returns {ReactElement}
	         */
	        value: function render() {
	            var style = undefined;
	
	            style = {
	                width: '100%',
	                height: '100%',
	                display: 'block'
	            };
	
	            return _react2['default'].createElement(
	                'div',
	                { ref: 'viewport', style: style },
	                _react2['default'].createElement('div', { ref: 'player', style: style })
	            );
	        }
	    }], [{
	        key: 'stateNames',
	        value: {
	            '-1': 'unstarted',
	            0: 'ended',
	            1: 'playing',
	            2: 'paused',
	            3: 'buffering',
	            5: 'cued'
	        },
	        enumerable: true
	    }, {
	        key: 'propTypes',
	        value: {
	            // https://developers.google.com/youtube/iframe_api_reference#onReady
	            // onReady: React.PropTypes.func,
	
	            // https://developers.google.com/youtube/iframe_api_reference#onStateChange
	            // onStateChange: React.PropTypes.func,
	
	            // https://developers.google.com/youtube/iframe_api_reference#onPlaybackQualityChange
	            // onPlaybackQualityChange: React.PropTypes.func,
	
	            // https://developers.google.com/youtube/iframe_api_reference#onPlaybackRateChange
	            // onPlaybackRateChange: React.PropTypes.func,
	
	            // https://developers.google.com/youtube/iframe_api_reference#onApiChange
	            // onApiChange: React.PropTypes.func,
	
	            onBuffer: _react2['default'].PropTypes.func,
	
	            // https://developers.google.com/youtube/iframe_api_reference#onStateChange
	            onEnd: _react2['default'].PropTypes.func,
	            // https://developers.google.com/youtube/iframe_api_reference#onError
	            onError: _react2['default'].PropTypes.func,
	
	            onPause: _react2['default'].PropTypes.func,
	            onPlay: _react2['default'].PropTypes.func,
	
	            /* eslint-disable camelcase, id-match */
	            configuration: _react2['default'].PropTypes.shape({
	                autoplay: _react2['default'].PropTypes.oneOf([0, 1]),
	                cc_load_policy: _react2['default'].PropTypes.oneOf([0, 1]),
	                color: _react2['default'].PropTypes.oneOf(['red', 'white']),
	                controls: _react2['default'].PropTypes.oneOf([0, 1, 2]),
	                disablekb: _react2['default'].PropTypes.oneOf([0, 1]),
	                enablejsapi: _react2['default'].PropTypes.oneOf([0, 1]),
	                end: _react2['default'].PropTypes.number,
	                fs: _react2['default'].PropTypes.oneOf([0, 1]),
	                hl: _react2['default'].PropTypes.string,
	                iv_load_policy: _react2['default'].PropTypes.oneOf([1, 3]),
	                list: _react2['default'].PropTypes.oneOf(['search', 'user_uploads', 'playlist']),
	                listType: _react2['default'].PropTypes.oneOf(['playlist', 'search', 'user_uploads']),
	                loop: _react2['default'].PropTypes.oneOf([0, 1]),
	                modestbranding: _react2['default'].PropTypes.oneOf([0, 1]),
	                origin: _react2['default'].PropTypes.string,
	                playlist: _react2['default'].PropTypes.string,
	                playsinline: _react2['default'].PropTypes.oneOf([0, 1]),
	                rel: _react2['default'].PropTypes.oneOf([0, 1]),
	                showinfo: _react2['default'].PropTypes.oneOf([0, 1]),
	                start: _react2['default'].PropTypes.number,
	                theme: _react2['default'].PropTypes.oneOf(['dark', 'light'])
	            })
	            /* eslint-enable camelcase, id-match */
	        },
	        enumerable: true
	    }, {
	        key: 'defaultProps',
	        value: {
	            width: '100%',
	            height: '100%',
	            playbackState: 'unstarted',
	            configuration: {},
	            onEnd: function onEnd() {},
	            onPlay: function onPlay() {},
	            onPause: function onPause() {},
	            onBuffer: function onBuffer() {},
	            onError: function onError() {}
	        },
	        enumerable: true
	    }]);
	
	    return ReactYoutubePlayer;
	})(_react2['default'].Component);
	
	exports['default'] = ReactYoutubePlayer;
	module.exports = exports['default'];
	
	/**
	 * @returns {string}
	 */
	
	/**
	 * Used to map YouTube IFrame Player API events to the callbacks
	 * defined using the component instance properties.
	 *
	 * @returns {undefined}
	 */
	
	/**
	 * The complexity of the ReactYoutubePlayer is that it attempts to combine
	 * stateless properties with stateful player. This function is comparing
	 * the last known property value of a state with the last known state of the player.
	 * When these are different, it initiates an action that changes the player state, e.g.
	 * when the current "state" property is "play" and the last known player state is "pause",
	 * then setPlaybackState method will be called.
	 *
	 * @param {Object} prevProps
	 * @param {Object} nextProps
	 * @returns {undefined}
	 */
	
	/**
	 * @param {string} stateName
	 * @returns {undefined}
	 */
	
	/**
	 * @param {string} videoId
	 * @returns {undefined}
	 */
	
	/**
	 * Update element's width without calling the render method.
	 *
	 * @param {string|number} width
	 * @returns {undefined}
	 */
	
	/**
	 * Update element's height without calling the render method.
	 *
	 * @param {string|number} height
	 * @returns {undefined}
	 */
	
	/**
	 * @param {string} name
	 * @param {string|number} size
	 * @returns {undefined}
	 */
	//# sourceMappingURL=index.js.map


/***/ }),
/* 2026 */,
/* 2027 */,
/* 2028 */,
/* 2029 */,
/* 2030 */,
/* 2031 */,
/* 2032 */,
/* 2033 */,
/* 2034 */,
/* 2035 */,
/* 2036 */,
/* 2037 */,
/* 2038 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 * @providesModule ReactCSSTransitionGroup
	 */
	
	'use strict';
	
	var React = __webpack_require__(262);
	
	var assign = __webpack_require__(17);
	
	var ReactTransitionGroup = __webpack_require__(803);
	var ReactCSSTransitionGroupChild = __webpack_require__(2039);
	
	function createTransitionTimeoutPropValidator(transitionType) {
	  var timeoutPropName = 'transition' + transitionType + 'Timeout';
	  var enabledPropName = 'transition' + transitionType;
	
	  return function (props) {
	    // If the transition is enabled
	    if (props[enabledPropName]) {
	      // If no timeout duration is provided
	      if (props[timeoutPropName] == null) {
	        return new Error(timeoutPropName + ' wasn\'t supplied to ReactCSSTransitionGroup: ' + 'this can cause unreliable animations and won\'t be supported in ' + 'a future version of React. See ' + 'https://fb.me/react-animation-transition-group-timeout for more ' + 'information.');
	
	        // If the duration isn't a number
	      } else if (typeof props[timeoutPropName] !== 'number') {
	          return new Error(timeoutPropName + ' must be a number (in milliseconds)');
	        }
	    }
	  };
	}
	
	var ReactCSSTransitionGroup = React.createClass({
	  displayName: 'ReactCSSTransitionGroup',
	
	  propTypes: {
	    transitionName: ReactCSSTransitionGroupChild.propTypes.name,
	
	    transitionAppear: React.PropTypes.bool,
	    transitionEnter: React.PropTypes.bool,
	    transitionLeave: React.PropTypes.bool,
	    transitionAppearTimeout: createTransitionTimeoutPropValidator('Appear'),
	    transitionEnterTimeout: createTransitionTimeoutPropValidator('Enter'),
	    transitionLeaveTimeout: createTransitionTimeoutPropValidator('Leave')
	  },
	
	  getDefaultProps: function () {
	    return {
	      transitionAppear: false,
	      transitionEnter: true,
	      transitionLeave: true
	    };
	  },
	
	  _wrapChild: function (child) {
	    // We need to provide this childFactory so that
	    // ReactCSSTransitionGroupChild can receive updates to name, enter, and
	    // leave while it is leaving.
	    return React.createElement(ReactCSSTransitionGroupChild, {
	      name: this.props.transitionName,
	      appear: this.props.transitionAppear,
	      enter: this.props.transitionEnter,
	      leave: this.props.transitionLeave,
	      appearTimeout: this.props.transitionAppearTimeout,
	      enterTimeout: this.props.transitionEnterTimeout,
	      leaveTimeout: this.props.transitionLeaveTimeout
	    }, child);
	  },
	
	  render: function () {
	    return React.createElement(ReactTransitionGroup, assign({}, this.props, { childFactory: this._wrapChild }));
	  }
	});
	
	module.exports = ReactCSSTransitionGroup;

/***/ }),
/* 2039 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 * @providesModule ReactCSSTransitionGroupChild
	 */
	
	'use strict';
	
	var React = __webpack_require__(262);
	var ReactDOM = __webpack_require__(382);
	
	var CSSCore = __webpack_require__(1353);
	var ReactTransitionEvents = __webpack_require__(2062);
	
	var onlyChild = __webpack_require__(810);
	
	// We don't remove the element from the DOM until we receive an animationend or
	// transitionend event. If the user screws up and forgets to add an animation
	// their node will be stuck in the DOM forever, so we detect if an animation
	// does not start and if it doesn't, we just call the end listener immediately.
	var TICK = 17;
	
	var ReactCSSTransitionGroupChild = React.createClass({
	  displayName: 'ReactCSSTransitionGroupChild',
	
	  propTypes: {
	    name: React.PropTypes.oneOfType([React.PropTypes.string, React.PropTypes.shape({
	      enter: React.PropTypes.string,
	      leave: React.PropTypes.string,
	      active: React.PropTypes.string
	    }), React.PropTypes.shape({
	      enter: React.PropTypes.string,
	      enterActive: React.PropTypes.string,
	      leave: React.PropTypes.string,
	      leaveActive: React.PropTypes.string,
	      appear: React.PropTypes.string,
	      appearActive: React.PropTypes.string
	    })]).isRequired,
	
	    // Once we require timeouts to be specified, we can remove the
	    // boolean flags (appear etc.) and just accept a number
	    // or a bool for the timeout flags (appearTimeout etc.)
	    appear: React.PropTypes.bool,
	    enter: React.PropTypes.bool,
	    leave: React.PropTypes.bool,
	    appearTimeout: React.PropTypes.number,
	    enterTimeout: React.PropTypes.number,
	    leaveTimeout: React.PropTypes.number
	  },
	
	  transition: function (animationType, finishCallback, userSpecifiedDelay) {
	    var node = ReactDOM.findDOMNode(this);
	
	    if (!node) {
	      if (finishCallback) {
	        finishCallback();
	      }
	      return;
	    }
	
	    var className = this.props.name[animationType] || this.props.name + '-' + animationType;
	    var activeClassName = this.props.name[animationType + 'Active'] || className + '-active';
	    var timeout = null;
	
	    var endListener = function (e) {
	      if (e && e.target !== node) {
	        return;
	      }
	
	      clearTimeout(timeout);
	
	      CSSCore.removeClass(node, className);
	      CSSCore.removeClass(node, activeClassName);
	
	      ReactTransitionEvents.removeEndEventListener(node, endListener);
	
	      // Usually this optional callback is used for informing an owner of
	      // a leave animation and telling it to remove the child.
	      if (finishCallback) {
	        finishCallback();
	      }
	    };
	
	    CSSCore.addClass(node, className);
	
	    // Need to do this to actually trigger a transition.
	    this.queueClass(activeClassName);
	
	    // If the user specified a timeout delay.
	    if (userSpecifiedDelay) {
	      // Clean-up the animation after the specified delay
	      timeout = setTimeout(endListener, userSpecifiedDelay);
	      this.transitionTimeouts.push(timeout);
	    } else {
	      // DEPRECATED: this listener will be removed in a future version of react
	      ReactTransitionEvents.addEndEventListener(node, endListener);
	    }
	  },
	
	  queueClass: function (className) {
	    this.classNameQueue.push(className);
	
	    if (!this.timeout) {
	      this.timeout = setTimeout(this.flushClassNameQueue, TICK);
	    }
	  },
	
	  flushClassNameQueue: function () {
	    if (this.isMounted()) {
	      this.classNameQueue.forEach(CSSCore.addClass.bind(CSSCore, ReactDOM.findDOMNode(this)));
	    }
	    this.classNameQueue.length = 0;
	    this.timeout = null;
	  },
	
	  componentWillMount: function () {
	    this.classNameQueue = [];
	    this.transitionTimeouts = [];
	  },
	
	  componentWillUnmount: function () {
	    if (this.timeout) {
	      clearTimeout(this.timeout);
	    }
	    this.transitionTimeouts.forEach(function (timeout) {
	      clearTimeout(timeout);
	    });
	  },
	
	  componentWillAppear: function (done) {
	    if (this.props.appear) {
	      this.transition('appear', done, this.props.appearTimeout);
	    } else {
	      done();
	    }
	  },
	
	  componentWillEnter: function (done) {
	    if (this.props.enter) {
	      this.transition('enter', done, this.props.enterTimeout);
	    } else {
	      done();
	    }
	  },
	
	  componentWillLeave: function (done) {
	    if (this.props.leave) {
	      this.transition('leave', done, this.props.leaveTimeout);
	    } else {
	      done();
	    }
	  },
	
	  render: function () {
	    return onlyChild(this.props.children);
	  }
	});
	
	module.exports = ReactCSSTransitionGroupChild;

/***/ }),
/* 2040 */,
/* 2041 */,
/* 2042 */,
/* 2043 */,
/* 2044 */,
/* 2045 */,
/* 2046 */,
/* 2047 */,
/* 2048 */,
/* 2049 */,
/* 2050 */,
/* 2051 */,
/* 2052 */,
/* 2053 */,
/* 2054 */,
/* 2055 */,
/* 2056 */,
/* 2057 */,
/* 2058 */,
/* 2059 */,
/* 2060 */,
/* 2061 */,
/* 2062 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactTransitionEvents
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(34);
	
	/**
	 * EVENT_NAME_MAP is used to determine which event fired when a
	 * transition/animation ends, based on the style property used to
	 * define that event.
	 */
	var EVENT_NAME_MAP = {
	  transitionend: {
	    'transition': 'transitionend',
	    'WebkitTransition': 'webkitTransitionEnd',
	    'MozTransition': 'mozTransitionEnd',
	    'OTransition': 'oTransitionEnd',
	    'msTransition': 'MSTransitionEnd'
	  },
	
	  animationend: {
	    'animation': 'animationend',
	    'WebkitAnimation': 'webkitAnimationEnd',
	    'MozAnimation': 'mozAnimationEnd',
	    'OAnimation': 'oAnimationEnd',
	    'msAnimation': 'MSAnimationEnd'
	  }
	};
	
	var endEvents = [];
	
	function detectEvents() {
	  var testEl = document.createElement('div');
	  var style = testEl.style;
	
	  // On some platforms, in particular some releases of Android 4.x,
	  // the un-prefixed "animation" and "transition" properties are defined on the
	  // style object but the events that fire will still be prefixed, so we need
	  // to check if the un-prefixed events are useable, and if not remove them
	  // from the map
	  if (!('AnimationEvent' in window)) {
	    delete EVENT_NAME_MAP.animationend.animation;
	  }
	
	  if (!('TransitionEvent' in window)) {
	    delete EVENT_NAME_MAP.transitionend.transition;
	  }
	
	  for (var baseEventName in EVENT_NAME_MAP) {
	    var baseEvents = EVENT_NAME_MAP[baseEventName];
	    for (var styleName in baseEvents) {
	      if (styleName in style) {
	        endEvents.push(baseEvents[styleName]);
	        break;
	      }
	    }
	  }
	}
	
	if (ExecutionEnvironment.canUseDOM) {
	  detectEvents();
	}
	
	// We use the raw {add|remove}EventListener() call because EventListener
	// does not know how to remove event listeners and we really should
	// clean up. Also, these events are not triggered in older browsers
	// so we should be A-OK here.
	
	function addEventListener(node, eventName, eventListener) {
	  node.addEventListener(eventName, eventListener, false);
	}
	
	function removeEventListener(node, eventName, eventListener) {
	  node.removeEventListener(eventName, eventListener, false);
	}
	
	var ReactTransitionEvents = {
	  addEndEventListener: function (node, eventListener) {
	    if (endEvents.length === 0) {
	      // If CSS transitions are not supported, trigger an "end animation"
	      // event immediately.
	      window.setTimeout(eventListener, 0);
	      return;
	    }
	    endEvents.forEach(function (endEvent) {
	      addEventListener(node, endEvent, eventListener);
	    });
	  },
	
	  removeEndEventListener: function (node, eventListener) {
	    if (endEvents.length === 0) {
	      return;
	    }
	    endEvents.forEach(function (endEvent) {
	      removeEventListener(node, endEvent, eventListener);
	    });
	  }
	};
	
	module.exports = ReactTransitionEvents;

/***/ }),
/* 2063 */,
/* 2064 */,
/* 2065 */,
/* 2066 */,
/* 2067 */,
/* 2068 */,
/* 2069 */,
/* 2070 */,
/* 2071 */,
/* 2072 */,
/* 2073 */,
/* 2074 */,
/* 2075 */,
/* 2076 */,
/* 2077 */,
/* 2078 */,
/* 2079 */,
/* 2080 */,
/* 2081 */,
/* 2082 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	* @providesModule shallowCompare
	*/
	
	'use strict';
	
	var shallowEqual = __webpack_require__(330);
	
	/**
	 * Does a shallow comparison for props and state.
	 * See ReactComponentWithPureRenderMixin
	 */
	function shallowCompare(instance, nextProps, nextState) {
	  return !shallowEqual(instance.props, nextProps) || !shallowEqual(instance.state, nextState);
	}
	
	module.exports = shallowCompare;

/***/ }),
/* 2083 */,
/* 2084 */,
/* 2085 */,
/* 2086 */,
/* 2087 */,
/* 2088 */,
/* 2089 */,
/* 2090 */,
/* 2091 */,
/* 2092 */,
/* 2093 */,
/* 2094 */,
/* 2095 */,
/* 2096 */,
/* 2097 */,
/* 2098 */,
/* 2099 */,
/* 2100 */,
/* 2101 */,
/* 2102 */,
/* 2103 */,
/* 2104 */,
/* 2105 */,
/* 2106 */,
/* 2107 */,
/* 2108 */,
/* 2109 */,
/* 2110 */,
/* 2111 */,
/* 2112 */,
/* 2113 */,
/* 2114 */,
/* 2115 */,
/* 2116 */,
/* 2117 */,
/* 2118 */,
/* 2119 */,
/* 2120 */,
/* 2121 */,
/* 2122 */,
/* 2123 */,
/* 2124 */,
/* 2125 */,
/* 2126 */,
/* 2127 */,
/* 2128 */,
/* 2129 */,
/* 2130 */,
/* 2131 */,
/* 2132 */,
/* 2133 */,
/* 2134 */,
/* 2135 */,
/* 2136 */,
/* 2137 */,
/* 2138 */,
/* 2139 */,
/* 2140 */,
/* 2141 */,
/* 2142 */,
/* 2143 */,
/* 2144 */,
/* 2145 */,
/* 2146 */,
/* 2147 */,
/* 2148 */,
/* 2149 */,
/* 2150 */,
/* 2151 */,
/* 2152 */,
/* 2153 */,
/* 2154 */,
/* 2155 */,
/* 2156 */,
/* 2157 */,
/* 2158 */,
/* 2159 */,
/* 2160 */,
/* 2161 */,
/* 2162 */,
/* 2163 */,
/* 2164 */,
/* 2165 */,
/* 2166 */,
/* 2167 */,
/* 2168 */,
/* 2169 */,
/* 2170 */,
/* 2171 */,
/* 2172 */
/***/ (function(module, exports) {

	/*!
	* screenfull
	* v1.2.1 - 2014-05-11
	* (c) Sindre Sorhus; MIT License
	*/
	(function () {
		'use strict';
	
		var isCommonjs = typeof module !== 'undefined' && module.exports;
		var keyboardAllowed = typeof Element !== 'undefined' && 'ALLOW_KEYBOARD_INPUT' in Element;
		var isBrowser = typeof window !== 'undefined';
	
		var fn = (function () {
			var val;
			var valLength;
	
			var fnMap = [
				[
					'requestFullscreen',
					'exitFullscreen',
					'fullscreenElement',
					'fullscreenEnabled',
					'fullscreenchange',
					'fullscreenerror'
				],
				// new WebKit
				[
					'webkitRequestFullscreen',
					'webkitExitFullscreen',
					'webkitFullscreenElement',
					'webkitFullscreenEnabled',
					'webkitfullscreenchange',
					'webkitfullscreenerror'
	
				],
				// old WebKit (Safari 5.1)
				[
					'webkitRequestFullScreen',
					'webkitCancelFullScreen',
					'webkitCurrentFullScreenElement',
					'webkitCancelFullScreen',
					'webkitfullscreenchange',
					'webkitfullscreenerror'
	
				],
				[
					'mozRequestFullScreen',
					'mozCancelFullScreen',
					'mozFullScreenElement',
					'mozFullScreenEnabled',
					'mozfullscreenchange',
					'mozfullscreenerror'
				],
				[
					'msRequestFullscreen',
					'msExitFullscreen',
					'msFullscreenElement',
					'msFullscreenEnabled',
					'MSFullscreenChange',
					'MSFullscreenError'
				]
			];
	
			var i = 0;
			var l = fnMap.length;
			var ret = {};
	
			if (isBrowser) {
				for (; i < l; i++) {
					val = fnMap[i];
					if (val && val[1] in document) {
						for (i = 0, valLength = val.length; i < valLength; i++) {
							ret[fnMap[0][i]] = val[i];
						}
						return ret;
					}
				}
			}
	
			return false;
		})();
	
		var screenfull = {
			request: function (elem) {
				var request = fn.requestFullscreen;
	
				elem = elem || document.documentElement;
	
				// Work around Safari 5.1 bug: reports support for
				// keyboard in fullscreen even though it doesn't.
				// Browser sniffing, since the alternative with
				// setTimeout is even worse.
				if (/5\.1[\.\d]* Safari/.test(navigator.userAgent)) {
					elem[request]();
				} else {
					elem[request](keyboardAllowed && Element.ALLOW_KEYBOARD_INPUT);
				}
			},
			exit: function () {
				document[fn.exitFullscreen]();
			},
			toggle: function (elem) {
				if (this.isFullscreen) {
					this.exit();
				} else {
					this.request(elem);
				}
			},
			onchange: function () {},
			onerror: function () {},
			raw: fn
		};
	
		if (!fn) {
			if (isCommonjs) {
				module.exports = false;
			} else {
				window.screenfull = false;
			}
	
			return;
		}
	
		Object.defineProperties(screenfull, {
			isFullscreen: {
				get: function () {
					return !!document[fn.fullscreenElement];
				}
			},
			element: {
				enumerable: true,
				get: function () {
					return document[fn.fullscreenElement];
				}
			},
			enabled: {
				enumerable: true,
				get: function () {
					// Coerce to boolean in case of old WebKit
					return !!document[fn.fullscreenEnabled];
				}
			}
		});
	
		if (isBrowser) {
			document.addEventListener(fn.fullscreenchange, function (e) {
				screenfull.onchange.call(screenfull, e);
			});
	
			document.addEventListener(fn.fullscreenerror, function (e) {
				screenfull.onerror.call(screenfull, e);
			});
		}
	
		if (isCommonjs) {
			module.exports = screenfull;
		} else {
			window.screenfull = screenfull;
		}
	})();


/***/ }),
/* 2173 */,
/* 2174 */,
/* 2175 */,
/* 2176 */,
/* 2177 */,
/* 2178 */,
/* 2179 */,
/* 2180 */,
/* 2181 */
/***/ (function(module, exports) {

	'use strict';
	
	var Sister;
	
	/**
	* @link https://github.com/gajus/sister for the canonical source repository
	* @license https://github.com/gajus/sister/blob/master/LICENSE BSD 3-Clause
	*/
	Sister = function () {
	    var sister = {},
	        events = {};
	
	    /**
	     * @name handler
	     * @function
	     * @param {Object} data Event data.
	     */
	
	    /**
	     * @param {String} name Event name.
	     * @param {handler} handler
	     * @return {listener}
	     */
	    sister.on = function (name, handler) {
	        var listener = {name: name, handler: handler};
	        events[name] = events[name] || [];
	        events[name].unshift(listener);
	        return listener;
	    };
	
	    /**
	     * @param {listener}
	     */
	    sister.off = function (listener) {
	        var index = events[listener.name].indexOf(listener);
	
	        if (index !== -1) {
	            events[listener.name].splice(index, 1);
	        }
	    };
	
	    /**
	     * @param {String} name Event name.
	     * @param {Object} data Event data.
	     */
	    sister.trigger = function (name, data) {
	        var listeners = events[name],
	            i;
	
	        if (listeners) {
	            i = listeners.length;
	            while (i--) {
	                listeners[i].handler(data);
	            }
	        }
	    };
	
	    return sister;
	};
	
	module.exports = Sister;


/***/ }),
/* 2182 */,
/* 2183 */,
/* 2184 */,
/* 2185 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1278);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(13)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js!../../node_modules/autoprefixer-loader/index.js?browsers=last 2 version!../../node_modules/sass-loader/index.js?sourceMap&includePaths[]=/tmp/ppa-firebase/src/styles!./theme.scss", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js!../../node_modules/autoprefixer-loader/index.js?browsers=last 2 version!../../node_modules/sass-loader/index.js?sourceMap&includePaths[]=/tmp/ppa-firebase/src/styles!./theme.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2186 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1279);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(13)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js!../../node_modules/autoprefixer-loader/index.js?browsers=last 2 version!../../node_modules/sass-loader/index.js?sourceMap&includePaths[]=/tmp/ppa-firebase/src/styles!./theme.scss", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js!../../node_modules/autoprefixer-loader/index.js?browsers=last 2 version!../../node_modules/sass-loader/index.js?sourceMap&includePaths[]=/tmp/ppa-firebase/src/styles!./theme.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2187 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1280);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(13)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js!../../node_modules/autoprefixer-loader/index.js?browsers=last 2 version!../../node_modules/sass-loader/index.js?sourceMap&includePaths[]=/tmp/ppa-firebase/src/styles!./theme.scss", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js!../../node_modules/autoprefixer-loader/index.js?browsers=last 2 version!../../node_modules/sass-loader/index.js?sourceMap&includePaths[]=/tmp/ppa-firebase/src/styles!./theme.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2188 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1281);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(13)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js!../../node_modules/autoprefixer-loader/index.js?browsers=last 2 version!../../node_modules/sass-loader/index.js?sourceMap&includePaths[]=/tmp/ppa-firebase/src/styles!./theme.scss", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js!../../node_modules/autoprefixer-loader/index.js?browsers=last 2 version!../../node_modules/sass-loader/index.js?sourceMap&includePaths[]=/tmp/ppa-firebase/src/styles!./theme.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2189 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1282);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(13)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js!../../node_modules/autoprefixer-loader/index.js?browsers=last 2 version!../../node_modules/sass-loader/index.js?sourceMap&includePaths[]=/tmp/ppa-firebase/src/styles!./theme.scss", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js!../../node_modules/autoprefixer-loader/index.js?browsers=last 2 version!../../node_modules/sass-loader/index.js?sourceMap&includePaths[]=/tmp/ppa-firebase/src/styles!./theme.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2190 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1283);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(13)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js!../../node_modules/autoprefixer-loader/index.js?browsers=last 2 version!../../node_modules/sass-loader/index.js?sourceMap&includePaths[]=/tmp/ppa-firebase/src/styles!./theme.scss", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js!../../node_modules/autoprefixer-loader/index.js?browsers=last 2 version!../../node_modules/sass-loader/index.js?sourceMap&includePaths[]=/tmp/ppa-firebase/src/styles!./theme.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2191 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1284);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(13)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js!../../node_modules/autoprefixer-loader/index.js?browsers=last 2 version!../../node_modules/sass-loader/index.js?sourceMap&includePaths[]=/tmp/ppa-firebase/src/styles!./theme.scss", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js!../../node_modules/autoprefixer-loader/index.js?browsers=last 2 version!../../node_modules/sass-loader/index.js?sourceMap&includePaths[]=/tmp/ppa-firebase/src/styles!./theme.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2192 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1285);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(13)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js!../../node_modules/autoprefixer-loader/index.js?browsers=last 2 version!../../node_modules/sass-loader/index.js?sourceMap&includePaths[]=/tmp/ppa-firebase/src/styles!./theme.scss", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js!../../node_modules/autoprefixer-loader/index.js?browsers=last 2 version!../../node_modules/sass-loader/index.js?sourceMap&includePaths[]=/tmp/ppa-firebase/src/styles!./theme.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2193 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1286);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(13)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js!../../node_modules/autoprefixer-loader/index.js?browsers=last 2 version!../../node_modules/sass-loader/index.js?sourceMap&includePaths[]=/tmp/ppa-firebase/src/styles!./theme.scss", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js!../../node_modules/autoprefixer-loader/index.js?browsers=last 2 version!../../node_modules/sass-loader/index.js?sourceMap&includePaths[]=/tmp/ppa-firebase/src/styles!./theme.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2194 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1287);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(13)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js!../../node_modules/autoprefixer-loader/index.js?browsers=last 2 version!../../node_modules/sass-loader/index.js?sourceMap&includePaths[]=/tmp/ppa-firebase/src/styles!./intercom.scss", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js!../../node_modules/autoprefixer-loader/index.js?browsers=last 2 version!../../node_modules/sass-loader/index.js?sourceMap&includePaths[]=/tmp/ppa-firebase/src/styles!./intercom.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2195 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1288);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(13)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js!../../node_modules/autoprefixer-loader/index.js?browsers=last 2 version!../../node_modules/sass-loader/index.js?sourceMap&includePaths[]=/tmp/ppa-firebase/src/styles!./core.scss", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js!../../node_modules/autoprefixer-loader/index.js?browsers=last 2 version!../../node_modules/sass-loader/index.js?sourceMap&includePaths[]=/tmp/ppa-firebase/src/styles!./core.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2196 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1289);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(13)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/autoprefixer-loader/index.js?browsers=last 2 version!../../../node_modules/sass-loader/index.js?sourceMap&includePaths[]=/tmp/ppa-firebase/src/styles!./changeEmailModal.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/autoprefixer-loader/index.js?browsers=last 2 version!../../../node_modules/sass-loader/index.js?sourceMap&includePaths[]=/tmp/ppa-firebase/src/styles!./changeEmailModal.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2197 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1290);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(13)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/autoprefixer-loader/index.js?browsers=last 2 version!../../../node_modules/sass-loader/index.js?sourceMap&includePaths[]=/tmp/ppa-firebase/src/styles!./registerEditProfileForm.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/autoprefixer-loader/index.js?browsers=last 2 version!../../../node_modules/sass-loader/index.js?sourceMap&includePaths[]=/tmp/ppa-firebase/src/styles!./registerEditProfileForm.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2198 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1292);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(13)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/autoprefixer-loader/index.js?browsers=last 2 version!../../../node_modules/sass-loader/index.js?sourceMap&includePaths[]=/tmp/ppa-firebase/src/styles!./buyNowModal.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/autoprefixer-loader/index.js?browsers=last 2 version!../../../node_modules/sass-loader/index.js?sourceMap&includePaths[]=/tmp/ppa-firebase/src/styles!./buyNowModal.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2199 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1293);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(13)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/autoprefixer-loader/index.js?browsers=last 2 version!../../../node_modules/sass-loader/index.js?sourceMap&includePaths[]=/tmp/ppa-firebase/src/styles!./confirmAddClassModal.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/autoprefixer-loader/index.js?browsers=last 2 version!../../../node_modules/sass-loader/index.js?sourceMap&includePaths[]=/tmp/ppa-firebase/src/styles!./confirmAddClassModal.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2200 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1294);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(13)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/autoprefixer-loader/index.js?browsers=last 2 version!../../../node_modules/sass-loader/index.js?sourceMap&includePaths[]=/tmp/ppa-firebase/src/styles!./homeDashboard.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/autoprefixer-loader/index.js?browsers=last 2 version!../../../node_modules/sass-loader/index.js?sourceMap&includePaths[]=/tmp/ppa-firebase/src/styles!./homeDashboard.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2201 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1295);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(13)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/autoprefixer-loader/index.js?browsers=last 2 version!../../../node_modules/sass-loader/index.js?sourceMap&includePaths[]=/tmp/ppa-firebase/src/styles!./sessionList.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/autoprefixer-loader/index.js?browsers=last 2 version!../../../node_modules/sass-loader/index.js?sourceMap&includePaths[]=/tmp/ppa-firebase/src/styles!./sessionList.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2202 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1296);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(13)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/autoprefixer-loader/index.js?browsers=last 2 version!../../../node_modules/sass-loader/index.js?sourceMap&includePaths[]=/tmp/ppa-firebase/src/styles!./sessionPanel.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/autoprefixer-loader/index.js?browsers=last 2 version!../../../node_modules/sass-loader/index.js?sourceMap&includePaths[]=/tmp/ppa-firebase/src/styles!./sessionPanel.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2203 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1297);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(13)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/autoprefixer-loader/index.js?browsers=last 2 version!../../../node_modules/sass-loader/index.js?sourceMap&includePaths[]=/tmp/ppa-firebase/src/styles!./startFromLastSlideModal.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/autoprefixer-loader/index.js?browsers=last 2 version!../../../node_modules/sass-loader/index.js?sourceMap&includePaths[]=/tmp/ppa-firebase/src/styles!./startFromLastSlideModal.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2204 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1298);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(13)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js!../../node_modules/autoprefixer-loader/index.js?browsers=last 2 version!../../node_modules/sass-loader/index.js?sourceMap&includePaths[]=/tmp/ppa-firebase/src/styles!./footer.scss", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js!../../node_modules/autoprefixer-loader/index.js?browsers=last 2 version!../../node_modules/sass-loader/index.js?sourceMap&includePaths[]=/tmp/ppa-firebase/src/styles!./footer.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2205 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1299);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(13)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/autoprefixer-loader/index.js?browsers=last 2 version!../../../../node_modules/sass-loader/index.js?sourceMap&includePaths[]=/tmp/ppa-firebase/src/styles!./exit.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/autoprefixer-loader/index.js?browsers=last 2 version!../../../../node_modules/sass-loader/index.js?sourceMap&includePaths[]=/tmp/ppa-firebase/src/styles!./exit.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2206 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1300);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(13)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/autoprefixer-loader/index.js?browsers=last 2 version!../../../../node_modules/sass-loader/index.js?sourceMap&includePaths[]=/tmp/ppa-firebase/src/styles!./fun.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/autoprefixer-loader/index.js?browsers=last 2 version!../../../../node_modules/sass-loader/index.js?sourceMap&includePaths[]=/tmp/ppa-firebase/src/styles!./fun.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2207 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1301);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(13)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/autoprefixer-loader/index.js?browsers=last 2 version!../../../node_modules/sass-loader/index.js?sourceMap&includePaths[]=/tmp/ppa-firebase/src/styles!./hud.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/autoprefixer-loader/index.js?browsers=last 2 version!../../../node_modules/sass-loader/index.js?sourceMap&includePaths[]=/tmp/ppa-firebase/src/styles!./hud.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2208 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1302);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(13)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/autoprefixer-loader/index.js?browsers=last 2 version!../../../../node_modules/sass-loader/index.js?sourceMap&includePaths[]=/tmp/ppa-firebase/src/styles!./overview.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/autoprefixer-loader/index.js?browsers=last 2 version!../../../../node_modules/sass-loader/index.js?sourceMap&includePaths[]=/tmp/ppa-firebase/src/styles!./overview.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2209 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1303);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(13)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/autoprefixer-loader/index.js?browsers=last 2 version!../../../../node_modules/sass-loader/index.js?sourceMap&includePaths[]=/tmp/ppa-firebase/src/styles!./scores.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/autoprefixer-loader/index.js?browsers=last 2 version!../../../../node_modules/sass-loader/index.js?sourceMap&includePaths[]=/tmp/ppa-firebase/src/styles!./scores.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2210 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1304);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(13)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/autoprefixer-loader/index.js?browsers=last 2 version!../../../node_modules/sass-loader/index.js?sourceMap&includePaths[]=/tmp/ppa-firebase/src/styles!./teacherRemote.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/autoprefixer-loader/index.js?browsers=last 2 version!../../../node_modules/sass-loader/index.js?sourceMap&includePaths[]=/tmp/ppa-firebase/src/styles!./teacherRemote.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2211 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1305);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(13)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/autoprefixer-loader/index.js?browsers=last 2 version!../../../node_modules/sass-loader/index.js?sourceMap&includePaths[]=/tmp/ppa-firebase/src/styles!./invite.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/autoprefixer-loader/index.js?browsers=last 2 version!../../../node_modules/sass-loader/index.js?sourceMap&includePaths[]=/tmp/ppa-firebase/src/styles!./invite.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2212 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1306);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(13)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/autoprefixer-loader/index.js?browsers=last 2 version!../../../node_modules/sass-loader/index.js?sourceMap&includePaths[]=/tmp/ppa-firebase/src/styles!./homeLanding.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/autoprefixer-loader/index.js?browsers=last 2 version!../../../node_modules/sass-loader/index.js?sourceMap&includePaths[]=/tmp/ppa-firebase/src/styles!./homeLanding.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2213 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1307);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(13)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js!../../node_modules/autoprefixer-loader/index.js?browsers=last 2 version!../../node_modules/sass-loader/index.js?sourceMap&includePaths[]=/tmp/ppa-firebase/src/styles!./navBar.scss", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js!../../node_modules/autoprefixer-loader/index.js?browsers=last 2 version!../../node_modules/sass-loader/index.js?sourceMap&includePaths[]=/tmp/ppa-firebase/src/styles!./navBar.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2214 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1308);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(13)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/autoprefixer-loader/index.js?browsers=last 2 version!../../../../../node_modules/sass-loader/index.js?sourceMap&includePaths[]=/tmp/ppa-firebase/src/styles!./completeLevelModal.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/autoprefixer-loader/index.js?browsers=last 2 version!../../../../../node_modules/sass-loader/index.js?sourceMap&includePaths[]=/tmp/ppa-firebase/src/styles!./completeLevelModal.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2215 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1309);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(13)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/autoprefixer-loader/index.js?browsers=last 2 version!../../../../../node_modules/sass-loader/index.js?sourceMap&includePaths[]=/tmp/ppa-firebase/src/styles!./hacked.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/autoprefixer-loader/index.js?browsers=last 2 version!../../../../../node_modules/sass-loader/index.js?sourceMap&includePaths[]=/tmp/ppa-firebase/src/styles!./hacked.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2216 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1310);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(13)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/autoprefixer-loader/index.js?browsers=last 2 version!../../../../../node_modules/sass-loader/index.js?sourceMap&includePaths[]=/tmp/ppa-firebase/src/styles!./missionReport.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/autoprefixer-loader/index.js?browsers=last 2 version!../../../../../node_modules/sass-loader/index.js?sourceMap&includePaths[]=/tmp/ppa-firebase/src/styles!./missionReport.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2217 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1311);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(13)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/autoprefixer-loader/index.js?browsers=last 2 version!../../../../../node_modules/sass-loader/index.js?sourceMap&includePaths[]=/tmp/ppa-firebase/src/styles!./onboarding.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/autoprefixer-loader/index.js?browsers=last 2 version!../../../../../node_modules/sass-loader/index.js?sourceMap&includePaths[]=/tmp/ppa-firebase/src/styles!./onboarding.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2218 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1313);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(13)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/autoprefixer-loader/index.js?browsers=last 2 version!../../../../../node_modules/sass-loader/index.js?sourceMap&includePaths[]=/tmp/ppa-firebase/src/styles!./startFromLastSlideModal.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/autoprefixer-loader/index.js?browsers=last 2 version!../../../../../node_modules/sass-loader/index.js?sourceMap&includePaths[]=/tmp/ppa-firebase/src/styles!./startFromLastSlideModal.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2219 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1314);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(13)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/autoprefixer-loader/index.js?browsers=last 2 version!../../../../../node_modules/sass-loader/index.js?sourceMap&includePaths[]=/tmp/ppa-firebase/src/styles!./startLevel.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/autoprefixer-loader/index.js?browsers=last 2 version!../../../../../node_modules/sass-loader/index.js?sourceMap&includePaths[]=/tmp/ppa-firebase/src/styles!./startLevel.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2220 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1315);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(13)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/autoprefixer-loader/index.js?browsers=last 2 version!../../../../../node_modules/sass-loader/index.js?sourceMap&includePaths[]=/tmp/ppa-firebase/src/styles!./teamNames.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/autoprefixer-loader/index.js?browsers=last 2 version!../../../../../node_modules/sass-loader/index.js?sourceMap&includePaths[]=/tmp/ppa-firebase/src/styles!./teamNames.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2221 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1316);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(13)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/autoprefixer-loader/index.js?browsers=last 2 version!../../../../../../node_modules/sass-loader/index.js?sourceMap&includePaths[]=/tmp/ppa-firebase/src/styles!./deck.scss", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/autoprefixer-loader/index.js?browsers=last 2 version!../../../../../../node_modules/sass-loader/index.js?sourceMap&includePaths[]=/tmp/ppa-firebase/src/styles!./deck.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2222 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1317);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(13)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/autoprefixer-loader/index.js?browsers=last 2 version!../../../node_modules/sass-loader/index.js?sourceMap&includePaths[]=/tmp/ppa-firebase/src/styles!./assignContracts.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/autoprefixer-loader/index.js?browsers=last 2 version!../../../node_modules/sass-loader/index.js?sourceMap&includePaths[]=/tmp/ppa-firebase/src/styles!./assignContracts.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2223 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1318);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(13)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/autoprefixer-loader/index.js?browsers=last 2 version!../../../node_modules/sass-loader/index.js?sourceMap&includePaths[]=/tmp/ppa-firebase/src/styles!./search.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/autoprefixer-loader/index.js?browsers=last 2 version!../../../node_modules/sass-loader/index.js?sourceMap&includePaths[]=/tmp/ppa-firebase/src/styles!./search.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2224 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1319);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(13)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/autoprefixer-loader/index.js?browsers=last 2 version!../../../node_modules/sass-loader/index.js?sourceMap&includePaths[]=/tmp/ppa-firebase/src/styles!./sessionPanel.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/autoprefixer-loader/index.js?browsers=last 2 version!../../../node_modules/sass-loader/index.js?sourceMap&includePaths[]=/tmp/ppa-firebase/src/styles!./sessionPanel.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2225 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1320);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(13)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js!../../node_modules/autoprefixer-loader/index.js?browsers=last 2 version!../../node_modules/sass-loader/index.js?sourceMap&includePaths[]=/tmp/ppa-firebase/src/styles!./subscribe.scss", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js!../../node_modules/autoprefixer-loader/index.js?browsers=last 2 version!../../node_modules/sass-loader/index.js?sourceMap&includePaths[]=/tmp/ppa-firebase/src/styles!./subscribe.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2226 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1321);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(13)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js!../../node_modules/autoprefixer-loader/index.js?browsers=last 2 version!../../node_modules/sass-loader/index.js?sourceMap&includePaths[]=/tmp/ppa-firebase/src/styles!./subscribed.scss", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js!../../node_modules/autoprefixer-loader/index.js?browsers=last 2 version!../../node_modules/sass-loader/index.js?sourceMap&includePaths[]=/tmp/ppa-firebase/src/styles!./subscribed.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2227 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1322);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(13)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js!../../node_modules/autoprefixer-loader/index.js?browsers=last 2 version!../../node_modules/sass-loader/index.js?sourceMap&includePaths[]=/tmp/ppa-firebase/src/styles!./unsubscribe.scss", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js!../../node_modules/autoprefixer-loader/index.js?browsers=last 2 version!../../node_modules/sass-loader/index.js?sourceMap&includePaths[]=/tmp/ppa-firebase/src/styles!./unsubscribe.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2228 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1323);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(13)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js!../../node_modules/autoprefixer-loader/index.js?browsers=last 2 version!../../node_modules/sass-loader/index.js?sourceMap&includePaths[]=/tmp/ppa-firebase/src/styles!./unsubscribed.scss", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js!../../node_modules/autoprefixer-loader/index.js?browsers=last 2 version!../../node_modules/sass-loader/index.js?sourceMap&includePaths[]=/tmp/ppa-firebase/src/styles!./unsubscribed.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2229 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1324);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(13)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../css-loader/index.js!./input-moment.css", function() {
				var newContent = require("!!../../css-loader/index.js!./input-moment.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2230 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1325);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(13)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../css-loader/index.js!./normalize.css", function() {
				var newContent = require("!!../css-loader/index.js!./normalize.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2231 */,
/* 2232 */,
/* 2233 */
/***/ (function(module, exports) {

	
	module.exports = function () {
	  var selection = document.getSelection();
	  if (!selection.rangeCount) {
	    return function () {};
	  }
	  var active = document.activeElement;
	
	  var ranges = [];
	  for (var i = 0; i < selection.rangeCount; i++) {
	    ranges.push(selection.getRangeAt(i));
	  }
	
	  switch (active.tagName.toUpperCase()) { // .toUpperCase handles XHTML
	    case 'INPUT':
	    case 'TEXTAREA':
	      active.blur();
	      break;
	
	    default:
	      active = null;
	      break;
	  }
	
	  selection.removeAllRanges();
	  return function () {
	    selection.type === 'Caret' &&
	    selection.removeAllRanges();
	
	    if (!selection.rangeCount) {
	      ranges.forEach(function(range) {
	        selection.addRange(range);
	      });
	    }
	
	    active &&
	    active.focus();
	  };
	};


/***/ }),
/* 2234 */
/***/ (function(module, exports) {

	'use strict'
	
	module.exports = trimLines
	
	var ws = /[ \t]*\n+[ \t]*/g
	var newline = '\n'
	
	function trimLines(value) {
	  return String(value).replace(ws, newline)
	}


/***/ }),
/* 2235 */
/***/ (function(module, exports) {

	'use strict'
	
	module.exports = trimTrailingLines
	
	// Remove final newline characters from `value`.
	function trimTrailingLines(value) {
	  return String(value).replace(/\n+$/, '')
	}


/***/ }),
/* 2236 */
/***/ (function(module, exports) {

	'use strict';
	
	// t: current time, b: beginning value, _c: final value, d: total duration
	var tweenFunctions = {
	  linear: function(t, b, _c, d) {
	    var c = _c - b;
	    return c * t / d + b;
	  },
	  easeInQuad: function(t, b, _c, d) {
	    var c = _c - b;
	    return c * (t /= d) * t + b;
	  },
	  easeOutQuad: function(t, b, _c, d) {
	    var c = _c - b;
	    return -c * (t /= d) * (t - 2) + b;
	  },
	  easeInOutQuad: function(t, b, _c, d) {
	    var c = _c - b;
	    if ((t /= d / 2) < 1) {
	      return c / 2 * t * t + b;
	    } else {
	      return -c / 2 * ((--t) * (t - 2) - 1) + b;
	    }
	  },
	  easeInCubic: function(t, b, _c, d) {
	    var c = _c - b;
	    return c * (t /= d) * t * t + b;
	  },
	  easeOutCubic: function(t, b, _c, d) {
	    var c = _c - b;
	    return c * ((t = t / d - 1) * t * t + 1) + b;
	  },
	  easeInOutCubic: function(t, b, _c, d) {
	    var c = _c - b;
	    if ((t /= d / 2) < 1) {
	      return c / 2 * t * t * t + b;
	    } else {
	      return c / 2 * ((t -= 2) * t * t + 2) + b;
	    }
	  },
	  easeInQuart: function(t, b, _c, d) {
	    var c = _c - b;
	    return c * (t /= d) * t * t * t + b;
	  },
	  easeOutQuart: function(t, b, _c, d) {
	    var c = _c - b;
	    return -c * ((t = t / d - 1) * t * t * t - 1) + b;
	  },
	  easeInOutQuart: function(t, b, _c, d) {
	    var c = _c - b;
	    if ((t /= d / 2) < 1) {
	      return c / 2 * t * t * t * t + b;
	    } else {
	      return -c / 2 * ((t -= 2) * t * t * t - 2) + b;
	    }
	  },
	  easeInQuint: function(t, b, _c, d) {
	    var c = _c - b;
	    return c * (t /= d) * t * t * t * t + b;
	  },
	  easeOutQuint: function(t, b, _c, d) {
	    var c = _c - b;
	    return c * ((t = t / d - 1) * t * t * t * t + 1) + b;
	  },
	  easeInOutQuint: function(t, b, _c, d) {
	    var c = _c - b;
	    if ((t /= d / 2) < 1) {
	      return c / 2 * t * t * t * t * t + b;
	    } else {
	      return c / 2 * ((t -= 2) * t * t * t * t + 2) + b;
	    }
	  },
	  easeInSine: function(t, b, _c, d) {
	    var c = _c - b;
	    return -c * Math.cos(t / d * (Math.PI / 2)) + c + b;
	  },
	  easeOutSine: function(t, b, _c, d) {
	    var c = _c - b;
	    return c * Math.sin(t / d * (Math.PI / 2)) + b;
	  },
	  easeInOutSine: function(t, b, _c, d) {
	    var c = _c - b;
	    return -c / 2 * (Math.cos(Math.PI * t / d) - 1) + b;
	  },
	  easeInExpo: function(t, b, _c, d) {
	    var c = _c - b;
	    var _ref;
	    return (_ref = t === 0) !== null ? _ref : {
	      b: c * Math.pow(2, 10 * (t / d - 1)) + b
	    };
	  },
	  easeOutExpo: function(t, b, _c, d) {
	    var c = _c - b;
	    var _ref;
	    return (_ref = t === d) !== null ? _ref : b + {
	      c: c * (-Math.pow(2, -10 * t / d) + 1) + b
	    };
	  },
	  easeInOutExpo: function(t, b, _c, d) {
	    var c = _c - b;
	    if (t === 0) {
	      b;
	    }
	    if (t === d) {
	      b + c;
	    }
	    if ((t /= d / 2) < 1) {
	      return c / 2 * Math.pow(2, 10 * (t - 1)) + b;
	    } else {
	      return c / 2 * (-Math.pow(2, -10 * --t) + 2) + b;
	    }
	  },
	  easeInCirc: function(t, b, _c, d) {
	    var c = _c - b;
	    return -c * (Math.sqrt(1 - (t /= d) * t) - 1) + b;
	  },
	  easeOutCirc: function(t, b, _c, d) {
	    var c = _c - b;
	    return c * Math.sqrt(1 - (t = t / d - 1) * t) + b;
	  },
	  easeInOutCirc: function(t, b, _c, d) {
	    var c = _c - b;
	    if ((t /= d / 2) < 1) {
	      return -c / 2 * (Math.sqrt(1 - t * t) - 1) + b;
	    } else {
	      return c / 2 * (Math.sqrt(1 - (t -= 2) * t) + 1) + b;
	    }
	  },
	  easeInElastic: function(t, b, _c, d) {
	    var c = _c - b;
	    var a, p, s;
	    s = 1.70158;
	    p = 0;
	    a = c;
	    if (t === 0) {
	      b;
	    } else if ((t /= d) === 1) {
	      b + c;
	    }
	    if (!p) {
	      p = d * 0.3;
	    }
	    if (a < Math.abs(c)) {
	      a = c;
	      s = p / 4;
	    } else {
	      s = p / (2 * Math.PI) * Math.asin(c / a);
	    }
	    return -(a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t * d - s) * (2 * Math.PI) / p)) + b;
	  },
	  easeOutElastic: function(t, b, _c, d) {
	    var c = _c - b;
	    var a, p, s;
	    s = 1.70158;
	    p = 0;
	    a = c;
	    if (t === 0) {
	      b;
	    } else if ((t /= d) === 1) {
	      b + c;
	    }
	    if (!p) {
	      p = d * 0.3;
	    }
	    if (a < Math.abs(c)) {
	      a = c;
	      s = p / 4;
	    } else {
	      s = p / (2 * Math.PI) * Math.asin(c / a);
	    }
	    return a * Math.pow(2, -10 * t) * Math.sin((t * d - s) * (2 * Math.PI) / p) + c + b;
	  },
	  easeInOutElastic: function(t, b, _c, d) {
	    var c = _c - b;
	    var a, p, s;
	    s = 1.70158;
	    p = 0;
	    a = c;
	    if (t === 0) {
	      b;
	    } else if ((t /= d / 2) === 2) {
	      b + c;
	    }
	    if (!p) {
	      p = d * (0.3 * 1.5);
	    }
	    if (a < Math.abs(c)) {
	      a = c;
	      s = p / 4;
	    } else {
	      s = p / (2 * Math.PI) * Math.asin(c / a);
	    }
	    if (t < 1) {
	      return -0.5 * (a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t * d - s) * (2 * Math.PI) / p)) + b;
	    } else {
	      return a * Math.pow(2, -10 * (t -= 1)) * Math.sin((t * d - s) * (2 * Math.PI) / p) * 0.5 + c + b;
	    }
	  },
	  easeInBack: function(t, b, _c, d, s) {
	    var c = _c - b;
	    if (s === void 0) {
	      s = 1.70158;
	    }
	    return c * (t /= d) * t * ((s + 1) * t - s) + b;
	  },
	  easeOutBack: function(t, b, _c, d, s) {
	    var c = _c - b;
	    if (s === void 0) {
	      s = 1.70158;
	    }
	    return c * ((t = t / d - 1) * t * ((s + 1) * t + s) + 1) + b;
	  },
	  easeInOutBack: function(t, b, _c, d, s) {
	    var c = _c - b;
	    if (s === void 0) {
	      s = 1.70158;
	    }
	    if ((t /= d / 2) < 1) {
	      return c / 2 * (t * t * (((s *= 1.525) + 1) * t - s)) + b;
	    } else {
	      return c / 2 * ((t -= 2) * t * (((s *= 1.525) + 1) * t + s) + 2) + b;
	    }
	  },
	  easeInBounce: function(t, b, _c, d) {
	    var c = _c - b;
	    var v;
	    v = tweenFunctions.easeOutBounce(d - t, 0, c, d);
	    return c - v + b;
	  },
	  easeOutBounce: function(t, b, _c, d) {
	    var c = _c - b;
	    if ((t /= d) < 1 / 2.75) {
	      return c * (7.5625 * t * t) + b;
	    } else if (t < 2 / 2.75) {
	      return c * (7.5625 * (t -= 1.5 / 2.75) * t + 0.75) + b;
	    } else if (t < 2.5 / 2.75) {
	      return c * (7.5625 * (t -= 2.25 / 2.75) * t + 0.9375) + b;
	    } else {
	      return c * (7.5625 * (t -= 2.625 / 2.75) * t + 0.984375) + b;
	    }
	  },
	  easeInOutBounce: function(t, b, _c, d) {
	    var c = _c - b;
	    var v;
	    if (t < d / 2) {
	      v = tweenFunctions.easeInBounce(t * 2, 0, c, d);
	      return v * 0.5 + b;
	    } else {
	      v = tweenFunctions.easeOutBounce(t * 2 - d, 0, c, d);
	      return v * 0.5 + c * 0.5 + b;
	    }
	  }
	};
	
	module.exports = tweenFunctions;


/***/ }),
/* 2237 */,
/* 2238 */,
/* 2239 */,
/* 2240 */
/***/ (function(module, exports) {

	module.exports = extend
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	function extend() {
	    var target = {}
	
	    for (var i = 0; i < arguments.length; i++) {
	        var source = arguments[i]
	
	        for (var key in source) {
	            if (hasOwnProperty.call(source, key)) {
	                target[key] = source[key]
	            }
	        }
	    }
	
	    return target
	}


/***/ }),
/* 2241 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author Titus Wormer
	 * @copyright 2015 Titus Wormer
	 * @license MIT
	 * @module unified
	 * @fileoverview Parse / Transform / Compile / Repeat.
	 */
	
	'use strict';
	
	/* eslint-env commonjs */
	
	/*
	 * Dependencies.
	 */
	
	var bail = __webpack_require__(1207);
	var ware = __webpack_require__(2547);
	var AttachWare = __webpack_require__(951)(ware);
	var VFile = __webpack_require__(2546);
	var unherit = __webpack_require__(841);
	var extend;
	
	try {
	    extend = __webpack_require__(524);
	} catch (e) {
	    extend = __webpack_require__(524);
	}
	
	/*
	 * Processing pipeline.
	 */
	
	var pipeline = ware()
	    .use(function (ctx) {
	        ctx.tree = ctx.context.parse(ctx.file, ctx.settings);
	    })
	    .use(function (ctx, next) {
	        ctx.context.run(ctx.tree, ctx.file, next);
	    })
	    .use(function (ctx) {
	        ctx.result = ctx.context.stringify(ctx.tree, ctx.file, ctx.settings);
	    });
	
	/**
	 * Construct a new Processor class based on the
	 * given options.
	 *
	 * @param {Object} options - Configuration.
	 * @param {string} options.name - Private storage.
	 * @param {Function} options.Parser - Class to turn a
	 *   virtual file into a syntax tree.
	 * @param {Function} options.Compiler - Class to turn a
	 *   syntax tree into a string.
	 * @return {Processor} - A new constructor.
	 */
	function unified(options) {
	    var name = options.name;
	    var Parser = options.Parser;
	    var Compiler = options.Compiler;
	    var data = options.data;
	
	    /**
	     * Construct a Processor instance.
	     *
	     * @constructor
	     * @class {Processor}
	     */
	    function Processor(processor) {
	        var self = this;
	
	        if (!(self instanceof Processor)) {
	            return new Processor(processor);
	        }
	
	        self.ware = new AttachWare(processor && processor.ware);
	        self.ware.context = self;
	
	        self.Parser = unherit(Parser);
	        self.Compiler = unherit(Compiler);
	
	        if (self.data) {
	            self.data = extend(true, {}, self.data);
	        }
	    }
	
	    /**
	     * Either return `context` if its an instance
	     * of `Processor` or construct a new `Processor`
	     * instance.
	     *
	     * @private
	     * @param {Processor?} [context] - Context object.
	     * @return {Processor} - Either `context` or a new
	     *   Processor instance.
	     */
	    function instance(context) {
	        return context instanceof Processor ? context : new Processor();
	    }
	
	    /**
	     * Attach a plugin.
	     *
	     * @this {Processor?} - Either a Processor instance or
	     *   the Processor constructor.
	     * @return {Processor} - Either `context` or a new
	     *   Processor instance.
	     */
	    function use() {
	        var self = instance(this);
	
	        self.ware.use.apply(self.ware, arguments);
	
	        return self;
	    }
	
	    /**
	     * Transform.
	     *
	     * @this {Processor?} - Either a Processor instance or
	     *   the Processor constructor.
	     * @param {Node} [node] - Syntax tree.
	     * @param {VFile?} [file] - Virtual file.
	     * @param {Function?} [done] - Callback.
	     * @return {Node} - `node`.
	     */
	    function run(node, file, done) {
	        var self = this;
	        var space;
	
	        if (typeof file === 'function') {
	            done = file;
	            file = null;
	        }
	
	        if (!file && node && !node.type) {
	            file = node;
	            node = null;
	        }
	
	        file = new VFile(file);
	        space = file.namespace(name);
	
	        if (!node) {
	            node = space.tree || node;
	        } else if (!space.tree) {
	            space.tree = node;
	        }
	
	        if (!node) {
	            throw new Error('Expected node, got ' + node);
	        }
	
	        done = typeof done === 'function' ? done : bail;
	
	        /*
	         * Only run when this is an instance of Processor,
	         * and when there are transformers.
	         */
	
	        if (self.ware && self.ware.fns) {
	            self.ware.run(node, file, done);
	        } else {
	            done(null, node, file);
	        }
	
	        return node;
	    }
	
	    /**
	     * Parse a file.
	     *
	     * Patches the parsed node onto the `name`
	     * namespace on the `type` property.
	     *
	     * @this {Processor?} - Either a Processor instance or
	     *   the Processor constructor.
	     * @param {string|VFile} value - Input to parse.
	     * @param {Object?} [settings] - Configuration.
	     * @return {Node} - `node`.
	     */
	    function parse(value, settings) {
	        var file = new VFile(value);
	        var CustomParser = (this && this.Parser) || Parser;
	        var node = new CustomParser(file, settings, instance(this)).parse();
	
	        file.namespace(name).tree = node;
	
	        return node;
	    }
	
	    /**
	     * Compile a file.
	     *
	     * Used the parsed node at the `name`
	     * namespace at `'tree'` when no node was given.
	     *
	     * @this {Processor?} - Either a Processor instance or
	     *   the Processor constructor.
	     * @param {Object} [node] - Syntax tree.
	     * @param {VFile} [file] - File with syntax tree.
	     * @param {Object?} [settings] - Configuration.
	     * @return {string} - Compiled `file`.
	     */
	    function stringify(node, file, settings) {
	        var CustomCompiler = (this && this.Compiler) || Compiler;
	        var space;
	
	        if (settings === null || settings === undefined) {
	            settings = file;
	            file = null;
	        }
	
	        if (!file && node && !node.type) {
	            file = node;
	            node = null;
	        }
	
	        file = new VFile(file);
	        space = file.namespace(name);
	
	        if (!node) {
	            node = space.tree || node;
	        } else if (!space.tree) {
	            space.tree = node;
	        }
	
	        if (!node) {
	            throw new Error('Expected node, got ' + node);
	        }
	
	        return new CustomCompiler(file, settings, instance(this)).compile();
	    }
	
	    /**
	     * Parse / Transform / Compile.
	     *
	     * @this {Processor?} - Either a Processor instance or
	     *   the Processor constructor.
	     * @param {string|VFile} value - Input to process.
	     * @param {Object?} [settings] - Configuration.
	     * @param {Function?} [done] - Callback.
	     * @return {string?} - Parsed document, when
	     *   transformation was async.
	     */
	    function process(value, settings, done) {
	        var self = instance(this);
	        var file = new VFile(value);
	        var result = null;
	
	        if (typeof settings === 'function') {
	            done = settings;
	            settings = null;
	        }
	
	        pipeline.run({
	            'context': self,
	            'file': file,
	            'settings': settings || {}
	        }, function (err, res) {
	            result = res && res.result;
	
	            if (done) {
	                done(err, file, result);
	            } else if (err) {
	                bail(err);
	            }
	        });
	
	        return result;
	    }
	
	    /*
	     * Methods / functions.
	     */
	
	    var proto = Processor.prototype;
	
	    Processor.use = proto.use = use;
	    Processor.parse = proto.parse = parse;
	    Processor.run = proto.run = run;
	    Processor.stringify = proto.stringify = stringify;
	    Processor.process = proto.process = process;
	    Processor.data = proto.data = data || null;
	
	    return Processor;
	}
	
	/*
	 * Expose.
	 */
	
	module.exports = unified;


/***/ }),
/* 2242 */
/***/ (function(module, exports) {

	'use strict'
	
	module.exports = convert
	
	function convert(test) {
	  if (typeof test === 'string') {
	    return typeFactory(test)
	  }
	
	  if (test === null || test === undefined) {
	    return ok
	  }
	
	  if (typeof test === 'object') {
	    return ('length' in test ? anyFactory : matchesFactory)(test)
	  }
	
	  if (typeof test === 'function') {
	    return test
	  }
	
	  throw new Error('Expected function, string, or object as test')
	}
	
	function convertAll(tests) {
	  var results = []
	  var length = tests.length
	  var index = -1
	
	  while (++index < length) {
	    results[index] = convert(tests[index])
	  }
	
	  return results
	}
	
	// Utility assert each property in `test` is represented in `node`, and each
	// values are strictly equal.
	function matchesFactory(test) {
	  return matches
	
	  function matches(node) {
	    var key
	
	    for (key in test) {
	      if (node[key] !== test[key]) {
	        return false
	      }
	    }
	
	    return true
	  }
	}
	
	function anyFactory(tests) {
	  var checks = convertAll(tests)
	  var length = checks.length
	
	  return matches
	
	  function matches() {
	    var index = -1
	
	    while (++index < length) {
	      if (checks[index].apply(this, arguments)) {
	        return true
	      }
	    }
	
	    return false
	  }
	}
	
	// Utility to convert a string into a function which checks a given node’s type
	// for said string.
	function typeFactory(test) {
	  return type
	
	  function type(node) {
	    return Boolean(node && node.type === test)
	  }
	}
	
	// Utility to return true.
	function ok() {
	  return true
	}


/***/ }),
/* 2243 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	module.exports = visitParents
	
	var convert = __webpack_require__(2242)
	
	var CONTINUE = true
	var SKIP = 'skip'
	var EXIT = false
	
	visitParents.CONTINUE = CONTINUE
	visitParents.SKIP = SKIP
	visitParents.EXIT = EXIT
	
	function visitParents(tree, test, visitor, reverse) {
	  var is
	
	  if (typeof test === 'function' && typeof visitor !== 'function') {
	    reverse = visitor
	    visitor = test
	    test = null
	  }
	
	  is = convert(test)
	
	  one(tree, null, [])
	
	  // Visit a single node.
	  function one(node, index, parents) {
	    var result = []
	    var subresult
	
	    if (!test || is(node, index, parents[parents.length - 1] || null)) {
	      result = toResult(visitor(node, parents))
	
	      if (result[0] === EXIT) {
	        return result
	      }
	    }
	
	    if (node.children && result[0] !== SKIP) {
	      subresult = toResult(all(node.children, parents.concat(node)))
	      return subresult[0] === EXIT ? subresult : result
	    }
	
	    return result
	  }
	
	  // Visit children in `parent`.
	  function all(children, parents) {
	    var min = -1
	    var step = reverse ? -1 : 1
	    var index = (reverse ? children.length : min) + step
	    var result
	
	    while (index > min && index < children.length) {
	      result = one(children[index], index, parents)
	
	      if (result[0] === EXIT) {
	        return result
	      }
	
	      index = typeof result[1] === 'number' ? result[1] : index + step
	    }
	  }
	}
	
	function toResult(value) {
	  if (value !== null && typeof value === 'object' && 'length' in value) {
	    return value
	  }
	
	  if (typeof value === 'number') {
	    return [CONTINUE, value]
	  }
	
	  return [value]
	}


/***/ }),
/* 2244 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "10e0e07cdc6289037efd92dafa315f92.ttf";

/***/ }),
/* 2245 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "14b39041b9bf6d207172b9a26e35d356.woff";

/***/ }),
/* 2246 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "eab41b772f9aa36a8d71db121a0a7768.woff2";

/***/ }),
/* 2247 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "8ae5cb544b933c39787c623f5b5735a2.ttf";

/***/ }),
/* 2248 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "1f1c07edcf3054fe1ec899ace9e99ad7.woff";

/***/ }),
/* 2249 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "4a51e4054ae546b6d5dcaaa38b4a280f.woff2";

/***/ }),
/* 2250 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "8d715138fea8cc8603d6218e90e19ae3.ttf";

/***/ }),
/* 2251 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "83ed7cf378b0942b9ad132466beeb278.woff";

/***/ }),
/* 2252 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "134aefa5125f69a17d6b7e3dfca38174.woff2";

/***/ }),
/* 2253 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "933317c72988ec929b9f1d6a289106a4.ttf";

/***/ }),
/* 2254 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "224a95c2ca202d37049e5fb1ef7a3f5a.woff";

/***/ }),
/* 2255 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "01ae930d559239d0c5fcca47d608e1f9.woff2";

/***/ }),
/* 2256 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "1d69ab1773ce7511448ef0bf9c1730f3.ttf";

/***/ }),
/* 2257 */
/***/ (function(module, exports) {

	module.exports = "data:application/font-woff;base64,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"

/***/ }),
/* 2258 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/epsHybridAssembly/images/characters/apprenticeCurious-3e7236cce83cb89c2edaeb8503ed9211.png";

/***/ }),
/* 2259 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/epsHybridAssembly/images/characters/apprenticeHandsHips3-406e8811bf51c1fbab97ac9ffe403280.png";

/***/ }),
/* 2260 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/epsHybridAssembly/images/characters/apprenticePointingUp2-9c0ac37f7e4a051b551e8d86a6fbf1fb.png";

/***/ }),
/* 2261 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/epsHybridAssembly/images/characters/apprenticePointingUp3-8de0bd064b02d2e9ed3688e6ef5bec10.png";

/***/ }),
/* 2262 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/epsHybridAssembly/images/characters/apprenticesBackToBack-3828e498bf581cc27ecb2f351a349b23.png";

/***/ }),
/* 2263 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/epsHybridAssembly/images/characters/apprenticesFlexArms-4aeefe98ba101c125fbc6e150654e893.png";

/***/ }),
/* 2264 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/epsHybridAssembly/images/characters/apprenticesPairArmsFolded-35d4b6c7dcaec4d89b2c5f631fcbfe04.png";

/***/ }),
/* 2265 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/epsHybridAssembly/images/characters/apprenticesRowArmsFolded-8d1e0374293625adce385ef4a156323c.png";

/***/ }),
/* 2266 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/epsHybridAssembly/images/characters/sara_giggle-f59c43c85e15482d7fe0fc5dcac1de28.png";

/***/ }),
/* 2267 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/epsHybridAssembly/images/emergencyPreparednessSquad-2064b85d3eb2aec8ecdcf1800236cfec.png";

/***/ }),
/* 2268 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/epsHybridAssembly/images/emergencyPreparednessSquadExpired-1761c2ab001f953107b074296a12fde4.png";

/***/ }),
/* 2269 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/epsHybridAssembly/images/emergencyPreparednessSquadTrial-2064b85d3eb2aec8ecdcf1800236cfec.png";

/***/ }),
/* 2270 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/epsHybridAssembly/images/level-1_start-94903c9cf11152555713aeb99ec77af8.png";

/***/ }),
/* 2271 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/epsHybridAssembly/images/overview/level-1_start-6bf328c5226bf5e0a3bcc8c8ee12412b.png";

/***/ }),
/* 2272 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 2273 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/epsHybridAssembly/sections/30_gameShow/title_gameshow-4db1c3edea9555aba358c3928e2305e0.png";

/***/ }),
/* 2274 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/epsHybridAssembly/sections/30_gameShow/title_gameshow_players-1f3dab0745c16a508ea646d3d95269a3.png";

/***/ }),
/* 2275 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/epsHybridIntermediates/images/characters/ian_hand_raised-384fabc0cb5b98efe85310c0d8c15540.png";

/***/ }),
/* 2276 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/epsHybridIntermediates/images/characters/ian_pointing_down-026a77087cf65bf8bbd037d9b72502c3.png";

/***/ }),
/* 2277 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/epsHybridIntermediates/images/characters/ian_pointing_left-4596053eb82e04f727bdd744c3de0325.png";

/***/ }),
/* 2278 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/epsHybridIntermediates/images/characters/ian_sara_two_fingers-5ed565638eae000314880d23ff009b43.png";

/***/ }),
/* 2279 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/epsHybridIntermediates/images/characters/ian_shrug_laugh-f19e9de88cd7960d4eff1c212c0e2d5f.png";

/***/ }),
/* 2280 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/epsHybridIntermediates/images/characters/sara_humph-a0889c055339bc1bd36428414d9e217e.png";

/***/ }),
/* 2281 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/epsHybridIntermediates/images/characters/sara_twist_hands_out_yay-bcf1fb30eda8e0aa404ef594e2dd3fd6.png";

/***/ }),
/* 2282 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/epsHybridIntermediates/images/emergencyPreparednessSquad-2064b85d3eb2aec8ecdcf1800236cfec.png";

/***/ }),
/* 2283 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/epsHybridIntermediates/images/emergencyPreparednessSquadExpired-1761c2ab001f953107b074296a12fde4.png";

/***/ }),
/* 2284 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/epsHybridIntermediates/images/emergencyPreparednessSquadTrial-2064b85d3eb2aec8ecdcf1800236cfec.png";

/***/ }),
/* 2285 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/epsHybridIntermediates/images/level-0_start-fa7258753d8cfafa05d92649458bde53.png";

/***/ }),
/* 2286 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 2287 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 2288 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 2289 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAyMS4wLjIsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iTGF5ZXJfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiDQoJIHZpZXdCb3g9IjAgMCAzMDAgMzMwIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCAzMDAgMzMwOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+DQo8c3R5bGUgdHlwZT0idGV4dC9jc3MiPg0KCS5zdDB7ZmlsbDojQjRFMTY2O30NCgkuc3Qxe2ZpbGw6IzI2Q0VFODt9DQoJLnN0MntmaWxsOiMwMERFRkY7fQ0KCS5zdDN7ZmlsbDpub25lO30NCgkuc3Q0e2VuYWJsZS1iYWNrZ3JvdW5kOm5ldyAgICA7fQ0KPC9zdHlsZT4NCjxwYXRoIGlkPSJzaGFwZVBhdGgxIiBjbGFzcz0ic3QwIiBkPSJNMjEyLjQsMTAwLjFjMC02LTIuOS0xMC45LTcuMy0xNC44YzIuMS01LjUsMi4xLTExLjQtMS0xNi42Yy0yLjktNS4yLTguMS03LjgtMTMuOC04LjgNCgljLTEtNi00LjItMTAuOS04LjgtMTMuOGMtNC45LTIuOS0xMC45LTMuMS0xNi42LTFjLTMuOS00LjQtOC44LTcuMy0xNC44LTcuM3MtMTAuOSwyLjktMTQuOCw3LjNjLTUuNS0yLjEtMTEuNC0yLjEtMTYuNiwxDQoJYy01LjIsMi45LTcuOCw4LjEtOC44LDEzLjhjLTYsMS0xMC45LDQuMi0xMy44LDguOGMtMi45LDUuMi0zLjEsMTAuOS0xLDE2LjZjLTQuNCwzLjktNy4zLDguOC03LjMsMTQuOHMyLjksMTAuOSw3LjMsMTQuOA0KCWMtMi4xLDUuNS0yLjEsMTEuNCwxLDE2LjZzNy44LDcuOCwxMy44LDguOGMxLDYsNC4yLDEwLjksOC44LDEzLjhjNC45LDIuOSwxMC45LDMuMSwxNi42LDFjMy45LDQuNCw4LjgsNy4zLDE0LjgsNy4zDQoJczEwLjktMi45LDE0LjgtNy4zYzUuNSwyLjEsMTEuNCwyLjEsMTYuNi0xYzUuMi0yLjksNy44LTcuOCw4LjgtMTMuOGM2LTEsMTAuOS00LjIsMTMuOC04LjhjMi45LTUuMiwzLjEtMTAuOSwxLTE2LjYNCglDMjA5LjUsMTExLDIxMi40LDEwNS41LDIxMi40LDEwMC4xIE0xODUuMSwxMzQuOWMtNC40LDAtOS42LTEuMy0xNS4xLTQuMmMtMS03LjUtMy45LTEzLjgtNy41LTE4LjJjNC40LDMuOSwxMC42LDYuNSwxOC4yLDcuNQ0KCUMxODMuOCwxMjQuNywxODUuMSwxMzAuNCwxODUuMSwxMzQuOSBNMTUyLjEsMTM2LjJjMi45LTcuMywzLjktMTMuOCwyLjktMTkuN2MyLjEsNS41LDYuMiwxMC45LDExLjksMTUuOGMwLDYtMS44LDExLjQtMy45LDE1LjENCglDMTU4LjksMTQ1LjIsMTU1LjIsMTQxLjMsMTUyLjEsMTM2LjIgTTEzNy42LDE0Ny42Yy0yLjMtMy45LTMuOS05LjMtMy45LTE1LjFjNi00LjksOS45LTEwLjQsMTEuOS0xNS44Yy0xLDYsMCwxMi43LDIuOSwxOS43DQoJQzE0NS4xLDE0MS4zLDE0MS4yLDE0NS4yLDEzNy42LDE0Ny42IE0xMTUuMiwxMzQuOWMwLTQuNCwxLjMtOS42LDQuMi0xNS4xYzcuNS0xLDEzLjgtMy45LDE4LjItNy41Yy0zLjksNC40LTYuNSwxMC42LTcuNSwxOC4yDQoJQzEyNS4xLDEzMy42LDExOS45LDEzNC45LDExNS4yLDEzNC45IE0xMTUuMiw2NWM0LjQsMCw5LjYsMS4zLDE1LjEsNC4yYzEsNy41LDMuOSwxMy44LDcuNSwxOC4yYy00LjQtMy45LTEwLjYtNi41LTE4LjItNy41DQoJQzExNi41LDc0LjksMTE1LjIsNjkuNywxMTUuMiw2NSBNMTQ4LjIsNjMuNGMtMi45LDcuMy0zLjksMTMuOC0yLjksMTkuN2MtMi4xLTUuNS02LjItMTAuOS0xMS45LTE1LjhjMC02LDEuOC0xMS40LDMuOS0xNS4xDQoJQzE0MS4yLDU0LjYsMTQ1LjEsNTguNSwxNDguMiw2My40IE0xMzMuNCw5NS42Yy02LTEtMTIuNywwLTE5LjcsMi45Yy01LjItMy4xLTguOC03LTExLjQtMTAuOWMzLjktMi4zLDkuMy0zLjksMTUuMS0zLjkNCglDMTIyLjUsODkuNCwxMjgsOTMuNiwxMzMuNCw5NS42IE0xMzMuNCwxMDQuNWMtNS41LDIuMS0xMC45LDYuMi0xNS44LDExLjljLTYsMC0xMS40LTEuOC0xNS4xLTMuOWMyLjMtMy45LDYuMi03LjgsMTEuNC0xMC45DQoJQzEyMC43LDEwNC41LDEyNy41LDEwNS41LDEzMy40LDEwNC41IE0xNDYuNCwxMTQuMWMtMi4xLDUuMi03LDEwLjQtMTIuNywxNC41YzAuMy03LjMsMi45LTEzLjgsNi4yLTE4LjINCgljLTQuNCwzLjQtMTAuOSw1LjUtMTguMiw2LjJjNC4yLTYsOS4zLTEwLjYsMTQuNS0xMi43Yy01LjUsMC44LTEyLjUtMC44LTE5LTMuOWM2LjUtMy4xLDEzLjUtNC40LDE5LTMuOWMtNS4yLTIuMS0xMC40LTctMTQuNS0xMi43DQoJYzcuMywwLjMsMTMuOCwyLjksMTguMiw2LjJjLTMuNC00LjQtNS41LTEwLjktNi4yLTE4LjJjNiw0LjIsMTAuNiw5LjMsMTIuNywxNC41Yy0wLjgtNS41LDAuOC0xMi41LDMuOS0xOWMzLjEsNi41LDQuNCwxMy41LDMuOSwxOQ0KCWMyLjEtNS4yLDctMTAuNCwxMi43LTE0LjVjLTAuMyw3LjMtMi45LDEzLjgtNi4yLDE4LjJjNC40LTMuNCwxMC45LTUuNSwxOC4yLTYuMmMtNC4yLDYtOS40LDEwLjYtMTQuNSwxMi43DQoJYzUuNS0wLjgsMTIuNSwwLjgsMTksMy45Yy02LjUsMy4xLTEzLjUsNC40LTE5LDMuOWM1LjIsMi4xLDEwLjQsNywxNC41LDEyLjdjLTcuMy0wLjMtMTMuOC0yLjktMTguMi02LjJjMy40LDQuNCw1LjUsMTAuOSw2LjIsMTguMg0KCWMtNi00LjItMTAuOS05LjMtMTIuNy0xNC41YzAuOCw1LjUtMC44LDEyLjUtMy45LDE5QzE0Ny4yLDEyNi41LDE0NS45LDExOS44LDE0Ni40LDExNC4xIE0xNjMsNTIuM2MyLjMsMy45LDMuOSw5LjMsMy45LDE1LjENCgljLTYsNC45LTkuOSwxMC40LTExLjksMTUuOGMxLTYsMC0xMi43LTIuOS0xOS43QzE1NS4yLDU4LjUsMTU4LjksNTQuNiwxNjMsNTIuMyBNMTg1LjEsNjVjMCw0LjQtMS4zLDkuNi00LjIsMTUuMQ0KCWMtNy41LDEtMTMuOCwzLjktMTguMiw3LjVjMy45LTQuNCw2LjUtMTAuNiw3LjUtMTguMkMxNzUuNSw2Ni4zLDE4MC43LDY1LDE4NS4xLDY1IE0xNjYuOSwxMDQuNWM2LDEsMTIuNywwLDE5LjctMi45DQoJYzUuMiwzLjEsOC44LDcsMTEuNCwxMC45Yy0zLjksMi4zLTkuNCwzLjktMTUuMSwzLjlDMTc3LjgsMTEwLjcsMTcyLjQsMTA2LjUsMTY2LjksMTA0LjUgTTE2Ni45LDk1LjZjNS41LTIuMSwxMC45LTYuMiwxNS44LTExLjkNCgljNiwwLDExLjQsMS44LDE1LjEsMy45Yy0yLjMsMy45LTYuMiw3LjgtMTEuNCwxMC45QzE3OS43LDk1LjEsMTcyLjYsOTQuNiwxNjYuOSw5NS42IE0xOTguOSw3MS43YzEuOCwzLjEsMi4xLDYuNSwxLjMsMTAuNA0KCWMtMy40LTEuOC03LjMtMi4zLTExLjQtMi4zaC0zLjFjMC44LTEsMS0xLjgsMS44LTIuOWMyLjEtMy45LDMuMS03LjUsMy40LTExLjRDMTkzLjksNjYuNiwxOTcuMSw2OC42LDE5OC45LDcxLjcgTTE3OC4xLDUxLjUNCgljMy4xLDEuOCw1LjIsNC40LDYuMiw4LjNjLTMuOSwwLjMtNy41LDEuMy0xMS40LDMuNGMtMSwwLjgtMS44LDEtMi45LDEuOHYtMy4xYzAtNC4yLTEtNy44LTIuMy0xMS40DQoJQzE3MS42LDQ5LjQsMTc1LDQ5LjcsMTc4LjEsNTEuNSBNMTUwLjMsNDRjMy40LDAsNywxLjMsOS4zLDQuMmMtMy4xLDIuMS02LDUuMi03LjgsOC42Yy0wLjgsMS0xLDEuOC0xLjMsMi45Yy0wLjMtMS0xLTEuOC0xLjMtMi45DQoJYy0yLjEtMy45LTQuOS02LjUtNy44LTguNkMxNDMuMyw0NS4zLDE0Ni40LDQ0LDE1MC4zLDQ0IE0xMjIsNTEuNWMzLjEtMS44LDYuNS0yLjEsMTAuNC0xLjNjLTEuOCwzLjQtMi4zLDcuMy0yLjMsMTEuNHYzLjENCgljLTEtMC44LTEuOC0xLTIuOS0xLjhjLTMuOS0yLjEtNy41LTMuMS0xMS40LTMuNEMxMTcuMyw1NS45LDExOC45LDUzLjMsMTIyLDUxLjUgTTEwMS43LDcxLjdjMS44LTMuMSw0LjQtNS4yLDguMy02LjINCgljMC4zLDMuOSwxLjMsNy41LDMuNCwxMS40YzAuOCwxLDEsMS44LDEuOCwyLjloLTMuMWMtNC4yLDAtNy44LDEtMTEuNCwyLjNDOTkuNyw3OC44LDk5LjksNzQuOSwxMDEuNyw3MS43IE05NC4yLDEwMC4xDQoJYzAtMy40LDEuMy03LDQuMi05LjNjMi4xLDMuMSw1LjIsNiw4LjYsNy44YzEsMC44LDEuOCwxLDIuOSwxLjNjLTEsMC4zLTEuOCwxLTIuOSwxLjNjLTMuOSwyLjEtNi41LDQuOS04LjYsNy44DQoJQzk1LjUsMTA2LjUsOTQuMiwxMDMuNCw5NC4yLDEwMC4xIE0xMDEuNywxMjcuOGMtMS44LTMuMS0yLjEtNi41LTEuMy0xMC40YzMuNCwxLjgsNy4zLDIuMywxMS40LDIuM2gzLjFjLTAuOCwxLTEsMS44LTEuOCwyLjkNCgljLTIuMSwzLjktMy4xLDcuNS0zLjQsMTEuNEMxMDYuMiwxMzMsMTAzLjYsMTMxLDEwMS43LDEyNy44IE0xMjIsMTQ4LjZjLTMuMS0xLjgtNS4yLTQuNC02LjItOC4zYzMuOS0wLjMsNy41LTEuMywxMS40LTMuNA0KCWMxLTAuOCwxLjgtMSwyLjktMS44djMuMWMwLDQuMiwxLDcuOCwyLjMsMTEuNEMxMjguNSwxNTAuNywxMjUuMSwxNTAuNCwxMjIsMTQ4LjYgTTE1MC4zLDE1Ni4yYy0zLjQsMC03LTEuMy05LjQtNC4yDQoJYzMuMS0yLjEsNi01LjIsNy44LTguNmMwLjgtMSwxLTEuOCwxLjMtMi45YzAuMywxLDEsMS44LDEuMywyLjljMi4xLDMuOSw0LjksNi41LDcuOCw4LjZDMTU2LjgsMTU0LjYsMTUzLjcsMTU2LjIsMTUwLjMsMTU2LjINCgkgTTE3OC4xLDE0OC42Yy0zLjEsMS44LTYuNSwyLjEtMTAuNCwxLjNjMS44LTMuNCwyLjMtNy4zLDIuMy0xMS40di0zLjFjMSwwLjgsMS44LDEsMi45LDEuOGMzLjksMi4xLDcuNSwzLjEsMTEuNCwzLjQNCglDMTgzLjMsMTQzLjcsMTgxLjIsMTQ2LjgsMTc4LjEsMTQ4LjYgTTE5OC45LDEyNy44Yy0xLjgsMy4xLTQuNCw1LjItOC4zLDYuMmMtMC4zLTMuOS0xLjMtNy41LTMuNC0xMS40Yy0wLjgtMS0xLTEuOC0xLjgtMi45aDMuMQ0KCWM0LjIsMCw4LjEtMSwxMS40LTIuM0MyMDEsMTIxLjMsMjAwLjcsMTI0LjcsMTk4LjksMTI3LjggTTIwMi4yLDEwOS40Yy0yLjEtMy4xLTUuMi02LTguNi03LjhjLTEtMC44LTEuOC0xLTIuOS0xLjMNCgljMS0wLjMsMS44LTEsMi45LTEuM2MzLjktMi4xLDYuNS00LjksOC42LTcuOGMyLjksMi45LDQuMiw2LDQuMiw5LjNDMjA2LjQsMTAzLjQsMjA0LjYsMTA2LjUsMjAyLjIsMTA5LjR6Ii8+DQo8cGF0aCBpZD0ic2hhcGVQYXRoMiIgY2xhc3M9InN0MSIgZD0iTTEzMC4zLDE4Ny42YzQuNCwxLDkuNCwxLjgsMTQsMi4xdjMuMWMtNi0wLjMtMTEuNC0xLjMtMTYuOS0yLjljLTEuMywxLjgtMy45LDUuMi04LjYsNy44DQoJYy01LjIsMy4xLTEyLjUsMS0xMi41LDFzMy40LTcuNSw5LjMtOS45YzEuOC0wLjgsMy45LTEsNi0xYy0zLjEtMS02LjItMi4xLTkuMy0zLjljLTEuMywxLjgtNC40LDQuNC05LjMsNi41DQoJYy01LjUsMi4xLTExLjktMS0xMS45LTFzNC40LTYuNSwxMC42LTcuOGMxLjgtMC4zLDMuOSwwLDYsMGwtMy40LTIuMWMtMS44LTEtMy45LTIuMS01LjUtMy40Yy0xLjgsMS4zLTUuMiwzLjktOS45LDQuOQ0KCWMtNiwxLjMtMTEuNy0zLjEtMTEuNy0zLjFzNS41LTUuNSwxMS43LTZjMS44LDAsMy45LDAuMyw1LjUsMWMtMi4zLTIuMS01LjItNC40LTcuNS03Yy0xLjgsMS01LjUsMi45LTEwLjYsMi45DQoJYy02LDAtMTAuNi01LjItMTAuNi01LjJzNi4yLTQuNCwxMS45LTMuOWMxLjgsMC4zLDMuOSwxLjMsNS41LDIuMWMtMi4zLTIuOS00LjQtNS41LTYuNS04LjZjLTEuOCwwLjgtNiwxLjgtMTAuOSwxDQoJYy01LjUtMC44LTkuMy02LjUtOS4zLTYuNXM3LTMuNCwxMi41LTEuOGMxLjgsMC44LDMuOSwyLjEsNS41LDMuNGMtMi4xLTMuMS0zLjktNi41LTUuNS05LjljLTEuOCwwLjMtNiwwLjgtMTAuNi0xDQoJYy01LjItMS44LTcuOC03LjgtNy44LTcuOHM3LjMtMi4xLDEyLjUsMC44YzEuOCwxLDMuMSwyLjMsNC40LDQuMmMtMS4zLTMuNC0yLjMtNy0zLjQtMTAuNmMtMS44LDAtNi0wLjMtMTAuNC0yLjkNCgljLTQuMi0xLjgtNi04LjMtNi04LjNzNy4zLTAuOCwxMS43LDIuOWMxLjMsMSwyLjksMy4xLDMuOSw0LjljLTAuOC0zLjktMS4zLTcuMy0xLjMtMTAuOWMtMS44LTAuMy01LjUtMS4zLTkuMy00LjQNCgljLTQuMi0zLjQtNC40LTkuNi00LjQtOS42czcuMywwLjMsMTAuNiw0LjRjMS4zLDEuMywyLjEsMy40LDIuOSw1LjVjMC0zLjksMC03LjgsMC4zLTExLjdjLTEuOC0wLjgtNS4yLTIuMS04LjMtNg0KCWMtMy40LTMuOS0yLjktMTAuNC0yLjktMTAuNHM3LDEuOCw5LjYsNi4yYzEsMS44LDEuMywzLjksMS44LDZjMC44LTMuOSwxLjMtNy44LDIuMy0xMS43Yy0xLjMtMC44LTQuOS0yLjktNy4zLTcuMw0KCWMtMi45LTQuNC0wLjgtMTAuNC0wLjgtMTAuNHM2LjIsMy4xLDguMyw3LjhjMC44LDEuOCwwLjgsNC40LDAuOCw2LjVjMS4zLTQuMiwzLjEtNy44LDQuOS0xMS43Yy0xLTEtNC4yLTMuNC02LTguMw0KCWMtMS44LTQuNCwxLTkuOSwxLTkuOXM1LjUsMy45LDYuNSw4LjhjMC4zLDIuMSwwLDQuOS0wLjgsN2MyLjEtMy45LDQuNC03LjUsNy0xMC45Yy0xLTEtMy40LTQuMi00LjItOC44Yy0wLjgtNC45LDIuOS05LjYsMi45LTkuNg0KCXM0LjksNC40LDQuOSw5LjZjMCwyLjEtMC44LDQuNC0xLjgsNi41YzIuOS0zLjQsNS41LTcsOC42LTkuNmMtMC44LTEuMy0yLjMtNC40LTIuOS05LjNjLTAuOC01LjIsMy45LTguOCwzLjktOC44UzkzLjQsMjYsOTIuNywzMQ0KCWMtMC4zLDIuMS0xLjgsNC40LTIuOSw2LjJjMS0xLDIuMS0xLjgsMy4xLTIuOWMyLjMtMi4xLDQuOS0zLjksNy4zLTUuMmMwLTEtMS4zLTQuOS0wLjgtOS42YzAuOC00LjQsNS41LTcuNSw1LjUtNy41DQoJczIuOSw2LDEuMywxMC40Yy0wLjgsMi4xLTMuMSw0LjktNC40LDYuMmM0LjctMi45LDguNi00LjksMTIuMi02LjhjMC0xLTEtNC45LDAuOC05LjZjMS44LTQuNCw3LTYuNSw3LTYuNXMxLjgsNi0wLjgsOS45DQoJYy0xLDIuMS00LjIsNC40LTUuNSw1LjVjMi4zLTEsNC45LTEuOCw2LjUtMi4zYzAuOC0wLjgsMy40LTMuOSw2LjUtNC40YzIuOS0wLjMsNy4zLDEuMyw3LjMsMS4zcy0yLjMsMi45LTYuNSw0LjQNCgljLTIuOSwxLTYtMC4zLTctMC44Yy0yLjEsMC44LTUuMiwxLjgtOC4zLDMuNGMxLjgtMC4zLDUuNS0wLjgsNy44LDBjNC40LDEuMyw3LjUsNyw3LjUsN3MtNS4yLDIuMS05LjMsMGMtNC40LTIuMy02LjUtNS41LTcuMy02LjUNCgljLTMuNCwxLjgtNy41LDMuOS0xMS43LDdjMS44LTAuOCw1LjItMS44LDcuMy0xLjNjNC45LDAuOCw4LjYsNS41LDguNiw1LjVzLTQuOSwzLjEtOS4zLDEuOHMtNy4zLTQuMi04LjMtNS4yDQoJYy0xLjgsMS4zLTMuOSwyLjktNS41LDQuNGMtMS44LDEuMy0zLjQsMi45LTUuMiw0LjRjMS44LTEsNC45LTIuMyw3LjMtMi4zYzQuOSwwLDkuNiw0LjIsOS42LDQuMnMtNC40LDMuOS05LjMsMy4xDQoJYy00LjktMC44LTcuOC0yLjktOC44LTMuOWMtMy4xLDMuMS02LDYuNS04LjYsMTAuNGMxLjgtMS4zLDQuMi0zLjEsNi4yLTMuNGM0LjktMSwxMC42LDIuMywxMC42LDIuM3MtMy45LDQuNC04LjYsNC45DQoJYy00LjksMC4zLTguMy0xLjMtOS42LTIuMWMtMi4zLDMuNC00LjQsNy4zLTYuNSwxMC45YzEuMy0xLjgsMy40LTMuNCw1LjUtNC4yYzQuOS0yLjEsMTAuOSwwLjgsMTAuOSwwLjhTODQuMiw2Niw3OS41LDY3DQoJYy00LjQsMS04LjMsMC4zLTkuNi0wLjVjLTEuOCwzLjktMy4xLDcuOC00LjQsMTEuOWMxLjMtMS44LDIuOS00LjIsNC40LTUuMmM0LjQtMi45LDEwLjktMS4zLDEwLjktMS4zcy0yLjEsNi02LjUsNy44DQoJYy0zLjksMS4zLTcuNSwxLjMtOS4zLDFjLTEsNC4yLTEuOCw4LjMtMi4zLDEyLjdjMC44LTIuMSwyLjEtNC45LDMuOS02LjJjMy45LTMuOSwxMC45LTMuNCwxMC45LTMuNHMtMSw2LjItNS41LDguOA0KCWMtNC4yLDIuOS03LjgsMy4xLTkuNiwzLjRjLTAuMyw0LjItMC4zLDguMywwLDEyLjVjMC44LTIuMSwxLjMtNC45LDIuOS02LjJjMy40LTQuNCwxMC42LTUuNSwxMC42LTUuNXMwLDYuNS0zLjksOS45DQoJcy03LjMsNC40LTguOCw0LjljMC4zLDMuOSwxLDcuOCwyLjEsMTEuN2MwLTIuMSwwLjMtNC45LDEuMy03YzIuOS00LjksOS42LTcuMyw5LjYtNy4zczEuMyw2LjUtMi4xLDEwLjZjLTIuOSw0LjItNi4yLDYuMi03LjgsNw0KCWMxLDMuOSwyLjMsNy4zLDMuOSwxMC42Yy0wLjMtMi4xLTAuMy00LjksMC4zLTYuNWMxLjgtNS41LDguMy04LjgsOC4zLTguOHMyLjMsNi4yLDAsMTAuOWMtMi4xLDQuNC01LjUsNy03LDcuOA0KCWMxLjgsMy40LDMuNCw2LjUsNS41LDkuM2MtMC44LTIuMS0xLTQuNC0wLjgtNi41YzAuOC02LDctMTAuNCw3LTEwLjRzMy40LDYsMS44LDExLjRjLTEuMyw0LjktNC4yLDcuOC01LjUsOS40DQoJYzIuMywzLjEsNC45LDYsNy4zLDguNmMtMS0yLjEtMi4xLTQuNC0yLjEtNi41YzAtNiw1LjItMTEuNyw1LjItMTEuN3M0LjQsNS4yLDMuOSwxMC45Yy0wLjgsNS4yLTIuOSw4LjYtMy45LDEwLjQNCgljMi45LDIuOSw2LDUuMiw4LjgsNy4zYy0xLjMtMS44LTIuOS00LjQtMy40LTYuNWMtMS4zLTYsMy4xLTEyLjcsMy4xLTEyLjdzNS41LDQuNCw2LDEwLjRjMC4zLDUuMi0xLjMsOS40LTIuMSwxMC45bDMuNCwyLjENCglsNi4yLDMuMWMtMS44LTEuOC0zLjQtMy45LTQuMi01LjVjLTIuMy01LjUsMC44LTEzLDAuOC0xM3M2LjIsMy40LDcuNSw5LjNjMSw1LjIsMC4zLDkuMywwLDExLjRjMy45LDEuOCw3LDIuOSw5LjksMy45DQoJYy0xLjgtMS4zLTMuOS0zLjEtNS4yLTQuOWMtMy40LTUuNS0xLjgtMTMuNS0xLjgtMTMuNXM3LjMsMi4zLDkuMyw3LjhDMTMwLjMsMTgxLjEsMTMwLjMsMTg1LjIsMTMwLjMsMTg3LjYgTTIzNi41LDEyNS44DQoJYy0xLDMuOS0yLjEsNy4zLTMuNCwxMC42YzEuMy0xLjgsMy4xLTMuNCw0LjQtNC4yYzUuMi0yLjksMTIuNS0wLjgsMTIuNS0wLjhzLTIuOSw2LjItNy44LDcuOGMtNC45LDEuOC04LjgsMS4zLTEwLjYsMQ0KCWMtMS44LDMuNC0zLjQsNy01LjUsOS45YzEuOC0xLjMsMy45LTIuOSw1LjUtMy40YzUuNS0xLjgsMTIuNSwxLjgsMTIuNSwxLjhzLTMuOSw2LTkuMyw2LjVjLTUuMiwwLjgtOS40LTAuMy0xMC45LTENCgljLTIuMSwzLjEtNC4yLDYtNi41LDguNmMxLjgtMSwzLjktMi4xLDUuNS0yLjFjNi0wLjgsMTEuOSwzLjksMTEuOSwzLjlzLTQuOSw1LjItMTAuNiw1LjJjLTUuMiwwLTguOC0xLjgtMTAuNi0yLjkNCgljLTIuMywyLjMtNS4yLDQuOS03LjUsN2MxLjgtMC44LDMuOS0xLDUuNS0xYzYuMiwwLjMsMTEuNyw2LDExLjcsNnMtNS41LDQuMi0xMS40LDMuMWMtNS4yLTEtOC42LTMuNC05LjktNC45DQoJYy0xLjgsMS4zLTMuOSwyLjMtNS41LDMuNGMtMSwwLjgtMi4zLDEuMy0zLjQsMi4xYzIuMS0wLjMsNC4yLTAuMyw2LDBjNiwxLjMsMTAuNiw3LjgsMTAuNiw3LjhzLTYuNSwzLjQtMTEuOSwxDQoJYy00LjktMS44LTcuOC00LjktOS4zLTYuNWMtMy40LDEuOC02LjUsMi45LTkuMywzLjljMi4xLDAsNC4yLDAuMyw2LDFjNiwyLjMsOS40LDkuOSw5LjQsOS45cy03LjMsMi4xLTEyLjUtMQ0KCWMtNC40LTIuOS03LjMtNi4yLTguMy04LjNjLTUuNSwxLjMtMTAuOSwyLjMtMTcuMSwyLjlWMTkwYzQuOS0wLjMsOS42LTEsMTQtMi4xYzAtMi4xLDAtNi41LDEuOC0xMS40YzIuMy01LjUsOS4zLTcuOCw5LjMtNy44DQoJczEuOCw4LjMtMS44LDEzLjVjLTEsMS44LTMuMSwzLjQtNS4yLDQuOWMzLjEtMSw2LjUtMi4xLDkuOS0zLjljLTAuOC0yLjEtMS4zLTYuMiwwLTExLjRjMS4zLTYsNy41LTkuMyw3LjUtOS4zczMuMSw3LjUsMC44LDEzDQoJYy0wLjgsMS44LTIuMywzLjktNC4yLDUuNWw2LjItMy4xYzEtMC44LDIuMy0xLjMsMy40LTIuMWMtMS0xLjgtMi4zLTYtMi4xLTEwLjljMC4zLTYsNi0xMC40LDYtMTAuNHM0LjIsNywzLjEsMTIuNw0KCWMtMC4zLDIuMS0xLjgsNC40LTMuNCw2LjVjMy4xLTIuMSw2LTQuNCw4LjgtNy4zYy0xLTEuOC0zLjQtNS4yLTMuOS0xMC40Yy0wLjgtNS41LDMuOS0xMC45LDMuOS0xMC45czUuMiw2LDUuMiwxMS43DQoJYzAsMi4xLTEsNC40LTIuMSw2LjVjMi4zLTIuOSw0LjktNS41LDcuMy04LjZjLTEuMy0xLjMtNC4yLTQuNC01LjUtOS40Yy0xLjgtNS41LDEuOC0xMS40LDEuOC0xMS40czYsNC45LDcsMTAuNA0KCWMwLjMsMS44LDAsNC40LTAuOCw2LjVjMi4xLTMuMSwzLjktNi4yLDUuNS05LjNjLTEuOC0xLTQuOS0zLjktNy03LjhjLTIuMy00LjksMC0xMC45LDAtMTAuOXM2LjUsMy40LDguMyw4LjgNCgljMC44LDEuOCwwLjgsNC40LDAuMyw2LjVjMS44LTMuNCwyLjktNywzLjktMTAuNmMtMS44LTAuOC01LjItMi45LTguMy02LjVjLTMuMS00LjItMi4xLTEwLjYtMi4xLTEwLjZzNywyLjMsOS42LDcuMw0KCWMxLDEuOCwxLjMsNC40LDEuMyw3YzEtMy45LDEuOC03LjUsMi4xLTExLjdjLTEuOC0wLjMtNS41LTEuOC04LjgtNC45Yy0zLjktMy40LTMuOS05LjktMy45LTkuOXM3LjMsMSwxMC42LDUuNQ0KCWMxLjMsMS44LDIuMSw0LjIsMi45LDYuMmMwLjMtNC4yLDAuMy04LjMsMC0xMi41Yy0xLjgsMC01LjUtMC44LTkuNi0zLjRjLTQuNC0yLjktNS41LTguOC01LjUtOC44czcuMywwLDEwLjksMy40DQoJYzEuOCwxLjMsMi45LDQuMiwzLjksNi4yYy0wLjMtNC40LTEuMy04LjYtMi4zLTEyLjdjLTEuMy0wLjgtNS4yLTAuOC05LjYtMi4zYy00LjQtMi4xLTYuNS04LjEtNi41LTguMXM3LTEuMywxMC45LDEuMw0KCWMxLjgsMSwzLjQsMy40LDQuNCw1LjJjLTEuMy00LjItMi45LTguMy00LjQtMTEuOWMtMS44LDAuMy01LjIsMS4zLTkuNiwwLjNjLTQuOS0xLTcuOC02LjUtNy44LTYuNXM2LjItMi4zLDEwLjktMC44DQoJYzEuOCwwLjgsMy45LDIuOSw1LjUsNC4yYy0xLjgtMy45LTQuMi03LjUtNi41LTEwLjljLTEuMywwLjgtNC45LDIuMS05LjYsMi4xYy00LjktMC4zLTguNi00LjktOC42LTQuOXM1LjUtMy40LDEwLjYtMi4zDQoJYzIuMSwwLjMsNC45LDIuMSw2LjIsMy40Yy0yLjktMy45LTUuNS03LjMtOC42LTEwLjRjLTEsMC44LTQuMiwzLjEtOC44LDMuOWMtNC45LDAuOC05LjMtMy4xLTkuMy0zLjFzNS4yLTQuNCw5LjktNC4yDQoJYzIuMywwLDUuNSwxLjgsNy4zLDIuM2MtMS44LTEuOC0zLjQtMy4xLTUuMi00LjRjLTIuMS0xLjgtMy45LTMuMS01LjUtNC40Yy0xLDEtMy45LDMuOS04LjMsNS4yYy00LjQsMS4zLTkuNC0xLjgtOS40LTEuOA0KCXMzLjktNS4yLDguNi01LjVjMi4zLTAuMyw1LjUsMC44LDcuNSwxLjNjLTQuMi0yLjktOC4zLTUuMi0xMS43LTdjLTAuOCwxLTIuOSw0LjItNy4zLDYuNWMtNC4yLDIuMS05LjMsMC05LjMsMHMzLjEtNS41LDcuNS03DQoJYzIuMy0wLjgsNi4yLTAuMyw3LjgsMGMtMy4xLTEuMy02LTIuMy04LjMtMy40Yy0xLDAuMy00LjIsMS44LTcsMC44Yy00LjQtMC44LTctMy45LTctMy45czQuNC0xLjgsNy4zLTEuM2MzLjQsMC44LDYsMy45LDYuNSw0LjQNCgljMS44LDAuOCw0LjIsMS4zLDYuNSwyLjNjLTEuNi0xLTQuNC0zLjQtNS41LTUuNWMtMi4xLTQuMi0wLjMtMTAuNC0wLjMtMTAuNHM1LjIsMi4xLDYuNSw2LjVjMS44LDQuOSwxLDguNiwwLjgsOS42DQoJYzMuOSwxLjgsNy41LDMuOSwxMS45LDYuNWMtMS4zLTEuMy0zLjktMy45LTQuNC02LjJjLTEuMy00LjQsMS4zLTEwLjQsMS4zLTEwLjRzNC45LDMuMSw1LjUsNy41YzAuOCw1LjItMC41LDguOC0wLjgsOS45bDcuMyw1LjINCgljMSwwLjgsMi4xLDEuOCwzLjEsMi45Yy0xLTEuOC0yLjktNC4yLTIuOS02LjJjLTAuOC00LjksMy4xLTEwLjQsMy4xLTEwLjRzNC4yLDMuOSw0LjIsOC42YzAsNC45LTEuOCw3LjgtMi45LDkuMw0KCWMzLjEsMi45LDYsNiw4LjYsOS42Yy0wLjgtMS44LTEuOC00LjQtMS44LTYuNWMwLTUuMiw0LjktOS42LDQuOS05LjZzMy45LDQuOSwyLjksOS42Yy0xLDQuOS0zLjQsNy44LTQuMiw4LjgNCgljMi4zLDMuNCw0LjksNy4zLDcsMTAuOWMtMC4zLTIuMS0xLTQuOS0wLjgtN2MxLTUuMiw2LjUtOC44LDYuNS04LjhzMi45LDUuNSwxLDkuOWMtMS44LDQuNC00LjksNy4zLTYsOC4zDQoJYzEuOCwzLjksMy40LDcuNSw0LjksMTEuN2MwLTIuMSwwLTQuOSwwLjgtNi41YzIuMS00LjksOC4zLTcuNSw4LjMtNy41czEuOCw2LTAuOCwxMC40Yy0yLjMsNC4yLTYsNi4yLTcuMyw3LjMNCgljMSwzLjksMi4xLDcuNSwyLjMsMTEuN2MwLjMtMi4xLDEtNC4yLDEuOC02YzIuOS00LjQsOS42LTYuMiw5LjYtNi4yczAuOCw2LjItMi45LDEwLjRjLTMuMSwzLjQtNi41LDUuMi04LjMsNg0KCWMwLjMsMy45LDAuMyw3LjUsMC4zLDExLjdjMC44LTEuOCwxLjgtNC4yLDIuOS01LjVjMy45LTQuMiwxMC45LTQuNCwxMC45LTQuNHMtMC4zLDYuNS00LjQsOS42Yy0zLjksMy4xLTcuNSw0LjItOS4zLDQuNA0KCWMtMC4zLDMuOS0wLjgsNy4zLTEuMywxMC45YzEtMS44LDIuMS0zLjksMy45LTQuOWM0LjQtMy40LDExLjctMi45LDExLjctMi45cy0xLjMsNi41LTYuMiw4LjhDMjQyLDEyNS4yLDIzOC4xLDEyNS41LDIzNi41LDEyNS44eiINCgkvPg0KPHBhdGggaWQ9InNoYXBlUGF0aDMiIGNsYXNzPSJzdDIiIGQ9Ik0xOC41LDIxMy4zYzEuOCwwLDMuMSwxLjMsMy4xLDMuMXY0LjRjMCwxLjgtMS4zLDMuMS0zLjEsMy4xSDguNHY1LjVINS4zdi0xNi4xSDE4LjUNCgkgTTE4LjUsMjE2LjdDMTguNSwyMTYuNCwxOC41LDIxNi40LDE4LjUsMjE2LjdIOC4xdjQuNGgxMC40VjIxNi43IE0yNCwyMTMuM2gzLjF2MTMuNWgxMy41djMuMUgyNC4ydi0xNi42SDI0IE01NS42LDIxMy4zDQoJYzEuOCwwLDMuMSwxLjMsMy4xLDMuMXYxM2gtMy4xdi01LjVINDUuM3Y1LjVoLTIuOXYtMTNjMC0xLjgsMS4zLTMuMSwzLjEtMy4xSDU1LjYgTTU1LjksMjIxLjF2LTQuOUg0NnY0LjlINTUuOSBNNzUuOSwyMTMuM0g3OQ0KCXYxNi4xaC0zLjFsLTkuOS0xMnYxMS45aC0zLjF2LTE2LjFINjZsOS45LDExLjlWMjEzLjMgTTk3LjIsMjE2LjRIODUuM3YzLjloOS42djIuOWgtOS42djMuOWgxMS45djMuMUg4Mi4xdi0xNi4xaDE1LjFWMjE2LjQNCgkgTTExNS45LDIxMy4zdjMuMWgtNi41djEzLjVoLTMuMXYtMTMuNWgtNi41di0zLjFIMTE1LjkgTTEzOS41LDIxMy4zYzEuOCwwLDMuMSwxLjMsMy4xLDMuMXY0LjRjMCwxLjgtMS4zLDMuMS0zLjEsMy4xaC05Ljl2NS41DQoJaC0zLjF2LTE2LjFIMTM5LjUgTTE0MCwyMTYuN0MxNDAsMjE2LjQsMTM5LjUsMjE2LjQsMTQwLDIxNi43aC0xMC40djQuNGg5Ljl2LTQuNEgxNDAgTTE2MS42LDIyMC44YzAsMS44LTEuMywzLjEtMy4xLDMuMWgtMQ0KCWw0LjIsNC45djAuOGgtMy4xbC00LjktNS41aC01LjJ2NS41aC0zLjF2LTE2LjFoMTNjMS44LDAsMy4xLDEuMywzLjEsMy4xdjQuMiBNMTU4LjUsMjIxLjF2LTQuNGgtOS45djQuNEgxNTguNSBNMTc4LjIsMjEzLjMNCgljMS44LDAsMy4xLDEuMywzLjEsMy4xdjkuOWMwLDEuOC0xLjMsMy4xLTMuMSwzLjFoLTkuOWMtMS44LDAtMy4xLTEuMy0zLjEtMy4xdi05LjljMC0xLjgsMS4zLTMuMSwzLjEtMy4xSDE3OC4yIE0xNzguMiwyMjYuOA0KCXYtMTAuNGgtOS45djkuOWg5LjlWMjI2LjggTTIwMC4zLDIxMy4zdjMuMWgtNi41djEzLjVoLTMuMXYtMTMuNWgtN3YtMy4xSDIwMC4zIE0yMTcuNywyMTYuNGgtMTEuOXYzLjloOS42djIuOWgtOS42djMuOWgxMS45djMuMQ0KCWgtMTUuMXYtMTYuMWgxNS4xVjIxNi40IE0yMjQuNSwyMTYuNEMyMjMuOSwyMTYuNCwyMjMuOSwyMTYuNCwyMjQuNSwyMTYuNHYxMC40aDEzdjMuMWgtMTNjLTEuOCwwLTMuMS0xLjMtMy4xLTMuMXYtOS45DQoJYzAtMS44LDEuMy0zLjEsMy4xLTMuMWgxM3YzLjFoLTEzVjIxNi40IE0yNTYuMSwyMTMuM3YzLjFoLTYuNXYxMy41aC0zLjF2LTEzLjVIMjQwdi0zLjFIMjU2LjEgTTI3MiwyMTMuM2MxLjgsMCwzLjEsMS4zLDMuMSwzLjENCgl2OS45YzAsMS44LTEuMywzLjEtMy4xLDMuMWgtOS45Yy0xLjgsMC0zLjEtMS4zLTMuMS0zLjF2LTkuOWMwLTEuOCwxLjMtMy4xLDMuMS0zLjFIMjcyIE0yNzIsMjI2LjgNCglDMjcyLDIyNi44LDI3Mi4yLDIyNi44LDI3MiwyMjYuOHYtMTAuNGgtOS45djkuOWg5LjlWMjI2LjggTTI5NS4xLDIyMC44YzAsMS44LTEuMywzLjEtMy4xLDMuMWgtMWw0LjIsNC45djAuOEgyOTJsLTQuOS01LjVoLTUuMg0KCXY1LjVoLTMuMXYtMTYuMWgxM2MxLjgsMCwzLjEsMS4zLDMuMSwzLjF2NC4yIE0yOTEuNSwyMjEuMUMyOTIsMjIxLjEsMjkyLDIyMS4xLDI5MS41LDIyMS4xdi00LjRoLTkuOXY0LjRIMjkxLjUgTTMzLjMsMjM1LjQNCgljMy45LDAsNywzLjEsNyw3djI4LjNoLTYuOFYyNTloLTIydjExLjdINXYtMjguNmMwLTMuOSwzLjEtNyw3LTdoMjEuMyBNMzMuNiwyNTJ2LTkuOWMwLTAuMywwLTAuMy0wLjMtMC4zSDEyYy0wLjMsMC0wLjMsMC0wLjMsMC4zDQoJdjkuOUgzMy42IE01My44LDI0MS42QzUzLjgsMjQxLjYsNTMuNiwyNDEuOSw1My44LDI0MS42bC0wLjMsMjEuOGMwLDAuMywwLDAuMywwLjMsMC4zaDI3Ljh2Ni41SDUzLjhjLTMuOSwwLTctMy4xLTctN3YtMjEuMw0KCWMwLTMuOSwzLjEtNyw3LTdoMjcuOHY2LjVINTMuOCBNMTE3LjIsMjM1LjRjMy45LDAsNywzLjEsNyw3djI4LjNoLTYuNVYyNTlIOTUuNnYxMS43aC02LjV2LTI4LjZjMC0zLjksMy4xLTcsNy03aDIxIE0xMTcuMiwyNTINCgl2LTkuOWMwLTAuMywwLTAuMy0wLjMtMC4zSDk1LjZjLTAuMywwLTAuMywwLTAuMywwLjN2OS45SDExNy4yIE0xNTkuMywyMzUuNGMzLjksMCw3LDMuMSw3LDd2MjEuM2MwLDMuOS0zLjEsNy03LDdoLTI3Ljh2LTM1LjMNCglMMTU5LjMsMjM1LjQgTTE1OS41LDI0MS45QzE1OS41LDI0MS45LDE1OS41LDI0MS42LDE1OS41LDI0MS45bC0yMS44LTAuM2MtMC4zLDAtMC4zLDAtMC4zLDAuM3YyMS4zYzAsMC4zLDAsMC4zLDAuMywwLjNIMTU5DQoJYzAuMywwLDAuMywwLDAuMy0wLjN2LTIxLjMgTTIwNS44LDI0MS42aC0yNS41djcuOGgyMC44djYuNWgtMjAuOHY3LjhoMjUuNXY2LjVoLTMxLjl2LTM0LjhoMzEuOVYyNDEuNiBNMjQzLjcsMjM1LjRoN3YzNC44aC02LjgNCgl2LTI1LjVsLTEzLDE1LjhsLTEzLTE1Ljh2MjUuNWgtNi41di0zNC44aDdsMTIuNywxNS4xTDI0My43LDIzNS40IE0yOTUuMSwyMzUuNEwyNzksMjU3LjJ2MTNoLTYuNXYtMTNjLTUuMi03LTEwLjktMTQuOC0xNi4xLTIxLjgNCgloNy41bDExLjcsMTQuOGwxMS43LTE0LjhMMjk1LjEsMjM1LjQiLz4NCjxyZWN0IHg9IjQiIHk9IjI3OSIgY2xhc3M9InN0MyIgd2lkdGg9IjI5OSIgaGVpZ2h0PSI1MyIvPg0KPGcgY2xhc3M9InN0NCI+DQoJPHBhdGggY2xhc3M9InN0MCIgZD0iTTUuNiwyODEuN2MwLTAuNCwwLjMtMC44LDAuOC0wLjhoOS45YzUuMiwwLDkuNCw0LjIsOS40LDkuM2MwLDUuMi00LjIsOS41LTkuNCw5LjVIMTF2OS45DQoJCWMwLDAuNC0wLjQsMC44LTAuOCwwLjhINi40Yy0wLjUsMC0wLjgtMC40LTAuOC0wLjhWMjgxLjd6IE0xNi4xLDI5NC41YzIuNCwwLDQuMi0xLjksNC4yLTQuNGMwLTIuMy0xLjgtNC4xLTQuMi00LjFoLTV2OC40SDE2LjF6Ig0KCQkvPg0KCTxwYXRoIGNsYXNzPSJzdDAiIGQ9Ik00My40LDI4MS43YzAtMC40LDAuMy0wLjgsMC44LTAuOGgxMmM1LDAsOS4yLDQsOS4yLDljMCwzLjktMi42LDctNi4yLDguNWw1LjgsMTAuN2MwLjMsMC41LDAsMS4yLTAuNywxLjINCgkJaC00LjRjLTAuNCwwLTAuNi0wLjItMC43LTAuNGwtNS42LTExLjFoLTQuN3YxMC43YzAsMC40LTAuNCwwLjgtMC44LDAuOGgtMy45Yy0wLjUsMC0wLjgtMC40LTAuOC0wLjhWMjgxLjd6IE01NS43LDI5NC4zDQoJCWMyLjIsMCw0LjItMS45LDQuMi00LjNjMC0yLjItMS45LTQuMS00LjItNC4xaC02Ljh2OC40SDU1Ljd6Ii8+DQoJPHBhdGggY2xhc3M9InN0MCIgZD0iTTg0LjIsMjgxLjdjMC0wLjQsMC4zLTAuOCwwLjgtMC44SDEwMmMwLjUsMCwwLjgsMC40LDAuOCwwLjh2My40YzAsMC40LTAuMywwLjgtMC44LDAuOEg4OS42djYuOUgxMDANCgkJYzAuNCwwLDAuOCwwLjQsMC44LDAuOHYzLjVjMCwwLjUtMC40LDAuOC0wLjgsMC44SDg5LjZ2Ny40SDEwMmMwLjUsMCwwLjgsMC40LDAuOCwwLjh2My40YzAsMC40LTAuMywwLjgtMC44LDAuOEg4NC45DQoJCWMtMC41LDAtMC44LTAuNC0wLjgtMC44VjI4MS43eiIvPg0KCTxwYXRoIGNsYXNzPSJzdDAiIGQ9Ik0xMjAsMzA3LjVjLTAuNC0wLjMtMC42LTAuNi0wLjItMS4zbDEuNS0yLjZjMC4zLTAuNiwxLjEtMC42LDEuNC0wLjNjMS43LDEuMywzLjYsMi42LDYuMywyLjYNCgkJYzIuMiwwLDMuOC0xLjQsMy44LTMuMmMwLTIuMS0xLjgtMy42LTUuMy01Yy0zLjktMS42LTcuOS00LjEtNy45LTkuMWMwLTMuNywyLjgtOC4xLDkuNS04LjFjNC4zLDAsNy42LDIuMiw4LjQsMi44DQoJCWMwLjQsMC4zLDAuNSwxLDAuMywxLjRsLTEuNiwyLjRjLTAuMywwLjUtMSwwLjgtMS41LDAuNWMtMS44LTEuMS0zLjUtMi4zLTUuOC0yLjNjLTIuNCwwLTMuNywxLjMtMy43LDIuOWMwLDIsMS42LDMuMyw1LDQuNw0KCQljNC4xLDEuNiw4LjgsNC4xLDguOCw5LjVjMCw0LjMtMy43LDguMy05LjcsOC4zQzEyMy45LDMxMC44LDEyMS4yLDMwOC41LDEyMCwzMDcuNXoiLz4NCgk8cGF0aCBjbGFzcz0ic3QwIiBkPSJNMTU3LjEsMjgxLjdjMC0wLjQsMC4zLTAuOCwwLjgtMC44SDE3NWMwLjUsMCwwLjgsMC40LDAuOCwwLjh2My40YzAsMC40LTAuMywwLjgtMC44LDAuOGgtMTIuNHY2LjlIMTczDQoJCWMwLjQsMCwwLjgsMC40LDAuOCwwLjh2My41YzAsMC41LTAuNCwwLjgtMC44LDAuOGgtMTAuNHY3LjRIMTc1YzAuNSwwLDAuOCwwLjQsMC44LDAuOHYzLjRjMCwwLjQtMC4zLDAuOC0wLjgsMC44aC0xNy4xDQoJCWMtMC41LDAtMC44LTAuNC0wLjgtMC44VjI4MS43eiIvPg0KCTxwYXRoIGNsYXNzPSJzdDAiIGQ9Ik0xOTQuNCwyODEuM2MwLTAuNCwwLjQtMC44LDAuOC0wLjhoMC42YzAuMywwLDAuNSwwLjEsMC43LDAuM2wxNy4xLDE4LjNoMC4xdi0xNy4zYzAtMC40LDAuMy0wLjgsMC44LTAuOGgzLjkNCgkJYzAuNCwwLDAuOCwwLjQsMC44LDAuOFYzMTBjMCwwLjQtMC40LDAuOC0wLjgsMC44aC0wLjZjLTAuMywwLTAuNS0wLjEtMC43LTAuM2wtMTcuMi0xOWgtMC4xdjE4LjFjMCwwLjQtMC4zLDAuOC0wLjgsMC44aC0zLjgNCgkJYy0wLjQsMC0wLjgtMC40LTAuOC0wLjhWMjgxLjN6Ii8+DQoJPHBhdGggY2xhc3M9InN0MCIgZD0iTTI0NC4yLDI4NmgtNi40Yy0wLjUsMC0wLjgtMC40LTAuOC0wLjh2LTMuNGMwLTAuNCwwLjMtMC44LDAuOC0wLjhoMTguNGMwLjUsMCwwLjgsMC40LDAuOCwwLjh2My40DQoJCWMwLDAuNC0wLjMsMC44LTAuOCwwLjhoLTYuNHYyMy42YzAsMC40LTAuNCwwLjgtMC44LDAuOEgyNDVjLTAuNCwwLTAuOC0wLjQtMC44LTAuOFYyODZ6Ii8+DQoJPHBhdGggY2xhc3M9InN0MCIgZD0iTTI3My40LDMwNy41Yy0wLjQtMC4zLTAuNi0wLjYtMC4yLTEuM2wxLjUtMi42YzAuMy0wLjYsMS0wLjYsMS40LTAuM2MxLjcsMS4zLDMuNiwyLjYsNi4zLDIuNg0KCQljMi4yLDAsMy44LTEuNCwzLjgtMy4yYzAtMi4xLTEuOC0zLjYtNS4zLTVjLTMuOS0xLjYtNy45LTQuMS03LjktOS4xYzAtMy43LDIuOC04LjEsOS41LTguMWM0LjMsMCw3LjYsMi4yLDguNCwyLjgNCgkJYzAuNCwwLjMsMC41LDEsMC4zLDEuNGwtMS42LDIuNGMtMC4zLDAuNS0xLDAuOC0xLjUsMC41Yy0xLjgtMS4xLTMuNS0yLjMtNS44LTIuM2MtMi40LDAtMy43LDEuMy0zLjcsMi45YzAsMiwxLjYsMy4zLDUsNC43DQoJCWM0LjEsMS42LDguOCw0LjEsOC44LDkuNWMwLDQuMy0zLjcsOC4zLTkuNyw4LjNDMjc3LjQsMzEwLjgsMjc0LjYsMzA4LjUsMjczLjQsMzA3LjV6Ii8+DQo8L2c+DQo8L3N2Zz4NCg=="

/***/ }),
/* 2290 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/epsHybridIntermediates/sections/20_gameShow/title_gameshow-4db1c3edea9555aba358c3928e2305e0.png";

/***/ }),
/* 2291 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/epsHybridIntermediates/sections/20_gameShow/title_gameshow_players-1f3dab0745c16a508ea646d3d95269a3.png";

/***/ }),
/* 2292 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0NzAuMiIgaGVpZ2h0PSI0NzAuMiIgdmlld0JveD0iMCAwIDQ3MC4yIDQ3MC4yIj48c3R5bGU+LnN0MHtvcGFjaXR5OjAuNTtmaWxsOm5vbmU7c3Ryb2tlOiNGRkZGRkY7c3Ryb2tlLXdpZHRoOjIwLjI1O3N0cm9rZS1saW5lY2FwOnJvdW5kO3N0cm9rZS1taXRlcmxpbWl0OjEwO30gLnN0MXtmaWxsOm5vbmU7c3Ryb2tlOiNGRkZGRkY7c3Ryb2tlLXdpZHRoOjIwLjI1O3N0cm9rZS1saW5lY2FwOnJvdW5kO3N0cm9rZS1taXRlcmxpbWl0OjEwO308L3N0eWxlPjxjaXJjbGUgY2xhc3M9InN0MCIgY3g9IjIzNS4xIiBjeT0iMjM1LjEiIHI9IjIyNSIvPjxwYXRoIGNsYXNzPSJzdDEiIGQ9Ik00MjkuMiAxMjIuNkMzODYuNCA0OC42IDMxMiAxMC4yIDIzNC4zIDEwLjFNNDI5LjIgMzQ3LjZjNDIuOC03NCAzOC44LTE1Ny43IDAtMjI1Ii8+PC9zdmc+"

/***/ }),
/* 2293 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0NzAuMiIgaGVpZ2h0PSI0NzAuMiIgdmlld0JveD0iMCAwIDQ3MC4yIDQ3MC4yIj48c3R5bGU+LnN0MHtvcGFjaXR5OjAuNTtmaWxsOm5vbmU7c3Ryb2tlOiNGRkZGRkY7c3Ryb2tlLXdpZHRoOjIwLjI1O3N0cm9rZS1saW5lY2FwOnJvdW5kO3N0cm9rZS1taXRlcmxpbWl0OjEwO30gLnN0MXtmaWxsOm5vbmU7c3Ryb2tlOiNGRkZGRkY7c3Ryb2tlLXdpZHRoOjIwLjI1O3N0cm9rZS1saW5lY2FwOnJvdW5kO3N0cm9rZS1taXRlcmxpbWl0OjEwO308L3N0eWxlPjxjaXJjbGUgY2xhc3M9InN0MCIgY3g9IjIzNS4xIiBjeT0iMjM1LjEiIHI9IjIyNSIvPjxwYXRoIGNsYXNzPSJzdDEiIGQ9Ik00MjkuMiAxMjIuNkMzODYuNCA0OC42IDMxMiAxMC4yIDIzNC4zIDEwLjFNNDI5LjIgMzQ3LjZjNDIuOC03NCAzOC44LTE1Ny43IDAtMjI1TTIzNC40IDQ2MC4xYzg1LjUgMCAxNTUuOS00NS4zIDE5NC44LTExMi41TTM5LjUgMzQ3LjZjNDIuOCA3NCAxMTguNCAxMTIuNCAxOTQuOSAxMTIuNSIvPjwvc3ZnPg=="

/***/ }),
/* 2294 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0NzAuMiIgaGVpZ2h0PSI0NzAuMiIgdmlld0JveD0iMCAwIDQ3MC4yIDQ3MC4yIj48c3R5bGU+LnN0MHtmaWxsOm5vbmU7c3Ryb2tlOiNGRkZGRkY7c3Ryb2tlLXdpZHRoOjIwLjI1O3N0cm9rZS1saW5lY2FwOnJvdW5kO3N0cm9rZS1taXRlcmxpbWl0OjEwO308L3N0eWxlPjxjaXJjbGUgY2xhc3M9InN0MCIgY3g9IjIzNS4xIiBjeT0iMjM1LjEiIHI9IjIyNSIvPjwvc3ZnPg=="

/***/ }),
/* 2295 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/epsHybridPrimaries/images/characters/ian_hand_raised-384fabc0cb5b98efe85310c0d8c15540.png";

/***/ }),
/* 2296 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/epsHybridPrimaries/images/characters/ian_pointing_down-026a77087cf65bf8bbd037d9b72502c3.png";

/***/ }),
/* 2297 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/epsHybridPrimaries/images/characters/ian_pointing_left-4596053eb82e04f727bdd744c3de0325.png";

/***/ }),
/* 2298 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/epsHybridPrimaries/images/characters/ian_sara_two_fingers-5ed565638eae000314880d23ff009b43.png";

/***/ }),
/* 2299 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/epsHybridPrimaries/images/characters/ian_shrug_laugh-f19e9de88cd7960d4eff1c212c0e2d5f.png";

/***/ }),
/* 2300 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/epsHybridPrimaries/images/characters/sara_humph-a0889c055339bc1bd36428414d9e217e.png";

/***/ }),
/* 2301 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/epsHybridPrimaries/images/characters/sara_twist_hands_out_yay-bcf1fb30eda8e0aa404ef594e2dd3fd6.png";

/***/ }),
/* 2302 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/epsHybridPrimaries/images/emergencyPreparednessSquad-2064b85d3eb2aec8ecdcf1800236cfec.png";

/***/ }),
/* 2303 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/epsHybridPrimaries/images/emergencyPreparednessSquadExpired-1761c2ab001f953107b074296a12fde4.png";

/***/ }),
/* 2304 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/epsHybridPrimaries/images/emergencyPreparednessSquadTrial-2064b85d3eb2aec8ecdcf1800236cfec.png";

/***/ }),
/* 2305 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/epsHybridPrimaries/images/level-0_start-fa7258753d8cfafa05d92649458bde53.png";

/***/ }),
/* 2306 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 2307 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 2308 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 2309 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 2310 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/epsHybridPrimaries/sections/20_gameShow/title_gameshow-4db1c3edea9555aba358c3928e2305e0.png";

/***/ }),
/* 2311 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/epsHybridPrimaries/sections/20_gameShow/title_gameshow_players-1f3dab0745c16a508ea646d3d95269a3.png";

/***/ }),
/* 2312 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0NzAuMiIgaGVpZ2h0PSI0NzAuMiIgdmlld0JveD0iMCAwIDQ3MC4yIDQ3MC4yIj48c3R5bGU+LnN0MHtvcGFjaXR5OjAuNTtmaWxsOm5vbmU7c3Ryb2tlOiNGRkZGRkY7c3Ryb2tlLXdpZHRoOjIwLjI1O3N0cm9rZS1saW5lY2FwOnJvdW5kO3N0cm9rZS1taXRlcmxpbWl0OjEwO30gLnN0MXtmaWxsOm5vbmU7c3Ryb2tlOiNGRkZGRkY7c3Ryb2tlLXdpZHRoOjIwLjI1O3N0cm9rZS1saW5lY2FwOnJvdW5kO3N0cm9rZS1taXRlcmxpbWl0OjEwO308L3N0eWxlPjxjaXJjbGUgY2xhc3M9InN0MCIgY3g9IjIzNS4xIiBjeT0iMjM1LjEiIHI9IjIyNSIvPjxwYXRoIGNsYXNzPSJzdDEiIGQ9Ik00MjkuMiAxMjIuNkMzODYuNCA0OC42IDMxMiAxMC4yIDIzNC4zIDEwLjFNNDI5LjIgMzQ3LjZjNDIuOC03NCAzOC44LTE1Ny43IDAtMjI1Ii8+PC9zdmc+"

/***/ }),
/* 2313 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0NzAuMiIgaGVpZ2h0PSI0NzAuMiIgdmlld0JveD0iMCAwIDQ3MC4yIDQ3MC4yIj48c3R5bGU+LnN0MHtvcGFjaXR5OjAuNTtmaWxsOm5vbmU7c3Ryb2tlOiNGRkZGRkY7c3Ryb2tlLXdpZHRoOjIwLjI1O3N0cm9rZS1saW5lY2FwOnJvdW5kO3N0cm9rZS1taXRlcmxpbWl0OjEwO30gLnN0MXtmaWxsOm5vbmU7c3Ryb2tlOiNGRkZGRkY7c3Ryb2tlLXdpZHRoOjIwLjI1O3N0cm9rZS1saW5lY2FwOnJvdW5kO3N0cm9rZS1taXRlcmxpbWl0OjEwO308L3N0eWxlPjxjaXJjbGUgY2xhc3M9InN0MCIgY3g9IjIzNS4xIiBjeT0iMjM1LjEiIHI9IjIyNSIvPjxwYXRoIGNsYXNzPSJzdDEiIGQ9Ik00MjkuMiAxMjIuNkMzODYuNCA0OC42IDMxMiAxMC4yIDIzNC4zIDEwLjFNNDI5LjIgMzQ3LjZjNDIuOC03NCAzOC44LTE1Ny43IDAtMjI1TTIzNC40IDQ2MC4xYzg1LjUgMCAxNTUuOS00NS4zIDE5NC44LTExMi41TTM5LjUgMzQ3LjZjNDIuOCA3NCAxMTguNCAxMTIuNCAxOTQuOSAxMTIuNSIvPjwvc3ZnPg=="

/***/ }),
/* 2314 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0NzAuMiIgaGVpZ2h0PSI0NzAuMiIgdmlld0JveD0iMCAwIDQ3MC4yIDQ3MC4yIj48c3R5bGU+LnN0MHtmaWxsOm5vbmU7c3Ryb2tlOiNGRkZGRkY7c3Ryb2tlLXdpZHRoOjIwLjI1O3N0cm9rZS1saW5lY2FwOnJvdW5kO3N0cm9rZS1taXRlcmxpbWl0OjEwO308L3N0eWxlPjxjaXJjbGUgY2xhc3M9InN0MCIgY3g9IjIzNS4xIiBjeT0iMjM1LjEiIHI9IjIyNSIvPjwvc3ZnPg=="

/***/ }),
/* 2315 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/epsIntermediates/images/characters/ian_hand_raised-384fabc0cb5b98efe85310c0d8c15540.png";

/***/ }),
/* 2316 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/epsIntermediates/images/characters/ian_pointing_down-026a77087cf65bf8bbd037d9b72502c3.png";

/***/ }),
/* 2317 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/epsIntermediates/images/characters/ian_pointing_left-4596053eb82e04f727bdd744c3de0325.png";

/***/ }),
/* 2318 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/epsIntermediates/images/characters/ian_sara_silly-8139b5d7a02986b6a0cea289575bc98a.png";

/***/ }),
/* 2319 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/epsIntermediates/images/characters/ian_sara_two_fingers-5ed565638eae000314880d23ff009b43.png";

/***/ }),
/* 2320 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/epsIntermediates/images/characters/ian_shrug_laugh-f19e9de88cd7960d4eff1c212c0e2d5f.png";

/***/ }),
/* 2321 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/epsIntermediates/images/characters/sara_humph-a0889c055339bc1bd36428414d9e217e.png";

/***/ }),
/* 2322 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/epsIntermediates/images/characters/sara_twist_hands_out_yay-bcf1fb30eda8e0aa404ef594e2dd3fd6.png";

/***/ }),
/* 2323 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/epsIntermediates/images/emergencyPreparednessSquad-2064b85d3eb2aec8ecdcf1800236cfec.png";

/***/ }),
/* 2324 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/epsIntermediates/images/emergencyPreparednessSquadExpired-1761c2ab001f953107b074296a12fde4.png";

/***/ }),
/* 2325 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/epsIntermediates/images/emergencyPreparednessSquadTrial-2064b85d3eb2aec8ecdcf1800236cfec.png";

/***/ }),
/* 2326 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/epsIntermediates/images/overview/level-1_start-6bf328c5226bf5e0a3bcc8c8ee12412b.png";

/***/ }),
/* 2327 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 2328 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 2329 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 2330 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAyMS4wLjIsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iTGF5ZXJfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiDQoJIHZpZXdCb3g9IjAgMCAzMDAgMzMwIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCAzMDAgMzMwOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+DQo8c3R5bGUgdHlwZT0idGV4dC9jc3MiPg0KCS5zdDB7ZmlsbDojQjRFMTY2O30NCgkuc3Qxe2ZpbGw6IzI2Q0VFODt9DQoJLnN0MntmaWxsOiMwMERFRkY7fQ0KCS5zdDN7ZmlsbDpub25lO30NCgkuc3Q0e2VuYWJsZS1iYWNrZ3JvdW5kOm5ldyAgICA7fQ0KPC9zdHlsZT4NCjxwYXRoIGlkPSJzaGFwZVBhdGgxIiBjbGFzcz0ic3QwIiBkPSJNMjEyLjQsMTAwLjFjMC02LTIuOS0xMC45LTcuMy0xNC44YzIuMS01LjUsMi4xLTExLjQtMS0xNi42Yy0yLjktNS4yLTguMS03LjgtMTMuOC04LjgNCgljLTEtNi00LjItMTAuOS04LjgtMTMuOGMtNC45LTIuOS0xMC45LTMuMS0xNi42LTFjLTMuOS00LjQtOC44LTcuMy0xNC44LTcuM3MtMTAuOSwyLjktMTQuOCw3LjNjLTUuNS0yLjEtMTEuNC0yLjEtMTYuNiwxDQoJYy01LjIsMi45LTcuOCw4LjEtOC44LDEzLjhjLTYsMS0xMC45LDQuMi0xMy44LDguOGMtMi45LDUuMi0zLjEsMTAuOS0xLDE2LjZjLTQuNCwzLjktNy4zLDguOC03LjMsMTQuOHMyLjksMTAuOSw3LjMsMTQuOA0KCWMtMi4xLDUuNS0yLjEsMTEuNCwxLDE2LjZzNy44LDcuOCwxMy44LDguOGMxLDYsNC4yLDEwLjksOC44LDEzLjhjNC45LDIuOSwxMC45LDMuMSwxNi42LDFjMy45LDQuNCw4LjgsNy4zLDE0LjgsNy4zDQoJczEwLjktMi45LDE0LjgtNy4zYzUuNSwyLjEsMTEuNCwyLjEsMTYuNi0xYzUuMi0yLjksNy44LTcuOCw4LjgtMTMuOGM2LTEsMTAuOS00LjIsMTMuOC04LjhjMi45LTUuMiwzLjEtMTAuOSwxLTE2LjYNCglDMjA5LjUsMTExLDIxMi40LDEwNS41LDIxMi40LDEwMC4xIE0xODUuMSwxMzQuOWMtNC40LDAtOS42LTEuMy0xNS4xLTQuMmMtMS03LjUtMy45LTEzLjgtNy41LTE4LjJjNC40LDMuOSwxMC42LDYuNSwxOC4yLDcuNQ0KCUMxODMuOCwxMjQuNywxODUuMSwxMzAuNCwxODUuMSwxMzQuOSBNMTUyLjEsMTM2LjJjMi45LTcuMywzLjktMTMuOCwyLjktMTkuN2MyLjEsNS41LDYuMiwxMC45LDExLjksMTUuOGMwLDYtMS44LDExLjQtMy45LDE1LjENCglDMTU4LjksMTQ1LjIsMTU1LjIsMTQxLjMsMTUyLjEsMTM2LjIgTTEzNy42LDE0Ny42Yy0yLjMtMy45LTMuOS05LjMtMy45LTE1LjFjNi00LjksOS45LTEwLjQsMTEuOS0xNS44Yy0xLDYsMCwxMi43LDIuOSwxOS43DQoJQzE0NS4xLDE0MS4zLDE0MS4yLDE0NS4yLDEzNy42LDE0Ny42IE0xMTUuMiwxMzQuOWMwLTQuNCwxLjMtOS42LDQuMi0xNS4xYzcuNS0xLDEzLjgtMy45LDE4LjItNy41Yy0zLjksNC40LTYuNSwxMC42LTcuNSwxOC4yDQoJQzEyNS4xLDEzMy42LDExOS45LDEzNC45LDExNS4yLDEzNC45IE0xMTUuMiw2NWM0LjQsMCw5LjYsMS4zLDE1LjEsNC4yYzEsNy41LDMuOSwxMy44LDcuNSwxOC4yYy00LjQtMy45LTEwLjYtNi41LTE4LjItNy41DQoJQzExNi41LDc0LjksMTE1LjIsNjkuNywxMTUuMiw2NSBNMTQ4LjIsNjMuNGMtMi45LDcuMy0zLjksMTMuOC0yLjksMTkuN2MtMi4xLTUuNS02LjItMTAuOS0xMS45LTE1LjhjMC02LDEuOC0xMS40LDMuOS0xNS4xDQoJQzE0MS4yLDU0LjYsMTQ1LjEsNTguNSwxNDguMiw2My40IE0xMzMuNCw5NS42Yy02LTEtMTIuNywwLTE5LjcsMi45Yy01LjItMy4xLTguOC03LTExLjQtMTAuOWMzLjktMi4zLDkuMy0zLjksMTUuMS0zLjkNCglDMTIyLjUsODkuNCwxMjgsOTMuNiwxMzMuNCw5NS42IE0xMzMuNCwxMDQuNWMtNS41LDIuMS0xMC45LDYuMi0xNS44LDExLjljLTYsMC0xMS40LTEuOC0xNS4xLTMuOWMyLjMtMy45LDYuMi03LjgsMTEuNC0xMC45DQoJQzEyMC43LDEwNC41LDEyNy41LDEwNS41LDEzMy40LDEwNC41IE0xNDYuNCwxMTQuMWMtMi4xLDUuMi03LDEwLjQtMTIuNywxNC41YzAuMy03LjMsMi45LTEzLjgsNi4yLTE4LjINCgljLTQuNCwzLjQtMTAuOSw1LjUtMTguMiw2LjJjNC4yLTYsOS4zLTEwLjYsMTQuNS0xMi43Yy01LjUsMC44LTEyLjUtMC44LTE5LTMuOWM2LjUtMy4xLDEzLjUtNC40LDE5LTMuOWMtNS4yLTIuMS0xMC40LTctMTQuNS0xMi43DQoJYzcuMywwLjMsMTMuOCwyLjksMTguMiw2LjJjLTMuNC00LjQtNS41LTEwLjktNi4yLTE4LjJjNiw0LjIsMTAuNiw5LjMsMTIuNywxNC41Yy0wLjgtNS41LDAuOC0xMi41LDMuOS0xOWMzLjEsNi41LDQuNCwxMy41LDMuOSwxOQ0KCWMyLjEtNS4yLDctMTAuNCwxMi43LTE0LjVjLTAuMyw3LjMtMi45LDEzLjgtNi4yLDE4LjJjNC40LTMuNCwxMC45LTUuNSwxOC4yLTYuMmMtNC4yLDYtOS40LDEwLjYtMTQuNSwxMi43DQoJYzUuNS0wLjgsMTIuNSwwLjgsMTksMy45Yy02LjUsMy4xLTEzLjUsNC40LTE5LDMuOWM1LjIsMi4xLDEwLjQsNywxNC41LDEyLjdjLTcuMy0wLjMtMTMuOC0yLjktMTguMi02LjJjMy40LDQuNCw1LjUsMTAuOSw2LjIsMTguMg0KCWMtNi00LjItMTAuOS05LjMtMTIuNy0xNC41YzAuOCw1LjUtMC44LDEyLjUtMy45LDE5QzE0Ny4yLDEyNi41LDE0NS45LDExOS44LDE0Ni40LDExNC4xIE0xNjMsNTIuM2MyLjMsMy45LDMuOSw5LjMsMy45LDE1LjENCgljLTYsNC45LTkuOSwxMC40LTExLjksMTUuOGMxLTYsMC0xMi43LTIuOS0xOS43QzE1NS4yLDU4LjUsMTU4LjksNTQuNiwxNjMsNTIuMyBNMTg1LjEsNjVjMCw0LjQtMS4zLDkuNi00LjIsMTUuMQ0KCWMtNy41LDEtMTMuOCwzLjktMTguMiw3LjVjMy45LTQuNCw2LjUtMTAuNiw3LjUtMTguMkMxNzUuNSw2Ni4zLDE4MC43LDY1LDE4NS4xLDY1IE0xNjYuOSwxMDQuNWM2LDEsMTIuNywwLDE5LjctMi45DQoJYzUuMiwzLjEsOC44LDcsMTEuNCwxMC45Yy0zLjksMi4zLTkuNCwzLjktMTUuMSwzLjlDMTc3LjgsMTEwLjcsMTcyLjQsMTA2LjUsMTY2LjksMTA0LjUgTTE2Ni45LDk1LjZjNS41LTIuMSwxMC45LTYuMiwxNS44LTExLjkNCgljNiwwLDExLjQsMS44LDE1LjEsMy45Yy0yLjMsMy45LTYuMiw3LjgtMTEuNCwxMC45QzE3OS43LDk1LjEsMTcyLjYsOTQuNiwxNjYuOSw5NS42IE0xOTguOSw3MS43YzEuOCwzLjEsMi4xLDYuNSwxLjMsMTAuNA0KCWMtMy40LTEuOC03LjMtMi4zLTExLjQtMi4zaC0zLjFjMC44LTEsMS0xLjgsMS44LTIuOWMyLjEtMy45LDMuMS03LjUsMy40LTExLjRDMTkzLjksNjYuNiwxOTcuMSw2OC42LDE5OC45LDcxLjcgTTE3OC4xLDUxLjUNCgljMy4xLDEuOCw1LjIsNC40LDYuMiw4LjNjLTMuOSwwLjMtNy41LDEuMy0xMS40LDMuNGMtMSwwLjgtMS44LDEtMi45LDEuOHYtMy4xYzAtNC4yLTEtNy44LTIuMy0xMS40DQoJQzE3MS42LDQ5LjQsMTc1LDQ5LjcsMTc4LjEsNTEuNSBNMTUwLjMsNDRjMy40LDAsNywxLjMsOS4zLDQuMmMtMy4xLDIuMS02LDUuMi03LjgsOC42Yy0wLjgsMS0xLDEuOC0xLjMsMi45Yy0wLjMtMS0xLTEuOC0xLjMtMi45DQoJYy0yLjEtMy45LTQuOS02LjUtNy44LTguNkMxNDMuMyw0NS4zLDE0Ni40LDQ0LDE1MC4zLDQ0IE0xMjIsNTEuNWMzLjEtMS44LDYuNS0yLjEsMTAuNC0xLjNjLTEuOCwzLjQtMi4zLDcuMy0yLjMsMTEuNHYzLjENCgljLTEtMC44LTEuOC0xLTIuOS0xLjhjLTMuOS0yLjEtNy41LTMuMS0xMS40LTMuNEMxMTcuMyw1NS45LDExOC45LDUzLjMsMTIyLDUxLjUgTTEwMS43LDcxLjdjMS44LTMuMSw0LjQtNS4yLDguMy02LjINCgljMC4zLDMuOSwxLjMsNy41LDMuNCwxMS40YzAuOCwxLDEsMS44LDEuOCwyLjloLTMuMWMtNC4yLDAtNy44LDEtMTEuNCwyLjNDOTkuNyw3OC44LDk5LjksNzQuOSwxMDEuNyw3MS43IE05NC4yLDEwMC4xDQoJYzAtMy40LDEuMy03LDQuMi05LjNjMi4xLDMuMSw1LjIsNiw4LjYsNy44YzEsMC44LDEuOCwxLDIuOSwxLjNjLTEsMC4zLTEuOCwxLTIuOSwxLjNjLTMuOSwyLjEtNi41LDQuOS04LjYsNy44DQoJQzk1LjUsMTA2LjUsOTQuMiwxMDMuNCw5NC4yLDEwMC4xIE0xMDEuNywxMjcuOGMtMS44LTMuMS0yLjEtNi41LTEuMy0xMC40YzMuNCwxLjgsNy4zLDIuMywxMS40LDIuM2gzLjFjLTAuOCwxLTEsMS44LTEuOCwyLjkNCgljLTIuMSwzLjktMy4xLDcuNS0zLjQsMTEuNEMxMDYuMiwxMzMsMTAzLjYsMTMxLDEwMS43LDEyNy44IE0xMjIsMTQ4LjZjLTMuMS0xLjgtNS4yLTQuNC02LjItOC4zYzMuOS0wLjMsNy41LTEuMywxMS40LTMuNA0KCWMxLTAuOCwxLjgtMSwyLjktMS44djMuMWMwLDQuMiwxLDcuOCwyLjMsMTEuNEMxMjguNSwxNTAuNywxMjUuMSwxNTAuNCwxMjIsMTQ4LjYgTTE1MC4zLDE1Ni4yYy0zLjQsMC03LTEuMy05LjQtNC4yDQoJYzMuMS0yLjEsNi01LjIsNy44LTguNmMwLjgtMSwxLTEuOCwxLjMtMi45YzAuMywxLDEsMS44LDEuMywyLjljMi4xLDMuOSw0LjksNi41LDcuOCw4LjZDMTU2LjgsMTU0LjYsMTUzLjcsMTU2LjIsMTUwLjMsMTU2LjINCgkgTTE3OC4xLDE0OC42Yy0zLjEsMS44LTYuNSwyLjEtMTAuNCwxLjNjMS44LTMuNCwyLjMtNy4zLDIuMy0xMS40di0zLjFjMSwwLjgsMS44LDEsMi45LDEuOGMzLjksMi4xLDcuNSwzLjEsMTEuNCwzLjQNCglDMTgzLjMsMTQzLjcsMTgxLjIsMTQ2LjgsMTc4LjEsMTQ4LjYgTTE5OC45LDEyNy44Yy0xLjgsMy4xLTQuNCw1LjItOC4zLDYuMmMtMC4zLTMuOS0xLjMtNy41LTMuNC0xMS40Yy0wLjgtMS0xLTEuOC0xLjgtMi45aDMuMQ0KCWM0LjIsMCw4LjEtMSwxMS40LTIuM0MyMDEsMTIxLjMsMjAwLjcsMTI0LjcsMTk4LjksMTI3LjggTTIwMi4yLDEwOS40Yy0yLjEtMy4xLTUuMi02LTguNi03LjhjLTEtMC44LTEuOC0xLTIuOS0xLjMNCgljMS0wLjMsMS44LTEsMi45LTEuM2MzLjktMi4xLDYuNS00LjksOC42LTcuOGMyLjksMi45LDQuMiw2LDQuMiw5LjNDMjA2LjQsMTAzLjQsMjA0LjYsMTA2LjUsMjAyLjIsMTA5LjR6Ii8+DQo8cGF0aCBpZD0ic2hhcGVQYXRoMiIgY2xhc3M9InN0MSIgZD0iTTEzMC4zLDE4Ny42YzQuNCwxLDkuNCwxLjgsMTQsMi4xdjMuMWMtNi0wLjMtMTEuNC0xLjMtMTYuOS0yLjljLTEuMywxLjgtMy45LDUuMi04LjYsNy44DQoJYy01LjIsMy4xLTEyLjUsMS0xMi41LDFzMy40LTcuNSw5LjMtOS45YzEuOC0wLjgsMy45LTEsNi0xYy0zLjEtMS02LjItMi4xLTkuMy0zLjljLTEuMywxLjgtNC40LDQuNC05LjMsNi41DQoJYy01LjUsMi4xLTExLjktMS0xMS45LTFzNC40LTYuNSwxMC42LTcuOGMxLjgtMC4zLDMuOSwwLDYsMGwtMy40LTIuMWMtMS44LTEtMy45LTIuMS01LjUtMy40Yy0xLjgsMS4zLTUuMiwzLjktOS45LDQuOQ0KCWMtNiwxLjMtMTEuNy0zLjEtMTEuNy0zLjFzNS41LTUuNSwxMS43LTZjMS44LDAsMy45LDAuMyw1LjUsMWMtMi4zLTIuMS01LjItNC40LTcuNS03Yy0xLjgsMS01LjUsMi45LTEwLjYsMi45DQoJYy02LDAtMTAuNi01LjItMTAuNi01LjJzNi4yLTQuNCwxMS45LTMuOWMxLjgsMC4zLDMuOSwxLjMsNS41LDIuMWMtMi4zLTIuOS00LjQtNS41LTYuNS04LjZjLTEuOCwwLjgtNiwxLjgtMTAuOSwxDQoJYy01LjUtMC44LTkuMy02LjUtOS4zLTYuNXM3LTMuNCwxMi41LTEuOGMxLjgsMC44LDMuOSwyLjEsNS41LDMuNGMtMi4xLTMuMS0zLjktNi41LTUuNS05LjljLTEuOCwwLjMtNiwwLjgtMTAuNi0xDQoJYy01LjItMS44LTcuOC03LjgtNy44LTcuOHM3LjMtMi4xLDEyLjUsMC44YzEuOCwxLDMuMSwyLjMsNC40LDQuMmMtMS4zLTMuNC0yLjMtNy0zLjQtMTAuNmMtMS44LDAtNi0wLjMtMTAuNC0yLjkNCgljLTQuMi0xLjgtNi04LjMtNi04LjNzNy4zLTAuOCwxMS43LDIuOWMxLjMsMSwyLjksMy4xLDMuOSw0LjljLTAuOC0zLjktMS4zLTcuMy0xLjMtMTAuOWMtMS44LTAuMy01LjUtMS4zLTkuMy00LjQNCgljLTQuMi0zLjQtNC40LTkuNi00LjQtOS42czcuMywwLjMsMTAuNiw0LjRjMS4zLDEuMywyLjEsMy40LDIuOSw1LjVjMC0zLjksMC03LjgsMC4zLTExLjdjLTEuOC0wLjgtNS4yLTIuMS04LjMtNg0KCWMtMy40LTMuOS0yLjktMTAuNC0yLjktMTAuNHM3LDEuOCw5LjYsNi4yYzEsMS44LDEuMywzLjksMS44LDZjMC44LTMuOSwxLjMtNy44LDIuMy0xMS43Yy0xLjMtMC44LTQuOS0yLjktNy4zLTcuMw0KCWMtMi45LTQuNC0wLjgtMTAuNC0wLjgtMTAuNHM2LjIsMy4xLDguMyw3LjhjMC44LDEuOCwwLjgsNC40LDAuOCw2LjVjMS4zLTQuMiwzLjEtNy44LDQuOS0xMS43Yy0xLTEtNC4yLTMuNC02LTguMw0KCWMtMS44LTQuNCwxLTkuOSwxLTkuOXM1LjUsMy45LDYuNSw4LjhjMC4zLDIuMSwwLDQuOS0wLjgsN2MyLjEtMy45LDQuNC03LjUsNy0xMC45Yy0xLTEtMy40LTQuMi00LjItOC44Yy0wLjgtNC45LDIuOS05LjYsMi45LTkuNg0KCXM0LjksNC40LDQuOSw5LjZjMCwyLjEtMC44LDQuNC0xLjgsNi41YzIuOS0zLjQsNS41LTcsOC42LTkuNmMtMC44LTEuMy0yLjMtNC40LTIuOS05LjNjLTAuOC01LjIsMy45LTguOCwzLjktOC44UzkzLjQsMjYsOTIuNywzMQ0KCWMtMC4zLDIuMS0xLjgsNC40LTIuOSw2LjJjMS0xLDIuMS0xLjgsMy4xLTIuOWMyLjMtMi4xLDQuOS0zLjksNy4zLTUuMmMwLTEtMS4zLTQuOS0wLjgtOS42YzAuOC00LjQsNS41LTcuNSw1LjUtNy41DQoJczIuOSw2LDEuMywxMC40Yy0wLjgsMi4xLTMuMSw0LjktNC40LDYuMmM0LjctMi45LDguNi00LjksMTIuMi02LjhjMC0xLTEtNC45LDAuOC05LjZjMS44LTQuNCw3LTYuNSw3LTYuNXMxLjgsNi0wLjgsOS45DQoJYy0xLDIuMS00LjIsNC40LTUuNSw1LjVjMi4zLTEsNC45LTEuOCw2LjUtMi4zYzAuOC0wLjgsMy40LTMuOSw2LjUtNC40YzIuOS0wLjMsNy4zLDEuMyw3LjMsMS4zcy0yLjMsMi45LTYuNSw0LjQNCgljLTIuOSwxLTYtMC4zLTctMC44Yy0yLjEsMC44LTUuMiwxLjgtOC4zLDMuNGMxLjgtMC4zLDUuNS0wLjgsNy44LDBjNC40LDEuMyw3LjUsNyw3LjUsN3MtNS4yLDIuMS05LjMsMGMtNC40LTIuMy02LjUtNS41LTcuMy02LjUNCgljLTMuNCwxLjgtNy41LDMuOS0xMS43LDdjMS44LTAuOCw1LjItMS44LDcuMy0xLjNjNC45LDAuOCw4LjYsNS41LDguNiw1LjVzLTQuOSwzLjEtOS4zLDEuOHMtNy4zLTQuMi04LjMtNS4yDQoJYy0xLjgsMS4zLTMuOSwyLjktNS41LDQuNGMtMS44LDEuMy0zLjQsMi45LTUuMiw0LjRjMS44LTEsNC45LTIuMyw3LjMtMi4zYzQuOSwwLDkuNiw0LjIsOS42LDQuMnMtNC40LDMuOS05LjMsMy4xDQoJYy00LjktMC44LTcuOC0yLjktOC44LTMuOWMtMy4xLDMuMS02LDYuNS04LjYsMTAuNGMxLjgtMS4zLDQuMi0zLjEsNi4yLTMuNGM0LjktMSwxMC42LDIuMywxMC42LDIuM3MtMy45LDQuNC04LjYsNC45DQoJYy00LjksMC4zLTguMy0xLjMtOS42LTIuMWMtMi4zLDMuNC00LjQsNy4zLTYuNSwxMC45YzEuMy0xLjgsMy40LTMuNCw1LjUtNC4yYzQuOS0yLjEsMTAuOSwwLjgsMTAuOSwwLjhTODQuMiw2Niw3OS41LDY3DQoJYy00LjQsMS04LjMsMC4zLTkuNi0wLjVjLTEuOCwzLjktMy4xLDcuOC00LjQsMTEuOWMxLjMtMS44LDIuOS00LjIsNC40LTUuMmM0LjQtMi45LDEwLjktMS4zLDEwLjktMS4zcy0yLjEsNi02LjUsNy44DQoJYy0zLjksMS4zLTcuNSwxLjMtOS4zLDFjLTEsNC4yLTEuOCw4LjMtMi4zLDEyLjdjMC44LTIuMSwyLjEtNC45LDMuOS02LjJjMy45LTMuOSwxMC45LTMuNCwxMC45LTMuNHMtMSw2LjItNS41LDguOA0KCWMtNC4yLDIuOS03LjgsMy4xLTkuNiwzLjRjLTAuMyw0LjItMC4zLDguMywwLDEyLjVjMC44LTIuMSwxLjMtNC45LDIuOS02LjJjMy40LTQuNCwxMC42LTUuNSwxMC42LTUuNXMwLDYuNS0zLjksOS45DQoJcy03LjMsNC40LTguOCw0LjljMC4zLDMuOSwxLDcuOCwyLjEsMTEuN2MwLTIuMSwwLjMtNC45LDEuMy03YzIuOS00LjksOS42LTcuMyw5LjYtNy4zczEuMyw2LjUtMi4xLDEwLjZjLTIuOSw0LjItNi4yLDYuMi03LjgsNw0KCWMxLDMuOSwyLjMsNy4zLDMuOSwxMC42Yy0wLjMtMi4xLTAuMy00LjksMC4zLTYuNWMxLjgtNS41LDguMy04LjgsOC4zLTguOHMyLjMsNi4yLDAsMTAuOWMtMi4xLDQuNC01LjUsNy03LDcuOA0KCWMxLjgsMy40LDMuNCw2LjUsNS41LDkuM2MtMC44LTIuMS0xLTQuNC0wLjgtNi41YzAuOC02LDctMTAuNCw3LTEwLjRzMy40LDYsMS44LDExLjRjLTEuMyw0LjktNC4yLDcuOC01LjUsOS40DQoJYzIuMywzLjEsNC45LDYsNy4zLDguNmMtMS0yLjEtMi4xLTQuNC0yLjEtNi41YzAtNiw1LjItMTEuNyw1LjItMTEuN3M0LjQsNS4yLDMuOSwxMC45Yy0wLjgsNS4yLTIuOSw4LjYtMy45LDEwLjQNCgljMi45LDIuOSw2LDUuMiw4LjgsNy4zYy0xLjMtMS44LTIuOS00LjQtMy40LTYuNWMtMS4zLTYsMy4xLTEyLjcsMy4xLTEyLjdzNS41LDQuNCw2LDEwLjRjMC4zLDUuMi0xLjMsOS40LTIuMSwxMC45bDMuNCwyLjENCglsNi4yLDMuMWMtMS44LTEuOC0zLjQtMy45LTQuMi01LjVjLTIuMy01LjUsMC44LTEzLDAuOC0xM3M2LjIsMy40LDcuNSw5LjNjMSw1LjIsMC4zLDkuMywwLDExLjRjMy45LDEuOCw3LDIuOSw5LjksMy45DQoJYy0xLjgtMS4zLTMuOS0zLjEtNS4yLTQuOWMtMy40LTUuNS0xLjgtMTMuNS0xLjgtMTMuNXM3LjMsMi4zLDkuMyw3LjhDMTMwLjMsMTgxLjEsMTMwLjMsMTg1LjIsMTMwLjMsMTg3LjYgTTIzNi41LDEyNS44DQoJYy0xLDMuOS0yLjEsNy4zLTMuNCwxMC42YzEuMy0xLjgsMy4xLTMuNCw0LjQtNC4yYzUuMi0yLjksMTIuNS0wLjgsMTIuNS0wLjhzLTIuOSw2LjItNy44LDcuOGMtNC45LDEuOC04LjgsMS4zLTEwLjYsMQ0KCWMtMS44LDMuNC0zLjQsNy01LjUsOS45YzEuOC0xLjMsMy45LTIuOSw1LjUtMy40YzUuNS0xLjgsMTIuNSwxLjgsMTIuNSwxLjhzLTMuOSw2LTkuMyw2LjVjLTUuMiwwLjgtOS40LTAuMy0xMC45LTENCgljLTIuMSwzLjEtNC4yLDYtNi41LDguNmMxLjgtMSwzLjktMi4xLDUuNS0yLjFjNi0wLjgsMTEuOSwzLjksMTEuOSwzLjlzLTQuOSw1LjItMTAuNiw1LjJjLTUuMiwwLTguOC0xLjgtMTAuNi0yLjkNCgljLTIuMywyLjMtNS4yLDQuOS03LjUsN2MxLjgtMC44LDMuOS0xLDUuNS0xYzYuMiwwLjMsMTEuNyw2LDExLjcsNnMtNS41LDQuMi0xMS40LDMuMWMtNS4yLTEtOC42LTMuNC05LjktNC45DQoJYy0xLjgsMS4zLTMuOSwyLjMtNS41LDMuNGMtMSwwLjgtMi4zLDEuMy0zLjQsMi4xYzIuMS0wLjMsNC4yLTAuMyw2LDBjNiwxLjMsMTAuNiw3LjgsMTAuNiw3LjhzLTYuNSwzLjQtMTEuOSwxDQoJYy00LjktMS44LTcuOC00LjktOS4zLTYuNWMtMy40LDEuOC02LjUsMi45LTkuMywzLjljMi4xLDAsNC4yLDAuMyw2LDFjNiwyLjMsOS40LDkuOSw5LjQsOS45cy03LjMsMi4xLTEyLjUtMQ0KCWMtNC40LTIuOS03LjMtNi4yLTguMy04LjNjLTUuNSwxLjMtMTAuOSwyLjMtMTcuMSwyLjlWMTkwYzQuOS0wLjMsOS42LTEsMTQtMi4xYzAtMi4xLDAtNi41LDEuOC0xMS40YzIuMy01LjUsOS4zLTcuOCw5LjMtNy44DQoJczEuOCw4LjMtMS44LDEzLjVjLTEsMS44LTMuMSwzLjQtNS4yLDQuOWMzLjEtMSw2LjUtMi4xLDkuOS0zLjljLTAuOC0yLjEtMS4zLTYuMiwwLTExLjRjMS4zLTYsNy41LTkuMyw3LjUtOS4zczMuMSw3LjUsMC44LDEzDQoJYy0wLjgsMS44LTIuMywzLjktNC4yLDUuNWw2LjItMy4xYzEtMC44LDIuMy0xLjMsMy40LTIuMWMtMS0xLjgtMi4zLTYtMi4xLTEwLjljMC4zLTYsNi0xMC40LDYtMTAuNHM0LjIsNywzLjEsMTIuNw0KCWMtMC4zLDIuMS0xLjgsNC40LTMuNCw2LjVjMy4xLTIuMSw2LTQuNCw4LjgtNy4zYy0xLTEuOC0zLjQtNS4yLTMuOS0xMC40Yy0wLjgtNS41LDMuOS0xMC45LDMuOS0xMC45czUuMiw2LDUuMiwxMS43DQoJYzAsMi4xLTEsNC40LTIuMSw2LjVjMi4zLTIuOSw0LjktNS41LDcuMy04LjZjLTEuMy0xLjMtNC4yLTQuNC01LjUtOS40Yy0xLjgtNS41LDEuOC0xMS40LDEuOC0xMS40czYsNC45LDcsMTAuNA0KCWMwLjMsMS44LDAsNC40LTAuOCw2LjVjMi4xLTMuMSwzLjktNi4yLDUuNS05LjNjLTEuOC0xLTQuOS0zLjktNy03LjhjLTIuMy00LjksMC0xMC45LDAtMTAuOXM2LjUsMy40LDguMyw4LjgNCgljMC44LDEuOCwwLjgsNC40LDAuMyw2LjVjMS44LTMuNCwyLjktNywzLjktMTAuNmMtMS44LTAuOC01LjItMi45LTguMy02LjVjLTMuMS00LjItMi4xLTEwLjYtMi4xLTEwLjZzNywyLjMsOS42LDcuMw0KCWMxLDEuOCwxLjMsNC40LDEuMyw3YzEtMy45LDEuOC03LjUsMi4xLTExLjdjLTEuOC0wLjMtNS41LTEuOC04LjgtNC45Yy0zLjktMy40LTMuOS05LjktMy45LTkuOXM3LjMsMSwxMC42LDUuNQ0KCWMxLjMsMS44LDIuMSw0LjIsMi45LDYuMmMwLjMtNC4yLDAuMy04LjMsMC0xMi41Yy0xLjgsMC01LjUtMC44LTkuNi0zLjRjLTQuNC0yLjktNS41LTguOC01LjUtOC44czcuMywwLDEwLjksMy40DQoJYzEuOCwxLjMsMi45LDQuMiwzLjksNi4yYy0wLjMtNC40LTEuMy04LjYtMi4zLTEyLjdjLTEuMy0wLjgtNS4yLTAuOC05LjYtMi4zYy00LjQtMi4xLTYuNS04LjEtNi41LTguMXM3LTEuMywxMC45LDEuMw0KCWMxLjgsMSwzLjQsMy40LDQuNCw1LjJjLTEuMy00LjItMi45LTguMy00LjQtMTEuOWMtMS44LDAuMy01LjIsMS4zLTkuNiwwLjNjLTQuOS0xLTcuOC02LjUtNy44LTYuNXM2LjItMi4zLDEwLjktMC44DQoJYzEuOCwwLjgsMy45LDIuOSw1LjUsNC4yYy0xLjgtMy45LTQuMi03LjUtNi41LTEwLjljLTEuMywwLjgtNC45LDIuMS05LjYsMi4xYy00LjktMC4zLTguNi00LjktOC42LTQuOXM1LjUtMy40LDEwLjYtMi4zDQoJYzIuMSwwLjMsNC45LDIuMSw2LjIsMy40Yy0yLjktMy45LTUuNS03LjMtOC42LTEwLjRjLTEsMC44LTQuMiwzLjEtOC44LDMuOWMtNC45LDAuOC05LjMtMy4xLTkuMy0zLjFzNS4yLTQuNCw5LjktNC4yDQoJYzIuMywwLDUuNSwxLjgsNy4zLDIuM2MtMS44LTEuOC0zLjQtMy4xLTUuMi00LjRjLTIuMS0xLjgtMy45LTMuMS01LjUtNC40Yy0xLDEtMy45LDMuOS04LjMsNS4yYy00LjQsMS4zLTkuNC0xLjgtOS40LTEuOA0KCXMzLjktNS4yLDguNi01LjVjMi4zLTAuMyw1LjUsMC44LDcuNSwxLjNjLTQuMi0yLjktOC4zLTUuMi0xMS43LTdjLTAuOCwxLTIuOSw0LjItNy4zLDYuNWMtNC4yLDIuMS05LjMsMC05LjMsMHMzLjEtNS41LDcuNS03DQoJYzIuMy0wLjgsNi4yLTAuMyw3LjgsMGMtMy4xLTEuMy02LTIuMy04LjMtMy40Yy0xLDAuMy00LjIsMS44LTcsMC44Yy00LjQtMC44LTctMy45LTctMy45czQuNC0xLjgsNy4zLTEuM2MzLjQsMC44LDYsMy45LDYuNSw0LjQNCgljMS44LDAuOCw0LjIsMS4zLDYuNSwyLjNjLTEuNi0xLTQuNC0zLjQtNS41LTUuNWMtMi4xLTQuMi0wLjMtMTAuNC0wLjMtMTAuNHM1LjIsMi4xLDYuNSw2LjVjMS44LDQuOSwxLDguNiwwLjgsOS42DQoJYzMuOSwxLjgsNy41LDMuOSwxMS45LDYuNWMtMS4zLTEuMy0zLjktMy45LTQuNC02LjJjLTEuMy00LjQsMS4zLTEwLjQsMS4zLTEwLjRzNC45LDMuMSw1LjUsNy41YzAuOCw1LjItMC41LDguOC0wLjgsOS45bDcuMyw1LjINCgljMSwwLjgsMi4xLDEuOCwzLjEsMi45Yy0xLTEuOC0yLjktNC4yLTIuOS02LjJjLTAuOC00LjksMy4xLTEwLjQsMy4xLTEwLjRzNC4yLDMuOSw0LjIsOC42YzAsNC45LTEuOCw3LjgtMi45LDkuMw0KCWMzLjEsMi45LDYsNiw4LjYsOS42Yy0wLjgtMS44LTEuOC00LjQtMS44LTYuNWMwLTUuMiw0LjktOS42LDQuOS05LjZzMy45LDQuOSwyLjksOS42Yy0xLDQuOS0zLjQsNy44LTQuMiw4LjgNCgljMi4zLDMuNCw0LjksNy4zLDcsMTAuOWMtMC4zLTIuMS0xLTQuOS0wLjgtN2MxLTUuMiw2LjUtOC44LDYuNS04LjhzMi45LDUuNSwxLDkuOWMtMS44LDQuNC00LjksNy4zLTYsOC4zDQoJYzEuOCwzLjksMy40LDcuNSw0LjksMTEuN2MwLTIuMSwwLTQuOSwwLjgtNi41YzIuMS00LjksOC4zLTcuNSw4LjMtNy41czEuOCw2LTAuOCwxMC40Yy0yLjMsNC4yLTYsNi4yLTcuMyw3LjMNCgljMSwzLjksMi4xLDcuNSwyLjMsMTEuN2MwLjMtMi4xLDEtNC4yLDEuOC02YzIuOS00LjQsOS42LTYuMiw5LjYtNi4yczAuOCw2LjItMi45LDEwLjRjLTMuMSwzLjQtNi41LDUuMi04LjMsNg0KCWMwLjMsMy45LDAuMyw3LjUsMC4zLDExLjdjMC44LTEuOCwxLjgtNC4yLDIuOS01LjVjMy45LTQuMiwxMC45LTQuNCwxMC45LTQuNHMtMC4zLDYuNS00LjQsOS42Yy0zLjksMy4xLTcuNSw0LjItOS4zLDQuNA0KCWMtMC4zLDMuOS0wLjgsNy4zLTEuMywxMC45YzEtMS44LDIuMS0zLjksMy45LTQuOWM0LjQtMy40LDExLjctMi45LDExLjctMi45cy0xLjMsNi41LTYuMiw4LjhDMjQyLDEyNS4yLDIzOC4xLDEyNS41LDIzNi41LDEyNS44eiINCgkvPg0KPHBhdGggaWQ9InNoYXBlUGF0aDMiIGNsYXNzPSJzdDIiIGQ9Ik0xOC41LDIxMy4zYzEuOCwwLDMuMSwxLjMsMy4xLDMuMXY0LjRjMCwxLjgtMS4zLDMuMS0zLjEsMy4xSDguNHY1LjVINS4zdi0xNi4xSDE4LjUNCgkgTTE4LjUsMjE2LjdDMTguNSwyMTYuNCwxOC41LDIxNi40LDE4LjUsMjE2LjdIOC4xdjQuNGgxMC40VjIxNi43IE0yNCwyMTMuM2gzLjF2MTMuNWgxMy41djMuMUgyNC4ydi0xNi42SDI0IE01NS42LDIxMy4zDQoJYzEuOCwwLDMuMSwxLjMsMy4xLDMuMXYxM2gtMy4xdi01LjVINDUuM3Y1LjVoLTIuOXYtMTNjMC0xLjgsMS4zLTMuMSwzLjEtMy4xSDU1LjYgTTU1LjksMjIxLjF2LTQuOUg0NnY0LjlINTUuOSBNNzUuOSwyMTMuM0g3OQ0KCXYxNi4xaC0zLjFsLTkuOS0xMnYxMS45aC0zLjF2LTE2LjFINjZsOS45LDExLjlWMjEzLjMgTTk3LjIsMjE2LjRIODUuM3YzLjloOS42djIuOWgtOS42djMuOWgxMS45djMuMUg4Mi4xdi0xNi4xaDE1LjFWMjE2LjQNCgkgTTExNS45LDIxMy4zdjMuMWgtNi41djEzLjVoLTMuMXYtMTMuNWgtNi41di0zLjFIMTE1LjkgTTEzOS41LDIxMy4zYzEuOCwwLDMuMSwxLjMsMy4xLDMuMXY0LjRjMCwxLjgtMS4zLDMuMS0zLjEsMy4xaC05Ljl2NS41DQoJaC0zLjF2LTE2LjFIMTM5LjUgTTE0MCwyMTYuN0MxNDAsMjE2LjQsMTM5LjUsMjE2LjQsMTQwLDIxNi43aC0xMC40djQuNGg5Ljl2LTQuNEgxNDAgTTE2MS42LDIyMC44YzAsMS44LTEuMywzLjEtMy4xLDMuMWgtMQ0KCWw0LjIsNC45djAuOGgtMy4xbC00LjktNS41aC01LjJ2NS41aC0zLjF2LTE2LjFoMTNjMS44LDAsMy4xLDEuMywzLjEsMy4xdjQuMiBNMTU4LjUsMjIxLjF2LTQuNGgtOS45djQuNEgxNTguNSBNMTc4LjIsMjEzLjMNCgljMS44LDAsMy4xLDEuMywzLjEsMy4xdjkuOWMwLDEuOC0xLjMsMy4xLTMuMSwzLjFoLTkuOWMtMS44LDAtMy4xLTEuMy0zLjEtMy4xdi05LjljMC0xLjgsMS4zLTMuMSwzLjEtMy4xSDE3OC4yIE0xNzguMiwyMjYuOA0KCXYtMTAuNGgtOS45djkuOWg5LjlWMjI2LjggTTIwMC4zLDIxMy4zdjMuMWgtNi41djEzLjVoLTMuMXYtMTMuNWgtN3YtMy4xSDIwMC4zIE0yMTcuNywyMTYuNGgtMTEuOXYzLjloOS42djIuOWgtOS42djMuOWgxMS45djMuMQ0KCWgtMTUuMXYtMTYuMWgxNS4xVjIxNi40IE0yMjQuNSwyMTYuNEMyMjMuOSwyMTYuNCwyMjMuOSwyMTYuNCwyMjQuNSwyMTYuNHYxMC40aDEzdjMuMWgtMTNjLTEuOCwwLTMuMS0xLjMtMy4xLTMuMXYtOS45DQoJYzAtMS44LDEuMy0zLjEsMy4xLTMuMWgxM3YzLjFoLTEzVjIxNi40IE0yNTYuMSwyMTMuM3YzLjFoLTYuNXYxMy41aC0zLjF2LTEzLjVIMjQwdi0zLjFIMjU2LjEgTTI3MiwyMTMuM2MxLjgsMCwzLjEsMS4zLDMuMSwzLjENCgl2OS45YzAsMS44LTEuMywzLjEtMy4xLDMuMWgtOS45Yy0xLjgsMC0zLjEtMS4zLTMuMS0zLjF2LTkuOWMwLTEuOCwxLjMtMy4xLDMuMS0zLjFIMjcyIE0yNzIsMjI2LjgNCglDMjcyLDIyNi44LDI3Mi4yLDIyNi44LDI3MiwyMjYuOHYtMTAuNGgtOS45djkuOWg5LjlWMjI2LjggTTI5NS4xLDIyMC44YzAsMS44LTEuMywzLjEtMy4xLDMuMWgtMWw0LjIsNC45djAuOEgyOTJsLTQuOS01LjVoLTUuMg0KCXY1LjVoLTMuMXYtMTYuMWgxM2MxLjgsMCwzLjEsMS4zLDMuMSwzLjF2NC4yIE0yOTEuNSwyMjEuMUMyOTIsMjIxLjEsMjkyLDIyMS4xLDI5MS41LDIyMS4xdi00LjRoLTkuOXY0LjRIMjkxLjUgTTMzLjMsMjM1LjQNCgljMy45LDAsNywzLjEsNyw3djI4LjNoLTYuOFYyNTloLTIydjExLjdINXYtMjguNmMwLTMuOSwzLjEtNyw3LTdoMjEuMyBNMzMuNiwyNTJ2LTkuOWMwLTAuMywwLTAuMy0wLjMtMC4zSDEyYy0wLjMsMC0wLjMsMC0wLjMsMC4zDQoJdjkuOUgzMy42IE01My44LDI0MS42QzUzLjgsMjQxLjYsNTMuNiwyNDEuOSw1My44LDI0MS42bC0wLjMsMjEuOGMwLDAuMywwLDAuMywwLjMsMC4zaDI3Ljh2Ni41SDUzLjhjLTMuOSwwLTctMy4xLTctN3YtMjEuMw0KCWMwLTMuOSwzLjEtNyw3LTdoMjcuOHY2LjVINTMuOCBNMTE3LjIsMjM1LjRjMy45LDAsNywzLjEsNyw3djI4LjNoLTYuNVYyNTlIOTUuNnYxMS43aC02LjV2LTI4LjZjMC0zLjksMy4xLTcsNy03aDIxIE0xMTcuMiwyNTINCgl2LTkuOWMwLTAuMywwLTAuMy0wLjMtMC4zSDk1LjZjLTAuMywwLTAuMywwLTAuMywwLjN2OS45SDExNy4yIE0xNTkuMywyMzUuNGMzLjksMCw3LDMuMSw3LDd2MjEuM2MwLDMuOS0zLjEsNy03LDdoLTI3Ljh2LTM1LjMNCglMMTU5LjMsMjM1LjQgTTE1OS41LDI0MS45QzE1OS41LDI0MS45LDE1OS41LDI0MS42LDE1OS41LDI0MS45bC0yMS44LTAuM2MtMC4zLDAtMC4zLDAtMC4zLDAuM3YyMS4zYzAsMC4zLDAsMC4zLDAuMywwLjNIMTU5DQoJYzAuMywwLDAuMywwLDAuMy0wLjN2LTIxLjMgTTIwNS44LDI0MS42aC0yNS41djcuOGgyMC44djYuNWgtMjAuOHY3LjhoMjUuNXY2LjVoLTMxLjl2LTM0LjhoMzEuOVYyNDEuNiBNMjQzLjcsMjM1LjRoN3YzNC44aC02LjgNCgl2LTI1LjVsLTEzLDE1LjhsLTEzLTE1Ljh2MjUuNWgtNi41di0zNC44aDdsMTIuNywxNS4xTDI0My43LDIzNS40IE0yOTUuMSwyMzUuNEwyNzksMjU3LjJ2MTNoLTYuNXYtMTNjLTUuMi03LTEwLjktMTQuOC0xNi4xLTIxLjgNCgloNy41bDExLjcsMTQuOGwxMS43LTE0LjhMMjk1LjEsMjM1LjQiLz4NCjxyZWN0IHg9IjQiIHk9IjI3OSIgY2xhc3M9InN0MyIgd2lkdGg9IjI5OSIgaGVpZ2h0PSI1MyIvPg0KPGcgY2xhc3M9InN0NCI+DQoJPHBhdGggY2xhc3M9InN0MCIgZD0iTTUuNiwyODEuN2MwLTAuNCwwLjMtMC44LDAuOC0wLjhoOS45YzUuMiwwLDkuNCw0LjIsOS40LDkuM2MwLDUuMi00LjIsOS41LTkuNCw5LjVIMTF2OS45DQoJCWMwLDAuNC0wLjQsMC44LTAuOCwwLjhINi40Yy0wLjUsMC0wLjgtMC40LTAuOC0wLjhWMjgxLjd6IE0xNi4xLDI5NC41YzIuNCwwLDQuMi0xLjksNC4yLTQuNGMwLTIuMy0xLjgtNC4xLTQuMi00LjFoLTV2OC40SDE2LjF6Ig0KCQkvPg0KCTxwYXRoIGNsYXNzPSJzdDAiIGQ9Ik00My40LDI4MS43YzAtMC40LDAuMy0wLjgsMC44LTAuOGgxMmM1LDAsOS4yLDQsOS4yLDljMCwzLjktMi42LDctNi4yLDguNWw1LjgsMTAuN2MwLjMsMC41LDAsMS4yLTAuNywxLjINCgkJaC00LjRjLTAuNCwwLTAuNi0wLjItMC43LTAuNGwtNS42LTExLjFoLTQuN3YxMC43YzAsMC40LTAuNCwwLjgtMC44LDAuOGgtMy45Yy0wLjUsMC0wLjgtMC40LTAuOC0wLjhWMjgxLjd6IE01NS43LDI5NC4zDQoJCWMyLjIsMCw0LjItMS45LDQuMi00LjNjMC0yLjItMS45LTQuMS00LjItNC4xaC02Ljh2OC40SDU1Ljd6Ii8+DQoJPHBhdGggY2xhc3M9InN0MCIgZD0iTTg0LjIsMjgxLjdjMC0wLjQsMC4zLTAuOCwwLjgtMC44SDEwMmMwLjUsMCwwLjgsMC40LDAuOCwwLjh2My40YzAsMC40LTAuMywwLjgtMC44LDAuOEg4OS42djYuOUgxMDANCgkJYzAuNCwwLDAuOCwwLjQsMC44LDAuOHYzLjVjMCwwLjUtMC40LDAuOC0wLjgsMC44SDg5LjZ2Ny40SDEwMmMwLjUsMCwwLjgsMC40LDAuOCwwLjh2My40YzAsMC40LTAuMywwLjgtMC44LDAuOEg4NC45DQoJCWMtMC41LDAtMC44LTAuNC0wLjgtMC44VjI4MS43eiIvPg0KCTxwYXRoIGNsYXNzPSJzdDAiIGQ9Ik0xMjAsMzA3LjVjLTAuNC0wLjMtMC42LTAuNi0wLjItMS4zbDEuNS0yLjZjMC4zLTAuNiwxLjEtMC42LDEuNC0wLjNjMS43LDEuMywzLjYsMi42LDYuMywyLjYNCgkJYzIuMiwwLDMuOC0xLjQsMy44LTMuMmMwLTIuMS0xLjgtMy42LTUuMy01Yy0zLjktMS42LTcuOS00LjEtNy45LTkuMWMwLTMuNywyLjgtOC4xLDkuNS04LjFjNC4zLDAsNy42LDIuMiw4LjQsMi44DQoJCWMwLjQsMC4zLDAuNSwxLDAuMywxLjRsLTEuNiwyLjRjLTAuMywwLjUtMSwwLjgtMS41LDAuNWMtMS44LTEuMS0zLjUtMi4zLTUuOC0yLjNjLTIuNCwwLTMuNywxLjMtMy43LDIuOWMwLDIsMS42LDMuMyw1LDQuNw0KCQljNC4xLDEuNiw4LjgsNC4xLDguOCw5LjVjMCw0LjMtMy43LDguMy05LjcsOC4zQzEyMy45LDMxMC44LDEyMS4yLDMwOC41LDEyMCwzMDcuNXoiLz4NCgk8cGF0aCBjbGFzcz0ic3QwIiBkPSJNMTU3LjEsMjgxLjdjMC0wLjQsMC4zLTAuOCwwLjgtMC44SDE3NWMwLjUsMCwwLjgsMC40LDAuOCwwLjh2My40YzAsMC40LTAuMywwLjgtMC44LDAuOGgtMTIuNHY2LjlIMTczDQoJCWMwLjQsMCwwLjgsMC40LDAuOCwwLjh2My41YzAsMC41LTAuNCwwLjgtMC44LDAuOGgtMTAuNHY3LjRIMTc1YzAuNSwwLDAuOCwwLjQsMC44LDAuOHYzLjRjMCwwLjQtMC4zLDAuOC0wLjgsMC44aC0xNy4xDQoJCWMtMC41LDAtMC44LTAuNC0wLjgtMC44VjI4MS43eiIvPg0KCTxwYXRoIGNsYXNzPSJzdDAiIGQ9Ik0xOTQuNCwyODEuM2MwLTAuNCwwLjQtMC44LDAuOC0wLjhoMC42YzAuMywwLDAuNSwwLjEsMC43LDAuM2wxNy4xLDE4LjNoMC4xdi0xNy4zYzAtMC40LDAuMy0wLjgsMC44LTAuOGgzLjkNCgkJYzAuNCwwLDAuOCwwLjQsMC44LDAuOFYzMTBjMCwwLjQtMC40LDAuOC0wLjgsMC44aC0wLjZjLTAuMywwLTAuNS0wLjEtMC43LTAuM2wtMTcuMi0xOWgtMC4xdjE4LjFjMCwwLjQtMC4zLDAuOC0wLjgsMC44aC0zLjgNCgkJYy0wLjQsMC0wLjgtMC40LTAuOC0wLjhWMjgxLjN6Ii8+DQoJPHBhdGggY2xhc3M9InN0MCIgZD0iTTI0NC4yLDI4NmgtNi40Yy0wLjUsMC0wLjgtMC40LTAuOC0wLjh2LTMuNGMwLTAuNCwwLjMtMC44LDAuOC0wLjhoMTguNGMwLjUsMCwwLjgsMC40LDAuOCwwLjh2My40DQoJCWMwLDAuNC0wLjMsMC44LTAuOCwwLjhoLTYuNHYyMy42YzAsMC40LTAuNCwwLjgtMC44LDAuOEgyNDVjLTAuNCwwLTAuOC0wLjQtMC44LTAuOFYyODZ6Ii8+DQoJPHBhdGggY2xhc3M9InN0MCIgZD0iTTI3My40LDMwNy41Yy0wLjQtMC4zLTAuNi0wLjYtMC4yLTEuM2wxLjUtMi42YzAuMy0wLjYsMS0wLjYsMS40LTAuM2MxLjcsMS4zLDMuNiwyLjYsNi4zLDIuNg0KCQljMi4yLDAsMy44LTEuNCwzLjgtMy4yYzAtMi4xLTEuOC0zLjYtNS4zLTVjLTMuOS0xLjYtNy45LTQuMS03LjktOS4xYzAtMy43LDIuOC04LjEsOS41LTguMWM0LjMsMCw3LjYsMi4yLDguNCwyLjgNCgkJYzAuNCwwLjMsMC41LDEsMC4zLDEuNGwtMS42LDIuNGMtMC4zLDAuNS0xLDAuOC0xLjUsMC41Yy0xLjgtMS4xLTMuNS0yLjMtNS44LTIuM2MtMi40LDAtMy43LDEuMy0zLjcsMi45YzAsMiwxLjYsMy4zLDUsNC43DQoJCWM0LjEsMS42LDguOCw0LjEsOC44LDkuNWMwLDQuMy0zLjcsOC4zLTkuNyw4LjNDMjc3LjQsMzEwLjgsMjc0LjYsMzA4LjUsMjczLjQsMzA3LjV6Ii8+DQo8L2c+DQo8L3N2Zz4NCg=="

/***/ }),
/* 2331 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/epsIntermediates/sections/20_gameShow/title_gameshow-4db1c3edea9555aba358c3928e2305e0.png";

/***/ }),
/* 2332 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/epsIntermediates/sections/20_gameShow/title_gameshow_players-1f3dab0745c16a508ea646d3d95269a3.png";

/***/ }),
/* 2333 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0NzAuMiIgaGVpZ2h0PSI0NzAuMiIgdmlld0JveD0iMCAwIDQ3MC4yIDQ3MC4yIj48c3R5bGU+LnN0MHtvcGFjaXR5OjAuNTtmaWxsOm5vbmU7c3Ryb2tlOiNGRkZGRkY7c3Ryb2tlLXdpZHRoOjIwLjI1O3N0cm9rZS1saW5lY2FwOnJvdW5kO3N0cm9rZS1taXRlcmxpbWl0OjEwO30gLnN0MXtmaWxsOm5vbmU7c3Ryb2tlOiNGRkZGRkY7c3Ryb2tlLXdpZHRoOjIwLjI1O3N0cm9rZS1saW5lY2FwOnJvdW5kO3N0cm9rZS1taXRlcmxpbWl0OjEwO308L3N0eWxlPjxjaXJjbGUgY2xhc3M9InN0MCIgY3g9IjIzNS4xIiBjeT0iMjM1LjEiIHI9IjIyNSIvPjxwYXRoIGNsYXNzPSJzdDEiIGQ9Ik0yMzUuMSAxMC4xQTIyNSAyMjUgMCAwIDEgNDYwLjEgMjM1LjEiLz48L3N2Zz4="

/***/ }),
/* 2334 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0NzAuMiIgaGVpZ2h0PSI0NzAuMiIgdmlld0JveD0iMCAwIDQ3MC4yIDQ3MC4yIj48c3R5bGU+LnN0MHtvcGFjaXR5OjAuNTtmaWxsOm5vbmU7c3Ryb2tlOiNGRkZGRkY7c3Ryb2tlLXdpZHRoOjIwLjI1O3N0cm9rZS1saW5lY2FwOnJvdW5kO3N0cm9rZS1taXRlcmxpbWl0OjEwO30gLnN0MXtmaWxsOm5vbmU7c3Ryb2tlOiNGRkZGRkY7c3Ryb2tlLXdpZHRoOjIwLjI1O3N0cm9rZS1saW5lY2FwOnJvdW5kO3N0cm9rZS1taXRlcmxpbWl0OjEwO308L3N0eWxlPjxjaXJjbGUgY2xhc3M9InN0MCIgY3g9IjIzNS4xIiBjeT0iMjM1LjEiIHI9IjIyNSIvPjxwYXRoIGNsYXNzPSJzdDEiIGQ9Ik0yMzUuMSAxMC4xQTIyNSAyMjUgMCAwIDEgMjM1LjEgNDYwLjEiLz48L3N2Zz4="

/***/ }),
/* 2335 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0NzAuMiIgaGVpZ2h0PSI0NzAuMiIgdmlld0JveD0iMCAwIDQ3MC4yIDQ3MC4yIj48c3R5bGU+LnN0MHtvcGFjaXR5OjAuNTtmaWxsOm5vbmU7c3Ryb2tlOiNGRkZGRkY7c3Ryb2tlLXdpZHRoOjIwLjI1O3N0cm9rZS1saW5lY2FwOnJvdW5kO3N0cm9rZS1taXRlcmxpbWl0OjEwO30uc3Qxe2ZpbGw6bm9uZTtzdHJva2U6I0ZGRkZGRjtzdHJva2Utd2lkdGg6MjAuMjU7c3Ryb2tlLWxpbmVjYXA6cm91bmQ7c3Ryb2tlLW1pdGVybGltaXQ6MTA7fTwvc3R5bGU+PGNpcmNsZSBjbGFzcz0ic3QwIiBjeD0iMjM1LjEiIGN5PSIyMzUuMSIgcj0iMjI1Ii8+PHBhdGggY2xhc3M9InN0MSIgZD0iTTIzNS4xIDEwLjFBMjI1IDIyNSAwIDEgMSAxMC4xIDIzNS4xIi8+PC9zdmc+"

/***/ }),
/* 2336 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0NzAuMiIgaGVpZ2h0PSI0NzAuMiIgdmlld0JveD0iMCAwIDQ3MC4yIDQ3MC4yIj48c3R5bGU+LnN0MHtvcGFjaXR5OjAuNTtmaWxsOm5vbmU7c3Ryb2tlOiNGRkZGRkY7c3Ryb2tlLXdpZHRoOjIwLjI1O3N0cm9rZS1saW5lY2FwOnJvdW5kO3N0cm9rZS1taXRlcmxpbWl0OjEwO30gLnN0MXtmaWxsOm5vbmU7c3Ryb2tlOiNGRkZGRkY7c3Ryb2tlLXdpZHRoOjIwLjI1O3N0cm9rZS1saW5lY2FwOnJvdW5kO3N0cm9rZS1taXRlcmxpbWl0OjEwO308L3N0eWxlPjxjaXJjbGUgY2xhc3M9InN0MCIgY3g9IjIzNS4xIiBjeT0iMjM1LjEiIHI9IjIyNSIvPjxjaXJjbGUgY2xhc3M9InN0MSIgY3g9IjIzNS4xIiBjeT0iMjM1LjEiIHI9IjIyNSIvPjwvc3ZnPg=="

/***/ }),
/* 2337 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/epsPrimaries/images/characters/ian_hand_raised-384fabc0cb5b98efe85310c0d8c15540.png";

/***/ }),
/* 2338 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/epsPrimaries/images/characters/ian_pointing_down-026a77087cf65bf8bbd037d9b72502c3.png";

/***/ }),
/* 2339 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/epsPrimaries/images/characters/ian_pointing_left-4596053eb82e04f727bdd744c3de0325.png";

/***/ }),
/* 2340 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/epsPrimaries/images/characters/ian_sara_silly-8139b5d7a02986b6a0cea289575bc98a.png";

/***/ }),
/* 2341 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/epsPrimaries/images/characters/ian_sara_two_fingers-5ed565638eae000314880d23ff009b43.png";

/***/ }),
/* 2342 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/epsPrimaries/images/characters/ian_shrug_laugh-f19e9de88cd7960d4eff1c212c0e2d5f.png";

/***/ }),
/* 2343 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/epsPrimaries/images/characters/sara_humph-a0889c055339bc1bd36428414d9e217e.png";

/***/ }),
/* 2344 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/epsPrimaries/images/characters/sara_twist_hands_out_yay-bcf1fb30eda8e0aa404ef594e2dd3fd6.png";

/***/ }),
/* 2345 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/epsPrimaries/images/emergencyPreparednessSquad-2064b85d3eb2aec8ecdcf1800236cfec.png";

/***/ }),
/* 2346 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/epsPrimaries/images/emergencyPreparednessSquadExpired-1761c2ab001f953107b074296a12fde4.png";

/***/ }),
/* 2347 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/epsPrimaries/images/emergencyPreparednessSquadTrial-2064b85d3eb2aec8ecdcf1800236cfec.png";

/***/ }),
/* 2348 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/epsPrimaries/images/overview/level-1_start-6bf328c5226bf5e0a3bcc8c8ee12412b.png";

/***/ }),
/* 2349 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAYJmlDQ1BJQ0MgUHJvZmlsZQAAWIWVeQdUFE3Tbs/OBliWJeeck2SWKDnnnBFYcs4ZlSgSVAQBRUAFFQQVDCQRFRFEFBFUwIBIMJBUUEERkH8I+n7f+99z77l9Ts88W11d/XRXdc/UDgAcjOSIiBAULQChYTFRNoY6vE7OLry4CQABHGBAKonsHR2hbWVlBpDy5/7fZXkY0UbKM8lNW/+7/f9a6Hx8o70BgKwQ7OUT7R2K4EYA0KzeEVExAGD6ELlAfEzEJl5AMGMUQhAALHoT+29j1k3stY13benY2egiWAsACgKZHOUPAHGTN2+ctz9ih4hwxNKH+QSGIaqpCNbwDiD7AMDegejsCg0N38TzCBb1+g87/v9l0+uvTTLZ/y/enstWodALjI4IISf+fy7H/7uEhsT+GYMfqYSAKCObzTkj63YhONx0ExMQ3B7mZWGJYHoEPwj02dLfxK8CYo3sd/TnvaN1kTUDzACggA9ZzxTBnAhmjg22197BcuSorb6IPsoiMMbYbgd7RYXb7NhHxYWFWJjt2MkO8DX+g0/5Ruvb/tHxCzQwRjASaajGpAA7x22eqK64QAcLBBMRPBAdbGu603csKUDX4o9OVKzNJmdBBH/3izKw2daBWUOj/8wLlvImb42FxAKsFRNgZ7TdF3byjXYy+8PBx1dPf5sD7OMbZr/DDUaiS8dmp29WRIjVjj58yjfE0GZ7neEr0XG2f/o+jUECbHsd4MkgsonVzljLETFWdtvc0ChgBnSBHuAFsUj1AuEgCAT2z7fMI7+2WwwAGUQBf+ALJHckf3o4brWEIVdbkAQ+IcgXRP/tp7PV6gviEPn6X+n2VRL4bbXGbfUIBh8QHIpmR2ug1dBmyFULqXJoZbTKn368NH9Gxepj9bBGWAOs2F8e3gjrEKRGgcD/g8wUufsis9vkEvZnDv/Yw3zADGImMUOYccxL4ADebVnZ0fIITI/6F3NeYA7GEWsGO7PzQmzO/NFBCyOsSWgdtDrCH+GOZkazA0m0AjITbbQmMjcSIv1PhrF/uf2zlv8eb5P1f85nR04UJ5J2WHj99YzuX61/W9H9jzXyQe6m/9aEs+HrcA98F+6F2+EWwAvfgVvhPvjWJv4bCe+2IuHPaDZb3IIRO4F/dGQuyszIrP1rbPLO+JvrFR3jmxCzuRl0wyMSowL9A2J4tZHT2JfXOMxbahevnIysEgCbZ/v20fHNZuvMhpif/CPznQZgNxLflAP/yIKOAVDXDQBL7j8yYVcA2JBz9upT79iouG3Z5nEMMAAPaJBdwQa4gQAQReYjBxSBGtAC+sAEWAI74AzckRUPAKEI53iwF6SBLJAHjoJicBKcBmfBBXAZXAMtoB3cBffBIzAAhsBrJC7egzmwAJbBKgRBOIgaYoDYIB5ICJKA5CBlSAPSh8wgG8gZ8oT8oTAoFtoLZUB5UCF0EqqEaqGr0A3oLtQLDUIvoQloBvoK/ULBKAKKEcWFEkZJo5RR2ihTlB1qD8ofFYlKQmWijqBOoKpQl1DNqLuoR6gh1DhqDrUEA5gKZob5YElYGdaFLWEX2A+OgvfDuXAJXAXXw22In5/B4/A8vILGohnQvGhJJDaN0PZob3Qkej/6EPok+gK6Gd2FfoaeQC+gf2OoMZwYCYwqxhjjhPHHxGOyMCWYakwTphvZN+8xy1gslhkrglVC9qUzNgibjD2ErcA2YDuwg9gp7BIOh2PDSeDUcZY4Mi4Gl4UrxV3C3cE9xb3H/aSgouChkKMwoHChCKNIpyihqKO4TfGU4iPFKiUtpRClKqUlpQ9lImU+5TnKNsonlO8pV/F0eBG8Ot4OH4RPw5/A1+O78aP4b1RUVPxUKlTWVIFUqVQnqK5QPaCaoFoh0BPECboEN0Is4QihhtBBeEn4Rk1NLUytRe1CHUN9hLqW+h71GPVPIgNRimhM9CGmEMuIzcSnxM80lDRCNNo07jRJNCU012me0MzTUtIK0+rSkmn305bR3qAdoV2iY6CTpbOkC6U7RFdH10s3TY+jF6bXp/ehz6Q/S3+PfooBZhBg0GXwZshgOMfQzfCeEcsowmjMGMSYx3iZsZ9xgYmeSYHJgSmBqYzpFtM4M8wszGzMHMKcz3yNeZj5FwsXizaLL0sOSz3LU5YfrBysWqy+rLmsDaxDrL/YeNn02YLZCtha2N6wo9nF2a3Z49lPsXezz3MwcqhxeHPkclzjeMWJ4hTntOFM5jzL2ce5xMXNZcgVwVXKdY9rnpuZW4s7iLuI+zb3DA8DjwZPIE8Rzx2eWV4mXm3eEN4TvF28C3ycfEZ8sXyVfP18q/wi/Pb86fwN/G8E8ALKAn4CRQKdAguCPILmgnsFLwq+EqIUUhYKEDou1CP0Q1hE2FH4oHCL8LQIq4ixSJLIRZFRUWpRTdFI0SrR52JYMWWxYLEKsQFxlDhJPEC8TPyJBEpCUSJQokJicBdml8qusF1Vu0YkCZLaknGSFyUnpJilzKTSpVqkPksLSrtIF0j3SP+WIcmEyJyTeS1LL2simy7bJvtVTlzOW65M7rk8tbyBfIp8q/yigoSCr8IphRckBpI56SCpk7SuqKQYpVivOKMkqOSpVK40osyobKV8SPmBCkZFRyVFpV1lRVVRNUb1muoXNUm1YLU6tendIrt9d5/bPaXOr05Wr1Qf1+DV8NQ4ozGuyadJ1qzSnNQS0PLRqtb6qC2mHaR9SfuzjoxOlE6Tzg9dVd19uh16sJ6hXq5evz69vr3+Sf0xA34Df4OLBguGJMNkww4jjJGpUYHRiDGXsbdxrfGCiZLJPpMuU4KprelJ00kzcbMoszZzlLmJ+THzUQshizCLFktgaWx5zPKNlYhVpNVNa6y1lXWZ9QcbWZu9Nj22DLYetnW2y3Y6dvl2r+1F7WPtOx1oHNwcah1+OOo5FjqOO0k77XN65MzuHOjc6oJzcXCpdlly1Xctdn3vRnLLchveI7InYU+vO7t7iPstDxoPssd1T4yno2ed5xrZklxFXvIy9ir3WvDW9T7uPeej5VPkM+Or7lvo+9FP3a/Qb9pf3f+Y/0yAZkBJwHygbuDJwMUgo6DTQT+CLYNrgjdCHEMaQilCPUNvhNGHBYd1hXOHJ4QPRkhEZEWMR6pGFkcuRJlGVUdD0XuiW2MYkdecvljR2AOxE3EacWVxP+Md4q8n0CWEJfQliifmJH5MMkg6n4xO9k7u3Mu3N23vxD7tfZX7of1e+ztTBFIyU96nGqZeSMOnBac9TpdJL0z/nuGY0ZbJlZmaOXXA8MDFLGJWVNbIQbWDp7PR2YHZ/TnyOaU5v3N9ch/myeSV5K0d8j708LDs4ROHN474HenPV8w/dRR7NOzocIFmwYVCusKkwqlj5seai3iLcou+F3sU95YolJw+jj8ee3z8hNmJ1lLB0qOlaycDTg6V6ZQ1lHOW55T/qPCpeHpK61T9aa7Tead/nQk886LSsLK5Sriq5Cz2bNzZD+cczvWcVz5fW81enVe9XhNWM37B5kJXrVJtbR1nXf5F1MXYizOX3C4NXNa73FovWV/ZwNyQdwVcib0ye9Xz6vA102ud15Wv1zcKNZY3MTTlNkPNic0LLQEt463OrYM3TG50tqm1Nd2UulnTztdedovpVv5t/O3M2xt3ku4sdUR0zN/1vzvV6dH5+p7Tvedd1l393abdD+4b3L/Xo91z54H6g/Ze1d4bD5UftjxSfNTcR+prekx63NSv2N/8ROlJ64DKQNvg7sHbTzWf3n2m9+z+c+Pnj4YshgaH7YdfjLiNjL/weTH9MuTl4qu4V6uvU0cxo7lvaN+UjHGOVb0Ve9swrjh+a0Jvom/SdvL1lPfU3Lvod2vvMz9Qfyj5yPOxdlpuun3GYGZg1nX2/VzE3Op81ie6T+WfRT83ftH60rfgtPB+MWpx4+uhb2zfar4rfO9csloaWw5dXv2R+5Pt54UV5ZWeX46/Pq7Gr+HWTqyLrbf9Nv09uhG6sRFBjiJvvQrASEX5+QHwtQYAamcAGAYAwBO3c6+dAkObKQcADpA+ShtWRrNi8FgKnAyFM2UG/g4BS00mttDi6ULoHzKSmMpZAGswWz+HIudRrjkeLd58vkEBvKCKkLNwsEioqJuYjjiX+KLE/V2lksFS6tLU0m9lGmRT5azl+eQ/KdwgHVC0VuJUeq9cr5Kgqq2GV3u2u1zdR2OXxlfNFq292jo6BJ23urf16vQrDAoM9xuRjTVNWE0WTfvM6s0rLCot262mbDC2bHbs9rQOsMOa46ozcKF0JbpR70HvWXKf9Bjw7CBf96r2LvXJ9U308/e3C9AJVAgSD+YLYQulCYPDvodPRgxE3ow6F30kJiU2K64pAZ3om9SxF+wT3q+aYpzqmhabfiSjODP5gMKBqaz8g1bZQjlUuSAPdYjusOgRjXyLo44FLoUux5yKHIrtSqyPW5wwLTU8qVOmUa5SIX9K8rT4GZlK06qMs+Pnjasv1czV0tUJXZS9pHZZr968wfGKx9WAaxHX4xv3N6U3H2jJbs27kd9WfLO8vfpW4+3uOyMd43eHOxvu+XWxdj3oLrkf3+P3YE+v40PrR6Z9ho+N+u2eRA6cGXz5jOq59JDusPGI/gvll0KviK9WXk+Pvnhzd+zs24xx/wn7SYsp83eW7y0/mHxUmWaZHp/JnVWYHZ+7MJ/0yegzxefaL4ZfphbOLiZ8df9m+d18KWi58+fBXy3rehsbO/6XhdHwDHocM4VdoIApFfEBVOWEcaI4TTztfXo2hkTG58xyLOmsb9hJHFmcA9zsPE68BXzt/KMCS4LLQrPCj0XOikaJaYhTiD+XOL0rSJIk+VvqvvQRGUdZHtmPcvXycQrqJIjUrZirZKnMoDysUqrqqsalNopEgZsGm8aI5nEtV21h7VWdId2reof0fQ12G9IZfjBqNy42iTP1NfMyD7AItwy18rK2tFGzFbfjsCc6oByWHT86DTvfc6l3LXPL3ZPkHujh5KlHlvZi9Ya8Z32GfLv8mvyrA0oCM4PCg51DtEJFwqiRSJiIGIv8Hs0X4xFbGnc3/kXCVOJ80speqn3c+0VTeFOxqW/TmtLzM6Iy3Q/YZzkdDMzOyKnIvZzXdKj5cOORq/mXj9YWnC88c6ysqLg4vyTnePqJxNLwk/5lgeWpFXdOi525UCVytvDcs/MrNcQL7LUCdeJIHChd1qjXazC/4nw15FrW9bONt5sGm8daplu/tcE3Wdolbqnd1rqj1MF3F3V3srPnXlNXTXfZ/aM9Bx4k9UY9jHmU09fez/xk38Cbp+zPNJ/bDfkNp46cf/Hk5ffX9KOSb8zGIt4eH7858XRybGry3dwHDOL9tJnBObp5mU+kz8JfaL78XPiwOPL14bcb3yuXUpYdfoj8WP7ZvpL0S22VsKa3PrPjfyloDlUBu6PFMDjMInYGN0sxSblIhScIUWsTXWjSaC/RDdJvMAox6TMHsRxgPc3WyN7N8YDzPtdN7kqeBF4d3l985/hN+ecEsgVFBDuF3IVWhItEZEQeivqL4cRqxI3EP0pk7RLd1S3pLQWkKqR3S7+QiUXebhrkzOSm5TMUuBVaSTakecUDSjxKLchby7RKiiqz6kU1bbWnu713f1ZP1sBplGkqaA5rJWlza7fqWOq81A3Q3dCr0rcyoDS4Z7jXSMFo1rjKxM2U1XTYrNjc1oLGotcyw0rN6rt1g02wrYjtO7tK+z0ObA7PHfOdjJw2nJtcQlwFXd+4leyx2LPsXuQh5NHoqe35ipzgxe/1AjlHAnwN/ZT8VQKMA8lBocHkEM1Q2tDRsPPhoRGkiLXIe1G50VYxTDGvY0/H+cQLx39IOJWonziaFJLMmPxs7819t/d3pdxLvZFWm16SkZEZfsA1S/+geDYm+3lOaa5LnmDe6qHxw4+P3Mg/c3R/gWuh6jH2YytFw8XXSo4fP3yisLTy5PWy++UvKmZPrZ6hruStkj9rdM7tfHj1/pqcC4dqU+vIF5UuES99vfypfuUK4Sr3NbnrVo3JTY3NP1tVbkS0ld680t566+bt3jtLdw07b3TZdi/1lPTKP3zed7jfc8D4qfZzneGQl8TRucn+2aXvK5v+3/4PbrNgFQE4loZkqFkA2GsCUNCF5JlDSN6JB8CKGgA7FYAS9gMoQh+AVCf+Pj8g5GmDBVSADrACHiACZIAqkhlbAhfgB6KR7DIfnAL14DZ4AibAdyRz5IRkIUPIA4qHCqBL0APoAwqLEkWZoaJRFUiet4HkdXHwDfg32hB9DD2JkcdkY95iVbGl2FUkw3pIoURRQ8lBWYCnwudQ4amOEtgJNdQK1O1EdWIbjTLNTVoj2td0MfS09JcZ9BgGGe0YB5ksmZ4yezD/ZCllVWcdY9vHzsHexuHOScnZzhXHrcD9jecabxQfiW+Nv0egRDBAaLcwUXhc5LpotpiXuLaE8C7irlXJz1LvpIdkmmST5WTlxuSzFUgKX0itioVKico+KmaqMmosu4nqUhplWhLah3V6db/oUxgwGbIZcRoLmiiYWphFmp+w6LL8ai1g42h7xK7HAe2o55Tl3OfK7Oa1p879nSeWTOeF9Vryfu8z6jvrTxNgGlgc9DFkd2hR2OcIk8i6aEJMZOyreIOE1iTJ5Op9vPvLUpnTCjLwmWkHlg4GZc/l5h0KPdJUQHeMvehTSe0Jj5PMZQMVh08bnlmqyj/HeD67evlCcO3Xi0cv6zfQXVm89qFxunmu9WPbVPviHZa7uvfcuz17bHs1H0k/FnuiOBj27OcI+hXl6Om3DBO33xOn985pf2r4svpV8bvBMv7H4Z8PV6Z/vV99uda4fvS314bM1vmx6X8cIAB6wAb4gDiQB+rACNgBTxAKkkEOKAW14AZ4BN6ABQgDsUMyW95PhIqgK1A/9AlFg5JHuaAyUNdQ72Ee2AM+B8+jFdGZ6CGMGCYNM4r4vgwHcAG4IQp9ilZKaco6vBj+EpUC1R2CFWGKOoFISSym4aO5guSvr+ni6ZnpWxgcGD4x7mPCM51glmR+yBLOysLawRbIzsjewRHOKcg5ylXK7cTDyvOSt4LPh19GAAg8F7wolCnsJqKA5HKzYn3i15GnWL5khtRe6RgZb1ktOYJcv3yugimJhbSo+FKpR7lZpUr1kFrS7jj1HI1WzR/a8jo+unl61frNBjcNbxrdMu41mTBDmYtbOFgesGqxnrcVtPOwr3AYc+J3DnJpdsPtcXQ/6dHtOUju9Kr1zvYJ9LXxM/J3DkgP7AimDvEKbQ9nj0iKfBOtE1MbRxMfkfAoiS85bu/AflLKuTSO9KJM/IHkrPlscs5kXtJhmXzU0TeFV4viShSOfy29WhZboXrq15nqKrmzFec+VovUBFy4Usdysfyyev2nK6XXVK73N5GbV1ur2qzbwa3aO2Ydi52nu7zuqz7ge4h+9Phx3BPsQO5TwrOqIY8R85chr2vefBznmbR6l/bh9gzL3NHPwguPvxUtH1oxXpVbO7X+7vfijv/RgBLQIrufD0gARaALrIA74vt9yM6vBI3gARhD9j0BEoa0oD1QMlQG3YImUJSI18moYtQAzAT7wrfQnOhU9CzGGfMYq4u9hVPH3aUwo3hDGY2nwV+hciDAhBbqSKIs8SdNN20pXSy9M4MxowmTNbMJixKrGBuJ3YMjkTOGy4vbjseC15zPnN9MwFzQRshDOFrksGid2APxmV3UkkpSftInZYbl2OV9FBpIq0pWyo9Vc3Y7a2A0j2qt6ZjqZiAebDFoN7xt1G+8ampq1mwhZXnJWsqm2U7Xftgx1BnvcsnNwZ3Ok8rLw8fV952/WkBe4Idgm5C+MPPwp5GuUdMxyXHc8WOJ95M79lWk2Kf+Sq/MdMjiObiQcyvv0GG/fMMCtsJHRX7Fy8czSulOVpUrVjw+7VcJVZWfUz4/VBNby1H34FJKveEV6WsGjSnNVa35bc7tLLdG7pTddb6H6zp/X6HnZq/+w5G+hH7pAXhw4dn00OBIwUuRVxWvf7/RH8t9+2iCZtJ+6sy7mQ+yH4Onz8w8mJ2dx3zi/CzzRW/BcZH81eeb1Xf+70tLh5c5l+t+qPw4+WPlp+PP5hXmlaiV5pXVX1q/Mn/1rhJXbVePrw6sUaxprSWsXV2bWedbd14vXH+4vv5b9rfP7+O/H/3+vSG74btxYqNv0//RfvJyW48PiKADAGZsY+ObMAC4QgDWCzY2Vqs2NtbPIsnGKAAdIdvfdbaeNbQAlG9+SwKPWn+l/vv7yv8A3x/HjMi0GmEAAAAJcEhZcwAACxMAAAsTAQCanBgAAAIEaVRYdFhNTDpjb20uYWRvYmUueG1wAAAAAAA8eDp4bXBtZXRhIHhtbG5zOng9ImFkb2JlOm5zOm1ldGEvIiB4OnhtcHRrPSJYTVAgQ29yZSA1LjQuMCI+CiAgIDxyZGY6UkRGIHhtbG5zOnJkZj0iaHR0cDovL3d3dy53My5vcmcvMTk5OS8wMi8yMi1yZGYtc3ludGF4LW5zIyI+CiAgICAgIDxyZGY6RGVzY3JpcHRpb24gcmRmOmFib3V0PSIiCiAgICAgICAgICAgIHhtbG5zOmV4aWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20vZXhpZi8xLjAvIgogICAgICAgICAgICB4bWxuczp0aWZmPSJodHRwOi8vbnMuYWRvYmUuY29tL3RpZmYvMS4wLyI+CiAgICAgICAgIDxleGlmOlBpeGVsWURpbWVuc2lvbj4zNjM8L2V4aWY6UGl4ZWxZRGltZW5zaW9uPgogICAgICAgICA8ZXhpZjpQaXhlbFhEaW1lbnNpb24+MzYzPC9leGlmOlBpeGVsWERpbWVuc2lvbj4KICAgICAgICAgPHRpZmY6T3JpZW50YXRpb24+MTwvdGlmZjpPcmllbnRhdGlvbj4KICAgICAgPC9yZGY6RGVzY3JpcHRpb24+CiAgIDwvcmRmOlJERj4KPC94OnhtcG1ldGE+Ch+2cX0AACXlSURBVHgB7XwHmFXVufZ7+plyps8whTrDgKhUQRRBBRtWlKjEa4zGWK4llvyWxMQYoybmj4kaS6y/XcRoNBK8GEPEGkARpIN0mML0Pqef/33XmQ0zMMMM6sMdnmc+2Ofssvbaa3/v19c6Yws+MSCGPuo1HLD3mpH0DcRwoA+QXiYIfYD0AdLLONDLhtOnIX2A9DIO9LLh9GlIHyC9jAO9bDh9GtIHSC/jQC8bTp+G9AHSyzjQy4bTpyF9gPQyDvSy4fRpSB8gvYwDvWw4fRrSB0gv40AvG06fhvQB0ss40MuG06chfYD0Mg70suH0aUgvA8TZ3XhiMRtisHXX7JC7brNFe+Vb7RcQraBz2sOw24OHHMP3P2AbwlEPohS23iZqXQIirXDYwqjyJ2Ntddb+3+8QuSrmSy/cjghGZe1CgjOISMzeq0DpFBBphgxVNBbD7PWFuGlLGo51RxCQRPGtdq89tXb0ptb+dwDOd9dV+57ig/Twa1HQjr+N8uCcwnUcree7Hfy3fP9OAVGfAiQYdaHC78KZCRFkumMIRaOIcdPVzsTKGAC9t0i8sPbNCeuj40lz1PHUPjdKCL49xQdkp45kOKJYX5+AitYEZHsjPNPFUL/9Qw+4hy4BUU82WwwuO4GBHXVNjVi1dj3C4RD5TA7xv93WMUiz2an+7Zhn44GtXRtdstnNZ9tAaRh53d7+Jl6xs5/dYJKPukfPirWpoZ6vvjuQeVb8jJtfEbaJmWfpHPdjUXjcHhTk90MYbrjtUQqcgz2qZe+h/QKiYdJqGYbVVldh86ZN+x25x+1GINh9AJDAXkLcwu16E1MkwyLBLKk9EPKysZ+b9d3VvSdPPR7OzHzzXrICvY26BcQasCWRHo+HWtKelZTGCE1aZiaqq6tN8+zsbDQ0NOzTzsGrgquVmrdHBcwthjVeyqqfe3Ew4nKbyMsCSPeJ2Q3c1I8FoIv7AkL3ifyUoDtsCfiQkH9K6U9ny3qe97hcaG1tRTRyoFCbbg/aR48BsUYk5mtrT/369cOuXbswffp089IffvihuZyUlITm5mazb4GRQwbNhAtNZPtX3MRYaUw29/5BnTmG7Nf+XO5n8nwcYtOFASWL16ramK/BC4wBPHcmYRrjTEJLZjKOqGpGUjRCQIKo5XWBJo00FMfZOup13z0GJBrtXL3z8vJQVlaGs88+Gw8//DBuvfVWPPTQQ0hJScHll1+OgoIClJSUIIWvLuZMJuPOIASVBGM6j31kZjn3k/n9DzTiQurBGNr4cyjd/4NWwhPDcYyEEnh9HdlKj4M5CKCE5xWMl5PBP2LoekxGDj6qqUJrRT3W+dIxw5uNxyorcR0hM56O7TrqNW/uhWTG2t244lDsC4jX6zVg6P6ZM2caxqempmLixImQ1ohCITKRTtq6W2angsxeT+b6yKpEMjqD361tLXS8nJJdRvZNJjAnE6ATCUg6gTyZsIyC04DhYz8xOXZ2nDJwEJ6tKcX9NoYfd96JpxprcWblDkR8PkxjfwG29fD7UKAeAdLZiyQkJMDvl8EA1q5dizFjxuDFF1/ENddcg4ULFyLK8Hjp0qUYPXq02c8cMgQgWKvI6JdsrZhPpv+dMDyKZiykFEv6RQvIvp+iBfP4LfBW8fxf2W4J28/l+a2GvXEfsov+wpOTg1u2b0btqNF4bfZrmD5pEma/+irOu/BC3NFYibX0eQr9WhWdkKyozxIQc7IXffTYZO095vT0dOMvfve732EToy8XnebTTz+Nq6++GmvWrDHHPkroJDLo/fffx6YtW0wX67KyEGTEJlpBJrenZB78lYDJpyz2urE4mS69vo5q1tYuPY0OJxH5jOQaqXlDGEhs2bwZP7vjDpw7YwY+WLAA3+f+9ddfj1/cdhvOPv10XP6jHyE9LQ3NLS3mUVa03Fv15RtriDRAJB8xe/ZsnHbaacZvnH/++Vi1ahVuueUWvPzyy8giAKeccgpeeeUV6Fqwqgq56RlIo8OXX0mhKckw36CjB00Y62eJ/JT2sW1yKIxclxtZNI+oJTilpSjl+cb6egMGm7PeZkfJzp3wsM1vfvMbbN++3QjFl9RQUZhBiPKQQ4F6qCEMRdsAsF7KCoMV6o4fP94w3O5wYOvWrWZTuxNOOAHr1683GjJt2jQoANA5KwpLTk5GU5Ng2EMxmsJGSvORRx6JU089FU899RTK1YYW7ZJLLsHYsWPJXKZzDL1TKfnz58/H888/j+GHHYaf/vSnuzs677zz0NjYaI6ND2uzUfuaKiWNMmX7Xtnd2UHc6SEgHUckMGSi9C1myGzddddd+P3vf4/CwkLj1DMzMk0usmHDBqMhP//5z00nisB+8pOfGElesWIF8vPzKfSl5ppyGTeTS4XLt9HkKGgYOXIkbr/9dlRUVOBC+oXc3FyspkmsJ0hHHHEEAoEA3nrrLfRv01TlSEGaNI1PgIscFBSBaPYZQNhZkxPFYgrGGXrbqUFRJ9/nfz8OO2BA9HJ6aZkF0VdffYUbbrgBdzK6ee6550yOIqYuoD2/7rrr8Kc//clI9WGU4EceeQQ33XQTfvnLX6K4uBgCRGCoT6fTuTuxFAhi5pNPPYnbb7vdRGwCpIU5zWZq4K5t25BDYaik6bI095lnnjFgKUeS1kkQVq9ebcZYW1trnqGDiDOGgCOMKO93OOtgi7VQ21LhdJexrwFUFdXrVAJSrnXwtabHgFhOUBI5bNgwXHvttQi0RVnKM+677z4j0dIagSQaOnSoMSM333yz0ZJjjjkGF198Me69915z/e6774aYJa0RI3/961/j8MMPx3vvvWcYeOsttxpTKJO4cuVKNNGUrWbfAeY78gjrb7gRBcOHmb7ko2QWL7vsMvzwhz805/Sh8Ug7PDEnw4UwUlq8yIpmwJtdjfqSsShZOg4tFV4MPnEDBh35KseRAqerARGB0yM8LM70qPHucXW102OnbhX21FEdHaqqvuV1daj2tyKTpZLxRx1lJF5gFBUVGaneuHEjcpiPPPjggzjnnHOMKVJI/IMf/MCMp6amBkcffbTxKzqh8Pmzzz4z56Ql8k8yS9///vdN+2aWPoZmZaOYRyXcUp0OBl0KAxh80fco59lG7REpMbXASGEA3Rzx40rbDHx/0fE4Y8EwDFoyAVtfmoKSBXmoXZmGNY+Mwor3rsPil6/DlmUcX0y+TaZOZm1fijEZjcVcRJzXuKndns0Cad/7ujvTYw1pM8FQLauKZZKb6UCnsvf+3F5qe0oaw9w6OlKFwaJEMquCbZUs1hPEc8891/gc5SqKwJTZi8aNG4ff/va3xmzJd4jefPNNfPnll4ax0iBRkBop8y+Powyorr4BeTR3Io1r+fLlpr18j2ppIh/BaGDrkzAeZ8aOgyviotmir/i8H7UsBrePITUPoyEnNv9tqOFv2Wcs8FwTw5Dxr9CM5bD+pYxojwbEqG12BysAdqavgQwCT+hcSj8JEKOPWCyl7R76J5rAA6EeA2J16qVpCXAAF/bLxwmhGHx0nv1Yon8g2Io62vQZzAcU4bz22msmApIvEBhW8VEmZc6cOYZ5ipDERLV9/fXXsfHrr81jlPUrnFbIrFKMRTE+u4X+6TOeGMgtvYV1MpXqSXXU1qlTp+LSSy/FvHnzzDkOky5cn8CxGEl2uRCi47aHec5FHxGlOWuMX2dDuJPCsLk4JVDnxNaFxUjPnwibw4nEtE38pgYYx88w27kFrQ0jUFN6LEqWDSHzXSg+8XO4vK30Rx54E8vg9a0jhHm8xhqBCRbanmNG0/XHAQPiVl8UloHlFVjj9qIp2GQSOU40IIeSqUhI/kB2XAy3CowyPzIjOp41a5ZJIocMGWLCWwEiPzN37lwzUpk0aYhAeeyxx0xwoAvyX06PF59w/0JuG3aWYCzNlkVy/IsXL44fUmyTYx5WeltxFibhKIygRkR2R1hExrot/k1BjjWrIK+p6yhavk7Contn8JkuHP7j1Sg6+lVE7XkEsYYm7WJsens4mkpVgYvfU/PhqexHlWo7Egb4kTelFIUTFsKTXE6QWHO2qRKx1zM7jsAcHTAgij1EZU4XphGMrKmnYGluDjD7FZPYyXTIN5hJJrYzUVCbtsuMKALq378/rrzyStPPPffcY5y5ojZpz4QJE0zYKrMnrRIoFpWV72IR8yw88eSTuysBirxEacxJ5D+effZZc6xXt7TDw5qYK9lpTFSsiYPRWyeyRZjsjyfw5p7dH2wSoxaFHW6y2IEdCwsxcHQ+I7FKrHr/MmykaXPxijuN3FARgdoV8zsR46E0rGVHMta9ehiqVmbjqEvmITF9K0GRT7O4t/tJ++z0GBAr042nWsBbqUkorW5F4gfv45p35uKxyZPwl7/8xUiotESMFcmea8Yv1lYtFkANzKoLCIqy6ypWZA8bMcKErIqGdL2srMxEZTqWH1FOIYf92GOP0j9tRDZNmfyT2r3TplUyWeeedy6+N/N7JoE0fovnBMyb3oWY2jQWRShAgPg6dsVgb4gzJ0KGm0ZtQmMG3fZhoymW/NuTo4z6tlEzLiUYxfDmhalNDHPq2kk8E0v5EiWwdmcECRlhVK/MxLI5p+PoS1+A0xuk+VKu08mD2j20x4BY6qaFD6pRNbIeVTtlCoaNHYOzzjnb5BgKY2WaZLJeeuklw5gdO3aYxynPUP4i9yh3K1CG0/w8/Oc/txtO17tHMYqTVgkcgaZo7Rz6q5nf+x7mzf0H/vrmG9ixbTsWfvCB6aSFIbJe3evLhL+xGvddHsK9NWkoeLucJUqa2hNZ+KeQJK/ww1lH9y5u7s0rmTFCYuegm2vGYdM7xXCm8UxZfB4nkkIdbOBNAkL3WvdTu6IVNnizQqhYmo2to0/DsEnPEpBCNpLp6poOAJB4J0r6rEmnO1jEKywsgpOzcMq+Za5k56UpkydPNtVfJWiKqLYyocukmasOh/ALFsOzbTQhgTBWMTj4f7tK2+IT+qaBA42v0YSXniUtUfKovjXjV8XAQd9OuwNlpWVoam1CQzBud5ZSm7RlOHyoDVKX6fD9Ts210MROPRqPFBRj8olZKMtNxJsDUnDzx6WY9tFGxNJpczRZ0wXZOf9eUzYU/rIE+ksGL/0TEU53IGNlC0LJDtg6Vn929xLlVCVjOmydQ90cMZbBAacEwknUkq4jrwMGRE+ThGq+o6y83Myhy1nLZyiiEiDvvvuuyQveeOMNXHTRRSbqUi5SnZaKY6qqMYzDvJRx/s99GRhFMFgMw8fUFOUZXzPSEsPl5OUXZIoEjPITbZ3RRGYmR3KesfDsY3HmjLNx9RVXIjs1E4GWEBqYeDbl5SKZ+cvyNDeWT8mPSzI1IrOO2kGGBT1kapt4M71g9s6naDNKY2OxM4hQnZeybcOW6wrw6hmDkUJhuvy3a5D2hR+RBLr21k5GxsDBkcoAod6Lqm2HYXD6Mj5NJdVvCwgHF1/+w0gnGEBGRoaZsv3oo48wZMgQPPDAA8YHyFyJ5JCV8AkYZeYqKmbwfA2l+zCCUcphnU3bfZzDg3d4fgRNoJsa0J/aoRDZyiHkB0yQUFeLbJoeX5oPm6NbMSk6BlNbxmJIUj5SYslwtTgQqg8ivNkO5yd+zjZOwjstBI/ilkELUZPTD00ENSEcQRKrxy6CUeZyoDQvCaPlkUkxNz+yaJ52kVkyVTJhvF/GKS27Bs4RjXjkxSPw8WGcAqBvoWPECSdnYeIXWxBOZWjbKgQ7IeOqbKjdnouBI3n9u/IhMh0iLcdRFCVSiCmmC6Byaouip530DcqsZaIuuOACU/JQBp6vQh8jLJlbliXJtAS8WVeO5zSzSLt/AUPhm2680URKsv8iK+vWfmWgGpX0BTfaZxGQUUz4NFcihim9I+9cnORdzVrV6hZc4ZqJ00NTMM/5KaeFP0GqP4R6anUrmRxggOEUs0NRjJvPfIFy3xqihgRjcJYGOV1G5uZydWM5OWleOYZwmRMtM9Lx8bA0FAYjqCRgjeEoCtY18un0I23TNRrnPiQnz44adqYgFBgAh4cnWCvrCpiemyxxso1koiTF06ZNw8knn2xyDq00sUrpmpR6/vnnjfZofkLAKLESMSk2W5CDLHN5QFXDsdQmHye8HqfvUQlm2bJlpmp8xhlnGHO1ZOkS5HiyMWVjIYZt5hIeMjUUVU9xMrkAk1QTMNGmC6hByMWPQ+eggHPrT65/C+k0fbUUHAmWBCLotGHTlCw4WqLwfehHcJADn9w6HLREmH7nJsRS2KuHUV+zHS5fAE0OTpuRlxLwRqcd4+oDSFneYgDhdKQ1lH2+Y+xPgPg3eghINlwJ21knox+Jo71P+54DYmQ7fr81z/DKK6+Ycoemb5Vxi1SzEjB///vfzXyEJq9+9atfmXI7aMtDZZV8rygWE5b/8uWglXPhBSwozmJ2rwgqITEBy5ctNz5ERUUVMDdxfvy0DSNQXJuHOlsjHMywVadq/04ChZbQgKFx0OrDFXbi9IzJqPQvx982rEUaAxBOcaFFwsUI63fT+nPSpgBn7mxCwGXHv4alY+rGOnga/cxcuFyJ+uPr34jCya9hbWyWboo/kgJRVOOHdytD2VRFWrzUFWn5LSvMoQaG7sF0tqIaU7/VV2cUN6CdXdn7XJvJ0mlJmRyuwtstnJpV6f2yyy4zd0h75Ess0N555x0MHjzYXENjExc4xMyChRcJyON1lfQlTrxKYBf8619YtGgRLv6vi42GXHXVVabPxSu+RL+Pub5qsQcVMxMRy6B8p5GjcYWL99vJp1anqLrraXTiVJwPvPIMApUVTO7IapovYaLKk4OaMm9oKv410IfcxgA+yUrAu48fjrU/yEMsL4hxl38Ed2YzMpu2IC/SjBqabN2cw4DAQQmI0aG3F4x9hiLl4YNYI0CIS1dtNtW8uqYeaYj6tHyI1ZWiH0VVH9D+a7GDkVhe1LGqvCLlK9IQbZqD9zPi+TfPz+T2K0pfvicRDa01cB91DIZxfiSVbVRyUb8CXBXccEsAue40PDvg3zhr40koruZCPf6LEEhGznH7x6/OiC4a4Vau78rKxMQ127F4zmzgiqvJIBd8DL/lSwJ8OWeAa83YQTm3BEcMT0weBByZhtWT3kU/x3sIRI5AbugDXNt0Ce5MG01Aw/DVaYGtONMNsYk0hOklggQkThKHzqlHgLS/1ayzbSvoyTSpNvWf//zHNFH2rLkRbUoEpSUmieS35j2SdB+163Eag8vp1IOtfjzjcCJIzbieW2f04vMvmNMThp+BgR+6aIoi+PiuIgxeV4/COVUIplBjlJx1QnptscJVZUe/nGnAcy9gXF4BtnFBX3ViEsU2ikTNtXNYzTKBHJ+LW+uOMhz/j9noV/w6osnF7IR5D/uatWsu7vQVUa2SkVwjSec9nVuejqMxzQh+C5/ZDfUIEL1YlOZJFArSs7UjJYma8RNZ0ZHyBk2jigSKNS/RTFNBN441ZNItjGcMsVudS6VWOBjm7iorZdSWafqsqKhEbgoTOVsFjm4aAH9REmbfW4S3B6bh6SXL2QuJzOyO5F9ctWxN05G74N/I02KJyePRPCAfC12M1sJcH8YqQgsFrIER4aAXn8FHK9dj7W0DMXkYC/0RLjh3DENxw1tYUFKIkwZfSCelXjsXhH3GwzGKh/4Gakg3t/QIED0gnfUjrR73eOLZs/rVOlklieZpPHZRKyJt51zMykVRLulUuUWgaFAB7uuhqbxup9moHj8BgRt+gooXXuCirAWsgbtNNq57ReWc8xCVnNcfz517JOYPTsT40mb4Puc6XaHh3/8b6pkRhkbNobgAuPplI7CjHKe+/yhOHRtGYmYRXvrKgbs+rkHul/9GOeVI9/CNsWxbDSYN5XyHDjnVG3QWY1rFH/EhQ6f1jcON2VSBUv9E8Tc0u+acdRwjeCrBhENxnuwPlf0DwucwoOBrR5HFBWlnnDk9niBKvUVkLv+3o72PTaO24bY1M/fwJgFEqYzQdCwZNAhDjz8e2Y11iOayxM3zls+K0aQ5dpVjxYn9sXkgc5lAEBktdNZVbOPgOBhWdkkaJqMcMSx7UgFOTj8ZyV4P/PwZQjQ5FymhrzCgZQVOotLfRYspGbLzPVtCrIXQxP5nkweXTaZZc9to3diZzY8QNeX4qoeRXHoDtqAQXgqVFWFYOZEe6xDXWLZR1dibwftaEuFmxh8nteic9gMIGUbJ8nMg5SE77T8lnZm1caS7+7JkYPeJNunac7zfPZo6JyMyLxPN2JAhcCdnIJLEMjUzaqujGGtWDkphVl0jGkIRVNHGZzSF4hGOjwkdc46uSLKiV48wn2Cqz8qzkw6ahU3yRZNdETvNlb0Yuzi5xiku2HwMyDmn0twWwc1fHWTQwVoY74swTFZf+rVM2MHw1d3WqMGOJY6VsEXsmIAjKLpRhDkhFWQtPpl+MsC7Bpy0BQ3b01jobFaCv1/qFBA9WIGh2x7CGQOq0BTKlhntKOn77bZnFyX9Lk8DAjs3490RozC2gDY2wqKgl6NuU70Y38Dho0aUfo0lwXGcx/Agyc9ZP46GE3j7HxQFykYNCbN+4ktsQCLL4jYWq3ITYihKbeBEFDPoFj+e/2gXOwqxaBoft59WOJOOrZoJX00zM/KM+GPicq0fD9UyOY0yV7Gh4Zjl+M2il8yNj+D/4HBqzaexFZibPB8/z7gE4e39kJpfhfzhK6n4yTThykEoFV1Qp4CorRQ9wkn8SflbMTanBOUtXMDGeWcBLMn7TkjMZmzfGHgD73rHYNwpo3H85nvQ7J3A5K+Zz4mzgLM+lMB/Ird2LP7kOwo+AmKklfZ0f47VnsyyByU4q7gJV436kv2xsEeg7ay2OrlleGNYsLIZc1eFMIiXtsXdlRG+JKYr1Qyk6lr2ZZ7m9b2cQ+8/ayVeqBYYWYxMqrAosIqy5MHz0bnY7C/F0Iv/ioSyKUhMLWNxczUioXT6Xc0edh2adQmIxXCBkkBbODilOW5HrQvfyTetuy0Z3uB/MKf6C8wqOgFVrS+hOLKWNac81vBkSshy2klnNAW3lj2Kf2b/DmVu/Tih65cyQyOzow1cQ8aW+YX1GJ61nZNcRWQGs2tKVILbjnWlAcx4XLk7XYYe1Y4c8k+EsCnQ8TnUN5bQC1B87GL8c+MGPDwHGJxYh60svy3gkvAP8QV26lctnCFMSavGoKHPMOIsYOrCX7ZQI7sT524smqUpfH2KhXHwHOd3963UjdGSeyDOKr0dM+lM7xt6PyW0iaEwnaU9gc/SJCptu6MfcoNf4q0tj2FkcDvZ4oZdtsW8otx2O71NomZwSjV9PP0T+0/NqVSKYcycg2YygZXeZdtacd5jlebuQmb+DXqcMGgjazckW92OZEld9H319h24e56cNO9loqjp4nJOqpTYCQbj65F5jfA6E6gRQ3gsNmusHfviiX2oW0B0hwanrfvu1PrAiPEL2e1mggb8efNDeDAhBw8MfQ6B6FZ4Il9zYUgqX4X2g2FnwDEcQxvfwZXVLxgrHGNRSrZcEQ1df3x8NFPBZhfyTy3BmPPnwjeCyWvaLmp3IpfuuNHYsB0Pzd+KcffUYN2uCMNvYHNdDIf3Y1TEMVhA7H6LLl769UURfLEthOGZLO8zVVGVS6Bk2WV0QijKdtKsUUxUXTwA6hEgVn/7DNa68K2+pSV+w+yC1oVcCvRH3JE8EFePeAsl3hPhCa6GJ7qZr5pECQ4wgumPpJRGJKRTs5jQeRn51TPJ3IBtcHipyU0uDDitFBNmzOa8dimGn7sEnqQK+lEuF42uQ4nnONy8ZCT7E6PsqOfX/Bu53Gi6Jo64zszX8S2tkpCuCTC3y4a1ZUFc/1otgwOunqzmqsg2LgoUpysOwLBcFwGRZSHIHbtUV13SAQHSZS/f+gJBoZkKOIejqHkeStf9AsnRIPqPuBsvDH4Qpd6pdP4bmAPR60bdXFqzCukT+aNSsnWjZzsexKv8gc8ncDCC2oTtnPT6v9jM8riDTjxzyFIWFGnyYmV4pv+DGDnxHhx5wbFGm/5wYS6+vi8Xp41OgmWaHG0caQvy4Gbx0RAZy6o7WoIOPPFB3PuXt9pwXCFDaVojq5nb+B5OuuW54OFJq5+esqhbp97Tjr59O61Kb6amFCM3sBwPrZ+FWdk/wz05x+GyzDtxQ9PVSHr5Udh2fgIbS0L12z6lTrgxl1olGqVwM7ACL3vextb3gPvea8InP2OUWJTOZJoVMFsW6h1efLpjPgry5iB4bz4Kc5h0kt8BcnRjhRI87mtehWQBlJIQR0g+yuFwYeGyLXhkoWmCN/47HWkJ/Kndg5UYxtnGOjp2a1XJ0H40s+xbvR2AgpgqRrz3XvEpTWlFyJ5PY8Kpil33Y0IVF8SlX4VF3iNwzXomY4s1UCZ0+IxiyfAz7OaXjb/G2mw2/eItn+WXUk41T7+/DGvvz0BBpo8ZcwJu3nIN++etKfm0VixqctZPq+DDdNwltXFTw1PGubMSbyg9kSMxYs5nR7dgg30Cz2/EM5cE8b2jklHRyL+bkufAirI94fHNJ/G3kP09LCPtDtzjnfXgsxdpiDVa5RY0MfwMuIbDHW3BmOqnMJr8Cg8C3qhh9svMenOZB838myV+ljP023RJoc/mRgMz5FHFNpSuZshKvVnPhXH9MyspqW5EHEX0QUwpo8yf2xl3LyenJgzx4pXPg+jHmcJMgrKuKoZzR3GZbCpDZ66A9EQ3YoXvStw86wK8WvAELkj5G5HLgz/YzHHE8OAFKZwK5m/k327ERRN9SEmyc5zKeaz36tl3LwQkPnAlfDaasKjNYcyYjUtGr5zaiouOZQ2LTRZt8uPsR6uRR2UpY4atc17OVzew2DhyYC5uP74ET0+9Dit9MUzb9N8s+Qxjm1YzBdveyQoXTo9g1ACaGNKqCvUUpynDvEilSeL0u/ER9Y4UPNu0BrNyFyISHMCHhjjPH8EmOvYrTlBQYMNjH3JaV13s6aatt5599VpA4sOXtkhXGFdKC8jJVJoQJ6OXEflxBrYwFZBDZblrt/2uJygnHkmNcWzE+NTpuCjhaOQEltEU9me3cdNksccIMO/9ansAP57kxaXH+QxDv9wWwNKtAc6xcz6FK92DjsE4ruqPmMyALUyTKlMndMsYpp06wmmcfys1Qj5JdS+jstZDDuA77rEO4Ib/vaaGdXxZmnIyyWvCGv7ZDPpiLqsyZEm+I9ZIM5aPEZV/wMRIEEszzmHphT8TsGnmZY/oak8Jo5+MfG+1H9NHJmLK4Yk44UhuwxNowljfosN30MzRCRGIIQi5inmTHsiBkGpZ6+qfxoktIiHz1C+ZCygkHd+QDiFA4m8opmsKJpOrS24/jYkAaSAz7cGpNviYh4jyfFyx60pFIsG6vGET5qUONytv7FoN3V50yTcxUUyfvyaCARk0GGRmmMdZrCQLvPJ6FiSFB+9T7mKLUVtNL7yR97fSnqUnxSVCoMgHyad8Uzr0AOGbqprh5RyFnKdoLR3w1voYvq6JMyI3lZNfnC4QjW5cj8e9majyTmJiuIU87Gil9aeh6rgUSNzN0hIi7bGbHAJy0jAHtlTSJsZxNtf2/ghJW2lCRcphsnlfTdOeiGvv9t0ddxxdd6172XXjPBkgv31turHb/Snhf/ifOiQxdXbwb0VGKf4DW1bj5qYxzEOkTR39h4GPvKznnIe4nsyyv85JAwX49JEJkC85ewx/B9IFKE5qhXIWgejk8/LTHKgSIKbzA2fYIach7V+xrI5/PWiw3dj+mUcnY8Jgr5FSZchifsg+AFnBNfjtph8jO8D5CPtAY3ba9yHpV0X3cK5WTCAImqm0gBo3yIPXPvejkUVM8t0w3brXapNA7dAklpmmJjcHZjqxqYL+hiDJHB4oHdKAKO7PTIondiHabT+PpTURiavhmKpLbjKzkA6dvynoQmyVnadRgVQa0a1GG6glRTluU4DcVh1mlq5AfC/iiWSvNIKzhG3uaVCmC0u2hsxY1I/6OxA65ABp/36SWmXWenFJo37dlk0/EPcJMkL6J4lXWaT9nR1ZZF1hF4b0HSayuUwKZ4x2s1RPR86T1nU1svYL0p34fFsECnl1UvfouIkLvhwclNW36bgHH4ccIGK8MQX8ziDzN1bFpVOguGiqilifUl1Ky62MpJMJekle7kA6ts6pIKgcJ+6T4s0UXntojs4/KhH/+IqlfzJc/RnlI5fVVr8KkxPfVsO5/ja/YQUGO2soBGxjxtrhyfs/OKScuhjYTMlTdizpk1RuqoxgRUmQ67c4I8JziXToO2qC2LCLoLR7d+3HzUfcAeuSjsX0Xezv081hrCwJIY2JpxI7tZcvyuFCvNe/DOKKDX7jH5RjWMCI2TKbxxW6sGKnlo/Hj2eOcWHZ9iB9kgPp/C1jDscmAC0B0LO7IlvwiQHq55AgDXRtGddyMRkTsxrpTB/8Zz1+fLwPMh0yM1xBZKKeJP6BXuvFxAgxUVogJlqbXlpRUjUB+ffaVkw7nL+Q4tSuybTb7hFon33tx/A8tzFHiqjUV/vOWygkKtPLB+mahEbHnJhEPmfABmVyFTD70W3d0SEFiF5GDlRRjWEKj7kyyLy4mKxzyiusOQ35GDsv6FibwlILjHh7sUjaQPDIMEm/2cg99atISYxUW0m4zJh5Bu+KPyv+LVDVk+mbz7Gydj1Pa7rUtqd0SJksvVSOj38kk5tFcZbGj6z3Ju+6lEZdM7R7x7orbqLa36kmAkqbOtzTsm1/r3Pxjjt+CsgDoUMOkL1Vn0JrGHUg792esRazzP2ddKK2nUm41V7P3x919qz9tT/kANn7Ba1j63t/L7u/a9/0/m96X1dj2aP7XbXoO39QOdAHyEFld/cP6wOkex4d1BZ9gBxUdnf/sD5AuufRQW3RB8hBZXf3D+sDpHseHdQWfYAcVHZ3/7A+QLrn0UFt0QfIQWV39w/rA6R7Hh3UFn2AHFR2d/+w/w/GGw1YiVHDhwAAAABJRU5ErkJggg=="

/***/ }),
/* 2350 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 2351 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 2352 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 2353 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/epsPrimaries/sections/20_gameShow/title_gameshow-4db1c3edea9555aba358c3928e2305e0.png";

/***/ }),
/* 2354 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/epsPrimaries/sections/20_gameShow/title_gameshow_players-1f3dab0745c16a508ea646d3d95269a3.png";

/***/ }),
/* 2355 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0NzAuMiIgaGVpZ2h0PSI0NzAuMiIgdmlld0JveD0iMCAwIDQ3MC4yIDQ3MC4yIj48c3R5bGU+LnN0MHtvcGFjaXR5OjAuNTtmaWxsOm5vbmU7c3Ryb2tlOiNGRkZGRkY7c3Ryb2tlLXdpZHRoOjIwLjI1O3N0cm9rZS1saW5lY2FwOnJvdW5kO3N0cm9rZS1taXRlcmxpbWl0OjEwO30gLnN0MXtmaWxsOm5vbmU7c3Ryb2tlOiNGRkZGRkY7c3Ryb2tlLXdpZHRoOjIwLjI1O3N0cm9rZS1saW5lY2FwOnJvdW5kO3N0cm9rZS1taXRlcmxpbWl0OjEwO308L3N0eWxlPjxjaXJjbGUgY2xhc3M9InN0MCIgY3g9IjIzNS4xIiBjeT0iMjM1LjEiIHI9IjIyNSIvPjxwYXRoIGNsYXNzPSJzdDEiIGQ9Ik0yMzUuMSAxMC4xQTIyNSAyMjUgMCAwIDEgNDYwLjEgMjM1LjEiLz48L3N2Zz4="

/***/ }),
/* 2356 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0NzAuMiIgaGVpZ2h0PSI0NzAuMiIgdmlld0JveD0iMCAwIDQ3MC4yIDQ3MC4yIj48c3R5bGU+LnN0MHtvcGFjaXR5OjAuNTtmaWxsOm5vbmU7c3Ryb2tlOiNGRkZGRkY7c3Ryb2tlLXdpZHRoOjIwLjI1O3N0cm9rZS1saW5lY2FwOnJvdW5kO3N0cm9rZS1taXRlcmxpbWl0OjEwO30gLnN0MXtmaWxsOm5vbmU7c3Ryb2tlOiNGRkZGRkY7c3Ryb2tlLXdpZHRoOjIwLjI1O3N0cm9rZS1saW5lY2FwOnJvdW5kO3N0cm9rZS1taXRlcmxpbWl0OjEwO308L3N0eWxlPjxjaXJjbGUgY2xhc3M9InN0MCIgY3g9IjIzNS4xIiBjeT0iMjM1LjEiIHI9IjIyNSIvPjxwYXRoIGNsYXNzPSJzdDEiIGQ9Ik0yMzUuMSAxMC4xQTIyNSAyMjUgMCAwIDEgMjM1LjEgNDYwLjEiLz48L3N2Zz4="

/***/ }),
/* 2357 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0NzAuMiIgaGVpZ2h0PSI0NzAuMiIgdmlld0JveD0iMCAwIDQ3MC4yIDQ3MC4yIj48c3R5bGU+LnN0MHtvcGFjaXR5OjAuNTtmaWxsOm5vbmU7c3Ryb2tlOiNGRkZGRkY7c3Ryb2tlLXdpZHRoOjIwLjI1O3N0cm9rZS1saW5lY2FwOnJvdW5kO3N0cm9rZS1taXRlcmxpbWl0OjEwO30uc3Qxe2ZpbGw6bm9uZTtzdHJva2U6I0ZGRkZGRjtzdHJva2Utd2lkdGg6MjAuMjU7c3Ryb2tlLWxpbmVjYXA6cm91bmQ7c3Ryb2tlLW1pdGVybGltaXQ6MTA7fTwvc3R5bGU+PGNpcmNsZSBjbGFzcz0ic3QwIiBjeD0iMjM1LjEiIGN5PSIyMzUuMSIgcj0iMjI1Ii8+PHBhdGggY2xhc3M9InN0MSIgZD0iTTIzNS4xIDEwLjFBMjI1IDIyNSAwIDEgMSAxMC4xIDIzNS4xIi8+PC9zdmc+"

/***/ }),
/* 2358 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0NzAuMiIgaGVpZ2h0PSI0NzAuMiIgdmlld0JveD0iMCAwIDQ3MC4yIDQ3MC4yIj48c3R5bGU+LnN0MHtvcGFjaXR5OjAuNTtmaWxsOm5vbmU7c3Ryb2tlOiNGRkZGRkY7c3Ryb2tlLXdpZHRoOjIwLjI1O3N0cm9rZS1saW5lY2FwOnJvdW5kO3N0cm9rZS1taXRlcmxpbWl0OjEwO30gLnN0MXtmaWxsOm5vbmU7c3Ryb2tlOiNGRkZGRkY7c3Ryb2tlLXdpZHRoOjIwLjI1O3N0cm9rZS1saW5lY2FwOnJvdW5kO3N0cm9rZS1taXRlcmxpbWl0OjEwO308L3N0eWxlPjxjaXJjbGUgY2xhc3M9InN0MCIgY3g9IjIzNS4xIiBjeT0iMjM1LjEiIHI9IjIyNSIvPjxjaXJjbGUgY2xhc3M9InN0MSIgY3g9IjIzNS4xIiBjeT0iMjM1LjEiIHI9IjIyNSIvPjwvc3ZnPg=="

/***/ }),
/* 2359 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/h2whoa/images/characters/apprenticeArmsFolded2-d85327598c4b416d7264a69b386051a0.png";

/***/ }),
/* 2360 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/h2whoa/images/characters/apprenticeCurious-3e7236cce83cb89c2edaeb8503ed9211.png";

/***/ }),
/* 2361 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/h2whoa/images/characters/apprenticeFistUp-5390131095151e6e55b467351470b1b0.png";

/***/ }),
/* 2362 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/h2whoa/images/characters/apprenticeHandsHips-b4f26c1a9e0dd97ed5eb777b8471d8dc.png";

/***/ }),
/* 2363 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/h2whoa/images/characters/apprenticeHandsHips2-13a429b2c8f7b2f101a13dd077b67c2c.png";

/***/ }),
/* 2364 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/h2whoa/images/characters/apprenticeHandsHips3-406e8811bf51c1fbab97ac9ffe403280.png";

/***/ }),
/* 2365 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/h2whoa/images/characters/apprenticePointingUp2-9c0ac37f7e4a051b551e8d86a6fbf1fb.png";

/***/ }),
/* 2366 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/h2whoa/images/characters/apprenticePointingUp3-8de0bd064b02d2e9ed3688e6ef5bec10.png";

/***/ }),
/* 2367 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/h2whoa/images/characters/apprenticesBackToBack-3828e498bf581cc27ecb2f351a349b23.png";

/***/ }),
/* 2368 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/h2whoa/images/characters/apprenticesPairArmsFolded-35d4b6c7dcaec4d89b2c5f631fcbfe04.png";

/***/ }),
/* 2369 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/h2whoa/images/characters/apprenticesPosing-ed4fd2a18932986d429cc02c13295d3c.png";

/***/ }),
/* 2370 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/h2whoa/images/characters/apprenticesRowArmsFolded-8d1e0374293625adce385ef4a156323c.png";

/***/ }),
/* 2371 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/h2whoa/images/characters/esPowerStance-82650de0a8f295f4044d086805341795.png";

/***/ }),
/* 2372 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/h2whoa/images/characters/esmeralda_hands_out_up_close-ba6908f9d0561286ef51d4d905ef4d57.png";

/***/ }),
/* 2373 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/h2whoa/images/characters/ian_pointing_down-026a77087cf65bf8bbd037d9b72502c3.png";

/***/ }),
/* 2374 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/h2whoa/images/characters/ian_pointing_left-4596053eb82e04f727bdd744c3de0325.png";

/***/ }),
/* 2375 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/h2whoa/images/characters/ian_pointing_up-bba09e13f5577e652503b9d51f9542fe.png";

/***/ }),
/* 2376 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/h2whoa/images/characters/ian_sara_lean_smile-12d488cb6a6d1d48a6f2c910bc4b245d.png";

/***/ }),
/* 2377 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/h2whoa/images/characters/ian_sara_side-465d53e88668c40822120ecc48022186.png";

/***/ }),
/* 2378 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/h2whoa/images/characters/ian_sara_silly-8139b5d7a02986b6a0cea289575bc98a.png";

/***/ }),
/* 2379 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/h2whoa/images/characters/ian_shrug_laugh-f19e9de88cd7960d4eff1c212c0e2d5f.png";

/***/ }),
/* 2380 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/h2whoa/images/characters/ian_side-73146e2c2ff78c910e4856232244643f.png";

/***/ }),
/* 2381 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/h2whoa/images/characters/sara_giggle-f59c43c85e15482d7fe0fc5dcac1de28.png";

/***/ }),
/* 2382 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/h2whoa/images/characters/sara_humph-a0889c055339bc1bd36428414d9e217e.png";

/***/ }),
/* 2383 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/h2whoa/images/characters/sara_smile-235bfd423fca04d38d1338973d9baaa5.png";

/***/ }),
/* 2384 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/h2whoa/images/characters/sara_twist_hands_out_heyhey-88fc7fcb491ac0a78f3ce4e8d416ce57.png";

/***/ }),
/* 2385 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/h2whoa/images/h2whoa.fr_CA-b7b32fac49870d47f86ec0e0fe764d27.png";

/***/ }),
/* 2386 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/h2whoa/images/h2whoa-2c81689cb1d200f7f297e1bfba69f72b.png";

/***/ }),
/* 2387 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/h2whoa/images/h2whoaExpired.fr_CA-009a7a50c8169db1f12ce9dcf8b065a7.png";

/***/ }),
/* 2388 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/h2whoa/images/h2whoaExpired-1de9dc822f551f75918590c0c6137608.png";

/***/ }),
/* 2389 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/h2whoa/images/h2whoaNoPPAPresents.fr_CA-0e02223aee7f72661a75e7515aa43a4f.png";

/***/ }),
/* 2390 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/h2whoa/images/h2whoaNoPPAPresents-d4d78bb7a2c06186e0530bd2fe983ff3.png";

/***/ }),
/* 2391 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/h2whoa/images/h2whoaTrial.fr_CA-5d324fcea46b0fa996e5a5e090693d48.png";

/***/ }),
/* 2392 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/h2whoa/images/h2whoaTrial-a0f49e576aad495f3ca4e21d39e1d96a.png";

/***/ }),
/* 2393 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 2394 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 2395 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 2396 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 2397 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/h2whoa/images/ppa_presents.fr_CA-42f6e3f2450b839eaf54d062274ca9ff.png";

/***/ }),
/* 2398 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/h2whoa/images/ppa_presents-9ffdcda2ef138e90e14be483c614d6bd.png";

/***/ }),
/* 2399 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/h2whoa/sections/20_gameShow/title_gameshow.fr_CA-5cc8b43f26b2adb1d2ffd8d862d7cff8.png";

/***/ }),
/* 2400 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/h2whoa/sections/20_gameShow/title_gameshow-4db1c3edea9555aba358c3928e2305e0.png";

/***/ }),
/* 2401 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/h2whoa/sections/20_gameShow/title_gameshow_players.fr_CA-efe5824dfaf329ec6522e78dabb21c6c.png";

/***/ }),
/* 2402 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/h2whoa/sections/20_gameShow/title_gameshow_players-1f3dab0745c16a508ea646d3d95269a3.png";

/***/ }),
/* 2403 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0NzAuMiIgaGVpZ2h0PSI0NzAuMiIgdmlld0JveD0iMCAwIDQ3MC4yIDQ3MC4yIj48c3R5bGU+LnN0MHtvcGFjaXR5OjAuNTtmaWxsOm5vbmU7c3Ryb2tlOiNGRkZGRkY7c3Ryb2tlLXdpZHRoOjIwLjI1O3N0cm9rZS1saW5lY2FwOnJvdW5kO3N0cm9rZS1taXRlcmxpbWl0OjEwO30gLnN0MXtmaWxsOm5vbmU7c3Ryb2tlOiNGRkZGRkY7c3Ryb2tlLXdpZHRoOjIwLjI1O3N0cm9rZS1saW5lY2FwOnJvdW5kO3N0cm9rZS1taXRlcmxpbWl0OjEwO308L3N0eWxlPjxjaXJjbGUgY2xhc3M9InN0MCIgY3g9IjIzNS4xIiBjeT0iMjM1LjEiIHI9IjIyNSIvPjxwYXRoIGNsYXNzPSJzdDEiIGQ9Ik0yMzUuMSAxMC4xQTIyNSAyMjUgMCAwIDEgNDYwLjEgMjM1LjEiLz48L3N2Zz4="

/***/ }),
/* 2404 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0NzAuMiIgaGVpZ2h0PSI0NzAuMiIgdmlld0JveD0iMCAwIDQ3MC4yIDQ3MC4yIj48c3R5bGU+LnN0MHtvcGFjaXR5OjAuNTtmaWxsOm5vbmU7c3Ryb2tlOiNGRkZGRkY7c3Ryb2tlLXdpZHRoOjIwLjI1O3N0cm9rZS1saW5lY2FwOnJvdW5kO3N0cm9rZS1taXRlcmxpbWl0OjEwO30gLnN0MXtmaWxsOm5vbmU7c3Ryb2tlOiNGRkZGRkY7c3Ryb2tlLXdpZHRoOjIwLjI1O3N0cm9rZS1saW5lY2FwOnJvdW5kO3N0cm9rZS1taXRlcmxpbWl0OjEwO308L3N0eWxlPjxjaXJjbGUgY2xhc3M9InN0MCIgY3g9IjIzNS4xIiBjeT0iMjM1LjEiIHI9IjIyNSIvPjxwYXRoIGNsYXNzPSJzdDEiIGQ9Ik0yMzUuMSAxMC4xQTIyNSAyMjUgMCAwIDEgMjM1LjEgNDYwLjEiLz48L3N2Zz4="

/***/ }),
/* 2405 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0NzAuMiIgaGVpZ2h0PSI0NzAuMiIgdmlld0JveD0iMCAwIDQ3MC4yIDQ3MC4yIj48c3R5bGU+LnN0MHtvcGFjaXR5OjAuNTtmaWxsOm5vbmU7c3Ryb2tlOiNGRkZGRkY7c3Ryb2tlLXdpZHRoOjIwLjI1O3N0cm9rZS1saW5lY2FwOnJvdW5kO3N0cm9rZS1taXRlcmxpbWl0OjEwO30uc3Qxe2ZpbGw6bm9uZTtzdHJva2U6I0ZGRkZGRjtzdHJva2Utd2lkdGg6MjAuMjU7c3Ryb2tlLWxpbmVjYXA6cm91bmQ7c3Ryb2tlLW1pdGVybGltaXQ6MTA7fTwvc3R5bGU+PGNpcmNsZSBjbGFzcz0ic3QwIiBjeD0iMjM1LjEiIGN5PSIyMzUuMSIgcj0iMjI1Ii8+PHBhdGggY2xhc3M9InN0MSIgZD0iTTIzNS4xIDEwLjFBMjI1IDIyNSAwIDEgMSAxMC4xIDIzNS4xIi8+PC9zdmc+"

/***/ }),
/* 2406 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0NzAuMiIgaGVpZ2h0PSI0NzAuMiIgdmlld0JveD0iMCAwIDQ3MC4yIDQ3MC4yIj48c3R5bGU+LnN0MHtvcGFjaXR5OjAuNTtmaWxsOm5vbmU7c3Ryb2tlOiNGRkZGRkY7c3Ryb2tlLXdpZHRoOjIwLjI1O3N0cm9rZS1saW5lY2FwOnJvdW5kO3N0cm9rZS1taXRlcmxpbWl0OjEwO30gLnN0MXtmaWxsOm5vbmU7c3Ryb2tlOiNGRkZGRkY7c3Ryb2tlLXdpZHRoOjIwLjI1O3N0cm9rZS1saW5lY2FwOnJvdW5kO3N0cm9rZS1taXRlcmxpbWl0OjEwO308L3N0eWxlPjxjaXJjbGUgY2xhc3M9InN0MCIgY3g9IjIzNS4xIiBjeT0iMjM1LjEiIHI9IjIyNSIvPjxjaXJjbGUgY2xhc3M9InN0MSIgY3g9IjIzNS4xIiBjeT0iMjM1LjEiIHI9IjIyNSIvPjwvc3ZnPg=="

/***/ }),
/* 2407 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/h2whoaHybrid/images/characters/ian_hand_raised-384fabc0cb5b98efe85310c0d8c15540.png";

/***/ }),
/* 2408 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/h2whoaHybrid/images/characters/ian_pointing_down-026a77087cf65bf8bbd037d9b72502c3.png";

/***/ }),
/* 2409 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/h2whoaHybrid/images/characters/ian_pointing_left-4596053eb82e04f727bdd744c3de0325.png";

/***/ }),
/* 2410 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/h2whoaHybrid/images/characters/ian_sara_two_fingers-5ed565638eae000314880d23ff009b43.png";

/***/ }),
/* 2411 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/h2whoaHybrid/images/characters/ian_shrug_laugh-f19e9de88cd7960d4eff1c212c0e2d5f.png";

/***/ }),
/* 2412 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/h2whoaHybrid/images/characters/sara_humph-a0889c055339bc1bd36428414d9e217e.png";

/***/ }),
/* 2413 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/h2whoaHybrid/images/characters/sara_twist_hands_out_heyhey-88fc7fcb491ac0a78f3ce4e8d416ce57.png";

/***/ }),
/* 2414 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/h2whoaHybrid/images/characters/sara_twist_hands_out_yay-bcf1fb30eda8e0aa404ef594e2dd3fd6.png";

/***/ }),
/* 2415 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/h2whoaHybrid/images/h2whoa-67e47c588e7a1903246d0b195377ad21.png";

/***/ }),
/* 2416 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/h2whoaHybrid/images/h2whoaExpired-a01aa247521e4ea23ce1fe9116e4c48a.png";

/***/ }),
/* 2417 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/h2whoaHybrid/images/h2whoaLevelStart-03c67538e52524739ace8ec4b4e545bf.png";

/***/ }),
/* 2418 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/h2whoaHybrid/images/h2whoaTrial-67e47c588e7a1903246d0b195377ad21.png";

/***/ }),
/* 2419 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/h2whoaHybrid/images/level-0_start-e43962d310155302845da8ef5f15e7d0.png";

/***/ }),
/* 2420 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/h2whoaHybrid/images/level-2_start-e43962d310155302845da8ef5f15e7d0.png";

/***/ }),
/* 2421 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/h2whoaHybrid/images/overview/level-1_start-e43962d310155302845da8ef5f15e7d0.png";

/***/ }),
/* 2422 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/h2whoaHybrid/images/overview/level-2_start-e43962d310155302845da8ef5f15e7d0.png";

/***/ }),
/* 2423 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 2424 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/h2whoaHybrid/sections/20_gameShow/title_gameshow-4db1c3edea9555aba358c3928e2305e0.png";

/***/ }),
/* 2425 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/h2whoaHybrid/sections/20_gameShow/title_gameshow_players-1f3dab0745c16a508ea646d3d95269a3.png";

/***/ }),
/* 2426 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0NzAuMiIgaGVpZ2h0PSI0NzAuMiIgdmlld0JveD0iMCAwIDQ3MC4yIDQ3MC4yIj48c3R5bGU+LnN0MHtvcGFjaXR5OjAuNTtmaWxsOm5vbmU7c3Ryb2tlOiNGRkZGRkY7c3Ryb2tlLXdpZHRoOjIwLjI1O3N0cm9rZS1saW5lY2FwOnJvdW5kO3N0cm9rZS1taXRlcmxpbWl0OjEwO30gLnN0MXtmaWxsOm5vbmU7c3Ryb2tlOiNGRkZGRkY7c3Ryb2tlLXdpZHRoOjIwLjI1O3N0cm9rZS1saW5lY2FwOnJvdW5kO3N0cm9rZS1taXRlcmxpbWl0OjEwO308L3N0eWxlPjxjaXJjbGUgY2xhc3M9InN0MCIgY3g9IjIzNS4xIiBjeT0iMjM1LjEiIHI9IjIyNSIvPjxwYXRoIGNsYXNzPSJzdDEiIGQ9Ik00MjkuMiAxMjIuNkMzODYuNCA0OC42IDMxMiAxMC4yIDIzNC4zIDEwLjFNNDI5LjIgMzQ3LjZjNDIuOC03NCAzOC44LTE1Ny43IDAtMjI1TTIzNC40IDQ2MC4xYzg1LjUgMCAxNTUuOS00NS4zIDE5NC44LTExMi41Ii8+PC9zdmc+"

/***/ }),
/* 2427 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0NzAuMiIgaGVpZ2h0PSI0NzAuMiIgdmlld0JveD0iMCAwIDQ3MC4yIDQ3MC4yIj48c3R5bGU+LnN0MHtmaWxsOm5vbmU7c3Ryb2tlOiNGRkZGRkY7c3Ryb2tlLXdpZHRoOjIwLjI1O3N0cm9rZS1saW5lY2FwOnJvdW5kO3N0cm9rZS1taXRlcmxpbWl0OjEwO308L3N0eWxlPjxjaXJjbGUgY2xhc3M9InN0MCIgY3g9IjIzNS4xIiBjeT0iMjM1LjEiIHI9IjIyNSIvPjwvc3ZnPg=="

/***/ }),
/* 2428 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/keepCool/images/characters/apprenticeArmsFolded-ae02d69d86e93dfd0afff07429891ee6.png";

/***/ }),
/* 2429 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/keepCool/images/characters/apprenticeArmsFolded2-d85327598c4b416d7264a69b386051a0.png";

/***/ }),
/* 2430 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/keepCool/images/characters/apprenticeCurious-3e7236cce83cb89c2edaeb8503ed9211.png";

/***/ }),
/* 2431 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/keepCool/images/characters/apprenticeFistUp-5390131095151e6e55b467351470b1b0.png";

/***/ }),
/* 2432 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/keepCool/images/characters/apprenticeHandsHips-b4f26c1a9e0dd97ed5eb777b8471d8dc.png";

/***/ }),
/* 2433 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/keepCool/images/characters/apprenticeHandsHips2-13a429b2c8f7b2f101a13dd077b67c2c.png";

/***/ }),
/* 2434 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/keepCool/images/characters/apprenticeHandsHips3-406e8811bf51c1fbab97ac9ffe403280.png";

/***/ }),
/* 2435 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/keepCool/images/characters/apprenticePointingUp2-9c0ac37f7e4a051b551e8d86a6fbf1fb.png";

/***/ }),
/* 2436 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/keepCool/images/characters/apprenticePointingUp3-8de0bd064b02d2e9ed3688e6ef5bec10.png";

/***/ }),
/* 2437 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/keepCool/images/characters/apprenticesBackToBack-3828e498bf581cc27ecb2f351a349b23.png";

/***/ }),
/* 2438 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/keepCool/images/characters/apprenticesPairArmsFolded-35d4b6c7dcaec4d89b2c5f631fcbfe04.png";

/***/ }),
/* 2439 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/keepCool/images/characters/apprenticesPosing-ed4fd2a18932986d429cc02c13295d3c.png";

/***/ }),
/* 2440 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/keepCool/images/characters/apprenticesRowArmsFolded-8d1e0374293625adce385ef4a156323c.png";

/***/ }),
/* 2441 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/keepCool/images/characters/esPowerStance-1381274efb7c4ae5e4948aa6c44fad6c.png";

/***/ }),
/* 2442 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/keepCool/images/characters/esmeralda_goober_wave-2bdb9e5ebafcf6d5d72017482c38d41f.png";

/***/ }),
/* 2443 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/keepCool/images/characters/esmeralda_hands_out_up_close-ba6908f9d0561286ef51d4d905ef4d57.png";

/***/ }),
/* 2444 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/keepCool/images/characters/ian_headshot_smile-b903fb205b52f0700ed096f73d3e7ab2.png";

/***/ }),
/* 2445 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/keepCool/images/characters/ian_sara_side-465d53e88668c40822120ecc48022186.png";

/***/ }),
/* 2446 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/keepCool/images/characters/ian_sara_silly-8139b5d7a02986b6a0cea289575bc98a.png";

/***/ }),
/* 2447 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/keepCool/images/characters/sara_giggle-f59c43c85e15482d7fe0fc5dcac1de28.png";

/***/ }),
/* 2448 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/keepCool/images/keepCool.fr_CA-f6a250f16ff52e54c8b1d928024df0b1.png";

/***/ }),
/* 2449 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/keepCool/images/keepCool-513e2dc5847d4f1af6d7556ebba5f062.png";

/***/ }),
/* 2450 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/keepCool/images/keepCoolExpired.fr_CA-9153361e59bcc76ae525d2724f6a85bb.png";

/***/ }),
/* 2451 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/keepCool/images/keepCoolExpired-6ca7b47ff2484639ca929820dadf9045.png";

/***/ }),
/* 2452 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/keepCool/images/keepCoolNoPPAPresents.fr_CA-c5434e3f5c25d978c579d5cdc388b3d8.png";

/***/ }),
/* 2453 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/keepCool/images/keepCoolNoPPAPresents-81aa5e2a52cdb5d614f38589ec185d01.png";

/***/ }),
/* 2454 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/keepCool/images/keepCoolTrial.fr_CA-f6a250f16ff52e54c8b1d928024df0b1.png";

/***/ }),
/* 2455 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/keepCool/images/keepCoolTrial-513e2dc5847d4f1af6d7556ebba5f062.png";

/***/ }),
/* 2456 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 2457 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 2458 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 2459 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 2460 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 2461 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 2462 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/keepCool/images/ppa_presents.fr_CA-42f6e3f2450b839eaf54d062274ca9ff.png";

/***/ }),
/* 2463 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/keepCool/images/ppa_presents-9ffdcda2ef138e90e14be483c614d6bd.png";

/***/ }),
/* 2464 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/keepCool/sections/20_gameShow/title_gameshow.fr_CA-5cc8b43f26b2adb1d2ffd8d862d7cff8.png";

/***/ }),
/* 2465 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/keepCool/sections/20_gameShow/title_gameshow-4db1c3edea9555aba358c3928e2305e0.png";

/***/ }),
/* 2466 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/keepCool/sections/20_gameShow/title_gameshow_players.fr_CA-efe5824dfaf329ec6522e78dabb21c6c.png";

/***/ }),
/* 2467 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/keepCool/sections/20_gameShow/title_gameshow_players-1f3dab0745c16a508ea646d3d95269a3.png";

/***/ }),
/* 2468 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0NzAuMiIgaGVpZ2h0PSI0NzAuMiIgdmlld0JveD0iMCAwIDQ3MC4yIDQ3MC4yIj48c3R5bGU+LnN0MHtvcGFjaXR5OjAuNTtmaWxsOm5vbmU7c3Ryb2tlOiNGRkZGRkY7c3Ryb2tlLXdpZHRoOjIwLjI1O3N0cm9rZS1saW5lY2FwOnJvdW5kO3N0cm9rZS1taXRlcmxpbWl0OjEwO30gLnN0MXtmaWxsOm5vbmU7c3Ryb2tlOiNGRkZGRkY7c3Ryb2tlLXdpZHRoOjIwLjI1O3N0cm9rZS1saW5lY2FwOnJvdW5kO3N0cm9rZS1taXRlcmxpbWl0OjEwO308L3N0eWxlPjxjaXJjbGUgY2xhc3M9InN0MCIgY3g9IjIzNS4xIiBjeT0iMjM1LjEiIHI9IjIyNSIvPjxwYXRoIGNsYXNzPSJzdDEiIGQ9Ik00MjkuMiAxMjIuNkMzODYuNCA0OC42IDMxMiAxMC4yIDIzNC4zIDEwLjEiLz48L3N2Zz4="

/***/ }),
/* 2469 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0NzAuMiIgaGVpZ2h0PSI0NzAuMiIgdmlld0JveD0iMCAwIDQ3MC4yIDQ3MC4yIj48c3R5bGU+LnN0MHtvcGFjaXR5OjAuNTtmaWxsOm5vbmU7c3Ryb2tlOiNGRkZGRkY7c3Ryb2tlLXdpZHRoOjIwLjI1O3N0cm9rZS1saW5lY2FwOnJvdW5kO3N0cm9rZS1taXRlcmxpbWl0OjEwO30gLnN0MXtmaWxsOm5vbmU7c3Ryb2tlOiNGRkZGRkY7c3Ryb2tlLXdpZHRoOjIwLjI1O3N0cm9rZS1saW5lY2FwOnJvdW5kO3N0cm9rZS1taXRlcmxpbWl0OjEwO308L3N0eWxlPjxjaXJjbGUgY2xhc3M9InN0MCIgY3g9IjIzNS4xIiBjeT0iMjM1LjEiIHI9IjIyNSIvPjxwYXRoIGNsYXNzPSJzdDEiIGQ9Ik00MjkuMiAxMjIuNkMzODYuNCA0OC42IDMxMiAxMC4yIDIzNC4zIDEwLjFNNDI5LjIgMzQ3LjZjNDIuOC03NCAzOC44LTE1Ny43IDAtMjI1Ii8+PC9zdmc+"

/***/ }),
/* 2470 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0NzAuMiIgaGVpZ2h0PSI0NzAuMiIgdmlld0JveD0iMCAwIDQ3MC4yIDQ3MC4yIj48c3R5bGU+LnN0MHtvcGFjaXR5OjAuNTtmaWxsOm5vbmU7c3Ryb2tlOiNGRkZGRkY7c3Ryb2tlLXdpZHRoOjIwLjI1O3N0cm9rZS1saW5lY2FwOnJvdW5kO3N0cm9rZS1taXRlcmxpbWl0OjEwO30gLnN0MXtmaWxsOm5vbmU7c3Ryb2tlOiNGRkZGRkY7c3Ryb2tlLXdpZHRoOjIwLjI1O3N0cm9rZS1saW5lY2FwOnJvdW5kO3N0cm9rZS1taXRlcmxpbWl0OjEwO308L3N0eWxlPjxjaXJjbGUgY2xhc3M9InN0MCIgY3g9IjIzNS4xIiBjeT0iMjM1LjEiIHI9IjIyNSIvPjxwYXRoIGNsYXNzPSJzdDEiIGQ9Ik00MjkuMiAxMjIuNkMzODYuNCA0OC42IDMxMiAxMC4yIDIzNC4zIDEwLjFNNDI5LjIgMzQ3LjZjNDIuOC03NCAzOC44LTE1Ny43IDAtMjI1TTIzNC40IDQ2MC4xYzg1LjUgMCAxNTUuOS00NS4zIDE5NC44LTExMi41Ii8+PC9zdmc+"

/***/ }),
/* 2471 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0NzAuMiIgaGVpZ2h0PSI0NzAuMiIgdmlld0JveD0iMCAwIDQ3MC4yIDQ3MC4yIj48c3R5bGU+LnN0MHtvcGFjaXR5OjAuNTtmaWxsOm5vbmU7c3Ryb2tlOiNGRkZGRkY7c3Ryb2tlLXdpZHRoOjIwLjI1O3N0cm9rZS1saW5lY2FwOnJvdW5kO3N0cm9rZS1taXRlcmxpbWl0OjEwO30gLnN0MXtmaWxsOm5vbmU7c3Ryb2tlOiNGRkZGRkY7c3Ryb2tlLXdpZHRoOjIwLjI1O3N0cm9rZS1saW5lY2FwOnJvdW5kO3N0cm9rZS1taXRlcmxpbWl0OjEwO308L3N0eWxlPjxjaXJjbGUgY2xhc3M9InN0MCIgY3g9IjIzNS4xIiBjeT0iMjM1LjEiIHI9IjIyNSIvPjxwYXRoIGNsYXNzPSJzdDEiIGQ9Ik00MjkuMiAxMjIuNkMzODYuNCA0OC42IDMxMiAxMC4yIDIzNC4zIDEwLjFNNDI5LjIgMzQ3LjZjNDIuOC03NCAzOC44LTE1Ny43IDAtMjI1TTIzNC40IDQ2MC4xYzg1LjUgMCAxNTUuOS00NS4zIDE5NC44LTExMi41TTM5LjUgMzQ3LjZjNDIuOCA3NCAxMTguNCAxMTIuNCAxOTQuOSAxMTIuNSIvPjwvc3ZnPg=="

/***/ }),
/* 2472 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0NzEuNCIgaGVpZ2h0PSI0NzAuMiIgdmlld0JveD0iMCAwIDQ3MS40IDQ3MC4yIj48c3R5bGU+LnN0MHtvcGFjaXR5OjAuNTtmaWxsOm5vbmU7c3Ryb2tlOiNGRkZGRkY7c3Ryb2tlLXdpZHRoOjIwLjI1O3N0cm9rZS1saW5lY2FwOnJvdW5kO3N0cm9rZS1taXRlcmxpbWl0OjEwO30gLnN0MXtmaWxsOm5vbmU7c3Ryb2tlOiNGRkZGRkY7c3Ryb2tlLXdpZHRoOjIwLjI1O3N0cm9rZS1saW5lY2FwOnJvdW5kO3N0cm9rZS1taXRlcmxpbWl0OjEwO308L3N0eWxlPjxjaXJjbGUgY2xhc3M9InN0MCIgY3g9IjIzNi4zIiBjeT0iMjM1LjEiIHI9IjIyNSIvPjxwYXRoIGNsYXNzPSJzdDEiIGQ9Ik00MzAuNCAxMjIuNmMtNDIuOC03NC0xMTcuMi0xMTIuNC0xOTQuOS0xMTIuNU00MzAuNCAzNDcuNmM0Mi44LTc0IDM4LjgtMTU3LjcgMC0yMjVNMjM1LjYgNDYwLjFjODUuNSAwIDE1NS45LTQ1LjMgMTk0LjgtMTEyLjVNNDAuNyAzNDcuNmM0Mi44IDc0IDExOC40IDExMi40IDE5NC45IDExMi41TTQwLjcgMTIyLjZjLTQyLjggNzQtMzguOCAxNTcuNyAwIDIyNSIvPjwvc3ZnPg=="

/***/ }),
/* 2473 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0NzAuMiIgaGVpZ2h0PSI0NzAuMiIgdmlld0JveD0iMCAwIDQ3MC4yIDQ3MC4yIj48c3R5bGU+LnN0MHtmaWxsOm5vbmU7c3Ryb2tlOiNGRkZGRkY7c3Ryb2tlLXdpZHRoOjIwLjI1O3N0cm9rZS1saW5lY2FwOnJvdW5kO3N0cm9rZS1taXRlcmxpbWl0OjEwO308L3N0eWxlPjxjaXJjbGUgY2xhc3M9InN0MCIgY3g9IjIzNS4xIiBjeT0iMjM1LjEiIHI9IjIyNSIvPjwvc3ZnPg=="

/***/ }),
/* 2474 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/zeroHeroes/images/characters/apprenticeArmsFolded-ae02d69d86e93dfd0afff07429891ee6.png";

/***/ }),
/* 2475 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/zeroHeroes/images/characters/apprenticeArmsFolded2-d85327598c4b416d7264a69b386051a0.png";

/***/ }),
/* 2476 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/zeroHeroes/images/characters/apprenticeCurious-3e7236cce83cb89c2edaeb8503ed9211.png";

/***/ }),
/* 2477 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/zeroHeroes/images/characters/apprenticeFistUp-5390131095151e6e55b467351470b1b0.png";

/***/ }),
/* 2478 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/zeroHeroes/images/characters/apprenticeHandsHips-b4f26c1a9e0dd97ed5eb777b8471d8dc.png";

/***/ }),
/* 2479 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/zeroHeroes/images/characters/apprenticeHandsHips2-13a429b2c8f7b2f101a13dd077b67c2c.png";

/***/ }),
/* 2480 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/zeroHeroes/images/characters/apprenticeHandsHips3-406e8811bf51c1fbab97ac9ffe403280.png";

/***/ }),
/* 2481 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/zeroHeroes/images/characters/apprenticePointingUp2-9c0ac37f7e4a051b551e8d86a6fbf1fb.png";

/***/ }),
/* 2482 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/zeroHeroes/images/characters/apprenticePointingUp3-8de0bd064b02d2e9ed3688e6ef5bec10.png";

/***/ }),
/* 2483 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/zeroHeroes/images/characters/apprenticesBackToBack-3828e498bf581cc27ecb2f351a349b23.png";

/***/ }),
/* 2484 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/zeroHeroes/images/characters/apprenticesPairArmsFolded-35d4b6c7dcaec4d89b2c5f631fcbfe04.png";

/***/ }),
/* 2485 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/zeroHeroes/images/characters/apprenticesPosing-ed4fd2a18932986d429cc02c13295d3c.png";

/***/ }),
/* 2486 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/zeroHeroes/images/characters/apprenticesRowArmsFolded-8d1e0374293625adce385ef4a156323c.png";

/***/ }),
/* 2487 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/zeroHeroes/images/characters/esPowerStance-82650de0a8f295f4044d086805341795.png";

/***/ }),
/* 2488 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/zeroHeroes/images/characters/esmeralda_goober_wave-2bdb9e5ebafcf6d5d72017482c38d41f.png";

/***/ }),
/* 2489 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/zeroHeroes/images/characters/esmeralda_hands_out_up_close-ba6908f9d0561286ef51d4d905ef4d57.png";

/***/ }),
/* 2490 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/zeroHeroes/images/characters/ian_pointing_down-026a77087cf65bf8bbd037d9b72502c3.png";

/***/ }),
/* 2491 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/zeroHeroes/images/characters/ian_pointing_left-4596053eb82e04f727bdd744c3de0325.png";

/***/ }),
/* 2492 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/zeroHeroes/images/characters/ian_pointing_up-bba09e13f5577e652503b9d51f9542fe.png";

/***/ }),
/* 2493 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/zeroHeroes/images/characters/ian_sara_side-465d53e88668c40822120ecc48022186.png";

/***/ }),
/* 2494 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/zeroHeroes/images/characters/ian_sara_silly-8139b5d7a02986b6a0cea289575bc98a.png";

/***/ }),
/* 2495 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/zeroHeroes/images/characters/ian_shrug_laugh-f19e9de88cd7960d4eff1c212c0e2d5f.png";

/***/ }),
/* 2496 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/zeroHeroes/images/characters/ian_side-73146e2c2ff78c910e4856232244643f.png";

/***/ }),
/* 2497 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/zeroHeroes/images/characters/sara_giggle-f59c43c85e15482d7fe0fc5dcac1de28.png";

/***/ }),
/* 2498 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/zeroHeroes/images/characters/sara_humph-a0889c055339bc1bd36428414d9e217e.png";

/***/ }),
/* 2499 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/zeroHeroes/images/characters/sara_smile-235bfd423fca04d38d1338973d9baaa5.png";

/***/ }),
/* 2500 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/zeroHeroes/images/characters/sara_twist_hands_out_heyhey-88fc7fcb491ac0a78f3ce4e8d416ce57.png";

/***/ }),
/* 2501 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 2502 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 2503 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 2504 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 2505 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 2506 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 2507 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 2508 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/zeroHeroes/images/zeroHeroes-709919bdc35c19934481c5a402c44ecc.png";

/***/ }),
/* 2509 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/zeroHeroes/images/zeroHeroesExpired-b447857a1120f4b2d653a440e3afde4d.png";

/***/ }),
/* 2510 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/zeroHeroes/images/zeroHeroesNoPPAPresents-0c4dea8bec4882f7565c876cd4671996.png";

/***/ }),
/* 2511 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/zeroHeroes/images/zeroHeroesTrial-709919bdc35c19934481c5a402c44ecc.png";

/***/ }),
/* 2512 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/zeroHeroes/sections/20_gameShow/title_gameshow-brainstorm-bfd5bfb1a52e0de65e6dd8decada664e.png";

/***/ }),
/* 2513 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/zeroHeroes/sections/20_gameShow/title_gameshow-4db1c3edea9555aba358c3928e2305e0.png";

/***/ }),
/* 2514 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/_/programs/zeroHeroes/sections/20_gameShow/title_gameshow_players-1f3dab0745c16a508ea646d3d95269a3.png";

/***/ }),
/* 2515 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0NzAuMiIgaGVpZ2h0PSI0NzAuMiIgdmlld0JveD0iMCAwIDQ3MC4yIDQ3MC4yIj48c3R5bGU+LnN0MHtvcGFjaXR5OjAuNTtmaWxsOm5vbmU7c3Ryb2tlOiNGRkZGRkY7c3Ryb2tlLXdpZHRoOjIwLjI1O3N0cm9rZS1saW5lY2FwOnJvdW5kO3N0cm9rZS1taXRlcmxpbWl0OjEwO30gLnN0MXtmaWxsOm5vbmU7c3Ryb2tlOiNGRkZGRkY7c3Ryb2tlLXdpZHRoOjIwLjI1O3N0cm9rZS1saW5lY2FwOnJvdW5kO3N0cm9rZS1taXRlcmxpbWl0OjEwO308L3N0eWxlPjxjaXJjbGUgY2xhc3M9InN0MCIgY3g9IjIzNS4xIiBjeT0iMjM1LjEiIHI9IjIyNSIvPjxwYXRoIGNsYXNzPSJzdDEiIGQ9Ik00MjkuMiAxMjIuNkMzODYuNCA0OC42IDMxMiAxMC4yIDIzNC4zIDEwLjEiLz48L3N2Zz4="

/***/ }),
/* 2516 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0NzAuMiIgaGVpZ2h0PSI0NzAuMiIgdmlld0JveD0iMCAwIDQ3MC4yIDQ3MC4yIj48c3R5bGU+LnN0MHtvcGFjaXR5OjAuNTtmaWxsOm5vbmU7c3Ryb2tlOiNGRkZGRkY7c3Ryb2tlLXdpZHRoOjIwLjI1O3N0cm9rZS1saW5lY2FwOnJvdW5kO3N0cm9rZS1taXRlcmxpbWl0OjEwO30gLnN0MXtmaWxsOm5vbmU7c3Ryb2tlOiNGRkZGRkY7c3Ryb2tlLXdpZHRoOjIwLjI1O3N0cm9rZS1saW5lY2FwOnJvdW5kO3N0cm9rZS1taXRlcmxpbWl0OjEwO308L3N0eWxlPjxjaXJjbGUgY2xhc3M9InN0MCIgY3g9IjIzNS4xIiBjeT0iMjM1LjEiIHI9IjIyNSIvPjxwYXRoIGNsYXNzPSJzdDEiIGQ9Ik00MjkuMiAxMjIuNkMzODYuNCA0OC42IDMxMiAxMC4yIDIzNC4zIDEwLjFNNDI5LjIgMzQ3LjZjNDIuOC03NCAzOC44LTE1Ny43IDAtMjI1Ii8+PC9zdmc+"

/***/ }),
/* 2517 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0NzAuMiIgaGVpZ2h0PSI0NzAuMiIgdmlld0JveD0iMCAwIDQ3MC4yIDQ3MC4yIj48c3R5bGU+LnN0MHtvcGFjaXR5OjAuNTtmaWxsOm5vbmU7c3Ryb2tlOiNGRkZGRkY7c3Ryb2tlLXdpZHRoOjIwLjI1O3N0cm9rZS1saW5lY2FwOnJvdW5kO3N0cm9rZS1taXRlcmxpbWl0OjEwO30gLnN0MXtmaWxsOm5vbmU7c3Ryb2tlOiNGRkZGRkY7c3Ryb2tlLXdpZHRoOjIwLjI1O3N0cm9rZS1saW5lY2FwOnJvdW5kO3N0cm9rZS1taXRlcmxpbWl0OjEwO308L3N0eWxlPjxjaXJjbGUgY2xhc3M9InN0MCIgY3g9IjIzNS4xIiBjeT0iMjM1LjEiIHI9IjIyNSIvPjxwYXRoIGNsYXNzPSJzdDEiIGQ9Ik00MjkuMiAxMjIuNkMzODYuNCA0OC42IDMxMiAxMC4yIDIzNC4zIDEwLjFNNDI5LjIgMzQ3LjZjNDIuOC03NCAzOC44LTE1Ny43IDAtMjI1TTIzNC40IDQ2MC4xYzg1LjUgMCAxNTUuOS00NS4zIDE5NC44LTExMi41Ii8+PC9zdmc+"

/***/ }),
/* 2518 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0NzAuMiIgaGVpZ2h0PSI0NzAuMiIgdmlld0JveD0iMCAwIDQ3MC4yIDQ3MC4yIj48c3R5bGU+LnN0MHtvcGFjaXR5OjAuNTtmaWxsOm5vbmU7c3Ryb2tlOiNGRkZGRkY7c3Ryb2tlLXdpZHRoOjIwLjI1O3N0cm9rZS1saW5lY2FwOnJvdW5kO3N0cm9rZS1taXRlcmxpbWl0OjEwO30gLnN0MXtmaWxsOm5vbmU7c3Ryb2tlOiNGRkZGRkY7c3Ryb2tlLXdpZHRoOjIwLjI1O3N0cm9rZS1saW5lY2FwOnJvdW5kO3N0cm9rZS1taXRlcmxpbWl0OjEwO308L3N0eWxlPjxjaXJjbGUgY2xhc3M9InN0MCIgY3g9IjIzNS4xIiBjeT0iMjM1LjEiIHI9IjIyNSIvPjxwYXRoIGNsYXNzPSJzdDEiIGQ9Ik00MjkuMiAxMjIuNkMzODYuNCA0OC42IDMxMiAxMC4yIDIzNC4zIDEwLjFNNDI5LjIgMzQ3LjZjNDIuOC03NCAzOC44LTE1Ny43IDAtMjI1TTIzNC40IDQ2MC4xYzg1LjUgMCAxNTUuOS00NS4zIDE5NC44LTExMi41TTM5LjUgMzQ3LjZjNDIuOCA3NCAxMTguNCAxMTIuNCAxOTQuOSAxMTIuNSIvPjwvc3ZnPg=="

/***/ }),
/* 2519 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0NzEuNCIgaGVpZ2h0PSI0NzAuMiIgdmlld0JveD0iMCAwIDQ3MS40IDQ3MC4yIj48c3R5bGU+LnN0MHtvcGFjaXR5OjAuNTtmaWxsOm5vbmU7c3Ryb2tlOiNGRkZGRkY7c3Ryb2tlLXdpZHRoOjIwLjI1O3N0cm9rZS1saW5lY2FwOnJvdW5kO3N0cm9rZS1taXRlcmxpbWl0OjEwO30gLnN0MXtmaWxsOm5vbmU7c3Ryb2tlOiNGRkZGRkY7c3Ryb2tlLXdpZHRoOjIwLjI1O3N0cm9rZS1saW5lY2FwOnJvdW5kO3N0cm9rZS1taXRlcmxpbWl0OjEwO308L3N0eWxlPjxjaXJjbGUgY2xhc3M9InN0MCIgY3g9IjIzNi4zIiBjeT0iMjM1LjEiIHI9IjIyNSIvPjxwYXRoIGNsYXNzPSJzdDEiIGQ9Ik00MzAuNCAxMjIuNmMtNDIuOC03NC0xMTcuMi0xMTIuNC0xOTQuOS0xMTIuNU00MzAuNCAzNDcuNmM0Mi44LTc0IDM4LjgtMTU3LjcgMC0yMjVNMjM1LjYgNDYwLjFjODUuNSAwIDE1NS45LTQ1LjMgMTk0LjgtMTEyLjVNNDAuNyAzNDcuNmM0Mi44IDc0IDExOC40IDExMi40IDE5NC45IDExMi41TTQwLjcgMTIyLjZjLTQyLjggNzQtMzguOCAxNTcuNyAwIDIyNSIvPjwvc3ZnPg=="

/***/ }),
/* 2520 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0NzAuMiIgaGVpZ2h0PSI0NzAuMiIgdmlld0JveD0iMCAwIDQ3MC4yIDQ3MC4yIj48c3R5bGU+LnN0MHtmaWxsOm5vbmU7c3Ryb2tlOiNGRkZGRkY7c3Ryb2tlLXdpZHRoOjIwLjI1O3N0cm9rZS1saW5lY2FwOnJvdW5kO3N0cm9rZS1taXRlcmxpbWl0OjEwO308L3N0eWxlPjxjaXJjbGUgY2xhc3M9InN0MCIgY3g9IjIzNS4xIiBjeT0iMjM1LjEiIHI9IjIyNSIvPjwvc3ZnPg=="

/***/ }),
/* 2521 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 2522 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/images/Goober-open-jump-cutout-d3725485efc0742b42a401ee61d069a3.png";

/***/ }),
/* 2523 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/images/Goober_leaps-1a13fb87beab7dcef940d7b4e88ed39b.jpg";

/***/ }),
/* 2524 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 2525 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/images/drawer-logo-full-logo_ppa.fr_CA-a6215054281886b2f56f270fd9a39b08.png";

/***/ }),
/* 2526 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/images/drawer-logo-full-logo_ppa-503e63c20208e65935976e945417e3dd.png";

/***/ }),
/* 2527 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNTAwIiBoZWlnaHQ9IjI1MDAiIHZpZXdCb3g9IjAgMCA1MTIgNTEyIj48cGF0aCBmaWxsPSIjMDA4NGZmIiBkPSJNNTEyIDBIMHY1MTJoNTEyeiIvPjxwYXRoIGQ9Ik0yNTcgOTNjLTg4LjkxOCAwLTE2MSA2Ny4xNTctMTYxIDE1MCAwIDQ3LjIwNSAyMy40MTIgODkuMzExIDYwIDExNi44MDdWNDE3bDU0LjgxOS0zMC4yNzNDMjI1LjQ0OSAzOTAuODAxIDI0MC45NDggMzkzIDI1NyAzOTNjODguOTE4IDAgMTYxLTY3LjE1NyAxNjEtMTUwUzM0NS45MTggOTMgMjU3IDkzem0xNiAyMDJsLTQxLTQ0LTgwIDQ0IDg4LTk0IDQyIDQ0IDc5LTQ0LTg4IDk0eiIgZmlsbD0iI2ZmZiIvPjwvc3ZnPg=="

/***/ }),
/* 2528 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 2529 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 2530 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 2531 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAPAAAADwCAYAAAA+VemSAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAYQElEQVR42u3dfVBTZ74H8OfERCNgVOSlUkjVhrywrgKrLCPQ3tqupeg4pVV0Wtd1Ld2uretKp2MZRbvi6hbUuXUVaKfuWEu9He3y4ljrKDLFtl5hHekCIhBBqxYUAd8CBkhj7h+FvTaNmEPOye8k+X5mvn+t5TznOb/fPuRw8hyOAam33357+6effrpAq9U263S6xsjIyPM6na7RYDAYw8PDv5PL5feoxwjSxVEPwNfNnTv38OHDh1Mc/W9KpbI/MjKyWaPRNBoMhmaNRtOwZMmS/xk5cmQ/9bgBgDGm0+nOM8ZszmTUqFHmH374QUY9ZgBgjPX29o6Uy+VW5mQDT5s2rZ56zCAt+H9zQhcvXpzCZ0V9/PHHG6nHDNKCBiZkNBr1fP69wWBoph4zSAsaeMDp06dnuPuYTU1NGj7/XqvVNrh7jCBtPt/AX3zxRcqsWbOq4uLiTldWVsa689hGo9HA59/rdDqswACMMVZcXJwyffr00+y+m0QpKSkH3TmGJ5988gRz8gYWY8zW2dkZSD1vAKRKS0vnxcbG/qRxB8NxnO2bb75x2yocGhrazpxs3qCgoC7quQMgU1paOj82NvYMe0ijPP/8825ZhW/dujWO4zinV99Zs2adpJ5DALcrKyt7xpnGZfetwjU1NdFij+tf//pXvLNjYozZfv/73++lnkuQHq+/iWU0GidVV1c7/WuxzWZjmzZtescN4+J1BzoyMhJ3oMH33L17V65Wqy8yHqsdx3G22tpaUVfh9evXb+YzpuLi4gXUcwlAIj8/P53xaBbGmG3BggUlYo5p4cKF+/mMp7a2dir1PAKQ6O3tHalWqy8xfquwtba2dppYY4qJialxdiwjRoyw3r17V0k9jwBkCgoK/sB4rsILFy4sEms8fn5+Pc6O4/HHH2+hnj8AUsNdhevq6gRfha9cuaLmM47k5OSj1PMH0uT1d6EHKZXK/szMzL/x+W9sNpssOzt7vdBj4fsMtE6nw7eQAAZW4SuM/yos6A2k/Pz8lXzGsGvXrpXUcwfS5DMrMGPDX4U3bdok6Crc1NQUyeff6/V6rMAAjDFmNptHRkRE8FqFZTKZ9ezZs4KtwikpKUf5HP+7776bRD1vAJKRl5f3OuN5R3rRokX7hTr+wF1lp47r7+/fQz1fAJJiNpuVERERrYz/Khzl6rHv3r2rHDFiBJ99sOqo5wtAcvLy8njdSGI/rsKfunrc+vr6KD7HTEtL+4x6rgAkx2w2K8PDw4ezCvPax8peUVHRC3yOOfDMNIBDPnUX+n6jR4/uzczMzOHz39y7d8/lO9LNzc34FhKAEIa7CtfV1Q17FR74Xq/Tx6uqqoqnnicAydq5c+cqxvOz8IsvvrhvuMdLTEw8yedYN27cGEc9RwCSZTablY8++uhVxqOp5HK55fz589rhHC84OLjL2eOEhoZ2UM8PgOS99957qxnPVXjZsmWFfI9z48aNQD7HSExM/Jp6bgAk786dO34TJkwQfRU+derULD7HSE9P30M9NyBtPnsX+n4qleru22+/vZXPf/PDDz/It2zZso7Pf9PY2MjrDrRGo8EdaPAc5eXlz1y/fj2E4tgmk8kvJCSE9yrM589C69at+xufn19aWvoCxVwA8NbZ2RmoUqluqlQq08aNG7NMJpOfu8eQm5v7JuP5WZjPdq9Xr14NO3LkSPJ77723+o033sj7zW9+U65Wqy/JZDKHP7uhocGlh0YA3CYjI2M7u694J06cePX999//g8VikbtrDAOrsNNvS2DDWIUd6e7u9qupqYn+7LPP0v76179mLV26dN+vf/3rqt7e3pHuOneAYWtubp6kVCr7mIMGMRgMDSUlJc+7ayy5ublvMZ6r8PLly3GzCXzXSy+9tI858SeVgbu4ojKZTAHBwcG8VuGZM2ee6e/vd9tvCgCSUV1dHctxnFNfr+M4zvbiiy8WNTQ0DOshCmfl5OSscWY80dHRNcXFxS9YrVbczQffNGfOnDLG81dWhUJhee211wpaW1sfEWNMA6twx4OOHxMT821JSQkaF3zb0aNH5zCezXt/xowZY3rnnXc2mkymAKHHlpOTk2l/vNjY2G9LS0vd9nkcQLKsVquMz9sJhkpoaOjV/Pz814W8Y20ymQKCgoI62I+Ne6a0tHQ+9ZwBSMbHH3+8hAnQvPdHq9U2FRcXC/bwwyeffLIEjQvgwNSpU+uYwA08mPj4+FNfffVVIvU5Anit69evh6xcuXKnQqFw+PdfITJ//vyDA3tQAYAYmpubNWlpafs5jhOlieVyueXVV1/9sK2tLYz6XAG8VmVlZdwTTzxxgom0Gvv7+/dkZWVtvnXrlor6XAG81sGDB+dFRUXVM5EaOTg4uP3vf//7SrPZjOeMAcRgsVjk//jHP5bz3XCOTyIjI88fOHAgzdWxZmZm5vT19eExSgB7PT09flu2bMkcO3bsbSZSI8fFxVVVVFQ84cIwbQkJCV+3trbiMzaAI52dnUF//vOfd4h1x/rVV1/9wIXh2RhjtpCQkPaysrJnqOcKQLJaWlqmLF68+FNnv/zgTPz8/ExtbW2uPFP9n58lk8msGzZs2Njf349npAEepKqqasbTTz9dzgRo4KysrE0uDudnP3P27Nnl165dI9kaCMBjHDlyJDk6OnrYz1MHBwe337lzx9U/Kzn82WFhYVdd/GwN4P0sFovso48+Wsr3pd2MMdvAGwpdNeRDJNnZ2Zn42iHAQ5jNZuW77767RqVS3WRO/hlJoD//PPRYc+fOPdLZ2RlEPUcAktfV1RWYkZGx/UF7bA1m//79Lv8NeIBTq31ERMSlkydPir4lEIBXuHjx4qTf/va3hY7uWM+cObNKwEM5/Su7QqGwbN269U3quQHwGNXV1dH22/YIfHOJ982z1NTUErx1EICHo0ePzomJifl23rx5hwT+0cO6Az5lypSLVVVVM6jnBcBjWK1WWUdHh9Ar37D/Bq1QKPry8/OFuBMOAMPk8sMkixYt2n/79m18zRGAgFDfjmo6c+bMNOqTAfA1gn2pws/Pz7x79+506hMC8CWCfztq6dKlhRRvZwTwRYI3MGPMptfr6xsaGrAhH4DIRGlgxn7cx6uwsHAJ9QkCeDPRGngw6enpH3Z3dyupTxTAG4newIwx2/Tp02uMRqNLLxIHgJ9zSwMzxmwqleq2EBvxAcD/c1sDD2bFihU7+/r6sC0ugADc3sCMMVtcXNzpCxcuTKI+eQBPR9LAjDHb+PHjb5aUlODtiQAuIGtgxpiN4zhbRkbGdmwuDzA8pA08mISEhJNXrlwJp54MAE9D3ryDCQoK6jh06FAy9YQAeBLyxr0/HMdZs7KyNlssFvxKDeAE8qZ1lKeeeupLF984AeATyJv1QQkNDb167Nix2dQTBCBl5I06VORyuTU7OzsLm8sDOEbepM5kzpw5R69du4bN5QHskDenswkLC7vyzTffJFJPGICUkDcmn8jlcktubu4a/EoN8CPyphxO5s2bd6ijoyOQevIAqJE343CjVqsvVVVVxVFPIAAl8kZ0JQqFom/Hjh2rqCcRgAp5EwqR1NTUolu3bmFzefA55M0nVDQaTUt1dXU09YQCuBN54wkZpVJpLigo+CP1pAK4C3nTiZHFixfvM5lMAdSTCyA28mYTK3q9vqGurm4q9QQDiIm80cSMv79/z+7du5dRTzKAWMibzB155ZVX9vT09OB9TeB1yJvLXfnlL39Z19DQoKeecAAhkTeWOxMQEGD65JNPFlNPOoBQyJuKIitWrCgwm814XxN4PPJmosqvfvWrM0ajcQr1BQBwBXkjUUalUt0sLi5+gfoiAAwXeRNJIatXr/5vvK8JPBF580glcXFxVS0tLWrqCwLAB3njSCkTJkzo+vzzz+dRXxQAZ5E3jdTCcZw1MzMzB+9rAk9A3jBSTUJCwtetra1h1BcIYCjkjSLlhISEtJeVlT1DfZEAHoS8SaQemUxm3bBhw8b+/n7shAmSQ94gnpLZs2eXX7t2LYT6ggHcj7wxPClhYWFXKyoq/ov6ogEMIm8KT4tcLrdkZ2evxebyIAXkDeGpmTt37pHOzk68rwlIkTeCJyciIuLKyZMnZ1FfRPBd5E3g6VEoFJatW7e+SX0hwTeRN4C3JDU19eCNGzfGUV9Q8C3khe9NmTJlysWqqqoZ1BcVfAd50XtbFApFX35+/krqCwu+gbzgvTWLFi3af/v2bbyvCURFXujenMjIyKYzZ85Mo77I4L3Ii9zb4+fnZ969e3c69YUG70Re4L6SpUuXFppMJmwuD4IiL2xfil6vr29oaIiivujgPciL2tfi7+/fU1hYuIT6woN3IC9oX016evqH3d3d2FweXEJeyL6c6dOn1xiNRi11EYDnIi9iX49Kpbp94MCBNOpCAM9EXsDIj1mxYsVObC4PfJEXLvL/iYuLO33hwoVJ1EUBnoO8aJGfZvz48TdLSkrmUxcGeAbygkV+Ho7jbBkZGduxuTw8DHmxIg9OQkLCyStXroRTFwlIF3mRIkMnKCio49ChQ8nUhQLSRF6gyMPDcZx17dq1my0WC36lhp8gL07E+Tz11FNftrW1PUJdNCAd5EWJ8EtoaGj7sWPHZlMXDkgDeUEi/COXy63Z2dkbsLk8kBcjMvzMmTPn6LVr17C5vA8jL0LEtUycOLH1xIkTidSFBDTICxBxPXK53JKbm7sGv1L7HvLiQ4TLvHnzDnV0dARSFxW4D3nRIcJGrVZfqqqqiqMuLHAP8oJDhI9CoejbsWPHKuriAvGRFxsiXlJTU4vwvibvRl5kiLjRaDQt1dXVsdSFBuIgLzBE/CiVSnNBQcEfqYsNhEdeXIj7snjx4n0mkymAuuhAOORFhbg3er2+oa6ubip14YEwyAsKcX/8/f17du/evYy6+MB15MWE0GXZsmV7enp6yN7XNILqwF7kL9QDABp+fn69FotlZHd395jy8vKvKcbAUU+CF7BRDwDEFRoa2qnT6c7p9frGX/ziF01arfacwWAwPvroo98pFIp7lGNDA7sODewF5HL5PY1G06zT6Rr1er1Rq9XWR0VFGXU63bnAwMBb1ON7EDSw69DAHmTcuHF3tFpto06nM0ZFRdXrdDqjwWBonDx5crNSqeynHh9faGDXoYElRiaTsfDw8MsGg8Go1WobDQZDk16vPxcZGWmMiIj4nnp8QkIDuw4NTGTUqFG9Op3ugl6vP6fT6Yw6na5er9cb9Xp9Y0BAQDf1+NwBDew6NLDIgoODbxgMhnNarfY/v/bq9frGxx577IJcLie9iUQNDew6NLAA5HL5vcmTJ1+IjIw0Tp06tVGr1TbodLpGg8HQGBQU1Ek9PqlCA7sODcyDSqXqjoyMNEZFRTXqdLqGgc+p5yIjI5uVSmUv9fg8DRrYdWjgIfzud7/7eObMmWcGP6dGRERcph4TwP3IH+eTct59991M6gsEMBTyJpFygoODO/D1O/HgWWjX/YV6AFJ29+5dv/Hjx98sKyv7X+qxADhCvspJPcHBwVe7u7vJvrHjzbCJNYiuo6PjkT179qRTjwPAEfIVzhMSHh7eajabldQXC8AeeXN4SvLz81+nvlgA9sgbw1OiVqsv9fb2jqS+YAD3I28MT0peXh4+C4OkkDeFJ0Wj0Vy0WCxy6osGMIi8KTwte/fuXUZ90QAGkTeEp0Wr1Z7HKgxSQd4QnpjCwsKXqC8cAGMSaAZPjE6na7BYLHiQCMiRN8ODIpfLrWvWrMnhOM5KPRZHOXDgQBr1xQMgbwRH8fPzM5eUlMxnjLEFCxaUUI/HUaZPn15ntVqxCgMp8kawz4QJE7q++uqrWYMDrKysjOU4jnxcjlJSUvIC9QUE30beBPfnscceu1RfX6+3H2RKSsph6rE5Smxs7LfUFxB8G3kTDGbatGl1ly9fDnM0yMrKynjq8T0opaWl86gvIvgu8gZgjNmefPLJE11dXeOGGmhycnIZ9TgdZcaMGVXUFxF8F3kDLFiw4LO+vr6HflWvoqIikXqsD8qxY8eSqS8k+CbSwn/jjTd28rmTm5SU9CX1mB0lMTHxJPWFBN9EUvAcx9k2b97Me8fH48ePz6Ya88Ny/PjxZ6gvJvgetxe6QqGwfPTRR0uHO+CEhISTFON+WJKSkk5QX0zwPW4tcn9/f9MXX3zh0ufFgc+b5A3rKOXl5U9QX1DwLW4r7uDg4PbKyso4IQYdExNz2p1jdzbPPvtsGfUFBd/ilsKePHlyS1NTk1aoQZeWls5319j55tSpU7MYgJuIXtDR0dFn2tvbHxF64DExMTXuGD/fPPfcc0eIriX4IFGL+emnny67c+eOSoyBFxUVLRB7/MNNVVXVDIJrCT5ItCJ++eWX9/X19Ym2i6PVapVFRUXVi3kOw01ycvJBt19J8EmiFPBbb7213R1ftRvYGYO8Ye3DcZyttrY22n2XEXyV0IVr3bZt25vuGrzFYpFptdomoc9DiCxcuLDIXfMAvkuwgh05cmTfvn37Frv7BAZ2iSRvWPtwHGetq6ub6u75AN8iSLEGBATcLi8vJ3mU0GKxyDUaTYtQ5yJkFi1atJ9iTsB3uFykoaGhV//973+Tft4beGMCecPaRyaTWc+ePatnACJxqUA1Gk3ThQsXplCfRG9v70i1Wn3J1fMRIy+//HIh9fyA9xp2YcbHx1ddv349iPoEBuXl5b3uyvmIFblcbmlubtZQzw94p2EVZUpKymGTySSpt9abzWZleHh463DPScwsX758D/X8gHfiXYzLli3b09/fL8lXi2zbtm31cM5J7CgUCktLS8sk6vkB78OrENetW7eZesBDMZlMfiEhIe18z8sdSU9P/4B6fsD7OFV8HMdZd+3a5RFvqM/JyVnj7Hm5MwqFou/y5ctq6vkB7/LQwhs1apT5n//8p8dsYG4ymQKCgoK6nDk3d+dPf/pTHvX8gHcZsuACAwNvVlRUeNwuE1u2bMl62LlRRKlUmltbW8MYgEAeWGxqtfpKTU2NRz4K2NnZqRo7duxNJoGmtc/q1at3UM8PeA+HRTZ16tT6ixcvhlMPzhXr16/fxCTQsPYZPXp0T1tbm+AbHIBv+lmBJSUlnbx+/fo4134sva6urkCVSmViEmha+2RkZGylnh/wDj8prNTU1JKenp6HviXBU6xduzaHSaBh7TNmzBhTZ2enZJ5iA8/1n6J67bXXPujv7/eq9922tbWFjB49uodJoGnts27dur9Rzw94PhtjzLZp06Ys6oGIZfXq1duZBBrWPiqV6nZXV1cg9fyAB5PL5ZYPP/wwnXocYmprawtTKpVmJoGmtc/69es3Us8PeLCDBw/6xLttV61alcck0LD2GTt27M2Ojg5Rdu0E8Brff/99uEKh6GMSaFr7DDx0AgBDeeWVVz5gEmhY+wQFBXWZTKYA6vkBkLSWlpZJCoXCwiTQtPbJycnh/apVAJ8z8MV68oa1T3BwcLvUNkgAkJzm5matXC6X5Cqcm5vrtv20ATzW4sWL9zEJNKx9QkJCrprNZq95Cg5AFGfPno2SyWRWJoGmtc+uXbtWUc8PgOSlpaV9xiTQsPaJiIhoxSoM8BC1tbXTOI4jb1hHyc/P/yP1/ABIXmpq6kEmgYa1j1qtvmQ2m0V7LSuAV6isrJwh1VX4/fff9+rn0wEE8dxzzx1mEmhY+2g0mhaLxSLJvbcBJOPUqVPxTAIN6ygDr00FgKE8++yzZUwCDWsfrVbbhFUY4CHKysqeYBJoWEcpLCx8iXp+ACQvKSnpBJNAw9pHq9XWe9s2RwCCKysre4ZJoGEdpaioKI16fgAkLyEh4RSTQMPaJz4+/hT13ABI3ueff57CJNCwg1GpVKa1a9fmtLe3h1DPDYBHiI2NPcOIG3fs2LE3169fvwk7VgLwVFJS8jwjatygoKCuLVu2ZGGTO4Bhslqtsujo6BrmxsYNCQlpz8nJWYN9sQAEMHDXV/TGDQ8Pb922bdtqbKUDIKD+/n6ZTqerZyI1rlqtvpSXl/c6vvcLIJLCwsIlTODG1Wg0LQUFBem9vb34qiCAmCwWi1yr1Z5nAjSuVqtt2rt37zI81wzgRnv37l3OXGjcqKio+sLCwpcsFgsehQRwN4vFIo+IiLjIeDZuTEzMt8XFxQusVisaF4BSQUHBH5jzjXu6tLR0PvWYAWBAb2/vyIiIiCtsiMZNTEw8eezYsWTqsQKAA7t27VrJHDRuUlLSl8ePH59NPT4AGILZbFZOnDjxKhto3OTk5LKKiopE6nEBgJNyc3PfTElJOVxZWRlPPRZv8n+0NfLieLzrWAAAAABJRU5ErkJggg=="

/***/ }),
/* 2532 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 2533 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 2534 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/images/startLevel-067b1d7070320fa55a55bc2f2caa8c2a.png";

/***/ }),
/* 2535 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiA/PjxzdmcgaWQ9IkxheWVyXzEiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDUxMiA1MTI7IiB2ZXJzaW9uPSIxLjEiIHZpZXdCb3g9IjAgMCA1MTIgNTEyIiB4bWw6c3BhY2U9InByZXNlcnZlIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIj48c3R5bGUgdHlwZT0idGV4dC9jc3MiPgoJLnN0MHtmaWxsOiNmZmY7fQo8L3N0eWxlPjxwYXRoIGNsYXNzPSJzdDAiIGQ9Ik01MDMuOCwxMDYuMWMtMTguNCw4LjItMzguMiwxMy43LTU4LjksMTYuMmMyMS4yLTEyLjcsMzcuNC0zMi44LDQ1LjEtNTYuOGMtMTkuOCwxMS44LTQxLjgsMjAuMy02NS4xLDI0LjkgIEM0MDYuMSw3MC41LDM3OS40LDU4LDM0OS45LDU4Yy01Ni43LDAtMTAyLjYsNDUuOS0xMDIuNiwxMDIuNmMwLDgsMC45LDE1LjksMi43LDIzLjRjLTg1LjMtNC4zLTE2MC44LTQ1LjEtMjExLjQtMTA3LjIgIGMtOC44LDE1LjEtMTMuOSwzMi44LTEzLjksNTEuNmMwLDM1LjYsMTguMSw2Nyw0NS42LDg1LjRjLTE2LjgtMC41LTMyLjYtNS4xLTQ2LjUtMTIuOGMwLDAuNCwwLDAuOSwwLDEuMyAgYzAsNDkuNywzNS40LDkxLjIsODIuMywxMDAuNmMtOC42LDIuMy0xNy43LDMuNi0yNywzLjZjLTYuNiwwLTEzLTAuNi0xOS4zLTEuOGMxMy4xLDQwLjgsNTAuOSw3MC40LDk1LjgsNzEuMiAgYy0zNS4xLDI3LjUtNzkuMyw0My45LTEyNy40LDQzLjljLTguMywwLTE2LjQtMC41LTI0LjUtMS40YzQ1LjQsMjkuMSw5OS4zLDQ2LjEsMTU3LjIsNDYuMWMxODguNywwLDI5MS45LTE1Ni4zLDI5MS45LTI5MS45ICBjMC00LjQtMC4xLTguOS0wLjMtMTMuM0M0NzIuNiwxNDQuOCw0OTAsMTI2LjcsNTAzLjgsMTA2LjF6Ii8+PC9zdmc+"

/***/ }),
/* 2536 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/views/landingPage/tall-logo_ppa-6726d827f386dd2e1b4e87b822ea983b.svg";

/***/ }),
/* 2537 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/views/session/presentation/components/bkg_hack-9c8536f29dda8314fde8529a51d7f76c.jpg";

/***/ }),
/* 2538 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 2539 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 2540 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 2541 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 2542 */,
/* 2543 */,
/* 2544 */,
/* 2545 */,
/* 2546 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author Titus Wormer
	 * @copyright 2015 Titus Wormer
	 * @license MIT
	 * @module vfile
	 * @fileoverview Virtual file format to attach additional
	 *   information related to processed input.  Similar to
	 *   `wearefractal/vinyl`.  Additionally, `VFile` can be
	 *   passed directly to ESLint formatters to visualise
	 *   warnings and errors relating to a file.
	 * @example
	 *   var VFile = require('vfile');
	 *
	 *   var file = new VFile({
	 *     'directory': '~',
	 *     'filename': 'example',
	 *     'extension': 'txt',
	 *     'contents': 'Foo *bar* baz'
	 *   });
	 *
	 *   file.toString(); // 'Foo *bar* baz'
	 *   file.filePath(); // '~/example.txt'
	 *
	 *   file.move({'extension': 'md'});
	 *   file.filePath(); // '~/example.md'
	 *
	 *   file.warn('Something went wrong', {'line': 2, 'column': 3});
	 *   // { [~/example.md:2:3: Something went wrong]
	 *   //   name: '~/example.md:2:3',
	 *   //   file: '~/example.md',
	 *   //   reason: 'Something went wrong',
	 *   //   line: 2,
	 *   //   column: 3,
	 *   //   fatal: false }
	 */
	
	'use strict';
	
	/* eslint-env commonjs */
	
	var proto;
	
	var SEPARATOR = '/';
	
	try {
	    SEPARATOR = __webpack_require__(1495).sep;
	} catch (e) { /* empty */ }
	
	/**
	 * Construct a new file message.
	 *
	 * Note: We cannot invoke `Error` on the created context,
	 * as that adds readonly `line` and `column` attributes on
	 * Safari 9, thus throwing and failing the data.
	 *
	 * @example
	 *   var message = new VFileMessage('Whoops!');
	 *
	 *   message instanceof Error // true
	 *
	 * @constructor
	 * @class {VFileMessage}
	 * @param {string} reason - Reason for messaging.
	 * @property {boolean} [fatal=null] - Whether the message
	 *   is fatal.
	 * @property {string} [name=''] - File-name and positional
	 *   information.
	 * @property {string} [file=''] - File-path.
	 * @property {string} [reason=''] - Reason for messaging.
	 * @property {number} [line=null] - Start of message.
	 * @property {number} [column=null] - Start of message.
	 * @property {Position|Location} [location=null] - Place of
	 *   message.
	 * @property {string} [stack] - Stack-trace of warning.
	 */
	function VFileMessage(reason) {
	    this.message = reason;
	}
	
	/**
	 * Inherit from `Error#`.
	 */
	function VFileMessagePrototype() {}
	
	VFileMessagePrototype.prototype = Error.prototype;
	
	proto = new VFileMessagePrototype();
	
	VFileMessage.prototype = proto;
	
	/*
	 * Expose defaults.
	 */
	
	proto.file = proto.name = proto.reason = proto.message = proto.stack = '';
	proto.fatal = proto.column = proto.line = null;
	
	/**
	 * File-related message with location information.
	 *
	 * @typedef {Error} VFileMessage
	 * @property {string} name - (Starting) location of the
	 *   message, preceded by its file-path when available,
	 *   and joined by `:`. Used internally by the native
	 *   `Error#toString()`.
	 * @property {string} file - File-path.
	 * @property {string} reason - Reason for message.
	 * @property {number?} line - Line of message, when
	 *   available.
	 * @property {number?} column - Column of message, when
	 *   available.
	 * @property {string?} stack - Stack of message, when
	 *   available.
	 * @property {boolean?} fatal - Whether the associated file
	 *   is still processable.
	 */
	
	/**
	 * Stringify a position.
	 *
	 * @example
	 *   stringify({'line': 1, 'column': 3}) // '1:3'
	 *   stringify({'line': 1}) // '1:1'
	 *   stringify({'column': 3}) // '1:3'
	 *   stringify() // '1:1'
	 *
	 * @private
	 * @param {Object?} [position] - Single position, like
	 *   those available at `node.position.start`.
	 * @return {string} - Compiled location.
	 */
	function stringify(position) {
	    if (!position) {
	        position = {};
	    }
	
	    return (position.line || 1) + ':' + (position.column || 1);
	}
	
	/**
	 * ESLint's formatter API expects `filePath` to be a
	 * string.  This hack supports invocation as well as
	 * implicit coercion.
	 *
	 * @example
	 *   var file = new VFile({
	 *     'filename': 'example',
	 *     'extension': 'txt'
	 *   });
	 *
	 *   filePath = filePathFactory(file);
	 *
	 *   String(filePath); // 'example.txt'
	 *   filePath(); // 'example.txt'
	 *
	 * @private
	 * @param {VFile} file - Virtual file.
	 * @return {Function} - `filePath` getter.
	 */
	function filePathFactory(file) {
	    /**
	     * Get the filename, with extension and directory, if applicable.
	     *
	     * @example
	     *   var file = new VFile({
	     *     'directory': '~',
	     *     'filename': 'example',
	     *     'extension': 'txt'
	     *   });
	     *
	     *   String(file.filePath); // ~/example.txt
	     *   file.filePath() // ~/example.txt
	     *
	     * @memberof {VFile}
	     * @property {Function} toString - Itself. ESLint's
	     *   formatter API expects `filePath` to be `string`.
	     *   This hack supports invocation as well as implicit
	     *   coercion.
	     * @return {string} - If the `vFile` has a `filename`,
	     *   it will be prefixed with the directory (slashed),
	     *   if applicable, and suffixed with the (dotted)
	     *   extension (if applicable).  Otherwise, an empty
	     *   string is returned.
	     */
	    function filePath() {
	        var directory = file.directory;
	        var separator;
	
	        if (file.filename || file.extension) {
	            separator = directory.charAt(directory.length - 1);
	
	            if (separator === '/' || separator === '\\') {
	                directory = directory.slice(0, -1);
	            }
	
	            if (directory === '.') {
	                directory = '';
	            }
	
	            return (directory ? directory + SEPARATOR : '') +
	                file.filename +
	                (file.extension ? '.' + file.extension : '');
	        }
	
	        return '';
	    }
	
	    filePath.toString = filePath;
	
	    return filePath;
	}
	
	/**
	* Get the filename with extantion.
	*
	* @example
	*   var file = new VFile({
	*     'directory': '~/foo/bar'
	*     'filename': 'example',
	*     'extension': 'txt'
	*   });
	*
	*   file.basename() // example.txt
	*
	* @memberof {VFile}
	* @return {string} - name of file with extantion.
	*/
	function basename() {
	    var self = this;
	    var extension = self.extension;
	
	    if (self.filename || extension) {
	        return self.filename + (extension ? '.' + extension : '');
	    }
	
	    return '';
	}
	
	/**
	 * Construct a new file.
	 *
	 * @example
	 *   var file = new VFile({
	 *     'directory': '~',
	 *     'filename': 'example',
	 *     'extension': 'txt',
	 *     'contents': 'Foo *bar* baz'
	 *   });
	 *
	 *   file === VFile(file) // true
	 *   file === new VFile(file) // true
	 *   VFile('foo') instanceof VFile // true
	 *
	 * @constructor
	 * @class {VFile}
	 * @param {Object|VFile|string} [options] - either an
	 *   options object, or the value of `contents` (both
	 *   optional).  When a `file` is passed in, it's
	 *   immediately returned.
	 * @property {string} [contents=''] - Content of file.
	 * @property {string} [directory=''] - Path to parent
	 *   directory.
	 * @property {string} [filename=''] - Filename.
	 *   A file-path can still be generated when no filename
	 *   exists.
	 * @property {string} [extension=''] - Extension.
	 *   A file-path can still be generated when no extension
	 *   exists.
	 * @property {boolean?} quiet - Whether an error created by
	 *   `VFile#fail()` is returned (when truthy) or thrown
	 *   (when falsey). Ensure all `messages` associated with
	 *   a file are handled properly when setting this to
	 *   `true`.
	 * @property {Array.<VFileMessage>} messages - List of associated
	 *   messages.
	 */
	function VFile(options) {
	    var self = this;
	
	    /*
	     * No `new` operator.
	     */
	
	    if (!(self instanceof VFile)) {
	        return new VFile(options);
	    }
	
	    /*
	     * Given file.
	     */
	
	    if (
	        options &&
	        typeof options.message === 'function' &&
	        typeof options.hasFailed === 'function'
	    ) {
	        return options;
	    }
	
	    if (!options) {
	        options = {};
	    } else if (typeof options === 'string') {
	        options = {
	            'contents': options
	        };
	    }
	
	    self.contents = options.contents || '';
	
	    self.messages = [];
	
	    /*
	     * Make sure eslint’s formatters stringify `filePath`
	     * properly.
	     */
	
	    self.filePath = filePathFactory(self);
	
	    self.history = [];
	
	    self.move({
	        'filename': options.filename,
	        'directory': options.directory,
	        'extension': options.extension
	    });
	}
	
	/**
	 * Get the value of the file.
	 *
	 * @example
	 *   var vFile = new VFile('Foo');
	 *   String(vFile); // 'Foo'
	 *
	 * @this {VFile}
	 * @memberof {VFile}
	 * @return {string} - value at the `contents` property
	 *   in context.
	 */
	function toString() {
	    return this.contents;
	}
	
	/**
	 * Move a file by passing a new directory, filename,
	 * and extension.  When these are not given, the default
	 * values are kept.
	 *
	 * @example
	 *   var file = new VFile({
	 *     'directory': '~',
	 *     'filename': 'example',
	 *     'extension': 'txt',
	 *     'contents': 'Foo *bar* baz'
	 *   });
	 *
	 *   file.move({'directory': '/var/www'});
	 *   file.filePath(); // '/var/www/example.txt'
	 *
	 *   file.move({'extension': 'md'});
	 *   file.filePath(); // '/var/www/example.md'
	 *
	 * @this {VFile}
	 * @memberof {VFile}
	 * @param {Object?} [options] - Configuration.
	 * @return {VFile} - Context object.
	 */
	function move(options) {
	    var self = this;
	    var before = self.filePath();
	    var after;
	
	    if (!options) {
	        options = {};
	    }
	
	    self.directory = options.directory || self.directory || '';
	    self.filename = options.filename || self.filename || '';
	    self.extension = options.extension || self.extension || '';
	
	    after = self.filePath();
	
	    if (after && before !== after) {
	        self.history.push(after);
	    }
	
	    return self;
	}
	
	/**
	 * Create a message with `reason` at `position`.
	 * When an error is passed in as `reason`, copies the
	 * stack.  This does not add a message to `messages`.
	 *
	 * @example
	 *   var file = new VFile();
	 *
	 *   file.message('Something went wrong');
	 *   // { [1:1: Something went wrong]
	 *   //   name: '1:1',
	 *   //   file: '',
	 *   //   reason: 'Something went wrong',
	 *   //   line: null,
	 *   //   column: null }
	 *
	 * @this {VFile}
	 * @memberof {VFile}
	 * @param {string|Error} reason - Reason for message.
	 * @param {Node|Location|Position} [position] - Location
	 *   of message in file.
	 * @param {string} [ruleId] - Category of warning.
	 * @return {VFileMessage} - File-related message with
	 *   location information.
	 */
	function message(reason, position, ruleId) {
	    var filePath = this.filePath();
	    var range;
	    var err;
	    var location = {
	        'start': {
	            'line': null,
	            'column': null
	        },
	        'end': {
	            'line': null,
	            'column': null
	        }
	    };
	
	    /*
	     * Node / location / position.
	     */
	
	    if (position && position.position) {
	        position = position.position;
	    }
	
	    if (position && position.start) {
	        range = stringify(position.start) + '-' + stringify(position.end);
	        location = position;
	        position = position.start;
	    } else {
	        range = stringify(position);
	
	        if (position) {
	            location.start = position;
	            location.end.line = null;
	            location.end.column = null;
	        }
	    }
	
	    err = new VFileMessage(reason.message || reason);
	
	    err.name = (filePath ? filePath + ':' : '') + range;
	    err.file = filePath;
	    err.reason = reason.message || reason;
	    err.line = position ? position.line : null;
	    err.column = position ? position.column : null;
	    err.location = location;
	    err.ruleId = ruleId || null;
	
	    if (reason.stack) {
	        err.stack = reason.stack;
	    }
	
	    return err;
	}
	
	/**
	 * Warn. Creates a non-fatal message (see `VFile#message()`),
	 * and adds it to the file's `messages` list.
	 *
	 * @example
	 *   var file = new VFile();
	 *
	 *   file.warn('Something went wrong');
	 *   // { [1:1: Something went wrong]
	 *   //   name: '1:1',
	 *   //   file: '',
	 *   //   reason: 'Something went wrong',
	 *   //   line: null,
	 *   //   column: null,
	 *   //   fatal: false }
	 *
	 * @see VFile#message
	 * @this {VFile}
	 * @memberof {VFile}
	 */
	function warn() {
	    var err = this.message.apply(this, arguments);
	
	    err.fatal = false;
	
	    this.messages.push(err);
	
	    return err;
	}
	
	/**
	 * Fail. Creates a fatal message (see `VFile#message()`),
	 * sets `fatal: true`, adds it to the file's
	 * `messages` list.
	 *
	 * If `quiet` is not `true`, throws the error.
	 *
	 * @example
	 *   var file = new VFile();
	 *
	 *   file.fail('Something went wrong');
	 *   // 1:1: Something went wrong
	 *   //     at VFile.exception (vfile/index.js:296:11)
	 *   //     at VFile.fail (vfile/index.js:360:20)
	 *   //     at repl:1:6
	 *
	 *   file.quiet = true;
	 *   file.fail('Something went wrong');
	 *   // { [1:1: Something went wrong]
	 *   //   name: '1:1',
	 *   //   file: '',
	 *   //   reason: 'Something went wrong',
	 *   //   line: null,
	 *   //   column: null,
	 *   //   fatal: true }
	 *
	 * @this {VFile}
	 * @memberof {VFile}
	 * @throws {VFileMessage} - When not `quiet: true`.
	 * @param {string|Error} reason - Reason for failure.
	 * @param {Node|Location|Position} [position] - Place
	 *   of failure in file.
	 * @return {VFileMessage} - Unless thrown, of course.
	 */
	function fail(reason, position) {
	    var err = this.message(reason, position);
	
	    err.fatal = true;
	
	    this.messages.push(err);
	
	    if (!this.quiet) {
	        throw err;
	    }
	
	    return err;
	}
	
	/**
	 * Check if a fatal message occurred making the file no
	 * longer processable.
	 *
	 * @example
	 *   var file = new VFile();
	 *   file.quiet = true;
	 *
	 *   file.hasFailed(); // false
	 *
	 *   file.fail('Something went wrong');
	 *   file.hasFailed(); // true
	 *
	 * @this {VFile}
	 * @memberof {VFile}
	 * @return {boolean} - `true` if at least one of file's
	 *   `messages` has a `fatal` property set to `true`
	 */
	function hasFailed() {
	    var messages = this.messages;
	    var index = -1;
	    var length = messages.length;
	
	    while (++index < length) {
	        if (messages[index].fatal) {
	            return true;
	        }
	    }
	
	    return false;
	}
	
	/**
	 * Access metadata.
	 *
	 * @example
	 *   var file = new VFile('Foo');
	 *
	 *   file.namespace('foo').bar = 'baz';
	 *
	 *   console.log(file.namespace('foo').bar) // 'baz';
	 *
	 * @this {VFile}
	 * @memberof {VFile}
	 * @param {string} key - Namespace key.
	 * @return {Object} - Private space.
	 */
	function namespace(key) {
	    var self = this;
	    var space = self.data;
	
	    if (!space) {
	        space = self.data = {};
	    }
	
	    if (!space[key]) {
	        space[key] = {};
	    }
	
	    return space[key];
	}
	
	/*
	 * Methods.
	 */
	
	proto = VFile.prototype;
	
	proto.basename = basename;
	proto.move = move;
	proto.toString = toString;
	proto.message = message;
	proto.warn = warn;
	proto.fail = fail;
	proto.hasFailed = hasFailed;
	proto.namespace = namespace;
	
	/*
	 * Expose.
	 */
	
	module.exports = VFile;


/***/ }),
/* 2547 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Module Dependencies
	 */
	
	var slice = [].slice;
	var wrap = __webpack_require__(2548);
	
	/**
	 * Expose `Ware`.
	 */
	
	module.exports = Ware;
	
	/**
	 * Throw an error.
	 *
	 * @param {Error} error
	 */
	
	function fail (err) {
	  throw err;
	}
	
	/**
	 * Initialize a new `Ware` manager, with optional `fns`.
	 *
	 * @param {Function or Array or Ware} fn (optional)
	 */
	
	function Ware (fn) {
	  if (!(this instanceof Ware)) return new Ware(fn);
	  this.fns = [];
	  if (fn) this.use(fn);
	}
	
	/**
	 * Use a middleware `fn`.
	 *
	 * @param {Function or Array or Ware} fn
	 * @return {Ware}
	 */
	
	Ware.prototype.use = function (fn) {
	  if (fn instanceof Ware) {
	    return this.use(fn.fns);
	  }
	
	  if (fn instanceof Array) {
	    for (var i = 0, f; f = fn[i++];) this.use(f);
	    return this;
	  }
	
	  this.fns.push(fn);
	  return this;
	};
	
	/**
	 * Run through the middleware with the given `args` and optional `callback`.
	 *
	 * @param {Mixed} args...
	 * @param {Function} callback (optional)
	 * @return {Ware}
	 */
	
	Ware.prototype.run = function () {
	  var fns = this.fns;
	  var ctx = this;
	  var i = 0;
	  var last = arguments[arguments.length - 1];
	  var done = 'function' == typeof last && last;
	  var args = done
	    ? slice.call(arguments, 0, arguments.length - 1)
	    : slice.call(arguments);
	
	  // next step
	  function next (err) {
	    if (err) return (done || fail)(err);
	    var fn = fns[i++];
	    var arr = slice.call(args);
	
	    if (!fn) {
	      return done && done.apply(null, [null].concat(args));
	    }
	
	    wrap(fn, next).apply(ctx, arr);
	  }
	
	  next();
	
	  return this;
	};


/***/ }),
/* 2548 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Module Dependencies
	 */
	
	var noop = function(){};
	var co = __webpack_require__(1214);
	
	/**
	 * Export `wrap-fn`
	 */
	
	module.exports = wrap;
	
	/**
	 * Wrap a function to support
	 * sync, async, and gen functions.
	 *
	 * @param {Function} fn
	 * @param {Function} done
	 * @return {Function}
	 * @api public
	 */
	
	function wrap(fn, done) {
	  done = once(done || noop);
	
	  return function() {
	    // prevents arguments leakage
	    // see https://github.com/petkaantonov/bluebird/wiki/Optimization-killers#3-managing-arguments
	    var i = arguments.length;
	    var args = new Array(i);
	    while (i--) args[i] = arguments[i];
	
	    var ctx = this;
	
	    // done
	    if (!fn) {
	      return done.apply(ctx, [null].concat(args));
	    }
	
	    // async
	    if (fn.length > args.length) {
	      // NOTE: this only handles uncaught synchronous errors
	      try {
	        return fn.apply(ctx, args.concat(done));
	      } catch (e) {
	        return done(e);
	      }
	    }
	
	    // generator
	    if (generator(fn)) {
	      return co(fn).apply(ctx, args.concat(done));
	    }
	
	    // sync
	    return sync(fn, done).apply(ctx, args);
	  }
	}
	
	/**
	 * Wrap a synchronous function execution.
	 *
	 * @param {Function} fn
	 * @param {Function} done
	 * @return {Function}
	 * @api private
	 */
	
	function sync(fn, done) {
	  return function () {
	    var ret;
	
	    try {
	      ret = fn.apply(this, arguments);
	    } catch (err) {
	      return done(err);
	    }
	
	    if (promise(ret)) {
	      ret.then(function (value) { done(null, value); }, done);
	    } else {
	      ret instanceof Error ? done(ret) : done(null, ret);
	    }
	  }
	}
	
	/**
	 * Is `value` a generator?
	 *
	 * @param {Mixed} value
	 * @return {Boolean}
	 * @api private
	 */
	
	function generator(value) {
	  return value
	    && value.constructor
	    && 'GeneratorFunction' == value.constructor.name;
	}
	
	
	/**
	 * Is `value` a promise?
	 *
	 * @param {Mixed} value
	 * @return {Boolean}
	 * @api private
	 */
	
	function promise(value) {
	  return value && 'function' == typeof value.then;
	}
	
	/**
	 * Once
	 */
	
	function once(fn) {
	  return function() {
	    var ret = fn.apply(this, arguments);
	    fn = noop;
	    return ret;
	  };
	}


/***/ }),
/* 2549 */
/***/ (function(module, exports) {

	/**
	 * @see https://developers.google.com/youtube/iframe_api_reference#Events
	 */
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports["default"] = ["ready", "stateChange", "playbackQualityChange", "playbackRateChange", "error", "apiChange"];
	module.exports = exports["default"];
	//# sourceMappingURL=eventNames.js.map

/***/ }),
/* 2550 */
/***/ (function(module, exports) {

	/**
	 * @see https://developers.google.com/youtube/iframe_api_reference#Functions
	 */
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports["default"] = ["cueVideoById", "loadVideoById", "cueVideoByUrl", "loadVideoByUrl", "playVideo", "pauseVideo", "stopVideo", "clearVideo", "getVideoBytesLoaded", "getVideoBytesTotal", "getVideoLoadedFraction", "getVideoStartBytes", "cuePlaylist", "loadPlaylist", "nextVideo", "previousVideo", "playVideoAt", "setShuffle", "setLoop", "getPlaylist", "getPlaylistIndex", "getPlaylistId", "loadModule", "unloadModule", "setOption", "mute", "unMute", "isMuted", "setVolume", "getVolume", "seekTo", "getPlayerState", "getPlaybackRate", "setPlaybackRate", "getAvailablePlaybackRates", "getPlaybackQuality", "setPlaybackQuality", "getAvailableQualityLevels", "getCurrentTime", "getDuration", "removeEventListener", "getVideoUrl", "getDebugText", "getVideoData", "addCueRange", "removeCueRange", "getApiInterface", "showVideoInfo", "hideVideoInfo", "G", "C", "R", "aa", "$", "Z", "getVideoEmbedCode", "getOptions", "getOption", "Y", "X", "addEventListener", "destroy", "A", "P", "J", "setSize", "getIframe"];
	module.exports = exports["default"];
	//# sourceMappingURL=functionNames.js.map

/***/ }),
/* 2551 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _lodashCollectionForEach2 = __webpack_require__(1457);
	
	var _lodashCollectionForEach3 = _interopRequireDefault(_lodashCollectionForEach2);
	
	var _lodashStringCapitalize2 = __webpack_require__(1474);
	
	var _lodashStringCapitalize3 = _interopRequireDefault(_lodashStringCapitalize2);
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _sister = __webpack_require__(2181);
	
	var _sister2 = _interopRequireDefault(_sister);
	
	var _bluebird = __webpack_require__(493);
	
	var _bluebird2 = _interopRequireDefault(_bluebird);
	
	var _functionNames = __webpack_require__(2550);
	
	var _functionNames2 = _interopRequireDefault(_functionNames);
	
	var _eventNames = __webpack_require__(2549);
	
	var _eventNames2 = _interopRequireDefault(_eventNames);
	
	var _loadYouTubeIframeAPI = __webpack_require__(2552);
	
	var _loadYouTubeIframeAPI2 = _interopRequireDefault(_loadYouTubeIframeAPI);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var YouTubePlayer = undefined,
	    youtubeIframeAPI = undefined;
	
	YouTubePlayer = {};
	youtubeIframeAPI = (0, _loadYouTubeIframeAPI2['default'])();
	
	/**
	 * Construct an object that defines an event handler for all of the
	 * YouTube player events. Proxy captured events through an event emitter.
	 *
	 * @todo Capture event parameters.
	 * @see https://developers.google.com/youtube/iframe_api_reference#Events
	 * @param {Sister} emitter
	 * @return {Object}
	 */
	YouTubePlayer.proxyEvents = function (emitter) {
	    var events = undefined;
	
	    events = {};
	
	    (0, _lodashCollectionForEach3['default'])(_eventNames2['default'], function (eventName) {
	        var onEventName = undefined;
	
	        onEventName = 'on' + (0, _lodashStringCapitalize3['default'])(eventName);
	
	        events[onEventName] = function (event) {
	            emitter.trigger(eventName, event);
	        };
	    });
	
	    return events;
	};
	
	/**
	 * Delays player API method execution until player state is ready.
	 *
	 * @todo Proxy all of the methods using Object.keys.
	 * @param {Promise} playerAPIReady Promise that resolves when player is ready.
	 * @return {Object}
	 */
	YouTubePlayer.promisifyPlayer = function (playerAPIReady) {
	    var functions = undefined;
	
	    functions = {};
	
	    (0, _lodashCollectionForEach3['default'])(_functionNames2['default'], function (functionName) {
	        functions[functionName] = function () {
	            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	                args[_key] = arguments[_key];
	            }
	
	            return playerAPIReady.then(function (player) {
	                return player[functionName].apply(player, args);
	            });
	        };
	    });
	
	    return functions;
	};
	
	/**
	 * @typedef options
	 * @see https://developers.google.com/youtube/iframe_api_reference#Loading_a_Video_Player
	 * @param {Number} width
	 * @param {Number} height
	 * @param {String} videoId
	 * @param {Object} playerVars
	 * @param {Object} events
	 */
	
	/**
	 * A factory function used to produce an instance of YT.Player and queue function calls and proxy events of the resulting object.
	 *
	 * @param {HTMLElement|String} elementId Either the DOM element or the id of the HTML element where the API will insert an <iframe>.
	 * @param {YouTubePlayer~options} options
	 * @return {Object}
	 */
	
	exports['default'] = function (elementId) {
	    var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	    var emitter = undefined,
	        playerAPI = undefined,
	        playerAPIReady = undefined;
	
	    playerAPI = {};
	    emitter = (0, _sister2['default'])();
	
	    if (options.events) {
	        throw new Error('Event handlers cannot be overwritten.');
	    }
	
	    if (typeof elementId === 'string' && !document.getElementById(elementId)) {
	        throw new Error('Element "#' + elementId + '" does not exist.');
	    }
	
	    options.events = YouTubePlayer.proxyEvents(emitter);
	
	    playerAPIReady = new _bluebird2['default'](function (resolve) {
	        youtubeIframeAPI.then(function (YT) {
	            return new YT.Player(elementId, options);
	        }).then(function (player) {
	            emitter.on('ready', function () {
	                resolve(player);
	
	                // Until Proxies become available, this is the only way to Promisify the SDK.
	                /*
	                methods = _.map(_.functions(player), function (name) {
	                    return '\'' + name + '\'';
	                });
	                 console.log(methods.join(', '));
	                */
	            });
	        });
	    });
	
	    playerAPI = YouTubePlayer.promisifyPlayer(playerAPIReady);
	    playerAPI.on = emitter.on;
	
	    return playerAPI;
	};
	
	module.exports = exports['default'];
	//# sourceMappingURL=index.js.map

/***/ }),
/* 2552 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _bluebird = __webpack_require__(493);
	
	var _bluebird2 = _interopRequireDefault(_bluebird);
	
	var _loadScript = __webpack_require__(1417);
	
	var _loadScript2 = _interopRequireDefault(_loadScript);
	
	exports['default'] = function () {
	    var iframeAPIReady = undefined;
	
	    /**
	     * A promise that is resolved when window.onYouTubeIframeAPIReady is called.
	     * The promise is resolved with a reference to global.YT object.
	     *
	     * @param {Function} resolve
	     * @member {Object} iframeAPIReady
	     */
	    iframeAPIReady = new _bluebird2['default'](function (resolve) {
	        var previous = undefined;
	
	        previous = global.onYouTubeIframeAPIReady;
	
	        // The API will call this function when page has finished downloading
	        // the JavaScript for the player API.
	        global.onYouTubeIframeAPIReady = function () {
	            if (previous) {
	                previous();
	            }
	
	            resolve(global.YT);
	        };
	    });
	
	    (0, _loadScript2['default'])('https://www.youtube.com/iframe_api');
	
	    return iframeAPIReady;
	};
	
	module.exports = exports['default'];
	//# sourceMappingURL=loadYouTubeIframeAPI.js.map
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ })
]);


// WEBPACK FOOTER //
// app.c87fbc89620f5799a26f.js